


  
  

  var faTurnUp = {
    prefix: 'fasl',
    iconName: 'turn-up',
    icon: [
      384,
      512,
      [10548,"level-up-alt"],
      'f3bf',
      
      'M160 160v32l0 192v32H128 32l0 64H224l0-288V160h32 50.7L192 45.3 77.3 160H128h32zM64 192H32l0-32L169.4 22.6 192 0l22.6 22.6L352 160v32H320 288 256l0 32V480v32H224 32 0l0-32 0-64 0-32H32 96h32V352l0-128V192H96 64z'
      
    ]
  };

  
    var faLevelUpAlt = faTurnUp;
  

  
  

  var faMessageText = {
    prefix: 'fasl',
    iconName: 'message-text',
    icon: [
      512,
      512,
      ["comment-alt-text"],
      'e1e6',
      
      'M160 416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448 416zm0-32h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zm32-256h64 64c8.8 0 16 7.2 16 16s-7.2 16-16 16H272V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V160H192c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faCommentAltText = faMessageText;
  

  
  

  var faSquareZ = {
    prefix: 'fasl',
    iconName: 'square-z',
    icon: [
      448,
      512,
      [],
      'e288',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm304 96h16v21.1l-3 4.2L175.1 352H304h16v32H304 144 128V362.9l3-4.2L272.9 160H144 128V128h16H304z'
      
    ]
  };

  

  
  

  var faPersonCircleCheck = {
    prefix: 'fasl',
    iconName: 'person-circle-check',
    icon: [
      576,
      512,
      [],
      'e53e',
      
      'M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM99.3 128h9.6H211.1h9.6l4.5 8.5 66.7 124.9c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496v16H192V496 352H128V496v16H96V496 202.1L46.1 295.5l-7.5 14.1L10.3 294.6l7.5-14.1 76.9-144 4.5-8.5zM128 320h64V160H128V320zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm78.6 112l-11.3 11.3-72 72L416 430.6l-11.3-11.3-40-40L353.4 368 376 345.4l11.3 11.3L416 385.4l60.7-60.7L488 313.4 510.6 336z'
      
    ]
  };

  

  
  

  var faHandHoldingMedical = {
    prefix: 'fasl',
    iconName: 'hand-holding-medical',
    icon: [
      576,
      512,
      [],
      'e05c',
      
      'M250.7 0h74.7 16V16 74.7H400h16v16 74.7 16H400 341.3V240v16h-16H250.7h-16V240 181.3H176 160v-16V90.7v-16h16 58.7V16 0h16zm16 90.7v16h-16H192v42.7h58.7 16v16V224h42.7V165.3v-16h16H384V106.7H325.3h-16v-16V32H266.7V90.7zM171.2 304H176 384h16v16 64h.2l103.6-61.7 13.5-8 8.3 13.3 40 64L574 405l-13.5 8.5-152 96-3.9 2.5H400 16 0V480H16 395.4L530 395l-23.3-37.2-94 56L409 416h-4.4H400 384 320 304 256 240V384h16 48 16 48V336H180.8l-92 61.3-4 2.7H80 16 0V368H16 75.2l92-61.3 4-2.7z'
      
    ]
  };

  

  
  

  var faGraduationCap = {
    prefix: 'fasl',
    iconName: 'graduation-cap',
    icon: [
      640,
      512,
      [127891,"mortar-board"],
      'f19d',
      
      'M320 288L640 176V144L320 32 0 144v32l92.1 32.2-38.9 36L48 249v7 64c-2.4 11.9-5.1 23.5-8.1 34.6c-8.5 32.1-18.7 59.9-26.7 79.4C5.6 452.8 0 464 0 464l32.3 6.5L80 480c25.1-58.6 15.2-99.7 0-125.6V263l46.3-42.8L320 288zM51.2 160L320 65.9 588.8 160 320 254.1 165.2 199.9l160.4-60.1-11.2-30-192 72-2.9 1.1-.8 .7L51.2 160zm92.4 100.2L128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.4 260.2l-31 10.9 14.2 135.3c-.7 .8-1.8 2.1-3.7 3.7c-6 5.2-16.5 11.5-31.9 17.5C413.6 439.4 369.7 448 320 448s-93.6-8.6-124.1-20.6c-15.4-6-25.8-12.3-31.9-17.5c-1.9-1.6-3-2.8-3.7-3.7L174.6 271l-31-10.9zM480.5 405a.2 .2 0 1 0 -.3-.1 .2 .2 0 1 0 .3 .1zm-321 0a.1 .1 0 1 0 .2 0 .1 .1 0 1 0 -.2 0zM59.1 443.2l-13.9-2.8c.9-2.2 1.8-4.5 2.7-6.9c4.3-11.3 9.1-24.4 13.7-38.9c2.6 12.6 2.8 28.7-2.5 48.6z'
      
    ]
  };

  
    var faMortarBoard = faGraduationCap;
  

  
  

  var faMessageMiddle = {
    prefix: 'fasl',
    iconName: 'message-middle',
    icon: [
      512,
      512,
      ["comment-middle-alt"],
      'e1e1',
      
      'M173.7 416H32 0V384 32 0H32 480h32V32 384v32H480 338.3l-61.2 71.4L256 512l-21.1-24.6L173.7 416zM256 462.8l58-67.7 9.6-11.2h14.7H480V32H32V384H173.7h14.7l9.6 11.2 58 67.7z'
      
    ]
  };

  
    var faCommentMiddleAlt = faMessageMiddle;
  

  
  

  var faVideo = {
    prefix: 'fasl',
    iconName: 'video',
    icon: [
      576,
      512,
      ["video-camera"],
      'f03d',
      
      'M32 96V416H352V96H32zM0 64H32 352h32V96v64V352v64 32H352 32 0V416 96 64zM544 396.2V115.8l-128 64V144L544 80l32-16V99.8 412.2 448l-32-16L416 368V332.2l128 64z'
      
    ]
  };

  
    var faVideoCamera = faVideo;
  

  
  

  var faSquareSlidersVertical = {
    prefix: 'fasl',
    iconName: 'square-sliders-vertical',
    icon: [
      448,
      512,
      ["sliders-v-square"],
      'f3f2',
      
      'M416 64V448H32V64H416zM32 32H0V64 448v32H32 416h32V448 64 32H416 32zm128 96H128v16 48H104 88v32h16 24 32 24 16V192H184 160V144 128zm0 128H128v16 96 16h32V368 272 256zM320 128H288v16V256H264 248v32h16 24 32 24 16V256H344 320V144 128zm0 192H288v16 32 16h32V368 336 320z'
      
    ]
  };

  
    var faSlidersVSquare = faSquareSlidersVertical;
  

  
  

  var faPlusMinus = {
    prefix: 'fasl',
    iconName: 'plus-minus',
    icon: [
      384,
      512,
      [],
      'e43c',
      
      'M176 352v16h32V352 208H352h16V176H352 208V32 16H176V32 176H32 16v32H32 176V352zM16 448v32H32 352h16V448H352 32 16z'
      
    ]
  };

  

  
  

  var faBulldozer = {
    prefix: 'fasl',
    iconName: 'bulldozer',
    icon: [
      640,
      512,
      [],
      'e655',
      
      'M32 32H48 192h9.9l4.4 8.8L281.9 192H336V128 112h32v16 64h64 16v16 96h80V240v-5.8l3.7-4.5 80-96 24.6 20.5L560 245.8V394.2l76.3 91.5-24.6 20.5-80-96-3.7-4.5V400 336H459.9c12.7 18.1 20.1 40.2 20.1 64c0 61.9-50.1 112-112 112H112C50.1 512 0 461.9 0 400c0-30.5 12.2-58.2 32-78.4V224 208 192 48 32zM272.3 224c-.2 0-.4 0-.7 0H64v74.8c14.5-6.9 30.8-10.8 48-10.8H368c17.2 0 33.5 3.9 48 10.8V224H272.3zM182.1 64H64V192H246.1l-64-128zM112 320c-44.2 0-80 35.8-80 80s35.8 80 80 80H368c44.2 0 80-35.8 80-80s-35.8-80-80-80H112zM96 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm264-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM256 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-56-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faBarcode = {
    prefix: 'fasl',
    iconName: 'barcode',
    icon: [
      512,
      512,
      [],
      'f02a',
      
      'M0 32H32V480H0V32zm64 0H96V480H64V32zm96 0V480H128V32h32zm64 0h32V480H224V32zm96 0V480H288V32h32zm64 0h32V480H384V32zm128 0V480H480V32h32z'
      
    ]
  };

  

  
  

  var faFileMp4 = {
    prefix: 'fasl',
    iconName: 'file-mp4',
    icon: [
      512,
      512,
      [],
      'e649',
      
      'M352 192v96h32V152L232 0H32 0V32 480v32H32 64V480H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM256 368V352l-16 0-5.6 0-9.6 0-4.5 8.5-28.5 53.8-29.7-54-4.6-8.3-9.5 0-4 0-16 0v16V496v16h32V496 423l18 32.7 14.3 26 13.9-26.2L224 421.8V496v16h32V496 368zm48-16H288v16 80 48 16h32V496 464h16c30.9 0 56-25.1 56-56s-25.1-56-56-56H304zm32 80H320V384h16c13.3 0 24 10.7 24 24s-10.7 24-24 24zm80 16h16 48v48 16h32V496 432 368 352H480v16 48H448V368 352H416v16 64 16z'
      
    ]
  };

  

  
  

  var faShieldKeyhole = {
    prefix: 'fasl',
    iconName: 'shield-keyhole',
    icon: [
      512,
      512,
      [],
      'e248',
      
      'M48.5 114.9L256 34.3l207.5 80.5c2.7 45.6-4.5 116.8-34.7 186.3S345.4 438.4 256 477.1C166.6 438.4 113.4 370.7 83.2 301.2S45.8 160.5 48.5 114.9zm447-1.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM256 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 25.4 16.9 46.8 40 53.7V336v16h32V336 261.7c23.1-6.9 40-28.3 40-53.7z'
      
    ]
  };

  

  
  

  var faReflectVertical = {
    prefix: 'fasl',
    iconName: 'reflect-vertical',
    icon: [
      512,
      512,
      [],
      'e665',
      
      'M0 240l16 0 480 0 16 0 0 32-16 0L16 272 0 272l0-32zM233.4 342.6L256 320l22.6 22.6L416 480l0 32-32 0-256 0-32 0 0-32L233.4 342.6zM370.7 480L256 365.3 141.3 480l229.5 0zM256 192l-22.6-22.6L96 32 96 0l32 0L384 0l32 0 0 32L278.6 169.4 256 192zm0-45.3L370.7 32 141.3 32 256 146.7z'
      
    ]
  };

  

  
  

  var faSquareShareNodes = {
    prefix: 'fasl',
    iconName: 'square-share-nodes',
    icon: [
      448,
      512,
      ["share-alt-square"],
      'f1e1',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-18.4 0-35.1-7.8-46.7-20.3l-81.7 44.6c.3 2.5 .5 5.1 .5 7.7s-.2 5.2-.5 7.7l81.7 44.6C284.9 295.8 301.6 288 320 288c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-5.4 .7-10.6 1.9-15.6l-78.2-42.7C168.1 309.6 149.2 320 128 320c-35.3 0-64-28.7-64-64s28.7-64 64-64c21.2 0 40.1 10.4 51.7 26.3l78.2-42.7c-1.3-5-1.9-10.2-1.9-15.6c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zm0 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  
    var faShareAltSquare = faSquareShareNodes;
  

  
  

  var faComet = {
    prefix: 'fasl',
    iconName: 'comet',
    icon: [
      512,
      512,
      [],
      'e003',
      
      'M304 16L270.4 35.4 101.3 133.4C38.6 169.7 0 236.6 0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3l97.9-169.1L496 208l-25 1.9L457.3 211l-21.2 1.6 11.8-33L498.1 38.9 512 0 473.1 13.9 332.4 64.1l-33 11.8L301 54.7 302.1 41 304 16zM117.3 161.1L267.4 74.1l-3.7 48.5 46.5-16.6 149-53.2-53.2 149-16.6 46.5 48.5-3.7L350.9 394.7C320.4 447.5 264 480 203 480c-94.4 0-171-76.5-171-171c0-61 32.5-117.4 85.3-148zm108.6 55.5L208 180.8l-17.9 35.7-21.7 43.3-48.3 6.9L80 272.5l29.3 28.1L144 334l-8.2 47.2-6.9 39.6 35.7-18.5L208 379.8l43.4 22.5 35.7 18.5-6.9-39.6L272 334l34.7-33.4L336 272.5l-40.2-5.8-48.3-6.9-21.7-43.3zM243 291.5l23.5 3.4-16.7 16-12.3 11.8 2.9 16.8 4 23.2-21.8-11.3L208 343.8l-14.7 7.6-21.8 11.3 4-23.2 2.9-16.8-12.3-11.8-16.7-16 23.5-3.4 16.6-2.4 7.5-15L208 252.3l10.9 21.9 7.5 15 16.6 2.4z'
      
    ]
  };

  

  
  

  var faJetFighter = {
    prefix: 'fasl',
    iconName: 'jet-fighter',
    icon: [
      640,
      512,
      ["fighter-jet"],
      'f0fb',
      
      'M224 32h23.9L352.6 176H224V32zM384.2 208H493.1L608 251.1v9.8L493.1 304H384.2h-.4H208 160h-6.6l-4.7 4.7L105.4 352H64V272h80 16V240H144 64V160h41.4l43.3 43.3 4.7 4.7H160h48H383.8h.4zM32 272v96 16H48h64 6.6l4.7-4.7L166.6 336H192V480H176v32h16 16 47.8 .4H304h16V480H304 287.4L392.1 336H496h2.9l2.7-1 128-48 10.4-3.9V272 240 228.9L629.6 225l-128-48-2.7-1H496 392.1L287.4 32H304h16V0H304 256.2h-.4H208 192 176V32h16V176H166.6l-43.3-43.3-4.7-4.7H112 48 32v16 96H16 0v32H16 32zM224 480V336H352.6L247.9 480H224z'
      
    ]
  };

  
    var faFighterJet = faJetFighter;
  

  
  

  var faPageCaretUp = {
    prefix: 'fasl',
    iconName: 'page-caret-up',
    icon: [
      384,
      512,
      ["file-caret-up"],
      'e42a',
      
      'M352 125.3V480H32V32H258.7L352 125.3zM384 112L272 0H32 0V32 480v32H32 352h32V480 112zM192 237.3L242.7 288H141.3L192 237.3zm0-45.3l-22.6 22.6L96 288v32h32H256h32V288l-73.4-73.4L192 192z'
      
    ]
  };

  
    var faFileCaretUp = faPageCaretUp;
  

  
  

  var faHandshakeSimple = {
    prefix: 'fasl',
    iconName: 'handshake-simple',
    icon: [
      640,
      512,
      [129309,"handshake-alt"],
      'f4c6',
      
      'M217.3 64h55.3l-32 32H223.1l-71.7 60.2-4.5 3.8h-5.8H48 32V128H48h87.3L207 67.8l4.5-3.8h5.8zm112.1 0h6.3 85.6 5.8l4.5 3.8L503.3 128H592h16v32H592 497.5h-5.8l-4.5-3.8L415.5 96H342.1L213.8 216.8l46.9 52 98.1-90.6 11.8-10.9 21.7 23.5-11.8 10.9-8.8 8.1L480.5 318.8H488 592h16v32H592 498.4l-4.2 4.2L410.3 439 399 450.3 387.6 439l-15.3-15.3-35.6 35.6-11.3 11.3-11.3-11.3-26.6-26.6-29 29-11.3 11.3-11.3-11.3L192 417.7l-11.3-11.3-7-7L126.3 352H48 32V320H48h84.9 6.6l4.7 4.7 52 52.1 7 7 11.3 11.3 32.6 32.6 29-29 11.3-11.3 11.3 11.3 26.6 26.6L361 389.7l11.3-11.3 11.3 11.3L399 405l61.3-61.3L348.1 231.7l-77.7 71.7-11.9 11-10.8-12-68.2-75.7L169.1 215l11.4-10.7L324.8 68.3l4.6-4.3z'
      
    ]
  };

  
    var faHandshakeAlt = faHandshakeSimple;
  

  
  

  var faEyes = {
    prefix: 'fasl',
    iconName: 'eyes',
    icon: [
      640,
      512,
      [],
      'e367',
      
      'M304 256c0 55.6-16.9 104.7-42.8 139.2C235.3 429.7 202.1 448 168 448s-67.3-18.3-93.2-52.8c-7-9.3-13.3-19.6-18.8-30.8c7.6 2.4 15.6 3.7 24 3.7c44.2 0 80-35.8 80-80s-35.8-80-80-80c-17.1 0-32.9 5.4-45.9 14.5c5.3-41.7 20.2-78.3 40.7-105.7C100.7 82.3 133.9 64 168 64s67.3 18.3 93.2 52.8C287.1 151.3 304 200.4 304 256zm16-95.5C293.1 84.5 235.2 32 168 32C75.2 32 0 132.3 0 256S75.2 480 168 480c67.2 0 125.1-52.5 152-128.5C346.9 427.5 404.8 480 472 480c92.8 0 168-100.3 168-224s-75.2-224-168-224c-67.2 0-125.1 52.5-152 128.5zm58.8 234.7c-7-9.3-13.3-19.6-18.8-30.8c7.6 2.4 15.6 3.7 24 3.7c44.2 0 80-35.8 80-80s-35.8-80-80-80c-17.1 0-32.9 5.4-45.9 14.5c5.3-41.7 20.2-78.3 40.7-105.7C404.7 82.3 437.9 64 472 64s67.3 18.3 93.2 52.8C591.1 151.3 608 200.4 608 256s-16.9 104.7-42.8 139.2S506.1 448 472 448s-67.3-18.3-93.2-52.8zM32 288a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm352-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faCircleJ = {
    prefix: 'fasl',
    iconName: 'circle-j',
    icon: [
      512,
      512,
      [],
      'e112',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-368V128H304v16V288c0 35.3-28.7 64-64 64s-64-28.7-64-64V272 256H144v16 16c0 53 43 96 96 96s96-43 96-96V144z'
      
    ]
  };

  

  
  

  var faGalleryThumbnails = {
    prefix: 'fasl',
    iconName: 'gallery-thumbnails',
    icon: [
      576,
      512,
      [],
      'e3aa',
      
      'M544 32V320H32V32H544zM32 0H0V32 320v32H32 544h32V320 32 0H544 32zM64 448v32H32V448H64zM32 416H0v32 32 32H32 64 96V480 448 416H64 32zm160 32h32v32H192V448zm-32-32v32 32 32h32 32 32V480 448 416H224 192 160zm224 32v32H352V448h32zm-32-32H320v32 32 32h32 32 32V480 448 416H384 352zm160 32h32v32H512V448zm-32-32v32 32 32h32 32 32V480 448 416H544 512 480z'
      
    ]
  };

  

  
  

  var faHandPointLeft = {
    prefix: 'fasl',
    iconName: 'hand-point-left',
    icon: [
      512,
      512,
      [],
      'f0a5',
      
      'M0 112L0 96l16 0 224 0 0-16 0-16 16 0 96 0c88.4 0 160 71.6 160 160l0 64c0 88.4-71.6 160-160 160l0 0-16 0-64 0-16 0-48 0-16 0 0-16 0-64-16 0 0-16 0-64-16 0-16 0 0-16 0-64L16 208 0 208l0-16 0-80zm176 96l0 48 16 0 48 0 0-48-64 0zm96 48l0 0 48 0 0-80 0-16 32 0 0 16 0 80 0 16 0 16 0 48 0 16 0 16 0 48c70.7 0 128-57.3 128-128l0-64c0-70.7-57.3-128-128-128l-80 0 0 80 0 0 0 32 0 0 0 48zm0 32l-16 0-16 0-32 0 0 48 112 0 0-48-48 0zM240 176l0-48L32 128l0 48 112 0 16 0 80 0zm32 240l48 0 0-48-96 0 0 48 32 0 16 0z'
      
    ]
  };

  

  
  

  var faPineapple = {
    prefix: 'fasl',
    iconName: 'pineapple',
    icon: [
      512,
      512,
      [],
      'e31f',
      
      'M391 2.4l8.2 24.6 5.5 16.6 56.2-11.2 23.5-4.7-4.7 23.5-11.2 56.1 16.6 5.5 24.6 8.2-18.3 18.3L470.6 160l12.7 12.7L499.6 189l-21 9.6L432 219.8V208l-16.1-16.1L444.4 179l-7.7-7.7L425.4 160l11.3-11.3L450.4 135l-5.4-1.8-13.4-4.5 2.8-13.9 9.3-46.5-46.5 9.3-13.8 2.8-4.5-13.4L377 61.6 363.3 75.3 352 86.6 340.7 75.3 333 67.6 320.1 96.1 304 80H292.2l21.2-46.6 9.6-21 16.3 16.3L352 41.4l20.7-20.7L391 2.4zM141.3 480H242.7L400 322.7V221.3L290.7 112H189.3L32 269.3V370.7L141.3 480zM256 512H128L0 384V256L176 80H304L432 208V336L256 512zM160 201.4l11.3 11.3L192 233.4l20.7-20.7L224 201.4 246.6 224l-11.3 11.3-32 32L192 278.6l-11.3-11.3-32-32L137.4 224 160 201.4zm-64 88l11.3 11.3L128 321.4l20.7-20.7L160 289.4 182.6 312l-11.3 11.3-32 32L128 366.6l-11.3-11.3-32-32L73.4 312 96 289.4zm128 0l11.3 11.3L256 321.4l20.7-20.7L288 289.4 310.6 312l-11.3 11.3-32 32L256 366.6l-11.3-11.3-32-32L201.4 312 224 289.4zm-64 88l11.3 11.3L192 409.4l20.7-20.7L224 377.4 246.6 400l-11.3 11.3-32 32L192 454.6l-11.3-11.3-32-32L137.4 400 160 377.4z'
      
    ]
  };

  

  
  

  var faCloudQuestion = {
    prefix: 'fasl',
    iconName: 'cloud-question',
    icon: [
      640,
      512,
      [],
      'e492',
      
      'M544 241.1V232c0-57.4-46.6-104-104-104c-13.4 0-26.2 2.5-37.9 7.1l-24.3 9.5-14.2-22C340.8 87.3 301.1 64 256 64c-70.7 0-128 57.3-128 128v8.2 22.6l-21.3 7.5C63.1 245.8 32 287.3 32 336V448H144 512h96V352c0-35.5-19.2-66.5-48-83.2l-16-9.2V241.1zM0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c56.4 0 106 29.2 134.5 73.3c15.3-6 32-9.3 49.5-9.3c75.1 0 136 60.9 136 136v9.1c38.3 22.1 64 63.5 64 110.9v96 32H608 512 144 32 0V448 336zM232 232c0-30.9 25.1-56 56-56h56c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L336 316.3V320v16H304V320 306.5v-9.8l8.7-4.5 45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H288c-13.3 0-24 10.7-24 24v8H232v-8zm64 136h48v48H296V368z'
      
    ]
  };

  

  
  

  var faFaceWoozy = {
    prefix: 'fasl',
    iconName: 'face-woozy',
    icon: [
      512,
      512,
      [],
      'e3a2',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM205.3 120.9c-28 42-69.6 64.1-88.3 70.3l-15.2 5.1L91.8 165.9l15.2-5.1c13.4-4.5 48.5-22.9 71.7-57.7l8.9-13.3 26.6 17.8-8.9 13.3zm22.1 114.8l-15.5 3.9-64 16-15.5 3.9-7.8-31 15.5-3.9 64-16 15.5-3.9 7.8 31zM411.3 347.3L372 386.6c-13.7 13.7-32.3 21.4-51.7 21.4c-13.7 0-27.1-3.8-38.7-11.1L267.4 388c-18.2-11.4-40.8-13.4-60.7-5.4c-30.4 12.2-64.8 8.6-92-9.6l-11.5-7.7-13.3-8.9 17.8-26.6 13.3 8.9 11.5 7.7c18.5 12.3 41.8 14.7 62.4 6.5c29.4-11.8 62.7-8.8 89.6 8l14.2 8.9c6.5 4.1 14.1 6.2 21.8 6.2c10.9 0 21.3-4.3 29-12l39.3-39.3L400 313.4 422.6 336l-11.3 11.3zM327.7 169.9c-4.5 8.9-7.7 22.4-7.7 38.1s3.2 29.2 7.7 38.1c2.2 4.5 4.5 7.2 6.2 8.7c.8 .7 1.4 1 1.7 1.1c.2 .1 .3 .1 .3 .1s.1 0 .1 0s0 0 0 0s0 0 .1 0c0 0 .1 0 .3-.1c.3-.1 .9-.4 1.7-1.1c1.7-1.5 4-4.2 6.2-8.7c4.5-8.9 7.7-22.4 7.7-38.1s-3.2-29.2-7.7-38.1c-2.2-4.5-4.5-7.2-6.2-8.7c-.8-.7-1.4-1-1.7-1.1c-.2-.1-.3-.1-.3-.1l0 0 0 0s0 0 0 0s0 0 0 0c0 0-.1 0-.3 .1c-.3 .1-.9 .4-1.7 1.1c-1.7 1.5-4 4.2-6.2 8.7zm-28.6-14.3c6.6-13.3 18.8-27.6 36.9-27.6s30.3 14.3 36.9 27.6c7.1 14.2 11.1 32.8 11.1 52.4s-3.9 38.2-11.1 52.4C366.3 273.7 354.2 288 336 288s-30.3-14.3-36.9-27.6C291.9 246.2 288 227.6 288 208s3.9-38.2 11.1-52.4z'
      
    ]
  };

  

  
  

  var faKipSign = {
    prefix: 'fasl',
    iconName: 'kip-sign',
    icon: [
      384,
      512,
      [],
      'e1c4',
      
      'M96 32V48 222.5l222-179 12.5-10 20.1 24.9L338 68.5 125.3 240H368h16v32H368 125.3L338 443.5l12.5 10-20.1 24.9-12.5-10L96 289.5V465v16H64V465 272H16 0V240H16 64V48 32H96z'
      
    ]
  };

  

  
  

  var faFileGif = {
    prefix: 'fasl',
    iconName: 'file-gif',
    icon: [
      512,
      512,
      [],
      'e645',
      
      'M352 192v96h32V152L232 0H32 0V32 480v32H32 160V480H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM224 392v80c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V448 432H304 288 272v32h16v8c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16h32V392c0-22.1-17.9-40-40-40H264c-22.1 0-40 17.9-40 40zm160-24V352H352v16V496v16h32V496 368zm48-16H416v16 64 64 16h32V496 448h32 16V416H480 448V384h32 16V352H480 432z'
      
    ]
  };

  

  
  

  var faMasksTheater = {
    prefix: 'fasl',
    iconName: 'masks-theater',
    icon: [
      640,
      512,
      [127917,"theater-masks"],
      'f630',
      
      'M254.7 447.7c-1.3 .7-1.9 1.1-1.9 1.1s-199.9-31.4-221.1-157.7L0 101.7s21-68.4 178.8-94.8C302.2-13.8 354.9 17.1 372 31.6c-22.1 .8-41 3.5-57.2 7.3c-25.7-6.9-67.1-11.1-130.7-.4C109.4 51 70.2 72.9 50.5 89c-9.1 7.4-14.3 13.8-17.1 17.9L63.3 285.8c7.8 46.4 49.5 79.6 100 102.3c23 10.3 45.6 17.4 63.1 22.1c8.5 13.6 18.3 26.2 28.3 37.5zm-53.1-183L198 285.8c-1 5.7-1.6 11.3-1.9 16.9c-5.3 3.1-10.3 6.6-14.8 10.1c-6.8 5.3-13.4 11.1-19.1 17.6L138 309.4c7-8.1 15.2-15.3 23.6-21.9c10.2-8 23.9-16.9 39.9-22.9zm-59.5-89.4c8.9-1.5 16.8-8.1 22.2-15.2l26.1 18.5c-10.2 13.9-25.9 25.3-43 28.2s-35.6-2.8-49.8-12.6c3.1-4.4 18.6-26.1 18.6-26.1c7.4 4.9 17 8.6 25.9 7.1zM608.3 354.4C587.2 480.7 387.3 512.1 387.3 512.1s-178.8-94.8-157.7-221.1l31.7-189.4s42.1-57.8 199.9-31.4S640 165.1 640 165.1L608.3 354.4zM313.1 106.1c-11 4-18 8.4-22.1 11.4L261.1 296.3c-7.8 46.4 20.9 91.4 61.3 129.3c19.3 18.1 39.5 32.8 54.9 43c6.1 4.1 11.4 7.4 15.6 9.8c4.7-1 10.8-2.4 17.9-4.2c17.9-4.6 41.7-12 65.9-22.8c50.5-22.7 92.2-55.9 100-102.3l29.9-178.9c-2.9-4.2-8.1-10.6-17.1-17.9c-19.7-16.1-58.9-38-133.6-50.5s-118.9-4.5-142.8 4.3zm11.4 108.3c14.1-10 32.8-15.5 49.8-12.7s32.9 14.2 43 28.2l-26.1 18.6c-5.4-7.1-13.3-13.7-22.2-15.2s-18.5 2.2-25.9 7.1l-18.6-26zM499.5 325c3.2-1 6.4-2.1 9.6-3.3c8.4-3.2 16.6-7.1 24.4-11.5c-.2 5.1-.6 10.2-1.5 15.3c-1.4 8.5-3.8 16.6-6.9 24.3c-19.4 47.2-69.5 76.5-122 67.7s-90.3-52.8-93.3-103.8c-.5-8.3-.1-16.7 1.4-25.2c.9-5.1 2.1-10.1 3.6-15c5.9 6.7 12.4 13 19.3 18.8c2.6 2.2 5.3 4.3 8 6.3c21.6 16 47.2 27.3 75.6 32s56.3 2.4 81.9-5.7zm-20.4 37.6c-21.6 3.4-44.1 3.4-66.8-.4s-44-11.2-63.3-21.4c10.8 23 32.3 40.6 59.3 45.1s53.1-5 70.7-23.3zm21.4-139.7c17.1 2.9 32.8 14.3 43 28.2l-26.1 18.5c-5.4-7.1-13.3-13.7-22.2-15.2c-8.8-1.5-18.6 2.3-25.9 7.1l-18.6-26c14.1-10 32.7-15.5 49.8-12.6z'
      
    ]
  };

  
    var faTheaterMasks = faMasksTheater;
  

  
  

  var faStapler = {
    prefix: 'fasl',
    iconName: 'stapler',
    icon: [
      640,
      512,
      [],
      'e5af',
      
      'M448 352v32H64 32v32 32 32H64 608h32V448 416 384 336 304 240L255.6 47.8C234.8 37.4 211.9 32 188.6 32C131.9 32 80 64.1 54.6 114.8L14.7 194.7 0 224l31.8 8L72 242v94 16H88 448zm-64-32H104V250l280 70zm224 64H480V336 311L455.8 305 46.5 202.6l36.7-73.5C103.2 89.2 144 64 188.6 64c18.3 0 36.3 4.3 52.7 12.4L608 259.8V304v32 48zM480 416H608v32H64V416H448h32z'
      
    ]
  };

  

  
  

  var faD = {
    prefix: 'fasl',
    iconName: 'd',
    icon: [
      384,
      512,
      [100],
      '44',
      
      'M0 32H16 160c123.7 0 224 100.3 224 224s-100.3 224-224 224H16 0V464 48 32zM32 64V448H160c106 0 192-86 192-192s-86-192-192-192H32z'
      
    ]
  };

  

  
  

  var faBedFront = {
    prefix: 'fasl',
    iconName: 'bed-front',
    icon: [
      512,
      512,
      ["bed-alt"],
      'f8f7',
      
      'M48 32H32V48v80 16 80H16 0v16V400v64c0 8.8 7.2 16 16 16s16-7.2 16-16V416H480v48 16h32V464 400 240 224H496 480V144 128 48 32H464 48zm400 96H272 256 240 64V64H448v64zM272 160H448v64H272V160zm-32 64H64V160H240v64zm240 32V384H32V256H240h32H448h32z'
      
    ]
  };

  
    var faBedAlt = faBedFront;
  

  
  

  var faHorizontalRule = {
    prefix: 'fasl',
    iconName: 'horizontal-rule',
    icon: [
      640,
      512,
      [8213],
      'f86c',
      
      'M0 240H16 624h16v32H624 16 0V240z'
      
    ]
  };

  

  
  

  var faTrowel = {
    prefix: 'fasl',
    iconName: 'trowel',
    icon: [
      512,
      512,
      [],
      'e589',
      
      'M398.6 209.4L376 232l-22.6-22.6-14.1-14.1-112 112 70.1 70.1L320 400l-22.6 22.6L280 440 35.4 502.9 0 512l9.1-35.4L72 232l17.4-17.4L112 192l22.6 22.6 70.1 70.1 112-112-14.1-14.1L280 136l22.6-22.6 90.7-90.7L416 0l22.6 22.6 50.7 50.7L512 96l-22.6 22.6-90.7 90.7zM466.7 96L416 45.3 325.3 136 376 186.7 466.7 96zM263.6 411.2L274.7 400 112 237.3l-11.2 11.2L44.5 467.5l219.1-56.3z'
      
    ]
  };

  

  
  

  var faUmbrella = {
    prefix: 'fasl',
    iconName: 'umbrella',
    icon: [
      576,
      512,
      [],
      'f0e9',
      
      'M304 0V16 48.4C438.2 55.3 548.8 148.9 571.7 272c.9 4.6 1.6 9.3 2.2 13.9l2.3 18.1H558h-6.5-7.2l-.5-.6-4.2-4.7C525 282.3 503.7 272 480 272c-44.2 0-80 35.8-80 80H384 368c0-44.2-35.8-80-80-80s-80 35.8-80 80H192 176c0-44.2-35.8-80-80-80c-23.7 0-45 10.3-59.6 26.7l-4.2 4.7-.5 .6H24.4 18-.2l2.3-18.1c.6-4.7 1.3-9.3 2.2-13.9C27.2 148.9 137.8 55.3 272 48.4V16 0h32zM288 80C170.1 80 71.7 154.2 41.6 254.1C57.7 245.1 76.2 240 96 240c40.7 0 76.4 21.8 96 54.3c19.6-32.5 55.3-54.3 96-54.3s76.4 21.8 96 54.3c19.6-32.5 55.3-54.3 96-54.3c19.8 0 38.3 5.1 54.4 14.1C504.3 154.2 405.9 80 288 80zM272 306.7c5-1.8 10.4-2.7 16-2.7s11 1 16 2.7V446.6c0 36.1-29.3 65.4-65.4 65.4c-24.8 0-47.4-14-58.5-36.2l-2.3-4.7-7.2-14.3 28.6-14.3 7.2 14.3 2.3 4.7c5.7 11.3 17.2 18.5 29.9 18.5c18.5 0 33.4-15 33.4-33.4V306.7z'
      
    ]
  };

  

  
  

  var faCameraCctv = {
    prefix: 'fasl',
    iconName: 'camera-cctv',
    icon: [
      576,
      512,
      ["cctv"],
      'f8ac',
      
      'M0 224l16-28.1L128 0 540.1 161.9 576 176l-31.8 21.9L320 352l-97.5-39L175 437.7 171 448H160 32v48 16H0V496 432 368 352H32v16 48H149l43.8-114.9L30 236 0 224zm316 91.9L508.2 183.8 142.1 39.9l-96 168 270 108zm81.6 32.5l-9.9-4.2L419 322.8 502.7 358 534 282l-35.6-13.8 31.9-21.9 15.8 6.2L576 264l-12.2 29.6-31.6 76.8L520 400l-29.5-12.4-93-39.1z'
      
    ]
  };

  
    var faCctv = faCameraCctv;
  

  
  

  var faGrid2 = {
    prefix: 'fasl',
    iconName: 'grid-2',
    icon: [
      512,
      512,
      [],
      'e196',
      
      'M64 64V192H192V64H64zM32 32H64 192h32V64 192v32H192 64 32V192 64 32zM64 320V448H192V320H64zM32 288H64 192h32v32V448v32H192 64 32V448 320 288zM448 64H320V192H448V64zM320 32H448h32V64 192v32H448 320 288V192 64 32h32zm0 288V448H448V320H320zm-32-32h32H448h32v32V448v32H448 320 288V448 320 288z'
      
    ]
  };

  

  
  

  var faSack = {
    prefix: 'fasl',
    iconName: 'sack',
    icon: [
      512,
      512,
      [],
      'f81c',
      
      'M393.9 32L351.2 94 333 120.4c7.7 4.9 16.7 11 26.4 18.1C420.8 183.7 512 273.4 512 416v64 32H480 32 0V480 416C0 273.4 91.2 183.7 152.6 138.5c9.7-7.1 18.6-13.2 26.4-18.1L160.8 94 118.1 32 96 0h38.9H377.1 416L393.9 32zM480 416c0-147.7-109.4-233.5-164.3-268.6l-5.3-3.4h-109l-5.3 3.4C141.4 182.5 32 268.3 32 416v64H480V416zM299.9 112l6.7-9.8L355.1 32H156.9l48.4 70.2 6.7 9.8h87.8z'
      
    ]
  };

  

  
  

  var faCircleT = {
    prefix: 'fasl',
    iconName: 'circle-t',
    icon: [
      512,
      512,
      [],
      'e124',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM144 144H128v32h16 96V368v16h32V368 176h96 16V144H368 256 144z'
      
    ]
  };

  

  
  

  var faBuildingColumns = {
    prefix: 'fasl',
    iconName: 'building-columns',
    icon: [
      512,
      512,
      ["bank","institution","museum","university"],
      'f19c',
      
      'M0 192H32 256 480h32V160 144L256 0 0 144v16 32zm306.6-32c3.5-7.3 5.4-15.4 5.4-24c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 8.6 1.9 16.7 5.4 24H36.8L256 36.7 475.2 160H306.6zM256 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 352H48v32H64 448h16V352H448V224H416V352H336V224H304V352H208V224H176V352H96V224H64V352zm424 96V416H472 40 24v32H40 472h16zM16 480H0v32H16 496h16V480H496 16z'
      
    ]
  };

  
    var faBank = faBuildingColumns;
  
    var faInstitution = faBuildingColumns;
  
    var faMuseum = faBuildingColumns;
  
    var faUniversity = faBuildingColumns;
  

  
  

  var faPersonMilitaryPointing = {
    prefix: 'fasl',
    iconName: 'person-military-pointing',
    icon: [
      576,
      512,
      [],
      'e54a',
      
      'M256 59.1V64v0H384v0V37.8L256 59.1zM398.4 96c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16H224V64 32L384 5.3 416 0V32.4 64 96H398.4zm-33.1 0H274.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16zM32 224H48 224h16 16H384h24 8 1.9l4.4 8.8 112 224 7.2 14.3-28.6 14.3-7.2-14.3L416 291.8V480v32H384 256 224V480 432.4c0-.2 0-.5 0-.7V256H48 32V224zM256 480H384V448H256v32zM384 281.3L273.8 416H384V281.3zM256 256V387.2L363.3 256H256z'
      
    ]
  };

  

  
  

  var faUsersGear = {
    prefix: 'fasl',
    iconName: 'users-gear',
    icon: [
      640,
      512,
      ["users-cog"],
      'f509',
      
      'M144 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm112 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm105.9 86.4c26.2-12.7 45.8-37 52-66.3c1.4-6.5 2.1-13.2 2.1-20.1c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c15 0 29.2-3.4 41.9-9.6zm-24 41.6H176L137.6 480 128 512h33.4H393.3l-18.5-32H171l28.8-96H352.1l0 0-24.6-14.2L337.9 352zm280-91L592 192H444c2.6 10.2 4 21 4 32H569.8h10.3v27.5l.3 .7 24.3-14L617.9 261zM192 224c0-11 1.4-21.8 4-32H48L0 320H34.2l36-96H192zM512 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128A80 80 0 1 0 512 0a80 80 0 1 0 0 160zm-35.9 96h-16v16 22.2c-4.1 2-8 4.3-11.8 6.8l-19.2-11.1-13.9-8-8 13.9-28 48.5-8 13.9 13.9 8 19.2 11.1c-.2 2.2-.2 4.5-.2 6.8s.1 4.5 .2 6.8l-19.2 11.1-13.9 8 8 13.9 28 48.5 8 13.9 13.9-8L448.4 467c3.8 2.5 7.7 4.8 11.8 6.8V496v16h16 56 16V496 473.8c4.1-2 8-4.3 11.8-6.8l19.2 11.1 13.9 8 8-13.9 28-48.5 8-13.9-13.9-8-19.2-11.1c.2-2.2 .2-4.5 .2-6.8s-.1-4.6-.2-6.8l19.2-11.1 13.9-8-8-13.9-28-48.5-8-13.9-13.9 8L559.9 301c-3.8-2.5-7.7-4.8-11.8-6.8V272 256h-16-56zm16 48.8V288h24v16.8 11.3l10.7 3.8c7.9 2.8 15.2 7.1 21.5 12.4l8.6 7.4 9.8-5.7 14.6-8.4 12 20.8-14.5 8.4-9.8 5.7 2.1 11.1c.7 4 1.1 8.2 1.1 12.5s-.4 8.4-1.1 12.4L569 407.6l9.8 5.7 14.5 8.4-12 20.8L566.7 434l-9.8-5.7-8.6 7.4c-6.3 5.4-13.6 9.6-21.5 12.4l-10.7 3.8v11.3V480h-24V463.2 451.9l-10.7-3.8c-7.9-2.8-15.2-7.1-21.5-12.4l-8.6-7.4-9.8 5.7L427 442.4l-12-20.8 14.5-8.4 9.8-5.7-2.1-11.1c-.7-4-1.1-8.2-1.1-12.4s.4-8.4 1.1-12.5l2.1-11.1-9.8-5.7L415 346.4l12-20.8 14.6 8.4 9.8 5.7 8.6-7.4c6.3-5.4 13.6-9.6 21.5-12.4l10.7-3.8V304.8zM520 384a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  
    var faUsersCog = faUsersGear;
  

  
  

  var faMagnifyingGlassDollar = {
    prefix: 'fasl',
    iconName: 'magnifying-glass-dollar',
    icon: [
      512,
      512,
      ["search-dollar"],
      'f688',
      
      'M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L487.9 510.5l22.6-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm16-304V96H192v16 9.3c-6.5 1.1-12.7 2.9-18.3 5.4c-14.1 6.4-25.9 18.1-28.8 34.7c-1.6 9.5-.7 18.5 3.1 26.6c3.8 7.9 9.7 13.7 15.9 17.9c11.1 7.5 25.8 11.9 37.7 15.5l0 0 2 .6c13.8 4.2 23.9 7.5 30.5 12.3c2.9 2.1 4.3 4 5.1 5.7c.7 1.6 1.3 4.3 .5 9c-.9 5-3.8 9-10.3 11.8c-7 3-17.7 4.3-31 2.2c-6.4-1-17.6-4.8-27.1-8.1l0 0 0 0c-2.2-.7-4.2-1.4-6.1-2.1l-15.2-5.1-10.1 30.4 15.2 5.1c1.3 .4 2.8 1 4.6 1.6l0 0 0 0 0 0c8.9 3 23 7.9 32.4 9.6V304v16h32V304v-8.9c6.3-.9 12.3-2.5 17.9-4.9c14.7-6.3 26.3-18.3 29.3-35.7c1.7-9.7 .9-18.9-2.7-27.2c-3.6-8.2-9.3-14.3-15.6-18.8c-11.6-8.4-27.2-13.1-39.5-16.9l0 0-.6-.2c-13.9-4.2-24.3-7.4-31-12c-3-2-4.3-3.8-5-5.1c-.6-1.2-1.2-3.3-.5-7.4c.6-3.6 3.3-7.8 10.5-11c7.3-3.3 18-4.9 30.9-2.9c4.4 .7 18.1 3.4 22.1 4.4l15.5 4.1 8.2-30.9-15.5-4.1c-5.1-1.4-18.2-3.9-24.1-4.9V112z'
      
    ]
  };

  
    var faSearchDollar = faMagnifyingGlassDollar;
  

  
  

  var faX = {
    prefix: 'fasl',
    iconName: 'x',
    icon: [
      384,
      512,
      [120],
      '58',
      
      'M340.8 32h40.1L212 256 380.9 480H340.8L192 282.6 43.2 480H3.1L172 256 3.1 32H43.2L192 229.4 340.8 32z'
      
    ]
  };

  

  
  

  var faSkullCow = {
    prefix: 'fasl',
    iconName: 'skull-cow',
    icon: [
      640,
      512,
      [],
      'f8de',
      
      'M61 24.6l-.5 1.3 0 0C54.8 42.2 47.8 61.7 49.4 77.7C52.3 106.3 76.3 128 105 128l55 0V96h32H448h32v32l55 0c28.7 0 52.7-21.7 55.6-50.3c1.6-16-5.3-35.5-11.1-51.8l-.5-1.3c-.7-2.1-1.4-4.1-2.1-6c-.3-.9-.6-1.7-.9-2.5L600 0c1.7 2.1 3.3 4.2 4.9 6.4c.8 1.1 1.6 2.1 2.4 3.2C625.2 34.4 640 65 640 95.5C640 182.1 582.8 240 512 240l-32 0V352v32H448 414.4L376 512H264L225.6 384H192 160V352 240l-32 0C57.2 240 0 182.1 0 95.5C0 65 14.8 34.4 32.7 9.6c.8-1.1 1.6-2.2 2.4-3.2C36.7 4.2 38.3 2.1 40 0L64 16c-.3 .8-.6 1.7-.9 2.5c-.7 2-1.4 4-2.1 6zM448 240V208.3 128H192v80.3V240 352h33.6 23.8l6.8 22.8L287.8 480h64.4l31.6-105.2 6.8-22.8h23.8H448V240zm32-31.7l32 0c43.6 0 83.5-30.4 93.8-84.7c-16 22-41.9 36.1-70.8 36.1l-55 0v48.6zM105 159.7h0c-28.9 0-54.8-14.1-70.8-36.1c10.2 54.3 50.1 84.7 93.8 84.7l32 0V159.7l-55 0zM232 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faComputerSpeaker = {
    prefix: 'fasl',
    iconName: 'computer-speaker',
    icon: [
      640,
      512,
      [],
      'f8b2',
      
      'M32 32H0V64 384v32H32 288V384H32V64H288V32H32zm80 416H96v32h16H288V448H112zM608 64V448H352V64H608zM352 32H320V64 448v32h32H608h32V448 64 32H608 352zM480 384a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM496 144a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM480 96a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faFerrisWheel = {
    prefix: 'fasl',
    iconName: 'ferris-wheel',
    icon: [
      512,
      512,
      [],
      'e174',
      
      'M240 32V48c0 8.8 7.2 16 16 16s16-7.2 16-16V32H240zM211.8 66.7C193.3 71 176 78 160 87.2V96v16c0 7.4-1.7 14.4-4.7 20.7l68.2 68.2c5.1-3 10.6-5.3 16.5-6.8V93.3c-12.7-4.5-23-14.2-28.2-26.6zM272 194c5.9 1.5 11.4 3.8 16.5 6.8l68.2-68.2c-3-6.3-4.7-13.3-4.7-20.7V96 87.2C336 78 318.7 71 300.2 66.7C295 79 284.7 88.8 272 93.3V194zm39.1 29.5c3 5.1 5.3 10.6 6.8 16.5h98V208h26.6c-4.6-18.8-11.9-36.6-21.6-52.8c-6.3 3.1-13.4 4.8-20.9 4.8c-7.4 0-14.4-1.7-20.7-4.7l-68.2 68.2zM418.7 272H318c-5 19.3-18.7 35.1-36.8 42.8L352 480v32H320 192 160V480l70.8-165.2c-18-7.7-31.8-23.5-36.8-42.8H93.3c-4.2 11.8-12.8 21.5-23.9 27c4.6 18.9 12 36.8 21.7 53H96h32 32v32 16c0 26.5-21.5 48-48 48s-48-21.5-48-48V384 369c-12.2-20.2-21.2-42.5-26.6-66.2C16 298 0 278.9 0 256V240 208H32h4.6c5.7-27.7 16.6-53.6 31.5-76.5c-2.7-6-4.1-12.6-4.1-19.5V96 64H96h32 8.6c21.6-13.6 45.7-23.7 71.4-29.3V32 0h32 32 32V32v2.7c25.7 5.6 49.8 15.7 71.4 29.3H384h32 32V96v16c0 6.9-1.5 13.6-4.1 19.5c14.9 22.9 25.8 48.8 31.5 76.5H480h32v32 16c0 22.9-16 42-37.4 46.8c-5.3 23.7-14.4 46-26.6 66.2v15 16c0 26.5-21.5 48-48 48s-48-21.5-48-48V384 352h32 32 4.9c9.7-16.3 17.1-34.1 21.7-53c-11.1-5.5-19.7-15.2-23.9-27zM194 240c1.5-5.9 3.8-11.4 6.8-16.5l-68.2-68.2c-6.3 3-13.3 4.7-20.7 4.7c-7.5 0-14.6-1.7-20.9-4.8c-9.7 16.2-17 34-21.6 52.8H96v32h98zM64 256V240H32v16c0 8.8 7.2 16 16 16s16-7.2 16-16zm384-16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V240H448zM96 96v16c0 8.8 7.2 16 16 16s16-7.2 16-16V96H96zm320 0H384v16c0 8.8 7.2 16 16 16s16-7.2 16-16V96zM96 400c0 8.8 7.2 16 16 16s16-7.2 16-16V384H96v16zm288-16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V384H384zM256 337.2L194.8 480H317.2L256 337.2zm0-49.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faDollarSign = {
    prefix: 'fasl',
    iconName: 'dollar-sign',
    icon: [
      320,
      512,
      [61781,128178,"dollar","usd"],
      '24',
      
      'M176 16V0H144V16 63.5c-6.3 .1-12.6 .3-18.8 .9c-24 2-47.9 7.8-67.4 20.6C37.7 98.1 23.2 118 17.9 146c-3.8 20.3-1.9 38.2 5.7 53.7C31 215 43.1 226.5 57.1 235.4c26.7 17 63.6 26.7 97.2 35.5l1.7 .4c35.7 9.4 67.8 17.9 89.8 31.9c10.6 6.8 17.8 14.2 21.9 22.6c4 8.3 5.8 19 3 33.8c-3.9 20.7-18.4 36.4-42.9 46c-24.9 9.8-59.1 12.6-98 7c-24.4-3.6-61-12.1-91.3-25.2l-14.7-6.3L11 410.6l14.7 6.3c33.6 14.5 73.1 23.5 99.3 27.4l.1 0c6.4 .9 12.7 1.6 18.9 2.1V496v16h32V496 447.4c23.2-.7 44.8-4.7 63.4-11.9c32-12.5 56.2-35.7 62.7-69.9c3.8-20.3 1.9-38.2-5.7-53.7c-7.4-15.3-19.6-26.8-33.5-35.6c-26.7-17-63.6-26.7-97.2-35.5l-1.7-.4c-35.7-9.4-67.8-17.9-89.8-31.9c-10.6-6.8-17.8-14.2-21.9-22.6c-4-8.3-5.8-19-3-33.8c3.6-19.3 13.1-31.8 26-40.2c13.4-8.8 31.5-13.7 52.6-15.5c42.3-3.5 91.3 6 124.3 14l15.5 3.8 7.6-31.1-15.5-3.8c-21.9-5.3-52.1-11.7-83.8-14.4V16z'
      
    ]
  };

  
    var faDollar = faDollarSign;
  
    var faUsd = faDollarSign;
  

  
  

  var faCircleWaveformLines = {
    prefix: 'fasl',
    iconName: 'circle-waveform-lines',
    icon: [
      512,
      512,
      ["waveform-circle"],
      'e12d',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 144V368v16H256V368 144 128h32v16zM160 176V336v16H128V336 176 160h32v16zm192 24V312v16H320V312 200 184h32v16zM224 216v80 16H192V296 216 200h32v16zm192 24v32 16H384V272 240 224h32v16z'
      
    ]
  };

  
    var faWaveformCircle = faCircleWaveformLines;
  

  
  

  var faFaceNoseSteam = {
    prefix: 'fasl',
    iconName: 'face-nose-steam',
    icon: [
      512,
      512,
      [],
      'e382',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 10.1-.7 20.1-2 29.9l31.7 4.2c1.5-11.2 2.3-22.6 2.3-34.1C512 114.6 397.4 0 256 0S0 114.6 0 256c0 11.6 .8 22.9 2.3 34.1L34 285.9c-1.3-9.8-2-19.7-2-29.9zM256 480c-15.4 0-30.3-1.5-44.8-4.5l-6.4 31.4c16.6 3.4 33.7 5.1 51.2 5.1s34.6-1.8 51.2-5.1l-6.4-31.4c-14.5 2.9-29.5 4.5-44.8 4.5zM182 290.3l-67.1 40.3c-1.1-1.4-2.3-2.8-3.7-4.1c-18.7-18.7-49.1-18.7-67.9 0c-2.7 2.7-5 5.6-6.9 8.8C22.7 334 8.6 338.6-1.9 349.1c-17.9 17.9-18.7 46.4-2.5 65.2c-10.3 23.4-5.8 51.8 13.4 70.9s47.5 23.6 70.9 13.4c18.9 16.2 47.3 15.4 65.2-2.5c10.5-10.5 15.1-24.6 13.9-38.3c3.1-1.9 6.1-4.2 8.8-6.9c18.7-18.7 18.7-49.1 0-67.9c-1.3-1.3-2.7-2.5-4.1-3.7l40.3-67.1-22-22zm-65.3 76.5l26.9-16.2-16.2 26.9-11.3 18.8 21.4 5c2.8 .7 5.4 2.1 7.6 4.3c6.2 6.2 6.2 16.4 0 22.6c-2.3 2.3-5.2 3.8-8.2 4.4l-20.3 4 9 18.6c2.9 6 1.8 13.3-3.1 18.2c-6.2 6.2-16.4 6.2-22.6 0c-1-1-1.9-2.2-2.6-3.4l-9.1-15.9L73.7 465.4c-12.5 9.6-30.6 8.7-42.1-2.8s-12.4-29.5-2.8-42.1L39.9 406l-15.9-9.1c-1.2-.7-2.3-1.5-3.4-2.6c-6.2-6.2-6.2-16.4 0-22.6c4.9-4.9 12.3-6 18.2-3.1l18.6 9 4-20.3c.6-3 2-5.8 4.4-8.2c6.2-6.2 16.4-6.2 22.6 0c2.2 2.2 3.6 4.8 4.3 7.6l5 21.4 18.8-11.3zm211.6-75.6l-22 22 40.3 67.1c-1.4 1.1-2.8 2.4-4.1 3.7c-18.7 18.7-18.7 49.1 0 67.9c2.7 2.7 5.6 5 8.8 6.9c-1.2 13.7 3.4 27.8 13.9 38.3c17.9 17.9 46.4 18.7 65.2 2.5c23.4 10.3 51.8 5.8 70.9-13.4s23.6-47.5 13.4-70.9c16.2-18.9 15.4-47.3-2.5-65.2c-10.5-10.5-24.6-15.1-38.3-13.9c-1.9-3.1-4.2-6.1-6.9-8.8c-18.7-18.7-49.1-18.7-67.9 0c-1.3 1.3-2.5 2.7-3.7 4.1l-67.1-40.3zm54.6 87.3l-16.2-26.9 26.9 16.2L412.4 379l5-21.4c.7-2.8 2.1-5.4 4.3-7.6c6.2-6.2 16.4-6.2 22.6 0c2.3 2.3 3.8 5.2 4.4 8.2l4 20.3 18.6-9c6-2.9 13.3-1.8 18.2 3.1c6.2 6.2 6.2 16.4 0 22.6c-1 1-2.2 1.9-3.4 2.6l-15.9 9.1 11.1 14.5c9.6 12.5 8.7 30.6-2.8 42.1s-29.5 12.4-42.1 2.8L422 455.1 412.9 471c-.7 1.2-1.5 2.3-2.6 3.4c-6.2 6.2-16.4 6.2-22.6 0c-4.9-4.9-6-12.3-3.1-18.2l9-18.6-20.3-4c-3-.6-5.8-2-8.2-4.4c-6.2-6.2-6.2-16.4 0-22.6c2.2-2.2 4.9-3.6 7.6-4.3l21.4-5-11.3-18.8zM96 224v32h16 96 16V224H208 112 96zm192 0v32h16 96 16V224H400 304 288zm27.3-36.7c9.3-9.3 38.2-32.3 73.7-44.1l15.2-5.1-5.1-15.2-5.1-15.2-15.2 5.1c-41.3 13.8-74.2 39.9-86.3 51.9L281.4 176l11.3 11.3 0 0 0 0L304 198.6l11.3-11.3zM122.9 143.2c35.5 11.8 64.4 34.8 73.7 44.1L208 198.6 230.6 176l-11.3-11.3c-12-12-45-38.1-86.3-51.9l-15.2-5.1-10.1 30.4 15.2 5.1z'
      
    ]
  };

  

  
  

  var faTurkishLiraSign = {
    prefix: 'fasl',
    iconName: 'turkish-lira-sign',
    icon: [
      384,
      512,
      ["try","turkish-lira"],
      'e2bb',
      
      'M96 32V48v77.1L251.6 80.6 267 76.2l8.8 30.8-15.4 4.4L96 158.4v62.7l155.6-44.5 15.4-4.4 8.8 30.8-15.4 4.4L96 254.4V448H208c79.5 0 144-64.5 144-144V272 256h32v16 32c0 97.2-78.8 176-176 176H80 64V464 263.5l-27.6 7.9L21 275.8 12.2 245l15.4-4.4L64 230.2V167.5l-27.6 7.9L21 179.8 12.2 149l15.4-4.4L64 134.2V48 32H96z'
      
    ]
  };

  
    var faTry = faTurkishLiraSign;
  
    var faTurkishLira = faTurkishLiraSign;
  

  
  

  var faPrint = {
    prefix: 'fasl',
    iconName: 'print',
    icon: [
      512,
      512,
      [9113,128424,128438],
      'f02f',
      
      'M96 160H64V32 0H96 384l64 64v96H416V77.3L370.7 32H96V160zm384 64H32V384H64V352 320H96 416h32v32 32h32V224zM448 416v64 32H416 96 64V480 416H32 0V384 224 192H32 480h32v32V384v32H480 448zM96 352V480H416V352H96zm352-96v32H416V256h32z'
      
    ]
  };

  

  
  

  var faCommentXmark = {
    prefix: 'fasl',
    iconName: 'comment-xmark',
    icon: [
      512,
      512,
      ["comment-times"],
      'f4b5',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM191.4 152.8l-22.6 22.6 11.3 11.3L233.4 240l-53.3 53.3-11.3 11.3 22.6 22.6 11.3-11.3L256 262.6l53.3 53.3 11.3 11.3 22.6-22.6-11.3-11.3L278.6 240l53.3-53.3 11.3-11.3-22.6-22.6-11.3 11.3L256 217.4l-53.3-53.3-11.3-11.3z'
      
    ]
  };

  
    var faCommentTimes = faCommentXmark;
  

  
  

  var faFaceSmileRelaxed = {
    prefix: 'fasl',
    iconName: 'face-smile-relaxed',
    icon: [
      512,
      512,
      [],
      'e392',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm129.7 71.2l28.6-14.3c8.7 17.5 41.3 55.2 97.7 55.2s88.9-37.7 97.7-55.2l28.6 14.3C369.7 352.3 327.6 400 256 400s-113.7-47.7-126.3-72.8zm89.5-89.6c-21.6-28.8-64.8-28.8-86.4 0l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2zm73.6 0l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0z'
      
    ]
  };

  

  
  

  var faArrowsSpin = {
    prefix: 'fasl',
    iconName: 'arrows-spin',
    icon: [
      512,
      512,
      [],
      'e4bb',
      
      'M257.1 79.5c-11.3 0-22.4 1.1-33.1 3.1V50.2c10.8-1.7 21.9-2.6 33.1-2.6c53.2 0 101.7 20 138.5 52.8l13.7-13.7L432 64l22.6 22.6L464 96v64 32H432 368l-9.4-9.4L336 160l22.6-22.6L373 123c-31-27.1-71.5-43.5-115.8-43.5zm-208 176c0-53 19.8-101.3 52.4-138L86.6 102.6 64 80 86.6 57.4 96 48h64 32V80v64l-9.4 9.4L160 176l-22.6-22.6-13.2-13.2c-26.8 30.9-43.1 71.2-43.1 115.3c0 11.1 1 21.9 3 32.5H51.7c-1.7-10.6-2.5-21.4-2.5-32.5zm384 0c0-10.8-1-21.3-2.8-31.5h32.4c1.6 10.3 2.4 20.8 2.4 31.5c0 53.8-20.4 102.8-53.9 139.7l14.1 14.1L448 432l-22.6 22.6L416 464H352 320V432 368l9.4-9.4L352 336l22.6 22.6 14 14c27.7-31.1 44.6-72.1 44.6-117zM288 428.8v32.4c-10.1 1.5-20.4 2.3-30.9 2.3c-53.5 0-102.3-20.2-139.2-53.5l-15.3 15.3L80 448 57.4 425.4 48 416V352 320H80h64l9.4 9.4L176 352l-22.6 22.6-12.8 12.8c31 27.5 71.8 44.1 116.5 44.1c10.5 0 20.8-.9 30.9-2.7zM160 130.7V80H109.3L160 130.7zm272-21.5L381.3 160H432V109.3zm-80 272V432h50.7L352 381.3zM80 402.7L130.7 352H80l0 50.7z'
      
    ]
  };

  

  
  

  var faExclamation = {
    prefix: 'fasl',
    iconName: 'exclamation',
    icon: [
      64,
      512,
      [10069,10071,61738],
      '21',
      
      'M48 48V32H16V48 352v16H48V352 48zm8 376H8v48H56V424z'
      
    ]
  };

  

  
  

  var faTentArrowsDown = {
    prefix: 'fasl',
    iconName: 'tent-arrows-down',
    icon: [
      576,
      512,
      [],
      'e581',
      
      'M214.6 129.2l-21.4-23.8-11.9 10.7-53.3 48L128 16V0H96V16l0 148.1-53.3-48L30.8 105.4 9.4 129.2l11.9 10.7 80 72 10.7 9.6 10.7-9.6 80-72 11.9-10.7zM64 512H96.3 479.7 512l-4.6-32L480 288 288 160 96 288 68.6 480 64 512zm240-32V377.8L365.3 480H304zm-32 0H100.9l24.8-173.3L272 209.1V319.7c0 .2 0 .4 0 .6V480zm32-270.9l146.3 97.6L475.1 480H402.7l-4.9-8.2L304 315.6V209.1zm250.7-69.2l11.9-10.7-21.4-23.8-11.9 10.7-53.3 48V16 0H448V16 164.1l-53.3-48-11.9-10.7-21.4 23.8 11.9 10.7 80 72 10.7 9.6 10.7-9.6 80-72z'
      
    ]
  };

  

  
  

  var faPlane = {
    prefix: 'fasl',
    iconName: 'plane',
    icon: [
      576,
      512,
      [],
      'f072',
      
      'M562.7 221.2c7.6 9.5 13.3 21.3 13.3 34.8c0 26.9-21.6 47.1-41.8 59.2c-21.1 12.7-47.3 20.8-67.9 20.8H365.9l-96 167.9-4.6 8.1H256 160 138.8l5.8-20.4L189.1 336H144l-43.2 57.6L96 400H88 24 3.5l5-19.9L39.5 256 8.5 131.9 3.5 112H24l64 0h8l4.8 6.4L144 176l45.1 0L144.6 20.4 138.8 0 160 0l96 0h9.3l4.6 8.1 96 167.9H466.3c20.7 0 46.9 8.4 68 21.2c10.7 6.5 20.8 14.5 28.4 24zm-45 3.3c-17.3-10.5-37.9-16.6-51.3-16.6H356.6h-9.3l-4.6-8.1L246.7 32l-65.5 0 44.5 155.6 5.8 20.4H210.3L136 208h-8l-4.8-6.4L80 144H44.5l27 108.1 1 3.9-1 3.9L44.5 368H80l43.2-57.6L128 304h8 74.3 21.2l-5.8 20.4L181.2 480h65.5l96-167.9 4.6-8.1h9.3H466.3c13.6 0 34.2-5.9 51.4-16.2C535.8 276.9 544 265.1 544 256c0-4.1-1.7-9-6.3-14.8c-4.6-5.8-11.5-11.5-20-16.7z'
      
    ]
  };

  

  
  

  var faFaceSadTear = {
    prefix: 'fasl',
    iconName: 'face-sad-tear',
    icon: [
      512,
      512,
      [128546,"sad-tear"],
      'f5b4',
      
      'M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm92.3 394.9c-25-27.1-57.4-42.9-92.3-42.9V320c45 0 85.6 20.5 115.7 53.1l10.9 11.7-23.5 21.7-10.9-11.8zM335.6 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-136 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM136 331.1c-5.2 5.8-8 13.3-8 21.1c0 17.4 14.3 31.8 32 31.8s32-14.4 32-31.8c0-7.8-2.9-15.3-8-21.1l-24-27-24 27zm-23.9-21.3l26.5-29.8L160 256l21.4 24.1 26.5 29.8c10.4 11.7 16.1 26.7 16.1 42.4c0 35.2-28.8 63.8-64 63.8s-64-28.5-64-63.8c0-15.6 5.7-30.7 16.1-42.4z'
      
    ]
  };

  
    var faSadTear = faFaceSadTear;
  

  
  

  var faBlockBrickFire = {
    prefix: 'fasl',
    iconName: 'block-brick-fire',
    icon: [
      640,
      512,
      ["firewall"],
      'e3dc',
      
      'M168 64v64h72 32 72V64H168zm-32 64V64H64v64h72zM64 160v80h72 32 72V160H64zm0 192h72V272H64v80zm0 32v64H240V384H168 136 64zm104-32H288c0 10.9 .9 21.6 2.7 32H272v64h41.8c6.6 11.5 14.5 22.2 23.3 32H64 32V448 64 32H64 448h32V64v82.6l-27.4-27.4-4.6 2.9V64H376v64h62.6l-7.5 4.7c-10.7 6.7-23.5 15.9-37 27.3H272v80h51.2c-6.4 10.1-12.2 20.8-17.2 32H168v80zM489.4 201.4L512 224l22.6-22.6L544 192c76.8 64 96 133.3 96 160c0 85.2-66.6 154.9-150.7 159.7c-3.1 .3-6.2 .4-9.3 .4s-6.3-.1-9.3-.4C386.6 506.9 320 437.2 320 352c0-89.6 85.3-165.3 128-192l41.4 41.4zM480 480c2.4 0 4.8-.1 7.2-.2c33.6-3.3 56.8-29.4 56.8-57.3c0-21.9-15.9-47.5-39-71.3c-8.8-9-17.6-16.9-25-23c-7.4 6.1-16.2 13.9-25 23c-23.1 23.8-39 49.5-39 71.3c0 27.8 23.2 54 56.8 57.3c2.4 .1 4.8 .2 7.2 .2zm96-57.4c0 5.4-.5 10.6-1.5 15.8C595.3 415.6 608 385.3 608 352c0-14.1-11-63.7-63-115.8l-10.4 10.4L512 269.3l-22.6-22.6-45-45c-16.2 12.7-34.9 30-51.4 50.7c-24.3 30.5-41 65-41 99.7c0 33.3 12.7 63.6 33.5 86.3c-1-5.1-1.5-10.4-1.5-15.8c0-70.4 96-134.4 96-134.4s96 64 96 134.4z'
      
    ]
  };

  
    var faFirewall = faBlockBrickFire;
  

  
  

  var faUserInjured = {
    prefix: 'fasl',
    iconName: 'user-injured',
    icon: [
      448,
      512,
      [],
      'f728',
      
      'M320 128c0-5.5-.5-10.8-1.3-16H192 129.3c-.9 5.2-1.3 10.5-1.3 16c0 53 43 96 96 96s96-43 96-96zM186.4 80l57.4-46c-6.4-1.3-13-2-19.8-2c-35.5 0-66.6 19.3-83.2 48h45.5zm51.2 0h69.5c-7.4-12.7-17.6-23.6-29.8-31.8L237.6 80zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM80 360.8L43.3 480H80V360.8zM112 480H226.9L135.2 336H112V480zm91.7-96H336h16v16 80h52.7L360.4 336H173.1l30.5 48zm20.4 32l40.7 64H320V416H224.1zM160 512H96 33.5 0l9.8-32L64 304H384l54.2 176 9.8 32H414.5 352 336 176 160z'
      
    ]
  };

  

  
  

  var faBrainCircuit = {
    prefix: 'fasl',
    iconName: 'brain-circuit',
    icon: [
      512,
      512,
      [],
      'e0c6',
      
      'M192 32h48V80v48H212.7c-6.2-14.1-20.3-24-36.7-24c-22.1 0-40 17.9-40 40s17.9 40 40 40c16.4 0 30.5-9.9 36.7-24H240V272H160 144v16 27.3c-14.1 6.2-24 20.3-24 36.7c0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.4-9.9-30.5-24-36.7V304h64V432v48H192c-20.4 0-37.9-12.8-44.8-30.8L142.5 437l-12.9 2.2c-3.1 .5-6.3 .8-9.5 .8c-30.9 0-56-25.1-56-56c0-7.8 1.6-15.2 4.4-21.8l5.3-12.6-11.6-7.2C44 331 32 310.9 32 288c0-19.1 8.4-36.3 21.7-48.1l7.9-7-3.3-10c-1.5-4.7-2.4-9.7-2.4-15c0-20.4 12.8-38 30.9-44.9l12.5-4.8-2.5-13.2c-.6-3-.9-6-.9-9.2c0-22.4 15.4-41.3 36.2-46.5l11-2.8 1.1-11.3C146.5 51.1 167 32 192 32zm80 128h64v27.3c-14.1 6.2-24 20.3-24 36.7c0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.4-9.9-30.5-24-36.7V144 128H352 272V80 32h48c25 0 45.5 19.1 47.8 43.4l1.1 11.3 11 2.8C400.6 94.7 416 113.6 416 136c0 3.1-.3 6.2-.9 9.2l-2.5 13.2 12.5 4.8C443.2 170 456 187.6 456 208c0 5.2-.8 10.3-2.4 15l-3.3 10 7.9 7C471.6 251.7 480 268.9 480 288c0 22.9-12 43-30.2 54.3l-11.6 7.2 5.3 12.6c2.8 6.7 4.4 14.1 4.4 21.8c0 30.9-25.1 56-56 56c-3.3 0-6.5-.3-9.5-.8L369.5 437l-4.7 12.2c-6.9 18-24.4 30.8-44.8 30.8H272V432 384h59.3c6.2 14.1 20.3 24 36.7 24c22.1 0 40-17.9 40-40s-17.9-40-40-40c-16.4 0-30.5 9.9-36.7 24H272V160zM192 512h48 16 16 48c29.6 0 55.5-16.1 69.3-40c.9 0 1.8 0 2.7 0c48.6 0 88-39.4 88-88c0-7.6-1-15-2.8-22c21.2-17.6 34.8-44.2 34.8-74c0-25.1-9.6-48-25.4-65c.9-4.9 1.4-9.9 1.4-15c0-29.6-16.1-55.5-40-69.3c0-.9 0-1.8 0-2.7c0-33.6-20.7-62.4-50.1-74.2C389.7 26.4 357.9 0 320 0H272 256 240 192c-37.9 0-69.7 26.4-77.9 61.8C84.7 73.6 64 102.4 64 136c0 .9 0 1.8 0 2.7C40.1 152.5 24 178.4 24 208c0 5.1 .5 10.1 1.4 15C9.6 240 0 262.9 0 288c0 29.8 13.6 56.4 34.8 74C33 369 32 376.4 32 384c0 48.6 39.4 88 88 88c.9 0 1.8 0 2.7 0c13.8 23.9 39.7 40 69.3 40zM176 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM160 336a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM336 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm32 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faSkiBootSki = {
    prefix: 'fasl',
    iconName: 'ski-boot-ski',
    icon: [
      640,
      512,
      [],
      'e3cd',
      
      'M380.2 32l6.9-32h32.7L370.2 231.2l100.9 50.5 8.8 4.4V296 400v16H464 96 76.4l3.9-19.2 72-352L154.9 32H168 380.2zM233 64H181.1L148.3 224h51.3L233 64zm32.7 0L228.3 243.3 225.7 256h-13H141.8L115.6 384H448V305.9L348.2 256H288 272V224h16 51.1l6.9-32H304 288V160h16 48 .8l20.6-96H265.7zM640 416v80 16H624 16 0V480H16 608V416 400h32v16z'
      
    ]
  };

  

  
  

  var faKeyboardBrightnessLow = {
    prefix: 'fasl',
    iconName: 'keyboard-brightness-low',
    icon: [
      640,
      512,
      [],
      'e1c1',
      
      'M336 128H304v32h32V128zM121.4 208L144 230.6 166.6 208 144 185.4 121.4 208zM96 384H64v32H96V384zm112 0H192v32h16H432h16V384H432 208zm368 0H544v32h32V384zM473.4 208L496 230.6 518.6 208 496 185.4 473.4 208z'
      
    ]
  };

  

  
  

  var faBenchTree = {
    prefix: 'fasl',
    iconName: 'bench-tree',
    icon: [
      640,
      512,
      [],
      'e2e7',
      
      'M575.2 106.1c.5-3.3 .8-6.7 .8-10.1c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 3.5 .3 6.8 .8 10.1l3.1 19.4-15.9 11.5C423.8 145.8 416 160 416 176v48H608V176c0-16-7.8-30.2-19.9-38.9l-15.9-11.5 3.1-19.4zM384 176c0-26.7 13.1-50.3 33.2-64.9c-.8-4.9-1.2-10-1.2-15.1c0-53 43-96 96-96s96 43 96 96c0 5.1-.4 10.2-1.2 15.1C626.9 125.7 640 149.3 640 176v48 32H608 528V496v16H496V496 256H416 384V224 176zM64 224v64H96 288h32V224H64zm0 96H32V288 224 192H64 320h32v32 64 32H320v48h16 32 16v32H368 352v96 16H320V496 400H304 80 64v96 16H32V496 400H16 0V368H16 48 64V320zm32 0v48H288V320H96z'
      
    ]
  };

  

  
  

  var faCircle3 = {
    prefix: 'fasl',
    iconName: 'circle-3',
    icon: [
      512,
      512,
      [],
      'e0f0',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-360.6V128H320 176 160v32h16H276.7l-79.2 67.9-5.6 4.8v23.4l16.1-.1 63.5-.3c26.7-.1 48.4 21.5 48.4 48.2c0 26.6-21.6 48.2-48.2 48.2h-36c-17.5 0-34-8.2-44.5-22.2l-2.5-3.4-9.6-12.8-25.6 19.2 9.6 12.8 2.5 3.4c16.5 22.1 42.5 35 70.1 35h36c44.3 0 80.2-35.9 80.2-80.2c0-44.4-36.1-80.4-80.6-80.2l-19.9 .1 78.9-67.6 5.6-4.8z'
      
    ]
  };

  

  
  

  var faCardsBlank = {
    prefix: 'fasl',
    iconName: 'cards-blank',
    icon: [
      640,
      512,
      [],
      'e4df',
      
      'M421.2 353.6L222.6 468.3 43.7 158.4 242.3 43.7 421.2 353.6zM226.3 16L0 146.7 194.9 484.3l16 27.7 27.7-16L437.2 381.4l27.7-16-16-27.7L270 27.7 254 0 226.3 16zM320 512h32H608h32V480 96 64H608 336.1h-8.2l18.5 32H608V480H352V467.5L320 486v26z'
      
    ]
  };

  

  
  

  var faBone = {
    prefix: 'fasl',
    iconName: 'bone',
    icon: [
      576,
      512,
      [129460],
      'f5d7',
      
      'M146.4 208l-2.6-29.1C141.2 150.4 117.2 128 88 128c-30.9 0-56 25.1-56 56c0 18.9 9.3 35.6 23.8 45.8l8.2 5.8v40.8l-8.2 5.8C41.3 292.4 32 309.1 32 328c0 30.9 25.1 56 56 56c29.2 0 53.2-22.4 55.8-50.9l2.6-29.1h29.2H400.4h29.2l2.6 29.1c2.6 28.5 26.6 50.9 55.8 50.9c30.9 0 56-25.1 56-56c0-18.9-9.3-35.6-23.8-45.8l-8.2-5.8V235.6l8.2-5.8C534.7 219.6 544 202.9 544 184c0-30.9-25.1-56-56-56c-29.2 0-53.2 22.4-55.8 50.9L429.6 208H400.4 175.6 146.4zm254-32c4-44.9 41.7-80 87.6-80c48.6 0 88 39.4 88 88c0 18.1-5.5 34.9-14.8 48.9c-6 9-13.7 16.9-22.6 23.1c8.9 6.2 16.5 14.1 22.6 23.1c9.4 14 14.8 30.8 14.8 48.9c0 48.6-39.4 88-88 88c-45.9 0-83.6-35.1-87.6-80H175.6c-4 44.9-41.7 80-87.6 80c-48.6 0-88-39.4-88-88c0-18.1 5.5-34.9 14.8-48.9c6-9 13.7-16.9 22.6-23.1c-8.9-6.2-16.5-14.1-22.6-23.1C5.5 218.9 0 202.1 0 184c0-48.6 39.4-88 88-88c45.9 0 83.6 35.1 87.6 80H400.4z'
      
    ]
  };

  

  
  

  var faFileCheck = {
    prefix: 'fasl',
    iconName: 'file-check',
    icon: [
      384,
      512,
      [],
      'f316',
      
      'M32 480V32H192V176v16h16H352V480H32zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zm51.3 294l11.3-11.3L272 260l-11.3 11.3-95.4 95.4-42-42L112 313.4 89.4 336l11.3 11.3L154 400.6 165.3 412l11.3-11.3L283.3 294z'
      
    ]
  };

  

  
  

  var faArrowUpFromWaterPump = {
    prefix: 'fasl',
    iconName: 'arrow-up-from-water-pump',
    icon: [
      576,
      512,
      [],
      'e4b6',
      
      'M96 32V256H256V32H96zm192 0V256H432l0-193.4-68.7 68.7L352 142.6 329.4 120l11.3-11.3 96-96L448 1.4l11.3 11.3 96 96L566.6 120 544 142.6l-11.3-11.3L464 62.6 464 256h80 32v32V415c-10.2 0-21.3-2.7-32-6.7V288H288 256 96 64 32V408.3c-10.7 4-21.8 6.7-32 6.7V288 256H32 64V32 0H96 256h32V32zM192 480c20.9 0 41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C342.3 470.1 363.1 480 384 480s41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C534.4 470.1 555.1 480 576 480v32c-30.3 0-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.9 9.9-19.8 15.3C441.5 497.9 414.3 512 384 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 497.9 222.3 512 192 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.8-19.8 15.3C57.6 497.9 30.3 512 0 512V480c20.9 0 41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.7 23.2 24.3 37.8 34.2C150.3 470.1 171.1 480 192 480z'
      
    ]
  };

  

  
  

  var faBoot = {
    prefix: 'fasl',
    iconName: 'boot',
    icon: [
      512,
      512,
      [129406],
      'f782',
      
      'M32 32H352V96H32V32zM0 0V32 96v32H32 352h32V96 32 0H352 32 0zM240 160H224v32h16 80v32H240 224v32h16 80.6l22.2 6.7L480 303.8V384H32V160H0V384v32 64l32 32H96l9.4-9.4L128 480l22.6 22.6L160 512h64l9.4-9.4L256 480l22.6 22.6L288 512h64l9.4-9.4L384 480l22.6 22.6L416 512h64l32-32V416 384 280L352 232v-8V160H336 320 240zM32 416H96 416h64v50.7L466.7 480H429.3l-22.6-22.6-9.4-9.4H370.7l-9.4 9.4L338.7 480H301.3l-22.6-22.6-9.4-9.4H242.7l-9.4 9.4L210.7 480H173.3l-22.6-22.6-9.4-9.4H114.7l-9.4 9.4L82.7 480H45.3L32 466.7V416z'
      
    ]
  };

  

  
  

  var faTruckContainer = {
    prefix: 'fasl',
    iconName: 'truck-container',
    icon: [
      640,
      512,
      [],
      'f4dc',
      
      'M16 32H400h16V48 304v16H384V304 64H32V304v16H0V304 48 32H16zm432 96h16 88 7.1l4.8 5.3 72 80 4.1 4.6V224v32 48 16 48 32H608c0 44.2-35.8 80-80 80s-80-35.8-80-80H288c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c32.8 0 61 19.7 73.3 48H448V256 240 224 144 128zm32 128v80c13.4-10 30-16 48-16c32.8 0 61 19.7 73.3 48H608V320 304 256H480zm122.5-32l-57.6-64H480v64H602.5zM128 96v16V272v16H96V272 112 96h32zm96 0v16V272v16H192V272 112 96h32zm96 0v16V272v16H288V272 112 96h32zM528 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faPenFancySlash = {
    prefix: 'fasl',
    iconName: 'pen-fancy-slash',
    icon: [
      640,
      512,
      [],
      'e210',
      
      'M552.6 125.8L576 104 553.4 81.4 494.6 22.6 472 0 450.2 23.4 314 169.7l25.2 19.9L472.8 46.1l57.1 57.1L392.2 231.4l25.4 20.1 135-125.7zM295.8 318.5L307.4 330l-28.9 92.4L130.8 467.8 198.7 400c.4 0 .9 0 1.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24c0 .4 0 .9 0 1.3l-67.8 67.8 45.4-147.7 82.9-25.9-30.4-24L128 272 64 480l32 32 208-64 30.9-98.7-39-30.8zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faToggleLargeOff = {
    prefix: 'fasl',
    iconName: 'toggle-large-off',
    icon: [
      576,
      512,
      [],
      'e5b0',
      
      'M32 128H288V384H32V128zM288 416h32H544h32V384 128 96H544 320 288 32 0v32V384v32H32 288zm32-32V128H544V384H320zM96 192H224V320H96V192zM64 160v32V320v32H96 224h32V320 192 160H224 96 64z'
      
    ]
  };

  

  
  

  var faLightSwitchOff = {
    prefix: 'fasl',
    iconName: 'light-switch-off',
    icon: [
      384,
      512,
      [],
      'e018',
      
      'M176 464v16H32V32H176V48 64h32V48 32H352V480H208V464 448H176v16zM0 512H32 352h32V480 32 0H352 32 0V32 480v32zM96 272V384v32h32H256h32V384 272 240 128 96H256 128 96v32V240v32zm32-32V128H256V240H128zm0 32H256V384H128V272zm48 72h32 16V312H208 176 160v32h16z'
      
    ]
  };

  

  
  

  var faCupcake = {
    prefix: 'fasl',
    iconName: 'cupcake',
    icon: [
      448,
      512,
      [129473],
      'e402',
      
      'M216 0H186.1l16.6 24.9 10.8 16.3c1.6 2.4 2.5 5.3 2.5 8.2c0 8.1-6.6 14.7-14.7 14.7H144c-40.5 0-74 30.1-79.3 69.2C27.1 146.2 0 181.9 0 224v48 16H16 432h16V272 224c0-42-26.9-77.6-64.4-90.7C378.2 58.8 315.9 0 240 0H216zm32 49.3c0-5.9-1.1-11.8-3.3-17.2C304.4 34.6 352 83.7 352 144c0 .4 0 .8 0 1.2l-.3 13.4 13.1 2.7C394 167.2 416 193.1 416 224v32H32V224c0-30.9 22-56.8 51.2-62.7l13.1-2.7L96 145.2c0-.4 0-.8 0-1.2c0-26.5 21.5-48 48-48h57.3C227.1 96 248 75.1 248 49.3zM96 512h87.8 .3 79.7 .3H352l26.5-192H346.2L324.1 480H281.4l13.3-160H262.6L249.3 480H198.7L185.4 320H153.3l13.3 160H123.9L101.8 320H69.5L96 512z'
      
    ]
  };

  

  
  

  var faBugSlash = {
    prefix: 'fasl',
    iconName: 'bug-slash',
    icon: [
      640,
      512,
      [],
      'e490',
      
      'M560 304h16V272H560 480V192v-9.4l59.3-59.3L550.6 112 528 89.4l-11.3 11.3L457.4 160H448 301.7l40.5 32H448v80 3.5L484.1 304H560zM411.4 409.7c-19.7 20.1-46 33.7-75.4 37.4V350.2l-32-25.3V447c-63.1-7.9-112-61.7-112-127V304 272 236.5l-32-25.3V272H80 64v32H80h80v16c0 30.2 8.4 58.4 22.9 82.5l-74.2 74.2L97.4 488 120 510.6l11.3-11.3 71-71C231.5 460.1 273.4 480 320 480c46 0 87.4-19.4 116.6-50.4l-25.2-19.9zM224 98.7L261.2 128H384h32V96c0-53-43-96-96-96s-96 43-96 96v2.7zM320 32c35.3 0 64 28.7 64 64H256c0-35.3 28.7-64 64-64zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faFaceSadSweat = {
    prefix: 'fasl',
    iconName: 'face-sad-sweat',
    icon: [
      576,
      512,
      [],
      'e38a',
      
      'M288 32C174.4 32 80.6 116.5 66 226.1l-31.7-4.2C50.9 96.6 158.2 0 288 0C429.4 0 544 114.6 544 256s-114.6 256-256 256c-57.6 0-110.8-19.1-153.6-51.2l19.2-25.6C191 463.3 237.5 480 288 480c123.7 0 224-100.3 224-224S411.7 32 288 32zM222.6 160l-11.3 11.3-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L200 137.4 222.6 160zm-15 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm184 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM358.8 422.6l-10.7-11.9c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7l-10.7 11.9-23.8-21.4 10.7-11.9C220.2 371.4 248.3 352 288 352s67.8 19.4 83.9 37.3l10.7 11.9-23.8 21.4zm5.9-251.3L353.4 160 376 137.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM40 347.1c-5.2 5.8-8 13.3-8 21.1C32 385.6 46.3 400 64 400s32-14.4 32-31.8c0-7.8-2.9-15.3-8-21.1l-24-27-24 27zM16.1 325.9l26.5-29.8L64 272l21.4 24.1 26.5 29.8c10.4 11.7 16.1 26.7 16.1 42.4c0 35.2-28.8 63.8-64 63.8s-64-28.5-64-63.8c0-15.6 5.7-30.7 16.1-42.4z'
      
    ]
  };

  

  
  

  var faLocationPinSlash = {
    prefix: 'fasl',
    iconName: 'location-pin-slash',
    icon: [
      640,
      512,
      ["map-marker-slash"],
      'f60c',
      
      'M512 192C512 86 426 0 320 0C263.8 0 213.3 24.1 178.2 62.5l25.2 19.9C232.6 51.4 274 32 320 32c88.4 0 160 71.6 160 160c0 15.6-5.4 37-16.6 63.4c-3.3 7.7-6.9 15.6-10.9 23.7l25.6 20.2C498.3 259.8 512 221.9 512 192zM176.6 255.4c-6.7-15.9-11.4-30-14-42.2L128.1 186c-.1 2-.1 4-.1 6c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0c17.3-21.6 42-53.6 67.2-89.8l-25.2-19.9c-24.4 35.2-48.5 66.5-65.8 88.1c-25.4-31.8-65.8-84.7-99.9-140c-17.3-28.1-32.7-56.3-43.6-82.1zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  
    var faMapMarkerSlash = faLocationPinSlash;
  

  
  

  var faWindWarning = {
    prefix: 'fasl',
    iconName: 'wind-warning',
    icon: [
      640,
      512,
      ["wind-circle-exclamation"],
      'f776',
      
      'M390.3 352c-33.2 57.4-95.2 96-166.3 96C118 448 32 362 32 256S118 64 224 64s192 86 192 192h32C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480c89.4 0 166.5-52.3 202.4-128H390.3zM240 128H208v16V272v16h32V272 144 128zm8 192H200v48h48V320zM496 480h48c53 0 96-43 96-96s-43-96-96-96H336 320v32h16H544c35.3 0 64 28.7 64 64s-28.7 64-64 64H496 480v32h16zm48-256c53 0 96-43 96-96s-43-96-96-96H496 480V64h16 48c35.3 0 64 28.7 64 64s-28.7 64-64 64H471.9c2.7 10.4 4.7 21.1 6.1 32h66z'
      
    ]
  };

  
    var faWindCircleExclamation = faWindWarning;
  

  
  

  var faPaperclipVertical = {
    prefix: 'fasl',
    iconName: 'paperclip-vertical',
    icon: [
      384,
      512,
      [],
      'e3c2',
      
      'M64 96c0-53 43-96 96-96s96 43 96 96V352c0 35.3-28.7 64-64 64s-64-28.7-64-64V144 128h32v16V352c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-35.3-28.7-64-64-64s-64 28.7-64 64V384c0 53 43 96 96 96s96-43 96-96V144 128h32v16V384c0 70.7-57.3 128-128 128s-128-57.3-128-128V96z'
      
    ]
  };

  

  
  

  var faHundredPoints = {
    prefix: 'fasl',
    iconName: 'hundred-points',
    icon: [
      512,
      512,
      [128175,"100"],
      'e41c',
      
      'M177.4 93.3c5-35.2 35.2-61.3 70.7-61.3c43.5 0 76.9 38.5 70.7 81.5L302.6 226.7c-5 35.2-35.2 61.3-70.7 61.3c-43.5 0-76.9-38.5-70.7-81.5L177.4 93.3zM248.1 64c-19.6 0-36.3 14.4-39 33.9L192.9 211c-3.4 23.8 15 45 39 45c19.6 0 36.3-14.4 39-33.9L287.1 109c3.4-23.8-15-45-39-45zM99.7 74.4L54.3 94.6l-14.7 6.5L27 71.9l14.7-6.5 72-32 22.1 16.8-40 256-2.5 15.8-31.6-4.4 2.5-15.8L99.7 74.4zM425.6 32c42.8 0 76.1 37.3 71.2 79.8l-11.2 96.7c-4.2 36.1-34.8 63.4-71.2 63.4c-42.8 0-76.1-37.3-71.2-79.8l11.2-96.7C358.6 59.3 389.2 32 425.6 32zM386.2 99.1L375 195.8c-2.7 23.5 15.7 44.2 39.4 44.2c20.1 0 37.1-15.1 39.4-35.1L465 108.2C467.7 84.6 449.3 64 425.6 64c-20.1 0-37.1 15.1-39.4 35.1zM498.1 351.9l-480 64-4.2-31.7 480-64 4.2 31.7zm-32.1 96l-256 32-4-31.8 256-32 15.9-2 4 31.8-15.9 2z'
      
    ]
  };

  
    var fa100 = faHundredPoints;
  

  
  

  var faDown = {
    prefix: 'fasl',
    iconName: 'down',
    icon: [
      384,
      512,
      ["arrow-alt-down"],
      'f354',
      
      'M240 272l0-32 0-176-96 0 0 176 0 32-32 0-80 0 0 2.7 160 160 160-160 0-2.7-80 0-32 0zm144 16L214.6 457.4 192 480l-22.6-22.6L0 288l0-16 0-32 32 0 48 0 32 0 0-32 0-144 0-32 32 0 96 0 32 0 0 32 0 144 0 32 32 0 48 0 32 0 0 32 0 16z'
      
    ]
  };

  
    var faArrowAltDown = faDown;
  

  
  

  var faNoteSticky = {
    prefix: 'fasl',
    iconName: 'note-sticky',
    icon: [
      448,
      512,
      [62026,"sticky-note"],
      'f249',
      
      'M32 64H416V304H288 272v16V448H32V64zM304 442.7V336H410.7L304 442.7zm8 37.3L448 344V64 32H416 32 0V64 448v32H32 312z'
      
    ]
  };

  
    var faStickyNote = faNoteSticky;
  

  
  

  var faDiceD12 = {
    prefix: 'fasl',
    iconName: 'dice-d12',
    icon: [
      512,
      512,
      [],
      'f6ce',
      
      'M0 187.4v23.5V324.6L68.6 443.4l98.3 56.7L187.4 512H324.6l20.5-11.9 98.3-56.7L512 324.6V210.9 187.4L443.4 68.6 424.6 57.8 324.6 0H187.4L87.4 57.8 68.6 68.6 0 187.4zM91.6 92.7l148.4 47V246.4L131.3 304.7 32 198.2V196L91.6 92.7zm180.4 47l148.4-47L480 196v2.3L380.7 304.7 272 246.4V139.7zM383.3 70.9L256 111.2 128.7 70.9 196 32l120 0 67.3 38.9zM480 245.2V316L420 420l-60.5 34.9 38.7-122L480 245.2zM318.4 478.6L316 480H196l-2.4-1.4L147.3 332.4 256 274.2l108.7 58.3L318.4 478.6zM152.5 454.9L92 420 32 316l0-70.9 81.8 87.7 38.7 122z'
      
    ]
  };

  

  
  

  var faGramophone = {
    prefix: 'fasl',
    iconName: 'gramophone',
    icon: [
      384,
      512,
      [],
      'f8bd',
      
      'M125.1 8.8L109 3.5l-4.5 16.3-72 264-3.5 12.7 11.7 5.9 16 8 8.8 4.4 7.9-5.8C191 222 276.9 235.3 314.7 247.3c11.9 3.8 20.1 16.1 21.1 33.4c-1.5 21.9-19.7 39.2-42 39.3l-.2 0H176l0 32H293.7l.2 0 6.4 0c37.4 0 67.7-30.3 67.7-67.7c0-1.1 0-2.3-.1-3.4c0-1.1 .1-2.1 .1-3.2c0-29.5-17.6-54.9-41.6-68.7c-64.2-36.8-106.2-82.8-132-119.4c-12.9-18.3-21.8-34.3-27.5-45.6c-2.8-5.6-4.8-10.1-6.1-13.1c-.6-1.5-1.1-2.6-1.4-3.3l-.3-.8-.1-.1 0 0 0 0 0 0-2.6-7.3-7.4-2.5-24-8zM168.2 108c21.3 30.1 52.5 65.9 96.5 98.7c-49.2-1.7-116.3 11.4-196 66.3L131 44.5l1 .3c1.5 3.4 3.5 7.9 6.2 13.4c6.3 12.5 16 30 30 49.8zM320 416v64H64V416H320zM64 384H32v32 64 0H16 0v32H16 368h16V480H368 352v0V416 384H320 64z'
      
    ]
  };

  

  
  

  var faJar = {
    prefix: 'fasl',
    iconName: 'jar',
    icon: [
      320,
      512,
      [],
      'e516',
      
      'M272 0V32H48V0H272zM32 96v96H288V96H32zm0 128V352H288V224H32zm0 160v96H288V384H32zM0 64H32 288h32V96 480v32H288 32 0V480 96 64z'
      
    ]
  };

  

  
  

  var faMagnet = {
    prefix: 'fasl',
    iconName: 'magnet',
    icon: [
      448,
      512,
      [129522],
      'f076',
      
      'M0 32H16 128h16V48 256c0 44.2 35.8 80 80 80s80-35.8 80-80V48 32h16H432h16V48 256c0 123.7-100.3 224-224 224S0 379.7 0 256V48 32zM32 64v64h80V64H32zm0 192c0 106 86 192 192 192s192-86 192-192V160H336v96c0 61.9-50.1 112-112 112s-112-50.1-112-112V160H32v96zM416 128V64H336v64h80z'
      
    ]
  };

  

  
  

  var faCircle2 = {
    prefix: 'fasl',
    iconName: 'circle-2',
    icon: [
      512,
      512,
      [],
      'e0ef',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm-3.9-352H257c26 0 47 21 47 47c0 12-4.6 23.5-12.8 32.2L176 361.7V384H352V352H229l85.5-90.8c10.1-10.7 16.9-23.9 19.8-38.2l1.6-16c0-43.6-35.4-79-79-79h-4.9c-22.2 0-43.6 8.8-59.3 24.6L169.4 176 192 198.6l23.4-23.4c9.7-9.7 22.9-15.2 36.7-15.2z'
      
    ]
  };

  

  
  

  var fa1 = {
    prefix: 'fasl',
    iconName: '1',
    icon: [
      256,
      512,
      [],
      '31',
      
      'M16 143.4l3.4-2.5L112 73.6V448H16 0v32H16 128 240h16V448H240 144V48 32H128h-8-5.2l-4.2 3.1L16 103.9v39.6z'
      
    ]
  };

  

  
  

  var faFalafel = {
    prefix: 'fasl',
    iconName: 'falafel',
    icon: [
      576,
      512,
      [129478],
      'e40a',
      
      'M152 152l15.7-31.9-.6-35.7 27.6-21.8 14.6-32.5 34.1-7.3L270.2 0 304 8.6 337.8 0l26.9 22.8 34.1 7.3 14.6 32.5 27.6 21.8-.6 35.7L456 152l-14.3 29.1-9.7 2.5-23.8-6 0-.8 3.4-6.9 8.7-17.8-8.7-17.8-3.4-6.9 .1-7.7 .3-19.9-15.2-12-6.2-4.9-3.2-7.2L376.2 58l-18.3-3.9-7.8-1.7L344 47.2 329.7 35.1l-17.8 4.5-7.9 2-7.9-2-17.8-4.5L264 47.2l-6.1 5.2-7.8 1.7L231.8 58l-7.9 17.7-3.2 7.2-6.2 4.9-15.2 12 .3 19.9 .1 7.7-3.4 6.9L187.6 152l8.7 17.8 3.4 6.9 0 1.1-5.8-4.9-16 4-12.2 3.1L152 152zM269.6 270.6l.7 .6-7.5 5.9 .3 15.9 .2 13.1-13.1-10-6.3-4.8-3.3-7.2-8.3-17.9-19.4-4.1-7.7-1.6-6.1-5-15.3-12.6-19.3 4.7-7.6 1.9-7.6-1.9-19.3-4.7-15.3 12.6-6.1 5-7.7 1.6-19.4 4.1L73.1 284l-3.3 7.2L63.5 296 47.8 308l.3 19.6 .1 7.9-3.6 7.1L35.9 360l8.8 17.5 3.6 7.1-.1 7.9L47.8 412l15.6 12 6.3 4.8 3.3 7.2 8.3 17.9 19.4 4.1 7.7 1.6 6.1 5 15.3 12.6 19.3-4.7 7.6-1.9 7.6 1.9 19.3 4.7 15.3-12.6 6.1-5 7.7-1.6 19.4-4.1 8.3-17.9 3.3-7.2 6.3-4.8 13.1-10-.2 13.1-.3 15.9 7.5 5.9-.7 .6-15 32.5-35.2 7.3L191.7 512l-34.9-8.6L121.9 512 94.2 489.2 59 481.9 44 449.4 15.5 427.6l.6-35.7L0 360l16.2-31.9-.6-35.7L44 270.6l15-32.5 35.2-7.3L121.9 208l34.9 8.6 34.9-8.6 27.7 22.8 35.2 7.3 15 32.5zm271 99.7c11.8 3.6 22.9 4.9 32.1 3.3l-4.4 18.3 .2 14.2 .4 21.5-27.6 21.8-14.6 32.5-34.1 7.3L465.8 512 432 503.4 398.2 512l-26.9-22.8-34.1-7.3-14.6-32.5-27.6-21.8 .6-35.7L280 360l15.7-31.9-.6-35.7 27.6-21.8 14.6-32.5 34.1-7.3L398.2 208l.5 .1 31.6 8c-2.9 5-4.3 11.1-4.5 17.9c-.8 27 18.3 65.3 46.6 93.6c20.2 20.2 45.6 35.7 68.3 42.6zm-4.1 32.1c-9-2.4-17.8-5.7-25.9-9.4c-21.4-9.8-42.9-24.7-60.9-42.7c-20.7-20.7-37.3-46.1-46.9-70.8c-3.1-8.1-6-17.4-7.6-27l-3.2 2.7-6.1 5.2-7.8 1.7L359.8 266l-7.9 17.7-3.2 7.2-6.2 4.9-15.2 12 .3 19.9 .1 7.7-3.4 6.9L315.6 360l8.7 17.8 3.4 6.9-.1 7.7-.3 19.9 15.2 12 6.2 4.9 3.2 7.2 7.9 17.7 18.3 3.9 7.8 1.7 6.1 5.2 14.3 12.1 17.8-4.5 7.9-2 7.9 2 17.8 4.5L472 464.8l6.1-5.2 7.8-1.7 18.3-3.9 7.9-17.7 3.2-7.2 6.2-4.9 15.2-12-.2-9.9zM224 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM64 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm32 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48-80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm224 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faPenSwirl = {
    prefix: 'fasl',
    iconName: 'pen-swirl',
    icon: [
      512,
      512,
      [],
      'e214',
      
      'M166.3 318.3L184 224 385.4 22.6 408 0l22.6 22.6 58.7 58.7L512 104l-22.6 22.6L288 328l-94.3 17.7L160 352l6.3-33.7zm33.7-6.3l72.3-13.6L410.1 160.7l-58.7-58.7L213.6 239.6l-13.6 72.3zM466.7 104L408 45.3 373.9 79.3l58.7 58.7L466.7 104zM464 256c0-18-2.3-35.5-6.6-52.2l25.7-25.7c8.4 24.4 12.9 50.6 12.9 77.8c0 79.5-64.5 144-144 144c-12.4 0-24.5-1.6-36-4.5l8-31c8.9 2.3 18.3 3.5 28 3.5c61.9 0 112-50.1 112-112zM256 16c27.2 0 53.4 4.5 77.8 12.9L308.2 54.6C291.5 50.3 274 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208v32C123.5 496 16 388.5 16 256S123.5 16 256 16z'
      
    ]
  };

  

  
  

  var faCommentExclamation = {
    prefix: 'fasl',
    iconName: 'comment-exclamation',
    icon: [
      512,
      512,
      [],
      'f4af',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM272 112H240v16V256v16h32V256 128 112zM232 352h48V304H232v48z'
      
    ]
  };

  

  
  

  var faGripDots = {
    prefix: 'fasl',
    iconName: 'grip-dots',
    icon: [
      448,
      512,
      [],
      'e410',
      
      'M384 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM224 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM48 176a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM384 352a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM208 336a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM64 352a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faSquareFull = {
    prefix: 'fasl',
    iconName: 'square-full',
    icon: [
      512,
      512,
      [11035,11036,128997,128998,128999,129000,129001,129002,129003],
      'f45c',
      
      'M480 32V480H32V32H480zM32 0H0V32 480v32H32 480h32V480 32 0H480 32z'
      
    ]
  };

  

  
  

  var faStopwatch20 = {
    prefix: 'fasl',
    iconName: 'stopwatch-20',
    icon: [
      448,
      512,
      [],
      'e06f',
      
      'M320 0H128V32h80V96.6C100.6 104.8 16 194.5 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-47.6-16-91.4-42.9-126.5l38.2-38.2L438.6 128 416 105.4l-11.3 11.3-37 37c-33.7-32.3-78.3-53.3-127.7-57V32h80V0zM224 480a176 176 0 1 1 0-352 176 176 0 1 1 0 352zm16-240V368c0 26.5 21.5 48 48 48s48-21.5 48-48V240c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48-16c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM151.8 235.3c2.3-6.8 8.6-11.3 15.7-11.3c9.1 0 16.5 7.4 16.5 16.5v14.8c0 7.1-2.4 14-6.9 19.6l-32.6 40.7c-15.9 19.9-24.5 44.5-24.5 70V400v16h16 64 16V384H200 152c.4-17.6 6.5-34.6 17.5-48.3L202.1 295c9-11.2 13.9-25.2 13.9-39.6V240.5c0-26.8-21.7-48.5-48.5-48.5c-20.9 0-39.4 13.4-46.1 33.2l-.6 1.7-5.1 15.2 30.4 10.1 5.1-15.2 .6-1.7z'
      
    ]
  };

  

  
  

  var faShieldExclamation = {
    prefix: 'fasl',
    iconName: 'shield-exclamation',
    icon: [
      512,
      512,
      [],
      'e247',
      
      'M48.5 114.9L256 34.3l207.5 80.5c2.7 45.6-4.5 116.8-34.7 186.3S345.4 438.4 256 477.1C166.6 438.4 113.4 370.7 83.2 301.2S45.8 160.5 48.5 114.9zm447-1.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM272 128H240v16V272v16h32V272 144 128zM232 368h48V320H232v48z'
      
    ]
  };

  

  
  

  var faCloudSun = {
    prefix: 'fasl',
    iconName: 'cloud-sun',
    icon: [
      640,
      512,
      [9925],
      'f6c4',
      
      'M109.3 135.6l22.5-3.8 3.8-22.5 9-53.9 45.1 31.6L208 99.7l18.4-12.8 45.1-31.6 9 53.9 3.8 22.5 22.5 3.8 53.9 9-31.6 45.1-7.8 11.1c14-5.5 29.3-8.6 45.2-8.7l29.1-41.6L416 121.3l-35-5.8L312 104 300.5 35 294.7 0 265.6 20.3 208 60.7 150.4 20.3 121.3 0l-5.8 35L104 104 35 115.5 0 121.3l20.3 29.1L60.7 208 20.3 265.6 0 294.7l35 5.8L104 312l11.5 69 5.8 35 29.1-20.3 13-9.1c6.4-27.4 21.7-51.4 42.6-68.9l-16.3 11.4-45.1 31.6-9-53.9-3.8-22.5-22.5-3.8-53.9-9 31.6-45.1L99.7 208 86.9 189.7 55.3 144.6l53.9-9zM288 208c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c14.2 0 27.5-3.7 39.1-10.2c7.8-22.5 21.8-42.1 39.9-56.9c.7-4.2 1-8.5 1-12.9zm-32 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm112 16c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6v64 32h32 64H559.9l48 0h32v-80c0-37.1-25.3-68.4-59.7-77.4c-2-.5-4.1-1-6.2-1.4c.5-2.1 .8-4.1 1.1-6.2c.5-3.6 .8-7.3 .8-11c0-44.2-35.8-80-80-80c-13.2 0-25.7 3.2-36.7 8.9c-3.2 1.6-6.2 3.5-9.1 5.5c-2.2-3.6-4.6-7.1-7.3-10.4C425.2 238 398.2 224 368 224zM607.9 431.9v48l-48 0H288 224v-64c0-31.7 23-58 53.3-63.1l26.9-4.5-.2-27.3 0-1.2c.1-35.3 28.7-63.9 64-63.9c23.2 0 43.5 12.3 54.8 30.9l17.7 29.3 28-19.6c7.8-5.4 17.2-8.6 27.4-8.6c26.5 0 48 21.5 48 48c0 3.6-.4 7.1-1.1 10.4l-7.1 32.5 32.8 5.8c22.4 4 39.5 23.7 39.5 47.2z'
      
    ]
  };

  

  
  

  var faSyringe = {
    prefix: 'fasl',
    iconName: 'syringe',
    icon: [
      512,
      512,
      [128137],
      'f48e',
      
      'M424 1.4L401.4 24l11.3 11.3L433.4 56 384 105.4 315.3 36.7 304 25.4 281.4 48l11.3 11.3 80 80 80 80L464 230.6 486.6 208l-11.3-11.3L406.6 128 456 78.6l20.7 20.7L488 110.6 510.6 88 499.3 76.7l-32-32-32-32L424 1.4zM121.4 240L68.7 292.7 64 297.4V304 425.4L12.7 476.7 1.4 488 24 510.6l11.3-11.3L86.6 448H208h6.6l4.7-4.7L425.4 237.3l-22.6-22.6L201.4 416H96V310.6l48-48 52.7 52.7L208 326.6 230.6 304l-11.3-11.3L166.6 240 208 198.6l52.7 52.7L272 262.6 294.6 240l-11.3-11.3L230.6 176l66.7-66.7L274.7 86.6 208 153.4 185.4 176 144 217.4 121.4 240z'
      
    ]
  };

  

  
  

  var faBoombox = {
    prefix: 'fasl',
    iconName: 'boombox',
    icon: [
      640,
      512,
      [128254],
      'f8a5',
      
      'M64 0H80 560h16V16 160h32 32v32V480v32H608 32 0V480 192 160H32 64V16 0zM96 32V160H544V32H96zM32 192V480H608V192H560 80 32zM256 336A80 80 0 1 0 96 336a80 80 0 1 0 160 0zM64 336a112 112 0 1 1 224 0A112 112 0 1 1 64 336zm400 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM208 96h32 16v32H240 208 192V96h16zm96 0h32 16v32H336 304 288V96h16zm96 0h32 16v32H432 400 384V96h16z'
      
    ]
  };

  

  
  

  var faUserNurse = {
    prefix: 'fasl',
    iconName: 'user-nurse',
    icon: [
      448,
      512,
      [],
      'f82f',
      
      'M128 128V70.2l96-36 96 36V128v16H128V128zM96 160v16c0 70.7 57.3 128 128 128s128-57.3 128-128V160 128 48L224 0 96 48v80 32zm224 16c0 53-43 96-96 96s-96-43-96-96H320zM200.7 445.9L224 470.7l23.3-24.8L335.7 352h25.2l42.7 128H44.4L87.1 352h25.2l88.4 93.9zM384 320H321.9L246 400.7 224 424l-22-23.3L126.1 320H64L10.7 480 0 512H33.7 414.3 448l-10.7-32L384 320zM208 48V72H184v32h24v24h32V104h24V72H240V48H208z'
      
    ]
  };

  

  
  

  var faTrashCheck = {
    prefix: 'fasl',
    iconName: 'trash-check',
    icon: [
      448,
      512,
      [],
      'e2af',
      
      'M160 0h-8.9l-4.7 7.5L111.1 64H64.1 32 0V96H34.3L64 512H384L413.7 96H448V64H416 383.9 336.9L301.6 7.5 296.9 0H288 160zM299.1 64H148.9l20-32H279.1l20 32zM93.8 480L66.4 96H381.6L354.2 480H93.8zM331.3 235.3L342.6 224 320 201.4l-11.3 11.3L192 329.4l-52.7-52.7L128 265.4 105.4 288l11.3 11.3 64 64L192 374.6l11.3-11.3 128-128z'
      
    ]
  };

  

  
  

  var faBridgeSuspension = {
    prefix: 'fasl',
    iconName: 'bridge-suspension',
    icon: [
      640,
      512,
      [],
      'e4cd',
      
      'M112 0h-1.9l-4.4 8.8c-23 46-61.3 91.7-98.7 117L25 152.3c31.7-21.4 62.8-54.7 87-90.9V256H16 0v32H16 624h16V256H624 528V61.4c24.2 36.2 55.4 69.5 87 90.9L633 125.8c-37.4-25.3-75.7-71-98.7-117L529.9 0H528h-8H504h-8-1.3l-4.6 8.1C452.1 74.6 390.8 128 320 128S187.9 74.6 149.9 8.1L145.3 0H144h-8H120h-8zM304 159.3V256H240V141.1c19.9 9.7 41.3 16.1 64 18.2zm-96-37.4V128 256H144V57.6c17.9 24.4 39.5 46.7 64 64.3zm128 37.4c22.7-2.1 44.1-8.5 64-18.2V256H336V159.3zm96-37.4c24.5-17.6 46.1-39.9 64-64.3V256H432V128v-6.1zM0 320v32H16 96V496v16h16 96 16V496 352H416V496v16h16 96 16V496 352h80 16V320H624 528 512v16V480H448V336 320H432 208 192v16V480H128V336 320H112 16 0z'
      
    ]
  };

  

  
  

  var faTrainTram = {
    prefix: 'fasl',
    iconName: 'train-tram',
    icon: [
      448,
      512,
      [128650],
      'e5b4',
      
      'M48.3 0H56 392h7.7l4.8 6 32 40 10 12.5-25 20L411.5 66 384.3 32H240V96H352h32v32V416v32H352h-9.4l52.7 52.7L406.6 512H361.4l-64-64H150.6l-64 64H41.4l0 0 11.3-11.3L105.4 448H96 64V416 128 96H96 208V32H63.7L36.5 66l-10 12.5-25-20L11.5 46l32-40 4.8-6zM208 128H96V256H352V128H240 208zM96 416H352V288H96V416zm72-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm88 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faStarshipFreighter = {
    prefix: 'fasl',
    iconName: 'starship-freighter',
    icon: [
      576,
      512,
      [],
      'e03a',
      
      'M377.1 371.9L315.5 285c2.9-9.2 4.5-18.9 4.5-29c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c.6 0 1.1 0 1.7 0l60.7 85.7C266.8 444.4 245.8 448 224 448C118 448 32 362 32 256S118 64 224 64c104.4 0 189.3 83.3 191.9 187c0 1.6 .1 3.3 .1 5c0 1.7 0 3.5-.1 5.2c-1.1 41.5-15.4 79.8-38.9 110.7zM405.4 400H397l-.6-.9c22.5-27.1 38.7-59.5 46.5-95.1h4.6H544v42.1L405.4 400zm74.6 5.3L576 368V304 272H544 479.5 447.4c.4-5.3 .6-10.6 .6-16c0-5.3-.2-10.6-.6-15.8l0-.2h32.1H544h32V208 144L347.6 55.2C308.2 39.9 266.3 32 224 32C100.3 32 0 132.3 0 256S100.3 480 224 480c28.7 0 57.1-3.6 84.8-10.7l13.5 19.1L339 512h29 56 56V405.3zM447.4 208h-4.6c-8.4-38.6-26.8-73.5-52.3-101.8L544 165.9V208H447.4zM80 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 368a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM348.2 469.6L262.3 344.1c15-6.5 28-16.8 37.9-29.6L380.7 432H424h24v48H424 368 355.3l-7.1-10.4z'
      
    ]
  };

  

  
  

  var faUserLarge = {
    prefix: 'fasl',
    iconName: 'user-large',
    icon: [
      512,
      512,
      ["user-alt"],
      'f406',
      
      'M368 144a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zM48 480H464L410.7 352H101.3L48 480zM80 320H432l66.7 160L512 512H477.3 34.7 0l13.3-32L80 320z'
      
    ]
  };

  
    var faUserAlt = faUserLarge;
  

  
  

  var faCirclesOverlap = {
    prefix: 'fasl',
    iconName: 'circles-overlap',
    icon: [
      640,
      512,
      [],
      'e600',
      
      'M232 415.8c-25.2-36.2-40-80.3-40-127.8c0-99.1 64.3-183.1 153.5-212.7C312.4 48.2 270.1 32 224 32C118 32 32 118 32 224s86 192 192 192c2.7 0 5.4-.1 8-.2zm36.4-5C353 390.8 416 314.7 416 224c0-46.7-16.7-89.5-44.4-122.8C287 121.2 224 197.3 224 288c0 46.7 16.7 89.5 44.4 122.8zm-11.6 34.8c-10.7 1.6-21.7 2.4-32.8 2.4C100.3 448 0 347.7 0 224S100.3 0 224 0c62.3 0 118.6 25.4 159.2 66.4C393.9 64.8 404.8 64 416 64c123.7 0 224 100.3 224 224s-100.3 224-224 224c-62.3 0-118.6-25.4-159.2-66.4zM408 96.2c25.2 36.3 40 80.3 40 127.8c0 99.1-64.3 183.1-153.5 212.7C327.6 463.8 369.9 480 416 480c106 0 192-86 192-192s-86-192-192-192c-2.7 0-5.4 .1-8 .2z'
      
    ]
  };

  

  
  

  var faRulerVertical = {
    prefix: 'fasl',
    iconName: 'ruler-vertical',
    icon: [
      256,
      512,
      [],
      'f548',
      
      'M224 32V96H160 144v32h16 64v64H160 144v32h16 64v64H160 144v32h16 64v64H160 144v32h16 64v64H32V32H224zM32 0H0V32 480v32H32 224h32V480 32 0H224 32z'
      
    ]
  };

  

  
  

  var faRightLeftLarge = {
    prefix: 'fasl',
    iconName: 'right-left-large',
    icon: [
      640,
      512,
      [],
      'e5e1',
      
      'M185.4 496L25.4 336l160-160H256v64H416v64h25.4l128-128L441.4 48H416v64H272V80H384V16h70.6l160 160-160 160H384V272H224V208H198.6L70.6 336l128 128H224V400H368v32H256v64H185.4z'
      
    ]
  };

  

  
  

  var faArrowDownFromArc = {
    prefix: 'fasl',
    iconName: 'arrow-down-from-arc',
    icon: [
      512,
      512,
      [],
      'e614',
      
      'M256 31.9c-123.7 0-224 100.3-224 224l0 16-32 0 0-16C0 114.5 114.6-.1 256-.1s256 114.6 256 256l0 16-32 0 0-16c0-123.7-100.3-224-224-224zM116 354.5l-10.6-12 23.9-21.3 10.6 12L240 445.8l0-269.9 0-16 32 0 0 16 0 269.9L372 333.3l10.6-12 23.9 21.3-10.6 12-128 144L256 512l-12-13.5-128-144z'
      
    ]
  };

  

  
  

  var faFlower = {
    prefix: 'fasl',
    iconName: 'flower',
    icon: [
      448,
      512,
      [10047,127804],
      'f7ff',
      
      'M203.3 88.7C185.1 73.3 161.7 64 136 64C78.6 64 32 110.6 32 168c0 25.7 9.3 49.1 24.7 67.3L74.3 256 56.7 276.7C41.3 294.9 32 318.3 32 344c0 57.4 46.6 104 104 104c25.7 0 49.1-9.3 67.3-24.7L224 405.7l20.7 17.6C262.9 438.7 286.3 448 312 448c57.4 0 104-46.6 104-104c0-25.7-9.3-49.1-24.7-67.3L373.7 256l17.6-20.7C406.7 217.1 416 193.7 416 168c0-57.4-46.6-104-104-104c-25.7 0-49.1 9.3-67.3 24.7L224 106.3 203.3 88.7zM448 168c0 33.6-12.2 64.3-32.3 88c20.1 23.7 32.3 54.4 32.3 88c0 75.1-60.9 136-136 136c-33.6 0-64.3-12.2-88-32.3c-23.7 20.1-54.4 32.3-88 32.3C60.9 480 0 419.1 0 344c0-33.6 12.2-64.3 32.3-88C12.2 232.3 0 201.6 0 168C0 92.9 60.9 32 136 32c33.6 0 64.3 12.2 88 32.3C247.7 44.2 278.4 32 312 32c75.1 0 136 60.9 136 136zM224 352l-22.6-22.6-50.7-50.7L128 256l22.6-22.6 50.7-50.7L224 160l22.6 22.6 50.7 50.7L320 256l-22.6 22.6-50.7 50.7L224 352zm0-146.7L173.3 256 224 306.7 274.7 256 224 205.3z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassMinus = {
    prefix: 'fasl',
    iconName: 'magnifying-glass-minus',
    icon: [
      512,
      512,
      ["search-minus"],
      'f010',
      
      'M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L487.9 510.5l22.6-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM112 192H96v32h16H304h16V192H304 112z'
      
    ]
  };

  
    var faSearchMinus = faMagnifyingGlassMinus;
  

  
  

  var faCalendarHeart = {
    prefix: 'fasl',
    iconName: 'calendar-heart',
    icon: [
      448,
      512,
      [],
      'e0d3',
      
      'M128 16V0H96V16 64H32 0V96v64 32V480v32H32 416h32V480 192 160 96 64H416 352V16 0H320V16 64H128V16zM32 192H416V480H32V192zm0-96H416v64H32V96zM216.3 257.2c-11.5-11-26.8-17.2-42.7-17.2h-2.4c-32.7 0-59.2 26.5-59.2 59.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L224 432.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2h-2.4c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4zm79.3 61.6L224 387.7l-71.7-68.9c-5.3-5.1-8.3-12.2-8.3-19.6c0-15 12.2-27.2 27.2-27.2h2.4c7.7 0 15 3 20.5 8.3l7.7 7.4L224 309l22.2-21.3 7.7-7.4c5.5-5.3 12.9-8.3 20.5-8.3h2.4c15 0 27.2 12.2 27.2 27.2c0 7.4-3 14.5-8.3 19.6z'
      
    ]
  };

  

  
  

  var faMask = {
    prefix: 'fasl',
    iconName: 'mask',
    icon: [
      576,
      512,
      [],
      'f6fa',
      
      'M252.2 320H272h32 19.8l8.8 17.7L371.8 416H400c41 0 76.8-13.6 102.1-37.3c25-23.4 41.9-58.7 41.9-106.7c0-49.8-14-91.7-48.9-121.8C459.3 119.3 396.2 96 288 96s-171.3 23.3-207.1 54.2C46 180.3 32 222.2 32 272c0 47.9 16.9 83.2 41.9 106.7C99.2 402.4 135 416 176 416h28.2l39.2-78.3 8.8-17.7zM224 448H176C80 448 0 384 0 272S64 64 288 64s288 96 288 208s-80 176-176 176H352l-48-96H272l-48 96zM160 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm288 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faTreeDecorated = {
    prefix: 'fasl',
    iconName: 'tree-decorated',
    icon: [
      448,
      512,
      [],
      'f7dc',
      
      'M392 224h-8.7H360 344l22.9 32L424 336v32H407.3 392 368l22.9 32L448 480v32H416 32 0V480l57.1-80L80 368H56 40.7 24V336l57.1-80L104 224H88 64.7 56V192L202.7 24.3 224 0l21.3 24.3L392 192v32zM224 48.6L98.5 192H104h62.2L130 242.6 63.3 336H80h62.2L106 386.6 39.3 480H408.7L342 386.6 305.8 336H368h16.7L318 242.6 281.8 192H344h5.5L224 48.6zM184 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32-104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm72 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faBrush = {
    prefix: 'fasl',
    iconName: 'brush',
    icon: [
      384,
      512,
      [],
      'f55d',
      
      'M128 384H96 32 0V352 32 0H32 352h32V32 352v32H352 288 256v32 64 32H224 160 128V480 416 384zm0-32h32v32 96h64V384 352h32 96V288H32v64h96zm224-96V32H224v80 16H192V112 32H128V144v16H96V144 32H32V256H352z'
      
    ]
  };

  

  
  

  var faMugSaucer = {
    prefix: 'fasl',
    iconName: 'mug-saucer',
    icon: [
      640,
      512,
      ["coffee"],
      'f0f4',
      
      'M416 64h16 16V224v32 96H128V64H416zm64 288V256h48c61.9 0 112-50.1 112-112s-50.1-112-112-112H480 448 432 416 128 96V64 352v32h32H448h32V352zm48-128H480V64h48c44.2 0 80 35.8 80 80s-35.8 80-80 80zM16 448H0v32H16 560h16V448H560 16z'
      
    ]
  };

  
    var faCoffee = faMugSaucer;
  

  
  

  var faGarlic = {
    prefix: 'fasl',
    iconName: 'garlic',
    icon: [
      512,
      512,
      [129476],
      'e40e',
      
      'M156.9 155.5L72.7 222.8C47 243.4 32 274.6 32 307.5c0 56 42.4 102.1 96.9 107.9C99 390 80 352.1 80 309.9c0-38.8 16.5-75.9 45.3-101.8c15.7-14.1 26.6-32.5 31.6-52.7zM224 416c61.8 0 112-50.4 112-112.3c0-26.9-9.6-53-27.1-73.3l-17.1-19.9c-33.5-39-51.9-88.8-51.9-140.2V32H192V96v16 15.4 2.8c0 38.8-16.5 75.8-45.3 101.7c-22.1 19.9-34.7 48.3-34.7 78C112 368.4 159.4 416 217.8 416H224zM272 70.2c0 43.8 15.7 86.1 44.1 119.3l17.1 19.9c22.5 26.2 34.8 59.7 34.8 94.2c0 45.3-20.9 85.8-53.7 112.3h57.2C431.4 416 480 367.4 480 307.5c0-33-15-64.1-40.7-84.7L332 137l-12-9.6V112 32H272V70.2zM208 448H176v48 16H144V496 448h-3.5C62.9 448 0 385.1 0 307.5c0-42.7 19.4-83 52.7-109.7L160 112V96 32 0h32H320h32V32v80l107.3 85.8c33.3 26.7 52.7 67 52.7 109.7C512 385.1 449.1 448 371.5 448H368v48 16H336V496 448H304v48 16H272V496 448H240v48 16H208V496 448z'
      
    ]
  };

  

  
  

  var faCommentArrowUp = {
    prefix: 'fasl',
    iconName: 'comment-arrow-up',
    icon: [
      512,
      512,
      [],
      'e144',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM272 320V182.6l52.7 52.7L336 246.6 358.6 224l-11.3-11.3-80-80L256 121.4l-11.3 11.3-80 80L153.4 224 176 246.6l11.3-11.3L240 182.6V320v16h32V320z'
      
    ]
  };

  

  
  

  var faRectangleWide = {
    prefix: 'fasl',
    iconName: 'rectangle-wide',
    icon: [
      640,
      512,
      [],
      'f2fc',
      
      'M608 96V416H32V96H608zM32 64H0V96 416v32H32 608h32V416 96 64H608 32z'
      
    ]
  };

  

  
  

  var faWindowMinimize = {
    prefix: 'fasl',
    iconName: 'window-minimize',
    icon: [
      512,
      512,
      [128469],
      'f2d1',
      
      'M512 448H0v32H512V448z'
      
    ]
  };

  

  
  

  var faFileInvoice = {
    prefix: 'fasl',
    iconName: 'file-invoice',
    icon: [
      384,
      512,
      [],
      'f570',
      
      'M32 480V32H192V176v16h16H352V480H32zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM64 64V96H80h64 16V64H144 80 64zm0 64v32H80h64 16V128H144 80 64zM224 448h16 64 16V416H304 240 224v32zm64-112H96V272H288v64zM96 240H64v32 64 32H96 288h32V336 272 240H288 96z'
      
    ]
  };

  

  
  

  var faHandDots = {
    prefix: 'fasl',
    iconName: 'hand-dots',
    icon: [
      512,
      512,
      ["allergies"],
      'f461',
      
      'M208 0h16 80 16l0 16 0 16h64 16V48 96h0 64 16v16V336c0 97.2-78.8 176-176 176l0 0h-8.5c-65.8 0-128.9-26.1-175.4-72.6L16.4 335.6 4.7 323.9 0 319.2v-6.6V279.4v-6.6l4.7-4.7 40-40L56 216.8l11.3 11.3 28.3 28.3L128 288.8V48 32h16 64V16 0zM368 128V112 64H320V80 240v16H288V240 80 64h0l0-16 0-16H240V48 240v16H208V240 64H160V304v6.6l-4.7 4.7L143.6 327l-11.3 11.3L121 327 73 279l-17-17-24 24v19.9l7 7L142.8 416.7c40.5 40.5 95.4 63.3 152.7 63.3H304l0 0c79.5 0 144-64.5 144-144V128H400V240v16H368V240 128h0zM240 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM320 416a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-80-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  
    var faAllergies = faHandDots;
  

  
  

  var faArrowDownToDottedLine = {
    prefix: 'fasl',
    iconName: 'arrow-down-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e095',
      
      'M235.3 347.3L224 358.6l-11.3-11.3-128-128L73.4 208 96 185.4l11.3 11.3L208 297.4V192 48 32h32V48 192 297.4L340.7 196.7 352 185.4 374.6 208l-11.3 11.3-128 128zM56 424v48H8V424H56zm96 0v48H104V424h48zm48 48V424h48v48H200zm144-48v48H296V424h48zm48 0h48v48H392V424z'
      
    ]
  };

  

  
  

  var faClockTwelveThirty = {
    prefix: 'fasl',
    iconName: 'clock-twelve-thirty',
    icon: [
      512,
      512,
      [],
      'e359',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 144V400v16H240V400 144 128h32v16z'
      
    ]
  };

  

  
  

  var faOnion = {
    prefix: 'fasl',
    iconName: 'onion',
    icon: [
      448,
      512,
      [129477],
      'e427',
      
      'M198.7 52.9c-2.9 7.6-6.3 14.8-10.1 21.5c-.5 .9-1.1 2.1-1.8 3.5c-2.1 4.1-5.2 10.1-8.9 17.6c-7.4 15-17.2 35.9-27.1 59.7C130.8 203.4 112 260.8 112 304c0 39.4 14.5 70.3 29.2 91.5c7.3 10.6 14.7 18.7 20.1 24.1c2.4 2.4 4.4 4.2 5.9 5.5c14.6 3.4 29.6 5.5 44.9 6.4c-2.2-4.5-4.5-9.4-6.8-14.9C194.6 391.3 184 355.2 184 312c0-61.9 6.1-128.6 12.1-179.6c3-25.6 6-47.3 8.3-62.6l.6-4.1-6.3-12.7zM95.3 126C120.5 105.6 144.8 85.8 160 60l1-1.8 .7-1.3 .2-.3 .1-.1 0 0 0 0 .1 0c8.7-16 14-34.3 14-56.4h28.2H208l16 32L240 0h3.8H272c0 22.1 5.2 40.4 13.9 56.3l.1 0 0 0 0 0 .1 .1 .2 .4 .7 1.4 1.2 2.2c15.3 25.7 39.5 45.4 64.5 65.7C399 163.7 448 203.5 448 288c0 83.4-62.5 139.3-140.4 163.1l-.1 .1-.6 .6-.2 .2-.1 .1 0 0 0 0s0 0-.1-.1c-.1-.1-.2-.2-.3-.4c-.2 0-.3 .1-.5 .1l13.7 48-30.8 8.8-14.1-49.3c-11.4 2.1-22.9 3.5-34.5 4.3V496v16H208V496 463.4c-11.6-.8-23.1-2.2-34.5-4.3l-14.1 49.3-30.8-8.8 13.7-48C63.6 428.2 0 372.1 0 288c0-84.5 49-124.3 95.3-162zm154-73.1L235.1 81.4c-2.1 14.4-4.6 33.2-7.2 54.7C221.9 186.6 216 251.9 216 312c0 37.9 9.4 69.8 18.8 92.2c4.7 11.2 9.4 19.9 12.8 25.8l.3 .5c14.7-1.5 29.2-4.2 43.1-8c.8-.8 1.6-1.7 2.6-2.7c5.1-5.6 12-13.8 18.9-24.3c13.8-21 27-49.9 27-83.6c0-44.9-19.7-104.3-40.5-154.1c-10.3-24.6-20.5-46.2-28.2-61.6c-3.8-7.7-7-13.9-9.3-18.1c-.7-1.3-1.3-2.4-1.8-3.3c-4-6.9-7.5-14.2-10.4-21.9zM359.2 391.3c35.3-25 56.8-59.5 56.8-103.3c0-64.5-33.4-96.1-76.3-131.2c-2.8-2.3-5.7-4.6-8.6-7l0 0-1.4-1.1c20.5 49.6 41.7 112.6 41.7 163.3c0 34.3-10.9 63.9-23.6 86.7c3.9-2.4 7.7-4.9 11.4-7.4zM116.9 149.8c-3 2.4-5.8 4.7-8.7 7C65.4 191.9 32 223.5 32 288c0 43.8 21.5 78.3 56.8 103.3c6 4.3 12.5 8.3 19.2 11.9C93.2 378.7 80 345.3 80 304c0-48.4 19.7-108.3 39.1-156l-2.2 1.8z'
      
    ]
  };

  

  
  

  var faUserClock = {
    prefix: 'fasl',
    iconName: 'user-clock',
    icon: [
      640,
      512,
      [],
      'f4fd',
      
      'M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM43.3 480L87.6 336H322.9c2-11.1 5.1-21.8 9.1-32H64L9.8 480 0 512H33.5 394.8c-12.9-9.1-24.5-19.9-34.6-32H43.3zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-224H480v16 64 16h16 48 16V352H544 512V304 288z'
      
    ]
  };

  

  
  

  var faCloudShowers = {
    prefix: 'fasl',
    iconName: 'cloud-showers',
    icon: [
      512,
      512,
      [],
      'f73f',
      
      'M384 128v32h32c35.3 0 64 28.7 64 64v64H416 96 32V224c0-27.8 17.8-51.6 42.7-60.4L96 156.1V133.5 112c0-44.2 35.8-80 80-80c27 0 50.9 13.4 65.5 34l17.8 25.2 25.9-16.9c10-6.5 22-10.3 34.9-10.3c35.3 0 64 28.7 64 64zM0 320H32 96 416h64 32V288 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v64 32zm128 64V368H96v16 80 16h32V464 384zm192 0V368H288v16 80 16h32V464 384zm-96 32V400H192v16 80 16h32V496 416zm192 0V400H384v16 80 16h32V496 416z'
      
    ]
  };

  

  
  

  var faThumbsUp = {
    prefix: 'fasl',
    iconName: 'thumbs-up',
    icon: [
      512,
      512,
      [61575,128077],
      'f164',
      
      'M224 32h16 96 16V48 98.4c0 21.1-3 41.8-8.6 61.6H448h48 16v16 96 16H496v56 16H480h-8v48 16H456h-8v40 16H432 384 272 257.5h-4.8l-4-2.7-12.1-8.1-76.5-51V379.8l94.2 62.8 8.1 5.4H272 384h32V408 392h16 8V344 328h16 8V272 256h16V192H448 321 297.3l8.8-22c9-22.5 13.9-46.7 13.9-71.7V64H256V98.4c0 42.8-21.4 82.8-57 106.5l-24.8 16.5-6.5 4.4-1.4 .9-1.6 .6-4.7 1.9V192.4l21.3-14.2C208 160.5 224 130.5 224 98.4V48 32zM32 224V448H96V224H32zM0 192H32 96h32v32V448v32H96 32 0V448 224 192z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassPlus = {
    prefix: 'fasl',
    iconName: 'magnifying-glass-plus',
    icon: [
      512,
      512,
      ["search-plus"],
      'f00e',
      
      'M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L487.9 510.5l22.6-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm16-304H192v16 64H128 112v32h16 64v64 16h32V288 224h64 16V192H288 224V128 112z'
      
    ]
  };

  
    var faSearchPlus = faMagnifyingGlassPlus;
  

  
  

  var faIdCardClip = {
    prefix: 'fasl',
    iconName: 'id-card-clip',
    icon: [
      576,
      512,
      ["id-card-alt"],
      'f47f',
      
      'M320 32H256V96h64V32zM256 0h64 32V32 96v32H320 256 224V96 32 0h32zm64 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm7.1 128l-21.3 64H176l32-96H368l32 96H366.3l-21.3-64H231.1zM32 64H192V96H32V480H544V96H384V64H544h32V96 480v32H544 32 0V480 96 64H32z'
      
    ]
  };

  
    var faIdCardAlt = faIdCardClip;
  

  
  

  var faEarthAsia = {
    prefix: 'fasl',
    iconName: 'earth-asia',
    icon: [
      512,
      512,
      [127759,"globe-asia"],
      'f57e',
      
      'M361.1 453.9l-2.9-5.9H304 288V432 368v-6.6l4.7-4.7 64-64 4.7-4.7H368h64 16v16 16h22.7c6-20.3 9.3-41.8 9.3-64c0-107.2-75.4-196.9-176-218.8V96v6.6l-4.7 4.7L272 134.6V208v16H256 224v80 16H208 144h-6.6l-4.7-4.7L105.4 288H34.3C49.8 396.6 143.2 480 256 480c38 0 73.7-9.4 105.1-26.1zM112 256h6.6l4.7 4.7L150.6 288H192V208 192h16 32V128v-6.6l4.7-4.7L272 89.4V32.6c-5.3-.4-10.6-.6-16-.6C132.3 32 32 132.3 32 256h80zM388.3 436.8c29.9-21.9 54.1-51 70.2-84.8H432 416V336 320H374.6L320 374.6V416h48 9.9l4.4 8.8 6 11.9zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192 96v32H128V352h64zM352 128v64H320V128h32zM256 256h32v64H256V256z'
      
    ]
  };

  
    var faGlobeAsia = faEarthAsia;
  

  
  

  var faHotel = {
    prefix: 'fasl',
    iconName: 'hotel',
    icon: [
      512,
      512,
      [127976],
      'f594',
      
      'M512 0H0V32H32V480H0v32H208h16 64 16H512V480H480V32h32V0zM272 480H240V416h32v64zm32-80V384H288 224 208v16 80H64V32H448V480H304V400zM320 64V80v64 16h16 64 16V144 80 64H400 336 320zm32 32h32v32H352V96zM224 64H208V80v64 16h16 64 16V144 80 64H288 224zm16 64V96h32v32H240zm-32 64v16 64 16h16 64 16V272 208 192H288 224 208zm32 32h32v32H240V224zm96-32H320v16 64 16h16 64 16V272 208 192H400 336zm16 64V224h32v32H352zM96 64V80v64 16h16 64 16V144 80 64H176 112 96zm32 32h32v32H128V96zm-16 96H96v16 64 16h16 64 16V272 208 192H176 112zm16 64V224h32v32H128zm68.4 122.7C211 362.3 232.3 352 256 352s45 10.3 59.6 26.7l23.8-21.3C319 334.4 289.2 320 256 320s-63 14.4-83.5 37.3l23.8 21.3z'
      
    ]
  };

  

  
  

  var fa9 = {
    prefix: 'fasl',
    iconName: '9',
    icon: [
      320,
      512,
      [],
      '39',
      
      'M119.2 480L278.8 300.5c25.3-28.4 39.8-64.7 41.1-102.6c.1-2 .1-3.9 .1-5.9c0-88.4-71.6-160-160-160S0 103.6 0 192s71.6 160 160 160c11.4 0 22.5-1.2 33.2-3.5L76.4 480h42.8zM160 64c70.7 0 128 57.3 128 128c0 1 0 2 0 3.1C286.3 264.3 229.7 320 160 320C89.3 320 32 262.7 32 192S89.3 64 160 64z'
      
    ]
  };

  

  
  

  var faAlbumCollection = {
    prefix: 'fasl',
    iconName: 'album-collection',
    icon: [
      512,
      512,
      [],
      'f8a0',
      
      'M32 0V32H48 464h16V0H464 48 32zM16 64V96H32 480h16V64H480 32 16zm19.5 96h441L443.2 480H68.8L35.5 160zM40 512H472l36.7-352 3.3-32H479.8 32.2 0l3.3 32L40 512zm216-96c-77.7 0-128-49.3-128-96s50.3-96 128-96s128 49.3 128 96s-50.3 96-128 96zm0 32c88.4 0 160-57.3 160-128s-71.6-128-160-128s-160 57.3-160 128s71.6 128 160 128zm0-104c13.3 0 24-9 24-20s-10.7-20-24-20s-24 9-24 20s10.7 20 24 20z'
      
    ]
  };

  

  
  

  var faGifts = {
    prefix: 'fasl',
    iconName: 'gifts',
    icon: [
      640,
      512,
      [],
      'f79c',
      
      'M192.9 29.8l5.8-14.9L168.8 3.3l-5.8 14.9L144.5 66.4 127 18.5l-5.5-15L91.5 14.4l5.5 15 15.9 43.8L64.6 42.5 51.1 33.9l-17.2 27 13.5 8.6L89.1 96H32 0v32V480v32H32 192V480H32V128H256v16.6c8.2-12.9 19.1-23.9 32-32.2V96H256 198.9l41.6-26.5 13.5-8.6-17.2-27-13.5 8.6L176.5 72.4l16.5-42.6zM361.8 172.6L401.4 224H392 336c-17.7 0-32-14.3-32-32c0-17.6 14.4-32 32.2-32c10 0 19.6 4.7 25.6 12.6zM272 192c0 11.7 3.1 22.6 8.6 32H256 224v32V480v32h32H608h32V480 256 224H608 583.4c5.4-9.4 8.6-20.3 8.6-32c0-35.4-28.9-64-64.2-64c-19.9 0-38.8 9.2-51 25.1L432 211.4l-44.8-58.3c-12.2-15.8-31.1-25.1-51-25.1c-35.3 0-64.2 28.6-64.2 64zm-16 64h80 56 24v96H256V256zm0 224V384H416v96H256zm352 0H448V384H608v96zm0-224v96H448V256h24 56 80zM472 224h-9.4l39.6-51.4c6.1-7.9 15.6-12.6 25.6-12.6c17.7 0 32.2 14.4 32.2 32c0 17.7-14.3 32-32 32H472z'
      
    ]
  };

  

  
  

  var faCircle4 = {
    prefix: 'fasl',
    iconName: 'circle-4',
    icon: [
      512,
      512,
      [],
      'e0f1',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM145.1 298.1L136.4 320H160 288v48 16h32V368 320h16 16V288H336 320V208 192H288v16 80H183.6l63.2-158.1 .8-1.9H213.2l-68 170.1z'
      
    ]
  };

  

  
  

  var faCircleXmark = {
    prefix: 'fasl',
    iconName: 'circle-xmark',
    icon: [
      512,
      512,
      [61532,"times-circle","xmark-circle"],
      'f057',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM191.4 168.8l-22.6 22.6 11.3 11.3L233.4 256l-53.3 53.3-11.3 11.3 22.6 22.6 11.3-11.3L256 278.6l53.3 53.3 11.3 11.3 22.6-22.6-11.3-11.3L278.6 256l53.3-53.3 11.3-11.3-22.6-22.6-11.3 11.3L256 233.4l-53.3-53.3-11.3-11.3z'
      
    ]
  };

  
    var faTimesCircle = faCircleXmark;
  
    var faXmarkCircle = faCircleXmark;
  

  
  

  var faCalendarMinus = {
    prefix: 'fasl',
    iconName: 'calendar-minus',
    icon: [
      448,
      512,
      [],
      'f272',
      
      'M128 16V0H96V16 64H32 0V96v64 32V480v32H32 416h32V480 192 160 96 64H416 352V16 0H320V16 64H128V16zM32 192H416V480H32V192zm0-96H416v64H32V96zM304 352h16V320H304 144 128v32h16H304z'
      
    ]
  };

  

  
  

  var faBandage = {
    prefix: 'fasl',
    iconName: 'bandage',
    icon: [
      640,
      512,
      [129657,"band-aid"],
      'f462',
      
      'M480 128V384H608V128H480zm-32 0H192V384H448V128zM160 384V128H32V384H160zm0-288h32H448h32H608h32v32V384v32H608 480 448 192 160 32 0V384 128 96H32 160zm112 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-72 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faBandAid = faBandage;
  

  
  

  var faClapperboardPlay = {
    prefix: 'fasl',
    iconName: 'clapperboard-play',
    icon: [
      512,
      512,
      [],
      'e132',
      
      'M480 192H32V448H480V192zm0-32V64h-1.4l-96 96H480zm-249.4 0H337.4l96-96H326.6l-96 96zm-45.3 0l96-96H174.6l-96 96H185.4zM32 64v96h1.4l96-96H32zm480 96v16 16V448v32H480 32 0V448 192 176 160 64 32H32 480h32V64v96zM216.1 226.2l136 80L375.6 320l-23.4 13.8-136 80L192 428V400 240 212l24.1 14.2zM312.4 320L224 268V372l88.4-52z'
      
    ]
  };

  

  
  

  var faSensorCloud = {
    prefix: 'fasl',
    iconName: 'sensor-cloud',
    icon: [
      640,
      512,
      ["sensor-smoke"],
      'e02c',
      
      'M32 64H416V225c11.2 1.4 21.9 4.2 32 8.3V64 32H416 32 0V64 448v32H32 224V448H32V64zm96 80V128H96v16V272v16h32V272 144zm64 0V128H160v16V272v16h32V272 144zM336 352c0-35.3 28.7-64 64-64c24.4 0 45.7 13.7 56.5 33.9l10.7 20 15.3-16.7C489.8 317 500.3 312 512 312c22.1 0 40 17.9 40 40c0 .4 0 .9 0 1.3l-.4 13.2 12.9 2.9c24.9 5.7 43.6 28 43.6 54.6v56H552 528 368 344 288V424c0-24.4 15.6-45.2 37.4-52.8l11.3-4-.6-11.9c-.1-1.1-.1-2.2-.1-3.3zm64-96c-50.8 0-92.4 39.5-95.8 89.5C275.6 360 256 389.7 256 424v72 16h16 72 24H528h24 72 16V496 424c0-37.6-23.6-69.7-56.7-82.3c-5-34.9-35-61.7-71.3-61.7c-13.9 0-27 4-38 10.8c-17.6-21.3-44.2-34.8-74-34.8z'
      
    ]
  };

  
    var faSensorSmoke = faSensorCloud;
  

  
  

  var faBookUser = {
    prefix: 'fasl',
    iconName: 'book-user',
    icon: [
      448,
      512,
      [],
      'f7e7',
      
      'M0 64C0 28.7 28.7 0 64 0H432h16V16 400v16H432 416v64h16 16v32H432 64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H416V32H64C46.3 32 32 46.3 32 64l0 328.6zM240 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM161.7 336H128l32-96H320l32 96H318.3l-21.3-64H183.1l-21.3 64z'
      
    ]
  };

  

  
  

  var faWatchSmart = {
    prefix: 'fasl',
    iconName: 'watch-smart',
    icon: [
      384,
      512,
      [],
      'e2cc',
      
      'M80 0H64V16 64H32 0V96 416v32H32 64l0 48v16H80l224 0h16V496 448h32 32V416 96 64H352 320V16 0H304 80zM96 480l0-32H288v32L96 480zM288 64H96V32H288V64zM32 96H352V416H32V96zm176 80V160H176v16 80 8.6l7.1 4.8 48 32 13.3 8.9 17.8-26.6-13.3-8.9L208 247.4V176z'
      
    ]
  };

  

  
  

  var faBrain = {
    prefix: 'fasl',
    iconName: 'brain',
    icon: [
      512,
      512,
      [129504],
      'f5dc',
      
      'M144.2 75.4l-1.1 11.3-11 2.8C111.4 94.7 96 113.6 96 136c0 3.1 .3 6.2 .9 9.2l2.5 13.2-12.5 4.8C68.8 170 56 187.6 56 208c0 5.2 .8 10.3 2.4 15l3.3 10-7.9 7C40.4 251.7 32 268.9 32 288c0 22.9 12 43 30.2 54.3l11.6 7.2-5.3 12.6C65.6 368.8 64 376.2 64 384c0 30.9 25.1 56 56 56c3.3 0 6.5-.3 9.5-.8l12.9-2.2 4.7 12.2c6.9 18 24.4 30.8 44.8 30.8h48V432 80 32H192c-25 0-45.5 19.1-47.8 43.4zM240 512H192c-29.6 0-55.5-16.1-69.3-40c-.9 0-1.8 0-2.7 0c-48.6 0-88-39.4-88-88c0-7.6 1-15 2.8-22C13.6 344.4 0 317.8 0 288c0-25.1 9.6-48 25.4-65c-.9-4.9-1.4-9.9-1.4-15c0-29.6 16.1-55.5 40-69.3c0-.9 0-1.8 0-2.7c0-33.6 20.7-62.4 50.1-74.2C122.3 26.4 154.1 0 192 0h48 16 16 48c37.9 0 69.7 26.4 77.9 61.8C427.3 73.6 448 102.4 448 136c0 .9 0 1.8 0 2.7c23.9 13.8 40 39.7 40 69.3c0 5.1-.5 10.1-1.4 15c15.8 17.1 25.4 40 25.4 65c0 29.8-13.6 56.4-34.8 74c1.8 7.1 2.8 14.4 2.8 22c0 48.6-39.4 88-88 88c-.9 0-1.8 0-2.7 0c-13.8 23.9-39.7 40-69.3 40H272 256 240zm32-32h48c20.4 0 37.9-12.8 44.8-30.8l4.7-12.2 12.9 2.2c3.1 .5 6.3 .8 9.5 .8c30.9 0 56-25.1 56-56c0-7.8-1.6-15.2-4.4-21.8l-5.3-12.6 11.6-7.2C468 331 480 310.9 480 288c0-19.1-8.4-36.3-21.7-48.1l-7.9-7 3.3-10c1.5-4.7 2.4-9.7 2.4-15c0-20.4-12.8-38-30.9-44.9l-12.5-4.8 2.5-13.2c.6-3 .9-6 .9-9.2c0-22.4-15.4-41.3-36.2-46.5l-11-2.8-1.1-11.3C365.5 51.1 345 32 320 32H272V80 432v48z'
      
    ]
  };

  

  
  

  var faPompebled = {
    prefix: 'fasl',
    iconName: 'pompebled',
    icon: [
      512,
      512,
      [],
      'e43d',
      
      'M257.2 22.7c49.9 34.5 57.2 107.2 27.9 170.8l5.3 3.8c47.9-49.7 116.9-68.7 166.4-33.1c64 45.3 72.1 140.1 25.2 209.7l0 0c-83.4 123.2-257.1 185-380.5 96.5l9.3-13-9.3 13c0 0 0 0 0 0C-21.9 382.3-27.4 196.3 56.1 73.1c0 0 0 0 0 0L69.3 82 56.1 73c0 0 0 0 0 0C103.1 2.9 192.9-22.8 257.2 22.7zM238.8 48.8C192.6 16.1 122.2 31.9 82.6 90.9l0 .1C5.7 204.5 15 369.3 120.1 444.4l0 0C224.2 519 378.6 469.5 455.5 356c39.6-58.7 29.4-132.7-17.2-165.7l-.1-.1c-33.5-24.1-90.7-12.7-133.1 38.7l-9.5 11.6-12.2-8.8-28.1-20.3-11.5-8.3 6.8-12.4C283.1 131.8 273.2 72.5 239 49l-.2-.1 0 0z'
      
    ]
  };

  

  
  

  var faBowlingBall = {
    prefix: 'fasl',
    iconName: 'bowling-ball',
    icon: [
      512,
      512,
      [],
      'f436',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm240-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-120-8a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM240 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faUnicorn = {
    prefix: 'fasl',
    iconName: 'unicorn',
    icon: [
      640,
      512,
      [129412],
      'f727',
      
      'M448 32h24 8 13.9l39.2 39.2 9.9 104.4-42.4 26.5-23.4-35.1-4.7-7.1H464 432 416v16 64c0 24-10.4 45.1-26.7 59.6l-5.3 4.8v7.2V480H336V334.7 321.2l-13.3-2.3c-1.4-.2-2.8-.5-4.3-.8L203.5 292.2 184 287.8v20V312v24 4.9l-1.9 4.5-18.5 43.1-2.2 5.2 1.5 5.4L185.4 480H135.5l-22.7-81.6-2.3-8.1 3.3-7.8 20.8-48.5 1.3-3v-3.3V320v-3.2l-1.2-3L99.9 230.2C97.3 224 96 217.4 96 210.7c0-28 22.7-50.7 50.7-50.7H192h64 64 16V144c0-61.9 50.1-112 112-112zM559.9 52.7L539.2 32H544h16V0H544 507.2h-6.6H480h-8H448C373.9 0 312.8 56 304.9 128H256 192 146.7c-33.5 0-62.3 19.9-75.3 48.5C31.3 180.8 0 214.7 0 256v48 16H32V304 256c0-20.9 13.4-38.7 32-45.3c0 10.9 2.2 21.7 6.4 31.7L104 323.2v1.3L84.5 369.9 79 382.9 76.8 388l1.5 5.4L82 407 108 500.3l3.3 11.7h12.2 83 21.1l-5.6-20.3L195.2 396l16.2-37.9 3.2-7.5 1.3-3v-3.3V336v-8.2l88 19.8V496v16h16 80 16V496 318.4c19.6-20 32-47.5 32-78.4V192h7.4l27.3 40.9 8.6 12.9 13.2-8.2 64-40 8.4-5.2-.9-9.8-7.5-78.6L640 80V64H564.6l-.1-1.5-.5-5.7-4.1-4.1zM480 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faDice = {
    prefix: 'fasl',
    iconName: 'dice',
    icon: [
      640,
      512,
      [127922],
      'f522',
      
      'M0 224l22.6 22.6L201.4 425.4 224 448l22.6-22.6L425.4 246.6 448 224l-22.6-22.6L246.6 22.6 224 0 201.4 22.6 22.6 201.4 0 224zM224 402.7L45.3 224 224 45.3 402.7 224 224 402.7zM224 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-72-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm96 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm96-96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-96-96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 352v32h32H608h32V480 224 192H608 461.3l9.4 9.4L493.3 224H608V480H352V365.3l-32 32V480zM480 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faSquareEnvelope = {
    prefix: 'fasl',
    iconName: 'square-envelope',
    icon: [
      448,
      512,
      ["envelope-square"],
      'f199',
      
      'M416 64V448H32V64H416zM32 32H0V64 448v32H32 416h32V448 64 32H416 32zM352 160v28.9L224 255.5 96 188.9V160H352zm0 65V352H96V225l120.6 62.7 7.4 3.8 7.4-3.8L352 225zM96 128H64v32V352v32H96 352h32V352 160 128H352 96z'
      
    ]
  };

  
    var faEnvelopeSquare = faSquareEnvelope;
  

  
  

  var faPersonWalkingArrowRight = {
    prefix: 'fasl',
    iconName: 'person-walking-arrow-right',
    icon: [
      640,
      512,
      [],
      'e552',
      
      'M200 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 200 0a56 56 0 1 0 0 112zM76.7 194.7l46.9-31.3L95 255.2c-5.7 18.2 0 38.1 14.4 50.6L210 393l30.7 102.7 4.6 15.3 30.7-9.2-4.6-15.3-32-107.2L238 375l-3.5-3L187.3 331l38.4-111 15 48.7 1.7 5.4 4.7 3.2 48 32 17.8-26.6-43.3-28.8-30.3-98.6-2.6-8.4-8.5-2.3-88-24-7-1.9-6.1 4-72 48-3.9 2.6-1.9 4.2-32 72-6.5 14.6 29.2 13 6.5-14.6 30.1-67.8zm48.8 70l33.1-106 49.7 13.6L161.2 308.4l-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zM66.9 422.5L12.7 476.7 1.4 488 24 510.6l11.3-11.3 56-56c1.2-1.2 2.2-2.6 3-4.2l36.3-72.6-25-21.6L66.9 422.5zM530.3 163.8l-12.2-10.3-20.7 24.4 12.2 10.3L570.8 240H384 368v32h16H570.8l-61.1 51.8-12.2 10.3 20.7 24.4 12.2-10.3 94.4-80L639.1 256l-14.4-12.2-94.4-80z'
      
    ]
  };

  

  
  

  var faRectangleBarcode = {
    prefix: 'fasl',
    iconName: 'rectangle-barcode',
    icon: [
      576,
      512,
      ["barcode-alt"],
      'f463',
      
      'M544 64V448H32V64H544zM32 32H0V64 448v32H32 544h32V448 64 32H544 32zm64 96V384h32V128H96zm320 0H384V384h32V128zm32 0V384h32V128H448zm-256 0H160V384h32V128zm32 0V384h32V128H224zm112 0H304V384h32V128z'
      
    ]
  };

  
    var faBarcodeAlt = faRectangleBarcode;
  

  
  

  var faSquareS = {
    prefix: 'fasl',
    iconName: 'square-s',
    icon: [
      448,
      512,
      [],
      'e27d',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM160.7 190c-1.5 8.5-.5 14.1 1.5 18.2c2 4.2 5.7 8.3 11.7 12.3c12.8 8.4 31.8 13.9 54.4 20.1l1.5 .4c20.7 5.7 44.5 12.3 62 23.8c9.3 6.1 17.7 14.3 23 25.2c5.3 11.1 6.6 23.8 4 37.7c-4.5 24.3-21.6 40.2-43.1 48.5c-21.1 8.1-47.2 9.5-74.1 5.6l-.1 0 0 0c-17-2.6-46.2-11.2-61.2-15.9l-15.3-4.8 9.6-30.5 15.3 4.8c15.2 4.8 42.2 12.6 56.4 14.8c23.4 3.4 43.6 1.8 57.9-3.8c13.9-5.4 21.2-13.8 23.1-24.4c1.5-8.5 .5-14.1-1.5-18.2c-2-4.2-5.7-8.3-11.7-12.3c-12.8-8.4-31.8-13.9-54.4-20.1l-1.5-.4 0 0c-20.7-5.7-44.5-12.3-62-23.8c-9.3-6.1-17.7-14.3-23-25.2c-5.3-11.1-6.6-23.8-4-37.7c4.5-24.3 21.6-40.2 43.1-48.5c21.1-8.1 47.2-9.5 74.1-5.6c8.4 1.2 25.9 5 34.1 7l15.5 3.9-7.8 31-15.5-3.9c-7.6-1.9-24-5.4-31-6.4c-23.4-3.5-43.6-1.8-57.9 3.8c-13.9 5.4-21.2 13.8-23.1 24.4z'
      
    ]
  };

  

  
  

  var faTurnDown = {
    prefix: 'fasl',
    iconName: 'turn-down',
    icon: [
      384,
      512,
      [10549,"level-down-alt"],
      'f3be',
      
      'M160 352V320l0-192V96H128 32l0-64H224l0 288v32h32 50.7L192 466.7 77.3 352H128h32zM64 320H32l0 32L169.4 489.4 192 512l22.6-22.6L352 352V320H320 288 256l0-32V32 0H224 32 0L0 32 0 96l0 32H32 96h32v32l0 128v32H96 64z'
      
    ]
  };

  
    var faLevelDownAlt = faTurnDown;
  

  
  

  var faWheelchairMove = {
    prefix: 'fasl',
    iconName: 'wheelchair-move',
    icon: [
      448,
      512,
      ["wheelchair-alt"],
      'e2ce',
      
      'M368 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 368 0zM172.2 61.2l9.8 4 176 72 22.3 9.1-17 17-83.1 83.1c6.9 7.9 13.1 16.4 18.4 25.6H424h19.9l-4.3 19.5-32 144-3.5 15.6-31.2-6.9 3.5-15.6L404.1 304H312.7c4.8 15.2 7.3 31.3 7.3 48c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c5.6 0 11.1 .3 16.5 .8l67.7-67.7L179.8 98.8l-56.5 56.5L112 166.6 89.4 144l11.3-11.3 64-64 7.5-7.5zm151.5 96.5l-47.4-19.4-62.8 62.8c15.7 5.6 30.3 13.5 43.3 23.4l66.9-66.9zM160 480a128 128 0 1 0 0-256 128 128 0 1 0 0 256z'
      
    ]
  };

  
    var faWheelchairAlt = faWheelchairMove;
  

  
  

  var faFaceGrimace = {
    prefix: 'fasl',
    iconName: 'face-grimace',
    icon: [
      512,
      512,
      [128556,"grimace"],
      'f57f',
      
      'M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM144 320v48h32V320H144zm64 0v48h32V320H208zm96 48V320H272v48h32zm32 0h32V320H336v48zM144 288H368h32v32 48 32H368 144 112V368 320 288h32zm8.4-80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faGrimace = faFaceGrimace;
  

  
  

  var faChessPawnPiece = {
    prefix: 'fasl',
    iconName: 'chess-pawn-piece',
    icon: [
      256,
      512,
      ["chess-pawn-alt"],
      'f444',
      
      'M176 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm16 80h-6.1l10.7 96H164.3l-10.7-96H128 102.3L91.7 352H59.5l10.7-96H64 48V224H64c-10-13.4-16-30-16-48c0-44.2 35.8-80 80-80s80 35.8 80 80c0 18-6 34.6-16 48h16v32H192zM32 480H224V463.3L191.2 416H64.8L32 463.3V480zM0 480V453.3L48 384H208l48 69.3V480v32H224 32 0V480z'
      
    ]
  };

  
    var faChessPawnAlt = faChessPawnPiece;
  

  
  

  var faArrowsUpDown = {
    prefix: 'fasl',
    iconName: 'arrows-up-down',
    icon: [
      320,
      512,
      ["arrows-v"],
      'f07d',
      
      'M171.3 12.7L160.4 1.8 149.1 12.2l-104 96L33.4 119.1l21.7 23.5 11.8-10.9L144 60.5V449.4L75.3 380.7 64 369.4 41.4 392l11.3 11.3 96 96L160 510.6l11.3-11.3 96-96L278.6 392 256 369.4l-11.3 11.3L176 449.4V62.6l68.7 68.7L256 142.6 278.6 120l-11.3-11.3-96-96z'
      
    ]
  };

  
    var faArrowsV = faArrowsUpDown;
  

  
  

  var faWaterLadder = {
    prefix: 'fasl',
    iconName: 'water-ladder',
    icon: [
      576,
      512,
      ["ladder-water","swimming-pool"],
      'f5c5',
      
      'M128 112c0-44.2 35.8-80 80-80s80 35.8 80 80v32 16H256V144 112c0-26.5-21.5-48-48-48s-48 21.5-48 48V224.2H384V112c0-44.2 35.8-80 80-80s80 35.8 80 80v32 16H512V144 112c0-26.5-21.5-48-48-48s-48 21.5-48 48V240.2 376.3c-10.7 4-21.8 6.7-32 6.7V256.2H160V376.3c-3-1.1-5.9-2.3-8.7-3.6c-8.1-3.7-15.2-8.1-23.3-13.7V240.2 112zm64 336c20.9 0 41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C342.3 438.1 363.1 448 384 448s41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C534.4 438.1 555.1 448 576 448v32c-30.3 0-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.9 9.9-19.8 15.3C441.5 465.9 414.3 480 384 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 465.9 222.3 480 192 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.8-19.8 15.3C57.6 465.9 30.3 480 0 480V448c20.9 0 41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.7 23.2 24.3 37.8 34.2C150.3 438.1 171.1 448 192 448z'
      
    ]
  };

  
    var faLadderWater = faWaterLadder;
  
    var faSwimmingPool = faWaterLadder;
  

  
  

  var faCalendarDay = {
    prefix: 'fasl',
    iconName: 'calendar-day',
    icon: [
      448,
      512,
      [],
      'f783',
      
      'M128 16V0H96V16 64H32 0V96v64 32V480v32H32 416h32V480 192 160 96 64H416 352V16 0H320V16 64H128V16zM32 192H416V480H32V192zm0-96H416v64H32V96zM96 256h96v96H96V256zM64 224v32 96 32H96h96 32V352 256 224H192 96 64z'
      
    ]
  };

  

  
  

  var faBellRing = {
    prefix: 'fasl',
    iconName: 'bell-ring',
    icon: [
      512,
      512,
      [],
      'e62c',
      
      'M240 0h32V32.8c80.9 8 144 76.2 144 159.2v97.4l59.3 59.3 4.7 4.7V360v40 16H464 48 32V400 360v-6.6l4.7-4.7L96 289.4V192c0-83 63.1-151.2 144-159.2V0zm16 64c-70.7 0-128 57.3-128 128V296v6.6l-4.7 4.7L64 366.6V384H448V366.6l-59.3-59.3-4.7-4.7V296 192c0-70.7-57.3-128-128-128zM192 448h32c0 17.7 14.3 32 32 32s32-14.3 32-32h32c0 35.3-28.7 64-64 64s-64-28.7-64-64zM117.3 44.3C74.9 79.5 48 132.6 48 192H16C16 122.7 47.5 60.8 96.9 19.7l20.5 24.6zM467.1 192c0-59.4-26.9-112.5-69.3-147.7l20.5-24.6c49.4 41.1 80.9 103 80.9 172.3h-32z'
      
    ]
  };

  

  
  

  var faAudioDescriptionSlash = {
    prefix: 'fasl',
    iconName: 'audio-description-slash',
    icon: [
      640,
      512,
      [],
      'e0a8',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM608 64V32H576 139.6l40.5 32H576V376.6l32 25.3V64zM125.4 352h35.2l22.1-48H184h80 1.3l22.1 48h35.2l-9-19.5L237 272H197.5L208 249.1l-25.8-20.4L125.4 352zM32 110.2V448v32H64 500.4l-40.5-32H64V135.4L32 110.2zM336 352h2.3l-2.3-1.8V352zm176-96c0-53-43-96-96-96H352 336v16 11.1l32 25.3V192h48c35.3 0 64 28.7 64 64c0 13.4-4.1 25.8-11.1 36l25.2 19.9c11.3-15.7 17.9-35 17.9-55.9z'
      
    ]
  };

  

  
  

  var faFileSpreadsheet = {
    prefix: 'fasl',
    iconName: 'file-spreadsheet',
    icon: [
      384,
      512,
      [],
      'f65b',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM176 256v32H96V256h80zM96 320h80v32H96V320zm112 0h80v32H208V320zM96 384h80v32H96V384zm112 0h80v32H208V384zm-16 64h16 80 32V416 384 368 352 320 304 288 256 224H288 208 192 176 96 64v32 32 16 16 32 16 16 32 32H96h80 16zm16-160V256h80v32H208z'
      
    ]
  };

  

  
  

  var faWheat = {
    prefix: 'fasl',
    iconName: 'wheat',
    icon: [
      512,
      512,
      [],
      'f72d',
      
      'M433.1 36c-28.7 1.4-51.7 24.4-53.1 53.1l-2.3 45.2 45.2-2.3c28.7-1.4 51.7-24.4 53.1-53.1l2.3-45.2L433.1 36zM431.5 4l48.4-2.4L512 0l-1.6 32.1L508 80.5c-2.3 45.1-38.3 81.2-83.5 83.5l-16.9 .8c23.1 5 45.2 16.6 63.2 34.6L482 210.7l22.6 22.6-22.6 22.6-22.6 22.6c-17.4 17.4-39.8 26.7-62.6 28l17.3 17.3-22.6 22.6L369 369c-17.4 17.4-39.8 26.7-62.5 28l17.3 17.3-22.6 22.6-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0l-33.9-33.9 0 0L27.3 507.1 4.7 484.5 86.2 403 52.3 369.1c-37.5-37.5-37.5-98.3 0-135.8l22.6-22.6 22.6-22.6 17.3 17.3c1.3-22.8 10.6-45.2 28-62.6l22.6-22.6L188 97.6l17.3 17.3c1.3-22.8 10.6-45.2 28-62.6l22.6-22.6L278.5 7.1l22.6 22.6L312.4 41c18.3 18.3 29.9 40.7 34.8 64.2l.9-17.7C350.3 42.4 386.4 6.3 431.5 4zm27.9 229.3L448.1 222c-37.5-37.5-98.2-37.5-135.7 0l33.9 33.9c25 25 65.5 25 90.5 0l22.6-22.6zm-169.7-34l1.5-1.5c36-37.6 35.5-97.3-1.5-134.3L278.5 52.3 255.9 74.9c-25 25-25 65.5 0 90.5l33.9 33.9zm-90.5 90.5l1.3-1.3c36.2-37.6 35.8-97.4-1.3-134.5L188 142.8l-22.6 22.6c-25 25-25 65.5 0 90.5l33.9 33.9zm-90.5-45.2L97.5 233.3 74.9 255.9c-25 25-25 65.5 0 90.5l33.9 33.9 .8-.8c36.7-37.6 36.4-97.7-.8-135zM278.5 414.3L267.2 403c-37.5-37.5-98.2-37.5-135.7 0l33.9 33.9c25 25 65.5 25 90.5 0l22.6-22.6zm90.5-90.5l-11.3-11.3c-37.5-37.5-98.2-37.5-135.7 0l33.9 33.9c25 25 65.5 25 90.5 0l22.6-22.6z'
      
    ]
  };

  

  
  

  var faTurnLeft = {
    prefix: 'fasl',
    iconName: 'turn-left',
    icon: [
      512,
      512,
      [],
      'e636',
      
      'M160 256l32 0 192 0 32 0 0 32 0 160 64 0 0-256-288 0-32 0 0-32 0-50.7L45.3 224 160 338.7l0-50.7 0-32zm32 96l0 32-32 0L22.6 246.6 0 224l22.6-22.6L160 64l32 0 0 32 0 32 0 32 32 0 256 0 32 0 0 32 0 256 0 32-32 0-64 0-32 0 0-32 0-128 0-32-32 0-128 0-32 0 0 32 0 32z'
      
    ]
  };

  

  
  

  var faCircleCaretRight = {
    prefix: 'fasl',
    iconName: 'circle-caret-right',
    icon: [
      512,
      512,
      ["caret-circle-right"],
      'f330',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM192 128l0 32 0 192 0 32 32 0 8 0L352 256 232 128l-8 0-32 0zM308.1 256L224 345.7l0-179.5L308.1 256z'
      
    ]
  };

  
    var faCaretCircleRight = faCircleCaretRight;
  

  
  

  var faHands = {
    prefix: 'fasl',
    iconName: 'hands',
    icon: [
      576,
      512,
      ["sign-language","signing"],
      'f2a7',
      
      'M576 240.2l-.9-123.6-96 .7 .1 18.8L419.1 3.2 360.8 29.6 347.6 .5 260.1 40.1l13.2 29.1L215 95.6l2.7 6.1 9.5 4.2 34.5 15.3-4.4-9.7 29.1-13.2 19.2 42.4 19.9 8.8c8.8 3.9 17.3 8.4 25.4 13.5L302.5 56l29.2-13.2 66 145.7 29.1-13.2L374 58.8l29.1-13.2 81.4 179.8 27.3-2.8-.5-73.5 32-.2 .6 91.6c.4 56.1-32.3 107.3-83.4 130.4c-5.4 2.4-10.8 4.5-16.3 6.2c-2.4 12.3-5.8 24.1-10.2 35.5c13.4-2.5 26.7-6.7 39.7-12.6c62.7-28.4 102.7-91 102.2-159.8zM214.3 134.5L199.6 128l-6.5 14.6-26 58.5-6.5 14.6 14.6 6.5 2.6 1.1H80 48 32v16 48H16 0v16 64 16H16 32v48 16l16 0 16 0v48 16H80h32H241.9c96.1 0 174.1-77.9 174.1-174.1c0-68.8-40.5-131.1-103.4-159.1l-69.1-30.7-29.2-13zM32 351.4v-32H48 64l16 0h96 16v-32H176 80 64v-32H80 253.2h8.1l8.7-26-10.3-4.6L217.5 206l-14.6-6.5 13-29.2 14.6 6.5 69.1 30.7c51.3 22.8 84.4 73.7 84.4 129.8c0 78.5-63.6 142.1-142.1 142.1H112 96v-32h16 64 16v-32H176 112l-16 0-16 0-16 0v-32H80h96 16v-32H176 80l-16 0H48 32z'
      
    ]
  };

  
    var faSignLanguage = faHands;
  
    var faSigning = faHands;
  

  
  

  var faLifeRing = {
    prefix: 'fasl',
    iconName: 'life-ring',
    icon: [
      512,
      512,
      [],
      'f1cd',
      
      'M402.7 425.3C363.4 459.4 312.1 480 256 480s-107.4-20.6-146.7-54.7l91.1-91C216.1 345.4 235.3 352 256 352s39.9-6.6 55.6-17.7l91.1 91zm22.6-22.6l-91-91.1C345.4 295.9 352 276.7 352 256s-6.6-39.9-17.7-55.6l91-91.1C459.4 148.6 480 199.9 480 256s-20.6 107.4-54.7 146.7zM448 425.4c39.8-45.1 64-104.4 64-169.4s-24.2-124.2-64-169.4l11.3-11.3L470.6 64 448 41.4 436.7 52.7 425.4 64C380.2 24.2 320.9 0 256 0S131.8 24.2 86.6 64L75.3 52.7 64 41.4 41.4 64 52.7 75.3 64 86.6C24.2 131.8 0 191.1 0 256s24.2 124.2 64 169.4L52.7 436.7 41.4 448 64 470.6l11.3-11.3L86.6 448c45.1 39.8 104.4 64 169.4 64s124.2-24.2 169.4-64l11.3 11.3L448 470.6 470.6 448l-11.3-11.3L448 425.4zM402.7 86.7l-91.1 91.1C295.9 166.6 276.7 160 256 160s-39.9 6.6-55.6 17.7L109.3 86.7C148.6 52.6 199.9 32 256 32s107.4 20.6 146.7 54.7zM177.7 311.6L86.7 402.7C52.6 363.4 32 312.1 32 256s20.6-107.4 54.7-146.7l91.1 91.1C166.6 216.1 160 235.3 160 256s6.6 39.9 17.7 55.6zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faMoneyBill1Wave = {
    prefix: 'fasl',
    iconName: 'money-bill-1-wave',
    icon: [
      576,
      512,
      ["money-bill-wave-alt"],
      'f53b',
      
      'M32 431.2V376c35.3 0 64 28.7 64 64v6.8c-21.6-2.1-42.8-7-64-15.6zm96 8.8c0-53-43-96-96-96V216c52.9 0 95.8-42.7 96-95.6c57.2-.9 112.6-15.1 163.9-28.1l4-1C350.1 77.4 400 65.1 448 64.1V72c0 53 43 96 96 96V296c-52.9 0-95.8 42.7-96 95.6c-57.2 .9-112.6 15.1-163.9 28.1l-4 1C225.9 434.6 176 446.9 128 447.9V440zM544 328v76.4c-21.5-6.6-42.8-10.3-64-11.9V392c0-35.3 28.7-64 64-64zM32 107.6c21.5 6.6 42.8 10.3 64 11.9v.5c0 35.3-28.7 64-64 64V107.6zM480 65.2c21.6 2.1 42.8 6.9 64 15.6V136c-35.3 0-64-28.7-64-64V65.2zM32 73.9C21.3 70.2 10.7 65.7 0 60.3V95.7 451.7c96 48.9 192 24.5 288 0c85.3-21.8 170.7-43.5 256-13.7c10.7 3.7 21.3 8.3 32 13.7V416.3 60.3c-96-48.9-192-24.5-288 0C202.7 82 117.3 103.8 32 73.9zM400 256c0-65-44.9-128-112-128s-112 63-112 128s44.9 128 112 128s112-63 112-128zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM272 192H256v32h16v64h-8H248v32h16 8 32 8 16V288H312h-8V208 192H288 272z'
      
    ]
  };

  
    var faMoneyBillWaveAlt = faMoneyBill1Wave;
  

  
  

  var faEngine = {
    prefix: 'fasl',
    iconName: 'engine',
    icon: [
      640,
      512,
      [],
      'e16e',
      
      'M416 96l-16 0-80 0v32h16 80l96 64V416v32H480 224l-51.2-64H128 96V352 272H88 32v80 16H0V352 160 144H32v16 80H88h8V160 128h32 32H288V96l-80 0H192V64h16H400h16V96zM304 160l-144 0H128V352h44.8 15.4l9.6 12 41.6 52H480V209.1L406.3 160H336l-32 0zm-88 72v48H168V232h48zm96 48H264V232h48v48zm48-48h48v48H360V232zm216-8V416h32V224H576zm-32-32h32 32 32v32V416v32H608 576 544V416 224 192z'
      
    ]
  };

  

  
  

  var faTire = {
    prefix: 'fasl',
    iconName: 'tire',
    icon: [
      512,
      512,
      [],
      'f631',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm319.9 4l61.8 20.1c1.5-7.8 2.3-15.9 2.3-24.2c0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6c0 1.4 0 2.7-.1 4zm-9.9 30.4c-8.6 13.5-22.1 23.5-38 27.6l0 65c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1zM240 383l0-65c-15.8-4.1-29.3-14.1-37.9-27.5l-61.9 20.1c18.3 38.8 55.5 66.9 99.8 72.4zM130.3 280.2L192.1 260c-.1-1.3-.1-2.7-.1-4c0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7C143.5 186.1 128 219.2 128 256c0 8.3 .8 16.3 2.3 24.2zm102.1-83.7c7.3-2.9 15.3-4.5 23.6-4.5s16.3 1.6 23.6 4.5l38.2-52.6C299.5 133.8 278.4 128 256 128s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320z'
      
    ]
  };

  

  
  

  var faScannerGun = {
    prefix: 'fasl',
    iconName: 'scanner-gun',
    icon: [
      576,
      512,
      ["scanner"],
      'f488',
      
      'M576 32H416V64H576V32zM124.1 435.9L42.9 388.1 115 256H225.3L124.1 435.9zM262 256h58 32V224 64 32H320 112C50.1 32 0 82.1 0 144c0 51.1 34.2 94.2 80.9 107.6L0 400l108.4 63.8L136 480l15.7-27.9L262 256zM416 96v32H576V96H416zm160 96H416v32H576V192zM416 256v32H576V256H416zm160 64H416v32H576V320zM416 448v32H576V448H416zM112 64H320V224H280 243.3 112c-44.2 0-80-35.8-80-80s35.8-80 80-80z'
      
    ]
  };

  
    var faScanner = faScannerGun;
  

  
  

  var faAlignRight = {
    prefix: 'fasl',
    iconName: 'align-right',
    icon: [
      448,
      512,
      [],
      'f038',
      
      'M432 48h16V80H432 176 160V48h16H432zm0 128h16v32H432 16 0V176H16 432zm16 128v32H432 176 160V304h16H432h16zM432 432h16v32H432 16 0V432H16 432z'
      
    ]
  };

  

  
  

  var faWindowFlip = {
    prefix: 'fasl',
    iconName: 'window-flip',
    icon: [
      512,
      512,
      ["window-alt"],
      'f40f',
      
      'M480 64V448H32V64H480zm32-32H480 32 0V64 448v32H32 480h32V448 64 32zM392 104v48h48V104H392zm-48 0H296v48h48V104zm-144 0v48h48V104H200z'
      
    ]
  };

  
    var faWindowAlt = faWindowFlip;
  

  
  

  var faInputText = {
    prefix: 'fasl',
    iconName: 'input-text',
    icon: [
      640,
      512,
      [],
      'e1bf',
      
      'M32 96V416H56 312 608V96H312 56 32zm89.3 256H86.7l2.5-6.1 72-176 4.1-9.9h21.5l4.1 9.9 72 176 2.5 6.1H230.7l-13.1-32.1c-.5 .1-1.1 .1-1.6 .1H136c-.5 0-1.1 0-1.6-.1L121.3 352zM288 352V336 320 256 192 176 160h16 8 48c30.9 0 56 25.1 56 56c0 12.1-3.8 23.3-10.4 32.5C421.5 258.4 432 276 432 296c0 30.9-25.1 56-56 56H312h-8H288zM0 64H32 608h32V96 416v32H608 32 0V416 96 64zM176 218.3L147.5 288h57.1L176 218.3zM360 272H320v48h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H360zm0-32c13.3 0 24-10.7 24-24s-10.7-24-24-24H320v48h40z'
      
    ]
  };

  

  
  

  var faHandHoldingBox = {
    prefix: 'fasl',
    iconName: 'hand-holding-box',
    icon: [
      576,
      512,
      [],
      'f47b',
      
      'M208 32v96 25.9l23.2-11.6L288 113.9l56.8 28.4L368 153.9V128 32h80V224H128V32h80zM224 0H128 96V32 224v32h32H448h32V224 32 0H448 352 224zm16 32h96v70.1L295.2 81.7 288 78.1l-7.2 3.6L240 102.1V32zM176 304h-4.8l-4 2.7L75.2 368H16 0v32H16 80h4.8l4-2.7 92-61.3H368v48H320 304 256 240v32h16 48 16 64 16 4.6H409l3.8-2.3 94-56L530 395 395.4 480H16 0v32H16 400h4.6l3.9-2.5 152-96L574 405l-8.4-13.5-40-64-8.3-13.3-13.5 8L400.2 384H400V320 304H384 176z'
      
    ]
  };

  

  
  

  var faDungeon = {
    prefix: 'fasl',
    iconName: 'dungeon',
    icon: [
      512,
      512,
      [],
      'f6d9',
      
      'M112 256H32c0-38.7 9.8-75 27-106.8l67 44.7c-9 18.8-14 39.9-14 62.1zm74.7-126.2c-16.9 9.3-31.8 21.9-43.7 37L76.3 122.3C97.3 94 124.9 70.9 156.8 55.1l29.9 74.7zm29.6-12.2L186.4 43c21.9-7.1 45.3-11 69.6-11s47.7 3.9 69.6 11l-29.8 74.5c-12.6-3.6-26-5.6-39.7-5.6s-27.1 1.9-39.7 5.6zm109.1 12.2l29.9-74.7c31.9 15.8 59.5 38.9 80.5 67.2L369 166.8c-11.9-15.1-26.8-27.7-43.7-37zM386 193.9l67-44.7c17.2 31.7 27 68.1 27 106.8H400c0-22.2-5-43.3-14-62.1zM480 288v80H400V288h80zM400 480V400h80v80H400zM112 288v80H32V288h80zM32 480V400h80v80H32zm112 0V256c0-61.9 50.1-112 112-112s112 50.1 112 112V480v32h32 80 32V480 256C512 114.6 397.4 0 256 0S0 114.6 0 256V480v32H32h80 32V480zM272 192V176H240v16V464v16h32V464 192zm-64 32V208H176v16V464v16h32V464 224zm128 0V208H304v16V464v16h32V464 224z'
      
    ]
  };

  

  
  

  var faRoadCircleExclamation = {
    prefix: 'fasl',
    iconName: 'road-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e565',
      
      'M184.1 64L74.4 448H339.2c5.9 11.4 12.9 22.2 21 32H65.3 32l9.1-32L160 32H304h32H480l46.5 162.6c-9.9-1.7-20.1-2.6-30.5-2.6c-1.2 0-2.4 0-3.6 0L455.9 64H336v48 16H304V112 64H184.1zM326.6 320H304V304 208 192h32v16 86.6c-3.8 8.2-6.9 16.7-9.4 25.4zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 80H480V416h32v32zm0-160v16 80 16H480V384 304 288h32z'
      
    ]
  };

  

  
  

  var faPaperPlane = {
    prefix: 'fasl',
    iconName: 'paper-plane',
    icon: [
      512,
      512,
      [61913],
      'f1d8',
      
      'M0 288l37 15.9 155 66.4v0V416v72l64 24 55.7-90.4-29.7-12.7-39.4 64-18.6-7V416 384v0l193.5 82.9L448 480l4.4-32.9L506.7 39.7 512 0 477.1 19.6 35.1 268.2 0 288zm239.4 67.8L468 87.7 421.9 434 239.4 355.8zM430.2 82.7L208.6 342.6 72.2 284.1l358-201.4z'
      
    ]
  };

  

  
  

  var faColumns3 = {
    prefix: 'fasl',
    iconName: 'columns-3',
    icon: [
      640,
      512,
      [],
      'e361',
      
      'M448 64V448H608V64H448zm-32 0H224V448H416V64zM192 448V64H32V448H192zM0 32H32 608h32V64 448v32H608 32 0V448 64 32z'
      
    ]
  };

  

  
  

  var faRightLeft = {
    prefix: 'fasl',
    iconName: 'right-left',
    icon: [
      512,
      512,
      ["exchange-alt"],
      'f362',
      
      'M512 144l-22.6-22.6L400 32H384 352V64v64H16 0v32H16 352v64 32h32 16l89.4-89.4L512 144zM386.7 64l80 80-80 80H384V64h2.7zM0 368l22.6 22.6L112 480h16 32V448 384H496h16V352H496 160V288 256H128 112L22.6 345.4 0 368zm125.3 80l-80-80 80-80H128V448h-2.7z'
      
    ]
  };

  
    var faExchangeAlt = faRightLeft;
  

  
  

  var faMessageDollar = {
    prefix: 'fasl',
    iconName: 'message-dollar',
    icon: [
      512,
      512,
      ["comment-alt-dollar"],
      'f650',
      
      'M160 416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448 416zm0-32h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zM272 112v9.6c5.9 1 19 3.5 24.1 4.9l15.5 4.1-8.2 30.9-15.5-4.1c-4-1.1-17.7-3.7-22.1-4.4c-12.8-2-23.6-.4-30.9 2.9c-7.2 3.3-9.9 7.5-10.5 11c-.7 4.1-.1 6.2 .5 7.4c.6 1.4 2 3.1 5 5.1c6.7 4.6 17.1 7.8 31 12l.6 .2c12.3 3.7 27.9 8.4 39.5 16.9c6.3 4.5 12 10.6 15.6 18.8c3.6 8.3 4.4 17.4 2.7 27.2c-3 17.5-14.6 29.4-29.3 35.7c-5.6 2.4-11.6 4-17.9 4.9V304v16H240V304v-9.6c-9.4-1.7-23.6-6.6-32.4-9.6l0 0 0 0 0 0c-1.8-.6-3.3-1.1-4.6-1.6l-15.2-5.1 10.1-30.4 15.2 5.1c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c9.5 3.2 20.7 7 27.1 8.1c13.3 2.1 24 .8 31-2.2c6.5-2.8 9.5-6.7 10.3-11.8c.8-4.7 .2-7.3-.5-9c-.7-1.7-2.2-3.6-5.1-5.7c-6.5-4.8-16.7-8.1-30.5-12.3l-2-.6 0 0c-11.9-3.6-26.6-8-37.7-15.5c-6.2-4.2-12.2-10-15.9-17.9c-3.8-8.1-4.7-17.1-3.1-26.6c2.9-16.7 14.7-28.4 28.8-34.7c5.6-2.6 11.8-4.4 18.3-5.4V112 96h32v16z'
      
    ]
  };

  
    var faCommentAltDollar = faMessageDollar;
  

  
  

  var faGridHorizontal = {
    prefix: 'fasl',
    iconName: 'grid-horizontal',
    icon: [
      448,
      512,
      [],
      'e307',
      
      'M32 160v64H96V160H32zM0 128H32 96h32v32 64 32H96 32 0V224 160 128zM32 320v64H96V320H32zM0 288H32 96h32v32 64 32H96 32 0V384 320 288zM256 160H192v64h64V160zm-64-32h64 32v32 64 32H256 192 160V224 160 128h32zm0 192v64h64V320H192zm-32-32h32 64 32v32 64 32H256 192 160V384 320 288zM416 160H352v64h64V160zm-64-32h64 32v32 64 32H416 352 320V224 160 128h32zm0 192v64h64V320H352zm-32-32h32 64 32v32 64 32H416 352 320V384 320 288z'
      
    ]
  };

  

  
  

  var faCircleO = {
    prefix: 'fasl',
    iconName: 'circle-o',
    icon: [
      512,
      512,
      [],
      'e119',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-256a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM256 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256z'
      
    ]
  };

  

  
  

  var faScannerKeyboard = {
    prefix: 'fasl',
    iconName: 'scanner-keyboard',
    icon: [
      512,
      512,
      [],
      'f489',
      
      'M128 0V64h32V0H128zM320 0V64h32V0H320zM224 0H192V64h32V0zM400 0V288h32V0H400zM512 0H480V288h32V0zM320 128V480H32V128H320zM32 96H0v32V480v32H32 320h32V480 128 96H320 32zm64 96H256v64H96V192zM64 160v32 64 32H96 256h32V256 192 160H256 96 64zm96 160H64v32h96V320zM64 384v32h96V384H64zm224-64H192v32h96V320zm-96 64v32h96V384H192z'
      
    ]
  };

  

  
  

  var faHillRockslide = {
    prefix: 'fasl',
    iconName: 'hill-rockslide',
    icon: [
      576,
      512,
      [],
      'e508',
      
      'M229.6 112l4.4-7.8 36-64 4.6-8.2H284h72 9.4l4.6 8.2 36 64 4.4 7.8-4.4 7.8-36 64-4.6 8.2H356 284h-9.4l-4.6-8.2-36-64-4.4-7.8zm63.7 48l53.3 0 27-48-27-48-53.3 0-27 48 27 48zM0 41.4L27.3 68.7l416 416L470.6 512H432 16 0V496 80 41.4zm32 77.3V480H393.4L32 118.6zM488.2 437.9l-64-36-8.2-4.6V388 316v-9.4l8.2-4.6 64-36 7.8-4.4 7.8 4.4 64 36 8.2 4.6V316v72 9.4l-8.2 4.6-64 36-7.8 4.4-7.8-4.4zM544 325.4l-48-27-48 27v53.3l48 27 48-27V325.4zM128 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM352 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faMaskFace = {
    prefix: 'fasl',
    iconName: 'mask-face',
    icon: [
      640,
      512,
      [],
      'e1d7',
      
      'M200.1 154.6L288 96l64 0 87.9 58.6c5.3 3.5 11.4 5.4 17.8 5.4H504h8v64c0 106-86 192-192 192s-192-86-192-192V160h8 16 30.3c6.3 0 12.5-1.9 17.8-5.4zM182.3 128H152 136h-8H16 0v16V336v12.5l12.1 3 144 36 14.9 3.7c39.6 35.3 91.8 56.8 149 56.8s109.4-21.5 149-56.8l14.9-3.7 144-36 12.1-3V336 144 128H624 512h-8H457.7L369.8 69.4C364.5 65.9 358.3 64 352 64H288c-6.3 0-12.5 1.9-17.8 5.4L182.3 128zM32 160H96v64c0 46.3 14 89.3 38.1 125L32 323.5V160zM608 323.5L505.9 349c24.1-35.7 38.1-78.7 38.1-125V160h64V323.5zM208 192H192v32h16H432h16V192H432 208zm-16 64v32h16H432h16V256H432 208 192zm48 64H224v32h16H400h16V320H400 240z'
      
    ]
  };

  

  
  

  var faBottleDroplet = {
    prefix: 'fasl',
    iconName: 'bottle-droplet',
    icon: [
      320,
      512,
      [],
      'e4c4',
      
      'M72 0L88 0l8 0V0h32 64 32 8l16 0 0 32-16 0-8 0V145.1c38.3 22.1 64 63.5 64 110.9V480v32H256 64 32V480 256c0-47.4 25.7-88.7 64-110.9V32l-8 0L72 32 72 0zM192 32l-64 0V145.1v18.5l-16 9.2C83.2 189.5 64 220.5 64 256V480H256V256c0-35.5-19.2-66.5-48-83.2l-16-9.2V145.1 32zm0 305c0-3.1-1.4-9.6-6.5-19.6c-4.8-9.5-11.6-19.6-18.9-29.2c-2.2-2.9-4.4-5.7-6.5-8.3c-2.2 2.6-4.4 5.4-6.5 8.3c-7.3 9.6-14.1 19.8-18.9 29.2c-5.1 10-6.5 16.5-6.5 19.6c0 16.6 13.8 31 32 31c11.5 0 19.3-3.4 23.8-7.5c4-3.6 8.2-10.3 8.2-23.5zm-96 0c0-25.6 23.9-59.1 42.4-81.3c7.9-9.4 14.8-16.7 18.5-20.6c1.9-2 3-3.1 3-3.1s1.1 1.1 3 3.1c3.8 3.9 10.7 11.3 18.5 20.6C200.1 277.9 224 311.4 224 337c0 42-28.7 63-64 63s-64-28.2-64-63z'
      
    ]
  };

  

  
  

  var faTurnDownRight = {
    prefix: 'fasl',
    iconName: 'turn-down-right',
    icon: [
      512,
      512,
      [],
      'e455',
      
      'M352 256l-32 0-192 0-32 0 0-32L96 64 32 64l0 256 288 0 32 0 0 32 0 50.7L466.7 288 352 173.3l0 50.7 0 32zm-32-96l0-32 32 0L489.4 265.4 512 288l-22.6 22.6L352 448l-32 0 0-32 0-32 0-32-32 0L32 352 0 352l0-32L0 64 0 32l32 0 64 0 32 0 0 32 0 128 0 32 32 0 128 0 32 0 0-32 0-32z'
      
    ]
  };

  

  
  

  var faFaceThinking = {
    prefix: 'fasl',
    iconName: 'face-thinking',
    icon: [
      512,
      512,
      [],
      'e39b',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 108.4-76.9 198.8-179.2 219.5l6.4 31.4C424 483.2 512 379.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 23.6 3.2 46.5 9.2 68.3l30.8-8.5c-5.2-19-8.1-39-8.1-59.7zM216.4 144.8l13.2 11.3 12.1 10.4 20.8-24.3-12.1-10.4-13.2-11.3C206.4 94.1 162.3 90 127.1 110.1l-7.1 4L106.2 122 122 149.8l13.9-7.9 7.1-4c23.5-13.4 52.9-10.6 73.4 7zm-40 71.2a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM160 272H128 96 64v32 16V464v16 32H96h16 88 10.7H232l8.2-19.7 4.1-9.8 33.2-79.7 36-14.1 14.9-5.8 29.8-11.7-11.7-29.8-11.7-29.8-11.7-29.8L299.7 291 197.1 256.8l-10.1 30.4 66.2 22.1L160 345.7V320 304 272zm0 108l68.9-27 12.7-5 33.7-13.2 14.9-5.8 14.9-5.8 11.7 29.8-14.9 5.8-14.9 5.8-33.7 13.2-38.4 92.2-4.1 9.8H200 128 112 96V464 448v-8.6V392.6 336 320 304h32v16 16 22.2 34.4L160 380zM360.4 208a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faShare = {
    prefix: 'fasl',
    iconName: 'share',
    icon: [
      512,
      512,
      ["mail-forward"],
      'f064',
      
      'M71.8 446.6C101 469.9 128 480 128 480s-20.2-20.2-28.5-52.6C97.3 419 96 409.9 96 400c0-61.9 50.1-112 112-112h48 32v32 32 32h32L488.3 229.7 512 208l-23.7-21.7L320 32H288V64 96v32H256 176C78.8 128 0 206.8 0 304c0 69.2 37.5 115.1 71.8 142.6zm-7.7-52.3C45.9 371.8 32 342.2 32 304c0-79.5 64.5-144 144-144H288h32V128 75.4L464.6 208 320 340.6V288 256H288 208c-77.6 0-140.9 61.4-143.9 138.3z'
      
    ]
  };

  
    var faMailForward = faShare;
  

  
  

  var faDownLeft = {
    prefix: 'fasl',
    iconName: 'down-left',
    icon: [
      384,
      512,
      [],
      'e16a',
      
      'M144 237.3l22.6-22.6L272 109.3 338.7 176 233.4 281.4 210.7 304l22.6 22.6L282.7 376l-8 8H64V173.3l8-8 49.4 49.4L144 237.3zM94.6 142.6L72 120 49.4 142.6 32 160V384v32H64 288l17.4-17.4L328 376l-22.6-22.6-26.7-26.7L256 304l22.6-22.6 82.7-82.7L384 176l-22.6-22.6L294.6 86.6 272 64 249.4 86.6l-82.7 82.7L144 192l-22.6-22.6L94.6 142.6z'
      
    ]
  };

  

  
  

  var faDatabase = {
    prefix: 'fasl',
    iconName: 'database',
    icon: [
      448,
      512,
      [],
      'f1c0',
      
      'M32 203.6l88.1 50.3 3.7 2.1H128 320h4.2l3.7-2.1L416 203.6v91.1L315.8 352H132.2L32 294.7V203.6zm0-36.9v-69L137.2 32H310.8L416 97.7v69L315.8 224H132.2L32 166.7zm0 247.6V331.6l88.1 50.3 3.7 2.1H128 320h4.2l3.7-2.1L416 331.6v82.7L310.8 480H137.2L32 414.3zM128 0L0 80V432l128 80H320l128-80V80L320 0H128z'
      
    ]
  };

  

  
  

  var faNoteMedical = {
    prefix: 'fasl',
    iconName: 'note-medical',
    icon: [
      448,
      512,
      [],
      'e200',
      
      'M416 64H32V448H288V336 320h16H416V64zM394.7 352H320v74.7L394.7 352zm53.3-8L312 480H32 0V448 64 32H32 416h32V64 344zM192 112h64 16v16 48h48 16v16 64 16H320 272v48 16H256 192 176V320 272H128 112V256 192 176h16 48V128 112h16zm16 80v16H192 144v32h48 16v16 48h32V256 240h16 48V208H256 240V192 144H208v48z'
      
    ]
  };

  

  
  

  var faTriangleExclamation = {
    prefix: 'fasl',
    iconName: 'triangle-exclamation',
    icon: [
      512,
      512,
      [9888,"exclamation-triangle","warning"],
      'f071',
      
      'M18.3 448L0 480H36.9 475.1 512l-18.3-32L274.4 64.2 256 32 237.6 64.2 18.3 448zm438.6 0H55.1L256 96.5 456.9 448zM240 320v16h32V320 192H240V320zm40 96V368H232v48h48z'
      
    ]
  };

  
    var faExclamationTriangle = faTriangleExclamation;
  
    var faWarning = faTriangleExclamation;
  

  
  

  var faSnake = {
    prefix: 'fasl',
    iconName: 'snake',
    icon: [
      512,
      512,
      [128013],
      'f716',
      
      'M389.8 214.3L512 160V64L368 0 270 56H180C98.3 56 32 122.3 32 204s66.3 148 148 148H344c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0H96L31.8 437.5 0 456l31.8 18.5L96 512h79.9l.1 0H344c75.1 0 136-60.9 136-136c0-58.4-36.8-108.2-88.4-127.5c-4.8-1.8-9.7-3.3-14.7-4.5c-6-1.5-12.2-2.6-18.5-3.2c-4.7-.5-9.6-.8-14.4-.8H331.5 180c-19.9 0-36-16.1-36-36s16.1-36 36-36h90l70 40 4 2.3L368 224l21.8-9.7zm-20-26.1l-83.9-48-7.4-4.2H270 180c-37.6 0-68 30.4-68 68s30.4 68 68 68H344c57.4 0 104 46.6 104 104s-46.6 104-104 104l-168 0 0 0-.1 0h0H104.7L63.5 456l41.1-24H288l56 0c30.9 0 56-25.1 56-56s-25.1-56-56-56H180c-64.1 0-116-51.9-116-116s51.9-116 116-116h90 8.5l7.4-4.2 83.9-48L480 84.8v54.4l-110.2 49zM384 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faHandcuffs = {
    prefix: 'fasl',
    iconName: 'handcuffs',
    icon: [
      640,
      512,
      [],
      'e4f8',
      
      'M244.2 8.3l8.3 47.3 47.3-8.3L291.5 0 244.2 8.3zM160 110.1L126.1 144H112 96v16 45.3C39.5 230 0 286.4 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-65.6-39.5-122-96-146.7V160 144H208 193.9L160 110.1zm32 85.1c-10.3-2.1-21-3.2-32-3.2s-21.7 1.1-32 3.2V176h64v19.2zM32 352a128 128 0 1 1 256 0A128 128 0 1 1 32 352zm64 0a64 64 0 1 1 128 0A64 64 0 1 1 96 352zm160 0A96 96 0 1 0 64 352a96 96 0 1 0 192 0zm224-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM416 144v16 45.3c-21.2 9.3-40 23-55.3 40l23.8 21.3C408 240.5 442.1 224 480 224c70.7 0 128 57.3 128 128s-57.3 128-128 128c-37.9 0-72-16.5-95.4-42.7l-23.8 21.3C390 491.4 432.6 512 480 512c88.4 0 160-71.6 160-160c0-65.6-39.5-122-96-146.7V160 144H528 513.9L480 110.1 446.1 144H432 416zm32 51.2V176h64v19.2c-10.3-2.1-21-3.2-32-3.2s-21.7 1.1-32 3.2zM199.1 38.8L158.8 64.9l26.1 40.3 40.3-26.1L199.1 38.8zm241.9 0L414.8 79.1l40.3 26.1 26.1-40.3L440.9 38.8zM395.8 8.3L348.5 0l-8.3 47.3 47.3 8.3 8.3-47.3z'
      
    ]
  };

  

  
  

  var faInhaler = {
    prefix: 'fasl',
    iconName: 'inhaler',
    icon: [
      576,
      512,
      [],
      'f5f9',
      
      'M421.4 136.1l17.4-65.4 97.6 24.4L502.7 217.4l26 26 38.8-140.6L576 72l-31.1-7.8L416 32l-20.8 78 26.1 26.1zM361.9 256l6.4-23.7L380.7 186 500.8 306.1 462.1 448H224V256H337.3h24.5zm-7.3-96.1L337.3 224H224 192v32V448v32h32H486.6l50-183.4L390.3 150.3l-26.1-26.1-9.6 35.7zM32 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm96 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM56 352A24 24 0 1 0 8 352a24 24 0 1 0 48 0zm72 72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM56 448A24 24 0 1 0 8 448a24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faBookJournalWhills = {
    prefix: 'fasl',
    iconName: 'book-journal-whills',
    icon: [
      448,
      512,
      ["journal-whills"],
      'f66a',
      
      'M0 64C0 28.7 28.7 0 64 0H432h16V16 400v16H432 416v64h16 16v32H432 64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H416V32H64C46.3 32 32 46.3 32 64l0 328.6zm192.3-111l.9-23.4-2.2 2.2-5.7 5.7-11.3-11.3 5.7-5.7 9-9H208h-8V224h8 12.7l-9-9-5.7-5.7 11.3-11.3 5.7 5.7 4.2 4.2L232 87.7c.2-4.3 3.7-7.7 8-7.7s7.8 3.4 8 7.7l4.8 120.2 4.2-4.2 5.7-5.7 11.3 11.3-5.7 5.7-9 9H272h8v16h-8H259.3l9 9 5.7 5.7-11.3 11.3-5.7-5.7-2.2-2.2 .9 23.4c21-6.7 36.3-26.3 36.3-49.6c0-13.2-4.9-25.2-13-34.4l-7.9-8.9 8.9-7.9c12.3-11 20-27 20-44.7c0-13-4.1-25-11.1-34.8l15.3-17.6c45 23.2 75.9 70.3 75.9 124.5c0 77.3-62.7 140-140 140s-140-62.7-140-140c0-54.2 30.8-101.2 75.9-124.5l15.3 17.6C184.1 111 180 123 180 136c0 17.8 7.7 33.7 20 44.7l8.9 7.9-7.9 8.9c-8.1 9.2-13 21.2-13 34.4c0 23.2 15.2 42.9 36.3 49.6zm99.3-154c.3 2.8 .4 5.6 .4 8.4c0 20.9-7.6 40-20.2 54.7c7.7 11.9 12.2 26.1 12.2 41.3c0 42-34 76-76 76s-76-34-76-76c0-15.2 4.5-29.4 12.2-41.3C163.6 176 156 156.9 156 136c0-2.8 .1-5.7 .4-8.4c-11 11.4-19.7 25.1-25.3 40.3l18.5 18.5 5.7 5.7L144 203.3l-5.7-5.7-12.2-12.2c-1.4 7.3-2.2 14.8-2.2 22.5l0 .7 25.7 25.7 5.7 5.7L144 251.3l-5.7-5.7L127 234.3c11.9 51.4 58 89.7 113 89.7s101.1-38.3 113-89.7l-11.3 11.3-5.7 5.7L324.7 240l5.7-5.7L356 208.7l0-.7c0-7.7-.7-15.2-2.2-22.5l-12.2 12.2-5.7 5.7L324.7 192l5.7-5.7 18.5-18.5c-5.6-15.2-14.3-28.8-25.3-40.3z'
      
    ]
  };

  
    var faJournalWhills = faBookJournalWhills;
  

  
  

  var faBookOpen = {
    prefix: 'fasl',
    iconName: 'book-open',
    icon: [
      576,
      512,
      [128214,128366],
      'f518',
      
      'M272 84.1c-1.2-.5-2.7-1-4.5-1.7c-5.6-2-14-4.7-24.6-7.5c-21.2-5.5-50.4-11-82.9-11c-43.6 0-79.9 9.1-105.2 18.1C45.6 85.4 38 88.6 32 91.4V423.1c4-.9 8.3-1.8 12.7-2.7C74 414.2 113 407.5 144.5 408c44.5 .7 84.3 11.9 112.6 22.5c5.4 2 10.4 4.1 14.9 6V84.1zm32 352.5c4.6-2 9.6-4 14.9-6c28.2-10.7 68-21.8 112.6-22.5c31.5-.5 70.5 6.2 99.8 12.4c4.4 .9 8.6 1.8 12.7 2.7V91.4c-6-2.8-13.6-6-22.8-9.3C495.9 73.1 459.6 64 416 64c-28.4 0-57.6 5.4-80.2 11c-11.2 2.8-20.5 5.6-27 7.7c-1.8 .6-3.4 1.1-4.8 1.6V436.5zM416 32c96 0 160 40 160 40V430.9 464s-12.9-3.6-32-8.1c-30.9-7.2-77.8-16.5-112-15.9c-79.3 1.2-144 40-144 40s-64.7-38.8-144-40c-34.2-.5-81.1 8.8-112 15.9C12.9 460.4 0 464 0 464V430.9 72s64-40 160-40c72 0 128 24 128 24s64-24 128-24z'
      
    ]
  };

  

  
  

  var faChevronsRight = {
    prefix: 'fasl',
    iconName: 'chevrons-right',
    icon: [
      512,
      512,
      ["chevron-double-right"],
      'f324',
      
      'M267.3 267.3L278.6 256l-11.3-11.3-192-192L64 41.4 41.4 64 52.7 75.3 233.4 256 52.7 436.7 41.4 448 64 470.6l11.3-11.3 192-192zm192 0L470.6 256l-11.3-11.3-192-192L256 41.4 233.4 64l11.3 11.3L425.4 256 244.7 436.7 233.4 448 256 470.6l11.3-11.3 192-192z'
      
    ]
  };

  
    var faChevronDoubleRight = faChevronsRight;
  

  
  

  var faCorner = {
    prefix: 'fasl',
    iconName: 'corner',
    icon: [
      448,
      512,
      [],
      'e3fe',
      
      'M0 160H16 432h16v16V368v16H416V368 192H16 0V160z'
      
    ]
  };

  

  
  

  var faBahtSign = {
    prefix: 'fasl',
    iconName: 'baht-sign',
    icon: [
      320,
      512,
      [],
      'e0ac',
      
      'M160 0H128V64H32 0V96 240v32V416v32H32h96v64h32V448h56c57.4 0 104-46.6 104-104c0-44.7-28.2-82.8-67.8-97.5C274.1 227.4 288 199.3 288 168c0-57.4-46.6-104-104-104H160V0zM128 96V240H32V96h96zm32 144V96h24c39.8 0 72 32.2 72 72s-32.2 72-72 72H160zm-32 32V416H32V272h96zm32 144V272h24 32c39.8 0 72 32.2 72 72s-32.2 72-72 72H160z'
      
    ]
  };

  

  
  

  var faCowbell = {
    prefix: 'fasl',
    iconName: 'cowbell',
    icon: [
      448,
      512,
      [],
      'f8b3',
      
      'M144 0H128V16 96H64L6.4 384 0 416H32.6 415.4 448l-6.4-32L384 96H320V16 0H304 144zM288 96H160V32H288V96zM144 128H304h53.8L409 384H39L90.2 128H144zm16 320c0 35.3 28.7 64 64 64s64-28.7 64-64H256c0 17.7-14.3 32-32 32s-32-14.3-32-32H160z'
      
    ]
  };

  

  
  

  var faLightbulbDollar = {
    prefix: 'fasl',
    iconName: 'lightbulb-dollar',
    icon: [
      384,
      512,
      [],
      'f670',
      
      'M336 176c0 30.6-9.5 58.8-25.7 82.1c-4.1 5.9-8.8 12.3-13.6 19c-12.7 17.5-27.1 37.2-38 57.1c-8.9 16.2-13.7 33.3-16.2 49.9H275c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1l0 0c-4.9-6.7-9.5-13-13.6-19C57.5 234.8 48 206.6 48 176C48 96.5 112.5 32 192 32s144 64.5 144 144zM144 448h96v32H144V448zm-32 0v32 32h32 96 32V480 448 416H240 144 112v32zM208 96V80H176V96v9.3c-6.5 1.1-12.7 2.9-18.3 5.4c-14.1 6.4-25.9 18.1-28.8 34.7c-1.6 9.5-.7 18.5 3.1 26.6c3.8 7.9 9.7 13.7 15.9 17.9c11.1 7.5 25.8 11.9 37.7 15.5l0 0 2 .6c13.8 4.2 23.9 7.5 30.5 12.3c2.9 2.1 4.3 4 5.1 5.7c.7 1.6 1.3 4.3 .5 9c-.9 5-3.8 9-10.3 11.8c-7 3-17.7 4.3-31 2.2c-6.4-1-17.6-4.8-27.1-8.1l0 0 0 0c-2.2-.7-4.2-1.4-6.1-2.1l-15.2-5.1-10.1 30.4 15.2 5.1c1.3 .4 2.8 1 4.6 1.6l0 0 0 0 0 0c8.9 3 23 7.9 32.4 9.6V288v16h32V288v-8.9c6.3-.9 12.3-2.5 17.9-4.9c14.7-6.3 26.3-18.3 29.3-35.7c1.7-9.7 .9-18.9-2.7-27.2c-3.6-8.2-9.3-14.3-15.6-18.8c-11.6-8.4-27.2-13.1-39.5-16.9l0 0-.6-.2c-13.9-4.2-24.3-7.4-31-12c-3-2-4.3-3.8-5-5.1c-.6-1.2-1.2-3.3-.5-7.4c.6-3.6 3.3-7.8 10.5-11c7.3-3.3 18-4.9 30.9-2.9c4.4 .7 18.1 3.4 22.1 4.4l15.5 4.1 8.2-30.9-15.5-4.1c-5.1-1.4-18.2-3.9-24.1-4.9V96z'
      
    ]
  };

  

  
  

  var faTireRugged = {
    prefix: 'fasl',
    iconName: 'tire-rugged',
    icon: [
      512,
      512,
      [],
      'f634',
      
      'M186.2 0h14.5H311.3h14.5l1.4 14.5 2.1 21.3c10.6 3.5 20.8 7.8 30.6 12.7l16.6-13.6 11.2-9.2 10.3 10.3 78.2 78.2 10.3 10.3-9.2 11.2-13.6 16.6c4.9 9.8 9.2 20.1 12.7 30.6l21.3 2.1 14.5 1.4v14.5V311.3v14.5l-14.5 1.4-21.3 2.1c-3.5 10.6-7.8 20.8-12.7 30.6l13.6 16.6 9.2 11.2-10.3 10.3-78.2 78.2-10.3 10.3-11.2-9.2-16.6-13.6c-9.8 4.9-20.1 9.2-30.6 12.7l-2.1 21.3L325.8 512H311.3 200.7 186.2l-1.4-14.5-2.1-21.4c-10.6-3.5-20.8-7.8-30.6-12.7l-16.6 13.6-11.2 9.2-10.3-10.3L35.9 397.9 25.6 387.7l9.2-11.2 13.6-16.6c-4.9-9.8-9.2-20.1-12.7-30.6l-21.4-2.1L0 325.8V311.3 200.7 186.2l14.5-1.4 21.4-2.1c3.5-10.6 7.8-20.8 12.7-30.6L34.9 135.6l-9.2-11.2 10.3-10.3 78.2-78.2 10.3-10.3 11.2 9.2 16.6 13.6c9.8-4.9 20.1-9.2 30.6-12.7l2.1-21.4L186.2 0zm29.1 32l-1.7 17.5-1.1 10.9-10.6 3c-15.5 4.3-30.2 10.5-43.9 18.2L148.5 87 140 80 126.4 68.8 68.8 126.4 80 140l7 8.5L81.6 158c-7.7 13.7-13.9 28.4-18.2 43.9l-3 10.6-10.9 1.1L32 215.3v81.5l17.5 1.7 10.9 1.1 3 10.6c4.3 15.5 10.5 30.2 18.2 43.9l5.4 9.6L80 372 68.8 385.6l57.6 57.6L140 432l8.5-7 9.6 5.4c13.7 7.7 28.4 13.9 43.9 18.2l10.6 3 1.1 10.9 1.7 17.5h81.5l1.7-17.5 1.1-10.9 10.6-3c15.5-4.3 30.2-10.5 43.9-18.2l9.6-5.4 8.5 7 13.6 11.2 57.6-57.6L432 372l-7-8.5 5.4-9.6c7.7-13.7 13.9-28.4 18.2-43.9l3-10.6 10.9-1.1 17.5-1.7V215.3l-17.5-1.7-10.9-1.1-3-10.6c-4.3-15.5-10.5-30.2-18.2-43.9l-5.4-9.6 7-8.5 11.2-13.6L385.6 68.8 372 80l-8.5 7L354 81.6c-13.7-7.7-28.4-13.9-43.9-18.2l-10.6-3-1.1-10.9L296.7 32H215.3zM96 256a160 160 0 1 1 320 0A160 160 0 1 1 96 256zM256 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-224a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-75.9 96.6a24 24 0 1 1 14.8-45.7 24 24 0 1 1 -14.8 45.7zm167.2-30.2a24 24 0 1 1 -45.7 14.8 24 24 0 1 1 45.7-14.8zm-29.6 73.8a24 24 0 1 1 -38.8 28.2 24 24 0 1 1 38.8-28.2zM199.6 333.7a24 24 0 1 1 28.2-38.8 24 24 0 1 1 -28.2 38.8z'
      
    ]
  };

  

  
  

  var faRectangleXmark = {
    prefix: 'fasl',
    iconName: 'rectangle-xmark',
    icon: [
      512,
      512,
      [62164,"rectangle-times","times-rectangle","window-close"],
      'f410',
      
      'M32 64V448H480V64H32zM0 32H32 480h32V64 448v32H480 32 0V448 64 32zM191.4 168.8l11.3 11.3L256 233.4l53.3-53.3 11.3-11.3 22.6 22.6-11.3 11.3L278.6 256l53.3 53.3 11.3 11.3-22.6 22.6-11.3-11.3L256 278.6l-53.3 53.3-11.3 11.3-22.6-22.6 11.3-11.3L233.4 256l-53.3-53.3-11.3-11.3 22.6-22.6z'
      
    ]
  };

  
    var faRectangleTimes = faRectangleXmark;
  
    var faTimesRectangle = faRectangleXmark;
  
    var faWindowClose = faRectangleXmark;
  

  
  

  var faHandBackPointRibbon = {
    prefix: 'fasl',
    iconName: 'hand-back-point-ribbon',
    icon: [
      448,
      512,
      [],
      'e1a0',
      
      'M112 0H96V16 64H51.2 17.9L38.7 90l24 30-24 30L17.9 176H51.2 96v72 8.6c-3.2 2-6.4 4.2-9.5 6.5L38.4 299.2 32 304v8 51.5c0 53 29.1 101.7 75.7 126.8l8.3 4.5c21 11.3 44.4 17.2 68.3 17.2H320c61.9 0 112-50.1 112-112V304 256 240H416 368V224 208H352 296V192 176H280 208V16 0H192 112zm16 176h32 16V144H160 84.5l11.2-14 8-10-8-10L84.5 96H160h16V64H160 128V32h48V80v80 32 16h16 72v16 16h16 56v16 16h16 48v32 96c0 44.2-35.8 80-80 80H184.3c-18.5 0-36.8-4.6-53.1-13.4l-7.6 14.1 7.6-14.1-8.3-4.5C86.6 442.6 64 404.7 64 363.5V320l32-24v48 16h32V344 275.3v-9.5V264 248 176z'
      
    ]
  };

  

  
  

  var faCartFlatbedSuitcase = {
    prefix: 'fasl',
    iconName: 'cart-flatbed-suitcase',
    icon: [
      640,
      512,
      ["luggage-cart"],
      'f59d',
      
      'M0 0H16h96 16V16 384h96H512 624h16v32H624 567.4c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H279.4c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H112 96V400 32H16 0V0zM512 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM288 0h16H464h16V16 80h64 32v32V288v32H544 224 192V288 112 80h32 64V16 0zm32 80H448V32H320V80zm-48 32H224V288h48V112zm32 176H464V112H304V288zm192 0h48V112H496V288z'
      
    ]
  };

  
    var faLuggageCart = faCartFlatbedSuitcase;
  

  
  

  var faEarthEurope = {
    prefix: 'fasl',
    iconName: 'earth-europe',
    icon: [
      512,
      512,
      ["globe-europe"],
      'f7a2',
      
      'M272 479.4V448H224h-6.6l-4.7-4.7-48-48-4.7-4.7V384 304 288h16H320h6.6l4.7 4.7L374.6 336H408h6.6l4.7 4.7L446.6 368H450c8.7-15 15.7-31.1 20.7-48H448h-6.6l-4.7-4.7-48-48-4.7-4.7V256 176H352v32 16l-16 0-48 0v16 16H272 192 176V240 208v-6.6l4.7-4.7L249.4 128H224 208V112 80 73.4l4.7-4.7 32-32 1.1-1.1 1.3-.9 4-2.6C129.6 34.7 32 133.9 32 256c0 123.7 100.3 224 224 224c5.4 0 10.7-.2 16-.6zm32-4.6c50.6-11 94.8-39.2 126.2-78l-1.5-1.5L401.4 368H368h-6.6l-4.7-4.7L313.4 320H192v57.4L230.6 416H288h16v16 42.8zM477.7 288c1.5-10.5 2.3-21.1 2.3-32c0-108-76.4-198.2-178.2-219.3L266.2 60.4 240 86.6V96h32 16v16 16 6.6l-4.7 4.7L208 214.6V224h48V208 192l16 0 48 0V160 144h16 64 16v16 89.4L454.6 288h23.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM182.6 112l-11.3 11.3-32 32L128 166.6 105.4 144l11.3-11.3 32-32L160 89.4 182.6 112z'
      
    ]
  };

  
    var faGlobeEurope = faEarthEurope;
  

  
  

  var faPrintSlash = {
    prefix: 'fasl',
    iconName: 'print-slash',
    icon: [
      640,
      512,
      [],
      'f686',
      
      'M512 489.1l-32-25.3V480H160V352H338.3l-40.5-32H160 128v32 32H96V224h80.2l-40.5-32H96 64v32V384v32H96h32v64 32h32H480h32V489.1zM160 48.1V32H434.7L480 77.3V160h32V64L448 0H160 128V22.9l32 25.3zM342.2 192l40.5 32H544v64 63.3l32 25.3V224 192H544 342.2zM512 256H480v32h32V256zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faRug = {
    prefix: 'fasl',
    iconName: 'rug',
    icon: [
      640,
      512,
      [],
      'e569',
      
      'M16 64H0V96H16 32v64H16 0v32H16 32v48H16 0v32H16 32v48H16 0v32H16 32v64H16 0v32H16 32 48 64 576h16 16 16 16V416H624 608V352h16 16V320H624 608V272h16 16V240H624 608V192h16 16V160H624 608V96h16 16V64H624 608 592 576 64 48 32 16zM64 96h64V416H64V352 320 272 240 192 160 96zm448 0h64v64 32 48 32 48 32 64H512V96zm-32 0V416H160V96H480z'
      
    ]
  };

  

  
  

  var faUserTag = {
    prefix: 'fasl',
    iconName: 'user-tag',
    icon: [
      640,
      512,
      [],
      'f507',
      
      'M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM43.3 480L87.6 336H320V304H64L9.8 480 0 512H33.5h381H448l-8.3-27.1-48.4-48.4L404.7 480H43.3zm574-118.6L480 224H384l-32 32v96L489.4 489.4 512 512l22.6-22.6 82.7-82.7L640 384l-22.6-22.6zM466.7 256l128 128L512 466.7l-128-128V269.3L397.3 256h69.5zM440 296a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faImagePortrait = {
    prefix: 'fasl',
    iconName: 'image-portrait',
    icon: [
      384,
      512,
      ["portrait"],
      'f3e0',
      
      'M32 32V480H352V32H32zM0 0H32 352h32V32 480v32H352 32 0V480 32 0zM224 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM124.4 352H259.6l-10.7-32H135.1l-10.7 32zM272 288l21.3 64L304 384H270.3 113.7 80l10.7-32L112 288h80 80zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  
    var faPortrait = faImagePortrait;
  

  
  

  var faPersonFalling = {
    prefix: 'fasl',
    iconName: 'person-falling',
    icon: [
      512,
      512,
      [],
      'e546',
      
      'M320 16l0-16H288l0 16 0 78.8L103.9 202.2 96 206.8V216 368v16l32 0V368l0-142.8 7.9-4.6 2.8 4.2 184 280 26.7-17.6L252.7 340.1l57.5-44.7 67-6.7 74.6 89.5 24.6-20.5-80-96-5.4-6.5-8.4 .8-70.3 7L243.2 158l68.9-40.2 7.9-4.6V104l0-88zM282.5 276.4l-47.4 36.9L165.4 207.2l-1.8-2.8 51.9-30.3 67 102.3zM96 88a24 24 0 1 1 48 0A24 24 0 1 1 96 88zm80 0A56 56 0 1 0 64 88a56 56 0 1 0 112 0z'
      
    ]
  };

  

  
  

  var faBriefcase = {
    prefix: 'fasl',
    iconName: 'briefcase',
    icon: [
      512,
      512,
      [128188],
      'f0b1',
      
      'M144 0H128V16 96H32 0v32V448v32H32 480h32V448 128 96H480 384V16 0H368 144zM352 96H160V32H352V96zM144 128H368 480V256H336 304 208 176 32V128H144zM480 288V448H32V288H176v48 32h32 96 32V336 288H480zm-272 0h96v48H208V288z'
      
    ]
  };

  

  
  

  var faPotFood = {
    prefix: 'fasl',
    iconName: 'pot-food',
    icon: [
      640,
      512,
      [127858],
      'e43f',
      
      'M128 16V0H96V16c0 25.8 4.3 44.4 11.7 59.2c7.2 14.3 16.7 23.9 24.6 31.7l.4 .4c8.1 8.1 14.3 14.4 19 23.8c4.6 9.2 8.3 22.7 8.3 44.8v16h32V176c0-25.8-4.3-44.4-11.7-59.2c-7.2-14.3-16.7-23.9-24.6-31.7l-.4-.4c-8.1-8.1-14.3-14.4-19-23.8C131.7 51.6 128 38.2 128 16zm96 0V0H192V16c0 25.8 4.3 44.4 11.7 59.2c7.2 14.3 16.7 23.9 24.6 31.7l0 0 0 0 0 0 .4 .4c8.1 8.1 14.3 14.4 19 23.8c4.6 9.2 8.3 22.7 8.3 44.8v16h32V176c0-25.8-4.3-44.4-11.7-59.2c-7.2-14.3-16.7-23.9-24.6-31.7l-.4-.4c-8.1-8.1-14.3-14.4-19-23.8C227.7 51.6 224 38.2 224 16zM32 256H16v32H32 67.8c5.8 81.7 55 150.6 124.2 184.9V480v32h32H416h32V480v-7.1C517.2 438.6 566.4 369.7 572.2 288H608h16V256H608 574.1l1.9-32H543.9 96.1 64l1.9 32H32zm507.4-64c-13.8-46.3-56.6-80-107.4-80s-93.6 33.7-107.4 80h34c12.3-28.3 40.5-48 73.3-48s61 19.7 73.3 48h34zM224 472.9V453l-17.8-8.8c-60.1-29.7-102.5-89.9-106.6-160.9L97.9 256H542.1l-1.6 27.3c-4.2 71-46.6 131.2-106.6 160.9L416 453v19.9V480H224v-7.1z'
      
    ]
  };

  

  
  

  var faCloudMoon = {
    prefix: 'fasl',
    iconName: 'cloud-moon',
    icon: [
      640,
      512,
      [],
      'f6c3',
      
      'M502.2 48.1c-35.2 26.3-58 68.2-58 115.5c0 77.5 61.2 140.7 137.9 143.9c2 .1 4.1 .1 6.1 .1c16.3 0 32-2.7 46.7-7.7c-12 15.5-26.4 28.9-42.8 39.7c-27.6 18.2-60.7 28.7-96.3 28.7c-13.3 0-26.3-1.5-38.8-4.3c-10.8-14.2-24.9-25.7-41.2-33.4c-.3-7.1-1.3-14-2.9-20.7c23.4 16.6 52 26.4 82.9 26.4c13.3 0 26.1-1.8 38.3-5.2C463.3 308.4 412.2 242 412.2 163.7c0-40.7 13.8-78.1 37-107.9C392.6 75.2 352 128.9 352 192.2c0 16.3 2.7 32 7.7 46.7c-11.1-6.4-23.4-10.9-36.5-13.2c-2.1-10.8-3.2-22-3.2-33.4C320 96 396.8 17.9 492.3 16c1.1 0 2.3 0 3.4 0c19.1 0 37.4 3 54.6 8.7c-17.6 4.8-33.9 12.8-48.2 23.5zM176 224c30.3 0 57.3 14 74.9 35.9c2.7 3.3 5.1 6.8 7.3 10.4c2.9-2 5.9-3.9 9.1-5.5c11-5.7 23.5-8.9 36.7-8.9c44.2 0 80 35.8 80 80c0 3.7-.3 7.4-.8 11c-.3 2.1-.7 4.2-1.1 6.2c2.1 .4 4.2 .8 6.2 1.4c34.3 9 59.7 40.2 59.7 77.4v80h-32l-48 0H96 32 0v-32-64c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96zM415.9 431.9c0-23.6-17-43.2-39.5-47.2l-32.8-5.8 7.1-32.5c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48c-10.3 0-19.7 3.2-27.4 8.6l-28 19.6-17.7-29.3C219.5 268.3 199.2 256 176 256c-35.3 0-63.9 28.6-64 63.9l0 1.2 .2 27.3-26.9 4.5C55 357.9 32 384.3 32 415.9v64H96 367.9l48 0v-48z'
      
    ]
  };

  

  
  

  var faLocationPen = {
    prefix: 'fasl',
    iconName: 'location-pen',
    icon: [
      384,
      512,
      ["map-marker-edit"],
      'f607',
      
      'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 20.2 9.1 48.6 26.5 82.7c16.9 33.2 39.9 68.2 63.4 100.5c23.4 32.2 46.9 61 64.5 81.9c1.9 2.3 3.8 4.5 5.6 6.6c1.8-2.1 3.6-4.3 5.6-6.6c17.7-20.8 41.1-49.7 64.5-81.9c23.5-32.3 46.4-67.3 63.4-100.5C342.9 240.6 352 212.2 352 192zm32 0c0 88.8-120.7 237.9-170.7 295.9C200.2 503.1 192 512 192 512s-8.2-8.9-21.3-24.1C120.7 429.9 0 280.8 0 192C0 86 86 0 192 0S384 86 384 192zM230.1 141.3L217 154.4l12.5 12.5 13.1-13.1-12.5-12.5zm-93.4 93.4l-2.3 14.8 14.8-2.3 57.7-57.7L194.4 177l-57.7 57.7zM265.3 131.2l22.6 22.6-22.6 22.6L164.4 277.2l-35.3 5.5L96 287.9l5.2-33.2 5.5-35.2L230.1 96l35.2 35.2z'
      
    ]
  };

  
    var faMapMarkerEdit = faLocationPen;
  

  
  

  var faSlashForward = {
    prefix: 'fasl',
    iconName: 'slash-forward',
    icon: [
      320,
      512,
      [],
      '2f',
      
      'M318.2 0H281.7L1.8 512H38.3L318.2 0z'
      
    ]
  };

  

  
  

  var faShieldQuartered = {
    prefix: 'fasl',
    iconName: 'shield-quartered',
    icon: [
      512,
      512,
      [],
      'e575',
      
      'M240 40.6V208H55.1c-6.6-35.7-8-68.2-6.6-93.1L240 40.6zM62.2 240H240V469.7C160.2 430.1 111.6 366.4 83.2 301.2c-8.9-20.5-15.8-41.1-21-61.2zM272 469.7V240H449.8c-5.2 20.1-12.1 40.7-21 61.2c-28.4 65.3-77 129-156.8 168.5zM456.9 208H272V40.6l191.5 74.3c1.5 24.9 0 57.4-6.6 93.1zm38.5-95l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9z'
      
    ]
  };

  

  
  

  var faHandFist = {
    prefix: 'fasl',
    iconName: 'hand-fist',
    icon: [
      448,
      512,
      [9994,"fist-raised"],
      'f6de',
      
      'M176 32V64 192h48V64 32H176zM144 192V64H96V192h48zm-80 0V64 32H96h48V0h32 48 32V32h48 32V64 96h48 32v32 48 16 32 32c0 49.9-25.4 93.9-64 119.8V496v16H320V496 366.9v-9.2l8-4.6c33.5-19.4 56-55.6 56-97H336 304V240H256v16 32 16H240 144 128V272h16 80V240 224H64v32 16c0 48.3 35.8 88.4 82.3 95l13.7 2v13.9V496v16H128V496 396c-55.2-14.2-96-64.3-96-124V256 208 192H48 64zm192 0v16h48V128 96 64H256V192zm128-16V128H336v80 16h48V192 176z'
      
    ]
  };

  
    var faFistRaised = faHandFist;
  

  
  

  var faAirplay = {
    prefix: 'fasl',
    iconName: 'airplay',
    icon: [
      576,
      512,
      [],
      'e089',
      
      'M32 64H544V384H442.5l26.9 24.2 8.7 7.8H544h32V384 64 32H544 32 0V64 384v32H32 97.9l8.7-7.8L133.5 384H32V64zM160 446.2L288 331 416 446.2V448H160v-1.8zM128 480h32H416h32V448 432L288 288 128 432v16 32z'
      
    ]
  };

  

  
  

  var faLamp = {
    prefix: 'fasl',
    iconName: 'lamp',
    icon: [
      448,
      512,
      [],
      'f4ca',
      
      'M34.2 256H0l12-32L96 0H352l84 224 12 32H413.8 34.2zm12-32H401.8l-72-192H118.2l-72 192zM160 320V288h32v32 15.5l-12.1 9.6 0 0-.3 .2c-.3 .2-.8 .7-1.5 1.3c-1.4 1.2-3.5 3-6.1 5.5c-5.2 4.9-12.1 12-18.9 20.7C138.8 390.9 128 411.9 128 432c0 16.8 5.6 31.4 11.8 42.1c1.2 2.2 2.5 4.1 3.6 5.9H304.6c1.2-1.8 2.4-3.7 3.6-5.9c6.2-10.8 11.8-25.3 11.8-42.1c0-20.1-10.8-41.1-25.1-59.3c-6.8-8.7-13.7-15.8-18.9-20.7c-2.6-2.4-4.7-4.3-6.1-5.5c-.7-.6-1.2-1-1.5-1.3l-.3-.2 0 0L256 335.5V320 288h32v32s64 50.5 64 112c0 48-32 80-32 80H128s-32-32-32-80c0-61.5 64-112 64-112z'
      
    ]
  };

  

  
  

  var faArrowsSplitUpAndLeft = {
    prefix: 'fasl',
    iconName: 'arrows-split-up-and-left',
    icon: [
      512,
      512,
      [],
      'e4bc',
      
      'M235.3 131.3L224 142.6 201.4 120l11.3-11.3L304 17.4V16h1.4l3.3-3.3L320 1.4l11.3 11.3 3.3 3.3H336v1.4l91.3 91.3L438.6 120 416 142.6l-11.3-11.3L336 62.6 336 272v16l0 96v16l0 80H496h16v32H496 320 304V496l0-96V384l0-80H62.6l68.7 68.7L142.6 384 120 406.6l-11.3-11.3-96-96L1.4 288l11.3-11.3 96-96L120 169.4 142.6 192l-11.3 11.3L62.6 272H304V62.6l-68.7 68.7z'
      
    ]
  };

  

  
  

  var faSquareW = {
    prefix: 'fasl',
    iconName: 'square-w',
    icon: [
      448,
      512,
      [],
      'e285',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM72.6 144h33.6l54 171.2 48.7-152 6.1-19.1h18.2l6.1 19.1 48.7 152 54-171.2h33.6L303.3 372.8 299.7 384H276.3l-3.6-11.1L224 220.5 175.2 372.9 171.7 384H148.3l-3.5-11.2L72.6 144z'
      
    ]
  };

  

  
  

  var faTruckArrowRight = {
    prefix: 'fasl',
    iconName: 'truck-arrow-right',
    icon: [
      640,
      512,
      [],
      'e58b',
      
      'M384 32V384H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H32V32H384zM32 416H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32 16 16V384H624 608V224v-5.9l-3.9-4.5-96-112L503.4 96H496 416V32 0H384 32 0V32 384v32H32zM488.6 128l82.3 96H416V128h72.6zM416 344.4V256H576V384h-5.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM235.3 84.7L224 73.4 201.4 96l11.3 11.3L265.4 160H112 96v32h16H265.4l-52.7 52.7L201.4 256 224 278.6l11.3-11.3 80-80L326.6 176l-11.3-11.3-80-80z'
      
    ]
  };

  

  
  

  var faDiagramSuccessor = {
    prefix: 'fasl',
    iconName: 'diagram-successor',
    icon: [
      512,
      512,
      [],
      'e47a',
      
      'M480 320L32 320l0 128 448 0 0-128zm32 128l0 32-32 0L32 480 0 480l0-32L0 320l0-32 32 0 448 0 32 0 0 32 0 128zM256 64l-64 0L32 64l0 128 224 0 0-128zm32 0l0 128 0 32-32 0L32 224 0 224l0-32L0 64 0 32l32 0 160 0 64 0 32 0 128 0 16 0 0 16 0 137.4 36.7-36.7L480 137.4 502.6 160l-11.3 11.3-64 64L416 246.6l-11.3-11.3-64-64L329.4 160 352 137.4l11.3 11.3L400 185.4 400 64 288 64zM96 368l320 0 16 0 0 32-16 0L96 400l-16 0 0-32 16 0z'
      
    ]
  };

  

  
  

  var faCartFlatbedBoxes = {
    prefix: 'fasl',
    iconName: 'cart-flatbed-boxes',
    icon: [
      640,
      512,
      ["dolly-flatbed-alt"],
      'f475',
      
      'M16 0H0V32H16 96V400v16h16 56.6c-5.4 9.4-8.6 20.3-8.6 32c0 35.3 28.7 64 64 64s64-28.7 64-64c0-11.7-3.1-22.6-8.6-32H456.6c-5.4 9.4-8.6 20.3-8.6 32c0 35.3 28.7 64 64 64s64-28.7 64-64c0-11.7-3.1-22.6-8.6-32H624h16V384H624 512 224 128V16 0H112 16zM544 448a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-416H352V288H224V64zM192 32V64 288v32h32H352h32V288 64 32H352 224 192zM448 64h64v64H448V64zM416 32V64v64 32h32 64 32V128 64 32H512 448 416zm32 192H576v64H448V224zm0-32H416v32 64 32h32H576h32V288 224 192H576 448z'
      
    ]
  };

  
    var faDollyFlatbedAlt = faCartFlatbedBoxes;
  

  
  

  var faAngleLeft = {
    prefix: 'fasl',
    iconName: 'angle-left',
    icon: [
      320,
      512,
      [8249],
      'f104',
      
      'M41.4 256l11.3-11.3 160-160L224 73.4 246.6 96l-11.3 11.3L86.6 256 235.3 404.7 246.6 416 224 438.6l-11.3-11.3-160-160L41.4 256z'
      
    ]
  };

  

  
  

  var faBuildings = {
    prefix: 'fasl',
    iconName: 'buildings',
    icon: [
      512,
      512,
      [],
      'e0cc',
      
      'M480 32V480H256V32H480zM256 0H224V32 480v32h32H480h32V480 32 0H480 256zM192 128H176 16 0v16V496v16H16 176h16V480H176 32V160H176h16V128zM80 320H64v16 64 16H80h64 16V400 336 320H144 80zm16 64V352h32v32H96zm224 32h16 64 16V400 336 320H400 336 320v16 64 16zm32-32V352h32v32H352zM80 192H64v16 64 16H80h64 16V272 208 192H144 80zm16 64V224h32v32H96zM320 64V80v64 16h16 64 16V144 80 64H400 336 320zm32 32h32v32H352V96zM336 288h64 16V272 208 192H400 336 320v16 64 16h16zm16-64h32v32H352V224z'
      
    ]
  };

  

  
  

  var faHouseCircleCheck = {
    prefix: 'fasl',
    iconName: 'house-circle-check',
    icon: [
      640,
      512,
      [],
      'e509',
      
      'M288 2.7L298.6 12 502.7 192.1c-2.2-.1-4.5-.1-6.7-.1c-12.8 0-25.3 1.4-37.3 4L288 45.3 96 214.7V480H208V304 288h16H339.2c-5.2 10.1-9.4 20.8-12.6 32H240V480l16 0H360.2c10 12.1 21.7 22.9 34.6 32H80 64V496 243L26.6 276 5.4 252l272-240L288 2.7zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm78.6 112l-11.3 11.3-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336z'
      
    ]
  };

  

  
  

  var faSwordLaser = {
    prefix: 'fasl',
    iconName: 'sword-laser',
    icon: [
      512,
      512,
      [],
      'e03b',
      
      'M293.7 289.9L512 48 464 0 222.1 218.3l22.7 22.7L462.9 44.1l5 5L271.1 267.2l22.7 22.7zM187.3 228.7L176 217.4 153.4 240l11.3 11.3 4.7 4.7L112 313.4l-8-8L92.7 316.7l-88 88L0 409.4V416v32 6.6l4.7 4.7 48 48 4.7 4.7H64 96h6.6l4.7-4.7 88-88L206.6 408l-8-8L256 342.6l4.7 4.7L272 358.6 294.6 336l-11.3-11.3-16-16 0 0 0 0-64-64-16-16zm4.7 49.9L233.4 320 216 337.4 174.6 296 192 278.6zM134.6 336L152 318.6 193.4 360 176 377.4 134.6 336zM32 422.6l72-72L161.4 408l-72 72H70.6L32 441.4V422.6z'
      
    ]
  };

  

  
  

  var faTomato = {
    prefix: 'fasl',
    iconName: 'tomato',
    icon: [
      512,
      512,
      [],
      'e330',
      
      'M269.5 80.3c45 2 84.1 13.5 112.7 24.8c15.7 6.3 28.4 12.5 37.1 17.3c4.4 2.4 7.8 4.4 10.2 5.8c1.2 .7 2.1 1.3 2.8 1.7l.8 .5 .2 .1 .1 0 0 0 0 0s0 0-8.8 13.3l8.8-13.3 29.1 19.2-33.5 9.5-40.4 11.4 10.7 32.1 10.6 31.8L378.4 223 256 177.1 133.6 223l-31.4 11.8 10.6-31.8 10.7-32.1L83.1 159.4l-33.5-9.5 29.1-19.2L87.5 144c-8.8-13.3-8.8-13.3-8.8-13.3l0 0 0 0 .1 0 .2-.1 .8-.5c.6-.4 1.6-1 2.8-1.7c2.4-1.4 5.8-3.4 10.2-5.8c8.8-4.8 21.4-11 37.1-17.3C157.2 94.2 194.3 83.2 237 80.6c-2.8-13.9-7.1-25-11.3-33.4c-3.5-7-7-12.2-9.5-15.6c-1.2-1.7-2.2-2.8-2.9-3.6c-.3-.4-.5-.6-.6-.7l-.1-.1 0 0 0 0 0 0 0 0s0 0 11.3-11.3S235.3 4.7 235.3 4.7l0 0 0 0 .1 .1 .2 .2 .4 .5c.4 .4 .8 .9 1.4 1.5c1.1 1.3 2.6 3.1 4.4 5.4c3.5 4.7 8 11.5 12.5 20.4c6 12 11.9 27.9 15.1 47.5zM240 112.5c-38.8 2.2-72.9 12.3-98.3 22.4c-3.9 1.6-7.7 3.1-11.2 4.7l17.9 5.1 16.1 4.6-5.3 15.9-5.4 16.2L250.4 145l5.6-2.1 5.6 2.1 96.6 36.2-5.4-16.2-5.3-15.9 16.1-4.6 17.9-5.1c-3.5-1.5-7.2-3.1-11.2-4.7c-25.4-10.1-59.5-20.2-98.3-22.4V128H240V112.5zm197.6 77.7l31.2-8.8C496.1 214 512 255.3 512 304c0 130.9-114.6 208-256 208S0 434.9 0 304c0-48.7 15.9-90 43.2-122.7l31.2 8.8 3.2 .9C48.9 219.7 32 257.5 32 304c0 55 23.6 97.8 62.5 127.7C134.1 462.2 190.8 480 256 480s121.9-17.8 161.5-48.3C456.4 401.8 480 359 480 304c0-46.5-16.9-84.3-45.6-112.9l3.2-.9z'
      
    ]
  };

  

  
  

  var faBatteryThreeQuarters = {
    prefix: 'fasl',
    iconName: 'battery-three-quarters',
    icon: [
      576,
      512,
      ["battery-4"],
      'f241',
      
      'M480 128V384H32V128H480zM32 96H0v32V384v32H32 480h32V384 128 96H480 32zm544 96H544v32 64 32h32V288 224 192zM96 192H320V320H96V192zM64 160v32V320v32H96 320h32V320 192 160H320 96 64z'
      
    ]
  };

  
    var faBattery4 = faBatteryThreeQuarters;
  

  
  

  var faCheck = {
    prefix: 'fasl',
    iconName: 'check',
    icon: [
      448,
      512,
      [10003,10004],
      'f00c',
      
      'M448.1 118.2L437 129.7 173.6 404l-11.5 12-11.5-12L11.1 258.8 0 247.2l23.1-22.2 11.1 11.5L162.1 369.8 414 107.5 425 96l23.1 22.2z'
      
    ]
  };

  

  
  

  var faIceSkate = {
    prefix: 'fasl',
    iconName: 'ice-skate',
    icon: [
      576,
      512,
      [9976],
      'f7ac',
      
      'M320 16V0H288V16v7.4l-4.1 1.1-240 64L32 91.7V104 368v16H48 496h16V368 256 243.5l-12.1-3L320 195.5V144 16zM64 116.3L288 56.6V128H240 224v32h16 48v32H240 224v32h16 62l178 44.5V352H64V116.3zM128 432V416H96v16 48H16 0v32H16h96H400 560h16V496 432 416H544v16 48H416V432 416H384v16 48H128V432z'
      
    ]
  };

  

  
  

  var faUserPlus = {
    prefix: 'fasl',
    iconName: 'user-plus',
    icon: [
      640,
      512,
      [],
      'f234',
      
      'M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM87.6 336H360.4l44.3 144H43.3L87.6 336zM384 304H64L9.8 480 0 512H33.5h381H448l-9.8-32L384 304zM544 112H512v16 64H448 432v32h16 64v64 16h32V288 224h64 16V192H608 544V128 112z'
      
    ]
  };

  

  
  

  var faBook = {
    prefix: 'fasl',
    iconName: 'book',
    icon: [
      448,
      512,
      [128212],
      'f02d',
      
      'M0 64C0 28.7 28.7 0 64 0H432h16V16 400v16H432 416v64h16 16v32H432 64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H96V32H64C46.3 32 32 46.3 32 64l0 328.6zM128 32V384H416V32H128zm48 96h16H352h16v32H352 192 176V128zm0 96h16H352h16v32H352 192 176V224z'
      
    ]
  };

  

  
  

  var faTurkey = {
    prefix: 'fasl',
    iconName: 'turkey',
    icon: [
      640,
      512,
      [],
      'f725',
      
      'M528 0c-35.3 0-64 28.7-64 64c0 11.1 2.9 21.6 7.9 30.8l-58.2 41.1C370.6 110.5 325.7 96 288 96C176 96 0 224 0 384v96 32H32 288 544h32V480 384c0-60.3-25-116.1-62.2-162.2l-26.2 18.5C522 282.3 544 332 544 384v96H288 32V384c0-68 37.6-132 91.4-180.2C177.6 155.2 242.3 128 288 128c25.9 0 58 8.8 90.8 25.2c-15.8 3.9-34 4.8-54.3 5.5l-.2 0c-9.9 .4-20.3 .8-30.4 1.7c-31 2.8-60.7 18.5-80.4 45.7c-18.2 25-24.5 55.1-20 83.3s19.8 54.9 44.8 73.1c50 36.4 120.1 25.3 156.4-24.7c4.4-6 8.1-12.4 11.1-19c4.3-9.3 8.1-18.9 11.8-28.1l0 0 .1-.2c12.2-30.8 22.8-56 43.4-70.6l4.9-3.5 26.5-18.7 36.8-26C540.9 184.2 557.6 192 576 192c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62c0-.7 0-1.3 0-2c0-35.3-28.7-64-64-64zM496 64c0-17.7 14.3-32 32-32s32 14.3 32 32c0 3.2-.5 6.2-1.3 9l-2.5 8.4 5.7 6.6c.3 .4 .7 .8 1 1.3l4.8 6.8H576c17.7 0 32 14.3 32 32s-14.3 32-32 32c-12.5 0-23.4-7.2-28.6-17.7L539 125.7l-15.2 10.7-81.3 57.4c-29.2 20.6-42.7 54.7-54 83l-.8 1.9c-3.8 9.5-7.3 18.4-11.2 26.7c-2.2 4.7-4.8 9.2-8 13.6c-26 35.7-76 43.6-111.7 17.7c-17.9-13-28.8-32-32-52.2s1.3-41.7 14.3-59.5c14.1-19.4 35.3-30.6 57.4-32.6c9.2-.8 18.8-1.2 28.9-1.6l2.1-.1c30.5-1.1 67.2-2.5 96.4-23.1l79.5-56.1 15.7-11.1L505.7 86.9C499.7 81.1 496 73 496 64z'
      
    ]
  };

  

  
  

  var faClipboardListCheck = {
    prefix: 'fasl',
    iconName: 'clipboard-list-check',
    icon: [
      384,
      512,
      [],
      'f737',
      
      'M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36l3.1 12H254h34v48H192 96V80h34 12.4l3.1-12zM192 0c-32.8 0-61 19.8-73.3 48H80 64V64 80H32 0v32V480v32H32 352h32V480 112 80H352 320V64 48H304 265.3C253 19.8 224.8 0 192 0zM320 144V112h32V480H32V112H64v32 16H80 192 304h16V144zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM171.3 235.3L182.6 224 160 201.4l-11.3 11.3L112 249.4 99.3 236.7 88 225.4 65.4 248l11.3 11.3 24 24L112 294.6l11.3-11.3 48-48zM192 256v32h16 64 16V256H272 208 192zm-32 96v32h16 96 16V352H272 176 160zm-48 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faRectangle = {
    prefix: 'fasl',
    iconName: 'rectangle',
    icon: [
      512,
      512,
      [9644,"rectangle-landscape"],
      'f2fa',
      
      'M480 96V416H32V96H480zM32 64H0V96 416v32H32 480h32V416 96 64H480 32z'
      
    ]
  };

  
    var faRectangleLandscape = faRectangle;
  

  
  

  var faCommentSms = {
    prefix: 'fasl',
    iconName: 'comment-sms',
    icon: [
      512,
      512,
      ["sms"],
      'f7cd',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM152 176H132.8C112.5 176 96 192.5 96 212.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8H112 96v32h16 27.2c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8H152h16V176h-8v0h-8zm40 16v96 16h32V288 240l19.2 25.6L256 282.7l12.8-17.1L288 240v48 16h32V288 192 176H296l-4.8 6.4L256 229.3l-35.2-46.9L216 176H192v16zm144 20.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8H352 336v32h16 27.2c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8H392h16V176H392h-8v0H372.7c-20.3 .1-36.7 16.6-36.7 36.8z'
      
    ]
  };

  
    var faSms = faCommentSms;
  

  
  

  var faBasketShoppingMinus = {
    prefix: 'fasl',
    iconName: 'basket-shopping-minus',
    icon: [
      576,
      512,
      [],
      'e652',
      
      'M245.9 31.9l7.9-13.9L225.9 2.2l-7.9 13.9L118.7 192H65 32 0v32H40l72 288H464l72-288h40V192H544 511 457.3L357.9 16.1 350.1 2.2 322.2 17.9l7.9 13.9L420.6 192H155.4L245.9 31.9zM73 224H503L439 480H137L73 224zM208 336H192v32h16H368h16V336H368 208z'
      
    ]
  };

  

  
  

  var faTableList = {
    prefix: 'fasl',
    iconName: 'table-list',
    icon: [
      512,
      512,
      ["th-list"],
      'f00b',
      
      'M192 64v96H480V64H192zm-32 0H32v96H160V64zM32 192V320H160V192H32zm0 160v96H160V352H32zm160 96H480V352H192v96zM480 320V192H192V320H480zM0 32H32 480h32V64 448v32H480 32 0V448 64 32z'
      
    ]
  };

  
    var faThList = faTableList;
  

  
  

  var faHandBackPointDown = {
    prefix: 'fasl',
    iconName: 'hand-back-point-down',
    icon: [
      448,
      512,
      [],
      'e19e',
      
      'M96 512H80V496 264v-8.6c-3.2-2-6.4-4.2-9.5-6.5L22.4 212.8 16 208v-8V148.5c0-53 29.1-101.7 75.7-126.8l8.3-4.5C121 5.9 144.4 0 168.3 0H304c61.9 0 112 50.1 112 112v96 48 16H400 352v16 16H336 280v16 16H264 192V496v16H176 96zM80 216V168 152h32v16 68.7 9.5V248v16V480h48V320 304h16 72V288 272h16 56V256 240h16 48V208 112c0-44.2-35.8-80-80-80H168.3c-18.5 0-36.8 4.6-53.1 13.4l-7.6-14.1 7.6 14.1-8.3 4.5C70.6 69.4 48 107.3 48 148.5V192l32 24z'
      
    ]
  };

  

  
  

  var faH5 = {
    prefix: 'fasl',
    iconName: 'h5',
    icon: [
      640,
      512,
      [],
      'e412',
      
      'M32 80V64H0V80 256 432v16H32V432 272H288V432v16h32V432 256 80 64H288V80 240H32V80zM432 64H418.9l-2.6 12.9-32 160L380.5 256H400 528c44.2 0 80 35.8 80 80s-35.8 80-80 80H458.2c-17.9 0-33.6-11.8-38.5-29l-4.4-15.4-30.8 8.8 4.4 15.4c8.8 30.9 37.1 52.2 69.2 52.2H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H419.5L445.1 96H592h16V64H592 432z'
      
    ]
  };

  

  
  

  var fa4 = {
    prefix: 'fasl',
    iconName: '4',
    icon: [
      384,
      512,
      [],
      '34',
      
      'M11.1 329.2L149.8 32h35.3L50.7 320H288V144 128h32v16V320h48 16v32H368 320V464v16H288V464 352H25.6 .5l10.6-22.8z'
      
    ]
  };

  

  
  

  var faSoftServe = {
    prefix: 'fasl',
    iconName: 'soft-serve',
    icon: [
      384,
      512,
      [127846,"creemee"],
      'e400',
      
      'M192 0H162.1l16.6 24.9 10.8 16.3c1.6 2.4 2.5 5.3 2.5 8.2c0 8.1-6.6 14.7-14.7 14.7H120c-39.8 0-72 32.2-72 72c0 10.1 2.1 19.7 5.8 28.4C22.5 175.2 0 205 0 240v64 16H16 48v64 16H64 83.9l12.2 98 1.8 14H112 272h14.1l1.8-14 12.2-98H320h16V384 320h32 16V304 240c0-36.2-24-66.8-57-76.6c5.7-11.2 9-23.9 9-37.4C336 56.4 279.6 0 210 0H192zM80 320H304v48H286 271.9l-1.8 14-12.2 98H126.1l-12.2-98-1.8-14H98 80V320zm256-32H320 64 48 32V240c0-26.5 21.5-48 48-48h.8H112h8 8V160H112 88c-5-6.7-8-15-8-24c0-22.1 17.9-40 40-40h57.3C203.1 96 224 75.1 224 49.3c0-5.7-1.1-11.4-3.1-16.7C267.7 38 304 77.8 304 126c0 14.5-6.1 27.5-16 36.7V160H240 224v32h16 14 34 9.1H304c26.5 0 48 21.5 48 48v48H336z'
      
    ]
  };

  
    var faCreemee = faSoftServe;
  

  
  

  var faFaceViewfinder = {
    prefix: 'fasl',
    iconName: 'face-viewfinder',
    icon: [
      512,
      512,
      [],
      'e2ff',
      
      'M16 0H0V16 144v16H32V144 32H144h16V0H144 16zM496 0H368 352V32h16H480V144v16h32V144 16 0H496zM0 512H16 144h16V480H144 32V368 352H0v16V496v16zm496 0h16V496 368 352H480v16V480H368 352v32h16H496zM240 216a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM256 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 288a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm0-112c-21.6 0-39.8-14.2-45.9-33.8l-30.6 9.4C189.6 312.2 220 336 256 336s66.4-23.8 76.5-56.4l-30.6-9.4c-6 19.6-24.3 33.8-45.9 33.8z'
      
    ]
  };

  

  
  

  var faGripDotsVertical = {
    prefix: 'fasl',
    iconName: 'grip-dots-vertical',
    icon: [
      256,
      512,
      [],
      'e411',
      
      'M64 96A16 16 0 1 0 32 96a16 16 0 1 0 32 0zM0 96a48 48 0 1 1 96 0A48 48 0 1 1 0 96zM64 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zM48 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM224 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm16 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faSpinnerScale = {
    prefix: 'fasl',
    iconName: 'spinner-scale',
    icon: [
      512,
      512,
      [],
      'e62a',
      
      'M236 44h40V64c0 11-9 20-20 20s-20-9-20-20V44zM204 12V44 64c0 28.7 23.3 52 52 52s52-23.3 52-52V44 12H276 236 204zm28 436v24h24 24V448c0-13.3-10.7-24-24-24s-24 10.7-24 24zM448 232c-13.3 0-24 10.7-24 24s10.7 24 24 24h24V256 232H448zM64 268H52l0-24H64c6.6 0 12 5.4 12 12s-5.4 12-12 12zm0-56H52 20v32 24 32H52 64c24.3 0 44-19.7 44-44s-19.7-44-44-44zm361.7-91.8l-17 17c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l17-17 33.9 33.9zM414.4 63.7L391.8 41 369.1 63.7l-17 17c-21.9 21.9-21.9 57.3 0 79.2s57.3 21.9 79.2 0l17-17L471 120.2 448.3 97.6 414.4 63.7zM80.6 391.8l19.8 19.8 19.8 19.8L140 411.6c10.9-10.9 10.9-28.7 0-39.6s-28.7-10.9-39.6 0L80.6 391.8zM401 401l17-17-17-17c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l17 17 17-17zm-292-269.4L97.6 120.2l22.6-22.6 11.3 11.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0zm45.3-45.3L142.9 75 120.2 52.4 97.6 75 75 97.6 52.4 120.2 75 142.9l11.3 11.3c18.7 18.7 49.1 18.7 67.9 0s18.7-49.1 0-67.9z'
      
    ]
  };

  

  
  

  var faM = {
    prefix: 'fasl',
    iconName: 'm',
    icon: [
      448,
      512,
      [109],
      '4d',
      
      'M0 32V48 464v16H32V464 99.7L210.8 361 224 380.3 237.2 361 416 99.7V464v16h32V464 48 32H423.6l-4.8 7L224 323.7 29.2 39l-4.8-7H0z'
      
    ]
  };

  

  
  

  var faDesktop = {
    prefix: 'fasl',
    iconName: 'desktop',
    icon: [
      576,
      512,
      [61704,128421,"desktop-alt"],
      'f390',
      
      'M544 32H32V256H544V32zm32 224v32 96 32H544 362.9l10.7 64H432h16v32H432 360 216 144 128V480h16 58.4l10.7-64H32 0V384 288 256 32 0H32 544h32V32 256zM32 288v96H231.7c.2 0 .4 0 .6 0H343.7c.2 0 .4 0 .6 0H544V288H32zM234.9 480H341.1l-10.7-64H245.6l-10.7 64z'
      
    ]
  };

  
    var faDesktopAlt = faDesktop;
  

  
  

  var faDiceD8 = {
    prefix: 'fasl',
    iconName: 'dice-d8',
    icon: [
      512,
      512,
      [],
      'f6d2',
      
      'M240 496l16 16 16-16 6.6-6.6L486.2 281.8l3.2-3.2L512 256l-12.6-12.6-10-10L278.6 22.6 272 16 256 0 240 16l-6.6 6.6L22.6 233.4l-10 10L0 256l22.6 22.6 3.2 3.2L233.4 489.4 240 496zm0-45.3L94.7 305.5 240 355.4v95.3zM46.3 255L240 61.3V321.6L46.3 255zM272 61.3L465.7 255 272 321.6V61.3zm0 294.2l145.3-49.9L272 450.7V355.4z'
      
    ]
  };

  

  
  

  var faShower = {
    prefix: 'fasl',
    iconName: 'shower',
    icon: [
      512,
      512,
      [128703],
      'f2cc',
      
      'M16 32H0V48 464v16H32V464 64h73.4l43.3 43.3 1.6 1.6c-32.9 43.9-29.4 106.4 10.5 146.3l4.7 4.7-16.8 16.8L137.4 288 160 310.6l11.3-11.3 192-192L374.6 96 352 73.4 340.7 84.7l-16.8 16.8-4.7-4.7C279.3 56.9 216.8 53.4 172.9 86.3l-1.6-1.6-48-48L118.6 32H112 16zm167.4 87.4c31.2-31.2 81.9-31.2 113.1 0l4.7 4.7L188.1 237.3l-4.7-4.7c-31.2-31.2-31.2-81.9 0-113.1zM416 200a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-64 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM424 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faDoNotEnter = {
    prefix: 'fasl',
    iconName: 'do-not-enter',
    icon: [
      512,
      512,
      [],
      'f5ec',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm80-56h32H400h32v32 48 32H400 112 80V280 232 200zm32 32v48H400V232H112z'
      
    ]
  };

  

  
  

  var faGaugeSimpleHigh = {
    prefix: 'fasl',
    iconName: 'gauge-simple-high',
    icon: [
      512,
      512,
      [61668,"tachometer","tachometer-fast"],
      'f62a',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64c0-18.6-7.9-35.3-20.5-47l82.6-153.4 7.6-14.1-28.2-15.2-7.6 14.1L271.3 289.8c-4.9-1.2-10-1.8-15.3-1.8c-35.3 0-64 28.7-64 64s28.7 64 64 64z'
      
    ]
  };

  
    var faTachometer = faGaugeSimpleHigh;
  
    var faTachometerFast = faGaugeSimpleHigh;
  

  
  

  var faArrowDownBigSmall = {
    prefix: 'fasl',
    iconName: 'arrow-down-big-small',
    icon: [
      576,
      512,
      ["sort-size-down"],
      'f88c',
      
      'M160 478.6l11.3-11.3 88-88L270.6 368 248 345.4l-11.3 11.3L176 417.4V48 32H144V48 417.4L83.3 356.7 72 345.4 49.4 368l11.3 11.3 88 88L160 478.6zM352 320H320v32 96 32h32 96 32V448 352 320H448 352zm96 32v96H352V352h96zM320 32V64 224v32h32H512h32V224 64 32H512 352 320zM512 224H352V64H512V224z'
      
    ]
  };

  
    var faSortSizeDown = faArrowDownBigSmall;
  

  
  

  var faCalendarLines = {
    prefix: 'fasl',
    iconName: 'calendar-lines',
    icon: [
      448,
      512,
      ["calendar-note"],
      'e0d5',
      
      'M128 0V16 64H320V16 0h32V16 64h64 32V96v64 32V480v32H416 32 0V480 192 160 96 64H32 96V16 0h32zM416 192H32V480H416V192zm0-96H32v64H416V96zM96 352h16H240h16v32H240 112 96V352zm16-96H336h16v32H336 112 96V256h16z'
      
    ]
  };

  
    var faCalendarNote = faCalendarLines;
  

  
  

  var faScaleBalanced = {
    prefix: 'fasl',
    iconName: 'scale-balanced',
    icon: [
      640,
      512,
      [9878,"balance-scale"],
      'f24e',
      
      'M384 64c0 29.8-20.4 54.9-48 62V480H528h16v32H528 320 112 96V480h16H304V126c-27.6-7.1-48-32.2-48-62H112 96V32h16H264.6C275.6 12.9 296.3 0 320 0s44.4 12.9 55.4 32H512h16V64H512 384zM142.2 119.6L253.5 298.8l2.4 3.9v4.6V336v6.6l-4.7 4.7-64 64-4.7 4.7h-6.6H80 73.4l-4.7-4.7-64-64L0 342.6V336 307.2v-4.6l2.5-3.9L115.1 119.5l13.6-21.7 13.5 21.8zM32 320v9.4L86.6 384h82.6l54.6-54.6V320H32zm177.1-32L128.6 158.2 47 288H209.1zM526.2 119.6L637.5 298.8l2.4 3.9v4.6V336v6.6l-4.7 4.7-64 64-4.7 4.7h-6.6H464h-6.6l-4.7-4.7-64-64-4.7-4.7V336 307.2v-4.6l2.5-3.9L499.1 119.5l13.6-21.7 13.5 21.8zM416 320v9.4L470.6 384h82.6l54.6-54.6V320H416zm177.1-32L512.6 158.2 431 288H593.1zM320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faBalanceScale = faScaleBalanced;
  

  
  

  var faDrawPolygon = {
    prefix: 'fasl',
    iconName: 'draw-polygon',
    icon: [
      448,
      512,
      [],
      'f5ee',
      
      'M96 96A32 32 0 1 0 32 96a32 32 0 1 0 64 0zM80 158V354c22.5 5.8 40.2 23.5 46 46H322c2.9-11.1 8.6-21 16.4-28.9l-32.2-53.7c-5.8 1.7-11.9 2.6-18.2 2.6c-35.3 0-64-28.7-64-64s28.7-64 64-64c6.3 0 12.4 .9 18.2 2.6l32.2-53.7c-7.8-7.9-13.5-17.8-16.4-28.9H126c-5.8 22.5-23.5 40.2-46 46zM365.8 354.6c5.8-1.7 11.9-2.6 18.2-2.6c35.3 0 64 28.7 64 64s-28.7 64-64 64c-29.8 0-54.9-20.4-62-48H126c-7.1 27.6-32.2 48-62 48c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62V158C20.4 150.9 0 125.8 0 96C0 60.7 28.7 32 64 32c29.8 0 54.9 20.4 62 48H322c7.1-27.6 32.2-48 62-48c35.3 0 64 28.7 64 64s-28.7 64-64 64c-6.3 0-12.4-.9-18.2-2.6l-32.2 53.7C345 222.6 352 238.5 352 256s-7 33.4-18.4 44.9l32.2 53.7zM64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM352 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faFaceMonocle = {
    prefix: 'fasl',
    iconName: 'face-monocle',
    icon: [
      512,
      512,
      [],
      'e380',
      
      'M448 371.4V224 208H429.2c-10.8-45.9-52-80-101.2-80c-57.4 0-104 46.6-104 104s46.6 104 104 104c37.1 0 69.6-19.4 88-48.5V393.9c0 5.9 .4 11.8 1.2 17.6C376.5 453.7 319.3 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224c0 42.2-11.7 81.7-32 115.4zm3.9 49.4C489.4 376.3 512 318.8 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c65.8 0 125.9-24.8 171.2-65.7c10.2 22.8 27.1 42.5 48.9 56.1l11.4 7.1 17-27.1-11.4-7.1c-20.2-12.6-34.7-32.2-41.3-54.5zM176.4 184a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM328 160a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM160 336v32h16c14.3 0 37.9 2.9 60.6 11.7c22.8 8.8 42.7 22.7 53.1 43.4l7.2 14.3 28.6-14.3-7.2-14.3c-15.3-30.5-43.3-48.6-70.1-59C221.3 339.5 193.7 336 176 336H160zM305.2 105.9c8-6.4 18-9.9 28.2-9.9c8.9 0 17.6 2.6 25.1 7.6l8.6 5.7 13.3 8.9 17.8-26.6-13.3-8.9L376.3 77c-12.7-8.5-27.6-13-42.8-13c-17.5 0-34.5 6-48.2 16.9L262 99.5l-12.5 10 20 25 12.5-10 23.2-18.6z'
      
    ]
  };

  

  
  

  var faRss = {
    prefix: 'fasl',
    iconName: 'rss',
    icon: [
      448,
      512,
      ["feed"],
      'f09e',
      
      'M448 480C448 232.6 247.4 32 0 32V64c229.8 0 416 186.2 416 416h32zM0 208c150.2 0 272 121.8 272 272h32C304 312.1 167.9 176 0 176v32zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faFeed = faRss;
  

  
  

  var faArrowTrendDown = {
    prefix: 'fasl',
    iconName: 'arrow-trend-down',
    icon: [
      576,
      512,
      [],
      'e097',
      
      'M368 416h16H560h16V400 224 208H544v16V361.4L331.3 148.7 320 137.4l-11.3 11.3L192 265.4 27.3 100.7 4.7 123.3l176 176L192 310.6l11.3-11.3L320 182.6 521.4 384H384 368v32z'
      
    ]
  };

  

  
  

  var faCookieBite = {
    prefix: 'fasl',
    iconName: 'cookie-bite',
    icon: [
      512,
      512,
      [],
      'f564',
      
      'M219.8 49.1L105.9 110 49.3 226.7 71.7 354.7l92.8 90.1 127.6 18L406.1 402l56.6-116.7-.5-2.8c-56.7-15.3-100.9-61-114.2-118.5c-57.3-13.2-102.8-57-118.3-113.4l-9.9-1.4zm156.4 86.6c3.7 62.4 52.2 112.7 113.7 119.5l6.1 34.7L430.3 425.3 298.1 496 149.8 475 42 370.4 16 222.1 81.7 86.7 213.9 16l42.8 6.1c6.7 61.5 57.1 110 119.5 113.7zM168 352l24-24 24 24-24 24-24-24zm-8-136l-24-24 24-24 24 24-24 24zm104 40l24-24 24 24-24 24-24-24zm88 120l-24-24 24-24 24 24-24 24z'
      
    ]
  };

  

  
  

  var faPeopleSimple = {
    prefix: 'fasl',
    iconName: 'people-simple',
    icon: [
      512,
      512,
      [],
      'e21b',
      
      'M128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 128 0a64 64 0 1 0 0 128zM62.7 192H193.3l5.3 128H192 160 96 64 57.4l5.3-128zM56 352h8V496v16H96V496 352h64V496v16h32V496 352h8 32l-1.3-32L224 160H32L25.3 320 24 352H56zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 384 0a64 64 0 1 0 0 128zm-39.9 64h79.7l45.7 160H298.4l45.7-160zM448 160H320L265.1 352 256 384h33.3H320V496v16h32V496 384h64V496v16h32V496 384h30.7H512l-9.1-32L448 160z'
      
    ]
  };

  

  
  

  var faFaceAngry = {
    prefix: 'fasl',
    iconName: 'face-angry',
    icon: [
      512,
      512,
      [128544,"angry"],
      'f556',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm70.8-105.4l23.8-21.4-10.7-11.9C323.8 355.4 295.7 336 256 336s-67.8 19.4-83.9 37.3l-10.7 11.9 23.8 21.4 10.7-11.9c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7l10.7 11.9zM176.4 264c13.3 0 24-10.7 24-24c0-2.6-.4-5.1-1.2-7.4l19.7 6.6 15.2 5.1 10.1-30.4-15.2-5.1-96-32-15.2-5.1-10.1 30.4 15.2 5.1 39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6c0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13 15.2-5.1-10.1-30.4-15.2 5.1-96 32-15.2 5.1 10.1 30.4 15.2-5.1 20.6-6.9c-.8 2.4-1.3 5-1.3 7.7c0 13.3 10.7 24 24 24s24-10.7 24-24z'
      
    ]
  };

  
    var faAngry = faFaceAngry;
  

  
  

  var faFunction = {
    prefix: 'fasl',
    iconName: 'function',
    icon: [
      640,
      512,
      [],
      'f661',
      
      'M80 0H96 208h16V32H208 112V192h64 16v32H176 112V464v16H96 16 0V448H16 80V224H16 0V192H16 80V16 0zM256 320c0 59.1 16.8 113.9 45.5 159.5l-27.1 17.1C242.5 445.9 224 385.2 224 320s18.5-125.9 50.5-176.5l27.1 17.1C272.8 206.1 256 260.9 256 320zm352 0c0-59.1-16.8-113.9-45.5-159.5l27.1-17.1C621.5 194.1 640 254.8 640 320s-18.5 125.9-50.5 176.5l-27.1-17.1C591.2 433.9 608 379.1 608 320zM379.3 244.7L432 297.4l52.7-52.7L496 233.4 518.6 256l-11.3 11.3L454.6 320l52.7 52.7L518.6 384 496 406.6l-11.3-11.3L432 342.6l-52.7 52.7L368 406.6 345.4 384l11.3-11.3L409.4 320l-52.7-52.7L345.4 256 368 233.4l11.3 11.3z'
      
    ]
  };

  

  
  

  var faBorderAll = {
    prefix: 'fasl',
    iconName: 'border-all',
    icon: [
      448,
      512,
      [],
      'f84c',
      
      'M416 64V240H240V64H416zm0 208V448H240V272H416zM208 240H32V64H208V240zM32 272H208V448H32V272zM32 32H0V64 448v32H32 416h32V448 64 32H416 32z'
      
    ]
  };

  

  
  

  var faAnchor = {
    prefix: 'fasl',
    iconName: 'anchor',
    icon: [
      576,
      512,
      [9875],
      'f13d',
      
      'M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64 78.4V160v32H208 192v32h16 64V480H96V310.6l28.7 28.7L136 350.6 158.6 328l-11.3-11.3-56-56L80 249.4 68.7 260.7l-56 56L1.4 328 24 350.6l11.3-11.3L64 310.6V496v16H80 288 496h16V496 310.6l28.7 28.7L552 350.6 574.6 328l-11.3-11.3-56-56L496 249.4l-11.3 11.3-56 56L417.4 328 440 350.6l11.3-11.3L480 310.6V480H304V224h64 16V192H368 304V160v-1.6c36.5-7.4 64-39.7 64-78.4c0-44.2-35.8-80-80-80z'
      
    ]
  };

  

  
  

  var faCircleQuarter = {
    prefix: 'fasl',
    iconName: 'circle-quarter',
    icon: [
      512,
      512,
      [],
      'e11f',
      
      'M34.3 224C48.3 125.9 125.9 48.3 224 34.3V224H34.3zM2 224c-1.3 10.5-2 21.2-2 32H32 224h32V224 32 0c-10.8 0-21.5 .7-32 2C108.2 16.4 16.4 108.2 2 224z'
      
    ]
  };

  

  
  

  var faBookQuran = {
    prefix: 'fasl',
    iconName: 'book-quran',
    icon: [
      448,
      512,
      ["quran"],
      'f687',
      
      'M384 0c35.3 0 64 28.7 64 64l0 384 0 0c0 35.3-28.7 64-64 64H16 0V480H16 32V416H16 0V400 16 0H16 384zM64 416v64H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zm320-32c11.7 0 22.6 3.1 32 8.6L416 64c0-17.7-14.3-32-32-32H32V384H384zM304 160l14.8 35.6 38.4 3.1L328 223.8l9 37.5L304 241.2l-32.9 20.1 8.9-37.5-29.3-25.1 38.4-3.1L304 160zM128 216c0 61.9 50.1 112 112 112c3.8 0 7.6-.2 11.4-.6C207.2 309.7 176 266.5 176 216s31.2-93.7 75.4-111.4c-3.7-.4-7.5-.6-11.4-.6c-61.9 0-112 50.1-112 112zM240 72c32.9 0 63.2 11 87.4 29.6l-13 28.4c-5.9-1.3-12.1-1.9-18.4-1.9c-48.6 0-88 39.4-88 88s39.4 88 88 88c6.3 0 12.5-.7 18.4-1.9l13 28.4C303.2 349 272.9 360 240 360c-79.5 0-144-64.5-144-144s64.5-144 144-144z'
      
    ]
  };

  
    var faQuran = faBookQuran;
  

  
  

  var faDeleteRight = {
    prefix: 'fasl',
    iconName: 'delete-right',
    icon: [
      576,
      512,
      [],
      'e154',
      
      'M0 448H32 400L576 256 400 64H32 0V96 416v32zM532.6 256L385.9 416H32V96H385.9L532.6 256zM159.4 168.8l-22.6 22.6 11.3 11.3L201.4 256l-53.3 53.3-11.3 11.3 22.6 22.6 11.3-11.3L224 278.6l53.3 53.3 11.3 11.3 22.6-22.6-11.3-11.3L246.6 256l53.3-53.3 11.3-11.3-22.6-22.6-11.3 11.3L224 233.4l-53.3-53.3-11.3-11.3z'
      
    ]
  };

  

  
  

  var faFileCirclePlus = {
    prefix: 'fasl',
    iconName: 'file-circle-plus',
    icon: [
      576,
      512,
      [58606],
      'e494',
      
      'M352 192v19.2c10.1-5.2 20.8-9.4 32-12.6V152L232 0H32 0V32 480v32H32 330.8c-12.9-9.1-24.5-19.9-34.6-32H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 304V288H416v16 48H368 352v32h16 48v48 16h32V432 384h48 16V352H496 448V304z'
      
    ]
  };

  

  
  

  var faTornado = {
    prefix: 'fasl',
    iconName: 'tornado',
    icon: [
      448,
      512,
      [127786],
      'f76f',
      
      'M352 122.6c0 13.9 4.5 27.4 12.8 38.5l55.6 74.2c17.9 23.8 27.5 52.8 27.5 82.6c0 41.8-19 81.3-51.6 107.4l-70.9 56.7L288 512l7.9-47.3 2-11.8c4-24 .3-48.7-10.6-70.5c-10-19.9-25.5-36.5-44.6-47.8L126.2 266.2C48 220.2 0 136.3 0 45.6V32 0H32 384h32V32L370.8 77.2c-12 12-18.8 28.4-18.8 45.4zm24.4 277.7c25-20 39.6-50.4 39.6-82.5c0-4.7-.3-9.3-.9-13.9H253.5l5.3 3.1c24.5 14.4 44.3 35.6 57 61c10.6 21.2 15.9 44.6 15.5 68.1l45-36zM405.5 272c-3-6.1-6.5-12-10.6-17.5l-55.6-74.2c-4.7-6.3-8.6-13.1-11.7-20.3H63.4c19 31.9 45.9 59.2 79 78.7L200 272.5V272H405.5zM320 122.6c0-25.5 10.1-50 28.2-68L370.7 32H32V45.6c0 28.7 5.5 56.6 15.7 82.4H320.2c-.1-1.8-.2-3.6-.2-5.4z'
      
    ]
  };

  

  
  

  var faFireFlameCurved = {
    prefix: 'fasl',
    iconName: 'fire-flame-curved',
    icon: [
      384,
      512,
      ["fire-alt"],
      'f7e4',
      
      'M88 181.3l-11.3 7.5C28.8 220.8 0 274.6 0 332.2C0 431.5 80.5 512 179.8 512h21.8C302.3 512 384 430.3 384 329.5c0-67.2-28.4-131.3-78.1-176.5L223.7 78.3c-10-9.1-15.7-22-15.7-35.5c0 0 0 0 0 0V0L178.9 25.9c-1 .9-1.9 1.7-2.9 2.6c-22.9 21.6-36.9 50.9-39.5 82c-.3 3.6-.5 7.2-.5 10.8c0 13.2 2 26.2 6 38.7c2.6 8 5.9 15.8 10 23.2c1.7 3 3.5 6 5.4 8.9l33.3 49.9c6.1 9.1 9.3 19.7 9.3 30.7V288c0 22.1-17.9 40-40 40s-40-17.9-40-40V198.5 191 160l-9.5 6.4L88 181.3zm0 38.7V288c0 39.8 32.2 72 72 72s72-32.2 72-72V272.7c0-17.2-5.1-34.1-14.7-48.4l-33.3-49.9c-10.5-15.7-16.1-34.2-16.1-53.1c0-17.5 4.8-34.5 13.6-49.2C186 83.4 193 93.6 202.2 102l82.2 74.7c43.1 39.2 67.6 94.7 67.6 152.9C352 412.6 284.6 480 201.5 480H179.8C98.2 480 32 413.8 32 332.2c0-44.3 20.9-85.7 56-112.1z'
      
    ]
  };

  
    var faFireAlt = faFireFlameCurved;
  

  
  

  var faArrowUpZA = {
    prefix: 'fasl',
    iconName: 'arrow-up-z-a',
    icon: [
      576,
      512,
      ["sort-alpha-up-alt"],
      'f882',
      
      'M336 32h16H480h16V48v8 6.1l-4 4.5L380.5 192H480h16v32H480 352 336V208v-8-6.1l4-4.5L451.5 64H352 336V32zM160 33.4l11.3 11.3 88 88L270.6 144 248 166.6l-11.3-11.3L176 94.6V464v16H144V464 94.6L83.3 155.3 72 166.6 49.4 144l11.3-11.3 88-88L160 33.4zM401.4 297.5l4.2-9.5h20.8l4.2 9.5 80 180 1.1 2.5h-35l-14.2-32h-93l-14.2 32h-35l1.1-2.5 80-180zM416 343.4L383.7 416h64.5L416 343.4z'
      
    ]
  };

  
    var faSortAlphaUpAlt = faArrowUpZA;
  

  
  

  var faPersonWalkingArrowLoopLeft = {
    prefix: 'fasl',
    iconName: 'person-walking-arrow-loop-left',
    icon: [
      640,
      512,
      [],
      'e551',
      
      'M200 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 200 0a56 56 0 1 0 0 112zM76.7 194.7l46.9-31.3L95 255.2c-5.7 18.2 0 38.1 14.4 50.6L210 393l30.7 102.7 4.6 15.3 30.7-9.2-4.6-15.3-32-107.2L238 375l-3.5-3L187.3 331l38.4-111 15 48.7 1.7 5.4 4.7 3.2 48 32 17.8-26.6-43.3-28.8-30.3-98.6-2.6-8.4-8.5-2.3-88-24-7-1.9-6.1 4-72 48-3.9 2.6-1.9 4.2-32 72-6.5 14.6 29.2 13 6.5-14.6 30.1-67.8zm48.8 70l33.1-106 49.7 13.6L161.2 308.4l-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zM66.9 422.5L12.7 476.7 1.4 488 24 510.6l11.3-11.3 56-56c1.2-1.2 2.2-2.6 3-4.2l36.3-72.6-25-21.6L66.9 422.5zm386.9 21.8L466 454.5 486.5 430l-12.3-10.2L412.2 368 624 368h16V352 80 64H624L336 64H320V96h16l272 0V336l-195.8 0 62.1-51.7L486.5 274 466 249.5l-12.3 10.2-96 80L343 352l14.7 12.3 96 80z'
      
    ]
  };

  

  
  

  var faClone = {
    prefix: 'fasl',
    iconName: 'clone',
    icon: [
      512,
      512,
      [],
      'f24d',
      
      'M32 480H320V384h32v96 32H320 32 0V480 192 160H32h96v32H32V480zM192 320H480V32H192V320zm-32 32V320 32 0h32H480h32V32 320v32H480 192 160z'
      
    ]
  };

  

  
  

  var faLinkSlash = {
    prefix: 'fasl',
    iconName: 'link-slash',
    icon: [
      640,
      512,
      ["chain-broken","chain-slash","unlink"],
      'f127',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM591.5 256c50-50 50-131 0-181s-131-50-181 0L387.9 97.6l22.6 22.6 22.6-22.6c37.5-37.5 98.3-37.5 135.8 0s37.5 98.3 0 135.8L492 310.3l25.3 20L591.5 256zM414.6 412.2l-33.4-26.3c-26.1 1.3-52.5-8.1-72.5-28c-14.2-14.2-23-31.7-26.4-50.1L249 281.5c-2.4 35.7 10.1 72 37.2 99.1c34.8 34.8 84.6 45.3 128.5 31.7zM331.2 154.1c14.2 14.2 23 31.7 26.4 50.1L391 230.5c2.4-35.7-10.1-72-37.2-99.1c-34.8-34.8-84.6-45.3-128.5-31.7l33.4 26.3c26.1-1.3 52.5 8.1 72.5 28zM148 201.7l-25.3-20L48.5 256c-50 50-50 131 0 181s131 50 181 0l22.6-22.6-22.6-22.6-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8L148 201.7z'
      
    ]
  };

  
    var faChainBroken = faLinkSlash;
  
    var faChainSlash = faLinkSlash;
  
    var faUnlink = faLinkSlash;
  

  
  

  var faPlugCircleExclamation = {
    prefix: 'fasl',
    iconName: 'plug-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e55d',
      
      'M128 16V0H96V16v96h32V16zm160 0V0H256V16v96h32V16zM16 144H0v32H16 32v64c0 83 63.1 151.2 144 159.2V496v16h32V496 399.2c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128V176H320v56.2c9.8-8.1 20.6-15.2 32-21V176h16 16V144H368 352 320 64 32 16zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 448V416H416v32h32zm0-160H416v16 80 16h32V384 304 288z'
      
    ]
  };

  

  
  

  var faHandHolding = {
    prefix: 'fasl',
    iconName: 'hand-holding',
    icon: [
      576,
      512,
      [],
      'f4bd',
      
      'M176 304h-4.8l-4 2.7L75.2 368H16 0v32H16 80h4.8l4-2.7 92-61.3H368v48H320 304 256 240v32h16 48 16 64 16 4.6H409l3.8-2.3 94-56L530 395 395.4 480H16 0v32H16 400h4.6l3.9-2.5 152-96L574 405l-8.4-13.5-40-64-8.3-13.3-13.5 8L400.2 384H400V320 304H384 176z'
      
    ]
  };

  

  
  

  var faFaceGrinTongueWink = {
    prefix: 'fasl',
    iconName: 'face-grin-tongue-wink',
    icon: [
      512,
      512,
      [128540,"grin-tongue-wink"],
      'f58b',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 77.2-39.1 145.3-98.6 185.6c-3.6 17.6-10.8 33.9-20.8 48.1C449.9 449.7 512 360.1 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 360.1 62.1 449.7 151.3 489.7c-10-14.2-17.2-30.5-20.8-48.1C71.1 401.3 32 333.2 32 256zM352 383.4c17.2-13.3 31.5-30.2 41.8-49.4c6.5-12.1 11.4-25.2 14.5-39c-11.8 4.6-24.3 8.8-37.2 12.3c-35.1 9.6-74 14.9-114.9 14.9s-79.9-5.3-114.9-14.9c-13-3.5-25.4-7.7-37.2-12.3c3.1 13.8 8 26.9 14.5 39c10.3 19.2 24.5 36 41.7 49.4V416c0 53 43 96 96 96s96-43 96-96V383.4zM320 352v64c0 35.3-28.7 64-64 64s-64-28.7-64-64V352h48v24h32V352h48zm16-192a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM116.8 237.6c21.6-28.8 64.8-28.8 86.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2zM336.4 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  
    var faGrinTongueWink = faFaceGrinTongueWink;
  

  
  

  var faCirclePlus = {
    prefix: 'fasl',
    iconName: 'circle-plus',
    icon: [
      512,
      512,
      ["plus-circle"],
      'f055',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm16-352H240v16 64H176 160v32h16 64v64 16h32V336 272h64 16V240H336 272V176 160z'
      
    ]
  };

  
    var faPlusCircle = faCirclePlus;
  

  
  

  var faShoePrints = {
    prefix: 'fasl',
    iconName: 'shoe-prints',
    icon: [
      640,
      512,
      [],
      'f54b',
      
      'M327.6 128l6.8 3.4 117.4 58.7L608 151v-64L445.4 32.9 288 59.1V128h32 7.6zM288 160H256V128 32L448 0 640 64V176L448 224 320 160H288zm-160 0V144 48 32h16 80V64H160v64h64v32H144 128zm71.6 224H192 160v68.9l157.4 26.2L480 424.9V361L323.7 321.9 206.3 380.6l-6.8 3.4zM160 352h32l128-64 192 48V448L320 512 128 480V384 352h32zM0 352H16 96v32H32v64H96v32H16 0V464 368 352z'
      
    ]
  };

  

  
  

  var faDragon = {
    prefix: 'fasl',
    iconName: 'dragon',
    icon: [
      640,
      512,
      [128009],
      'f6d5',
      
      'M256 0h48H432h16 80 7.4l4.8 5.6 96 112 3.9 4.5V128v64 16H624 528h-6.6l-4.7-4.7L489.4 176H480v40L614.4 316.8l19.2 14.4L640 336v8 24 80 48 16H624 576 560 528 440 48.3h-.7H16 0V496 464.3v-.7V432 416H16 45.8l376.1-34.8-58.7-70.5-7.4-8.9-3.7-4.4v-5.8V280.2l0 0V272 248 153.9l-55.2-27.6-23.2-11.6 20.7-15.5L341.3 64 294.4 28.8 256 0zM384 263.8l0 0V272v8 5.8l3.7 4.5 72.6 87.1 3.7 4.4v5.8 7.2 14.6l-14.5 1.3L48 447.9l-.7 .1h-.7H32v15.6 .7V480H47.6h.7H440h88 32 16 32V448 368 352l-12.8-9.6L454.4 236.8 448 232v-8V160 144h16 32 6.6l4.7 4.7L534.6 176H608V133.9L520.6 32H448 432 352l25.6 19.2L394.7 64 377.6 76.8l-43.3 32.5 40.8 20.4 8.8 4.4V144 248v15.8zm-64-74.4l0 37L165.2 136.1 81.6 219.7l68.7-3.6 69.9-3.7-43 55.3L161.4 288H320l0 8.7 0 0V309l9.2 11H320 136.5 96l24.9-32 5.1-6.6L152 248l-42.3 2.2-62 3.3L0 256l33.8-33.8L160 96l160 93.3zM495.2 57.7l32 16 14.3 7.2-14.3 28.6-14.3-7.2-32-16-14.3-7.2 14.3-28.6 14.3 7.2z'
      
    ]
  };

  

  
  

  var faWifiWeak = {
    prefix: 'fasl',
    iconName: 'wifi-weak',
    icon: [
      640,
      512,
      ["wifi-1"],
      'f6aa',
      
      'M320 384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  
    var faWifi1 = faWifiWeak;
  

  
  

  var faBorderBottom = {
    prefix: 'fasl',
    iconName: 'border-bottom',
    icon: [
      448,
      512,
      [],
      'f84d',
      
      'M448 480L0 480l0-32 448 0 0 32zm-8-104l-48 0 0-48 48 0 0 48zM8 376l0-48 48 0 0 48L8 376zm240 0l-48 0 0-48 48 0 0 48zM392 184l0-48 48 0 0 48-48 0zM56 184L8 184l0-48 48 0 0 48zm144 0l0-48 48 0 0 48-48 0zm240 96l-48 0 0-48 48 0 0 48zM8 280l0-48 48 0 0 48L8 280zm240 0l-48 0 0-48 48 0 0 48zM392 88l0-48 48 0 0 48-48 0zM56 88L8 88 8 40l48 0 0 48zm144 0l0-48 48 0 0 48-48 0zM344 280l-48 0 0-48 48 0 0 48zM296 88l0-48 48 0 0 48-48 0zM152 88l-48 0 0-48 48 0 0 48zM104 280l0-48 48 0 0 48-48 0z'
      
    ]
  };

  

  
  

  var faVolumeSlash = {
    prefix: 'fasl',
    iconName: 'volume-slash',
    icon: [
      640,
      512,
      [128263],
      'f2e2',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM576 256c0-62.8-30.2-118.6-76.8-153.6L480 128c38.9 29.2 64 75.7 64 128c0 28.7-7.6 55.6-20.8 78.9l25.4 20C566 326 576 292.2 576 256zM472 294.5c5.2-11.8 8-24.8 8-38.5c0-31.4-15.1-59.3-38.4-76.8l-19.2 25.6C437.9 216.5 448 235.1 448 256c0 6.1-.9 12-2.4 17.6L472 294.5zM352 64V32H320 304l-77.4 68.8 25.5 20.1 64-56.9H320V174.5l32 25.3V64zM64 192h71.6L95.1 160H64 32v32V320v32H64h96L304 480h16 32V448 362.8l-32-25.3V448h-3.8L181.3 328.1l-9.1-8.1H160 64V192z'
      
    ]
  };

  

  
  

  var faSdCard = {
    prefix: 'fasl',
    iconName: 'sd-card',
    icon: [
      384,
      512,
      [],
      'f7c2',
      
      'M352 32V480H32V141.3L141.3 32H352zM128 0L0 128V480v32H32 352h32V480 32 0H352 128zm64 80V64H160V80v64 16h32V144 80zm64 0V64H224V80v64 16h32V144 80zm64 0V64H288V80v64 16h32V144 80z'
      
    ]
  };

  

  
  

  var faAmpGuitar = {
    prefix: 'fasl',
    iconName: 'amp-guitar',
    icon: [
      512,
      512,
      [],
      'f8a1',
      
      'M256 0c-45.9 0-87.7 27.2-116.4 51.9c-4.8 4.1-9.3 8.2-13.4 12.1H32 0V96 256v16 16V480v32H32 480h32V480 288 272 256 96 64H480 385.8c-4.2-4-8.7-8.1-13.4-12.1C343.7 27.2 301.9 0 256 0zm80.4 64H175.6C199.9 46 228 32 256 32s56.1 14 80.4 32zM480 288V480H32V288H480zm0-32H32V96H480V256zM120 176a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM112 352V320H80v32h32zm0 96V416H80v32h32zm32-128v32h32V320H144zm32 96H144v32h32V416zm-64-48v32h32V368H112zm128-48H208v32h32V320zm-32 96v32h32V416H208zm0-16V368H176v32h32zm64-80v32h32V320H272zm32 96H272v32h32V416zm-64-48v32h32V368H240zm128-48H336v32h32V320zm32 32h32V320H400v32zm-32 64H336v32h32V416zm32 32h32V416H400v32zm-64-48V368H304v32h32zm32-32v32h32V368H368z'
      
    ]
  };

  

  
  

  var faLighthouse = {
    prefix: 'fasl',
    iconName: 'lighthouse',
    icon: [
      640,
      512,
      [],
      'e612',
      
      'M256 96V67.8l64-32 64 32V96v32h32V96h32V64L320 0 192 64V96h32v32h32V96zm192 64H432 416 384 256 224 208 192v32h16 10.2L165.8 480H144 128v32h16 16 32.5H256h32 64 32 63.5H480h16 16V480H496 474.2L421.8 192H432h16V160zm-64 32h5.3l52.4 288H384V416c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H198.3l52.4-288H256 384zM352 480H288V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64zM151.2 65.7l-128-64L8.9 30.3l128 64 14.3 7.2 14.3-28.6-14.3-7.2zm0 124.6l14.3-7.2-14.3-28.6-14.3 7.2-128 64 14.3 28.6 128-64zM616.9 1.7l-128 64-14.3 7.2 14.3 28.6 14.3-7.2 128-64L616.9 1.7zM474.5 183.2l14.3 7.2 128 64 14.3-28.6-128-64-14.3-7.2-14.3 28.6z'
      
    ]
  };

  

  
  

  var faBahai = {
    prefix: 'fasl',
    iconName: 'bahai',
    icon: [
      576,
      512,
      ["haykal"],
      'f666',
      
      'M321 117.4L304.6 59.1 288 0 271.4 59.1 255 117.4l-9.1 32.5L217.9 131 167.1 96.5 115.7 61.8 141.8 118l25.2 54.4 14.3 30.8-33.8 3.2-60.7 5.7L24 218.1l57 26.8 54.8 25.7L166.6 285l-24 24.1-42.5 42.5L55.8 395.9l60.7-15.5L176 365.3l32.8-8.4L206 390.7l-4.8 60L196.3 512l36.1-49.8 35.8-49.5L288 385.4l19.8 27.3 35.8 49.5L379.7 512l-4.9-61.4-4.8-60L367.3 357l32.8 8.4 59.5 15.2 60.6 15.5-44.2-44.3-42.5-42.5-24-24.1 30.8-14.5L495 244.9l57-26.8-62.7-5.9-60.8-5.7-33.8-3.2 14.3-30.8L434.2 118l26.1-56.3L408.9 96.5 358.1 131l-27.9 18.9L321 117.4zm61.8 35.4l-17.1 37-19 41 45 4.3 40.6 3.8-36.5 17.1-41.2 19.4 32.2 32.2 28.5 28.5L375.2 326l-43.4-11.1 3.6 44.6 3.3 41.3-24.8-34.2L288 330.8l-25.9 35.8-24.8 34.2 3.3-41.3 3.6-44.6L200.8 326l-40.1 10.2 28.5-28.5 32.2-32.2-41.2-19.4-36.5-17.1 40.6-3.8 45-4.3-19-41-17.1-37 34.8 23.5 36.7 24.9 12-42.7L288 118.1l11.4 40.4 12 42.7 36.7-24.9 34.8-23.5z'
      
    ]
  };

  
    var faHaykal = faBahai;
  

  
  

  var faUserDoctorMessage = {
    prefix: 'fasl',
    iconName: 'user-doctor-message',
    icon: [
      640,
      512,
      ["user-md-chat"],
      'f82e',
      
      'M320 128a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM224 0a128 128 0 1 0 0 256A128 128 0 1 0 224 0zM87.6 336H144v34.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V336H288v34.3c-23.1 6.9-40 28.3-40 53.7v24 16h16 16 16V432H280v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8H312v32h16 16 16V448 424c0-25.4-16.9-46.8-40-53.7V336h40.4l44.3 144H43.3L87.6 336zM176 416a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM384 304H64L9.8 480 0 512H33.5h381H448l-9.8-32L384 304zm224-80h32V192 32 0H608 416 384V32 192v32h32 32v32 13.3V280v16l12.8-9.6 8.5-6.4 10.7-8 64-48h64zm-83.2-25.6L480 232v-8V192H448 416V32H608V192H544 533.3l-8.5 6.4z'
      
    ]
  };

  
    var faUserMdChat = faUserDoctorMessage;
  

  
  

  var faTrailer = {
    prefix: 'fasl',
    iconName: 'trailer',
    icon: [
      640,
      512,
      [],
      'e041',
      
      'M0 32H16 496h16V48 352H616h16v32H616 288c0 53-43 96-96 96s-96-43-96-96H16 0V368 48 32zM128 384a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm154.5-32H480V64H32V352h69.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64zM128 96v16V240v16H96V240 112 96h32zm96 0v16V240v16H192V240 112 96h32zm96 0v16V272v16H288V272 112 96h32zm96 0v16V272v16H384V272 112 96h32z'
      
    ]
  };

  

  
  

  var faBoxHeart = {
    prefix: 'fasl',
    iconName: 'box-heart',
    icon: [
      448,
      512,
      [],
      'f49d',
      
      'M42.1 160H208V64H84.8L42.1 160zM208 192H32V448H416V192H240 208zM363.2 64H240v96H405.9L363.2 64zM64 32H384l64 144V448v32H416 32 0V448 176L64 32zm84 231.2c-14.2 14.2-13.4 37.5 1.7 50.7L224 378.8l74.3-64.8c15.2-13.2 15.9-36.5 1.7-50.7c-13.6-13.6-35.6-13.6-49.1 0l-15.5 15.5L224 290.1l-11.3-11.3-15.5-15.5c-13.6-13.6-35.6-13.6-49.1 0zm71.8-22.6l4.2 4.2 4.2-4.2c26.1-26.1 68.3-26.1 94.4 0c27.3 27.3 25.8 72.1-3.3 97.5l-84.8 74L224 421.2l-10.5-9.2-84.8-74c-29.1-25.4-30.6-70.2-3.3-97.5c26.1-26.1 68.3-26.1 94.4 0z'
      
    ]
  };

  

  
  

  var faCalendar = {
    prefix: 'fasl',
    iconName: 'calendar',
    icon: [
      448,
      512,
      [128197,128198],
      'f133',
      
      'M128 0V16 64H320V16 0h32V16 64h64 32V96v64 32V480v32H416 32 0V480 192 160 96 64H32 96V16 0h32zM416 192H32V480H416V192zm0-96H32v64H416V96z'
      
    ]
  };

  

  
  

  var faBoothCurtain = {
    prefix: 'fasl',
    iconName: 'booth-curtain',
    icon: [
      512,
      512,
      [],
      'f734',
      
      'M0 0V16 496v16H32V496 32H64V0H16 0zM288 32V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V32h64zM256 448c19.1 0 36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7c11.7 0 22.6-3.1 32-8.6V496v16h32V496 384 48 16 0H496 96V16 32 384c0 35.3 28.7 64 64 64c19.1 0 36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7zM480 48V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V32h64V48zM384 32V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V32h64zM192 384c0 17.7-14.3 32-32 32s-32-14.3-32-32V32h64V384z'
      
    ]
  };

  

  
  

  var faCloudMoonRain = {
    prefix: 'fasl',
    iconName: 'cloud-moon-rain',
    icon: [
      576,
      512,
      [],
      'f73c',
      
      'M453.2 231.4c7.7 9 14 19.3 18.5 30.5c28.4-4.3 53.8-17.7 73.2-37.1c10.7-10.7 19.6-23.3 26.1-37.1c-10 3.4-20.7 5.2-31.8 5.2c-2.8 0-5.6-.1-8.4-.4c-50.6-4.3-90.4-46.7-90.4-98.4c0-23.3 8.1-44.8 21.6-61.7c8.5-10.6 19.2-19.5 31.3-25.8C480.2 2.3 466.2 0 451.7 0c-1.1 0-2.2 0-3.4 0c-59.6 1.5-109.3 42.5-124 97.8c10.7 2 21 5.5 30.4 10.3c8.2-34 33.8-61.2 66.9-71.6c-8.5 17.4-13.3 36.9-13.3 57.6c0 58.6 38.5 108.2 91.7 124.8c-13.9 7.7-29.8 12.2-46.8 12.4zM250.8 131.9C233.2 110 206.2 96 176 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6v64 32H32 96 367.9l48 0h32v-80c0-37.1-25.3-68.4-59.7-77.4c-2-.5-4.1-1-6.2-1.4c.5-2.1 .8-4.1 1.1-6.2c.5-3.6 .8-7.3 .8-11c0-44.2-35.8-80-80-80c-13.2 0-25.7 3.2-36.7 8.9c-3.2 1.6-6.2 3.5-9.1 5.5c-2.2-3.6-4.6-7.1-7.3-10.4zm165 220l-48 0H96 32v-64c0-31.7 23-58 53.3-63.1l26.9-4.5-.2-27.3 0-1.2c.1-35.3 28.7-63.9 64-63.9c23.2 0 43.5 12.3 54.8 30.9l17.7 29.3 28-19.6c7.8-5.4 17.2-8.6 27.4-8.6c26.5 0 48 21.5 48 48c0 3.6-.4 7.1-1.1 10.4l-7.1 32.5 32.8 5.8c22.4 4 39.5 23.7 39.5 47.2v48zM104 416H64L0 512H40l64-96zm96 0H160L96 512h40l64-96zm56 0l-64 96h40l64-96H256zm136 0H352l-64 96h40l64-96z'
      
    ]
  };

  

  
  

  var faUpDown = {
    prefix: 'fasl',
    iconName: 'up-down',
    icon: [
      256,
      512,
      [8597,11021,"arrows-alt-v"],
      'f338',
      
      'M224 352H192V320 192 160h32 32V128L150.6 22.6 128 0 105.4 22.6 0 128v32H32 64v32V320v32H32 0v32L105.4 489.4 128 512l22.6-22.6L256 384V352H224zm-13.3 32L128 466.7 45.3 384H64 96V352 160 128H64 45.3L128 45.3 210.7 128H192 160v32V352v32h32 18.7z'
      
    ]
  };

  
    var faArrowsAltV = faUpDown;
  

  
  

  var faPencilMechanical = {
    prefix: 'fasl',
    iconName: 'pencil-mechanical',
    icon: [
      512,
      512,
      [],
      'e5ca',
      
      'M384 48L368 32 345.4 54.6 311.3 88.7l-52-52L248 25.4 236.7 36.7l-128 128L97.4 176 120 198.6l11.3-11.3L248 70.6l40.7 40.7L72 328 34.8 454.6 0 489.4 22.6 512l34.8-34.8L184 440 457.4 166.6 480 144l-16-16 25.4-25.4L512 80 489.4 57.4 454.6 22.6 432 0 409.4 22.6 384 48zm22.6 22.6L432 45.3 466.7 80l-25.4 25.4L406.6 70.6zM188.7 390.1l-66.7-66.7L368 77.3 434.7 144 188.7 390.1zm-23.2 22L72.6 439.4l27.3-92.9 65.6 65.6z'
      
    ]
  };

  

  
  

  var faTurtle = {
    prefix: 'fasl',
    iconName: 'turtle',
    icon: [
      576,
      512,
      [128034],
      'f726',
      
      'M200 64C124.9 64 64 124.9 64 200v40 16H32V240 200c0-92.8 75.2-168 168-168s168 75.2 168 168v40 16H336V240 200c0-75.1-60.9-136-136-136zm200 48h16 56c57.4 0 104 46.6 104 104v56 16H560 496v80 16H480 352v80 16H336 240 224V464 384H192v80 16H176 80 64V464 384H16 0V368 304 288H16 400V128 112zM256 448h64V416 384 352H464V272 256h16 64V216c0-39.8-32.2-72-72-72H432V304v16H416 320 256 160 96 32v32H96v32 32 32h64V416 384 352h96v32 32 32zM480 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faCaravanSimple = {
    prefix: 'fasl',
    iconName: 'caravan-simple',
    icon: [
      640,
      512,
      ["caravan-alt"],
      'e000',
      
      'M32 64V384h69.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H544V192c0-70.7-57.3-128-128-128H32zM96 416H32 0V384 64 32H32 416c88.4 0 160 71.6 160 160V384l48 0h16v32H624l-48 0H544 288c0 53-43 96-96 96s-96-43-96-96zM256 160H128v64H256V160zM128 128H256h32v32 64 32H256 128 96V224 160 128h32zm224 32v64h64V160H352zm-32-32h32 64 32v32 64 32H416 352 320V224 160 128zM256 416a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faCaravanAlt = faCaravanSimple;
  

  
  

  var faPersonWalkingLuggage = {
    prefix: 'fasl',
    iconName: 'person-walking-luggage',
    icon: [
      576,
      512,
      [],
      'e554',
      
      'M448 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 368 56zM347.7 163.5l-46.9 31.3-30.1 67.8-6.5 14.6-29.2-13 6.5-14.6 32-72 1.9-4.2 3.9-2.6 72-48 6.1-4 7 1.9 88 24 8.5 2.3 2.6 8.4 30.3 98.6 43.3 28.8-17.8 26.6-48-32-4.7-3.2-1.7-5.4-15-48.7L411.3 331l47.2 40.9 3.5 3 1.3 4.5 32 107.2 4.6 15.3-30.7 9.2-4.6-15.3L434 393 333.4 305.8c-14.4-12.5-20.1-32.4-14.4-50.6l28.7-91.8zm35-4.7l-33.1 106c-1.9 6.1 0 12.7 4.8 16.9l30.9 26.8 47.1-136.1-49.7-13.6zm-53 186.2l25 21.6-36.3 72.6c-.8 1.5-1.8 2.9-3 4.2l-56 56L248 510.6 225.4 488l11.3-11.3 54.2-54.2 38.8-77.6zM187.1 357.3l-55.4-32-64 110.9 55.4 32 4.7-8.2 0 0 2.5-4.2 56.8-98.5zM157.9 471.9l-7.1 12.3-16 27.7-27.7-16-55.4-32L24 447.9l16-27.7 64-110.9 16-27.7 27.7 16 55.4 32 1.3 .7 29.8-50.5 27.6 16.3L163.5 462.4l-5.6 9.5z'
      
    ]
  };

  

  
  

  var faParagraphLeft = {
    prefix: 'fasl',
    iconName: 'paragraph-left',
    icon: [
      384,
      512,
      ["paragraph-rtl"],
      'f878',
      
      'M320 32h16 16V0H336 224 208 176 144C82.1 0 32 50.1 32 112s50.1 112 112 112h48v80 16h32V304l0-80V208 32h64V304v16h32V304 32zM192 32V192H144c-44.2 0-80-35.8-80-80s35.8-80 80-80h32 16zM114.7 355.9l11.9-10.7-21.4-23.8L93.3 332.1l-80 72L.1 416l13.2 11.9 80 72 11.9 10.7 21.4-23.8-11.9-10.7L65.7 432H368h16V400H368 65.7l49-44.1z'
      
    ]
  };

  
    var faParagraphRtl = faParagraphLeft;
  

  
  

  var faBagsShopping = {
    prefix: 'fasl',
    iconName: 'bags-shopping',
    icon: [
      576,
      512,
      [128717],
      'f847',
      
      'M160 96c0-35.3 28.7-64 64-64s64 28.7 64 64v64H160V96zm-32 64H32 0v32V448v32H32 160V448H32V192H416v32h32V192 160H416 320V96c0-53-43-96-96-96s-96 43-96 96v64zm96 128H544V480H224V288zm-32-32v32V480v32h32H544h32V480 288 256H544 224 192zm128 80V320H288v16 16c0 53 43 96 96 96s96-43 96-96V336 320H448v16 16c0 35.3-28.7 64-64 64s-64-28.7-64-64V336z'
      
    ]
  };

  

  
  

  var faFan = {
    prefix: 'fasl',
    iconName: 'fan',
    icon: [
      512,
      512,
      [],
      'f863',
      
      'M242.5 134.2l-4.7 47.1 45.4-13.1c16.9-4.9 39.3-8.2 68.8-8.2l.1 0c59.2-.2 108.1 37.6 123.1 92.2l-97.5-9.7-47.1-4.7 13.1 45.4c4.9 16.9 8.2 39.3 8.2 68.8l0 .1c.2 59.2-37.6 108.1-92.2 123.1l9.7-97.5 4.7-47.1-45.4 13.1c-16.9 4.9-39.3 8.2-68.8 8.2l-.1 0c-59.2 .2-108.1-37.6-123.1-92.2l97.5 9.7 47.1 4.7-13.1-45.4c-4.9-16.9-8.2-39.3-8.2-68.8l0-.1c-.2-59.2 37.6-108.1 92.2-123.1l-9.7 97.5zM512 288c0-11.2-1.1-22-3.1-32.5C494.3 181.1 430.2 127.7 352 128c-16.6 0-31.5 1-44.9 2.7c-12.2 1.6-23.1 3.9-32.8 6.7l3.4-33.9L284.8 32 288 0c-11.2 0-22 1.1-32.5 3.1C181.1 17.7 127.7 81.8 128 160c0 16.6 1 31.5 2.7 44.9c1.6 12.2 3.9 23.1 6.7 32.8l-33.9-3.4-71.5-7.1L0 224c0 11.2 1.1 22 3.1 32.5C17.7 330.9 81.8 384.3 160 384c16.6 0 31.5-1 44.9-2.7c12.2-1.6 23.1-3.9 32.8-6.7l-3.4 33.9L227.2 480 224 512c11.2 0 22-1.1 32.5-3.1C330.9 494.3 384.4 430.2 384 352c0-16.6-1-31.5-2.7-44.9c-1.6-12.2-3.9-23.1-6.7-32.8l33.9 3.4 71.5 7.1 32 3.2zm-256-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faBlockBrick = {
    prefix: 'fasl',
    iconName: 'block-brick',
    icon: [
      448,
      512,
      ["wall-brick"],
      'e3db',
      
      'M136 64v64h72 32 72V64H136zm-32 64V64H32v64h72zM32 160v80h72 32 72V160H32zm0 192h72V272H32v80zm0 32v64H208V384H136 104 32zm104-32H312V272H136v80zm208 0h72V272H344v80zm72 32H344 312 240v64H416V384zm0-224H240v80h72 32 72V160zm0-32V64H344v64h72zM0 32H32 416h32V64 448v32H416 32 0V448 64 32z'
      
    ]
  };

  
    var faWallBrick = faBlockBrick;
  

  
  

  var faVoicemail = {
    prefix: 'fasl',
    iconName: 'voicemail',
    icon: [
      640,
      512,
      [],
      'f897',
      
      'M144 352a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM288 240c0 45.2-20.9 85.6-53.5 112h171C372.9 325.6 352 285.2 352 240c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144H144C64.5 384 0 319.5 0 240S64.5 96 144 96s144 64.5 144 144zM496 352a112 112 0 1 0 0-224 112 112 0 1 0 0 224z'
      
    ]
  };

  

  
  

  var faPersonArrowDownToLine = {
    prefix: 'fasl',
    iconName: 'person-arrow-down-to-line',
    icon: [
      640,
      512,
      [],
      'e538',
      
      'M168 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 136 56a56 56 0 1 0 112 0zM140.9 128h-9.6l-4.5 8.5-76.9 144-7.5 14.1 28.2 15.1 7.5-14.1L128 202.1V480H16 0v32H16l112 0h32 64 32l368 0h16V480H624 256V202.2l49.9 93.4 7.5 14.1 28.2-15.1-7.5-14.1-76.9-144-4.5-8.5h-9.6H140.9zM224 480H160V352h64V480zm0-160H160V160h64V320zM480 48l0 313.4-68.7-68.7L400 281.4 377.4 304l11.3 11.3 96 96L496 422.6l11.3-11.3 96-96L614.6 304 592 281.4l-11.3 11.3L512 361.4 512 48V32l-32 0V48z'
      
    ]
  };

  

  
  

  var faObjectIntersect = {
    prefix: 'fasl',
    iconName: 'object-intersect',
    icon: [
      512,
      512,
      [],
      'e49d',
      
      'M96 32H32V96H0V32 0H32 96V32zm32 0V0h96V32H128zM0 128H32v96H0V128zM320 32H256V0h64 32V32v96H320V32zm0 128h32v32 64 64 32H320 224 192 160V320 256 192 160h32 96 32zM160 384h32v96h64v32H192 160V480 384zm-32-32H32 0V320 256H32v64h96v32zM384 192V160h96 32v32 64H480V192H384zM288 512V480h96v32H288zm192 0H416V480h64V416h32v64 32H480zm32-128H480V288h32v96zM320 192H192V320H320V192z'
      
    ]
  };

  

  
  

  var faChimney = {
    prefix: 'fasl',
    iconName: 'chimney',
    icon: [
      448,
      512,
      [],
      'f78b',
      
      'M32 64v64H64h96 32H384h32V64H32zm0 96H0V128 64 32H32 416h32V64v64 32H416V272 400v64 16H384V464 416H272 192v48 16H160V464 416H64v48 16H32V464 400 272 160zm32 0v96h96V160H64zm128 0v96h80H384V160H192zM176 384h80V288H176 64v96H176zm112 0h96V288H288v96z'
      
    ]
  };

  

  
  

  var faVialCircleCheck = {
    prefix: 'fasl',
    iconName: 'vial-circle-check',
    icon: [
      512,
      512,
      [],
      'e596',
      
      'M0 32H16 32 64 192h32 16 16V64H240 224V266.8c-20.2 28.6-32 63.5-32 101.2V224H64V384c0 35.3 28.7 64 64 64s64-28.7 64-64V368c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96V64H16 0V32zM64 64V192H192V64H64zM368 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm78.6 112l-11.3 11.3-72 72L352 430.6l-11.3-11.3-40-40L289.4 368 312 345.4l11.3 11.3L352 385.4l60.7-60.7L424 313.4 446.6 336z'
      
    ]
  };

  

  
  

  var faInfinity = {
    prefix: 'fasl',
    iconName: 'infinity',
    icon: [
      640,
      512,
      [8734,9854],
      'f534',
      
      'M0 96H16 192h7.2l4.8 5.4L320 231.9 436 101.4l4.8-5.4H448 624h16v16V400v16H624 448h-7.2l-4.8-5.4L320 280.1 204 410.6l-4.8 5.4H192 16 0V400 112 96zM298.6 256L184.8 128H32V384H184.8L298.6 256zm42.8 0L455.2 384H608V128H455.2L341.4 256z'
      
    ]
  };

  

  
  

  var faCassetteVhs = {
    prefix: 'fasl',
    iconName: 'cassette-vhs',
    icon: [
      576,
      512,
      [128252,"vhs"],
      'f8ec',
      
      'M32 160H544V448H32V160zm0-32V64H544v64H32zm544 16V128 64 32H544 32 0V64v64 16 16V448v32H32 544h32V448 160 144zM136 208h-5.4l-4.3 3.3L136 224c-9.7-12.7-9.7-12.7-9.7-12.7l0 0 0 0-.1 0-.2 .1-.5 .4c-.4 .3-1 .8-1.6 1.3c-1.3 1.1-3.2 2.7-5.3 4.8c-4.3 4.1-9.9 10.2-15.6 18c-11.3 15.5-23 38.8-23 68s11.8 52.5 23 68c5.7 7.8 11.3 13.8 15.6 18c2.1 2.1 4 3.7 5.3 4.8c.7 .6 1.2 1 1.6 1.3l.5 .4 .2 .1 .1 0 0 0 0 0s0 0 9.7-12.7l-9.7 12.7 4.3 3.3H136h72H368h72 5.4l4.3-3.3L440 384c9.7 12.7 9.7 12.7 9.7 12.7l0 0 0 0 .1 0 .2-.1 .5-.4c.4-.3 1-.8 1.6-1.3c1.3-1.1 3.2-2.7 5.3-4.8c4.3-4.1 9.9-10.2 15.6-18c11.3-15.5 23-38.8 23-68s-11.8-52.5-23-68c-5.7-7.8-11.3-13.8-15.6-18c-2.1-2.1-4-3.7-5.3-4.8c-.7-.6-1.2-1-1.6-1.3l-.5-.4-.2-.1-.1 0 0 0 0 0s0 0-9.7 12.7l9.7-12.7-4.3-3.3H440 368 208 136zm4.9 33c.4-.4 .7-.7 1.1-1H192v32c-17.7 0-32 14.3-32 32s14.3 32 32 32v32H141.9c-.3-.3-.7-.7-1.1-1c-3.2-3.1-7.6-7.8-11.9-13.7c-8.7-12.1-17-28.8-17-49.2s8.2-37.2 17-49.2c4.3-6 8.7-10.6 11.9-13.7zM352 368H224V240H352V368zm82.1 0H384V336c17.7 0 32-14.3 32-32s-14.3-32-32-32V240h50.1c.3 .3 .7 .7 1.1 1c3.2 3.1 7.6 7.8 11.9 13.7c8.7 12.1 17 28.8 17 49.2s-8.2 37.2-17 49.2c-4.3 6-8.7 10.6-11.9 13.7l-.5 .5-.6 .5z'
      
    ]
  };

  
    var faVhs = faCassetteVhs;
  

  
  

  var faChartColumn = {
    prefix: 'fasl',
    iconName: 'chart-column',
    icon: [
      512,
      512,
      [],
      'e0e3',
      
      'M32 32V48 448H496h16v32H496 16 0V464 48 32H32zM160 256v16 96 16H128V368 272 256h32zm96-112V368v16H224V368 144 128h32v16zm96 48v16V368v16H320V368 208 192h32zm96-80V368v16H416V368 112 96h32v16z'
      
    ]
  };

  

  
  

  var faHippo = {
    prefix: 'fasl',
    iconName: 'hippo',
    icon: [
      640,
      512,
      [129435],
      'f6ed',
      
      'M427.3 44.7L416 33.4 393.4 56l11.3 11.3 12.1 12.1c-4.4 3.2-8.4 6.8-12 10.8L341.9 65.1 339.1 64H336 224C118 64 32 150 32 256v8 51.2l-29.3 44 26.6 17.8 32-48 2.7-4V320 264v-8c0-88.4 71.6-160 160-160H332.9l55.4 22.1c-2.8 8.1-4.3 16.8-4.3 25.9v20.1c-19.5 16.1-32 40.6-32 67.9c0 45.9 35.1 83.6 80 87.6V352h32V320h88c2.7 0 5.4-.1 8-.4V352h32V310.4c28.5-14.6 48-44.2 48-78.4s-19.5-63.8-48-78.4V144c0-22.4-9.2-42.7-24.1-57.3l11.4-11.4L590.6 64 568 41.4 556.7 52.7 540.2 69.1C531.5 65.8 521.9 64 512 64H464c-5.4 0-10.7 .5-15.8 1.6L427.3 44.7zM464 288H440c-30.9 0-56-25.1-56-56c0-17.4 7.9-32.9 20.4-43.2l11.6-9.6V164.1 144c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48v9.6 19.6l9.3 4.8C545.5 184.4 528 206.2 528 232v16h32V232c0-13.3 10.7-24 24-24s24 10.7 24 24c0 30.9-25.1 56-56 56H464zm-48 96v64H336V363.9 342.1l-20.8 6.5-11.3 3.6c-31.2 9.8-64.6 9.8-95.8 0l-11.3-3.6L176 342.1v21.8V448H96l0-80 0-16-32 0v16l0 96 0 16H80 192h16V464 385.4c31.5 8.1 64.5 8.1 96 0V464v16h16H432h16V464 384H432 416zm64-240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-40 64c13.3 0 24 10.7 24 24v16h32V232c0-30.9-25.1-56-56-56v32zm88-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faTransformerBolt = {
    prefix: 'fasl',
    iconName: 'transformer-bolt',
    icon: [
      384,
      512,
      [],
      'e2a4',
      
      'M128 0H96V16 32H64 48V64H64h96 16V32H160 128V16 0zM288 0H256V16 32H224 208V64h16 96 16V32H320 288V16 0zM64 96H48v32H64h96 16V96H160 64zm160 0H208v32h16 96 16V96H320 224zM16 160H0v32H16 32V480H16 0v32H16 48 336h32 16V480H368 352V192h16 16V160H368 336 48 16zM64 480V192H320V480H64zM216 224h-6.6l-4.7 4.7-104 104L96 337.4V344v8 16h16 38.3l-6.2 62.4L142.3 448H160h8 6.6l4.7-4.7 104-104 4.7-4.7V328v-8V304H272 233.7l6.2-62.4 1.8-17.6H224h-8zM142.6 336l61.9-61.9-4.4 44.3L198.3 336H216h25.4l-61.9 61.9 4.4-44.3 1.8-17.6H168 142.6z'
      
    ]
  };

  

  
  

  var faT = {
    prefix: 'fasl',
    iconName: 't',
    icon: [
      384,
      512,
      [116],
      '54',
      
      'M16 32H0V64H16 176V464v16h32V464 64H368h16V32H368 192 16z'
      
    ]
  };

  

  
  

  var faOilCan = {
    prefix: 'fasl',
    iconName: 'oil-can',
    icon: [
      640,
      512,
      [],
      'f613',
      
      'M272 96h80V64H160V96h80v64H128 96 32 0v32V304l96 48v32 32h32H384h48L640 192l-32-32L448 192l-64-32H272V96zM32 192H96V316.2l-64-32V192zm401.7 28.6l9.8 4.9 10.8-2.2 138.7-27.7L418 384H384 128V368 332.2 192H376.4l57.2 28.6z'
      
    ]
  };

  

  
  

  var faUpRightAndDownLeftFromCenter = {
    prefix: 'fasl',
    iconName: 'up-right-and-down-left-from-center',
    icon: [
      512,
      512,
      ["expand-alt"],
      'f424',
      
      'M232 184l22.6-22.6 50.7-50.7L328 88 305.4 65.4l-2.7-2.7L280 40l22.6-22.6L320 0H480h32V32 192l-17.4 17.4L472 232l-22.6-22.6-2.7-2.7L424 184l-22.6 22.6-50.7 50.7L328 280l-22.6-22.6-50.7-50.7L232 184zM350.6 65.4L373.3 88l-22.6 22.6L277.3 184 328 234.7l73.4-73.4L424 138.7l22.6 22.6L472 186.7l8-8V32H333.3l-8 8 25.4 25.4zM280 328l-22.6 22.6-50.7 50.7L184 424l22.6 22.6 2.7 2.7L232 472l-22.6 22.6L192 512H32 0V480 320l17.4-17.4L40 280l22.6 22.6 2.7 2.7L88 328l22.6-22.6 50.7-50.7L184 232l22.6 22.6 50.7 50.7L280 328zM161.4 446.6L138.7 424l22.6-22.6L234.7 328 184 277.3l-73.4 73.4L88 373.3 65.4 350.6 40 325.3l-8 8V480H178.7l8-8-25.4-25.4z'
      
    ]
  };

  
    var faExpandAlt = faUpRightAndDownLeftFromCenter;
  

  
  

  var faHashtag = {
    prefix: 'fasl',
    iconName: 'hashtag',
    icon: [
      448,
      512,
      [62098],
      '23',
      
      'M445.9 144H432 346.3L372.1 32H339.3L313.4 144H186.3L212.1 32H179.3L153.4 144H48 46.9l-6.4 32H48h98L109.1 336H16 8.5L2.1 368H16h85.7L75.9 480h32.8l25.8-112H261.7L235.9 480h32.8l25.8-112H400h1.1l6.4-32H400 302l36.9-160H432h7.5l6.4-32zm-267 32H306L269.1 336H142l36.9-160z'
      
    ]
  };

  

  
  

  var faFaceExplode = {
    prefix: 'fasl',
    iconName: 'face-explode',
    icon: [
      512,
      512,
      ["exploding-head"],
      'e2fe',
      
      'M136 144c-22.1 0-40-17.9-40-40s17.9-40 40-40c.5 0 1.1 0 1.6 0C150 64.5 161 70.7 168 80c0-12.5 4.8-23.9 12.7-32.5C189.4 38 202 32 216 32c5 0 9.9 .8 14.4 2.2C241 37.5 250 44.4 256 53.5c6-9 15-15.9 25.6-19.3C286.1 32.8 291 32 296 32c12.3 0 23.5 4.6 31.9 12.2c8.1 7.2 13.7 17.1 15.5 28.3c6.8-5.3 15.3-8.4 24.6-8.4c2.2 0 4.4 .2 6.5 .5c19 3.1 33.5 19.6 33.5 39.5c0 22.1-17.9 40-40 40H320 288v32 32h32V176h48c39.8 0 72-32.2 72-72s-32.2-72-72-72c-2.6 0-5.2 .1-7.7 .4C345.7 12.7 322.4 0 296 0c-14.6 0-28.2 3.9-40 10.7C244.2 3.9 230.6 0 216 0c-26.9 0-50.6 13.2-65.1 33.5c-4.8-1-9.8-1.5-14.9-1.5c-39.8 0-72 32.2-72 72s32.2 72 72 72h56v32h32V176h16V144H224 200h-8H176.1 136zM0 256c0 11.1 .7 22 2.1 32.7C18.1 414.7 125.7 512 256 512s237.9-97.3 253.9-223.3c1.4-10.7 2.1-21.6 2.1-32.7l0-1.8-5.3 1.8-23.1 8-3.6-2-53.3-30-56.9 32-56.9-32L256 264l-56.9-32-56.9 32L85.3 232 32.1 262l-3.6 2L5.3 256 0 254.2 0 256zm467.9 35.9l8.5 4.8C457.2 401 365.8 480 256 480S54.8 401 35.7 296.6l8.5-4.8 41.2-23.2 41.2 23.2 15.7 8.8 15.7-8.8 41.2-23.2 41.2 23.2 15.7 8.8 15.7-8.8 41.2-23.2 41.2 23.2 15.7 8.8 15.7-8.8 41.2-23.2 41.2 23.2zM176.4 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM256 352c-35.3 0-64 28.7-64 64v16 16h16 96 16V432 416c0-35.3-28.7-64-64-64zm-32 64c0-17.7 14.3-32 32-32s32 14.3 32 32H224z'
      
    ]
  };

  
    var faExplodingHead = faFaceExplode;
  

  
  

  var faSquareXmark = {
    prefix: 'fasl',
    iconName: 'square-xmark',
    icon: [
      448,
      512,
      [10062,"times-square","xmark-square"],
      'f2d3',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM159.4 168.8l11.3 11.3L224 233.4l53.3-53.3 11.3-11.3 22.6 22.6-11.3 11.3L246.6 256l53.3 53.3 11.3 11.3-22.6 22.6-11.3-11.3L224 278.6l-53.3 53.3-11.3 11.3-22.6-22.6 11.3-11.3L201.4 256l-53.3-53.3-11.3-11.3 22.6-22.6z'
      
    ]
  };

  
    var faTimesSquare = faSquareXmark;
  
    var faXmarkSquare = faSquareXmark;
  

  
  

  var faFacePouting = {
    prefix: 'fasl',
    iconName: 'face-pouting',
    icon: [
      512,
      512,
      [],
      'e387',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm107.2-93.6l-4.2-28c-7.4-49.3-51-86.5-103-86.5s-95.6 37.1-103 86.4l-4.2 28L175 407.5c23.7-9.8 51.3-15.5 81-15.5c29.7 0 57.4 5.7 81.1 15.6l26.1 10.9zm-46.9-51.2c-19-4.7-39.3-7.2-60.3-7.2c-21 0-41.3 2.5-60.3 7.2C208.5 348.5 230.6 336 256 336s47.5 12.5 60.3 31.2zM176.4 264c13.3 0 24-10.7 24-24c0-2.6-.4-5.1-1.2-7.4l19.7 6.6 15.2 5.1 10.1-30.4-15.2-5.1-96-32-15.2-5.1-10.1 30.4 15.2 5.1 39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6c0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13 15.2-5.1-10.1-30.4-15.2 5.1-96 32-15.2 5.1 10.1 30.4 15.2-5.1 20.6-6.9c-.8 2.4-1.3 5-1.3 7.7c0 13.3 10.7 24 24 24s24-10.7 24-24z'
      
    ]
  };

  

  
  

  var faContainerStorage = {
    prefix: 'fasl',
    iconName: 'container-storage',
    icon: [
      640,
      512,
      [],
      'f4b7',
      
      'M16 32H0V64H16 32V448H16 0v32H16 32 64 576h32 16 16V448H624 608V64h16 16V32H624 608 576 64 32 16zM64 448V64H576V448H64zM192 144V128H160v16V368v16h32V368 144zm96 0V128H256v16V368v16h32V368 144zm96 0V128H352v16V368v16h32V368 144zm96 0V128H448v16V368v16h32V368 144z'
      
    ]
  };

  

  
  

  var faEarthOceania = {
    prefix: 'fasl',
    iconName: 'earth-oceania',
    icon: [
      512,
      512,
      ["globe-oceania"],
      'e47b',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM395.3 387.3l-24 24L360 422.6 337.4 400l11.3-11.3 24-24L384 353.4 406.6 376l-11.3 11.3zM288 416v32H224V416h64zM432 256v64H400V256h32zM137.4 208H144h32 16v16 16h32V224 208h16 32 6.6l4.7 4.7 48 48 4.7 4.7V272v96 16H320 224h-6.6l-4.7-4.7L185.4 352H96 80V336 272v-6.6l4.7-4.7 48-48 4.7-4.7zM256 240v16 16H240 176 160V256 240h-9.4L112 278.6V320h80 6.6l4.7 4.7L230.6 352H304V278.6L265.4 240H256zm-64-96V112 80h32 64 32v32 32 32H288 224l-32-32zm96-32H224v18.7L237.3 144H288V112z'
      
    ]
  };

  
    var faGlobeOceania = faEarthOceania;
  

  
  

  var faGopuram = {
    prefix: 'fasl',
    iconName: 'gopuram',
    icon: [
      512,
      512,
      [],
      'f664',
      
      'M128 0V16 32h64V16 0h32V16 32h64V16 0h32V16 32h64V16 0h32V16 32 64 80 96v32h32v32 64h32v32 96h32v32 96 32H480 320 288 224 192 32 0V480 384 352H32V256 224H64V160 128H96V96 80 64 32 16 0h32zm96 480h64c0-17.7-14.3-32-32-32s-32 14.3-32 32zm96 0h64V384H352 304 272 240 208 160 128v96h64c0-35.3 28.7-64 64-64s64 28.7 64 64zM128 80V96v32H384V96 80 64H128V80zm288 80H384 352v64h64V160zm-64 96H320 272 240 192 160v96h48V336c0-26.5 21.5-48 48-48s48 21.5 48 48v16h48V256zm-32-32V160H192v64h48V208c0-8.8 7.2-16 16-16s16 7.2 16 16v16h48zM272 352V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h32zM128 160H96v64h64V160H128zm288 96H384v96h64V256H416zm64 224V384H448 416v96h64zM128 256H96 64v96h64V256zM96 480V384H64 32v96H96z'
      
    ]
  };

  

  
  

  var faMelon = {
    prefix: 'fasl',
    iconName: 'melon',
    icon: [
      512,
      512,
      [],
      'e310',
      
      'M480 256c0-46.8-14.4-90.3-39-126.3c-1 54.3-16.9 140.4-93.9 217.4s-163.1 92.9-217.4 93.9c36 24.6 79.4 39 126.3 39c123.7 0 224-100.3 224-224zM76.6 390.2c4.5-58.5 22.3-159.3 88.2-225.3c72.7-72.7 165.2-88.8 221.4-91.1C349.6 47.5 304.6 32 256 32C132.3 32 32 132.3 32 256c0 50.3 16.6 96.8 44.6 134.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM160.5 406.7c46.9-6.2 107.9-26.1 164-82.2s76.1-117 82.2-164c2.9-22.2 2.7-41.2 1.7-55c-15.2-.3-36.4 .4-60.7 4.1c-49.7 7.7-110.5 28.1-160.2 77.9c-42.2 42.2-62.9 102.6-72.6 155.7c-4.7 25.7-6.6 48.7-7.4 65.4c13.6 .9 31.9 .9 52.9-1.9z'
      
    ]
  };

  

  
  

  var faLightbulbCflOn = {
    prefix: 'fasl',
    iconName: 'lightbulb-cfl-on',
    icon: [
      640,
      512,
      [],
      'e5a7',
      
      'M35.2 7.7l52 26 14.3 7.2L87.2 69.5 72.8 62.3l-52-26L6.5 29.2 20.8 .5 35.2 7.7zm584 28.6l-52 26-14.3 7.2L538.5 40.8l14.3-7.2 52-26L619.2 .5l14.3 28.6-14.3 7.2zM16 160H80 96v32H80 16 0V160H16zm544 0h64 16v32H624 560 544V160h16zM87.2 318.3l-52 26-14.3 7.2L6.5 322.8l14.3-7.2 52-26 14.3-7.2 14.3 28.6-14.3 7.2zm465.7-35.8l14.3 7.2 52 26 14.3 7.2-14.3 28.6-14.3-7.2-52-26-14.3-7.2 14.3-28.6zM320 7.5V28 87.5l140.1-35 19.9-5V68v59.5V148v12.5 47l0 0V228v80 12.5l-12.1 3-99.9 25V384h16 32v32 32 32H384 336v16 16H304V496 480H256 224V448 416 384h32 16V341.5l32-8V384h32V336 323.5l12.1-3 99.9-25v-47l-92.1 23-64 16-.1 0-111.9 28-19.9 5V300 240.5 220 207.5v-47V140v0V127.5 60 47.5l12.1-3 128-32 19.9-5zm-35.9 249l163.9-41v-47l-256 64v47l92.1-23zm23.8-133L192 152.5v47l256-64v-47l-128 32-12.1 3zM288 48.5l-96 24v47l96-24v-47zM384 416H256v32h48 32 48V416z'
      
    ]
  };

  

  
  

  var faCardHeart = {
    prefix: 'fasl',
    iconName: 'card-heart',
    icon: [
      384,
      512,
      [],
      'e3eb',
      
      'M32 32V480H352V32H32zM0 0H32 352h32V32 480v32H352 32 0V480 32 0zM184.3 177.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L192 352.1l-11.1-10.7L98.2 261.8C86.6 250.7 80 235.3 80 219.2c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2zm79.3 61.6c5.3-5.1 8.3-12.2 8.3-19.6c0-15-12.2-27.2-27.2-27.2h-2.4c-7.7 0-15 3-20.5 8.3l-7.7 7.4L192 229l-22.2-21.3-7.7-7.4c-5.5-5.3-12.9-8.3-20.5-8.3h-2.4c-15 0-27.2 12.2-27.2 27.2c0 7.4 3 14.5 8.3 19.6L192 307.7l71.7-68.9z'
      
    ]
  };

  

  
  

  var faShieldHeart = {
    prefix: 'fasl',
    iconName: 'shield-heart',
    icon: [
      512,
      512,
      [],
      'e574',
      
      'M48.5 114.9L256 34.3l207.5 80.5c2.7 45.6-4.5 116.8-34.7 186.3S345.4 438.4 256 477.1C166.6 438.4 113.4 370.7 83.2 301.2S45.8 160.5 48.5 114.9zm447-1.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM245.8 166.1c-12.7-12.5-29.8-19.5-47.6-19.5h-1.3c-36.8 0-66.6 29.8-66.6 66.6c0 17.9 7.2 35 19.9 47.5l94.6 92.9 11.2 11 11.2-11 94.6-92.9c12.8-12.5 19.9-29.6 19.9-47.5c0-36.8-29.8-66.6-66.6-66.6h-1.3c-17.8 0-34.9 7-47.6 19.5l-10.2 10-10.2-10zM172.6 238c-6.6-6.5-10.4-15.4-10.4-24.7c0-19.1 15.5-34.6 34.6-34.6h1.3c9.4 0 18.4 3.7 25.2 10.3l10.2 10L256 221l22.4-22 10.2-10c6.7-6.6 15.8-10.3 25.2-10.3h1.3c19.1 0 34.6 15.5 34.6 34.6c0 9.3-3.7 18.2-10.4 24.7L256 319.8 172.6 238z'
      
    ]
  };

  

  
  

  var faVacuum = {
    prefix: 'fasl',
    iconName: 'vacuum',
    icon: [
      640,
      512,
      [],
      'e04d',
      
      'M237 32H528c44.2 0 80 35.8 80 80c0 34.8-22.2 64.4-53.2 75.4C519.9 150.8 470.6 128 416 128H384 352v32V292c10.2-2.6 21-4 32-4V160h32c88.4 0 160 71.6 160 160V480H494.9c-7 12-15.8 22.8-26.2 32H576h32V480 320c0-39.5-11.9-76.1-32.3-106.6c38-17.9 64.3-56.6 64.3-101.4C640 50.1 589.9 0 528 0H224 211l-2.7 12.7L164.3 224H197L237 32zM190.3 256H157.7L131 384H64L0 448v32 32H32 192h32V480 416 384H192 163.7l26.7-128zM77.3 416h66.4c.2 0 .4 0 .6 0H192v64H32V461.3L77.3 416zM384 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm24-96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faBroom = {
    prefix: 'fasl',
    iconName: 'broom',
    icon: [
      576,
      512,
      [129529],
      'f51a',
      
      'M340 212L552 0l24 24L364 236l52 52v32l-75.9 12.6 1.4 9.8c6.6 46.3-9 93-42 126c-27.8 27.8-65.6 43.5-105 43.5L32 512H0V480l64-64 32-32H64v-2.5 0c0-3.7 .1-7.5 .4-11.2c.5-6.2 1.3-12.3 2.5-18.3c5.8-28.4 19.7-54.7 40.5-75.5c33.1-33.1 79.7-48.6 126-42l9.8 1.4L256 160h32l52 52zM306.3 322.3l-52.6-52.6L229 266.2c-36.3-5.2-72.9 7-98.9 33c-14.7 14.7-25.1 33-30.3 52.9h73.5l-54.6 54.6L45.3 480l149.2 0c30.9 0 60.5-12.3 82.4-34.1c25.9-25.9 38.1-62.6 33-98.9l-3.5-24.7zm70.5-28.2l-94.9-94.9-7.2 43.5 58.7 58.7 43.5-7.2z'
      
    ]
  };

  

  
  

  var faCoinBlank = {
    prefix: 'fasl',
    iconName: 'coin-blank',
    icon: [
      512,
      512,
      [],
      'e3fb',
      
      'M90.7 281.9C49 258.5 32 231.1 32 208s17-50.5 58.7-73.9C131.4 111.2 189.8 96 256 96s124.6 15.2 165.3 38.1C463 157.5 480 184.9 480 208s-17 50.5-58.7 73.9C380.6 304.8 322.2 320 256 320s-124.6-15.2-165.3-38.1zM240 351.7l0 64c-22.5-.7-44-3-64-6.6l0-64.3c20.3 3.8 41.8 6.1 64 6.9zM96 320.4c14.8 6.7 30.8 12.4 48 17.1l0 64.6c-17.7-4.7-33.8-10.5-48-17l0-64.7zM64 303.2l0 63.6c-23.5-16.9-32-34-32-46.8l0-42.2c9 9.2 19.8 17.7 32 25.5zM272 415.7l0-64c22.2-.8 43.7-3.1 64-6.9l0 64.3c-20 3.6-41.5 5.8-64 6.6zM448 303.2c12.2-7.8 23-16.3 32-25.5l0 42.2c0 12.9-8.5 29.9-32 46.8l0-63.6zm-32 17.2l0 64.7c-14.2 6.5-30.3 12.3-48 17l0-64.6c17.2-4.7 33.2-10.5 48-17.1zM256 64C114.6 64 0 128.5 0 208l0 32 0 80c0 70.7 114.6 128 256 128s256-57.3 256-128l0-80 0-32c0-79.5-114.6-144-256-144z'
      
    ]
  };

  

  
  

  var faCircleArrowUpLeft = {
    prefix: 'fasl',
    iconName: 'circle-arrow-up-left',
    icon: [
      512,
      512,
      [],
      'e0fb',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 160H160v16V320v16h32V320 214.6L324.7 347.3 336 358.6 358.6 336l-11.3-11.3L214.6 192H312h16V160H312 176z'
      
    ]
  };

  

  
  

  var faCircleG = {
    prefix: 'fasl',
    iconName: 'circle-g',
    icon: [
      512,
      512,
      [],
      'e10f',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 256c0-53 43-96 96-96c24.6 0 47 9.2 64 24.4l11.9 10.7 21.3-23.8-11.9-10.7C318.7 140.3 288.8 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128V240H368 288 272v32h16 62.7c-7.6 45.4-47.1 80-94.7 80c-53 0-96-43-96-96z'
      
    ]
  };

  

  
  

  var faSkeleton = {
    prefix: 'fasl',
    iconName: 'skeleton',
    icon: [
      512,
      512,
      [],
      'f620',
      
      'M272 0V16 64H416h16V96H416 272v64H480h16v32H480 272v64H384h16v32H384 272v75.4L368 336h48 32v32 72l-64 72H128L64 440V368 336H96h48l96 27.4V288H128 112V256h16H240V192H32 16V160H32 240V96H96 80V64H96 240V16 0h32zM372.5 368L264.8 398.8l-8.8 2.5-8.8-2.5L139.5 368H96v59.8L142.4 480H369.6L416 427.8V368H372.5zM160 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faDisplayChartUpCircleCurrency = {
    prefix: 'fasl',
    iconName: 'display-chart-up-circle-currency',
    icon: [
      640,
      512,
      [],
      'e5e5',
      
      'M32 32H544V198.6c11.2 3.2 21.9 7.4 32 12.6V32 0H544 32 0V32 384v32H32 213.1l-10.7 64H144 128v32h16 72H360h34.8c-12.9-9.1-24.5-19.9-34.6-32H341.1 288 234.9l10.7-64H288h38.6c-2.9-10.3-4.9-21-5.9-32H232.3c-.2 0-.4 0-.6 0H32V32zM480 192.7V112 96H464 368 352v32h16 57.4L304 249.4l-68.7-68.7L224 169.4l-11.3 11.3-112 112L89.4 304 112 326.6l11.3-11.3L224 214.6l68.7 68.7L304 294.6l11.3-11.3L448 150.6v48c10.3-2.9 21-4.9 32-5.9zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM470.6 342.6a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1 -50.7-50.7zM531.3 426l17.3 17.3 22.6-22.6L554 403.3c13.2-21.6 13.2-49.1 0-70.7l17.3-17.3-22.6-22.6L531.3 310c-21.6-13.2-49.1-13.2-70.7 0l-17.3-17.3-22.6 22.6L438 332.7c-13.2 21.6-13.2 49.1 0 70.7l-17.3 17.3 22.6 22.6L460.7 426c21.6 13.2 49.1 13.2 70.7 0z'
      
    ]
  };

  

  
  

  var faPersonBiking = {
    prefix: 'fasl',
    iconName: 'person-biking',
    icon: [
      640,
      512,
      [128692,"biking"],
      'f84a',
      
      'M392 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 392 0a56 56 0 1 0 0 112zM224 384A96 96 0 1 1 32 384a96 96 0 1 1 192 0zM128 256a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM608 384a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM512 256a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM330.7 124.1l-10.4-9.4-10.7 9.1-80.4 68.9c-23.9 20.5-21.9 58.1 4 76L320 328.4V416v16h32V416 320v-8.4l-6.9-4.8-93.7-64.4c-8.7-6-9.3-18.5-1.3-25.3l69.7-59.8 69.6 62.6 4.6 4.1H400h80 16V192H480 406.1l-75.4-67.9z'
      
    ]
  };

  
    var faBiking = faPersonBiking;
  

  
  

  var faTemperatureLow = {
    prefix: 'fasl',
    iconName: 'temperature-low',
    icon: [
      512,
      512,
      [],
      'f76b',
      
      'M416 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 416 0a64 64 0 1 0 0 128zM101.3 284.5L112 275V260.7 32H240V260.7 275l10.7 9.5c23 20.6 37.3 50.3 37.3 83.5c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-33.2 14.4-62.9 37.3-83.5zM272 0H240 112 80V32 260.7C50.5 287.1 32 325.4 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-42.6-18.5-81-48-107.3V32 0zM144 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V272 256H160v16 34c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  

  
  

  var faCodeCommit = {
    prefix: 'fasl',
    iconName: 'code-commit',
    icon: [
      640,
      512,
      [],
      'f386',
      
      'M224 160v80 32 80H416V272 240 160H224zm-32 80V160 128h32H416h32v32 80H624h16v32H624 448v80 32H416 224 192V352 272H16 0V240H16 192z'
      
    ]
  };

  

  
  

  var faFileMusic = {
    prefix: 'fasl',
    iconName: 'file-music',
    icon: [
      384,
      512,
      [],
      'f8b6',
      
      'M32 480V32H192V176v16h16H352V480H32zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zm72 232V208.9L282.4 217l-128 48L144 268.9V280v90.5c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V291.1l96-36v83.4c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V232zM144 412c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12zm112-20c-11.5 0-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12s-4.5 12-16 12z'
      
    ]
  };

  

  
  

  var faClockOne = {
    prefix: 'fasl',
    iconName: 'clock-one',
    icon: [
      512,
      512,
      [],
      'e34e',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112v91.2l34.7-52 8.9-13.3 26.6 17.8-8.9 13.3-64 96L240 256V112 96h32v16z'
      
    ]
  };

  

  
  

  var faCompassSlash = {
    prefix: 'fasl',
    iconName: 'compass-slash',
    icon: [
      640,
      512,
      [],
      'f5e9',
      
      'M448.8 439.3C412.4 464.9 368 480 320 480C196.3 480 96 379.7 96 256c0-29.3 5.6-57.2 15.8-82.8L85.7 152.6C71.8 184.2 64 219.2 64 256c0 141.4 114.6 256 256 256c58.2 0 111.9-19.4 154.9-52.2l-26.1-20.6zM320 0C261.8 0 208.1 19.4 165.1 52.2l26.1 20.6C227.6 47.1 272 32 320 32c123.7 0 224 100.3 224 224c0 29.3-5.6 57.2-15.8 82.8l26.1 20.6c14-31.6 21.7-66.6 21.7-103.4C576 114.6 461.4 0 320 0zM204.6 346.1L192 384l37.9-12.6 93.4-31.1-30-23.7-50.7 16.9 15-45.1-26.7-21.1-26.3 78.8zm112-174.3l30 23.7 50.7-16.9-15 45.1 26.7 21.1 26.3-78.8L448 128l-37.9 12.6-93.4 31.1zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faMusic = {
    prefix: 'fasl',
    iconName: 'music',
    icon: [
      512,
      512,
      [127925],
      'f001',
      
      'M512 24V2.5L491.4 8.7l-320 96L160 108.1V120 240 372.4C143 359.7 120.6 352 96 352c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80c0 0 0 0 0 0V251.6L480 158V308.4c-17-12.7-39.4-20.4-64-20.4c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80c0 0 0 0 0 0V136 24zM480 368s0 0 0 0c0 21.3-22.9 48-64 48s-64-26.7-64-48s22.9-48 64-48s64 26.7 64 48zM160 432s0 0 0 0c0 21.3-22.9 48-64 48s-64-26.7-64-48s22.9-48 64-48s64 26.7 64 48zM480 124.4L192 218V131.9L480 45.5v78.9z'
      
    ]
  };

  

  
  

  var faYinYang = {
    prefix: 'fasl',
    iconName: 'yin-yang',
    icon: [
      512,
      512,
      [9775],
      'f6ad',
      
      'M480 256c0 123.7-100.3 224-224 224c-57.4 0-104-46.6-104-104s46.6-104 104-104c75.1 0 136-60.9 136-136c0-26.5-7.6-51.2-20.6-72C436.5 103.1 480 174.5 480 256zM256 32c57.4 0 104 46.6 104 104s-46.6 104-104 104c-75.1 0-136 60.9-136 136c0 26.5 7.6 51.2 20.6 72C75.5 408.9 32 337.5 32 256C32 132.3 132.3 32 256 32zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 376l32 32 32-32-32-32-32 32zm32-272l-32 32 32 32 32-32-32-32z'
      
    ]
  };

  

  
  

  var faSendBackward = {
    prefix: 'fasl',
    iconName: 'send-backward',
    icon: [
      512,
      512,
      [],
      'f87f',
      
      'M32 32H320v96h32V32 0H320 32 0V32 320v32H32h96V320H32V32zM288 96V64H256 96 64V96 256v32H96h32V256H96V96H256v32h32V96zm-96 96H480V480H192V192zm-32-32v32V480v32h32H480h32V480 192 160H480 192 160z'
      
    ]
  };

  

  
  

  var faCheese = {
    prefix: 'fasl',
    iconName: 'cheese',
    icon: [
      512,
      512,
      [],
      'f7ef',
      
      'M32 448H480V288H32V448zM52.1 256H480c0-102.5-80.3-186.2-181.4-191.7L52.1 256zM0 256L288 32c123.7 0 224 100.3 224 224V448v32H480 32 0V448 256z'
      
    ]
  };

  

  
  

  var faSquareStar = {
    prefix: 'fasl',
    iconName: 'square-star',
    icon: [
      448,
      512,
      [],
      'e27f',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm242.1 98.3l30.8 58.4L338 199.9l38.2 6.6-27 27.8-46 47.4 9.4 65.4 5.5 38.4-34.8-17.1L224 339.2l-59.3 29.1L130 385.4l5.5-38.4 9.4-65.4-46-47.4-27-27.8 38.2-6.6 65.1-11.3 30.8-58.4L224 96l18.1 34.3zm25.4 89.9l-15.5-2.7-7.3-13.9-20.6-39-20.6 39-7.3 13.9-15.5 2.7L137 227.7l30.8 31.7 11 11.3-2.2 15.6L170.3 330l39.6-19.5 14.1-6.9 14.1 6.9L277.7 330l-6.3-43.7-2.2-15.6 11-11.3L311 227.7l-43.5-7.5z'
      
    ]
  };

  

  
  

  var faWineGlassEmpty = {
    prefix: 'fasl',
    iconName: 'wine-glass-empty',
    icon: [
      320,
      512,
      ["wine-glass-alt"],
      'f5ce',
      
      'M46.4 195.6L61.2 32H258.8l14.9 163.6C279.7 262.4 227.1 320 160 320S40.3 262.4 46.4 195.6zM176 351.1c78.1-8.5 136.8-78.3 129.5-158.5L288 0H32L14.5 192.7C7.2 272.8 65.9 342.7 144 351.1V480H80 64v32H80h80 80 16V480H240 176V351.1z'
      
    ]
  };

  
    var faWineGlassAlt = faWineGlassEmpty;
  

  
  

  var faPenSlash = {
    prefix: 'fasl',
    iconName: 'pen-slash',
    icon: [
      640,
      512,
      [],
      'e213',
      
      'M553.4 150.6L576 128l-22.6-22.6L470.6 22.6 448 0 425.4 22.6 294 154l25.3 20 60-60 82.7 82.7-50.3 50.3 25.3 20L553.4 150.6zM320.7 338.1L208.2 450.5 104.8 471.2l20.7-103.4L228.2 265.1l-25.3-20L96 352 70.8 478 64 512l34-6.8L224 480 346 358l-25.3-20zm164-164L401.9 91.3 448 45.3 530.7 128l-46.1 46.1zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faMoon = {
    prefix: 'fasl',
    iconName: 'moon',
    icon: [
      384,
      512,
      [9214,127769],
      'f186',
      
      'M287.6 41.2c-19.7-5.8-40.6-9-62.2-9.2c-.5 0-1 0-1.5 0C100.3 32 0 132.3 0 256S100.3 480 224 480c40 0 77.5-10.5 110-28.8c.4-.2 .8-.5 1.2-.7c17.9-10.3 34.3-22.9 48.6-37.6c-15.5 4.1-31.8 6.2-48.6 6.2c-3.2 0-6.4-.1-9.6-.2c-101.3-5-181.9-89-181.9-191.8c0-68.7 36-129 90.2-163c16.4-10.3 34.5-18.1 53.8-23.1zM175.9 70.1c-39.7 40.4-64.2 95.9-64.2 157.1c0 101.6 67.5 187.4 160 214.8c-15.2 3.9-31.2 6-47.7 6C118 448 32 362 32 256C32 166.6 93.1 91.4 175.9 70.1z'
      
    ]
  };

  

  
  

  var faArrowUpFromLine = {
    prefix: 'fasl',
    iconName: 'arrow-up-from-line',
    icon: [
      384,
      512,
      [8613,"arrow-from-bottom"],
      'f342',
      
      'M203.3 44.7L192 33.4 180.7 44.7l-128 128L41.4 184 64 206.6l11.3-11.3L176 94.6 176 368l0 16 32 0 0-16 0-273.4L308.7 195.3 320 206.6 342.6 184l-11.3-11.3-128-128zM16 448L0 448l0 32 16 0 352 0 16 0 0-32-16 0L16 448z'
      
    ]
  };

  
    var faArrowFromBottom = faArrowUpFromLine;
  

  
  

  var faCarrot = {
    prefix: 'fasl',
    iconName: 'carrot',
    icon: [
      512,
      512,
      [129365],
      'f787',
      
      'M336 24l10-12.5L334.8 2.6 324.7 12.7 336 24zM488 176c12.5-10 12.5-10 12.5-10l0 0 0 0 0-.1-.1-.2-.4-.5c-.3-.4-.8-.9-1.4-1.6c-1.2-1.3-2.8-3.1-4.9-5.2c-4.2-4.2-10.4-9.8-18.3-15.5c-15.6-11.1-38.8-23-67.3-23c-6.3 0-11.9 .3-16.8 .8c.5-4.9 .8-10.5 .8-16.8c0-28.5-11.8-51.7-23-67.3c-5.6-7.9-11.2-14-15.5-18.3c-2.1-2.1-3.9-3.8-5.2-4.9c-.7-.6-1.2-1-1.6-1.4l-.5-.4-.2-.1-.1 0 0 0 0 0s0 0-10 12.5c-11.3-11.3-11.3-11.3-11.3-11.3l0 0 0 0 0 0-.1 .1-.4 .4c-.4 .4-.9 .9-1.5 1.5c-1.2 1.3-2.9 3.2-5 5.6c-4.1 4.7-9.5 11.5-14.9 19.7C292.2 55.9 280 79.2 280 104c0 13.9 .8 25.7 3.2 36.5c-10.6-2.9-21.8-4.5-33.4-4.5c-49.8 0-94.9 29.3-115.2 74.7L19.6 468.2 0 512l43.8-19.6L301.3 377.4c45.4-20.3 74.7-65.4 74.7-115.2c0-11.5-1.6-22.7-4.5-33.4c10.7 2.4 22.6 3.2 36.5 3.2c24.8 0 48.1-12.2 63.9-22.7c8.2-5.4 14.9-10.9 19.7-14.9c2.4-2 4.3-3.8 5.6-5c.7-.6 1.2-1.1 1.5-1.5l.4-.4 .1-.1 0 0 0 0 0 0s0 0-11.3-11.3zm0 0l12.5-10 8.9 11.2-10.1 10.1L488 176zM356.7 132.7c0 0 0 0 11.3 11.3s11.3 11.3 11.3 11.3l0 0 0 0-.1 .1-.2 .2-.3 .3c-.2 .2-.3 .3-.5 .4c-.1 .1-.2 .2-.3 .2c0 0 0 0 0 0c.2-.1 1.1-.6 3.1-1.3c4-1.3 12.2-3.2 26.9-3.2c19.5 0 36.3 8.1 48.7 17c2.9 2.1 5.5 4.2 7.8 6.1c-3 2.4-6.6 5-10.4 7.5C439.9 192.2 423.2 200 408 200c-19.2 0-30.6-1.8-39.6-5.5c-9-3.7-17.2-9.9-29-21.8s-18.1-20.1-21.8-29c-3.7-9.1-5.5-20.4-5.5-39.6c0-15.2 7.8-31.9 17.3-46.1c2.6-3.9 5.2-7.4 7.5-10.4c2 2.3 4.1 4.9 6.1 7.8c8.9 12.4 17 29.2 17 48.7c0 14.7-1.8 22.9-3.2 26.9c-.7 2-1.2 2.9-1.3 3.1c0 0 0 0 0 0s.1-.1 .2-.3c.1-.1 .2-.3 .4-.5l.3-.3 .2-.2 .1-.1 0 0 0 0zM63.4 448.6l92.2-206.4 25.1 25.1L192 278.6 214.6 256l-11.3-11.3-33-33c17.1-26.9 47-43.7 79.5-43.7c52 0 94.2 42.2 94.2 94.2c0 37.2-21.8 70.8-55.8 86L168.4 401.7l-21-21L136 369.4 113.4 392l11.3 11.3 12.4 12.4L63.4 448.6z'
      
    ]
  };

  

  
  

  var faAmpersand = {
    prefix: 'fasl',
    iconName: 'ampersand',
    icon: [
      448,
      512,
      [],
      '26',
      
      'M96 32H80V48v80.6c0 24.3 9.2 47.6 25.7 65.4L152 243.7 72.9 299C47.3 317 32 346.3 32 377.7V464v16H48 256h8l4.8-6.4 43.3-57.7L371.7 480h43.7l-83.8-90.1 81.2-108.3-25.6-19.2L309.5 366.1l-109-117.2L263.1 205c25.7-18 40.9-47.3 40.9-78.6V48 32H288 96zM244.7 178.8l-66.3 46.4-49.3-53c-11-11.8-17.1-27.4-17.1-43.6V64H272v62.3c0 20.9-10.2 40.5-27.3 52.4zM91.3 325.2L174 267.4l116 124.7L248 448H64V377.7c0-20.9 10.2-40.5 27.3-52.4z'
      
    ]
  };

  

  
  

  var faAtomSimple = {
    prefix: 'fasl',
    iconName: 'atom-simple',
    icon: [
      512,
      512,
      ["atom-alt"],
      'f5d3',
      
      'M175.1 438.1c-50.8 16.9-82.3 10.1-96.7-4.4s-21.3-46-4.4-96.7c5.4-16.2 12.9-33.3 22.5-50.9c16.8 23.8 36.7 47.4 59.4 70.1s46.3 42.6 70.1 59.4c-17.6 9.6-34.7 17.2-50.9 22.5zM55.7 55.7C16.5 94.9 27.6 173.9 76.8 256C27.6 338.1 16.5 417.1 55.7 456.3s118.2 28.1 200.3-21.1c82.1 49.2 161.1 60.3 200.3 21.1s28.1-118.2-21.1-200.3c49.2-82.1 60.3-161.1 21.1-200.3S338.1 27.6 256 76.8C173.9 27.6 94.9 16.5 55.7 55.7zM178.5 333.5c-25.3-25.3-46.6-51.6-63.8-77.5c17.2-25.9 38.6-52.3 63.8-77.5s51.6-46.6 77.5-63.8c25.9 17.2 52.3 38.6 77.5 63.8s46.6 51.6 63.8 77.5c-17.2 25.9-38.6 52.3-63.8 77.5s-51.6 46.6-77.5 63.8c-25.9-17.2-52.3-38.6-77.5-63.8zM155.8 155.8c-22.7 22.7-42.6 46.3-59.4 70.1c-9.6-17.6-17.2-34.7-22.5-50.9c-16.9-50.8-10-82.3 4.4-96.7s46-21.3 96.7-4.4c16.2 5.4 33.3 12.9 50.9 22.5c-23.8 16.8-47.4 36.7-70.1 59.4zm200.3 0c-22.7-22.7-46.3-42.6-70.1-59.4c17.6-9.6 34.7-17.2 50.9-22.5c50.8-16.9 82.3-10 96.7 4.4s21.3 46 4.4 96.7c-5.4 16.2-12.9 33.3-22.5 50.9c-16.8-23.8-36.7-47.4-59.4-70.1zm0 200.3c22.7-22.7 42.6-46.3 59.4-70.1c9.6 17.6 17.2 34.7 22.5 50.9c16.9 50.8 10.1 82.3-4.4 96.7s-46 21.3-96.7 4.4c-16.2-5.4-33.3-12.9-50.9-22.5c23.8-16.8 47.4-36.7 70.1-59.4zM224 256l32 32 32-32-32-32-32 32z'
      
    ]
  };

  
    var faAtomAlt = faAtomSimple;
  

  
  

  var faPenLine = {
    prefix: 'fasl',
    iconName: 'pen-line',
    icon: [
      576,
      512,
      [],
      'e212',
      
      'M6.8 478L0 512l34-6.8L160 480 489.4 150.6 512 128l-22.6-22.6L406.6 22.6 384 0 361.4 22.6 32 352 6.8 478zm34-6.8L61.5 367.8 315.3 113.9l82.7 82.7L144.2 450.5 40.8 471.2zM466.7 128l-46.1 46.1L337.9 91.3 384 45.3 466.7 128zM240 480H224v32h16H560h16V480H560 240z'
      
    ]
  };

  

  
  

  var faDog = {
    prefix: 'fasl',
    iconName: 'dog',
    icon: [
      576,
      512,
      [128021],
      'f6d3',
      
      'M336 331.5v43.8V480h64V261.9l-.1 0L307.7 208h-1H192 136 96V480h64V375.3 331.5l41.7 13.3c14.5 4.6 30.1 7.2 46.3 7.2s31.7-2.5 46.3-7.2L336 331.5zm69.8-112.8l4.5-26.7h27.1H480c35.3 0 64-28.7 64-64V96H496 482.7l-9.4-9.4L450.7 64H400 384l-9.6-12.8L362.5 35.4 338.2 181.3l-1.1 6.9 67.2 39.2 1.4-8.6zM64 206c-.7-.2-1.4-.3-2.1-.5C39.2 199.6 20 183.9 9.8 162.5c-2.3-4.8-4.1-9.8-5.4-15.1l0 0L.5 131.9l31-7.8 3.9 15.5c.3 1.4 .8 2.7 1.2 4.1c2 5.8 5.1 11.1 9 15.6C54.5 169.7 67.6 176 82 176h54 56H306.7L336 0h40l24 32h64l32 32h48 32V96v32c0 53-43 96-96 96H437.3L432 256V480v32H400 336 304V480 408.7 375.3c-10.3 3.3-21 5.7-32 7.1c-7.9 1-15.9 1.6-24 1.6s-16.1-.5-24-1.6c-11-1.4-21.7-3.8-32-7.1v33.3V480v32H160 96 64V480 206zM432 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faWandMagic = {
    prefix: 'fasl',
    iconName: 'wand-magic',
    icon: [
      512,
      512,
      ["magic"],
      'f0d0',
      
      'M96 512l22.6-22.6L489.4 118.6 512 96 489.4 73.4 438.6 22.6 416 0 393.4 22.6 22.6 393.4 0 416l22.6 22.6 50.7 50.7L96 512zM356.7 206.1l-50.7-50.7L416 45.3 466.7 96 356.7 206.1zm-22.6 22.6L96 466.7 45.3 416 283.3 177.9l50.7 50.7z'
      
    ]
  };

  
    var faMagic = faWandMagic;
  

  
  

  var faTents = {
    prefix: 'fasl',
    iconName: 'tents',
    icon: [
      640,
      512,
      [],
      'e582',
      
      'M236.1 120L416 0 608 128l27.4 192 4.6 32H607.7 465.5L461 320H603.1L578.3 146.7 416 38.5 264.9 139.2l-18.7-12.5L236.1 120zM32.3 512H0l4.6-32L32 288 224 160 416 288l27.4 192 4.6 32H415.7 32.3zm269-32L240 377.8V480h61.3zM208 320.3c0-.2 0-.4 0-.6V209.1L61.7 306.7 36.9 480H208V320.3zm178.3-13.6L240 209.1V315.6l93.7 156.2c1.6 2.6 2.3 5.4 2.3 8.2h75.1L386.3 306.7z'
      
    ]
  };

  

  
  

  var faCricketBatBall = {
    prefix: 'fasl',
    iconName: 'cricket-bat-ball',
    icon: [
      512,
      512,
      [127951,"cricket"],
      'f449',
      
      'M356.3 178.3l151-151L484.7 4.7l-151 151-47-47L264 86.1l-22.6 22.6L.2 349.8C-.2 367.1 .6 384 3.8 401c4 21.4 13.1 51.4 35.2 71.9c20.6 22.1 50.6 31.2 71.9 35.2c17 3.2 34 4 51.2 3.6L403.3 270.6 425.9 248l-22.6-22.6-47-47zM62.4 451.2l-.8-.8-.8-.8c-14.5-13.5-21.9-35-25.5-54.4c-1.9-10.3-2.9-20.9-3.1-32L192 203.3V304v16h16H308.7L148.9 479.8c-11.1-.2-21.7-1.1-32-3.1c-19.4-3.7-41-11.1-54.4-25.5zM224 288V171.3l40-40L380.7 248l-40 40H224zM384 432a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  
    var faCricket = faCricketBatBall;
  

  
  

  var faDiagramCells = {
    prefix: 'fasl',
    iconName: 'diagram-cells',
    icon: [
      512,
      512,
      [],
      'e475',
      
      'M480 192L32 192 32 64l448 0V192zm32 32V192 64 32H480 32 0V64 192v32H32l448 0h32zm0 240V304 288H496L16 288H0v16V464v16H16l480 0h16V464zM32 448l0-128 448 0V448L32 448z'
      
    ]
  };

  

  
  

  var faFaceDiagonalMouth = {
    prefix: 'fasl',
    iconName: 'face-diagonal-mouth',
    icon: [
      512,
      512,
      [129764],
      'e47e',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM148.4 383.4l-8.8-30.8 224-64 8.8 30.8-224 64zm4-175.4a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faTentArrowTurnLeft = {
    prefix: 'fasl',
    iconName: 'tent-arrow-turn-left',
    icon: [
      576,
      512,
      [],
      'e580',
      
      'M101.2 4.2l21.5 23.7L65.4 80H464c61.9 0 112 50.1 112 112v48 16H544V240 192c0-44.2-35.8-80-80-80H65.4l57.4 52.2-21.5 23.7-88-80L.2 96l13-11.8 88-80zM96.3 512H64l4.6-32L96 288 288 160 480 288l27.4 192 4.6 32H479.7 96.3zm269-32L304 377.8V480h61.3zM272 320.3c0-.1 0-.2 0-.2c0-.1 0-.2 0-.3V209.1L125.7 306.7 100.9 480H272V320.3zm178.3-13.6L304 209.1V315.6l93.7 156.2 4.9 8.2h72.4L450.3 306.7z'
      
    ]
  };

  

  
  

  var faBanParking = {
    prefix: 'fasl',
    iconName: 'ban-parking',
    icon: [
      512,
      512,
      ["parking-circle-slash"],
      'f616',
      
      'M256 480C132.3 480 32 379.7 32 256c0-56.1 20.6-107.4 54.7-146.7l316 316C363.4 459.4 312.1 480 256 480zm76-170.6c30.9-16 52-48.2 52-85.4c0-53-43-96-96-96H192 176v16 9.4L109.3 86.7C148.6 52.6 199.9 32 256 32c123.7 0 224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7L332 309.4zM307.6 285L208 185.4V160h80c35.3 0 64 28.7 64 64c0 28.5-18.7 52.7-44.4 61zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 257.9V304v64 16h32V368 320h30.1L176 257.9z'
      
    ]
  };

  
    var faParkingCircleSlash = faBanParking;
  

  
  

  var faPenNib = {
    prefix: 'fasl',
    iconName: 'pen-nib',
    icon: [
      512,
      512,
      [10001],
      'f5ad',
      
      'M396.7 198.1L466.7 128 384 45.3l-70.1 70.1 82.7 82.7zM381 227.7L284.3 131 121.7 185.2 40.6 448.7 152.9 336.5c-5.6-9.5-8.9-20.6-8.9-32.5c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-11.9 0-23-3.2-32.5-8.9L63.3 471.4l263.6-81.1L381 227.7zM352 416L40 512 0 472 96 160 288 96l73.4-73.4L384 0l22.6 22.6 82.7 82.7L512 128l-22.6 22.6L416 224 352 416zM176 304a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  

  
  

  var faScythe = {
    prefix: 'fasl',
    iconName: 'scythe',
    icon: [
      640,
      512,
      [],
      'f710',
      
      'M352 0C144.7 0 48.9 130.1 15.1 192C4.5 211.3 0 224 0 224H34.7 527.8l6.4-32H52.1c10.6-17.1 25.3-37.5 44.9-57.8C146 83.5 226 32 352 32H566.2l6.4-32H352zM637.9 0H605.3L544.5 304H544 400 384v32h16H538.1L502.9 512h32.6L637.9 0z'
      
    ]
  };

  

  
  

  var faHouseChimneyWindow = {
    prefix: 'fasl',
    iconName: 'house-chimney-window',
    icon: [
      576,
      512,
      [],
      'e00d',
      
      'M288 2.7L298.6 12 384 87.4V48 32h16 96 16V48 200h-.3l58.9 52-21.2 24L512 243V496v16H496 80 64V496 243L26.6 276 5.4 252l272-240L288 2.7zM480 172.1V64H416v51.6l64 56.5zM96 214.7V480H480V214.7L288 45.3 96 214.7zM224 192H352h16v16V336v16H352 224 208V336 208 192h16zm16 128h96V224H240v96z'
      
    ]
  };

  

  
  

  var faCircleChevronLeft = {
    prefix: 'fasl',
    iconName: 'circle-chevron-left',
    icon: [
      512,
      512,
      ["chevron-circle-left"],
      'f137',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM164.7 244.7L153.4 256l11.3 11.3 112 112L288 390.6 310.6 368l-11.3-11.3L198.6 256 299.3 155.3 310.6 144 288 121.4l-11.3 11.3-112 112z'
      
    ]
  };

  
    var faChevronCircleLeft = faCircleChevronLeft;
  

  
  

  var faGolfBallTee = {
    prefix: 'fasl',
    iconName: 'golf-ball-tee',
    icon: [
      384,
      512,
      ["golf-ball"],
      'f450',
      
      'M288 320c38.9-29.2 64-75.7 64-128c0-88.4-71.6-160-160-160S32 103.6 32 192c0 52.3 25.1 98.8 64 128H48.9C18.5 286 0 241.2 0 192C0 86 86 0 192 0S384 86 384 192c0 49.2-18.5 94-48.9 128H288zM80 352h96 32 96 16v32H304 208V496v16H176V496 384H80 64V352H80zM226.1 248.6c0-4.9-1.1-9.6-3-13.8c11.6 5.3 19.7 16.9 19.7 30.5c0 18.5-15 33.5-33.5 33.5c-13.6 0-25.3-8.1-30.5-19.7c4.2 1.9 8.9 3 13.8 3c18.5 0 33.5-15 33.5-33.5zm-52.3-49.3c18.5 0 33.5-15 33.5-33.5c0-4.9-1.1-9.6-3-13.8c11.6 5.3 19.7 16.9 19.7 30.5c0 18.5-15 33.5-33.5 33.5c-13.6 0-25.3-8.1-30.5-19.7c4.2 1.9 8.9 3 13.8 3zm113.5-17.5c0-4.9-1.1-9.6-3-13.8c11.6 5.3 19.7 16.9 19.7 30.5c0 18.5-15 33.5-33.5 33.5c-13.6 0-25.3-8.1-30.5-19.7c4.2 1.9 8.9 3 13.8 3c18.5 0 33.5-15 33.5-33.5z'
      
    ]
  };

  
    var faGolfBall = faGolfBallTee;
  

  
  

  var faHouseMedical = {
    prefix: 'fasl',
    iconName: 'house-medical',
    icon: [
      576,
      512,
      [],
      'e3b2',
      
      'M298.6 12L288 2.7 277.4 12 5.4 252l21.2 24L64 243V496v16H80 496h16V496 243l37.4 33 21.2-24L298.6 12zM96 480V214.7L288 45.3 480 214.7V480H96zM256 176H240v16 48H192 176v16 64 16h16 48v48 16h16 64 16V384 336h48 16V320 256 240H384 336V192 176H320 256zm16 80V208h32v48 16h16 48v32H320 304v16 48H272V320 304H256 208V272h48 16V256z'
      
    ]
  };

  

  
  

  var faPersonSeat = {
    prefix: 'fasl',
    iconName: 'person-seat',
    icon: [
      384,
      512,
      [],
      'e21e',
      
      'M128 88a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 56a56 56 0 1 1 0-112 56 56 0 1 1 0 112zM32 144V416H208h16v32H208 16 0V432 144 128H32v16zm56 32h16 88 16v16 32h64 16v32H272 208v72h64 13.1l2.6 12.9L309.1 448H368h16v32H368 296 282.9l-2.6-12.9L258.9 360H208 176 136c-26.5 0-48-21.5-48-48V192 176zm88 80V224 208H120V312c0 8.8 7.2 16 16 16h40V256z'
      
    ]
  };

  

  
  

  var faDitto = {
    prefix: 'fasl',
    iconName: 'ditto',
    icon: [
      320,
      512,
      [],
      '22',
      
      'M58.9 256L32 101.2V64H96v37.2L69.1 256H58.9zM128 32H96 32 0V64v40L32 288H96l32-184V64 32zM250.9 256L224 101.2V64h64v37.2L261.1 256H250.9zM320 32H288 224 192V64v40l32 184h64l32-184V64 32z'
      
    ]
  };

  

  
  

  var faPhonePlus = {
    prefix: 'fasl',
    iconName: 'phone-plus',
    icon: [
      640,
      512,
      [],
      'f4d2',
      
      'M344.4 355.3l21.3 12.3L383 350.2l40.7-40.7L539.8 356 517.3 480H512C282.2 480 96 293.7 96 64l0-5.3L220 36.2l46.5 116.1-40.7 40.7-17.3 17.3 12.3 21.3c29.6 51.4 72.4 94.1 123.7 123.7zM576 336L416 272l-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L304 160 240 0 64 32l0 32c0 247.4 200.6 448 448 448h32l32-176zM480 16H448V32 96H384 368v32h16 64v64 16h32V192 128h64 16V96H544 480V32 16z'
      
    ]
  };

  

  
  

  var faGlassesRound = {
    prefix: 'fasl',
    iconName: 'glasses-round',
    icon: [
      576,
      512,
      [128083,"glasses-alt"],
      'f5f5',
      
      'M67.7 32.5l14.5 2.6 72.7 13.2 15.7 2.9-5.7 31.5-15.7-2.9L91 69.2 44.5 243.4c24.2-22 56.3-35.4 91.5-35.4c55.1 0 102.6 32.8 124 80H316c21.3-47.2 68.8-80 124-80c35.3 0 67.4 13.4 91.5 35.4L485 69.2 426.9 79.7l-15.7 2.9-5.7-31.5 15.7-2.9 72.7-13.2 14.5-2.6 3.8 14.2 63.3 237.2 .5 2V288v40 16c0 75.1-60.9 136-136 136s-136-60.9-136-136c0-8.2 .7-16.2 2.1-24H269.9c1.4 7.8 2.1 15.8 2.1 24c0 75.1-60.9 136-136 136S0 419.1 0 344V328 288v-2.1l.5-2L63.9 46.7l3.8-14.2zM544 344a104 104 0 1 0 -208 0 104 104 0 1 0 208 0zM136 448a104 104 0 1 0 0-208 104 104 0 1 0 0 208z'
      
    ]
  };

  
    var faGlassesAlt = faGlassesRound;
  

  
  

  var faBinary = {
    prefix: 'fasl',
    iconName: 'binary',
    icon: [
      384,
      512,
      [],
      'e33b',
      
      'M240 0H224V32h16 48V192H240 224v32h16 64 64 16V192H368 320V16 0H304 240zM16 288H0v32H16 64V480H16 0v32H16 80h64 16V480H144 96V304 288H80 16zM0 0V16 208v16H16 176h16V208 16 0H176 16 0zM32 32H160V192H32V32zM208 288H192v16V496v16h16H368h16V496 304 288H368 208zm16 192V320H352V480H224z'
      
    ]
  };

  

  
  

  var faAvocado = {
    prefix: 'fasl',
    iconName: 'avocado',
    icon: [
      512,
      512,
      [],
      'e0aa',
      
      'M393.3 277.1l53.9-53.9c43.7-43.7 43.7-114.7 0-158.4s-114.7-43.7-158.4 0l-53.9 53.9-9.6 9.6-13.6-.3c-46.3-1-92.8 16.2-128.1 51.5c-68.7 68.7-68.7 180.2 0 248.9s180.2 68.7 248.9 0c35.3-35.3 52.5-81.8 51.5-128.1l-.3-13.6 9.6-9.6zm76.5-31.2L416 299.7c1.1 54.7-19.2 109.7-60.9 151.4c-81.2 81.2-212.9 81.2-294.2 0s-81.2-212.9 0-294.2c41.7-41.7 96.7-62 151.4-60.9l53.9-53.9c56.2-56.2 147.4-56.2 203.6 0s56.2 147.4 0 203.6zm-293.7-5.7c-38.2 38.2-40.4 88.1-16.4 112.1s73.9 21.8 112.1-16.4s40.4-88.1 16.4-112.1s-73.9-21.8-112.1 16.4zm134.8-39c41.4 41.4 28.8 112.1-16.4 157.4s-116 57.8-157.4 16.4s-28.8-112.1 16.4-157.4s116-57.8 157.4-16.4z'
      
    ]
  };

  

  
  

  var faGunSlash = {
    prefix: 'fasl',
    iconName: 'gun-slash',
    icon: [
      640,
      512,
      [],
      'e19c',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM480 240h6.6l4.7-4.7L518.6 208H592h16V192 80 64H592 544V48 32H512V48 64H180.1l40.5 32H512h32 32v80H512h-6.6l-4.7 4.7L473.4 208H362.5L403 240h77zM255.4 286.5L215 448H105l52-208h39.5l-40.5-32H132 64V135.4L32 110.2V224v16H48h76L72 448l-8 32H97 240l42.9-171.7-27.5-21.7z'
      
    ]
  };

  

  
  

  var faArrowsRepeat1 = {
    prefix: 'fasl',
    iconName: 'arrows-repeat-1',
    icon: [
      512,
      512,
      ["repeat-1-alt"],
      'f366',
      
      'M0 256v16H32V256 112H390.3l-49 44.1-11.9 10.7 21.4 23.8 11.9-10.7 80-72L455.9 96 442.7 84.1l-80-72L350.8 1.4 329.4 25.2l11.9 10.7 49 44.1H16 0V96 256zm512 0V240H480v16V400H121.7l49-44.1 11.9-10.7-21.4-23.8-11.9 10.7-80 72L56.1 416l13.2 11.9 80 72 11.9 10.7 21.4-23.8-11.9-10.7-49-44.1H496h16V416 256zM240 192H224v32h16 16v80 16h32V304 208 192H272 240z'
      
    ]
  };

  
    var faRepeat1Alt = faArrowsRepeat1;
  

  
  

  var faArrowUpShortWide = {
    prefix: 'fasl',
    iconName: 'arrow-up-short-wide',
    icon: [
      576,
      512,
      ["sort-amount-up-alt"],
      'f885',
      
      'M139.3 44.7L128 33.4 116.7 44.7l-88 88L17.4 144 40 166.6l11.3-11.3L112 94.6V464v16h32V464 94.6l60.7 60.7L216 166.6 238.6 144l-11.3-11.3-88-88zM304 48H288V80h16 64 16V48H368 304zm0 128H288v32h16H432h16V176H432 304zm0 128H288v32h16H496h16V304H496 304zm0 128H288v32h16H560h16V432H560 304z'
      
    ]
  };

  
    var faSortAmountUpAlt = faArrowUpShortWide;
  

  
  

  var faShield = {
    prefix: 'fasl',
    iconName: 'shield',
    icon: [
      512,
      512,
      [128737,"shield-blank"],
      'f132',
      
      'M256 34.3L48.5 114.9C45.8 160.5 53 231.7 83.2 301.2s83.4 137.3 172.8 175.9c89.4-38.7 142.6-106.4 172.8-175.9s37.4-140.7 34.7-186.3L256 34.3zM494.3 92.5l1.2 20.5c2.9 50-4.9 126.3-37.3 200.9c-32.7 75.2-91.1 150-189.4 192.6L256 512l-12.7-5.5C144.9 463.9 86.5 389.2 53.9 313.9C21.4 239.3 13.6 162.9 16.6 113l1.2-20.5L36.9 85 244.4 4.5 256 0l11.6 4.5L475.1 85l19.2 7.4z'
      
    ]
  };

  
    var faShieldBlank = faShield;
  

  
  

  var faFileExport = {
    prefix: 'fasl',
    iconName: 'file-export',
    icon: [
      576,
      512,
      ["arrow-right-from-file"],
      'f56e',
      
      'M352 192v64h32V152L232 0H32 0V32 480v32H32 352h32V480 368H352V480H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zm120.6 52.7L456 201.4 433.4 224l11.3 11.3L513.4 304H208 192v32h16H513.4l-68.7 68.7L433.4 416 456 438.6l11.3-11.3 96-96L574.6 320l-11.3-11.3-96-96z'
      
    ]
  };

  
    var faArrowRightFromFile = faFileExport;
  

  
  

  var faPhoneMissed = {
    prefix: 'fasl',
    iconName: 'phone-missed',
    icon: [
      640,
      512,
      [],
      'e226',
      
      'M112 0H240h16V32H240 150.6l112 112H377.4L500.7 20.7 512 9.4 534.6 32 523.3 43.3l-128 128-4.7 4.7H384 256h-6.6l-4.7-4.7L128 54.6V144v16H96V144 16 0h16zM416 464V368c-62.3-20.8-129.7-20.8-192 0v96L64 512 0 368c37.3-48 153.6-144 320-144s282.7 96 320 144L576 512 416 464zM192 368V344.9l21.9-7.3c68.9-23 143.4-23 212.2 0l21.9 7.3V368v72.2l110.2 33.1 44.3-99.7C559.7 328.3 458.7 256 320 256S80.3 328.3 37.5 373.5l44.3 99.7L192 440.2V368z'
      
    ]
  };

  

  
  

  var faFireSmoke = {
    prefix: 'fasl',
    iconName: 'fire-smoke',
    icon: [
      640,
      512,
      [],
      'f74b',
      
      'M352.7 112.8L377 85.3c2.4-2.8 4.8-5.4 7-7.8c7 7.5 14.9 16.6 22.8 26.7C430.4 134.5 448 167 448 192.2c0 25.3-7.4 49-20.1 68.8c7.4 5.7 14.3 12.1 20.7 18.9c2.8-1.8 5.6-3.6 8.5-5.2c14.5-24.1 22.9-52.3 22.9-82.5c0-73.6-96-160-96-160s-3.4 3.1-9 8.6c-5.6 5.6-13.4 13.6-22.1 23.4c-7.4-8.5-14.7-16.5-21.7-23.7C307.5 15.9 288 .2 288 .2s-128 103.6-128 192c0 30.2 8.3 58.4 22.9 82.5c2.9 1.6 5.8 3.4 8.5 5.2c6.4-6.8 13.3-13.1 20.7-18.9c-12.7-19.9-20.1-43.5-20.1-68.8c0-14.7 5.5-32.3 16.1-52c10.5-19.4 25-38.7 40.1-56.2c14.3-16.5 28.6-30.7 39.8-41.1c11.4 10.6 26.1 25.3 40.7 42.2l24 27.8zM232 201.8c0 15.2 3.3 28.9 9.3 40.7c9.6-4.8 19.6-8.7 30-11.7c-4.6-7.7-7.3-17.4-7.3-29c0-7.1 2.1-14.4 8-24.4c4-6.8 9.3-14.3 16.4-23.4c3.9 5.2 8.4 11 12.9 16.9c5.8 7.6 11.4 15.1 15.6 20.6l5.1 6.7 1.4 1.9 .4 .5 .1 .1c0 0 0 0 0 0s0 0 0 0s0 0 0 0l12.8-9.7-12.8 9.7 9.5 12.6 12.7-9.4 25.8-19c6.5 15.6 5.1 32.7-2.6 46c10.4 3 20.5 7 30 11.8c12-24 11.6-53.6-1.8-78.2c0 0 0 0 0-.1c-1.7-3.5-4.1-8.2-7.7-12.9L380.4 139l-12.7 9.4-27.8 20.4-13.1-17.3c-11.4-15-23.6-31.1-25.6-33.6l-12.4-15.4-12.5 15.4c-13.5 16.5-24.4 30.5-31.9 43.3c-7.7 13.1-12.3 26.1-12.3 40.6zM213.9 364c15-44.2 56.9-76 106.1-76s91.1 31.8 106.1 76l12.7 37.4 16.9-35.6C468.6 338.7 496.1 320 528 320c44.2 0 80 35.8 80 80l0 80-80 0-123.3 0-169.3 0L112 480l-80 0 0-80c0-44.2 35.8-80 80-80c31.9 0 59.4 18.7 72.3 45.7l16.9 35.6L213.9 364zM320 256c-52.6 0-98.6 28.2-123.7 70.3C175.8 302.8 145.6 288 112 288C50.1 288 0 338.1 0 400l0 96 0 16 16 0 96 0 123.3 0 169.3 0L528 512l96 0 16 0 0-16 0-96c0-61.9-50.1-112-112-112c-33.6 0-63.8 14.8-84.3 38.3C418.6 284.2 372.6 256 320 256z'
      
    ]
  };

  

  
  

  var faFaceGrinBeamSweat = {
    prefix: 'fasl',
    iconName: 'face-grin-beam-sweat',
    icon: [
      512,
      512,
      [128517,"grin-beam-sweat"],
      'f583',
      
      'M380.3 32.2C343.5 11.7 301.1 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-27.3-4.3-53.7-12.2-78.4c-9.1 5.5-19.2 9.6-29.8 11.9c6.5 21 10 43.3 10 66.4c0 123.7-100.3 224-224 224S32 379.7 32 256S132.3 32 256 32c38.9 0 75.5 9.9 107.4 27.4c4.8-9.5 10.8-18.8 16.9-27.2zM345.9 345.8c-22.5 23.6-54.5 38.3-89.9 38.3s-67.4-14.7-89.9-38.3c28.5 5.4 58.7 8.3 89.9 8.3s61.4-2.9 89.9-8.3zm25-38.6c-35.1 9.6-74 14.9-114.9 14.9s-79.9-5.3-114.9-14.9c-13-3.5-25.4-7.7-37.2-12.3c3.1 13.8 8 26.9 14.5 39c26.2 48.9 78 82.2 137.7 82.2s111.5-33.3 137.7-82.2c6.5-12.1 11.4-25.2 14.5-39c-11.8 4.6-24.3 8.8-37.2 12.3zM143.5 219.9c2.1-8.6 6.7-18.2 12.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4l31-7.8c-3.2-12.7-9.8-27.1-19.9-38.6C209.6 161.9 194.8 152 176 152s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6l31 7.8zm172.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4l31-7.8c-3.2-12.7-9.8-27.1-19.9-38.6C369.6 161.9 354.8 152 336 152s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6l31 7.8c2.1-8.6 6.7-18.2 12.9-25.4zM480 101.3c0 12.2-11.7 26.7-32 26.7s-32-14.5-32-26.7c0-1 .6-4.9 4.2-12.2c3.4-6.9 8.6-14.8 14.9-23.3c4.4-5.9 8.7-11.3 12.9-16.3c4.4 5.3 8.8 10.8 12.9 16.3c6.3 8.5 11.5 16.4 14.9 23.3c3.6 7.3 4.2 11.2 4.2 12.2zm-96 0c0 32.5 28.7 58.7 64 58.7s64-26.2 64-58.7c0-22.9-23.2-53.1-43-76.5c-3.3-3.9-6.5-7.6-9.4-11l0 0C455.1 8.5 451.1 3.9 448 0c-3 3.7-6.8 8.2-11.1 13.1l0 0c-3.1 3.6-6.5 7.5-9.9 11.6C407.1 48.1 384 78.3 384 101.3z'
      
    ]
  };

  
    var faGrinBeamSweat = faFaceGrinBeamSweat;
  

  
  

  var faTrumpet = {
    prefix: 'fasl',
    iconName: 'trumpet',
    icon: [
      640,
      512,
      [127930],
      'f8e3',
      
      'M591.1 64H600h24 16V80 400v16H624 600h-8.9l-4.7-7.5 0 0 0 0 0 0 0 0-.1-.2-.6-.9c-.5-.8-1.4-2.1-2.5-3.8c-2.3-3.3-5.7-8.1-10.1-13.8c-8.9-11.5-21.8-26.8-38-42.1c-32.9-31-77.1-59.7-127-59.7H384V416h32c35.3 0 64-28.7 64-64c0-2.6-.2-5.2-.5-7.8c7 4.6 13.8 9.7 20.5 15.2c3.6 3 7.2 6.1 10.5 9.2C502.7 413.7 463.4 448 416 448H384 352 304 272 224 192 160c-53 0-96-43-96-96c0-24.6 9.2-47 24.4-64H32v16H0V288 272 208 192 176H32v16H192V176 160h32v16 16h48V176 160h32v16 16h48V176 160h32v16 16h24c49.9 0 94.1-28.7 127-59.7c16.2-15.3 29.2-30.6 38-42.1c4.4-5.7 7.8-10.5 10.1-13.8c1.1-1.6 2-2.9 2.5-3.8l.6-.9 .1-.2 0 0 0 0 0 0 0 0 4.7-7.5zM160 256h32 32 48 32 48 10.7H384h24c62.1 0 113.9 35.3 149 68.3c17.8 16.7 31.8 33.4 41.5 45.9c3.9 5.1 7.1 9.5 9.6 13V96.8c-2.4 3.5-5.6 7.9-9.6 13c-9.6 12.5-23.7 29.2-41.5 45.9c-35.1 33-86.9 68.3-149 68.3H384 352 304 272 224 192 32v32H160zm192 32H304V416h48V288zM272 416V288H224V416h48zm-80 0V288H160c-35.3 0-64 28.7-64 64s28.7 64 64 64h32z'
      
    ]
  };

  

  
  

  var faClockRotateLeft = {
    prefix: 'fasl',
    iconName: 'clock-rotate-left',
    icon: [
      512,
      512,
      ["history"],
      'f1da',
      
      'M32 132V48 32H0V48 176v16H16 144h16V160H144 53.6C89.5 84.3 166.7 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-73.3 0-138.3-35.2-179.2-89.6l-9.6-12.8L41.6 396.8l9.6 12.8C97.9 471.8 172.2 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C159.6 0 75.7 53.3 32 132zm240-4H240v16V256v6.6l4.7 4.7 80 80L336 358.6 358.6 336l-11.3-11.3L272 249.4V144 128z'
      
    ]
  };

  
    var faHistory = faClockRotateLeft;
  

  
  

  var faNestingDolls = {
    prefix: 'fasl',
    iconName: 'nesting-dolls',
    icon: [
      640,
      512,
      [],
      'e3ba',
      
      'M192 32c53 0 96 43 96 96v80 16h32V208 128C320 57.3 262.7 0 192 0S64 57.3 64 128v80 16H96V208 128c0-53 43-96 96-96zM317.3 288c5-11.4 11.3-22.2 18.7-32H42.3c-1.4 2.8-2.9 5.7-4.3 8.6l0 0 0 0C20.2 299.6 0 339.6 0 384c0 80 48 128 48 128H250.7l9.9-16.5 0 0 0 0 0 0 0 0 .1-.1 .3-.6c.3-.5 .8-1.3 1.4-2.4c1.2-2.1 3-5.2 5.1-9.1c.6-1.1 1.2-2.2 1.9-3.4H63c-3.2-4.4-7.1-10.2-10.9-17.3C42 444.2 32 417.5 32 384c0-32.6 13.6-63.3 30-96H317.3zM70.7 489.4l.1 .1 0 0 0-.1 0 0zM206.4 67.9l-28.8 0c-9.5 19.5-28.5 33.4-50.8 35.7l-16.1 1.7 1.9 16.1c2 17.2 9.7 33.9 22.9 47.1c31.2 31.2 81.9 31.2 113.1 0c13.2-13.2 20.8-29.9 22.9-47.1l1.9-16.1-16.1-1.7c-22.4-2.3-41.4-16.3-50.8-35.7zm-58.1 63.9c17.1-5.3 32.2-15.2 43.8-28.3c11.6 13.1 26.6 23 43.8 28.3c-2.3 5.1-5.6 9.9-9.8 14.2c-18.7 18.7-49.1 18.7-67.9 0c-4.2-4.2-7.5-9-9.8-14.2zM449.6 307.9c-9.5 19.5-28.5 33.4-50.8 35.7l-16.1 1.7 1.9 16.1c2 17.2 9.7 33.9 22.9 47.1c31.2 31.2 81.9 31.2 113.1 0c13.2-13.2 20.8-29.9 22.9-47.1l1.9-16.1-16.1-1.7c-22.4-2.3-41.4-16.3-50.8-35.7l-28.8 0zM464 343.5c11.6 13.1 26.6 23 43.8 28.3c-2.3 5.1-5.6 9.9-9.8 14.2c-18.7 18.7-49.1 18.7-67.9 0c-4.2-4.2-7.5-9-9.8-14.2c17.1-5.3 32.2-15.2 43.8-28.3zM640 512s-7.9-13.2-17.3-32C609 452.4 592 412.5 592 384V352c0-70.7-57.3-128-128-128s-128 57.3-128 128v32c0 28.5-17 68.4-30.7 96c-9.4 18.8-17.3 32-17.3 32h36.7H603.3 640zm-53.1-32.6l.3 .6H340.8l.3-.6C353 453.5 368 415.7 368 384V352c0-53 43-96 96-96s96 43 96 96v32c0 31.7 15 69.5 26.9 95.4z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassMusic = {
    prefix: 'fasl',
    iconName: 'magnifying-glass-music',
    icon: [
      512,
      512,
      [],
      'e65f',
      
      'M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L487.9 510.5l22.6-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM288 90.8l-20.4 5.8-56 16L200 115.9V128v63.6c0 .2 0 .5 0 .7v21.2c-8.4-3.5-17.9-5.5-28-5.5c-33.1 0-60 21.5-60 48s26.9 48 60 48s60-21.5 60-48v0V204.1l44.4-12.7 11.6-3.3V176 112 90.8zM194.4 247c4.7 3.8 5.6 7.2 5.6 9v0c0 1.8-.8 5.2-5.6 8.9c-4.8 3.8-12.6 7-22.4 7s-17.6-3.2-22.4-7c-4.7-3.8-5.6-7.2-5.6-9s.8-5.2 5.6-9c4.8-3.8 12.6-7 22.4-7s17.6 3.2 22.4 7zM232 170.8V140.1l24-6.9v30.7l-24 6.9z'
      
    ]
  };

  

  
  

  var faChairOffice = {
    prefix: 'fasl',
    iconName: 'chair-office',
    icon: [
      448,
      512,
      [],
      'f6c1',
      
      'M320 32V224h32V32 0H320 128 96V32 224h32V32H320zM240 432V384H384h32V352l-48-96H80L32 352v32H64 208v48H144 128v16 48 16h32V496 464h48v32 16h32V496 464h48v32 16h32V496 448 432H304 240zM64 128H32v16 80 16H64V224 144 128zm352 0H384v16 80 16h32V224 144 128zM99.8 288H348.2l32 64H240 208 67.8l32-64z'
      
    ]
  };

  

  
  

  var faFishCooked = {
    prefix: 'fasl',
    iconName: 'fish-cooked',
    icon: [
      576,
      512,
      [],
      'f7fe',
      
      'M108.6 186.1l20.3 10.2 16.3-15.9C192.9 134 261.3 96 320 96c75.2 0 131.2 40.8 169.9 85.1c19.2 22 33.5 44.1 43 60.8c3.1 5.4 5.6 10.2 7.6 14.2c-2 4-4.6 8.8-7.6 14.2c-9.5 16.7-23.8 38.8-43 60.8C451.2 375.2 395.2 416 320 416c-63 0-136.8-43.7-184-93.7L117.9 303 95.6 317.2 37.2 354.4l25.6-89.6 2.5-8.8-2.5-8.8-28-98.1 73.8 36.9zM320 64c-70.4 0-146.4 44.1-197.1 93.5L32 112 0 96v35.8V144L32 256 0 368v10.1V416l32-20.4 80.8-51.4C163.1 397.6 244.7 448 320 448c176 0 256-192 256-192s-80-192-256-192zm-4.7 107.3L326.6 160 304 137.4l-11.3 11.3-64 64L217.4 224 240 246.6l11.3-11.3 64-64zm112 16L438.6 176 416 153.4l-11.3 11.3-160 160L233.4 336 256 358.6l11.3-11.3 160-160zm16 112L454.6 288 432 265.4l-11.3 11.3-64 64L345.4 352 368 374.6l11.3-11.3 64-64z'
      
    ]
  };

  

  
  

  var faPenPaintbrush = {
    prefix: 'fasl',
    iconName: 'pen-paintbrush',
    icon: [
      576,
      512,
      ["pencil-paintbrush"],
      'f618',
      
      'M38.8 478L32 512l34-6.8L192 480 521.4 150.6 544 128l-22.6-22.6L438.6 22.6 416 0 393.4 22.6 64 352 38.8 478zm34-6.8L93.5 367.8 347.3 113.9l82.7 82.7L176.2 450.5 72.8 471.2zM498.7 128l-46.1 46.1L369.9 91.3 416 45.3 498.7 128zM136.4 45.9L113.8 23.3 91.2 .7 68.6 23.3 23.3 68.6 .7 91.2l22.6 22.6L46 136.5l94.2 94.2L162.8 208 68.6 113.8 45.9 91.2 91.2 45.9l22.6 22.6L208 162.7l22.6-22.6L136.4 45.9zM400 512h0 80 32 32 16 16V480H560 544h0H512V448 400c0-52.8-36.6-97.1-85.8-108.9l-29 29c.9 0 1.9 0 2.8 0c44.2 0 80 35.8 80 80v80H400h0c-44.2 0-80-35.8-80-80c0-.9 0-1.9 0-2.8l-29 29C302.9 475.4 347.2 512 400 512z'
      
    ]
  };

  
    var faPencilPaintbrush = faPenPaintbrush;
  

  
  

  var faBrowser = {
    prefix: 'fasl',
    iconName: 'browser',
    icon: [
      512,
      512,
      [128468],
      'f37e',
      
      'M160 64v64H480V64H160zm-32 0H32v64h96V64zM32 160V448H480V160H144 32zM0 32H32 480h32V64 448v32H480 32 0V448 64 32z'
      
    ]
  };

  

  
  

  var faFireplace = {
    prefix: 'fasl',
    iconName: 'fireplace',
    icon: [
      640,
      512,
      [],
      'f79a',
      
      'M0 0H16 624h16V16v96 16H624 608V496v16H592 496 480V496 352c0-88.4-71.6-160-160-160s-160 71.6-160 160V496v16H144 48 32V496 128H16 0V112 16 0zM64 128V480h64V352c0-106 86-192 192-192s192 86 192 192V480h64V128H64zM32 32V96H608V32H32zM319.8 279.8l22.6 22.6L364.8 280c53.8 44.8 67.2 93.3 67.2 112c0 59.6-46.6 108.4-105.4 111.8c-2.2 .2-4.4 .3-6.6 .3s-4.4-.1-6.6-.3C254.6 500.4 208 451.7 208 392c0-62.7 59.7-115.7 89.6-134.4l22.2 22.2zM320 472c1.5 0 2.9 0 4.4-.1c19-2 30.8-16.6 30.8-30.5c0-11.3-8.7-26.9-24.6-43.3c-3.6-3.7-7.2-7.1-10.6-10.1c-3.4 3-7 6.4-10.6 10.1c-15.9 16.4-24.6 32-24.6 43.3c0 13.9 11.8 28.5 30.8 30.5c1.5 .1 2.9 .1 4.4 .1zm0-124.7s62.2 41.5 66.9 88.5c8.3-12.6 13.1-27.7 13.1-43.8c0-6.6-5.6-35.1-34.7-67.3l-.3 .3-22.6 22.6-22.6-22.6-25.3-25.3c-9.1 7.7-19 17.4-27.8 28.5C250.3 348.7 240 370.8 240 392c0 16.2 4.8 31.3 13.1 43.8c4.7-47 66.9-88.5 66.9-88.5z'
      
    ]
  };

  

  
  

  var faDiceD10 = {
    prefix: 'fasl',
    iconName: 'dice-d10',
    icon: [
      512,
      512,
      [],
      'f6cd',
      
      'M240 498l16 14 16-14L487.9 309.1l8.8-7.7L512 288l-17.4-19.6-3.8-4.3L283.6 31l-6.2-7-9.2-10.4L256 0 243.8 13.7l-9.2 10.4-6.2 7L21.3 264.1l-3.8 4.3L0 288l15.3 13.4 8.8 7.7L240 498zM55.2 293.8l109-20.8L240 328.1V455.5L55.2 293.8zM187 250L256 49.2 325 250l-69 50.2L187 250zM310.6 109.6L443 258.6 356.1 242 310.6 109.6zM456.8 293.8L272 455.5V328.1L347.8 273l109 20.8zM201.4 109.6L155.9 242 69 258.6l132.4-149z'
      
    ]
  };

  

  
  

  var faQrcode = {
    prefix: 'fasl',
    iconName: 'qrcode',
    icon: [
      448,
      512,
      [],
      'f029',
      
      'M160 64V192H32V64H160zM32 32H0V64 192v32H32 160h32V192 64 32H160 32zM160 320V448H32V320H160zM32 288H0v32V448v32H32 160h32V448 320 288H160 32zM288 64H416V192H288V64zM256 32V64 192v32h32H416h32V192 64 32H416 288 256zm0 256v16V464v16h32V464 320h32v68 16h16 96 16V388 304 288H416v16 68H352V304 288H336 272 256zM120 104H72v48h48V104zM72 360v48h48V360H72zM376 104H328v48h48V104zM320 432v48h48V432H320zm128 0H400v48h48V432z'
      
    ]
  };

  

  
  

  var faSubtitlesSlash = {
    prefix: 'fasl',
    iconName: 'subtitles-slash',
    icon: [
      640,
      512,
      [],
      'e610',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM459.9 448H64V135.4L32 110.2V448v32H64 500.4l-40.5-32zM576 32H139.6l40.5 32H576V376.6l32 25.3V64 32H576zM423.3 256l40.5 32H496h16V256H496 423.3zM144 256H128v32h16H257.2l-40.5-32H144zm160 96H288v32h16 74.8l-40.5-32H304zm-160 0H128v32h16 96 16V352H240 144z'
      
    ]
  };

  

  
  

  var faAlbumCircleUser = {
    prefix: 'fasl',
    iconName: 'album-circle-user',
    icon: [
      576,
      512,
      [],
      'e48d',
      
      'M416 64H32V448H275.2c5.9 11.4 12.9 22.2 21 32H32 0V448 64 32H32 416h32V64 192.7c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7V64zM224 96c69.3 0 128.3 44 150.5 105.6c-10.2 3.5-20 8-29.3 13.2C328.1 164.3 280.3 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c11.2 0 22-1.4 32.4-4.1c.7 10.9 2.4 21.5 5 31.7c-12 2.9-24.5 4.4-37.4 4.4c-88.4 0-160-71.6-160-160s71.6-160 160-160zm0 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM489.5 464.1L473.4 448H390.6l-16.1 16.1C391.3 474.2 411 480 432 480s40.7-5.8 57.5-15.9zm24.9-20.3C532.8 423.9 544 397.2 544 368c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 29.2 11.2 55.9 29.6 75.8l23.1-23.1 4.7-4.7H384h96 6.6l4.7 4.7 23.1 23.1zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112z'
      
    ]
  };

  

  
  

  var faPancakes = {
    prefix: 'fasl',
    iconName: 'pancakes',
    icon: [
      512,
      512,
      [129374],
      'e42d',
      
      'M73.8 100c-8.9 6.5-9.8 10.7-9.8 12c0 .9 .4 3.2 4 7c3.7 3.9 9.9 8.3 19 12.7l9 4.4v10V320v16h32V320 165.9 146.5l19.1 3.8c18.7 3.7 39.6 6.5 62.1 8.1l14.8 1.1v14.9V288v16h32V288 175.8 160.2l15.6-.4c52.6-1.2 99-8.6 131.6-19.4c16.4-5.4 28.5-11.4 36.1-17.3c7.9-6 8.6-9.9 8.6-11.1c0-1.3-.9-5.5-9.8-12c-8.5-6.2-21.9-12.5-39.9-18c-13.5-4.2-29.1-7.8-46.4-10.6V96v32H320 192 160V96 71.4c-17.2 2.9-32.9 6.5-46.4 10.6c-18 5.5-31.3 11.8-39.9 18zM192 67.2V96H320V67.2c-20-2-41.5-3.2-64-3.2s-44 1.1-64 3.2zM104.2 51.5C143.8 39.3 197.4 32 256 32s112.2 7.3 151.8 19.5c19.7 6.1 36.8 13.6 49.3 22.7C469.2 83 480 95.6 480 112c0 15.6-9.8 27.8-21.2 36.5c-11.6 8.9-27.4 16.3-45.5 22.3c-33 10.9-76.7 18.2-125.3 20.5V288v32 16H272 208 192V320 288 189c-11.1-1.1-21.7-2.4-32-4V320v32 16H144 80 64V352 320 155.7c-7.4-4.3-14-9.2-19.2-14.6C37.5 133.4 32 123.6 32 112c0-16.4 10.8-29 22.9-37.9C67.5 65 84.5 57.5 104.2 51.5zM320 229.7c42.1-3.1 78.7-9.5 106.8-19c37.8-12.8 49.9-27 52.6-37.6c9-7.1 19.4-17.5 25.9-31.4c4.4 8 6.7 16.7 6.7 26.3c0 13.5-4.7 25.5-13.4 36c8.7 10.5 13.4 22.5 13.4 36s-4.7 25.5-13.4 36c8.7 10.5 13.4 22.5 13.4 36s-4.7 25.5-13.4 36c8.7 10.5 13.4 22.5 13.4 36c0 66.7-114.6 96-256 96S0 450.7 0 384c0-13.5 4.7-25.5 13.4-36C4.7 337.5 0 325.5 0 312s4.7-25.5 13.4-36C4.7 265.5 0 253.5 0 240s4.7-25.5 13.4-36C4.7 193.5 0 181.5 0 168c0-9.5 2.3-18.3 6.7-26.3c4 8.5 9.4 15.7 14.9 21.5c3.2 3.4 6.7 6.5 10.3 9.4V240v64 8 24 48c0 10.8 8.9 27.7 53.2 42.7C126.8 440.8 186.9 448 256 448s129.2-7.2 170.8-21.3c44.3-15 53.2-31.9 53.2-42.7c0-4.4-1.4-9.7-6.1-15.5C428.8 395.6 348.1 408 256 408c-22.1 0-43.5-.7-64-2.2V384 373.7c20.2 1.5 41.6 2.3 64 2.3c69.1 0 129.2-7.2 170.8-21.3c44.3-15 53.2-31.9 53.2-42.7c0-4.4-1.4-9.7-6.1-15.5c-34.3 20.6-89.1 32.7-153.9 37.3V320 301.7c42.1-3.1 78.7-9.5 106.8-19c44.3-15 53.2-31.9 53.2-42.7c0-4.4-1.4-9.7-6.1-15.5c-34.3 20.6-89.1 32.7-153.9 37.3V229.7z'
      
    ]
  };

  

  
  

  var faCamcorder = {
    prefix: 'fasl',
    iconName: 'camcorder',
    icon: [
      576,
      512,
      [128249,"video-handheld"],
      'f8a8',
      
      'M80 32H64V48 160H32 0v32V448v32H32 352h32V448 398.5v-157V192 160H352 96V64H304h16V32H304 80zM64 192H96 352V448H32V192H64zM544 466.5L576 480V445.3 194.7 160l-32 13.5L416 227.7v34.7l128-54.2V431.7L416 377.6v34.7l128 54.2zM64 224v32H80 304h16V224H304 80 64z'
      
    ]
  };

  
    var faVideoHandheld = faCamcorder;
  

  
  

  var faAnglesLeft = {
    prefix: 'fasl',
    iconName: 'angles-left',
    icon: [
      512,
      512,
      [171,"angle-double-left"],
      'f100',
      
      'M52.7 244.7L41.4 256l11.3 11.3 160 160L224 438.6 246.6 416l-11.3-11.3L86.6 256 235.3 107.3 246.6 96 224 73.4 212.7 84.7l-160 160zm192 0L233.4 256l11.3 11.3 160 160L416 438.6 438.6 416l-11.3-11.3L278.6 256 427.3 107.3 438.6 96 416 73.4 404.7 84.7l-160 160z'
      
    ]
  };

  
    var faAngleDoubleLeft = faAnglesLeft;
  

  
  

  var faBuilding = {
    prefix: 'fasl',
    iconName: 'building',
    icon: [
      384,
      512,
      [61687,127970],
      'f1ad',
      
      'M32 32V480h96V400 368h32 64 32v32 80h96V32H32zM160 480h64V400H160v80zm-32 32H32 0V480 32 0H32 352h32V32 480v32H352 256 224 160 128zM64 96H80h64 16v16 64 16H144 80 64V176 112 96zm32 32v32h32V128H96zM240 96h64 16v16 64 16H304 240 224V176 112 96h16zm16 64h32V128H256v32zM64 224H80h64 16v16 64 16H144 80 64V304 240 224zm32 32v32h32V256H96zm144-32h64 16v16 64 16H304 240 224V304 240 224h16zm16 64h32V256H256v32z'
      
    ]
  };

  

  
  

  var faTicketSimple = {
    prefix: 'fasl',
    iconName: 'ticket-simple',
    icon: [
      576,
      512,
      ["ticket-alt"],
      'f3ff',
      
      'M0 96V64H32 544h32V96v80 32c-26.5 0-48 21.5-48 48s21.5 48 48 48v32 80 32H544 32 0V416 336 304c26.5 0 48-21.5 48-48s-21.5-48-48-48V176 96zm32 86.7C60.3 195 80 223.2 80 256s-19.7 61-48 73.3V416H544V329.3c-28.3-12.3-48-40.5-48-73.3s19.7-61 48-73.3V96H32v86.7z'
      
    ]
  };

  
    var faTicketAlt = faTicketSimple;
  

  
  

  var faAward = {
    prefix: 'fasl',
    iconName: 'award',
    icon: [
      384,
      512,
      [],
      'f559',
      
      'M236.2 26.9L192 0 147.8 26.9 96 25.7 71.2 71.2 25.7 96l1.2 51.8L0 192l26.9 44.2L25.7 288l45.4 24.8L96 358.3l51.8-1.2L192 384l44.2-26.9 51.8 1.2 24.8-45.4L358.3 288l-1.2-51.8L384 192l-26.9-44.2L358.3 96 312.8 71.2 288 25.7l-51.8 1.2zm33 31.2l15.5 28.3 4.5 8.2 8.2 4.5 28.3 15.5-.8 32.3-.2 9.4 4.9 8L346.5 192l-16.8 27.6-4.9 8 .2 9.4 .8 32.3-28.3 15.5-8.2 4.5-4.5 8.2-15.5 28.3-32.3-.8-9.4-.2-8 4.9L192 346.5l-27.6-16.8-8-4.9-9.4 .2-32.3 .8L99.3 297.5l-4.5-8.2-8.2-4.5L58.2 269.3l.8-32.3 .2-9.4-4.9-8L37.5 192l16.8-27.6 4.9-8-.2-9.4-.8-32.3L86.5 99.3l8.2-4.5 4.5-8.2 15.5-28.3 32.3 .8 9.4 .2 8-4.9L192 37.5l27.6 16.8 8 4.9 9.4-.2 32.3-.8zM192 248a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm-88-56a88 88 0 1 0 176 0 88 88 0 1 0 -176 0zM13.5 424L0 456H34.7 75.8l28.3 30.3L128 512l13.6-32.3 29.8-70.8-27.6-16.8L117.7 454 99.2 434.2 89.7 424H75.8 48.2l20.6-48.8-.8-1.5L49.2 339.3 13.5 424zm228.9 55.7L256 512l23.9-25.7L308.2 456h41.1H384l-13.5-32-35.7-84.7-18.8 34.3-.8 1.5L335.8 424H308.2 294.3l-9.5 10.2L266.3 454l-26.1-61.9-27.6 16.8 29.8 70.8z'
      
    ]
  };

  

  
  

  var faUserGroupSimple = {
    prefix: 'fasl',
    iconName: 'user-group-simple',
    icon: [
      640,
      512,
      [],
      'e603',
      
      'M88 136a72 72 0 1 1 144 0A72 72 0 1 1 88 136zm176 0A104 104 0 1 0 56 136a104 104 0 1 0 208 0zm144 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm176 0a104 104 0 1 0 -208 0 104 104 0 1 0 208 0zM87.1 320H232.9l42.7 128H44.4L87.1 320zM256 288H64L10.7 448 0 480H33.7 286.3 320l-10.7-32L256 288zm108.4 32H595.6L552.9 448H407.1L364.4 320zM384 480H576l53.3-160L640 288H606.3 353.7 320l10.7 32L384 480z'
      
    ]
  };

  

  
  

  var faConveyorBeltEmpty = {
    prefix: 'fasl',
    iconName: 'conveyor-belt-empty',
    icon: [
      640,
      512,
      [],
      'e150',
      
      'M96 352c-35.3 0-64 28.7-64 64s28.7 64 64 64H544c35.3 0 64-28.7 64-64s-28.7-64-64-64H96zM0 416c0-53 43-96 96-96H544c53 0 96 43 96 96s-43 96-96 96H96c-53 0-96-43-96-96zm128-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faFlagPennant = {
    prefix: 'fasl',
    iconName: 'flag-pennant',
    icon: [
      448,
      512,
      [128681,"pennant"],
      'f456',
      
      'M32 16V0H0V16 32 64 320v32V496v16H32V496 350.8L403.1 209.1 448 192l-44.9-17.1L32 33.2V16zm0 51.5L358.3 192 32 316.5V67.5z'
      
    ]
  };

  
    var faPennant = faFlagPennant;
  

  
  

  var faPersonFallingBurst = {
    prefix: 'fasl',
    iconName: 'person-falling-burst',
    icon: [
      640,
      512,
      [],
      'e547',
      
      'M256 0l0 16 0 88v9.2l-7.9 4.6L179.2 158l68.9 105.1 70.3-7 11-1.1 4.9 9.9 48 96 7.2 14.3-28.6 14.3-7.2-14.3L310.6 289l-64.4 6.4-57.5 44.7 96.6 147.1-26.7 17.6-184-280-2.8-4.2L64 225.2 64 368v16H32V368 216v-9.2l7.9-4.6L224 94.8 224 16l0-16h32zM171.1 313.3l47.4-36.9-67-102.3L99.6 204.4l1.8 2.8 69.7 106.1zM56 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 56 32zM419.4 309.8l-19.3 15.1-12.8-25.6 0-5-.6-56.6-55.1-13.1-39.2-9.4 31.3-25.4L367.6 154l-24.1-51.2L326.4 66.3l39.4 8.6 55.3 12 25.1-50.8L464 0l17.8 36.1 25.1 50.8 55.3-12 39.4-8.6-17.1 36.5L560.4 154l43.9 35.7 31.3 25.4-39.2 9.4-55.1 13.1-.6 56.6-.4 40.3-31.8-24.8L464 274.9l-44.6 34.9zM545.1 111.3l-31.4 6.8-24.4 5.3-11.1-22.4L464 72.3l-14.2 28.8-11.1 22.4-24.4-5.3-31.4-6.8 13.6 29.1L407.2 163l-19.4 15.8-24.9 20.3 31.2 7.5 24.3 5.8 .2 25 .3 32.1 25.3-19.8L464 234.3l19.7 15.4L509 269.5l.3-32.1 .2-25 24.3-5.8 31.2-7.5-24.9-20.3L520.8 163l10.6-22.6 13.6-29.1z'
      
    ]
  };

  

  
  

  var faArrowRightToLine = {
    prefix: 'fasl',
    iconName: 'arrow-right-to-line',
    icon: [
      448,
      512,
      [8677,"arrow-to-right"],
      'f340',
      
      'M448 80l0-16-32 0 0 16 0 352 0 16 32 0 0-16 0-352zM347.3 267.3L358.6 256l-11.3-11.3-128-128L208 105.4 185.4 128l11.3 11.3L297.4 240 192 240 16 240 0 240l0 32 16 0 176 0 105.4 0L196.7 372.7 185.4 384 208 406.6l11.3-11.3 128-128z'
      
    ]
  };

  
    var faArrowToRight = faArrowRightToLine;
  

  
  

  var faAnt = {
    prefix: 'fasl',
    iconName: 'ant',
    icon: [
      640,
      512,
      [],
      'e680',
      
      'M505.4 0L512 0l80 0 16 0 0 32-16 0-73.4 0L499.9 50.8C561.3 63.4 608 117.7 608 182.9l0 57.1 0 16-16 0-120 0c-4.7 0-9.3-.3-13.8-.9c3.7 10.3 5.8 21.3 5.8 32.9c0 7.6-.9 14.9-2.5 22l107.8 77 4.4 3.1 1.6 5.1L612 512l-33.5 0L546.3 409.9l-97.7-69.8c-4.9 7.6-10.8 14.4-17.6 20.3l44.3 44.3 2.4 2.4 1.2 3.2L517.5 512l-34.2 0-33-87.1-47.4-47.4C392 381.7 380.3 384 368 384c-14.3 0-27.9-3.1-40.1-8.7l-14.4 23.9L249.1 512l-36.9 0 73.6-128.8s0 0 0 0l.2-.3 15.4-25.7c-6.7-6.4-12.4-13.8-17-21.9c-8.4 12.3-19.3 22.8-31.8 30.9l-5.6 9.7L169.3 512l-36.9 0 73.6-128.9c-4.6 .6-9.3 .9-14.1 .9l-29.6 0L89.3 512l-36.9 0 73.1-128L16 384 0 384l0-16 0-68.6C0 204.8 76.8 128 171.4 128c59.8 0 110.3 39.6 126.9 94c17.5-18.5 42.3-30 69.7-30c2.7 0 5.4 .1 8.1 .3c-5.2-12.4-8.1-26-8.1-40.3c0-52 38.4-94.9 88.1-102.7L500.7 4.7 505.4 0zM472.5 80c-39.9 0-72.5 32.4-72.5 72c0 39.8 32.2 72 72 72l104 0 0-41.1C576 126.2 529.4 80 472.5 80zM368 224a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM32 299.4L32 352l160 0c44.2 0 80-35.8 80-80l0-11.4C272 205 227 160 171.4 160C94.4 160 32 222.4 32 299.4zM476 144a20 20 0 1 1 40 0 20 20 0 1 1 -40 0z'
      
    ]
  };

  

  
  

  var faLineColumns = {
    prefix: 'fasl',
    iconName: 'line-columns',
    icon: [
      512,
      512,
      [],
      'f870',
      
      'M16 48H0V80H16 208h16V48H208 16zm0 128H0v32H16 208h16V176H208 16zM0 304v32H16 208h16V304H208 16 0zM16 432H0v32H16 208h16V432H208 16zM288 176v32h16H496h16V176H496 304 288zM304 48H288V80h16H496h16V48H496 304zM288 304v32h16H496h16V304H496 304 288zm16 128H288v32h16H496h16V432H496 304z'
      
    ]
  };

  

  
  

  var faCardSpade = {
    prefix: 'fasl',
    iconName: 'card-spade',
    icon: [
      384,
      512,
      [],
      'e3ec',
      
      'M32 32V480H352V32H32zM0 0H32 352h32V32 480v32H352 32 0V480 32 0zM192 120.9l11.3 11.3 33.9 33.9L297 225.9c25 25 25 65.5 0 90.5c-24.5 24.5-63.9 25-89 1.5V352h16 16v32H224 208 176 160 144V352h16 16V317.8c-25.1 23.5-64.5 23-89-1.5c-25-25-25-65.5 0-90.5l59.7-59.7 33.9-33.9L192 120.9zm0 45.3l-22.6 22.6-59.7 59.7c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l25.8-25.8L192 256.6l11.3 11.3 25.8 25.8c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-59.7-59.7L192 166.1z'
      
    ]
  };

  

  
  

  var faSpade = {
    prefix: 'fasl',
    iconName: 'spade',
    icon: [
      512,
      512,
      [9824],
      'f2f4',
      
      'M240 400.2l-6.5 6.6-1.4 1.4c-53.1 53.1-139.2 53.1-192.3 0s-53.1-139.2 0-192.3L256 0l0 0L472.2 215.8c53.1 53.1 53.1 139.2 0 192.3s-139.2 53.1-192.3 0l-1.4-1.4-6.5-6.6V480h64 16v32H336 272 240 176 160V480h16 64V400.2zm-6.8-38.7L256 338.4l22.8 23.1 23.8 24.1c40.6 40.5 106.4 40.5 147-.1c40.6-40.6 40.6-106.5 0-147.1l0 0L256 45.2 62.5 238.5l0 0c-40.6 40.6-40.6 106.5 0 147.1c40.6 40.6 106.4 40.6 147 .1l23.8-24.1z'
      
    ]
  };

  

  
  

  var faArrowTurnDown = {
    prefix: 'fasl',
    iconName: 'arrow-turn-down',
    icon: [
      384,
      512,
      ["level-down"],
      'f149',
      
      'M16 32L0 32 0 0 16 0 192 0l16 0 0 16 0 441.4L308.7 356.7 320 345.4 342.6 368l-11.3 11.3-128 128L192 518.6l-11.3-11.3-128-128L41.4 368 64 345.4l11.3 11.3L176 457.4 176 32 16 32z'
      
    ]
  };

  
    var faLevelDown = faArrowTurnDown;
  

  
  

  var faBorderRight = {
    prefix: 'fasl',
    iconName: 'border-right',
    icon: [
      448,
      512,
      [],
      'f852',
      
      'M448 32l0 448-32 0 0-448 32 0zM344 40l0 48-48 0 0-48 48 0zm0 432l-48 0 0-48 48 0 0 48zm0-240l0 48-48 0 0-48 48 0zM152 88l-48 0 0-48 48 0 0 48zm0 336l0 48-48 0 0-48 48 0zm0-144l-48 0 0-48 48 0 0 48zM248 40l0 48-48 0 0-48 48 0zm0 432l-48 0 0-48 48 0 0 48zm0-240l0 48-48 0 0-48 48 0zM56 88L8 88 8 40l48 0 0 48zm0 336l0 48L8 472l0-48 48 0zm0-144L8 280l0-48 48 0 0 48zM248 136l0 48-48 0 0-48 48 0zM56 184L8 184l0-48 48 0 0 48zm0 144l0 48L8 376l0-48 48 0zm192 48l-48 0 0-48 48 0 0 48z'
      
    ]
  };

  

  
  

  var faKnifeKitchen = {
    prefix: 'fasl',
    iconName: 'knife-kitchen',
    icon: [
      576,
      512,
      [128298],
      'f6f5',
      
      'M553.4 118.6L576 96 553.4 73.4 502.6 22.6 480 0 457.4 22.6 294.6 185.4 272 208l22.6 22.6L392 328l72-56V208l89.4-89.4zM432 208v48.3l-37.3 29L317.3 208 480 45.3 530.7 96l-89.4 89.4-9.4 9.4V208zM249.4 230.6l-226 226L0 480s11.2 7.5 30 15.2c20.1 8.3 48.9 16.8 82 16.8c118.8 0 216.3-75.7 258.6-114.7l1.2-1.1c13.9-12.9 21.4-21.5 21.4-21.5l-9.4-9.4-22.6-22.6 .1-.1L338.7 320l-.1 .1L316 342.7l22.6 22.6 9.3 9.3c-12.9 11.8-31 27-53.3 42.3C247 449.4 183 480 112 480c-21.5 0-41.1-4.3-57.1-9.7L272 253.3l-22.6-22.6zM448 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faUpFromBracket = {
    prefix: 'fasl',
    iconName: 'up-from-bracket',
    icon: [
      448,
      512,
      [],
      'e590',
      
      'M272 208l0-32 32 0 48 0 0-17.7L224 43.1 96 158.3 96 176l48 0 32 0 0 32 0 112 96 0 0-112zm112 0l-32 0-16 0-32 0 0 32 0 80 0 32-32 0-96 0-32 0 0-32 0-80 0-32-32 0-16 0-32 0 0-32 0-32L224 0 384 144l0 32 0 32zM32 336l0 144 384 0 0-144 0-16 32 0 0 16 0 160 0 16-16 0L16 512 0 512l0-16L0 336l0-16 32 0 0 16z'
      
    ]
  };

  

  
  

  var faMercury = {
    prefix: 'fasl',
    iconName: 'mercury',
    icon: [
      384,
      512,
      [9791],
      'f223',
      
      'M118.6 64C88.2 50.1 62.5 27.7 44.5 0H84.7C111 29.5 149.4 48 192 48s81-18.5 107.3-48h40.2c-18.1 27.7-43.8 50.1-74.1 64C326 91.8 368 153 368 224c0 91.8-70.3 167.2-160 175.3V432h48 16v32H256 208v32 16H176V496 464H128 112V432h16 48V399.3C86.3 391.2 16 315.8 16 224C16 153 58 91.8 118.6 64zM192 368a144 144 0 1 0 0-288 144 144 0 1 0 0 288z'
      
    ]
  };

  

  
  

  var faTransgender = {
    prefix: 'fasl',
    iconName: 'transgender',
    icon: [
      512,
      512,
      [9895,"transgender-alt"],
      'f225',
      
      'M160 0H144 32 16V16 128v16H48V128 54.6L89.4 96l-4.7 4.7L73.4 112 96 134.6l11.3-11.3 4.7-4.7 13.2 13.2C106.8 157.9 96 189.7 96 224c0 83 63.1 151.2 144 159.2V416H208 192v32h16 32v48 16h32V496 448h32 16V416H304 272V383.2c80.9-8 144-76.2 144-159.2c0-34.3-10.8-66.1-29.2-92.2L464 54.6V128v16h32V128 16 0H480 368 352V32h16 73.4l-75.6 75.6C337.1 80.6 298.5 64 256 64s-81.1 16.6-109.8 43.6L134.6 96l4.7-4.7L150.6 80 128 57.4 116.7 68.7 112 73.4 70.6 32H144h16V0zm96 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256z'
      
    ]
  };

  
    var faTransgenderAlt = faTransgender;
  

  
  

  var faSimCard = {
    prefix: 'fasl',
    iconName: 'sim-card',
    icon: [
      384,
      512,
      [],
      'f7c4',
      
      'M32 32V480H352V141.3L242.7 32H32zM256 0L384 128V480v32H352 32 0V480 32 0H32 256zM64 280V224 192H96h64 16 16 40 56 32v32 56 80 56 32H288 224 208 192 96 64V416 360 280zm32 96v40h96V376H152 96zm192 0H224v40h64V376zm-80-32h80V296H232 176 96v48h56 56zm80-120H232 192v40h40 56V224zm-128 0H96v40h64V224z'
      
    ]
  };

  

  
  

  var faDiceFour = {
    prefix: 'fasl',
    iconName: 'dice-four',
    icon: [
      448,
      512,
      [9859],
      'f524',
      
      'M416 64V448H32V64H416zM32 32H0V64 448v32H32 416h32V448 64 32H416 32zM152 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 168a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faMandolin = {
    prefix: 'fasl',
    iconName: 'mandolin',
    icon: [
      512,
      512,
      [],
      'f6f9',
      
      'M370.6 141.4l72.1-24L471.7 69 443 40.3 394.6 69.3l-24 72.1zM368 48L448 0l64 64-48 80L357.9 179.4l-4 1.3-32.5 32.5C324.9 284.6 324.4 512 176 512C78.8 512 0 433.2 0 336C0 187.6 227.4 187.1 298.8 190.6l32.5-32.5 1.3-4L368 48zM224.5 264.9l43.1-43.1c-28.6-.2-65.6 1.4-102.1 7.8c-37.9 6.6-72.4 18-96.7 35.6C45.9 281.7 32 303.6 32 336c0 79.5 64.5 144 144 144c32.4 0 54.3-13.9 70.8-36.8c17.6-24.3 29-58.8 35.6-96.7c6.4-36.5 7.9-73.5 7.8-102.1l-43.1 43.1c5.6 9.5 8.9 20.6 8.9 32.5c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c11.9 0 23 3.2 32.5 8.9zM224 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faMeter = {
    prefix: 'fasl',
    iconName: 'meter',
    icon: [
      512,
      512,
      [],
      'e1e8',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 144v64 16H144V208 144 128h32v16zm96 0v64 16H240V208 144 128h32v16zm96 0v64 16H336V208 144 128h32v16z'
      
    ]
  };

  

  
  

  var faFaceGrinHearts = {
    prefix: 'fasl',
    iconName: 'face-grin-hearts',
    icon: [
      512,
      512,
      [128525,"grin-hearts"],
      'f584',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.5 23.6 54.5 38.3 89.9 38.3s67.4-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm0-32c41 0 79.9-5.3 114.9-14.9c13-3.5 25.4-7.7 37.2-12.3c-3.1 13.8-8 26.9-14.5 39c-26.2 48.9-78 82.2-137.7 82.2s-111.5-33.3-137.7-82.2c-6.5-12.1-11.4-25.2-14.5-39c11.8 4.6 24.3 8.8 37.2 12.3c35.1 9.6 74 14.9 114.9 14.9zM195.1 144.6c-9.3-2.5-18.8 3-21.3 12.3l-4.3 16.1-4.1 15.5L150 184.2l-16.1-4.3c-9.3-2.5-18.8 3-21.3 12.3s3 18.8 12.3 21.3L190 230.9l17.4-65c2.5-9.3-3-18.8-12.3-21.3zm-52.2 4c7.1-26.3 34.1-42 60.4-34.9s42 34.1 34.9 60.4l-21.6 80.5-4.1 15.5-15.5-4.1-80.6-21.6c-26.3-7.1-42-34.1-34.9-60.4s34.1-42 60.4-34.9l.7 .2 .2-.6zm226.1 0l.2 .6 .7-.2c26.3-7.1 53.4 8.6 60.4 34.9s-8.6 53.4-34.9 60.4l-80.6 21.6-15.5 4.1-4.1-15.5-21.6-80.5c-7.1-26.3 8.6-53.4 34.9-60.4s53.4 8.6 60.4 34.9zm-52.2-4c-9.3 2.5-14.8 12-12.3 21.3l17.4 65 65.1-17.4c9.3-2.5 14.8-12 12.3-21.3s-12-14.8-21.3-12.3L362 184.2l-15.5 4.1-4.1-15.5-4.3-16.1c-2.5-9.3-12-14.8-21.3-12.3z'
      
    ]
  };

  
    var faGrinHearts = faFaceGrinHearts;
  

  
  

  var faSplotch = {
    prefix: 'fasl',
    iconName: 'splotch',
    icon: [
      512,
      512,
      [],
      'f5bc',
      
      'M51 237.8c7.8 11.9 12.1 25.7 12.4 39.8c.4 17-4.9 33.7-15.2 47.4L16 368v63.9V464l32-2.9L192 448c20.7 0 40.8 7 57 20l55 44h63.8H400l-3.6-32-4.9-43.9c-4.7-42.2 13.3-83.8 47.3-109.3L512 272V192l-74.4-27.9c-33.9-12.7-60.3-40.1-71.7-74.4L336 0H256L220.8 42.2c-27.7 33.2-71.1 49-113.7 41.2L32 69.8 0 64V96.5 160l51 77.8zM32 150.5V102.3L101.4 115c53.9 9.8 108.9-10.2 144-52.2L271 32h41.9l22.6 67.8c14.5 43.5 47.9 78.2 90.8 94.3L480 214.2V256l-60.4 45.3c-43 32.3-65.8 84.9-59.9 138.4l4.5 40.3h-49L269 443c-21.8-17.5-49-27-77-27c-1 0-1.9 0-2.9 .1L48 429V378.7l25.8-34.4c14.5-19.4 22.1-43.1 21.6-67.3c-.5-20.2-6.6-39.8-17.6-56.6L32 150.5z'
      
    ]
  };

  

  
  

  var faSquareN = {
    prefix: 'fasl',
    iconName: 'square-n',
    icon: [
      448,
      512,
      [],
      'e277',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm128 96h24.2l4.8 6.7L288 318.1V144 128h32v16V368v16H295.8l-4.8-6.7L160 193.9V368v16H128V368 144 128z'
      
    ]
  };

  

  
  

  var faArrowUpRightDots = {
    prefix: 'fasl',
    iconName: 'arrow-up-right-dots',
    icon: [
      576,
      512,
      [],
      'e4b7',
      
      'M144 0H128V32h16H265.4L12.7 284.7 1.4 296 24 318.6l11.3-11.3L288 54.6V176v16h32V176 16 0H304 144zM528 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM400 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 448a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm128-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 448a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 464a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM528 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM512 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faSquareFragile = {
    prefix: 'fasl',
    iconName: 'square-fragile',
    icon: [
      448,
      512,
      ["box-fragile","square-wine-glass-crack"],
      'f49b',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm304 96H230.6l20.7 20.7 13.8 13.8-16.2 10.8-30.2 20.1 31.5 26.3L262.5 230 242 254.5l-12.3-10.2-48-40-16.5-13.7 17.8-11.9 31.8-21.2L185.4 128H144v80c0 44.2 35.8 80 80 80s80-35.8 80-80V128zM144 96H304h32v32 80c0 56.4-41.7 103.1-96 110.9V384h48v32H160V384h48V318.9c-54.3-7.8-96-54.4-96-110.9V128 96h32z'
      
    ]
  };

  
    var faBoxFragile = faSquareFragile;
  
    var faSquareWineGlassCrack = faSquareFragile;
  

  
  

  var faLockKeyholeOpen = {
    prefix: 'fasl',
    iconName: 'lock-keyhole-open',
    icon: [
      576,
      512,
      ["lock-open-alt"],
      'f3c2',
      
      'M448 32c-53 0-96 43-96 96v64h64 32v32V480v32H416 32 0V480 224 192H32 320V128C320 57.3 377.3 0 448 0s128 57.3 128 128v80 16H544V208 128c0-53-43-96-96-96zM32 224V480H416V224H336 32zM264 368H184 168V336h16 80 16v32H264z'
      
    ]
  };

  
    var faLockOpenAlt = faLockKeyholeOpen;
  

  
  

  var faConveyorBeltArm = {
    prefix: 'fasl',
    iconName: 'conveyor-belt-arm',
    icon: [
      640,
      512,
      [],
      'e5f8',
      
      'M128 0V32h16 77.1l-5.5 32.7C193.1 68.7 176 88.3 176 112c0 26.5 21.5 48 48 48c18.6 0 34.8-10.6 42.8-26.2L448 158v50 16h32V208 144 130l-13.9-1.9L271 102.1c-2.9-13.8-11.8-25.5-23.8-32.1l6.3-38H336h16V0H336 144 128zm72 112a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM480 288v32H448V288h32zm-64 0v32H352V288 256H320 288 256v32 32H192V288 256H160 128 96v32l0 32c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H512V288 256H480 448 416v32zM96 352h32 32 32 64 32 32 32 64 32 32 32 32c35.3 0 64 28.7 64 64s-28.7 64-64 64H96c-35.3 0-64-28.7-64-64s28.7-64 64-64zm64-64v32H128V288h32zm128 32V288h32v32H288zM128 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faWarehouse = {
    prefix: 'fasl',
    iconName: 'warehouse',
    icon: [
      640,
      512,
      [],
      'f494',
      
      'M320 6.8l5.9 2.3 304 120 10.1 4V144 496v16H608V496 154.9L320 41.2 32 154.9V496v16H0V496 144 133.1l10.1-4 304-120L320 6.8zM96 192h16H528h16v16V496v16H512v0H128v0H96V496 208 192zm32 288H512V416H128v64zM512 320H128v64H512V320zm0-32V224H128v64H512z'
      
    ]
  };

  

  
  

  var faSunBright = {
    prefix: 'fasl',
    iconName: 'sun-bright',
    icon: [
      512,
      512,
      ["sun-alt"],
      'e28f',
      
      'M272 0V16 96v16H240V96 16 0h32zM0 240H16 96h16v32H96 16 0V240zm400 0h16 80 16v32H496 416 400V240zM272 400v16 80 16H240V496 416 400h32zM86.3 63.7L97.6 75l56.6 56.6 11.3 11.3-22.6 22.6-11.3-11.3L75 97.6 63.7 86.3 86.3 63.7zm-22.6 362L75 414.4l56.6-56.6 11.3-11.3 22.6 22.6-11.3 11.3L97.6 437 86.3 448.3 63.7 425.7zM346.5 142.9l11.3-11.3L414.4 75l11.3-11.3 22.6 22.6L437 97.6l-56.6 56.6-11.3 11.3-22.6-22.6zm22.6 203.6l11.3 11.3L437 414.4l11.3 11.3-22.6 22.6L414.4 437l-56.6-56.6-11.3-11.3 22.6-22.6zM336 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-192 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z'
      
    ]
  };

  
    var faSunAlt = faSunBright;
  

  
  

  var faGears = {
    prefix: 'fasl',
    iconName: 'gears',
    icon: [
      640,
      512,
      ["cogs"],
      'f085',
      
      'M205 56.1L195 8H125L115 56.1c-13.8 5.2-26.5 12.7-37.5 22L34.4 64 0 123.4l33.9 30.3C32.7 160.9 32 168.4 32 176s.7 15.1 1.9 22.3L0 228.6 34.4 288l43.1-14.2c11.1 9.3 23.7 16.8 37.5 22L125 344h70l10-48.1c13.8-5.2 26.5-12.7 37.5-22L285.6 288 320 228.6l-33.9-30.3c1.3-7.3 1.9-14.7 1.9-22.3s-.7-15.1-1.9-22.3L320 123.4 285.6 64 242.5 78.2c-11.1-9.3-23.7-16.8-37.5-22zM271 102.5l8.3 14.3-14.5 12.9-13.3 11.9 3.1 17.6c1 5.4 1.5 11 1.5 16.8s-.5 11.4-1.5 16.8l-3.1 17.6 13.3 11.9 14.5 12.9L271 249.5l-18.4-6.1-17-5.6-13.7 11.5c-8.3 7-17.8 12.6-28.1 16.5l-16.5 6.2-3.6 17.2L169 312H151l-4.7-22.7-3.6-17.2-16.5-6.2c-10.3-3.9-19.8-9.5-28.1-16.5L84.4 237.8l-17 5.6L49 249.5l-8.3-14.3 14.5-12.9 13.3-11.9-3.1-17.6c-1-5.4-1.5-11-1.5-16.8s.5-11.4 1.5-16.8l3.1-17.6L55.2 129.8 40.8 116.9 49 102.5l18.4 6.1 17 5.6 13.7-11.5c8.3-7 17.8-12.6 28.1-16.5l16.5-6.2 3.6-17.2L151 40h18l4.7 22.7 3.6 17.2 16.5 6.2c10.3 3.9 19.8 9.5 28.1 16.5l13.7 11.5 17-5.6 18.4-6.1zM160 200a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-56-24a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zM344.1 307L296 317v70l48.1 10c5.2 13.8 12.7 26.5 22 37.5L352 477.6 411.4 512l30.3-33.9c7.3 1.3 14.7 1.9 22.3 1.9s15.1-.7 22.3-1.9L516.6 512 576 477.6l-14.2-43.1c9.3-11.1 16.8-23.7 22-37.5L632 387V317l-48.1-10c-5.2-13.8-12.7-26.5-22-37.5L576 226.4 516.6 192l-30.3 33.9c-7.3-1.3-14.7-1.9-22.3-1.9s-15.1 .7-22.3 1.9L411.4 192 352 226.4l14.2 43.1c-9.3 11.1-16.8 23.7-22 37.5zM390.5 241l14.3-8.3 12.9 14.5 11.9 13.3 17.6-3.1c5.4-1 11-1.5 16.8-1.5s11.4 .5 16.8 1.5l17.6 3.1 11.9-13.3 12.9-14.5 14.3 8.3-6.1 18.4-5.6 17 11.5 13.7c7 8.3 12.6 17.8 16.5 28.1l6.2 16.5 17.2 3.6L600 343v18l-22.7 4.7-17.2 3.6-6.2 16.5c-3.9 10.3-9.5 19.8-16.5 28.1l-11.5 13.7 5.6 17 6.1 18.4-14.3 8.3-12.9-14.5-11.9-13.3-17.6 3.1c-5.4 1-11 1.5-16.8 1.5s-11.4-.5-16.8-1.5l-17.6-3.1-11.9 13.3-12.9 14.5L390.5 463l6.1-18.4 5.6-17-11.5-13.7c-7-8.3-12.6-17.8-16.5-28.1l-6.2-16.5-17.2-3.6L328 361V343l22.7-4.7 17.2-3.6 6.2-16.5c3.9-10.3 9.5-19.8 16.5-28.1l11.5-13.7-5.6-17L390.5 241zM488 352a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24 56a56 56 0 1 0 0-112 56 56 0 1 0 0 112z'
      
    ]
  };

  
    var faCogs = faGears;
  

  
  

  var faPartyHorn = {
    prefix: 'fasl',
    iconName: 'party-horn',
    icon: [
      512,
      512,
      [],
      'e31b',
      
      'M88 32A24 24 0 1 0 40 32a24 24 0 1 0 48 0zM504 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM480 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM161.4 136L184 158.6l11.3-11.3 8.3-8.3c23.1-23.1 37.7-53.4 41.3-85.9l3-27.4 1.8-15.9L217.9 6.3l-1.8 15.9-3 27.4c-2.8 25.3-14.1 48.8-32.1 66.8l-8.3 8.3L161.4 136zM364.7 316.7L353.4 328 376 350.6l11.3-11.3 8.2-8.3c18-18 41.6-29.3 66.8-32.1l27.4-3 15.9-1.8-3.5-31.8-15.9 1.8-27.4 3c-32.5 3.6-62.8 18.2-85.9 41.3l-8.3 8.3zM510.6 25.9L489.9 1.5 477.7 11.8l-10 8.5c-7.3 6.2-16.6 9.4-26.1 9.2c-38.2-1-70.4 28.5-72.6 66.6l-1.8 30c-1.2 20.9-18.8 37.1-39.8 36.5c-17.4-.5-34.4 5.5-47.7 16.7l-10 8.5-12.2 10.3 20.7 24.4 12.2-10.3 10-8.5c7.3-6.2 16.6-9.4 26.1-9.2c38.2 1 70.4-28.5 72.6-66.6l1.8-30c1.2-20.9 18.8-37.1 39.8-36.5c17.4 .5 34.4-5.5 47.7-16.7l10-8.5 12.2-10.3zM39.9 474.6l-2.5-2.5 25.8-66.3 43 43L39.9 474.6zm147-57.2l-48.1 18.7L75.9 373.2l18.7-48.1 92.3 92.3zM107.3 292.7l-.1-.1L124 249.3 262.7 388l-43.3 16.8-.1-.1-112-112zm-8-68.1L0 480l32 32 255.4-99.3L320 400l-24.7-24.7L136.7 216.7 112 192 99.3 224.6z'
      
    ]
  };

  

  
  

  var faPeace = {
    prefix: 'fasl',
    iconName: 'peace',
    icon: [
      512,
      512,
      [9774],
      'f67c',
      
      'M240 479.4V289.8L93.2 409.9c37.4 39.6 89.1 65.5 146.8 69.6zM72.9 385.1L240 248.4V32.6C123.8 40.8 32 137.7 32 256c0 48.1 15.1 92.6 40.9 129.1zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm16-32.6c57.7-4.1 109.4-30 146.8-69.6L272 289.8V479.4zm167.1-94.3c25.8-36.5 40.9-81 40.9-129.1c0-118.3-91.8-215.2-208-223.4V248.4L439.1 385.1z'
      
    ]
  };

  

  
  

  var faRobot = {
    prefix: 'fasl',
    iconName: 'robot',
    icon: [
      640,
      512,
      [129302],
      'f544',
      
      'M336 0V16 96H512h32v32V480v32H512 128 96V480 128 96h32H304V16 0h32zM128 128V480H512V128H336 304 128zm80 256h32 16v32H240 208 192V384h16zm96 0h32 16v32H336 304 288V384h16zm96 0h32 16v32H432 400 384V384h16zM224 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM32 224H64v32H32V384H64v32H32 0V384 256 224H32zM608 384V256H576V224h32 32v32V384v32H608 576V384h32z'
      
    ]
  };

  

  
  

  var faWhale = {
    prefix: 'fasl',
    iconName: 'whale',
    icon: [
      640,
      512,
      [128011],
      'f72c',
      
      'M157.3 130.7l-4.5-19.5-11-47.7L113.9 91.3l10.3 72.4 72.4 10.3 27.9-27.9-47.7-11-19.5-4.5zm93.9-11.2L288 128l-26.7 26.7L208 208l-91.4-13.1-4 5.1L72.8 250.6c-10.2 13-12.1 30.8-4.6 45.7c7.3 14.5 22.1 23.7 38.3 23.7h4.1c11.3 0 22.2-3.8 31-10.9l121.2-97C330.9 157.7 415.5 128 502.7 128H608h32v32V448v32H608 158.2C70.8 480 0 409.2 0 321.8C0 280 18.1 240.2 49.5 212.7l39.7-34.7 4.3-3.7L80 80l53.3-53.3L160 0l8.5 36.8L184 104l67.2 15.5zM368 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM608 448V160H502.7c-79.9 0-157.5 27.2-219.9 77.1l-121.2 97c-14.5 11.6-32.4 17.9-50.9 17.9h-4.1c-28.4 0-54.3-16-67-41.4c-2.1-4.1-3.7-8.4-5-12.7c-1.7 7.8-2.6 15.8-2.6 23.9C32 391.5 88.5 448 158.2 448H608z'
      
    ]
  };

  

  
  

  var faArrowUpTriangleSquare = {
    prefix: 'fasl',
    iconName: 'arrow-up-triangle-square',
    icon: [
      576,
      512,
      ["sort-shapes-up"],
      'f88a',
      
      'M296 224l20-32L397.1 62.2 416 32l18.9 30.2L516 192l20 32H498.3 333.7 296zm182.3-32L416 92.4 353.7 192H478.3zM160 33.4l11.3 11.3 88 88L270.6 144 248 166.6l-11.3-11.3L176 94.6V464v16H144V464 94.6L83.3 155.3 72 166.6 49.4 144l11.3-11.3 88-88L160 33.4zM352 448H480V320H352V448zM320 288h32H480h32v32V448v32H480 352 320V448 320 288z'
      
    ]
  };

  
    var faSortShapesUp = faArrowUpTriangleSquare;
  

  
  

  var faTowerControl = {
    prefix: 'fasl',
    iconName: 'tower-control',
    icon: [
      448,
      512,
      [],
      'e2a2',
      
      'M160 0h16 48 48 16V32H272 240V64h64 16V80v48H424h20.7l-5.2 20L394.6 320H400h16v32H400 352V496v16H320V496 352l-192 0V496v16H96V496 352H48 32l0-32H48h5.4L8.5 148 3.3 128H24 128V80 64h16 64V32H176 160V0zM128 160H44.7L86.4 320H128V176h0V160zm32 160H288V176h0V160H160V320zM320 160V320l41.6 0 41.7-160H320zm-32-32V96H240 208 160v32H288z'
      
    ]
  };

  

  
  

  var faSpinner = {
    prefix: 'fasl',
    iconName: 'spinner',
    icon: [
      512,
      512,
      [],
      'f110',
      
      'M240 64l32 0V32H240V64zM208 96V64 32 0h32 32 32V32 64 96l-32 0H240 208zM64 240H32v32H64V240zM32 208H64 96v32 32 32H64 32 0V272 240 208H32zM240 448v32h32V448H240zm-32 32V448 416h32 32 32v32 32 32H272 240 208V480zM448 240v32h32V240H448zm-32-32h32 32 32v32 32 32H480 448 416V272 240 208zM108.9 380.5L86.3 403.1l22.6 22.6 22.6-22.6-22.6-22.6zm-45.3 0l22.6-22.6 22.6-22.6 22.6 22.6 22.6 22.6 22.6 22.6-22.6 22.6-22.6 22.6L108.9 471 86.3 448.3 63.7 425.7 41 403.1l22.6-22.6zm316.8 22.6l22.6 22.6 22.6-22.6-22.6-22.6-22.6 22.6zm0 45.3l-22.6-22.6-22.6-22.6 22.6-22.6 22.6-22.6 22.6-22.6 22.6 22.6 22.6 22.6L471 403.1l-22.6 22.6-22.6 22.6L403.1 471l-22.6-22.6zM108.9 131.5l22.6-22.6L108.9 86.3 86.3 108.9l22.6 22.6zm0 45.3L86.3 154.2 63.7 131.5 41 108.9 63.7 86.3 86.3 63.7 108.9 41l22.6 22.6 22.6 22.6 22.6 22.6-22.6 22.6-22.6 22.6-22.6 22.6z'
      
    ]
  };

  

  
  

  var faCircleQuarters = {
    prefix: 'fasl',
    iconName: 'circle-quarters',
    icon: [
      512,
      512,
      [],
      'e3f8',
      
      'M402.7 425.3L256 278.6 109.3 425.3C148.6 459.4 199.9 480 256 480s107.4-20.6 146.7-54.7zm22.6-22.6C459.4 363.4 480 312.1 480 256s-20.6-107.4-54.7-146.7L278.6 256 425.3 402.7zm-22.6-316C363.4 52.6 312.1 32 256 32s-107.4 20.6-146.7 54.7L256 233.4 402.7 86.7zm-316 22.6C52.6 148.6 32 199.9 32 256s20.6 107.4 54.7 146.7L233.4 256 86.7 109.3zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faRotate = {
    prefix: 'fasl',
    iconName: 'rotate',
    icon: [
      512,
      512,
      [128260,"sync-alt"],
      'f2f1',
      
      'M429.1 288C414 369.9 342.3 432 256 432c-52.7 0-99.9-23.1-132.2-59.8l37.6-37.6L184 312l-22.6-22.6L160 288H64 32v32 96l1.4 1.4L56 440l22.6-22.6 22.5-22.5C139.2 437.3 194.5 464 256 464c104 0 190.2-76.3 205.6-176H429.1zM410.9 117.1C372.8 74.7 317.5 48 256 48C152 48 65.8 124.3 50.4 224H82.9C97.9 142.1 169.7 80 256 80c52.7 0 99.9 23.1 132.2 59.8l-37.6 37.6L328 200l22.6 22.6L352 224h96 32V192 96l-1.4-1.4L456 72 433.4 94.6l-22.5 22.5zM130.7 320L64 386.7V320h66.7zM448 192H381.3L448 125.3V192z'
      
    ]
  };

  
    var faSyncAlt = faRotate;
  

  
  

  var faCircleTrash = {
    prefix: 'fasl',
    iconName: 'circle-trash',
    icon: [
      512,
      512,
      ["trash-circle"],
      'e126',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM160 144h32.1 9.3l11.3-11.3 4.7-4.7H224h64 6.6l4.7 4.7L310.6 144h9.3H352h16v32H352h-2.1L336 384H176L162.1 176H160 144V144h16zm157.8 32H194.2l11.7 176H306.1l11.7-176z'
      
    ]
  };

  
    var faTrashCircle = faCircleTrash;
  

  
  

  var faHandPeace = {
    prefix: 'fasl',
    iconName: 'hand-peace',
    icon: [
      512,
      512,
      [9996],
      'f25b',
      
      'M214 12.2l-15.9-1.6-1.6 15.9-4.1 39.8L180.5 180.4l-27-106.2-9.9-38.8-3.9-15.5-15.5 3.9L46.6 43.6 31.1 47.5l3.9 15.5 9.9 38.8L80.1 240H80 64v16 96c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160l0-32 0-80V224l0-16V192H432l-64 0V176H352 293.5l10.2-98.2L307.8 38l1.6-15.9-15.9-1.6L214 12.2zM368 224l48 0v16l0 80v16l-48 0 0-112zm47 144c-7.9 63.1-61.7 112-127 112H224c-70.7 0-128-57.3-128-128V272H256v48H176 160v32h16 80 16 16l48 0v16h16 63zm-79-48H288V256 240 208h48V320zM122.5 82.1L162.7 240H113.1L75.9 93.9 70 70.7l46.5-11.8 5.9 23.3zM256 227.9L254.8 240H206.5L224.1 69.5l2.5-23.9 47.7 4.9-2.5 23.9L261.4 176H256v16 35.9z'
      
    ]
  };

  

  
  

  var faDial = {
    prefix: 'fasl',
    iconName: 'dial',
    icon: [
      576,
      512,
      ["dial-med-high"],
      'e15b',
      
      'M312 8H264V56h48V8zM120 72H72v48h48V72zm336 0v48h48V72H456zM568 264H520v48h48V264zM8 264v48H56V264H8zM120 456H72v48h48V456zm336 0v48h48V456H456zM197.5 197.5c46.2-46.2 118.8-49.7 169-10.6l-89.8 89.8L265.4 288 288 310.6l11.3-11.3 89.8-89.8c39.1 50.2 35.5 122.9-10.6 169c-50 50-131 50-181 0s-50-131 0-181zm203.6-22.6A160 160 0 1 0 174.9 401.1 160 160 0 1 0 401.1 174.9z'
      
    ]
  };

  
    var faDialMedHigh = faDial;
  

  
  

  var faAlt = {
    prefix: 'fasl',
    iconName: 'alt',
    icon: [
      640,
      512,
      [],
      'e08a',
      
      'M464 64h-7.6l-4.8 5.9L168.4 416H16 0v32H16 176h7.6l4.8-5.9L471.6 96H624h16V64H624 464zM432 416H416v32h16H624h16V416H624 432z'
      
    ]
  };

  

  
  

  var faDiagramLeanCanvas = {
    prefix: 'fasl',
    iconName: 'diagram-lean-canvas',
    icon: [
      640,
      512,
      [],
      'e156',
      
      'M512 64V320h96V64H512zm-32 0H384V192h96V64zM352 64H288V320h64V64zm-96 0H160V192h96V64zM128 64H32V320h96V64zM32 352v96H304V352H32zm304 96H608V352H336v96zM0 32H32 608h32V64 448v32H608 32 0V448 64 32zM256 320V224H160v96h96zm224-96H384v96h96V224z'
      
    ]
  };

  

  
  

  var faMugTeaSaucer = {
    prefix: 'fasl',
    iconName: 'mug-tea-saucer',
    icon: [
      640,
      512,
      [],
      'e1f5',
      
      'M240 64H416h16 16V224v32 96H128V64h80v40.5l-42.2 35.2-5.8 4.8V152v88 16h16 96 16V240 152v-7.5l-5.8-4.8L240 104.5V64zM224 32H128 96V64 352v32h32H448h32V352 256h48c61.9 0 112-50.1 112-112s-50.1-112-112-112H480 448 432 416 224zM480 224V64h48c44.2 0 80 35.8 80 80s-35.8 80-80 80H480zM0 448v32H16 560h16V448H560 16 0zM192 224V159.5l32-26.7 32 26.7V224H192z'
      
    ]
  };

  

  
  

  var faTtyAnswer = {
    prefix: 'fasl',
    iconName: 'tty-answer',
    icon: [
      640,
      512,
      ["teletype-answer"],
      'e2b9',
      
      'M280.4 355.3l21.3 12.3L319 350.2l40.7-40.7L475.8 356 453.3 480H448C218.2 480 32 293.7 32 64l0-5.3L156 36.2l46.5 116.1-40.7 40.7-17.3 17.3 12.3 21.3c29.6 51.4 72.4 94.1 123.7 123.7zM512 336L352 272l-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L240 160 176 0 0 32 0 64C0 311.4 200.6 512 448 512h32l32-176zM344 64H296v48h48V64zm0 96H296v48h48V160zm48-96v48h48V64H392zm144 0H488v48h48V64zm48 0v48h48V64H584zm48 96H584v48h48V160zm-216 0H384v32h32 96 32V160H512 416z'
      
    ]
  };

  
    var faTeletypeAnswer = faTtyAnswer;
  

  
  

  var faSpeakers = {
    prefix: 'fasl',
    iconName: 'speakers',
    icon: [
      640,
      512,
      [],
      'f8e0',
      
      'M256 0V32H32V480H256v32H32 0V480 32 0H32 256zm0 256.8v63.6C248.5 284 215.3 256 176 256c-44.2 0-80 35.8-80 80s35.8 80 80 80c39.3 0 72.5-28 80-64.4v63.6c-20.7 20.3-49.1 32.8-80 32.8c-61.9 0-112-50.1-112-112s50.1-112 112-112c30.9 0 59.3 12.5 80 32.8zM176 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM152 336a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM320 32V480H608V32H320zM288 0h32H608h32V32 480v32H608 320 288V480 32 0zM464 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 352a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM440 336a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faFaceVomit = {
    prefix: 'fasl',
    iconName: 'face-vomit',
    icon: [
      576,
      512,
      [],
      'e3a0',
      
      'M288 32C164.3 32 64 132.3 64 256c0 57.4 21.6 109.7 57 149.3L97.2 426.7C56.7 381.4 32 321.6 32 256C32 114.6 146.6 0 288 0S544 114.6 544 256c0 65.6-24.7 125.4-65.2 170.7L455 405.3c35.5-39.6 57-91.9 57-149.3C512 132.3 411.7 32 288 32zM153.8 182l15.9-27.8 13.9 7.9 56 32L263.9 208l-24.3 13.9-56 32-13.9 7.9L153.8 234l13.9-7.9L199.4 208l-31.7-18.1L153.8 182zm254.5 7.9L376.6 208l31.7 18.1 13.9 7.9-15.9 27.8-13.9-7.9-56-32L312.1 208l24.3-13.9 56-32 13.9-7.9L422.2 182l-13.9 7.9zM16 488a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm520-56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM288 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-63.4-78c-19 10.6-32.6 24.7-43.8 39.6l-25.6-19.2c12.8-17.1 29.7-35 53.9-48.4c24.3-13.5 55-22 94.9-22s70.7 8.5 94.9 22c24.2 13.4 41 31.3 53.9 48.4l-25.6 19.2c-11.2-14.9-24.8-29-43.8-39.6c-19-10.5-44.2-18-79.4-18s-60.4 7.5-79.4 18zm11.7 21c1.2-.7 2.5-1.3 3.7-2v19.9c0 39.8-21.2 76.7-55.6 96.7l-11 6.4H418.5l-11-6.4c-34.4-20.1-55.6-56.9-55.6-96.7V357c1.3 .6 2.5 1.3 3.7 2c11.3 6.3 20.4 14.2 28.4 23.4c1.8 26.3 16.5 50.2 39.5 63.6l48.4 28.2 7.9 4.6V488v8 16H464 112 96V496v-8-9.2l7.9-4.6L152.3 446c23-13.4 37.7-37.3 39.5-63.6c8-9.1 17.1-17.1 28.4-23.4z'
      
    ]
  };

  

  
  

  var faHammer = {
    prefix: 'fasl',
    iconName: 'hammer',
    icon: [
      576,
      512,
      [128296],
      'f6e3',
      
      'M504 136l-22.6-22.6L405.5 37.5C381.5 13.5 348.9 0 315 0H291.5c-23.2 0-46 6.3-65.9 18.2L208.5 28.5 176 48l33.9 17L272 96v48l89.4 89.4L384 256l16-16 22.6 22.6 26.7 26.7 3.3 3.3-16 16 22.6 22.6 112-112-22.6-22.6-8 8-3.3-3.3-26.7-26.7L488 152l16-16zm-45.3 0l-16 16 22.6 22.6L514.7 224 472 266.7l-49.4-49.4L400 194.7l-16 16-80-80V96 76.2l-17.7-8.8L242.5 45.4c14.8-8.8 31.8-13.4 49-13.4H315c25.5 0 49.9 10.1 67.9 28.1L458.7 136zM24 394.7L0 416l22.7 22.7 50.7 50.7L96 512l21.3-24L330.7 248 308 225.3 94.6 465.4l-48-48L286.7 204 264 181.3 24 394.7z'
      
    ]
  };

  

  
  

  var faPersonPraying = {
    prefix: 'fasl',
    iconName: 'person-praying',
    icon: [
      448,
      512,
      [128720,"pray"],
      'f683',
      
      'M320 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 224 64zm-66.8 80H168h64 10.2l4.3 9.2 46.7 100.1 95.9-89.1 21.8 23.4-112 104-16.1 14.9-9.3-19.9-21.7-46.4L185.6 399.3l126.5 75 7.8 4.6V488v8 16H304 48 32V480H48 259.1L115.2 394.7c-27.1-16.1-38.5-49.5-26.8-78.8l64.7-161.8 4-10.1zm64.6 32h-43L118.1 327.8c-5.9 14.6-.2 31.4 13.4 39.4l26.3 15.6 75.4-180.9c.1-.2 .2-.5 .3-.7L221.8 176z'
      
    ]
  };

  
    var faPray = faPersonPraying;
  

  
  

  var faCloudsSun = {
    prefix: 'fasl',
    iconName: 'clouds-sun',
    icon: [
      640,
      512,
      [],
      'f746',
      
      'M109.3 135.6l22.5-3.8 3.8-22.5 9-53.9 45.1 31.6L208 99.7l18.4-12.8 45.1-31.6 9 53.9 3.8 22.5 22.2 3.7c8.1-11.2 18.6-20.5 30.8-27.3L312 104 300.5 35 294.7 0 265.6 20.3 208 60.7 150.4 20.3 121.3 0l-5.8 35L104 104 35 115.5 0 121.3l20.3 29.1L60.7 208 20.3 265.6 0 294.7l35 5.8L104 312l11.5 69 5.8 35 29.1-20.3 13-9.1c6.4-27.4 21.7-51.4 42.6-68.9l-16.3 11.4-45.1 31.6-9-53.9-3.8-22.5-22.5-3.8-53.9-9 31.6-45.1L99.7 208 86.9 189.7 55.3 144.6l53.9-9zM288 208c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c14.2 0 27.5-3.7 39.1-10.2c7.8-22.5 21.8-42.2 39.9-56.9c.7-4.2 1-8.5 1-12.9zm-32 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm150.7-47.9h20.9l8.4-19.2c7.4-17 24.4-28.8 44-28.8c23.2 0 42.6 16.5 47 38.3l5.2 25.6h26.2H568c22.1 0 40 17.9 40 40v40H574.4c9.4 9.2 17.1 20 22.8 32H608h32v-32-40c0-39.8-32.2-72-72-72h-9.6c-7.4-36.5-39.7-64-78.4-64c-32.8 0-61 19.7-73.3 48H384.1c-35.3 0-64 28.6-64 64c0 3 .2 6 .6 8.9c9.9-3.9 20.4-6.7 31.4-8c0-.3 0-.6 0-.9c0-17.7 14.3-32 32-32h22.6zM368 224c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6v64 32h32 64H559.9l48 0h32v-80c0-37.1-25.3-68.4-59.7-77.4c-2-.5-4.1-1-6.2-1.4c.5-2.1 .8-4.1 1.1-6.2c.5-3.6 .8-7.3 .8-11c0-44.2-35.8-80-80-80c-13.2 0-25.7 3.2-36.7 8.9c-3.2 1.6-6.2 3.5-9.1 5.5c-2.2-3.6-4.6-7.1-7.3-10.4C425.2 238 398.2 224 368 224zM607.9 431.9v48l-48 0H288 224v-64c0-31.7 23-58 53.3-63.1l26.9-4.5-.2-27.3 0-1.2c.1-35.3 28.7-63.9 64-63.9c23.2 0 43.5 12.3 54.8 30.9l17.7 29.3 28-19.6c7.8-5.4 17.2-8.6 27.4-8.6c26.5 0 48 21.5 48 48c0 3.6-.4 7.1-1.1 10.4l-7.1 32.5 32.8 5.8c22.4 4 39.5 23.7 39.5 47.2z'
      
    ]
  };

  

  
  

  var faTrophy = {
    prefix: 'fasl',
    iconName: 'trophy',
    icon: [
      576,
      512,
      [127942],
      'f091',
      
      'M271.6 381c.1 0 .3 .1 .4 .1V480H176 160v32h16H288 400h16V480H400 304V381.1c.1 0 .3-.1 .4-.1l2.3-.4c34-6 100.6-27.8 159.1-74.4C524.8 259.2 576 186.5 576 80V64H560 446.4c.5-10.3 .9-21 1.2-32c.3-10.4 .4-21 .4-32H416 160 128c0 11 .1 21.6 .4 32c.3 11 .7 21.7 1.2 32H16 0V80C0 186.5 51.2 259.2 110.2 306.1c58.5 46.6 125.1 68.5 159.1 74.4l2.3 .4zm25.3-31.2l-8.9 1.6-8.9-1.6c-1.3-.4-2.7-.9-4.2-1.5c-10.2-4.1-25.8-13-42.3-32.8C201.3 278 164.6 198.4 160.4 32H415.6c-4.2 166.4-40.9 246-72.2 283.5c-16.5 19.8-32.1 28.7-42.3 32.8c-1.5 .6-2.9 1.1-4.2 1.5zm80.9-26.6C407 281.9 434.5 212.5 444.2 96h99.3c-4.8 85.9-47.6 145.2-97.7 185.1c-22.3 17.8-46 31.6-68.1 42.1zm-179.6 0c-22.2-10.5-45.8-24.3-68.1-42.1C80 241.2 37.2 181.9 32.4 96h99.3c9.8 116.5 37.2 185.9 66.4 227.2z'
      
    ]
  };

  

  
  

  var faWheatSlash = {
    prefix: 'fasl',
    iconName: 'wheat-slash',
    icon: [
      640,
      512,
      [],
      'e339',
      
      'M523.5 278.5l22.6-22.6 22.6-22.6L546 210.7l-11.3-11.3c-18-18-40-29.5-63.2-34.6l16.9-.8c45.1-2.3 81.2-38.4 83.5-83.5l2.4-48.4L576 0 543.9 1.6 495.5 4C450.4 6.3 414.3 42.4 412 87.5l-.9 17.7c-4.9-23.5-16.5-46-34.8-64.2L365.1 29.7 342.5 7.1 319.8 29.7 297.2 52.3c-19.1 19.1-28.5 44.3-28.1 69.4l42.3 33.4c-16.2-24.8-13.4-58.4 8.4-80.2l22.6-22.6 11.3 11.3c35.4 35.4 37.4 91.7 5.8 129.4l26.2 20.7c37.6-29 91.9-26.3 126.4 8.2l11.3 11.3-22.6 22.6c-10.7 10.8-24.4 16.9-38.4 18.4l31.1 24.6c10.9-4.7 21-11.4 29.9-20.3zM286.9 311.4l-25.3-20-29 29c1.3-20.6-2.4-41.4-11-60.6l-73.7-58.2-9 9-22.6 22.6c-37.5 37.5-37.5 98.3 0 135.8L150.2 403 68.7 484.5l22.6 22.6 81.5-81.5 0 0 33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6 22.6-22.6-22.6-22.6-11.3-11.3c-27-27-63.2-39.4-98.6-37.2l31.7-31.7zM542.3 33.7L540 78.9c-1.4 28.7-24.4 51.7-53.1 53.1l-45.2 2.3L444 89.1c1.4-28.7 24.4-51.7 53.1-53.1l45.2-2.3zM172.8 380.3l-33.9-33.9c-25-25-25-65.5 0-90.5l22.6-22.6 11.3 11.3c37.2 37.2 37.5 97.4 .8 135l-.8 .8zm169.6 33.9l-22.6 22.6c-25 25-65.5 25-90.5 0L195.5 403c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faThumbtack = {
    prefix: 'fasl',
    iconName: 'thumbtack',
    icon: [
      384,
      512,
      [128204,128392,"thumb-tack"],
      'f08d',
      
      'M280 209.7l11.9 8.7c21.2 15.5 36.6 35.9 46.6 55c5 9.5 8.5 18.4 10.7 25.6c1.1 3.6 1.8 6.7 2.3 9c.2 1.2 .3 2.1 .4 2.8c0 .4 .1 .6 .1 .8l0 .2 0 .1 0 0 0 0v0c0 0 0 0 0 0v8H208V224 208H176v16 96H32v-8 0c0-6 3.2-22 13.5-41.6c9.9-18.9 25.1-38.5 46.2-53.3l12.4-8.7 1.2-15.1L117.6 32H266.4l12.5 163 1.1 14.7zM208 352H352h32V320v-8c0-21.3-21.3-81.6-73.2-119.5L298.5 32H320h16V0H320 296 88 64 48V32H64 85.5L73.3 191C21.3 227.5 0 286.4 0 312v8 32H32 176V496v16h32V496 352z'
      
    ]
  };

  
    var faThumbTack = faThumbtack;
  

  
  

  var faSignatureSlash = {
    prefix: 'fasl',
    iconName: 'signature-slash',
    icon: [
      640,
      512,
      [],
      'e3cb',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM378.8 384H336 320v32h16 83.4l-40.5-32zm85-96l40.5 32H560h16V288H560 463.8zM626 416h14V384H624 585.4L626 416zM478.3 183.2l16-32-34.5 9.4-117 31.9L374 217.1l59.7-16.3L411 246.3l25.7 20.3 41.7-83.4zM320 131.4V128c0-53-43-96-96-96c-22.2 0-42.6 7.5-58.9 20.2l26.3 20.7c9.6-5.7 20.7-8.9 32.6-8.9c35.3 0 64 28.7 64 64v3.4c0 5.8-.1 11.7-.4 17.5L318.1 173c1.3-13.8 1.9-27.7 1.9-41.6zM107.8 256.6L96 259.8V272 464v16h16 80 9.4l4.6-8.2L247.5 398c15.6-27.7 28.7-56.8 39-86.9L259.8 290c-10.2 32-23.7 63-40.2 92.3l-37 65.7H128V284.2L220.5 259l-31.2-24.7-81.5 22.2zM128 186v6h7.6l-7.6-6zM16 384H0v32H16 48 64V384H48 16z'
      
    ]
  };

  

  
  

  var faPhoneHangup = {
    prefix: 'fasl',
    iconName: 'phone-hangup',
    icon: [
      640,
      512,
      [],
      'e225',
      
      'M416 264v96l160 32 64-144c-37.3-48-153.6-144-320-144S37.3 200 0 248L64 392l160-32V264c62.3-20.8 129.7-20.8 192 0zM192 333.8L82.8 355.6 37.5 253.5C80.3 208.3 181.3 136 320 136s239.7 72.3 282.5 117.5L557.2 355.6 448 333.8V264 240.9l-21.9-7.3c-68.9-23-143.4-23-212.2 0L192 240.9V264v69.8z'
      
    ]
  };

  

  
  

  var faFaceSmile = {
    prefix: 'fasl',
    iconName: 'face-smile',
    icon: [
      512,
      512,
      [128578,"smile"],
      'f118',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm129.7 71.2l28.6-14.3c8.7 17.5 41.3 55.2 97.7 55.2s88.9-37.7 97.7-55.2l28.6 14.3C369.7 352.3 327.6 400 256 400s-113.7-47.7-126.3-72.8zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faSmile = faFaceSmile;
  

  
  

  var faPersonSign = {
    prefix: 'fasl',
    iconName: 'person-sign',
    icon: [
      512,
      512,
      [],
      'f757',
      
      'M308.8 0L298.1 30.1 256 148.4l82.8 30.8-18.2 49.5-55.4-18.5L212 149.5l-4.8-5.5H200 88 78.1l-4.4 8.8-72 144 28.6 14.3L80 211.8V336 496v16h32V496 352h70.9L224 420.4V496v16h32V496 416v-4.4l-2.3-3.8L208 331.6V193.4l36 41.1 2.9 3.3 4.1 1.4 58.6 19.5L289 314.5l-5.5 15 30 11.1 5.5-15 49.8-135.2 60.4 22.5 30 11.2 10.7-30.2L512 75.6l-88.7-33L434.5 12 404.5 1 393.3 31.4 338.8 11.2 308.8 0zM112 320V176h64V320H112zM328.1 41.3L471.3 94.6l-31.4 88.1L296.7 129.4l31.4-88.1zM120 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 88 56a56 56 0 1 0 112 0z'
      
    ]
  };

  

  
  

  var faDisplay = {
    prefix: 'fasl',
    iconName: 'display',
    icon: [
      576,
      512,
      [],
      'e163',
      
      'M32 32V384H231.7c.2 0 .4 0 .6 0H343.7c.2 0 .4 0 .6 0H544V32H32zM213.1 416H32 0V384 32 0H32 544h32V32 384v32H544 362.9l10.7 64H432h16v32H432 360 216 144 128V480h16 58.4l10.7-64zm32.4 0l-10.7 64H341.1l-10.7-64H245.6z'
      
    ]
  };

  

  
  

  var faCoinVertical = {
    prefix: 'fasl',
    iconName: 'coin-vertical',
    icon: [
      384,
      512,
      [],
      'e3fd',
      
      'M256 256c0-66.2-15.2-124.6-38.1-165.3C194.5 49 167.1 32 144 32s-50.5 17-73.9 58.7C47.2 131.4 32 189.8 32 256s15.2 124.6 38.1 165.3C93.5 463 120.9 480 144 480s50.5-17 73.9-58.7C240.8 380.6 256 322.2 256 256zm24.8 80h64.3c3.6-20 5.8-41.5 6.6-64h-64c-.8 22.2-3.1 43.7-6.9 64zm-7.3 32c-4.7 17.2-10.5 33.2-17.1 48h64.7c6.5-14.2 12.3-30.3 17-48H273.5zM213.8 480H256c12.8 0 29.9-8.5 46.8-32H239.2c-7.8 12.2-16.3 23-25.5 32zm74-240h64c-.7-22.5-3-44-6.6-64H280.8c3.8 20.3 6.1 41.8 6.9 64zm-74-208c9.2 9 17.7 19.8 25.5 32h63.6c-16.9-23.5-34-32-46.8-32H213.8zm59.8 112h64.6c-4.7-17.7-10.5-33.8-17-48H256.4c6.7 14.8 12.4 30.8 17.1 48zM144 512C64.5 512 0 397.4 0 256S64.5 0 144 0h32 80c70.7 0 128 114.6 128 256s-57.3 256-128 256H176 144zM88 256c0 47.1 7.4 89.1 18.8 118.7c5.7 14.8 12.2 25.8 18.5 32.7c6.3 6.9 11.3 8.6 14.7 8.6s8.3-1.7 14.7-8.6c6.3-6.9 12.8-17.8 18.5-32.7C184.6 345.1 192 303.1 192 256s-7.4-89.1-18.8-118.7c-5.7-14.8-12.2-25.8-18.5-32.7C148.3 97.7 143.4 96 140 96s-8.3 1.7-14.7 8.6c-6.3 6.9-12.8 17.8-18.5 32.7C95.4 166.9 88 208.9 88 256zM140 64c15.4 0 28.3 8.2 38.3 19c9.9 10.9 18.2 25.7 24.7 42.7c13.2 34.1 21 80.2 21 130.2s-7.8 96.1-21 130.2c-6.6 17-14.8 31.9-24.7 42.7c-9.9 10.9-22.9 19-38.3 19s-28.3-8.2-38.3-19c-9.9-10.9-18.2-25.7-24.7-42.7C63.8 352.1 56 306.1 56 256s7.8-96.1 21-130.2c6.6-17 14.8-31.9 24.7-42.7c9.9-10.9 22.9-19 38.3-19z'
      
    ]
  };

  

  
  

  var faLocationCheck = {
    prefix: 'fasl',
    iconName: 'location-check',
    icon: [
      384,
      512,
      ["map-marker-check"],
      'f606',
      
      'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 20.2 9.1 48.6 26.5 82.7c16.9 33.2 39.9 68.2 63.4 100.5c23.4 32.2 46.9 61 64.5 81.9c1.9 2.3 3.8 4.5 5.6 6.6c1.8-2.1 3.6-4.3 5.6-6.6c17.7-20.8 41.1-49.7 64.5-81.9c23.5-32.3 46.4-67.3 63.4-100.5C342.9 240.6 352 212.2 352 192zm32 0c0 88.8-120.7 237.9-170.7 295.9C200.2 503.1 192 512 192 512s-8.2-8.9-21.3-24.1C120.7 429.9 0 280.8 0 192C0 86 86 0 192 0S384 86 384 192zM176.6 256.6L165.3 268 154 256.6l-60-60L116.6 174l48.7 48.7 102-102L290 143.3 176.6 256.6z'
      
    ]
  };

  
    var faMapMarkerCheck = faLocationCheck;
  

  
  

  var faConveyorBelt = {
    prefix: 'fasl',
    iconName: 'conveyor-belt',
    icon: [
      640,
      512,
      [],
      'f46e',
      
      'M480 32V256H160V32h80v90.7V160l32-19.2L320 112l48 28.8L400 160V122.7 32h80zM272 32h96v71.5L336.5 84.6 320 74.7l-16.5 9.9L272 103.5V32zM480 0H400 368 272 240 160 128V32 256v32h32H480h32V256 32 0H480zM608 416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64s28.7-64 64-64H544c35.3 0 64 28.7 64 64zM96 320c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H96zm56 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faGlassWaterDroplet = {
    prefix: 'fasl',
    iconName: 'glass-water-droplet',
    icon: [
      384,
      512,
      [],
      'e4f5',
      
      'M58.9 343.4l5.2 2.6c30.4 15.2 66.9 11.3 93.4-9.9c20.1-16.1 48.8-16.1 68.9 0c26.5 21.2 63 25.1 93.4 9.9l5.2-2.6L314.4 480H69.6L58.9 343.4zM25.5 326.6L40 512H344l14.5-185.4 .7-.3-.6-1.1L381.5 32 384 0H351.9 32.1 0L2.5 32 25.4 325.2l-.6 1.1 .7 .3zM56 306.1L34.6 32H349.4L328 306.1l-22.4 11.2c-19.2 9.6-42.3 7.2-59.1-6.3c-31.8-25.5-77.1-25.5-108.9 0c-16.8 13.4-39.9 15.9-59.1 6.3L56 306.1zm136-162l24 27c5.2 5.8 8 13.3 8 21.1c0 17.4-14.3 31.8-32 31.8s-32-14.4-32-31.8c0-7.8 2.9-15.3 8-21.1l24-27zm-21.4-24.1l-26.5 29.8c-10.4 11.7-16.1 26.7-16.1 42.4c0 35.2 28.8 63.8 64 63.8s64-28.5 64-63.8c0-15.6-5.7-30.7-16.1-42.4l-26.5-29.8L192 96l-21.4 24.1z'
      
    ]
  };

  

  
  

  var faTruckMoving = {
    prefix: 'fasl',
    iconName: 'truck-moving',
    icon: [
      640,
      512,
      [],
      'f4df',
      
      'M32 64V304v32c13.4-10 30-16 48-16c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c32.8 0 61 19.7 73.3 48H448V256 224 64H32zM480 336c13.4-10 30-16 48-16c32.8 0 61 19.7 73.3 48H608V304 256H480v80zm0-112H602.5l-57.6-64H480v64zm160-6.1V224v32 48 64 32H608c0 44.2-35.8 80-80 80s-80-35.8-80-80H288c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80V368 304 64 32H32 448h32V64v64h72 7.1l4.8 5.3 72 80 4.1 4.6zM528 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faPercent = {
    prefix: 'fasl',
    iconName: 'percent',
    icon: [
      384,
      512,
      [62101,62785,"percentage"],
      '25',
      
      'M96 96H32v64H96V96zM32 64H96h32V96v64 32H96 32 0V160 96 64H32zM4.7 420.7l352-352 22.6 22.6-352 352L4.7 420.7zM288 352v64h64V352H288zm-32-32h32 64 32v32 64 32H352 288 256V416 352 320z'
      
    ]
  };

  
    var faPercentage = faPercent;
  

  
  

  var faHandMiddleFinger = {
    prefix: 'fasl',
    iconName: 'hand-middle-finger',
    icon: [
      448,
      512,
      [128405],
      'f806',
      
      'M208 0H192V16 192H128 112v16 36L38.4 299.2 32 304v8 51.5c0 53 29.1 101.7 75.7 126.8l8.3 4.5c21 11.3 44.4 17.2 68.3 17.2H320c61.9 0 112-50.1 112-112V304 256 240H416 368V224 208H352 304V16 0H288 208zm80 240h48v16 16h16 48v32 96c0 44.2-35.8 80-80 80H184.3c-18.5 0-36.8-4.6-53.1-13.4l-7.6 14.1 7.6-14.1-8.3-4.5C86.6 442.6 64 404.7 64 363.5V320l48-36v60 16h32V344 264v-4-8-4V224h64 16V208 32h48V224v16h16z'
      
    ]
  };

  

  
  

  var faBrightnessLow = {
    prefix: 'fasl',
    iconName: 'brightness-low',
    icon: [
      512,
      512,
      [],
      'e0ca',
      
      'M232 56v48h48V56H232zm24 136a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM131.6 97.6L97.6 131.5l33.9 33.9 33.9-33.9L131.6 97.6zM56 280h48l0-48H56v48zM97.6 380.5l33.9 33.9 33.9-33.9-33.9-33.9L97.6 380.5zM280 408H232v48h48V408zm100.4-61.5l-33.9 33.9 33.9 33.9 33.9-33.9-33.9-33.9zM408 232v48h48V232H408zM346.5 131.5l33.9 33.9 33.9-33.9L380.4 97.6l-33.9 33.9z'
      
    ]
  };

  

  
  

  var faGaugeCircleMinus = {
    prefix: 'fasl',
    iconName: 'gauge-circle-minus',
    icon: [
      640,
      512,
      [],
      'e497',
      
      'M256 480c32.2 0 62.8-6.8 90.5-19c5.8 9.3 12.5 18 19.8 26.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-8.4 0-16.7 .6-24.8 1.7C444.3 100.3 358.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-194 0-16 32 0 0 16 0 194c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64zM144 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM72 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM344 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 160H560l-128 0-16 0V352h16H560h16v32z'
      
    ]
  };

  

  
  

  var faCarTilt = {
    prefix: 'fasl',
    iconName: 'car-tilt',
    icon: [
      640,
      512,
      [],
      'f5e5',
      
      'M77.4 77.6L66 80.6l-.4 11.9L61.2 232.3 45 236.6l-30.9 8.3 8.3 30.9L61 419.7 65.3 436l0 0L77.1 480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H108.6l-10-37.2 1.5-.4L508.7 332.9l1.5-.4L526 391.3l29.4-7.9-19.7-73.5 0 0-4.3-16.2-38.6-144-8.3-30.9-30.9 8.3-16.5 4.4L359.5 13.4l-6.3-9.7L342 6.7 77.4 77.6zm327.1 62.7l-311 83.3 3.7-118.2L339.1 40.6l65.4 99.7zM461.8 158l38.6 144L91.9 411.5l-38.6-144L461.8 158zM141.2 336.9a22.8 22.8 0 1 0 -11.8-44.1 22.8 22.8 0 1 0 11.8 44.1zM436.6 234.1a22.8 22.8 0 1 0 -44.1 11.8 22.8 22.8 0 1 0 44.1-11.8z'
      
    ]
  };

  

  
  

  var faVrCardboard = {
    prefix: 'fasl',
    iconName: 'vr-cardboard',
    icon: [
      640,
      512,
      [],
      'f729',
      
      'M336 320l64 128H608h32V416 96 64H608 32 0V96 416v32H32 240l64-128h32zM220.2 416H32V96H608V416H419.8L364.6 305.7 355.8 288H336 304 284.2l-8.8 17.7L220.2 416zM176 192a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm240-80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faShieldMinus = {
    prefix: 'fasl',
    iconName: 'shield-minus',
    icon: [
      512,
      512,
      [],
      'e249',
      
      'M48.5 114.9L256 34.3l207.5 80.5c2.7 45.6-4.5 116.8-34.7 186.3S345.4 438.4 256 477.1C166.6 438.4 113.4 370.7 83.2 301.2S45.8 160.5 48.5 114.9zm447-1.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM160 240H144v32h16H352h16V240H352 160z'
      
    ]
  };

  

  
  

  var faThermometer = {
    prefix: 'fasl',
    iconName: 'thermometer',
    icon: [
      512,
      512,
      [],
      'f491',
      
      'M352.8 53.8c14-14 32.9-21.8 52.7-21.8c41.1 0 74.5 33.4 74.5 74.5c0 19.8-7.8 38.7-21.8 52.7L233.4 384H128V278.6l32-32 36.7 36.7L208 294.6 230.6 272l-11.3-11.3L182.6 224 224 182.6l36.7 36.7L272 230.6 294.6 208l-11.3-11.3L246.6 160 288 118.6l36.7 36.7L336 166.6 358.6 144l-11.3-11.3L310.6 96l42.2-42.2zM96 272V393.4L12.7 476.7 1.4 488 24 510.6l11.3-11.3L118.6 416H240h6.6l4.7-4.7L480.8 181.8c20-20 31.2-47.1 31.2-75.3C512 47.7 464.3 0 405.5 0c-28.2 0-55.3 11.2-75.3 31.2L288 73.4 265.4 96 224 137.4 201.4 160 160 201.4 137.4 224l-36.7 36.7L96 265.4V272z'
      
    ]
  };

  

  
  

  var faCloudMinus = {
    prefix: 'fasl',
    iconName: 'cloud-minus',
    icon: [
      640,
      512,
      [],
      'e35d',
      
      'M544 241.1V232c0-57.4-46.6-104-104-104c-13.4 0-26.2 2.5-37.9 7.1l-24.3 9.5-14.2-22C340.8 87.3 301.1 64 256 64c-70.7 0-128 57.3-128 128v8.2 22.6l-21.3 7.5C63.1 245.8 32 287.3 32 336V448H144 512h96V352c0-35.5-19.2-66.5-48-83.2l-16-9.2V241.1zM0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c56.4 0 106 29.2 134.5 73.3c15.3-6 32-9.3 49.5-9.3c75.1 0 136 60.9 136 136v9.1c38.3 22.1 64 63.5 64 110.9v96 32H608 512 144 32 0V448 336zm224-64H416h16v32H416 224 208V272h16z'
      
    ]
  };

  

  
  

  var faTrafficLight = {
    prefix: 'fasl',
    iconName: 'traffic-light',
    icon: [
      320,
      512,
      [128678],
      'f637',
      
      'M32 32V352c0 70.7 57.3 128 128 128s128-57.3 128-128V32H32zM0 0H32 288h32V32 352c0 88.4-71.6 160-160 160S0 440.4 0 352V32 0zM136 392a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM160 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 80a56 56 0 1 1 0-112 56 56 0 1 1 0 112zM136 120a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0z'
      
    ]
  };

  

  
  

  var faCloudMusic = {
    prefix: 'fasl',
    iconName: 'cloud-music',
    icon: [
      640,
      512,
      [],
      'f8ae',
      
      'M544 241.1V232c0-57.4-46.6-104-104-104c-13.4 0-26.2 2.5-37.9 7.1l-24.3 9.5-14.2-22C340.8 87.3 301.1 64 256 64c-70.7 0-128 57.3-128 128v8.2 22.6l-21.3 7.5C63.1 245.8 32 287.3 32 336V448H144 512h96V352c0-35.5-19.2-66.5-48-83.2l-16-9.2V241.1zM0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c56.4 0 106 29.2 134.5 73.3c15.3-6 32-9.3 49.5-9.3c75.1 0 136 60.9 136 136v9.1c38.3 22.1 64 63.5 64 110.9v96 32H608 512 144 32 0V448 336zM416 200V328c0 .5 0 1-.1 1.5c0 .8 .1 1.6 .1 2.5c0 24.3-21.5 44-48 44s-48-19.7-48-44s21.5-44 48-44c5.6 0 11 .9 16 2.5V223.1l-96 36V360c0 .5 0 1-.1 1.5c0 .8 .1 1.6 .1 2.5c0 24.3-21.5 44-48 44s-48-19.7-48-44s21.5-44 48-44c5.6 0 11 .9 16 2.5V248 236.9l10.4-3.9 128-48 21.6-8.1V200zM256 364c0-4.1-4.5-12-16-12s-16 7.9-16 12s4.5 12 16 12s16-7.9 16-12zm112-20c11.5 0 16-7.9 16-12s-4.5-12-16-12s-16 7.9-16 12s4.5 12 16 12z'
      
    ]
  };

  

  
  

  var faDownToDottedLine = {
    prefix: 'fasl',
    iconName: 'down-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e408',
      
      'M272 176v32h32 48v17.7L224 340.9 96 225.7V208h48 32V176 64h96V176zm112 0H352 336 304V144 64 32H272 176 144V64v80 32H112 96 64v32 32L224 384 384 240V208 176zM56 424H8v48H56V424zm96 0H104v48h48V424zm48 48h48V424H200v48zm144-48H296v48h48V424zm48 0v48h48V424H392z'
      
    ]
  };

  

  
  

  var faFaceExpressionless = {
    prefix: 'fasl',
    iconName: 'face-expressionless',
    icon: [
      512,
      512,
      [],
      'e373',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160 80H352h16v32H352 160 144V336h16zM128 192h16 64 16v32H208 144 128V192zm176 0h64 16v32H368 304 288V192h16z'
      
    ]
  };

  

  
  

  var faBabyCarriage = {
    prefix: 'fasl',
    iconName: 'baby-carriage',
    icon: [
      512,
      512,
      ["carriage-baby"],
      'f77d',
      
      'M256 192L123 0C52.3 35.8 3.1 108 .1 192H0v16c0 2.5 0 4.9 .1 7.4c.1 2.9 .3 5.8 .5 8.6c1.8 22.2 7.5 44 16.8 64.5C28.9 314 45.7 336.9 66.6 356c20.9 19.2 45.6 34.2 72.6 44.5S195 416 224 416s57.9-5.2 84.8-15.5s51.6-25.3 72.6-44.5s37.7-42.1 49.2-67.5c9.3-20.5 14.9-42.3 16.8-64.5c.2-2.7 .4-5.3 .5-8h.2v-8V192 128h48 16V96H496 432 416v16 80H264v0h-8zm-38.9 0H32.2c2.5-61.6 34.1-115.9 81.6-149.2L217.1 192zm38.7 32c.1 0 .1 0 .2 0H415.2c-1.8 17.6-6.4 34.9-13.8 51.4c-9.6 21.4-23.8 40.8-41.6 57.1s-39 29.3-62.3 38.2S249.2 384 224 384s-50.2-4.6-73.5-13.4s-44.5-21.8-62.3-38.2s-32-35.7-41.6-57.1c-7.4-16.4-12.1-33.7-13.8-51.4h223zM80 448a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm272-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  
    var faCarriageBaby = faBabyCarriage;
  

  
  

  var faRadio = {
    prefix: 'fasl',
    iconName: 'radio',
    icon: [
      512,
      512,
      [128251],
      'f8d7',
      
      'M32 160v80V480H480V160H32zM0 240V160 136v-8-4.5l12.1-3 480-120 7.8 31L114 128H480h32v32V480v32H480 32 0V480 240zm96 0h96 16v32H192 96 80V240H96zM80 304H208h16v32H208 80 64V304H80zm16 64h96 16v32H192 96 80V368H96zM352 256a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm96 64a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z'
      
    ]
  };

  

  
  

  var faEllipsisStroke = {
    prefix: 'fasl',
    iconName: 'ellipsis-stroke',
    icon: [
      512,
      512,
      ["ellipsis-h-alt"],
      'f39b',
      
      'M64 224l64 0 0 64-64 0 0-64zM32 288l0 32 32 0 64 0 32 0 0-32 0-64 0-32-32 0-64 0-32 0 0 32 0 64zm192-64l64 0 0 64-64 0 0-64zm-32 64l0 32 32 0 64 0 32 0 0-32 0-64 0-32-32 0-64 0-32 0 0 32 0 64zm192 0l0-64 64 0 0 64-64 0zm-32 32l32 0 64 0 32 0 0-32 0-64 0-32-32 0-64 0-32 0 0 32 0 64 0 32z'
      
    ]
  };

  
    var faEllipsisHAlt = faEllipsisStroke;
  

  
  

  var faBatteryQuarter = {
    prefix: 'fasl',
    iconName: 'battery-quarter',
    icon: [
      576,
      512,
      ["battery-2"],
      'f243',
      
      'M480 128V384H32V128H480zM32 96H0v32V384v32H32 480h32V384 128 96H480 32zm544 96H544v32 64 32h32V288 224 192zM96 192h64V320H96V192zM64 160v32V320v32H96h64 32V320 192 160H160 96 64z'
      
    ]
  };

  
    var faBattery2 = faBatteryQuarter;
  

  
  

  var faVideoSlash = {
    prefix: 'fasl',
    iconName: 'video-slash',
    icon: [
      640,
      512,
      [],
      'f4e2',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM608 99.8V64L576 80 448 144v35.8l128-64V376.6l32 25.3V99.8zM416 413.3l-32-25.3V416H64V135.4L32 110.2V416v32H64 384h32V416v-2.7zm0-163.1V160 96 64H384 180.1l40.5 32H384V225l32 25.3z'
      
    ]
  };

  

  
  

  var faFrame = {
    prefix: 'fasl',
    iconName: 'frame',
    icon: [
      448,
      512,
      [],
      'e495',
      
      'M448 128l0-32-64 0 0-64-32 0 0 64L96 96l0-64L64 32l0 64L0 96l0 32 64 0 0 256L0 384l0 32 64 0 0 64 32 0 0-64 256 0 0 64 32 0 0-64 64 0 0-32-64 0 0-256 64 0zM96 384l0-256 256 0 0 256L96 384z'
      
    ]
  };

  

  
  

  var faComputerClassic = {
    prefix: 'fasl',
    iconName: 'computer-classic',
    icon: [
      448,
      512,
      [],
      'f8b1',
      
      'M416 32V400H32V32H416zM32 0H0V32 400v32H32v48 32H64 384h32V480 432h32V400 32 0H416 32zM64 432H384v48H64V432zM352 96V224H96V96H352zM96 64H64V96 224v32H96 352h32V224 96 64H352 96zM224 320v32h16H368h16V320H368 240 224zM96 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faPumpSoap = {
    prefix: 'fasl',
    iconName: 'pump-soap',
    icon: [
      448,
      512,
      [],
      'e06b',
      
      'M144 0h96 16V16 48h96 6.6l4.7 4.7 48 48L422.6 112 400 134.6l-11.3-11.3L345.4 80H256v48H224V32H160v96H128V16 0h16zM64.1 512H32l2.2-32L56 160H328l21.8 320 2.2 32H319.9 64.1zm2.2-32H317.7L298.1 192H85.9L66.3 480zM192 236.7l13 17.9 45.3 62.5c9 12.4 13.8 27.3 13.8 42.6c0 39.7-32.1 72.3-72 72.3s-72-32.6-72-72.3c0-15.2 4.8-30.2 13.8-42.6L179 254.6l13-17.9zm0 54.6l-32.3 44.6c-5 6.9-7.7 15.3-7.7 23.8c0 22.2 18 40.3 40 40.3s40-18.1 40-40.3c0-8.5-2.7-16.9-7.7-23.8L192 291.3z'
      
    ]
  };

  

  
  

  var faCarRear = {
    prefix: 'fasl',
    iconName: 'car-rear',
    icon: [
      512,
      512,
      ["car-alt"],
      'f5de',
      
      'M100.1 32H112 400h11.9l3.4 11.4L459.9 192H480h32v32 64 32 64 32H480v64H448V416H352 320 192 160 64v64H32V416H0V384 320 288 224 192H32 52.1L96.7 43.4 100.1 32zM32 320v64H160V336 320h16H336h16v16 48H480V320H432 416V288h16 48V224H32v64H80 96v32H80 32zm160 64H320V352H192v32zM388.1 64H123.9L85.5 192h341L388.1 64z'
      
    ]
  };

  
    var faCarAlt = faCarRear;
  

  
  

  var faRetweet = {
    prefix: 'fasl',
    iconName: 'retweet',
    icon: [
      576,
      512,
      [],
      'f079',
      
      'M32 192H0V160L73.4 86.6 96 64l22.6 22.6L192 160v32H160 112V384H304h16v32H304 96 80V400 192H32zm114.7-32L96 109.3 45.3 160H80h32 34.7zM464 128H272 256V96h16H480h16v16V320h48 32v32l-73.4 73.4L480 448l-22.6-22.6L384 352V320h32 48V128zm16 274.7L530.7 352H496 464 429.3L480 402.7z'
      
    ]
  };

  

  
  

  var faClockFive = {
    prefix: 'fasl',
    iconName: 'clock-five',
    icon: [
      512,
      512,
      [],
      'e349',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112V251.2l61.3 92 8.9 13.3-26.6 17.8-8.9-13.3-64-96-2.7-4V256 112 96h32v16z'
      
    ]
  };

  

  
  

  var faSignalWeak = {
    prefix: 'fasl',
    iconName: 'signal-weak',
    icon: [
      640,
      512,
      ["signal-1"],
      'f68c',
      
      'M80 384v16 96 16H48V496 400 384H80z'
      
    ]
  };

  
    var faSignal1 = faSignalWeak;
  

  
  

  var faChevronRight = {
    prefix: 'fasl',
    iconName: 'chevron-right',
    icon: [
      320,
      512,
      [9002],
      'f054',
      
      'M310.6 256l-11.3 11.3-192 192L96 470.6 73.4 448l11.3-11.3L265.4 256 84.7 75.3 73.4 64 96 41.4l11.3 11.3 192 192L310.6 256z'
      
    ]
  };

  

  
  

  var faGenderless = {
    prefix: 'fasl',
    iconName: 'genderless',
    icon: [
      384,
      512,
      [],
      'f22d',
      
      'M192 112a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 320a176 176 0 1 0 0-352 176 176 0 1 0 0 352z'
      
    ]
  };

  

  
  

  var faBriefcaseMedical = {
    prefix: 'fasl',
    iconName: 'briefcase-medical',
    icon: [
      512,
      512,
      [],
      'f469',
      
      'M128 0h16H368h16V16 96h96 32v32V448v32H480 32 0V448 128 96H32h96V16 0zM352 32H160V96H352V32zM32 128V448H480V128H368 144 32zm192 48h64 16v16 48h48 16v16 64 16H352 304v48 16H288 224 208V384 336H160 144V320 256 240h16 48V192 176h16zm16 80v16H224 176v32h48 16v16 48h32V320 304h16 48V272H288 272V256 208H240v48z'
      
    ]
  };

  

  
  

  var faTurntable = {
    prefix: 'fasl',
    iconName: 'turntable',
    icon: [
      576,
      512,
      [],
      'f8e4',
      
      'M544 64V448H32V64H544zM32 32H0V64 448v32H32 544h32V448 64 32H544 32zM224 384a128 128 0 1 1 0-256 128 128 0 1 1 0 256zM64 256a160 160 0 1 0 320 0A160 160 0 1 0 64 256zm160 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm263.8 20.2l-7.8-3.9V112 96H448v16V280.3l-17.5-8.7-14.3 28.6-30.3 60.6-14.3 28.6 28.6 14.3 28.6 14.3 28.6 14.3 14.3-28.6 30.3-60.6 14.3-28.6-28.6-14.3zm-30.3 60.6l-14.3 28.6-28.6-14.3 14.3-28.6 1.7-3.4 14.3-28.6 28.6 14.3-14.3 28.6-1.7 3.4z'
      
    ]
  };

  

  
  

  var faPersonToDoor = {
    prefix: 'fasl',
    iconName: 'person-to-door',
    icon: [
      576,
      512,
      [58704],
      'e433',
      
      'M256 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 224 56a56 56 0 1 0 112 0zM128 112h-6.6l-4.7 4.7-64 64L41.4 192 64 214.6l11.3-11.3L134.6 144h39.1l15.9 4.5L153.2 257.9c-7.3 21.8 2 45.7 22 57l93.3 52.5L217.4 512h33.9l51.8-146.7 4.5-12.7-11.7-6.6-49.2-27.7c.2-.4 .4-.9 .5-1.3l37.2-111.6 20.3 70.9 3.3 11.6H320h80 16V256H400 332.1L303.4 155.6l-2.4-8.5-8.5-2.4-112-32-2.2-.6H176 128zm55.5 156l36.9-110.7 42.2 12.1-44.3 133L190.9 287c-6.7-3.8-9.8-11.7-7.3-19zM101.3 384H16 0v32H16h96 10.7l4.1-9.9 27.4-66.6c-10-6.7-18.2-15.5-24.1-25.4L101.3 384zM544 32V480H416V320H384V480v32h32H544h32V480 32 0H544 416 384V32 224h32V32H544z'
      
    ]
  };

  

  
  

  var faDisease = {
    prefix: 'fasl',
    iconName: 'disease',
    icon: [
      512,
      512,
      [],
      'f7fa',
      
      'M64.1 280.3c0-15.6-6.2-30.5-17.2-41.5L17.7 209.6C6.4 198.3 .1 183 .1 167.1c0-37.2 33.4-65.5 70.1-59.4l59.6 9.9c37.9 6.3 76-10.2 97.3-42.1l9.4-14.1C248.7 43 269.2 32 291.3 32c30.9 0 57.6 21.4 64.3 51.5l7.1 31.5c8.1 36.2 37.1 64 73.6 70.7l28 5.1c27.7 5.1 47.8 29.2 47.8 57.3c0 24.1-14.8 45.6-37.2 54.3L438 316.7c-32.5 12.6-53.9 43.9-53.9 78.8l0 25.2c0 32.7-26.5 59.3-59.3 59.3c-13.5 0-26.5-4.6-37-13l-30.9-24.7c-21.3-17-47.7-26.3-75-26.3h-10c-7.9 0-15.8 .9-23.6 2.6L86.1 432.4c-36 8-70.1-19.4-70.1-56.2c0-15.5 6.2-30.3 17.3-41.2l13.1-12.8c11.3-11 17.7-26.2 17.7-42zM253.6 93.2c-28.3 42.4-78.9 64.3-129.2 56l-59.6-9.9c-17.2-2.9-32.8 10.4-32.8 27.8c0 7.5 3 14.6 8.3 19.9l29.2 29.2c17 17 26.6 40.1 26.6 64.1c0 24.4-9.8 47.8-27.3 64.8L55.7 357.9c-4.9 4.8-7.7 11.4-7.7 18.3c0 16.4 15.1 28.5 31.1 25l62.3-13.8c10-2.2 20.3-3.4 30.5-3.4h10c34.5 0 68 11.7 94.9 33.3L307.8 442c4.8 3.9 10.8 6 17 6c15.1 0 27.3-12.2 27.3-27.3l0-25.2c0-48.1 29.5-91.2 74.3-108.6l36.9-14.3c10.1-3.9 16.8-13.7 16.8-24.5c0-12.7-9.1-23.6-21.6-25.9l-28-5.1c-49.1-9-88.1-46.4-99-95.2l-7.1-31.5C320.9 75 307.2 64 291.3 64c-11.3 0-21.9 5.7-28.2 15.1l-9.4 14.1zM160 256l-32-32 32-32 32 32-32 32zm96 64l32-32 32 32-32 32-32-32zm48-88l-24-24 24-24 24 24-24 24z'
      
    ]
  };

  

  
  

  var faNotdef = {
    prefix: 'fasl',
    iconName: 'notdef',
    icon: [
      384,
      512,
      [],
      'e1fe',
      
      'M0 0H16 368h16V16 496v16H368 16 0V496 16 0zM32 452.5L172.3 256 32 59.5V452.5zM51.7 480H332.3L192 283.5 51.7 480zm160-224L352 452.5V59.5L211.7 256zM332.3 32H51.7L192 228.5 332.3 32z'
      
    ]
  };

  

  
  

  var faTrashCanUndo = {
    prefix: 'fasl',
    iconName: 'trash-can-undo',
    icon: [
      448,
      512,
      ["trash-can-arrow-turn-left","trash-undo-alt"],
      'f896',
      
      'M160 0h-8.9l-4.7 7.5L111.1 64H64 32 0V96H32V480v32H64 384h32V480 96h32V64H416 384 336.9L301.6 7.5 296.9 0H288 160zM299.1 64H148.9l20-32H279.1l20 32zM64 480V96H384V480H64zM230.6 201.2l-21.4-23.8-11.9 10.7-80 72L104.1 272l13.2 11.9 80 72 11.9 10.7 21.4-23.8-11.9-10.7-49-44.1H240c26.5 0 48 21.5 48 48v40 16h32V376 336c0-44.2-35.8-80-80-80H169.7l49-44.1 11.9-10.7z'
      
    ]
  };

  
    var faTrashCanArrowTurnLeft = faTrashCanUndo;
  
    var faTrashUndoAlt = faTrashCanUndo;
  

  
  

  var faFilterSlash = {
    prefix: 'fasl',
    iconName: 'filter-slash',
    icon: [
      640,
      512,
      [],
      'e17d',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM576 96V64 32H544 139.6l40.5 32H544V84.2L407.4 243.5l25.1 19.8L576 96zM352 362.8v78.7l-64-56V312.3L256 287V400l96 84 32 28V469.5 388.1l-32-25.3z'
      
    ]
  };

  

  
  

  var faTablePivot = {
    prefix: 'fasl',
    iconName: 'table-pivot',
    icon: [
      512,
      512,
      [],
      'e291',
      
      'M160 64v96H480V64H160zm0 128V448H480V192H160zM128 64H32v96h96V64zM32 448h96V192H32V448zM0 32H32 480h32V64 448v32H480 32 0V448 64 32zM400 224l48 48v16H416v80 16H400 320v32H304l-48-48 48-48h16v32h64V288H352V272l48-48z'
      
    ]
  };

  

  
  

  var faHandLizard = {
    prefix: 'fasl',
    iconName: 'hand-lizard',
    icon: [
      512,
      512,
      [],
      'f258',
      
      'M0 64H16 336h8.2l4.8 6.7 160 224 3 4.2V304 432v16H480V432 309.1L327.8 96H32v48H256c35.3 0 64 28.7 64 64s-28.7 64-64 64H96v48H272c3.2 0 6.2 .9 8.9 2.7l96 64c4.4 3 7.1 8 7.1 13.3v32 16H352V432 408.6L267.2 352H80 64V336 256 240H80 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H16 0V160 80 64z'
      
    ]
  };

  

  
  

  var faMoneyBillSimple = {
    prefix: 'fasl',
    iconName: 'money-bill-simple',
    icon: [
      576,
      512,
      [],
      'e1f1',
      
      'M32 96V416H544V96H32zM0 64H32 544h32V96 416v32H544 32 0V416 96 64zM352 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  

  
  

  var faClouds = {
    prefix: 'fasl',
    iconName: 'clouds',
    icon: [
      640,
      512,
      [],
      'f744',
      
      'M160.9 288c1.2-11.1 3.7-21.8 7.3-32H96 32V192c0-35.3 28.6-64 63.9-64l1 0 27.9 .2 4-27.6C134.4 61.8 167.7 32 208 32c31.9 0 59.4 18.6 72.3 45.7L289 96h20.2H352c35.3 0 64 28.7 64 64c0 14.7-5 28.3-13.3 39.1l.9 .8c12.2-4.5 25.3-7.2 39-7.8c3.6-10 5.5-20.9 5.5-32.1c0-53-43-96-96-96H309.2C291.2 26.2 252.7 0 208 0C151.6 0 104.9 41.7 97.1 96L96 96C43 96 0 139 0 192v64 32H32 96h64.9zM512 320v32h32c35.3 0 64 28.7 64 64v64H544 224 160V416c0-27.8 17.8-51.6 42.7-60.4l21.3-7.5V325.5 304c0-44.2 35.8-80 80-80c27 0 50.9 13.4 65.4 34l17.8 25.2 25.9-16.9c10-6.5 22-10.3 34.9-10.3c35.3 0 64 28.7 64 64zM128 512h32 64H544h64 32V480 416c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C375.3 210.8 341.9 192 304 192c-61.9 0-112 50.1-112 112v21.5c-37.3 13.2-64 48.7-64 90.5v64 32z'
      
    ]
  };

  

  
  

  var faBacteria = {
    prefix: 'fasl',
    iconName: 'bacteria',
    icon: [
      640,
      512,
      [],
      'e059',
      
      'M286.2 0l-6.8 21.1c-8.1-.6-16.5 0-24.9 2c-9.7 2.2-19.1 4.8-28.1 7.6l-4.3-10.1L215.9 5.9 186.5 18.5l6.3 14.7 3.6 8.5c-17.7 7.5-33.8 16.1-48.3 25.5l-9-14.7-8.4-13.6L103.5 55.7l8.4 13.6 10.3 16.8C107.6 98 94.9 110.8 84 123.9l-5-3.7-12.8-9.6L47.1 136.1l12.8 9.6 5.1 3.8c-2.1 3.2-4.1 6.4-6.1 9.6c-7.8 13-13.9 25.5-18.8 37.2l-11.6-5.8-14.3-7.2L0 212.1l14.3 7.2 15.2 7.6c-.3 .9-.5 1.7-.7 2.6c-3.2 11.7-5.8 23.8-7 35.9c-.4 4.6-.5 9.1-.1 13.6L.6 285.7l9.8 30.5L30 309.8c8 16.3 21.1 29.7 37.4 38l-4.7 10.7-6.4 14.7L85.8 386l6.4-14.7 6.4-14.7c19.7 1.6 38.4-3.7 53.7-13.9l9.6 10.2 11 11.6 23.3-22-11-11.6-10.2-10.8c7.5-11 12.5-24 14-38.1c.5-3.4 1.3-6.8 2.3-10.1l7.4 3.5 14.5 6.9 13.7-28.9-14.5-6.9-7.6-3.6c7.6-11.8 19.3-25.6 38.8-37.2l2.4 10.7 3.5 15.6 31.2-6.9-3.5-15.6-3.8-17.3c5.9-2 12.3-3.8 19.1-5.4c9.2-2.1 17.8-5.7 25.4-10.5l13.3 8.2 13.6 8.4 16.8-27.2-13.6-8.4-6-3.7c11.2-15.8 17-35.4 15.3-55.6l14.7-6.4 14.7-6.4L373.8 55.9l-14.7 6.4-10.7 4.7c-8.4-16.5-21.9-29.5-38-37.4l6.3-19.6L286.2 0zM221.5 148.9a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM157.2 278.6c-3.1 28.1-28.1 48.7-56.4 46.1c-28.6-2.6-49.7-27.9-47.1-56.4c.9-9.6 3.1-19.8 6-30.3c4.5-16.5 12.6-38.7 26.7-62.3c29-48.4 82.3-99.9 175.4-121.4c28-6.5 55.9 11 62.4 39s-11 55.9-39 62.4c-62.9 14.5-93.6 46.9-109.6 73.6c-7.9 13.2-15.4 29.8-18.2 48c-.1 .5-.1 .9-.2 1.4zM351.2 508.9l6.8-21.1c8.1 .6 16.5 0 24.9-2c9.7-2.2 19.1-4.8 28.1-7.6l4.3 10.1 6.3 14.7L451 490.4l-6.3-14.7-3.6-8.5c17.7-7.5 33.8-16.1 48.3-25.5l9 14.7 8.4 13.6L534 453.2l-8.4-13.6-10.3-16.8c14.6-11.9 27.2-24.7 38.1-37.8l5 3.7 12.8 9.6 19.2-25.6-12.8-9.6-5.1-3.8c2.1-3.2 4.1-6.4 6.1-9.6c7.8-13 13.9-25.5 18.8-37.2l11.6 5.8 14.3 7.2 14.3-28.6-14.3-7.2-15.2-7.6c.3-.9 .5-1.7 .7-2.6c3.2-11.7 5.8-23.8 7-35.9c.4-4.6 .5-9.1 .1-13.6l21.1-6.8-9.8-30.5-19.6 6.3c-8-16.3-21.1-29.7-37.4-38l4.7-10.7 6.4-14.7L551.7 123l-6.4 14.7L539 152.3c-19.7-1.6-38.4 3.7-53.7 13.9L475.6 156l-11-11.6-23.3 22 11 11.6 10.2 10.8c-7.5 11-12.5 24-14 38.1c-.5 3.4-1.3 6.8-2.3 10.1l-7.4-3.5-14.5-6.9-13.7 28.9 14.5 6.9 7.6 3.6c-7.6 11.8-19.3 25.6-38.8 37.2l-2.4-10.7-3.5-15.6-31.2 6.9 3.5 15.6 3.8 17.3c-5.9 2-12.3 3.8-19.1 5.4c-9.2 2.1-17.8 5.7-25.4 10.5l-13.3-8.2L292.8 316 276 343.2l13.6 8.4 6 3.7c-11.2 15.8-17 35.4-15.3 55.6l-14.7 6.4L251 423.7l12.8 29.3 14.7-6.4 10.7-4.7c8.4 16.5 21.9 29.5 38 37.4l-6.3 19.6 30.5 9.8zM416 360a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm64.3-129.6c3.1-28.1 28.1-48.7 56.4-46.1c28.6 2.6 49.7 27.9 47.1 56.4c-.9 9.6-3.1 19.8-6 30.3c-4.5 16.5-12.6 38.7-26.7 62.3c-29 48.4-82.3 99.9-175.4 121.4c-28 6.5-55.9-11-62.4-39s11-55.9 39-62.4c62.9-14.5 93.6-46.9 109.6-73.6c7.9-13.2 15.4-29.8 18.2-48c.1-.5 .1-.9 .2-1.4z'
      
    ]
  };

  

  
  

  var faChevronLeft = {
    prefix: 'fasl',
    iconName: 'chevron-left',
    icon: [
      320,
      512,
      [9001],
      'f053',
      
      'M9.4 256l11.3-11.3 192-192L224 41.4 246.6 64 235.3 75.3 54.6 256 235.3 436.7 246.6 448 224 470.6l-11.3-11.3-192-192L9.4 256z'
      
    ]
  };

  

  
  

  var faArrowLeftToArc = {
    prefix: 'fasl',
    iconName: 'arrow-left-to-arc',
    icon: [
      512,
      512,
      [],
      'e616',
      
      'M32 256C32 132.3 132.3 32 256 32h16V0H256C114.6 0 0 114.6 0 256S114.6 512 256 512h16V480H256C132.3 480 32 379.7 32 256zM309.4 116l-144 128-13.5 12 13.5 12 144 128 12 10.6 21.3-23.9-12-10.6L218.1 272H496h16V240H496 218.1L330.6 140l12-10.6-21.3-23.9-12 10.6z'
      
    ]
  };

  

  
  

  var faNose = {
    prefix: 'fasl',
    iconName: 'nose',
    icon: [
      448,
      512,
      [],
      'e5bd',
      
      'M163.4 25.8L416 349.5V480H294.3l-2.3-2.6-64-72-4.8-5.4H216 184c-30.9 0-56 25.1-56 56s25.1 56 56 56H432h16V496 344v-5.5l-3.4-4.3-256-328L163.4 25.8zM184 432h24.8l42.7 48H184c-13.3 0-24-10.7-24-24s10.7-24 24-24zM131.4 303.6l15.6-3.4L140.3 269l-15.6 3.4-22.8 4.9C42.4 290 0 342.4 0 403.2c0 38.2 17 74.5 46.3 98.9l7.4 6.2 20.5-24.6-7.4-6.2C44.8 459.1 32 431.9 32 403.2c0-45.6 31.9-85.1 76.5-94.6l22.8-4.9z'
      
    ]
  };

  

  
  

  var faHollyBerry = {
    prefix: 'fasl',
    iconName: 'holly-berry',
    icon: [
      512,
      512,
      [],
      'f7aa',
      
      'M256 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32A64 64 0 1 1 192 64a64 64 0 1 1 128 0zM46.6 343.6L96 327.1l.8-45.7 .6-32.3 31.9 4.7 46.7 6.9 44.4-20.5L256 224l-7.1 38.5L240 310.6l18.3 43.7 5.1 12.1 5.1-12.1 18.3-43.7-8.9-48.1L270.7 224l35.6 16.4 44.4 20.5 46.7-6.9 31.9-4.7 .6 32.3 .8 45.7 49.4 16.5 30.6 10.2-14.1 29-19.6 40.3 9.9 49.7 7.8 39.2-36.1-17.3-45.7-21.9L369.2 482l-31.8 6.6-1.1-32.5-1.6-47.2-48.1-15.3-23.3-7.4-23.3 7.4L192 408.9l-1.6 47.2-1.1 32.5L157.5 482l-43.7-9.1L68.1 494.7 32 512l7.8-39.2 9.9-49.7L30.1 382.8 16 353.8l30.6-10.2zM128 327.7l-.4 22.6-21.5 7.2L60.8 372.6l17.8 36.5 4.7 9.7-2.1 10.6-5.2 26.1L100 444l9.7-4.7 10.6 2.2 38.3 8 1.4-41.7 .8-22.6 21.5-6.8L227.7 364l-17.2-41-3.7-8.8 1.7-9.4 4.8-25.9-24 11-8.7 4-9.4-1.4-42.6-6.3-.7 41.5zm270.7 0l-.7-41.5-42.6 6.3-9.4 1.4-8.7-4-24-11 4.8 25.9 1.7 9.4-3.7 8.8L299 364l45.3 14.4 21.5 6.8 .8 22.6 1.4 41.7 38.3-8 10.6-2.2 9.7 4.7 24.1 11.5-5.2-26.1-2.1-10.6 4.7-9.7 17.8-36.5-45.4-15.1-21.5-7.2-.4-22.6zM112 144c0-30.4 21.2-55.8 49.6-62.4c2 10.9 5.9 21.2 11.3 30.5C156.7 113.7 144 127.4 144 144c0 17.7 14.3 32 32 32c16.6 0 30.3-12.7 31.9-28.9c9.3 5.4 19.6 9.3 30.5 11.3c-6.5 28.4-32 49.6-62.4 49.6c-35.3 0-64-28.7-64-64zm224 64c-30.4 0-55.8-21.2-62.4-49.6c10.9-2 21.2-5.9 30.5-11.3c1.5 16.2 15.2 28.9 31.9 28.9c17.7 0 32-14.3 32-32c0-16.6-12.7-30.3-28.9-31.9c5.4-9.3 9.3-19.6 11.3-30.5c28.4 6.5 49.6 32 49.6 62.4c0 35.3-28.7 64-64 64z'
      
    ]
  };

  

  
  

  var faLinkHorizontalSlash = {
    prefix: 'fasl',
    iconName: 'link-horizontal-slash',
    icon: [
      640,
      512,
      ["chain-horizontal-slash"],
      'e1cc',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM640 320c0-70.7-57.3-128-128-128H480v32h32c53 0 96 43 96 96c0 24.2-8.9 46.3-23.7 63.1L609.5 403c19-22.3 30.5-51.3 30.5-83zM459.9 448l-40.5-32H335.9c-52.9 0-95.9-42.9-95.9-95.9c0-13.9 3-27.2 8.4-39.2l-25.7-20.3c-9.4 17.8-14.6 38.1-14.6 59.5C208 390.8 265.2 448 335.9 448H459.9zM400 191.9c0 13.9-3 27.2-8.4 39.2l25.7 20.3c9.4-17.8 14.6-38.1 14.6-59.5C432 121.2 374.8 64 304.1 64H180.1l40.5 32h83.5c52.9 0 95.9 42.9 95.9 95.9zm-344.3-63L30.5 109C11.5 131.4 0 160.3 0 192c0 70.7 57.3 128 128 128h32V288H128c-53 0-96-43-96-96c0-24.2 8.9-46.3 23.7-63.1z'
      
    ]
  };

  
    var faChainHorizontalSlash = faLinkHorizontalSlash;
  

  
  

  var faDrumstickBite = {
    prefix: 'fasl',
    iconName: 'drumstick-bite',
    icon: [
      512,
      512,
      [],
      'f6d7',
      
      'M237.3 320h90.9c-5.3-15-8.2-31.2-8.2-48c0-79.5 64.5-144 144-144c2.6 0 5.3 .1 7.9 .2C452.2 72.2 398.8 32 336 32c-79.5 0-144 64.5-144 144v98.7L237.3 320zM336 0c82.9 0 152.5 57.4 171.1 134.6c2.8 11.6 4.5 23.7 4.8 36.2c-10.2-4.8-21.1-8.1-32.7-9.7c-5-.7-10.1-1-15.2-1c-61.9 0-112 50.1-112 112c0 16.3 3.5 31.8 9.7 45.7c4.7 10.5 11 20.2 18.5 28.7c-11.6 3-23.7 4.9-36.1 5.4c-2.7 .1-5.4 .2-8.1 .2H230.6l-40.5 40.5C201.2 405.2 208 421.8 208 440c0 39.8-32.2 72-72 72c-37.2 0-67.8-28.2-71.6-64.4C28.2 443.8 0 413.2 0 376c0-39.8 32.2-72 72-72c18.2 0 34.8 6.8 47.5 17.9L160 281.4V176C160 78.8 238.8 0 336 0zM179.3 307.3l-49.2 49.2-13.9 13.9L105.4 354C98.2 343.1 86 336 72 336c-22.1 0-40 17.9-40 40s17.9 40 40 40h8H96v16 8c0 22.1 17.9 40 40 40s40-17.9 40-40c0-14-7.1-26.2-18-33.4l-16.4-10.8 13.9-13.9 49.2-49.2-25.4-25.4z'
      
    ]
  };

  

  
  

  var faDinosaur = {
    prefix: 'fasl',
    iconName: 'dinosaur',
    icon: [
      640,
      512,
      [],
      'e5fe',
      
      'M432 0h8 32c92.8 0 168 75.2 168 168v52.7c0 77.2-39.8 149-105.3 190L512 424.9V496v16H496 400 384V496 461c-3.5 .9-7.5 1.8-11.7 2.6c-14.2 3-32.3 6-52.3 7.5V439c17.3-1.4 33.1-4 45.7-6.7c9.1-1.9 16.5-3.8 21.6-5.3c2.5-.7 4.5-1.3 5.8-1.7c.6-.2 1.1-.4 1.4-.5l.3-.1 .1 0 0 0 0 0 0 0 0 0 21-7V440v40h64V416v-8.9l7.5-4.7 30.2-18.9c56.1-35.1 90.2-96.6 90.2-162.8V168c0-75.1-60.9-136-136-136H448L428.8 57.6l-2.7 3.6-4.2 1.7L392 74.8v30.5L414.6 128H496c35.3 0 64 28.7 64 64v64 16H544 464h-5.1l-4.2-3-56-40c-33.7-24.1-74-37-115.4-37c-49.6 0-97.3 18.5-133.9 51.9L32 351.1V480H256V455.5L108.6 423.6 96 420.9V408 368 352h32v16 27.1L275.4 427l12.6 2.7v12.9V496v16H272 16 0V496 344v-7.1l5.2-4.8L127.7 220.3c42.5-38.8 97.9-60.3 155.5-60.3c48.1 0 94.9 15 134 43l51.9 37H528V192c0-17.7-14.3-32-32-32H408h-6.6l-4.7-4.7-32-32-4.7-4.7V112 64 53.2l10.1-4 35.8-14.3L427.2 6.4 432 0zm32 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faAngleUp = {
    prefix: 'fasl',
    iconName: 'angle-up',
    icon: [
      448,
      512,
      [8963],
      'f106',
      
      'M224 137.4l11.3 11.3 160 160L406.6 320 384 342.6l-11.3-11.3L224 182.6 75.3 331.3 64 342.6 41.4 320l11.3-11.3 160-160L224 137.4z'
      
    ]
  };

  

  
  

  var faMessageMinus = {
    prefix: 'fasl',
    iconName: 'message-minus',
    icon: [
      512,
      512,
      ["comment-alt-minus"],
      'f4a7',
      
      'M160 448V416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448zm0-64h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zm0-192H352h16v32H352 160 144V192h16z'
      
    ]
  };

  
    var faCommentAltMinus = faMessageMinus;
  

  
  

  var faFill = {
    prefix: 'fasl',
    iconName: 'fill',
    icon: [
      512,
      512,
      [],
      'f575',
      
      'M22.6 294.6L0 272l22.6-22.6L140.7 131.3l-96-96L33.4 24 56 1.4 67.3 12.7l96 96 86.1-86.1L272 0l22.6 22.6L489.4 217.4 512 240l-22.6 22.6L262.6 489.4 240 512l-22.6-22.6L22.6 294.6zM163.3 153.9L45.3 272l16 16H418.7l48-48L272 45.3l-86.1 86.1 81.4 81.4L278.6 224 256 246.6l-11.3-11.3-81.4-81.4zM240 466.7L386.7 320H93.3L240 466.7z'
      
    ]
  };

  

  
  

  var faGlassHalf = {
    prefix: 'fasl',
    iconName: 'glass-half',
    icon: [
      384,
      512,
      ["glass-half-empty","glass-half-full"],
      'e192',
      
      'M52.1 256H331.9L314.4 480H69.6L52.1 256zm-2.5-32L34.6 32H349.4l-15 192H49.6zM40 512H344L381.5 32 384 0H351.9 32.1 0L2.5 32 40 512z'
      
    ]
  };

  
    var faGlassHalfEmpty = faGlassHalf;
  
    var faGlassHalfFull = faGlassHalf;
  

  
  

  var faMessageCode = {
    prefix: 'fasl',
    iconName: 'message-code',
    icon: [
      512,
      512,
      [],
      'e1df',
      
      'M160 416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448 416zm0-32h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zm59.3-228.7L166.6 208l52.7 52.7L230.6 272 208 294.6l-11.3-11.3-64-64L121.4 208l11.3-11.3 64-64L208 121.4 230.6 144l-11.3 11.3zm96-22.6l64 64L390.6 208l-11.3 11.3-64 64L304 294.6 281.4 272l11.3-11.3L345.4 208l-52.7-52.7L281.4 144 304 121.4l11.3 11.3z'
      
    ]
  };

  

  
  

  var faSchoolFlag = {
    prefix: 'fasl',
    iconName: 'school-flag',
    icon: [
      576,
      512,
      [],
      'e56e',
      
      'M304 32V64h80V32H304zM272 0h32 80 32V32 64 96H384 315.5l89.6 64H560h16v16V496v16H560 352 320 256 224 16 0V496 176 160H16 170.9L272 87.8V64 32 0zm48 416c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64V416zm32 64H544V192H400h-5.1l-4.2-3L288 115.7 185.3 189l-4.2 3H176 32V480H224V416c0-35.3 28.7-64 64-64s64 28.7 64 64v64zM256 240a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM64 224H80h64 16v16 64 16H144 80 64V304 240 224zm32 32v32h32V256H96zm336-32h64 16v16 64 16H496 432 416V304 240 224h16zm48 64V256H448v32h32zM64 352H80h64 16v16 64 16H144 80 64V432 368 352zm32 32v32h32V384H96zm336-32h64 16v16 64 16H496 432 416V432 368 352h16zm16 64h32V384H448v32z'
      
    ]
  };

  

  
  

  var faTablet = {
    prefix: 'fasl',
    iconName: 'tablet',
    icon: [
      448,
      512,
      ["tablet-android"],
      'f3fb',
      
      'M32 32V480H416V32H32zM0 0H32 416h32V32 480v32H416 32 0V480 32 0zM192 400h64 16v32H256 192 176V400h16z'
      
    ]
  };

  
    var faTabletAndroid = faTablet;
  

  
  

  var faCommentQuote = {
    prefix: 'fasl',
    iconName: 'comment-quote',
    icon: [
      512,
      512,
      [],
      'e14c',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM160 176h48v16 16 16H160V176zm48 80v28.9L154.4 305l-15 5.6 11.2 30 15-5.6 64-24 10.4-3.9V296 256 224 208 192 176 144H208 160 128v32 48 32h32 48zm176 0V224 208 192 176 144H352 304 272v32 48 32h32 48v28.9L298.4 305l-15 5.6 11.2 30 15-5.6 64-24 10.4-3.9V296 256zm-32-48v16H304V176h48v16 16z'
      
    ]
  };

  

  
  

  var faCameraSlash = {
    prefix: 'fasl',
    iconName: 'camera-slash',
    icon: [
      640,
      512,
      [],
      'e0d9',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zm460 462l-40.5-32H96V160.7L64 135.4V448v32H96 500.4zM206.4 84.8l26.7 21.1 14-41.9H392.9l14 42.1 7.3 21.9h23.1H544V351.3l32 25.3V128 96H544 437.3L416 32H224L206.4 84.8zm7 168.6c-3.5 10.9-5.4 22.5-5.4 34.6c0 61.9 50.1 112 112 112c21.4 0 41.4-6 58.4-16.4l-27.6-21.8c-9.5 4-19.9 6.1-30.8 6.1c-44.2 0-80-35.8-80-80c0-4.4 .3-8.6 1-12.8l-27.6-21.8z'
      
    ]
  };

  

  
  

  var faCloudBoltSun = {
    prefix: 'fasl',
    iconName: 'cloud-bolt-sun',
    icon: [
      640,
      512,
      ["thunderstorm-sun"],
      'f76e',
      
      'M109.3 135.6l22.5-3.8 3.8-22.5 9-53.9 45.1 31.6L208 99.7l18.4-12.8 45.1-31.6 7.5 44.7c8.6-8.3 18.3-15.4 28.9-21.1l-7.3-44L294.7 0 265.6 20.3 208 60.7 150.4 20.3 121.3 0l-5.8 35L104 104 35 115.5 0 121.3l20.3 29.1L60.7 208 20.3 265.6 0 294.7l35 5.8L104 312l11.5 69 5.8 35 29.1-20.3 9.6-6.7V349.9l-15.4 10.8-9-53.9-3.8-22.5-22.5-3.8-53.9-9 31.6-45.1L99.7 208 86.9 189.7 55.3 144.6l53.9-9zM208 128c-44.2 0-80 35.8-80 80c0 26.6 13 50.1 32.9 64.7c1.5-12.3 4.7-24 9.4-35c-6.4-8.2-10.3-18.5-10.3-29.7c0-26.5 21.5-48 48-48c11.2 0 21.5 3.8 29.7 10.3c1.5-.6 3-1.2 4.5-1.8c1.8-9.8 4.7-19.2 8.7-28C238.4 132.5 223.7 128 208 128zm234.8 3.9C425.2 110 398.2 96 368 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6v64 32h32 32V356.1v-4.2H224v-64c0-31.7 23-58 53.3-63.1l26.9-4.5-.2-27.3 0-1.2c.1-35.3 28.7-63.9 64-63.9c23.2 0 43.5 12.3 54.8 30.9l17.7 29.3 28-19.6c7.8-5.4 17.2-8.6 27.4-8.6c26.5 0 48 21.5 48 48c0 3.6-.4 7.1-1.1 10.4l-7.1 32.5 32.8 5.8c22.4 4 39.5 23.7 39.5 47.2v48l-48 0H544v28 4h15.9l48 0h32v-80c0-37.1-25.3-68.4-59.7-77.4c-2-.5-4.1-1-6.2-1.4c.5-2.1 .8-4.1 1.1-6.2c.5-3.6 .8-7.3 .8-11c0-44.2-35.8-80-80-80c-13.2 0-25.7 3.2-36.7 8.9c-3.2 1.6-6.2 3.5-9.1 5.5c-2.2-3.6-4.6-7.1-7.3-10.4zM440 224h-6.6l-4.7 4.7-136 136-4.7 4.7V376v8 16h16 45.6l-13.4 93.7L333.6 512H352h8 6.6l4.7-4.7 136-136 4.7-4.7V360v-8V336H496 450.4l13.4-93.7 2.6-18.3H448h-8zM334.6 368l92.1-92.1-10.5 73.8L413.6 368H432h33.4l-92.1 92.1 10.5-73.8 2.6-18.3H368 334.6z'
      
    ]
  };

  
    var faThunderstormSun = faCloudBoltSun;
  

  
  

  var faBellSlash = {
    prefix: 'fasl',
    iconName: 'bell-slash',
    icon: [
      640,
      512,
      [61943,128277],
      'f1f6',
      
      'M419.4 416l-40.5-32H128V366.6l59.3-59.3 4.7-4.7V296 236.5l-32-25.3v78.1l-59.3 59.3L96 353.4V360v40 16h16H419.4zM203.4 82.4l25.2 19.9C251.9 78.7 284.2 64 320 64c70.7 0 128 57.3 128 128v83.5l32 25.3V289.4 192c0-83-63.1-151.2-144-159.2V0H304V32.8C264.5 36.7 229.2 55 203.4 82.4zM320 512c35.3 0 64-28.7 64-64H352c0 17.7-14.3 32-32 32s-32-14.3-32-32H256c0 35.3 28.7 64 64 64zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faStoreLock = {
    prefix: 'fasl',
    iconName: 'store-lock',
    icon: [
      640,
      512,
      [],
      'e4a6',
      
      'M579.6 103.8c14.4 22.8 15.6 49.9 6.7 72.6c-9-5.5-18.9-9.8-29.4-12.6c5.1-13 4.6-28.7-4.2-42.7L494.7 32H145.3L87.3 121.1c-18.5 29.5-.1 66.4 29.2 70.4c2.7 .3 5.4 .5 7.9 .5c16.6 0 31.3-7.2 41.5-18.4l23.7-26.3 23.7 26.3c10.2 11.2 24.9 18.4 41.4 18.4c16.6 0 31.3-7.2 41.4-18.4l23.7-26.3 23.7 26.3c10.2 11.2 24.9 18.4 41.4 18.4c16.6 0 31.3-7.2 41.4-18.4l23.7-26.2 23.7 26.1 .2 .2c-15 8.2-27.8 19.7-37.6 33.6c-14.4 10.4-32.1 16.7-51.5 16.7c-19.6 0-37.5-6.4-52-17c-4.8-3.5-9.2-7.5-13.2-11.9c-4 4.4-8.4 8.4-13.2 12c-14.4 10.6-32.4 17-52 17c-19.6 0-37.5-6.4-52-17c-4.8-3.5-9.2-7.5-13.2-11.9c-4 4.4-8.4 8.4-13.2 11.9c-14.4 10.6-32.4 17-52 17c-4.1 0-8.2-.3-12.1-.8c-55.3-7.4-81.5-72.6-51.9-119.4L128 0H512l67.6 103.8zM128 352H384l0 32H128v96H384l0 32H128 96V480 384 352 256h32v96zM528 224c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32v32V480v32H608 448 416V480 352 320h32V272zm0 80V480H608V352H448z'
      
    ]
  };

  

  
  

  var faEyeDropperHalf = {
    prefix: 'fasl',
    iconName: 'eye-dropper-half',
    icon: [
      512,
      512,
      [],
      'e173',
      
      'M220.7 195.4l-22.6-22.6-6.1-6.1-11.3-11.3L169.4 144 192 121.4l6.1 6.1 5.2 5.2L214.6 144l6.1 6.1 22.6-22.6 98.3-98.3c39-39 102.2-39 141.1 0s39 102.2 0 141.1l-98.3 98.3-22.6 22.6 6.1 6.1 11.3 11.3 5.2 5.2 6.1 6.1L368 342.6l-11.3-11.3L345.4 320l-6.1-6.1-22.6-22.6-95.9-95.9zm118.5 73.3L460.1 147.8c26.5-26.5 26.5-69.4 0-95.9s-69.4-26.5-95.9 0L243.4 172.7l95.9 95.9zM178.1 197.9l22.6 22.6L101.3 320H282.7l8.7-8.7 22.6 22.6L168 480H88L40 512 0 472l32-48V344L178.1 197.9zM69.3 352L64 357.3V424v9.7l-5.4 8.1L41.2 467.9l2.9 2.9 26.2-17.4 8.1-5.4H88h66.7l96-96H69.3z'
      
    ]
  };

  

  
  

  var faBezierCurve = {
    prefix: 'fasl',
    iconName: 'bezier-curve',
    icon: [
      640,
      512,
      [],
      'f55b',
      
      'M368 64v37.2V112v22 26H272V134 112 101.2 64h96zm67.4 64H514c7.1 27.6 32.2 48 62 48c35.3 0 64-28.7 64-64s-28.7-64-64-64c-29.8 0-54.9 20.4-62 48H400V64 32H368 272 240V64 96H126c-7.1-27.6-32.2-48-62-48C28.7 48 0 76.7 0 112s28.7 64 64 64c29.8 0 54.9-20.4 62-48h78.6C139.5 167.2 96 238.5 96 320l-32 0H32v32 96 32H64h96 32V448 352 320H160l-32 0c0-77.5 45.9-144.3 112-174.6V160v32h32 96 32V160 145.4c66.1 30.3 112 97.1 112 174.6l-32 0H448v32 96 32h32 96 32V448 352 320H576l-32 0c0-81.5-43.5-152.8-108.6-192zM544 352l32 0v96H480V352l32 0h32zm-416 0l32 0v96H64V352l32 0h32zM32 112a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm512 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faSignalStreamSlash = {
    prefix: 'fasl',
    iconName: 'signal-stream-slash',
    icon: [
      640,
      512,
      [],
      'e250',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM576 256c0-67.4-23.2-129.4-61.9-178.5L488.9 97.4C523.4 141 544 196.1 544 256c0 29.5-5 57.8-14.1 84.1L556.3 361C569 328.5 576 293 576 256zm-96 0c0-44.9-15.4-86.3-41.3-119l-25.1 19.8C435.1 184.1 448 218.6 448 256c0 6.3-.4 12.5-1.1 18.7l28.6 22.6c2.9-13.3 4.4-27.1 4.4-41.3zM139.9 195.4l-26-20.5C102.4 199.5 96 227 96 256c0 44.9 15.4 86.3 41.3 119l25.1-19.8C140.9 327.9 128 293.4 128 256c0-21.5 4.2-41.9 11.9-60.6zm-77.2-61L37.2 114.3C13.5 156.1 0 204.5 0 256c0 67.4 23.2 129.4 61.9 178.5l25.1-19.8C52.6 371 32 315.9 32 256c0-44 11.1-85.4 30.7-121.6z'
      
    ]
  };

  

  
  

  var faFolderCheck = {
    prefix: 'fasl',
    iconName: 'folder-check',
    icon: [
      512,
      512,
      [],
      'e64e',
      
      'M32 32H224l48 64H480h32v32V448v32H480 32 0V448 64 32H32zm240 96H256l-9.6-12.8L208 64H32V448H480V128H272zm91.3 107.3l-128 128L224 374.6l-11.3-11.3-64-64L137.4 288 160 265.4l11.3 11.3L224 329.4 340.7 212.7 352 201.4 374.6 224l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faSquareDivide = {
    prefix: 'fasl',
    iconName: 'square-divide',
    icon: [
      448,
      512,
      [],
      'e26a',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM248 136v48H200V136h48zM128 240H320h16v32H320 128 112V240h16zm72 88h48v48H200V328z'
      
    ]
  };

  

  
  

  var faSignHanging = {
    prefix: 'fasl',
    iconName: 'sign-hanging',
    icon: [
      512,
      512,
      ["sign"],
      'f4d9',
      
      'M96 0V16 64l400 0h16V96H496L96 96V496v16H64V496 96H16 0V64H16l48 0V16 0H96zm64 160V352H448V160H160zm-32-32h32H448h32v32V352v32H448 160 128V352 160 128z'
      
    ]
  };

  
    var faSign = faSignHanging;
  

  
  

  var faVacuumRobot = {
    prefix: 'fasl',
    iconName: 'vacuum-robot',
    icon: [
      512,
      512,
      [],
      'e04e',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM356.7 155.3c-55.6-55.6-145.8-55.6-201.4 0l-22.6-22.6c68.1-68.1 178.5-68.1 246.6 0s68.1 178.5 0 246.6l-22.6-22.6c55.6-55.6 55.6-145.8 0-201.4zM224 201.4l11.3 11.3 64 64L310.6 288 288 310.6l-11.3-11.3-64-64L201.4 224 224 201.4zm-80 16l11.3 11.3 128 128L294.6 368 272 390.6l-11.3-11.3-128-128L121.4 240 144 217.4zm-16 80l11.3 11.3 64 64L214.6 384 192 406.6l-11.3-11.3-64-64L105.4 320 128 297.4z'
      
    ]
  };

  

  
  

  var faAngle = {
    prefix: 'fasl',
    iconName: 'angle',
    icon: [
      448,
      512,
      [],
      'e08c',
      
      'M209.6 41.1L11.2 457.1 .2 480H25.6 432h16V448H432 51L238.4 54.9 209.6 41.1zm14.8 131.4l-14.5 29c26.2 18.9 49.3 42 68.3 68.1l27.1-17.2c-22.2-31-49.6-58.1-80.9-79.9zM333.4 408h32.2c-4.9-40.9-17.1-79.6-35.3-114.7l-27.1 17.2c15.2 30 25.6 62.8 30.2 97.5z'
      
    ]
  };

  

  
  

  var faOliveBranch = {
    prefix: 'fasl',
    iconName: 'olive-branch',
    icon: [
      640,
      512,
      [],
      'e317',
      
      'M248.8 59.3C232.6 40.8 189.9 0 128 0C48 0 0 68.3 0 68.3s27.9 34.7 76.5 51.2C30.6 147.6 0 198.2 0 256v16 16H16 32 48c88.4 0 160-71.6 160-160V114.4L379.6 32H624h16V0H624 376h-3.6l-3.3 1.6L248.8 59.3zM45 66.6c2.6-2.4 5.5-4.8 8.6-7.2C72.2 45 97.4 32 128 32s55.8 13 74.4 27.4c3.1 2.4 6 4.8 8.6 7.2c-2.2 1.7-4.5 3.3-7 5C185.6 84.2 159.8 96 128 96S70.4 84.2 52 71.7c-2.5-1.7-4.8-3.4-7-5zM412.2 436.6C390.7 465.2 363.4 480 336 480s-54.7-14.8-76.2-43.4S224 366.8 224 320s14.3-87.9 35.8-116.6C281.3 174.8 308.6 160 336 160s54.7 14.8 76.2 43.4C433.7 232.1 448 273.2 448 320s-14.3 87.9-35.8 116.6zM336 512c79.5 0 144-86 144-192s-64.5-192-144-192s-144 86-144 192s64.5 192 144 192zm129.7-40.2c52.9 16.5 105.5 8.4 139.6-27c56.2-58.3 41-168.6-33.9-246.4c-42.9-44.5-96.1-68.7-144.2-70.3c13.6 10.4 25.7 22.9 36.2 36.9c.5 .7 1 1.4 1.5 2c28.3 9 57.7 26.8 83.4 53.5c33.1 34.4 52.4 75.3 57.5 112.6c5.2 37.5-3.9 68.9-23.6 89.3c-19.5 20.2-48.9 29.2-84 24c-5-.7-10.1-1.8-15.2-3.1c-5.2 10-11 19.5-17.4 28.3zM32 256c0-70.7 57.3-128 128-128h16c0 70.7-57.3 128-128 128H32z'
      
    ]
  };

  

  
  

  var faPlugCircleMinus = {
    prefix: 'fasl',
    iconName: 'plug-circle-minus',
    icon: [
      576,
      512,
      [],
      'e55e',
      
      'M128 16V0H96V16v96h32V16zm160 0V0H256V16v96h32V16zM16 144H0v32H16 32v64c0 83 63.1 151.2 144 159.2V496v16h32V496 399.2c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128V176H320v56.2c9.8-8.1 20.6-15.2 32-21V176h16 16V144H368 352 320 64 32 16zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm80-128V352H496 368 352v32h16H496h16z'
      
    ]
  };

  

  
  

  var faArrowTrendUp = {
    prefix: 'fasl',
    iconName: 'arrow-trend-up',
    icon: [
      576,
      512,
      [],
      'e098',
      
      'M368 96h16H560h16v16V288v16H544V288 150.6L331.3 363.3 320 374.6l-11.3-11.3L192 246.6 27.3 411.3 4.7 388.7l176-176L192 201.4l11.3 11.3L320 329.4 521.4 128H384 368V96z'
      
    ]
  };

  

  
  

  var faStore = {
    prefix: 'fasl',
    iconName: 'store',
    icon: [
      576,
      512,
      [],
      'f54e',
      
      'M483.4 224c-19.7 0-37.7-6.5-52.2-17.2c-4.7-3.5-9.1-7.4-13-11.8c-3.9 4.3-8.2 8.2-12.9 11.7c-14.5 10.8-32.5 17.3-52.3 17.3c-19.6 0-37.5-6.4-52-17c-4.8-3.5-9.2-7.5-13.2-11.9c-4 4.4-8.4 8.4-13.2 12c-14.4 10.6-32.4 17-52 17c-19.6 0-37.5-6.4-52-17c-4.8-3.5-9.2-7.5-13.2-11.9c-4 4.4-8.4 8.4-13.2 11.9c-14.4 10.6-32.4 17-52 17c-4.1 0-8.2-.3-12.1-.8c-55.3-7.4-81.5-72.6-51.9-119.4L96 0H480l67.6 103.8c29.7 46.9 3.4 112-52.1 119.4c-4 .5-7.9 .8-12.1 .8zm-399-32.5c2.7 .3 5.4 .5 7.9 .5c16.6 0 31.3-7.2 41.5-18.4l23.7-26.3 23.7 26.3c10.2 11.2 24.9 18.4 41.4 18.4c16.6 0 31.3-7.2 41.4-18.4l23.7-26.3 23.7 26.3c10.2 11.2 24.9 18.4 41.4 18.4c16.6 0 31.3-7.2 41.4-18.4l23.7-26.2 23.7 26.1c10.3 11.3 25 18.5 41.5 18.5c2.7 0 5.3-.2 7.9-.5c29.5-3.9 47.9-40.9 29.3-70.4L462.7 32H113.3L55.3 121.1c-18.5 29.5-.1 66.4 29.2 70.4zM96 256v96H480V256h32v96 32 96 32H480 96 64V480 384 352 256H96zm0 128v96H480V384H96z'
      
    ]
  };

  

  
  

  var faDisplayArrowDown = {
    prefix: 'fasl',
    iconName: 'display-arrow-down',
    icon: [
      576,
      512,
      [],
      'e164',
      
      'M32 0H240V32H32V384H231.7c.2 0 .4 0 .6 0H343.7c.2 0 .4 0 .6 0H544V32H336V0H544h32V32 384v32H544 362.9l10.7 64H432h16v32H432 360 216 144 128V480h16 58.4l10.7-64H32 0V384 32 0H32zM245.6 416l-10.7 64H341.1l-10.7-64H245.6zM304 16V233.4l52.7-52.7L368 169.4 390.6 192l-11.3 11.3-80 80L288 294.6l-11.3-11.3-80-80L185.4 192 208 169.4l11.3 11.3L272 233.4V16 0h32V16z'
      
    ]
  };

  

  
  

  var faCircleGf = {
    prefix: 'fasl',
    iconName: 'circle-gf',
    icon: [
      512,
      512,
      [],
      'e67f',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 128c35.3 0 64 28.7 64 64l0 8 0 16-32 0 0-16 0-8c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32-16 0-16 0 0-32 16 0 32 0 16 0 0 16 0 48c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-128c0-35.3 28.7-64 64-64zm96 0l16 0 64 0 16 0 0 32-16 0-48 0 0 96 32 0 16 0 0 32-16 0-32 0 0 80 0 16-32 0 0-16 0-224 0-16z'
      
    ]
  };

  

  
  

  var faChartScatter = {
    prefix: 'fasl',
    iconName: 'chart-scatter',
    icon: [
      512,
      512,
      [],
      'f7ee',
      
      'M32 48V32H0V48 464v16H16 496h16V448H496 32V48zm184 88H168v48h48V136zM136 296v48h48V296H136zm176-64H264v48h48V232zm48 64v48h48V296H360zm80-192H392v48h48V104z'
      
    ]
  };

  

  
  

  var faFaceEyesXmarks = {
    prefix: 'fasl',
    iconName: 'face-eyes-xmarks',
    icon: [
      512,
      512,
      [],
      'e374',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm248 48h16c48.6 0 88 39.4 88 88v8 16H336 176 160V400v-8c0-48.6 39.4-88 88-88zm16 32H248c-28.2 0-51.6 20.9-55.4 48H319.4c-3.9-27.1-27.2-48-55.4-48zM137.4 192l-36.7-36.7 22.6-22.6L160 169.4l36.7-36.7 22.6 22.6L182.6 192l36.7 36.7-22.6 22.6L160 214.6l-36.7 36.7-22.6-22.6L137.4 192zm192 0l-36.7-36.7 22.6-22.6L352 169.4l36.7-36.7 22.6 22.6L374.6 192l36.7 36.7-22.6 22.6L352 214.6l-36.7 36.7-22.6-22.6L329.4 192z'
      
    ]
  };

  

  
  

  var faPlanetMoon = {
    prefix: 'fasl',
    iconName: 'planet-moon',
    icon: [
      576,
      512,
      [],
      'e01f',
      
      'M512 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 512 0a64 64 0 1 0 0 128zM224 480C118 480 32 394 32 288c0-8.1 .5-16.1 1.5-24h71.9L152 310.6V360v9.9l8.8 4.4L184 385.9V440v16h16 48 8.9l4.7-7.6 64-104 2.4-3.9V336 264 248H312 209.9l-7.4-14.9 58.8-88.3 3-4.5-.4-5.4-2.4-35.3C349.6 117.2 416 194.8 416 288c0 106-86 192-192 192zM40.3 232C64.3 153.3 137.4 96 224 96c1.8 0 3.5 0 5.3 .1l2.4 35.6-61 91.5-5.2 7.7 4.2 8.3 16 32 4.4 8.8H200h96v51.5L239.1 424H216V376v-9.9l-8.8-4.4L184 350.1V304v-6.6l-4.7-4.7-56-56-4.7-4.7H112 40.3zM227.2 64c-1.1 0-2.1 0-3.2 0C100.3 64 0 164.3 0 288S100.3 512 224 512s224-100.3 224-224c0-111.7-81.7-204.2-188.6-221.2l0 0c-10.5-1.7-21.3-2.6-32.3-2.8l0 0z'
      
    ]
  };

  

  
  

  var faFolderMinus = {
    prefix: 'fasl',
    iconName: 'folder-minus',
    icon: [
      512,
      512,
      [],
      'f65d',
      
      'M32 32H224l48 64H480h32v32V448v32H480 32 0V448 64 32H32zm240 96H256l-9.6-12.8L208 64H32V448H480V128H272zM160 264H352h16v32H352 160 144V264h16z'
      
    ]
  };

  

  
  

  var faFloppyDiskCircleArrowRight = {
    prefix: 'fasl',
    iconName: 'floppy-disk-circle-arrow-right',
    icon: [
      576,
      512,
      ["save-circle-arrow-right"],
      'e180',
      
      'M32 480H0V448 64 32H32 336L448 144v48.7c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7V157.3L322.7 64H320V176v16H304 80 64V176 64H32V448H275.2c5.9 11.4 12.9 22.2 21 32H32zM224 240c25.1 0 47.4 11.5 62.1 29.5c-6.9 10.2-12.8 21.2-17.4 32.8c-7-17.8-24.4-30.4-44.7-30.4c-26.5 0-48 21.5-48 48s21.5 48 48 48c12.5 0 23.9-4.8 32.4-12.6c-.3 4.2-.4 8.4-.4 12.6c0 8.3 .6 16.5 1.7 24.6C247.5 397.3 236 400 224 400c-44.2 0-80-35.8-80-80s35.8-80 80-80zM96 64v96H288V64H96zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm8 65.4l11.3 11.3 56 56L518.6 368l-11.3 11.3-56 56L440 446.6 417.4 424l11.3-11.3L457.4 384H368 352V352h16 89.4l-28.7-28.7L417.4 312 440 289.4z'
      
    ]
  };

  
    var faSaveCircleArrowRight = faFloppyDiskCircleArrowRight;
  

  
  

  var faPhotoFilm = {
    prefix: 'fasl',
    iconName: 'photo-film',
    icon: [
      640,
      512,
      ["photo-video"],
      'f87c',
      
      'M608 32H224V233.4l84.7-84.7L320 137.4l11.3 11.3L384 201.4 500.7 84.7 512 73.4l11.3 11.3L608 169.4V32zm32 176c0 0 0 0 0 .1V320v32H608 272c0 0 0 0 0 0H224 192V320 272s0 0 0 0V32 0h32H608h32V32 208zm-32 6.7l-96-96L395.3 235.3 310.6 320H608V214.6zM265.4 320l96-96L320 182.6l-96 96V320h41.4zM296 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM128 160h32v32H128v80V400v80H384V384h32v96h64V384h32v96 32H480 416 400 384 128 112 96 32 0V480 192 160H32 96h16 16zM96 192H32v64H96V192zM32 480H96V416H32v64zm64-96V288H32v96H96z'
      
    ]
  };

  
    var faPhotoVideo = faPhotoFilm;
  

  
  

  var faVideoArrowDownLeft = {
    prefix: 'fasl',
    iconName: 'video-arrow-down-left',
    icon: [
      576,
      512,
      [],
      'e2c8',
      
      'M352 96V416H32V96H352zM32 64H0V96 416v32H32 352h32V416 352 160 96 64H352 32zM416 332.2V368l128 64 32 16V412.2 99.8 64L544 80 416 144v35.8l128-64V396.2l-128-64zM224 352h16V320H224 150.6L283.3 187.3 294.6 176 272 153.4l-11.3 11.3L128 297.4V224 208H96v16V336v16h16H224z'
      
    ]
  };

  

  
  

  var faCandleHolder = {
    prefix: 'fasl',
    iconName: 'candle-holder',
    icon: [
      448,
      512,
      [128367],
      'f6bc',
      
      'M160 160c26.5 0 48-21.5 48-48c0-3.7-1.8-10.9-8.1-21.5c-6-10.2-14.4-20.8-23.6-30.9c-5.6-6.1-11.2-11.8-16.3-16.7c-5.1 4.9-10.7 10.6-16.3 16.7c-9.2 10.1-17.6 20.8-23.6 30.9c-6.3 10.7-8.1 17.8-8.1 21.5c0 26.5 21.5 48 48 48zM160 0s80 64 80 112c0 44.2-35.8 80-80 80s-80-35.8-80-80C80 64 160 0 160 0zM0 480H16 64V272c0-26.5 21.5-48 48-48h16 32 48c26.5 0 48 21.5 48 48V480h72.6c-5.4-9.4-8.6-20.3-8.6-32c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64H256 224 96 64 16 0V480zM128 256H112c-8.8 0-16 7.2-16 16V480H224V272c0-8.8-7.2-16-16-16H160v48 16H128V304 256zM384 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faClockTen = {
    prefix: 'fasl',
    iconName: 'clock-ten',
    icon: [
      512,
      512,
      [],
      'e354',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112V226.1l-71.1-47.4-13.3-8.9-17.8 26.6 13.3 8.9 96 64L272 285.9V256 112 96H240v16z'
      
    ]
  };

  

  
  

  var faSirenOn = {
    prefix: 'fasl',
    iconName: 'siren-on',
    icon: [
      640,
      512,
      [],
      'e02e',
      
      'M55.2 33.7l64 32 14.3 7.2-14.3 28.6-14.3-7.2-64-32L26.5 55.2 40.8 26.5l14.3 7.2zm544 28.6l-64 32-14.3 7.2L506.5 72.8l14.3-7.2 64-32 14.3-7.2 14.3 28.6-14.3 7.2zM16 192H80 96v32H80 16 0V192H16zm544 0h64 16v32H624 560 544V192h16zM492 320H459.8l-24-192H204.2l-24 192H148L176 96H464l28 224zm-250.1 0l14.2-114 1.8-14h32.2l-2.2 18L274.1 320H241.9zM512 384H128v64H512V384zM128 352H512h32v32 64 32H512 128 96V448 384 352h32z'
      
    ]
  };

  

  
  

  var faRocket = {
    prefix: 'fasl',
    iconName: 'rocket',
    icon: [
      512,
      512,
      [],
      'f135',
      
      'M384 312.1c4-2.5 7.7-4.9 11.3-7.3C527.1 215.4 519.9 78.3 502.7 9.3c-68.9-17.2-206-24.5-295.4 107.4c-2.4 3.6-4.9 7.3-7.3 11.3H88 78.1l-4.4 8.8-64 128L-1.9 288H24h94.5c-10.9 24.4-17.9 40.9-17.9 40.9l80.8 80.8s17.2-7 42.6-17.9l0 96.2 0 25.9 23.2-11.6 128-64 8.8-4.4V424 312.1zm-32 18.5v83.5l-96 48 0-84.5c30.3-13.7 65.4-30.3 96-47zM133.1 256H49.9l48-96h83.3c-16.9 30.7-34 65.8-48.1 96zm5.5 65.6l1.5-3.5c6.3-14.4 15.2-34.4 25.6-56.4c20.9-44.6 46.7-95.6 68-127.1c70.9-104.6 175.7-110.1 242-98.4c11.7 66.3 6.2 171.1-98.4 242c-31.5 21.3-82.7 46.6-127.7 67.1c-22.2 10.1-42.3 18.8-56.8 25l-3.9 1.6-50.4-50.4zM368 168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-56-24a56 56 0 1 0 112 0 56 56 0 1 0 -112 0z'
      
    ]
  };

  

  
  

  var faClockEleven = {
    prefix: 'fasl',
    iconName: 'clock-eleven',
    icon: [
      512,
      512,
      [],
      'e347',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112v91.2l-34.7-52-8.9-13.3-26.6 17.8 8.9 13.3 64 96L272 256V112 96H240v16z'
      
    ]
  };

  

  
  

  var faLassoSparkles = {
    prefix: 'fasl',
    iconName: 'lasso-sparkles',
    icon: [
      576,
      512,
      [],
      'e1c9',
      
      'M352 0V16 64h48 16V96H400 352v48 16H320V144 96H272 256V64l16 0h48V16 0h32zM0 176C0 85.4 112 10.8 256 1.1v32C129.7 42 32 102.6 32 176c0 47.1 40.2 88.9 102.4 115.2l0 0c5.5 2.3 11.2 4.5 17 6.6l0 0C190.9 311.9 237.8 320 288 320c141.4 0 256-64.5 256-144c0-45.5-37.5-86-96-112.4V29.6C525.2 61.2 576 115 576 176c0 97.2-128.9 176-288 176c-22.9 0-45.3-1.6-66.7-4.7c11.9 17.2 18.7 38 18.7 59.7c0 58-47 105-105 105H48 32V480H48h87c40.3 0 73-32.7 73-73c0-27.6-15.6-52.9-40.4-65.3l-34.9-17.4C52.9 293 0 238.3 0 176zM512 368v48h48 16v32H560 512v48 16H480V496 448H432 416V416h16 48V368 352h32v16z'
      
    ]
  };

  

  
  

  var faFaceDisappointed = {
    prefix: 'fasl',
    iconName: 'face-disappointed',
    icon: [
      512,
      512,
      [],
      'e36f',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM316.1 410.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7l-10.7 11.9-23.8-21.4 10.7-11.9C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3l10.7 11.9-23.8 21.4-10.7-11.9zM222.6 256l-11.3 11.3-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L200 233.4 222.6 256zm78.1 11.3L289.4 256 312 233.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z'
      
    ]
  };

  

  
  

  var faFileCircleInfo = {
    prefix: 'fasl',
    iconName: 'file-circle-info',
    icon: [
      576,
      512,
      [58604],
      'e493',
      
      'M352 192v19.2c10.1-5.2 20.8-9.4 32-12.6V152L232 0H32 0V32 480v32H32 330.8c-12.9-9.1-24.5-19.9-34.6-32H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 288H416v32h32V288zM400 448h16 0 32 0 16V416H448h0V352 336H432 416 400v32h16v48H400v32z'
      
    ]
  };

  

  
  

  var faArrowLeftFromArc = {
    prefix: 'fasl',
    iconName: 'arrow-left-from-arc',
    icon: [
      512,
      512,
      [],
      'e615',
      
      'M480.1 256c0-123.7-100.3-224-224-224h-16V0h16c141.4 0 256 114.6 256 256s-114.6 256-256 256h-16V480h16c123.7 0 224-100.3 224-224zM157.5 116l12-10.6 21.3 23.9-12 10.6L66.2 240H336.1h16v32h-16H66.2L178.7 372l12 10.6-21.3 23.9-12-10.6L13.5 268 0 256l13.5-12 144-128z'
      
    ]
  };

  

  
  

  var faMap = {
    prefix: 'fasl',
    iconName: 'map',
    icon: [
      576,
      512,
      [62072,128506],
      'f279',
      
      'M160 387.8L32 434.3V118.4L160 71.9V387.8zm224 54.4L192 387.3V69.9l192 54.9V442.1zm32-2V124.2L544 77.7V393.6L416 440.1zM0 480l32-11.6L176 416l224 64 176-64V66 32L544 43.6 400 96 176 32 0 96V445.9 480z'
      
    ]
  };

  

  
  

  var faUserHairLong = {
    prefix: 'fasl',
    iconName: 'user-hair-long',
    icon: [
      448,
      512,
      [],
      'e45b',
      
      'M224 240c-53 0-96-43-96-96V128l88 0h8l4.8-6.4 16-21.3 20.1 10 3.4 1.7H272h46.7c.9 5.2 1.3 10.5 1.3 16v16c0 53-43 96-96 96zM275.8 80L247.2 65.7l-11.9-6-8 10.7L208 96H133.5c13.2-37.3 48.7-64 90.5-64c35.5 0 66.6 19.3 83.2 48H275.8zM351 112C343.1 48.9 289.3 0 224 0S104.9 48.9 97 112H96v16 16 40L38.4 227.2 32 232v8 32 16H48h80 16V256H128 64v-8l50.4-37.8C136.8 247.2 177.5 272 224 272s87.2-24.8 109.6-61.8L384 248v8H320 304v32h16 80 16V272 240v-8l-6.4-4.8L352 184V144 128 112h-1zM44.4 480L87.1 352H360.9l42.7 128H44.4zM64 320L10.7 480 0 512H33.7 414.3 448l-10.7-32L384 320H64z'
      
    ]
  };

  

  
  

  var faAxeBattle = {
    prefix: 'fasl',
    iconName: 'axe-battle',
    icon: [
      512,
      512,
      [],
      'f6b3',
      
      'M510.6 169.4L488 192l22.6 22.6 .4 .4c-6 70.3-38.4 118.7-61.9 145.1C434.9 376 424 384 424 384s-4-12.8-13.5-30.3C394 323.5 361.1 279.2 304 262.6V229.5c50.1 12 85.5 41.6 108.8 70.3c8.2 10.1 15 20.1 20.5 29.3c1.6-2 3.2-4.1 4.8-6.3c16.1-22.1 33.1-54.1 39.4-96.2l-12.1-12.1L442.7 192l22.6-22.6 12.1-12.1c-6.3-42.1-23.3-74.1-39.4-96.2c-1.6-2.2-3.2-4.3-4.8-6.3c-5.5 9.2-12.3 19.3-20.5 29.3c-23.3 28.7-58.7 58.3-108.8 70.3V121.4c57.1-16.6 90-60.8 106.5-91.1C420 12.8 424 0 424 0s10.9 8 25.1 23.9C472.6 50.3 505 98.7 511 169l-.4 .4zM101.5 30.3C118 60.5 150.9 104.8 208 121.4v33.1c-50.1-12-85.5-41.6-108.8-70.3C91 74.1 84.2 64.1 78.7 54.8c-2.7 3.5-5.5 7.2-8.3 11.3C51.2 94 32 135.7 32 192s19.2 98 38.4 125.9c2.8 4.1 5.6 7.8 8.3 11.3c5.5-9.3 12.3-19.3 20.5-29.3c23.3-28.7 58.7-58.3 108.8-70.3v33.1c-57.1 16.6-90 60.8-106.5 91.1C92 371.2 88 384 88 384s-10.9-8-25.1-23.9C36.9 330.9 0 274.9 0 192S36.9 53.1 62.9 23.9C77.1 8 88 0 88 0s4 12.8 13.5 30.3zM272 48V496v16H240V496 48 32h32V48z'
      
    ]
  };

  

  
  

  var faCars = {
    prefix: 'fasl',
    iconName: 'cars',
    icon: [
      640,
      512,
      [],
      'f85b',
      
      'M75.9 0H88 296h12.1l3.3 11.6L340.1 112H352h32v32H352h-8H328.4h-.7H307.8 56.4c-.2 0-.5 0-.7 0H32v96 16H224v32H32v48H0V288 256 240 144 112H32 43.9L72.6 11.6 75.9 0zm208 32H100.1L77.2 112H306.8L283.9 32zM80 176a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm251.9 0H344 552h12.1l3.3 11.6L596.1 288H608h32v32 96 16 32 48H608V464H288v48H256V464 432 416 320 288h32 11.9l28.7-100.4 3.3-11.6zM608 320H584.4c-.2 0-.5 0-.7 0H312.4c-.2 0-.5 0-.7 0H288v96 16H608V416 320zM539.9 208H356.1l-22.9 80H562.8l-22.9-80zM336 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm200 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faShekelSign = {
    prefix: 'fasl',
    iconName: 'shekel-sign',
    icon: [
      448,
      512,
      [8362,"ils","shekel","sheqel","sheqel-sign"],
      'f20b',
      
      'M48 32H32V48 464v16H64V464 64H192c44.2 0 80 35.8 80 80V336v16h32V336 144c0-61.9-50.1-112-112-112H48zM304 480c61.9 0 112-50.1 112-112V48 32H384V48 368c0 44.2-35.8 80-80 80H176V176 160H144v16V464v16h16H304z'
      
    ]
  };

  
    var faIls = faShekelSign;
  
    var faShekel = faShekelSign;
  
    var faSheqel = faShekelSign;
  
    var faSheqelSign = faShekelSign;
  

  
  

  var faTally2 = {
    prefix: 'fasl',
    iconName: 'tally-2',
    icon: [
      640,
      512,
      [],
      'e295',
      
      'M144 48V32H112V48 464v16h32V464 48zm128 0V32H240V48 464v16h32V464 48z'
      
    ]
  };

  

  
  

  var faTeeth = {
    prefix: 'fasl',
    iconName: 'teeth',
    icon: [
      576,
      512,
      [],
      'f62e',
      
      'M32 64V448H544V64H32zM0 32H32 544h32V64 448v32H544 32 0V448 64 32zM160 224c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h64V224zM96 288v32c0 17.7 14.3 32 32 32s32-14.3 32-32V288H96zm75.5 79c-11.4 10.6-26.7 17-43.5 17c-35.3 0-64-28.7-64-64V272 224c0-35.3 28.7-64 64-64c14 0 27 4.5 37.6 12.2c10.9-26 36.5-44.2 66.4-44.2c22.6 0 42.8 10.4 56 26.7c13.2-16.3 33.4-26.7 56-26.7c29.9 0 55.5 18.2 66.4 44.2C421 164.5 434 160 448 160c35.3 0 64 28.7 64 64v48 48c0 35.3-28.7 64-64 64c-16.8 0-32-6.5-43.5-17c-12.8 19.9-35.1 33-60.5 33c-22.6 0-42.8-10.4-56-26.7c-13.2 16.3-33.4 26.7-56 26.7c-25.4 0-47.7-13.2-60.5-33zM232 160c-22.1 0-40 17.9-40 40v24 32h80V200c0-22.1-17.9-40-40-40zM192 320v8c0 22.1 17.9 40 40 40s40-17.9 40-40V288H192v32zm224-64h64V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v32zm0 64c0 17.7 14.3 32 32 32s32-14.3 32-32V288H416v32zm-72 48c22.1 0 40-17.9 40-40v-8V288H304v40c0 22.1 17.9 40 40 40zm40-112V224 200c0-22.1-17.9-40-40-40s-40 17.9-40 40v56h80z'
      
    ]
  };

  

  
  

  var faBlender = {
    prefix: 'fasl',
    iconName: 'blender',
    icon: [
      512,
      512,
      [],
      'f517',
      
      'M0 0H16 128h24 8.1H479h33l-8 32-24 96L424 352h24 32v32 96 32H448 128 96V480 384 352h32 29.3L148 240H16 0V224 16 0zM423 224H304 288V192h16H431l16-64H304 288V96h16H455l16-64H162.8l26.7 320H391l32-128zM128 384v96H448V384H416 160 128zM32 32V208H145.3L130.7 32H32zM288 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faWrenchSimple = {
    prefix: 'fasl',
    iconName: 'wrench-simple',
    icon: [
      384,
      512,
      [],
      'e2d1',
      
      'M262.6 182.6l9.4-9.4V160 53.4c47.8 27.7 80 79.4 80 138.6c0 59.2-32.1 110.9-80 138.6l-16 9.2v18.5V416v64 32h32V480 358.3c57.4-33.2 96-95.2 96-166.3c0-77.5-45.9-144.3-112-174.6C261.8 12.7 251.1 8.9 240 6V39.3 160l-25.4 25.4L192 208l-22.6-22.6L144 160V39.3 6c-11.1 2.9-21.8 6.7-32 11.4C45.9 47.7 0 114.5 0 192c0 71.1 38.6 133.1 96 166.3V480v32h32V480 416 358.3 339.9l-16-9.2C64.1 302.9 32 251.2 32 192c0-59.2 32.2-110.9 80-138.6V160v13.3l9.4 9.4 48 48L192 253.3l22.6-22.6 48-48z'
      
    ]
  };

  

  
  

  var faPeanut = {
    prefix: 'fasl',
    iconName: 'peanut',
    icon: [
      512,
      512,
      [],
      'e430',
      
      'M512 148c0 41.1-16.7 78.2-43.8 105.1c-14.1 14-30.3 24.6-47.6 31.7c-11.2 4.6-22.9 7.6-34.6 10.4c-22.4 5.6-44.6 11.1-62.1 28.6c-17.6 17.6-25.4 42.2-30.3 66.7c-5.4 29.9-19.4 56.9-41.8 78.9C225.1 495.8 188.5 512 148 512H32 0V480 364c0-20.1 4-39.2 11.2-56.7c7.2-17.5 17.9-33.8 32.1-48c22-22 48.6-35.6 78.1-41c24.5-4.8 49.1-12.6 66.7-30.3c17.6-17.6 23.1-39.7 28.6-62.1c2.9-11.7 5.8-23.4 10.4-34.6c7.2-17.5 18-34 32.3-48.2c14.2-14.1 30.5-24.8 47.8-32C324.8 4 343.9 0 364 0H480h32V32 148zM148 480c31.7 0 60.4-12.7 81.4-33.3l20.9 21.3-20.9-21.3c17.6-17.4 28.5-38.3 32.7-61.8l0-.2 0-.2c5.1-25.9 14.4-58.5 39-83.1c19.1-19.1 41.3-27.4 60-32.6c7.7-2.2 14.1-3.8 19.9-5.2c10.1-2.5 18.2-4.5 27.2-8.2l0 0c13.5-5.6 26.2-13.9 37.3-24.9l0 0C466.9 209.3 480 180.2 480 148V32H364c-15.8 0-30.8 3.1-44.4 8.8l0 0c-13.6 5.6-26.3 14-37.5 25.1c-11.2 11.2-19.7 24.1-25.3 37.8l0 0c-3.7 9-5.7 17.1-8.2 27.2l0 0c-1.4 5.8-3 12.2-5.2 19.9c-5.3 18.7-13.5 40.9-32.6 60c-24.6 24.6-57.2 33.9-83.1 39l-.2 0-.2 0C104 254.1 83.3 264.7 66 282c-11.2 11.2-19.5 24-25.2 37.6l0 0C35.1 333.2 32 348.2 32 364V480H148zM396.8 128a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-64 64a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-224 224a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM192 396.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM396.8 192a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM192 332.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4z'
      
    ]
  };

  

  
  

  var faBuildingMagnifyingGlass = {
    prefix: 'fasl',
    iconName: 'building-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e61c',
      
      'M32 32H352V192c9.8-7.4 20.6-13.7 32-18.7V32 0H352 32 0V32 480v32H32h96 32 64 32 96 32V480 466.7c-11.4-5-22.2-11.3-32-18.7v32H256V400 368H224 160 128v32 80H32V32zM304 224H240 224v16 64 16h16 48c0-36 11.9-69.3 32-96H304zM160 480V400h64v80H160zM64 96v16 64 16H80h64 16V176 112 96H144 80 64zm32 32h32v32H96V128zM240 96H224v16 64 16h16 64 16V176 112 96H304 240zm16 64V128h32v32H256zM64 224v16 64 16H80h64 16V304 240 224H144 80 64zm32 32h32v32H96V256zm160 32V256h32v32H256zm192-63.9a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224c29.6 0 56.8-10 78.5-26.9L604.7 499l11.3 11.3 22.6-22.7-11.3-11.3-78.1-77.7C566 376.9 576 349.7 576 320.2c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z'
      
    ]
  };

  

  
  

  var faCakeSlice = {
    prefix: 'fasl',
    iconName: 'cake-slice',
    icon: [
      512,
      512,
      [127856,"shortcake"],
      'e3e5',
      
      'M296 64L52.3 256H480c0-64-28-112-65-144s-83-48-119-48zM0 272V256.5l12.2-9.6 264-208 8.7-6.9H296c44.3 0 97.6 19.2 139.9 55.8C479.2 125.2 512 181.7 512 256v.7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .6 .1 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .1 .4 .5 .5 .4 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .2 .3 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 32H480 32 0V448 368 272zm32 80H480v-.4-.5-.5-.5-.5-.5-.5V348v-.5V347v-.5V346v-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5V339v-.5V338v-.5-.5-.5-.6-.6-.6-.6-.6V333v-.6-.6-.6-.6-.6-.6V329v-.6-.6-.6-.6-.6-.6V325v-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6V318v-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6V310v-.6-.6-.6-.6-.6-.6-.6V305v-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6V298v-.7-.7V296v-.7-.7V294v-.7-.7-.7-.7-.7-.7-.7-.7V288v0H32v64zm0 32v64H480v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V447 447v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V446 446v-.1-.1-.1-.1-.1-.1-.1-.1-.1V445v-.1-.1-.1-.1-.1-.1-.1-.1-.1V444v-.1-.1-.1-.1-.1-.1-.1V443v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V441v-.1-.1-.1-.1-.1-.1V440v-.1-.1-.1-.1-.1-.1V439v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V437v-.2-.2-.2-.2-.2V436v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V434v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V429v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V425v-.2-.2-.2V424v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.3-.2-.3-.3-.3-.3-.3-.3-.3-.3V419v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V416v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V412v-.3-.3-.3-.3-.3-.3-.3-.3-.3V409v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.4-.4-.4-.4-.4V396v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V392v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V387v-.4-.4-.4-.4V385v-.4-.4V384H32z'
      
    ]
  };

  
    var faShortcake = faCakeSlice;
  

  
  

  var faEquals = {
    prefix: 'fasl',
    iconName: 'equals',
    icon: [
      448,
      512,
      [62764],
      '3d',
      
      'M32 144H16v32H32 416h16V144H416 32zm0 192H16v32H32 416h16V336H416 32z'
      
    ]
  };

  

  
  

  var faH2 = {
    prefix: 'fasl',
    iconName: 'h2',
    icon: [
      640,
      512,
      [],
      'f314',
      
      'M32 80V64H0V80 256 432v16H32V432 272H288V432v16h32V432 256 80 64H288V80 240H32V80zM501.2 96H507c47 0 85 38.1 85 85c0 23.1-9.4 45.2-26.1 61.2l-185 178.2-4.9 4.7V448h16H624h16V416H624 431.7L588.1 265.3C611.1 243.3 624 212.8 624 181c0-64.6-52.4-117-117-117h-5.8c-33 0-64.8 11.8-89.9 33.2l-21.7 18.6-12.1 10.4 20.8 24.3 12.1-10.4 21.7-18.6c19.2-16.5 43.7-25.5 69-25.5z'
      
    ]
  };

  

  
  

  var faArrowRightFromLine = {
    prefix: 'fasl',
    iconName: 'arrow-right-from-line',
    icon: [
      448,
      512,
      [8614,"arrow-from-left"],
      'f343',
      
      'M435.3 267.3L446.6 256l-11.3-11.3-128-128L296 105.4 273.4 128l11.3 11.3L385.4 240 112 240l-16 0 0 32 16 0 273.4 0L284.7 372.7 273.4 384 296 406.6l11.3-11.3 128-128zM32 80l0-16L0 64 0 80 0 432l0 16 32 0 0-16L32 80z'
      
    ]
  };

  
    var faArrowFromLeft = faArrowRightFromLine;
  

  
  

  var faIslandTropical = {
    prefix: 'fasl',
    iconName: 'island-tropical',
    icon: [
      512,
      512,
      [127965,"island-tree-palm"],
      'f811',
      
      'M165.8 125.8c11.4-11.4 22.8-19.8 33.9-26l-15.5-28C173 78.1 161.8 86 150.8 96H66.9C76.3 68.5 108.7 32 176 32c45.5 0 75.1 16.8 92.3 35.9l7.2 8 10.2-3.7C299.5 67.2 316.2 64 336 64c67.3 0 99.7 36.5 109.1 64H260.8h-6.6l-4.7 4.7L134 248.2c-12.9-26.1-15.7-74.8 31.9-122.4l0 0 0 0zM176 0C78.6 0 32 66.2 32 112v16H48h74.1C77.8 190.3 92 255.7 120.6 284.2l11.3 11.3 11.3-11.3 94.4-94.4c-.4 3.9-.9 7.9-1.4 12.1c-5.3 40.7-17 94.1-42.4 150.1H160C89.3 352 32 409.3 32 480v32H64 384h32V480c0-65-48.4-118.6-111.1-126.9c19.6-64.1 20.6-123.6 16.1-168.7c-.9-8.7-1.9-16.8-3.1-24.4H464h16V144c0-45.8-46.6-112-144-112c-19 0-36.1 2.5-51.4 6.9C260.8 16.5 224.7 0 176 0zM285.4 160c1.4 8.4 2.7 17.6 3.7 27.6c4.4 44 3.2 102.1-17.4 164.4h-43c23-54.6 34-106.1 39.2-145.9c2.3-18 3.5-33.6 4-46.1h13.5zM160 384H288c53 0 96 43 96 96H64c0-53 43-96 96-96z'
      
    ]
  };

  
    var faIslandTreePalm = faIslandTropical;
  

  
  

  var faBracketSquare = {
    prefix: 'fasl',
    iconName: 'bracket-square',
    icon: [
      192,
      512,
      ["bracket","bracket-left"],
      '5b',
      
      'M0 32H16 144h16V64H144 32V448H144h16v32H144 16 0V464 48 32z'
      
    ]
  };

  
    var faBracket = faBracketSquare;
  
    var faBracketLeft = faBracketSquare;
  

  
  

  var faHighlighterLine = {
    prefix: 'fasl',
    iconName: 'highlighter-line',
    icon: [
      576,
      512,
      [],
      'e1af',
      
      'M336 416H263.4L214 465.4 191.4 488 175 471.6l-35.7 35.7-4.7 4.7H128 16 0V496 480v-6.6l4.7-4.7L88.4 385 72 368.6 94.6 346 144 296.6V224L480 0l80 80L336 416zm-225-8.4L38.6 480h82.7l31-31L111 407.6zm129.8-14.2l9.4-9.4h13.3 55.5l23.4-35.1L211.1 217.7 176 241.1v55.5 13.3l-9.4 9.4-49.4 49.4 74.1 74.1 49.4-49.4zm119.6-71.6L518.8 84.1 475.9 41.2 238.2 199.6 360.4 321.7zM272 480H560h16v32H560 272 256V480h16z'
      
    ]
  };

  

  
  

  var faFlaskGear = {
    prefix: 'fasl',
    iconName: 'flask-gear',
    icon: [
      640,
      512,
      [],
      'e5f1',
      
      'M288 214.9V224l4.7 7.7 28.1 45.6L339 245.8l-19-30.9V32h16 16V0H336 320 288 160 128 112 96V32h16 16V214.9L0 422.9V480v32H32 352V480H32V432l49.2-80H325.5l.5-.3-36.1-20.8 6.3-10.9H100.9l54.3-88.3L160 224v-9.1V32H288V214.9zm240.2 23.5v-32h-32-32-32v32 3.2c-7.7 3.4-15 7.5-21.8 12.3l-4.3-2.5-27.5-16.3L362.8 263l-32.1 57 30.1 17.8c-.5 4.6-.8 9.2-.8 13.9s.3 9.4 .8 13.9l-30.1 17.8 32.1 57 15.7 27.9L406.1 452l4.3-2.5c6.8 4.8 14.1 9 21.8 12.3V465v32h32 32 32V465v-3.3c7.6-3.3 14.8-7.4 21.5-12.2l4.3 2.5 27.5 16.3 15.7-27.9 32.1-57-30.1-17.8c.5-4.6 .8-9.2 .8-13.9s-.3-9.4-.8-13.9L629.3 320l-32.1-57-15.7-27.9-27.5 16.3-4.3 2.5c-6.7-4.8-13.9-8.9-21.5-12.2v-3.3zm37.8 43.1l3.7-2.2L586 308.4l-3.1 1.8L565 320.8l2.4 20.6c.4 3.4 .6 6.8 .6 10.3s-.2 6.9-.6 10.3L565 382.6l17.9 10.6L586 395l-16.4 29.1-3.7-2.2L548 411.3l-17 12.1c-4.9 3.5-10.2 6.5-15.7 8.9l-19.1 8.4v20.9V465h-32v-3.2-21l-19.2-8.4c-5.6-2.5-11-5.5-16-9l-17-12.1-17.9 10.6-3.7 2.2L374 395l3.1-1.8L395 382.6 392.6 362c-.4-3.4-.6-6.8-.6-10.3s.2-6.9 .6-10.3l2.4-20.6-17.9-10.6-3.1-1.8 16.4-29.1 3.7 2.2L412 292.1 429 280c5-3.5 10.3-6.6 16-9l19.2-8.4v-21-3.2h32v3.3 20.9l19.1 8.4c5.6 2.4 10.8 5.4 15.7 8.9l17 12.1 17.9-10.6zM480.1 407.7a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm0-80a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faCopyright = {
    prefix: 'fasl',
    iconName: 'copyright',
    icon: [
      512,
      512,
      [169],
      'f1f9',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 256c0-53 43-96 96-96c31.4 0 59.3 15.1 76.8 38.5l25.6-19.2C335.1 148.2 297.9 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c41.9 0 79.1-20.2 102.4-51.3l-25.6-19.2C315.3 336.9 287.4 352 256 352c-53 0-96-43-96-96z'
      
    ]
  };

  

  
  

  var faSymbols = {
    prefix: 'fasl',
    iconName: 'symbols',
    icon: [
      512,
      512,
      [128291,"icons-alt"],
      'f86e',
      
      'M16 0H208h16V32H208 16 0V0H16zm0 64H208h16V96H208 128V208v16H96V208 96H16 0V64H16zM512 4.5V24 168h-.2c.1 1.3 .2 2.7 .2 4c0 28.7-28.7 52-64 52s-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7V43.5L352 69.1V200h-.2c.1 1.3 .2 2.7 .2 4c0 28.7-28.7 52-64 52s-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7V56 42.9l12.9-2.6 160-32L512 4.5zM480 172c0-3.1-1.5-7.5-6.9-11.9c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zM320 204c0-3.1-1.5-7.5-6.9-11.9c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zm16 148a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm171.3 27.3l-192 192-22.6-22.6 192-192 22.6 22.6zM480 464a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM32 256h96 16v16 32.9c0 24.5-11.3 47.7-30.6 62.9l-12.2 9.6L154 425.2l43.6-37.4 20.8 24.3-40.6 34.8 40.9 37.2-21.5 23.7-43.9-39.9-46.9 40.2c-2.9 2.5-6.6 3.9-10.4 3.9H16 0V496 470.7c0-34.4 15.8-66.8 42.8-88.1l8.9-7-9.6-8.7C25.5 351.7 16 330.2 16 307.7V272 256H32zm61.7 86.6c11.6-9.1 18.3-23 18.3-37.7V288H48v19.7c0 13.5 5.7 26.4 15.7 35.5l13.5 12.3 16.4-12.9zM62.6 407.8C43.3 422.9 32 446.1 32 470.7V480H90.1l39.4-33.8L75.8 397.4 62.6 407.8z'
      
    ]
  };

  
    var faIconsAlt = faSymbols;
  

  
  

  var faRulerCombined = {
    prefix: 'fasl',
    iconName: 'ruler-combined',
    icon: [
      512,
      512,
      [],
      'f546',
      
      'M256 288H224V256l0-224V0H192 32 0V32 288 480v32H32 224l256 0h32V480 320 288H480 256zm128 32v64 16h32V384 320h64l0 160-256 0H32l0-192L32 32l160 0 0 64-64 0H112v32h16l64 0v64H128l-16 0v32h16l64 0v64H128 112v32h16 64v64 16h32V384 320h64v64 16h32V384 320h64z'
      
    ]
  };

  

  
  

  var faSquareQ = {
    prefix: 'fasl',
    iconName: 'square-q',
    icon: [
      448,
      512,
      [],
      'e27b',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM128 256c0 53 43 96 96 96c20.6 0 39.7-6.5 55.4-17.6L212 258.6l-2.3-2.6h42.8l49.6 55.8c11.3-15.7 17.9-35 17.9-55.8c0-53-43-96-96-96s-96 43-96 96zm224 0c0 30.4-10.6 58.2-28.2 80.2L364 381.4l2.3 2.6H323.5l-22.7-25.6c-21.4 16.1-48 25.6-76.8 25.6c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128z'
      
    ]
  };

  

  
  

  var faLinesLeaning = {
    prefix: 'fasl',
    iconName: 'lines-leaning',
    icon: [
      384,
      512,
      [],
      'e51e',
      
      'M191 53.5l5.5-15-30.1-11-5.5 15L9 458.5l-5.5 15 30.1 11 5.5-15 152-416zM291.2 36L260 28.8l-3.6 15.6-96 416L156.8 476l31.2 7.2 3.6-15.6 96-416L291.2 36zM384 32H352V48 464v16h32V464 48 32z'
      
    ]
  };

  

  
  

  var faArrowDownToBracket = {
    prefix: 'fasl',
    iconName: 'arrow-down-to-bracket',
    icon: [
      448,
      512,
      [],
      'e094',
      
      'M235.3 347.3L224 358.6l-11.3-11.3-128-128L73.4 208 96 185.4l11.3 11.3L208 297.4 208 16l0-16 32 0 0 16 0 281.4L340.7 196.7 352 185.4 374.6 208l-11.3 11.3-128 128zM32 336l0 144 384 0 0-144 0-16 32 0 0 16 0 160 0 16-16 0L16 512 0 512l0-16L0 336l0-16 32 0 0 16z'
      
    ]
  };

  

  
  

  var faArrowDownUpLock = {
    prefix: 'fasl',
    iconName: 'arrow-down-up-lock',
    icon: [
      640,
      512,
      [],
      'e4b0',
      
      'M128 510.6l11.3-11.3 96-96L246.6 392 224 369.4l-11.3 11.3L144 449.4V272H304h32l80 0c0-11.1 1.6-21.9 4.6-32H336V62.6l68.7 68.7L416 142.6 438.6 120l-11.3-11.3-96-96L320 1.4 308.7 12.7l-96 96L201.4 120 224 142.6l11.3-11.3L304 62.6V240H144 112 16 0v32H16h96V449.4L43.3 380.7 32 369.4 9.4 392l11.3 11.3 96 96L128 510.6zM112 48V200h32V48 32H112V48zM336 312H304V464v16h32V464 312zm192-88c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48H416v32V480v32h32H608h32V480 352 320H608V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z'
      
    ]
  };

  

  
  

  var faTrashArrowUp = {
    prefix: 'fasl',
    iconName: 'trash-arrow-up',
    icon: [
      448,
      512,
      ["trash-restore"],
      'f829',
      
      'M160 0h-8.9l-4.7 7.5L111.1 64H64.1 32 0V96H34.3L64 512H384L413.7 96H448V64H416 383.9 336.9L301.6 7.5 296.9 0H288 160zM299.1 64H148.9l20-32H279.1l20 32zM93.8 480L66.4 96H381.6L354.2 480H93.8zM224 169.4l-11.3 11.3-80 80L121.4 272 144 294.6l11.3-11.3L208 230.6V408h32V230.6l52.7 52.7L304 294.6 326.6 272l-11.3-11.3-80-80L224 169.4z'
      
    ]
  };

  
    var faTrashRestore = faTrashArrowUp;
  

  
  

  var faKeySkeleton = {
    prefix: 'fasl',
    iconName: 'key-skeleton',
    icon: [
      448,
      512,
      [128477],
      'f6f3',
      
      'M304 32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256c79.5 0 144-64.5 144-144S383.5 0 304 0S160 64.5 160 144c0 34 11.8 65.2 31.5 89.9L80 345.4 57.4 368 12.7 412.7 1.4 424l11.3 11.3 64 64L88 510.6 110.6 488 99.3 476.7 46.6 424 80 390.6l52.7 52.7L144 454.6 166.6 432l-11.3-11.3L102.6 368 214.1 256.5C238.8 276.2 270 288 304 288z'
      
    ]
  };

  

  
  

  var faDownFromBracket = {
    prefix: 'fasl',
    iconName: 'down-from-bracket',
    icon: [
      448,
      512,
      [],
      'e66b',
      
      'M176 304l0 32-32 0-48 0 0 17.7L224 468.9 352 353.7l0-17.7-48 0-32 0 0-32 0-112-96 0 0 112zM64 304l32 0 16 0 32 0 0-32 0-80 0-32 32 0 96 0 32 0 0 32 0 80 0 32 32 0 16 0 32 0 0 32 0 32L224 512 64 368l0-32 0-32zM416 176l0-144L32 32l0 144 0 16L0 192l0-16L0 16 0 0 16 0 432 0l16 0 0 16 0 160 0 16-32 0 0-16z'
      
    ]
  };

  

  
  

  var faTractor = {
    prefix: 'fasl',
    iconName: 'tractor',
    icon: [
      640,
      512,
      [128668],
      'f722',
      
      'M112 0H96V16 144.5l-5.8 5.8L22.3 218.2 12.1 228.4l9.2 11.2 11.9 14.6-18.8 1.9L0 257.5V272v96 14.5l14.4 1.4 18.7 1.9L21.2 400.4l-9.2 11.2 10.2 10.2 67.9 67.9 10.2 10.2 11.2-9.2 14.6-11.9 1.9 18.7 1.4 14.4H144h96 14.5l1.4-14.4 1.9-18.8 14.6 11.9 11.2 9.2 10.2-10.2 67.9-67.9 10.2-10.2-9.2-11.2-11.9-14.6 18.7-1.9 14.4-1.4V368 352H544h5.6l4.4-3.5 80-64 6-4.8V272 176 160H624v16l0-16h0 0 0 0 0 0 0 0 0 0 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1H623h-.1-.1-.1-.1-.1-.1-.1-.1-.1H622h-.1-.1-.1-.1-.1-.1-.1H621h-.1-.2-.2-.2-.2H620h-.2-.2-.2-.2-.2H619h-.2-.2-.2-.2H618h-.2-.2-.2-.2-.2-.2-.2-.2H616h-.2-.2-.2-.2-.2-.2-.3H614h-.3-.3-.3H613h-.3-.3-.3-.3-.3-.3H611h-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.4-.4-.4-.4-.4-.4-.4H602h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H596h-.4-.4-.4-.4-.4-.4H593h-.4-.4-.4-.4-.4-.5-.5-.5H589h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H575h-.5H574h-.5-.5-.5-.6-.5-.6-.6-.6H569h-.6-.6-.6-.6-.6-.6H565h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H553h-.6-.6-.6-.6-.6-.6-.6H548h-.6-.6H546h-.6-.6-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H534h-.7-.7H532h-.7-.7-.7-.7-.7-.7-.7-.7-.7H525h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H517h-.7-.7-.7-.7-.7-.7H512V86.6l27.3-27.3L550.6 48 528 25.4 516.7 36.7l-32 32L480 73.4V80v80h-.1-.8-.8-.8-.8-.8H475h-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8-.8H460h-.8-.8-.8-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9H448h-.9-.9-.9-.9-.9-.9H442h-.9-.9-.9-.9-.9-.9-.9H435h-.9-.9-.9-.9-.9-.9-.9-.9H427h-.9-.9-.9-.9-.9-.9-.9-.9-.9H418h-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9H408h-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9H397h-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9-.9H385 384h-.9-.9-.9-.9-.9-.9-.1L310.6 9.4 306.3 0H296 112zM384 320V272 257.5l-14.4-1.4-18.8-1.9 11.9-14.6 9.2-11.2-10.2-10.2L335.5 192h.1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 .9 1 .9 1 .9 .9 .9 .9 .5c.2 0 .5 0 .7 0h.6 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .9 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .8 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .5 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .3 .3 .3 .3 .3 .3 .3 .1v72.3L538.4 320H384zM303.5 160l-9.7-9.7-10.2-10.2-11.2 9.2-14.6 11.9-1.9-18.7L254.5 128H240 144 129.5l-1.4 14.4-.1 .8V32H285.7l57.6 128h-.9-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-.2zM512 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM155.7 187.3l2.7-27.3h67l2.7 27.3 1 9.8 9.1 3.6c1.8 .7 3.5 1.4 5.2 2.2l9 4 7.6-6.2 21.3-17.4 47.4 47.4-17.4 21.3-6.2 7.6 4 9c.8 1.7 1.5 3.5 2.2 5.2l3.6 9.1 9.8 1 27.3 2.7v67l-27.3 2.7-9.8 1-3.6 9.1c-.7 1.8-1.4 3.5-2.2 5.2l-4 9 6.2 7.6 17.4 21.3-47.4 47.4-21.3-17.4-7.6-6.2-9 4c-1.7 .8-3.5 1.5-5.2 2.2l-9.1 3.6-1 9.8L225.5 480h-67l-2.7-27.3-1-9.8-9.1-3.6c-1.8-.7-3.5-1.4-5.2-2.2l-9-4-7.6 6.2-21.3 17.4L55.2 409.4l17.4-21.3 6.2-7.6-4-9c-.8-1.7-1.5-3.5-2.2-5.2l-3.6-9.1-9.8-1L32 353.5v-67l27.3-2.7 9.8-1 3.6-9.1c.7-1.8 1.4-3.5 2.2-5.2l4-9-6.2-7.6L55.2 230.6l47.4-47.4 21.3 17.4 7.6 6.2 9-4c1.7-.8 3.5-1.5 5.2-2.2l9.1-3.6 1-9.8zM246.4 320a54.4 54.4 0 1 1 -108.8 0 54.4 54.4 0 1 1 108.8 0zM192 233.6a86.4 86.4 0 1 0 0 172.8 86.4 86.4 0 1 0 0-172.8z'
      
    ]
  };

  

  
  

  var faQuoteLeft = {
    prefix: 'fasl',
    iconName: 'quote-left',
    icon: [
      448,
      512,
      [8220,"quote-left-alt"],
      'f10d',
      
      'M0 208C0 146.1 50.1 96 112 96h32 16v32H144 112c-44.2 0-80 35.8-80 80v16H160h32v32V384v32H160 32 0V384 320 256 224 208zm32 48v64 64H160V256H32zm384 0H288v64 64H416V256zM256 320V256 224 208c0-61.9 50.1-112 112-112h32 16v32H400 368c-44.2 0-80 35.8-80 80v16H416h32v32V384v32H416 288 256V384 320z'
      
    ]
  };

  
    var faQuoteLeftAlt = faQuoteLeft;
  

  
  

  var faUsersLine = {
    prefix: 'fasl',
    iconName: 'users-line',
    icon: [
      640,
      512,
      [],
      'e592',
      
      'M115.2 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm256 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-341 224l24-64H393.8l24 64H222.2zM416 256H224l-36 96-12 32h34.2H429.8 464l-12-32-36-96zM273.6 144a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM87.1 256H189.8l4.2-11.2 7.8-20.8H64L32 320H65.7l21.3-64zm363.1 0H552.9l21.3 64H608l-32-96H438.2l7.8 20.8 4.2 11.2zM16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z'
      
    ]
  };

  

  
  

  var faBaby = {
    prefix: 'fasl',
    iconName: 'baby',
    icon: [
      448,
      512,
      [],
      'f77c',
      
      'M224 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM364.6 104.9l10.6 12 53.1 59.8 10.6 12-12 10.6-29.9 26.6-72 64-5.2 4.6v23.2l42 57.2 11.6 15.9 4.7 6.3-2.2 7.6-5.5 18.9-20.8 72-4.4 15.4L330 506.5l-76.9-22.2-15.4-4.4 4.4-15.4 13.2-45.5L235.6 392H212.4l-19.7 26.9 13.2 45.5 4.4 15.4-15.4 4.4L118 506.5l-15.4 4.4-4.4-15.4-20.8-72-5.5-18.9-2.2-7.6 4.7-6.3L86 374.9l42-57.2V294.5l-5.2-4.6-72-64L20.9 199.3l-12-10.6 10.6-12 53.1-59.8 10.6-12 12 10.6 29.9 26.6L181.3 192h85.4l56.1-49.9 29.9-26.6 12-10.6zM86 150.1L54.1 186l17.9 15.9 72 64 6.8 6.1H297.1l6.8-6.1 72-64L393.9 186 362 150.1l-17.9 15.9L283.4 220l-4.5 4h-6.1H175.2h-6.1l-4.5-4-60.6-53.9L86 150.1zM288 304H160v17.4L198.6 360h5.6 39.5 5.6L288 321.4V304zm16.3 46.3l-34.3 34.3 15.9 21.6 4.7 6.3-2.2 7.6L277.4 458l46.1 13.3 16.4-56.6 3.3-11.3-7-9.5-31.9-43.5zM178.1 384.7l-34.3-34.3-31.9 43.5-7 9.5 3.3 11.3 16.4 56.6L170.6 458l-10.9-37.7-2.2-7.6 4.7-6.3 15.9-21.6z'
      
    ]
  };

  

  
  

  var faCirclePhoneFlip = {
    prefix: 'fasl',
    iconName: 'circle-phone-flip',
    icon: [
      512,
      512,
      ["phone-circle-alt"],
      'e11c',
      
      'M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm25.2 122.1l4.9-12.1 12.9 2.3 88 16 13.1 2.4 0 13.4 0 16c0 132.5-107.5 240-240 240H144 130.7l-2.4-13.1-16-88L109.9 286l12.1-4.9 80-32 9.8-3.9 7.5 7.5L238 271.4c13-9.1 24.3-20.4 33.4-33.4l-18.7-18.7-7.5-7.5 3.9-9.8 32-80zM368 160l0-2.6-62-11.3-23.2 58.1 20.3 20.3 8.7 8.7-6.1 10.6c-14.8 25.7-36.2 47.1-61.9 61.9l-10.6 6.1-8.7-8.7-20.3-20.3L146.1 306l11.3 62H160c114.9 0 208-93.1 208-208z'
      
    ]
  };

  
    var faPhoneCircleAlt = faCirclePhoneFlip;
  

  
  

  var faBuildingShield = {
    prefix: 'fasl',
    iconName: 'building-shield',
    icon: [
      576,
      512,
      [],
      'e4d8',
      
      'M32 32H352V219.8L384 207V32 0H352 32 0V32 480v32H32h96 32 64 32 96 8.2c-13.7-9.8-25.6-20.6-36.1-32H256V400 368H224 160 128v32 80H32V32zM301.6 240l18.4-7.4V224H304 240 224v16 64 16h16 16V296.2 296v-8V257.8 256c0-8.8 7.2-16 16-16h29.6zM160 480V400h64v80H160zM64 96v16 64 16H80h64 16V176 112 96H144 80 64zm32 32h32v32H96V128zM240 96H224v16 64 16h16 64 16V176 112 96H304 240zm16 64V128h32v32H256zM64 224v16 64 16H80h64 16V304 240 224H144 80 64zm32 32h32v32H96V256zm447.9 45.6C542.1 367.4 508.8 437 448 470.3V264.5l95.9 37.1zm-223.8 0L416 264.5V470.3c-60.8-33.3-94.1-102.8-95.9-168.6zM432 512c96-32 144-130.2 144-216V279.8L432 224 288 279.8V296c0 85.8 48 184 144 216z'
      
    ]
  };

  

  
  

  var faCartCircleXmark = {
    prefix: 'fasl',
    iconName: 'cart-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e3f4',
      
      'M16 0H0V32H16 67.2l77.2 339.5 2.8 12.5H160 320.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32H151L107.3 64H532.5l-40 128c1.2 0 2.4 0 3.5 0c10 0 19.7 .8 29.2 2.4L566 64l10-32H542.5 100L95.6 12.5 92.8 0H80 16zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7L566.6 320 544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7z'
      
    ]
  };

  

  
  

  var faFaceSmileTongue = {
    prefix: 'fasl',
    iconName: 'face-smile-tongue',
    icon: [
      512,
      512,
      [],
      'e394',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224h32C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c36.4 0 71-7.6 102.4-21.3l-12.8-29.3c-27.4 12-57.7 18.6-89.6 18.6C132.3 480 32 379.7 32 256zm392.6 18.5l-18.4-11.7-5.6 21.1C382.5 351.5 324.1 400 256 400s-126.5-48.5-144.5-116.1l-30.9 8.3C102 372.3 171.9 432 256 432c31 0 60.1-8.1 85.5-22.4l45.3 29.6c36.8 24 86.2 12.2 108.2-25.8l1.4-2.4-13.9-8 13.9 8c21.4-37.1 9.8-84.4-26.3-107.5l-45.5-29zM404.3 412.4l-34.4-22.5C394 369.6 413 343 424.8 312.6l28.1 17.9c21.7 13.8 28.6 42.2 15.8 64.5l-1.4 2.4 13.9 8-13.9-8c-12.8 22.2-41.6 29-63 15zM156.5 194.5c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4l31-7.8c-3.2-12.7-9.8-27.1-19.9-38.6C209.6 161.9 194.8 152 176 152s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6l31 7.8c2.1-8.6 6.7-18.2 12.9-25.4zm147.1 25.4c2.1-8.6 6.7-18.2 12.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4l31-7.8c-3.2-12.7-9.8-27.1-19.9-38.6C369.6 161.9 354.8 152 336 152s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6l31 7.8z'
      
    ]
  };

  

  
  

  var faPesoSign = {
    prefix: 'fasl',
    iconName: 'peso-sign',
    icon: [
      384,
      512,
      [],
      'e222',
      
      'M48 32H32V48v80H0v32H32v64H0v32H32v80V464v16H64V464 352H192c65.6 0 122-39.5 146.7-96H384V224H348.8c2.1-10.3 3.2-21 3.2-32s-1.1-21.7-3.2-32H384V128H338.7C314 71.5 257.6 32 192 32H48zm254.9 96H64V64H192c47.4 0 88.7 25.7 110.9 64zM64 160H316c2.6 10.2 4 21 4 32s-1.4 21.8-4 32H64V160zm238.9 96c-22.1 38.3-63.5 64-110.9 64H64V256H302.9z'
      
    ]
  };

  

  
  

  var faClawMarks = {
    prefix: 'fasl',
    iconName: 'claw-marks',
    icon: [
      576,
      512,
      [],
      'f6c2',
      
      'M160 150.6L36.7 27.3 59.3 4.7l128 128 4.7 4.7V144v48h48 6.6l4.7 4.7 128 128 4.7 4.7V336v48h48 6.6l4.7 4.7 96 96-22.6 22.6L425.4 416H368 352V400 342.6L233.4 224H176 160V208 150.6zm-32 192L36.7 251.3l22.6-22.6 96 96 4.7 4.7V336v48h48 6.6l4.7 4.7 96 96-22.6 22.6L201.4 416H144 128V400 342.6zM260.7 27.3L283.3 4.7l32 32 4.7 4.7V48 96h48 6.6l4.7 4.7 64 64 4.7 4.7V176v48h48 6.6l4.7 4.7 32 32-22.6 22.6L489.4 256H432 416V240 182.6L361.4 128H304 288V112 54.6L260.7 27.3z'
      
    ]
  };

  

  
  

  var faRhombus = {
    prefix: 'fasl',
    iconName: 'rhombus',
    icon: [
      448,
      512,
      [],
      'e23b',
      
      'M202.7 487.7L224 512l21.3-24.3L448 256 245.3 24.3 224 0 202.7 24.3 0 256 202.7 487.7zM224 463.4L42.5 256 224 48.6 405.5 256 224 463.4z'
      
    ]
  };

  

  
  

  var faChalkboardUser = {
    prefix: 'fasl',
    iconName: 'chalkboard-user',
    icon: [
      640,
      512,
      ["chalkboard-teacher"],
      'f51c',
      
      'M608 32H192v68c-10.2-2.6-21-4-32-4V32 0h32H608h32V32 384v32H608 576 560 400 384 324.6L315 384h69V304 288h16H560h16v16 80h32V32zM544 384V320H416v64H544zM224 224A64 64 0 1 0 96 224a64 64 0 1 0 128 0zM64 224a96 96 0 1 1 192 0A96 96 0 1 1 64 224zM43 480H277l-28.8-96H71.8L43 480zm5-128H272l38.4 128 9.6 32H286.6 33.4 0l9.6-32L48 352z'
      
    ]
  };

  
    var faChalkboardTeacher = faChalkboardUser;
  

  
  

  var faArrowsUpDownLeftRight = {
    prefix: 'fasl',
    iconName: 'arrows-up-down-left-right',
    icon: [
      512,
      512,
      ["arrows"],
      'f047',
      
      'M267.3 12.7L256 1.4 244.7 12.7l-72 72L161.4 96 184 118.6l11.3-11.3L240 62.6V240H62.6l44.7-44.7L118.6 184 96 161.4 84.7 172.7l-72 72L1.4 256l11.3 11.3 72 72L96 350.6 118.6 328l-11.3-11.3L62.6 272H240V449.4l-44.7-44.7L184 393.4 161.4 416l11.3 11.3 72 72L256 510.6l11.3-11.3 72-72L350.6 416 328 393.4l-11.3 11.3L272 449.4V272H449.4l-44.7 44.7L393.4 328 416 350.6l11.3-11.3 72-72L510.6 256l-11.3-11.3-72-72L416 161.4 393.4 184l11.3 11.3L449.4 240H272V62.6l44.7 44.7L328 118.6 350.6 96 339.3 84.7l-72-72z'
      
    ]
  };

  
    var faArrows = faArrowsUpDownLeftRight;
  

  
  

  var faFaceSmirking = {
    prefix: 'fasl',
    iconName: 'face-smirking',
    icon: [
      512,
      512,
      [],
      'e397',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm375.8 82.6l-.2 1.2c-5.8 34.7-35.8 60.2-71 60.2H192 176V368h16H304.6c19.6 0 36.2-14.1 39.5-33.4l.2-1.2 2.6-15.8 31.6 5.3-2.6 15.8zM112 192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H112 96V192h16zm176 0h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H304 288V192z'
      
    ]
  };

  

  
  

  var faXmark = {
    prefix: 'fasl',
    iconName: 'xmark',
    icon: [
      384,
      512,
      [215,10005,10006,10060,128473,"close","multiply","remove","times"],
      'f00d',
      
      'M192 233.4L59.5 100.9 36.9 123.5 169.4 256 36.9 388.5l22.6 22.6L192 278.6 324.5 411.1l22.6-22.6L214.6 256 347.1 123.5l-22.6-22.6L192 233.4z'
      
    ]
  };

  
    var faClose = faXmark;
  
    var faMultiply = faXmark;
  
    var faRemove = faXmark;
  
    var faTimes = faXmark;
  

  
  

  var faCloudCheck = {
    prefix: 'fasl',
    iconName: 'cloud-check',
    icon: [
      640,
      512,
      [],
      'e35c',
      
      'M544 241.1V232c0-57.4-46.6-104-104-104c-13.4 0-26.2 2.5-37.9 7.1l-24.3 9.5-14.2-22C340.8 87.3 301.1 64 256 64c-70.7 0-128 57.3-128 128v8.2 22.6l-21.3 7.5C63.1 245.8 32 287.3 32 336V448H144 512h96V352c0-35.5-19.2-66.5-48-83.2l-16-9.2V241.1zM0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c56.4 0 106 29.2 134.5 73.3c15.3-6 32-9.3 49.5-9.3c75.1 0 136 60.9 136 136v9.1c38.3 22.1 64 63.5 64 110.9v96 32H608 512 144 32 0V448 336zM427.3 235.3l-128 128L288 374.6l-11.3-11.3-64-64L201.4 288 224 265.4l11.3 11.3L288 329.4 404.7 212.7 416 201.4 438.6 224l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faFort = {
    prefix: 'fasl',
    iconName: 'fort',
    icon: [
      640,
      512,
      [],
      'e486',
      
      'M128 96h64v32 64H64 32V128 96H96h32zM0 224H32V480v32H64 240h32 96 32H576h32V480 224h32V192 128 96 64 32 0H608V32 64H576 544V32 0H512V32 64H480 448V32 0H416V32 64 96v32 64H224V128 96 64 32 0H192V32 64H160 128V32 0H96V32 64H64 32V32 0H0V32 64 96v32 64 32zM480 480V224h96V480H480zm-32 0H400V400c0-44.2-35.8-80-80-80s-80 35.8-80 80v80H192V224h32H416h32V480zM64 224h96V480H64V224zM368 480H272V400c0-26.5 21.5-48 48-48s48 21.5 48 48v80zM608 128v64H576 448V128 96h64 32 64v32z'
      
    ]
  };

  

  
  

  var faComputer = {
    prefix: 'fasl',
    iconName: 'computer',
    icon: [
      640,
      512,
      [],
      'e4e5',
      
      'M416 64V352H275.5 264 184 172.5 32V64H416zM32 384H161.8l-21.3 64H64v32h65.8H152 296h22.2H384V448H307.5l-21.3-64H416h32V352 64 32H416 32 0V64 352v32H32zm142.2 64l21.3-64h56.9l21.3 64H174.2zM512 64h96v64H512V64zm0 96h96v32H512V160zm0 288V224h96V448H512zM480 32V64 448v32h32 96 32V448 64 32H608 512 480zm80 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faExpand = {
    prefix: 'fasl',
    iconName: 'expand',
    icon: [
      448,
      512,
      [],
      'f065',
      
      'M144 32h16V64H144 32V176v16H0V176 48 32H16 144zM0 336V320H32v16V448H144h16v32H144 16 0V464 336zM432 32h16V48 176v16H416V176 64H304 288V32h16H432zM416 336V320h32v16V464v16H432 304 288V448h16H416V336z'
      
    ]
  };

  

  
  

  var faPlus = {
    prefix: 'fasl',
    iconName: 'plus',
    icon: [
      448,
      512,
      [10133,61543,"add"],
      '2b',
      
      'M240 64V48H208V64 240H32 16v32H32 208V448v16h32V448 272H416h16V240H416 240V64z'
      
    ]
  };

  
    var faAdd = faPlus;
  

  
  

  var faHatBeach = {
    prefix: 'fasl',
    iconName: 'hat-beach',
    icon: [
      640,
      512,
      [],
      'e606',
      
      'M192 224v10.8 3.9c.3 .5 1.1 1.5 2.6 2.9c4.2 4 11.9 9 24.2 13.9C243.1 265.3 278.8 272 320 272c11.5 0 22.6-.5 33.1-1.5c-.7-3.8-1.1-7.7-1.1-11.8c0-12.5 3.8-24.6 10.8-34.7c-.5-.7-1-1.4-1.4-2.2c-13.2 1.4-27.1 2.2-41.4 2.2c-44.2 0-84.2-7.2-113.1-18.7c-4.4-1.8-8.6-3.7-12.5-5.6c-1.5 7.9-2.3 16-2.3 24.4zm160-34.7c0-31.1 23.2-56.8 53.3-60.7C382.6 108.3 352.7 96 320 96c-50.9 0-94.9 29.7-115.5 72.8c3.8 2.2 8.6 4.5 14.2 6.8C243.1 185.3 278.8 192 320 192c11.1 0 21.8-.5 32-1.4c0-.4 0-.9 0-1.3zM320 64c55.7 0 104.7 28.4 133.3 71.5c8.9-4.9 19-7.5 29.4-7.5c33.8 0 61.3 27.4 61.3 61.3c0 12.5-3.8 24.6-10.8 34.7c5.2 7.6 8.7 16.2 10.1 25.3L629.9 284l10.1 4v10.8V320c0 17.7-8.9 34.5-25.1 49.8c-16.2 15.3-39.6 29.1-68.6 40.7C488.4 433.7 408.4 448 320 448s-168.4-14.3-226.3-37.5c-29-11.6-52.4-25.4-68.6-40.7C8.9 354.5 0 337.7 0 320V298.8 288l10.1-4L160 224c0-88.4 71.6-160 160-160zM482.7 320c-12.5 0-24.6-3.8-34.7-10.8c-10.1 7-22.2 10.8-34.7 10.8c-17.5 0-33.2-7.3-44.4-19c-15.4 2-31.8 3-48.9 3c-44.2 0-84.2-7.2-113.1-18.7c-14.5-5.8-26.2-12.7-34.3-20.3c-2.9-2.8-5.4-5.6-7.3-8.6L32 309.7V320c0 6.1 2.9 15 15.1 26.6c12.3 11.6 31.8 23.5 58.5 34.2C158.9 402.1 234.7 416 320 416s161.1-13.9 214.4-35.2c26.7-10.7 46.2-22.6 58.5-34.2C605.1 335 608 326.1 608 320V309.7l-68.7-27.5c-9.2 22.2-31.1 37.8-56.6 37.8zM413.3 160c-16.2 0-29.3 13.1-29.3 29.3c0 7.8 3.1 15.2 8.6 20.7l2.7 2.7L406.6 224l-11.3 11.3-2.7 2.7c-5.5 5.5-8.6 12.9-8.6 20.7c0 16.2 13.1 29.3 29.3 29.3c7.8 0 15.2-3.1 20.7-8.6l2.7-2.7L448 265.4l11.3 11.3 2.7 2.7c5.5 5.5 12.9 8.6 20.7 8.6c16.2 0 29.3-13.1 29.3-29.3c0-7.8-3.1-15.2-8.6-20.7l-2.7-2.7L489.4 224l11.3-11.3 2.7-2.7c5.5-5.5 8.6-12.9 8.6-20.7c0-16.2-13.1-29.3-29.3-29.3c-7.8 0-15.2 3.1-20.7 8.6l-2.7 2.7L448 182.6l-11.3-11.3-2.7-2.7c-5.5-5.5-12.9-8.6-20.7-8.6zM448 248l-24-24 24-24 24 24-24 24z'
      
    ]
  };

  

  
  

  var faSquarePhone = {
    prefix: 'fasl',
    iconName: 'square-phone',
    icon: [
      448,
      512,
      ["phone-square"],
      'f098',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm198.8 90.1l32 80 3.9 9.8-7.5 7.5L208.6 238c9.1 13 20.4 24.3 33.4 33.4l18.7-18.7 7.5-7.5 9.8 3.9 80 32 12.1 4.9-2.3 12.9-16 88L349.3 400H336 320C187.4 400 80 292.5 80 160l0-16 0-13.4 13.1-2.4 88-16 12.9-2.3 4.9 12.1zM112 160c0 114.9 93.1 208 208 208h2.6l11.3-62-58.1-23.2-20.3 20.3-8.7 8.7-10.6-6.1c-25.7-14.8-47.1-36.2-61.9-61.9l-6.1-10.6 8.7-8.7 20.3-20.3L174 146.1l-62 11.3 0 2.6z'
      
    ]
  };

  
    var faPhoneSquare = faSquarePhone;
  

  
  

  var fa2 = {
    prefix: 'fasl',
    iconName: '2',
    icon: [
      320,
      512,
      [],
      '32',
      
      'M70.9 95.8C91.2 75.5 119.2 64 148 64c59.2 0 108 48 108 106.8c0 29.5-12.2 57.7-33.8 77.9L5.1 452.3 0 457.1V480H16 304h16V448H304 56.5L244.1 272.1c28-26.2 43.9-62.9 43.9-101.3C288 93.9 224.5 32 148 32c-37.2 0-73.4 14.8-99.8 41.1L20.7 100.7 9.4 112 32 134.6l11.3-11.3L70.9 95.8z'
      
    ]
  };

  

  
  

  var faGun = {
    prefix: 'fasl',
    iconName: 'gun',
    icon: [
      576,
      512,
      [],
      'e19b',
      
      'M512 48V32H480V48 64H16 0V80 224v16H16 92L40 448l-8 32H65 208l32-128H344h11.3l3.8-10.6L395.3 240H448h6.6l4.7-4.7L486.6 208H560h16V192 80 64H560 512V48zM248 320l20-80h93.3l-28.6 80H248zm-13-80L183 448H73l52-208H235zm41-32H243 100 32V96H480h32 32v80H480h-6.6l-4.7 4.7L441.4 208H276z'
      
    ]
  };

  

  
  

  var faChildCombatant = {
    prefix: 'fasl',
    iconName: 'child-combatant',
    icon: [
      576,
      512,
      ["child-rifle"],
      'e4e0',
      
      'M208 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 112 64zM416 224H384V368h32v32 80h57l-14.7-73.7L457 400l-5.1-25.7-1.3-6.3-1.9-9.7-.6-3.1V352 329v-3.7V302.3 288 160H416v32 32zm116.2 83.9L480 325.3V352l3.2 16h6.4H512h32v32H522.2 512 489.6l6.4 32 9.6 48 6.4 32H479.4 416 384V480 432 400H352V368 224 192h32V160 128h32V96 64 32H400V0h16 16 16V16 32 96v32h32v32 32 63 25 8l32-8V224 192h32v32 56 24l-11.8 3.9zM117 160h9.5 99H235l4.6 8.3 70.5 128 7.7 14-28 15.4-7.7-14-42-76.2V496v16H208V496 384H144V496v16H112V496 235.5L70 311.7l-7.7 14-28-15.4 7.7-14 70.5-128L117 160zm27 192h64V200v-8H144v8V352z'
      
    ]
  };

  
    var faChildRifle = faChildCombatant;
  

  
  

  var faKeynote = {
    prefix: 'fasl',
    iconName: 'keynote',
    icon: [
      512,
      512,
      [],
      'f66c',
      
      'M304 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H224V32h80zM224 0H192V32h-8c-44.2 0-80 35.8-80 80v48H64L0 288v16 48 32H32 480h32V352 304 288L448 160H136V112c0-26.5 21.5-48 48-48h8V96h32 80c26.5 0 48-21.5 48-48s-21.5-48-48-48H224zM32 352V320H480v32H32zm3.8-64l48-96H428.2l48 96H35.8zM128 512h16H256 368h16V480H368 272V416H240v64H144 128v32z'
      
    ]
  };

  

  
  

  var faShareFromSquare = {
    prefix: 'fasl',
    iconName: 'share-from-square',
    icon: [
      576,
      512,
      [61509,"share-square"],
      'f14d',
      
      'M400 240V208H368 302.5c-58.2 0-105.9 45-110.2 102.1C173.4 291.9 160 268.9 160 240c0-70.7 57.3-128 128-128h80 32V80 32h2.7l128 128-128 128H400V240zM256 384s-23.2-19-30.1-48.8c-1.2-5.2-1.9-10.8-1.9-16.6c0-43.4 35.2-78.5 78.5-78.5H336h32v32 16 32h32 16L553.4 182.6 576 160l-22.6-22.6L416 0H400 368V32 48 80H336 288c-88.4 0-160 71.6-160 160c0 56.1 36.7 93.4 70.8 116c29.6 19.6 57.2 28 57.2 28zM16 32H0V48 496v16H16 464h16V496 400 384H448v16 80H32V64h80 16V32H112 16z'
      
    ]
  };

  
    var faShareSquare = faShareFromSquare;
  

  
  

  var faGrip = {
    prefix: 'fasl',
    iconName: 'grip',
    icon: [
      448,
      512,
      ["grip-horizontal"],
      'f58d',
      
      'M416 384l0-64-64 0 0 64 64 0zm32 32l-32 0-64 0-32 0 0-32 0-64 0-32 32 0 64 0 32 0 0 32 0 64 0 32zM416 192l0-64-64 0 0 64 64 0zm32 32l-32 0-64 0-32 0 0-32 0-64 0-32 32 0 64 0 32 0 0 32 0 64 0 32zM192 384l64 0 0-64-64 0 0 64zm64 32l-64 0-32 0 0-32 0-64 0-32 32 0 64 0 32 0 0 32 0 64 0 32-32 0zm0-224l0-64-64 0 0 64 64 0zm32 32l-32 0-64 0-32 0 0-32 0-64 0-32 32 0 64 0 32 0 0 32 0 64 0 32zM32 384l64 0 0-64-64 0 0 64zm64 32l-64 0L0 416l0-32 0-64 0-32 32 0 64 0 32 0 0 32 0 64 0 32-32 0zm0-224l0-64-64 0 0 64 64 0zm32 32l-32 0-64 0L0 224l0-32 0-64L0 96l32 0 64 0 32 0 0 32 0 64 0 32z'
      
    ]
  };

  
    var faGripHorizontal = faGrip;
  

  
  

  var faJackOLantern = {
    prefix: 'fasl',
    iconName: 'jack-o-lantern',
    icon: [
      576,
      512,
      [127875],
      'f30e',
      
      'M275.6 96.4c-13.6 1-26.8 3.5-39.5 7.3l3.1-6.1 34.5-69L288 0l28.6 14.3L352 32v76c-10.2-4-20.9-7.1-32-9.1V51.8l-17.7-8.8L275.6 96.4zM197.5 121c-11.4 6.8-22 14.9-31.5 24.1c-4.6-.8-9.3-1.1-14-1.1c-31.3 0-60.9 17.1-83.3 47.4S32 264.3 32 312s14.3 90.3 36.7 120.6s52 47.4 83.3 47.4c20.7 0 40.6-7.5 58.1-21.2c5.8-4.5 13.9-4.5 19.7 0C247.4 472.5 267.3 480 288 480s40.6-7.5 58.1-21.2c5.8-4.5 13.9-4.5 19.7 0C383.4 472.5 403.3 480 424 480c31.3 0 60.9-17.1 83.3-47.4S544 359.7 544 312s-14.3-90.3-36.7-120.6s-52-47.4-83.3-47.4c-4.7 0-9.4 .4-14 1.1c-9.5-9.2-20.1-17.3-31.5-24.1c14.3-5.8 29.5-9 45.5-9c43.8 0 82.2 24.1 109 60.4s43 85.7 43 139.6s-16.1 103.3-43 139.6S467.8 512 424 512c-24.7 0-47.8-7.7-68-20.9c-20.2 13.3-43.3 20.9-68 20.9s-47.8-7.7-68-20.9c-20.2 13.3-43.3 20.9-68 20.9c-43.8 0-82.2-24.1-109-60.4S0 365.9 0 312s16.1-103.3 43-139.6S108.2 112 152 112c15.9 0 31.2 3.2 45.5 9zM288 160c-26.5 0-50.8 9.2-70 24.6l-20-25c24.6-19.8 56-31.6 90-31.6s65.4 11.8 90 31.6l-20 25c-19.2-15.4-43.5-24.6-70-24.6zm-67.5 54l32 40 10 12.5-25 20-10-12.5L208 249.6 188.5 274l-10 12.5-25-20 10-12.5 32-40L208 198.4 220.5 214zm160 0l32 40 10 12.5-25 20-10-12.5L368 249.6 348.5 274l-10 12.5-25-20 10-12.5 32-40L368 198.4 380.5 214zM104 312l-15.8 2.2L87 306.3l5.6-5.6 16-16 9.8-9.8 11.1 8.3 .1 0 .4 .3c.4 .3 1 .7 1.8 1.3c1.7 1.1 4.3 2.9 7.9 4.9c7 4.2 17.6 9.8 31.3 15.5c27.4 11.4 67.3 22.8 117 22.8s89.5-11.4 117-22.8c13.7-5.7 24.3-11.3 31.3-15.5c3.5-2.1 6.2-3.8 7.9-4.9c.9-.6 1.5-1 1.8-1.3l.4-.3 0 0 0 0 0 0 0 0 0 0 11.1-8.3 9.8 9.8 16 16 5.6 5.6-1.1 7.9L472 312c15.8 2.2 15.8 2.3 15.8 2.3l0 0 0 .1 0 .2-.1 .4c-.1 .3-.1 .8-.2 1.3c-.2 1.1-.5 2.6-1 4.4c-.9 3.7-2.4 8.7-4.7 14.7C477.1 347.3 469 363 455 378.6c-18.4 20.6-46 40.2-87 51.5V432h-7.2c-20.8 5-44.9 8-72.8 8c-88 0-138.6-29.5-167-61.4c-14-15.7-22.1-31.4-26.8-43.3c-2.3-6-3.8-11-4.7-14.7c-.5-1.8-.8-3.3-1-4.4c-.1-.5-.2-1-.2-1.3l-.1-.4 0-.2 0-.1 0 0c0 0 0 0 15.8-2.3zm264 84.7c30.6-10 50.4-25.1 63.1-39.4c11-12.3 17.3-24.6 20.9-33.7c1-2.5 1.8-4.8 2.3-6.7l-.5-.5-1.3 .8c-8.2 4.8-20.1 11.2-35.3 17.5C386.7 347.4 342.6 360 288 360c-5.4 0-10.8-.1-16-.4V368v16H240V368 356.7c-32.8-4.6-60.2-13.2-81.2-21.9c-15.3-6.3-27.2-12.7-35.3-17.5l-1.3-.8-.5 .5c.6 1.9 1.4 4.2 2.3 6.7c3.6 9.1 9.9 21.4 20.9 33.7c7.6 8.5 17.7 17.4 31.1 25.2V368h32v16 12.7c21.1 6.9 47.3 11.3 80 11.3c17.9 0 33.8-1.3 48-3.6V384 368h32v16 12.7z'
      
    ]
  };

  

  
  

  var faUserVneckHair = {
    prefix: 'fasl',
    iconName: 'user-vneck-hair',
    icon: [
      448,
      512,
      [],
      'e462',
      
      'M320 144c0 53-43 96-96 96s-96-43-96-96V128l88 0h8l4.8-6.4 16-21.3 20.1 10 3.4 1.7H272h46.7c.9 5.2 1.3 10.5 1.3 16v16zM224 32c35.5 0 66.6 19.3 83.2 48H275.8L247.2 65.7l-11.9-6-8 10.7L208 96H133.5c13.2-37.3 48.7-64 90.5-64zm0-32C153.3 0 96 57.3 96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128V128C352 57.3 294.7 0 224 0zM199.7 420.8L224 449.2l24.3-28.3L321 336h39.4l44.3 144H43.3L87.6 336H127l72.7 84.8zM384 304H306.3l-61.2 71.4L224 400l-21.1-24.6L141.7 304H64L9.8 480 0 512H33.5h381H448l-9.8-32L384 304z'
      
    ]
  };

  

  
  

  var faPartyBell = {
    prefix: 'fasl',
    iconName: 'party-bell',
    icon: [
      512,
      512,
      [],
      'e31a',
      
      'M67.5 335.3L335.3 67.5C260.3 14 155.5 21 88.2 88.2S14 260.3 67.5 335.3zM65.6 65.6c79.8-79.8 204.8-86.8 292.6-21c8.4 6.3 16.6 13.3 24.2 21L359.8 88.2 88.2 359.8 65.6 382.4c-7.7-7.7-14.7-15.8-21-24.2c-65.8-87.7-58.8-212.8 21-292.6zM480 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM352 456a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM88 480a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM376 161.4l11.3 11.3 8.2 8.3c18 18 41.6 29.3 66.8 32.1l27.4 3 15.9 1.8-3.5 31.8-15.9-1.8-27.4-3c-32.5-3.6-62.8-18.2-85.9-41.3l-8.3-8.3L353.4 184 376 161.4zM195.3 364.7l8.3 8.3c23.1 23.1 37.7 53.4 41.3 85.9l3 27.4 1.8 15.9-31.8 3.5-1.8-15.9-3-27.4c-2.8-25.3-14.1-48.8-32.1-66.8l-8.3-8.2L161.4 376 184 353.4l11.3 11.3zM486.1 510.6l-10.3-12.2-8.5-10c-11.2-13.3-17.2-30.3-16.7-47.7c.6-21-15.6-38.6-36.5-39.8l-30-1.8c-38.2-2.2-67.7-34.4-66.6-72.6c.3-9.5-3-18.8-9.2-26.1l-8.5-10-10.3-12.2 24.4-20.7 10.3 12.2 8.5 10c11.2 13.3 17.2 30.3 16.7 47.7c-.6 21 15.6 38.6 36.5 39.8l30 1.8c38.2 2.2 67.7 34.4 66.6 72.6c-.3 9.5 3 18.8 9.2 26.1l8.5 10 10.3 12.2-24.4 20.7z'
      
    ]
  };

  

  
  

  var faPaintbrushPencil = {
    prefix: 'fasl',
    iconName: 'paintbrush-pencil',
    icon: [
      576,
      512,
      [],
      'e206',
      
      'M182.6 22.6L300.1 140.1l-22.6 22.6-48.8-48.8-82.7 82.7 48.8 48.8-10.8 10.8c-2.6-.1-5.3-.2-7.9-.2c-5.1 0-10.2 .3-15.2 .8L54.6 150.6 32 128l22.6-22.6 82.7-82.7L160 0l22.6 22.6zM413.2 298.5l22.6-22.6L512 352l25.2 126 6.8 34-34-6.8L384 480l-64.8-64.8c.5-5 .8-10.1 .8-15.2c0-2.7-.1-5.4-.2-8.1l10.7-10.7 69.3 69.3 103.4 20.7L482.5 367.8l-69.3-69.3zM77.3 128l46.1 46.1 82.7-82.7L160 45.3 77.3 128zM552.7 68.6l22.6 22.6-22.6 22.6L530 136.5 286.3 380.2c1.1 6.4 1.7 13.1 1.7 19.8c0 61.9-50.1 112-112 112h0H96 64 32 16 0V480H16 32h0H64V448 400c0-61.9 50.1-112 112-112c6.7 0 13.3 .6 19.7 1.7L439.6 45.9l22.6-22.6L484.8 .7l22.6 22.6 45.2 45.3zM274.5 346.7l72.8-72.8L302 228.7l-36.6 36.6 0 0L224.6 306l45.3 45.3 4.6-4.6 0 0zM256 400c0-6.9-.9-13.5-2.5-19.9l-57.7-57.7c-6.3-1.6-13-2.5-19.9-2.5c-44.2 0-80 35.8-80 80v80h80 0c44.2 0 80-35.8 80-80zM369.9 251.3L507.4 113.8l22.6-22.6L484.8 45.9 462.2 68.6 324.7 206l45.3 45.3z'
      
    ]
  };

  

  
  

  var faBarsFilter = {
    prefix: 'fasl',
    iconName: 'bars-filter',
    icon: [
      448,
      512,
      [],
      'e0ad',
      
      'M0 64H448V96H0V64zM64 224H384v32H64V224zM288 384v32H160V384H288z'
      
    ]
  };

  

  
  

  var faHandSparkles = {
    prefix: 'fasl',
    iconName: 'hand-sparkles',
    icon: [
      640,
      512,
      [],
      'e05d',
      
      'M272 0h16 80 16l0 16 0 16h64 16V48 96h0 64 16v16l0 208H512V128H464V240v16H432V240 128h0V112 64H384V80 240v16H352V240 80 64h0l0-16 0-16H304V48 240v16H272V240 64H224V304v6.6l-4.7 4.7L207.6 327l-11.3 11.3L185 327l-48-48-17-17-24 24v19.9l7 7L206.8 416.7c40.5 40.5 95.4 63.3 152.7 63.3H368l0 0c29.6 0 57.1-8.9 80-24.2V480h21.2c-28.6 20.2-63.5 32-101.2 32l0 0h-8.5c-65.8 0-128.9-26.1-175.4-72.6L80.4 335.6 68.7 323.9 64 319.2v-6.6V279.4v-6.6l4.7-4.7 40-40L120 216.8l11.3 11.3 28.3 28.3L192 288.8V48 32h16 64V16 0zM96 80v48h48 16v32H144 96v32 16H64V192 160H16 0V128H16 64V80 64H96V80zM336 304v32h32 16v32H368 336v32 16H304V400 368H272 256V336h16 32V304 288h32v16zm240 64v48h48 16v32H624 576v48 16H544V496 448H496 480V416h16 48V368 352h32v16z'
      
    ]
  };

  

  
  

  var faVolumeXmark = {
    prefix: 'fasl',
    iconName: 'volume-xmark',
    icon: [
      576,
      512,
      ["volume-mute","volume-times"],
      'f6a9',
      
      'M149.3 328.1l-9.1-8.1H128 32V192h96 12.2l9.1-8.1L284.2 64H288V448h-3.8L149.3 328.1zM0 352H32h96L272 480h16 32V448 64 32H288 272L128 160H32 0v32V320v32zm411.3-4.7L480 278.6l68.7 68.7 22.6-22.6L502.6 256l68.7-68.7-22.6-22.6L480 233.4l-68.7-68.7-22.6 22.6L457.4 256l-68.7 68.7 22.6 22.6z'
      
    ]
  };

  
    var faVolumeMute = faVolumeXmark;
  
    var faVolumeTimes = faVolumeXmark;
  

  
  

  var faBurgerGlass = {
    prefix: 'fasl',
    iconName: 'burger-glass',
    icon: [
      640,
      512,
      [],
      'e0ce',
      
      'M47.1 192L69.6 480H256v32H40L2.5 32 0 0H32.1 351.9 384l-2.5 32L370.3 174.7c-13.9 4.9-26.2 10.8-37.2 17.3H47.1zm-2.5-32H339.4l10-128H34.6l10 128zM325.5 285.6c-2.4 2.9-4.2 5.3-5.5 7.1v11.1H608V292.7c-1.3-1.8-3.1-4.2-5.5-7.1c-5.6-6.8-14.3-15.9-26.2-25.1c-4.9-3.8-10.3-7.5-16.3-11.1c-.8 8.1-7.6 14.5-15.9 14.5c-8.8 0-16-7.2-16-16c0-4.6 1.9-8.7 5-11.6c-15.7-6.1-33.9-10.5-54.9-11.9c1.2 2.2 1.9 4.8 1.9 7.5c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.7 .7-5.3 1.9-7.5c-21 1.4-39.2 5.9-54.9 11.9c3.1 2.9 5 7 5 11.6c0 8.8-7.2 16-16 16c-8.3 0-15.1-6.3-15.9-14.5c-6 3.6-11.4 7.4-16.3 11.1c-11.9 9.2-20.6 18.3-26.2 25.1zm312.2-6l2.3 3.8v4.4 32 16H624 304 288v-16-32-4.4l2.3-3.8 13.7 8.2c-13.7-8.2-13.7-8.2-13.7-8.2l0 0 0 0 .1-.1 .2-.3c.1-.2 .3-.5 .6-.9c.5-.7 1.2-1.8 2-3c1.8-2.5 4.3-6 7.8-10.1c6.9-8.2 17.2-19.1 31.3-29.9c28.3-21.8 71.6-43.3 131.8-43.3s103.5 21.6 131.8 43.3c14.1 10.8 24.4 21.7 31.3 29.9c3.4 4.1 6 7.6 7.8 10.1c.9 1.3 1.6 2.3 2 3c.2 .4 .4 .7 .6 .9l.2 .3 .1 .1 0 0 0 0s0 0-13.7 8.2l13.7-8.2zM288 359.8h16H624h16v32H624 304 288v-32zm0 56h16H624h16v16 64 16H624 304 288v-16-64-16zm32 32v32H608v-32H320z'
      
    ]
  };

  

  
  

  var faCopy = {
    prefix: 'fasl',
    iconName: 'copy',
    icon: [
      448,
      512,
      [],
      'f0c5',
      
      'M416 352H192V32H338.7L416 109.3V352zM448 96L352 0H192 160V32 352v32h32H416h32V352 96zM32 128H0v32V480v32H32 256h32V480 416H256v64H32V160h96V128H32z'
      
    ]
  };

  

  
  

  var faSnowmanHead = {
    prefix: 'fasl',
    iconName: 'snowman-head',
    icon: [
      448,
      512,
      ["frosty-head"],
      'f79b',
      
      'M352 32V160h32V32 0H352 96 64V32 160H96V32H352zm.7 192c29.3 31.4 47.3 73.6 47.3 120c0 54.8-25 103.7-64.3 136H112.3C73 447.7 48 398.8 48 344c0-46.4 17.9-88.6 47.3-120H96 352h.7zm41.2 0H432h16V192H432 384 352 96 64 16 0v32H16 54.1C30.1 257.9 16 299.3 16 344c0 69 33.6 130.2 85.3 168H346.7c51.7-37.8 85.3-99 85.3-168c0-44.7-14.1-86.1-38.1-120zM168 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM176 367.6c0 8.3 2.2 16.4 6.3 23.6l27.8 48.7L224 464.2l13.9-24.3 27.8-48.7c4.1-7.2 6.3-15.3 6.3-23.6c0-26.3-21.3-47.6-47.6-47.6h-.8c-26.3 0-47.6 21.3-47.6 47.6zM223.6 352h.8c8.6 0 15.6 7 15.6 15.6c0 2.7-.7 5.4-2.1 7.7L224 399.8l-13.9-24.4c-1.3-2.4-2.1-5-2.1-7.7c0-8.6 7-15.6 15.6-15.6z'
      
    ]
  };

  
    var faFrostyHead = faSnowmanHead;
  

  
  

  var faSidebar = {
    prefix: 'fasl',
    iconName: 'sidebar',
    icon: [
      512,
      512,
      [],
      'e24e',
      
      'M480 64V448H224V64H480zM32 64H192V448H32V64zm0-32H0V64 448v32H32 480h32V448 64 32H480 32zM160 96H64v32h96V96zM64 160v32h96V160H64zm96 64H64v32h96V224z'
      
    ]
  };

  

  
  

  var faChartPyramid = {
    prefix: 'fasl',
    iconName: 'chart-pyramid',
    icon: [
      512,
      512,
      [],
      'e0e6',
      
      'M18.3 448L0 480H36.9 475.1 512l-18.3-32L274.4 64.2 256 32 237.6 64.2 18.3 448zM310.6 192H201.4L256 96.5 310.6 192zm18.3 32l54.9 96H128.3l54.9-96H328.9zM402 352l54.9 96H55.1L110 352H402z'
      
    ]
  };

  

  
  

  var faPedestal = {
    prefix: 'fasl',
    iconName: 'pedestal',
    icon: [
      448,
      512,
      [],
      'e20d',
      
      'M384 32H64V448H32V32 0H64 384h32V32 448H384V32zM16 480H432h16v32H432 16 0V480H16zM112 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM320 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faDiagramProject = {
    prefix: 'fasl',
    iconName: 'diagram-project',
    icon: [
      576,
      512,
      ["project-diagram"],
      'f542',
      
      'M160 64v48 32 48H32V64H160zm32 128V144H384v48 32h32H544h32V192 64 32H544 416 384V64v48H192V64 32H160 32 0V64 192v32H32 160h7.4L224 308.8V320 448v32h32H384h32V448 320 288H384 256h-7.4L192 203.2V192zm224 0V144 112 64H544V192H416zM384 320V448H256V320H384z'
      
    ]
  };

  
    var faProjectDiagram = faDiagramProject;
  

  
  

  var faJetFighterUp = {
    prefix: 'fasl',
    iconName: 'jet-fighter-up',
    icon: [
      512,
      512,
      [],
      'e518',
      
      'M248 0H237.5l-4.2 9.6-56 128-1.3 3.1V144v66.1l-.4 .3L32 299.3V272 256H0v16 56 40 32 16H32V400 384H176v2.9l-45.1 63.9-2.9 4.1V460v36 16h16H368h16V496 460v-5.1l-2.9-4.1L336 386.9V384H480v16 16h32V400 368 328 272 256H480v16 27.3L336.4 210.4l-.4-.3V144v-3.3l-1.3-3.1-56-128L274.5 0H264 248zM32 336.9l144-89.1V352H32V336.9zm304-89.1l144 89.1V352H336V247.8zM208 147.3L256 37.6l48 109.7V392v5.1l2.9 4.1L352 465.1V480H272V432 416H240v16 48H160V465.1l45.1-63.9 2.9-4.1V392 147.3z'
      
    ]
  };

  

  
  

  var faAwardSimple = {
    prefix: 'fasl',
    iconName: 'award-simple',
    icon: [
      384,
      512,
      [],
      'e0ab',
      
      'M236.2 26.9L192 0 147.8 26.9 96 25.7 71.2 71.2 25.7 96l1.2 51.8L0 192l26.9 44.2L25.7 288l45.4 24.8L96 358.3l51.8-1.2L192 384l44.2-26.9 51.8 1.2 24.8-45.4L358.3 288l-1.2-51.8L384 192l-26.9-44.2L358.3 96 312.8 71.2 288 25.7l-51.8 1.2zm33 31.2l15.5 28.3 4.5 8.2 8.2 4.5 28.3 15.5-.8 32.3-.2 9.4 4.9 8L346.5 192l-16.8 27.6-4.9 8 .2 9.4 .8 32.3-28.3 15.5-8.2 4.5-4.5 8.2-15.5 28.3-32.3-.8-9.4-.2-8 4.9L192 346.5l-27.6-16.8-8-4.9-9.4 .2-32.3 .8L99.3 297.5l-4.5-8.2-8.2-4.5L58.2 269.3l.8-32.3 .2-9.4-4.9-8L37.5 192l16.8-27.6 4.9-8-.2-9.4-.8-32.3L86.5 99.3l8.2-4.5 4.5-8.2 15.5-28.3 32.3 .8 9.4 .2 8-4.9L192 37.5l27.6 16.8 8 4.9 9.4-.2 32.3-.8zM192 248a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm-88-56a88 88 0 1 0 176 0 88 88 0 1 0 -176 0zM92.1 390.4L72.6 474.6 64 512l36-13.5L192 464l92 34.5L320 512l-8.6-37.4-19.4-84.2-4.7-.1-28.3-.7 16.5 71.5L203.2 434 192 429.8 180.8 434l-72.2 27.1 16.5-71.5-28.3 .7-4.7 .1z'
      
    ]
  };

  

  
  

  var faCircleP = {
    prefix: 'fasl',
    iconName: 'circle-p',
    icon: [
      512,
      512,
      [],
      'e11a',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128H160v16V288v80 16h32V368 304h72c48.6 0 88-39.4 88-88s-39.4-88-88-88H176zm88 144H192V160h72c30.9 0 56 25.1 56 56s-25.1 56-56 56z'
      
    ]
  };

  

  
  

  var faBaseball = {
    prefix: 'fasl',
    iconName: 'baseball',
    icon: [
      512,
      512,
      [9918,129358,"baseball-ball"],
      'f433',
      
      'M256.6 480c-.4-5.3-.6-10.6-.6-16c0-5.8 .2-11.6 .7-17.3l31.9 2.6c-.4 4.8-.6 9.7-.6 14.7c0 4.6 .2 9.1 .5 13.7c97.7-14.2 174.9-91.5 189.1-189.1c-4.5-.3-9.1-.5-13.7-.5c-4.9 0-9.8 .2-14.7 .6l-2.6-31.9c5.7-.5 11.5-.7 17.3-.7c5.4 0 10.7 .2 16 .6c0-.2 0-.4 0-.6C480 132.3 379.7 32 256 32c-.2 0-.4 0-.6 0c.4 5.3 .6 10.6 .6 16c0 5.8-.2 11.6-.7 17.3l-31.9-2.6c.4-4.8 .6-9.7 .6-14.7c0-4.6-.2-9.1-.5-13.7C125.8 48.6 48.6 125.8 34.3 223.5c4.5 .3 9.1 .5 13.7 .5c4.9 0 9.8-.2 14.7-.6l2.6 31.9c-5.7 .5-11.5 .7-17.3 .7c-5.4 0-10.7-.2-16-.6c0 .2 0 .4 0 .6c0 123.7 100.3 224 224 224c.2 0 .4 0 .6 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 121.3l29.1 13.3c-20.8 45.2-57.2 81.7-102.5 102.5L121.3 208c38.3-17.6 69.2-48.5 86.7-86.7zM304 390.7l-29.1-13.4c20.8-45.2 57.2-81.7 102.5-102.5L390.7 304c-38.3 17.6-69.2 48.5-86.7 86.7z'
      
    ]
  };

  
    var faBaseballBall = faBaseball;
  

  
  

  var faGlobeStand = {
    prefix: 'fasl',
    iconName: 'globe-stand',
    icon: [
      448,
      512,
      [],
      'f5f6',
      
      'M28.7 348.7L17.4 360 40 382.6l11.3-11.3 10-10C99 394.1 145.1 412.1 192 415.4V480H64v32H352V480H224V415.4c51.9-3.7 102.7-25.4 142.4-65c83.7-83.7 87.3-217.1 10.9-305.1l10-10L398.6 24 376 1.4 364.7 12.7 343.8 33.6 332.4 44.9l11.3 11.3c75 75 75 196.5 0 271.5s-196.5 75-271.5 0L60.9 316.5 49.6 327.8 28.7 348.7zM80 192a128 128 0 1 1 256 0A128 128 0 1 1 80 192zm288 0A160 160 0 1 0 48 192a160 160 0 1 0 320 0z'
      
    ]
  };

  

  
  

  var faFaceTongueSweat = {
    prefix: 'fasl',
    iconName: 'face-tongue-sweat',
    icon: [
      576,
      512,
      [],
      'e39e',
      
      'M288 32C174.4 32 80.6 116.5 66 226.1l-31.7-4.2C50.9 96.6 158.2 0 288 0C429.4 0 544 114.6 544 256s-114.6 256-256 256c-57.6 0-110.8-19.1-153.6-51.2l19.2-25.6c15.6 11.8 32.9 21.5 51.3 28.9C196.7 449.9 192 433.5 192 416v-7.3c-10.2-7.2-16-15.7-16-24.7c0-26.5 50.1-48 112-48s112 21.5 112 48c0 9-5.8 17.5-16 24.7V416c0 17.5-4.7 33.9-12.9 48.1C453.7 431.1 512 350.3 512 256C512 132.3 411.7 32 288 32zM222.6 160l-11.3 11.3-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L200 137.4 222.6 160zm142.1 11.3L353.4 160 376 137.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM64 320.2l-24 27c-5.2 5.8-8 13.3-8 21.1C32 385.6 46.3 400 64 400s32-14.4 32-31.8c0-7.8-2.9-15.3-8-21.1l-24-27zM42.6 296.1L64 272l21.4 24.1 26.5 29.8c10.4 11.7 16.1 26.7 16.1 42.4c0 35.2-28.8 63.8-64 63.8s-64-28.5-64-63.8c0-15.6 5.7-30.7 16.1-42.4l26.5-29.8zm325-48.1a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-136 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM352 416V376H304v24H272V376H224v40c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  

  
  

  var faCircleRadiation = {
    prefix: 'fasl',
    iconName: 'circle-radiation',
    icon: [
      512,
      512,
      [9762,"radiation-alt"],
      'f7ba',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM189.8 109.4l-8-13.9-13.9 8C115.4 134 80 190.8 80 256v16H96 202.3c-1.5-5.1-2.3-10.4-2.3-16s.8-10.9 2.3-16H112.9c4.5-40.9 26.2-76.7 57.7-99.9l44.7 77.5c7.4-7.8 16.9-13.5 27.7-16l-53.2-92.1zM269 201.5c10.8 2.6 20.3 8.2 27.7 16l44.7-77.5c31.5 23.3 53.2 59 57.7 99.9H309.7c1.5 5.1 2.3 10.4 2.3 16s-.8 10.9-2.3 16H416h16V256c0-65.2-35.4-122-88-152.4l-13.9-8-8 13.9L269 201.5zm27.7 93c-7.4 7.8-16.9 13.5-27.7 16L313.7 388c-17.7 7.7-37.2 12-57.7 12s-40.1-4.3-57.7-12L243 310.5c-10.8-2.6-20.3-8.2-27.7-16l-53.2 92.1-8 13.8 13.8 8c25.9 15 56 23.6 88 23.6s62.1-8.6 88-23.6l13.8-8-8-13.8-53.2-92.1zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  
    var faRadiationAlt = faCircleRadiation;
  

  
  

  var faMusicNoteSlash = {
    prefix: 'fasl',
    iconName: 'music-note-slash',
    icon: [
      640,
      512,
      ["music-alt-slash"],
      'f8d0',
      
      'M512 160V33 0L480 8 320 48v80 46.5l32.3 25.5L512 160zM320 337.5V376c-20.3-14.8-48.7-24-80-24c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80V362.8l-32-25.3zM352 128V73L480 41v94L352 167V128zM300.6 401.5C314.9 411.7 320 422.9 320 432s-5.1 20.3-19.4 30.5C286.4 472.7 265 480 240 480s-46.3-7.3-60.6-17.5C165.1 452.3 160 441.1 160 432s5.1-20.3 19.4-30.5C193.7 391.3 215 384 240 384s46.3 7.3 60.6 17.5zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  
    var faMusicAltSlash = faMusicNoteSlash;
  

  
  

  var faMango = {
    prefix: 'fasl',
    iconName: 'mango',
    icon: [
      512,
      512,
      [],
      'e30f',
      
      'M352 130.4V87.6c17 15.2 39.4 24.4 64 24.4h80 16V96c0-53-43-96-96-96H352 336 320V16 128c-48.7 .2-97.4 17.5-134.6 51.9c-45.7 34.4-67.6 72.9-88.1 108.8c-19 33.2-36.7 64.3-70.8 88L0 393.8l1.8 59.1 43.7 19.2s99.8 39.9 243.3 39.9C454.7 512 512 375.9 512 305.2c0-45.4-18.7-90.7-56-125.3c-16.6-15.4-35.5-27.4-55.7-35.9H384v27.9c18.3 7.2 35.4 17.7 50.2 31.5C465.1 232 480 268.8 480 305.2c0 28.2-11.9 72.7-42.1 109.6c-29.2 35.7-76 65.1-149.1 65.1c-68.8 0-127.2-9.6-168.2-19.1c-20.5-4.8-36.6-9.5-47.4-13c-5.4-1.7-9.5-3.2-12.2-4.2c-1.3-.5-2.3-.9-2.9-1.1l-.3-.1L33.2 431.7l-.6-20.8 11.3-7.3 .4-.3 .4-.3c40.2-28 61.2-64.8 79.7-97.2l3-5.3c19.5-34.2 38.9-66.1 77.3-95.1l1.3-1 1.2-1.1c31.1-28.8 71.9-43.2 112.9-43.4v16 16h32V176 162.8 144 130.4zM320 432c61.9 0 112-50.1 112-112H400c0 44.2-35.8 80-80 80v32zM416 80c-29.8 0-54.9-20.4-62-48h62c29.8 0 54.9 20.4 62 48H416z'
      
    ]
  };

  

  
  

  var faLinkHorizontal = {
    prefix: 'fasl',
    iconName: 'link-horizontal',
    icon: [
      640,
      512,
      ["chain-horizontal"],
      'e1cb',
      
      'M128 64C57.3 64 0 121.3 0 192s57.3 128 128 128h32V288H128c-53 0-96-43-96-96s43-96 96-96H304.1c52.9 0 95.9 42.9 95.9 95.9c0 50.3-38.9 92-89 95.6l-8.1 .6 2.3 31.9 8.1-.6C380.2 314.6 432 258.9 432 191.9C432 121.2 374.8 64 304.1 64H128zM512 448c70.7 0 128-57.3 128-128s-57.3-128-128-128H480v32h32c53 0 96 43 96 96s-43 96-96 96H335.9c-52.9 0-95.9-42.9-95.9-95.9c0-50.3 38.9-92 89-95.6l8.1-.6L334.9 192l-8.1 .6C259.8 197.4 208 253.1 208 320.1C208 390.8 265.2 448 335.9 448H512z'
      
    ]
  };

  
    var faChainHorizontal = faLinkHorizontal;
  

  
  

  var faPhoneIntercom = {
    prefix: 'fasl',
    iconName: 'phone-intercom',
    icon: [
      512,
      512,
      [],
      'e434',
      
      'M96 64V448H32V64H96zM32 32H0V64 448v32H32 96h32V448 64 32H96 32zM480 64V448H192V64H480zM192 32H160V64 448v32h32H480h32V448 64 32H480 192zm64 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm32-48v32h16 64 16V304H432 368 352zm0 64v32h16 64 16V368H432 368 352zM256 128H416v96H256V128zM224 96v32 96 32h32H416h32V224 128 96H416 256 224z'
      
    ]
  };

  

  
  

  var faSquareChevronLeft = {
    prefix: 'fasl',
    iconName: 'square-chevron-left',
    icon: [
      448,
      512,
      ["chevron-square-left"],
      'f32a',
      
      'M32 448l384 0 0-384L32 64l0 384zM0 480l0-32L0 64 0 32l32 0 384 0 32 0 0 32 0 384 0 32-32 0L32 480 0 480zM132.7 244.7l112-112L256 121.4 278.6 144l-11.3 11.3L166.6 256 267.3 356.7 278.6 368 256 390.6l-11.3-11.3-112-112L121.4 256l11.3-11.3z'
      
    ]
  };

  
    var faChevronSquareLeft = faSquareChevronLeft;
  

  
  

  var faClapperboard = {
    prefix: 'fasl',
    iconName: 'clapperboard',
    icon: [
      512,
      512,
      [],
      'e131',
      
      'M32 192H480V448H32V192zm350.6-32l96-96H480v96H382.6zm-45.3 0H230.6l96-96H433.4l-96 96zm-56-96l-96 96H78.6l96-96H281.4zm-152 0l-96 96H32V64h97.4zM512 176V160 64 32H480 32 0V64v96 16 16V448v32H32 480h32V448 192 176z'
      
    ]
  };

  

  
  

  var faDiamondHalfStroke = {
    prefix: 'fasl',
    iconName: 'diamond-half-stroke',
    icon: [
      512,
      512,
      [],
      'e5b8',
      
      'M22.6 278.6L0 256l22.6-22.6L233.4 22.6 240 16 256 0l16 16 6.6 6.6L489.4 233.4 512 256l-22.6 22.6L278.6 489.4 272 496l-16 16-16-16-6.6-6.6L22.6 278.6zM272 450.7L466.7 256 272 61.3V450.7zM240 61.3L45.3 256 240 450.7V61.3z'
      
    ]
  };

  

  
  

  var faSquareArrowDown = {
    prefix: 'fasl',
    iconName: 'square-arrow-down',
    icon: [
      448,
      512,
      ["arrow-square-down"],
      'f339',
      
      'M32 448V64H416V448H32zM0 480H32 416h32V448 64 32H416 32 0V64 448v32zM235.3 379.3l96-96L342.6 272 320 249.4l-11.3 11.3L240 329.4V144 128H208v16V329.4l-68.7-68.7L128 249.4 105.4 272l11.3 11.3 96 96L224 390.6l11.3-11.3z'
      
    ]
  };

  
    var faArrowSquareDown = faSquareArrowDown;
  

  
  

  var faArrowRightLongToLine = {
    prefix: 'fasl',
    iconName: 'arrow-right-long-to-line',
    icon: [
      640,
      512,
      [],
      'e3d5',
      
      'M640 80V432v16H608V432 80 64h32V80zM512 256l-11.3 11.3-144 144-11.3 11.3L322.7 400l11.3-11.3L450.7 272 16 272H0l0-32H16l434.7 0L334.1 123.3 322.7 112l22.6-22.6 11.3 11.3 144 144L512 256z'
      
    ]
  };

  

  
  

  var faCircleHalfStroke = {
    prefix: 'fasl',
    iconName: 'circle-half-stroke',
    icon: [
      512,
      512,
      [9680,"adjust"],
      'f042',
      
      'M240 479.4V32.6C123.8 40.8 32 137.7 32 256s91.8 215.2 208 223.4zM480 256c0-118.3-91.8-215.2-208-223.4V479.4C388.2 471.2 480 374.3 480 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faAdjust = faCircleHalfStroke;
  

  
  

  var faStarfighter = {
    prefix: 'fasl',
    iconName: 'starfighter',
    icon: [
      640,
      512,
      [],
      'e037',
      
      'M273.8 0l-1.7 14.1-32 264-.1 1v1V464v16h16H384h16V464 280v-1l-.1-1-32-264L366.2 0H352 288 273.8zm28.4 32h35.6L368 281V448H272V281L302.2 32zM64 96V80H32V96v32H16 0v32H16 32V448v16H64V448 428.7l64 26.7V464v16h16 48v16 16h32V496 464 448H208 160V288h48 16V256H208 144 128v16 48H64V160H80 96V128H80 64V96zm0 298V352h64v68.7L64 394zM608 96V80H576V96v32H560 544v32h16 16V320H512V272 256H496 432 416v32h16 48V448H432 416v16 32 16h32V496 480h48 16V464v-8.7l64-26.7V448v16h32V448 160h16 16V128H624 608V96zM512 352h64v42l-64 26.7V352zM320 224c-8.8 0-16 7.2-16 16v80h32V240c0-8.8-7.2-16-16-16z'
      
    ]
  };

  

  
  

  var faUserGraduate = {
    prefix: 'fasl',
    iconName: 'user-graduate',
    icon: [
      448,
      512,
      [],
      'f501',
      
      'M60.5 80L224 33.3 387.5 80 224 126.7 60.5 80zM224 160L448 96V64L224 0 0 64V96l32 9.1V174L8.5 268.1 3.5 288H24 80h22.2l-7-21.1L64 173.4V114.3L224 160zM200.7 445.9L224 470.7l23.3-24.8L335.7 352h25.2l42.7 128H44.4L87.1 352h25.2l88.4 93.9zM384 320H321.9L246 400.7 224 424l-22-23.3L126.1 320H64L10.7 480 0 512H33.7 414.3 448l-10.7-32L384 320zM50.2 233.2L57.8 256H44.5l5.7-22.8zM96 156.7V176c0 70.7 57.3 128 128 128s128-57.3 128-128V156.7l-32 9.1V176c0 53-43 96-96 96s-96-43-96-96V165.9l-32-9.1z'
      
    ]
  };

  

  
  

  var faObjectUnion = {
    prefix: 'fasl',
    iconName: 'object-union',
    icon: [
      512,
      512,
      [],
      'e49f',
      
      'M128 352h32v32 96 32h32H480h32V480 192 160H480 384 352V128 32 0H320 32 0V32 320v32H32h96zM32 320V32H320V160v32h32H480V480H192V352 320H160 32z'
      
    ]
  };

  

  
  

  var faCartShoppingFast = {
    prefix: 'fasl',
    iconName: 'cart-shopping-fast',
    icon: [
      640,
      512,
      [],
      'e0dc',
      
      'M64 0H80h64 12.8l2.8 12.5L164 32H606.5 640L630 64 560 288H222.2l14.5 64H560h16v32H560 224 211.2l-2.8-12.5L131.2 32H80 64V0zM536.5 256l60-192H171.3L215 256H536.5zM272 456a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm328 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM16 128h96 16v32H112 16 0V128H16zm0 64H128h16v32H128 16 0V192H16zm0 64H144h16v32H144 16 0V256H16z'
      
    ]
  };

  

  
  

  var faHexagonExclamation = {
    prefix: 'fasl',
    iconName: 'hexagon-exclamation',
    icon: [
      512,
      512,
      [],
      'e417',
      
      'M36.9 256L146.6 64H365.4L475.1 256 365.4 448H146.6L36.9 256zM128 32L0 256 128 480H384L512 256 384 32H128zm144 96H240v16V272v16h32V272 144 128zM232 320v48h48V320H232z'
      
    ]
  };

  

  
  

  var faMusicNote = {
    prefix: 'fasl',
    iconName: 'music-note',
    icon: [
      384,
      512,
      ["music-alt"],
      'f8cf',
      
      'M224 128v39l128-32V41L224 73v55zm-32 0V48L352 8l32-8V33 160L224 200V432c0 44.2-50.1 80-112 80S0 476.2 0 432s50.1-80 112-80c31.3 0 59.7 9.2 80 24V208 175 128zM172.6 401.5C158.3 391.3 137 384 112 384s-46.3 7.3-60.6 17.5C37.1 411.7 32 422.9 32 432s5.1 20.3 19.4 30.5C65.7 472.7 87 480 112 480s46.3-7.3 60.6-17.5C186.9 452.3 192 441.1 192 432s-5.1-20.3-19.4-30.5z'
      
    ]
  };

  
    var faMusicAlt = faMusicNote;
  

  
  

  var faWaffle = {
    prefix: 'fasl',
    iconName: 'waffle',
    icon: [
      512,
      512,
      [129479],
      'e466',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 80v64h64V112 96h32v16 32h32 16v32H400 368v64h64 16v32H432 368v64h32 16v32H400 368v32 16H336V400 368H272v64 16H240V432 368H176v32 16H144V400 368H112 96V336h16 32V272H80 64V240H80h64V176H112 96V144h16 32V112 96h32v16 32l64 0V80 64h32V80zm-96 96v64h64V176l-64 0zm0 96v64h64V272H176zm96 0v64h64V272H272zm0-32h64V176H272v64z'
      
    ]
  };

  

  
  

  var faCloudFog = {
    prefix: 'fasl',
    iconName: 'cloud-fog',
    icon: [
      640,
      512,
      [127787,"fog"],
      'f74e',
      
      'M448 128v32h32c35.3 0 64 28.7 64 64v64H480 160 96V224c0-27.8 17.8-51.6 42.7-60.4l21.3-7.5V133.5 112c0-44.2 35.8-80 80-80c27 0 50.9 13.4 65.5 34l17.8 25.2 25.9-16.9c10-6.5 22-10.3 34.9-10.3c35.3 0 64 28.7 64 64zM64 320H96h64H480h64 32V288 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C311.3 18.8 277.9 0 240 0C178.1 0 128 50.1 128 112v21.5C90.7 146.6 64 182.2 64 224v64 32zM0 384v32H16 560h16V384H560 16 0zm64 96v32H80 208h16V480H208 80 64zm224 0v32h16H624h16V480H624 304 288z'
      
    ]
  };

  
    var faFog = faCloudFog;
  

  
  

  var faFish = {
    prefix: 'fasl',
    iconName: 'fish',
    icon: [
      576,
      512,
      [128031],
      'f578',
      
      'M137.8 204.8l21.2 8.5L174 196c37-42.9 91.1-84 162-84c67.4 0 119.4 36.9 156.3 77.5c18.3 20.1 32.1 40.3 41.3 55.6c2.5 4 4.6 7.7 6.3 10.9c-1.8 3.2-3.9 6.9-6.3 10.9c-9.2 15.2-23 35.5-41.3 55.6C455.4 363.1 403.4 400 336 400c-71 0-125-41.1-162-84L159 298.7l-21.2 8.5L39.7 346.5l-.8-.8 37.7-75.4L83.8 256l-7.2-14.3L38.9 166.3l.8-.8 98.1 39.3zM336 432c160 0 240-176 240-176s-80-176-240-176c-84.3 0-146.4 48.9-186.3 95.1L32 128 0 160l48 96L0 352l32 32 117.7-47.1C189.6 383.1 251.7 432 336 432zm80-152a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faCircleStar = {
    prefix: 'fasl',
    iconName: 'circle-star',
    icon: [
      512,
      512,
      ["star-circle"],
      'e123',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm18.1-381.7L256 96l-18.1 34.3-30.8 58.4L142 199.9l-38.2 6.6 27 27.8 46 47.4-9.4 65.4L162 385.4l34.8-17.1L256 339.2l59.3 29.1L350 385.4l-5.5-38.4-9.4-65.4 46-47.4 27-27.8L370 199.9l-65.1-11.3-30.8-58.4zm25.4 89.9l43.5 7.5-30.8 31.7-11 11.3 2.2 15.6 6.3 43.7-39.6-19.5L256 303.5l-14.1 6.9L202.3 330l6.3-43.7 2.2-15.6-11-11.3L169 227.7l43.5-7.5 15.5-2.7 7.3-13.9 20.6-39 20.6 39 7.3 13.9 15.5 2.7z'
      
    ]
  };

  
    var faStarCircle = faCircleStar;
  

  
  

  var faCircle1 = {
    prefix: 'fasl',
    iconName: 'circle-1',
    icon: [
      512,
      512,
      [],
      'e0ee',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM196.9 197.3L240 168.6V352H192 176v32h16 64 64 16V352H320 272V144 128H256h-8-4.8l-4 2.7L184 167.4v38.5l12.9-8.6z'
      
    ]
  };

  

  
  

  var faCommentHeart = {
    prefix: 'fasl',
    iconName: 'comment-heart',
    icon: [
      512,
      512,
      [],
      'e5c8',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM248.3 177.2c-11.5-11-26.8-17.2-42.7-17.2h-2.4c-32.7 0-59.2 26.5-59.2 59.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L256 352.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2h-2.4c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4zm79.3 61.6L256 307.7l-71.7-68.9c-5.3-5.1-8.3-12.2-8.3-19.6c0-15 12.2-27.2 27.2-27.2h2.4c7.7 0 15 3 20.5 8.3l7.7 7.4L256 229l22.2-21.3 7.7-7.4c5.5-5.3 12.9-8.3 20.5-8.3h2.4c15 0 27.2 12.2 27.2 27.2c0 7.4-3 14.5-8.3 19.6z'
      
    ]
  };

  

  
  

  var faStarSharp = {
    prefix: 'fasl',
    iconName: 'star-sharp',
    icon: [
      576,
      512,
      [],
      'e28b',
      
      'M351.6 195.6L304.9 51.8 288.1 0 271.2 51.8 224.5 195.6H73.3 18.9l44 32 122.3 88.9L138.5 460.2 121.7 512l44-32 122.3-88.9L410.4 480l44 32-16.8-51.8L390.9 316.4l122.3-88.9 44-32H502.8 351.6zm107.1 32l-86.7 63-18.8 13.7 7.2 22.1 33.1 101.9-86.7-63-18.8-13.7-18.8 13.7-86.7 63 33.1-101.9 7.2-22.1L204 290.5l-86.7-63H224.5h23.2l7.2-22.1 33.1-101.9 33.1 101.9 7.2 22.1h23.3H458.7z'
      
    ]
  };

  

  
  

  var faUserMagnifyingGlass = {
    prefix: 'fasl',
    iconName: 'user-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e5c5',
      
      'M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM87.6 336H288.8c-.5-5.3-.8-10.6-.8-16s.3-10.7 .8-16H64L9.8 480 0 512H33.5h381H448l-9.8-32H404.7 192 43.3L87.6 336zM448 224.1a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224c29.6 0 56.8-10 78.5-26.9L604.7 499l11.3 11.3 22.6-22.7-11.3-11.3-78.1-77.7C566 376.9 576 349.7 576 320.2c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z'
      
    ]
  };

  

  
  

  var faTruckFast = {
    prefix: 'fasl',
    iconName: 'truck-fast',
    icon: [
      640,
      512,
      ["shipping-fast"],
      'f48b',
      
      'M96 32H384V384H250.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4V288H64v96 32c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h48 16V384H624 608V224v-5.9l-3.9-4.5-96-112L503.4 96H496 416V32 0H384 96 64V32 96H16 0v32H16 240h16V96H240 96V32zM416 224V128h72.6l82.3 96H416zm0 32H576V384h-5.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4V256zM96 416a64 64 0 1 1 128 0A64 64 0 1 1 96 416zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM48 160H32v32H48 272h16V160H272 48zM16 224H0v32H16 240h16V224H240 16z'
      
    ]
  };

  
    var faShippingFast = faTruckFast;
  

  
  

  var faLacrosseStickBall = {
    prefix: 'fasl',
    iconName: 'lacrosse-stick-ball',
    icon: [
      576,
      512,
      [],
      'e3b6',
      
      'M344 32v0c-44.3 0-83.7 28.4-97.7 70.4L233 142.3l-1.9 5.6-3.7 4.6L179.5 211c-12.6 15.4-19.5 34.7-19.5 54.7c0 47.7 38.7 86.3 86.3 86.3c19.9 0 39.2-6.9 54.7-19.5l58.5-47.9 4.6-3.7 5.6-1.9 39.9-13.3c42-14 70.4-53.3 70.4-97.6l0-.1 0-.2 0-.1c0-28.8-18.4-62.8-45.6-90.1C407.2 50.4 373.2 32 344.4 32l-.2 0-.2 0zm.3-32C385.1 0 426.8 24.8 457 55s55 71.9 55 112.7l0 .3c0 58.1-37.2 109.7-92.3 128.1l-39.9 13.3-58.5 47.9c-21.1 17.3-47.6 26.7-74.9 26.7c-26.9 0-51.7-9-71.6-24.1L27.3 507.3 4.7 484.7 152.1 337.3C137 317.4 128 292.6 128 265.7c0-27.3 9.5-53.8 26.7-74.9l47.9-58.5 13.3-39.9C234.3 37.2 285.9 0 344 0l.3 0zM544 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  

  
  

  var faSquareChevronRight = {
    prefix: 'fasl',
    iconName: 'square-chevron-right',
    icon: [
      448,
      512,
      ["chevron-square-right"],
      'f32b',
      
      'M416 64L32 64l0 384 384 0 0-384zm32-32l0 32 0 384 0 32-32 0L32 480 0 480l0-32L0 64 0 32l32 0 384 0 32 0zM315.3 267.3l-112 112L192 390.6 169.4 368l11.3-11.3L281.4 256 180.7 155.3 169.4 144 192 121.4l11.3 11.3 112 112L326.6 256l-11.3 11.3z'
      
    ]
  };

  
    var faChevronSquareRight = faSquareChevronRight;
  

  
  

  var faPersonSnowboarding = {
    prefix: 'fasl',
    iconName: 'person-snowboarding',
    icon: [
      512,
      512,
      [127938,"snowboarding"],
      'f7ce',
      
      'M194.3 16.2l48 80 3.6 6.1 6.9 1.4 50 10-83.3 39.2c-16.8 7.9-27.6 24.8-27.6 43.4l0 83.1-88.9 59.3-13.3 8.9 .4 .7-24.6-9.6L28.3 293.8 18 281.5-6.5 302 3.7 314.2l40 48 2.6 3.2 3.8 1.5 368 144L421 512h3 56 16V480H480 427L325.8 440.4l.9-2 56-128 5-11.4-9.8-7.6-68.3-53.1 96.1-54.1 80 68 20.7-24.4-160-136-3.2-2.7-4.1-.8L266.1 73.7 221.7-.2 194.3 16.2zm87.9 200.7l-46.6-36.2 106.8-50.3 37.2 31.7-97.5 54.8zM224 212.3L348.4 309l-51 116.6-1.4 3.1L125.7 362.1l91.2-60.8 7.1-4.7V288l0-75.7zM424 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 424 0a56 56 0 1 0 0 112z'
      
    ]
  };

  
    var faSnowboarding = faPersonSnowboarding;
  

  
  

  var faArrowsRetweet = {
    prefix: 'fasl',
    iconName: 'arrows-retweet',
    icon: [
      640,
      512,
      ["retweet-alt"],
      'f361',
      
      'M128 65.4l11.3 11.3 80 80L230.6 168 208 190.6l-11.3-11.3L144 126.6V384H336h16v32H336 128 112V400 126.6L59.3 179.3 48 190.6 25.4 168l11.3-11.3 80-80L128 65.4zm400 320l52.7-52.7L592 321.4 614.6 344l-11.3 11.3-80 80L512 446.6l-11.3-11.3-80-80L409.4 344 432 321.4l11.3 11.3L496 385.4V128H304 288V96h16H512h16v16V385.4z'
      
    ]
  };

  
    var faRetweetAlt = faArrowsRetweet;
  

  
  

  var faUserHeadset = {
    prefix: 'fasl',
    iconName: 'user-headset',
    icon: [
      448,
      512,
      [],
      'f82d',
      
      'M224 32C135.6 32 64 103.6 64 192v32H32V192C32 86 118 0 224 0S416 86 416 192V304v16H400 272 224 176V256h96v32H384V192c0-88.4-71.6-160-160-160zM144 291.9c-29.3-23.5-48-59.5-48-99.9c0-70.7 57.3-128 128-128s128 57.3 128 128c0 23.3-6.2 45.2-17.1 64H304V245.1c10.1-15.2 16-33.5 16-53.1c0-53-43-96-96-96s-96 43-96 96c0 19.6 5.9 37.9 16 53.1v46.8zM9.6 480L48 352h96 32 48 48H400l38.4 128 9.6 32H414.6 33.4 0l9.6-32zm62.2-96L43 480H405l-28.8-96H71.8z'
      
    ]
  };

  

  
  

  var faY = {
    prefix: 'fasl',
    iconName: 'y',
    icon: [
      384,
      512,
      [121],
      '59',
      
      'M176 292.8L2.1 32H40.6L192 259.2 343.4 32h38.5L208 292.9V464v16H176V464 292.8z'
      
    ]
  };

  

  
  

  var faCarBurst = {
    prefix: 'fasl',
    iconName: 'car-burst',
    icon: [
      640,
      512,
      ["car-crash"],
      'f5e1',
      
      'M193.8 36.1l25.1 50.8 51-11.1-22.6 37.7-16.8 3.7-16.2-4.4-21-5.6-3-6.1L176 72.3l-14.2 28.8-11.1 22.4-24.4-5.3-31.4-6.8 13.6 29.1L119.2 163 99.8 178.8 74.9 199.1l31.2 7.5 24.3 5.8 .2 25 .3 32.1 10.3-8-13.8 51.4L99.6 334.6l-.4-40.3-.6-56.6L43.6 224.5 4.4 215.2l31.3-25.4L79.6 154 55.5 102.7 38.4 66.3l39.4 8.6 55.3 12 25.1-50.8L176 0l17.8 36.1zm132.7 7.4l11.7 3.1 234.3 62.8 11.7 3.1 .2 12.1 2 121 21.3 5.7 30.9 8.3-8.3 30.9L593.7 427l-8.3 30.9-14.5 54.1-36.1-9.7 14.5-54.1L188.9 351.6l-14.5 54.1-36-9.7 14.5-54.1 5.2-19.4 3.1-11.5 36.6-136.5 8.3-30.9 30.9 8.3 21.3 5.7L320.3 53.9l6.2-10.4zm226 93.7l-211-56.5-51.3 85.6 264 70.7-1.6-99.8zm46.8 145L228.6 182.9 192 319.3l370.8 99.4 36.6-136.5zM276.7 239.9A28 28 0 1 1 262.3 294a28 28 0 1 1 14.5-54.1zm218.1 87.4a28 28 0 1 1 54.1 14.5 28 28 0 1 1 -54.1-14.5z'
      
    ]
  };

  
    var faCarCrash = faCarBurst;
  

  
  

  var faBoxDollar = {
    prefix: 'fasl',
    iconName: 'box-dollar',
    icon: [
      448,
      512,
      ["box-usd"],
      'f4a0',
      
      'M42.1 160H208V64H84.8L42.1 160zM208 192H32V448H416V192H240 208zM363.2 64H240v96H405.9L363.2 64zM64 32H384l64 144V448v32H416 32 0V448 176L64 32zM240 224v9.6c5.9 1 19 3.5 24.1 4.9l15.5 4.1-8.2 30.9-15.5-4.1c-4-1.1-17.7-3.7-22.1-4.4c-12.8-2-23.6-.4-30.9 2.9c-7.2 3.3-9.9 7.5-10.5 11c-.7 4.1-.1 6.2 .5 7.4c.6 1.4 2 3.1 5 5.1c6.7 4.6 17.1 7.8 31 12l.6 .2c12.3 3.7 27.9 8.4 39.5 16.8c6.3 4.6 12 10.6 15.6 18.8c3.6 8.3 4.4 17.4 2.7 27.2c-3 17.5-14.6 29.4-29.3 35.7c-5.6 2.4-11.6 4-17.9 4.9V416v16H208V416v-9.6c-9.4-1.7-23.6-6.6-32.4-9.6l0 0 0 0 0 0c-1.8-.6-3.3-1.1-4.6-1.6l-15.2-5.1 10.1-30.4 15.2 5.1c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c9.5 3.2 20.7 7 27.1 8.1c13.3 2.1 24 .8 31-2.2c6.5-2.8 9.5-6.7 10.3-11.8c.8-4.7 .2-7.3-.5-9c-.7-1.7-2.2-3.6-5.1-5.7c-6.5-4.7-16.7-8.1-30.5-12.3l-2-.6c-11.9-3.6-26.6-8-37.7-15.5c-6.2-4.2-12.2-10-15.9-17.9c-3.8-8.1-4.7-17.1-3.1-26.6c2.9-16.7 14.7-28.4 28.8-34.7c5.6-2.6 11.8-4.4 18.3-5.4V224 208h32v16z'
      
    ]
  };

  
    var faBoxUsd = faBoxDollar;
  

  
  

  var faWind = {
    prefix: 'fasl',
    iconName: 'wind',
    icon: [
      512,
      512,
      [],
      'f72e',
      
      'M288 0V32h16 64c26.5 0 48 21.5 48 48s-21.5 48-48 48H16 0v32H16 368c44.2 0 80-35.8 80-80s-35.8-80-80-80H304 288zm64 416h16 56c48.6 0 88-39.4 88-88s-39.4-88-88-88H16 0v32H16 424c30.9 0 56 25.1 56 56s-25.1 56-56 56H368 352v32zM112 512h64c44.2 0 80-35.8 80-80s-35.8-80-80-80H16 0v32H16 176c26.5 0 48 21.5 48 48s-21.5 48-48 48H112 96v32h16z'
      
    ]
  };

  

  
  

  var faCircleExclamationCheck = {
    prefix: 'fasl',
    iconName: 'circle-exclamation-check',
    icon: [
      640,
      512,
      [],
      'e10d',
      
      'M32 256C32 132.3 132.3 32 256 32c95.3 0 176.7 59.5 209.1 143.4l29.9-11.5C458 68 364.9 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c75.8 0 144-33 190.8-85.3L423 405.3c-41 45.9-100.6 74.7-167 74.7C132.3 480 32 379.7 32 256zM272 144V128H240v16V272v16h32V272 144zm8 224V320H232v48h48zM630.6 192L608 169.4l-11.3 11.3L480 297.4l-52.7-52.7L416 233.4 393.4 256l11.3 11.3 64 64L480 342.6l11.3-11.3 128-128L630.6 192z'
      
    ]
  };

  

  
  

  var faWreathLaurel = {
    prefix: 'fasl',
    iconName: 'wreath-laurel',
    icon: [
      640,
      512,
      [],
      'e5d2',
      
      'M384 32c44.2 0 80 35.8 80 80c-44.2 0-80-35.8-80-80zM495.4 99.9C489.3 43.7 441.8 0 384 0H352V32c0 61.9 50.1 112 112 112h8.1c25.7 31.5 39.9 71 39.9 112c0 69.6-37 130.5-92.4 164.2l21.2 10.6 11.7 5.9 27.6 13.8c51.5 9 105.4-14.2 133-62.1l8-13.9 16-27.7-6.9-4c-7.1-4.1-14.5-7.4-22-9.9c-7-2.3-14.1-4-21.3-5C619.1 304.5 640 266.7 640 224V208 176h-8c-8.2 0-16.2 .8-24 2.4c-7.2 1.5-14.2 3.6-20.9 6.3c16.2-36.2 15.4-79.4-5.9-116.4l-8-13.9-16-27.7-6.9 4c-7.1 4.1-13.7 8.8-19.6 14.1c-17 15-29 34.2-35.3 55.1zM319.8 480l.2 0h76.2l60.6 30.3 14.3-28.6-64-32-3.4-1.7H400 320c-106 0-192-86-192-192c0-41 14.2-80.5 39.9-112H176c61.9 0 112-50.1 112-112V0H256C198.2 0 150.7 43.7 144.6 99.9c-6.3-20.9-18.3-40.1-35.3-55.1c-5.9-5.2-12.5-10-19.6-14.1l-6.9-4-16 27.7-8 13.9c-21.4 37-22.2 80.2-5.9 116.4c-6.7-2.7-13.7-4.8-20.9-6.3c-7.8-1.6-15.8-2.4-24-2.4H0v32 16c0 42.7 20.9 80.5 53.1 103.8c-7.2 1-14.3 2.7-21.3 5c-7.5 2.5-14.9 5.8-22 9.9l-6.9 4 16 27.7 8 13.9c29.8 51.7 90.2 74.7 145.1 59.4c6.9-1.9 13.7-4.4 20.3-7.6c8.7 6 17.8 11.5 27.3 16.2l-50.8 25.4 14.3 28.6L243.8 480h76zM176 112c0-26.2 12.6-49.4 32-64c13.4-10 30-16 48-16c0 44.2-35.8 80-80 80zM96 296v18.5C58.7 301.4 32 265.8 32 224V211.3c36.9 10.4 64 44.4 64 84.7zm448 18.5V296c0-40.3 27.1-74.2 64-84.7V224c0 41.8-26.7 77.4-64 90.5zM146 402.6l9.3 16.1c-38.9 7.2-79.8-10.2-100.7-46.4l-6.3-11c37.2-9.4 77.6 6.5 97.8 41.3zM96.7 194.7C71 164.6 65.7 120.5 86.6 84.3l6.3-11c26.8 27.5 33.2 70.5 13.1 105.3l-9.3 16.1zM534 178.6c-20.1-34.9-13.7-77.8 13.1-105.3l6.3 11c20.9 36.2 15.5 80.4-10.2 110.4L534 178.6zm-40 224c20.1-34.9 60.6-50.8 97.8-41.3l-6.3 11c-20.9 36.2-61.8 53.6-100.7 46.4l9.3-16.1z'
      
    ]
  };

  

  
  

  var faMegaphone = {
    prefix: 'fasl',
    iconName: 'megaphone',
    icon: [
      576,
      512,
      [128227],
      'f675',
      
      'M576 32H544V59.5L32 187.5V176 160H0v16 19.5V208v96 12.5V336v16H32V336 324.5l131.7 32.9c-2.4 8.4-3.7 17.4-3.7 26.6c0 53 43 96 96 96c46.2 0 84.7-32.6 93.9-76L544 452.5V480h32V440 72 32zM544 419.5L32 291.5v-71l512-128v327zM192 384c0-6.5 1-12.9 2.8-18.8l124 31C313.1 425.7 287.2 448 256 448c-35.3 0-64-28.7-64-64z'
      
    ]
  };

  

  
  

  var faUserShield = {
    prefix: 'fasl',
    iconName: 'user-shield',
    icon: [
      640,
      512,
      [],
      'f505',
      
      'M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM43.3 480L87.6 336H323c-1.6-10.8-2.6-21.5-2.9-32H64L9.8 480 0 512H33.5h381 11.6c-13.3-9.5-25.3-20.3-36.1-32H43.3zM607.9 301.6C606.1 367.4 572.8 437 512 470.3V264.5l95.9 37.1zm-223.8 0L480 264.5V470.3c-60.8-33.3-94.1-102.8-95.9-168.6zM496 512c96-32 144-130.2 144-216V279.8L496 224 352 279.8V296c0 85.8 48 184 144 216z'
      
    ]
  };

  

  
  

  var faMushroom = {
    prefix: 'fasl',
    iconName: 'mushroom',
    icon: [
      512,
      512,
      [127812],
      'e425',
      
      'M131.2 105.6C148.7 128.9 176.6 144 208 144c45.8 0 84.1-32.1 93.7-75c40.7 9.1 76.9 30.2 104.7 59.3c-2.1-.2-4.2-.3-6.4-.3c-35.3 0-64 28.7-64 64s28.7 64 64 64c25.2 0 47.1-14.6 57.5-35.8c4.3 16.6 6.5 33.9 6.5 51.8v16H48V272c0-68 32.7-128.5 83.2-166.4zM116.4 76.8C55.6 120.3 16 191.5 16 272v16 32H48 464h32V288 272c0-116.3-82.8-213.4-192.7-235.3c0-.3-.1-.6-.1-.9c-10.8-2-21.9-3.2-33.2-3.6c0 .1 0 .2 .1 .3c-4.7-.3-9.4-.4-14.1-.4c-40.1 0-77.8 9.8-111 27.2c-.1-.4-.1-.8-.2-1.2c-10 5.3-19.6 11.3-28.6 18c.1 .3 .2 .5 .3 .8zm41.9 11.6C187.4 72.8 220.7 64 256 64c4.7 0 9.3 .2 13.9 .5C262.6 91.8 237.7 112 208 112c-20.1 0-38-9.2-49.7-23.7zM179.7 352l-14.8 96L160 480h32.4H319.6 352l-4.9-32-14.8-96H299.9l14.8 96H197.3l14.8-96H179.7zM128 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm208-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faPlanetRinged = {
    prefix: 'fasl',
    iconName: 'planet-ringed',
    icon: [
      512,
      512,
      [129680],
      'e020',
      
      'M502.6 26.4c1.7-12 1.2-18.3 1.2-18.3s-6.3-.4-18.3 1.2c-3.9 .5-8.5 1.3-13.7 2.4c-21.6 4.6-53.8 14.7-94.9 36.9c10.3 6 20.3 12.9 29.8 20.6c9.1-4.5 17.6-8.3 25.5-11.5c12.9-5.3 24.1-9 33.5-11.5c-2.6 9.4-6.3 20.6-11.5 33.5c-6.6 16.2-15.7 35.1-28.3 56.4C388.3 82.8 326.2 48 256 48C141.1 48 48 141.1 48 256c0 70.2 34.8 132.3 88.1 170c-21.4 12.6-40.2 21.7-56.4 28.3c-12.9 5.3-24.1 9-33.5 11.5c2.6-9.4 6.3-20.6 11.5-33.5c3.2-7.9 7-16.4 11.5-25.5c-7.7-9.5-14.6-19.5-20.6-29.8c-22.2 41.2-32.3 73.3-36.9 94.9c-1.1 5.2-1.9 9.7-2.4 13.7c-1.7 12-1.2 18.3-1.2 18.3s6.3 .4 18.3-1.2c3.9-.6 8.5-1.3 13.7-2.4c27-5.7 70.5-20.1 127.5-55.9C194.4 456.9 224.4 464 256 464c114.9 0 208-93.1 208-208c0-31.6-7.1-61.6-19.7-88.5c35.9-57 50.2-100.4 55.9-127.5c1.1-5.2 1.9-9.7 2.4-13.7zM407.2 165.9c-25.4 37.8-60.8 81.8-110.2 131.2s-93.4 84.8-131.2 110.2C114.4 376.5 80 320.3 80 256c0-97.2 78.8-176 176-176c64.3 0 120.5 34.4 151.2 85.9zM199.6 422.8c35.8-25.5 76-59 120.1-103.1s77.6-84.2 103.1-120.1c6 17.7 9.2 36.7 9.2 56.4c0 97.2-78.8 176-176 176c-19.7 0-38.7-3.2-56.4-9.2z'
      
    ]
  };

  

  
  

  var faUserDoctorHair = {
    prefix: 'fasl',
    iconName: 'user-doctor-hair',
    icon: [
      448,
      512,
      [],
      'e458',
      
      'M320 144V128c0-5.5-.5-10.8-1.3-16H272h-3.8l-3.4-1.7-20.1-10-16 21.3L224 128h-8l-88 0v16c0 53 43 96 96 96s96-43 96-96zM224 32c-41.8 0-77.4 26.7-90.5 64H208l19.2-25.6 8-10.7 11.9 6L275.8 80h31.4C290.6 51.3 259.5 32 224 32zm0-32c70.7 0 128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128C96 57.3 153.3 0 224 0zM43.3 480H404.7L360.4 336H320v34.3c23.1 6.9 40 28.3 40 53.7v24 16H344 328 312V432h16v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8h16v32H280 264 248V448 424c0-25.4 16.9-46.8 40-53.7V336H176v34.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V336H87.6L43.3 480zM144 416a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM64 304H384l54.2 176 9.8 32H414.5 33.5 0l9.8-32L64 304z'
      
    ]
  };

  

  
  

  var faSquareY = {
    prefix: 'fasl',
    iconName: 'square-y',
    icon: [
      448,
      512,
      [],
      'e287',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM208 293.5L92.2 144h40.5L224 261.9 315.4 144h40.5L240 293.5V384v16H208V384 293.5z'
      
    ]
  };

  

  
  

  var faCircleUser = {
    prefix: 'fasl',
    iconName: 'circle-user',
    icon: [
      512,
      512,
      [62142,"user-circle"],
      'f2bd',
      
      'M480 256C480 132.3 379.7 32 256 32S32 132.3 32 256c0 67.5 29.8 128 77 169l35-105H368l35 105c47.2-41.1 77-101.6 77-169zM376 445.2L344.9 352H167.1L136 445.2c34.7 22 75.9 34.8 120 34.8c44.5 0 85.9-13 120.7-35.3l-.7 .5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208-48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z'
      
    ]
  };

  
    var faUserCircle = faCircleUser;
  

  
  

  var faJugDetergent = {
    prefix: 'fasl',
    iconName: 'jug-detergent',
    icon: [
      384,
      512,
      [],
      'e519',
      
      'M128 32h64V64H128V32zM96 64H64V96H96h32 64 32 32V64H224V32 0H192 128 96V32 64zm256 96V480H32V256c0-53 43-96 96-96H352zM128 128C57.3 128 0 185.3 0 256V480v32H32 352h32V480 160 128H352 128zm96 80H208v16V384v16h16 64 16V384 224 208H288 224zm16 160V240h32V368H240z'
      
    ]
  };

  

  
  

  var faDiagramSubtask = {
    prefix: 'fasl',
    iconName: 'diagram-subtask',
    icon: [
      512,
      512,
      [],
      'e479',
      
      'M480 64V192H144 112 32V64H480zM144 224H480h32V192 64 32H480 32 0V64 192v32H32h80V384v16h16 96v48 32h32H480h32V448 320 288H480 256 224v32 48H144V224zm336 96V448H256V320H480z'
      
    ]
  };

  

  
  

  var faListCheck = {
    prefix: 'fasl',
    iconName: 'list-check',
    icon: [
      512,
      512,
      ["tasks"],
      'f0ae',
      
      'M156.3 58.2L166.5 46 142 25.5 131.7 37.8 62.9 120.3 27.3 84.7 16 73.4-6.6 96 4.7 107.3l48 48 12.4 12.4 11.2-13.5 80-96zm0 160L166.5 206 142 185.5l-10.2 12.3L62.9 280.3 27.3 244.7 16 233.4-6.6 256 4.7 267.3l48 48 12.4 12.4 11.2-13.5 80-96zM192 80v32h16H496h16V80H496 208 192zm0 160v32h16H496h16V240H496 208 192zM160 400v32h16H496h16V400H496 176 160zM96 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  
    var faTasks = faListCheck;
  

  
  

  var faShrimp = {
    prefix: 'fasl',
    iconName: 'shrimp',
    icon: [
      512,
      512,
      [129424],
      'e448',
      
      'M0 32H16 432h16V64H432 32v64H336c97.2 0 176 78.8 176 176s-78.8 176-176 176H272 256 240 210.1l16.6-24.9L252.8 416l-26.1-39.1-21.8-32.8 38.5 8.3L348.9 375c3.2 .7 6.4 1 9.7 1c14 0 25.4-11.4 25.4-25.4V348c0-15.5-12.5-28-28-28H240c-91.8 0-167.2-70.3-175.3-160H16 0V144 48 32zM336 448V404.9l-60.8-13 10.2 15.2 5.9 8.9-5.9 8.9L269.9 448H272h64zm32-3.6c33-7.5 61.7-26.3 81.7-52.1l-39.8-15.9c-8.1 16.1-23.5 27.8-41.9 30.8v37.2zm98.7-79.8c8.6-18.4 13.3-39 13.3-60.6c0-9.3-.9-18.3-2.5-27.1l-67.4 45c3.3 6.9 5.4 14.4 5.9 22.4l50.8 20.3zm.8-119.5C447 199.6 403.6 166.6 352 160.9V288h4c12 0 23.3 3.6 32.7 9.7l78.8-52.5zM320 160H96.9c8 72 69 128 143.1 128h80V160zM208 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faCircleDivide = {
    prefix: 'fasl',
    iconName: 'circle-divide',
    icon: [
      512,
      512,
      [],
      'e106',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-328V136H232v48h48zM160 240H144v32h16H352h16V240H352 160zm72 136h48V328H232v48z'
      
    ]
  };

  

  
  

  var faBorderLeft = {
    prefix: 'fasl',
    iconName: 'border-left',
    icon: [
      448,
      512,
      [],
      'f84f',
      
      'M0 480L0 32l32 0 0 448L0 480zm104-8l0-48 48 0 0 48-48 0zm0-432l48 0 0 48-48 0 0-48zm0 240l0-48 48 0 0 48-48 0zM296 424l48 0 0 48-48 0 0-48zm0-336l0-48 48 0 0 48-48 0zm0 144l48 0 0 48-48 0 0-48zM200 472l0-48 48 0 0 48-48 0zm0-432l48 0 0 48-48 0 0-48zm0 240l0-48 48 0 0 48-48 0zM392 424l48 0 0 48-48 0 0-48zm0-336l0-48 48 0 0 48-48 0zm0 144l48 0 0 48-48 0 0-48zM200 376l0-48 48 0 0 48-48 0zm192-48l48 0 0 48-48 0 0-48zm0-144l0-48 48 0 0 48-48 0zM200 136l48 0 0 48-48 0 0-48z'
      
    ]
  };

  

  
  

  var faTv = {
    prefix: 'fasl',
    iconName: 'tv',
    icon: [
      640,
      512,
      [63717,"television","tv-alt"],
      'f26c',
      
      'M32 32V416H608V32H32zM0 0H32 608h32V32 416v32H608 32 0V416 32 0zM112 480H528h16v32H528 112 96V480h16z'
      
    ]
  };

  
    var faTelevision = faTv;
  
    var faTvAlt = faTv;
  

  
  

  var faDownFromDottedLine = {
    prefix: 'fasl',
    iconName: 'down-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e407',
      
      'M56 40H8V88H56V40zm96 0H104V88h48V40zm48 0V88h48V40H200zm144 0H296V88h48V40zm48 0V88h48V40H392zM272 272v32h32 48v17.7L224 436.9 96 321.7V304h48 32V272 160h96V272zm112 0H352 336 304V240 160 128H272 176 144v32 80 32H112 96 64v32 32L224 480 384 336V304 272z'
      
    ]
  };

  

  
  

  var faArrowUp = {
    prefix: 'fasl',
    iconName: 'arrow-up',
    icon: [
      384,
      512,
      [8593],
      'f062',
      
      'M203.3 44.7L192 33.4 180.7 44.7l-168 168L1.4 224 24 246.6l11.3-11.3L176 94.6V464v16h32V464 94.6L348.7 235.3 360 246.6 382.6 224l-11.3-11.3-168-168z'
      
    ]
  };

  

  
  

  var faBoneBreak = {
    prefix: 'fasl',
    iconName: 'bone-break',
    icon: [
      640,
      512,
      [],
      'f5d8',
      
      'M336 0H304V16v96 16h32V112 16 0zM176 57.4L153.4 80l11.3 11.3 64 64L240 166.6 262.6 144l-11.3-11.3-64-64L176 57.4zM486.6 80L464 57.4 452.7 68.7l-64 64L377.4 144 400 166.6l11.3-11.3 64-64L486.6 80zM266.5 228.9l-95.9 25.7c-15.5-42.3-61-66.5-105.4-54.6C18.3 212.6-9.6 260.8 3 307.8c4.7 17.5 14.3 32.3 27 43.4c8.2 7.2 17.6 12.7 27.8 16.5c-7 8.3-12.3 17.9-15.8 28.2c-5.4 15.9-6.3 33.6-1.7 51.1c12.6 46.9 60.8 74.8 107.8 62.2c44.3-11.9 71.7-55.6 63.9-100l95.9-25.7-8.3-30.9L175.5 385.8l5 28.8c4.9 28.2-12.5 56-40.7 63.6c-29.9 8-60.6-9.7-68.6-39.6c-4.9-18.3-.2-36.9 11.1-50.4l6.4-7.7L78.2 341l-9.4-3.4c-16.6-6.1-30-19.8-34.9-38.1c-8-29.9 9.7-60.6 39.6-68.6c28.2-7.6 57.2 7.8 67 34.7l10.1 27.5 124.2-33.3-8.3-30.9zm202.9 25.7l-95.9-25.7-8.3 30.9 124.2 33.3 10.1-27.5c9.9-26.9 38.8-42.3 67-34.7c29.9 8 47.6 38.7 39.6 68.6c-4.9 18.3-18.3 32-34.9 38.1l-9.4 3.4-10.6 39.4 6.4 7.7c11.3 13.6 16 32.2 11.1 50.4c-8 29.9-38.7 47.6-68.6 39.6c-28.2-7.6-45.6-35.4-40.7-63.6l5-28.8L340.3 352.5l-8.3 30.9L428 409.1c-7.7 44.4 19.6 88.1 63.9 100c46.9 12.6 95.2-15.3 107.8-62.2c4.7-17.5 3.8-35.1-1.7-51.1c-3.5-10.3-8.9-19.8-15.8-28.2c10.2-3.7 19.6-9.3 27.8-16.5c12.7-11.1 22.3-25.9 27-43.4c12.6-46.9-15.3-95.2-62.2-107.8c-44.3-11.9-89.8 12.3-105.4 54.6z'
      
    ]
  };

  

  
  

  var faLandmarkDome = {
    prefix: 'fasl',
    iconName: 'landmark-dome',
    icon: [
      512,
      512,
      ["landmark-alt"],
      'f752',
      
      'M272 0V16 32.7c87.9 7.2 159 73.7 173.3 159.3H464h16v32H464 448 416 96 64 48 32V192H48 66.7C81 106.3 152.1 39.9 240 32.7V16 0h32zM99.2 192H412.8C398 119 333.4 64 256 64s-142 55-156.8 128zM64 352V256H96v96h80V256h32v96h96V256h32v96h80V256h32v96h16v32H448 64 48V352H64zM24 448V416H40 472h16v32H472 40 24zM0 480H16 496h16v32H496 16 0V480z'
      
    ]
  };

  
    var faLandmarkAlt = faLandmarkDome;
  

  
  

  var faBrazilianRealSign = {
    prefix: 'fasl',
    iconName: 'brazilian-real-sign',
    icon: [
      512,
      512,
      [],
      'e46c',
      
      'M416 16V0H384V16 64.1c-53.3 1.8-96 45.5-96 99.3c0 42.2 26.7 79.8 66.6 93.8l80.3 28c27 9.4 45.1 34.9 45.1 63.6c0 37.2-30.1 67.3-67.3 67.3H395.4c-20.3 0-40.1-5.5-57.5-15.9l-25.6-15.3-16.4 27.5 25.6 15.3c19.1 11.4 40.5 18.2 62.6 20V496v16h32V496 447.9c53.3-1.8 96-45.5 96-99.3c0-42.2-26.7-79.8-66.6-93.8l-80.3-28c-27-9.4-45.1-34.9-45.1-63.6c0-37.2 30.1-67.3 67.3-67.3H403c17 0 33.8 3.4 49.5 9.9l13.3 5.6L478.2 82l-13.3-5.6c-15.6-6.5-32.1-10.5-48.9-11.9V16zM0 32V48 304 480H32V320h80c3.1 0 6.3-.1 9.3-.3L172.6 480h33.6L153.1 314C212.6 296.3 256 241.2 256 176c0-79.5-64.5-144-144-144H16 0zM224 176c0 51-34 94-80.6 107.5l-.1-.4-7.1 2.3c-7.8 1.7-15.9 2.6-24.2 2.6H32V64h80c61.9 0 112 50.1 112 112z'
      
    ]
  };

  

  
  

  var faHatWinter = {
    prefix: 'fasl',
    iconName: 'hat-winter',
    icon: [
      512,
      512,
      [],
      'f7a8',
      
      'M278.4 22.9L256 0 233.6 22.9l-.9 .9-1.3 0-32-.4 .4 32 0 1.3-.9 .9L176 80l22.9 22.4 .9 .9 0 1.3-.4 32 32-.4 1.3 0 .9 .9L256 160l22.4-22.9 .9-.9 1.3 0 32 .4-.4-32 0-1.3 .9-.9L336 80 313.1 57.6l-.9-.9 0-1.3 .4-32-32 .4-1.3 0-.9-.9zm1.3 32.9l.5 0 0 .5L280 70.1l9.8 9.6 .4 .4-.4 .4L280 89.9l.2 13.7 0 .5-.5 0-13.7-.2-7.8 8c-.7 0-1.4 0-2.1 0s-1.4 0-2.1 0l-7.8-8-13.7 .2-.5 0 0-.5 .2-13.7-9.8-9.6-.4-.4 .4-.4 9.8-9.6-.2-13.7 0-.5 .5 0 13.7 .2 9.6-9.8 .4-.4 .4 .4 9.6 9.8 13.7-.2zM32 480V432H480v48H32zM0 400v32 48 32H32 480h32V480 432 400H480 32 0zM167.5 132C65.1 183.7 39.5 321 33.6 368H65.9c.8-5.8 1.9-12.8 3.3-20.6c.5-2.9 1.1-5.9 1.8-9l8.2-4.1 56.3-28.2 48.6 27.8 7.4 4.2 7.7-3.8L256 305.9l56.8 28.4 7.7 3.8 7.4-4.2 48.6-27.8 56.3 28.2 8.2 4.1c.6 3.1 1.2 6.1 1.8 9c1.5 7.9 2.5 14.9 3.3 20.6h32.3c-5.9-47-31.5-184.3-133.9-236l.1 4.2L345 169l-.5 0c33.4 21.8 56.2 55.6 72.2 92c5.4 12.2 9.9 24.5 13.6 36.4l-47.2-23.6-7.7-3.8-7.4 4.2-48.6 27.8-56.3-28.2-7.2-3.6-7.2 3.6-56.3 28.2-48.6-27.8-7.4-4.2-7.7 3.8L81.6 297.3c3.7-11.9 8.2-24.1 13.6-36.4c16-36.4 38.9-70.2 72.2-92l-.5 0 .4-32.8 0-4.2z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassPlay = {
    prefix: 'fasl',
    iconName: 'magnifying-glass-play',
    icon: [
      512,
      512,
      [],
      'e660',
      
      'M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L487.9 510.5l22.6-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM145.8 153.2V262.8v37l32-18.6L272 226.5 303.9 208 272 189.5l-94.2-54.7-32-18.6v37zM240.1 208l-62.4 36.2V171.8L240.1 208z'
      
    ]
  };

  

  
  

  var faPersonHarassing = {
    prefix: 'fasl',
    iconName: 'person-harassing',
    icon: [
      576,
      512,
      [],
      'e549',
      
      'M168 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 136 56a56 56 0 1 0 112 0zM92.9 128H83.3l-4.5 8.5L1.9 280.5l28.2 15.1L80 202.2V496v16h32V496 352h64V496v16h32V496 183.9l83.8 98.5 24.4-20.7-108.9-128-4.8-5.6h-7.4H92.9zM112 320V160h64V320H112zM304 32H288V64h16 56 16V32H360 304zM432 224a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm80-16h-6.6l-4.7 4.7-32 32-4.7 4.7 0 6.6 0 103.6-51.4-65.4-26.5 1.9-64 112 27.8 15.9 52.2-91.4 53.5 68.2C471.2 500.5 494.9 512 520 512c30.9 0 56-25.1 56-56V304 288H560 512zm8 192c-13.3 0-24-10.7-24-24l0-113.4L518.6 320H544V456c0 13.3-10.7 24-24 24zM272.8 90.5l-14.3 28.6 14.3 7.2 48 24 14.3 7.2 14.3-28.6-14.3-7.2-48-24-14.3-7.2z'
      
    ]
  };

  

  
  

  var faNfcPen = {
    prefix: 'fasl',
    iconName: 'nfc-pen',
    icon: [
      576,
      512,
      [],
      'e1fa',
      
      'M416 64H32V448H263.7l-5 32H32 0V448 64 32H32 416h32V64 220.9l-32 32V64zm-32 48V284.9l-32 32V128H240v82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112 96h16H368h16v16zM271.7 397.2L268.7 416H80 64V400 112 96H80h64 16v32H144 96V384H284.9l-13.2 13.2zM224 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm265.3 29.3L466.5 292 508 333.5l22.8-22.8-41.5-41.5zM334 424.5l-7.7 49.1 49.1-7.7L485.4 356.1l-41.5-41.5L334 424.5zM553.4 288.1L576 310.7l-22.6 22.6L390.7 496l-69.5 10.8L288 512l5.2-33.2L304 409.3 489.3 224l64.1 64.1z'
      
    ]
  };

  

  
  

  var faChessKing = {
    prefix: 'fasl',
    iconName: 'chess-king',
    icon: [
      448,
      512,
      [9818],
      'f43f',
      
      'M240 16V0H208V16 48H168 152V80h16 40v48H32 0v32 40L66.1 352H101L32 193.3V160H208h32H416v33.3L347 352h34.9L448 200V160 128H416 240V80h40 16V48H280 240V16zM64 470.5L97.8 416H350.2L384 470.5V480H64v-9.5zM80 384L32 461.3V480v32H64 384h32V480 461.3L368 384H80z'
      
    ]
  };

  

  
  

  var faRankingStar = {
    prefix: 'fasl',
    iconName: 'ranking-star',
    icon: [
      640,
      512,
      [],
      'e561',
      
      'M334.1 31.1l-14.3-28-14.3 28L282.8 75.8l-49.5 7.9-30.9 4.9 22.1 22.2 35.4 35.5-7.8 49.6-4.9 31 27.9-14.2 44.7-22.7 44.7 22.7 27.9 14.2-4.9-31-7.8-49.6 35.4-35.5 22.1-22.2-30.9-4.9-49.5-7.9L334.1 31.1zM307.6 97.6l12.2-24 12.2 24 3.7 7.3 8 1.3 26.6 4.2-19 19.1-5.7 5.8 1.3 8 4.2 26.6-24-12.2-7.3-3.7-7.3 3.7-24 12.2 4.2-26.6 1.3-8-5.7-5.8-19-19.1 26.6-4.2 8-1.3 3.7-7.3zM224 256v32 32V480v32h32H384h32V480 384 352 288 256H384 256 224zM384 480H256V288H384V480zM0 320v32V480v32H32 160h32V480 352 320H160 32 0zM160 480H32V352H160V480zm320-64H608v64H480V416zm160-32H608 480 448v32 64 32h32H608h32V480 416 384z'
      
    ]
  };

  

  
  

  var faPhoneOffice = {
    prefix: 'fasl',
    iconName: 'phone-office',
    icon: [
      576,
      512,
      [],
      'f67d',
      
      'M208 32V400H112V32h96zM112 0H80V32H32 0V64 480v32H32 544h32V480 64 32H544 512 480 320 288 240V0H208 112zM288 64v64 32h32H480h32V128 64h32V480H32V64H80V400v32h32 96 32V400 64h48zm192 0v64H320V64H480zM352 224v32H320V224h32zm-32-32H288v32 32 32h32 32 32V256 224 192H352 320zm0 160h32v32H320V352zm-32-32v32 32 32h32 32 32V384 352 320H352 320 288zm192-96v32H448V224h32zm-32-32H416v32 32 32h32 32 32V256 224 192H480 448zm0 160h32v32H448V352zm-32-32v32 32 32h32 32 32V384 352 320H480 448 416z'
      
    ]
  };

  

  
  

  var faEnvelopes = {
    prefix: 'fasl',
    iconName: 'envelopes',
    icon: [
      576,
      512,
      [],
      'e170',
      
      'M544 110.9V64H128v46.9L336 249.5 544 110.9zM544 352V149.3L336 288 128 149.3V352H544zm32-224V352v32H544 128 96V352 128 64 32h32H544h32V64v64zM32 96v16V448H464h16v32H464 16 0V464 112 96H32z'
      
    ]
  };

  

  
  

  var faDownLong = {
    prefix: 'fasl',
    iconName: 'down-long',
    icon: [
      320,
      512,
      ["long-arrow-alt-down"],
      'f309',
      
      'M120 352V320l0-288h80l0 288v32h32 42.7L160 466.7 45.3 352H88h32zM32 320H0l0 32L137.4 489.4 160 512l22.6-22.6L320 352V320H288 264 232V288l0-256V0H200 120 88V32l0 256v32H56 32z'
      
    ]
  };

  
    var faLongArrowAltDown = faDownLong;
  

  
  

  var faJugBottle = {
    prefix: 'fasl',
    iconName: 'jug-bottle',
    icon: [
      640,
      512,
      [],
      'e5fb',
      
      'M192 32V64H128V32h64zM96 32V64H64V96H96h32 64 32 32V64H224V32 0H192 128 96V32zM416 175.1v35.3L455.4 192H568.6L608 210.5v32.3l-14.6 14.6L570.7 280l22.6 22.6L608 317.3v37.5l-14.6 14.6L570.7 392l22.6 22.6L608 429.3v37.5L594.7 480H416v32H608l32-32V416l-1.4-1.4L616 392l22.6-22.6L640 368V304l-1.4-1.4L616 280l22.6-22.6L640 256V190.1L575.7 160H448.3L416 175.1zM384 512V480 190.1 160 128H352 128C57.3 128 0 185.3 0 256V480v32H32 352h32zM128 160H352V480H32V256c0-53 43-96 96-96zm80 48v16V384v16h16 64 16V384 224 208H288 224 208zm32 32h32V368H240V240zM448 64V80v48h32V96h64v32h32V80 64H560 464 448z'
      
    ]
  };

  

  
  

  var faSdCards = {
    prefix: 'fasl',
    iconName: 'sd-cards',
    icon: [
      448,
      512,
      [],
      'e240',
      
      'M416 400H112V141.3L221.3 32H416V400zM80 128V400v32h32H416h32V400 32 0H416 208L80 128zM256 64H224V80v64 16h32V144 80 64zm64 0H288V80v64 16h32V144 80 64zm64 0H352V80v64 16h32V144 80 64zM32 112V96H0v16V496v16H16 368h16V480H368 32V112z'
      
    ]
  };

  

  
  

  var faTowerCell = {
    prefix: 'fasl',
    iconName: 'tower-cell',
    icon: [
      576,
      512,
      [],
      'e585',
      
      'M32 128c0-41.2 9.7-80.1 27-114.5L32 0 17.4 29.2C6.1 60 0 93.3 0 128s6.1 68 17.4 98.8L32 256l27-13.5C41.7 208.1 32 169.2 32 128zm64 0c0 30.9 7.3 60 20.2 85.9l28.6-14.3C134.1 178 128 153.7 128 128s6.1-50 16.9-71.6L116.2 42.1C103.3 68 96 97.1 96 128zM459.8 42.1L431.1 56.4C441.9 78 448 102.3 448 128s-6.1 50-16.9 71.6l28.6 14.3C472.7 188 480 158.9 480 128s-7.3-60-20.2-85.9zM544 128c0 41.2-9.7 80.1-27 114.5L544 256l14.6-29.2C569.9 196 576 162.7 576 128s-6.1-68-17.4-98.8L544 0 517 13.5c17.3 34.5 27 73.3 27 114.5zM288 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm47.3 75.1C345.7 159.7 352 144.6 352 128c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 16.6 6.3 31.7 16.7 43.1L98 512h34.7l40.2-96H405.4l41.1 96h34.8l-2.7-6.3L335.3 171.1zM391.7 384H186.3l26.8-64H364.3l27.4 64zm-41.1-96H226.5L268 188.8c6.3 2.1 13 3.2 20 3.2c7 0 13.8-1.1 20.1-3.2L350.6 288z'
      
    ]
  };

  

  
  

  var faSchoolLock = {
    prefix: 'fasl',
    iconName: 'school-lock',
    icon: [
      640,
      512,
      [],
      'e56f',
      
      'M160 96H32 0v32V480v32H32 256h32 64 32V480 384c0-35.3-28.7-64-64-64s-64 28.7-64 64v96H32V128H160c5.8 0 11.5-1.6 16.5-4.6L320 37.3l143.5 86.1c5 3 10.7 4.6 16.5 4.6H608v65.6c19.8 20.2 32 47.9 32 78.4V128 96H608 480L320 0 160 96zM288 384c0-17.7 14.3-32 32-32s32 14.3 32 32v96H288V384zM112 160H96v16 96 16h16 64 16V272 176 160H176 112zm16 96V192h32v64H128zM96 320v16 96 16h16 64 16V432 336 320H176 112 96zm32 32h32v64H128V352zM320 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm16-128V144H304v16 32 16h16 24 16V176H344h-8V160zm192 64c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48H416v32V480v32h32H608h32V480 352 320H608V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm160 80V480H448V352H608z'
      
    ]
  };

  

  
  

  var faCircleEllipsis = {
    prefix: 'fasl',
    iconName: 'circle-ellipsis',
    icon: [
      512,
      512,
      [],
      'e10a',
      
      'M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM184 232l0 48-48 0 0-48 48 0zm192 0l0 48-48 0 0-48 48 0zm-144 0l48 0 0 48-48 0 0-48z'
      
    ]
  };

  

  
  

  var faWatermelonSlice = {
    prefix: 'fasl',
    iconName: 'watermelon-slice',
    icon: [
      512,
      512,
      [],
      'e337',
      
      'M208 480c150.2 0 272-121.8 272-272c0-59.5-19.1-114.5-51.5-159.3L401.1 76.1C430.5 115 448 163.5 448 216c0 128.1-103.9 232-232 232c-52.5 0-101-17.5-139.9-46.9L48.7 428.5C93.5 460.9 148.5 480 208 480zm8-64c110.5 0 200-89.5 200-200c0-43.7-14-84.1-37.8-117L99 378.2C131.9 402 172.3 416 216 416zM25.8 451.4C17.3 445 9 438.1 1.2 430.8l22.6-22.6L408.2 23.8 430.8 1.2C438.1 9 445 17.3 451.4 25.8C489.5 76.6 512 139.7 512 208c0 167.9-136.1 304-304 304c-68.3 0-131.4-22.5-182.2-60.6zM355.3 172.7l16 16L382.6 200 360 222.6l-11.3-11.3-16-16L321.4 184 344 161.4l11.3 11.3zm-80 80l16 16L302.6 280 280 302.6l-11.3-11.3-16-16L241.4 264 264 241.4l11.3 11.3zm80 0l16 16L382.6 280 360 302.6l-11.3-11.3-16-16L321.4 264 344 241.4l11.3 11.3zm-160 80l16 16L222.6 360 200 382.6l-11.3-11.3-16-16L161.4 344 184 321.4l11.3 11.3zm80 0l16 16L302.6 360 280 382.6l-11.3-11.3-16-16L241.4 344 264 321.4l11.3 11.3z'
      
    ]
  };

  

  
  

  var faHandHoldingMagic = {
    prefix: 'fasl',
    iconName: 'hand-holding-magic',
    icon: [
      576,
      512,
      [],
      'f6e5',
      
      'M160 80c0 26.5 21.5 48 48 48h80 16v32H288 208c-44.2 0-80-35.8-80-80s35.8-80 80-80H328c66.3 0 120 53.7 120 120s-53.7 120-120 120H272v24 16H240V264 224 208h16 72c48.6 0 88-39.4 88-88s-39.4-88-88-88H208c-26.5 0-48 21.5-48 48zm11.2 224H176 384h16v16 64h.2l103.6-61.7 13.5-8 8.3 13.3 40 64L574 405l-13.5 8.5-152 96-3.9 2.5H400 16 0V480H16 395.4L530 395l-23.3-37.2-94 56L409 416h-4.4H400 384 320 304 256 240V384h16 48 16 48V336H180.8l-92 61.3-4 2.7H80 16 0V368H16 75.2l92-61.3 4-2.7z'
      
    ]
  };

  

  
  

  var faListUl = {
    prefix: 'fasl',
    iconName: 'list-ul',
    icon: [
      512,
      512,
      ["list-dots"],
      'f0ca',
      
      'M64 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM176 80H160v32h16H496h16V80H496 176zm0 160H160v32h16H496h16V240H496 176zm0 160H160v32h16H496h16V400H496 176zM96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  
    var faListDots = faListUl;
  

  
  

  var faCodeCompare = {
    prefix: 'fasl',
    iconName: 'code-compare',
    icon: [
      512,
      512,
      [],
      'e13a',
      
      'M480 32v96H448 416 384V32h96zM384 160h32V320c0 44.2-35.8 80-80 80H265.4l57.4-52.2-21.5-23.7-88 80-13 11.8 13 11.8 88 80 21.5-23.7L265.4 432H336c61.9 0 112-50.1 112-112V160h32 32V128 32 0H480 384 352V32v96 32h32zM210.8 4.2L189.2 27.8 246.6 80H176C114.1 80 64 130.1 64 192V352H32 0v32 96 32H32h96 32V480 384 352H128 96V192c0-44.2 35.8-80 80-80h70.6l-57.4 52.2 21.5 23.7 88-80 13-11.8-13-11.8-88-80zM64 384v0H96v0h32v96H32V384H64z'
      
    ]
  };

  

  
  

  var faDropletDegree = {
    prefix: 'fasl',
    iconName: 'droplet-degree',
    icon: [
      512,
      512,
      ["dewpoint"],
      'f748',
      
      'M352 320c0-18.5-8.9-46-26.5-80.1c-17-33-40-68.3-63.5-101c-23.4-32.6-47-62.1-64.7-83.4c-1.9-2.2-3.6-4.4-5.4-6.4c-1.7 2.1-3.5 4.2-5.4 6.4c-17.7 21.3-41.2 50.8-64.7 83.4c-23.5 32.7-46.5 68-63.5 101C40.9 274 32 301.5 32 320c0 88.4 71.6 160 160 160s160-71.6 160-160zM0 320C0 235.8 121 83.6 170.9 24.4C183.8 9.1 192 0 192 0s8.2 9.1 21.1 24.4C263 83.6 384 235.8 384 320c0 106-86 192-192 192S0 426 0 320zM480 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  
    var faDewpoint = faDropletDegree;
  

  
  

  var faSkullCrossbones = {
    prefix: 'fasl',
    iconName: 'skull-crossbones',
    icon: [
      448,
      512,
      [9760,128369],
      'f714',
      
      'M300.1 198.4C322.9 180.2 336 155 336 128c0-49.6-46.5-96-112-96s-112 46.4-112 96c0 27 13.1 52.2 35.9 70.4L160 208v15.4V256H288V223.4 208l12.1-9.6zM368 128c0 37.9-18.5 72-48 95.4V256v32H288 160 128V256 223.4C98.5 200 80 165.9 80 128C80 57.3 144.5 0 224 0s144 57.3 144 128zm57.3 382.5L224 417.6 22.7 510.5 9.3 481.5 185.8 400 9.3 318.5l13.4-29.1L224 382.4l201.3-92.9 13.4 29.1L262.2 400l176.5 81.5-13.4 29.1zM160 136a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faClub = {
    prefix: 'fasl',
    iconName: 'club',
    icon: [
      512,
      512,
      [9827],
      'f327',
      
      'M359.7 143.6c.2-2.5 .3-5.1 .3-7.6c0-57.4-46.6-104-104-104s-104 46.6-104 104c0 2.6 .1 5.1 .3 7.6l2.1 29.1-28.8 4.8C72.5 186.3 32 232.4 32 288c0 61.9 50.1 112 112 112c35.2 0 66.5-16.2 87.1-41.6L256 327.6l24.9 30.7c20.6 25.4 52 41.6 87.1 41.6c61.9 0 112-50.1 112-112c0-55.6-40.5-101.7-93.6-110.5l-28.8-4.8 2.1-29.1zM368 432c-33.7 0-64.6-11.5-89.1-30.9c-2.3-1.9-4.6-3.8-6.9-5.8V480h64 16v32H336 272 240 176 160V480h16 64V395.3c-2.2 2-4.5 3.9-6.9 5.8C208.6 420.5 177.7 432 144 432C64.5 432 0 367.5 0 288c0-71.5 52.1-130.8 120.4-142.1c-.2-3.3-.4-6.6-.4-9.9C120 60.9 180.9 0 256 0s136 60.9 136 136c0 3.3-.1 6.7-.4 9.9C459.9 157.2 512 216.5 512 288c0 79.5-64.5 144-144 144z'
      
    ]
  };

  

  
  

  var faHospitals = {
    prefix: 'fasl',
    iconName: 'hospitals',
    icon: [
      576,
      512,
      [],
      'f80e',
      
      'M544 32H288V64H256V32 0h32H544h32V32 480v32H544 320V480H544V416H320V384H544V320H320V288H544V32zM448 80v48h48v32H448v48H416V160H368V128h48V80h32zM256 128H32V352H256V128zM32 480H256V384H32v96zm96-304h32v48h48v32H160v48H128V256H80V224h48V176zM32 96H256h32v32V480v32H256 32 0V480 128 96H32z'
      
    ]
  };

  

  
  

  var faBookArrowRight = {
    prefix: 'fasl',
    iconName: 'book-arrow-right',
    icon: [
      640,
      512,
      [],
      'e0b9',
      
      'M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H432h16V480H432 416V416h16 16V400 272H416V384H64c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H416V144h32V16 0H432 64zM384 416v64H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H384zM531.3 100.7L520 89.4 497.4 112l11.3 11.3L577.4 192H272 256v32h16H577.4l-68.7 68.7L497.4 304 520 326.6l11.3-11.3 96-96L638.6 208l-11.3-11.3-96-96z'
      
    ]
  };

  

  
  

  var faBellPlus = {
    prefix: 'fasl',
    iconName: 'bell-plus',
    icon: [
      448,
      512,
      [],
      'f849',
      
      'M208 0h32V32.8c80.9 8 144 76.2 144 159.2v97.4l59.3 59.3 4.7 4.7V360v40 16H432 16 0V400 360v-6.6l4.7-4.7L64 289.4V192c0-83 63.1-151.2 144-159.2V0zm16 64C153.3 64 96 121.3 96 192V296v6.6l-4.7 4.7L32 366.6V384H416V366.6l-59.3-59.3-4.7-4.7V296 192c0-70.7-57.3-128-128-128zM160 448h32c0 17.7 14.3 32 32 32s32-14.3 32-32h32c0 35.3-28.7 64-64 64s-64-28.7-64-64zm80-288v16 48h48 16v32H288 240v48 16H208V304 256H160 144V224h16 48V176 160h32z'
      
    ]
  };

  

  
  

  var faBatteryFull = {
    prefix: 'fasl',
    iconName: 'battery-full',
    icon: [
      576,
      512,
      [128267,"battery","battery-5"],
      'f240',
      
      'M480 128V384H32V128H480zM32 96H0v32V384v32H32 480h32V384 128 96H480 32zm544 96H544v32 64 32h32V288 224 192zM96 192H416V320H96V192zM64 160v32V320v32H96 416h32V320 192 160H416 96 64z'
      
    ]
  };

  
    var faBattery = faBatteryFull;
  
    var faBattery5 = faBatteryFull;
  

  
  

  var faChevronDown = {
    prefix: 'fasl',
    iconName: 'chevron-down',
    icon: [
      512,
      512,
      [],
      'f078',
      
      'M256 406.6l11.3-11.3 192-192L470.6 192 448 169.4l-11.3 11.3L256 361.4 75.3 180.7 64 169.4 41.4 192l11.3 11.3 192 192L256 406.6z'
      
    ]
  };

  

  
  

  var faMoneyBillSimpleWave = {
    prefix: 'fasl',
    iconName: 'money-bill-simple-wave',
    icon: [
      576,
      512,
      [],
      'e1f2',
      
      'M280.1 420.7l4-1C363.7 399.4 453 376.6 544 404.4V80.8C466.1 49 387 68 295.9 91.3l-4 1C212.3 112.6 122.9 135.4 32 107.6V431.2C109.9 463 189 444 280.1 420.7zM0 60.3c10.7 5.4 21.3 10 32 13.7c85.3 29.8 170.7 8.1 256-13.7c96-24.5 192-48.9 288 0V416.3v35.4c-10.7-5.4-21.3-10-32-13.7c-85.3-29.8-170.7-8.1-256 13.7c-96 24.5-192 48.9-288 0V95.7 60.3zM224 256c0 47 31.3 80 64 80s64-33 64-80s-31.3-80-64-80s-64 33-64 80zm64-112c55.6 0 96 53 96 112s-40.4 112-96 112s-96-53-96-112s40.4-112 96-112z'
      
    ]
  };

  

  
  

  var faHandsHoldingDiamond = {
    prefix: 'fasl',
    iconName: 'hands-holding-diamond',
    icon: [
      640,
      512,
      ["hand-receiving"],
      'f47c',
      
      'M320 256l-22.6-22.6-82.7-82.7L192 128l22.6-22.6 82.7-82.7L320 0l22.6 22.6 82.7 82.7L448 128l-22.6 22.6-82.7 82.7L320 256zm0-210.7L237.3 128 320 210.7 402.7 128 320 45.3zM112 64h16V80 265.4l36.7-36.7L176 217.4l11.3 11.3L320 361.4 452.7 228.7 464 217.4l11.3 11.3L512 265.4V80 64h16 96 16V80 384v6.6l-4.7 4.7-104 104L520 510.6 497.4 488l11.3-11.3L608 377.4V96H544V288v6.6l-1.4 1.4-3.3 3.3-8 8-72 72L448 390.6l-4.7 4.7L432 406.6 409.4 384l11.3-11.3 4.7-4.7 11.3-11.3L497.4 296 464 262.6l-128 128V496v16H304V496 390.6l-128-128L142.6 296l60.7 60.7 0 0 16 16L230.6 384 208 406.6l-11.3-11.3-16-16 0 0-72-72-8-8L97.4 296 96 294.6V288 96H32V377.4l99.3 99.3L142.6 488 120 510.6l-11.3-11.3-104-104L0 390.6V384 80 64H16h96z'
      
    ]
  };

  
    var faHandReceiving = faHandsHoldingDiamond;
  

  
  

  var faTransporter2 = {
    prefix: 'fasl',
    iconName: 'transporter-2',
    icon: [
      512,
      512,
      [],
      'e044',
      
      'M64 16V32H80 96V64H80 64V80 96H32V80 64H16 0V32H16 32V16 0H64V16zM480 336v16h16 16v32H496 480v16 16H448V400 384H432 416V352h16 16V336 320h32v16zM256 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM96 464V448h16H400h16v16 32 16H384V496 480H128v16 16H96V496 464zM383.7 224H343.5L320 193v31H288V176H224v48H192V193l-23.5 31H128.3l55.9-73.7L189 144h7.9H315.1 323l4.8 6.3L383.7 224zM96 256h16H400h16v32H400 112 96V256zm64 64h16H336h16v32H336 176 160V320zm0 64h16H336h16v32H336 176 160V384z'
      
    ]
  };

  

  
  

  var faPersonCircleExclamation = {
    prefix: 'fasl',
    iconName: 'person-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e53f',
      
      'M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM99.3 128h9.6H211.1h9.6l4.5 8.5 66.7 124.9c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496v16H192V496 352H128V496v16H96V496 202.1L46.1 295.5l-7.5 14.1L10.3 294.6l7.5-14.1 76.9-144 4.5-8.5zM128 320h64V160H128V320zm416 48a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 80H416V416h32v32zm0-160v16 80 16H416V384 304 288h32z'
      
    ]
  };

  

  
  

  var faSuitcaseRolling = {
    prefix: 'fasl',
    iconName: 'suitcase-rolling',
    icon: [
      384,
      512,
      [],
      'f5c1',
      
      'M112 0H96V16 128H32 0v32V448v32H32 64v16 16H96V496 480H288v16 16h32V496 480h32 32V448 160 128H352 288V16 0H272 112zM320 448H288 96 64 32V160h80H272h80V448H320zM256 128H128V32H256v96zM96 240v32h16H272h16V240H272 112 96zm0 96v32h16H272h16V336H272 112 96z'
      
    ]
  };

  

  
  

  var faDisplaySlash = {
    prefix: 'fasl',
    iconName: 'display-slash',
    icon: [
      640,
      512,
      ["desktop-slash"],
      'e2fa',
      
      'M32 110.3V384v32H64 245.1l-10.7 64H176 160v32h16 72H392h72 16V480H464 405.6l-10.7-64h24.3l-40.5-32h-2.4c-.2 0-.4 0-.6 0H264.3c-.2 0-.4 0-.6 0H64V135.6L32 110.3zM608 402V384 32 0H576 64 32V.2H99L139.4 32H576V376.7L608 402zM277.6 416h84.9l10.7 64H266.9l10.7-64zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  
    var faDesktopSlash = faDisplaySlash;
  

  
  

  var faCircleMicrophoneLines = {
    prefix: 'fasl',
    iconName: 'circle-microphone-lines',
    icon: [
      512,
      512,
      ["microphone-circle-alt"],
      'e117',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 96H192v16V256c0 35.3 28.7 64 64 64s64-28.7 64-64V224 192 160 112 96H304 208zm80 64H272 256v32h16 16v32H272 256v32h16 16c0 17.7-14.3 32-32 32s-32-14.3-32-32V128h64v32zM160 240V224H128v16 16c0 65.3 48.9 119.1 112 127v17 16h32V400 383c63.1-7.9 112-61.7 112-127V240 224H352v16 16c0 53-43 96-96 96s-96-43-96-96V240z'
      
    ]
  };

  
    var faMicrophoneCircleAlt = faCircleMicrophoneLines;
  

  
  

  var faSquarePen = {
    prefix: 'fasl',
    iconName: 'square-pen',
    icon: [
      448,
      512,
      ["pen-square","pencil-square"],
      'f14b',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM289.3 149.3L266.5 172 308 213.5l22.8-22.8-41.5-41.5zM134 304.5l-7.7 49.1 49.1-7.7L285.4 236.1l-41.5-41.5L134 304.5zM353.4 168.1L376 190.7l-22.6 22.6L190.7 376l-69.5 10.8L88 392l5.2-33.2L104 289.3 289.3 104l64.1 64.1z'
      
    ]
  };

  
    var faPenSquare = faSquarePen;
  
    var faPencilSquare = faSquarePen;
  

  
  

  var faTablePicnic = {
    prefix: 'fasl',
    iconName: 'table-picnic',
    icon: [
      512,
      512,
      [],
      'e32d',
      
      'M64 64H80 432h16V96H432 343.4l49.8 128H496h16v32H496 405.6 371.3 140.7 106.4 16 0V224H16 118.8L168.6 96H80 64V64zm89.2 160H358.8L309.1 96H202.9L153.2 224zm264.9 64l62.2 160H445.9L383.7 288h34.3zm-289.8 0L66.1 448H31.7L93.9 288h34.3z'
      
    ]
  };

  

  
  

  var faReceipt = {
    prefix: 'fasl',
    iconName: 'receipt',
    icon: [
      384,
      512,
      [129534],
      'f543',
      
      'M87.9 452.2l-14.1-8L59 450.8l-27 12V49.2l27 12 14.8 6.6 14.1-8L129 36.3l48.7 24.3L192 67.8l14.3-7.2L255 36.3l41.1 23.5 14.1 8L325 61.2l27-12V462.8l-27-12-14.8-6.6-14.1 8L255 475.7l-48.7-24.3L192 444.2l-14.3 7.2L129 475.7 87.9 452.2zM0 512l32-14.2L72 480l56 32 64-32 64 32 56-32 40 17.8L384 512V477 35 0L352 14.2 312 32 256 0 192 32 128 0 72 32 32 14.2 0 0V35 477v35zM96 144H80v32H96 288h16V144H288 96zM80 336v32H96 288h16V336H288 96 80zm16-96H80v32H96 288h16V240H288 96z'
      
    ]
  };

  

  
  

  var faFilePen = {
    prefix: 'fasl',
    iconName: 'file-pen',
    icon: [
      576,
      512,
      [128221,"file-edit"],
      'f31c',
      
      'M352 192V316.9l32-32V152L232 0H32 0V32 480v32H32 253.8l5-32H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zm142.3 64L304 409.1l-10.8 69.4L288 511.7l33.2-5.2 69.4-10.8L553.1 333.3l22.6-22.6 .1-.1L553.1 288l-63.8-63.8-.2-.2zM334 424.3L443.7 314.6 485.1 356 375.4 465.7l-49 7.6 7.6-49zM530.4 310.6l-22.7 22.7L466.4 292l22.7-22.7 41.4 41.4z'
      
    ]
  };

  
    var faFileEdit = faFilePen;
  

  
  

  var faWalkieTalkie = {
    prefix: 'fasl',
    iconName: 'walkie-talkie',
    icon: [
      384,
      512,
      [],
      'f8ef',
      
      'M96 16V0H64V16 96H16 0v16V312v6.6l4.7 4.7L32 350.6V496v16H48 336h16V496 350.6l27.3-27.3 4.7-4.7V312 112 96H368 96V16zM64 128H96 352V305.4l-27.3 27.3-4.7 4.7V344 480H64V344v-6.6l-4.7-4.7L32 305.4V128H64zM176 48H160V80h16 32 16V48H208 176zm96 0H256V80h16 32 16V48H304 272zM96 176v32h16H272h16V176H272 112 96zm0 64v32h16H272h16V240H272 112 96zm0 64v32h16H272h16V304H272 112 96z'
      
    ]
  };

  

  
  

  var faWand = {
    prefix: 'fasl',
    iconName: 'wand',
    icon: [
      512,
      512,
      [],
      'f72a',
      
      'M376 160h14.3H416V127.5 115.3l8.2-9.1 43.8-49L454.8 44 191.2 279.8l-9.1 8.2H169.9 128v34.1 14.3L117.3 346 46.5 409.3l56.2 56.2L366.5 170.7 376 160zM125.4 488.1L104 512 81.3 489.3 22.7 430.7 0 408l23.9-21.4L96 322.1V288 256h32 41.9L456 0l56 56-64 71.5V160v32H416 390.3L125.4 488.1z'
      
    ]
  };

  

  
  

  var faCartArrowDown = {
    prefix: 'fasl',
    iconName: 'cart-arrow-down',
    icon: [
      576,
      512,
      [],
      'f218',
      
      'M0 0H16 80 92.8l2.8 12.5L151 256H476L541.9 32h33.4L503.4 276.5 500 288H488 158.2l14.5 64H496h16v32H496 160 147.2l-2.8-12.5L67.2 32H16 0V0zM184 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm296 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM336 16l0 137.4 36.7-36.7L384 105.4 406.6 128l-11.3 11.3-64 64L320 214.6l-11.3-11.3-64-64L233.4 128 256 105.4l11.3 11.3L304 153.4 304 16V0h32V16z'
      
    ]
  };

  

  
  

  var faColon = {
    prefix: 'fasl',
    iconName: 'colon',
    icon: [
      192,
      512,
      [],
      '3a',
      
      'M64 96v64h64V96H64zM32 64H64h64 32V96v64 32H128 64 32V160 96 64zM64 352v64h64V352H64zM32 320H64h64 32v32 64 32H128 64 32V416 352 320z'
      
    ]
  };

  

  
  

  var faCartFlatbedEmpty = {
    prefix: 'fasl',
    iconName: 'cart-flatbed-empty',
    icon: [
      640,
      512,
      ["dolly-flatbed-empty"],
      'f476',
      
      'M0 0H16h96 16V16 384h96H512 624h16v32H624 567.4c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H279.4c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H112 96V400 32H16 0V0zM512 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  
    var faDollyFlatbedEmpty = faCartFlatbedEmpty;
  

  
  

  var faLobster = {
    prefix: 'fasl',
    iconName: 'lobster',
    icon: [
      512,
      512,
      [129438],
      'e421',
      
      'M59.6 36.6C43.3 44.2 32 60.8 32 80l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48 0-16 32 0 0 16 0 48c0 16.7-6.4 31.9-16.9 43.3L149.3 200l26.7 0c0-25.6 14.7-48.9 32-67.2l0-79.2-34.6-5.8-15.8-2.6 5.3-31.6 15.8 2.6 48 8L240 26.4 240 40l0 65.6c6.3-4.3 11.8-7.6 16-9.6c4.2 2.1 9.7 5.3 16 9.6L272 40l0-13.6 13.4-2.2 48-8 15.8-2.6 5.3 31.6-15.8 2.6L304 53.6l0 79.2c17.3 18.3 32 41.6 32 67.2l26.7 0 38.2-28.7C390.4 159.9 384 144.7 384 128l0-48 0-16 32 0 0 16 0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48c0-19.2-11.3-35.8-27.6-43.4l11.3 56.3 3.1 15.7-31.4 6.3-3.1-15.7-16-80L412.5 0 432 0c44.2 0 80 35.8 80 80l0 48c0 35.3-28.7 64-64 64c-6.2 0-12.2-.9-17.9-2.5l-52.5 39.3-4.3 3.2-5.3 0-32 0 0 24 44.2 0 44.6-22.3 14.3-7.2 14.3 28.6-14.3 7.2-48 24-3.4 1.7-3.8 0-48 0 0 16 61.4 0 45.5-15.2 15.2-5.1 10.1 30.4-15.2 5.1-48 16-2.5 .8-2.6 0-64 0 0 16 16 0 3.8 0 3.4 1.7 32 16 14.3 7.2-14.3 28.6-14.3-7.2L348.2 384 336 384s0 0 0 0l-18.5 51.7c19.8 7.1 35.1 23.7 40.5 44.3c1.3 5.1 2 10.5 2 16l0 16-32 0-144 0-32 0 0-16c0-5.5 .7-10.9 2-16c5.3-20.6 20.6-37.2 40.5-44.3L176 384s0 0 0 0l-12.2 0-28.6 14.3-14.3 7.2-14.3-28.6 14.3-7.2 32-16 3.4-1.7 3.8 0 16 0 0-16-64 0-2.6 0-2.5-.8-48-16-15.2-5.1 10.1-30.4 15.2 5.1L114.6 304l61.4 0 0-16-48 0-3.8 0-3.4-1.7-48-24-14.3-7.2 14.3-28.6 14.3 7.2L131.8 256l44.2 0 0-24-32 0-5.3 0-4.3-3.2L81.9 189.5C76.2 191.1 70.2 192 64 192c-35.3 0-64-28.7-64-64L0 80C0 35.8 35.8 0 80 0L99.5 0 95.7 19.1l-16 80-3.1 15.7-31.4-6.3 3.1-15.7L59.6 36.6zM208 256l0 32 0 9.9 48 6 48-6 0-9.9 0-32 0-24 0-32s0 0 0 0c0-13.5-8.1-29.3-23.2-45.2c-8.2-8.7-17.2-16-24.8-21.3c-7.6 5.4-16.6 12.7-24.8 21.3C216.1 170.7 208 186.5 208 200c0 0 0 0 0 0l0 32 0 24zm96 74.1l-46 5.8-2 .2-2-.2-46-5.8 0 5.9 0 9.9 48 6 48-6 0-9.9 0-5.9zm0 48l-46 5.8-2 .2-2-.2-46-5.8 0 .3 6.1 17.1 41.9 4.4 41.9-4.4 6.1-17.1 0-.3zm-18 50.8l-28.3 3-1.7 .2-1.7-.2-28.3-3 9.3 26.1-30.1 10.8c-7.2 2.6-13.2 7.6-17 14.2l135.4 0c-3.8-6.5-9.8-11.6-17-14.2l-30.1-10.8 9.3-26.1z'
      
    ]
  };

  

  
  

  var faBracketCurly = {
    prefix: 'fasl',
    iconName: 'bracket-curly',
    icon: [
      256,
      512,
      ["bracket-curly-left"],
      '7b',
      
      'M80 32H64V48 185.4L4.7 244.7 0 249.4v13.3l4.7 4.7L64 326.6V464v16H80 208h16V448H208 96V320v-6.6l-4.7-4.7L38.6 256l52.7-52.7 4.7-4.7V192 64H208h16V32H208 80z'
      
    ]
  };

  
    var faBracketCurlyLeft = faBracketCurly;
  

  
  

  var faTaxiBus = {
    prefix: 'fasl',
    iconName: 'taxi-bus',
    icon: [
      640,
      512,
      [],
      'e298',
      
      'M32 96V84.3C42.7 68.5 86.7 32 192 32s149.3 36.5 160 52.3V96h32V80 76.2l-1.7-3.4C367.8 43.8 310.2 0 192 0S16.2 43.8 1.7 72.8L0 76.2V80 400v16H16 32v48 16H64V464 416H224V384H32V256H192h32 51.8l9.1-32H208V128H336V96H192 32zm0 32H176v96H32V128zm72 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM496 160v16H400V160h96zm-128 0v16H344 331.9l-3.3 11.6L299.9 288H288 256v32 96 16 32 48h32V464H608v48h32V464 432 416 320 288H608 596.1L567.4 187.6 564.1 176H552 528V160 128H496 400 368v32zm128 48h32 11.9l22.9 80H333.2l22.9-80H368h32 96zM608 416v16H288V416 320h23.6c.2 0 .5 0 .7 0H583.6c.2 0 .5 0 .7 0H608v96zM360 376a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm200 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faPeach = {
    prefix: 'fasl',
    iconName: 'peach',
    icon: [
      512,
      512,
      [],
      'e20b',
      
      'M96 0H80V16 32c0 22.3 5.7 43.2 15.7 61.5c10.2-3.9 20.8-7.1 31.7-9.3C117.6 69.1 112 51.2 112 32h32c39.8 0 73.9 24.2 88.5 58.6c8.1 2.8 16 6 23.5 9.7c7.6-3.7 15.5-7 23.5-9.7C294.1 56.2 328.2 32 368 32h32c0 19.2-5.6 37.1-15.4 52.1c10.9 2.3 21.5 5.4 31.7 9.3C426.3 75.2 432 54.3 432 32V16 0H416 368c-48.2 0-90.2 26.6-112 66C234.2 26.6 192.2 0 144 0H96zM336 280c0-48-20.1-91.3-52.4-121.9c18.2-9 38.7-14.1 60.4-14.1c75.1 0 136 60.9 136 136c0 57.4-49.4 107.1-112.7 145.7c-30.1 18.4-60.5 32.4-83.5 41.9c-11.4 4.7-21 8.2-27.5 10.6l-.3 .1-.3-.1c-6.6-2.3-16.1-5.9-27.5-10.6c-23-9.5-53.4-23.5-83.5-41.9C81.4 387.1 32 337.4 32 280c0-75.1 60.9-136 136-136s136 60.9 136 136h32zM256 136.9c-25.6-15.8-55.7-24.9-88-24.9C75.2 112 0 187.2 0 280C0 432 256 512 256 512s256-80 256-232c0-92.8-75.2-168-168-168c-32.3 0-62.4 9.1-88 24.9z'
      
    ]
  };

  

  
  

  var faNairaSign = {
    prefix: 'fasl',
    iconName: 'naira-sign',
    icon: [
      448,
      512,
      [],
      'e1f6',
      
      'M80 32H64V48 256H16 0v32H16 64V464v16H96V464 288H226.1L349.4 472.9l4.7 7.1h8.6H368h16V464 288h48 16V256H432 384V48 32H352V48 256H243.2L98.6 39.1 93.9 32H85.3 80zM264.6 288H352V419.2L264.6 288zm-59.8-32H96V92.8L204.8 256z'
      
    ]
  };

  

  
  

  var faFloppyDiskCircleXmark = {
    prefix: 'fasl',
    iconName: 'floppy-disk-circle-xmark',
    icon: [
      576,
      512,
      ["floppy-disk-times","save-circle-xmark","save-times"],
      'e181',
      
      'M32 480H0V448 64 32H32 336L448 144v48.7c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7V157.3L322.7 64H320V176v16H304 80 64V176 64H32V448H275.2c5.9 11.4 12.9 22.2 21 32H32zM224 240c25.1 0 47.4 11.5 62.1 29.5c-6.9 10.2-12.8 21.2-17.4 32.8c-7-17.8-24.4-30.4-44.7-30.4c-26.5 0-48 21.5-48 48s21.5 48 48 48c12.5 0 23.9-4.8 32.4-12.6c-.3 4.2-.4 8.4-.4 12.6c0 8.3 .6 16.5 1.7 24.6C247.5 397.3 236 400 224 400c-44.2 0-80-35.8-80-80s35.8-80 80-80zM96 64v96H288V64H96zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-36.7L454.6 368l36.7 36.7L502.6 416 480 438.6l-11.3-11.3L432 390.6l-36.7 36.7L384 438.6 361.4 416l11.3-11.3L409.4 368l-36.7-36.7L361.4 320 384 297.4l11.3 11.3L432 345.4l36.7-36.7L480 297.4 502.6 320l-11.3 11.3z'
      
    ]
  };

  
    var faFloppyDiskTimes = faFloppyDiskCircleXmark;
  
    var faSaveCircleXmark = faFloppyDiskCircleXmark;
  
    var faSaveTimes = faFloppyDiskCircleXmark;
  

  
  

  var faLocationQuestion = {
    prefix: 'fasl',
    iconName: 'location-question',
    icon: [
      384,
      512,
      ["map-marker-question"],
      'f60b',
      
      'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 20.2 9.1 48.6 26.5 82.7c16.9 33.2 39.9 68.2 63.4 100.5c23.4 32.2 46.9 61 64.5 81.9c1.9 2.3 3.8 4.5 5.6 6.6c1.8-2.1 3.6-4.3 5.6-6.6c17.7-20.8 41.1-49.7 64.5-81.9c23.5-32.3 46.4-67.3 63.4-100.5C342.9 240.6 352 212.2 352 192zm32 0c0 88.8-120.7 237.9-170.7 295.9C200.2 503.1 192 512 192 512s-8.2-8.9-21.3-24.1C120.7 429.9 0 280.8 0 192C0 86 86 0 192 0S384 86 384 192zM104 152c0-30.9 25.1-56 56-56h56c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L208 236.3V240v16H176V240 226.5v-9.8l8.7-4.5 45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H160c-13.3 0-24 10.7-24 24v8H104v-8zm64 136h48v48H168V288z'
      
    ]
  };

  
    var faMapMarkerQuestion = faLocationQuestion;
  

  
  

  var faSignalGood = {
    prefix: 'fasl',
    iconName: 'signal-good',
    icon: [
      640,
      512,
      ["signal-3"],
      'f68e',
      
      'M336 208V192H304v16V496v16h32V496 208zM208 288H176v16V496v16h32V496 304 288zM80 384H48v16 96 16H80V496 400 384z'
      
    ]
  };

  
    var faSignal3 = faSignalGood;
  

  
  

  var faTrashCanArrowUp = {
    prefix: 'fasl',
    iconName: 'trash-can-arrow-up',
    icon: [
      448,
      512,
      ["trash-restore-alt"],
      'f82a',
      
      'M160 0h-8.9l-4.7 7.5L111.1 64H64 32 0V96H32V480v32H64 384h32V480 96h32V64H416 384 336.9L301.6 7.5 296.9 0H288 160zM299.1 64H148.9l20-32H279.1l20 32zM64 480V96H384V480H64zM224 169.4l-11.3 11.3-80 80L121.4 272 144 294.6l11.3-11.3L208 230.6V408h32V230.6l52.7 52.7L304 294.6 326.6 272l-11.3-11.3-80-80L224 169.4z'
      
    ]
  };

  
    var faTrashRestoreAlt = faTrashCanArrowUp;
  

  
  

  var faChevronsDown = {
    prefix: 'fasl',
    iconName: 'chevrons-down',
    icon: [
      512,
      512,
      ["chevron-double-down"],
      'f322',
      
      'M244.7 267.3L256 278.6l11.3-11.3 192-192L470.6 64 448 41.4 436.7 52.7 256 233.4 75.3 52.7 64 41.4 41.4 64 52.7 75.3l192 192zm0 192L256 470.6l11.3-11.3 192-192L470.6 256 448 233.4l-11.3 11.3L256 425.4 75.3 244.7 64 233.4 41.4 256l11.3 11.3 192 192z'
      
    ]
  };

  
    var faChevronDoubleDown = faChevronsDown;
  

  
  

  var faPersonDotsFromLine = {
    prefix: 'fasl',
    iconName: 'person-dots-from-line',
    icon: [
      576,
      512,
      ["diagnoses"],
      'f470',
      
      'M344 88A56 56 0 1 0 232 88a56 56 0 1 0 112 0zM200 88a88 88 0 1 1 176 0A88 88 0 1 1 200 88zM64 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM0 480H16 560h16v32H560 16 0V480zM320 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM448 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-80 32H208V448H176V255.1l-117.2 63-14.1 7.6L29.5 297.5l14.1-7.6 148.8-80L196 208h4H376h4l3.5 1.9 148.8 80 14.1 7.6-15.2 28.2-14.1-7.6L400 255.1V448H368V240z'
      
    ]
  };

  
    var faDiagnoses = faPersonDotsFromLine;
  

  
  

  var faTableTennisPaddleBall = {
    prefix: 'fasl',
    iconName: 'table-tennis-paddle-ball',
    icon: [
      512,
      512,
      [127955,"ping-pong-paddle-ball","table-tennis"],
      'f45d',
      
      'M240 480l-44.7-44.7-22.6-22.6-21.8 23.4-49 52.5L80 512 57.4 489.4 22.6 454.6 0 432l23.4-21.8 52.5-49 23.4-21.8L76.7 316.7 32 272l0-108.8 97.6-97.6c87.5-87.5 229.3-87.5 316.8 0c67.1 67.1 82.7 166.3 46.8 248.3c-8.5-6.5-17.9-11.9-27.9-16.1c29-69.7 15.1-152.9-41.5-209.6c-75-75-196.5-75-271.5 0L99.5 140.9 307.2 348.6c-6 9.6-10.7 20.1-14 31.3L76.9 163.5 64 176.5v82.3l57.9 57.9 23.4 23.4-24.2 22.6L46 432.8 79.2 466l70.1-75.1 22.6-24.2 23.4 23.4L253.3 448H292c2.9 11.4 7.4 22.1 13.1 32H240zm240-64a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  
    var faPingPongPaddleBall = faTableTennisPaddleBall;
  
    var faTableTennis = faTableTennisPaddleBall;
  

  
  

  var faMagnifyingGlass = {
    prefix: 'fasl',
    iconName: 'magnifying-glass',
    icon: [
      512,
      512,
      [128269,"search"],
      'f002',
      
      'M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L510.5 487.9l-22.6 22.6L343.3 366z'
      
    ]
  };

  
    var faSearch = faMagnifyingGlass;
  

  
  

  var faRupiahSign = {
    prefix: 'fasl',
    iconName: 'rupiah-sign',
    icon: [
      512,
      512,
      [],
      'e23d',
      
      'M0 32H16h96c79.5 0 144 64.5 144 144c0 65.2-43.4 120.3-102.9 138l53.1 166H172.6L121.3 319.7c-3.1 .2-6.2 .3-9.3 .3H32V480H0V304 48 32zM224 176c0-61.9-50.1-112-112-112H32V288h80c8.3 0 16.4-.9 24.2-2.6l7.1-2.3 .1 .4C190 270 224 227 224 176zm80-16h96c61.9 0 112 50.1 112 112s-50.1 112-112 112H320V496v16H288V496 176 160h16zm96 192c44.2 0 80-35.8 80-80s-35.8-80-80-80H320V352h80z'
      
    ]
  };

  

  
  

  var faTableCellsRowLock = {
    prefix: 'fasl',
    iconName: 'table-cells-row-lock',
    icon: [
      640,
      512,
      [],
      'e67a',
      
      'M32 64l0 96 448 0 0-96L32 64zm0 128l0 128 128 0 0-128L32 192zm0 160l0 96 128 0 0-96L32 352zm160 96l128 0 0-96-128 0 0 96zm160 0l32 0 0 32L32 480 0 480l0-32L0 64 0 32l32 0 448 0 32 0 0 32 0 97.1c-24.1 3.5-45.8 14.6-62.4 30.9L352 192l0 128 32 0 0 32-32 0 0 96zM192 320l128 0 0-128-128 0 0 128zm336-96c-26.5 0-48 21.5-48 48l0 48 96 0 0-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 32 0 128 0 32-32 0-160 0-32 0 0-32 0-128 0-32 32 0 0-48zm0 80l0 128 160 0 0-128-160 0z'
      
    ]
  };

  

  
  

  var faBurgerLettuce = {
    prefix: 'fasl',
    iconName: 'burger-lettuce',
    icon: [
      512,
      512,
      [],
      'e3e3',
      
      'M256 32c112.8 0 206.2 83.4 221.7 192c1.5 10.5 2.3 21.1 2.3 32H448 64 32c0-10.9 .8-21.5 2.3-32C49.8 115.4 143.2 32 256 32zm0 32C160.9 64 81.9 133.2 66.7 224H445.3C430.1 133.2 351.1 64 256 64zM64 448H448V384H64v64zM32 352H64 448h32v32 64 32H448 64 32V448 384 352zM144 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM256 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM173.5 273L256 303l82.5-30 5.5-2 5.5 2 82.4 30L490.4 281l11.2 30-64 24-5.5 2.1-5.6-2L344 305l-82.5 30-5.5 2-5.5-2L168 305 85.5 335l-5.6 2L74.4 335l-64-24 11.2-30 58.5 21.9 82.4-30 5.5-2 5.5 2z'
      
    ]
  };

  

  
  

  var faSquareDownLeft = {
    prefix: 'fasl',
    iconName: 'square-down-left',
    icon: [
      448,
      512,
      [],
      'e26b',
      
      'M32 448V64H416V448H32zM0 480H32 416h32V448 64 32H416 32 0V64 448v32zM128 368H288h6.6l4.7-4.7 16-16L326.6 336l-11.3-11.3L274.6 284l64.7-64.7L350.6 208l-11.3-11.3-56-56L272 129.4l-11.3 11.3L196 205.4l-40.7-40.7L144 153.4l-11.3 11.3-16 16-4.7 4.7V192 352v16h16zm16-169.4l40.7 40.7L196 250.6l11.3-11.3L272 174.6 305.4 208l-64.7 64.7L229.4 284l11.3 11.3L281.4 336H144V198.6z'
      
    ]
  };

  

  
  

  var faCupTogo = {
    prefix: 'fasl',
    iconName: 'cup-togo',
    icon: [
      448,
      512,
      ["coffee-togo"],
      'f6c5',
      
      'M80 0H368h11.5l3.6 10.9L411.5 96H432h16v32H432 400.4c-.2 0-.5 0-.7 0H48.4c-.2 0-.5 0-.7 0H16 0V96H16 36.5L64.8 10.9 68.5 0H80zM377.8 96L356.5 32H91.5L70.2 96H377.8zM80 512L47.4 160H79.5l5.9 64H362.5l5.9-64h32.1L368 512H80zM359.6 256H88.4l11.9 128H347.7l11.9-128zM344.8 416H103.2l5.9 64H338.8l5.9-64z'
      
    ]
  };

  
    var faCoffeeTogo = faCupTogo;
  

  
  

  var faFont = {
    prefix: 'fasl',
    iconName: 'font',
    icon: [
      448,
      512,
      [],
      'f031',
      
      'M209.3 41.8l4.1-9.8h21.2l4.1 9.8L410.6 448H432h16v32H432 352 336V448h16 23.9l-40.6-96H112.8L72.1 448H96h16v32H96 16 0V448H16 37.4L209.3 41.8zM126.3 320H321.7L224 89.1 126.3 320z'
      
    ]
  };

  

  
  

  var faPlay = {
    prefix: 'fasl',
    iconName: 'play',
    icon: [
      384,
      512,
      [9654],
      'f04b',
      
      'M32 461.3L0 480V443 69 32L32 50.7 352.2 237.5 384 256l-31.8 18.5L32 461.3zM320.5 256L32 87.7V424.3L320.5 256z'
      
    ]
  };

  

  
  

  var faTreeCity = {
    prefix: 'fasl',
    iconName: 'tree-city',
    icon: [
      640,
      512,
      [],
      'e587',
      
      'M288 0h16H496h16V16 192h32V112 96h32v16 80h48 16v16V496v16H608V496 224H576 544 496 480V208 32H320V496v16H288V496 16 0zm80 64h64 16V80v64 16H432 368 352V144 80 64h16zm16 64h32V96H384v32zm96 128h16 64 16v16 64 16H560 496 480V336 272 256zm32 32v32h32V288H512zm-16 96h64 16v16 64 16H560 496 480V464 400 384h16zm16 64h32V416H512v32zM352 192h16 64 16v16 64 16H432 368 352V272 208 192zm32 64h32V224H384v32zm-16 64h64 16v16 64 16H432 368 352V400 336 320h16zm16 64h32V352H384v32zM188.1 189.5l3.1-19.4c.5-3.3 .8-6.7 .8-10.1c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 3.5 .3 6.8 .8 10.1l3.1 19.4L51.9 201.1C39.8 209.8 32 224 32 240v48h80V240 224h32v16 48h80V240c0-16-7.8-30.2-19.9-38.9l-15.9-11.5zM256 288v32H224 144V496v16H112V496 320H32 0V288 240c0-26.7 13.1-50.3 33.2-64.9c-.8-4.9-1.2-10-1.2-15.1c0-53 43-96 96-96s96 43 96 96c0 5.1-.4 10.2-1.2 15.1C242.9 189.7 256 213.3 256 240v48z'
      
    ]
  };

  

  
  

  var faFileMinus = {
    prefix: 'fasl',
    iconName: 'file-minus',
    icon: [
      384,
      512,
      [],
      'f318',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM96 320H80v32H96 288h16V320H288 96z'
      
    ]
  };

  

  
  

  var faEarListen = {
    prefix: 'fasl',
    iconName: 'ear-listen',
    icon: [
      512,
      512,
      ["assistive-listening-systems"],
      'f2a2',
      
      'M480 240v16h32V240C512 137.6 455.4 48.4 371.8 2L356.3 30C430.1 71 480 149.7 480 240zM96 240c0-79.5 64.5-144 144-144s144 64.5 144 144c0 47.1-22.6 88.9-57.6 115.2L320 360v8 16c0 53-43 96-96 96H208 192v32h16 16c70.7 0 128-57.3 128-128v-8.2c39.1-32.3 64-81.1 64-135.8c0-97.2-78.8-176-176-176S64 142.8 64 240v16H96V240zm64 136a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 504a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM64 361.4L41.4 384l11.3 11.3 64 64L128 470.6 150.6 448l-11.3-11.3-64-64L64 361.4zM160 240c0-44.2 35.8-80 80-80s80 35.8 80 80v16h32V240c0-61.9-50.1-112-112-112s-112 50.1-112 112v16h32V240z'
      
    ]
  };

  
    var faAssistiveListeningSystems = faEarListen;
  

  
  

  var faLink = {
    prefix: 'fasl',
    iconName: 'link',
    icon: [
      640,
      512,
      [128279,"chain"],
      'f0c1',
      
      'M48.5 256c-50 50-50 131 0 181s131 50 181 0l22.6-22.6-22.6-22.6-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8L195.7 154.1c37.4-37.4 98.1-37.4 135.6 0c35.6 35.6 37.6 92.6 4.7 130.6l-5.3 6.1 24.2 21 5.3-6.1c43.9-50.7 41.2-126.7-6.2-174.1C303.9 81.5 223 81.5 173 131.4L48.5 256zm543.1 0c50-50 50-131 0-181s-131-50-181 0L387.9 97.6l22.6 22.6 22.6-22.6c37.5-37.5 98.3-37.5 135.8 0s37.5 98.3 0 135.8L444.3 357.9c-37.4 37.4-98.1 37.4-135.6 0c-35.6-35.6-37.6-92.6-4.7-130.6l5.3-6.1-24.2-21-5.3 6.1c-43.9 50.7-41.2 126.7 6.2 174.1c49.9 49.9 130.9 49.9 180.8 0L591.5 256z'
      
    ]
  };

  
    var faChain = faLink;
  

  
  

  var faBallotCheck = {
    prefix: 'fasl',
    iconName: 'ballot-check',
    icon: [
      448,
      512,
      [],
      'f733',
      
      'M416 32V480H32V32H416zM32 0H0V32 480v32H32 416h32V480 32 0H416 32zM160 112v32h16H352h16V112H352 176 160zm48 128v32h16H352h16V240H352 224 208zM160 368v32h16H352h16V368H352 176 160zM120 104H72v48h48V104zM72 360v48h48V360H72zm91.3-116.7L174.6 232 152 209.4l-11.3 11.3L104 257.4 91.3 244.7 80 233.4 57.4 256l11.3 11.3 24 24L104 302.6l11.3-11.3 48-48z'
      
    ]
  };

  

  
  

  var faGrillHot = {
    prefix: 'fasl',
    iconName: 'grill-hot',
    icon: [
      448,
      512,
      [],
      'e5a5',
      
      'M128 0H96V16v4c0 17.6 8.3 34.2 22.4 44.8l32 24c6 4.5 9.6 11.6 9.6 19.2v4 16h32V112v-4c0-17.6-8.3-34.2-22.4-44.8l-32-24c-6-4.5-9.6-11.6-9.6-19.2V16 0zM448 160H416 32 0c0 10.9 .8 21.5 2.3 32C12.9 266 59.6 328.3 124 360.5l-11.6 25.6c-5.2-1.4-10.7-2.1-16.4-2.1c-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48H338.8l22.8 47 28.8-14L324.1 360.4c64.3-32.2 111-94.5 121.6-168.4c1.5-10.5 2.3-21.1 2.3-32zM140.4 401.9l13.3-29.2C175.7 380 199.4 384 224 384c24.6 0 48.3-4 70.5-11.3L323.3 432H158c-3-11.7-9.2-22-17.6-30.1zM34.7 192H413.3C398.1 282.8 319.1 352 224 352s-174.1-69.2-189.3-160zM64 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 16V0H192V16v4c0 17.6 8.3 34.2 22.4 44.8l32 24c6 4.5 9.6 11.6 9.6 19.2v4 16h32V112v-4c0-17.6-8.3-34.2-22.4-44.8l-32-24c-6-4.5-9.6-11.6-9.6-19.2V16z'
      
    ]
  };

  

  
  

  var faLandmarkMagnifyingGlass = {
    prefix: 'fasl',
    iconName: 'landmark-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e622',
      
      'M448 288c-11 0-21.7-1.1-32-3.2V352H336V242.3c-5.8-5.7-11.1-11.8-16-18.3H304V352H208V224H176V352H96V224H64V352H48v32H64 448h16V352H448V288zM256 0L0 144v16 32H32 301.3c-4.4-10.2-7.9-20.9-10.1-32H36.8L256 36.7l46 25.8c4.4-9.8 9.8-19.1 16-27.7L256 0zM24 448H40 472h16V416H472 40 24v32zM0 480v32H16 496h16V480H496 16 0zM448 32.1a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224c29.6 0 56.8-10 78.5-26.9L604.7 307l11.3 11.3 22.6-22.7-11.3-11.3-78.1-77.7C566 184.9 576 157.7 576 128.2c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z'
      
    ]
  };

  

  
  

  var faBoxesStacked = {
    prefix: 'fasl',
    iconName: 'boxes-stacked',
    icon: [
      576,
      512,
      [62625,"boxes","boxes-alt"],
      'f468',
      
      'M416 32V192h32V32 0H416 352 320 256 224 160 128V32 192h32V32h64V96v32h32 64 32V96 32h64zM256 32h64V96H256V32zm96 480H544h32V480 256 224H544 480 448 384 352l0 128h32 64 32V320 256h64V480H352v32zm32-256h64v64H384V256zM288 480H32V256H96v64 32h32 64 32V320 256h64V480zM128 320V256h64v64H128zm160-96H224 192 128 96 32 0v32V480v32H32 288h32V480 256 224H288z'
      
    ]
  };

  
    var faBoxes = faBoxesStacked;
  
    var faBoxesAlt = faBoxesStacked;
  

  
  

  var faTimer = {
    prefix: 'fasl',
    iconName: 'timer',
    icon: [
      512,
      512,
      [],
      'e29e',
      
      'M256 0H240V16v96 16h32V112 32.6C388.2 40.8 480 137.7 480 256c0 123.7-100.3 224-224 224S32 379.7 32 256c0-61.9 25.1-117.8 65.6-158.4L75 75C28.7 121.3 0 185.3 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM171.3 148.7L160 137.4 137.4 160l11.3 11.3 96 96L256 278.6 278.6 256l-11.3-11.3-96-96z'
      
    ]
  };

  

  
  

  var faSpeaker = {
    prefix: 'fasl',
    iconName: 'speaker',
    icon: [
      384,
      512,
      [],
      'f8df',
      
      'M32 32V480H352V32H32zM0 0H32 352h32V32 480v32H352 32 0V480 32 0zM272 336a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM80 336a112 112 0 1 1 224 0A112 112 0 1 1 80 336zm88 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm56-208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faCarBus = {
    prefix: 'fasl',
    iconName: 'car-bus',
    icon: [
      640,
      512,
      [],
      'f85a',
      
      'M32 96H192 352V84.3C341.3 68.5 297.3 32 192 32S42.7 68.5 32 84.3V96zm0 32v96H176V128H32zm0 128V384H224v32H64v48 16H32V464 416H16 0V400 80 76.2l1.7-3.4C16.2 43.8 73.8 0 192 0S367.8 43.8 382.3 72.8l1.7 3.4V80v64H352V128H208v96h76.9l-9.1 32H224 192 32zm72 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM331.9 176H344 552h12.1l3.3 11.6L596.1 288H608h32v32 96 16 32 48H608V464H288v48H256V464 432 416 320 288h32 11.9l28.7-100.4 3.3-11.6zM608 320H584.4c-.2 0-.5 0-.7 0H312.4c-.2 0-.5 0-.7 0H288v96 16H608V416 320zM539.9 208H356.1l-22.9 80H562.8l-22.9-80zM336 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm200 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faStarHalf = {
    prefix: 'fasl',
    iconName: 'star-half',
    icon: [
      576,
      512,
      [61731],
      'f089',
      
      'M148.1 328.5L127 474.9 121.7 512l34.5-14.8 155.9-67V57.3 0l-32 47.5L201.6 164 57.1 189l-38.2 6.6 27 27.8L148.1 328.5zm-64-111.7L207 195.5l13.5-2.3 7.6-11.3 52-77.1V409.1L161.5 460.1l18.3-127 2.2-15.6-11-11.3L84.1 216.8z'
      
    ]
  };

  

  
  

  var faMoneyFromBracket = {
    prefix: 'fasl',
    iconName: 'money-from-bracket',
    icon: [
      640,
      512,
      [],
      'e312',
      
      'M0 0H16 624h16V16 176v16H608V176 32H32V176v16H0V176 16 0zM512 96v16l0 384v16H496l-352 0H128V496l0-384V96h32v16l0 272c53 0 96 43 96 96H384c0-53 43-96 96-96V112 96h32zM224 480c0-35.3-28.7-64-64-64l0 64h64zm256 0l0-64c-35.3 0-64 28.7-64 64h64zM320 208c-47 0-80 31.3-80 64s33 64 80 64s80-31.3 80-64s-33-64-80-64zm112 64c0 55.6-53 96-112 96s-112-40.4-112-96s53-96 112-96s112 40.4 112 96z'
      
    ]
  };

  

  
  

  var faCheckToSlot = {
    prefix: 'fasl',
    iconName: 'check-to-slot',
    icon: [
      576,
      512,
      ["vote-yea"],
      'f772',
      
      'M128 64V384H448V64H128zm352 0V384h16 16v32H496 480 448 128 96 80 64V384H80 96V64 32h32H448h32V64zM32 320H64v32H32v96H544V352H512V320h32 32v32 96 32H544 32 0V448 352 320H32zM379.3 174L272.6 280.6 261.3 292 250 280.6l-53.3-53.3L185.4 216 208 193.4l11.3 11.3 42 42 95.4-95.4L368 140l22.6 22.6L379.3 174z'
      
    ]
  };

  
    var faVoteYea = faCheckToSlot;
  

  
  

  var faCloudHail = {
    prefix: 'fasl',
    iconName: 'cloud-hail',
    icon: [
      512,
      512,
      [],
      'f739',
      
      'M384 160V128c0-35.3-28.7-64-64-64c-12.9 0-24.9 3.8-34.9 10.3L259.2 91.2 241.5 66C226.9 45.4 203 32 176 32c-44.2 0-80 35.8-80 80v21.5 22.6l-21.3 7.5C49.8 172.4 32 196.2 32 224v64H96 416h64V224c0-35.3-28.7-64-64-64H384zM32 320H0V288 224c0-41.8 26.7-77.4 64-90.5V112C64 50.1 114.1 0 176 0c37.9 0 71.3 18.8 91.6 47.5C282.7 37.7 300.7 32 320 32c53 0 96 43 96 96c53 0 96 43 96 96v64 32H480 416 96 32zm64 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM56 464a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168-72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-40 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168-72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-40 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faMeterFire = {
    prefix: 'fasl',
    iconName: 'meter-fire',
    icon: [
      640,
      512,
      [],
      'e1eb',
      
      'M256 32c75.9 0 142.9 37.7 183.5 95.4l13.2-8.2L493.4 160C455.4 66.2 363.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c33.5 0 65.5-6.4 94.8-18.1c-8.5-7.8-16.4-16.3-23.4-25.5C305 475.9 281 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32zM368 144V128H336v16 64 13.4c2.3-3.1 4.6-6.1 7-9.1c8-10.1 16.5-19.5 25-28.2V144zm-192 0V128H144v16 64 16h32V208 144zm96 0V128H240v16 64 16h32V208 144zm217.4 57.4L448 160c-42.7 26.7-128 102.4-128 192c0 85.2 66.6 154.9 150.7 159.7c3.1 .3 6.2 .4 9.3 .4s6.3-.1 9.3-.4C573.4 506.9 640 437.2 640 352c0-26.7-19.2-96-96-160l-9.4 9.4L512 224l-22.6-22.6zM480 480c-2.4 0-4.8-.1-7.2-.2c-33.6-3.3-56.8-29.4-56.8-57.3c0-21.9 15.9-47.5 39-71.3c8.8-9 17.6-16.9 25-23c7.4 6.1 16.2 13.9 25 23c23.1 23.8 39 49.5 39 71.3c0 27.8-23.2 54-56.8 57.3c-2.4 .1-4.8 .2-7.2 .2zm96-57.4c0-70.4-96-134.4-96-134.4s-96 64-96 134.4c0 5.4 .5 10.6 1.5 15.8C364.7 415.6 352 385.3 352 352c0-34.7 16.7-69.1 41-99.7c16.4-20.6 35.2-38 51.4-50.7l45 45L512 269.3l22.6-22.6L545 236.2C597 288.3 608 337.9 608 352c0 33.3-12.7 63.6-33.5 86.3c1-5.1 1.5-10.4 1.5-15.8z'
      
    ]
  };

  

  
  

  var faSquareE = {
    prefix: 'fasl',
    iconName: 'square-e',
    icon: [
      448,
      512,
      [],
      'e26d',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm144 96H304h16v32H304 160v80H272h16v32H272 160v80H304h16v32H304 144 128V368 256 144 128h16z'
      
    ]
  };

  

  
  

  var faHeadSideHeart = {
    prefix: 'fasl',
    iconName: 'head-side-heart',
    icon: [
      512,
      512,
      [],
      'e1aa',
      
      'M32 224C32 118 118 32 224 32h24c88.4 0 160 71.6 160 160v7.2l5.4 4.8L480 263.2V304H432 416v16 96H304 288v16 64 16h32V496 448H432h16V432 336h48 16V320 256v-7.2l-5.4-4.8-66.8-59.3C436 82 351.6 0 248 0H224C100.3 0 0 100.3 0 224c0 61 24.4 116.4 64 156.8V496v16H96V496 374.1v-6.8l-4.9-4.7C54.6 327.6 32 278.4 32 224zm184.3-78.8c-11.5-11-26.8-17.2-42.7-17.2h-2.4c-32.7 0-59.2 26.5-59.2 59.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L224 320.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2h-2.4c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4zm79.3 61.6L224 275.7l-71.7-68.9c-5.3-5.1-8.3-12.2-8.3-19.6c0-15 12.2-27.2 27.2-27.2h2.4c7.7 0 15 3 20.5 8.3l7.7 7.4L224 197l22.2-21.3 7.7-7.4c5.5-5.3 12.9-8.3 20.5-8.3h2.4c15 0 27.2 12.2 27.2 27.2c0 7.4-3 14.5-8.3 19.6z'
      
    ]
  };

  

  
  

  var faParagraph = {
    prefix: 'fasl',
    iconName: 'paragraph',
    icon: [
      448,
      512,
      [182],
      'f1dd',
      
      'M32 192c0-88.4 71.6-160 160-160h64H432h16V64H432 384l0 400v16H352V464l0-400H288V464v16H256V464l0-112H192c-88.4 0-160-71.6-160-160zM256 320V64H192C121.3 64 64 121.3 64 192s57.3 128 128 128h64z'
      
    ]
  };

  

  
  

  var faFax = {
    prefix: 'fasl',
    iconName: 'fax',
    icon: [
      512,
      512,
      [128224,128439],
      'f1ac',
      
      'M128 0h16H408h6.6l4.7 4.7 56 56 4.7 4.7V72v88H448V78.6L401.4 32H160v96 32 32H496h16v16V496v16H496 160 128 96 32 0V480 160 128H32h96V16 0zM480 224H160V480H480V224zm-352 0V208 160H32V480H96h32V224zM296 376v48H248V376h48zm-48-96h48v48H248V280zm144 0v48H344V280h48zm-48 96h48v48H344V376z'
      
    ]
  };

  

  
  

  var faDeerRudolph = {
    prefix: 'fasl',
    iconName: 'deer-rudolph',
    icon: [
      576,
      512,
      [],
      'f78f',
      
      'M256 0V16 40c0 13.3 10.7 24 24 24h8 8c13.3 0 24-10.7 24-24V16 0h32V16 40c0 8.6-1.9 16.7-5.4 24H408h6.6H416c13.3 0 24-10.7 24-24V16 0h32V16 40c0 22-12.7 41.1-31.2 50.2l35 35C483.1 108 500.2 96 520 96c26.5 0 48 21.5 48 48s-21.5 48-48 48c-2.7 0-5.4-.2-8-.7V224v16H496 403.9l-18.6 61.8c-.9 3-1.4 6.1-1.4 9.2V496v16H368 288 272V496 368H216h-4.8l-4-2.7-17.3-11.5 1.9 11.6 1.7 10.2-8.6 5.7L147 406.5l28.1 84.4 7 21.1H160 80 68.5l-3.6-10.9-32-96L31.1 400l1.7-5.1L48 349.4V326.6l-16-16V320v16H0V320 272c0-53 43-96 96-96h8 16H300.7l10-35.9-13.8 9.2-13.3 8.9-17.8-26.6 13.3-8.9 40-26.7H296h-8-8c-30.9 0-56-25.1-56-56V16 0h32zM356.2 96L328.3 196.3 325 208H312.9 120 104c-30.9 0-56 25.1-56 56v17.4l27.3 27.3 4.7 4.7V320v32 2.6l-.8 2.5L64.9 400l26.7 80h46.3l-25-74.9L109 393.5l10.2-6.8 39.4-26.3-6.3-37.8 24.7-15.9 44 29.3H288h16v16V480h48V311c0-6.2 .9-12.4 2.7-18.4l22-73.3 3.4-11.4H392h88V174.6L401.4 96H356.2zM400 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm136 16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faFishBones = {
    prefix: 'fasl',
    iconName: 'fish-bones',
    icon: [
      576,
      512,
      [],
      'e304',
      
      'M76.2 240l-38-101.5L96 177.1V138.7L32 96 0 128 48 256 0 384l32 32 64-42.7V334.9L38.1 373.5 76.2 272H144v80 16h32V352 272h64v80 16h32V352 272h64v80 16h32V352 272h48v96 32h32L576 256 448 112H416v32 96H368V160 144H336v16 80H272V160 144H240v16 80H176V160 144H144v16 80H76.2zM448 351.8V272 240 160.2L533.2 256 448 351.8z'
      
    ]
  };

  

  
  

  var faHeartCircleBolt = {
    prefix: 'fasl',
    iconName: 'heart-circle-bolt',
    icon: [
      576,
      512,
      [],
      'e4fc',
      
      'M256 141.3l-22.6-22.6L209.1 94.4C189.7 74.9 163.3 64 135.8 64C78.5 64 32 110.5 32 167.8c0 27.5 10.9 53.9 30.4 73.4l24.2 24.2L256 434.8l9.5-9.5c3.7 10.9 8.5 21.3 14.2 31.1l-1.1 1.1L256 480l-22.6-22.6L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8l1.6 1.6L256 96l22.6-22.6 1.6-1.6c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4c-9.6-4.5-19.7-8.1-30.2-10.7c2.9-9.5 4.3-19.5 4.3-29.7C480 110.5 433.5 64 376.2 64c-27.5 0-53.9 10.9-73.4 30.4l-24.2 24.2L256 141.3zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168-80l-10.7 64H512L408 448l10.7-64H352l104-96z'
      
    ]
  };

  

  
  

  var faIceCream = {
    prefix: 'fasl',
    iconName: 'ice-cream',
    icon: [
      448,
      512,
      [127848],
      'f810',
      
      'M224 0C139.7 0 70.6 65.2 64.4 147.9C36.2 157.7 16 184.5 16 216v56 16H32 64h69.5 181H384h32 16V272 216c0-31.5-20.2-58.3-48.4-68.1C377.4 65.2 308.3 0 224 0zM96 160v0C96 89.3 153.3 32 224 32s128 57.3 128 128l0 .5 0 13.9 13.8 2c19.4 2.8 34.3 19.5 34.3 39.6v40H384 314.5h-181H64 48V216c0-20.1 14.9-36.8 34.3-39.6l13.8-2 0-13.9 0-.5zM205 482.4L224 512l19-29.6L347.4 320h-38L224 452.8 138.6 320h-38L205 482.4z'
      
    ]
  };

  

  
  

  var faScrubber = {
    prefix: 'fasl',
    iconName: 'scrubber',
    icon: [
      512,
      512,
      [],
      'f2f8',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  

  
  

  var faDrum = {
    prefix: 'fasl',
    iconName: 'drum',
    icon: [
      512,
      512,
      [129345],
      'f569',
      
      'M380.6 139L248.5 221.6l-17-27.1L332 131.6c-23.5-2.4-49-3.6-76-3.6c-69 0-128.5 7.9-169.4 23.8C45.3 167.9 32 187.6 32 208c0 11.2 11.3 31.5 55.7 50.6C129 276.5 188.5 288 256 288s127-11.5 168.3-29.4C468.7 239.5 480 219.2 480 208c0-20.4-13.3-40.1-54.6-56.2c-13.1-5.1-28.2-9.4-44.8-12.8zm37.6-23.5C475.4 133 512 162.8 512 208V368c0 22.6-13.6 41.6-32.3 56.2c-18.8 14.7-44.9 26.8-75.1 35.9C362.8 472.7 311.3 480 256 480s-106.8-7.3-148.6-19.9C77.1 451 51.1 439 32.3 424.2C13.6 409.6 0 390.6 0 368V208C0 128 114.6 96 256 96c42.7 0 82.9 2.9 118.3 9.2L487.5 34.4l17 27.1-86.3 53.9zM32 263.2V368c0 8.8 5.3 19.5 20 31c10.8 8.5 25.6 16.5 44 23.5V296.1c-25.9-8.9-47.8-20.1-64-32.9zm96 42.3V432.7c32.3 8.5 70.5 14 112 15.1v-128c-40.6-1.1-78.7-6.1-112-14.3zm144 14.3v128c41.5-1.1 79.7-6.6 112-15.1l0-127.2c-33.3 8.2-71.4 13.3-112 14.3zm144-23.7l0 126.4c18.3-7 33.2-15 44-23.5c14.8-11.6 20-22.2 20-31V263.2c-16.2 12.8-38.1 24-64 32.9z'
      
    ]
  };

  

  
  

  var faKite = {
    prefix: 'fasl',
    iconName: 'kite',
    icon: [
      640,
      512,
      [129665],
      'f6f4',
      
      'M270.9 346.5L457.4 160 341.2 43.9 270.9 346.5zm-14.9 64.2l-5.2 1.2-95.4 95.4-4.7 4.7H144 96 80V496 316.3L24.2 349.7 0 364.3V336 240 211.7l24.2 14.5L80 259.7V160H16 0V128H16 96h16v16V259.7l55.8-33.5L192 211.7V240v96 28.3l-24.2-14.5L112 316.3V480h25.4L228 389.3l1.2-5.2 3.6-15.3 80-344L318.6 0H344 608h32V32 296v25.4l-24.8 5.8-344 80-15.3 3.6zM480 182.6L293.5 369.1l302.6-70.4L480 182.6zM502.6 160L608 265.4V54.6L502.6 160zM374.6 32L480 137.4 585.4 32H374.6zM32 268.3v39.5L64.9 288 32 268.3zm128 39.5V268.3L127.1 288 160 307.7z'
      
    ]
  };

  

  
  

  var faRectangleTerminal = {
    prefix: 'fasl',
    iconName: 'rectangle-terminal',
    icon: [
      512,
      512,
      [],
      'e236',
      
      'M480 64V448H32V64H480zM32 32H0V64 448v32H32 480h32V448 64 32H480 32zM89.4 160l11.3 11.3L185.4 256l-84.7 84.7L89.4 352 112 374.6l11.3-11.3 96-96L230.6 256l-11.3-11.3-96-96L112 137.4 89.4 160zM224 352H208v32h16H400h16V352H400 224z'
      
    ]
  };

  

  
  

  var faAngle90 = {
    prefix: 'fasl',
    iconName: 'angle-90',
    icon: [
      448,
      512,
      [],
      'e08d',
      
      'M32 48V32H0V48 464v16H16 432h16V448H432 32V48zM80 96.4v32c40 2.2 77.8 12.5 111.8 29.4l16.8-27.4c-39-19.8-82.5-31.8-128.6-34.1zm139.6 77.2c34.8 22.4 64.4 52 86.7 86.7l27.3-16.8c-25-39-58.2-72.2-97.2-97.2l-16.8 27.3zM351.6 400h32c-2.3-46.1-14.3-89.7-34.1-128.6l-27.4 16.8c16.9 34 27.2 71.8 29.4 111.8z'
      
    ]
  };

  

  
  

  var faPersonWalkingWithCane = {
    prefix: 'fasl',
    iconName: 'person-walking-with-cane',
    icon: [
      512,
      512,
      ["blind"],
      'f29d',
      
      'M184 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 184 0a56 56 0 1 0 0 112zm-72 32H101.1l-4 10.2-56 144-5.8 14.9 29.8 11.6 5.8-14.9L120 183.6V285.7c0 17 9 32.7 23.7 41.4L256 393.2V496v16h32V496 384v-9.2l-7.9-4.6L240 346.6V344 188.8l82.7 124 8.9 13.3 26.6-17.8-8.9-13.3-96-144-4.8-7.1H240 208 112zm40 141.7V176h56V327.8l-48.1-28.3c-4.9-2.9-7.9-8.1-7.9-13.8zM133.1 358l-42 154h33.2l37.4-137.2L133.1 358zM450.8 505.1l26.3-18.2L373.3 336.8l-26.6 17.8L450.8 505.1z'
      
    ]
  };

  
    var faBlind = faPersonWalkingWithCane;
  

  
  

  var faTransporterEmpty = {
    prefix: 'fasl',
    iconName: 'transporter-empty',
    icon: [
      512,
      512,
      [],
      'e046',
      
      'M96 448h16H400h16v16 32 16H384V496 480H128v16 16H96V496 464 448z'
      
    ]
  };

  

  
  

  var faHotdog = {
    prefix: 'fasl',
    iconName: 'hotdog',
    icon: [
      512,
      512,
      [127789],
      'f80f',
      
      'M454.7 244l12 12L256 466.7l-12-12-22.6 22.6 12 12L256 512l22.6-22.6L489.4 278.6 512 256l-22.6-22.6-12-12L454.7 244zM22.6 278.6l12 12L57.3 268l-12-12L256 45.3l12 12 22.6-22.6-12-12L256 0 233.4 22.6 22.6 233.4 0 256l22.6 22.6zM458.9 154.9l-304 304c-28.1 28.1-73.7 28.1-101.8 0S25 385.2 53.1 357.1l304-304c28.1-28.1 73.7-28.1 101.8 0s28.1 73.7 0 101.8zm22.6 22.6c40.6-40.6 40.6-106.5 0-147.1s-106.5-40.6-147.1 0l-304 304c-40.6 40.6-40.6 106.5 0 147.1s106.5 40.6 147.1 0l304-304zm-60.4-33.4l-13-29.2-14.6 6.5-72 32-4.9 2.2-2.6 4.7-37.6 67.7-59.6 29.8-4.4 2.2-2.4 4.3-37.8 68-68 37.8-14 7.8 15.5 28 14-7.8 72-40 4-2.2 2.2-4 37.6-67.7 59.6-29.8 4.4-2.2 2.4-4.3 37.4-67.3 67.1-29.8 14.6-6.5z'
      
    ]
  };

  

  
  

  var faEarMuffs = {
    prefix: 'fasl',
    iconName: 'ear-muffs',
    icon: [
      640,
      512,
      [],
      'f795',
      
      'M112 0h16H512h16V16 201.6c-9.8-5-20.6-8.2-32-9.2V32H144V192.4c-11.4 1-22.2 4.3-32 9.2V16 0zM496 224.6c9 1.3 17.2 4.7 24.3 9.7c5-1.5 10.3-2.2 15.7-2.2c19.9 0 37.5 10.4 47.4 26.1c23.4 6.7 40.6 28.3 40.6 53.9c0 5.1-.7 10.1-2 14.9c11.1 10.2 18 24.9 18 41.1s-6.9 30.9-18 41.1c1.3 4.7 2 9.7 2 14.9c0 25.6-17.2 47.2-40.6 53.9C573.5 493.6 555.9 504 536 504c-5.5 0-10.7-.8-15.7-2.2C511.2 508.2 500 512 488 512c-30.9 0-56-25.1-56-56c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-11.9 3.7-22.9 10-32c-6.3-9.1-10-20.1-10-32c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-30.9 25.1-56 56-56c2.7 0 5.4 .2 8 .6zM152 224c30.9 0 56 25.1 56 56c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 11.9-3.7 22.9-10 32c6.3 9.1 10 20.1 10 32c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 30.9-25.1 56-56 56c-12 0-23.2-3.8-32.3-10.2c-5 1.5-10.3 2.2-15.7 2.2c-20 0-37.5-10.4-47.4-26.1C33.2 471.2 16 449.6 16 424c0-5.1 .7-10.1 2-14.9C6.9 398.9 0 384.3 0 368s6.9-30.9 18-41.1c-1.3-4.7-2-9.7-2-14.9c0-25.6 17.2-47.2 40.6-53.9C66.5 242.4 84 232 104 232c5.5 0 10.7 .8 15.7 2.2c7.1-5 15.3-8.4 24.3-9.7c2.6-.4 5.3-.6 8-.6zm11.5 84l9.3-16c2-3.5 3.2-7.6 3.2-12c0-13.3-10.7-24-24-24c-5.2 0-9.9 1.6-13.8 4.4l-12.6 8.9L110.8 265c-2.1-.6-4.4-1-6.8-1c-8.5 0-16 4.4-20.3 11.2l-6.5 10.3-11.8 3.4C55.3 291.8 48 301.1 48 312c0 2.3 .3 4.4 .9 6.4L54 337.2 39.7 350.4C34.9 354.8 32 361 32 368s2.9 13.2 7.7 17.6L54 398.8l-5.2 18.8c-.5 2-.9 4.1-.9 6.4c0 10.9 7.3 20.2 17.4 23.1l11.8 3.4 6.5 10.3C88 467.6 95.5 472 104 472c2.4 0 4.6-.3 6.8-1l14.8-4.3 12.6 8.9c3.9 2.8 8.6 4.4 13.8 4.4c13.3 0 24-10.7 24-24c0-4.4-1.2-8.5-3.2-12l-9.3-16 9.3-16c2-3.5 3.2-7.6 3.2-12c0-5.1-1.6-9.8-4.3-13.7L158.9 368l12.8-18.3c2.7-3.9 4.3-8.6 4.3-13.7c0-4.4-1.2-8.5-3.2-12l-9.3-16zm303.7-16l9.3 16-9.3 16c-2 3.5-3.2 7.6-3.2 12c0 5.1 1.6 9.8 4.3 13.7L481.1 368l-12.8 18.3c-2.7 3.9-4.3 8.6-4.3 13.7c0 4.4 1.2 8.5 3.2 12l9.3 16-9.3 16c-2 3.5-3.2 7.6-3.2 12c0 13.3 10.7 24 24 24c5.2 0 9.9-1.6 13.8-4.4l12.6-8.9 14.8 4.3c2.1 .6 4.4 1 6.8 1c8.5 0 16-4.4 20.3-11.2l6.5-10.3 11.8-3.4c10.1-2.9 17.4-12.2 17.4-23.1c0-2.3-.3-4.4-.9-6.4L586 398.8l14.3-13.2c4.8-4.4 7.7-10.7 7.7-17.6s-2.9-13.2-7.7-17.6L586 337.2l5.2-18.8c.5-2 .9-4.1 .9-6.4c0-10.9-7.3-20.2-17.4-23.1l-11.8-3.4-6.5-10.3C552 268.4 544.5 264 536 264c-2.4 0-4.6 .3-6.8 1l-14.8 4.3-12.6-8.9c-3.9-2.8-8.6-4.4-13.8-4.4c-13.3 0-24 10.7-24 24c0 4.4 1.2 8.5 3.2 12z'
      
    ]
  };

  

  
  

  var faRouteInterstate = {
    prefix: 'fasl',
    iconName: 'route-interstate',
    icon: [
      512,
      512,
      [],
      'f61b',
      
      'M265.6 11.2L256 4l-9.6 7.2C187.1 55.6 113.3 63.1 46.5 33.4L26.4 24.5 24.1 46.3c-12 112-13.5 203 17.7 277.8C73.6 400 137.7 456.4 249.9 502.8l6.5 2.7 6.4-2.9C372.4 451.9 436.3 395.6 468.6 321c31.8-73.7 31.4-162.5 19.3-274.7l-2.3-21.8-20.1 8.9C398.7 63.1 324.9 55.6 265.6 11.2zM53.8 70.6C121.9 93.9 195 84.9 256 43.6c60.9 41.3 134.1 50.2 202.2 26.9c3.1 32.3 5 62 5.2 89.4H256 48.2c.4-27.6 2.4-57.3 5.5-89.4zM48.5 192H462.9c-1.9 44.4-9.1 82.5-23.7 116.3c-27.3 63.2-81.7 114.1-183.5 162.2C152.3 426.6 98.1 375.8 71.4 311.7C56.8 277 50 237.6 48.5 192z'
      
    ]
  };

  

  
  

  var faBroccoli = {
    prefix: 'fasl',
    iconName: 'broccoli',
    icon: [
      512,
      512,
      [129382],
      'e3e2',
      
      'M256 0c-37.2 0-69.5 21.2-85.4 52.1C162.2 49.4 153.3 48 144 48c-48.6 0-88 39.4-88 88c0 10.7 1.9 20.9 5.4 30.4C25.5 180.3 0 215.2 0 256c0 53 43 96 96 96h8s56 64 88 160H320c32-96 88-160 88-160h8c53 0 96-43 96-96c0-40.8-25.5-75.7-61.4-89.6c3.5-9.5 5.4-19.7 5.4-30.4c0-48.6-39.4-88-88-88c-9.3 0-18.2 1.4-26.6 4.1C325.5 21.2 293.2 0 256 0zm27.4 352l-9 15.8L256 400l-18.4-32.2-9-15.8h54.9zM192 352v.5l4.2 7.4 32 56 9.2 16.1h37.1l9.2-16.1 32-56 4.2-7.4 0-.5h47.4c-5.3 7.2-11.5 16.2-18.3 26.7C332.8 404 313.4 438.6 297.5 480h-83c-15.9-41.4-35.3-76-51.6-101.3c-6.8-10.5-13-19.5-18.3-26.7H192zm2.6-274.2C202.5 51.3 227 32 256 32s53.5 19.3 61.4 45.8L323.1 97l17.5-9.9C348.7 82.6 358 80 368 80c30.9 0 56 25.1 56 56c0 11.8-3.6 22.7-9.8 31.7L399.5 189l25.6 3.6c31 4.4 54.9 31.1 54.9 63.4c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64c0-32.3 23.9-59 54.9-63.4l25.6-3.6L97.8 167.7c-6.2-9-9.8-19.9-9.8-31.7c0-30.9 25.1-56 56-56c10 0 19.3 2.6 27.4 7.2L188.9 97l5.7-19.2zM256 464.5l.3-.5h-.6l.3 .5z'
      
    ]
  };

  

  
  

  var faFaceSmilingHands = {
    prefix: 'fasl',
    iconName: 'face-smiling-hands',
    icon: [
      640,
      512,
      [],
      'e396',
      
      'M320 32c95.3 0 176.7 59.5 209.1 143.4l29.9-11.5C522 68 428.9 0 320 0S118 68 81.1 163.9l29.9 11.5C143.3 91.5 224.7 32 320 32zM290.1 478l-4.2 31.7c11.2 1.5 22.6 2.3 34.1 2.3s22.9-.8 34.1-2.3L349.9 478c-9.8 1.3-19.7 2-29.9 2s-20.1-.7-29.9-2zm-2.6-81.5c10.1 2.2 20.9 3.5 32.5 3.5s22.5-1.3 32.5-3.5c5.9 64.6 60.2 115.3 126.3 115.5h.7c33.6-.1 65.8-13.5 89.6-37.3l48.8-48.8 11.3-11.3L640 403.9V380.1l-10.7-10.7-9.4-9.4 9.4-9.4L640 339.9V316.1l-10.7-10.7-9.4-9.4 16-16-22.6-22.6-22.6-22.6L568 212.1l-16 16-9.4-9.4L520 196.1l-22.6 22.6-11.3 11.3-40.3 40.3H424 384 352v32 20V352v11.7c-9.6 2.7-20.3 4.3-32 4.3s-22.4-1.6-32-4.3V352 322.4v-20-32H256 216 194.3l-40.3-40.3-11.3-11.3L120 196.1 97.4 218.7 88 228.1l-16-16L49.4 234.7 26.7 257.4 4.1 280l16 16-9.4 9.4L0 316.1v23.8l10.7 10.7 9.4 9.4-9.4 9.4L0 380.1v23.8l10.7 10.7 11.3 11.3 48.8 48.8c23.8 23.8 56 37.2 89.6 37.3h.7c66.1-.2 120.4-50.8 126.3-115.5zM384 385.1V348.8s0 0 0 0V334.4v-12-20h8 21.7H416h8v20 12 3l6.1-6.1 8.9-8.9 13.7-13.7 3.3-3.3L497.4 264l11.3-11.3L520 241.4l9.4 9.4L542.6 264l-11.3 11.3L520 286.6l-22.1 22.1-22.6 22.6 9.4 9.4 22.6-22.6 33.4-33.4 4.7-4.7 6.6-6.6 4.7-4.7L568 257.4l9.4 9.4 3.9 3.9 9.4 9.4-11.3 11.3-4.7 4.7-6.6 6.6-4.7 4.7-33.4 33.4-22.6 22.6 9.4 9.4 22.6-22.6L561.4 328l11.3-11.3L584 305.4l13.3 13.3 9.4 9.4-9.4 9.4-1.9 1.9L584 350.6l-9.4 9.4-11.3 11.3-1.4 1.4-22.6 22.6 9.4 9.4L561.4 392l9.9-9.9 1.4-1.4L584 369.4l13.3 13.3 9.4 9.4-11.3 11.3L584 414.6l-12.7 12.7-22.6 22.6-2.2 2.2C528.7 470 504.4 480 479.2 480c-52.5 0-95-42.5-95.2-94.9zM207.5 203.9c2.1-8.6 6.7-18.2 12.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4l31-7.8c-3.2-12.7-9.8-27.1-19.9-38.6C273.6 145.9 258.8 136 240 136s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6l31 7.8zm172.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4l31-7.8c-3.2-12.7-9.8-27.1-19.9-38.6C433.6 145.9 418.8 136 400 136s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6l31 7.8c2.1-8.6 6.7-18.2 12.9-25.4zM72 257.4l11.3 11.3 4.7 4.7 6.6 6.6 4.7 4.7 33.4 33.4 22.6 22.6 9.4-9.4-22.6-22.6L120 286.6l-11.3-11.3L97.4 264l13.3-13.3 9.4-9.4 11.3 11.3L142.6 264 184 305.4l3.3 3.3L201 322.4l8.9 8.9 6.1 6.1v-3-12-20h8 2.3H248h8v20 12V352v20 12.8c0 52.6-42.6 95.2-95.2 95.2c-25.2 0-49.5-10-67.3-27.9l-2.2-2.2L68.7 427.3 56 414.6 44.7 403.3 33.4 392l9.4-9.4L56 369.4l11.3 11.3 1.4 1.4 9.9 9.9 12.7 12.7 9.4-9.4L78.1 372.7l-1.4-1.4L65.4 360 56 350.6 44.7 339.3l-1.9-1.9L33.4 328l9.4-9.4L56 305.4l11.3 11.3L78.6 328l22.1 22.1 22.6 22.6 9.4-9.4-22.6-22.6L76.7 307.3 72 302.6 65.4 296l-4.7-4.7L49.4 280l9.4-9.4 3.9-3.9 9.4-9.4z'
      
    ]
  };

  

  
  

  var faOilCanDrip = {
    prefix: 'fasl',
    iconName: 'oil-can-drip',
    icon: [
      640,
      512,
      [],
      'e205',
      
      'M352 96H272v64H384l64 32 160-32 32 32L432 416H384 128 96V384 352L0 304V192 160H32 96h32H240V96H160V64H352V96zM96 192H32v92.2l64 32V192zm347.5 33.5l-9.8-4.9L376.4 192H128V332.2 368v16H384h34L592.9 195.6 454.3 223.4l-10.8 2.2zM608 400c0-1.3-.9-6.4-4.9-15.9c-2.9-6.9-6.8-14.3-11.1-21.8c-4.3 7.4-8.1 14.9-11.1 21.8c-4.1 9.5-4.9 14.6-4.9 15.9c0 8.8 7.2 16 16 16c7 0 10.7-2.1 12.3-3.5c1.2-1.1 3.7-4 3.7-12.5zm-64 0c0-18.2 15.4-46.6 28.8-67.8C583 316 592 304 592 304s9 12 19.2 28.2C624.6 353.4 640 381.8 640 400c0 32-21.5 48-48 48s-48-21.5-48-48z'
      
    ]
  };

  

  
  

  var faObjectsAlignLeft = {
    prefix: 'fasl',
    iconName: 'objects-align-left',
    icon: [
      512,
      512,
      [],
      'e3be',
      
      'M0 512L0 0 32 0l0 512L0 512zM160 192l320 0 0-96L160 96l0 96zM128 96l0-32 32 0 320 0 32 0 0 32 0 96 0 32-32 0-320 0-32 0 0-32 0-96zm32 320l192 0 0-96-192 0 0 96zm-32-96l0-32 32 0 192 0 32 0 0 32 0 96 0 32-32 0-192 0-32 0 0-32 0-96z'
      
    ]
  };

  

  
  

  var faDharmachakra = {
    prefix: 'fasl',
    iconName: 'dharmachakra',
    icon: [
      512,
      512,
      [9784],
      'f655',
      
      'M272 0V16 48.6c45.4 3.5 86.7 21.5 119.3 49.4L414.4 75l11.3-11.3 22.6 22.6L437 97.6 414 120.7c27.9 32.6 46 73.9 49.4 119.3H496h16v32H496 463.4c-3.5 45.4-21.5 86.7-49.4 119.3L437 414.4l11.3 11.3-22.6 22.6L414.4 437 391.3 414c-32.6 27.9-73.9 46-119.3 49.4V496v16H240V496 463.4c-45.4-3.5-86.7-21.5-119.3-49.4L97.6 437 86.3 448.3 63.7 425.7 75 414.4 98 391.3c-27.9-32.6-46-73.9-49.4-119.3H16 0V240H16 48.6c3.5-45.4 21.5-86.7 49.4-119.3L75 97.6 63.7 86.3 86.3 63.7 97.6 75 120.7 98c32.6-27.9 73.9-46 119.3-49.4V16 0h32zM120.7 143.4c-22.2 26.7-36.7 60-40 96.6h80.6c2.4-14.4 8.1-27.9 16.4-39.6l-57-57zm79.6 34.4c11.4-8.1 24.9-13.9 39.6-16.4V80.7c-36.6 3.3-69.9 17.8-96.6 40l57 57zm9.8 33.5c-11.2 11.4-17.9 26.9-18.2 43.5v2.3c.1 3.2 .3 6.3 .9 9.6c2.2 13.3 8.5 25 17.2 34l1.1 1.1c11.4 11.2 26.9 17.9 43.5 18.2h2.3c3.2-.1 6.3-.3 9.6-.9c13.3-2.2 25-8.5 34-17.3l1.1-1.1c11.2-11.4 17.9-26.9 18.2-43.5v-2.3c-.1-3.2-.3-6.3-.9-9.6c-2.2-13.3-8.5-25-17.3-34l-1.1-1.1c-11.4-11.2-26.9-17.9-43.5-18.2h-2.3c-3.2 .1-6.3 .3-9.6 .9c-13.3 2.2-25 8.5-34 17.2l-1.1 1.1zM177.7 311.6c-8.1-11.4-13.9-24.9-16.4-39.6H80.7c3.3 36.6 17.8 69.9 40 96.6l57-57zm-34.4 79.6c26.7 22.2 60 36.7 96.6 40V350.7c-14.4-2.4-27.9-8.1-39.6-16.4l-57 57zm168.3-57c-11.4 8.1-24.9 13.9-39.6 16.4v80.6c36.6-3.3 69.9-17.8 96.6-40l-57-57zm79.6 34.4c22.2-26.7 36.7-60 40-96.6H350.7c-2.4 14.4-8.1 27.9-16.4 39.6l57 57zm-57-168.3c8.1 11.4 13.9 24.9 16.4 39.6h80.6c-3.3-36.6-17.8-69.9-40-96.6l-57 57zm34.4-79.6c-26.7-22.2-60-36.7-96.6-40v80.6c14.4 2.4 27.9 8.1 39.6 16.4l57-57z'
      
    ]
  };

  

  
  

  var faCircleUpLeft = {
    prefix: 'fasl',
    iconName: 'circle-up-left',
    icon: [
      512,
      512,
      [],
      'e128',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 144H144v16V320v6.6l4.7 4.7 16 16L176 358.6l11.3-11.3L228 306.6l64.7 64.7L304 382.6l11.3-11.3 56-56L382.6 304l-11.3-11.3L306.6 228l40.7-40.7L358.6 176l-11.3-11.3-16-16-4.7-4.7H320 160zm16 169.4V176H313.4l-40.7 40.7L261.4 228l11.3 11.3L337.4 304 304 337.4l-64.7-64.7L228 261.4l-11.3 11.3L176 313.4z'
      
    ]
  };

  

  
  

  var faCloudHailMixed = {
    prefix: 'fasl',
    iconName: 'cloud-hail-mixed',
    icon: [
      512,
      512,
      [],
      'f73a',
      
      'M384 160V128c0-35.3-28.7-64-64-64c-12.9 0-24.9 3.8-34.9 10.3L259.2 91.2 241.5 66C226.9 45.4 203 32 176 32c-44.2 0-80 35.8-80 80v21.5 22.6l-21.3 7.5C49.8 172.4 32 196.2 32 224v64H96 416h64V224c0-35.3-28.7-64-64-64H384zM32 320H0V288 224c0-41.8 26.7-77.4 64-90.5V112C64 50.1 114.1 0 176 0c37.9 0 71.3 18.8 91.6 47.5C282.7 37.7 300.7 32 320 32c53 0 96 43 96 96c53 0 96 43 96 96v64 32H480 416 96 32zM0 488a24 24 0 1 1 48 0A24 24 0 1 1 0 488zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM80 352h40L76 432H36l44-80zm96 0h40L128 512H88l88-160zm96 0h40l-44 80H228l44-80zm104 0h40L328 512H288l88-160zm88 0h40l-44 80H420l44-80z'
      
    ]
  };

  

  
  

  var faDiagramSankey = {
    prefix: 'fasl',
    iconName: 'diagram-sankey',
    icon: [
      576,
      512,
      [],
      'e158',
      
      'M326.9 32l-4.7 7.8L230.9 192H16 0v32H16 240h9.1l4.7-7.8L345.1 64H560h16V32H560 336h-9.1zM181.9 288l-.3-.4-.7 .4H16 0v32H16 164l94.4 152.4 4.7 7.6H272 560h16V448H560 280.9L201.7 320H560h16V288H560 181.9z'
      
    ]
  };

  

  
  

  var faBarsStaggered = {
    prefix: 'fasl',
    iconName: 'bars-staggered',
    icon: [
      512,
      512,
      ["reorder","stream"],
      'f550',
      
      'M0 64H448V96H0V64zM64 224H512v32H64V224zM448 384v32H0V384H448z'
      
    ]
  };

  
    var faReorder = faBarsStaggered;
  
    var faStream = faBarsStaggered;
  

  
  

  var faUserBountyHunter = {
    prefix: 'fasl',
    iconName: 'user-bounty-hunter',
    icon: [
      448,
      512,
      [],
      'e2bf',
      
      'M80 0H64V16 256v15.2l-1.3 20.7 155.9 27.2c1.7 .6 3.5 .9 5.4 .9s3.7-.3 5.4-.9l155.9-27.2-9.7-149.7C370.5 62.2 304.1 0 224 0C170.5 0 123.1 27.7 96 70V32h16V0H96 80zM240 284.7V160H340.2c-1 .5-2 1.1-3.1 1.7c-9.7 5.5-22.6 13.9-35.6 25.2c-23.6 20.7-48.7 52.5-52.9 96.3l-8.6 1.5zm111.6-19.4l-69.8 12.2c5.3-28.4 22.5-50.4 40.8-66.4c8.5-7.4 17.1-13.4 24.4-17.9l4.7 72.2zM341.6 128H224 106.4C117.6 72.9 166.3 32 224 32s106.4 40.9 117.6 96zM101.1 193.1c7.3 4.5 15.8 10.5 24.4 17.9c18.3 16 35.5 38 40.8 66.4L96.4 265.3l4.7-72.2zm6.7-33.1H208V284.7l-8.6-1.5c-4.2-43.8-29.2-75.6-52.9-96.3c-13-11.4-25.9-19.7-35.6-25.2c-1.1-.6-2.1-1.2-3.1-1.7zm-36 224H376.2L405 480H310.1l-75.4-67.9L224 402.5l-10.7 9.6L137.9 480H43l28.8-96zM224 445.5L262.3 480H185.7L224 445.5zM33.4 512h68.9H144 304h41.7 68.9H448l-9.6-32L400 352H48L9.6 480 0 512H33.4z'
      
    ]
  };

  

  
  

  var faChessRook = {
    prefix: 'fasl',
    iconName: 'chess-rook',
    icon: [
      448,
      512,
      [9820],
      'f447',
      
      'M48 32H32V48 200v7.4l5.6 4.8 50 42.9-5.1 97h32L120 248.8l.4-7.9-6-5.1L64 192.6V64h80v40 16h32V104 64h96v40 16h32V104 64h80V192.6l-50.4 43.2-6 5.1 .4 7.9L333.5 352h32l-5.1-97 50-42.9 5.6-4.8V200 48 32H400 48zM224 160c-26.5 0-48 21.5-48 48v64 16h16 64 16V272 208c0-26.5-21.5-48-48-48zm-16 48c0-8.8 7.2-16 16-16s16 7.2 16 16v48H208V208zM64 480v-9.5L97.8 416H350.2L384 470.5V480H64zm304-96H80L32 461.3V480v32H64 384h32V480 461.3L368 384z'
      
    ]
  };

  

  
  

  var faWineBottle = {
    prefix: 'fasl',
    iconName: 'wine-bottle',
    icon: [
      512,
      512,
      [],
      'f72f',
      
      'M422.6 0L512 89.4V112l-11.3 11.3-10.7-10.7-98.2 98.2c10.8 41.9-.2 88.2-32.9 120.9L201.1 489.4 178.5 512l-22.6-22.6L22.6 356.1 0 333.5l22.6-22.6L180.2 153.3c32.8-32.8 79.1-43.8 120.9-32.9l98.2-98.2L388.7 11.3 400 0h22.6zm44.7 89.9L422.1 44.7 372.7 94.1l45.3 45.3 49.4-49.4zm-72 72l-45.3-45.3-26.2 26.2-12.9 12.9-17.7-4.6c-31.3-8.1-65.9 .2-90.3 24.6l-2.2 2.2L333.9 311.3l2.2-2.2c24.4-24.4 32.7-59 24.6-90.3l-4.6-17.7 12.9-12.9 26.2-26.2zm-84 172L178.1 200.7l-73.4 73.4L237.9 407.3l73.4-73.4zm-96 96L82.1 296.7 45.3 333.5 178.5 466.7l36.8-36.8z'
      
    ]
  };

  

  
  

  var faWhiskeyGlassIce = {
    prefix: 'fasl',
    iconName: 'whiskey-glass-ice',
    icon: [
      512,
      512,
      ["glass-whiskey-rocks"],
      'f7a1',
      
      'M91.8 448H420.2L475.1 64H36.9L91.8 448zM448 480H64L4.6 64 0 32H32.3 479.7 512l-4.6 32L448 480zM256 192h2.7l-32 32H128V352h57.8l32 32H128 96V352 224 192h32H256zm56 37.3l-79.2 79.2L312 387.6l79.2-79.2L312 229.3zm0-45.3l22.6 22.6 79.2 79.2 22.6 22.6-22.6 22.6-79.2 79.2L312 432.9l-22.6-22.6-79.2-79.2-22.6-22.6 22.6-22.6 79.2-79.2L312 184z'
      
    ]
  };

  
    var faGlassWhiskeyRocks = faWhiskeyGlassIce;
  

  
  

  var faPollPeople = {
    prefix: 'fasl',
    iconName: 'poll-people',
    icon: [
      640,
      512,
      [],
      'f759',
      
      'M96 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64A48 48 0 1 0 96 0a48 48 0 1 0 0 96zM608 64v96H512V64h96zM256 64H480v96H256V64zm0-32H224V64v96 32h32H608h32V160 64 32H608 256zM608 352v96H384V352H608zm-352 0h96v96H256V352zm0-32H224v32 96 32h32H608h32V448 352 320H608 256zM80 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM40 416H27.9l-3.3 11.6L.4 512H33.7l18.3-64h87.9l18.3 64h33.3l-24.2-84.4L164.1 416H152 40zM27.9 128l-3.3 11.6L.4 224H33.7l18.3-64h87.9l18.3 64h33.3l-24.2-84.4L164.1 128H152 40 27.9z'
      
    ]
  };

  

  
  

  var faHospital = {
    prefix: 'fasl',
    iconName: 'hospital',
    icon: [
      640,
      512,
      [62589,127973,"hospital-alt","hospital-wide"],
      'f0f8',
      
      'M160 0h16H464h16V16 96H624h16v16 80 32 64 32V496v16H624 416v0H384 368 272 256 224v0H16 0V496 320 288 224 192 112 96H16 160V16 0zM608 128H480V336 480H608V320H528 512V288h16 80V224H528 512V192h16 80V128zM32 224v64h80 16v32H112 32V480H160V128H32v64h80 16v32H112 32zM448 480V336 32H192V480h64V368 352h16 96 16v16V480h64zm-96 0V384H288v96h64zM296 64h48 16V80v24h24 16v16 48 16H384 360v24 16H344 296 280V208 184H256 240V168 120 104h16 24V80 64h16zm16 56v16H296 272v16h24 16v16 24h16V168 152h16 24V136H344 328V120 96H312v24z'
      
    ]
  };

  
    var faHospitalAlt = faHospital;
  
    var faHospitalWide = faHospital;
  

  
  

  var faLampDesk = {
    prefix: 'fasl',
    iconName: 'lamp-desk',
    icon: [
      512,
      512,
      [],
      'e014',
      
      'M368 96l-9.4-9.4L320.6 48.6C310 38 295.6 32 280.6 32C249.3 32 224 57.3 224 88.6c0 15 6 29.4 16.6 40l38.1 38.1L288 176v13.3 69.5l16 16L466.7 112l-16-16H381.3 368zm96-32l25.4 25.4L512 112l-22.6 22.6L326.6 297.4 304 320l-22.6-22.6L256 272V189.3l-19.3-19.3-90.8 90.8L204.3 480H368h16v32H368 192 16 0V480H16 171.2L112.5 260.1l-2.4-8.9 6.5-6.5 97.5-97.5c-14.3-16.1-22.2-37-22.2-58.6C192 39.7 231.7 0 280.6 0c23.5 0 46 9.3 62.6 25.9L381.3 64H464zM378.6 287.9L401.5 265c6.4 4.4 14.2 7 22.5 7c22.1 0 40-17.9 40-40c0-8.4-2.6-16.1-7-22.5l22.8-22.8C490 199 496 214.8 496 232c0 39.8-32.2 72-72 72c-17.2 0-33-6-45.4-16.1z'
      
    ]
  };

  

  
  

  var faEnvelopeOpenText = {
    prefix: 'fasl',
    iconName: 'envelope-open-text',
    icon: [
      512,
      512,
      [],
      'f658',
      
      'M416 32H96V222.5L77.5 207.2c-4.2-3.4-8.7-6.3-13.5-8.6V32 0H96 416h32V32 198.6c-4.8 2.3-9.3 5.2-13.4 8.6L416 222.5V32zM256 414.8l-18.1-12.5L32 260.8V480H480V260.8L274.1 402.4 256 414.8zM480 222l32-22v38.8V480v32H480 32 0V480 238.8 200l32 22L256 376 480 222zM176 128H336h16v32H336 176 160V128h16zm0 96H336h16v32H336 176 160V224h16z'
      
    ]
  };

  

  
  

  var faSquareAmpersand = {
    prefix: 'fasl',
    iconName: 'square-ampersand',
    icon: [
      448,
      512,
      [],
      'e260',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm144 96h16 96 16v16 38.8c0 21.1-10.4 40.8-27.7 52.7l-18.7 12.8 44.9 49.4 36.4-51 9.3-13 26 18.6-9.3 13-40.4 56.6 51.3 56.3 5.3 5.8H305.8l-32.3-35.4L253 377.3l-4.8 6.7H240 224 128 112V368 321.2c0-21.1 10.4-40.8 27.7-52.7l37.5-25.8-16.6-18.2c-10.7-11.8-16.7-27.1-16.7-43.1V144 128zm59.9 96.4l22.3-15.3c8.7-6 13.9-15.8 13.9-26.4V160H176v21.4c0 8 3 15.6 8.3 21.5l19.5 21.5zM199 266.6l-41.1 28.3c-8.7 6-13.9 15.8-13.9 26.4V352h87.8l19.8-27.7L199 266.6z'
      
    ]
  };

  

  
  

  var faGaugeHigh = {
    prefix: 'fasl',
    iconName: 'gauge-high',
    icon: [
      512,
      512,
      [62461,"tachometer-alt","tachometer-alt-fast"],
      'f625',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM280 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-18.6-7.9-35.3-20.5-47l82.6-153.4 7.6-14.1-28.2-15.2-7.6 14.1L271.3 289.8c-4.9-1.2-10-1.8-15.3-1.8c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zM168 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM96 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm344-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faTachometerAlt = faGaugeHigh;
  
    var faTachometerAltFast = faGaugeHigh;
  

  
  

  var faSquareThisWayUp = {
    prefix: 'fasl',
    iconName: 'square-this-way-up',
    icon: [
      448,
      512,
      ["box-up"],
      'f49f',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM352 368v32H96V368H352zM144 105.4l11.3 11.3 64 64-22.6 22.6L160 166.6V304v16H128V304 166.6L91.3 203.3 68.7 180.7l64-64L144 105.4zm160 0l11.3 11.3 64 64-22.6 22.6L320 166.6V304v16H288V304 166.6l-36.7 36.7-22.6-22.6 64-64L304 105.4z'
      
    ]
  };

  
    var faBoxUp = faSquareThisWayUp;
  

  
  

  var faSection = {
    prefix: 'fasl',
    iconName: 'section',
    icon: [
      256,
      512,
      [],
      'e447',
      
      'M32.5 84.7c3.6-20.1 16.3-34.6 36.9-43.4c21.2-9.1 50.6-11.9 84.4-6.6c10.7 1.7 43.5 8.1 54 10.9L216 14.7c-12-3.2-46-9.8-57.3-11.6C121-2.9 85.1-.3 56.7 11.9C27.8 24.3 6.5 47 .9 79.7c0 .3-.1 .6-.1 .8c-2.2 19 .4 35.7 7.6 50c7.1 14.2 18.1 25 30.7 33.6c4.6 3.1 9.6 6 14.7 8.7c-26.7 12-46.7 33-52.1 63.1c-.1 .3-.1 .6-.1 .9c-2.3 18.3 .4 34.3 7.8 48.1c7.2 13.6 18.3 23.9 30.8 32c23.3 15 54.8 24 83.1 32.1l3.3 .9c30.8 8.8 57.7 16.8 75.9 29.5c8.7 6.1 14.6 12.7 18 20.3c3.3 7.5 4.8 17.2 2.3 30.6c-3.4 18.5-15.7 32.3-36.5 40.8c-21.3 8.7-50.7 11.3-84.4 6.3c-16.9-2.6-45.6-11.9-67.8-19.1l0 0 0 0c-4.8-1.5-9.2-3-13.2-4.3l-9.7 30.5c3.4 1.1 7.4 2.4 11.8 3.8C44.9 495.5 77.2 506 97 509.1l.1 0c37.5 5.6 73.1 3.2 101.3-8.3c28.6-11.7 50.2-33.2 55.9-64.7c3.4-18.6 1.8-35-4.6-49.4c-6.3-14.3-16.8-25.1-28.9-33.6c-1.7-1.2-3.5-2.4-5.4-3.5c20-13.1 34.4-32.5 38.9-58.7c3.3-19.4 1.8-36.4-4.5-51.3c-6.2-14.8-16.6-26.2-28.8-35.2c-23.6-17.4-56.4-27.3-85.9-36.1l-.5-.1c-30.8-9.3-58.3-17.5-77.6-30.6c-9.4-6.3-16-13.4-20.1-21.4c-4-7.9-6-17.9-4.5-31.5zM178 332.3c-14.1-5.1-28.8-9.3-42.7-13.2l-.5-.1c-30.7-8.7-58.1-16.6-77.4-29c-9.3-6-15.9-12.6-19.8-20c-3.8-7.2-5.8-16.3-4.3-28.8c3.5-18.3 15.8-32 36.4-40.4c10.1-4.1 22-6.9 35.4-8.1c5.9 1.8 11.8 3.6 17.5 5.3l0 0 3.3 1c30.9 9.3 57.9 17.8 76.1 31.2c8.7 6.4 14.8 13.5 18.3 21.8c3.5 8.2 4.9 18.9 2.5 33.4c-3.8 22.2-19.1 38.5-44.8 46.8z'
      
    ]
  };

  

  
  

  var faSquare0 = {
    prefix: 'fasl',
    iconName: 'square-0',
    icon: [
      448,
      512,
      [],
      'e255',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm224 96c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96V224c0-53 43-96 96-96zm-64 96v64c0 35.3 28.7 64 64 64s64-28.7 64-64V224c0-35.3-28.7-64-64-64s-64 28.7-64 64z'
      
    ]
  };

  

  
  

  var faInbox = {
    prefix: 'fasl',
    iconName: 'inbox',
    icon: [
      512,
      512,
      [],
      'f01c',
      
      'M32 448H480V323.9l-1-3.9H377.9l-27.6 55.2-4.4 8.8H336 176h-9.9l-4.4-8.8L134.1 320H33l-1 3.9V448zM471 288L415 64H97L41 288H144h9.9l4.4 8.8L185.9 352H326.1l27.6-55.2 4.4-8.8H368 471zM0 448V320L72 32H440l72 288V448v32H480 32 0V448z'
      
    ]
  };

  

  
  

  var faFaceSunglasses = {
    prefix: 'fasl',
    iconName: 'face-sunglasses',
    icon: [
      512,
      512,
      [],
      'e398',
      
      'M480 256c0-21.8-3.1-42.8-8.9-62.7l-23.7 83.1L444.1 288H432 304 291.9l-3.3-11.6-32-112-.6-2.2-.6 2.2-32 112L220.1 288H208 80 67.9l-3.3-11.6L40.9 193.3C35.1 213.2 32 234.2 32 256c0 123.7 100.3 224 224 224s224-100.3 224-224zM427.6 112C386.5 63.1 324.9 32 256 32s-130.5 31.1-171.6 80H240h16 16H427.6zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm129.7 87.2l28.6-14.3c8.7 17.5 41.3 55.2 97.7 55.2s88.9-37.7 97.7-55.2l28.6 14.3C369.7 368.3 327.6 416 256 416s-113.7-47.7-126.3-72.8zm-29-162.5L137.4 144H64v13.8l27.5 96.1L137.4 208H112l-11.3-27.3zm86.6 22.6L134.6 256h61.3L224 157.8V144H182.6l-32 32H176l11.3 27.3zM361.4 144H288v13.8l27.5 96.1L361.4 208H336l-11.3-27.3L361.4 144zm45.3 0l-32 32H400l11.3 27.3L358.6 256h61.3L448 157.8V144H406.6z'
      
    ]
  };

  

  
  

  var faSocks = {
    prefix: 'fasl',
    iconName: 'socks',
    icon: [
      512,
      512,
      [129510],
      'f696',
      
      'M288 0H160 128V32 96v16 16V272L38.4 339.2C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l21.6-16.2c-5.2-9.7-9.2-20.1-11.8-31.1l-29 21.8 19.2 25.6-19.2-25.6C123.3 475.5 109.8 480 96 480c-35.3 0-64-28.7-64-64c0-20.1 9.5-39.1 25.6-51.2l89.6-67.2L160 288V272 128H288V96H160V32H288V0zm64 128H480V352L326.4 467.2C315.3 475.5 301.8 480 288 480c-35.3 0-64-28.7-64-64c0-20.1 9.5-39.1 25.6-51.2l89.6-67.2L352 288V272 128zM288 512c20.8 0 41-6.7 57.6-19.2L512 368V128 112 96 32 0H480 352 320V32 96v16 16V272l-89.6 67.2C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96zM352 96V32H480V96H352z'
      
    ]
  };

  

  
  

  var faGrid4 = {
    prefix: 'fasl',
    iconName: 'grid-4',
    icon: [
      448,
      512,
      [],
      'e198',
      
      'M24 56V97.6H65.6V56H24zm0 119.5v41.6H65.6V175.5H24zM0 270.9H24 65.6h24v24 41.6 24h-24H24 0v-24V294.9v-24zm65.6 65.6V294.9H24v41.6H65.6zM24 414.4V456H65.6V414.4H24zM89.6 32V56 97.6v24h-24H24 0v-24V56 32H24 65.6h24zm0 119.5v24 41.6 24h-24H24 0v-24V175.5v-24H24 65.6h24zm0 238.9v24V456v24h-24H24 0V456 414.4v-24H24 65.6h24zM143.5 56V97.6h41.6V56H143.5zm0 119.5v41.6h41.6V175.5H143.5zm-24 95.5h24 41.6 24v24 41.6 24h-24H143.5h-24v-24V294.9v-24zm65.6 65.6V294.9H143.5v41.6h41.6zm-41.6 77.9V456h41.6V414.4H143.5zM209.1 32V56 97.6v24h-24H143.5h-24v-24V56 32h24 41.6 24zm0 119.5v24 41.6 24h-24H143.5h-24v-24V175.5v-24h24 41.6 24zm0 238.9v24V456v24h-24H143.5h-24V456 414.4v-24h24 41.6 24zM304.5 56H262.9V97.6h41.6V56zm0 119.5H262.9v41.6h41.6V175.5zM238.9 294.9v-24h24 41.6 24v24 41.6 24h-24H262.9h-24v-24V294.9zm24 41.6h41.6V294.9H262.9v41.6zm41.6 77.9H262.9V456h41.6V414.4zm0-382.4h24V56 97.6v24h-24H262.9h-24v-24V56 32h24 41.6zm0 119.5h24v24 41.6 24h-24H262.9h-24v-24V175.5v-24h24 41.6zm0 238.9h24v24V456v24h-24H262.9h-24V456 414.4v-24h24 41.6zM382.4 56V97.6H424V56H382.4zm0 119.5v41.6H424V175.5H382.4zm-24 95.5h24H424h24v24 41.6 24H424 382.4h-24v-24V294.9v-24zM424 336.5V294.9H382.4v41.6H424zm-41.6 77.9V456H424V414.4H382.4zM448 32V56 97.6v24H424 382.4h-24v-24V56 32h24H424h24zm0 119.5v24 41.6 24H424 382.4h-24v-24V175.5v-24h24H424h24zm0 238.9v24V456v24H424 382.4h-24V456 414.4v-24h24H424h24z'
      
    ]
  };

  

  
  

  var faBatteryEmpty = {
    prefix: 'fasl',
    iconName: 'battery-empty',
    icon: [
      576,
      512,
      ["battery-0"],
      'f244',
      
      'M32 128V384H480V128H32zM0 96H32 480h32v32V384v32H480 32 0V384 128 96zm544 96h32v32 64 32H544V288 224 192z'
      
    ]
  };

  
    var faBattery0 = faBatteryEmpty;
  

  
  

  var faSnowflakeDroplets = {
    prefix: 'fasl',
    iconName: 'snowflake-droplets',
    icon: [
      640,
      512,
      [],
      'e5c1',
      
      'M336 16V0H304V16 89.4L267.3 52.7 256 41.4 233.4 64l11.3 11.3L304 134.6v93.7l-81.1-46.8-21.7-81L197 85l-30.9 8.3 4.1 15.5 13.4 50.1-70.5-40.7-16 27.7 70.5 40.7L117.6 200l-15.5 4.1 8.3 30.9 15.5-4.1 81-21.7L288 256l-81.1 46.8-81-21.7L110.4 277l-8.3 30.9 15.5 4.1 50.1 13.4-45.1 26L137.2 380l46.5-26.8-13.4 50.1-4.1 15.5L197 427l4.1-15.5 21.7-81L304 283.7v93.7l-59.3 59.3L233.4 448 256 470.6l11.3-11.3L304 422.6V496v16h32V496 422.6l36.7 36.7L384 470.6 406.6 448l-11.3-11.3L336 377.4V283.7l81.1 46.8 21.7 81L443 427l30.9-8.3-4.1-15.5-13.4-50.1L502.8 380l14.7-28.5-45.1-26L522.4 312l15.5-4.1L529.6 277l-15.5 4.1-81 21.7L352 256l81.1-46.8 81 21.7 15.5 4.1 8.3-30.9L522.4 200l-50.1-13.4 70.5-40.7-16-27.7-70.5 40.7 13.4-50.1 4.1-15.5L443 85l-4.1 15.5-21.7 81L336 228.3V134.6l59.3-59.3L406.6 64 384 41.4 372.7 52.7 336 89.4V16zM576 384.5l27.9 48.8c2.7 4.7 4.1 10.1 4.1 15.5c0 17.2-14 31.2-31.2 31.2h-1.6C558 480 544 466 544 448.8c0-5.4 1.4-10.8 4.1-15.5L576 384.5zm-18.4-32.2l-37.2 65.2c-5.5 9.6-8.3 20.4-8.3 31.4c0 34.9 28.3 63.2 63.2 63.2h1.6c34.9 0 63.2-28.3 63.2-63.2c0-11-2.9-21.8-8.3-31.4l-37.2-65.2L576 320l-18.4 32.2zM36.1 433.3L64 384.5l27.9 48.8c2.7 4.7 4.1 10.1 4.1 15.5C96 466 82 480 64.8 480H63.2C46 480 32 466 32 448.8c0-5.4 1.4-10.8 4.1-15.5zM8.3 417.4C2.9 427 0 437.8 0 448.8C0 483.7 28.3 512 63.2 512h1.6c34.9 0 63.2-28.3 63.2-63.2c0-11-2.9-21.8-8.3-31.4L82.4 352.2 64 320 45.6 352.2 8.3 417.4z'
      
    ]
  };

  

  
  

  var faDove = {
    prefix: 'fasl',
    iconName: 'dove',
    icon: [
      512,
      512,
      [128330],
      'f4ba',
      
      'M272 146.5v19.1c-12.8-3.9-26.3-8.9-39.7-15.3C216.2 131 202.1 109 192.2 84.7c-4.3 9.4-8.5 19.8-12.4 31.3c-9.1-8.3-17.2-17.4-24-27.5c7.6-19.3 16-35.7 23.9-48.9C191.9 19.4 203.1 6.3 210 .3c-1 15.9 .3 31.2 3.6 45.7c8.7 38.8 31 72.5 58.4 100.5zM88.1 23l7.6 37.9c11.5 57.4 50.8 92.7 96.8 114.7C231 194 273 202.4 304 206.3l0-62.3c0-44.2 35.8-80 80-80H488h24.3l-9.6 22.3-22.7 53V288c0 88.4-71.6 160-160 160H248.6l-78.9 60.7-4.3 3.3H160 80 73.4l-4.7-4.7-64-64-16-16 20.4-9.8 110.7-52.9C78.3 333.7 32 280.5 32 192C32 111.6 54.5 73.3 66.7 55.1L88.1 23zM76.6 106C69.8 125.2 64 152.7 64 192c0 89.9 55.5 136.8 96.3 161.2l25.6 15.3-26.9 12.9L43.3 436.7 86.6 480h67.9l78.9-60.7 4.3-3.3h5.4H320c70.7 0 128-57.3 128-128V136v-3.3l1.3-3L463.7 96H384c-26.5 0-48 21.5-48 48l0 80 0 17.4-17.3-1.4c-32.8-2.7-88.7-11-140-35.5C137.4 184.7 98 153.8 76.6 106zM360 160a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faHandBackPointRight = {
    prefix: 'fasl',
    iconName: 'hand-back-point-right',
    icon: [
      512,
      512,
      [],
      'e1a1',
      
      'M512 128l0-16-16 0-232 0-8.6 0c-2-3.2-4.2-6.4-6.5-9.5L212.8 54.4 208 48l-8 0-51.5 0c-53 0-101.7 29.1-126.8 75.7L17.2 132C5.9 153 0 176.4 0 200.3L0 336c0 61.9 50.1 112 112 112l96 0 48 0 16 0 0-16 0-48 16 0 16 0 0-16 0-56 16 0 16 0 0-16 0-72 160 0 16 0 0-16 0-80zM216 112l-48 0-16 0 0 32 16 0 68.7 0 9.5 0 1.7 0 16 0 216 0 0 48-160 0-16 0 0 16 0 72-16 0-16 0 0 16 0 56-16 0-16 0 0 16 0 48-32 0-96 0c-44.2 0-80-35.8-80-80l0-135.7c0-18.5 4.6-36.8 13.4-53.1l-14.1-7.6 14.1 7.6 4.5-8.3C69.4 102.6 107.3 80 148.5 80L192 80l24 32z'
      
    ]
  };

  

  
  

  var faHatChef = {
    prefix: 'fasl',
    iconName: 'hat-chef',
    icon: [
      512,
      512,
      [],
      'f86b',
      
      'M160 96L134.4 76.8C123.7 68.7 110.4 64 96 64c-35.3 0-64 28.7-64 64v1.4c0 6.5 1 13 2.9 19.2L87.6 320h50.5L112.3 178.9l-2.9-15.7 31.5-5.8 2.9 15.7 26.4 144 .5 2.9H240V144 128h32v16V320h69.3l.5-2.9 26.4-144 2.9-15.7 31.5 5.8-2.9 15.7L373.8 320h50.5l52.7-171.4c1.9-6.2 2.9-12.7 2.9-19.2V128c0-35.3-28.7-64-64-64c-14.4 0-27.7 4.7-38.4 12.8L352 96 332.8 70.4C315.2 47 287.4 32 256 32s-59.2 15-76.8 38.4L160 96zM448 352H64L4.3 158C1.5 148.7 0 139.1 0 129.4V128C0 75 43 32 96 32c21.6 0 41.6 7.1 57.6 19.2l0 0C177 20.1 214.1 0 256 0s79 20.1 102.4 51.2l0 0c16-12 36-19.2 57.6-19.2c53 0 96 43 96 96v1.4c0 9.7-1.4 19.4-4.3 28.6L448 352zM64 384H96v96H416V384h32v96 32H416 96 64V480 384z'
      
    ]
  };

  

  
  

  var faGameBoard = {
    prefix: 'fasl',
    iconName: 'game-board',
    icon: [
      448,
      512,
      [],
      'f867',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm144 80v32h64V112 96h32v16 32h64V112 96h32v16 32h32 16v32H368 336v64h32 16v32H368 336v64h32 16v32H368 336v32 16H304V400 368H240v32 16H208V400 368H144v32 16H112V400 368H80 64V336H80h32V272H80 64V240H80h32V176H80 64V144H80h32V112 96h32v16zm0 128h64V176H144v64zm96 0h64V176H240v64zm0 32v64h64V272H240zm-32 0H144v64h64V272z'
      
    ]
  };

  

  
  

  var faPersonBurst = {
    prefix: 'fasl',
    iconName: 'person-burst',
    icon: [
      640,
      512,
      [],
      'e53b',
      
      'M193.8 36.1L176 0 158.2 36.1 133.1 86.9l-55.3-12L38.4 66.3l17.1 36.5L79.6 154 35.7 189.7 4.4 215.2l39.2 9.4 55.1 13.1 .6 56.6 .4 40.3 31.8-24.8L176 274.9l44.6 34.9 31.8 24.8 .4-40.3 .6-56.6 55.1-13.1 39.2-9.4-31.3-25.4L272.4 154l24.1-51.2 17.1-36.5-39.4 8.6-55.3 12L193.8 36.1zm31.9 82l31.4-6.8-13.6 29.1L232.8 163l19.4 15.8 24.9 20.3-31.2 7.5-24.3 5.8-.2 25-.3 32.1-25.3-19.8L176 234.3l-19.7 15.4L131 269.5l-.3-32.1-.2-25-24.3-5.8-31.2-7.5 24.9-20.3L119.2 163l-10.6-22.6L94.9 111.3l31.4 6.8 24.4 5.3 11.1-22.4L176 72.3l14.2 28.8 11.1 22.4 24.4-5.3zM456 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM428.9 128h-9.6l-4.5 8.5-76.9 144-7.5 14.1 28.2 15.1 7.5-14.1L416 202.1V496v16h32V496 352h64V496v16h32V496 202.2l49.9 93.4 7.5 14.1 28.2-15.1-7.5-14.1-76.9-144-4.5-8.5h-9.6H428.9zM512 320H448V160h64V320z'
      
    ]
  };

  

  
  

  var faCrateApple = {
    prefix: 'fasl',
    iconName: 'crate-apple',
    icon: [
      512,
      512,
      ["apple-crate"],
      'f6b1',
      
      'M219.3 27.3L196.7 4.7l-32 32L153.4 48 176 70.6l11.3-11.3 32-32zm192 0L388.7 4.7l-32 32L345.4 48 368 70.6l11.3-11.3 32-32zM160 98.3L96 80c-43.6 0-64 47.8-64 91.4c0 7 .4 13.9 1.2 20.6H65.5c-1-6.6-1.5-13.4-1.5-20.6c0-17.5 4.2-34.2 11-45.5c5.3-8.8 11-12.7 17.4-13.7l58.8 16.8 8.8 2.5 8.8-2.5 58.8-16.8c6.4 1 12.1 4.9 17.4 13.7c6.8 11.2 11 28 11 45.5c0 7.1-.5 14-1.5 20.6h32.3c.8-6.7 1.2-13.5 1.2-20.6c0-43.6-20.4-91.4-64-91.4L160 98.3zM478.8 192c.8-6.7 1.2-13.5 1.2-20.6c0-43.6-20.4-91.4-64-91.4L352 98.3 291.4 81c3 3.8 5.8 7.7 8.3 11.8c5.2 8.6 9.3 17.8 12.4 27.4l31.1 8.9 8.8 2.5 8.8-2.5 58.8-16.8c6.4 1 12.1 4.9 17.4 13.7c6.8 11.2 11 28 11 45.5c0 7.1-.5 14-1.5 20.6h32.3zM32 480V384H480v96H32zm0-224H480v96H32V256zM512 368V352 256 224H480 32 0v32 96 16 16 96 32H32 480h32V480 384 368zM80 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm368-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM80 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm368-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faAppleCrate = faCrateApple;
  

  
  

  var faFileSvg = {
    prefix: 'fasl',
    iconName: 'file-svg',
    icon: [
      512,
      512,
      [],
      'e64b',
      
      'M352 192v96h32V152L232 0H32 0V32 480v32H32 96V480H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM205.7 352c-25.2 0-45.7 20.4-45.7 45.7c0 17.3 9.8 33.1 25.2 40.8l31.2 15.6c4.6 2.3 7.6 7 7.6 12.2c0 7.5-6.1 13.7-13.7 13.7H176 160v32h16 34.3c25.2 0 45.7-20.4 45.7-45.7c0-17.3-9.8-33.1-25.2-40.8l-31.2-15.6c-4.6-2.3-7.6-7-7.6-12.2c0-7.5 6.1-13.7 13.7-13.7H232h16V352H232 205.7zM320 368V352H288v16 35c0 21.1 3.8 42 11.2 61.8L313 501.6l3.9 10.4H328h16 11.1l3.9-10.4 13.8-36.8C380.2 445 384 424.1 384 403V368 352H352v16 35c0 17.3-3.1 34.4-9.2 50.6L336 471.8l-6.8-18.2c-6.1-16.2-9.2-33.3-9.2-50.6V368zm96 24v80c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V448 432H496 480 464v32h16v8c0 4.4-3.6 8-8 8H456c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16h32V392c0-22.1-17.9-40-40-40H456c-22.1 0-40 17.9-40 40z'
      
    ]
  };

  

  
  

  var faEarthAmericas = {
    prefix: 'fasl',
    iconName: 'earth-americas',
    icon: [
      512,
      512,
      [127758,"earth","earth-america","globe-americas"],
      'f57d',
      
      'M477.7 288C462.2 396.6 368.8 480 256 480C132.3 480 32 379.7 32 256c0-10.3 .7-20.5 2.1-30.5l36.3 27.3 4.3 3.2H80h41.4L160 294.6V352v6.6l4.7 4.7L192 390.6V432v16h16 64 16V432 406.6l59.3-59.3 4.7-4.7V336 256 240H336 214.6L192 217.4V208h64 16V192 160v-6.6l-4.7-4.7L240 121.4v-2.7l27.3-27.3 4.7-4.7V80 32.6c69.9 4.9 130.9 41.9 168.5 96.3l-51.8 51.8-4.7 4.7V192v80 16h16 77.7zM457.2 157.4C471.8 187.2 480 220.6 480 256H416V198.6l41.2-41.2zM41.5 191.1C67.9 104 145.9 39.2 240 32.6V73.4l-27.3 27.3-4.7 4.7V112v16 6.6l4.7 4.7L240 166.6V176H176 160v16 32 6.6l4.7 4.7 32 32 4.7 4.7H208 320v57.4l-59.3 59.3-4.7 4.7V400v16H224V384v-6.6l-4.7-4.7L192 345.4V288v-6.6l-4.7-4.7-48-48-4.7-4.7H128 85.3L41.5 191.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  
    var faEarth = faEarthAmericas;
  
    var faEarthAmerica = faEarthAmericas;
  
    var faGlobeAmericas = faEarthAmericas;
  

  
  

  var faHexagonImage = {
    prefix: 'fasl',
    iconName: 'hexagon-image',
    icon: [
      512,
      512,
      [],
      'e504',
      
      'M136.5 430.4L91 350.8l53.2-53.2 61.3 59.2-69 73.5zM340.3 213.1l-113 120.5-72.3-69.8-11.3-10.9-11.1 11.1L74.6 322 36.9 256 146.6 64H365.4L475.1 256l-27 47.2-84.5-90.1L352 200.6l-11.7 12.5zm91.2 119.2L365.4 448H163.9L352 247.4l79.6 84.9zM128 32L0 256 128 480H384L512 256 384 32H128zm48 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faEraser = {
    prefix: 'fasl',
    iconName: 'eraser',
    icon: [
      576,
      512,
      [],
      'f12d',
      
      'M173.3 448H306.7l59.3-59.3L187.3 209.9 61.3 336l112 112zm36.7-260.7L388.7 366.1 514.7 240 336 61.3 209.9 187.3zM38.6 358.6L16 336l22.6-22.6L313.4 38.6 336 16l22.6 22.6L537.4 217.4 560 240l-22.6 22.6L352 448H528h16v32H528 304l-144 0L38.6 358.6z'
      
    ]
  };

  

  
  

  var faBullseyePointer = {
    prefix: 'fasl',
    iconName: 'bullseye-pointer',
    icon: [
      512,
      512,
      [],
      'f649',
      
      'M256 480c123.7 0 224-100.3 224-224S379.7 32 256 32S32 132.3 32 256c0 12.3 1 24.3 2.9 36.1L4.2 302.6C1.5 287.5 0 271.9 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-16.1 0-31.9-1.5-47.2-4.3L219.5 477c11.9 1.9 24.1 3 36.5 3zm-15-64.7l10.9-31.4c1.4 0 2.7 .1 4.1 .1c70.7 0 128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128c0 1.3 0 2.6 .1 3.9L96.7 270.7c-.4-4.8-.7-9.8-.7-14.7c0-88.4 71.6-160 160-160s160 71.6 160 160s-71.6 160-160 160c-5.1 0-10.1-.2-15-.7zm14.1-138l-64 184L178.3 498l-16.8-35.1-29-60.8L27.3 507.3 4.7 484.7 110.1 379.3 50 349.5l-34.3-17 36.2-12.5 183-63.2 31.2-10.8-10.8 31.1zM144.3 360.4l5 2.5 2.4 5 22 46.1 40.4-116.1L98.5 337.8l45.8 22.6z'
      
    ]
  };

  

  
  

  var faDroplet = {
    prefix: 'fasl',
    iconName: 'droplet',
    icon: [
      384,
      512,
      [128167,"tint"],
      'f043',
      
      'M352 320c0-18.5-8.9-46-26.5-80.1c-17-33-40-68.3-63.5-101c-23.4-32.6-47-62.1-64.7-83.4c-1.9-2.2-3.6-4.4-5.4-6.4c-1.7 2.1-3.5 4.2-5.4 6.4c-17.7 21.3-41.2 50.8-64.7 83.4c-23.5 32.7-46.5 68-63.5 101C40.9 274 32 301.5 32 320c0 88.4 71.6 160 160 160s160-71.6 160-160zM0 320C0 235.8 121 83.6 170.9 24.4C183.8 9.1 192 0 192 0s8.2 9.1 21.1 24.4C263 83.6 384 235.8 384 320c0 106-86 192-192 192S0 426 0 320zm192 80v32c-61.9 0-112-50.1-112-112h32c0 44.2 35.8 80 80 80z'
      
    ]
  };

  
    var faTint = faDroplet;
  

  
  

  var faCircleWifi = {
    prefix: 'fasl',
    iconName: 'circle-wifi',
    icon: [
      512,
      512,
      [],
      'e67d',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm405.2-13.2C368.6 201.8 315.3 176 256 176s-112.6 25.8-149.2 66.8L84.1 220.1C126.6 173.4 187.9 144 256 144s129.4 29.4 171.9 76.1l-22.7 22.7zm-47.5 47.5l-22.9 22.9C317.5 288.3 288.6 272 256 272s-61.5 16.3-78.8 41.2l-22.9-22.9C177.7 259.7 214.5 240 256 240s78.3 19.7 101.7 50.3zM232 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faNotebook = {
    prefix: 'fasl',
    iconName: 'notebook',
    icon: [
      512,
      512,
      [],
      'e201',
      
      'M224 480H448V32H224V480zm-32 0V32H96v80h32 16v32H128 96v96h32 16v32H128 96v96h32 16v32H128 96v80h96zm0 32H96 64V480 400H16 0V368H16 64V272H16 0V240H16 64V144H16 0V112H16 64V32 0H96h96 32H448h32V32 480v32H448 224 192z'
      
    ]
  };

  

  
  

  var faFolderMagnifyingGlass = {
    prefix: 'fasl',
    iconName: 'folder-magnifying-glass',
    icon: [
      512,
      512,
      ["folder-search"],
      'e18b',
      
      'M32 32H224l48 64H480h32v32V448v32H480 32 0V448 64 32H32zm240 96H256l-9.6-12.8L208 64H32V448H480V128H272zM240 336a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0 32c-53 0-96-43-96-96s43-96 96-96s96 43 96 96c0 20.8-6.6 40-17.8 55.7l45.1 45.1 11.3 11.3L352 406.8l-11.3-11.3-45.1-45.1C279.9 361.5 260.7 368 240 368z'
      
    ]
  };

  
    var faFolderSearch = faFolderMagnifyingGlass;
  

  
  

  var faCandyCorn = {
    prefix: 'fasl',
    iconName: 'candy-corn',
    icon: [
      640,
      512,
      [],
      'f6bd',
      
      'M480 0C608 0 640 32 640 32v96L512 416H448L320 128V32s32-32 160-32zM608 50.2c-2.8-1.2-6.1-2.5-10.1-3.8C577.9 39.7 541.4 32 480 32s-97.9 7.7-117.9 14.4c-4 1.3-7.4 2.6-10.1 3.8v71l.3 .7c1.6-.9 3.4-1.5 5.3-1.8L360 136c-2.4-15.8-2.4-15.8-2.4-15.8l0 0 0 0 0 0 .1 0 .5-.1 1.9-.3c1.7-.2 4.1-.5 7.2-.9c6.2-.8 15.2-1.8 26.2-2.8c22-2 52.6-4.1 86.4-4.1s64.3 2 86.4 4.1c11 1 20 2 26.2 2.8c3.1 .4 5.5 .7 7.2 .9l1.9 .3 .5 .1 .1 0 0 0 0 0 0 0s0 0-2.4 15.8l2.4-15.8c1.9 .3 3.7 .9 5.3 1.8l.3-.7v-71zM365.4 151.4L406.1 243c20.5-1.6 46.1-3 73.9-3s53.4 1.4 73.9 3l40.7-91.6c-1.5-.2-3.5-.5-6-.8c-5.9-.7-14.5-1.7-25.2-2.7c-21.4-2-50.9-3.9-83.4-3.9s-62.1 2-83.4 3.9c-10.7 1-19.3 2-25.2 2.7c-2.5 .3-4.5 .6-6 .8zM468.8 384h22.4l48.9-109.9c-17.6-1.2-38.1-2.1-60.1-2.1s-42.5 .9-60.1 2.1L468.8 384zM90.5 195.2c90.5-90.5 135.8-90.5 135.8-90.5l67.9 67.9L407.3 466.7 362 511.9 67.9 398.8 0 330.9s0-45.3 90.5-135.8zm126-55c-2.8 1.1-6.1 2.6-9.9 4.5c-18.9 9.4-50.1 29.8-93.5 73.2s-63.8 74.6-73.2 93.5c-1.9 3.8-3.3 7.1-4.5 9.9l50.2 50.2c.4 .2 4-5 6.6-8.8c1.2-1.7 2.2-3.2 2.6-3.8c3.8-4.9 9.5-12 16.5-20.5c14.2-17 34.3-40 58.2-63.9s46.9-44 63.9-58.2c8.5-7.1 15.6-12.7 20.5-16.5c2.5-1.9 4.4-3.4 5.7-4.4l1.5-1.2 .4-.3 .1-.1 0 0c1.6-1.2 3.3-2 5-2.5l-.3-.8-50.2-50.2zM262 193.6l9.5 12.8c-9.5-12.9-9.5-12.8-9.5-12.8zM116.5 383.2l93.6 36c13.3-15.6 30.4-34.7 50.1-54.4s38.7-36.8 54.4-50.1l-36-93.6c-1.2 .9-2.8 2.1-4.8 3.7c-4.7 3.7-11.5 9.1-19.7 15.9c-16.5 13.7-38.7 33.2-61.8 56.2s-42.5 45.3-56.2 61.8c-6.8 8.2-12.2 15-15.9 19.7c-1.5 2-2.8 3.6-3.7 4.8zm237.6 91.4L370 458.8 326.8 346.5c-13.3 11.6-28.4 25.5-43.9 41s-29.4 30.7-41 43.9l112.3 43.2z'
      
    ]
  };

  

  
  

  var faMessageQuote = {
    prefix: 'fasl',
    iconName: 'message-quote',
    icon: [
      512,
      512,
      ["comment-alt-quote"],
      'e1e4',
      
      'M160 416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448 416zm0-32h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zm0-240v48h48V176 160 144H160zm48 80H160 128V192 144 112h32 48 32v32 16 16 16 32 40 11.1L229.6 279l-64 24-15 5.6-11.2-30 15-5.6L208 252.9V224zm176 0v40 11.1L373.6 279l-64 24-15 5.6-11.2-30 15-5.6L352 252.9V224H304 272V192 144 112h32 48 32v32 16 16 16 32zm-32-48V160 144H304v48h48V176z'
      
    ]
  };

  
    var faCommentAltQuote = faMessageQuote;
  

  
  

  var faUserRobotXmarks = {
    prefix: 'fasl',
    iconName: 'user-robot-xmarks',
    icon: [
      448,
      512,
      [],
      'e4a7',
      
      'M240 16V0H208V16 64H96 64V96 288v32H96 352h32V288 96 64H352 240V16zM96 96H352V288H304V240H272v48H240V240H208v48H176V240H144v48H96V96zM32 128H0V256H32V128zm416 0H416V256h32V128zM272 480H240V448h32v32zm32-32h32v32H304V448zm64 32V448 416H336 288 224 112 80v32 32H43l28.8-96H376.2L405 480H368zm-224 0H112V448h32v32zm64 0H176V448h32v32zM80 512h32 48 64 64 48 32 46.6H448l-9.6-32L400 352H48L9.6 480 0 512H33.4 80zm48-402.7L109.3 128l9.3 9.3L141.3 160l-22.7 22.7-9.3 9.3L128 210.7l9.3-9.3L160 178.7l22.7 22.7 9.3 9.3L210.7 192l-9.3-9.3L178.7 160l22.7-22.7 9.3-9.3L192 109.3l-9.3 9.3L160 141.3l-22.7-22.7-9.3-9.3zm137.3 9.3l-9.3-9.3L237.3 128l9.3 9.3L269.3 160l-22.7 22.7-9.3 9.3L256 210.7l9.3-9.3L288 178.7l22.7 22.7 9.3 9.3L338.7 192l-9.3-9.3L306.7 160l22.7-22.7 9.3-9.3L320 109.3l-9.3 9.3L288 141.3l-22.7-22.7z'
      
    ]
  };

  

  
  

  var faArrowDown = {
    prefix: 'fasl',
    iconName: 'arrow-down',
    icon: [
      384,
      512,
      [8595],
      'f063',
      
      'M203.3 467.3L192 478.6l-11.3-11.3-168-168L1.4 288 24 265.4l11.3 11.3L176 417.4V48 32h32V48 417.4L348.7 276.7 360 265.4 382.6 288l-11.3 11.3-168 168z'
      
    ]
  };

  

  
  

  var faPersonSwimming = {
    prefix: 'fasl',
    iconName: 'person-swimming',
    icon: [
      576,
      512,
      [127946,"swimmer"],
      'f5c4',
      
      'M104 128a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 112a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm29.8 122.8c-14.6-10-26-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C41.7 374.1 20.9 384 0 384v32c30.3 0 57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 401.9 161.7 416 192 416s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 401.9 353.7 416 384 416s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C518.5 401.9 545.7 416 576 416V384c-20.9 0-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C425.6 374.1 404.9 384 384 384s-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C233.6 374.1 212.9 384 192 384s-41.7-9.9-58.2-21.2zm135-169L410.7 314.2c4.8-1.6 9.5-3.4 14-5.5c6.1-2.8 11.6-6 17.4-9.8L291.5 171.1 334.6 128H464h16V96H464 328h-6.6l-4.7 4.7L267 150.3l-.1-.1-1 1.1-85.3 85.3-4.7 4.7V248v69.1c5.5 1.2 10.8 1.9 16 1.9s10.5-.7 16-1.9V254.6l60.8-60.8z'
      
    ]
  };

  
    var faSwimmer = faPersonSwimming;
  

  
  

  var faTRex = {
    prefix: 'fasl',
    iconName: 't-rex',
    icon: [
      640,
      512,
      [],
      'e629',
      
      'M432 32c-26.5 0-48 21.5-48 48V96v8l-6.4 4.8-64 48-4.3 3.2H304 272c-61.9 0-112 50.1-112 112v16 16H144 96 83.9l-3.3-11.6L55.6 205l-5 8.4C38.4 233.7 32 256.9 32 280.6C32 346.6 85.4 400 151.4 400H192V368 352h32v16 41.4L294.6 480H384v-8c0-13.3-10.7-24-24-24h-8H340.5l-3.6-10.9-16-48-2.3-6.8 3.6-6.2L352 323.8V312c0-30.9-25.1-56-56-56l-24 0 0-32 24 0c48.6 0 88 39.4 88 88v16 4.2l-2.1 3.7-28.5 49.8 10.1 30.4C392.8 418 416 442.3 416 472v24 16H400 288h-6.6l-4.7-4.7L201.4 432h-50C67.8 432 0 364.2 0 280.6c0-29.5 8-58.4 23.2-83.7l17.5-29.2 4.7-7.8h9.1H64 76.1l3.3 11.6L108.1 272H128c0-79.5 64.5-144 144-144h26.7L352 88V80c0-44.2 35.8-80 80-80h2.9H528h10.4l4.2 9.5 10 22.5H560c44.2 0 80 35.8 80 80v64 16H624 608h-9.4l-27.3 27.3-4.7 4.7H560 470.6L429 265.6l42.9 24.5 8.1 4.6V304v32 16H448V336 313.3l-33.3-19c-2.3-15.8-7.8-30.7-15.7-43.9l53.7-53.7 4.7-4.7H464h73.4l-4.7-4.7L505.4 160H480 464V128h16 32 6.6l4.7 4.7L550.6 160h34.7H592h16V112c0-26.5-21.5-48-48-48H542.2 531.8l-4.2-9.5L517.6 32H434.9 432zm48 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faPretzel = {
    prefix: 'fasl',
    iconName: 'pretzel',
    icon: [
      512,
      512,
      [129384],
      'e441',
      
      'M149.4 64C84.6 64 32 116.6 32 181.4c0 64.6 28 122.7 72.7 162.8l27.6-39.9C100.1 273.3 80 229.7 80 181.4c0-38.3 31.1-69.4 69.4-69.4H156c42 0 76 34 76 76v3.6c0 16.2-4.9 32-14.2 45.3l-18.2 26.3-33 47.6L156.9 325l-27.1 39.2-8.7 12.5-19.7 28.4 39.5 27.3 25.4-36.6 6.7-9.7 11.3 3.6c20.9 6.7 43.2 10.3 66.4 10.3H256h5.4c15.5 0 30.6-1.6 45.1-4.7l-30.4-44c-4.8 .4-9.7 .6-14.7 .6H256h-5.4c-8.4 0-16.6-.6-24.7-1.8l-25.6-3.7 14.7-21.2 27.8-40.1 13.2-19 13.2 19 13 18.8 14.7 21.3 14.7 21.2 27.4 39.6 6.7 9.7 25.4 36.6 39.5-27.3-19.7-28.4-8.7-12.5 12.1-9.3C446.5 315 480 252.1 480 181.4C480 116.6 427.4 64 362.6 64H356c-34.7 0-66 14.2-88.6 37.2L256 112.9l-11.4-11.7C222 78.2 190.7 64 156 64h-6.6zM326.1 423.6c-20.6 5.5-42.3 8.4-64.7 8.4H256h-5.4c-22.3 0-44-2.9-64.7-8.4L158 463.9 148.9 477l-13.2-9.1L70 422.4l-13.2-9.1L66 400.1l0 0 20.4-29.5C33.5 324.7 0 257 0 181.4C0 98.9 66.9 32 149.4 32H156c38 0 72.9 13.6 100 36.3C283.1 45.6 318 32 356 32h6.6C445.1 32 512 98.9 512 181.4c0 75.6-33.5 143.3-86.3 189.3L446 400.1l9.1 13.2L442 422.4l-65.8 45.5L363.1 477 354 463.9l0 0-27.9-40.3zM173.3 245l18.2-26.3c5.5-8 8.5-17.4 8.5-27.1V188c0-24.3-19.7-44-44-44h-6.6c-20.7 0-37.4 16.7-37.4 37.4c0 37.3 14.8 71.2 38.8 96.2L173.3 245zM356 144c-24.3 0-44 19.7-44 44v3.6c0 9.7 3 19.1 8.5 27.1l40.7 58.8c24-24.9 38.8-58.8 38.8-96.2c0-20.7-16.7-37.4-37.4-37.4H356zm-76 44c0-42 34-76 76-76h6.6c38.3 0 69.4 31.1 69.4 69.4c0 53.7-24.8 101.5-63.5 132.8L355.1 325l-9.8-14.2L294.2 237c-9.2-13.3-14.2-29.1-14.2-45.3V188z'
      
    ]
  };

  

  
  

  var faQuotes = {
    prefix: 'fasl',
    iconName: 'quotes',
    icon: [
      576,
      512,
      [],
      'e234',
      
      'M0 88C0 39.4 39.4 0 88 0h8 16V32H96 88C57.1 32 32 57.1 32 88v8H96h32v32 64 32H96 32 0V192 168 128 96 88zm32 40v40 24H96V128H32zM160 88c0-48.6 39.4-88 88-88h8 16V32H256h-8c-30.9 0-56 25.1-56 56v8h64 32v32 64 32H256 192 160V192 168 128 96 88zm32 80v24h64V128H192v40zM576 424c0 48.6-39.4 88-88 88h-8H464V480h16 8c30.9 0 56-25.1 56-56v-8H480 448V384 320 288h32 64 32v32 24 40 32 8zm-32-40V344 320H480v64h64zM416 424c0 48.6-39.4 88-88 88h-8H304V480h16 8c30.9 0 56-25.1 56-56v-8H320 288V384 320 288h32 64 32v32 24 40 32 8zm-32-80V320H320v64h64V344z'
      
    ]
  };

  

  
  

  var faGreaterThan = {
    prefix: 'fasl',
    iconName: 'greater-than',
    icon: [
      384,
      512,
      [62769],
      '3e',
      
      'M0 64.3L374.8 241.5l9.2 4.3v20.3l-9.2 4.3L0 447.7V412.3L330.6 256 0 99.7V64.3z'
      
    ]
  };

  

  
  

  var faFile = {
    prefix: 'fasl',
    iconName: 'file',
    icon: [
      384,
      512,
      [61462,128196,128459],
      'f15b',
      
      'M352 192H208 192V176 32H32V480H352V192zm-5.3-32L224 37.3V160H346.7zM32 0H232L384 152V480v32H352 32 0V480 32 0H32z'
      
    ]
  };

  

  
  

  var faBoxOpenFull = {
    prefix: 'fasl',
    iconName: 'box-open-full',
    icon: [
      640,
      512,
      ["box-full"],
      'f49c',
      
      'M256 32c53 0 96 43 96 96v16h32V128C384 57.3 326.7 0 256 0S128 57.3 128 128v16h32V128c0-53 43-96 96-96zM76.6 160.1l-11.9-1.4-4.7 11-48 112L4.5 299.1l18.4 4.4 200 48 10.5 2.5 6.3-8.8L320 232.9l80.3 112.4 6.3 8.8 10.5-2.5 200-48 18.4-4.4L628 281.7l-48-112-4.7-11-11.9 1.4L320 189.2 76.6 160.1zM48.8 276.9l35.8-83.6L291.3 218l-71.4 99.9L48.8 276.9zM544 348.7V423L336 475V336 320H304v16V475L96 423V348.7l-32-9.1V448l256 64 256-64V339.6l-32 9.1zm11.3-155.4l35.8 83.6L420.1 317.9 348.7 218l206.6-24.7zM495.2 37.1l5.1-15.2L469.9 11.8l-5.1 15.2-32 96-5.1 15.2 30.4 10.1 5.1-15.2 32-96z'
      
    ]
  };

  
    var faBoxFull = faBoxOpenFull;
  

  
  

  var faCrab = {
    prefix: 'fasl',
    iconName: 'crab',
    icon: [
      512,
      512,
      [129408],
      'e3ff',
      
      'M192 0H176 112C50.1 0 0 50.1 0 112v64 9.3l8.1 4.6 96.3 55c-6 8.3-11.1 17.4-15 27.1H51.8L23.2 257.7 8.8 250.5-5.5 279.2l14.3 7.2 32 16 3.4 1.7H48 81c-.7 5.2-1 10.6-1 16v8l-22.2 9.2-2.9 1.2-2.2 2.2-32 32L9.4 384 32 406.6l11.3-11.3 29.8-29.8 25.7-10.7 31.1 31.1L90.3 401l-3.2 1.2-2.4 2.4-32 32L41.4 448 64 470.6l11.3-11.3 29.6-29.6 49.8-19 15.1 15.1L134.7 451l-6.7 4.8V464v32 16h32V496 472.2L193.9 448H318.1L352 472.2V496v16h32V496 464v-8.2l-6.7-4.8-35.2-25.1 15.1-15.1 49.8 19 29.6 29.6L448 470.6 470.6 448l-11.3-11.3-32-32-2.4-2.4-3.2-1.2-39.6-15.1 31.1-31.1 25.7 10.7 29.8 29.8L480 406.6 502.6 384l-11.3-11.3-32-32-2.2-2.2-2.9-1.2L432 328v-8c0-5.4-.3-10.8-1-16h33 3.8l3.4-1.7 32-16 14.3-7.2-14.3-28.6-14.3 7.2L460.2 272H422.7c-3.9-9.7-9-18.8-15-27.1l96.3-55 8.1-4.6V176 112C512 50.1 461.9 0 400 0H336 320V24l6.4 4.8 64 48 12.8 9.6 19.2-25.6-12.8-9.6L384 32h16c38.7 0 71 27.5 78.4 64H374.6L363.3 84.7 352 73.4 329.4 96l11.3 11.3 16 16 4.7 4.7H368 480v38.7L385.1 221C366.9 206 344.5 196 320 193V144 128H288v16 48H224V144 128H192v16 49c-24.5 3.1-46.9 13.1-65.1 28L32 166.7V128H144h6.6l4.7-4.7 16-16L182.6 96 160 73.4 148.7 84.7 137.4 96H33.6C41 59.5 73.3 32 112 32h16L102.4 51.2 89.6 60.8l19.2 25.6 12.8-9.6 64-48L192 24V0zM112 322.7V320c0-53 43-96 96-96h96c53 0 96 43 96 96v2.7L306.7 416H205.3L112 322.7z'
      
    ]
  };

  

  
  

  var faLocationDot = {
    prefix: 'fasl',
    iconName: 'location-dot',
    icon: [
      384,
      512,
      ["map-marker-alt"],
      'f3c5',
      
      'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 20.2 9.1 48.6 26.5 82.7c16.9 33.2 39.9 68.2 63.4 100.5c23.4 32.2 46.9 61 64.5 81.9c1.9 2.3 3.8 4.5 5.6 6.6c1.8-2.1 3.6-4.3 5.6-6.6c17.7-20.8 41.1-49.7 64.5-81.9c23.5-32.3 46.4-67.3 63.4-100.5C342.9 240.6 352 212.2 352 192zm32 0c0 88.8-120.7 237.9-170.7 295.9C200.2 503.1 192 512 192 512s-8.2-8.9-21.3-24.1C120.7 429.9 0 280.8 0 192C0 86 86 0 192 0S384 86 384 192zm-240 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z'
      
    ]
  };

  
    var faMapMarkerAlt = faLocationDot;
  

  
  

  var faDialMedLow = {
    prefix: 'fasl',
    iconName: 'dial-med-low',
    icon: [
      576,
      512,
      [],
      'e160',
      
      'M312 8V56H264V8h48zM120 72v48H72V72h48zm336 0h48v48H456V72zM568 264v48H520V264h48zM8 264H56v48H8V264zM120 456v48H72V456h48zm336 0h48v48H456V456zM299.3 276.7L310.6 288 288 310.6l-11.3-11.3-89.8-89.8c-39.1 50.2-35.5 122.8 10.6 169c50 50 131 50 181 0s50-131 0-181c-46.2-46.2-118.8-49.7-169-10.6l89.8 89.8zM401.1 401.1A160 160 0 1 1 174.9 174.9 160 160 0 1 1 401.1 401.1z'
      
    ]
  };

  

  
  

  var faCircle0 = {
    prefix: 'fasl',
    iconName: 'circle-0',
    icon: [
      512,
      512,
      [],
      'e0ed',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-53 0-96 43-96 96v64c0 53 43 96 96 96s96-43 96-96V224c0-53-43-96-96-96zm-64 96c0-35.3 28.7-64 64-64s64 28.7 64 64v64c0 35.3-28.7 64-64 64s-64-28.7-64-64V224z'
      
    ]
  };

  

  
  

  var faHandshakeAngle = {
    prefix: 'fasl',
    iconName: 'handshake-angle',
    icon: [
      640,
      512,
      ["hands-helping"],
      'f4c4',
      
      'M499.3 35.3L510.6 24 488 1.4 476.7 12.7 425.4 64H224 208V80 304v16h16 96 16V304 224H480v64H464 448v16 56H416 400v16 40H384 368 320 224h-6.6l-4.7 4.7-56 56L145.4 488 168 510.6l11.3-11.3L230.6 448H320h48 16 32 16V432 392h32 16V376 320h16 16V304 278.6 233.4 208 192H496 336V168 152H304v16V288H240V96H432h6.6l4.7-4.7 56-56zM544 201.4v45.3l83.3-83.3L638.6 152 616 129.4l-11.3 11.3L544 201.4zM112 128H96v16V265.4L12.7 348.7 1.4 360 24 382.6l11.3-11.3 88-88 4.7-4.7V272 160h48V128H112z'
      
    ]
  };

  
    var faHandsHelping = faHandshakeAngle;
  

  
  

  var faAccentGrave = {
    prefix: 'fasl',
    iconName: 'accent-grave',
    icon: [
      192,
      512,
      [],
      '60',
      
      'M64 77.8L144.6 192h9.2L125.2 32H64V77.8zM152 0l34.3 192 5.7 32H159.5 128L32 88V32 0H64h88z'
      
    ]
  };

  

  
  

  var faPaintRoller = {
    prefix: 'fasl',
    iconName: 'paint-roller',
    icon: [
      512,
      512,
      [],
      'f5aa',
      
      'M384 32V64 96v32H32V32H384zm32 32V32 0H384 32 0V32v96 32H32 384h32V128 96 64zM256 480H192V352h64V480zM192 320H160v32V480v32h32 64 32V480 352 320H256 240V256H496h16V240 80 64H496 448V96h32V224H224 208v16 80H192z'
      
    ]
  };

  

  
  

  var faTrafficLightStop = {
    prefix: 'fasl',
    iconName: 'traffic-light-stop',
    icon: [
      320,
      512,
      [],
      'f63a',
      
      'M32 32V352c0 70.7 57.3 128 128 128s128-57.3 128-128V32H32zM0 0H32 288h32V32 352c0 88.4-71.6 160-160 160S0 440.4 0 352V32 0zM136 392a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM160 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 80a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm0-136a56 56 0 1 1 0-112 56 56 0 1 1 0 112z'
      
    ]
  };

  

  
  

  var faPhoneSlash = {
    prefix: 'fasl',
    iconName: 'phone-slash',
    icon: [
      640,
      512,
      [],
      'f3dd',
      
      'M63.9 64l0-32 176-32 64 160-55.6 55.6c2 3.5 4.1 7 6.3 10.4l-25.2 19.9c-3-4.7-6-9.5-8.8-14.4l-12.3-21.3 17.3-17.3 40.7-40.7L219.9 36.2 95.9 58.7l0 5.3c0 85.8 26 165.5 70.5 231.7l-25.2 19.9C92.4 243.9 63.9 157.3 63.9 64zM227.7 410.3L253.4 390c71 56.3 160.8 90 258.4 90h5.3l22.5-124L423.6 309.5l-40.7 40.7-17.3 17.4-21.3-12.3c-8.9-5.1-17.6-10.7-25.9-16.6L344.7 318c5.1 3.4 10.3 6.6 15.6 9.6L415.9 272l160 64-32 176h-32C404 512 305 473.9 227.7 410.3zM599.5 18l12.6-9.8 19.7 25.2-12.6 9.8L40.1 494.3l-12.6 9.8L7.8 478.9 20.4 469 599.5 18z'
      
    ]
  };

  

  
  

  var faStarOfLife = {
    prefix: 'fasl',
    iconName: 'star-of-life',
    icon: [
      512,
      512,
      [],
      'f621',
      
      'M192 0h16 96 16V16 145.1L431.8 80.6l13.9-8 8 13.9 48 83.1 8 13.9-13.9 8L384 256l111.8 64.6 13.9 8-8 13.9-48 83.1-8 13.9-13.9-8L320 366.9V496v16H304 208 192V496 366.9L80.2 431.4l-13.9 8-8-13.9-48-83.1-8-13.9 13.9-8L128 256 16.2 191.4l-13.9-8 8-13.9 48-83.1 8-13.9 13.9 8L192 145.1V16 0zm32 32V172.9v27.7l-24-13.9L78 116.3 46 171.7l122 70.4L192 256l-24 13.9L46 340.3l32 55.4 122-70.4 24-13.9v27.7V480h64V339.1 311.4l24 13.9 122 70.4 32-55.4L344 269.9 320 256l24-13.9 122-70.4-32-55.4L312 186.7l-24 13.9V172.9 32H224z'
      
    ]
  };

  

  
  

  var faPlugCircleXmark = {
    prefix: 'fasl',
    iconName: 'plug-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e560',
      
      'M128 16V0H96V16v96h32V16zm160 0V0H256V16v96h32V16zM16 144H0v32H16 32v64c0 83 63.1 151.2 144 159.2V496v16h32V496 399.2c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128V176H320v56.2c9.8-8.1 20.6-15.2 32-21V176h16 16V144H368 352 320 64 32 16zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7L502.6 320 480 297.4l-11.3 11.3L432 345.4l-36.7-36.7L384 297.4 361.4 320l11.3 11.3L409.4 368l-36.7 36.7L361.4 416 384 438.6l11.3-11.3L432 390.6l36.7 36.7L480 438.6 502.6 416l-11.3-11.3L454.6 368l36.7-36.7z'
      
    ]
  };

  

  
  

  var faHexagonCheck = {
    prefix: 'fasl',
    iconName: 'hexagon-check',
    icon: [
      512,
      512,
      [],
      'e416',
      
      'M36.9 256L146.6 64H365.4L475.1 256 365.4 448H146.6L36.9 256zM128 32L0 256 128 480H384L512 256 384 32H128zM363.3 203.3L374.6 192 352 169.4l-11.3 11.3L224 297.4l-52.7-52.7L160 233.4 137.4 256l11.3 11.3 64 64L224 342.6l11.3-11.3 128-128z'
      
    ]
  };

  

  
  

  var faBowlSpoon = {
    prefix: 'fasl',
    iconName: 'bowl-spoon',
    icon: [
      512,
      512,
      [129379],
      'e3e0',
      
      'M112 160c-49 0-80-33.1-80-64s31-64 80-64h80V96v64H112zM112 0C50.1 0 0 43 0 96s50.1 96 112 96h80 32V160 112H496h16V80H496 224V32 0H192 112zm48 453l-17.8-8.8C82.1 414.5 39.7 354.3 35.5 283.3L33.9 256H478.1l-1.6 27.3c-4.2 71-46.6 131.2-106.6 160.9L352 453v19.9V480H160v-7.1V453zM1.9 256l1.7 29.2C8.5 368.1 58 438.2 128 472.9V480v32h32H352h32V480v-7.1c70-34.6 119.5-104.8 124.4-187.7l1.7-29.2 1.9-32H479.9 32.1 0l1.9 32z'
      
    ]
  };

  

  
  

  var faSuperscript = {
    prefix: 'fasl',
    iconName: 'superscript',
    icon: [
      512,
      512,
      [],
      'f12b',
      
      'M400 0H384V32h16 32V160H400 384v32h16 48 48 16V160H496 464V16 0H448 400zM16 64H0V96H16 55.2L157 256 55.2 416H16 0v32H16 64h8.8l4.7-7.4L176 285.8l98.5 154.8 4.7 7.4H288h48 16V416H336 296.8L195 256 296.8 96H336h16V64H336 288h-8.8l-4.7 7.4L176 226.2 77.5 71.4 72.8 64H64 16z'
      
    ]
  };

  

  
  

  var faArrowsFromLine = {
    prefix: 'fasl',
    iconName: 'arrows-from-line',
    icon: [
      448,
      512,
      [],
      'e0a4',
      
      'M224 1.4l11.3 11.3 80 80L326.6 104 304 126.6l-11.3-11.3L240 62.6V176v16H208V176 62.6l-52.7 52.7L144 126.6 121.4 104l11.3-11.3 80-80L224 1.4zm0 509.3l-11.3-11.3-80-80L121.4 408 144 385.4l11.3 11.3L208 449.4 208 336V320h32v16l0 113.4 52.7-52.7L304 385.4 326.6 408l-11.3 11.3-80 80L224 510.6zM16 240H432h16v32H432 16 0V240H16z'
      
    ]
  };

  

  
  

  var faFilePpt = {
    prefix: 'fasl',
    iconName: 'file-ppt',
    icon: [
      512,
      512,
      [],
      'e64a',
      
      'M352 192v96h32V152L232 0H32 0V32 480v32H32 96V480H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM288 352v16 80 48 16h32V496 464h16c30.9 0 56-25.1 56-56s-25.1-56-56-56H304 288zm32 80V384h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H320zM160 352v16 80 48 16h32V496 464h16c30.9 0 56-25.1 56-56s-25.1-56-56-56H176 160zm32 80V384h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H192zm224-80v32h16 16V496v16h32V496 384h16 16V352H496 464 432 416z'
      
    ]
  };

  

  
  

  var faPinata = {
    prefix: 'fasl',
    iconName: 'pinata',
    icon: [
      512,
      512,
      [],
      'e3c3',
      
      'M160 0h16 64 16V16 224H496h16v16V496v16H496 400 384V496 416H224v80 16H208 112 96V496 225.9L8.8 182.3 0 177.9V168 80 64H16 160V16 0zm32 32V80 96H176 32v62.1l87.2 43.6 8.8 4.4V216v8.4l18.1-7.2 5.4-2.2 5.6 1.9L199.5 231l24.5-9.8V32H192zM128 307.6l26.1-10.4 6.7-2.7 6.4 3.2 25.6 12.8 33.3-13.3 6.7-2.7 6.4 3.2 25.6 12.8 33.3-13.3 6.7-2.7 6.4 3.2 25.6 12.8 33.3-13.3 6.7-2.7 6.4 3.2 25.6 12.8 33.3-13.3 6.7-2.7 6.4 3.2L480 310.1V256H240 224v-.4l-18.1 7.2-5.4 2.2-5.6-1.9L152.5 249 128 258.8v48.7zm0 34.5v50.3l18.1-7.2 5.4-2.2 5.6 1.9L192 396.5V384h16H400h16v12.5l34.9-11.6 5.6-1.9 5.4 2.2 18.1 7.2V345.2l-.7 .3-6.4-3.2-25.6-12.8-33.3 13.3-6.7 2.7-6.4-3.2-25.6-12.8-33.3 13.3-6.7 2.7-6.4-3.2-25.6-12.8-33.3 13.3-6.7 2.7-6.4-3.2-25.6-12.8-33.3 13.3-6.7 2.7-6.4-3.2-25.6-12.8L128 342zm352 84.8L455.5 417 416 430.2V480h64V426.8zm-288 3.4L152.5 417 128 426.8V480h64V430.2zM152 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faXmarkLarge = {
    prefix: 'fasl',
    iconName: 'xmark-large',
    icon: [
      448,
      512,
      [],
      'e59b',
      
      'M27.3 36.7L16 25.4-6.6 48 4.7 59.3 201.4 256 4.7 452.7-6.6 464 16 486.6l11.3-11.3L224 278.6 420.7 475.3 432 486.6 454.6 464l-11.3-11.3L246.6 256 443.3 59.3 454.6 48 432 25.4 420.7 36.7 224 233.4 27.3 36.7z'
      
    ]
  };

  

  
  

  var faCandyBar = {
    prefix: 'fasl',
    iconName: 'candy-bar',
    icon: [
      640,
      512,
      [127851,"chocolate-bar"],
      'e3e8',
      
      'M159.2 64h11.3H320h16 16H608h32V96 416v32H608 352 336 320 16 0V432 234.5 223.2l10.7-3.8C41.8 208.5 64 178.8 64 144V128H80c34.8 0 64.5-22.2 75.5-53.3L159.2 64zM192 96v96H320V96H192zm-32 30.4c-17 17.4-39.7 29.2-65 32.6c-1.6 11.7-4.9 22.8-9.8 33H160V126.4zm-96 96c-9.2 9.4-20 17.1-32 22.8V320H160V224H64v-1.6zM32 352v64H160V352H32zm160 64H320V352H192v64zm128-96V224H192v96H320zm32 96H608V96H352V416z'
      
    ]
  };

  
    var faChocolateBar = faCandyBar;
  

  
  

  var faBell = {
    prefix: 'fasl',
    iconName: 'bell',
    icon: [
      448,
      512,
      [61602,128276],
      'f0f3',
      
      'M208 0h32V32.8c80.9 8 144 76.2 144 159.2v97.4l59.3 59.3 4.7 4.7V360v40 16H432 16 0V400 360v-6.6l4.7-4.7L64 289.4V192c0-83 63.1-151.2 144-159.2V0zm16 64C153.3 64 96 121.3 96 192V296v6.6l-4.7 4.7L32 366.6V384H416V366.6l-59.3-59.3-4.7-4.7V296 192c0-70.7-57.3-128-128-128zM160 448h32c0 17.7 14.3 32 32 32s32-14.3 32-32h32c0 35.3-28.7 64-64 64s-64-28.7-64-64z'
      
    ]
  };

  

  
  

  var faTemperatureFull = {
    prefix: 'fasl',
    iconName: 'temperature-full',
    icon: [
      320,
      512,
      ["temperature-4","thermometer-4","thermometer-full"],
      'f2c7',
      
      'M96 275l-10.7 9.5C62.4 305.1 48 334.9 48 368c0 61.9 50.1 112 112 112s112-50.1 112-112c0-33.2-14.4-62.9-37.3-83.5L224 275V260.7 32H96V260.7 275zM224 0h32V32 260.7c29.5 26.4 48 64.7 48 107.3c0 79.5-64.5 144-144 144S16 447.6 16 368c0-42.6 18.5-81 48-107.3V32 0H96 224zM160 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62V96 80h32V96 306c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTemperature4 = faTemperatureFull;
  
    var faThermometer4 = faTemperatureFull;
  
    var faThermometerFull = faTemperatureFull;
  

  
  

  var faBee = {
    prefix: 'fasl',
    iconName: 'bee',
    icon: [
      576,
      512,
      [],
      'e0b2',
      
      'M227.3 12.7L216 1.4 193.4 24l11.3 11.3 23.5 23.5C215.6 73 208 91.6 208 112c0 3 .2 6 .5 8.9C185.7 105 157 96 128 96C63 96 0 140.9 0 208c0 61.9 53.6 104.9 112.9 111.2c-.6-5.1-.9-10.2-.9-15.2c0-5.7 .3-11.4 .8-17C66.7 280.9 32 247.6 32 208c0-43.8 42.5-80 96-80c40.8 0 75.2 21.1 89.3 50.5C173.5 203.3 144 250.2 144 304c0 96 144 208 144 208s144-112 144-208c0-53.8-29.5-100.7-73.3-125.5c14-29.5 48.5-50.5 89.3-50.5c53.5 0 96 36.2 96 80c0 39.6-34.7 72.9-80.8 79c.5 5.6 .8 11.3 .8 17c0 5-.3 10.1-.9 15.2C522.4 312.9 576 269.9 576 208c0-67.1-63-112-128-112c-29 0-57.7 9-80.5 24.9c.3-2.9 .5-5.9 .5-8.9c0-20.4-7.6-39-20.2-53.2l23.5-23.5L382.6 24 360 1.4 348.7 12.7 321.9 39.5C311.6 34.7 300.1 32 288 32s-23.6 2.7-33.9 7.5L227.3 12.7zM288 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM177.1 288c1.6-11.3 4.9-22.1 9.6-32H389.2c4.7 9.9 8 20.7 9.6 32H177.1zm32.5-64c20.2-19.8 47.9-32 78.4-32s58.2 12.2 78.4 32H209.6zm188.6 96c-2.1 9.9-6 20.6-11.7 32H189.5c-5.7-11.4-9.6-22.1-11.7-32H398.2zm-31 64c-7.7 11-16.3 21.8-25.2 32H234c-8.9-10.2-17.5-21-25.2-32H367.2zm-55.4 64c-8.2 8.1-16 15.2-22.6 21.1l-1.2 1.1-1.2-1.1c-6.6-5.9-14.3-13-22.6-21.1h47.6z'
      
    ]
  };

  

  
  

  var faPodcast = {
    prefix: 'fasl',
    iconName: 'podcast',
    icon: [
      448,
      512,
      [],
      'f2ce',
      
      'M416 224c0 73.9-41.7 138-102.8 170.1l-5.4 37.7C390 398.6 448 318.1 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224c0 94.1 58 174.6 140.2 207.8l-5.4-37.7C73.7 362 32 297.9 32 224C32 118 118 32 224 32s192 86 192 192zm-48 0c0-79.5-64.5-144-144-144S80 144.5 80 224c0 43 18.8 81.5 48.7 107.9L135 324l13.7-17.1c-22.5-20.5-36.7-50-36.7-82.9c0-61.9 50.1-112 112-112s112 50.1 112 112c0 32.9-14.2 62.4-36.7 82.9L313 324l6.3 7.9C349.2 305.5 368 267 368 224zM224 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm12.2 192H211.8L193.6 353.2 207.4 336h33.2l13.7 17.2L236.2 480zM160 344l24 168h80l24-168-32-40H192l-32 40z'
      
    ]
  };

  

  
  

  var faCalendarUsers = {
    prefix: 'fasl',
    iconName: 'calendar-users',
    icon: [
      640,
      512,
      [],
      'e5e2',
      
      'M224 16V0H192V16 64H128 96V96v64 32h16 16 32H480h32 16 16V160 96 64H512 448V16 0H416V16 64H224V16zM379.2 512l11.2-32H249.6l11.2 32H379.2zM128 96H512v64H128V96zM112 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM55.1 448H168.9l10.7 32H44.4l10.7-32zm158.3 32L192 416H112 32L10.7 480 0 512H33.7 190.3 224l-10.7-32zM192 304A80 80 0 1 0 32 304a80 80 0 1 0 160 0zm288 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM460.4 480l10.7-32H584.9l10.7 32H460.4zM608 416H528 448l-21.3 64L416 512h33.7H606.3 640l-10.7-32L608 416zm-80-32a80 80 0 1 0 0-160 80 80 0 1 0 0 160z'
      
    ]
  };

  

  
  

  var faSquareEllipsisVertical = {
    prefix: 'fasl',
    iconName: 'square-ellipsis-vertical',
    icon: [
      448,
      512,
      [],
      'e26f',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM200 328h48v48H200V328zm0-48V232h48v48H200zm0-144h48v48H200V136z'
      
    ]
  };

  

  
  

  var faClockTwo = {
    prefix: 'fasl',
    iconName: 'clock-two',
    icon: [
      512,
      512,
      [],
      'e35a',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112V226.1l71.1-47.4 13.3-8.9 17.8 26.6-13.3 8.9-96 64L240 285.9V256 112 96h32v16z'
      
    ]
  };

  

  
  

  var faSquareC = {
    prefix: 'fasl',
    iconName: 'square-c',
    icon: [
      448,
      512,
      [],
      'e266',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM128 256c0 53 43 96 96 96c31.4 0 59.3-15.1 76.8-38.5l25.6 19.2C303.1 363.8 265.9 384 224 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c41.9 0 79.1 20.2 102.4 51.2l-25.6 19.2C283.3 175.1 255.4 160 224 160c-53 0-96 43-96 96z'
      
    ]
  };

  

  
  

  var faSquareH = {
    prefix: 'fasl',
    iconName: 'square-h',
    icon: [
      448,
      512,
      ["h-square"],
      'f0fd',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM336 144V256 368v16H304V368 272l-160 0 0 96v16H112V368 272 240l0-96V128h32v16 96l160 0V144 128h32v16z'
      
    ]
  };

  
    var faHSquare = faSquareH;
  

  
  

  var faBookCopy = {
    prefix: 'fasl',
    iconName: 'book-copy',
    icon: [
      576,
      512,
      [],
      'e0be',
      
      'M256 0H560h16V16 304v16H560 544v64h16 16v32H560 528 256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64zM224 64V296.6c9.4-5.4 20.3-8.6 32-8.6H528h16V32H256c-17.7 0-32 14.3-32 32zm32 320H512V320H256c-17.7 0-32 14.3-32 32s14.3 32 32 32zM64 96h96v32H64c-17.7 0-32 14.3-32 32V392.6c9.4-5.4 20.3-8.6 32-8.6H165.5c4.2 11.9 10.7 22.8 19 32H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H320V448h32v32h16 16v32H368 336 64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64z'
      
    ]
  };

  

  
  

  var faBed = {
    prefix: 'fasl',
    iconName: 'bed',
    icon: [
      640,
      512,
      [128716],
      'f236',
      
      'M32 48V32H0V48 336v64 64 16H32V464 416H608v48 16h32V464 400 336 240c0-61.9-50.1-112-112-112H272 256v16V320H32V48zM608 384H32V352H272 608v32zm0-144v80H288V160H528c44.2 0 80 35.8 80 80zM96 208a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 64 208a80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faPersonFairy = {
    prefix: 'fasl',
    iconName: 'person-fairy',
    icon: [
      640,
      512,
      [],
      'e608',
      
      'M320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 320 0zM254.7 192l-5.3 128H256h32 64 32 6.6l-5.3-128H254.7zM248 352H216l1.3-32L224 160H416l6.7 160 1.3 32H392h-8V496v16H352V496 352H288V496v16H256V496 352h-8zm.2-224H203.1C158.4 88.2 99.5 64 34.9 64H32v48c0 76.5 35.7 144.6 91.5 188.6l12.1 9.5 12.1 9.5-9.1 12.4-9.1 12.4C108.5 373.6 96 409.3 96 448h16c42.5 0 81.6-15.1 112-40.2v39.5C191.7 468 153.2 480 112 480H80 64V464 448c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V48 32H16 34.9c84.9 0 161.1 37.1 213.4 96zM605.1 64c-64.6 0-123.5 24.2-168.2 64H391.7C444 69.1 520.2 32 605.1 32H624h16V48v64c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448v16 16H560 528c-41.2 0-79.7-12-112-32.7V407.8c30.4 25.1 69.5 40.2 112 40.2h16c0-38.7-12.5-74.4-33.6-103.5l-9.1-12.4-9.1-12.4 12.1-9.5 12.1-9.5C572.3 256.6 608 188.5 608 112V64h-2.9z'
      
    ]
  };

  

  
  

  var faMedal = {
    prefix: 'fasl',
    iconName: 'medal',
    icon: [
      512,
      512,
      [127941],
      'f5a2',
      
      'M160 0H38.5 0L21.3 32l98.1 147.1c8-7 16.6-13.4 25.7-19.1L59.8 32h83.1l67.4 101c11.4-2.6 23.2-4.2 35.3-4.8l-8.7-13.1L160 0zM392.6 179.1L490.7 32 512 0H473.5 352L275.2 115.2l-8.7 13.1c12.1 .6 23.8 2.2 35.3 4.8L369.1 32h83.1L366.9 160c9.1 5.7 17.7 12.1 25.7 19.1zM256 192a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 320a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm14.3-271.1L256 211.8l-14.3 29.1-22.1 44.9L170 293l-32.1 4.7 23.2 22.6L197 355.2l-8.5 49.3-5.5 32 28.7-15.1L256 398.1l44.3 23.3L329 436.4l-5.5-32L315 355.2l35.8-34.9 23.2-22.6L342 293l-49.5-7.2-22.1-44.9zm-25.9 66.6L256 284.2l11.5 23.3 3.7 7.5 8.3 1.2 25.7 3.7-18.6 18.2-6 5.9 1.4 8.3 4.4 25.6-23-12.1-7.4-3.9-7.4 3.9-23 12.1 4.4-25.6 1.4-8.3-6-5.9L206.7 320l25.7-3.7 8.3-1.2 3.7-7.5z'
      
    ]
  };

  

  
  

  var faTemperatureArrowUp = {
    prefix: 'fasl',
    iconName: 'temperature-arrow-up',
    icon: [
      576,
      512,
      ["temperature-up"],
      'e040',
      
      'M101.3 284.5L112 275V260.7 32H240V260.7 275l10.7 9.5c23 20.6 37.3 50.3 37.3 83.5c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-33.2 14.4-62.9 37.3-83.5zM272 0H240 112 80V32 260.7C50.5 287.1 32 325.4 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-42.6-18.5-81-48-107.3V32 0zM144 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V96 80H160V96 306c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64zM420.7 36.7l-96 96 22.6 22.6L416 86.6V464v16h32V464 86.6l68.7 68.7 22.6-22.6-96-96L432 25.4 420.7 36.7z'
      
    ]
  };

  
    var faTemperatureUp = faTemperatureArrowUp;
  

  
  

  var faFileCircleXmark = {
    prefix: 'fasl',
    iconName: 'file-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e5a1',
      
      'M352 192v19.2c10.1-5.2 20.8-9.4 32-12.6V152L232 0H32 0V32 480v32H32 330.8c-12.9-9.1-24.5-19.9-34.6-32H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7L502.6 320 480 297.4l-11.3 11.3L432 345.4l-36.7-36.7L384 297.4 361.4 320l11.3 11.3L409.4 368l-36.7 36.7L361.4 416 384 438.6l11.3-11.3L432 390.6l36.7 36.7L480 438.6 502.6 416l-11.3-11.3L454.6 368l36.7-36.7z'
      
    ]
  };

  

  
  

  var faTruckDroplet = {
    prefix: 'fasl',
    iconName: 'truck-droplet',
    icon: [
      640,
      512,
      [],
      'e58c',
      
      'M384 32V384H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H32V32H384zM32 416H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32 16 16V384H624 608V224v-5.9l-3.9-4.5-96-112L503.4 96H496 416V32 0H384 32 0V32 384v32H32zM416 128h72.6l82.3 96H416V128zm0 216.4V256H576V384h-5.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM256 211c0 23.7-20.3 45-48 45s-48-21.3-48-45c0-2.9 2.1-11.8 9.4-27.2c6.7-14.1 15.9-29.9 25.6-45.1c4.4-6.9 8.8-13.6 13-19.7c4.2 6.2 8.6 12.8 13 19.7c9.7 15.2 18.9 31 25.6 45.1c7.3 15.4 9.4 24.3 9.4 27.2zm-128 0c0 42.5 35.8 77 80 77s80-34.5 80-77c0-28.8-36.6-85.9-60.3-119.8C216.4 74.9 208 64 208 64s-8.4 10.9-19.7 27.1C164.6 125.1 128 182.2 128 211z'
      
    ]
  };

  

  
  

  var faDrone = {
    prefix: 'fasl',
    iconName: 'drone',
    icon: [
      512,
      512,
      [],
      'f85f',
      
      'M112 32c39.6 0 72.5 28.8 78.9 66.6l31.6-5.3C213.6 40.4 167.5 0 112 0C50.1 0 0 50.1 0 112c0 55.5 40.4 101.6 93.4 110.5l5.3-31.6C60.8 184.5 32 151.6 32 112c0-44.2 35.8-80 80-80zm286.7 0c44.2 0 80 35.8 80 80c0 39.6-28.8 72.5-66.6 78.9l5.3 31.6c53-8.9 93.4-54.9 93.4-110.5c0-61.9-50.1-112-112-112C343.2 0 297.1 40.4 288.2 93.4l31.6 5.3C326.1 60.8 359 32 398.7 32zM32 398.7c0-39.6 28.8-72.5 66.6-78.9l-5.3-31.6C40.4 297.1 0 343.2 0 398.7c0 61.9 50.1 112 112 112c55.5 0 101.6-40.4 110.5-93.4L190.9 412c-6.3 37.8-39.3 66.6-78.9 66.6c-44.2 0-80-35.8-80-80zm366.7 80c-39.6 0-72.5-28.8-78.9-66.6l-31.6 5.3c8.9 53 54.9 93.4 110.5 93.4c61.9 0 112-50.1 112-112c0-55.5-40.4-101.6-93.4-110.5L412 319.8c37.8 6.3 66.6 39.3 66.6 78.9c0 44.2-35.8 80-80 80zM120.3 142.9L160 182.6V329.4l-39.7 39.7c-2.6-.7-5.4-1.1-8.3-1.1c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3L182.6 352H329.4l39.7 39.7c-.7 2.6-1.1 5.4-1.1 8.3c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32c-2.9 0-5.6 .4-8.3 1.1L352 329.4V182.6l39.7-39.7c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L329.4 160H182.6l-39.7-39.7c.7-2.6 1.1-5.4 1.1-8.3c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32c2.9 0 5.6-.4 8.3-1.1zM192 320V192H320V320H192z'
      
    ]
  };

  

  
  

  var faDiceD20 = {
    prefix: 'fasl',
    iconName: 'dice-d20',
    icon: [
      512,
      512,
      [],
      'f6cf',
      
      'M240 502.9l16 9.1 16-9.1L480 384V368s0 0 0 0V147.7 128l-15.3-8.7L269.8 7.9 256 0 242.2 7.9 47.3 119.3 32 128v19.7V368s0 0 0 0v16L240 502.9zM104.1 388.4L240 398.8V466L104.1 388.4zM272 398.8l135.9-10.5L272 466V398.8zm176-88.6l-58.7-97.8L448 170.5V310.2zM373 184.8L302 63.2l134 76.6-63.1 45zM210 63.2L139 184.8 76 139.7 210 63.2zM122.7 212.4L64 310.2V170.5l58.7 41.9zM75 354l69.4-115.6 80.9 127.2L75 354zm98.1-130H338.9L256 354.2 173.1 224zm194.5 14.4L437 354 286.7 365.6l80.9-127.2zM171.9 192L256 47.8 340.1 192H171.9z'
      
    ]
  };

  

  
  

  var faBeerMug = {
    prefix: 'fasl',
    iconName: 'beer-mug',
    icon: [
      512,
      512,
      ["beer-foam"],
      'e0b3',
      
      'M208 0c-26.9 0-51.2 11-68.6 28.8C126.9 20.7 112 16 96 16C51.8 16 16 51.8 16 96s35.8 80 80 80c16 0 30.9-4.7 43.4-12.8C156.8 181 181.1 192 208 192s51.2-11 68.6-28.8C289.1 171.3 304 176 320 176c44.2 0 80-35.8 80-80s-35.8-80-80-80c-16 0-30.9 4.7-43.4 12.8C259.2 11 234.9 0 208 0zM155 60.2c11.5-17 31-28.2 53-28.2s41.5 11.1 53 28.2l11 16.2 13.7-14C294.4 53.5 306.6 48 320 48c26.5 0 48 21.5 48 48s-21.5 48-48 48c-13.4 0-25.6-5.5-34.3-14.4l-13.7-14-11 16.2c-11.5 17-31 28.2-53 28.2s-41.5-11.1-53-28.2l-11-16.2-13.7 14C121.6 138.5 109.4 144 96 144c-26.5 0-48-21.5-48-48s21.5-48 48-48c13.4 0 25.6 5.5 34.3 14.4l13.7 14 11-16.2zM32 187.9V480v32H64 352h32V480 434.5l118.4-51.8 9.6-4.2V368 208 192H496 384v-4.1c-9.7 6.7-20.4 12-32 15.4V423.7c0 .2 0 .5 0 .7V480H64V203.4c-11.6-3.4-22.3-8.7-32-15.4zM208 224H192v16V400v16h32V400 240 224H208zM480 357.5l-96 42V224h96V357.5zM160 240V224H128v16V400v16h32V400 240zm128 0V224H256v16V400v16h32V400 240z'
      
    ]
  };

  
    var faBeerFoam = faBeerMug;
  

  
  

  var faFileHeart = {
    prefix: 'fasl',
    iconName: 'file-heart',
    icon: [
      384,
      512,
      [],
      'e176',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM170.1 296.5L192 316.9l21.9-20.4 5.2-4.8c4.3-4 10-6.3 15.9-6.3h3.5c10.9 0 19.8 8.9 19.8 19.8c0 5.5-2.3 10.7-6.3 14.4l-60 56.1-60-56.1c-4-3.7-6.3-9-6.3-14.4c0-10.9 8.9-19.8 19.8-19.8H149c5.9 0 11.6 2.2 15.9 6.3l5.2 4.8zm-76.4 8.7c0 14.3 5.9 28 16.4 37.8l70.9 66.4L192 419.5l10.9-10.2 70.9-66.4c10.5-9.8 16.4-23.5 16.4-37.8c0-28.6-23.2-51.8-51.8-51.8H235c-14 0-27.5 5.3-37.8 14.9l-5.2 4.8-5.2-4.8c-10.3-9.6-23.8-14.9-37.8-14.9h-3.5c-28.6 0-51.8 23.2-51.8 51.8z'
      
    ]
  };

  

  
  

  var faMessageDots = {
    prefix: 'fasl',
    iconName: 'message-dots',
    icon: [
      512,
      512,
      ["comment-alt-dots","messaging"],
      'f4a3',
      
      'M160 416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448 416zm0-32h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zM128 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm128 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faCommentAltDots = faMessageDots;
  
    var faMessaging = faMessageDots;
  

  
  

  var faHandBackPointLeft = {
    prefix: 'fasl',
    iconName: 'hand-back-point-left',
    icon: [
      512,
      512,
      [],
      'e19f',
      
      'M0 128l0-16 16 0 232 0 8.6 0c2-3.2 4.2-6.4 6.5-9.5l36.1-48.1L304 48l8 0 51.5 0c53 0 101.7 29.1 126.8 75.7l4.5 8.3c11.3 21 17.2 44.4 17.2 68.3L512 336c0 61.9-50.1 112-112 112l-96 0-48 0-16 0 0-16 0-48-16 0-16 0 0-16 0-56-16 0-16 0 0-16 0-72L16 224 0 224l0-16 0-80zm296-16l48 0 16 0 0 32-16 0-68.7 0-9.5 0-1.7 0-16 0L32 144l0 48 160 0 16 0 0 16 0 72 16 0 16 0 0 16 0 56 16 0 16 0 0 16 0 48 32 0 96 0c44.2 0 80-35.8 80-80l0-135.7c0-18.5-4.6-36.8-13.4-53.1l14.1-7.6-14.1 7.6-4.5-8.3C442.6 102.6 404.7 80 363.5 80L320 80l-24 32z'
      
    ]
  };

  

  
  

  var faArrowsLeftRightToLine = {
    prefix: 'fasl',
    iconName: 'arrows-left-right-to-line',
    icon: [
      640,
      512,
      [],
      'e4ba',
      
      'M32 64V80l0 352 0 16H0V432 80 64H32zm198.6 96l-11.3 11.3L150.6 240l338.7 0-68.7-68.7L409.4 160 432 137.4l11.3 11.3 96 96L550.6 256l-11.3 11.3-96 96L432 374.6 409.4 352l11.3-11.3L489.4 272l-338.7 0 68.7 68.7L230.6 352 208 374.6l-11.3-11.3-96-96L89.4 256l11.3-11.3 96-96L208 137.4 230.6 160zM640 80V432v16H608V432 80 64h32V80z'
      
    ]
  };

  

  
  

  var faBluetooth = {
    prefix: 'fasl',
    iconName: 'bluetooth',
    icon: [
      384,
      512,
      [],
      'f293',
      
      'M176-1.9l26.2 21.6 136 112 15.2 12.5L338 156.5 213.6 256 338 355.5l15.4 12.3-15.2 12.5-136 112L176 513.9V480 286.1L58 380.5l-20-25L162.4 256 38 156.5l20-25 118 94.4V32-1.9zm32 294.4V446.1l94.6-77.9L208 292.5zm0-73l94.6-75.7L208 65.9V219.5z'
      
    ]
  };

  

  
  

  var faChartSimpleHorizontal = {
    prefix: 'fasl',
    iconName: 'chart-simple-horizontal',
    icon: [
      448,
      512,
      [],
      'e474',
      
      'M416 224L32 224l0 64 384 0 0-64zm32 64l0 32-32 0L32 320 0 320l0-32 0-64 0-32 32 0 384 0 32 0 0 32 0 64zM224 384L32 384l0 64 192 0 0-64zm32 64l0 32-32 0L32 480 0 480l0-32 0-64 0-32 32 0 192 0 32 0 0 32 0 64zm96-320l0-64L32 64l0 64 320 0zm32 32l-32 0L32 160 0 160l0-32L0 64 0 32l32 0 320 0 32 0 0 32 0 64 0 32z'
      
    ]
  };

  

  
  

  var faMountainSun = {
    prefix: 'fasl',
    iconName: 'mountain-sun',
    icon: [
      640,
      512,
      [],
      'e52f',
      
      'M512 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 480 80a80 80 0 1 0 160 0zM32 449.9l224-329 224 329V480H32V449.9zM0 440v40 32H32 457h23 32 96 32V480 433.7L499.2 221 480 192l-19.2 29-48.3 72.9L275.4 92.4 256 64 236.6 92.4 0 440zm608 40H512V440L432 322.5 480 250 608 443.3V480z'
      
    ]
  };

  

  
  

  var faCabin = {
    prefix: 'fasl',
    iconName: 'cabin',
    icon: [
      512,
      512,
      [],
      'e46d',
      
      'M32 224H64h96 32H320h32 96 32V200.4L256 39.4 32 200.4V224zm0 32H0V224 184L256 0l96 69V48 32h16 96 16V48 160h-1.4L512 184v40 32H480v32 32 32 32 32 32 32 32H448 352 320V480 448 416 384 352 320 288 256H192v32 32 32 32 32 32 32 32H160 64 32V480 448 416 384 352 320 288 256zm128 0H64v32h96V256zm192 0v32h96V256H352zm96-118V64H384V92l64 46zM256 128a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM160 320H64v32h96V320zm0 64H64v32h96V384zM64 480h96V448H64v32zM448 320H352v32h96V320zm0 64H352v32h96V384zm-96 96h96V448H352v32z'
      
    ]
  };

  

  
  

  var faCircleX = {
    prefix: 'fasl',
    iconName: 'circle-x',
    icon: [
      512,
      512,
      [],
      'e12e',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM141 128l95.1 128L141 384h39.9L256 282.8 331.2 384H371L275.9 256 371 128H331.2L256 229.2 180.8 128H141z'
      
    ]
  };

  

  
  

  var faFamilyDress = {
    prefix: 'fasl',
    iconName: 'family-dress',
    icon: [
      512,
      512,
      [],
      'e301',
      
      'M128 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM88.1 192L42.4 352H144v32H96V496v16H64V496 384H33.3 0l9.1-32L64 160H171.3c-2.2 7.6-3.3 15.7-3.3 24c0 3.6 .2 7.2 .7 10.8l-.8-2.8H88.1zm88 29.1c.5 1 .9 2 1.4 2.9H177l-.8-2.9zM340.7 160H448l54.9 192 9.1 32H478.7 448V496v16H416V496 384H368V352H469.6L423.9 192H344.1l-.8 2.8c.4-3.5 .7-7.1 .7-10.8c0-8.3-1.2-16.4-3.3-24zm-4.9 61.1L335 224h-.6c.5-1 1-1.9 1.4-2.9zM384 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM256 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm48 160H208v96h32 32 32V288zM208 416H176V384 288 256h32 96 32v32 96 32H304v80 16H272V496 416H240v80 16H208V496 416z'
      
    ]
  };

  

  
  

  var faBookOpenReader = {
    prefix: 'fasl',
    iconName: 'book-open-reader',
    icon: [
      512,
      512,
      ["book-reader"],
      'f5da',
      
      'M256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160A96 96 0 1 0 256 0a96 96 0 1 0 0 192zm0 48s-56.8-42.6-224-47.5c-10.2-.3-20.9-.5-32-.5v32V432v32c160 0 256 48 256 48s96-48 256-48V432 224 192c-11.1 0-21.8 .2-32 .5C312.8 197.4 256 240 256 240zm224-15.5V432.6c-68.5 2.7-124.2 13.5-164.4 24.5c-17.5 4.8-32.1 9.6-43.6 13.7V268l2.9-2.2c.2-.1 .5-.3 1.1-.7c1.3-.8 3.7-2.2 7.4-4c7.3-3.6 19.6-9 37.9-14.5c32.2-9.7 83.3-19.9 158.8-22.2zM240 470.9c-11.5-4.2-26.1-9-43.6-13.7c-40.3-11-96-21.8-164.4-24.5V224.5c75.5 2.3 126.6 12.5 158.8 22.2c18.3 5.5 30.6 10.8 37.9 14.5c3.7 1.8 6.1 3.2 7.4 4c.6 .3 .9 .6 1.1 .7L240 268V470.9z'
      
    ]
  };

  
    var faBookReader = faBookOpenReader;
  

  
  

  var faMicrophoneStand = {
    prefix: 'fasl',
    iconName: 'microphone-stand',
    icon: [
      512,
      512,
      [127908],
      'f8cb',
      
      'M449.5 186.9L325.1 62.5l4.7-4.7c34.4-34.4 90.1-34.4 124.4 0s34.4 90.1 0 124.5l-4.7 4.7zm-22.6 22.6l-4.7 4.7c-15.2 15.2-34.7 23.7-54.6 25.4l-6.4-6.4-82.6-82.6-6.4-6.4c1.7-19.9 10.2-39.3 25.4-54.6l4.7-4.7L426.9 209.5zM275.1 67.1c-22.1 22.1-33.8 50.7-35 79.7l-4.8 5.7L0 432l80 80L256 363.8V496v16h32V496 336.8l71.4-60.2 5.7-4.8c29-1.2 57.6-12.9 79.7-35l4.7-4.7 11.3-11.3 11.3-11.3 4.7-4.7c46.9-46.9 46.9-122.8 0-169.7S354-11.7 307.1 35.1l-4.7 4.7L291.1 51.1 279.8 62.5l-4.7 4.7zM258.3 320H256v2L81.9 468.6 43.4 430.1 258 175.3 336.7 254l-78.4 66z'
      
    ]
  };

  

  
  

  var faUserHairMullet = {
    prefix: 'fasl',
    iconName: 'user-hair-mullet',
    icon: [
      448,
      512,
      ["business-front","party-back","trian-balbot"],
      'e45c',
      
      'M320 144V128c0-5.5-.5-10.8-1.3-16H256h-8.6l-4.8-7.1L224 76.8l-18.7 28-4.8 7.1H192 129.3c-.9 5.2-1.3 10.5-1.3 16v16c0 53 43 96 96 96s96-43 96-96zm40-32h-9c.7 5.2 1 10.6 1 16v16c0 15.6-2.8 30.6-7.9 44.5c.7 26.5 7.7 46.3 21.3 66.6l10.1 15.1-16.2 8.1-16 8-14.3 7.2-14.3-28.6 14.3-7.2 .6-.3c-4.6-8.7-8.3-17.6-11.1-26.9c-5.7 6.3-12.1 12-19 17l11.8 35.5 5.1 15.2-30.4 10.1-5.1-15.2-10-29.9c-14.5 5.7-30.3 8.8-46.9 8.8s-32.3-3.1-46.9-8.8l-10 29.9-5.1 15.2-30.4-10.1 5.1-15.2 11.8-35.5c-6.9-5-13.2-10.7-19-17c-2.8 9.3-6.5 18.2-11.1 26.9l.6 .3 14.3 7.2-14.3 28.6-14.3-7.2-16-8-16.2-8.1 10.1-15.1c13.5-20.3 20.6-40.2 21.3-66.6C98.8 174.6 96 159.6 96 144V128c0-5.4 .3-10.8 1-16H88V80h16 1.3c19-46.9 65-80 118.7-80s99.7 33.1 118.7 80H344h16v32zM183.4 80l27.2-40.9 4.5-6.7c-31.8 2.9-59.1 21.3-74.3 47.6h42.6zm123.7 0c-15.2-26.3-42.5-44.7-74.3-47.6l4.5 6.7L264.6 80h42.6zM44.4 480H403.6L360.9 352H87.1L44.4 480zM64 320H384l53.3 160L448 512H414.3 33.7 0l10.7-32L64 320z'
      
    ]
  };

  
    var faBusinessFront = faUserHairMullet;
  
    var faPartyBack = faUserHairMullet;
  
    var faTrianBalbot = faUserHairMullet;
  

  
  

  var faPodiumStar = {
    prefix: 'fasl',
    iconName: 'podium-star',
    icon: [
      448,
      512,
      [],
      'f758',
      
      'M208 32h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H208V32zM176 96h32 80c26.5 0 48-21.5 48-48s-21.5-48-48-48H208 176V32h-8c-44.2 0-80 35.8-80 80v48H16 0v32H16 432h16V160H432 120V112c0-26.5 21.5-48 48-48h8V96zM47.3 224L80 512H368l32.7-288H368.5L339.4 480H108.6L79.5 224H47.3zm191.3 25.3L224 217.8l-14.5 31.5-18.8 40.8L146 295.4l-34.4 4.1L137.1 323l33 30.5-8.8 44.1-6.8 34 30.3-16.9L224 392.7l39.2 21.9 30.3 16.9-6.8-34L278 353.5l33-30.5 25.5-23.5L302 295.4l-44.6-5.3-18.8-40.8zM216 311.6l8-17.4 8 17.4 3.8 8.1 8.9 1.1 19.1 2.3-14.1 13-6.6 6.1 1.7 8.8 3.7 18.8-16.8-9.4-7.8-4.4-7.8 4.4-16.8 9.4 3.7-18.8 1.7-8.8-6.6-6.1-14.1-13 19.1-2.3 8.9-1.1 3.8-8.1z'
      
    ]
  };

  

  
  

  var faUserTieHair = {
    prefix: 'fasl',
    iconName: 'user-tie-hair',
    icon: [
      448,
      512,
      [],
      'e45f',
      
      'M320 144c0 53-43 96-96 96s-96-43-96-96V128v0h88 8l4.8-6.4 16-21.3 20.1 10 3.4 1.7H272h46.7c.9 5.2 1.3 10.5 1.3 16v16zM224 32c35.5 0 66.6 19.3 83.2 48H275.8L247.2 65.7l-11.9-6-8 10.7L208 96H133.5c13.2-37.3 48.7-64 90.5-64zm0-32C153.3 0 96 57.3 96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128V128C352 57.3 294.7 0 224 0zM192 304H176v32h16 9.8l-19.9 59.8L144 320H64L10.7 480 0 512H33.7 204.2h39.6H414.3 448l-10.7-32L384 320H304l-37.9 75.8L246.2 336H256h16V304H256 224 192zm14.1 140.2l-4-8L224 370.6l21.9 65.6-4 8L224 480l0 0 0 0-17.9-35.8zM259.8 480l64-128h37.2l42.7 128H259.8zm-71.6 0H44.4L87.1 352h37.2l64 128z'
      
    ]
  };

  

  
  

  var faHandHoldingHand = {
    prefix: 'fasl',
    iconName: 'hand-holding-hand',
    icon: [
      576,
      512,
      [],
      'e4f7',
      
      'M404.8 240H400 192 176V224 160h-.2L72.2 221.7l-13.5 8-8.3-13.3-40-64L2 139l13.5-8.5 152-96 3.9-2.5H176 560h16V64H560 180.6L46 149l23.3 37.2 94-56L167 128h4.4H176h16 64 16 48 16v32H320 272 256 208v48H395.2l92-61.3 4-2.7H496h64 16v32H560 500.8l-92 61.3-4 2.7zM171.2 272H176 384h16v16 64h.2l103.6-61.7 13.5-8 8.3 13.3 40 64L574 373l-13.5 8.5-152 96-3.9 2.5H400 16 0V448H16 395.4L530 363l-23.3-37.2-94 56L409 384h-4.4H400 384 320 304 256 240V352h16 48 16 48V304H180.8l-92 61.3-4 2.7H80 16 0V336H16 75.2l92-61.3 4-2.7z'
      
    ]
  };

  

  
  

  var faCar = {
    prefix: 'fasl',
    iconName: 'car',
    icon: [
      512,
      512,
      [128664,"automobile"],
      'f1b9',
      
      'M112 32H100.1L96.7 43.4 52.1 192H32 0v32V384v16 16 64H32V416H480v64h32V416 400 384 224 192H480 459.9L415.3 43.4 411.9 32H400 112zM426.5 192H85.5L123.9 64H388.1l38.4 128zM480 224V384H32V224H480zM104 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm328-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faAutomobile = faCar;
  

  
  

  var faBoxBallot = {
    prefix: 'fasl',
    iconName: 'box-ballot',
    icon: [
      576,
      512,
      [128499],
      'f735',
      
      'M160 32V224H416V32H160zM128 0h32H416h32V32 224v32H416 160 128V224 32 0zM32 160H96v32H32V320H544V192H480V160h64 32v32V320v16 16V480v32H544 32 0V480 352 336 320 192 160H32zM544 352H32V480H544V352z'
      
    ]
  };

  

  
  

  var faCircleS = {
    prefix: 'fasl',
    iconName: 'circle-s',
    icon: [
      512,
      512,
      [],
      'e121',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192.7 190c2-10.7 9.2-19.1 23.1-24.4c14.3-5.5 34.5-7.2 57.9-3.8c7 1 23.4 4.5 31 6.4l15.5 3.9 7.8-31-15.5-3.9c-8.2-2.1-25.7-5.8-34.1-7c-26.9-4-53.1-2.6-74.1 5.6c-21.5 8.3-38.6 24.2-43.1 48.5c-2.5 13.9-1.2 26.6 4 37.7c5.2 11 13.6 19.1 23 25.2c17.5 11.5 41.3 18.1 62 23.8l0 0 1.5 .4c22.6 6.3 41.6 11.7 54.4 20.1c6 4 9.7 8 11.7 12.3c1.9 4.1 3 9.7 1.5 18.2c-2 10.7-9.2 19.1-23.1 24.4c-14.3 5.5-34.5 7.2-57.9 3.8c-14.3-2.2-41.3-10-56.4-14.8l-15.3-4.8-9.6 30.5 15.3 4.8c15 4.7 44.2 13.3 61.2 15.9l0 0 .1 0c26.9 4 53.1 2.6 74.1-5.6c21.5-8.3 38.6-24.2 43.1-48.5c2.5-13.9 1.2-26.6-4-37.7c-5.2-11-13.6-19.1-23-25.2c-17.5-11.5-41.3-18.1-62-23.8l-1.5-.4c-22.6-6.3-41.6-11.7-54.4-20.1c-6-4-9.7-8-11.7-12.3c-1.9-4.1-3-9.7-1.5-18.2z'
      
    ]
  };

  

  
  

  var faCreditCard = {
    prefix: 'fasl',
    iconName: 'credit-card',
    icon: [
      576,
      512,
      [62083,128179,"credit-card-alt"],
      'f09d',
      
      'M32 64v64H544V64H32zm0 96v64H544V160H32zm0 96V448H544V256H32zM0 32H32 544h32V64 448v32H544 32 0V448 64 32zM96 352h96v32H96V352zm128 0H384v32H224V352z'
      
    ]
  };

  
    var faCreditCardAlt = faCreditCard;
  

  
  

  var faBowlChopsticks = {
    prefix: 'fasl',
    iconName: 'bowl-chopsticks',
    icon: [
      512,
      512,
      [],
      'e2e9',
      
      'M19.1 127.7l480-96L492.9 .3l-480 96 6.3 31.4zM497.1 160L494.9 128l-480 32L17.1 192l480-32zM160 453l-17.8-8.8C82.1 414.5 39.7 354.3 35.5 283.3L33.9 256H478.1l-1.6 27.3c-4.2 71-46.6 131.2-106.6 160.9L352 453v19.9V480H160v-7.1V453zM1.9 256l1.7 29.2C8.5 368.1 58 438.2 128 472.9V480v32h32H352h32V480v-7.1c70-34.6 119.5-104.8 124.4-187.7l1.7-29.2 1.9-32H479.9 32.1 0l1.9 32z'
      
    ]
  };

  

  
  

  var faBug = {
    prefix: 'fasl',
    iconName: 'bug',
    icon: [
      512,
      512,
      [],
      'f188',
      
      'M256 32c-35.3 0-64 28.7-64 64H320c0-35.3-28.7-64-64-64zM160 96c0-53 43-96 96-96s96 43 96 96v32H320 192 160V96zM48 89.4l11.3 11.3L118.6 160H128 384h9.4l59.3-59.3L464 89.4 486.6 112l-11.3 11.3L416 182.6V192v80h80 16v32H496 416v16c0 30.2-8.4 58.4-22.9 82.5l74.2 74.2L478.6 488 456 510.6l-11.3-11.3-71-71C344.5 460.1 302.6 480 256 480s-88.5-19.9-117.7-51.6l-71 71L56 510.6 33.4 488l11.3-11.3 74.2-74.2C104.4 378.4 96 350.2 96 320V304H16 0V272H16 96V192v-9.4L36.7 123.3 25.4 112 48 89.4zM128 304v16c0 65.3 48.9 119.1 112 127V256 240h32v16V447c63.1-7.9 112-61.7 112-127V304 272 192H128v80 32z'
      
    ]
  };

  

  
  

  var faHandsHoldingCircle = {
    prefix: 'fasl',
    iconName: 'hands-holding-circle',
    icon: [
      640,
      512,
      [],
      'e4fb',
      
      'M416 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-224 0a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM112 64h16V80 265.4l36.7-36.7L176 217.4l11.3 11.3L320 361.4 452.7 228.7 464 217.4l11.3 11.3L512 265.4V80 64h16 96 16V80 384v6.6l-4.7 4.7-104 104L520 510.6 497.4 488l11.3-11.3L608 377.4V96H544V288v6.6l-1.4 1.4-3.3 3.3-8 8-72 72L448 390.6l-4.7 4.7L432 406.6 409.4 384l11.3-11.3 4.7-4.7 11.3-11.3L497.4 296 464 262.6l-128 128V496v16H304V496 390.6l-128-128L142.6 296l60.7 60.7 0 0 16 16L230.6 384 208 406.6l-11.3-11.3-16-16 0 0-72-72-8-8L97.4 296 96 294.6V288 96H32V377.4l99.3 99.3L142.6 488 120 510.6l-11.3-11.3-104-104L0 390.6V384 80 64H16h96z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassWaveform = {
    prefix: 'fasl',
    iconName: 'magnifying-glass-waveform',
    icon: [
      512,
      512,
      [],
      'e661',
      
      'M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L487.9 510.5l22.6-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM192 112V96H160v16V304v16h32V304 112zm-64 32V128H96v16V272v16h32V272 144zm128 0V128H224v16V272v16h32V272 144zm64 32V160H288v16 64 16h32V240 176z'
      
    ]
  };

  

  
  

  var faEnvelopeDot = {
    prefix: 'fasl',
    iconName: 'envelope-dot',
    icon: [
      576,
      512,
      ["envelope-badge"],
      'e16f',
      
      'M448 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 416 80a80 80 0 1 0 160 0zM512 416V190.9c-5.2 .7-10.6 1.1-16 1.1c-17.2 0-33.5-3.9-48-10.8l-192 132L32 159.2V96H385.1c-.7-5.2-1.1-10.6-1.1-16s.4-10.8 1.1-16H32 0V96v80V416v32H32 480h32V416zM480 198V416H32V198L256 352 480 198z'
      
    ]
  };

  
    var faEnvelopeBadge = faEnvelopeDot;
  

  
  

  var faToolbox = {
    prefix: 'fasl',
    iconName: 'toolbox',
    icon: [
      512,
      512,
      [129520],
      'f552',
      
      'M128 32l16 0 224 0 16 0 0 16 0 80 48 0 80 80 0 240 0 32-32 0L32 480 0 480l0-32L0 208l80-80 48 0 0-80 0-16zM352 64L160 64l0 64 192 0 0-64zM93.3 160L32 221.3 32 320l128 0 0-32 0-16 32 0 0 16 0 32 128 0 0-32 0-16 32 0 0 16 0 32 128 0 0-98.7L418.7 160 384 160l-32 0-192 0-32 0-34.7 0zM32 352l0 96 448 0 0-96-128 0 0 32 0 16-32 0 0-16 0-32-128 0 0 32 0 16-32 0 0-16 0-32L32 352z'
      
    ]
  };

  

  
  

  var faPersonThroughWindow = {
    prefix: 'fasl',
    iconName: 'person-through-window',
    icon: [
      640,
      512,
      [],
      'e5a9',
      
      'M32 32V416h96l0-144v-8.3l6.8-4.8L320 127.7 320 32 32 32zM352 136l0 8.3-6.8 4.8L267 204.5 328.1 288l71.9 0 7.4 0 4.8 5.6 96 112 8.9 10.4H608V32L352 32l0 104zm15 280H474.9l-82.3-96-51.3 0-54 40.5 93.5 126-25.7 19.1L312.5 448H32 0V416 32 0H32 608h32V32 416v32H608 390.5L367 416zm-98.7-81.2l35.1-26.3L240.9 223l-36.4 25.8 63.8 86zm-89.9-67.5l-18.4 13L160 416H288.7L178.4 267.3zM168 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 88 136z'
      
    ]
  };

  

  
  

  var faBells = {
    prefix: 'fasl',
    iconName: 'bells',
    icon: [
      640,
      512,
      [],
      'f77f',
      
      'M43.6 286.9l55.1-39.4 8.1-5.8 3.4-9.3 36.4-100c17.4-47.8 66.2-75 114.6-66.9c9.6-9.2 20.2-17.3 31.9-24.2c-.8-.3-1.7-.6-2.5-1c-70.5-25.6-148.4 10.7-174 81.2l-36.4 100-67.2 48-2 5.5L0 305 30.1 316l211.9 77.1 8-31.2-206.2-75zm53.2 97.1c0 35.4 28.7 64 64.1 64c23.1 0 43.3-12.2 54.5-30.4L184 406.1c-5.8 6.1-14 9.9-23.1 9.9c-17 0-30.9-13.2-32-30L97.5 374.6c-.4 3-.7 6.2-.7 9.3zm332 68.9c7.4 10.5 17.8 18.6 30 23.1c7 2.6 14.5 4 22.3 4c14.6 0 28-4.9 38.7-13c6.9-5.2 12.7-11.8 17-19.4c5.3-9.3 8.4-20.1 8.4-31.6c0-1.8-.1-3.6-.2-5.4L530.3 416l-17.7 6.4c-3 14.6-15.9 25.6-31.4 25.6c-7.5 0-14.4-2.6-19.9-6.9l0 0-32.4 11.8zm96.6-192.7l3.4 9.3 8 5.8 61 43.8L299.1 427.7l18.6-72.8 2.4-9.6-3.4-9.3L278.1 229.7c-21-57.6 8.7-121.3 66.3-142.2s121.3 8.7 142.3 66.3l38.7 106.4zm-246.5 209L609.9 348.7 640 337.7l-10.9-30.1-2.7-7.5-70.9-50.9L516.7 142.9c-27-74.2-109.1-112.5-183.3-85.5s-112.5 109-85.4 183.2L286.7 347l-21.6 84.5 13.7 37.6 0 0z'
      
    ]
  };

  

  
  

  var faGrid2Plus = {
    prefix: 'fasl',
    iconName: 'grid-2-plus',
    icon: [
      512,
      512,
      [],
      'e197',
      
      'M192 64H64V192H192V64zM64 32H192h32V64 192v32H192 64 32V192 64 32H64zM192 320H64V448H192V320zM64 288H192h32v32V448v32H192 64 32V448 320 288H64zM320 64V192H448V64H320zM288 32h32H448h32V64 192v32H448 320 288V192 64 32zM400 272v16 80h80 16v32H480 400v80 16H368V480 400H288 272V368h16 80V288 272h32z'
      
    ]
  };

  

  
  

  var faKitMedical = {
    prefix: 'fasl',
    iconName: 'kit-medical',
    icon: [
      576,
      512,
      ["first-aid"],
      'f479',
      
      'M128 448V64H448V448H128zm-32 0H32V64H96V448zM112 32H96 32 0V64 448v32H32 96h16 16H448h16 16 64 32V448 64 32H544 480 464 448 128 112zM544 448H480V64h64V448zM256 144H240v16 48H192 176v16 64 16h16 48v48 16h16 64 16V352 304h48 16V288 224 208H384 336V160 144H320 256zm16 80V176h32v48 16h16 48v32H320 304v16 48H272V288 272H256 208V240h48 16V224z'
      
    ]
  };

  
    var faFirstAid = faKitMedical;
  

  
  

  var faChessPawn = {
    prefix: 'fasl',
    iconName: 'chess-pawn',
    icon: [
      320,
      512,
      [9823],
      'f443',
      
      'M240 144A80 80 0 1 0 80 144a80 80 0 1 0 160 0zm16 112H235.4L254 352H221.4l-18.6-96H160 117.2L98.6 352H66l18.6-96H64 48V224H64 81.6C60.9 203.7 48 175.3 48 144C48 82.1 98.1 32 160 32s112 50.1 112 112c0 31.3-12.9 59.7-33.6 80H256h16v32H256zM32 480H288v-9.5L254.2 416H65.8L32 470.5V480zm240-96l48 77.3V480v32H288 32 0V480 461.3L48 384H272z'
      
    ]
  };

  

  
  

  var faNfcSlash = {
    prefix: 'fasl',
    iconName: 'nfc-slash',
    icon: [
      640,
      512,
      [],
      'e1fc',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM544 351.3V64 32H512 139.6l40.5 32H192h64H512V326l32 25.3zm-64-50.5V112 96H464 320 304v16 49.8l32 25.3V128H448V275.5l32 25.3zM378.8 384H192V236.5l-32-25.3V400v16h16H419.4l-40.5-32zM128 186L96 160.7V448v32h32H500.4l-40.5-32H128V186z'
      
    ]
  };

  

  
  

  var faEllipsis = {
    prefix: 'fasl',
    iconName: 'ellipsis',
    icon: [
      448,
      512,
      ["ellipsis-h"],
      'f141',
      
      'M32 288l0-64 64 0 0 64-64 0zm160 0l0-64 64 0 0 64-64 0zm160-64l64 0 0 64-64 0 0-64z'
      
    ]
  };

  
    var faEllipsisH = faEllipsis;
  

  
  

  var faAnchorCircleXmark = {
    prefix: 'fasl',
    iconName: 'anchor-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e4ac',
      
      'M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64 78.4V160v32H208 192v32h16 64V480H96V310.6l28.7 28.7L136 350.6 158.6 328l-11.3-11.3-56-56L80 249.4 68.7 260.7l-56 56L1.4 328 24 350.6l11.3-11.3L64 310.6V496v16H80 288 394.8c-12.9-9.1-24.5-19.9-34.6-32H304V224h64 16V192H368 304V160v-1.6c36.5-7.4 64-39.7 64-78.4c0-44.2-35.8-80-80-80zm96 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7L566.6 320 544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7z'
      
    ]
  };

  

  
  

  var faTentDoublePeak = {
    prefix: 'fasl',
    iconName: 'tent-double-peak',
    icon: [
      576,
      512,
      [],
      'e627',
      
      'M7.9 142.7c52.3-27.8 97.5-67.2 132-115.2c3.6-5 7-10 10.4-15.2l8-12.3 8.5 9.5c4.5 5.1 9.3 9.8 14.3 14.2C210.4 49.5 248.4 64 288 64s77.6-14.5 107-40.3c5-4.4 9.8-9.1 14.3-14.2L417.8 0l8 12.3c3.3 5.2 6.8 10.2 10.4 15.2c34.5 48 79.6 87.4 132 115.2l7.9 4.2V480v32H544 32 0V480 146.9l7.9-4.2zM32 166v26H544V166c-51.4-28.9-95.9-68.3-130.8-115.7C378.4 79.6 334.1 96 288 96s-90.4-16.4-125.2-45.7C127.9 97.7 83.4 137.1 32 166zm0 58V480H272V224H32zM406.1 480L304 275.8V480H406.1zm35.8 0H544V224H313.9l128 256z'
      
    ]
  };

  

  
  

  var faTicketsAirline = {
    prefix: 'fasl',
    iconName: 'tickets-airline',
    icon: [
      640,
      512,
      ["tickets-perforated-plane","tickets-plane"],
      'e29b',
      
      'M128 64V352H608V272.5c-23.7-11.8-40-36.2-40-64.5s16.3-52.7 40-64.5V64H128zM640 168c-22.1 0-40 17.9-40 40s17.9 40 40 40v32 72 32H608 128 96V352 64 32h32H608h32V64v72 32zM480 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM32 96v16V448H528h16v32H528 16 0V464 112 96H32zm224 0h56 9.2l4.6 7.9L358.5 160h32.4c20.3 0 39.8 8.1 54.1 22.4c14.1 14.1 14.1 37 0 51.2c-14.4 14.4-33.8 22.4-54.1 22.4H358.5l-32.7 56.1-4.6 7.9H312 256 233.8l7-21.1L255.1 256H248l-19.2 25.6L224 288h-8H176 155.5l5-19.9 15-60.1-15-60.1-5-19.9H176h40 8l4.8 6.4L248 160h7.1l-14.3-42.9-7-21.1H256zm36.5 74.9l7 21.1H277.3 240h-8l-4.8-6.4L208 160H196.5l11 44.1 1 3.9-1 3.9-11 44.1H208l19.2-25.6L232 224h8 37.3 22.2l-7 21.1L278.2 288h24.6l32.7-56.1 4.6-7.9h9.2 41.6c11.8 0 23.1-4.7 31.5-13c1.6-1.6 1.6-4.3 0-5.9c-8.4-8.4-19.7-13-31.5-13H349.3h-9.2l-4.6-7.9L302.8 128H278.2l14.3 42.9z'
      
    ]
  };

  
    var faTicketsPerforatedPlane = faTicketsAirline;
  
    var faTicketsPlane = faTicketsAirline;
  

  
  

  var faArrowRightLong = {
    prefix: 'fasl',
    iconName: 'arrow-right-long',
    icon: [
      512,
      512,
      ["long-arrow-right"],
      'f178',
      
      'M500.7 267.3L512 256l-11.3-11.3-144-144L345.4 89.4 322.7 112l11.3 11.3L450.7 240 16 240 0 240l0 32 16 0 434.7 0L334.1 388.7 322.7 400l22.6 22.6 11.3-11.3 144-144z'
      
    ]
  };

  
    var faLongArrowRight = faArrowRightLong;
  

  
  

  var faUserLock = {
    prefix: 'fasl',
    iconName: 'user-lock',
    icon: [
      640,
      512,
      [],
      'f502',
      
      'M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM43.3 480L87.6 336H360.4L384 412.8 384 304H64L9.8 480 0 512H33.5 384l0-32H43.3zM528 224c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48H416v32V480v32h32H608h32V480 352 320H608V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z'
      
    ]
  };

  

  
  

  var faThumbsDown = {
    prefix: 'fasl',
    iconName: 'thumbs-down',
    icon: [
      512,
      512,
      [61576,128078],
      'f165',
      
      'M224 480h16 96 16V464 413.6c0-21.1-3-41.8-8.6-61.6H448h48 16V336 240 224H496V168 152H480h-8V104 88H456h-8V48 32H432 384 272 257.5h-4.8l-4 2.7-12.1 8.1L160 93.8v38.5l94.2-62.8 8.1-5.4H272 384h32v40 16h16 8v48 16h16 8v56 16h16v64H448 321 297.3l8.8 22c9 22.5 13.9 46.7 13.9 71.7V448H256V413.6c0-42.8-21.4-82.8-57-106.5l-24.8-16.5-6.5-4.4-1.4-.9-1.6-.6-4.7-1.9v36.8l21.3 14.2C208 351.6 224 381.5 224 413.6V464v16zM32 352V128H96V352H32zM0 384H32 96h32V352 128 96H96 32 0v32V352v32z'
      
    ]
  };

  

  
  

  var faGripLines = {
    prefix: 'fasl',
    iconName: 'grip-lines',
    icon: [
      448,
      512,
      [],
      'f7a4',
      
      'M448 208l0-32L0 176l0 32 448 0zm0 128l0-32L0 304l0 32 448 0z'
      
    ]
  };

  

  
  

  var faHeadSideCough = {
    prefix: 'fasl',
    iconName: 'head-side-cough',
    icon: [
      640,
      512,
      [],
      'e061',
      
      'M32 224C32 118 118 32 224 32h24c88.4 0 160 71.6 160 160v7.2l5.4 4.8L480 263.2V304H432 416v16 8 8 10.1l-98.3 14-13.7 2V376v40 14.7l14.7 1.2 81.3 6.8V456H304 288v16 24 16h32V496v-8h96 16V472 424 409.3l-14.7-1.2L336 401.3V389.9l98.3-14 13.7-2V360 336v0h48 16V320 256v-7.2l-5.4-4.8-66.8-59.3C436 82 351.6 0 248 0H224C100.3 0 0 100.3 0 224c0 61 24.4 116.4 64 156.8V496v16H96V496 374.1v-6.8l-4.9-4.7C54.6 327.6 32 278.4 32 224zm312 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM512 392a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM552 368a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM552 464a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faPanFood = {
    prefix: 'fasl',
    iconName: 'pan-food',
    icon: [
      640,
      512,
      [129368],
      'e42b',
      
      'M522.4 352c4.5-9.4 8.3-19.3 11.5-29.4c.3-.9 .5-1.7 .8-2.6c6-20.3 9.3-41.8 9.3-64s-3.2-43.7-9.3-64c-3.1-10.6-7-20.8-11.6-30.7l-.6-1.3C486.5 84.3 409.4 32 320 32s-166.5 52.3-202.4 128c-4.9 10.2-9 20.9-12.3 32l0 0c-6 20.3-9.3 41.8-9.3 64s3.2 43.7 9.3 64c3.1 10.6 7 20.8 11.6 30.7l.6 1.3c36 75.7 113.1 128 202.4 128s166.5-52.3 202.4-128zm34.9 0c-38 93.8-130 160-237.4 160s-199.4-66.2-237.4-160H32 0V320 192 160H32 82.6C120.6 66.2 212.6 0 320 0S519.4 66.2 557.4 160H608h32v32V320v32H608 557.4zm10.5-160c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H608V192H567.9zM72.1 192H32V320H72.1c-5.3-20.5-8.1-41.9-8.1-64s2.8-43.5 8.1-64zM496 257.3v2.4c0 27.4-14.7 52.6-38.4 66.2c-11.5 6.6-24.6 10-37.8 10l-1.6 0c-14.7 0-29.1-4-41.6-11.3c-6-3.5-11.6-7.8-16.7-12.9L352 304l22.6-22.6L464 192l8.4 8.4 .2 .2c4.8 4.8 8.8 10.1 12.2 15.8c7.3 12.3 11.2 26.4 11.2 40.9zM419.8 304c7.7 0 15.3-2 22-5.8c13.8-7.9 22.3-22.5 22.3-38.4v-2.4c0-5.9-1.1-11.6-3.1-17l-60.5 60.5c5.6 2.1 11.6 3.2 17.7 3.2l1.6 0zM203.3 203.3l-32 32L160 246.6 137.4 224l11.3-11.3 32-32L192 169.4 214.6 192l-11.3 11.3zM296 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM416 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM235.3 299.3l-4.7 4.7 16 16H256h32c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64V352v-9.4l-16-16-4.7 4.7L192 342.6 169.4 320l11.3-11.3 16-16 16-16L224 265.4 246.6 288l-11.3 11.3zM320 384c0-17.7-14.3-32-32-32H256v32c0 17.7 14.3 32 32 32s32-14.3 32-32zm80-240v16H368 272 240V144c0-5.5 .6-10.8 1.6-16C249 91.5 281.3 64 320 64s71 27.5 78.4 64c1 5.2 1.6 10.5 1.6 16zM320 96c-20.9 0-38.7 13.4-45.3 32h90.5c-6.6-18.6-24.4-32-45.3-32z'
      
    ]
  };

  

  
  

  var faPersonDollyEmpty = {
    prefix: 'fasl',
    iconName: 'person-dolly-empty',
    icon: [
      512,
      512,
      [],
      'f4d1',
      
      'M80 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM80 0a56 56 0 1 1 0 112A56 56 0 1 1 80 0zM0 340.3c.5 .4 1.1 .9 1.6 1.3L32 365.5 32 496l0 16L0 512l0-16L0 340.3zM0 144H16 96h8.7l4.7 7.3L176.7 256h44l-20.3-84.2-3.8-15.6 31.1-7.5 3.8 15.6 53.1 219.8c1.1-.1 2.2-.1 3.4-.1c25.7 0 47.9 15.1 58 37l146.1-36.5 7.8 31-148 37c-2.3 33.2-30 59.5-63.8 59.5c-35.3 0-64-28.7-64-64c0-22.9 12-42.9 30-54.3L228.5 288H168h-8.7l-4.7-7.3L112 214.5V340.8l32.9 21.9 5.5 3.7 1.3 6.5L179.5 512H146.9L121.6 385.6 21.4 318.8C8 309.9 0 294.9 0 278.9V160 144zM80 319.4V176H32V278.9c0 5.3 2.7 10.3 7.1 13.3L80 319.4zM288 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faCarTunnel = {
    prefix: 'fasl',
    iconName: 'car-tunnel',
    icon: [
      512,
      512,
      [],
      'e4de',
      
      'M256 32C132.3 32 32 132.3 32 256V496v16H0V496 256C0 114.6 114.6 0 256 0S512 114.6 512 256V496v16H480V496 256C480 132.3 379.7 32 256 32zM175.1 224H336.9h11.6l3.6 11.1L379.6 320H400h16v16V496v16H384V496 480H128v16 16H96V496 336 320h16 20.4l27.5-84.9 3.6-11.1h11.6zM384 448V352H128v96H384zM346 320l-20.7-64H186.7L166 320H346zM160 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm168-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faOmega = {
    prefix: 'fasl',
    iconName: 'omega',
    icon: [
      448,
      512,
      [],
      'f67a',
      
      'M224 64C118 64 32 150 32 256c0 72.6 40.3 135.8 99.9 168.5l8.3 4.6 0 9.5 0 25.5v16h-16H16 0V448H16h92.2v-.2C43.4 408.5 0 337.3 0 256C0 132.3 100.3 32 224 32s224 100.3 224 224c0 81.3-43.4 152.5-108.2 191.8v.2H432h16v32H432 323.8h-16V464 438.5 429l8.3-4.6C375.7 391.8 416 328.6 416 256c0-106-86-192-192-192z'
      
    ]
  };

  

  
  

  var faMountains = {
    prefix: 'fasl',
    iconName: 'mountains',
    icon: [
      640,
      512,
      [9968],
      'f6fd',
      
      'M32 448H480V417.9L256 88.9 32 417.9V448zM0 448V408L236.6 60.4 256 32l19.4 28.4L412.5 261.9 460.8 189 480 160l19.2 29L640 401.7V448v32H608 512 480 457 32 0V448zm512 0h96V411.3L480 218l-48 72.5L512 408v40z'
      
    ]
  };

  

  
  

  var faAngleDown = {
    prefix: 'fasl',
    iconName: 'angle-down',
    icon: [
      448,
      512,
      [8964],
      'f107',
      
      'M224 374.6l11.3-11.3 160-160L406.6 192 384 169.4l-11.3 11.3L224 329.4 75.3 180.7 64 169.4 41.4 192l11.3 11.3 160 160L224 374.6z'
      
    ]
  };

  

  
  

  var faAirConditioner = {
    prefix: 'fasl',
    iconName: 'air-conditioner',
    icon: [
      576,
      512,
      [],
      'f8f4',
      
      'M32 32V224H544V32H32zM0 0H32 544h32V32 224v32H544 32 0V224 32 0zM112 128H464h16v32H464 112 96V128h16zM256 288V432c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-29.6 16.1-55.5 40-69.3l16 27.7c-14.4 8.3-24 23.8-24 41.6c0 26.5 21.5 48 48 48s48-21.5 48-48V288h32zm64 112V288h32V400c0 26.5 21.5 48 48 48s48-21.5 48-48c0-17.7-9.6-33.3-24-41.6l16-27.7c23.9 13.8 40 39.7 40 69.3c0 44.2-35.8 80-80 80s-80-35.8-80-80z'
      
    ]
  };

  

  
  

  var faSquareQuestion = {
    prefix: 'fasl',
    iconName: 'square-question',
    icon: [
      448,
      512,
      ["question-square"],
      'f2fd',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM136 184c0-30.9 25.1-56 56-56h56c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L240 268.3V272v16H208V272 258.5v-9.8l8.7-4.5 45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H192c-13.3 0-24 10.7-24 24v8H136v-8zm64 136h48v48H200V320z'
      
    ]
  };

  
    var faQuestionSquare = faSquareQuestion;
  

  
  

  var faOilTemperature = {
    prefix: 'fasl',
    iconName: 'oil-temperature',
    icon: [
      576,
      512,
      ["oil-temp"],
      'f614',
      
      'M272 0h16 80 16V32H368 304V96h64 16v32H368 304v97.6c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4V112 16 0zm16 352a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM133.8 314.8c13.5 9.2 29.7 17.5 46.6 20.2c3.4 11.9 8.8 23 15.7 32.9c-1.3 .1-2.7 .1-4 .1c-30.3 0-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.8-19.8 15.3C57.6 353.9 30.3 368 0 368V336c20.9 0 41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.7 23.2 24.3 37.8 34.2zM384 368c-1.3 0-2.7 0-4-.1c6.9-9.9 12.2-21 15.7-32.9c16.8-2.8 33.1-11.1 46.5-20.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C534.4 326.1 555.1 336 576 336v32c-30.3 0-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.9 9.9-19.8 15.3C441.5 353.9 414.3 368 384 368zM192 480c20.9 0 41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C342.3 470.1 363.1 480 384 480s41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C534.4 470.1 555.1 480 576 480v32c-30.3 0-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.9 9.9-19.8 15.3C441.5 497.9 414.3 512 384 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 497.9 222.3 512 192 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.8-19.8 15.3C57.6 497.9 30.3 512 0 512V480c20.9 0 41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.7 23.2 24.3 37.8 34.2C150.3 470.1 171.1 480 192 480z'
      
    ]
  };

  
    var faOilTemp = faOilTemperature;
  

  
  

  var faFaceDrooling = {
    prefix: 'fasl',
    iconName: 'face-drooling',
    icon: [
      512,
      512,
      [],
      'e372',
      
      'M32 256c0 123.7 100.3 224 224 224v32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 80.8-37.5 152.9-96 199.9V412.8c39.6-40.4 64-95.7 64-156.8C480 132.3 379.7 32 256 32S32 132.3 32 256zm111.2-42.9l-5.1 15.2-30.4-10.1 5.1-15.2c3.4-10.2 11.1-24.6 23.8-36.5C149.5 154.2 167.9 144 192 144h16v32H192c-14.3 0-25.2 5.8-33.4 13.6c-8.4 8-13.5 17.7-15.4 23.5zm-12.7 84.5l10 12.5c22.8 28.5 61.3 58 115.5 58s92.7-29.5 115.5-58l10-12.5 25 20-10 12.5c-3.8 4.7-7.9 9.5-12.5 14.2V496v16H352V496 370.9c-9.7 6.4-20.3 12.2-32 16.9V464v16H288V464 397.1c-10.1 1.9-20.8 2.9-32 2.9c-67 0-113.8-36.7-140.5-70l-10-12.5 25-20zM353.4 189.6c-8.2-7.8-19-13.6-33.4-13.6H304V144h16c24.1 0 42.5 10.2 55.4 22.4c12.6 12 20.4 26.3 23.8 36.5l5.1 15.2-30.4 10.1-5.1-15.2c-1.9-5.8-7-15.4-15.4-23.5z'
      
    ]
  };

  

  
  

  var faDisplayCode = {
    prefix: 'fasl',
    iconName: 'display-code',
    icon: [
      576,
      512,
      ["desktop-code"],
      'e165',
      
      'M544 32V384H344.3c-.2 0-.4 0-.6 0H232.3c-.2 0-.4 0-.6 0H32V32H544zM32 416H213.1l-10.7 64H144 128v32h16 72H360h72 16V480H432 373.6l-10.7-64H544h32V384 32 0H544 32 0V32 384v32H32zm202.9 64l10.7-64h84.9l10.7 64H234.9zm16.4-324.7L262.6 144 240 121.4l-11.3 11.3-64 64L153.4 208l11.3 11.3 64 64L240 294.6 262.6 272l-11.3-11.3L198.6 208l52.7-52.7zm96-22.6L336 121.4 313.4 144l11.3 11.3L377.4 208l-52.7 52.7L313.4 272 336 294.6l11.3-11.3 64-64L422.6 208l-11.3-11.3-64-64z'
      
    ]
  };

  
    var faDesktopCode = faDisplayCode;
  

  
  

  var faLessThan = {
    prefix: 'fasl',
    iconName: 'less-than',
    icon: [
      384,
      512,
      [62774],
      '3c',
      
      'M384 64.3L9.2 241.5 0 245.9v20.3l9.2 4.3L384 447.7V412.3L53.4 256 384 99.7V64.3z'
      
    ]
  };

  

  
  

  var faArrowDownShortWide = {
    prefix: 'fasl',
    iconName: 'arrow-down-short-wide',
    icon: [
      576,
      512,
      ["sort-amount-desc","sort-amount-down-alt"],
      'f884',
      
      'M139.3 467.3L128 478.6l-11.3-11.3-88-88L17.4 368 40 345.4l11.3 11.3L112 417.4V48 32h32V48 417.4l60.7-60.7L216 345.4 238.6 368l-11.3 11.3-88 88zM304 48h64 16V80H368 304 288V48h16zm0 128H432h16v32H432 304 288V176h16zm0 128H496h16v32H496 304 288V304h16zm0 128H560h16v32H560 304 288V432h16z'
      
    ]
  };

  
    var faSortAmountDesc = faArrowDownShortWide;
  
    var faSortAmountDownAlt = faArrowDownShortWide;
  

  
  

  var faFlorinSign = {
    prefix: 'fasl',
    iconName: 'florin-sign',
    icon: [
      384,
      512,
      [],
      'e184',
      
      'M322.4 32c-32.1 0-61.2 19.2-73.7 48.8L188.2 224H32v32H174.6L105.8 418.7C98.3 436.5 80.9 448 61.6 448H16 0v32H16 61.6c32.1 0 61.2-19.2 73.7-48.8L209.4 256H352V224H222.9L278.2 93.3C285.7 75.5 303.1 64 322.4 64H368h16V32H368 322.4z'
      
    ]
  };

  

  
  

  var faChartMixed = {
    prefix: 'fasl',
    iconName: 'chart-mixed',
    icon: [
      512,
      512,
      ["analytics"],
      'f643',
      
      'M522.2 44.3l-192 160L319.7 213l-10.3-9L191.1 100.5 25.4 220.9 6.6 195.1l176-128 10.3-7.5 9.6 8.4L320.2 171 501.8 19.7l20.5 24.6zM80 352H48v96H80V352zM48 320H80h32v32 96 32H80 48 16V448 352 320H48zm128-64V448h32V256H176zm-32-32h32 32 32v32V448v32H208 176 144V448 256 224zm192 96H304V448h32V320zm-32-32h32 32v32V448v32H336 304 272V448 320 288h32zm128-32V448h32V256H432zm-32-32h32 32 32v32V448v32H464 432 400V448 256 224z'
      
    ]
  };

  
    var faAnalytics = faChartMixed;
  

  
  

  var faArrowsTurnToDots = {
    prefix: 'fasl',
    iconName: 'arrows-turn-to-dots',
    icon: [
      512,
      512,
      [],
      'e4c1',
      
      'M260.7 36.7l-80 80L169.4 128l11.3 11.3 80 80L272 230.6 294.6 208l-11.3-11.3L230.6 144 480 144v96 16h32V240 128 112H496l-265.4 0 52.7-52.7L294.6 48 272 25.4 260.7 36.7zm-9.4 256L240 281.4 217.4 304l11.3 11.3L281.4 368 16 368H0v16V496v16H32V496 400l249.4 0-52.7 52.7L217.4 464 240 486.6l11.3-11.3 80-80L342.6 384l-11.3-11.3-80-80zM448 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM96 128a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 128a64 64 0 1 0 128 0A64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faGrill = {
    prefix: 'fasl',
    iconName: 'grill',
    icon: [
      448,
      512,
      [],
      'e5a3',
      
      'M416 64V96c0 106-86 192-192 192S32 202 32 96V64H416zM32 32H0V64 96c0 92.5 56 171.9 136 206.1l-23.7 52c-5.2-1.4-10.7-2.1-16.4-2.1c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64H328.6l24.8 54.6 29.1-13.2L312 302.1C392 267.9 448 188.5 448 96V64 32H416 32zM140.4 369.9l26.1-57.3c18.4 4.9 37.7 7.5 57.6 7.5s39.2-2.6 57.6-7.5L314.1 384H151.4c-3-5.2-6.8-10-11.1-14.1zM96 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faCircleDown = {
    prefix: 'fasl',
    iconName: 'circle-down',
    icon: [
      512,
      512,
      [61466,"arrow-alt-circle-down"],
      'f358',
      
      'M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM224 256v32H192 173.3L256 370.7 338.7 288H320 288V256 160H224v96zm32 160l-22.6-22.6L128 288V256h32 32V224 160 128h32 64 32v32 64 32h32 32v32L278.6 393.4 256 416z'
      
    ]
  };

  
    var faArrowAltCircleDown = faCircleDown;
  

  
  

  var faPersonRunningFast = {
    prefix: 'fasl',
    iconName: 'person-running-fast',
    icon: [
      512,
      512,
      [],
      'e5ff',
      
      'M376 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 376 0zM217.4 112H224h48 2.2l2.2 .6 112 32 8.5 2.4 2.4 8.5L428.1 256H496h16v32H496 416 403.9l-3.3-11.6-20.3-70.9L343.2 317.1c-.2 .5-.3 .9-.5 1.3l49.2 27.7 11.7 6.6-4.5 12.7L347.3 512H313.4l51.1-144.6-93.3-52.5c-20-11.3-29.3-35.2-22-57l36.4-109.3L269.8 144H230.6l-59.3 59.3 0 0-22.6-22.6 0 0 64-64 4.7-4.7zm99 45.3L279.5 268c-2.4 7.3 .7 15.2 7.3 19l27.5 15.4 44.3-133-42.2-12.1zM226 314.1c5.9 10 14.1 18.7 24.1 25.4l-27.4 66.6-4.1 9.9H208 112 96V384h16 85.3L226 314.1zM16 95.8H144h16v32H144 16 0v-32H16zm-16 64H16 80 96v32H80 16 0v-32zm16 64H144h16v32H144 16 0v-32H16z'
      
    ]
  };

  

  
  

  var faTurnLeftDown = {
    prefix: 'fasl',
    iconName: 'turn-left-down',
    icon: [
      384,
      512,
      [],
      'e637',
      
      'M224 352l0-32 0-192 0-32 32 0 96 0 0-64L160 32l0 288 0 32-32 0-50.7 0L192 466.7 306.7 352 256 352l-32 0zm96-32l32 0 0 32L214.6 489.4 192 512l-22.6-22.6L32 352l0-32 32 0 32 0 32 0 0-32 0-256 0-32 32 0L352 0l32 0 0 32 0 64 0 32-32 0-64 0-32 0 0 32 0 128 0 32 32 0 32 0z'
      
    ]
  };

  

  
  

  var faWaveTriangle = {
    prefix: 'fasl',
    iconName: 'wave-triangle',
    icon: [
      640,
      512,
      [],
      'f89a',
      
      'M176.2 32.3l12.7 17.4L464.2 425.9l147-195.6 25.6 19.2-160 212.8-13 17.2-12.7-17.4L175.8 86.1 28.8 281.6 3.2 262.4l160-212.8 13-17.2z'
      
    ]
  };

  

  
  

  var faImagePolaroid = {
    prefix: 'fasl',
    iconName: 'image-polaroid',
    icon: [
      448,
      512,
      [],
      'f8c4',
      
      'M416 384v64H32V384H416zM105.4 352H32v-9.4l96-96L169.4 288l-60.7 60.7-3.3 3.3zm45.3 0l52.7-52.7L288 214.6l128 128V352H150.6zM416 297.4L299.3 180.7 288 169.4l-11.3 11.3L192 265.4l-52.7-52.7L128 201.4l-11.3 11.3L32 297.4V64H416V297.4zM448 336V64 32H416 32 0V64 336s0 0 0 0v16 16 16 64 32H32 416h32V448 384 368 352 336s0 0 0 0zM128 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faIndustry = {
    prefix: 'fasl',
    iconName: 'industry',
    icon: [
      576,
      512,
      [],
      'f275',
      
      'M32 32H48 176h16V48 190.1l152.8-76.4L368 102.1V128v59.1l153.1-73.5 22.9-11V128 256v64V464v16H528 48 32V464 384 256 48 32zM64 64V256 384v64H512V320 256 153.4L358.9 226.9l-22.9 11V212.5 153.9L183.2 230.3 160 241.9V216 64H64z'
      
    ]
  };

  

  
  

  var faBoreHole = {
    prefix: 'fasl',
    iconName: 'bore-hole',
    icon: [
      512,
      512,
      [],
      'e4c3',
      
      'M272 16V258c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-29.8 20.4-54.9 48-62V16 0h32V16zM224 320a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM480 160H384V320c0 70.7-57.3 128-128 128s-128-57.3-128-128V160H32V480H480V160zM128 128h32v32V320c0 53 43 96 96 96s96-43 96-96V160 128h32 96 32v32V480v32H480 32 0V480 160 128H32h96z'
      
    ]
  };

  

  
  

  var faArrowsRepeat = {
    prefix: 'fasl',
    iconName: 'arrows-repeat',
    icon: [
      512,
      512,
      ["repeat-alt"],
      'f364',
      
      'M0 272V256 96 80H16 390.3l-49-44.1L329.4 25.2 350.8 1.4l11.9 10.7 80 72L455.9 96l-13.2 11.9-80 72-11.9 10.7-21.4-23.8 11.9-10.7 49-44.1H32V256v16H0zm512-32v16V416v16H496 121.7l49 44.1 11.9 10.7-21.4 23.8-11.9-10.7-80-72L56.1 416l13.2-11.9 80-72 11.9-10.7 21.4 23.8-11.9 10.7-49 44.1H480V256 240h32z'
      
    ]
  };

  
    var faRepeatAlt = faArrowsRepeat;
  

  
  

  var faHorseHead = {
    prefix: 'fasl',
    iconName: 'horse-head',
    icon: [
      640,
      512,
      [],
      'f7ab',
      
      'M438.7 17.7L432.9 4.3 419 8.8 251.8 63.2C139.8 99.7 64 204.1 64 321.9V496v16H80 400h27.1L414 488.3 343 359.9c7.5-2.5 14.8-5.9 21.7-10.1l46.7 60 4.8 6.2H424h88 8.6l4.7-7.1 48-72 4.5-6.8-2.8-7.6-80-216L491.1 96H480 451.8l3.4-1.7 13.5-6.7-5.9-13.9-24-56zM224.4 329.6c22.6 24.7 54 37 85.3 36.3l1.7 3L372.9 480H96V321.9c0-103.9 66.9-196 165.7-228.2L415.1 43.7l12.3 28.7L392.8 89.7 373 99.6l15.7 15.7 8 8 4.7 4.7H408h60.9l73.3 197.9L503.4 384H431.8l-51.2-65.8-9.8-12.6-12.6 9.8-2.1 1.6c-32.9 25.6-79.9 21.6-108.1-9.1l-28.2-30.7L209 265.4 185.4 287l10.8 11.8 28.2 30.7zM400 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faCircleDollar = {
    prefix: 'fasl',
    iconName: 'circle-dollar',
    icon: [
      512,
      512,
      ["dollar-circle","usd-circle"],
      'f2e8',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 144.7c14.4 1.4 28.9 4.1 42.9 7.6l15.5 3.9-7.8 31-15.5-3.9c-6.1-1.5-25.7-5.1-32.1-6.1c-19.4-2.9-36.2-.7-48 4.4c-18.1 7.7-26.7 28.6-8.2 40.4c11.6 7.4 25.6 11.3 39 14.9c2.4 .7 4.8 1.3 7.1 2c17.7 5 38.9 11.1 54.3 21.7c19 13 27.8 33.8 23.6 56.5c-4 21.6-18.9 36-37.8 43.6c-9.9 4-21.1 6.3-33.1 6.9V408H240V366.1c-12.6-2-32.8-8.5-45.9-12.7c-5.9-1.9-11.8-3.7-17.7-5.6c-1.5-.5-2.9-.9-4.4-1.4l9.6-30.5c1.4 .4 2.7 .9 4.1 1.3c6.5 2 13 4.1 19.5 6.1l0 0c13.5 4.3 30.2 9.7 39.9 11.2c19.8 2.9 36.5 1.3 48-3.4c19.2-7.8 26.4-31.6 8.1-44.1c-12-8.2-26.8-12.3-40.9-16.2c-2.3-.6-4.7-1.3-6.9-1.9c-17.1-4.8-37-10.5-51.7-19.9c-8.1-5.2-15.7-12.1-20.5-21.7c-4.9-9.8-6.2-20.8-4-32.8c3.7-20.4 19-34.6 37.3-42.4c7.8-3.3 16.4-5.6 25.6-7V104h32v40.7z'
      
    ]
  };

  
    var faDollarCircle = faCircleDollar;
  
    var faUsdCircle = faCircleDollar;
  

  
  

  var faFaceLaughWink = {
    prefix: 'fasl',
    iconName: 'face-laugh-wink',
    icon: [
      512,
      512,
      ["laugh-wink"],
      'f59c',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 400c52 0 97.1-32.8 115.7-80H140.3c18.6 47.2 63.7 80 115.7 80zM100 288h32.2H379.8 412c-1.1 11-3.2 21.7-6.4 32c-20 64.9-79.4 112-149.6 112s-129.6-47.1-149.6-112c-3.2-10.3-5.3-21-6.4-32zm52.4-96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm140.4 29.6l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0z'
      
    ]
  };

  
    var faLaughWink = faFaceLaughWink;
  

  
  

  var faSignalFair = {
    prefix: 'fasl',
    iconName: 'signal-fair',
    icon: [
      640,
      512,
      ["signal-2"],
      'f68d',
      
      'M208 304V288H176v16V496v16h32V496 304zM80 400V384H48v16 96 16H80V496 400z'
      
    ]
  };

  
    var faSignal2 = faSignalFair;
  

  
  

  var faHouseTree = {
    prefix: 'fasl',
    iconName: 'house-tree',
    icon: [
      640,
      512,
      [],
      'e1b3',
      
      'M416 2l11 10.4 144 136 5 4.7V160v16 16H560 513.7l90.7 111 3.6 4.4v5.7V336v16H592 532.3L635.8 465.2l4.2 4.6V476v20 16H624 416V480H606L496 359.7V320h80v-1.2L480 201.3V160h56.7L416 46 310.7 145.4l-23.7-21.7L405 12.4 416 2zM384 480v32H352 32 0V480 256L192 96 384 256V448v32zM32 480H352V271L192 137.7 32 271V480zM160 352h64V288H160v64zm-32-96h32 64 32v32 64 32H224 160 128V352 288 256z'
      
    ]
  };

  

  
  

  var faHockeyStickPuck = {
    prefix: 'fasl',
    iconName: 'hockey-stick-puck',
    icon: [
      640,
      512,
      [],
      'e3ae',
      
      'M320.9 320L481.8 8.7l28.4 14.7-248 480-4.5 8.7H248 16 0V496 336 320H16 320.9zm-16.5 32H128V480H238.3l66.1-128zM32 352V480H96V352H32zm384 80v48H608V432H416zm-32-32h32H608h32v32 48 32H608 416 384V480 432 400z'
      
    ]
  };

  

  
  

  var faLaptopArrowDown = {
    prefix: 'fasl',
    iconName: 'laptop-arrow-down',
    icon: [
      640,
      512,
      [],
      'e1c6',
      
      'M96 32H272V64H96V352H64V64 32H96zM544 64H368V32H544h32V64 352H544V64zM61.3 448H578.7L608 418.7V416H32v2.7L61.3 448zM640 384v32 16l-48 48H48L0 432V416 384H32 608h32zM336 48V265.4l52.7-52.7L400 201.4 422.6 224l-11.3 11.3-80 80L320 326.6l-11.3-11.3-80-80L217.4 224 240 201.4l11.3 11.3L304 265.4V48 32h32V48z'
      
    ]
  };

  

  
  

  var faBracketsSquare = {
    prefix: 'fasl',
    iconName: 'brackets-square',
    icon: [
      448,
      512,
      ["brackets"],
      'f7e9',
      
      'M16 32H0V48 464v16H16 144h16V448H144 32V64H144h16V32H144 16zm416 0H304 288V64h16H416V448H304 288v32h16H432h16V464 48 32H432z'
      
    ]
  };

  
    var faBrackets = faBracketsSquare;
  

  
  

  var faFaceSmileHearts = {
    prefix: 'fasl',
    iconName: 'face-smile-hearts',
    icon: [
      640,
      512,
      [],
      'e390',
      
      'M542 226c1.3 9.8 2 19.8 2 30c0 18.9-2.3 37.2-6.7 54.7c2.3 1 4.5 2 6.7 3.1c8.5-4.4 17.8-7.4 27.3-8.9c3.1-15.9 4.7-32.2 4.7-49c0-19.8-2.2-39-6.5-57.5L542 226zM320 480c-46.6 0-89.8-14.2-125.6-38.5l-23 23C213.3 494.4 264.6 512 320 512c51.3 0 99-15.1 139.1-41l-17.4-17.4c-1.9-1.9-3.7-3.9-5.5-6C402.3 468.1 362.5 480 320 480zM422.9 21.5C391.4 7.7 356.6 0 320 0C178.6 0 64 114.6 64 256c0 11.1 .7 21.9 2.1 32.6c10.5 1.3 20.6 4.4 29.9 9.2c1.2-.6 2.4-1.2 3.6-1.8c-2.4-13-3.6-26.4-3.6-40.1C96 132.3 196.3 32 320 32c34.4 0 66.9 7.7 96 21.6c.3-11.4 2.7-22.2 6.9-32.1zM320 400c71.6 0 113.7-47.7 126.3-72.8l-28.6-14.3C408.9 330.3 376.4 368 320 368s-88.9-37.7-97.7-55.2l-28.6 14.3C206.3 352.3 248.4 400 320 400zM196.8 237.6c21.6-28.8 64.8-28.8 86.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2zm246.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2c21.6-28.8 64.8-28.8 86.4 0zM55.6 320C24.9 320 0 344.9 0 375.6c0 14.7 5.9 28.9 16.3 39.3l68.4 68.4L96 494.6l11.3-11.3 68.4-68.4c10.4-10.4 16.3-24.6 16.3-39.3c0-30.7-24.9-55.6-55.6-55.6c-14.7 0-28.9 5.9-39.3 16.3L96 337.4l-1.1-1.1C84.5 325.9 70.3 320 55.6 320zM32 375.6c0-13 10.6-23.6 23.6-23.6c6.3 0 12.3 2.5 16.7 6.9l12.4 12.4L96 382.6l11.3-11.3 12.4-12.4c4.4-4.4 10.4-6.9 16.7-6.9c13 0 23.6 10.6 23.6 23.6c0 6.3-2.5 12.3-6.9 16.7L96 449.4 38.9 392.3c-4.4-4.4-6.9-10.4-6.9-16.7zm416-320c0 14.7 5.9 28.9 16.3 39.3l68.4 68.4L544 174.6l11.3-11.3 68.4-68.4C634.1 84.5 640 70.3 640 55.6C640 24.9 615.1 0 584.4 0c-14.7 0-28.9 5.9-39.3 16.3L544 17.4l-1.1-1.1C532.5 5.9 518.3 0 503.6 0C472.9 0 448 24.9 448 55.6zM503.6 32c6.3 0 12.3 2.5 16.7 6.9l12.4 12.4L544 62.6l11.3-11.3 12.4-12.4c4.4-4.4 10.4-6.9 16.7-6.9c13 0 23.6 10.6 23.6 23.6c0 6.3-2.5 12.3-6.9 16.7L544 129.4 486.9 72.3c-4.4-4.4-6.9-10.4-6.9-16.7c0-13 10.6-23.6 23.6-23.6zm39.3 320.3c-10.4-10.4-24.6-16.3-39.3-16.3c-30.7 0-55.6 24.9-55.6 55.6c0 14.7 5.9 28.9 16.3 39.3l68.4 68.4L544 510.6l11.3-11.3 68.4-68.4c10.4-10.4 16.3-24.6 16.3-39.3c0-30.7-24.9-55.6-55.6-55.6c-14.7 0-28.9 5.9-39.3 16.3l-1.1 1.1-1.1-1.1zm-56 56c-4.4-4.4-6.9-10.4-6.9-16.7c0-13 10.6-23.6 23.6-23.6c6.3 0 12.3 2.5 16.7 6.9l12.4 12.4L544 398.6l11.3-11.3 12.4-12.4c4.4-4.4 10.4-6.9 16.7-6.9c13 0 23.6 10.6 23.6 23.6c0 6.3-2.5 12.3-6.9 16.7L544 465.4l-57.1-57.1z'
      
    ]
  };

  

  
  

  var faSquare8 = {
    prefix: 'fasl',
    iconName: 'square-8',
    icon: [
      448,
      512,
      [],
      'e25d',
      
      'M416 64V448H32V64H416zM32 32H0V64 448v32H32 416h32V448 64 32H416 32zm204 96H212c-37.6 0-68 30.4-68 68c0 20.2 8.8 38.4 22.9 50.9C148.1 260.7 136 282.9 136 308c0 42 34 76 76 76h24c42 0 76-34 76-76c0-25.1-12.1-47.3-30.9-61.1c14-12.5 22.9-30.6 22.9-50.9c0-37.6-30.4-68-68-68zM212 232c-19.9 0-36-16.1-36-36s16.1-36 36-36h24c19.9 0 36 16.1 36 36s-16.1 36-36 36H212s0 0 0 0zm0 32s0 0 0 0h24c24.3 0 44 19.7 44 44s-19.7 44-44 44H212c-24.3 0-44-19.7-44-44s19.7-44 44-44z'
      
    ]
  };

  

  
  

  var faSquareArrowLeft = {
    prefix: 'fasl',
    iconName: 'square-arrow-left',
    icon: [
      448,
      512,
      ["arrow-square-left"],
      'f33a',
      
      'M32 448l384 0 0-384L32 64l0 384zM0 480l0-32L0 64 0 32l32 0 384 0 32 0 0 32 0 384 0 32-32 0L32 480 0 480zM100.7 244.7l96-96L208 137.4 230.6 160l-11.3 11.3L150.6 240 336 240l16 0 0 32-16 0-185.4 0 68.7 68.7L230.6 352 208 374.6l-11.3-11.3-96-96L89.4 256l11.3-11.3z'
      
    ]
  };

  
    var faArrowSquareLeft = faSquareArrowLeft;
  

  
  

  var faGuitar = {
    prefix: 'fasl',
    iconName: 'guitar',
    icon: [
      512,
      512,
      [],
      'f7a6',
      
      'M431 107l-33.4 7.4L405 81 446.7 44 468 65.3 431 107zM448 0L376 64l-14.1 63.5-36 36c-51.7-42.9-120-48-158.3-9.6c-12 12-19.7 26.8-23.4 43.2c-4.1 18.1-20.8 33.5-39.4 34.5C76.9 233 51 243.2 31.4 262.8C-17.4 311.7-8.3 400 51.8 460.2s148.5 69.3 197.4 20.4c19.6-19.6 29.8-45.5 31.2-73.4c.9-18.5 16.4-35.3 34.5-39.4c16.4-3.7 31.2-11.4 43.2-23.4c38.3-38.3 33.3-106.6-9.6-158.3l36-36L448 136l64-72L448 0zM190.2 176.5c22-22 70.1-24.8 113 9.7l-74.4 74.4c-6.3-3-13.3-4.7-20.7-4.7c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-7.4-1.7-14.4-4.7-20.7l74.4-74.4c34.5 42.9 31.7 91 9.7 113c-7.3 7.3-16.6 12.3-27.6 14.8c-30.7 6.9-57.7 34.7-59.4 69c-1.1 21-8.6 39.1-21.9 52.4c-32.2 32.2-99.9 31.8-152.1-20.4S21.8 317.6 54 285.4c13.3-13.3 31.4-20.9 52.4-21.9c34.3-1.7 62.1-28.7 69-59.4c2.5-11 7.5-20.3 14.8-27.6zM192 304a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faScreenUsers = {
    prefix: 'fasl',
    iconName: 'screen-users',
    icon: [
      640,
      512,
      ["users-class"],
      'f63d',
      
      'M576 32H64V229.5c-11.9 4.2-22.8 10.7-32 19V32 0H64 576h32V32 248.4c-9.2-8.3-20.1-14.8-32-19V32zM96 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm224 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM55.1 448L33.7 512H0l32-96H160l32 96H158.3l-21.3-64H55.1zm202.7 64H224l32-96H384l32 96H382.3l-21.3-64H279.1l-21.3 64zm245.3-64l-21.3 64H448l32-96H608l32 96H606.3l-21.3-64H503.1z'
      
    ]
  };

  
    var faUsersClass = faScreenUsers;
  

  
  

  var faTrashCanSlash = {
    prefix: 'fasl',
    iconName: 'trash-can-slash',
    icon: [
      640,
      512,
      ["trash-alt-slash"],
      'e2ad',
      
      'M512 326V96h32V64H512 480 432.9L397.6 7.5 392.9 0H384 256h-8.9l-4.7 7.5L207.1 64h-27l40.5 32H480V300.8L512 326zm0 163.1L500.4 480H480 448 160V211.2L128 186V480v32h32H480h32V489.1zm-304-240V400v16h32V400 274.4l-32-25.3zm96 75.8V400v16h32V400 350.2l-32-25.3zm128-62V176 160H400v16 61.6l32 25.3zM244.9 64l20-32H375.1l20 32H244.9zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  
    var faTrashAltSlash = faTrashCanSlash;
  

  
  

  var faSun = {
    prefix: 'fasl',
    iconName: 'sun',
    icon: [
      512,
      512,
      [9728],
      'f185',
      
      'M178.7 15.5L256 57.1l77.3-41.6L362 0l9.4 31.3 25.2 84.1 84.1 25.2L512 150l-15.5 28.8L454.9 256l41.6 77.3L512 362l-31.3 9.4-84.1 25.2-25.2 84.1L362 512l-28.8-15.5L256 454.9l-77.3 41.6L150 512l-9.4-31.3-25.2-84.1L31.3 371.4 0 362l15.5-28.8L57.1 256 15.5 178.7 0 150l31.3-9.4 84.1-25.2 25.2-84.1L150 0l28.8 15.5zm92.5 69.8L256 93.5l-15.2-8.2L169.3 46.8 146 124.6l-5 16.5-16.5 5L46.8 169.3l38.5 71.5L93.5 256l-8.2 15.2L46.8 342.7 124.6 366l16.5 5 5 16.5 23.3 77.8 71.5-38.5 15.2-8.2 15.2 8.2 71.5 38.5L366 387.4l5-16.5 16.5-5 77.8-23.3-38.5-71.5L418.5 256l8.2-15.2 38.5-71.5L387.4 146l-16.5-5-5-16.5L342.7 46.8 271.2 85.3zM256 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm96 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  

  
  

  var faObjectsAlignCenterHorizontal = {
    prefix: 'fasl',
    iconName: 'objects-align-center-horizontal',
    icon: [
      512,
      512,
      [],
      'e3bc',
      
      'M448 192l-176 0-32 0L64 192l0-96 176 0 32 0 176 0 0 96zM272 224l176 0 32 0 0-32 0-96 0-32-32 0L272 64l0-64L240 0l0 64L64 64 32 64l0 32 0 96 0 32 32 0 176 0 0 64-112 0-32 0 0 32 0 96 0 32 32 0 112 0 0 64 32 0 0-64 112 0 32 0 0-32 0-96 0-32-32 0-112 0 0-64zm0 96l112 0 0 96-112 0-32 0-112 0 0-96 112 0 32 0z'
      
    ]
  };

  

  
  

  var faChampagneGlass = {
    prefix: 'fasl',
    iconName: 'champagne-glass',
    icon: [
      320,
      512,
      ["glass-champagne"],
      'f79e',
      
      'M74.5 160h171l7.3 53.6C260.5 269.9 216.8 320 160 320s-100.5-50.1-92.8-106.4L74.5 160zm4.4-32L91.9 32H228.1l13.1 96H78.8zM64 0L35.5 209.3C25.9 279.4 75.8 342.4 144 351V480H80 64v32H80h80 80 16V480H240 176V351c68.2-8.6 118.1-71.6 108.5-141.7L256 0H64z'
      
    ]
  };

  
    var faGlassChampagne = faChampagneGlass;
  

  
  

  var faTrashUndo = {
    prefix: 'fasl',
    iconName: 'trash-undo',
    icon: [
      448,
      512,
      ["trash-arrow-turn-left"],
      'f895',
      
      'M160 0h-8.9l-4.7 7.5L111.1 64H64.1 32 0V96H34.3L64 512H384L413.7 96H448V64H416 383.9 336.9L301.6 7.5 296.9 0H288 160zM299.1 64H148.9l20-32H279.1l20 32zM93.8 480L66.4 96H381.6L354.2 480H93.8zM230.6 201.2l-21.4-23.8-11.9 10.7-80 72L104.1 272l13.2 11.9 80 72 11.9 10.7 21.4-23.8-11.9-10.7-49-44.1H240c26.5 0 48 21.5 48 48v40 16h32V376 336c0-44.2-35.8-80-80-80H169.7l49-44.1 11.9-10.7z'
      
    ]
  };

  
    var faTrashArrowTurnLeft = faTrashUndo;
  

  
  

  var faRubleSign = {
    prefix: 'fasl',
    iconName: 'ruble-sign',
    icon: [
      384,
      512,
      [8381,"rouble","rub","ruble"],
      'f158',
      
      'M80 32H64V48 288H0v32H64v64H0v32H64v48 16H96V464 416H320V384H96V320H240c79.5 0 144-64.5 144-144s-64.5-144-144-144H80zM96 288V64H240c61.9 0 112 50.1 112 112s-50.1 112-112 112H96z'
      
    ]
  };

  
    var faRouble = faRubleSign;
  
    var faRub = faRubleSign;
  
    var faRuble = faRubleSign;
  

  
  

  var faNotes = {
    prefix: 'fasl',
    iconName: 'notes',
    icon: [
      512,
      512,
      [],
      'e202',
      
      'M128 416H96V384 64 32h32H448h32V64 304L368 416H128zm226.7-32L448 290.7V288H352v96h2.7zM320 384V272 256h16H448V64H128V384H320zm0 96v32H304 16 0V496 144 128H32v16l0 336H304h16z'
      
    ]
  };

  

  
  

  var faGearCode = {
    prefix: 'fasl',
    iconName: 'gear-code',
    icon: [
      512,
      512,
      [],
      'e5e8',
      
      'M195 108c-13.2 5.4-25.5 12.6-36.7 21.2l-13.3 10.2-16-5.1-52-16.6L46.9 170.2l40.3 36.7 12.4 11.3-2.2 16.6c-.9 6.9-1.4 14-1.4 21.2s.5 14.3 1.4 21.2l2.2 16.6L87.2 305.1 46.9 341.8l30.2 52.4 52-16.6 16-5.1 13.3 10.2c11.2 8.6 23.5 15.8 36.7 21.2l15.5 6.4 3.6 16.4L225.8 480h60.5l11.7-53.3 3.6-16.4L317 404c13.2-5.4 25.5-12.6 36.7-21.2l13.3-10.2 16 5.1 52 16.6 30.2-52.4-40.3-36.7-12.4-11.3 2.2-16.6c.9-6.9 1.4-14 1.4-21.2s-.5-14.3-1.4-21.2l-2.2-16.6 12.4-11.3 40.3-36.7-30.2-52.4-52 16.6-16 5.1-13.3-10.2c-11.2-8.6-23.5-15.8-36.7-21.2l-15.5-6.4-3.6-16.4L286.2 32H225.8L214.1 85.3l-3.6 16.4L195 108zM200 0H312l17.2 78.4c15.8 6.5 30.6 15.1 44 25.4l76.5-24.4 56 97-59.4 54.1c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l59.4 54.1-56 97-76.5-24.4c-13.4 10.3-28.2 18.9-44 25.4L312 512H200l-17.2-78.4c-15.8-6.5-30.6-15.1-44-25.4L62.3 432.5l-56-97 59.4-54.1C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L6.3 176.5l56-97 76.5 24.4c13.4-10.3 28.2-18.9 44-25.4L200 0zm87.8 162.6l-32 192-2.6 15.8-31.6-5.3 2.6-15.8 32-192 2.6-15.8 31.6 5.3-2.6 15.8zM187.3 227.3L158.6 256l28.7 28.7L198.6 296 176 318.6l-11.3-11.3-40-40L113.4 256l11.3-11.3 40-40L176 193.4 198.6 216l-11.3 11.3zm160-22.6l40 40L398.6 256l-11.3 11.3-40 40L336 318.6 313.4 296l11.3-11.3L353.4 256l-28.7-28.7L313.4 216 336 193.4l11.3 11.3z'
      
    ]
  };

  

  
  

  var faYenSign = {
    prefix: 'fasl',
    iconName: 'yen-sign',
    icon: [
      320,
      512,
      [165,"cny","jpy","rmb","yen"],
      'f157',
      
      'M-3.2 32l128 192H48 32v32H48h96v64H48 32v32H48h96V464v16h32V464 352h96 16V320H272 176V256h96 16V224H272 195.2l128-192H284.8L160 219.2 35.2 32H-3.2z'
      
    ]
  };

  
    var faCny = faYenSign;
  
    var faJpy = faYenSign;
  
    var faRmb = faYenSign;
  
    var faYen = faYenSign;
  

  
  

  var faPlaneCircleXmark = {
    prefix: 'fasl',
    iconName: 'plane-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e557',
      
      'M256 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4C184.4 62.7 176 89 176 109.7v44.5L8.1 250.1 0 254.7V264v96 21.9l20.9-6.7L176 325.4l0 50.6-57.6 43.2L112 424v8 64 16h16 16 2.2l2.2-.6L256 480.6l107.6 30.7 2.2 .6H368h16 10.8c-14.2-10-26.9-22-37.5-35.7l-96.8-27.7-4.4-1.3-4.4 1.3L144 479.4V440l57.6-43.2L208 392v-8l0-80.6V281.5l-20.9 6.7L32 338.1V273.3l167.9-96 8.1-4.6v-9.3V109.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3C298.1 75.5 304 96.1 304 109.7v61.7 9.3l8.1 4.6 76.2 43.5c9.6-7.4 19.9-13.9 30.9-19.2L336 162.1V109.7c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7L566.6 320 544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7z'
      
    ]
  };

  

  
  

  var faToilet = {
    prefix: 'fasl',
    iconName: 'toilet',
    icon: [
      448,
      512,
      [128701],
      'f7d8',
      
      'M0 0V32H16 432h16V0H432 16 0zM32 64V210.6c-2.1 1.2-4.2 2.5-6.1 3.8C12 223.8 0 237.5 0 256c0 70.4 36.4 119 82.3 149.3c2 1.3 3.9 2.6 5.9 3.8L71.5 480 64 512H96.9 351.1 384l-7.5-32-16.7-70.9c2-1.2 4-2.5 5.9-3.8C411.6 375 448 326.4 448 256c0-18.5-12-32.2-25.9-41.6c-1.9-1.3-4-2.6-6.1-3.8V64H384V196.8c-5-1.6-10.2-3.2-15.4-4.6C327 181.2 273.5 176 224 176s-103 5.2-144.6 16.3c-5.3 1.4-10.4 2.9-15.4 4.6V64H32zM330.5 424.5L343.6 480H104.4l13.1-55.5C154.1 440.8 193 448 224 448s69.9-7.2 106.5-23.5zM99.9 378.7c-26.5-17.5-48.4-41.3-59.7-72.9c11.5 5.6 24.9 10.2 39.2 14C121 330.8 174.5 336 224 336s103-5.2 144.6-16.3c14.3-3.8 27.6-8.4 39.2-14c-11.3 31.6-33.2 55.4-59.7 72.9C308.6 404.7 259.8 416 224 416s-84.6-11.3-124.1-37.3zM404.2 271c-9.8 6.6-24.7 12.7-43.9 17.8C322.2 298.9 271.7 304 224 304s-98.2-5.1-136.3-15.2c-19.2-5.1-34.1-11.2-43.9-17.8C33.8 264.3 32 259.1 32 256s1.8-8.3 11.8-15c9.8-6.6 24.7-12.7 43.9-17.8C125.8 213.1 176.3 208 224 208s98.2 5.1 136.3 15.2c19.2 5.1 34.1 11.2 43.9 17.8c9.9 6.7 11.8 11.9 11.8 15s-1.8 8.3-11.8 15zM112 64H96V96h16 32 16V64H144 112z'
      
    ]
  };

  

  
  

  var faMars = {
    prefix: 'fasl',
    iconName: 'mars',
    icon: [
      448,
      512,
      [9794],
      'f222',
      
      'M304 32H288V64h16 89.4L288.6 168.7C258.1 143.3 218.8 128 176 128C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-42.8-15.3-82.1-40.7-112.6L416 86.6V176v16h32V176 48 32H432 304zM32 304a144 144 0 1 1 288 0A144 144 0 1 1 32 304z'
      
    ]
  };

  

  
  

  var faVault = {
    prefix: 'fasl',
    iconName: 'vault',
    icon: [
      576,
      512,
      [],
      'e2c5',
      
      'M32 32V448H544V32H32zM0 0H32 544h32V32 448v32H544 512v16 16H480V496 480H96v16 16H64V496 480H32 0V448 32 0zM352 240A128 128 0 1 0 96 240a128 128 0 1 0 256 0zM64 240a160 160 0 1 1 320 0A160 160 0 1 1 64 240zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0c0 20.9-13.4 38.7-32 45.3V336v16H448V336 221.3c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48z'
      
    ]
  };

  

  
  

  var faArrowTurnLeftUp = {
    prefix: 'fasl',
    iconName: 'arrow-turn-left-up',
    icon: [
      384,
      512,
      [],
      'e634',
      
      'M331.3 132.7L342.6 144 320 166.6l-11.3-11.3L208 54.6 208 480l160 0 16 0 0 32-16 0-176 0-16 0 0-16 0-441.4L75.3 155.3 64 166.6 41.4 144l11.3-11.3 128-128L192-6.6 203.3 4.7l128 128z'
      
    ]
  };

  

  
  

  var faPersonSimple = {
    prefix: 'fasl',
    iconName: 'person-simple',
    icon: [
      256,
      512,
      [],
      'e220',
      
      'M160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM57.4 320H64 96h64 32 6.6l-5.3-128H62.7L57.4 320zM64 352H56 24l1.3-32L32 160H224l6.7 160 1.3 32H200h-8V496v16H160V496 352H96V496v16H64V496 352z'
      
    ]
  };

  

  
  

  var faOilWell = {
    prefix: 'fasl',
    iconName: 'oil-well',
    icon: [
      576,
      512,
      [],
      'e532',
      
      'M497.4 69.6c-6.9-25.6-33.2-40.8-58.8-33.9l-15.5 4.1L489.4 287l15.5-4.1c25.6-6.9 40.8-33.2 33.9-58.8L497.4 69.6zM430.4 4.7c42.7-11.4 86.5 13.9 98 56.6l41.4 154.5c11.4 42.7-13.9 86.5-56.6 98l-15.5 4.1-30.9 8.3-8.3-30.9L429.2 185.8 96 272.2V480h36.3l64.5-201.9 36.6-9.5L206.8 352H337.2L304.7 250.1l31-8 76 237.9H560h16v32H560 16 0V480H16 64V176 160H96v16 63.2l123.5-32 32-100L255 96h11.7 10.7H289l3.6 11.1L316.5 182l104.4-27.1L392.3 48 384 17.1l30.9-8.3 15.5-4.1zM285.5 190.1L272 147.9l-15.9 49.8 29.4-7.6zM378.1 480l-30.7-96H196.6l-30.7 96H378.1z'
      
    ]
  };

  

  
  

  var faGlassWater = {
    prefix: 'fasl',
    iconName: 'glass-water',
    icon: [
      384,
      512,
      [],
      'e4f4',
      
      'M45.9 176.8L64.1 186c30.4 15.2 66.9 11.3 93.4-9.9c20.1-16.1 48.8-16.1 68.9 0c26.5 21.2 63 25.1 93.4 9.9l18.2-9.1L314.4 480H69.6L45.9 176.8zM43 139.6L34.6 32H349.4L341 139.6l-35.4 17.7c-19.2 9.6-42.3 7.2-59.1-6.3c-31.8-25.5-77.1-25.5-108.9 0c-16.8 13.4-39.9 15.9-59.1 6.3L43 139.6zM40 512H344L381.5 32 384 0H351.9 32.1 0L2.5 32 40 512z'
      
    ]
  };

  

  
  

  var faTrashCanCheck = {
    prefix: 'fasl',
    iconName: 'trash-can-check',
    icon: [
      448,
      512,
      [],
      'e2a9',
      
      'M160 0h-8.9l-4.7 7.5L111.1 64H64 32 0V96H32V480v32H64 384h32V480 96h32V64H416 384 336.9L301.6 7.5 296.9 0H288 160zM299.1 64H148.9l20-32H279.1l20 32zM64 480V96H384V480H64zM331.3 235.3L342.6 224 320 201.4l-11.3 11.3L192 329.4l-52.7-52.7L128 265.4 105.4 288l11.3 11.3 64 64L192 374.6l11.3-11.3 128-128z'
      
    ]
  };

  

  
  

  var faBolt = {
    prefix: 'fasl',
    iconName: 'bolt',
    icon: [
      448,
      512,
      [9889,"zap"],
      'f0e7',
      
      'M303.5 184.4L338.9 49.8 352 0 310.8 30.9 32 240v48l88.3 5.9 32.5 2.2-8.3 31.5L109.1 462.2 96 512l41.2-30.9L416 272V224l-88.3-5.9-32.5-2.2 8.3-31.5zM384 253.9V256L150.3 431.2l33.4-127 9.9-37.5L155 264.1l-91-6.1V256L297.7 80.8l-33.4 127-9.9 37.5 38.7 2.6 91 6.1z'
      
    ]
  };

  
    var faZap = faBolt;
  

  
  

  var faMessageSlash = {
    prefix: 'fasl',
    iconName: 'message-slash',
    icon: [
      640,
      512,
      ["comment-alt-slash"],
      'f4a9',
      
      'M576 32V0H544 99l40.5 32H544V351.3l32 25.3V32zM64 135.4V384v32H96h96 32v32 25.5V512l32-21.3L368 416h51.4l-40.5-32H368h-9.7l-8.1 5.4L256 452.2V416 384H224 96V160.7L64 135.4zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  
    var faCommentAltSlash = faMessageSlash;
  

  
  

  var faShieldCat = {
    prefix: 'fasl',
    iconName: 'shield-cat',
    icon: [
      512,
      512,
      [],
      'e572',
      
      'M48.5 114.9L256 34.3l207.5 80.5c2.7 45.6-4.5 116.8-34.7 186.3S345.4 438.4 256 477.1C166.6 438.4 113.4 370.7 83.2 301.2S45.8 160.5 48.5 114.9zm447-1.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM216 288a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM144 144V272c0 61.9 50.1 112 112 112s112-50.1 112-112V144 128H345.4l-4.7 4.7L281.4 192H230.6l-59.3-59.3-4.7-4.7H144v16zm32 38.6l36.7 36.7 4.7 4.7H224h64 6.6l4.7-4.7L336 182.6V272c0 44.2-35.8 80-80 80s-80-35.8-80-80V182.6z'
      
    ]
  };

  

  
  

  var faCaravan = {
    prefix: 'fasl',
    iconName: 'caravan',
    icon: [
      640,
      512,
      [],
      'f8ff',
      
      'M416 64c70.7 0 128 57.3 128 128V384H480V160 128H448 352 320v32V384H282.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H32V64H416zM32 416H96c0 53 43 96 96 96s96-43 96-96h32 32 96 32 64 32l48 0h16V384H624l-48 0V192c0-88.4-71.6-160-160-160H32 0V64 384v32H32zM448 224H416 400v32h16 32V384H352V160h96v64zM128 160H256v64H128V160zM96 128v32 64 32h32H256h32V224 160 128H256 128 96zm96 224a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faArrowUpArrowDown = {
    prefix: 'fasl',
    iconName: 'arrow-up-arrow-down',
    icon: [
      576,
      512,
      ["sort-up-down"],
      'e099',
      
      'M427.3 467.3l96-96L534.6 360 512 337.4l-11.3 11.3L432 417.4V48 32H400V48 417.4l-68.7-68.7L320 337.4 297.4 360l11.3 11.3 96 96L416 478.6l11.3-11.3zM171.3 44.7L160 33.4 148.7 44.7l-96 96L41.4 152 64 174.6l11.3-11.3L144 94.6V464v16h32V464 94.6l68.7 68.7L256 174.6 278.6 152l-11.3-11.3-96-96z'
      
    ]
  };

  
    var faSortUpDown = faArrowUpArrowDown;
  

  
  

  var faHandWave = {
    prefix: 'fasl',
    iconName: 'hand-wave',
    icon: [
      544,
      512,
      [],
      'e1a7',
      
      'M332.2 0c28 0 53.6 15.8 66.1 40.8L369.7 55.2C362.6 41 348.1 32 332.2 32H320 304V0h16 12.2zM61.6 381.9l2.3 15.8 1.2 8.5c3 21.1 19.6 37.7 40.7 40.7l8.5 1.2 15.8 2.3-4.5 31.7-15.8-2.3-8.5-1.2c-35.2-5-62.9-32.7-67.9-67.9l-1.2-8.5-2.3-15.8 31.7-4.5zm84-337.5L156.9 33l11.3 11.3 19.3 19.3 45.3-45.3L244.1 7.1l11.3 11.3L400 163l0-11 0-40 0-16 16 0 80 0 16 0 0 16 0 40 0 160.1 0 0 0 .7 0 0 0 13.8C512 429 429 512 326.6 512c-49.5 0-96.9-19.8-131.7-54.9L43.7 304.5 32.5 293.2l11.3-11.3L89 236.7 55.1 202.7 43.8 191.4l11.3-11.3 45.3-45.3L89 123.5 77.7 112.2 89 100.9l56.6-56.6zm19.1 268l-53-53-34 34 140 141.3c28.8 29.1 68 45.4 109 45.4C411.3 480 480 411.3 480 326.6l0-13.8 0 0 0-.7 0 0 0-160 0-24-48 0 0 24 0 49.6 0 22.4H415.8l-11.1-11.1L244.1 52.4 210.2 86.3 342.6 218.7l11.3 11.3-22.6 22.6L320 241.4 182.9 104.2 171.5 92.9l0 0L156.9 78.3 123 112.2 239.4 228.7 266.7 256h0l19.3 19.3 11.3 11.3-22.6 22.6-11.3-11.3L126.3 160.8l-3.3-3.3L89 191.4l37.3 37.3L137.6 240l49.7 49.7 4.7 4.7 37.5 37.5 11.3 11.3-22.6 22.6-11.3-11.3L192 339.6v0l-27.3-27.3z'
      
    ]
  };

  

  
  

  var faFolderGear = {
    prefix: 'fasl',
    iconName: 'folder-gear',
    icon: [
      512,
      512,
      ["folder-cog"],
      'e187',
      
      'M32 32H224l48 64H480h32v32V448v32H480 32 0V448 64 32H32zm240 96H256l-9.6-12.8L208 64H32V448H480V128H272zm-64 40h16 64 16v16 20.8c.8 .5 1.6 1 2.4 1.4l15-8.1 13.7-7.4 7.8 13.5 32 55.4 8.2 14.3-14.5 7.8L357.1 288l11.5 6.2 14.5 7.8-8.2 14.3-32 55.4-7.8 13.5-13.7-7.4-15-8.1c-.8 .5-1.6 1-2.4 1.4V392v16H288 224 208V392 371.2c-.8-.5-1.6-1-2.4-1.4l-15 8.1-13.7 7.4-7.8-13.5-32-55.4L128.9 302l14.5-7.8 11.5-6.2-11.5-6.2L128.9 274l8.2-14.3 32-55.4 7.8-13.5 13.7 7.4 15 8.1c.8-.5 1.6-1 2.4-1.4V184 168zm32 32v14.7 10.5l-9.6 4.2c-5 2.2-9.6 5-13.9 8.3l-8.2 6.5-9.2-5-10-5.4-16 27.7 10.8 5.8 9.2 5-.9 10.4c-.1 1.8-.2 3.5-.2 5.3s.1 3.6 .2 5.3l.9 10.4-9.2 5-10.8 5.8 16 27.7 10-5.4 9.2-5 8.2 6.5c4.2 3.3 8.9 6.1 13.9 8.3l9.6 4.2v10.5V376h32V361.3 350.9l9.6-4.2c5-2.2 9.6-5 13.9-8.3l8.2-6.5 9.2 5 10 5.4 16-27.7-10.8-5.8-9.2-5 .9-10.4c.1-1.8 .2-3.5 .2-5.3s-.1-3.6-.2-5.3l-.9-10.4 9.2-5 10.8-5.8-16-27.7-10 5.4-9.2 5-8.2-6.5c-4.2-3.3-8.9-6.1-13.9-8.3l-9.6-4.2V214.7 200H240zm-8 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faFolderCog = faFolderGear;
  

  
  

  var faFolderMedical = {
    prefix: 'fasl',
    iconName: 'folder-medical',
    icon: [
      512,
      512,
      [],
      'e18c',
      
      'M32 32H224l48 64H480h32v32V448v32H480 32 0V448 64 32H32zm240 96H256l-9.6-12.8L208 64H32V448H480V128H272zm-48 48h64 16v16 48h48 16v16 64 16H352 304v48 16H288 224 208V384 336H160 144V320 256 240h16 48V192 176h16zm16 80v16H224 176v32h48 16v16 48h32V320 304h16 48V272H288 272V256 208H240v48z'
      
    ]
  };

  

  
  

  var faCameraWebSlash = {
    prefix: 'fasl',
    iconName: 'camera-web-slash',
    icon: [
      640,
      512,
      ["webcam-slash"],
      'f833',
      
      'M544 224C544 100.3 443.7 0 320 0C262.8 0 210.5 21.5 170.9 56.8L196.5 77C229.9 48.9 273 32 320 32c106 0 192 86 192 192c0 30.9-7.3 60.1-20.3 86l25.6 20.2c17-31.6 26.7-67.8 26.7-106.2zM398.3 399.4C374.4 410.1 347.9 416 320 416c-106 0-192-86-192-192c0-12.1 1.1-24 3.3-35.5l-27.8-22C98.6 184.9 96 204.1 96 224c0 76.4 38.3 143.9 96.7 184.3L136.9 480 112 512h40.5H487.5 528l-20.7-26.6-6.9-5.4H462.6l0 0H177.4l43-55.3c30 14.9 63.8 23.3 99.6 23.3s69.6-8.4 99.6-23.3l1.6 2.1 5.2-5.2-28.1-22.2zM176 224c0 79.5 64.5 144 144 144c11.6 0 22.8-1.4 33.6-3.9L318 336c-51.4-.9-94.3-36.3-106.5-84.1l-35.5-28 0 .1zm256 0c0 12.1-1.9 23.7-5.4 34.6L453 279.4c7.1-17.1 11-35.8 11-55.4c0-79.5-64.5-144-144-144c-31.7 0-61 10.2-84.7 27.6l26.4 20.8c17-10.4 37-16.4 58.4-16.4c61.9 0 112 50.1 112 112zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  
    var faWebcamSlash = faCameraWebSlash;
  

  
  

  var faSaxophoneFire = {
    prefix: 'fasl',
    iconName: 'saxophone-fire',
    icon: [
      640,
      512,
      ["sax-hot"],
      'f8db',
      
      'M102.4 0C68.3 21.3 0 81.9 0 153.6C0 167 2.1 179.9 5.9 192H40c-5.1-11.8-8-24.7-8-38.4c0-25.7 12.4-51.9 31.4-75.7C74.8 63.6 87.6 51.4 99.1 41.9L131 73.8l22.6 22.6 22.6-22.6 3.7-3.7c36.6 38.9 44 74.5 44 83.5c0 13.7-2.9 26.6-8 38.4h34.1c3.8-12.1 5.9-25 5.9-38.4c0-21.3-15.4-76.8-76.8-128l-3 3L153.6 51.2 131 28.6 102.4 0zM128 102.5s-61.1 40.7-74.3 89.5H87.6c4.9-10.9 13.5-22.7 25-34.6c5.3-5.4 10.6-10.3 15.4-14.5c4.8 4.1 10.1 9 15.4 14.5c11.5 11.9 20.1 23.7 25 34.6h33.9c-13.2-48.8-74.3-89.5-74.3-89.5zM496 64h-6.5l-4.7 4.5-254.7 247-4.3-2.9L237.1 256H240h16V224H240 224 32 16 0v32H12.8L2.7 311.5C.9 321.5 0 331.7 0 341.9v7.6C0 439.2 72.8 512 162.6 512c48.8 0 94.9-21.9 125.8-59.6L527.6 160H624h16V144 128v-6.6l-4.7-4.7-48-48L582.6 64H576 496zM45.4 256H204.5l-12.2 60.9-2.1 10.5 8.9 5.9 24 16 10.7 7.2 9.3-9L502.5 96h66.9l32 32H520h-7.6l-4.8 5.9-244 298.3c-24.8 30.3-61.9 47.9-101 47.9C90.5 480 32 421.5 32 349.4v-7.6c0-8.3 .7-16.6 2.2-24.7L45.4 256zM144 328a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faSaxHot = faSaxophoneFire;
  

  
  

  var faFileArrowDown = {
    prefix: 'fasl',
    iconName: 'file-arrow-down',
    icon: [
      384,
      512,
      ["file-download"],
      'f56d',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM208 240V224H176v16V361.4l-52.7-52.7L112 297.4 89.4 320l11.3 11.3 80 80L192 422.6l11.3-11.3 80-80L294.6 320 272 297.4l-11.3 11.3L208 361.4V240z'
      
    ]
  };

  
    var faFileDownload = faFileArrowDown;
  

  
  

  var faCompactDisc = {
    prefix: 'fasl',
    iconName: 'compact-disc',
    icon: [
      512,
      512,
      [128191,128192,128440],
      'f51f',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm72 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-120 0H80c0-97.2 78.8-176 176-176v32c-79.5 0-144 64.5-144 144z'
      
    ]
  };

  

  
  

  var faToiletPortable = {
    prefix: 'fasl',
    iconName: 'toilet-portable',
    icon: [
      320,
      512,
      [],
      'e583',
      
      'M16 0H0V16 496v16H32V496 480H288v16 16h32V496 336 304 240 208 16 0H304 16zM288 240v64H256V240h32zm0-112v80H256 224v32 64 32h32 32V448H32V128H288zm0-32H32V32H288V96z'
      
    ]
  };

  

  
  

  var faBrakeWarning = {
    prefix: 'fasl',
    iconName: 'brake-warning',
    icon: [
      640,
      512,
      [],
      'e0c7',
      
      'M320 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 416a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm16-336V128H304v16V272v16h32V272 144zM296 320v48h48V320H296zM77.5 100.6l8.6-13.5L59.2 69.9 50.5 83.3C18.5 133.2 0 192.4 0 256s18.5 122.8 50.5 172.7l8.6 13.5 26.9-17.3-8.6-13.5C48.7 366.6 32 313.3 32 256s16.7-110.6 45.5-155.4zm512-17.3l-8.6-13.5L553.9 87.2l8.6 13.5C591.3 145.4 608 198.7 608 256s-16.7 110.6-45.5 155.4l-8.6 13.5 26.9 17.3 8.6-13.5C621.4 378.8 640 319.6 640 256s-18.6-122.8-50.5-172.7z'
      
    ]
  };

  

  
  

  var faCircleHalf = {
    prefix: 'fasl',
    iconName: 'circle-half',
    icon: [
      512,
      512,
      [],
      'e110',
      
      'M224 34.3V477.7C115.4 462.2 32 368.8 32 256S115.4 49.8 224 34.3zM224 2C97.7 17.7 0 125.5 0 256S97.7 494.3 224 510c10.5 1.3 21.2 2 32 2V480 32 0c-10.8 0-21.5 .7-32 2z'
      
    ]
  };

  

  
  

  var faWindsock = {
    prefix: 'fasl',
    iconName: 'windsock',
    icon: [
      512,
      512,
      [],
      'f777',
      
      'M32 0V16 128H96V80.6 48l32 6.2L512 128V288L128 361.8 96 368V335.4 288H32V496v16H0V496 272 144 16 0H32zm0 160v96H96V160H32zm96 169.3l96-18.5V105.2L128 86.7V128v32 96 32 41.3zm128-24.6L384 280V136L256 111.4V304.6zM416 142.1V273.9l64-12.3V154.4l-64-12.3z'
      
    ]
  };

  

  
  

  var faMound = {
    prefix: 'fasl',
    iconName: 'mound',
    icon: [
      576,
      512,
      [],
      'e52d',
      
      'M519.5 384H56.5L170 194.8c24.9-41.4 69.6-66.8 118-66.8s93.1 25.4 118 66.8L519.5 384zm37.3 0L433.4 178.3C402.7 127.2 347.6 96 288 96s-114.7 31.2-145.4 82.3L19.2 384 0 416H37.3 538.7 576l-19.2-32z'
      
    ]
  };

  

  
  

  var faPeoplePants = {
    prefix: 'fasl',
    iconName: 'people-pants',
    icon: [
      640,
      512,
      [],
      'e219',
      
      'M136 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 104 56a56 56 0 1 0 112 0zM108.9 128H99.3l-4.5 8.5-76.9 144-7.5 14.1 28.2 15.1 7.5-14.1L96 202.1V496v16h32V496 352h64V496v16h32V496 202.2l49.9 93.4 7.5 14.1 28.2-15.1-7.5-14.1-76.9-144-4.5-8.5h-9.6H108.9zM192 320H128V160h64V320zM456 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM428.9 128h-9.6l-4.5 8.5-76.9 144-7.5 14.1 28.2 15.1 7.5-14.1L416 202.1V496v16h32V496 352h64V496v16h32V496 202.2l49.9 93.4 7.5 14.1 28.2-15.1-7.5-14.1-76.9-144-4.5-8.5h-9.6H428.9zM512 320H448V160h64V320z'
      
    ]
  };

  

  
  

  var faGridRound2Plus = {
    prefix: 'fasl',
    iconName: 'grid-round-2-plus',
    icon: [
      512,
      512,
      [],
      'e5dc',
      
      'M64 128a64 64 0 1 0 128 0A64 64 0 1 0 64 128zm64 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM64 384a64 64 0 1 0 128 0A64 64 0 1 0 64 384zm64 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM384 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM384 272c8.8 0 16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H400v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V400H288c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V288c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faHurricane = {
    prefix: 'fasl',
    iconName: 'hurricane',
    icon: [
      384,
      512,
      [],
      'f751',
      
      'M216 16.2V-.5L199.3 .2C88.5 4.7 0 96 0 208C0 309.2 72.3 393.5 168 412.2v83.1 16.7l16.7-.7C295.5 506.7 384 415.4 384 303.4c0-101.2-72.3-185.5-168-204.2V16.2zM32 208C32 118.9 98.2 45.3 184 33.6v79.3V127l14 1.7c86.8 10.8 154 84.9 154 174.6c0 89.1-66.2 162.7-152 174.4V398.5 384.4l-14-1.8C99.2 371.8 32 297.7 32 208zm208 48a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z'
      
    ]
  };

  

  
  

  var faUpload = {
    prefix: 'fasl',
    iconName: 'upload',
    icon: [
      512,
      512,
      [],
      'f093',
      
      'M272 368v16H240V368 62.6L139.3 163.3 128 174.6 105.4 152l11.3-11.3 128-128L256 1.4l11.3 11.3 128 128L406.6 152 384 174.6l-11.3-11.3L272 62.6V368zm-64-16H32V480H480V352H304V320H480h32v32V480v32H480 32 0V480 352 320H32 208v32zm176 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faUpFromLine = {
    prefix: 'fasl',
    iconName: 'up-from-line',
    icon: [
      384,
      512,
      ["arrow-alt-from-bottom"],
      'f346',
      
      'M240 240l0-32 32 0 48 0 0-17.7L192 75.1 64 190.3 64 208l48 0 32 0 0 32 0 112 96 0 0-112zm112 0l-32 0-16 0-32 0 0 32 0 80 0 32-32 0-96 0-32 0 0-32 0-80 0-32-32 0-16 0-32 0 0-32 0-32L192 32 352 176l0 32 0 32zM16 480L0 480l0-32 16 0 352 0 16 0 0 32-16 0L16 480z'
      
    ]
  };

  
    var faArrowAltFromBottom = faUpFromLine;
  

  
  

  var faMoneyCheckDollarPen = {
    prefix: 'fasl',
    iconName: 'money-check-dollar-pen',
    icon: [
      640,
      512,
      ["money-check-edit-alt"],
      'f873',
      
      'M32 96H544v92.9l4.9-4.9L576 156.9V96 64H544 32 0V96 416v32H32 327.8l5-32H32V96zM256 288v32H384V288H256zm224-96H256v32H480V192zM160 144H128v16 9.3c-6.5 1.1-12.7 2.9-18.3 5.4c-14.1 6.4-25.9 18.1-28.8 34.7c-1.6 9.5-.7 18.5 3.1 26.6c3.8 7.9 9.7 13.7 15.9 17.9c11.1 7.5 25.8 11.9 37.7 15.5l0 0 0 0 2 .6c13.8 4.2 23.9 7.5 30.5 12.3c2.9 2.1 4.3 4 5.1 5.7c.7 1.6 1.3 4.3 .5 9c-.9 5-3.8 9-10.3 11.8c-7 3-17.7 4.3-31 2.2c-6.4-1-17.6-4.8-27.1-8.1l0 0 0 0c-2.2-.7-4.2-1.4-6.1-2.1l-15.2-5.1L75.8 326.1l15.2 5.1c1.3 .4 2.8 1 4.6 1.6l0 0 0 0 0 0c8.9 3 23 7.9 32.4 9.6V352v16h32V352v-8.9c6.3-.9 12.3-2.5 17.9-4.9c14.7-6.3 26.3-18.3 29.3-35.7c1.7-9.7 .9-18.9-2.7-27.2c-3.6-8.2-9.3-14.3-15.6-18.8c-11.6-8.4-27.2-13.1-39.5-16.9l0 0-.6-.2c-13.9-4.2-24.3-7.4-31-12c-3-2-4.3-3.8-5-5.1c-.6-1.2-1.2-3.3-.5-7.4c.6-3.6 3.3-7.8 10.5-11c7.3-3.3 18-4.9 30.9-2.9c4.4 .7 18.1 3.4 22.1 4.4l15.5 4.1 8.2-30.9-15.5-4.1c-5.1-1.4-18.2-3.9-24.1-4.9V160 144zM553.3 269.3l41.5 41.5L572 333.5 530.5 292l22.8-22.8zM398 424.5L507.9 314.6l41.5 41.5L439.5 466l-49.1 7.7 7.7-49.1zM617.4 288.1L553.3 224 368 409.3l-10.8 69.5L352 512l33.2-5.2L454.7 496 617.4 333.3 640 310.7l-22.6-22.6z'
      
    ]
  };

  
    var faMoneyCheckEditAlt = faMoneyCheckDollarPen;
  

  
  

  var faCodeMerge = {
    prefix: 'fasl',
    iconName: 'code-merge',
    icon: [
      448,
      512,
      [],
      'f387',
      
      'M128 32v96H96 64 32V32h96zM32 160H64V352H32 0v32 96 32H32h96 32V480 384 352H128 96V234.5c26.4 32.6 66.8 53.5 112 53.5h80v32 32h32 96 32V320 224 192H416 320 288v32 32H208c-56.4 0-103.1-41.7-110.9-96H128h32V128 32 0H128 32 0V32v96 32H32zM320 288V256 224h96v96H320V288zM64 384H96h32v96H32V384H64z'
      
    ]
  };

  

  
  

  var faStop = {
    prefix: 'fasl',
    iconName: 'stop',
    icon: [
      384,
      512,
      [9209],
      'f04d',
      
      'M352 96V416H32V96H352zM32 64H0V96 416v32H32 352h32V416 96 64H352 32z'
      
    ]
  };

  

  
  

  var faUpLong = {
    prefix: 'fasl',
    iconName: 'up-long',
    icon: [
      320,
      512,
      ["long-arrow-alt-up"],
      'f30c',
      
      'M120 160v32l0 288h80l0-288V160h32 42.7L160 45.3 45.3 160H88h32zM32 192H0l0-32L137.4 22.6 160 0l22.6 22.6L320 160v32H288 264 232v32l0 256v32H200 120 88V480l0-256V192H56 32z'
      
    ]
  };

  
    var faLongArrowAltUp = faUpLong;
  

  
  

  var faBlockQuote = {
    prefix: 'fasl',
    iconName: 'block-quote',
    icon: [
      448,
      512,
      [],
      'e0b5',
      
      'M16 80H0v32H16 432h16V80H432 16zM144 240H128v32h16H432h16V240H432 144zM128 400v32h16H432h16V400H432 144 128zM0 432v16H32V432l0-192 0-16H0v16V432z'
      
    ]
  };

  

  
  

  var faTruckPickup = {
    prefix: 'fasl',
    iconName: 'truck-pickup',
    icon: [
      640,
      512,
      [128763],
      'f63c',
      
      'M240 32H224V48 192H64 32v32V352H16 0v32H16 32 64 80c0 53 43 96 96 96s96-43 96-96h96c0 53 43 96 96 96s96-43 96-96h16 32 16 16V352H624 608V224 192H576 526.1l-1.5-1.9-120-152L399.8 32H392 240zM576 224V352H554.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H266.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H64V224H576zm-90.7-32H256V64H384.2L485.3 192zM112 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm352-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faTowerBroadcast = {
    prefix: 'fasl',
    iconName: 'tower-broadcast',
    icon: [
      576,
      512,
      ["broadcast-tower"],
      'f519',
      
      'M517.6 241.4l28.7 14.2c19-38.4 29.7-81.7 29.7-127.5s-10.7-89.1-29.7-127.5L517.6 14.6C534.5 48.8 544 87.3 544 128s-9.5 79.2-26.4 113.4zm-459.2 0C41.5 207.2 32 168.7 32 128s9.5-79.2 26.4-113.4L29.7 .5C10.7 38.9 0 82.2 0 128s10.7 89.1 29.7 127.5l28.7-14.2zM115.8 213l28.7-14.2C133.9 177.5 128 153.4 128 128s5.9-49.5 16.5-70.9L115.8 43C103.1 68.6 96 97.5 96 128s7.1 59.4 19.8 85zm344.4 0c12.7-25.6 19.8-54.5 19.8-85s-7.1-59.4-19.8-85L431.5 57.1C442.1 78.5 448 102.6 448 128s-5.9 49.5-16.5 70.9L460.2 213zM288 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 94c27.6-7.1 48-32.2 48-62c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 29.8 20.4 54.9 48 62V496v16h32V496 190z'
      
    ]
  };

  
    var faBroadcastTower = faTowerBroadcast;
  

  
  

  var faLoveseat = {
    prefix: 'fasl',
    iconName: 'loveseat',
    icon: [
      512,
      512,
      ["couch-small"],
      'f4cc',
      
      'M416 64H96V192H64V64 32H96 416h32V64 192H416V64zM32 448H96V416 320 288 256H32V448zm96-192v32H384V256 224h32 64 32v32V448v32H480 416 384V448H128v32H96 32 0V448 256 224H32 96h32v32zm0 160H384V320H128v96zm288 0v32h64V256H416v32 32 96z'
      
    ]
  };

  
    var faCouchSmall = faLoveseat;
  

  
  

  var faPeopleDress = {
    prefix: 'fasl',
    iconName: 'people-dress',
    icon: [
      640,
      512,
      [],
      'e217',
      
      'M136 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 104 56a56 56 0 1 0 112 0zM126.3 263.2l7.2-14.3-28.6-14.3-7.2 14.3-64 128L22.1 400H48 96v96 16h32V496 400h64v96 16h32V496 400h48 25.9l-11.6-23.2-64-128-7.2-14.3-28.6 14.3 7.2 14.3L246.1 368H224 192 128 96 73.9l52.4-104.8zM99.3 128l-4.5 8.5-76.9 144-7.5 14.1 28.2 15.1 7.5-14.1L118.5 160h83l72.4 135.5 7.5 14.1 28.2-15.1-7.5-14.1-76.9-144-4.5-8.5h-9.6H108.9 99.3zM456 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM446.3 263.2l7.2-14.3-28.6-14.3-7.2 14.3-64 128L342.1 400H368h48v96 16h32V496 400h64v96 16h32V496 400h48 25.9l-11.6-23.2-64-128-7.2-14.3-28.6 14.3 7.2 14.3L566.1 368H544 512 448 416 393.9l52.4-104.8zM419.3 128l-4.5 8.5-76.9 144-7.5 14.1 28.2 15.1 7.5-14.1L438.5 160h83l72.4 135.5 7.5 14.1 28.2-15.1-7.5-14.1-76.9-144-4.5-8.5h-9.6H428.9h-9.6z'
      
    ]
  };

  

  
  

  var faHandHoldingSkull = {
    prefix: 'fasl',
    iconName: 'hand-holding-skull',
    icon: [
      576,
      512,
      [],
      'e1a4',
      
      'M176 128c0 33.3 20 63.5 51.9 81l10.8 5.9-3 12L228.5 256h119l-7.3-29.1-3-12 10.8-5.9C380 191.5 400 161.3 400 128c0-51.1-48.1-96-112-96s-112 44.9-112 96zM288 0c77.5 0 144 55.4 144 128c0 42.6-23.3 79.6-57.9 102.6l9.4 37.5 5 19.9H368 208 187.5l5-19.9 9.4-37.5c-34.6-23-57.9-60-57.9-102.6C144 55.4 210.5 0 288 0zM248 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM171.2 304H176 384h16v16 64h.2l103.6-61.7 13.5-8 8.3 13.3 40 64L574 405l-13.5 8.5-152 96-3.9 2.5H400 16 0V480H16 395.4L530 395l-23.3-37.2-94 56L409 416h-4.4H400 384 320 304 256 240V384h16 48 16 48V336H180.8l-92 61.3-4 2.7H80 16 0V368H16 75.2l92-61.3 4-2.7z'
      
    ]
  };

  

  
  

  var faBanana = {
    prefix: 'fasl',
    iconName: 'banana',
    icon: [
      576,
      512,
      [],
      'e2e5',
      
      'M349.4 51.8L325.8 67.9C332.5 92.1 336 117.7 336 144c0 41.9-8.9 81.7-25 117.6L286.2 238c11.5-29.1 17.8-60.8 17.8-94c0-31.4-5.6-61.3-15.9-89l65.1-44.6C411.4 63.1 448 139.3 448 224c0 14.7-1.1 29.2-3.2 43.3l-34.5 10.9c3.8-17.5 5.8-35.6 5.8-54.2c0-66.3-25.2-126.8-66.6-172.2zM254.1 295.8l-13.8-13.2-90.4 36.2-14.9 5.9-11.9-29.7 14.9-5.9 100-40 9.6-3.8 7.4 7.1 85.2 81.5 143-45.1 11-3.5 6.8 9.3 64 88 9.4 12.9-25.9 18.8-9.4-12.9-57.2-78.7-58.7 18.5C378.2 441.9 277.3 512 160 512L32 512H0V432 400H32 48c84.5 0 159.5-41 206.1-104.2zm125.9 59l-39.3 12.4-9 2.9-6.8-6.5-47.5-45.4C224.8 387.3 141.6 432 48 432H32v48l128 0c93.6 0 175.4-50.2 220.1-125.1z'
      
    ]
  };

  

  
  

  var faHouseTurret = {
    prefix: 'fasl',
    iconName: 'house-turret',
    icon: [
      640,
      512,
      [],
      'e1b4',
      
      'M0 0H16 336h16V16 134.3L320 161V32H256V96v16H224V96 32H128V96v16H96V96 32H32V209.9l60 67.5 4 4.5V288 496v16H64V496 294.1L4 226.6l-4-4.5V216 16 0zM320 202.7L352 176l96-80L640 256V480v32H608 288 256V480 256l64-53.3zM192 192c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h32V192zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48v32 32H192 160 128V224 192zm160 79V480H608V271L448 137.7 288 271zm128 17v64h64V288H416zm0-32h64 32v32 64 32H480 416 384V352 288 256h32z'
      
    ]
  };

  

  
  

  var faChartScatterBubble = {
    prefix: 'fasl',
    iconName: 'chart-scatter-bubble',
    icon: [
      512,
      512,
      [],
      'e0e9',
      
      'M32 32V48 448H496h16v32H496 16 0V464 48 32H32zM176 323.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm0-67.2a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm208 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm-48-92.8a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm0-67.2a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm176 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faCircleVideo = {
    prefix: 'fasl',
    iconName: 'circle-video',
    icon: [
      512,
      512,
      ["video-circle"],
      'e12b',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-320v24 80 24H160V192H288zm32 12V192 160H288 160 128v32V320v32h32H288h32V320 308l64 24 32 12V309.8 202.2 168l-32 12-64 24zm0 34.2l64-24v83.6l-64-24V238.2z'
      
    ]
  };

  
    var faVideoCircle = faCircleVideo;
  

  
  

  var faGameBoardSimple = {
    prefix: 'fasl',
    iconName: 'game-board-simple',
    icon: [
      448,
      512,
      ["game-board-alt"],
      'f868',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM80 96H224h16v16V240H368h16v16V400v16H368 224 208V400 272H80 64V256 112 96H80zm128 32H96V240H208V128zm32 256H352V272H240V384z'
      
    ]
  };

  
    var faGameBoardAlt = faGameBoardSimple;
  

  
  

  var faSkull = {
    prefix: 'fasl',
    iconName: 'skull',
    icon: [
      512,
      512,
      [128128],
      'f54c',
      
      'M384 382.2v16.6V480H320V432 416H288v16 48H224V432 416H192v16 48H128V398.9 382.2l-13.6-9.6C63.1 336.7 32 282.8 32 224C32 121.8 128.1 32 256 32s224 89.8 224 192c0 58.8-31.1 112.7-82.4 148.7L384 382.2zm32 16.6c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224c0 70.7 37.5 133.8 96 174.9V480v32h32H384h32V480 398.9zM160 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm160-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faTimelineArrow = {
    prefix: 'fasl',
    iconName: 'timeline-arrow',
    icon: [
      640,
      512,
      [],
      'e29d',
      
      'M80 48v64h64V48H80zM48 16H80h64 32V48v64 32H144 128V256H352V144H336 304V112 48 16h32 64 32V48v64 32H400 384V256H574.6l-57.4-52.2-11.8-10.8 21.5-23.7 11.8 10.8 88 80 13 11.8-13 11.8-88 80-11.8 10.8-21.5-23.7 11.8-10.8L574.6 288H256v80h16 32v32 64 32H272 208 176V464 400 368h32 16V288H16 0V256H16 96V144H80 48V112 48 16zM256 400H224 208v64h64V400H256zM400 48H336v64h64V48z'
      
    ]
  };

  

  
  

  var faBowlRice = {
    prefix: 'fasl',
    iconName: 'bowl-rice',
    icon: [
      512,
      512,
      [],
      'e2eb',
      
      'M176 64h16 32 16V96H224 192 176V64zm16 64h32 16v32H224 192 176V128h16zM48 192H80 96v32H80 48 32V192H48zm80 239.8V448H384V431.8 411.6l18.3-8.7c43.7-20.8 74.6-64.1 77.5-114.9H32.2c2.9 50.8 33.8 94.2 77.5 114.9l18.3 8.7v20.2zm-32 0C41.5 405.9 3.2 351.6 .2 288c-.1-2.7-.2-5.3-.2-8V256H32 480h32v24c0 2.7-.1 5.3-.2 8c-3 63.6-41.3 117.9-95.8 143.8V448v32H384 128 96V448 431.8zM224 192h16 32 16v32H272 240 224V192zm-96 0h16 32 16v32H176 144 128V192zM96 128h32 16v32H128 96 80V128H96zm224 64h16 32 16v32H368 336 320V192zm-32-64h32 16v32H320 288 272V128h16zm128 64h16 32 16v32H464 432 416V192zm-32-64h32 16v32H416 384 368V128h16zM288 64h32 16V96H320 288 272V64h16z'
      
    ]
  };

  

  
  

  var faMillSign = {
    prefix: 'fasl',
    iconName: 'mill-sign',
    icon: [
      384,
      512,
      [],
      'e1ed',
      
      'M176 241.6L88.8 498.9l30.3 10.3L176 341.3V432v16h32V432 246.8l37.2-109.9c10.3-5.7 22.2-8.9 34.8-8.9c39.8 0 72 32.2 72 72V432v16h32V432 200c0-57.4-46.6-104-104-104c-7.4 0-14.7 .8-21.7 2.3l28.8-85.1L256.8 2.9 218.5 116.1C208 123.9 199 133.5 192 144.5C173.6 115.4 141.1 96 104 96c-27.9 0-53.3 11-72 29V96H0V200v8V432v16H32V432 208v-8c0-39.8 32.2-72 72-72s72 32.2 72 72v41.6z'
      
    ]
  };

  

  
  

  var faBalloons = {
    prefix: 'fasl',
    iconName: 'balloons',
    icon: [
      640,
      512,
      [],
      'e2e4',
      
      'M172.8 342.4l0 0 .1-.1 .8-.6c.8-.6 2-1.6 3.6-2.8c3.1-2.6 7.8-6.4 13.3-11.4c11.2-10 26.1-24.5 40.9-42C262 249.1 288 204.5 288 160c0-70.7-57.3-128-128-128S32 89.3 32 160c0 44.5 26 89.1 56.5 125.4c14.8 17.6 29.7 32 40.9 42c5.6 5 10.2 8.8 13.3 11.4c1.6 1.3 2.8 2.2 3.6 2.8l.8 .6 .1 .1 0 0 0 0 0 0 0 0L160 352l12.8-9.6 0 0 0 0 0 0zm-10.5 37.5l-2.3-5.7-2.3 5.7L143.3 416h33.5l-14.4-36.1zM211.2 416L224 448H189.5 130.5 96l12.8-32L128 368s-128-96-128-208C0 71.6 71.6 0 160 0s160 71.6 160 160c0 112-128 208-128 208l19.2 48zM176 112c-35.3 0-64 28.7-64 64H80c0-53 43-96 96-96v32zm320 64c-35.3 0-64 28.7-64 64H400c0-53 43-96 96-96v32zM448 432s-85.6-64.2-116.8-148.9c8.2-13.9 15.6-28.8 21.7-44.7c4.8 39.7 28.4 78.7 55.6 111.1c14.8 17.6 29.7 32 40.9 42c5.6 5 10.2 8.8 13.3 11.4c1.6 1.3 2.8 2.2 3.6 2.8l.8 .6 .1 .1 0 0 0 0 0 0 0 0L480 416l12.8-9.6 0 0 0 0 0 0 0 0 .1-.1 .8-.6c.8-.6 2-1.6 3.6-2.8c3.1-2.6 7.8-6.4 13.3-11.4c11.2-10 26.1-24.5 40.9-42C582 313.1 608 268.5 608 224c0-70.7-57.3-128-128-128c-48.2 0-90.2 26.6-112 66c0-.7 0-1.3 0-2c0-15.5-1.7-30.7-4.9-45.2C392.3 83.5 433.9 64 480 64c88.4 0 160 71.6 160 160c0 112-128 208-128 208l19.2 48L544 512H509.5 450.5 416l12.8-32L448 432zm34.3 11.9l-2.3-5.7-2.3 5.7L463.3 480h33.5l-14.4-36.1z'
      
    ]
  };

  

  
  

  var faChartPieSimpleCircleDollar = {
    prefix: 'fasl',
    iconName: 'chart-pie-simple-circle-dollar',
    icon: [
      640,
      512,
      [],
      'e605',
      
      'M288 32.5V224H394.8c-12.9 9.1-24.5 19.9-34.6 32H288 256V224 .6c5.6-.4 11.3-.6 17.1-.6c116 0 212.7 82.7 234.4 192.4c-3.8-.2-7.6-.4-11.5-.4c-7.1 0-14.2 .4-21.1 1.2C455.2 105.6 379.9 39.1 288 32.5zM256 288h83.2c-5.2 10.1-9.4 20.8-12.6 32H224 192V288 69.6C100.3 91.2 32 173.6 32 272c0 114.9 93.1 208 208 208c37.1 0 71.9-9.7 102-26.7c5.2 9.4 11.3 18.3 18.1 26.5C324.8 500.3 283.8 512 240 512C107.5 512 0 404.6 0 272C0 155.9 82.5 59 192 36.8c10.4-2.1 21.1-3.6 32-4.3V64.6 256v32h32zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM472.8 335.4c-.4 .7-.9 1.6-.8 3.6l0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8 16H480v-16V438.1c-8.6-1.7-16.7-4.3-23.7-6.6l0 0 0 0c-1.7-.6-3.4-1.1-5-1.6L436 425.2l9.5-30.6 15.3 4.8c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3V288 272h32v16 9.4c6.3 .9 12.3 2.3 17.9 3.7l15.5 3.9-7.7 31.1-15.5-3.9c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4z'
      
    ]
  };

  

  
  

  var faArrowUpWideShort = {
    prefix: 'fasl',
    iconName: 'arrow-up-wide-short',
    icon: [
      576,
      512,
      ["sort-amount-up"],
      'f161',
      
      'M139.3 44.7L128 33.4 116.7 44.7l-88 88L17.4 144 40 166.6l11.3-11.3L112 94.6V464v16h32V464 94.6l60.7 60.7L216 166.6 238.6 144l-11.3-11.3-88-88zM304 464h64 16V432H368 304 288v32h16zm0-128H432h16V304H432 304 288v32h16zm0-128H496h16V176H496 304 288v32h16zm0-128H560h16V48H560 304 288V80h16z'
      
    ]
  };

  
    var faSortAmountUp = faArrowUpWideShort;
  

  
  

  var faUtensils = {
    prefix: 'fasl',
    iconName: 'utensils',
    icon: [
      448,
      512,
      [61685,127860,"cutlery"],
      'f2e7',
      
      'M197.6 0H165.1l26.2 157.4c.4 2.6 .7 5.2 .7 7.9V176c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V165.3c0-2.6 .2-5.3 .7-7.9L58.9 0H26.4L1.1 152.1C.4 156.5 0 160.9 0 165.3V176c0 44.2 35.8 80 80 80H96V496v16h32V496 256h16c44.2 0 80-35.8 80-80V165.3c0-4.4-.4-8.8-1.1-13.2L197.6 0zM151.2 0h-32l.8 16.8 8.5 170 .3 5.2h32l-.3-6.8L152 15.2 151.2 0zM104.8 0h-32L72 15.2l-8.5 170-.3 6.8h32l.3-5.2 8.5-170L104.8 0zM320 176c0-62.5 23.8-97.7 47-117.8c12-10.4 24.4-17.2 34.5-21.3c7.6-3.1 12.6-4.2 14.3-4.6l.2-.1V320H320V176zM448 320V32 0H416C400 0 288 32 288 176V320v32h32 96V496v16h32V496 352 336 320z'
      
    ]
  };

  
    var faCutlery = faUtensils;
  

  
  

  var faRotateRight = {
    prefix: 'fasl',
    iconName: 'rotate-right',
    icon: [
      512,
      512,
      ["redo-alt","rotate-forward"],
      'f2f9',
      
      'M256 64c48.9 0 93.6 18.3 127.5 48.5l-32.9 32.9L328 168l22.6 22.6L352 192h96 32V160 64l-1.4-1.4L456 40 433.4 62.6 406.2 89.8C366.5 53.9 313.8 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c86.4 0 161.4-49 198.8-120.6l-28.4-14.8C394.3 406.1 330.1 448 256 448C150 448 64 362 64 256S150 64 256 64zm192 96H381.3L448 93.3V160z'
      
    ]
  };

  
    var faRedoAlt = faRotateRight;
  
    var faRotateForward = faRotateRight;
  

  
  

  var faArrowRightArrowLeft = {
    prefix: 'fasl',
    iconName: 'arrow-right-arrow-left',
    icon: [
      448,
      512,
      [8644,"exchange"],
      'f0ec',
      
      'M12.7 395.3L1.4 384l11.3-11.3 96-96L120 265.4 142.6 288l-11.3 11.3L62.6 368 432 368l16 0 0 32-16 0L62.6 400l68.7 68.7L142.6 480 120 502.6l-11.3-11.3-96-96zm422.6-256l-96 96L328 246.6 305.4 224l11.3-11.3L385.4 144 16 144 0 144l0-32 16 0 369.4 0L316.7 43.3 305.4 32 328 9.4l11.3 11.3 96 96L446.6 128l-11.3 11.3z'
      
    ]
  };

  
    var faExchange = faArrowRightArrowLeft;
  

  
  

  var faGolfClub = {
    prefix: 'fasl',
    iconName: 'golf-club',
    icon: [
      512,
      512,
      [],
      'f451',
      
      'M481.7 8.8L303.5 365.1 20.2 288.6 0 283.1V304 496v16H16 256h9.9l4.4-8.8 56-112 184-368L481.7 8.8zM32 324.9l256.9 69.4L246.1 480H32V448H80 96V416H80 32V400H80 96V368H80 32V324.9z'
      
    ]
  };

  

  
  

  var faCastle = {
    prefix: 'fasl',
    iconName: 'castle',
    icon: [
      640,
      512,
      [],
      'e0de',
      
      'M128 0h16 72 16V16 64h32V16 0h16 80 16V16 64h32V16 0h16 72 16V16 224h32V176 160h16 64 16v16V496v16H624 16 0V496 176 160H16 80 96v16 48h32V16 0zm32 256H144 80 64V240 192H32V480H224V400c0-53 43-96 96-96s96 43 96 96v80H608V192H576v48 16H560 496 480 160zm320-32V32H440V80 96H424 360 344V80 32H296V80 96H280 216 200V80 32H160V224H480zM384 400c0-35.3-28.7-64-64-64s-64 28.7-64 64v80H384V400z'
      
    ]
  };

  

  
  

  var faKiwiBird = {
    prefix: 'fasl',
    iconName: 'kiwi-bird',
    icon: [
      576,
      512,
      [],
      'f535',
      
      'M331.6 304L322 317.3C292.9 357.8 245.5 384 192 384c-22.8 0-44.4-4.7-64-13.3V368h-5.8C68.8 342.1 32 287.3 32 224c0-88.4 71.6-160 160-160c53.5 0 100.9 26.2 130 66.7l9.6 13.3H348 464c44.2 0 80 35.8 80 80v80H348 331.6zm180.1 32H544l0 44-32.4-44zM348 336H471.9l75.2 102.3L576 477.6l0-48.8 0-92.8V304 224c0-61.9-50.1-112-112-112H348c-34.9-48.5-91.7-80-156-80C86 32 0 118 0 224c0 71.1 38.6 133.1 96 166.3V464v16h32V464 405.1c20 7.1 41.6 10.9 64 10.9c10.9 0 21.6-.9 32-2.7V464v16h32V464 405.1c37.3-13.2 69.3-37.5 92-69.1zm100-88a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faBlanketFire = {
    prefix: 'fasl',
    iconName: 'blanket-fire',
    icon: [
      640,
      512,
      [],
      'e3da',
      
      'M16 0H0V16 256v16 16V432v16H16 313.8c-5.9-10.1-10.8-20.8-14.8-32H32V288H299.5c4-11.2 8.9-21.8 14.4-32H32V32H416V142.8c5.3-3.8 10.4-7.2 15-10.1l17-10.6V16 0H432 16zM288 351.8c0-5.3 .2-10.6 .7-15.8H96 80v32H96 288.7c-.4-5.3-.7-10.7-.7-16.2zM489.4 201.4L448 160c-42.7 26.7-128 102.4-128 192c0 85.2 66.6 154.9 150.7 159.7c3.1 .3 6.2 .4 9.3 .4s6.3-.1 9.3-.4C573.4 506.9 640 437.2 640 352c0-26.7-19.2-96-96-160l-9.4 9.4L512 224l-22.6-22.6zM480 480c-2.4 0-4.8-.1-7.2-.2c-33.6-3.3-56.8-29.4-56.8-57.3c0-21.9 15.9-47.5 39-71.3c8.8-9 17.6-16.9 25-23c7.4 6.1 16.2 13.9 25 23c23.1 23.8 39 49.5 39 71.3c0 27.8-23.2 54-56.8 57.3c-2.4 .1-4.8 .2-7.2 .2zm96-57.4c0-70.4-96-134.4-96-134.4s-96 64-96 134.4c0 5.4 .5 10.6 1.5 15.8C364.7 415.6 352 385.3 352 352c0-34.7 16.7-69.1 41-99.7c16.4-20.6 35.2-38 51.4-50.7l45 45L512 269.3l22.6-22.6L545 236.2C597 288.3 608 337.9 608 352c0 33.3-12.7 63.6-33.5 86.3c1-5.1 1.5-10.4 1.5-15.8z'
      
    ]
  };

  

  
  

  var faButter = {
    prefix: 'fasl',
    iconName: 'butter',
    icon: [
      640,
      512,
      [129480],
      'e3e4',
      
      'M480 96V288H448V96H96V288H64V96 64H96 448h16 16 64 32V96 288H544V96H480zM0 320H16 32 64 576h32 16 16v32H624 608v64 32H576 64 32V416 352H16 0V320zm64 32v64H576V352H64z'
      
    ]
  };

  

  
  

  var faHelmetBattle = {
    prefix: 'fasl',
    iconName: 'helmet-battle',
    icon: [
      576,
      512,
      [],
      'f6eb',
      
      'M288 0S96 80 96 224c0 80-32 192-32 192l176 88 16 8h16V480 264l-40-8-40-8V224h4.8H224h11.2H340.8 352h27.2H384v24l-40 8-40 8V480v32h16l16-8 176-88s-32-112-32-192C480 80 288 0 288 0zM474.4 399L336 468.2v-178l54.3-10.9 25.7-5.1V248 224 192H384 192 160v32 24 26.2l25.7 5.1L240 290.2v178L101.6 399c2.8-11.4 6.3-26 9.8-42.4C119.4 318 128 267.4 128 224c0-57.1 38.3-104.8 83.9-140.9C234 65.5 256.4 52 273.2 42.9c5.6-3.1 10.6-5.6 14.8-7.6c4.1 2 9.1 4.6 14.8 7.6C319.6 52 342 65.5 364.1 83.1C409.7 119.2 448 166.9 448 224c0 43.4 8.6 94 16.7 132.6c3.5 16.4 6.9 31 9.8 42.4zM44.3 224L95.6 11.8 64.4 4.2l-56 232L3.7 256H24 56 72V224H56 44.3zM480.4 11.8L531.7 224H520 504v32h16 32 20.3l-4.8-19.8-56-232-31.1 7.5z'
      
    ]
  };

  

  
  

  var faCircleA = {
    prefix: 'fasl',
    iconName: 'circle-a',
    icon: [
      512,
      512,
      [],
      'e0f7',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM245.8 112l-4.3 9.2L126 368h35.3l30-64H320.7l30 64H386L270.5 121.2l-4.3-9.2H245.8zM256 165.7L305.8 272H206.2L256 165.7z'
      
    ]
  };

  

  
  

  var faDiceOne = {
    prefix: 'fasl',
    iconName: 'dice-one',
    icon: [
      448,
      512,
      [9856],
      'f525',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM224 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faPotato = {
    prefix: 'fasl',
    iconName: 'potato',
    icon: [
      512,
      512,
      [129364],
      'e440',
      
      'M118.6 230.6l2.8-2.8 2-3.4 43.9-73.1 73.1-43.9 3.4-2 2.8-2.8 36.9-36.9C305.1 44.1 334.4 32 364.9 32C428.5 32 480 83.5 480 147.1c0 30.5-12.1 59.8-33.7 81.4l-4.9 4.9-3.2 3.2-2.2 3.9L361.3 374.9 259.4 418.6l-5.7 2.4-4.4 4.4-20.9 20.9c-21.6 21.6-50.9 33.7-81.4 33.7C83.5 480 32 428.5 32 364.9c0-30.5 12.1-59.8 33.7-81.4l52.9-52.9zM224 80l-80 48L96 208 43.1 260.9C15.5 288.5 0 325.9 0 364.9C0 446.2 65.8 512 147.1 512c39 0 76.4-15.5 104-43.1L272 448l112-48 80-144 4.9-4.9c27.6-27.6 43.1-65 43.1-104C512 65.8 446.2 0 364.9 0c-39 0-76.4 15.5-104 43.1L224 80zm112 96v32h32V176H336zM208 240H176v32h32V240zM176 368H144v32h32V368z'
      
    ]
  };

  

  
  

  var faFileMedical = {
    prefix: 'fasl',
    iconName: 'file-medical',
    icon: [
      384,
      512,
      [],
      'f477',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM160 224H144v16 48H96 80v16 64 16H96h48v48 16h16 64 16V432 384h48 16V368 304 288H288 240V240 224H224 160zm16 80V256h32v48 16h16 48v32H224 208v16 48H176V368 352H160 112V320h48 16V304z'
      
    ]
  };

  

  
  

  var faPipe = {
    prefix: 'fasl',
    iconName: 'pipe',
    icon: [
      64,
      512,
      [],
      '7c',
      
      'M48 0V16 496v16H16V496 16 0H48z'
      
    ]
  };

  

  
  

  var faMoonOverSun = {
    prefix: 'fasl',
    iconName: 'moon-over-sun',
    icon: [
      512,
      512,
      ["eclipse-alt"],
      'f74a',
      
      'M178.7 15.5L256 57.1l77.3-41.6L362 0l9.4 31.3 25.2 84.1 84.1 25.2L512 150l-15.5 28.8L454.9 256l41.6 77.3L512 362l-31.3 9.4-84.1 25.2-25.2 84.1L362 512l-28.8-15.5L256 454.9l-77.3 41.6L150 512l-9.4-31.3-25.2-84.1L31.3 371.4 0 362l15.5-28.8L57.1 256 15.5 178.7 0 150l31.3-9.4 84.1-25.2 25.2-84.1L150 0l28.8 15.5zm92.5 69.8L256 93.5l-15.2-8.2L169.3 46.8 146 124.6l-5 16.5-16.5 5L46.8 169.3l38.5 71.5L93.5 256l-8.2 15.2L46.8 342.7 124.6 366l16.5 5 5 16.5 23.3 77.8 71.5-38.5 15.2-8.2 15.2 8.2 71.5 38.5L366 387.4l5-16.5 16.5-5 77.8-23.3-38.5-71.5L418.5 256l8.2-15.2 38.5-71.5L387.4 146l-16.5-5-5-16.5L342.7 46.8 271.2 85.3zM174 256c0 45.3 36.7 82 82 82c14.6 0 28.4-3.8 40.3-10.6c-43.3-9.1-75.9-47.2-75.9-93.1c0-22.3 7.7-42.8 20.7-59c-38.2 7-67.1 40.5-67.1 80.6zm82-114c11.2 0 22.1 1.6 32.4 4.7l1.9 30c-22.4 9.9-37.9 32.1-37.9 57.7c0 34.7 28.5 63.2 63.9 63.2c5.8 0 11.5-.8 16.8-2.2l17.4 24.4C330.1 350 295.4 370 256 370c-63 0-114-51-114-114s51-114 114-114z'
      
    ]
  };

  
    var faEclipseAlt = faMoonOverSun;
  

  
  

  var faSeatAirline = {
    prefix: 'fasl',
    iconName: 'seat-airline',
    icon: [
      448,
      512,
      [],
      'e244',
      
      'M32 16V0H0V16 160v3.5l1.5 3.2L64 300.7V304h1.5l48 102.8 4.3 9.2H128h96v64H112 96v32h16H368h16V480H368 256V416H384h11.3l3.8-10.6 40-112 7.6-21.4H424 85.9L63.5 224H336h16V192H336 48.6L32 156.5V16zM240 384H138.2l-37.3-80H401.3l-28.6 80H240z'
      
    ]
  };

  

  
  

  var faB = {
    prefix: 'fasl',
    iconName: 'b',
    icon: [
      320,
      512,
      [98],
      '42',
      
      'M16 32H0V48 224v16 16V464v16H16 192c70.7 0 128-57.3 128-128c0-52.8-32-98.2-77.7-117.7C270 213.9 288 181 288 144c0-61.9-50.1-112-112-112H16zM192 256c53 0 96 43 96 96s-43 96-96 96H32V256H176h16zm-16-32H32V64H176c44.2 0 80 35.8 80 80s-35.8 80-80 80z'
      
    ]
  };

  

  
  

  var faSquareDownRight = {
    prefix: 'fasl',
    iconName: 'square-down-right',
    icon: [
      448,
      512,
      [],
      'e26c',
      
      'M416 448V64H32V448H416zm32 32H416 32 0V448 64 32H32 416h32V64 448v32zM320 368H160h-6.6l-4.7-4.7-16-16L121.4 336l11.3-11.3L173.4 284l-64.7-64.7L97.4 208l11.3-11.3 56-56L176 129.4l11.3 11.3L252 205.4l40.7-40.7L304 153.4l11.3 11.3 16 16 4.7 4.7V192 352v16H320zM304 198.6l-40.7 40.7L252 250.6l-11.3-11.3L176 174.6 142.6 208l64.7 64.7L218.6 284l-11.3 11.3L166.6 336H304V198.6z'
      
    ]
  };

  

  
  

  var faLaptopMedical = {
    prefix: 'fasl',
    iconName: 'laptop-medical',
    icon: [
      640,
      512,
      [],
      'f812',
      
      'M96 64H544V352h32V64 32H544 96 64V64 352H96V64zM32 418.7V416H608v2.7L578.7 448H61.3L32 418.7zM608 384H32 0v32 16l48 48H592l48-48V416 384H608zM288 112H272v16 48H224 208v16 64 16h16 48v48 16h16 64 16V320 272h48 16V256 192 176H416 368V128 112H352 288zm16 80V144h32v48 16h16 48v32H352 336v16 48H304V256 240H288 240V208h48 16V192z'
      
    ]
  };

  

  
  

  var faFlyingDisc = {
    prefix: 'fasl',
    iconName: 'flying-disc',
    icon: [
      448,
      512,
      [],
      'e3a9',
      
      'M401.7 78.3c14.5 14.5 21.3 46 4.4 96.7c-16.2 48.7-52 105.9-104.6 158.5S191.8 421.9 143.1 438.1c-50.8 16.9-82.3 10-96.7-4.4c-12.1-12.1-18.9-36.1-10.9-73.4c3 5.8 7 11.5 12.3 16.8c20 20 45.9 21.8 63.4 19.8c18.1-2 36.3-8.8 52.8-17c33.6-16.6 70.7-44.5 105.1-78.9s62.2-71.5 78.9-105.1c8.2-16.6 14.9-34.7 17-52.8c2-17.5 .2-43.4-19.8-63.4c-5.3-5.3-11-9.3-16.8-12.3c37.2-8 61.3-1.2 73.4 10.9zM105.1 175.5C8.3 282-28.4 404.2 23.7 456.3C79 511.6 213.5 466.8 324.1 356.2S479.6 111 424.3 55.7C372.2 3.6 250 40.3 143.6 137c-6.7 6-13.3 12.3-19.8 18.8c-6.5 6.5-12.8 13.1-18.7 19.7zM128.8 197c5.7-6.2 11.5-12.4 17.6-18.5c6.1-6.1 12.3-12 18.5-17.7c26.8-24.2 54-43.2 78.1-55.2c14.8-7.3 29.2-12.4 42.2-13.9c13-1.5 27 .5 37.2 10.6s12.1 24.2 10.6 37.2c-1.5 13-6.5 27.4-13.9 42.2c-14.7 29.7-40.3 64.1-72.8 96.7s-67 58.1-96.7 72.8c-14.8 7.3-29.2 12.4-42.2 13.9c-13 1.5-27-.5-37.2-10.6s-12.1-24.2-10.6-37.2c1.5-13 6.5-27.4 13.9-42.2c12-24.1 31-51.3 55.2-78.1z'
      
    ]
  };

  

  
  

  var faCalendarWeek = {
    prefix: 'fasl',
    iconName: 'calendar-week',
    icon: [
      448,
      512,
      [],
      'f784',
      
      'M128 16V0H96V16 64H32 0V96v64 32V480v32H32 416h32V480 192 160 96 64H416 352V16 0H320V16 64H128V16zM32 192H416V480H32V192zm0-96H416v64H32V96zM96 256H352v96H96V256zM64 224v32 96 32H96 352h32V352 256 224H352 96 64z'
      
    ]
  };

  

  
  

  var faCarCircleBolt = {
    prefix: 'fasl',
    iconName: 'car-circle-bolt',
    icon: [
      640,
      512,
      [],
      'e342',
      
      'M112 32H100.1L96.7 43.4 52.1 192H32 0v32V384v16 16 64H32V416H326.6c-2.9-10.3-4.9-21-5.9-32H32V224H394.8c19.5-13.7 41.9-23.6 66.2-28.5L415.3 43.4 411.9 32H400 112zM426.5 192H416 85.5L123.9 64H388.1l38.4 128zM104 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm280 48a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM520 288L416 384h66.7L472 448l104-96H509.3L520 288z'
      
    ]
  };

  

  
  

  var faVectorCircle = {
    prefix: 'fasl',
    iconName: 'vector-circle',
    icon: [
      512,
      512,
      [],
      'e2c6',
      
      'M288 32l0 18.4V82.9L288 96H224V32h64zm32 26V32 0H288 224 192V32 58C128.6 78.5 78.5 128.6 58 192H32 0v32 64 32H32 58c20.5 63.4 70.6 113.5 134 134v26 32h32 64 32V480 454c63.4-20.5 113.5-70.6 134-134h26 32V288 224 192H480 454C433.5 128.6 383.4 78.5 320 58zm0 34c45.7 17.9 82.1 54.3 100 100h-4H384v32 64 32h32 4c-17.9 45.7-54.3 82.1-100 100v-4V384H288 224 192v32 4c-45.7-17.9-82.1-54.3-100-100h4 32V288 224 192H96 92c17.9-45.7 54.3-82.1 100-100v4 32h32 64 32V96 92zM429.1 224s0 0 0 0h32.5s0 0 0 0H480v64H416V224h13.1zM288 429.1v32.5l0 18.4H224V416h64l0 13.1zM50.4 224s0 0 0 0H82.9s0 0 0 0H96v64H32V224H50.4z'
      
    ]
  };

  

  
  

  var faHouse = {
    prefix: 'fasl',
    iconName: 'house',
    icon: [
      576,
      512,
      [63498,63500,127968,"home","home-alt","home-lg-alt"],
      'f015',
      
      'M298.6 12L288 2.7 277.4 12 5.4 252l21.2 24L64 243V496v16H80 496h16V496 243l37.4 33 21.2-24L298.6 12zM96 480V214.7L288 45.3 480 214.7V480H368V304 288H352 224 208v16V480H96zm144 0V320h96V480H240z'
      
    ]
  };

  
    var faHome = faHouse;
  
    var faHomeAlt = faHouse;
  
    var faHomeLgAlt = faHouse;
  

  
  

  var faHeartCircleExclamation = {
    prefix: 'fasl',
    iconName: 'heart-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e4fe',
      
      'M256 141.3l-22.6-22.6L209.1 94.4C189.7 74.9 163.3 64 135.8 64C78.5 64 32 110.5 32 167.8c0 27.5 10.9 53.9 30.4 73.4l24.2 24.2L256 434.8l9.5-9.5c3.7 10.9 8.5 21.3 14.2 31.1l-1.1 1.1L256 480l-22.6-22.6L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8l1.6 1.6L256 96l22.6-22.6 1.6-1.6c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4c-9.6-4.5-19.7-8.1-30.2-10.7c2.9-9.5 4.3-19.5 4.3-29.7C480 110.5 433.5 64 376.2 64c-27.5 0-53.9 10.9-73.4 30.4l-24.2 24.2L256 141.3zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 80H416V416h32v32zm0-160v16 80 16H416V384 304 288h32z'
      
    ]
  };

  

  
  

  var faCourtSport = {
    prefix: 'fasl',
    iconName: 'court-sport',
    icon: [
      640,
      512,
      [],
      'e643',
      
      'M32 64v64H96h32v32V352v32H96 32v64H304V350.7c-45.4-7.6-80-47.1-80-94.7s34.6-87.1 80-94.7V64H32zM336 350.7V448H608V384H544 512V352 160 128h32 64V64H336v97.3c45.4 7.6 80 47.1 80 94.7s-34.6 87.1-80 94.7zM336 194V318c27.6-7.1 48-32.2 48-62s-20.4-54.9-48-62zm-32 0c-27.6 7.1-48 32.2-48 62s20.4 54.9 48 62V194zM32 160V352H96V160H32zM544 352h64V160H544V352zM0 32H32 608h32V64 448v32H608 32 0V448 64 32z'
      
    ]
  };

  

  
  

  var faOutdent = {
    prefix: 'fasl',
    iconName: 'outdent',
    icon: [
      448,
      512,
      ["dedent"],
      'f03b',
      
      'M0 48V80H16 432h16V48H432 16 0zM192 176v32h16H432h16V176H432 208 192zm16 128H192v32h16H432h16V304H432 208zM0 432v32H16 432h16V432H432 16 0zM27.3 236.3L0 256l27.3 19.7L112 336.9 144 360V320.5 191.5 152l-32 23.1L27.3 236.3zM112 214.6v82.8L54.7 256 112 214.6z'
      
    ]
  };

  
    var faDedent = faOutdent;
  

  
  

  var faFaceWorried = {
    prefix: 'fasl',
    iconName: 'face-worried',
    icon: [
      512,
      512,
      [],
      'e3a3',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM337.1 423.6C313.4 413.7 285.7 408 256 408c-29.7 0-57.3 5.7-81 15.5l-26.1 10.9 4.2-28c7.4-49.3 51-86.4 103-86.4s95.7 37.1 103 86.5l4.2 28-26.1-10.9zM256 352c-25.4 0-47.5 12.5-60.3 31.2c19-4.7 39.3-7.2 60.3-7.2c21 0 41.3 2.5 60.3 7.2C303.5 364.5 281.5 352 256 352zM152.4 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9L89.4 175.2l11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1h16v32H192zm141 .9c-4.3-.6-8.6-.9-13-.9H304V128h16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8z'
      
    ]
  };

  

  
  

  var faFaceDotted = {
    prefix: 'fasl',
    iconName: 'face-dotted',
    icon: [
      512,
      512,
      [129765],
      'e47f',
      
      'M256 0c-17.1 0-33.8 1.7-49.9 4.9L190.4 8l6.2 31.4 15.7-3.1C226.4 33.5 241 32 256 32s29.6 1.5 43.7 4.3l15.7 3.1L321.6 8 305.9 4.9C289.8 1.7 273.1 0 256 0zM398.2 43.1L385 34.2 367.2 60.8l13.3 8.9c24.4 16.4 45.5 37.4 61.8 61.8l8.9 13.3L477.8 127l-8.9-13.3c-18.7-27.9-42.7-51.9-70.6-70.6zM131.6 69.7l13.3-8.9L127 34.2l-13.3 8.9C85.8 61.8 61.8 85.8 43.1 113.8L34.2 127l26.6 17.8 8.9-13.3c16.4-24.4 37.4-45.5 61.8-61.8zM36.3 212.3l3.1-15.7L8 190.4 4.9 206.1C1.7 222.2 0 238.9 0 256s1.7 33.8 4.9 49.9L8 321.6l31.4-6.2-3.1-15.7C33.5 285.6 32 271 32 256s1.5-29.6 4.3-43.7zm470.9-6.2L504 190.4l-31.4 6.2 3.1 15.7c2.8 14.1 4.3 28.8 4.3 43.7s-1.5 29.6-4.3 43.7l-3.1 15.7 31.4 6.2 3.1-15.7c3.2-16.2 4.9-32.9 4.9-49.9s-1.7-33.8-4.9-49.9zM69.7 380.4l-8.9-13.3L34.2 385l8.9 13.3c18.7 27.9 42.7 51.9 70.6 70.6l13.3 8.9 17.8-26.6-13.3-8.9c-24.4-16.4-45.5-37.4-61.8-61.8zm399.2 17.8l8.9-13.3-26.6-17.8-8.9 13.3c-16.4 24.4-37.4 45.5-61.8 61.8l-13.3 8.9L385 477.8l13.3-8.9c27.9-18.7 51.9-42.7 70.6-70.6zM212.3 475.7l-15.7-3.1L190.4 504l15.7 3.1c16.2 3.2 32.9 4.9 49.9 4.9s33.8-1.7 49.9-4.9l15.7-3.1-6.2-31.4-15.7 3.1C285.6 478.5 271 480 256 480s-29.6-1.5-43.7-4.3zM176.4 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM184 336H168v32h16H328h16V336H328 184z'
      
    ]
  };

  

  
  

  var faIdCard = {
    prefix: 'fasl',
    iconName: 'id-card',
    icon: [
      576,
      512,
      [62147,"drivers-license"],
      'f2c2',
      
      'M32 64V96H544V64H32zM0 112V64 32H32 544h32V64v48V448v32H544 32 0V448 112zm544 16H32V448H544V128zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM113.7 416H80l32-96H272l32 96H270.3l-21.3-64H135.1l-21.3 64zM336 192h16H480h16v32H480 352 336V192zm0 64h16H480h16v32H480 352 336V256zm0 64h16H480h16v32H480 352 336V320z'
      
    ]
  };

  
    var faDriversLicense = faIdCard;
  

  
  

  var faBookSkull = {
    prefix: 'fasl',
    iconName: 'book-skull',
    icon: [
      448,
      512,
      ["book-dead"],
      'f6b7',
      
      'M0 64C0 28.7 28.7 0 64 0H432h16V16 400v16H432 416v64h16 16v32H432 64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H416V32H64C46.3 32 32 46.3 32 64l0 328.6zM240 96c-38.9 0-64 24.6-64 48c0 14.1 8.4 28 24.2 37.5l7.8 4.7v9.1V208h64V195.2v-9.1l7.8-4.7C295.6 172 304 158.1 304 144c0-23.4-25.1-48-64-48zm-96 48c0-47.3 46.5-80 96-80s96 32.7 96 80c0 24.6-13 45.6-32 59.7V224v16H288 192 176V224 203.7c-19-14.1-32-35.1-32-59.7zm56 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM135.4 235.1l14.8 6.2L240 278.7l89.8-37.4 14.8-6.2 12.3 29.5-14.8 6.2L281.6 296l60.6 25.2 14.8 6.2-12.3 29.5-14.8-6.2L240 313.3l-89.8 37.4-14.8 6.2-12.3-29.5 14.8-6.2L198.4 296l-60.6-25.2-14.8-6.2 12.3-29.5z'
      
    ]
  };

  
    var faBookDead = faBookSkull;
  

  
  

  var faAlignCenter = {
    prefix: 'fasl',
    iconName: 'align-center',
    icon: [
      448,
      512,
      [],
      'f037',
      
      'M112 48H96V80h16H336h16V48H336 112zM16 176H0v32H16 432h16V176H432 16zM96 304v32h16H336h16V304H336 112 96zM16 432H0v32H16 432h16V432H432 16z'
      
    ]
  };

  

  
  

  var faFaceMeh = {
    prefix: 'fasl',
    iconName: 'face-meh',
    icon: [
      512,
      512,
      [128528,"meh"],
      'f11a',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM176 336H160v32h16H336h16V336H336 176z'
      
    ]
  };

  
    var faMeh = faFaceMeh;
  

  
  

  var faCodePullRequestClosed = {
    prefix: 'fasl',
    iconName: 'code-pull-request-closed',
    icon: [
      512,
      512,
      [],
      'e3f9',
      
      'M64 32v96h96V32H64zM32 0H64h96 32V32v96 32H160 128V352h32 32v32 96 32H160 64 32V480 384 352H64 96V160H64 32V128 32 0zM355.3 12.7L400 57.4l44.7-44.7L456 1.4 478.6 24 467.3 35.3 422.6 80l44.7 44.7L478.6 136 456 158.6l-11.3-11.3L400 102.6l-44.7 44.7L344 158.6 321.4 136l11.3-11.3L377.4 80 332.7 35.3 321.4 24 344 1.4l11.3 11.3zM416 192v16V352h32 32v32 96 32H448 352 320V480 384 352h32 32V208 192h32zM384 384H352v96h96V384H416v0H384v0zm-224 0H64v96h96V384z'
      
    ]
  };

  

  
  

  var faMobile = {
    prefix: 'fasl',
    iconName: 'mobile',
    icon: [
      384,
      512,
      [128241,"mobile-android","mobile-phone"],
      'f3ce',
      
      'M64 32V480H320V32H64zM32 0H64 320h32V32 480v32H320 64 32V480 32 0zM160 400h64 16v32H224 160 144V400h16z'
      
    ]
  };

  
    var faMobileAndroid = faMobile;
  
    var faMobilePhone = faMobile;
  

  
  

  var faUserPilot = {
    prefix: 'fasl',
    iconName: 'user-pilot',
    icon: [
      448,
      512,
      [],
      'e2c0',
      
      'M400 80L368 99.2V144c-16 10.7-67.2 32-144 32s-128-21.3-144-32V99.2L48 80V48L224 0 400 48V80zM336 99.2V81.1l15.5-9.3 4.4-2.6L224 33.2 92.1 69.1l4.4 2.6L112 81.1V99.2v25.3c20.2 8.4 58.6 19.5 112 19.5s91.8-11.1 112-19.5V99.2zM224 456l-19.2-14.4L128 384H71.8L43 480H405l-28.8-96H320l-76.8 57.6L224 456zm85.3-104H400l38.4 128 9.6 32H414.6 33.4 0l9.6-32L48 352h90.7L224 416l85.3-64zM304 416h16 32 16v32H352 320 304V416zM96.2 184.1c10.4 4 21 7.6 31.8 10.7c1.5 51.7 43.9 93.2 96 93.2s94.5-41.5 96-93.2c10.8-3.1 21.4-6.6 31.8-10.7c.2 2.6 .2 5.2 .2 7.9c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-2.7 .1-5.3 .2-7.9zM183.2 65.7L224 86.1l40.8-20.4 14.3-7.2 14.3 28.6-14.3 7.2-48 24-7.2 3.6-7.2-3.6-48-24-14.3-7.2 14.3-28.6 14.3 7.2z'
      
    ]
  };

  

  
  

  var faForward = {
    prefix: 'fasl',
    iconName: 'forward',
    icon: [
      512,
      512,
      [9193],
      'f04e',
      
      'M483.2 275.2L512 256l-28.8-19.2L256 85.3 224 64v38.5 95.9L32 83.2 0 64v37.3V410.7 448l32-19.2L224 313.6v95.9V448l32-21.3L483.2 275.2zM224 276.3L32 391.5v-271L224 235.7v40.6zm32 111.9V123.8L454.3 256 256 388.2z'
      
    ]
  };

  

  
  

  var faLoader = {
    prefix: 'fasl',
    iconName: 'loader',
    icon: [
      512,
      512,
      [],
      'e1d4',
      
      'M272 16v96 16H240V112 16 0h32V16zm0 384v96 16H240V496 400 384h32v16zM0 240H16h96 16v32H112 16 0V240zm400 0h96 16v32H496 400 384V240h16zM448.3 86.3L437 97.6l-67.9 67.9-11.3 11.3-22.6-22.6 11.3-11.3L414.4 75l11.3-11.3 22.6 22.6zM165.5 369.1L97.6 437 86.3 448.3 63.7 425.7 75 414.4l67.9-67.9 11.3-11.3 22.6 22.6-11.3 11.3zM86.3 63.7L97.6 75l67.9 67.9 11.3 11.3-22.6 22.6-11.3-11.3L75 97.6 63.7 86.3 86.3 63.7zM369.1 346.5L437 414.4l11.3 11.3-22.6 22.6L414.4 437l-67.9-67.9-11.3-11.3 22.6-22.6 11.3 11.3z'
      
    ]
  };

  

  
  

  var faGlass = {
    prefix: 'fasl',
    iconName: 'glass',
    icon: [
      384,
      512,
      [129371],
      'f804',
      
      'M42.1 128H341.9L314.4 480H69.6L42.1 128zM39.6 96l-5-64H349.4l-5 64H39.6zM40 512H344L381.5 32 384 0H351.9 32.1 0L2.5 32 40 512z'
      
    ]
  };

  

  
  

  var faFileCircleCheck = {
    prefix: 'fasl',
    iconName: 'file-circle-check',
    icon: [
      576,
      512,
      [],
      'e5a0',
      
      'M352 192v19.2c10.1-5.2 20.8-9.4 32-12.6V152L232 0H32 0V32 480v32H32 330.8c-12.9-9.1-24.5-19.9-34.6-32H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm78.6-176L488 313.4l-11.3 11.3L416 385.4l-28.7-28.7L376 345.4 353.4 368l11.3 11.3 40 40L416 430.6l11.3-11.3 72-72L510.6 336z'
      
    ]
  };

  

  
  

  var faRotateExclamation = {
    prefix: 'fasl',
    iconName: 'rotate-exclamation',
    icon: [
      512,
      512,
      [],
      'e23c',
      
      'M403.5 133.1C368.3 90.9 315.3 64 256 64C165.2 64 89.1 127 69.1 211.7L38 204.3C61.3 105.5 150.1 32 256 32c69.2 0 131 31.4 172.1 80.6L464 154.9V96 80h32V96v96 16H480 384 368V176h16 55.9l-36.3-42.8 0 0-.1-.1zM272 144V272v16H240V272 144 128h32v16zm8 176v48H232V320h48zM16 432V416 320 304H32h96 16v32H128 72.1l36.3 42.8 0 0 .1 .1C143.7 421.1 196.7 448 256 448c90.8 0 166.9-63 186.9-147.7l31.1 7.4C450.7 406.5 361.9 480 256 480c-69.2 0-131-31.4-172.1-80.6L48 357.1V416v16H16z'
      
    ]
  };

  

  
  

  var faScribble = {
    prefix: 'fasl',
    iconName: 'scribble',
    icon: [
      512,
      512,
      [],
      'e23f',
      
      'M196.6 19.5C210.2 7 228 0 246.5 0h.9C287.5 0 320 32.5 320 72.6c0 19.2-7.6 37.7-21.3 51.3L75.9 346.7C68.3 354.4 64 364.7 64 375.4c0 22.4 18.2 40.6 40.6 40.6c10.8 0 21.1-4.3 28.7-11.9L388.1 149.3c13.6-13.6 32.1-21.3 51.3-21.3c40.1 0 72.6 32.5 72.6 72.6c0 19.2-7.6 37.7-21.3 51.3L370.5 372.1c-11.8 11.8-18.5 28-18.5 44.8c0 34.8 28.2 63.1 63 63.1c8.7 0 17.3-2 25.1-5.9l48.8-24.4 14.3 28.6-48.8 24.4c-12.2 6.1-25.8 9.3-39.4 9.3c-52.5 0-95-42.7-95-95.1c0-25.2 10-49.5 27.9-67.4L468.1 229.3c7.6-7.6 11.9-17.9 11.9-28.7c0-22.4-18.2-40.6-40.6-40.6c-10.8 0-21.1 4.3-28.7 11.9L155.9 426.7c-13.6 13.6-32.1 21.3-51.3 21.3C64.5 448 32 415.5 32 375.4c0-19.2 7.6-37.7 21.3-51.3L276.1 101.3c7.6-7.6 11.9-17.9 11.9-28.7C288 50.2 269.8 32 247.4 32h-.9c-10.4 0-20.5 3.9-28.2 11L26.9 219.8 5.1 196.2 196.6 19.5z'
      
    ]
  };

  

  
  

  var faCommentsQuestion = {
    prefix: 'fasl',
    iconName: 'comments-question',
    icon: [
      640,
      512,
      [],
      'e14e',
      
      'M78.2 274.7L70.9 293 52.4 339.1l99.9-23 6.7-1.6 6.8 1.4c13.5 2.7 27.6 4.2 42.2 4.2c102.4 0 176-69.3 176-144s-73.6-144-176-144S32 101.3 32 176c0 30.8 11.9 59.8 33.2 84l13 14.8zM38 375.2L0 384l14.5-36.2 26.7-66.7C15.3 251.8 0 215.4 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176s-93.1 176-208 176c-16.7 0-32.9-1.7-48.5-4.8L38 375.2zm207.2 6.2c11.5-1.6 22.8-3.9 33.8-6.8C308.4 417.3 363.8 448 432 448c14.6 0 28.7-1.5 42.2-4.2l6.8-1.4 6.7 1.6 99.9 23L569.1 421l-7.3-18.3 13-14.8c21.3-24.1 33.2-53.2 33.2-84c0-70.9-66.3-137-160.6-143.5c-.9-11.1-2.8-21.9-5.6-32.3C552.1 132.5 640 209.6 640 304c0 39.4-15.3 75.8-41.2 105.1l26.7 66.7L640 512l-38-8.8-121.5-28c-15.6 3.1-31.8 4.8-48.5 4.8c-82 0-153-40.2-186.8-98.5zM141 125c0-24.5 19.8-44.3 44.3-44.3H225c27.7 0 50 22.7 50 50.2c0 18.7-10.5 36.1-27.3 44.7L224 187.6v15.7H192v-16-9.5V168l8.7-4.5L233.2 147c6-3 9.8-9.3 9.8-16.1c0-10.1-8.2-18.2-18-18.2H185.3c-6.8 0-12.3 5.5-12.3 12.3v5.7H141V125zm50 96.3h34v34H191v-34z'
      
    ]
  };

  

  
  

  var faCommentCaptions = {
    prefix: 'fasl',
    iconName: 'comment-captions',
    icon: [
      512,
      512,
      [],
      'e146',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM80 224H64v32H80 304h16V224H304 80zm288 0H352v32h16 64 16V224H432 368zM112 288H96v32h16 64 16V288H176 112zm128 0H224v32h16H400h16V288H400 240z'
      
    ]
  };

  

  
  

  var faEyeDropper = {
    prefix: 'fasl',
    iconName: 'eye-dropper',
    icon: [
      512,
      512,
      ["eye-dropper-empty","eyedropper"],
      'f1fb',
      
      'M198.1 172.7l22.6 22.6 95.9 95.9 22.6 22.6 6.1 6.1 11.3 11.3L368 342.6 390.6 320l-6.1-6.1-5.2-5.2L368 297.4l-6.1-6.1 22.6-22.6 98.3-98.3c39-39 39-102.2 0-141.1s-102.2-39-141.1 0l-98.3 98.3-22.6 22.6-6.1-6.1-11.3-11.3-5.2-5.2-6.1-6.1L169.4 144l11.3 11.3L192 166.6l6.1 6.1zm262-25L339.3 268.6l-95.9-95.9L364.2 51.9c26.5-26.5 69.4-26.5 95.9 0s26.5 69.4 0 95.9zM32 344v80L0 472l40 40 48-32h80L314.1 333.9l-22.6-22.6L154.7 448H88 78.3l-8.1 5.4L44.1 470.8l-2.9-2.9 17.4-26.2 5.4-8.1V424 357.3L200.7 220.6l-22.6-22.6L32 344z'
      
    ]
  };

  
    var faEyeDropperEmpty = faEyeDropper;
  
    var faEyedropper = faEyeDropper;
  

  
  

  var faCloudBinary = {
    prefix: 'fasl',
    iconName: 'cloud-binary',
    icon: [
      640,
      512,
      [],
      'e601',
      
      'M544 241.1V232c0-57.4-46.6-104-104-104c-13.4 0-26.2 2.5-37.9 7.1l-24.3 9.5-14.2-22C340.8 87.3 301.1 64 256 64c-70.7 0-128 57.3-128 128v8.2 22.6l-21.3 7.5C63.1 245.8 32 287.3 32 336V448H144 512h96V352c0-35.5-19.2-66.5-48-83.2l-16-9.2V241.1zM0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c56.4 0 106 29.2 134.5 73.3c15.3-6 32-9.3 49.5-9.3c75.1 0 136 60.9 136 136v9.1c38.3 22.1 64 63.5 64 110.9v96 32H608 512 144 32 0V448 336zM176 176h16 64 16v16 64 16H256 192 176V256 192 176zm32 32v32h32V208H208zm80-32h16 16 16v16 64 16H304V256 208H288V176zm96 0h64 16v16 64 16H448 384 368V256 192 176h16zm16 64h32V208H400v32zM192 304h16 16 16v16 64 16H208V384 336H192V304zm80 0h16 64 16v16 64 16H352 288 272V384 320 304zm32 32v32h32V336H304zm96-32h16 16v16 64 16H400V384 336H384V304h16z'
      
    ]
  };

  

  
  

  var faOven = {
    prefix: 'fasl',
    iconName: 'oven',
    icon: [
      448,
      512,
      [],
      'e01d',
      
      'M32 32V160H416V32H32zm0 160V480H416V192H32zM0 0H32 416h32V32 480v32H416 32 0V480 32 0zM104 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM264 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 256V416H352V256H96zM64 224H96 352h32v32V416v32H352 96 64V416 256 224zm64 64h16H304h16v32H304 144 128V288z'
      
    ]
  };

  

  
  

  var faDeleteLeft = {
    prefix: 'fasl',
    iconName: 'delete-left',
    icon: [
      576,
      512,
      [9003,"backspace"],
      'f55a',
      
      'M576 448H544 176L0 256 176 64H544h32V96 416v32zM43.4 256L190.1 416H544V96H190.1L43.4 256zm373.2-87.2l22.6 22.6-11.3 11.3L374.6 256l53.3 53.3 11.3 11.3-22.6 22.6-11.3-11.3L352 278.6l-53.3 53.3-11.3 11.3-22.6-22.6 11.3-11.3L329.4 256l-53.3-53.3-11.3-11.3 22.6-22.6 11.3 11.3L352 233.4l53.3-53.3 11.3-11.3z'
      
    ]
  };

  
    var faBackspace = faDeleteLeft;
  

  
  

  var faFaceGrin = {
    prefix: 'fasl',
    iconName: 'face-grin',
    icon: [
      512,
      512,
      [128512,"grin"],
      'f580',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.5 23.6 54.5 38.3 89.9 38.3s67.4-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm0-32c41 0 79.9-5.3 114.9-14.9c13-3.5 25.4-7.7 37.2-12.3c-3.1 13.8-8 26.9-14.5 39c-26.2 48.9-78 82.2-137.7 82.2s-111.5-33.3-137.7-82.2c-6.5-12.1-11.4-25.2-14.5-39c11.8 4.6 24.3 8.8 37.2 12.3c35.1 9.6 74 14.9 114.9 14.9zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faGrin = faFaceGrin;
  

  
  

  var faCloudSnow = {
    prefix: 'fasl',
    iconName: 'cloud-snow',
    icon: [
      512,
      512,
      [127784],
      'f742',
      
      'M384 128v32h32c35.3 0 64 28.7 64 64v64H416 96 32V224c0-27.8 17.8-51.6 42.7-60.4L96 156.1V133.5 112c0-44.2 35.8-80 80-80c27 0 50.9 13.4 65.5 34l17.8 25.2 25.9-16.9c10-6.5 22-10.3 34.9-10.3c35.3 0 64 28.7 64 64zM0 320H32 96 416h64 32V288 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v64 32zm80 32H48v16 32l-32 0H0l0 32H16l32 0v32 16H80V464 432h32 16l0-32H112 80V368 352zm384 0H432v16 32l-32 0H384l0 32h16l32 0v32 16h32V464 432h32 16V400H496 464V368 352zM272 400V384H240v16 32l-32 0H192l0 32h16l32 0v32 16h32V496 464h32 16V432H304 272V400z'
      
    ]
  };

  

  
  

  var faShelves = {
    prefix: 'fasl',
    iconName: 'shelves',
    icon: [
      640,
      512,
      ["inventory"],
      'f480',
      
      'M32 0V16 160H608V16 0h32V16 160v16 16V416v16 16 48 16H608V496 448H32v48 16H0V496 448 432 416 192 176 160 16 0H32zm0 416H608V192H32V416zM448 32H384V96h64V32zM384 0h64 32V32 96v32H448 384 352V96 32 0h32zM128 288v64h64V288H128zM96 256h32 64 32v32 64 32H192 128 96V352 288 256zm192 32v64h64V288H288zm-32-32h32 64 32v32 64 32H352 288 256V352 288 256z'
      
    ]
  };

  
    var faInventory = faShelves;
  

  
  

  var faAnglesUpDown = {
    prefix: 'fasl',
    iconName: 'angles-up-down',
    icon: [
      448,
      512,
      [],
      'e60d',
      
      'M234 19.5l160 128 12.5 10-20 25-12.5-10L224 52.5 74 172.5l-12.5 10-20-25 12.5-10 160-128 10-8 10 8zm0 473l-10 8-10-8L54 364.5l-12.5-10 20-25 12.5 10 150 120 150-120 12.5-10 20 25-12.5 10-160 128z'
      
    ]
  };

  

  
  

  var faDownload = {
    prefix: 'fasl',
    iconName: 'download',
    icon: [
      512,
      512,
      [],
      'f019',
      
      'M272 16V0H240V16 329.4L139.3 228.7 128 217.4 105.4 240l11.3 11.3 128 128L256 390.6l11.3-11.3 128-128L406.6 240 384 217.4l-11.3 11.3L272 329.4V16zM140.1 320H32 0v32V480v32H32 480h32V480 352 320H480 371.9l-32 32H480V480H32V352H172.1l-32-32zM432 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faArrowsDownToLine = {
    prefix: 'fasl',
    iconName: 'arrows-down-to-line',
    icon: [
      576,
      512,
      [],
      'e4b8',
      
      'M128 406.6l11.3-11.3 104-104L254.6 280 232 257.4l-11.3 11.3L144 345.4 144 48l0-16H112l0 16 0 297.4L35.3 268.7 24 257.4 1.4 280l11.3 11.3 104 104L128 406.6zm320 0l11.3-11.3 104-104L574.6 280 552 257.4l-11.3 11.3L464 345.4V48 32H432V48 345.4l-76.7-76.7L344 257.4 321.4 280l11.3 11.3 104 104L448 406.6zM16 448H0v32H16 560h16V448H560 16z'
      
    ]
  };

  

  
  

  var faTugrikSign = {
    prefix: 'fasl',
    iconName: 'tugrik-sign',
    icon: [
      384,
      512,
      [],
      'e2ba',
      
      'M16 32H0V64H16 176V211.5l-115.9 29-15.5 3.9 7.8 31 15.5-3.9 108.1-27v63l-115.9 29-15.5 3.9 7.8 31 15.5-3.9 108.1-27V456v16h32V456 332.5l115.9-29 15.5-3.9-7.8-31-15.5 3.9L208 299.5v-63l115.9-29 15.5-3.9-7.8-31-15.5 3.9L208 203.5V64H368h16V32H368 192 16z'
      
    ]
  };

  

  
  

  var faBatterySlash = {
    prefix: 'fasl',
    iconName: 'battery-slash',
    icon: [
      640,
      512,
      [],
      'f377',
      
      'M32.5 10L19.9 .1 .1 25.3l12.6 9.9L607.8 502.2l12.6 9.9 19.8-25.2-12.6-9.9L32.5 10zM378.8 384H64V135.4L32 110.2V128 384v32H64 419.4l-40.5-32zM512 96H220.6l40.5 32H512V326l32 25.3V128 96H512zm64 96v32 64 32h32V288 224 192H576z'
      
    ]
  };

  

  
  

  var faClockSixThirty = {
    prefix: 'fasl',
    iconName: 'clock-six-thirty',
    icon: [
      512,
      512,
      [],
      'e353',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400V256 240H240v16V400v16h32V400z'
      
    ]
  };

  

  
  

  var faShip = {
    prefix: 'fasl',
    iconName: 'ship',
    icon: [
      576,
      512,
      [128674],
      'f21a',
      
      'M208 0H192V16 64H112 96V80 240h3.1L26.8 264.9l-23.3 8 16.8 18 112 120 23.4-21.8-95.2-102L272 214.4V384v16h32V384 214.4l211.5 72.7-95.2 102 23.4 21.8 112-120 16.8-18-23.3-8L476.9 240H480V80 64H464 384V16 0H368 208zM352 64H224V32H352V64zM192 96h16H368h16 64V230.1L293.2 176.9l-5.2-1.8-5.2 1.8L128 230.1V96h64zM133.8 458.8c-14.6-10-26-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C41.7 470.1 20.9 480 0 480v32c30.3 0 57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C518.5 497.9 545.7 512 576 512V480c-20.9 0-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C425.6 470.1 404.9 480 384 480s-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C233.6 470.1 212.9 480 192 480s-41.7-9.9-58.2-21.2z'
      
    ]
  };

  

  
  

  var faGameConsoleHandheld = {
    prefix: 'fasl',
    iconName: 'game-console-handheld',
    icon: [
      384,
      512,
      [],
      'f8bb',
      
      'M32 32V480H352V32H32zM0 0H32 352h32V32 480v32H352 32 0V480 32 0zM96 96V224H288V96H96zM64 64H96 288h32V96 224v32H288 96 64V224 96 64zM208 360a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 288h32v32h32v32H128v32H96V352H64V320H96V288z'
      
    ]
  };

  

  
  

  var faPersonSledding = {
    prefix: 'fasl',
    iconName: 'person-sledding',
    icon: [
      512,
      512,
      ["sledding"],
      'f7cb',
      
      'M392 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm24.8 443.4L8.8 270.3l14.4-28.6 401.7 202L474.4 425l15-5.6 11.3 29.9-15 5.6-56 21.1-6.6 2.5-6.3-3.2zM160 144H320l11.3 27.3L230.6 272 352 272h16v16 80 16H336V368 304H230.6c-28.5 0-42.8-34.5-22.6-54.6L281.4 176H160 144V144h16z'
      
    ]
  };

  
    var faSledding = faPersonSledding;
  

  
  

  var faBuildingCircleXmark = {
    prefix: 'fasl',
    iconName: 'building-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e4d4',
      
      'M32 32H352V266.8c9.1-12.9 19.9-24.5 32-34.6V32 0H352 32 0V32 480v32H32h96 32 64 32 96 32v-8.2c-12.1-10-22.9-21.7-32-34.6V480H256V400 368H224 160 128v32 80H32V32zM160 480V400h64v80H160zM64 96v16 64 16H80h64 16V176 112 96H144 80 64zm32 32h32v32H96V128zM240 96H224v16 64 16h16 64 16V176 112 96H304 240zm16 64V128h32v32H256zM64 224v16 64 16H80h64 16V304 240 224H144 80 64zm32 32h32v32H96V256zm144-32H224v16 64 16h16 64 16V304 240 224H304 240zm16 64V256h32v32H256zm128 80a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7L566.6 320 544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7z'
      
    ]
  };

  

  
  

  var faSprinkler = {
    prefix: 'fasl',
    iconName: 'sprinkler',
    icon: [
      512,
      512,
      [],
      'e035',
      
      'M512 16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM16 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm128 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm224 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm144-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM80 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm432 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM16 288a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM80 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM16 32A16 16 0 1 0 16 0a16 16 0 1 0 0 32zM224 369.9l-10.4-9.5-79-72.4H240h32H377.4l-79 72.4L288 369.9V384v96H224V384 369.9zM240 256H128 96v32 8l96 88v96 32h32 64 32V480 384l96-88v-8V256H384 272V80 64H240V80 256z'
      
    ]
  };

  

  
  

  var faFaceLying = {
    prefix: 'fasl',
    iconName: 'face-lying',
    icon: [
      512,
      512,
      [],
      'e37e',
      
      'M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c79.8 0 149.8-41.7 189.5-104.5l27.1 17.1C427.3 464.3 347.2 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C373.8 0 472.9 79.5 502.8 187.7l-30.8 8.5C445.8 101.5 359 32 256 32zM152.4 176a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm160 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM188.8 393.6l-9.6 12.8-25.6-19.2 9.6-12.8C180.7 351.1 208.6 336 240 336c13.6 0 26.6 2.8 38.4 8l14.7 6.4-12.8 29.3-14.7-6.4c-7.8-3.4-16.5-5.3-25.6-5.3c-20.9 0-39.5 10-51.2 25.6zM288 224H448c35.3 0 64 28.7 64 64s-28.7 64-64 64H352 336V320h16 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272V224h16z'
      
    ]
  };

  

  
  

  var faCloudRain = {
    prefix: 'fasl',
    iconName: 'cloud-rain',
    icon: [
      512,
      512,
      [9926,127783],
      'f73d',
      
      'M384 128v32h32c35.3 0 64 28.7 64 64v64H416 96 32V224c0-27.8 17.8-51.6 42.7-60.4L96 156.1V133.5 112c0-44.2 35.8-80 80-80c27 0 50.9 13.4 65.5 34l17.8 25.2 25.9-16.9c10-6.5 22-10.3 34.9-10.3c35.3 0 64 28.7 64 64zM0 320H32 96 416h64 32V288 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v64 32zM82.6 452.6L96 430.2l13.4 22.4c1.7 2.8 2.6 6 2.6 9.3V464c0 8.8-7.2 16-16 16s-16-7.2-16-16v-2.1c0-3.3 .9-6.5 2.6-9.3zM55.1 436.1c-4.7 7.8-7.1 16.7-7.1 25.8V464c0 26.5 21.5 48 48 48s48-21.5 48-48v-2.1c0-9.1-2.5-18-7.1-25.8l-22.2-37L96 368 77.3 399.1l-22.2 37zm187.4 16.5L256 430.2l13.4 22.4c1.7 2.8 2.6 6 2.6 9.3V464c0 8.8-7.2 16-16 16s-16-7.2-16-16v-2.1c0-3.3 .9-6.5 2.6-9.3zm-27.4-16.5c-4.7 7.8-7.1 16.7-7.1 25.8V464c0 26.5 21.5 48 48 48s48-21.5 48-48v-2.1c0-9.1-2.5-18-7.1-25.8l-22.2-37L256 368l-18.7 31.1-22.2 37zM416 430.2l13.4 22.4c1.7 2.8 2.6 6 2.6 9.3V464c0 8.8-7.2 16-16 16s-16-7.2-16-16v-2.1c0-3.3 .9-6.5 2.6-9.3L416 430.2zm-18.7-31.1l-22.2 37c-4.7 7.8-7.1 16.7-7.1 25.8V464c0 26.5 21.5 48 48 48s48-21.5 48-48v-2.1c0-9.1-2.5-18-7.1-25.8l-22.2-37L416 368l-18.7 31.1z'
      
    ]
  };

  

  
  

  var faShovelSnow = {
    prefix: 'fasl',
    iconName: 'shovel-snow',
    icon: [
      512,
      512,
      [],
      'f7c3',
      
      'M400 0L377.4 22.6 359.2 40.8c-14.9 14.9-23.2 35-23.2 56c0 16.1 4.8 31 13 43.5l-88.3 88.3L192 160 25.9 284.6 0 304l22.9 22.9L185.1 489.1 208 512l19.4-25.9L352 320l-68.7-68.7L371.7 163c12.5 8.2 27.5 13 43.5 13c21 0 41.1-8.3 56-23.2l18.2-18.2L512 112 489.4 89.4 422.6 22.6 400 0zm0 45.3L466.7 112l-18.2 18.2c-8.9 8.9-20.9 13.8-33.4 13.8c-26.1 0-47.2-21.1-47.2-47.2c0-12.5 5-24.5 13.8-33.4L400 45.3zm-195.5 418L48.7 307.5 189 202.3 309.7 323 204.5 463.3zm-73.2-124l72-72-22.6-22.6-72 72 22.6 22.6zm64 64l72-72-22.6-22.6-72 72 22.6 22.6z'
      
    ]
  };

  

  
  

  var faCableCar = {
    prefix: 'fasl',
    iconName: 'cable-car',
    icon: [
      512,
      512,
      [57551,128673,"tram"],
      'f7da',
      
      'M288 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-72 8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM320 256v96H192V256h48 32 48zm32 0h96v96H352V256zm96 128v96H64V384H176 336 448zM64 352V256h96v96H64zM448 224H272V141L491.2 95.7l15.7-3.2-6.5-31.3-15.7 3.2-232 48-232 48L5.1 163.6l6.5 31.3 15.7-3.2 212.8-44V224H64 32v32V480v32H64 448h32V480 256 224H448z'
      
    ]
  };

  
    var faTram = faCableCar;
  

  
  

  var faGarage = {
    prefix: 'fasl',
    iconName: 'garage',
    icon: [
      640,
      512,
      [],
      'e009',
      
      'M320 6.8l5.9 2.3 304 120 10.1 4V144 496v16H608V496 154.9L320 41.2 32 154.9V496v16H0V496 144 133.1l10.1-4 304-120L320 6.8zM96 192h16H528h16v16V496v16H512V496 352H128V496v16H96V496 208 192zm32 128H512V224H128v96zm144 96h96 16v32H368 272 256V416h16z'
      
    ]
  };

  

  
  

  var faSwap = {
    prefix: 'fasl',
    iconName: 'swap',
    icon: [
      640,
      512,
      [],
      'e609',
      
      'M48 160H16V128v-8L90.2 39.6 112 16l21.8 23.6L208 120v8 32H176 128V448H304V48 32l16 0 208 0h16V48l0 304h48 32v32 8l-74.2 80.4L528 496l-21.8-23.6L432 392v-8V352h32 48V64L336 64l0 400v16H320 112 96V464 160H48zM528 384H468.2L528 448.8 587.8 384H528s0 0 0 0s0 0 0 0zM171.8 128L112 63.2 52.2 128H171.8z'
      
    ]
  };

  

  
  

  var faN = {
    prefix: 'fasl',
    iconName: 'n',
    icon: [
      384,
      512,
      [110],
      '4e',
      
      'M0 48V32H23.4l4.8 5.7L352 420.3V48 32h32V48 464v16H360.6l-4.8-5.7L32 91.7V464v16H0V464 48z'
      
    ]
  };

  

  
  

  var faPeoplePulling = {
    prefix: 'fasl',
    iconName: 'people-pulling',
    icon: [
      576,
      512,
      [],
      'e535',
      
      'M80 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM80 0a56 56 0 1 1 0 112A56 56 0 1 1 80 0zM389.2 118.6l7 1.9 88 24 8.5 2.3 2.6 8.4 30.3 98.6 43.3 28.8-17.8 26.6-48-32-4.7-3.2-1.7-5.4-15-48.7L443.3 331l47.2 40.9 3.5 3 1.3 4.5 32 107.2 4.6 15.3-30.7 9.2-4.6-15.3L466 393 365.4 305.8c-14.4-12.5-20.1-32.4-14.4-50.6l28.7-91.8-46.9 31.3-30.1 67.8-8 17.9-16-11.4L148.2 175.9l80 336.1H195.4L157.3 352H100.9l30.5 160H98.8L32.3 163l-.3-1.5V336v16H0V336 144 128H16 131.1h5.1l4.2 3 141 100.6 24-54.1 1.9-4.2 3.9-2.6 72-48 6.1-4zm25.5 40.1l-33.1 106c-1.9 6.1 0 12.7 4.8 16.9l30.9 26.8 47.1-136.1-49.7-13.6zM64.3 160L94.8 320h54.9L112.4 163.7l-.9-3.7H64.3zM480 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 400 56zM361.6 344.9l25 21.6-36.3 72.6c-.8 1.5-1.8 2.9-3 4.2l-56 56L280 510.6 257.4 488l11.3-11.3 54.2-54.2 38.8-77.6z'
      
    ]
  };

  

  
  

  var faEyeEvil = {
    prefix: 'fasl',
    iconName: 'eye-evil',
    icon: [
      640,
      512,
      [],
      'f6db',
      
      'M275.8 115.9l6.8-9.5L320 54.7l37.4 51.8 6.8 9.5 11.3 2.8c14.5 3.6 28.2 8.6 40.9 14.8l9.4 4.6 10.3-1.9 56.7-10.4-14.1 28.4-8.5 17.1 11 15.6c5.4 7.6 9.8 15.6 13.3 23.7l4.6 10.8 10.5 5.2L568.4 256l-58.8 29.4-10.5 5.2-4.6 10.8c-3.5 8.2-8 16.1-13.3 23.7l-11 15.6 8.5 17.1 14.1 28.4-56.6-10.4-10.3-1.9-9.4 4.6c-12.6 6.1-26.3 11.1-40.9 14.8l-11.3 2.8-6.8 9.5L320 457.3l-37.4-51.8-6.8-9.5-11.3-2.8c-14.5-3.6-28.2-8.6-40.9-14.8l-9.4-4.6-10.3 1.9-56.6 10.4 14.1-28.4 8.5-17.1-11-15.6c-5.4-7.6-9.8-15.6-13.3-23.7l-4.6-10.8-10.5-5.2L71.6 256l58.8-29.4 10.5-5.2 4.6-10.8c3.5-8.2 8-16.1 13.3-23.7l11-15.6-8.5-17.1-14.1-28.4 56.6 10.4 10.3 1.9 9.4-4.6c12.6-6.1 26.3-11.1 40.9-14.8l11.3-2.8zm24.5-88.6L256.7 87.7c-16.6 4.2-32.4 9.9-47.1 17L129.3 89.9 90 82.7l17.8 35.8 24.8 49.9c-6.6 9.4-12.2 19.3-16.6 29.6L35.8 238.1 0 256l35.8 17.9L116 314c4.4 10.3 10 20.2 16.6 29.6l-24.8 49.9L90 429.3l39.3-7.2 80.3-14.8c14.7 7.1 30.4 12.9 47.1 17l43.6 60.4L320 512l19.7-27.3 43.6-60.4c16.6-4.2 32.4-9.9 47.1-17l80.3 14.8 39.3 7.2-17.8-35.8-24.8-49.9c6.6-9.4 12.2-19.3 16.6-29.6l80.2-40.1L640 256l-35.8-17.9L524 198c-4.4-10.3-10-20.2-16.6-29.6l24.8-49.9L550 82.7l-39.3 7.2-80.3 14.8c-14.7-7.1-30.4-12.9-47.1-17L339.7 27.3 320 0 300.3 27.3zm-51 207.2c13.3 5.3 27.4 9.1 42 11.3C299.4 272.8 320 288 320 288s20.6-15.2 28.8-42.1c14.6-2.2 28.7-6 42-11.3c.8 4.4 1.3 8.9 1.3 13.5c0 39.8-32.2 72-72 72s-72-32.2-72-72c0-4.6 .4-9.1 1.3-13.5zm-29.4-14.7c-2.5 9-3.9 18.4-3.9 28.2c0 57.4 46.6 104 104 104s104-46.6 104-104c0-9.8-1.3-19.2-3.9-28.2c-2.7-9.6-6.8-18.7-12-27c-.5-.8-1-1.5-1.5-2.3c-25 16.1-54.7 25.5-86.7 25.5s-61.7-9.4-86.7-25.5c-.5 .8-1 1.5-1.5 2.3c-5.2 8.3-9.3 17.4-12 27z'
      
    ]
  };

  

  
  

  var faUserHair = {
    prefix: 'fasl',
    iconName: 'user-hair',
    icon: [
      448,
      512,
      [],
      'e45a',
      
      'M320 144V128c0-5.5-.5-10.8-1.3-16H272h-3.8l-3.4-1.7-20.1-10-16 21.3L224 128h-8l-88 0v16c0 53 43 96 96 96s96-43 96-96zM224 32c-41.8 0-77.4 26.7-90.5 64H208l19.2-25.6 8-10.7 11.9 6L275.8 80h31.4C290.6 51.3 259.5 32 224 32zm0-32c70.7 0 128 57.3 128 128v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V128C96 57.3 153.3 0 224 0zM44.4 480H403.6L360.9 352H87.1L44.4 480zM64 320H384l53.3 160L448 512H414.3 33.7 0l10.7-32L64 320z'
      
    ]
  };

  

  
  

  var faShuttlecock = {
    prefix: 'fasl',
    iconName: 'shuttlecock',
    icon: [
      512,
      512,
      [],
      'f45b',
      
      'M232 0h-9.9l-4.4 8.8L92.2 259.8 73.4 278.6 33.1 318.9C11.9 340.1 0 368.9 0 398.9C0 461.3 50.7 512 113.1 512c30 0 58.8-11.9 80-33.1l40.2-40.2 18.9-18.9L503.2 294.3l8.8-4.4V280 208 192H496 424V104 88H408 320V16 0H304 232zm77.1 355.6l-75.7 37.8 0 0-46.1-46.1 77.2-77.2 103-32.5-58.4 118zm81-163.6l-2.9 5.8L280.5 231.5l33.7-106.7 5.8-2.9V120h72v72h-1.9zM356.5 331.8l53.3-107.6 .6-.2H480v46.1L356.5 331.8zM288 101.5l-.2 .6L180.2 155.5 241.9 32H288v69.5zm-13.6 43l-32.5 103-77.2 77.2-46.1-46.1 0 0 37.8-75.7 118-58.4zM61.9 335.3L96 301.3 210.7 416l-34.1 34.1L61.9 335.3zm89.7 135c-11.7 6.3-24.9 9.7-38.5 9.7C68.3 480 32 443.7 32 398.9c0-13.6 3.4-26.8 9.7-38.5L151.6 470.3z'
      
    ]
  };

  

  
  

  var faCalculator = {
    prefix: 'fasl',
    iconName: 'calculator',
    icon: [
      384,
      512,
      [128425],
      'f1ec',
      
      'M352 160V480H32V160H352zm0-32H32V32H352v96zm32 0V32 0H352 32 0V32v96 16 16V480v32H32 352h32V480 160 144 128zM72 224a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72-72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72-72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM264 416a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-56-16H80 64v32H80 208h16V400H208z'
      
    ]
  };

  

  
  

  var faImages = {
    prefix: 'fasl',
    iconName: 'images',
    icon: [
      576,
      512,
      [],
      'f302',
      
      'M128 64H544V201.4l-68.7-68.7L464 121.4l-11.3 11.3L304 281.4l-84.7-84.7L208 185.4l-11.3 11.3L128 265.4V64zm448 0V32H544 128 96V64 304v48 32h32H240h0H544h32V352 240 240 64zM464 166.6l80 80V352H278.6l36.7-36.7L464 166.6zM281.4 304l-48 48H128V310.6l80-80L281.4 304zM32 112V96H0v16V464v16H16 464h16V448H464 32V112zm232 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faVenusDouble = {
    prefix: 'fasl',
    iconName: 'venus-double',
    icon: [
      640,
      512,
      [9890],
      'f226',
      
      'M192 320a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM368 176c0 91.8-70.3 167.2-160 175.3V416h64 16v32H272 208v48 16H176V496 448H112 96V416h16 64V351.3C86.3 343.2 16 267.8 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c7.3-7.8 14-16.2 20-25c23.6 17 52.6 27 84 27c79.5 0 144-64.5 144-144s-64.5-144-144-144c-31.3 0-60.3 10-84 27c-6-8.9-12.7-17.2-20-25C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 91.8-70.3 167.2-160 175.3V416h64 16v32H528 464v48 16H432V496 448H368 352V416h16 64V351.3c-32.7-3-62.9-14.9-88-33.3z'
      
    ]
  };

  

  
  

  var faRightFromLine = {
    prefix: 'fasl',
    iconName: 'right-from-line',
    icon: [
      448,
      512,
      ["arrow-alt-from-left"],
      'f347',
      
      'M240 304l32 0 0 32 0 48 17.7 0L404.9 256 289.7 128 272 128l0 48 0 32-32 0-112 0 0 96 112 0zm0 112l0-32 0-16 0-32-32 0-80 0-32 0 0-32 0-96 0-32 32 0 80 0 32 0 0-32 0-16 0-32 32 0 32 0L448 256 304 416l-32 0-32 0zM0 80L0 64l32 0 0 16 0 352 0 16L0 448l0-16L0 80z'
      
    ]
  };

  
    var faArrowAltFromLeft = faRightFromLine;
  

  
  

  var faPersonHiking = {
    prefix: 'fasl',
    iconName: 'person-hiking',
    icon: [
      384,
      512,
      ["hiking"],
      'f6ec',
      
      'M264 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 264 0a56 56 0 1 0 0 112zM144 96H111 48L8.5 241 0 272l31.7 5.3L96 288l40-160 8-32zM72.1 251.6l-31.9-5.3L72.4 128H103L72.1 251.6zM384 176V160H352v16 48H312.8L275 164.6l.2-.7-.7-.2-12.9-20.3-3.7-5.9-6.8-1.3-64-12-15.5-2.9-3.2 15.4L140.7 271.7c-3.9 19.1 4.1 38.7 20.4 49.6l95 63.3V496v16h32V496 376v-8.6l-7.1-4.7-43.7-29.1 27.9-124.9 25.4 39.9 4.7 7.4H304h48V496v16h32V496 176zM75 512h33.2l43.6-158.5-26.4-17.6c-.6-.4-1.1-.8-1.6-1.1L75 512zM240.4 172.5l-31.8 142-29.8-19.9c-5.4-3.6-8.1-10.1-6.8-16.5l24.5-119.5 41.7 7.8 2.6 4.1-.4 2z'
      
    ]
  };

  
    var faHiking = faPersonHiking;
  

  
  

  var faClosedCaptioning = {
    prefix: 'fasl',
    iconName: 'closed-captioning',
    icon: [
      576,
      512,
      [],
      'f20a',
      
      'M544 64V448H32V64H544zM32 32H0V64 448v32H32 544h32V448 64 32H544 32zM200 192c21.9 0 41.2 11 52.8 27.8l26.4-18.1C261.8 176.5 232.9 160 200 160c-53 0-96 43-96 96s43 96 96 96c32.9 0 61.8-16.5 79.1-41.6l-26.4-18.1C241.2 309 221.9 320 200 320c-35.3 0-64-28.7-64-64s28.7-64 64-64zm128 64c0-35.3 28.7-64 64-64c21.9 0 41.2 11 52.8 27.8l26.4-18.1C453.8 176.5 424.9 160 392 160c-53 0-96 43-96 96s43 96 96 96c32.9 0 61.8-16.5 79.1-41.6l-26.4-18.1C433.2 309 413.9 320 392 320c-35.3 0-64-28.7-64-64z'
      
    ]
  };

  

  
  

  var faBadminton = {
    prefix: 'fasl',
    iconName: 'badminton',
    icon: [
      576,
      512,
      [],
      'e33a',
      
      'M349 32c35.5 0 69 12.2 93.9 37.1S480 127.5 480 163c0 45.1-19.6 93.4-57.6 131.4c-68.1 68.1-168.9 76.9-225.3 20.5C172.2 290 160 256.5 160 221c0-45.1 19.6-93.4 57.6-131.4S303.9 32 349 32zm0-32c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 37.7 11.4 74.7 35.7 104.7l-31 31-6.1-6.1L104 328 81.4 350.6 22.6 409.4 0 432l22.6 22.6 34.7 34.7L80 512l22.6-22.6 58.7-58.7L184 408l-22.6-22.6-6.1-6.1 31-31c73.5 60.1 186.4 41.1 258.7-31.2c43.6-43.6 67-99.8 66.9-154c0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM104 373.3L138.7 408 80 466.7 45.3 432 104 373.3zM458.9 464l-6.5 23L448 502.4l30.8 8.8 4.4-15.4 9-31.8H458.9zm37.1 0v32 16h32V496 464H496zm35.8 0l9 31.8 4.4 15.4 30.8-8.8L571.7 487l-6.5-23H531.8zM496 400c0-8.8 7.2-16 16-16s16 7.2 16 16v16H496V400zm64 0c0-26.5-21.5-48-48-48s-48 21.5-48 48v16 32h32 32 32V416 400z'
      
    ]
  };

  

  
  

  var faHouseMedicalCircleExclamation = {
    prefix: 'fasl',
    iconName: 'house-medical-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e512',
      
      'M298.6 12L288 2.7 277.4 12 5.4 252l21.2 24L64 243V496v16H80 394.8c-12.9-9.1-24.5-19.9-34.6-32H96V214.7L288 45.3 458.7 196c12-2.6 24.5-4 37.3-4c2.3 0 4.5 0 6.7 .1L298.6 12zM336 240V192 176H320 256 240v16 48H192 176v16 64 16h16 48v48 16h16 64 2.9c-1.9-10.4-2.9-21.1-2.9-32c0-22.6 4.3-44.2 12-64H320 304v16 48H272V320 304H256 208V272h48 16V256 208h32v48 16h16 28.5c7.6-11.7 16.6-22.4 26.7-32H336zm48 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 448V416H480v32h32zm0-160H480v16 80 16h32V384 304 288z'
      
    ]
  };

  

  
  

  var faGearComplexCode = {
    prefix: 'fasl',
    iconName: 'gear-complex-code',
    icon: [
      512,
      512,
      [],
      'e5eb',
      
      'M208 0H194.9l-2.6 12.9-9.7 48.5c-4.2 1.6-8.3 3.3-12.4 5.1L129.1 39l-10.9-7.3L108.9 41 41 108.9l-9.3 9.3L39 129.1l27.4 41.1c-1.8 4.1-3.6 8.2-5.1 12.4l-48.5 9.7L0 194.9V208v96 13.1l12.9 2.6 48.5 9.7c1.6 4.2 3.3 8.3 5.1 12.4L39 382.9l-7.3 10.9 9.3 9.3L108.9 471l9.3 9.3 10.9-7.3 41.1-27.4c4.1 1.8 8.2 3.6 12.4 5.1l9.7 48.5 2.6 12.9H208h96 13.1l2.6-12.9 9.7-48.5c4.2-1.6 8.3-3.3 12.4-5.1L382.9 473l10.9 7.3 9.3-9.3L471 403.1l9.3-9.3L473 382.9l-27.4-41.1c1.8-4.1 3.6-8.2 5.1-12.4l48.5-9.7 12.9-2.6V304 208 194.9l-12.9-2.6-48.5-9.7c-1.6-4.2-3.3-8.3-5.1-12.4L473 129.1l7.3-10.9-9.3-9.3L403.1 41l-9.3-9.3L382.9 39 341.8 66.5c-4.1-1.8-8.2-3.6-12.4-5.1l-9.7-48.5L317.1 0H304 208zm4.2 76.5L221.1 32h69.8l8.9 44.5 1.8 9.2 8.9 2.9c8.7 2.8 17.2 6.4 25.3 10.5l8.3 4.3 7.8-5.2 37.8-25.2 49.3 49.3-25.2 37.8-5.2 7.8 4.3 8.3c4.1 8.1 7.6 16.5 10.5 25.3l2.9 8.9 9.2 1.8 44.5 8.9v69.8l-44.5 8.9-9.2 1.8-2.9 8.9c-2.8 8.7-6.4 17.2-10.5 25.3l-4.3 8.3 5.2 7.8 25.2 37.8-49.3 49.3-37.8-25.2-7.8-5.2-8.3 4.3c-8.1 4.1-16.5 7.6-25.3 10.5l-8.9 2.9-1.8 9.2L290.9 480H221.1l-8.9-44.5-1.8-9.2-8.9-2.9c-8.7-2.8-17.2-6.4-25.3-10.5l-8.3-4.3-7.8 5.2-37.8 25.2L72.9 389.7l25.2-37.8 5.2-7.8-4.3-8.3c-4.1-8.1-7.6-16.5-10.5-25.3l-2.9-8.9-9.2-1.8L32 290.9V221.1l44.5-8.9 9.2-1.8 2.9-8.9c2.8-8.7 6.4-17.2 10.5-25.3l4.3-8.3-5.2-7.8L72.9 122.3l49.3-49.3 37.8 25.2 7.8 5.2 8.3-4.3c8.1-4.1 16.5-7.6 25.3-10.5l8.9-2.9 1.8-9.2zm75.6 86.1l2.6-15.8-31.6-5.3-2.6 15.8-32 192-2.6 15.8 31.6 5.3 2.6-15.8 32-192zM187.3 227.3L198.6 216 176 193.4l-11.3 11.3-40 40L113.4 256l11.3 11.3 40 40L176 318.6 198.6 296l-11.3-11.3L158.6 256l28.7-28.7zm160-22.6L336 193.4 313.4 216l11.3 11.3L353.4 256l-28.7 28.7L313.4 296 336 318.6l11.3-11.3 40-40L398.6 256l-11.3-11.3-40-40z'
      
    ]
  };

  

  
  

  var faCirclePhoneHangup = {
    prefix: 'fasl',
    iconName: 'circle-phone-hangup',
    icon: [
      512,
      512,
      ["phone-circle-down"],
      'e11d',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352c-58 0-116.1 21.6-160.5 64.9L84.8 235.3l-9.4 9.2 7.2 11 37.3 57.2 6.4 9.8 11.3-3.1 74.7-20.8 13.9-3.9-2.4-14.2L220.6 262c23.3-4.9 47.4-4.9 70.7 0l-3.1 18.6-2.4 14.2 13.9 3.9 74.7 20.8 11.3 3.1 6.4-9.8 37.3-57.2 7.2-11-9.4-9.2-10.7-10.4 0 0C372.1 181.6 314 160 256 160zM117.8 247.8C155.9 210.6 205.9 192 256 192s100.1 18.6 138.2 55.8l0 0 1.3 1.2-23.7 36.4-49.5-13.8 3.2-18.8 2.4-13.9-13.5-4.1c-37.9-11.4-78.5-11.4-116.4 0l-13.5 4.1 2.4 13.9 3.2 18.8-49.5 13.8L116.6 249l1.3-1.2z'
      
    ]
  };

  
    var faPhoneCircleDown = faCirclePhoneHangup;
  

  
  

  var faCompressWide = {
    prefix: 'fasl',
    iconName: 'compress-wide',
    icon: [
      512,
      512,
      [],
      'f326',
      
      'M128 80V64h32V80 208v16H144 16 0V192H16 128V80zm16 208h16v16V432v16H128V432 320H16 0V288H16 144zM352 80V64h32V80 192H496h16v32H496 368 352V208 80zM496 288h16v32H496 384V432v16H352V432 304 288h16H496z'
      
    ]
  };

  

  
  

  var faFaceSpiralEyes = {
    prefix: 'fasl',
    iconName: 'face-spiral-eyes',
    icon: [
      512,
      512,
      [],
      'e485',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM295.1 413.3L256 387.2l-39.1 26.1-8.9 5.9-8.9-5.9-40.3-26.8-23.7 11.8-14.3 7.2-14.3-28.6 14.3-7.2 32-16 8.3-4.2 7.7 5.2L208 380.8l39.1-26.1 8.9-5.9 8.9 5.9L304 380.8l39.1-26.1 7.7-5.2 8.3 4.2 32 16 14.3 7.2-14.3 28.6-14.3-7.2-23.7-11.8-40.3 26.8-8.9 5.9-8.9-5.9zM174.4 123.5l-12 .5c-46.9 1.9-82.2 45-78.1 84.3l0 .3 0 .3c2 40.2 40.8 70.7 76.2 66.7l.3 0 .3 0c36.3-2 62.1-35.7 58.4-64.5l0-.3 0-.3c-2.1-29.8-31.3-51-56-47.5l-.3 0-.3 0c-25.7 2.2-42 26.2-38.9 44.5l.1 .4 0 .4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1 .3 0c15.2-2.1 22-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2l-.1-.1 .5 5.8c1 11.1-8.8 15.8-14.1 16.4c-6.6 .8-13.4-2.2-17.6-8.5c-5-6.8-4.4-15.6-1.8-21.8c2.9-7 8.9-13.2 17.8-16c9.2-3.3 19.4-1.3 27.5 3.3c8.3 4.9 15.5 13.4 17.9 24.8c5.8 22.8-11.9 49.5-39.5 53.6c-27.7 5.3-59.8-16.2-63.6-49.2c-5.4-33 21.9-68.7 60.3-72.1c38.2-5.2 79.6 25.8 82.9 69.3c5.4 43.3-31.5 88.2-80.6 91.2c-48.8 5.3-99.6-35.2-102.5-89.1c-5.5-53.8 41.1-108.1 101-110.5l12-.5 1 24zM349.6 292c46.9-1.9 82.2-45 78.1-84.3l0-.3 0-.3c-2-40.2-40.8-70.7-76.2-66.7l-.3 0-.3 0c-36.3 2-62.1 35.7-58.4 64.5l0 .3 0 .3c2.1 29.8 31.3 51 56 47.5l.3 0 .3 0c25.7-2.2 42-26.2 38.9-44.5l-.1-.4 0-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3 .1-.3 0c-15.2 2.1-21.9 16.3-19.9 24l.1 .4 .1 .4c.9 4.3 3.4 7.4 6.5 9.2l.1 .1-.5-5.8c-1-11.1 8.8-15.8 14.1-16.4c6.6-.8 13.4 2.2 17.6 8.5c5 6.8 4.4 15.6 1.8 21.8c-2.9 7-8.9 13.2-17.8 16c-9.2 3.3-19.4 1.3-27.5-3.3c-8.3-4.9-15.5-13.4-17.9-24.8c-5.8-22.8 11.9-49.5 39.5-53.6c27.7-5.3 59.8 16.2 63.6 49.2c5.4 33-21.9 68.7-60.3 72.1c-38.2 5.2-79.6-25.8-82.9-69.3c-5.4-43.3 31.5-88.2 80.6-91.2c48.8-5.3 99.6 35.2 102.5 89.1c5.5 53.8-41.1 108.1-101 110.5l-12 .5-1-24 12-.5z'
      
    ]
  };

  

  
  

  var faArrowUpFromArc = {
    prefix: 'fasl',
    iconName: 'arrow-up-from-arc',
    icon: [
      512,
      512,
      [],
      'e4b4',
      
      'M256 480C132.3 480 32 379.7 32 256l0-16L0 240l0 16C0 397.4 114.6 512 256 512s256-114.6 256-256l0-16-32 0 0 16c0 123.7-100.3 224-224 224zM116 157.4l-10.6 12 23.9 21.3 10.6-12L240 66.1 240 336l0 16 32 0 0-16 0-269.9L372 178.6l10.6 12 23.9-21.3-10.6-12L268 13.4 256-.1 244 13.4l-128 144z'
      
    ]
  };

  

  
  

  var faPipeValve = {
    prefix: 'fasl',
    iconName: 'pipe-valve',
    icon: [
      512,
      512,
      [],
      'e439',
      
      'M272 32V16H240V32 80H144 128v32h16 96v80H32V176 160H0v16 32V432v32 16H32V464 448H480v16 16h32V464 432 208 176 160H480v16 16H272V112h96 16V80H368 272V32zM240 224h16 16H480V416H32V224H240z'
      
    ]
  };

  

  
  

  var faClockFiveThirty = {
    prefix: 'fasl',
    iconName: 'clock-five-thirty',
    icon: [
      512,
      512,
      [],
      'e34a',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400V308.8l34.7 52 8.9 13.3 26.6-17.8-8.9-13.3-64-96L240 256V400v16h32V400z'
      
    ]
  };

  

  
  

  var faPersonRifle = {
    prefix: 'fasl',
    iconName: 'person-rifle',
    icon: [
      576,
      512,
      [],
      'e54e',
      
      'M328 192h8V512H304V224H176V512H144V263.2L62.5 438.7l-29-13.5 104-224 4.3-9.3H152 328zM288 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM160 80a80 80 0 1 1 160 0A80 80 0 1 1 160 80zM532.2 307.9L480 325.3V352l3.2 16h6.4H512h32v32H522.2 512 489.6l6.4 32 9.6 48 6.4 32H479.4 416 384V480 432 400H368V368 224 192h16V160 128h32V96 64 32H400V0h16 16 16V32 96v32h32v32 32 63 25 8l32-8V224 192h32v32 56 24l-11.8 3.9zm-83.6 50.3l-.6-3.1V352 329v-3.7V302.3 288 160H416v32 32H400V368h16v32 80h57l-14.7-73.7L457 400l-5.1-25.7-1.3-6.3-1.9-9.7z'
      
    ]
  };

  

  
  

  var faDiagramNext = {
    prefix: 'fasl',
    iconName: 'diagram-next',
    icon: [
      512,
      512,
      [],
      'e476',
      
      'M480 192l-208 0H240L32 192 32 64l448 0V192zM272 224H480h32V192 64 32H480 32 0V64 192v32H32 240V329.4l-36.7-36.7L192 281.4 169.4 304l11.3 11.3 64 64L256 390.6l11.3-11.3 64-64L342.6 304 320 281.4l-11.3 11.3L272 329.4V224zM512 480V464 304 288H496 400 384v32h16 80V448L32 448l0-128h80 16V288H112 16 0v16V464v16H16l480 0h16z'
      
    ]
  };

  

  
  

  var faChartTreeMap = {
    prefix: 'fasl',
    iconName: 'chart-tree-map',
    icon: [
      512,
      512,
      [],
      'e0ea',
      
      'M192 64V208H32V64H192zM32 32H0V64 208v32H32 192h32V208 64 32H192 32zM192 304V448H32V304H192zM32 272H0v32V448v32H32 192h32V448 304 272H192 32zM288 64H480v64H288V64zM256 32V64v64 32h32H480h32V128 64 32H480 288 256zM480 224v64H288V224H480zM288 192H256v32 64 32h32H480h32V288 224 192H480 288zm0 192H480v64H288V384zm-32-32v32 64 32h32H480h32V448 384 352H480 288 256z'
      
    ]
  };

  

  
  

  var faTty = {
    prefix: 'fasl',
    iconName: 'tty',
    icon: [
      512,
      512,
      ["teletype"],
      'f1e4',
      
      'M322 237.2V164.8c-42.3-17.2-89.7-17.2-132 0v72.4L32 256-8 152.6C22.8 112.4 118.7 32 256 32s233.2 80.4 264 120.6L480 256 322 237.2zM158 164.8V143.2l20-8.1c50-20.3 106-20.3 156.1 0l20 8.1v21.5 44l105.1 12.5L483.2 159C447.9 121.9 366.8 64 256 64S64.1 121.9 28.8 159l24.1 62.3L158 208.8v-44zM56 291.2h64 12.8V304v64 12.8H120 56 43.2V368 304 291.2H56zm12.8 64h38.4V316.8H68.8v38.4zM56 403.2h64 12.8V416v64 12.8H120 56 43.2V480 416 403.2H56zm12.8 64h38.4V428.8H68.8v38.4zm323.2-64h64 12.8V416v64 12.8H456 392 379.2V480 416 403.2H392zm12.8 64h38.4V428.8H404.8v38.4zm-249.6-64H168 344h12.8V416v64 12.8H344 168 155.2V480 416 403.2zm25.6 25.6v38.4H331.2V428.8H180.8zM155.2 291.2H168h64 12.8V304v64 12.8H232 168 155.2V368 304 291.2zm25.6 25.6v38.4h38.4V316.8H180.8zM280 291.2h64 12.8V304v64 12.8H344 280 267.2V368 304 291.2H280zm12.8 64h38.4V316.8H292.8v38.4zm86.4-64H392h64 12.8V304v64 12.8H456 392 379.2V368 304 291.2zm25.6 25.6v38.4h38.4V316.8H404.8z'
      
    ]
  };

  
    var faTeletype = faTty;
  

  
  

  var faLaptopFile = {
    prefix: 'fasl',
    iconName: 'laptop-file',
    icon: [
      640,
      512,
      [],
      'e51d',
      
      'M480 32H96V288H320v32H96 64 32v2.7L61.3 352H320v32H48L0 336V320 288H32 64V32 0H96 480h32V32 96H480V32zm0 128H384V480H608V288H496 480V272 160zm32 0v96h96v-2.7L514.7 160H512zm16-32L640 240V480v32H608 384 352V480 160 128h32H528z'
      
    ]
  };

  

  
  

  var faFlagUsa = {
    prefix: 'fasl',
    iconName: 'flag-usa',
    icon: [
      448,
      512,
      [],
      'f74d',
      
      'M32 16V0H0V16 64 367v33 96 16H32V496 392l96.3-24.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4L448 368V51.8 16L416 32 393.6 43.2c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L32 56V16zm0 298.6l107.1-23c33.6-7.2 68.6-4.4 100.7 8.1l25.8 10c45.2 17.6 95.1 18.8 141.2 3.5l9.2-3.1v35.6l-34.7 13c-37.9 14.2-80 12-116.2-6.1c-44.7-22.4-96-28-144.5-15.9L32 359V314.6zm0-32.7V242.6l102.2-21.9c36.4-7.8 74.3-3.9 108.4 11.3l13.8 6.2c50.6 22.5 108 23.9 159.6 3.9v34.4l-19.3 6.4c-38.9 13-81.2 11.9-119.4-2.9l-25.8-10c-37.9-14.7-79.2-18-119-9.5L32 281.9zm0-72V89L140.7 61.8c6.4-1.6 12.8-2.7 19.3-3.3V185.1c-10.9 .6-21.7 2-32.5 4.3L32 209.9zm160-24l0-47.8c17.4 2.1 34.4 6.7 50.6 13.9l13.8 6.2c50.6 22.5 108 23.9 159.6 3.9v45.7l-11.3 4.4c-43.7 17-92.4 15.8-135.3-3.2l-13.8-6.2c-20.3-9-41.8-14.7-63.6-16.9zm0-80l0-46.6c13.9 2 27.4 6.2 40.1 12.6c55.3 27.7 120.4 27.7 175.8 0l8.1-4.1v59.9l-11.3 4.4c-43.7 17-92.4 15.8-135.3-3.2l-13.8-6.2c-20.3-9-41.8-14.7-63.6-16.9zM88 120a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM88 168a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCitrus = {
    prefix: 'fasl',
    iconName: 'citrus',
    icon: [
      512,
      512,
      [],
      'e2f4',
      
      'M304 128h16 64c53 0 96-43 96-96V16 0H464 448 384c-31 0-58.7 14.7-76.2 37.6c-16.7-3.7-34-5.6-51.8-5.6C123.5 32 16 139.5 16 272s107.5 240 240 240s240-107.5 240-240c0-49.5-15-95.5-40.7-133.7c-8.9 6-18.6 10.9-28.9 14.5C450.1 186.5 464 227.7 464 272c0 114.9-93.1 208-208 208S48 386.9 48 272S141.1 64 256 64c12.4 0 24.6 1.1 36.4 3.2C289.5 76.3 288 86 288 96v16 16h16zm80-96h64c0 35.3-28.7 64-64 64H320c0-35.3 28.7-64 64-64z'
      
    ]
  };

  

  
  

  var faLightsHoliday = {
    prefix: 'fasl',
    iconName: 'lights-holiday',
    icon: [
      640,
      512,
      [],
      'f7b2',
      
      'M7.9 93.8c91 53.5 195.4 82.2 301 82.2H320h11.1c105.6 0 210-28.7 301-82.2L615.9 66.2C529.8 116.8 431 144 331.1 144H320 308.8C209 144 110.2 116.8 24.1 66.2L7.9 93.8zM308.8 208c-1.6 0-3.2 0-4.8 0v49.6c-36.5 7.4-64 39.7-64 78.4c0 64 80 128 80 128s80-64 80-128c0-38.7-27.5-71-64-78.4V208c-1.6 0-3.2 0-4.9 0H320 308.8zm192.8-23.9c-10.3 2.9-20.7 5.6-31.1 8l15.2 41.7c-31.8 19.5-46.6 59.2-33.3 95.6c21.9 60.1 119 92.9 119 92.9s53.3-87.5 31.4-147.6c-13.2-36.4-50.1-57.3-87-51.8l-14.1-38.8zm-332.2 8c-10.4-2.4-20.8-5.1-31.1-8l-14.1 38.8c-36.8-5.5-73.7 15.4-87 51.8C15.4 334.8 68.7 422.3 68.7 422.3s97.1-32.8 119-92.9c13.2-36.4-1.5-76.1-33.3-95.6l15.2-41.7zM67.3 285.6c9.1-24.9 36.6-37.8 61.5-28.7s37.8 36.6 28.7 61.5c-6.9 18.9-27.9 37.3-53.7 52.3c-7.1 4.1-14 7.7-20.3 10.7c-2.9-6.3-5.9-13.5-8.7-21.2c-10.1-28.1-14.4-55.7-7.5-74.6zM272 336c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.1-13.5 44.6-32.6 67.5c-5.3 6.3-10.6 12.1-15.4 17c-4.9-4.9-10.2-10.7-15.4-17C285.5 380.6 272 356.1 272 336zm239.1-79.1c24.9-9.1 52.5 3.8 61.5 28.7c6.9 18.9 2.6 46.5-7.5 74.6c-2.8 7.7-5.8 14.9-8.7 21.2c-6.3-3-13.2-6.6-20.3-10.7c-25.8-15-46.8-33.4-53.7-52.3c-9.1-24.9 3.8-52.5 28.7-61.5z'
      
    ]
  };

  

  
  

  var faPipeCollar = {
    prefix: 'fasl',
    iconName: 'pipe-collar',
    icon: [
      512,
      512,
      [],
      'e437',
      
      'M382.1 450l-16-16-20.4 9.8c-27.1 13-57.5 20.3-89.7 20.3s-62.5-7.3-89.7-20.3L145.9 434l-16 16-30 30H32V412.1l30-30 16-16-9.8-20.4C55.3 318.5 48 288.2 48 256s7.3-62.5 20.3-89.7L78 145.9l-16-16-30-30L32 32l67.9 0 30 30 16 16 20.4-9.8C193.5 55.3 223.8 48 256 48s62.5 7.3 89.7 20.3L366.1 78l16-16 30-30H480V99.9l-30 30-16 16 9.8 20.4c13 27.1 20.3 57.5 20.3 89.7s-7.3 62.5-20.3 89.7L434 366.1l16 16 30 30V480H412.1l-30-30zM32 512h81.1l39.4-39.4c31.3 15 66.4 23.4 103.5 23.4s72.1-8.4 103.5-23.4L398.9 512H480h32V480 398.9l-39.4-39.4c15-31.3 23.4-66.4 23.4-103.5s-8.4-72.1-23.4-103.5L512 113.1V32 0H480 398.9L359.5 39.4C328.1 24.4 293.1 16 256 16s-72.1 8.4-103.5 23.4L113.1 0 0 0 0 113.1l39.4 39.4C24.4 183.9 16 218.9 16 256s8.4 72.1 23.4 103.5L0 398.9V480v32H32zm96-256a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm288 0A160 160 0 1 0 96 256a160 160 0 1 0 320 0zM96 432a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM448 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM80 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faPersonDressSimple = {
    prefix: 'fasl',
    iconName: 'person-dress-simple',
    icon: [
      256,
      512,
      [],
      'e21c',
      
      'M160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM42.4 352H213.6L167.9 192H88.1L42.4 352zM64 160H192l54.9 192 9.1 32H222.7 192V496v16H160V496 384H96V496v16H64V496 384H33.3 0l9.1-32L64 160z'
      
    ]
  };

  

  
  

  var faCircleB = {
    prefix: 'fasl',
    iconName: 'circle-b',
    icon: [
      512,
      512,
      [],
      'e0fd',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128v16V256 368v16h16H296c39.8 0 72-32.2 72-72c0-26.6-14.4-49.8-35.9-62.3C344.4 236.8 352 219.3 352 200c0-39.8-32.2-72-72-72H176 160zm160 72c0 22.1-17.9 40-40 40H192V160h88c22.1 0 40 17.9 40 40zM192 352V272h88 16c22.1 0 40 17.9 40 40s-17.9 40-40 40H192z'
      
    ]
  };

  

  
  

  var faRightLong = {
    prefix: 'fasl',
    iconName: 'right-long',
    icon: [
      512,
      512,
      ["long-arrow-alt-right"],
      'f30b',
      
      'M352 216l-32 0L32 216l0 80 288 0 32 0 0 32 0 42.7L466.7 256 352 141.3l0 42.7 0 32zm-32-88l0-32 32 0L489.4 233.4 512 256l-22.6 22.6L352 416l-32 0 0-32 0-24 0-32-32 0L32 328 0 328l0-32 0-80 0-32 32 0 256 0 32 0 0-32 0-24z'
      
    ]
  };

  
    var faLongArrowAltRight = faRightLong;
  

  
  

  var faLaptopSlash = {
    prefix: 'fasl',
    iconName: 'laptop-slash',
    icon: [
      640,
      512,
      [],
      'e1c7',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM500.3 480l-40.5-32H61.3L32 418.7V416H419.2l-40.5-32H32 0v32 16l48 48H500.3zM544 351.5l.7 .5H576V64 32H544 139.4l40.5 32H544V351.5zM64 135.6V352H96V160.8L64 135.6z'
      
    ]
  };

  

  
  

  var faCoin = {
    prefix: 'fasl',
    iconName: 'coin',
    icon: [
      512,
      512,
      [129689],
      'f85c',
      
      'M256 320c66.2 0 124.6-15.2 165.3-38.1C463 258.5 480 231.1 480 208s-17-50.5-58.7-73.9C380.6 111.2 322.2 96 256 96s-124.6 15.2-165.3 38.1C49 157.5 32 184.9 32 208s17 50.5 58.7 73.9C131.4 304.8 189.8 320 256 320zm-80 24.8l0 64.3c20 3.6 41.5 5.8 64 6.6l0-64c-22.2-.8-43.7-3.1-64-6.9zm-32-7.3c-17.2-4.7-33.2-10.5-48-17.1l0 64.7c14.2 6.5 30.3 12.3 48 17l0-64.6zM32 277.8L32 320c0 12.9 8.5 29.9 32 46.8l0-63.6c-12.2-7.8-23-16.3-32-25.5zm240 74l0 64c22.5-.7 44-3 64-6.6l0-64.3c-20.3 3.8-41.8 6.1-64 6.9zm208-74c-9 9.2-19.8 17.7-32 25.5l0 63.6c23.5-16.9 32-34 32-46.8l0-42.2zM368 337.5l0 64.6c17.7-4.7 33.8-10.5 48-17l0-64.7c-14.8 6.7-30.8 12.4-48 17.1zM0 208C0 128.5 114.6 64 256 64s256 64.5 256 144l0 32 0 80c0 70.7-114.6 128-256 128S0 390.7 0 320l0-80 0-32zm256-56c-47.1 0-89.1 7.4-118.7 18.8c-14.8 5.7-25.8 12.2-32.7 18.5C97.7 195.7 96 200.6 96 204s1.7 8.3 8.6 14.7c6.9 6.3 17.8 12.8 32.7 18.5C166.9 248.6 208.9 256 256 256s89.1-7.4 118.7-18.8c14.8-5.7 25.8-12.2 32.7-18.5c6.9-6.3 8.6-11.3 8.6-14.7s-1.7-8.3-8.6-14.7c-6.9-6.3-17.8-12.8-32.7-18.5C345.1 159.4 303.1 152 256 152zm192 52c0 15.4-8.2 28.3-19 38.3c-10.9 9.9-25.7 18.2-42.7 24.7c-34.1 13.2-80.2 21-130.2 21s-96.1-7.8-130.2-21c-17-6.6-31.9-14.8-42.7-24.7c-10.9-9.9-19-22.9-19-38.3s8.2-28.3 19-38.3c10.9-9.9 25.7-18.2 42.7-24.7c34.1-13.2 80.2-21 130.2-21s96.1 7.8 130.2 21c17 6.6 31.9 14.8 42.7 24.7c10.9 9.9 19 22.9 19 38.3z'
      
    ]
  };

  

  
  

  var faPowerOff = {
    prefix: 'fasl',
    iconName: 'power-off',
    icon: [
      512,
      512,
      [9211],
      'f011',
      
      'M272 16V0H240V16 272v16h32V272 16zM56 256c0-77.4 43.9-144.5 108.3-177.8L149.6 49.8C75 88.3 24 166.2 24 256c0 128.1 103.9 232 232 232s232-103.9 232-232c0-89.8-51-167.7-125.6-206.2L347.7 78.2C412.1 111.5 456 178.6 456 256c0 110.5-89.5 200-200 200S56 366.5 56 256z'
      
    ]
  };

  

  
  

  var faTicket = {
    prefix: 'fasl',
    iconName: 'ticket',
    icon: [
      576,
      512,
      [127903],
      'f145',
      
      'M0 64V96v80 32c26.5 0 48 21.5 48 48s-21.5 48-48 48v32 80 32H32 544h32V416 336 304c-26.5 0-48-21.5-48-48s21.5-48 48-48V176 96 64H544 32 0zM80 256c0-32.8-19.7-61-48-73.3V96H544v86.7c-28.3 12.3-48 40.5-48 73.3s19.7 61 48 73.3V416H32V329.3C60.3 317 80 288.8 80 256zm80-64H416V320H160V192zm-32-32v32V320v32h32H416h32V320 192 160H416 160 128z'
      
    ]
  };

  

  
  

  var faSwordLaserAlt = {
    prefix: 'fasl',
    iconName: 'sword-laser-alt',
    icon: [
      512,
      512,
      [],
      'e03c',
      
      'M352 225.3V224H310.1L467.9 49.1l-5-5L263.5 224H215.8L464 0l48 48L352 225.3zM96 512L73.4 489.4 22.6 438.6 0 416l22.6-22.6L160 256H306.7 352l-32 32L118.6 489.4 96 512zM274.7 288H173.3l-43.3 43.3 25.4 25.4 25.4 25.4L274.7 288zM144 390.6L81.9 452.7 96 466.7l62.1-62.1L144 390.6zM121.4 368l-14.1-14.1L45.3 416l14.1 14.1L121.4 368z'
      
    ]
  };

  

  
  

  var faEllipsisVertical = {
    prefix: 'fasl',
    iconName: 'ellipsis-vertical',
    icon: [
      128,
      512,
      ["ellipsis-v"],
      'f142',
      
      'M32 64H96v64H32V64zm0 160H96v64H32V224zM96 384v64H32V384H96z'
      
    ]
  };

  
    var faEllipsisV = faEllipsisVertical;
  

  
  

  var faRouter = {
    prefix: 'fasl',
    iconName: 'router',
    icon: [
      576,
      512,
      [],
      'f8da',
      
      'M352 0c71.4 0 136.7 26 187 69L516.3 91.7C471.9 54.4 414.5 32 352 32s-119.9 22.4-164.3 59.7L165 69C215.3 26 280.6 0 352 0zm0 96c44.9 0 86.1 15.4 118.8 41.2L448 160c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32l-22.8-22.8C265.9 111.4 307.1 96 352 96zm16 128v16 80H544h32v32V480v32H544 32 0V480 352 320H32 336V240 224h32zM544 352H32V480H544V352zM160 392h48v48H160V392zm-32 0v48H80V392h48z'
      
    ]
  };

  

  
  

  var faWandSparkles = {
    prefix: 'fasl',
    iconName: 'wand-sparkles',
    icon: [
      512,
      512,
      [],
      'f72b',
      
      'M390.3 160H376l-9.5 10.7L102.7 465.5 46.5 409.3 117.3 346l10.7-9.5V322.1 288h41.9 12.2l9.1-8.2L454.8 44 468 57.2l-43.8 49-8.2 9.1v12.2V160H390.3zM104 512l21.4-23.9L390.3 192H416h32V160 127.5L512 56 456 0 169.9 256H128 96v32 34.1L23.9 386.6 0 408l22.7 22.7 58.7 58.7L104 512zM256 32V16H224V32 64H192 176V96h16 32v32 16h32V128 96h32 16V64H288 256V32zM96 80V64H64V80v48H16 0v32H16 64v48 16H96V208 160h48 16V128H144 96V80zM448 304V288H416v16 48H368 352v32h16 48v48 16h32V432 384h48 16V352H496 448V304z'
      
    ]
  };

  

  
  

  var faSquareU = {
    prefix: 'fasl',
    iconName: 'square-u',
    icon: [
      448,
      512,
      [],
      'e281',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM144 160V288c0 44.2 35.8 80 80 80s80-35.8 80-80V160 144h32v16V288c0 61.9-50.1 112-112 112s-112-50.1-112-112V160 144h32v16z'
      
    ]
  };

  

  
  

  var faPersonPregnant = {
    prefix: 'fasl',
    iconName: 'person-pregnant',
    icon: [
      384,
      512,
      [],
      'e31e',
      
      'M192 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 192 0zM160 384V496v16H128V496l0-112H96V352 211.1L62.9 293.9 33.1 282.1l57.6-144 4-10.1H96h9.6H128h64 64l18.3 97.7c44.3 8.6 77.7 47.5 77.7 94.3v32 32H320 304 256V496v16H224V496 384H192 160zm32-224H128l0 192h32 32 32 32 48 16V320c0-31.1-22.3-57.1-51.7-62.8L246.9 253l-4-21.4L229.4 160H192z'
      
    ]
  };

  

  
  

  var faFlask = {
    prefix: 'fasl',
    iconName: 'flask',
    icon: [
      448,
      512,
      [],
      'f0c3',
      
      'M288 224l4.7 7.7L347.1 320H100.9l54.3-88.3L160 224v-9.1V32H288V214.9 224zM128 0H112 96V32h16 16V214.9L0 422.9V480v32H32 416h32V480 422.9l-128-208V32h16 16V0H336 320 288 160 128zM32 432l49.2-80H366.8L416 432v48H32V432z'
      
    ]
  };

  

  
  

  var faSwordsLaser = {
    prefix: 'fasl',
    iconName: 'swords-laser',
    icon: [
      640,
      512,
      [],
      'e03d',
      
      'M384 160l0 27.7L176 0 128 48 384 331.7V352L521.4 489.4 544 512l22.6-22.6 50.7-50.7L640 416l-22.6-22.6L416 192l-32-32zM172.1 49.1l5-5L384 230.8v53.1L172.1 49.1zM510.1 331.3l-25.4 25.4-25.4 25.4L416 338.7V237.3l94.1 94.1zm22.6 22.6L594.7 416l-14.1 14.1L518.6 368l14.1-14.1zm25.4 98.7L544 466.7l-62.1-62.1L496 390.6l62.1 62.1zm-359.7-213l-11-11L176 217.4 153.4 240l11.3 11.3 4.7 4.7L112 313.4l-8-8L92.7 316.7l-88 88L0 409.4V416v32 6.6l4.7 4.7 48 48 4.7 4.7H64 96h6.6l4.7-4.7 88-88L206.6 408l-8-8L256 342.6l4.7 4.7L272 358.6 294.6 336l-11.3-11.3-11-11 26.2-29-21.6-23.9L249.6 291 221 262.4l31.6-28.5-21.4-23.8-32.8 29.6zM467.9 49.1l-69.6 77.1 22.7 22.7L512 48 464 0 343.9 108.4 367.8 130l95.1-85.8 5 5zM192 278.6L233.4 320 216 337.4 174.6 296 192 278.6zM134.6 336L152 318.6 193.4 360 176 377.4 134.6 336zM32 422.6l72-72L161.4 408l-72 72H70.6L32 441.4V422.6z'
      
    ]
  };

  

  
  

  var faCentSign = {
    prefix: 'fasl',
    iconName: 'cent-sign',
    icon: [
      384,
      512,
      [],
      'e3f5',
      
      'M224 0V16 64c1.3 0 2.7 0 4 0c44 0 84.7 14.2 117.5 38.3l-18.9 25.8C299.1 108 265 96 228 96C137.1 96 64 168 64 256s73.1 160 164 160c37 0 71.1-12 98.5-32.1l18.9 25.8C312.7 433.8 272 448 228 448c-1.3 0-2.7 0-4 0v48 16H192V496 444.8C101.2 428.2 32 350.3 32 256s69.2-172.2 160-188.8V16 0h32z'
      
    ]
  };

  

  
  

  var faHamsa = {
    prefix: 'fasl',
    iconName: 'hamsa',
    icon: [
      512,
      512,
      [],
      'f665',
      
      'M192 0h16 96 16V16 32h80 16V48 256h80 16v16 64 6.6l-4.7 4.7L403.9 450.7C364.7 490 311.5 512 256 512s-108.7-22-147.9-61.3L4.7 347.3 0 342.6V336 272 256H16 96V48 32h16 80V16 0zM320 208v16H304 288V208 48 32H224V48 208v16H208 192V208 64H128V272c0 8.8-7.2 16-16 16H32v41.4l98.7 98.7C164 461.3 209 480 256 480s92-18.7 125.3-51.9L480 329.4V288H400c-8.8 0-16-7.2-16-16V64H320V208zM200.6 372c17.6 15.6 37.7 28 55.4 28s37.8-12.3 55.4-28c8.1-7.2 15-14.5 19.9-20c-4.9-5.6-11.8-12.8-19.9-20c-17.6-15.6-37.7-28-55.4-28s-37.8 12.3-55.4 28c-8.1 7.2-15 14.5-19.9 20c4.9 5.6 11.8 12.8 19.9 20zm164.2-29.6s0 0-12.8 9.6c12.8 9.6 12.8 9.6 12.8 9.6l0 0 0 0 0 .1-.1 .2-.5 .6c-.4 .5-1 1.3-1.8 2.3c-1.5 1.9-3.7 4.6-6.5 7.8c-5.6 6.4-13.5 14.9-23.2 23.4c-18.4 16.4-46.3 36-76.6 36s-58.2-19.7-76.6-36c-9.6-8.6-17.6-17.1-23.2-23.4c-2.8-3.2-5-5.9-6.5-7.8c-.8-1-1.4-1.7-1.8-2.3l-.5-.6-.1-.2 0-.1 0 0 0 0s0 0 12.8-9.6c-12.8-9.6-12.8-9.6-12.8-9.6l0 0 0 0 0-.1 .1-.2 .5-.6c.4-.5 1-1.3 1.8-2.3c1.5-1.9 3.7-4.6 6.5-7.8c5.6-6.4 13.5-14.9 23.2-23.4c18.4-16.4 46.3-36 76.6-36s58.2 19.7 76.6 36c9.6 8.6 17.6 17.1 23.2 23.4c2.8 3.2 5 5.9 6.5 7.8c.8 1 1.4 1.7 1.8 2.3l.5 .6 .1 .2 0 .1 0 0 0 0zM352 352l12.8 9.6L372 352l-7.2-9.6L352 352zm-204.8-9.6L160 352l-12.8 9.6L140 352l7.2-9.6zM256 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faMapPin = {
    prefix: 'fasl',
    iconName: 'map-pin',
    icon: [
      320,
      512,
      [128205],
      'f276',
      
      'M160 256a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM304 144c0 74.1-56 135.2-128 143.1V496v16H144V496 287.1c-72-8-128-69-128-143.1C16 64.5 80.5 0 160 0s144 64.5 144 144zm-192 0H80c0-44.2 35.8-80 80-80V96c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  

  
  

  var faCroissant = {
    prefix: 'fasl',
    iconName: 'croissant',
    icon: [
      512,
      512,
      [129360],
      'f7f6',
      
      'M40.1 175.8C67.3 115.7 115.7 67.3 175.8 40.1l123 226.2-32.5 32.5L40.1 175.8zM190.4 0C100.9 30.3 30.2 100.9 0 190.4l14.3 7.8C5 226.4 0 256.6 0 288c0 55.2 15.5 106.7 42.4 150.5c5.5 9 11.6 17.7 18 26l.2 .3 23.8-18.5c26.9 29 60.5 51.7 98.2 65.7L224 480l-16-96V350.2l35.3-27.5L272 338.4 338.4 272l-15.6-28.7L350.2 208H384l96 16 32-41.3c-14.1-37.8-36.8-71.3-65.7-98.2l18.5-23.8-.3-.2c-8.3-6.5-17-12.5-26-18C394.7 15.5 343.2 0 288 0c-31.4 0-61.6 5-89.8 14.3L190.4 0zM426.6 109.9c20.2 19.3 36.8 42.3 48.8 68l-8.9 11.5-77.2-12.9-2.6-.4H384h-8.9l51.4-66.1zM176 375.1V384v2.6l.4 2.6 12.9 77.2-11.5 8.9c-25.7-11.9-48.7-28.5-68-48.7L176 375.1zM32 288c0-25.8 3.8-50.7 10.9-74.2l169.7 92.3L67.8 418.7C45.1 380.5 32 335.8 32 288zM418.7 67.8L306.1 212.6 213.8 42.9C237.3 35.8 262.2 32 288 32c47.8 0 92.5 13.1 130.7 35.8z'
      
    ]
  };

  

  
  

  var faNetworkWired = {
    prefix: 'fasl',
    iconName: 'network-wired',
    icon: [
      640,
      512,
      [],
      'f6ff',
      
      'M416 32V160H224V32H416zM224 0H192V32 160v32h32 80v48H176 144 16 0v32H16 144v48H64 32v32V480v32H64 256h32V480 352 320H256 176V272H304h32H464v48H384 352v32V480v32h32H576h32V480 352 320H576 496V272H624h16V240H624 496 464 336V192h80 32V160 32 0H416 224zM64 352H256V480H64V352zm512 0V480H384V352H576z'
      
    ]
  };

  

  
  

  var faFolderTree = {
    prefix: 'fasl',
    iconName: 'folder-tree',
    icon: [
      576,
      512,
      [],
      'f802',
      
      'M0 0V112 400v16H16 256V384H32V128H256V96H32V0H0zM426.7 64H440 544V192H320V32h74.7l22.6 22.6 9.4 9.4zM544 32H440L408 0H320 288V32 192v32h32H544h32V192 64 32H544zM426.7 352H440 544V480H320V320h74.7l22.6 22.6 9.4 9.4zM544 320H440l-32-32H320 288v32V480v32h32H544h32V480 352 320H544z'
      
    ]
  };

  

  
  

  var faPeople = {
    prefix: 'fasl',
    iconName: 'people',
    icon: [
      640,
      512,
      [],
      'e216',
      
      'M136 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 104 56a56 56 0 1 0 112 0zM108.9 128H99.3l-4.5 8.5-76.9 144-7.5 14.1 28.2 15.1 7.5-14.1L96 202.1V496v16h32V496 352h64V496v16h32V496 202.2l49.9 93.4 7.5 14.1 28.2-15.1-7.5-14.1-76.9-144-4.5-8.5h-9.6H108.9zM192 320H128V160h64V320zM456 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 424 56a56 56 0 1 0 112 0zM446.3 263.2l7.2-14.3-28.6-14.3-7.2 14.3-64 128L342.1 400H368h48v96 16h32V496 400h64v96 16h32V496 400h48 25.9l-11.6-23.2-64-128-7.2-14.3-28.6 14.3 7.2 14.3L566.1 368H544 512 448 416 393.9l52.4-104.8zM419.3 128l-4.5 8.5-76.9 144-7.5 14.1 28.2 15.1 7.5-14.1L438.5 160h83l72.4 135.5 7.5 14.1 28.2-15.1-7.5-14.1-76.9-144-4.5-8.5h-9.6H428.9h-9.6z'
      
    ]
  };

  

  
  

  var faCauldron = {
    prefix: 'fasl',
    iconName: 'cauldron',
    icon: [
      448,
      512,
      [],
      'f6bf',
      
      'M160 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm96 24a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM60.1 244.9C72 223 85.2 204.3 94.9 192H224 353.1c9.7 12.3 22.9 31 34.8 52.9C404.3 275 416 307.1 416 334.4c0 45.1-21.4 80.4-56.1 105.5C324.5 465.5 275.4 480 224 480s-100.5-14.5-135.9-40.1C53.4 414.8 32 379.5 32 334.4c0-27.3 11.7-59.4 28.1-89.5zM55.2 192C30.2 228.1 0 283.9 0 334.4c0 37.4 11.9 69.4 32 95.5V512H64V461.8C106.3 494.6 164.6 512 224 512s117.7-17.4 160-50.2V512h32V429.9c20.1-26.1 32-58.1 32-95.5c0-50.5-30.2-106.3-55.2-142.4H448V160H368 224 80 0v32H55.2z'
      
    ]
  };

  

  
  

  var faSliders = {
    prefix: 'fasl',
    iconName: 'sliders',
    icon: [
      512,
      512,
      ["sliders-h"],
      'f1de',
      
      'M0 400l0 32 16 0 64 0 0 32 0 32 32 0 96 0 32 0 0-32 0-32 256 0 16 0 0-32-16 0-256 0 0-32 0-32-32 0-96 0-32 0 0 32 0 32-64 0L0 400zm208 32l0 32-96 0 0-32 0-32 0-32 96 0 0 32 0 32zM0 240l0 32 16 0 256 0 0 32 0 32 32 0 96 0 32 0 0-32 0-32 64 0 16 0 0-32-16 0-64 0 0-32 0-32-32 0-96 0-32 0 0 32 0 32L16 240 0 240zM112 112l0 32 0 32 32 0 96 0 32 0 0-32 0-32 224 0 16 0 0-32-16 0L272 80l0-32 0-32-32 0-96 0-32 0 0 32 0 32L16 80 0 80l0 32 16 0 96 0zm32 0l0-32 0-32 96 0 0 32 0 32 0 32-96 0 0-32zM400 240l0 32 0 32-96 0 0-32 0-32 0-32 96 0 0 32z'
      
    ]
  };

  
    var faSlidersH = faSliders;
  

  
  

  var faOutlet = {
    prefix: 'fasl',
    iconName: 'outlet',
    icon: [
      448,
      512,
      [],
      'e01c',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM96 256c0 35.7 12.8 61 25.5 77.6c6.4 8.4 12.7 14.5 17.3 18.4H309.3c4.6-3.9 10.9-10 17.3-18.4C339.2 317 352 291.7 352 256s-12.8-61-25.5-77.6c-6.4-8.4-12.7-14.5-17.3-18.4H138.7c-4.6 3.9-10.9 10-17.3 18.4C108.8 195 96 220.3 96 256zm-32 0c0-88 64-128 64-128H320s64 40 64 128s-64 128-64 128H128s-64-40-64-128zm128-64v16 48 16H160V256 208 192h32zm96 0v16 48 16H256V256 208 192h32zm-64 96c13.3 0 24 10.7 24 24v24H200V312c0-13.3 10.7-24 24-24z'
      
    ]
  };

  

  
  

  var faFilterList = {
    prefix: 'fasl',
    iconName: 'filter-list',
    icon: [
      512,
      512,
      [],
      'e17c',
      
      'M144 256v87.2l64 44V256 244l7.9-9L320 116V96H32v20l104.1 119 7.9 9v12zm-32 0L0 128V96 64H32 320h32V96v32L240 256V409.2 448l-32-22-96-66V256zM384 80h16 96 16v32H496 400 384V80zM336 240H496h16v32H496 336 320V240h16zm0 160H496h16v32H496 336 320V400h16z'
      
    ]
  };

  

  
  

  var faKhanda = {
    prefix: 'fasl',
    iconName: 'khanda',
    icon: [
      512,
      512,
      [9772],
      'f66d',
      
      'M256 0l64 48s-6.6 10.6-14.5 27.5C342.5 93.8 368 131.9 368 176s-25.5 82.2-62.5 100.5C313.4 293.4 320 304 320 304l-48 36v22.6l34.5-23.7 .1-.1C363.8 299.5 416 256 416 180.6c0-27.1-4.8-58-12.1-84.3C398.4 76.4 391.4 59.1 384 48c0 0 21.8 9.3 47.5 28.8C467.9 104.5 512 152.7 512 224c0 96-112 192-112 192l-83.4-45.3L284.2 393l46.1 31.7c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4v28.9c9.6 5.5 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7V423.4L199.8 451c-1.5 11.8-11.6 21-23.8 21c-13.3 0-24-10.7-24-24s10.7-24 24-24c2 0 3.9 .2 5.7 .7L227.8 393l-32.4-22.3L112 416s-112-96-112-192C0 152.7 44.1 104.5 80.5 76.8C106.1 57.3 128 48 128 48c-7.4 11.1-14.4 28.4-19.9 48.3C100.8 122.6 96 153.5 96 180.6c0 75.4 52.2 118.9 109.4 158.2l.1 .1L240 362.6V340l-48-36s6.6-10.6 14.5-27.5C169.5 258.2 144 220.1 144 176s25.5-82.2 62.5-100.5C198.6 58.6 192 48 192 48L256 0zm24 176c0 24.8 6 49.7 13.4 70.7C318.7 233.3 336 206.7 336 176s-17.3-57.3-42.6-70.7C286 126.3 280 151.2 280 176zm-48 0c0-24.8-6-49.7-13.4-70.7C193.3 118.7 176 145.3 176 176s17.3 57.3 42.6 70.7C226 225.7 232 200.8 232 176zm38.5 100.3c-5-12.1-10.3-26.6-14.5-42.4c-4.2 15.9-9.4 30.3-14.5 42.4c-2.8 6.8-5.7 13.1-8.4 18.6L256 312l22.8-17.1c-2.7-5.5-5.5-11.7-8.4-18.6zm0-200.6c2.8-6.8 5.7-13.1 8.4-18.6L256 40 233.2 57.1c2.7 5.5 5.5 11.7 8.4 18.6c5 12.1 10.3 26.6 14.5 42.4c4.2-15.9 9.4-30.3 14.5-42.4zM32 224c0 36.8 22.2 77.6 49.3 112.4c13 16.7 26 30.6 35.8 40.5l49.1-26.6C115.1 312.7 64 262.6 64 180.6c0-15.7 1.4-32.2 3.9-48.5C47.6 155.7 32 186 32 224zm448 0c0-38-15.6-68.3-35.9-91.9c2.4 16.2 3.9 32.8 3.9 48.5c0 82-51.1 132.1-102.1 169.6l49 26.6c9.8-9.8 22.9-23.8 35.8-40.5c27-34.7 49.3-75.5 49.3-112.4z'
      
    ]
  };

  

  
  

  var faOlive = {
    prefix: 'fasl',
    iconName: 'olive',
    icon: [
      448,
      512,
      [],
      'e316',
      
      'M160 448C89.3 448 32 390.7 32 320c0-84.8 39.8-148.3 91.7-191.4C176.5 84.7 239.5 64 280 64c18.4 0 39.8 9.7 59.3 22.6c9.2 6.1 16.9 12.3 22.3 16.9c2.7 2.3 4.8 4.2 6.1 5.4c.7 .6 1.2 1.1 1.5 1.4l.3 .3 .3 .3c.3 .3 .7 .8 1.4 1.5c1.3 1.3 3.1 3.4 5.4 6.1c4.6 5.4 10.8 13.1 16.9 22.3C406.3 160.2 416 181.6 416 200c0 40.5-20.7 103.5-64.6 156.3C308.3 408.2 244.8 448 160 448zM0 320c0 88.4 71.6 160 160 160c192 0 288-181.9 288-280c0-56-56-112-56-112s-56-56-112-56C181.9 32 0 128 0 320zM282.4 197.6c-11.2-11.2-16.1-28.6-17.7-45.4c-.5-5.3-.6-10.6-.4-15.9c5.4-.2 10.6-.1 15.9 .4c16.8 1.6 34.2 6.5 45.4 17.7s16.1 28.6 17.7 45.4c.6 5.9 .7 11.5 .6 16.1c-4.6 .1-10.1 0-16.1-.6c-16.8-1.6-34.2-6.5-45.4-17.7zm-49.6-42.5c1.8 19.5 7.9 46 27 65.1s45.6 25.1 65.1 27c10 .9 19 .8 25.4 .5c6.8-.4 13.4-1.3 20.2-2.3l0 0 2.6-.4 .4-2.6 0 0c1-6.7 2-13.3 2.3-20.2c.3-6.4 .4-15.4-.5-25.4c-1.8-19.5-7.9-46-27-65.1s-45.6-25.1-65.1-27c-16.6-1.6-32-.1-48.1 2.2c-2.4 16.2-3.8 31.5-2.2 48.1z'
      
    ]
  };

  

  
  

  var faHoneyPot = {
    prefix: 'fasl',
    iconName: 'honey-pot',
    icon: [
      448,
      512,
      [127855],
      'e418',
      
      'M128 64h32v80 16h32V144 64h32H384V96H320 224v32h96c53 0 96 43 96 96H32c0-53 43-96 96-96V96H64V64h64zM447.8 237.3c.2-4.4 .2-8.8 .2-13.3c0-38.2-16.8-72.5-43.3-96H416V96 64 32H384 192 160 64 32V64 96v32H43.3C16.8 151.5 0 185.8 0 224c0 4.5 .1 8.9 .2 13.3c-.2 .9-.2 1.8-.2 2.7c0 1.4 .2 2.8 .5 4.1C9.2 406.1 120 480 120 480H328s110.8-73.9 119.5-235.9c.3-1.3 .5-2.7 .5-4.1c0-.9-.1-1.8-.2-2.7zM414.5 256c-2.2 23.6-6.8 44.9-12.9 64.1c-.5-.1-1-.1-1.6-.1H48c-.5 0-1.1 0-1.6 .1c-6.1-19.2-10.7-40.5-12.9-64.1h381zm-25.2 96c-8.4 18.4-17.9 34.1-27.3 47.4c-13.5 18.9-26.9 32.7-36.8 41.7c-3 2.8-5.7 5.1-8 6.9H130.8c-2.2-1.8-4.9-4.1-8-6.9c-9.9-9-23.3-22.8-36.8-41.7c-9.5-13.3-19-29-27.3-47.4H389.3z'
      
    ]
  };

  

  
  

  var faCoins = {
    prefix: 'fasl',
    iconName: 'coins',
    icon: [
      512,
      512,
      [],
      'f51e',
      
      'M160 80c0 2.4 1.3 6.8 8.3 12.8c1.4 1.2 2.9 2.4 4.6 3.6c-15.4 .6-30.4 1.9-44.9 3.9V80c0-15.3 8.6-27.7 19.4-37c10.9-9.4 25.7-17.1 42.7-23.2C224.1 7.3 270 0 320 0s95.9 7.3 129.9 19.7c16.9 6.2 31.8 13.9 42.7 23.2C503.4 52.3 512 64.7 512 80l0 104 0 0 0 113.9c0 15.4-8.2 28.2-19.1 38s-25.7 17.9-42.7 24.4c-10.4 3.9-21.8 7.4-34.1 10.3v-33c8.2-2.2 15.8-4.6 22.8-7.2c14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2V231.7c-8.7 5.6-18.8 10.5-29.9 14.7c-10.4 3.9-21.8 7.4-34.1 10.3v-33c8.2-2.2 15.8-4.6 22.8-7.2c14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2V126.1c-8.8 5.4-19 10.1-30.1 14.1c-17.3 6.3-37.6 11.3-60 14.6c-1.9-1.9-3.8-3.8-5.7-5.5c-10.1-9.1-21.7-16.4-33.8-22.5c34.8-2.3 65.4-8.4 88.5-16.8c14.9-5.4 25.8-11.5 32.8-17.4c7-6 8.3-10.4 8.3-12.8s-1.3-6.8-8.3-12.8c-6.9-5.9-17.8-12-32.8-17.4C409.3 39 367.2 32 320 32s-89.3 7-119 17.8c-14.9 5.4-25.8 11.5-32.8 17.4c-7 6-8.3 10.4-8.3 12.8zM32 208c0 2.4 1.3 6.8 8.3 12.8c6.9 5.9 17.8 12 32.8 17.4C102.7 249 144.8 256 192 256s89.3-7 119-17.8c14.9-5.4 25.8-11.5 32.8-17.4c7-6 8.3-10.4 8.3-12.8s-1.3-6.8-8.3-12.8c-6.9-5.9-17.8-12-32.8-17.4C281.3 167 239.2 160 192 160s-89.3 7-119 17.8c-14.9 5.4-25.8 11.5-32.8 17.4c-7 6-8.3 10.4-8.3 12.8zM0 208c0-15.3 8.6-27.7 19.4-37c10.9-9.4 25.7-17.1 42.7-23.2C96.1 135.3 142 128 192 128s95.9 7.3 129.9 19.7c16.9 6.2 31.8 13.9 42.7 23.2c10.9 9.3 19.4 21.8 19.4 37l0 104 0 0 0 113.9c0 15.4-8.2 28.2-19.1 38s-25.7 17.9-42.7 24.4C288.1 501.3 242 509 192 509s-96.1-7.7-130.1-20.7c-17-6.5-31.8-14.6-42.7-24.4S0 441.3 0 425.9V312 208zm352 46.1c-8.8 5.4-19 10.1-30.1 14.1C287.9 280.7 242 288 192 288s-95.9-7.3-129.9-19.7c-11.1-4-21.3-8.7-30.1-14.1V312c0 3.1 1.6 8 8.5 14.2s17.8 12.6 32.7 18.2C102.9 355.7 144.8 363 192 363s89.1-7.3 118.8-18.6c14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2V254.1zM32 425.9c0 3.1 1.6 8 8.5 14.2s17.8 12.6 32.7 18.2C102.9 469.6 144.8 477 192 477s89.1-7.3 118.8-18.6c14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2V359.7c-8.7 5.6-18.8 10.5-29.9 14.7C288.1 387.4 242 395 192 395s-96.1-7.7-130.1-20.7c-11-4.2-21.1-9.1-29.9-14.7v66.2z'
      
    ]
  };

  

  
  

  var faMountainCity = {
    prefix: 'fasl',
    iconName: 'mountain-city',
    icon: [
      640,
      512,
      [],
      'e52e',
      
      'M288 0V16 144.4l32 51.2V32H480V208v16h16 48 32 32V496v16h32V496 208 192H624 576V112 96H544v16 80H512V16 0H496 304 288zm80 64H352V80v64 16h16 64 16V144 80 64H432 368zm16 64V96h32v32H384zm-16 64v32h16 32v32 16h32V256 208 192H432 384 368zm128 64H480v16 64 16h16 64 16V336 272 256H560 496zm16 64V288h32v32H512zm-32 64v16 64 16h16 64 16V464 400 384H560 496 480zm32 32h32v32H512V416zm-32 96l-20-32L258.9 158.2 240 128l-18.9 30.2L20 480 0 512H37.7 442.3 480zm-57.7-32H57.7l92-147.2L179.5 370l12.2 15.2 12.6-15L246.5 320h75.8l100 160zM240 188.4L302.3 288H239h-7.5l-4.8 5.7-34.4 41L167.7 304 240 188.4z'
      
    ]
  };

  

  
  

  var faFluxCapacitor = {
    prefix: 'fasl',
    iconName: 'flux-capacitor',
    icon: [
      448,
      512,
      [],
      'f8ba',
      
      'M416 64V448H32V64H416zM32 32H0V64 448v32H32 416h32V448 64 32H416 32zM292.7 255.2c3.7 .5 7.5 .8 11.3 .8c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c3.8 0 7.6-.3 11.3-.8L86.1 185.9l67.9-67.9L224 188.1l70.1-70.1 67.9 67.9-69.3 69.3zM173.8 273.7C155.6 288.4 144 310.8 144 336c0 44.2 35.8 80 80 80s80-35.8 80-80c0-25.2-11.6-47.6-29.8-62.3l-2.2 2.2V368H224 176V275.9l-2.2-2.2zm-41.1-86.4L208 262.6V336h32V262.6l75.3-75.3-22.6-22.6L224 233.4l-68.7-68.7-22.6 22.6z'
      
    ]
  };

  

  
  

  var faBatteryHalf = {
    prefix: 'fasl',
    iconName: 'battery-half',
    icon: [
      576,
      512,
      ["battery-3"],
      'f242',
      
      'M480 128V384H32V128H480zM32 96H0v32V384v32H32 480h32V384 128 96H480 32zm544 96H544v32 64 32h32V288 224 192zM96 192H256V320H96V192zM64 160v32V320v32H96 256h32V320 192 160H256 96 64z'
      
    ]
  };

  
    var faBattery3 = faBatteryHalf;
  

  
  

  var faBoltAuto = {
    prefix: 'fasl',
    iconName: 'bolt-auto',
    icon: [
      576,
      512,
      [],
      'e0b6',
      
      'M338.9 49.8L303.5 184.4l-8.3 31.5 32.5 2.2L416 224v48L137.2 481.1 96 512l13.1-49.8 35.4-134.6 8.3-31.5-32.5-2.2L32 288V240L310.8 30.9 352 0 338.9 49.8zM293 247.9l-38.7-2.6 9.9-37.5 33.4-127L64 256v2.1l91 6.1 38.7 2.6-9.9 37.5-33.4 127L384 256v-2.1l-91-6.1zM453.6 288h20.9l4.2 9.6L573 512H538l-21.1-48H411.1L390 512H355l94.4-214.4 4.2-9.6zM464 343.7L425.2 432h77.7L464 343.7z'
      
    ]
  };

  

  
  

  var faIndustryWindows = {
    prefix: 'fasl',
    iconName: 'industry-windows',
    icon: [
      576,
      512,
      [127981,"industry-alt"],
      'f3b3',
      
      'M48 32H32V48 256 384v80 16H48 528h16V464 320 256 128 102.6l-22.9 11L368 187.1V128 102.1l-23.2 11.6L192 190.1V48 32H176 48zM64 256V64h96V216v25.9l23.2-11.6L336 153.9v58.6 25.4l22.9-11L512 153.4V256v64V448H64V384 256zm64 48H112v16 64 16h16 64 16V384 320 304H192 128zm16 64V336h32v32H144zm96-64v16 64 16h16 64 16V384 320 304H320 256 240zm32 32h32v32H272V336zm112-32H368v16 64 16h16 64 16V384 320 304H448 384zm16 64V336h32v32H400z'
      
    ]
  };

  
    var faIndustryAlt = faIndustryWindows;
  

  
  

  var faCarMirrors = {
    prefix: 'fasl',
    iconName: 'car-mirrors',
    icon: [
      576,
      512,
      [],
      'e343',
      
      'M132.1 32H144 432h11.9l3.4 11.4L491.9 192H512h32 16 16v32H560 544V384v16 16 64H512V416H64v64H32V416 400 384 224H16 0V192H16 32 64 84.1L128.7 43.4 132.1 32zM112 224H96 64V384H512V224H480 464 112zM420.1 64H155.9L117.5 192h341L420.1 64zM112 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faRacquet = {
    prefix: 'fasl',
    iconName: 'racquet',
    icon: [
      512,
      512,
      [],
      'f45a',
      
      'M349 32c35.5 0 69 12.2 93.9 37.1S480 127.5 480 163c0 45.1-19.6 93.4-57.6 131.4c-68.1 68.1-168.9 76.9-225.3 20.5C172.2 290 160 256.5 160 221c0-45.1 19.6-93.4 57.6-131.4S303.9 32 349 32zm0-32c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 37.7 11.4 74.7 35.7 104.7l-31 31-6.1-6.1L104 328 81.4 350.6 22.6 409.4 0 432l22.6 22.6 34.7 34.7L80 512l22.6-22.6 58.7-58.7L184 408l-22.6-22.6-6.1-6.1 31-31c73.5 60.1 186.4 41.1 258.7-31.2c43.6-43.6 67-99.8 66.9-154c0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM104 373.3L138.7 408 80 466.7 45.3 432 104 373.3z'
      
    ]
  };

  

  
  

  var faPiggyBank = {
    prefix: 'fasl',
    iconName: 'piggy-bank',
    icon: [
      576,
      512,
      [],
      'f4d3',
      
      'M193.1 98.6l-31.6-5.3C170.4 40.4 216.5 0 272 0c48.8 0 90.3 31.2 105.6 74.7L347.5 85.3C336.5 54.2 306.8 32 272 32c-39.6 0-72.5 28.8-78.9 66.6zM376.4 160H224c-70.7 0-128 57.3-128 128c0 41.9 20.1 79 51.2 102.4L160 400v16 64h64V448 416h32 64 32v32 32h64V434.7 413.7l19.2-8.4c20.4-8.9 38-23 51.2-40.6L496 352h16 32V256H530.7 509.7l-8.4-19.2c-8.9-20.4-23-38-40.6-51.2l-17-12.8 5.1-20.6L455 128h-7c-19 0-35.9 8.2-47.7 21.3L390.7 160H376.4zM448 96h15 33l-8 32-8 32c22 16.5 39.5 38.5 50.7 64H544h32v32 96 32H544 512c-16.5 22-38.5 39.6-64 50.7V480v32H416 352 320V480 448H288 256v32 32H224 160 128V480 416c-38.9-29.2-64-75.7-64-128v0c-35.5-.8-64-29.8-64-65.4c0-24.8 14-47.4 36.2-58.5l4.7-2.3 14.3 28.6-4.7 2.3C39.2 198.3 32 209.9 32 222.6C32 241 47 256 65.4 256h1.8C82 183 146.6 128 224 128H376.4C394 108.4 419.6 96 448 96zM424 240a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faCarBump = {
    prefix: 'fasl',
    iconName: 'car-bump',
    icon: [
      640,
      512,
      [],
      'f5e0',
      
      'M66 80.6l11.5-3.1L342 6.7l11.2-3 6.3 9.7 77.6 118.2 16.5-4.4 30.9-8.3 8.3 30.9 38.6 144 8.3 30.9 15.8 58.8L526 391.3l-15.8-58.8-1.5 .4L100.2 442.4l-1.5 .4 15.8 58.8L85 509.4 65.3 436l0 0L61 419.7l-38.6-144-8.3-30.9L45 236.6l16.2-4.3L65.6 92.5 66 80.6zM339.1 40.6L97.2 105.4 93.5 223.6l311-83.3L339.1 40.6zM53.3 267.5l38.6 144L500.4 302 461.8 158 53.3 267.5zm59.9 53.2a22.8 22.8 0 1 1 44.1-11.8 22.8 22.8 0 1 1 -44.1 11.8zM408.6 217.9A22.8 22.8 0 1 1 420.4 262a22.8 22.8 0 1 1 -11.8-44.1zM512 448c-41.8 0-77.4 26.7-90.5 64H388c14.2-55.2 64.3-96 124-96s109.8 40.8 124 96H602.5c-13.2-37.3-48.7-64-90.5-64z'
      
    ]
  };

  

  
  

  var faSushiRoll = {
    prefix: 'fasl',
    iconName: 'sushi-roll',
    icon: [
      448,
      512,
      ["maki-roll","makizushi"],
      'e48b',
      
      'M447.5 128c-2.5-18.6-13.4-33.3-25.3-44C408.5 71.9 390.5 62.4 371 55.1C331.8 40.4 279.8 32 224 32s-107.8 8.4-147 23.1C57.5 62.4 39.5 71.9 25.9 84C13.9 94.7 3 109.4 .5 128L0 128l0 8 0 24L0 368s44.3 112 224 112s224-112 224-112l0-208 0-24 0-8-.5 0zm-31.5 6.2c0 .6 .1 1.2 .1 1.8c0 14.5-11.4 28-31 39.3L274 133.7 247.5 64.6c45.8 2.4 86.2 11.6 116.4 24.6c37.5 16.2 50.2 34 51.9 43.9l.2 1.1zM224 208c-39.7 0-76.6-4.5-107.2-12.3L157.6 158l80.6-28.4 8.5 22.3 2.6 6.7 6.8 2.5L341.2 193c-32.4 9.4-73 15-117.2 15zM81.9 184.4C50.9 171.6 32 154.6 32 136c0-.6 0-1.2 .1-1.8l.2-1.1c1.6-9.9 14.3-27.7 51.9-43.9C117 75 162.1 65.4 213 64.1l13.6 35.6-82.9 29.2-3.1 1.1-2.4 2.2L81.9 184.4zM32 193c12.7 9.7 28.3 17.6 45 23.8c39.2 14.7 91.2 23.1 147 23.1s107.8-8.4 147-23.1c16.7-6.3 32.3-14.1 45-23.8l0 167.6c-1.1 1.9-2.5 4.4-4.4 7.2c-5.5 8.3-14.7 19.9-28.7 31.6C355.3 422.5 306.6 448 224 448s-131.3-25.5-158.9-48.6c-14.1-11.7-23.2-23.3-28.7-31.6c-1.9-2.8-3.3-5.3-4.4-7.2L32 193z'
      
    ]
  };

  
    var faMakiRoll = faSushiRoll;
  
    var faMakizushi = faSushiRoll;
  

  
  

  var faFaceHeadBandage = {
    prefix: 'fasl',
    iconName: 'face-head-bandage',
    icon: [
      576,
      512,
      [],
      'e37a',
      
      'M288 32c2.4 0 4.9 0 7.3 .1c-29.3 9.7-57.6 21.4-84.8 35c-17.1 1.4-34.1 3.2-51 5.4C195.8 47 240.2 32 288 32zm80.1-19.2C342.9 4.5 316 0 288 0C213.6 0 146.6 31.8 99.8 82.4c-12.5 2.5-25 5.2-37.3 8.2l-12.4 3c-2.3 3.3-4.5 6.7-6.6 10.1l-.8 1.2C26.9 130.6 15 158.9 7.8 189l-.4 1.8c-3.8 16.4-6.2 33.3-7 50.6l0 0c-.1 1.3-.1 2.6-.2 3.8l0 .5c-.1 3.1-.2 6.2-.2 9.3l0 .9 0 .5 0 .7c.1 31 5.1 60.9 14.4 88.9l.7 2.1c6.3 18.7 14.5 36.5 24.2 53.2l32-47.4c31.3-46.3 69.9-87.2 114.1-121c-.7 2.2-1.1 4.6-1.1 7.1c0 13.3 10.7 24 24 24s24-10.7 24-24c0-13.1-10.5-23.7-23.5-24c12-8.2 24.4-15.8 37.2-23c13.9-.7 27.9-1 41.9-1c83.4 0 163.9 12.3 239.8 35.1l47.8 14.4c-.9-17.2-3.2-34.1-7-50.4l-.5-2.1c-5.2-21.6-12.8-42.3-22.5-61.8l0 0c-4.1-8.1-8.5-16-13.3-23.7c-1.8-2.9-3.7-5.8-5.6-8.7c-4.2-6.2-8.6-12.2-13.3-18.1l-.6-.7c-21.2-26.5-47-49.1-76.2-66.8l-1.5-.9c-2.8-1.6-5.5-3.2-8.4-4.8L416.2 4.9c-16.2 2-32.2 4.6-48.1 7.9zM476.2 82.4C419.3 71.1 360.6 64.9 300.6 64.1c38.3-13 78.3-22.3 119.5-27.4c13.7 8.3 26.6 17.9 38.5 28.5c6.1 5.5 11.9 11.2 17.5 17.2zm-160 78s0 0 0 0c-9.4-.3-18.8-.5-28.2-.5c-17.1 0-34.1 .5-51 1.5c0 0 0 0 0 0c-47.8 2.8-94.6 9.4-140 19.7c0 0 0 0 0 0c-19.6 4.4-39 9.5-58.1 15.3c0-.2 .1-.4 .1-.6c.4-1.8 .9-3.6 1.4-5.4c2.8-10.5 6.2-20.8 10.2-30.7c5.4-13.3 11.8-26 19.3-38C139.9 104.9 212.9 96 288 96s148.1 8.9 218 25.8c7.4 12 13.9 24.8 19.3 38c4.8 11.8 8.7 24.1 11.7 36.7c-11.9-3.6-23.9-6.9-36-10c-59.4-15.1-121.2-24-184.8-26zm-265.9 66c41-12.2 83.3-21.3 126.6-27.1c-40.6 29.4-77 64.4-108 103.7c-8.5 10.7-16.5 21.7-24.2 33.1c-4.4-13.3-7.7-27.1-9.9-41.3C33 282.1 32 269.2 32 256c0-3 .1-6.1 .2-9.1c5.9-7 12-13.8 18.2-20.5zm461.2 44.5C503.8 387.7 406.7 480 288 480c-73.3 0-138.3-35.2-179.2-89.6L83.2 409.6C129.9 471.8 204.2 512 288 512c135.7 0 246.7-105.5 255.4-238.9l-31.9-2.1zM373.2 397.5l11.8 10.8 21.5-23.7-11.8-10.8C373.2 354.3 340.2 336 296 336c-16.4 0-31.4 2.5-44.8 6.8l-15.3 4.8 9.6 30.5 15.3-4.8c10.4-3.3 22.1-5.3 35.2-5.3c34.8 0 60.4 14.2 77.2 29.5zM368.4 264a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faCircleLocationArrow = {
    prefix: 'fasl',
    iconName: 'circle-location-arrow',
    icon: [
      512,
      512,
      ["location-circle"],
      'f602',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm264.6 15.4l9.5 41.1L316 196 199.5 238l41.1 9.5 19.5 4.5 4.5 19.5zm-31.2 7.2L143.9 258 86.3 244.7l55.6-20 188.2-67.7 39.1-14.1-14.1 39.1L287.3 370.1l-20 55.6L254 368.1l-20.7-89.5z'
      
    ]
  };

  
    var faLocationCircle = faCircleLocationArrow;
  

  
  

  var faFolderHeart = {
    prefix: 'fasl',
    iconName: 'folder-heart',
    icon: [
      512,
      512,
      [],
      'e189',
      
      'M32 32H224l48 64H480h32v32V448v32H480 32 0V448 64 32H32zm240 96H256l-9.6-12.8L208 64H32V448H480V128H272zm-23.7 81.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L256 384.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2zm79.3 61.6c5.3-5.1 8.3-12.2 8.3-19.6c0-15-12.2-27.2-27.2-27.2h-2.4c-7.7 0-15 3-20.5 8.3l-7.7 7.4L256 261l-22.2-21.3-7.7-7.4c-5.5-5.3-12.9-8.3-20.5-8.3h-2.4c-15 0-27.2 12.2-27.2 27.2c0 7.4 3 14.5 8.3 19.6L256 339.7l71.7-68.9z'
      
    ]
  };

  

  
  

  var faPlaneUp = {
    prefix: 'fasl',
    iconName: 'plane-up',
    icon: [
      512,
      512,
      [],
      'e22d',
      
      'M221.2 13.3C230.8 5.7 242.6 0 256 0c26.9 0 47.1 21.6 59.2 41.8C327.9 62.9 336 89.1 336 109.7v52.5l167.9 96 8.1 4.6V272v96 22.7l-21.4-7.6L336 327.8V376l57.6 43.2L400 424v8 64 16H384 368h-2.2l-2.2-.6L256 480.6 148.4 511.4l-2.2 .6H144 128 112V496 432v-8l6.4-4.8L176 376l0-50.6L20.9 375.2 0 381.9V360 264v-9.3l8.1-4.6 167.9-96V109.7c0-20.7 8.4-46.9 21.2-67.9c6.5-10.7 14.5-20.8 24-28.4zm3.3 45C214.1 75.6 208 96.2 208 109.7v53.7 9.3l-8.1 4.6L32 273.3v64.8l155.1-49.9 20.9-6.7v21.9l0 80.6v8l-6.4 4.8L144 440v39.4l107.6-30.7 4.4-1.3 4.4 1.3L368 479.4V440l-57.6-43.2L304 392v-8V305.1 282.4l21.4 7.6L480 345.3v-64l-167.9-96-8.1-4.6v-9.3V109.7c0-13.6-5.9-34.2-16.2-51.4C276.9 40.2 265.1 32 256 32c-4.1 0-9 1.7-14.8 6.3c-5.8 4.6-11.5 11.5-16.7 20z'
      
    ]
  };

  

  
  

  var faMobileScreen = {
    prefix: 'fasl',
    iconName: 'mobile-screen',
    icon: [
      384,
      512,
      ["mobile-android-alt"],
      'f3cf',
      
      'M320 32V320H64V32H320zm0 320V480H64V352H320zM64 0H32V32 480v32H64 320h32V480 32 0H320 64zm80 400v32h16 64 16V400H224 160 144z'
      
    ]
  };

  
    var faMobileAndroidAlt = faMobileScreen;
  

  
  

  var faBellSchool = {
    prefix: 'fasl',
    iconName: 'bell-school',
    icon: [
      512,
      512,
      [],
      'f5d5',
      
      'M208 384a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm0 32c-41.2 0-79.7-12-112-32.7V480H272h48V383.3C287.7 404 249.2 416 208 416zm64 96H80 64V496 358.1C24.6 320.2 0 267 0 208C0 93.1 93.1 0 208 0S416 93.1 416 208c0 59-24.6 112.2-64 150.1V480h96V445.3c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3V496v16H464 352 336 272zM256 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM464 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faTemperatureThreeQuarters = {
    prefix: 'fasl',
    iconName: 'temperature-three-quarters',
    icon: [
      320,
      512,
      ["temperature-3","thermometer-3","thermometer-three-quarters"],
      'f2c8',
      
      'M96 275l-10.7 9.5C62.4 305.1 48 334.9 48 368c0 61.9 50.1 112 112 112s112-50.1 112-112c0-33.2-14.4-62.9-37.3-83.5L224 275V260.7 32H96V260.7 275zM224 0h32V32 260.7c29.5 26.4 48 64.7 48 107.3c0 79.5-64.5 144-144 144S16 447.6 16 368c0-42.6 18.5-81 48-107.3V32 0H96 224zM160 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62V144 128h32v16V306c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTemperature3 = faTemperatureThreeQuarters;
  
    var faThermometer3 = faTemperatureThreeQuarters;
  
    var faThermometerThreeQuarters = faTemperatureThreeQuarters;
  

  
  

  var faBoxingGlove = {
    prefix: 'fasl',
    iconName: 'boxing-glove',
    icon: [
      448,
      512,
      [129354,"glove-boxing"],
      'f438',
      
      'M16 0H0V16 312v6.6l4.7 4.7L32 350.6V496v16H48 336h16V496 382.6l27.3-27.3 64-64 4.7-4.7V280 144 128H432 384V16 0H368 16zM384 160h32V273.4l-59.3 59.3-32 32-4.7 4.7V376 480H64V344v-6.6l-4.7-4.7L32 305.4V32H352v96H272 256v16 48H133.3l-27.7-20.8-12.8-9.6L73.6 187.2l12.8 9.6 32 24 4.3 3.2H128 256v48 16h16 64 16V256H336 288V224 192 160h64 16 16zM152.9 338.7l-13.3-8.9-17.8 26.6 13.3 8.9 28 18.7-28 18.7-13.3 8.9 17.8 26.6 13.3-8.9L192 403.2l39.1 26.1 13.3 8.9 17.8-26.6-13.3-8.9-28-18.7 28-18.7 13.3-8.9-17.8-26.6-13.3 8.9L192 364.8l-39.1-26.1z'
      
    ]
  };

  
    var faGloveBoxing = faBoxingGlove;
  

  
  

  var faHouseChimneyMedical = {
    prefix: 'fasl',
    iconName: 'house-chimney-medical',
    icon: [
      576,
      512,
      ["clinic-medical"],
      'f7f2',
      
      'M288 2.7L298.6 12 384 87.4V48 32h16 96 16V48 200h-.3l58.9 52-21.2 24L512 243V496v16H496 80 64V496 243L26.6 276 5.4 252l272-240L288 2.7zM480 172.1V64H416v51.6l64 56.5zM96 214.7V480H480V214.7L288 45.3 96 214.7zM240 176h16 64 16v16 48h48 16v16 64 16H384 336v48 16H320 256 240V384 336H192 176V320 256 240h16 48V192 176zm32 32v48 16H256 208v32h48 16v16 48h32V320 304h16 48V272H320 304V256 208H272z'
      
    ]
  };

  
    var faClinicMedical = faHouseChimneyMedical;
  

  
  

  var faCards = {
    prefix: 'fasl',
    iconName: 'cards',
    icon: [
      640,
      512,
      [],
      'e3ed',
      
      'M421.2 353.6L222.6 468.3 43.7 158.4 242.3 43.7 421.2 353.6zM226.3 16L0 146.7 194.9 484.3l16 27.7 27.7-16L437.2 381.4l27.7-16-16-27.7L270 27.7 254 0 226.3 16zM320 512h32H608h32V480 96 64H608 336.1h-8.2l18.5 32H608V480H352V467.5L320 486v26zM488.2 164.7l4.3 4.5 11.9 12.5L516 168.9l3.9-4.3c5.7-5.6 14-5.8 19.1-1.7c6.4 5.7 6.8 16 .9 22.2l-35.7 37-35.9-37 0 0c-5.9-6.2-5.6-16.5 1.1-22.2l0 0 .1-.1c4.5-3.9 13-4 18.9 1.9zM504 136.4c-16.2-11-39.1-12.1-55.6 2.2c-20.8 17.9-21.8 49.5-3.2 68.7l0 0 47.4 48.9 11.5 11.9 11.5-11.9 47.2-48.9c18.5-19.2 17.6-50.7-3-68.6l0 0-.2-.2c-16.7-14-39.4-13.2-55.6-2.1zM218.7 288.3c-3.1 11.3-13.4 17.4-22.4 16c-12.3-2.6-20.2-15.4-17.2-27.4l0 0 20.1-80.7 80.2 22.8 0 0c11.9 3.4 19 16.8 14.8 28.8l0 .1c-2.8 8.2-13.9 14-24.9 11l-25-7.4-16.5-4.9-3.6 16.9-5.3 24.7zm31 7.9l.1-.4 .1-.4 1.8-8.3 8.6 2.5 0 0 .3 .1c23.7 6.5 54.3-3.9 63.8-31.4c10.4-29.7-6.8-61.7-36.2-70.2l0 0-96.1-27.3-15.9-4.5-4 16.1-24.1 96.7 0 0c-7.4 29.6 11.7 60.5 42.2 66.6l0 0 .4 .1c27.1 4.7 52.2-13.7 59.1-39.6zm-19.4 44.3l16 27.7 13.9-8 48.2-27.8 13.9-8-16-27.7-13.9 8-48.2 27.8-13.9 8z'
      
    ]
  };

  

  
  

  var faLocationDotSlash = {
    prefix: 'fasl',
    iconName: 'location-dot-slash',
    icon: [
      640,
      512,
      ["map-marker-alt-slash"],
      'f605',
      
      'M381.9 386.4c-20.6 27.6-40.7 52.3-56.3 70.7c-1.9 2.3-3.8 4.5-5.6 6.6c-1.8-2.1-3.6-4.3-5.6-6.6c-17.7-20.8-41.1-49.7-64.5-81.9c-23.5-32.3-46.4-67.3-63.4-100.5c-11.9-23.4-20-44.1-23.8-61.4L128.1 186c-.1 2-.1 4-.1 6c0 88.8 120.7 237.9 170.7 295.9C311.8 503.1 320 512 320 512s8.2-8.9 21.3-24.1c16.5-19.1 40.7-48.2 65.7-81.7l-25.1-19.8zM320 0C263.8 0 213.3 24.1 178.2 62.5l25.2 19.9C232.6 51.4 274 32 320 32c88.4 0 160 71.6 160 160c0 20.2-9.1 48.6-26.5 82.7c-.6 1.2-1.3 2.4-1.9 3.7l25.5 20.2C497.8 260 512 222.4 512 192C512 86 426 0 320 0zm80 192c0-44.2-35.8-80-80-80c-20.5 0-39.2 7.7-53.3 20.4l25.8 20.3c7.8-5.5 17.3-8.7 27.6-8.7c26.5 0 48 21.5 48 48c0 6.2-1.2 12.2-3.4 17.7L390.4 230c6.1-11.3 9.6-24.3 9.6-38zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  
    var faMapMarkerAltSlash = faLocationDotSlash;
  

  
  

  var faCaretDown = {
    prefix: 'fasl',
    iconName: 'caret-down',
    icon: [
      320,
      512,
      [],
      'f0d7',
      
      'M288 224L32 224l0 1.7L160 341 288 225.8l0-1.7zm0-32l32 0 0 32 0 16L160 384 0 240l0-16 0-32 32 0 256 0z'
      
    ]
  };

  

  
  

  var faBallot = {
    prefix: 'fasl',
    iconName: 'ballot',
    icon: [
      448,
      512,
      [],
      'f732',
      
      'M416 32V480H32V32H416zM32 0H0V32 480v32H32 416h32V480 32 0H416 32zM160 112v32h16H352h16V112H352 176 160zm0 128v32h16H352h16V240H352 176 160zm0 128v32h16H352h16V368H352 176 160zM120 104H72v48h48V104zM72 232v48h48V232H72zm48 128H72v48h48V360z'
      
    ]
  };

  

  
  

  var faUsbDrive = {
    prefix: 'fasl',
    iconName: 'usb-drive',
    icon: [
      640,
      512,
      [],
      'f8e9',
      
      'M32 128V384H416V128H32zM0 96H32 416h32v32V384v32H416 32 0V384 128 96zM480 384V352H608V160H480V128H608h32v32V352v32H608 480zm64-192h32v32H544V192zm32 96v32H544V288h32z'
      
    ]
  };

  

  
  

  var faArrowsFromDottedLine = {
    prefix: 'fasl',
    iconName: 'arrows-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e0a3',
      
      'M224 1.4l11.3 11.3 80 80L326.6 104 304 126.6l-11.3-11.3L240 62.6V176v16H208V176 62.6l-52.7 52.7L144 126.6 121.4 104l11.3-11.3 80-80L224 1.4zm0 509.3l-11.3-11.3-80-80L121.4 408 144 385.4l11.3 11.3L208 449.4 208 336V320h32v16l0 113.4 52.7-52.7L304 385.4 326.6 408l-11.3 11.3-80 80L224 510.6zM56 232v48H8V232H56zm48 0h48v48H104V232zm144 48H200V232h48v48zm48-48h48v48H296V232zm144 0v48H392V232h48z'
      
    ]
  };

  

  
  

  var faKeyboard = {
    prefix: 'fasl',
    iconName: 'keyboard',
    icon: [
      576,
      512,
      [9000],
      'f11c',
      
      'M32 96V416H544V96H32zM0 64H32 544h32V96 416v32H544 32 0V416 96 64zm120 72v48H72V136h48zM72 232h48v48H72V232zm48 96v48H72V328h48zm48-192h48v48H168V136zm48 96v48H168V232h48zm48-96h48v48H264V136zm48 96v48H264V232h48zm48-96h48v48H360V136zm48 96v48H360V232h48zm48-96h48v48H456V136zm48 96v48H456V232h48zm-48 96h48v48H456V328zm-56 8h16v32H400 176 160V336h16H400z'
      
    ]
  };

  

  
  

  var faTimeline = {
    prefix: 'fasl',
    iconName: 'timeline',
    icon: [
      640,
      512,
      [],
      'e29c',
      
      'M112 48v64h64V48H112zM80 16h32 64 32V48v64 32H176 160V256H480V144H464 432V112 48 16h32 64 32V48v64 32H528 512V256H624h16v32H624 352v80h16 32v32 64 32H368 304 272V464 400 368h32 16V288H16 0V256H16 128V144H112 80V112 48 16zM352 400H320 304v64h64V400H352zM528 48H464v64h64V48z'
      
    ]
  };

  

  
  

  var faS = {
    prefix: 'fasl',
    iconName: 's',
    icon: [
      320,
      512,
      [115],
      '53',
      
      'M83.4 75.8c-27.8 11.5-45.1 30.6-49.8 56.6c-3.3 18.2-1.2 31.7 3.6 42.3c4.9 10.7 13.4 19.8 25.5 27.9c25 16.7 61.4 27 101.5 38c.6 .2 1.1 .3 1.7 .5c38 10.5 79.3 21.8 109.1 41.8c15.5 10.4 28.7 23.6 36.8 41.1c8.1 17.5 10.3 37.9 6.1 61.3c-7 39-33.3 65.8-69.1 80.6c-35.3 14.5-80.2 17.7-127.9 10.5l-.1 0c-25-3.9-66.1-17.4-94.4-26.7c-5.7-1.9-10.9-3.6-15.3-5l9.8-30.5c5 1.6 10.7 3.5 16.8 5.5c28.5 9.3 65.9 21.6 88 25.1c44 6.6 82.6 3.2 110.9-8.4c27.8-11.5 45.1-30.6 49.8-56.6c3.3-18.2 1.2-31.7-3.6-42.3c-4.9-10.7-13.4-19.8-25.5-27.9c-25-16.7-61.4-27-101.5-38l-1.7-.5c-38-10.5-79.3-21.8-109.1-41.8c-15.5-10.4-28.7-23.6-36.8-41.1C.1 170.5-2.1 150.2 2.1 126.8c7-39 33.3-65.8 69.1-80.6c35.3-14.5 80.2-17.7 127.9-10.5C213.4 37.9 256.9 46 272 49.8l-7.9 31c-13.6-3.5-55.9-11.4-69.7-13.5l2.4-15.8-2.4 15.8c-44-6.6-82.7-3.3-111 8.4z'
      
    ]
  };

  

  
  

  var faOverline = {
    prefix: 'fasl',
    iconName: 'overline',
    icon: [
      448,
      512,
      [],
      'f876',
      
      'M16 32H0V64H16 432h16V32H432 16zm208 96c-88.4 0-160 71.6-160 160v32c0 88.4 71.6 160 160 160s160-71.6 160-160V288c0-88.4-71.6-160-160-160zM96 288c0-70.7 57.3-128 128-128s128 57.3 128 128v32c0 70.7-57.3 128-128 128s-128-57.3-128-128V288z'
      
    ]
  };

  

  
  

  var faSquareUpLeft = {
    prefix: 'fasl',
    iconName: 'square-up-left',
    icon: [
      448,
      512,
      [],
      'e282',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM128 144H288h6.6l4.7 4.7 16 16L326.6 176l-11.3 11.3L274.6 228l64.7 64.7L350.6 304l-11.3 11.3-56 56L272 382.6l-11.3-11.3L196 306.6l-40.7 40.7L144 358.6l-11.3-11.3-16-16-4.7-4.7V320 160 144h16zm16 169.4l40.7-40.7L196 261.4l11.3 11.3L272 337.4 305.4 304l-64.7-64.7L229.4 228l11.3-11.3L281.4 176H144V313.4z'
      
    ]
  };

  

  
  

  var faBaseballBatBall = {
    prefix: 'fasl',
    iconName: 'baseball-bat-ball',
    icon: [
      512,
      512,
      [],
      'f432',
      
      'M403.3 12.7L392 1.4 380.7 12.7 226.1 167.2c-9.7 9.7-18.4 20.3-26 31.7L125.2 311.3c-6.4 9.6-13.8 18.6-22 26.8L32 409.4l-7.9-7.9L1.5 424.1 9.4 432l11.3 11.3 48 48L80 502.6l0 0 7.9 7.9 22.6-22.6-7.9-7.9 71.2-71.2c8.2-8.2 17.2-15.6 26.8-22l112.4-74.9c11.4-7.6 22-16.3 31.7-26L499.3 131.3 510.6 120l-11.3-11.3-96-96zM54.6 432l71.2-71.2c.7-.7 1.4-1.4 2.1-2.1L153.4 384c-.7 .7-1.4 1.4-2.1 2.1L80 457.4 54.6 432zm93.9-98.1c1.1-1.6 2.2-3.2 3.3-4.8l74.9-112.4c6.4-9.6 13.8-18.6 22-26.8L392 46.6 465.4 120 322.1 263.2c-8.2 8.2-17.2 15.6-26.8 22L182.9 360.1c-1.6 1.1-3.2 2.2-4.8 3.3l-29.6-29.6zM384 432a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faPenNibSlash = {
    prefix: 'fasl',
    iconName: 'pen-nib-slash',
    icon: [
      640,
      512,
      [],
      'e4a1',
      
      'M480 224l73.4-73.4L576 128l-22.6-22.6L470.6 22.6 448 0 425.4 22.6 352 96l-83.3 27.8 30 23.7L348.3 131 445 227.7l-9.3 28 26.7 21.1L480 224zM378.6 394L127.3 471.4 239.5 359.1c9.5 5.6 20.6 8.9 32.5 8.9c18.7 0 35.6-8 47.3-20.8L294 327.2c-5.7 5.4-13.5 8.8-22 8.8c-17.7 0-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16L219.1 268c-7 10.2-11.1 22.6-11.1 36c0 11.9 3.2 23 8.9 32.5L104.6 448.7l67.1-218.1-26.9-21.3L64 472l40 40 305.1-93.9L378.6 394zm82.1-196l-82.7-82.7L448 45.3 530.7 128l-70.1 70.1zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faListRadio = {
    prefix: 'fasl',
    iconName: 'list-radio',
    icon: [
      512,
      512,
      [],
      'e1d0',
      
      'M32 96a32 32 0 1 1 64 0A32 32 0 1 1 32 96zm96 0A64 64 0 1 0 0 96a64 64 0 1 0 128 0zm64-16v32h16H496h16V80H496 208 192zm0 160v32h16H496h16V240H496 208 192zm0 160v32h16H496h16V400H496 208 192zM64 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-96a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM80 96A16 16 0 1 0 48 96a16 16 0 1 0 32 0zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faLampStreet = {
    prefix: 'fasl',
    iconName: 'lamp-street',
    icon: [
      512,
      512,
      [],
      'e1c5',
      
      'M32 168C32 92.9 92.9 32 168 32c72.7 0 132 57 135.8 128.7C216 168 145 234.4 130.7 320c-1.7 10.4-2.7 21.1-2.7 32h32H480h32c0-10.9-.9-21.6-2.7-32C495 234.3 423.8 167.8 335.8 160.6C332 71.3 258.3 0 168 0C75.2 0 0 75.2 0 168V496v16H32V496 168zm288 24c77.4 0 142 55 156.8 128H163.2C178 247 242.6 192 320 192zM241.6 384c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64H365.3c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32H241.6z'
      
    ]
  };

  

  
  

  var faCloudSleet = {
    prefix: 'fasl',
    iconName: 'cloud-sleet',
    icon: [
      512,
      512,
      [],
      'f741',
      
      'M384 128v32h32c35.3 0 64 28.7 64 64v64H416 96 32V224c0-27.8 17.8-51.6 42.7-60.4L96 156.1V133.5 112c0-44.2 35.8-80 80-80c27 0 50.9 13.4 65.5 34l17.8 25.2 25.9-16.9c10-6.5 22-10.3 34.9-10.3c35.3 0 64 28.7 64 64zM0 320H32 96 416h64 32V288 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v64 32zm72 32L0 512H32l72-160H72zm256 0L256 512h32l72-160H328zm-136 0H160v16 32H128 112v32h16 32v32 16h32V464 432h32 16V400H224 192V368 352zm256 16V352H416v16 32l-32 0H368l0 32h16l32 0v32 16h32V464 432l32 0h16l0-32H480l-32 0V368z'
      
    ]
  };

  

  
  

  var faFaucet = {
    prefix: 'fasl',
    iconName: 'faucet',
    icon: [
      512,
      512,
      [],
      'e005',
      
      'M240 80V64H208V80v48H80 64v32H80 208v48H176h-6.6l-4.7 4.7L121.4 256H16 0v32H16 128h6.6l4.7-4.7L182.6 240h82.7l43.3 43.3 4.7 4.7H320h48c61.9 0 112 50.1 112 112v16H416V400c0-26.5-21.5-48-48-48H307.2h-9.2l-4.6 8c-13.9 24-39.7 40-69.3 40s-55.5-16.1-69.3-40l-4.6-8h-9.2H16 0v32H16 132.1c20.2 29 53.8 48 91.9 48s71.7-19 91.9-48H368c8.8 0 16 7.2 16 16v32 16h16 96 16V432 400c0-79.5-64.5-144-144-144H326.6l-43.3-43.3-4.7-4.7H272 240V160H368h16V128H368 240V80z'
      
    ]
  };

  

  
  

  var faArrowsMaximize = {
    prefix: 'fasl',
    iconName: 'arrows-maximize',
    icon: [
      512,
      512,
      ["expand-arrows"],
      'f31d',
      
      'M336 32H320V64h16 89.4L256 233.4 86.6 64H176h16V32H176 48 32V48 176v16H64V176 86.6L233.4 256 64 425.4V336 320H32v16V464v16H48 176h16V448H176 86.6L256 278.6 425.4 448H336 320v32h16H464h16V464 336 320H448v16 89.4L278.6 256 448 86.6V176v16h32V176 48 32H464 336z'
      
    ]
  };

  
    var faExpandArrows = faArrowsMaximize;
  

  
  

  var faCarBolt = {
    prefix: 'fasl',
    iconName: 'car-bolt',
    icon: [
      512,
      512,
      [],
      'e341',
      
      'M112 32H100.1L96.7 43.4 52.1 192H32 0v32V384v16 16 64H32V416H480v64h32V416 400 384 224 192H480 459.9L415.3 43.4 411.9 32H400 112zM384 192v32h96V384H32V224h96V192H85.5L123.9 64H388.1l38.4 128H384zM104 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm328-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM299.3 139.3L310.6 128 288 105.4l-11.3 11.3-80 80L169.4 224H208h59.1l-54.3 52.5-11.5 11.1 22.3 23 11.5-11.1 82.7-80L346.2 192H306.7h-60l52.7-52.7z'
      
    ]
  };

  

  
  

  var faPallet = {
    prefix: 'fasl',
    iconName: 'pallet',
    icon: [
      640,
      512,
      [],
      'f482',
      
      'M16 352H0v32H16 64v96H16 0v32H16 64 80 96 304h16 16H544h16 16 48 16V480H624 576V384h48 16V352H624 576 560 544 336 320 304 96 80 64 16zm80 32H304v96H96V384zm240 0H544v96H336V384z'
      
    ]
  };

  

  
  

  var faBackwardStep = {
    prefix: 'fasl',
    iconName: 'backward-step',
    icon: [
      320,
      512,
      ["step-backward"],
      'f048',
      
      'M64 80V64H32V80 240v32V432v16H64V432 294L256 426l32 22V409.2 102.8 64L256 86 64 218V80zm1.2 176L256 124.8V387.2L65.2 256z'
      
    ]
  };

  
    var faStepBackward = faBackwardStep;
  

  
  

  var faTruckTow = {
    prefix: 'fasl',
    iconName: 'truck-tow',
    icon: [
      640,
      512,
      [],
      'e2b8',
      
      'M64 32V16 0H80 96h3.8H160L384 252V112 96h16H512h7.8l4.8 6.2 112 144 3.4 4.3V256 400v16H624 576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H16 0V400 272 256H16 192L96 64V176c0 20.9-13.4 38.7-32 45.3V224H48c-26.5 0-48-21.5-48-48V160 144H32v16 16c0 8.8 7.2 16 16 16s16-7.2 16-16V32zM250.5 384H389.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H608V288H416 384 373.2 208 32v96H69.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64zM416 416a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm0-288V256H603.7L504.2 128H416zM115.8 32l112 224h117L145.6 32H115.8zM224 416A64 64 0 1 0 96 416a64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faInputNumeric = {
    prefix: 'fasl',
    iconName: 'input-numeric',
    icon: [
      640,
      512,
      [],
      'e1bd',
      
      'M608 96V416H32V96H608zM32 64H0V96 416v32H32 608h32V416 96 64H608 32zm64 96v32h16 16V320H112 96v32h16 64 16V320H176 160V176 160H144 112 96zm169.9 40c11.4-9.7 28.5-8.5 38.3 2.8c9.7 11.1 8.8 28-2 38l-73 67.4L224 313v7 16 16h16 96 16V320H336 263.6l60.3-55.6c23.6-21.8 25.6-58.4 4.4-82.6c-21.4-24.5-58.5-27.1-83.2-6l-23.5 20.1 20.8 24.3L265.9 200z'
      
    ]
  };

  

  
  

  var faClock = {
    prefix: 'fasl',
    iconName: 'clock',
    icon: [
      512,
      512,
      [128339,"clock-four"],
      'f017',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112V256v8.6l7.1 4.8 96 64 13.3 8.9 17.8-26.6-13.3-8.9L272 247.4V112 96H240v16z'
      
    ]
  };

  
    var faClockFour = faClock;
  

  
  

  var faDash = {
    prefix: 'fasl',
    iconName: 'dash',
    icon: [
      512,
      512,
      ["minus-large"],
      'e404',
      
      'M0 240H16 496h16v32H496 16 0V240z'
      
    ]
  };

  
    var faMinusLarge = faDash;
  

  
  

  var faRaindrops = {
    prefix: 'fasl',
    iconName: 'raindrops',
    icon: [
      448,
      512,
      [],
      'f75c',
      
      'M160 94.2l-27 45.1c-3.2 5.4-5 11.6-5 17.9V160c0 17.7 14.3 32 32 32s32-14.3 32-32v-2.8c0-6.3-1.7-12.5-5-17.9L160 94.2zM141.3 63.1L160 32l18.7 31.1 35.8 59.7c6.2 10.4 9.5 22.3 9.5 34.4V160c0 35.3-28.7 64-64 64s-64-28.7-64-64v-2.8c0-12.1 3.3-24 9.5-34.4l35.8-59.7zM64 286.2L37 331.3c-3.2 5.4-5 11.6-5 17.9V352c0 17.7 14.3 32 32 32s32-14.3 32-32v-2.8c0-6.3-1.7-12.5-5-17.9L64 286.2zM45.3 255.1L64 224l18.7 31.1 35.8 59.7c6.2 10.4 9.5 22.3 9.5 34.4V352c0 35.3-28.7 64-64 64s-64-28.7-64-64v-2.8c0-12.1 3.3-24 9.5-34.4l35.8-59.7zm195 46.5c-10.6 15.6-16.3 34-16.3 52.8c0 51.7 41.9 93.7 93.7 93.7h4.7c51.7 0 93.7-41.9 93.7-93.7c0-18.8-5.7-37.2-16.3-52.8L320 184.8 240.3 301.6zm-26.4-18l86.8-127.1L320 128l19.4 28.4 86.8 127.1c14.2 20.9 21.9 45.6 21.9 70.8C448 423.7 391.7 480 322.3 480h-4.7C248.3 480 192 423.7 192 354.3c0-25.3 7.6-50 21.9-70.8z'
      
    ]
  };

  

  
  

  var faArrowDownArrowUp = {
    prefix: 'fasl',
    iconName: 'arrow-down-arrow-up',
    icon: [
      576,
      512,
      ["sort-alt"],
      'f883',
      
      'M116.7 467.3L128 478.6l11.3-11.3 96-96L246.6 360 224 337.4l-11.3 11.3L144 417.4V48 32H112V48 417.4L43.3 348.7 32 337.4 9.4 360l11.3 11.3 96 96zm256-422.6l-96 96L265.4 152 288 174.6l11.3-11.3L368 94.6V464v16h32V464 94.6l68.7 68.7L480 174.6 502.6 152l-11.3-11.3-96-96L384 33.4 372.7 44.7z'
      
    ]
  };

  
    var faSortAlt = faArrowDownArrowUp;
  

  
  

  var faLightSwitchOn = {
    prefix: 'fasl',
    iconName: 'light-switch-on',
    icon: [
      384,
      512,
      [],
      'e019',
      
      'M176 48V32H32V480H176V464 448h32v16 16H352V32H208V48 64H176V48zM0 0H32 352h32V32 480v32H352 32 0V480 32 0zM96 240V128 96h32H256h32v32V240v32V384v32H256 128 96V384 272 240zm32 32V384H256V272H128zm0-32H256V128H128V240zm48-72h32 16v32H208 176 160V168h16z'
      
    ]
  };

  

  
  

  var faSquareRootVariable = {
    prefix: 'fasl',
    iconName: 'square-root-variable',
    icon: [
      576,
      512,
      ["square-root-alt"],
      'f698',
      
      'M316 32h12H560h16V64H560 340L223.4 468.4 220 480H198.4l-4.5-8.4L78.4 256H16 0V224H16 88h9.6l4.5 8.4L203.5 421.8 312.6 43.6 316 32zM532.7 395.3L480 342.6l-52.7 52.7-22.6-22.6L457.4 320l-52.7-52.7 22.6-22.6L480 297.4l52.7-52.7 22.6 22.6L502.6 320l52.7 52.7-22.6 22.6z'
      
    ]
  };

  
    var faSquareRootAlt = faSquareRootVariable;
  

  
  

  var faArrowUpFromDottedLine = {
    prefix: 'fasl',
    iconName: 'arrow-up-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e09b',
      
      'M235.3 44.7L224 33.4 212.7 44.7l-128 128L73.4 184 96 206.6l11.3-11.3L208 94.6V336v16h32V336 94.6L340.7 195.3 352 206.6 374.6 184l-11.3-11.3-128-128zM56 424H8v48H56V424zm96 0H104v48h48V424zm48 48h48V424H200v48zm144-48H296v48h48V424zm48 0v48h48V424H392z'
      
    ]
  };

  

  
  

  var faU = {
    prefix: 'fasl',
    iconName: 'u',
    icon: [
      384,
      512,
      [117],
      '55',
      
      'M32 32V48 288c0 88.4 71.6 160 160 160s160-71.6 160-160V48 32h32V48 288c0 106-86 192-192 192S0 394 0 288V48 32H32z'
      
    ]
  };

  

  
  

  var faArrowTurnUp = {
    prefix: 'fasl',
    iconName: 'arrow-turn-up',
    icon: [
      384,
      512,
      ["level-up"],
      'f148',
      
      'M16 480L0 480l0 32 16 0 176 0 16 0 0-16 0-441.4L308.7 155.3 320 166.6 342.6 144l-11.3-11.3-128-128L192-6.6 180.7 4.7l-128 128L41.4 144 64 166.6l11.3-11.3L176 54.6 176 480 16 480z'
      
    ]
  };

  
    var faLevelUp = faArrowTurnUp;
  

  
  

  var faMobileSignalOut = {
    prefix: 'fasl',
    iconName: 'mobile-signal-out',
    icon: [
      512,
      512,
      [],
      'e1f0',
      
      'M64 32H224V0H64 32V32 480v32H64 320h32V480 288H320V480H64V32zm96 368H144v32h16 64 16V400H224 160zM256 32c123.7 0 224 100.3 224 224h32C512 114.6 397.4 0 256 0V32zm32 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 0h32c0-88.4-71.6-160-160-160v32c70.7 0 128 57.3 128 128z'
      
    ]
  };

  

  
  

  var faGripVertical = {
    prefix: 'fasl',
    iconName: 'grip-vertical',
    icon: [
      320,
      512,
      [],
      'f58e',
      
      'M32 448l0-64 64 0 0 64-64 0zM0 480l32 0 64 0 32 0 0-32 0-64 0-32-32 0-64 0L0 352l0 32 0 64 0 32zm224-32l0-64 64 0 0 64-64 0zm-32 32l32 0 64 0 32 0 0-32 0-64 0-32-32 0-64 0-32 0 0 32 0 64 0 32zM32 224l64 0 0 64-64 0 0-64zM0 288l0 32 32 0 64 0 32 0 0-32 0-64 0-32-32 0-64 0L0 192l0 32 0 64zm224 0l0-64 64 0 0 64-64 0zm-32 32l32 0 64 0 32 0 0-32 0-64 0-32-32 0-64 0-32 0 0 32 0 64 0 32zM32 64l64 0 0 64-64 0 0-64zM0 128l0 32 32 0 64 0 32 0 0-32 0-64 0-32L96 32 32 32 0 32 0 64l0 64zm224 0l0-64 64 0 0 64-64 0zm-32 32l32 0 64 0 32 0 0-32 0-64 0-32-32 0-64 0-32 0 0 32 0 64 0 32z'
      
    ]
  };

  

  
  

  var faSquareD = {
    prefix: 'fasl',
    iconName: 'square-d',
    icon: [
      448,
      512,
      [],
      'e268',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm144 96h80c70.7 0 128 57.3 128 128s-57.3 128-128 128H144 128V368 144 128h16zm16 224h64c53 0 96-43 96-96s-43-96-96-96H160V352z'
      
    ]
  };

  

  
  

  var faAxe = {
    prefix: 'fasl',
    iconName: 'axe',
    icon: [
      640,
      512,
      [129683],
      'f6b2',
      
      'M64 512L41.4 489.4 22.6 470.6 0 448l22.6-22.6L249.4 198.6 272 221.3 45.3 448 64 466.7 290.7 240l22.6 22.6L86.6 489.4 64 512zM489.4 86.6L464 112l48 48h96 32v32c0 123.7-100.3 224-224 224H384V384 288L246.6 150.6 224 128l22.6-22.6 82.7-82.7L352 0l22.6 22.6L400 48l25.4-25.4L448 0l22.6 22.6 18.7 18.7L512 64 489.4 86.6zm-66.7-16l18.7 18.7L466.7 64 448 45.3 422.6 70.6zM512 192H498.7l-9.4-9.4L352 45.3 269.3 128 406.6 265.4l9.4 9.4V288v96c106 0 192-86 192-192H512z'
      
    ]
  };

  

  
  

  var faChessClock = {
    prefix: 'fasl',
    iconName: 'chess-clock',
    icon: [
      640,
      512,
      [],
      'f43d',
      
      'M240 32h16V64H240 192v64H608h32v32V448v32H608 32 0V448 160 128H32 160V64H112 96V32h16 64 64zM544 64V96H528 400 384V64h16H528h16zM32 160V448H608V160H32zM176 384a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM520.6 360.6A80 80 0 1 0 407.4 247.4 80 80 0 1 0 520.6 360.6zM384.8 224.8A112 112 0 1 1 543.2 383.2 112 112 0 1 1 384.8 224.8zM160 240h32v16 48 16H160V304 256 240zm349.3 41.4l-33.9 33.9L464 326.6 441.4 304l11.3-11.3 33.9-33.9 11.3-11.3 22.6 22.6-11.3 11.3z'
      
    ]
  };

  

  
  

  var faPeapod = {
    prefix: 'fasl',
    iconName: 'peapod',
    icon: [
      512,
      512,
      [],
      'e31c',
      
      'M416 32C203.9 32 32 203.9 32 416v64H96c212.1 0 384-171.9 384-384V32H416zm0-32h64 32V32 96c0 229.8-186.2 416-416 416H32 0V480 416C0 186.2 186.2 0 416 0zM368 112a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zM224 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM112 368a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128z'
      
    ]
  };

  

  
  

  var faShareAll = {
    prefix: 'fasl',
    iconName: 'share-all',
    icon: [
      576,
      512,
      [],
      'f367',
      
      'M373.2 65.8L361.4 55 383 31.4l11.8 10.8 168 154L575.7 208l-12.9 11.8-168 154L383 384.6 361.4 361l11.8-10.8L528.3 208 373.2 65.8zM128 480s-27-10.1-56.2-33.4C37.5 419.1 0 373.2 0 304c0-97.2 78.8-176 176-176h48 32V96 64 32h32L456.3 186.3 480 208l-23.7 21.7L288 384H256V352 320 288H224 208c-61.9 0-112 50.1-112 112c0 9.9 1.3 19 3.5 27.4C107.8 459.8 128 480 128 480zM32 304c0 38.2 13.9 67.8 32.1 90.3C67.1 317.4 130.4 256 208 256h48 32v32 52.6L432.6 208 288 75.4V128v32H256 176C96.5 160 32 224.5 32 304z'
      
    ]
  };

  

  
  

  var faDisplayMedical = {
    prefix: 'fasl',
    iconName: 'display-medical',
    icon: [
      576,
      512,
      ["desktop-medical"],
      'e166',
      
      'M544 32V384H344.3c-.2 0-.4 0-.6 0H232.3c-.2 0-.4 0-.6 0H32V32H544zM32 416H213.1l-10.7 64H144 128v32h16 72H360h72 16V480H432 373.6l-10.7-64H544h32V384 32 0H544 32 0V32 384v32H32zm202.9 64l10.7-64h84.9l10.7 64H234.9zM256 96H240v16 48H192 176v16 64 16h16 48v48 16h16 64 16V304 256h48 16V240 176 160H384 336V112 96H320 256zm16 80V128h32v48 16h16 48v32H320 304v16 48H272V240 224H256 208V192h48 16V176z'
      
    ]
  };

  
    var faDesktopMedical = faDisplayMedical;
  

  
  

  var faFolderMusic = {
    prefix: 'fasl',
    iconName: 'folder-music',
    icon: [
      512,
      512,
      [],
      'e18d',
      
      'M32 32H224l48 64H480h32v32V448v32H480 32 0V448 64 32H32zm240 96H256l-9.6-12.8L208 64H32V448H480V128H272zm80 64V336c0 .5 0 1-.1 1.5c0 .8 .1 1.6 .1 2.5c0 24.3-21.5 44-48 44s-48-19.7-48-44s21.5-44 48-44c5.6 0 11 .9 16 2.5V215.1l-96 36V368c0 .5 0 1-.1 1.5c0 .8 .1 1.6 .1 2.5c0 24.3-21.5 44-48 44s-48-19.7-48-44s21.5-44 48-44c5.6 0 11 .9 16 2.5V240 228.9l10.4-3.9 128-48 21.6-8.1V192zM192 372c0-4.1-4.5-12-16-12s-16 7.9-16 12s4.5 12 16 12s16-7.9 16-12zm112-20c11.5 0 16-7.9 16-12s-4.5-12-16-12s-16 7.9-16 12s4.5 12 16 12z'
      
    ]
  };

  

  
  

  var faHexagonVerticalNftSlanted = {
    prefix: 'fasl',
    iconName: 'hexagon-vertical-nft-slanted',
    icon: [
      448,
      512,
      [],
      'e506',
      
      'M416 365.4V146.6L224 36.9 32 146.6V365.4L224 475.1 416 365.4zM0 128L224 0 448 128V384L224 512 0 384V128zM192 92l31.8-18.2L272 101.4v36.9l-48-27.5V240h32 16v32H256 224V432v6.3L192 420V256 92zM320 383.4V165.8L296 152V115.1l47.9 27.4 0 0L384 165.4v36.8L352 184V365.1l-32 18.3zM160 384v17.7L127.2 383 96 266.1V360v5.1L64 346.9V165.1l33.1-18.9L128 261.9V128.6l32-18.3V112 381.9 384z'
      
    ]
  };

  

  
  

  var faTabletScreen = {
    prefix: 'fasl',
    iconName: 'tablet-screen',
    icon: [
      448,
      512,
      ["tablet-android-alt"],
      'f3fc',
      
      'M416 32V320H32V32H416zm0 320V480H32V352H416zM32 0H0V32 480v32H32 416h32V480 32 0H416 32zM176 400v32h16 64 16V400H256 192 176z'
      
    ]
  };

  
    var faTabletAndroidAlt = faTabletScreen;
  

  
  

  var faToiletPaperBlank = {
    prefix: 'fasl',
    iconName: 'toilet-paper-blank',
    icon: [
      640,
      512,
      ["toilet-paper-alt"],
      'f71f',
      
      'M21.3 480l5.1-12.2C60.1 382.6 64 281.9 64 192C64 86 107 0 160 0H492.2l0 .1c1.3-.1 2.5-.1 3.8-.1c40.7 0 69 32.2 85.2 64.6C598.3 98.8 608 143.9 608 192s-9.7 93.2-26.8 127.4C565 351.8 536.7 384 496 384c-22.7 0-41.5-10-56.6-24.5c2-15.3 3.5-30.6 4.7-45.8c14 23.8 32.1 38.2 51.9 38.2c44.2 0 80-71.6 80-160s-35.8-160-80-160c-3.3 0-6.5 .4-9.7 1.2C446.7 42.8 416 110.2 416 192c0 41.3-.8 85-4.6 128.6c-5.2 59.4-15.9 118.6-37.9 171.6L365.3 512H42.7 8l13.3-32zM384 192c0-48.1 9.7-93.2 26.8-127.4c5.7-11.3 12.8-22.6 21.5-32.6H160c-7.9 0-23.6 7.2-39.3 38.5C106 100 96 142.9 96 192c0 89.8-3.6 196.2-39.8 287.6L56 480H344l0 0c35.4-85.5 40-190.3 40-288zm97.5 20.4c2.6 16.3 8.1 27.6 14.5 27.6s11.9-11.3 14.5-27.6c1-6.2 1.5-13.1 1.5-20.4s-.5-14.2-1.5-20.4c-2.6-16.3-8.1-27.6-14.5-27.6s-11.9 11.3-14.5 27.6c-1 6.2-1.5 13.1-1.5 20.4s.5 14.2 1.5 20.4zM527.4 256c-4.8 6.1-15.1 16-31.4 16s-26.6-9.9-31.4-16c-5.1-6.4-8.2-13.8-10.3-20c-4.2-12.7-6.3-28.3-6.3-44.1s2.1-31.3 6.3-44.1c2.1-6.2 5.2-13.5 10.3-20c4.8-6.1 15.1-16 31.4-16s26.6 9.9 31.4 16c5.1 6.4 8.2 13.8 10.3 20c4.2 12.7 6.3 28.3 6.3 44.1s-2.1 31.3-6.3 44.1c-2.1 6.2-5.2 13.5-10.3 20z'
      
    ]
  };

  
    var faToiletPaperAlt = faToiletPaperBlank;
  

  
  

  var faFolderXmark = {
    prefix: 'fasl',
    iconName: 'folder-xmark',
    icon: [
      512,
      512,
      ["folder-times"],
      'f65f',
      
      'M32 32H224l48 64H480h32v32V448v32H480 32 0V448 64 32H32zm240 96H256l-9.6-12.8L208 64H32V448H480V128H272zm-80.6 72.8l11.3 11.3L256 265.4l53.3-53.3 11.3-11.3 22.6 22.6-11.3 11.3L278.6 288l53.3 53.3 11.3 11.3-22.6 22.6-11.3-11.3L256 310.6l-53.3 53.3-11.3 11.3-22.6-22.6 11.3-11.3L233.4 288l-53.3-53.3-11.3-11.3 22.6-22.6z'
      
    ]
  };

  
    var faFolderTimes = faFolderXmark;
  

  
  

  var faFilmCanister = {
    prefix: 'fasl',
    iconName: 'film-canister',
    icon: [
      576,
      512,
      ["film-cannister"],
      'f8b7',
      
      'M112 0H96V32h16H240h16V0H240 112zM16 64H0V96H16 32V480H16 0v32H16 48 304h32 16V480H336 320V96h16 16V64H336 304 48 16zM64 480V96H288V480H64zM384 192v32h32V192H384zm32 160H384v32h32V352zm64-160v32h32V192H480zM352 160H544V320H496 480v16 80H352v32H496h16V432 352h48 16V336 144 128H560 352v32z'
      
    ]
  };

  
    var faFilmCannister = faFilmCanister;
  

  
  

  var faSplit = {
    prefix: 'fasl',
    iconName: 'split',
    icon: [
      512,
      512,
      [],
      'e254',
      
      'M416 33.4l11.3 11.3L494.6 112H496v1.4l3.3 3.3L510.6 128l-11.3 11.3-3.3 3.3V144h-1.4l-67.3 67.3L416 222.6 393.4 200l11.3-11.3L449.4 144H400 326.6l-112 112 112 112H400h49.4l-44.7-44.7L393.4 312 416 289.4l11.3 11.3L494.6 368H496v1.4l3.3 3.3L510.6 384l-11.3 11.3-3.3 3.3V400h-1.4l-67.3 67.3L416 478.6 393.4 456l11.3-11.3L449.4 400H400 320h-6.6l-4.7-4.7L185.4 272H48 32 16 0V240H16 32 48 185.4L308.7 116.7l4.7-4.7H320h80 49.4L404.7 67.3 393.4 56 416 33.4z'
      
    ]
  };

  

  
  

  var faWaveformLines = {
    prefix: 'fasl',
    iconName: 'waveform-lines',
    icon: [
      640,
      512,
      ["waveform-path"],
      'f8f2',
      
      'M336 0V16 496v16H304V496 16 0h32zM528 64V80 432v16H496V432 80 64h32zM240 96v16V400v16H208V400 112 96h32zm192 32v16V368v16H400V368 144 128h32zM144 192v16 96 16H112V304 208 192h32zM48 224v16 32 16H16V272 240 224H48zm576 0v16 32 16H592V272 240 224h32z'
      
    ]
  };

  
    var faWaveformPath = faWaveformLines;
  

  
  

  var faWaterArrowUp = {
    prefix: 'fasl',
    iconName: 'water-arrow-up',
    icon: [
      576,
      512,
      ["water-rise"],
      'f775',
      
      'M304 240V224 62.6l52.7 52.7L368 126.6 390.6 104 379.3 92.7l-80-80L288 1.4 276.7 12.7l-80 80L185.4 104 208 126.6l11.3-11.3L272 62.6V224v16h32zM133.8 458.8c-14.6-10-26-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C41.7 470.1 20.9 480 0 480v32c30.3 0 57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C518.5 497.9 545.7 512 576 512V480c-20.9 0-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C425.6 470.1 404.9 480 384 480s-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C233.6 470.1 212.9 480 192 480s-41.7-9.9-58.2-21.2zM192 352c-20.9 0-41.7-9.9-58.2-21.2c-14.6-10-26-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C41.7 342.1 20.9 352 0 352v32c30.3 0 57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 369.9 161.7 384 192 384s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 369.9 353.7 384 384 384s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C518.5 369.9 545.7 384 576 384V352c-20.9 0-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C425.6 342.1 404.9 352 384 352s-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C233.6 342.1 212.9 352 192 352z'
      
    ]
  };

  
    var faWaterRise = faWaterArrowUp;
  

  
  

  var faPlaceOfWorship = {
    prefix: 'fasl',
    iconName: 'place-of-worship',
    icon: [
      640,
      512,
      [],
      'f67f',
      
      'M224 176l-64 48V480H128 32V354.1l96-57.6V259.2L0 336V480v32H32 160v0h32 64 32 64 32 64 32v0H608h32V480 336L512 259.2v37.3l96 57.6V480H512 480V224l-64-48V96L342.6 22.6 320 0 297.4 22.6 224 96v80zM448 480H384V384c0-35.3-28.7-64-64-64s-64 28.7-64 64v96H192V240l51.2-38.4L256 192V176 109.3l64-64 64 64V176v16l12.8 9.6L448 240V480zm-96 0H288V384c0-17.7 14.3-32 32-32s32 14.3 32 32v96z'
      
    ]
  };

  

  
  

  var faPersonSkiJumping = {
    prefix: 'fasl',
    iconName: 'person-ski-jumping',
    icon: [
      512,
      512,
      ["ski-jump"],
      'f7c7',
      
      'M432 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 352 56zM112 96h16H288h16 6.6l4.7 4.7 32 32 4.7 4.7V144v16 10.6l-9.8 4.1L207 231.5c-1.6 2.4-3 4.9-4.2 7.5L142.6 374.5l-6.5 14.6-29.2-13 6.5-14.6 60.2-135.4c3.2-7.1 7.3-13.7 12.4-19.6L253.2 128H128 112V96zm183.4 32l-42.5 49.6 66.2-27.8L297.4 128h-2zM512 176v16 56 9.7l-8.7 4.5-480 248L8.7 481.8 480 238.3V192 176h32z'
      
    ]
  };

  
    var faSkiJump = faPersonSkiJumping;
  

  
  

  var faPlugCirclePlus = {
    prefix: 'fasl',
    iconName: 'plug-circle-plus',
    icon: [
      576,
      512,
      [],
      'e55f',
      
      'M128 0V16v96H96V16 0h32zM288 0V16v96H256V16 0h32zM0 144H16 32 64 320h32 16 16v32H368 352v35.2c-11.4 5.9-22.2 12.9-32 21V176H64v64c0 70.7 57.3 128 128 128c23.7 0 45.8-6.4 64.9-17.6c-.6 5.8-.9 11.7-.9 17.6c0 6.2 .3 12.3 .9 18.3c-15.2 6.8-31.7 11.2-48.9 12.9V496v16H176V496 399.2C95.1 391.2 32 323 32 240V176H16 0V144zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-224H416v16 48H368l-16 0v32l16 0h48v48l0 16h32l0-16V384h48 16V352H496 448V304 288z'
      
    ]
  };

  

  
  

  var faCircle7 = {
    prefix: 'fasl',
    iconName: 'circle-7',
    icon: [
      512,
      512,
      [],
      'e0f4',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-364.1V128H336 176 160v32h16H309.8L194.6 384h36L350.2 151.3l1.8-3.4z'
      
    ]
  };

  

  
  

  var faScannerTouchscreen = {
    prefix: 'fasl',
    iconName: 'scanner-touchscreen',
    icon: [
      512,
      512,
      [],
      'f48a',
      
      'M128 0V64h32V0H128zM320 0V64h32V0H320zM224 0H192V64h32V0zM400 0V288h32V0H400zM512 0H480V288h32V0zM320 128V480H32V128H320zM32 96H0v32V480v32H32 320h32V480 128 96H320 32zm64 96H256V416H96V192zM64 160v32V416v32H96 256h32V416 192 160H256 96 64z'
      
    ]
  };

  

  
  

  var faWaterArrowDown = {
    prefix: 'fasl',
    iconName: 'water-arrow-down',
    icon: [
      576,
      512,
      ["water-lower"],
      'f774',
      
      'M304 0V16 185.4l52.7-52.7L368 121.4 390.6 144l-11.3 11.3-80 80L288 246.6l-11.3-11.3-80-80L185.4 144 208 121.4l11.3 11.3L272 185.4V16 0h32zM133.8 458.8C150.3 470.1 171.1 480 192 480s41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C342.3 470.1 363.1 480 384 480s41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C534.4 470.1 555.1 480 576 480v32c-30.3 0-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.9 9.9-19.8 15.3C441.5 497.9 414.3 512 384 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 497.9 222.3 512 192 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.8-19.8 15.3C57.6 497.9 30.3 512 0 512V480c20.9 0 41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.7 23.2 24.3 37.8 34.2zM192 352c20.9 0 41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C342.3 342.1 363.1 352 384 352s41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C534.4 342.1 555.1 352 576 352v32c-30.3 0-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.9 9.9-19.8 15.3C441.5 369.9 414.3 384 384 384s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 369.9 222.3 384 192 384s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.8-19.8 15.3C57.6 369.9 30.3 384 0 384V352c20.9 0 41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.7 23.2 24.3 37.8 34.2C150.3 342.1 171.1 352 192 352z'
      
    ]
  };

  
    var faWaterLower = faWaterArrowDown;
  

  
  

  var faFaceSwear = {
    prefix: 'fasl',
    iconName: 'face-swear',
    icon: [
      640,
      512,
      [],
      'e399',
      
      'M534.7 192C507.2 99.5 421.5 32 320 32S132.8 99.5 105.3 192H72.1C100.5 81.6 200.7 0 320 0S539.5 81.6 567.9 192H534.7zM264.4 176c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-8.1 4-15.3 10.2-19.6l-39.6-13.2-15.2-5.1 10.1-30.4 15.2 5.1 96 32 15.2 5.1-10.1 30.4-15.2-5.1-19.7-6.6c.8 2.3 1.2 4.8 1.2 7.4zm136 24c-13.3 0-24-10.7-24-24c0-2.7 .4-5.3 1.3-7.7l-20.6 6.9-15.2 5.1-10.1-30.4 15.2-5.1 96-32 15.2-5.1 10.1 30.4-15.2 5.1-39.1 13c6.3 4.3 10.4 11.6 10.4 19.8c0 13.3-10.7 24-24 24zM32 256V480H608V256H32zM0 224H32 608h32v32V480v32H608 32 0V480 256 224zM400 352H384v32h16 16v32H400 384v16 16H352V432 416H320v16 16H288V432 416H272 256V384h16 16V352H272 256V320h16 16V304 288h32v16 16h32V304 288h32v16 16h16 16v32H400zm-80 0v32h32V352H320zm128-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm124.1 2.4l-96 112-24.3-20.8 96-112 24.3 20.8zM552 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 288v16 64 16H192V368 304 288h32zM184 424a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM128 304v1.8c4.6 .8 8.7 1.7 12.1 2.6l15.5 4.1-8.2 30.9-15.5-4.1c-7.9-2.1-18.5-3.9-26.8-2.9c-4.1 .5-6.3 1.4-7.4 2.2c-.6 .4-1.2 .9-1.5 2.9c-.2 1-.1 1.6-.1 1.8c.1 .1 .5 .6 1.5 1.3c3.7 2.5 9.6 4.4 19.2 7.3l.7 .2c8 2.4 19.1 5.8 27.6 11.9c4.7 3.4 9.3 8.2 12.1 14.7c2.9 6.6 3.4 13.8 2.2 21.1c-2 11.5-7.9 20.5-17 25.9c-4.9 3-10.1 4.6-15.3 5.4v.8 16h-32V432v-3c-8.1-1.9-15.3-4.2-20.2-5.9l-15.2-5.1 10.1-30.4 15.2 5.1c9.5 3.2 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5l0 0c.5-.3 1.4-.9 2-4c.2-1.2 .2-1.9 .2-2.3c0-.4-.1-.6-.1-.6l0 0c0-.1-.3-.6-1.6-1.6c-3.5-2.5-9.3-4.6-18.7-7.4L106 382l0 0c-7.7-2.3-18.3-5.5-26.4-11c-4.7-3.2-9.4-7.7-12.4-14.1c-3.1-6.5-3.7-13.7-2.5-20.9c1.8-10.2 7-18.1 14.5-23.5c5.3-3.8 11.2-5.9 16.9-7V304 288h32v16zM96.1 343.4s0 0 0-.1l0 .1c0 0 0 0 0 0z'
      
    ]
  };

  

  
  

  var faRadioTuner = {
    prefix: 'fasl',
    iconName: 'radio-tuner',
    icon: [
      512,
      512,
      ["radio-alt"],
      'f8d8',
      
      'M32 160v64H480V160H32zM0 240V160 136v-8-4.5l12.1-3 480-120 7.8 31L114 128H480h32v32V480v32H480 32 0V480 240zM32 480H480V256H32V480zM80 320H208h16v32H208 80 64V320H80zm16 64h96 16v32H192 96 80V384H96zm272-64a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm80 48a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z'
      
    ]
  };

  
    var faRadioAlt = faRadioTuner;
  

  
  

  var faFaceSmilePlus = {
    prefix: 'fasl',
    iconName: 'face-smile-plus',
    icon: [
      640,
      512,
      ["smile-plus"],
      'f5b9',
      
      'M560 16V80h64 16v32H624 560v64 16H528V176 112H464 448V80h16 64V16 0h32V16zM416 288A192 192 0 1 0 32 288a192 192 0 1 0 384 0zM0 288a224 224 0 1 1 448 0A224 224 0 1 1 0 288zm144.4-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM97.1 341.9l29.7-11.9c4.5 11.2 15.1 29.1 31.8 44C175.1 388.7 196.8 400 224 400s48.9-11.3 65.3-25.9c16.7-14.9 27.3-32.8 31.8-44l29.7 11.9c-6.2 15.4-19.5 37.5-40.2 56C289.8 416.6 260.8 432 224 432s-65.8-15.4-86.7-34.1c-20.7-18.5-34-40.6-40.2-56z'
      
    ]
  };

  
    var faSmilePlus = faFaceSmilePlus;
  

  
  

  var faMoped = {
    prefix: 'fasl',
    iconName: 'moped',
    icon: [
      640,
      512,
      [],
      'e3b9',
      
      'M336 32h16 64 11.5l3.6 10.9 12.5 37.4 61.2-30.6 3.4-1.7H512h16 16V64v96 16H528 512h-3.8l-3.4-1.7L469 156.4 494.5 233c5.7-.7 11.6-1 17.5-1c41.5 0 79.1 16.6 106.5 43.5l-22.4 22.8C574.4 277.1 544.7 264 512 264c-56.5 0-104 39.1-116.7 91.8c-2.2 9-3.3 18.5-3.3 28.2H368h-8H256c0 53-43 96-96 96s-96-43-96-96H32 0V352 320c0-70.7 57.3-128 128-128h96 32v32 96 32h32 64 11.4c.3-1.3 .6-2.5 .9-3.8c12.2-50.8 50-91.6 98.9-108.2L404.5 64H352 336V32zm118.9 82.2l.2-.5L512 142.1V81.9l-56.8 28.4-1.3 .7 1.1 3.2zM256 128v32H96V128H256zM224 352V224H128c-53 0-96 43-96 96v32H69.5h35.1H215.4 224zm-64 96c35.3 0 64-28.7 64-64H96c0 35.3 28.7 64 64 64zm352 0a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
      
    ]
  };

  

  
  

  var faTemperatureSnow = {
    prefix: 'fasl',
    iconName: 'temperature-snow',
    icon: [
      576,
      512,
      ["temperature-frigid"],
      'f768',
      
      'M357.3 284.5L368 275V260.7 32H496V260.7 275l10.7 9.5c23 20.6 37.3 50.3 37.3 83.5c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-33.2 14.4-62.9 37.3-83.5zM528 0H496 368 336V32 260.7c-29.5 26.4-48 64.7-48 107.3c0 79.5 64.5 144 144 144s144-64.5 144-144c0-42.6-18.5-81-48-107.3V32 0zM400 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V272 256H416v16 34c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64zM284.6 142.8l7.6-28.3 4.1-15.5-30.9-8.3-4.1 15.5-15.9 59.2L192 196.3V134.6l43.3-43.3L246.6 80 224 57.4 212.7 68.7 192 89.4V48 32H160V48 89.4L139.3 68.7 128 57.4 105.4 80l11.3 11.3L160 134.6v61.7l-53.4-30.8L90.7 106.3 86.6 90.8 55.7 99.1l4.1 15.5 7.6 28.3L31.6 122.1l-13.9-8-16 27.7 13.9 8 35.8 20.7-28.3 7.6L7.7 182.3 16 213.2 31.4 209l59.2-15.9L144 224 90.6 254.8 31.4 239 16 234.8 7.7 265.7l15.5 4.1 28.3 7.6L15.6 298.1l-13.9 8 16 27.7 13.9-8 35.8-20.7-7.6 28.3-4.1 15.5 30.9 8.3 4.1-15.5 15.9-59.2L160 251.7v61.7l-43.3 43.3L105.4 368 128 390.6l11.3-11.3L160 358.6V400v16h32V400 358.6l20.7 20.7L224 390.6 246.6 368l-11.3-11.3L192 313.4V251.7l53.4 30.8 13.8 51.7c6.5-33.3 22.4-63.3 44.8-87v-3.8l-42.6 11.4L208 224l53.4-30.8L304 204.6V171.5l-3.4-.9 3.4-2v-37l-19.4 11.2z'
      
    ]
  };

  
    var faTemperatureFrigid = faTemperatureSnow;
  

  
  

  var faTabletRugged = {
    prefix: 'fasl',
    iconName: 'tablet-rugged',
    icon: [
      448,
      512,
      [],
      'f48f',
      
      'M48 0H32V16 46.1L8.8 57.7 0 62.1V72v80 9.9l8.8 4.4L32 177.9v12.2L8.8 201.7 0 206.1V216v80 9.9l8.8 4.4L32 321.9v12.2L8.8 345.7 0 350.1V360v80 9.9l8.8 4.4L32 465.9V496v16H48 400h16V496 465.9l23.2-11.6 8.8-4.4V440 360v-9.9l-8.8-4.4L416 334.1V321.9l23.2-11.6 8.8-4.4V296 216v-9.9l-8.8-4.4L416 190.1V177.9l23.2-11.6 8.8-4.4V152 72 62.1l-8.8-4.4L416 46.1V16 0H400 48zM64 56V32H384V56v9.9l8.8 4.4L416 81.9v60.2l-23.2 11.6-8.8 4.4V168v32 9.9l8.8 4.4L416 225.9v60.2l-23.2 11.6-8.8 4.4V312v32 9.9l8.8 4.4L416 369.9v60.2l-23.2 11.6-8.8 4.4V456v24H64V456v-9.9l-8.8-4.4L32 430.1V369.9l23.2-11.6 8.8-4.4V344 312v-9.9l-8.8-4.4L32 286.1V225.9l23.2-11.6 8.8-4.4V200 168v-9.9l-8.8-4.4L32 142.1V81.9L55.2 70.3 64 65.9V56zm64 40H320V416H128V96zM96 64V96 416v32h32H320h32V416 96 64H320 128 96z'
      
    ]
  };

  

  
  

  var faDistributeSpacingHorizontal = {
    prefix: 'fasl',
    iconName: 'distribute-spacing-horizontal',
    icon: [
      512,
      512,
      [],
      'e365',
      
      'M480 0L448 0l0 512 32 0L480 0zM320 384l-128 0 0-256 128 0 0 256zm32-256l0-32-32 0L192 96l-32 0 0 32 0 256 0 32 32 0 128 0 32 0 0-32 0-256zM64 512L64 0 32 0l0 512 32 0z'
      
    ]
  };

  

  
  

  var faEyeDropperFull = {
    prefix: 'fasl',
    iconName: 'eye-dropper-full',
    icon: [
      512,
      512,
      [],
      'e172',
      
      'M198.1 172.7l22.6 22.6 95.9 95.9 22.6 22.6 6.1 6.1 11.3 11.3L368 342.6 390.6 320l-6.1-6.1-5.2-5.2L368 297.4l-6.1-6.1 22.6-22.6 98.3-98.3c39-39 39-102.2 0-141.1s-102.2-39-141.1 0l-98.3 98.3-22.6 22.6-6.1-6.1-11.3-11.3-5.2-5.2-6.1-6.1L169.4 144l11.3 11.3L192 166.6l6.1 6.1zm262-25L339.3 268.6l-95.9-95.9L364.2 51.9c26.5-26.5 69.4-26.5 95.9 0s26.5 69.4 0 95.9zM58.6 441.8l5.4-8.1V424 357.3L178.1 243.2l90.7 90.7L154.7 448H88 78.3l-8.1 5.4L44.1 470.8l-2.9-2.9 17.4-26.2zm96.8-221.2L32 344v80L0 472l40 40 48-32h80L291.4 356.6l22.6-22.6-22.6-22.6-90.7-90.7-22.6-22.6-22.6 22.6z'
      
    ]
  };

  

  
  

  var faVials = {
    prefix: 'fasl',
    iconName: 'vials',
    icon: [
      512,
      512,
      [],
      'f493',
      
      'M16 32H0V64H16 32V272 400c0 44.2 35.8 80 80 80s80-35.8 80-80V272 64h16 16V32H208 176 48 16zM64 256V64h96V256H64zm0 32h96V400c0 26.5-21.5 48-48 48s-48-21.5-48-48V288zM304 32H288V64h16 16V272 400c0 44.2 35.8 80 80 80s80-35.8 80-80V272 64h16 16V32H496 464 336 304zm48 224V64h96V256H352zm0 32h96V400c0 26.5-21.5 48-48 48s-48-21.5-48-48V288z'
      
    ]
  };

  

  
  

  var faShieldPlus = {
    prefix: 'fasl',
    iconName: 'shield-plus',
    icon: [
      512,
      512,
      [],
      'e24a',
      
      'M48.5 114.9L256 34.3l207.5 80.5c2.7 45.6-4.5 116.8-34.7 186.3S345.4 438.4 256 477.1C166.6 438.4 113.4 370.7 83.2 301.2S45.8 160.5 48.5 114.9zm447-1.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM272 160H240v16 64H176 160v32h16 64v64 16h32V336 272h64 16V240H336 272V176 160z'
      
    ]
  };

  

  
  

  var faBookFont = {
    prefix: 'fasl',
    iconName: 'book-font',
    icon: [
      448,
      512,
      [],
      'e0bf',
      
      'M0 64C0 28.7 28.7 0 64 0H432h16V16 400v16H432 416v64h16 16v32H432 64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H416V32H64C46.3 32 32 46.3 32 64l0 328.6zM249.9 96l4.4 8.8L361.9 320H326.1l-32-64H185.9l-32 64H118.1L225.7 104.8l4.4-8.8h19.8zm-48 128h76.2L240 147.8 201.9 224z'
      
    ]
  };

  

  
  

  var faCartShopping = {
    prefix: 'fasl',
    iconName: 'cart-shopping',
    icon: [
      576,
      512,
      [128722,"shopping-cart"],
      'f07a',
      
      'M16 0H0V32H16 67.2l77.2 339.5 2.8 12.5H160 496h16V352H496 172.8l-14.5-64H496L566 64l10-32H542.5 100L95.6 12.5 92.8 0H80 16zm91.3 64H532.5l-60 192H151L107.3 64zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm248-56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z'
      
    ]
  };

  
    var faShoppingCart = faCartShopping;
  

  
  

  var faCarGarage = {
    prefix: 'fasl',
    iconName: 'car-garage',
    icon: [
      640,
      512,
      [],
      'f5e2',
      
      'M328.5 10.5L320 5.1l-8.5 5.4-304 192 17.1 27.1L320 42.9 615.5 229.5l17.1-27.1-304-192zM203.9 176l-3.3 11.6L171.9 288H160 128v32 96 16 32 48h32V464H480v48h32V464 432 416 320 288H480 468.1L439.4 187.6 436.1 176H424 216 203.9zM480 320v96 16H160V416 320H480zM411.9 208l22.9 80H205.2l22.9-80H411.9zM208 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faPersonMilitaryRifle = {
    prefix: 'fasl',
    iconName: 'person-military-rifle',
    icon: [
      512,
      512,
      [],
      'e54b',
      
      'M192 64v0H320v0V37.8L192 59.1V64zM352 96H334.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16H160V64 32L320 5.3 352 0V32.4 64 96zM210.7 96c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H210.7zM158.1 224H160h8 24H312.2l35.5-61.4 16-27.7 27.7 16 16-27.7 16-27.7 16-27.7-13.9-8 16-27.7 13.9 8 13.9 8 13.9 8-8 13.9-8 13.9-32 55.4-16 27.7 27.7 16-16 27.7L386 288.2l84.3 168.6 7.2 14.3-28.6 14.3-7.2-14.3L352 291.8V480v32H320 192 160V480 291.8L70.3 471.2l-7.2 14.3L34.5 471.2l7.2-14.3 112-224 4.4-8.8zm210.7 29.9l34.3-59.4-27.7-16L349.2 224H352h1.9l4.4 8.8 10.5 21.1zM320 447.8V256H210.4L320 447.8zM192 288.3V480H301.6L192 288.3zm96-.3a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faFlagSwallowtail = {
    prefix: 'fasl',
    iconName: 'flag-swallowtail',
    icon: [
      448,
      512,
      ["flag-alt"],
      'f74c',
      
      'M32 16V0H0V16 32 64 320v32V496v16H32V496 352H410.7 448l-19.2-32L352 192 428.8 64 448 32H410.7 32V16zm0 48H391.5L324.6 175.5 314.7 192l9.9 16.5L391.5 320H32V64z'
      
    ]
  };

  
    var faFlagAlt = faFlagSwallowtail;
  

  
  

  var faStarOfDavid = {
    prefix: 'fasl',
    iconName: 'star-of-david',
    icon: [
      512,
      512,
      [10017],
      'f69a',
      
      'M476 352l20 32H458.3 336l-61.1 97.8L256 512l-18.9-30.2L176 384H53.7 16l20-32 60-96L36 160 16 128H53.7 176l61.1-97.8L256 0l18.9 30.2L336 128H458.3 496l-20 32-60 96 60 96zM397.1 225.8L438.3 160H356l41.1 65.8zM318.3 160H193.7l-60 96 60 96H318.3l60-96-60-96zm-20-32L256 60.4 213.7 128h84.5zM156 160H73.7l41.1 65.8L156 160zM114.9 286.2L73.7 352H156l-41.1-65.8zM356 352h82.3l-41.1-65.8L356 352zM213.7 384L256 451.6 298.3 384H213.7z'
      
    ]
  };

  

  
  

  var faMosquito = {
    prefix: 'fasl',
    iconName: 'mosquito',
    icon: [
      640,
      512,
      [],
      'e52b',
      
      'M221.4 81.8L179.5 26.1l25-19.8 48 63.9 6.1 8.2L254 87.5l-26.7 53.2L272 185.4v-9.5l0-48 40 0V63.8v-8h16v8 64.1l40 0 0 48v9.5l44.6-44.7L386 87.5l-4.6-9.2 6.1-8.2 48-63.9 25 19.8L418.6 81.8 446 136.5l5.3 10.7-8.4 8.4-45.1 45.1 162.7 25.5c45.3 5.9 79.4 46.3 79.4 94.2c0 84.5-97.6 126.9-154.6 67.1L368 280.4v23.9L412 357l3.8 4.6v6 58.3l44.7 59.5-25 19.8-48-63.9-3.3-4.4v-5.5l0-57.9L368 354.1v45.4 48H272v-48V354.1l-16.2 19.4v57.9 5.5l-3.3 4.4-48 63.9-25-19.8 44.7-59.5V367.5v-6L228 357l44-52.7V280.4L154.6 387.4C97.6 447.2 0 404.9 0 320.3c0-47.9 34-88.2 79.3-94.2l162.8-25.5L197 155.6l-8.4-8.4 5.3-10.7 27.4-54.7zm48.7 146.9L84.3 257.8c-.3 0-.5 .1-.8 .1C55.2 261.6 32 287.4 32 320.3c0 58.9 64.6 81.6 99.5 45c.5-.5 1-1 1.6-1.5L272 237.1l0-6.4-1.9-1.9zm97.9 1.9l0 6.4L506.9 363.8c.5 .5 1.1 1 1.6 1.5c34.9 36.6 99.5 13.9 99.5-45c0-32.9-23.2-58.7-51.5-62.4c-.3 0-.5-.1-.8-.1L369.9 228.7l-1.9 1.9zM304 399.5v16h32v-16l0-223.6 0-16-32 0 0 16 0 223.6z'
      
    ]
  };

  

  
  

  var faDuck = {
    prefix: 'fasl',
    iconName: 'duck',
    icon: [
      512,
      512,
      [129414],
      'f6d8',
      
      'M368 209.3v13.1V259v13.8l10 9.5c18.5 17.5 30 42.3 30 69.7c0 53-43 96-96 96H192c-87.4 0-158.5-70.1-160-157.2l43.4 18.6 10.4 4.4 10.9-3 165-46.2 26.3-7.4V220l-15.8-11.8C252.6 193.5 240 170.2 240 144c0-44.2 35.8-80 80-80s80 35.8 80 80c0 21.8-8.7 41.5-22.9 56l-9.1 9.3zM88 280L32 256H0v32C0 394 86 480 192 480H312c70.7 0 128-57.3 128-128c0-36.6-15.4-69.6-40-93V240h16c53 0 96-43 96-96V133 114.9l-18 2.2-35.4 4.4c-9.6 1.2-19.3 1.1-28.9-.1C419.3 70.4 374.1 32 320 32c-61.9 0-112 50.1-112 112c0 23.6 7.3 45.6 19.8 63.6c6.9 10 15.5 18.9 25.2 26.2L216.4 244 88 280zM431.6 153.8c10.3 .9 20.7 .8 31-.5l17-2.1C476 183.1 448.9 208 416 208h-4.1c10.9-15.6 17.9-34.2 19.7-54.2zM360 152a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM293.5 307.5C289 341 263.5 370.8 226.7 380c-30.1 7.5-60-.8-80.7-19.1l-21.2 23.9c28.5 25.3 69.3 36.3 109.7 26.2c49.3-12.3 84.5-52.6 90.7-99.3l-31.7-4.2z'
      
    ]
  };

  

  
  

  var faMosque = {
    prefix: 'fasl',
    iconName: 'mosque',
    icon: [
      640,
      512,
      [128332],
      'f678',
      
      'M80 4.7L90.5 14l23 20.1c27.4 24 43.9 57.8 46.2 93.9h.3v8.5V160v80 16H128V240 160H32v16V480h80 16v32H112 16 0V496 176 136.5C0 97.2 16.9 59.9 46.4 34.1L69.5 14 80 4.7zM32.3 128h95.3c-2.2-26.8-14.7-51.9-35.2-69.8L80 47.3 67.5 58.2c-20.4 17.9-33 43-35.2 69.8zM400 5.3l12.8 17.1c31.2 41.7 69.1 65 117.4 94.7l0 0 0 0c10.8 6.6 22 13.6 33.9 21.1c28.1 17.9 43.9 49 43.9 81.6c0 26.3-10.2 50.3-26.8 68.2H624h16v16V496v16H624 544 512 464 432 368 336 288 256 176 160V496 304 288h16 42.8c-16.6-17.9-26.8-41.8-26.8-68.2c0-32.6 15.8-63.7 43.9-81.6c11.8-7.5 23.1-14.5 33.9-21.1C318.1 87.4 356 64.1 387.2 22.4L400 5.3zM432 480V424c0-10.1-4.7-19.6-12.8-25.6L400 384l-19.2 14.4c-8.1 6-12.8 15.5-12.8 25.6v56h64zm32 0h48V416 384h32v32 64h64V320H507.8 400 292.2 192V480h64V416 384h32v32 64h48V424c0-20.1 9.5-39.1 25.6-51.2L400 344l38.4 28.8C454.5 384.9 464 403.9 464 424v56zM576 219.8c0-22.4-10.8-43-29.1-54.6c-10.8-6.9-21.4-13.4-31.8-19.8c-43-26.4-82.3-50.5-115.1-88c-32.8 37.5-72.1 61.6-115.1 88l0 0 0 0c-10.4 6.4-21 12.9-31.8 19.8c-18.3 11.6-29.1 32.2-29.1 54.6c0 37.7 30.5 68.2 68.2 68.2H400 507.8c37.7 0 68.2-30.5 68.2-68.2z'
      
    ]
  };

  

  
  

  var faBookHeart = {
    prefix: 'fasl',
    iconName: 'book-heart',
    icon: [
      448,
      512,
      [],
      'f499',
      
      'M0 64C0 28.7 28.7 0 64 0H432h16V16 400v16H432 416v64h16 16v32H432 64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H416V32H64C46.3 32 32 46.3 32 64l0 328.6zM232.3 129.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L240 304.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2zm79.3 61.6c5.3-5.1 8.3-12.2 8.3-19.6c0-15-12.2-27.2-27.2-27.2h-2.4c-7.7 0-15 3-20.5 8.3l-7.7 7.4L240 181l-22.2-21.3-7.7-7.4c-5.5-5.3-12.9-8.3-20.5-8.3h-2.4c-15 0-27.2 12.2-27.2 27.2c0 7.4 3 14.5 8.3 19.6L240 259.7l71.7-68.9z'
      
    ]
  };

  

  
  

  var faDropletSlash = {
    prefix: 'fasl',
    iconName: 'droplet-slash',
    icon: [
      640,
      512,
      ["tint-slash"],
      'f5c7',
      
      'M436.6 429.6C407.4 460.6 366 480 320 480c-88.4 0-160-71.6-160-160c0-18.5 8.9-46 26.5-80.1c.9-1.8 1.9-3.7 2.9-5.5l-25.5-20.1C142.6 253.2 128 290.7 128 320c0 106 86 192 192 192c56.2 0 106.7-24.1 141.8-62.5l-25.2-19.9zM298.9 24.4C282.6 43.8 258.7 73 234 106.5l25.1 19.8c20.3-27.6 40.1-52.3 55.5-70.9c1.9-2.2 3.6-4.4 5.4-6.4c1.7 2.1 3.5 4.2 5.4 6.4c17.7 21.3 41.2 50.8 64.7 83.4c23.5 32.7 46.5 68 63.5 101c11.6 22.6 19.5 42.4 23.4 58.5L511.9 326c.1-2 .1-4 .1-6c0-84.2-121-236.4-170.9-295.6C328.2 9.1 320 0 320 0s-8.2 9.1-21.1 24.4zM320 400c-44.2 0-80-35.8-80-80H208c0 61.9 50.1 112 112 112V400zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  
    var faTintSlash = faDropletSlash;
  

  
  

  var faGear = {
    prefix: 'fasl',
    iconName: 'gear',
    icon: [
      512,
      512,
      [9881,"cog"],
      'f013',
      
      'M195 108c-13.2 5.4-25.5 12.6-36.7 21.2l-13.3 10.2-16-5.1-52-16.6L46.9 170.2l40.3 36.7 12.4 11.3-2.2 16.6c-.9 6.9-1.4 14-1.4 21.2s.5 14.3 1.4 21.2l2.2 16.6L87.2 305.1 46.9 341.8l30.2 52.4 52-16.6 16-5.1 13.3 10.2c11.2 8.6 23.5 15.8 36.7 21.2l15.5 6.4 3.6 16.4L225.8 480h60.5l11.7-53.3 3.6-16.4L317 404c13.2-5.4 25.5-12.6 36.7-21.2l13.3-10.2 16 5.1 52 16.6 30.2-52.4-40.3-36.7-12.4-11.3 2.2-16.6c.9-6.9 1.4-14 1.4-21.2s-.5-14.3-1.4-21.2l-2.2-16.6 12.4-11.3 40.3-36.7-30.2-52.4-52 16.6-16 5.1-13.3-10.2c-11.2-8.6-23.5-15.8-36.7-21.2l-15.5-6.4-3.6-16.4L286.2 32H225.8L214.1 85.3l-3.6 16.4L195 108zM200 0H312l17.2 78.4c15.8 6.5 30.6 15.1 44 25.4l76.5-24.4 56 97-59.4 54.1c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l59.4 54.1-56 97-76.5-24.4c-13.4 10.3-28.2 18.9-44 25.4L312 512H200l-17.2-78.4c-15.8-6.5-30.6-15.1-44-25.4L62.3 432.5l-56-97 59.4-54.1C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L6.3 176.5l56-97 76.5 24.4c13.4-10.3 28.2-18.9 44-25.4L200 0zM312 256a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm-144 0a88 88 0 1 1 176 0 88 88 0 1 1 -176 0z'
      
    ]
  };

  
    var faCog = faGear;
  

  
  

  var faCameraSecurity = {
    prefix: 'fasl',
    iconName: 'camera-security',
    icon: [
      448,
      512,
      ["camera-home"],
      'f8fe',
      
      'M416 32V384H328.9 119.1 32V32H416zM32 416h69.3L65.8 480 48 512H84.6 363.4 400l-17.8-32-35.6-64H416h32V384 32 0H416 32 0V32 384v32H32zm70.4 64l35.6-64H310.1l35.6 64H102.4zM320 208a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM224 80a128 128 0 1 0 0 256 128 128 0 1 0 0-256z'
      
    ]
  };

  
    var faCameraHome = faCameraSecurity;
  

  
  

  var faUserDoctorHairLong = {
    prefix: 'fasl',
    iconName: 'user-doctor-hair-long',
    icon: [
      448,
      512,
      [],
      'e459',
      
      'M318.7 112H272h-3.8l-3.4-1.7-20.1-10-16 21.3L224 128h-8l-88 0v16c0 53 43 96 96 96s96-43 96-96V128c0-5.5-.5-10.8-1.3-16zm14.9 98.2C311.2 247.2 270.5 272 224 272s-87.2-24.8-109.6-61.8L64 248v8h64 16v32H128 48 32V272 240v-8l6.4-4.8L96 184V144 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16 40l57.6 43.2L416 232v8 32 16H400 320 304V256h16 64v-8l-50.4-37.8zM307.2 80C290.6 51.3 259.5 32 224 32c-41.8 0-77.4 26.7-90.5 64H208l19.2-25.6 8-10.7 11.9 6L275.8 80h31.4zM43.3 480H404.7L360.4 336H320v34.3c23.1 6.9 40 28.3 40 53.7v24 16H344 328 312V432h16v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8h16v32H280 264 248V448 424c0-25.4 16.9-46.8 40-53.7V336H176v34.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V336H87.6L43.3 480zM144 416a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM64 304H384l54.2 176 9.8 32H414.5 33.5 0l9.8-32L64 304z'
      
    ]
  };

  

  
  

  var faFileCertificate = {
    prefix: 'fasl',
    iconName: 'file-certificate',
    icon: [
      512,
      512,
      ["file-award"],
      'f5f3',
      
      'M480 192V480H224v32 0H480h32V480 152L360 0H160 128V32 134.7l23.6-9.7 8.4-3.4V32H320V176v16h16H480zm-5.3-32H352V37.3L474.7 160zM128 177.9L94.9 164.4 73 192.7l-35.5 4.8L32.7 233 4.4 254.9 17.9 288 4.4 321.1 32.7 343l4.8 35.5L64 382.1v94.1V512l32-16 32-16 32 16 32 16V476.2 382.1l26.5-3.6 4.8-35.5 28.3-21.9L238.1 288l13.6-33.1L223.3 233l-4.8-35.5L183 192.7l-21.9-28.3L128 177.9zm32 233.3v49.1l-17.7-8.8L128 444.2l-14.3 7.2L96 460.2V411.2l32-13.1 32 13.1zm-9.3-208l7 9.1 8 10.4 13 1.8 11.4 1.5 1.5 11.4 1.8 13 10.4 8 9.1 7-4.3 10.6-5 12.1 5 12.1 4.3 10.6-9.1 7-10.4 8-1.8 13-1.5 11.4-11.4 1.5-13 1.8-8 10.4-7 9.1-10.6-4.3-12.1-5-12.1 5-10.6 4.3-7-9.1-8-10.4-13-1.8-11.4-1.5-1.5-11.4-1.8-13-10.4-8-9.1-7 4.3-10.6 5-12.1-5-12.1-4.3-10.6 9.1-7 10.4-8 1.8-13 1.5-11.4 11.4-1.5 13-1.8 8-10.4 7-9.1 10.6 4.3 12.1 5 12.1-5 10.6-4.3z'
      
    ]
  };

  
    var faFileAward = faFileCertificate;
  

  
  

  var faMessageXmark = {
    prefix: 'fasl',
    iconName: 'message-xmark',
    icon: [
      512,
      512,
      ["comment-alt-times","message-times"],
      'f4ab',
      
      'M160 416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448 416zm0-32h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zm31.4-263.2l11.3 11.3L256 185.4l53.3-53.3 11.3-11.3 22.6 22.6-11.3 11.3L278.6 208l53.3 53.3 11.3 11.3-22.6 22.6-11.3-11.3L256 230.6l-53.3 53.3-11.3 11.3-22.6-22.6 11.3-11.3L233.4 208l-53.3-53.3-11.3-11.3 22.6-22.6z'
      
    ]
  };

  
    var faCommentAltTimes = faMessageXmark;
  
    var faMessageTimes = faMessageXmark;
  

  
  

  var faHousePersonReturn = {
    prefix: 'fasl',
    iconName: 'house-person-return',
    icon: [
      640,
      512,
      ["house-person-arrive","house-return"],
      'e011',
      
      'M437.1 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm123.3 82.7l30.1 67.8 6.5 14.6 29.2-13-6.5-14.6-32-72-1.9-4.2-3.9-2.6-72-48-6.1-4-7 1.9-88 24-8.5 2.3-2.6 8.4-30.3 98.6-43.3 28.8L342 309.3l48-32 4.7-3.2 1.7-5.4 15-48.7 38.4 111-47.2 40.9-3.5 3-1.3 4.5-32 107.2L361.2 502l30.7 9.2 4.6-15.3L427.1 393l100.6-87.2c14.4-12.5 20.1-32.4 14.4-50.6l-28.7-91.8 46.9 31.3zm-48.8 70c1.9 6.1 0 12.7-4.8 16.9l-30.9 26.8L428.8 172.3l49.7-13.6 33.1 106zm58.7 157.8l-38.8-77.6-25 21.6 36.3 72.6c.8 1.5 1.8 2.9 3 4.2l56 56 11.3 11.3L635.7 488l-11.3-11.3-54.2-54.2zM250.1 11.6L240 3.4l-10.1 8.2-216 176L1.5 197.7l20.2 24.8 12.4-10.1L64 188V400v16H80 346.5l9.6-32H320 96V162L240 44.6l121 98.6 9-29.2 4.4-1.2L250.1 11.6zM256 192v64H192V192h64zm-64-32H160v32 64 32h32 64 32V256 192 160H256 192z'
      
    ]
  };

  
    var faHousePersonArrive = faHousePersonReturn;
  
    var faHouseReturn = faHousePersonReturn;
  

  
  

  var faCartCircleArrowDown = {
    prefix: 'fasl',
    iconName: 'cart-circle-arrow-down',
    icon: [
      640,
      512,
      [],
      'e3ef',
      
      'M16 0H0V32H16 67.2l77.2 339.5 2.8 12.5H160 320.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32H151L107.3 64H532.5l-40 128c1.2 0 2.4 0 3.5 0c10 0 19.7 .8 29.2 2.4L566 64l10-32H542.5 100L95.6 12.5 92.8 0H80 16zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM608 368a112 112 0 1 1 -224 0 112 112 0 1 1 224 0zm-256 0a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm222.6 8L552 353.4l-11.3 11.3L512 393.4V304 288H480v16 89.4l-28.7-28.7L440 353.4 417.4 376l11.3 11.3 56 56L496 454.6l11.3-11.3 56-56L574.6 376z'
      
    ]
  };

  

  
  

  var faFaceSmileHalo = {
    prefix: 'fasl',
    iconName: 'face-smile-halo',
    icon: [
      512,
      512,
      [],
      'e38f',
      
      'M480.3 78.1a.1 .1 0 1 0 -.2 0 .1 .1 0 1 0 .2 0zm-7.4-3.5c3.2 2.4 5 4.2 6.1 5.4c-1.1 1.2-2.9 3-6.1 5.4c-9 6.6-24 13.9-45.4 20.6C385 119.3 324.4 128 256 128s-129-8.7-171.5-22C63.1 99.3 48.1 92 39.1 85.4c-3.2-2.4-5-4.2-6.1-5.4c1.1-1.2 2.9-3 6.1-5.4c9-6.6 24-13.9 45.4-20.6C127 40.7 187.6 32 256 32s129 8.7 171.5 22c21.4 6.7 36.4 14 45.4 20.6zM31.7 78.1a.1 .1 0 1 0 .2 0 .1 .1 0 1 0 -.2 0zm0 3.8a.1 .1 0 1 0 .2 0 .1 .1 0 1 0 -.2 0zm448.5-.1a.2 .2 0 1 0 -.1 .3 .2 .2 0 1 0 .1-.3zM512 80C512 35.8 397.4 0 256 0S0 35.8 0 80s114.6 80 256 80s256-35.8 256-80zM45.6 156.5C26.7 190.7 16 230.1 16 272c0 132.5 107.5 240 240 240s240-107.5 240-240c0-41.9-10.7-81.3-29.6-115.5c-9.5 3.9-19.7 7.6-30.5 11C453.8 198.2 464 233.9 464 272c0 114.9-93.1 208-208 208S48 386.9 48 272c0-38.1 10.2-73.8 28.1-104.5c-10.9-3.4-21.1-7.1-30.5-11zm110.9 94c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4l31-7.8c-3.2-12.7-9.8-27.1-19.9-38.6C209.6 217.9 194.8 208 176 208s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6l31 7.8c2.1-8.6 6.7-18.2 12.9-25.4zM256 416c71.6 0 113.7-47.7 126.3-72.8l-28.6-14.3C344.9 346.3 312.4 384 256 384s-88.9-37.7-97.7-55.2l-28.6 14.3C142.3 368.3 184.4 416 256 416zm47.5-140.1c2.1-8.6 6.7-18.2 12.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4l31-7.8c-3.2-12.7-9.8-27.1-19.9-38.6C369.6 217.9 354.8 208 336 208s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6l31 7.8z'
      
    ]
  };

  

  
  

  var faCircleBolt = {
    prefix: 'fasl',
    iconName: 'circle-bolt',
    icon: [
      512,
      512,
      [],
      'e0fe',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM296 112h8 18.4l-2.6 18.3L306.4 224H352h16v16 8 6.6l-4.7 4.7-136 136-4.7 4.7H216h-8H189.6l2.6-18.3L205.6 288H160 144V272v-8-6.6l4.7-4.7 136-136 4.7-4.7H296zM190.6 256H224h18.4l-2.6 18.3-10.5 73.8L321.4 256H288 269.6l2.6-18.3 10.5-73.8L190.6 256z'
      
    ]
  };

  

  
  

  var faPresentationScreen = {
    prefix: 'fasl',
    iconName: 'presentation-screen',
    icon: [
      576,
      512,
      ["presentation"],
      'f685',
      
      'M16 0H0V32H16 560h16V0H560 16zM64 80V64H32V80 336v16H48 272v41.4l-83.3 83.3L177.4 488 200 510.6l11.3-11.3L288 422.6l76.7 76.7L376 510.6 398.6 488l-11.3-11.3L304 393.4V352H528h16V336 80 64H512V80 320H288 64V80z'
      
    ]
  };

  
    var faPresentation = faPresentationScreen;
  

  
  

  var faHandsAslInterpreting = {
    prefix: 'fasl',
    iconName: 'hands-asl-interpreting',
    icon: [
      569,
      512,
      ["american-sign-language-interpreting","asl-interpreting","hands-american-sign-language-interpreting"],
      'f2a3',
      
      'M92.4 33.4L79.1 28.3 74 41.6 7.7 214C2.6 227.1 .1 241.1 .1 255.1c0 63.3 51.3 114.6 114.6 114.6h70.3c25.1 0 48-9.3 65.4-24.5l0 .2 13.8 55.2 3.4 13.8 13.8-3.4 27.6-6.9 14.9-3.7-8.9 7-11.2 8.8 8.8 11.2 35.1 44.8 8.8 11.2 11.2-8.8 49.1-38.4-1.4 3.7-5.1 13.3 13.3 5.1 53.1 20.4 13.3 5.1 5.1-13.3L561.3 298c5-13.1 7.6-27.1 7.6-41.2c0-63.3-51.3-114.6-114.6-114.6H384.1c-25.1 0-48 9.3-65.4 24.5l0-.2-13.8-55.2-3.5-13.8L287.5 101l-27.6 6.9L245 111.7l8.9-7 11.2-8.8-8.8-11.2L221.3 39.9l-8.8-11.2-11.2 8.8L152.2 75.9l1.4-3.7 5.1-13.3-13.3-5.1L92.4 33.4zM302 185.4c-1.5 2.1-2.9 4.3-4.2 6.6l-7.1 12.3 12.3 7.1 49.2 28.5 3.3 1.9-3.3 1.9L303 272.2l-12.3 7.1 7.1 12.3c4.9 8.5 11 16.1 18.1 22.8l-27.6 6.9L267 326.6c1.5-2.1 2.9-4.3 4.2-6.6l7.1-12.3L266 300.6l-49.2-28.5-3.3-1.9 3.3-1.9L266 239.8l12.3-7.1-7.1-12.3c-4.9-8.5-11-16.1-18.1-22.8l27.6-6.9 21.4-5.3zM197.3 263.1l4.1 7.1-4.1 7.1c-2.5 4.3-7.1 7.1-12.3 7.1c-7.9 0-14.2-6.4-14.2-14.2s6.4-14.2 14.2-14.2c5.2 0 9.8 2.8 12.3 7.1zm-163-38.9L95.5 65.1 122 75.3l-14.8 38.5-18.5 48L129.3 130l78.4-61.4 17.5 22.4-50.4 39.4-52.7 41.2L187 155.5l79.8-19.9 13.8-3.4 6.9 27.6-13.8 3.4-58.9 14.7-41.2 10.3 39 16.6c9.8 4.2 18.5 10.5 25.4 18.3l-25.5 14.7c-7.5-6.4-17.2-10.2-27.7-10.2c-23.6 0-42.7 19.1-42.7 42.7s19.1 42.7 42.7 42.7c10.6 0 20.3-3.8 27.7-10.2l25.5 14.7c-13 14.7-32 24-53.2 24H114.7c-47.6 0-86.2-38.6-86.2-86.2c0-10.6 1.9-21.1 5.7-30.9zm337.5 24.7l-4.1-7.1 4.1-7.1c2.5-4.3 7.1-7.1 12.3-7.1c7.9 0 14.2 6.4 14.2 14.2s-6.4 14.2-14.2 14.2c-5.2 0-9.8-2.8-12.3-7.1zm163 38.9L473.5 446.9 447 436.7l14.8-38.5 18.5-48L439.7 382l-78.4 61.4-17.5-22.4 50.4-39.4 52.7-41.2L382 356.5l-79.8 19.9-13.8 3.5-6.9-27.6 13.8-3.5 58.9-14.7 41.2-10.3-39-16.6c-9.8-4.2-18.5-10.5-25.4-18.3l25.5-14.7c7.5 6.4 17.2 10.2 27.7 10.2c23.6 0 42.7-19.1 42.7-42.7s-19.1-42.7-42.7-42.7c-10.6 0-20.3 3.8-27.7 10.2l-25.5-14.7c13-14.7 32-24 53.2-24h70.3c47.6 0 86.2 38.6 86.2 86.2c0 10.6-1.9 21.1-5.7 30.9z'
      
    ]
  };

  
    var faAmericanSignLanguageInterpreting = faHandsAslInterpreting;
  
    var faAslInterpreting = faHandsAslInterpreting;
  
    var faHandsAmericanSignLanguageInterpreting = faHandsAslInterpreting;
  

  
  

  var faChartUser = {
    prefix: 'fasl',
    iconName: 'chart-user',
    icon: [
      640,
      512,
      ["user-chart"],
      'f6a3',
      
      'M608 32H192v68c-10.2-2.6-21-4-32-4V32 0h32H608h32V32 384v32H608 324.6L315 384H608V32zM400 112h16 96 16v16 96 16H496V224 166.6L395.3 267.3 384 278.6l-11.3-11.3-80-80L281.4 176 304 153.4l11.3 11.3L384 233.4 473.4 144H416 400V112zM160 288a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM71.8 384L43 480H277l-28.8-96H71.8zM272 352l38.4 128 9.6 32H286.6 33.4 0l9.6-32L48 352H272z'
      
    ]
  };

  
    var faUserChart = faChartUser;
  

  
  

  var faBookCircleArrowRight = {
    prefix: 'fasl',
    iconName: 'book-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e0bc',
      
      'M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H394.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H326.6c-2.9-10.3-4.9-21-5.9-32H64c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H416V211.2c10.1-5.2 20.8-9.4 32-12.6V16 0H432 64zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm8-222.6L481.4 312l11.3 11.3L521.4 352H432 416v32h16 89.4l-28.7 28.7L481.4 424 504 446.6l11.3-11.3 56-56L582.6 368l-11.3-11.3-56-56L504 289.4z'
      
    ]
  };

  

  
  

  var faVolumeOff = {
    prefix: 'fasl',
    iconName: 'volume-off',
    icon: [
      320,
      512,
      [],
      'f026',
      
      'M140.2 320l9.1 8.1L284.2 448H288V64h-3.8L149.3 183.9l-9.1 8.1H128 32V320h96 12.2zM32 352H0V320 192 160H32h96L272 32h16 32V64 448v32H288 272L128 352H32z'
      
    ]
  };

  

  
  

  var faFlaskRoundPoison = {
    prefix: 'fasl',
    iconName: 'flask-round-poison',
    icon: [
      448,
      512,
      ["flask-poison"],
      'f6e0',
      
      'M160 186.8V167.4 32H288V167.4v19.4l17.2 9C361.6 225.2 400 284.1 400 352c0 50.4-21.2 95.9-55.2 128H103.2C69.2 447.9 48 402.4 48 352c0-67.9 38.4-126.8 94.8-156.2l17.2-9zm160-19.4V32h16 16V0H336 320 288 160 128 112 96V32h16 16V167.4C61.4 202.1 16 271.8 16 352c0 64.3 29.2 121.8 75.1 160H356.9c45.9-38.2 75.1-95.7 75.1-160c0-80.2-45.4-149.9-112-184.6zM128 312c0-36.4 39.2-72 96-72s96 35.6 96 72c0 22.6-14.4 44.3-39.7 58.2l-8.3 4.6v9.5V416H176V384.2v-9.5l-8.3-4.6C142.4 356.3 128 334.6 128 312zm96-104c-66.9 0-128 43.2-128 104c0 34 19.7 62.9 48 81.3V432v16h16H288h16V432 393.3c28.3-18.4 48-47.3 48-81.3c0-60.8-61.1-104-128-104zm64 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM184 336a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  
    var faFlaskPoison = faFlaskRoundPoison;
  

  
  

  var faFrancSign = {
    prefix: 'fasl',
    iconName: 'franc-sign',
    icon: [
      320,
      512,
      [],
      'e18f',
      
      'M80 32H64V48 192v32 96H0v32H64V464v16H96V464 352H224V320H96V224H288V192H96V64H304h16V32H304 80z'
      
    ]
  };

  

  
  

  var faArrowDownLeft = {
    prefix: 'fasl',
    iconName: 'arrow-down-left',
    icon: [
      384,
      512,
      [],
      'e091',
      
      'M48 416H32V400 176 160H64v16V361.4L316.7 108.7 328 97.4 350.6 120l-11.3 11.3L86.6 384H272h16v32H272 48z'
      
    ]
  };

  

  
  

  var faStreetView = {
    prefix: 'fasl',
    iconName: 'street-view',
    icon: [
      512,
      512,
      [],
      'f21d',
      
      'M352 224c0-35.3-28.7-64-64-64H256 224c-35.3 0-64 28.7-64 64v56 32h26.7L200 432H312l13.3-120H352V280 224zm-32 0v56H296.7l-3.2 28.5L283.4 400H228.6l-10.2-91.5L215.3 280H192V224c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32zM224 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64A64 64 0 1 0 256 0a64 64 0 1 0 0 128zM32 426.2c0-1.1 .4-3.3 3.6-6.9c3.3-3.7 8.9-8 17.3-12.5c16.8-8.9 42-17 73.6-23.1l-6.1-31.4c-33.2 6.4-61.8 15.3-82.6 26.2C27.6 384 18.5 390.4 11.8 398C4.9 405.6 0 415.1 0 426.2c0 17.6 12.2 31 25.8 40.3c14.1 9.7 33.5 17.8 56 24.4C127.1 504.1 188.7 512 256 512s128.9-7.9 174.2-21.1c22.5-6.6 41.9-14.7 56-24.4c13.6-9.4 25.8-22.7 25.8-40.3c0-11.1-4.9-20.6-11.8-28.3c-6.7-7.5-15.9-13.9-26.2-19.4c-20.8-11-49.4-19.8-82.6-26.2l-6.1 31.4c31.6 6.1 56.8 14.2 73.6 23.1c8.4 4.5 14 8.7 17.3 12.5c3.2 3.6 3.6 5.9 3.6 6.9c0 1.6-1.3 6.6-11.9 14c-10.2 7-25.9 13.9-46.8 20C379.6 472.3 321.2 480 256 480s-123.6-7.7-165.2-19.8c-20.9-6.1-36.7-13-46.8-20c-10.7-7.3-11.9-12.3-11.9-14z'
      
    ]
  };

  

  
  

  var faFontCase = {
    prefix: 'fasl',
    iconName: 'font-case',
    icon: [
      640,
      512,
      [],
      'f866',
      
      'M161 42.5L164.8 32h22.3L191 42.5 351.8 480H317.7l-47-128H81.3l-47 128H.2L161 42.5zM93.1 320H258.9L176 94.4 93.1 320zM640 176V464v16H608V464 429.3C585.4 460.1 549 480 508 480c-68.5 0-124-55.5-124-124V284c0-68.5 55.5-124 124-124c41 0 77.4 19.9 100 50.7V176 160h32v16zM508 192c-50.8 0-92 41.2-92 92v72c0 50.8 41.2 92 92 92s92-41.2 92-92V284c0-50.8-41.2-92-92-92z'
      
    ]
  };

  

  
  

  var faPlugCircleCheck = {
    prefix: 'fasl',
    iconName: 'plug-circle-check',
    icon: [
      576,
      512,
      [],
      'e55c',
      
      'M128 16V0H96V16v96h32V16zm160 0V0H256V16v96h32V16zM16 144H0v32H16 32v64c0 83 63.1 151.2 144 159.2V496v16h32V496 399.2c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128V176H320v56.2c9.8-8.1 20.6-15.2 32-21V176h16 16V144H368 352 320 64 32 16zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm78.6-176L488 313.4l-11.3 11.3L416 385.4l-28.7-28.7L376 345.4 353.4 368l11.3 11.3 40 40L416 430.6l11.3-11.3 72-72L510.6 336z'
      
    ]
  };

  

  
  

  var faArrowLeftLong = {
    prefix: 'fasl',
    iconName: 'arrow-left-long',
    icon: [
      512,
      512,
      ["long-arrow-left"],
      'f177',
      
      'M11.3 244.7L0 256l11.3 11.3 144 144 11.3 11.3L189.3 400l-11.3-11.3L61.3 272 496 272l16 0 0-32-16 0L61.3 240 177.9 123.3 189.3 112 166.6 89.4l-11.3 11.3-144 144z'
      
    ]
  };

  
    var faLongArrowLeft = faArrowLeftLong;
  

  
  

  var faTrashSlash = {
    prefix: 'fasl',
    iconName: 'trash-slash',
    icon: [
      640,
      512,
      [],
      'e2b3',
      
      'M509.7 96H544V64H512 479.9h-47L397.6 7.5 392.9 0H384 256h-8.9l-4.7 7.5L207.1 64h-27l40.5 32h257L463.9 288.1l30.4 24L509.7 96zM452.9 442.5L450.2 480H189.8L171.2 220.1l-34-26.8L160 512H480l3.3-45.6-30.4-24zM244.9 64l20-32H375.1l20 32H244.9zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faChess = {
    prefix: 'fasl',
    iconName: 'chess',
    icon: [
      512,
      512,
      [],
      'f439',
      
      'M144 0V16 32h16 16V64H160 144V96h48 32v32 24l-32.7 72H200h16v32H200 186.2l13.1 96H167l-13.1-96H102.1L89 352H56.7l13.1-96H56 40V224H56h8.7L32 152V128 96H64h48V64H96 80V32H96h16V16 0h32zM99.9 224h56.2L192 145.1V128H144 112 64v17.1L99.9 224zM32 480H224V463.3L191.2 416H64.8L32 463.3V480zM0 480V453.3L48 384H208l48 69.3V480v32H224 32 0V480zm350.1-64L320 470.2V480H480v-9.8L449.9 416H350.1zm118.6-32l2.3 4.1 40 72 1 1.8V464v16 24 8h-8H480 320 296h-8v-8V480 464v-2.1l1-1.8 40-72 2.3-4.1H336 464h4.7zM304 160h64 64 64 16v16 80 5.8l-3.7 4.5L472 309.8V336v16H440V336 304v-5.8l3.7-4.5L480 250.2V192H448v16 16H416V208 192H384v16 16H352V208 192H320v58.2l36.3 43.6 3.7 4.5V304v32 16H328V336 309.8l-36.3-43.5-3.7-4.5V256 176 160h16z'
      
    ]
  };

  

  
  

  var faGif = {
    prefix: 'fasl',
    iconName: 'gif',
    icon: [
      576,
      512,
      [],
      'e190',
      
      'M544 64V448H32V64H544zM32 32H0V64 448v32H32 544h32V448 64 32H544 32zM320 160H288v16V336v16h32V336 176 160zm32 0v16 80 80 16h32V336 272h64 16V240H448 384V192h80 16V160H464 368 352zM128 256c0-35.3 28.7-64 64-64c14.4 0 27.7 4.8 38.4 12.8l19.2-25.6c-16-12.1-36-19.2-57.6-19.2c-53 0-96 43-96 96s43 96 96 96c21.6 0 41.6-7.1 57.6-19.2L256 328v-8V264 248H240 184 168v32h16 40v31.4c-9.4 5.4-20.3 8.6-32 8.6c-35.3 0-64-28.7-64-64z'
      
    ]
  };

  

  
  

  var faRightToLine = {
    prefix: 'fasl',
    iconName: 'right-to-line',
    icon: [
      448,
      512,
      ["arrow-alt-to-right"],
      'f34c',
      
      'M416 80l0-16 32 0 0 16 0 352 0 16-32 0 0-16 0-352zM144 304l32 0 0 32 0 48 17.7 0L308.9 256 193.7 128 176 128l0 48 0 32-32 0L32 208l0 96 112 0zm0 112l0-32 0-16 0-32-32 0-80 0L0 336l0-32 0-96 0-32 32 0 80 0 32 0 0-32 0-16 0-32 32 0 32 0L352 256 208 416l-32 0-32 0z'
      
    ]
  };

  
    var faArrowAltToRight = faRightToLine;
  

  
  

  var faFireFlame = {
    prefix: 'fasl',
    iconName: 'fire-flame',
    icon: [
      384,
      512,
      ["flame"],
      'f6df',
      
      'M180.9 9.7L192 0l11.1 9.7c76.7 67.1 135.2 152.5 170 248.3c7.2 19.9 10.9 41.1 10.9 62.2C384 425.4 297.2 512 192 512S0 425.4 0 320.2C0 299 3.7 277.8 10.9 258c34.8-95.8 93.3-181.2 170-248.3zM41 268.9c-5.9 16.3-9 33.8-9 51.3C32 407.6 104.5 480 192 480s160-72.4 160-159.8c0-17.4-3.1-34.9-9-51.3c-31.5-86.5-83.3-164.1-151-226.2C124.3 104.9 72.4 182.4 41 268.9zM221.7 144v12.4c0 8.4 3.3 16.4 9.2 22.4l51.4 52.3c24.2 24.6 37.7 57.7 37.7 92.2C320 392.2 264.2 448 195.3 448h-5.9C120.1 448 64 391.9 64 322.6c0-32 16.2-61.8 43-79.3l13.4-8.7 24.7-16.1V248v46.3c0 14.2 11.5 25.7 25.7 25.7h2.5c12.8 0 23.3-10.4 23.3-23.3c0-6-2.3-11.8-6.5-16.1l-9-9.4c-16.4-17-25.6-39.7-25.6-63.4c0-27.2 12.1-52.9 33-70.3l7.1-5.9 26.2-21.7V144zm-34.3 63.8c0 15.4 6 30.1 16.6 41.2l9 9.4c9.9 10.3 15.5 24.1 15.5 38.4c0 30.5-24.7 55.3-55.3 55.3h-2.5c-31.9 0-57.7-25.8-57.7-57.7V279.6c-10.9 11.5-17.1 26.9-17.1 43c0 51.6 41.8 93.4 93.4 93.4h5.9c51.2 0 92.7-41.5 92.7-92.7c0-26.1-10.3-51.2-28.5-69.8l-51.4-52.3c-6-6.1-10.7-13.3-13.8-21.1c-4.5 8.4-6.9 17.9-6.9 27.7z'
      
    ]
  };

  
    var faFlame = faFireFlame;
  

  
  

  var faMinus = {
    prefix: 'fasl',
    iconName: 'minus',
    icon: [
      448,
      512,
      [8211,8722,10134,"subtract"],
      'f068',
      
      'M432 272H416L32 272H16l0-32 16 0 384 0 16 0v32z'
      
    ]
  };

  
    var faSubtract = faMinus;
  

  
  

  var faCircle5 = {
    prefix: 'fasl',
    iconName: 'circle-5',
    icon: [
      512,
      512,
      [],
      'e0f2',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 128H195.5l-3 12.1-24 96L164 254.1l18.4 1.9 98.8 10c22.1 2.2 38.8 20.8 38.8 42.9c0 23.8-19.3 43.2-43.2 43.2h-44c-16.8 0-32.4-8.3-41.8-22.3l-1.8-2.7-8.9-13.3-26.6 17.8 8.9 13.3 1.8 2.7c15.3 22.8 40.9 36.4 68.3 36.4h44c41.5 0 75.2-33.7 75.2-75.2c0-38.6-29.2-70.9-67.6-74.8L204 225.9 220.5 160H320h16V128H320 208z'
      
    ]
  };

  

  
  

  var faCircleSterling = {
    prefix: 'fasl',
    iconName: 'circle-sterling',
    icon: [
      512,
      512,
      [],
      'e5cf',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM259.6 144c-20.2 0-36.5 16.5-36.4 36.7l.3 43.3H272h16v32H272 223.8l.2 33.3 0 5-2.8 4.1L206.4 320H328h16v32H328 176 145.6l17.2-25.1L192 284.5l-.2-28.5H176 160V224h16 15.5l-.3-43.1c-.3-38 30.4-68.9 68.4-68.9c10.6 0 21.1 2.5 30.6 7.2l20.9 10.5 14.3 7.2-14.3 28.6-14.3-7.2-20.9-10.5c-5.1-2.5-10.6-3.8-16.3-3.8z'
      
    ]
  };

  

  
  

  var faBracketRoundRight = {
    prefix: 'fasl',
    iconName: 'bracket-round-right',
    icon: [
      192,
      512,
      [],
      '29',
      
      'M192 256C192 136.7 100.8 58.4 55.6 33.9L40.4 62.1C80.5 83.8 160 153.4 160 256s-79.5 172.2-119.6 193.9l15.2 28.1C100.8 453.6 192 375.3 192 256z'
      
    ]
  };

  

  
  

  var faVirusSlash = {
    prefix: 'fasl',
    iconName: 'virus-slash',
    icon: [
      640,
      512,
      [],
      'e075',
      
      'M532.5 288H544h.3H576V256.3 256v-.3V224H544.3 544 532.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2 .2-.2 22.4-22.4L501.2 75.2 501 75l-.2-.2L478.4 52.4 456 74.8l-.2 .2-8.2 8.2 0 0C412.3 118.4 352 93.4 352 43.5V32v-.3V0H320.3 320h-.3H288V31.7 32 43.5c0 36.4-32.2 59.6-63.3 55.7l34.9 27.5c33.3-11.1 60.1-41.7 60.1-83.2V32v-.3h.3 .3V32 43.5c0 78.1 94.4 117.2 149.6 62l0 0 0 0 8.2-8.2 .2-.2 .2 .2 .2 .2-.2 .2-8.2 8.2c-55.2 55.2-16.1 149.7 62 149.7H544h.3v.3 .3H544 532.5c-29 0-52.6 13-68 32.2l24.9 19.7c9.9-12 24.8-20.1 43.1-20.1zM150.7 203.9c-9.9 12-24.8 20.1-43.1 20.1H96h-.3H64v31.7 .3 .3V288H95.7 96h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2-.2 .2-22.4 22.4 22.4 22.4 .2 .2 0 0 .2 .2 22.4 22.4L184 437.2l.2-.2 8.2-8.2 0 0c35.3-35.2 95.6-10.3 95.6 39.6V480v.3V512h31.7 .3 .3H352V480.3 480 468.5c0-36.4 32.2-59.6 63.3-55.7l-34.9-27.5c-33.3 11.1-60.1 41.7-60.1 83.2V480v.3H320h-.3V480 468.5c0-78.1-94.4-117.2-149.6-62l0 0 0 0 0 0-8.1 8.1-.2 .2-.2-.2 0 0-.1-.1 0 0-.1-.2 .2-.2 8.2-8.2c55.2-55.2 16.1-149.7-62-149.7H96h-.3V256v-.3H96h11.5c29 0 52.6-13 68-32.2l-24.9-19.7zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faDna = {
    prefix: 'fasl',
    iconName: 'dna',
    icon: [
      448,
      512,
      [129516],
      'f471',
      
      'M416 0V16c0 120.2-94.2 188.6-179.7 250.9l-2.8 2.1c-37.8 27.5-73.9 54-102.9 83.1h187c-19.8-19.8-42.8-38.4-67.5-57c3.2-2.3 6.4-4.6 9.7-6.9c5.9-4.2 11.7-8.4 17.6-12.7C349.4 330.4 416 394.9 416 496v16H384V496c0-5.5-.2-10.8-.7-16H64.7c-.4 5.2-.7 10.5-.7 16v16H32V496c0-113.2 83.6-180.5 164.8-240C115.6 196.5 32 129.2 32 16V0H64V16c0 5.5 .2 10.8 .7 16H383.3c.4-5.2 .7-10.5 .7-16V0h32zM377.6 64H70.4c6.5 23.4 17.6 44.5 32.2 64H345.5c14.6-19.5 25.7-40.6 32.2-64zm-60.1 96h-187c26.6 26.7 59.1 51.1 93.5 76.2c34.4-25.1 66.9-49.5 93.5-76.2zM70.4 448H377.6c-6.5-23.5-17.6-44.5-32.2-64.1c-.5 0-.9 .1-1.4 .1H104c-.5 0-.9 0-1.4-.1C88 403.5 76.8 424.5 70.4 448z'
      
    ]
  };

  

  
  

  var faTurnLeftUp = {
    prefix: 'fasl',
    iconName: 'turn-left-up',
    icon: [
      384,
      512,
      [],
      'e638',
      
      'M224 160l0 32 0 192 0 32 32 0 96 0 0 64-192 0 0-288 0-32-32 0-50.7 0L192 45.3 306.7 160 256 160l-32 0zm96 32l32 0 0-32L214.6 22.6 192 0 169.4 22.6 32 160l0 32 32 0 32 0 32 0 0 32 0 256 0 32 32 0 192 0 32 0 0-32 0-64 0-32-32 0-64 0-32 0 0-32 0-128 0-32 32 0 32 0z'
      
    ]
  };

  

  
  

  var faCloudBoltMoon = {
    prefix: 'fasl',
    iconName: 'cloud-bolt-moon',
    icon: [
      576,
      512,
      ["thunderstorm-moon"],
      'f76d',
      
      'M506.4 212.6c-11.3 6.2-24 10.1-37.4 11.2c4.6 9.7 7.9 20.2 9.6 31.2c27.9-3.8 52.9-16.8 71.9-35.9c10.5-10.6 19.2-23 25.5-36.8c-9.4 3.2-19.4 4.9-29.8 4.9c-3.3 0-6.6-.2-9.9-.5c-47.5-5-84.6-45.9-84.6-95.5c0-22.1 7.3-42.4 19.6-58.6c8.1-10.7 18.4-19.6 30.1-26C489.1 2.2 475.8 0 461.9 0c-1.5 0-3.1 0-4.6 .1c-48.2 1.8-89.6 31.1-109.2 73c10 4.3 19.2 10 27.5 16.9c10.5-24.8 30.9-44.1 55.9-52.8C424 53.5 419.8 71.8 419.8 91c0 56.3 36.1 104.6 86.6 121.5zM250.8 99.9C233.2 78 206.2 64 176 64c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6v64 32H32 68.2l32-32H96 32v-64c0-31.7 23-58 53.3-63.1l26.9-4.5-.2-27.3 0-1.2C112 124.6 140.7 96 176 96c23.2 0 43.5 12.3 54.8 30.9l17.7 29.3 28-19.6c7.8-5.4 17.2-8.6 27.4-8.6c26.5 0 48 21.5 48 48c0 3.6-.4 7.1-1.1 10.4l-7.1 32.5 32.8 5.8c22.4 4 39.5 23.7 39.5 47.2v48l-48 0H352v32h15.9l48 0h32v-80c0-37.1-25.3-68.4-59.7-77.4c-2-.5-4.1-1-6.2-1.4c.5-2.1 .8-4.1 1.1-6.2c.5-3.6 .8-7.3 .8-11c0-44.2-35.8-80-80-80c-13.2 0-25.7 3.2-36.7 8.9c-3.2 1.6-6.2 3.5-9.1 5.5c-2.2-3.6-4.6-7.1-7.3-10.4zM241.4 224l-4.7 4.7-136 136L96 369.4V376v8 16h16 45.6l-13.4 93.7L141.6 512H160h8 6.6l4.7-4.7 136-136 4.7-4.7V360v-8V336H304 258.4l13.4-93.7 2.6-18.3H256h-8-6.6zm-6.7 51.9l-10.5 73.8L221.6 368H240h33.4l-92.1 92.1 10.5-73.8 2.6-18.3H176 142.6l92.1-92.1z'
      
    ]
  };

  
    var faThunderstormMoon = faCloudBoltMoon;
  

  
  

  var faCircleUpRight = {
    prefix: 'fasl',
    iconName: 'circle-up-right',
    icon: [
      512,
      512,
      [],
      'e129',
      
      'M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm96 144h16v16V320v6.6l-4.7 4.7-16 16L336 358.6l-11.3-11.3L284 306.6l-64.7 64.7L208 382.6l-11.3-11.3-56-56L129.4 304l11.3-11.3L205.4 228l-40.7-40.7L153.4 176l11.3-11.3 16-16 4.7-4.7H192 352zM336 313.4V176H198.6l40.7 40.7L250.6 228l-11.3 11.3L174.6 304 208 337.4l64.7-64.7L284 261.4l11.3 11.3L336 313.4z'
      
    ]
  };

  

  
  

  var faKeyboardDown = {
    prefix: 'fasl',
    iconName: 'keyboard-down',
    icon: [
      576,
      512,
      [],
      'e1c2',
      
      'M32 32V256H544V32H32zM0 0H32 544h32V32 256v32H544 32 0V256 32 0zM216 72v48H168V72h48zM72 168h48v48H72V168zm48-96v48H72V72h48zm144 0h48v48H264V72zm144 0v48H360V72h48zm48 0h48v48H456V72zm48 96v48H456V168h48zm-328 8H400h16v32H400 176 160V176h16zm-4.7 172.7L288 465.4 404.7 348.7 416 337.4 438.6 360l-11.3 11.3-128 128L288 510.6l-11.3-11.3-128-128L137.4 360 160 337.4l11.3 11.3z'
      
    ]
  };

  

  
  

  var faLeftLong = {
    prefix: 'fasl',
    iconName: 'left-long',
    icon: [
      512,
      512,
      ["long-arrow-alt-left"],
      'f30a',
      
      'M160 296l32 0 288 0 0-80-288 0-32 0 0-32 0-42.7L45.3 256 160 370.7l0-42.7 0-32zm32 88l0 32-32 0L22.6 278.6 0 256l22.6-22.6L160 96l32 0 0 32 0 24 0 32 32 0 256 0 32 0 0 32 0 80 0 32-32 0-256 0-32 0 0 32 0 24z'
      
    ]
  };

  
    var faLongArrowAltLeft = faLeftLong;
  

  
  

  var faMoneyBill1 = {
    prefix: 'fasl',
    iconName: 'money-bill-1',
    icon: [
      576,
      512,
      ["money-bill-alt"],
      'f3d1',
      
      'M544 96v64c-35.3 0-64-28.7-64-64h64zM128 96H448c0 53 43 96 96 96V320c-53 0-96 43-96 96H128c0-53-43-96-96-96V192c53 0 96-43 96-96zM32 352c35.3 0 64 28.7 64 64H32V352zm448 64c0-35.3 28.7-64 64-64v64H480zM96 96c0 35.3-28.7 64-64 64V96H96zM32 64H0V96 416v32H32 544h32V416 96 64H544 32zM256 192v32h16v64h-8H248v32h16 8 32 8 16V288H312h-8V208 192H288 272 256zm-64 64a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z'
      
    ]
  };

  
    var faMoneyBillAlt = faMoneyBill1;
  

  
  

  var faCropSimple = {
    prefix: 'fasl',
    iconName: 'crop-simple',
    icon: [
      512,
      512,
      ["crop-alt"],
      'f565',
      
      'M128 16V0H96V16 96H16 0v32H16 96V400v16h16H352V384H128V16zM384 496v16h32V496 416h80 16V384H496 416l0-272V96H400L160 96v32l224 0 0 368z'
      
    ]
  };

  
    var faCropAlt = faCropSimple;
  

  
  

  var faIndianRupeeSign = {
    prefix: 'fasl',
    iconName: 'indian-rupee-sign',
    icon: [
      320,
      512,
      ["indian-rupee","inr"],
      'e1bc',
      
      'M0 32H16 96h16H304h16V64H304 202.5c28.7 23.2 48.3 57.3 52.6 96H304h16v32H304 255.1c-8 72-69 128-143.1 128H62.7L241.1 442.8l13.2 9.1-18.1 26.4-13.2-9.1L6.9 320.4 0 315.7v-8.4V304 288H16h96c56.4 0 103.1-41.7 110.9-96H16 0V160H16 222.9c-7.8-54.3-54.4-96-110.9-96H96 16 0V32z'
      
    ]
  };

  
    var faIndianRupee = faIndianRupeeSign;
  
    var faInr = faIndianRupeeSign;
  

  
  

  var faListTimeline = {
    prefix: 'fasl',
    iconName: 'list-timeline',
    icon: [
      512,
      512,
      [],
      'e1d1',
      
      'M144 96l22.6-22.6L208 32H416h32V64v64 32H416 208l-41.4-41.4L144 96zm272 32V64H221.3l-32 32 32 32H416zM64 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0l22.6-22.6L208 352H416h32v32 64 32H416 208l-41.4-41.4L144 416zm272 32V384H221.3l-32 32 32 32H416zM166.6 278.6L144 256l22.6-22.6L208 192H480h32v32 64 32H480 208l-41.4-41.4zm54.6 9.4H480V224H221.3l-32 32 32 32z'
      
    ]
  };

  

  
  

  var faMoneyBillsSimple = {
    prefix: 'fasl',
    iconName: 'money-bills-simple',
    icon: [
      640,
      512,
      ["money-bills-alt"],
      'e1f4',
      
      'M608 64V352H128V64H608zM128 32H96V64 352v32h32H608h32V352 64 32H608 128zM368 272a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM32 112V96H0v16V464v16H16 528h16V448H528 32V112z'
      
    ]
  };

  
    var faMoneyBillsAlt = faMoneyBillsSimple;
  

  
  

  var faBadgeDollar = {
    prefix: 'fasl',
    iconName: 'badge-dollar',
    icon: [
      512,
      512,
      [],
      'f645',
      
      'M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4l6.2 11.7 12.6-3.9c25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1l-3.9 12.6 11.7 6.2C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4l-11.7 6.2 3.9 12.6c7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4l-12.6-3.9-6.2 11.7C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4l-6.2-11.7-12.6 3.9c-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1l3.9-12.6-11.7-6.2C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4l11.7-6.2-3.9-12.6c-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4l12.6 3.9 6.2-11.7zM256 0c-36.1 0-68 18.1-87.1 45.6c-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4C188 493.9 219.9 512 256 512s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9C493.9 324 512 292.1 512 256s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zm16.9 149.3v-16h-32v16 11.9c-7.6 1.1-14.9 3.2-21.4 6.2c-15.3 6.9-27.9 19.5-31 37.3c-1.8 10.3-.8 19.9 3.3 28.5c4 8.5 10.4 14.6 17.1 19.2c12 8.2 28.2 13 41.4 17l2.2 .7c15.2 4.6 26.8 8.4 34.4 13.9c3.4 2.5 5.2 4.8 6.2 7.1c.9 2.2 1.6 5.5 .7 11c-1.1 6.3-4.9 11.1-12.5 14.4c-8.2 3.5-20.4 4.9-35.4 2.5c-7.3-1.2-19.9-5.5-30.5-9.1l0 0 0 0c-2.4-.8-4.7-1.6-6.7-2.3l-15.2-5.1-10.1 30.4 15.2 5.1c1.4 .5 3.2 1.1 5.2 1.8c10.3 3.5 26.8 9.2 37 10.8l0 0 .1 0 .1 0v12.2 16h32v-16V351.2c7.4-.9 14.5-2.7 20.9-5.5c15.9-6.8 28.2-19.6 31.5-38.4c1.8-10.5 1-20.3-2.9-29.2c-3.8-8.8-10-15.3-16.7-20.2c-12.6-9.2-29.7-14.4-43.5-18.5l-.5-.1c-15.4-4.6-27.2-8.3-34.9-13.5c-3.5-2.4-5.3-4.5-6.1-6.4c-.8-1.7-1.5-4.5-.7-9.3c.8-4.7 4.3-9.8 12.7-13.6c8.5-3.8 20.8-5.6 35.3-3.4c4.9 .8 20.2 3.7 24.8 5l15.5 4.1 8.2-30.9L301 167.2c-6.1-1.6-22.6-4.8-28-5.7l-.1 0V149.3z'
      
    ]
  };

  

  
  

  var faBallPile = {
    prefix: 'fasl',
    iconName: 'ball-pile',
    icon: [
      576,
      512,
      [],
      'f77e',
      
      'M352 96A64 64 0 1 0 224 96a64 64 0 1 0 128 0zm-35.4 91.7c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C277.1 205.1 288 229.3 288 256s-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3s19.5 1.5 28.6 4.3C298.9 306.9 288 282.7 288 256s10.9-50.9 28.6-68.3zM384 352c-9.9 0-19.5-1.5-28.6-4.3C373.1 365.1 384 389.3 384 416c0 53-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C181.1 365.1 192 389.3 192 416c0 53-43 96-96 96s-96-43-96-96s43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C106.9 306.9 96 282.7 96 256c0-53 43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C202.9 146.9 192 122.7 192 96c0-53 43-96 96-96s96 43 96 96c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3zM256 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM160 416A64 64 0 1 0 32 416a64 64 0 1 0 128 0zm224-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM288 480a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm256-64a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faFaceSmileUpsideDown = {
    prefix: 'fasl',
    iconName: 'face-smile-upside-down',
    icon: [
      512,
      512,
      [],
      'e395',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM129.7 184.8l28.6 14.3c8.7-17.5 41.3-55.2 97.7-55.2s88.9 37.7 97.7 55.2l28.6-14.3C369.7 159.7 327.6 112 256 112s-113.7 47.7-126.3 72.8zM200.4 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48z'
      
    ]
  };

  

  
  

  var faChartGantt = {
    prefix: 'fasl',
    iconName: 'chart-gantt',
    icon: [
      512,
      512,
      [],
      'e0e4',
      
      'M32 32V48 448H496h16v32H496 16 0V464 48 32H32zm96 96l16 0 128 0 16 0 0 32-16 0-128 0-16 0 0-32zm80 96H368h16v32H368 208 192V224h16zm160 96h96 16v32H464 368 352V320h16z'
      
    ]
  };

  

  
  

  var faTrainSubway = {
    prefix: 'fasl',
    iconName: 'train-subway',
    icon: [
      448,
      512,
      ["subway"],
      'f239',
      
      'M32 32H208l0 192H32V32zM240 224l0-192H416V224H240zM32 256H416V416H342.6 336 112h-6.6H32V256zM374.6 448H416h32V416 32 0H416 32 0V32 416v32H32 73.4L20.7 500.7 9.4 512H54.6l64-64H329.4l64 64h45.3l-11.3-11.3L374.6 448zM120 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm232-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faSubway = faTrainSubway;
  

  
  

  var faGameConsoleHandheldCrank = {
    prefix: 'fasl',
    iconName: 'game-console-handheld-crank',
    icon: [
      576,
      512,
      [],
      'e5b9',
      
      'M32 64V448H416V288 256 64H32zm416 0V256h32V208 144 128h16 64 16v16 64 16H560 512v48 16H496 448V448v32H416 32 0V448 64 32H32 416h32V64zM96 128V256H352V128H96zM64 96H96 352h32v32V256v32H352 96 64V256 128 96zm448 96h32V160H512v32zM128 336v16h16 16v32H144 128v16 16H96V400 384H80 64V352H80 96V336 320h32v16zm96 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faSportsball = {
    prefix: 'fasl',
    iconName: 'sportsball',
    icon: [
      512,
      512,
      [],
      'e44b',
      
      'M436.9 52.4l-94.3 94.3c-23.7-27.4-40.9-60.6-49.2-97.2c41.2-5.3 88.7-4.8 143.5 2.9zM261.9 55c9.5 43.2 29.8 82.4 58.1 114.4l-64 64L138.4 115.8c22.2-19.9 49.1-36.6 81.6-48.7c13-4.8 27-8.9 41.9-12.2zM116.1 138.8L233.4 256l-64 64c-31.6-27.9-70.2-48.1-112.7-57.7c7.5-32.2 19.3-63.5 36.7-92c6.7-11 14.3-21.6 22.8-31.6zm-65.5 155c36.1 8.4 68.9 25.4 96 48.9L52.2 437.2c-6.9-42.8-8.9-93.2-1.5-143.4zM75 459.6l94.3-94.3c23.7 27.4 41 60.6 49.2 97.2c-41.2 5.3-88.7 4.8-143.5-2.9zm175-2.5c-9.5-43.2-29.8-82.4-58.1-114.4l64-64L373.6 396.2c-22.2 19.9-49.1 36.6-81.6 48.7c-13 4.8-27 8.9-41.9 12.2zm145.8-83.8L278.6 256l64-64c31.6 27.9 70.2 48.1 112.8 57.7c-7.5 32.2-19.3 63.5-36.7 92c-6.7 11-14.3 21.6-22.8 31.6zm65.5-155c-36.1-8.4-68.9-25.5-96-48.9l94.5-94.5c6.9 42.8 8.9 93.2 1.5 143.4zM487.6 48.9l-4.4-21.5-21.6-3.6c-103.9-17.4-187-11-252.6 13.3C142.9 61.6 96.7 103.6 66 153.6C5.8 251.8 6.9 378.3 24.4 463.1l4.4 21.5 21.6 3.6c103.9 17.4 187 11 252.6-13.3c66-24.5 112.2-66.5 142.9-116.5c60.2-98.2 59.1-224.7 41.6-309.5z'
      
    ]
  };

  

  
  

  var faSignalBarsFair = {
    prefix: 'fasl',
    iconName: 'signal-bars-fair',
    icon: [
      640,
      512,
      ["signal-alt-2"],
      'f692',
      
      'M224 288V480h32V288H224zm-32-32h32 32 32v32V480v32H256 224 192V480 288 256zM64 416v64H96V416H64zM32 384H64 96h32v32 64 32H96 64 32V480 416 384z'
      
    ]
  };

  
    var faSignalAlt2 = faSignalBarsFair;
  

  
  

  var faDistributeSpacingVertical = {
    prefix: 'fasl',
    iconName: 'distribute-spacing-vertical',
    icon: [
      512,
      512,
      [],
      'e366',
      
      'M512 480l0-32L0 448l0 32 512 0zM128 320l0-128 256 0 0 128-256 0zm256 32l32 0 0-32 0-128 0-32-32 0-256 0-32 0 0 32 0 128 0 32 32 0 256 0zM0 64l512 0 0-32L0 32 0 64z'
      
    ]
  };

  

  
  

  var faCircleLeft = {
    prefix: 'fasl',
    iconName: 'circle-left',
    icon: [
      512,
      512,
      [61840,"arrow-alt-circle-left"],
      'f359',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM256 288l-32 0 0 32 0 18.7L141.3 256 224 173.3l0 18.7 0 32 32 0 96 0 0 64-96 0zM96 256l22.6 22.6L224 384l32 0 0-32 0-32 32 0 64 0 32 0 0-32 0-64 0-32-32 0-64 0-32 0 0-32 0-32-32 0L118.6 233.4 96 256z'
      
    ]
  };

  
    var faArrowAltCircleLeft = faCircleLeft;
  

  
  

  var faCowbellCirclePlus = {
    prefix: 'fasl',
    iconName: 'cowbell-circle-plus',
    icon: [
      576,
      512,
      ["cowbell-more"],
      'f8b4',
      
      'M144 0H128V16 96H64L6.4 384 0 416H32.6h230c-2.9-10.3-4.9-21-5.9-32H39L90.2 128H144 304h53.8l14.9 74.3c10-3.6 20.3-6.3 31-8L384 96H320V16 0H304 144zM256 448c0 17.7-14.3 32-32 32s-32-14.3-32-32H160c0 35.3 28.7 64 64 64c29.2 0 53.9-19.6 61.5-46.4c-3.8-5.7-7.2-11.5-10.3-17.6H256zM288 96H160V32H288V96zm32 272a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 304V288H416v16 48H368 352v32h16 48v48 16h32V432 384h48 16V352H496 448V304z'
      
    ]
  };

  
    var faCowbellMore = faCowbellCirclePlus;
  

  
  

  var faPlaneArrival = {
    prefix: 'fasl',
    iconName: 'plane-arrival',
    icon: [
      640,
      512,
      [128748],
      'f5af',
      
      'M285.9 8.2L281.4 0H272 192 170.8l5.8 20.4 46 160.8-65.8-18.3L135.3 91.4l-2.7-9-9.2-2-72-16L32 60l0 20 .3 132.1 0 8.2 6.6 4.8 112.5 81.3 2.3 1.7 2.7 .8 304.3 86.5c31.8 9 65.4 10 97.7 2.9c40.6-8.9 53.6-60.3 22.1-87.5l-26.7-23.1c-16.1-13.9-35.1-24.1-55.6-29.8l-85.1-23.7L285.9 8.2zM213.2 32l49.4 0L388.5 255.7l3.3 5.8 6.4 1.8 91.5 25.4c15.9 4.4 30.7 12.3 43.2 23.2l26.7 23.1c11.5 9.9 6.7 28.7-8.1 32c-27.1 6-55.3 5.1-82-2.5L167.8 278.7 64.3 203.9 64 100l43.3 9.6 21.3 71 2.5 8.5 8.5 2.4 101.8 28.3 27.5 7.6-7.8-27.5L213.2 32zM16 480H0v32H16 624h16V480H624 16zM176 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faPersonFromPortal = {
    prefix: 'fasl',
    iconName: 'person-from-portal',
    icon: [
      512,
      512,
      ["portal-exit"],
      'e023',
      
      'M128 256c0 37.2-1.4 69-3.9 96h32.1c2.5-27.7 3.8-59.6 3.8-96c0-14.7-.2-28.7-.6-42l.6 .6 11.3-11.3L230.6 144h39.1l15.9 4.5L249.2 257.9c-7.3 21.8 2 45.7 22 57l93.3 52.5L313.4 512h33.9l51.8-146.7 4.5-12.7-11.7-6.6-49.2-27.7c.2-.4 .4-.9 .5-1.3l37.2-111.6 20.3 70.9 3.3 11.6H416h80 16V256H496 428.1L399.4 155.6l-2.4-8.5-8.5-2.4-112-32-2.2-.6H272 224h-6.6l-4.7 4.7-55.5 55.5C148 46.5 116.9 0 80 0C35.8 0 0 66.6 0 256S35.8 512 80 512c23.3 0 44.3-18.6 59-64H105c-12.3 32-23.5 32-25 32h0 0c-1.6 0-13.6 0-26.4-35.8C40.9 409.1 32 349.5 32 256s8.9-153.1 21.5-188.2C66.4 32 78.4 32 80 32l0 0 0 0c1.6 0 13.6 0 26.4 35.8C119.1 102.9 128 162.5 128 256zM352 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 320 56a56 56 0 1 0 112 0zM279.5 268l36.9-110.7 42.2 12.1-44.3 133L286.9 287c-6.7-3.8-9.8-11.7-7.3-19zM197.3 384H112 96v32h16 96 10.7l4.1-9.9 27.4-66.6c-10-6.7-18.2-15.5-24.1-25.4L197.3 384z'
      
    ]
  };

  
    var faPortalExit = faPersonFromPortal;
  

  
  

  var faCalendarPlus = {
    prefix: 'fasl',
    iconName: 'calendar-plus',
    icon: [
      448,
      512,
      [],
      'f271',
      
      'M128 0V16 64H320V16 0h32V16 64h64 32V96v64 32V480v32H416 32 0V480 192 160 96 64H32 96V16 0h32zM416 192H32V480H416V192zm0-96H32v64H416V96zM320 352H304 240v64 16H208V416 352H144 128V320h16 64V256 240h32v16 64h64 16v32z'
      
    ]
  };

  

  
  

  var faPersonSkiingNordic = {
    prefix: 'fasl',
    iconName: 'person-skiing-nordic',
    icon: [
      576,
      512,
      ["skiing-nordic"],
      'f7ca',
      
      'M320 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 288 56a56 56 0 1 0 112 0zM192 112h-6.6l-4.7 4.7-64 64L105.4 192 121 207.6 64.3 476.7c-.2 1.1-.3 2.2-.3 3.3H16 0v32H16l265.4 0h33.9L560 512h16V496 432 416H544v16 48H432.2l29.5-192H464h16V256H464 448.2h-.5H396.1L367.4 155.6l-2.4-8.5-8.5-2.4-112-32-2.2-.6H240 192zM96.4 480l62.3-296 40-40h39.1l15.9 4.5L217.2 257.9c-7.3 21.8 2 45.7 22 57l93.3 52.5L292.7 480H167.2l52.9-139.2c-10.2-6.4-18.6-14.9-24.8-24.7L133 480H96.4zm303.8-2.4c-.1 .8-.2 1.6-.2 2.4H326.6l40.5-114.7 4.5-12.7-11.7-6.6-49.2-27.7c.2-.4 .4-.9 .5-1.3l37.2-111.6 20.3 70.9 3.3 11.6H384h45.3L400.2 477.6zM247.5 268l36.9-110.7 42.2 12.1-44.3 133L254.9 287c-6.7-3.8-9.8-11.7-7.3-19z'
      
    ]
  };

  
    var faSkiingNordic = faPersonSkiingNordic;
  

  
  

  var faArrowDownRight = {
    prefix: 'fasl',
    iconName: 'arrow-down-right',
    icon: [
      384,
      512,
      [],
      'e093',
      
      'M336 416h16V400 176 160H320v16V361.4L67.3 108.7 56 97.4 33.4 120l11.3 11.3L297.4 384H112 96v32h16H336z'
      
    ]
  };

  

  
  

  var faGrate = {
    prefix: 'fasl',
    iconName: 'grate',
    icon: [
      448,
      512,
      [],
      'e193',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM80 96h72 72 72 72 16v16V256 400v16H368 296 224 152 80 64V400 256 112 96H80zM96 240h40V128H96V240zm72 0h40V128H168V240zm72 0h40V128H240V240zm72 0h40V128H312V240zm0 32V384h40V272H312zm-32 0H240V384h40V272zm-72 0H168V384h40V272zm-72 0H96V384h40V272z'
      
    ]
  };

  

  
  

  var faTrafficCone = {
    prefix: 'fasl',
    iconName: 'traffic-cone',
    icon: [
      512,
      512,
      [],
      'f636',
      
      'M221.2 0H232h48 10.8l4 10.1L482.8 480H496h16v32H496 16 0V480H16 29.2l188-469.9 4-10.1zm176 352H114.8L63.6 480H448.4L397.2 352zm-12.8-32L333.2 192H178.8L127.6 320H384.4zM191.6 160H320.4L269.2 32H242.8L191.6 160z'
      
    ]
  };

  

  
  

  var faHouseMedicalCircleCheck = {
    prefix: 'fasl',
    iconName: 'house-medical-circle-check',
    icon: [
      640,
      512,
      [],
      'e511',
      
      'M298.6 12L288 2.7 277.4 12 5.4 252l21.2 24L64 243V496v16H80 394.8c-12.9-9.1-24.5-19.9-34.6-32H96V214.7L288 45.3 458.7 196c12-2.6 24.5-4 37.3-4c2.3 0 4.5 0 6.7 .1L298.6 12zM336 240V192 176H320 256 240v16 48H192 176v16 64 16h16 48v48 16h16 64 2.9c-1.9-10.4-2.9-21.1-2.9-32c0-22.6 4.3-44.2 12-64H320 304v16 48H272V320 304H256 208V272h48 16V256 208h32v48 16h16 28.5c7.6-11.7 16.6-22.4 26.7-32H336zm160 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm78.6-176L552 313.4l-11.3 11.3L480 385.4l-28.7-28.7L440 345.4 417.4 368l11.3 11.3 40 40L480 430.6l11.3-11.3 72-72L574.6 336z'
      
    ]
  };

  

  
  

  var faAlarmExclamation = {
    prefix: 'fasl',
    iconName: 'alarm-exclamation',
    icon: [
      512,
      512,
      [],
      'f843',
      
      'M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5l27-17.2c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1l21.8-23.5C138.4 9.3 116.4 0 92.2 0zM357.1 24.6l21.8 23.5C389.6 38.1 404 32 419.8 32C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3l27 17.2c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM67.3 499.3l42-42C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l42 42L456 510.6 478.6 488l-11.3-11.3-42-42C459.4 395.4 480 344.1 480 288C480 164.3 379.7 64 256 64S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-42 42L33.4 488 56 510.6l11.3-11.3zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm16 64H240v16V320v16h32V320 176 160zM240 400h32V368H240v32z'
      
    ]
  };

  

  
  

  var faTarpDroplet = {
    prefix: 'fasl',
    iconName: 'tarp-droplet',
    icon: [
      576,
      512,
      [],
      'e57c',
      
      'M328 113.5s0 0 0 0c0-.2-.2-2-1.4-5.7c-1.3-3.9-3.4-8.7-6.3-14.3c-5.8-11.3-13.9-24-22.5-36.3c-3.3-4.7-6.6-9.3-9.8-13.5c-3.2 4.3-6.5 8.8-9.8 13.5c-8.6 12.3-16.7 25-22.5 36.3c-2.9 5.6-5 10.5-6.3 14.3c-1.3 3.8-1.4 5.5-1.4 5.7c0 0 0 0 0 0c0 17.7 15.9 35.5 40 35.5s40-17.8 40-35.5zm-112 0c0-24.2 30.3-68.1 51.6-96C279.1 2.4 288-8 288-8s8.9 10.4 20.4 25.5c21.3 27.9 51.6 71.8 51.6 96c0 37.3-32.2 67.5-72 67.5s-72-30.2-72-67.5zM32 128H193.3c1.9 11.5 5.9 22.3 11.5 32H32l0 320 352 0 0-144V320h16H544V160H371.2c5.6-9.7 9.6-20.5 11.5-32H544h32v32V368L432 512H32 0V480 160 128H32zM418.7 480L544 354.7V352H416l0 128h2.7zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faRectangleList = {
    prefix: 'fasl',
    iconName: 'rectangle-list',
    icon: [
      576,
      512,
      ["list-alt"],
      'f022',
      
      'M32 64V448H544V64H32zM0 32H32 544h32V64 448v32H544 32 0V448 64 32zM104 160a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-16h16H464h16v32H464 208 192V144zm0 96h16H464h16v32H464 208 192V240zm0 96h16H464h16v32H464 208 192V336zm-64-56a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-24 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faListAlt = faRectangleList;
  

  
  

  var faDumbbell = {
    prefix: 'fasl',
    iconName: 'dumbbell',
    icon: [
      640,
      512,
      [],
      'f44b',
      
      'M224 64V240v32V448H160V416 384 128 96 64h64zM128 416v32 32h32 64 32V448 272H384V448v32h32 64 32V448 416h64 32V384 272h16 16V240H624 608V128 96H576 512V64 32H480 416 384V64 240H256V64 32H224 160 128V64 96H64 32v32V240H16 0v32H16 32V384v32H64h64zM512 128h64V240v32V384H512V128zM480 416v32H416V272 240 64h64V96v32V384v32zM128 384H64V272 240 128h64V384z'
      
    ]
  };

  

  
  

  var faFaceGrinSquintTears = {
    prefix: 'fasl',
    iconName: 'face-grin-squint-tears',
    icon: [
      512,
      512,
      [129315,"grin-squint-tears"],
      'f586',
      
      'M473.4 75c0 0-.1 .1-.2 .2c0 0-.1 .1-.1 .1c.1-.1 .2-.2 .3-.3zm-1.1-35.3c-10.3-10.3-25.8-9.9-34.8-1.1c0 0 .1 0 .1 0c0 0 0 .1-.2 .3c-.5 .9-2 3.6-4.1 9.3c-2.7 7.4-5.3 17-7.7 27.6c-1 4.5-2 9.1-2.8 13.7c4.6-.9 9.2-1.8 13.7-2.8c10.6-2.3 20.2-4.9 27.6-7.6c5.6-2 8.2-3.5 9.1-4c.2-.1 .3-.2 .3-.2c0 0 0 0 0 0c8.8-9.2 9.2-24.9-1.1-35.3zm23.5 58.2c-11.8 11.8-48.6 20-78.7 25.1c-13.2 2.2-25.2 3.9-33 5c1.1-7.9 2.8-19.8 5.1-33c5.3-30.1 13.7-66.9 25.4-78.7c22-22.1 58-21.6 80.4 .9s22.8 58.6 .9 80.7zM480 256c0-38.9-9.9-75.5-27.3-107.3c10.6-2.4 21.6-5.3 31.6-8.8C502 174.7 512 214.2 512 256c0 141.4-114.6 256-256 256c-42 0-81.6-10.1-116.5-28c3.5-9.9 6.4-20.9 8.9-31.5C180.3 470 217 480 256 480c123.7 0 224-100.3 224-224zM256 0c42 0 81.6 10.1 116.5 28c-3.5 9.9-6.4 20.9-8.9 31.5C331.7 42 295 32 256 32C132.3 32 32 132.3 32 256c0 38.9 9.9 75.5 27.3 107.3c-10.6 2.4-21.6 5.3-31.6 8.8C10 337.3 0 297.8 0 256C0 114.6 114.6 0 256 0zm69.4 325.4c-22 22-45.4 41.3-69.4 57.7c32.6 .7 65.6-11.4 90.7-36.5s37.2-58.1 36.5-90.7c-16.4 24-35.7 47.4-57.7 69.4zm-22.6-22.6c29-29 52.7-60.2 70.7-91.8c6.7-11.7 12.6-23.4 17.6-35c7.6 11.9 13.3 24.6 17.3 37.8c16.1 53.1 3 113.3-39.2 155.5s-102.4 55.3-155.5 39.2c-13.2-4-25.9-9.8-37.8-17.3c11.6-5.1 23.4-11 35-17.6c31.6-18 62.8-41.8 91.8-70.7zm-194.1-4.2l-8.4-30.9 15.4-4.2 62.2-17 27-7.4-7.4 27-17 62.2-4.2 15.4-30.9-8.4 4.2-15.4 9.6-35.2-35.2 9.6-15.4 4.2zM294.3 124.2l-9.6 35.2 35.2-9.6 15.4-4.2 8.4 30.9-15.4 4.2-62.2 17-27 7.4 7.4-27 17-62.2 4.2-15.4 30.9 8.4-4.2 15.4zM38.9 436.7l-.1 .1-.2 .2 .3-.3zm-.3 .3c-8.8 9.2-9.2 24.9 1.1 35.3c10.3 10.3 25.8 9.9 34.8 1.1l0 0c0 0 0 0 0 0c0 0 0-.1 .2-.3c.5-.9 2-3.6 4.1-9.3c2.7-7.4 5.3-17 7.7-27.6c1-4.5 2-9.1 2.8-13.7c-4.6 .9-9.2 1.8-13.7 2.8c-10.6 2.3-20.2 4.9-27.6 7.6c-5.6 2-8.2 3.5-9.1 4l0 0c-.2 .1-.3 .2-.3 .2c0 0 0 0 0 0zm56.3-48c13.2-2.2 25.2-3.9 33-5c-1.1 7.9-2.8 19.8-5.1 33c-5.3 30.1-13.7 66.9-25.4 78.7c-22 22.1-58 21.6-80.4-.9s-22.8-58.6-.9-80.7c11.7-11.8 48.6-20 78.7-25.1z'
      
    ]
  };

  
    var faGrinSquintTears = faFaceGrinSquintTears;
  

  
  

  var faReel = {
    prefix: 'fasl',
    iconName: 'reel',
    icon: [
      448,
      512,
      [],
      'e238',
      
      'M0 0H16 80 368h64 16V32H432 384V96v16H368 80 64V96 32H16 0V0zM96 32V80H352V32H96zM64 144H80 368h16v32H368 80 64V144zm0 64H80 432h16v32H432 80 64V208zm0 64H80 368h16v32H368 80 64V272zm0 64H80 368h16v32H368 80 64V336zM16 512H0V480H16 64V416 400H80 368h16v16 64h48 16v32H432 368 80 16zm80-80v48H352V432H96z'
      
    ]
  };

  

  
  

  var faHardDrive = {
    prefix: 'fasl',
    iconName: 'hard-drive',
    icon: [
      512,
      512,
      [128436,"hdd"],
      'f0a0',
      
      'M32 64V256H480V64H32zm0 224V448H480V288H32zM0 256V64 32H32 480h32V64 256v32V448v32H480 32 0V448 288 256zm320 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faHdd = faHardDrive;
  

  
  

  var faTvMusic = {
    prefix: 'fasl',
    iconName: 'tv-music',
    icon: [
      640,
      512,
      [],
      'f8e6',
      
      'M608 32V416H32V32H608zM32 0H0V32 416v32H32 608h32V416 32 0H608 32zM96 480v32h16H528h16V480H528 112 96zM416 112V88.9L394.4 97l-128 48L256 148.9V160v90.5c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V171.1l96-36v83.4c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V112zM256 292c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12zm112-20c-11.5 0-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12s-4.5 12-16 12z'
      
    ]
  };

  

  
  

  var faArrowRotateLeft = {
    prefix: 'fasl',
    iconName: 'arrow-rotate-left',
    icon: [
      512,
      512,
      [8634,"arrow-left-rotate","arrow-rotate-back","arrow-rotate-backward","undo"],
      'f0e2',
      
      'M48 192H32V176 48 32H64V48v92.6C103.2 75.5 174.5 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-86.4 0-161.4-49-198.8-120.6l28.4-14.8C117.7 406.1 181.9 448 256 448c106 0 192-86 192-192s-86-192-192-192c-71 0-133.1 38.6-166.3 96H176h16v32H176 48z'
      
    ]
  };

  
    var faArrowLeftRotate = faArrowRotateLeft;
  
    var faArrowRotateBack = faArrowRotateLeft;
  
    var faArrowRotateBackward = faArrowRotateLeft;
  
    var faUndo = faArrowRotateLeft;
  

  
  

  var faCookie = {
    prefix: 'fasl',
    iconName: 'cookie',
    icon: [
      512,
      512,
      [127850],
      'f563',
      
      'M105.9 110L49.3 226.7 71.7 354.7l92.8 90.1 127.6 18L406.1 402l56.6-116.7L440.3 157.3 347.4 67.2l-127.6-18L105.9 110zm108-94L362.2 37 470 141.6l26 148.3L430.3 425.3 298.1 496 149.8 475 42 370.4 16 222.1 81.7 86.7 213.9 16zM192 376l-24-24 24-24 24 24-24 24zM136 192l24-24 24 24-24 24-24-24zm152 88l-24-24 24-24 24 24-24 24zm8-152l24-24 24 24-24 24-24-24zm56 248l-24-24 24-24 24 24-24 24z'
      
    ]
  };

  

  
  

  var faOctagonDivide = {
    prefix: 'fasl',
    iconName: 'octagon-divide',
    icon: [
      512,
      512,
      [],
      'e203',
      
      'M32 338.7V173.3L173.3 32H338.7L480 173.3V338.7L338.7 480H173.3L32 338.7zM160 0L0 160V352L160 512H352L512 352V160L352 0H160zM280 136H232v48h48V136zM160 240H144v32h16H352h16V240H352 160zm72 88v48h48V328H232z'
      
    ]
  };

  

  
  

  var faCommentArrowUpRight = {
    prefix: 'fasl',
    iconName: 'comment-arrow-up-right',
    icon: [
      512,
      512,
      [],
      'e145',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM192 152H176v32h16 89.4L172.7 292.7 161.4 304 184 326.6l11.3-11.3L304 206.6V296v16h32V296 168 152H320 192z'
      
    ]
  };

  

  
  

  var faOctagon = {
    prefix: 'fasl',
    iconName: 'octagon',
    icon: [
      512,
      512,
      [128721],
      'f306',
      
      'M173.3 480H338.7L480 338.7V173.3L338.7 32H173.3L32 173.3V338.7L173.3 480zM0 160L160 0H352L512 160V352L352 512H160L0 352V160z'
      
    ]
  };

  

  
  

  var faBorderBottomRight = {
    prefix: 'fasl',
    iconName: 'border-bottom-right',
    icon: [
      448,
      512,
      ["border-style-alt"],
      'f854',
      
      'M448 64l0-16-32 0 0 16 0 384L32 448l-16 0 0 32 16 0 400 0 16 0 0-16 0-400zM344 88l0-48-48 0 0 48 48 0zM152 88l0-48-48 0 0 48 48 0zm96-48l-48 0 0 48 48 0 0-48zM56 88l0-48L8 40 8 88l48 0zm0 144L8 232l0 48 48 0 0-48zm0-48l0-48L8 136l0 48 48 0zm0 144L8 328l0 48 48 0 0-48z'
      
    ]
  };

  
    var faBorderStyleAlt = faBorderBottomRight;
  

  
  

  var faCarBuilding = {
    prefix: 'fasl',
    iconName: 'car-building',
    icon: [
      640,
      512,
      [],
      'f859',
      
      'M32 32H320V144h24 8V32 0H320 32 0V32 448v32H32 224V448H32V32zM275.8 256L288 213.3V208 192H272 208 192v16 64 16h16 16V256 224h32v32h19.8zM80 64H64V80v64 16H80h64 16V144 80 64H144 80zm16 64V96h32v32H96zm96-64V80v64 16h16 64 16V144 80 64H272 208 192zm32 32h32v32H224V96zM80 192H64v16 64 16H80h64 16V272 208 192H144 80zm16 64V224h32v32H96zM80 320H64v16 64 16H80h64 16V400 336 320H144 80zm16 64V352h32v32H96zM331.9 176l-3.3 11.6L299.9 288H288 256v32 96 16 32 48h32V464H608v48h32V464 432 416 320 288H608 596.1L567.4 187.6 564.1 176H552 344 331.9zM608 320v96 16H288V416 320h23.6c.2 0 .5 0 .7 0H583.6c.2 0 .5 0 .7 0H608zM539.9 208l22.9 80H333.2l22.9-80H539.9zM336 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faMessageMusic = {
    prefix: 'fasl',
    iconName: 'message-music',
    icon: [
      512,
      512,
      ["comment-alt-music"],
      'f8af',
      
      'M160 416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448 416zm0-32h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zM352 96V240c0 .5 0 1-.1 1.5c0 .8 .1 1.6 .1 2.5c0 24.3-21.5 44-48 44s-48-19.7-48-44s21.5-44 48-44c5.6 0 11 .9 16 2.5V119.1l-96 36V272c0 .5 0 1-.1 1.5c0 .8 .1 1.6 .1 2.5c0 24.3-21.5 44-48 44s-48-19.7-48-44s21.5-44 48-44c5.6 0 11 .9 16 2.5V144 132.9l10.4-3.9 128-48L352 72.9V96zM192 276c0-4.1-4.5-12-16-12s-16 7.9-16 12s4.5 12 16 12s16-7.9 16-12zm112-20c11.5 0 16-7.9 16-12s-4.5-12-16-12s-16 7.9-16 12s4.5 12 16 12z'
      
    ]
  };

  
    var faCommentAltMusic = faMessageMusic;
  

  
  

  var faCameraViewfinder = {
    prefix: 'fasl',
    iconName: 'camera-viewfinder',
    icon: [
      512,
      512,
      ["screenshot"],
      'e0da',
      
      'M0 0H16 144h16V32H144 32V144v16H0V144 16 0zM320 96l12 32h52 32v32V352v32H384 128 96V352 160 128h32 52l12-32H320zm12 64H309.8L302 139.2 297.8 128H214.2L210 139.2 202.2 160H180 128V352H384V160H332zm-44 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM496 0h16V16 144v16H480V144 32H368 352V0h16H496zM0 512V496 368 352H32v16V480H144h16v32H144 16 0zm496 0H368 352V480h16H480V368 352h32v16V496v16H496z'
      
    ]
  };

  
    var faScreenshot = faCameraViewfinder;
  

  
  

  var faMoneyBillWheat = {
    prefix: 'fasl',
    iconName: 'money-bill-wheat',
    icon: [
      512,
      512,
      [],
      'e52a',
      
      'M224 80v5.3c-18.6-6.6-32-24.4-32-45.3V34.7c18.6 6.6 32 24.4 32 45.3zm32 0c0-38.7-27.5-71-64-78.4C186.8 .6 181.5 0 176 0H160V32v8c0 31.7 18.4 59 45.1 72c-26.7 13-45.1 40.3-45.1 72v8 32h16c5.5 0 10.8-.6 16-1.6c36.5-7.4 64-39.7 64-78.4v-8V104 80zM48 16H32V48H48h64 16V16H112 48zM16 96H0v32H16h96 16V96H112 16zm16 80v32H48h64 16V176H112 48 32zM336 85.3c-18.6-6.6-32-24.4-32-45.3V34.7c18.6 6.6 32 24.4 32 45.3v5.3zM304 1.6C298.8 .6 293.5 0 288 0H272V32v8c0 31.7 18.4 59 45.1 72c-26.7 13-45.1 40.3-45.1 72v8 32h16c5.5 0 10.8-.6 16-1.6c36.5-7.4 64-39.7 64-78.4v-8V104 80c0-38.7-27.5-71-64-78.4zM448 80v5.3c-18.6-6.6-32-24.4-32-45.3V34.7c18.6 6.6 32 24.4 32 45.3zm32 0c0-38.7-27.5-71-64-78.4C410.8 .6 405.5 0 400 0H384V32v8c0 31.7 18.4 59 45.1 72c-26.7 13-45.1 40.3-45.1 72v8 32h16c5.5 0 10.8-.6 16-1.6c36.5-7.4 64-39.7 64-78.4v-8V104 80zM304 189.3V184c0-20.9 13.4-38.7 32-45.3V144c0 20.9-13.4 38.7-32 45.3zM192 184c0-20.9 13.4-38.7 32-45.3V144c0 20.9-13.4 38.7-32 45.3V184zm224 5.3V184c0-20.9 13.4-38.7 32-45.3V144c0 20.9-13.4 38.7-32 45.3zM480 288v48c-26.5 0-48-21.5-48-48h48zM32 368c44.2 0 80-35.8 80-80H400c0 44.2 35.8 80 80 80v32c-44.2 0-80 35.8-80 80H112c0-44.2-35.8-80-80-80V368zM432 480c0-26.5 21.5-48 48-48v48H432zM32 432c26.5 0 48 21.5 48 48H32V432zM80 288c0 26.5-21.5 48-48 48V288H80zM32 256H0v32V480v32H32 480h32V480 288 256H480 32zM224 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faPlusLarge = {
    prefix: 'fasl',
    iconName: 'plus-large',
    icon: [
      512,
      512,
      [],
      'e59e',
      
      'M272 16l0-16H240l0 16 0 224L16 240 0 240v32l16 0 224 0 0 224 0 16h32l0-16 0-224 224 0 16 0 0-32-16 0-224 0 0-224z'
      
    ]
  };

  

  
  

  var faBellSchoolSlash = {
    prefix: 'fasl',
    iconName: 'bell-school-slash',
    icon: [
      640,
      512,
      [],
      'f5d6',
      
      'M541 512l-40.5-32H416V413.3l-32-25.3V480H336 160V383.3C192.3 404 230.8 416 272 416c39.8 0 77-11.2 108.6-30.6L353.5 364c-24.4 12.8-52.1 20-81.5 20c-97.2 0-176-78.8-176-176c0-14.9 1.8-29.3 5.3-43.1L74.2 143.5C67.6 163.8 64 185.5 64 208c0 59 24.6 112.2 64 150.1V496v16h16H336h64 16H528h13zM480 208C480 93.1 386.9 0 272 0c-45.8 0-88.1 14.8-122.5 39.9l26.3 20.7C203.4 42.5 236.5 32 272 32c97.2 0 176 78.8 176 176c0 20.8-3.6 40.8-10.3 59.4L464 288.1c10.3-24.7 16-51.7 16-80.1zM272 128c-3.4 0-6.8 .2-10.1 .6l89.6 70.7C347.2 159.2 313.3 128 272 128zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faBowlingBallPin = {
    prefix: 'fasl',
    iconName: 'bowling-ball-pin',
    icon: [
      576,
      512,
      [],
      'e0c3',
      
      'M403.8 165.2C396.9 146.7 384 108.5 384 82V80c0-44.2 35.8-80 80-80s80 35.8 80 80v2c0 36.2-24 94-24 94l57.3 191.9L536.1 512H391.9l-11.7-40.8c9-9.3 17.3-19.3 24.7-29.9L416 480h96l32-111.9L491.4 192H436.6l-6.4 21.3c-7-17.1-15.9-33.2-26.5-48.1zm88.1-5.2c.5-1.3 1.1-3 1.9-4.9c2.1-5.6 4.9-13.4 7.7-22.2C507.4 114.2 512 94.7 512 82V80c0-26.5-21.5-48-48-48s-48 21.5-48 48v2c0 12.8 4.6 32.2 10.5 50.9c2.8 8.8 5.6 16.6 7.7 22.2c.7 1.9 1.3 3.5 1.9 4.9h55.9zM176 264a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-56-40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56-40a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM384 304A176 176 0 1 0 32 304a176 176 0 1 0 352 0zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304z'
      
    ]
  };

  

  
  

  var faArrowDownAZ = {
    prefix: 'fasl',
    iconName: 'arrow-down-a-z',
    icon: [
      576,
      512,
      ["sort-alpha-asc","sort-alpha-down"],
      'f15d',
      
      'M171.3 467.3L160 478.6l-11.3-11.3-88-88L49.4 368 72 345.4l11.3 11.3L144 417.4V48 32h32V48 417.4l60.7-60.7L248 345.4 270.6 368l-11.3 11.3-88 88zM352 288H480h16v16 8 6.1l-4 4.5L380.5 448H480h16v32H480 352 336V464v-8-6.1l4-4.5L451.5 320H352 336V288h16zm17.5-96l-14.2 32h-35l1.1-2.5 80-180 4.2-9.5h20.8l4.2 9.5 80 180 1.1 2.5h-35l-14.2-32h-93zm78.8-32L416 87.4 383.7 160h64.5z'
      
    ]
  };

  
    var faSortAlphaAsc = faArrowDownAZ;
  
    var faSortAlphaDown = faArrowDownAZ;
  

  
  

  var faCheckDouble = {
    prefix: 'fasl',
    iconName: 'check-double',
    icon: [
      448,
      512,
      [],
      'f560',
      
      'M331.3 75.3L342.6 64 320 41.4 308.7 52.7 160 201.4 91.3 132.7 80 121.4 57.4 144l11.3 11.3 80 80L160 246.6l11.3-11.3 160-160zM437 193.7l11.1-11.5L425 160 414 171.5 162.1 433.8 34.2 300.6 23.1 289.1 0 311.2l11.1 11.5L150.5 468l11.5 12 11.5-12L437 193.7z'
      
    ]
  };

  

  
  

  var faPeopleDressSimple = {
    prefix: 'fasl',
    iconName: 'people-dress-simple',
    icon: [
      512,
      512,
      [],
      'e218',
      
      'M128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 128 0a64 64 0 1 0 0 128zM88.1 192h79.7l45.7 160H42.4L88.1 192zM192 160H64L9.1 352 0 384H33.3 64V496v16H96V496 384h64V496v16h32V496 384h30.7H256h33.3H320V496v16h32V496 384h64V496v16h32V496 384h30.7H512l-9.1-32L448 160H320L265.1 352 256 384l-9.1-32L192 160zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 384 0a64 64 0 1 0 0 128zm-39.9 64h79.7l45.7 160H298.4l45.7-160z'
      
    ]
  };

  

  
  

  var faVestPatches = {
    prefix: 'fasl',
    iconName: 'vest-patches',
    icon: [
      448,
      512,
      [],
      'e086',
      
      'M173.4 69.1l33.4 87.4-17.1 44.8L125 32H80v96 72 4.4l-2.3 3.8L32 284.4V480H160v16 16H16 0V496 280v-4.4l2.3-3.8L48 195.6V128 16 0H64h72 7 4 7.3l3.7 10.6 0 .1c.1 .1 .2 .5 .4 .9c.4 .9 1.1 2.3 2.1 4c2 3.5 5.3 8.3 10.2 13.1C180.2 37.9 196.5 48 224 48s43.8-10.1 53.3-19.4c4.9-4.8 8.2-9.6 10.2-13.1c1-1.7 1.7-3.1 2.1-4c.2-.4 .3-.7 .4-.9l0-.1L293.6 0H301h4 7 72 16V16 128v67.6l45.7 76.2 2.3 3.8V280 496v16H432 208 192V496 288v-3l1.1-2.8L274.6 69.1C261.3 75.6 244.6 80 224 80s-37.3-4.4-50.6-10.9zM323 32L224 291V480H416V284.4l-45.7-76.2-2.3-3.8V200 128 32H323zM112 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM96 233.4l11.3 11.3L120 257.4l12.7-12.7L144 233.4 166.6 256l-11.3 11.3L142.6 280l12.7 12.7L166.6 304 144 326.6l-11.3-11.3L120 302.6l-12.7 12.7L96 326.6 73.4 304l11.3-11.3L97.4 280 84.7 267.3 73.4 256 96 233.4zM312 240c19.6 0 35.9 14.1 39.3 32.7c18.6 3.4 32.7 19.7 32.7 39.3c0 22.1-17.9 40-40 40h-8H288 272V336 288v-8c0-22.1 17.9-40 40-40zm-8 40v8 32h32 8c4.4 0 8-3.6 8-8s-3.6-8-8-8h-8H320V288v-8c0-4.4-3.6-8-8-8s-8 3.6-8 8z'
      
    ]
  };

  

  
  

  var faLaptopBinary = {
    prefix: 'fasl',
    iconName: 'laptop-binary',
    icon: [
      640,
      512,
      [],
      'e5e7',
      
      'M96 64H544V352h32V64 32H544 96 64V64 352H96V64zM32 418.7V416H608v2.7L578.7 448H61.3L32 418.7zM608 384H32 0v32 16l48 48H592l48-48V416 384H608zM176 128H160v16 80 16h16 64 16V224 144 128H240 176zm16 80V160h32v48H192zm112-80H288v32h16v64 16h32V224 144 128H320 304zm80 0v16 80 16h16 64 16V224 144 128H464 400 384zm32 32h32v48H416V160zM192 272H176v32h16v48h32V288 272H208 192zm256 16V272H432 416 400v32h16v48h32V288zm-80 0V272H352 288 272v16 64h32V304h32v48h32V288z'
      
    ]
  };

  

  
  

  var faTent = {
    prefix: 'fasl',
    iconName: 'tent',
    icon: [
      576,
      512,
      [],
      'e57d',
      
      'M32.1 512H0l2.9-32L32 160 288 0 544 176l29 304 3 32H543.9 32.1zM272 480V47.7L62.4 178.7 35 480H272zm32 0H405.4L304 288.4V480zm137.6 0h99.2L513.6 193.9 304 49.8V220L441.6 480z'
      
    ]
  };

  

  
  

  var faAlien = {
    prefix: 'fasl',
    iconName: 'alien',
    icon: [
      448,
      512,
      [128125],
      'f8f5',
      
      'M224 32C118 32 32 118 32 224c0 74.2 47.5 138.1 101.3 186.1c26.3 23.5 52.8 42 72.8 54.6c6.9 4.3 13 8 17.9 10.8c5-2.9 11-6.5 17.9-10.8c19.9-12.6 46.4-31 72.8-54.6C368.5 362.1 416 298.2 416 224c0-106-86-192-192-192zM0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 176-224 288-224 288S0 400 0 224zm352 16H320c-26.5 0-48 21.5-48 48h32c26.5 0 48-21.5 48-48zm-32-32h32 32v32c0 44.2-35.8 80-80 80H272 240V288c0-44.2 35.8-80 80-80zM128 240H96c0 26.5 21.5 48 48 48h32c0-26.5-21.5-48-48-48zm80 48v32H176 144c-44.2 0-80-35.8-80-80V208H96h32c44.2 0 80 35.8 80 80z'
      
    ]
  };

  

  
  

  var faPersonCane = {
    prefix: 'fasl',
    iconName: 'person-cane',
    icon: [
      448,
      512,
      [],
      'e53c',
      
      'M200 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 168 56a56 56 0 1 0 112 0zM124.9 128h-9.6l-4.5 8.5-76.9 144 28.2 15.1L112 202.2V496v16h32V496 352h64V496v16h32V496 183.9l83.8 98.5 24.4-20.7-108.9-128-4.8-5.6h-7.4H124.9zM208 160V320H144V160h64zM368 352c8.8 0 16 7.2 16 16V496v16h32V496 368c0-26.5-21.5-48-48-48s-48 21.5-48 48v8 16h32V376v-8c0-8.8 7.2-16 16-16z'
      
    ]
  };

  

  
  

  var faCloudRainbow = {
    prefix: 'fasl',
    iconName: 'cloud-rainbow',
    icon: [
      576,
      512,
      [],
      'f73e',
      
      'M284.8 196.9C337.4 98.8 440.9 32 560 32h16V0H560C427.8 0 313.1 74.5 255.5 183.9c7.2 4.8 13.9 10.1 20.1 16c3-1.1 6.1-2.1 9.3-3zm160.4 96.2c1.8 .5 3.6 1.1 5.4 1.6C469.3 253.1 511.3 224 560 224h16V192H560c-53 0-99.6 27.1-126.8 68.2c5.4 10.2 9.5 21.3 12 33zm-56.3-81C428.4 161 490.4 128 560 128h16V96H560c-82.5 0-155.5 40.2-200.6 102.2c10.5 3.4 20.4 8.1 29.5 13.9zM384 320v32h32c35.3 0 64 28.7 64 64v64H416 96 32V416c0-27.8 17.8-51.6 42.7-60.4L96 348.1V325.5 304c0-44.2 35.8-80 80-80c27 0 50.9 13.4 65.5 34l17.8 25.2 25.9-16.9c10-6.5 22-10.3 34.9-10.3c35.3 0 64 28.7 64 64zM0 512H32 96 416h64 32V480 416c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 210.8 213.9 192 176 192c-61.9 0-112 50.1-112 112v21.5C26.7 338.6 0 374.2 0 416v64 32z'
      
    ]
  };

  

  
  

  var faCrosshairs = {
    prefix: 'fasl',
    iconName: 'crosshairs',
    icon: [
      512,
      512,
      [],
      'f05b',
      
      'M272 0V16 48.6C374.1 56.4 455.6 137.9 463.4 240H496h16v32H496 463.4C455.6 374.1 374.1 455.6 272 463.4V496v16H240V496 463.4C137.9 455.6 56.4 374.1 48.6 272H16 0V240H16 48.6C56.4 137.9 137.9 56.4 240 48.6V16 0h32zM80.7 272c7.6 84.4 74.8 151.7 159.3 159.3V384 368h32v16 47.3c84.4-7.6 151.7-74.8 159.3-159.3H384 368V240h16 47.3C423.7 155.6 356.4 88.3 272 80.7V128v16H240V128 80.7C155.6 88.3 88.3 155.6 80.7 240H128h16v32H128 80.7zM256 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faMusicMagnifyingGlass = {
    prefix: 'fasl',
    iconName: 'music-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e662',
      
      'M512 208c0 91.8-70.3 167.2-160 175.3v17.8c0 5-.5 9.8-1.5 14.4c46-3.2 87.9-21.3 120.8-49.5L615.9 510.5l22.6-22.6L494 343.3c31.2-36.4 50-83.7 50-135.3C544 93.1 450.9 0 336 0C229 0 140.9 80.8 129.3 184.7l34.1-11.4C179.5 92.7 250.7 32 336 32c97.2 0 176 78.8 176 176zM320 155.1l-21.1 7-192 64L96 229.8v11.5 72V422.5c-9.4-4.1-20.3-6.4-32-6.4c-35.3 0-64 21.5-64 48s28.7 48 64 48c33.7 0 61.4-19.6 63.8-44.4c.1-.8 .2-1.6 .2-2.4v-1.2V324.8l160-53.3v87c-9.4-4.1-20.3-6.4-32-6.4c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48V249.3v-72V155.1zM282.1 391.8c5.5 4.1 5.9 7.4 5.9 8.3s-.4 4.2-5.9 8.3c-5.5 4.1-14.6 7.7-26.1 7.7s-20.5-3.5-26.1-7.7c-5.5-4.1-5.9-7.4-5.9-8.3s.4-4.2 5.9-8.3c5.5-4.1 14.6-7.7 26.1-7.7s20.5 3.5 26.1 7.7zm-192 64c5.5 4.1 5.9 7.4 5.9 8.3s-.4 4.2-5.9 8.3c-5.5 4.1-14.6 7.7-26.1 7.7s-20.5-3.5-26.1-7.7c-5.5-4.1-5.9-7.4-5.9-8.3s.4-4.2 5.9-8.3c5.5-4.1 14.6-7.7 26.1-7.7s20.5 3.5 26.1 7.7zM128 291.1V252.8l160-53.3v38.3L128 291.1z'
      
    ]
  };

  

  
  

  var faTruck = {
    prefix: 'fasl',
    iconName: 'truck',
    icon: [
      640,
      512,
      [9951,128666],
      'f0d1',
      
      'M32 32V384H69.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H384V32H32zM64 416H32 0V384 32 0H32 384h32V32 96h80 7.4l4.8 5.6 96 112 3.9 4.5V224 384h16 16v32H624 608 576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96zM416 224H570.9l-82.3-96H416v96zm0 32v88.4c17-15.2 39.4-24.4 64-24.4c41.8 0 77.4 26.7 90.5 64H576V256H416zM224 416A64 64 0 1 0 96 416a64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faLandmark = {
    prefix: 'fasl',
    iconName: 'landmark',
    icon: [
      512,
      512,
      [127963],
      'f66f',
      
      'M0 192H32 480h32V160 144L256 0 0 144v16 32zM256 36.7L475.2 160H36.8L256 36.7zM64 352H48v32H64 448h16V352H448V224H416V352H336V224H304V352H208V224H176V352H96V224H64V352zM24 448H40 472h16V416H472 40 24v32zM0 480v32H16 496h16V480H496 16 0z'
      
    ]
  };

  

  
  

  var faHouseWindow = {
    prefix: 'fasl',
    iconName: 'house-window',
    icon: [
      576,
      512,
      [],
      'e3b3',
      
      'M298.6 12L288 2.7 277.4 12 5.4 252l21.2 24L64 243V496v16H80 496h16V496 243l37.4 33 21.2-24L298.6 12zM96 480V214.7L288 45.3 480 214.7V480H96zM224 192H208v16V336v16h16H352h16V336 208 192H352 224zm16 128V224h96v96H240z'
      
    ]
  };

  

  
  

  var faHoseReel = {
    prefix: 'fasl',
    iconName: 'hose-reel',
    icon: [
      640,
      512,
      [],
      'e41a',
      
      'M96 256C96 132.3 196.3 32 320 32s224 100.3 224 224v96H512 496v32h16 1.9l12 96H512v32h16 1.9H544h32 14.1H592h16V480H594.1l12-96H608h16V352H608 576V256C576 114.6 461.4 0 320 0S64 114.6 64 256s114.6 256 256 256c57.6 0 110.8-19 153.6-51.2l-19.2-25.6C417 463.3 370.4 480 320 480C196.3 480 96 379.7 96 256zM573.9 384l-12 96h-3.8l-12-96H560h13.9zM464 256a144 144 0 1 1 -288 0 144 144 0 1 1 288 0zM320 80a176 176 0 1 0 0 352 176 176 0 1 0 0-352zm0 240a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z'
      
    ]
  };

  

  
  

  var faFamilyPants = {
    prefix: 'fasl',
    iconName: 'family-pants',
    icon: [
      512,
      512,
      [],
      'e302',
      
      'M128 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM62.7 192L57.4 320H64 96h48v32H96V496v16H64V496 352H56 24l1.3-32L32 160H171.3c-2.2 7.6-3.3 15.7-3.3 24c0 2.7 .1 5.4 .4 8H62.7zM368 352V320h48 32 6.6l-5.3-128H343.6c.2-2.6 .4-5.3 .4-8c0-8.3-1.2-16.4-3.3-24H480l6.7 160 1.3 32H456h-8V496v16H416V496 352H368zM384 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM256 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm48 160H208v96h32 32 32V288zM208 416H176V384 288 256h32 96 32v32 96 32H304v80 16H272V496 416H240v80 16H208V496 416z'
      
    ]
  };

  

  
  

  var faPlateUtensils = {
    prefix: 'fasl',
    iconName: 'plate-utensils',
    icon: [
      640,
      512,
      [58713],
      'e43b',
      
      'M32 16H0V32 176c0 26.5 21.5 48 48 48H64V480v16H96V480 224h16c26.5 0 48-21.5 48-48V32 16H128V32 176c0 8.8-7.2 16-16 16H96V32 16H64V32 192H48c-8.8 0-16-7.2-16-16V32 16zm608 0s-13.6 1.7-32 8.4C570.1 38.4 512 73.8 512 160V288v32h32 64V480v16h32V480 320 304 288 48.5 16zM608 288H544V160c0-50.8 24.4-77.5 49-92.9c5-3.2 10.1-5.8 15-8.1V288zM498 78.9C455.3 39.8 398.4 16 336 16c-54 0-103.9 17.9-144 48v41.9C229.4 70 280.1 48 336 48c58.8 0 112 24.4 149.8 63.7c3-11.9 7.2-22.8 12.2-32.8zM520.6 352C485.9 418.6 416.2 464 336 464c-78 0-146-42.9-181.6-106.4L131.1 381c42.2 69 118.2 115 204.9 115c98.4 0 183-59.2 220-144H544 520.6zM480 256a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-256 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z'
      
    ]
  };

  

  
  

  var faPrescriptionBottleMedical = {
    prefix: 'fasl',
    iconName: 'prescription-bottle-medical',
    icon: [
      384,
      512,
      ["prescription-bottle-alt"],
      'f486',
      
      'M352 32V96H32V32H352zM32 0H0V32 96v32H32 352h32V96 32 0H352 32zm0 160V480v32H64 320h32V480 160H320V480H64V160H32zm133.3 32h-16v16 37.3H112 96v16 53.3 16h16 37.3V368v16h16 53.3 16V368 330.7H272h16v-16V261.3v-16H272 234.7V208 192h-16H165.3zm16 69.3V224h21.3v37.3 16h16H256v21.3H218.7h-16v16V352H181.3V314.7v-16h-16H128V277.3h37.3 16v-16z'
      
    ]
  };

  
    var faPrescriptionBottleAlt = faPrescriptionBottleMedical;
  

  
  

  var faBraille = {
    prefix: 'fasl',
    iconName: 'braille',
    icon: [
      640,
      512,
      [],
      'f2a1',
      
      'M64 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 64 32a64 64 0 1 0 0 128zm160 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0zm64 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM32 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 0 256a64 64 0 1 0 128 0zM192 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 160 96a64 64 0 1 0 128 0zM416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM544 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 512 96a64 64 0 1 0 128 0zM576 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM240 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM80 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCalendarClock = {
    prefix: 'fasl',
    iconName: 'calendar-clock',
    icon: [
      576,
      512,
      ["calendar-time"],
      'e0d2',
      
      'M128 0V16 64H320V16 0h32V16 64h64 32V96v64 32 .7c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7V192H32V480H296.2c10 12.1 21.7 22.9 34.6 32H32 0V480 192 160 96 64H32 96V16 0h32zM416 96H32v64H416V96zm16 384a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 64v16 48h32 16v32H480 432 416V368 304 288h32z'
      
    ]
  };

  
    var faCalendarTime = faCalendarClock;
  

  
  

  var faClockDesk = {
    prefix: 'fasl',
    iconName: 'clock-desk',
    icon: [
      448,
      512,
      [],
      'e134',
      
      'M32 224a192 192 0 1 1 384 0A192 192 0 1 1 32 224zM416 339.4V480H32V339.4C71.2 404.5 142.5 448 224 448s152.8-43.5 192-108.6zM0 224V496v16H16 432h16V496 224C448 100.3 347.7 0 224 0S0 100.3 0 224zM240 96H208v16V224v6.6l4.7 4.7 48 48L272 294.6 294.6 272l-11.3-11.3L240 217.4V112 96z'
      
    ]
  };

  

  
  

  var faCalendarCheck = {
    prefix: 'fasl',
    iconName: 'calendar-check',
    icon: [
      448,
      512,
      [],
      'f274',
      
      'M128 16V0H96V16 64H32 0V96v64 32V480v32H32 416h32V480 192 160 96 64H416 352V16 0H320V16 64H128V16zM32 192H416V480H32V192zm0-96H416v64H32V96zM331.3 283.3L342.6 272 320 249.4l-11.3 11.3L208 361.4l-52.7-52.7L144 297.4 121.4 320l11.3 11.3 64 64L208 406.6l11.3-11.3 112-112z'
      
    ]
  };

  

  
  

  var faPlaneProp = {
    prefix: 'fasl',
    iconName: 'plane-prop',
    icon: [
      576,
      512,
      [],
      'e22b',
      
      'M256 0H242l-1.9 13.9L235.6 48H192 176V64v64 16h16 30.8l-4.9 36.9-67.1 9-6.9-48.2-2-13.7H128 64 50.1l-2 13.7-9.1 63.5C16.3 211.2 0 231.9 0 256s16.3 44.8 39.1 50.8l9.1 63.5 2 13.7H64h64 13.9l2-13.7 6.9-48.2 67.1 9 4.9 36.9H192 176v16 64 16h16 43.6l4.5 34.1L242 512h14 64 14l1.8-13.9 8.8-66.1H368v32 16h32V464 432h16V400H400V368 352H368v16 32H348.9l8.5-64 108.8 0c20.6 0 46.8-8.1 67.9-20.8C554.4 303.1 576 282.9 576 256c0-13.4-5.7-25.2-13.3-34.8s-17.7-17.6-28.4-24c-21-12.8-47.3-21.2-68-21.2H357.5l-8.5-64H368v32 16h32V144 112h16V80H400V48 32H368V48 80H344.7l-8.8-66.1L334 0H320 256zM208 400h19.1l4.3 32H208V400zm0-320h23.3l-4.3 32H208V80zm117.2 96H256h-1.1l-1.1 .1-3.2 .4L270 32h36l19.2 144zm0 160L306 480H270L250.7 335.4l3.2 .4 1.1 .1H256h69.2zM69.1 221.3L77.9 160h36.2l7.2 50.1 2.2 15.7 15.7-2.1L257.1 208H466.3c13.5 0 34.1 6.1 51.3 16.6c8.5 5.2 15.4 10.9 20 16.7c4.6 5.8 6.3 10.7 6.3 14.8c0 9.1-8.2 20.9-26.3 31.8c-17.2 10.3-37.8 16.2-51.4 16.2l-209.3 0L139.2 288.3l-15.7-2.1-2.2 15.7L114.1 352H77.9l-8.8-61.3-1.7-12-12-1.6-5.6-.7C39.6 275 32 266.3 32 256s7.6-19 17.8-20.4l5.6-.7 12-1.6 1.7-12z'
      
    ]
  };

  

  
  

  var faNfcSignal = {
    prefix: 'fasl',
    iconName: 'nfc-signal',
    icon: [
      512,
      512,
      [],
      'e1fb',
      
      'M416 64H32V448H231.1c-2.4 10.5-4.2 21.1-5.4 32H32 0V448 64 32H32 416h32V64 231.1c-10.9 2.5-21.6 5.6-32 9.3V64zm-32 48V253.9c-11.1 5.5-21.8 11.7-32 18.6V128H240v82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112 96h16H368h16v16zM240.4 416H80 64V400 112 96H80h64 16v32H144 96V384H253.9c-5.1 10.3-9.7 21-13.5 32zM224 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm288 48c-123.7 0-224 100.3-224 224H256c0-141.4 114.6-256 256-256v32zM480 448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-96 64H352c0-88.4 71.6-160 160-160v32c-70.7 0-128 57.3-128 128z'
      
    ]
  };

  

  
  

  var faStarSharpHalfStroke = {
    prefix: 'fasl',
    iconName: 'star-sharp-half-stroke',
    icon: [
      576,
      512,
      ["star-sharp-half-alt"],
      'e28d',
      
      'M304.9 51.8l46.7 143.8H502.8h54.4l-44 32L390.9 316.4l46.7 143.8L454.4 512l-44-32L288.1 391.1 165.7 480l-44 32 16.8-51.8 46.7-143.8L62.9 227.6l-44-32H73.3 224.5L271.2 51.8 288.1 0l16.8 51.8zm46.7 175.8H328.3l-7.2-22.1L304 152.6V363.2l2.9 2.1 86.7 63L360.4 326.3l-7.2-22.1 18.8-13.7 86.7-63H351.6zM272 363.2V153l-17.1 52.5-7.2 22.1H224.5 117.4l86.7 63 18.8 13.7-7.2 22.1L182.6 428.2l86.7-63 2.8-2z'
      
    ]
  };

  
    var faStarSharpHalfAlt = faStarSharpHalfStroke;
  

  
  

  var faWater = {
    prefix: 'fasl',
    iconName: 'water',
    icon: [
      576,
      512,
      [],
      'f773',
      
      'M133.8 106.8C150.3 118.1 171.1 128 192 128s41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C342.3 118.1 363.1 128 384 128s41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C534.4 118 555.1 128 576 128v32c-30.3 0-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.9 9.9-19.8 15.3C441.5 145.9 414.3 160 384 160s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 145.9 222.3 160 192 160s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C57.6 145.9 30.3 160 0 160V128c20.9 0 41.6-9.9 58.2-21.2C72.9 96.8 84.1 85.3 96 72.5c11.9 12.7 23.2 24.3 37.8 34.2zm0 288C150.3 406.1 171.1 416 192 416s41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C342.3 406.1 363.1 416 384 416s41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C534.4 406.1 555.1 416 576 416v32c-30.3 0-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.9 9.9-19.8 15.3C441.5 433.9 414.3 448 384 448s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 433.9 222.3 448 192 448s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C57.6 433.9 30.3 448 0 448V416c20.9 0 41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.7 23.2 24.3 37.8 34.2zM192 272c20.9 0 41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C342.3 262.1 363.1 272 384 272s41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C534.4 262 555.1 272 576 272v32c-30.3 0-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.9 9.9-19.8 15.3C441.5 289.9 414.3 304 384 304s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 289.9 222.3 304 192 304s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C57.6 289.9 30.3 304 0 304V272c20.9 0 41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.7 23.2 24.3 37.8 34.2C150.3 262.1 171.1 272 192 272z'
      
    ]
  };

  

  
  

  var faWaveform = {
    prefix: 'fasl',
    iconName: 'waveform',
    icon: [
      640,
      512,
      [],
      'f8f1',
      
      'M434.3 64H462l1.9 13.8 34.6 254 29.8-158.8 2.4-13.1h25.4l3.3 11.6L588.1 272H624h16v32H624 576 563.9l-3.3-11.6-13.4-46.8L511.7 434.9 509.3 448H482l-1.9-13.8L447 191.4l-47.2 307L397.7 512H370l-1.8-13.9L320 137.1 271.9 498.1 270 512H242.3l-2.1-13.6L193 191.4 159.9 434.2 158 448H130.7l-2.4-13.1L92.8 245.6 79.4 292.4 76.1 304H64 16 0V272H16 51.9L80.6 171.6 83.9 160h25.3l2.4 13.1 29.8 158.8 34.6-254L178 64h27.7l2.1 13.6 47.1 305.9L304.1 13.9 306 0h28l1.8 13.9 49.3 369.5L432.2 77.6 434.3 64z'
      
    ]
  };

  

  
  

  var faTricycleAdult = {
    prefix: 'fasl',
    iconName: 'tricycle-adult',
    icon: [
      640,
      512,
      [],
      'e5c4',
      
      'M304 64H288V96h16 47.5l88.4 130.7L376 312H353.9L27.8 232.5l-15.5-3.8L4.7 259.8l15.5 3.8 26 6.3C18.5 286.7 0 317.2 0 352c0 53 43 96 96 96c18 0 34.9-5 49.3-13.6c-.4 .3-.9 .5-1.3 .8c14.1 8.2 30.5 12.8 48 12.8c53 0 96-43 96-96c0-8.2-1-16.2-3-23.9l63.2 15.4 1.9 .5H352h32 8l4.8-6.4 62.1-82.8 18.8 27.8C459.4 300 448 324.7 448 352c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-14.2 0-27.7 3.1-39.8 8.6L373.3 71l-4.8-7H360 304zM480 352c0-16.2 6.1-31.1 16-42.4L530.7 361l9 13.3 26.5-17.9-9-13.3-34.7-51.3c6.7-2.4 13.9-3.7 21.5-3.7c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64zM246.7 318.8c5.9 9.7 9.3 21 9.3 33.2c0 35.3-28.7 64-64 64c-7.5 0-14.7-1.3-21.3-3.6l0 0C184 395.9 192 374.9 192 352c0-18.3-5.1-35.4-14-50l68.7 16.8zM62.9 106.1L56.9 91.2 27.2 103.1l5.9 14.9 32 80 2.9 7.2 7.5 2.2 112 32.8 15.4 4.5 9-30.7-15.4-4.5L92 178.8 62.9 106.1zM96 416s0 0 0 0c-1.1 0-2.2 0-3.3-.1C58.9 414.2 32 386.2 32 352c0-34.7 27.6-63 62.1-64c.5 0 1 0 1.5 0c.1 0 .3 0 .4 0c0 0 0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64z'
      
    ]
  };

  

  
  

  var faFileEps = {
    prefix: 'fasl',
    iconName: 'file-eps',
    icon: [
      512,
      512,
      [],
      'e644',
      
      'M352 192v96h32V152L232 0H32 0V32 480v32H32 96V480H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM160 352v16 64 64 16h16 64 16V480H240 192V448h32 16V416H224 192V384h48 16V352H240 176 160zm144 0H288v16 80 48 16h32V496 464h16c30.9 0 56-25.1 56-56s-25.1-56-56-56H304zm32 80H320V384h16c13.3 0 24 10.7 24 24s-10.7 24-24 24zm117.7-80c-25.2 0-45.7 20.4-45.7 45.7c0 17.3 9.8 33.1 25.2 40.8l31.2 15.6c4.6 2.3 7.6 7 7.6 12.2c0 7.5-6.1 13.7-13.7 13.7H424 408v32h16 34.3c25.2 0 45.7-20.4 45.7-45.7c0-17.3-9.8-33.1-25.2-40.8l-31.2-15.6c-4.6-2.3-7.6-7-7.6-12.2c0-7.5 6.1-13.7 13.7-13.7H480h16V352H480 453.7z'
      
    ]
  };

  

  
  

  var faHandHoldingDroplet = {
    prefix: 'fasl',
    iconName: 'hand-holding-droplet',
    icon: [
      576,
      512,
      ["hand-holding-water"],
      'f4c1',
      
      'M236.8 121.6C228.5 132.7 224 146.2 224 160c0 35.3 28.7 64 64 64s64-28.7 64-64c0-13.8-4.5-27.3-12.8-38.4L288 53.3l-51.2 68.3zm-25.6-19.2L268 26.7 288 0l20 26.7 56.8 75.7C377.3 119 384 139.2 384 160c0 53-43 96-96 96s-96-43-96-96c0-20.8 6.7-41 19.2-57.6zM171.2 304H176 384h16v16 64h.2l103.6-61.7 13.5-8 8.3 13.3 40 64L574 405l-13.5 8.5-152 96-3.9 2.5H400 16 0V480H16 395.4L530 395l-23.3-37.2-94 56L409 416h-4.4H400 384 320 304 256 240V384h16 48 16 48V336H180.8l-92 61.3-4 2.7H80 16 0V368H16 75.2l92-61.3 4-2.7z'
      
    ]
  };

  
    var faHandHoldingWater = faHandHoldingDroplet;
  

  
  

  var faSquare4 = {
    prefix: 'fasl',
    iconName: 'square-4',
    icon: [
      448,
      512,
      [],
      'e259',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM113.1 298.1l68-170.1h34.5l-.8 1.9L151.6 288H256V208 192h32v16 80h16 16v32H304 288v48 16H256V368 320H128 104.4l8.8-21.9z'
      
    ]
  };

  

  
  

  var faBuoyMooring = {
    prefix: 'fasl',
    iconName: 'buoy-mooring',
    icon: [
      576,
      512,
      [],
      'e5b6',
      
      'M272 0h32V64h64 13.2l2.5 13L444 393.6c-6.5 4.3-12.5 7.9-19.3 11c-3.4 1.5-6.8 3-10.4 4.3L397.4 320H178.6l-16.9 88.9c-3.5-1.3-7-2.7-10.4-4.3c-6.8-3.1-12.8-6.7-19.3-11L192.3 77l2.5-13H208h64V0zM221.2 96L184.7 288H391.3L354.8 96H304 272 221.2zM192 480c20.9 0 41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C342.3 470.1 363.1 480 384 480s41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C534.4 470.1 555.1 480 576 480v32c-30.3 0-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.9 9.9-19.8 15.3C441.5 497.9 414.3 512 384 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 497.9 222.3 512 192 512s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.8-19.8 15.3C57.6 497.9 30.3 512 0 512V480c20.9 0 41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.7 23.2 24.3 37.8 34.2C150.3 470.1 171.1 480 192 480z'
      
    ]
  };

  

  
  

  var faArrowDown19 = {
    prefix: 'fasl',
    iconName: 'arrow-down-1-9',
    icon: [
      576,
      512,
      ["sort-numeric-asc","sort-numeric-down"],
      'f162',
      
      'M160 478.6l11.3-11.3 88-88L270.6 368 248 345.4l-11.3 11.3L176 417.4V48 32H144V48 417.4L83.3 356.7 72 345.4 49.4 368l11.3 11.3 88 88L160 478.6zM368 32V64h16 32V192H384 368v32h16 48 48 16V192H480 448V48 32H432 384 368zm60 360a52 52 0 1 1 0-104 52 52 0 1 1 0 104zm-84-52c0 46.4 37.6 84 84 84c2 0 3.9-.1 5.8-.2l-42.4 53.5c-.7 .9-1.2 1.7-1.7 2.7h40.4l61.7-77.9c13.1-16.5 20.2-37 20.2-58.1h-.1c.1-1.3 .1-2.7 .1-4c0-46.4-37.6-84-84-84s-84 37.6-84 84z'
      
    ]
  };

  
    var faSortNumericAsc = faArrowDown19;
  
    var faSortNumericDown = faArrowDown19;
  

  
  

  var faSleigh = {
    prefix: 'fasl',
    iconName: 'sleigh',
    icon: [
      640,
      512,
      [],
      'f7cc',
      
      'M16 32H0V64H16 32V256c0 59.6 40.8 109.8 96 124v68H48 32v32H48 624h16V464 384 368H608v16 64H448V384c70.7 0 128-57.3 128-128V128h16 16V96H592 576 544 528 480 448v32 64 32H416h-6.6c-80.5 0-155.3-41.5-198-109.7C179.6 63.4 124 32.4 64 32l-1 0H56 32 16zM416 448H160V384H416v64zM528 128h16V256c0 53-43 96-96 96H160c-53 0-96-43-96-96V64c48.9 .4 94.3 25.7 120.3 67.2C232.8 208.9 317.9 256 409.4 256H448h32V224 128h48z'
      
    ]
  };

  

  
  

  var faCarOn = {
    prefix: 'fasl',
    iconName: 'car-on',
    icon: [
      512,
      512,
      [],
      'e4dd',
      
      'M272 24v80 16H240V104 24 8h32V24zM139.9 176H152 360h12.1l3.3 11.6L404.1 288H416h32v32V432v16h0v64H416V464h0H96v48H64V464h0V432 320 288H96h11.9l28.7-100.4 3.3-11.6zM392.4 320c-.2 0-.5 0-.7 0H120.4c-.2 0-.5 0-.7 0H96V432H416V320H392.4zM347.9 208H164.1l-22.9 80H370.8l-22.9-80zM144 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm200 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM56 33.4L67.3 44.7l48 48L126.6 104 104 126.6 92.7 115.3l-48-48L33.4 56 56 33.4zM444.7 44.7L456 33.4 478.6 56 467.3 67.3l-48 48L408 126.6 385.4 104l11.3-11.3 48-48z'
      
    ]
  };

  

  
  

  var faMeteor = {
    prefix: 'fasl',
    iconName: 'meteor',
    icon: [
      512,
      512,
      [9732],
      'f753',
      
      'M304 16L270.4 35.4 101.3 133.4C38.6 169.7 0 236.6 0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3l97.9-169.1L496 208l-25 1.9L457.3 211l-21.2 1.6 11.8-33L498.1 38.9 512 0 473.1 13.9 332.4 64.1l-33 11.8L301 54.7 302.1 41 304 16zM117.3 161.1L267.4 74.1l-3.7 48.5 46.5-16.6 149-53.2-53.2 149-16.6 46.5 48.5-3.7L350.9 394.7C320.4 447.5 264 480 203 480c-94.4 0-171-76.5-171-171c0-61 32.5-117.4 85.3-148zM296 312a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM200 184a128 128 0 1 0 0 256 128 128 0 1 0 0-256zm8 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm16 88a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCartArrowUp = {
    prefix: 'fasl',
    iconName: 'cart-arrow-up',
    icon: [
      576,
      512,
      [],
      'e3ee',
      
      'M0 0H16 80 92.8l2.8 12.5L151 256H476L541.9 32h33.4L503.4 276.5 500 288H488 158.2l14.5 64H496h16v32H496 160 147.2l-2.8-12.5L67.2 32H16 0V0zM184 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm296 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM304 208V86.6l-36.7 36.7L256 134.6 233.4 112l11.3-11.3 64-64L320 25.4l11.3 11.3 64 64L406.6 112 384 134.6l-11.3-11.3L336 86.6V208v16H304V208z'
      
    ]
  };

  

  
  

  var faSquareVirus = {
    prefix: 'fasl',
    iconName: 'square-virus',
    icon: [
      448,
      512,
      [],
      'e578',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM200 208a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-69.6 87.5l-.1 .1-16.8 16.8-33.9-33.9 17.1-17.1c16.6-16.8 4.7-45.4-19-45.4h-24V232h24c23.7 0 35.7-28.6 19.1-45.4l-17.1-17.1 33.9-33.9 16.8 16.8 .1 .1c16.8 16.8 45.6 4.9 45.6-18.9l0-.2V109.6h48v24.2c.2 23.6 28.6 35.4 45.4 18.8l17.1-17.1 16.8 16.8 .1 .1 .1 .1 16.8 16.8-16.8 16.8-.1 .1c-16.8 16.8-4.9 45.6 18.9 45.6l24 0v48l-24 0c-23.8 0-35.7 28.8-18.9 45.6l.1 .1 16.8 16.8-16.8 16.8-.1 .1-.1 .1-16.8 16.8-17.1-17.1c-16.8-16.6-45.3-4.7-45.4 18.9v24.2H200V378.6l0-.2c0-23.8-28.8-35.7-45.6-18.9zm4.2-38.1c25-6.4 52.2 4.8 65.4 27.1c13.1-22.2 40.4-33.5 65.4-27.1c-6.4-25 4.9-52.2 27.1-65.4c-22.3-13.1-33.5-40.4-27.1-65.4c-9.6 2.5-19.4 2.3-28.7 0c-15-3.8-28.6-13.3-36.7-27.1c-13.1 22.2-40.4 33.5-65.4 27.1c6.4 25-4.9 52.2-27.1 65.4c22.2 13.1 33.5 40.4 27.1 65.4z'
      
    ]
  };

  

  
  

  var faCamera = {
    prefix: 'fasl',
    iconName: 'camera',
    icon: [
      512,
      512,
      [62258,"camera-alt"],
      'f030',
      
      'M160 32H352l21.3 64H480h32v32V448v32H480 32 0V448 128 96H32 138.7L160 32zm213.3 96H350.3L343 106.1 328.9 64H183.1l-14 42.1L161.7 128H138.7 32V448H480V128H373.3zM256 176a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm80 112a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  
    var faCameraAlt = faCamera;
  

  
  

  var faCameraPolaroid = {
    prefix: 'fasl',
    iconName: 'camera-polaroid',
    icon: [
      576,
      512,
      [],
      'f8aa',
      
      'M480 256v9.7l5.4 8.1L516.2 320H59.8l30.8-46.2 5.4-8.1V256 64H480V256zM32 361.7l6.5-9.7H537.5l6.5 9.7V448H32V361.7zM576 448V352l-64-96V64 32H480 96 64V64 256L0 352v96 32H32 544h32V448zM336 192a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160zM96 384v32h16H464h16V384H464 112 96zM440 104H392v48h48V104z'
      
    ]
  };

  

  
  

  var faCloudMeatball = {
    prefix: 'fasl',
    iconName: 'cloud-meatball',
    icon: [
      512,
      512,
      [],
      'f73b',
      
      'M176 0c37.1 0 70 18.9 90.3 48.1c.4 .6 .8 1.2 1.3 1.8c.5-.3 1-.7 1.5-1c14.8-9.7 32.2-15.3 50.9-15.3c53 0 96 45.1 96 100.8c53 0 96 45.1 96 100.8V304v32H480 416h-9.5l-11.9-7.9-1.4-.9 .3-1.6 4.3-21.5H416h64V235.2c0-39.5-30.1-68.8-64-68.8H384v-32c0-39.5-30.1-68.8-64-68.8c-12.6 0-24.3 3.9-34.3 10.7L259 94.6 241 67.8C226.2 45.7 202.3 32 176 32c-42.7 0-80 36.8-80 85.6v22.5 22.3l-20.9 7.7C50.7 179.2 32 204.3 32 235.2V304H96h18.1l4.3 21.5 .3 1.6-1.4 .9L105.5 336H96 32 0V304 235.2c0-43.9 26.7-81.2 64-95.1V117.6C64 52.7 114.1 0 176 0zm64 256h32 8.6l4.8 7.1 12.8 19.2 22.6-4.5 8.4-1.7 6.1 6.1 22.6 22.6 6.1 6.1-1.7 8.4-4.5 22.6 19.2 12.8 7.1 4.7V368v32 8.6l-7.1 4.7-19.2 12.8 4.5 22.6 1.7 8.4-6.1 6.1-22.6 22.6-6.1 6.1-8.4-1.7-22.6-4.5-12.8 19.2-4.8 7.1H272 240h-8.6l-4.8-7.1-12.8-19.2-22.6 4.5-8.4 1.7-6.1-6.1-22.6-22.6-6.1-6.1 1.7-8.4 4.5-22.6-19.2-12.8-7.1-4.7V400 368v-8.6l7.1-4.7 19.2-12.8-4.5-22.6-1.7-8.4 6.1-6.1 22.6-22.6 6.1-6.1 8.4 1.7 22.6 4.5 12.8-19.2 4.8-7.1H240zm-5.4 53l-5.9 8.9-10.5-2.1-24.7-4.9-10.5 10.5 4.9 24.7 2.1 10.5-8.9 5.9-21 14v14.9l21 14 8.9 5.9-2.1 10.5-4.9 24.7 10.5 10.5 24.7-4.9 10.5-2.1 5.9 8.9 14 21h14.9l14-21 5.9-8.9 10.5 2.1 24.7 5 10.5-10.5-5-24.7-2.1-10.5 8.9-5.9 21-14V376.6l-21-14-8.9-5.9 2.1-10.5 4.9-24.7-10.5-10.5-24.7 4.9-10.5 2.1-5.9-8.9-14-21H248.6l-14 21zM464 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM64 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 416a48 48 0 1 1 96 0A48 48 0 1 1 0 416z'
      
    ]
  };

  

  
  

  var faMessageHeart = {
    prefix: 'fasl',
    iconName: 'message-heart',
    icon: [
      512,
      512,
      [],
      'e5c9',
      
      'M160 448V416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448zm0-64h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zm88.3-254.8l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L256 304.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2zm79.3 61.6c5.3-5.1 8.3-12.2 8.3-19.6c0-15-12.2-27.2-27.2-27.2h-2.4c-7.7 0-15 3-20.5 8.3l-7.7 7.4L256 181l-22.2-21.3-7.7-7.4c-5.5-5.3-12.9-8.3-20.5-8.3h-2.4c-15 0-27.2 12.2-27.2 27.2c0 7.4 3 14.5 8.3 19.6L256 259.7l71.7-68.9z'
      
    ]
  };

  

  
  

  var faHammerCrash = {
    prefix: 'fasl',
    iconName: 'hammer-crash',
    icon: [
      640,
      512,
      [],
      'e414',
      
      'M284.9 359.8l7.4-33.8 13.4 6.7 28.6 14.3 6.8-13.5 33.3-15.6L397 307.1l15.8 19.4 37 45.4L463.4 315l5.8-24.3 25-.2 58.5-.6-36-46.1L501.3 224l15.4-19.7 36-46.1-58.5-.6-25-.2L463.4 133 449.8 76.1l-21.4 26.3-6-3L399 87.7l41.4-50.9L465.8 5.6l9.4 39.2 19.3 80.8 83 .8 40.3 .4L593 158.6 541.9 224 593 289.4l24.8 31.8-40.3 .4-83 .8-19.3 80.8-9.4 39.2-25.4-31.3L388 346.7 312.8 382l-36.5 17.1 8.6-39.4zM42.9 129.7L305.7 261.1l59.4-118.8L176.4 48H83.8L42.9 129.7zM28.6 158.3L0 144l14.3-28.6L64 16H184l195.4 97.7L408 128l-14.3 28.6L334.3 275.4 320 304l0 0-28.6-14.3L28.6 158.3zm80.5 76l28.6 14.3L43 438.2l28.6 14.3L166.4 263 195 277.3 100.2 466.8 85.9 495.5 57.3 481.1 28.7 466.8 .1 452.5l14.3-28.6 94.8-189.6z'
      
    ]
  };

  

  
  

  var faFishingRod = {
    prefix: 'fasl',
    iconName: 'fishing-rod',
    icon: [
      448,
      512,
      [],
      'e3a8',
      
      'M272 0h-2.4l-2.3 .7-208 64L48 68.2V80 288H32 0v32V480v32H32 96h32V480 320 288H96 80V91.8L274.4 32H320V136v16h32V136 16 0H336 272zm71.2 177.7l-7.2-3.6-7.2 3.6c-17.9 8.9-43.7 27.1-65.2 53.4C242 257.5 224 292.9 224 336c0 33.2 14.9 80.2 57.1 115L259.5 478l-3.5 4.4V488v8 16h16H400h16V496v-8-5.6l-3.5-4.4L390.9 451c42.3-34.8 57.1-81.7 57.1-115c0-43.1-18-78.5-39.6-104.9c-21.5-26.3-47.4-44.4-65.2-53.4zM256 336c0-33.7 14-62.3 32.4-84.7c15.6-19 33.8-33 47.6-41.1c13.8 8.1 32 22.1 47.6 41.1C402 273.7 416 302.3 416 336c0 27.3-13.9 70-56.9 98.7l-14.5 9.7L355.5 458l17.6 22H298.9l17.6-22 10.9-13.6-14.5-9.7C269.9 406 256 363.3 256 336zM32 320H96V480H32V320zm352-8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faCircleInfo = {
    prefix: 'fasl',
    iconName: 'circle-info',
    icon: [
      512,
      512,
      ["info-circle"],
      'f05a',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 352v32h16 96 16V352H304 272V240 224H256 216 200v32h16 24v96H208 192zm88-168V136H232v48h48z'
      
    ]
  };

  
    var faInfoCircle = faCircleInfo;
  

  
  

  var faSlashBack = {
    prefix: 'fasl',
    iconName: 'slash-back',
    icon: [
      320,
      512,
      [],
      '5c',
      
      'M1.8 0H38.3L318.2 512H281.7L1.8 0z'
      
    ]
  };

  

  
  

  var faUserDoctor = {
    prefix: 'fasl',
    iconName: 'user-doctor',
    icon: [
      448,
      512,
      ["user-md"],
      'f0f0',
      
      'M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm128-96A128 128 0 1 1 96 128a128 128 0 1 1 256 0zM43.3 480H404.7L360.4 336H320v34.3c23.1 6.9 40 28.3 40 53.7v24 16H344 328 312V432h16v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8h16v32H280 264 248V448 424c0-25.4 16.9-46.8 40-53.7V336H176v34.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V336H87.6L43.3 480zM160 400a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM64 304H384l54.2 176 9.8 32H414.5 33.5 0l9.8-32L64 304z'
      
    ]
  };

  
    var faUserMd = faUserDoctor;
  

  
  

  var faMeterBolt = {
    prefix: 'fasl',
    iconName: 'meter-bolt',
    icon: [
      640,
      512,
      [],
      'e1e9',
      
      'M480 256c0 1.4 0 2.8 0 4.2l30.7-30.7C497.4 100.6 388.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c72.4 0 137.9-30.1 184.4-78.5l.2-1.5H394.6c-38.1 30.1-86.3 48-138.6 48C132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224zM176 144V128H144v16 64 16h32V208 144zm96 0V128H240v16 64 16h32V208 144zm96 0V128H336v16 64 16h32V208 144zm200 80h-6.6l-4.7 4.7-136 136-4.7 4.7V376v8 16h16 45.6l-13.4 93.7L461.6 512H480h8 6.6l4.7-4.7 136-136 4.7-4.7V360v-8V336H624 578.4l13.4-93.7 2.6-18.3H576h-8zM462.6 368l92.1-92.1-10.5 73.8L541.6 368H560h33.4l-92.1 92.1 10.5-73.8 2.6-18.3H496 462.6z'
      
    ]
  };

  

  
  

  var faHouseChimneyBlank = {
    prefix: 'fasl',
    iconName: 'house-chimney-blank',
    icon: [
      576,
      512,
      [],
      'e3b0',
      
      'M298.6 12L288 2.7 277.4 12 5.4 252l21.2 24L64 243V496v16H80 496h16V496 243l37.4 33 21.2-24-58.9-52h.3V48 32H496 400 384V48 87.4L298.6 12zM416 115.6V64h64V172.1l-64-56.5zM96 480V214.7L288 45.3 480 214.7V480H96z'
      
    ]
  };

  

  
  

  var faHouseHeart = {
    prefix: 'fasl',
    iconName: 'house-heart',
    icon: [
      576,
      512,
      ["home-heart"],
      'f4c9',
      
      'M298.6 12L288 2.7 277.4 12 5.4 252l21.2 24L64 243V496v16H80 496h16V496 243l37.4 33 21.2-24L298.6 12zM96 480V214.7L288 45.3 480 214.7V480H96zM280.3 241.2c-11.5-11-26.8-17.2-42.7-17.2h-2.4c-32.7 0-59.2 26.5-59.2 59.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L288 416.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2h-2.4c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4zm79.3 61.6L288 371.7l-71.7-68.9c-5.3-5.1-8.3-12.2-8.3-19.6c0-15 12.2-27.2 27.2-27.2h2.4c7.7 0 15 3 20.5 8.3l7.7 7.4L288 293l22.2-21.3 7.7-7.4c5.5-5.3 12.9-8.3 20.5-8.3h2.4c15 0 27.2 12.2 27.2 27.2c0 7.4-3 14.5-8.3 19.6z'
      
    ]
  };

  
    var faHomeHeart = faHouseHeart;
  

  
  

  var faFileXmark = {
    prefix: 'fasl',
    iconName: 'file-xmark',
    icon: [
      384,
      512,
      ["file-times"],
      'f317',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM127.4 248.8l-22.6 22.6 11.3 11.3L169.4 336l-53.3 53.3-11.3 11.3 22.6 22.6 11.3-11.3L192 358.6l53.3 53.3 11.3 11.3 22.6-22.6-11.3-11.3L214.6 336l53.3-53.3 11.3-11.3-22.6-22.6-11.3 11.3L192 313.4l-53.3-53.3-11.3-11.3z'
      
    ]
  };

  
    var faFileTimes = faFileXmark;
  

  
  

  var faMountain = {
    prefix: 'fasl',
    iconName: 'mountain',
    icon: [
      512,
      512,
      [127956],
      'f6fc',
      
      'M32 448H480V417.9L369.8 256H264l-43.2 57.6-12.4 16.5L195.5 314l-50.1-62.7L32 417.9V448zM348 224L256 88.9 164.2 223.7l43.4 54.2 35.6-47.5L248 224h8 92zM0 448V408L236.6 60.4 256 32l19.4 28.4L512 408v40 32H480 32 0V448z'
      
    ]
  };

  

  
  

  var faHourglass = {
    prefix: 'fasl',
    iconName: 'hourglass',
    icon: [
      384,
      512,
      [9203,62032,"hourglass-empty"],
      'f254',
      
      'M16 0H0V32H16 32V144v7.8l6.2 4.8L165.9 256 38.2 355.4 32 360.2V368 480H16 0v32H16 48 336h32 16V480H368 352V368v-7.8l-6.2-4.8L218.1 256l127.8-99.4 6.2-4.8V144 32h16 16V0H368 336 48 16zM320 32V136.2L192 235.7 64 136.2V32H320zM192 276.3l128 99.6V480H64V375.8l128-99.6z'
      
    ]
  };

  
    var faHourglassEmpty = faHourglass;
  

  
  

  var faNfcTrash = {
    prefix: 'fasl',
    iconName: 'nfc-trash',
    icon: [
      640,
      512,
      [],
      'e1fd',
      
      'M32 64H416V200.2L429.4 160H448V64 32H416 32 0V64 448v32H32 381.6l-2.3-32H32V64zm352 48V96H368 224 208v16 98.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V128H352v80h32V112zm-6.9 304l-8-112H352v80H96V128h48 16V96H144 80 64v16V400v16H80 368h9.1zM240 256a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm212.5-64l-3.6 10.9L436.5 240H400 384v32h16 48H576h48 16V240H624 587.5l-12.4-37.1L571.5 192H560 464 452.5zm17.7 48l5.3-16h72.9l5.3 16H470.2zm-69 64.1L416 512H608l14.9-207.9H590.8L578.2 480H445.8L433.2 304.1H401.1z'
      
    ]
  };

  

  
  

  var faTruckFieldUn = {
    prefix: 'fasl',
    iconName: 'truck-field-un',
    icon: [
      640,
      512,
      [],
      'e58e',
      
      'M64 64v64V288v64h5.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H352V256 224 64H64zM32 352V288H0V128H32V64 32H64 352h32V64 96h72 9.1l4.7 7.8 72 120 .1 .2H576h32v32 96h16 16v32H624 608 576c0 53-43 96-96 96s-96-43-96-96H352 256c0 53-43 96-96 96s-96-43-96-96H32 16 0V352H16 32zM384 128v96H504.5l-57.6-96H384zm0 128v96h5.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H576V256H384zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144 128h32v16 64c0 26.5-21.5 48-48 48s-48-21.5-48-48V144 128h32v16zm112-16h8 9.9l4.4 8.8L288 188.2V144 128h32v16 96 16H304h-8-9.9l-4.4-8.8L256 195.8V240v16H224V240 144 128h16zM224 384A64 64 0 1 0 96 384a64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faPuzzlePieceSimple = {
    prefix: 'fasl',
    iconName: 'puzzle-piece-simple',
    icon: [
      640,
      512,
      ["puzzle-piece-alt"],
      'e231',
      
      'M128 64h16H288h16V80v23.5 9.8l-8.8 4.4C280.5 125.2 272 138.3 272 152c0 20.2 19.4 40 48 40s48-19.8 48-40c0-13.7-8.5-26.8-23.2-34.2l-8.8-4.4v-9.8V80 64h16H496h16V80 208h12.7c10.9-18.3 28.9-32 51.3-32c19.4 0 35.8 10.5 46.7 25.1s17.3 34.1 17.3 54.9s-6.3 40.2-17.3 54.9s-27.3 25.1-46.7 25.1c-22.4 0-40.4-13.7-51.3-32H512V432v16H496 352 336V432 408.5v-9.8l8.8-4.4c14.7-7.4 23.2-20.5 23.2-34.2c0-20.2-19.4-40-48-40s-48 19.8-48 40c0 13.7 8.5 26.8 23.2 34.2l8.8 4.4v9.8V432v16H288 144 128V432 304H115.3c-10.9 18.3-28.9 32-51.3 32c-19.4 0-35.8-10.5-46.7-25.1S0 276.8 0 256s6.3-40.2 17.3-54.9S44.6 176 64 176c22.4 0 40.4 13.7 51.3 32H128V80 64zm32 32V224v16H144 105.6 95.1l-4.2-9.6C84.2 215 73.4 208 64 208c-7.1 0-14.7 3.8-21.1 12.3S32 241.5 32 256s4.4 27.1 10.9 35.7S56.9 304 64 304c9.4 0 20.2-7 26.9-22.4l4.2-9.6h10.5H144h16v16V416H269.7C252 403.1 240 383.2 240 360c0-41.7 37.9-72 80-72s80 30.3 80 72c0 23.2-12 43.1-29.7 56H480V288 272h16 38.4 10.5l4.2 9.6C555.8 297 566.6 304 576 304c7.1 0 14.7-3.8 21.1-12.3s10.9-21.1 10.9-35.7s-4.4-27.1-10.9-35.7s-14.1-12.3-21.1-12.3c-9.4 0-20.2 7-26.9 22.4l-4.2 9.6H534.4 496 480V224 96H370.3C388 108.9 400 128.8 400 152c0 41.7-37.9 72-80 72s-80-30.3-80-72c0-23.2 12-43.1 29.7-56H160z'
      
    ]
  };

  
    var faPuzzlePieceAlt = faPuzzlePieceSimple;
  

  
  

  var faTreeDeciduous = {
    prefix: 'fasl',
    iconName: 'tree-deciduous',
    icon: [
      512,
      512,
      [127795,"tree-alt"],
      'f400',
      
      'M177.7 95.6L174 113.4l-17.2-5.9c-6.5-2.2-13.5-3.5-20.8-3.5c-35.3 0-64 28.7-64 64c0 13.2 4 25.4 10.8 35.6l11.5 17.2-19.5 6.8C49.9 236.3 32 260.1 32 288v64H240V144 128h32v16V352H480V288c0-27.9-17.9-51.7-42.8-60.4l-19.5-6.8 11.5-17.2C436 193.4 440 181.2 440 168c0-35.3-28.7-64-64-64c-7.3 0-14.3 1.2-20.8 3.5L338 113.4l-3.7-17.8C326.8 59.3 294.5 32 256 32s-70.8 27.3-78.3 63.6zM240 384H16 0V368 288c0-35.3 19.1-66.2 47.5-82.8c-4.8-11.4-7.5-24-7.5-37.2c0-53 43-96 96-96c5.1 0 10.1 .4 14.9 1.2C166.7 30.4 207.8 0 256 0s89.3 30.4 105.1 73.2c4.9-.8 9.9-1.2 14.9-1.2c53 0 96 43 96 96c0 13.2-2.7 25.7-7.5 37.2C492.9 221.8 512 252.7 512 288v80 16H496 272V496v16H240V496 384z'
      
    ]
  };

  
    var faTreeAlt = faTreeDeciduous;
  

  
  

  var faIndent = {
    prefix: 'fasl',
    iconName: 'indent',
    icon: [
      448,
      512,
      [],
      'f03c',
      
      'M0 48H16 432h16V80H432 16 0V48zM192 176h16H432h16v32H432 208 192V176zm16 128H432h16v32H432 208 192V304h16zM0 432H16 432h16v32H432 16 0V432zM116.7 236.3L144 256l-27.3 19.7L32 336.9 0 360V320.5 191.5 152l32 23.1 84.7 61.2zM32 214.6v82.8L89.3 256 32 214.6z'
      
    ]
  };

  

  
  

  var faCommentMusic = {
    prefix: 'fasl',
    iconName: 'comment-music',
    icon: [
      512,
      512,
      [],
      'f8b0',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM352 128V104.9L330.4 113l-128 48L192 164.9V176v90.5c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V187.1l96-36v83.4c-5-1.6-10.4-2.5-16-2.5c-26.5 0-48 19.7-48 44s21.5 44 48 44s48-19.7 48-44c0-.8 0-1.6-.1-2.5c0-.5 .1-1 .1-1.5V128zM192 308c0 4.1-4.5 12-16 12s-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12zm112-20c-11.5 0-16-7.9-16-12s4.5-12 16-12s16 7.9 16 12s-4.5 12-16 12z'
      
    ]
  };

  

  
  

  var faRugbyBall = {
    prefix: 'fasl',
    iconName: 'rugby-ball',
    icon: [
      512,
      512,
      [],
      'e3c6',
      
      'M336 48h59.2L242.4 121.8 240 123l-1.9 1.9L124.9 238.1 123 240l-1.2 2.4L48 395.2V336C48 176.9 176.9 48 336 48zM77 447.7L64.3 435l85.2-176.3L258.8 149.5 435 64.3 447.7 77 362.5 253.2 253.2 362.5 77 447.7zM116.8 464l152.8-73.8L272 389l1.9-1.9L387.1 273.9 389 272l1.2-2.4L464 116.8V176c0 159.1-128.9 288-288 288H116.8zM496 80L432 16H336C159.3 16 16 159.3 16 336v96l64 64h96c176.7 0 320-143.3 320-320V80z'
      
    ]
  };

  

  
  

  var faMessageMedical = {
    prefix: 'fasl',
    iconName: 'message-medical',
    icon: [
      512,
      512,
      ["comment-alt-medical"],
      'f7f4',
      
      'M160 448V416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448zm0-64h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zM224 96h64 16v16 48h48 16v16 64 16H352 304v48 16H288 224 208V304 256H160 144V240 176 160h16 48V112 96h16zm16 80v16H224 176v32h48 16v16 48h32V240 224h16 48V192H288 272V176 128H240v48z'
      
    ]
  };

  
    var faCommentAltMedical = faMessageMedical;
  

  
  

  var faReflectHorizontal = {
    prefix: 'fasl',
    iconName: 'reflect-horizontal',
    icon: [
      512,
      512,
      [],
      'e664',
      
      'M272 0l0 16 0 480 0 16-32 0 0-16 0-480 0-16 32 0zM169.4 233.4L192 256l-22.6 22.6L32 416 0 416l0-32L0 128 0 96l32 0L169.4 233.4zM32 370.7L146.7 256 32 141.3l0 229.5zM320 256l22.6-22.6L480 96l32 0 0 32 0 256 0 32-32 0L342.6 278.6 320 256zm45.3 0L480 370.7l0-229.5L365.3 256z'
      
    ]
  };

  

  
  

  var faParachuteBox = {
    prefix: 'fasl',
    iconName: 'parachute-box',
    icon: [
      512,
      512,
      [],
      'f4cd',
      
      'M512 224c0-10.4-.9-21.1-2.7-32C494.2 101.9 415.9 0 256 0S17.8 101.9 2.7 192C.9 202.9 0 213.6 0 224H32 49.1L160 341.4V352 480v32h32H320h32V480 352 341.4L462.9 224H480h32zm-93.1 0l-90.7 96H320 272V224h95.5 32 19.3zM240 224v96H192h-8.2L93.1 224h19.3 32H240zm0 128h32 48V480H192V352h48zM35.2 192C46.3 135.7 86.8 73.6 165.5 46.2c-29.9 35-50 87-53.1 145.8H35.2zM180.5 79.1C202.5 47.4 229.7 32 256 32s53.5 15.4 75.5 47.1c19.6 28.3 33.4 67.8 36 112.9H144.5c2.7-45.1 16.4-84.5 36-112.9zm166-32.9C425.2 73.6 465.7 135.7 476.8 192H399.6c-3.1-58.8-23.1-110.8-53.1-145.8z'
      
    ]
  };

  

  
  

  var faCircleNodes = {
    prefix: 'fasl',
    iconName: 'circle-nodes',
    icon: [
      512,
      512,
      [],
      'e4e2',
      
      'M376.2 121.7l0 0c7 4 15.2 6.3 23.8 6.3c2.6 0 5.2-.2 7.6-.6l0 0C430.5 123.7 448 103.9 448 80c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 .7 0 1.3 0 2l0 0c.5 11.4 4.9 21.7 11.9 29.7l0 0c3.5 4 7.6 7.4 12.2 10zm-5.9 32.6c-15.2-6.1-28.2-16.8-37.1-30.3L158.7 193.7c.8 4.6 1.3 9.4 1.3 14.3c0 14.4-3.8 27.9-10.5 39.6l138 120.8c13-9.9 29.2-16 46.7-16.3l36-197.7zm-4.5 203.4C395.2 369.5 416 398.3 416 432c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-14.4 3.8-27.9 10.5-39.6l-138-120.8C115 281.9 98.2 288 80 288c-44.2 0-80-35.8-80-80s35.8-80 80-80c27.9 0 52.5 14.3 66.8 36L321.3 94.3c-.8-4.6-1.3-9.4-1.3-14.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 43.6-34.9 79.1-78.3 80l-36 197.7zm-246-122.9c.7-1 1.3-2 1.9-3.1c4-7 6.3-15.1 6.3-23.8c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48c8.5 0 16.6-2.2 23.5-6.2l0 0c6.5-3.7 12.1-8.8 16.3-15zM291.4 414.2c-2.2 5.5-3.4 11.5-3.4 17.8c0 26.5 21.5 48 48 48s48-21.5 48-48s-21.5-48-48-48c-14 0-26.6 6-35.3 15.5c-2.7 2.9-5 6.1-6.9 9.6c-.9 1.6-1.7 3.4-2.4 5.1l0 0z'
      
    ]
  };

  

  
  

  var faCircleWifiCircleWifi = {
    prefix: 'fasl',
    iconName: 'circle-wifi-circle-wifi',
    icon: [
      640,
      512,
      ["circle-wifi-group"],
      'e67e',
      
      'M256 32c102.1 0 188.3 68.3 215.2 161.7c8.1-1.1 16.4-1.7 24.8-1.7c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c39.5 0 77-9 110.4-25c-7.4-8-14-16.8-19.8-26.1c-27.7 12.2-58.3 19-90.5 19C132.3 480 32 379.7 32 256S132.3 32 256 32zm0 112c-68.1 0-129.4 29.4-171.9 76.1l22.7 22.7c36.6-41 89.9-66.8 149.2-66.8c51.5 0 98.5 19.5 134 51.5c8.8-6.6 18.2-12.5 28.2-17.4C376.3 169.2 319.1 144 256 144zm0 96c-41.5 0-78.3 19.7-101.7 50.3l22.9 22.9C194.5 288.3 223.4 272 256 272c30.1 0 57 13.9 74.6 35.6c4-10.9 9-21.3 14.9-31C322.5 253.9 290.9 240 256 240zm24 128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm95.9-164.8C568.4 320.7 534.2 304 496 304s-72.4 16.7-95.9 43.2l24.4 20.7C442.1 348.3 467.6 336 496 336s53.9 12.3 71.4 31.9l24.4-20.7zM496 360c-21.3 0-40.6 8.3-54.9 21.8l24.7 20.9C474 396 484.5 392 496 392s22 4 30.2 10.7l24.7-20.9C536.6 368.3 517.3 360 496 360zm0 92a20 20 0 1 0 0-40 20 20 0 1 0 0 40z'
      
    ]
  };

  
    var faCircleWifiGroup = faCircleWifiCircleWifi;
  

  
  

  var faArrowTurnDownLeft = {
    prefix: 'fasl',
    iconName: 'arrow-turn-down-left',
    icon: [
      512,
      512,
      [],
      'e2e1',
      
      'M480 48V32h32V48 288v16H496 54.6L155.3 404.7 166.6 416 144 438.6l-11.3-11.3-128-128L-6.6 288 4.7 276.7l128-128L144 137.4 166.6 160l-11.3 11.3L54.6 272H480V48z'
      
    ]
  };

  

  
  

  var faBorderNone = {
    prefix: 'fasl',
    iconName: 'border-none',
    icon: [
      448,
      512,
      [],
      'f850',
      
      'M8 424l0 48 48 0 0-48L8 424zM104 88l48 0 0-48-48 0 0 48zm0 384l48 0 0-48-48 0 0 48zm0-240l0 48 48 0 0-48-48 0zM296 472l48 0 0-48-48 0 0 48zm0-432l0 48 48 0 0-48-48 0zm0 240l48 0 0-48-48 0 0 48zM200 424l0 48 48 0 0-48-48 0zm0-336l48 0 0-48-48 0 0 48zm0 144l0 48 48 0 0-48-48 0zM392 472l48 0 0-48-48 0 0 48zm0-384l48 0 0-48-48 0 0 48zM8 40L8 88l48 0 0-48L8 40zM392 280l48 0 0-48-48 0 0 48zM8 232l0 48 48 0 0-48L8 232zM200 376l48 0 0-48-48 0 0 48zm192-48l0 48 48 0 0-48-48 0zM8 376l48 0 0-48L8 328l0 48zM392 136l0 48 48 0 0-48-48 0zM8 184l48 0 0-48L8 136l0 48zm192-48l0 48 48 0 0-48-48 0z'
      
    ]
  };

  

  
  

  var faCircleSmall = {
    prefix: 'fasl',
    iconName: 'circle-small',
    icon: [
      320,
      512,
      [],
      'e122',
      
      'M160 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 288a160 160 0 1 0 0-320 160 160 0 1 0 0 320z'
      
    ]
  };

  

  
  

  var faBottleBaby = {
    prefix: 'fasl',
    iconName: 'bottle-baby',
    icon: [
      512,
      512,
      [],
      'e673',
      
      'M176 64l32-16c0-26.5 21.5-48 48-48s48 21.5 48 48l32 16 0 32 16 0 0 32 0 32 21.8 21.8c27 27 42.2 63.6 42.2 101.8L416 480l0 32-32 0-256 0-32 0 0-32 0-196.4c0-38.2 15.2-74.8 42.2-101.8L160 160l0-32 0-32 16 0 0-32zm32 32l96 0 0-12.2-14.3-7.2L272 67.8 272 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 19.8-17.7 8.8L208 83.8 208 96zm-16 32l0 32 128 0 0-32-16 0-96 0-16 0zm-31.2 76.5c-21 21-32.8 49.5-32.8 79.2l0 4.4 128 0 0 32-128 0 0 64 128 0 0 32-128 0 0 64 256 0 0-196.4c0-29.7-11.8-58.2-32.8-79.2L338.7 192 320 192l-128 0-18.7 0-12.5 12.5z'
      
    ]
  };

  

  
  

  var faLitecoinSign = {
    prefix: 'fasl',
    iconName: 'litecoin-sign',
    icon: [
      384,
      512,
      [],
      'e1d3',
      
      'M96 48V32H64V48 227.5l-51.9 13-15.5 3.9 7.8 31 15.5-3.9 44.1-11V464v16H80 368h16V448H368 96V252.5l179.9-45 15.5-3.9-7.8-31-15.5 3.9L96 219.5V48z'
      
    ]
  };

  

  
  

  var faH6 = {
    prefix: 'fasl',
    iconName: 'h6',
    icon: [
      640,
      512,
      [],
      'e413',
      
      'M32 80V64H0V80 256 432v16H32V432 272H288V432v16h32V432 256 80 64H288V80 240H32V80zM487.9 64L383.3 207.8C363 235.7 352 269.4 352 304c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144c-15 0-29.6 2.3-43.2 6.6L527.4 64H487.9zM496 192a112 112 0 1 1 0 224 112 112 0 1 1 0-224z'
      
    ]
  };

  

  
  

  var faCircleY = {
    prefix: 'fasl',
    iconName: 'circle-y',
    icon: [
      512,
      512,
      [],
      'e12f',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 293.5V384v16h32V384 293.5L387.8 144H347.4L256 261.9 164.6 144H124.2L240 293.5z'
      
    ]
  };

  

  
  

  var faAppleCore = {
    prefix: 'fasl',
    iconName: 'apple-core',
    icon: [
      384,
      512,
      [],
      'e08f',
      
      'M178.3 128H160V109.7 96 80c0-44.2 35.8-80 80-80h16 13.7H288V18.3 32 48c0 44.2-35.8 80-80 80H192 178.3zM240 32c-26.5 0-48 21.5-48 48V96h16c26.5 0 48-21.5 48-48V32H240zM80 128l112 32 112-32c13.9 0 26.4 2.8 37.7 7.8c10.5 4.7 19.9 11.4 28.2 19.5c-9.2 5.8-17.7 12.4-25.7 19.8C309.6 207.2 288 253.1 288 304c0 53.7 24.1 101.8 62 134.1c4.8 4.1 9.7 7.9 14.9 11.4c-6.7 8.8-14 16.8-21.6 24C317.2 498 286.6 512 256 512l-64-16-64 16c-30.6 0-61.2-14-87.3-38.6c-7.6-7.1-14.8-15.2-21.6-24c5.2-3.5 10.2-7.3 14.9-11.4C71.9 405.8 96 357.7 96 304c0-50.9-21.6-96.8-56.2-128.9c-7.9-7.4-16.5-14-25.7-19.8c8.2-8.2 17.6-14.8 28.2-19.5c11.2-5 23.8-7.8 37.7-7.8zm120.8 62.8l-8.8 2.5-8.8-2.5L75.9 160.1c-1.8 .1-3.5 .3-5.2 .5C106.2 197.9 128 248.4 128 304c0 58.3-24 111-62.6 148.7c19.4 17.3 40.2 26.2 59 27.2L184.2 465 192 463l7.8 1.9 59.8 14.9c18.8-1 39.6-9.9 59-27.2C280 415 256 362.3 256 304c0-55.6 21.8-106.1 57.3-143.4c-1.7-.2-3.4-.4-5.2-.5L200.8 190.8z'
      
    ]
  };

  

  
  

  var faArrowUp91 = {
    prefix: 'fasl',
    iconName: 'arrow-up-9-1',
    icon: [
      576,
      512,
      ["sort-numeric-up-alt"],
      'f887',
      
      'M428 64a52 52 0 1 0 0 104 52 52 0 1 0 0-104zm-84 52c0-46.4 37.6-84 84-84s84 37.6 84 84c0 1.3 0 2.7-.1 4h.1c0 21.1-7.1 41.6-20.2 58.1L430.1 256H389.7c.5-.9 1-1.8 1.7-2.7l42.4-53.5c-1.9 .1-3.9 .2-5.8 .2c-46.4 0-84-37.6-84-84zM160 33.4l11.3 11.3 88 88L270.6 144 248 166.6l-11.3-11.3L176 94.6V464v16H144V464 94.6L83.3 155.3 72 166.6 49.4 144l11.3-11.3 88-88L160 33.4zM368 320V288h16 48 16v16V448h32 16v32H480 432 384 368V448h16 32V320H384 368z'
      
    ]
  };

  
    var faSortNumericUpAlt = faArrowUp91;
  

  
  

  var faPersonPinball = {
    prefix: 'fasl',
    iconName: 'person-pinball',
    icon: [
      640,
      512,
      [],
      'e21d',
      
      'M104 56A24 24 0 1 0 56 56a24 24 0 1 0 48 0zM24 56a56 56 0 1 1 112 0A56 56 0 1 1 24 56zm8 136l0 95.6 48 33V176H32v0h0l0 16zM80 359.4l-48-33L32 496l0 16L0 512l0-16L0 304.4l0 0V296 160 144H16 96h8.7l4.7 7.3L176.7 256h29.7l316.4-60.8-42-126.1-.8-2.5V64 16 0h16H624h16V16 172.6 192 400v96 16H608V496 416H224v80 16H192V496 400 288H168h-8.7l-4.7-7.3L112 214.5V342.6l41.1 28.2 6.9 4.8V384 496v16H128V496 392.4L80.9 360H80v-.6zM608 178.8V32H512V61.4l42.6 127.7L608 178.8zM224 285.2V288v96H608V211.4L224 285.2zM288 304a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faLungs = {
    prefix: 'fasl',
    iconName: 'lungs',
    icon: [
      640,
      512,
      [129729],
      'f604',
      
      'M384 245.8l-48-30.5V16 0H304V16 215.2l-48 30.5V128 96H224 152c-26.9 35.8-51.5 73.2-73.8 112.1C42.3 271.1 0 348.4 0 423c0 49.1 39.8 89 89 89c38.2 0 78.8-12.6 117.7-24.7c16.8-5.2 33.4-10.4 49.3-14.3V321.6L224 342V448.6c-9.4 2.8-19 5.7-28.4 8.7c-10.9 3.4-21.4 6.6-31.1 9.4C136.9 474.6 111.8 480 89 480c-31.5 0-57-25.5-57-57c0-64.7 37.2-134.6 74-199c18.9-33.2 39.7-65.1 62.1-96H224V266.1l-88.6 56.4-13.5 8.6 17.2 27 13.5-8.6L224 304.1l32-20.4L320 243l64 40.7 32 20.4 71.4 45.4 13.5 8.6 17.2-27-13.5-8.6L416 266.1V128h55.9c22.5 30.9 43.2 62.8 62.1 96c36.8 64.4 74 134.3 74 199c0 31.5-25.5 57-57 57c-22.8 0-47.9-5.4-75.5-13.3c-9.7-2.8-20.2-6-31.1-9.4c-9.4-2.9-19-5.9-28.4-8.7V342l-32-20.4V473c15.9 4 32.5 9.1 49.3 14.3C472.2 499.4 512.8 512 551 512c49.1 0 89-39.8 89-89c0-74.6-42.3-152-78.2-214.9C539.5 169.2 514.9 131.8 488 96H416 384v32V245.8z'
      
    ]
  };

  

  
  

  var faRibbon = {
    prefix: 'fasl',
    iconName: 'ribbon',
    icon: [
      448,
      512,
      [127895],
      'f4d6',
      
      'M256 112H224 192v32 3.6L426.5 408.1 448 432l-26.2 18.7L336 512 48 192V128L136 0h56 32 32 56l88 128v64l-62.5 69.4L316 237.5l52-57.8V137.9L295.2 32H288 256 192 160h-7.2L80 137.9v41.8L340.7 469.3l59.6-42.6L168.2 169l-8.2-9.1V147.6 112 80h32 64 32v32 35.6 12.3l-8.2 9.1-12.7 14.1-21.5-23.9L256 147.6V144 112zM110.5 309.3L132 333.2 47.7 426.8l59.6 42.6 73.6-81.8 21.5 23.9L112 512 26.2 450.7 0 432l21.5-23.9 88.9-98.8z'
      
    ]
  };

  

  
  

  var faLockA = {
    prefix: 'fasl',
    iconName: 'lock-a',
    icon: [
      448,
      512,
      [],
      'e422',
      
      'M128 128v64H320V128c0-53-43-96-96-96s-96 43-96 96zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h64 32v32V480v32H416 32 0V480 224 192H32 96zM32 480H416V224H32V480zm232.7-80H183.3l-21.9 48H126.2l1.2-2.6 82-180 4.3-9.4h20.6l4.3 9.4 82 180 1.2 2.6H286.6l-21.9-48zm-14.6-32L224 310.6 197.8 368h52.3z'
      
    ]
  };

  

  
  

  var faArrowRightToCity = {
    prefix: 'fasl',
    iconName: 'arrow-right-to-city',
    icon: [
      640,
      512,
      [],
      'e4b3',
      
      'M304 0H288V16 496v16h32V496 32H480V208v16h16 48 32 32V496v16h32V496 208 192H624 576V112 96H544v16 80H512V16 0H496 304zm48 64V80v64 16h16 64 16V144 80 64H432 368 352zm32 32h32v32H384V96zM496 256H480v16 64 16h16 64 16V336 272 256H560 496zm16 64V288h32v32H512zm-32 64v16 64 16h16 64 16V464 400 384H560 496 480zm32 32h32v32H512V416zM368 192H352v16 64 16h16 64 16V272 208 192H432 368zm16 64V224h32v32H384zm-32 64v16 64 16h16 64 16V400 336 320H432 368 352zm32 32h32v32H384V352zM155.3 148.7L144 137.4 121.4 160l11.3 11.3L201.4 240H16 0v32H16 201.4l-68.7 68.7L121.4 352 144 374.6l11.3-11.3 96-96L262.6 256l-11.3-11.3-96-96z'
      
    ]
  };

  

  
  

  var faChartLineDown = {
    prefix: 'fasl',
    iconName: 'chart-line-down',
    icon: [
      512,
      512,
      [128201],
      'f64d',
      
      'M32 48V32H0V48 464v16H16 496h16V448H496 32V48zM336 352H464h16V336 208 192H448v16 89.4L331.3 180.7 320 169.4l-11.3 11.3L224 265.4 123.3 164.7 112 153.4 89.4 176l11.3 11.3 112 112L224 310.6l11.3-11.3L320 214.6 425.4 320H336 320v32h16z'
      
    ]
  };

  

  
  

  var faPaperclip = {
    prefix: 'fasl',
    iconName: 'paperclip',
    icon: [
      448,
      512,
      [128206],
      'f0c6',
      
      'M380.7 67.3c-29.1-29.1-76.3-29.1-105.4 0l-192 192c-46.8 46.8-46.8 122.6 0 169.4s122.6 46.8 169.4 0l152-152L416 265.4 438.6 288l-11.3 11.3-152 152c-59.3 59.3-155.4 59.3-214.6 0S1.4 296 60.7 236.7l192-192c41.6-41.6 109-41.6 150.6 0s41.6 109 0 150.6L219.5 379.1c-28.2 28.2-74.6 25.6-99.6-5.5c-21.3-26.6-19.2-65 4.9-89.1L276.7 132.7 288 121.4 310.6 144l-11.3 11.3L147.5 307.1c-12.6 12.6-13.7 32.6-2.6 46.5c13 16.2 37.2 17.6 51.9 2.9L380.7 172.7c29.1-29.1 29.1-76.3 0-105.4z'
      
    ]
  };

  

  
  

  var faBinRecycle = {
    prefix: 'fasl',
    iconName: 'bin-recycle',
    icon: [
      576,
      512,
      [],
      'e5f7',
      
      'M544 64V96H511.9 64.1 32V64H544zM32 128h2.7L64 480H512l29.3-352H544h32V96 64 32H544 32 0V64 96v32H32zm34.8 0H509.2L482.6 448H93.4L66.8 128zM288 192c5 0 9.7 2.4 12.6 6.4l39.8 54 27.2-17-41.2-56c-9-12.2-23.2-19.4-38.4-19.4s-29.4 7.2-38.4 19.4l-41.2 56 27.2 17 39.8-54c3-4 7.6-6.4 12.6-6.4zm-98.7 69.2L153 310.5c-5.8 7.9-9 17.5-9 27.4c0 25.5 20.6 46.1 46.1 46.1H272V352H190.1c-7.8 0-14.1-6.3-14.1-14.1c0-3 1-5.9 2.8-8.4l37.8-51.3-27.2-17zM304 384h81.9c25.5 0 46.1-20.6 46.1-46.1c0-9.8-3.1-19.4-9-27.4l-36.4-49.3-27.2 17 37.8 51.3c1.8 2.4 2.7 5.4 2.7 8.4c0 7.8-6.3 14.1-14.1 14.1H304v32z'
      
    ]
  };

  

  
  

  var faAnglesUp = {
    prefix: 'fasl',
    iconName: 'angles-up',
    icon: [
      448,
      512,
      ["angle-double-up"],
      'f102',
      
      'M235.3 52.7L224 41.4 212.7 52.7l-160 160L41.4 224 64 246.6l11.3-11.3L224 86.6 372.7 235.3 384 246.6 406.6 224l-11.3-11.3-160-160zm0 192L224 233.4l-11.3 11.3-160 160L41.4 416 64 438.6l11.3-11.3L224 278.6 372.7 427.3 384 438.6 406.6 416l-11.3-11.3-160-160z'
      
    ]
  };

  
    var faAngleDoubleUp = faAnglesUp;
  

  
  

  var faFaceTissue = {
    prefix: 'fasl',
    iconName: 'face-tissue',
    icon: [
      512,
      512,
      [],
      'e39c',
      
      'M256 32C132.3 32 32 132.3 32 256H0C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256V480c123.7 0 224-100.3 224-224S379.7 32 256 32zM100.6 375.4l-6.3 18.8L82.6 429.4l35.3-11.8 18.8-6.3 14 14 18.7 18.7 16.9-118.4L67.9 342.6l18.7 18.7 14 14zM28.3 348.3L0 320l39.6-5.7L191 292.7l33-4.7-4.7 33L197.7 472.4 192 512l-28.3-28.3L128 448 69.9 467.4 32 480l12.6-37.9L64 384 28.3 348.3zm284.6-9.6l40.3 26.8 23.7-11.8 14.3-7.2 14.3 28.6-14.3 7.2-32 16-8.3 4.2-7.7-5.2L304 371.2l-39.1 26.1-13.3 8.9-17.8-26.6 13.3-8.9 48-32 8.9-5.9 8.9 5.9zM121.8 182l15.9-27.8 13.9 7.9 56 32L231.9 208l-24.3 13.9-56 32-13.9 7.9L121.8 234l13.9-7.9L167.4 208l-31.7-18.1L121.8 182zm254.5 7.9L344.6 208l31.7 18.1 13.9 7.9-15.9 27.8-13.9-7.9-56-32L280.1 208l24.3-13.9 56-32 13.9-7.9L390.2 182l-13.9 7.9z'
      
    ]
  };

  

  
  

  var faDollyEmpty = {
    prefix: 'fasl',
    iconName: 'dolly-empty',
    icon: [
      576,
      512,
      [],
      'f473',
      
      'M8 0H24h88c6.9 0 13 4.4 15.2 10.9L241.3 353.3c4.8-.9 9.7-1.3 14.7-1.3c34.1 0 63.2 21.3 74.7 51.4L554.5 321l15-5.5 11.1 30-15 5.5L335.9 435.6C334 478.1 299 512 256 512c-44.2 0-80-35.8-80-80c0-27.8 14.1-52.2 35.6-66.6L100.5 32H24 8V0zM304 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faEnvelope = {
    prefix: 'fasl',
    iconName: 'envelope',
    icon: [
      512,
      512,
      [9993,61443,128386],
      'f0e0',
      
      'M32 159.2l224 154 224-154V96H32v63.2zM480 198L256 352 32 198V416H480V198zM0 416V176 96 64H32 480h32V96v80V416v32H480 32 0V416z'
      
    ]
  };

  

  
  

  var faTruckLadder = {
    prefix: 'fasl',
    iconName: 'truck-ladder',
    icon: [
      640,
      512,
      [],
      'e657',
      
      'M352 32V64H336v96h16v32H0V160H16V64H0V32H352zM304 64H240v96h64V64zm-96 0H144v96h64V64zm-96 0H48v96h64V64zM384 96h16 96 6.6l4.7 4.7 128 128 4.7 4.7V240 400v16H624 576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H16 0V400 240 224H16 384V112 96zm32 128H585.4l-96-96H416v96zm192 32H32V384H69.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H389.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H608V256zM224 416A64 64 0 1 0 96 416a64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faHeadSide = {
    prefix: 'fasl',
    iconName: 'head-side',
    icon: [
      512,
      512,
      [],
      'f6e9',
      
      'M32 224C32 118 118 32 224 32h24c88.4 0 160 71.6 160 160v7.2l5.4 4.8L480 263.2V304H432 416v16 96H304 288v16 64 16h32V496 448H432h16V432 336h48 16V320 256v-7.2l-5.4-4.8-66.8-59.3C436 82 351.6 0 248 0H224C100.3 0 0 100.3 0 224c0 61 24.4 116.4 64 156.8V496v16H96V496 374.1v-6.8l-4.9-4.7C54.6 327.6 32 278.4 32 224zm312 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faCakeCandles = {
    prefix: 'fasl',
    iconName: 'cake-candles',
    icon: [
      448,
      512,
      [127874,"birthday-cake","cake"],
      'f1fd',
      
      'M83.2 70.4C81.1 73.2 80 76.5 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-3.5-1.1-6.8-3.2-9.6L96 53.3 83.2 70.4zM57.6 51.2L76 26.7 96 0l20 26.7 18.4 24.5c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8zM211.2 70.4c-2.1 2.8-3.2 6.1-3.2 9.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-3.5-1.1-6.8-3.2-9.6L224 53.3 211.2 70.4zM185.6 51.2L204 26.7 224 0l20 26.7 18.4 24.5c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8zM352 53.3L339.2 70.4c-2.1 2.8-3.2 6.1-3.2 9.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-3.5-1.1-6.8-3.2-9.6L352 53.3zM332 26.7L352 0l20 26.7 18.4 24.5c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8L332 26.7zM32 372.8l57.1-27.2 7-3.4 7 3.5L160 374.1l56.8-28.4 7.2-3.6 7.2 3.6L288 374.1l56.8-28.4 7-3.5 7.1 3.4L416 372.8V256H368v16 16H336V272 256H240v16 16H208V272 256H112v16 16H80V272 256H32V372.8zm0 34.9V480H416V407.7c-1.2-.3-2.5-.7-3.7-1.2l-60.2-28.6-57 28.5-7.2 3.6-7.2-3.6L224 377.9l-56.8 28.4-7.2 3.6-7.2-3.6-57-28.5L35.7 406.4c-1.2 .6-2.4 1-3.7 1.2zM32 224H80V176 160h32v16 48h96V176 160h32v16 48h96V176 160h32v16 48h48 32v32V480v32H416 32 0V480 256 224H32z'
      
    ]
  };

  
    var faBirthdayCake = faCakeCandles;
  
    var faCake = faCakeCandles;
  

  
  

  var faSquare1 = {
    prefix: 'fasl',
    iconName: 'square-1',
    icon: [
      448,
      512,
      [],
      'e256',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM164.9 197.3L152 205.9V167.4l55.1-36.8 4-2.7H216h8 16v16V352h48 16v32H288 224 160 144V352h16 48V168.6l-43.1 28.8z'
      
    ]
  };

  

  
  

  var faComment = {
    prefix: 'fasl',
    iconName: 'comment',
    icon: [
      512,
      512,
      [61669,128489],
      'f075',
      
      'M94.1 362.8L86.9 382 68.6 430.8l88.5-26.6 9.3-2.8 9.2 2.8c24.9 7.6 51.9 11.7 80.3 11.7c130.2 0 224-84.7 224-176s-93.8-176-224-176S32 148.7 32 240c0 39.9 17.1 77.6 47.6 108.2l14.5 14.6zM54.5 468.4L16 480l14.1-37.6 26.8-71.5C21.3 335.1 0 289.6 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-31.5 0-61.7-4.6-89.6-13.1L54.5 468.4z'
      
    ]
  };

  

  
  

  var faEllipsisStrokeVertical = {
    prefix: 'fasl',
    iconName: 'ellipsis-stroke-vertical',
    icon: [
      192,
      512,
      ["ellipsis-v-alt"],
      'f39c',
      
      'M128 64l0 64H64l0-64 64 0zM64 32L32 32l0 32 0 64 0 32H64l64 0h32V128 64 32l-32 0L64 32zm64 192l0 64H64l0-64 64 0zM64 192H32l0 32 0 64 0 32H64h64 32V288l0-64V192H128l-64 0zm0 192h64l0 64H64l0-64zM32 352l0 32 0 64 0 32H64h64 32V448 384 352H128 64 32z'
      
    ]
  };

  
    var faEllipsisVAlt = faEllipsisStrokeVertical;
  

  
  

  var faBracketsCurly = {
    prefix: 'fasl',
    iconName: 'brackets-curly',
    icon: [
      576,
      512,
      [],
      'f7ea',
      
      'M64 32H80 208h16V64H208 96V192v6.6l-4.7 4.7L38.6 256l52.7 52.7 4.7 4.7V320 448H208h16v32H208 80 64V464 326.6L4.7 267.3 0 262.6V249.4l4.7-4.7L64 185.4V48 32zm448 0V48 185.4l59.3 59.3 4.7 4.7v13.3l-4.7 4.7L512 326.6V464v16H496 368 352V448h16H480V320v-6.6l4.7-4.7L537.4 256l-52.7-52.7-4.7-4.7V192 64H368 352V32h16H496h16z'
      
    ]
  };

  

  
  

  var faCircleYen = {
    prefix: 'fasl',
    iconName: 'circle-yen',
    icon: [
      512,
      512,
      [],
      'e5d0',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM152.3 144h41L256 222.4 318.7 144h41l-89 111.2H272v.8h48 16v32H320 272v32h48 16v32H320 272v17 16H240V369 352H192 176V320h16 48V288H192 176V256h16 48v-.8h1.3L152.3 144z'
      
    ]
  };

  

  
  

  var faCoffeeBean = {
    prefix: 'fasl',
    iconName: 'coffee-bean',
    icon: [
      448,
      512,
      [],
      'e13e',
      
      'M382.9 102c25.1 28.3 35.5 69 28.9 115.5c-7 49.3-33.2 102.9-78.3 148s-98.7 71.3-148 78.3c-37.8 5.4-71.7-.5-98.3-16.4l52.9-96.3L328.9 205.3l3.5-2.4 1.9-3.8L382.9 102zM357.7 80.9L307.6 181 119.1 306.7l-3.3 2.2-1.9 3.4-52 94.6c-26.1-28.3-37-69.7-30.3-117c7-49.3 33.2-102.9 78.3-148s98.7-71.3 148-78.3c38.5-5.5 73 .7 99.8 17.2zm26.6-20.6c-77.2-56.7-205-32.9-297 59.1c-99 99-119 239.4-44.8 313.6c1.1 1.1 2.2 2.2 3.3 3.2c6 5.6 12.4 10.7 19.2 15.2c2.2 1.5 4.4 2.8 6.7 4.2l0 0c77.9 45.7 197.2 19.8 284.4-67.4c99-99 119-239.4 44.8-313.6c-.9-.9-1.9-1.9-2.9-2.8c-3.2-3-6.5-5.9-9.9-8.5c-.9-.7-1.7-1.4-2.6-2c-.4-.3-.8-.6-1.2-.9z'
      
    ]
  };

  

  
  

  var faInboxes = {
    prefix: 'fasl',
    iconName: 'inboxes',
    icon: [
      512,
      512,
      [],
      'e1bb',
      
      'M32 198.4l2.7-6.4h83.4l27.6 55.2 4.4 8.8H160 352h9.9l4.4-8.8L393.9 192h83.4l2.7 6.4V288H32V198.4zM48 160L101.3 32H410.7L464 160H384h-9.9l-4.4 8.8L342.1 224H169.9l-27.6-55.2-4.4-8.8H128 48zM80 0L0 192v96 32H32 480h32V288 192L432 0H80zm64 352H32 0v32 96 32H32 480h32V480 384 352H480 368l-32 64H176l-32-64zm243.8 32H480v96H32V384h92.2l23.2 46.3 8.8 17.7H176 336h19.8l8.8-17.7L387.8 384z'
      
    ]
  };

  

  
  

  var faBookSection = {
    prefix: 'fasl',
    iconName: 'book-section',
    icon: [
      448,
      512,
      ["book-law"],
      'e0c1',
      
      'M0 64C0 28.7 28.7 0 64 0H432h16V16 400v16H432 416v64h16 16v32H432 64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H416V32H64C46.3 32 32 46.3 32 64l0 328.6zM231.7 256l-7-1.8c-20.7-5.5-63.7-17-55.7-58.8c2-10.5 7.5-19.2 15.6-25.8c-11.5-8.8-19.4-21.7-15.6-41.7c5.7-29.8 37.9-45 82-38.7c7.8 1.1 16.8 3.3 28.3 6.9l-8.9 28.6c-9.9-3.1-17.5-4.9-23.6-5.8c-26.1-3.8-46 2.3-48.4 14.7c-1.7 8.7-.2 15.1 34 24.1l6.8 1.8 0 0c28.2 7.3 70.9 18.3 62.8 60.6c-2 10.5-7.5 19.2-15.6 25.9c11.8 8.9 19.4 21.7 15.6 41.6c-4.8 25.3-28.9 40.2-63.1 40.2c-6 0-12.3-.5-18.9-1.4c-12.1-1.7-24.9-5.8-36.1-9.5l-5.4-1.8 9.1-28.6 5.5 1.8c10.1 3.3 21.5 7 31 8.3c26.3 3.7 46.1-2.3 48.4-14.7c2.3-11.9-5.4-16.8-40.9-26zm0-67.5s-8.8-2.3-9.7-2.6c-8.1 1.1-21.6 4.5-23.6 15.1c-1.7 8.7-.2 15.1 34 24.1c0 0 13.2 3.5 16.6 4.4c8.2-1.1 21.6-4.5 23.6-15c2.3-11.9-5.4-16.8-40.9-26z'
      
    ]
  };

  
    var faBookLaw = faBookSection;
  

  
  

  var faStretcher = {
    prefix: 'fasl',
    iconName: 'stretcher',
    icon: [
      640,
      512,
      [],
      'f825',
      
      'M35.6 69l-11-11.6L1.4 79.4 12.4 91l152 160 4.7 5H176 624h16V224H624 528.2h-.4H208.2h-.4-25L35.6 69zM224 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-8.8-1.8-17.3-5-24.9l53-40.6 53 40.6c-3.2 7.7-5 16.1-5 24.9c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-14.9 0-28.6 5.1-39.5 13.6l-46.2-35.3L491.6 288H438.9L368 342.2 297.1 288H244.4l97.2 74.4-46.2 35.3C284.6 389.1 270.9 384 256 384c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faTag = {
    prefix: 'fasl',
    iconName: 'tag',
    icon: [
      448,
      512,
      [127991],
      'f02b',
      
      'M224 434.7L32 242.7V64H210.7l192 192L224 434.7zM425.4 233.4L224 32H32 0V64 256L201.4 457.4 224 480l22.6-22.6L425.4 278.6 448 256l-22.6-22.6zM112 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faSteeringWheel = {
    prefix: 'fasl',
    iconName: 'steering-wheel',
    icon: [
      512,
      512,
      [],
      'f622',
      
      'M240 390.6v88.8C134.4 472 49.1 391.4 34.3 288H137.4L240 390.6zm32 0L374.6 288H477.7C462.9 391.4 377.6 472 272 479.4V390.6zM377.9 256l-27.6-55.2-4.4-8.8H336 176h-9.9l-4.4 8.8L134.1 256H32C32 132.3 132.3 32 256 32s224 100.3 224 224H377.9zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM163.5 268.8L185.9 224H326.1l22.4 44.8L256 361.4l-92.5-92.5z'
      
    ]
  };

  

  
  

  var faPlaneLock = {
    prefix: 'fasl',
    iconName: 'plane-lock',
    icon: [
      640,
      512,
      [],
      'e558',
      
      'M256 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4C184.4 62.7 176 89 176 109.7v44.5L8.1 250.1 0 254.7V264v96 21.9l20.9-6.7L176 325.4l0 50.6-57.6 43.2L112 424v8 64 16h16 16 2.2l2.2-.6L256 480.6l107.6 30.7 2.2 .6H368V479.4L260.4 448.6l-4.4-1.3-4.4 1.3L144 479.4V440l57.6-43.2L208 392v-8l0-80.6V281.5l-20.9 6.7L32 338.1V273.3l167.9-96 8.1-4.6v-9.3V109.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3C298.1 75.5 304 96.1 304 109.7v61.7 9.3l8.1 4.6 106.9 61.1c2.5-10.7 6.5-20.8 11.9-30.1L336 162.1V109.7c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zm80 376V327.8L384 345l0-34-58.6-20.9L304 282.4v22.7V384v8l6.4 4.8L368 440V400l-32-24zM528 224c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48H416v32V480v32h32H608h32V480 352 320H608V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z'
      
    ]
  };

  

  
  

  var faTruckFire = {
    prefix: 'fasl',
    iconName: 'truck-fire',
    icon: [
      640,
      512,
      [],
      'e65a',
      
      'M640 0H0V32H64V96H32 0v32V384v32H32 64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32 32V384 128 96H608 544c0-17.7-14.3-32-32-32s-32 14.3-32 32H384V32H640V0zM352 32V96H288V32h64zm0 96h32V256H32V128H64 96 352zm64 0h64 64 64V384H570.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H32V288H400h16V272 128zM256 32V96H192V32h64zm-96 0V96H96V32h64zM480 192h64v64H480V192zm0-32H448v32 64 32h32 64 32V256 192 160H544 480zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faSatellite = {
    prefix: 'fasl',
    iconName: 'satellite',
    icon: [
      512,
      512,
      [128752],
      'f7bf',
      
      'M390.6 409.4L368 432l-22.6-22.6-36.7-36.7c2.3 36.2-6.2 73-25.5 105.2c-5.5 9.1-11.8 17.9-19.1 26.2l-22.7-22.7-94-94-24 24c3 6.3 4.7 13.3 4.7 20.7c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c7.4 0 14.4 1.7 20.7 4.7l24-24-94-94L8 248c8.3-7.2 17-13.6 26.2-19.1c32.2-19.4 69-27.8 105.2-25.5l-36.7-36.7L80 144l22.6-22.6 98.7-98.7L224 0l22.6 22.6L304 80l-22.6 22.6L224 45.3 125.3 144l57.4 57.4-7.8 7.8c29.8 8 57.9 23.6 81.2 46.8s38.9 51.4 46.8 81.2l0 0c-3-11.3-7.1-22.3-12.3-32.9L450.7 144 368 61.3 207.8 221.5c-10.6-5.2-21.7-9.3-32.9-12.3L345.4 38.6 368 16l22.6 22.6 82.7 82.7L496 144l-22.6 22.6L432 208l57.4 57.4L512 288l-22.6 22.6-98.7 98.7zm18.7-178.7l-98.7 98.7L368 386.7 466.7 288l-57.4-57.4zM57.6 252.4l202 202c30.1-56.8 21-128.5-26.2-175.7s-118.9-56.3-175.7-26.2zM80 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faChessClockFlip = {
    prefix: 'fasl',
    iconName: 'chess-clock-flip',
    icon: [
      640,
      512,
      ["chess-clock-alt"],
      'f43e',
      
      'M400 32H384V64h16 48v64H32 0v32V448v32H32 608h32V448 160 128H608 480V64h48 16V32H528 464 400zM96 64V96h16H240h16V64H240 112 96zm512 96V448H32V160H608zM464 224a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 192a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM119.4 247.4A80 80 0 1 1 232.6 360.6 80 80 0 1 1 119.4 247.4zM255.2 383.2A112 112 0 1 0 96.8 224.8 112 112 0 1 0 255.2 383.2zM480 240H448v16 48 16h32V304 256 240zM221.3 281.4l11.3-11.3-22.6-22.6-11.3 11.3-33.9 33.9L153.4 304 176 326.6l11.3-11.3 33.9-33.9z'
      
    ]
  };

  
    var faChessClockAlt = faChessClockFlip;
  

  
  

  var faFilePlusMinus = {
    prefix: 'fasl',
    iconName: 'file-plus-minus',
    icon: [
      384,
      512,
      [],
      'e177',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM208 240V224H176v16 48H128 112v32h16 48v48 16h32V368 320h48 16V288H256 208V240zM128 416H112v32h16H256h16V416H256 128z'
      
    ]
  };

  

  
  

  var faUserVisor = {
    prefix: 'fasl',
    iconName: 'user-visor',
    icon: [
      448,
      512,
      [],
      'e04c',
      
      'M224 224c41.8 0 77.4-26.7 90.5-64H133.5c13.2 37.3 48.7 64 90.5 64zm0 32c-59.6 0-109.8-40.8-124-96H80V128 96 64h32 1.1C135.3 25.7 176.6 0 224 0s88.7 25.7 110.9 64H336h32V96v32 32H348c-14.2 55.2-64.3 96-124 96zM152.4 64H295.6C278 44.4 252.4 32 224 32s-54 12.4-71.6 32zM43.3 480H404.7L360.4 336H87.6L43.3 480zM64 304H384l54.2 176 9.8 32H414.5 33.5 0l9.8-32L64 304zM336 96H112v32H336V96zM288 456l-8-8 40-88 40 88-8 8-24-24-40 24z'
      
    ]
  };

  

  
  

  var faLiraSign = {
    prefix: 'fasl',
    iconName: 'lira-sign',
    icon: [
      320,
      512,
      [8356],
      'f195',
      
      'M96 143.2C96 99.5 131.5 64 175.2 64c9.2 0 18.4 1.6 27.1 4.8L274.5 95l15 5.5 10.9-30.1-15-5.5L213.2 38.7c-12.2-4.4-25-6.7-38-6.7C113.8 32 64 81.8 64 143.2V224H0v32H64v64H0v32H50.1L1.7 448.8 0 452.2V456v8 16H16 304h16V448H304 37.9l48-96H256V320H96V256H256V224H96V143.2z'
      
    ]
  };

  

  
  

  var faChild = {
    prefix: 'fasl',
    iconName: 'child',
    icon: [
      320,
      512,
      [],
      'f1ae',
      
      'M128 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 96 64a64 64 0 1 0 128 0zM94.5 160h-9l-4.7 7.6L2.4 295.6l27.3 16.7L80 230.2V496v16h32V496 384h96V496v16h32V496 230.2l50.4 82.1 27.3-16.7-78.5-128-4.7-7.6h-9H94.5zM208 352H112V200v-8h96v8V352z'
      
    ]
  };

  

  
  

  var faWashingMachine = {
    prefix: 'fasl',
    iconName: 'washing-machine',
    icon: [
      448,
      512,
      ["washer"],
      'f898',
      
      'M416 32V480H32V32H416zM32 0H0V32 480v32H32 416h32V480 32 0H416 32zm96 96A24 24 0 1 0 80 96a24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM335.2 317.5c-9.8 1.5-20.3 2.5-31.2 2.5c-32 0-56-16-80-32s-48-32-80-32c-7.2 0-14.6 .6-22 1.7C139.6 219 178.7 192 224 192c61.9 0 112 50.1 112 112c0 4.6-.3 9.1-.8 13.5zM325.7 351c-17.8 38.4-56.6 65-101.7 65c-61.9 0-112-50.1-112-112c0-4 .2-8 .6-12c10.8-2.5 21.5-4 31.4-4c20.9 0 37.2 9.9 62.2 26.6l2.1 1.4c22.8 15.2 53.9 36 95.7 36c7.5 0 14.7-.4 21.7-1zM224 448a144 144 0 1 0 0-288 144 144 0 1 0 0 288z'
      
    ]
  };

  
    var faWasher = faWashingMachine;
  

  
  

  var faBookSparkles = {
    prefix: 'fasl',
    iconName: 'book-sparkles',
    icon: [
      448,
      512,
      ["book-spells"],
      'f6b8',
      
      'M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H432h16V480H432 416V416h16 16V400 16 0H432 64zM384 416v64H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H384zM64 384c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H416V384H64zM288 144.1L274.2 168l-24.3 41.9L208 234.2 184.1 248 208 261.8l41.9 24.3L274.2 328 288 351.9 301.8 328l24.3-41.9L368 261.8 391.9 248 368 234.2l-41.9-24.3L301.8 168 288 144.1zm0 63.9l12.6 21.7 2.1 3.7 3.7 2.1L328.1 248l-21.7 12.6-3.7 2.1-2.1 3.7L288 288.1l-12.6-21.7-2.1-3.7-3.7-2.1L247.9 248l21.7-12.6 3.7-2.1 2.1-3.7L288 207.9zM173.6 79.6L160 57.4 146.4 79.6l-16.2 26.5-26.5 16.2L81.4 136l22.3 13.6 26.5 16.2 16.2 26.5L160 214.6l13.6-22.3 16.2-26.5 26.5-16.2L238.6 136l-22.3-13.6-26.5-16.2L173.6 79.6zm-18.2 46.5l4.6-7.5 4.6 7.5 2 3.3 3.3 2 7.5 4.6-7.5 4.6-3.3 2-2 3.3-4.6 7.5-4.6-7.5-2-3.3-3.3-2-7.5-4.6 7.5-4.6 3.3-2 2-3.3z'
      
    ]
  };

  
    var faBookSpells = faBookSparkles;
  

  
  

  var faSquareArrowDownRight = {
    prefix: 'fasl',
    iconName: 'square-arrow-down-right',
    icon: [
      448,
      512,
      [],
      'e262',
      
      'M416 448V64H32V448H416zm32 32H416 32 0V448 64 32H32 416h32V64 448v32zM304 352H168 152V320h16 97.4L132.7 187.3 121.4 176 144 153.4l11.3 11.3L288 297.4V192 176h32v16V336v16H304z'
      
    ]
  };

  

  
  

  var faFilmSlash = {
    prefix: 'fasl',
    iconName: 'film-slash',
    icon: [
      640,
      512,
      [],
      'e179',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zm460 462L448 438.6V448H192V352 256 240H160 96V176 160.7L64 135.4V448v32H96 500.4zM139.6 32L192 73.4V64H448v96 96 16h32 64v64 15.3l32 25.3V64 32H544 139.6zM160 448H96V368h64v80zM96 336V272h64v64H96zM480 176h64v64H480V176zm64-32H480V64h64v80z'
      
    ]
  };

  

  
  

  var faBusSchool = {
    prefix: 'fasl',
    iconName: 'bus-school',
    icon: [
      512,
      512,
      [],
      'f5dd',
      
      'M96 128H240h32H416V80.6C405.1 65.5 365.2 32 256 32c-54.3 0-93.2 9.6-119.5 21.1c-22.9 10-35.3 21-40.5 27.6V128zm0 32v93.2V256H240V240 160H96zm320 96v-2.8V160H272v80 16H416zM64 160V128 75.9 71.7l2-3.6C74 53.9 93.4 37 123.7 23.8C154.5 10.3 198 0 256 0C379.7 0 430.8 41 446 68.1l2 3.6v4.2V128v32 93.2V256h16 16v16V432v16H464 448v48 16H416V496 448H96v48 16H64V496 448H48 32V432 272 256H48 64v-2.8V160zM448 416V288H64V416H96 416h32zM104 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm256 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM208 64h96 16V96H304 208 192V64h16zM32 128v16 64 16H0V208 144 128H32zm480 16v64 16H480V208 144 128h32v16z'
      
    ]
  };

  

  
  

  var faClipboardUser = {
    prefix: 'fasl',
    iconName: 'clipboard-user',
    icon: [
      384,
      512,
      [],
      'f7f3',
      
      'M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36l3.1 12H254h34v48H192 96V80h34 12.4l3.1-12zM192 0c-32.8 0-61 19.8-73.3 48H80 64V64 80H32 0v32V480v32H32 352h32V480 112 80H352 320V64 48H304 265.3C253 19.8 224.8 0 192 0zM320 144V112h32V480H32V112H64v32 16H80 192 304h16V144zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM192 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM113.7 448l21.3-64H248.9l21.3 64H304l-32-96H112L80 448h33.7z'
      
    ]
  };

  

  
  

  var faFaceFearful = {
    prefix: 'fasl',
    iconName: 'face-fearful',
    icon: [
      512,
      512,
      [],
      'e375',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm248 48h16c48.6 0 88 39.4 88 88v8 16H336 176 160V400v-8c0-48.6 39.4-88 88-88zm16 32H248c-28.2 0-51.6 20.9-55.4 48H319.4c-3.9-27.1-27.2-48-55.4-48zM136.4 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM176 112c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8L95.2 150.6 73.4 127.2l11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1h16v32H176zm173 .9c-4.3-.6-8.6-.9-13-.9H320V80h16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8zM160 176a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm80 48A80 80 0 1 1 80 224a80 80 0 1 1 160 0zm64 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z'
      
    ]
  };

  

  
  

  var faLocationExclamation = {
    prefix: 'fasl',
    iconName: 'location-exclamation',
    icon: [
      384,
      512,
      ["map-marker-exclamation"],
      'f608',
      
      'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 20.2 9.1 48.6 26.5 82.7c16.9 33.2 39.9 68.2 63.4 100.5c23.4 32.2 46.9 61 64.5 81.9c1.9 2.3 3.8 4.5 5.6 6.6c1.8-2.1 3.6-4.3 5.6-6.6c17.7-20.8 41.1-49.7 64.5-81.9c23.5-32.3 46.4-67.3 63.4-100.5C342.9 240.6 352 212.2 352 192zm32 0c0 88.8-120.7 237.9-170.7 295.9C200.2 503.1 192 512 192 512s-8.2-8.9-21.3-24.1C120.7 429.9 0 280.8 0 192C0 86 86 0 192 0S384 86 384 192zM208 96v16V240v16H176V240 112 96h32zM168 336V288h48v48H168z'
      
    ]
  };

  
    var faMapMarkerExclamation = faLocationExclamation;
  

  
  

  var faTableRows = {
    prefix: 'fasl',
    iconName: 'table-rows',
    icon: [
      512,
      512,
      ["rows"],
      'e292',
      
      'M32 64l96 0 0 176 0 32 0 176-96 0L32 64zM160 272l320 0 0 176-320 0 0-176zm320-32l-320 0 0-176 320 0 0 176zM0 448l0 32 32 0 448 0 32 0 0-32 0-384 0-32-32 0L32 32 0 32 0 64 0 448z'
      
    ]
  };

  
    var faRows = faTableRows;
  

  
  

  var faHatCowboySide = {
    prefix: 'fasl',
    iconName: 'hat-cowboy-side',
    icon: [
      640,
      512,
      [],
      'f8c1',
      
      'M422.5 68.7l-233.9 39-11.3 84.5c36.3 1.8 71.1 15.2 99.2 38.4L307.5 256h151l-36-187.3zM464.6 288H346.3L486.9 403.8 464.6 288zM560 448H496 464 16 0V432 361.1c0-85.2 62.9-155.6 144.8-167.4L160 80 448 32l31.8 165.4c4.3 2 9.9 4.6 16.3 7.8c15.5 7.7 36.2 19.1 57 33.7c20.7 14.5 42.2 32.6 58.5 53.9C628.1 314 640 339.4 640 368c0 44.2-35.8 80-80 80zM534.8 265.1c-16.8-11.8-33.8-21.4-47.5-28.5L521.8 416H560c26.5 0 48-21.5 48-48c0-19.4-8.1-38-21.7-55.7c-13.7-17.7-32.2-33.7-51.5-47.1zM169.1 224C93.4 224 32 285.4 32 361.1V416H451.4L256.2 255.3c-24.5-20.2-55.3-31.3-87.1-31.3z'
      
    ]
  };

  

  
  

  var faDiscDrive = {
    prefix: 'fasl',
    iconName: 'disc-drive',
    icon: [
      512,
      512,
      [],
      'f8b5',
      
      'M32 32H48 464h16V48 448h16 16v32H496 464 48 16 0V448H16 32V48 32zM64 448H448V64H64V448zM256 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM416 256A160 160 0 1 1 96 256a160 160 0 1 1 320 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faPhoneVolume = {
    prefix: 'fasl',
    iconName: 'phone-volume',
    icon: [
      512,
      512,
      ["volume-control-phone"],
      'f2a0',
      
      'M280.4 355.3l21.3 12.3L319 350.2l40.7-40.7L475.8 356 453.3 480H448C218.2 480 32 293.7 32 64l0-5.3L156 36.2l46.5 116.1-40.7 40.7-17.3 17.3 12.3 21.3c29.6 51.4 72.4 94.1 123.7 123.7zM512 336L352 272l-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L240 160 176 0 0 32 0 64C0 311.4 200.6 512 448 512h32l32-176zM256 32c123.7 0 224 100.3 224 224h32C512 114.6 397.4 0 256 0V32zm32 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 0h32c0-88.4-71.6-160-160-160v32c70.7 0 128 57.3 128 128z'
      
    ]
  };

  
    var faVolumeControlPhone = faPhoneVolume;
  

  
  

  var faSealQuestion = {
    prefix: 'fasl',
    iconName: 'seal-question',
    icon: [
      512,
      512,
      [],
      'e243',
      
      'M278.6 22.6L323 67l82 0 32 0 0 32 0 82 52.4 52.4L512 256l-22.6 22.6L437 331l0 82 0 32-32 0-82 0-44.4 44.4L256 512l-22.6-22.6L189 445l-82 0-32 0 0-32 0-82L22.6 278.6 0 256l22.6-22.6L75 181l0-82 0-32 32 0 82 0 44.4-44.4L256 0l22.6 22.6zM323 99l-13.3 0-9.4-9.4L256 45.3 211.6 89.6 202.3 99 189 99l-82 0 0 82 0 13.3-9.4 9.4L45.3 256l52.4 52.4 9.4 9.4 0 13.3 0 82 82 0 13.3 0 9.4 9.4L256 466.7l44.4-44.4 9.4-9.4 13.3 0 82 0 0-82 0-13.3 9.4-9.4L466.7 256l-52.4-52.4-9.4-9.4 0-13.3 0-82-82 0zM168 184c0-30.9 25.1-56 56-56l56 0c35.5 0 64 29 64 64.3l0 16-2 0c-4.5 17.5-16.3 32.7-32.9 41.2L272 268.3l0 3.7 0 16-32 0 0-16 0-13.5 0-9.8 8.7-4.5 45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3l-56 0c-13.3 0-24 10.7-24 24l0 8-32 0 0-8zm64 136l48 0 0 48-48 0 0-48z'
      
    ]
  };

  

  
  

  var faSolarSystem = {
    prefix: 'fasl',
    iconName: 'solar-system',
    icon: [
      512,
      512,
      [],
      'e02f',
      
      'M32 256c0 123.7 100.3 224 224 224c31.4 0 61.4-6.5 88.5-18.2c4.2 8.8 9.9 17.1 17.3 24.4c.7 .7 1.4 1.4 2.1 2C331.1 503.5 294.5 512 256 512C114.6 512 0 397.4 0 256c0-50.9 14.9-98.4 40.5-138.3C35.1 109.1 32 98.9 32 88c0-30.9 25.1-56 56-56c10.9 0 21.1 3.1 29.7 8.5l0 0c3.4 2.2 6.7 4.7 9.7 7.7l.2 .2 .1 .1c4.9 4.9 8.6 10.5 11.3 16.4l0 0c3.2 7 5 14.8 5 23.1c0 30.9-25.1 56-56 56c-8.2 0-16-1.8-23.1-5C44 173.1 32 213.1 32 256zM394.3 471.5l0 0c-3.5-2.2-6.8-4.8-9.8-7.8l9.8 7.8zM424 480c-10.9 0-21.1-3.1-29.7-8.5L373 447.1c-3.2-7-5-14.9-5-23.1c0-30.9 25.1-56 56-56c8.2 0 16 1.8 23.1 5c20.9-34 32.9-74.1 32.9-117C480 132.3 379.7 32 256 32c-31.4 0-61.4 6.5-88.5 18.2c-4.2-8.8-10-17.1-17.3-24.4c-.7-.7-1.4-1.4-2.1-2C180.9 8.5 217.5 0 256 0C397.4 0 512 114.6 512 256c0 50.9-14.9 98.4-40.5 138.3c5.4 8.6 8.5 18.8 8.5 29.7c0 30.9-25.1 56-56 56zm24-56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM88 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm264 80c-22.1 0-40-17.9-40-40c0-3.6 .5-7.1 1.4-10.4C296.1 132.9 276.6 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128c0-24.3-6.8-47-18.5-66.3c-4.2 1.5-8.8 2.3-13.5 2.3zm64 64c0 88.4-71.6 160-160 160s-160-71.6-160-160s71.6-160 160-160c28.3 0 54.9 7.4 78 20.3c5.4-2.7 11.5-4.3 18-4.3c22.1 0 40 17.9 40 40c0 5.3-1 10.4-3 15.1c17 25.4 27 56 27 88.9zM256 336l-22.6-22.6-34.7-34.7L176 256l22.6-22.6 34.7-34.7L256 176l22.6 22.6 34.7 34.7L336 256l-22.6 22.6-34.7 34.7L256 336zm0-114.7L221.3 256 256 290.7 290.7 256 256 221.3z'
      
    ]
  };

  

  
  

  var faBookTanakh = {
    prefix: 'fasl',
    iconName: 'book-tanakh',
    icon: [
      448,
      512,
      ["tanakh"],
      'f827',
      
      'M384 0c35.3 0 64 28.7 64 64l0 384 0 0c0 35.3-28.7 64-64 64H16 0V480H16 32V416H16 0V400 16 0H16 384zM64 416v64H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zm320-32c11.7 0 22.6 3.1 32 8.6L416 64c0-17.7-14.3-32-32-32H32V384H384zM216 64l13.9 24 27.7 48H313h27.7l-13.9 24-27.7 48 27.7 48 13.9 24H313 257.6l-27.7 48L216 352l-13.9-24-27.7-48H119 91.3l13.9-24 27.7-48-27.7-48L91.3 136H119h55.4l27.7-48L216 64zm27.7 96H188.3l-27.7 48 27.7 48h55.4l27.7-48-27.7-48zm-13.9-24L216 112l-13.9 24h27.7zm55.4 48l13.9-24H271.4l13.9 24zm0 48l-13.9 24h27.7l-13.9-24zm-55.4 48H202.1L216 304l13.9-24zm-69.3-24l-13.9-24-13.9 24h27.7zm-13.9-72l13.9-24H132.9l13.9 24z'
      
    ]
  };

  
    var faTanakh = faBookTanakh;
  

  
  

  var faTableCellsLarge = {
    prefix: 'fasl',
    iconName: 'table-cells-large',
    icon: [
      512,
      512,
      ["th-large"],
      'f009',
      
      'M272 64V240H480V64H272zm-32 0H32V240H240V64zM32 272V448H240V272H32zM272 448H480V272H272V448zM0 32H32 480h32V64 448v32H480 32 0V448 64 32z'
      
    ]
  };

  
    var faThLarge = faTableCellsLarge;
  

  
  

  var faCloudDrizzle = {
    prefix: 'fasl',
    iconName: 'cloud-drizzle',
    icon: [
      512,
      512,
      [],
      'f738',
      
      'M384 128v32h32c35.3 0 64 28.7 64 64v64H416 96 32V224c0-27.8 17.8-51.6 42.7-60.4L96 156.1V133.5 112c0-44.2 35.8-80 80-80c27 0 50.9 13.4 65.5 34l17.8 25.2 25.9-16.9c10-6.5 22-10.3 34.9-10.3c35.3 0 64 28.7 64 64zM0 320H32 96 416h64 32V288 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v64 32zm64 56V360H32v16 40 16H64V416 376zm192 0V360H224v16 40 16h32V416 376zm192 0V360H416v16 40 16h32V416 376zM160 448V432H128v16 48 16h32V496 448zm192 0V432H320v16 48 16h32V496 448z'
      
    ]
  };

  

  
  

  var faPeoplePantsSimple = {
    prefix: 'fasl',
    iconName: 'people-pants-simple',
    icon: [
      512,
      512,
      [],
      'e21a',
      
      'M128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 128 0a64 64 0 1 0 0 128zM62.7 192H193.3l5.3 128H192 160 96 64 57.4l5.3-128zM56 352h8V496v16H96V496 352h64V496v16h32V496 352h8 32l-1.3-32L224 160H32L25.3 320 24 352H56zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 384 0a64 64 0 1 0 0 128zm-65.3 64H449.3l5.3 128H448 416 352 320h-6.6l5.3-128zM312 352h8V496v16h32V496 352h64V496v16h32V496 352h8 32l-1.3-32L480 160H288l-6.7 160L280 352h32z'
      
    ]
  };

  

  
  

  var faFlowerTulip = {
    prefix: 'fasl',
    iconName: 'flower-tulip',
    icon: [
      512,
      512,
      [127799],
      'f801',
      
      'M295 100l18.3 22.9 24.4-16.3L384 75.8V160c0 53-43 96-96 96H224c-53 0-96-43-96-96V75.8l46.2 30.8 24.4 16.3L217 100l39-48.8L295 100zM416 16L384 37.3 320 80 276.5 25.6 256 0 235.5 25.6 192 80 128 37.3 96 16V54.5 160c0 70.7 57.3 128 128 128h16V396.6C200.8 331.5 129.5 288 48 288H32 0c0 10.9 .8 21.5 2.3 32C17.8 428.6 111.2 512 224 512h16 32 16c112.8 0 206.2-83.4 221.7-192c1.5-10.5 2.3-21.1 2.3-32H480 464c-81.5 0-152.8 43.5-192 108.6V288h16c70.7 0 128-57.3 128-128V54.5 16zM48 320c95.1 0 174.1 69.2 189.3 160H224c-95.1 0-174.1-69.2-189.3-160H48zm416 0h13.3C462.1 410.8 383.1 480 288 480H274.7c15.2-90.8 94.2-160 189.3-160z'
      
    ]
  };

  

  
  

  var faBusinessTime = {
    prefix: 'fasl',
    iconName: 'business-time',
    icon: [
      640,
      512,
      ["briefcase-clock"],
      'f64a',
      
      'M144 0H128V16 96H32 0v32V448v32H32 360.2c-8.1-9.8-15.2-20.6-21-32H32V288H176v48 32h32H320c0-10.9 1-21.6 2.9-32H208V288H339.2c5.9-11.4 12.9-22.2 21-32H352 208 176 32V128H144 368 480v64.7c5.3-.5 10.6-.7 16-.7s10.7 .2 16 .7V128 96H480 384V16 0H368 144zM352 96H160V32H352V96zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-224H480v16 64 16h16 48 16V352H544 512V304 288z'
      
    ]
  };

  
    var faBriefcaseClock = faBusinessTime;
  

  
  

  var faCommentDollar = {
    prefix: 'fasl',
    iconName: 'comment-dollar',
    icon: [
      512,
      512,
      [],
      'f651',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM272 144V128H240v16 9.3c-6.5 1.1-12.7 2.9-18.3 5.4c-14.1 6.4-25.9 18.1-28.8 34.7c-1.6 9.5-.7 18.5 3.1 26.6c3.8 7.9 9.7 13.7 15.9 17.9c11.1 7.5 25.8 11.9 37.7 15.5l0 0 2 .6c13.8 4.2 23.9 7.5 30.5 12.3c2.9 2.1 4.3 4 5.1 5.7c.7 1.6 1.3 4.3 .5 9c-.9 5-3.8 9-10.3 11.8c-7 3-17.7 4.3-31 2.2c-6.4-1-17.6-4.8-27.1-8.1l0 0 0 0c-2.2-.7-4.2-1.4-6.1-2.1l-15.2-5.1-10.1 30.4 15.2 5.1c1.3 .4 2.8 1 4.6 1.6l0 0 0 0 0 0c8.9 3 23 7.9 32.4 9.6V336v16h32V336v-8.9c6.3-.9 12.3-2.5 17.9-4.9c14.7-6.3 26.3-18.3 29.3-35.7c1.7-9.7 .9-18.9-2.7-27.2c-3.6-8.2-9.3-14.3-15.6-18.8c-11.6-8.4-27.2-13.1-39.5-16.9l-.6-.2c-13.9-4.2-24.3-7.4-31-12c-3-2-4.3-3.8-5-5.1c-.6-1.2-1.2-3.3-.5-7.4c.6-3.6 3.3-7.8 10.5-11c7.3-3.3 18-4.9 30.9-2.9c4.4 .7 18.1 3.4 22.1 4.4l15.5 4.1 8.2-30.9-15.5-4.1c-5.1-1.4-18.2-3.9-24.1-4.9V144z'
      
    ]
  };

  

  
  

  var faPersonDress = {
    prefix: 'fasl',
    iconName: 'person-dress',
    icon: [
      320,
      512,
      ["female"],
      'f182',
      
      'M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM133.5 248.8l-7.2 14.3L73.9 368H96h32 64 32 22.1L193.7 263.2l-7.2-14.3 28.6-14.3 7.2 14.3 64 128L297.9 400H272 224v96 16H192V496 400H128v96 16H96V496 400H48 22.1l11.6-23.2 64-128 7.2-14.3 28.6 14.3zM108.9 128H211.1h9.6l4.5 8.5 76.9 144 7.5 14.1-28.2 15.1-7.5-14.1L201.5 160h-83L46.1 295.5l-7.5 14.1L10.3 294.6l7.5-14.1 76.9-144 4.5-8.5h9.6z'
      
    ]
  };

  
    var faFemale = faPersonDress;
  

  
  

  var faDreidel = {
    prefix: 'fasl',
    iconName: 'dreidel',
    icon: [
      448,
      512,
      [],
      'f792',
      
      'M443.4 59.2L432.1 70.5 321.9 180.7l84.7 84.7L429.3 288l-22.6 22.6-160 160-9.4 9.4H224 32 0V448 256 242.7l9.4-9.4 160-160L192 50.7l22.6 22.6 84.7 84.7L409.5 47.9l11.3-11.3 22.6 22.6zM292.7 379.3l-192-192L32 256l0 192H224l68.7-68.7zm22.6-22.6L384 288 192 96l-68.7 68.7 192 192z'
      
    ]
  };

  

  
  

  var faOtter = {
    prefix: 'fasl',
    iconName: 'otter',
    icon: [
      640,
      512,
      [129446],
      'f700',
      
      'M167.9 197.9l15.2-7.6 8.8-4.4V176 160 144H176 144 128v16 16 9.9l8.8 4.4 15.2 7.6-11.3 8.5L117.3 224H48V144c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80v77 3H202.7l-23.5-17.6-11.3-8.5zM192 256h72.6c11.1 19.1 31.7 32 55.4 32h81.4l-44.7 44.7-4.7 4.7V344v8H272V304 288H256 112c-20.9 0-38.7-13.4-45.3-32H128l32-24 32 24zM16 256H32v.6C32 380 132 480 255.4 480H414.9C539.2 480 640 379.2 640 254.9c0-90.7-64-168.8-153-186.6l-19.9-4-8.2 30.9 21.6 7.2c37.9 12.6 63.4 48.1 63.4 88c0 16.4-6 31.4-16 42.9V192 176H512 448 432v16 64 0H400V208 192H384 352h-8c-14.2 0-27.7 2.8-40 8V144c0-5.4-.4-10.8-1.1-16H304h16V96H304 293.2c-18-37.8-56.5-64-101.2-64H128C83.3 32 44.8 58.2 26.8 96H16 0v32H16h1.1c-.7 5.2-1.1 10.6-1.1 16v80 32zm288-19.9c11.4-7.7 25.2-12.1 40-12.1h8 16v32H352h-8l-.2 0H320c-5.8 0-11.3-1.6-16-4.3V236.1zM528 368V274.5c28.7-17 48-48.3 48-84.1c0-13.3-2.1-26.3-6.1-38.5c23.9 27.9 38.1 64 38.1 103C608 361.5 521.5 448 414.9 448H255.4c-87.6 0-161.4-58.9-184.2-139.2C83.1 315.9 97.1 320 112 320H240v32H208 160 144v32h16 48 48 16 96 16V368 350.6l75.3-75.3 4.7-4.7V264v-8V208h32V359.4l-40.9 27.3-13.3 8.9 17.8 26.6 13.3-8.9 48-32 7.1-4.7V368zM112 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm112 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faUserSecret = {
    prefix: 'fasl',
    iconName: 'user-secret',
    icon: [
      448,
      512,
      [128373],
      'f21b',
      
      'M188.7 14.3L224 32l35.3-17.7L288 0l13 29.3 35.6 80.2c4-1.4 7.8-2.9 11.4-4.3c14.2-5.7 25-11.3 32.2-15.5c3.6-2.1 6.2-3.8 7.9-4.9c.9-.6 1.5-1 1.8-1.3l.4-.3 0 0s0 0 9.6 12.8s9.6 12.8 9.6 12.8l0 0 0 0-.1 .1-.2 .2-.7 .5c-.6 .4-1.5 1-2.6 1.8c-2.2 1.5-5.4 3.5-9.6 6c-8.4 4.8-20.5 11.2-36.3 17.5C328.3 147.5 282.3 160 224 160s-104.3-12.5-135.9-25.1c-15.8-6.3-28-12.7-36.3-17.5c-4.2-2.4-7.4-4.5-9.6-6c-1.1-.7-2-1.3-2.6-1.8l-.7-.5-.2-.2-.1-.1 0 0 0 0s0 0 9.6-12.8s9.6-12.8 9.6-12.8l0 0 .4 .3c.4 .3 1 .7 1.8 1.3c1.7 1.1 4.4 2.8 7.9 4.9c7.2 4.2 18 9.8 32.2 15.5c3.6 1.4 7.4 2.9 11.4 4.3L147 29.3 160 0l28.7 14.3zm83.7 29.3l-34 17L224 67.8l-14.3-7.2-34-17-33.3 75c23 5.5 50.3 9.4 81.7 9.4s58.7-3.9 81.7-9.4l-33.3-75zM100 224c-2.6-10.2-4-21-4-32c0-6.7 .5-13.3 1.5-19.7c9.6 3.1 19.9 6.1 31.1 8.8c-.4 3.6-.6 7.2-.6 10.9c0 53 43 96 96 96s96-43 96-96c0-4-.2-7.9-.7-11.7c11.1-2.8 21.5-5.8 31-9c1.1 6.8 1.7 13.7 1.7 20.8c0 11-1.4 21.8-4 32h49.5H432l-13.1 32-19.6 48-13.1 32H416l1.5 8 24.7 136 5.8 32H415.5 32.5 0l5.8-32L30.5 344l1.5-8H61.8L48.7 304 29.1 256 16 224H50.6 100zm234.8 32c-22.1 38.3-63.5 64-110.9 64s-88.7-25.7-110.9-64H63.7l27.8 67.9 18 44.1H61.8 58.7L38.3 480H154.8l-26.2-91.6 30.8-8.8 20.3 70.9L201.8 384H192 176V352h16 32 32 16v32H256h-9.8l22.2 66.5 20.3-70.9 30.8 8.8L293.2 480H409.7L389.3 368h-3.1H338.5l18-44.1L384.3 256H334.9zM224 418.6L203.5 480h40.9L224 418.6zM144 184.4c10.1 2 20.8 3.6 32 4.9V198c0 7 5.7 12.7 12.7 12.7c5.5 0 10.3-3.5 12-8.7l3.5-10.5c6.5 .3 13.1 .5 19.8 .5c6.7 0 13.3-.2 19.8-.5l3.5 10.5c1.7 5.2 6.6 8.7 12 8.7c7 0 12.7-5.7 12.7-12.7v-9c11.2-1.4 21.8-3.2 32-5.3V198c0 24.7-20 44.7-44.7 44.7c-14.1 0-27-6.6-35.3-17.3c-8.3 10.7-21.2 17.3-35.3 17.3c-24.7 0-44.7-20-44.7-44.7V184.4z'
      
    ]
  };

  

  
  

  var faRv = {
    prefix: 'fasl',
    iconName: 'rv',
    icon: [
      640,
      512,
      [],
      'f7be',
      
      'M224 0H384V32H592h16V48 176v16H592 549.6L634 259.5l6 4.8V272 400v16H624 574.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16H400 254.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-7.7 1.1-15.2 3.1-22.2L4.7 315.3 0 310.6V304 48 32H16 224V0zM32 64V297.4l82.9 82.9C129.6 363 151.5 352 176 352c26.2 0 49.4 12.6 64 32H384V176 160h16H576V64H384 352V32H256V64H224 32zM541.3 416a48 48 0 1 0 -90.5 32 48 48 0 1 0 90.5-32zM432 384c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32h48V288H416v96h16zm66.4-192H416v64H578.4l-80-64zM221.3 416a48 48 0 1 0 -90.5 32 48 48 0 1 0 90.5-32zM128 160v64H288V160H128zM96 128h32H288h32v32 64 32H288 128 96V224 160 128z'
      
    ]
  };

  

  
  

  var faClockElevenThirty = {
    prefix: 'fasl',
    iconName: 'clock-eleven-thirty',
    icon: [
      512,
      512,
      [],
      'e348',
      
      'M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400V260.8l-61.3-92-8.9-13.3 26.6-17.8 8.9 13.3 64 96 2.7 4V256 400v16H240V400z'
      
    ]
  };

  

  
  

  var faExpandWide = {
    prefix: 'fasl',
    iconName: 'expand-wide',
    icon: [
      512,
      512,
      [],
      'f320',
      
      'M144 64h16V96H144 32V208v16H0V208 80 64H16 144zM0 304V288H32v16V416H144h16v32H144 16 0V432 304zM496 64h16V80 208v16H480V208 96H368 352V64h16H496zM480 304V288h32v16V432v16H496 368 352V416h16H480V304z'
      
    ]
  };

  

  
  

  var faBriefcaseArrowRight = {
    prefix: 'fasl',
    iconName: 'briefcase-arrow-right',
    icon: [
      512,
      512,
      [],
      'e2f2',
      
      'M128 0h16H368h16V16 96h96 32v32V448v32H480 32 0V448 128 96H32h96V16 0zM352 32H160V96H352V32zM32 128V448H480V128H368 144 32zm267.3 68.7l80 80L390.6 288l-11.3 11.3-80 80L288 390.6 265.4 368l11.3-11.3L329.4 304H144 128V272h16H329.4l-52.7-52.7L265.4 208 288 185.4l11.3 11.3z'
      
    ]
  };

  

  
  

  var faSuitcaseMedical = {
    prefix: 'fasl',
    iconName: 'suitcase-medical',
    icon: [
      512,
      512,
      ["medkit"],
      'f0fa',
      
      'M128 0h16H368h16V16 96h96 32v32V448v32H480 32 0V448 128 96H32h96V16 0zM352 32H160V96H352V32zm16 96H144 128V448H384V128H368zM96 128H32V448H96V128zM416 448h64V128H416V448zM224 176h64 16v16 48h48 16v16 64 16H352 304v48 16H288 224 208V384 336H160 144V320 256 240h16 48V192 176h16zm16 80v16H224 176v32h48 16v16 48h32V320 304h16 48V272H288 272V256 208H240v48z'
      
    ]
  };

  
    var faMedkit = faSuitcaseMedical;
  

  
  

  var faO = {
    prefix: 'fasl',
    iconName: 'o',
    icon: [
      448,
      512,
      [111],
      '4f',
      
      'M224 64a192 192 0 1 0 0 384 192 192 0 1 0 0-384zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z'
      
    ]
  };

  

  
  

  var faBookBible = {
    prefix: 'fasl',
    iconName: 'book-bible',
    icon: [
      448,
      512,
      ["bible"],
      'f647',
      
      'M0 64C0 28.7 28.7 0 64 0H432h16V16 400v16H432 416v64h16 16v32H432 64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H416V32H64C46.3 32 32 46.3 32 64l0 328.6zM208 72h64 16V88v48h48 16v16 64 16H336 288v96 16H272 208 192V328 232H144 128V216 152 136h16 48V88 72h16zm16 80v16H208 160v32h48 16v16 96h32V216 200h16 48V168H272 256V152 104H224v48z'
      
    ]
  };

  
    var faBible = faBookBible;
  

  
  

  var faMessagesQuestion = {
    prefix: 'fasl',
    iconName: 'messages-question',
    icon: [
      640,
      512,
      [],
      'e1e7',
      
      'M128 368L96 384V352v-3.8V320H64 32 0V288 32 0H32 384h32V32 288v32H384 224l-96 48zm0-35.8l81.7-40.8 6.8-3.4H224 384V32H32V288H96h32v32 12.2zM256 416V352h32v64H416h7.6l6.8 3.4L512 460.2V448 416h32 64V160H448V128H608h32v32V416v32H608 576 544v28.2V480v32l-32-16-96-48H288 256V416zM146.7 109c0-21.4 17.3-38.7 38.7-38.7h40.3c24.2 0 43.7 19.6 43.7 43.7c0 15.7-8.4 30.1-22 37.9L224 165.4v5.9 16H192v-16V156.1v-9.3l8-4.6 31.4-18c3.6-2.1 5.9-6 5.9-10.2c0-6.5-5.3-11.7-11.7-11.7H185.3c-3.7 0-6.7 3-6.7 6.7l0 4.6-32 0 0-4.6zM191 216.7h34v34H191v-34z'
      
    ]
  };

  

  
  

  var faGamepadModern = {
    prefix: 'fasl',
    iconName: 'gamepad-modern',
    icon: [
      640,
      512,
      [63676,127918,"gamepad-alt"],
      'e5a2',
      
      'M440 480l-16-96H216l-16 96H32.2 0l3.6-32L42.8 96 160 32H320 480L597.2 96l39.2 352 3.6 32H607.8 440zM184.4 378.7l4.5-26.7H216 424h27.1l4.5 26.7L467.1 448H604.2l-37-331.9L471.8 64H320 168.2L72.8 116.1 35.8 448H172.9l11.5-69.3zM208 160v48h48 16v32H256 208v48 16H176V288 240H128 112V208h16 48V160 144h32v16zM408 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faGamepadAlt = faGamepadModern;
  

  
  

  var faCurlingStone = {
    prefix: 'fasl',
    iconName: 'curling-stone',
    icon: [
      576,
      512,
      [129356,"curling"],
      'f44a',
      
      'M176 32H160V48 160H112 96v16 48H64L0 288v24 24 80l64 64H512l64-64V336 312 288l-64-64H480V176 160H464 192V64H400h16V32H400 176zM448 224H128V192h32 32H448v32zM32 312V301.3L77.3 256H498.7L544 301.3V312v24H32V312zm0 56H544v34.7L498.7 448H77.3L32 402.7V368z'
      
    ]
  };

  
    var faCurling = faCurlingStone;
  

  
  

  var faTankWater = {
    prefix: 'fasl',
    iconName: 'tank-water',
    icon: [
      448,
      512,
      [],
      'e452',
      
      'M208 32H32 0V64 448v32H32 416h32V448 64 32H416 240l9.6 12.8L264 64H416V352c-20.9 0-41.7-10-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C265.6 342.1 244.9 352 224 352s-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C73.6 342.1 52.9 352 32 352V64H184l14.4-19.2L208 32zM32 384c30.3 0 57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C166.4 369.9 193.7 384 224 384s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C358.5 369.9 385.7 384 416 384v64H32V384zM224 117.3L256 160c5.2 6.9 8 15.3 8 24c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-8.7 2.8-17.1 8-24l32-42.7zM204 90.7l-37.6 50.1C157.1 153.3 152 168.4 152 184c0 39.8 32.2 72 72 72s72-32.2 72-72c0-15.6-5.1-30.7-14.4-43.2L244 90.7 224 64 204 90.7z'
      
    ]
  };

  

  
  

  var faImageLandscape = {
    prefix: 'fasl',
    iconName: 'image-landscape',
    icon: [
      576,
      512,
      ["landscape"],
      'e1b5',
      
      'M544 96V406.4L364.5 182 352 166.4 339.5 182 244.4 300.9l-39.5-54.3-12.2-16.8-13.1 16L40.4 416H32V96H544zM510.7 416H193.3l63-78.8L352 217.6 510.7 416zM160.1 448H544h32V416 96 64H544 32 0V96 416v32H32 159.9c.1 0 .2 0 .3 0zm-7.8-32H81.8L191.3 282.2l32.4 44.6L152.3 416zM144 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  
    var faLandscape = faImageLandscape;
  

  
  

  var faArrowUpToDottedLine = {
    prefix: 'fasl',
    iconName: 'arrow-up-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e0a1',
      
      'M56 40H8V88H56V40zm96 0H104V88h48V40zm48 0V88h48V40H200zm144 0H296V88h48V40zm48 0V88h48V40H392zM235.3 164.7L224 153.4l-11.3 11.3-128 128L73.4 304 96 326.6l11.3-11.3L208 214.6V320 464v16h32V464 320 214.6L340.7 315.3 352 326.6 374.6 304l-11.3-11.3-128-128z'
      
    ]
  };

  

  
  

  var faSiren = {
    prefix: 'fasl',
    iconName: 'siren',
    icon: [
      448,
      512,
      [],
      'e02d',
      
      'M363.8 320H396L368 96H80L52 320H84.2l24-192H339.8l24 192zm-185.6 0l13.8-110 2.2-18H161.9l-1.8 14L145.9 320h32.2zM32 384H416v64H32V384zM0 352v32 64 32H32 416h32V448 384 352H416 32 0z'
      
    ]
  };

  

  
  

  var faFilePdf = {
    prefix: 'fasl',
    iconName: 'file-pdf',
    icon: [
      512,
      512,
      [],
      'f1c1',
      
      'M352 192l0 112 32 0 0-152L232 0 32 0 0 0 0 32 0 480l0 32 32 0 80 0 0-32-80 0L32 32l160 0 0 144 0 16 16 0 144 0zm-5.3-32L224 160l0-122.7L346.7 160zM176 352l-16 0 0 16 0 80 0 64 32 0 0-48 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0zm32 80l-16 0 0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm96-80l-16 0 0 16 0 128 0 16 16 0 32 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-32 0zm32 128l-16 0 0-96 16 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16zm80-128l0 16 0 64 0 64 0 16 32 0 0-16 0-48 32 0 16 0 0-32-16 0-32 0 0-32 32 0 16 0 0-32-16 0-48 0-16 0z'
      
    ]
  };

  

  
  

  var faBagShoppingMinus = {
    prefix: 'fasl',
    iconName: 'bag-shopping-minus',
    icon: [
      448,
      512,
      [],
      'e650',
      
      'M224 32c35.3 0 64 28.7 64 64v32H160V96c0-35.3 28.7-64 64-64zM128 96v32H32 0v32V480v32H32 416h32V480 160 128H416 320V96c0-47.6-34.6-87.1-80-94.7V0H224c-53 0-96 43-96 96zM32 160h96 32H288h32 96V480H32V160zM144 304H128v32h16H304h16V304H304 144z'
      
    ]
  };

  

  
  

  var faTableCells = {
    prefix: 'fasl',
    iconName: 'table-cells',
    icon: [
      512,
      512,
      ["th"],
      'f00a',
      
      'M352 64v96H480V64H352zm-32 0H192v96H320V64zM160 64H32v96H160V64zM32 192V320H160V192H32zm0 160v96H160V352H32zm160 96H320V352H192v96zm160 0H480V352H352v96zM480 320V192H352V320H480zM0 32H32 480h32V64 448v32H480 32 0V448 64 32zM192 320H320V192H192V320z'
      
    ]
  };

  
    var faTh = faTableCells;
  

  
  

  var faCircleSort = {
    prefix: 'fasl',
    iconName: 'circle-sort',
    icon: [
      512,
      512,
      ["sort-circle"],
      'e030',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 224H336h32V192L256 96 144 192v32h32zm142.8-32H193.2L256 138.1 318.8 192zM176 288H144v32l112 96 112-96V288H336 176zm142.8 32L256 373.9 193.2 320H318.8z'
      
    ]
  };

  
    var faSortCircle = faCircleSort;
  

  
  

  var faUpRightFromSquare = {
    prefix: 'fasl',
    iconName: 'up-right-from-square',
    icon: [
      512,
      512,
      ["external-link-alt"],
      'f35d',
      
      'M365.3 32l-8 8L472 154.7l8-8V32H365.3zM480 0h32V32 160l-17.4 17.4L472 200l-22.6-22.6-46.1-46.1-168 168L224 310.6 201.4 288l11.3-11.3 168-168L334.6 62.6 312 40l22.6-22.6L352 0H480zM0 32H16 208h16V64H208 32V480H448V304 288h32v16V496v16H464 16 0V496 48 32z'
      
    ]
  };

  
    var faExternalLinkAlt = faUpRightFromSquare;
  

  
  

  var faCherries = {
    prefix: 'fasl',
    iconName: 'cherries',
    icon: [
      640,
      512,
      [],
      'e0ec',
      
      'M288 32l8.9-13.3L273.8 3.3 272 31l0 0 0 0 0 0 0 0 0 .2-.1 .9c-.1 .8-.2 2.1-.4 3.9c-.4 3.5-1 8.6-2.1 15.2c-2.2 13.2-6 32-12.8 54.2C244.2 146.5 221.8 199 182 249.2c-15.2-9.4-46.7-25.2-86-25.2c0 0-96 0-96 112C0 480 144 512 192 512s192-16 192-176c0-112-96-112-96-112c-21.5 0-40.7 4.7-56.1 10.6c27.8-42.9 44.9-85.3 55.4-119.9c6.4-21.2 10.4-39.5 12.9-53.4l.4 .3c13.3 10.9 31.2 26.8 49.5 47.1c31.1 34.4 62.6 80.2 76.3 133.9c-13.2-6.7-31.7-14.1-53.6-17.2c11.7 10.6 22.1 24.2 29.8 41.3c1.7 .7 3.3 1.4 4.8 2.2c7 3.3 12.5 6.5 16.1 8.9c1.8 1.2 3.1 2.1 3.9 2.7c.4 .3 .6 .5 .8 .6l0 0L448 297l19.9-15.9 0 0c.1-.1 .4-.3 .8-.6c.8-.6 2.1-1.5 3.9-2.7c3.6-2.3 9.1-5.6 16.1-8.9c14.1-6.6 33.3-12.9 55.1-13l.1 0c.3 0 .8 0 1.6 .1c1.6 .1 4.2 .4 7.4 1.1c6.5 1.3 14.9 3.8 23 8.5C590 273.9 608 291.3 608 336c0 68-29.4 101.7-61.9 120.2c-35 20-76.5 23.8-98.1 23.8c-14.6 0-42.6-4-71.1-15.9c-7 9.2-14.8 17.4-23 24.8C390.4 506.3 427.7 512 448 512c48 0 192-16 192-176c0-112-96-112-96-112c-37.4 0-67.6 14.3-83.6 23.7C447 181.1 409 126.2 373.9 87.3c-19.7-21.7-38.8-38.8-53-50.4c-7.1-5.8-13-10.3-17.2-13.4c-2.1-1.5-3.7-2.7-4.9-3.5c-.6-.4-1-.7-1.3-.9l-.4-.3-.1-.1 0 0 0 0s0 0-8.9 13.3zm-.2 224l.1 0c.3 0 .8 0 1.6 .1c1.6 .1 4.2 .4 7.4 1.1c6.5 1.3 14.9 3.8 23 8.5C334 273.9 352 291.3 352 336c0 68-29.4 101.7-61.9 120.2c-35 20-76.5 23.8-98.1 23.8c-19.1 0-61.1-6.9-97.2-29.2C60.5 429.5 32 395 32 336c0-44.7 18-62.2 32.1-70.4c8.1-4.7 16.4-7.2 23-8.5c3.2-.6 5.8-.9 7.4-1.1c.8-.1 1.4-.1 1.6-.1l.1 0c21.9 0 41.1 6.3 55.1 13c7 3.3 12.5 6.5 16.1 8.9c1.8 1.2 3.1 2.1 3.9 2.7c.4 .3 .6 .5 .8 .6l0 0L192 297l19.9-15.9 0 0c.1-.1 .4-.3 .8-.6c.8-.6 2.1-1.5 3.9-2.7c3.6-2.3 9.1-5.6 16.1-8.9c14.1-6.6 33.3-12.9 55.1-13z'
      
    ]
  };

  

  
  

  var faFileVideo = {
    prefix: 'fasl',
    iconName: 'file-video',
    icon: [
      384,
      512,
      [],
      'f1c8',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM208 288v13.2V312v48 10.8V384H96V288H208zm32 96v-.4l58.1 23.2 21.9 8.8V392 280 256.4l-21.9 8.8L240 288.4V288 256H208 96 64v32 96 32H96 208h32V384zm48-15.6l-48-19.2V322.8l48-19.2v64.7z'
      
    ]
  };

  

  
  

  var faUsersViewfinder = {
    prefix: 'fasl',
    iconName: 'users-viewfinder',
    icon: [
      640,
      512,
      [],
      'e595',
      
      'M0 0V16 128v16H32V128 32h96 16V0H128 16 0zM640 0H624 512 496V32h16 96v96 16h32V128 16 0zM16 512H128h16V480H128 32V384 368H0v16V496v16H16zm624 0V496 384 368H608v16 96H512 496v32h16H624h16zM159.8 176a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM288 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm80.2-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM129.4 336l14.4-48h46.5l3.4-10.1 7.3-21.9H120L96 336h33.4zm366.8-48l14.4 48H544l-24-80H439.1l7.3 21.9 3.4 10.1h46.5zM224 288l-21.3 64L192 384h33.7H414.3 448l-10.7-32L416 288H224zm23.1 32H392.9l10.7 32H236.4l10.7-32z'
      
    ]
  };

  

  
  

  var faGalaxy = {
    prefix: 'fasl',
    iconName: 'galaxy',
    icon: [
      512,
      512,
      [],
      'e008',
      
      'M144 184c0-83.5 67.3-151.3 150.7-152c-31.8 30.1-52.7 69.6-59.9 112.2l-5.3 31.7 28.5-14.8C278.9 150.2 302.7 144 328 144c83.5 0 151.3 67.3 152 150.7c-30.1-31.8-69.6-52.7-112.2-59.9l-31.7-5.3 14.8 28.5C361.8 278.9 368 302.7 368 328c0 83.5-67.3 151.3-150.7 152c31.8-30.1 52.7-69.6 59.9-112.2l5.3-31.7-28.5 14.8C233.1 361.8 209.3 368 184 368c-83.5 0-151.3-67.3-152-150.7c30.1 31.8 69.6 52.7 112.2 59.9l31.7 5.3-14.8-28.5C150.2 233.1 144 209.3 144 184zM296 0C194.4 0 112 82.4 112 184c0 18.7 2.8 36.8 8 53.9c-25.4-9.2-48.4-24.5-67-44.9L27.8 165.2 0 134.6V176v40C0 317.6 82.4 400 184 400c18.7 0 36.8-2.8 53.9-8c-9.2 25.4-24.5 48.4-44.9 67l-27.7 25.2L134.6 512H176h40c101.6 0 184-82.4 184-184c0-18.7-2.8-36.8-8-53.9c25.4 9.2 48.4 24.5 67 44.9l25.2 27.7L512 377.4V336 296c0-101.6-82.4-184-184-184c-18.7 0-36.8 2.8-53.9 8c9.2-25.4 24.5-48.4 44.9-67l27.7-25.2L377.4 0H336 296zM233.4 310.6L256 333.3l22.6-22.6 32-32L333.3 256l-22.6-22.6-32-32L256 178.7l-22.6 22.6-32 32L178.7 256l22.6 22.6 32 32zm32-32L256 288l-9.4-9.4-13.3-13.3L224 256l9.4-9.4 13.3-13.3L256 224l9.4 9.4 13.3 13.3L288 256l-9.4 9.4-13.3 13.3z'
      
    ]
  };

  

  
  

  var faJ = {
    prefix: 'fasl',
    iconName: 'j',
    icon: [
      320,
      512,
      [106],
      '4a',
      
      'M320 32V48 320c0 88.4-71.6 160-160 160S0 408.4 0 320V272 256H32v16 48c0 70.7 57.3 128 128 128s128-57.3 128-128V48 32h32z'
      
    ]
  };

  

  
  

  var faHighDefinition = {
    prefix: 'fasl',
    iconName: 'high-definition',
    icon: [
      576,
      512,
      ["rectangle-hd"],
      'e1ae',
      
      'M544 64V448H32V64H544zM32 32H0V64 448v32H32 544h32V448 64 32H544 32zM320 160v16V336v16h16 48c53 0 96-43 96-96s-43-96-96-96H336 320zm64 32c35.3 0 64 28.7 64 64s-28.7 64-64 64H352V192h32zM144 176V160H112v16 80 80 16h32V336 272h96v64 16h32V336 256 176 160H240v16 64H144V176z'
      
    ]
  };

  
    var faRectangleHd = faHighDefinition;
  

  
  

  var faRestroom = {
    prefix: 'fasl',
    iconName: 'restroom',
    icon: [
      640,
      512,
      [],
      'f7bd',
      
      'M144 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 144 0zM82.8 128H92.9 195.1h10.1l4.4 9.1 68.9 144 6.9 14.4-28.9 13.8-6.9-14.4L208 208.1V496v16H176V496 352H112V496v16H80V496 208.1L38.4 294.9l-6.9 14.4L2.7 295.5l6.9-14.4 68.9-144 4.4-9.1zM112 320h64V160H112V320zM496 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 496 0zM469.5 248.8l-7.2 14.3L409.9 368H432h32 64 32 22.1L529.7 263.2l-7.2-14.3 28.6-14.3 7.2 14.3 64 128L633.9 400H608 560v96 16H528V496 400H464v96 16H432V496 400H384 358.1l11.6-23.2 64-128 7.2-14.3 28.6 14.3zM444.9 128H547.1h9.6l4.5 8.5 76.9 144-28.2 15.1L537.5 160h-83L382.1 295.5l-28.2-15.1 76.9-144 4.5-8.5h9.6zM336 16V496v16H304V496 16 0h32V16z'
      
    ]
  };

  

  
  

  var faDiceD6 = {
    prefix: 'fasl',
    iconName: 'dice-d6',
    icon: [
      448,
      512,
      [],
      'f6d1',
      
      'M208 502.9l16 9.1 16-9.1L448 384V140.1 121.4l-16.3-8.9L224 0 16.2 115.9 0 125v18.5V384L208 502.9zM32 365.4V162.2l176 103V466L32 365.4zM48.3 134.7L224.2 36.5l175.6 95.2L223.9 237.4 48.3 134.7zM416 159.3V365.4L240 466V265.1L416 159.3z'
      
    ]
  };

  

  
  

  var faAlignLeft = {
    prefix: 'fasl',
    iconName: 'align-left',
    icon: [
      448,
      512,
      [],
      'f036',
      
      'M16 48H0V80H16 272h16V48H272 16zm0 128H0v32H16 432h16V176H432 16zM0 304v32H16 272h16V304H272 16 0zM16 432H0v32H16 432h16V432H432 16z'
      
    ]
  };

  

  
  

  var faTemperatureSun = {
    prefix: 'fasl',
    iconName: 'temperature-sun',
    icon: [
      640,
      512,
      ["temperature-hot"],
      'f76a',
      
      'M312 104L300.5 35 294.7 0 265.6 20.3 208 60.7 150.4 20.3 121.3 0l-5.8 35L104 104 35 115.5 0 121.3l20.3 29.1L60.7 208 20.3 265.6 0 294.7l35 5.8L104 312l11.5 69 5.8 35 29.1-20.3L208 355.3l57.6 40.3 9.4 6.6c-2-11.1-3-22.6-3-34.3c0-2.6 .1-5.2 .2-7.8l-.5-.5-.2 1.1-45.1-31.6L208 316.3l-18.4 12.8-45.1 31.6-9-53.9-3.8-22.5-22.5-3.8-53.9-9 31.6-45.1L99.7 208 86.9 189.7 55.3 144.6l53.9-9 22.5-3.8 3.8-22.5 9-53.9 45.1 31.6L208 99.7l18.4-12.8 45.1-31.6 9 53.9 3.8 22.5 22.5 3.8 29.3 4.9V108l-24-4zM256 208a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160zM389.3 284.5L400 275V260.7 32H528V260.7 275l10.7 9.5c23 20.6 37.3 50.3 37.3 83.5c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-33.2 14.4-62.9 37.3-83.5zM560 0H528 400 368V32 260.7c-29.5 26.4-48 64.7-48 107.3c0 79.5 64.5 144 144 144s144-64.5 144-144c0-42.6-18.5-81-48-107.3V32 0zM432 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V96 80H448V96 306c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  
    var faTemperatureHot = faTemperatureSun;
  

  
  

  var faCupStrawSwoosh = {
    prefix: 'fasl',
    iconName: 'cup-straw-swoosh',
    icon: [
      384,
      512,
      [],
      'e364',
      
      'M224 0H211.5l-3 12.1L179.5 128H16 0v32H16 368h16V128H368 212.5l24-96H272h16V0H272 224zM37.3 192L64 512H320l26.7-320H314.6l-4.2 50c-36.2 3.7-61.4 12.6-80.6 24.9c-19.3 12.3-31.7 27.6-42.5 41l-2 2.5c-11.5 14.1-22 26.3-39.1 36.1c-14 8-33.3 14.9-62.3 18.6L69.4 192H37.3zM86.5 397c32.9-4.1 56.8-12 75.5-22.8c22.6-13 36.2-29.2 48-43.7l1.4-1.7c11.3-13.9 20.7-25.5 35.5-35c13.2-8.5 31.7-15.7 60.7-19.4L290.6 480H93.4l-6.9-83z'
      
    ]
  };

  

  
  

  var faArrowLeftFromBracket = {
    prefix: 'fasl',
    iconName: 'arrow-left-from-bracket',
    icon: [
      512,
      512,
      [],
      'e668',
      
      'M11.3 244.7L0 256l11.3 11.3 128 128 11.3 11.3L173.3 384l-11.3-11.3L61.3 272 336 272l16 0 0-32-16 0L61.3 240 161.9 139.3 173.3 128l-22.6-22.6-11.3 11.3-128 128zM336 448l-16 0 0 32 16 0 160 0 16 0 0-16 0-416 0-16-16 0L336 32l-16 0 0 32 16 0 144 0 0 384-144 0z'
      
    ]
  };

  

  
  

  var faRuler = {
    prefix: 'fasl',
    iconName: 'ruler',
    icon: [
      512,
      512,
      [128207],
      'f545',
      
      'M512 160l-22.6-22.6L374.6 22.6 352 0 329.4 22.6 22.6 329.4 0 352l22.6 22.6L137.4 489.4 160 512l22.6-22.6L489.4 182.6 512 160zM352 45.3L466.7 160 160 466.7 45.3 352l46.1-46.1 41.4 41.4L144 358.6 166.6 336l-11.3-11.3-41.4-41.4 41.4-41.4 41.4 41.4L208 294.6 230.6 272l-11.3-11.3-41.4-41.4 41.4-41.4 41.4 41.4L272 230.6 294.6 208l-11.3-11.3-41.4-41.4 41.4-41.4 41.4 41.4L336 166.6 358.6 144l-11.3-11.3L305.9 91.3 352 45.3z'
      
    ]
  };

  

  
  

  var faPersonCircleXmark = {
    prefix: 'fasl',
    iconName: 'person-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e543',
      
      'M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM99.3 128h9.6H211.1h9.6l4.5 8.5 66.7 124.9c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496v16H192V496 352H128V496v16H96V496 202.1L46.1 295.5l-7.5 14.1L10.3 294.6l7.5-14.1 76.9-144 4.5-8.5zM128 320h64V160H128V320zm416 48a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-36.7L454.6 368l36.7 36.7L502.6 416 480 438.6l-11.3-11.3L432 390.6l-36.7 36.7L384 438.6 361.4 416l11.3-11.3L409.4 368l-36.7-36.7L361.4 320 384 297.4l11.3 11.3L432 345.4l36.7-36.7L480 297.4 502.6 320l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faArrowLeft = {
    prefix: 'fasl',
    iconName: 'arrow-left',
    icon: [
      448,
      512,
      [8592],
      'f060',
      
      'M12.7 244.7L1.4 256l11.3 11.3 168 168L192 446.6 214.6 424l-11.3-11.3L62.6 272 432 272l16 0 0-32-16 0L62.6 240 203.3 99.3 214.6 88 192 65.4 180.7 76.7l-168 168z'
      
    ]
  };

  

  
  

  var faLeafMaple = {
    prefix: 'fasl',
    iconName: 'leaf-maple',
    icon: [
      512,
      512,
      [127809],
      'f6f6',
      
      'M469.6 68.2L448 144l35.4 22.1L512 184l-25.9 21.6L448.4 237 416 264l16.3 2.7 25.3 4.2L464 272l-7.8 31.1L448 336l31.4 26.9L504 384l-24.6 21.1L448 432l4.6 46 3.4 34-33-8.6L272 464l-24.5 24.5L224 512l-16.2-29.1L152.1 382.5 38.5 496.1 27.2 507.4 4.6 484.8l11.3-11.3L129.5 359.9 29.1 304.2 0 288l23.5-23.5L48 240 8.6 89 0 56l34 3.4L80 64l26.9-31.4L128 8l21.1 24.6L176 64l32.9-8.2L240 48l1.1 6.3 4.2 25.3L248 96l27-32.4 31.4-37.7L328 0l17.9 28.6L368 64l75.8-21.6L480 32 469.6 68.2zM153 336.4L293.6 195.8l11.3-11.3 22.6 22.6-11.3 11.3L175.6 359l55.8 100.4 18-18 13-13 17.7 4.6 139.5 36.4-3.4-34.2-1.7-16.6 12.7-10.9L454.8 384l-27.7-23.7-15-12.9 4.8-19.2 7.6-30.4-13.8-2.3-68.8-11.5 53.6-44.7 62-51.7L431 171.1l-20.4-12.8 6.6-23.2 16.2-56.6L376.8 94.8l-23.2 6.6L340.9 81 324.3 54.4l-51.7 62-44.7 53.6-11.5-68.8-2.3-13.8L183.8 95l-19.2 4.8-12.9-15L128 57.2 104.3 84.8 93.4 97.5 76.8 95.8 42.6 92.4 79 231.9l4.6 17.7-13 13-18 18L153 336.4z'
      
    ]
  };

  

  
  

  var faRepublican = {
    prefix: 'fasl',
    iconName: 'republican',
    icon: [
      640,
      512,
      [],
      'f75e',
      
      'M0 176C0 96.5 64.5 32 144 32H368c79.5 0 144 64.5 144 144v96 64 16 16c0 8.8 7.2 16 16 16s16-7.2 16-16V272 256h16 64 16v16 96c0 61.9-50.1 112-112 112c-31.3 0-59.7-12.9-80-33.6V464v16H432 304 288V464 384H160v80 16H144 16 0V464 272 176zM528 448c44.2 0 80-35.8 80-80V288H576v80c0 26.5-21.5 48-48 48s-48-21.5-48-48V352 336 288H32V448h96V368 352h16H304h16v16 80h96V368 352h32v16c0 44.2 35.8 80 80 80zM32 256H480V176c0-61.9-50.1-112-112-112H144C82.1 64 32 114.1 32 176v80zM160 144v16h16 16v32H176 160v16 16H128V208 192H112 96V160h16 16V144 128h32v16zm112-16v16 16h16 16v32H288 272v16 16H240V208 192H224 208V160h16 16V144 128h32zm112 16v16h16 16v32H400 384v16 16H352V208 192H336 320V160h16 16V144 128h32v16z'
      
    ]
  };

  

  
  

  var faHandsClapping = {
    prefix: 'fasl',
    iconName: 'hands-clapping',
    icon: [
      512,
      512,
      [],
      'e1a8',
      
      'M336 16V0H304V16 80 96h32V80 16zM228.4 9.8L201.8 27.6l8.9 13.3 32 48 8.9 13.3 26.6-17.8-8.9-13.3-32-48L228.4 9.8zm183.1 0l-8.9 13.3-32 48-8.9 13.3 26.6 17.8 8.9-13.3 32-48 8.9-13.3L411.6 9.8zM179.3 124.7L168 113.4l-11.3 11.3L120 161.4 99.3 140.7 88 129.4 76.7 140.7l-48 48L17.4 200l11.3 11.3L49.4 232 12.7 268.7 1.4 280l11.3 11.3L49.4 328 12.7 364.7 1.4 376l11.3 11.3 23.9 23.9 .1 .1 16 16L64 438.6l22.3 22.3C119 493.6 163.4 512 209.6 512C305.9 512 384 433.9 384 337.6V176 160H368 304 288v16 57.4L179.3 124.7zM72 209.4L62.6 200 88 174.6l9.4 9.4 0 0 11.3 11.3 88 88L208 294.6l0 0 0 0L230.6 272l-11.3-11.3L142.6 184 168 158.6 292.7 283.3 320 272V192h32V337.6C352 416.2 288.2 480 209.6 480c-37.8 0-74-15-100.7-41.7L86.6 416 75.3 404.7l-16-16L46.6 376 72 350.6l28.7 28.7L112 390.6 134.6 368l-11.3-11.3-40-40L72 305.4 46.6 280 72 254.6l76.7 76.7L160 342.6 182.6 320l-11.3-11.3-88-88L72 209.4zM360.8 478.1c-11.7 12.6-25 23.7-39.5 33.1c5.4 .5 10.9 .8 16.4 .8C433.9 512 512 433.9 512 337.6V176 160H496 432 416v16 57.4l0 0v45.3l4.7 4.7L448 272V192h32V337.6c0 70.7-51.6 129.4-119.2 140.5z'
      
    ]
  };

  

  
  

  var faSnowflakes = {
    prefix: 'fasl',
    iconName: 'snowflakes',
    icon: [
      640,
      512,
      [],
      'f7cf',
      
      'M240 16V0H208V16 89.4L171.3 52.7 160 41.4 137.4 64l11.3 11.3L208 134.6v93.7l-81.1-46.8-21.7-81L101 85 70.1 93.3l4.1 15.5 13.4 50.1L17.2 118.1l-16 27.7 70.5 40.7L21.6 200 6.1 204.1 14.4 235l15.5-4.1 81-21.7L192 256l-81.1 46.8-81-21.7L14.4 277 6.1 307.9 21.6 312l50.1 13.4L1.2 366.1l16 27.7 70.5-40.7L74.3 403.3l-4.1 15.5L101 427l4.1-15.5 21.7-81L208 283.7v93.7l-59.3 59.3L137.4 448 160 470.6l11.3-11.3L208 422.6V496v16h32V496 422.6l36.7 36.7L288 470.6 310.6 448l-11.3-11.3L240 377.4V283.7l81.1 46.8 21.7 81L347 427l30.9-8.3-4.1-15.5-13.4-50.1 70.5 40.7 16-27.7-70.5-40.7L426.4 312l15.5-4.1L433.6 277l-15.5 4.1-81 21.7L256 256l81.1-46.8 81 21.7 15.5 4.1 8.3-30.9L426.4 200l-50.1-13.4 70.5-40.7-16-27.7-70.5 40.7 13.4-50.1 4.1-15.5L347 85l-4.1 15.5-21.7 81L240 228.3V134.6l59.3-59.3L310.6 64 288 41.4 276.7 52.7 240 89.4V16zM561.4 264l-28.7 28.7 22.6 22.6L584 286.6l28.7 28.7 22.6-22.6L606.6 264l28.7-28.7-22.6-22.6L584 241.4l-28.7-28.7-22.6 22.6L561.4 264zM484.7 27.3L513.4 56 484.7 84.7l22.6 22.6L536 78.6l28.7 28.7 22.6-22.6L558.6 56l28.7-28.7L564.7 4.7 536 33.4 507.3 4.7 484.7 27.3z'
      
    ]
  };

  

  
  

  var faCircleAmpersand = {
    prefix: 'fasl',
    iconName: 'circle-ampersand',
    icon: [
      512,
      512,
      [],
      'e0f8',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128v16 37.4c0 15.9 5.9 31.3 16.7 43.1l16.6 18.2-37.5 25.8c-17.4 11.9-27.7 31.7-27.7 52.7V368v16h16 96 16 8.2l4.8-6.7 20.5-28.7L337.8 384h43.3l-5.3-5.8-51.3-56.3L365 265.3l9.3-13-26-18.6-9.3 13-36.4 51-44.9-49.4 18.7-12.8c17.4-11.9 27.7-31.7 27.7-52.7V144 128H288 192 176zm59.9 96.4L216.3 203c-5.4-5.9-8.3-13.6-8.3-21.5V160h64v22.8c0 10.5-5.2 20.4-13.9 26.4l-22.3 15.3zM231 266.6l52.5 57.7L263.8 352H176V321.2c0-10.5 5.2-20.4 13.9-26.4L231 266.6z'
      
    ]
  };

  

  
  

  var faCampfire = {
    prefix: 'fasl',
    iconName: 'campfire',
    icon: [
      512,
      512,
      [],
      'f6ba',
      
      'M266 37.6L228.4 0C189.6 24.2 112 93.1 112 174.5c0 77.5 60.6 140.8 137 145.2c2.8 .2 5.6 .4 8.4 .4s5.7-.1 8.4-.4c76.4-4.4 137-67.7 137-145.2c0-24.2-17.5-87.3-87.3-145.5l-8.5 8.5L286.5 58.2 266 37.6zm-8.5 253.3c-2.2 0-4.4-.1-6.5-.2c-30.6-3-51.7-26.7-51.7-52c0-19.9 14.5-43.2 35.5-64.9c8-8.2 16-15.3 22.7-20.9c6.7 5.5 14.8 12.6 22.7 20.9c21 21.7 35.5 45 35.5 64.9c0 25.3-21.1 49.1-51.7 52c-2.2 .1-4.3 .2-6.5 .2zm87.3-52.2c0-64-87.3-122.2-87.3-122.2s-87.3 58.2-87.3 122.2c0 4.9 .5 9.7 1.3 14.3c-18.9-20.7-30.4-48.2-30.4-78.5c0-31.5 15.2-62.8 37.3-90.6c15-18.8 32-34.6 46.7-46.1L266 78.8l20.6 20.6 20.6-20.6 9.5-9.5c47.2 47.4 57.2 92.4 57.2 105.2c0 30.2-11.5 57.8-30.4 78.5c.9-4.7 1.3-9.4 1.3-14.3zM37.9 295.5l-14.9-5.9L11.2 319.3l14.9 5.9L212.9 400 26.1 474.7l-14.9 5.9 11.9 29.7 14.9-5.9L256 417.2l218.1 87.2 14.9 5.9 11.9-29.7-14.9-5.9L299.1 400l186.9-74.7 14.9-5.9-11.9-29.7-14.9 5.9L256 382.8 37.9 295.5z'
      
    ]
  };

  

  
  

  var faHandsHolding = {
    prefix: 'fasl',
    iconName: 'hands-holding',
    icon: [
      640,
      512,
      [],
      'f4c2',
      
      'M128 64H112 16 0V80 384v6.6l4.7 4.7 104 104L120 510.6 142.6 488l-11.3-11.3L32 377.4V96H96V288v6.6l1.4 1.4 3.3 3.3 8 8 72 72s0 0 0 0l16 16L208 406.6 230.6 384l-11.3-11.3-16-16s0 0 0 0L142.6 296 176 262.6l128 128V496v16h32V496 390.6l128-128L497.4 296l-60.7 60.7L425.4 368l-4.7 4.7L409.4 384 432 406.6l11.3-11.3 4.7-4.7 11.3-11.3 72-72 8-8 3.3-3.3 1.4-1.4V288 96h64V377.4l-99.3 99.3L497.4 488 520 510.6l11.3-11.3 104-104 4.7-4.7V384 80 64H624 528 512V80 265.4l-36.7-36.7L464 217.4l-11.3 11.3L320 361.4 187.3 228.7 176 217.4l-11.3 11.3L128 265.4V80 64z'
      
    ]
  };

  

  
  

  var faHeadphones = {
    prefix: 'fasl',
    iconName: 'headphones',
    icon: [
      512,
      512,
      [127911],
      'f025',
      
      'M256 64C143.2 64 49.8 147.4 34.3 256H128V480H0V368 288C0 146.6 114.6 32 256 32s256 114.6 256 256v80V480H384V256h93.7C462.2 147.4 368.8 64 256 64zM480 368V288H416V448h64V368zM32 448H96V288H32v80 80z'
      
    ]
  };

  

  
  

  var faTengeSign = {
    prefix: 'fasl',
    iconName: 'tenge-sign',
    icon: [
      384,
      512,
      [8376,"tenge"],
      'f7d7',
      
      'M0 32H384V64H0V32zM208 160H384v32H208V480H176V192H0V160H176h32z'
      
    ]
  };

  
    var faTenge = faTengeSign;
  

  
  

  var faSquare7 = {
    prefix: 'fasl',
    iconName: 'square-7',
    icon: [
      448,
      512,
      [],
      'e25c',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM320 147.9l-1.8 3.4L198.6 384h-36L277.8 160H144 128V128h16H304h16v19.9z'
      
    ]
  };

  

  
  

  var faLampFloor = {
    prefix: 'fasl',
    iconName: 'lamp-floor',
    icon: [
      640,
      512,
      [],
      'e015',
      
      'M161.3 224H128l9.1-32L192 0H448l54.9 192 9.1 32H478.7 161.3zm308.3-32L423.9 32H216.1L170.4 192H469.6zM208 480h96V256h32V480h96 16v32H432 320 208 192V480h16z'
      
    ]
  };

  

  
  

  var faSunCloud = {
    prefix: 'fasl',
    iconName: 'sun-cloud',
    icon: [
      640,
      512,
      [127780],
      'f763',
      
      'M178.7 15.5L256 57.1l77.3-41.6L362 0l9.4 31.3 25.2 84.1 84.1 25.2L512 150l-15.5 28.8L488 194.6c-7.7-1.7-15.7-2.6-24-2.6c-3.8 0-7.6 .2-11.3 .6l12.5-23.2L387.4 146l-16.5-5-5-16.5L342.7 46.8 271.2 85.3 256 93.5l-15.2-8.2L169.3 46.8 146 124.6l-5 16.5-16.5 5L46.8 169.3l38.5 71.5L93.5 256l-8.2 15.2L46.8 342.7 124.6 366l16.5 5 5 16.5 23.3 77.8 71.5-38.5 15.2-8.2 15.2 8.2 71.5 38.5 5.2-17.2h33.4l-9.8 32.7L362 512l-28.8-15.5L256 454.9l-77.3 41.6L150 512l-9.4-31.3-25.2-84.1L31.3 371.4 0 362l15.5-28.8L57.1 256 15.5 178.7 0 150l31.3-9.4 84.1-25.2 25.2-84.1L150 0l28.8 15.5zM256 128c61.3 0 112.6 43.1 125.1 100.7c-8 8.8-14.6 18.9-19.5 29.9c-3.3 .8-6.6 1.8-9.7 2.9c.1-1.8 .2-3.7 .2-5.5c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c11.3 0 22.1-1.9 32.2-5.5c-.1 1.8-.2 3.7-.2 5.5v28c-10.2 2.6-21 4-32 4c-70.7 0-128-57.3-128-128s57.3-128 128-128zM416 304c0 .7 0 1.4 0 2.1l1 23.7-22.3-7.9c-3.3-1.2-6.9-1.8-10.7-1.8c-17.7 0-32 14.3-32 32v32h32H560h48V336c0-26.5-21.5-48-48-48c-9.9 0-19.1 3-26.7 8.1l-17.2 11.5-6.8-19.5C502.7 269.4 484.9 256 464 256c-26.5 0-48 21.5-48 48zm48-80c28.5 0 53.4 14.8 67.6 37.2c8.8-3.4 18.4-5.2 28.4-5.2c44.2 0 80 35.8 80 80v64 16H624 560 384 336 320V400 352c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0c7.4-36.5 39.7-64 78.4-64z'
      
    ]
  };

  

  
  

  var faDivide = {
    prefix: 'fasl',
    iconName: 'divide',
    icon: [
      448,
      512,
      [247,10135],
      'f529',
      
      'M192 96v64h64V96H192zM160 64h32 64 32V96v64 32H256 192 160V160 96 64zM432 272H416 32 16V240H32 416h16v32zM256 352H192v64h64V352zm-64-32h64 32v32 64 32H256 192 160V416 352 320h32z'
      
    ]
  };

  

  
  

  var faEnvelopeOpenDollar = {
    prefix: 'fasl',
    iconName: 'envelope-open-dollar',
    icon: [
      512,
      512,
      [],
      'f657',
      
      'M416 32H96V222.5L77.5 207.2c-4.2-3.4-8.7-6.3-13.5-8.6V32 0H96 416h32V32 198.6c-4.8 2.3-9.3 5.2-13.4 8.6L416 222.5V32zM256 414.8l-18.1-12.5L32 260.8V480H480V260.8L274.1 402.4 256 414.8zM480 222l32-22v38.8V480v32H480 32 0V480 238.8 200l32 22L256 376 480 222zM272 96v9.6c5.9 1 19 3.5 24.1 4.9l15.5 4.1-8.2 30.9-15.5-4.1c-4-1.1-17.7-3.7-22.1-4.4c-12.8-2-23.6-.4-30.9 2.9c-7.2 3.3-9.9 7.5-10.5 11c-.7 4.1-.1 6.2 .5 7.4c.6 1.4 2 3.1 5 5.1c6.7 4.6 17.1 7.8 31 12l.6 .2c12.3 3.7 27.9 8.4 39.5 16.9c6.3 4.5 12 10.6 15.6 18.8c3.6 8.3 4.4 17.4 2.7 27.2c-3 17.5-14.6 29.4-29.3 35.7c-5.6 2.4-11.6 4-17.9 4.9V288v16H240V288v-9.6c-9.4-1.7-23.6-6.6-32.4-9.6l0 0 0 0 0 0c-1.8-.6-3.3-1.1-4.6-1.6l-15.2-5.1 10.1-30.4 15.2 5.1c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c9.5 3.2 20.7 7 27.1 8.1c13.3 2.1 24 .8 31-2.2c6.5-2.8 9.5-6.7 10.3-11.8c.8-4.7 .2-7.3-.5-9c-.7-1.7-2.2-3.6-5.1-5.7c-6.5-4.8-16.7-8.1-30.5-12.3l-2-.6 0 0c-11.9-3.6-26.6-8-37.7-15.5c-6.2-4.2-12.2-10-15.9-17.9c-3.8-8.1-4.7-17.1-3.1-26.6c2.9-16.7 14.7-28.4 28.8-34.7c5.6-2.6 11.8-4.4 18.3-5.4V96 80h32V96z'
      
    ]
  };

  

  
  

  var faCubes = {
    prefix: 'fasl',
    iconName: 'cubes',
    icon: [
      576,
      512,
      [],
      'f1b3',
      
      'M288 4.9l5.4 1.9 136 48.5L440 59.2V70.4 212.8l125.4 44.7 10.6 3.8v11.3V434.8v10.7l-9.9 4.1-136 56.3-6.1 2.5-6.1-2.5L288 452.1 158.1 505.8l-6.1 2.5-6.1-2.5L9.9 449.6 0 445.5V434.8 272.6 261.4l10.6-3.8L136 212.8V70.4 59.2l10.6-3.8 136-48.5L288 4.9zM408 106.3L304 146.2V249.9l104-37.1V106.3zM272 146.2L168 106.3V212.8l104 37.1V146.2zm32 277.9l112 46.3V348.6L304 308.2V424.1zm144 39.7l96-39.7V308.9l-96 39.2V463.8zM272 308.2L160 348.6V470.4l112-46.3V308.2zM32 424.1l96 39.7V348.1L32 308.9V424.1zM288 38.9L181.1 77 288 118 394.9 77 288 38.9zM152 241.1L44.6 279.4l99.8 40.8 114.1-41.1L152 241.1zm379.4 38.3L424 241.1l-106.5 38 114.1 41.1 99.8-40.8z'
      
    ]
  };

  

  
  

  var faSquareR = {
    prefix: 'fasl',
    iconName: 'square-r',
    icon: [
      448,
      512,
      [],
      'e27c',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm128 96h16 96c44.2 0 80 35.8 80 80c0 35.1-22.6 64.9-54.1 75.7L327.2 384H289.7L231 288H160v80 16H128V368 272 144 128zm32 128h80c26.5 0 48-21.5 48-48s-21.5-48-48-48H160v96z'
      
    ]
  };

  

  
  

  var faBillboard = {
    prefix: 'fasl',
    iconName: 'billboard',
    icon: [
      640,
      512,
      [],
      'e5cd',
      
      'M432 16V0H400V16 32H240V16 0H208V16 32H64 32V64 352H0v32H32 64 304V488v16h32V488 384H576h32 32V352H608V64 32H576 432V16zM336 352H304 64V64H208v64H192 176v32h16 32 32 16V128H256 240V64H400v64H384 368v32h16 32 32 16V128H448 432V64H576V352H336z'
      
    ]
  };

  

  
  

  var fa0 = {
    prefix: 'fasl',
    iconName: '0',
    icon: [
      320,
      512,
      [],
      '30',
      
      'M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160V320c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 64C89.3 64 32 121.3 32 192V320c0 70.7 57.3 128 128 128s128-57.3 128-128V192c0-70.7-57.3-128-128-128z'
      
    ]
  };

  

  
  

  var faShirt = {
    prefix: 'fasl',
    iconName: 'shirt',
    icon: [
      640,
      512,
      [128085,"t-shirt","tshirt"],
      'f553',
      
      'M172.6 0h-6.1L162 4 141.5 22.2l-72 64L15.7 134.1l-12 10.6 10.6 12 95.7 107.6 10.6 12 12-10.6L160 241.3V496v16h16H464h16V496 241.3l27.3 24.3 12 10.6 10.6-12 95.7-107.6 10.6-12-12-10.6L570.5 86.2l-72-64L478 4l-4.5-4h-6.1H440 416h-8.4H393 247 232.4 224 200 172.6zm79.5 32H387.9C378 60 351.3 80 320 80s-58-20-67.9-48zM165.4 193.7l-.2 .2 0 0-41.9 37.2L48.9 147.3l41.9-37.2 72-64L178.7 32H200h18.8c10.8 45.9 52 80 101.2 80s90.4-34.1 101.2-80H440h21.3l15.9 14.1 72 64 41.9 37.2-74.4 83.7-41.9-37.2 0 0-.2-.1L448 170v35.6V480H192V205.7 170l-26.6 23.7z'
      
    ]
  };

  
    var faTShirt = faShirt;
  
    var faTshirt = faShirt;
  

  
  

  var faClockSix = {
    prefix: 'fasl',
    iconName: 'clock-six',
    icon: [
      512,
      512,
      [],
      'e352',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112V368v16H240V368 112 96h32v16z'
      
    ]
  };

  

  
  

  var faHose = {
    prefix: 'fasl',
    iconName: 'hose',
    icon: [
      448,
      512,
      [],
      'e419',
      
      'M288 112v16h32V112v-1.9l96-12V112h32V96 94.1 80 48 33.9 32 16l-32 0V29.9l-96-12V16 0H288V16 64v48zm32-61.9l96 12v3.8l-96 12V64 50.1zM32 416V384H416v32H32zm416 0V384 368 352 320 304 288 240 224H432 152c-30.9 0-56-25.1-56-56s25.1-56 56-56H256V80H152c-48.6 0-88 39.4-88 88s39.4 88 88 88H416v32H152C85.7 288 32 234.3 32 168S85.7 48 152 48H256V16H152C68.1 16 0 84.1 0 168c0 48.8 23 92.2 58.7 120H16 0v16 48 16 16 32 16 16 48 16H16 432h16V496 448 432 416zM152 320H416v32H32V320H152zM416 448v32H32V448H416z'
      
    ]
  };

  

  
  

  var faPhoneXmark = {
    prefix: 'fasl',
    iconName: 'phone-xmark',
    icon: [
      640,
      512,
      [],
      'e227',
      
      'M344.4 355.3l21.3 12.3L383 350.2l40.7-40.7L539.8 356 517.3 480H512C282.2 480 96 293.7 96 64l0-5.3L220 36.2l46.5 116.1-40.7 40.7-17.3 17.3 12.3 21.3c29.6 51.4 72.4 94.1 123.7 123.7zM576 336L416 272l-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L304 160 240 0 64 32l0 32c0 247.4 200.6 448 448 448h32l32-176zM423.4 .8L400.8 23.4l11.3 11.3L465.4 88l-53.3 53.3-11.3 11.3 22.6 22.6 11.3-11.3L488 110.6l53.3 53.3 11.3 11.3 22.6-22.6-11.3-11.3L510.6 88l53.3-53.3 11.3-11.3L552.6 .8 541.3 12.1 488 65.4 434.7 12.1 423.4 .8z'
      
    ]
  };

  

  
  

  var faGuitars = {
    prefix: 'fasl',
    iconName: 'guitars',
    icon: [
      512,
      512,
      [],
      'f8bf',
      
      'M80 0H96h64 16V16 88v4.8l-2.7 4-29.3 44v36c29.1 3.3 54.6 15.3 72 32.7v19.9c0 13 2.9 24.8 5.7 34.3c1.4 4.8 3 9.4 4.4 13.5l0 .1 0 0 0 0c1.4 4.2 2.6 7.7 3.7 11.1c.8 2.5 1.4 5.4 1.8 8.9c-1 1.9-2.1 3.8-3.3 5.7c-5.4 8.6-6.9 19.7-4.4 29.6c-2.4 5.4-5.3 11.7-8.7 19l0 0 0 0 0 0-.3 .6c-2.3 5-4.8 10.3-7.2 16l-.3-.3c-20.9-23.2-21.3-58-6.2-82c4.5-7.1 6.7-14.5 6.7-22c0-21.6-22.4-49.2-64-54.9v65.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V209.1c-41.6 5.7-64 33.4-64 54.9c0 7.5 2.2 14.9 6.7 22c15.1 23.9 14.7 58.8-6.2 82C37.6 380.1 32 393.9 32 408c0 33.9 36.5 72 96 72c27.4 0 49.9-8.1 66.2-20.1c2.3 10.9 6.2 21.2 11.6 30.6C184.3 504 157.3 512 128 512C57.3 512 0 465.4 0 408c0-23 9.2-44.3 24.8-61.5c10.3-11.4 11.1-30.4 2.9-43.4C20.2 291.3 16 278 16 264c0-44.3 41.7-81 96-87.1v-36l-29.3-44-2.7-4V88 16 0zm32 320a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16-212.8l16-24V32H112V83.2l16 24zM248 176h31.7 .3s0 64 64 64h8V198l-52-59.5-5.3-6 1.7-7.8 24-112L323.1 0H336h36c28.7 0 52 23.3 52 52c0 24.6-17.1 45.2-40 50.6V192v48h8c64 0 64-48 64-48h.3H488v31.7 5.8c0 12.9-4.3 25.4-8.5 37.8l0 0 0 0 0 0c-1.4 4-2.7 7.9-3.9 11.8c-2.1 6.8-3.6 15.1-3.6 24.8c0 19.2 8.6 37.5 17.8 57.2c10.7 22.8 22.2 47.3 22.2 77c0 40.8-33 73.8-73.8 73.8H297.8C257 512 224 479 224 438.2c0-29.7 11.5-54.3 22.2-77c9.2-19.7 17.8-38 17.8-57.2c0-9.8-1.5-18-3.6-24.8c-1.2-3.9-2.5-7.9-3.9-11.8l0 0 0 0 0 0c-4.2-12.4-8.5-25-8.5-37.8V207.7 176zm96 95.7c-21.5 0-39.8-5.5-54.6-15.3c-1.4-1-2.8-2-4.2-3l1.1 3.3 .2 .5c1.3 3.8 2.8 8.2 4.2 12.7c2.9 9.6 4.9 21 4.9 34.1c0 26.7-11.8 51.5-20.5 69.9l0 0c-.9 1.8-1.7 3.6-2.5 5.3c-9.9 21.3-17 38.9-17 59c0 23.3 18.9 42.1 42.1 42.1H438.2c23.3 0 42.1-18.9 42.1-42.1c0-20.1-7.1-37.7-17-59c-.8-1.7-1.6-3.5-2.5-5.3l0 0 0 0c-8.7-18.4-20.5-43.2-20.5-69.9c0-13 2-24.4 4.9-34.1c1.3-4.4 2.8-8.7 4.1-12.5c-14.6 8.8-33.5 14.3-57.4 14.3H371.2c-1 .2-2.1 .3-3.2 .3s-2.2-.1-3.2-.3H344zm8-122.3V88 72h16 4c11 0 20-9 20-20s-9-20-20-20H348.9l-19.6 91.5L352 149.4zM336 336h64 16v32H400 336 320V336h16zm0 64h64 16v32H400 336 320V400h16z'
      
    ]
  };

  

  
  

  var faScrollOld = {
    prefix: 'fasl',
    iconName: 'scroll-old',
    icon: [
      576,
      512,
      [],
      'f70f',
      
      'M80 64c-26.5 0-48 21.5-48 48v80H96v32H16 0V208 112C0 67.8 35.8 32 80 32H400c44.2 0 80 35.8 80 80V288H448V256H400 384V224h16 48V160H400 384V128h16 48V112c0-26.5-21.5-48-48-48H144c10 13.4 16 30 16 48V224h48 16v32H208 160V400c0 26.5 21.5 48 48 48s48-21.5 48-48V328 312h16 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 16v16 80c0 39.8-32.2 72-72 72H208c-44.2 0-80-35.8-80-80V256 224 112c0-26.5-21.5-48-48-48zM272 448H504c22.1 0 40-17.9 40-40V344h-.3-.7-.7-.7-.7-.7-.7-.6-.6-.6-.6-.6-.6-.6-.6H534h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H527h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H519h-.6-.6-.6-.6H516h-.6-.6-.6-.6H513h-.6-.6-.6-.6H510h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H503h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H495h-.6-.6-.6-.6-.6-.6H491h-.6-.6-.6-.6-.6-.6-.6-.6H486h-.6-.6-.6-.6-.5-.5-.5-.5-.5-.5H480h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H474h-.5H473h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H465h-.5H464h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H450h-.5H449h-.5H448h-.5H447h-.5H446h-.5H445h-.5H444h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H422h-.5H421h-.5H420h-.5H419h-.5H418h-.5H417h-.5H416h-.5H415h-.5H414h-.5H413h-.5H412h-.5H411h-.5H410h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H400v40 16H368V384 344h-.5H367h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H359h-.5H358h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H352h-.5-.5-.5-.5-.5-.5-.5-.6-.6-.6H346h-.6-.6-.6-.6-.6-.6-.6-.6H341h-.6-.6-.6-.6-.6-.6H337h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H329h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H322h-.6-.6-.6-.6H319h-.6-.6-.6-.6H316h-.6-.6-.6-.6H313h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H305h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H298h-.6-.6-.6-.6-.6-.6-.6-.6-.7-.7-.7-.7-.7-.7-.7H288v56c0 18-6 34.6-16 48z'
      
    ]
  };

  

  
  

  var faQuoteRight = {
    prefix: 'fasl',
    iconName: 'quote-right',
    icon: [
      448,
      512,
      [8221,"quote-right-alt"],
      'f10e',
      
      'M448 304c0 61.9-50.1 112-112 112H304 288V384h16 32c44.2 0 80-35.8 80-80V288H288 256V256 128 96h32H416h32v32 64 64 32 16zm-32-48V192 128H288V256H416zM32 256H160V192 128H32V256zm160-64v64 32 16c0 61.9-50.1 112-112 112H48 32V384H48 80c44.2 0 80-35.8 80-80V288H32 0V256 128 96H32 160h32v32 64z'
      
    ]
  };

  
    var faQuoteRightAlt = faQuoteRight;
  

  
  

  var faPenClipSlash = {
    prefix: 'fasl',
    iconName: 'pen-clip-slash',
    icon: [
      640,
      512,
      ["pen-alt-slash"],
      'e20f',
      
      'M468.7 235.3l0 0 22.6-22.6 0 0 62.1-62.1L576 128l-22.6-22.6L470.6 22.6 448 0 425.4 22.6 363.3 84.7l-48-48L304 25.4 292.7 36.7l-64.9 64.9 25.3 20 51-51 36.7 36.7L294 154l25.3 20 44-44 82.7 82.7-34.2 34.3 25.3 20 31.6-31.6zm-148 102.8L208.2 450.5 104.8 471.2l20.7-103.4L228.2 265.1l-25.3-20L96 352 70.8 478 64 512l34-6.8L224 480 346 358l-25.3-20zm148-148l-82.7-82.7L448 45.3 530.7 128l-62.1 62.1zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  
    var faPenAltSlash = faPenClipSlash;
  

  
  

  var faPoo = {
    prefix: 'fasl',
    iconName: 'poo',
    icon: [
      512,
      512,
      [128169],
      'f2fe',
      
      'M224 0H185.4l27.3 27.3 5.8 5.8c8.7 8.7 13.5 20.4 13.5 32.7v8.9c0 20.6-16.7 37.3-37.3 37.3H176.9 176c-48.6 0-88 39.4-88 88c0 7.2 .9 14.3 2.5 21.1C56.4 233.2 32 265.7 32 304c0 16 4.3 31 11.7 43.9C17.6 363.2 0 391.5 0 424v72 16H16 496h16V496 424c0-32.5-17.6-60.8-43.7-76.1C475.7 335 480 320 480 304c0-38.3-24.4-70.8-58.5-82.9c1.7-6.8 2.5-13.8 2.5-21.1c0-35-20.4-65.1-49.9-79.3C363 52.2 303.6 0 232 0h-8zm40 65.8c0-10.7-2.2-21.2-6.3-30.8c46.1 10.8 81.3 50.2 85.8 98.4l1 10.3 9.8 3.4c22 7.6 37.8 28.4 37.8 53c0 9.1-2.2 17.7-6 25.2l-10.4 20.5 22.8 2.6c27.9 3.2 49.5 26.9 49.5 55.6c0 15.3-6.2 29.2-16.2 39.4l-19.2 19.4L439 370c23.7 6.5 41 28.3 41 54v56H32V424c0-25.7 17.4-47.4 41-54l26.3-7.3L80.2 343.4C70.2 333.2 64 319.3 64 304c0-28.7 21.7-52.4 49.5-55.6l22.8-2.6L126 225.2c-3.8-7.6-6-16.1-6-25.2c0-30.9 25.1-56 56-56h.9 17.8C233 144 264 113 264 74.7V65.8zM192 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM168 352H147.5l5 19.9L168 368c-15.5 3.9-15.5 3.9-15.5 3.9l0 0 0 0 0 .1 .1 .3 .2 .8c.2 .7 .5 1.5 .8 2.6c.7 2.2 1.8 5.1 3.3 8.6c3.1 7 8 16.3 15.6 25.7C188.1 429.2 214.4 448 256 448s67.9-18.8 83.4-37.9c7.6-9.4 12.6-18.7 15.6-25.7c1.5-3.5 2.6-6.5 3.3-8.6c.4-1.1 .6-2 .8-2.6l.2-.8 .1-.3 0-.1 0 0 0 0c0 0 0 0-15.5-3.9l15.5 3.9 5-19.9H344 168zm29.4 37.9c-1.6-2-3.1-4-4.4-5.9H318.9c-1.3 1.9-2.7 3.9-4.4 5.9C304.1 402.8 286.4 416 256 416s-48.1-13.2-58.6-26.1z'
      
    ]
  };

  

  
  

  var faFaceMelting = {
    prefix: 'fasl',
    iconName: 'face-melting',
    icon: [
      640,
      512,
      [129760],
      'e483',
      
      'M535.3 318c5.6-19.6 8.7-40.4 8.7-62C544 132.3 443.7 32 320 32S96 132.3 96 256c0 35.9 8.4 69.8 23.4 99.8c14.8 29.8 10.1 67.6-1.3 95.4c-3.8 9.3-9.4 19.5-16.7 28.9H320 504.6c-5.4-9.4-8.6-20.3-8.6-32c0-30.8 21.7-56.5 50.7-62.6c-.6-.9-1.3-1.9-1.9-2.8c-11.6-18.2-16-41.9-9.5-64.6zM320 512H64 41.4 16 0V496 480H16 41.4c41.3 0 67.7-73 49.3-110C73.6 335.7 64 297 64 256C64 114.6 178.6 0 320 0S576 114.6 576 256c0 24.6-3.5 48.3-9.9 70.8C558.4 353.4 576.4 384 604 384c0 0 0 0 0 0H624l16 0v15.9c0 0 0 .1 0 .1s0 .1 0 .1V416H624s0 0 0 0H604.1L576 416l-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16v16 16H560 512 320zM232.3 182.8a24 24 0 1 1 46.4 12.4 24 24 0 1 1 -46.4-12.4zm183.9 24.4a24 24 0 1 1 -12.4 46.4 24 24 0 1 1 12.4-46.4zM282.7 379.1c-53.2-14.3-83.4-51.2-98.3-81.7l28.8-14c12 24.7 35.9 53.6 77.8 64.8s77.1-1.9 99.8-17.2l17.9 26.5c-28.1 19-72.8 35.9-126 21.7z'
      
    ]
  };

  

  
  

  var faBookMedical = {
    prefix: 'fasl',
    iconName: 'book-medical',
    icon: [
      448,
      512,
      [],
      'f7e6',
      
      'M0 64C0 28.7 28.7 0 64 0H432h16V16 400v16H432 416v64h16 16v32H432 64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H416V32H64C46.3 32 32 46.3 32 64l0 328.6zM208 96h64 16v16 48h48 16v16 64 16H336 288v48 16H272 208 192V304 256H144 128V240 176 160h16 48V112 96h16zm16 80v16H208 160v32h48 16v16 48h32V240 224h16 48V192H272 256V176 128H224v48z'
      
    ]
  };

  

  
  

  var faArrowDownSmallBig = {
    prefix: 'fasl',
    iconName: 'arrow-down-small-big',
    icon: [
      576,
      512,
      ["sort-size-down-alt"],
      'f88d',
      
      'M160 478.6l11.3-11.3 88-88L270.6 368 248 345.4l-11.3 11.3L176 417.4V48 32H144V48 417.4L83.3 356.7 72 345.4 49.4 368l11.3 11.3 88 88L160 478.6zM352 192h96 32V160 64 32H448 352 320V64v96 32h32zm96-32H352V64h96v96zM320 480h32H512h32V448 288 256H512 352 320v32V448v32zm32-192H512V448H352V288z'
      
    ]
  };

  
    var faSortSizeDownAlt = faArrowDownSmallBig;
  

  
  

  var faGaugeSimple = {
    prefix: 'fasl',
    iconName: 'gauge-simple',
    icon: [
      512,
      512,
      ["gauge-simple-med","tachometer-average"],
      'f629',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62l0-194 0-16-32 0 0 16 0 194c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64z'
      
    ]
  };

  
    var faGaugeSimpleMed = faGaugeSimple;
  
    var faTachometerAverage = faGaugeSimple;
  

  
  

  var faTrash = {
    prefix: 'fasl',
    iconName: 'trash',
    icon: [
      448,
      512,
      [],
      'f1f8',
      
      'M151.1 0H160 288h8.9l4.7 7.5L336.9 64h47.1H416h32V96H413.7L384 512H64L34.3 96H0V64H32 64.1h47.1L146.4 7.5 151.1 0zm-2.3 64H299.1l-20-32H168.9l-20 32zM66.4 96L93.8 480H354.2L381.6 96H66.4z'
      
    ]
  };

  

  
  

  var faHandFingersCrossed = {
    prefix: 'fasl',
    iconName: 'hand-fingers-crossed',
    icon: [
      416,
      512,
      [],
      'e1a3',
      
      'M177 7.7L162.2 1.5 156 16.3 144 44.6 132 16.3 125.8 1.5 111 7.7 37.3 38.9 22.6 45.2l6.2 14.7L44.4 96.7l38.8 91.6L61.3 240H48 32v16 96c0 88.4 71.6 160 160 160h64c83 0 151.2-63.1 159.2-144h.8V352v0V240 224 208 192H400 336V176H320 240 224v16 41.7l-19.2-45.4 38.8-91.6 15.6-36.8 6.2-14.7-14.7-6.2L177 7.7zm10.5 221.7l4.5 10.6H183l4.5-10.6zm-86.9-82.1l-26.7-63L64.5 62.2l44.2-18.7 9.4 22.1 8.5 20.1-26.1 61.6zM69.3 272H224v48H144 128v32h16 80 16 16 48v16h16 63c-7.9 63.1-61.7 112-127 112H192c-70.7 0-128-57.3-128-128V280l5.3-8zM169.9 65.6l9.4-22.1 44.2 18.7-9.4 22.1L148.2 240H96.1L169.9 65.6zM336 224h48v16 96H336V224zm-32 96H256l0-64V240l0-32h48V320z'
      
    ]
  };

  

  
  

  var faCloudWord = {
    prefix: 'fasl',
    iconName: 'cloud-word',
    icon: [
      640,
      512,
      [],
      'e138',
      
      'M544 259.6l16 9.2c28.8 16.6 48 47.7 48 83.2v96H512 144 32V336c0-48.7 31.1-90.2 74.7-105.6l21.3-7.5V200.2 192c0-70.7 57.3-128 128-128c45.1 0 84.8 23.3 107.6 58.7l14.2 22 24.3-9.5c11.7-4.6 24.4-7.1 37.9-7.1c57.4 0 104 46.6 104 104v9.1 18.5zM96 200.2C40.1 220 0 273.3 0 336V448v32H32 144 512h96 32V448 352c0-47.4-25.7-88.7-64-110.9V232c0-75.1-60.9-136-136-136c-17.5 0-34.2 3.3-49.5 9.3C362 61.2 312.4 32 256 32C167.6 32 96 103.6 96 192v8.2zM512 352H496 304 288v32h16H496h16V352zm-272 0H144 128v32h16 96 16V352H240zM128 288v32h16H336h16V288H336 144 128zm272 0H384v32h16 96 16V288H496 400z'
      
    ]
  };

  

  
  

  var faPhoneArrowDownLeft = {
    prefix: 'fasl',
    iconName: 'phone-arrow-down-left',
    icon: [
      512,
      512,
      ["phone-arrow-down","phone-incoming"],
      'e223',
      
      'M280.4 355.3l21.3 12.3L319 350.2l40.7-40.7L475.8 356 453.3 480H448C218.2 480 32 293.7 32 64l0-5.3L156 36.2l46.5 116.1-40.7 40.7-17.3 17.3 12.3 21.3c29.6 51.4 72.4 94.1 123.7 123.7zM512 336L352 272l-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L240 160 176 0 0 32 0 64C0 311.4 200.6 512 448 512h32l32-176zM499.3 35.3L510.6 24 488 1.4 476.7 12.7 320 169.4V80 64H288V80 208v16h16H432h16V192H432 342.6L499.3 35.3z'
      
    ]
  };

  
    var faPhoneArrowDown = faPhoneArrowDownLeft;
  
    var faPhoneIncoming = faPhoneArrowDownLeft;
  

  
  

  var faOrnament = {
    prefix: 'fasl',
    iconName: 'ornament',
    icon: [
      384,
      512,
      [],
      'f7b8',
      
      'M208 64H176V48c0-8.8 7.2-16 16-16s16 7.2 16 16V64zm32 0V48c0-26.5-21.5-48-48-48s-48 21.5-48 48V64H128 96V96v48 9.7C38.6 186.9 0 248.9 0 320C0 426 86 512 192 512s192-86 192-192c0-71.1-38.6-133.1-96-166.3V144 96 64H256 240zm21.8 112c23 11.2 43 27.7 58.2 48H64c15.2-20.3 35.2-36.8 58.2-48H128 256h5.8zM144 96h32 32 32 16v48H128V96h16zM32 320c0-22.8 4.8-44.4 13.3-64H338.7c8.6 19.6 13.3 41.2 13.3 64s-4.7 44.4-13.3 64H45.3C36.8 364.4 32 342.8 32 320zM192 480c-52.3 0-98.8-25.1-128-64H320c-29.2 38.9-75.7 64-128 64z'
      
    ]
  };

  

  
  

  var faFileXml = {
    prefix: 'fasl',
    iconName: 'file-xml',
    icon: [
      512,
      512,
      [],
      'e654',
      
      'M352 192v96h32V152L232 0H32 0V32 480v32H32 96V480H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM416 352l-16 0-5.6 0-9.6 0-4.5 8.5-28.5 53.8-29.7-54-4.6-8.3-9.5 0-4 0-16 0v16V496v16h32V496 423l18 32.7 14.3 26 13.9-26.2L384 421.8V496v16h32V496 368 352zm-224 0H160v16c0 13.6 4 26.9 11.6 38.2L188.8 432l-17.2 25.8C164 469.1 160 482.4 160 496v16h32V496c0-7.3 2.2-14.4 6.2-20.4l9.8-14.7 9.8 14.7c4 6.1 6.2 13.2 6.2 20.4v16h32V496c0-13.6-4-26.9-11.6-38.2L227.2 432l17.2-25.8C252 394.9 256 381.6 256 368V352H224v16c0 7.3-2.2 14.4-6.2 20.4L208 403.2l-9.8-14.7c-4-6.1-6.2-13.2-6.2-20.4V352zM448 512h16 32 16V480H496 480V368 352H448v16V496v16z'
      
    ]
  };

  

  
  

  var faCarSideBolt = {
    prefix: 'fasl',
    iconName: 'car-side-bolt',
    icon: [
      640,
      512,
      [],
      'e344',
      
      'M128 32H117.2l-4 10.1L53.2 192H32 0v32V368v32H32 65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608h32V368 224 192H608 519.7L396.5 38l-4.8-6H384 128zM542 400c-7.1 27.6-32.2 48-62 48s-54.9-20.4-62-48c-1.3-5.1-2-10.5-2-16s.7-10.9 2-16c7.1-27.6 32.2-48 62-48s54.9 20.4 62 48c1.3 5.1 2 10.5 2 16s-.7 10.9-2 16zM385.3 368H254.7c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80H32V224H160V192H87.6L138.8 64H376.3L478.7 192H448v32H608V368H574.7c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80zM160 448c-29.8 0-54.9-20.4-62-48c-1.3-5.1-2-10.5-2-16s.7-10.9 2-16c7.1-27.6 32.2-48 62-48s54.9 20.4 62 48c1.3 5.1 2 10.5 2 16s-.7 10.9-2 16c-7.1 27.6-32.2 48-62 48zM331.3 139.3L342.6 128 320 105.4l-11.3 11.3-80 80L201.4 224H240h89.4l-52.7 52.7L265.4 288 288 310.6l11.3-11.3 80-80L406.6 192H368 278.6l52.7-52.7z'
      
    ]
  };

  

  
  

  var faBrightness = {
    prefix: 'fasl',
    iconName: 'brightness',
    icon: [
      512,
      512,
      [],
      'e0c9',
      
      'M240 104v16h32V104 16 0H240V16v88zm16 88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM240 512h32V496 416 400H240v16 80 16zM0 240v32H16 96h16V240H96 16 0zm408 0H392v32h16 88 16V240H496 408zM63.7 425.7l22.6 22.6L97.6 437l56.6-56.6 11.3-11.3-22.6-22.6-11.3 11.3L75 414.4 63.7 425.7zM352.2 137.2l-11.3 11.3 22.6 22.6 11.3-11.3L437 97.6l11.3-11.3L425.7 63.7 414.4 75l-62.2 62.2zM86.3 63.7L63.7 86.3 75 97.6l56.6 56.6 11.3 11.3 22.6-22.6-11.3-11.3L97.6 75 86.3 63.7zM374.8 352.2l-11.3-11.3-22.6 22.6 11.3 11.3L414.4 437l11.3 11.3 22.6-22.6L437 414.4l-62.2-62.2z'
      
    ]
  };

  

  
  

  var faBoxCircleCheck = {
    prefix: 'fasl',
    iconName: 'box-circle-check',
    icon: [
      576,
      512,
      [],
      'e0c4',
      
      'M42.1 160L84.8 64H208v96H42.1zM208 192h32H352h64 16 16V176L384 32H64L0 176V448v32H32 296.2c-8.1-9.8-15.2-20.6-21-32H32V192H208zM363.2 64l42.7 96H240V64H363.2zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm78.6-176L488 313.4l-11.3 11.3L416 385.4l-28.7-28.7L376 345.4 353.4 368l11.3 11.3 40 40L416 430.6l11.3-11.3 72-72L510.6 336z'
      
    ]
  };

  

  
  

  var faShowerDown = {
    prefix: 'fasl',
    iconName: 'shower-down',
    icon: [
      384,
      512,
      ["shower-alt"],
      'e24d',
      
      'M208 0V16 32.8c80.9 8 144 76.2 144 159.2h16 16v32H368 336 48 16 0V192H16 32C32 109 95.1 40.8 176 32.8V16 0h32zM192 64C121.3 64 64 121.3 64 192H320c0-70.7-57.3-128-128-128zm51.2 390.4c-2.1 2.8-3.2 6.1-3.2 9.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-3.5-1.1-6.8-3.2-9.6L256 437.3l-12.8 17.1zm-25.6-19.2L236 410.7 256 384l20 26.7 18.4 24.5c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8zM320 309.3l-12.8 17.1c-2.1 2.8-3.2 6.1-3.2 9.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-3.5-1.1-6.8-3.2-9.6L320 309.3zm-20-26.7L320 256l20 26.7 18.4 24.5c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8L300 282.7zM115.2 454.4c-2.1 2.8-3.2 6.1-3.2 9.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-3.5-1.1-6.8-3.2-9.6L128 437.3l-12.8 17.1zM89.6 435.2L108 410.7 128 384l20 26.7 18.4 24.5c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8zM192 309.3l-12.8 17.1c-2.1 2.8-3.2 6.1-3.2 9.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-3.5-1.1-6.8-3.2-9.6L192 309.3zm-20-26.7L192 256l20 26.7 18.4 24.5c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8L172 282.7zM51.2 326.4c-2.1 2.8-3.2 6.1-3.2 9.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-3.5-1.1-6.8-3.2-9.6L64 309.3 51.2 326.4zM25.6 307.2L44 282.7 64 256l20 26.7 18.4 24.5c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8z'
      
    ]
  };

  
    var faShowerAlt = faShowerDown;
  

  
  

  var faPersonDigging = {
    prefix: 'fasl',
    iconName: 'person-digging',
    icon: [
      576,
      512,
      ["digging"],
      'f85e',
      
      'M224 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 64A64 64 0 1 1 256 0a64 64 0 1 1 0 128zM138.9 107.6l12.2 6.1 96 48 5.8 2.9 2.1 6.1 54 154.2L388 368l39.9-53.2L448 288l19.7 27.1L576 464v16 32H544 289.7 256l10.7-32L288 416h64l16.6-22.2L24.3 206l-14-7.7 15.3-28.1 14 7.7 35.3 19.2L131 118.7l7.9-11.1zM227 187.4l-78-39-45.9 64.2L267.2 302 227 187.4zM447.6 341.9l-70 93.3L368 448H352 311.1l-10.7 32H544v-5.6L447.6 341.9zM53 279.6L71.8 290l144 80 8.2 4.6V384 496v16H192V496 393.4l-117-65L34.2 512H1.4l47-211.5L53 279.6z'
      
    ]
  };

  
    var faDigging = faPersonDigging;
  

  
  

  var faMouseField = {
    prefix: 'fasl',
    iconName: 'mouse-field',
    icon: [
      512,
      512,
      [],
      'e5a8',
      
      'M379.4 36.6c6.2-3 13.2-4.6 20.6-4.6c26.5 0 48 21.5 48 48c0 9.6-2.8 18.6-7.7 26.1c-12.5-5.5-26-8.9-40.3-9.8V96c0-22.4-7.7-43-20.6-59.4zm88.2 86.2C475.4 110.4 480 95.7 480 80c0-44.2-35.8-80-80-80c-16.9 0-32.7 5.3-45.6 14.3C339.7 5.2 322.5 0 304 0c-53.1 0-96 43.4-96 96.3c0 25.7 10.2 49.8 27.5 67.5C155.8 180.6 96 251.3 96 336v48H64c-35.3 0-64 28.7-64 64s28.7 64 64 64H464h16V480H464 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H96h16H344h16 24 16V400 352 340.5l-10.9-3.6-31.9-10.6L378.8 272H496h16V256 216c0-37.6-17.3-71.2-44.4-93.2zM360 384H344 128V336c0-79.5 64.5-144 144-144h16l5.6-31-12.1-4.5c-24.9-9.3-41.5-33.4-41.5-60.2C240 60.9 268.7 32 304 32c35.3 0 64 28.7 64 64v16 16h16 8c48.6 0 88 39.4 88 88v24H368 357.2l-4 10.1-26.4 66-33.7-11.2-15.2-5.1-10.1 30.4 15.2 5.1L368 363.5V384h-8zM336 80V64H304V80 96H288 272v32h16 32 16V112 80zm96 108a20 20 0 1 0 -40 0 20 20 0 1 0 40 0z'
      
    ]
  };

  

  
  

  var faCoffeePot = {
    prefix: 'fasl',
    iconName: 'coffee-pot',
    icon: [
      512,
      512,
      [],
      'e002',
      
      'M0 32H16 96h32 16H445.9 480L468.4 64l-41 112.8C478.4 211.3 512 269.7 512 336v8c0 80-72 136-72 136H136s-72-56-72-136v-8c0-65.4 32.7-123.2 82.7-157.9L96 64H32V208v16H0V208 48 32zM180.8 176H393.6L434.3 64H144 131l49.8 112zM416 208H160l0 0c-26.4 19.9-46.5 47.7-56.7 80H472.7c-10.1-32.3-30.2-60.1-56.7-80l0 0zm63.2 112H96.8c-.5 5.3-.8 10.6-.8 16v8c0 30.4 13.8 57.7 29.6 78.8c7.8 10.3 15.5 18.6 21.3 24.2l1.1 1H428l1.1-1c5.8-5.6 13.6-13.8 21.3-24.2C466.2 401.7 480 374.4 480 344v-8c0-5.4-.3-10.7-.8-16z'
      
    ]
  };

  

  
  

  var faPenFancy = {
    prefix: 'fasl',
    iconName: 'pen-fancy',
    icon: [
      512,
      512,
      [10002,128395],
      'f5ac',
      
      'M64 272l128-40L386.2 23.4 408 0l22.6 22.6 58.7 58.7L512 104l-23.4 21.8L280 320 240 448 32 512 0 480 64 272zm151.4-18.2l-1.4 1.5L256.6 298l1.5-1.4L465.9 103.2 408.8 46.1 215.4 253.8zM182 268.6L89.6 297.5 44.2 445.2 112 377.3c0-.4 0-.9 0-1.3c0-13.3 10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24c-.4 0-.9 0-1.3 0L66.8 467.8l147.7-45.4L243.4 330 182 268.6z'
      
    ]
  };

  

  
  

  var faChartKanban = {
    prefix: 'fasl',
    iconName: 'chart-kanban',
    icon: [
      448,
      512,
      [],
      'e64f',
      
      'M352 448l0-384h64l0 384H352zm-32 32h32 64 32V448l0-384V32H416 352 320V64l0 384v32zM96 384H32L32 64H96l0 320zM32 416H96h32l0-32 0-320 0-32H96 32 0L0 64 0 384l0 32H32zM256 256H192l0-192h64V256zm-64 32h64l32 0V256 64 32H256 192l-32 0 0 32 0 192v32h32z'
      
    ]
  };

  

  
  

  var faHatWizard = {
    prefix: 'fasl',
    iconName: 'hat-wizard',
    icon: [
      512,
      512,
      [],
      'f6e8',
      
      'M421.8 40.9L384 192l62.9 176h-34l-59-165.2-3.3-9.1 2.3-9.4L384.1 59.7 200.6 151.5 104.4 368h-35L176 128 394.3 18.8 432 0 421.8 40.9zM480 480V432H32v48H480zM32 400H480h32v32 48 32H480 32 0V480 432 400H32zM288 176v16h16 16v32H304 288v16 16H256V240 224H240 224V192h16 16V176 160h32v16zM240 304v32h32 16v32H272 240 208 176 160V336h16 32V304 288h32v16z'
      
    ]
  };

  

  
  

  var faSquareKanban = {
    prefix: 'fasl',
    iconName: 'square-kanban',
    icon: [
      448,
      512,
      [],
      'e488',
      
      'M32 448V64H416V448H32zM0 480H32 416h32V448 64 32H416 32 0V64 448v32zM144 288V128H112V288h32zm160 64h32V128H304V352zm-64-96V128H208V256h32z'
      
    ]
  };

  

  
  

  var faGarageCar = {
    prefix: 'fasl',
    iconName: 'garage-car',
    icon: [
      640,
      512,
      [],
      'e00a',
      
      'M320 6.8l5.9 2.3 304 120 10.1 4V144 496v16H608V496 154.9L320 41.2 32 154.9V496v16H0V496 144 133.1l10.1-4 304-120L320 6.8zM96 192h16H528h16v16V496v16H512V496 224H128V496v16H96V496 208 192zm148.9 64H395.1h11.6l3.6 11.1L435.3 344H448h16v16V496v16H432V496 480H208v16 16H176V496 360 344h16 12.7l24.9-76.9 3.6-11.1h11.6zM432 448V376H208v72H432zM401.6 344l-18.2-56h-127l-18.1 56H401.6zM232 416a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm160-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faTextWidth = {
    prefix: 'fasl',
    iconName: 'text-width',
    icon: [
      448,
      512,
      [],
      'f035',
      
      'M16 32H0V48v80 16H32V128 64H208l0 192H160 144v32h16H288h16V256H288 240l0-192H416v64 16h32V128 48 32H432 16zM12.7 372.7L1.4 384l11.3 11.3 80 80 22.6-22.6L62.6 400H385.4l-52.7 52.7 22.6 22.6 80-80L446.6 384l-11.3-11.3-80-80-22.6 22.6L385.4 368H62.6l52.7-52.7L92.7 292.7l-80 80z'
      
    ]
  };

  

  
  

  var faPersonBooth = {
    prefix: 'fasl',
    iconName: 'person-booth',
    icon: [
      576,
      512,
      [],
      'f756',
      
      'M80 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM80 0a56 56 0 1 1 0 112A56 56 0 1 1 80 0zM32 176l0 16 0 95.6 48 33V176H32v0h0zm0 150.4L32 496l0 16L0 512l0-16L0 304.4l0 0V296 160 144H16 96h8.7l4.7 7.3L176.7 256H240h16v32H240 168h-8.7l-4.7-7.3L112 214.5V342.6l41.1 28.2 6.9 4.8V384 496v16H128V496 392.4L80.9 360H80v-.6l-48-33zM208 0h16 34.5H280 560h16V16 432v16 48 16H544V496 448H304 288V432 368v-3.3l1.3-3L335 255 268.1 32H240V224H208V16 0zm93.5 32l65.8 219.4L369 257l-2.3 5.3L320 371.3V416H544V32H301.5zM240 320V496v16H208V496 320h32z'
      
    ]
  };

  

  
  

  var faBanBug = {
    prefix: 'fasl',
    iconName: 'ban-bug',
    icon: [
      512,
      512,
      ["debug"],
      'f7f9',
      
      'M256 480C132.3 480 32 379.7 32 256c0-56.1 20.6-107.4 54.7-146.7l316 316C363.4 459.4 312.1 480 256 480zm80-166.6V298.1l46 5.8 15.9 2 4-31.8-15.9-2-50-6.2V244.5l51.9-13 15.5-3.9-7.8-31-15.5 3.9-44.1 11V184.6l40.9-27.2 13.3-8.9-17.8-26.6-13.3 8.9-41.1 27.4L288 128H224l-36.7 36.7-78-78C148.6 52.6 199.9 32 256 32c123.7 0 224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7L336 313.4zM209.9 187.3L237.3 160h37.5L304 189.3V279l-.3 2.1-93.8-93.8zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 265.9l-50 6.2-15.9 2 4 31.8 15.9-2 46-5.8v29.3l-40.9 27.3-13.3 8.9 17.8 26.6 13.3-8.9 41.1-27.4L224 384h64l14.1-14.1-22.6-22.6-4.7 4.7H237.3L208 322.7V275.9l-32-32v22z'
      
    ]
  };

  
    var faDebug = faBanBug;
  

  
  

  var faBridgeWater = {
    prefix: 'fasl',
    iconName: 'bridge-water',
    icon: [
      576,
      512,
      [],
      'e4ce',
      
      'M576 208V176 96 64H544 32 0V96v80 32c53 0 96 43 96 96v32l0 0 18.6 13.4 1.1 .8 0 0 0 0c4.4 3.2 8.5 6.1 12.3 8.7V304c0-59.6-40.8-109.8-96-124V96H544v84c-55.2 14.2-96 64.3-96 124v54.9c3.8-2.6 7.8-5.5 12.3-8.7l0 0L480 336V304c0-53 43-96 96-96zM352 272V376.3c10.7 4 21.8 6.7 32 6.7V272c0-53-43-96-96-96s-96 43-96 96V383c10.2 0 21.3-2.7 32-6.7V272c0-35.3 28.7-64 64-64s64 28.7 64 64zM192 448c-20.9 0-41.7-9.9-58.2-21.2c-14.6-10-26-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C41.7 438.1 20.9 448 0 448v32c30.3 0 57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 465.9 161.7 480 192 480s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 465.9 353.7 480 384 480s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C518.5 465.9 545.7 480 576 480V448c-20.9 0-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C425.6 438.1 404.9 448 384 448s-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C233.6 438.1 212.9 448 192 448z'
      
    ]
  };

  

  
  

  var faVentDamper = {
    prefix: 'fasl',
    iconName: 'vent-damper',
    icon: [
      640,
      512,
      [],
      'e465',
      
      'M544 96v48V368v48H96V368 144 96H544zM64 96v32H16c-8.8 0-16 7.2-16 16V368c0 8.8 7.2 16 16 16H64v32 32H96 544h32V416 384h48c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H576V96 64H544 96 64V96zM32 352V160H64V352H32zm576 0H576V160h32V352zM176 160H160v32h16H464h16V160H464 176zm0 80H160v32h16H464h16V240H464 176zm0 80H160v32h16H464h16V320H464 176z'
      
    ]
  };

  

  
  

  var faMosquitoNet = {
    prefix: 'fasl',
    iconName: 'mosquito-net',
    icon: [
      640,
      512,
      [],
      'e52c',
      
      'M161.7 440.8L192 380.2l0-44.2v-6.6l4.7-4.7L244 277.4V252.7L139.2 344C87.8 395.3 0 358.9 0 286.3c0-41.1 30.6-75.8 71.4-80.9l159.9-23.9-49.6-41.3-8.4-7 3.5-10.4 13.9-41.7-29-58.1L190.3 8.8l32 64 3 5.9-2.1 6.3-12.5 37.6L244 150.5V137.9v-44l35.8 0V63.7 55.5l16.3 0v8.2V93.9H332v44 12.6l33.4-27.8L352.8 85.1l-2.1-6.3 3-5.9 32-64 28.6 14.3-29 58.1 13.9 41.7 3.5 10.4-8.4 7-49.6 41.3 159.9 23.9c16.2 2 30.7 8.7 42.4 18.5H480 464 412l-77.5-11.6L384 255.5v.5H352v14.1l-20-17.4v24.7l20 20v45.3l-20-20v38 44H244l0-44v-38l-20 20 0 41.4v3.8l-1.7 3.4-32 64-28.6-14.3zM361.4 352h2.8c-.4 .5-.9 1-1.3 1.5l-1.5-1.5zM118.2 319.8L241.5 212.4 76.1 237.1l-.8 .1C50.6 240.3 32 261.4 32 286.3c0 44.1 53.3 66.2 84.6 35c.5-.5 1.1-1 1.6-1.5zM528 272v16h48V272 256h32v16 16h16 16v32H624 608v48h16 16v32H624 608v48h16 16v32H624 608v16 16H576V496 480H528v16 16H496V496 480H448v16 16H416V496 480H400 384V448h16 16V400H400 384V368h16 16V320H400 384V288h16 16V272 256h32v16 16h48V272 256h32v16zm48 48H528v48h48V320zm0 80H528v48h48V400zM448 368h48V320H448v48zm0 80h48V400H448v48zM272 360.6v16h32v-16l0-222.7v-16H272v16l0 222.7z'
      
    ]
  };

  

  
  

  var faRocketLaunch = {
    prefix: 'fasl',
    iconName: 'rocket-launch',
    icon: [
      512,
      512,
      [128640],
      'e027',
      
      'M219.3 292.7c-10-10-21.4-18.1-33.8-24.1C217.8 137.7 276.6 78.5 332.6 52.2c50.3-23.6 103.3-23 143.1-15.9c7 39.8 7.7 92.8-15.9 143.1c-26.3 55.9-85.5 114.8-216.4 147.1c-6-12.4-14.1-23.9-24.1-33.8zM256 381.3c0-8.2-.8-16.3-2.4-24.3c37.8-9.5 70.4-21.3 98.4-34.7v91.9l-96 48 0-80.9zM384 424V305C527.5 217.9 520.4 80.2 502.7 9.3C431.8-8.4 294.1-15.5 207.1 128H88 78.1l-4.4 8.8-64 128L-1.9 288H24 130.7c24.7 0 48.5 9.8 65.9 27.3s27.3 41.2 27.3 65.9L224 488l0 25.9 23.2-11.6 128-64 8.8-4.4V424zM155 258.4c-7.9-1.6-16.1-2.4-24.3-2.4H49.9l48-96h91.9c-13.5 28-25.2 60.5-34.7 98.4zm-11.2 189c-16.6 16.6-48.4 26.1-82.7 30.2c-10.4 1.2-20.3 1.9-28.9 2.2c.3-8.6 1-18.5 2.2-28.9c4.1-34.3 13.6-66.2 30.2-82.7c21.9-21.9 57.4-21.9 79.3 0s21.9 57.4 0 79.3zM166.5 470c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.5 0C-7.5 395 .5 511.5 .5 511.5s116.5 8 166-41.5zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM368 88a56 56 0 1 0 0 112 56 56 0 1 0 0-112z'
      
    ]
  };

  

  
  

  var faStarfighterTwinIonEngine = {
    prefix: 'fasl',
    iconName: 'starfighter-twin-ion-engine',
    icon: [
      576,
      512,
      ["starfighter-alt"],
      'e038',
      
      'M32 32V48 197.1l116.4-19.4C175.8 128.9 228.1 96 288 96s112.2 32.9 139.6 81.7L544 197.1V48 32h32V48 202.4 216v80 13.6V464v16H544V464 314.9L427.6 334.3C400.2 383.1 347.9 416 288 416s-112.2-32.9-139.6-81.7L32 314.9V464v16H0V464 309.6 296 216 202.4 48 32H32zM448 256c0 15.1-2.1 29.6-6 43.4l102-17V229.6l-102-17c3.9 13.8 6 28.4 6 43.4zM32 282.4l102 17c-3.9-13.8-6-28.4-6-43.4s2.1-29.6 6-43.4l-102 17v52.9zM288 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm62-144h34 16v32H384 350c-1.5 5.9-3.8 11.4-6.8 16.5l24.1 24.1 11.3 11.3-22.6 22.6-11.3-11.3-24.1-24.1c-5.1 3-10.6 5.3-16.5 6.8v34 16H272V352 318c-5.9-1.5-11.4-3.8-16.5-6.8l-24.1 24.1-11.3 11.3-22.6-22.6 11.3-11.3 24.1-24.1c-3-5.1-5.3-10.6-6.8-16.5H192 176V240h16 34c1.5-5.9 3.8-11.4 6.8-16.5l-24.1-24.1-11.3-11.3 22.6-22.6 11.3 11.3 24.1 24.1c5.1-3 10.6-5.3 16.5-6.8V160 144h32v16 34c5.9 1.5 11.4 3.8 16.5 6.8l24.1-24.1 11.3-11.3 22.6 22.6-11.3 11.3-24.1 24.1c3 5.1 5.3 10.6 6.8 16.5zm-62 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faStarfighterAlt = faStarfighterTwinIonEngine;
  

  
  

  var faDiceSix = {
    prefix: 'fasl',
    iconName: 'dice-six',
    icon: [
      448,
      512,
      [9861],
      'f526',
      
      'M416 64V448H32V64H416zM32 32H0V64 448v32H32 416h32V448 64 32H416 32zM152 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM296 160a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faStarfighterTwinIonEngineAdvanced = {
    prefix: 'fasl',
    iconName: 'starfighter-twin-ion-engine-advanced',
    icon: [
      640,
      512,
      ["starfighter-alt-advanced"],
      'e28e',
      
      'M4.7 132.7l128-128 22.6 22.6L32 150.6v47l148.6-20.3C208.1 128.8 260.2 96 320 96s111.9 32.8 139.4 81.4L608 197.7v-47L484.7 27.3 507.3 4.7l128 128 4.7 4.7V144v58 14 80 14 58 6.6l-4.7 4.7-128 128-22.6-22.6L608 361.4v-47L459.4 334.6C431.9 383.2 379.8 416 320 416s-111.9-32.8-139.4-81.4L32 314.3v47L155.3 484.7l-22.6 22.6-128-128L0 374.6V368 310 296 216 202 144v-6.6l4.7-4.7zm469.1 79c4.1 14.1 6.2 29 6.2 44.3s-2.2 30.3-6.2 44.3L608 282V230L473.8 211.7zM32 282l134.2 18.3c-4.1-14.1-6.2-29-6.2-44.3s2.2-30.3 6.2-44.3L32 230V282zm416-26a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM304 318c-5.9-1.5-11.4-3.8-16.5-6.8l-24.1 24.1-11.3 11.3-22.6-22.6 11.3-11.3 24.1-24.1c-3-5.1-5.3-10.6-6.8-16.5H224 208V240h16 34c1.5-5.9 3.8-11.4 6.8-16.5l-24.1-24.1-11.3-11.3 22.6-22.6 11.3 11.3 24.1 24.1c5.1-3 10.6-5.3 16.5-6.8V160 144h32v16 34c5.9 1.5 11.4 3.8 16.5 6.8l24.1-24.1 11.3-11.3 22.6 22.6-11.3 11.3-24.1 24.1c3 5.1 5.3 10.6 6.8 16.5h34 16v32H416 382c-1.5 5.9-3.8 11.4-6.8 16.5l24.1 24.1 11.3 11.3-22.6 22.6-11.3-11.3-24.1-24.1c-5.1 3-10.6 5.3-16.5 6.8v34 16H304V352 318zm16-30a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faStarfighterAltAdvanced = faStarfighterTwinIonEngineAdvanced;
  

  
  

  var faShieldVirus = {
    prefix: 'fasl',
    iconName: 'shield-virus',
    icon: [
      512,
      512,
      [],
      'e06c',
      
      'M48.5 114.9L256 34.3l207.5 80.5c2.7 45.6-4.5 116.8-34.7 186.3S345.4 438.4 256 477.1C166.6 438.4 113.4 370.7 83.2 301.2S45.8 160.5 48.5 114.9zm447-1.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM369.1 149.5l-22.6-22.6-11.3 11.3C311.9 161.5 272 145 272 112V96H240v16c0 33-39.9 49.5-63.2 26.2l-11.3-11.3-22.6 22.6 11.3 11.3C177.5 184.1 161 224 128 224H112v32h16c33 0 49.5 39.9 26.2 63.2l-11.3 11.3 22.6 22.6 11.3-11.3C200.1 318.5 240 335 240 368v16h32V368c0-33 39.9-49.5 63.2-26.2l11.3 11.3 22.6-22.6-11.3-11.3C334.5 295.9 351 256 384 256h16V224H384c-33 0-49.5-39.9-26.2-63.2l11.3-11.3zm-54.1 31.4c-1.8 22.3 7.4 44.6 24.5 59.1c-17 14.5-26.3 36.8-24.5 59.1c-22.3-1.8-44.6 7.4-59.1 24.5c-14.5-17-36.8-26.3-59.1-24.5c1.8-22.3-7.4-44.6-24.5-59.1c17-14.5 26.3-36.8 24.5-59.1c22.3 1.8 44.6-7.4 59.1-24.5c7.4 8.7 16.8 15.3 27.2 19.5c10 4.1 21 5.8 31.9 4.9zM240 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm32 40a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faConveyorBeltBoxes = {
    prefix: 'fasl',
    iconName: 'conveyor-belt-boxes',
    icon: [
      640,
      512,
      ["conveyor-belt-alt"],
      'f46f',
      
      'M320 32V256H96V32H320zM96 0H64V32 256v32H96 320h32V256 32 0H320 96zM544 96V256H416V96H544zM416 64H384V96 256v32h32H544h32V256 96 64H544 416zM608 416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64s28.7-64 64-64H544c35.3 0 64 28.7 64 64zM96 320c-53 0-96 43-96 96s43 96 96 96H544c53 0 96-43 96-96s-43-96-96-96H96zm56 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faConveyorBeltAlt = faConveyorBeltBoxes;
  

  
  

  var faLaptopMobile = {
    prefix: 'fasl',
    iconName: 'laptop-mobile',
    icon: [
      640,
      512,
      ["phone-laptop"],
      'f87a',
      
      'M96 32H480V96h32V32 0H480 96 64V32 288H32 0v32 16l48 48H352V352H61.3L32 322.7V320H64 96 352V288H96V32zm288 96v32V480v32h32H608h32V480 160 128H608 416 384zm32 32H608V480H416V160z'
      
    ]
  };

  
    var faPhoneLaptop = faLaptopMobile;
  

  
  

  var faDoorClosed = {
    prefix: 'fasl',
    iconName: 'door-closed',
    icon: [
      576,
      512,
      [128682],
      'f52a',
      
      'M448 32V480H128V32H448zm32 448V32 0H448 128 96V32 480H16 0v32H16 96h32H448h32 80 16V480H560 480zM408 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faDialLow = {
    prefix: 'fasl',
    iconName: 'dial-low',
    icon: [
      576,
      512,
      [],
      'e15d',
      
      'M312 8H264V56h48V8zM120 72H72v48h48V72zm336 0v48h48V72H456zM568 264H520v48h48V264zM8 264v48H56V264H8zM120 456H72v48h48V456zm336 0v48h48V456H456zM288 416c-65.3 0-119.1-48.9-127-112H288h16V272H288 161c7.9-63.1 61.7-112 127-112c70.7 0 128 57.3 128 128s-57.3 128-128 128zM128 288a160 160 0 1 0 320 0 160 160 0 1 0 -320 0z'
      
    ]
  };

  

  
  

  var faOctagonExclamation = {
    prefix: 'fasl',
    iconName: 'octagon-exclamation',
    icon: [
      512,
      512,
      [],
      'e204',
      
      'M32 338.7V173.3L173.3 32H338.7L480 173.3V338.7L338.7 480H173.3L32 338.7zM160 0L0 160V352L160 512H352L512 352V160L352 0H160zM272 128H240v16V272v16h32V272 144 128zM232 320v48h48V320H232z'
      
    ]
  };

  

  
  

  var faArrowUp19 = {
    prefix: 'fasl',
    iconName: 'arrow-up-1-9',
    icon: [
      576,
      512,
      ["sort-numeric-up"],
      'f163',
      
      'M368 32h16 48 16V48 192h32 16v32H480 432 384 368V192h16 32V64H384 368V32zM160 33.4l11.3 11.3 88 88L270.6 144 248 166.6l-11.3-11.3L176 94.6V464v16H144V464 94.6L83.3 155.3 72 166.6 49.4 144l11.3-11.3 88-88L160 33.4zM428 288a52 52 0 1 0 0 104 52 52 0 1 0 0-104zm-84 52c0-46.4 37.6-84 84-84s84 37.6 84 84c0 1.3 0 2.7-.1 4h.1c0 21.1-7.1 41.6-20.2 58.1L430.1 480H389.7c.5-.9 1-1.8 1.7-2.7l42.4-53.5c-1.9 .1-3.9 .2-5.8 .2c-46.4 0-84-37.6-84-84z'
      
    ]
  };

  
    var faSortNumericUp = faArrowUp19;
  

  
  

  var faPipeCircleCheck = {
    prefix: 'fasl',
    iconName: 'pipe-circle-check',
    icon: [
      640,
      512,
      [],
      'e436',
      
      'M32 96v16 16H256 448V112 96h32v16 32 48.7c-11 1-21.7 3-32 5.9V160H256 32V352H320.7c-.5 5.3-.7 10.6-.7 16s.2 10.7 .7 16H32v16 16H0V400 368 144 112 96H32zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm78.6 112l-11.3 11.3-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336z'
      
    ]
  };

  

  
  

  var faUserGear = {
    prefix: 'fasl',
    iconName: 'user-gear',
    icon: [
      640,
      512,
      ["user-cog"],
      'f4fe',
      
      'M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM87.6 336L43.3 480H352v32H33.5 0l9.8-32L64 304H305.4l-15.5 26.9 8.9 5.1H87.6zm440.5-97.6v3.3c7.6 3.3 14.8 7.4 21.5 12.2l4.3-2.5 27.5-16.3L597.2 263l32.1 57-30.1 17.8c.5 4.6 .8 9.2 .8 13.9s-.3 9.4-.8 13.9l30.1 17.8-32.1 57-15.7 27.9L553.9 452l-4.3-2.5c-6.7 4.8-13.9 8.9-21.5 12.2V465v32h-32-32-32V465v-3.2c-7.7-3.4-15-7.5-21.8-12.3l-4.3 2.5-27.6 16.3-15.7-27.9-32.1-57 30.1-17.8c-.5-4.6-.8-9.2-.8-13.9s.3-9.4 .8-13.9L330.7 320l32.1-57 15.7-27.9 27.5 16.3 4.3 2.5c6.8-4.8 14.1-9 21.8-12.3v-3.2-32h32 32 32v32zm37.8 43.1L548 292.1 531 280c-4.9-3.5-10.2-6.5-15.7-8.9l-19.1-8.4V241.8v-3.3h-32v3.2 21L444.9 271c-5.6 2.5-11 5.5-16 9l-17 12.1-17.9-10.6-3.7-2.2L374 308.4l3.1 1.8L395 320.8l-2.4 20.6c-.4 3.4-.6 6.8-.6 10.3s.2 6.9 .6 10.3l2.4 20.6-17.9 10.6L374 395l16.4 29.1 3.7-2.2L412 411.3l17 12.1c5 3.5 10.3 6.6 16 9l19.2 8.4v21V465h32v-3.3V440.7l19.1-8.4c5.6-2.4 10.8-5.4 15.7-8.9l17-12.1 17.9 10.6 3.7 2.2L586 395l-3.1-1.8L565 382.6l2.4-20.6c.4-3.4 .6-6.8 .6-10.3s-.2-6.9-.6-10.3L565 320.8l17.9-10.6 3.1-1.8-16.4-29.1-3.7 2.2zm-85.8 14.2a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  
    var faUserCog = faUserGear;
  

  
  

  var faPuzzle = {
    prefix: 'fasl',
    iconName: 'puzzle',
    icon: [
      512,
      512,
      [],
      'e443',
      
      'M304 0H288V16 72 88h16 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H304 288v16 56 16h16 48c0 26.5 21.5 48 48 48s48-21.5 48-48h48 16V192 16 0H496 304zm16 56V32H480V176H432 416v16 16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192 176H368 320V152h16c26.5 0 48-21.5 48-48s-21.5-48-48-48H320zM16 64H0V80 288 496v16H16 224 432h16V496 288 272H432 352 336v16 32c0 8.8-7.2 16-16 16s-16-7.2-16-16V288 272H288 240V80 64H224 16zM208 96V272H176V256c0-26.5-21.5-48-48-48s-48 21.5-48 48v16H32V96H208zM96 304h16V288 256c0-8.8 7.2-16 16-16s16 7.2 16 16v32 16h16 48v32H192c-26.5 0-48 21.5-48 48s21.5 48 48 48h16v48H32V304H96zM240 416V400H224 192c-8.8 0-16-7.2-16-16s7.2-16 16-16h32 16V352 304h32v16c0 26.5 21.5 48 48 48s48-21.5 48-48V304h48V480H240V416z'
      
    ]
  };

  

  
  

  var faSquareHeart = {
    prefix: 'fasl',
    iconName: 'square-heart',
    icon: [
      448,
      512,
      [128159,"heart-square"],
      'f4c8',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM199 195.9l-9.3-11.6c-8.3-10.4-20.8-16.4-34.1-16.4c-24.1 0-43.6 19.5-43.6 43.6v3.6c0 12.5 5 24.5 13.8 33.4l24.8 24.8L224 346.7l73.4-73.4 24.8-24.8c8.9-8.9 13.8-20.9 13.8-33.4v-3.6c0-24.1-19.5-43.6-43.6-43.6c-13.3 0-25.8 6-34.1 16.4L249 195.9l-25 31.2-25-31.2zm121 100l-73.4 73.4L224 391.9l-22.6-22.6L128 295.9l-24.8-24.8c-14.9-14.9-23.2-35-23.2-56v-3.6c0-41.8 33.9-75.6 75.6-75.6c17 0 33.4 5.7 46.6 16c4.6 3.6 8.8 7.7 12.5 12.4l9.3 11.6 9.3-11.6c3.7-4.6 7.9-8.8 12.5-12.4c13.2-10.3 29.5-16 46.6-16c41.8 0 75.6 33.9 75.6 75.6v3.6c0 21-8.3 41.1-23.2 56L320 295.9z'
      
    ]
  };

  
    var faHeartSquare = faSquareHeart;
  

  
  

  var faSquare5 = {
    prefix: 'fasl',
    iconName: 'square-5',
    icon: [
      448,
      512,
      [],
      'e25a',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm176 96H288h16v32H288 188.5L172 225.9l80.4 8.1c38.4 3.9 67.6 36.2 67.6 74.8c0 41.5-33.7 75.2-75.2 75.2h-44c-27.4 0-53-13.7-68.3-36.4l-1.8-2.7-8.9-13.3 26.6-17.8 8.9 13.3 1.8 2.7c9.3 13.9 25 22.3 41.8 22.3h44c23.8 0 43.2-19.3 43.2-43.2c0-22.2-16.8-40.7-38.8-42.9l-98.8-10L132 254.1l4.5-17.9 24-96 3-12.1H176z'
      
    ]
  };

  

  
  

  var faHouseBlank = {
    prefix: 'fasl',
    iconName: 'house-blank',
    icon: [
      576,
      512,
      ["home-blank"],
      'e487',
      
      'M288 2.7L298.6 12l272 240-21.2 24L512 243V496v16H496 80 64V496 243L26.6 276 5.4 252l272-240L288 2.7zM96 214.7V480H480V214.7L288 45.3 96 214.7z'
      
    ]
  };

  
    var faHomeBlank = faHouseBlank;
  

  
  

  var faLightbulbSlash = {
    prefix: 'fasl',
    iconName: 'lightbulb-slash',
    icon: [
      640,
      512,
      [],
      'f673',
      
      'M438.3 258.1c-3.3 4.7-6.9 9.7-10.7 15l25.2 19.9c4-5.5 8-11 11.8-16.6c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0C260.6 0 208 29.4 176.2 74.5l25.2 19.9C227.3 56.7 270.8 32 320 32c79.5 0 144 64.5 144 144c0 30.6-9.5 58.8-25.7 82.1zM226.5 114.3l25.2 19.9C265.8 111.3 291.1 96 320 96V64c-39.1 0-73.4 20-93.5 50.3zM201.2 257.3l-52.6-41.6c5.1 22.1 14.3 42.5 26.9 60.5c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1l0 0c-4.9-6.7-9.5-13-13.6-19l-.5-.7zM272 448h96v32H272V448zm-32 0v32 32h32 96 32V480 448 416H368 272 240v32zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faBooksMedical = {
    prefix: 'fasl',
    iconName: 'books-medical',
    icon: [
      576,
      512,
      [],
      'f7e8',
      
      'M192 480H96V416h96v64zm0-96H96 64v16 16 64 32H96h96 32 96 32V480 416 400 384 230.6l41.6 155.2 4.1 15.5 4.1 15.5 17.2 64.4 8.3 30.9 30.9-8.3 85.8-23 30.9-8.3-8.3-30.9-17.2-64.4-4.1-15.5-4.1-15.5-59-220.1-4.1-15.5L474 95.3 456.7 30.9 448.4 0 417.5 8.3 352 25.8V0H320 224 192 96 64V32 96v16 16H96h96 32 16 80V384H240 224 192zm0-352V96H96V32h96zM352 59l73.8-19.8 17.2 64.4-85.8 23L352 107V96 59zM320 480H224V416h96v64zm0-384H224V32h96V96zM450 472.8l-17.2-64.4 85.8-23 17.2 64.4-85.8 23zm-25.5-95.3l-59-220.1 85.8-23 59 220.1-85.8 23zM64 160H48v16 32H16L0 208v16 64 16H16 48v32 16H64h64 16V336 304h32 16V288 224 208H176 144V176 160H128 64zm16 80V224 192h32v32 16h16 32v32H128 112v16 32H80V288 272H64 32V240H64 80z'
      
    ]
  };

  

  
  

  var faKeyboardBrightness = {
    prefix: 'fasl',
    iconName: 'keyboard-brightness',
    icon: [
      640,
      512,
      [],
      'e1c0',
      
      'M115.3 172.7L104 161.4 81.4 184l11.3 11.3 88 88L192 294.6 214.6 272l-11.3-11.3-88-88zM304 224v16h32V224 96 80H304V96 224zm132.7 36.7L425.4 272 448 294.6l11.3-11.3 88-88L558.6 184 536 161.4l-11.3 11.3-88 88zM0 384v32H16h96 16V384H112 16 0zm208 0H192v32h16H432h16V384H432 208zm320 0H512v32h16 96 16V384H624 528z'
      
    ]
  };

  

  
  

  var faHeadSideVirus = {
    prefix: 'fasl',
    iconName: 'head-side-virus',
    icon: [
      512,
      512,
      [],
      'e064',
      
      'M32 224C32 118 118 32 224 32h24c88.4 0 160 71.6 160 160v7.2l5.4 4.8L480 263.2V304H432 416v16 96H304 288v16 64 16h32V496 448H432h16V432 336h48 16V320 256v-7.2l-5.4-4.8-66.8-59.3C436 82 351.6 0 248 0H224C100.3 0 0 100.3 0 224c0 61 24.4 116.4 64 156.8V496v16H96V496 374.1v-6.8l-4.9-4.7C54.6 327.6 32 278.4 32 224zM337.1 117.5L314.5 94.9l-11.3 11.3C279.9 129.5 240 113 240 80V64H208V80c0 33-39.9 49.5-63.2 26.2L133.5 94.9l-22.6 22.6 11.3 11.3C145.5 152.1 129 192 96 192H80v32H96c33 0 49.5 39.9 26.2 63.2l-11.3 11.3 22.6 22.6 11.3-11.3C168.1 286.5 208 303 208 336v16h32V336c0-33 39.9-49.5 63.2-26.2l11.3 11.3 22.6-22.6-11.3-11.3C302.5 263.9 319 224 352 224h16V192H352c-33 0-49.5-39.9-26.2-63.2l11.3-11.3zm-54.1 31.4c-1.8 22.3 7.4 44.6 24.5 59.1c-17 14.5-26.3 36.8-24.5 59.1c-22.3-1.8-44.6 7.4-59.1 24.5c-14.5-17-36.8-26.3-59.1-24.5c1.8-22.3-7.4-44.6-24.5-59.1c17-14.5 26.3-36.8 24.5-59.1c22.3 1.8 44.6-7.4 59.1-24.5c7.4 8.7 16.8 15.3 27.2 19.5c10 4.1 21 5.8 31.9 4.9zM208 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm32 40a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faRectangleCode = {
    prefix: 'fasl',
    iconName: 'rectangle-code',
    icon: [
      512,
      512,
      [],
      'e322',
      
      'M480 64V448H32V64H480zM32 32H0V64 448v32H32 480h32V448 64 32H480 32zM281.4 182.7l10.6 12L346.6 256 292 317.4l-10.6 12 23.9 21.3 10.6-12 64-72 9.4-10.6L380 245.4l-64-72-10.6-12-23.9 21.3zm-61.5 12l10.6-12-23.9-21.3-10.6 12-64 72L122.6 256l9.4 10.6 64 72 10.6 12 23.9-21.3-10.6-12L165.4 256 220 194.6z'
      
    ]
  };

  

  
  

  var faTrafficLightSlow = {
    prefix: 'fasl',
    iconName: 'traffic-light-slow',
    icon: [
      320,
      512,
      [],
      'f639',
      
      'M32 32V352c0 70.7 57.3 128 128 128s128-57.3 128-128V32H32zM0 0H32 288h32V32 352c0 88.4-71.6 160-160 160S0 440.4 0 352V32 0zM136 392a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm0-136a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM136 120a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0z'
      
    ]
  };

  

  
  

  var faKiwiFruit = {
    prefix: 'fasl',
    iconName: 'kiwi-fruit',
    icon: [
      448,
      512,
      [],
      'e30c',
      
      'M416 176c0-25.2-15.9-52.4-50.9-74.9C330.4 78.8 280.6 64 224 64s-106.4 14.8-141.1 37.1C47.9 123.6 32 150.8 32 176s15.9 52.4 50.9 74.9C117.6 273.2 167.4 288 224 288s106.4-14.8 141.1-37.1c35-22.5 50.9-49.7 50.9-74.9zm32 0v80c0 123.7-100.3 224-224 224S0 379.7 0 256V176C0 96.5 100.3 32 224 32s224 64.5 224 144zm-32 74.2C376.8 292 305.5 320 224 320s-152.8-28-192-69.8V256c0 106 86 192 192 192s192-86 192-192v-5.8zM280 176c0 13.3-25.1 24-56 24s-56-10.7-56-24s25.1-24 56-24s56 10.7 56 24zM240 88v24 16H208V112 88 72h32V88zm-84.7 12.7l8 8L174.6 120 152 142.6l-11.3-11.3-8-8L121.4 112 144 89.4l11.3 11.3zm160 22.6l-8 8L296 142.6 273.4 120l11.3-11.3 8-8L304 89.4 326.6 112l-11.3 11.3zM96 160h32 16v32H128 96 80V160H96zm224 0h32 16v32H352 320 304V160h16zM163.3 243.3l-8 8L144 262.6 121.4 240l11.3-11.3 8-8L152 209.4 174.6 232l-11.3 11.3zm144-22.6l8 8L326.6 240 304 262.6l-11.3-11.3-8-8L273.4 232 296 209.4l11.3 11.3zM240 264v16H208V264 240 224h32v16 24z'
      
    ]
  };

  

  
  

  var faPawClaws = {
    prefix: 'fasl',
    iconName: 'paw-claws',
    icon: [
      512,
      512,
      [],
      'f702',
      
      'M400 128c0-69.9-37.9-112.8-64.8-126.3L320.8 30.3c8.5 4.2 21.6 15.4 31.8 34c-30-3.5-62.2 21.7-75.2 60.5c-14.3 42.9 .3 86.2 32.6 96.8s70.1-15.6 84.4-58.5c4-11.9 5.7-23.9 5.5-35.2h0zm-203.9 7c5.2 15.5 4.7 29.9 1.2 40.2c-3.5 10.3-9 14.6-13.4 16.1c-4.5 1.5-11.7 1.2-20.8-5.1s-18.2-17.6-23.3-33.1s-4.7-29.9-1.2-40.2c3.5-10.3 9-14.6 13.4-16.1c4.5-1.5 11.7-1.2 20.8 5.1s18.2 17.6 23.3 33.1zm30.4-10.1c-13-38.8-45.2-64-75.2-60.5c10.2-18.6 23.3-29.8 31.8-34L168.8 1.7C141.9 15.2 104 58.1 104 128h0c-.2 11.3 1.5 23.2 5.5 35.2c14.3 42.9 52.1 69.1 84.4 58.5s46.9-53.9 32.6-96.8zM79.8 275.7c-.9 7.6-3.9 10.4-5.5 11.3c-1.6 .9-5.7 2.2-13-.9s-15.7-9.9-22-20.7s-8-21.4-7-29c.9-7.6 3.9-10.4 5.5-11.3c1.6-.9 5.7-2.2 13 .9s15.7 9.9 22 20.7s8 21.4 7 29zm10.4 39c24.5-14 29.1-51.7 10.2-84.1C85.9 205.6 61.7 191.1 40.2 192c10.4-28.1 28.3-44.4 39-49.7L64.8 113.7C37.9 127.2 0 170.1 0 240H0c-.1 13.3 3.7 27.8 11.6 41.4c18.9 32.4 54 47.3 78.5 33.3zm342.1-39c-.9-7.7 .8-18.2 7-29s14.7-17.6 22-20.7s11.4-1.8 13-.9c1.6 .9 4.6 3.7 5.5 11.3c.9 7.7-.8 18.2-7 29s-14.7 17.6-22 20.7s-11.4 1.8-13 .9c-1.6-.9-4.6-3.7-5.5-11.3zm-10.4 39c24.5 14 59.7-.9 78.5-33.3c7.9-13.6 11.7-28.1 11.6-41.4h0c0-69.9-37.9-112.8-64.8-126.3l-14.3 28.6c10.7 5.3 28.6 21.6 39 49.7c-21.5-1-45.7 13.6-60.2 38.5c-18.9 32.4-14.3 70.1 10.2 84.1zM306.6 175.2c-3.5-10.3-4-24.7 1.2-40.2s14.2-26.8 23.3-33.1s16.3-6.6 20.8-5.1c4.4 1.5 9.9 5.8 13.4 16.1c3.5 10.3 4 24.7-1.2 40.2s-14.2 26.8-23.3 33.1s-16.3 6.6-20.8 5.1c-4.4-1.5-9.9-5.8-13.4-16.1zM263.8 433L256 431l-7.8 1.9L98.8 470.3c8-58 32.3-100.8 60.4-130.2C194.8 302.7 234.9 288 256 288s61.2 14.7 96.8 52.1c28.1 29.5 52.4 72.3 60.4 130.2L263.8 433zM64 512l32.1-8L256 464l159.9 40 32.1 8c0-11.5-.6-22.7-1.6-33.4C431.5 325.9 315.8 256 256 256s-175.5 69.9-190.4 222.6c-1 10.7-1.6 21.8-1.6 33.4z'
      
    ]
  };

  

  
  

  var faBorderInner = {
    prefix: 'fasl',
    iconName: 'border-inner',
    icon: [
      448,
      512,
      [],
      'f84e',
      
      'M208 240l0-192 0-16 32 0 0 16 0 192 192 0 16 0 0 32-16 0-192 0 0 192 0 16-32 0 0-16 0-192L16 272 0 272l0-32 16 0 192 0zM8 472l0-48 48 0 0 48L8 472zm384 0l0-48 48 0 0 48-48 0zM8 376l0-48 48 0 0 48L8 376zm384 0l0-48 48 0 0 48-48 0zm48-192l-48 0 0-48 48 0 0 48zM8 184l0-48 48 0 0 48L8 184zM440 88l-48 0 0-48 48 0 0 48zM56 88L8 88 8 40l48 0 0 48zm288 0l-48 0 0-48 48 0 0 48zM296 472l0-48 48 0 0 48-48 0zM152 88l-48 0 0-48 48 0 0 48zM104 472l0-48 48 0 0 48-48 0z'
      
    ]
  };

  

  
  

  var faToothbrush = {
    prefix: 'fasl',
    iconName: 'toothbrush',
    icon: [
      576,
      512,
      [129701],
      'f635',
      
      'M32 160c0-17.7 14.3-32 32-32H288c14.2 0 27.8-3.2 39.6-10.9c11.8-7.7 19.3-18.3 23.9-28.8c2.9-6.7 4.8-13.8 6.1-20.8c12.6 3 24.2 8 33.6 14.6C406.8 93 416 107.8 416 128c0 35.3-28.7 64-64 64H64 32V160zM360 35.3c-10.6-2.2-21.4-3.3-32-3.3c0 30.8-2.3 64-40 64H64C28.7 96 0 124.7 0 160v32 32H32 64 352c53 0 96-43 96-96c0-52.5-41.6-83.2-88-92.7zM64 272V256H32v16V448H16 0v32H16 48h64 64 64 64 64H560h16V448H560 384V272 256H352v16V448H320V272 256H288v16V448H256V272 256H224v16V448H192V272 256H160v16V448H128V272 256H96v16V448H64V272z'
      
    ]
  };

  

  
  

  var faCalendarCirclePlus = {
    prefix: 'fasl',
    iconName: 'calendar-circle-plus',
    icon: [
      576,
      512,
      [],
      'e470',
      
      'M128 16V0H96V16 64H32 0V96v64 32V480v32H32 330.8c-12.9-9.1-24.5-19.9-34.6-32H32V192H352h64 16 16V160 96 64H416 352V16 0H320V16 64H128V16zM32 96H416v64H32V96zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 304V288H416v16 48H368 352v32h16 48v48 16h32V432 384h48 16V352H496 448V304z'
      
    ]
  };

  

  
  

  var faRampLoading = {
    prefix: 'fasl',
    iconName: 'ramp-loading',
    icon: [
      448,
      512,
      [],
      'f4d4',
      
      'M64 32H384V341.7l32 58.7V384 32 0H384 64 32V32 384v16.4l32-58.7V32zm80 256h-9.5l-4.5 8.4-104 192L13.1 512H40 408h26.9l-12.8-23.6-104-192-4.5-8.4H304 144zM66.9 480l86.7-160H294.5l86.7 160H66.9z'
      
    ]
  };

  

  
  

  var faNarwhal = {
    prefix: 'fasl',
    iconName: 'narwhal',
    icon: [
      640,
      512,
      [],
      'f6fe',
      
      'M638.6 22.6L562.4 190.1C609.2 221.7 640 275.3 640 336c0 97.2-78.8 176-176 176H240c-63.7 0-118.7-37.2-144.5-91.1c-7.8-16.3-12.9-34.1-14.8-52.9c-.5-5.3-.8-10.6-.8-16V272v-8L0 224V131.8 96l32 16 64 32 64-32 32-16v35.8V224l-80 40v8 55.7V352v16l.9-.7L144 343.5 323.5 206.2c39.2-30 87.2-46.2 136.6-46.2H464c25 0 48.8 5.2 70.3 14.6L609.4 9.4l29.1 13.2zM240 480H464c79.5 0 144-64.5 144-144s-64.5-144-144-144h-3.9c-42.3 0-83.5 13.9-117.1 39.7L131.4 393.4l-9.8 7.5c19.2 46.4 65 79.1 118.3 79.1zM504 272a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM110.3 172.6L96 179.8l-14.3-7.2L32 147.8v56.4l64 32 64-32V147.8l-49.7 24.8z'
      
    ]
  };

  

  
  

  var faTableLayout = {
    prefix: 'fasl',
    iconName: 'table-layout',
    icon: [
      512,
      512,
      [],
      'e290',
      
      'M480 64v96L32 160l0-96 448 0zM32 448l0-256 128 0 0 256H32zm160 0l0-256 288 0 0 256H192zM32 32L0 32 0 64 0 448l0 32H32l448 0h32V448l0-384V32l-32 0L32 32z'
      
    ]
  };

  

  
  

  var faChildReaching = {
    prefix: 'fasl',
    iconName: 'child-reaching',
    icon: [
      384,
      512,
      [],
      'e59d',
      
      'M224 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 128 64zM112 192h-9.5H93.3l-4.6-8L42.2 104l-8-13.8L61.8 74.1l8 13.8 41.9 72H270.9l43.3-72.2L322.5 74 350 90.5l-8.2 13.7-48 80-4.7 7.8H280h-8V496v16H240V496 384H144V496v16H112V496 192zm32 0V352h96V192H144z'
      
    ]
  };

  

  
  

  var faCalendarXmark = {
    prefix: 'fasl',
    iconName: 'calendar-xmark',
    icon: [
      448,
      512,
      ["calendar-times"],
      'f273',
      
      'M128 16V0H96V16 64H32 0V96v64 32V480v32H32 416h32V480 192 160 96 64H416 352V16 0H320V16 64H128V16zM32 192H416V480H32V192zm0-96H416v64H32V96zM299.3 283.3L310.6 272 288 249.4l-11.3 11.3L224 313.4l-52.7-52.7L160 249.4 137.4 272l11.3 11.3L201.4 336l-52.7 52.7L137.4 400 160 422.6l11.3-11.3L224 358.6l52.7 52.7L288 422.6 310.6 400l-11.3-11.3L246.6 336l52.7-52.7z'
      
    ]
  };

  
    var faCalendarTimes = faCalendarXmark;
  

  
  

  var faComputerMouseScrollwheel = {
    prefix: 'fasl',
    iconName: 'computer-mouse-scrollwheel',
    icon: [
      384,
      512,
      ["mouse-alt"],
      'f8cd',
      
      'M224 480c70.7 0 128-57.3 128-128V32H32V352c0 70.7 57.3 128 128 128h64zM0 0H32 352h32V32 352c0 88.4-71.6 160-160 160H160C71.6 512 0 440.4 0 352V32 0zM208 112v64 16H176V176 112 96h32v16z'
      
    ]
  };

  
    var faMouseAlt = faComputerMouseScrollwheel;
  

  
  

  var faPhone = {
    prefix: 'fasl',
    iconName: 'phone',
    icon: [
      512,
      512,
      [128222,128379],
      'f095',
      
      'M301.7 367.6l-21.3-12.3c-51.4-29.6-94.1-72.4-123.7-123.7l-12.3-21.3 17.3-17.3 40.7-40.7L156 36.2 32 58.7 32 64c0 229.7 186.3 416 416 416h5.3l22.5-124L359.7 309.5 319 350.2l-17.3 17.4zM352 272l160 64L480 512H448C200.6 512 0 311.4 0 64L0 32 176 0l64 160-55.6 55.6c26.8 46.5 65.5 85.2 112 112L352 272z'
      
    ]
  };

  

  
  

  var faFaceGrinTears = {
    prefix: 'fasl',
    iconName: 'face-grin-tears',
    icon: [
      640,
      512,
      [128514,"grin-tears"],
      'f588',
      
      'M320 32c-102.6 0-189.1 69-215.6 163.1c-10.2 1.6-22.3 3.6-34.5 6C95 86.1 197.5 0 320 0S545 86.1 570.1 201.1c-12.2-2.5-24.3-4.5-34.5-6C509.1 101 422.6 32 320 32zM120.1 358.3l.4-.4C157.6 430.4 233 480 320 480s162.4-49.6 199.5-122.1l.4 .4c7.8 7.8 16.7 13.9 26.1 18.1C502.9 457.1 417.9 512 320 512s-182.9-54.9-226-135.6c9.4-4.2 18.3-10.3 26.1-18.1zm87.4-138.4l-31-7.8c3.2-12.7 9.8-27.1 19.9-38.6C206.4 161.9 221.2 152 240 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6l-31 7.8c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4zM320 354.1c-31.2 0-61.4-2.9-89.9-8.3c22.5 23.6 54.5 38.3 89.9 38.3s67.4-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm0-32c41 0 79.9-5.3 114.9-14.9c13-3.5 25.4-7.7 37.2-12.3c-3.1 13.8-8 26.9-14.5 39c-26.2 48.9-78 82.2-137.7 82.2s-111.5-33.3-137.7-82.2c-6.5-12.1-11.4-25.2-14.5-39c11.8 4.6 24.3 8.8 37.2 12.3c35.1 9.6 74 14.9 114.9 14.9zm60.4-127.6c-6.2 7.2-10.8 16.8-12.9 25.4l-31-7.8c3.2-12.7 9.8-27.1 19.9-38.6C366.4 161.9 381.2 152 400 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6l-31 7.8c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zM38.9 276.7l-.1 .1-.2 .2 .3-.3zm-.3 .3c-8.8 9.2-9.2 24.9 1.1 35.3c10.3 10.3 25.8 9.9 34.8 1.1c0 0-.1 0-.1 0s0-.1 .2-.3c.5-.9 2-3.6 4.1-9.3c2.7-7.4 5.3-17 7.7-27.6c1-4.5 2-9.1 2.8-13.7c-4.6 .9-9.2 1.8-13.7 2.8c-10.6 2.3-20.2 4.9-27.6 7.6c-5.6 2-8.2 3.5-9.1 4l0 0c-.2 .1-.3 .2-.3 .2c0 0 0 0 0 0zM95 229c13.2-2.2 25.2-3.9 33-5c-1.1 7.9-2.8 19.8-5.1 33c-5.3 30.1-13.7 66.9-25.4 78.7c-22 22.1-58 21.6-80.4-.9s-22.8-58.6-.9-80.7C28 242.3 64.9 234.1 95 229zm506.4 48c-.1-.1-.2-.2-.3-.3l.1 .1c.1 .1 .2 .2 .2 .2zm-1.1 35.3c10.3-10.4 10-26.1 1.1-35.3c0 0 0 0 0 0c0 0-.1 0-.3-.2c-.9-.5-3.5-2-9.1-4c-7.4-2.7-16.9-5.2-27.6-7.6c-4.5-1-9.1-1.9-13.7-2.8c.9 4.5 1.8 9.1 2.8 13.7c2.4 10.6 5 20.2 7.7 27.6c2.1 5.7 3.6 8.4 4.1 9.3c.1 .2 .2 .3 .2 .3c0 0 0 0-.1 0c9 8.8 24.5 9.3 34.8-1.1zm23.5-58.2c22 22.1 21.5 58.2-.9 80.7s-58.4 22.9-80.4 .9c-11.7-11.8-20.2-48.6-25.4-78.7c-2.3-13.2-4-25.1-5.1-33c7.9 1.1 19.8 2.7 33 5c30.1 5.1 67 13.3 78.7 25.1z'
      
    ]
  };

  
    var faGrinTears = faFaceGrinTears;
  

  
  

  var faSpinnerThird = {
    prefix: 'fasl',
    iconName: 'spinner-third',
    icon: [
      512,
      512,
      [],
      'f3f4',
      
      'M477.7 384c21.8-37.7 34.3-81.4 34.3-128C512 114.6 397.4 0 256 0V32c123.7 0 224 100.3 224 224c0 40.8-10.9 79.1-30 112l27.7 16z'
      
    ]
  };

  

  
  

  var faLungsVirus = {
    prefix: 'fasl',
    iconName: 'lungs-virus',
    icon: [
      640,
      512,
      [],
      'e067',
      
      'M336 16V144H304V16 0h32V16zM256 128v60.1l-32-32V128H168.1c-22.5 30.9-43.2 62.8-62.1 96C69.2 288.4 32 358.3 32 423c0 31.5 25.5 57 57 57c22.8 0 47.9-5.4 75.5-13.3c9.7-2.8 20.2-6 31.1-9.4c3.2-1 6.5-2 9.8-3L231 479.9c-8 2.4-16.1 4.9-24.3 7.4l0 0C167.8 499.4 127.2 512 89 512c-49.1 0-89-39.8-89-89c0-74.6 42.3-152 78.2-214.9C100.5 169.2 125.1 131.8 152 96h72 32v32zM444.4 457.3c10.9 3.4 21.4 6.6 31.1 9.4c27.6 7.9 52.7 13.3 75.5 13.3c31.5 0 57-25.5 57-57c0-64.7-37.2-134.6-74-199c-18.9-33.2-39.7-65.1-62.1-96H416v28.1l-32 32V128 96h32 72c26.9 35.8 51.5 73.2 73.8 112.1C597.7 271.1 640 348.4 640 423c0 49.1-39.8 89-89 89c-38.2 0-78.8-12.6-117.7-24.7c-8.2-2.5-16.3-5.1-24.3-7.4l25.7-25.7c3.3 1 6.5 2 9.8 3zM433.1 229.5l-11.3 11.3C398.5 264.1 415 304 448 304h16v32H448c-33 0-49.5 39.9-26.2 63.2l11.3 11.3-22.6 22.6-11.3-11.3C375.9 398.5 336 415 336 448v16H304V448c0-33-39.9-49.5-63.2-26.2l-11.3 11.3-22.6-22.6 11.3-11.3C241.5 375.9 225 336 192 336H176V304h16c33 0 49.5-39.9 26.2-63.2l-11.3-11.3 22.6-22.6 11.3 11.3C264.1 241.5 304 225 304 192V176h32v16c0 33 39.9 49.5 63.2 26.2l11.3-11.3 22.6 22.6zm-54.1 31.4c-10.9 .9-21.9-.9-31.9-4.9c-10.4-4.2-19.8-10.9-27.2-19.5c-14.5 17-36.8 26.3-59.1 24.5c1.8 22.3-7.4 44.6-24.5 59.1c17 14.5 26.3 36.8 24.5 59.1c22.3-1.8 44.6 7.4 59.1 24.5c14.5-17 36.8-26.3 59.1-24.5c-1.8-22.3 7.4-44.6 24.5-59.1c-17-14.5-26.3-36.8-24.5-59.1zM304 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 56a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faUsersBetweenLines = {
    prefix: 'fasl',
    iconName: 'users-between-lines',
    icon: [
      640,
      512,
      [],
      'e591',
      
      'M0 0V32H16 624h16V0H624 16 0zM0 480v32H16 624h16V480H624 16 0zM115.2 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm256 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-341 224l24-64H393.8l24 64H222.2zM416 288H224l-36 96-12 32h34.2H429.8 464l-12-32-36-96zM273.6 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM87.1 288H189.8l4.2-11.2 7.8-20.8H64L32 352H65.7l21.3-64zm363.1 0H552.9l21.3 64H608l-32-96H438.2l7.8 20.8 4.2 11.2z'
      
    ]
  };

  

  
  

  var faChildDress = {
    prefix: 'fasl',
    iconName: 'child-dress',
    icon: [
      320,
      512,
      [],
      'e59c',
      
      'M160 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 160 0zM96 400H72 51.1l5.4-20.2L98 225.8 28.6 313.9 3.4 294.1l100.9-128 4.8-6.1h6.6 1.2H128h64 11.1 1.2 6.6l4.8 6.1 100.9 128-25.1 19.8L222 225.8l41.5 154 5.4 20.2H248 224v96 16H192V496 400H128v96 16H96V496 400zm83.7-208H140.3L92.9 368H227.1L179.7 192z'
      
    ]
  };

  

  
  

  var faCardClub = {
    prefix: 'fasl',
    iconName: 'card-club',
    icon: [
      384,
      512,
      [],
      'e3e9',
      
      'M352 32V480H32V32H352zM32 0H0V32 480v32H32 352h32V480 32 0H352 32zM208 331.9c7.5 2.7 15.6 4.1 24 4.1c39.8 0 72-32.2 72-72c0-28.3-16.3-52.7-40-64.5c-.3-39.5-32.4-71.5-72-71.5s-71.7 32-72 71.5C96.3 211.3 80 235.7 80 264c0 39.8 32.2 72 72 72c8.4 0 16.5-1.4 24-4.1V352H160 144v32h16 16 32 16 16V352H224 208V331.9zM152 200c0-22.1 17.9-40 40-40s40 17.9 40 40c0 2.5-.2 4.9-.6 7.2l-2.6 14.3 14 3.9c16.9 4.7 29.2 20.2 29.2 38.5c0 22.1-17.9 40-40 40c-11.2 0-21.3-4.6-28.6-12L192 280.3 180.6 292c-7.3 7.4-17.4 12-28.6 12c-22.1 0-40-17.9-40-40c0-18.3 12.3-33.8 29.2-38.5l14-3.9-2.6-14.3c-.4-2.3-.6-4.7-.6-7.2z'
      
    ]
  };

  

  
  

  var faRulerTriangle = {
    prefix: 'fasl',
    iconName: 'ruler-triangle',
    icon: [
      512,
      512,
      [128208],
      'f61c',
      
      'M32 32V480H480v-2.7l-51.3-51.3-17.4 17.4L400 454.6 377.4 432l11.3-11.3 17.4-17.4-57.4-57.4-17.4 17.4L320 374.6 297.4 352l11.3-11.3 17.4-17.4-57.4-57.4-17.4 17.4L240 294.6 217.4 272l11.3-11.3 17.4-17.4-57.4-57.4-17.4 17.4L160 214.6 137.4 192l11.3-11.3 17.4-17.4-57.4-57.4L91.3 123.3 80 134.6 57.4 112l11.3-11.3L86.1 83.3 34.7 32H32zM48 0L512 464v16 32H480 32 0V480 32 0H32 48zm64 217.4l27.3 27.3 128 128L294.6 400H256 128 112V384 256 217.4zm32 77.3V368h73.4L144 294.6z'
      
    ]
  };

  

  
  

  var faHousePersonLeave = {
    prefix: 'fasl',
    iconName: 'house-person-leave',
    icon: [
      640,
      512,
      ["house-leave","house-person-depart"],
      'e00f',
      
      'M520 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 520 0a56 56 0 1 0 0 112zM396.7 194.7l46.9-31.3L415 255.2c-5.7 18.2 0 38.1 14.4 50.6L530 393l30.7 102.7 4.6 15.3 30.7-9.2-4.6-15.3-32-107.2L558 375l-3.5-3L507.3 331l38.4-111 15 48.7 1.7 5.4 4.7 3.2 48 32 17.8-26.6-43.3-28.8-30.3-98.6-2.6-8.4-8.5-2.3-88-24-7-1.9-6.1 4-72 48-3.9 2.6-1.9 4.2-32 72-6.5 14.6 29.2 13 6.5-14.6 30.1-67.8zm48.8 70l33.1-106 49.7 13.6L481.2 308.4l-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zM386.9 422.5l-54.2 54.2L321.4 488 344 510.6l11.3-11.3 56-56c1.2-1.2 2.2-2.6 3-4.2l36.3-72.6-25-21.6-38.8 77.6zM250.1 11.6L240 3.4l-10.1 8.2-216 176L1.5 197.7l20.2 24.8 12.4-10.1L64 188V400v16H80 335.4l17.2-17.2L360 384H320 96V162L240 44.6l112.8 91.9L380.7 118 250.1 11.6zM256 192v64H192V192h64zm-64-32H160v32 64 32h32 64 32V256 192 160H256 192z'
      
    ]
  };

  
    var faHouseLeave = faHousePersonLeave;
  
    var faHousePersonDepart = faHousePersonLeave;
  

  
  

  var faLeftFromBracket = {
    prefix: 'fasl',
    iconName: 'left-from-bracket',
    icon: [
      512,
      512,
      [],
      'e66c',
      
      'M208 208l-32 0 0-32 0-48-17.7 0L43.1 256 158.3 384l17.7 0 0-48 0-32 32 0 112 0 0-96-112 0zm0-112l0 32 0 16 0 32 32 0 80 0 32 0 0 32 0 96 0 32-32 0-80 0-32 0 0 32 0 16 0 32-32 0-32 0L0 256 144 96l32 0 32 0zM336 448l144 0 0-384L336 64l-16 0 0-32 16 0 160 0 16 0 0 16 0 416 0 16-16 0-160 0-16 0 0-32 16 0z'
      
    ]
  };

  

  
  

  var faMarsDouble = {
    prefix: 'fasl',
    iconName: 'mars-double',
    icon: [
      640,
      512,
      [9891],
      'f227',
      
      'M304 32h16H432h16V48 160v16H416V160 86.6L311.3 191.4C336.7 221.9 352 261.2 352 304c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c42.8 0 82.1 15.3 112.6 40.7L393.4 64H320 304V32zM176 448a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM480 202.7V169.4L585.4 64H512 496V32h16H624h16V48 160v16H608V160 86.6l-100 100c22.6 30.6 36 68.4 36 109.4c0 101.6-82.4 184-184 184c-20.7 0-40.5-3.4-59.1-9.7c10.1-7.6 19.5-16.2 28.1-25.5c10 2.1 20.3 3.2 30.9 3.2c83.9 0 152-68.1 152-152c0-35.2-11.9-67.5-32-93.3z'
      
    ]
  };

  

  
  

  var faLocationCrosshairs = {
    prefix: 'fasl',
    iconName: 'location-crosshairs',
    icon: [
      512,
      512,
      ["location"],
      'f601',
      
      'M272 0V16 64.7c93.3 7.7 167.6 82.1 175.3 175.3H496h16v32H496 447.3c-7.7 93.3-82.1 167.6-175.3 175.3V496v16H240V496 447.3C146.7 439.6 72.4 365.3 64.7 272H16 0V240H16 64.7C72.4 146.7 146.7 72.4 240 64.7V16 0h32zM96 256a160 160 0 1 0 320 0A160 160 0 1 0 96 256zm224 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  
    var faLocation = faLocationCrosshairs;
  

  
  

  var faChessQueenPiece = {
    prefix: 'fasl',
    iconName: 'chess-queen-piece',
    icon: [
      256,
      512,
      ["chess-queen-alt"],
      'f446',
      
      'M152 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM48 224H32v32H48 61.9l-8.3 96H85.7L94 256H162l8.3 96h32.1l-8.3-96H208h16V224H208 195.8l56.1-118 2-4.3 2-4.3L232 80.7c-1.2 1.3-2.4 2.4-3.7 3.5c-.8 .7-1.6 1.3-2.3 1.9C207.2 100.4 184 96.5 184 64H152c0 32.4-48 32.4-48 0H72c0 32.5-23.2 36.4-41.9 22.2c-.8-.6-1.6-1.2-2.3-1.9c-1.3-1.1-2.5-2.3-3.7-3.5L0 97.4l2 4.3 2 4.3L60.2 224H48zm47.6 0l-2.7-5.7L49 126c4.4 .1 8.8-.3 13.3-1.3c11.3-2.6 21.2-8.8 28.5-18c10.9 9.5 24.5 13.6 37.2 13.6s26.2-4.1 37.2-13.6c7.3 9.2 17.2 15.4 28.5 18c4.5 1 9 1.4 13.3 1.3l-43.9 92.3-2.7 5.7H95.6zM32 480V463.3L64.8 416H191.2L224 463.3V480H32zM0 480v32H32 224h32V480 453.3L208 384H48L0 453.3V480z'
      
    ]
  };

  
    var faChessQueenAlt = faChessQueenPiece;
  

  
  

  var faBiohazard = {
    prefix: 'fasl',
    iconName: 'biohazard',
    icon: [
      576,
      512,
      [9763],
      'f780',
      
      'M152 0h8 .9 17.9l-2 17.8c-3.5 30.8 4.4 62.5 22.7 86.3c18 23.3 47 40 88.5 40s70.4-16.6 88.5-40c18.4-23.7 26.2-55.5 22.7-86.3L397.2 0h17.9 .9 8l4.8 6.4C450.9 35.8 464 72.4 464 112c0 18.6-2.9 36.5-8.2 53.3c15.5 3.9 30.6 10 45.1 18.3c34.3 19.8 59.4 49.4 73.9 83.3l3.1 7.4-4 6.9-.5 .8-9 15.5-14.4-10.6c-24.9-18.4-56.3-27.5-86.1-23.4c-29.2 4-58.1 20.7-78.8 56.6s-20.8 69.3-9.6 96.6c11.4 27.8 35 50.4 63.3 62.8l16.4 7.2-8.9 15.5-.5 .8-4 6.9-7.9 1c-36.5 4.4-74.8-2.5-109.1-22.3c-13.8-8-26.1-17.5-36.9-28.3c-10.7 10.8-23.1 20.4-36.9 28.3c-34.3 19.8-72.5 26.8-109.1 22.3l-7.9-1-4-6.9-.5-.8-8.9-15.5 16.4-7.2c28.4-12.4 51.9-35 63.3-62.8c11.2-27.3 11.1-60.7-9.6-96.6s-49.6-52.7-78.8-56.6c-29.8-4-61.1 5.1-86.1 23.4L11.5 297.4 2.6 281.9l-.5-.8-4-6.9 3.1-7.4c14.4-33.8 39.6-63.5 73.9-83.3c14.5-8.3 29.6-14.4 45.1-18.3c-5.3-16.8-8.2-34.7-8.2-53.3c0-39.6 13.1-76.2 35.2-105.6L152 0zm-2.6 72.9C145.9 85.3 144 98.4 144 112c0 21 4.5 40.9 12.5 58.8l8.8 19.6L144 193.3c-18.1 2.4-36.1 8.3-52.9 18.1C79.4 218.1 69 226.3 60 235.5c18.2-4.9 37.4-6.4 56.3-3.8c39.4 5.3 76.8 28.2 102.3 72.3s26.6 87.9 11.5 124.7c-7.3 17.7-18.1 33.5-31.5 46.9c12.5-3.2 24.8-8.1 36.5-14.9c16-9.2 29.5-21 40.4-34.6L288 410.6l12.5 15.6c10.9 13.5 24.4 25.4 40.4 34.6c11.7 6.8 24 11.7 36.5 14.9c-13.3-13.3-24.2-29.2-31.5-46.9c-15.1-36.8-14-80.6 11.5-124.7s62.9-67 102.3-72.3c19-2.6 38.1-1.1 56.3 3.8c-9-9.2-19.4-17.4-31.2-24.2c-16.8-9.7-34.8-15.6-52.9-18.1l-21.3-2.8 8.8-19.6c8-17.9 12.5-37.9 12.5-58.9c0-13.6-1.9-26.7-5.4-39.1c-4.9 18.2-13.1 35.5-24.9 50.7C377.5 155.1 339 176 288 176s-89.5-20.9-113.8-52.4c-11.7-15.1-20-32.5-24.9-50.7zm5.1 358.6c-40.1-33.6-67.4-82.1-73.3-136.9c9-1.8 18.1-2.2 26.7-1.1c1.8 .2 3.7 .6 5.5 1c5.6 43.9 27.3 82.7 59 110.3l-.1 .3c-3.9 9.6-10.1 18.6-17.9 26.4zM288 96c-15.9 0-31.3 2.1-45.9 6.1c-7.6-4.6-13.7-10.4-18.5-16.6c-2.2-2.9-4.2-6-6.1-9.2C239.5 68.3 263.3 64 288 64s48.5 4.3 70.5 12.2c-1.8 3.2-3.8 6.3-6.1 9.2c-4.8 6.2-10.9 12-18.5 16.6c-14.6-3.9-30-6.1-45.9-6.1zM462.6 294.5c1.8-.4 3.7-.7 5.5-1c8.6-1.2 17.7-.8 26.7 1.1c-5.9 54.9-33.2 103.3-73.3 136.9c-7.8-7.8-13.9-16.8-17.9-26.4l-.1-.3c31.7-27.6 53.5-66.4 59.1-110.3zM288 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faWebAwesome = {
    prefix: 'fasl',
    iconName: 'web-awesome',
    icon: [
      640,
      512,
      [],
      'e682',
      
      'M300.2 52a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM342 99.2C359.8 91 372.2 72.9 372.2 52c0-28.7-23.3-52-52-52s-52 23.3-52 52c0 20.8 12.3 38.8 30 47.1L192 192 87.6 171.1c5.3-7.7 8.4-17.1 8.4-27.1c0-26.5-21.5-48-48-48S0 117.5 0 144c0 26 20.6 47.1 46.4 48l1.7 3.9L176 480l288 0L591.9 195.9l1.8-3.9c25.8-.9 46.4-22 46.4-48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 10.1 3.1 19.4 8.4 27.1L448 192 342 99.2zM47.9 192l.1 0 .2 0-.2 0-.1 0zm390.9 34.5l15.5-3.1 99-19.8L443.3 448l-246.6 0L86.7 203.6l99 19.8 15.5 3.1 11.9-10.4L320 122.5l106.9 93.6 11.9 10.4zM592 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM320.2 104s0 0 0 0l.2 0-.2 0zM32 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faBalloon = {
    prefix: 'fasl',
    iconName: 'balloon',
    icon: [
      384,
      512,
      [],
      'e2e3',
      
      'M205.6 405.8l0 0 0 0 0 0L192 415.3l-13.6-9.5 0 0 0 0 0 0 0 0-.2-.2-1.1-.8c-1-.7-2.6-1.9-4.6-3.4c-4-3-9.9-7.6-17-13.5c-14.2-11.8-33.1-28.8-51.8-49.4C65 295.9 32 243.6 32 192c0-88.4 71.6-160 160-160s160 71.6 160 160c0 51.6-33 103.9-71.7 146.5c-18.8 20.6-37.6 37.6-51.8 49.4c-7.1 5.9-12.9 10.5-17 13.5c-2 1.5-3.6 2.7-4.6 3.4l-1.1 .8-.2 .2 0 0zM192 438.2l2.3 5.7L208.7 480H175.3l14.4-36.1 2.3-5.7zM256 512l-12.8-32L224 432s160-112 160-240C384 86 298 0 192 0S0 86 0 192C0 320 160 432 160 432l-19.2 48L128 512h34.5 59.1H256zM112 192c0-44.2 35.8-80 80-80V80C130.1 80 80 130.1 80 192h32z'
      
    ]
  };

  

  
  

  var faSensorOn = {
    prefix: 'fasl',
    iconName: 'sensor-on',
    icon: [
      640,
      512,
      [],
      'e02b',
      
      'M416 64V448H32V64H416zM32 32H0V64 448v32H32 416h32V448 64 32H416 32zm96 96H96v16V272v16h32V272 144 128zm64 0H160v16V272v16h32V272 144 128zM600.2 93.7L614 85.5 597.5 58l-13.7 8.2-80 48L490 122.5 506.5 150l13.7-8.2 80-48zM528 240H512v32h16 96 16V240H624 528zm-7.8 130.3L506.5 362 490 389.5l13.7 8.2 80 48 13.7 8.2L614 426.5l-13.7-8.2-80-48z'
      
    ]
  };

  

  
  

  var faMessagesDollar = {
    prefix: 'fasl',
    iconName: 'messages-dollar',
    icon: [
      640,
      512,
      ["comments-alt-dollar"],
      'f652',
      
      'M128 368L96 384V352v-3.8V320H64 32 0V288 32 0H32 384h32V32 288v32H384 224l-96 48zm0-35.8l81.7-40.8 6.8-3.4H224 384V32H32V288H96h32v32 12.2zM256 416V352h32v64H416h7.6l6.8 3.4L512 460.2V448 416h32 64V160H448V128H608h32v32V416v32H608 576 544v28.2V480v32l-32-16-96-48H288 256V416zM222.2 85.3v5.9c5.1 .9 14.3 2.6 18.1 3.6l13.8 3.6L247 126l-13.8-3.6c-3.2-.8-14.1-2.9-17.6-3.4c-10.1-1.5-18.5-.3-24.1 2.2c-5.5 2.4-7.1 5.4-7.5 7.3c-.5 2.8 0 4 .2 4.5c.3 .7 1.1 1.8 3.4 3.3c5.2 3.4 13.2 5.9 24.5 9.1l.5 .2c9.8 2.9 22.4 6.6 31.9 13.3c5.1 3.6 10 8.6 13 15.3c3.1 6.9 3.7 14.4 2.3 22.3c-2.6 14.4-12.4 24.1-24.4 29.1c-4.2 1.7-8.6 2.9-13.3 3.7v5.3 14.2l-28.4 0V234.7v-6c-7.6-1.5-18.2-5.1-24.9-7.3c-1.4-.5-2.6-.9-3.6-1.2l-13.5-4.4 8.8-27.1 13.5 4.4c1.6 .5 3.2 1.1 5 1.6l0 0 0 0 0 0 0 0c7.6 2.5 16.4 5.4 21.4 6.2c10.5 1.6 18.9 .6 24.2-1.6c4.9-2.1 6.8-4.8 7.3-7.8c.6-3.3 .1-4.9-.3-5.8c-.4-.9-1.3-2.2-3.5-3.7c-5-3.5-12.9-6.1-24-9.4l-1.7-.5c-9.4-2.8-21.4-6.3-30.4-12.2c-5.1-3.4-10.1-8-13.3-14.6c-3.3-6.7-4-14.2-2.6-21.9c2.5-13.8 12.5-23.3 24-28.3c4.2-1.9 8.8-3.2 13.7-4.1V85.3 71.1h28.4V85.3z'
      
    ]
  };

  
    var faCommentsAltDollar = faMessagesDollar;
  

  
  

  var faArrowRotateRight = {
    prefix: 'fasl',
    iconName: 'arrow-rotate-right',
    icon: [
      512,
      512,
      [8635,"arrow-right-rotate","arrow-rotate-forward","redo"],
      'f01e',
      
      'M464 192h16V176 48 32H448V48v92.6C408.8 75.5 337.5 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c86.4 0 161.4-49 198.8-120.6l-28.4-14.8C394.3 406.1 330.1 448 256 448C150 448 64 362 64 256S150 64 256 64c71 0 133.1 38.6 166.3 96H336 320v32h16H464z'
      
    ]
  };

  
    var faArrowRightRotate = faArrowRotateRight;
  
    var faArrowRotateForward = faArrowRotateRight;
  
    var faRedo = faArrowRotateRight;
  

  
  

  var faUserMusic = {
    prefix: 'fasl',
    iconName: 'user-music',
    icon: [
      640,
      512,
      [],
      'f8eb',
      
      'M320 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM43.3 480H289.6c2.7 12.2 8.5 23 16.5 32H33.5 0l9.8-32L64 304H384v81.1c-2.8 0-5.7 .1-8.4 .3L360.4 336H87.6L43.3 480zM640 155.1v22.2 72 144c0 1.1-.1 2.2-.3 3.2c.2 1.6 .3 3.2 .3 4.8c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c11.7 0 22.6 2.3 32 6.4V271.5L448 324.8V465.3c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c11.7 0 22.6 2.3 32 6.4V313.3v-72V229.8l10.9-3.6 192-64 21.1-7zM410.1 457c-5.5-4.1-14.6-7.7-26.1-7.7s-20.5 3.5-26.1 7.7c-5.5 4.1-5.9 7.4-5.9 8.3s.4 4.2 5.9 8.3c5.5 4.1 14.6 7.7 26.1 7.7s20.5-3.5 26.1-7.7c5.5-4.1 5.9-7.4 5.9-8.3s-.4-4.2-5.9-8.3zM448 291.1l160-53.3V199.5L448 252.8v38.3zM608 401.3c0-.9-.4-4.2-5.9-8.3c-5.5-4.1-14.6-7.7-26.1-7.7s-20.5 3.5-26.1 7.7c-5.5 4.1-5.9 7.4-5.9 8.3s.4 4.2 5.9 8.3c5.5 4.1 14.6 7.7 26.1 7.7s20.5-3.5 26.1-7.7c5.5-4.1 5.9-7.4 5.9-8.3z'
      
    ]
  };

  

  
  

  var faFacePensive = {
    prefix: 'fasl',
    iconName: 'face-pensive',
    icon: [
      512,
      512,
      [],
      'e384',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 384h96 16v32H304 208 192V384h16zM395.2 266.4l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0l25.6-19.2c21.6 28.8 64.8 28.8 86.4 0zm-278.4 0c21.6 28.8 64.8 28.8 86.4 0l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0l25.6-19.2zM74.5 200.8l14.3-7.2 22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18 10-12.5 25 20-10 12.5-14.4 18c-13 16.3-29.4 29.5-48 38.8l-22.9 11.4-14.3 7.2L74.5 200.8zm348.6-7.2l14.3 7.2-14.3 28.6-14.3-7.2L386 210.9c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18-10-12.5 25-20 10 12.5 14.4 18c10.1 12.7 22.9 23 37.4 30.2l22.9 11.4z'
      
    ]
  };

  

  
  

  var faHandsPraying = {
    prefix: 'fasl',
    iconName: 'hands-praying',
    icon: [
      640,
      512,
      ["praying-hands"],
      'f684',
      
      'M365.6 11.9L378.9 .5 389 14.7l120 168 3 4.2V192 292.2l116.8 36.5-9.5 30.5-128-40L480 315.8V304 197.1L373.1 47.5l-32 27.4 72.1 108.2 2.7 4V192 304l0 16H384V304 208H336V388.3l292.8 92.5-9.6 30.5L320 416.8 20.8 511.3l-9.6-30.5L304 388.3V208H256v96h0v16H224V304 224h0V192v-4.8l2.7-4L298.8 74.9l-32-27.4L160 197.1V304v11.8l-11.2 3.5-128 40-9.5-30.5L128 292.2V192v-5.1l3-4.2 120-168L261.1 .5l13.3 11.4L320 50.9l45.6-39.1zm-45.6 89L269.9 176H304h16 0 16 34.1L320 100.8z'
      
    ]
  };

  
    var faPrayingHands = faHandsPraying;
  

  
  

  var faHandScissors = {
    prefix: 'fasl',
    iconName: 'hand-scissors',
    icon: [
      544,
      512,
      [],
      'f257',
      
      'M17 189.2L1.6 184.9l4.2-15.4L27 92.3l4.2-15.4 15.4 4.2L85.3 91.8l31.7 8.7 .1-.3 4.3 1.2-.1 .2 136.9 37.7c3.7-7.2 8-14.2 13-20.8l36.1-48.1L312 64l8 0 51.5 0c53 0 101.7 29.1 126.8 75.7l4.5 8.3c11.3 21 17.2 44.4 17.2 68.3L520 352c0 61.9-50.1 112-112 112l-8 0-88 0-48 0-16 0 0-16 0-48-16 0-16 0 0-16 0-51.2L68.2 343.8l-39.9 3-16 1.2-1.2-16-6-79.8L4 236.3l16-1.2 39.9-3 89.2-6.7L55.6 199.8 17 189.2zm272.1-39.8l67.3 19.2 15.4 4.4L363 203.8l-15.4-4.4L134.4 138.5 76.8 122.6l-23.1-6.4L40.9 162.5 64 168.9l182.5 50.2-3 31.4L62.2 264.1l-23.9 1.8 3.6 47.9 23.9-1.8 165-12.4 17.2-1.3 0 17.2 0 52.5 16 0 16 0 0 16 0 48 32 0 88 0 8 0c44.2 0 80-35.8 80-80l0-135.7c0-18.5-4.6-36.8-13.4-53.1l-4.5-8.3C450.6 118.6 412.7 96 371.5 96L328 96l-31.3 41.7c-2.8 3.7-5.4 7.6-7.7 11.6z'
      
    ]
  };

  

  
  

  var faDrumSteelpan = {
    prefix: 'fasl',
    iconName: 'drum-steelpan',
    icon: [
      576,
      512,
      [],
      'f56a',
      
      'M544 160c0-19.9-16.1-43.9-64.8-64.5c-24.4-10.3-54.3-18.4-88.3-23.8l-14.4 86.1 38 83.6 1.1 2.4c23.9-5 45.3-11.5 63.6-19.2C527.9 203.9 544 179.9 544 160zm-197.5 9l-52.3 21.8-6.2 2.6-6.2-2.6L229.5 169l-36.6 80.6c29.2 4.2 61.3 6.5 95.1 6.5s65.9-2.3 95.1-6.5L346.5 169zm1.7-35.4l11-66.1C336.7 65.2 312.8 64 288 64s-48.7 1.2-71.2 3.5l11 66.1L288 158.7l60.2-25.1zM96.8 224.5c18.3 7.7 39.7 14.2 63.6 19.2l1.1-2.4 38-83.6L185.1 71.7c-33.9 5.4-63.9 13.5-88.3 23.8C48.1 116.1 32 140.1 32 160s16.1 43.9 64.8 64.5zM576 160V344c0 47.6-38.6 81.6-89.5 102.9C434.7 468.6 364.4 480 288 480s-146.7-11.4-198.5-33.1C38.6 425.6 0 391.6 0 344V160C0 80 128.9 32 288 32s288 48 288 128zm-32 62.8C496.1 264.4 399.5 288 288 288s-208.1-23.6-256-65.2V344c0 27.4 22.3 53.4 69.9 73.4C148.5 436.9 214.2 448 288 448s139.5-11.1 186.2-30.6c47.6-19.9 69.8-46 69.8-73.4V222.8z'
      
    ]
  };

  

  
  

  var faHandPointer = {
    prefix: 'fasl',
    iconName: 'hand-pointer',
    icon: [
      448,
      512,
      [],
      'f25a',
      
      'M112 0H96V16 288.4L74.2 261.6 64.1 249.2 51.7 259.3 5.9 296.5 0 301.3V309v33.2 5.7l3.6 4.4 9 11 75.2 92.5c28.9 35.5 72.2 56.2 118 56.2H256h16 64c61.9 0 112-50.1 112-112V336 320 240 224H432 368V208 192H352 288V176 160H272 208V16 0H192 112zM272 224h64v16 16h16 64v64 16 64c0 44.2-35.8 80-80 80H272 256 205.7c-36.1 0-70.3-16.3-93.1-44.3L37.4 343.1 32 336.5V316.6l27.5-22.3 15.1 18.6 18.9 23.3 11.2 13.8 12.5-12.5 6-6 4.7-4.7V320 32h48V176v16h16 64v16 16h16zm-48 96V304H192v16 96 16h32V416 320zm64 0V304H256v16 96 16h32V416 320zm64 0V304H320v16 96 16h32V416 320z'
      
    ]
  };

  

  
  

  var faBacterium = {
    prefix: 'fasl',
    iconName: 'bacterium',
    icon: [
      512,
      512,
      [],
      'e05a',
      
      'M409.3 39.9C434.6 50 456 69.1 468.4 94.3l29.1-12.9 13 29.2-32.1 14.3c5.1 29.3-1.8 58.3-17.3 81.5l14.3 14.3L486.6 232 464 254.6l-11.3-11.3-13.1-13.1c-13 10.8-28.7 18.9-46.4 22.9c-10.8 2.5-20.7 5.4-29.7 8.7l3.9 13.8 4.4 15.4L341 299.8l-4.4-15.4-2.7-9.4c-30.2 16.6-47.7 37-58.4 54.3l18.8 8.1 14.7 6.3L296.4 373l-14.7-6.3-20.5-8.8c-2.7 7.2-4.7 14.7-5.9 22.2c-2.5 22.7-11.6 43.1-25.2 59.4l13.1 13.1L254.6 464 232 486.6l-11.3-11.3L206.4 461c-20.6 13.8-45.9 20.9-72.5 18.5c-3-.3-6-.7-9-1.2l-14.3 32.1-29.2-13 12.9-29.1c-22.5-11.1-40.5-29.5-51.2-51.8l-31.6 7L4.5 392.4 33.4 386c-1.5-9.1-1.8-18.5-1-28.1c2-18.7 5.9-37.5 11.4-55.9l-17.8-7.1-14.9-5.9 11.9-29.7 14.9 5.9 16.5 6.6c7.7-19.4 17.1-38 27.5-55.4c3.3-5.5 6.7-10.9 10.4-16.4L78 188.5l-12.5-10 20-25 12.5 10 13.4 10.7c17.1-21.3 37.7-42 62.1-61.1L162.7 96.9l-8.9-13.3 26.6-17.8 8.9 13.3 10.3 15.4c21.8-14.2 46.2-27.1 73.5-38l-7.8-18.2L259 23.6 288.4 11l6.3 14.7 8.6 20c12.6-4 25.8-7.7 39.5-10.8c11.9-2.7 23.8-3.5 35.4-2.4l6.2-27.9 31.2 6.9-6.3 28.4zM223.7 375.3c3.4-22.5 12.7-43.2 22.9-60.1c20-33.3 58.7-74.6 139.4-93.2c43.1-9.9 69.9-52.9 60-95.9S393.1 56.1 350 66C222.8 95.4 149.4 166.1 109.4 232.8C86 271.9 69 317.1 64.3 361c-3.9 43.9 28.5 82.7 72.4 86.7c43.5 4 82.1-27.7 86.8-71c0-.5 .1-.9 .2-1.4zM216 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM144 320a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a48 48 0 1 1 0-96 48 48 0 1 1 0 96z'
      
    ]
  };

  

  
  

  var faGridDividers = {
    prefix: 'fasl',
    iconName: 'grid-dividers',
    icon: [
      512,
      512,
      [],
      'e3ad',
      
      'M0 0H512V32H0V0zM64 128v64h64V128H64zM32 96H64h64 32v32 64 32H128 64 32V192 128 96zM64 416v64h64V416H64zM32 384H64h64 32v32 64 32H128 64 32V480 416 384zM288 128H224v64h64V128zM224 96h64 32v32 64 32H288 224 192V192 128 96h32zm0 320v64h64V416H224zm-32-32h32 64 32v32 64 32H288 224 192V480 416 384zM448 128H384v64h64V128zM384 96h64 32v32 64 32H448 384 352V192 128 96h32zm0 320v64h64V416H384zm-32-32h32 64 32v32 64 32H448 384 352V480 416 384zm160-96v32H0V288H512z'
      
    ]
  };

  

  
  

  var faHandHoldingDollar = {
    prefix: 'fasl',
    iconName: 'hand-holding-dollar',
    icon: [
      576,
      512,
      ["hand-holding-usd"],
      'f4c0',
      
      'M304 32v9.6c5.9 1 19 3.5 24.1 4.9l15.5 4.1-8.2 30.9-15.5-4.1c-4-1.1-17.7-3.7-22.1-4.4c-12.8-2-23.6-.4-30.9 2.9c-7.2 3.3-9.9 7.5-10.5 11c-.7 4.1-.1 6.2 .5 7.4c.6 1.4 2 3.1 5 5.1c6.7 4.6 17.1 7.8 31 12l.6 .2c12.3 3.7 27.9 8.4 39.5 16.9c6.3 4.5 12 10.6 15.6 18.8c3.6 8.3 4.4 17.4 2.7 27.2c-3 17.5-14.6 29.4-29.3 35.7c-5.6 2.4-11.6 4-17.9 4.9V224v16H272V224v-9.6c-9.4-1.7-23.6-6.6-32.4-9.6l0 0 0 0 0 0c-1.8-.6-3.3-1.1-4.6-1.6l-15.2-5.1 10.1-30.4 15.2 5.1c1.9 .6 4 1.3 6.1 2.1l0 0 0 0 0 0c9.5 3.2 20.7 7 27.1 8.1c13.3 2.1 24 .8 31-2.2c6.5-2.8 9.5-6.7 10.3-11.8c.8-4.7 .2-7.3-.5-9c-.7-1.7-2.2-3.6-5.1-5.7c-6.5-4.8-16.7-8.1-30.5-12.3l-2-.6c-11.9-3.6-26.6-8-37.7-15.5c-6.2-4.2-12.2-10-15.9-17.9c-3.8-8.1-4.7-17.1-3.1-26.6c2.9-16.7 14.7-28.4 28.8-34.7c5.6-2.6 11.8-4.4 18.3-5.4V32 16h32V32zM171.2 304H176 384h16v16 64h.2l103.6-61.7 13.5-8 8.3 13.3 40 64L574 405l-13.5 8.5-152 96-3.9 2.5H400 16 0V480H16 395.4L530 395l-23.3-37.2-94 56L409 416h-4.4H400 384 320 304 256 240V384h16 48 16 48V336H180.8l-92 61.3-4 2.7H80 16 0V368H16 75.2l92-61.3 4-2.7z'
      
    ]
  };

  
    var faHandHoldingUsd = faHandHoldingDollar;
  

  
  

  var faCircleEllipsisVertical = {
    prefix: 'fasl',
    iconName: 'circle-ellipsis-vertical',
    icon: [
      512,
      512,
      [],
      'e10b',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm232 72h48v48H232V328zm0-192h48v48H232V136zm0 144V232h48v48H232z'
      
    ]
  };

  

  
  

  var faFaceGrinSquint = {
    prefix: 'fasl',
    iconName: 'face-grin-squint',
    icon: [
      512,
      512,
      [128518,"grin-squint"],
      'f585',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.5 23.6 54.5 38.3 89.9 38.3s67.4-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm0-32c41 0 79.9-5.3 114.9-14.9c13-3.5 25.4-7.7 37.2-12.3c-3.1 13.8-8 26.9-14.5 39c-26.2 48.9-78 82.2-137.7 82.2s-111.5-33.3-137.7-82.2c-6.5-12.1-11.4-25.2-14.5-39c11.8 4.6 24.3 8.8 37.2 12.3c35.1 9.6 74 14.9 114.9 14.9zM121.8 182l15.9-27.8 13.9 7.9 56 32L231.9 208l-24.3 13.9-56 32-13.9 7.9L121.8 234l13.9-7.9L167.4 208l-31.7-18.1L121.8 182zm254.5 7.9L344.6 208l31.7 18.1 13.9 7.9-15.9 27.8-13.9-7.9-56-32L280.1 208l24.3-13.9 56-32 13.9-7.9L390.2 182l-13.9 7.9z'
      
    ]
  };

  
    var faGrinSquint = faFaceGrinSquint;
  

  
  

  var faSquareLeft = {
    prefix: 'fasl',
    iconName: 'square-left',
    icon: [
      448,
      512,
      [11013,"arrow-alt-square-left"],
      'f351',
      
      'M32 64l384 0 0 384L32 448 32 64zM0 32V64L0 448v32H32l384 0h32V448 64 32H416 32 0zM224 224l96 0v64l-96 0H192l0 32v18.7L109.3 256 192 173.3V192v32h32zM64 256l22.6 22.6L192 384h32V352 320h32 64 32V288 224l0-32H320 256l-32 0V160 128H192L86.6 233.4 64 256z'
      
    ]
  };

  
    var faArrowAltSquareLeft = faSquareLeft;
  

  
  

  var faDiamond = {
    prefix: 'fasl',
    iconName: 'diamond',
    icon: [
      512,
      512,
      [9830],
      'f219',
      
      'M0 256l22.6 22.6L233.4 489.4 256 512l22.6-22.6L489.4 278.6 512 256l-22.6-22.6L278.6 22.6 256 0 233.4 22.6 22.6 233.4 0 256zM256 466.7L45.3 256 256 45.3 466.7 256 256 466.7z'
      
    ]
  };

  

  
  

  var faUserNurseHairLong = {
    prefix: 'fasl',
    iconName: 'user-nurse-hair-long',
    icon: [
      448,
      512,
      [],
      'e45e',
      
      'M128 76.9l96-42 96 42V144v0H128V76.9zM352 144V56L224 0 96 56v88 16 0 16 0 40L38.4 259.2 32 264v8 32 16H48h80 16V288H128 64v-8l50.4-37.8C136.8 279.2 177.5 304 224 304s87.2-24.8 109.6-61.8L384 280v8H320 304v32h16 80 16V304 272v-8l-6.4-4.8L352 216V176v0V160v0V144v0zm-32 32c0 53-43 96-96 96c-35.5 0-66.6-19.3-83.2-48H216h9.9l4.4-8.8L249.9 176H320v0zm-192 0v0h86.1l-8 16H129.3c-.9-5.2-1.3-10.5-1.3-16zm73.4 276.6L224 475.2l22.6-22.6L315.2 384h47.1l38.4 96H47.3l38.4-96h47.1l68.6 68.6zM384 352H301.9l-55.3 55.3L224 429.9l-22.6-22.6L146.1 352H64L12.8 480 0 512H34.5 413.5 448l-12.8-32L384 352zM240 48H208V64v8h-8H184v32h16 8v8 16h32V112v-8h8 16V72H248h-8V64 48z'
      
    ]
  };

  

  
  

  var faAlbumCirclePlus = {
    prefix: 'fasl',
    iconName: 'album-circle-plus',
    icon: [
      576,
      512,
      [],
      'e48c',
      
      'M416 64H32V448H275.2c5.9 11.4 12.9 22.2 21 32H32 0V448 64 32H32 416h32V64 192.7c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7V64zM224 96c69.3 0 128.3 44 150.5 105.6c-10.2 3.5-20 8-29.3 13.2C328.1 164.3 280.3 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c11.2 0 22-1.4 32.4-4.1c.7 10.9 2.4 21.5 5 31.7c-12 2.9-24.5 4.4-37.4 4.4c-88.4 0-160-71.6-160-160s71.6-160 160-160zm0 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64v48h48 16v32H496 448v48 16H416V432 384H368 352V352h16 48V304 288h32v16z'
      
    ]
  };

  

  
  

  var faScarf = {
    prefix: 'fasl',
    iconName: 'scarf',
    icon: [
      512,
      512,
      [129507],
      'f7c1',
      
      'M174.6 0H184 328h9.4l4.6 8.2 72 128 2.1 3.7V144v64 6.6l-4.7 4.7L374.6 256 416 297.4l3.3 3.3 8 8 3.3 3.3 68.7 68.7L510.6 392 488 414.6l-11.3-11.3L408 334.6 382.6 360l68.7 68.7L462.6 440 440 462.6l-11.3-11.3L360 382.6 334.6 408l68.7 68.7L414.6 488 392 510.6l-11.3-11.3L312 430.6l-3.3-3.3-8-8-3.3-3.3L100.7 219.3 96 214.6V208 144v-4.2l2.1-3.7 72-128L174.6 0zM352 233.4l32-32V148.2L318.6 32H193.4L128 148.2v53.2l184 184L385.4 312l-44.7-44.7L208 134.6V96h96 16v32H304 246.6L352 233.4zM210.7 374.6l22.6 22.6L131.3 499.3 120 510.6 97.4 488l11.3-11.3L210.7 374.6zm-48-48l22.6 22.6L83.3 451.3 72 462.6 49.4 440l11.3-11.3L162.7 326.6zm-48-48l22.6 22.6L35.3 403.3 24 414.6 1.4 392l11.3-11.3L114.7 278.6z'
      
    ]
  };

  

  
  

  var faPlantWilt = {
    prefix: 'fasl',
    iconName: 'plant-wilt',
    icon: [
      512,
      512,
      [],
      'e5aa',
      
      'M288 96c0-35.3 28.7-64 64-64s64 28.7 64 64v33.1c-38.4 5.7-64 32.2-64 73.9c0 29.3 35.8 79.4 80 116.9c44.2-37.5 80-88 80-116.9c0-41.7-25.6-68.3-64-73.9V96c0-53-43-96-96-96s-96 43-96 96v65.6c-20.3-20.7-48.7-33.6-80-33.6c-61.9 0-112 50.1-112 112v17.1c-38.4 5.7-64 32.2-64 73.9C0 360.4 35.8 410.5 80 448c44.2-37.5 80-88 80-116.9c0-41.7-25.6-68.3-64-73.9V240c0-44.2 35.8-80 80-80s80 35.8 80 80v40 16V496v16h32V496 296 280 240 96zm128 65.7V192v16h32V192 161.7c8.9 2 15.5 5.6 20.1 9.8c6.6 6 11.9 15.8 11.9 31.6c0 4.1-3.9 17-17.8 37c-8.2 11.8-18.6 24.3-30.3 36.2c-11.7-11.9-22.1-24.3-30.2-36.1c-13.8-20-17.7-32.9-17.7-37.1c0-15.8 5.3-25.6 11.9-31.6c4.6-4.2 11.2-7.8 20.1-9.8zM43.9 299.5c4.6-4.2 11.2-7.8 20.1-9.8v30.6 16H96v-16V289.7c8.9 2 15.5 5.6 20.1 9.8c6.6 6 11.9 15.8 11.9 31.6c0 4.1-3.9 17-17.8 37c-8.2 11.8-18.6 24.3-30.3 36.2C68.3 392.4 57.9 380 49.7 368.2C35.9 348.3 32 335.3 32 331.1c0-15.8 5.3-25.6 11.9-31.6z'
      
    ]
  };

  

  
  

  var faCommentDots = {
    prefix: 'fasl',
    iconName: 'comment-dots',
    icon: [
      512,
      512,
      [62075,128172,"commenting"],
      'f4ad',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM128 264a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faCommenting = faCommentDots;
  

  
  

  var faCalendarArrowUp = {
    prefix: 'fasl',
    iconName: 'calendar-arrow-up',
    icon: [
      448,
      512,
      ["calendar-upload"],
      'e0d1',
      
      'M128 16V0H96V16 64H32 0V96v64 32V480v32H32 416h32V480 192 160 96 64H416 352V16 0H320V16 64H128V16zM32 192H416V480H32V192zm0-96H416v64H32V96zM208 408v16h32V408l0-121.4 52.7 52.7L304 350.6 326.6 328l-11.3-11.3-80-80L224 225.4l-11.3 11.3-80 80L121.4 328 144 350.6l11.3-11.3L208 286.6 208 408z'
      
    ]
  };

  
    var faCalendarUpload = faCalendarArrowUp;
  

  
  

  var faSortUp = {
    prefix: 'fasl',
    iconName: 'sort-up',
    icon: [
      320,
      512,
      ["sort-asc"],
      'f0de',
      
      'M32 192H288v-1.7L160 75.1 32 190.3V192zm0 32H0V192 176L160 32 320 176v16 32H288 32z'
      
    ]
  };

  
    var faSortAsc = faSortUp;
  

  
  

  var faSquareL = {
    prefix: 'fasl',
    iconName: 'square-l',
    icon: [
      448,
      512,
      [],
      'e275',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM160 144V352H304h16v32H304 144 128V368 144 128h32v16z'
      
    ]
  };

  

  
  

  var faTennisBall = {
    prefix: 'fasl',
    iconName: 'tennis-ball',
    icon: [
      512,
      512,
      [127934],
      'f45e',
      
      'M256.6 480c-4.5-58.4 15.6-118.4 60.3-163.1s104.6-64.8 163.1-60.3c0-.2 0-.4 0-.6C480 132.3 379.7 32 256 32c-.2 0-.4 0-.6 0c4.5 58.4-15.6 118.4-60.3 163.1S90.4 259.9 32 255.4c0 .2 0 .4 0 .6c0 123.7 100.3 224 224 224c.2 0 .4 0 .6 0zm31.9-2.3c97.7-14.2 174.9-91.4 189.1-189.1c-49.5-3.8-100.3 13.2-138.1 51s-54.8 88.6-51 138.1zM223.5 34.3C125.8 48.6 48.6 125.8 34.3 223.5c49.5 3.8 100.3-13.2 138.1-51s54.8-88.6 51-138.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faFaceTongueMoney = {
    prefix: 'fasl',
    iconName: 'face-tongue-money',
    icon: [
      512,
      512,
      [],
      'e39d',
      
      'M256 32C132.3 32 32 132.3 32 256c0 77.2 39.1 145.3 98.6 185.6c3.6 17.6 10.8 33.9 20.8 48.1C62.1 449.7 0 360.1 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 104.1-62.1 193.7-151.3 233.7c10-14.2 17.2-30.5 20.8-48.1C440.9 401.3 480 333.2 480 256C480 132.3 379.7 32 256 32zm-95.6 81.8V96h32v17.7c4.1 .8 8.1 1.7 11.7 2.7l15.5 4.1-8.2 30.9-15.5-4.1c-7.3-1.9-14.1-3.3-20.1-3.4c-4.4-.1-9.6 1-13 2.9c-1.5 .9-2.1 1.6-2.4 2c-.1 .2-.4 .7-.3 2.1c0 .1 0 .2 0 .2l0 0c.1 .2 .8 .9 2.6 1.9c4.1 2.3 9.8 4.1 18.3 6.7l.3 .1c7.3 2.2 17.2 5.2 25.1 10.2c8.9 5.6 17.2 15 17.6 29.4c.4 16.1-8 27.3-18.6 33.5c-4.1 2.4-8.5 4.1-12.9 5.2V256h-32l0-18.2c-6.5-1.5-12.5-3.6-17.6-5.3c-1.4-.5-2.7-.9-3.9-1.3l-15.2-5.1 10.1-30.4 15.2 5.1c1.7 .6 3.2 1.1 4.7 1.6c9.2 3.1 15.8 5.3 22.7 5.6c4.9 .2 9.8-.9 12.7-2.6c1.3-.8 1.9-1.5 2.2-1.9c.2-.3 .6-1.2 .6-3l0-.1c0-.6 0-1.3-2.6-3c-3.7-2.4-9.3-4.2-17.6-6.7l-1.5-.4c-7-2.1-16.2-4.9-23.6-9.1c-8.7-5-17.7-13.7-18.6-28c-1-16.7 8.3-27.8 18.7-33.8c4.3-2.5 9-4.2 13.6-5.3zM112 288h48 32H320h32 48 16v16c0 51.1-24 96.6-61.3 125.9l-4.3 3.4C342.3 478 303.1 512 256 512s-86.3-34-94.4-78.7l-4.3-3.4C120 400.6 96 355.1 96 304V288h16zm48 32H129c3.3 26.2 14.4 49.9 31 68.7V320zm160 0H288 224 192v32 64c0 35.3 28.7 64 64 64s64-28.7 64-64V352 320zm32 0v68.7c16.6-18.8 27.8-42.5 31-68.7H352zM306.9 119.2c4.2-2.4 8.7-4.1 13.1-5.2V96h32v17.7c4.3 .8 8.3 1.8 12.1 2.8l15.5 4.1-8.2 30.9-15.5-4.1c-7.3-1.9-14.1-3.3-20.1-3.4c-4.4-.1-9.6 1-13 2.9c-1.5 .9-2.1 1.6-2.4 2c-.1 .2-.4 .7-.3 2.1c0 .1 0 .2 0 .2l0 0c.1 .2 .8 .9 2.6 1.9c4 2.3 9.8 4.1 18.3 6.7l.3 .1c7.3 2.2 17.2 5.2 25.1 10.2c8.9 5.6 17.2 15 17.5 29.4c.4 16.1-8 27.3-18.6 33.5c-4.3 2.5-8.8 4.2-13.3 5.3V256H320V237.8c-6.3-1.5-12.2-3.5-17.1-5.2c-1.4-.5-2.7-.9-3.9-1.3l-15.2-5.1 10.1-30.4 15.2 5.1c1.7 .6 3.2 1.1 4.7 1.6c9.2 3.1 15.8 5.3 22.7 5.6c4.9 .2 9.8-.9 12.7-2.6c1.3-.8 1.9-1.5 2.2-1.9c.2-.3 .6-1.2 .6-3l0-.1c0-.6 0-1.3-2.6-3c-3.7-2.4-9.3-4.2-17.6-6.7l-1.5-.4c-7-2.1-16.2-4.9-23.6-9.1c-8.7-5-17.7-13.7-18.6-28c-1-16.7 8.3-27.8 18.7-33.8zM268.7 344v15.6c3.1 .5 6.2 1.2 8.9 1.9l11.6 2.9-5.8 23.3-11.6-2.9c-5.5-1.4-10.7-2.3-15.3-2.4c-3.5-.1-7.5 .7-10.1 2.1c-1.2 .6-1.6 1.2-1.7 1.3c0 0 0 .1 0 .1s0 .1 0 .3c.2 .2 .8 .6 1.7 1.1c3.1 1.7 7.5 2.9 13.9 4.7l.2 .1 0 0c5.5 1.6 12.9 3.6 18.8 7.1c6.6 3.9 13.2 10.6 13.5 21.4c.3 12.1-6.4 20.1-14.3 24.4c-3.1 1.7-6.4 2.9-9.7 3.6v16.6h-24v-17c-4.6-1-9-2.4-12.7-3.6l0 0 0 0c-1-.3-2-.7-3-.9l-11.5-3.6 7.1-22.9 11.5 3.6c1.2 .4 2.4 .8 3.5 1.1l0 0 0 0c6.9 2.2 12 3.8 17.3 3.9c3.8 .1 7.6-.6 9.9-1.9c1-.6 1.4-1 1.5-1.2c.1-.1 .3-.4 .2-1.4l0-.1c-.1-.1-.5-.6-1.7-1.3c-2.9-1.7-7.1-3-13.4-4.8l-1.1-.3c-5.3-1.5-12.1-3.4-17.7-6.4c-6.3-3.4-13.6-9.6-14.2-20.4c-.8-12.5 6.7-20.6 14.4-24.7c3.1-1.6 6.4-2.8 9.6-3.6V344h24z'
      
    ]
  };

  

  
  

  var faUserPoliceTie = {
    prefix: 'fasl',
    iconName: 'user-police-tie',
    icon: [
      448,
      512,
      [],
      'e334',
      
      'M368 99.2L400 80V48L224 0 48 48V80L80 99.2V144c16 10.7 67.2 32 144 32s128-21.3 144-32V99.2zm-32 25.3c-13.6 5.6-35.5 12.5-64.7 16.4c12.9-19.7 16.7-42 16.7-57.7V72.4l-10.1-4-48-19.2L224 46.8l-5.9 2.4-48 19.2-10.1 4V83.2c0 15.7 3.8 38.1 16.7 57.7c-29.2-3.9-51.1-10.8-64.7-16.4V99.2 81.1L96.5 71.8l-4.4-2.6L224 33.2l131.9 36-4.4 2.6L336 81.1V99.2v25.3zM179.7 420.9L128 352H48L9.6 480 0 512H33.4 208h32H414.6 448l-9.6-32L400 352H320l-51.7 68.9L249.9 384H256h16V352H256 224 192 176v32h16 6.1l-18.4 36.9zm21.5 28.6L224 403.8l22.9 45.7-2.9 3.8L224 480l-20-26.7-2.9-3.8zM264 480l72-96h40.2L405 480H264zm-80 0H43l28.8-96H112l72 96zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-2.7-.1-5.3-.2-7.9c-10.4 4-21 7.6-31.8 10.7c-1.5 51.7-43.9 93.2-96 93.2s-94.5-41.5-96-93.2c-10.8-3.1-21.4-6.6-31.8-10.7c-.2 2.6-.2 5.2-.2 7.9zm96.7-98.3L224 81.2l31.3 12.5C252.9 111 244.5 131 224 142.3C203.5 131 195.1 111 192.7 93.7z'
      
    ]
  };

  

  
  

  var faFileUser = {
    prefix: 'fasl',
    iconName: 'file-user',
    icon: [
      384,
      512,
      [],
      'f65c',
      
      'M352 480H304l-32-96H112L80 480H32V32H192V176v16h16H352V480zm-81.7 0H113.7l21.3-64H248.9l21.3 64zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faScaleUnbalanced = {
    prefix: 'fasl',
    iconName: 'scale-unbalanced',
    icon: [
      640,
      512,
      ["balance-scale-left"],
      'f515',
      
      'M256.7 64c0 6.8 1.1 13.3 3 19.5L123.6 128.8l10.1 30.4 143.8-47.9c7.6 6.9 16.9 12.1 27.2 14.7V496c0 8.8 7.2 16 16 16h208 16V480h-16-192V126c23.8-6.1 42.3-25.7 46.9-50.1L517.7 31.2 507.6 .8 381.1 43c-8.7-25-32.5-43-60.5-43c-35.3 0-64 28.7-64 64zM32 425.4V416H223.9v9.4L169.2 480H86.6L32 425.4zm96.6-171.2L209.1 384H47l81.6-129.8zM512.7 65.8L499.1 87.5 386.6 266.7l-2.4 3.9 0 4.6-.1 28.8 0 6.7 4.7 4.7 64 64 4.7 4.7H464h95.9 6.6l4.7-4.7 64-64 4.7-4.7V304 275.2v-4.6l-2.4-3.9L526.2 87.6 512.7 65.8zM416.1 288H607.9v9.4L553.2 352H470.6L416 297.4l0-9.4zm15-32l81.5-129.8L593.1 256h-162zM128.7 193.8l-13.6 21.7L2.5 394.7 0 398.6v4.6V432v6.6l4.7 4.7 64 64 4.7 4.7H80h95.9 6.6l4.7-4.7 64-64 4.7-4.7V432 403.2v-4.6l-2.4-3.9L142.2 215.6l-13.5-21.8zM320.7 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  
    var faBalanceScaleLeft = faScaleUnbalanced;
  

  
  

  var faFaceKissClosedEyes = {
    prefix: 'fasl',
    iconName: 'face-kiss-closed-eyes',
    icon: [
      512,
      512,
      [],
      'e37d',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM237.8 367.8V336.2c13.1-1.8 27.3-5.7 37.9-10.8c5.3-2.6 8.8-5.1 10.8-7.2c1.1-1.1 1.4-1.8 1.6-2.1c-.1-.3-.5-1-1.6-2.1c-2-2.1-5.5-4.6-10.8-7.2c-10.5-5.1-24.8-9-37.9-10.8l4.5-31.7c15.4 2.2 33.1 6.7 47.5 13.8c7.2 3.5 14.3 8 19.9 13.9c5.6 5.9 10.4 14.1 10.4 24.2s-4.8 18.3-10.4 24.2c-4.5 4.7-10.1 8.6-15.9 11.8c5.8 3.2 11.4 7.1 15.9 11.8c5.6 5.9 10.4 14.1 10.4 24.2s-4.8 18.3-10.4 24.2c-5.6 5.8-12.7 10.3-19.9 13.9c-14.4 7-32.1 11.6-47.5 13.8l-4.5-31.7c13.1-1.8 27.3-5.7 37.9-10.8c5.3-2.6 8.8-5.1 10.8-7.2c1.1-1.1 1.4-1.8 1.6-2.1c-.1-.3-.5-1-1.6-2.1c-2-2.1-5.5-4.6-10.8-7.2c-10.5-5.1-24.8-9-37.9-10.8zM288 388.2a0 0 0 1 0 -.1 0 0 0 0 1 0 .1 0zm0-.3a.1 .1 0 1 0 0-.1 .1 .1 0 1 0 0 .1zm0-71.7a0 0 0 1 0 -.1 0 0 0 0 1 0 .1 0zm0-.3a.1 .1 0 1 0 0-.1 .1 .1 0 1 0 0 .1zm-68.8-78.3c-21.6-28.8-64.8-28.8-86.4 0l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2zm73.6 0l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0z'
      
    ]
  };

  

  
  

  var faVihara = {
    prefix: 'fasl',
    iconName: 'vihara',
    icon: [
      640,
      512,
      [],
      'f6a7',
      
      'M320 3.2l10.2 8.5C378 51.5 422.7 88.5 505.4 96.1l15.9 1.4-2.9 31.9-15.9-1.4c-7.8-.7-15.3-1.7-22.6-2.8V160l31.2 35.1c18.3 20.6 41.5 36 67.4 44.9c4.4 1.5 8.9 2.9 13.4 4l16.1 4v24h-6H584.9 576h-2.6H544v48l11.9 23.7c13.2 26.3 33.3 48.5 58.3 64.1l13 8.1 12.8 8v24H625h-7H608 576v56 16H544V504 448H416v56 16H384V504 448H256v56 16H224V504 448H96v56 16H64V504 448H32 22 15 0V424l12.8-8 13-8.1c25-15.6 45.1-37.8 58.3-64.1L96 320V272H66.6 64 55.1 38 32V248l16.1-4c4.5-1.1 9-2.5 13.4-4c25.9-8.9 49.1-24.4 67.4-44.9L160 160V124.5c-7.3 1.5-14.7 2.6-22.2 3.4l-15.9 1.8-3.5-31.8 15.9-1.8c67.5-7.5 128.5-45.2 175.5-84.4L320 3.2zM128 320H512V272H128v48zM448 118.1c-55.2-15.4-93.1-44.4-128.1-73.4c-35.7 28.4-79.8 56.3-129.5 71.9H192V160H448V118.1zM512.5 240c-9.1-7.1-17.5-15-25.2-23.7L465.6 192H174.4l-21.6 24.3c-7.7 8.7-16.2 16.6-25.2 23.7H512.5zM112.8 358c-11 22.1-26.2 41.7-44.5 58L224 416h32H384h32l155.8 0c-18.3-16.2-33.5-35.9-44.5-58l-3-6H115.8l-3 6z'
      
    ]
  };

  

  
  

  var faFloppyDisk = {
    prefix: 'fasl',
    iconName: 'floppy-disk',
    icon: [
      448,
      512,
      [128190,128426,"save"],
      'f0c7',
      
      'M32 480H0V448 64 32H32 336L448 144V448v32H416 32zm384-32V157.3L322.7 64H320V176v16H304 80 64V176 64H32V448H416zM96 64v96H288V64H96zm80 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z'
      
    ]
  };

  
    var faSave = faFloppyDisk;
  

  
  

  var faShop = {
    prefix: 'fasl',
    iconName: 'shop',
    icon: [
      640,
      512,
      ["store-alt"],
      'f54f',
      
      'M608 224h32V192 176L544 0H96L0 176v16 32H32 64V496v16H80 368h16V496 272 256H352v16 80H96V224H544V496v16h32V496 224h32zm-32-32H544 96 64 32v-7.8L115 32H525l83 152.2V192H576zM96 480V384H352v96H96z'
      
    ]
  };

  
    var faStoreAlt = faShop;
  

  
  

  var faPrescription = {
    prefix: 'fasl',
    iconName: 'prescription',
    icon: [
      448,
      512,
      [],
      'f5b1',
      
      'M16 0H0V16 208v96 16H32V304 224H137.4l3.3 3.3L265.4 352 140.7 476.7 129.4 488 152 510.6l11.3-11.3L288 374.6 412.7 499.3 424 510.6 446.6 488l-11.3-11.3L310.6 352 435.3 227.3 446.6 216 424 193.4l-11.3 11.3L288 329.4 182.4 223.8C241.3 220.5 288 171.7 288 112C288 50.1 237.9 0 176 0H16zM176 192H32V32H176c44.2 0 80 35.8 80 80s-35.8 80-80 80z'
      
    ]
  };

  

  
  

  var faWalker = {
    prefix: 'fasl',
    iconName: 'walker',
    icon: [
      448,
      512,
      [],
      'f831',
      
      'M115.1 0H128 384h16V16 386c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-29.8 20.4-54.9 48-62V224H98.6L39.6 491.4l-3.4 15.6L4.9 500.2l3.4-15.6 104-472L115.1 0zm-9.5 192H368V32H140.9L105.6 192zM352 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  

  
  

  var faScreencast = {
    prefix: 'fasl',
    iconName: 'screencast',
    icon: [
      576,
      512,
      [],
      'e23e',
      
      'M544 64H32V193.8C21.5 192.6 10.8 192 0 192V64 32H32 544h32V64 448v32H544 288c0-10.8-.6-21.5-1.8-32H544V64zM0 256V224c141.4 0 256 114.6 256 256H224C224 356.3 123.7 256 0 256zM32 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 64c0-70.7-57.3-128-128-128V320c88.4 0 160 71.6 160 160H128z'
      
    ]
  };

  

  
  

  var faDiploma = {
    prefix: 'fasl',
    iconName: 'diploma',
    icon: [
      640,
      512,
      ["scroll-ribbon"],
      'f5ea',
      
      'M253.2 80.8C245 70.2 232.4 64 219 64c-23.8 0-43 19.3-43 43v37h64 32 29.8L253.2 80.8zM144 144V107c0-41.4 33.6-75 75-75c23.3 0 45.3 10.8 59.5 29.3L320 115.2l41.5-53.9C375.7 42.8 397.7 32 421 32c41.4 0 75 33.6 75 75v37H608h32v32V288L576 416 400 383v62.5V480l-32-12.8L320 448l-48 19.2L240 480V445.5 383L64 416 0 288V176 144H32 144zm96 206.4V176H176 144 32V280.4l49.8 99.7L240 350.4zm160 0l158.2 29.7L608 280.4V176H496 464 400V350.4zM400 144h64V107c0-23.8-19.3-43-43-43c-13.4 0-26 6.2-34.1 16.8L338.2 144H368h32zm-64 32H304 272V432.7l36.1-14.4 11.9-4.8 11.9 4.8L368 432.7V176H336z'
      
    ]
  };

  
    var faScrollRibbon = faDiploma;
  

  
  

  var faShirtTankTop = {
    prefix: 'fasl',
    iconName: 'shirt-tank-top',
    icon: [
      384,
      512,
      [],
      'e3c9',
      
      'M80 0H96V16 64c0 53 43 96 96 96s96-43 96-96V16 0h16 16V16 64v60.6l62.6 140.9 1.4 3.1V272 496v16H368 16 0V496 272v-3.4l1.4-3.1L64 124.6V64 16 0H80zM91 142.6L32 275.4V480H352V275.4L293 142.6c-23.4 30-60 49.4-101 49.4s-77.6-19.3-101-49.4z'
      
    ]
  };

  

  
  

  var faChessBishopPiece = {
    prefix: 'fasl',
    iconName: 'chess-bishop-piece',
    icon: [
      256,
      512,
      ["chess-bishop-alt"],
      'f43b',
      
      'M80 32H96h32 32 16V64h-6.1c3.4 3.6 6.9 7.5 10.4 11.8C201.4 101.1 224 138.7 224 184c0 16.2-4.2 29.4-10.3 40H224v32H208 196.1l9.6 96H173.5l-9.6-96H92.1l-9.6 96H50.3l9.6-96H48 32V224H42.3C36.2 213.4 32 200.2 32 184c0-45.3 22.6-82.9 43.7-108.2c3.5-4.2 7-8.1 10.4-11.8H80V32zm91.5 192c10.2-7.5 20.5-19.8 20.5-40c0-18.9-5.2-36.6-13-52.4l-31.7 31.7L136 174.6 113.4 152l11.3-11.3 37-37c-2-2.6-3.9-5.1-5.9-7.5C146.4 85.1 137 76.2 130 70.1c-.7-.6-1.4-1.2-2-1.7c-.6 .5-1.3 1.1-2 1.7c-7 6.1-16.4 15-25.7 26.2C81.4 118.9 64 149.3 64 184c0 20.2 10.3 32.5 20.5 40h87.1zM32 463.3V480H224V463.3L191.2 416H64.8L32 463.3zm-32-10L48 384H208l48 69.3V480v32H224 32 0V480 453.3z'
      
    ]
  };

  
    var faChessBishopAlt = faChessBishopPiece;
  

  
  

  var faFaceFrown = {
    prefix: 'fasl',
    iconName: 'face-frown',
    icon: [
      512,
      512,
      [9785,"frown"],
      'f119',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM159.3 388.7l-30.6-9.5C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3l-30.6 9.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faFrown = faFaceFrown;
  

  
  

  var faDryer = {
    prefix: 'fasl',
    iconName: 'dryer',
    icon: [
      448,
      512,
      [],
      'f861',
      
      'M416 32V480H32V32H416zM32 0H0V32 480v32H32 416h32V480 32 0H416 32zm96 96A24 24 0 1 0 80 96a24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40 296c-56.4 0-103.1-41.7-110.9-96H176h16V288H176 113.1c7.8-54.3 54.4-96 110.9-96c61.9 0 112 50.1 112 112s-50.1 112-112 112zm0 32a144 144 0 1 0 0-288 144 144 0 1 0 0 288z'
      
    ]
  };

  

  
  

  var faWindowMaximize = {
    prefix: 'fasl',
    iconName: 'window-maximize',
    icon: [
      512,
      512,
      [128470],
      'f2d0',
      
      'M32 64V192H480V64H32zm0 160V448H480V224H32zM0 32H32 480h32V64 448v32H480 32 0V448 64 32z'
      
    ]
  };

  

  
  

  var faHouseChimney = {
    prefix: 'fasl',
    iconName: 'house-chimney',
    icon: [
      576,
      512,
      [63499,"home-lg"],
      'e3af',
      
      'M288 2.7L298.6 12 384 87.4V48 32h16 96 16V48 200h-.3l58.9 52-21.2 24L512 243V496v16H496 80 64V496 243L26.6 276 5.4 252l272-240L288 2.7zM480 172.1V64H416v51.6l64 56.5zM96 214.7V480H208V304c0-8.8 7.2-16 16-16H352c8.8 0 16 7.2 16 16V480H480V214.7L288 45.3 96 214.7zM336 320H240V480h96V320z'
      
    ]
  };

  
    var faHomeLg = faHouseChimney;
  

  
  

  var faArrowUpLeftFromCircle = {
    prefix: 'fasl',
    iconName: 'arrow-up-left-from-circle',
    icon: [
      512,
      512,
      [],
      'e09e',
      
      'M16 0H0V16 176v16H32V176 54.6L300.7 323.3 312 334.6 334.6 312l-11.3-11.3L54.6 32H176h16V0H176 16zM288 64H272V96h16c106 0 192 86 192 192s-86 192-192 192S96 394 96 288V272H64v16c0 123.7 100.3 224 224 224s224-100.3 224-224S411.7 64 288 64z'
      
    ]
  };

  

  
  

  var faHeartCircleXmark = {
    prefix: 'fasl',
    iconName: 'heart-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e501',
      
      'M256 141.3l-22.6-22.6L209.1 94.4C189.7 74.9 163.3 64 135.8 64C78.5 64 32 110.5 32 167.8c0 27.5 10.9 53.9 30.4 73.4l24.2 24.2L256 434.8l9.5-9.5c3.7 10.9 8.5 21.3 14.2 31.1l-1.1 1.1L256 480l-22.6-22.6L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8l1.6 1.6L256 96l22.6-22.6 1.6-1.6c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4c-9.6-4.5-19.7-8.1-30.2-10.7c2.9-9.5 4.3-19.5 4.3-29.7C480 110.5 433.5 64 376.2 64c-27.5 0-53.9 10.9-73.4 30.4l-24.2 24.2L256 141.3zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-36.7L454.6 368l36.7 36.7L502.6 416 480 438.6l-11.3-11.3L432 390.6l-36.7 36.7L384 438.6 361.4 416l11.3-11.3L409.4 368l-36.7-36.7L361.4 320 384 297.4l11.3 11.3L432 345.4l36.7-36.7L480 297.4 502.6 320l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faBus = {
    prefix: 'fasl',
    iconName: 'bus',
    icon: [
      576,
      512,
      [128653],
      'f207',
      
      'M96 91.5c6.2-8.3 21.4-22 49.6-34.3C177.1 43.5 223.5 32 288 32c131.4 0 179.1 40.8 192 59.4V128H304 272 96V91.5zM272 160v96H96V160H272zm32 96V160H480v96H304zm0 32H480V416H448 367.2 128 96V288H272h32zM64 128v32 96 32V432v16H80 96v48 16h32V496 448H367.2 448v48 16h32V496 448h16 16V432 288 256 160 128 86.8 82.6L510 79C492.8 48.3 433.6 0 288 0C219.8 0 168.8 12.1 132.8 27.9C97.3 43.4 75 63 66 79l-2 3.6v4.2V128zM184 352a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM240 64H224V96h16 96 16V64H336 240zM32 144V128H0v16 96 16H32V240 144zm544 0V128H544v16 96 16h32V240 144z'
      
    ]
  };

  

  
  

  var faPump = {
    prefix: 'fasl',
    iconName: 'pump',
    icon: [
      640,
      512,
      [],
      'e442',
      
      'M76.9 0h-16V32h16H96V208H32V192 176H0v16 32V384v32 16H32V416 400H320V368H32V240h80 16V224 32H256V224v16h16 48V208H288V32h16 16V0H304 272 112 76.9zM384 177.1L457.7 128H608V480H457.7L384 430.9V177.1zM448 96l-96 64V448l96 64H608h32V480 128 96H608 448zm0 112v32h16 80 16V208H544 464 448zm0 80v32h16 80 16V288H544 464 448zm0 80v32h16 80 16V368H544 464 448z'
      
    ]
  };

  

  
  

  var faSignal = {
    prefix: 'fasl',
    iconName: 'signal',
    icon: [
      640,
      512,
      [128246,"signal-5","signal-perfect"],
      'f012',
      
      'M592 16V0H560V16 496v16h32V496 16zM464 96H432v16V496v16h32V496 112 96zM336 208V192H304v16V496v16h32V496 208zM208 288H176v16V496v16h32V496 304 288zM80 384H48v16 96 16H80V496 400 384z'
      
    ]
  };

  
    var faSignal5 = faSignal;
  
    var faSignalPerfect = faSignal;
  

  
  

  var faFileCode = {
    prefix: 'fasl',
    iconName: 'file-code',
    icon: [
      384,
      512,
      [],
      'f1c9',
      
      'M32 480V32H192V176v16h16H352V480H32zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM155.3 299.3L166.6 288 144 265.4l-11.3 11.3-48 48L73.4 336l11.3 11.3 48 48L144 406.6 166.6 384l-11.3-11.3L118.6 336l36.7-36.7zm96-22.6L240 265.4 217.4 288l11.3 11.3L265.4 336l-36.7 36.7L217.4 384 240 406.6l11.3-11.3 48-48L310.6 336l-11.3-11.3-48-48z'
      
    ]
  };

  

  
  

  var faToiletPaperBlankUnder = {
    prefix: 'fasl',
    iconName: 'toilet-paper-blank-under',
    icon: [
      512,
      512,
      ["toilet-paper-reverse-alt"],
      'e29f',
      
      'M58.2 75.2C42.3 104.3 32 145.5 32 192s10.3 87.7 26.2 116.8C74.4 338.5 94.1 352 112 352H337.3c-7.2-8.2-13.6-17.7-19.2-27.9C299.2 289.5 288 242.8 288 192s11.2-97.5 30.1-132.1c5.6-10.2 12-19.6 19.2-27.9H112C94.1 32 74.4 45.5 58.2 75.2zM400 32c-17.9 0-37.6 13.5-53.8 43.2C330.3 104.3 320 145.5 320 192s10.3 87.7 26.2 116.8C362.4 338.5 382.1 352 400 352s37.6-13.5 53.8-43.2C469.7 279.7 480 238.5 480 192s-10.3-87.7-26.2-116.8C437.6 45.5 417.9 32 400 32zm80 448V327.6c-18.6 32.3-46.1 56.4-80 56.4H112c-35.1 0-63.4-25.9-81.9-59.9C11.2 289.5 0 242.8 0 192S11.2 94.5 30.1 59.9C48.6 25.9 76.9 0 112 0H400c35.1 0 63.4 25.9 81.9 59.9C500.8 94.5 512 141.2 512 192V496v16H496 144 128V496 416h32v64H480zM400 240c6.4 0 11.9-11.3 14.5-27.6c1-6.2 1.5-13.1 1.5-20.4s-.5-14.2-1.5-20.4c-2.6-16.3-8.1-27.6-14.5-27.6s-11.9 11.3-14.5 27.6c-1 6.2-1.5 13.1-1.5 20.4s.5 14.2 1.5 20.4c2.6 16.3 8.1 27.6 14.5 27.6zm0 32c-16.2 0-26.6-9.9-31.4-16c-5.1-6.4-8.2-13.8-10.3-20c-4.2-12.7-6.3-28.3-6.3-44.1s2.1-31.3 6.3-44.1c2.1-6.2 5.2-13.5 10.3-20c4.8-6.1 15.1-16 31.4-16s26.6 9.9 31.4 16c5.1 6.4 8.2 13.8 10.3 20c4.2 12.7 6.3 28.3 6.3 44.1s-2.1 31.3-6.3 44.1c-2.1 6.2-5.2 13.5-10.3 20c-4.8 6.1-15.1 16-31.4 16z'
      
    ]
  };

  
    var faToiletPaperReverseAlt = faToiletPaperBlankUnder;
  

  
  

  var faFloppyDisks = {
    prefix: 'fasl',
    iconName: 'floppy-disks',
    icon: [
      512,
      512,
      [],
      'e183',
      
      'M96 416h32H480h32V384 112L400 0H192 160 128 96V32 384v32zM160 32v96 16h16H368h16V128 32h2.7L480 125.3V384H128V32h32zm192 0v80H192V32H352zM32 112V96H0v16V496v16H16 400h16V480H400 32V112zM296 224a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 112a72 72 0 1 0 0-144 72 72 0 1 0 0 144z'
      
    ]
  };

  

  
  

  var faTowerObservation = {
    prefix: 'fasl',
    iconName: 'tower-observation',
    icon: [
      512,
      512,
      [],
      'e586',
      
      'M256 6.1l7.2 3.6 176 88 14.3 7.2-14.3 28.6-14.3-7.2-8.8-4.4V224v16H400 360.2l39.6 237.4c.1 .9 .2 1.8 .2 2.6h96 16v32H496 16 0V480H16h96c0-.9 .1-1.7 .2-2.6L151.8 240H112 96V224 121.9l-8.8 4.4-14.3 7.2L58.5 104.8l14.3-7.2 176-88L256 6.1zm0 35.8l-128 64V128H384V105.9l-128-64zM128 160v48H384V160H128zM359.4 480L256 391.4 152.6 480H359.4zM183.8 242.6l-6.5 39.1L256 349.2l78.7-67.5-6.5-39.1c-.1-.9-.2-1.8-.2-2.6H184c0 .9-.1 1.7-.2 2.6zm-12.7 76L151 439.2l80.4-68.9-60.3-51.7zm109.5 51.7L361 439.2 340.9 318.6l-60.3 51.7z'
      
    ]
  };

  

  
  

  var faPen = {
    prefix: 'fasl',
    iconName: 'pen',
    icon: [
      512,
      512,
      [128394],
      'f304',
      
      'M0 512l6.8-34L32 352 361.4 22.6 384 0l22.6 22.6 82.7 82.7L512 128l-22.6 22.6L160 480 34 505.2 0 512zm144.2-61.5L398.1 196.7l-82.7-82.7L61.5 367.8 40.8 471.2l103.4-20.7zM420.7 174.1L466.7 128 384 45.3 337.9 91.3l82.7 82.7z'
      
    ]
  };

  

  
  

  var faUserSlash = {
    prefix: 'fasl',
    iconName: 'user-slash',
    icon: [
      640,
      512,
      [],
      'f506',
      
      'M541 512l-40.5-32H139.3l44.3-144H318l-40.5-32H160L105.8 480 96 512h33.5 381H541zM448 128C448 57.3 390.7 0 320 0C266.1 0 219.9 33.4 201.1 80.6l26.6 21C239.2 61.4 276.1 32 320 32c53 0 96 43 96 96c0 35.9-19.7 67.2-48.9 83.7l26.6 21C426.6 209.5 448 171.2 448 128zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faManhole = {
    prefix: 'fasl',
    iconName: 'manhole',
    icon: [
      512,
      512,
      [],
      'e1d6',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM201.6 122.6C215.8 135.9 235 144 256 144s40.2-8.1 54.4-21.4C363 144.1 400 195.8 400 256s-37 111.9-89.6 133.4C296.2 376.1 277 368 256 368s-40.2 8.1-54.4 21.4C149 367.9 112 316.2 112 256s37-111.9 89.6-133.4zM213 85.3C136.6 104.5 80 173.6 80 256s56.6 151.5 133 170.7c7.8-15.8 24.2-26.7 43-26.7s35.2 10.9 43 26.7c76.4-19.2 133-88.3 133-170.7s-56.6-151.5-133-170.7c-7.8 15.8-24.2 26.7-43 26.7s-35.2-10.9-43-26.7zM208 176H176v32h32V176zm0 64H176v32h32V240zm-32 64v32h32V304H176zm96-96V176H240v32h32zm0 128V304H240v32h32zm32-160v32h32V176H304zm-64 64v32h32V240H240zm96 0H304v32h32V240zm-32 64v32h32V304H304z'
      
    ]
  };

  

  
  

  var faHexagon = {
    prefix: 'fasl',
    iconName: 'hexagon',
    icon: [
      512,
      512,
      [11043],
      'f312',
      
      'M146.6 448l218.9 0L475.1 256 365.4 64 146.6 64 36.9 256 146.6 448zM0 256L128 32l256 0L512 256 384 480l-256 0L0 256z'
      
    ]
  };

  

  
  

  var faFileShield = {
    prefix: 'fasl',
    iconName: 'file-shield',
    icon: [
      576,
      512,
      [],
      'e4f0',
      
      'M352 192v28.7l32-12.4V152L232 0H32 0V32 480v32H32 352h10.1c-13.3-9.5-25.3-20.3-36.1-32H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM543.9 301.6C542.1 367.4 508.8 437 448 470.3V264.5l95.9 37.1zm-223.8 0L416 264.5V470.3c-60.8-33.3-94.1-102.8-95.9-168.6zM432 512c96-32 144-130.1 144-216V279.7L432 224 288 279.7V296c0 85.9 48 184 144 216z'
      
    ]
  };

  

  
  

  var faPersonMilitaryToPerson = {
    prefix: 'fasl',
    iconName: 'person-military-to-person',
    icon: [
      512,
      512,
      [],
      'e54c',
      
      'M182.9 0l-1 .1L69.9 15 56 16.8v14 32 16H72 192h16v-16V16 0H192h-8-1.1zM176 33.2V46.8H88V44.9l88-11.7zM352 96.6a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM79.6 239.6L160.3 288H70.6l9.1-48.4zm101.1 23.3l-65-38.9h57.7l7.3 38.9zM64 96.6c0 35.3 28.7 63.9 64 63.9s64-28.6 64-63.9H160c0 17.6-14.3 31.9-32 31.9s-32-14.3-32-31.9H64zm90.5 267.6l-12-10.5-21.1 24.1 12 10.5 31.9 27.9H16 0v32H16 165.4L133.5 476l-12 10.5 21.1 24.1 12-10.5 64-55.9 13.8-12.1-13.8-12-64-55.9zm202.9 0l-64 55.9-13.8 12 13.8 12.1 64 55.9 12 10.5 21.1-24.1L378.5 476l-31.9-27.9H496h16v-32H496 346.6l31.9-27.9 12.1-10.5-21.1-24.1-12 10.5zM338.6 224h90.9l12 64H326.6l12-64zM456 192H312l-18 96-6 32h32.6H447.4 480l-6-32-18-96zM56 192L38 288l-6 32H64.6 191.4 224l-6-32-18-96H56z'
      
    ]
  };

  

  
  

  var faAudioDescription = {
    prefix: 'fasl',
    iconName: 'audio-description',
    icon: [
      576,
      512,
      [],
      'f29e',
      
      'M544 64V448H32V64H544zM32 32H0V64 448v32H32 544h32V448 64 32H544 32zM304 160v16V336v16h16 64c53 0 96-43 96-96s-43-96-96-96H320 304zm32 32h48c35.3 0 64 28.7 64 64s-28.7 64-64 64H336V192zM202.3 160H181.7l-4.3 9.3L93.4 352h35.2l22.1-48H152h80 1.3l22.1 48h35.2l-84-182.7-4.3-9.3zM165.5 272L192 214.3 218.5 272H165.5z'
      
    ]
  };

  

  
  

  var faArrowsMinimize = {
    prefix: 'fasl',
    iconName: 'arrows-minimize',
    icon: [
      512,
      512,
      ["compress-arrows"],
      'e0a5',
      
      'M56 33.4L67.3 44.7 192 169.4V64 48h32V64 208v16H208 64 48V192H64 169.4L44.7 67.3 33.4 56 56 33.4zM478.6 56L467.3 67.3 342.6 192H448h16v32H448 304 288V208 64 48h32V64 169.4L444.7 44.7 456 33.4 478.6 56zM48 320V288H64 208h16v16V448v16H192V448 342.6L67.3 467.3 56 478.6 33.4 456l11.3-11.3L169.4 320H64 48zm240-32h16H448h16v32H448 342.6L467.3 444.7 478.6 456 456 478.6l-11.3-11.3L320 342.6V448v16H288V448 304 288z'
      
    ]
  };

  
    var faCompressArrows = faArrowsMinimize;
  

  
  

  var faBootHeeled = {
    prefix: 'fasl',
    iconName: 'boot-heeled',
    icon: [
      512,
      512,
      [],
      'e33f',
      
      'M141 418.8L278.8 480H432h16V419.8L241.7 316.6 224 307.8V288 32H128V240v16H96V240 32H32V62L55.8 252l.6 5-.9 4.9L32 387v29h96 6.8l6.2 2.8zM128 0h96 32V32 288L480 400v80h16 16v32H496 480 448 432 272L160 462.2V496v16H144 16 0V496 448 432 416 384L24 256 0 64V32 0H32 96h32zm0 448H32v32h96V448z'
      
    ]
  };

  

  
  

  var faTicketAirline = {
    prefix: 'fasl',
    iconName: 'ticket-airline',
    icon: [
      640,
      512,
      ["ticket-perforated-plane","ticket-plane"],
      'e29a',
      
      'M0 96V64H32 608h32V96v80 32H624c-26.5 0-48 21.5-48 48s21.5 48 48 48h16v32 80 32H608 32 0V416 96zM32 416H608V334.4c-36.5-7.4-64-39.7-64-78.4s27.5-71 64-78.4V96H32V416zM464 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM176 128h56 9.2l4.6 7.9 42 72.1h31.1c20.3 0 39.8 8.1 54.1 22.4c14.1 14.1 14.1 37 0 51.2c-14.4 14.4-33.8 22.4-54.1 22.4H287.9l-42 72.1-4.6 7.9H232 176 153.8l7-21.1L180.5 304H176l-19.2 25.6L152 336h-8H104 83.5l5-19.9 15-60.1-15-60.1-5-19.9H104h40 8l4.8 6.4L176 208h4.5l-19.6-58.9-7-21.1H176zm41.8 90.9l7 21.1H202.7 168h-8l-4.8-6.4L136 208H124.5l11 44.1 1 3.9-1 3.9-11 44.1H136l19.2-25.6L160 272h8 34.7 22.2l-7 21.1L198.2 352h24.6l42-72.1 4.6-7.9h9.2 40.3c11.8 0 23.1-4.7 31.5-13c1.6-1.6 1.6-4.3 0-5.9c-8.4-8.4-19.7-13-31.5-13H278.7h-9.2l-4.6-7.9-42-72.1H198.2l19.6 58.9z'
      
    ]
  };

  
    var faTicketPerforatedPlane = faTicketAirline;
  
    var faTicketPlane = faTicketAirline;
  

  
  

  var faHeat = {
    prefix: 'fasl',
    iconName: 'heat',
    icon: [
      448,
      512,
      [],
      'e00c',
      
      'M192 32V48v96c0 38.1 12.4 75.1 35.2 105.6l19.2 25.6c27 36 41.6 79.8 41.6 124.8v64 16H256V464 400c0-38.1-12.4-75.1-35.2-105.6l-19.2-25.6C174.6 232.8 160 189 160 144V48 32h32zM32 96v16 45.9c0 34.7 10.3 68.7 29.6 97.6l31.5 47.3c22.8 34.2 34.9 74.3 34.9 115.4V464v16H96V464 418.1c0-34.7-10.3-68.7-29.6-97.6L34.9 273.2C12.2 239.1 0 198.9 0 157.9V112 96H32zm320 16v45.9c0 34.7 10.3 68.7 29.6 97.6l31.5 47.3c22.8 34.2 34.9 74.3 34.9 115.4V464v16H416V464 418.1c0-34.7-10.3-68.7-29.6-97.6l-31.5-47.3C332.2 239.1 320 198.9 320 157.9V112 96h32v16z'
      
    ]
  };

  

  
  

  var faFaceSadCry = {
    prefix: 'fasl',
    iconName: 'face-sad-cry',
    icon: [
      512,
      512,
      [128557,"sad-cry"],
      'f5b3',
      
      'M384 439.8V272 256H352v16V458.4c-29.1 13.8-61.6 21.6-96 21.6s-66.9-7.7-96-21.6V272 256H128v16V439.8C70 399.4 32 332.1 32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 76.1-38 143.4-96 183.8zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM203.2 237.6l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2c21.6-28.8 64.8-28.8 86.4 0zm105.6 0c21.6-28.8 64.8-28.8 86.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2zM288 352c0 17.7-14.3 32-32 32s-32-14.3-32-32V328c0-17.7 14.3-32 32-32s32 14.3 32 32v24zm-32-88c-35.3 0-64 28.7-64 64v24c0 35.3 28.7 64 64 64s64-28.7 64-64V328c0-35.3-28.7-64-64-64z'
      
    ]
  };

  
    var faSadCry = faFaceSadCry;
  

  
  

  var faEye = {
    prefix: 'fasl',
    iconName: 'eye',
    icon: [
      576,
      512,
      [128065],
      'f06e',
      
      'M118 373c-39.8-38.3-67.9-83.7-83.2-117c15.3-33.3 43.4-78.6 83.2-117c44.6-42.9 101.5-75 170-75s125.4 32.1 170 75c39.8 38.3 67.9 83.7 83.2 117c-15.3 33.3-43.4 78.6-83.2 117c-44.6 42.9-101.5 75-170 75s-125.4-32.1-170-75zM288 480c158.4 0 258-149.3 288-224C546 181.3 446.4 32 288 32S30 181.3 0 256c30 74.7 129.6 224 288 224zM192 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z'
      
    ]
  };

  

  
  

  var faBusSimple = {
    prefix: 'fasl',
    iconName: 'bus-simple',
    icon: [
      448,
      512,
      ["bus-alt"],
      'f55e',
      
      'M32 96V91.5c6.2-8.3 21.4-22 49.6-34.3C113.1 43.5 159.5 32 224 32c131.4 0 179.1 40.8 192 59.4V96H32zm0 32H416V256H32V128zM416 288V416H303.2 32V288H416zM224 0C155.8 0 104.8 12.1 68.8 27.9C33.3 43.4 11 63 2 79L0 82.6v4.2V432v16H16 32v48 16H64V496 448H303.2 384v48 16h32V496 448h16 16V432 86.8 82.6L446 79C428.8 48.3 369.6 0 224 0zM96 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm280-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faBusAlt = faBusSimple;
  

  
  

  var faChestnut = {
    prefix: 'fasl',
    iconName: 'chestnut',
    icon: [
      448,
      512,
      [127792],
      'e3f6',
      
      'M32 402.7L77.3 448H370.7L416 402.7V384H32v18.7zM416 352c0-83-44.5-143.1-95.7-190.5c-20.4-18.9-40.9-35-59.9-49.7c-5-3.9-9.8-7.7-14.5-11.4c-7.6-6-15.1-12.1-21.9-18.2c-6.7 6-14.2 12.1-21.9 18.2c-4.7 3.7-9.6 7.5-14.5 11.4l0 0 0 0c-18.9 14.8-39.4 30.8-59.8 49.7C76.5 208.9 32 269 32 352H416zM168.4 86.2C181.3 76 192.9 67 202.2 58.7c11.3-10 19.2-18.8 21.8-26.7c2.6 7.9 10.5 16.7 21.8 26.7c9.3 8.2 20.9 17.3 33.8 27.4C346.3 138.2 448 217.7 448 352v32 32l-64 64H64L0 416V384 352C0 217.7 101.7 138.2 168.4 86.2z'
      
    ]
  };

  

  
  

  var faTape = {
    prefix: 'fasl',
    iconName: 'tape',
    icon: [
      576,
      512,
      [],
      'f4db',
      
      'M224 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zM339.4 448C404.5 408.8 448 337.5 448 256C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480H560h16V448H560 339.4zM224 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192z'
      
    ]
  };

  

  
  

  var faBasketShopping = {
    prefix: 'fasl',
    iconName: 'basket-shopping',
    icon: [
      576,
      512,
      ["shopping-basket"],
      'f291',
      
      'M253.8 17.9l-7.9 13.9L155.4 192H420.6L330.1 31.9l-7.9-13.9L350.1 2.2l7.9 13.9L457.3 192H511h33 32v32H536L464 512H112L40 224H0V192H32 65h53.7L218.1 16.1l7.9-13.9 27.9 15.7zM73 224l64 256H439l64-256H73zm151 80v96 16H192V400 304 288h32v16zm80-16v16 96 16H272V400 304 288h32zm80 16v96 16H352V400 304 288h32v16z'
      
    ]
  };

  
    var faShoppingBasket = faBasketShopping;
  

  
  

  var faHouseMedicalFlag = {
    prefix: 'fasl',
    iconName: 'house-medical-flag',
    icon: [
      640,
      512,
      [],
      'e514',
      
      'M480 16V32H608h32V64v96 32H608 480V512H448V192 160 64 32 16 0h32V16zM608 160V64H480v96H608zM281.6 35.2L416 136v40L272 68 96 200V480l312 0c2.7 0 5.4-.3 8-.8v32.4c-2.6 .3-5.3 .4-8 .4L80 512H64V496 224L25.6 252.8 6.4 227.2l256-192L272 28l9.6 7.2zM240 176h64 16v16 48h48 16v16 64 16H368 320v48 16H304 240 224V384 336H176 160V320 256 240h16 48V192 176h16zm16 80v16H240 192v32h48 16v16 48h32V320 304h16 48V272H304 288V256 208H256v48z'
      
    ]
  };

  

  
  

  var faMobileButton = {
    prefix: 'fasl',
    iconName: 'mobile-button',
    icon: [
      384,
      512,
      [],
      'f10b',
      
      'M64 32V480H320V32H64zM32 0H64 320h32V32 480v32H320 64 32V480 32 0zM192 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faTerminal = {
    prefix: 'fasl',
    iconName: 'terminal',
    icon: [
      576,
      512,
      [],
      'f120',
      
      'M12.9 67.5L1.4 56.4 23.6 33.4 35.1 44.5l208 200 12 11.5-12 11.5-208 200L23.6 478.6 1.4 455.6l11.5-11.1L208.9 256 12.9 67.5zM240 448H560h16v32H560 240 224V448h16z'
      
    ]
  };

  

  
  

  var faCircleSortUp = {
    prefix: 'fasl',
    iconName: 'circle-sort-up',
    icon: [
      512,
      512,
      ["sort-circle-up"],
      'e032',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176-32H144V192L256 96l112 96v32H336 176zm142.8-32L256 138.1 193.2 192H318.8zM244.7 403.3l-88-88L145.4 304 168 281.4l11.3 11.3L256 369.4l76.7-76.7L344 281.4 366.6 304l-11.3 11.3-88 88L256 414.6l-11.3-11.3z'
      
    ]
  };

  
    var faSortCircleUp = faCircleSortUp;
  

  
  

  var faBanSmoking = {
    prefix: 'fasl',
    iconName: 'ban-smoking',
    icon: [
      512,
      512,
      [128685,"smoking-ban"],
      'f54d',
      
      'M86.7 109.3L201.4 224l32 32 32 32 32 32L402.7 425.3C363.4 459.4 312.1 480 256 480C132.3 480 32 379.7 32 256c0-56.1 20.6-107.4 54.7-146.7zM278.6 256H384v32H310.6l-32-32zm64 64H400h16V304 240 224H400 246.6L109.3 86.7C148.6 52.6 199.9 32 256 32c123.7 0 224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7L342.6 320zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM288 96H256v16c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16v16h32V176c0-26.5-21.5-48-48-48H304c-8.8 0-16-7.2-16-16V96zM220.1 288H128V256h60.1l-32-32H112 96v16 64 16h16H252.1l-32-32z'
      
    ]
  };

  
    var faSmokingBan = faBanSmoking;
  

  
  

  var faCartFlatbed = {
    prefix: 'fasl',
    iconName: 'cart-flatbed',
    icon: [
      640,
      512,
      ["dolly-flatbed"],
      'f474',
      
      'M0 0H16h96 16V16 384h96H512 624h16v32H624 567.4c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H279.4c5.4 9.4 8.6 20.3 8.6 32c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H112 96V400 32H16 0V0zM512 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM320 64H224V288H576V64H480V170.7 208l-32-19.2L400 160l-48 28.8L320 208V170.7 64zm0-32h32 96 32 96 32V64 288v32H576 224 192V288 64 32h32 96zm32 32v87.5l31.5-18.9 16.5-9.9 16.5 9.9L448 151.5V64H352z'
      
    ]
  };

  
    var faDollyFlatbed = faCartFlatbed;
  

  
  

  var faCircleR = {
    prefix: 'fasl',
    iconName: 'circle-r',
    icon: [
      512,
      512,
      [],
      'e120',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128v16V272v96 16h32V368 288h71l58.7 96h37.5L297.9 283.7C329.4 272.9 352 243.1 352 208c0-44.2-35.8-80-80-80H176 160zm32 128V160h80c26.5 0 48 21.5 48 48s-21.5 48-48 48H192z'
      
    ]
  };

  

  
  

  var faArrowUpRight = {
    prefix: 'fasl',
    iconName: 'arrow-up-right',
    icon: [
      384,
      512,
      [],
      'e09f',
      
      'M336 96h16v16V336v16H320V336 150.6L67.3 403.3 56 414.6 33.4 392l11.3-11.3L297.4 128H112 96V96h16H336z'
      
    ]
  };

  

  
  

  var faDolphin = {
    prefix: 'fasl',
    iconName: 'dolphin',
    icon: [
      512,
      512,
      [],
      'e168',
      
      'M32 144C32 64.5 96.5 0 176 0h49.1c43.3 0 84.4 9.6 121.3 26.8L452.6 3.6 460 1.9l6 4.8 16 12.8 9.8 7.8-5.2 11.4-33.9 73.4c37.2 48.4 59.4 109 59.4 174.8c0 89-72.1 161.1-161.1 161.1H320 273.6L248 512H178.5 144l12.8-32L176 432l-19.2-48L144 352h34.5H248l25.6 64H320c35.3 0 64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V352v16H336 298h-6.5l-4.7-4.6-77-75.4H176 40 16 0V272 248 232 218.2 209l7.9-4.6 11.9-6.9 8.1 13.8-8.1-13.8 9.2-5.4 9.3-5.4C34.2 173.1 32 158.8 32 144zM398.8 406.8c47.6-19 81.2-65.6 81.2-119.9c0-61.7-21.9-118.2-58.4-162.3l-6.4-7.8 4.2-9.1 32.8-71-.3-.2L347.9 59.3l-5.5 1.2-5-2.5c-33.9-16.6-72-26-112.3-26H176C114.1 32 64 82.1 64 144c0 15.5 3.1 30.1 8.8 43.5l5.5 13-12.1 7.1L36 225.1l-4 2.3V232v16 8h8H176h40 .3 6.5l4.7 4.6 77 75.4H320V273.6 254l19.2 3.9C383 266.8 416 305.5 416 352c0 20.4-6.3 39.3-17.2 54.8zM210.5 432l-4.8 11.9L191.3 480h35.1l19.2-48-19.2-48H191.3l14.4 36.1 4.8 11.9zM152 128a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faArrowsToLine = {
    prefix: 'fasl',
    iconName: 'arrows-to-line',
    icon: [
      448,
      512,
      [],
      'e0a7',
      
      'M224 198.6l11.3-11.3 80-80L326.6 96 304 73.4 292.7 84.7 240 137.4 240 16V0H208V16l0 121.4L155.3 84.7 144 73.4 121.4 96l11.3 11.3 80 80L224 198.6zM0 240v32H16 432h16V240H432 16 0zm235.3 84.7L224 313.4l-11.3 11.3-80 80L121.4 416 144 438.6l11.3-11.3L208 374.6V496v16h32V496 374.6l52.7 52.7L304 438.6 326.6 416l-11.3-11.3-80-80z'
      
    ]
  };

  

  
  

  var faFaucetDrip = {
    prefix: 'fasl',
    iconName: 'faucet-drip',
    icon: [
      512,
      512,
      [128688],
      'e006',
      
      'M240 16V0H208V16 32H80 64V64H80 208v48H176h-6.6l-4.7 4.7L121.4 160H16 0v32H16 128h6.6l4.7-4.7L182.6 144H208h32 25.4l43.3 43.3 4.7 4.7H320h48c61.9 0 112 50.1 112 112v16H416V304c0-26.5-21.5-48-48-48H307.2h-9.2l-4.6 8c-13.9 24-39.7 40-69.3 40s-55.5-16.1-69.3-40l-4.6-8h-9.2H16 0v32H16 132.1c20.2 29 53.8 48 91.9 48s71.7-19 91.9-48H368c8.8 0 16 7.2 16 16v32 16h16 96 16V336 304c0-79.5-64.5-144-144-144H326.6l-43.3-43.3-4.7-4.7H272 240V64H368h16V32H368 240V16zM448 437.3l12.8 17.1c2.1 2.8 3.2 6.1 3.2 9.6c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-3.5 1.1-6.8 3.2-9.6L448 437.3zm-20-26.7l-18.4 24.5c-6.2 8.3-9.6 18.4-9.6 28.8c0 26.5 21.5 48 48 48s48-21.5 48-48c0-10.4-3.4-20.5-9.6-28.8L468 410.7 448 384l-20 26.7z'
      
    ]
  };

  

  
  

  var faBarsProgress = {
    prefix: 'fasl',
    iconName: 'bars-progress',
    icon: [
      512,
      512,
      ["tasks-alt"],
      'f828',
      
      'M480 96v96H320V96H480zM32 96H288v96H32V96zm0-32H0V96v96 32H32 480h32V192 96 64H480 32zM480 320v96H192V320H480zM32 320H160v96H32V320zm0-32H0v32 96 32H32 480h32V416 320 288H480 32z'
      
    ]
  };

  
    var faTasksAlt = faBarsProgress;
  

  
  

  var faNfcSymbol = {
    prefix: 'fasl',
    iconName: 'nfc-symbol',
    icon: [
      512,
      512,
      [],
      'e531',
      
      'M145.8 40.1l-8.7-8.1L126.8 38C51.2 81.8 0 161.9 0 256c0 90.9 47.8 170.3 119.5 215.2l13.6 8.5 17-27.1L136.5 444C73.7 404.7 32 335.4 32 256c0-77.7 40-144.7 100.9-184.2L309.1 235.7l11.7 10.9 21.8-23.4-11.7-10.9L145.8 40.1zM367.3 472.2l8.7 8 10.2-5.9C461.9 430.5 513.1 350 513.1 256c0-91.4-48.4-170.5-120.6-215.2l-13.6-8.4L362 59.6 375.6 68C439 107.2 481.1 176.3 481.1 256c0 77.8-40 145-100.9 184.5L202.9 276.3l-11.7-10.9-21.7 23.5 11.7 10.9L367.3 472.2z'
      
    ]
  };

  

  
  

  var faSquareChevronUp = {
    prefix: 'fasl',
    iconName: 'square-chevron-up',
    icon: [
      448,
      512,
      ["chevron-square-up"],
      'f32c',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM235.3 164.7l112 112L358.6 288 336 310.6l-11.3-11.3L224 198.6 123.3 299.3 112 310.6 89.4 288l11.3-11.3 112-112L224 153.4l11.3 11.3z'
      
    ]
  };

  
    var faChevronSquareUp = faSquareChevronUp;
  

  
  

  var faHouseSignal = {
    prefix: 'fasl',
    iconName: 'house-signal',
    icon: [
      576,
      512,
      [],
      'e012',
      
      'M336 0l10.1 8.2 216 176 12.4 10.1-20.2 24.8L541.9 209 512 184.7v212 16H496 271.6c-3.9-11-8.4-21.7-13.5-32H480v-222L336 41.3 192 158.6V294c-10.1-9-20.7-17.3-32-24.8V184.7L130.1 209l-12.4 10.1L97.5 194.3l12.4-10.1 216-176L336 0zM288 172.6h96 16v16 96 16H384 288 272v-16-96-16h16zm16 96h64v-64H304v64zM0 284.6v-32c141.4 0 256 114.6 256 256H224c0-123.7-100.3-224-224-224zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 64c0-70.7-57.3-128-128-128v-32c88.4 0 160 71.6 160 160H128z'
      
    ]
  };

  

  
  

  var faFaceRaisedEyebrow = {
    prefix: 'fasl',
    iconName: 'face-raised-eyebrow',
    icon: [
      512,
      512,
      [],
      'e388',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200.4 240a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm29.4-118.5l4.9 7.4 8.9 13.3 26.6-17.8-8.9-13.3-4.9-7.4c-19.6-29.4-61.2-33.5-86.2-8.5l-29.5 29.5L265.4 160 288 182.6l11.3-11.3 29.5-29.5c10.7-10.7 28.5-8.9 36.9 3.7zM112 144v32h16 64 16V144H192 128 112zm64 192H160v32h16H336h16V336H336 176z'
      
    ]
  };

  

  
  

  var faFaceZipper = {
    prefix: 'fasl',
    iconName: 'face-zipper',
    icon: [
      512,
      512,
      [],
      'e3a5',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 29.1-5.6 57-15.7 82.5L493 352.9c12.2-29.9 19-62.6 19-96.9C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c34.3 0 67-6.7 96.9-19l-14.4-28.7C313 474.4 285.1 480 256 480C132.3 480 32 379.7 32 256zm144.4-24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm160 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm54.8 105.7l-10.3-5.2-8.2 8.2-32 32-8.2 8.2 5.2 10.3 56 112 4.4 8.8H408h40 6.6l4.7-4.7 48-48 4.7-4.7V448 408v-9.9l-8.8-4.4-112-56zm-19.7 49.5l15.7-15.7L480 417.9v23.5L441.4 480H417.9l-46.4-92.8zM224 320H192v16 32 16h32V368 336 320zm64 16V320H256v16 32 16h32V368 336zM160 320H128v16 32 16h32V368 336 320zM448.5 432.5L457 424l-17-17-8.5 8.5-16 16L407 440l17 17 8.5-8.5 16-16z'
      
    ]
  };

  

  
  

  var faCardDiamond = {
    prefix: 'fasl',
    iconName: 'card-diamond',
    icon: [
      384,
      512,
      [],
      'e3ea',
      
      'M32 32V480H352V32H32zM0 0H32 352h32V32 480v32H352 32 0V480 32 0zM203.3 148.7l96 96L310.6 256l-11.3 11.3-96 96L192 374.6l-11.3-11.3-96-96L73.4 256l11.3-11.3 96-96L192 137.4l11.3 11.3zM192 329.4L265.4 256 192 182.6 118.6 256 192 329.4z'
      
    ]
  };

  

  
  

  var faSquareParking = {
    prefix: 'fasl',
    iconName: 'square-parking',
    icon: [
      448,
      512,
      [127359,"parking"],
      'f540',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm160 96h96c53 0 96 43 96 96s-43 96-96 96H176v48 16H144V368 304 144 128h16zm96 160c35.3 0 64-28.7 64-64s-28.7-64-64-64H176V288h80z'
      
    ]
  };

  
    var faParking = faSquareParking;
  

  
  

  var faUserRobot = {
    prefix: 'fasl',
    iconName: 'user-robot',
    icon: [
      448,
      512,
      [],
      'e04b',
      
      'M240 16V0H208V16 64H96 64V96 288v32H96 352h32V288 96 64H352 240V16zM96 96H352V288H304V240H272v48H240V240H208v48H176V240H144v48H96V96zM32 128H0V256H32V128zm416 0H416V256h32V128zM160 176a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-48-16a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm192 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-48a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM272 448v32H240V448h32zm32 32V448h32v32H304zm64 0V448 416H336 288 224 112 80v32 32H43l28.8-96H376.2L405 480H368zm-256 0V448h32v32H112zm64 0V448h32v32H176zM80 512h32 48 64 64 48 32 46.6H448l-9.6-32L400 352H48L9.6 480 0 512H33.4 80z'
      
    ]
  };

  

  
  

  var faFaceMehBlank = {
    prefix: 'fasl',
    iconName: 'face-meh-blank',
    icon: [
      512,
      512,
      [128566,"meh-blank"],
      'f5a4',
      
      'M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faMehBlank = faFaceMehBlank;
  

  
  

  var faForwardFast = {
    prefix: 'fasl',
    iconName: 'forward-fast',
    icon: [
      512,
      512,
      [9197,"fast-forward"],
      'f050',
      
      'M480 64V80 218L288 86 256 64v38.8V240L32 86 0 64v38.8V409.2 448l32-22L256 272V409.2 448l32-22L480 294V432v16h32V432 272 240 80 64H480zM288 124.8L478.8 256 288 387.2V124.8zM222.8 256L32 387.2V124.8L222.8 256z'
      
    ]
  };

  
    var faFastForward = faForwardFast;
  

  
  

  var faWineGlass = {
    prefix: 'fasl',
    iconName: 'wine-glass',
    icon: [
      320,
      512,
      [127863],
      'f4e3',
      
      'M49.6 160l-3.2 35.6C40.3 262.4 92.9 320 160 320s119.7-57.6 113.6-124.4L270.4 160H49.6zm2.9-32h215l-8.7-96H61.2l-8.7 96zm253 64.7c7.3 80.2-51.4 150-129.5 158.5V480h64 16v32H240 160 80 64V480H80h64V351.1C65.9 342.7 7.2 272.8 14.5 192.7L32 0H288l17.5 192.7z'
      
    ]
  };

  

  
  

  var faTags = {
    prefix: 'fasl',
    iconName: 'tags',
    icon: [
      512,
      512,
      [],
      'f02c',
      
      'M32 242.7l192 192 160-160V237.3L210.7 64H32V242.7zM224 32L416 224v64L246.6 457.4 224 480l-22.6-22.6L0 256V64 32H32 224zM88 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM355.3 44.7L505.6 194.9l4.7 4.7v6.6 99.5 6.6l-4.7 4.7L355.3 467.3 344 478.6 321.4 456l11.3-11.3L478.2 299.1V212.9L332.7 67.3 321.4 56 344 33.4l11.3 11.3z'
      
    ]
  };

  

  
  

  var faArrowTurnRight = {
    prefix: 'fasl',
    iconName: 'arrow-turn-right',
    icon: [
      512,
      512,
      [],
      'e635',
      
      'M379.3 363.3L368 374.6 345.4 352l11.3-11.3L457.4 240H32V464v16H0V464 224 208H16 457.4L356.7 107.3 345.4 96 368 73.4l11.3 11.3 128 128L518.6 224l-11.3 11.3-128 128z'
      
    ]
  };

  

  
  

  var faHeadSideMedical = {
    prefix: 'fasl',
    iconName: 'head-side-medical',
    icon: [
      512,
      512,
      [],
      'f809',
      
      'M32 224C32 118 118 32 224 32h24c88.4 0 160 71.6 160 160v7.2l5.4 4.8L480 263.2V304H432 416v16 96H304 288v16 64 16h32V496 448H432h16V432 336h48 16V320 256v-7.2l-5.4-4.8-66.8-59.3C436 82 351.6 0 248 0H224C100.3 0 0 100.3 0 224c0 61 24.4 116.4 64 156.8V496v16H96V496 374.1v-6.8l-4.9-4.7C54.6 327.6 32 278.4 32 224zM208 96H192v16 48H144 128v16 64 16h16 48v48 16h16 64 16V304 256h48 16V240 176 160H336 288V112 96H272 208zm16 80V128h32v48 16h16 48v32H272 256v16 48H224V240 224H208 160V192h48 16V176z'
      
    ]
  };

  

  
  

  var faFileCircleMinus = {
    prefix: 'fasl',
    iconName: 'file-circle-minus',
    icon: [
      576,
      512,
      [],
      'e4ed',
      
      'M352 192v19.2c10.1-5.2 20.8-9.4 32-12.6V152L232 0H32 0V32 480v32H32 330.8c-12.9-9.1-24.5-19.9-34.6-32H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm80-128V352H496 368 352v32h16H496h16z'
      
    ]
  };

  

  
  

  var faUserTieHairLong = {
    prefix: 'fasl',
    iconName: 'user-tie-hair-long',
    icon: [
      448,
      512,
      [],
      'e460',
      
      'M224 240c-53 0-96-43-96-96V128l88 0h8l4.8-6.4 16-21.3 20.1 10 3.4 1.7H272h46.7c.9 5.2 1.3 10.5 1.3 16v16c0 53-43 96-96 96zM275.8 80L247.2 65.7l-11.9-6-8 10.7L208 96H133.5c13.2-37.3 48.7-64 90.5-64c35.5 0 66.6 19.3 83.2 48H275.8zM351 112C343.1 48.9 289.3 0 224 0S104.9 48.9 97 112H96v16 16 40L38.4 227.2 32 232v8 32 16H48h80 16V256H128 64v-8l50.4-37.8C136.8 247.2 177.5 272 224 272s87.2-24.8 109.6-61.8L384 248v8H320 304v32h16 80 16V272 240v-8l-6.4-4.8L352 184V144 128 112h-1zM33.7 512H204.2h39.6H414.3 448l-10.7-32L384 320H304l-37.9 75.8L246.2 336H256h16V304H256 224 192 176v32h16 9.8l-19.9 59.8L144 320H64L10.7 480 0 512H33.7zm168.4-75.8L224 370.6l21.9 65.6-4 8L224 480l0 0 0 0-17.9-35.8-4-8zM259.8 480l64-128h37.2l42.7 128H259.8zm-71.6 0H44.4L87.1 352h37.2l64 128z'
      
    ]
  };

  

  
  

  var faTeethOpen = {
    prefix: 'fasl',
    iconName: 'teeth-open',
    icon: [
      576,
      512,
      [],
      'f62f',
      
      'M32 64H544V224H512V192c0-35.3-28.7-64-64-64c-14 0-27 4.5-37.6 12.2C399.5 114.2 373.9 96 344 96c-22.6 0-42.8 10.4-56 26.7C274.8 106.4 254.6 96 232 96c-29.9 0-55.5 18.2-66.4 44.2C155 132.5 142 128 128 128c-35.3 0-64 28.7-64 64v32H32V64zM416 224V192c0-17.7 14.3-32 32-32s32 14.3 32 32v32H416zm-112 0V168c0-22.1 17.9-40 40-40s40 17.9 40 40v24 32H304zm-72-96c22.1 0 40 17.9 40 40v56H192V192 168c0-22.1 17.9-40 40-40zM176 256H288 400h96 48 32V224 64 32H544 32 0V64 224v32H32 80h96zm-16-64v32H96V192c0-17.7 14.3-32 32-32s32 14.3 32 32zM544 320V448H32V320H64v32c0 35.3 28.7 64 64 64c16.8 0 32-6.5 43.5-17c12.8 19.9 35.1 33 60.5 33c22.6 0 42.8-10.4 56-26.7c13.2 16.3 33.4 26.7 56 26.7c25.4 0 47.7-13.2 60.5-33c11.4 10.6 26.7 17 43.5 17c35.3 0 64-28.7 64-64V320h32zM272 360c0 22.1-17.9 40-40 40s-40-17.9-40-40v-8V320h80v40zm16-72H176 80 32 0v32V448v32H32 544h32V448 320 288H544 496 400 288zm128 32h64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V320zm-32 32v8c0 22.1-17.9 40-40 40s-40-17.9-40-40V320h80v32zm-224 0c0 17.7-14.3 32-32 32s-32-14.3-32-32V320h64v32z'
      
    ]
  };

  

  
  

  var faCommentMedical = {
    prefix: 'fasl',
    iconName: 'comment-medical',
    icon: [
      512,
      512,
      [],
      'f7f5',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM224 128H208v16 48H160 144v16 64 16h16 48v48 16h16 64 16V336 288h48 16V272 208 192H352 304V144 128H288 224zm16 80V160h32v48 16h16 48v32H288 272v16 48H240V272 256H224 176V224h48 16V208z'
      
    ]
  };

  

  
  

  var faPanorama = {
    prefix: 'fasl',
    iconName: 'panorama',
    icon: [
      640,
      512,
      [],
      'e209',
      
      'M0 64V32H32 53.5C138.3 62.3 230.5 72 320 72s181.7-9.7 266.5-40H608h32V64 448v32H608 586.5c-84.8-30.3-176.9-40-266.5-40c-79.2 0-160.4 7.6-236.7 30.3l-.1 .1-.1-.1c-9.9 3-19.8 6.2-29.6 9.7H32 0V448 64zM114.2 429.1c27.3-6.3 55-10.9 82.7-14.2L260 330.7l-36-48L114.2 429.1zm125.7-18.3c26.9-1.9 53.7-2.8 80.1-2.8c74.1 0 151.3 6.5 225.4 25.9L384 218.7 292.8 340.3l-52.9 70.5zM596 448h12V64H591.9C504 94.5 409.8 104 320 104s-184-9.5-271.9-40H32V448H48.1c5.3-1.8 10.6-3.6 15.9-5.2l3.3-4.4 144-192L224 229.3l12.8 17.1L280 304l91.2-121.6L384 165.3l12.8 17.1 192 256L596 448zM112 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faClipboardQuestion = {
    prefix: 'fasl',
    iconName: 'clipboard-question',
    icon: [
      384,
      512,
      [],
      'e4e3',
      
      'M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36l3.1 12H254h34v48H192 96V80h34 12.4l3.1-12zM192 0c-32.8 0-61 19.8-73.3 48H80 64V64 80H32 0v32V480v32H32 352h32V480 112 80H352 320V64 48H304 265.3C253 19.8 224.8 0 192 0zM320 144V112h32V480H32V112H64v32 16H80 192 304h16V144zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM104 248v8h32v-8c0-13.3 10.7-24 24-24h56c17.6 0 32 14.5 32 32.3c0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4-8.7 4.5v9.8V336v16h32V336v-3.7l37.1-18.9c21.5-11 34.9-33.2 34.9-57.2c0-35.2-28.5-64.3-64-64.3H160c-30.9 0-56 25.1-56 56zm64 136v48h48V384H168z'
      
    ]
  };

  

  
  

  var faCartCircleCheck = {
    prefix: 'fasl',
    iconName: 'cart-circle-check',
    icon: [
      640,
      512,
      [],
      'e3f1',
      
      'M16 0H0V32H16 67.2l77.2 339.5 2.8 12.5H160 320.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32H151L107.3 64H532.5l-40 128c1.2 0 2.4 0 3.5 0c10 0 19.7 .8 29.2 2.4L566 64l10-32H542.5 100L95.6 12.5 92.8 0H80 16zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm78.6-176L552 313.4l-11.3 11.3L480 385.4l-28.7-28.7L440 345.4 417.4 368l11.3 11.3 40 40L480 430.6l11.3-11.3 72-72L574.6 336z'
      
    ]
  };

  

  
  

  var faRoute = {
    prefix: 'fasl',
    iconName: 'route',
    icon: [
      512,
      512,
      [],
      'f4d7',
      
      'M468.4 133.7c-7.8 15.7-18.6 32-30 47.1c-7.7 10.3-15.5 19.8-22.4 27.8c-6.9-8-14.7-17.5-22.4-27.8c-11.4-15.1-22.1-31.4-30-47.1C355.5 117.5 352 104.7 352 96c0-35.3 28.7-64 64-64s64 28.7 64 64c0 8.7-3.5 21.5-11.6 37.7zm-30.7 98.7C466 199.9 512 140.3 512 96c0-53-43-96-96-96s-96 43-96 96c0 40.7 38.8 94.3 67.1 128H272 256v16V368v16h16H480v96H166c-9.4 12.3-18.6 23.2-26.4 32H496h16V496 368 352H496 288V256H416s9.1-9.1 21.7-23.6zM148.4 389.7c-7.8 15.7-18.6 32-30 47.1c-7.7 10.3-15.5 19.8-22.4 27.8c-6.9-8-14.7-17.5-22.4-27.8c-11.3-15.1-22.1-31.4-30-47.1C35.5 373.5 32 360.7 32 352c0-35.3 28.7-64 64-64s64 28.7 64 64c0 8.7-3.5 21.5-11.6 37.7zm-23.8 90.7C152.9 446.7 192 392.8 192 352c0-53-43-96-96-96s-96 43-96 96c0 44.3 46 103.9 74.3 136.4C86.9 502.9 96 512 96 512s6.5-6.5 16-17.2l0 0c1.8-2 3.7-4.1 5.6-6.4c2.2-2.5 4.5-5.2 6.9-8.1zM440 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM96 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faTruckField = {
    prefix: 'fasl',
    iconName: 'truck-field',
    icon: [
      640,
      512,
      [],
      'e58d',
      
      'M352 64V224v32 96H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H64V288 128 64H352zM32 288v64H16 0v32H16 32 64c0 53 43 96 96 96s96-43 96-96h96 32c0 53 43 96 96 96s96-43 96-96h32 16 16V352H624 608V256 224H576 537.4L469.9 104.2 465.4 96H456 384V64 32H352 64 32V64v64H0V288H32zm352-64V128h62.6l54 96H384zm0 128V256H527.7c.2 0 .4 0 .6 0H576v96h-5.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H384zM96 384a64 64 0 1 1 128 0A64 64 0 1 1 96 384zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faBasketShoppingPlus = {
    prefix: 'fasl',
    iconName: 'basket-shopping-plus',
    icon: [
      576,
      512,
      [],
      'e653',
      
      'M253.8 17.9l-7.9 13.9L155.4 192H420.6L330.1 31.9l-7.9-13.9L350.1 2.2l7.9 13.9L457.3 192H511h33 32v32H536L464 512H112L40 224H0V192H32 65h53.7L218.1 16.1l7.9-13.9 27.9 15.7zM503 224H73l64 256H439l64-256zM192 336h16 64V272 256h32v16 64h64 16v32H368 304v64 16H272V432 368H208 192V336z'
      
    ]
  };

  

  
  

  var faUserCrown = {
    prefix: 'fasl',
    iconName: 'user-crown',
    icon: [
      448,
      512,
      [],
      'f6a4',
      
      'M278.2 67.8L293 61.2l27-12V112H128V49.2l27 12 14.8 6.6 14.1-8L224 36.9l40.1 22.9 14.1 8zM320 144c0 53-43 96-96 96s-96-43-96-96H320zM96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128V128 35 0L320 14.2 280 32 224 0 168 32 128 14.2 96 0V35v93zM87.6 336H360.4l44.3 144H43.3L87.6 336zM384 304H64L9.8 480 0 512H33.5h381H448l-9.8-32L384 304z'
      
    ]
  };

  

  
  

  var faFaceClouds = {
    prefix: 'fasl',
    iconName: 'face-clouds',
    icon: [
      640,
      512,
      [],
      'e47d',
      
      'M136 0c20.3 0 38.6 8.4 51.6 21.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72v56 16H272 216h-8H80 64 16 0V144 96C0 60.7 28.7 32 64 32H76.1C89 12.7 111 0 136 0zM99.8 54.9L95.5 64H85.4 64C46.3 64 32 78.3 32 96v32H64 80 208h8 40V88c0-22.1-17.9-40-40-40c-8.7 0-16.6 2.7-23.2 7.4L179 65.3l-9-14.4C162.9 39.5 150.3 32 136 32c-15.9 0-29.7 9.3-36.2 22.9zM288.3 1.9C298.7 .7 309.3 0 320 0C461.4 0 576 114.6 576 256c0 7.3-.3 14.5-.9 21.7c-9.4-6-20-10.2-31.3-12.2c.1-3.1 .2-6.3 .2-9.4C544 132.3 443.7 32 320 32c-3.6 0-7.1 .1-10.7 .2C304 21 296.9 10.8 288.3 1.9zM224 458.4v34.9c-93.8-38-160-130-160-237.4c0-22.1 2.8-43.5 8.1-64h33.2c-6 20.3-9.3 41.8-9.3 64c0 89.4 52.3 166.5 128 202.4zM216.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM321.1 353.4c7-46.1 46.8-81.4 94.9-81.4c28.7 0 54.5 12.6 72 32.5c9.4-5.4 20.3-8.5 32-8.5c33.9 0 61.6 26.3 63.9 59.6C616.4 365.8 640 396.1 640 432v64 16H624 560 336 272 256V496 432c0-39.1 28-71.6 65.1-78.6zM416 304c-35.3 0-64 28.7-64 64v16H336c-26.5 0-48 21.5-48 48v48h48H560h48V432c0-24.7-18.6-45-42.5-47.7l-16.9-1.9 3-16.8c.3-1.8 .5-3.7 .5-5.6c0-17.7-14.3-32-32-32c-9.2 0-17.6 3.9-23.4 10.2L482 353.8l-10.9-18.4C459.9 316.6 439.4 304 416 304z'
      
    ]
  };

  

  
  

  var faAnchorCircleExclamation = {
    prefix: 'fasl',
    iconName: 'anchor-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e4ab',
      
      'M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64 78.4V160v32H208 192v32h16 64V480H96V310.6l28.7 28.7L136 350.6 158.6 328l-11.3-11.3-56-56L80 249.4 68.7 260.7l-56 56L1.4 328 24 350.6l11.3-11.3L64 310.6V496v16H80 288 394.8c-12.9-9.1-24.5-19.9-34.6-32H304V224h64 16V192H368 304V160v-1.6c36.5-7.4 64-39.7 64-78.4c0-44.2-35.8-80-80-80zm96 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 448V416H480v32h32zm0-160H480v16 80 16h32V384 304 288z'
      
    ]
  };

  

  
  

  var faFiles = {
    prefix: 'fasl',
    iconName: 'files',
    icon: [
      448,
      512,
      [],
      'e178',
      
      'M128 384V32H304v96 16h16 96V384H128zM336 57.5L390 112H336V57.5zM324 0H128 96V32 384v32h32H416h32V384 125L324 0zM32 112V96H0v16V496v16H16 336h16V480H336 32V112z'
      
    ]
  };

  

  
  

  var faCircleCaretLeft = {
    prefix: 'fasl',
    iconName: 'circle-caret-left',
    icon: [
      512,
      512,
      ["caret-circle-left"],
      'f32e',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM320 384l0-32 0-192 0-32-32 0-8 0L160 256 280 384l8 0 32 0zM203.9 256L288 166.3l0 179.5L203.9 256z'
      
    ]
  };

  
    var faCaretCircleLeft = faCircleCaretLeft;
  

  
  

  var faTrashXmark = {
    prefix: 'fasl',
    iconName: 'trash-xmark',
    icon: [
      448,
      512,
      [],
      'e2b4',
      
      'M160 0h-8.9l-4.7 7.5L111.1 64H64.1 32 0V96H34.3L64 512H384L413.7 96H448V64H416 383.9 336.9L301.6 7.5 296.9 0H288 160zM299.1 64H148.9l20-32H279.1l20 32zM93.8 480L66.4 96H381.6L354.2 480H93.8zm65.6-279.2l-22.6 22.6 11.3 11.3L201.4 288l-53.3 53.3-11.3 11.3 22.6 22.6 11.3-11.3L224 310.6l53.3 53.3 11.3 11.3 22.6-22.6-11.3-11.3L246.6 288l53.3-53.3 11.3-11.3-22.6-22.6-11.3 11.3L224 265.4l-53.3-53.3-11.3-11.3z'
      
    ]
  };

  

  
  

  var faCat = {
    prefix: 'fasl',
    iconName: 'cat',
    icon: [
      576,
      512,
      [128008],
      'f6be',
      
      'M336 0h24 6.6l4.7 4.7L414.6 48h34.7L492.7 4.7 497.4 0H504h24 16V16 144c0 61.9-50.1 112-112 112s-112-50.1-112-112V16 0h16zm16 144c0 44.2 35.8 80 80 80s80-35.8 80-80V32h-1.4L467.3 75.3 462.6 80H456 408h-6.6l-4.7-4.7L353.4 32H352V144zM128 299.2c33.8-61.5 92.1-108.2 162.9-126.2c2.2 10.6 5.5 20.9 9.9 30.5C200.2 228.2 128 318.7 128 424v56l48 0 128 0 0 0h48v-5.3c0-14.7-11.9-26.7-26.7-26.7H288 272V432 416 392c0-22.1-17.9-40-40-40h-8H208V320h16 8c39.8 0 72 32.2 72 72v7.3l118.2-91.9L448 287.3V320 480h32V279.8c11.4-4 22.1-9.4 32-16.1V496v16H496 432 416V496 352.7l-82.2 63.9c28.4 4.1 50.2 28.5 50.2 58.1V496v16H368l-64 0-128 0 0 0H112 96V496 424 176c0-26.5-21.5-48-48-48H32V96H48c44.2 0 80 35.8 80 80V299.2zM384 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faTruckFront = {
    prefix: 'fasl',
    iconName: 'truck-front',
    icon: [
      512,
      512,
      [],
      'e2b7',
      
      'M32 32V224H71.5l41.4-117.3L116.7 96H128 384h11.3l3.8 10.7L440.5 224H480V32H32zm0 224V416H64 448h32V256H32zM0 224V32 0H32 480h32V32 224v32V416v32H480v64H448V448H64v64H32V448H0V416 256 224zm105.4 0H406.6l-33.9-96H139.3l-33.9 96zM80 328a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faSquareQuarters = {
    prefix: 'fasl',
    iconName: 'square-quarters',
    icon: [
      448,
      512,
      [],
      'e44e',
      
      'M393.4 64H54.6L224 233.4 393.4 64zM32 86.6V425.4L201.4 256 32 86.6zM54.6 448H393.4L224 278.6 54.6 448zM416 425.4V86.6L246.6 256 416 425.4zM0 32H32 416h32V64 448v32H416 32 0V448 64 32z'
      
    ]
  };

  

  
  

  var faFileDoc = {
    prefix: 'fasl',
    iconName: 'file-doc',
    icon: [
      512,
      512,
      [],
      'e5ed',
      
      'M352 192v96h32V152L232 0H32 0V32 480v32H32 96V480H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM176 352H160v16V496v16h16 32c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H176zm16 128V384h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H192zM456 352c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-8V448H480v16 8c0 4.4-3.6 8-8 8H456c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v8 16h32V400v-8c0-22.1-17.9-40-40-40H456zM288 392v80c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faArrowDownFromDottedLine = {
    prefix: 'fasl',
    iconName: 'arrow-down-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e090',
      
      'M56 40V88H8V40H56zm96 0V88H104V40h48zm48 0h48V88H200V40zm144 0V88H296V40h48zm48 0h48V88H392V40zM235.3 467.3L224 478.6l-11.3-11.3-128-128L73.4 328 96 305.4l11.3 11.3L208 417.4V176 160h32v16V417.4L340.7 316.7 352 305.4 374.6 328l-11.3 11.3-128 128z'
      
    ]
  };

  

  
  

  var faPhoneFlip = {
    prefix: 'fasl',
    iconName: 'phone-flip',
    icon: [
      512,
      512,
      [128381,"phone-alt"],
      'f879',
      
      'M210.3 367.6l21.3-12.3c51.4-29.6 94.1-72.4 123.7-123.7l12.2-21.3-17.3-17.3-40.7-40.7L356 36.2 480 58.7l0 5.3c0 229.7-186.3 416-416 416H58.7L36.2 356l116.1-46.5L193 350.2l17.3 17.4zM160 272L0 336 32 512H64c247.4 0 448-200.6 448-448l0-32L336 0 272 160l55.6 55.6c-26.8 46.5-65.5 85.2-112 112L160 272z'
      
    ]
  };

  
    var faPhoneAlt = faPhoneFlip;
  

  
  

  var faBridge = {
    prefix: 'fasl',
    iconName: 'bridge',
    icon: [
      576,
      512,
      [],
      'e4c8',
      
      'M16 32H0V64H16 80v64H16 0v32H16 80h32 96 32 96 32 96 32 64 16V128H560 496V64h64 16V32H560 496 464 368 336 240 208 112 80 16zM464 64v64H368V64h96zM336 64v64H240V64h96zM208 64v64H112V64h96zM16 240H0v32H16 32c35.3 0 64 28.7 64 64V464v16h16 96 16V464 336c0-35.3 28.7-64 64-64s64 28.7 64 64V464v16h16 96 16V464 336c0-35.3 28.7-64 64-64h16 16V240H560 544c-53 0-96 43-96 96V448H384V336c0-53-43-96-96-96s-96 43-96 96V448H128V336c0-53-43-96-96-96H16z'
      
    ]
  };

  

  
  

  var faHatCowboy = {
    prefix: 'fasl',
    iconName: 'hat-cowboy',
    icon: [
      640,
      512,
      [],
      'f8c0',
      
      'M245.4 45.6L216 32l-8.8 31.2L151.7 260.6c9.5 3.4 19.7 6.6 30.5 9.6L236.6 76.8l69.9 32.3 13.4 6.2 13.4-6.2 69.9-32.3 54.4 193.5c10.9-3 21-6.2 30.5-9.6L432.8 63.2 424 32 394.6 45.6 320 80 245.4 45.6zM640 256l-4.7-6.2L616 224s-8.2 8.3-24.9 20.1C551 272.2 462.1 320 320 320s-231-47.8-271.1-75.9C32.2 232.3 24 224 24 224L4.7 249.8 0 256s96 192 320 192s320-192 320-192zm-82.3 44.7c7.6-3.7 14.6-7.5 21.1-11.1c-9.9 12.1-22 25.5-36.5 38.9C494.6 372.5 422 416 320 416s-174.6-43.5-222.3-87.5c-14.5-13.4-26.6-26.8-36.5-38.9c6.5 3.7 13.5 7.4 21.1 11.1C135.2 326.7 214 352 320 352s184.8-25.3 237.7-51.3z'
      
    ]
  };

  

  
  

  var faWarehouseFull = {
    prefix: 'fasl',
    iconName: 'warehouse-full',
    icon: [
      640,
      512,
      ["warehouse-alt"],
      'f495',
      
      'M320 6.8l5.9 2.3 304 120 10.1 4V144 496v16H608V496 154.9L320 41.2 32 154.9V496v16H0V496 144 133.1l10.1-4 304-120L320 6.8zM96 192h16H528h16v16V496v16H512V496 224H128V496v16H96V496 208 192zM352 368h32 64 32v32 80 32H448 192 160V480 288 256h32H320h32v32 48 32zm-32 32H192v80H320V400zm32 80h96V400H352v80zM320 368V288H192v80H320z'
      
    ]
  };

  
    var faWarehouseAlt = faWarehouseFull;
  

  
  

  var faCodeBranch = {
    prefix: 'fasl',
    iconName: 'code-branch',
    icon: [
      448,
      512,
      [],
      'f126',
      
      'M128 32v96H32V32h96zM32 0H0V32v96 32H32 64V352H32 0v32 96 32H32h96 32V480 384 352H128 96c0-44.2 35.8-80 80-80h96c61.9 0 112-50.1 112-112h32 32V128 32 0H416 320 288V32v96 32h32 32c0 44.2-35.8 80-80 80H176c-31.3 0-59.7 12.9-80 33.6V160h32 32V128 32 0H128 32zM384 128H352 320V32h96v96H384zM128 384v96H32V384h96z'
      
    ]
  };

  

  
  

  var faObjectSubtract = {
    prefix: 'fasl',
    iconName: 'object-subtract',
    icon: [
      512,
      512,
      [],
      'e49e',
      
      'M32 32l64 0V0H32 0V32 96H32l0-64zm192 0V0H128V32l96 0zM32 128H0v96H32l0-96zm0 128H0v64 32H32 96V320H32l0-64zm96 96h32l32 0h32V320H192 160 128v32zm32 32l0 96v32h32l288 0h32V480 192l0-32H480l-96 0v32l96 0 0 288-288 0 0-96H160zM352 192l0-32V128H320v32 32 32h32V192zm0-160V0H320 256V32l64 0V96h32V32zM256 320v32h64 32V320 256H320v64l-64 0z'
      
    ]
  };

  

  
  

  var faHouseWater = {
    prefix: 'fasl',
    iconName: 'house-water',
    icon: [
      576,
      512,
      ["house-flood"],
      'f74f',
      
      'M298.6 12L288 2.7 277.4 12 5.4 252l21.2 24L64 243V390.9c3.8-2.6 7.8-5.5 12.3-8.7l0 0 1.1-.8L96 368l0-153.3L288 45.3 480 214.7 480 368l19.7 14.2 0 0 0 0c4.4 3.2 8.5 6.1 12.2 8.7V243l37.4 33 21.2-24L298.6 12zM208 176v16V320v16h16H352h16V320 192 176H352 224 208zm32 32h96v96H240V208zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-14.6-10-26-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C41.7 470.1 20.9 480 0 480v32c30.3 0 57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C518.5 497.9 545.7 512 576 512V480c-20.9 0-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C425.6 470.1 404.9 480 384 480s-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C233.6 470.1 212.9 480 192 480z'
      
    ]
  };

  
    var faHouseFlood = faHouseWater;
  

  
  

  var faPopcorn = {
    prefix: 'fasl',
    iconName: 'popcorn',
    icon: [
      448,
      512,
      [127871],
      'f819',
      
      'M176.2 21.5C187.9 8.3 205 0 224 0s36.1 8.3 47.8 21.5C279.1 18 287.3 16 296 16c25.5 0 47 17 53.8 40.3C378 59.2 400 83 400 112c0 2.8-.2 5.5-.6 8.2c15 8.4 26.2 22.7 30.6 39.8H395.7c-4.2-7.3-11.3-12.8-19.7-15l-19-4.9 8.6-17.6c1.5-3.2 2.4-6.7 2.4-10.5c0-13.3-10.7-24-24-24c-1.7 0-3.3 .2-4.8 .5l-19.4 3.9 .2-19.8 0-.7C320 58.7 309.2 48 296 48c-6.7 0-12.7 2.7-17.1 7.1L262.7 71.5l-9.7-20.9C248 39.6 236.9 32 224 32s-24 7.6-29.1 18.6l-9.7 20.9L169.1 55.1C164.7 50.7 158.7 48 152 48c-13.2 0-24 10.7-24 23.9l0 .7 .2 19.8-19.4-3.9c-1.5-.3-3.2-.5-4.8-.5c-13.3 0-24 10.7-24 24c0 3.8 .9 7.3 2.4 10.5L91 140.1 72 145c-8.4 2.2-15.5 7.7-19.7 15H18c4.4-17 15.6-31.3 30.6-39.8c-.4-2.7-.6-5.4-.6-8.2c0-29 22-52.8 50.2-55.7C105 33 126.5 16 152 16c8.7 0 16.9 2 24.2 5.5zM105 480H343l64-256H349.9l-32 224H285.6l32-224H240V432v16H208V432 224H130.4l32 224H130.1l-32-224H41l64 256zm263 32H80L8 224 0 192H33 415h33l-8 32L368 512z'
      
    ]
  };

  

  
  

  var faFaceHandOverMouth = {
    prefix: 'fasl',
    iconName: 'face-hand-over-mouth',
    icon: [
      512,
      512,
      [129762],
      'e378',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 57.4-21.6 109.7-57 149.3l23.8 21.3C487.3 381.4 512 321.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 57.6 19.1 110.8 51.2 153.6l25.6-19.2C48.7 353 32 306.5 32 256zm144.4-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM328 257.4l9.4 9.4 3.9 3.9 9.4 9.4-11.3 11.3-4.7 4.7-6.6 6.6-4.7 4.7-33.4 33.4-22.6 22.6 9.4 9.4 22.6-22.6L321.4 328l11.3-11.3L344 305.4l13.3 13.3 9.4 9.4-9.4 9.4-1.9 1.9L344 350.6l-9.4 9.4-11.3 11.3-1.4 1.4-22.6 22.6 9.4 9.4L321.4 392l9.9-9.9 1.4-1.4L344 369.4l13.3 13.3 9.4 9.4-11.3 11.3L344 414.6l-12.7 12.7-22.6 22.6-2.2 2.2C288.7 470 264.4 480 239.2 480c-52.6 0-95.2-42.6-95.2-95.2V372 352 334.4v-12-20h8 21.7H176h8v20 12 3l6.1-6.1 8.9-8.9 13.7-13.7 3.3-3.3L257.4 264l11.3-11.3L280 241.4l9.4 9.4L302.6 264l-11.3 11.3L280 286.6l-22.1 22.1-22.6 22.6 9.4 9.4 22.6-22.6 33.4-33.4 4.7-4.7 6.6-6.6 4.7-4.7L328 257.4zm0-45.3l-16 16-9.4-9.4L280 196.1l-22.6 22.6-11.3 11.3-40.3 40.3H184 144 112v32 20V352v20 12.8C112 455.1 168.9 512 239.2 512c33.7 0 66.1-13.4 89.9-37.3l48.8-48.8 11.3-11.3L411.9 392l-22.6-22.6-9.4-9.4 9.4-9.4L411.9 328l-22.6-22.6-9.4-9.4 16-16-22.6-22.6-22.6-22.6L328 212.1z'
      
    ]
  };

  

  
  

  var faCircleK = {
    prefix: 'fasl',
    iconName: 'circle-k',
    icon: [
      512,
      512,
      [],
      'e113',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128v16V298.5 368v16h32V368 305.1l43.4-43.7L321.3 384h39.1l-102-145.7L368.1 128H322.9L192 259.7V144 128H160z'
      
    ]
  };

  

  
  

  var faArrowRightFromArc = {
    prefix: 'fasl',
    iconName: 'arrow-right-from-arc',
    icon: [
      512,
      512,
      [],
      'e4b1',
      
      'M32 256C32 132.3 132.3 32 256 32h16V0H256C114.6 0 0 114.6 0 256S114.6 512 256 512h16V480H256C132.3 480 32 379.7 32 256zM354.6 116l-12-10.6-21.3 23.9 12 10.6L445.9 240H176 160v32h16H445.9L333.4 372l-12 10.6 21.3 23.9 12-10.6 144-128 13.5-12-13.5-12-144-128z'
      
    ]
  };

  

  
  

  var faTypewriter = {
    prefix: 'fasl',
    iconName: 'typewriter',
    icon: [
      512,
      512,
      [],
      'f8e7',
      
      'M64 0V16 160H96V32H369.4L416 78.6V160h32V72 65.4l-4.7-4.7-56-56L382.6 0H376 80 64zM333.3 256l9.4-9.4L365.3 224H480v64H448 64 32V224H146.7l22.6 22.6 9.4 9.4H192 320h13.3zM480 320h32V288 224 192H480 352l-32 32H192l-32-32H32 0v32 64 32H32V480v32H64 448h32V480 320zm-32 0V480H64V320H448zM160 416H144v32h16H352h16V416H352 160zm-48-64v32h32V352H112zm96 32V352H176v32h32zm32-32v32h32V352H240zm96 32V352H304v32h32zm32-32v32h32V352H368z'
      
    ]
  };

  

  
  

  var faCanFood = {
    prefix: 'fasl',
    iconName: 'can-food',
    icon: [
      384,
      512,
      [129387],
      'e3e6',
      
      'M328.4 445.3c-6.1 5.8-15.9 11.8-29.2 17.1C272.6 473.1 234.7 480 192 480s-80.6-6.9-107.2-17.6c-13.4-5.3-23.1-11.3-29.2-17.1C49.5 439.5 48 435 48 432V285.6c12.8 6.5 27.7 11.9 43.7 16.2c6.5 1.7 13.3 3.3 20.3 4.7V352v32h32 96 32V352 306.4c7-1.4 13.8-3 20.3-4.7c16-4.3 30.8-9.7 43.7-16.2V432c0 3-1.5 7.5-7.6 13.3zM112 273.7c-4.1-.9-8.2-1.9-12.1-2.9c-22.7-6.1-40.3-14-51.9-22.5V127.6c7.4 4.7 15.9 8.9 24.9 12.5C104.2 152.6 146.3 160 192 160s87.8-7.4 119.1-19.9c9.1-3.6 17.5-7.8 24.9-12.5V248.3c-11.7 8.5-29.3 16.4-51.9 22.5c-3.9 1-7.9 2-12.1 2.9V256 224H240 144 112v32 17.7zM368 432V80 72c0-39.8-78.8-72-176-72S16 32.2 16 72v8V432v8c0 39.8 78.8 72 176 72s176-32.2 176-72v-8zM55.6 93.3C49.5 87.5 48 83 48 80s1.5-7.5 7.6-13.3c6.1-5.8 15.9-11.8 29.2-17.1C111.4 38.9 149.3 32 192 32s80.6 6.9 107.2 17.6c13.4 5.3 23.1 11.3 29.2 17.1C334.5 72.5 336 77 336 80s-1.5 7.5-7.6 13.3c-6.1 5.8-15.9 11.8-29.2 17.1C272.6 121.1 234.7 128 192 128s-80.6-6.9-107.2-17.6c-13.4-5.3-23.1-11.3-29.2-17.1zM144 352V256h96v96H144z'
      
    ]
  };

  

  
  

  var faBorderCenterH = {
    prefix: 'fasl',
    iconName: 'border-center-h',
    icon: [
      448,
      512,
      [],
      'f89c',
      
      'M432 240L16 240 0 240l0 32 16 0 416 0 16 0 0-32-16 0zM8 88l48 0 0-48L8 40 8 88zM8 472l48 0 0-48L8 424l0 48zM104 88l48 0 0-48-48 0 0 48zm0 384l48 0 0-48-48 0 0 48zm192-48l0 48 48 0 0-48-48 0zm0-336l48 0 0-48-48 0 0 48zM200 424l0 48 48 0 0-48-48 0zm0-336l48 0 0-48-48 0 0 48zM392 424l0 48 48 0 0-48-48 0zm0-384l0 48 48 0 0-48-48 0zM200 328l0 48 48 0 0-48-48 0zm192 48l48 0 0-48-48 0 0 48zM8 328l0 48 48 0 0-48L8 328zM392 184l48 0 0-48-48 0 0 48zM8 136l0 48 48 0 0-48L8 136zm192 48l48 0 0-48-48 0 0 48z'
      
    ]
  };

  

  
  

  var faBookBookmark = {
    prefix: 'fasl',
    iconName: 'book-bookmark',
    icon: [
      448,
      512,
      [],
      'e0bb',
      
      'M0 64C0 28.7 28.7 0 64 0h96 16H336h16 80 16V16 400v16H432 416v64h16 16v32H432 64c-35.3 0-64-28.7-64-64l0 0L0 64zM320 32H192V206.7l54-43.2 10-8 10 8 54 43.2V32zM160 32H64C46.3 32 32 46.3 32 64l0 328.6c9.4-5.4 20.3-8.6 32-8.6H416V32H352V240v33.3l-26-20.8-70-56-70 56-26 20.8V240 32zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64z'
      
    ]
  };

  

  
  

  var faHandshakeSlash = {
    prefix: 'fasl',
    iconName: 'handshake-slash',
    icon: [
      640,
      512,
      [],
      'e060',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM626 416h14V384 160 128H608 560 528v32V338.7l32 25.3V160h48v96V384v17.8L626 416zM372.1 378.7l-46.7 46.6-26.6-26.6-11.3-11.3-11.3 11.3-29 29-32.6-32.6-11.3-11.3-7-7-52-52.1-4.7-4.7h-6.6H112V173.3L54.6 128H32 0v32V384v32H32 80h32V384 352h14.3l47.4 47.4 7 7L192 417.7l43.9 43.9 11.3 11.3 11.3-11.3 29-29 26.6 26.6 11.3 11.3 11.3-11.3 60.6-60.6-25.3-20zM261.3 128.1l25.4 20L342.1 96h73.4l71.7 60.3 4.5 3.7H496V121.8L431.6 67.7 427.2 64h-5.8H335.8h-6.3l-4.6 4.4-63.5 59.8zM221.9 97l1.2-1h17.5l32-32H217.3h-5.8L207 67.7l-10.7 9L221.9 97zm121.2 95.7L366.3 211l25.4-20.6-21.2-22.9-11.8 10.9-15.6 14.4zM32 160H80V384H32V160z'
      
    ]
  };

  

  
  

  var faPlaneDeparture = {
    prefix: 'fasl',
    iconName: 'plane-departure',
    icon: [
      640,
      512,
      [128747],
      'f5b0',
      
      'M181.5 65l-6.2-2.3-6 2.7-88 40L54.1 117.8l25.4 15.8 136.3 84.6-57.9 29L91.5 232.4l-6-1.3-5.4 3.1-56 32L5.9 276.5l14.8 14.8 88 88 4.7 4.7H120 256h3.8l3.4-1.7L543.3 242.2c39.4-19.7 70.9-52.2 89.3-92.2c15.1-32.7-8.8-70-44.8-70H526.2c-22.4 0-44.4 5.2-64.4 15.2l-83.7 41.9L181.5 65zm-59.6 57.2l54.8-24.9 196.9 72.2 6.5 2.4 6.2-3.1 89.9-44.9c15.6-7.8 32.7-11.8 50.1-11.8h61.6c12.7 0 21.1 13.1 15.8 24.6c-15.4 33.4-41.7 60.5-74.6 77L252.2 352H126.6L58.1 283.5 90.6 265l66 14.7 5.5 1.2 5.1-2.5L255.8 234l25.6-12.8-24.3-15.1L121.9 122.2zM16 480H0v32H16 624h16V480H624 16z'
      
    ]
  };

  

  
  

  var faBuoy = {
    prefix: 'fasl',
    iconName: 'buoy',
    icon: [
      576,
      512,
      [],
      'e5b5',
      
      'M400 0H176V32h28.3L147 304H96 64v32 54.9c3.8-2.6 7.8-5.5 12.3-8.7l1.1-.8L96 368V336H480v32l0 0 19.7 14.2 0 0c4.4 3.2 8.5 6.1 12.3 8.7V336 304H480 429L371.7 32H400V0zM339 32l9.8 46.4-60.8 76-60.8-76L237 32H339zM218.7 119l48.8 61L183.8 284.6 218.7 119zM288 205.6L366.7 304H209.3L288 205.6zm104.2 79L308.5 180l48.8-61 34.9 165.7zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-14.6-10-26-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C41.7 470.1 20.9 480 0 480v32c30.3 0 57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C518.5 497.9 545.7 512 576 512V480c-20.9 0-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C425.6 470.1 404.9 480 384 480s-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C233.6 470.1 212.9 480 192 480z'
      
    ]
  };

  

  
  

  var faImageUser = {
    prefix: 'fasl',
    iconName: 'image-user',
    icon: [
      512,
      512,
      [],
      'e1b8',
      
      'M32 64V448H480V64H32zM0 32H32 480h32V64 448v32H480 32 0V448 64 32zM288 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM188.4 352H323.6l-10.7-32H199.1l-10.7 32zM336 288l21.3 64L368 384H334.3 177.7 144l10.7-32L176 288h80 80zM256 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faTicketsPerforated = {
    prefix: 'fasl',
    iconName: 'tickets-perforated',
    icon: [
      640,
      512,
      [],
      'e63f',
      
      'M608 64v79.5c-23.7 11.8-40 36.2-40 64.5s16.3 52.7 40 64.5V352H128V64H608zm32 72V64 32H608 128 96V64 352v32h32H608h32V352 280 248c-22.1 0-40-17.9-40-40s17.9-40 40-40V136zm-144-8a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM32 112V96H0v16V464v16H16 528h16V448H528 32V112z'
      
    ]
  };

  

  
  

  var faCircleQuestion = {
    prefix: 'fasl',
    iconName: 'circle-question',
    icon: [
      512,
      512,
      [62108,"question-circle"],
      'f059',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168-72c0-30.9 25.1-56 56-56h56c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L272 268.3V272v16H240V272 258.5v-9.8l8.7-4.5 45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H224c-13.3 0-24 10.7-24 24v8H168v-8zm64 136h48v48H232V320z'
      
    ]
  };

  
    var faQuestionCircle = faCircleQuestion;
  

  
  

  var faFileImage = {
    prefix: 'fasl',
    iconName: 'file-image',
    icon: [
      384,
      512,
      [128443],
      'f1c5',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM120 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104.4 2.5l-13.7 20.6-37.2 55.8-18.2-18.2-13.2-13.2-11 15.1-64 88L64 410.8V416v16 16H80 304h16V432 416v-4.6l-2.4-3.9-80-128-13.1-21zm-.9 59L285.1 416H99.8l46.1-63.4 18.8 18.8 13.8 13.8 10.8-16.2 34.3-51.4z'
      
    ]
  };

  

  
  

  var faRupeeSign = {
    prefix: 'fasl',
    iconName: 'rupee-sign',
    icon: [
      448,
      512,
      [8360,"rupee"],
      'f156',
      
      'M0 32H16h96c79.5 0 144 64.5 144 144c0 65.2-43.4 120.3-102.9 138l53.1 166H172.6L121.3 319.7c-3.1 .2-6.2 .3-9.3 .3H32V480H0V304 48 32zM224 176c0-61.9-50.1-112-112-112H32V288h80c8.3 0 16.4-.9 24.2-2.6l7.1-2.3 .1 .4C190 270 224 227 224 176zm72.8 84.4c-1.5 9.7-.4 16.5 1.8 21.6c2.2 5.1 5.9 9.7 11.5 14c12.1 9.2 29.9 15.2 51.4 22.6l.1 0c20 6.8 43.6 14.8 60.7 28.8c8.9 7.3 16.6 16.6 21.2 28.4c4.6 11.9 5.7 25.3 3.4 40.3c-3.9 25.5-19 44-40.2 54.2c-20.6 9.9-46.3 11.8-72.8 7.2l-.1 0c-9-1.6-20.6-5.5-31-9.3c-7-2.5-14.2-5.3-20.2-7.6l0 0c-3-1.2-5.8-2.2-8.1-3.1l-15-5.6 11.2-30 15 5.6c2.7 1 5.7 2.2 8.8 3.4l0 0c5.8 2.2 12.3 4.7 19.1 7.2c10.5 3.8 19.8 6.8 25.9 7.9c22 3.9 40.4 1.7 53.3-4.5c12.3-5.9 20.2-15.7 22.5-30.3c1.6-10.6 .6-18.2-1.6-23.9c-2.2-5.7-6-10.7-11.6-15.2c-11.8-9.7-29.5-16-50.8-23.3l-2.8-1c-19.2-6.5-41.4-14-57.7-26.5c-9-6.8-16.8-15.6-21.6-27c-4.8-11.5-6.1-24.4-3.9-38.9c3.7-23.9 19-42 39.7-52.6c20.5-10.4 46.3-13.6 73.3-8.8c7.7 1.4 31 6.4 39.4 8.9l15.3 4.6-9.2 30.7-15.3-4.6c-6.7-2-28.7-6.8-35.8-8.1c-21.4-3.8-40-.9-53.2 5.8c-13 6.6-20.7 16.8-22.6 28.9z'
      
    ]
  };

  
    var faRupee = faRupeeSign;
  

  
  

  var faDiagramNested = {
    prefix: 'fasl',
    iconName: 'diagram-nested',
    icon: [
      448,
      512,
      [],
      'e157',
      
      'M160 64V192H112 80 32V64H160zM112 224h48 32V192 64 32H160 32 0V64 192v32H32 80V384v16H96 256v48 32h32H416h32V448 320 288H416 288 256v32 48H112V224zM288 368V320H416V448H288V400 368z'
      
    ]
  };

  

  
  

  var faVectorPolygon = {
    prefix: 'fasl',
    iconName: 'vector-polygon',
    icon: [
      448,
      512,
      [],
      'e2c7',
      
      'M416 64v64H352V64h64zM352 32H320V64 80H128V64 32H96 32 0V64v64 32H32 48l0 192H32 0v32 64 32H32 96h32V448 432H320v16 32h32 64 32V448 384 352H416 364.3l-19.2-32H352V288 224 192h-6.9l19.2-32H416h32V128 64 32H416 352zM307.7 320l19.2 32H320v32 16H128V384 352H96 80l0-192H96h32V128 112H320v16 32h6.9l-19.2 32H256 224v32 64 32h32 51.7zM32 384H96v64H32V384zm320 0h64v64H352V384zM256 224h64v64H256V224zM96 64v64H32V64H96z'
      
    ]
  };

  

  
  

  var faBugs = {
    prefix: 'fasl',
    iconName: 'bugs',
    icon: [
      576,
      512,
      [],
      'e4d0',
      
      'M156.7 102.8l34-80.6L161.3 9.8 128 88.6 94.7 9.8 65.3 22.2l34 80.6c-13.8 7-24.8 18.8-30.6 33.2H37.1l-5.4-27.1L.3 115.1l8 40L10.9 168H24 64v49.8l-45.1 15L9.6 236l-1.4 9.8-8 56 31.7 4.5 6.6-46.2 30.9-10.3C79.3 272.3 101.8 288 128 288s48.7-15.7 58.6-38.3l30.9 10.3 6.6 46.2 31.7-4.5-8-56-1.4-9.8-9.4-3.1-45.1-15V168h40 13.1l2.6-12.9 8-40-31.4-6.3L218.9 136H187.4c-5.8-14.4-16.8-26.2-30.6-33.2zM160 224c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32v64zm332.3 55.4l69.7-52.8-19.3-25.5-68.2 51.6 10.6-84.9-31.8-4-10.8 86.8c-15.4-.9-30.8 3.9-43.1 13.4l-27.3-15.8 8.9-26.2-30.3-10.3-13.1 38.6-4.2 12.4 11.4 6.6 34.6 20-24.9 43.1L308 323.1l-9.7-2-6.1 7.8-34.9 44.5 25.2 19.8 28.8-36.7 32 6.5c-2.7 24.5 8.9 49.4 31.6 62.4s50 10.7 69.9-3.8L466.4 446 449 489.3l29.7 11.9 21.1-52.5 3.7-9.2-6.6-7.4-31.5-35.5 24.9-43.1 34.6 20 11.4 6.6 8.7-9.9 26.9-30.6-24-21.1-18.3 20.8-27.3-15.8c2.2-15.4-1.4-31.1-9.9-44.1zM434.6 386c-8.8 15.3-28.4 20.5-43.7 11.7s-20.6-28.4-11.7-43.7l32-55.4c8.8-15.3 28.4-20.5 43.7-11.7s20.5 28.4 11.7 43.7l-32 55.4z'
      
    ]
  };

  

  
  

  var faWrench = {
    prefix: 'fasl',
    iconName: 'wrench',
    icon: [
      512,
      512,
      [128295],
      'f0ad',
      
      'M318.1 283.5l-17.9-4.9L287 291.7l-175 175L45.3 400l175-175 13.1-13.1-4.9-17.9c-2.9-10.8-4.5-22.1-4.5-33.9c0-70.7 57.3-128 128-128c10.7 0 21.1 1.3 31 3.8L329.4 89.4 320 98.7V112v48 32h32 48 13.3l9.4-9.4L476.2 129c2.5 9.9 3.8 20.3 3.8 31c0 70.7-57.3 128-128 128c-11.8 0-23.1-1.6-33.9-4.5zM112 512l22.6-22.6 175-175c13.5 3.7 27.7 5.7 42.3 5.7c88.4 0 160-71.6 160-160c0-19.9-3.6-38.9-10.3-56.5c-4-10.6-9.1-20.7-15.2-30.1L463.3 96.7 400 160H384 352V128 112l63.3-63.3 23.3-23.3c-9.4-6.1-19.5-11.2-30.1-15.2C390.9 3.6 371.9 0 352 0C263.6 0 192 71.6 192 160c0 14.7 2 28.9 5.7 42.3l-175 175L0 400l22.6 22.6 66.7 66.7L112 512zm8-97.4L142.6 392 120 369.4 97.4 392 120 414.6z'
      
    ]
  };

  

  
  

  var faArrowTurnLeft = {
    prefix: 'fasl',
    iconName: 'arrow-turn-left',
    icon: [
      512,
      512,
      [],
      'e632',
      
      'M480 496v16h32V496 256 240H496 54.6L155.3 139.3 166.6 128 144 105.4l-11.3 11.3-128 128L-6.6 256 4.7 267.3l128 128L144 406.6 166.6 384l-11.3-11.3L54.6 272H480V496z'
      
    ]
  };

  

  
  

  var faTransporter6 = {
    prefix: 'fasl',
    iconName: 'transporter-6',
    icon: [
      512,
      512,
      [],
      'e2a7',
      
      'M64 16V32H80 96V64H80 64V80 96H32V80 64H16 0V32H16 32V16 0H64V16zM480 368v16h16 16v32H496 480v16 16H448V432 416H432 416V384h16 16V368 352h32v16zM208 0h16 64 16V32H288 224 208V0zM96 256h16H400h16v32H400 112 96V256zm0 192h16H400h16v16 32 16H384V496 480H128v16 16H96V496 464 448z'
      
    ]
  };

  

  
  

  var faUtilityPole = {
    prefix: 'fasl',
    iconName: 'utility-pole',
    icon: [
      512,
      512,
      [],
      'e2c3',
      
      'M208 0h16 64 16V16 96h80V48 32h32V48 96h15.8c.1 0 .2 0 .3 0H480V48 32h32V48v64 16H496 437.5L304 231.8V496v16H272V496 224.2c0-.1 0-.2 0-.3V128H240v95.9c0 .1 0 .2 0 .3V496v16H208V496 231.8L74.5 128H16 0V112 48 32H32V48 96H79.9c.1 0 .2 0 .3 0H96V48 32h32V48 96h80V16 0zM126.6 128L208 191.3V128H126.6zM304 191.3L385.4 128H304v63.3zM272 32H240V96h32V32z'
      
    ]
  };

  

  
  

  var faBurger = {
    prefix: 'fasl',
    iconName: 'burger',
    icon: [
      512,
      512,
      ["hamburger"],
      'f805',
      
      'M256 32c112.8 0 206.2 83.4 221.7 192c1.5 10.5 2.3 21.1 2.3 32H448 64 32c0-10.9 .8-21.5 2.3-32C49.8 115.4 143.2 32 256 32zm0 32C160.9 64 81.9 133.2 66.7 224H445.3C430.1 133.2 351.1 64 256 64zM448 384H64v64H448V384zM32 352H64 448h32v32 64 32H448 64 32V448 384 352zM16 288H32 480h16v32H480 32 16V288zM160 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faHamburger = faBurger;
  

  
  

  var faStaff = {
    prefix: 'fasl',
    iconName: 'staff',
    icon: [
      512,
      512,
      [],
      'f71b',
      
      'M443.7 263.7l33.4-9.6 34.8-9.9V208 48 32 0H480 464 336 306.3L293.1 26.5l-16 32-7.2 14.3-14.3 28.6 28.6 14.3 28.6 14.3 28.6 14.3 14.3-28.6 7.2-14.3 2.7-5.5H384h32v32 43.8L226.8 225.8l-12 3.4-8.8 8.8L156.1 288H128 96v32 28.1L38.1 406.1 26.7 417.4 4.1 440l22.6 22.6 22.6 22.6L72 507.9l22.6-22.6 11.3-11.3L265.1 314.7l96-27.4 24.7 13.9L413.7 317l15.7-27.9 14.3-25.4zm-42.2 9.7l-24.7-13.9-11.7-6.6-12.9 3.7-96 27.4-8 2.3-5.9 5.9L83.3 451.3 72 462.6 49.4 440l11.3-11.3 57.9-57.9 9.4-9.4V348.1 320h28.1 13.3l9.4-9.4 49.9-49.9 2.9-2.9 4-1.1 189.2-54.1 23.2-6.6V171.8 96 64H416 365.7 345.9L337 81.7l-2.7 5.5-7.2 14.3L298.5 87.2l7.2-14.3 16-32 4.4-8.8H336 464h16V48 208v12.1l-11.6 3.3L435 232.9l-12.6 3.6L415.9 248l-14.3 25.4z'
      
    ]
  };

  

  
  

  var faChartRadar = {
    prefix: 'fasl',
    iconName: 'chart-radar',
    icon: [
      512,
      512,
      [],
      'e0e7',
      
      'M136 32h-9.2l-4.6 8L2.1 248l-4.6 8 4.6 8 120 208 4.6 8H136 376h9.2l4.6-8 120-208 4.6-8-4.6-8L389.9 40l-4.6-8H376 136zM34.5 256L145.2 64H366.8L477.5 256 366.8 448H145.2L34.5 256zM312 160c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 12.5 4.1 24 11 33.3l-31.6 42.1c-6-2.2-12.6-3.5-19.4-3.5c-30.9 0-56 25.1-56 56s25.1 56 56 56c21.5 0 40.1-12.1 49.5-29.8l54.7 10.9c2.6 28.5 26.6 50.8 55.8 50.8c30.9 0 56-25.1 56-56s-25.1-56-56-56c-1.7 0-3.4 .1-5.1 .2l-24.1-60.3C303.7 193.6 312 177.8 312 160zM270.5 293.8l-54.7-10.9c-1-10.5-4.8-20.2-10.8-28.2l31.6-42.1c6 2.2 12.6 3.5 19.4 3.5c1.7 0 3.4-.1 5.1-.2l24.1 60.3c-6 4.8-11.1 10.8-14.7 17.7zM256 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM160 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faLockHashtag = {
    prefix: 'fasl',
    iconName: 'lock-hashtag',
    icon: [
      448,
      512,
      [],
      'e423',
      
      'M128 128v64H320V128c0-53-43-96-96-96s-96 43-96 96zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h64 32v32V480v32H416 32 0V480 224 192H32 96zM32 480H416V224H32V480zM192 240v16 32h64V256 240h32v16 32h32 16v32H320 288v64h32 16v32H320 288v32 16H256V448 416H192v32 16H160V448 416H128 112V384h16 32V320H128 112V288h16 32V256 240h32zm0 144h64V320H192v64z'
      
    ]
  };

  

  
  

  var faTurnDownLeft = {
    prefix: 'fasl',
    iconName: 'turn-down-left',
    icon: [
      512,
      512,
      [],
      'e331',
      
      'M160 256l32 0 192 0 32 0 0-32 0-160 64 0 0 256-288 0-32 0 0 32 0 50.7L45.3 288 160 173.3l0 50.7 0 32zm32-96l0-32-32 0L22.6 265.4 0 288l22.6 22.6L160 448l32 0 0-32 0-32 0-32 32 0 256 0 32 0 0-32 0-256 0-32-32 0-64 0-32 0 0 32 0 128 0 32-32 0-128 0-32 0 0-32 0-32z'
      
    ]
  };

  

  
  

  var faFileAudio = {
    prefix: 'fasl',
    iconName: 'file-audio',
    icon: [
      384,
      512,
      [],
      'f1c7',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zm22.2 447.9C293.4 426.1 320 384.1 320 336s-26.6-90.1-65.8-111.9l-15.5 28C268.1 268.5 288 299.9 288 336s-19.9 67.5-49.4 83.9l15.5 28zm-31.1-56C242.7 381 256 360.1 256 336s-13.3-45-32.9-56l-15.5 28c9.8 5.5 16.5 15.9 16.5 28s-6.6 22.5-16.5 28l15.5 28zm-91.5-40H120 96V320h24 11.6l8.9-7.4L160 296.3v79.4l-19.5-16.3-8.9-7.4zM96 384h24l40 33.3 8 6.7h24V392 280 248H168l-8 6.7L120 288H96 64v32 32 32H96z'
      
    ]
  };

  

  
  

  var faPool8Ball = {
    prefix: 'fasl',
    iconName: 'pool-8-ball',
    icon: [
      512,
      512,
      [],
      'e3c5',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm368-64a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm37.3 14.2C304.8 184.5 312 199.4 312 216c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-16.6 7.2-31.5 18.7-41.8C212 166 208 155.5 208 144c0-26.5 21.5-48 48-48s48 21.5 48 48c0 11.5-4 22-10.7 30.2zM256 192a24 24 0 1 0 0 48 24 24 0 1 0 0-48z'
      
    ]
  };

  

  
  

  var faTruckClock = {
    prefix: 'fasl',
    iconName: 'truck-clock',
    icon: [
      640,
      512,
      ["shipping-timed"],
      'f48c',
      
      'M32 32V384H69.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H384V32H32zM64 416H32 0V384 32 0H32 384h32V32 96h80 7.4l4.8 5.6 96 112 3.9 4.5V224 384h16 16v32H624 608 576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96zM416 128v96H570.9l-82.3-96H416zm0 128v88.4c17-15.2 39.4-24.4 64-24.4c41.8 0 77.4 26.7 90.5 64H576V256H416zM224 416A64 64 0 1 0 96 416a64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM208 256a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm16 64v32h16 16v32H240 208 192V176 128 112h32v16z'
      
    ]
  };

  
    var faShippingTimed = faTruckClock;
  

  
  

  var faCartCirclePlus = {
    prefix: 'fasl',
    iconName: 'cart-circle-plus',
    icon: [
      640,
      512,
      [],
      'e3f3',
      
      'M16 0H0V32H16 67.2l77.2 339.5 2.8 12.5H160 320.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32H151L107.3 64H532.5l-40 128c1.2 0 2.4 0 3.5 0c10 0 19.7 .8 29.2 2.4L566 64l10-32H542.5 100L95.6 12.5 92.8 0H80 16zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 304V288H480v16 48H432 416v32h16 48v48 16h32V432 384h48 16V352H560 512V304z'
      
    ]
  };

  

  
  

  var faClipboardCheck = {
    prefix: 'fasl',
    iconName: 'clipboard-check',
    icon: [
      384,
      512,
      [],
      'f46c',
      
      'M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36l3.1 12H254h34v48H192 96V80h34 12.4l3.1-12zM192 0c-32.8 0-61 19.8-73.3 48H80 64V64 80H32 0v32V480v32H32 352h32V480 112 80H352 320V64 48H304 265.3C253 19.8 224.8 0 192 0zM320 144V112h32V480H32V112H64v32 16H80 192 304h16V144zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm91.3 171.3L310.6 240 288 217.4l-11.3 11.3L160 345.4l-52.7-52.7L96 281.4 73.4 304l11.3 11.3 64 64L160 390.6l11.3-11.3 128-128z'
      
    ]
  };

  

  
  

  var faFlatbreadStuffed = {
    prefix: 'fasl',
    iconName: 'flatbread-stuffed',
    icon: [
      576,
      512,
      [129369],
      'e40c',
      
      'M422.5 44.2l-75.9 9L255.9 3.4 185.1 78.8 83.6 98.9 77.8 202.2 13 282.9 75 365.7l.5 25.5 31.3-31.3-.1-5.1-6.1-8.2-47.1-63 49.3-61.3 6.4-8 .6-10.2 4.4-78.5 77.1-15.3 10.1-2 7-7.5 53.8-57.3 68.9 37.9 9 4.9L350.4 85 386 80.8l36.6-36.6zm40.3 50.2c72 94.1 64.9 229.2-21.1 315.3s-221.2 93.1-315.3 21.1L462.8 94.4zM79.7 432.3c7.7 7.7 15.7 14.8 23.9 21.3c106.8 84.4 262.2 77.3 360.7-21.3s105.7-254 21.3-360.7c-6.6-8.3-13.7-16.3-21.3-23.9L441.7 70.3 102.3 409.7 79.7 432.3zM272 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM240 160c-61.9 0-112 50.1-112 112c0 20.9 5.7 40.4 15.7 57.1l23.7-23.7C162.6 295.3 160 284 160 272c0-44.2 35.8-80 80-80c12 0 23.3 2.6 33.5 7.3l23.7-23.7C280.4 165.7 260.9 160 240 160z'
      
    ]
  };

  

  
  

  var faOctagonCheck = {
    prefix: 'fasl',
    iconName: 'octagon-check',
    icon: [
      512,
      512,
      [],
      'e426',
      
      'M32 338.7V173.3L173.3 32H338.7L480 173.3V338.7L338.7 480H173.3L32 338.7zM160 0L0 160V352L160 512H352L512 352V160L352 0H160zM363.3 203.3L374.6 192 352 169.4l-11.3 11.3L224 297.4l-52.7-52.7L160 233.4 137.4 256l11.3 11.3 64 64L224 342.6l11.3-11.3 128-128z'
      
    ]
  };

  

  
  

  var faWallet = {
    prefix: 'fasl',
    iconName: 'wallet',
    icon: [
      512,
      512,
      [],
      'f555',
      
      'M16 32H0V48 464v16H16 496h16V464 112 96H496 112 96v32h16H480V448H32V64H464h16V32H464 16zM384 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faUsersRays = {
    prefix: 'fasl',
    iconName: 'users-rays',
    icon: [
      640,
      512,
      [],
      'e593',
      
      'M4.7 27.3l64 64L80 102.6 102.6 80 91.3 68.7l-64-64L4.7 27.3zm608-22.6l-64 64L537.4 80 560 102.6l11.3-11.3 64-64L612.7 4.7zM91.3 443.3L102.6 432 80 409.4 68.7 420.7l-64 64 22.6 22.6 64-64zm480-22.6L560 409.4 537.4 432l11.3 11.3 64 64 22.6-22.6-64-64zM159.8 176a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM288 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm80.2-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM129.4 336l14.4-48h46.5l3.4-10.1 7.3-21.9H120L96 336h33.4zm366.8-48l14.4 48H544l-24-80H439.1l7.3 21.9 3.4 10.1h46.5zM224 288l-21.3 64L192 384h33.7H414.3 448l-10.7-32L416 288H224zm23.1 32H392.9l10.7 32H236.4l10.7-32z'
      
    ]
  };

  

  
  

  var faVolumeHigh = {
    prefix: 'fasl',
    iconName: 'volume-high',
    icon: [
      640,
      512,
      [128266,"volume-up"],
      'f028',
      
      'M608 256c0 83.8-40.2 158.1-102.4 204.8l19.2 25.6C594.7 433.9 640 350.3 640 256.1l0-.1 0-.1c0-94.2-45.3-177.8-115.2-230.3L505.6 51.2C567.8 97.9 608 172.2 608 256zM448 384l19.2 25.6c46.6-35 76.8-90.8 76.8-153.6s-30.2-118.6-76.8-153.6L448 128c38.9 29.2 64 75.7 64 128s-25.1 98.8-64 128zM416 256c0 20.9-10.1 39.5-25.6 51.2l19.2 25.6C432.9 315.3 448 287.4 448 256s-15.1-59.3-38.4-76.8l-19.2 25.6C405.9 216.5 416 235.1 416 256zM149.3 328.1l-9.1-8.1H128 32V192h96 12.2l9.1-8.1L284.2 64H288V448h-3.8L149.3 328.1zM0 352H32h96L272 480h16 32V448 64 32H288 272L128 160H32 0v32V320v32z'
      
    ]
  };

  
    var faVolumeUp = faVolumeHigh;
  

  
  

  var faCloudSlash = {
    prefix: 'fasl',
    iconName: 'cloud-slash',
    icon: [
      640,
      512,
      [],
      'e137',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM459.9 448H144 32V336c0-48.7 31.1-90.2 74.7-105.6l21.3-7.5V200.2 192c0-2 0-4 .1-5.9L98.7 162.8C96.9 172.3 96 182 96 192v8.2C40.1 220 0 273.3 0 336V448v32H32 144 500.4l-40.5-32zM256 32c-31.4 0-60.6 9-85.3 24.6L197.8 78C215.2 69 235 64 256 64c45.1 0 84.8 23.3 107.6 58.7l14.2 22 24.3-9.5c11.7-4.6 24.4-7.1 37.9-7.1c57.4 0 104 46.6 104 104v9.1 18.5l16 9.2c28.8 16.6 48 47.7 48 83.2v49.8l32 25.3V352c0-47.4-25.7-88.7-64-110.9V232c0-75.1-60.9-136-136-136c-17.5 0-34.2 3.3-49.5 9.3C362 61.2 312.4 32 256 32z'
      
    ]
  };

  

  
  

  var faInboxOut = {
    prefix: 'fasl',
    iconName: 'inbox-out',
    icon: [
      512,
      512,
      [128228,"inbox-arrow-up"],
      'f311',
      
      'M272 304v16H240V304 62.6l-84.7 84.7L144 158.6 121.4 136l11.3-11.3 112-112L256 1.4l11.3 11.3 112 112L390.6 136 368 158.6l-11.3-11.3L272 62.6V304zM32 320H144l32 64H336l32-64H480h32v32V480v32H480 32 0V480 352 320H32zm332.6 78.3L355.8 416H336 176 156.2l-8.8-17.7L124.2 352H32V480H480V352H387.8l-23.2 46.3z'
      
    ]
  };

  
    var faInboxArrowUp = faInboxOut;
  

  
  

  var faClockOneThirty = {
    prefix: 'fasl',
    iconName: 'clock-one-thirty',
    icon: [
      512,
      512,
      [],
      'e34f',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400V260.8l61.3-92 8.9-13.3-26.6-17.8-8.9 13.3-64 96-2.7 4V256 400v16h32V400z'
      
    ]
  };

  

  
  

  var faMobileScreenButton = {
    prefix: 'fasl',
    iconName: 'mobile-screen-button',
    icon: [
      384,
      512,
      ["mobile-alt"],
      'f3cd',
      
      'M320 32V320H64V32H320zm0 320V480H64V352H320zM64 0H32V32 480v32H64 320h32V480 32 0H320 64zM216 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faMobileAlt = faMobileScreenButton;
  

  
  

  var faSlider = {
    prefix: 'fasl',
    iconName: 'slider',
    icon: [
      512,
      512,
      [],
      'e252',
      
      'M384 128V384H288V128h96zM288 96H256v32V384v32h32 96 32V384 272h80 16V240H496 416V128 96H384 288zM0 272H16 224V240H16 0v32z'
      
    ]
  };

  

  
  

  var faCircleUp = {
    prefix: 'fasl',
    iconName: 'circle-up',
    icon: [
      512,
      512,
      [61467,"arrow-alt-circle-up"],
      'f35b',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 256V224H192 173.3L256 141.3 338.7 224H320 288v32 96H224V256zM256 96l-22.6 22.6L128 224v32h32 32v32 64 32h32 64 32V352 288 256h32 32V224L278.6 118.6 256 96z'
      
    ]
  };

  
    var faArrowAltCircleUp = faCircleUp;
  

  
  

  var faBadgeCheck = {
    prefix: 'fasl',
    iconName: 'badge-check',
    icon: [
      512,
      512,
      [],
      'f336',
      
      'M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4l6.2 11.7 12.6-3.9c25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1l-3.9 12.6 11.7 6.2C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4l-11.7 6.2 3.9 12.6c7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4l-12.6-3.9-6.2 11.7C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4l-6.2-11.7-12.6 3.9c-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1l3.9-12.6-11.7-6.2C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4l11.7-6.2-3.9-12.6c-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4l12.6 3.9 6.2-11.7zM256 0c-36.1 0-68 18.1-87.1 45.6c-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4C188 493.9 219.9 512 256 512s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9C493.9 324 512 292.1 512 256s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zM363.3 203.3L374.6 192 352 169.4l-11.3 11.3L224 297.4l-52.7-52.7L160 233.4 137.4 256l11.3 11.3 64 64L224 342.6l11.3-11.3 128-128z'
      
    ]
  };

  

  
  

  var faSatelliteDish = {
    prefix: 'fasl',
    iconName: 'satellite-dish',
    icon: [
      512,
      512,
      [128225],
      'f7c0',
      
      'M192 32V0C368.7 0 512 143.3 512 320H480C480 160.9 351.1 32 192 32zM416 320H384c0-106-86-192-192-192V96c123.7 0 224 100.3 224 224zM32 304c0 97.2 78.8 176 176 176c24.4 0 47.7-5 68.8-13.9L45.9 235.2C37 256.3 32 279.6 32 304zM0 304c0-33.4 7.9-64.9 21.8-92.9c4.9-9.9 10.6-19.3 17-28.2l23 23L172.7 316.7l24-24c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7l-24 24L306.1 450.1l23 23c-8.9 6.4-18.3 12.1-28.2 17c-28 14-59.5 21.8-92.9 21.8C93.1 512 0 418.9 0 304zm256-32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faForkKnife = {
    prefix: 'fasl',
    iconName: 'fork-knife',
    icon: [
      576,
      512,
      ["utensils-alt"],
      'f2e6',
      
      'M332.2 86.9L449.2 1.2l22.9 22.9L351.1 112.7c-3.1 2.3-6.1 4.8-8.8 7.6l-1.6 1.6C327.5 135.2 320 153.2 320 172s7.5 36.8 20.8 50.1l13.1 13.1C367.2 248.5 385.2 256 404 256s36.8-7.5 50.1-20.8l1.6-1.6c2.7-2.7 5.3-5.7 7.6-8.8l88.7-120.9 22.9 22.9L489.1 243.8c-3.3 4.4-6.9 8.6-10.7 12.5l-1.6 1.6C457.5 277.2 431.3 288 404 288c-25 0-49.1-9.1-67.8-25.5L91.3 507.3 68.7 484.7 313.5 239.8C297.1 221.1 288 197 288 172c0-27.3 10.8-53.5 30.1-72.8l1.6-1.6c3.9-3.9 8.1-7.5 12.5-10.7zm16.2 68.9L484.7 36.7l22.7 22.7L369.5 179.9l-7.3 6.4-22.7-22.7 8.9-7.8zm63.9 80.6l-22.7-22.7 6.4-7.3L516.7 68.7l22.7 22.7L420.2 227.5l-7.8 8.9zM46.8 13.8L58.5 3.2 69.3 14.7 274.2 233.9l-22.6 22.6L57.9 49.3c-2.4 3.1-5 6.7-7.5 10.8C41 75 32 95.7 32 120c0 20.2 9.8 46.9 34.8 83.5c23.7 34.6 59.9 76.3 110.5 127.3l-22.6 22.6c-51.2-51.6-88.9-95-114.2-131.9C14.2 183.2 0 149.9 0 120C0 87.8 11.8 61.2 23.3 43.1C29 34 34.7 26.8 39.1 21.8c2.2-2.5 4-4.4 5.4-5.8c.7-.7 1.2-1.2 1.6-1.6l.5-.5 .2-.1 .1-.1 0 0 0 0s0 0 10.8 11.8L46.8 13.8zM487.5 510.1L317.1 326.8l22.6-22.6L510.9 488.3l-23.4 21.8z'
      
    ]
  };

  
    var faUtensilsAlt = faForkKnife;
  

  
  

  var faBasketball = {
    prefix: 'fasl',
    iconName: 'basketball',
    icon: [
      512,
      512,
      [127936,"basketball-ball"],
      'f434',
      
      'M290.7 477.3c-1.8-9.5-2.7-19.3-2.7-29.3c0-38.4 13.5-73.7 36.1-101.3l78.6 78.6c-31 26.9-69.5 45.4-112 52zm-32 2.7c-.9 0-1.8 0-2.7 0c-56.1 0-107.4-20.6-146.7-54.7L256 278.6 301.4 324C273.1 357.5 256 400.7 256 448c0 10.9 .9 21.6 2.7 32zM324 301.4L278.6 256 425.3 109.3C459.4 148.6 480 199.9 480 256c0 .9 0 1.8 0 2.7c-10.4-1.7-21.1-2.7-32-2.7c-47.3 0-90.5 17.1-124 45.4zm22.7 22.7C374.3 301.5 409.6 288 448 288c10 0 19.8 .9 29.3 2.7c-6.6 42.5-25.1 81-52 112l-78.6-78.6zM256 233.4L210.6 188C238.9 154.5 256 111.3 256 64c0-10.9-.9-21.6-2.7-32c.9 0 1.8 0 2.7 0c56.1 0 107.4 20.6 146.7 54.7L256 233.4zm-68.1-68.1L109.3 86.7c31-26.9 69.5-45.4 112-52C223.1 44.2 224 54 224 64c0 38.4-13.5 73.7-36.1 101.3zm-22.6 22.6C137.7 210.5 102.4 224 64 224c-10 0-19.8-.9-29.3-2.7c6.6-42.5 25.1-81 52-112l78.6 78.6zM32 253.3c10.4 1.7 21.1 2.7 32 2.7c47.3 0 90.5-17.1 124-45.4L233.4 256 86.7 402.7C52.6 363.4 32 312.1 32 256c0-.9 0-1.8 0-2.7zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  
    var faBasketballBall = faBasketball;
  

  
  

  var faTrademark = {
    prefix: 'fasl',
    iconName: 'trademark',
    icon: [
      640,
      512,
      [8482],
      'f25c',
      
      'M0 96H16 240h16v32H240 16 0V96zM112 400V128h32V400v16H112V400zM288 112V96h23.5l4.8 5.8L464 279 611.7 101.8l4.8-5.8H640v16V400v16H608V400 156.2L476.3 314.2 464 329l-12.3-14.7L320 156.2V400v16H288V400 112z'
      
    ]
  };

  

  
  

  var faCircleDashed = {
    prefix: 'fasl',
    iconName: 'circle-dashed',
    icon: [
      512,
      512,
      [],
      'e105',
      
      'M1.1 232H33.3c4.7-43.9 22-83.9 48.3-116.5L58.8 92.7C26.9 131.3 6 179.3 1.1 232zM115.5 81.5C148.1 55.3 188.1 37.9 232 33.3V1.1C179.3 6 131.3 26.9 92.7 58.8l22.7 22.7zM280 478.7v32.2c52.7-4.9 100.7-25.8 139.3-57.7l-22.7-22.7c-32.6 26.3-72.7 43.6-116.5 48.3zm150.5-82.2l22.7 22.7c31.9-38.5 52.8-86.6 57.7-139.3H478.7c-4.7 43.9-22 83.9-48.3 116.5zM92.7 453.2c38.5 31.9 86.6 52.8 139.3 57.7V478.7c-43.9-4.7-83.9-22-116.5-48.3L92.7 453.2zM58.8 419.3l22.7-22.7C55.3 363.9 37.9 323.9 33.3 280H1.1C6 332.7 26.9 380.7 58.8 419.3zM419.3 58.8C380.7 26.9 332.7 6 280 1.1V33.3c43.9 4.7 83.9 22 116.5 48.3l22.7-22.7zm11.2 56.7c26.3 32.6 43.6 72.7 48.3 116.5h32.2c-4.9-52.7-25.8-100.7-57.7-139.3l-22.7 22.7z'
      
    ]
  };

  

  
  

  var faPlaneSlash = {
    prefix: 'fasl',
    iconName: 'plane-slash',
    icon: [
      640,
      512,
      [],
      'e069',
      
      'M347.6 359.4L278.7 480l-65.5 0 44.5-155.6 5.8-20.4-21.2 0H168h-8l-4.8 6.4L112 368H76.5l27-108.1 1-3.9-1-3.9L76.9 145.6 35.8 113.2l4.7 18.7L71.5 256l-31 124.1-5 19.9H56h64 8l4.8-6.4L176 336h45.1L176.6 491.6 170.8 512H192l96 0h9.3l4.6-8.1L373 379.4l-25.4-20.1zm-171-339l15.1 52.8 43 33.9L213.2 32l65.5 0 96 167.9 4.6 8.1h9.3l109.8 0c13.5 0 34.1 6.1 51.3 16.6c8.5 5.2 15.4 10.9 20 16.7c4.6 5.8 6.3 10.7 6.3 14.8c0 9.1-8.2 20.9-26.3 31.8c-17.2 10.3-37.8 16.2-51.4 16.2H484.1l37.1 29.3c15.2-3.4 31.2-9.7 45.1-18C586.4 303.1 608 282.9 608 256c0-13.4-5.7-25.2-13.3-34.8c-7.6-9.5-17.7-17.6-28.4-24c-21-12.8-47.3-21.2-67.9-21.2l-100.5 0L301.9 8.1 297.3 0H288 192 170.8l5.8 20.4zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faInterrobang = {
    prefix: 'fasl',
    iconName: 'interrobang',
    icon: [
      320,
      512,
      [8253],
      'e5ba',
      
      'M144 64c-53 0-96 43-96 96H16C16 89.3 73.3 32 144 32h32c70.7 0 128 57.3 128 128c0 35.3-16.6 68.4-44.8 89.6L176 312v32 8 8 8H144v-8-8-8V304v-8V160 144h32v16V272l64-48c20.1-15.1 32-38.8 32-64c0-53-43-96-96-96H144zm-8 360h48v48H136V424z'
      
    ]
  };

  

  
  

  var faUserAstronaut = {
    prefix: 'fasl',
    iconName: 'user-astronaut',
    icon: [
      448,
      512,
      [],
      'f4fb',
      
      'M368 176A144 144 0 1 0 80 176a144 144 0 1 0 288 0zM48 176a176 176 0 1 1 352 0A176 176 0 1 1 48 176zM32 112V240H0V112H32zm416 0V240H416V112h32zM48 304H60c9.2 11.7 19.6 22.5 31 32H73.5L40.2 480H96V416 400h16H336h16v16 64h55.8L374.5 336H356.9c11.5-9.5 21.9-20.3 31-32h12l40.6 176 7.4 32H415.2 336 288 256 192 160 112 32.8 0l7.4-32L48 304zM320 432H128v48h32V464 448h32v16 16h64V464 448h32v16 16h32V432zM240 256c44.2 0 80-35.8 80-80V157.3L290.7 128H157.3L128 157.3V176c0 44.2 35.8 80 80 80h32zM96 144l48-48H304l48 48v32c0 61.9-50.1 112-112 112H208c-61.9 0-112-50.1-112-112V144zm96 0l13.3 26.7L232 184l-26.7 13.3L192 224l-13.3-26.7L152 184l26.7-13.3L192 144z'
      
    ]
  };

  

  
  

  var faRecycle = {
    prefix: 'fasl',
    iconName: 'recycle',
    icon: [
      512,
      512,
      [9842,9850,9851],
      'f1b8',
      
      'M215 0h9 64 9l4.7 7.7 94.4 155.1 11.1-54 3.2-15.7 31.3 6.5-3.2 15.7-19.4 94.4-3.6 17.6-17.1-5.7L307 191.2l-15.2-5 10.1-30.4 15.2 5 50.5 16.8L279 32H233l-51.4 84.4L154.2 100 210.3 7.7 215 0zM421.4 266l27.4-16.5 60.7 99.8 5.3 8.8-5.8 8.5L469.6 425l-4.8 7h-8.5l-190.3 0 40.5 36 12 10.6-21.3 23.9-12-10.6-72-64-13.5-12 13.5-12 72-64 12-10.6 21.3 23.9-12 10.6L266.1 400l181.9 0 29-42.8L421.4 266zM101.3 186.9L45 205.5l-15.2 5L19.8 180.2l15.2-5 91.4-30.4 17.1-5.7 3.6 17.6 19.4 94.4 3.2 15.7-31.3 6.5-3.2-15.7-10-48.4L35.1 357.3l29 42.8 95.9 0v32L55.6 432H47.1l-4.8-7L2.9 366.7l-5.8-8.5 5.3-8.8 98.9-162.6z'
      
    ]
  };

  

  
  

  var faBackwardFast = {
    prefix: 'fasl',
    iconName: 'backward-fast',
    icon: [
      512,
      512,
      [9198,"fast-backward"],
      'f049',
      
      'M32 64V80 218L224 86l32-22v38.8V240L480 86l32-22v38.8V409.2 448l-32-22L256 272V409.2 448l-32-22L32 294V432v16H0V432 272 240 80 64H32zm192 60.8L33.2 256 224 387.2V124.8zM289.2 256L480 387.2V124.8L289.2 256z'
      
    ]
  };

  
    var faFastBackward = faBackwardFast;
  

  
  

  var faSword = {
    prefix: 'fasl',
    iconName: 'sword',
    icon: [
      512,
      512,
      [128481],
      'f71c',
      
      'M182.6 233.4L205.3 256 415.1 46.2l59.2-8.5-8.5 59.2L256 306.7l22.6 22.6L496 112l11.3-79L512 0 479 4.7 400 16 182.6 233.4zm-59.3-20.7L112 201.4l-11.3 11.3-32 32-9.1 9.1 6.9 10.8 49.1 77.2L82.7 374.6l-31.6-6.3-8.4-1.7-6.1 6.1-24 24L1.4 408l11.3 11.3 80 80L104 510.6l11.3-11.3 24-24 6.1-6.1-1.7-8.4-6.3-31.6 32.9-32.9 77.2 49.1 10.8 6.9 9.1-9.1 32-32L310.6 400l-11.3-11.3-176-176zm26.2 122.7l-49.1-77.2L112 246.6 265.4 400l-11.6 11.6-77.2-49.1-10.8-6.9-9.1 9.1-48 48-6.1 6.1 1.7 8.4 6.3 31.6-6.6 6.6L46.6 408l6.6-6.6 31.6 6.3 8.4 1.7 6.1-6.1 48-48 9.1-9.1-6.9-10.8z'
      
    ]
  };

  

  
  

  var faCartCircleExclamation = {
    prefix: 'fasl',
    iconName: 'cart-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e3f2',
      
      'M16 0H0V32H16 67.2l77.2 339.5 2.8 12.5H160 320.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32H151L107.3 64H532.5l-40 128c1.2 0 2.4 0 3.5 0c10 0 19.7 .8 29.2 2.4L566 64l10-32H542.5 100L95.6 12.5 92.8 0H80 16zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 288H480v16 80 16h32V384 304 288zm0 160V416H480v32h32z'
      
    ]
  };

  

  
  

  var faLeftToBracket = {
    prefix: 'fasl',
    iconName: 'left-to-bracket',
    icon: [
      512,
      512,
      [],
      'e66d',
      
      'M368 208l-32 0 0-32 0-48-17.7 0L203.1 256 318.3 384l17.7 0 0-48 0-32 32 0 112 0 0-96-112 0zm0-112l0 32 0 16 0 32 32 0 80 0 32 0 0 32 0 96 0 32-32 0-80 0-32 0 0 32 0 16 0 32-32 0-32 0L160 256 304 96l32 0 32 0zM176 448l16 0 0 32-16 0L16 480 0 480l0-16L0 48 0 32l16 0 160 0 16 0 0 32-16 0L32 64l0 384 144 0z'
      
    ]
  };

  

  
  

  var faCircle = {
    prefix: 'fasl',
    iconName: 'circle',
    icon: [
      512,
      512,
      [9679,9898,9899,11044,61708,61915,128308,128309,128992,128993,128994,128995,128996],
      'f111',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  

  
  

  var faSquarePollHorizontal = {
    prefix: 'fasl',
    iconName: 'square-poll-horizontal',
    icon: [
      448,
      512,
      ["poll-h"],
      'f682',
      
      'M416 64L32 64l0 384 384 0 0-384zm32-32l0 32 0 384 0 32-32 0L32 480 0 480l0-32L0 64 0 32l32 0 384 0 32 0zM256 176L96 176l0-32 160 0 0 32zm96 64l0 32L96 272l0-32 256 0zM192 368l-96 0 0-32 96 0 0 32z'
      
    ]
  };

  
    var faPollH = faSquarePollHorizontal;
  

  
  

  var faHouseFloodWaterCircleArrowRight = {
    prefix: 'fasl',
    iconName: 'house-flood-water-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e50f',
      
      'M144 32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256A144 144 0 1 0 144 0a144 144 0 1 0 0 288zm8-222.6L129.4 88l11.3 11.3L169.4 128H80 64v32H80h89.4l-28.7 28.7L129.4 200 152 222.6l11.3-11.3 56-56L230.6 144l-11.3-11.3-56-56L152 65.4zm159.7 25L384 43.1l144 94.2V251.5l3.7 2.7 0 0 0 0c11 7.9 19.3 13.9 28.3 18.8V158.2l23.2 15.2 17.5-26.8-208-136L384 4.9l-8.8 5.7L299 60.5c5.1 9.5 9.4 19.5 12.7 29.9zM224 368c-20.9 0-41.7-9.9-58.2-21.2c-14.6-10-26-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C73.7 358.1 52.9 368 32 368v32c30.3 0 57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C166.4 385.9 193.7 400 224 400s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C358.4 385.9 385.7 400 416 400s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C550.5 385.9 577.7 400 608 400V368c-20.9 0-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C457.6 358.1 436.9 368 416 368s-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C265.6 358.1 244.9 368 224 368zm-58.2 90.8c-14.6-10-26-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C73.7 470.1 52.9 480 32 480v32c30.3 0 57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C166.4 497.9 193.7 512 224 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C358.4 497.9 385.7 512 416 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C550.5 497.9 577.7 512 608 512V480c-20.9 0-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C457.6 470.1 436.9 480 416 480s-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C265.6 470.1 244.9 480 224 480s-41.7-9.9-58.2-21.2z'
      
    ]
  };

  

  
  

  var faMoneyBillTrendUp = {
    prefix: 'fasl',
    iconName: 'money-bill-trend-up',
    icon: [
      512,
      512,
      [],
      'e529',
      
      'M352 0V32h16 57.4L287.2 170.2 186.4 83.9 176 74.9l-10.4 8.9-112 96 20.8 24.3L176 117.1l101.6 87.1 11.2 9.6 10.5-10.5L448 54.6V112v16h32V112 16 0H464 368 352zM480 288v48c-26.5 0-48-21.5-48-48h48zm-368 0H400c0 44.2 35.8 80 80 80v32c-44.2 0-80 35.8-80 80H112c0-44.2-35.8-80-80-80V368c44.2 0 80-35.8 80-80zM432 480c0-26.5 21.5-48 48-48v48H432zM32 432c26.5 0 48 21.5 48 48H32V432zM80 288c0 26.5-21.5 48-48 48V288H80zM32 256H0v32V480v32H32 480h32V480 288 256H480 32zM224 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faMoneyBillTransfer = {
    prefix: 'fasl',
    iconName: 'money-bill-transfer',
    icon: [
      640,
      512,
      [],
      'e528',
      
      'M638.6 80L627.3 68.7l-64-64L540.7 27.3 577.4 64l-37.3 0 0 0H454.5L384 64l-.2 0H64 32V96 348.1l14.1-14.1L64 316.1V192c53 0 96-43 96-96l293.9 0 123.5 0-36.7 36.7 22.6 22.6 64-64L638.6 80zM64 160V96l64 0c0 35.3-28.7 64-64 64zM62.6 448l37.3 0 0 0H576h32V416 163.9l-14.1 14.1L576 195.9V320h0c-53 0-96 43-96 96H256.4l-.4 0L62.6 416l36.7-36.7L76.7 356.7l-64 64L1.4 432l11.3 11.3 64 64 22.6-22.6L62.6 448zM576 352h0v64H512c0-35.3 28.7-64 64-64zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm160 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  

  
  

  var faElevator = {
    prefix: 'fasl',
    iconName: 'elevator',
    icon: [
      512,
      512,
      [],
      'e16d',
      
      'M155.3 12.7l64 64L196.7 99.3 144 46.6 91.3 99.3 68.7 76.7l64-64L144 1.4l11.3 11.3zM292.7 27.3L315.3 4.7 368 57.4 420.7 4.7l22.6 22.6-64 64L368 102.6 356.7 91.3l-64-64zM32 160V480H480V160H32zM0 128H32 480h32v32V480v32H480 32 0V480 160 128zM184 264a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM113 448H80l24-96H216l24 96H207l-16-64H129l-16 64zm208-64l-16 64H272l24-96H408l24 96H399l-16-64H321z'
      
    ]
  };

  

  
  

  var faTally3 = {
    prefix: 'fasl',
    iconName: 'tally-3',
    icon: [
      640,
      512,
      [],
      'e296',
      
      'M144 32V48 464v16H112V464 48 32h32zm128 0V48 464v16H240V464 48 32h32zM400 48V464v16H368V464 48 32h32V48z'
      
    ]
  };

  

  
  

  var faHouseChimneyHeart = {
    prefix: 'fasl',
    iconName: 'house-chimney-heart',
    icon: [
      576,
      512,
      [],
      'e1b2',
      
      'M288 2.7L298.6 12 384 87.4V48 32h16 96 16V48 200h-.3l58.9 52-21.2 24L512 243V496v16H496 80 64V496 243L26.6 276 5.4 252l272-240L288 2.7zM480 172.1V64H416v51.6l64 56.5zM96 214.7V480H480V214.7L288 45.3 96 214.7zm192 33.8l7.7-7.4c11.5-11 26.8-17.2 42.7-17.2h2.4c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L288 416.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7c0-32.7 26.5-59.2 59.2-59.2h2.4c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4zm0 123.1l71.7-68.9c5.3-5.1 8.3-12.2 8.3-19.6c0-15-12.2-27.2-27.2-27.2h-2.4c-7.7 0-15 3-20.5 8.3l-7.7 7.4L288 293l-22.2-21.3-7.7-7.4c-5.5-5.3-12.9-8.3-20.5-8.3h-2.4c-15 0-27.2 12.2-27.2 27.2c0 7.4 3 14.5 8.3 19.6L288 371.7z'
      
    ]
  };

  

  
  

  var faTableTree = {
    prefix: 'fasl',
    iconName: 'table-tree',
    icon: [
      512,
      512,
      [],
      'e293',
      
      'M32 64v96H96h32H480V64H32zM96 192H32V448H480V192H128v64h48 16v32H176 128v64H240h16v32H240 112 96V368 288 272 192zM0 32H32 480h32V64 448v32H480 32 0V448 64 32zM224 256H416v32H224V256zm192 96v32H288V352H416z'
      
    ]
  };

  

  
  

  var faLockOpen = {
    prefix: 'fasl',
    iconName: 'lock-open',
    icon: [
      576,
      512,
      [],
      'f3c1',
      
      'M352 128c0-53 43-96 96-96s96 43 96 96v80 16h32V208 128C576 57.3 518.7 0 448 0S320 57.3 320 128v64H32 0v32V480v32H32 416h32V480 224 192H416 352V128zm-16 96h80V480H32V224H336z'
      
    ]
  };

  

  
  

  var faSolarPanel = {
    prefix: 'fasl',
    iconName: 'solar-panel',
    icon: [
      640,
      512,
      [],
      'f5ba',
      
      'M57.9 208H203.2L190.7 352H32V328L57.9 208zm6.9-32L96 32H218.4L206 176H64.9zM250.5 32H389.5l12.5 144H238.1L250.5 32zm171 0H544l31.1 144H434L421.6 32zM582.1 208L608 328v24H449.3L436.8 208H582.1zM417.2 352H222.8l12.5-144H404.7l12.5 144zM569.8 0H70.2L0 324.6V352v32H32 304v96H208 192v32h16 96 32 96 16V480H432 336V384H608h32V352 324.6L569.8 0z'
      
    ]
  };

  

  
  

  var faShieldDog = {
    prefix: 'fasl',
    iconName: 'shield-dog',
    icon: [
      512,
      512,
      [],
      'e573',
      
      'M48.5 114.9L256 34.3l207.5 80.5c2.7 45.6-4.5 116.8-34.7 186.3S345.4 438.4 256 477.1C166.6 438.4 113.4 370.7 83.2 301.2S45.8 160.5 48.5 114.9zm447-1.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM152 128H120v32 56c0 22.6 13.4 42.1 32.7 50.9l-15 29.9-7.2 14.3 28.6 14.3 7.2-14.3L186.4 271c26-4.9 45.6-27.7 45.6-55V160h60.2 9.9l11.6 23.2 4.4 8.8H328h56v16c0 35.3-28.7 64-64 64H272 256v16 80 16h32V368 304h32c53 0 96-43 96-96V176 160H400 337.9l-11.6-23.2-4.4-8.8H312 292.2 232 216 200 152zm32 32h16v32 24c0 13.3-10.7 24-24 24s-24-10.7-24-24V192 160h16 16zm88 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faShutters = {
    prefix: 'fasl',
    iconName: 'shutters',
    icon: [
      512,
      512,
      [],
      'e449',
      
      'M16 32H0V48v64 16H16 496h16V112 48 32H496 16zM32 96V64H480V96H32zM8 448L0 480H33 479h33l-8-32-16-64H455l16 64H41l16-64H24L8 448zM24 256L8 320 0 352H33 479h33l-8-32-16-64H455l16 64H41l16-64H24zm488-32l-8-32-8-32H463l8 32H41l8-32H16L8 192 0 224H33 479h33z'
      
    ]
  };

  

  
  

  var faBitcoinSign = {
    prefix: 'fasl',
    iconName: 'bitcoin-sign',
    icon: [
      320,
      512,
      [],
      'e0b4',
      
      'M64 0H96V64h64V0h32V64.3c53.7 4.1 96 49 96 103.7c0 31.3-13.9 59.4-35.8 78.5C291.8 261.2 320 299.3 320 344c0 57.4-46.6 104-104 104H192v64H160V448H96v64H64V448H32 0V416 272 240 96 64H32 64V0zm96 416h32 24c39.8 0 72-32.2 72-72s-32.2-72-72-72H184 32V416H64 96h64zM184 96H160 96 64 32V240H184c39.8 0 72-32.2 72-72s-32.2-72-72-72z'
      
    ]
  };

  

  
  

  var faArrowDownTriangleSquare = {
    prefix: 'fasl',
    iconName: 'arrow-down-triangle-square',
    icon: [
      576,
      512,
      ["sort-shapes-down"],
      'f888',
      
      'M160 478.6l11.3-11.3 88-88L270.6 368 248 345.4l-11.3 11.3L176 417.4V48 32H144V48 417.4L83.3 356.7 72 345.4 49.4 368l11.3 11.3 88 88L160 478.6zM296 224h37.7H498.3 536l-20-32L434.9 62.2 416 32 397.1 62.2 316 192l-20 32zm182.3-32H353.7L416 92.4 478.3 192zM352 448V320H480V448H352zM320 288v32V448v32h32H480h32V448 320 288H480 352 320z'
      
    ]
  };

  
    var faSortShapesDown = faArrowDownTriangleSquare;
  

  
  

  var faCube = {
    prefix: 'fasl',
    iconName: 'cube',
    icon: [
      512,
      512,
      [],
      'f1b2',
      
      'M256 7l5.5 2 240 88 10.5 3.8V112 384v10.5l-9.6 4.2-240 104-6.4 2.8-6.4-2.8-240-104L0 394.5V384 112 100.8L10.5 97l240-88L256 7zM32 373.5l208 90.1V222L32 140.3V373.5zm240 90.1l208-90.1V140.3L272 222V463.6zM256 41L54.7 114.9 256 194l201.3-79.1L256 41z'
      
    ]
  };

  

  
  

  var faHandsHoldingDollar = {
    prefix: 'fasl',
    iconName: 'hands-holding-dollar',
    icon: [
      640,
      512,
      ["hands-usd"],
      'f4c5',
      
      'M336 32v9.6c5.9 1 19 3.5 24.1 4.9l15.5 4.1-8.2 30.9-15.5-4.1c-4-1.1-17.7-3.7-22.1-4.4c-12.8-2-23.6-.4-30.9 2.9c-7.2 3.3-9.9 7.5-10.5 11c-.7 4.1-.1 6.2 .5 7.4c.6 1.4 2 3.1 5 5.1c6.7 4.6 17.1 7.8 31 12l.6 .2c12.3 3.7 27.9 8.4 39.5 16.9c6.3 4.5 12 10.6 15.6 18.8c3.6 8.3 4.4 17.4 2.7 27.2c-3 17.5-14.6 29.4-29.3 35.7c-5.6 2.4-11.6 4-17.9 4.9V224v16H304V224v-9.6c-9.4-1.7-23.6-6.6-32.4-9.6l0 0 0 0 0 0c-1.8-.6-3.3-1.1-4.6-1.6l-15.2-5.1 10.1-30.4 15.2 5.1c1.9 .6 4 1.3 6.1 2.1l0 0 0 0 0 0c9.5 3.2 20.7 7 27.1 8.1c13.3 2.1 24 .8 31-2.2c6.5-2.8 9.5-6.7 10.3-11.8c.8-4.7 .2-7.3-.5-9c-.7-1.7-2.2-3.6-5.1-5.7c-6.5-4.8-16.7-8.1-30.5-12.3l-2-.6c-11.9-3.6-26.6-8-37.7-15.5c-6.2-4.2-12.2-10-15.9-17.9c-3.8-8.1-4.7-17.1-3.1-26.6c2.9-16.7 14.7-28.4 28.8-34.7c5.6-2.6 11.8-4.4 18.3-5.4V32 16h32V32zM112 64h16V80 265.4l36.7-36.7L176 217.4l11.3 11.3L320 361.4 452.7 228.7 464 217.4l11.3 11.3L512 265.4V80 64h16 96 16V80 384v6.6l-4.7 4.7-104 104L520 510.6 497.4 488l11.3-11.3L608 377.4V96H544V288v6.6l-1.4 1.4-3.3 3.3-8 8-72 72L448 390.6l-4.7 4.7L432 406.6 409.4 384l11.3-11.3 4.7-4.7 11.3-11.3L497.4 296 464 262.6l-128 128V496v16H304V496 390.6l-128-128L142.6 296l60.7 60.7 0 0 16 16L230.6 384 208 406.6l-11.3-11.3-16-16 0 0-72-72-8-8L97.4 296 96 294.6V288 96H32V377.4l99.3 99.3L142.6 488 120 510.6l-11.3-11.3-104-104L0 390.6V384 80 64H16h96z'
      
    ]
  };

  
    var faHandsUsd = faHandsHoldingDollar;
  

  
  

  var faToiletPaperXmark = {
    prefix: 'fasl',
    iconName: 'toilet-paper-xmark',
    icon: [
      512,
      512,
      [],
      'e5b3',
      
      'M32 192c0-46.5 10.3-87.7 26.2-116.8C74.4 45.5 94.1 32 112 32H337.3c-7.2 8.2-13.6 17.7-19.2 27.9C299.2 94.5 288 141.2 288 192s11.2 97.5 30.1 132.1c5.6 10.2 12 19.6 19.2 27.9H112c-17.9 0-37.6-13.5-53.8-43.2C42.3 279.7 32 238.5 32 192zM346.2 75.2C362.4 45.5 382.1 32 400 32s37.6 13.5 53.8 43.2C469.7 104.3 480 145.5 480 192s-10.3 87.7-26.2 116.8C437.6 338.5 417.9 352 400 352s-37.6-13.5-53.8-43.2C330.3 279.7 320 238.5 320 192s10.3-87.7 26.2-116.8zM480 327.6V480H160V416H128v80 16h16H496h16V496 192c0-50.8-11.2-97.5-30.1-132.1C463.4 25.9 435.1 0 400 0H112C76.9 0 48.6 25.9 30.1 59.9C11.2 94.5 0 141.2 0 192s11.2 97.5 30.1 132.1C48.6 358.1 76.9 384 112 384H400c33.9 0 61.4-24.1 80-56.4zM385.5 212.4c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6s-11.9-11.3-14.5-27.6zM431.4 256c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16s26.6-9.9 31.4-16zM238.6 144L216 121.4l-11.3 11.3L168 169.4l-36.7-36.7L120 121.4 97.4 144l11.3 11.3L145.4 192l-36.7 36.7L97.4 240 120 262.6l11.3-11.3L168 214.6l36.7 36.7L216 262.6 238.6 240l-11.3-11.3L190.6 192l36.7-36.7L238.6 144z'
      
    ]
  };

  

  
  

  var faWifiSlash = {
    prefix: 'fasl',
    iconName: 'wifi-slash',
    icon: [
      640,
      512,
      [],
      'f6ac',
      
      'M27.8 8.1L40.4 18 619.5 469l12.6 9.8-19.7 25.2-12.6-9.8L20.7 43.2 8.1 33.4 27.8 8.1zm370.4 228l-54.7-43.2c73 5.9 138.2 38.9 185.7 89l-21.6 23.8c-29.5-31.8-67.1-56-109.4-69.6zM208.5 249.5c-28.7 13.9-54.5 33.1-76 56.2L110.9 282c20.3-21.5 44-39.8 70-54.2l27.6 21.8zM201.7 81.1L171.5 57.2C218 40.9 267.9 32 320 32c123.8 0 235.9 50.2 316.9 131.4l-21.6 23.7C540 111.1 435.5 64 320 64c-41.1 0-80.8 6-118.3 17.1zM48.8 123.4l26 20.5c-17.8 13-34.6 27.5-50.2 43.1L3.1 163.4c14.3-14.3 29.6-27.7 45.7-40zM320 480c-11.7 0-22.7-3.2-32.2-8.7c-19-11.1-31.8-31.7-31.8-55.3c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0c8.1 .2 15.8 1.9 22.8 4.8c23.2 9.6 39.6 32.5 39.6 59.2c0 35.3-28.7 64-64 64c0 0 0 0 0 0zm0-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faSquareInfo = {
    prefix: 'fasl',
    iconName: 'square-info',
    icon: [
      448,
      512,
      [8505,"info-square"],
      'f30f',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM160 352h16 32V256H184 168V224h16 40 16v16V352h32 16v32H272 176 160V352zm88-216v48H200V136h48z'
      
    ]
  };

  
    var faInfoSquare = faSquareInfo;
  

  
  

  var faTemperatureQuarter = {
    prefix: 'fasl',
    iconName: 'temperature-quarter',
    icon: [
      320,
      512,
      ["temperature-1","thermometer-1","thermometer-quarter"],
      'f2ca',
      
      'M96 275l-10.7 9.5C62.4 305.1 48 334.9 48 368c0 61.9 50.1 112 112 112s112-50.1 112-112c0-33.2-14.4-62.9-37.3-83.5L224 275V260.7 32H96V260.7 275zM224 0h32V32 260.7c29.5 26.4 48 64.7 48 107.3c0 79.5-64.5 144-144 144S16 447.6 16 368c0-42.6 18.5-81 48-107.3V32 0H96 224zM160 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62V272 256h32v16 34c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTemperature1 = faTemperatureQuarter;
  
    var faThermometer1 = faTemperatureQuarter;
  
    var faThermometerQuarter = faTemperatureQuarter;
  

  
  

  var faR = {
    prefix: 'fasl',
    iconName: 'r',
    icon: [
      320,
      512,
      [114],
      '52',
      
      'M16 32H0V48 272 464v16H32V464 288H166.9L282.1 480h37.3L203.9 287.5C269 281.4 320 226.7 320 160c0-70.7-57.3-128-128-128H16zM176 256H32V64H192c53 0 96 43 96 96s-43 96-96 96H176z'
      
    ]
  };

  

  
  

  var faLockKeyhole = {
    prefix: 'fasl',
    iconName: 'lock-keyhole',
    icon: [
      448,
      512,
      ["lock-alt"],
      'f30d',
      
      'M224 32c53 0 96 43 96 96v64H128V128c0-53 43-96 96-96zM96 128v64H32 0v32V480v32H32 416h32V480 224 192H416 352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM32 224H416V480H32V224zm208 88V296H208v16 80 16h32V392 312z'
      
    ]
  };

  
    var faLockAlt = faLockKeyhole;
  

  
  

  var faDiamondHalf = {
    prefix: 'fasl',
    iconName: 'diamond-half',
    icon: [
      512,
      512,
      [],
      'e5b7',
      
      'M233.4 22.6L256 0V32 45.3 466.7 480v32l-22.6-22.6L224 480 22.6 278.6 0 256l22.6-22.6L224 32l9.4-9.4zM224 77.3L45.3 256 224 434.7V77.3z'
      
    ]
  };

  

  
  

  var faKitchenSet = {
    prefix: 'fasl',
    iconName: 'kitchen-set',
    icon: [
      576,
      512,
      [],
      'e51a',
      
      'M144 256a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm143.1-96c-8 72-69 128-143.1 128C64.5 288 0 223.5 0 144S64.5 0 144 0c74.1 0 135.2 56 143.1 128H352V96h32H512h32v32 32 32H512 384 352V160H287.1zm.9 160h32V272 256h16H464h16v16 48h32 32v32H512V480v32H480 320 288V480 352H256V320h32zm64 0h96V288H352v32zm128 32H320V480H480V352zm32-224H384v32H512V128zM192 144a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 144a80 80 0 1 1 160 0A80 80 0 1 1 64 144zM0 480H224v32H0V480zM160 352v32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H160zm16 64H160v32H128 64 32V416 352 320H64h64 32 16c26.5 0 48 21.5 48 48s-21.5 48-48 48zM64 352v64h64V384 352H64z'
      
    ]
  };

  

  
  

  var faAppleWhole = {
    prefix: 'fasl',
    iconName: 'apple-whole',
    icon: [
      448,
      512,
      [127822,127823,"apple-alt"],
      'f5d1',
      
      'M210.3 128H192V109.7 96 80c0-44.2 35.8-80 80-80h16 13.7H320V18.3 32 48c0 44.2-35.8 80-80 80H224 210.3zM272 32c-26.5 0-48 21.5-48 48V96h16c26.5 0 48-21.5 48-48V32H272zM112 128l112 32 112-32c76.3 0 112 83.7 112 160c0 128-80 224-160 224l-64-16-64 16C80 512 0 416 0 288c0-76.3 35.7-160 112-160zm120.8 62.8l-8.8 2.5-8.8-2.5L107.9 160.1c-22.3 1.3-39.8 13.7-53.2 35.9C40 220.3 32 254.2 32 288c0 57.5 18 106.6 43.6 140.8c24.9 33.1 54.7 49.7 80.8 51.1L216.2 465 224 463l7.8 1.9 59.8 14.9c26.1-1.4 56-18 80.8-51.1C398 394.6 416 345.5 416 288c0-33.8-8-67.7-22.8-92c-13.4-22.1-30.9-34.5-53.2-35.9L232.8 190.8z'
      
    ]
  };

  
    var faAppleAlt = faAppleWhole;
  

  
  

  var faCircleEuro = {
    prefix: 'fasl',
    iconName: 'circle-euro',
    icon: [
      512,
      512,
      [],
      'e5ce',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm152.2 16c-.7-5-1-10.1-1-15.2c0-5.7 .4-11.3 1.2-16.8H112V208h50.2c18.2-37.9 56.9-64 101.7-64H305h16v32H305 263.9c-26.3 0-49.6 12.6-64.4 32H304v32H184.9c-1.1 5.4-1.7 11-1.7 16.8c0 5.2 .5 10.3 1.4 15.2H304v32H198.4c14.7 20.3 38.5 33.5 65.5 33.5H305h16v32H305 263.9c-45.4 0-84.5-26.8-102.4-65.5H112V272h40.2z'
      
    ]
  };

  

  
  

  var faToiletPaperSlash = {
    prefix: 'fasl',
    iconName: 'toilet-paper-slash',
    icon: [
      640,
      512,
      [],
      'e072',
      
      'M416 192c0-81.8 30.7-149.2 70.3-158.8c3.2-.8 6.4-1.2 9.7-1.2c44.2 0 80 71.6 80 160c0 65.6-19.7 122-48 146.7l25.4 20c11.5-11.3 20.8-25.3 27.8-39.3C598.3 285.2 608 240.1 608 192s-9.7-93.2-26.8-127.4C565 32.2 536.7 0 496 0c-1.3 0-2.6 0-3.8 .1l0-.1H160c-14.1 0-27.5 6.1-39.5 17l25.7 20.3c5.6-4 10.4-5.3 13.8-5.3H432.3c-8.6 9.9-15.8 21.2-21.5 32.6C393.7 98.8 384 143.9 384 192c0 10.9-.1 21.8-.2 32.8l31.5 24.9c.5-19.6 .7-38.9 .7-57.7zM372 378.6c-6 35.6-14.9 69.8-27.9 101.4l0 0H56l.2-.4C92.4 388.2 96 281.8 96 192c0-10.4 .4-20.5 1.3-30.3L67.8 138.4c-2.5 17-3.8 35-3.8 53.6c0 89.9-3.9 190.6-37.6 275.8L21.3 480 8 512H42.7 365.3l8.2-19.7c12-28.9 20.6-59.7 26.8-91.3L372 378.6zM481.5 212.4c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6s-11.9-11.3-14.5-27.6zM527.4 256c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16s26.6-9.9 31.4-16zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faRabbit = {
    prefix: 'fasl',
    iconName: 'rabbit',
    icon: [
      512,
      512,
      [128007],
      'f708',
      
      'M341 50.3c-4.8-10.2-10.4-20.1-16.9-29.5c1.8-2 3.7-3.9 5.6-5.8L340.2 4.6 344.8 0l6.6 0 32 0 13.9 0 2 13.7L403 40.1c4.2 29.6 1 59.4-8.7 86.8c1.6 1.2 3.1 2.4 4.7 3.6l59.1 48.2 5.9 4.8v7.6V280v16H448 368v9.1L493.3 486.9 510.6 512H480.1 402.4 394l-4.8-6.9-37.2-54V496v16H336 304 176 144 128v0H112 96V496 475.9c-7.5 2.7-15.6 4.1-24 4.1c-39.8 0-72-32.2-72-72s32.2-72 72-72c14.2 0 27.5 4.1 38.6 11.2c23.8-59.9 74.6-106.1 137.4-123.6V186.1c-35-39.7-51.2-93-43.6-145.9l3.8-26.4 2-13.7L224 0l32 0 6.6 0 4.7 4.6L277.7 15c24.9 24.7 41 55.8 47.4 89c14 .1 27.8 2.6 40.7 7.5c6.8-21.3 8.9-44.1 5.6-66.8L369.5 32 358 32l-5.7 5.7c-4 4-7.8 8.2-11.2 12.6zM100.6 380.1C93.4 372.6 83.2 368 72 368c-22.1 0-40 17.9-40 40s17.9 40 40 40c9 0 17.3-3 24-8V424c0-15.1 1.6-29.8 4.6-43.9zM352 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM176 480H304h16V448H304 268.6 231.4L257 421l51.9-54.8 13.6-14.3 11.2 16.3L410.8 480h38.9L338.8 319.1 336 315v-5V280 264h16 80V198.7l-53.2-43.4c-15.3-12.5-34.5-19.3-54.3-19.3c-3.3 0-6.5 .4-9.6 1l-17.7 3.9-1.7-18c-3-31.7-16.9-62-40.3-85.2L249.4 32l-11.5 0-1.8 12.7c-6.5 45.4 8.2 91.1 39.5 124.2l4.4 4.7L280 180l0 .4v55.7 13l-12.7 2.7C187.7 268.7 128 339.4 128 424v56h16 16v0h16zm142.6-77.5L305.8 416h22l-9.3-13.5z'
      
    ]
  };

  

  
  

  var faValueAbsolute = {
    prefix: 'fasl',
    iconName: 'value-absolute',
    icon: [
      512,
      512,
      [],
      'f6a6',
      
      'M32 32H0V48 464v16H32V464 48 32zM171.3 148.7L160 137.4 137.4 160l11.3 11.3L233.4 256l-84.7 84.7L137.4 352 160 374.6l11.3-11.3L256 278.6l84.7 84.7L352 374.6 374.6 352l-11.3-11.3L278.6 256l84.7-84.7L374.6 160 352 137.4l-11.3 11.3L256 233.4l-84.7-84.7zM512 48V32H480V48 464v16h32V464 48z'
      
    ]
  };

  

  
  

  var faAngel = {
    prefix: 'fasl',
    iconName: 'angel',
    icon: [
      576,
      512,
      [],
      'f779',
      
      'M384 64.2c0-.1 0-.1 0-.2s0-.1 0-.2s-.1-.3-.2-.6c-.3-.6-.9-1.8-2.3-3.5c-2.9-3.5-8.4-7.9-17.3-12.4C346.4 38.4 319.5 32 288 32s-58.4 6.4-76.2 15.4c-8.9 4.5-14.4 8.9-17.3 12.4c-1.4 1.7-2 2.8-2.3 3.5c-.1 .3-.2 .5-.2 .6s0 .1 0 .2s0 .1 0 .2s.1 .3 .2 .6c.3 .6 .9 1.8 2.3 3.5c1.4 1.7 3.4 3.6 6.2 5.6c-6.7 8.3-12.2 17.6-16.3 27.7C169 91 160 78 160 64c0-35.3 57.3-64 128-64s128 28.7 128 64c0 14-9 27-24.3 37.5c-4.1-10-9.6-19.3-16.3-27.7c2.7-2 4.8-4 6.2-5.6c1.4-1.7 2-2.8 2.3-3.5c.1-.3 .2-.5 .2-.6zM288 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM74.6 334.2l9.9 14.9-7.5 16.3L32 463v17h80L216.9 270.2 138.7 192H32v78.3l42.6 63.9zM248 256h80l96-96H544h32v32 88l-48 72 48 104v24 32H544 480 444.2 131.8 96 32 0V480 456L48 352 0 280V192 160H32 152l96 96zm111.1 14.2L464 480h80V463l-45.1-97.6-7.5-16.3 9.9-14.9L544 270.3V192H437.3l-78.2 78.2zM428.2 480l-96-192H243.8l-96 192H428.2z'
      
    ]
  };

  

  
  

  var faFolders = {
    prefix: 'fasl',
    iconName: 'folders',
    icon: [
      576,
      512,
      [],
      'f660',
      
      'M304 32H128 96V64 352v32h32H544h32V352 128 96H544 368L304 32zm64 96H544V352H128V64H290.7l54.6 54.6 9.4 9.4H368zM32 112V96H0v16V464v16H16 464h16V448H464 32V112z'
      
    ]
  };

  

  
  

  var faGaugeCirclePlus = {
    prefix: 'fasl',
    iconName: 'gauge-circle-plus',
    icon: [
      640,
      512,
      [],
      'e498',
      
      'M256 480c32.2 0 62.8-6.8 90.5-19c5.8 9.3 12.5 18 19.8 26.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-8.4 0-16.7 .6-24.8 1.7C444.3 100.3 358.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-194 0-16 32 0 0 16 0 194c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64zM144 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM72 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM344 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64v48h48 16v32H560 512v48l0 16H480V432 384H432l-16 0V352h16 48V304 288h32v16z'
      
    ]
  };

  

  
  

  var faCirclePause = {
    prefix: 'fasl',
    iconName: 'circle-pause',
    icon: [
      512,
      512,
      [62092,"pause-circle"],
      'f28b',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224-80V336v16H192V336 176 160h32v16zm96 0V336v16H288V336 176 160h32v16z'
      
    ]
  };

  
    var faPauseCircle = faCirclePause;
  

  
  

  var faBottleWater = {
    prefix: 'fasl',
    iconName: 'bottle-water',
    icon: [
      320,
      512,
      [],
      'e4c5',
      
      'M128 32l0 48 64 0 0-48-64 0zM96 83.4L96 80l0-48L96 0l32 0 64 0 32 0 0 32 0 48 0 3.4c7.6 2.1 14.9 5 21.8 8.9l6.2 3.4c27.1 15.1 44 43.7 44 74.8c0 15.9-4.3 30.8-11.9 43.5c7.5 12.2 11.9 26.6 11.9 42c0 18-6 34.6-16 48c10 13.4 16 30 16 48c0 17-5.3 32.7-14.3 45.6c9 14.6 14.3 31.9 14.3 50.4l0 32 0 32-32 0L56 512l-32 0 0-32 0-32c0-18.5 5.2-35.7 14.3-50.4C29.3 384.7 24 369 24 352c0-18 6-34.6 16-48c-10-13.4-16-30-16-48c0-15.4 4.4-29.8 11.9-42C28.3 201.3 24 186.4 24 170.5c0-31.1 16.8-59.7 44-74.8l6.2-3.4c6.9-3.8 14.3-6.8 21.8-8.9zM121.6 112c-11.1 0-22.1 2.8-31.8 8.3l-6.2 3.4C66.5 133.1 56 151 56 170.5c0 10 2.7 19.3 7.4 27.2c6.1 10.2 5.9 23-.3 33.1C58.6 238.1 56 246.7 56 256c0 10.8 3.6 20.8 9.6 28.8c8.6 11.4 8.6 27.1 0 38.4c-6 8-9.6 17.9-9.6 28.8c0 10.2 3.2 19.6 8.5 27.3c7.3 10.5 7.6 24.2 1 35.1c-6 9.7-9.5 21.2-9.5 33.6l0 32 208 0 0-32c0-12.4-3.5-23.8-9.5-33.6c-6.7-10.8-6.3-24.6 1-35.1c5.4-7.8 8.5-17.1 8.5-27.3c0-10.8-3.6-20.8-9.6-28.8c-8.6-11.4-8.6-27.1 0-38.4c6-8 9.6-17.9 9.6-28.8c0-9.3-2.6-17.9-7.1-25.2c-6.3-10.1-6.4-22.9-.3-33.1c4.7-8 7.4-17.2 7.4-27.2c0-19.4-10.5-37.3-27.5-46.8l-6.2-3.4c-9.7-5.4-20.7-8.3-31.8-8.3l-6.4 0-64 0-6.4 0zM112 224l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 368c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faFaceSurprise = {
    prefix: 'fasl',
    iconName: 'face-surprise',
    icon: [
      512,
      512,
      [128558,"surprise"],
      'f5c2',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM208 352a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z'
      
    ]
  };

  
    var faSurprise = faFaceSurprise;
  

  
  

  var faArrowRightToArc = {
    prefix: 'fasl',
    iconName: 'arrow-right-to-arc',
    icon: [
      512,
      512,
      [],
      'e4b2',
      
      'M480 256C480 132.3 379.7 32 256 32H240V0h16C397.4 0 512 114.6 512 256s-114.6 256-256 256H240V480h16c123.7 0 224-100.3 224-224zM202.6 116l144 128 13.5 12-13.5 12-144 128-12 10.6-21.3-23.9 12-10.6L293.9 272H16 0V240H16 293.9L181.4 140l-12-10.6 21.3-23.9 12 10.6z'
      
    ]
  };

  

  
  

  var faUserShakespeare = {
    prefix: 'fasl',
    iconName: 'user-shakespeare',
    icon: [
      448,
      512,
      [],
      'e2c2',
      
      'M304 112v48c0 40.1-29.5 73.3-68 79.1V224 212H212v12 15.1c-38.5-5.8-68-39-68-79.1V112c0-44.2 35.8-80 80-80s80 35.8 80 80zM96 80v32 40L64 192v32 32H96h70.3c16.9 10.2 36.6 16 57.7 16s40.9-5.8 57.7-16H352h32V224 192l-32-40V112 80H331.4C317.6 33.7 274.7 0 224 0s-93.6 33.7-107.4 80H96zM315.9 224c8.9-12.7 15.2-27.4 18.1-43.2L352 203.2V224H315.9zM96 224V203.2l17.9-22.4c3 15.8 9.3 30.5 18.1 43.2H96zm112-96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 31l-8.5 8.5C204.9 178.1 194.1 180 192 180H180v24h12c7 0 19.6-3 32.1-12.3c2.2 1.6 4.5 3.2 7.1 4.6c6.5 3.8 15.4 7.6 24.8 7.6h12V180H256c-3.3 0-7.8-1.5-12.8-4.4c-4.8-2.8-8.8-6.1-10.7-8.1L224 159zM144 288h-6.6l-4.7 4.7L105.4 320H64L10.7 480 0 512H33.7 414.3 448l-10.7-32L384 320H342.6l-27.3-27.3-4.7-4.7H304 224 144zm64 32v32H144h-5.3l-4.3 3.2L128 360V342.6L150.6 320H208zm32 32V320h57.4L320 342.6V360l-6.4-4.8-4.3-3.2H304 240zm-16 32h74.7l27.7 20.8L352 424V392 352h8.9l42.7 128H240c0-8.8-7.2-16-16-16s-16 7.2-16 16H44.4L87.1 352H96v40 32l25.6-19.2L149.3 384H224zm0 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faMartiniGlassCitrus = {
    prefix: 'fasl',
    iconName: 'martini-glass-citrus',
    icon: [
      576,
      512,
      ["cocktail"],
      'f561',
      
      'M544 144c0-61.9-50.1-112-112-112c-44.7 0-83.2 26.2-101.2 64H296.2C316 40.1 369.3 0 432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-28.2 0-54.5-8.1-76.7-22.1l23.4-23.4c15.8 8.6 34 13.5 53.3 13.5c61.9 0 112-50.1 112-112zM0 160V128H32 384h32v32L230.6 345.4 224 352V480h96v32H224 208 96V480h96V352l-6.6-6.6L0 160zM208 322.7L370.7 160H45.3L208 322.7z'
      
    ]
  };

  
    var faCocktail = faMartiniGlassCitrus;
  

  
  

  var faBracketsRound = {
    prefix: 'fasl',
    iconName: 'brackets-round',
    icon: [
      512,
      512,
      ["parentheses"],
      'e0c5',
      
      'M136.4 33.9C91.2 58.4 0 136.7 0 256S91.2 453.6 136.4 478.1l15.2-28.1C111.5 428.2 32 358.6 32 256S111.5 83.8 151.6 62.1L136.4 33.9zm239.2 0L360.4 62.1C400.5 83.8 480 153.4 480 256s-79.5 172.2-119.6 193.9l15.2 28.1C420.8 453.6 512 375.3 512 256s-91.2-197.6-136.4-222.1z'
      
    ]
  };

  
    var faParentheses = faBracketsRound;
  

  
  

  var faArrowLeftLongToLine = {
    prefix: 'fasl',
    iconName: 'arrow-left-long-to-line',
    icon: [
      640,
      512,
      [],
      'e3d4',
      
      'M0 80V432v16H32V432 80 64H0V80zM128 256l11.3 11.3 144 144 11.3 11.3L317.3 400l-11.3-11.3L189.3 272 624 272h16V240H624l-434.7 0L305.9 123.3 317.3 112 294.6 89.4l-11.3 11.3-144 144L128 256z'
      
    ]
  };

  

  
  

  var faPawSimple = {
    prefix: 'fasl',
    iconName: 'paw-simple',
    icon: [
      448,
      512,
      ["paw-alt"],
      'f701',
      
      'M152 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM136.7 310.2l7.3-14.6L195.8 192h56.4l51.8 103.7 7.3 14.6 16 2.7c32.1 5.4 56.6 33.4 56.6 67.1c0 37.6-30.4 68-68 68c-16.9 0-32.3-6.1-44.2-16.3l-9-7.7H251 197 185.2l-9 7.7C164.3 441.9 148.9 448 132 448c-37.6 0-68-30.4-68-68c0-33.7 24.5-61.7 56.6-67.1l16-2.7zM176 160L115.3 281.4C68 289.3 32 330.5 32 380c0 55.2 44.8 100 100 100c24.8 0 47.5-9 65-24h54c17.5 15 40.2 24 65 24c55.2 0 100-44.8 100-100c0-49.5-36-90.7-83.3-98.6L272 160H176zm96-72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 240 88a56 56 0 1 0 112 0zm40 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM32 200a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 0 200a56 56 0 1 0 112 0z'
      
    ]
  };

  
    var faPawAlt = faPawSimple;
  

  
  

  var faHouseCrack = {
    prefix: 'fasl',
    iconName: 'house-crack',
    icon: [
      576,
      512,
      [],
      'e3b1',
      
      'M298.6 12L288 2.7 277.4 12 5.4 252l21.2 24L64 243V496v16H80 496h16V496 243l37.4 33 21.2-24L298.6 12zM96 480V214.7L288 45.3 480 214.7V480H312.6l-50.4-75.6 82.7-55.1 16.2-10.8-13.8-13.8-96-96L240 217.4 217.4 240l11.3 11.3 82.2 82.2-79.8 53.2-13.3 8.9 8.9 13.3L274.1 480H96z'
      
    ]
  };

  

  
  

  var faLeftToLine = {
    prefix: 'fasl',
    iconName: 'left-to-line',
    icon: [
      448,
      512,
      ["arrow-alt-to-left"],
      'f34b',
      
      'M32 432l0 16L0 448l0-16L0 80 0 64l32 0 0 16 0 352zM304 208l-32 0 0-32 0-48-17.7 0L139.1 256 254.3 384l17.7 0 0-48 0-32 32 0 112 0 0-96-112 0zm0-112l0 32 0 16 0 32 32 0 80 0 32 0 0 32 0 96 0 32-32 0-80 0-32 0 0 32 0 16 0 32-32 0-32 0L96 256 240 96l32 0 32 0z'
      
    ]
  };

  
    var faArrowAltToLeft = faLeftToLine;
  

  
  

  var faHexagonMinus = {
    prefix: 'fasl',
    iconName: 'hexagon-minus',
    icon: [
      512,
      512,
      ["minus-hexagon"],
      'f307',
      
      'M36.9 256L146.6 64H365.4L475.1 256 365.4 448H146.6L36.9 256zM128 32L0 256 128 480H384L512 256 384 32H128zm32 208H144v32h16H352h16V240H352 160z'
      
    ]
  };

  
    var faMinusHexagon = faHexagonMinus;
  

  
  

  var faDumpsterFire = {
    prefix: 'fasl',
    iconName: 'dumpster-fire',
    icon: [
      640,
      512,
      [],
      'f794',
      
      'M304 64H410.4l8.5 44.8c4.3-3 8.3-5.7 12.1-8L448 90.1 443 64h74.8l12.8 64L542 116.6l22.5 18.7 .2 .2L544 32H424c-.2 0-.4 0-.6 0H288l0 0 0 0H152.3c-.2 0-.4 0-.6 0H32L6.4 160 0 192H32.6h1.1H66h61.7 .6L288 192h46.1c2.9-4 5.9-7.9 8.9-11.7c5.7-7.1 11.5-13.9 17.5-20.3H304V64zm33 384c-8.8-9.8-16.6-20.5-23.3-32H92.3L69.8 224H37.5l3.8 32H16 0v32H16 45.1L64 448.9V464v16H96V464 448H337zM272 64v96H147.3l18-96H272zM132.7 64l-18 96H39L58.2 64h74.5zM489.4 169.4L448 128c-42.7 26.7-128 102.4-128 192c0 85.2 66.6 154.9 150.7 159.7c3.1 .3 6.2 .4 9.3 .4s6.3-.1 9.3-.4C573.4 474.9 640 405.2 640 320c0-26.7-19.2-96-96-160l-9.4 9.4L512 192l-22.6-22.6zM480 448c-2.4 0-4.8-.1-7.2-.2c-33.6-3.3-56.8-29.4-56.8-57.2c0-21.9 15.9-47.5 39-71.3c8.8-9 17.6-16.9 25-23c7.4 6.1 16.2 13.9 25 23c23.1 23.8 39 49.5 39 71.3c0 27.8-23.2 54-56.8 57.2c-2.4 .1-4.8 .2-7.2 .2zm96-57.4c0-70.4-96-134.4-96-134.4s-96 64-96 134.4c0 5.4 .5 10.6 1.5 15.8C364.7 383.6 352 353.3 352 320c0-34.7 16.7-69.1 41-99.7c16.4-20.6 35.2-38 51.4-50.7l45 45L512 237.3l22.6-22.6L545 204.2C597 256.3 608 305.9 608 320c0 33.3-12.7 63.6-33.5 86.3c1-5.1 1.5-10.4 1.5-15.8z'
      
    ]
  };

  

  
  

  var faCircleArrowDownLeft = {
    prefix: 'fasl',
    iconName: 'circle-arrow-down-left',
    icon: [
      512,
      512,
      [],
      'e0f9',
      
      'M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM176 352H160V336 192 176h32v16V297.4L324.7 164.7 336 153.4 358.6 176l-11.3 11.3L214.6 320H312h16v32H312 176z'
      
    ]
  };

  

  
  

  var faHouseUser = {
    prefix: 'fasl',
    iconName: 'house-user',
    icon: [
      576,
      512,
      ["home-user"],
      'e1b0',
      
      'M288 2.7L298.6 12l272 240-21.2 24L512 243V496v16H496 80 64V496 243L26.6 276 5.4 252l272-240L288 2.7zM96 214.7V480H480V214.7L288 45.3 96 214.7zM288 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM231.1 352l-21.3 64H176l32-96H368l32 96H366.3l-21.3-64H231.1z'
      
    ]
  };

  
    var faHomeUser = faHouseUser;
  

  
  

  var faMarsAndVenus = {
    prefix: 'fasl',
    iconName: 'mars-and-venus',
    icon: [
      512,
      512,
      [9893],
      'f224',
      
      'M368 0H352V32h16 73.4l-75.6 75.6C337.1 80.6 298.5 64 256 64C167.6 64 96 135.6 96 224c0 83 63.1 151.2 144 159.2V416H208 192v32h16 32v48 16h32V496 448h32 16V416H304 272V383.2c80.9-8 144-76.2 144-159.2c0-34.3-10.8-66.1-29.2-92.2L464 54.6V128v16h32V128 16 0H480 368zM256 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256z'
      
    ]
  };

  

  
  

  var faFileChartPie = {
    prefix: 'fasl',
    iconName: 'file-chart-pie',
    icon: [
      384,
      512,
      [],
      'f65a',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM176 216v16 96 16h16 96 16V328c0-61.9-50.1-112-112-112H176zm32 33.6c31.3 6.4 56 31.1 62.4 62.4H208V249.6zm-56-21C105.7 242.4 72 285.3 72 336c0 61.9 50.1 112 112 112c50.7 0 93.6-33.7 107.4-80h-34c-12.3 28.3-40.5 48-73.3 48c-44.2 0-80-35.8-80-80c0-32.8 19.7-61 48-73.3v-34z'
      
    ]
  };

  

  
  

  var faHeart = {
    prefix: 'fasl',
    iconName: 'heart',
    icon: [
      512,
      512,
      [9829,10084,61578,128153,128154,128155,128156,128420,129293,129294,129505],
      'f004',
      
      'M256 141.3l-22.6-22.6L209.1 94.4C189.7 74.9 163.3 64 135.8 64C78.5 64 32 110.5 32 167.8c0 27.5 10.9 53.9 30.4 73.4l24.2 24.2L256 434.8 425.4 265.4l24.2-24.2c19.5-19.5 30.4-45.9 30.4-73.4C480 110.5 433.5 64 376.2 64c-27.5 0-53.9 10.9-73.4 30.4l-24.2 24.2L256 141.3zm22.6 316.1L256 480l-22.6-22.6L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8l1.6 1.6L256 96l22.6-22.6 1.6-1.6c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 36-14.3 70.5-39.8 96L448 288 278.6 457.4z'
      
    ]
  };

  

  
  

  var faFaceNauseated = {
    prefix: 'fasl',
    iconName: 'face-nauseated',
    icon: [
      512,
      512,
      [],
      'e381',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM203.3 123.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-5.3-31.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4 22.6 22.6zM175.6 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm160 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-19.6-53.3l-7.4-7.4 22.6-22.6 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4-5.3 31.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7zM176 336c0-17.7-9.6-33.3-24-41.6l16-27.7c19.5 11.3 33.8 30.5 38.4 53.3h99.2c4.6-22.8 18.9-42 38.4-53.3l16 27.7c-14.4 8.3-24 23.8-24 41.6s9.6 33.3 24 41.6l-16 27.7c-19.5-11.3-33.8-30.5-38.4-53.3H206.4c-4.6 22.8-18.9 42-38.4 53.3l-16-27.7c14.4-8.3 24-23.8 24-41.6z'
      
    ]
  };

  

  
  

  var faBookCircleArrowUp = {
    prefix: 'fasl',
    iconName: 'book-circle-arrow-up',
    icon: [
      640,
      512,
      [],
      'e0bd',
      
      'M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H394.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H326.6c-2.9-10.3-4.9-21-5.9-32H64c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H416V211.2c10.1-5.2 20.8-9.4 32-12.6V16 0H432 64zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-222.6-8L440 382.6l11.3-11.3L480 342.6V432v16h32V432 342.6l28.7 28.7L552 382.6 574.6 360l-11.3-11.3-56-56L496 281.4l-11.3 11.3-56 56L417.4 360z'
      
    ]
  };

  

  
  

  var faShirtRunning = {
    prefix: 'fasl',
    iconName: 'shirt-running',
    icon: [
      384,
      512,
      [],
      'e3c8',
      
      'M96 0H80 64V16 64v60.6L1.4 265.5 0 268.6V272 496v16H16 368h16V496 272v-3.4l-1.4-3.1L320 124.6V64 16 0H304 288V16 64c0 53-43 96-96 96s-96-43-96-96V16 0zM32 275.4L91 142.6c23.4 30 60 49.4 101 49.4s77.6-19.3 101-49.4l21.9 49.3-4.3 3.1L32 396.3V275.4zm0 160.3l9.4-6.8L328.2 221.8 352 275.4V480H32V435.7z'
      
    ]
  };

  

  
  

  var faSignPostsWrench = {
    prefix: 'fasl',
    iconName: 'sign-posts-wrench',
    icon: [
      640,
      512,
      [],
      'e626',
      
      'M64 64H32V384H332c4.4 11.3 9.9 22 16.5 32H96l0 96H64l0-96H32 0V384 64 32H32 64L64 0H96l0 32H480l0-32h32l0 32h32 32V64v96H544V64H512 480 96 64zM434 192h14 16v16 87.4l32 21.3 32-21.3V208 192h16 14 4.1l3.6 2C610 218.6 640 265.8 640 320c0 42.7-18.6 81-48 107.3V496v16H560V496 419.9v-7.7l6-4.8c25.6-20.6 42-52.1 42-87.4c0-38-19-71.7-48-91.9V304v8.6l-7.1 4.7-48 32-8.9 5.9-8.9-5.9-48-32-7.1-4.7V304 228.1c-29 20.3-48 53.9-48 91.9c0 35.4 16.4 66.9 42 87.4l6 4.8v7.7V496v16H400V496 427.3C370.6 401 352 362.7 352 320c0-54.2 30-101.4 74.2-126l3.6-2H434z'
      
    ]
  };

  

  
  

  var faGridRound4 = {
    prefix: 'fasl',
    iconName: 'grid-round-4',
    icon: [
      448,
      512,
      [],
      'e5dd',
      
      'M44.8 56a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zM0 76.8a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 76.8zm44.8 98.7a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zM0 196.3a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 196.3zM65.6 315.7a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zM44.8 270.9a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zM0 435.2a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 435.2zM185.1 76.8a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zM164.3 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm65.6 119.5a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zm-20.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM304.5 76.8a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zM283.7 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm65.6 119.5a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zm-20.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM424 76.8a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zM403.2 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM424 315.7a20.8 20.8 0 1 1 -41.6 0 20.8 20.8 0 1 1 41.6 0zm-20.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0z'
      
    ]
  };

  

  
  

  var faFaceThermometer = {
    prefix: 'fasl',
    iconName: 'face-thermometer',
    icon: [
      576,
      512,
      [],
      'e39a',
      
      'M288 32C164.3 32 64 132.3 64 256s100.3 224 224 224c92 0 171.1-55.5 205.6-134.9L540 301.1C518.8 421 414 512 288 512C146.6 512 32 397.4 32 256S146.6 0 288 0c97 0 181.4 54 224.8 133.5c-11.3-.2-22.6 1.9-33.2 6.4C440.3 75.2 369.2 32 288 32zM477 179.4c19.6-18.8 50.6-18.4 69.8 .7c19.8 19.8 19.4 52.1-.9 71.4L408.3 382.6c2.5 3.7 4.5 7.1 6 10.3l-28.6 14.3C376.9 389.7 344.4 352 288 352s-88.9 37.7-97.7 55.2l-28.6-14.3C174.3 367.7 216.4 320 288 320c13.5 0 26 1.7 37.4 4.6L477 179.4zM429.4 318.3l-5.8-5.8L415 304l17-17 8.5 8.5 6.3 6.3 15.4-14.7-6.6-6.6L447 272l17-17 8.5 8.5 7 7 15.4-14.7-7.4-7.4L479 240l17-17 8.5 8.5 7.8 7.8 11.5-11c7.3-6.9 7.4-18.5 .3-25.6c-6.9-6.9-18-7-25-.3l-140.9 135c11.3 6.1 21 13.4 29.1 20.8l9.3-8.8-5.1-5.1L383 336l17-17 8.5 8.5L414 333l15.4-14.7zM184.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faPlugCircleBolt = {
    prefix: 'fasl',
    iconName: 'plug-circle-bolt',
    icon: [
      576,
      512,
      [],
      'e55b',
      
      'M128 16V0H96V16v96h32V16zm160 0V0H256V16v96h32V16zM16 144H0v32H16 32v64c0 83 63.1 151.2 144 159.2V496v16h32V496 399.2c17.3-1.7 33.7-6.2 48.9-12.9c-.6-6-.9-12.1-.9-18.3c0-6 .3-11.8 .9-17.6c-19 11.2-41.2 17.6-64.9 17.6c-70.7 0-128-57.3-128-128V176H320v56.2c9.8-8.1 20.6-15.2 32-21V176h16 16V144H368 352 320 64 32 16zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM456 288L352 384h66.7L408 448l104-96H445.3L456 288z'
      
    ]
  };

  

  
  

  var faTrophyStar = {
    prefix: 'fasl',
    iconName: 'trophy-star',
    icon: [
      576,
      512,
      ["trophy-alt"],
      'f2eb',
      
      'M272 381.1l-.4-.1-2.3-.4c-34-6-100.6-27.8-159.1-74.4C51.2 259.2 0 186.5 0 80V64H16 129.6c-.5-10.3-.9-21-1.2-32c-.3-10.4-.4-21-.4-32h32H416h32c0 11-.1 21.6-.4 32c-.3 11-.7 21.7-1.2 32H560h16V80c0 106.5-51.2 179.2-110.2 226.1c-58.5 46.6-125.1 68.5-159.1 74.4l-2.3 .4-.4 .1V480h96 16v32H400 288 176 160V480h16 96V381.1zm16-29.7l8.9-1.6c1.3-.4 2.7-.9 4.2-1.5c10.2-4.1 25.8-13 42.3-32.8c31.3-37.5 68-117.1 72.2-283.5H160.4c4.2 166.4 40.9 246 72.2 283.5c16.5 19.8 32.1 28.7 42.3 32.8c1.5 .6 2.9 1.1 4.2 1.5l8.9 1.6zm157.9-70.3C496 241.2 538.8 181.9 543.6 96H444.2c-9.8 116.5-37.2 185.9-66.4 227.2c22.2-10.5 45.8-24.3 68.1-42.1zm-315.8 0c22.3 17.8 46 31.6 68.1 42.1C169 281.9 141.5 212.5 131.8 96H32.4c4.8 85.9 47.6 145.2 97.7 185.1zM302.3 88.9l17.4 35.3 39 5.7 32.1 4.7-23.2 22.6-28.2 27.5 6.7 38.8 5.5 32-28.7-15.1L288 222.1l-34.9 18.3-28.7 15.1 5.5-32 6.7-38.8-28.2-27.5-23.2-22.6 32.1-4.7 39-5.7 17.4-35.3L288 59.8l14.3 29.1zm-21.2 57l-3.7 7.5-8.3 1.2-15.2 2.2 11 10.7 6 5.9-1.4 8.3L266.9 197l13.6-7.2 7.4-3.9 7.4 3.9 13.6 7.2-2.6-15.2-1.4-8.3 6-5.9 11-10.7-15.2-2.2-8.3-1.2-3.7-7.5L288 132.2 281.2 146z'
      
    ]
  };

  
    var faTrophyAlt = faTrophyStar;
  

  
  

  var faCircleThreeQuarters = {
    prefix: 'fasl',
    iconName: 'circle-three-quarters',
    icon: [
      512,
      512,
      [],
      'e125',
      
      'M224 288V256 34.3C115.4 49.8 32 143.2 32 256c0 123.7 100.3 224 224 224c112.8 0 206.2-83.4 221.7-192H256 224zm286 0C494.3 414.3 386.5 512 256 512C114.6 512 0 397.4 0 256C0 125.5 97.7 17.7 224 2c10.5-1.3 21.2-2 32-2V32 224v32h32H480h32c0 10.8-.7 21.5-2 32z'
      
    ]
  };

  

  
  

  var faArrowsToEye = {
    prefix: 'fasl',
    iconName: 'arrows-to-eye',
    icon: [
      640,
      512,
      [],
      'e4bf',
      
      'M32 9.4L9.4 32 20.7 43.3 105.4 128H48 32v32H48h96 16V144 48 32H128V48v57.4L43.3 20.7 32 9.4zM596.7 20.7L512 105.4V48 32H480V48v96 16h16 96 16V128H592 534.6l84.7-84.7L630.6 32 608 9.4 596.7 20.7zM630.6 480l-11.3-11.3L534.6 384H592h16V352H592 496 480v16 96 16h32V464 406.6l84.7 84.7L608 502.6 630.6 480zM9.4 480L32 502.6l11.3-11.3L128 406.6V464v16h32V464 368 352H144 48 32l0 32H48h57.4L20.7 468.7 9.4 480zM320 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM213.7 322.6c-23.3-21.6-40.3-46.9-50.4-66.6c10.1-19.6 27.1-44.9 50.4-66.6C242 163.2 277.6 144 320 144s78 19.2 106.3 45.4c23.3 21.6 40.3 46.9 50.4 66.6c-10.1 19.6-27.1 44.9-50.4 66.6C398 348.8 362.4 368 320 368s-78-19.2-106.3-45.4zM320 400c105.6 0 172-96 192-144c-20-48-86.4-144-192-144s-172 96-192 144c20 48 86.4 144 192 144z'
      
    ]
  };

  

  
  

  var faScrewdriverWrench = {
    prefix: 'fasl',
    iconName: 'screwdriver-wrench',
    icon: [
      512,
      512,
      ["tools"],
      'f7d9',
      
      'M160 160V112L67 42.3 42.3 67 112 160h48zm32 0v9.4l99.3 99.3 14.1-14.1L328 232l22.6 22.6L489.4 393.4 512 416l-22.6 22.6-50.7 50.7L416 512l-22.6-22.6L254.6 350.6 232 328l22.6-22.6 14.1-14.1L169.4 192H160 96L0 64 64 0 192 96v64zM416 466.7L466.7 416 328 277.3 277.3 328 416 466.7zM22.6 377.4L166.1 233.9l22.6 22.6L45.3 400 112 466.7 218.7 360l22.6 22.6L134.6 489.4 112 512 89.4 489.4 22.6 422.6 0 400l22.6-22.6zM480 160c0-10.7-1.3-21.1-3.8-31l-53.6 53.6-9.4 9.4H400 352 320V160 112 98.7l9.4-9.4L383 35.8c-9.9-2.5-20.3-3.8-31-3.8c-46.5 0-87.2 24.8-109.6 61.8L216.7 74.5C245.1 29.7 295.1 0 352 0c19.9 0 38.9 3.6 56.5 10.3c10.6 4 20.7 9.1 30.1 15.2L415.3 48.7 352 112v16 32h32 16l63.3-63.3 23.3-23.3c6.1 9.4 11.2 19.5 15.2 30.1c6.6 17.6 10.3 36.6 10.3 56.5c0 57.2-30 107.3-75.1 135.6l-23.4-23.4C453.1 250.5 480 208.4 480 160zM120 414.6L97.4 392 120 369.4 142.6 392 120 414.6z'
      
    ]
  };

  
    var faTools = faScrewdriverWrench;
  

  
  

  var faHandHorns = {
    prefix: 'fasl',
    iconName: 'hand-horns',
    icon: [
      384,
      512,
      [],
      'e1a9',
      
      'M32 0H48h80 16V16 144h64 16v16 16h48V80 64h16 80 16V80 224v16V352c0 88.4-71.6 160-160 160H160C71.6 512 0 440.4 0 352V256 240H16 32V16 0zM224 208l0 32v16l0 16 0 48h48V240 208H224zm-32 64l0 0H144v0H112v0H32v80c0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128V240 224 96H304v80 16 48 96 16H288 224 208 192 112 96V320h16 80l0-48zm-80-32V160 144 32H64V240h48zm32 0h48V192 176H144v64z'
      
    ]
  };

  

  
  

  var faFaceSleepy = {
    prefix: 'fasl',
    iconName: 'face-sleepy',
    icon: [
      512,
      512,
      [],
      'e38e',
      
      'M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c34.6 0 67.3-7.8 96.5-21.8c1.2 11.1 4.2 21.6 8.8 31.2C329.2 503.9 293.6 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 30.6-5.4 59.9-15.2 87c-8.4-8.4-17.4-15.8-26.3-22.2c6.2-20.5 9.5-42.3 9.5-64.8C480 132.3 379.7 32 256 32zM116.8 234.4c21.6 28.8 64.8 28.8 86.4 0l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0l25.6-19.2zm278.4 0l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0l25.6-19.2c21.6 28.8 64.8 28.8 86.4 0zm-32 200l-26.1-10.9C313.4 413.7 285.7 408 256 408c-29.7 0-57.3 5.7-81 15.5l-26.1 10.9 4.2-28c7.4-49.3 51-86.4 103-86.4s95.7 37.1 103 86.5l4.2 28zm-46.9-51.2C303.5 364.5 281.5 352 256 352s-47.5 12.5-60.3 31.2c19-4.7 39.3-7.2 60.3-7.2c21 0 41.3 2.5 60.3 7.2zm62.8-71.9c20.8 6.2 43.3 16.1 63.6 29.3C478.5 363.7 512 399.9 512 448c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-16.2-.1-39.4-7.2-61.5c-4.5-13.8-11.5-26.8-23-37.1l25.4-38.1zm28.1 65.4c8.8 27.2 8.8 54.9 8.8 70.8v.5c0 17.7 14.3 32 32 32s32-14.3 32-32c0-31.9-22.5-59.7-54.7-80.6c-9.4-6.1-19.3-11.3-29.1-15.7c4.7 8.1 8.3 16.5 11 24.9z'
      
    ]
  };

  

  
  

  var faTarp = {
    prefix: 'fasl',
    iconName: 'tarp',
    icon: [
      576,
      512,
      [],
      'e57b',
      
      'M32 416L32 96l512 0V256l-144 0H384v16l0 144L32 416zm386.7 0H416l0-128H544v2.7L418.7 416zM576 304V96 64H544 32 0V96 416v32H32l400 0L576 304zM96 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faHammerBrush = {
    prefix: 'fasl',
    iconName: 'hammer-brush',
    icon: [
      640,
      512,
      [],
      'e620',
      
      'M128 0C57.3 0 0 57.3 0 128v40 23.1L21.6 183 72.1 164l9.6 19.1 4.4 8.8H96h7.3L96.7 480 96 512h32 64 32l-.7-32-6.5-288H240h16V176 160h64v32h32V0H320V32H256V16 0H240 128zM320 64v64H240 224v16 16h-8H105.9L94.3 136.8 87.9 124 74.4 129 32 144.9V128c0-53 43-96 96-96h96V48 64h16 80zM184.7 192l6.5 288H128.7l6.5-288h49.4zM560 205.3V32 0H528 464 432V32 205.3L352 272V480v32h32H608h32V480 272l-80-66.7zM528 32V205.3v15l11.5 9.6L608 287v1H384v-1l68.5-57.1 11.5-9.6v-15V32h64zM384 320H608V480H480V416 400H448v16 64H384V320zM512 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faClockNine = {
    prefix: 'fasl',
    iconName: 'clock-nine',
    icon: [
      512,
      512,
      [],
      'e34c',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112V256v16H256 144 128V240h16 96V112 96h32v16z'
      
    ]
  };

  

  
  

  var faHandsHoldingHeart = {
    prefix: 'fasl',
    iconName: 'hands-holding-heart',
    icon: [
      640,
      512,
      ["hands-heart"],
      'f4c3',
      
      'M295 59.9l-9.3-11.6c-8.3-10.4-20.8-16.4-34.1-16.4c-24.1 0-43.6 19.5-43.6 43.6v3.6c0 12.5 5 24.5 13.8 33.4l24.8 24.8L320 210.7l73.4-73.4 24.8-24.8C427 103.6 432 91.6 432 79.1V75.6c0-24.1-19.5-43.6-43.6-43.6c-13.3 0-25.8 6-34.1 16.4L345 59.9 320 91.1 295 59.9zm121 100l-73.4 73.4L320 255.9l-22.6-22.6L224 159.9l-24.8-24.8c-14.9-14.9-23.2-35-23.2-56V75.6C176 33.8 209.9-.1 251.6-.1c17 0 33.4 5.7 46.6 16c4.6 3.6 8.8 7.7 12.5 12.4L320 39.9l9.3-11.6c3.7-4.6 7.9-8.8 12.5-12.4C355 5.6 371.3-.1 388.4-.1C430.1-.1 464 33.8 464 75.6v3.6c0 21-8.3 41.1-23.2 56L416 159.9zM112 64h16V80 265.4l36.7-36.7L176 217.4l11.3 11.3L320 361.4 452.7 228.7 464 217.4l11.3 11.3L512 265.4V80 64h16 96 16V80 384v6.6l-4.7 4.7-104 104L520 510.6 497.4 488l11.3-11.3L608 377.4V96H544V288v6.6l-1.4 1.4-3.3 3.3-8 8-72 72L448 390.6l-4.7 4.7L432 406.6 409.4 384l11.3-11.3 4.7-4.7 11.3-11.3L497.4 296 464 262.6l-128 128V496v16H304V496 390.6l-128-128L142.6 296l60.7 60.7 0 0 16 16L230.6 384 208 406.6l-11.3-11.3-16-16 0 0-72-72-8-8L97.4 296 96 294.6V288 96H32V377.4l99.3 99.3L142.6 488 120 510.6l-11.3-11.3-104-104L0 390.6V384 80 64H16h96z'
      
    ]
  };

  
    var faHandsHeart = faHandsHoldingHeart;
  

  
  

  var faBasketShoppingSimple = {
    prefix: 'fasl',
    iconName: 'basket-shopping-simple',
    icon: [
      576,
      512,
      ["shopping-basket-alt"],
      'e0af',
      
      'M253.8 17.9l-7.9 13.9L155.4 192H420.6L330.1 31.9l-7.9-13.9L350.1 2.2l7.9 13.9L457.3 192H511h33 32v32H536L464 512H112L40 224H0V192H32 65h53.7L218.1 16.1l7.9-13.9 27.9 15.7zM503 224H73l64 256H439l64-256zM144 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm264-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faShoppingBasketAlt = faBasketShoppingSimple;
  

  
  

  var faH = {
    prefix: 'fasl',
    iconName: 'h',
    icon: [
      384,
      512,
      [104],
      '48',
      
      'M352 256l0 208v16l32 0V464 256l0-32V48 32H352V48 224L32 224 32 48V32H0V48 224v32V464v16H32V464l0-208 320 0z'
      
    ]
  };

  

  
  

  var faLeftFromLine = {
    prefix: 'fasl',
    iconName: 'left-from-line',
    icon: [
      448,
      512,
      ["arrow-alt-from-right"],
      'f348',
      
      'M208 208l-32 0 0-32 0-48-17.7 0L43.1 256 158.3 384l17.7 0 0-48 0-32 32 0 112 0 0-96-112 0zm0-112l0 32 0 16 0 32 32 0 80 0 32 0 0 32 0 96 0 32-32 0-80 0-32 0 0 32 0 16 0 32-32 0-32 0L0 256 144 96l32 0 32 0zM448 432l0 16-32 0 0-16 0-352 0-16 32 0 0 16 0 352z'
      
    ]
  };

  
    var faArrowAltFromRight = faLeftFromLine;
  

  
  

  var faCupStraw = {
    prefix: 'fasl',
    iconName: 'cup-straw',
    icon: [
      384,
      512,
      [129380],
      'e363',
      
      'M211.5 0H224h48 16V32H272 236.5l-24 96H368h16v32H368 16 0V128H16 179.5l29-115.9 3-12.1zM64 512L37.3 192H69.4l24 288H290.6l24-288h32.1L320 512H64z'
      
    ]
  };

  

  
  

  var faMessageSmile = {
    prefix: 'fasl',
    iconName: 'message-smile',
    icon: [
      512,
      512,
      ["comment-alt-smile"],
      'f4aa',
      
      'M160 416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448 416zm0-32h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zm32-248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm128 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM167.8 241.4l10.7 11.9C197.5 274.6 225.2 288 256 288s58.5-13.4 77.5-34.7l10.7-11.9L368 262.7l-10.7 11.9C332.5 302.5 296.3 320 256 320s-76.5-17.5-101.4-45.3L144 262.7l23.8-21.3z'
      
    ]
  };

  
    var faCommentAltSmile = faMessageSmile;
  

  
  

  var faSpaceStationMoon = {
    prefix: 'fasl',
    iconName: 'space-station-moon',
    icon: [
      512,
      512,
      [],
      'e033',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 14.8-1.4 29.3-4.2 43.3c-2.1 .7-4.2 1.5-6.5 2.3C433 314.7 369.9 337.4 256 337.4s-177-22.7-213.3-35.8l0 0c-2.3-.8-4.4-1.6-6.5-2.3c-2.7-14-4.2-28.5-4.2-43.3zM256 369.4c104.8 0 169.6-18.7 208.8-32.3C432.3 420.8 351.1 480 256 480s-176.3-59.2-208.8-142.8c39.2 13.6 104 32.3 208.8 32.3zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM136 160a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0zm-88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faMelonSlice = {
    prefix: 'fasl',
    iconName: 'melon-slice',
    icon: [
      512,
      512,
      [],
      'e311',
      
      'M128 368c-6.1 0-12.1-.2-18.1-.7L99 378.2C131.9 402 172.3 416 216 416c110.5 0 200-89.5 200-200c0-43.7-14-84.1-37.8-117l-10.9 10.9c.4 6 .7 12 .7 18.1c0 132.5-107.5 240-240 240zM76.1 401.1L48.7 428.5C93.5 460.9 148.5 480 208 480c150.2 0 272-121.8 272-272c0-59.5-19.1-114.5-51.5-159.3L401.1 76.1C430.5 115 448 163.5 448 216c0 128.1-103.9 232-232 232c-52.5 0-101-17.5-139.9-46.9zM336 128c0-10.1-.7-20.1-2.1-29.9l74.3-74.3L430.8 1.2C438.1 9 445 17.3 451.4 25.8C489.5 76.6 512 139.7 512 208c0 167.9-136.1 304-304 304c-68.3 0-131.4-22.5-182.2-60.6C17.3 445 9 438.1 1.2 430.8l22.6-22.6 74.3-74.3c9.8 1.4 19.7 2.1 29.9 2.1c114.9 0 208-93.1 208-208z'
      
    ]
  };

  

  
  

  var faPersonCircleQuestion = {
    prefix: 'fasl',
    iconName: 'person-circle-question',
    icon: [
      576,
      512,
      [],
      'e542',
      
      'M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM99.3 128h9.6H211.1h9.6l4.5 8.5 66.7 124.9c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496v16H192V496 352H128V496v16H96V496 202.1L46.1 295.5l-7.5 14.1L10.3 294.6l7.5-14.1 76.9-144 4.5-8.5zM128 320h64V160H128V320zm416 48a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 80H416V416h32v32zM368 329.5c0-23 18.6-41.6 41.6-41.6h40.5c25.4 0 45.9 20.6 45.9 45.9c0 17.1-9.5 32.7-24.5 40.6L448 386.8v13.1H416v-16-6.8-9.7l8.6-4.5 32-16.8c4.6-2.4 7.4-7.2 7.4-12.3c0-7.7-6.2-13.9-13.9-13.9H409.6c-5.3 0-9.6 4.3-9.6 9.6v6.4l-32 0v-6.4z'
      
    ]
  };

  

  
  

  var faCashRegister = {
    prefix: 'fasl',
    iconName: 'cash-register',
    icon: [
      512,
      512,
      [],
      'f788',
      
      'M64 32V96H288V32H64zM32 0H64 288h32V32 96v32H288 192v32H480l32 224v96 32H480 32 0V480 384L32 160H160V128H64 32V96 32 0zM480 480V416H32v64H480zM452.2 192H59.8L32.3 384H479.7L452.2 192zM136 224v48H88V224h48zm48 0h48v48H184V224zm0 128H136V304h48v48zm96-128h48v48H280V224zm0 80v48H232V304h48zm96-80h48v48H376V224zm0 80v48H328V304h48z'
      
    ]
  };

  

  
  

  var faOctagonPlus = {
    prefix: 'fasl',
    iconName: 'octagon-plus',
    icon: [
      512,
      512,
      ["plus-octagon"],
      'f301',
      
      'M32 338.7V173.3L173.3 32H338.7L480 173.3V338.7L338.7 480H173.3L32 338.7zM160 0L0 160V352L160 512H352L512 352V160L352 0H160zM272 160H240v16 64H176 160v32h16 64v64 16h32V336 272h64 16V240H336 272V176 160z'
      
    ]
  };

  
    var faPlusOctagon = faOctagonPlus;
  

  
  

  var faSignsPost = {
    prefix: 'fasl',
    iconName: 'signs-post',
    icon: [
      512,
      512,
      ["map-signs"],
      'f277',
      
      'M240 0h32V32H448l64 80-64 80H272v32H448h32v32 96 32H448 272V512H240V384H64L0 304l64-80H240V192H64 32V160 64 32H64 240V0zM432.6 64H64v96H432.6L471 112 432.6 64zM79.4 256L41 304l38.4 48H448V256H79.4z'
      
    ]
  };

  
    var faMapSigns = faSignsPost;
  

  
  

  var faArrowRight = {
    prefix: 'fasl',
    iconName: 'arrow-right',
    icon: [
      448,
      512,
      [8594],
      'f061',
      
      'M435.3 267.3L446.6 256l-11.3-11.3-168-168L256 65.4 233.4 88l11.3 11.3L385.4 240 16 240 0 240l0 32 16 0 369.4 0L244.7 412.7 233.4 424 256 446.6l11.3-11.3 168-168z'
      
    ]
  };

  

  
  

  var faSignatureLock = {
    prefix: 'fasl',
    iconName: 'signature-lock',
    icon: [
      640,
      512,
      [],
      'e3ca',
      
      'M64 128c0-35.3 28.7-64 64-64s64 28.7 64 64v3.4c0 26.2-2.4 52.3-7.2 78L11.8 256.6 0 259.8V272 464v16H16 96h9.4l4.6-8.2L151.5 398c20.9-37.1 37.2-76.5 48.5-117.5l7.2-25.7c1.8-6.5 3.5-13 5-19.6l125.5-34.2-48 96L278.1 320H304h80l0-32H329.9l52.4-104.8 16-32-34.5 9.4L218.8 200.1c3.4-22.7 5.2-45.7 5.2-68.7V128c0-53-43-96-96-96s-96 43-96 96v48c0 8.8 7.2 16 16 16s16-7.2 16-16V128zM384 384H240 224v32h16H384V384zM32 284.2l144.7-39.5-.4 1.4-7.2 25.7c-10.7 38.5-26 75.6-45.6 110.4L86.6 448H32V284.2zM528 224c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48H416v32V480v32h32H608h32V480 352 320H608V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm160 80V480H448V352H608z'
      
    ]
  };

  

  
  

  var faTickets = {
    prefix: 'fasl',
    iconName: 'tickets',
    icon: [
      640,
      512,
      [],
      'e658',
      
      'M96 64V32h32H608h32V64v72 32c-22.1 0-40 17.9-40 40s17.9 40 40 40v32 72 32H608 128 96V352 280 248c22.1 0 40-17.9 40-40s-17.9-40-40-40V136 64zm32 79.5c23.7 11.8 40 36.2 40 64.5s-16.3 52.7-40 64.5V352H608V272.5c-23.7-11.8-40-36.2-40-64.5s16.3-52.7 40-64.5V64H128v79.5zM32 96v16V448H528h16v32H528 16 0V464 112 96H32zm224 64v96H480V160H256zm-32-32h32H480h32v32 96 32H480 256 224V256 160 128z'
      
    ]
  };

  

  
  

  var faMaskVentilator = {
    prefix: 'fasl',
    iconName: 'mask-ventilator',
    icon: [
      640,
      512,
      [],
      'e524',
      
      'M223.2 418.3c-9.7-16.7-15.2-36.2-15.2-57c0-25.4 9.1-54.2 21.6-80.1c12.6-26.1 29.6-51 47.1-68.5l4.7-4.7H288h64 6.6l4.7 4.7c17.5 17.5 34.5 42.4 47.1 68.5C422.9 307.2 432 336 432 361.3c0 20.7-5.5 40-15 56.5c38.5-27.1 63-69.9 63-117.1c0-45.1-22.1-112-58.4-164.5L367.9 64H272l-54 72.3c-36.2 52.4-58 119.4-58 164.5c0 47.2 24.3 90.3 63.2 117.5zM192 117.6L256 32H384l63.6 85.6c2.4 3.4 4.7 6.9 6.9 10.4H624h16v16V336v12.3l-11.9 3.1-140.6 37C462.1 430.6 419 462 368 474.3V426c19.3-14.7 32-38 32-64.7c0-18.6-6.9-42.5-18.4-66.2c-10.2-21.1-23.4-40.9-36.4-55.1H294.8c-13.1 14.3-26.2 34-36.4 55.1c-11.5 23.7-18.4 47.6-18.4 66.2c0 26.6 12.5 50.1 32 64.9v48.2c-51.6-12.3-94.5-43.9-119.7-86L11.9 351.5 0 348.3V336 144 128H16 185.1c2.3-3.5 4.6-7 6.9-10.4zM166.8 160H32V323.7l103.5 27.2c-4.9-15.9-7.5-32.7-7.5-50.1c0-40.5 14.4-93 38.8-140.8zM504.4 350.9L608 323.7V160H472.9C497.4 207.8 512 260.3 512 300.8c0 17.4-2.7 34.3-7.6 50.1zM304 304h32V512H304V304z'
      
    ]
  };

  

  
  

  var faSendBack = {
    prefix: 'fasl',
    iconName: 'send-back',
    icon: [
      640,
      512,
      [],
      'f87e',
      
      'M224 32V224H32V32H224zM32 0H0V32 224v32H32 224h32V224 32 0H224 32zM608 288V480H416V288H608zM416 256H384v32V480v32h32H608h32V480 288 256H608 416zM160 288v96 32h32H352V384H192V288H160zM480 128V96H448 288v32H448v96h32V128zM160 96v64H96V96h64zM96 64H64V96v64 32H96h64 32V160 96 64H160 96zM480 352h64v64H480V352zm-32-32v32 64 32h32 64 32V416 352 320H544 480 448z'
      
    ]
  };

  

  
  

  var faCalendarArrowDown = {
    prefix: 'fasl',
    iconName: 'calendar-arrow-down',
    icon: [
      448,
      512,
      ["calendar-download"],
      'e0d0',
      
      'M128 16V0H96V16 64H32 0V96v64 32V480v32H32 416h32V480 192 160 96 64H416 352V16 0H320V16 64H128V16zM32 192H416V480H32V192zm0-96H416v64H32V96zM240 256V240H208v16V377.4l-52.7-52.7L144 313.4 121.4 336l11.3 11.3 80 80L224 438.6l11.3-11.3 80-80L326.6 336 304 313.4l-11.3 11.3L240 377.4V256z'
      
    ]
  };

  
    var faCalendarDownload = faCalendarArrowDown;
  

  
  

  var faChartLine = {
    prefix: 'fasl',
    iconName: 'chart-line',
    icon: [
      512,
      512,
      ["line-chart"],
      'f201',
      
      'M32 48V32H0V48 464v16H16 496h16V448H496 32V48zM475.3 155.3L486.6 144 464 121.4l-11.3 11.3L320 265.4l-84.7-84.7L224 169.4l-11.3 11.3-112 112L89.4 304 112 326.6l11.3-11.3L224 214.6l84.7 84.7L320 310.6l11.3-11.3 144-144z'
      
    ]
  };

  
    var faLineChart = faChartLine;
  

  
  

  var faFrenchFries = {
    prefix: 'fasl',
    iconName: 'french-fries',
    icon: [
      384,
      512,
      [127839],
      'f803',
      
      'M144 2.9l23.2 11.6 64 32 8.8 4.4v9.9V256v16H208V256 70.7l-32-16V256v16H144V256 28.8 2.9zM301.8 205.7L272 248.2l0-39.6L299.1 84.5 272 89.9V57.3l44.9-9 24-4.8-5.2 23.9L307 198.2l-5.2 7.5zM332.5 192l19.8-99.1 31.4 6.3L365.1 192H332.5zM18.9 192L.3 99.1l31.4-6.3L51.5 192H18.9zm63.3 13.6l-2-2.8L56.2 58.6 54.3 47l10.6-5.3L112 18.1V53.9L89.7 65l33.1 198.7-40.6-58zM64 224l48 80H272l48-80h31.2H384l-7.1 32L320 512H64L7.1 256 0 224H32.8 64zm235.4 96.5L290.1 336H272 112 93.9l-9.3-15.5L45.9 256h-6L89.7 480H294.3l49.8-224h-6l-38.7 64.5z'
      
    ]
  };

  

  
  

  var faObjectGroup = {
    prefix: 'fasl',
    iconName: 'object-group',
    icon: [
      576,
      512,
      [],
      'f247',
      
      'M64 64V96H80 96V80 64H64zm0 64H32V96 64 32H64 96h32V64H448V32h32 32 32V64 96v32H512V384h32v32 32 32H512 480 448V448H128v32H96 64 32V448 416 384H64V128zM96 448V432 416H80 64v32H96zm32-32H448V400 384h16 16V128H464 448V112 96H128v16 16H112 96V384h16 16v16 16zm0-288v16V272v16h16H304h16V272 144 128H304 144 128zM448 384H432 272 256V368 336 320h32v16 16H416V256H368 352V224h16 64 16v16V368v16zm32 64h32V416H496 480v16 16zm0-384V80 96h16 16V64H480zM160 160H288v96H160V160z'
      
    ]
  };

  

  
  

  var faRingsWedding = {
    prefix: 'fasl',
    iconName: 'rings-wedding',
    icon: [
      512,
      512,
      [],
      'f81b',
      
      'M162.1 96H176h13.9l28.3-47.1L206.9 32H145.1L133.9 48.9 162.1 96zM256 48l-32.7 54.4C297.5 123.1 352 191.2 352 272c0 64.4-34.5 120.7-86.1 151.3c-8.6-6.9-16.1-15-22.4-24.1C289 375 320 327.1 320 272c0-27.5-7.7-53.3-21.1-75.2C237.3 213.2 192 269.3 192 336c0 27.5 7.7 53.3 21.1 75.2c6 9.8 13.2 18.8 21.3 26.9c0 0 0 0 0 0C260.5 464 296.4 480 336 480c79.5 0 144-64.5 144-144c0-67.9-47-124.9-110.3-140c-4.9-12.4-10.9-24.2-17.9-35.3C441.6 168.7 512 244.1 512 336c0 97.2-78.8 176-176 176c-55.3 0-104.7-25.5-137-65.5c-7.5 1-15.2 1.5-23 1.5C78.8 448 0 369.2 0 272c0-80.8 54.5-148.9 128.7-169.6L96 48 128 0h96l32 48zM179.2 416c-12.3-24-19.2-51.2-19.2-80c0-76.7 49.1-142 117.6-166.1C251.5 144 215.6 128 176 128C96.5 128 32 192.5 32 272s64.5 144 144 144c1.1 0 2.1 0 3.2 0z'
      
    ]
  };

  

  
  

  var faBreadLoaf = {
    prefix: 'fasl',
    iconName: 'bread-loaf',
    icon: [
      640,
      512,
      [127838],
      'f7eb',
      
      'M96 224H64c-17.7 0-32-14.3-32-32c0-45.8 30.4-77.3 77.4-98.9C156.4 71.4 211.6 64 240 64s83.6 7.4 130.6 29.1c47 21.7 77.4 53.1 77.4 98.9c0 17.7-14.3 32-32 32H384v32V448H320 96V256 224zm320 32H544V448H416V288 256zm152-32l-24 0-72.6 0c5.4-9.4 8.6-20.3 8.6-32c0-64-44-104-96-128h16c28.4 0 83.6 7.4 130.6 29.1c47 21.7 77.4 53.1 77.4 98.9c0 17.7-14.3 32-32 32l-8 0zM96 480H320h64 32H544h32V448 288 256c35.3 0 64-28.7 64-64C640 64 464 32 400 32H240C176 32 0 64 0 192c0 35.3 28.7 64 64 64v32V448v32H96z'
      
    ]
  };

  

  
  

  var faFaceRollingEyes = {
    prefix: 'fasl',
    iconName: 'face-rolling-eyes',
    icon: [
      512,
      512,
      [128580,"meh-rolling-eyes"],
      'f5a5',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 368H320h16v32H320 192 176V368h16zm-32-96c26.5 0 48-21.5 48-48c0-14.3-6.3-27.2-16.2-36c.2 1.3 .2 2.6 .2 4c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.4 .1-2.7 .2-4c-10 8.8-16.2 21.7-16.2 36c0 26.5 21.5 48 48 48zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm240 80c0-14.3-6.3-27.2-16.2-36c.2 1.3 .2 2.6 .2 4c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.4 .1-2.7 .2-4c-10 8.8-16.2 21.7-16.2 36c0 26.5 21.5 48 48 48s48-21.5 48-48zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  
    var faMehRollingEyes = faFaceRollingEyes;
  

  
  

  var faHexagonVerticalNft = {
    prefix: 'fasl',
    iconName: 'hexagon-vertical-nft',
    icon: [
      448,
      512,
      [],
      'e505',
      
      'M224 475.1L416 365.4V146.6L224 36.9 32 146.6V365.4L224 475.1zM0 128L224 0 448 128V384L224 512 0 384V128zm79.8 32H88 99.9l3.4 11.4 24.5 81.7V176 160h32v16V336v16h-16H136 124.1l-3.4-11.4L95.8 257.8V336v16h-32V336 176 160h16zm128 0h48 16v32h-16-32v48h32 16v32h-16-32v64 16h-32V336 256 176 160h16zm96 0h32 32 16v32h-16-16V336v16h-32V336 192h-16-16V160h16z'
      
    ]
  };

  

  
  

  var faUserCowboy = {
    prefix: 'fasl',
    iconName: 'user-cowboy',
    icon: [
      448,
      512,
      [],
      'f8ea',
      
      'M224 32L188.7 14.3 160 0 147 29.3l-37.5 84.4c9.7 2.7 20.2 5.2 31.8 7.3l34.4-77.4 34 17L224 67.8l14.3-7.2 34-17L306.8 121c-23.6 4.3-51.1 7-82.8 7c-62.2 0-108.2-10.4-140.2-22.9c-32.4-12.7-49.4-27.2-55-34.7L.8 85.1c9.3 27.9 35 62.4 72.5 89.9c38 27.7 89.2 49.1 150.6 49.1s112.7-21.4 150.6-49.1c37.6-27.4 63.2-62 72.5-89.9l-28-14.7c-5.6 7.5-22.7 22-55 34.7c-7.7 3-16.2 5.9-25.6 8.6L301 29.3 288 0 259.4 14.3 224 32zM46.2 480l24-64H377.8l24 64H46.2zM48 384L12 480 0 512H34.2 413.8 448l-12-32-36-96H48zM371.3 136.6c-4.8 4.2-10 8.4-15.5 12.4C322.5 173.4 277.8 192 224 192s-98.5-18.6-131.8-42.9c-5.5-4-10.7-8.2-15.5-12.4C112.4 149.9 160.9 160 224 160s111.6-10.1 147.3-23.4zM96 226c1.1 69.8 58 126 128 126s126.9-56.2 128-126c-10.5 5.2-21.6 10-33.3 14.1C311 285.4 271.5 320 224 320s-87-34.6-94.7-79.9C117.7 236 106.5 231.3 96 226z'
      
    ]
  };

  

  
  

  var faSeal = {
    prefix: 'fasl',
    iconName: 'seal',
    icon: [
      512,
      512,
      [],
      'e241',
      
      'M331 75L278.6 22.6 256 0 233.4 22.6 181 75H107 75v32 74L22.6 233.4 0 256l22.6 22.6L75 331v74 32h32 74l52.4 52.4L256 512l22.6-22.6L331 437h74 32V405 331l52.4-52.4L512 256l-22.6-22.6L437 181V107 75H405 331zm74 32v74 13.3l9.4 9.4L466.7 256l-52.4 52.4-9.4 9.4V331v74H331 317.7l-9.4 9.4L256 466.7l-52.4-52.4-9.4-9.4H181 107V331 317.7l-9.4-9.4L45.3 256l52.4-52.4 9.4-9.4V181 107h74 13.3l9.4-9.4L256 45.3l52.4 52.4 9.4 9.4H331h74z'
      
    ]
  };

  

  
  

  var faPlaneCircleCheck = {
    prefix: 'fasl',
    iconName: 'plane-circle-check',
    icon: [
      640,
      512,
      [],
      'e555',
      
      'M256 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4C184.4 62.7 176 89 176 109.7v44.5L8.1 250.1 0 254.7V264v96 21.9l20.9-6.7L176 325.4l0 50.6-57.6 43.2L112 424v8 64 16h16 16 2.2l2.2-.6L256 480.6l107.6 30.7 2.2 .6H368h16 10.8c-14.2-10-26.9-22-37.5-35.7l-96.8-27.7-4.4-1.3-4.4 1.3L144 479.4V440l57.6-43.2L208 392v-8l0-80.6V281.5l-20.9 6.7L32 338.1V273.3l167.9-96 8.1-4.6v-9.3V109.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3C298.1 75.5 304 96.1 304 109.7v61.7 9.3l8.1 4.6 76.2 43.5c9.6-7.4 19.9-13.9 30.9-19.2L336 162.1V109.7c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm78.6-176L552 313.4l-11.3 11.3L480 385.4l-28.7-28.7L440 345.4 417.4 368l11.3 11.3 40 40L480 430.6l11.3-11.3 72-72L574.6 336z'
      
    ]
  };

  

  
  

  var faCircleRight = {
    prefix: 'fasl',
    iconName: 'circle-right',
    icon: [
      512,
      512,
      [61838,"arrow-alt-circle-right"],
      'f35a',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm256-32l32 0 0-32 0-18.7L370.7 256 288 338.7l0-18.7 0-32-32 0-96 0 0-64 96 0zm160 32l-22.6-22.6L288 128l-32 0 0 32 0 32-32 0-64 0-32 0 0 32 0 64 0 32 32 0 64 0 32 0 0 32 0 32 32 0L393.4 278.6 416 256z'
      
    ]
  };

  
    var faArrowAltCircleRight = faCircleRight;
  

  
  

  var faEject = {
    prefix: 'fasl',
    iconName: 'eject',
    icon: [
      448,
      512,
      [9167],
      'f052',
      
      'M32 320v-3.4L224 110.9 416 316.6V320H32zM224 64L202.1 87.4 0 304v16 32H32 416h32V320 304L245.9 87.4 224 64zM16 416H0v32H16 432h16V416H432 16z'
      
    ]
  };

  

  
  

  var faStarship = {
    prefix: 'fasl',
    iconName: 'starship',
    icon: [
      640,
      512,
      [],
      'e039',
      
      'M0 64H16 240h16V80v64 16H240 161.2l47.6 34.6 60.1-8.2C296.8 114.8 366.5 64 448 64c106 0 192 86 192 192s-86 192-192 192c-81.5 0-151.2-50.8-179-122.4l-60.1-8.2L161.2 352H240h16v16 64 16H240 16 0V432 368 352H16h90.8L163 311.1l-53.2-7.3L96 302V288 224 210l13.8-1.9 53.2-7.3L106.8 160H16 0V144 80 64zM32 96v32H224V96H32zm96 142V274l131.4 17.9c-2.2-11.6-3.4-23.7-3.4-35.9s1.2-24.3 3.4-35.9L128 238zM32 416H224V384H32v32zm416 0a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm32-160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faSimCards = {
    prefix: 'fasl',
    iconName: 'sim-cards',
    icon: [
      448,
      512,
      [],
      'e251',
      
      'M112 400H416V141.3L306.7 32H112V400zM448 128V400v32H416 112 80V400 32 0h32H320L448 128zM32 96v16V480H368h16v32H368 16 0V496 112 96H32zm128 48h80 56 72 16v16 64 64 64 16H368 272 232 160 144V352 288 224 160 144h16zm16 64h48V176H176v32zm80 0h40 56V176H296 256v32zm40 32H240 176v32h56 40 80V240H296zm-8 96h64V304H288v32zm-32-32H232 176v32h56 24V304z'
      
    ]
  };

  

  
  

  var faCommentCode = {
    prefix: 'fasl',
    iconName: 'comment-code',
    icon: [
      512,
      512,
      [],
      'e147',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM219.3 187.3L230.6 176 208 153.4l-11.3 11.3-64 64L121.4 240l11.3 11.3 64 64L208 326.6 230.6 304l-11.3-11.3L166.6 240l52.7-52.7zm96-22.6L304 153.4 281.4 176l11.3 11.3L345.4 240l-52.7 52.7L281.4 304 304 326.6l11.3-11.3 64-64L390.6 240l-11.3-11.3-64-64z'
      
    ]
  };

  

  
  

  var faHelmetSafety = {
    prefix: 'fasl',
    iconName: 'helmet-safety',
    icon: [
      576,
      512,
      ["hard-hat","hat-hard"],
      'f807',
      
      'M224 32H208V48 272v16h32V272 64h96V272v16h32V272 48 32H352 224zM176 78.7C91.8 110.9 32 192.5 32 288v32H64V288c0-77.5 45.9-144.3 112-174.6V78.7zm224 34.7c65.5 30 111.1 95.8 112 172.3l0 34.3h32l0-32 0-2.4c-1-94.5-60.5-174.9-144-206.9v34.7zM32 391.7V384H544v7.7l-.8 .5c-9.1 5.7-23.8 13.8-44.9 22.1C456.2 430.7 388.2 448 288 448s-168.2-17.3-210.3-33.8c-21.1-8.2-35.8-16.3-44.9-22.1l-.8-.5zM576 408V384 352H544 32 0v32 24s80 72 288 72s288-72 288-72z'
      
    ]
  };

  
    var faHardHat = faHelmetSafety;
  
    var faHatHard = faHelmetSafety;
  

  
  

  var faToiletPaper = {
    prefix: 'fasl',
    iconName: 'toilet-paper',
    icon: [
      640,
      512,
      [129531],
      'f71e',
      
      'M26.4 467.8L21.3 480 8 512H42.7 365.3l8.2-19.7c21.9-53 32.7-112.3 37.9-171.6C415.2 277 416 233.3 416 192c0-81.8 30.7-149.2 70.3-158.8c3.2-.8 6.4-1.2 9.7-1.2c44.2 0 80 71.6 80 160s-35.8 160-80 160c-19.8 0-37.9-14.4-51.9-38.2c-1.2 15.2-2.7 30.5-4.7 45.8C454.5 374 473.3 384 496 384c40.7 0 69-32.2 85.2-64.6C598.3 285.2 608 240.1 608 192s-9.7-93.2-26.8-127.4C565 32.2 536.7 0 496 0c-1.3 0-2.6 0-3.8 .1l0-.1H160C107 0 64 86 64 192c0 89.9-3.9 190.6-37.6 275.8zM410.8 64.6C393.7 98.8 384 143.9 384 192c0 97.7-4.6 202.5-40 288l0 0H56l.2-.4C92.4 388.2 96 281.8 96 192c0-49.1 10-92 24.7-121.5C136.4 39.2 152.1 32 160 32H432.3c-8.6 9.9-15.8 21.2-21.5 32.6zM496 240c-6.4 0-11.9-11.3-14.5-27.6c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6zm0 32c16.2 0 26.6-9.9 31.4-16c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16zM160 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faKaaba = {
    prefix: 'fasl',
    iconName: 'kaaba',
    icon: [
      576,
      512,
      [128331],
      'f66b',
      
      'M544 193.8L288 279.1 32 193.8V154.7L288 240l256-85.3v39.1zm0 33.7v38.3l-32 10.7v33.7l32-10.7v93.4L288 478.3 32 392.9V299.5l32 10.7V276.5L32 265.8V227.5l250.9 83.6 5.1 1.7 5.1-1.7L544 227.5zm0-108.5v1.9L288 206.3 32 120.9v-1.9L288 33.7l256 85.3zM576 416V144 128 96L288 0 0 96v32 16V416l288 96 288-96zM96 287.1v33.7l96 32V319.1l-96-32zm186.9 96l5.1 1.7 5.1-1.7L352 363.5V329.8l-64 21.3-64-21.3v33.7l58.9 19.6zM384 352.9l96-32V287.1l-96 32v33.7z'
      
    ]
  };

  

  
  

  var faSquareList = {
    prefix: 'fasl',
    iconName: 'square-list',
    icon: [
      448,
      512,
      [],
      'e489',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM104 160a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-16h16H336h16v32H336 208 192V144zm0 96h16H336h16v32H336 208 192V240zm0 96h16H336h16v32H336 208 192V336zm-64-56a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-24 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faLocationPin = {
    prefix: 'fasl',
    iconName: 'location-pin',
    icon: [
      384,
      512,
      ["map-marker"],
      'f041',
      
      'M325.5 274.7c-16.9 33.2-39.9 68.2-63.4 100.5c-23.4 32.2-46.9 61-64.5 81.9c-1.9 2.3-3.8 4.5-5.6 6.6c-1.8-2.1-3.6-4.3-5.6-6.6c-17.7-20.8-41.1-49.7-64.5-81.9c-23.5-32.3-46.4-67.3-63.4-100.5C41.1 240.6 32 212.2 32 192c0-88.4 71.6-160 160-160s160 71.6 160 160c0 20.2-9.1 48.6-26.5 82.7zM213.3 487.9C263.3 429.9 384 280.8 384 192C384 86 298 0 192 0S0 86 0 192c0 88.8 120.7 237.9 170.7 295.9C183.8 503.1 192 512 192 512s8.2-8.9 21.3-24.1z'
      
    ]
  };

  
    var faMapMarker = faLocationPin;
  

  
  

  var faTelescope = {
    prefix: 'fasl',
    iconName: 'telescope',
    icon: [
      576,
      512,
      [128301],
      'e03e',
      
      'M356.6 88l96 166.3L529.3 210l-96-166.3L356.6 88zM557 194l16 27.7-27.7 16-76.6 44.2-27.7 16-16-27.7-.5-.8-41.4 22.4c.6 4 .9 8.1 .9 12.2c0 23.2-9.9 44.2-25.7 58.8L419.1 512l-34.6 0-54-132.5c-8.3 2.9-17.2 4.5-26.5 4.5s-18.2-1.6-26.5-4.5L223.5 512l-34.6 0 60.2-147.8-127 68.7-85.4-148L326.9 100.5l-14-24.2 27.7-16L417.3 16 445 0l16 27.7L557 194zm-214-65.8L79.8 295.4l54.5 94.5 97-52.4c-4.7-10.2-7.3-21.5-7.3-33.4c0-44.2 35.8-80 80-80c28.6 0 53.6 15 67.8 37.5l36.6-19.8L342.9 128.2zM304 352a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM37.9 344.1l32 56L77.8 414 50 429.8l-7.9-13.9-32-56L2.2 346 30 330.2l7.9 13.9z'
      
    ]
  };

  

  
  

  var faObjectExclude = {
    prefix: 'fasl',
    iconName: 'object-exclude',
    icon: [
      512,
      512,
      [],
      'e49c',
      
      'M32 32H320v96h32V32 0H320 32 0V32 320v32H32h96V320H32V32zM160 384v96 32h32H480h32V480 192 160H480 384v32h96V480H192V384H160zm64-32l0-32H192V256H160v64 32h32 32zM160 224l32 0V192h64V160H192 160v32 32zm96 128h64 32V320 288H320v32H256v32zm96-96V192 160H320 288v32h32v64h32z'
      
    ]
  };

  

  
  

  var faPoop = {
    prefix: 'fasl',
    iconName: 'poop',
    icon: [
      512,
      512,
      [],
      'f619',
      
      'M185.4 0H224h8c71.6 0 131 52.2 142.1 120.7C403.6 134.9 424 165 424 200c0 7.2-.9 14.3-2.5 21.1C455.6 233.2 480 265.7 480 304c0 16-4.3 31-11.7 43.9C494.4 363.2 512 391.5 512 424v72 16H496 16 0V496 424c0-32.5 17.6-60.8 43.7-76.1C36.3 335 32 320 32 304c0-38.3 24.4-70.8 58.5-82.9C88.9 214.3 88 207.2 88 200c0-48.6 39.4-88 88-88h.9 17.8c20.6 0 37.3-16.7 37.3-37.3V65.8c0-12.3-4.9-24-13.5-32.7l-5.8-5.8L185.4 0zm72.3 35c4.1 9.6 6.3 20.1 6.3 30.8v8.9c0 38.3-31 69.3-69.3 69.3H176.9 176c-30.9 0-56 25.1-56 56c0 9.1 2.2 17.7 6 25.2l10.4 20.5-22.8 2.6C85.7 251.6 64 275.3 64 304c0 15.3 6.2 29.2 16.2 39.4l19.2 19.4L73 370c-23.7 6.5-41 28.3-41 54v56H480V424c0-25.7-17.4-47.4-41-54l-26.3-7.3 19.2-19.4c10-10.1 16.2-24 16.2-39.4c0-28.7-21.7-52.4-49.5-55.6l-22.8-2.6L386 225.2c3.8-7.6 6-16.1 6-25.2c0-24.5-15.8-45.4-37.8-53l-9.8-3.4-1-10.3C339 85.1 303.8 45.8 257.7 35z'
      
    ]
  };

  

  
  

  var faHandPointRibbon = {
    prefix: 'fasl',
    iconName: 'hand-point-ribbon',
    icon: [
      448,
      512,
      [],
      'e1a6',
      
      'M80 0H64V16 64H51.2 17.9L38.7 90l24 30-24 30L17.9 176H51.2 64v64H48 32v16 96c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160v0V336 272 256 208 192H400 336V176H320 256V160 144H240 176l0-48V64l0-48V0H160 80zm64 64H96V32h48V64zm0 32v48H84.5l11.2-14 8-10-8-10L84.5 96H144zm0 80v64H96V176h48zm32 0h48v16 48H176V176zm48 96l0 0 0 48H144 128v32h16 80 16 16 48 16 16 48c0 70.7-57.3 128-128 128H192c-70.7 0-128-57.3-128-128V272h80v0h32v0h48zm32 0l0-16V240l0-32h48V320H256l0-48zm128 0v48H336V224h48v32 16z'
      
    ]
  };

  

  
  

  var faAlien8bit = {
    prefix: 'fasl',
    iconName: 'alien-8bit',
    icon: [
      576,
      512,
      [128126,"alien-monster"],
      'f8f6',
      
      'M112 32H96V48v64H80 16 0v16V304v16H16 64v48 16H80h48v80 16h16H256h16V464 400 384h32v16 64 16h16H432h16V464 384h48 16V368 320h48 16V304 128 112H560 496 480V48 32H464 400 384V48 64H336 320V80v48H256V80 64H240 192V48 32H176 112zM96 128h16 48v32H96V128zm0 64h80 16V176 112 96h32v48 16h16 96 16V144 96h32v16 64 16h16 80v48 16h32V240 176 144h32V288H496 480v16 48H432 368 208 144 96V304 288H80 32V144H64v32 64 16H96V240 192zm384-32H416V128h48 16v32zM160 80V96H128V64h32V80zM448 96H416V80 64h32V96zM160 448V384h32v16 16h16 32v32H160zm224-48V384h32v64H336V416h32 16V400zM224 240V224H192v16 64 16h32V304 240zm160 0V224H352v16 64 16h32V304 240z'
      
    ]
  };

  
    var faAlienMonster = faAlien8bit;
  

  
  

  var faCircleArrowDownRight = {
    prefix: 'fasl',
    iconName: 'circle-arrow-down-right',
    icon: [
      512,
      512,
      [],
      'e0fa',
      
      'M256 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm80 352h16V336 192 176H320v16V297.4L187.3 164.7 176 153.4 153.4 176l11.3 11.3L297.4 320H200 184v32h16H336z'
      
    ]
  };

  

  
  

  var faFaceDisguise = {
    prefix: 'fasl',
    iconName: 'face-disguise',
    icon: [
      512,
      512,
      [],
      'e370',
      
      'M480 256c0 123.7-100.3 224-224 224S32 379.7 32 256c0-16.5 1.8-32.5 5.2-48H72c0 49.4 37.4 90.1 85.4 95.4l-4.5 2.3-8.8 4.4V320v32 9.9l8.8 4.4 14.3 7.1L147.5 398l-10 12.5 25 20 10-12.5 23.9-29.9 7.3 3.6-10.5 26.3-5.9 14.9 29.7 11.9 5.9-14.9 9.5-23.9 7.6 3.8V432v16h32V432 409.9l7.6-3.8 9.5 23.9 5.9 14.9 29.7-11.9-5.9-14.9-10.5-26.3 7.3-3.6L339.5 418l10 12.5 25-20-10-12.5-19.6-24.5 14.3-7.1 8.8-4.4V352 320v-9.9l-8.8-4.4-4.5-2.3c48-5.3 85.4-46 85.4-95.4h34.8c3.4 15.5 5.2 31.5 5.2 48zM230.7 220.8l-29.6 42.3-.2-.4c-2.9 1.8-5.4 3.2-6.8 3.8c-7.9 3.5-16.8 5.5-26.1 5.5c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64c0 4.4-.4 8.7-1.3 12.8zm80.2 42.3l-29.6-42.3c-.8-4.1-1.3-8.4-1.3-12.8c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-9.3 0-18.1-2-26.1-5.5c-1.4-.6-3.9-2-6.8-3.8l-.2 .4zM465.3 176H434.5c-5.3-14.9-14.1-28-25.4-38.5l5.2-10.3 7.2-14.3L392.8 98.5l-7.2 14.3-3.5 7c-4.6-2-9.3-3.6-14.2-4.9V96 80H336V96v16.3c-4.4 .4-8.7 1-13 2l-4.7-9.5-7.2-14.3-28.6 14.3 7.2 14.3 3.6 7.3c-16.4 10.2-29.5 25.3-37.3 43.1c-7.8-17.9-20.9-32.9-37.3-43.1l3.6-7.3 7.2-14.3L200.8 90.5l-7.2 14.3-4.7 9.5c-4.2-.9-8.6-1.6-13-2V96 80H144V96v19c-4.9 1.3-9.6 2.9-14.2 4.9l-3.5-7-7.2-14.3L90.5 112.8l7.2 14.3 5.2 10.3C91.5 148 82.7 161.1 77.5 176H46.7C78.9 91.8 160.5 32 256 32s177.1 59.8 209.3 144zm34 0C465.7 73.8 369.4 0 256 0S46.3 73.8 12.7 176H0v32H4.5C1.5 223.5 0 239.6 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-16.4-1.5-32.5-4.5-48H512V176H499.3zM256 240.5l50.9 72.7 2.3 3.3 3.6 1.8L336 329.9v12.2l-80 40-80-40V329.9l23.2-11.6 3.6-1.8 2.3-3.3L256 240.5zM192 216a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm152 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faObjectUngroup = {
    prefix: 'fasl',
    iconName: 'object-ungroup',
    icon: [
      640,
      512,
      [],
      'f248',
      
      'M96 32V96H32V32H96zM32 0H0V32 96v32H32 48v96H32 0v32 64 32H32 96h32V320 304H320v16 32h32 64 32V320 256 224H416 400V128h16 32V96 32 0H416 352 320V32 48H128V32 0H96 32zM368 224H352 320v32 16H128V256 224H96 80V128H96h32V96 80H320V96v32h32 16v96zM32 256H96v64H32V256zM416 32V96H352V32h64zM352 256h64v64H352V256zm256-64v64H544V192h64zm-64-32H512v32 16H480v32h32v16 32h32 16v96H544 512v32 16H320V416 384H288 272V336H240v48H224 192v32 64 32h32 64 32V480 464H512v16 32h32 64 32V480 416 384H608 592V288h16 32V256 192 160H608 544zM224 416h64v64H224V416zm320 0h64v64H544V416z'
      
    ]
  };

  

  
  

  var faFaceGrinBeam = {
    prefix: 'fasl',
    iconName: 'face-grin-beam',
    icon: [
      512,
      512,
      [128516,"grin-beam"],
      'f582',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.5 23.6 54.5 38.3 89.9 38.3s67.4-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm0-32c41 0 79.9-5.3 114.9-14.9c13-3.5 25.4-7.7 37.2-12.3c-3.1 13.8-8 26.9-14.5 39c-26.2 48.9-78 82.2-137.7 82.2s-111.5-33.3-137.7-82.2c-6.5-12.1-11.4-25.2-14.5-39c11.8 4.6 24.3 8.8 37.2 12.3c35.1 9.6 74 14.9 114.9 14.9zM156.5 188.5c-6.2 7.2-10.8 16.8-12.9 25.4l-31-7.8c3.2-12.7 9.8-27.1 19.9-38.6C142.4 155.9 157.2 146 176 146s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6l-31 7.8c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4l-31-7.8c3.2-12.7 9.8-27.1 19.9-38.6C302.4 155.9 317.2 146 336 146s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6l-31 7.8c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z'
      
    ]
  };

  
    var faGrinBeam = faFaceGrinBeam;
  

  
  

  var faBuildingFlag = {
    prefix: 'fasl',
    iconName: 'building-flag',
    icon: [
      640,
      512,
      [],
      'e4d5',
      
      'M32 32V480h96V400 368h32 64 32v32 80h96V32H32zM160 480h64V400H160v80zm-32 32H32 0V480 32 0H32 352h32V32 480v32H352 256 224 160 128zM64 96H80h64 16v16 64 16H144 80 64V176 112 96zm32 32v32h32V128H96zM240 96h64 16v16 64 16H304 240 224V176 112 96h16zm16 64h32V128H256v32zM64 224H80h64 16v16 64 16H144 80 64V304 240 224zm32 32v32h32V256H96zm144-32h64 16v16 64 16H304 240 224V304 240 224h16zm16 64h32V256H256v32zM448 0V16 32H608h32V64 192v32H608 448V496v16H416V496 224 192 64 32 16 0h32zm0 192H608V64H448V192z'
      
    ]
  };

  

  
  

  var faCircleQ = {
    prefix: 'fasl',
    iconName: 'circle-q',
    icon: [
      512,
      512,
      [],
      'e11e',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 256c0-53 43-96 96-96s96 43 96 96c0 20.8-6.6 40.1-17.9 55.8L284.5 256H241.7l2.3 2.6 67.4 75.8C295.7 345.5 276.6 352 256 352c-53 0-96-43-96-96zm224 0c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128c28.8 0 55.4-9.5 76.8-25.6L355.5 384h42.8l-2.3-2.6-40.2-45.2C373.4 314.2 384 286.4 384 256z'
      
    ]
  };

  

  
  

  var faFishFins = {
    prefix: 'fasl',
    iconName: 'fish-fins',
    icon: [
      576,
      512,
      [],
      'e4f2',
      
      'M272 32l73.4 64.2C499.1 102.2 576 256 576 256s-76.9 153.8-230.6 159.8L272 480l-48-32 7.1-56.9c-30.6-15.3-56-35.8-76.3-56.2L32 384 0 352l48-96L0 160l32-32 118.7 53.4c20.8-21.8 47.7-44.1 80.4-60.5L224 64l48-32zM534.9 249.5c-8.8-13.2-21.9-31-39.4-48.8c-35.2-35.9-85.6-70-151.4-72.6l-11.3-.4-8.5-7.4L269.4 72.2l-11.2 7.4 4.7 37.3 2.8 22.5-20.3 10.1c-28.7 14.3-52.6 34.1-71.6 54l-15.6 16.3-20.6-9.3L39 166.2l-.1 .1 37.7 75.4L83.8 256l-7.2 14.3L38.9 345.7l.8 .8L143 305.1l19.7-7.9 14.9 15.1c18.4 18.6 41 36.7 67.8 50.1l20.3 10.1L262.9 395l-4.7 37.3 11.2 7.4 54.9-48.1 8.5-7.4 11.3-.4c65.8-2.6 116.2-36.7 151.4-72.6c17.5-17.8 30.6-35.5 39.4-48.8c1.5-2.3 2.9-4.5 4.2-6.5c-1.2-2-2.6-4.1-4.2-6.5zm12.5 20.8s0 0 0 0l0 0zM416 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faFileContract = {
    prefix: 'fasl',
    iconName: 'file-contract',
    icon: [
      384,
      512,
      [],
      'f56c',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM80 64H64V96H80h64 16V64H144 80zm0 64H64v32H80h64 16V128H144 80zm56 176H124.1l-3.4 11.4L100.1 384H80 64v32H80h32 11.9l3.4-11.4L144 349l16.7 55.6 3.4 11.4H176h8 9.9l4.4-8.8L209.9 384h4.2l11.6 23.2 4.4 8.8H240h64 16V384H304 249.9l-11.6-23.2-4.4-8.8H224 200h-9.9l-4.4 8.8-3 5.9-15.4-51.4L163.9 304H152 136z'
      
    ]
  };

  

  
  

  var faFileExcel = {
    prefix: 'fasl',
    iconName: 'file-excel',
    icon: [
      384,
      512,
      [],
      'f1c3',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zm46.7 240H239.7L192 308.1 144.3 240H105.3l3.6 5.2L172.5 336l-63.6 90.8-3.6 5.2h39.1L192 363.9 239.7 432h39.1l-3.6-5.2L211.5 336l63.6-90.8 3.6-5.2z'
      
    ]
  };

  

  
  

  var faFileXls = {
    prefix: 'fasl',
    iconName: 'file-xls',
    icon: [
      512,
      512,
      [],
      'e64d',
      
      'M352 192v96h32V152L232 0H32 0V32 480v32H32h96V480H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM224 368V352H192v16c0 13.6 4 26.9 11.6 38.2L220.8 432l-17.2 25.8C196 469.1 192 482.4 192 496v16h32V496c0-7.3 2.2-14.4 6.2-20.4l9.8-14.7 9.8 14.7c4 6.1 6.2 13.2 6.2 20.4v16h32V496c0-13.6-4-26.9-11.6-38.2L259.2 432l17.2-25.8C284 394.9 288 381.6 288 368V352H256v16c0 7.3-2.2 14.4-6.2 20.4L240 403.2l-9.8-14.7c-4-6.1-6.2-13.2-6.2-20.4zm96 144h16 40 16V480H376 352V368 352H320v16V496v16zm88-114.3c0 17.3 9.8 33.1 25.2 40.8l31.2 15.6c4.6 2.3 7.6 7 7.6 12.2c0 7.5-6.1 13.7-13.7 13.7H432 416v32h16 26.3c25.2 0 45.7-20.4 45.7-45.7c0-17.3-9.8-33.1-25.2-40.8l-31.2-15.6c-4.6-2.3-7.6-7-7.6-12.2c0-7.5 6.1-13.7 13.7-13.7H480h16V352H480 453.7c-25.2 0-45.7 20.4-45.7 45.7z'
      
    ]
  };

  

  
  

  var faSackXmark = {
    prefix: 'fasl',
    iconName: 'sack-xmark',
    icon: [
      512,
      512,
      [],
      'e56a',
      
      'M393.9 32L351.2 94 333 120.4c7.7 4.9 16.7 11 26.4 18.1C420.8 183.7 512 273.4 512 416v64 32H480 32 0V480 416C0 273.4 91.2 183.7 152.6 138.5c9.7-7.1 18.6-13.2 26.4-18.1L160.8 94 118.1 32 96 0h38.9H377.1 416L393.9 32zM480 416c0-147.7-109.4-233.5-164.3-268.6l-5.3-3.4h-109l-5.3 3.4C141.4 182.5 32 268.3 32 416v64H480V416zM299.9 112l6.7-9.8L355.1 32H156.9l48.4 70.2 6.7 9.8h87.8zM203.3 244.7L256 297.4l52.7-52.7L320 233.4 342.6 256l-11.3 11.3L278.6 320l52.7 52.7L342.6 384 320 406.6l-11.3-11.3L256 342.6l-52.7 52.7L192 406.6 169.4 384l11.3-11.3L233.4 320l-52.7-52.7L169.4 256 192 233.4l11.3 11.3z'
      
    ]
  };

  

  
  

  var faClockEight = {
    prefix: 'fasl',
    iconName: 'clock-eight',
    icon: [
      512,
      512,
      [],
      'e345',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112V256v8.6l-7.1 4.8-96 64-13.3 8.9-17.8-26.6 13.3-8.9L240 247.4V112 96h32v16z'
      
    ]
  };

  

  
  

  var faBoltLightning = {
    prefix: 'fasl',
    iconName: 'bolt-lightning',
    icon: [
      384,
      512,
      [],
      'e0b7',
      
      'M230.4 128l19.2-96L256 0H223.4 32L3.6 256 0 288H32.2 143.3 176l-6.9 32L142.3 445.4 128 512l43.9-52.1L384 208V192 160H352 256.6 224l6.4-32zM352 192v4.3L186.2 393.2l21.1-98.5 8.3-38.7H176 35.8L60.6 32H217L192.6 153.7 185 192h39H352z'
      
    ]
  };

  

  
  

  var faChartPie = {
    prefix: 'fasl',
    iconName: 'chart-pie',
    icon: [
      576,
      512,
      ["pie-chart"],
      'f200',
      
      'M543.4 208c.4 5.3 .6 10.6 .6 16s-.2 10.7-.6 16H336 304V208 .6c5.3-.4 10.6-.6 16-.6s10.7 .2 16 .6C447 8.4 535.6 97 543.4 208zM336 208H511.3C503.6 114.7 429.3 40.4 336 32.7V208zM224 301.3V288 69.6C132.3 91.2 64 173.6 64 272c0 114.9 93.1 208 208 208c37.6 0 72.9-10 103.3-27.4L233.4 310.6l-9.4-9.4zm178.2 133L425 457c-8.3 6.9-17.1 13.2-26.3 19C361.9 498.8 318.5 512 272 512C139.5 512 32 404.6 32 272C32 155.9 114.5 59 224 36.8c10.4-2.1 21.1-3.6 32-4.3V64.6 288L402.2 434.2zM320 288h45.3H543.4h32.1c-.7 10.9-2.2 21.6-4.3 32c-11.1 54.7-40.8 102.7-82.2 137L352 320l-32-32zm77.3 32l92.3 92.3c23.5-25.7 40.6-57.3 48.9-92.3H397.3z'
      
    ]
  };

  
    var faPieChart = faChartPie;
  

  
  

  var faPersonCirclePlus = {
    prefix: 'fasl',
    iconName: 'person-circle-plus',
    icon: [
      576,
      512,
      [],
      'e541',
      
      'M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM99.3 128h9.6H211.1h9.6l4.5 8.5 66.7 124.9c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496v16H192V496 352H128V496v16H96V496 202.1L46.1 295.5l-7.5 14.1L10.3 294.6l7.5-14.1 76.9-144 4.5-8.5zM128 320h64V160H128V320zm416 48a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64v48h48 16v32H496 448v48 16H416V432 384H368 352V352h16 48V304 288h32v16z'
      
    ]
  };

  

  
  

  var faTaxi = {
    prefix: 'fasl',
    iconName: 'taxi',
    icon: [
      512,
      512,
      [128662,"cab"],
      'f1ba',
      
      'M176 0H160V16 64H112 100.1L96.7 75.4 52.1 224H32 0v32V416v16 16 64H32V448H480v64h32V448 432 416 256 224H480 459.9L415.3 75.4 411.9 64H400 352V16 0H336 176zM320 64H192V32H320V64zm68.1 32l38.4 128H85.5L123.9 96H388.1zM32 256H480V416H32V256zm96 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  
    var faCab = faTaxi;
  

  
  

  var faRoad = {
    prefix: 'fasl',
    iconName: 'road',
    icon: [
      576,
      512,
      [128739],
      'f018',
      
      'M42.4 448H272V400 384h32v16 48H533.6L423.9 64H304v48 16H272V112 64H152.1L42.4 448zM304 32H448L566.9 448l9.1 32H542.7 304 272 33.3 0l9.1-32L128 32H272h32zm0 176v96 16H272V304 208 192h32v16z'
      
    ]
  };

  

  
  

  var faBedBunk = {
    prefix: 'fasl',
    iconName: 'bed-bunk',
    icon: [
      576,
      512,
      [],
      'f8f8',
      
      'M32 16V0H0V16 176 431.7 496v16H32V496 447.7H240 544V496v16h32V496 431.7 272 176 112C576 50.1 525.9 0 464 0H240 224V16 160H32V16zM224 272V415.7H32V192H240 544v64H240 224v16zM544 112v48H256V32H464c44.2 0 80 35.8 80 80zM256 288H544V415.7H256V288zM128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm0 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faLeaf = {
    prefix: 'fasl',
    iconName: 'leaf',
    icon: [
      512,
      512,
      [],
      'f06c',
      
      'M272 128c-67.9 0-124.9 47-140 110.3c23.6-9.3 49.2-14.3 76-14.3h96 16v32H304 208c-28.8 0-56 6.9-80 19.2C129.7 353.2 193.5 416 272 416h0l.8 0c109-.5 207.2-110.5 207.2-259.4c0-23-2.4-45.2-6.9-66.3C447.5 113.7 413.4 128 376 128H304v0H272zM96.7 256.3C104.7 166.4 180.1 96 272 96l32 0h72c35.2 0 66.6-16.2 87.2-41.7c8.7-10.8 15.5-23.3 19.8-36.9c6.1 13.5 11.3 27.7 15.5 42.4c8.8 30.3 13.5 62.9 13.5 96.8C512 317.1 405.1 447.3 273 448l-1 0c-89.4 0-163.2-66.7-174.5-153C57.5 327.3 32 376.7 32 432v32 16H0V464 432c0-73.9 38.6-138.9 96.7-175.7z'
      
    ]
  };

  

  
  

  var faF = {
    prefix: 'fasl',
    iconName: 'f',
    icon: [
      320,
      512,
      [102],
      '46',
      
      'M16 32H0V48 248 464v16H32V464 272H240h16V240H240 32V64H304h16V32H304 16z'
      
    ]
  };

  

  
  

  var faCloudPlus = {
    prefix: 'fasl',
    iconName: 'cloud-plus',
    icon: [
      640,
      512,
      [],
      'e35e',
      
      'M544 241.1V232c0-57.4-46.6-104-104-104c-13.4 0-26.2 2.5-37.9 7.1l-24.3 9.5-14.2-22C340.8 87.3 301.1 64 256 64c-70.7 0-128 57.3-128 128v8.2 22.6l-21.3 7.5C63.1 245.8 32 287.3 32 336V448H144 512h96V352c0-35.5-19.2-66.5-48-83.2l-16-9.2V241.1zM0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c56.4 0 106 29.2 134.5 73.3c15.3-6 32-9.3 49.5-9.3c75.1 0 136 60.9 136 136v9.1c38.3 22.1 64 63.5 64 110.9v96 32H608 512 144 32 0V448 336zM336 192v16 64h64 16v32H400 336v64 16H304V368 304H240 224V272h16 64V208 192h32z'
      
    ]
  };

  

  
  

  var faAustralSign = {
    prefix: 'fasl',
    iconName: 'austral-sign',
    icon: [
      448,
      512,
      [],
      'e0a9',
      
      'M205.1 32H216h16 10.9l4 10.1L318.9 224H432h16v32H432 331.6L357 320h75 16v32H432 369.7l45.2 114.1 5.5 13.9H386l-.8-2.1L335.2 352H112.8L62.9 477.9 62 480H27.6l5.5-13.9L78.3 352H16 0V320H16 91l25.4-64H16 0V224H16 129.1L201.1 42.1l4-10.1zM224 71.2L163.5 224H284.5L224 71.2zM125.4 320H322.6l-25.4-64H150.8l-25.4 64z'
      
    ]
  };

  

  
  

  var faChessKnightPiece = {
    prefix: 'fasl',
    iconName: 'chess-knight-piece',
    icon: [
      320,
      512,
      ["chess-knight-alt"],
      'f442',
      
      'M53.3 96l80.4 0C210.1 96 272 157.9 272 234.3c0 12.7-1.7 25.3-5.2 37.5L244.3 352h33.2l20.1-71.5c4.2-15 6.4-30.6 6.4-46.2C304 140.3 227.7 64 133.7 64L32.4 64l-16 0V80 98.7v7.1l5.3 4.8 11.9 10.7L20.4 136.1l-4 4.5 0 6-.4 109 0 10.5 9.7 4.2 36.2 15.7-6.9 4.8L48 295.6l0 8.4 0 48H80l0-39.6 97.1-67.2 13.2-9.1L172 209.7l-13.2 9.1L92.8 264.6 48 245.2l.3-92.4L68 130.6l10.5-11.9L66.7 108.1 53.3 96zM96 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM32 480V463.3L64.8 416H255.2L288 463.3V480H32zM0 480v32H32 288h32V480 453.3L272 384H48L0 453.3V480z'
      
    ]
  };

  
    var faChessKnightAlt = faChessKnightPiece;
  

  
  

  var faPie = {
    prefix: 'fasl',
    iconName: 'pie',
    icon: [
      576,
      512,
      [129383],
      'f705',
      
      'M288 80C187.6 80 101.5 141.7 65.7 229.3l-2.4 6-5.9 2.6-1.7 .8L52.6 240H49.2 48 32v32H48h8 3.4l3.1-1.4 59.7-26.5 6.2-2.7 6.3 2.5 67.5 27 5.9 2.4 5.9-2.4 68.1-27.2 5.9-2.4 5.9 2.4 68.1 27.2 5.9 2.4 5.9-2.4 67.5-27 6.3-2.5 6.2 2.7 59.7 26.5 3.1 1.4H520h8 16V240H528h-1.2-3.4l-3.1-1.4-1.7-.8-5.9-2.6-2.4-6C474.5 141.7 388.4 80 288 80zM40.1 208C82.7 113.7 177.7 48 288 48s205.3 65.7 247.9 160H560h16v16 64 16H560 528h-8-6.8-3.4l-3.1-1.4-6.2-2.8L447 276.1l-61.2 24.5-11.9 4.8-5.9 2.4-5.9-2.4-11.9-4.8L288 275.7l-62.2 24.9-11.9 4.8-5.9 2.4-5.9-2.4-11.9-4.8L129 276.1 75.5 299.9l0 0-6.2 2.8L66.2 304H62.8 56 48 16 0V288 224 208H16 40.1zm35.4 91.9l13 29.2-6.2 2.8L73 336H62.8 58.7L96 448H480l37.3-112h-4.1H503l-9.3-4.1-6.2-2.8-1.4-.6L456.9 416H119.1L89.9 328.5l-1.4 .6-13-29.2zM206.3 151.2l-16 32-7.2 14.3-28.6-14.3 7.2-14.3 16-32 7.2-14.3 28.6 14.3-7.2 14.3zm192-14.3l16 32 7.2 14.3-28.6 14.3-7.2-14.3-16-32-7.2-14.3 28.6-14.3 7.2 14.3zM304 144v32 16H272V176 144 128h32v16z'
      
    ]
  };

  

  
  

  var faSquareEllipsis = {
    prefix: 'fasl',
    iconName: 'square-ellipsis',
    icon: [
      448,
      512,
      [],
      'e26e',
      
      'M416 64L32 64l0 384 384 0 0-384zm32-32l0 32 0 384 0 32-32 0L32 480 0 480l0-32L0 64 0 32l32 0 384 0 32 0zM152 232l0 48-48 0 0-48 48 0zm48 0l48 0 0 48-48 0 0-48zm144 0l0 48-48 0 0-48 48 0z'
      
    ]
  };

  

  
  

  var faVirusCovid = {
    prefix: 'fasl',
    iconName: 'virus-covid',
    icon: [
      512,
      512,
      [],
      'e4a8',
      
      'M216 0H200V32h16 24V72.7c-38.8 3.3-74.1 18.7-102.3 42.4L108.9 86.3l0 0 17-17L137.2 58 114.6 35.4 103.3 46.7 46.7 103.3 35.4 114.6 58 137.2l11.3-11.3 17-17 0 0 28.8 28.8C91.4 165.9 76 201.2 72.7 240H32l0-24V200H0v16 80 16H32l0-16 0-24H72.7c3.3 38.8 18.7 74.1 42.4 102.3L86.3 403.1l0 0-17-17L58 374.8 35.4 397.4l11.3 11.3 56.6 56.6 11.3 11.3L137.2 454l-11.3-11.3-17-17 0 0 28.8-28.8c28.2 23.7 63.5 39 102.3 42.4V480H216 200v32h16 80 16V480H296 272V439.3c38.8-3.3 74.1-18.7 102.3-42.4l28.8 28.8 0 0-17 17L374.8 454l22.6 22.6 11.3-11.3 56.6-56.6 11.3-11.3L454 374.8l-11.3 11.3-17 17 0 0-28.8-28.8c23.7-28.2 39-63.5 42.4-102.3H480v24 16h32V296 216 200H480v16 24H439.3c-3.3-38.8-18.7-74.1-42.4-102.3l28.8-28.8 0 0 17 17L454 137.2l22.6-22.6-11.3-11.3L408.7 46.7 397.4 35.4 374.8 58l11.3 11.3 17 17 0 0-28.8 28.8C346.1 91.4 310.8 76 272 72.7V32l24 0h16V0H296 216zm40 104a152 152 0 1 1 0 304 152 152 0 1 1 0-304zM192 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm112 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faImagePolaroidUser = {
    prefix: 'fasl',
    iconName: 'image-polaroid-user',
    icon: [
      448,
      512,
      [],
      'e1b6',
      
      'M340 384h76v64H32V384h76 34.2H305.8 340zm-12-32l-24-64H224 144l-24 64H32V64H416V352H328zm-173.8 0l12-32H281.8l12 32H154.2zM448 368V352 64 32H416 32 0V64 352v16 16 64 32H32 416h32V448 384 368zM288 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faWonSign = {
    prefix: 'fasl',
    iconName: 'won-sign',
    icon: [
      512,
      512,
      [8361,"krw","won"],
      'f159',
      
      'M72.1 256L4.1 32H37.6l68 224h84L236.4 44.5 239.2 32H252h8 12.8l2.8 12.5L322.4 256h84l68-224h33.4l-68 224H496h16v32H496 430.2L375.3 468.6 371.9 480H360h-8H339.2l-2.8-12.5L296.7 288H215.3L175.6 467.5 172.8 480H160h-8H140.1l-3.4-11.4L81.8 288H16 0V256H16 72.1zm43.2 32l38.9 128.2L182.5 288H115.3zm107.1-32h67.2L256 104 222.4 256zm107.1 32l28.3 128.2L396.7 288H329.5z'
      
    ]
  };

  
    var faKrw = faWonSign;
  
    var faWon = faWonSign;
  

  
  

  var faImagesUser = {
    prefix: 'fasl',
    iconName: 'images-user',
    icon: [
      576,
      512,
      [],
      'e1b9',
      
      'M544 64H128V352h92l36-96h80 80l36 96h92V64zM464 384H429.8 242.2 208 128 96V352 64 32h32H544h32V64 352v32H544 464zm-46.2-32l-24-64H278.2l-24 64H417.8zM32 96v16V448H464h16v32H464 16 0V464 112 96H32zm240 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm96 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faCubesStacked = {
    prefix: 'fasl',
    iconName: 'cubes-stacked',
    icon: [
      448,
      512,
      [],
      'e4e6',
      
      'M288 64H224v64h64V64zM224 32h64 32V64v64 32H288 224 192V128 64 32h32zM98.7 234.7l32 55.4 55.4-32-32-55.4-55.4 32zM55 223l27.7-16 55.4-32 27.7-16 16 27.7 32 55.4 16 27.7-27.7 16-55.4 32-27.7 16-16-27.7L71 250.7 55 223zm297 1H288v64h64V224zm-96-32h32 64 32v32 64 32H352 288 256V288 224 192zm96 256h64V384H352v64zm-32-96h32 64 32v32 64 32H416 352 320V448 384 352zm-64 32H192v64h64V384zm-64-32h64 32v32 64 32H256 192 160V448 384 352h32zM32 384v64H96V384H32zM0 352H32 96h32v32 64 32H96 32 0V448 384 352z'
      
    ]
  };

  

  
  

  var faArrowUpRightFromSquare = {
    prefix: 'fasl',
    iconName: 'arrow-up-right-from-square',
    icon: [
      512,
      512,
      ["external-link"],
      'f08e',
      
      'M336 0H320V32h16H457.4L212.7 276.7 201.4 288 224 310.6l11.3-11.3L480 54.6V176v16h32V176 16 0H496 336zM16 32H0V48 496v16H16 464h16V496 304 288H448v16V480H32V64H208h16V32H208 16z'
      
    ]
  };

  
    var faExternalLink = faArrowUpRightFromSquare;
  

  
  

  var faMagnifyingGlassChart = {
    prefix: 'fasl',
    iconName: 'magnifying-glass-chart',
    icon: [
      512,
      512,
      [],
      'e522',
      
      'M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L487.9 510.5l22.6-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM128 224l0 64v16h32V288l0-64V208H128v16zm64-96V288l0 16h32l0-16V128 112H192v16zm64 64v96 16h32V288 192 176H256v16z'
      
    ]
  };

  

  
  

  var faMobileNotch = {
    prefix: 'fasl',
    iconName: 'mobile-notch',
    icon: [
      384,
      512,
      ["mobile-iphone"],
      'e1ee',
      
      'M256 32V64 80H240 144 128V64 32H64V480H320V32H256zm-32 0H160V48h64V32zM32 0H64 320h32V32 480v32H320 64 32V480 32 0z'
      
    ]
  };

  
    var faMobileIphone = faMobileNotch;
  

  
  

  var faClothesHanger = {
    prefix: 'fasl',
    iconName: 'clothes-hanger',
    icon: [
      640,
      512,
      [],
      'e136',
      
      'M212.2 85.8C220.4 36.3 263.2 0 313.4 0C370.1 0 416 45.9 416 102.6v8.1c0 36.1-17.6 70-47.2 90.7l-20.7 14.5L633 410.8l7 4.8V424v72 16H624 16 0V496 424v-8.4l7-4.8 303.9-208 39.5-27.7c21-14.7 33.6-38.8 33.6-64.5v-8.1c0-39-31.6-70.6-70.6-70.6c-34.5 0-64 25-69.7 59l-3.9 23.6-2.6 15.8-31.6-5.3 2.6-15.8 3.9-23.6zM320 235.4L32 432.4V480H608V432.4L320 235.4z'
      
    ]
  };

  

  
  

  var faBuildingCircleExclamation = {
    prefix: 'fasl',
    iconName: 'building-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e4d3',
      
      'M32 32H352V266.8c9.1-12.9 19.9-24.5 32-34.6V32 0H352 32 0V32 480v32H32h96 32 64 32 96 32v-8.2c-12.1-10-22.9-21.7-32-34.6V480H256V400 368H224 160 128v32 80H32V32zM160 480V400h64v80H160zM64 96v16 64 16H80h64 16V176 112 96H144 80 64zm32 32h32v32H96V128zM240 96H224v16 64 16h16 64 16V176 112 96H304 240zm16 64V128h32v32H256zM64 224v16 64 16H80h64 16V304 240 224H144 80 64zm32 32h32v32H96V256zm144-32H224v16 64 16h16 64 16V304 240 224H304 240zm16 64V256h32v32H256zm128 80a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 448V416H480v32h32zm0-160H480v16 80 16h32V384 304 288z'
      
    ]
  };

  

  
  

  var faMoonStars = {
    prefix: 'fasl',
    iconName: 'moon-stars',
    icon: [
      512,
      512,
      [],
      'f755',
      
      'M320 0H288V16 48H256 240V80h16 32v32 16h32V112 80h32 16V48H352 320V16 0zM252.2 137.6c-15.8-5.2-32.5-8.4-49.8-9.3c-3.4-.2-6.9-.3-10.4-.3C86 128 0 214 0 320S86 512 192 512c58.4 0 110.8-26.1 146-67.3c11-12.8 20.3-27.1 27.6-42.5c-13.9 6.6-29 11-44.8 12.8c-5.5 .6-11.1 1-16.7 1c-79.5 0-144-64.5-144-144c0-44.5 20.2-84.4 52-110.8c11.9-9.9 25.5-17.9 40.2-23.6zM166.6 162C142.5 192.1 128 230.4 128 272c0 92.1 70.8 167.7 160.9 175.4C262 467.8 228.4 480 192 480c-88.4 0-160-71.6-160-160c0-79.7 58.3-145.8 134.6-158zM432 160V144H400v16 64H336 320v32h16 64v64 16h32V320 256h64 16V224H496 432V160z'
      
    ]
  };

  

  
  

  var faWhiskeyGlass = {
    prefix: 'fasl',
    iconName: 'whiskey-glass',
    icon: [
      512,
      512,
      [129347,"glass-whiskey"],
      'f7a0',
      
      'M68.9 288H443.1L420.2 448H91.8L68.9 288zm-4.6-32L36.9 64H475.1L447.7 256H64.3zM64 480H448L507.4 64 512 32H479.7 32.3 0L4.6 64 64 480z'
      
    ]
  };

  
    var faGlassWhiskey = faWhiskeyGlass;
  

  
  

  var faCode = {
    prefix: 'fasl',
    iconName: 'code',
    icon: [
      640,
      512,
      [],
      'f121',
      
      'M381.5 4l-4.7 15.3-144 464L228 498.5l30.6 9.5 4.7-15.3 144-464L412 13.5 381.5 4zM160.7 105.4l-11.7 11L13 244.4 .7 256 13 267.7l136 128 11.7 11 21.9-23.3-11.7-11L47.3 256 171 139.6l11.7-11-21.9-23.3zm296.7 23.9l12 10.6c27.8 24.7 47.5 44 67.4 63.5l0 0c16.8 16.4 33.7 32.9 55.5 52.8L469 372.3l-11.7 11 21.9 23.3 11.7-11 136-128 12.7-12L626.6 244c-27.8-24.7-47.5-44-67.4-63.5l0 0C539.2 161 519 141.3 490.6 116l-12-10.6-21.3 23.9z'
      
    ]
  };

  

  
  

  var faFileExclamation = {
    prefix: 'fasl',
    iconName: 'file-exclamation',
    icon: [
      384,
      512,
      [],
      'f31a',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM208 224H176v16V352v16h32V352 240 224zM168 440h48V392H168v48z'
      
    ]
  };

  

  
  

  var faStarHalfStroke = {
    prefix: 'fasl',
    iconName: 'star-half-stroke',
    icon: [
      576,
      512,
      ["star-half-alt"],
      'f5c0',
      
      'M306.1 34.3L374.6 164 519 189l38.2 6.6-27 27.8L428 328.5l20.9 145.1 5.5 38.4-34.8-17.1L288.1 430.2 156.5 494.9 121.7 512l5.5-38.4 20.9-145.1L45.9 223.4l-27-27.8L57.1 189l144.5-25L270 34.3 288.1 0l18.1 34.3zm63 161.2l-15.5-2.7-7.3-13.9L304 98.8V402.4l110.1 54.1L396.4 333.1l-2.2-15.6 11-11.3L492 216.8 369.1 195.5zM272 99l-42.1 79.9-7.3 13.9L207 195.5 84.1 216.8 171 306.2l11 11.3-2.2 15.6L162 456.5l110-54.1V99z'
      
    ]
  };

  
    var faStarHalfAlt = faStarHalfStroke;
  

  
  

  var faMoneyCheck = {
    prefix: 'fasl',
    iconName: 'money-check',
    icon: [
      576,
      512,
      [],
      'f53c',
      
      'M32 96V416H544V96H32zM0 64H32 544h32V96 416v32H544 32 0V416 96 64zM256 224v32H96V224H256zM96 320H480v32H96V320zM352 176v64h96V176H352zm-32-32h32 96 32v32 64 32H448 352 320V240 176 144z'
      
    ]
  };

  

  
  

  var faPuzzlePiece = {
    prefix: 'fasl',
    iconName: 'puzzle-piece',
    icon: [
      512,
      512,
      [129513],
      'f12e',
      
      'M169.1 17.3C183.8 6.3 203.2 0 224 0s40.2 6.3 54.9 17.3S304 44.6 304 64c0 22.4-13.7 40.4-32 51.3V128h96 16v16 96h12.7c10.9-18.3 28.9-32 51.3-32c19.4 0 35.8 10.5 46.7 25.1s17.3 34.1 17.3 54.9s-6.3 40.2-17.3 54.9s-27.3 25.1-46.7 25.1c-22.4 0-40.4-13.7-51.3-32H384V496v16H368 256 240V496 457.6 447.1l9.6-4.2C265 436.2 272 425.4 272 416c0-7.1-3.8-14.7-12.3-21.1s-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1c0 9.4 7 20.2 22.4 26.9l9.6 4.2v10.5V496v16H192 16 0V496 320 304H16 54.4 64.9l4.2 9.6C75.8 329 86.6 336 96 336c7.1 0 14.7-3.8 21.1-12.3s10.9-21.1 10.9-35.7s-4.4-27.1-10.9-35.7S103.1 240 96 240c-9.4 0-20.2 7-26.9 22.4L64.9 272H54.4 16 0V256 144 128H16 176V115.3c-18.3-10.9-32-28.9-32-51.3c0-19.4 10.5-35.8 25.1-46.7zm19.2 25.6C179.8 49.3 176 56.9 176 64c0 9.4 7 20.2 22.4 26.9l9.6 4.2v10.5V144v16H192 32v80H44.7c10.9-18.3 28.9-32 51.3-32c19.4 0 35.8 10.5 46.7 25.1s17.3 34.1 17.3 54.9s-6.3 40.2-17.3 54.9S115.4 368 96 368c-22.4 0-40.4-13.7-51.3-32H32V480H176V467.3c-18.3-10.9-32-28.9-32-51.3c0-19.4 10.5-35.8 25.1-46.7s34.1-17.3 54.9-17.3s40.2 6.3 54.9 17.3s25.1 27.3 25.1 46.7c0 22.4-13.7 40.4-32 51.3V480h80V320 304h16 38.4 10.5l4.2 9.6C427.8 329 438.6 336 448 336c7.1 0 14.7-3.8 21.1-12.3s10.9-21.1 10.9-35.7s-4.4-27.1-10.9-35.7s-14.1-12.3-21.1-12.3c-9.4 0-20.2 7-26.9 22.4l-4.2 9.6H406.4 368 352V256 160H256 240V144 105.6 95.1l9.6-4.2C265 84.2 272 73.4 272 64c0-7.1-3.8-14.7-12.3-21.1S238.5 32 224 32s-27.1 4.4-35.7 10.9z'
      
    ]
  };

  

  
  

  var faTrainTrack = {
    prefix: 'fasl',
    iconName: 'train-track',
    icon: [
      576,
      512,
      [],
      'e453',
      
      'M395.4 32H361.5l22.2 64H192.3l22.2-64H180.6L158.5 96H112 96v32h16 35.4l-33.2 96H72 56v32H72h31.1L69.8 352H32 16v32H32 58.8L25.5 480H59.4l33.2-96H483.4l33.2 96h33.9l-33.2-96H544h16V352H544 506.2l-33.2-96H504h16V224H504 461.9l-33.2-96H464h16V96H464 417.5L395.4 32zm-.6 96L428 224H148l33.2-96H394.8zm44.3 128l33.2 96H103.7l33.2-96H439.1z'
      
    ]
  };

  

  
  

  var faArrowUpSmallBig = {
    prefix: 'fasl',
    iconName: 'arrow-up-small-big',
    icon: [
      576,
      512,
      ["sort-size-up-alt"],
      'f88f',
      
      'M352 192H320V160 64 32h32 96 32V64v96 32H448 352zm96-32V64H352v96h96zM160 33.4l11.3 11.3 88 88L270.6 144 248 166.6l-11.3-11.3L176 94.6V464v16H144V464 94.6L83.3 155.3 72 166.6 49.4 144l11.3-11.3 88-88L160 33.4zM320 480V448 288 256h32H512h32v32V448v32H512 352 320zM512 288H352V448H512V288z'
      
    ]
  };

  
    var faSortSizeUpAlt = faArrowUpSmallBig;
  

  
  

  var faHandHoldingHeart = {
    prefix: 'fasl',
    iconName: 'hand-holding-heart',
    icon: [
      576,
      512,
      [],
      'f4be',
      
      'M263 59.9l-9.3-11.6c-8.3-10.4-20.8-16.4-34.1-16.4c-24.1 0-43.6 19.5-43.6 43.6v3.6c0 12.5 5 24.5 13.8 33.4l24.8 24.8L288 210.7l73.4-73.4 24.8-24.8C395 103.6 400 91.6 400 79.1V75.6c0-24.1-19.5-43.6-43.6-43.6c-13.3 0-25.8 6-34.1 16.4L313 59.9 288 91.1 263 59.9zm121 100l-73.4 73.4L288 255.9l-22.6-22.6L192 159.9l-24.8-24.8c-14.9-14.9-23.2-35-23.2-56V75.6C144 33.8 177.9-.1 219.6-.1c17 0 33.4 5.7 46.6 16c4.6 3.6 8.8 7.7 12.5 12.4L288 39.9l9.3-11.6c3.7-4.6 7.9-8.8 12.5-12.4C323 5.6 339.3-.1 356.4-.1C398.1-.1 432 33.8 432 75.6v3.6c0 21-8.3 41.1-23.2 56L384 159.9zM171.2 304H176 384h16v16 64h.2l103.6-61.7 13.5-8 8.3 13.3 40 64L574 405l-13.5 8.5-152 96-3.9 2.5H400 16 0V480H16 395.4L530 395l-23.3-37.2-94 56L409 416h-4.4H400 384 320 304 256 240V384h16 48 16 48V336H180.8l-92 61.3-4 2.7H80 16 0V368H16 75.2l92-61.3 4-2.7z'
      
    ]
  };

  

  
  

  var faHouseChimneyUser = {
    prefix: 'fasl',
    iconName: 'house-chimney-user',
    icon: [
      576,
      512,
      [],
      'e065',
      
      'M298.6 12L288 2.7 277.4 12 5.4 252l21.2 24L64 243V496v16H80 496h16V496 243l37.4 33 21.2-24-58.9-52h.3V48 32H496 400 384V48 87.4L298.6 12zM480 64V172.1l-64-56.5V64h64zM96 480V214.7L288 45.3 480 214.7V480H96zM256 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM231.1 352H344.9l21.3 64H400l-32-96H208l-32 96h33.7l21.3-64z'
      
    ]
  };

  

  
  

  var faDryerHeat = {
    prefix: 'fasl',
    iconName: 'dryer-heat',
    icon: [
      448,
      512,
      ["dryer-alt"],
      'f862',
      
      'M32 32V480H416V32H32zM0 0H32 416h32V32 480v32H416 32 0V480 32 0zM104 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM336 304a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM80 304a144 144 0 1 1 288 0A144 144 0 1 1 80 304zm107.3-83.3L200 233.4c10.2 10.2 16 24.1 16 38.6s-5.8 28.4-16 38.6l-9.4 9.4c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16l12.7 12.7-22.6 22.6L168 374.6c-10.2-10.2-16-24.1-16-38.6s5.8-28.4 16-38.6l9.4-9.4c4.2-4.2 6.6-10 6.6-16s-2.4-11.8-6.6-16l-12.7-12.7 22.6-22.6zM280 233.4c10.2 10.2 16 24.1 16 38.6s-5.8 28.4-16 38.6l-9.4 9.4c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16l12.7 12.7-22.6 22.6L248 374.6c-10.2-10.2-16-24.1-16-38.6s5.8-28.4 16-38.6l9.4-9.4c4.2-4.2 6.6-10 6.6-16s-2.4-11.8-6.6-16l-12.7-12.7 22.6-22.6L280 233.4z'
      
    ]
  };

  
    var faDryerAlt = faDryerHeat;
  

  
  

  var faUpDownLeftRight = {
    prefix: 'fasl',
    iconName: 'up-down-left-right',
    icon: [
      512,
      512,
      ["arrows-alt"],
      'f0b2',
      
      'M160 128V96l73.4-73.4L256 0l22.6 22.6L352 96v32H320l-48 0V240H384V192 160h32l73.4 73.4L512 256l-22.6 22.6L416 352H384V320 272H272V384h48 32v32l-73.4 73.4L256 512l-22.6-22.6L160 416V384h32 48V272H128v48 32H96L22.6 278.6 0 256l22.6-22.6L96 160h32v32 48H240V128H192 160zM306.7 96L256 45.3 205.3 96l101.5 0zM45.3 256L96 306.7V205.3L45.3 256zM306.7 416H205.3L256 466.7 306.7 416zm160-160L416 205.3V306.7L466.7 256z'
      
    ]
  };

  
    var faArrowsAlt = faUpDownLeftRight;
  

  
  

  var faToggleLargeOn = {
    prefix: 'fasl',
    iconName: 'toggle-large-on',
    icon: [
      576,
      512,
      [],
      'e5b1',
      
      'M544 128H288V384H544V128zM288 416H256 32 0V384 128 96H32 256h32H544h32v32V384v32H544 288zm-32-32V128H32V384H256zm96-192V320H480V192H352zm-32-32h32H480h32v32V320v32H480 352 320V320 192 160z'
      
    ]
  };

  

  
  

  var faFileSignature = {
    prefix: 'fasl',
    iconName: 'file-signature',
    icon: [
      576,
      512,
      [],
      'f573',
      
      'M352 192v28.9l32-32V152L232 0H32 0V32 480v32H32 352h32V480 434.7l-32 5V480H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM136 304H124.1l-3.4 11.4L100.1 384H80 64v32H80h32 11.9l3.4-11.4L144 349l16.7 55.6 3.4 11.4H176h8 9.9l4.4-8.8L209.9 384h4.2l11.6 23.2 4.4 8.8H240h16 16 16v0l33.2-5.2L390.7 400 553.4 237.3 576 214.7l-22.6-22.6L489.3 128 304 313.3l-10.8 69.5L293 384h-5H272 256h-6.1l-11.6-23.2-4.4-8.8H224 200h-9.9l-4.4 8.8-3 5.9-15.4-51.4L163.9 304H152 136zM466.5 196l22.8-22.8 41.5 41.5L508 237.5 466.5 196zm-22.6 22.6l41.5 41.5L375.5 370l-49.1 7.7 7.7-49.1L443.9 218.6z'
      
    ]
  };

  

  
  

  var faQuestion = {
    prefix: 'fasl',
    iconName: 'question',
    icon: [
      320,
      512,
      [10067,10068,61736],
      '3f',
      
      'M48 160c0-53 43-96 96-96h32c53 0 96 43 96 96c0 25.2-11.9 48.9-32 64l-89.6 67.2L144 296v8 48 16h32V352 312l83.2-62.4C287.4 228.4 304 195.3 304 160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160H48zM184 424H136v48h48V424z'
      
    ]
  };

  

  
  

  var faUserNurseHair = {
    prefix: 'fasl',
    iconName: 'user-nurse-hair',
    icon: [
      448,
      512,
      [],
      'e45d',
      
      'M128 76.9l96-42 96 42V144H128V76.9zM96 56v88 16 16 0c0 70.7 57.3 128 128 128s128-57.3 128-128v0V160 144 56L224 0 96 56zm32 120v0h86.1l-8 16H129.3c-.9-5.2-1.3-10.5-1.3-16zm102.3 39.2L249.9 176H320v0c0 53-43 96-96 96c-35.5 0-66.6-19.3-83.2-48H216h9.9l4.4-8.8zM201.4 436.6L224 459.2l22.6-22.6L331.2 352h29.8l42.7 128H44.4L87.1 352h29.8l84.6 84.6zM384 320H317.9l-71.3 71.3L224 413.9l-22.6-22.6L130.1 320H64L10.7 480 0 512H33.7 414.3 448l-10.7-32L384 320zM240 48H208V64v8h-8H184v32h16 8v8 16h32V112v-8h8 16V72H248h-8V64 48z'
      
    ]
  };

  

  
  

  var faClipboardPrescription = {
    prefix: 'fasl',
    iconName: 'clipboard-prescription',
    icon: [
      384,
      512,
      [],
      'f5e8',
      
      'M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36l3.1 12H254h34v48H192 96V80h34 12.4l3.1-12zM192 0c-32.8 0-61 19.8-73.3 48H80 64V64 80H32 0v32V480v32H32 352h32V480 112 80H352 320V64 48H304 265.3C253 19.8 224.8 0 192 0zM320 144V112h32V480H32V112H64v32 16H80 192 304h16V144zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM112 208H96v16 80 64 16h32V368 320h41.4l48 48-36.7 36.7L169.4 416 192 438.6l11.3-11.3L240 390.6l36.7 36.7L288 438.6 310.6 416l-11.3-11.3L262.6 368l36.7-36.7L310.6 320 288 297.4l-11.3 11.3L240 345.4l-31.2-31.2C227.3 305.1 240 286 240 264c0-30.9-25.1-56-56-56H112zm72 80H128V240h56c13.3 0 24 10.7 24 24s-10.7 24-24 24z'
      
    ]
  };

  

  
  

  var faCirclePhone = {
    prefix: 'fasl',
    iconName: 'circle-phone',
    icon: [
      512,
      512,
      ["phone-circle"],
      'e11b',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM230.8 122.1L226 109.9l-12.9 2.3-88 16L112 130.7l0 13.4 0 16c0 132.5 107.5 240 240 240h16 13.4l2.4-13.1 16-88 2.3-12.9-12.1-4.9-80-32-9.8-3.9-7.5 7.5L274 271.4c-13-9.1-24.3-20.4-33.4-33.4l18.7-18.7 7.5-7.5-3.9-9.8-32-80zM144 160l0-2.6 62-11.3 23.2 58.1-20.3 20.3-8.7 8.7 6.1 10.6c14.8 25.7 36.2 47.1 61.9 61.9l10.6 6.1 8.7-8.7 20.3-20.3L365.9 306l-11.3 62H352c-114.9 0-208-93.1-208-208z'
      
    ]
  };

  
    var faPhoneCircle = faCirclePhone;
  

  
  

  var faSquareG = {
    prefix: 'fasl',
    iconName: 'square-g',
    icon: [
      448,
      512,
      [],
      'e271',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM128 256c0 53 43 96 96 96c47.6 0 87.1-34.6 94.7-80H256 240V240h16 80 16v16c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6l11.9 10.7-21.3 23.8L288 184.4c-17-15.2-39.4-24.4-64-24.4c-53 0-96 43-96 96z'
      
    ]
  };

  

  
  

  var faFilter = {
    prefix: 'fasl',
    iconName: 'filter',
    icon: [
      512,
      512,
      [],
      'f0b0',
      
      'M224 308.2l-7.7-9L32 84.2V64H480V84.2l-184.3 215-7.7 9V320 441.5l-64-56V320 308.2zM0 96L192 320v80l96 84 32 28V469.5 320L512 96V64 32H480 32 0V64 96z'
      
    ]
  };

  

  
  

  var faDownToLine = {
    prefix: 'fasl',
    iconName: 'down-to-line',
    icon: [
      384,
      512,
      ["arrow-alt-to-bottom"],
      'f34a',
      
      'M16 448L0 448l0 32 16 0 352 0 16 0 0-32-16 0L16 448zM240 176l0 32 32 0 48 0 0 17.7L192 340.9 64 225.7 64 208l48 0 32 0 0-32 0-112 96 0 0 112zm112 0l-32 0-16 0-32 0 0-32 0-80 0-32-32 0-96 0-32 0 0 32 0 80 0 32-32 0-16 0-32 0 0 32 0 32L192 384 352 240l0-32 0-32z'
      
    ]
  };

  
    var faArrowAltToBottom = faDownToLine;
  

  
  

  var faRouteHighway = {
    prefix: 'fasl',
    iconName: 'route-highway',
    icon: [
      448,
      512,
      [],
      'f61a',
      
      'M232.2 10.3L224 5.3l-8.2 4.9-4.7 2.8c-42.2 25.3-94.5 27.3-138.5 5.3l-1.4-.7-11.9-6-8 10.7-48 64-6.8 9.1 6.3 9.4 2.2 3.2C22.6 134.7 32 165.9 32 197.8c0 20.6-3.9 40.9-11.6 60L8 288.9c-5.3 13.2-8 27.4-8 41.6C0 374.2 25.4 414 65.1 432.3l152.2 70.2 6.7 3.1 6.7-3.1 152.2-70.2C422.6 414 448 374.2 448 330.5c0-14.3-2.7-28.4-8-41.6l-12.4-31.1c-7.6-19.1-11.6-39.5-11.6-60c0-31.9 9.4-63.1 27.1-89.7l2.2-3.2 6.3-9.4-6.8-9.1-48-64-8-10.7-11.9 6-1.4 .7c-44 22-96.3 20-138.5-5.3l-4.7-2.8zM69 52c50.2 21 107.4 17.7 155-9.4C271.5 69.6 328.8 73 379 52l33.5 44.7c-12 19.6-20.3 41-24.8 63.3H60.3c-4.4-22.3-12.8-43.8-24.8-63.3L69 52zM63.9 192H384.1c-.1 1.9-.1 3.9-.1 5.8c0 24.6 4.7 49 13.8 71.9l12.4 31.1c3.8 9.5 5.7 19.6 5.7 29.8c0 31.2-18.2 59.6-46.5 72.7L224 470.4 78.5 403.2C50.2 390.1 32 361.8 32 330.5c0-10.2 1.9-20.3 5.7-29.8l12.4-31.1C59.3 246.8 64 222.4 64 197.8c0-1.9 0-3.9-.1-5.8z'
      
    ]
  };

  

  
  

  var faMemoCircleCheck = {
    prefix: 'fasl',
    iconName: 'memo-circle-check',
    icon: [
      576,
      512,
      [],
      'e1d9',
      
      'M352 32H32V480H296.2c10 12.1 21.7 22.9 34.6 32H32 0V480 32 0H32 352h32V32 198.6c-11.2 3.2-21.9 7.4-32 12.6V32zM64 128H80 304h16v32H304 80 64V128zm16 96H272h16v32H272 80 64V224H80zm0 96H208h16v32H208 80 64V320H80zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm78.6 112l-11.3 11.3-72 72L416 430.6l-11.3-11.3-40-40L353.4 368 376 345.4l11.3 11.3L416 385.4l60.7-60.7L488 313.4 510.6 336z'
      
    ]
  };

  

  
  

  var faPodium = {
    prefix: 'fasl',
    iconName: 'podium',
    icon: [
      448,
      512,
      [],
      'f680',
      
      'M288 32H208V64h80c8.8 0 16-7.2 16-16s-7.2-16-16-16zM176 64h-8c-26.5 0-48 21.5-48 48v48H432h16v32H432 16 0V160H16 88V112c0-44.2 35.8-80 80-80h8V0h32 80c26.5 0 48 21.5 48 48s-21.5 48-48 48H208 176V64zM80 512L47.3 224H79.5l29.1 256H339.4l29.1-256h32.2L368 512H80z'
      
    ]
  };

  

  
  

  var faDagger = {
    prefix: 'fasl',
    iconName: 'dagger',
    icon: [
      384,
      512,
      [],
      'f6cb',
      
      'M208 0V16 128h32 32 32 64 16v16 32c0 26.5-21.5 48-48 48s-48-21.5-48-48V160H272 240 208 176 144 112 96v16c0 26.5-21.5 48-48 48s-48-21.5-48-48V144 128H16 80h32 32 32V16 0h32zM64 160H32v16c0 8.8 7.2 16 16 16s16-7.2 16-16V160zm256 0v16c0 8.8 7.2 16 16 16s16-7.2 16-16V160H320zM144 404.4L192 462l48-57.6V192h32V416l-59.2 71L192 512l-20.8-25L112 416V192h32V404.4z'
      
    ]
  };

  

  
  

  var faFaceKissWinkHeart = {
    prefix: 'fasl',
    iconName: 'face-kiss-wink-heart',
    icon: [
      512,
      512,
      [128536,"kiss-wink-heart"],
      'f598',
      
      'M325.2 469.1C303.4 476.2 280.2 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224c0 25.9-4.4 50.8-12.5 73.9c10.9 1.2 21.2 4.5 30.6 9.5c9-26.2 13.9-54.2 13.9-83.4C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c26.9 0 52.8-4.1 77.2-11.8l-2.1-8.2-5.8-22.8zM260.7 304.5c5.4 2.7 9.2 5.3 11.5 7.7c2.2 2.3 2.2 3.5 2.2 3.8s-.1 1.5-2.2 3.8c-2.3 2.4-6.1 5.1-11.5 7.7c-10.8 5.3-25.3 9.2-38.6 11v26.9c13.3 1.9 27.8 5.8 38.6 11c5.4 2.7 9.2 5.3 11.5 7.7c2.2 2.3 2.2 3.5 2.2 3.8s-.1 1.5-2.2 3.8c-2.3 2.4-6.1 5.1-11.5 7.7c-10.8 5.3-25.3 9.2-38.6 11l3.8 26.9c15.2-2.1 32.7-6.6 46.8-13.6c7-3.4 13.9-7.8 19.2-13.4c5.4-5.6 9.8-13.2 9.8-22.5s-4.4-16.9-9.8-22.5c-5.3-5.5-12.2-9.9-19.2-13.4l-.2-.1 .2-.1c7-3.4 13.9-7.8 19.2-13.4c5.4-5.6 9.8-13.2 9.8-22.5s-4.4-16.9-9.8-22.5c-5.3-5.5-12.2-9.9-19.2-13.4c-14.1-6.9-31.6-11.4-46.8-13.6l-3.8 26.9c13.3 1.9 27.8 5.8 38.6 11zM176.4 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm202.8 5.6l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2c21.6-28.8 64.8-28.8 86.4 0zm62.1 123.5c-7.4-29-36.5-47.3-65.8-39.2c-28.9 8.1-45.1 38.6-37.7 67.4L362.1 484l4.1 15.8 15.8-4.4L472.5 470c28.9-8.1 45.1-38.6 37.7-67.4c-7.4-29-36.5-47.3-65.8-39.2l-2.4 .7-.8-3zm-57.1-8.3c10.8-3 22.9 3.5 26.1 16.3l4.8 18.9 4.1 15.8 15.8-4.4 18.1-5.1c10.8-3 22.9 3.5 26.1 16.3c3.3 13-4.2 25.5-15.3 28.6l-74.9 21-20.2-78.8c-3.3-13 4.2-25.5 15.3-28.6z'
      
    ]
  };

  
    var faKissWinkHeart = faFaceKissWinkHeart;
  

  
  

  var faWheatAwnSlash = {
    prefix: 'fasl',
    iconName: 'wheat-awn-slash',
    icon: [
      640,
      512,
      [],
      'e338',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM261.7 291.5l-37 37c1.9-31.2-7.5-62.9-28.2-88.5l-48.5-38.3-17 17-22.6 22.6c-37.5 37.5-37.5 98.3 0 135.8L142.2 411l0 0L68.7 484.5l22.6 22.6 73.5-73.5 0 0 33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6 22.6-22.6-22.6-22.6-11.3-11.3c-27-27-63.2-39.4-98.5-37.2L287 311.5l-25.3-20zM289.2 60.3C270.5 79 261.2 103.5 261.1 128l40.4 31.9c-13.9-24.4-10.5-56.1 10.4-76.9l22.6-22.6 11.3 11.3c35.1 35.1 37.3 90.7 6.6 128.4l26.5 20.9c37.6-28.1 91.1-25.1 125.3 9.1l11.3 11.3-22.6 22.6c-10.3 10.3-23.2 16.3-36.6 18.2l30.6 24.2c10.3-4.6 20-11.2 28.5-19.7l22.6-22.6 22.6-22.6-22.6-22.6-11.3-11.3c-5.8-5.8-12-10.9-18.6-15.4L555 145.1l11.3-11.3-22.6-22.6-11.3 11.3L478 176.9c-16.1-5.5-33-7.8-49.8-6.7L555 43.3 532.4 20.7 405.6 147.5c1-16.8-1.2-33.7-6.7-49.8l54.3-54.4L464.5 32 441.9 9.4 430.6 20.7 383.8 67.5c-4.5-6.5-9.6-12.8-15.4-18.6L357.1 37.7 334.5 15.1 311.8 37.7 289.2 60.3zm-135.7 181l11.3 11.3c37.5 37.5 37.5 98.2 0 135.7l-33.9-33.9c-25-25-25-65.5 0-90.5l22.6-22.6zm181 181l-22.6 22.6c-25 25-65.5 25-90.5 0L187.5 411c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3z'
      
    ]
  };

  

  
  

  var faLanguage = {
    prefix: 'fasl',
    iconName: 'language',
    icon: [
      640,
      512,
      [],
      'f1ab',
      
      'M32 96V416H304V96H32zM336 416H608V96H336V416zM608 64h32V96 416v32H608 32 0V416 96 64H32 608zM496 160v16 16h48 16 16v32H560h-6.1l-41.8 83.7c1.7 1.1 3.5 2.2 5.3 3.3l18.9 11.3 13.7 8.2L533.5 358l-13.7-8.2-18.9-11.3c-5.6-3.4-11-7-16.3-10.8l-45.4 22.7-14.3 7.2-14.3-28.6 14.3-7.2L458.3 305l-21.6-21.6L425.4 272 448 249.4l11.3 11.3 22.6 22.6c1.5 1.5 2.9 2.9 4.4 4.3L518.1 224H480 400 384V192h16 64V176 160h32zm-346.7 0h21.5l4.1 9.9 72 176 2.5 6.1H214.7l-13.1-32.1c-.5 .1-1.1 .1-1.6 .1H120c-.5 0-1.1 0-1.6-.1L105.3 352H70.7l2.5-6.1 72-176 4.1-9.9zM160 218.3L131.5 288h57.1L160 218.3z'
      
    ]
  };

  

  
  

  var faBreadSlice = {
    prefix: 'fasl',
    iconName: 'bread-slice',
    icon: [
      512,
      512,
      [],
      'f7ec',
      
      'M96 224v32V448H416V256 224h32c17.7 0 32-14.3 32-32c0-44.3-32.4-76.2-84.6-98.6C344.1 71.4 284.5 64 256 64s-88.1 7.4-139.4 29.4C64.4 115.8 32 147.7 32 192c0 17.7 14.3 32 32 32H96zM448 448v32H416 96 64V448 288 256c-35.3 0-64-28.7-64-64C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64v32V448z'
      
    ]
  };

  

  
  

  var faVectorSquare = {
    prefix: 'fasl',
    iconName: 'vector-square',
    icon: [
      448,
      512,
      [],
      'f5cb',
      
      'M416 64v64H352V64h64zM352 32H320V64 80H128V64 32H96 32 0V64v64 32H32 48l0 192H32 0v32 64 32H32 96h32V448 432H320v16 32h32 64 32V448 384 352H416 400V160h16 32V128 64 32H416 352zM80 352l0-192H96h32V128 112H320v16 32h32 16V352H352 320v32 16H128V384 352H96 80zM32 384H96v64H32V384zm320 0h64v64H352V384zM32 64H96v64H32V64z'
      
    ]
  };

  

  
  

  var faMoneyCheckDollar = {
    prefix: 'fasl',
    iconName: 'money-check-dollar',
    icon: [
      576,
      512,
      ["money-check-alt"],
      'f53d',
      
      'M32 96V416H544V96H32zM0 64H32 544h32V96 416v32H544 32 0V416 96 64zM480 288v32H256V288H480zM256 192H480v32H256V192zm-96-32v9.6c5.9 1 19 3.5 24.1 4.9l15.5 4.1-8.2 30.9-15.5-4.1c-4-1.1-17.7-3.7-22.1-4.4c-12.8-2-23.6-.4-30.9 2.9c-7.2 3.3-9.9 7.5-10.5 11c-.7 4.1-.1 6.2 .5 7.4c.6 1.4 2 3.1 5 5.1c6.7 4.6 17.1 7.8 31 12l.6 .2 0 0c12.3 3.7 27.9 8.4 39.5 16.9c6.3 4.5 12 10.6 15.6 18.8c3.6 8.3 4.4 17.4 2.7 27.2c-3 17.5-14.6 29.4-29.3 35.7c-5.6 2.4-11.6 4-17.9 4.9V352v16H128V352v-9.6c-9.4-1.7-23.6-6.6-32.4-9.6l0 0 0 0 0 0c-1.8-.6-3.3-1.1-4.6-1.6l-15.2-5.1 10.1-30.4 15.2 5.1c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c9.5 3.2 20.7 7 27.1 8.1c13.3 2.1 24 .8 31-2.2c6.5-2.8 9.5-6.7 10.3-11.8c.8-4.7 .2-7.3-.5-9c-.7-1.7-2.2-3.6-5.1-5.7c-6.5-4.8-16.7-8.1-30.5-12.3l-2-.6 0 0c-11.9-3.6-26.6-8-37.7-15.5c-6.2-4.2-12.2-10-15.9-17.9c-3.8-8.1-4.7-17.1-3.1-26.6c2.9-16.7 14.7-28.4 28.8-34.7c5.6-2.6 11.8-4.4 18.3-5.4V160 144h32v16z'
      
    ]
  };

  
    var faMoneyCheckAlt = faMoneyCheckDollar;
  

  
  

  var faDiceD4 = {
    prefix: 'fasl',
    iconName: 'dice-d4',
    icon: [
      512,
      512,
      [],
      'f6d0',
      
      'M235.5 25.6L20 295 0 320l25.6 19.2L240 500l16 12 16-12L486.4 339.2 512 320l-20-25L276.5 25.6 272 20 256 0 240 20l-4.5 5.6zM240 71.2V460L45.6 314.2 240 71.2zM272 460V71.2l194.4 243L272 460z'
      
    ]
  };

  

  
  

  var faPersonDressBurst = {
    prefix: 'fasl',
    iconName: 'person-dress-burst',
    icon: [
      640,
      512,
      [],
      'e544',
      
      'M193.8 36.1l25.1 50.8 55.3-12 39.4-8.6-17.1 36.5L272.4 154l43.9 35.7 31.3 25.4-39.2 9.4-55.1 13.1-.6 56.6-.4 40.3-31.8-24.8L176 274.9l-44.6 34.9L99.6 334.6l-.4-40.3-.6-56.6L43.6 224.5 4.4 215.2l31.3-25.4L79.6 154 55.5 102.7 38.4 66.3l39.4 8.6 55.3 12 25.1-50.8L176 0l17.8 36.1zm31.9 82l-24.4 5.3-11.1-22.4L176 72.3l-14.2 28.8-11.1 22.4-24.4-5.3-31.4-6.8 13.6 29.1L119.2 163 99.8 178.8 74.9 199.1l31.2 7.5 24.3 5.8 .2 25 .3 32.1 25.3-19.8L176 234.3l19.7 15.4L221 269.5l.3-32.1 .2-25 24.3-5.8 31.2-7.5-24.9-20.3L232.8 163l10.6-22.6 13.6-29.1-31.4 6.8zM504 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 424 56zm22.3 207.2L393.9 368H416h32 64 32 22.1L513.7 263.2l-7.2-14.3 28.6-14.3 7.2 14.3 64 128L617.9 400H592 544v96 16H512V496 400H448v96 16H416V496 400H368 342.1l11.6-23.2 64-128 7.2-14.3 28.6 14.3-7.2 14.3zM419.3 128h9.6H531.1h9.6l4.5 8.5 76.9 144 7.5 14.1-28.2 15.1-7.5-14.1L521.5 160h-83L366.1 295.5l-7.5 14.1-28.2-15.1 7.5-14.1 76.9-144 4.5-8.5z'
      
    ]
  };

  

  
  

  var faChartNetwork = {
    prefix: 'fasl',
    iconName: 'chart-network',
    icon: [
      640,
      512,
      [],
      'f78a',
      
      'M192 32V96h64V32H192zM160 0h32 64 32V32 96v21.3L314.7 194c6.9-1.3 14-2 21.3-2c31.7 0 60.2 13.1 80.6 34.2L512 157.6V96 64h32 64 32V96v64 32H608 544 518.9l-83.6 60.2c8.1 15.5 12.7 33.1 12.7 51.8c0 12.3-2 24.2-5.7 35.3L531.8 384H544h64 32v32 64 32H608 544 512V480 416v-6.1l-84-42C407.8 397 374.1 416 336 416c-56.4 0-103.1-41.7-110.9-96H128v16 32H96 32 0V336 272 240H32 96h32v32 16h97.1c5.2-36.4 27.9-67.2 59.3-83.5L257.8 128H256 192 160V96 32 0zM336 384a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM96 272H32v64H96V272zM608 96H544v64h64V96zM544 416v64h64V416H544z'
      
    ]
  };

  

  
  

  var faWifiExclamation = {
    prefix: 'fasl',
    iconName: 'wifi-exclamation',
    icon: [
      640,
      512,
      [],
      'e2cf',
      
      'M336 48V32H304V48 288v16h32V288 48zM3.1 163.4l21.6 23.7C89.4 121.8 175.7 77.8 272 66.7V48 34.5C167.4 45.7 73.5 92.8 3.1 163.4zM110.9 282l21.6 23.8c36.4-39.1 84.9-66.9 139.5-77.2V196c-63 10.6-119.1 41.6-161.1 86zM368 196v32.5c54.6 10.4 103.1 38.1 139.5 77.2L529.1 282C487 237.6 431 206.5 368 196zm0-148V66.7c96.3 11.1 182.6 55 247.4 120.3l21.6-23.7C566.5 92.8 472.6 45.7 368 34.5V48zM288 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faKidneys = {
    prefix: 'fasl',
    iconName: 'kidneys',
    icon: [
      640,
      512,
      [],
      'f5fb',
      
      'M456 192l-9.3-10.5-39.2-44.1c-10-11.2-15.5-25.7-15.5-40.6c0-21 11-40.1 30.7-53.2c9.5-6.3 28.9-12.2 53.3-11.6c40.2 1.1 72.4 24.5 95.9 62.2C595.6 132.3 608 181.6 608 224c0 30.8-6.8 64.6-21.5 89.6c-13.9 23.5-33.9 38.4-64.8 38.4c-42.9 0-77.9-37.3-74.3-73.3l7.3-72.7 1.4-14zm-36.2 40l-4.4 43.5C409.7 333.6 463.3 384 521.7 384C610.2 384 640 293 640 224C640 128.4 585 3 476.8 0C448-.8 421.5 5.9 404.9 16.9C377.8 35 360 63.5 360 96.7c0 22.8 8.4 44.8 23.5 61.9l34.3 38.6-1 .5-56 28-8.8 4.4V240 496v16h32V496 249.9L419.8 232zM184 192l1.4 14 7.3 72.7c3.6 36-31.5 73.3-74.3 73.3c-30.9 0-50.9-14.8-64.8-38.4C38.8 288.6 32 254.8 32 224c0-42.4 12.4-91.7 36.1-129.8C91.7 56.5 123.9 33.1 164 32c24.4-.7 43.8 5.2 53.3 11.6C237 56.7 248 75.7 248 96.7c0 15-5.5 29.4-15.5 40.6l-39.2 44.1L184 192zm36.2 40L256 249.9V496v16h32V496 240v-9.9l-8.8-4.4-56-28-1-.5 34.3-38.6c15.2-17.1 23.5-39.1 23.5-61.9c0-33.3-17.8-61.7-44.9-79.8C218.5 5.9 192-.8 163.2 0C55 3 0 128.4 0 224c0 69 29.8 160 118.3 160c58.4 0 112-50.4 106.2-108.5L220.2 232z'
      
    ]
  };

  

  
  

  var faFaceParty = {
    prefix: 'fasl',
    iconName: 'face-party',
    icon: [
      640,
      512,
      [],
      'e383',
      
      'M320 32C196.3 32 96 132.3 96 256s100.3 224 224 224c4.1 0 8.3-.1 12.4-.3C396.2 476.2 453 446 491.6 400h7.2 .1 32.7c-43.6 64-115.4 107.2-197.6 111.6c-4.7 .3-9.4 .4-14.1 .4C178.6 512 64 397.4 64 256c0-19.9 2.3-39.2 6.5-57.8L16.8 37.1 7.4 8.7l28.8 7.9L165.5 51.8C208.5 19.3 262 0 320 0c25.8 0 50.8 3.8 74.3 10.9c79.7 24.1 143 86.1 169 165.1H540.4c-.2 0-.5 0-.7 0H529.3c-26.4-69-86-121.6-159.2-138.4C354 33.9 337.2 32 320 32zM87.7 148.4c12.3-26.5 29-50.6 49.2-71.2l-20.3-5.5c-14.4 15.2-27.1 32-37.8 50.1l8.9 26.6zm-31-93.1L65.9 83C71 75.8 76.4 68.9 82 62.2L56.6 55.3zM196.8 237.6l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0zm160 0l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0zm22.8 141.1c-10.5-5.1-24.8-9-37.9-10.8V336.2c13.1-1.8 27.3-5.7 37.9-10.8c5.3-2.6 8.8-5.1 10.8-7.2c1.1-1.1 1.4-1.8 1.6-2.1c-.1-.3-.5-1-1.6-2.1c-2-2.1-5.5-4.6-10.8-7.2c-10.5-5.1-24.8-9-37.9-10.8l4.5-31.7c15.4 2.2 33.1 6.7 47.5 13.8c7.2 3.5 14.3 8 19.9 13.9c5.6 5.9 10.4 14.1 10.4 24.2c0 7.9-2.9 14.6-6.9 20H608V240H544v32h32 16v32H576 528 512V288 224 208h16 96 16v16V352v16H624 417.1c4 5.4 6.9 12.1 6.9 20c0 10.1-4.8 18.3-10.4 24.2c-5.6 5.8-12.7 10.3-19.9 13.9c-14.4 7-32.1 11.6-47.5 13.8l-4.5-31.7c13.1-1.8 27.3-5.7 37.9-10.8c5.3-2.6 8.8-5.1 10.8-7.2c1.1-1.1 1.4-1.8 1.6-2.1c-.1-.3-.5-1-1.6-2.1c-2-2.1-5.5-4.6-10.8-7.2zm12.4 9.5a0 0 0 1 0 -.1 0 0 0 0 1 0 .1 0zm0-.3a.1 .1 0 1 0 0-.1 .1 .1 0 1 0 0 .1zm0-71.7a0 0 0 1 0 -.1 0 0 0 0 1 0 .1 0zm0-.3a.1 .1 0 1 0 0-.1 .1 .1 0 1 0 0 .1z'
      
    ]
  };

  

  
  

  var faSparkle = {
    prefix: 'fasl',
    iconName: 'sparkle',
    icon: [
      448,
      512,
      [],
      'e5d6',
      
      'M298.7 330.7l113.6-56.8L448 256l-35.8-17.9L298.7 181.3 241.9 67.8 224 32 206.1 67.8 149.3 181.3 35.8 238.1 0 256l35.8 17.9 113.6 56.8 56.8 113.6L224 480l17.9-35.8 56.8-113.6zM224 408.4l-46-92.1-4.8-9.5-9.5-4.8L71.6 256l92.1-46 9.5-4.8 4.8-9.5 46-92.1 46 92.1 4.8 9.5 9.5 4.8 92.1 46-92.1 46-9.5 4.8-4.8 9.5-46 92.1z'
      
    ]
  };

  

  
  

  var faChartWaterfall = {
    prefix: 'fasl',
    iconName: 'chart-waterfall',
    icon: [
      512,
      512,
      [],
      'e0eb',
      
      'M32 32V48 448H496h16v32H496 16 0V464 48 32H32zM160 224v16 96 16H128V336 240 224h32zm96-80v96 16H224V240 144 128h32v16zm96-80V80v96 16H320V176 80 64h32zm96 16V336v16H416V336 80 64h32V80z'
      
    ]
  };

  

  
  

  var faListOl = {
    prefix: 'fasl',
    iconName: 'list-ol',
    icon: [
      512,
      512,
      ["list-1-2","list-numeric"],
      'f0cb',
      
      'M32 32H48 80 96V48 192h32 16v32H128 32 16V192H32 64V64H48 32V32zM192 80h16H496h16v32H496 208 192V80zm0 160h16H496h16v32H496 208 192V240zm0 160h16H496h16v32H496 208 192V400zM80 288h4.5c32.9 0 59.5 26.6 59.5 59.5c0 17.7-7.9 34.6-21.6 45.9L56.4 448H128h16v32H128 32 16V464 447.4v-7.5l5.8-4.8L102 368.7c6.3-5.2 10-13 10-21.2c0-15.2-12.3-27.5-27.5-27.5H80c-17.7 0-32 14.3-32 32H16c0-35.3 28.7-64 64-64z'
      
    ]
  };

  
    var faList12 = faListOl;
  
    var faListNumeric = faListOl;
  

  
  

  var faSort = {
    prefix: 'fasl',
    iconName: 'sort',
    icon: [
      320,
      512,
      ["unsorted"],
      'f0dc',
      
      'M32 190.2L160 75 288 190.2V192H32v-1.7zM0 224H32 288h32V192 176L160 32 0 176v16 32zm32 97.8V320H288v1.8L160 437 32 321.8zM0 288v32 16L160 480 320 336V320 288H288 32 0z'
      
    ]
  };

  
    var faUnsorted = faSort;
  

  
  

  var faLocust = {
    prefix: 'fasl',
    iconName: 'locust',
    icon: [
      576,
      512,
      [],
      'e520',
      
      'M304 32H288V64h16 80c88.4 0 160 71.6 160 160H429.9L382 136.3l-12-22.1-14.9 20.2-36.9 50-32.9-49.4-12.5-18.8-13.6 18.1L192 224H64 32v32 83.2l54.8 25.1L0 480H40l76.6-102.1 53.1 24.3L112.3 480h39.7l47.3-64.3 .6 .3h81l-36.6 64h36.9l36.6-64H454.1l32 64h35.8l-32.2-64.5c48.5-4.8 86.3-45.8 86.3-95.5V256 224h0c0-106-86-192-192-192H304zm62 141.7L393.4 224H344.6l-7.4-11.1L366 173.7zm-67.9 38.2L289.2 224H232l39.2-52.3 26.8 40.2zM64 256H168l-61.5 82.1L64 318.6V256zm144 0H544v64c0 35.3-28.7 64-64 64H207l-70.7-32.3L208 256zm264 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faFilterCircleXmark = {
    prefix: 'fasl',
    iconName: 'filter-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e17b',
      
      'M224 276.2V288v65.5L256.5 382c1.5 19 6 37.1 13 53.9L192 368V288L0 64V32 0H32 480h32V32 64L399.8 194.9c-23.4 4.3-45.2 13.3-64.3 25.9L480 52.2V32H32V52.2l184.3 215 7.7 9zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-36.7L454.6 368l36.7 36.7L502.6 416 480 438.6l-11.3-11.3L432 390.6l-36.7 36.7L384 438.6 361.4 416l11.3-11.3L409.4 368l-36.7-36.7L361.4 320 384 297.4l11.3 11.3L432 345.4l36.7-36.7L480 297.4 502.6 320l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faToiletPaperCheck = {
    prefix: 'fasl',
    iconName: 'toilet-paper-check',
    icon: [
      640,
      512,
      [],
      'e5b2',
      
      'M26.4 467.8L21.3 480 8 512H42.7 365.3l8.2-19.7c21.9-53 32.7-112.3 37.9-171.6C415.2 277 416 233.3 416 192c0-81.8 30.7-149.2 70.3-158.8c3.2-.8 6.4-1.2 9.7-1.2c44.2 0 80 71.6 80 160s-35.8 160-80 160c-19.8 0-37.9-14.4-51.9-38.2c-1.2 15.2-2.7 30.5-4.7 45.8C454.5 374 473.3 384 496 384c40.7 0 69-32.2 85.2-64.6C598.3 285.2 608 240.1 608 192s-9.7-93.2-26.8-127.4C565 32.2 536.7 0 496 0c-1.3 0-2.6 0-3.8 .1l0-.1H160C107 0 64 86 64 192c0 89.9-3.9 190.6-37.6 275.8zM410.8 64.6C393.7 98.8 384 143.9 384 192c0 97.7-4.6 202.5-40 288l0 0H56l.2-.4C92.4 388.2 96 281.8 96 192c0-49.1 10-92 24.7-121.5C136.4 39.2 152.1 32 160 32H432.3c-8.6 9.9-15.8 21.2-21.5 32.6zM496 240c-6.4 0-11.9-11.3-14.5-27.6c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6zm0 32c16.2 0 26.6-9.9 31.4-16c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16zM307.3 187.3L318.6 176 296 153.4l-11.3 11.3L224 225.4l-28.7-28.7L184 185.4 161.4 208l11.3 11.3 40 40L224 270.6l11.3-11.3 72-72z'
      
    ]
  };

  

  
  

  var faCircleI = {
    prefix: 'fasl',
    iconName: 'circle-i',
    icon: [
      512,
      512,
      [],
      'e111',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128H160v32h16 64V352H176 160v32h16 64 32 64 16V352H336 272V160h64 16V128H336 256 176z'
      
    ]
  };

  

  
  

  var faUserGroupCrown = {
    prefix: 'fasl',
    iconName: 'user-group-crown',
    icon: [
      640,
      512,
      ["users-crown"],
      'f6a5',
      
      'M264.1 59.8L224 36.9 183.9 59.8l-14.1 8L155 61.2l-27-12V112H320V49.2l-27 12-14.8 6.6-14.1-8zM224 240c53 0 96-43 96-96H128c0 53 43 96 96 96zM96 144V128 35 0l32 14.2L168 32 224 0l56 32 40-17.8L352 0V35v93 16c0 70.7-57.3 128-128 128s-128-57.3-128-128zM43.3 480H404.7L360.4 336H87.6L43.3 480zM64 304H384l54.2 176 9.8 32H414.5 33.5 0l9.8-32L64 304zM606.3 512H481.5l-2.9-9.4-7-22.6h124L552.9 352H432.2l-9.8-32H576l53.3 160L640 512H606.3zM432 256c-27.7 0-53-10.1-72.6-26.7c5.9-9.4 10.9-19.4 14.8-30C388.8 214.5 409.3 224 432 224c44.2 0 80-35.8 80-80s-35.8-80-80-80c-18 0-34.6 6-48 16V53.7 42.8C398.6 35.9 414.8 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z'
      
    ]
  };

  
    var faUsersCrown = faUserGroupCrown;
  

  
  

  var faCircleArrowRight = {
    prefix: 'fasl',
    iconName: 'circle-arrow-right',
    icon: [
      512,
      512,
      ["arrow-circle-right"],
      'f0a9',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm379.3 11.3L390.6 256l-11.3-11.3-96-96L272 137.4 249.4 160l11.3 11.3L329.4 240 144 240l-16 0 0 32 16 0 185.4 0-68.7 68.7L249.4 352 272 374.6l11.3-11.3 96-96z'
      
    ]
  };

  
    var faArrowCircleRight = faCircleArrowRight;
  

  
  

  var faBreadSliceButter = {
    prefix: 'fasl',
    iconName: 'bread-slice-butter',
    icon: [
      512,
      512,
      [],
      'e3e1',
      
      'M96 256V224H64c-17.7 0-32-14.3-32-32c0-44.3 32.4-76.2 84.6-98.6C167.9 71.4 227.5 64 256 64s88.1 7.4 139.4 29.4C447.6 115.8 480 147.7 480 192c0 17.7-14.3 32-32 32H416v32V448H96V256zM448 480V448 288 256c35.3 0 64-28.7 64-64C512 64 320 32 256 32S0 64 0 192c0 35.3 28.7 64 64 64v32V448v32H96 416h32zM267.3 188.7L256 177.4l-11.3 11.3-88 88L145.4 288l11.3 11.3 88 88L256 398.6l11.3-11.3 88-88L366.6 288l-11.3-11.3-88-88zM256 353.4L190.6 288 256 222.6 321.4 288 256 353.4z'
      
    ]
  };

  

  
  

  var faMoonCloud = {
    prefix: 'fasl',
    iconName: 'moon-cloud',
    icon: [
      640,
      512,
      [],
      'f754',
      
      'M543.6 41.2c-19.7-5.8-40.6-9-62.2-9.2L480 32c-118.5 0-215.4 91.9-223.5 208.3c11.1 .9 21.8 3.6 31.6 7.7c3.5-85.9 63.4-157.2 143.7-178c-39.7 40.4-64.2 95.9-64.2 157.1c0 101.6 67.5 187.4 160 214.8c-15.2 3.9-31.2 6-47.7 6c-49.2 0-94-18.5-128-48.9v40.7c36.3 25.3 80.4 40.2 128 40.2c40 0 77.5-10.5 110-28.8l1.2-.7c17.9-10.3 34.3-22.9 48.6-37.6c-15.5 4.1-31.8 6.2-48.6 6.2c-3.2 0-6.4-.1-9.6-.2c-101.3-5-181.9-89-181.9-191.8c0-68.7 36-129 90.2-163c16.4-10.3 34.5-18.1 53.8-23.1zM64 288c-35.3 0-64 28.7-64 64v32 32H32 64 248h40 32V384 344c0-39.8-32.2-72-72-72c-6.4 0-12.7 .8-18.6 2.4c-3.4 .9-6.6 2-9.8 3.4c-1.3-3.6-2.8-7.2-4.5-10.5C201.8 241.6 174.9 224 144 224c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0zm224 56v40H248 64 32V352c0-17.7 14.3-32 32-32c.3 0 .5 0 .8 0l26.8 .7L97 294.4c4.4-21.9 23.9-38.4 47-38.4c21 0 38.9 13.4 45.4 32.3l11.3 32.5 31.6-13.6c4.8-2.1 10.1-3.2 15.8-3.2c22.1 0 40 17.9 40 40z'
      
    ]
  };

  

  
  

  var faArrowTurnDownRight = {
    prefix: 'fasl',
    iconName: 'arrow-turn-down-right',
    icon: [
      512,
      512,
      [],
      'e3d6',
      
      'M32 48V32H0V48 288v16H16 457.4L356.7 404.7 345.4 416 368 438.6l11.3-11.3 128-128L518.6 288l-11.3-11.3-128-128L368 137.4 345.4 160l11.3 11.3L457.4 272H32V48z'
      
    ]
  };

  

  
  

  var faGuitarElectric = {
    prefix: 'fasl',
    iconName: 'guitar-electric',
    icon: [
      512,
      512,
      [127928],
      'f8be',
      
      'M457.2 6.1L448.9 .3l-8.8 4.9L360.2 50 352 54.6V64v72c0 .4 0 .9 .1 1.3l-72.9 72.9c-12.3-15.1-13-30.1-10.5-42.5c3-15.1 10.5-25.5 19-37.3l0 0 0 0c.9-1.2 1.8-2.4 2.6-3.7l-24.5-24.5L243.2 79.6l-22.6 22.6-35 35c-9.6 9.6-15.6 21.6-21.5 33.5c-5.9 11.8-11.7 23.5-21 32.8c-14.8 14.8-34.9 20.4-55.2 26.1c-20.9 5.8-42.1 11.8-58.1 27.8c-39.6 39.6-39.6 103.8 0 143.5l0 0 80.4 81.2 .1 .1c20.5 20.5 47.6 30.4 74.4 29.7c25.1-.6 50-10.6 69.1-29.7c16.2-16.2 22-37.5 27.8-58.6c5.6-20.5 11.2-40.7 26.1-55.6c9.3-9.3 21-15.1 32.8-21l0 0c11.9-5.9 23.9-11.9 33.5-21.5l23.1-23.1 22.6-22.6-22.6-22.6-23.7-23.7c-25.2 16-46.5 20.8-71.6-.7L432 102.6c18.4 17.1 47.3 16.7 65.2-1.2c20.6-20.7 17.6-54.9-6.3-71.7L457.2 6.1zM420.7 68.7L384 105.4v-32l63.1-35.3 25.5 17.9c7.6 5.3 8.6 16.3 2 22.8c-5.8 5.8-15.3 5.8-21.2 0L443.3 68.7 432 57.4 420.7 68.7zM243.2 124.9l5.8 5.8c-4.9 8.6-9.3 18.8-11.7 30.8c-4.4 21.9-2 50.6 24 76.6l11.9 11.9c17.5 17.5 37.5 28.9 61 29.4c12 .2 23.1-2.5 33.2-6.5l7.1 7.1L351.3 303c-5.3 5.3-12.4 9.1-24.9 15.4l-1.5 .7c-11 5.4-26.8 13.3-39.8 26.4c-21 21-28.6 48.7-33.8 67.6l-.8 2.9c-6 22-10.3 34.5-19.4 43.6C218 472.8 201 479.6 183.8 480c-18.4 .5-36.9-6.3-51-20.3l-.1-.1L52.5 378.5l0 0-.1-.1 0 0 0 0c-27.1-27.1-27.1-71.1 0-98.2c9-9 21.5-13.3 43.3-19.4l2.9-.8c18.8-5.2 46.3-12.8 67.1-33.7c13-13 20.9-28.9 26.4-39.8l.7-1.5c6.3-12.6 10.1-19.7 15.4-24.9l35-35zM160 265.4L137.4 288l11.3 11.3 64 64L224 374.6 246.6 352l-11.3-11.3-64-64L160 265.4zm-48 48L89.4 336l11.3 11.3 64 64L176 422.6 198.6 400l-11.3-11.3-64-64L112 313.4z'
      
    ]
  };

  

  
  

  var faRectangleAd = {
    prefix: 'fasl',
    iconName: 'rectangle-ad',
    icon: [
      576,
      512,
      ["ad"],
      'f641',
      
      'M32 64V448H544V64H32zM0 32H32 544h32V64 448v32H544 32 0V448 64 32zM336 280a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm40-72c14.8 0 28.6 4.5 40 12.1V176 160h32v16V280v56 16H416V339.9c-11.4 7.7-25.2 12.1-40 12.1c-39.8 0-72-32.2-72-72s32.2-72 72-72zM186.6 160h10.5 5.9 10.5l4.2 9.7L296.3 352H261.5l-13.8-32-94.5 .5-1 0L138.5 352H103.7l78.7-182.3 4.2-9.7zM166 288.4l67.9-.3L200 209.6l-34 78.8z'
      
    ]
  };

  
    var faAd = faRectangleAd;
  

  
  

  var faNewspaper = {
    prefix: 'fasl',
    iconName: 'newspaper',
    icon: [
      512,
      512,
      [128240],
      'f1ea',
      
      'M96 32h16H496h16V48 464v16H496 128 112 64 16 0V464 112 96H16 64v32H32V448H64 96V48 32zm32 416H480V64H128V448zM384 96h16 32 16v32H432 400 384V96zm0 64h16 32 16v32H432 400 384V160zm0 64h16 32 16v32H432 400 384V224zM160 288h16H432h16v32H432 176 160V288zm0 64h16H432h16v32H432 176 160V352zm32-224v96H320V128H192zM160 96h32H320h32v32 96 32H320 192 160V224 128 96z'
      
    ]
  };

  

  
  

  var faStomach = {
    prefix: 'fasl',
    iconName: 'stomach',
    icon: [
      512,
      512,
      [],
      'f623',
      
      'M160 16V0H128V16 176v16h16H260c-2.6 10.2-4 21-4 32v48c0 44.2-35.8 80-80 80H64 48 16 0v16V496v16H32V496 384H48 64c25.1 0 49.5 12 68.3 31.2c19.2 19.5 46.1 43.5 77.9 62.7C242 497 279.6 512 320 512c106 0 192-86 192-192V224c0-70.7-57.3-128-128-128c-47.4 0-88.7 25.7-110.9 64H160V16zm-4.9 376.7c-3-3-6.1-5.9-9.3-8.7H176c42.8 0 80-24 98.9-59.4c25.6-11.2 43.6-12.6 57.6-10.2c15.3 2.6 27.6 9.7 42.4 18.4l.5 .3c14.1 8.3 30.9 18.1 52.1 20.7c15.2 1.8 31.7-.2 50.4-7.3C465.2 422.2 399.4 480 320 480c-32.5 0-64.4-12.1-93.2-29.5c-28.8-17.4-53.6-39.4-71.7-57.8zM480 310.5c-21.6 11-36.9 12.9-48.7 11.5c-13.9-1.7-25.4-8.1-40.2-16.8l-1.2-.7c-13.9-8.2-30.7-18-52.1-21.6c-15.1-2.5-31.7-1.8-50.7 3.4c.6-4.7 .9-9.4 .9-14.3V224c0-53 43-96 96-96s96 43 96 96v86.5z'
      
    ]
  };

  

  
  

  var faSnowflake = {
    prefix: 'fasl',
    iconName: 'snowflake',
    icon: [
      448,
      512,
      [10052,10054],
      'f2dc',
      
      'M240 16V0H208V16 89.4L171.3 52.7 160 41.4 137.4 64l11.3 11.3L208 134.6v93.7l-81.1-46.8-21.7-81L101 85 70.1 93.3l4.1 15.5 13.4 50.1L17.2 118.1l-16 27.7 70.5 40.7L21.6 200 6.1 204.1 14.4 235l15.5-4.1 81-21.7L192 256l-81.1 46.8-81-21.7L14.4 277 6.1 307.9 21.6 312l50.1 13.4L1.2 366.1l16 27.7 70.5-40.7L74.3 403.3l-4.1 15.5L101 427l4.1-15.5 21.7-81L208 283.7v93.7l-59.3 59.3L137.4 448 160 470.6l11.3-11.3L208 422.6V496v16h32V496 422.6l36.7 36.7L288 470.6 310.6 448l-11.3-11.3L240 377.4V283.7l81.1 46.8 21.7 81L347 427l30.9-8.3-4.1-15.5-13.4-50.1 70.5 40.7 16-27.7-70.5-40.7L426.4 312l15.5-4.1L433.6 277l-15.5 4.1-81 21.7L256 256l81.1-46.8 81 21.7 15.5 4.1 8.3-30.9L426.4 200l-50.1-13.4 70.5-40.7-16-27.7-70.5 40.7 13.4-50.1 4.1-15.5L347 85l-4.1 15.5-21.7 81L240 228.3V134.6l59.3-59.3L310.6 64 288 41.4 276.7 52.7 240 89.4V16z'
      
    ]
  };

  

  
  

  var faBroomWide = {
    prefix: 'fasl',
    iconName: 'broom-wide',
    icon: [
      512,
      512,
      [],
      'e5d1',
      
      'M340 148L488 0l24 24L364 172l52 52L257.2 483.9 240 512l-23.3-23.3L23.3 295.3 0 272l28.1-17.2L288 96l52 52zM51.4 278.1l47.9 47.9 33.4-33.4L144 281.4 166.6 304l-11.3 11.3-33.4 33.4L233.9 460.6l89.6-146.6L197.9 188.6 51.4 278.1zM340.6 286l34.9-57.2-92.4-92.4L226 171.4 340.6 286z'
      
    ]
  };

  

  
  

  var faP = {
    prefix: 'fasl',
    iconName: 'p',
    icon: [
      320,
      512,
      [112],
      '50',
      
      'M0 32H16 176c79.5 0 144 64.5 144 144s-64.5 144-144 144H32V464v16H0V464 320 288 48 32zM32 288H176c61.9 0 112-50.1 112-112s-50.1-112-112-112H32V288z'
      
    ]
  };

  

  
  

  var faTrashCanClock = {
    prefix: 'fasl',
    iconName: 'trash-can-clock',
    icon: [
      576,
      512,
      [],
      'e2aa',
      
      'M160 0h-8.9l-4.7 7.5L111.1 64H64 32 0V96H32V480v32H64 330.8c-12.9-9.1-24.5-19.9-34.6-32H64V96H384V198.6c10.3-2.9 21-4.9 32-5.9V96h32V64H416 384 336.9L301.6 7.5 296.9 0H288 160zM304 247.2c9.6-10.1 20.3-19.1 32-26.7V176 160H304v16 71.2zM299.1 64H148.9l20-32H279.1l20 32zM144 176V160H112v16V400v16h32V400 176zm96 0V160H208v16V400v16h32V400 176zm192 80a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-224H416v16 64 16h16 48 16V352H480 448V304 288z'
      
    ]
  };

  

  
  

  var faSausage = {
    prefix: 'fasl',
    iconName: 'sausage',
    icon: [
      512,
      512,
      [],
      'f820',
      
      'M400 0H384V32h16 64 16V0H464 400zM32 400V384H0v16 64 16H32V464 400zM480 160c0 176.7-143.3 320-320 320c-35.3 0-64-28.7-64-64s28.7-64 64-64c106 0 192-86 192-192c0-35.3 28.7-64 64-64s64 28.7 64 64zm32 0c0-53-43-96-96-96s-96 43-96 96c0 88.4-71.6 160-160 160c-53 0-96 43-96 96s43 96 96 96c194.4 0 352-157.6 352-352zm-96 16H384c0 114.9-93.1 208-208 208v32c132.5 0 240-107.5 240-240z'
      
    ]
  };

  

  
  

  var faFeatherPointed = {
    prefix: 'fasl',
    iconName: 'feather-pointed',
    icon: [
      512,
      512,
      ["feather-alt"],
      'f56b',
      
      'M160 154.3C199.7 114.6 266 85.2 336.3 65c50.4-14.5 100.5-23.7 139.6-28.8c-5.2 39-14.3 89.1-28.8 139.5c-4.7 16.4-9.9 32.6-15.7 48.3H310.6l37.6-37.6 11.3-11.3-22.6-22.6-11.3 11.3L116.4 373C96.1 345.5 91 310.2 98 272.2c8.1-44.3 32.4-88.3 62-118zM116.2 418.4c77.8 61.8 199.5 20.9 264.2-43.8c80.9-80.9 116.5-247.3 128.2-342.2c1.5-12.1 2.6-23 3.4-32.4c-9.4 .8-20.3 1.9-32.4 3.4c-95 11.8-261.3 47.4-342.2 128.2C72.7 196.3 31.7 318 93.6 395.8L14.3 475.1 3 486.4 25.6 509l11.3-11.3 79.3-79.3zM139 395.6L182.6 352H357.7c-29.6 29.6-73.7 53.9-118 62c-38 7-73.2 1.8-100.7-18.4zM384 320H214.6l64-64h140c-10.2 23.5-21.7 45.2-34.6 64z'
      
    ]
  };

  
    var faFeatherAlt = faFeatherPointed;
  

  
  

  var faMace = {
    prefix: 'fasl',
    iconName: 'mace',
    icon: [
      512,
      512,
      [],
      'f6f8',
      
      'M312.5 114l-5.9-11.1L288 68l-18.6 34.8L263.5 114 251.6 118c-32.5 11.2-58.4 37-69.5 69.5L178 199.5l-11.1 5.9L132 224l34.8 18.6 11.1 5.9 4.1 11.9c11.2 32.5 37 58.4 69.5 69.5l11.9 4.1 5.9 11.1L288 380l18.6-34.8 5.9-11.1 11.9-4.1c32.5-11.2 58.4-37 69.5-69.5l4.1-11.9 11.1-5.9L444 224l-34.8-18.6L398 199.5 394 187.6c-11.2-32.5-37-58.4-69.5-69.5L312.5 114zM478 205.9L512 224l-34 18.1-53.8 28.7c-14.4 41.9-47.5 75-89.4 89.4L306.1 414 288 448l-18.1-34-28.7-53.8c-15.8-5.4-30.3-13.5-43.1-23.7L35.3 499.3 24 510.6 1.4 488l11.3-11.3L175.5 313.9c-10.2-12.8-18.3-27.3-23.7-43.1L98 242.1 64 224l34-18.1 53.8-28.7c14.4-41.9 47.5-75 89.4-89.4L269.9 34 288 0l18.1 34 28.7 53.8c41.9 14.4 75 47.5 89.4 89.4L478 205.9zM288 208a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z'
      
    ]
  };

  

  
  

  var faTemperatureArrowDown = {
    prefix: 'fasl',
    iconName: 'temperature-arrow-down',
    icon: [
      576,
      512,
      ["temperature-down"],
      'e03f',
      
      'M101.3 284.5L112 275V260.7 32H240V260.7 275l10.7 9.5c23 20.6 37.3 50.3 37.3 83.5c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-33.2 14.4-62.9 37.3-83.5zM272 0H240 112 80V32 260.7C50.5 287.1 32 325.4 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-42.6-18.5-81-48-107.3V32 0zM144 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V272 256H160v16 34c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64zM420.7 475.3L432 486.6l11.3-11.3 80-80-22.6-22.6L448 425.4V48 32l-32 0V48 425.4l-52.7-52.7-22.6 22.6 80 80z'
      
    ]
  };

  
    var faTemperatureDown = faTemperatureArrowDown;
  

  
  

  var faBookmarkSlash = {
    prefix: 'fasl',
    iconName: 'bookmark-slash',
    icon: [
      640,
      512,
      [],
      'e0c2',
      
      'M512 32V0H480 160 128V22.9l32 25.3V32H480V300.8L512 326V32zM160 456.3V211.2L128 186V475v37l32-18.7L320 400l160 93.3L512 512V489.1l-68.7-54.3L336.1 372.4 320 363l-16.1 9.4L160 456.3zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faA = {
    prefix: 'fasl',
    iconName: 'a',
    icon: [
      384,
      512,
      [97],
      '41',
      
      'M181.2 32h21.7l4 10.1L382 480H347.6l-38.4-96H74.8L36.4 480H2L177.1 42.1l4-10.1zM192 91.1L87.6 352H296.4L192 91.1z'
      
    ]
  };

  

  
  

  var faRoadLock = {
    prefix: 'fasl',
    iconName: 'road-lock',
    icon: [
      640,
      512,
      [],
      'e567',
      
      'M74.4 448L184.1 64H304v48 16h32V112 64H455.9l29.8 104.3c9.7-4 20.2-6.6 31.1-7.7L480 32H336 304 160L41.1 448 32 480H65.3 304h32 48l0-32H336V400 384H304v16 48H74.4zM336 208V192H304v16 96 16h32V304 208zm192 16c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48H416v32V480v32h32H608h32V480 352 320H608V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z'
      
    ]
  };

  

  
  

  var faInputPipe = {
    prefix: 'fasl',
    iconName: 'input-pipe',
    icon: [
      640,
      512,
      [],
      'e1be',
      
      'M32 96V416H608V96H32zM0 64H32 608h32V96 416v32H608 32 0V416 96 64zM128 176V336v16H96V336 176 160h32v16z'
      
    ]
  };

  

  
  

  var faDeer = {
    prefix: 'fasl',
    iconName: 'deer',
    icon: [
      512,
      512,
      [129420],
      'f78e',
      
      'M256 16V0H224V16 40c0 30.9 25.1 56 56 56h8 8 23.2l-40 26.7-13.3 8.9 17.8 26.6 13.3-8.9 13.8-9.2-10 35.9H120 104 96c-53 0-96 43-96 96v48 16H32V320v-9.4l16 16v22.8L32.8 394.9 31.1 400l1.7 5.1 32 96L68.5 512H80h80 22.2l-7-21.1L147 406.5l37.8-25.2 8.6-5.7-1.7-10.2-1.9-11.6 17.3 11.5 4 2.7H216h56V496v16h16 80 16V496 311c0-3.1 .5-6.2 1.4-9.2L403.9 240H496h16V224 168v-6.6l-4.7-4.7L440.8 90.2C459.3 81.1 472 62 472 40V16 0H440V16 40c0 13.3-10.7 24-24 24h-1.4H408 346.6c3.5-7.3 5.4-15.4 5.4-24V16 0H320V16 40c0 13.3-10.7 24-24 24h-8-8c-13.3 0-24-10.7-24-24V16zM401.4 96L480 174.6V208H392 380.1l-3.4 11.4-22 73.3c-1.8 6-2.7 12.2-2.7 18.4V480H304V352 336H288 220.8l-44-29.3-24.7 15.9 6.3 37.8-39.4 26.3L109 393.5l3.9 11.6 25 74.9H91.5L64.9 400l14.3-42.9 .8-2.5V352 320v-6.6l-4.7-4.7L48 281.4V264c0-30.9 25.1-56 56-56h16H312.9h12.2l3.3-11.7L356.2 96h45.2zM416 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faPersonSkiing = {
    prefix: 'fasl',
    iconName: 'person-skiing',
    icon: [
      512,
      512,
      [9975,"skiing"],
      'f7c9',
      
      'M424 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 424 0zm-7.2 507.4L8.8 302.3l14.4-28.6L236.4 380.9 306.4 297l-97.2-97.2c-7.6-7.6-12.1-17.1-13.5-26.8l61.1 29.1L329 274.4c11.7 11.7 12.6 30.4 2 43.1l-65.2 78.2 159.1 80L474.4 457l15-5.6 11.3 29.9-15 5.6-56 21.1-6.6 2.5-6.3-3.2zM118.9 65.6L137 74.2l8.7-17.3 7.2-14.3 28.6 14.3-7.2 14.3L165.9 88 229 118l82.5-51.6 15.7-9.8 7.4 17 52 119.3 67.9 32.5 .3 .1 14.4 6.9 0 0 0 0-6.9 14.5-6.9 14.4 0 0 0 0-14.4-6.9-.2-.1L151.6 116.6l-9.3 18.6-7.2 14.3-28.6-14.3 7.2-14.3 9-18-17.6-8.4L90.7 87.6l13.8-28.9 14.4 6.9zm144.4 68.8l79.4 37.8-30-68.7-49.5 30.9z'
      
    ]
  };

  
    var faSkiing = faPersonSkiing;
  

  
  

  var faZ = {
    prefix: 'fasl',
    iconName: 'z',
    icon: [
      384,
      512,
      [122],
      '5a',
      
      'M384 32H368 16 0V64H16 333.5L3.8 453.7 0 458.1V480H16 368h16V448H368 50.5L380.2 58.3l3.8-4.5V32z'
      
    ]
  };

  

  
  

  var faPinball = {
    prefix: 'fasl',
    iconName: 'pinball',
    icon: [
      448,
      512,
      [],
      'e229',
      
      'M416 128a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM76.2 348.9l0 0 282.2 90.9 4.9-9.2L137.1 239l0 0C110 216.3 69.7 219.8 47 246.9s-19.2 67.5 7.9 90.2c6.1 5.1 13.2 9.1 21.3 11.8zm-9.9 30.4c-12.1-3.9-22.8-10-32-17.7c-40.6-34.1-46-94.7-11.9-135.3s94.6-45.9 135.2-11.8l246 208.3-29.6 55.7L66.3 379.3zM72 288a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faFaceConfused = {
    prefix: 'fasl',
    iconName: 'face-confused',
    icon: [
      512,
      512,
      [],
      'e36d',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM171.1 395.6l-1.1 .9-20-25 1.1-.9C205 327.5 272 304 341 304h11v32H341c-61.8 0-121.7 21-169.9 59.6zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faDemocrat = {
    prefix: 'fasl',
    iconName: 'democrat',
    icon: [
      640,
      512,
      [],
      'f747',
      
      'M88 0H78.9L74.2 7.9 88 16C74.2 7.9 74.2 7.9 74.2 7.9l0 0 0 0 0 0 0 .1L74 8.3l-.6 1c-.5 .8-1.2 2-2 3.5c-1.6 2.9-3.7 7-5.9 11.5c-2.1 4.5-4.4 9.7-6.2 14.8C57.7 43.9 56 50.1 56 56c0 17 7.8 31.3 16.4 42.1L11.5 174 4 183.3l6.9 9.8 56 80 8.7 12.4 12.9-8 46.3-29L160 330.4V336 496v16h16H288h16V496 416H432v80 16h16H560h16V496 336v-8V189.5l34.2 58.6 27.6-16.1-56-96-4.6-7.9-1.2 0H560 270.8L225.9 81.9c3.6-7.6 6.1-16.3 6.1-25.9c0-5.9-1.7-12.1-3.4-16.9c-1.8-5.1-4-10.3-6.2-14.8c-2.2-4.5-4.3-8.6-5.9-11.5c-.8-1.5-1.5-2.7-2-3.5l-.6-1-.2-.3 0-.1 0 0 0 0 0 0s0 0-13.8 8.1l13.8-8.1L209.1 0H200h-8-5.8l-4.5 3.8L144 35.5 106.3 3.8 101.8 0H96 88zM512 160h16l16 0V320H190.3l-31-100.7-6.1-19.9-17.7 11-51.1 32L44 184.7l62-77.2L115.1 96 104.6 85.9C94.9 76.6 88 66 88 56v0s0-.2 0-.5c0-.4 .1-.8 .3-1.4c.3-1.2 .7-2.7 1.3-4.5c1.2-3.6 3-7.6 4.8-11.5c.3-.6 .6-1.2 .8-1.7l37.6 31.6 5.9 5 7.6-1.5c.5-.1 1-.2 1.5-.3l4.4-.7 3.4-2.8 37.2-31.3c.3 .6 .6 1.2 .8 1.7c1.9 3.9 3.6 7.9 4.8 11.5c.6 1.8 1 3.3 1.3 4.5c.1 .6 .2 1.1 .3 1.4c0 .3 0 .5 0 .5l0 0c0 6.1-2.5 12.5-7.2 19.1L185.2 86l9.3 9.5 58.1 59.7 4.7 4.8H264l248 0zM192 480V352H544V480H464V400 384H448 288 272v16 80H192zm80-272V192H240v16 16H224 208v32h16 16v16 16h32V272 256h16 16V224H288 272V208zm112 0V192H352v16 16H336 320v32h16 16v16 16h32V272 256h16 16V224H400 384V208zm112-16H464v16 16H448 432v32h16 16v16 16h32V272 256h16 16V224H512 496V208 192z'
      
    ]
  };

  

  
  

  var faLinkSimpleSlash = {
    prefix: 'fasl',
    iconName: 'link-simple-slash',
    icon: [
      640,
      512,
      [],
      'e1ce',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM608 256c0-88.4-71.6-160-160-160H368 352v32h16 80c70.7 0 128 57.3 128 128c0 35.5-14.4 67.6-37.7 90.8l25.3 19.9C591.1 338 608 299 608 256zM456 272h16V240H456 403l40.5 32H456zM196.4 240H184 168v32h16 53l-40.5-32zm-94.7-74.8L76.5 145.3C48.9 174 32 213 32 256c0 88.4 71.6 160 160 160h80 16V384H272 192c-70.7 0-128-57.3-128-128c0-35.5 14.4-67.6 37.7-90.8z'
      
    ]
  };

  

  
  

  var faPickaxe = {
    prefix: 'fasl',
    iconName: 'pickaxe',
    icon: [
      512,
      512,
      [],
      'e5bf',
      
      'M474.1 324.8c-30.1-61.3-68.7-118-118.8-168.1S248.5 68 187.2 37.9c79-17.4 164.8 6.4 222.8 64.7c57.8 58 81.4 143.5 64.1 222.2zm20.1 44.3c37.7-98.7 13.4-214-61.5-289.1C357.5 4.6 241.8-19.9 142.9 17.9c-1.6 .6-3.2 1.3-4.9 1.9L99.6 35.3c14.5 5.4 28.8 11.1 42.8 17.2C213 83.2 277.3 123.9 332.7 179.3s96.1 119.7 126.8 190.2c6.1 14 11.8 28.3 17.2 42.8L492.2 374c.7-1.6 1.3-3.2 1.9-4.9zM0 456l56 56L341.9 236.7c-6.7-8-13.8-16-21.3-23.9L56.4 467.2 44.8 455.6 299.2 191.4c-7.9-7.5-15.9-14.6-23.9-21.3L0 456zM443.3 20.7L432 9.4 409.4 32l11.3 11.3 48 48L480 102.6 502.6 80 491.3 68.7l-48-48z'
      
    ]
  };

  

  
  

  var faTicketsSimple = {
    prefix: 'fasl',
    iconName: 'tickets-simple',
    icon: [
      640,
      512,
      [],
      'e659',
      
      'M96 32V64v72 32c22.1 0 40 17.9 40 40s-17.9 40-40 40v32 72 32h32H608h32V352 280 248c-22.1 0-40-17.9-40-40s17.9-40 40-40V136 64 32H608 128 96zm72 176c0-28.3-16.3-52.7-40-64.5V64H608v79.5c-23.7 11.8-40 36.2-40 64.5s16.3 52.7 40 64.5V352H128V272.5c23.7-11.8 40-36.2 40-64.5zM32 112V96H0v16V464v16H16 528h16V448H528 32V112z'
      
    ]
  };

  

  
  

  var faCommentsDollar = {
    prefix: 'fasl',
    iconName: 'comments-dollar',
    icon: [
      640,
      512,
      [],
      'f653',
      
      'M78.2 274.7L70.9 293 52.4 339.1l99.9-23 6.7-1.6 6.8 1.4c13.5 2.7 27.6 4.2 42.2 4.2c102.4 0 176-69.3 176-144s-73.6-144-176-144S32 101.3 32 176c0 30.8 11.9 59.8 33.2 84l13 14.8zM38 375.2L0 384l14.5-36.2 26.7-66.7C15.3 251.8 0 215.4 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176s-93.1 176-208 176c-16.7 0-32.9-1.7-48.5-4.8L38 375.2zm207.2 6.2c11.5-1.6 22.8-3.9 33.8-6.8C308.4 417.3 363.8 448 432 448c14.6 0 28.7-1.5 42.2-4.2l6.8-1.4 6.7 1.6 99.9 23L569.1 421l-7.3-18.3 13-14.8c21.3-24.1 33.2-53.2 33.2-84c0-70.9-66.3-137-160.6-143.5c-.9-11.1-2.8-21.9-5.6-32.3C552.1 132.5 640 209.6 640 304c0 39.4-15.3 75.8-41.2 105.1l26.7 66.7L640 512l-38-8.8-121.5-28c-15.6 3.1-31.8 4.8-48.5 4.8c-82 0-153-40.2-186.8-98.5zM224 90.7v7c5.8 1 16.2 3 20.5 4.2l15.5 4.1-8.1 30.9-15.5-4.1c-3.6-.9-15.8-3.3-19.8-3.9c-11.3-1.8-20.8-.3-27 2.5c-6.2 2.8-8.1 6.1-8.5 8.5c-.6 3.3 0 4.8 .3 5.4c.4 .8 1.3 2.1 3.9 3.9c5.8 3.9 14.9 6.7 27.5 10.4l.6 .2c11 3.3 25.2 7.5 35.9 15.2c5.8 4.2 11.2 9.8 14.6 17.4c3.4 7.8 4.1 16.3 2.6 25.3c-2.9 16.3-13.8 27.3-27.4 33.1c-4.7 2-9.8 3.4-15.1 4.2v6.4 16H192v-16-7.1c-8.6-1.7-20.5-5.8-28.1-8.4l0 0 0 0c-1.6-.5-2.9-1-4.1-1.4l-15.2-5 10-30.4 15.2 5c1.8 .6 3.7 1.2 5.6 1.9l0 0c8.6 2.9 18.5 6.2 24.1 7.1c11.8 1.8 21.1 .7 27.1-1.8c5.5-2.3 7.6-5.4 8.3-9.1c.7-3.8 .1-5.8-.3-6.8c-.5-1.1-1.5-2.6-4-4.3c-5.6-4-14.5-7-27-10.7l-1.9-.6c-10.6-3.2-24.1-7.2-34.3-14c-5.8-3.9-11.4-9.2-14.9-16.6c-3.6-7.6-4.5-16-2.9-24.8c2.7-15.6 13.9-26.4 26.9-32.2c4.8-2.1 10-3.7 15.5-4.7V90.7v-16h32v16z'
      
    ]
  };

  

  
  

  var faFaceHushed = {
    prefix: 'fasl',
    iconName: 'face-hushed',
    icon: [
      512,
      512,
      [],
      'e37b',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM179 160.9c-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9L89.4 175.2l11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1h16v32H192c-4.4 0-8.8 .3-13 .9zm141-.9H304V128h16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9zM288 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faPersonSnowmobiling = {
    prefix: 'fasl',
    iconName: 'person-snowmobiling',
    icon: [
      640,
      512,
      ["snowmobile"],
      'f7d1',
      
      'M256 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 176 56zM349.5 66l8.2 13.7 43.8 73L576 240v96l-90.4 60.3 63.1 82c.4 .6 .8 1.2 1.2 1.8h11.5l43.3-43.3L616 425.4 638.6 448l-11.3 11.3-48 48-4.7 4.7H568 432 416V480h16 77.7l-61.5-80H313.3c4.3 9.8 6.7 20.6 6.7 32c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80c0-26.2 12.6-49.4 32-64l48-96H288l36-48H280h-8l-4.8-6.4L224 160H186.4l-27.8 62.5-6.5 14.6-29.2-13 6.5-14.6 32-72 4.2-9.5H176h56 8l4.8 6.4L288 192h60l22.1-29.4L330.3 96.2 322 82.5 349.5 66zm45.1 119l-2.6 1.6L313.6 291.2c-6 8.1-15.5 12.8-25.6 12.8H99.8L75.7 352.1c1.4-.1 2.8-.1 4.3-.1H240c18 0 34.6 6 48 16H455.8h.3 14.2L544 318.9V259.8L394.6 185.1zM80 384c-26.5 0-48 21.5-48 48s21.5 48 48 48H240c26.5 0 48-21.5 48-48s-21.5-48-48-48H80z'
      
    ]
  };

  
    var faSnowmobile = faPersonSnowmobiling;
  

  
  

  var faChurch = {
    prefix: 'fasl',
    iconName: 'church',
    icon: [
      640,
      512,
      [9962],
      'f51d',
      
      'M336 16V0H304V16 48H264 248V80h16 40v39.4L167.1 210.7l-7.1 4.8V224 480H32V360.7l96-62.1V260.5L7.3 338.6 0 343.3V352 496v16H16 184v0h72 32 64 32 72v0H624h16V496 352v-8.7l-7.3-4.7L512 260.5v38.1l96 62.1V480H480V224v-8.6l-7.1-4.8L336 119.4V80h40 16V48H376 336V16zM448 480H384V384c0-35.3-28.7-64-64-64s-64 28.7-64 64v96H192V232.6l128-85.3 128 85.3V480zm-96-96v96H288V384c0-17.7 14.3-32 32-32s32 14.3 32 32z'
      
    ]
  };

  

  
  

  var faTableCellsColumnLock = {
    prefix: 'fasl',
    iconName: 'table-cells-column-lock',
    icon: [
      640,
      512,
      [],
      'e678',
      
      'M352 64l0 96 128 0 0-96L352 64zm-32 0L192 64l0 96 128 0 0-96zM160 64L32 64l0 384 128 0 0-384zm32 384l128 0 0-96-128 0 0 96zm160 0l32 0 0 32L32 480 0 480l0-32L0 64 0 32l32 0 448 0 32 0 0 32 0 97.1c-24.1 3.5-45.8 14.6-62.4 30.9L352 192l0 128 32 0 0 32-32 0 0 96zM320 320l0-128-128 0 0 128 128 0zm208-96c-26.5 0-48 21.5-48 48l0 48 96 0 0-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 32 0 128 0 32-32 0-160 0-32 0 0-32 0-128 0-32 32 0 0-48zm0 80l0 128 160 0 0-128-160 0z'
      
    ]
  };

  

  
  

  var faCalendarLinesPen = {
    prefix: 'fasl',
    iconName: 'calendar-lines-pen',
    icon: [
      576,
      512,
      [],
      'e472',
      
      'M128 16V0H96V16 64H32 0V96v64 32V480v32H32 253.4l4.6-32H32V192H384h32 32V160 96 64H416 352V16 0H320V16 64H128V16zM32 96H416v64H32V96zm80 256H96v32h16H240h16V352H240 112zM96 256v32h16H336h16V256H336 112 96zm393.3 13.3l41.5 41.5L508 333.5 466.5 292l22.8-22.8zM334 424.5L443.9 314.6l41.5 41.5L375.5 466l-49.1 7.7 7.7-49.1zM553.4 288.1L489.3 224 304 409.3l-10.8 69.5L288 512l33.2-5.2L390.7 496 553.4 333.3 576 310.7l-22.6-22.6z'
      
    ]
  };

  

  
  

  var faGlassCitrus = {
    prefix: 'fasl',
    iconName: 'glass-citrus',
    icon: [
      512,
      512,
      [],
      'f869',
      
      'M480 144c0-61.9-50.1-112-112-112c-44.7 0-83.2 26.2-101.2 64H232.2C252 40.1 305.3 0 368 0c79.5 0 144 64.5 144 144s-64.5 144-144 144l-.5 0 3.3-32C431.4 254.5 480 204.9 480 144zM68.8 480H283.2l20-192H48.8l20 192zM306.5 256l10-96H35.5l10 96h261zM312 512H40L3.3 160 0 128H32.2 319.8 352l-3.3 32L312 512z'
      
    ]
  };

  

  
  

  var faItalic = {
    prefix: 'fasl',
    iconName: 'italic',
    icon: [
      384,
      512,
      [],
      'f033',
      
      'M128 32h16H368h16V64H368 283L135.3 448H240h16v32H240 16 0V448H16h85L248.7 64H144 128V32z'
      
    ]
  };

  

  
  

  var faCediSign = {
    prefix: 'fasl',
    iconName: 'cedi-sign',
    icon: [
      384,
      512,
      [],
      'e0df',
      
      'M224 0V16 64c1.3 0 2.7 0 4 0c44 0 84.7 14.2 117.5 38.3l-18.9 25.8C299.1 108 265 96 228 96c-1.3 0-2.7 0-4 0V416c1.3 0 2.7 0 4 0c37 0 71.1-12 98.5-32.1l18.9 25.8C312.7 433.8 272 448 228 448c-1.3 0-2.7 0-4 0v48 16H192V496 444.8C101.2 428.2 32 350.3 32 256s69.2-172.2 160-188.8V16 0h32zM64 256c0 76 54.5 140.1 128 156.1V99.9C118.5 115.9 64 180 64 256z'
      
    ]
  };

  

  
  

  var faCouch = {
    prefix: 'fasl',
    iconName: 'couch',
    icon: [
      640,
      512,
      [],
      'f4b8',
      
      'M544 64H96V192H64V64 32H96 544h32V64 192H544V64zM32 448H96V416 320 288 256H32V448zm96-192v32H512V256 224h32 64 32v32V448v32H608 544 512V448H128v32H96 32 0V448 256 224H32 96h32v32zm0 160H512V320H128v96zm416 0v32h64V256H544v32 32 96z'
      
    ]
  };

  

  
  

  var faMartiniGlassEmpty = {
    prefix: 'fasl',
    iconName: 'martini-glass-empty',
    icon: [
      512,
      512,
      ["glass-martini"],
      'f000',
      
      'M256 258.7L32 34.7V32H480v2.7l-224 224zM512 0H480 32 0V32 48L233.4 281.4 240 288V480H144 128v32h16H256 368h16V480H368 272V288l6.6-6.6L512 48V32 0z'
      
    ]
  };

  
    var faGlassMartini = faMartiniGlassEmpty;
  

  
  

  var faMemo = {
    prefix: 'fasl',
    iconName: 'memo',
    icon: [
      384,
      512,
      [],
      'e1d8',
      
      'M32 32V480H352V32H32zM0 0H32 352h32V32 480v32H352 32 0V480 32 0zM80 128H304h16v32H304 80 64V128H80zm0 96H304h16v32H304 80 64V224H80zm0 96H208h16v32H208 80 64V320H80z'
      
    ]
  };

  

  
  

  var faSquare = {
    prefix: 'fasl',
    iconName: 'square',
    icon: [
      448,
      512,
      [9632,9723,9724,61590],
      'f0c8',
      
      'M416 64V448H32V64H416zM32 32H0V64 448v32H32 416h32V448 64 32H416 32z'
      
    ]
  };

  

  
  

  var faCommentCheck = {
    prefix: 'fasl',
    iconName: 'comment-check',
    icon: [
      512,
      512,
      [],
      'f4ac',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM363.3 187.3L374.6 176 352 153.4l-11.3 11.3L224 281.4l-52.7-52.7L160 217.4 137.4 240l11.3 11.3 64 64L224 326.6l11.3-11.3 128-128z'
      
    ]
  };

  

  
  

  var faHeartHalf = {
    prefix: 'fasl',
    iconName: 'heart-half',
    icon: [
      512,
      512,
      [],
      'e1ab',
      
      'M256 480V434.7 96L231.8 71.8c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8c0 36 14.3 70.5 39.8 96L224 448l32 32zm-32-77.3L62.4 241.1C42.9 221.7 32 195.3 32 167.8C32 110.5 78.5 64 135.8 64c27.5 0 53.9 10.9 73.4 30.4L224 109.3V402.7z'
      
    ]
  };

  

  
  

  var faTicketPerforated = {
    prefix: 'fasl',
    iconName: 'ticket-perforated',
    icon: [
      640,
      512,
      [],
      'e63e',
      
      'M0 64V96 416v32H32 608h32V416 336 304H624c-26.5 0-48-21.5-48-48s21.5-48 48-48h16V176 96 64H608 32 0zM608 416H32V96H608v81.6c-36.5 7.4-64 39.7-64 78.4s27.5 71 64 78.4V416zM480 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faFileZipper = {
    prefix: 'fasl',
    iconName: 'file-zipper',
    icon: [
      384,
      512,
      ["file-archive"],
      'f1c6',
      
      'M208 192H192V176 32H32V480H352V192H208zm138.7-32L224 37.3V160H346.7zM32 0H232L384 152V480v32H352 32 0V480 32 0H32zM64 64H80h64 16V96H144 80 64V64zm0 64H80h64 16v32H144 80 64V128zm0 64H80h64 16v32H144 80 64V192zm32 64h32 12.1l3.3 11.6L158 318.9c1.3 4.6 2 9.3 2 14V336c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3.1c0-4.7 .7-9.5 2-14l14.7-51.3L83.9 256H96zm.7 71.7c-.5 1.7-.7 3.5-.7 5.2V336c0 8.8 7.2 16 16 16s16-7.2 16-16v-3.1c0-1.8-.2-3.5-.7-5.2L115.9 288h-7.9L96.7 327.7z'
      
    ]
  };

  
    var faFileArchive = faFileZipper;
  

  
  

  var faHouseChimneyCrack = {
    prefix: 'fasl',
    iconName: 'house-chimney-crack',
    icon: [
      576,
      512,
      ["house-damage"],
      'f6f1',
      
      'M288 2.7L298.6 12 384 87.4V48 32h16 96 16V48 200h-.3l58.9 52-21.2 24L512 243V496v16H496 80 64V496 243L26.6 276 5.4 252l272-240L288 2.7zM480 172.1V64H416v51.6l64 56.5zM96 214.7V480H274.1l-47.4-71.1-8.9-13.3 13.3-8.9 79.8-53.2-82.2-82.2L217.4 240 240 217.4l11.3 11.3 96 96 13.8 13.8-16.2 10.8-82.7 55.1L312.6 480H480V214.7L288 45.3 96 214.7z'
      
    ]
  };

  
    var faHouseDamage = faHouseChimneyCrack;
  

  
  

  var faHeartCircleCheck = {
    prefix: 'fasl',
    iconName: 'heart-circle-check',
    icon: [
      576,
      512,
      [],
      'e4fd',
      
      'M256 141.3l-22.6-22.6L209.1 94.4C189.7 74.9 163.3 64 135.8 64C78.5 64 32 110.5 32 167.8c0 27.5 10.9 53.9 30.4 73.4l24.2 24.2L256 434.8l9.5-9.5c3.7 10.9 8.5 21.3 14.2 31.1l-1.1 1.1L256 480l-22.6-22.6L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8l1.6 1.6L256 96l22.6-22.6 1.6-1.6c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4c-9.6-4.5-19.7-8.1-30.2-10.7c2.9-9.5 4.3-19.5 4.3-29.7C480 110.5 433.5 64 376.2 64c-27.5 0-53.9 10.9-73.4 30.4l-24.2 24.2L256 141.3zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm78.6 112l-11.3 11.3-72 72L416 430.6l-11.3-11.3-40-40L353.4 368 376 345.4l11.3 11.3L416 385.4l60.7-60.7L488 313.4 510.6 336z'
      
    ]
  };

  

  
  

  var faArchway = {
    prefix: 'fasl',
    iconName: 'archway',
    icon: [
      512,
      512,
      [],
      'f557',
      
      'M0 32H16 32 64 448h32 16 16V64H496 480V448h16 16v32H496 480 448 424 408 384 352V448 352c0-53-43-96-96-96s-96 43-96 96v96 32H128 104 88 64 32 16 0V448H16 32V64H16 0V32zM64 64v64H448V64H64zm0 96V448H88h16 24V352c0-70.7 57.3-128 128-128s128 57.3 128 128v96h24 16 24V160H64z'
      
    ]
  };

  

  
  

  var faClockTwoThirty = {
    prefix: 'fasl',
    iconName: 'clock-two-thirty',
    icon: [
      512,
      512,
      [],
      'e35b',
      
      'M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400V256v-8.6l7.1-4.8 96-64 13.3-8.9 17.8 26.6-13.3 8.9L272 264.6V400v16H240V400z'
      
    ]
  };

  

  
  

  var faHashtagLock = {
    prefix: 'fasl',
    iconName: 'hashtag-lock',
    icon: [
      576,
      512,
      [],
      'e415',
      
      'M432 144h13.9l-3.6 18.1c-12.9 2.5-25.1 7.3-36 13.9H338.9L268.7 480H235.9l25.8-112H134.6L108.7 480H75.9l25.8-112H16 2.1l6.4-32H16h93.1L146 176H48 40.5l6.4-32H48 153.4L179.3 32h32.8L186.3 144H313.4L339.3 32h32.8L346.3 144H432zM178.9 176L142 336H269.1L306 176H178.9zM464 224c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32v32V480v32H544 384 352V480 352 320h32V272zm0 80V480H544V352H384z'
      
    ]
  };

  

  
  

  var faBorderOuter = {
    prefix: 'fasl',
    iconName: 'border-outer',
    icon: [
      448,
      512,
      [],
      'f851',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM248 136v48H200V136h48zM104 232h48v48H104V232zm144 0v48H200V232h48zm48 0h48v48H296V232zm-48 96v48H200V328h48z'
      
    ]
  };

  

  
  

  var faArrowsToDot = {
    prefix: 'fasl',
    iconName: 'arrows-to-dot',
    icon: [
      512,
      512,
      [],
      'e4be',
      
      'M272 16V0H240V16l0 121.4L187.3 84.7 176 73.4 153.4 96l11.3 11.3 80 80L256 198.6l11.3-11.3 80-80L358.6 96 336 73.4 324.7 84.7 272 137.4 272 16zm16 240a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm70.6 160l-11.3-11.3-80-80L256 313.4l-11.3 11.3-80 80L153.4 416 176 438.6l11.3-11.3L240 374.6V496v16h32V496 374.6l52.7 52.7L336 438.6 358.6 416zM96 153.4L73.4 176l11.3 11.3L137.4 240 16 240H0v32H16 137.4L84.7 324.7 73.4 336 96 358.6l11.3-11.3 80-80L198.6 256l-11.3-11.3-80-80L96 153.4zm320 0l-11.3 11.3-80 80L313.4 256l11.3 11.3 80 80L416 358.6 438.6 336l-11.3-11.3L374.6 272H496h16V240H496l-121.4 0 52.7-52.7L438.6 176 416 153.4z'
      
    ]
  };

  

  
  

  var faRestroomSimple = {
    prefix: 'fasl',
    iconName: 'restroom-simple',
    icon: [
      640,
      512,
      [],
      'e23a',
      
      'M96 64a32 32 0 1 1 64 0A32 32 0 1 1 96 64zm96 0A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM57.4 320l5.3-128H193.3l5.3 128H192 160 96 64 57.4zM64 352V496v16H96V496 352h64V496v16h32V496 352h8 32l-1.3-32L224 160H32L25.3 320 24 352H56h8zM336 0H304V16 496v16h32V496 16 0zM512 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 512 0a64 64 0 1 0 0 128zm-39.9 64h79.7l45.7 160H426.4l45.7-160zM576 160H448L393.1 352 384 384h33.3H448V496v16h32V496 384h64V496v16h32V496 384h30.7H640l-9.1-32L576 160z'
      
    ]
  };

  

  
  

  var faLayerGroup = {
    prefix: 'fasl',
    iconName: 'layer-group',
    icon: [
      576,
      512,
      [],
      'f5fd',
      
      'M288 221L78.8 128 288 35l209.2 93L288 221zM536.6 110.5L288 0 39.4 110.5 0 128l39.4 17.5L288 256 536.6 145.5 576 128l-39.4-17.5zM144 227l-39.4-17.5-65.2 29L0 256l39.4 17.5L288 384 536.6 273.5 576 256l-39.4-17.5-65.2-29L432 227l65.2 29L288 349 78.8 256 144 227zM104.6 337.5l-65.2 29L0 384l39.4 17.5L288 512 536.6 401.5 576 384l-39.4-17.5-65.2-29L432 355l65.2 29L288 477 78.8 384 144 355l-39.4-17.5z'
      
    ]
  };

  

  
  

  var faEnvelopeCircleCheck = {
    prefix: 'fasl',
    iconName: 'envelope-circle-check',
    icon: [
      640,
      512,
      [],
      'e4e8',
      
      'M32 159.2l224 154L339.2 256c-8 15.6-13.7 32.5-16.7 50.3L256 352 32 198V416H339.2c5.9 11.4 12.9 22.2 21 32H32 0V416 176 96 64H32 480h32V96v64.7c-5.3-.5-10.6-.7-16-.7c-6.3 0-12.5 .3-18.6 1l2.6-1.8V96H32v63.2zM496 448a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm78.6 112l-11.3 11.3-72 72L480 398.6l-11.3-11.3-40-40L417.4 336 440 313.4l11.3 11.3L480 353.4l60.7-60.7L552 281.4 574.6 304z'
      
    ]
  };

  

  
  

  var faWave = {
    prefix: 'fasl',
    iconName: 'wave',
    icon: [
      576,
      512,
      [],
      'e65b',
      
      'M304 80c-88.4 0-160 71.6-160 160c0 61.9-50.1 112-112 112H16V320H32c44.2 0 80-35.8 80-80c0-106 86-192 192-192c64.9 0 122.4 32.3 157.1 81.6l-19.9 23.7c-12.4-5.9-26.4-9.2-41.1-9.2c-53 0-96 43-96 96c0 44.2 35.8 80 80 80c20.9 0 41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C534.4 310.1 555.1 320 576 320v32c-30.3 0-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.9 9.9-19.8 15.3C441.5 337.9 414.3 352 384 352c-61.9 0-112-50.1-112-112c0-70.7 57.3-128 128-128l0 0c-26.8-20.1-60-32-96-32zM133.8 426.8C150.3 438.1 171.1 448 192 448s41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C342.3 438.1 363.1 448 384 448s41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C534.4 438.1 555.1 448 576 448v32c-30.3 0-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.9 9.9-19.8 15.3C441.5 465.9 414.3 480 384 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 465.9 222.3 480 192 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.8-19.8 15.3C57.6 465.9 30.3 480 0 480V448c20.9 0 41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.7 23.2 24.3 37.8 34.2z'
      
    ]
  };

  

  
  

  var faCommentMiddleTop = {
    prefix: 'fasl',
    iconName: 'comment-middle-top',
    icon: [
      512,
      512,
      [],
      'e14a',
      
      'M300.2 131.1L293 119.5 256 60.4l-37 59.2-7.2 11.6-13.3 2.8C98 154.9 32 226.7 32 304c0 91.3 93.8 176 224 176s224-84.7 224-176c0-77.3-66-149.1-166.5-170.1l-13.3-2.8zM237.1 30.2L256 0l18.9 30.2 45.2 72.4C430.5 125.7 512 207.1 512 304c0 114.9-114.6 208-256 208S0 418.9 0 304c0-96.9 81.5-178.3 191.9-201.4l45.2-72.4z'
      
    ]
  };

  

  
  

  var faGridRound2 = {
    prefix: 'fasl',
    iconName: 'grid-round-2',
    icon: [
      512,
      512,
      [],
      'e5db',
      
      'M128 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64A96 96 0 1 1 32 128a96 96 0 1 1 192 0zM128 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64A96 96 0 1 1 32 384a96 96 0 1 1 192 0zm96-256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm64 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm0 224a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z'
      
    ]
  };

  

  
  

  var faVirus = {
    prefix: 'fasl',
    iconName: 'virus',
    icon: [
      512,
      512,
      [],
      'e074',
      
      'M383.6 83.1l0 0C348.3 118.4 288 93.4 288 43.5V32v-.3V0H256.3 256h-.3H224V31.7 32 43.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75l-.2-.2L97.6 52.4 75.2 74.8 75 75l0 0 0 0-.2 .2L52.4 97.6 74.8 120l.2 .2 8.2 8.2 0 0C118.4 163.7 93.4 224 43.5 224H32h-.3H0v31.7 .3 .3V288H31.7 32 43.5c49.9 0 74.9 60.3 39.6 95.6L75 391.8l-.2 .2L52.4 414.4l22.4 22.4 .2 .2 0 0 .2 .2 22.4 22.4L120 437.2l.2-.2 8.2-8.2 0 0c35.3-35.2 95.6-10.3 95.6 39.6V480v.3V512h31.7 .3 .3H288V480.3 480 468.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2 .2 .2 22.4 22.4 22.4-22.4 .2-.2 .2-.2 22.4-22.4L437.2 392l-.2-.2-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480h.3H512V256.3 256v-.3V224H480.3 480 468.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2 .2-.2 22.4-22.4L437.2 75.2 437 75l-.2-.2L414.4 52.4 392 74.8l-.2 .2-8.2 8.2zm30.8 14l.2 .2 .2 .2-.2 .2-8.2 8.2c-55.2 55.2-16.1 149.7 62 149.7H480h.3v.3 .3H480 468.5c-78.1 0-117.2 94.4-62 149.7l8.2 8.2 .2 .2-.2 .2-.2 .2-.2-.2-8.2-8.2c-55.2-55.2-149.7-16.1-149.7 62V480v.3H256h-.3V480 468.5c0-78.1-94.4-117.2-149.6-62l0 0 0 0 0 0-8.1 8.1-.2 .2-.2-.2 0 0-.1-.1 0 0-.1-.2 .2-.2 8.2-8.2c55.2-55.2 16.1-149.7-62-149.7H32h-.3V256v-.3H32 43.5c78.1 0 117.2-94.4 62-149.7l0 0 0 0-8.2-8.2-.2-.2 .2-.2 0 0 0 0 .2-.2 .2 .2 8.2 8.2c55.2 55.2 149.7 16.1 149.7-62V32v-.3h.3 .3V32 43.5c0 78.1 94.4 117.2 149.6 62l0 0 0 0 8.2-8.2 .2-.2zM224 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faBookAtlas = {
    prefix: 'fasl',
    iconName: 'book-atlas',
    icon: [
      448,
      512,
      ["atlas"],
      'f558',
      
      'M0 64C0 28.7 28.7 0 64 0H432h16V16 400v16H432 416v64h16 16v32H432 64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H416V32H64C46.3 32 32 46.3 32 64l0 328.6zM176.5 224h-31c4.8 26.1 21.1 48.2 43.5 60.8c-6.6-16.9-11-37.8-12.5-60.8zm0-32c1.4-22.9 5.9-43.8 12.5-60.8c-22.4 12.6-38.7 34.7-43.5 60.8h31zM112 208a120 120 0 1 1 240 0 120 120 0 1 1 -240 0zm206.5 16h-31c-1.4 22.9-5.9 43.8-12.5 60.8c22.4-12.6 38.7-34.7 43.5-60.8zM275 131.2c6.6 16.9 11 37.8 12.5 60.8h31c-4.8-26.1-21.1-48.2-43.5-60.8zM255.4 224H208.6c1.6 22.6 6.5 41.8 12.8 55.3c4.7 10.1 8.6 14.2 10.6 15.8c2-1.6 5.9-5.7 10.6-15.8c6.3-13.5 11.2-32.7 12.8-55.3zm-46.9-32h46.9c-1.6-22.6-6.5-41.8-12.8-55.3c-4.7-10.1-8.6-14.2-10.6-15.8c-2 1.6-5.9 5.7-10.6 15.8c-6.3 13.5-11.2 32.7-12.8 55.3z'
      
    ]
  };

  
    var faAtlas = faBookAtlas;
  

  
  

  var faTruckPlow = {
    prefix: 'fasl',
    iconName: 'truck-plow',
    icon: [
      640,
      512,
      [],
      'f7de',
      
      'M128 32h16H288h9l4.7 7.7 88 144 5.1 8.3H448h32v32V352h32V208v-5.8l3.7-4.4 80-96L606 89.5 630.5 110l-10.2 12.3L544 213.8V352v10.2l76.3 91.5L630.5 466 606 486.5l-10.2-12.3L520.5 384H480 464c0 53-43 96-96 96s-96-43-96-96H224c0 53-43 96-96 96s-96-43-96-96H0V352 224 192H32h96V48 32zm32 160H357.2L279 64H160V192zm58.5 160h58.9c13.2-37.3 48.7-64 90.5-64c33.4 0 62.8 17 80 42.9V224H32V352h5.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64zM192 384A64 64 0 1 0 64 384a64 64 0 1 0 128 0zm176 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z'
      
    ]
  };

  

  
  

  var faShieldHalved = {
    prefix: 'fasl',
    iconName: 'shield-halved',
    icon: [
      512,
      512,
      ["shield-alt"],
      'f3ed',
      
      'M240 40.6V469.7C160.2 430.1 111.6 366.4 83.2 301.2C53 231.7 45.8 160.5 48.5 114.9L240 40.6zm32 429.1V40.6l191.5 74.3c2.7 45.6-4.5 116.8-34.7 186.3c-28.4 65.2-77 129-156.8 168.5zM495.5 113l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9z'
      
    ]
  };

  
    var faShieldAlt = faShieldHalved;
  

  
  

  var faFaceConfounded = {
    prefix: 'fasl',
    iconName: 'face-confounded',
    icon: [
      512,
      512,
      [],
      'e36c',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm216.9 98.7L256 380.8l39.1-26.1 8.9-5.9 8.9 5.9 40.3 26.8 23.7-11.8 14.3-7.2 14.3 28.6-14.3 7.2-32 16-8.3 4.2-7.7-5.2L304 387.2l-39.1 26.1-8.9 5.9-8.9-5.9L208 387.2l-39.1 26.1-7.7 5.2-8.3-4.2-32-16-14.3-7.2 14.3-28.6 14.3 7.2 23.7 11.8 40.3-26.8 8.9-5.9 8.9 5.9zM121.8 230l15.9-27.8 13.9 7.9 56 32L231.9 256l-24.3 13.9-56 32-13.9 7.9L121.8 282l13.9-7.9L167.4 256l-31.7-18.1L121.8 230zm254.5 7.9L344.6 256l31.7 18.1 13.9 7.9-15.9 27.8-13.9-7.9-56-32L280.1 256l24.3-13.9 56-32 13.9-7.9L390.2 230l-13.9 7.9z'
      
    ]
  };

  

  
  

  var faPalletBox = {
    prefix: 'fasl',
    iconName: 'pallet-box',
    icon: [
      640,
      512,
      [],
      'e208',
      
      'M480 32V256H160V32h80v90.7V160l32-19.2L320 112l48 28.8L400 160V122.7 32h80zM272 32h96v71.5L336.5 84.6 320 74.7l-16.5 9.9L272 103.5V32zM480 0H400 368 272 240 160 128V32 256v32h32H480h32V256 32 0H480zM0 352v32H16 64v96H16 0v32H16 64 80 96 304h16 16H544h16 16 48 16V480H624 576V384h48 16V352H624 576 560 544 336 320 304 96 80 64 16 0zM96 480V384H304v96H96zm240 0V384H544v96H336z'
      
    ]
  };

  

  
  

  var faGreaterThanEqual = {
    prefix: 'fasl',
    iconName: 'greater-than-equal',
    icon: [
      448,
      512,
      [],
      'f532',
      
      'M405.8 177.1L32 32V66.3L355.8 192 32 317.7V352L405.8 206.9l10.2-4V181.1l-10.2-4zM432 448H16 0v32H16 432h16V448H432z'
      
    ]
  };

  

  
  

  var faSquareArrowUp = {
    prefix: 'fasl',
    iconName: 'square-arrow-up',
    icon: [
      448,
      512,
      ["arrow-square-up"],
      'f33c',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM235.3 132.7l96 96L342.6 240 320 262.6l-11.3-11.3L240 182.6V368v16H208V368 182.6l-68.7 68.7L128 262.6 105.4 240l11.3-11.3 96-96L224 121.4l11.3 11.3z'
      
    ]
  };

  
    var faArrowSquareUp = faSquareArrowUp;
  

  
  

  var faBurgerSoda = {
    prefix: 'fasl',
    iconName: 'burger-soda',
    icon: [
      640,
      512,
      [],
      'f858',
      
      'M224 0H211.5l-3 12.1L179.5 128H16 0v32H16 288h80 16V128H368 212.5l24-96H272h16V0H272 224zM37.3 192L64 512H256V480H93.4l-24-288H37.3zm288.2 93.6c5.6-6.8 14.3-15.9 26.2-25.1c4.9-3.8 10.3-7.5 16.3-11.1c.8 8.1 7.6 14.5 15.9 14.5c8.8 0 16-7.2 16-16c0-4.6-1.9-8.7-5-11.6c15.7-6.1 33.9-10.5 54.9-11.9c-1.2 2.2-1.9 4.8-1.9 7.5c0 8.8 7.2 16 16 16s16-7.2 16-16c0-2.7-.7-5.3-1.9-7.5c21 1.4 39.2 5.9 54.9 11.9c-3.1 2.9-5 7-5 11.6c0 8.8 7.2 16 16 16c8.3 0 15.1-6.3 15.9-14.5c6 3.6 11.4 7.4 16.3 11.1c11.9 9.2 20.6 18.3 26.2 25.1c2.4 2.9 4.2 5.3 5.5 7.1v11.1H320V292.7c1.3-1.8 3.1-4.2 5.5-7.1zm312.2-6L624 287.8c13.7-8.2 13.7-8.2 13.7-8.2l0 0 0 0-.1-.1-.2-.3c-.1-.2-.3-.5-.6-.9c-.5-.7-1.2-1.8-2-3c-1.8-2.5-4.3-6-7.8-10.1c-6.9-8.2-17.2-19.1-31.3-29.9c-28.3-21.8-71.6-43.3-131.8-43.3s-103.5 21.6-131.8 43.3c-14.1 10.8-24.4 21.7-31.3 29.9c-3.4 4.1-6 7.6-7.8 10.1c-.9 1.3-1.6 2.3-2 3c-.2 .4-.4 .7-.6 .9l-.2 .3-.1 .1 0 0 0 0s0 0 13.7 8.2l-13.7-8.2-2.3 3.8v4.4 32 16h16H624h16v-16-32-4.4l-2.3-3.8zM288 359.8v32h16H624h16v-32H624 304 288zm0 56v16 64 16h16H624h16v-16-64-16H624 304 288zm32 32H608v32H320v-32z'
      
    ]
  };

  

  
  

  var faCabinetFiling = {
    prefix: 'fasl',
    iconName: 'cabinet-filing',
    icon: [
      448,
      512,
      [128452],
      'f64b',
      
      'M416 240V32H32V240H416zM0 480V272 256 240 32 0H32 416h32V32 240v16 16V480v32H416 32 0V480zM32 272V480H416V272H32zM144 96H304h16v16 32 16H288V144 128H160v16 16H128V144 112 96h16zm0 256H304h16v16 32 16H288V400 384H160v16 16H128V400 368 352h16z'
      
    ]
  };

  

  
  

  var faListDropdown = {
    prefix: 'fasl',
    iconName: 'list-dropdown',
    icon: [
      512,
      512,
      [],
      'e1cf',
      
      'M32 64H480V176H32V64zM512 208V176 64 32H480 32 0V64 448v32H32 480h32V448 208zM32 208H480V448H32V208zm96 48H112v32h16H384h16V256H384 128zm0 96H112v32h16H384h16V352H384 128zM400 144l48-48H352l48 48z'
      
    ]
  };

  

  
  

  var faWatchCalculator = {
    prefix: 'fasl',
    iconName: 'watch-calculator',
    icon: [
      384,
      512,
      [],
      'f8f0',
      
      'M80 0H64V16 64H32 0V96 416v32H32 64l0 48v16H80l224 0h16V496 448h32 32V416 96 64H352 320V16 0H304 80zM96 480l0-32H288v32L96 480zM288 64H96V32H288V64zM32 96H352V416H32V96zm64 64H288v32H96V160zM64 128v32 32 32H96 288h32V192 160 128H288 96 64zM80 256v48h48V256H80zm136 0H168v48h48V256zm40 0v48h48V256H256zM128 336H80v48h48V336zm40 0v48h48V336H168zm136 0H256v48h48V336z'
      
    ]
  };

  

  
  

  var faWatchApple = {
    prefix: 'fasl',
    iconName: 'watch-apple',
    icon: [
      384,
      512,
      [],
      'e2cb',
      
      'M80 0H64V16 64H32 0V96 416v32H32 64l0 48v16H80l224 0h16V496 448h32 32V416 96 64H352 320V16 0H304 80zM96 480l0-32H288v32L96 480zM288 64H96V32H288V64zM32 96H352V416H32V96zM192 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64 48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM152 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM256 184a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM152 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-8 48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm120 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faCruzeiroSign = {
    prefix: 'fasl',
    iconName: 'cruzeiro-sign',
    icon: [
      448,
      512,
      [],
      'e152',
      
      'M64 256C64 150.1 150.6 64 257.7 64c49.6 0 94.9 18.5 129.2 48.9L408.1 89c-39.9-35.4-92.7-57-150.4-57C133.2 32 32 132.2 32 256s101.2 224 225.7 224c57.7 0 110.5-21.6 150.4-57l-21.2-23.9C352.6 429.5 307.3 448 257.7 448c-11.5 0-22.7-1-33.7-2.9V320c0-26.5 21.5-48 48-48c15.1 0 29.3 7.1 38.4 19.2l4.8 6.4 25.6-19.2L336 272c-15.1-20.1-38.8-32-64-32c-18 0-34.6 6-48 16V240H192v80V436.7C117.3 410 64 339.1 64 256z'
      
    ]
  };

  

  
  

  var faShelvesEmpty = {
    prefix: 'fasl',
    iconName: 'shelves-empty',
    icon: [
      640,
      512,
      [],
      'e246',
      
      'M32 16V0H0V16 160v16 16V416v16 16 48 16H32V496 448H608v48 16h32V496 448 432 416 192 176 160 16 0H608V16 160H32V16zm0 176H608V416H32V192z'
      
    ]
  };

  

  
  

  var faGarageOpen = {
    prefix: 'fasl',
    iconName: 'garage-open',
    icon: [
      640,
      512,
      [],
      'e00b',
      
      'M325.9 9.1L320 6.8l-5.9 2.3-304 120L0 133.1V144 496v16H32V496 154.9L320 41.2 608 154.9V496v16h32V496 144 133.1l-10.1-4-304-120zM112 192H96v16V496v16h32V496 288H512V496v16h32V496 208 192H528 112zm400 64H128V224H512v32zM212.5 320l-7.8 24H192 176v16V496v16h32V496 480H432v16 16h32V496 360 344H448 435.3l-7.8-24H393.8l7.8 24H238.4l7.8-24H212.5zM208 448V376H432v72H208zm40-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm160-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassArrowsRotate = {
    prefix: 'fasl',
    iconName: 'magnifying-glass-arrows-rotate',
    icon: [
      512,
      512,
      [],
      'e65e',
      
      'M294.6 97.4L272 120l22.6 22.6L296 144h88 32V112 24l-1.4-1.4L392 0 369.4 22.6 342.6 49.4C306.3 18.6 259.3 0 208 0C93.1 0 0 93.1 0 208H32c0-97.2 78.8-176 176-176c42.5 0 81.5 15.1 111.9 40.1L294.6 97.4zM384 53.3V112H325.3L384 53.3zM121.4 318.6L144 296l-22.6-22.6L120 272H32 0v32 88l1.4 1.4L24 416l22.6-22.6 26.8-26.8C109.7 397.4 156.7 416 208 416c51.7 0 99-18.8 135.3-50L487.9 510.5l22.6-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3H384c0 97.2-78.8 176-176 176c-42.5 0-81.5-15.1-111.9-40.1l25.2-25.2zM32 362.7L32 304H90.7L32 362.7z'
      
    ]
  };

  

  
  

  var faFireExtinguisher = {
    prefix: 'fasl',
    iconName: 'fire-extinguisher',
    icon: [
      512,
      512,
      [129519],
      'f134',
      
      'M160 0V64C104.5 64 55.6 92.3 27 135.1c-7.3 11-13.4 22.9-17.8 35.6l30.2 10.7c3.6-10.1 8.4-19.7 14.3-28.4C76.5 118.6 115.6 96 160 96v33.1c-54.3 7.8-96 54.4-96 110.9V480v32H96 256h32V480 240c0-56.4-41.7-103.1-96-110.9V96h96v32l192 27.4 32 4.6V127.7 32.3 0L480 4.6 288 32V64H192V0H160zM320 100.2V59.8L480 36.9v86.2L320 100.2zM256 384H96V240c0-44.2 35.8-80 80-80s80 35.8 80 80V384zM96 416H256v64H96V416z'
      
    ]
  };

  

  
  

  var faArrowsToDottedLine = {
    prefix: 'fasl',
    iconName: 'arrows-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e0a6',
      
      'M224 198.6l11.3-11.3 80-80L326.6 96 304 73.4 292.7 84.7 240 137.4 240 16V0H208V16l0 121.4L155.3 84.7 144 73.4 121.4 96l11.3 11.3 80 80L224 198.6zM8 232v48H56V232H8zm96 0v48h48V232H104zm96 0v48h48V232H200zm96 0v48h48V232H296zm144 0H392v48h48V232zM235.3 324.7L224 313.4l-11.3 11.3-80 80L121.4 416 144 438.6l11.3-11.3L208 374.6V496v16h32V496 374.6l52.7 52.7L304 438.6 326.6 416l-11.3-11.3-80-80z'
      
    ]
  };

  

  
  

  var faCircleBookOpen = {
    prefix: 'fasl',
    iconName: 'circle-book-open',
    icon: [
      512,
      512,
      ["book-circle"],
      'e0ff',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM152.5 183.2c10.8-3.7 25-7.2 39.5-7.2s28.7 3.5 39.5 7.2c3.2 1.1 6.1 2.2 8.5 3.2V323.8c-12.6-6-29.6-11.8-48-11.8c-18.1 0-35 2.1-47.3 4.2l-.7 .1v-130c2.4-1 5.3-2.1 8.5-3.2zM132.1 351.5l0 0 0 0 0 0 .2 0 .9-.2c.8-.2 2-.5 3.6-.8c3.1-.7 7.7-1.6 13.3-2.6c11.2-1.9 26.3-3.8 42-3.8c13.3 0 26.7 4.8 37.4 10.3c5.2 2.7 9.5 5.3 12.5 7.3c1.5 1 2.6 1.8 3.3 2.3c.4 .3 .6 .5 .8 .6l.1 .1 0 0 0 0 9.9 7.9 9.9-7.9 0 0 0 0 0 0 .1-.1c.2-.1 .4-.3 .8-.6c.7-.5 1.8-1.3 3.3-2.3c2.9-2 7.2-4.6 12.5-7.3c10.7-5.4 24.1-10.3 37.4-10.3c15.7 0 30.8 1.9 42 3.8c5.6 1 10.1 1.9 13.3 2.6c1.6 .4 2.8 .6 3.6 .8l.9 .2 .2 0 0 0 0 0 0 0 0 0 0 0 20.1 5.3V336 176v-9.6l-8.5-4.5L384 176c7.5-14.1 7.5-14.1 7.5-14.1l0 0 0 0 0 0-.1-.1-.4-.2c-.3-.2-.7-.4-1.2-.6c-1.1-.5-2.5-1.2-4.4-2.1c-3.7-1.7-9-3.9-15.5-6c-12.7-4.3-30.6-8.8-49.8-8.8s-37.1 4.5-49.8 8.8c-5.7 1.9-10.6 3.9-14.2 5.5c-3.6-1.6-8.5-3.5-14.2-5.5c-12.7-4.3-30.6-8.8-49.8-8.8s-37.1 4.5-49.8 8.8c-6.4 2.2-11.7 4.4-15.5 6c-1.9 .8-3.4 1.5-4.4 2.1c-.5 .3-.9 .5-1.2 .6l-.4 .2-.1 .1 0 0 0 0 0 0s0 0 7.5 14.1l-7.5-14.1-8.5 4.5V176 336v20.8l20.1-5.3 0 0 0 0zM320 312c-18.4 0-35.4 5.9-48 11.8V186.3c2.4-1 5.3-2.1 8.5-3.2c10.8-3.7 25-7.2 39.5-7.2s28.7 3.5 39.5 7.2c3.2 1.1 6.1 2.2 8.5 3.2v130l-.7-.1C355 314.1 338.1 312 320 312z'
      
    ]
  };

  
    var faBookCircle = faCircleBookOpen;
  

  
  

  var faArrowsRotate = {
    prefix: 'fasl',
    iconName: 'arrows-rotate',
    icon: [
      512,
      512,
      [128472,"refresh","sync"],
      'f021',
      
      'M66.7 224C81.9 133.2 160.9 64 256 64c71.1 0 133.1 38.6 166.3 96H368 352v32h16 69.1H464h6.7H480V176 80 64H448V80v60.6C408.8 75.5 337.5 32 256 32C143.2 32 49.8 115.4 34.3 224H66.7zM256 448c-71.1 0-133.1-38.6-166.3-96h54.5 16V320h-16H74.9 48.2 41.3 32.2v16 96 16h32V432 371.8C103.4 436.6 174.7 480 256 480c112.8 0 206.2-83.4 221.7-192H445.4C430.1 378.8 351.1 448 256 448z'
      
    ]
  };

  
    var faRefresh = faArrowsRotate;
  
    var faSync = faArrowsRotate;
  

  
  

  var faBorderTop = {
    prefix: 'fasl',
    iconName: 'border-top',
    icon: [
      448,
      512,
      [],
      'f855',
      
      'M0 32H448V64H0V32zM8 136H56v48H8V136zm432 0v48H392V136h48zm-240 0h48v48H200V136zM56 328v48H8V328H56zm336 0h48v48H392V328zm-144 0v48H200V328h48zM8 232H56v48H8V232zm432 0v48H392V232h48zm-240 0h48v48H200V232zM56 424v48H8V424H56zm336 0h48v48H392V424zm-144 0v48H200V424h48zM104 232h48v48H104V232zm48 192v48H104V424h48zm144 0h48v48H296V424zm48-192v48H296V232h48z'
      
    ]
  };

  

  
  

  var faMugTea = {
    prefix: 'fasl',
    iconName: 'mug-tea',
    icon: [
      576,
      512,
      [],
      'f875',
      
      'M144 96H64V416H384V272 96H352 176v40.5l42.2 35.2 5.8 4.8V184v88 16H208 112 96V272 184v-7.5l5.8-4.8L144 136.5V96zm16-32H352h32 32 48c61.9 0 112 50.1 112 112s-50.1 112-112 112H416V416v32H384 64 32V416 96 64H64h96zM464 96H416V256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80zM128 256h64V191.5l-32-26.7-32 26.7V256z'
      
    ]
  };

  

  
  

  var faBurgerFries = {
    prefix: 'fasl',
    iconName: 'burger-fries',
    icon: [
      640,
      512,
      [],
      'e0cd',
      
      'M144 2.9l23.2 11.6 64 32 8.8 4.4v9.9V256v16H208V256 70.7l-32-16V256v16H144V256 28.8 2.9zM301.8 205.7L272 248.2l0-39.6L299.1 84.5 272 89.9V57.3l44.9-9 24-4.8-5.2 23.9L307 198.2l-5.2 7.5zM332.5 192l19.8-99.1 31.4 6.3-15.3 76.3c-13.1 4.8-24.8 10.4-35.3 16.6h-.6zM112 304H256v32H112 93.9l-9.3-15.5L45.9 256h-6L89.7 480H256v32H64L7.1 256 0 224H32.8 64l48 80zM18.9 192L.3 99.1l31.4-6.3L51.5 192H18.9zm63.3 13.6l-2-2.8L56.2 58.6 54.3 47l10.6-5.3L112 18.1V53.9L89.7 65l33.1 198.7-40.6-58zm243.3 79.9c-2.4 2.9-4.2 5.3-5.5 7.1v11.1H608V292.7c-1.3-1.8-3.1-4.2-5.5-7.1c-5.6-6.8-14.3-15.9-26.2-25.1c-4.9-3.8-10.3-7.5-16.3-11.1c-.8 8.1-7.6 14.5-15.9 14.5c-8.8 0-16-7.2-16-16c0-4.6 1.9-8.7 5-11.6c-15.7-6.1-33.9-10.5-54.9-11.9c1.2 2.2 1.9 4.8 1.9 7.5c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.7 .7-5.3 1.9-7.5c-21 1.4-39.2 5.9-54.9 11.9c3.1 2.9 5 7 5 11.6c0 8.8-7.2 16-16 16c-8.3 0-15.1-6.3-15.9-14.5c-6 3.6-11.4 7.4-16.3 11.1c-11.9 9.2-20.6 18.3-26.2 25.1zm312.2-6l2.3 3.8v4.4 32 16H624 304 288v-16-32-4.4l2.3-3.8 13.7 8.2c-13.7-8.2-13.7-8.2-13.7-8.2l0 0 0 0 .1-.1 .2-.3c.1-.2 .3-.5 .6-.9c.5-.7 1.2-1.8 2-3c1.8-2.5 4.3-6 7.8-10.1c6.9-8.2 17.2-19.1 31.3-29.9c28.3-21.8 71.6-43.3 131.8-43.3s103.5 21.6 131.8 43.3c14.1 10.8 24.4 21.7 31.3 29.9c3.4 4.1 6 7.6 7.8 10.1c.9 1.3 1.6 2.3 2 3c.2 .4 .4 .7 .6 .9l.2 .3 .1 .1 0 0 0 0s0 0-13.7 8.2l13.7-8.2zM288 359.8h16H624h16v32H624 304 288v-32zm0 56h16H624h16v16 64 16H624 304 288v-16-64-16zm32 32v32H608v-32H320z'
      
    ]
  };

  

  
  

  var faGuaraniSign = {
    prefix: 'fasl',
    iconName: 'guarani-sign',
    icon: [
      384,
      512,
      [],
      'e19a',
      
      'M192 0H160V66.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3V512h32l0-64c106 0 192-86 192-192V240H368 192V96c43.6 0 83.1 17.4 112 45.7l22.4-22.9C291.8 85 244.3 64 192 64l0-64zM160 99.2V412.8C87 398 32 333.4 32 256s55-142 128-156.8zM192 416V272H351.2c-8 80.9-76.2 144-159.2 144z'
      
    ]
  };

  

  
  

  var faGingerbreadMan = {
    prefix: 'fasl',
    iconName: 'gingerbread-man',
    icon: [
      448,
      512,
      [],
      'f79d',
      
      'M224 0C162.1 0 112 50.1 112 112c0 17.2 3.9 33.4 10.8 48H80 16 0v16V304v16H16 80h21.2L35.7 398.6 32 403v5.8V496v16H48h94 7.5l4.8-5.8L216.1 432h15.7l61.9 74.2 4.8 5.8H306h94 16V496 408.8 403l-3.7-4.5L346.8 320H368h64 16V304 176 160H432 368 325.2c6.9-14.6 10.8-30.8 10.8-48C336 50.1 285.9 0 224 0zM144 112c0-44.2 35.8-80 80-80s80 35.8 80 80c0 20.5-7.7 39.2-20.4 53.3L259.8 192h35.8H368h48v96H368 320 304v16 8.8 5.8l3.7 4.4L384 414.6V480H313.5l-61.9-74.2-4.8-5.8h-7.5H208.6h-7.5l-4.8 5.8L134.5 480H64V414.6l76.3-91.6 3.7-4.4v-5.8V304 288H128 80 32V192H80h72.4 35.8l-23.9-26.7C151.7 151.2 144 132.5 144 112zm80 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM208 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM240 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCommentQuestion = {
    prefix: 'fasl',
    iconName: 'comment-question',
    icon: [
      512,
      512,
      [],
      'e14b',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM168 168v8h32v-8c0-13.3 10.7-24 24-24h56c17.6 0 32 14.5 32 32.3c0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4-8.7 4.5v9.8V256v16h32V256v-3.7l37.1-18.9c21.5-11 34.9-33.2 34.9-57.2c0-35.2-28.5-64.3-64-64.3H224c-30.9 0-56 25.1-56 56zm64 136v48h48V304H232z'
      
    ]
  };

  

  
  

  var faAlicorn = {
    prefix: 'fasl',
    iconName: 'alicorn',
    icon: [
      640,
      512,
      [],
      'f6b0',
      
      'M336 144c0-61.9 50.1-112 112-112h24 8 13.9l39.2 39.2 9.9 104.4-42.4 26.5-23.4-35.1-4.7-7.1H464 432 416v16 64c0 24-10.4 45.1-26.7 59.6l-5.3 4.8v7.2V480H336V334.7 321.2l-13.3-2.3c-1.4-.2-2.8-.5-4.3-.8L203.5 292.2 184 287.8v20V312v24 4.9l-1.9 4.5-18.5 43.1-2.2 5.2 1.5 5.4L185.4 480H135.5l-22.7-81.6-2.3-8.1 3.3-7.8 20.8-48.5 1.3-3v-3.3V320v-3.2l-1.2-3L99.9 230.2C97.3 224 96 217.4 96 210.7c0-21.8 13.8-40.5 33.2-47.6c-4.4-9.4-8.4-19.3-11.8-29.8c-20.4 7.7-37 23.3-46 43.1C31.3 180.8 0 214.7 0 256v48 16H32V304 256c0-20.9 13.4-38.7 32-45.3c0 10.9 2.2 21.7 6.4 31.7L104 323.2v1.3L84.5 369.9 79 382.9 76.8 388l1.5 5.4L82 407 108 500.3l3.3 11.7h12.2 83 21.1l-5.6-20.3L195.2 396l16.2-37.9 3.2-7.5 1.3-3v-3.3V336v-8.2l88 19.8V496v16h16 80 16V496 318.4c19.6-20 32-47.5 32-78.4V192h7.4l27.3 40.9 8.6 12.9 13.2-8.2 64-40 8.4-5.2-.9-9.8-7.5-78.6L640 80V64H564.6l-.1-1.5-.5-5.7-4.1-4.1L539.2 32H544h16V0H544 507.2h-6.6H480h-8H448C376.1 0 316.5 52.7 305.7 121.6L160.2 34.3 136 19.7V48c0 77.2 34.4 132.9 68.3 169c16.9 18 33.9 31.2 46.6 40c6.4 4.4 11.7 7.7 15.5 9.9c1.9 1.1 3.4 2 4.5 2.5c.5 .3 1 .5 1.3 .7l.4 .2 .1 .1 0 0 0 0s0 0 7.2-14.3l-7.2 14.3 14.3 7.2 14.3-28.6-14.3-7.1 0 0 0 0 0 0 0 0-.2-.1-.9-.5c-.8-.4-2-1.1-3.6-2c-3.2-1.8-7.8-4.7-13.5-8.6c-11.3-7.8-26.4-19.5-41.4-35.5c-25.5-27-50.6-65.8-57.7-117.6l133.8 80.3 3.8 2.3H312h8 16V144zM496 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faAlarmPlus = {
    prefix: 'fasl',
    iconName: 'alarm-plus',
    icon: [
      512,
      512,
      [],
      'f844',
      
      'M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5l27-17.2c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1l21.8-23.5C138.4 9.3 116.4 0 92.2 0zM357.1 24.6l21.8 23.5C389.6 38.1 404 32 419.8 32C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3l27 17.2c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM67.3 499.3l42-42C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l42 42L456 510.6 478.6 488l-11.3-11.3-42-42C459.4 395.4 480 344.1 480 288C480 164.3 379.7 64 256 64S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-42 42L33.4 488 56 510.6l11.3-11.3zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm16 80H240v16 80H160 144v32h16 80v80 16h32V384 304h80 16V272H352 272V192 176z'
      
    ]
  };

  

  
  

  var faMattressPillow = {
    prefix: 'fasl',
    iconName: 'mattress-pillow',
    icon: [
      640,
      512,
      [],
      'e525',
      
      'M256 96V416H32V96H256zm32 0H608V416H288V96zM32 64H0V96 416v32H32 608h32V416 96 64H608 32zm160 96V352H96V160h96zM96 128H64v32V352v32H96h96 32V352 160 128H192 96z'
      
    ]
  };

  

  
  

  var faMemoPad = {
    prefix: 'fasl',
    iconName: 'memo-pad',
    icon: [
      448,
      512,
      [],
      'e1da',
      
      'M32 128H416V480H32V128zm0-32V32H416V96H32zm416 16V96 32 0H416 32 0V32 96v16 16V480v32H32 416h32V480 128 112zM112 192H96v32h16H336h16V192H336 112zm0 96H96v32h16H336h16V288H336 112zm0 96H96v32h16H240h16V384H240 112z'
      
    ]
  };

  

  
  

  var faRabbitRunning = {
    prefix: 'fasl',
    iconName: 'rabbit-running',
    icon: [
      576,
      512,
      ["rabbit-fast"],
      'f709',
      
      'M474.3 147.2l16.5 12.3c-2.2-32.9-16.2-64.4-40.5-88.2l-4.5-4.4-10.5 2c-8.2-8.5-17.2-16.3-26.9-23.2l1.2-4.4 9.7-1.9 28.5-5.5 8.2-1.6 6 5.9 10.5 10.3c36.3 35.6 54.1 85.2 49.8 134.7l47.2 35.2 6.4 4.8v8V320v16H560 399.4L361 368h95 16v16 64 16H456 280h-6.6l-4.7-4.7L237 427.7l-72.4 48.3-2.1 1.4-4 2.7h-4.8H118.2h-8.6l-4.7-7.1L80.3 436l-8.9-13.3 13.3-8.9 26.6-17.8 56.4-37.6-55-55c-9.8-9.8-17.6-21.2-23.1-33.7C84 271.2 78.1 272 72 272c-39.8 0-72-32.2-72-72s32.2-72 72-72c16.3 0 31.3 5.4 43.3 14.5c20.1-18.9 47.1-30.5 76.9-30.5h9c17.3 0 34.4 3.7 50.2 10.9l66 30c-2.3-5.4-4.2-11-5.8-16.8L296 79.6l-3.3-11.9 10.7-6.2 27.6-16 6.2-3.6 6.8 2.2c48.8 16.1 87 54 103.8 102c5.1-1 10.3-1.7 15.6-2.2l6-.5 4.8 3.6zM81 239c-.7-4.9-1-9.8-1-14.8c0-20.7 5.6-40 15.3-56.7C88.8 162.8 80.7 160 72 160c-22.1 0-40 17.9-40 40s17.9 40 40 40c3.1 0 6.1-.4 9-1zm48.1 183.7l-13.3 8.9 11 16.4h22.1L214 404.6l-23.1-23.1-61.8 41.2zM330.1 83l12.3 44.5c5.5 20 16.5 37.9 31.4 51.9l-17.6 26.2L238.1 152c-11.6-5.3-24.2-8-36.9-8h-9c-44.3 0-80.2 35.9-80.2 80.2c0 21.3 8.4 41.7 23.5 56.7L286.6 432H440V400l-88 0-32 0V384 368.6c0-50-33.1-94-81.2-107.7l-19.2-5.5L204.2 251l8.8-30.8 15.4 4.4 19.2 5.5c51.4 14.7 89.5 56.2 100.9 106.7l34.9-29.1 4.5-3.7h5.8H544V239.1l-83.8-62.6c-6.3 .9-12.3 2.3-18.1 4.2l-16.4 5.6-4.2-16.8-.4-1.4c-10.5-41.8-40.6-75.7-80.5-91.2L330.1 83zM480 224a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  
    var faRabbitFast = faRabbitRunning;
  

  
  

  var faHandshakeSimpleSlash = {
    prefix: 'fasl',
    iconName: 'handshake-simple-slash',
    icon: [
      640,
      512,
      ["handshake-alt-slash"],
      'e05f',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM592 350.8h16v-32H592 502.9l40.5 32H592zM397.4 398.6l-25.3-20-46.7 46.6-26.6-26.6-11.3-11.3-11.3 11.3-29 29-32.6-32.6-11.3-11.3-7-7-52-52.1-4.7-4.7h-6.6H48 32v32H48h78.3l47.4 47.4 7 7L192 417.7l43.9 43.9 11.3 11.3 11.3-11.3 29-29 26.6 26.6 11.3 11.3 11.3-11.3 60.6-60.6zM324.8 68.3l-63.5 59.8 25.4 20L342.1 96h73.4l71.7 60.3 4.5 3.7h5.8H592h16V128H592 503.3L431.6 67.7 427.2 64h-5.8H335.8h-6.3l-4.6 4.4zm34 109.9l-15.6 14.4L366.3 211l25.4-20.6-21.2-22.9-11.8 10.9zM196.3 76.8L221.9 97l1.2-1h17.5l32-32H217.3h-5.8L207 67.7l-10.7 9zM95.1 160L54.6 128H48 32v32H48 95.1z'
      
    ]
  };

  
    var faHandshakeAltSlash = faHandshakeSimpleSlash;
  

  
  

  var faCatSpace = {
    prefix: 'fasl',
    iconName: 'cat-space',
    icon: [
      640,
      512,
      [],
      'e001',
      
      'M448 288c-70.7 0-128-57.3-128-128c0-32.5 12.1-62.1 32-84.7V160c0 53 43 96 96 96s96-43 96-96V75.3c19.9 22.6 32 52.2 32 84.7c0 70.7-57.3 128-128 128zM608 160c0-52.3-25.1-98.8-64-128V30.7l-.8 .7C516.6 11.7 483.6 0 448 0s-68.6 11.7-95.2 31.4l-.8-.7V32c-38.9 29.2-64 75.7-64 128c0 4.6 .2 9.1 .6 13.6C218.8 192.1 161.5 238.4 128 299.2V176c0-44.2-35.8-80-80-80H32v32H48c26.5 0 48 21.5 48 48V424v72 16h16 64 0H304h64 16V496 474.7c0-23.4-13.7-43.5-33.4-53L416 392.6V496v16h16 64 16V496 306.7c56.5-24.7 96-81.1 96-146.7zM480 316.8V480H448V368 343.4l-22.5 10L304 407.4V392c0-39.8-32.2-72-72-72h-8H208v32h16 8c22.1 0 40 17.9 40 40v24 16 16h16 37.3c14.7 0 26.7 11.9 26.7 26.7V480H304h0H176 128V424c0-103.1 69.2-192 166.5-218.8C314 271.5 375.3 320 448 320c11 0 21.7-1.1 32-3.2zM413.6 80L378.9 52.2C398.8 39.4 422.6 32 448 32s49.2 7.4 69.1 20.2L482.4 80H413.6zM240 16V0H208V16 48H176 160V80h16 32v32 16h32V112 80h32 16V48H272 240V16zM384 97.3l14 11.2 4.4 3.5H408h80 5.6l4.4-3.5 14-11.2V160c0 35.3-28.7 64-64 64s-64-28.7-64-64V97.3zM416 168a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faDrawCircle = {
    prefix: 'fasl',
    iconName: 'draw-circle',
    icon: [
      512,
      512,
      [],
      'f5ed',
      
      'M256 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm58.5-6c-10 22.4-32.4 38-58.5 38s-48.6-15.6-58.5-38C147.4 107.6 107.6 147.4 90 197.5c22.4 10 38 32.4 38 58.5s-15.6 48.6-38 58.5c17.7 50.1 57.4 89.9 107.5 107.5c10-22.4 32.4-38 58.5-38s48.6 15.6 58.5 38c50.1-17.7 89.9-57.4 107.5-107.5c-22.4-10-38-32.4-38-58.5s15.6-48.6 38-58.5C404.4 147.4 364.6 107.6 314.5 90zM454.1 192.3c32.5 3.1 57.9 30.4 57.9 63.7s-25.4 60.7-57.9 63.7c-20.5 63.6-70.7 113.9-134.3 134.3C316.7 486.6 289.3 512 256 512s-60.7-25.4-63.7-57.9C128.7 433.6 78.4 383.3 57.9 319.7C25.4 316.7 0 289.3 0 256s25.4-60.7 57.9-63.7C78.4 128.7 128.7 78.4 192.3 57.9C195.3 25.4 222.7 0 256 0s60.7 25.4 63.7 57.9c63.6 20.5 113.9 70.7 134.3 134.3zM256 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faEnvelopeOpen = {
    prefix: 'fasl',
    iconName: 'envelope-open',
    icon: [
      512,
      512,
      [62135],
      'f2b6',
      
      'M32 223.2l224 154 224-154V208L256 40 32 208v15.2zM480 262L256 416 32 262V480H480V262zM0 192L256 0 512 192v48V480v32H480 32 0V480 240 192z'
      
    ]
  };

  

  
  

  var faListTree = {
    prefix: 'fasl',
    iconName: 'list-tree',
    icon: [
      512,
      512,
      [],
      'e1d2',
      
      'M32 80v32H64V80H32zM0 48H32 64 96V80v32 32H64v96h64V208h32 32 32v32 32 32H192 160 128V272H64V400h64V368h32 32 32v32 32 32H192 160 128V432H48 32V416 256 144H0V112 80 48zM160 80h16H496h16v32H496 176 160V80zM288 240h16H496h16v32H496 304 288V240zm0 160h16H496h16v32H496 304 288V400zM192 240H160v32h32V240zM160 400v32h32V400H160z'
      
    ]
  };

  

  
  

  var faLollipop = {
    prefix: 'fasl',
    iconName: 'lollipop',
    icon: [
      512,
      512,
      [127853,"lollypop"],
      'e424',
      
      'M192 352c-27 0-52.4-6.7-74.7-18.5c8.7 1.6 17.6 2.5 26.7 2.5h16c75.1 0 136-60.9 136-136v-8c0-57.4-46.6-104-104-104S88 134.6 88 192c0 35.3 28.7 64 64 64s64-28.7 64-64v-8V168H184v16 8c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-39.8 32.2-72 72-72s72 32.2 72 72v8c0 57.4-46.6 104-104 104H144C82.1 304 32 253.9 32 192c0-88.4 71.6-160 160-160s160 71.6 160 160s-71.6 160-160 160zM0 192C0 298 86 384 192 384c47.3 0 90.5-17.1 124-45.4L484.7 507.3l22.6-22.6L338.6 316c28.3-33.5 45.4-76.7 45.4-124C384 86 298 0 192 0S0 86 0 192z'
      
    ]
  };

  
    var faLollypop = faLollipop;
  

  
  

  var faSignalStrong = {
    prefix: 'fasl',
    iconName: 'signal-strong',
    icon: [
      640,
      512,
      ["signal-4"],
      'f68f',
      
      'M464 112V96H432v16V496v16h32V496 112zM336 192H304v16V496v16h32V496 208 192zM208 304V288H176v16V496v16h32V496 304zM80 400V384H48v16 96 16H80V496 400z'
      
    ]
  };

  
    var faSignal4 = faSignalStrong;
  

  
  

  var faUserLargeSlash = {
    prefix: 'fasl',
    iconName: 'user-large-slash',
    icon: [
      640,
      512,
      ["user-alt-slash"],
      'f4fa',
      
      'M541 512l-40.5-32H112l53.3-128h173l-40.5-32H144L77.3 480 64 512H98.7 541zM464 144C464 64.5 399.5 0 320 0C265.6 0 218.2 30.2 193.7 74.8l25.6 20.2C237.5 57.7 275.7 32 320 32c61.9 0 112 50.1 112 112c0 34.9-15.9 66-40.9 86.6l25.6 20.2C445.7 224.4 464 186.3 464 144zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  
    var faUserAltSlash = faUserLargeSlash;
  

  
  

  var faChalkboard = {
    prefix: 'fasl',
    iconName: 'chalkboard',
    icon: [
      576,
      512,
      ["blackboard"],
      'f51b',
      
      'M48 32H32V48 416H64V64H512V416h32V48 32H528 48zM224 352v16 80H16 0v32H16 560h16V448H560 416V368 352H400 240 224zm32 32H384v56H256V384z'
      
    ]
  };

  
    var faBlackboard = faChalkboard;
  

  
  

  var faMeterDroplet = {
    prefix: 'fasl',
    iconName: 'meter-droplet',
    icon: [
      640,
      512,
      [],
      'e1ea',
      
      'M256 480c49.7 0 95.5-16.2 132.7-43.5c2.8 10.8 6.9 21.1 12 30.7C359.5 495.5 309.7 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C369.8 0 466.3 74.3 499.6 177l-23.6 36.3C456 110 365.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224zM176 144v64 16H144V208 144 128h32v16zm96 0v64 16H240V208 144 128h32v16zm96 0v64 16H336V208 144 128h32v16zm93.3 209.1C452.6 366.4 448 382 448 397.9V400c0 44.2 35.8 80 80 80s80-35.8 80-80v-2.1c0-15.9-4.6-31.5-13.3-44.8L528 250.6 461.3 353.1zm-26.8-17.5l74.4-114.3L528 192l19.1 29.3 74.4 114.3c12.1 18.5 18.5 40.2 18.5 62.3V400c0 61.9-50.1 112-112 112s-112-50.1-112-112v-2.1c0-22.1 6.4-43.7 18.5-62.3z'
      
    ]
  };

  

  
  

  var faChildren = {
    prefix: 'fasl',
    iconName: 'children',
    icon: [
      640,
      512,
      [],
      'e4e1',
      
      'M188.6 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm-24 336H47.7l5.4-20.2 41.5-154L25.1 313.9 0 294.1l100.9-128 4.8-6.1h6.6 1.2 11.1 64 11.1 1.2 6.6l4.8 6.1 100.9 128L288 313.9l-69.5-88.1 41.5 154 5.4 20.2H244.6h-24v96 16h-32V496 400h-64v96 16h-32V496 400h-24zm68.3-208L89.4 368H223.7L176.3 192H136.8zM476.6 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM402.1 160h9 131 9l4.7 7.6 78.5 128-27.3 16.7-50.4-82.1V496v16h-32V496 384h-96V496v16h-32V496 230.2l-50.4 82.1-27.3-16.7 78.5-128 4.7-7.6zm122.5 40v-8h-96v8V352h96V200z'
      
    ]
  };

  

  
  

  var faWreath = {
    prefix: 'fasl',
    iconName: 'wreath',
    icon: [
      448,
      512,
      [],
      'f7e2',
      
      'M203.3 39.6L224 57.2l20.7-17.6c5.6-4.8 12.8-7.6 20.7-7.6c13.9 0 25.8 8.9 30.2 21.3L305.7 82l29.1-8.6c2.9-.8 5.9-1.3 9.1-1.3c17.7 0 32 14.3 32 32c0 3.2-.5 6.3-1.3 9.1L366 142.3l28.6 10.1c12.5 4.4 21.3 16.3 21.3 30.2c0 7.9-2.8 15.1-7.6 20.7L390.8 224l17.6 20.7c4.8 5.6 7.6 12.8 7.6 20.7c0 13.9-8.9 25.8-21.3 30.2L366 305.7l8.6 29.1c.8 2.9 1.3 5.9 1.3 9.1c0 14.9-10.2 27.4-24 31v9 23.5c31.6-3.9 56-30.9 56-63.5c0-6.3-.9-12.5-2.6-18.2c24.8-8.8 42.6-32.5 42.6-60.3c0-15.8-5.7-30.2-15.2-41.4c9.5-11.2 15.2-25.6 15.2-41.4c0-27.9-17.8-51.6-42.6-60.3c1.7-5.8 2.6-11.9 2.6-18.2c0-35.3-28.7-64-64-64c-6.3 0-12.5 .9-18.2 2.6C317 17.8 293.3 0 265.4 0C249.6 0 235.2 5.7 224 15.2C212.8 5.7 198.4 0 182.6 0C154.7 0 131 17.8 122.2 42.6C116.5 40.9 110.3 40 104 40c-35.3 0-64 28.7-64 64c0 6.3 .9 12.5 2.6 18.2C17.8 131 0 154.7 0 182.6c0 15.8 5.7 30.2 15.2 41.4C5.7 235.2 0 249.6 0 265.4c0 27.9 17.8 51.6 42.6 60.3C40.9 331.5 40 337.7 40 344c0 32.6 24.4 59.6 56 63.5V384v-9c-13.8-3.6-24-16.1-24-31c0-3.2 .5-6.3 1.3-9.1L82 305.7 53.3 295.6C40.9 291.2 32 279.3 32 265.4c0-7.9 2.8-15.1 7.6-20.7L57.2 224 39.6 203.3c-4.8-5.6-7.6-12.8-7.6-20.7c0-13.9 8.9-25.8 21.3-30.2L82 142.3l-8.6-29.1c-.8-2.9-1.3-5.9-1.3-9.1c0-17.7 14.3-32 32-32c3.2 0 6.3 .5 9.1 1.3L142.3 82l10.1-28.6C156.8 40.9 168.7 32 182.6 32c7.9 0 15.1 2.8 20.7 7.6zm50.6 112.3l-7.9-8.5L224 120l-21.9 23.4-7.9 8.5-11.6-.4-32.1-1.1 1.1 32.1 .4 11.6-8.5 7.9L120 224l23.4 21.9 8.5 7.9-.4 11.6-1.1 32.1 32.1-1.1 11.6-.4 7.9 8.5L224 328l21.9-23.4 7.9-8.5 11.6 .4 32.1 1.1-1.1-32.1-.4-11.6 8.5-7.9L328 224l-23.4-21.9-8.5-7.9 .4-11.6 1.1-32.1-32.1 1.1-11.6 .4zm10.6 31.7l-.3 9.5-.5 14.5 10.6 9.9 6.9 6.5-6.9 6.5-10.6 9.9 .5 14.5 .3 9.5-9.5-.3-14.5-.5-9.9 10.6-6.5 6.9-6.5-6.9-9.9-10.6-14.5 .5-9.5 .3 .3-9.5 .5-14.5-10.6-9.9-6.9-6.5 6.9-6.5 10.6-9.9-.5-14.5-.3-9.5 9.5 .3 14.5 .5 9.9-10.6 6.5-6.9 6.5 6.9 9.9 10.6 14.5-.5 9.5-.3zM231.8 457L224 455l-7.8 1.9L160 471V425L216.2 439 224 441l7.8-1.9L288 425v46L231.8 457zM128 512l32-8 64-16 64 16 32 8V479 417 384l-32 8-64 16-64-16-32-8v33 62 33z'
      
    ]
  };

  

  
  

  var faCloudArrowDown = {
    prefix: 'fasl',
    iconName: 'cloud-arrow-down',
    icon: [
      640,
      512,
      [62337,"cloud-download","cloud-download-alt"],
      'f0ed',
      
      'M544 241.1V232c0-57.4-46.6-104-104-104c-13.4 0-26.2 2.5-37.9 7.1l-24.3 9.5-14.2-22C340.8 87.3 301.1 64 256 64c-70.7 0-128 57.3-128 128v8.2 22.6l-21.3 7.5C63.1 245.8 32 287.3 32 336V448H144 512h96V352c0-35.5-19.2-66.5-48-83.2l-16-9.2V241.1zM0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c56.4 0 106 29.2 134.5 73.3c15.3-6 32-9.3 49.5-9.3c75.1 0 136 60.9 136 136v9.1c38.3 22.1 64 63.5 64 110.9v96 32H608 512 144 32 0V448 336zm228.7-36.7L217.4 288 240 265.4l11.3 11.3L304 329.4V176 160h32v16V329.4l52.7-52.7L400 265.4 422.6 288l-11.3 11.3-80 80L320 390.6l-11.3-11.3-80-80z'
      
    ]
  };

  
    var faCloudDownload = faCloudArrowDown;
  
    var faCloudDownloadAlt = faCloudArrowDown;
  

  
  

  var faHouseLock = {
    prefix: 'fasl',
    iconName: 'house-lock',
    icon: [
      640,
      512,
      [],
      'e510',
      
      'M298.6 12L288 2.7 277.4 12 5.4 252l21.2 24L64 243V496v16H80 384l0-32H368V304 288H352 224 208v16V480H96V214.7L288 45.3 451.8 189.9c8.1-7.5 17.2-13.8 27.2-18.7L298.6 12zM336 480H240V320h96V480zM528 224c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48H416v32V480v32h32H608h32V480 352 320H608V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z'
      
    ]
  };

  

  
  

  var faArrowsLeftRight = {
    prefix: 'fasl',
    iconName: 'arrows-left-right',
    icon: [
      512,
      512,
      ["arrows-h"],
      'f07e',
      
      'M499.3 267.3l10.9-10.9-10.4-11.3-96-104-10.9-11.8-23.5 21.7 10.9 11.8L451.5 240 62.6 240l68.7-68.7L142.6 160 120 137.4l-11.3 11.3-96 96L1.4 256l11.3 11.3 96 96L120 374.6 142.6 352l-11.3-11.3L62.6 272l386.7 0-68.7 68.7L369.4 352 392 374.6l11.3-11.3 96-96z'
      
    ]
  };

  
    var faArrowsH = faArrowsLeftRight;
  

  
  

  var faObjectsAlignCenterVertical = {
    prefix: 'fasl',
    iconName: 'objects-align-center-vertical',
    icon: [
      512,
      512,
      [],
      'e3bd',
      
      'M192 64l0 176v32l0 176-96 0 0-176 0-32L96 64l96 0zm32 176l0-176V32l-32 0L96 32 64 32V64l0 176H0l0 32H64l0 176v32H96l96 0h32l0-32 0-176 64 0V384v32h32 96 32V384 272h64V240H448l0-112V96l-32 0H320 288v32l0 112-64 0zm96 0l0-112 96 0 0 112v32V384H320V272 240z'
      
    ]
  };

  

  
  

  var faSquareDown = {
    prefix: 'fasl',
    iconName: 'square-down',
    icon: [
      448,
      512,
      [11015,"arrow-alt-square-down"],
      'f350',
      
      'M416 448l0-384L32 64l0 384 384 0zm32 32l-32 0L32 480 0 480l0-32L0 64 0 32l32 0 384 0 32 0 0 32 0 384 0 32zM256 256l0-96-64 0 0 96 0 32-32 0-18.7 0L224 370.7 306.7 288 288 288l-32 0 0-32zM224 416l-22.6-22.6L96 288l0-32 32 0 32 0 0-32 0-64 0-32 32 0 64 0 32 0 0 32 0 64 0 32 32 0 32 0 0 32L246.6 393.4 224 416z'
      
    ]
  };

  
    var faArrowAltSquareDown = faSquareDown;
  

  
  

  var faFilePowerpoint = {
    prefix: 'fasl',
    iconName: 'file-powerpoint',
    icon: [
      384,
      512,
      [],
      'f1c4',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM128 240H112v16V368v64 16h32V432 384h56c39.8 0 72-32.2 72-72s-32.2-72-72-72H128zm72 112H144V272h56c22.1 0 40 17.9 40 40s-17.9 40-40 40z'
      
    ]
  };

  

  
  

  var faFileWord = {
    prefix: 'fasl',
    iconName: 'file-word',
    icon: [
      384,
      512,
      [],
      'f1c2',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zm77.9 224H276.7L240.1 355.7 207.4 235.8 204.2 224H179.8l-3.2 11.8L143.9 355.7 107.3 224H74.1l54.5 196.3 3.3 11.7h24.4l3.2-11.8L192 300.8l32.6 119.4 3.2 11.8h24.4l3.3-11.7L309.9 224z'
      
    ]
  };

  

  
  

  var faLeft = {
    prefix: 'fasl',
    iconName: 'left',
    icon: [
      448,
      512,
      ["arrow-alt-left"],
      'f355',
      
      'M208 208l32 0 176 0 0 96-176 0-32 0 0 32 0 80-2.7 0L45.2 256l160-160 2.7 0 0 80 0 32zM192 64L22.6 233.4 0 256l22.6 22.6L192 448l16 0 32 0 0-32 0-48 0-32 32 0 144 0 32 0 0-32 0-96 0-32-32 0-144 0-32 0 0-32 0-48 0-32-32 0-16 0z'
      
    ]
  };

  
    var faArrowAltLeft = faLeft;
  

  
  

  var faWavesSine = {
    prefix: 'fasl',
    iconName: 'waves-sine',
    icon: [
      640,
      512,
      [],
      'e65d',
      
      'M240 121.2c-14.4 24-26.5 53.4-38.1 85.4c-5.2-15.2-10.8-30.6-16.7-45.8c8.3-20.2 17.3-39.2 27.3-56C237.1 63.8 270.7 32 320 32s82.9 31.8 107.4 72.8c24.3 40.5 42.2 93.8 59.4 145l.4 1.2c17.6 52.5 34.6 102.7 56.9 139.9c22.2 37 47.2 57.2 80 57.2h16v32H624c-49.3 0-82.9-31.8-107.4-72.8c-24.3-40.5-42.2-93.8-59.4-145l0 0-.4-1.2c-17.6-52.5-34.6-102.7-56.9-139.9C377.8 84.2 352.8 64 320 64s-57.8 20.2-80 57.2zm-89.3 230c-8.3 20.2-17.3 39.2-27.3 56C98.9 448.2 65.3 480 16 480H0V448H16c32.8 0 57.8-20.2 80-57.2c14.4-24 26.5-53.4 38.1-85.4c5.2 15.2 10.8 30.6 16.7 45.8zM400 390.8c14.4-24 26.5-53.4 38.1-85.4c5.2 15.2 10.8 30.6 16.7 45.8c-8.3 20.2-17.3 39.2-27.3 56C402.9 448.2 369.3 480 320 480s-82.9-31.8-107.4-72.8c-24.3-40.5-42.2-93.8-59.4-145l0 0-.4-1.2C135.2 208.6 118.3 158.4 96 121.2C73.8 84.2 48.8 64 16 64H0V32H16c49.3 0 82.9 31.8 107.4 72.8c24.3 40.5 42.2 93.8 59.4 145l.4 1.2c17.6 52.5 34.6 102.7 56.9 139.9c22.2 37 47.2 57.2 80 57.2s57.8-20.2 80-57.2zM544 121.2c-14.4 24-26.5 53.4-38.1 85.4c-5.2-15.2-10.8-30.6-16.7-45.8c8.3-20.2 17.3-39.2 27.3-56C541.1 63.8 574.7 32 624 32h16V64H624c-32.8 0-57.8 20.2-80 57.2z'
      
    ]
  };

  

  
  

  var faCircle6 = {
    prefix: 'fasl',
    iconName: 'circle-6',
    icon: [
      512,
      512,
      [],
      'e0f3',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192.7 208.3C171.7 229.5 160 258.2 160 288c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-.8 0-1.6 0-2.4 0l61.8-62.8 1.2-1.2H271.7l-79 80.3zM320 288a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z'
      
    ]
  };

  

  
  

  var faChessKingPiece = {
    prefix: 'fasl',
    iconName: 'chess-king-piece',
    icon: [
      256,
      512,
      ["chess-king-alt"],
      'f440',
      
      'M144 0V16 32h16 16V64H160 144V96h48 32v32 24l-32.7 72H200h16v32H200 186.2l13.1 96H167l-13.1-96H102.1L89 352H56.7l13.1-96H56 40V224H56h8.7L32 152V128 96H64h48V64H96 80V32H96h16V16 0h32zM99.9 224h56.2L192 145.1V128H144 112 64v17.1L99.9 224zM32 480H224V463.3L191.2 416H64.8L32 463.3V480zM0 480V453.3L48 384H208l48 69.3V480v32H224 32 0V480z'
      
    ]
  };

  
    var faChessKingAlt = faChessKingPiece;
  

  
  

  var faTombstoneBlank = {
    prefix: 'fasl',
    iconName: 'tombstone-blank',
    icon: [
      448,
      512,
      [129702,"tombstone-alt"],
      'f721',
      
      'M384 192V448h32V192C416 86 330 0 224 0S32 86 32 192V448H64V192c0-88.4 71.6-160 160-160s160 71.6 160 160zM16 480H0v32H16 432h16V480H432 16z'
      
    ]
  };

  
    var faTombstoneAlt = faTombstoneBlank;
  

  
  

  var faFaceSmileWink = {
    prefix: 'fasl',
    iconName: 'face-smile-wink',
    icon: [
      512,
      512,
      [128521,"smile-wink"],
      'f4da',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm129.7 71.2l28.6-14.3c8.7 17.5 41.3 55.2 97.7 55.2s88.9-37.7 97.7-55.2l28.6 14.3C369.7 352.3 327.6 400 256 400s-113.7-47.7-126.3-72.8zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm140.4 29.6l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0z'
      
    ]
  };

  
    var faSmileWink = faFaceSmileWink;
  

  
  

  var faProjector = {
    prefix: 'fasl',
    iconName: 'projector',
    icon: [
      640,
      512,
      [],
      'f8d6',
      
      'M432 16V0H400V16v96 16h32V112 16zM267.3 36.7L256 25.4 233.4 48l11.3 11.3 64 64L320 134.6 342.6 112l-11.3-11.3-64-64zm320 22.6L598.6 48 576 25.4 564.7 36.7l-64 64L489.4 112 512 134.6l11.3-11.3 64-64zM288 320a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm288 0c0-36-11.9-69.3-32-96h64V416H576 544c20.1-26.7 32-60 32-96zm0 128h32 32V416 224 192H608 512c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32H32 0v32V416v32H32 64v48 16H96V496 448H320c26.7 20.1 60 32 96 32c37.3 0 71.6-12.7 98.8-34.1c-.9 .7-1.8 1.4-2.8 2.1h32v48 16h32V496 448zM96 416H64 32V224H288c-20.1 26.7-32 60-32 96s11.9 69.3 32 96H96zm24-96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faText = {
    prefix: 'fasl',
    iconName: 'text',
    icon: [
      448,
      512,
      [],
      'f893',
      
      'M0 32H16 432h16V48v64 16H416V112 64H240l0 384h64 16v32H304 144 128V448h16 64l0-384H32v48 16H0V112 48 32z'
      
    ]
  };

  

  
  

  var faCircleDownLeft = {
    prefix: 'fasl',
    iconName: 'circle-down-left',
    icon: [
      512,
      512,
      [],
      'e107',
      
      'M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM160 368H144V352 192v-6.6l4.7-4.7 16-16L176 153.4l11.3 11.3L228 205.4l64.7-64.7L304 129.4l11.3 11.3 56 56L382.6 208l-11.3 11.3L306.6 284l40.7 40.7L358.6 336l-11.3 11.3-16 16-4.7 4.7H320 160zm16-169.4V336H313.4l-40.7-40.7L261.4 284l11.3-11.3L337.4 208 304 174.6l-64.7 64.7L228 250.6l-11.3-11.3L176 198.6z'
      
    ]
  };

  

  
  

  var faWatch = {
    prefix: 'fasl',
    iconName: 'watch',
    icon: [
      384,
      512,
      [8986],
      'f2e1',
      
      'M64 0H80 304h16V16v96h-1c39.9 35.2 65 86.7 65 144s-25.1 108.8-65 144h1v96 16H304L80 512H64V496l0-96h1C25.1 364.8 0 313.3 0 256s25.1-108.8 65-144H64V16 0zM96 422.3L96 480l192 0V422.3c-28.2 16.3-61 25.7-96 25.7s-67.8-9.4-96-25.7zM288 32H96V89.7C124.2 73.3 157 64 192 64s67.8 9.3 96 25.7V32zm64 224A160 160 0 1 0 32 256a160 160 0 1 0 320 0zM208 176v71.4l40.9 27.2 13.3 8.9-17.8 26.6-13.3-8.9-48-32-7.1-4.8V256 176 160h32v16z'
      
    ]
  };

  

  
  

  var faTextSlash = {
    prefix: 'fasl',
    iconName: 'text-slash',
    icon: [
      640,
      512,
      ["remove-format"],
      'f87d',
      
      'M40.4 18L27.8 8.2 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM352.3 200L390.4 64H539.5l-16 64h33l19-76.1 5-19.9H560 144h-4.4l40.5 32H357.1L325.1 178.5 352.3 200zM314.9 333.5L287.7 312 249.6 448H176 160v32h16H336h16V448H336 282.9l32.1-114.5z'
      
    ]
  };

  
    var faRemoveFormat = faTextSlash;
  

  
  

  var faChartLineUpDown = {
    prefix: 'fasl',
    iconName: 'chart-line-up-down',
    icon: [
      512,
      512,
      [],
      'e5d7',
      
      'M32 48V32H0V48 464v16H16 496h16V448H496 32V48zM352 64V96h16 57.4L288 233.4l-68.7-68.7L208 153.4l-11.3 11.3-96 96L89.4 272 112 294.6l11.3-11.3L208 198.6l68.7 68.7L288 278.6l11.3-11.3L448 118.6V176v16h32V176 80 64H464 368 352zm0 320h16 96 16V368 272 256H448v16 57.4l-60.7-60.7L376 257.4 353.4 280l11.3 11.3L425.4 352H368 352v32z'
      
    ]
  };

  

  
  

  var faCloudBolt = {
    prefix: 'fasl',
    iconName: 'cloud-bolt',
    icon: [
      512,
      512,
      [127785,"thunderstorm"],
      'f76c',
      
      'M384 128v32h32c35.3 0 64 28.7 64 64v64H416 400v16h0v16h16 64 32V288 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v64 32H32 96h52.1l32-32H96 32V224c0-27.8 17.8-51.6 42.7-60.4L96 156.1V133.5 112c0-44.2 35.8-80 80-80c27 0 50.9 13.4 65.5 34l17.8 25.2 25.9-16.9c10-6.5 22-10.3 34.9-10.3c35.3 0 64 28.7 64 64zm-88 96h-6.6l-4.7 4.7-136 136-4.7 4.7V376v8 16h16 45.6l-13.4 93.7L189.6 512H208h8 6.6l4.7-4.7 136-136 4.7-4.7V360v-8V336H352 306.4l13.4-93.7 2.6-18.3H304h-8zM190.6 368l92.1-92.1-10.5 73.8L269.6 368H288h33.4l-92.1 92.1 10.5-73.8 2.6-18.3H224 190.6z'
      
    ]
  };

  
    var faThunderstorm = faCloudBolt;
  

  
  

  var faMessageCheck = {
    prefix: 'fasl',
    iconName: 'message-check',
    icon: [
      512,
      512,
      ["comment-alt-check"],
      'f4a2',
      
      'M160 416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448 416zm0-32h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zM363.3 147.3l-128 128L224 286.6l-11.3-11.3-64-64L137.4 200 160 177.4l11.3 11.3L224 241.4 340.7 124.7 352 113.4 374.6 136l-11.3 11.3z'
      
    ]
  };

  
    var faCommentAltCheck = faMessageCheck;
  

  
  

  var faHandHoldingSeedling = {
    prefix: 'fasl',
    iconName: 'hand-holding-seedling',
    icon: [
      576,
      512,
      [],
      'f4bf',
      
      'M112 0h32c83 0 151.2 63.1 159.2 144h.8v16 96 16H272V256 176H240C160.5 176 96 111.5 96 32V16 0h16zm32 32H128c0 61.9 50.1 112 112 112h31C263.1 80.9 209.3 32 144 32zM336 176V160c0-5.4-.2-10.7-.7-16h.7c61.9 0 112-50.1 112-112H416c-40.2 0-75.4 21.2-95.2 53c-4.7-11-10.4-21.5-16.9-31.3C330.3 20.9 370.7 0 416 0h48 16V16 32c0 79.5-64.5 144-144 144zM171.2 304H176 384h16v16 64h.2l103.6-61.7 13.5-8 8.3 13.3 40 64L574 405l-13.5 8.5-152 96-3.9 2.5H400 16 0V480H16 395.4L530 395l-23.3-37.2-94 56L409 416h-4.4H400 384 320 304 256 240V384h16 48 16 48V336H180.8l-92 61.3-4 2.7H80 16 0V368H16 75.2l92-61.3 4-2.7z'
      
    ]
  };

  

  
  

  var faPhoneArrowRight = {
    prefix: 'fasl',
    iconName: 'phone-arrow-right',
    icon: [
      512,
      512,
      [],
      'e5be',
      
      'M280.4 355.3l21.3 12.3L319 350.2l40.7-40.7L475.8 356 453.3 480H448C218.2 480 32 293.7 32 64l0-5.3L156 36.2l46.5 116.1-40.7 40.7-17.3 17.3 12.3 21.3c29.6 51.4 72.4 94.1 123.7 123.7zM512 336L352 272l-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L240 160 176 0 0 32 0 64C0 311.4 200.6 512 448 512h32l32-176zM411.3 12.7L400 1.4 377.4 24l11.3 11.3L449.4 96H304 288v32h16H449.4l-60.7 60.7L377.4 200 400 222.6l11.3-11.3 88-88L510.6 112l-11.3-11.3-88-88z'
      
    ]
  };

  

  
  

  var faSquareDollar = {
    prefix: 'fasl',
    iconName: 'square-dollar',
    icon: [
      448,
      512,
      ["dollar-square","usd-square"],
      'f2e9',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM240 144.7c14.4 1.4 28.9 4.1 42.9 7.6l15.5 3.9-7.8 31-15.5-3.9c-6.1-1.5-25.7-5.1-32.1-6.1c-19.4-2.9-36.2-.7-48 4.4c-18.1 7.7-26.7 28.6-8.2 40.4c11.6 7.4 25.6 11.3 39 14.9c2.4 .7 4.8 1.3 7.1 2c17.7 5 38.9 11.1 54.3 21.7c19 13 27.8 33.8 23.6 56.5c-4 21.6-18.9 36-37.8 43.6c-9.9 4-21.1 6.3-33.1 6.9V408H208V366.1c-12.6-2-32.8-8.5-45.9-12.7c-5.9-1.9-11.8-3.7-17.7-5.6c-1.5-.5-2.9-.9-4.4-1.4l9.6-30.5c1.4 .4 2.7 .9 4.1 1.3c6.5 2 13 4.1 19.5 6.1l0 0c13.5 4.3 30.2 9.7 39.9 11.2c19.8 2.9 36.5 1.3 48-3.4c19.2-7.8 26.4-31.6 8.1-44.1c-12-8.2-26.8-12.3-40.9-16.2c-2.3-.6-4.7-1.3-6.9-1.9c-17.1-4.8-37-10.5-51.7-19.9c-8.1-5.2-15.7-12.1-20.5-21.7c-4.9-9.8-6.2-20.8-4-32.8c3.7-20.4 19-34.6 37.3-42.4c7.8-3.3 16.4-5.6 25.6-7V104h32v40.7z'
      
    ]
  };

  
    var faDollarSquare = faSquareDollar;
  
    var faUsdSquare = faSquareDollar;
  

  
  

  var faArrowDownWideShort = {
    prefix: 'fasl',
    iconName: 'arrow-down-wide-short',
    icon: [
      576,
      512,
      ["sort-amount-asc","sort-amount-down"],
      'f160',
      
      'M139.3 467.3L128 478.6l-11.3-11.3-88-88L17.4 368 40 345.4l11.3 11.3L112 417.4V48 32h32V48 417.4l60.7-60.7L216 345.4 238.6 368l-11.3 11.3-88 88zM304 464H288V432h16 64 16v32H368 304zm0-128H288V304h16H432h16v32H432 304zm0-128H288V176h16H496h16v32H496 304zm0-128H288V48h16H560h16V80H560 304z'
      
    ]
  };

  
    var faSortAmountAsc = faArrowDownWideShort;
  
    var faSortAmountDown = faArrowDownWideShort;
  

  
  

  var faCandyCane = {
    prefix: 'fasl',
    iconName: 'candy-cane',
    icon: [
      512,
      512,
      [],
      'f786',
      
      'M348 97.5L327.8 36.7C338.5 33.6 349.7 32 361 32c27.1 0 52.1 9.1 72.1 24.3l-46.2 46.2C379.2 98.3 370.3 96 361 96c-4.4 0-8.7 .5-12.9 1.5zm61.5 27.6l46.2-46.2c15.3 20 24.3 45 24.3 72.1v5.6c0 8.7-.9 17.3-2.7 25.6l-61.6-20.5c.1-1.7 .2-3.4 .2-5.1V151c0-9.4-2.3-18.2-6.5-25.9zm57.3 87.4c-10.1 20.2-25.6 37.5-45.4 49.9l-31.3 19.6-60.4-37.7 57.8-36.1c6.9-4.3 12.7-9.9 17.3-16.3l62 20.7zM359.9 300.8l-77 48.1-60.4-37.7 77-48.1 60.4 37.7zm-107.2 67l-73 45.6-60.4-37.7 73-45.6 60.4 37.7zM149.5 432.3l-57 35.6L58.6 413.6l30.5-19.1 60.4 37.7zM298.4 49.8l20.8 62.5-40.8 25.5L244.5 83.4l53.4-33.4c.2-.1 .3-.2 .5-.3zm-3 115.1l53.4-33.4c3.7-2.3 7.9-3.5 12.2-3.5c12.7 0 23 10.3 23 23v5.6c0 9.9-5.1 19.1-13.5 24.3L41.7 386.5l-27.1 17 17 27.1 33.9 54.3 17 27.1 27.1-17L438.4 289.5c45.8-28.6 73.6-78.8 73.6-132.8V151C512 67.6 444.4 0 361 0c-28.3 0-56 8-80 23L227.6 56.3l-27.1 17 17 27.1 33.9 54.3 17 27.1 27.1-17z'
      
    ]
  };

  

  
  

  var faSquare9 = {
    prefix: 'fasl',
    iconName: 'square-9',
    icon: [
      448,
      512,
      [],
      'e25e',
      
      'M416 448V64H32V448H416zm32 32H416 32 0V448 64 32H32 416h32V64 448v32zM287.3 303.7l-79 80.3H163.4l1.2-1.2L226.4 320c-.8 0-1.6 0-2.4 0c-53 0-96-43-96-96s43-96 96-96s96 43 96 96c0 29.8-11.7 58.5-32.7 79.7zM288 224a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faBowlFood = {
    prefix: 'fasl',
    iconName: 'bowl-food',
    icon: [
      512,
      512,
      [],
      'e4c6',
      
      'M203.8 98.2l-7.8 16.1-15.1-9.6C172 99.2 161.8 96 151 96c-27.8 0-52.1 21.2-57.8 51l-2.5 13.4L77.1 160c-.4 0-.7 0-1.1 0c-23.3 0-44 20.5-44 48v16H0V208c0-39.4 27.5-73.5 64.9-79.2C77 91.6 110.5 64 151 64c11.4 0 22.3 2.2 32.3 6.2C199.8 47.2 226 32 256 32s56.2 15.2 72.7 38.2c10-4 20.9-6.2 32.3-6.2c40.5 0 74 27.6 86.1 64.8c37.4 5.7 64.9 39.8 64.9 79.2v16H480V208c0-27.5-20.7-48-44-48c-.4 0-.7 0-1.1 0l-13.6 .4L418.8 147c-5.7-29.8-30-51-57.8-51c-10.8 0-21 3.2-29.8 8.7l-15.1 9.6-7.8-16.1C298.1 77.5 278.2 64 256 64s-42.1 13.5-52.2 34.2zM128 431.8V448H384V431.8 411.6l18.3-8.7c43.7-20.8 74.6-64.1 77.5-114.9H32.2c2.9 50.8 33.8 94.2 77.5 114.9l18.3 8.7v20.2zm-32 0C41.5 405.9 3.2 351.6 .2 288c-.1-2.7-.2-5.3-.2-8V256H32 480h32v24c0 2.7-.1 5.3-.2 8c-3 63.6-41.3 117.9-95.8 143.8V448v32H384 128 96V448 431.8z'
      
    ]
  };

  

  
  

  var faGroupArrowsRotate = {
    prefix: 'fasl',
    iconName: 'group-arrows-rotate',
    icon: [
      512,
      512,
      [],
      'e4f6',
      
      'M196.6 56.6c-14.2 4.2-27.8 10-40.6 17c2.6 7 4 14.5 4 22.4c0 35.3-28.7 64-64 64c-7.9 0-15.4-1.4-22.4-4c-7 12.8-12.7 26.4-17 40.6l-30.7-9.1c5.2-17.6 12.4-34.3 21.3-50C37.7 126.3 32 111.8 32 96c0-35.3 28.7-64 64-64c15.8 0 30.3 5.7 41.5 15.3c15.6-8.9 32.4-16.1 50-21.3l9.1 30.7zm258.8 140c-4.2-14.2-10-27.8-17-40.6c-7 2.6-14.5 4-22.4 4c-35.3 0-64-28.7-64-64c0-7.9 1.4-15.4 4-22.4c-12.8-7-26.4-12.7-40.6-17l9.1-30.7c17.6 5.2 34.3 12.4 50 21.3C385.7 37.7 400.2 32 416 32c35.3 0 64 28.7 64 64c0 15.8-5.7 30.3-15.3 41.5c8.9 15.6 16.1 32.4 21.3 50l-30.7 9.1zM56.6 315.4c4.2 14.2 10 27.8 17 40.6c7-2.6 14.5-4 22.4-4c35.3 0 64 28.7 64 64c0 7.9-1.4 15.4-4 22.4c12.8 7 26.4 12.7 40.6 17l-9.1 30.7c-17.6-5.2-34.3-12.4-50-21.3C126.3 474.3 111.8 480 96 480c-35.3 0-64-28.7-64-64c0-15.8 5.7-30.3 15.3-41.5c-8.9-15.6-16.1-32.4-21.3-50l30.7-9.1zm258.8 140c14.2-4.2 27.8-10 40.6-17c-2.6-7-4-14.5-4-22.4c0-35.3 28.7-64 64-64c7.9 0 15.4 1.4 22.4 4c7-12.8 12.7-26.4 17-40.6l30.7 9.1c-5.2 17.6-12.4 34.3-21.3 50c9.5 11.2 15.3 25.7 15.3 41.5c0 35.3-28.7 64-64 64c-15.8 0-30.3-5.7-41.5-15.3c-15.6 8.9-32.4 16.1-50 21.3l-9.1-30.7zM96 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM144.8 152.8h16 56 16v16 56 16h-32v-16V211.5c-10 12.4-16 28.1-16 45.3c0 28 15.9 52.2 39.3 64.2l-14.6 28.5c-33.6-17.2-56.7-52.2-56.7-92.7c0-27.6 10.8-52.8 28.4-71.4l.2-.2 .2-.2 .3-.3h-21-16v-32zm208 208h-56-16v-16-56l0-16h32v16 11.7c10-12.4 16-28.1 16-45.3c0-28-15.9-52.2-39.3-64.2l14.6-28.5c33.6 17.2 56.7 52.2 56.7 92.7c0 27.6-10.8 52.8-28.4 71.4l-.2 .2-.2 .2-1.9 1.9h22.6 16v32h-16z'
      
    ]
  };

  

  
  

  var faFileJpg = {
    prefix: 'fasl',
    iconName: 'file-jpg',
    icon: [
      512,
      512,
      [],
      'e646',
      
      'M352 192v96h32V152L232 0H32 0V32 480v32H32 96V480H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM208 512c26.5 0 48-21.5 48-48V368 352H224v16 96c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 432H160v16 16c0 26.5 21.5 48 48 48zM456 352c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V448 432H496 480 464v32h16v8c0 4.4-3.6 8-8 8H456c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16h32V392c0-22.1-17.9-40-40-40H456zm-168 0v16 80 48 16h32V496 464h16c30.9 0 56-25.1 56-56s-25.1-56-56-56H304 288zm32 80V384h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H320z'
      
    ]
  };

  

  
  

  var faFlashlight = {
    prefix: 'fasl',
    iconName: 'flashlight',
    icon: [
      640,
      512,
      [128294],
      'f8b8',
      
      'M401.8 325.4l-8.1-5.4H384 32V192H384h9.7l8.1-5.4 31.5-21c24-16 50.8-27.1 78.7-32.9V379.3c-28-5.8-54.7-16.9-78.7-32.9l-31.5-21zM544 383.6V128.4c4.5-.3 9-.4 13.5-.4H608V384H557.5c-4.5 0-9-.1-13.5-.4zM0 352H32 384l31.5 21c42.1 28 91.5 43 142 43H608h32V384 128 96H608 557.5c-50.5 0-100 15-142 43L384 160H32 0v32V320v32zM224 240v32h16 64 16V240H304 240 224z'
      
    ]
  };

  

  
  

  var faCircleArrowLeft = {
    prefix: 'fasl',
    iconName: 'circle-arrow-left',
    icon: [
      512,
      512,
      ["arrow-circle-left"],
      'f0a8',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM132.7 244.7L121.4 256l11.3 11.3 96 96L240 374.6 262.6 352l-11.3-11.3L182.6 272 368 272l16 0 0-32-16 0-185.4 0 68.7-68.7L262.6 160 240 137.4l-11.3 11.3-96 96z'
      
    ]
  };

  
    var faArrowCircleLeft = faCircleArrowLeft;
  

  
  

  var faBoxesPacking = {
    prefix: 'fasl',
    iconName: 'boxes-packing',
    icon: [
      640,
      512,
      [],
      'e4c7',
      
      'M608 32H288v96H256V32 0h32H608h32V32 480v32H608 384V480H608V32zM491.3 252.7l64 64-22.6 22.6L496 302.6V432v16H464V432 302.6l-36.7 36.7-22.6-22.6 64-64L480 241.4l11.3 11.3zM352 192H32v64H64 320h32V192zM0 288V256 192 160H32 352h32v32 64 32H352V480v32H320 64 32V480 288H0zM64 480H320V288H64V480zM256 320v32H128V320H256z'
      
    ]
  };

  

  
  

  var faLeftRight = {
    prefix: 'fasl',
    iconName: 'left-right',
    icon: [
      512,
      512,
      [8596,"arrows-alt-h"],
      'f337',
      
      'M160 352l0-32 32 0 128 0 32 0 0 32 0 32 32 0L489.4 278.6 512 256l-22.6-22.6L384 128l-32 0 0 32 0 32-32 0-128 0-32 0 0-32 0-32-32 0L22.6 233.4 0 256l22.6 22.6L128 384l32 0 0-32zm-32-13.3L45.3 256 128 173.3l0 18.7 0 32 32 0 192 0 32 0 0-32 0-18.7L466.7 256 384 338.7l0-18.7 0-32-32 0-192 0-32 0 0 32 0 18.7z'
      
    ]
  };

  
    var faArrowsAltH = faLeftRight;
  

  
  

  var faClockSeven = {
    prefix: 'fasl',
    iconName: 'clock-seven',
    icon: [
      512,
      512,
      [],
      'e350',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112V251.2l-61.3 92-8.9 13.3 26.6 17.8 8.9-13.3 64-96 2.7-4V256 112 96H240v16z'
      
    ]
  };

  

  
  

  var faSeedling = {
    prefix: 'fasl',
    iconName: 'seedling',
    icon: [
      512,
      512,
      [127793,"sprout"],
      'f4d8',
      
      'M480 32c0 95.3-69.4 174.4-160.5 189.4c2.7 10.2 4.7 20.7 6.1 31.4C431.4 234.9 512 142.9 512 32V0H480 448C367 0 296 43 256.6 107.5c7.8 8.3 15.1 17.2 21.8 26.4C310.7 73.3 374.5 32 448 32h32zM64 96c106 0 192 86 192 192H224C118 288 32 202 32 96H64zM224 320h32V496v16h32V496 320 304 288C288 164.3 187.7 64 64 64H32 0V96C0 219.7 100.3 320 224 320z'
      
    ]
  };

  
    var faSprout = faSeedling;
  

  
  

  var faArrowsDownToPeople = {
    prefix: 'fasl',
    iconName: 'arrows-down-to-people',
    icon: [
      640,
      512,
      [],
      'e4b9',
      
      'M128 16V145.4L91.3 108.7 80 97.4 57.4 120l11.3 11.3 64 64L144 206.6l11.3-11.3 64-64L230.6 120 208 97.4l-11.3 11.3L160 145.4V16 0H128V16zM409.4 120l11.3 11.3 64 64L496 206.6l11.3-11.3 64-64L582.6 120 560 97.4l-11.3 11.3L512 145.4V16 0H480V16 145.4l-36.7-36.7L432 97.4 409.4 120zM304 192a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-96 64h-8.9l-4.7 7.6-55.9 90.9-1.5-2.5H192 96 87.1l-4.7 7.6-64 104L10 477.2 37.2 494l8.4-13.6L88 411.5V496v16h16 80 16V496 411.5l42.4 68.9 8.4 13.6L278 477.2l-8.4-13.6L221.3 385l.4-.6L264 315.5V416v16h16 80 16V416 315.5l42.4 68.9 .4 .6-48.4 78.6L362 477.2 389.2 494l8.4-13.6L440 411.5V496v16h16 80 16V496 411.5l42.4 68.9 8.4 13.6L630 477.2l-8.4-13.6-64-104-4.7-7.6H544 448h-8.9l-1.5 2.5-55.9-90.9-4.7-7.6H368 272zm24 144V288h48V400H296zM144 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-24 48h48v96H120V384zm360-96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM520 480H472V384h48v96z'
      
    ]
  };

  

  
  

  var faBullseyeArrow = {
    prefix: 'fasl',
    iconName: 'bullseye-arrow',
    icon: [
      512,
      512,
      [127919],
      'f648',
      
      'M323.2 8.9C301.8 3.1 279.3 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-23.3-3.1-45.8-8.9-67.2l-26.7 26.7c2.4 13.1 3.6 26.7 3.6 40.5c0 123.7-100.3 224-224 224S32 379.7 32 256S132.3 32 256 32c13.8 0 27.3 1.3 40.5 3.6L323.2 8.9zm-50 88c-5.6-.6-11.4-.9-17.2-.9C167.6 96 96 167.6 96 256s71.6 160 160 160s160-71.6 160-160c0-5.8-.3-11.5-.9-17.2l-32.6-2.5c1 6.4 1.5 13 1.5 19.7c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c6.7 0 13.3 .5 19.7 1.5l-2.5-32.6zM437.2 75.2l-.4-.4 .1 .3 .3 .1zm-56 33l-39.9 39.9-4.8-62 25.6-25.6 19.1 47.7zm-47.1 92.4l96.7 7.4 7.3 .6 5.2-5.2 48-48 17.2-17.2-22.5-9L412.3 99.7 382.9 26.1l-9-22.5L356.7 20.7l-48 48-5.2 5.2 .6 7.3 7.4 96.7-66.8 66.8L233.4 256 256 278.6l11.3-11.3 66.8-66.8zm29.8-29.8l39.9-39.9 47.7 19.1-25.6 25.6-62-4.8z'
      
    ]
  };

  

  
  

  var faFerry = {
    prefix: 'fasl',
    iconName: 'ferry',
    icon: [
      576,
      512,
      [],
      'e4ea',
      
      'M224 0H192V32H122.7 88l13.3 32 13.3 32H80 64v16V304v4.4l2.3 3.8 48 80 27.4-16.5L108.3 320H467.7l-33.5 55.8 27.4 16.5 48-80 2.3-3.8V304 112 96H496 461.3l13.3-32L488 32H453.3 384V0H352 224zM128 288H96V128h32H448h32V288H448V176 160H432 144 128v16V288zm32 0V192H416v96H160zM426.7 96H149.3L136 64h56 32V32H352V64h32 56L426.7 96zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-14.6-10-26-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C41.7 470.1 20.9 480 0 480v32c30.3 0 57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C518.5 497.9 545.7 512 576 512V480c-20.9 0-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C425.6 470.1 404.9 480 384 480s-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C233.6 470.1 212.9 480 192 480z'
      
    ]
  };

  

  
  

  var faTrianglePersonDigging = {
    prefix: 'fasl',
    iconName: 'triangle-person-digging',
    icon: [
      640,
      512,
      ["construction"],
      'f85d',
      
      'M0 512l20-32L301.1 30.2 320 0l18.9 30.2L620 480l20 32H602.3 37.7 0zM320 60.4L57.7 480H582.3L320 60.4zM288 200a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-14.7 28.1l12.7 5.1 40 16 7.3 2.9 2.2 7.5 20 69.4 44.4 26.6 13.4-21.4L432 304l18.9 30.2L492 400l20 32H474.3 389.7 352l20-32 10.8-17.3-49.3-29.6-85.7-51.4L234 293.5l8.2-13.7 24-40 7-11.7zm41.8 76.7l-8.3-28.8-20.1-8L278 282.5l37.1 22.3zM432 364.4L409.7 400h44.5L432 364.4zM252.1 332.7l60.3 37.7 7.5 4.7V384v32 16H304 288V416 392.9l-37.9-23.7L218.9 432H183.1l2.6-5.1 43.7-87.7 7.9-15.8 14.9 9.3z'
      
    ]
  };

  
    var faConstruction = faTrianglePersonDigging;
  

  
  

  var faCircleEnvelope = {
    prefix: 'fasl',
    iconName: 'circle-envelope',
    icon: [
      512,
      512,
      ["envelope-circle"],
      'e10c',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160-96H352h32v32V320v32H352 160 128V320 192 160h32zm192 48.2V192H160v16.2l96 47.4 96-47.4zm0 35.7l-88.9 43.9-7.1 3.5-7.1-3.5L160 243.9V320H352V243.9z'
      
    ]
  };

  
    var faEnvelopeCircle = faCircleEnvelope;
  

  
  

  var faInboxFull = {
    prefix: 'fasl',
    iconName: 'inbox-full',
    icon: [
      512,
      512,
      [],
      'e1ba',
      
      'M32 323.9l1-3.9H134.1l27.6 55.2 4.4 8.8H176 336h9.9l4.4-8.8L377.9 320H479l1 3.9V448H32V323.9zM97 64H415l56 224H368h-9.9l-4.4 8.8L326.1 352H185.9l-27.6-55.2-4.4-8.8H144 41L97 64zM0 320V448v32H32 480h32V448 320L440 32H72L0 320zM176 144H160v32h16H336h16V144H336 176zm-32 80H128v32h16H368h16V224H368 144z'
      
    ]
  };

  

  
  

  var faPig = {
    prefix: 'fasl',
    iconName: 'pig',
    icon: [
      640,
      512,
      [128022],
      'f706',
      
      'M480 32h-2.4l-2.3 .7L416.6 50.8C399.7 56 385.5 66.4 375.5 80H240C162.6 80 98 135 83.2 208H47.4c-8.5 0-15.4-6.9-15.4-15.4c0-7.1 4.8-13.3 11.7-15l8.2-2 15.5-3.9-7.8-31-15.5 3.9-8.2 2C14.8 151.8 0 170.8 0 192.6C0 218.8 21.2 240 47.4 240H80v16c0 53.4 29.1 100 72.2 124.8l31.6 88.6 3.8 10.6h11.3H272h16V464 416h32 48v48 16h16 73.1 11.3l3.8-10.6L494 408.5c26.2-9.1 49.3-25.9 65.9-48.5H624h16V344 216 200H624 581.3c-5.9-4-11.2-8.8-15.8-14.2C591.9 166.5 608 135.5 608 102V96 80H592 528V48 32H512 480zM112 256V240c0-70.7 57.3-128 128-128H380.5c1.1 0 2.2 0 3.4 0l9.6 .2 4.7-8.4c5.9-10.6 15.7-18.8 27.9-22.5L482.4 64H496V90.1c0 12.5-4.5 24.1-12 33.3l-10.9 13.1 13.8 10c17.9 13 33.5 29.3 45.8 48.5c9.1 14.2 21.3 26 35.7 34.7l3.8 2.3h4.4H608v96H551.4h-8.8l-4.7 7.4c-14 22-35.7 37.9-60.6 44.8l-8 2.2-2.8 7.8L445.9 448H400V400 384H384 320 272 256v16 48H210.1l-29.9-83.7-2.1-5.9-5.6-2.9c-36-18.7-60.5-56.2-60.5-99.5zM525.1 112h50.2c-2.7 19.2-13.1 36.5-28.5 47.9c-8.7-10.9-18.4-20.8-28.9-29.7c3.1-5.7 5.6-11.8 7.3-18.2zM468 256a20 20 0 1 0 0-40 20 20 0 1 0 0 40z'
      
    ]
  };

  

  
  

  var faVest = {
    prefix: 'fasl',
    iconName: 'vest',
    icon: [
      448,
      512,
      [],
      'e085',
      
      'M143 0h4 7.3l3.7 10.6 0 .1c.1 .1 .2 .5 .4 .9c.4 .9 1.1 2.3 2.1 4c2 3.5 5.3 8.3 10.2 13.1C180.2 37.9 196.5 48 224 48s43.8-10.1 53.3-19.4c4.9-4.8 8.2-9.6 10.2-13.1c1-1.7 1.7-3.1 2.1-4c.2-.4 .3-.7 .4-.9l0-.1L293.6 0H301h4 7 72 16V16 128v67.6l45.7 76.2 2.3 3.8V280 496v16H432 208 192V496 288v-3l1.1-2.8L274.6 69.1C261.3 75.6 244.6 80 224 80s-37.3-4.4-50.6-10.9l33.4 87.4-17.1 44.8L125 32H80v96 72 4.4l-2.3 3.8L32 284.4V425.4l68.7-68.7L112 345.4 134.6 368l-11.3 11.3-88 88L32 470.6V480H160v16 16H16 0V496 280v-4.4l2.3-3.8L48 195.6V128 16 0H64h72 7zM323 32L224 291V480H416v-9.4l-3.3-3.3-88-88L313.4 368 336 345.4l11.3 11.3L416 425.4V284.4l-45.7-76.2-2.3-3.8V200 128 32H323z'
      
    ]
  };

  

  
  

  var faArrowsTurnRight = {
    prefix: 'fasl',
    iconName: 'arrows-turn-right',
    icon: [
      448,
      512,
      [],
      'e4c0',
      
      'M322.5 11.9L310.4 1.4l-21 24.2 12.1 10.5L389.1 112 16 112 0 112v16V272v16H32V272 144l357.1 0-87.6 75.9-12.1 10.5 21 24.2 12.1-10.5 120-104 14-12.1-14-12.1-120-104zm-96 256l-12.1-10.5-21 24.2 12.1 10.5L293.1 368 16 368 0 368v16V496v16H32V496 400l261.1 0-87.6 75.9-12.1 10.5 21 24.2 12.1-10.5 120-104 14-12.1-14-12.1-120-104z'
      
    ]
  };

  

  
  

  var faObjectsAlignRight = {
    prefix: 'fasl',
    iconName: 'objects-align-right',
    icon: [
      512,
      512,
      [],
      'e3bf',
      
      'M512 512L512 0 480 0l0 512 32 0zM352 192L32 192l0-96 320 0 0 96zm32-96l0-32-32 0L32 64 0 64 0 96l0 96 0 32 32 0 320 0 32 0 0-32 0-96zM352 416l-192 0 0-96 192 0 0 96zm32-96l0-32-32 0-192 0-32 0 0 32 0 96 0 32 32 0 192 0 32 0 0-32 0-96z'
      
    ]
  };

  

  
  

  var faChartMixedUpCircleCurrency = {
    prefix: 'fasl',
    iconName: 'chart-mixed-up-circle-currency',
    icon: [
      576,
      512,
      [],
      'e5d8',
      
      'M416 0H400V32h16 71L320.2 171 202.5 68l-9.6-8.4-10.3 7.5-176 128 18.8 25.9L191.1 100.5 309.5 204l10.3 9 10.5-8.7L512 52.8V128v16h32V128 16 0H528 416zm96 32l0 0h0v0zM80 352v96H48V352H80zM48 320H16v32 96 32H48 80h32V448 352 320H80 48zm128-64h32V448H176V256zm-32-32v32V448v32h32 32 32V448 256 224H208 176 144zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM406.6 393.4a35.9 35.9 0 1 1 50.7-50.7 35.9 35.9 0 1 1 -50.7 50.7zm-10 32.6c21.6 13.2 49.1 13.2 70.7 0l17.3 17.3 22.6-22.6L490 403.3c13.2-21.6 13.2-49.1 0-70.7l17.3-17.3-22.6-22.6L467.3 310c-21.6-13.2-49.1-13.2-70.7 0l-17.3-17.3-22.6 22.6L374 332.7c-13.2 21.6-13.2 49.1 0 70.7l-17.3 17.3 22.6 22.6L396.7 426z'
      
    ]
  };

  

  
  

  var faTransporter4 = {
    prefix: 'fasl',
    iconName: 'transporter-4',
    icon: [
      512,
      512,
      [],
      'e2a5',
      
      'M208 0h16 64 16V32H288 224 208V0zm0 64h16 64 16V96H288 224 208V64zm-48 64h16H336h16v32H336 176 160V128zm-32 64h16H368h16v32H368 144 128V192zM96 256h16H400h16v32H400 112 96V256zm64 64h16H336h16v32H336 176 160V320zm0 64h16H336h16v32H336 176 160V384zM96 448h16H400h16v16 32 16H384V496 480H128v16 16H96V496 464 448zM480 144v16h16 16v32H496 480v16 16H448V208 192H432 416V160h16 16V144 128h32v16zM64 368v16H80 96v32H80 64v16 16H32V432 416H16 0V384H16 32V368 352H64v16z'
      
    ]
  };

  

  
  

  var faPalette = {
    prefix: 'fasl',
    iconName: 'palette',
    icon: [
      512,
      512,
      [127912],
      'f53f',
      
      'M480 288V256C480 132.3 379.7 32 256 32S32 132.3 32 256c0 119.4 93.4 217 211.1 223.6l32.4-32.4c-12.6-17.1-19.5-37.8-19.5-59.3c0-55.2 44.7-99.9 99.9-99.9H480zM307.9 435.9L320 448l-22.6 22.6L256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v32 32H480 355.9c-37.5 0-67.9 30.4-67.9 67.9c0 18 7.2 35.3 19.9 48zM104 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm56-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72-8a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faCloudArrowUp = {
    prefix: 'fasl',
    iconName: 'cloud-arrow-up',
    icon: [
      640,
      512,
      [62338,"cloud-upload","cloud-upload-alt"],
      'f0ee',
      
      'M544 241.1V232c0-57.4-46.6-104-104-104c-13.4 0-26.2 2.5-37.9 7.1l-24.3 9.5-14.2-22C340.8 87.3 301.1 64 256 64c-70.7 0-128 57.3-128 128v8.2 22.6l-21.3 7.5C63.1 245.8 32 287.3 32 336V448H144 512h96V352c0-35.5-19.2-66.5-48-83.2l-16-9.2V241.1zM0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c56.4 0 106 29.2 134.5 73.3c15.3-6 32-9.3 49.5-9.3c75.1 0 136 60.9 136 136v9.1c38.3 22.1 64 63.5 64 110.9v96 32H608 512 144 32 0V448 336zm228.7-91.3l80-80L320 153.4l11.3 11.3 80 80L422.6 256 400 278.6l-11.3-11.3L336 214.6V368v16H304V368 214.6l-52.7 52.7L240 278.6 217.4 256l11.3-11.3z'
      
    ]
  };

  
    var faCloudUpload = faCloudArrowUp;
  
    var faCloudUploadAlt = faCloudArrowUp;
  

  
  

  var faFontAwesome = {
    prefix: 'fasl',
    iconName: 'font-awesome',
    icon: [
      512,
      512,
      [62501,62694,"font-awesome-flag","font-awesome-logo-full"],
      'f2b4',
      
      'M64 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm55.5 64c5.4-9.4 8.6-20.3 8.6-32C128 28.7 99.3 0 64 0S0 28.7 0 64c0 23.7 12.9 44.4 32 55.4l0 8.6 0 288 0 32 0 64 32 0 0-64 400 0 32 0 0-32L432 272l64-144 0-32-32 0L119.4 96zM64 128l397 0L402.8 259 397 272l5.8 13L461 416 64 416l0-288z'
      
    ]
  };

  
    var faFontAwesomeFlag = faFontAwesome;
  
    var faFontAwesomeLogoFull = faFontAwesome;
  

  
  

  var faGasPumpSlash = {
    prefix: 'fasl',
    iconName: 'gas-pump-slash',
    icon: [
      640,
      512,
      [],
      'f5f4',
      
      'M352 362.8V480H128V186L96 160.7V480l-32 0v32H96h32H352h32 32V480l-32 0V388.1l-32-25.3zM139.6 32H352V199.7L384 225V32 0H352 128 99l40.5 32zM576 136v-7l-5.2-4.8-96-88L463 25.4 441.4 49l11.8 10.8L480 84.4V160c0 35.3 28.7 64 64 64V351.3l32 25.3V136zm-64-22.3L544 143v49c-17.7 0-32-14.3-32-32V113.7zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faCrutch = {
    prefix: 'fasl',
    iconName: 'crutch',
    icon: [
      512,
      512,
      [],
      'f7f7',
      
      'M312 1.4L289.4 24l11.3 11.3 176 176L488 222.6 510.6 200l-11.3-11.3-176-176L312 1.4zM196.6 164.8l-47.9 47.9-3.4 3.4-1 4.8-31 155.2L12.7 476.7 1.4 488 24 510.6l11.3-11.3L135.9 398.7l155.2-31 4.8-1 3.4-3.4 48-48 94.1-94.1-22.6-22.6L336 281.4 230.6 176l82.7-82.7L290.7 70.6l-94 94c0 0-.1 .1-.1 .1s-.1 .1-.1 .1zM208 198.6L313.4 304l-33.3 33.3L148.4 363.6l26.3-131.7L208 198.6z'
      
    ]
  };

  

  
  

  var faSquareALock = {
    prefix: 'fasl',
    iconName: 'square-a-lock',
    icon: [
      576,
      512,
      [],
      'e44d',
      
      'M32 64H416V170.8c9.9-4.7 20.7-8 32-9.6V64 32H416 32 0V64 448v32H32 320l0-32H32V64zm206.5 73.2l-4.3-9.2H213.8l-4.3 9.2L94 384h35.3l30-64H288.7l30 64H320l0-72.7L238.5 137.2zM224 181.7L273.8 288H174.2L224 181.7zM464 224c26.5 0 48 21.5 48 48v48H416V272c0-26.5 21.5-48 48-48zm-80 48v48H352v32V480v32h32H544h32V480 352 320H544V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H544V480H384V352z'
      
    ]
  };

  

  
  

  var faUserVneckHairLong = {
    prefix: 'fasl',
    iconName: 'user-vneck-hair-long',
    icon: [
      448,
      512,
      [],
      'e463',
      
      'M224 240c-53 0-96-43-96-96V128l88 0h8l4.8-6.4 16-21.3 20.1 10 3.4 1.7H272h46.7c.9 5.2 1.3 10.5 1.3 16v16c0 53-43 96-96 96zM275.8 80L247.2 65.7l-11.9-6-8 10.7L208 96H133.5c13.2-37.3 48.7-64 90.5-64c35.5 0 66.6 19.3 83.2 48H275.8zM351 112C343.1 48.9 289.3 0 224 0S104.9 48.9 97 112H96v16 16 40L38.4 227.2 32 232v8 32 16H48h80 16V256H128 64v-8l50.4-37.8C136.8 247.2 177.5 272 224 272s87.2-24.8 109.6-61.8L384 248v8H320 304v32h16 80 16V272 240v-8l-6.4-4.8L352 184V144 128 112h-1zM199.7 420.8L224 449.2l24.3-28.3 59-68.8h53.6l42.7 128H44.4L87.1 352h53.6l59 68.8zM384 320H292.6l-47.5 55.4L224 400l-21.1-24.6L155.4 320H64L10.7 480 0 512H33.7 414.3 448l-10.7-32L384 320z'
      
    ]
  };

  

  
  

  var faCircleCaretUp = {
    prefix: 'fasl',
    iconName: 'circle-caret-up',
    icon: [
      512,
      512,
      ["caret-circle-up"],
      'f331',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 320h32H352h32V288v-8L256 160 128 280v8 32zM256 203.9L345.7 288H166.3L256 203.9z'
      
    ]
  };

  
    var faCaretCircleUp = faCircleCaretUp;
  

  
  

  var faUfoBeam = {
    prefix: 'fasl',
    iconName: 'ufo-beam',
    icon: [
      576,
      512,
      [],
      'e048',
      
      'M141.3 166.7l11.3-11.4c-11.3 11.4-11.3 11.4-11.3 11.4l0 0 0 0 .1 .1 .2 .2 .6 .5c.5 .4 1.1 1 1.9 1.6c1.6 1.3 3.8 3 6.7 5.1c5.9 4 14.5 9.1 26.3 14.1C200.7 198.4 236.7 208 288 208s87.3-9.6 110.9-19.6c11.8-5 20.4-10.1 26.3-14.1c2.9-2 5.1-3.7 6.7-5.1c.8-.7 1.4-1.2 1.9-1.6l.6-.5 .2-.2 .1-.1 0 0 0 0s0 0-11.3-11.4l11.3 11.4c2.7-2.7 4.3-6.2 4.7-9.9c.7-8.1 .8-16 .2-23.7c30.2 8 55.1 18.1 73.1 29.4c23.1 14.4 31.2 28.3 31.2 39.1c0 7.9-4.2 17.4-16 27.9c-11.8 10.5-29.7 20.7-53.3 29.5c-47 17.7-113 29-186.7 29s-139.7-11.3-186.7-29c-23.6-8.9-41.5-19-53.3-29.5c-11.8-10.5-16-20-16-27.9c0-10.9 8.2-24.7 31.2-39.1c18-11.3 42.9-21.4 73.1-29.4c-.6 7.7-.5 15.6 .2 23.7c.3 3.7 2 7.3 4.7 9.9zm2.3-68.3c-38.9 8.9-72.5 21.4-97.3 36.9C20.1 151.7 0 173.9 0 201.6c0 20.3 11 37.8 26.7 51.8c15.7 14 37.6 25.9 63.3 35.6c51.4 19.4 121.4 31 198 31s146.5-11.7 198-31c25.7-9.7 47.5-21.6 63.3-35.6c15.7-14 26.7-31.5 26.7-51.8c0-27.7-20.1-49.9-46.3-66.3c-24.8-15.5-58.4-28-97.3-36.9C412.1 39.7 353.1 0 288 0S163.9 39.7 143.5 98.4zM288 32c66.9 0 122 50.8 119.9 115.3l-.8 .6c-4.2 2.9-10.9 6.9-20.7 11.1C366.9 167.2 335.2 176 288 176s-78.9-8.8-98.4-17.1c-9.8-4.2-16.5-8.2-20.7-11.1l-.8-.6C166 82.8 221.1 32 288 32zM117.6 345.3l-28.3-15-7.5 14.1-72 136L2.4 494.7l28.3 15 7.5-14.1 72-136 7.5-14.1zm369-15l-28.3 15 7.5 14.1 72 136 7.5 14.1 28.3-15-7.5-14.1-72-136-7.5-14.1zM288 216l-32 32 32 32 32-32-32-32zM64 200l32 32 32-32L96 168 64 200zm416-32l-32 32 32 32 32-32-32-32z'
      
    ]
  };

  

  
  

  var faSmog = {
    prefix: 'fasl',
    iconName: 'smog',
    icon: [
      640,
      512,
      [],
      'f75f',
      
      'M176 0C96.5 0 32 64.5 32 144V272v16H48 176 299.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496h96 16V272 176c0-61.9-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.7 0-62.5 12.2-85.1 32.3C242.2 12.1 210.5 0 176 0zM64 144C64 82.1 114.1 32 176 32c31.4 0 59.7 12.9 80.1 33.7l12.1 12.4L279.6 65c17.6-20.2 43.5-33 72.4-33c41 0 76.1 25.7 89.8 62l6 15.9 15.5-6.9c10-4.5 21-7 32.7-7c44.2 0 80 35.8 80 80v80H496 462.4h-6.5l-4.7 4.6c-17.3 17-41 27.4-67.2 27.4s-49.9-10.4-67.2-27.4l-4.7-4.6h-6.5H176 64V144zM80 384H64v32H80 208h16V384H208 80zm192 0H256v32h16H624h16V384H624 272zM16 480H0v32H16 368h16V480H368 16zm416 0H416v32h16H560h16V480H560 432z'
      
    ]
  };

  

  
  

  var faBlindsRaised = {
    prefix: 'fasl',
    iconName: 'blinds-raised',
    icon: [
      512,
      512,
      [],
      'f8fd',
      
      'M16 0H0V16 80 96H16 128V418.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V96H496h16V80 16 0H496 16zM32 64V32H480V64H32zm96 400a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM41 160l8-32H16L8 160 0 192H33 96V160H41zm0 96l8-32H16L8 256 0 288H33 96V256H41zm151 0v32H479h33l-8-32-8-32H463l8 32H192zm0-96v32H479h33l-8-32-8-32H463l8 32H192z'
      
    ]
  };

  

  
  

  var faMoneyBills = {
    prefix: 'fasl',
    iconName: 'money-bills',
    icon: [
      640,
      512,
      [],
      'e1f3',
      
      'M608 64v64c-35.3 0-64-28.7-64-64h64zM224 64H512c0 53 43 96 96 96v96c-53 0-96 43-96 96H224c0-53-43-96-96-96V160c53 0 96-43 96-96zM128 288c35.3 0 64 28.7 64 64H128V288zm416 64c0-35.3 28.7-64 64-64v64H544zM192 64c0 35.3-28.7 64-64 64V64h64zM128 32H96V64 352v32h32H608h32V352 64 32H608 128zM368 272a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM32 112V96H0v16V464v16H16 528h16V448H528 32V112z'
      
    ]
  };

  

  
  

  var faFaceTired = {
    prefix: 'fasl',
    iconName: 'face-tired',
    icon: [
      512,
      512,
      [128555,"tired"],
      'f5c8',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 94c26.3 0 52.4 4 77.5 11.9c-10.6-26.1-38.7-43.9-77.5-43.9c-38.1 0-65.4 17.3-76.6 43.6C204.2 353.9 230 350 256 350zm0-64c62.2 0 114 38.8 114 100v22.7L348.6 401l-16.5-5.9C307.7 386.4 282 382 256 382s-51.8 4.5-76.2 13.2L163.3 401 141 409l1-23.7c2.5-60.2 51.2-99.4 114-99.4zM121.8 182l15.9-27.8 13.9 7.9 56 32L231.9 208l-24.3 13.9-56 32-13.9 7.9L121.8 234l13.9-7.9L167.4 208l-31.7-18.1L121.8 182zm254.5 7.9L344.6 208l31.7 18.1 13.9 7.9-15.9 27.8-13.9-7.9-56-32L280.1 208l24.3-13.9 56-32 13.9-7.9L390.2 182l-13.9 7.9z'
      
    ]
  };

  
    var faTired = faFaceTired;
  

  
  

  var faHouseLaptop = {
    prefix: 'fasl',
    iconName: 'house-laptop',
    icon: [
      640,
      512,
      ["laptop-house"],
      'e066',
      
      'M240 3.4l10.1 8.2 216 176 12.4 10.1-20.2 24.8-12.4-10.1L416 188v36H384V162L240 44.6 96 162V384H272v32H80 64V400 188L34.1 212.4 21.7 222.5 1.5 197.7l12.4-10.1 216-176L240 3.4zM192 176h96 16v16 32H272V208H208v64h48 16v32H256 192 176V288 192 176h16zm112 80h16H576h16v16V432v16H560V432 288H336V432v16H304V432 272 256zM256 480H640v32H256V480z'
      
    ]
  };

  
    var faLaptopHouse = faHouseLaptop;
  

  
  

  var faBurst = {
    prefix: 'fasl',
    iconName: 'burst',
    icon: [
      512,
      512,
      [],
      'e4dc',
      
      'M312.8 118.8L273.7 37.1 256 0 238.3 37.1 213 89.8l-13.9 29-27.6-16.5L57.8 34.5 0 0 34.5 57.8l67.8 113.7 16.5 27.6L89.8 213 37.1 238.3 0 256l37.1 17.7 81.7 39.1L88.7 398.3 75 437l38.8-13.7 85.4-30.2 39.1 81.7L256 512l17.7-37.1 39.1-81.7 85.4 30.2L437 437l-13.7-38.8-30.2-85.4 81.7-39.1L512 256l-37.1-17.7-81.7-39.1 30.2-85.4L437 75 398.3 88.7l-85.4 30.2zm71.7 8.6L363 188.5l-9.6 27.1L379.4 228l58.5 28-58.5 28-25.9 12.4 9.6 27.1 21.6 61.1L323.5 363l-27.1-9.6L284 379.4l-28 58.5-28-58.5-12.4-25.9L188.5 363l-61.1 21.6L149 323.5l9.6-27.1L132.6 284 74.2 256l58.5-28 31.6-15.1-18-30.1L92.4 92.4l90.4 53.9 30.1 18L228 132.6l28-58.5 28 58.5 12.4 25.9 27.1-9.6 61.1-21.6z'
      
    ]
  };

  

  
  

  var faIntegral = {
    prefix: 'fasl',
    iconName: 'integral',
    icon: [
      320,
      512,
      [],
      'f667',
      
      'M144 0h16H272h16V16 96v16H256V96 32H176V496v16H160 48 32V496 416 400H64v16 64h80V16 0z'
      
    ]
  };

  

  
  

  var faDiamondTurnRight = {
    prefix: 'fasl',
    iconName: 'diamond-turn-right',
    icon: [
      512,
      512,
      ["directions"],
      'f5eb',
      
      'M22.6 278.6L0 256l22.6-22.6L233.4 22.6 256 0l22.6 22.6L489.4 233.4 512 256l-22.6 22.6L278.6 489.4 256 512l-22.6-22.6L22.6 278.6zM45.3 256L256 466.7 466.7 256 256 45.3 45.3 256zM304 137.4l11.3 11.3 64 64L390.6 224l-11.3 11.3-64 64L304 310.6 281.4 288l11.3-11.3L329.4 240H208v80 16H176V320 224 208h16H329.4l-36.7-36.7L281.4 160 304 137.4z'
      
    ]
  };

  
    var faDirections = faDiamondTurnRight;
  

  
  

  var faSubscript = {
    prefix: 'fasl',
    iconName: 'subscript',
    icon: [
      512,
      512,
      [],
      'f12c',
      
      'M16 64H0V96H16 55.2L157 256 55.2 416H16 0v32H16 64h8.8l4.7-7.4L176 285.8l98.5 154.8 4.7 7.4H288h48 16V416H336 296.8L195 256 296.8 96H336h16V64H336 288h-8.8l-4.7 7.4L176 226.2 77.5 71.4 72.8 64H64 16zM400 320H384v32h16 32V480H400 384v32h16 48 48 16V480H496 464V336 320H448 400z'
      
    ]
  };

  

  
  

  var faGlobeSnow = {
    prefix: 'fasl',
    iconName: 'globe-snow',
    icon: [
      448,
      512,
      [],
      'f7a3',
      
      'M416 224c0 49.2-18.5 94-48.9 128h40.7c25.3-36.3 40.2-80.4 40.2-128C448 100.3 347.7 0 224 0S0 100.3 0 224c0 47.6 14.8 91.7 40.2 128H80.9C50.5 318 32 273.2 32 224C32 118 118 32 224 32s192 86 192 192zM264 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-28.7 68.7L224 137.4l-11.3 11.3-64 64L137.4 224 160 246.6l11.3-11.3L208 198.6v34.7l-59.3 59.3L137.4 304 160 326.6l11.3-11.3L208 278.6V352h32V278.6l36.7 36.7L288 326.6 310.6 304l-11.3-11.3L240 233.4V198.6l36.7 36.7L288 246.6 310.6 224l-11.3-11.3-64-64zM35.8 512H412.2 448l-16-32-48-96H64L16 480 0 512H35.8zm328.4-96l32 64H51.8l32-64H364.2zM336 200a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM104 240a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faScaleUnbalancedFlip = {
    prefix: 'fasl',
    iconName: 'scale-unbalanced-flip',
    icon: [
      640,
      512,
      ["balance-scale-right"],
      'f516',
      
      'M383.3 64c0 6.8-1.1 13.3-3 19.5l136.1 45.4-10.1 30.4L362.5 111.3c-7.6 6.9-16.9 12.1-27.2 14.7V496c0 8.8-7.2 16-16 16h-208-16V480h16 192V126c-23.8-6.1-42.3-25.7-46.9-50.1L122.3 31.2 132.4 .8 258.9 43c8.7-25 32.5-43 60.5-43c35.3 0 64 28.7 64 64zM608 425.4V416H416.1v9.4L470.8 480h82.6L608 425.4zM511.4 254.2L430.9 384H593L511.4 254.2zM127.3 65.8l13.6 21.7L253.4 266.7l2.4 3.9 0 4.6 .1 28.8 0 6.7-4.7 4.7-64 64-4.7 4.7H176 80.1 73.5l-4.7-4.7-64-64L.1 310.6V304 275.2v-4.6l2.4-3.9L113.8 87.6l13.5-21.8zM223.9 288H32.1v9.4L86.8 352h82.6L224 297.4l0-9.4zm-15-32L127.4 126.2 46.9 256h162zm302.3-62.2l13.6 21.7L637.5 394.7l2.5 3.9v4.6V432v6.6l-4.7 4.7-64 64-4.7 4.7H560 464.1h-6.6l-4.7-4.7-64-64-4.7-4.7V432 403.2v-4.6l2.4-3.9L497.8 215.6l13.5-21.8zM319.3 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faBalanceScaleRight = faScaleUnbalancedFlip;
  

  
  

  var faAddressCard = {
    prefix: 'fasl',
    iconName: 'address-card',
    icon: [
      576,
      512,
      [62140,"contact-card","vcard"],
      'f2bb',
      
      'M544 64V448H32V64H544zM32 32H0V64 448v32H32 544h32V448 64 32H544 32zM160 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM135.1 320H248.9l21.3 64H304l-32-96H112L80 384h33.7l21.3-64zM352 160H336v32h16H480h16V160H480 352zm0 64H336v32h16H480h16V224H480 352zm0 64H336v32h16H480h16V288H480 352z'
      
    ]
  };

  
    var faContactCard = faAddressCard;
  
    var faVcard = faAddressCard;
  

  
  

  var faTrashCanPlus = {
    prefix: 'fasl',
    iconName: 'trash-can-plus',
    icon: [
      448,
      512,
      [],
      'e2ac',
      
      'M160 0h-8.9l-4.7 7.5L111.1 64H64 32 0V96H32V480v32H64 384h32V480 96h32V64H416 384 336.9L301.6 7.5 296.9 0H288 160zM299.1 64H148.9l20-32H279.1l20 32zM64 480V96H384V480H64zM240 192H208v16 64H144 128v32h16 64v64 16h32V368 304h64 16V272H304 240V208 192z'
      
    ]
  };

  

  
  

  var faRegistered = {
    prefix: 'fasl',
    iconName: 'registered',
    icon: [
      512,
      512,
      [174],
      'f25d',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128v16V272v96 16h32V368 288h71l58.7 96h37.5L297.9 283.7C329.4 272.9 352 243.1 352 208c0-44.2-35.8-80-80-80H176 160zm32 128V160h80c26.5 0 48 21.5 48 48s-21.5 48-48 48H192z'
      
    ]
  };

  

  
  

  var faGaugeLow = {
    prefix: 'fasl',
    iconName: 'gauge-low',
    icon: [
      512,
      512,
      ["tachometer-alt-slow"],
      'f627',
      
      'M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm24 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-32 0c0-18.6 7.9-35.3 20.5-47L129.9 151.6l-7.6-14.1 28.2-15.2 7.6 14.1 82.6 153.4c4.9-1.2 10-1.8 15.3-1.8c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm24 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM120 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z'
      
    ]
  };

  
    var faTachometerAltSlow = faGaugeLow;
  

  
  

  var faBomb = {
    prefix: 'fasl',
    iconName: 'bomb',
    icon: [
      512,
      512,
      [128163],
      'f1e2',
      
      'M464 0V16 48h32 16V80H496 464v32 16H432V112 80H400 384V48h16 32V16 0h32zM304 128l-2.9 2.9-14.4 14.4-19.1-6.9C249.1 131.7 229 128 208 128c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-21-3.7-41.1-10.4-59.7l-6.9-19.1 14.4-14.4L384 208l-80-80zM406.6 230.6l-2.9 2.9c7.9 22 12.2 45.7 12.2 70.5c0 114.9-93.1 208-208 208S0 418.9 0 304S93.1 96 208 96c24.7 0 48.5 4.3 70.5 12.3l2.9-2.9L304 82.7l22.6 22.6 28.7 28.7 17.4-17.4L384 105.4 406.6 128l-11.3 11.3-17.4 17.4 28.7 28.7L429.3 208l-22.6 22.6zM96 296v8H64v-8c0-75.1 60.9-136 136-136h8v32h-8c-57.4 0-104 46.6-104 104z'
      
    ]
  };

  

  
  

  var faTemperatureEmpty = {
    prefix: 'fasl',
    iconName: 'temperature-empty',
    icon: [
      320,
      512,
      ["temperature-0","thermometer-0","thermometer-empty"],
      'f2cb',
      
      'M85.3 284.5L96 275V260.7 32H224V260.7 275l10.7 9.5c23 20.6 37.3 50.3 37.3 83.5c0 61.9-50.1 112-112 112S48 429.9 48 368c0-33.2 14.4-62.9 37.3-83.5zM256 0H224 96 64V32 260.7C34.5 287.1 16 325.4 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-42.6-18.5-81-48-107.3V32 0zM128 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 96 368a64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faTemperature0 = faTemperatureEmpty;
  
    var faThermometer0 = faTemperatureEmpty;
  
    var faThermometerEmpty = faTemperatureEmpty;
  

  
  

  var faHillAvalanche = {
    prefix: 'fasl',
    iconName: 'hill-avalanche',
    icon: [
      576,
      512,
      [],
      'e507',
      
      'M144.2 89.8C147.2 66.2 167.4 48 191.7 48c13.1 0 24.9 5.2 33.6 13.8L235.6 72l11.2-9.3C257.8 53.5 272 48 287.5 48c35.2 0 63.9 28.6 63.9 64c0 6-.8 11.7-2.3 17.2l-3.9 13.9 13.4 5.3c23.8 9.3 40.6 32.5 40.6 59.6c0 14.4-4.7 27.7-12.8 38.4l-9.6 12.8 25.6 19.2 9.6-12.8c12-16 19.2-36 19.2-57.6c0-35.9-19.6-67.1-48.7-83.6c.5-4.1 .8-8.2 .8-12.4c0-53-42.9-96-95.9-96c-18.4 0-35.7 5.2-50.3 14.3c-12.9-9-28.6-14.3-45.5-14.3c-44.1 0-79.9 35.8-79.9 80v6.6l4.7 4.7 308.2 308c30.6 30.5 80.1 30.5 110.6 0l4-4c28.3-28.3 28.3-74.3 0-102.6s-74.3-28.3-102.6 0l22.6 22.6c15.8-15.8 41.5-15.8 57.4 0s15.8 41.5 0 57.4l-4 4c-18.1 18.1-47.3 18.1-65.4 0L144.2 89.8zm303 6.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm31.9 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM27.3 68.7L0 41.3V80 496v16H16 431.2h38.6l-27.3-27.3L27.3 68.7zM32 480V118.7L392.6 480H32z'
      
    ]
  };

  

  
  

  var faPlaneEngines = {
    prefix: 'fasl',
    iconName: 'plane-engines',
    icon: [
      576,
      512,
      [9992,"plane-alt"],
      'f3de',
      
      'M576 256c0-13.4-5.7-25.2-13.3-34.8s-17.7-17.6-28.4-24c-21-12.8-47.3-21.2-68-21.2l-100.5 0-9.1-16H368h16V144 80 64H368 301.9l-32-55.9L265.3 0H256 160 138.8l5.8 20.4L189.1 176 144 176l-43.2-57.6L96 112H88 24 3.5l5 19.9 23 92.1C14.1 224.3 0 238.5 0 256s14.1 31.7 31.5 32l-23 92.1L3.5 400H24 88h8l4.8-6.4L144 336h45.1L144.6 491.6 138.8 512H160l96 0h9.3l4.6-8.1 32-55.9H368h16V432 368 352H368 356.7l9.1-16H466.3c20.6 0 46.8-8.1 67.9-20.8C554.4 303.1 576 282.9 576 256zM338.4 384H352v32H320.1l18.3-32zM352 128H338.4L320.1 96H352v32zm114.3 80c13.5 0 34.1 6.1 51.3 16.6c8.5 5.2 15.4 10.9 20 16.7c4.6 5.8 6.3 10.7 6.3 14.8c0 9.1-8.2 20.9-26.3 31.8c-17.2 10.3-37.8 16.2-51.4 16.2H356.6h-9.3l-4.6 8.1L246.7 480l-65.5 0 44.5-155.6 5.8-20.4-21.2 0H136h-8l-4.8 6.4L80 368H44.5l27-108.1 1-3.9-1-3.9L44.5 144H80l43.2 57.6L128 208h8l74.3 0h21.2l-5.8-20.4L181.2 32l65.5 0 96 167.9 4.6 8.1h9.3l109.7 0z'
      
    ]
  };

  
    var faPlaneAlt = faPlaneEngines;
  

  
  

  var faClockEightThirty = {
    prefix: 'fasl',
    iconName: 'clock-eight-thirty',
    icon: [
      512,
      512,
      [],
      'e346',
      
      'M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400V285.9l-71.1 47.4-13.3 8.9-17.8-26.6 13.3-8.9 96-64L272 226.1V256 400v16H240V400z'
      
    ]
  };

  

  
  

  var faPause = {
    prefix: 'fasl',
    iconName: 'pause',
    icon: [
      320,
      512,
      [9208],
      'f04c',
      
      'M32 96V416h80V96H32zM0 64H32h80 32V96 416v32H112 32 0V416 96 64zM208 96V416h80V96H208zM176 64h32 80 32V96 416v32H288 208 176V416 96 64z'
      
    ]
  };

  

  
  

  var faLocationPinLock = {
    prefix: 'fasl',
    iconName: 'location-pin-lock',
    icon: [
      512,
      512,
      [],
      'e51f',
      
      'M197.6 457.1c16.1-19 37.1-44.7 58.4-73.5l0 52.7c-16.4 20.7-31.3 38.6-42.7 51.7C200.2 503.1 192 512 192 512s-8.2-8.9-21.3-24.1C120.7 429.9 0 280.8 0 192C0 86 86 0 192 0c95.7 0 175 70 189.6 161.5c-10.9 1.8-21.3 5.2-30.9 9.9C340.6 92.8 273.4 32 192 32C103.6 32 32 103.6 32 192c0 20.2 9.1 48.6 26.5 82.7c16.9 33.2 39.9 68.2 63.4 100.5c23.4 32.2 46.9 61 64.5 81.9c1.9 2.3 3.8 4.5 5.6 6.6c1.8-2.1 3.6-4.3 5.6-6.6zM144 192a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm208-48c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32v32V480v32H480 320 288V480 352 320h32V272zm0 80V480H480V352H320z'
      
    ]
  };

  

  
  

  var faStrawberry = {
    prefix: 'fasl',
    iconName: 'strawberry',
    icon: [
      512,
      512,
      [],
      'e32b',
      
      'M464.6 3.6l30.8 8.8C484.1 52 460.7 87.1 428.5 112.9l-4.3 3.4c4.2 .7 8.3 1.5 12.3 2.5c13.5 3.4 26.7 8.9 37.9 15.6c10.9 6.6 21.2 15.1 27.3 25.4l5.8 9.7-7.3 8.7L488 168c12.3 10.2 12.3 10.2 12.3 10.2l0 0 0 0 0 0-.1 .2-.4 .5c-.4 .4-.9 1-1.5 1.7c-1.3 1.5-3.2 3.5-5.5 5.9c-4.7 4.8-11.5 11.3-19.6 17.8c-7.3 5.8-16.4 12.2-26.6 17.4c-4.1-5.2-8.5-10.2-13.3-15l-9.8-9.8c10-3.6 20.2-10 29.7-17.6c5.1-4.1 9.7-8.3 13.3-11.8c-2.3-1.9-5.1-3.9-8.4-5.9c-8.3-5-18.6-9.3-29.2-12c-21.8-5.5-39.3-3.2-48.2 4.4l-22.7-22.7c7.6-8.9 9.9-26.4 4.4-48.2c-2.7-10.7-7-20.9-12-29.2c-2-3.3-3.9-6.1-5.9-8.4c-3.6 3.6-7.7 8.2-11.8 13.3c-7.6 9.4-14 19.7-17.6 29.7l-9.8-9.8c-4.8-4.8-9.8-9.2-15-13.3c5.2-10.2 11.6-19.3 17.4-26.6c6.5-8.1 13-14.9 17.8-19.6c2.4-2.4 4.5-4.2 5.9-5.5c.7-.7 1.3-1.2 1.7-1.5l.5-.4 .2-.1 0 0 0 0 0 0s0 0 10.2 12.3L333.8 11.7l8.7-7.3 9.7 5.8c10.2 6.1 18.8 16.4 25.4 27.3c6.7 11.2 12.2 24.4 15.6 37.9c1.7 6.8 3 14.2 3.6 21.8l11.7-9.4c27-21.6 46.6-51 56.1-84.3zM32 336V480H176c166.1 0 240-88.5 240-160c0-24.6-9.4-49.1-28.1-67.9l-128-128c-18.7-18.7-43.1-28.1-67.7-28.1C120.7 96 32 170 32 336zM0 336C0 160 96.2 64 192.2 64c32.7 .1 65.3 12.6 90.3 37.5l128 128c25 25 37.5 57.8 37.5 90.5c0 96-96 192-272 192H32 0V480 336zM180.8 188.8c-11.9 11.9-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6s2.3 23.3-9.6 35.2zm-24 88c-11.9 11.9-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6s2.3 23.3-9.6 35.2zm57.6 20.8s2.3 23.3-9.6 35.2s-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6zm46.4 83.2c-11.9 11.9-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6s2.3 23.3-9.6 35.2zM134.4 329.6s2.3 23.3-9.6 35.2s-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6zm38.4 83.2c-11.9 11.9-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6s2.3 23.3-9.6 35.2zm73.6-195.2s2.3 23.3-9.6 35.2s-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6zm38.4 83.2c-11.9 11.9-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6s2.3 23.3-9.6 35.2zm73.6 20.8s2.3 23.3-9.6 35.2s-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6z'
      
    ]
  };

  

  
  

  var faArrowLeftFromLine = {
    prefix: 'fasl',
    iconName: 'arrow-left-from-line',
    icon: [
      448,
      512,
      [8612,"arrow-from-right"],
      'f344',
      
      'M12.7 244.7L1.4 256l11.3 11.3 128 128L152 406.6 174.6 384l-11.3-11.3L62.6 272 336 272l16 0 0-32-16 0L62.6 240 163.3 139.3 174.6 128 152 105.4l-11.3 11.3-128 128zM416 432l0 16 32 0 0-16 0-352 0-16-32 0 0 16 0 352z'
      
    ]
  };

  
    var faArrowFromRight = faArrowLeftFromLine;
  

  
  

  var faSpa = {
    prefix: 'fasl',
    iconName: 'spa',
    icon: [
      576,
      512,
      [],
      'f5bb',
      
      'M288 68.3c20.7 21.2 61.9 71.2 83 150c9-6.5 18.5-12.5 28.2-18C372 107.9 319.6 53.5 301.9 37.2c-3.8-3.5-8.8-5.2-13.9-5.2s-10.1 1.7-13.9 5.2c-17.6 16.3-70 70.7-97.2 163.1c9.7 5.5 19.1 11.5 28.2 18c21.1-78.8 62.3-128.8 83-150zM0 192c0 10.8 .6 21.5 1.8 32C15.3 346.5 113.3 454.4 234.5 476c14.5 2.6 29.4 4 44.5 4h18c15.1 0 30-1.4 44.5-4c121.2-21.7 219.2-129.5 232.8-252c1.2-10.5 1.8-21.2 1.8-32c-2.9 0-5.7 0-8.6 0c-7.8 0-15.6-.1-23.4 .2c-80.7 2.5-152.9 39.1-202.5 95.9c-23.2 26.5-41.5 57.4-53.5 91.3c-12-33.9-30.3-64.8-53.5-91.3C184.9 231.3 112.7 194.7 32 192.1c-7.8-.2-15.6-.2-23.4-.2c-2.9 0-5.7 0-8.6 0zM234.5 341.5c19.5 31.3 32.2 67.3 36.2 105.9c-12.3-.8-24.4-2.5-36.2-5C129.1 420 47.6 332.7 34 224.2c84.7 3.7 158.4 49.6 200.5 117.3zm106.9 0C383.6 273.9 457.3 227.9 542 224.2C528.4 332.7 446.9 420 341.5 442.4c-11.8 2.5-23.9 4.2-36.2 5c3.9-38.6 16.7-74.6 36.2-105.9z'
      
    ]
  };

  

  
  

  var faScroll = {
    prefix: 'fasl',
    iconName: 'scroll',
    icon: [
      576,
      512,
      [128220],
      'f70e',
      
      'M32 112c0-26.5 21.5-48 48-48s48 21.5 48 48V400c0 44.2 35.8 80 80 80H504c39.8 0 72-32.2 72-72V328 312H560h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.6-.6-.6-.6-.6-.6-.6-.6H534h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H527h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H519h-.6-.6-.6-.6H516h-.6-.6-.6-.6H513h-.6-.6-.6-.6H510h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H503h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H495h-.6-.6-.6-.6-.6-.6H491h-.6-.6-.6-.6-.6-.6-.6-.6H486h-.6-.6-.6-.6-.5-.5-.5-.5-.5-.5H480h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H474h-.5H473h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H465h-.5H464h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H450h-.5H449h-.5H448h-.5H447h-.5H446h-.5H445h-.5H444h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H422h-.5H421h-.5H420h-.5H419h-.5H418h-.5H417h-.5H416h-.5H415h-.5H414h-.5H413h-.5H412h-.5H411h-.5H410h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H388h-.5H387h-.5H386h-.5H385h-.5H384h-.5H383h-.5H382h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H368h-.5H367h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H359h-.5H358h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H352h-.5-.5-.5-.5-.5-.5-.5-.6-.6-.6H346h-.6-.6-.6-.6-.6-.6-.6-.6H341h-.6-.6-.6-.6-.6-.6H337h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H329h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H322h-.6-.6-.6-.6H319h-.6-.6-.6-.6H316h-.6-.6-.6-.6H313h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H305h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H298h-.6-.6-.6-.6-.6-.6-.6-.6-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H272 256v16 72c0 26.5-21.5 48-48 48s-48-21.5-48-48V112c0-18-6-34.6-16-48H400c26.5 0 48 21.5 48 48V288h32V112c0-44.2-35.8-80-80-80H80C35.8 32 0 67.8 0 112v96 16H16 96V192H32V112zM504 448H272c10-13.4 16-30 16-48V344h.3 .7 .7 .7 .7 .7 .7 .7 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .7 .7 .7 .7 .7 .7 .3v64c0 22.1-17.9 40-40 40z'
      
    ]
  };

  

  
  

  var faSquareF = {
    prefix: 'fasl',
    iconName: 'square-f',
    icon: [
      448,
      512,
      [],
      'e270',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm144 96H304h16v32H304 160v80H272h16v32H272 160v96 16H128V368 256 144 128h16z'
      
    ]
  };

  

  
  

  var faBoxOpen = {
    prefix: 'fasl',
    iconName: 'box-open',
    icon: [
      640,
      512,
      [],
      'f49e',
      
      'M76.6 48.1L320 77.2 563.4 48.1l11.9-1.4 4.7 11 48 112 7.5 17.4-18.4 4.4-200 48-10.5 2.5-6.3-8.8L320 120.9 239.7 233.3l-6.3 8.8-10.5-2.5-200-48L4.5 187.1 12 169.7l48-112 4.7-11 11.9 1.4zM48.8 164.9l171.1 41.1L291.3 106 84.7 81.3 48.8 164.9zM544 239l32-8V416L320 480 64 416V231l32 8V391l208 52V224h32V443l208-52V239zM555.3 81.3L348.7 106l71.4 99.9 171.1-41.1L555.3 81.3z'
      
    ]
  };

  

  
  

  var faKerning = {
    prefix: 'fasl',
    iconName: 'kerning',
    icon: [
      640,
      512,
      [],
      'f86f',
      
      'M417.5 9.2l-224 480 29 13.5 224-480-29-13.5zM145.4 406.6l4.3 9.4h20.6l4.3-9.4L316.1 96H280.9L160 361.4 39.1 96H3.9L145.4 406.6zm320-301.2L325 416h35.1l36.2-80H563.7l36.2 80H635L494.6 105.4 490.3 96H469.7l-4.2 9.4zM480 150.8L549.2 304H410.8L480 150.8z'
      
    ]
  };

  

  
  

  var faLightEmergencyOn = {
    prefix: 'fasl',
    iconName: 'light-emergency-on',
    icon: [
      640,
      512,
      [],
      'e420',
      
      'M55.2 33.7L40.8 26.5 26.5 55.2l14.3 7.2 64 32 14.3 7.2 14.3-28.6-14.3-7.2-64-32zm544 28.6l14.3-7.2L599.2 26.5l-14.3 7.2-64 32-14.3 7.2 14.3 28.6 14.3-7.2 64-32zM16 192H0v32H16 80 96V192H80 16zm544 0H544v32h16 64 16V192H624 560zm-112 0V320h32V192c0-88.4-71.6-160-160-160s-160 71.6-160 160V320h32V192c0-70.7 57.3-128 128-128s128 57.3 128 128zM128 448V384H512v64H128zM96 352v32 64 32h32H512h32V448 384 352H512 128 96zM320 128V96c-53 0-96 43-96 96h32c0-35.3 28.7-64 64-64z'
      
    ]
  };

  

  
  

  var faSquareArrowUpRight = {
    prefix: 'fasl',
    iconName: 'square-arrow-up-right',
    icon: [
      448,
      512,
      ["external-link-square"],
      'f14c',
      
      'M416 64V448H32V64H416zm32-32H416 32 0V64 448v32H32 416h32V448 64 32zM304 160H168 152v32h16 97.4L132.7 324.7 121.4 336 144 358.6l11.3-11.3L288 214.6V320v16h32V320 176 160H304z'
      
    ]
  };

  
    var faExternalLinkSquare = faSquareArrowUpRight;
  

  
  

  var faBanjo = {
    prefix: 'fasl',
    iconName: 'banjo',
    icon: [
      512,
      512,
      [129685],
      'f8a3',
      
      'M431 107l-33.4 7.4L405 81 446.7 44 468 65.3 431 107zM448 0L376 64l-14.1 63.5-63 63c-25.2-20.8-56.6-34.4-90.9-37.7V144 128H176v16 8.8c-34.4 3.2-65.8 16.9-90.9 37.7l-6.2-6.2L67.5 172.9 44.9 195.5l11.3 11.3 6.2 6.2C41.6 238.2 28 269.6 24.8 304H16 0v32H16h8.8c3.2 34.4 16.9 65.8 37.7 90.9l-6.2 6.2L44.9 444.5l22.6 22.6 11.3-11.3 6.2-6.2c25.2 20.8 56.6 34.4 90.9 37.7V496v16h32V496v-8.8c34.4-3.2 65.8-16.9 90.9-37.7l6.2 6.2 11.3 11.3 22.6-22.6-11.3-11.3-6.2-6.2c20.8-25.2 34.4-56.6 37.7-90.9H368h16V304H368h-8.8c-3.2-34.4-16.9-65.8-37.7-90.9l63-62.9L448 136l64-72L448 0zM192 184a136 136 0 1 1 0 272 136 136 0 1 1 0-272zM147.3 316.7L136 305.4 113.4 328l11.3 11.3 48 48L184 398.6 206.6 376l-11.3-11.3-48-48z'
      
    ]
  };

  

  
  

  var faFileImport = {
    prefix: 'fasl',
    iconName: 'file-import',
    icon: [
      512,
      512,
      ["arrow-right-to-file"],
      'f56f',
      
      'M336 192H480V480H160V368H128V480v32h32H480h32V480 152L360 0H160 128V32 256h32V32H320V176v16h16zm138.7-32H352V37.3L474.7 160zM283.3 212.7L272 201.4 249.4 224l11.3 11.3L329.4 304H16 0v32H16 329.4l-68.7 68.7L249.4 416 272 438.6l11.3-11.3 96-96L390.6 320l-11.3-11.3-96-96z'
      
    ]
  };

  
    var faArrowRightToFile = faFileImport;
  

  
  

  var faCommentPen = {
    prefix: 'fasl',
    iconName: 'comment-pen',
    icon: [
      512,
      512,
      ["comment-edit"],
      'f4ae',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM294.1 189.3l12.5 12.5-13.1 13.1L281 202.4l13.1-13.1zm-93.4 93.4L258.4 225l12.5 12.5-57.7 57.7-14.8 2.3 2.3-14.8zM329.3 179.2L294.1 144 170.7 267.5l-5.5 35.2L160 335.9l33.2-5.2 35.3-5.5L329.3 224.4l22.6-22.6-22.6-22.6z'
      
    ]
  };

  
    var faCommentEdit = faCommentPen;
  

  
  

  var faCircleArrowDown = {
    prefix: 'fasl',
    iconName: 'circle-arrow-down',
    icon: [
      512,
      512,
      ["arrow-circle-down"],
      'f0ab',
      
      'M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm11.3-132.7L256 390.6l-11.3-11.3-96-96L137.4 272 160 249.4l11.3 11.3L240 329.4V144 128h32v16V329.4l68.7-68.7L352 249.4 374.6 272l-11.3 11.3-96 96z'
      
    ]
  };

  
    var faArrowCircleDown = faCircleArrowDown;
  

  
  

  var faCameraRetro = {
    prefix: 'fasl',
    iconName: 'camera-retro',
    icon: [
      512,
      512,
      [128247],
      'f083',
      
      'M192 112H32V224H145.1c22.1-38.3 63.5-64 110.9-64s88.7 25.7 110.9 64H480V64H266.7l-55.5 41.6c-5.5 4.2-12.3 6.4-19.2 6.4zM32 256V448H480V256H380c2.6 10.2 4 21 4 32c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-11 1.4-21.8 4-32H32zM192 80l64-48H480h32V64 448v32H480 32 0V448 112 80H32 192zM352 288a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM64 32h96V64H64V32z'
      
    ]
  };

  

  
  

  var faFilterCircleDollar = {
    prefix: 'fasl',
    iconName: 'filter-circle-dollar',
    icon: [
      576,
      512,
      ["funnel-dollar"],
      'f662',
      
      'M224 276.2V288v65.5L256.5 382c1.5 19 6 37.1 13 53.9L192 368V288L0 64V32 0H32 480h32V32 64L399.8 194.9c-23.4 4.3-45.2 13.3-64.3 25.9L480 52.2V32H32V52.2l184.3 215 7.7 9zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM408.8 335.4c-.4 .7-.9 1.6-.8 3.6l0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8 16H416v-16V438.1c-8.6-1.7-16.7-4.3-23.7-6.6l0 0 0 0c-1.7-.6-3.4-1.1-5-1.6L372 425.2l9.5-30.6 15.3 4.8c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3V288 272h32v16 9.4c6.3 .9 12.3 2.3 17.9 3.7l15.5 3.9-7.7 31.1-15.5-3.9c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4z'
      
    ]
  };

  
    var faFunnelDollar = faFilterCircleDollar;
  

  
  

  var faBinaryLock = {
    prefix: 'fasl',
    iconName: 'binary-lock',
    icon: [
      640,
      512,
      [],
      'e33d',
      
      'M224 0V32h16 48V192H240 224v32h16 64 64 16V192H368 320V16 0H304 240 224zM0 288v32H16 64V480H16 0v32H16 80h64 16V480H144 96V304 288H80 16 0zM16 0H0V16 208v16H16 176h16V208 16 0H176 16zM32 192V32H160V192H32zm160 96v16V496v16h16H368h16V496 304 288H368 208 192zm32 32H352V480H224V320zm304-96c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48H416v32V480v32h32H608h32V480 352 320H608V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z'
      
    ]
  };

  

  
  

  var faStarShooting = {
    prefix: 'fasl',
    iconName: 'star-shooting',
    icon: [
      512,
      512,
      [127776],
      'e036',
      
      'M307.3 35.3l-56 56L240 102.6 217.4 80l11.3-11.3 56-56L296 1.4 318.6 24 307.3 35.3zm192 0l-152 152L336 198.6 313.4 176l11.3-11.3 152-152L488 1.4 510.6 24 499.3 35.3zm0 192l-56 56L432 294.6 409.4 272l11.3-11.3 56-56L488 193.4 510.6 216l-11.3 11.3zm-288-47.2l41.9 85L347 278.8l39.9 5.8-28.9 28.1-67.9 66.2 16 93.4L313 512l-35.7-18.8-83.9-44.1-83.9 44.1L73.9 512l6.8-39.7 16-93.4L28.9 312.7 0 284.6l39.9-5.8 93.8-13.6 41.9-85L193.5 144l17.8 36.2zm37.3 116.7L232 294.4l-7.4-15.1-31.1-63-31.1 63-7.4 15.1-16.6 2.4L68.8 306.9l50.3 49 12 11.7-2.8 16.6-11.9 69.2 62.2-32.7 14.9-7.8 14.9 7.8 62.2 32.7-11.9-69.2-2.8-16.6 12-11.7 50.3-49-69.5-10.1z'
      
    ]
  };

  

  
  

  var faPersonSkating = {
    prefix: 'fasl',
    iconName: 'person-skating',
    icon: [
      448,
      512,
      ["skating"],
      'f7c5',
      
      'M392 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 392 0zM135.2 478.3l-32 16-10.3 5.2-8.2-8.2-72-72L1.4 408 24 385.4l11.3 11.3 63.8 63.8 21.7-10.8 14.3-7.2 14.3 28.6-14.3 7.2zm284.2-26l-3.9 15.5-8 32-3 12.1H392 288 272V480h16 91.5l5-19.9 3.9-15.5 31 7.8zM274.7 144H112 96V112h16H320h6.6l4.7 4.7 32 32 4.7 4.7V160v24 9.1l-7.8 4.7L252.8 262.2l62.5 62.5 4.7 4.7V336v96 16H288V432 342.6l-70.5-70.5c-11.2-11.2-17.5-26.4-17.5-42.3c0-18.8 8.9-36.5 23.9-47.8L274.7 144zm45 6.3l-76.5 57.4c-7 5.2-11.1 13.5-11.1 22.2c0 2.4 .3 4.7 .9 6.9L336 174.9v-8.3l-16.4-16.4zM180.8 276.6c3.9 6.6 8.7 12.8 14.2 18.3l6.4 6.4-94.1 94.1L96 406.6 73.4 384l11.3-11.3 96.1-96.1z'
      
    ]
  };

  
    var faSkating = faPersonSkating;
  

  
  

  var faSuitcase = {
    prefix: 'fasl',
    iconName: 'suitcase',
    icon: [
      512,
      512,
      [129523],
      'f0f2',
      
      'M144 0H128V16 96H32 0v32V448v32H32 480h32V448 128 96H480 384V16 0H368 144zM352 96H160V32H352V96zM144 128H368h16V448H128V128h16zM32 128H96V448H32V128zM480 448H416V128h64V448z'
      
    ]
  };

  

  
  

  var faReplyAll = {
    prefix: 'fasl',
    iconName: 'reply-all',
    icon: [
      576,
      512,
      ["mail-reply-all"],
      'f122',
      
      'M202.8 65.8L214.6 55 193 31.4 181.2 42.2l-168 154L.3 208l12.9 11.8 168 154L193 384.6 214.6 361l-11.8-10.8L47.7 208 202.8 65.8zM448 480s27-10.1 56.2-33.4C538.5 419.1 576 373.2 576 304c0-97.2-78.8-176-176-176H352 320V96 64 32H288L119.7 186.3 96 208l23.7 21.7L288 384h32V352 320 288h32 16c61.9 0 112 50.1 112 112c0 9.9-1.4 19-3.5 27.4C468.2 459.8 448 480 448 480zm96-176c0 38.2-13.9 67.8-32.1 90.3C508.9 317.4 445.6 256 368 256H320 288v32 52.6L143.4 208 288 75.4V128v32h32 80c79.5 0 144 64.5 144 144z'
      
    ]
  };

  
    var faMailReplyAll = faReplyAll;
  

  
  

  var faCrystalBall = {
    prefix: 'fasl',
    iconName: 'crystal-ball',
    icon: [
      448,
      512,
      [],
      'e362',
      
      'M416 224c0 49.2-18.5 94-48.9 128h40.7c25.3-36.3 40.2-80.4 40.2-128C448 100.3 347.7 0 224 0S0 100.3 0 224c0 47.6 14.8 91.7 40.2 128H80.9C50.5 318 32 273.2 32 224C32 118 118 32 224 32s192 86 192 192zM34.9 512H413.1 448l-14-32-42-96H56L14 480 0 512H34.9zm336.1-96l28 64H48.9l28-64H371.1zM304 144H272v16 48H224 208v32h16 48v48 16h32V288 240h48 16V208H352 304V160 144zM160 96H128v16 16H112 96v32h16 16v16 16h32V176 160h16 16V128H176 160V112 96z'
      
    ]
  };

  

  
  

  var faCertificate = {
    prefix: 'fasl',
    iconName: 'certificate',
    icon: [
      512,
      512,
      [],
      'f0a3',
      
      'M256 57.2L213.5 21.8 187.4 0 175.7 31.9l-19.1 52-54.5-9.5L68.6 68.6l5.8 33.5 9.5 54.5-52 19.1L0 187.4l21.8 26.1L57.2 256 21.8 298.5 0 324.6l31.9 11.7 52 19.1-9.5 54.5-5.8 33.5 33.5-5.8 54.5-9.5 19.1 52L187.4 512l26.1-21.8L256 454.8l42.5 35.5L324.6 512l11.7-31.9 19.1-52 54.5 9.5 33.5 5.8-5.8-33.5-9.5-54.5 52-19.1L512 324.6l-21.8-26.1L454.8 256l35.5-42.5L512 187.4l-31.9-11.7-52-19.1 9.5-54.5 5.8-33.5-33.5 5.8-54.5 9.5-19.1-52L324.6 0 298.5 21.8 256 57.2zm54.2-3.6l15.1 41.2 9.2 25.1 26.3-4.6 43.3-7.5-7.5 43.3-4.6 26.3 25.1 9.2 41.2 15.1-28.1 33.7L413.1 256l17.1 20.5 28.1 33.7-41.2 15.1-25.1 9.2 4.6 26.3 7.5 43.3-43.3-7.5-26.3-4.6-9.2 25.1-15.1 41.2-33.7-28.1L256 413.1l-20.5 17.1-33.7 28.1-15.1-41.2-9.2-25.1-26.3 4.6-43.3 7.5 7.5-43.3 4.6-26.3-25.1-9.2L53.7 310.2l28.1-33.7L98.9 256 81.8 235.5 53.7 201.8l41.2-15.1 25.1-9.2-4.6-26.3-7.5-43.3 43.3 7.5 26.3 4.6 9.2-25.1 15.1-41.2 33.7 28.1L256 98.9l20.5-17.1 33.7-28.1z'
      
    ]
  };

  

  
  

  var faTentArrowDownToLine = {
    prefix: 'fasl',
    iconName: 'tent-arrow-down-to-line',
    icon: [
      640,
      512,
      [],
      'e57e',
      
      'M254.6 129.1l-21.5-23.7-11.8 10.8L160 171.8 160 16V0H128V16l0 155.8L66.8 116.2 54.9 105.4 33.4 129.1l11.8 10.8 88 80 10.8 9.8 10.8-9.8 88-80 11.8-10.8zM0 480v32H16 624h16V480H624 16 0zM192 256L164.6 448h32.3l24.8-173.3L368 177.1V287.7c0 .2 0 .4 0 .6V448h32V345.8L461.3 448h37.3l-4.9-8.2L400 283.6V177.1l146.3 97.6L571.1 448h32.3L576 256 384 128 192 256z'
      
    ]
  };

  

  
  

  var faArrowDownLong = {
    prefix: 'fasl',
    iconName: 'arrow-down-long',
    icon: [
      384,
      512,
      ["long-arrow-down"],
      'f175',
      
      'M180.7 500.7L192 512l11.3-11.3 144-144 11.3-11.3L336 322.7l-11.3 11.3L208 450.7 208 16l0-16L176 0l0 16 0 434.7L59.3 334.1 48 322.7 25.4 345.4l11.3 11.3 144 144z'
      
    ]
  };

  
    var faLongArrowDown = faArrowDownLong;
  

  
  

  var faUpToBracket = {
    prefix: 'fasl',
    iconName: 'up-to-bracket',
    icon: [
      448,
      512,
      [],
      'e66e',
      
      'M272 368l0-32 32 0 48 0 0-17.7L224 203.1 96 318.3 96 336l48 0 32 0 0 32 0 112 96 0 0-112zm112 0l-32 0-16 0-32 0 0 32 0 80 0 32-32 0-96 0-32 0 0-32 0-80 0-32-32 0-16 0-32 0 0-32 0-32L224 160 384 304l0 32 0 32zM32 176l0 16L0 192l0-16L0 16 0 0 16 0 432 0l16 0 0 16 0 160 0 16-32 0 0-16 0-144L32 32l0 144z'
      
    ]
  };

  

  
  

  var faUserTie = {
    prefix: 'fasl',
    iconName: 'user-tie',
    icon: [
      448,
      512,
      [],
      'f508',
      
      'M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm96 176H176v32h16 9.8l-19.9 59.8L144 320H64L10.7 480 0 512H33.7 204.2h39.6H414.3 448l-10.7-32L384 320H304l-37.9 75.8L246.2 336H256h16V304H256 224 192zm14.1 140.2l-4-8L224 370.6l21.9 65.6-4 8L224 480l0 0 0 0-17.9-35.8zM259.8 480l64-128h37.2l42.7 128H259.8zm-71.6 0H44.4L87.1 352h37.2l64 128z'
      
    ]
  };

  

  
  

  var faSquarePersonConfined = {
    prefix: 'fasl',
    iconName: 'square-person-confined',
    icon: [
      448,
      512,
      [],
      'e577',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM296 192h40 16v16V360c0 30.9-25.1 56-56 56c-25.1 0-48.8-11.5-64.4-31.3l-53.5-68.2-52.2 91.4L118 421.8 90.2 406l7.9-13.9 64-112 26.5-1.9L240 343.6V248v-6.6l4.7-4.7 40-40 4.7-4.7H296zm24 168V224H302.6L272 254.6V360c0 13.3 10.7 24 24 24s24-10.7 24-24zM232 152a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z'
      
    ]
  };

  

  
  

  var faViruses = {
    prefix: 'fasl',
    iconName: 'viruses',
    icon: [
      640,
      512,
      [],
      'e076',
      
      'M344.7 73.2L318.2 99.7C293 124.9 310 168 345.6 168H384v48H345.6c-35.6 0-52.6 43.1-27.4 68.3l26.5 26.5-33.9 33.9-26.5-26.5C259.1 293 216 310 216 345.6V384H168V345.6c0-35.6-43.1-52.6-68.3-27.4L73.2 344.7 39.3 310.8l26.5-26.5C91 259.1 74 216 38.4 216H0V168H38.4C74 168 96 128 65.8 99.7L39.3 73.2 73.2 39.3 99.7 65.8C124.9 91 168 74 168 38.4V0h48V38.4C216 74 259.1 91 284.3 65.8l26.5-26.5 33.9 33.9zm-67.1 33.1c-14.5 4.6-29.9 4.4-43.9 0C216.2 100.9 200.9 89 192 72.1c-15.7 30-51.8 44.1-83.9 34.8c6 16.8 5.2 34.7-2.2 50.9c-6.8 15-18.7 27-33.6 34.4c30.3 16 44.3 53 34 85.5c32.6-10.4 69.7 3.8 85.7 34.3c16-30.5 53.1-44.6 85.7-34.3c-10.4-32.6 3.8-69.7 34.3-85.7c-30.5-16-44.6-53.1-34.3-85.7zM168 144a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM464 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm122.5-97.1l22.6 22.6-11.3 11.3C574.5 312.1 591 352 624 352h16v32H624c-33 0-49.5 39.9-26.2 63.2l11.3 11.3-22.6 22.6-11.3-11.3C551.9 446.5 512 463 512 496v16H480V496c0-33-39.9-49.5-63.2-26.2l-11.3 11.3-22.6-22.6 11.3-11.3C417.5 423.9 401 384 368 384H352V352h16c33 0 49.5-39.9 26.2-63.2l-11.3-11.3 22.6-22.6 11.3 11.3C440.1 289.5 480 273 480 240V224h32v16c0 33 39.9 49.5 63.2 26.2l11.3-11.3zm-31.4 54.1c-9.2 .8-18.4-.4-27.1-3.2c-12.3-4-23.5-11.3-32-21.3c-14.5 17-36.8 26.3-59.1 24.5c1.8 22.3-7.4 44.6-24.5 59.1c17 14.5 26.3 36.8 24.5 59.1c22.3-1.8 44.6 7.4 59.1 24.5c14.5-17 36.8-26.3 59.1-24.5c-1.8-22.3 7.4-44.6 24.5-59.1c-17-14.5-26.3-36.8-24.5-59.1z'
      
    ]
  };

  

  
  

  var faBatteryExclamation = {
    prefix: 'fasl',
    iconName: 'battery-exclamation',
    icon: [
      576,
      512,
      [],
      'e0b0',
      
      'M80 96H208v32H80c-26.5 0-48 21.5-48 48V336c0 26.5 21.5 48 48 48H208v32H80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80zM432 384c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H336V96h96c44.2 0 80 35.8 80 80V336c0 44.2-35.8 80-80 80H336V384h96zM560 192c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zM288 96v16V304v16H256V304 112 96h32zM248 352h48v48H248V352z'
      
    ]
  };

  

  
  

  var faSterlingSign = {
    prefix: 'fasl',
    iconName: 'sterling-sign',
    icon: [
      320,
      512,
      [163,"gbp","pound-sign"],
      'f154',
      
      'M96 143.2C96 99.5 131.5 64 175.2 64c9.2 0 18.4 1.6 27.1 4.8L274.5 95l15 5.5 10.9-30.1-15-5.5L213.2 38.7c-12.2-4.4-25-6.7-38-6.7C113.8 32 64 81.8 64 143.2V256H0v32H64v36.2L1.7 448.8 0 452.2V456v8 16H16 304h16V448H304 37.9L94.3 335.2l1.7-3.4V328 288H256V256H96V143.2z'
      
    ]
  };

  
    var faGbp = faSterlingSign;
  
    var faPoundSign = faSterlingSign;
  

  
  

  var faSmoke = {
    prefix: 'fasl',
    iconName: 'smoke',
    icon: [
      640,
      512,
      [],
      'f760',
      
      'M64 128c0 28.1 12 53.3 31.2 70.8c-11.2 3.2-21.9 7.5-32.1 12.8C43.7 189.2 32 160 32 128C32 57.3 89.3 0 160 0c40.1 0 75.9 18.4 99.3 47.3C277.4 37.5 298.1 32 320 32c44.3 0 83.4 22.5 106.4 56.8c-9.1 5.8-17.5 12.4-25.3 19.8C384.1 81.8 354.1 64 320 64c-20.8 0-40 6.6-55.7 17.8l-13.8 9.9-9-14.4C224.5 50 194.3 32 160 32c-53 0-96 43-96 96zm448 0c-41.3 0-76.6 26.1-90.1 62.8l-9.7 26.3-17.7-21.7C376.8 173.8 350 160 320 160c-38.7 0-72.1 22.9-87.3 56c-9.2-5.4-18.9-9.9-29-13.6C224 158.5 268.4 128 320 128c31.4 0 60.1 11.3 82.3 30c22.4-37.1 63.1-62 109.7-62c70.7 0 128 57.3 128 128c0 42.2-20.4 79.6-51.9 102.9c-5.5-9.2-11.9-17.8-19.2-25.6C592.6 283.9 608 255.7 608 224c0-53-43-96-96-96zM144 256C82.1 256 32 306.1 32 368V480H144 464h80V400c0-44.2-35.8-80-80-80c-11.7 0-22.7 2.5-32.7 7l-15.5 6.9-6-15.9c-13.7-36.3-48.8-62-89.8-62c-28.9 0-54.8 12.8-72.4 33l-11.4 13.1-12.1-12.4C203.7 268.9 175.4 256 144 256zM0 368c0-79.5 64.5-144 144-144c34.5 0 66.2 12.1 90.9 32.3C257.5 236.2 287.3 224 320 224c49.1 0 91.8 27.7 113.2 68.3c9.8-2.8 20.1-4.3 30.8-4.3c61.9 0 112 50.1 112 112v96 16H560 464 144 16 0V496 368z'
      
    ]
  };

  

  
  

  var faMaskSnorkel = {
    prefix: 'fasl',
    iconName: 'mask-snorkel',
    icon: [
      576,
      512,
      [],
      'e3b7',
      
      'M576 32V48 160H544V48 32h32zM544 192h32V384c0 70.7-57.3 128-128 128s-128-57.3-128-128V368 352h32v16 16c0 53 43 96 96 96s96-43 96-96V192zM264 288l-22.1-44.2-4.6-9.1L232 224H216l-5.3 10.7-4.6 9.1L184 288H32 0V256 96 64H32 416h32V96 256v32H416 264zm-76.6-78.3l8.8-17.7H216h16 19.8l8.8 17.7L283.8 256H416V96H32V256H164.2l23.2-46.3z'
      
    ]
  };

  

  
  

  var faImageSlash = {
    prefix: 'fasl',
    iconName: 'image-slash',
    icon: [
      640,
      512,
      [],
      'e1b7',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM576 64V32H544 139.6l40.5 32H544V265.4l-84.7-84.7L448 169.4l-11.3 11.3-48 48 25.3 20 34-34 96 96v40.7l32 25.3V64zM297.6 319.8l-9.6 9.6-81.2-81.2-16.5-13.1-9.6 9.6L96 329.4V160.7L64 135.4V448v32H96 500.4l-40.5-32H214.6L322.8 339.8l-25.3-20zM265.4 352l-96 96H96V374.6l96-96L265.4 352z'
      
    ]
  };

  

  
  

  var faPersonWalkingDashedLineArrowRight = {
    prefix: 'fasl',
    iconName: 'person-walking-dashed-line-arrow-right',
    icon: [
      640,
      512,
      [],
      'e553',
      
      'M200 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 200 0a56 56 0 1 0 0 112zM76.7 194.7l46.9-31.3L95 255.2c-5.7 18.2 0 38.1 14.4 50.6L210 393l30.7 102.7 4.6 15.3 30.7-9.2-4.6-15.3-32-107.2L238 375l-3.5-3L187.3 331l38.4-111 15 48.7 1.7 5.4 4.7 3.2 48 32 17.8-26.6-43.3-28.8-30.3-98.6-2.6-8.4-8.5-2.3-88-24-7-1.9-6.1 4-72 48-3.9 2.6-1.9 4.2-32 72-6.5 14.6 29.2 13 6.5-14.6 30.1-67.8zm48.8 70l33.1-106 49.7 13.6L161.2 308.4l-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zM66.9 422.5L12.7 476.7 1.4 488 24 510.6l11.3-11.3 56-56c1.2-1.2 2.2-2.6 3-4.2l36.3-72.6-25-21.6L66.9 422.5zM416 16V0H384V16 80 96h32V80 16zM530.3 163.8l-12.2-10.3-20.7 24.4 12.2 10.3L570.8 240H384 368v32h16H570.8l-61.1 51.8-12.2 10.3 20.7 24.4 12.2-10.3 94.4-80L639.1 256l-14.4-12.2-94.4-80zM416 128H384v16 32 16h32V176 144 128zm0 208V320H384v16 32 16h32V368 336zm0 80H384v16 64 16h32V496 432 416z'
      
    ]
  };

  

  
  

  var faStocking = {
    prefix: 'fasl',
    iconName: 'stocking',
    icon: [
      384,
      512,
      [],
      'f7d5',
      
      'M96 32V80H352V32H96zM64 0H96 352h32V32 80v32H352 96 64V80 32 0zm64 273.1l-14.2 9.5L73.4 309.5C47.6 326.8 32 355.8 32 386.9v2.2c0 50.2 40.7 90.8 90.8 90.8c17.9 0 35.5-5.3 50.4-15.3L320 366.9V144h32V384L190.9 491.4c-20.2 13.4-43.9 20.6-68.1 20.6C55 512 0 457 0 389.2v-2.2c0-41.8 20.9-80.9 55.7-104.1L96 256V144h32V256v17.1z'
      
    ]
  };

  

  
  

  var faTeddyBear = {
    prefix: 'fasl',
    iconName: 'teddy-bear',
    icon: [
      576,
      512,
      [],
      'e3cf',
      
      'M160 64c0 12.5 7.2 23.4 17.8 28.7l11.8 5.9-3.5 12.7c-1.3 4.8-2.1 10.4-2.1 16.7c0 51.3 44.7 96 104 96s104-44.7 104-96c0-6.4-.8-11.9-2.1-16.7l-3.5-12.7 11.8-5.9C408.8 87.4 416 76.5 416 64c0-17.7-14.3-32-32-32c-15.1 0-27.8 10.5-31.2 24.7l-3.6 15.5-15.5-3.5C319 65.3 303 64 288 64s-31 1.3-45.7 4.6l-15.5 3.5-3.6-15.5C219.8 42.5 207.1 32 192 32c-17.7 0-32 14.3-32 32zM192 0c24.8 0 46.4 14.2 57 34.8c13.3-2 26.6-2.8 39-2.8s25.7 .8 39 2.8C337.6 14.2 359.2 0 384 0c35.3 0 64 28.7 64 64c0 20.6-9.8 38.9-24.9 50.6c.6 4.3 .9 8.8 .9 13.4c0 70.7-60.9 128-136 128s-136-57.3-136-128c0-4.6 .3-9.1 .9-13.4C137.8 102.9 128 84.6 128 64c0-35.3 28.7-64 64-64zm96 184c-17.7 0-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24s-14.3 24-32 24zm152 3.5l12.5 10 75 60 12.5 10L530 280l-10.8 13.5c-27 33.7-59.5 59.8-95.1 78.2V384h14.4L451 366.6l4.8-6.6H464h56 18.3l-2.4 18.1-16 120L518 512H504 424 408v0H168v0H152 72 58l-1.9-13.9-16-120L37.7 360H56h56 8.2l4.8 6.6L137.6 384H152V371.7c-35.6-18.4-68.2-44.5-95.1-78.2L46 280 36 267.5l12.5-10 75-60 12.5-10L146 200l10.8 13.5c67.3 84.1 195.1 84.1 262.4 0L430 200l10-12.5zM136 480v0h16 56V416H192 160v0H129.4h-8.2l-4.8-6.6L103.8 392H74.3L86 480h50zm104-89.4V400v80h96V400v-9.4L313.4 368H262.6L240 390.6zM374.6 384H392V361.8 351.6l9.2-4.3c34.9-16.5 66.8-41.1 93-73.8l.8-1.1-50-40-.8 1.1c-80.1 100.1-232.3 100.1-312.3 0l-.8-1.1-50 40 .8 1.1c26.2 32.7 58.1 57.3 93 73.8l9.2 4.3v10.1V384h17.4l43.3-43.3 4.7-4.7H256h64 6.6l4.7 4.7L374.6 384zm9.4 32H368v64h56 16v0h50l11.7-88H472.2l-12.6 17.4-4.8 6.6h-8.2H416v0H384zM240 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faVolcano = {
    prefix: 'fasl',
    iconName: 'volcano',
    icon: [
      512,
      512,
      [127755],
      'f770',
      
      'M213 58.7C220.9 42.8 237.2 32 256 32s35.1 10.8 43 26.7l11.7 23.5L326.2 61c5.9-7.9 15.2-13 25.8-13c17.7 0 32 14.3 32 32s-14.3 32-32 32H302.4h-7.7l-4.8 6-33.6 42h-.6l-33.6-42-4.8-6h-7.7H160c-17.7 0-32-14.3-32-32s14.3-32 32-32c10.6 0 19.9 5.1 25.8 13l15.5 21.1L213 58.7zM256 0c-23.9 0-45.3 10.5-60 27.1c-10.3-7-22.6-11.1-36-11.1c-35.3 0-64 28.7-64 64s28.7 64 64 64h41.9l33.6 42 4.8 6H248h16 7.7l4.8-6 33.6-42H352c35.3 0 64-28.7 64-64s-28.7-64-64-64c-13.4 0-25.8 4.1-36 11.1C301.3 10.5 279.9 0 256 0zM32 452.2l82.7-93L128 368l112-32 80 64 78.7-39.3L480 452.2V480H32V452.2zM428.3 345.8l-22-24.8L320 224H192h0L0 440v40 32H32 480h32V480 440l-83.7-94.2zM324 362.2L260 311l-12.9-10.3-15.9 4.5-92 26.3L206.4 256h99.3l71 79.9L324 362.2z'
      
    ]
  };

  

  
  

  var faLariSign = {
    prefix: 'fasl',
    iconName: 'lari-sign',
    icon: [
      384,
      512,
      [],
      'e1c8',
      
      'M160 32V98.7c10.4-1.7 21.1-2.7 32-2.7s21.6 .9 32 2.7V32h32v74.9c74.6 26.4 128 97.5 128 181.1H352c0-65.6-39.5-122-96-146.7L256 288H224l0-156.8c-10.3-2.1-21-3.2-32-3.2s-21.7 1.1-32 3.2L160 288H128l0-146.7C71.5 166 32 222.4 32 288c0 88.4 71.6 160 160 160H384v32H192 0V448H85.8C34.1 413.6 0 354.8 0 288c0-83.6 53.4-154.7 128-181.1V32h32z'
      
    ]
  };

  

  
  

  var faUserPolice = {
    prefix: 'fasl',
    iconName: 'user-police',
    icon: [
      448,
      512,
      [],
      'e333',
      
      'M368 99.2V144c-16 10.7-67.2 32-144 32s-128-21.3-144-32V99.2L48 80V48L224 0 400 48V80L368 99.2zm-32 25.3V99.2 81.1l15.5-9.3 4.4-2.6L224 33.2 92.1 69.1l4.4 2.6L112 81.1V99.2v25.3c13.6 5.6 35.5 12.5 64.7 16.4c-12.9-19.7-16.7-42-16.7-57.7V72.4l10.1-4 48-19.2 5.9-2.4 5.9 2.4 48 19.2 10.1 4V83.2c0 15.7-3.8 38.1-16.7 57.7c29.2-3.9 51.1-10.8 64.7-16.4zM96.2 184.1c10.4 4 21 7.6 31.8 10.7c1.5 51.7 43.9 93.2 96 93.2s94.5-41.5 96-93.2c10.8-3.1 21.4-6.6 31.8-10.7c.2 2.6 .2 5.2 .2 7.9c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-2.7 .1-5.3 .2-7.9zM224 142.3c20.5-11.3 28.9-31.3 31.3-48.5L224 81.2 192.7 93.7c2.3 17.3 10.8 37.3 31.3 48.5zm0 317.3l-21.7-20L142.2 384H71.8L43 480H304V464H288 272V432h16 16V416 400h32v16 16h16 16v32H352 336v16h69l-28.8-96H305.8l-60.1 55.5-21.7 20zM336 512H304 33.4 0l9.6-32L48 352H154.7L224 416l69.3-64H400l38.4 128 9.6 32H414.6 336z'
      
    ]
  };

  

  
  

  var faCircleChevronUp = {
    prefix: 'fasl',
    iconName: 'circle-chevron-up',
    icon: [
      512,
      512,
      ["chevron-circle-up"],
      'f139',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm11.3-347.3L256 153.4l-11.3 11.3-112 112L121.4 288 144 310.6l11.3-11.3L256 198.6 356.7 299.3 368 310.6 390.6 288l-11.3-11.3-112-112z'
      
    ]
  };

  
    var faChevronCircleUp = faCircleChevronUp;
  

  
  

  var faUpRight = {
    prefix: 'fasl',
    iconName: 'up-right',
    icon: [
      384,
      512,
      [],
      'e2be',
      
      'M240 274.7l-22.6 22.6L112 402.7 45.3 336 150.6 230.6 173.3 208l-22.6-22.6L101.3 136l8-8H320V338.7l-8 8-49.4-49.4L240 274.7zm49.4 94.6L312 392l22.6-22.6L352 352V128 96H320 96L78.6 113.4 56 136l22.6 22.6 26.7 26.7L128 208l-22.6 22.6L22.6 313.4 0 336l22.6 22.6 66.7 66.7L112 448l22.6-22.6 82.7-82.7L240 320l22.6 22.6 26.7 26.7z'
      
    ]
  };

  

  
  

  var faFileMagnifyingGlass = {
    prefix: 'fasl',
    iconName: 'file-magnifying-glass',
    icon: [
      384,
      512,
      ["file-search"],
      'f865',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM176 256a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160c20.7 0 39.9-6.5 55.5-17.7l45.1 45.1L288 454.8l22.6-22.6-11.3-11.3-45.1-45.1C265.4 360 272 340.8 272 320c0-53-43-96-96-96s-96 43-96 96s43 96 96 96z'
      
    ]
  };

  
    var faFileSearch = faFileMagnifyingGlass;
  

  
  

  var faGearComplex = {
    prefix: 'fasl',
    iconName: 'gear-complex',
    icon: [
      512,
      512,
      [],
      'e5e9',
      
      'M208 0H194.9l-2.6 12.9-9.7 48.5c-4.2 1.6-8.3 3.3-12.4 5.1L129.1 39l-10.9-7.3L108.9 41 41 108.9l-9.3 9.3L39 129.1l27.4 41.1c-1.8 4.1-3.6 8.2-5.1 12.4l-48.5 9.7L0 194.9V208v96 13.1l12.9 2.6 48.5 9.7c1.6 4.2 3.3 8.3 5.1 12.4L39 382.9l-7.3 10.9 9.3 9.3L108.9 471l9.3 9.3 10.9-7.3 41.1-27.4c4.1 1.8 8.2 3.6 12.4 5.1l9.7 48.5 2.6 12.9H208h96 13.1l2.6-12.9 9.7-48.5c4.2-1.6 8.3-3.3 12.4-5.1L382.9 473l10.9 7.3 9.3-9.3L471 403.1l9.3-9.3L473 382.9l-27.4-41.1c1.8-4.1 3.6-8.2 5.1-12.4l48.5-9.7 12.9-2.6V304 208 194.9l-12.9-2.6-48.5-9.7c-1.6-4.2-3.3-8.3-5.1-12.4L473 129.1l7.3-10.9-9.3-9.3L403.1 41l-9.3-9.3L382.9 39 341.8 66.5c-4.1-1.8-8.2-3.6-12.4-5.1l-9.7-48.5L317.1 0H304 208zm4.2 76.5L221.1 32h69.8l8.9 44.5 1.8 9.2 8.9 2.9c8.7 2.8 17.2 6.4 25.3 10.5l8.3 4.3 7.8-5.2 37.8-25.2 49.3 49.3-25.2 37.8-5.2 7.8 4.3 8.3c4.1 8.1 7.6 16.5 10.5 25.3l2.9 8.9 9.2 1.8 44.5 8.9v69.8l-44.5 8.9-9.2 1.8-2.9 8.9c-2.8 8.7-6.4 17.2-10.5 25.3l-4.3 8.3 5.2 7.8 25.2 37.8-49.3 49.3-37.8-25.2-7.8-5.2-8.3 4.3c-8.1 4.1-16.5 7.6-25.3 10.5l-8.9 2.9-1.8 9.2L290.9 480H221.1l-8.9-44.5-1.8-9.2-8.9-2.9c-8.7-2.8-17.2-6.4-25.3-10.5l-8.3-4.3-7.8 5.2-37.8 25.2L72.9 389.7l25.2-37.8 5.2-7.8-4.3-8.3c-4.1-8.1-7.6-16.5-10.5-25.3l-2.9-8.9-9.2-1.8L32 290.9V221.1l44.5-8.9 9.2-1.8 2.9-8.9c2.8-8.7 6.4-17.2 10.5-25.3l4.3-8.3-5.2-7.8L72.9 122.3l49.3-49.3 37.8 25.2 7.8 5.2 8.3-4.3c8.1-4.1 16.5-7.6 25.3-10.5l8.9-2.9 1.8-9.2zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm160 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  

  
  

  var faUniversalAccess = {
    prefix: 'fasl',
    iconName: 'universal-access',
    icon: [
      512,
      512,
      [],
      'f29a',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM135.9 186.9l-13 29.2 14.6 6.5L208 254v64.5l-15.7 78.4-3.1 15.7 31.4 6.3 3.1-15.7L237.1 336h37.8l13.4 67.1 3.1 15.7 31.4-6.3-3.1-15.7L304 318.4V254l70.5-31.3 14.6-6.5-13-29.2-14.6 6.5L292.6 224H272 240 219.4l-68.9-30.6-14.6-6.5zM240 256h32v48H240V256z'
      
    ]
  };

  

  
  

  var faAperture = {
    prefix: 'fasl',
    iconName: 'aperture',
    icon: [
      512,
      512,
      [],
      'e2df',
      
      'M418.8 409.9l-3.3-5.8L348.4 288 316 344 237.9 479.3c6 .5 12 .7 18.1 .7c64.1 0 121.9-26.9 162.8-70.1zm21.6-26.6c25-36.1 39.7-80 39.7-127.3c0-22.2-3.2-43.7-9.3-64H464 329.9l32.3 56 78.1 135.3zM458.4 160C429.7 99.5 374.6 53.9 307.9 38.1l-3.4 5.8L237.5 160h64.7H458.4zM274.1 32.7c-6-.5-12-.7-18.1-.7c-64.1 0-121.9 26.9-162.8 70.1l3.3 5.8 67 116.1L196 168 274.1 32.7zm-202.4 96C46.6 164.9 32 208.7 32 256c0 22.2 3.2 43.7 9.3 64H48 182.1l-32.3-56L71.7 128.7zM53.6 352c28.8 60.5 83.9 106.1 150.5 121.9l3.4-5.8 67-116.1H209.8 53.6zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm219.1 64H293l37-64L293 192H219l-36.9 64 37 64z'
      
    ]
  };

  

  
  

  var faHelicopterSymbol = {
    prefix: 'fasl',
    iconName: 'helicopter-symbol',
    icon: [
      512,
      512,
      [],
      'e502',
      
      'M469.7 224H502C487.9 110.9 400 20.7 288 3.1V35.6c94.3 17 168.1 93 181.7 188.4zM502 288H469.7C456.1 383.4 382.3 459.4 288 476.4v32.5C400 491.3 487.9 401.1 502 288zM-6 288C8.7 406.5 104.4 499.8 224 510.9V478.7C122.1 467.9 40.7 388.8 26.3 288H-6zm0-64H26.3C40.7 123.2 122.1 44.1 224 33.3V1.1C104.5 12.2 8.8 105.5-6 224zm182-80V128H144v16V368v16h32V368 272H336v96 16h32V368 144 128H336v16 96H176V144z'
      
    ]
  };

  

  
  

  var faTreeLarge = {
    prefix: 'fasl',
    iconName: 'tree-large',
    icon: [
      448,
      512,
      [],
      'f7dd',
      
      'M383.3 224H392V192L245.3 24.3 224 0 202.7 24.3 56 192v32h8.7H88h16L81.1 256 24 336v32H40.7 56 80L57.1 400 0 480v32H32 416h32V480l-57.1-80L368 368h24 15.3H424V336l-57.1-80L344 224h16 23.3zm-33.8-32H344 281.8L318 242.6 384.7 336H368 305.8L342 386.6 408.7 480H39.3L106 386.6 142.2 336H80 63.3L130 242.6 166.2 192H104 98.5L224 48.6 349.5 192z'
      
    ]
  };

  

  
  

  var faBatteryBolt = {
    prefix: 'fasl',
    iconName: 'battery-bolt',
    icon: [
      576,
      512,
      [],
      'f376',
      
      'M32 96H260.1l-32 32H32V384H159.5l-4.6 32H32 0V384 128 96H32zM480 384V128H352.5l4.6-32H480h32v32V384v32H480 251.9l32-32H480zm64-192h32v32 64 32H544V288 224 192zM296 112h8 18.4l-2.6 18.3L306.4 224H352h16v16 8 6.6l-4.7 4.7-136 136-4.7 4.7H216h-8H189.6l2.6-18.3L205.6 288H160 144V272v-8-6.6l4.7-4.7 136-136 4.7-4.7H296zM190.6 256H224h18.4l-2.6 18.3-10.5 73.8L321.4 256H288 269.6l2.6-18.3 10.5-73.8L190.6 256z'
      
    ]
  };

  

  
  

  var faSquareArrowDownLeft = {
    prefix: 'fasl',
    iconName: 'square-arrow-down-left',
    icon: [
      448,
      512,
      [],
      'e261',
      
      'M32 448V64H416V448H32zM0 480H32 416h32V448 64 32H416 32 0V64 448v32zM144 352H280h16V320H280 182.6L315.3 187.3 326.6 176 304 153.4l-11.3 11.3L160 297.4V192 176H128v16V336v16h16z'
      
    ]
  };

  

  
  

  var faFaceLaughBeam = {
    prefix: 'fasl',
    iconName: 'face-laugh-beam',
    icon: [
      512,
      512,
      [128513,"laugh-beam"],
      'f59a',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 400c52 0 97.1-32.8 115.7-80H140.3c18.6 47.2 63.7 80 115.7 80zM100 288h32.2H379.8 412c-1.1 11-3.2 21.7-6.4 32c-20 64.9-79.4 112-149.6 112s-129.6-47.1-149.6-112c-3.2-10.3-5.3-21-6.4-32zm56.5-99.5c-6.2 7.2-10.8 16.8-12.9 25.4l-31-7.8c3.2-12.7 9.8-27.1 19.9-38.6C142.4 155.9 157.2 146 176 146s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6l-31 7.8c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4l-31-7.8c3.2-12.7 9.8-27.1 19.9-38.6C302.4 155.9 317.2 146 336 146s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6l-31 7.8c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z'
      
    ]
  };

  
    var faLaughBeam = faFaceLaughBeam;
  

  
  

  var faBinBottles = {
    prefix: 'fasl',
    iconName: 'bin-bottles',
    icon: [
      640,
      512,
      [],
      'e5f5',
      
      'M384 0V32h16 96 16V0H496 400 384zM352 192v-2.5l0 0V144l-.4-.2-32-16L256 96H128L32 144v48H64V163.8L135.6 128H248.4l71.2 35.6v28.4 .1h.4 32zm223.6 0v-.1V160 94.1L511.3 64H383.9L321.8 93.1l36.5 18.2L391 96H504.2l39.4 18.5v71.9c-.3 1.8-.5 3.7-.5 5.6h32 .5zm30.5 64H608h32V224H608h-1.9H592 577.7 62.3 48 33.9 32 0v32H32h1.9L64 512H576l30.1-256zM547.5 480H92.5L66.1 256H573.9L547.5 480zM144 0H128V16 32H112V64h16 16 16V48 32h64V48 64h16 16 16V32H256V16 0H240 144z'
      
    ]
  };

  

  
  

  var faMarker = {
    prefix: 'fasl',
    iconName: 'marker',
    icon: [
      512,
      512,
      [],
      'f5a1',
      
      'M6.8 478L0 512l34-6.8L160 480 485.5 154.5c17-17 26.5-40 26.5-64C512 40.5 471.5 0 421.5 0c-24 0-47 9.5-64 26.5L307.3 76.7l-48-48L248 17.4 236.7 28.7l-96 96L129.4 136 152 158.6l11.3-11.3L248 62.6l36.7 36.7L32 352 6.8 478zm34-6.8L61.5 367.8 187.3 241.9l82.7 82.7L144.2 450.5 40.8 471.2zM209.9 219.3L380.1 49.1c11-11 25.9-17.1 41.4-17.1C453.8 32 480 58.2 480 90.5c0 15.5-6.2 30.4-17.1 41.4L292.7 302.1l-82.7-82.7z'
      
    ]
  };

  

  
  

  var faKazoo = {
    prefix: 'fasl',
    iconName: 'kazoo',
    icon: [
      640,
      512,
      [],
      'f8c7',
      
      'M416 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256c23.8 0 46.3-5.8 66-16H608h32V352 160 128H608 482c-19.8-10.2-42.2-16-66-16s-46.3 5.8-66 16H224L0 192V320l224 64H350c19.8 10.2 42.2 16 66 16zm106.6-47.2c.2-.3 .5-.5 .7-.8l-.7 .8zm.7-.8c22.8-25.5 36.7-59.1 36.7-96s-13.9-70.5-36.7-96l0 0H608V352H523.3zM228.5 160h80.2c-22.8 25.5-36.7 59.1-36.7 96s13.9 70.5 36.7 96H228.5L32 295.9V216.1L228.5 160zm158.8 44.7L376 193.4 353.4 216l11.3 11.3L393.4 256l-28.7 28.7L353.4 296 376 318.6l11.3-11.3L416 278.6l28.7 28.7L456 318.6 478.6 296l-11.3-11.3L438.6 256l28.7-28.7L478.6 216 456 193.4l-11.3 11.3L416 233.4l-28.7-28.7z'
      
    ]
  };

  

  
  

  var faIdBadge = {
    prefix: 'fasl',
    iconName: 'id-badge',
    icon: [
      384,
      512,
      [],
      'f2c1',
      
      'M32 32V480H352V32H32zM0 0H32 352h32V32 480v32H352 32 0V480 32 0zM128 64h16 96 16V96H240 144 128V64zm96 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm7.1 128l-21.3 64H80l32-96H272l32 96H270.3l-21.3-64H135.1z'
      
    ]
  };

  

  
  

  var faNeuter = {
    prefix: 'fasl',
    iconName: 'neuter',
    icon: [
      384,
      512,
      [9906],
      'f22c',
      
      'M48 176a144 144 0 1 1 288 0A144 144 0 1 1 48 176zM208 351.3c89.7-8.1 160-83.5 160-175.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 91.8 70.3 167.2 160 175.3V496v16h32V496 351.3z'
      
    ]
  };

  

  
  

  var faPersonShelter = {
    prefix: 'fasl',
    iconName: 'person-shelter',
    icon: [
      512,
      512,
      [],
      'e54f',
      
      'M32 162.7V512H0V144L256 0 512 144V512H480V162.7L256 36.7 32 162.7zM272 168a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm0 64h96 8.9l4.7 7.6 64 104 8.4 13.6L362.8 374l-8.4-13.6L312 291.5V496v16H280V496 400H232v96 16H200V496 291.5l-42.4 68.9L149.2 374 122 357.2l8.4-13.6 64-104 4.7-7.6H208zm72 32H232V368h48V264z'
      
    ]
  };

  

  
  

  var faIcicles = {
    prefix: 'fasl',
    iconName: 'icicles',
    icon: [
      512,
      512,
      [],
      'f7ad',
      
      'M398.2 433.5L351.7 229.1 336 160l-17.2 68.8-15.6 62.5L288 352l-18-60-10.9-36.4L240 192l-13.9 65-17.7 82.7L192 416l-16.4-76.4L157.9 257 144 192l-19.1 63.6-11.5 38.5L96 352 80.1 293.7 8.7 32 0 0H33.2 479.4 512l-6 32L430.8 432.9 416 512l-17.8-78.5zM305 152.2L319 96h35.3l12.9 56.9L413 354.4 473.4 32H400 339.7 335 96 41.9L97.5 235.8l15.9-52.9L129.8 128H163l12.3 57.3 16.7 78 16.7-78L221 128h33.2l16.4 54.8 14.5 48.5 19.8-79z'
      
    ]
  };

  

  
  

  var faCarWrench = {
    prefix: 'fasl',
    iconName: 'car-wrench',
    icon: [
      512,
      512,
      ["car-mechanic"],
      'f5e3',
      
      'M88 40C62.6 40 41.2 56.9 34.3 80H80 96v32H80 34.3c6.9 23.1 28.3 40 53.7 40c22 0 41-12.6 50.2-31.1l4.4-8.9h9.9 207 9.9l4.4 8.9C383 139.4 402 152 424 152c25.4 0 46.8-16.9 53.7-40H432 416V80h16 45.7c-6.9-23.1-28.3-40-53.7-40c-22 0-41 12.6-50.2 31.1L369.4 80h-9.9-207-9.9l-4.4-8.9C129 52.6 110 40 88 40zM0 96C0 47.4 39.4 8 88 8c30.9 0 58.1 15.9 73.8 40H350.2C365.9 23.9 393.1 8 424 8c48.6 0 88 39.4 88 88s-39.4 88-88 88c-30.9 0-58.1-15.9-73.8-40H161.8c-15.7 24.1-42.9 40-73.8 40C39.4 184 0 144.6 0 96zm166.1 80H176 336h9.9l4.4 8.8L401.9 288H416h32v32 96 16 32 48H416V464H96v48H64V464 432 416 320 288H96h14.1l51.6-103.2 4.4-8.8zM416 320H392.3c-.2 0-.4 0-.7 0H120.3c-.2 0-.4 0-.7 0H96v96 16H416V416 320zM326.1 208H185.9l-40 80H366.1l-40-80zM144 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm200 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faCarMechanic = faCarWrench;
  

  
  

  var faChopsticks = {
    prefix: 'fasl',
    iconName: 'chopsticks',
    icon: [
      640,
      512,
      [],
      'e3f7',
      
      'M309.6 26.9L328 .6l25.2 19.8L410 65.1l25.2 19.8L414 108.9 59.6 511.3 2.5 466.4 309.6 26.9zM46.1 460l9.5 7.5L388.8 89.1l-54-42.4L46.1 460zM528.7 76.9l23.2-22.1 20.9 24.3L618.9 133l20.9 24.3-25.4 19.5L180.5 509.7l-47.1-54.9L528.7 76.9zM177.4 456.9l7.6 8.9L593.5 152.5l-43.9-51.2L177.4 456.9z'
      
    ]
  };

  

  
  

  var faCalendarCircleMinus = {
    prefix: 'fasl',
    iconName: 'calendar-circle-minus',
    icon: [
      576,
      512,
      [],
      'e46f',
      
      'M128 16V0H96V16 64H32 0V96v64 32V480v32H32 330.8c-12.9-9.1-24.5-19.9-34.6-32H32V192H352h64 16 16V160 96 64H416 352V16 0H320V16 64H128V16zM32 96H416v64H32V96zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm80-128V352H496 368 352v32h16H496h16z'
      
    ]
  };

  

  
  

  var faPlateWheat = {
    prefix: 'fasl',
    iconName: 'plate-wheat',
    icon: [
      512,
      512,
      [],
      'e55a',
      
      'M304 66.7V72c0 20.9 13.4 38.7 32 45.3V112c0-20.9-13.4-38.7-32-45.3zm0-33.1c36.5 7.4 64 39.7 64 78.4v8 32H352c-5.5 0-10.8-.6-16-1.6c-36.5-7.4-64-39.7-64-78.4V64 32h16c5.5 0 10.8 .6 16 1.6zM48 64h64 16V96H112 48 32V64H48zM16 144H144h16v32H144 16 0V144H16zm16 80H48h64 16v32H112 48 32V224zm272 24v5.3c18.6-6.6 32-24.4 32-45.3v-5.3c-18.6 6.6-32 24.4-32 45.3zm64-40c0 38.7-27.5 71-64 78.4c-5.2 1-10.5 1.6-16 1.6H272V256v-8c0-38.7 27.5-71 64-78.4c5.2-1 10.5-1.6 16-1.6h16v32 8zM192 248v5.3c18.6-6.6 32-24.4 32-45.3v-5.3c-18.6 6.6-32 24.4-32 45.3zm64-40c0 38.7-27.5 71-64 78.4c-5.2 1-10.5 1.6-16 1.6H160V256v-8c0-38.7 27.5-71 64-78.4c5.2-1 10.5-1.6 16-1.6h16v32 8zM192 66.7V72c0 20.9 13.4 38.7 32 45.3V112c0-20.9-13.4-38.7-32-45.3zm0-33.1c36.5 7.4 64 39.7 64 78.4v8 32H240c-5.5 0-10.8-.6-16-1.6c-36.5-7.4-64-39.7-64-78.4V64 32h16c5.5 0 10.8 .6 16 1.6zM416 248v5.3c18.6-6.6 32-24.4 32-45.3v-5.3c-18.6 6.6-32 24.4-32 45.3zm64-40c0 38.7-27.5 71-64 78.4c-5.2 1-10.5 1.6-16 1.6H384V256v-8c0-38.7 27.5-71 64-78.4c5.2-1 10.5-1.6 16-1.6h16v32 8zM416 66.7V72c0 20.9 13.4 38.7 32 45.3V112c0-20.9-13.4-38.7-32-45.3zm0-33.1c36.5 7.4 64 39.7 64 78.4v8 32H464c-5.5 0-10.8-.6-16-1.6c-36.5-7.4-64-39.7-64-78.4V64 32h16c5.5 0 10.8 .6 16 1.6zM128 448H384V427.4l22.4-7C439 410.1 464.7 384.5 475 352H37c10.4 32.5 36.1 58.1 68.6 68.3l22.4 7V448zm-32 2.9C50.3 436.5 15 399 3.8 352C1.3 341.7 0 331 0 320H32 480h32c0 11-1.3 21.7-3.8 32c-11.2 47-46.6 84.5-92.2 98.9V480H384 128 96V450.9z'
      
    ]
  };

  

  
  

  var faCompassDrafting = {
    prefix: 'fasl',
    iconName: 'compass-drafting',
    icon: [
      512,
      512,
      ["drafting-compass"],
      'f568',
      
      'M282.3 154.3l-.2-.3 13-7.4c15.1-11.7 24.8-30 24.8-50.6c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 20.6 9.7 38.9 24.8 50.6l13 7.4-.2 .3c8 3.6 17 5.7 26.3 5.7s18.3-2 26.3-5.7zm15.9 27.9c-12.8 6.3-27.1 9.8-42.3 9.8s-29.5-3.5-42.3-9.8L142.2 307.4C176.1 325.6 214.8 336 256 336c88.8 0 166.4-48.2 207.9-120l27.7 16c-47 81.3-134.9 136-235.6 136c-47 0-91.1-11.9-129.7-32.8L29.9 503.9 2.1 488.1l97-169.8c-32.1-22.7-59-52.1-78.7-86.2l27.7-16c16.9 29.2 39.8 54.6 67 74.3l72.5-126.9C170.5 146.1 160 122.3 160 96c0-53 43-96 96-96s96 43 96 96c0 26.3-10.5 50.1-27.6 67.4l56.5 98.9c-8.5 6.4-17.5 12.2-27 17.2l-55.6-97.4zM482.1 503.9L401.5 363c9.4-5.1 18.5-10.7 27.2-16.8l81.1 141.9-27.8 15.9z'
      
    ]
  };

  
    var faDraftingCompass = faCompassDrafting;
  

  
  

  var faArrowUpToBracket = {
    prefix: 'fasl',
    iconName: 'arrow-up-to-bracket',
    icon: [
      448,
      512,
      [],
      'e66a',
      
      'M235.3 164.7L224 153.4l-11.3 11.3-128 128L73.4 304 96 326.6l11.3-11.3L208 214.6 208 496l0 16 32 0 0-16 0-281.4L340.7 315.3 352 326.6 374.6 304l-11.3-11.3-128-128zM32 176L32 32l384 0 0 144 0 16 32 0 0-16 0-160 0-16L432 0 16 0 0 0 0 16 0 176l0 16 32 0 0-16z'
      
    ]
  };

  

  
  

  var faPhoneRotary = {
    prefix: 'fasl',
    iconName: 'phone-rotary',
    icon: [
      512,
      512,
      [9742],
      'f8d3',
      
      'M32 224H86.6l18.3-32H32V143.6c1.9-1.4 3.9-2.9 6.2-4.5c11.8-8.3 29.1-19.5 50.6-30.8C132.1 85.8 190.9 64 256 64s123.9 21.8 167.2 44.4c21.5 11.2 38.8 22.4 50.6 30.8c2.3 1.6 4.4 3.1 6.2 4.5V192H407.1l18.3 32H480h32V192 128s-112-96-256-96S0 128 0 128v64 32H32zm0 256H64 448h32V448 384L352 160H320V128 112H288v16 32H224V128 112H192v16 32H160L32 384v64 32zM192 192h32 64 32 13.4L448 392.5V448H64V392.5L178.6 192H192zM304 320a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z'
      
    ]
  };

  

  
  

  var faHeadSideHeadphones = {
    prefix: 'fasl',
    iconName: 'head-side-headphones',
    icon: [
      512,
      512,
      [],
      'f8c2',
      
      'M176 38v62.6c10.1-3 20.9-4.6 32-4.6s21.9 1.6 32 4.6V32H224c-16.6 0-32.7 2.1-48 6zM144 49.4C77.9 79.7 32 146.5 32 224c0 54.5 22.6 103.6 59.1 138.5l4.9 4.7v6.8V496v16H64V496 380.8C24.4 340.4 0 285 0 224C0 100.3 100.3 0 224 0h24C351.6 0 436 82 439.9 184.7L506.6 244l5.4 4.8V256v64 16H496 448v96 16H432 320v48 16H288V496 432 416h16H416V320 304h16 48V263.2l-66.6-59.2-5.4-4.8V192c0-80.2-59-146.6-136-158.2v82.3c29 20.2 48 53.9 48 91.9c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-38.1 19-71.7 48-91.9V49.4zM288 208a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faCircleStop = {
    prefix: 'fasl',
    iconName: 'circle-stop',
    icon: [
      512,
      512,
      [62094,"stop-circle"],
      'f28d',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160-96h32H320h32v32V320v32H320 192 160V320 192 160zm32 32V320H320V192H192z'
      
    ]
  };

  
    var faStopCircle = faCircleStop;
  

  
  

  var faBat = {
    prefix: 'fasl',
    iconName: 'bat',
    icon: [
      576,
      512,
      [],
      'f6b5',
      
      'M271.5 112l-7.4-4.2-19.3-11-14.1 56.4-9.5 37.9-35.3-16.8-80.8-38.5c-45.9 61.3-71.5 135.6-73 212.4l49.6-24.8 26.5-13.3 15.2 25.4 26.9 44.9 35-35 25.8-25.8 22.2 28.9 54.6 71 54.6-71 22.2-28.9 25.8 25.8 35 35 26.9-44.9 15.2-25.4 26.5 13.3 49.6 24.8c-1.5-76.8-27.2-151.1-73-212.4l-80.8 38.5-35.3 16.8-9.5-37.9L331.2 96.7l-19.3 11-7.4 4.2H296 280h-8.5zm51.6-47.5L352 48l8.1 32.2 8.4 33.4 7.9 31.7 29.5-14L480 96c61.9 72.3 96 164.3 96 259.5v8.7V400l-32-16-64-32-31 51.7L432 432l-23.3-23.3-17.9-17.9L368 368l-19.7 25.6-40.1 52.2L288 472l-20.2-26.2-40.1-52.2L208 368l-22.8 22.8-17.9 17.9L144 432l-17-28.3L96 352 32 384 0 400V364.2v-8.7C0 260.3 34.1 168.3 96 96l74.2 35.3 29.5 14 7.9-31.7 8.4-33.4L224 48l28.9 16.5L280 80h16l27.1-15.5z'
      
    ]
  };

  

  
  

  var faMoneySimpleFromBracket = {
    prefix: 'fasl',
    iconName: 'money-simple-from-bracket',
    icon: [
      640,
      512,
      [],
      'e313',
      
      'M0 0H16 624h16V16 176v16H608V176 32H32V176v16H0V176 16 0zM512 96v16l0 384v16H496l-352 0H128V496l0-384V96h32v16l0 368H480l0-368V96h32zM320 208c-47 0-80 31.3-80 64s33 64 80 64s80-31.3 80-64s-33-64-80-64zm112 64c0 55.6-53 96-112 96s-112-40.4-112-96s53-96 112-96s112 40.4 112 96z'
      
    ]
  };

  

  
  

  var faHandHoldingCircleDollar = {
    prefix: 'fasl',
    iconName: 'hand-holding-circle-dollar',
    icon: [
      576,
      512,
      [],
      'e621',
      
      'M272 256a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM272 0a144 144 0 1 1 0 288A144 144 0 1 1 272 0zM248.8 111.4c-.4 .7-.9 1.6-.8 3.6l0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2v10.8 16H256v-16V214.1c-8.6-1.7-16.7-4.3-23.7-6.6l0 0 0 0c-1.7-.6-3.4-1.1-5-1.6L212 201.2l9.5-30.6 15.3 4.8c2 .6 3.9 1.2 5.8 1.8c11.5 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3V64 48h32V64v9.4c6.3 .9 12.3 2.3 17.9 3.7l15.5 3.9-7.7 31.1-15.5-3.9c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4zM171.2 304H176 384h16v16 64h.2l103.6-61.7 13.5-8 8.3 13.3 40 64L574 405l-13.5 8.5-152 96-3.9 2.5H400 16 0V480H16 395.4L530 395l-23.3-37.2-94 56L409 416h-4.4H400 384 320 304 256 240V384h16 48 16 48V336H180.8l-92 61.3-4 2.7H80 16 0V368H16 75.2l92-61.3 4-2.7z'
      
    ]
  };

  

  
  

  var faSquareDashedCirclePlus = {
    prefix: 'fasl',
    iconName: 'square-dashed-circle-plus',
    icon: [
      576,
      512,
      [],
      'e5c2',
      
      'M16 32H128V64H32v96H0V48 32H16zM0 192H32V320H0V192zM0 352H32v96h96v32H16 0V464 352zM416 64H320V32H432h16V48 192c-10.9 0-21.6 1-32 2.9V64zM288 480H160V448H288v32zM160 64V32H288V64H160zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64v48h48 16v32H496 448v48 16H416V432 384H368 352V352h16 48V304 288h32v16z'
      
    ]
  };

  

  
  

  var faCircleCheck = {
    prefix: 'fasl',
    iconName: 'circle-check',
    icon: [
      512,
      512,
      [61533,"check-circle"],
      'f058',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 203.3L374.6 192 352 169.4l-11.3 11.3L224 297.4l-52.7-52.7L160 233.4 137.4 256l11.3 11.3 64 64L224 342.6l11.3-11.3 128-128z'
      
    ]
  };

  
    var faCheckCircle = faCircleCheck;
  

  
  

  var faChair = {
    prefix: 'fasl',
    iconName: 'chair',
    icon: [
      448,
      512,
      [129681],
      'f6c0',
      
      'M288 32h64V224h32V32 0H352 96 64V32 224H96V32h64V224h32V32h64V224h32V32zM67.8 288H380.2l32 64H35.8l32-64zM448 352l-48-96H48L0 352v32H32V496v16H64V496 384H384V496v16h32V496 384h32V352z'
      
    ]
  };

  

  
  

  var faEuroSign = {
    prefix: 'fasl',
    iconName: 'euro-sign',
    icon: [
      320,
      512,
      [8364,"eur","euro"],
      'f153',
      
      'M34.3 224c-1.5 10.5-2.3 21.1-2.3 32s.8 21.5 2.3 32H0v32H41.3C68.8 412.5 154.5 480 256 480h49 16V448H305 256c-83.6 0-154.7-53.4-181.1-128H288V288H66.7c-1.7-10.4-2.7-21.1-2.7-32s.9-21.6 2.7-32H288V192H74.9C101.3 117.4 172.4 64 256 64h49 16V32H305 256C154.5 32 68.8 99.5 41.3 192H0v32H34.3z'
      
    ]
  };

  
    var faEur = faEuroSign;
  
    var faEuro = faEuroSign;
  

  
  

  var faEthernet = {
    prefix: 'fasl',
    iconName: 'ethernet',
    icon: [
      512,
      512,
      [],
      'f796',
      
      'M128 64h16H368h16V80v48h48 16v16 48h48 16v16V432v16H496 400 304 208 112 16 0V432 208 192H16 64V144 128H80h48V80 64zm32 32v48 16H144 96v48 16H80 32V416H96V336 320h32v16 80h64V336 320h32v16 80h64V336 320h32v16 80h64V336 320h32v16 80h64V224H432 416V208 160H368 352V144 96H160z'
      
    ]
  };

  

  
  

  var fa360Degrees = {
    prefix: 'fasl',
    iconName: '360-degrees',
    icon: [
      640,
      512,
      [],
      'e2dc',
      
      'M640 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM544 368c0 26.5-21.5 48-48 48s-48-21.5-48-48V144c0-26.5 21.5-48 48-48s48 21.5 48 48V368zM496 64c-44.2 0-80 35.8-80 80V368c0 44.2 35.8 80 80 80s80-35.8 80-80V144c0-44.2-35.8-80-80-80zM337.1 67.3l0 0 0 0-.1 0-.3 0c-.3 0-.6 .1-1.1 .2c-.9 .2-2.2 .4-3.8 .7c-3.1 .6-7.5 1.7-12.7 3.2c-10.3 3.1-24.2 8.5-38.2 17.7C252.3 107.9 224 141.8 224 200v72 16 16 64c0 44.2 35.8 80 80 80s80-35.8 80-80V272c0-44.2-35.8-80-80-80c-18 0-34.6 6-48 16v-8c0-45.8 21.3-70.3 42.4-84c10.8-7.1 21.7-11.3 30-13.9c4.1-1.2 7.5-2 9.8-2.5c1.1-.2 2-.4 2.5-.5l.6-.1 .1 0 0 0 15.8-2L353 65.3l-15.9 2 2 15.9c-2-15.9-2.1-15.9-2.1-15.9zM256 368V304 288 272c0-26.5 21.5-48 48-48s48 21.5 48 48v96c0 26.5-21.5 48-48 48s-48-21.5-48-48zM176 85.5V64H160 16 0V96H16 127.3L35.4 214.2 32 218.5V240H48 80c44.2 0 80 35.8 80 80v16c0 44.2-35.8 80-80 80c-15.6 0-28.4-6.2-37.6-12.9c-4.6-3.3-8.1-6.7-10.5-9.1c-1.2-1.2-2-2.2-2.6-2.8c-.3-.3-.4-.5-.5-.7l-.1-.1 0 0 0 0 0 0s0 0-12.8 9.6s-12.8 9.6-12.8 9.6l0 0 0 0 0 .1 .1 .2 .3 .4c.3 .3 .6 .8 1.1 1.4c.9 1.1 2.3 2.6 4 4.4c3.4 3.5 8.4 8.2 14.8 12.9C36.4 438.2 55.6 448 80 448c61.9 0 112-50.1 112-112V320c0-61.6-49.8-111.6-111.3-112L172.6 89.8l3.4-4.3z'
      
    ]
  };

  

  
  

  var faTablets = {
    prefix: 'fasl',
    iconName: 'tablets',
    icon: [
      640,
      512,
      [],
      'f490',
      
      'M603.9 261.3c-3.4 4.1-6.9 8.1-10.8 11.9s-7.8 7.4-11.9 10.8c-62.8 51.5-155.7 47.9-214.4-10.8s-62.3-151.6-10.8-214.4c3.4-4.1 6.9-8.1 10.8-11.9s7.8-7.4 11.9-10.8c62.8-51.5 155.7-47.9 214.4 10.8s62.3 151.6 10.8 214.4zM570.5 69.5c-46.2-46.2-118.8-49.7-169-10.6L581.1 238.5c39.1-50.2 35.5-122.8-10.6-169zm-12 191.6L378.9 81.5c-39.1 50.2-35.5 122.8 10.6 169s118.8 49.7 169 10.6zM319.2 336c.5 5.3 .8 10.6 .8 16s-.3 10.7-.8 16c-8 80.9-76.2 144-159.2 144S8.8 448.9 .8 368c-.5-5.3-.8-10.6-.8-16s.3-10.7 .8-16C8.8 255.1 77 192 160 192s151.2 63.1 159.2 144zM160 224C94.7 224 40.9 272.9 33 336H287c-7.9-63.1-61.7-112-127-112zm0 256c65.3 0 119.1-48.9 127-112H33c7.9 63.1 61.7 112 127 112z'
      
    ]
  };

  

  
  

  var faLocationArrowUp = {
    prefix: 'fasl',
    iconName: 'location-arrow-up',
    icon: [
      448,
      512,
      [],
      'e63a',
      
      'M224 328.9l18.4 12.8 132 92.4L224 108.4 73.6 434.2l132-92.4L224 328.9zM32 448L206.4 70.2 224 32l17.6 38.2L416 448l-32 32L224 368 64 480 32 448z'
      
    ]
  };

  

  
  

  var faArrowUpRightAndArrowDownLeftFromCenter = {
    prefix: 'fasl',
    iconName: 'arrow-up-right-and-arrow-down-left-from-center',
    icon: [
      512,
      512,
      [],
      'e0a0',
      
      'M292.7 196.7L281.4 208 304 230.6l11.3-11.3L480 54.6V160v16h32V160 16 0H496 352 336V32h16H457.4L292.7 196.7zM219.3 315.3L230.6 304 208 281.4l-11.3 11.3L32 457.4V352 336H0v16V496v16H16 160h16V480H160 54.6L219.3 315.3z'
      
    ]
  };

  

  
  

  var faCirclePlay = {
    prefix: 'fasl',
    iconName: 'circle-play',
    icon: [
      512,
      512,
      [61469,"play-circle"],
      'f144',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 364.3L176 384V346.4 165.6 128l32 19.7 145.5 89.5L384 256l-30.5 18.8L208 364.3zM322.9 256L208 185.3V326.7L322.9 256z'
      
    ]
  };

  
    var faPlayCircle = faCirclePlay;
  

  
  

  var faCannabis = {
    prefix: 'fasl',
    iconName: 'cannabis',
    icon: [
      512,
      512,
      [],
      'f55f',
      
      'M153.4 230.6c-8-8-20.9-16.1-38-23.6c-16.7-7.4-35.5-13.4-53.5-18.1c-8.1-2.1-15.8-4-23.1-5.5c1.2 5.1 2.5 10.4 4 16c9.4 33.8 25.5 71.6 51.8 97.9L122.2 325 89.8 346.6 54.6 370.1c1.4 .9 2.8 1.8 4.2 2.7C82.2 387.2 112.3 400 144 400h32v32c0 1.9 0 3.7 .1 5.5c18.5-7.5 41.4-18.3 62.2-32.1l1.8-1.2V336 320h32v16 68.2l1.8 1.2c20.7 13.8 43.6 24.6 62.2 32.1c.1-1.8 .1-3.6 .1-5.5V400h32c31.7 0 61.8-12.8 85.2-27.3c1.4-.9 2.8-1.8 4.2-2.7l-35.2-23.5L389.8 325l27.6-27.6c26.3-26.3 42.4-64.2 51.8-97.9c1.5-5.6 2.9-10.9 4-16c-7.2 1.6-15 3.4-23.1 5.5c-18 4.7-36.8 10.7-53.5 18.1c-17.1 7.5-30 15.6-38 23.6L304 285.3V208c0-57.2-17.9-103.9-36-136.5c-4.1-7.4-8.2-14-12-19.8c-3.9 5.8-7.9 12.4-12 19.8c-18.1 32.6-36 79.2-36 136.5v77.3l-54.6-54.6zM240 442c-43.6 25.4-88 38-88 38s-3.3-6.6-5.7-19.8c-.6-3.4-1.1-7.2-1.6-11.4c-.5-5-.8-10.6-.8-16.8c-49.1 0-92.2-24.1-118.2-42.8C9.5 377.5 0 368 0 368l27.4-18.3L44.9 338 72 320c-7.6-7.6-14.5-16-20.6-24.7C23.8 255.9 10.7 208.2 4.8 177C.9 157.2 0 144 0 144s13.2 1.7 32.7 5.5c30.7 6 76.9 17.4 112 36.3c12.1 6.5 22.9 13.9 31.3 22.3c0-13.6 .9-26.7 2.5-39.2c8.6-66.2 37.1-116 57.1-143.8C247.3 8.7 256 0 256 0s8.7 8.7 20.4 25c19.9 27.8 48.5 77.7 57.1 143.8c1.6 12.5 2.5 25.5 2.5 39.2c8.4-8.4 19.1-15.8 31.3-22.3c35.1-18.8 81.3-30.2 112-36.3c19.5-3.8 32.7-5.5 32.7-5.5s-.9 13.2-4.8 33c-6 31.2-19 78.9-46.6 118.3c-6.1 8.7-13 17.1-20.6 24.7l27.1 18 17.5 11.7L512 368s-9.5 9.5-25.8 21.2C460.2 407.9 417.1 432 368 432c0 6.2-.3 11.8-.8 16.8c-.4 4.2-1 8-1.6 11.4C363.3 473.4 360 480 360 480s-44.4-12.7-88-38v54 16H240V496 442z'
      
    ]
  };

  

  
  

  var faTruckRampCouch = {
    prefix: 'fasl',
    iconName: 'truck-ramp-couch',
    icon: [
      640,
      512,
      ["truck-couch"],
      'f4dd',
      
      'M352 0h16H624h16V32H624 384V378.6l36-9.3 .3-.1C433.6 322.4 476.8 288 528 288c61.9 0 112 50.1 112 112s-50.1 112-112 112c-60.7 0-110.2-48.3-111.9-108.6L28 503.5l-15.5 4-8-31 15.5-4 332-85.6V384 16 0zM608 400a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM225.7 128.2c36.4-9.8 73.6 4.8 94.3 33.7v75.5c-3.1-.4-6.3-.3-9.5 .6c-11.1 3-18.3 13.3-17.8 24.3l1.3 25.8-25 6.7L127.6 332.8l-25 6.7-11.8-23c-5-9.9-16.5-15.2-27.6-12.2c-12.8 3.4-20.4 16.6-17 29.4l15.5 58 32.5-8.7 30.9-8.3 .1 .2 153-41 30.9-8.3 0 .1 10.9-2.9v33.1l-2.6 .7-30.9 8.3 0-.1-30.9 8.3L133.5 405.8 102.6 414l-.1-.2-30.9 8.3-1.6 .4-30.9 8.3-8.3-30.9-15.5-58c-3.9-14.7-1.6-29.7 5.3-42l-6.4-24C1.7 229 29.5 180.8 76.5 168.2l149.2-40zm8.3 30.9l-149.2 40c-29.9 8-47.6 38.7-39.6 68.6l2.2 8.3c2.4-1 5-1.9 7.6-2.6c26-7 52.6 5.5 64.3 28.5L260.8 264c-1.3-25.8 15.5-49.9 41.4-56.9c.8-.2 1.6-.4 2.4-.6l-2.1-7.8c-8-29.9-38.7-47.6-68.6-39.6z'
      
    ]
  };

  
    var faTruckCouch = faTruckRampCouch;
  

  
  

  var faAnglesRight = {
    prefix: 'fasl',
    iconName: 'angles-right',
    icon: [
      512,
      512,
      [187,"angle-double-right"],
      'f101',
      
      'M267.3 267.3L278.6 256l-11.3-11.3-160-160L96 73.4 73.4 96l11.3 11.3L233.4 256 84.7 404.7 73.4 416 96 438.6l11.3-11.3 160-160zm192 0L470.6 256l-11.3-11.3-160-160L288 73.4 265.4 96l11.3 11.3L425.4 256 276.7 404.7 265.4 416 288 438.6l11.3-11.3 160-160z'
      
    ]
  };

  
    var faAngleDoubleRight = faAnglesRight;
  

  
  

  var faSnowplow = {
    prefix: 'fasl',
    iconName: 'snowplow',
    icon: [
      640,
      512,
      [],
      'f7d2',
      
      'M128 0h16H320h10.4l4.2 9.5 96 216 1.4 3.1V232v56h96V240v-5.8l3.7-4.4 80-96 24.6 20.5L560 245.8V288v32 74.2l76.3 91.5-24.6 20.5-80-96-3.7-4.5V400 320H446.4c20.7 20.3 33.6 48.7 33.6 80c0 61.9-50.1 112-112 112H112C50.1 512 0 461.9 0 400c0-44.7 26.2-83.2 64-101.2V144 128H80h48V16 0zM400 292.6V288 256H208h-8.6l-4.8-7.1L135.4 160H128 96V289.1c5.2-.7 10.6-1.1 16-1.1H368c11.1 0 21.9 1.6 32 4.6zM160 139.2L216.6 224H394.9L309.6 32H160V139.2zM368 320H112c-44.2 0-80 35.8-80 80s35.8 80 80 80H368c44.2 0 80-35.8 80-80s-35.8-80-80-80zM120 376a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faAlignSlash = {
    prefix: 'fasl',
    iconName: 'align-slash',
    icon: [
      640,
      512,
      [],
      'f846',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM528 336h16V304H528 484.1l40.5 32H528zm0-128h16V176H528 322l40.5 32H528zm-372.1 0l-40.5-32H112 96v32h16 43.9zM528 48H159.8l40.5 32H528h16V48H528zM318 336l-40.5-32H112 96v32h16H318zm121.6 96H112 96v32h16H480.2l-40.5-32z'
      
    ]
  };

  

  
  

  var faOctagonXmark = {
    prefix: 'fasl',
    iconName: 'octagon-xmark',
    icon: [
      512,
      512,
      ["times-octagon","xmark-octagon"],
      'f2f0',
      
      'M32 338.7V173.3L173.3 32H338.7L480 173.3V338.7L338.7 480H173.3L32 338.7zM160 0L0 160V352L160 512H352L512 352V160L352 0H160zm31.4 168.8l-22.6 22.6 11.3 11.3L233.4 256l-53.3 53.3-11.3 11.3 22.6 22.6 11.3-11.3L256 278.6l53.3 53.3 11.3 11.3 22.6-22.6-11.3-11.3L278.6 256l53.3-53.3 11.3-11.3-22.6-22.6-11.3 11.3L256 233.4l-53.3-53.3-11.3-11.3z'
      
    ]
  };

  
    var faTimesOctagon = faOctagonXmark;
  
    var faXmarkOctagon = faOctagonXmark;
  

  
  

  var faMonument = {
    prefix: 'fasl',
    iconName: 'monument',
    icon: [
      384,
      512,
      [],
      'f5a6',
      
      'M86.3 384l39.8-272.9L192 45.3l65.9 65.9L297.7 384H330L288 96 214.6 22.6 192 0 169.4 22.6 96 96 54 384H86.3zM240 288H144v32h96V288zM32 480V448H352v32H32zM0 416v32 32 32H32 352h32V480 448 416H352 32 0z'
      
    ]
  };

  

  
  

  var faRefrigerator = {
    prefix: 'fasl',
    iconName: 'refrigerator',
    icon: [
      384,
      512,
      [],
      'e026',
      
      'M352 32V160H288V112 96H256v16 48H32V32H352zM256 192V368v16h32V368 192h64V480H32V192H256zM32 0H0V32 480v32H32 352h32V480 32 0H352 32z'
      
    ]
  };

  

  
  

  var faMinimize = {
    prefix: 'fasl',
    iconName: 'minimize',
    icon: [
      512,
      512,
      ["compress-arrows-alt"],
      'f78c',
      
      'M43.3 20.7l96 96 46.1-46.1L192 64l16-16 16 16V77.3 192v32H192 77.3 64L48 208l16-16 6.6-6.6 46.1-46.1-96-96L9.4 32 32 9.4 43.3 20.7zm448 22.6l-96 96 46.1 46.1L448 192l16 16-16 16H434.7 320 288V192 77.3 64l16-16 16 16 6.6 6.6 46.1 46.1 96-96L480 9.4 502.6 32 491.3 43.3zm-352 352l-96 96L32 502.6 9.4 480l11.3-11.3 96-96L70.6 326.6 64 320 48 304l16-16H77.3 192h32v32V434.7 448l-16 16-16-16-6.6-6.6-46.1-46.1zm233.4 0l-46.1 46.1L320 448l-16 16-16-16V434.7 320 288h32H434.7 448l16 16-16 16-6.6 6.6-46.1 46.1 96 96L502.6 480 480 502.6l-11.3-11.3-96-96zM192 109.3L109.3 192H192V109.3zm0 293.5V320H109.3L192 402.7zM320 320v82.7L402.7 320H320zm0-210.7V192h82.7L320 109.3z'
      
    ]
  };

  
    var faCompressArrowsAlt = faMinimize;
  

  
  

  var faSmoking = {
    prefix: 'fasl',
    iconName: 'smoking',
    icon: [
      640,
      512,
      [128684],
      'f48d',
      
      'M448 0h32V43c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v43H544V245c0-21.2-8.4-41.6-23.4-56.6l-21-21C466.5 134.4 448 89.7 448 43V0zM640 288H608V245c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V0h32V43c0 21.2 8.4 41.6 23.4 56.6l21 21c33 33 51.5 77.8 51.5 124.5v43zM0 352H16 192h32H496h16v16V496v16H496 224 192 16 0V496 368 352zm32 32v96H192V384H32zm448 96V384H224v96H480zm96-128v16V496v16H544V496 368 352h32zm64 0v16V496v16H608V496 368 352h32z'
      
    ]
  };

  

  
  

  var faDolly = {
    prefix: 'fasl',
    iconName: 'dolly',
    icon: [
      576,
      512,
      ["dolly-box"],
      'f472',
      
      'M24 0H8V32H24h76.5L211.6 365.4C190.1 379.8 176 404.2 176 432c0 44.2 35.8 80 80 80c43 0 78-33.9 79.9-76.4L565.5 351l15-5.5-11.1-30-15 5.5L330.7 403.4C319.2 373.3 290.1 352 256 352c-5 0-9.9 .5-14.7 1.3L127.2 10.9C125 4.4 118.9 0 112 0H24zM256 384a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm96.8-201.1l5.5 15L388.3 187l-5.5-15-19.2-52.6 60.1-21.9 54.7 150.4L328.2 302.5 273.5 152.2l60.1-21.9 19.2 52.6zM232.5 133.1l10.9 30.1 54.7 150.4 10.9 30.1 30.1-10.9 150.4-54.7 30.1-10.9-10.9-30.1L453.9 86.5 442.9 56.5 412.9 67.4 262.5 122.1l-30.1 10.9z'
      
    ]
  };

  
    var faDollyBox = faDolly;
  

  
  

  var faGem = {
    prefix: 'fasl',
    iconName: 'gem',
    icon: [
      512,
      512,
      [128142],
      'f3a5',
      
      'M278 456.7L256 480l-22-23.3L0 208 112 32H400L512 208 278 456.7zM453 224H256 59L256 433.3 453 224zm10.9-32L386.5 70.4 289.3 192H463.9zM350.7 64H161.3L256 182.4 350.7 64zM125.5 70.4L48.1 192H222.7L125.5 70.4z'
      
    ]
  };

  

  
  

  var faHandshake = {
    prefix: 'fasl',
    iconName: 'handshake',
    icon: [
      640,
      512,
      [],
      'f2b5',
      
      'M217.3 64h55.3l-32 32H223.1l-71.7 60.2-4.5 3.8H144V120.7l63-52.9 4.5-3.8h5.8zm-91 288H112v32 32H80 32 0V384 160 128H32 80h32v32V320h20.9 6.6l4.7 4.7 52 52.1 7 7 11.3 11.3 32.6 32.6 29-29 11.3-11.3 11.3 11.3 26.6 26.6L361 389.7l11.3-11.3 11.3 11.3L399 405l61.3-61.3L348.1 231.7l-77.7 71.7-11.9 11-10.8-12-68.2-75.7L169.1 215l11.4-10.7L324.8 68.3l4.6-4.3h6.3 85.6 5.8l4.5 3.8L496 121.8V160h-4.3l-4.5-3.8L415.5 96H342.1L213.8 216.8l46.9 52 98.1-90.6 11.8-10.9 21.7 23.5-11.8 10.9-8.8 8.1L480.5 318.8H488h40V160 128h32 48 32v32V384v32H608 560 528V384 350.8H498.4l-4.2 4.2L410.3 439 399 450.3 387.6 439l-15.3-15.3-35.6 35.6-11.3 11.3-11.3-11.3-26.6-26.6-29 29-11.3 11.3-11.3-11.3L192 417.7l-11.3-11.3-7-7L126.3 352zM80 160H32V384H80V160zm528 0H560V384h48V160z'
      
    ]
  };

  

  
  

  var faHeadSideMask = {
    prefix: 'fasl',
    iconName: 'head-side-mask',
    icon: [
      576,
      512,
      [],
      'e063',
      
      'M78.7 150.2L276.5 272H288 512v-8.8l-66.6-59.2-5.4-4.8V192c0-88.4-71.6-160-160-160H256C176.1 32 107.6 80.8 78.7 150.2zm-10 31.4C65.6 195.3 64 209.4 64 224c0 54.5 22.6 103.6 59.1 138.5l4.9 4.7v6.8V496v16H96V496 380.8C56.4 340.4 32 285 32 224C32 100.3 132.3 0 256 0h24C383.6 0 468 82 471.9 184.7L538.6 244l5.4 4.8V256v16 16l-4.6 16L480 512H288 256V480 304v-7.1L68.7 181.7zM376 176a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM506.1 304H288V480H455.9l11.4-40H368 352V408h16H476.4l9.1-32H368 352V344h16H494.7l11.4-40z'
      
    ]
  };

  

  
  

  var faLemon = {
    prefix: 'fasl',
    iconName: 'lemon',
    icon: [
      448,
      512,
      [127819],
      'f094',
      
      'M448 80l-24.1 72.3c39.8 83.7 9.9 181.4-56.1 247.4s-163.7 96-247.4 56.1L48 480 0 432l24.1-72.3C-15.7 276 14.2 178.2 80.2 112.2s163.7-96 247.4-56.1L400 32l48 48zM110.2 425.5l12.2-4.1 11.6 5.5c68.2 32.5 151.7 9.4 211-49.9s82.3-142.9 49.9-211l-5.5-11.6 4.1-12.2 17.9-53.6-20-20L337.8 86.5l-12.2 4.1L313.9 85c-68.2-32.5-151.7-9.4-211 49.9S20.6 277.8 53 345.9l5.5 11.6-4.1 12.2L36.6 423.4l20 20 53.6-17.9zM228.3 143c-51.8 23.9-93.4 65.5-117.3 117.3l-8.5 18.4L73.5 265.3l8.5-18.4c27.1-58.7 74.3-105.9 133-133l18.4-8.5 13.4 29.1L228.3 143z'
      
    ]
  };

  

  
  

  var faTick = {
    prefix: 'fasl',
    iconName: 'tick',
    icon: [
      192,
      512,
      [],
      'e32f',
      
      'M56 116.2L89.3 256l13.4 0L136 116.2 136 64 56 64l0 52.2zM136 32l32 0 0 32 0 56L128 288l-64 0L24 120l0-56 0-32 32 0 80 0z'
      
    ]
  };

  

  
  

  var faSquareA = {
    prefix: 'fasl',
    iconName: 'square-a',
    icon: [
      448,
      512,
      [],
      'e25f',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm213.8 96h20.4l4.3 9.2L354 384H318.7l-30-64H159.3l-30 64H94L209.5 137.2l4.3-9.2zM224 181.7L174.2 288h99.5L224 181.7z'
      
    ]
  };

  

  
  

  var faTableColumns = {
    prefix: 'fasl',
    iconName: 'table-columns',
    icon: [
      512,
      512,
      ["columns"],
      'f0db',
      
      'M480 64v96L32 160l0-96 448 0zM32 448l0-256 208 0 0 256L32 448zm240 0l0-256 208 0 0 256H272zM32 32L0 32 0 64 0 448l0 32H32l448 0h32V448l0-384V32l-32 0L32 32z'
      
    ]
  };

  
    var faColumns = faTableColumns;
  

  
  

  var faRotateLeft = {
    prefix: 'fasl',
    iconName: 'rotate-left',
    icon: [
      512,
      512,
      ["rotate-back","rotate-backward","undo-alt"],
      'f2ea',
      
      'M256 64c-48.9 0-93.6 18.3-127.5 48.5l32.9 32.9L184 168l-22.6 22.6L160 192H64 32V160 64l1.4-1.4L56 40 78.6 62.6l27.2 27.2C145.5 53.9 198.2 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-86.4 0-161.4-49-198.8-120.6l28.4-14.8C117.7 406.1 181.9 448 256 448c106 0 192-86 192-192s-86-192-192-192zM64 160h66.7L64 93.3V160z'
      
    ]
  };

  
    var faRotateBack = faRotateLeft;
  
    var faRotateBackward = faRotateLeft;
  
    var faUndoAlt = faRotateLeft;
  

  
  

  var faMartiniGlass = {
    prefix: 'fasl',
    iconName: 'martini-glass',
    icon: [
      512,
      512,
      [127864,"glass-martini-alt"],
      'f57b',
      
      'M157.3 160L256 258.7 354.7 160H157.3zm-31.8-31.8c.8-.1 1.7-.2 2.5-.2H384c.9 0 1.7 .1 2.5 .2L480 34.7V32H32v2.7l93.5 93.5zM480 0h32V32 48L278.6 281.4 272 288V480h96 16v32H368 256 144 128V480h16 96V288l-6.6-6.6L0 48V32 0H32 480z'
      
    ]
  };

  
    var faGlassMartiniAlt = faMartiniGlass;
  

  
  

  var faBracketSquareRight = {
    prefix: 'fasl',
    iconName: 'bracket-square-right',
    icon: [
      192,
      512,
      [],
      '5d',
      
      'M192 32H176 48 32V64H48 160V448H48 32v32H48 176h16V464 48 32z'
      
    ]
  };

  

  
  

  var faArrowUpFromGroundWater = {
    prefix: 'fasl',
    iconName: 'arrow-up-from-ground-water',
    icon: [
      576,
      512,
      [],
      'e4b5',
      
      'M304 352V336 62.6l68.7 68.7L384 142.6 406.6 120l-11.3-11.3-96-96L288 1.4 276.7 12.7l-96 96L169.4 120 192 142.6l11.3-11.3L272 62.6V336v16h32zM32 192H0v32V415c10.2 0 21.3-2.7 32-6.7V224H192V192H32zM576 415V224 192H544 384v32H544V408.3c10.7 4 21.8 6.7 32 6.7zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-14.6-10-26-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C41.7 470.1 20.9 480 0 480v32c30.3 0 57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C518.5 497.9 545.7 512 576 512V480c-20.9 0-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C425.6 470.1 404.9 480 384 480s-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C233.6 470.1 212.9 480 192 480z'
      
    ]
  };

  

  
  

  var faForklift = {
    prefix: 'fasl',
    iconName: 'forklift',
    icon: [
      640,
      512,
      [],
      'f47a',
      
      'M144 0H128V16 160H32 0v32V384v32c0 53 43 96 96 96s96-43 96-96h64c0 53 43 96 96 96s96-43 96-96c0-28.4-12.4-54-32-71.6V288 256v-3.5l-1.5-3.2-112-240L298.2 0H288 144zM128 192h19.5l94.8 87.5 9.2 8.5H264 384v37.5c-10-3.5-20.8-5.5-32-5.5c-41.8 0-77.4 26.7-90.5 64H186.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4V192h96zm136 64L160 160V32H277.8L382.3 256H264zm88 224a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM96 480a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM512 16V0H480V16 432v16h16H624h16V416H624 512V16z'
      
    ]
  };

  

  
  

  var faSquareNfi = {
    prefix: 'fasl',
    iconName: 'square-nfi',
    icon: [
      448,
      512,
      [],
      'e576',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM80 160h8 9.9l4.4 8.8L160 284.2V176 160h32v16V336v16H176h-8-9.9l-4.4-8.8L96 227.8V336v16H64V336 176 160H80zm160 0h64 16v32H304 256v32h48 16v32H304 256v80 16H224V336 240 176 160h16zm144 16V336v16H352V336 176 160h32v16z'
      
    ]
  };

  

  
  

  var faHouseTsunami = {
    prefix: 'fasl',
    iconName: 'house-tsunami',
    icon: [
      576,
      512,
      [],
      'e515',
      
      'M32 200c0-92 78.8-168 177.9-168c20.6 0 40.4 3.3 58.7 9.4l10-30.4C257.1 3.9 233.9 0 209.9 0C94.8 0 0 88.8 0 200C0 309.1 74 400 191.2 400v0c.3 0 .5 0 .8 0v0l.3 0 .2 0v0c30.1-.1 57.2-14.1 75.7-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 385.9 353.7 400 384 400s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C518.5 385.9 545.7 400 576 400V368c-20.9 0-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C425.6 358.1 404.9 368 384 368s-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2c-16.5 11.2-37.1 21.1-57.9 21.2C125.8 367.9 72 314.1 72 248c0-66.2 53.9-120 120.5-120c18.3 0 35.6 4 51 11.3l13.5-29C237.4 101.1 215.5 96 192.5 96C108.3 96 40 164 40 248c0 3 .1 6.1 .3 9.1C34.8 239.3 32 220.1 32 200zm320 80.3V144l96-72L543.5 144l.3 136.2c10.7 4.1 21.8 6.7 32 6.8l-.3-159L448 32 320 128V262.9c8.1 5.6 15.2 10 23.3 13.7c2.9 1.3 5.8 2.5 8.7 3.6zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-14.6-10-26-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C41.7 470.1 20.9 480 0 480v32c30.3 0 57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C518.5 497.9 545.7 512 576 512V480c-20.9 0-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C425.6 470.1 404.9 480 384 480s-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C233.6 470.1 212.9 480 192 480z'
      
    ]
  };

  

  
  

  var faFolderClosed = {
    prefix: 'fasl',
    iconName: 'folder-closed',
    icon: [
      512,
      512,
      [],
      'e185',
      
      'M32 32H224l48 64H480h32v32V448v32H480 32 0V448 64 32H32zm240 96H256l-9.6-12.8L208 64H32V192H480V128H272zM32 224V448H480V224H32z'
      
    ]
  };

  

  
  

  var faCircleSortDown = {
    prefix: 'fasl',
    iconName: 'circle-sort-down',
    icon: [
      512,
      512,
      ["sort-circle-down"],
      'e031',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM176 288H144v32l112 96 112-96V288H336 176zm142.8 32L256 373.9 193.2 320H318.8zM244.7 108.7l-88 88L145.4 208 168 230.6l11.3-11.3L256 142.6l76.7 76.7L344 230.6 366.6 208l-11.3-11.3-88-88L256 97.4l-11.3 11.3z'
      
    ]
  };

  
    var faSortCircleDown = faCircleSortDown;
  

  
  

  var faScrewdriver = {
    prefix: 'fasl',
    iconName: 'screwdriver',
    icon: [
      512,
      512,
      [129691],
      'f54a',
      
      'M352 112v48h48l69.7-93L445 42.3 352 112zM320 96L448 0l64 64L416 192H352h-9.4l-76.7 76.7-22.6-22.6L320 169.4V160 96zM118.6 489.4L96 512 73.4 489.4 22.6 438.6 0 416l22.6-22.6L161.4 254.6 184 232l22.6 22.6 50.7 50.7L280 328l-22.6 22.6L118.6 489.4zM234.7 328L184 277.3 45.3 416 96 466.7 234.7 328z'
      
    ]
  };

  

  
  

  var faShieldXmark = {
    prefix: 'fasl',
    iconName: 'shield-xmark',
    icon: [
      512,
      512,
      ["shield-times"],
      'e24c',
      
      'M48.5 114.9L256 34.3l207.5 80.5c2.7 45.6-4.5 116.8-34.7 186.3S345.4 438.4 256 477.1C166.6 438.4 113.4 370.7 83.2 301.2S45.8 160.5 48.5 114.9zm447-1.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zm-304 55.8l-22.6 22.6 11.3 11.3L233.4 256l-53.3 53.3-11.3 11.3 22.6 22.6 11.3-11.3L256 278.6l53.3 53.3 11.3 11.3 22.6-22.6-11.3-11.3L278.6 256l53.3-53.3 11.3-11.3-22.6-22.6-11.3 11.3L256 233.4l-53.3-53.3-11.3-11.3z'
      
    ]
  };

  
    var faShieldTimes = faShieldXmark;
  

  
  

  var faCaretUp = {
    prefix: 'fasl',
    iconName: 'caret-up',
    icon: [
      320,
      512,
      [],
      'f0d8',
      
      'M32 288H288v-1.7L160 171 32 286.2V288zm0 32H0V288 272L160 128 320 272v16 32H288 32z'
      
    ]
  };

  

  
  

  var faDownFromLine = {
    prefix: 'fasl',
    iconName: 'down-from-line',
    icon: [
      384,
      512,
      ["arrow-alt-from-top"],
      'f349',
      
      'M240 272l0 32 32 0 48 0 0 17.7L192 436.9 64 321.7 64 304l48 0 32 0 0-32 0-112 96 0 0 112zm112 0l-32 0-16 0-32 0 0-32 0-80 0-32-32 0-96 0-32 0 0 32 0 80 0 32-32 0-16 0-32 0 0 32 0 32L192 480 352 336l0-32 0-32zM16 32L0 32 0 64l16 0 352 0 16 0 0-32-16 0L16 32z'
      
    ]
  };

  
    var faArrowAltFromTop = faDownFromLine;
  

  
  

  var faSquareRing = {
    prefix: 'fasl',
    iconName: 'square-ring',
    icon: [
      448,
      512,
      [],
      'e44f',
      
      'M416 64V448H32V64H416zM32 32H0V64 448v32H32 416h32V448 64 32H416 32zm192 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 288a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM160 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm160 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z'
      
    ]
  };

  

  
  

  var fa3 = {
    prefix: 'fasl',
    iconName: '3',
    icon: [
      320,
      512,
      [],
      '33',
      
      'M304 32V55l-5.1 4.8L120.9 224H192c70.7 0 128 57.3 128 128s-57.3 128-128 128H92.8c-38.4 0-73.1-22.9-88.2-58.2l-3.2-7.5 29.4-12.6 3.2 7.5C44 432.7 67.1 448 92.8 448H192c53 0 96-43 96-96s-43-96-96-96H80 64V233l5.1-4.8L247.1 64H16 0V32H16 288h16z'
      
    ]
  };

  

  
  

  var faFileZip = {
    prefix: 'fasl',
    iconName: 'file-zip',
    icon: [
      512,
      512,
      [],
      'e5ee',
      
      'M352 192v96h32V152L232 0H32 0V32 480v32H32 160V480H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM304 352H240 224v32h16 41l-54.9 96.1-2.1 3.7V488v8 16h16 64 16V480H304 263l54.9-96.1 2.1-3.7V376v-8V352H304zm80 16V352H352v16V496v16h32V496 368zm32-16v16 80 48 16h32V496 464h8c30.9 0 56-25.1 56-56s-25.1-56-56-56H432 416zm32 80V384h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8z'
      
    ]
  };

  

  
  

  var faCow = {
    prefix: 'fasl',
    iconName: 'cow',
    icon: [
      640,
      512,
      [128004],
      'f6c8',
      
      'M176.2 96H367.8c-1.3 17.7-8.9 34.5-21.6 47.2l-3.6 3.6C323.9 165.5 298.5 176 272 176s-51.9-10.5-70.6-29.3l-3.6-3.6c-12.7-12.7-20.3-29.4-21.6-47.2zm223.7 0h29.8c26.3 0 50.8 12.9 65.8 34.5l39.4 56.9L564 229.4V192.8h24v12 54.3 5l2.8 4.1L608 293V416H560.8L512 339.3V272v-9.9l-8.8-4.4-64-32L416 214.1V240 416H368V352.2c0-.2 0-.3 0-.5V336c0-53-43-96-96-96s-96 43-96 96v15.8c0 .2 0 .3 0 .5V416H128V144c0-14.8 6.7-28.1 17.3-36.9c3.5 22.1 13.9 42.7 29.9 58.7l3.6 3.6C203.5 194.1 237 208 272 208s68.5-13.9 93.3-38.6l3.6-3.6c18.7-18.7 29.7-43.6 31-69.8zM336 375.8V432v16h16 80 16V432 265.9l32 16V344v4.7l2.5 3.9 56 88 4.7 7.4H552h72 16V432 288v-5l-2.8-4.1L620 254.1V204.8v-28-16H604 555.4l-33.6-48.6C500.9 82 466.5 64 429.7 64H400 384 176 160 144 112c-44.2 0-80 35.8-80 80v88.6C12.9 243.6 0 264.3 0 288v32c35.3 0 64-28.7 64-64V240 224 144c0-26.5 21.5-48 48-48c-10 13.4-16 30-16 48V432v16h16 80 16V432 375.8c6.6 2 14.6 3.8 24 5.3V392v16h32V392v-8.1c2.6 .1 5.3 .1 8 .1s5.4 0 8-.1V392v16h32V392 381.1c9.4-1.5 17.4-3.3 24-5.3zm0-33.8c-2.1 .8-4.7 1.8-7.7 2.7c-11.4 3.5-29.8 7.3-56.3 7.3s-44.9-3.8-56.3-7.3c-3-.9-5.6-1.9-7.7-2.7v-6c0-35.3 28.7-64 64-64s64 28.7 64 64v6zm232-6a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faMicrophone = {
    prefix: 'fasl',
    iconName: 'microphone',
    icon: [
      384,
      512,
      [],
      'f130',
      
      'M128 32H256V256c0 35.3-28.7 64-64 64s-64-28.7-64-64V32zM96 0V32 256c0 53 43 96 96 96s96-43 96-96V32 0H256 128 96zM64 208V192H32v16 48c0 83 63.1 151.2 144 159.2V480H112 96v32h16 80 80 16V480H272 208V415.2c80.9-8 144-76.2 144-159.2V208 192H320v16 48c0 70.7-57.3 128-128 128s-128-57.3-128-128V208z'
      
    ]
  };

  

  
  

  var faWindowFrame = {
    prefix: 'fasl',
    iconName: 'window-frame',
    icon: [
      512,
      512,
      [129695],
      'e04f',
      
      'M240 288V480H64V288H240zm32 192V288H448V480H272zm208 0V32 0H448 64 32V32 480H16 0v32H16 32 64 448h32 16 16V480H496 480zM448 256H272V32H448V256zM64 32H240V256H64V32z'
      
    ]
  };

  

  
  

  var faImage = {
    prefix: 'fasl',
    iconName: 'image',
    icon: [
      512,
      512,
      [],
      'f03e',
      
      'M32 64V329.4l84.7-84.7L128 233.4l11.3 11.3L224 329.4 372.7 180.7 384 169.4l11.3 11.3L480 265.4V64H32zm0 310.6V448h73.4l96-96L128 278.6l-96 96zm352-160L150.6 448H480V310.6l-96-96zM0 32H32 480h32V64 448v32H480 32 0V448 64 32zM160 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faFloppyDiskPen = {
    prefix: 'fasl',
    iconName: 'floppy-disk-pen',
    icon: [
      576,
      512,
      [],
      'e182',
      
      'M32 480H0V448 64 32H32 336L448 144v76.9l-32 32V157.3L322.7 64H320V176v16H304 80 64V176 64H32V448H263.7l-5 32H32zM96 64v96H288V64H96zm80 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zM489.3 269.4l-22.8 22.8L508 333.6l22.8-22.8-41.5-41.5zM334 424.7l-7.7 49.1 49.1-7.7L485.4 356.2l-41.5-41.5L334 424.7zM553.4 288.2L576 310.8l-22.6 22.6L390.7 496.1 321.2 507 288 512.1l5.2-33.2L304 409.4 489.3 224.1l64.1 64.1z'
      
    ]
  };

  

  
  

  var faBucket = {
    prefix: 'fasl',
    iconName: 'bucket',
    icon: [
      448,
      512,
      [],
      'e4cf',
      
      'M82.2 0H96 352h13.8l2 13.6 22 146.4H357.4L338.2 32H109.8L90.6 160H58.2l22-146.4L82.2 0zM0 192H24 56.2 391.8 424h24v32H420L384 512H64L28 224H0V192zm60.2 32l32 256H355.8l32-256H60.2z'
      
    ]
  };

  

  
  

  var faFrog = {
    prefix: 'fasl',
    iconName: 'frog',
    icon: [
      576,
      512,
      [],
      'f52e',
      
      'M368 64c-26.5 0-48 21.5-48 48v16H304h-3.2C152.3 128 32 248.3 32 396.8V448H352V416H336 320 304 265.4l27.3-27.3 8.8-8.8C313.3 368 320 352 320 335.2c0-34.9-28.3-63.2-63.2-63.2c-16.8 0-32.8 6.7-44.7 18.5l-40.8 40.8L160 342.6 137.4 320l11.3-11.3 40.8-40.8C207.3 250 231.6 240 256.8 240c52.6 0 95.2 42.6 95.2 95.2c0 17.3-4.7 34.2-13.5 48.8H352h16 16v16 64 16H368 16 0V464 396.8C0 234.4 128.6 102.1 289.6 96.2C296.9 59.6 329.2 32 368 32c41.4 0 75.4 31.4 79.6 71.7c34.2 6.6 62.8 16.3 83.4 24.7c11.6 4.8 20.8 9.2 27.1 12.4c3.2 1.6 5.6 2.9 7.3 3.9c.8 .5 1.5 .9 2 1.1l.6 .3 .2 .1 .1 0 0 0 0 0s0 0-8.2 13.7l8.2-13.7 7.8 4.7V160v64 9.1l-7.8 4.7L423.7 324.4 519.8 448H560h16v32H560 512h-7.8l-4.8-6.2-112-144-11.1-14.3 15.5-9.3L544 214.9V169.5l-.4-.2c-5.6-2.9-14-6.9-24.7-11.3c-21.5-8.8-52.3-19.1-89.6-25.1l-14.6-2.3 1.2-14.7c.1-1.3 .2-2.6 .2-3.9c0-26.5-21.5-48-48-48zm0 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faMessageLines = {
    prefix: 'fasl',
    iconName: 'message-lines',
    icon: [
      512,
      512,
      ["comment-alt-lines"],
      'f4a6',
      
      'M160 448V416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448zm0-64h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zM144 144H368h16v32H368 144 128V144h16zm0 96H272h16v32H272 144 128V240h16z'
      
    ]
  };

  
    var faCommentAltLines = faMessageLines;
  

  
  

  var faCloudExclamation = {
    prefix: 'fasl',
    iconName: 'cloud-exclamation',
    icon: [
      640,
      512,
      [],
      'e491',
      
      'M544 241.1V232c0-57.4-46.6-104-104-104c-13.4 0-26.2 2.5-37.9 7.1l-24.3 9.5-14.2-22C340.8 87.3 301.1 64 256 64c-70.7 0-128 57.3-128 128v8.2 22.6l-21.3 7.5C63.1 245.8 32 287.3 32 336V448H144 512h96V352c0-35.5-19.2-66.5-48-83.2l-16-9.2V241.1zM0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c56.4 0 106 29.2 134.5 73.3c15.3-6 32-9.3 49.5-9.3c75.1 0 136 60.9 136 136v9.1c38.3 22.1 64 63.5 64 110.9v96 32H608 512 144 32 0V448 336zM336 160v16V304v16H304V304 176 160h32zM296 352h48v48H296V352z'
      
    ]
  };

  

  
  

  var faToriiGate = {
    prefix: 'fasl',
    iconName: 'torii-gate',
    icon: [
      512,
      512,
      [9961],
      'f6a1',
      
      'M416 64h5.2l4.9-1.6 53.9-18V112l-42.7 32L272 144H240L74.7 144 32 112V44.4l53.9 18L90.8 64H96 416zM240 176v80L96 256V176H240zM64 288V496v16H96V496 288l160 0 160 0V496v16h32V496 288h48 16V256H496 448V176l64-48V33.7 0L480 10.7 416 32H96L32 10.7 0 0V33.7 128l64 48v80H16 0v32H16 64zm352-32l-144 0V176H416v80z'
      
    ]
  };

  

  
  

  var faPanelEws = {
    prefix: 'fasl',
    iconName: 'panel-ews',
    icon: [
      512,
      512,
      [],
      'e42e',
      
      'M32 32V289.6C68.5 297 96 329.3 96 368v16c0 17.7 14.3 32 32 32s32-14.3 32-32V352H144 112V320 256 224h32 64 32v32 64 32H208 192v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V368c0-20.9-13.4-38.7-32-45.3V480H480V32H32zM0 0H32 480h32V32 480v32H480 32 0V480 32 0zM112 80h96 16v32H208 112 96V80h16zm192 0h96 16v32H400 304 288V80h16zM112 144h96 16v32H208 112 96V144h16zm192 0h96 16v32H400 304 288V144h16zM208 320V256H144v64h32 32zm112-64V416h64V256H320zm-32-32h32 64 32v32V416v32H384 320 288V416 256 224z'
      
    ]
  };

  

  
  

  var faSubtitles = {
    prefix: 'fasl',
    iconName: 'subtitles',
    icon: [
      576,
      512,
      [],
      'e60f',
      
      'M32 64V448H544V64H32zM0 32H32 544h32V64 448v32H544 32 0V448 64 32zM112 256H304h16v32H304 112 96V256h16zm256 0h96 16v32H464 368 352V256h16zM112 352h96 16v32H208 112 96V352h16zm160 0H464h16v32H464 272 256V352h16z'
      
    ]
  };

  

  
  

  var faSunrise = {
    prefix: 'fasl',
    iconName: 'sunrise',
    icon: [
      576,
      512,
      [127749],
      'f766',
      
      'M288 1.4L276.7 12.7l-96 96L169.4 120 192 142.6l11.3-11.3L272 62.6V208v16h32V208 62.6l68.7 68.7L384 142.6 406.6 120l-11.3-11.3-96-96L288 1.4zm0 279.7l-77.3-41.6L182 224l-9.4 31.3-25.2 84.1L63.3 364.6 32 374l15.5 28.8L71.9 448h36.3L78.8 393.3 156.6 370l16.5-5 5-16.5 23.3-77.8 71.5 38.5 15.2 8.2 15.2-8.2 71.5-38.5L398 348.6l5 16.5 16.5 5 77.8 23.3L467.8 448h36.3l24.4-45.3L544 374l-31.3-9.4-84.1-25.2-25.2-84.1L394 224l-28.8 15.5L288 281.1zM412 448c-14.2-55.2-64.3-96-124-96s-109.8 40.8-124 96h33.4c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H412zM16 480H0v32H16 560h16V480H560 16z'
      
    ]
  };

  

  
  

  var faHockeyMask = {
    prefix: 'fasl',
    iconName: 'hockey-mask',
    icon: [
      448,
      512,
      [],
      'f6ee',
      
      'M224 480c84 0 127.6-19.1 152.7-51.6C403.6 393.6 416 335.4 416 240V32H224 32V240c0 95.4 12.4 153.6 39.3 188.4C96.4 460.9 140 480 224 480zm0 32C48 512 0 432 0 240V32 0H32 224 416h32V32 240c0 192-48 272-224 272zM160 208V192H96v16c0 17.7 14.3 32 32 32s32-14.3 32-32zm-32 64c-35.3 0-64-28.7-64-64V192 160H96h64 32v32 16c0 35.3-28.7 64-64 64zm192-32c17.7 0 32-14.3 32-32V192H288v16c0 17.7 14.3 32 32 32zm64-32c0 35.3-28.7 64-64 64s-64-28.7-64-64V192 160h32 64 32v32 16zM176 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm32 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM176 304a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0-192a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faLacrosseStick = {
    prefix: 'fasl',
    iconName: 'lacrosse-stick',
    icon: [
      512,
      512,
      [],
      'e3b5',
      
      'M344 32v0l.2 0 .2 0c28.8 0 62.8 18.4 90 45.6c27.2 27.2 45.6 61.2 45.6 90.1l0 .1 0 .2 0 .1c0 44.3-28.4 83.6-70.4 97.6L369.7 279l-5.6 1.9-4.6 3.7L301 332.5c-15.4 12.6-34.7 19.5-54.7 19.5c-47.7 0-86.3-38.7-86.3-86.3c0-19.9 6.9-39.2 19.5-54.7l47.9-58.5 3.7-4.6 1.9-5.6 13.3-39.9C260.3 60.4 299.7 32 344 32zM457 55C426.8 24.8 385.1 0 344.3 0L344 0C285.9 0 234.3 37.2 215.9 92.3l-13.3 39.9-47.9 58.5c-17.3 21.1-26.7 47.6-26.7 74.9c0 26.9 9 51.7 24.1 71.6L4.7 484.7l22.6 22.6L174.7 359.9C194.6 375 219.4 384 246.3 384c27.3 0 53.8-9.4 74.9-26.7l58.5-47.9 39.9-13.3c55.1-18.4 92.3-70 92.3-128.1l0-.3c0-40.8-24.8-82.5-55-112.7z'
      
    ]
  };

  

  
  

  var faCustard = {
    prefix: 'fasl',
    iconName: 'custard',
    icon: [
      576,
      512,
      [127854],
      'e403',
      
      'M130.6 190.9l57.6-14.4 4.5-1.1 4.4 1.5L288 207.1l90.9-30.3 4.4-1.5 4.5 1.1 57.6 14.4L422.7 96H153.2l-22.7 94.9zm-8.4 35.1L84.4 384H51.5L128 64H448l76.5 320H491.6L453.8 225.9l-69.2-17.3-91.6 30.5-5.1 1.7-5.1-1.7-91.6-30.5-69.2 17.3zM0 416H16 560h16v32H560 16 0V416z'
      
    ]
  };

  

  
  

  var faMistletoe = {
    prefix: 'fasl',
    iconName: 'mistletoe',
    icon: [
      576,
      512,
      [],
      'f7b4',
      
      'M304 0V16 89.4l91.3 91.3 .7 .7 5.8 1.1 82.9 15.9C537.7 208.6 576 255 576 309c0 41.4-33.6 75-75 75c-54 0-100.3-38.3-110.5-91.3l-15.9-82.9-1.1-5.8-.7-.7L304 134.6V277.3l4 5.3 56.8 75.7C377.3 375 384 395.2 384 416c0 53-43 96-96 96s-96-43-96-96c0-20.8 6.7-41 19.2-57.6L268 282.7l4-5.3V134.6l-68.7 68.7c-.2 .2-.5 .4-.7 .7l-1.1 5.9-.4 2.2c-7.9-2.6-16.3-4-25.1-4c-18 0-34.6 5.9-48 16l-30.7 5.9C59.4 237.2 32 270.3 32 309c0 23.8 19.3 43 43 43c14.8 0 28.8-4 40.9-11.2c7.5 8.5 16.8 15.4 27.3 20.2c-19.1 14.5-42.8 23-68.2 23c-41.4 0-75-33.6-75-75c0-54 38.3-100.3 91.3-110.5l82.9-15.9 5.9-1.1c.2-.2 .4-.5 .7-.7L272 89.4V16 0h32zM478.7 229.9l-70.3-13.5 13.5 70.3c7.3 37.9 40.5 65.3 79.1 65.3c23.8 0 43-19.3 43-43c0-38.6-27.4-71.8-65.3-79.1zM236.8 377.6C228.5 388.7 224 402.2 224 416c0 35.3 28.7 64 64 64s64-28.7 64-64c0-13.8-4.5-27.3-12.8-38.4L288 309.3l-51.2 68.3zM368 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM176 272a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z'
      
    ]
  };

  

  
  

  var faBowlScoops = {
    prefix: 'fasl',
    iconName: 'bowl-scoops',
    icon: [
      448,
      512,
      [127813],
      'e3df',
      
      'M335.3 64.7c-5-.5-10.1-.7-15.3-.7c-7.8 0-15.5 .6-23 1.6C279.4 45.1 253.2 32 224 32s-55.4 13.1-73 33.6c-7.5-1.1-15.2-1.6-23-1.6c-5.2 0-10.3 .2-15.3 .7C134.7 26.1 176.3 0 224 0s89.3 26.1 111.3 64.7zM448 224H416c0-53-43-96-96-96s-96 43-96 96H192c0-70.7 57.3-128 128-128s128 57.3 128 128zM316.2 416h-1.3H272l28.4 32 28.4 32 7.1 8v24H304 144 112V488l7.1-8 28.4-32L176 416H133.2h-1.3C66.1 416 11 366.2 4.5 300.7L3.2 288 0 256H32.2 415.8 448l-3.2 32-1.3 12.7C437 366.2 381.9 416 316.2 416zm-68.1 21.3L224 410.2l-24.1 27.1-38 42.7H286.1l-38-42.7zm-.8-53.3H272h44.2c49.3 0 90.6-37.4 95.5-86.4l1-9.6H35.4l1 9.6c4.9 49.1 46.2 86.4 95.5 86.4H176h24.7 46.5zM200 118.2c-7.1 8-13.3 16.7-18.7 26C166.1 134 147.7 128 128 128c-53 0-96 43-96 96H0C0 153.3 57.3 96 128 96c26.7 0 51.5 8.2 72 22.2z'
      
    ]
  };

  

  
  

  var faSquarePlus = {
    prefix: 'fasl',
    iconName: 'square-plus',
    icon: [
      448,
      512,
      [61846,"plus-square"],
      'f0fe',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM240 160v16 64h64 16v32H304 240v64 16H208V336 272H144 128V240h16 64V176 160h32z'
      
    ]
  };

  
    var faPlusSquare = faSquarePlus;
  

  
  

  var faCircleV = {
    prefix: 'fasl',
    iconName: 'circle-v',
    icon: [
      512,
      512,
      [],
      'e12a',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM125.2 144L241.5 390.8l4.3 9.2h20.3l4.3-9.2L386.8 144H351.5L256 346.5 160.5 144H125.2z'
      
    ]
  };

  

  
  

  var faFileBinary = {
    prefix: 'fasl',
    iconName: 'file-binary',
    icon: [
      384,
      512,
      [],
      'e175',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM80 256H64v16V400v16H80h96 16V400 272 256H176 80zM96 384V288h64v96H96zM240 256H224v32h16 16v96H240 224v32h16 32 32 16V384H304 288V272 256H272 240z'
      
    ]
  };

  

  
  

  var faNfcMagnifyingGlass = {
    prefix: 'fasl',
    iconName: 'nfc-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e1f9',
      
      'M416 64H32V448H352c26.7 20.1 60 32 96 32H416 32 0V448 64 32H32 416h32V64v96c-11 0-21.7 1.1-32 3.2V64zm-32 48v61.3c-11.4 5-22.2 11.3-32 18.7V128H240v82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112 96h16H368h16v16zM320 416H80 64V400 112 96H80h64 16v32H144 96V384H301.3c5 11.4 11.3 22.2 18.7 32zM224 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM448 416.2a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 32c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 29.6-10 56.8-26.9 78.5l78.1 77.7 11.3 11.3-22.6 22.7L604.7 499l-78.2-77.8c-21.7 16.9-48.9 26.9-78.5 26.9z'
      
    ]
  };

  

  
  

  var faWindowRestore = {
    prefix: 'fasl',
    iconName: 'window-restore',
    icon: [
      512,
      512,
      [],
      'f2d2',
      
      'M480 32H160V96H128V32 0h32H480h32V32 352v32H480 416V352h64V32zM352 160H32v96H352V160zM32 480H352V288H32V480zm0-352H352h32v32V480v32H352 32 0V480 160 128H32z'
      
    ]
  };

  

  
  

  var faSailboat = {
    prefix: 'fasl',
    iconName: 'sailboat',
    icon: [
      576,
      512,
      [],
      'e445',
      
      'M288 352H256V320 52.3 0l32 41.4L503.3 320 528 352H487.6 288zm174.8-32L288 93.7V320H462.8zM40 384H536h40l-24 32-72 96H96L24 416 0 384H40zm24 32l48 64H464l48-64H64zm160-64H192 85.5 48l19.6-32L192 116.4 224 64v61.4V320v32zM192 177.7L105.1 320H192V177.7z'
      
    ]
  };

  

  
  

  var faCassetteBetamax = {
    prefix: 'fasl',
    iconName: 'cassette-betamax',
    icon: [
      576,
      512,
      ["betamax"],
      'f8a4',
      
      'M32 160H544V448H32V160zm0-32V64H544v64H32zm544 16V128 64 32H544 32 0V64v64 16 16V448v32H32 544h32V448 160 144zM112 304a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm160 0A96 96 0 1 0 80 304a96 96 0 1 0 192 0zm-72 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm152-48h96v96H352V256zm-32-32v32 96 32h32 96 32V352 256 224H448 352 320z'
      
    ]
  };

  
    var faBetamax = faCassetteBetamax;
  

  
  

  var faCrow = {
    prefix: 'fasl',
    iconName: 'crow',
    icon: [
      640,
      512,
      [],
      'f520',
      
      'M63.2 384l-12.1 9.2L25.7 412.7 6.3 387.3l25.4-19.5 12.1-9.2 8.6-6.6L320 147V96c0-53 43-96 96-96c28.4 0 54 12.4 71.6 32H592l48 48v32L512 144v48c0 78.8-47.5 146.5-115.4 176.1L455.9 512H421.3l-55-133.6C351.4 382.1 336 384 320 384H307.2l52.7 128H325.3L272.6 384H63.2zM512 96v15l91-22.8L578.7 64H506.5c3.5 10 5.5 20.8 5.5 32zM352 162.8v11.6c0 83.1-58.2 154.9-139.5 172.2L186.8 352H320c88.4 0 160-71.6 160-160V128 96c0-35.3-28.7-64-64-64s-64 28.7-64 64v51 5 10.8zm-219.3 168l73.2-15.5C268 302.1 313.6 250 319.4 187.8l-186.7 143zM392 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var fa00 = {
    prefix: 'fasl',
    iconName: '00',
    icon: [
      640,
      512,
      [],
      'e467',
      
      'M144 32C64.5 32 0 96.5 0 176V336c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM32 176C32 114.1 82.1 64 144 64s112 50.1 112 112V336c0 61.9-50.1 112-112 112S32 397.9 32 336V176zM496 32c-79.5 0-144 64.5-144 144V336c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM384 176c0-61.9 50.1-112 112-112s112 50.1 112 112V336c0 61.9-50.1 112-112 112s-112-50.1-112-112V176z'
      
    ]
  };

  

  
  

  var faHexagonDivide = {
    prefix: 'fasl',
    iconName: 'hexagon-divide',
    icon: [
      512,
      512,
      [],
      'e1ad',
      
      'M36.9 256L146.6 64H365.4L475.1 256 365.4 448H146.6L36.9 256zM128 32L0 256 128 480H384L512 256 384 32H128zM280 136H232v48h48V136zM160 240H144v32h16H352h16V240H352 160zm72 88v48h48V328H232z'
      
    ]
  };

  

  
  

  var faUserUnlock = {
    prefix: 'fasl',
    iconName: 'user-unlock',
    icon: [
      640,
      512,
      [],
      'e058',
      
      'M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM87.6 336L43.3 480H384l0 32H33.5 0l9.8-32L64 304H384l0 108.8L360.4 336H87.6zM480 272v48h32 64 32 32v32V480v32H608 448 416V480 352 320h32V272c0-44.2 35.8-80 80-80s80 35.8 80 80H576c0-26.5-21.5-48-48-48s-48 21.5-48 48zM448 480H608V352H448V480z'
      
    ]
  };

  

  
  

  var faSensorFire = {
    prefix: 'fasl',
    iconName: 'sensor-fire',
    icon: [
      640,
      512,
      [],
      'e02a',
      
      'M32 64H416v78.8c5.3-3.8 10.4-7.2 15-10.1l17-10.6V64 32H416 32 0V64 448v32H32 337c-8.8-9.8-16.6-20.5-23.3-32H32V64zm96 80V128H96v16V272v16h32V272 144zm64 0V128H160v16V272v16h32V272 144zm297.4 57.4L448 160c-42.7 26.7-128 102.4-128 192c0 85.2 66.6 154.9 150.7 159.7c3.1 .3 6.2 .4 9.3 .4s6.3-.1 9.3-.4C573.4 506.9 640 437.2 640 352c0-26.7-19.2-96-96-160l-9.4 9.4L512 224l-22.6-22.6zM480 480c-2.4 0-4.8-.1-7.2-.2c-33.6-3.3-56.8-29.4-56.8-57.3c0-21.9 15.9-47.5 39-71.3c8.8-9 17.6-16.9 25-23c7.4 6.1 16.2 13.9 25 23c23.1 23.8 39 49.5 39 71.3c0 27.8-23.2 54-56.8 57.3c-2.4 .1-4.8 .2-7.2 .2zm96-57.4c0-70.4-96-134.4-96-134.4s-96 64-96 134.4c0 5.4 .5 10.6 1.5 15.8C364.7 415.6 352 385.3 352 352c0-34.7 16.7-69.1 41-99.7c16.4-20.6 35.2-38 51.4-50.7l45 45L512 269.3l22.6-22.6L545 236.2C597 288.3 608 337.9 608 352c0 33.3-12.7 63.6-33.5 86.3c1-5.1 1.5-10.4 1.5-15.8z'
      
    ]
  };

  

  
  

  var faFaceExhaling = {
    prefix: 'fasl',
    iconName: 'face-exhaling',
    icon: [
      576,
      512,
      [],
      'e480',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224l0 1.4c4.8-.9 9.8-1.3 14.8-1.3c5.9 0 11.6 .6 17.1 1.8l0-1.8C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c50.1 0 96.9-14.4 136.4-39.3c-7.5-7.6-13.6-16.6-17.8-26.6C340.2 467.6 299.6 480 256 480C132.3 480 32 379.7 32 256zm84.9-21.5L91.3 253.7c34.4 45.9 103.2 45.9 137.6 0l-25.6-19.2c-21.6 28.8-64.8 28.8-86.4 0zm278.4 0c-21.6 28.8-64.8 28.8-86.4 0l-25.6 19.2c34.4 45.9 103.2 45.9 137.6 0l-25.6-19.2zM256.1 360.1a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM452.6 309.9l-.7 0c-24.4 0-44.7 16.9-50.4 39.5l-40.6 20.4-28.6 14.3 28.6 14.3L400.2 418c2.4 26.5 24.5 47.5 51.7 47.5c2.2 0 4.4-.1 6.6-.4c9.3 9.2 22.2 15 36.4 15c26.1 0 47.4-19.3 51.3-44.2c17.9-10.3 29.9-29.7 29.9-51.8s-12-41.6-29.9-51.9c-3.9-24.9-25.3-44.1-51.3-44.1c-17.5 0-32.8 8.7-42.2 21.8zm42.2 10.2c10.8 0 19.9 8.9 19.9 20.4c0 .4 0 .9 0 1.3l-.7 12.2 11.5 3.9c10.7 3.6 18.5 13.9 18.5 26.2s-7.8 22.6-18.5 26.2L514 414.2l.7 12.2c0 .4 0 .9 0 1.3c0 11.4-9.1 20.4-19.9 20.4c-7 0-13.2-3.7-16.8-9.4l-7-11.1-12.2 4.6c-2.1 .8-4.5 1.3-6.9 1.3c-10.8 0-20-8.9-20-20.4c0-1 .1-1.9 .2-2.8l1.5-11.3-10.2-5.1L403.8 384l19.4-9.7 8.3-4.1 .5-9.2c.6-10.8 9.5-19.1 19.9-19.1c1.8 0 3.6 .2 5.2 .7l13.9 3.8 5.2-13.5c3-7.7 10.2-12.9 18.6-12.9z'
      
    ]
  };

  

  
  

  var faTrafficLightGo = {
    prefix: 'fasl',
    iconName: 'traffic-light-go',
    icon: [
      320,
      512,
      [],
      'f638',
      
      'M32 32V352c0 70.7 57.3 128 128 128s128-57.3 128-128V32H32zM0 0H32 288h32V32 352c0 88.4-71.6 160-160 160S0 440.4 0 352V32 0zM160 448a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm0-216a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 80a56 56 0 1 1 0-112 56 56 0 1 1 0 112zM136 120a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0a56 56 0 1 1 -112 0 56 56 0 1 1 112 0z'
      
    ]
  };

  

  
  

  var faEyeLowVision = {
    prefix: 'fasl',
    iconName: 'eye-low-vision',
    icon: [
      640,
      512,
      ["low-vision"],
      'f2a8',
      
      'M27.8 8.1L40.4 18 619.5 469l12.6 9.8-19.7 25.2-12.6-9.8L20.7 43.2 8.1 33.4 27.8 8.1zM576 256c-9.2 22.9-25 52.9-47 83.4l-25.1-19.8c16.3-22.7 28.8-45 37.3-63.6c-15.3-33.3-43.4-78.6-83.2-117C413.4 96.1 356.4 64 288 64c-30.9 0-59.4 6.5-85.5 17.7L174.3 59.5C207.9 42.6 245.9 32 288 32c158.4 0 258 149.3 288 224zM0 256v0l0 0 0 0zM288 128c68.7 0 124.8 54.2 127.9 122.1l-39.2-30.9c-12.6-30.3-40.2-52.7-73.5-58l-39.2-31c7.8-1.5 15.8-2.2 24-2.2zM106 163.5l320 256 12.5 10-20 25-12.5-10L86 188.5l-12.5-10 20-25 12.5 10zm-28.5 62l12.5 10 250 200 12.5 10-20 25-12.5-10L70 260.5l-12.5-10 20-25zM106 336.3l124 99.2 12.5 10-20 25-12.5-10L86 361.3l-12.5-10 20-25 12.5 10z'
      
    ]
  };

  
    var faLowVision = faEyeLowVision;
  

  
  

  var faUpFromDottedLine = {
    prefix: 'fasl',
    iconName: 'up-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e456',
      
      'M176 240V208H144l-48 0V190.3L224 75.1 352 190.3l0 17.7-48 0H272v32V352H176l0-112zM64 240H96h16l32 0v32l0 80v32h32 96 32V352 272 240l32 0h16 32V208l0-32L224 32 64 176l0 32 0 32zM56 424H8v48H56V424zm96 0H104v48h48V424zm48 48h48V424H200v48zm144-48H296v48h48V424zm48 0v48h48V424H392z'
      
    ]
  };

  

  
  

  var faTrain = {
    prefix: 'fasl',
    iconName: 'train',
    icon: [
      448,
      512,
      [128646],
      'f238',
      
      'M32 32H416V224H32V32zm0 224H416V416H342.6 336 112h-6.6H32V256zM374.6 448H416h32V416 32 0H416 32 0V32 416v32H32 73.4L20.7 500.7 9.4 512H54.6l64-64H329.4l64 64h45.3l-11.3-11.3L374.6 448zM256 336a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faLessThanEqual = {
    prefix: 'fasl',
    iconName: 'less-than-equal',
    icon: [
      448,
      512,
      [],
      'f537',
      
      'M42.2 177.1L416 32V66.3L92.2 192 416 317.7V352L42.2 206.9 32 203V181.1l10.2-4zM16 448H432h16v32H432 16 0V448H16z'
      
    ]
  };

  

  
  

  var faHandsBubbles = {
    prefix: 'fasl',
    iconName: 'hands-bubbles',
    icon: [
      576,
      512,
      ["hands-wash"],
      'e05e',
      
      'M384 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM0 240.2L.9 116.6l96 .7L96.7 136 156.9 3.2l58.3 26.4L228.4 .5l87.4 39.6L302.7 69.2 361 95.6l-2.7 6.1-9.5 4.2-34.5 15.3 4.4-9.7L289.5 98.4l-19.2 42.4-19.9 8.8c-8.8 3.9-17.3 8.4-25.4 13.5L273.5 56 244.4 42.8l-66 145.7-29.1-13.2L202 58.8 172.9 45.6 91.4 225.3l-27.3-2.8 .5-73.5-32-.2L32 240.4c-.4 50.3 25.8 96.5 68 122.2c-10.1 5.2-19.2 12.2-26.9 20.6C27.4 350.8-.4 297.6 0 240.2zM334.1 511.4c-37 0-71.4-11.6-99.6-31.3c3.6-10 5.5-20.8 5.5-32.1c0-1.5 0-2.9-.1-4.3c25.1 22.2 58 35.7 94.2 35.7H464h16v-32H464 400 384v-32h16 64l16 0 16 0 16 0v-32H496 400 384v-32h16 96l16 0h16 16v-32H528 512l-16 0H400 384v-32h16 96 16v-32H496 322.8h-8.1l-8.7-26 10.3-4.6L358.5 206l14.6-6.5-13-29.2-14.6 6.5-69.1 30.7C225.1 230.3 192 281.1 192 337.3c0 10.1 1 19.9 3 29.4c-10.3-6.5-21.9-11-34.3-13.2c-.5-5.3-.7-10.7-.7-16.2c0-68.8 40.5-131.1 103.4-159.1l69.1-30.7 29.2-13 14.6-6.5 6.5 14.6 26 58.5 6.5 14.6-14.6 6.5-2.6 1.1H496h32 16v16 48h16 16v16 64 16H560 544v48 16l-16 0-16 0v48 16H496 464 334.1zM176 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 80 448zM512 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  
    var faHandsWash = faHandsBubbles;
  

  
  

  var faChartBar = {
    prefix: 'fasl',
    iconName: 'chart-bar',
    icon: [
      512,
      512,
      ["bar-chart"],
      'f080',
      
      'M32 32V48 448H496h16v32H496 16 0V464 48 32H32zm96 96l16 0 224 0h16v32H368l-224 0H128l0-32zm16 96H304h16v32H304 144 128V224h16zm0 96H432h16v32H432 144 128V320h16z'
      
    ]
  };

  
    var faBarChart = faChartBar;
  

  
  

  var faCloudShowersWater = {
    prefix: 'fasl',
    iconName: 'cloud-showers-water',
    icon: [
      576,
      512,
      [],
      'e4e4',
      
      'M176.1 99.3C178.6 61.7 209.8 32 248 32c26.4 0 49.4 14.2 62 35.4l8.7 14.7 14.1-9.7c7.7-5.3 17-8.4 27.2-8.4c23 0 42.2 16.1 46.9 37.7l2.7 12.6h12.9H432c26.5 0 48 21.5 48 48V192H96V162.3c0-26.5 21.5-48 48-48h16.2 15l1-15zM248 0c-50 0-91.7 35.3-101.7 82.3H144c-44.2 0-80 35.8-80 80V208v16H80 496h16V208 162.3c0-43.4-34.6-78.7-77.7-80C422.5 52.8 393.7 32 360 32c-11.1 0-21.7 2.3-31.3 6.4C309.6 15 280.6 0 248 0zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-14.6-10-26-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C41.7 470.1 20.9 480 0 480v32c30.3 0 57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C518.5 497.9 545.7 512 576 512V480c-20.9 0-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C425.6 470.1 404.9 480 384 480s-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C233.6 470.1 212.9 480 192 480zM136 256H104L32 384H64l72-128zm88 0L152 384h32l72-128H224zm120 0L272 384h32l72-128H344zm48 128h32l72-128H464L392 384z'
      
    ]
  };

  

  
  

  var faSquareCaretUp = {
    prefix: 'fasl',
    iconName: 'square-caret-up',
    icon: [
      448,
      512,
      ["caret-square-up"],
      'f151',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM96 320V288v-8L224 160 352 280v8 32H320 128 96zM224 203.9L134.3 288H313.7L224 203.9z'
      
    ]
  };

  
    var faCaretSquareUp = faSquareCaretUp;
  

  
  

  var faTally = {
    prefix: 'fasl',
    iconName: 'tally',
    icon: [
      640,
      512,
      ["tally-5"],
      'f69c',
      
      'M144 32V48 297.8l96-32V48 32h32V48 255.1l96-32V48 32h32V48 212.5l96-32V48 32h32V48 169.8l74.9-25 15.2-5.1 10.1 30.4-15.2 5.1L528 203.5V464v16H496V464 214.2l-96 32V464v16H368V464 256.9l-96 32V464v16H240V464 299.5l-96 32V464v16H112V464 342.2l-74.9 25-15.2 5.1L11.8 341.9l15.2-5.1L112 308.5V48 32h32z'
      
    ]
  };

  
    var faTally5 = faTally;
  

  
  

  var faGridRound5 = {
    prefix: 'fasl',
    iconName: 'grid-round-5',
    icon: [
      448,
      512,
      [],
      'e5de',
      
      'M40 64A8 8 0 1 1 24 64a8 8 0 1 1 16 0zM32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm8 128a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zM0 448a32 32 0 1 0 64 0A32 32 0 1 0 0 448zM136 64a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM224 56a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM328 64a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM416 56a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm40 96a8 8 0 1 1 -16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z'
      
    ]
  };

  

  
  

  var faHandBackFist = {
    prefix: 'fasl',
    iconName: 'hand-back-fist',
    icon: [
      448,
      512,
      ["hand-rock"],
      'f255',
      
      'M36.7 164.7L96 105.4V64 48 16 0h16 96 16V16 32h48 16V48 64h48 16V80 96h48 16v16 64 16 16 48c0 49.9-25.4 93.9-64 119.8V496v16H320V496 366.9v-9.2l8-4.6c33.5-19.4 56-55.6 56-97V208 192 176 128H336 320V112 96H272 256V80 64H224 208 192V48 32H128V48 64v48 96 16H96V208 150.6l-32 32V256v16c0 48.3 35.8 88.4 82.3 95l13.7 2v13.9V496v16H128V496 396c-55.2-14.2-96-64.3-96-124V256 176v-6.6l4.7-4.7z'
      
    ]
  };

  
    var faHandRock = faHandBackFist;
  

  
  

  var faMarsStrokeRight = {
    prefix: 'fasl',
    iconName: 'mars-stroke-right',
    icon: [
      640,
      512,
      [9897,"mars-stroke-h"],
      'f22b',
      
      'M64 256a144 144 0 1 1 288 0A144 144 0 1 1 64 256zm319.3-16C375.2 150.3 299.8 80 208 80C110.8 80 32 158.8 32 256s78.8 176 176 176c91.8 0 167.2-70.3 175.3-160H432v48 16h32V320 272h81.4l-44.7 44.7L489.4 328 512 350.6l11.3-11.3 72-72L606.6 256l-11.3-11.3-72-72L512 161.4 489.4 184l11.3 11.3L545.4 240H464V192 176H432v16 48H383.3z'
      
    ]
  };

  
    var faMarsStrokeH = faMarsStrokeRight;
  

  
  

  var faPersonChalkboard = {
    prefix: 'fasl',
    iconName: 'person-chalkboard',
    icon: [
      640,
      512,
      [],
      'e53d',
      
      'M168 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 136 56a56 56 0 1 0 112 0zM140.9 128h-9.6l-4.5 8.5-76.9 144-7.5 14.1 28.2 15.1 7.5-14.1L128 202.1V496v16h32V496 352h64V496v16h32V496 160H400h16V128H400 352V32H608V288H352V192H320v96 32h32H608h32V288 32 0H608 352 320V32v96H243.1 140.9zM224 320H160V160h64V320z'
      
    ]
  };

  

  
  

  var faRightLongToLine = {
    prefix: 'fasl',
    iconName: 'right-long-to-line',
    icon: [
      640,
      512,
      [],
      'e444',
      
      'M640 80V64H608V80 432v16h32V432 80zM320 216l32 0V184 141.3L466.7 256 352 370.7V328 296l-32 0L32 296l0-80 288 0zm0-120v32 24 32H288 32 0l0 32 0 80 0 32H32 288h32v32 24 32h32L489.4 278.6 512 256l-22.6-22.6L352 96H320z'
      
    ]
  };

  

  
  

  var faSwapArrows = {
    prefix: 'fasl',
    iconName: 'swap-arrows',
    icon: [
      640,
      512,
      [],
      'e60a',
      
      'M112 17.4l11.3 11.3 80 80L214.6 120 192 142.6l-11.3-11.3L128 78.6V448H304V48 32l16 0 208 0 16 0V48 433.4l52.7-52.7L608 369.4 630.6 392l-11.3 11.3-80 80L528 494.6l-11.3-11.3-80-80L425.4 392 448 369.4l11.3 11.3L512 433.4V64L336 64V464v16H320 112 96V464 78.6L43.3 131.3 32 142.6 9.4 120l11.3-11.3 80-80L112 17.4z'
      
    ]
  };

  

  
  

  var faGrid5 = {
    prefix: 'fasl',
    iconName: 'grid-5',
    icon: [
      448,
      512,
      [],
      'e199',
      
      'M40 56V72H24V56H40zM24 32H0V56 72 96H24 40 64V72 56 32H40 24zM40 152v16H24V152H40zM24 128H0v24 16 24H24 40 64V168 152 128H40 24zm0 120H40v16H24V248zM0 224v24 16 24H24 40 64V264 248 224H40 24 0zM40 344v16H24V344H40zM24 320H0v24 16 24H24 40 64V360 344 320H40 24zm0 120H40v16H24V440zM0 416v24 16 24H24 40 64V456 440 416H40 24 0zM136 56V72H120V56h16zM120 32H96V56 72 96h24 16 24V72 56 32H136 120zm0 120h16v16H120V152zM96 128v24 16 24h24 16 24V168 152 128H136 120 96zm40 120v16H120V248h16zm-16-24H96v24 16 24h24 16 24V264 248 224H136 120zm0 120h16v16H120V344zM96 320v24 16 24h24 16 24V360 344 320H136 120 96zm40 120v16H120V440h16zm-16-24H96v24 16 24h24 16 24V456 440 416H136 120zM216 56h16V72H216V56zM192 32V56 72 96h24 16 24V72 56 32H232 216 192zm40 120v16H216V152h16zm-16-24H192v24 16 24h24 16 24V168 152 128H232 216zm0 120h16v16H216V248zm-24-24v24 16 24h24 16 24V264 248 224H232 216 192zm40 120v16H216V344h16zm-16-24H192v24 16 24h24 16 24V360 344 320H232 216zm0 120h16v16H216V440zm-24-24v24 16 24h24 16 24V456 440 416H232 216 192zM328 56V72H312V56h16zM312 32H288V56 72 96h24 16 24V72 56 32H328 312zm0 120h16v16H312V152zm-24-24v24 16 24h24 16 24V168 152 128H328 312 288zm40 120v16H312V248h16zm-16-24H288v24 16 24h24 16 24V264 248 224H328 312zm0 120h16v16H312V344zm-24-24v24 16 24h24 16 24V360 344 320H328 312 288zm40 120v16H312V440h16zm-16-24H288v24 16 24h24 16 24V456 440 416H328 312zM408 56h16V72H408V56zM384 32V56 72 96h24 16 24V72 56 32H424 408 384zm40 120v16H408V152h16zm-16-24H384v24 16 24h24 16 24V168 152 128H424 408zm0 120h16v16H408V248zm-24-24v24 16 24h24 16 24V264 248 224H424 408 384zm40 120v16H408V344h16zm-16-24H384v24 16 24h24 16 24V360 344 320H424 408zm0 120h16v16H408V440zm-24-24v24 16 24h24 16 24V456 440 416H424 408 384z'
      
    ]
  };

  

  
  

  var faArrowDownToLine = {
    prefix: 'fasl',
    iconName: 'arrow-down-to-line',
    icon: [
      384,
      512,
      ["arrow-to-bottom"],
      'f33d',
      
      'M16 480L0 480l0-32 16 0 352 0 16 0 0 32-16 0L16 480zM203.3 379.3L192 390.6l-11.3-11.3-128-128L41.4 240 64 217.4l11.3 11.3L176 329.4 176 224l0-176 0-16 32 0 0 16 0 176 0 105.4L308.7 228.7 320 217.4 342.6 240l-11.3 11.3-128 128z'
      
    ]
  };

  
    var faArrowToBottom = faArrowDownToLine;
  

  
  

  var faRepeat1 = {
    prefix: 'fasl',
    iconName: 'repeat-1',
    icon: [
      512,
      512,
      [128258],
      'f365',
      
      'M320 0V32 80H16 0V96 256v16H32V256 112H320v48 32h32l73.4-73.4L448 96 425.4 73.4 352 0H320zm32 112V80 45.3L402.7 96 352 146.7V112zM512 240l-32 0v16l0 144-288 0V352 320H160L86.6 393.4 64 416l22.6 22.6L160 512h32V480 432l304 0h16V416l0-160V240zM160 466.7L109.3 416 160 365.3V466.7zM240 192H224v32h16 16v80 16h32V304 208 192H272 240z'
      
    ]
  };

  

  
  

  var faBuildingCircleCheck = {
    prefix: 'fasl',
    iconName: 'building-circle-check',
    icon: [
      640,
      512,
      [],
      'e4d2',
      
      'M32 32H352V266.8c9.1-12.9 19.9-24.5 32-34.6V32 0H352 32 0V32 480v32H32h96 32 64 32 96 32v-8.2c-12.1-10-22.9-21.7-32-34.6V480H256V400 368H224 160 128v32 80H32V32zM160 480V400h64v80H160zM64 96v16 64 16H80h64 16V176 112 96H144 80 64zm32 32h32v32H96V128zM240 96H224v16 64 16h16 64 16V176 112 96H304 240zm16 64V128h32v32H256zM64 224v16 64 16H80h64 16V304 240 224H144 80 64zm32 32h32v32H96V256zm144-32H224v16 64 16h16 64 16V304 240 224H304 240zm16 64V256h32v32H256zm240-32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm78.6-176L552 313.4l-11.3 11.3L480 385.4l-28.7-28.7L440 345.4 417.4 368l11.3 11.3 40 40L480 430.6l11.3-11.3 72-72L574.6 336z'
      
    ]
  };

  

  
  

  var faBurgerCheese = {
    prefix: 'fasl',
    iconName: 'burger-cheese',
    icon: [
      512,
      512,
      [127828,"cheeseburger"],
      'f7f1',
      
      'M477.7 224C462.2 115.4 368.8 32 256 32S49.8 115.4 34.3 224c-1.5 10.5-2.3 21.1-2.3 32H64 224h14.5H401.5 416h32 32c0-10.9-.8-21.5-2.3-32zM448 352H430.5l-48 32H448v64H64V384H257.5l-48-32H64 32v32 64 32H64 448h32V448 384 352H448zm-2.7-128H66.7C81.9 133.2 160.9 64 256 64s174.1 69.2 189.3 160zM160 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM32 288H16v32H32 219.2l92 61.3 8.9 5.9 8.9-5.9 92-61.3H480h16V288H480 416h-4.8l-4 2.7L320 348.8l-87.1-58.1-4-2.7H224 32z'
      
    ]
  };

  
    var faCheeseburger = faBurgerCheese;
  

  
  

  var faChessBoard = {
    prefix: 'fasl',
    iconName: 'chess-board',
    icon: [
      448,
      512,
      [],
      'f43c',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM80 96h72 72 72 72 16v16 72 72 72 72 16H368 296 224 152 80 64V400 328 256 184 112 96H80zm16 72h40V128H96v40zm72 0h40V128H168v40zm72 0h40V128H240v40zm72 0h40V128H312v40zm0 32v40h40V200H312zm0 72v40h40V272H312zm0 72v40h40V344H312zm-32 0H240v40h40V344zm-72 0H168v40h40V344zm-72 0H96v40h40V344zm0-32V272H96v40h40zm0-72V200H96v40h40zm32 0h40V200H168v40zm72 0h40V200H240v40zm0 32v40h40V272H240zm-32 0H168v40h40V272z'
      
    ]
  };

  

  
  

  var faBringFront = {
    prefix: 'fasl',
    iconName: 'bring-front',
    icon: [
      640,
      512,
      [],
      'f857',
      
      'M32 32H224V64h32V32 0H224 32 0V32 224v32H32h96V224H32V32zM384 480v32h32H608h32V480 288 256H608 512v32h96V480H416V448H384v32zm64-352V384H192V128H448zM192 96H160v32V384v32h32H448h32V384 128 96H448 192zm64 96H384V320H256V192zm-32-32v32V320v32h32H384h32V320 192 160H384 256 224z'
      
    ]
  };

  

  
  

  var faUpLeft = {
    prefix: 'fasl',
    iconName: 'up-left',
    icon: [
      384,
      512,
      [],
      'e2bd',
      
      'M144 274.7l22.6 22.6L272 402.7 338.7 336 233.4 230.6 210.7 208l22.6-22.6L282.7 136l-8-8H64V338.7l8 8 49.4-49.4L144 274.7zM94.6 369.4L72 392 49.4 369.4 32 352V128 96H64 288l17.4 17.4L328 136l-22.6 22.6-26.7 26.7L256 208l22.6 22.6 82.7 82.7L384 336l-22.6 22.6-66.7 66.7L272 448l-22.6-22.6-82.7-82.7L144 320l-22.6 22.6L94.6 369.4z'
      
    ]
  };

  

  
  

  var faSquareQuote = {
    prefix: 'fasl',
    iconName: 'square-quote',
    icon: [
      448,
      512,
      [],
      'e329',
      
      'M416 64V448H32V64H416zM32 32H0V64 448v32H32 416h32V448 64 32H416 32zM208 288V272 240 216 192 160H176 128 96v32 48 32h32 48v16c0 17.7-14.3 32-32 32H128 112v32h16 16c35.3 0 64-28.7 64-64zm-32-48H128V192h48v24 24zm176 32V240 216 192 160H320 272 240v32 48 32h32 48v16c0 17.7-14.3 32-32 32H272 256v32h16 16c35.3 0 64-28.7 64-64V272zm-32-56v24H272V192h48v24z'
      
    ]
  };

  

  
  

  var faHoodCloak = {
    prefix: 'fasl',
    iconName: 'hood-cloak',
    icon: [
      576,
      512,
      [],
      'f6ef',
      
      'M0 464l64-80V288C64 128 160 0 288 0H434.7 480L448 32 430.2 49.8l-23 23c8.9 6 17.3 12.7 25.3 20C480.8 136.9 512 203.5 512 288v96l64 80v16 32H544 32 0V480 464zM288 32C185 32 96 137.4 96 288v96 11.2L89 404 32 475.2V480H160V320c0-70.7 57.3-128 128-128s128 57.3 128 128V480H544v-4.8L487 404l-7-8.8V384 288c0-88.6-37.8-152.6-90.8-188.7L357.2 77.5l27.3-27.3L402.7 32H288zM192 480H384V320c0-53-43-96-96-96s-96 43-96 96V480z'
      
    ]
  };

  

  
  

  var faGlasses = {
    prefix: 'fasl',
    iconName: 'glasses',
    icon: [
      576,
      512,
      [],
      'f530',
      
      'M68.2 32.6l14 2.5 72.7 13.2 15.7 2.9-5.7 31.5-15.7-2.9L90.4 69.1 32.7 256H224h32v32h64V256h32H543.3L485.6 69.1 426.9 79.7l-15.7 2.9-5.7-31.5 15.7-2.9 72.7-13.2 14-2.5L512 46.1l63.3 205.2 .7 2.3V256v0 32 48 16 96 32H544 352 320V448 320H256V448v32H224 32 0V448 352 336 288 256v0-2.4l.7-2.3L64 46.1l4.2-13.6zM544 352V336 288H352V448H544V352zM32 336v16 96H224V288H32v48z'
      
    ]
  };

  

  
  

  var faPaintbrushFine = {
    prefix: 'fasl',
    iconName: 'paintbrush-fine',
    icon: [
      576,
      512,
      ["paint-brush-alt","paint-brush-fine","paintbrush-alt"],
      'f5a9',
      
      'M575.3 91.2L552.7 68.6 507.4 23.3 484.8 .7 462.2 23.3 439.6 45.9 195.7 289.7c-6.4-1.1-13-1.7-19.7-1.7c-61.9 0-112 50.1-112 112v48 32H32h0H16 0v32H16 32 64 96h80 0c61.9 0 112-50.1 112-112c0-6.8-.6-13.4-1.7-19.8L530 136.5l22.6-22.6 22.6-22.6zM274.5 346.7l-4.6 4.6L224.6 306l40.7-40.7 0 0L302 228.7l45.3 45.3-72.8 72.8 0 0zm-21 33.5c1.6 6.3 2.5 13 2.5 19.9c0 44.2-35.8 80-80 80h0H96V400c0-44.2 35.8-80 80-80c6.9 0 13.5 .9 19.9 2.5l57.7 57.7zM507.4 113.8L369.9 251.3 324.7 206 462.2 68.6l22.6-22.6 45.2 45.3-22.6 22.6z'
      
    ]
  };

  
    var faPaintBrushAlt = faPaintbrushFine;
  
    var faPaintBrushFine = faPaintbrushFine;
  
    var faPaintbrushAlt = faPaintbrushFine;
  

  
  

  var faChessQueen = {
    prefix: 'fasl',
    iconName: 'chess-queen',
    icon: [
      512,
      512,
      [9819],
      'f445',
      
      'M256 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM176 128h32s0 48 48 48s48-48 48-48h32 32c0 26.2 5.4 52.5 33.8 61.1c13.9 4.2 28.4-2 39.7-11.1L464 160l48 32L418.7 352h-37l87.6-150.1-3.5-2.3-4.2 3.4c-14.6 11.7-40.1 25.5-69 16.8c-23.7-7.2-39.1-22.7-47.5-41.5c-2.7-6-4.6-12.2-6-18.3h-9.6c-.8 2.1-1.8 4.2-2.8 6.3c-4.9 9.8-12.7 20.6-25.1 28.8C288.9 203.5 273.6 208 256 208s-32.9-4.5-45.5-12.9c-12.4-8.2-20.2-19-25.1-28.8c-1.1-2.1-2-4.2-2.8-6.3h-9.6c-1.4 6.1-3.3 12.3-6 18.3c-8.4 18.7-23.8 34.3-47.5 41.5c-28.9 8.7-54.4-5.1-69-16.8l-4.2-3.4-3.5 2.3L130.4 352h-37L0 192l48-32 22.5 18c11.3 9.1 25.8 15.3 39.7 11.1c28.4-8.6 33.8-34.8 33.8-61.1h32zM96 480H416V463.3L383.2 416H128.8L96 463.3V480zm-32 0V453.3L112 384H400l48 69.3V480v32H416 96 64V480z'
      
    ]
  };

  

  
  

  var faTreasureChest = {
    prefix: 'fasl',
    iconName: 'treasure-chest',
    icon: [
      576,
      512,
      [],
      'f723',
      
      'M128 64V256h64V192 160h32H352h32v32 64h64V64H128zM384 384H352 224 192V352 288H128V448H448V288H384v64 32zM96 69.5C58.7 82.6 32 118.2 32 160v96H96V69.5zM32 288V448H96V288H32zM480 448h64V288H480V448zm64-192V160c0-41.8-26.7-77.4-64-90.5V256h64zM0 160C0 89.3 57.3 32 128 32H448c70.7 0 128 57.3 128 128V448v32H544 32 0V448 160zm352 32H224V352H352V192zm-48 48v64 16H272V304 240 224h32v16z'
      
    ]
  };

  

  
  

  var faMessageArrowUpRight = {
    prefix: 'fasl',
    iconName: 'message-arrow-up-right',
    icon: [
      512,
      512,
      [],
      'e1dd',
      
      'M160 416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448 416zm0-32h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zm32-256H320h16v16V272v16H304V272 182.6L195.3 291.3 184 302.6 161.4 280l11.3-11.3L281.4 160H192 176V128h16z'
      
    ]
  };

  

  
  

  var faFileSlash = {
    prefix: 'fasl',
    iconName: 'file-slash',
    icon: [
      640,
      512,
      [],
      'e3a7',
      
      'M512 326l-32-25.3V192H352h-9.8H320V174.5 160 32H160V48.1L128 22.9V0h32H360L512 152V326zM352 160H474.7L352 37.3V160zM160 211.2V480H480V463.9l32 25.3V512H480 160 128V480 186l32 25.3zM27.8 8.1L40.4 18 619.5 469l12.6 9.8-19.7 25.2-12.6-9.8L20.7 43.2 8.1 33.4 27.8 8.1z'
      
    ]
  };

  

  
  

  var faCoinFront = {
    prefix: 'fasl',
    iconName: 'coin-front',
    icon: [
      512,
      512,
      [],
      'e3fc',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-416a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 352a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm16-272V160H240v16V336v16h32V336 176z'
      
    ]
  };

  

  
  

  var faGaugeCircleBolt = {
    prefix: 'fasl',
    iconName: 'gauge-circle-bolt',
    icon: [
      640,
      512,
      [],
      'e496',
      
      'M256 480c32.2 0 62.8-6.8 90.5-19c5.8 9.3 12.5 18 19.8 26.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-8.4 0-16.7 .6-24.8 1.7C444.3 100.3 358.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-194 0-16 32 0 0 16 0 194c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64zM144 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM72 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM344 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm168-80l-10.7 64H576L472 448l10.7-64H416l104-96z'
      
    ]
  };

  

  
  

  var faTransporter5 = {
    prefix: 'fasl',
    iconName: 'transporter-5',
    icon: [
      512,
      512,
      [],
      'e2a6',
      
      'M480 16V32h16 16V64H496 480V80 96H448V80 64H432 416V32h16 16V16 0h32V16zM64 144v16H80 96v32H80 64v16 16H32V208 192H16 0V160H16 32V144 128H64v16zM208 0h16 64 16V32H288 224 208V0zM160 128h16H336h16v32H336 176 160V128zM96 256h16H400h16v32H400 112 96V256zm64 128h16H336h16v32H336 176 160V384zM96 448h16H400h16v16 32 16H384V496 480H128v16 16H96V496 464 448z'
      
    ]
  };

  

  
  

  var faVolume = {
    prefix: 'fasl',
    iconName: 'volume',
    icon: [
      576,
      512,
      [128265,"volume-medium"],
      'f6a8',
      
      'M181.3 328.1l-9.1-8.1H160 64V192h96 12.2l9.1-8.1L316.2 64H320V448h-3.8L181.3 328.1zM32 352H64h96L304 480h16 32V448 64 32H320 304L160 160H64 32v32V320v32zm409.6-19.2C464.9 315.3 480 287.4 480 256s-15.1-59.3-38.4-76.8l-19.2 25.6C437.9 216.5 448 235.1 448 256s-10.1 39.5-25.6 51.2l19.2 25.6zm57.6 76.8c46.6-35 76.8-90.8 76.8-153.6s-30.2-118.6-76.8-153.6L480 128c38.9 29.2 64 75.7 64 128s-25.1 98.8-64 128l19.2 25.6z'
      
    ]
  };

  
    var faVolumeMedium = faVolume;
  

  
  

  var faDiceTwo = {
    prefix: 'fasl',
    iconName: 'dice-two',
    icon: [
      448,
      512,
      [9857],
      'f528',
      
      'M416 64V448H32V64H416zM32 32H0V64 448v32H32 416h32V448 64 32H416 32zM152 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM320 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faGift = {
    prefix: 'fasl',
    iconName: 'gift',
    icon: [
      512,
      512,
      [127873],
      'f06b',
      
      'M365.1 32c-17.6 0-33.9 9-43.2 23.9l-45 72.1H288h80c26.5 0 48-21.5 48-48s-21.5-48-48-48h-2.9zm-130 96l-45-72.1C180.8 41 164.5 32 146.9 32H144c-26.5 0-48 21.5-48 48s21.5 48 48 48h80 11.1zM256 101l38.8-62c15.2-24.2 41.7-39 70.3-39H368c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48h48 32v32 96 32H480V480v32H448 64 32V480 288H0V256 160 128H32 80C70 114.6 64 98 64 80C64 35.8 99.8 0 144 0h2.9c28.6 0 55.2 14.7 70.3 39L256 101zM144 160H32v96H64 240V160H224 144zm128 0v96H448h32V160H368 288 272zM240 288H64V480H240V288zm32 192H448V288H272V480z'
      
    ]
  };

  

  
  

  var faMemoCircleInfo = {
    prefix: 'fasl',
    iconName: 'memo-circle-info',
    icon: [
      576,
      512,
      [],
      'e49a',
      
      'M352 32H32V480H296.2c10 12.1 21.7 22.9 34.6 32H32 0V480 32 0H32 352h32V32 198.6c-11.2 3.2-21.9 7.4-32 12.6V32zM64 128H80 304h16v32H304 80 64V128zm16 96H272h16v32H272 80 64V224H80zm0 96H208h16v32H208 80 64V320H80zm464 48a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80v32H416V288h32zM400 448V416h16V368H400V336h16 16 16v16 64h0 16v32H448h0H416h0H400z'
      
    ]
  };

  

  
  

  var faMailboxFlagUp = {
    prefix: 'fasl',
    iconName: 'mailbox-flag-up',
    icon: [
      576,
      512,
      [],
      'e5bb',
      
      'M352 208V112 48 32h16 96 16V48v64 16H464l-80 0v80 16H352V208zM448 96V64l-64 0V96l64 0zm96 112c0-30.5-12.2-58.2-32-78.4V112 88.2c38.6 25.8 64 69.8 64 119.8V416v32H544 288 256 32 0V416 208C0 128.5 64.5 64 144 64H320V96H234.5c32.6 26.4 53.5 66.8 53.5 112V416H544V208zM256 416V208c0-61.9-50.1-112-112-112S32 146.1 32 208V416H256zM96 192h16 64 16v32H176 112 96V192z'
      
    ]
  };

  

  
  

  var faFaceDowncastSweat = {
    prefix: 'fasl',
    iconName: 'face-downcast-sweat',
    icon: [
      512,
      512,
      [],
      'e371',
      
      'M64 48.2l24 27c5.2 5.8 8 13.3 8 21.1C96 113.6 81.7 128 64 128s-32-14.4-32-31.8c0-7.8 2.9-15.3 8-21.1l24-27zM42.6 24.1L16.1 53.9C5.7 65.6 0 80.6 0 96.2C0 131.5 28.8 160 64 160s64-28.5 64-63.8c0-15.6-5.7-30.7-16.1-42.4L85.4 24.1 64 0 42.6 24.1zM96 256v32h16 96 16V256H208 112 96zm192 0v32h16 96 16V256H400 304 288zM195.9 410.7c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7l10.7 11.9 23.8-21.4-10.7-11.9C323.8 371.4 295.7 352 256 352s-67.8 19.4-83.9 37.3l-10.7 11.9 23.8 21.4 10.7-11.9zM256 0c-46.1 0-89.4 12.2-126.8 33.5l11.3 14.1c3 3.7 5.6 7.7 8 11.8C180.4 41.9 217 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224S32 379.7 32 256c0-22.7 3.4-44.6 9.7-65.3c-10.8-1.9-21-5.7-30.1-11.1C4.1 203.7 0 229.4 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0z'
      
    ]
  };

  

  
  

  var faCarBattery = {
    prefix: 'fasl',
    iconName: 'car-battery',
    icon: [
      512,
      512,
      ["battery-car"],
      'f5df',
      
      'M64 64H192V96H64V64zm256 0H448V96H320V64zM32 160V416H480V160H32zM0 128H32 480h32v32V416v32H480 32 0V416 160 128zm384 80v16 32h32 16v32H416 384v32 16H352V320 288H320 304V256h16 32V224 208h32zM96 256h96 16v32H192 96 80V256H96z'
      
    ]
  };

  
    var faBatteryCar = faCarBattery;
  

  
  

  var faDogLeashed = {
    prefix: 'fasl',
    iconName: 'dog-leashed',
    icon: [
      576,
      512,
      [129454],
      'f6d4',
      
      'M336 331.5v43.8V480h64V261.9l-.1 0L307.7 208h-1H288V346.7c2.1-.6 4.2-1.2 6.3-1.9L336 331.5zm-80 20.3V208H192 136 96V480h64V375.3 331.5l41.7 13.3c14.5 4.6 30.1 7.2 46.3 7.2c2.7 0 5.4-.1 8-.2zM405.8 218.7l4.5-26.7h27.1H480c35.3 0 64-28.7 64-64V96H496 482.7l-9.4-9.4L450.7 64H400 384l-9.6-12.8L362.5 35.4 338.2 181.3l-1.1 6.9 67.2 39.2 1.4-8.6zM64 206c-.7-.2-1.4-.3-2.1-.5C39.2 199.6 20 183.9 9.8 162.5c-2.3-4.8-4.1-9.8-5.4-15.1l0 0L.5 131.9l31-7.8 3.9 15.5c.3 1.4 .8 2.7 1.2 4.1c2 5.8 5.1 11.1 9 15.6C54.5 169.7 67.6 176 82 176h54 56 65.7L70.1 28.6 89.9 3.4 307 174 336 0h40l24 32h64l32 32h48 32V96v32c0 53-43 96-96 96H437.3L432 256V480v32H400 336 304V480 408.7 375.3c-10.3 3.3-21 5.7-32 7.1c-7.9 1-15.9 1.6-24 1.6s-16.1-.5-24-1.6c-11-1.4-21.7-3.8-32-7.1v33.3V480v32H160 96 64V480 206zM432 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faMugHot = {
    prefix: 'fasl',
    iconName: 'mug-hot',
    icon: [
      512,
      512,
      [9749],
      'f7b6',
      
      'M96 0V16c0 16.2 6.5 31.8 17.9 43.3l18.7 18.7C150.2 95.5 160 119.3 160 144v16H128V144c0-16.2-6.5-31.8-17.9-43.3L91.3 81.9C73.8 64.5 64 40.7 64 16V0H96zM32 224V480H352V224H336 32zm352 0V384h16c44.2 0 80-35.8 80-80s-35.8-80-80-80H384zm0 192v64 32H352 32 0V480 224 192H32 336h16 32 16c61.9 0 112 50.1 112 112s-50.1 112-112 112H384zM224 16c0 16.2 6.5 31.8 17.9 43.3l18.7 18.7C278.2 95.5 288 119.3 288 144v16H256V144c0-16.2-6.5-31.8-17.9-43.3L219.3 81.9C201.8 64.5 192 40.7 192 16V0h32V16z'
      
    ]
  };

  

  
  

  var faArrowDownSquareTriangle = {
    prefix: 'fasl',
    iconName: 'arrow-down-square-triangle',
    icon: [
      576,
      512,
      ["sort-shapes-down-alt"],
      'f889',
      
      'M160 478.6l11.3-11.3 88-88L270.6 368 248 345.4l-11.3 11.3L176 417.4V48 32H144V48 417.4L83.3 356.7 72 345.4 49.4 368l11.3 11.3 88 88L160 478.6zM296 480h37.7H498.3 536l-20-32L434.9 318.2 416 288l-18.9 30.2L316 448l-20 32zm182.3-32H353.7L416 348.4 478.3 448zM352 64H480V192H352V64zM320 32V64 192v32h32H480h32V192 64 32H480 352 320z'
      
    ]
  };

  
    var faSortShapesDownAlt = faArrowDownSquareTriangle;
  

  
  

  var faSquarePollVertical = {
    prefix: 'fasl',
    iconName: 'square-poll-vertical',
    icon: [
      448,
      512,
      ["poll"],
      'f681',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM144 224V384H112V224h32zm64-96h32V384H208V128zM336 288v96H304V288h32z'
      
    ]
  };

  
    var faPoll = faSquarePollVertical;
  

  
  

  var faJedi = {
    prefix: 'fasl',
    iconName: 'jedi',
    icon: [
      576,
      512,
      [],
      'f669',
      
      'M304 0V16 278.1l51.9-25.9-25.1 50.2L384 320l-53.2 17.7 25.1 50.2L304 361.9v68.9c54.3-7.8 96-54.4 96-110.9c0-36.2-17.1-68.3-43.8-88.8l-18.6-14.3 20.2-12.1C397.5 181 424 137.6 424 88c0-20.3-4.5-39.6-12.4-56.9l23.2-20.2C510 59.3 560 143.8 560 240c0 150.2-121.8 272-272 272S16 390.2 16 240C16 143.8 66 59.3 141.3 10.9l23.2 20.2C156.5 48.4 152 67.7 152 88c0 49.6 26.5 93 66.2 116.8l20.2 12.1-18.6 14.3C193.1 251.7 176 283.8 176 320c0 56.4 41.7 103.1 96 110.9V361.9l-51.9 25.9 25.1-50.2L192 320l53.2-17.7-25.1-50.2L272 278.1V16 0h32zM64.1 153.5l43.2 43.2L118.6 208 96 230.6 84.7 219.3 53.6 188.2c-2.2 9.9-3.8 20.1-4.7 30.5c.8 .6 1.6 1.2 2.4 2l56 56L118.6 288 96 310.6 84.7 299.3 49.2 263.8C61.1 385.2 163.5 480 288 480s226.9-94.8 238.8-216.2l-35.5 35.5L480 310.6 457.4 288l11.3-11.3 56-56c.7-.7 1.5-1.4 2.4-2c-.9-10.4-2.5-20.5-4.7-30.5l-31.1 31.1L480 230.6 457.4 208l11.3-11.3 43.2-43.2c-12.7-32.8-32.3-62.1-57.2-86.1C455.6 74.1 456 81 456 88c0 53.6-25.1 101.4-64.2 132.1C416.7 246 432 281.2 432 320c0 79.5-64.5 144-144 144s-144-64.5-144-144c0-38.8 15.3-74 40.2-99.9C145.1 189.4 120 141.6 120 88c0-7 .4-13.9 1.3-20.6c-24.8 24-44.5 53.3-57.2 86.1z'
      
    ]
  };

  

  
  

  var faTilde = {
    prefix: 'fasl',
    iconName: 'tilde',
    icon: [
      448,
      512,
      [63135],
      '7e',
      
      'M0 128H16 136h7.8l4.8 6.1L319.8 352H416V192 176h32v16V368v16H432 312h-7.8l-4.8-6.1L128.2 160H32V320v16H0V320 144 128z'
      
    ]
  };

  

  
  

  var faMapLocationDot = {
    prefix: 'fasl',
    iconName: 'map-location-dot',
    icon: [
      576,
      512,
      ["map-marked-alt"],
      'f5a0',
      
      'M360.8 166.2C371.4 145.4 376 129.7 376 120c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 9.7 4.6 25.4 15.2 46.2c10.2 20 24.1 41.3 38.6 61.2c12 16.5 24.1 31.7 34.1 43.7c10-12 22.1-27.2 34.1-43.7c14.5-19.9 28.4-41.2 38.6-61.2zM309.2 295.7C296.6 310.7 288 320 288 320s-8.6-9.3-21.2-24.3C232.4 254.7 168 171.3 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120c0 51.3-64.4 134.7-98.8 175.7zm92-70.1l-.5-.2c6.1-9.9 12-20 17.1-30.1c2-3.9 3.9-7.8 5.8-11.9L544 139.6 576 128v34V448L400 512 176 448 32 500.4 0 512V477.9 192l138.3-50.3c2.1 10.3 5.4 20.6 9.4 30.6L32 214.4V466.3l128-46.5V288h32V419.3l192 54.9V288h32V472.1l128-46.5V173.7L410.9 222.1l-9.8 3.5zM288 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faMapMarkedAlt = faMapLocationDot;
  

  
  

  var faBorderTopLeft = {
    prefix: 'fasl',
    iconName: 'border-top-left',
    icon: [
      448,
      512,
      ["border-style"],
      'f853',
      
      'M0 448l0 16 32 0 0-16L32 64l384 0 16 0 0-32-16 0L16 32 0 32 0 48 0 448zm104-24l0 48 48 0 0-48-48 0zm192 0l0 48 48 0 0-48-48 0zm-96 48l48 0 0-48-48 0 0 48zm192-48l0 48 48 0 0-48-48 0zm0-144l48 0 0-48-48 0 0 48zm0 48l0 48 48 0 0-48-48 0zm0-144l48 0 0-48-48 0 0 48z'
      
    ]
  };

  
    var faBorderStyle = faBorderTopLeft;
  

  
  

  var faNotEqual = {
    prefix: 'fasl',
    iconName: 'not-equal',
    icon: [
      448,
      512,
      [],
      'f53e',
      
      'M398.5 32H359.6L282.1 144H32 16v32H32 259.9L149.2 336H32 16v32H32h95L49.5 480H88.4l77.5-112H416h16V336H416 188.1L298.8 176H416h16V144H416 321L398.5 32z'
      
    ]
  };

  

  
  

  var faMoneyCheckPen = {
    prefix: 'fasl',
    iconName: 'money-check-pen',
    icon: [
      640,
      512,
      ["money-check-edit"],
      'f872',
      
      'M544 96H32V416H332.7l-5 32H32 0V416 96 64H32 544h32V96v60.9L548.9 184l-4.9 4.9V96zM384 288v32H96V288H384zM96 192H480v32H96V192zm457.3 77.3L530.5 292 572 333.5l22.8-22.8-41.5-41.5zM398 424.5l-7.7 49.1 49.1-7.7L549.4 356.1l-41.5-41.5L398 424.5zM617.4 288.1L640 310.7l-22.6 22.6L454.7 496l-69.5 10.8L352 512l5.2-33.2L368 409.3 553.3 224l64.1 64.1z'
      
    ]
  };

  
    var faMoneyCheckEdit = faMoneyCheckPen;
  

  
  

  var faManatSign = {
    prefix: 'fasl',
    iconName: 'manat-sign',
    icon: [
      384,
      512,
      [],
      'e1d5',
      
      'M208 32H176V96.7C77.4 104.8 0 187.3 0 288V464v16H32V464 288c0-83 63.1-151.2 144-159.2V480h32V128.8c80.9 8 144 76.2 144 159.2V464v16h32V464 288c0-100.7-77.4-183.2-176-191.3V32z'
      
    ]
  };

  

  
  

  var faSquareK = {
    prefix: 'fasl',
    iconName: 'square-k',
    icon: [
      448,
      512,
      [],
      'e274',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm128 96h32v16V259.7L290.9 128h45.1L226.4 238.3 328.3 384H289.3L203.4 261.4 160 305.1V368v16H128V368 298.5 144 128z'
      
    ]
  };

  

  
  

  var faCircleDownRight = {
    prefix: 'fasl',
    iconName: 'circle-down-right',
    icon: [
      512,
      512,
      [],
      'e108',
      
      'M256 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm96 368h16V352 192v-6.6l-4.7-4.7-16-16L336 153.4l-11.3 11.3L284 205.4l-64.7-64.7L208 129.4l-11.3 11.3-56 56L129.4 208l11.3 11.3L205.4 284l-40.7 40.7L153.4 336l11.3 11.3 16 16 4.7 4.7H192 352zM336 198.6V336H198.6l40.7-40.7L250.6 284l-11.3-11.3L174.6 208 208 174.6l64.7 64.7L284 250.6l11.3-11.3L336 198.6z'
      
    ]
  };

  

  
  

  var faEngineWarning = {
    prefix: 'fasl',
    iconName: 'engine-warning',
    icon: [
      640,
      512,
      ["engine-exclamation"],
      'f5f2',
      
      'M416 96l-16 0-80 0v32h16 80l96 64V416v32H480 224l-51.2-64H128 96V352 272H88 32v80 16H0V352 160 144H32v16 80H88h8V160 128h32 32H288V96l-80 0H192V64h16H400h16V96zM304 160l-144 0H128V352h44.8 15.4l9.6 12 41.6 52H480V209.1L406.3 160H336l-32 0zm304 64H576V416h32V224zm-32-32h32 32v32V416v32H608 576 544V416 224 192h32zm-256 0v16 80 16H288V288 208 192h32zM280 376V328h48v48H280z'
      
    ]
  };

  
    var faEngineExclamation = faEngineWarning;
  

  
  

  var faTransporter3 = {
    prefix: 'fasl',
    iconName: 'transporter-3',
    icon: [
      512,
      512,
      [],
      'e045',
      
      'M480 16V0H448V16 32H432 416V64h16 16V80 96h32V80 64h16 16V32H496 480V16zM64 112V96H32v16 16H16 0v32H16 32v16 16H64V176 160H80 96V128H80 64V112zM256 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 256 0a56 56 0 1 0 0 112zM416 448H400 112 96v16 32 16h32V496 480H384v16 16h32V496 464 448zM160 128v32h16H336h16V128H336 176 160zm-32 64v32h16H368h16V192H368 144 128zM96 256v32h16H400h16V256H400 112 96zm64 64v32h16H336h16V320H336 176 160zm0 64v32h16H336h16V384H336 176 160z'
      
    ]
  };

  

  
  

  var faBuildingNgo = {
    prefix: 'fasl',
    iconName: 'building-ngo',
    icon: [
      384,
      512,
      [],
      'e4d7',
      
      'M352 32H32V48H0V32 0H32 352h32V32 48H352V32zM0 240H32V480h96V400 368h32 64 32v32 80h96V240h32V480v32H352 256 224 160 128 32 0V480 240zM224 480V400H160v80h64zM32 80H48h8 9.9l4.4 8.8L96 140.2V96 80h32V96v96 16H112h-8H94.1l-4.4-8.8L64 147.8V192v16H32V192 96 80zm136 0h48 16v32H216 184v64h16V160 144h32v16 32 16H216 168 152V192 96 80h16zm120 48v32c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16s-16 7.2-16 16zm16-48c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V128c0-26.5 21.5-48 48-48zM288 240h16v16 64 16H288 224 208V320 256 240h16 64zm-48 32v32h32V272H240zM96 240h64 16v16 64 16H160 96 80V320 256 240H96zm16 64h32V272H112v32z'
      
    ]
  };

  

  
  

  var faAnchorLock = {
    prefix: 'fasl',
    iconName: 'anchor-lock',
    icon: [
      640,
      512,
      [],
      'e4ad',
      
      'M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64 78.4V160v32H208 192v32h16 64V480H96V310.6l28.7 28.7L136 350.6 158.6 328l-11.3-11.3-56-56L80 249.4 68.7 260.7l-56 56L1.4 328 24 350.6l11.3-11.3L64 310.6V496v16H80 288h96l0-32H304V224h64 16V192H368 304V160v-1.6c36.5-7.4 64-39.7 64-78.4c0-44.2-35.8-80-80-80zM528 224c26.5 0 48 21.5 48 48v48H480V272c0-26.5 21.5-48 48-48zm-80 48v48H416v32V480v32h32H608h32V480 352 320H608V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H608V480H448V352z'
      
    ]
  };

  

  
  

  var faBold = {
    prefix: 'fasl',
    iconName: 'bold',
    icon: [
      384,
      512,
      [],
      'f032',
      
      'M0 32H16 48 80 232c66.3 0 120 53.7 120 120c0 38.8-18.4 73.3-46.9 95.2C351.1 264 384 308.1 384 360c0 66.3-53.7 120-120 120H80 48 16 0V448H16 32V256 64H16 0V32zM64 448H80 264c48.6 0 88-39.4 88-88s-39.4-88-88-88H232 64V448zm0-208H232c48.6 0 88-39.4 88-88s-39.4-88-88-88H80 64V240z'
      
    ]
  };

  

  
  

  var faStroopwafel = {
    prefix: 'fasl',
    iconName: 'stroopwafel',
    icon: [
      512,
      512,
      [],
      'f551',
      
      'M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM142.9 120.2l45.3 45.3 45.3-45.3L210.7 97.6 199.4 86.3l22.6-22.6L233.4 75 256 97.6 278.6 75l11.3-11.3 22.6 22.6L301.3 97.6l-22.6 22.6 45.3 45.3 45.3-45.3 11.3-11.3 22.6 22.6-11.3 11.3-45.3 45.3 45.3 45.3 22.6-22.6 11.3-11.3 22.6 22.6L437 233.4 414.4 256 437 278.6l11.3 11.3-22.6 22.6-11.3-11.3-22.6-22.6-45.3 45.3 45.3 45.3 11.3 11.3-22.6 22.6-11.3-11.3-45.3-45.3-45.3 45.3 22.6 22.6 11.3 11.3-22.6 22.6L278.6 437 256 414.4 233.4 437l-11.3 11.3-22.6-22.6 11.3-11.3 22.6-22.6-45.3-45.3-45.3 45.3-11.3 11.3-22.6-22.6 11.3-11.3 45.3-45.3-45.3-45.3L97.6 301.3 86.3 312.6 63.7 289.9 75 278.6 97.6 256 75 233.4 63.7 222.1l22.6-22.6 11.3 11.3 22.6 22.6 45.3-45.3-45.3-45.3-11.3-11.3 22.6-22.6 11.3 11.3zm45.3 90.5L142.9 256l45.3 45.3L233.4 256l-45.3-45.3zm181 45.3l-45.3-45.3L278.6 256l45.3 45.3L369.1 256zm-67.9 67.9L256 278.6l-45.3 45.3L256 369.1l45.3-45.3zM210.7 188.1L256 233.4l45.3-45.3L256 142.9l-45.3 45.3z'
      
    ]
  };

  

  
  

  var faSignature = {
    prefix: 'fasl',
    iconName: 'signature',
    icon: [
      640,
      512,
      [],
      'f5b7',
      
      'M160 128c0-35.3 28.7-64 64-64s64 28.7 64 64v3.4c0 26.2-2.4 52.3-7.2 78L107.8 256.6 96 259.8V272 464v16h16 80 9.4l4.6-8.2L247.5 398c20.9-37.1 37.2-76.5 48.5-117.5l7.2-25.7c1.8-6.5 3.5-13 5-19.6l125.5-34.2-48 96L374.1 320H400 560h16V288H560 425.9l52.4-104.8 16-32-34.5 9.4L314.8 200.1c3.4-22.7 5.2-45.7 5.2-68.7V128c0-53-43-96-96-96s-96 43-96 96v48 16h32V176 128zM128 284.2l144.7-39.5-.4 1.4-7.2 25.7c-10.7 38.5-26 75.6-45.6 110.4l-37 65.7H128V284.2zM16 384H0v32H16 48 64V384H48 16zm320 0H320v32h16H624h16V384H624 336z'
      
    ]
  };

  

  
  

  var faCaduceus = {
    prefix: 'fasl',
    iconName: 'caduceus',
    icon: [
      512,
      512,
      [],
      'e681',
      
      'M256 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16 61.3c18.6-6.6 32-24.4 32-45.3c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 20.9 13.4 38.7 32 45.3l0 31.4L135.8 66.1l-10.6-5.9-8.6 8.6-112 112L0 185.4 0 192l0 16 0 16 16 0 130.1 0c33 0 65.3-9.3 93.3-26.8l.6-.4 0 148.5-39-21.3c-15.4-8.4-25-24.6-25-42.1l0-10 0-16-32 0 0 16 0 10c0 29.3 16 56.2 41.7 70.2l36.9 20.1-20.9 11.4c-25.7 14-41.7 41-41.7 70.2l0 10 0 16 32 0 0-16 0-10c0-17.6 9.6-33.7 25-42.1l23-12.5 0 48.7 0 64 32 0 0-64 0-48.7 23 12.5c15.4 8.4 25 24.6 25 42.1l0 10 0 16 32 0 0-16 0-10c0-29.3-16-56.2-41.7-70.2l-20.9-11.4 36.9-20.1c25.7-14 41.7-41 41.7-70.2l0-10 0-16-32 0 0 16 0 10c0 17.6-9.6 33.7-25 42.1l-39 21.3 0-148.5 .6 .4c28 17.5 60.3 26.8 93.3 26.8L496 224l16 0 0-16 0-16 0-6.6-4.7-4.7-112-112-8.6-8.6-10.6 5.9L272 124.6l0-31.4zM473.4 192l-107.5 0c-27 0-53.4-7.6-76.3-21.9l-15.7-9.8L381.3 99.9 473.4 192zM130.7 99.9l107.4 60.4-15.7 9.8c-22.9 14.3-49.3 21.9-76.3 21.9L38.6 192l92.1-92.1z'
      
    ]
  };

  

  
  

  var faSquareO = {
    prefix: 'fasl',
    iconName: 'square-o',
    icon: [
      448,
      512,
      [],
      'e278',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM128 256a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm96 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faBinarySlash = {
    prefix: 'fasl',
    iconName: 'binary-slash',
    icon: [
      640,
      512,
      [],
      'e33e',
      
      'M432 224h64 16V192H496 448V16 0H432 368 352V32h16 48V192H368 352v7.7L382.8 224H432zM320 16V0H304 144 128V16v6.9l32 25.3V32H288V149.2l32 25.3V16zm0 480v16h16H496h16V496v-6.9l-32-25.3V480H352V362.8l-32-25.3V496zM144 288H128v32h16 48V480H144 128v32h16 64 64 16V480H272 224V304 288H208 144zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faUserPen = {
    prefix: 'fasl',
    iconName: 'user-pen',
    icon: [
      640,
      512,
      ["user-edit"],
      'f4ff',
      
      'M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM43.3 480L87.6 336H360.4l8.6 27.9 25.6-25.6L384 304H64L9.8 480 0 512H33.5 317.8l5-32H43.3zm510-210.7l41.5 41.5L572 333.5 530.5 292l22.8-22.8zM398 424.5L507.9 314.6l41.5 41.5L439.5 466l-49.1 7.7 7.7-49.1zM617.4 288.1L553.3 224 368 409.3l-10.8 69.5L352 512l33.2-5.2L454.7 496 617.4 333.3 640 310.7l-22.6-22.6z'
      
    ]
  };

  
    var faUserEdit = faUserPen;
  

  
  

  var faPrescriptionBottlePill = {
    prefix: 'fasl',
    iconName: 'prescription-bottle-pill',
    icon: [
      576,
      512,
      [],
      'e5c0',
      
      'M352 32V96H32V32H352zM32 0H0V32 96v32H32 352h32V96 32 0H352 32zm0 160V480v32H64 320h10.8c-12.9-9.1-24.5-19.9-34.6-32H64V416h80 16V384H144 64V320h80 16V288H144 64V224h80 16V192H144 64V160H32zm320 0H320v72.2c9.8-8.1 20.6-15.2 32-21V160zm80 96a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM384 297.4L361.4 320l11.3 11.3 96 96L480 438.6 502.6 416l-11.3-11.3-96-96L384 297.4z'
      
    ]
  };

  

  
  

  var faUnderline = {
    prefix: 'fasl',
    iconName: 'underline',
    icon: [
      448,
      512,
      [],
      'f0cd',
      
      'M0 32H16 144h16V64H144 96V224c0 70.7 57.3 128 128 128s128-57.3 128-128V64H304 288V32h16H432h16V64H432 384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V64H16 0V32zM0 448H16 432h16v32H432 16 0V448z'
      
    ]
  };

  

  
  

  var faRectangleHistoryCirclePlus = {
    prefix: 'fasl',
    iconName: 'rectangle-history-circle-plus',
    icon: [
      640,
      512,
      [],
      'e4a3',
      
      'M480 160v32.7c5.3-.5 10.6-.7 16-.7s10.7 .2 16 .7V160 128H480L32 128H0v32V480v32H32l362.8 0c-12.9-9.1-24.5-19.9-34.6-32L32 480l0-320 448 0zM464 64L48 64V96l416 0V64zM416 0H96V32l320 0V0zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 304V288H480v16 48H432 416v32h16 48v48 16h32V432 384h48 16V352H560 512V304z'
      
    ]
  };

  

  
  

  var faUmbrellaSimple = {
    prefix: 'fasl',
    iconName: 'umbrella-simple',
    icon: [
      512,
      512,
      ["umbrella-alt"],
      'e2bc',
      
      'M272 16V0H240V16 32.5C116.7 40.1 17.1 134.9 2 256c-1.3 10.5-2 21.2-2 32H32 480h32c0-10.8-.7-21.5-2-32C494.9 134.9 395.3 40.1 272 32.5V16zm0 430.6V320H240V446.6c0 18.5-15 33.4-33.4 33.4c-12.7 0-24.2-7.2-29.9-18.5l-2.3-4.7-7.2-14.3-28.6 14.3 7.2 14.3 2.3 4.7C159.1 498 181.8 512 206.6 512c36.1 0 65.4-29.3 65.4-65.4zM34.3 256C49.8 147.4 143.2 64 256 64s206.2 83.4 221.7 192H34.3z'
      
    ]
  };

  
    var faUmbrellaAlt = faUmbrellaSimple;
  

  
  

  var faBath = {
    prefix: 'fasl',
    iconName: 'bath',
    icon: [
      512,
      512,
      [128705,"bathtub"],
      'f2cd',
      
      'M32 0H48h64 6.6l4.7 4.7L161.7 43c11.1-7 24.2-11 38.3-11c20.2 0 38.5 8.3 51.6 21.8l1.1-1.1L264 41.4 286.6 64 275.3 75.3l-104 104L160 190.6 137.4 168l11.3-11.3 1.1-1.1C136.3 142.5 128 124.2 128 104c0-14.1 4-27.2 11-38.3L105.4 32H64V256H448h32 16 16v32H496 480 448 64 32 16 0V256H16 32V16 0zm0 320H64v48c0 26.2 12.6 49.4 32 64h0v0c13.4 10 30 16 48 16H368c18 0 34.6-6 48-16v0h0c19.4-14.6 32-37.8 32-64V320h32v48c0 30.5-12.2 58.2-32 78.4V496v16H416V496 469.2c-14.5 6.9-30.8 10.8-48 10.8H144c-17.2 0-33.5-3.9-48-10.8V496v16H64V496 446.4C44.2 426.2 32 398.5 32 368V320zM200 64c-22.1 0-40 17.9-40 40c0 11.4 4.8 21.7 12.4 29L229 76.4C221.7 68.8 211.4 64 200 64z'
      
    ]
  };

  
    var faBathtub = faBath;
  

  
  

  var faMessages = {
    prefix: 'fasl',
    iconName: 'messages',
    icon: [
      640,
      512,
      ["comments-alt"],
      'f4b6',
      
      'M96 384l32-16 96-48H384h32V288 32 0H384 32 0V32 288v32H32 64 96v28.2V352v32zm113.7-92.6L128 332.2V320 288H96 32V32H384V288H224h-7.6l-6.8 3.4zM256 448h32H416l96 48 32 16V480v-3.8V448h32 32 32V416 160 128H608 448v32H608V416H544 512v32 12.2l-81.7-40.8-6.8-3.4H416 288V352H256v64 32z'
      
    ]
  };

  
    var faCommentsAlt = faMessages;
  

  
  

  var faWifi = {
    prefix: 'fasl',
    iconName: 'wifi',
    icon: [
      640,
      512,
      ["wifi-3","wifi-strong"],
      'f1eb',
      
      'M320 224c-74.1 0-140.8 31.5-187.5 81.7L110.9 282c52.5-55.4 126.8-90 209.1-90s156.6 34.6 209.1 90l-21.6 23.8C460.8 255.5 394.1 224 320 224zm316.9-60.6l-21.6 23.7C540 111.1 435.5 64 320 64S100 111.1 24.6 187.1L3.1 163.4C84.1 82.2 196.2 32 320 32s235.9 50.2 316.9 131.4zM352 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  
    var faWifi3 = faWifi;
  
    var faWifiStrong = faWifi;
  

  
  

  var faFileArrowUp = {
    prefix: 'fasl',
    iconName: 'file-arrow-up',
    icon: [
      384,
      512,
      ["file-upload"],
      'f574',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM208 400V278.6l52.7 52.7L272 342.6 294.6 320l-11.3-11.3-80-80L192 217.4l-11.3 11.3-80 80L89.4 320 112 342.6l11.3-11.3L176 278.6V400v16h32V400z'
      
    ]
  };

  
    var faFileUpload = faFileArrowUp;
  

  
  

  var faHouseCircleExclamation = {
    prefix: 'fasl',
    iconName: 'house-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e50a',
      
      'M288 2.7L298.6 12 502.7 192.1c-2.2-.1-4.5-.1-6.7-.1c-12.8 0-25.3 1.4-37.3 4L288 45.3 96 214.7V480H208V304 288h16H339.2c-5.2 10.1-9.4 20.8-12.6 32H240V480l16 0H360.2c10 12.1 21.7 22.9 34.6 32H80 64V496 243L26.6 276 5.4 252l272-240L288 2.7zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 80H480V416h32v32zm0-160v16 80 16H480V384 304 288h32z'
      
    ]
  };

  

  
  

  var faClipboard = {
    prefix: 'fasl',
    iconName: 'clipboard',
    icon: [
      384,
      512,
      [128203],
      'f328',
      
      'M192 32c-22.3 0-41.2 15.3-46.5 36l-3.1 12H130 96v48h96 96V80H254 241.6l-3.1-12c-5.3-20.7-24.1-36-46.5-36zM118.7 48C131 19.8 159.2 0 192 0s61 19.8 73.3 48H304h16V64 80h32 32v32V480v32H352 32 0V480 112 80H32 64V64 48H80h38.7zM320 160H304 192 80 64V144 112H32V480H352V112H320v32 16zM192 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faHexagonPlus = {
    prefix: 'fasl',
    iconName: 'hexagon-plus',
    icon: [
      512,
      512,
      ["plus-hexagon"],
      'f300',
      
      'M36.9 256L146.6 64H365.4L475.1 256 365.4 448H146.6L36.9 256zM128 32L0 256 128 480H384L512 256 384 32H128zM272 160H240v16 64H176 160v32h16 64v64 16h32V336 272h64 16V240H336 272V176 160z'
      
    ]
  };

  
    var faPlusHexagon = faHexagonPlus;
  

  
  

  var faTaco = {
    prefix: 'fasl',
    iconName: 'taco',
    icon: [
      512,
      512,
      [127790],
      'f826',
      
      'M325.9 86.1L256 32 186.1 86.1 97.8 83.4 73.1 168.3 0 218l22.2 61.8c7.3-10.1 15.2-19.7 23.7-28.7l-7.4-20.5 52.6-35.8 9.5-6.5 3.2-11 17.8-61.1 63.6 2 11.5 .4 9.1-7L256 72.5l50.3 38.9 9.1 7 11.5-.4 63.6-2 17.8 61.1 3.2 11 9.5 6.5 52.6 35.8L466.1 251c8.5 9.1 16.4 18.7 23.7 28.7L512 218l-73.1-49.7L414.2 83.4l-88.3 2.7zM256 224c123.7 0 224 100.3 224 224H32c0-123.7 100.3-224 224-224zM0 448v32H32 480h32V448c0-141.4-114.6-256-256-256S0 306.6 0 448zm112-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faChampagneGlasses = {
    prefix: 'fasl',
    iconName: 'champagne-glasses',
    icon: [
      640,
      512,
      [129346,"glass-cheers"],
      'f79f',
      
      'M101.3 189.5c-24.1 45.8-2.3 102.3 46.4 120s101.7-11.6 112.7-62.2l10.6-48.7L124.5 145.4l-23.2 44.1zm176.4-22.3l18.5-85.3-116-42.2-40.7 77.2 138.2 50.3zM73 174.6L164.9 0 320 56.4 475.1 0 567 174.6c30.6 58.1 7.3 128.9-49.1 158.5l40.9 112.4L614 425.4l15-5.5L640 450l-15 5.5L554.8 481l-70.2 25.6-15 5.5L458.6 482l15-5.5 55.2-20.1L487.9 344.1c-62.3 13.5-125.6-25.7-139.5-89.9L320 123.2 291.6 254.2c-13.9 64.2-77.2 103.5-139.5 89.9L111.2 456.4l55.2 20.1 15 5.5-10.9 30.1-15-5.5L85.2 481 15 455.5 0 450l10.9-30.1 15 5.5 55.2 20.1 40.9-112.4C65.6 303.5 42.4 232.7 73 174.6zm465.7 14.9l-23.2-44.1L369.1 198.7l10.6 48.7c11 50.6 64 79.9 112.7 62.2s70.5-74.2 46.4-120zM362.3 167.2l138.2-50.3L459.8 39.6l-116 42.2 18.5 85.3z'
      
    ]
  };

  
    var faGlassCheers = faChampagneGlasses;
  

  
  

  var faMarsStrokeUp = {
    prefix: 'fasl',
    iconName: 'mars-stroke-up',
    icon: [
      320,
      512,
      [9896,"mars-stroke-v"],
      'f22a',
      
      'M171.3 12.7L160 1.4 148.7 12.7l-56 56L81.4 80 104 102.6l11.3-11.3L144 62.6V128H96 80v32H96h48v32.8C63.1 200.8 0 269 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-83-63.1-151.2-144-159.2V160h48 16V128H224 176V62.6l28.7 28.7L216 102.6 238.6 80 227.3 68.7l-56-56zM160 480a128 128 0 1 1 0-256 128 128 0 1 1 0 256z'
      
    ]
  };

  
    var faMarsStrokeV = faMarsStrokeUp;
  

  
  

  var faUserMinus = {
    prefix: 'fasl',
    iconName: 'user-minus',
    icon: [
      640,
      512,
      [],
      'f503',
      
      'M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM87.6 336H360.4l44.3 144H43.3L87.6 336zM384 304H64L9.8 480 0 512H33.5h381H448l-9.8-32L384 304zm48-80H416v32h16H624h16V224H624 432z'
      
    ]
  };

  

  
  

  var faSignalSlash = {
    prefix: 'fasl',
    iconName: 'signal-slash',
    icon: [
      640,
      512,
      [],
      'f695',
      
      'M592 16V0H560V16 363.9l32 25.3V16zM464 451.2L432 426v70 16h32V496 451.2zM336 350.2l-32-25.3V496v16h32V496 350.2zM432 112V262.9l32 25.3V112 96H432v16zM208 288H176v16V496v16h32V496 304 288zM80 384H48v16 96 16H80V496 400 384zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faRoadCircleXmark = {
    prefix: 'fasl',
    iconName: 'road-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e566',
      
      'M184.1 64L74.4 448H339.2c5.9 11.4 12.9 22.2 21 32H65.3 32l9.1-32L160 32H304h32H480l46.5 162.6c-9.9-1.7-20.1-2.6-30.5-2.6c-1.2 0-2.4 0-3.6 0L455.9 64H336v48 16H304V112 64H184.1zM326.6 320H304V304 208 192h32v16 86.6c-3.8 8.2-6.9 16.7-9.4 25.4zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-36.7L518.6 368l36.7 36.7L566.6 416 544 438.6l-11.3-11.3L496 390.6l-36.7 36.7L448 438.6 425.4 416l11.3-11.3L473.4 368l-36.7-36.7L425.4 320 448 297.4l11.3 11.3L496 345.4l36.7-36.7L544 297.4 566.6 320l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faStoreSlash = {
    prefix: 'fasl',
    iconName: 'store-slash',
    icon: [
      640,
      512,
      [],
      'e071',
      
      'M541 512l-40.5-32H128V384H378.8l-40.5-32H128V256H96v96 32 96 32h32H512l29 0zM385.1 224c19.8 0 37.8-6.5 52.3-17.3c4.7-3.5 9-7.4 12.9-11.7c3.9 4.3 8.3 8.3 13 11.8c14.5 10.7 32.5 17.2 52.2 17.2c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L512 0H128l-9.8 15.1L143.4 35l2-3H494.7l58 89.1c18.5 29.6 .2 66.5-29.3 70.4c-2.6 .3-5.2 .5-7.9 .5c-16.5 0-31.2-7.2-41.5-18.5l-23.7-26.1-23.7 26.2c-10.2 11.2-24.8 18.4-41.4 18.4c-16.5 0-31.3-7.2-41.4-18.4l-23.7-26.3-14.3 15.8L382.7 224c.8 0 1.6 0 2.3 0zM512 256v70l32 25.3V256H512zM164.1 214.5l-29.6-23.4c-3.3 .6-6.7 .9-10.1 .9c-2.6 0-5.2-.2-7.9-.5c-20.7-2.8-35.9-22.1-36.6-43.5l-29-22.9c-12 43.2 14 91.7 61.3 98.1c4 .5 8.1 .8 12.1 .8c14.4 0 27.9-3.5 39.8-9.5zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faH4 = {
    prefix: 'fasl',
    iconName: 'h4',
    icon: [
      640,
      512,
      [],
      'f86a',
      
      'M32 64V80 240H288V80 64h32V80 256 432v16H288V432 272H32V432v16H0V432 256 80 64H32zm608 0V80 432v16H608V432 304H392 372.6l3.7-19L418.8 64h32.6l-40 208H608V80 64h32z'
      
    ]
  };

  

  
  

  var faBadgerHoney = {
    prefix: 'fasl',
    iconName: 'badger-honey',
    icon: [
      640,
      512,
      [129441],
      'f6b4',
      
      'M420.2 64H424h72 3.3l3.1 1.3 128 56 9.6 4.2V136v64 6.6l-4.7 4.7-32 32-4.7 4.7H592c-5.3 0-10.7 .2-16 .6V272v16H544V272 252.9c-53.3 10.6-102.5 36.8-136.6 62.1l24.4 146.4 3.1 18.6H416 328 314.4l-2.2-13.4L293.1 352h-94L185 385l22.3 74.4 6.2 20.6H192 104 92.1l-3.4-11.4-24-80-1.3-4.5 1.3-4.5 11.1-38.8C58.9 333.3 44 322.3 32 308.7V320v16H0V320 224C0 153.3 57.3 96 128 96H356.2l60.6-30.3 3.4-1.7zM99.8 315.8l15 4.6-4.3 15.1L96.7 383.9 115.9 448h54.6l-17.8-59.4L151 383l2.3-5.3 20.6-48L178 320h10.6H306.7h13.6l2.2 13.4L341.6 448h55.6L374.2 310.7l-1.6-9.3 7.4-5.9c45.6-35.9 122.9-77.3 205.2-79.4L608 193.4V168H511.6c.3 1.3 .4 2.6 .4 4c0 11-9 20-20 20s-20-9-20-20c0-1.4 .1-2.7 .4-4H419.9L255.4 254.2l-3.5 1.8H248 216c-68.3 0-124.9-50.4-134.5-116C52 156.4 32 187.9 32 224c0 43.2 28.5 79.8 67.8 91.8zM427.8 96l-60.6 30.3-3.4 1.7H360 128c-5.3 0-10.5 .4-15.6 1.3C117.1 182.4 161.7 224 216 224h28.1l164.5-86.2 3.5-1.8H416 584.1L492.7 96H427.8z'
      
    ]
  };

  

  
  

  var faHeadset = {
    prefix: 'fasl',
    iconName: 'headset',
    icon: [
      512,
      512,
      [],
      'f590',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224V448.1L352 448v0V416H320 224 192v32 32 32h32 96 32V480l144 .1 16 0v-16V256C512 114.6 397.4 0 256 0S0 114.6 0 256v48 16H32V304 256zM320 464l0 16h0v0H224V448h96v16zM96 224h64V352H96V224zM64 192v32V352v32H96h64 32V352 224 192H160 96 64zm288 32h64V352H352V224zm64-32H352 320v32V352v32h32 64 32V352 224 192H416z'
      
    ]
  };

  

  
  

  var faColonSign = {
    prefix: 'fasl',
    iconName: 'colon-sign',
    icon: [
      384,
      512,
      [],
      'e140',
      
      'M128.7 422.7l-16.3 69.7 31.2 7.3 14.7-63.2c14.2 5.2 29.2 8.7 44.7 10.4l-10.6 45.5 31.2 7.3 12.1-52c58-3.5 109.1-32.7 141.9-76.4L352 352c-25.6 34-64.3 57.5-108.6 62.8l68.3-292.7c15.5 10.2 29.2 23 40.3 37.9l25.6-19.2c-15.7-20.9-35.5-38.4-58.3-51.5l16.3-69.7-31.2-7.3L289.7 75.5c-14.2-5.2-29.2-8.7-44.7-10.4l10.6-45.5-31.2-7.3-12.1 52C111.7 70.4 32 153.9 32 256c0 71.3 38.9 133.6 96.7 166.7zm37-17.7l72-308.5c15.7 1.3 30.7 4.9 44.7 10.4l-72 308.5c-15.7-1.3-30.7-4.9-44.7-10.4zm39-307.9L136.3 389.9C92.8 361.3 64 312 64 256c0-81.8 61.4-149.3 140.6-158.8z'
      
    ]
  };

  

  
  

  var faUnlock = {
    prefix: 'fasl',
    iconName: 'unlock',
    icon: [
      448,
      512,
      [128275],
      'f09c',
      
      'M128 128c0-53 43-96 96-96c43.5 0 80.2 28.9 92 68.6l30.7-9.1C331 38.6 282 0 224 0C153.3 0 96 57.3 96 128v64H32 0v32V480v32H32 416h32V480 224 192H416 128V128zM32 480V224H416V480H32z'
      
    ]
  };

  

  
  

  var faSheep = {
    prefix: 'fasl',
    iconName: 'sheep',
    icon: [
      640,
      512,
      [128017],
      'f711',
      
      'M544 272H400V117.3L453.3 64h37.5L544 117.3V272zM440 32l-72 72v.3l-34 27.2-12.5 10 20 25 12.5-10 14-11.2V272v32h32H544h32V272 141.9l23.1 15.4 13.3 8.9 17.8-26.6-13.3-8.9-42.6-28.4L504 32H440zm24 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM366.6 60.1C359.6 57.5 352 56 344 56c-15 0-28.9 5.2-39.8 13.9C292.5 56.5 275.2 48 256 48s-36.5 8.5-48.2 21.9C196.9 61.2 183 56 168 56c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 194.3 0 215.5 0 240s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 33.1 25.2 60.4 57.4 63.7l31.1 124.2 3 12.1H136h72 16V496 423.4c9.4 5.4 20.3 8.6 32 8.6s22.6-3.1 32-8.6V496v16h16 72 12.5l3-12.1 31.1-124.2c24-2.5 44.1-18.2 52.8-39.7H437.2c-5.6 5-13.1 8-21.2 8c-1.7 0-3.4-.1-5-.4l-29-4.5-7 28.5C371.7 381.6 359 392 344 392c-7.6 0-14.4-2.6-19.9-6.9l-23.9-19-20.1 23c-5.9 6.8-14.5 11-24.1 11s-18.2-4.2-24.1-11l-20.1-23-23.9 19c-5.5 4.3-12.3 6.9-19.9 6.9c-15 0-27.7-10.4-31.1-24.3l-7-28.5-29 4.5c-1.6 .2-3.2 .4-5 .4c-17.7 0-32-14.3-32-32c0-2.7 .3-5.3 .9-7.8L71 280 49 268.3c-10.2-5.4-17-16.1-17-28.3s6.8-22.8 17-28.3L71 200l-6-24.2c-.6-2.5-.9-5.1-.9-7.8c0-17.7 14.3-32 32-32c1.7 0 3.4 .1 5 .4l29 4.5 7-28.5C140.3 98.4 153 88 168 88c7.6 0 14.4 2.6 19.9 6.9l23.9 19 20.1-23c5.9-6.8 14.5-11 24.1-11s18.2 4.2 24.1 11l20.1 23 23.9-19c4-3.2 8.8-5.5 14.1-6.4l7.1-7.1 21.3-21.3zM320 480V419.3c7.4 3 15.5 4.7 24 4.7c13.5 0 26-4.2 36.3-11.3L363.5 480H320zM192 419.3V480H148.5l-16.8-67.3C142 419.8 154.5 424 168 424c8.5 0 16.6-1.7 24-4.7z'
      
    ]
  };

  

  
  

  var faCitrusSlice = {
    prefix: 'fasl',
    iconName: 'citrus-slice',
    icon: [
      512,
      512,
      [],
      'e2f5',
      
      'M480 208c0 150.2-121.8 272-272 272c-59.5 0-114.5-19.1-159.3-51.5l27.4-27.4C115 430.5 163.5 448 216 448c128.1 0 232-103.9 232-232c0-52.5-17.5-101-46.9-139.9l27.4-27.4C460.9 93.5 480 148.5 480 208zM176 412c-28.3-5.7-54.4-17.5-77-33.8l77-77V412zm32 3.8v-122c18.4 4.6 38.2 1.8 54.9-8.4l82.8 82.8C310.7 398 265.5 416 216 416c-2.7 0-5.3-.1-8-.2zm77.8-152.7c10.7-16.5 14-36.5 9.8-55.2H415.8c.1 2.7 .2 5.3 .2 8c0 49.5-18 94.7-47.7 129.7l-82.5-82.5zM301.3 176l77-77c16.3 22.6 28 48.7 33.8 77H301.3zm-37.3 37.3c3.7 13.4 .3 28.4-10.3 39s-25.5 14-39 10.3l49.2-49.2zM1.2 430.8C9 438.1 17.3 445 25.8 451.4C76.6 489.5 139.7 512 208 512c167.9 0 304-136.1 304-304c0-68.3-22.5-131.4-60.6-182.2C445 17.3 438.1 9 430.8 1.2L408.2 23.8 23.8 408.2 1.2 430.8z'
      
    ]
  };

  

  
  

  var faPepperHot = {
    prefix: 'fasl',
    iconName: 'pepper-hot',
    icon: [
      512,
      512,
      [127798],
      'f816',
      
      'M476.7 42.6c6.1 25.8 4 52.6-5.7 76.8c-1.2 3.1-2.6 6.2-4.1 9.3l.3 .3C495 157.8 512 196.9 512 240c0 21.1-4.1 41.2-11.5 59.6c-4.8 11.9-10.9 23-18.2 33.3l-17.6-32.1L440 256H336L320 152l-51.9-8.7-38.5-6.4c8.7-10.4 18.8-19.6 29.8-27.5C285.6 90.9 317.5 80 352 80c21.6 0 42.2 4.3 60.9 12c10.1 4.1 19.6 9.3 28.5 15.3c4.2-10.7 6.5-22.1 6.7-33.5c.1-3.5-.1-7.1-.4-10.7c-.8-8-2.5-16-5.4-23.8l0 0 0 0L433 13.5 463 2.5l9.4 25.8 0 0 0 0c.5 1.4 1 2.8 1.5 4.3c1.1 3.3 2 6.7 2.8 10zM443.9 150.9l-9.3-9.6-11.1-7.5C403.1 120 378.5 112 352 112c-13.9 0-27.2 2.2-39.7 6.3l13 2.2 22.8 3.8 3.5 22.9L363.5 224H440h18.9l9.1 16.6 10.5 19c1-6.4 1.5-12.9 1.5-19.6c0-34.6-13.7-66-36.1-89.1zM172.3 304.4l78.1-131.6 33.9 5.6L199.8 320.7c-22.5 38-59.8 64.9-102.9 74.5L32 409.7V480h71.2c134.3 0 255.8-66.6 329.2-171.6l17 31C369.4 445.5 242.7 512 103.2 512H32 0V480 384l90-20c34.5-7.7 64.3-29.2 82.3-59.6z'
      
    ]
  };

  

  
  

  var faClockTwelve = {
    prefix: 'fasl',
    iconName: 'clock-twelve',
    icon: [
      512,
      512,
      [],
      'e358',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM272 112V256v16H240V256 112 96h32v16z'
      
    ]
  };

  

  
  

  var faMicrophoneLines = {
    prefix: 'fasl',
    iconName: 'microphone-lines',
    icon: [
      384,
      512,
      [127897,"microphone-alt"],
      'f3c9',
      
      'M256 32H128V256c0 35.3 28.7 64 64 64s64-28.7 64-64H208 192V224h16 48V192H208 192V160h16 48V128H208 192V96h16 48V32zm32 64v32 32 32 32 32c0 53-43 96-96 96s-96-43-96-96V32 0h32H256h32V32 96zM64 192v16 48c0 70.7 57.3 128 128 128s128-57.3 128-128V208 192h32v16 48c0 83-63.1 151.2-144 159.2V480h64 16v32H272 192 112 96V480h16 64V415.2C95.1 407.2 32 339 32 256V208 192H64z'
      
    ]
  };

  
    var faMicrophoneAlt = faMicrophoneLines;
  

  
  

  var faSignalBarsWeak = {
    prefix: 'fasl',
    iconName: 'signal-bars-weak',
    icon: [
      640,
      512,
      ["signal-alt-1"],
      'f691',
      
      'M96 416v64H64V416H96zM64 384H32v32 64 32H64 96h32V480 416 384H96 64z'
      
    ]
  };

  
    var faSignalAlt1 = faSignalBarsWeak;
  

  
  

  var faCity = {
    prefix: 'fasl',
    iconName: 'city',
    icon: [
      640,
      512,
      [127961],
      'f64f',
      
      'M96 16V0H64V16 64H16 0V80 496v16H16 192V480H32V96H192V80 64 16 0H160V16 64H96V16zM544 160H512V128 32 0H480 256 224V32 480v32h32H512h96 32V480 192 160H608 544zM480 32V160v32h32 96V480H512 256V32H480zM320 416h16 64 16V400 336 320H400 336 320v16 64 16zm32-32V352h32v32H352zM336 64H320V80v64 16h16 64 16V144 80 64H400 336zm16 64V96h32v32H352zM320 288h16 64 16V272 208 192H400 336 320v16 64 16zm32-32V224h32v32H352zM496 448h64 16V432 368 352H560 496 480v16 64 16h16zm48-64v32H512V384h32zm-64-64h16 64 16V304 240 224H560 496 480v16 64 16zm32-32V256h32v32H512zM80 352h64 16V336 272 256H144 80 64v16 64 16H80zm16-64h32v32H96V288zM64 224H80h64 16V208 144 128H144 80 64v16 64 16zm32-32V160h32v32H96z'
      
    ]
  };

  

  
  

  var faCodeFork = {
    prefix: 'fasl',
    iconName: 'code-fork',
    icon: [
      448,
      512,
      [],
      'e13b',
      
      'M128 32v96H96 64 32V32h96zM32 160H64v32c0 44.2 35.8 80 80 80h64v80H176 144v32 96 32h32 96 32V480 384 352H272 240V272h64c44.2 0 80-35.8 80-80V160h32 32V128 32 0H416 320 288V32v96 32h32 32v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V160h32 32V128 32 0H128 32 0V32v96 32H32zm352-32H352 320V32h96v96H384zM240 384h32v96H176V384h32 32z'
      
    ]
  };

  

  
  

  var faHeartCirclePlus = {
    prefix: 'fasl',
    iconName: 'heart-circle-plus',
    icon: [
      576,
      512,
      [],
      'e500',
      
      'M256 141.3l-22.6-22.6L209.1 94.4C189.7 74.9 163.3 64 135.8 64C78.5 64 32 110.5 32 167.8c0 27.5 10.9 53.9 30.4 73.4l24.2 24.2L256 434.8l9.5-9.5c3.7 10.9 8.5 21.3 14.2 31.1l-1.1 1.1L256 480l-22.6-22.6L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8l1.6 1.6L256 96l22.6-22.6 1.6-1.6c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4c-9.6-4.5-19.7-8.1-30.2-10.7c2.9-9.5 4.3-19.5 4.3-29.7C480 110.5 433.5 64 376.2 64c-27.5 0-53.9 10.9-73.4 30.4l-24.2 24.2L256 141.3zM544 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64v48h48 16v32H496 448v48 16H416V432 384H368 352V352h16 48V304 288h32v16z'
      
    ]
  };

  

  
  

  var faFlatbread = {
    prefix: 'fasl',
    iconName: 'flatbread',
    icon: [
      512,
      512,
      [129747],
      'e40b',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM171.3 363.3l-22.6-22.6 192-192 22.6 22.6-192 192zm80-240l-128 128-22.6-22.6 128-128 22.6 22.6zm32 288l-22.6-22.6 128-128 22.6 22.6-128 128z'
      
    ]
  };

  

  
  

  var faBowlHot = {
    prefix: 'fasl',
    iconName: 'bowl-hot',
    icon: [
      512,
      512,
      ["soup"],
      'f823',
      
      'M160 0H128V16 32c0 30.2 14.2 58.7 38.4 76.8C182.5 120.9 192 139.9 192 160v16 16h32V176 160c0-24.8-9.6-48.4-26.4-66.1l.8-1.1-12.8-9.6C169.5 71.1 160 52.1 160 32V16 0zm0 453l-17.8-8.8C82.1 414.5 39.7 354.3 35.5 283.3L33.9 256H478.1l-1.6 27.3c-4.2 71-46.6 131.2-106.6 160.9L352 453v19.9V480H160v-7.1V453zM1.9 256l1.7 29.2C8.5 368.1 58 438.2 128 472.9V480v32h32H352h32V480v-7.1c70-34.6 119.5-104.8 124.4-187.7l1.7-29.2 1.9-32H479.9 32.1 0l1.9 32zM288 16V0H256V16 32c0 30.2 14.2 58.7 38.4 76.8C310.5 120.9 320 139.9 320 160v16 16h32V176 160c0-24.8-9.6-48.4-26.4-66.1l.8-1.1-12.8-9.6C297.5 71.1 288 52.1 288 32V16z'
      
    ]
  };

  
    var faSoup = faBowlHot;
  

  
  

  var faCandy = {
    prefix: 'fasl',
    iconName: 'candy',
    icon: [
      640,
      512,
      [127852],
      'e3e7',
      
      'M376.9 405.6C359.2 412.3 340 416 320 416c-4.9 0-9.7-.2-14.4-.6L183.8 171.9c12.8-20.7 30.1-38.2 50.6-51.2L376.9 405.6zm28.6-14.3L263.1 106.4C280.8 99.7 300 96 320 96c4.9 0 9.7 .2 14.4 .6L456.2 340.1c-12.8 20.7-30.1 38.2-50.6 51.2zm-9.4 41.1c8.3-3.6 16.2-7.7 23.8-12.3l0 0c20.3-12.4 38.2-28.5 52.6-47.3l0 0c7.6-9.9 14.3-20.6 19.8-31.9l0 0c4.2-8.5 7.8-17.3 10.7-26.5l101.8 50.9L633 327l-9.8-9.8-25.8-25.8 35-10.2L640 279V233l-7.6-2.2-35-10.2 25.8-25.8L633 185l-28.2-38.2L503 197.7C481.8 131.1 425.3 80.3 355.5 67.3l0 0C344 65.1 332.1 64 320 64h0c-.6 0-1.3 0-1.9 0c-84.9 .8-156.6 56.7-181.1 133.7L35.2 146.8 7 185l9.8 9.8 25.8 25.8-35 10.2L0 233v46l7.6 2.2 35 10.2L16.8 317.2 7 327l28.2 38.2L137 314.3c21.2 66.5 77.7 117.3 147.5 130.4c11.5 2.2 23.4 3.3 35.5 3.3m-54.7-41.6C203.9 384.1 160 325.2 160 256c0-16.2 2.4-31.8 6.9-46.5l98.5 196.9zM374.7 105.6C436.1 127.9 480 186.8 480 256c0 16.2-2.4 31.8-6.9 46.5L374.7 105.6zM320 448c.6 0 1.3 0 1.9 0c24.5-.2 47.9-5.1 69.4-13.7c1.6-.6 3.2-1.3 4.8-2M512 256c0-8.9-.6-17.6-1.8-26.2l65.2-32.6-.7 .7-38.2 38.2 51.8 15.2 16.2 4.7-16.2 4.7-51.8 15.2 38.2 38.2 .7 .7-65.2-32.6c1.2-8.6 1.8-17.3 1.8-26.2zM129.8 229.8c-1.2 8.6-1.8 17.3-1.8 26.2s.6 17.6 1.8 26.2L64.5 314.8l.7-.7 38.2-38.2L51.6 260.7 35.4 256l16.2-4.7 51.8-15.2L65.2 197.9l-.7-.7 65.2 32.6z'
      
    ]
  };

  

  
  

  var faAlbumCollectionCircleUser = {
    prefix: 'fasl',
    iconName: 'album-collection-circle-user',
    icon: [
      640,
      512,
      [],
      'e48f',
      
      'M32 0H48 464h16V32H464 48 32V0zM16 64H32 480h16V96H480 32 16V64zm19.5 96L68.8 480H360.2c10 12.1 21.7 22.9 34.6 32H40L3.3 160 0 128H32.2 479.8 512l-3.3 32-3.4 32.2c-3.1-.2-6.2-.2-9.3-.2c-7.8 0-15.5 .5-23 1.5l3.5-33.5H35.5zM256 192c49 0 92.8 17.6 122.1 45.3c-8 7.2-15.2 15.1-21.8 23.6C334 239.3 299.3 224 256 224c-77.7 0-128 49.3-128 96s50.3 96 128 96c25.7 0 48.4-5.4 67.2-14.3c2.1 10.7 5.1 21 9 30.8C309.6 442.4 283.6 448 256 448c-88.4 0-160-57.3-160-128s71.6-128 160-128zm0 152c-13.3 0-24-9-24-20s10.7-20 24-20s24 9 24 20s-10.7 20-24 20zM553.5 464.1L537.4 448H454.6l-16.1 16.1C455.3 474.2 475 480 496 480s40.7-5.8 57.5-15.9zm24.9-20.3C596.8 423.9 608 397.2 608 368c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 29.2 11.2 55.9 29.6 75.8l23.1-23.1 4.7-4.7H448h96 6.6l4.7 4.7 23.1 23.1zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112z'
      
    ]
  };

  

  
  

  var faFolderOpen = {
    prefix: 'fasl',
    iconName: 'folder-open',
    icon: [
      576,
      512,
      [61717,128194,128449],
      'f07c',
      
      'M272 96L208 32H32 0V64 448v32H32h3.8H384h64L560 256l16-32H540.2 128L32 416V64H194.7l54.6 54.6 9.4 9.4H272 448v64h32V128 96H448 272zM51.8 448l96-192H524.2l-96 192H384 51.8z'
      
    ]
  };

  

  
  

  var faFaceLaugh = {
    prefix: 'fasl',
    iconName: 'face-laugh',
    icon: [
      512,
      512,
      ["laugh"],
      'f599',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 400c52 0 97.1-32.8 115.7-80H140.3c18.6 47.2 63.7 80 115.7 80zM100 288h32.2H379.8 412c-1.1 11-3.2 21.7-6.4 32c-20 64.9-79.4 112-149.6 112s-129.6-47.1-149.6-112c-3.2-10.3-5.3-21-6.4-32zm52.4-96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faLaugh = faFaceLaugh;
  

  
  

  var faChartPieSimple = {
    prefix: 'fasl',
    iconName: 'chart-pie-simple',
    icon: [
      512,
      512,
      ["chart-pie-alt"],
      'f64e',
      
      'M288 32.5C390.4 39.8 472.2 121.6 479.5 224H288V32.5zM273.1 0c-5.7 0-11.4 .2-17.1 .6V224v32h32H511.4c.4-5.6 .6-11.3 .6-17.1C512 107 405 0 273.1 0zM192 288v32h32H442.4C420.8 411.7 338.4 480 240 480C125.1 480 32 386.9 32 272c0-98.4 68.3-180.8 160-202.4V288zm287.5 0H447.4 256 224V256 64.6 32.5c-10.9 .7-21.6 2.2-32 4.3C82.5 59 0 155.9 0 272C0 404.5 107.5 512 240 512c116.1 0 213-82.5 235.2-192c2.1-10.4 3.6-21.1 4.3-32z'
      
    ]
  };

  
    var faChartPieAlt = faChartPieSimple;
  

  
  

  var faShirtLongSleeve = {
    prefix: 'fasl',
    iconName: 'shirt-long-sleeve',
    icon: [
      640,
      512,
      [],
      'e3c7',
      
      'M123.6 0h-9.5l-4.6 8.3L95.9 33.2l-88 160L2 204l-2 3.6v4.1V224 400v16H16h96 16V400 240.4l32-58.2V496v16h16H464h16V496 182.3l32 58.2V400v16h16 96 16V400 224 211.7v-4.1l-2-3.6-5.9-10.8-88-160L530.4 8.3 525.8 0h-9.5H488 464 444 400h-.4H381.9 258.1 240.4 240 196 176 152 123.6zM256.5 32h127c-3.9 31.6-30.9 56-63.5 56s-59.6-24.4-63.5-56zM124 48.6L133.1 32H152h24 20 28.3c4.1 49.3 45.3 88 95.7 88s91.6-38.7 95.7-88H444h20 24 18.9L516 48.6l88 160 4 7.2V224 384H544V236.3v-4.1l-2-3.6L478 112.3 448 120V480H192V120l-30-7.7L98 228.6l-2 3.6v4.1V384H32V224v-8.2l4-7.2 88-160z'
      
    ]
  };

  

  
  

  var faShuttleSpace = {
    prefix: 'fasl',
    iconName: 'shuttle-space',
    icon: [
      640,
      512,
      ["space-shuttle"],
      'f197',
      
      'M192 480L405.3 352H464c69.8 0 123.8-31.8 164.8-86.4L636 256l-7.2-9.6c-41-54.6-95-86.4-164.8-86.4H405.3L192 32H64 32V64v64H16 0v16V368v16H16 32v64 32H64 192zM64 384H96h3.1l2.9-1.1L128 372.4V448H64V384zm119.1 64H160V359.6l19.1-7.6H343.1l-160 96zM64 352H32V272H176h16V240H176 32V160H64 92.9l77.1 30.9 2.9 1.1H176 464c54.2 0 97.1 22.4 131.6 64c-34.6 41.6-77.4 64-131.6 64H176h-3.1l-2.9 1.1L92.9 352H64zm0-224V64h64v75.6l-26.1-10.4L99.1 128H96 64zm115.1 32L160 152.4V64h23.1l160 96H179.1zM480 288V224H448v64h32z'
      
    ]
  };

  
    var faSpaceShuttle = faShuttleSpace;
  

  
  

  var faHouseDay = {
    prefix: 'fasl',
    iconName: 'house-day',
    icon: [
      640,
      512,
      [],
      'e00e',
      
      'M192 0H160V16 64h32V16 0zM0 160v32H16 64V160H16 0zM299.3 75.3L310.6 64 288 41.4 276.7 52.7l-32 32 22.6 22.6 32-32zm110.8 32.3L400 99.4l-10.1 8.2-216 176-12.4 10.1 20.2 24.8 12.4-10.1L224 284V496v16h16H560h16V496 284l29.9 24.4 12.4 10.1 20.2-24.8-12.4-10.1-216-176zM544 258V480H256V258L400 140.6 544 258zM336 272v16 96 16h16 96 16V384 288 272H448 352 336zm32 32h64v64H368V304zM107.3 267.3L84.7 244.7l-32 32L41.4 288 64 310.6l11.3-11.3 32-32zM75.3 52.7L64 41.4 41.4 64 52.7 75.3l32 32 22.6-22.6-32-32zM176 96c-44.2 0-80 35.8-80 80c0 36.7 24.7 67.6 58.4 77l40.3-32.8c-5.7 2.4-12 3.8-18.7 3.8c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48c0 10.1-3.1 19.5-8.5 27.2l40.3-32.8C252.9 128.8 218.3 96 176 96z'
      
    ]
  };

  

  
  

  var faBedPulse = {
    prefix: 'fasl',
    iconName: 'bed-pulse',
    icon: [
      640,
      512,
      ["procedures"],
      'f487',
      
      'M464 0h8 11.1L487 10.4 507.1 64H624h16V96H624 496 484.9L481 85.6 467.6 50l-52.8 132-4 10.1H400h-8H381.3l-4.1-9.8L341.3 96H208 192V64h16H352h10.7l4.1 9.8 29 69.6L449.1 10.1l4-10.1H464zM272 160h61.3l13.3 32H288V352H608V272c0-44.2-35.8-80-80-80H445.3l12.8-32H528c61.9 0 112 50.1 112 112v96 64 64 16H608V496 448H32v48 16H0V496 432 368 80 64H32V80 352H256V176 160h16zM32 416H608V384H272 32v32zM192 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 240a80 80 0 1 1 160 0A80 80 0 1 1 64 240z'
      
    ]
  };

  
    var faProcedures = faBedPulse;
  

  
  

  var faFire = {
    prefix: 'fasl',
    iconName: 'fire',
    icon: [
      448,
      512,
      [128293],
      'f06d',
      
      'M239.7 109.4C229 96.1 208.3 75.1 189 56.4c-4.6-4.5-9-8.7-13.1-12.6c-1.6 1.5-3.2 3.1-4.9 4.8c-15.9 15.7-37 38-58.1 64.1c-21.1 26.2-41.7 55.7-56.8 85.8C40.8 228.9 32 258.2 32 284.5C32 394.9 116.6 480 224 480c106.2 0 192-85.1 192-195.5c0-47.2-28.4-99.5-61.5-143.3c-16-21.2-32.1-39-44.3-51.6l0 0c-9.6 8.3-17.3 15.7-20.1 19.3l-24.8 32.5-25.5-31.9zM0 284.5C0 152 176 0 176 0s38.4 35.3 67.1 65.3c8.5 8.9 16.1 17.2 21.6 24.1c4.7-6.1 13.8-14.7 22.9-22.6C299.9 56.1 312 46.6 312 46.6s136 121.4 136 237.9C448 412.2 348.2 512 224 512C98.4 512 0 412.1 0 284.5zM187.7 182c2.9 3.6 24.7 31.3 45.7 58L262 276.4l.8 1 37.9-44 13-15.1 12 15.9c5.1 6.8 8.4 13.5 11.2 18.9l.1 .1c28.6 52.6 16.3 120.4-33.1 154.9l-.3 .2 0 0C279.8 424 254.3 432 225.7 432c-35 0-67.4-11.3-91.3-33.1C110.3 377 96 345.3 96 306.8c0-20.5 6.5-39.1 18-58.6c11.2-19.2 27.8-40.5 48.8-66.2l12.5-15.4L187.7 182zm62 130.5l0 0 0 0 0-.1-.2-.2-.7-.9-2.6-3.3-9.3-11.8-28.6-36.4c-12.1-15.4-24.4-31-33.2-42.2c-14.7 18.5-25.7 33.4-33.5 46.6C132 280.8 128 293.7 128 306.8c0 30.1 11 53 28 68.5C173.1 391 197.5 400 225.7 400c22 0 41.3-6 59.8-18.2c33.7-23.7 44.3-71.2 24.7-110.4L274.4 313l-12.7 14.8-12-15.3 12.6-9.9c-12.6 9.9-12.6 9.9-12.6 9.9z'
      
    ]
  };

  

  
  

  var faStars = {
    prefix: 'fasl',
    iconName: 'stars',
    icon: [
      512,
      512,
      [],
      'f762',
      
      'M352 0V16 80h64 16v32H416 352v64 16H320V176 112H256 240V80h16 64V16 0h32zM464 160v16 32h32 16v32H496 464v32 16H432V272 240H400 384V208h16 32V176 160h32zM211.3 180.2l41.9 85L347 278.8l39.9 5.8-28.9 28.1-67.9 66.2 16 93.4L313 512l-35.7-18.8-83.9-44.1-83.9 44.1L73.9 512l6.8-39.7 16-93.4L28.9 312.7 0 284.6l39.9-5.8 93.8-13.6 41.9-85L193.5 144l17.8 36.2zm37.3 116.7L232 294.4l-7.4-15.1-31.1-63-31.1 63-7.4 15.1-16.6 2.4L68.8 306.9l50.3 49 12 11.7-2.8 16.6-11.9 69.2 62.2-32.7 14.9-7.8 14.9 7.8 62.2 32.7-11.9-69.2-2.8-16.6 12-11.7 50.3-49-69.5-10.1z'
      
    ]
  };

  

  
  

  var faCircleZ = {
    prefix: 'fasl',
    iconName: 'circle-z',
    icon: [
      512,
      512,
      [],
      'e130',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-384H176 160v32h16H304.9L163 358.7l-3 4.2V384h16H336h16V352H336 207.1L349 153.3l3-4.2V128H336z'
      
    ]
  };

  

  
  

  var faDownToBracket = {
    prefix: 'fasl',
    iconName: 'down-to-bracket',
    icon: [
      448,
      512,
      [],
      'e4e7',
      
      'M272 144l0 32 32 0 48 0 0 17.7L224 308.9 96 193.7 96 176l48 0 32 0 0-32 0-112 96 0 0 112zm112 0l-32 0-16 0-32 0 0-32 0-80 0-32L272 0 176 0 144 0l0 32 0 80 0 32-32 0-16 0-32 0 0 32 0 32L224 352 384 208l0-32 0-32zM32 336l0-16L0 320l0 16L0 496l0 16 16 0 416 0 16 0 0-16 0-160 0-16-32 0 0 16 0 144L32 480l0-144z'
      
    ]
  };

  

  
  

  var faSignalStream = {
    prefix: 'fasl',
    iconName: 'signal-stream',
    icon: [
      576,
      512,
      [],
      'f8dd',
      
      'M544 256c0 59.9-20.6 115-55.1 158.6l25.1 19.8C552.8 385.4 576 323.4 576 256s-23.2-129.4-61.9-178.5L488.9 97.4C523.4 141 544 196.1 544 256zM32 256c0-59.9 20.6-115 55.1-158.6L61.9 77.5C23.2 126.6 0 188.6 0 256s23.2 129.4 61.9 178.5l25.1-19.8C52.6 371 32 315.9 32 256zm64 0c0 44.9 15.4 86.3 41.3 119l25.1-19.8C140.9 327.9 128 293.4 128 256s12.9-71.9 34.4-99.1L137.3 137C111.4 169.7 96 211.1 96 256zm384 0c0-44.9-15.4-86.3-41.3-119l-25.1 19.8C435.1 184.1 448 218.6 448 256s-12.9 71.9-34.4 99.1L438.7 375c25.9-32.7 41.3-74 41.3-119zM288 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faL = {
    prefix: 'fasl',
    iconName: 'l',
    icon: [
      320,
      512,
      [108],
      '4c',
      
      'M64 32V48 448H304h16v32H304 48 32V464 48 32H64z'
      
    ]
  };

  

  
  

  var faPersonWalking = {
    prefix: 'fasl',
    iconName: 'person-walking',
    icon: [
      320,
      512,
      [128694,"walking"],
      'f554',
      
      'M224 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 144 56zM123.7 163.5L76.7 194.7 46.6 262.5l-6.5 14.6-29.2-13 6.5-14.6 32-72 1.9-4.2 3.9-2.6 72-48 6.1-4 7 1.9 88 24 8.5 2.3 2.6 8.4 30.3 98.6 43.3 28.8-17.8 26.6-48-32-4.7-3.2-1.7-5.4-15-48.7L187.3 331l47.2 40.9 3.5 3 1.3 4.5 32 107.2 4.6 15.3-30.7 9.2-4.6-15.3L210 393 109.4 305.8C94.9 293.3 89.3 273.4 95 255.2l28.7-91.8zm35-4.7l-33.1 106c-1.9 6.1 0 12.7 4.8 16.9l30.9 26.8 47.1-136.1-49.7-13.6zm-53 186.2l25 21.6L94.3 439.2c-.8 1.5-1.8 2.9-3 4.2l-56 56L24 510.6 1.4 488l11.3-11.3 54.2-54.2 38.8-77.6z'
      
    ]
  };

  
    var faWalking = faPersonWalking;
  

  
  

  var faRectangleVertical = {
    prefix: 'fasl',
    iconName: 'rectangle-vertical',
    icon: [
      384,
      512,
      ["rectangle-portrait"],
      'f2fb',
      
      'M352 480L32 480 32 32l320 0 0 448zM384 32V0L352 0 32 0 0 0 0 32 0 480l0 32H32l320 0h32V480l0-448z'
      
    ]
  };

  
    var faRectanglePortrait = faRectangleVertical;
  

  
  

  var faToggleOn = {
    prefix: 'fasl',
    iconName: 'toggle-on',
    icon: [
      576,
      512,
      [],
      'f205',
      
      'M32 128V384H544V128H32zM0 96H32 544h32v32V384v32H544 32 0V384 128 96zm352 96V320H480V192H352zm-32-32h32H480h32v32V320v32H480 352 320V320 192 160z'
      
    ]
  };

  

  
  

  var faCircleArrowUp = {
    prefix: 'fasl',
    iconName: 'circle-arrow-up',
    icon: [
      512,
      512,
      ["arrow-circle-up"],
      'f0aa',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm11.3-379.3L256 121.4l-11.3 11.3-96 96L137.4 240 160 262.6l11.3-11.3L240 182.6V368v16h32V368 182.6l68.7 68.7L352 262.6 374.6 240l-11.3-11.3-96-96z'
      
    ]
  };

  
    var faArrowCircleUp = faCircleArrowUp;
  

  
  

  var faBedEmpty = {
    prefix: 'fasl',
    iconName: 'bed-empty',
    icon: [
      640,
      512,
      [128719],
      'f8f9',
      
      'M32 48V32H0V48 208 336v64 64 16H32V464 416H608v48 16h32V464 400 336 208 192H624 32V48zM608 320H32V224H608v96zM32 352H608v32H32V352z'
      
    ]
  };

  

  
  

  var faPianoKeyboard = {
    prefix: 'fasl',
    iconName: 'piano-keyboard',
    icon: [
      576,
      512,
      [127929],
      'f8d5',
      
      'M544 224V416H448V336h16 16V320 224h64zM416 416H304V336h16 16V320 224h48v96 16h16 16v80zm-144 0H160V336h16 16V320 224h48v96 16h16 16v80zM144 448H288 432 544h32V416 224 208 192 96 64H544 32 0V96v96 16 16V416v32H32 144zm-16-32H32V224H96v96 16h16 16v80zm16-112H128V224h32v80H144zm144 0H272V224h32v80H288zm144 0H416V224h32v80H432zM544 192H464 400 320 256 176 112 32V96H544v96z'
      
    ]
  };

  

  
  

  var faUserPilotTie = {
    prefix: 'fasl',
    iconName: 'user-pilot-tie',
    icon: [
      448,
      512,
      [],
      'e2c1',
      
      'M368 99.2V144c-16 10.7-67.2 32-144 32s-128-21.3-144-32V99.2L48 80V48L224 0 400 48V80L368 99.2zm-32 25.3V99.2 81.1l15.5-9.3 4.4-2.6L224 33.2 92.1 69.1l4.4 2.6L112 81.1V99.2v25.3c20.2 8.4 58.6 19.5 112 19.5s91.8-11.1 112-19.5zM204 453.3L224 480l20-26.7 2.9-3.8L224 403.8l-22.9 45.7 2.9 3.8zM128 352l51.7 68.9L198.1 384H192 176V352h16 32 32 16v32H256h-6.1l18.4 36.9L320 352h80l38.4 128 9.6 32H414.6 240 208 33.4 0l9.6-32L48 352h80zM264 480H405l-28.8-96H336l-72 96zm-80 0l-72-96H71.8L43 480H184zM96 192c0-2.7 .1-5.3 .2-7.9c10.4 4 21 7.6 31.8 10.7c1.5 51.7 43.9 93.2 96 93.2s94.5-41.5 96-93.2c10.8-3.1 21.4-6.6 31.8-10.7c.2 2.6 .2 5.2 .2 7.9c0 70.7-57.3 128-128 128s-128-57.3-128-128zM183.2 65.7L224 86.1l40.8-20.4 14.3-7.2 14.3 28.6-14.3 7.2-48 24-7.2 3.6-7.2-3.6-48-24-14.3-7.2 14.3-28.6 14.3 7.2z'
      
    ]
  };

  

  
  

  var faWheelchair = {
    prefix: 'fasl',
    iconName: 'wheelchair',
    icon: [
      512,
      512,
      [],
      'f193',
      
      'M176 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 176 0a56 56 0 1 0 0 112zM131.5 227.2L124.5 196C53.2 212.1 0 275.8 0 352c0 88.4 71.6 160 160 160c69.7 0 128.9-44.5 150.9-106.7l-30.2-10.7C263.1 444.4 215.7 480 160 480C89.3 480 32 422.7 32 352c0-60.9 42.5-111.9 99.5-124.8zm68.1-70.7l-3.5-15.6-31.2 7.1 3.5 15.6 34.3 151.1c5 21.9 24.4 37.4 46.8 37.4H358.1l59.6 119.2 7.2 14.3 14.3-7.2 64-32-14.3-28.6-49.7 24.8L382.3 328.8l-4.4-8.8H368 249.5c-7.5 0-13.9-5.2-15.6-12.5L215 224H352h16V192H352 207.7l-8.1-35.5z'
      
    ]
  };

  

  
  

  var faTriangleInstrument = {
    prefix: 'fasl',
    iconName: 'triangle-instrument',
    icon: [
      576,
      512,
      ["triangle-music"],
      'f8e2',
      
      'M304 16V0H272V16 58.7l-2.7 4.4L19.2 480 0 512H37.3 538.7 576l-19.2-32L421.5 254.4l-23.3 23.3L519.5 480H56.5L288 94.2l76.2 127-43.7 43.7c-9.5-5.6-20.6-8.9-32.5-8.9c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-11.9-3.2-23-8.9-32.5l38-38 23.3-23.3L539.3 91.3 550.6 80 528 57.4 516.7 68.7 387.5 197.9 306.7 63.1 304 58.7V16zm16 304a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z'
      
    ]
  };

  
    var faTriangleMusic = faTriangleInstrument;
  

  
  

  var faCommentPlus = {
    prefix: 'fasl',
    iconName: 'comment-plus',
    icon: [
      512,
      512,
      [],
      'f4b2',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM272 144H240v16 64H176 160v32h16 64v64 16h32V320 256h64 16V224H336 272V160 144z'
      
    ]
  };

  

  
  

  var faSquareChevronDown = {
    prefix: 'fasl',
    iconName: 'square-chevron-down',
    icon: [
      448,
      512,
      ["chevron-square-down"],
      'f329',
      
      'M32 448V64H416V448H32zM0 480H32 416h32V448 64 32H416 32 0V64 448v32zM235.3 347.3l112-112L358.6 224 336 201.4l-11.3 11.3L224 313.4 123.3 212.7 112 201.4 89.4 224l11.3 11.3 112 112L224 358.6l11.3-11.3z'
      
    ]
  };

  
    var faChevronSquareDown = faSquareChevronDown;
  

  
  

  var faObjectsColumn = {
    prefix: 'fasl',
    iconName: 'objects-column',
    icon: [
      448,
      512,
      [],
      'e3c1',
      
      'M32 64V256H160V64H32zM0 32H32 160h32V64 256v32H160 32 0V256 64 32zM288 256V448H416V256H288zm-32-32h32H416h32v32V448v32H416 288 256V448 256 224zM160 352H32v96H160V352zM32 320H160h32v32 96 32H160 32 0V448 352 320H32zM288 64v96H416V64H288zM256 32h32H416h32V64v96 32H416 288 256V160 64 32z'
      
    ]
  };

  

  
  

  var faViolin = {
    prefix: 'fasl',
    iconName: 'violin',
    icon: [
      640,
      512,
      [127931],
      'f8ed',
      
      'M520 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM27.3 347.3l320-320L324.7 4.7l-320 320 22.6 22.6zM429.4 188L324.7 292.7l22.6 22.6L452 210.6c25.4 34.6 25.1 79.5 2.1 109.9C405.8 325.4 368 366.3 368 416c0 11 1.9 21.6 5.3 31.5C350.6 467.7 320.8 480 288 480c-18.3 0-35.7-3.8-51.5-10.8L288 392l-40-40-77.2 51.5C163.8 387.7 160 370.3 160 352c0-32.8 12.3-62.6 32.5-85.3c9.9 3.4 20.5 5.3 31.5 5.3c49.7 0 90.6-37.8 95.5-86.2c30.4-23 75.3-23.3 109.9 2.1zm22.8-22.8c-49.9-39.4-120.4-38-163.9 5.5l-.5 .5c.1 1.6 .2 3.2 .2 4.8c0 35.3-28.7 64-64 64c-13.9 0-26.7-4.4-37.2-11.9C150.9 257.4 128 302 128 352c0 24.9 5.7 48.4 15.8 69.5L128 432l23.1 23.1 33.8 33.8L208 512l10.5-15.8c21 10.1 44.6 15.8 69.5 15.8c50 0 94.6-22.9 123.9-58.8C404.4 442.7 400 429.9 400 416c0-35.3 28.7-64 64-64c1.6 0 3.2 .1 4.8 .2l.5-.5c43.5-43.5 44.9-114 5.5-163.9L635.3 27.3 612.7 4.7 452.2 165.1zM496 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm96 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm24-24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM178.2 437l65.7-43.8 2.9 2.9L203 461.8 178.2 437z'
      
    ]
  };

  

  
  

  var faBurrito = {
    prefix: 'fasl',
    iconName: 'burrito',
    icon: [
      512,
      512,
      [127791],
      'f7ed',
      
      'M269 80.3L32.3 317c23.9 12.2 51 19 79.7 19c79.2 0 146.2-52.3 168.3-124.3c5-16.3 7.7-33.7 7.7-51.7c0-28.7-6.9-55.8-19-79.7zM32 352.1v34.7L125.3 480h69.5l237-237c-23.9-12.2-51-19-79.7-19c-15.2 0-29.9 1.9-43.9 5.5C279.5 310.2 202.5 368 112 368c-28.3 0-55.4-5.7-80-15.9zM450 270L208 512H112L0 400V304L242 62c8.2-35.5 40-62 78-62c11.4 0 22.2 2.4 32 6.7C361.8 2.4 372.6 0 384 0c34.6 0 64.1 22 75.2 52.8C490 63.9 512 93.4 512 128c0 11.4-2.4 22.2-6.7 32c4.3 9.8 6.7 20.6 6.7 32c0 38-26.5 69.8-62 78zM320 160c0 11.9-1 23.6-2.9 34.9c11.4-1.9 23-2.9 34.9-2.9c42.1 0 81.2 12.5 113.9 33.9c8.7-8.7 14.1-20.7 14.1-34c0-8.8-2.3-16.9-6.4-24l-4.6-8 4.6-8c4.1-7 6.4-15.2 6.4-24c0-22.8-15.9-41.9-37.2-46.8L433 79l-2.2-9.8C425.9 47.9 406.8 32 384 32c-8.8 0-16.9 2.3-24 6.4L352 43l-8-4.6c-7-4.1-15.2-6.4-24-6.4c-13.3 0-25.3 5.4-33.9 14.1C307.5 78.8 320 117.9 320 160z'
      
    ]
  };

  

  
  

  var faCommentMinus = {
    prefix: 'fasl',
    iconName: 'comment-minus',
    icon: [
      512,
      512,
      [],
      'f4b1',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM160 224H144v32h16H352h16V224H352 160z'
      
    ]
  };

  

  
  

  var faBinaryCircleCheck = {
    prefix: 'fasl',
    iconName: 'binary-circle-check',
    icon: [
      640,
      512,
      [],
      'e33c',
      
      'M240 0H224V32h16 48V192H240 224v32h16 64 64 13.4c.8-.7 1.7-1.3 2.6-2V192H368 320V16 0H304 240zM208 288H192v16V496v16h16H368h13.4c-11.7-9.3-22.3-20.1-31.4-32H224V320h94.3c3-11.1 7-21.8 11.9-32H208zM16 288H0v32H16 64V480H16 0v32H16 80h64 16V480H144 96V304 288H80 16zM0 0V16 208v16H16 176h16V208 16 0H176 16 0zM32 32H160V192H32V32zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm78.6-176L552 313.4l-11.3 11.3L480 385.4l-28.7-28.7L440 345.4 417.4 368l11.3 11.3 40 40L480 430.6l11.3-11.3 72-72L574.6 336z'
      
    ]
  };

  

  
  

  var faPanelFire = {
    prefix: 'fasl',
    iconName: 'panel-fire',
    icon: [
      640,
      512,
      [],
      'e42f',
      
      'M416 64H32V448H313.8c6.6 11.5 14.5 22.2 23.3 32H32 0V448 64 32H32 416h32V64v58.1l-17 10.6c-4.6 2.9-9.7 6.3-15 10.1V64zM343 212.3c-6.8 8.6-13.5 17.8-19.7 27.7H96 80V224 128 112H96 352h16v16 56.1c-8.5 8.7-17 18.1-25 28.2zM112 144v64H336V144H112zm16 176H96V288h32v32zm32-32h32v32H160V288zm96 0v32H224V288h32zm233.4-86.6L512 224l22.6-22.6L544 192c76.8 64 96 133.3 96 160c0 85.2-66.6 154.9-150.7 159.7c-3.1 .3-6.2 .4-9.3 .4s-6.3-.1-9.3-.4C386.6 506.9 320 437.2 320 352c0-89.6 85.3-165.3 128-192l41.4 41.4zM480 480c2.4 0 4.8-.1 7.2-.2c33.6-3.3 56.8-29.4 56.8-57.3c0-21.9-15.9-47.5-39-71.3c-8.8-9-17.6-16.9-25-23c-7.4 6.1-16.2 13.9-25 23c-23.1 23.8-39 49.5-39 71.3c0 27.8 23.2 54 56.8 57.3c2.4 .1 4.8 .2 7.2 .2zm96-57.4c0 5.4-.5 10.6-1.5 15.8C595.3 415.6 608 385.3 608 352c0-14.1-11-63.7-63-115.8l-10.4 10.4L512 269.3l-22.6-22.6-45-45c-16.2 12.7-34.9 30-51.4 50.7c-24.3 30.5-41 65-41 99.7c0 33.3 12.7 63.6 33.5 86.3c-1-5.1-1.5-10.4-1.5-15.8c0-70.4 96-134.4 96-134.4s96 64 96 134.4z'
      
    ]
  };

  

  
  

  var faBoltSlash = {
    prefix: 'fasl',
    iconName: 'bolt-slash',
    icon: [
      640,
      512,
      [],
      'e0b8',
      
      'M544 272V224l-88.3-5.9-32.5-2.2 8.3-31.5L466.9 49.8 480 0 438.8 30.9 284.6 146.5l26 20.5L425.7 80.8l-33.4 127-5.2 19.6 25.2 19.9 8.8 .6 91 6.1V256l-45.5 34.1 26 20.5L544 272zM178.7 226L160 240v48l88.3 5.9 17.9 1.2-44.4-35-29.8-2V256l12.7-9.5-26-20.5zm99.8 78.8l-6 22.8L237.1 462.2 224 512l41.2-30.9 121.3-91-26-20.5-82.2 61.7 27.6-104.8-27.4-21.6zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faCodeSimple = {
    prefix: 'fasl',
    iconName: 'code-simple',
    icon: [
      576,
      512,
      [],
      'e13d',
      
      'M203.3 99.3L214.6 88 192 65.4 180.7 76.7l-168 168L1.4 256l11.3 11.3 168 168L192 446.6 214.6 424l-11.3-11.3L46.6 256 203.3 99.3zm169.4 0L529.4 256 372.7 412.7 361.4 424 384 446.6l11.3-11.3 168-168L574.6 256l-11.3-11.3-168-168L384 65.4 361.4 88l11.3 11.3z'
      
    ]
  };

  

  
  

  var faFaceLaughSquint = {
    prefix: 'fasl',
    iconName: 'face-laugh-squint',
    icon: [
      512,
      512,
      ["laugh-squint"],
      'f59b',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 400c52 0 97.1-32.8 115.7-80H140.3c18.6 47.2 63.7 80 115.7 80zM100 288h32.2H379.8 412c-1.1 11-3.2 21.7-6.4 32c-20 64.9-79.4 112-149.6 112s-129.6-47.1-149.6-112c-3.2-10.3-5.3-21-6.4-32zm21.8-122l15.9-27.8 13.9 7.9 56 32L231.9 192l-24.3 13.9-56 32-13.9 7.9L121.8 218l13.9-7.9L167.4 192l-31.7-18.1L121.8 166zm254.5 7.9L344.6 192l31.7 18.1 13.9 7.9-15.9 27.8-13.9-7.9-56-32L280.1 192l24.3-13.9 56-32 13.9-7.9L390.2 166l-13.9 7.9z'
      
    ]
  };

  
    var faLaughSquint = faFaceLaughSquint;
  

  
  

  var faPalletBoxes = {
    prefix: 'fasl',
    iconName: 'pallet-boxes',
    icon: [
      640,
      512,
      [57863,"palette-boxes","pallet-alt"],
      'f483',
      
      'M320 32H96V256H320V32zM96 0H320h32V32 256v32H320 96 64V256 32 0H96zM544 128H416V256H544V128zM416 96H544h32v32V256v32H544 416 384V256 128 96h32zM0 352H16 64 80 96 304h16 16H544h16 16 48 16v32H624 576v96h48 16v32H624 576 560 544 336 320 304 96 80 64 16 0V480H16 64V384H16 0V352zM96 480H304V384H96v96zm240 0H544V384H336v96z'
      
    ]
  };

  
    var faPaletteBoxes = faPalletBoxes;
  
    var faPalletAlt = faPalletBoxes;
  

  
  

  var faBarsSort = {
    prefix: 'fasl',
    iconName: 'bars-sort',
    icon: [
      448,
      512,
      [],
      'e0ae',
      
      'M0 64H448V96H0V64zM0 224H320v32H0V224zM192 384v32H0V384H192z'
      
    ]
  };

  

  
  

  var faChessKnight = {
    prefix: 'fasl',
    iconName: 'chess-knight',
    icon: [
      448,
      512,
      [9822],
      'f441',
      
      'M80 0H64V16 48v9.9l8.8 4.4L85 68.4 68.7 84.7 64 89.4 64 96l-.4 159.6 0 8.3 6.7 4.8L98.9 289 71.4 306.5 64 311.2l0 8.8 0 32H96l0-23.2L264.6 221.5l13.5-8.6-17.2-27-13.5 8.6L128 270.5 95.6 247.4 96 102.6l27.3-27.3L139 59.6l-19.9-9.9L96 38.1V32H230.6C315.3 32 384 100.7 384 185.4c0 8.8-.8 17.6-2.3 26.3L357.3 352h32.5l23.5-134.9c1.8-10.5 2.7-21.1 2.7-31.8C416 83 333 0 230.6 0H80zM48 470.5L81.8 416H366.2L400 470.5V480H48v-9.5zM64 384L16 461.3V480v32H48 400h32V480 461.3L384 384H64zm84-216a20 20 0 1 0 0-40 20 20 0 1 0 0 40z'
      
    ]
  };

  

  
  

  var faFarm = {
    prefix: 'fasl',
    iconName: 'farm',
    icon: [
      576,
      512,
      ["barn-silo"],
      'f864',
      
      'M32 480V192H155.7l17.1-32H32V112c0-44.2 35.8-80 80-80s80 35.8 80 80v12l5.6-10.6 7.8-14.7L220.8 92l1.4-.6C212.5 39.4 166.8 0 112 0C50.1 0 0 50.1 0 112V480v32H32h96V496 480H32zM374.4 65.3L368 62.5l-6.4 2.8-128 56-5.1 2.2-2.6 4.9-64 120L160 252v4V496v16h16H560h16V496 256v-4l-1.9-3.5-64-120-2.6-4.9-5.1-2.2-128-56zM192 260l59.5-111.6L368 97.5l116.5 51L544 260V480H448V384 368H432 304 288v16 96H192V260zM416 480H320V400h96v80zM336 192H304v32 64 32h32 64 32V288 224 192H400 336zm64 32v64H336V224h64z'
      
    ]
  };

  
    var faBarnSilo = faFarm;
  

  
  

  var faSquareT = {
    prefix: 'fasl',
    iconName: 'square-t',
    icon: [
      448,
      512,
      [],
      'e280',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM112 144H224 336h16v32H336 240V368v16H208V368 176H112 96V144h16z'
      
    ]
  };

  

  
  

  var faTvRetro = {
    prefix: 'fasl',
    iconName: 'tv-retro',
    icon: [
      512,
      512,
      [128250],
      'f401',
      
      'M163.9 12L151.7 1.6 130.9 25.8l12.1 10.4L212.7 96H32 0v32V480v32H32 480h32V480 128 96H480 299.3l69.7-59.7 12.2-10.4L360.3 1.6 348.1 12 256 90.9 163.9 12zM256 128H480V480H32V128H256zm96 64V416H96V192H352zM96 160H64v32V416v32H96 352h32V416 192 160H352 96zm336 72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faScannerImage = {
    prefix: 'fasl',
    iconName: 'scanner-image',
    icon: [
      576,
      512,
      [],
      'f8f3',
      
      'M54.8 41.5L40.3 34.7l-13.6 29 14.5 6.8L505.2 288H32 0v32V448v32H32 544h32V448 408 392 320 296v-8-2.2l-9.2-4.3-512-240zM544 320v72 16 40H32V320H544zM208 360H160v48h48V360zM80 360v48h48V360H80z'
      
    ]
  };

  

  
  

  var faSnooze = {
    prefix: 'fasl',
    iconName: 'snooze',
    icon: [
      448,
      512,
      [128164,"zzz"],
      'f880',
      
      'M160 0h16H304h16V16v8 7.3L314.5 36 209.4 128H304h16v32H304 176 160V144v-8-7.3l5.5-4.8L270.6 32H176 160V0zM0 224H16 208h16v16 8 5.6l-3.5 4.4L42.9 480H208h16v32H208 16 0V496v-8-5.6L3.5 478 181.1 256H16 0V224zm304 0H432h16v16 8 6.1l-4 4.5L332.5 384H432h16v32H432 304 288V400v-8-6.1l4-4.5L403.5 256H304 288V224h16z'
      
    ]
  };

  
    var faZzz = faSnooze;
  

  
  

  var faBlockQuestion = {
    prefix: 'fasl',
    iconName: 'block-question',
    icon: [
      448,
      512,
      [],
      'e3dd',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM88 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm248 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM88 368a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm248 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM136 192c0-30.9 25.1-56 56-56h56c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L240 276.3V280v16H208V280 266.5v-9.8l8.7-4.5 45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H192c-13.3 0-24 10.7-24 24v8H136v-8zm64 136h48v48H200V328z'
      
    ]
  };

  

  
  

  var faPlayPause = {
    prefix: 'fasl',
    iconName: 'play-pause',
    icon: [
      640,
      512,
      [],
      'e22f',
      
      'M64 448V408 104 64L96 88 293.3 236 320 256l-26.7 20L96 424 64 448zM266.7 256L96 128V384L266.7 256zM448 80V432v16H416V432 80 64h32V80zm128 0V432v16H544V432 80 64h32V80z'
      
    ]
  };

  

  
  

  var faLayerPlus = {
    prefix: 'fasl',
    iconName: 'layer-plus',
    icon: [
      576,
      512,
      ["layer-group-plus"],
      'f5ff',
      
      'M480 24V64h40 16V96H520 480v40 16H448V136 96H408 392V64h16 40V24 8h32V24zM78.8 256L288 349l209.2-93L288 163 78.8 256zM288 128L536.6 238.5 576 256l-39.4 17.5L288 384 39.4 273.5 0 256l39.4-17.5L288 128zM104.6 337.5L144 355 78.8 384 288 477l209.2-93L432 355l39.4-17.5 65.2 29L576 384l-39.4 17.5L288 512 39.4 401.5 0 384l39.4-17.5 65.2-29z'
      
    ]
  };

  
    var faLayerGroupPlus = faLayerPlus;
  

  
  

  var faArrowUpAZ = {
    prefix: 'fasl',
    iconName: 'arrow-up-a-z',
    icon: [
      576,
      512,
      ["sort-alpha-up"],
      'f15e',
      
      'M405.6 32l-4.2 9.5-80 180-1.1 2.5h35l14.2-32h93l14.2 32h35l-1.1-2.5-80-180L426.4 32H405.6zm42.7 128H383.7L416 87.4 448.3 160zM171.3 44.7L160 33.4 148.7 44.7l-88 88L49.4 144 72 166.6l11.3-11.3L144 94.6V464v16h32V464 94.6l60.7 60.7L248 166.6 270.6 144l-11.3-11.3-88-88zM352 288H336v32h16 99.5L340 445.4l-4 4.5V456v8 16h16H480h16V448H480 380.5L492 322.6l4-4.5V312v-8V288H480 352z'
      
    ]
  };

  
    var faSortAlphaUp = faArrowUpAZ;
  

  
  

  var faUserGroup = {
    prefix: 'fasl',
    iconName: 'user-group',
    icon: [
      640,
      512,
      [128101,"user-friends"],
      'f500',
      
      'M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM87.6 336H360.4l44.3 144H43.3L87.6 336zM384 304H64L9.8 480 0 512H33.5h381H448l-9.8-32L384 304zM606.3 512H640l-10.7-32L576 320H422.4l9.8 32H552.9l42.7 128h-124l7 22.6 2.9 9.4H606.3zM432 256c61.9 0 112-50.1 112-112s-50.1-112-112-112c-24.8 0-47.7 8.1-66.3 21.7c5.2 9.8 9.3 20.3 12.4 31.2C392.3 71.9 411.2 64 432 64c44.2 0 80 35.8 80 80s-35.8 80-80 80c-25.2 0-47.6-11.6-62.3-29.8c-4.7 10.3-10.4 19.9-17 28.9C373 243.4 401 256 432 256z'
      
    ]
  };

  
    var faUserFriends = faUserGroup;
  

  
  

  var faBooks = {
    prefix: 'fasl',
    iconName: 'books',
    icon: [
      512,
      512,
      [128218],
      'f5db',
      
      'M128 416v64H32V416h96zm0-288V384H32V128h96zm0-96V96H32V32h96zM160 0H128 32 0V32 96v16 16V384v16 16 64 32H32h96 32 96 32V480 416 400 384 230.6l41.6 155.2 4.1 15.5 4.1 15.5 17.2 64.4 8.3 30.9 30.9-8.3 85.8-23 30.9-8.3-8.3-30.9-17.2-64.4-4.1-15.5-4.1-15.5-59-220.1-4.1-15.5L410 95.3 392.7 30.9 384.4 0 353.5 8.3 288 25.8V0H256 160zM288 59l73.8-19.8 17.2 64.4-85.8 23L288 107V96 59zM256 480H160V416h96v64zm0-384H160V32h96V96zm0 288H160V128h96V384zm130 88.8l-17.2-64.4 85.8-23 17.2 64.4-85.8 23zm-25.5-95.3l-59-220.1 85.8-23 59 220.1-85.8 23z'
      
    ]
  };

  

  
  

  var faStarExclamation = {
    prefix: 'fasl',
    iconName: 'star-exclamation',
    icon: [
      576,
      512,
      [],
      'f2f3',
      
      'M306.1 34.3L374.6 164 519 189l38.2 6.6-27 27.8L428 328.5l21 146.1 5.4 37.4-34.5-15.3L288.1 438.2 156.2 496.7 121.7 512l5.4-37.4 21-146.1L45.9 223.4l-27-27.8L57.1 189l144.5-25L270 34.3 288.1 0l18.1 34.3zm63 161.2l-15.5-2.7-7.3-13.9L288.1 68.6 229.9 178.9l-7.3 13.9L207 195.5 84.1 216.8 171 306.2l11 11.3-2.2 15.6L161.6 459.3 275.1 409l13-5.8 13 5.8 113.5 50.3L396.4 333.1l-2.2-15.6 11-11.3L492 216.8 369.1 195.5zM304 160v16V280v16H272V280 176 160h32zM264 328h48v48H264V328z'
      
    ]
  };

  

  
  

  var faArrowUpToArc = {
    prefix: 'fasl',
    iconName: 'arrow-up-to-arc',
    icon: [
      512,
      512,
      [],
      'e617',
      
      'M256 32c123.7 0 224 100.3 224 224l0 16 32 0 0-16C512 114.6 397.4 0 256 0S0 114.6 0 256l0 16 32 0 0-16C32 132.3 132.3 32 256 32zM396 309.4l-128-144-12-13.5-12 13.5-128 144-10.6 12 23.9 21.3 10.6-12L240 218.1 240 496l0 16 32 0 0-16 0-277.9L372 330.6l10.6 12 23.9-21.3-10.6-12z'
      
    ]
  };

  

  
  

  var faWeightScale = {
    prefix: 'fasl',
    iconName: 'weight-scale',
    icon: [
      512,
      512,
      ["weight"],
      'f496',
      
      'M112 176a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm320 0c0-28.8-6.9-56-19.2-80H480V480H32V96H99.2C86.9 120 80 147.2 80 176c0 97.2 78.8 176 176 176s176-78.8 176-176zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H32 0V96 480v32H32 480h32V480 96 64H480 391.8zM320 224c0-20.6-9.7-39-24.9-50.7l23.6-55 6.3-14.7L295.6 91l-6.3 14.7-23.6 55c-3.2-.5-6.4-.7-9.7-.7c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zm-64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  
    var faWeight = faWeightScale;
  

  
  

  var faHandBackPointUp = {
    prefix: 'fasl',
    iconName: 'hand-back-point-up',
    icon: [
      448,
      512,
      [],
      'e1a2',
      
      'M96 0H80V16 248v8.6c-3.2 2-6.4 4.2-9.5 6.5L22.4 299.2 16 304v8 51.5c0 53 29.1 101.7 75.7 126.8l8.3 4.5c21 11.3 44.4 17.2 68.3 17.2H304c61.9 0 112-50.1 112-112V304 256 240H400 352V224 208H336 280V192 176H264 192V16 0H176 96zM80 296v48 16h32V344 275.3v-9.5V264 248 32h48V192v16h16 72v16 16h16 56v16 16h16 48v32 96c0 44.2-35.8 80-80 80H168.3c-18.5 0-36.8-4.6-53.1-13.4l-7.6 14.1 7.6-14.1-8.3-4.5C70.6 442.6 48 404.7 48 363.5V320l32-24z'
      
    ]
  };

  

  
  

  var faFlowerDaffodil = {
    prefix: 'fasl',
    iconName: 'flower-daffodil',
    icon: [
      512,
      512,
      [9880],
      'f800',
      
      'M256 61.6l20.4-16.8c9.7-8 22.1-12.8 35.6-12.8c30.9 0 56 25.1 56 56c0 13.6-4.8 25.9-12.8 35.6L338.4 144l16.8 20.4c8 9.7 12.8 22.1 12.8 35.6c0 30.9-25.1 56-56 56c-13.6 0-25.9-4.8-35.6-12.8L256 226.4l-20.4 16.8c-9.7 8-22.1 12.8-35.6 12.8c-30.9 0-56-25.1-56-56c0-13.6 4.8-25.9 12.8-35.6L173.6 144l-16.8-20.4c-8-9.7-12.8-22.1-12.8-35.6c0-30.9 25.1-56 56-56c13.6 0 25.9 4.8 35.6 12.8L256 61.6zM379.9 144c12.6-15.2 20.1-34.7 20.1-56c0-48.6-39.4-88-88-88c-21.3 0-40.8 7.5-56 20.1C240.8 7.5 221.3 0 200 0c-48.6 0-88 39.4-88 88c0 21.3 7.5 40.8 20.1 56c-12.6 15.2-20.1 34.7-20.1 56c0 48.6 39.4 88 88 88c14.4 0 28-3.5 40-9.6V396.6C200.8 331.5 129.5 288 48 288H32 0c0 10.9 .8 21.5 2.3 32C17.8 428.6 111.2 512 224 512h16 32 16c112.8 0 206.2-83.4 221.7-192c1.5-10.5 2.3-21.1 2.3-32H480 464c-81.5 0-152.8 43.5-192 108.6V278.4c12 6.1 25.6 9.6 40 9.6c48.6 0 88-39.4 88-88c0-21.3-7.5-40.8-20.1-56zM237.3 480H224c-95.1 0-174.1-69.2-189.3-160H48c95.1 0 174.1 69.2 189.3 160zm37.3 0c15.2-90.8 94.2-160 189.3-160h13.3C462.1 410.8 383.1 480 288 480H274.7zM256 184l40-40-40-40-40 40 40 40z'
      
    ]
  };

  

  
  

  var faCalendarRange = {
    prefix: 'fasl',
    iconName: 'calendar-range',
    icon: [
      448,
      512,
      [],
      'e0d6',
      
      'M128 0V16 64H320V16 0h32V16 64h64 32V96v64 32V480v32H416 32 0V480 192 160 96 64H32 96V16 0h32zM416 192H32V480H416V192zm0-96H32v64H416V96zM384 288H368 208 192V256h16H368h16v32zM240 416H80 64V384H80 240h16v32H240zM128 256H96v32h32V256zM96 224h32 32v32 32 32H128 96 64V288 256 224H96zM320 384v32h32V384H320zm-32-32h32 32 32v32 32 32H352 320 288V416 384 352z'
      
    ]
  };

  

  
  

  var faTableCellsLock = {
    prefix: 'fasl',
    iconName: 'table-cells-lock',
    icon: [
      640,
      512,
      [],
      'e679',
      
      'M352 64l0 96 128 0 0-96L352 64zm-32 0L192 64l0 96 128 0 0-96zM160 64L32 64l0 96 128 0 0-96zM32 192l0 128 128 0 0-128L32 192zm0 160l0 96 128 0 0-96L32 352zm160 96l128 0 0-96-128 0 0 96zm160 0l32 0 0 32L32 480 0 480l0-32L0 64 0 32l32 0 448 0 32 0 0 32 0 97.1c-24.1 3.5-45.8 14.6-62.4 30.9L352 192l0 128 32 0 0 32-32 0 0 96zM192 320l128 0 0-128-128 0 0 128zm336-96c-26.5 0-48 21.5-48 48l0 48 96 0 0-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 32 0 128 0 32-32 0-160 0-32 0 0-32 0-128 0-32 32 0 0-48zm0 80l0 128 160 0 0-128-160 0z'
      
    ]
  };

  

  
  

  var faFilePrescription = {
    prefix: 'fasl',
    iconName: 'file-prescription',
    icon: [
      384,
      512,
      [],
      'f572',
      
      'M32 480V32H192V176v16h16H352V480H32zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM112 224H96v16 80 64 16h32V384 336h41.4l48 48-36.7 36.7L169.4 432 192 454.6l11.3-11.3L240 406.6l36.7 36.7L288 454.6 310.6 432l-11.3-11.3L262.6 384l36.7-36.7L310.6 336 288 313.4l-11.3 11.3L240 361.4l-31.2-31.2C227.3 321.1 240 302 240 280c0-30.9-25.1-56-56-56H112zm72 80H128V256h56c13.3 0 24 10.7 24 24s-10.7 24-24 24z'
      
    ]
  };

  

  
  

  var faXmarksLines = {
    prefix: 'fasl',
    iconName: 'xmarks-lines',
    icon: [
      640,
      512,
      [],
      'e59a',
      
      'M16 32H0V64H16 624h16V32H624 16zm0 416H0v32H16 624h16V448H624 16zM35.3 172.7L24 161.4 1.4 184l11.3 11.3L73.4 256 12.7 316.7 1.4 328 24 350.6l11.3-11.3L96 278.6l60.7 60.7L168 350.6 190.6 328l-11.3-11.3L118.6 256l60.7-60.7L190.6 184 168 161.4l-11.3 11.3L96 233.4 35.3 172.7zm224 0L248 161.4 225.4 184l11.3 11.3L297.4 256l-60.7 60.7L225.4 328 248 350.6l11.3-11.3L320 278.6l60.7 60.7L392 350.6 414.6 328l-11.3-11.3L342.6 256l60.7-60.7L414.6 184 392 161.4l-11.3 11.3L320 233.4l-60.7-60.7zm224 0L472 161.4 449.4 184l11.3 11.3L521.4 256l-60.7 60.7L449.4 328 472 350.6l11.3-11.3L544 278.6l60.7 60.7L616 350.6 638.6 328l-11.3-11.3L566.6 256l60.7-60.7L638.6 184 616 161.4l-11.3 11.3L544 233.4l-60.7-60.7z'
      
    ]
  };

  

  
  

  var faWeightHanging = {
    prefix: 'fasl',
    iconName: 'weight-hanging',
    icon: [
      512,
      512,
      [],
      'f5cd',
      
      'M208 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 48c10-13.4 16-30 16-48c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 18 6 34.6 16 48H88L7.3 480 0 512H32.8 479.2 512l-7.3-32L424 128H320zm-64 32H398.5l73.3 320H40.2l73.3-320H256z'
      
    ]
  };

  

  
  

  var faCrown = {
    prefix: 'fasl',
    iconName: 'crown',
    icon: [
      576,
      512,
      [128081],
      'f521',
      
      'M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L206.6 226.7 192 256l-25.6-20.4L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L96 480H480l55.3-304c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-94.4 75.6L384 256l-14.6-29.3L309 106zM220.6 270.3L288 135.6l67.4 134.8 17.7 35.4L404 281l93.2-74.6L453.3 448H122.7L78.8 206.4 172 281l30.9 24.7 17.7-35.4z'
      
    ]
  };

  

  
  

  var faLeftLongToLine = {
    prefix: 'fasl',
    iconName: 'left-long-to-line',
    icon: [
      640,
      512,
      [],
      'e41e',
      
      'M0 80V64H32V80 432v16H0V432 80zM320 216l-32 0V184 141.3L173.3 256 288 370.7V328 296l32 0 288 0 0-80-288 0zm0-120v32 24 32h32H608h32v32 80 32H608 352 320v32 24 32H288L150.6 278.6 128 256l22.6-22.6L288 96h32z'
      
    ]
  };

  

  
  

  var faMicrochip = {
    prefix: 'fasl',
    iconName: 'microchip',
    icon: [
      512,
      512,
      [],
      'f2db',
      
      'M176 16V0H144V16 64H96 64V96v48H16 0v32H16 64v64H16 0v32H16 64v64H16 0v32H16 64v48 32H96h48v48 16h32V496 448h64v48 16h32V496 448h64v48 16h32V496 448h48 32V416 368h48 16V336H496 448V272h48 16V240H496 448V176h48 16V144H496 448V96 64H416 368V16 0H336V16 64H272V16 0H240V16 64H176V16zM416 96V416H96V96H416zm-64 64V352H160V160H352zM160 128H128v32V352v32h32H352h32V352 160 128H352 160z'
      
    ]
  };

  

  
  

  var faTemperatureHigh = {
    prefix: 'fasl',
    iconName: 'temperature-high',
    icon: [
      512,
      512,
      [],
      'f769',
      
      'M416 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 416 0a64 64 0 1 0 0 128zM101.3 284.5L112 275V260.7 32H240V260.7 275l10.7 9.5c23 20.6 37.3 50.3 37.3 83.5c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-33.2 14.4-62.9 37.3-83.5zM272 0H240 112 80V32 260.7C50.5 287.1 32 325.4 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-42.6-18.5-81-48-107.3V32 0zM144 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V96 80H160V96 306c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  

  
  

  var faTrashCanXmark = {
    prefix: 'fasl',
    iconName: 'trash-can-xmark',
    icon: [
      448,
      512,
      [],
      'e2ae',
      
      'M160 0h-8.9l-4.7 7.5L111.1 64H64 32 0V96H32V480v32H64 384h32V480 96h32V64H416 384 336.9L301.6 7.5 296.9 0H288 160zM299.1 64H148.9l20-32H279.1l20 32zM64 480V96H384V480H64zm95.4-279.2l-22.6 22.6 11.3 11.3L201.4 288l-53.3 53.3-11.3 11.3 22.6 22.6 11.3-11.3L224 310.6l53.3 53.3 11.3 11.3 22.6-22.6-11.3-11.3L246.6 288l53.3-53.3 11.3-11.3-22.6-22.6-11.3 11.3L224 265.4l-53.3-53.3-11.3-11.3z'
      
    ]
  };

  

  
  

  var faFolderUser = {
    prefix: 'fasl',
    iconName: 'folder-user',
    icon: [
      512,
      512,
      [],
      'e18e',
      
      'M32 32H224l48 64H480h32v32V448v32H480 32 0V448 64 32H32zm240 96H256l-9.6-12.8L208 64H32V448H480V128H272zM256 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM177.7 416H144l32-96H336l32 96H334.3l-21.3-64H199.1l-21.3 64z'
      
    ]
  };

  

  
  

  var faPeopleCarryBox = {
    prefix: 'fasl',
    iconName: 'people-carry-box',
    icon: [
      640,
      512,
      ["people-carry"],
      'f4ce',
      
      'M136 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 136 0zm88.3 512H191.8L169.3 384.9 82.7 318.3c-11.8-9.1-18.7-23.1-18.7-38V160 144H80h64 9.9l4.4 8.8L212.4 261l11.6 7.7V144 128h16H400h16v16V268.8l11.6-7.7 54.1-108.2 4.4-8.8H496h64 16v16V280.2c0 14.9-6.9 29-18.7 38l-86.6 66.6L448.2 512H415.7l.5-2.8 24-136 1.1-6.1 4.9-3.8 33.8-26V227.8l-25.7 51.4-1.9 3.8-3.5 2.4-48 32-4 2.7H392 248h-4.8l-4-2.7-48-32-3.5-2.4-1.9-3.8L160 227.8V337.3l33.8 26 4.9 3.8 1.1 6.1 24 136 .5 2.8zM2 512L69 344.3l26.2 20.6L36.4 512H2zM638 512H603.6L544.7 364.9 571 344.3 638 512zM480 56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm80 0A56 56 0 1 1 448 56a56 56 0 1 1 112 0zM384 288V160H256V288H384zM128 312.7V176H96V280.2c0 5 2.3 9.7 6.2 12.7L128 312.7zm384 0l25.8-19.8c3.9-3 6.2-7.7 6.2-12.7V176H512V312.7z'
      
    ]
  };

  
    var faPeopleCarry = faPeopleCarryBox;
  

  
  

  var faClockTenThirty = {
    prefix: 'fasl',
    iconName: 'clock-ten-thirty',
    icon: [
      512,
      512,
      [],
      'e355',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400V256v-8.6l-7.1-4.8-96-64-13.3-8.9-17.8 26.6 13.3 8.9L240 264.6V400v16h32V400z'
      
    ]
  };

  

  
  

  var faCloudsMoon = {
    prefix: 'fasl',
    iconName: 'clouds-moon',
    icon: [
      640,
      512,
      [],
      'f745',
      
      'M512 26.8c-2.8 1.7-5.6 3.5-8.3 5.4C470 56.2 448 95.5 448 140c0 71 56 128.9 126.3 131.9c1.9 .1 3.8 .1 5.7 .1c20.8 0 40.5-4.8 58-13.4c-15 19.1-34.2 34.7-56.2 45.4c-21.1 10.3-44.8 16-69.8 16c-4 0-7.9-.1-11.8-.4c-11.2-9.8-24.2-17.7-38.4-23.1c-1.4-7.4-3.4-14.5-5.9-21.3c16.1 7.9 34.2 12.5 53.3 12.9C454.1 261.5 416 205.2 416 140c0-31.6 8.9-61.1 24.4-86.1c-34 23-56.4 61.9-56.4 106.1c0 15.8 2.9 30.9 8.1 44.9c-11.4-5.5-23.7-9.4-36.6-11.4c-2.3-10.8-3.5-22-3.5-33.5C352 78.2 413.4 10.7 492.7 1.2C499 .4 505.5 0 512 0c18.5 0 36.2 3.1 52.7 8.9c-19.1 2.2-37 8.5-52.7 18zM261 259.9C278.6 238 305.6 224 335.9 224c53 0 96 43 96 96l0 1.3c45.4 7.6 80 47.1 80 94.6v64 32h-32-64H144l-48 0H64v-80c0-37.1 25.3-68.4 59.7-77.4c2-.5 4.1-1 6.2-1.4c-.5-2.1-.8-4.1-1.1-6.2c-.5-3.6-.8-7.3-.8-11c0-44.2 35.8-80 80-80c13.2 0 25.7 3.2 36.7 8.9c3.2 1.6 6.2 3.5 9.1 5.5c2.2-3.6 4.6-7.1 7.3-10.4zM96 479.9l48 0H415.9h64v-64c0-31.7-23-58-53.3-63.1l-26.9-4.5 .2-27.3 0-1.2c-.1-35.3-28.7-63.9-64-63.9c-23.2 0-43.5 12.3-54.8 30.9l-17.7 29.3-28-19.6c-7.8-5.4-17.2-8.6-27.4-8.6c-26.5 0-48 21.5-48 48c0 3.6 .4 7.1 1.1 10.4l7.1 32.5-32.8 5.8C113 388.7 96 408.4 96 431.9v48zM233.4 160.1H212.4L204 140.9c-7.4-17-24.4-28.8-44-28.8c-23.2 0-42.6 16.5-47 38.3l-5.2 25.6H81.7 72.1c-22.1 0-40 17.9-40 40v40h40 32l0 0h25.6c-9.4 9.2-17.1 20-22.8 32H72.1l0 0h-40H.1v-32-40c0-39.8 32.2-72 72-72h9.6c7.4-36.5 39.7-64 78.4-64c32.8 0 61 19.7 73.3 48H256c35.3 0 64 28.6 64 64v.9c-11.2 1.4-21.9 4.2-32 8.3v-9.2c0-17.7-14.3-32-32-32H233.4z'
      
    ]
  };

  

  
  

  var faCircle8 = {
    prefix: 'fasl',
    iconName: 'circle-8',
    icon: [
      512,
      512,
      [],
      'e0f5',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM268 128c37.6 0 68 30.4 68 68c0 20.2-8.8 38.4-22.9 50.9C331.9 260.7 344 282.9 344 308c0 42-34 76-76 76H244c-42 0-76-34-76-76c0-25.1 12.1-47.3 30.9-61.1c-14-12.5-22.9-30.6-22.9-50.9c0-37.6 30.4-68 68-68h24zM244 232s0 0 0 0h24c19.9 0 36-16.1 36-36s-16.1-36-36-36H244c-19.9 0-36 16.1-36 36s16.1 36 36 36zm24 32H244c-24.3 0-44 19.7-44 44s19.7 44 44 44h24c24.3 0 44-19.7 44-44s-19.7-44-44-44z'
      
    ]
  };

  

  
  

  var faHeartPulse = {
    prefix: 'fasl',
    iconName: 'heart-pulse',
    icon: [
      512,
      512,
      ["heartbeat"],
      'f21e',
      
      'M256 141.3l-22.6-22.6L209.1 94.4C189.7 74.9 163.3 64 135.8 64C78.5 64 32 110.5 32 167.8c0 27.5 10.9 53.9 30.4 73.4L77.2 256H80h54.1l35.6-71.2 13.5-27 14.8 26.3 59.2 105.3 49.5-74.3 13.3-20 13.3 20L360.6 256H432h2.8l14.9-14.8c19.5-19.5 30.4-45.9 30.4-73.4C480 110.5 433.5 64 376.2 64c-27.5 0-53.9 10.9-73.4 30.4l-24.2 24.2L256 141.3zM448 288H432 402.8 352h-8.6l-4.7-7.1-18.7-28-50.7 76-14.5 21.7-12.8-22.7L184.8 226.1l-26.5 53-4.4 8.8H144 109.2 80 64h0L39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8l1.6 1.6L256 96l22.6-22.6 1.6-1.6c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 36-14.3 70.5-39.8 96L448 288h0zM96 320h45.3L256 434.8 370.8 320H416L278.6 457.4 256 480l-22.6-22.6L96 320z'
      
    ]
  };

  
    var faHeartbeat = faHeartPulse;
  

  
  

  var faInboxIn = {
    prefix: 'fasl',
    iconName: 'inbox-in',
    icon: [
      512,
      512,
      [128229,"inbox-arrow-down"],
      'f310',
      
      'M272 16V265.4l84.7-84.7L368 169.4 390.6 192l-11.3 11.3-112 112L256 326.6l-11.3-11.3-112-112L121.4 192 144 169.4l11.3 11.3L240 265.4V16 0h32V16zM32 320H144l32 64H336l32-64H480h32v32V480v32H480 32 0V480 352 320H32zm332.6 78.3L355.8 416H336 176 156.2l-8.8-17.7L124.2 352H32V480H480V352H387.8l-23.2 46.3z'
      
    ]
  };

  
    var faInboxArrowDown = faInboxIn;
  

  
  

  var faPassport = {
    prefix: 'fasl',
    iconName: 'passport',
    icon: [
      448,
      512,
      [],
      'f5ab',
      
      'M416 32V480H32V32H416zM32 0H0V32 480v32H32 416h32V480 32 0H416 32zM96 384v32h16H336h16V384H336 112 96zm33.3-176h39.1c1.6 30.4 7.7 53.8 14.6 70.8c-27.9-13.2-48.4-39.4-53.7-70.8zM224 288l-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5l-.3 0zm94.7-80c-5.3 31.4-25.8 57.6-53.7 70.8c6.8-17.1 12.9-40.4 14.6-70.8h39.1zm0-32H279.6c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8zM224 96l.3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5H200.5c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5l.3 0zm-94.7 80c5.3-31.4 25.8-57.6 53.7-70.8c-6.8 17.1-12.9 40.4-14.6 70.8H129.3zM224 320a128 128 0 1 0 0-256 128 128 0 1 0 0 256z'
      
    ]
  };

  

  
  

  var faVenus = {
    prefix: 'fasl',
    iconName: 'venus',
    icon: [
      384,
      512,
      [9792],
      'f221',
      
      'M48 176a144 144 0 1 1 288 0A144 144 0 1 1 48 176zM208 351.3c89.7-8.1 160-83.5 160-175.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 91.8 70.3 167.2 160 175.3V416H112 96v32h16 64v48 16h32V496 448h64 16V416H272 208V351.3z'
      
    ]
  };

  

  
  

  var faCommentSmile = {
    prefix: 'fasl',
    iconName: 'comment-smile',
    icon: [
      512,
      512,
      [],
      'f4b4',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM192 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM167.8 273.4L144 294.7l10.7 11.9C179.5 334.5 215.7 352 256 352s76.5-17.5 101.4-45.3L368 294.7l-23.8-21.3-10.7 11.9C314.5 306.6 286.8 320 256 320s-58.5-13.4-77.5-34.7l-10.7-11.9z'
      
    ]
  };

  

  
  

  var faSquareRight = {
    prefix: 'fasl',
    iconName: 'square-right',
    icon: [
      448,
      512,
      [10145,"arrow-alt-square-right"],
      'f352',
      
      'M416 64L32 64l0 384 384 0 0-384zm32-32V64l0 384v32H416L32 480H0V448 64 32H32 416h32zM224 224l-96 0v64l96 0h32l0 32v18.7L338.7 256 256 173.3V192v32H224zm160 32l-22.6 22.6L256 384H224V352 320H192 128 96V288 224l0-32h32 64l32 0V160 128h32L361.4 233.4 384 256z'
      
    ]
  };

  
    var faArrowAltSquareRight = faSquareRight;
  

  
  

  var faVideoPlus = {
    prefix: 'fasl',
    iconName: 'video-plus',
    icon: [
      576,
      512,
      [],
      'f4e1',
      
      'M352 96V416H32V96H352zM32 64H0V96 416v32H32 352h32V416 352 160 96 64H352 32zM416 332.2V368l128 64 32 16V412.2 99.8 64L544 80 416 144v35.8l128-64V396.2l-128-64zM208 176V160H176v16 64H112 96v32h16 64v64 16h32V336 272h64 16V240H272 208V176z'
      
    ]
  };

  

  
  

  var faRightToBracket = {
    prefix: 'fasl',
    iconName: 'right-to-bracket',
    icon: [
      512,
      512,
      ["sign-in-alt"],
      'f2f6',
      
      'M144 208l32 0 0-32 0-48 17.7 0L308.9 256 193.7 384 176 384l0-48 0-32-32 0L32 304l0-96 112 0zm0-112l0 32 0 16 0 32-32 0-80 0L0 176l0 32 0 96 0 32 32 0 80 0 32 0 0 32 0 16 0 32 32 0 32 0L352 256 208 96l-32 0-32 0zM336 448l-16 0 0 32 16 0 160 0 16 0 0-16 0-416 0-16-16 0L336 32l-16 0 0 32 16 0 144 0 0 384-144 0z'
      
    ]
  };

  
    var faSignInAlt = faRightToBracket;
  

  
  

  var faFireHydrant = {
    prefix: 'fasl',
    iconName: 'fire-hydrant',
    icon: [
      384,
      512,
      [],
      'e17f',
      
      'M208 0V16 33c57.9 7.2 103.8 53.1 111 111h17 16v32H336 48 32V144H48 65C72.2 86.1 118.1 40.2 176 33V16 0h32zM192 64c-47.6 0-87.1 34.6-94.7 80H286.7c-7.6-45.4-47.1-80-94.7-80zM32 480H48 64V400H16 0V384 256 240H16 64V208H96v48V384v96H288V384 256 208h32v32h48 16v16V384v16H368 320v80h16 16v32H336 304 80 48 32V480zM64 368V272H32v96H64zm160-48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 48V272H320v96h32zM128 320a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faFilePng = {
    prefix: 'fasl',
    iconName: 'file-png',
    icon: [
      512,
      512,
      [],
      'e666',
      
      'M352 192l0 112 32 0 0-152L232 0 32 0 0 0 0 32 0 480l0 32 32 0 80 0 0-32-80 0L32 32l160 0 0 144 0 16 16 0 144 0zm-5.3-32L224 160l0-122.7L346.7 160zM176 352l-16 0 0 16 0 80 0 48 0 16 32 0 0-16 0-32 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0zm32 80l-16 0 0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm96-80l-16 0 0 16 0 128 0 16 32 0 0-16 0-58.9 27.7 65.1 4.1 9.7 10.6 0 5.6 0 16 0 0-16 0-128 0-16-32 0 0 16 0 62.6-29.3-68.9-4.1-9.7L308 352l-4 0zm112 40l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-24 0-16-16 0-16 0-16 0 0 32 16 0 0 8c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 16 32 0 0-16c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40z'
      
    ]
  };

  

  
  

  var faApostrophe = {
    prefix: 'fasl',
    iconName: 'apostrophe',
    icon: [
      192,
      512,
      [],
      '27',
      
      'M80 352c61.9 0 112-50.1 112-112V224 192 128 64 32H160 32 0V64 192v32H32 160v16c0 44.2-35.8 80-80 80H64v32H80zm80-160H32V64H160v64 64z'
      
    ]
  };

  

  
  

  var faPersonBreastfeeding = {
    prefix: 'fasl',
    iconName: 'person-breastfeeding',
    icon: [
      448,
      512,
      [],
      'e53a',
      
      'M176 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 144 80a80 80 0 1 0 160 0zM128 192h-8.6l-4.7 7.1-96 144-2.7 4V352v62.8V425l9.3 4.3 176 81.2 13.4-29.1L48 404.5V356.8L136.6 224H313.1l100 106.5v31l-88.6 91.3-11.1 11.5 23 22.3 11.1-11.5 93.1-96 4.5-4.7V368 324.1v-6.3l-4.3-4.6L331.7 197l-4.7-5H320 128zm64 128V304H160v16 48 7.2l5.4 4.8 72 64 4.5 4H248h40 16V416H288 254.1L192 360.8V320zm80 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faGaugeMax = {
    prefix: 'fasl',
    iconName: 'gauge-max',
    icon: [
      512,
      512,
      ["tachometer-alt-fastest"],
      'f626',
      
      'M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm24 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-32 0c0-35.3 28.7-64 64-64c17.5 0 33.4 7 44.9 18.4l106.9-64.1 13.7-8.2L438 261.5l-13.7 8.2L317.4 333.8c1.7 5.8 2.6 11.9 2.6 18.2c0 35.3-28.7 64-64 64s-64-28.7-64-64zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM96 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72-88a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z'
      
    ]
  };

  
    var faTachometerAltFastest = faGaugeMax;
  

  
  

  var faBuildingWheat = {
    prefix: 'fasl',
    iconName: 'building-wheat',
    icon: [
      640,
      512,
      [],
      'e4db',
      
      'M352 32V480H256V400 368H224 160 128v32 80H32V32H352zM224 480H160V400h64v80zM32 512h96 32 64 32 96 32V480 32 0H352 32 0V32 480v32H32zM80 96H64v16 64 16H80h64 16V176 112 96H144 80zm16 64V128h32v32H96zM224 96v16 64 16h16 64 16V176 112 96H304 240 224zm32 32h32v32H256V128zM80 224H64v16 64 16H80h64 16V304 240 224H144 80zm16 64V256h32v32H96zm128-64v16 64 16h16 64 16V304 240 224H304 240 224zm32 32h32v32H256V256zm384-64H624 608c-33.4 0-62.8 17-80 42.9C510.8 209 481.4 192 448 192H432 416v16 16c0 24.6 9.2 47 24.4 64H432 416v16 16c0 24.6 9.2 47 24.4 64H432 416v16 16c0 53 43 96 96 96h16 16c53 0 96-43 96-96V400 384H624h-8.4c15.2-17 24.4-39.4 24.4-64V304 288H624h-8.4c15.2-17 24.4-39.4 24.4-64V208 192zm-96 96c0-35.3 28.7-64 64-64c0 35.3-28.7 64-64 64v0zm-7.6 32c-3.1 3.4-5.9 7.1-8.4 10.9c-2.6-3.8-5.4-7.5-8.4-10.9H528h8.4zM512 288c-35.3 0-64-28.7-64-64c35.3 0 64 28.7 64 64zm32 96v0c0-35.3 28.7-64 64-64c0 35.3-28.7 64-64 64zm-16 32h8.4c-3.1 3.4-5.9 7.1-8.4 10.9c-2.6-3.8-5.4-7.5-8.4-10.9H528zm16 64c0-35.3 28.7-64 64-64c0 35.3-28.7 64-64 64v0zm-32 0c-35.3 0-64-28.7-64-64c35.3 0 64 28.7 64 64zm0-96c-35.3 0-64-28.7-64-64c35.3 0 64 28.7 64 64zM544 32l-32 0V48 160v16h32V160 48l0-16zm32 64v48 16h32V144 96 80H576V96zM448 144v16l32 0V144 96 80H448V96v48z'
      
    ]
  };

  

  
  

  var faCircleE = {
    prefix: 'fasl',
    iconName: 'circle-e',
    icon: [
      512,
      512,
      [],
      'e109',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128H160v16V256 368v16h16H336h16V352H336 192V272H304h16V240H304 192V160H336h16V128H336 176z'
      
    ]
  };

  

  
  

  var faChartPieSimpleCircleCurrency = {
    prefix: 'fasl',
    iconName: 'chart-pie-simple-circle-currency',
    icon: [
      640,
      512,
      [],
      'e604',
      
      'M288 32.5V224H394.8c-12.9 9.1-24.5 19.9-34.6 32H288 256V224 .6c5.6-.4 11.3-.6 17.1-.6c116 0 212.7 82.7 234.4 192.4c-3.8-.2-7.6-.4-11.5-.4c-7.1 0-14.2 .4-21.1 1.2C455.2 105.6 379.9 39.1 288 32.5zM256 288h83.2c-5.2 10.1-9.4 20.8-12.6 32H224 192V288 69.6C100.3 91.2 32 173.6 32 272c0 114.9 93.1 208 208 208c37.1 0 71.9-9.7 102-26.7c5.2 9.4 11.3 18.3 18.1 26.5C324.8 500.3 283.8 512 240 512C107.5 512 0 404.6 0 272C0 155.9 82.5 59 192 36.8c10.4-2.1 21.1-3.6 32-4.3V64.6 256v32h32zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm25.4 169.4a35.9 35.9 0 1 0 -50.7-50.7 35.9 35.9 0 1 0 50.7 50.7zm10 32.6c-21.6 13.2-49.1 13.2-70.7 0l-17.3 17.3-22.6-22.6L438 403.3c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3 22.6-22.6L460.7 310c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3 22.6 22.6L554 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3-22.6 22.6L531.3 426z'
      
    ]
  };

  

  
  

  var faLayerMinus = {
    prefix: 'fasl',
    iconName: 'layer-minus',
    icon: [
      576,
      512,
      ["layer-group-minus"],
      'f5fe',
      
      'M408 64H392V96h16H520h16V64H520 408zM288 349L78.8 256 288 163l209.2 93L288 349zM536.6 238.5L288 128 39.4 238.5 0 256l39.4 17.5L288 384 536.6 273.5 576 256l-39.4-17.5zM144 355l-39.4-17.5-65.2 29L0 384l39.4 17.5L288 512 536.6 401.5 576 384l-39.4-17.5-65.2-29L432 355l65.2 29L288 477 78.8 384 144 355z'
      
    ]
  };

  
    var faLayerGroupMinus = faLayerMinus;
  

  
  

  var faLightbulbExclamation = {
    prefix: 'fasl',
    iconName: 'lightbulb-exclamation',
    icon: [
      384,
      512,
      [],
      'f671',
      
      'M336 176c0 30.6-9.5 58.8-25.7 82.1c-4.1 5.9-8.8 12.3-13.6 19c-12.7 17.5-27.1 37.2-38 57.1c-8.9 16.2-13.7 33.3-16.2 49.9H275c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1l0 0c-4.9-6.7-9.5-13-13.6-19C57.5 234.8 48 206.6 48 176C48 96.5 112.5 32 192 32s144 64.5 144 144zM144 448h96v32H144V448zm-32 0v32 32h32 96 32V480 448 416H240 144 112v32zM208 96H176v16V240v16h32V240 112 96zM168 336h48V288H168v48z'
      
    ]
  };

  

  
  

  var faMessageArrowUp = {
    prefix: 'fasl',
    iconName: 'message-arrow-up',
    icon: [
      512,
      512,
      ["comment-alt-arrow-up"],
      'e1dc',
      
      'M160 416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448 416zm0-32h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zm112-80v16H240V304 150.6l-52.7 52.7L176 214.6 153.4 192l11.3-11.3 80-80L256 89.4l11.3 11.3 80 80L358.6 192 336 214.6l-11.3-11.3L272 150.6V304z'
      
    ]
  };

  
    var faCommentAltArrowUp = faMessageArrowUp;
  

  
  

  var faPaperPlaneTop = {
    prefix: 'fasl',
    iconName: 'paper-plane-top',
    icon: [
      512,
      512,
      ["paper-plane-alt","send"],
      'e20a',
      
      'M124 272H408.4L56.4 448H48.5L124 272zm284.5-32H124L48.5 64h7.9l352 176zM0 32L13.7 64 96 256 13.7 448 0 480H34.8 64L476.2 273.9 512 256l-35.8-17.9L64 32H34.8 0z'
      
    ]
  };

  
    var faPaperPlaneAlt = faPaperPlaneTop;
  
    var faSend = faPaperPlaneTop;
  

  
  

  var faPersonSeatReclined = {
    prefix: 'fasl',
    iconName: 'person-seat-reclined',
    icon: [
      512,
      512,
      [],
      'e21f',
      
      'M208 88a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM184 32a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM32.2 146.6l48 288L82.4 448H96 288h16V416H288 109.6L63.8 141.4l-31.6 5.3zM160 176H141.1l3.1 18.6 19.5 117.3c3.9 23.1 23.9 40.1 47.3 40.1h60.6l.3 0 .3 0h68.6L385 469.6l5 13.4 13.8-3.5 64-16-7.8-31L410 445 367 330.4 363.1 320H352 285.6l-10.7-64H336h16V224H336 269.6l-5.8-34.6L261.6 176H248 160zm74.4 32l18.7 112h-42c-7.8 0-14.5-5.7-15.8-13.4L178.9 208h55.6z'
      
    ]
  };

  

  
  

  var faHourglassClock = {
    prefix: 'fasl',
    iconName: 'hourglass-clock',
    icon: [
      576,
      512,
      [],
      'e41b',
      
      'M16 512H0V480H16 32V368v-7.8l6.2-4.8L165.9 256 38.2 156.6 32 151.8V144 32H16 0V0H16 48 336h32 16V32H368 352V144v7.8l-6.2 4.8L218.1 256l52.8 41.1c-4.5 10.3-8.1 21.1-10.6 32.3L192 276.3 64 375.8V480H296.2c10 12.1 21.7 22.9 34.6 32H48 16zM192 235.7l128-99.6V32H64V136.2l128 99.6zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 64v16 48h32 16v32H480 432 416V368 304 288h32z'
      
    ]
  };

  

  
  

  var faBlenderPhone = {
    prefix: 'fasl',
    iconName: 'blender-phone',
    icon: [
      576,
      512,
      [],
      'f6b6',
      
      'M148.7 147.2L192 57.6 98.2 0 83.7 12.8c-111.6 99-111.6 259.4 0 358.4L98.2 384 192 326.4l-43.3-89.6H98.5c-8.9-29.3-8.9-60.3 0-89.6h50.1zM74.8 268.8h53.8l22 45.5-48.9 30C55.2 301.6 32 246.8 32 192s23.2-109.6 69.7-152.3l48.9 30-22 45.5H74.8l-6.9 22.7c-10.7 35.4-10.7 72.8 0 108.2l6.9 22.7zM535 32L519 96H368 352v32h16H511l-16 64H368 352v32h16H487L455 352H256V32H535zM488 352l56-224 24-96 8-32H543 256 224V32 352H192v32 96 32h32H512h32V480 384 352H512 488zM224 384h32H480h32v96H224V384zm168 48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faUserHairBuns = {
    prefix: 'fasl',
    iconName: 'user-hair-buns',
    icon: [
      448,
      512,
      [],
      'e3d3',
      
      'M256 128h-6.6l-4.7-4.7L224 102.6l-20.7 20.7-4.7 4.7H192l-64 0v16c0 53 43 96 96 96s96-43 96-96V128H256zm67.9 96c-23.5 29.3-59.5 48-99.9 48s-76.5-18.7-99.9-48H96 64 32V192 96 64H64 96h17.1C135.3 25.7 176.6 0 224 0s88.7 25.7 110.9 64H352h32 32V96v96 32H384 352 323.9zM352 144v48h32V96H352v32 16zM314.5 96C301.4 58.7 265.8 32 224 32s-77.4 26.7-90.5 64h51.9l27.3-27.3L224 57.4l11.3 11.3L262.6 96h51.9zM87.6 336L43.3 480H404.7L360.4 336H87.6zM384 304l54.2 176 9.8 32H414.5 33.5 0l9.8-32L64 304H384zM96 96H64v96H96V144 128 96z'
      
    ]
  };

  

  
  

  var faHourglassStart = {
    prefix: 'fasl',
    iconName: 'hourglass-start',
    icon: [
      384,
      512,
      ["hourglass-1"],
      'f251',
      
      'M384 512H368 336 48 16 0V480H16 32V368v-7.8l6.2-4.8L165.9 256 38.2 156.6 32 151.8V144 32H16 0V0H16 48 336h32 16V32H368 352V144v7.8l-6.2 4.8L218.1 256l127.8 99.4 6.2 4.8V368 480h16 16v32zm-64-32V375.8L192 276.3 64 375.8V480H320zm0-343.8V128H64v8.2l128 99.6 128-99.6zM320 96V32H64V96H320z'
      
    ]
  };

  
    var faHourglass1 = faHourglassStart;
  

  
  

  var faFamily = {
    prefix: 'fasl',
    iconName: 'family',
    icon: [
      512,
      512,
      [],
      'e300',
      
      'M128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 128 0a64 64 0 1 0 0 128zM62.7 192H168.4c-.2-2.6-.4-5.3-.4-8c0-8.3 1.2-16.4 3.3-24H32L25.3 320 24 352H56h8V496v16H96V496 352h48V320H96 64 57.4l5.3-128zM368 384h48V496v16h32V496 384h30.7H512l-9.1-32L448 160H340.7c2.2 7.6 3.3 15.7 3.3 24c0 3.6-.2 7.2-.7 10.8l.8-2.8h79.7l45.7 160H368v32zM335 224l.8-2.9c-.5 1-.9 2-1.4 2.9h.6zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 384 0a64 64 0 1 0 0 128zM256 160a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm48 48v96H272 240 208V288h96zM208 416v80 16h32V496 416h32v80 16h32V496 416h32V384 288 256H304 208 176v32 96 32h32z'
      
    ]
  };

  

  
  

  var faShopLock = {
    prefix: 'fasl',
    iconName: 'shop-lock',
    icon: [
      640,
      512,
      [],
      'e4a5',
      
      'M449.6 192c-9.4 9.2-17.1 20-22.8 32H96V352H352V272 256h32v16 16h0l0 224H368 80 64V496 224H32 0V192 176L96 0H544l96 176v16 32H629.2c-5.7-12-13.5-22.8-22.8-32H608v-7.8L525 32H115L32 184.2V192H64 96 449.6zM96 480H352V384H96v96zM528 224c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32v32V480v32H608 448 416V480 352 320h32V272zm0 80V480H608V352H448z'
      
    ]
  };

  

  
  

  var faIntersection = {
    prefix: 'fasl',
    iconName: 'intersection',
    icon: [
      384,
      512,
      [8898],
      'f668',
      
      'M32 480V464 224c0-88.4 71.6-160 160-160s160 71.6 160 160V464v16h32V464 224c0-106-86-192-192-192S0 118 0 224V464v16H32z'
      
    ]
  };

  

  
  

  var faVirusCovidSlash = {
    prefix: 'fasl',
    iconName: 'virus-covid-slash',
    icon: [
      640,
      512,
      [],
      'e4a9',
      
      'M503.3 272H544v24 16h32V296 216 200H544v16 24H503.3c-3.3-38.8-18.7-74.1-42.4-102.3l28.8-28.8 0 0 17 17L518 137.2l22.6-22.6-11.3-11.3L472.7 46.7 461.4 35.4 438.8 58l11.3 11.3 17 17 0 0-28.8 28.8C410.1 91.4 374.8 76 336 72.7V32l24 0h16V0H360 280 264V32h16 24V72.7c-29 2.5-56.2 11.7-79.8 26.2l27.2 21.5C272 109.9 295.3 104 320 104c83.9 0 152 68.1 152 152c0 12.1-1.4 23.9-4.1 35.2l27.2 21.5c4.2-13 7-26.6 8.2-40.7zM168 256c0-12.1 1.4-23.9 4.1-35.2l-27.2-21.5c-4.2 13-7 26.6-8.2 40.7H96V216 200H64v16 80 16H96l0-16 0-24h40.7c3.3 38.8 18.7 74.1 42.4 102.3l-28.8 28.8 0 0-17-17L122 374.8 99.4 397.4l11.3 11.3 56.6 56.6 11.3 11.3L201.2 454l-11.3-11.3-17-17 0 0 28.8-28.8c28.2 23.7 63.5 39 102.3 42.4V480H280 264v32h16 80 16V480H360 336V439.3c29-2.5 56.2-11.8 79.8-26.2l-27.2-21.5C368 402.1 344.7 408 320 408c-83.9 0-152-68.1-152-152zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faServer = {
    prefix: 'fasl',
    iconName: 'server',
    icon: [
      512,
      512,
      [],
      'f233',
      
      'M32 64V192H480V64H32zM0 32H32 480h32V64 192v32H480 32 0V192 64 32zM32 320V448H480V320H32zM0 288H32 480h32v32V448v32H480 32 0V448 320 288zm304 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faBadgeSheriff = {
    prefix: 'fasl',
    iconName: 'badge-sheriff',
    icon: [
      448,
      512,
      [],
      'f8a2',
      
      'M249.4 83.5l-13.1 17 10.8 18.6L266 151.6l9.2 15.8 18.3 .1 35.2 .1 18.4 .1 9.3-15.9c2.7-4.6 6.6-8.6 11.6-11.5c15.3-8.8 34.9-3.6 43.7 11.7s3.6 34.9-11.7 43.7c-6.2 3.6-12.9 4.8-19.4 4.1l-20.8-2.3-10.4 18.2-13.9 24.4L326.3 256l9.1 15.9 13.9 24.4 10.4 18.2 20.8-2.3c6.5-.7 13.3 .6 19.4 4.1c15.3 8.8 20.6 28.4 11.7 43.7s-28.4 20.6-43.7 11.7c-5-2.9-8.9-6.9-11.6-11.5l-9.3-15.9-18.4 .1-35.2 .1-18.3 .1L266 360.4l-18.9 32.4-10.8 18.6 13.1 17c4.2 5.4 6.6 12.1 6.6 19.5c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-7.4 2.5-14.1 6.6-19.5l13.1-17-10.8-18.6L182 360.4l-9.2-15.8-18.3-.1-35.2-.1-18.4-.1-9.3 15.9c-2.7 4.6-6.6 8.6-11.6 11.5l16 27.7L80 371.7c-15.3 8.8-34.9 3.6-43.7-11.7s-3.6-34.9 11.7-43.7c6.1-3.5 12.9-4.8 19.4-4.1l20.8 2.3 10.4-18.2 13.9-24.4 9.1-15.9-9.1-15.9L98.6 215.7 88.2 197.6l-20.8 2.3c-6.5 .7-13.3-.6-19.4-4.1c-15.3-8.8-20.5-28.4-11.7-43.7s28.4-20.5 43.7-11.7c5 2.9 8.9 6.9 11.6 11.5l9.3 15.9 18.4-.1 35.2-.1 18.3-.1 9.2-15.8 18.9-32.4 10.8-18.6-13.1-17C194.5 78.1 192 71.4 192 64c0-17.7 14.3-32 32-32s32 14.3 32 32c0 7.4-2.5 14.1-6.6 19.5zM8.6 376c17.7 30.6 56.8 41.1 87.4 23.4c10-5.7 17.8-13.8 23.2-23l35.2 .1L173.3 409C165 419.8 160 433.3 160 448c0 35.3 28.7 64 64 64s64-28.7 64-64c0-14.7-5-28.2-13.3-39l18.9-32.4 35.2-.1c5.4 9.3 13.2 17.3 23.2 23c30.6 17.7 69.8 7.2 87.4-23.4s7.2-69.8-23.4-87.4c-12.2-7.1-25.8-9.6-38.9-8.2L363.2 256l13.9-24.4c13 1.4 26.6-1.1 38.9-8.2c30.6-17.7 41.1-56.8 23.4-87.4s-56.8-41.1-87.4-23.4c-10 5.7-17.8 13.8-23.2 23l-35.2-.1L274.7 103C283 92.2 288 78.7 288 64c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 14.7 5 28.2 13.3 39l-18.9 32.4-35.2 .1c-5.4-9.3-13.2-17.3-23.2-23C65.4 94.9 26.3 105.4 8.6 136S1.4 205.8 32 223.4c12.2 7.1 25.8 9.6 38.9 8.2L84.8 256 70.9 280.4c-13-1.4-26.6 1.2-38.9 8.2C1.4 306.2-9.1 345.4 8.6 376zM235.3 188.7L224 177.4l-11.3 11.3-56 56L145.4 256l11.3 11.3 56 56L224 334.6l11.3-11.3 56-56L302.6 256l-11.3-11.3-56-56zM224 289.4L190.6 256 224 222.6 257.4 256 224 289.4z'
      
    ]
  };

  

  
  

  var faGridRound = {
    prefix: 'fasl',
    iconName: 'grid-round',
    icon: [
      448,
      512,
      [],
      'e5da',
      
      'M96 96A32 32 0 1 1 32 96a32 32 0 1 1 64 0zM64 32a64 64 0 1 0 0 128A64 64 0 1 0 64 32zM96 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM64 192a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 416a64 64 0 1 0 128 0A64 64 0 1 0 0 416zM256 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 32a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm96 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM384 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM320 96a64 64 0 1 0 128 0A64 64 0 1 0 320 96zm96 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z'
      
    ]
  };

  

  
  

  var faSlidersSimple = {
    prefix: 'fasl',
    iconName: 'sliders-simple',
    icon: [
      512,
      512,
      [],
      'e253',
      
      'M32 416l96 0 0-32 0-32 0-32-96 0 0 96zm128-32l0 32 0 32-32 0-96 0L0 448l0-32 0-96 0-32 32 0 96 0 32 0 0 32 0 32 336 0 16 0 0 32-16 0-336 0zM16 160L0 160l0-32 16 0 336 0 0-32 0-32 32 0 96 0 32 0 0 32 0 96 0 32-32 0-96 0-32 0 0-32 0-32L16 160zM384 96l0 96 96 0 0-96-96 0z'
      
    ]
  };

  

  
  

  var faWindTurbine = {
    prefix: 'fasl',
    iconName: 'wind-turbine',
    icon: [
      512,
      512,
      [],
      'f89b',
      
      'M318 378.4L229.4 246.6l-2.6-3.8-4.2-1.9L77.4 176.5l158.5-10.8 4.6-.3 3.7-2.7L372.6 69 302.7 211.7l-2 4.1 .5 4.6 16.9 158zm9.5 71.5l29.2-10.6L333.5 221.7 429.8 25.1 406 5.1l-176.9 129L10.7 149 5.3 179.6l200.2 88.7L240 319.7V328 480H144 128v32h16H256 368h16V480H368 272V367.3L327.5 450zM272 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faShopSlash = {
    prefix: 'fasl',
    iconName: 'shop-slash',
    icon: [
      640,
      512,
      ["store-alt-slash"],
      'e070',
      
      'M608 224h32V192 176L544 0H99l40.5 32H525l83 152.2V192H560 342.2l40.5 32H544V351.3l32 25.3V224h32zM0 176v16 32H32 64V496v16H80 368h16V496 388.1L338.3 352H96V224h80.2l-40.5-32H96 64 32v-7.8l28.2-51.7L34.7 112.3 0 176zM96 480V384H352v96H96zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  
    var faStoreAltSlash = faShopSlash;
  

  
  

  var faSquare6 = {
    prefix: 'fasl',
    iconName: 'square-6',
    icon: [
      448,
      512,
      [],
      'e25b',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM160.7 208.3l79-80.3h44.9l-1.2 1.2L221.6 192c.8 0 1.6 0 2.4 0c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-29.8 11.7-58.5 32.7-79.7zM160 288a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z'
      
    ]
  };

  

  
  

  var faPersonSkiLift = {
    prefix: 'fasl',
    iconName: 'person-ski-lift',
    icon: [
      512,
      512,
      ["ski-lift"],
      'f7c8',
      
      'M272 16V210.8c-1.9 .3-3.7 .6-5.6 1.1L240 218.5V16 0h32V16zM128 88A24 24 0 1 0 80 88a24 24 0 1 0 48 0zM48 88a56 56 0 1 1 112 0A56 56 0 1 1 48 88zm71.2 82.5l7.2 14.3 42.3 84.5 115.5-28.9L304 256V402.8l176-69.7V304 288h32v16 40 10.9l-10.1 4L304 437.2V440h-7.1L117.9 510.9l-11.8-29.8L272 415.5v-139l-95.7 23.9c-14.6 3.6-29.7-3.3-36.4-16.7L97.7 199.2l-7.2-14.3 28.6-14.3zM1.6 182.9l28.8-13.8 90.2 188 75.1-20.5 15.4-4.2 8.4 30.9-15.4 4.2-88 24-12.9 3.5-5.8-12-96-200z'
      
    ]
  };

  
    var faSkiLift = faPersonSkiLift;
  

  
  

  var faNfcLock = {
    prefix: 'fasl',
    iconName: 'nfc-lock',
    icon: [
      576,
      512,
      [],
      'e1f8',
      
      'M416 64H32V448H320l0 32H32 0V448 64 32H32 416h32V64v97.1c-11.3 1.6-22.1 4.9-32 9.6V64zm-32 48v81.6c-19.8 20.2-32 47.9-32 78.4V128H240v82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112 96h16H368h16v16zM96 384H320l0 32H80 64V400 112 96H80h64 16v32H144 96V384zM224 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm240-16c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32v32V480v32H544 384 352V480 352 320h32V272zm160 80H384V480H544V352z'
      
    ]
  };

  

  
  

  var faCannon = {
    prefix: 'fasl',
    iconName: 'cannon',
    icon: [
      640,
      512,
      [],
      'e642',
      
      'M143.6 207.2C208 176 559 59.3 559 59.3l81 161.9s-49.9 34.6-113.5 78c-5.1-9.4-11.3-18.2-18.3-26.2c24.4-16.7 46.9-32 65.2-44.6c9.8-6.7 18.4-12.7 25.6-17.6L542.8 98.4c-8.2 2.8-18.2 6.1-29.4 9.9c-33.9 11.4-79.7 27-127.5 43.5c-96.7 33.4-197.9 69.5-228.2 84.1c-55.2 27.7-77.5 94.9-49.9 150.2s94.8 77.7 150.1 50.2c3.3-1.7 7.3-3.9 11.9-6.6c4.6 9.7 10.3 18.8 16.8 27.2c-5.6 3.3-10.4 5.9-14.3 7.9C219.3 491.3 157.7 482 115 446L85.9 460.6 57.2 474.9 42.9 446.3 14.3 389.1 0 360.4l28.6-14.3 35.6-17.8s0 0 0 0c2.7-50 31.4-97.2 79.4-121.1zM66.5 363L42.9 374.8 71.6 432l20.7-10.3c-4.9-6.6-9.2-13.7-13-21.3c-6.1-12.1-10.3-24.7-12.7-37.4zM480 368a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-192 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm112-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faFilesMedical = {
    prefix: 'fasl',
    iconName: 'files-medical',
    icon: [
      448,
      512,
      [],
      'f7fd',
      
      'M416 384V144H320 304V128 32H128V384H416zM390 112L336 57.5V112h54zM128 0H324L448 125V384v32H416 128 96V384 32 0h32zM32 96v16V480H336h16v32H336 16 0V496 112 96H32zm213.3 64h53.3 16v16 37.3H352h16v16 53.3 16H352 314.7V336v16h-16H245.3h-16V336 298.7H192 176v-16V229.3v-16h16 37.3V176 160h16zm16 69.3v16h-16l-37.3 0v21.3h37.3 16v16V320h21.3V282.7v-16h16H336V245.3H298.7h-16v-16V192H261.3v37.3z'
      
    ]
  };

  

  
  

  var faPegasus = {
    prefix: 'fasl',
    iconName: 'pegasus',
    icon: [
      576,
      512,
      [],
      'f703',
      
      'M448 32c-61.9 0-112 50.1-112 112v16H320h-8-4.4l-3.8-2.3L170 77.4c7.1 51.8 32.2 90.5 57.7 117.6c15.1 16 30.1 27.8 41.4 35.5c5.6 3.9 10.3 6.7 13.5 8.6c1.6 .9 2.8 1.6 3.6 2l.9 .5 .2 .1 0 0 0 0 0 0 0 0 14.3 7.1-14.3 28.6-14.3-7.2L280 256c-7.2 14.3-7.2 14.3-7.2 14.3l0 0 0 0-.1-.1-.4-.2c-.3-.2-.7-.4-1.3-.7c-1.1-.6-2.6-1.4-4.5-2.5c-3.8-2.2-9.2-5.5-15.5-9.9c-12.7-8.7-29.6-22-46.6-40C170.4 180.9 136 125.2 136 48V19.7l24.2 14.5 145.5 87.3C316.5 52.7 376.1 0 448 0h24 8 20.6 6.6H544h16V32H544h-4.8l20.7 20.7 4.1 4.1 .5 5.7 11.4 120 .9 9.8-8.4 5.2-64 40-13.2 8.2-8.6-12.9L455.4 192H448v48c0 30.9-12.4 58.4-32 78.4V496v16H400 320 304V496 347.6l-88-19.8V336v8.2 3.3l-1.3 3-3.2 7.5L195.2 396l26.6 95.7 5.6 20.3H206.4h-83H111.2L108 500.3 82 407l-3.8-13.5L76.8 388l2.2-5.2 5.5-12.9L104 324.5v-1.3L70.4 242.5c-4.2-10.1-6.4-20.8-6.4-31.7c-18.6 6.6-32 24.4-32 45.3v48 16H0V304 256c0-41.3 31.3-75.2 71.4-79.5c9-19.8 25.6-35.4 46-43.1c3.4 10.5 7.4 20.4 11.8 29.8C109.8 170.2 96 188.8 96 210.7c0 6.7 1.3 13.3 3.9 19.5l34.9 83.7 1.2 3V320v7.8 3.3l-1.3 3-20.8 48.5-3.3 7.8 2.3 8.1L135.5 480h49.8l-22.5-80.9-1.5-5.4 2.2-5.2 18.5-43.1 1.9-4.5V336 312v-4.2-20l19.5 4.4L318.4 318c1.4 .3 2.8 .6 4.3 .8l13.3 2.3v13.5V480h48V311.6v-7.2l5.3-4.8C405.6 285.1 416 264 416 240V176 160h16 32 8.6l4.7 7.1 23.4 35.1 42.4-26.5L533.2 71.2 493.9 32H480h-8H448zm32 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faArrowRightToBracket = {
    prefix: 'fasl',
    iconName: 'arrow-right-to-bracket',
    icon: [
      512,
      512,
      ["sign-in"],
      'f090',
      
      'M347.3 267.3L358.6 256l-11.3-11.3-128-128L208 105.4 185.4 128l11.3 11.3L297.4 240 16 240 0 240l0 32 16 0 281.4 0L196.7 372.7 185.4 384 208 406.6l11.3-11.3 128-128zM336 448l-16 0 0 32 16 0 160 0 16 0 0-16 0-416 0-16-16 0L336 32l-16 0 0 32 16 0 144 0 0 384-144 0z'
      
    ]
  };

  
    var faSignIn = faArrowRightToBracket;
  

  
  

  var faComputerMouse = {
    prefix: 'fasl',
    iconName: 'computer-mouse',
    icon: [
      384,
      512,
      [128433,"mouse"],
      'f8cc',
      
      'M192 224H32V352c0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128V224H192zm192-32v16 16V352c0 88.4-71.6 160-160 160H160C71.6 512 0 440.4 0 352V224 208 192 32 0H32 176h16 16H352h32V32 192zM352 32H208V192H352V32zM176 32H32V192H176V32z'
      
    ]
  };

  
    var faMouse = faComputerMouse;
  

  
  

  var faCalendarStar = {
    prefix: 'fasl',
    iconName: 'calendar-star',
    icon: [
      448,
      512,
      [],
      'f736',
      
      'M128 16V0H96V16 64H32 0V96v64 32V480v32H32 416h32V480 192 160 96 64H416 352V16 0H320V16 64H128V16zM32 192H416V480H32V192zm0-96H416v64H32V96zM238.4 240.9L224 211.7l-14.4 29.2-23.5 47.7-52.5 7.7-32 4.7 23.1 22.6 38 37.2-9 52.5-5.5 32 28.7-15.1L224 405.4l46.9 24.8 28.7 15.1-5.5-32-9-52.5 38-37.2L346.3 301l-32-4.7-52.5-7.7-23.5-47.7zm-27.2 69.4L224 284.3l12.8 26.1 3.7 7.6 8.3 1.2 28.8 4.2-20.9 20.4-6 5.9 1.4 8.3 4.9 28.8-25.7-13.6-7.5-3.9-7.5 3.9-25.7 13.6 4.9-28.8 1.4-8.3-6-5.9-20.9-20.4 28.8-4.2 8.3-1.2 3.7-7.6z'
      
    ]
  };

  

  
  

  var faPersonToPortal = {
    prefix: 'fasl',
    iconName: 'person-to-portal',
    icon: [
      512,
      512,
      ["portal-enter"],
      'e022',
      
      'M256 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 224 56a56 56 0 1 0 112 0zM128 112h-6.6l-4.7 4.7-64 64L41.4 192 64 214.6l11.3-11.3L134.6 144h39.1l15.9 4.5L153.2 257.9c-7.3 21.8 2 45.7 22 57l93.3 52.5L217.4 512h33.9l51.8-146.7 4.5-12.7-11.7-6.6-49.2-27.7c.2-.4 .4-.9 .5-1.3l37.2-111.6 20.3 70.9 3.3 11.6H320h80 16V256H400 332.1L303.4 155.6l-2.4-8.5-8.5-2.4-112-32-2.2-.6H176 128zm55.5 156l36.9-110.7 42.2 12.1-44.3 133L190.9 287c-6.7-3.8-9.8-11.7-7.3-19zM101.3 384H16 0v32H16h96 10.7l4.1-9.9 27.4-66.6c-10-6.7-18.2-15.5-24.1-25.4L101.3 384zm357.2 60.2C445.6 480 433.6 480 432 480h0 0c-1.6 0-13.6 0-26.4-35.8c-9.4-26.3-16.8-66.4-19.9-124.2h-32c7.3 140.7 39.7 192 78.4 192c44.2 0 80-66.6 80-256S476.2 0 432 0c-41.6 0-75.8 59-79.6 224h32c1.8-75.3 10.1-125.3 21.2-156.2C418.4 32 430.4 32 432 32l0 0 0 0c1.6 0 13.6 0 26.4 35.8C471.1 102.9 480 162.5 480 256s-8.9 153.1-21.5 188.2z'
      
    ]
  };

  
    var faPortalEnter = faPersonToPortal;
  

  
  

  var faSlash = {
    prefix: 'fasl',
    iconName: 'slash',
    icon: [
      640,
      512,
      [],
      'f715',
      
      'M27.8 8.1L40.4 18 619.5 469l12.6 9.8-19.7 25.2-12.6-9.8L20.7 43.2 8.1 33.4 27.8 8.1z'
      
    ]
  };

  

  
  

  var faLasso = {
    prefix: 'fasl',
    iconName: 'lasso',
    icon: [
      576,
      512,
      [],
      'f8c8',
      
      'M576 176c0 97.2-128.9 176-288 176c-22.9 0-45.3-1.6-66.7-4.7c11.9 17.2 18.7 38 18.7 59.7c0 58-47 105-105 105H48 32V480H48h87c40.3 0 73-32.7 73-73c0-27.6-15.6-52.9-40.4-65.3l-34.9-17.4C52.9 293 0 238.3 0 176C0 78.8 128.9 0 288 0S576 78.8 576 176zM288 320c141.4 0 256-64.5 256-144S429.4 32 288 32S32 96.5 32 176s114.6 144 256 144z'
      
    ]
  };

  

  
  

  var faCircleQuarterStroke = {
    prefix: 'fasl',
    iconName: 'circle-quarter-stroke',
    icon: [
      512,
      512,
      [],
      'e5d3',
      
      'M480 256C480 132.3 379.7 32 256 32V240c0 8.8-7.2 16-16 16H32c0 123.7 100.3 224 224 224s224-100.3 224-224zM224 34.3C125.9 48.3 48.3 125.9 34.3 224H224V34.3zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faLocationXmark = {
    prefix: 'fasl',
    iconName: 'location-xmark',
    icon: [
      384,
      512,
      ["map-marker-times","map-marker-xmark"],
      'f60e',
      
      'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 20.2 9.1 48.6 26.5 82.7c16.9 33.2 39.9 68.2 63.4 100.5c23.4 32.2 46.9 61 64.5 81.9c1.9 2.3 3.8 4.5 5.6 6.6c1.8-2.1 3.6-4.3 5.6-6.6c17.7-20.8 41.1-49.7 64.5-81.9c23.5-32.3 46.4-67.3 63.4-100.5C342.9 240.6 352 212.2 352 192zm32 0c0 88.8-120.7 237.9-170.7 295.9C200.2 503.1 192 512 192 512s-8.2-8.9-21.3-24.1C120.7 429.9 0 280.8 0 192C0 86 86 0 192 0S384 86 384 192zM127.4 104.8l11.3 11.3L192 169.4l53.3-53.3 11.3-11.3 22.6 22.6-11.3 11.3L214.6 192l53.3 53.3 11.3 11.3-22.6 22.6-11.3-11.3L192 214.6l-53.3 53.3-11.3 11.3-22.6-22.6 11.3-11.3L169.4 192l-53.3-53.3-11.3-11.3 22.6-22.6z'
      
    ]
  };

  
    var faMapMarkerTimes = faLocationXmark;
  
    var faMapMarkerXmark = faLocationXmark;
  

  
  

  var faSpellCheck = {
    prefix: 'fasl',
    iconName: 'spell-check',
    icon: [
      576,
      512,
      [],
      'f891',
      
      'M101.1 0h21.9l4 10.2L222.4 256H188.1l-24.9-64H60.8L35.9 256H1.6L97.1 10.2l4-10.2zm49.7 160L112 60.2 73.2 160h77.6zM272 0h72c39.8 0 72 32.2 72 72c0 16.7-5.7 32.1-15.3 44.4C428.3 126.4 448 152.9 448 184c0 39.8-32.2 72-72 72H272 256V240 128 16 0h16zM384 72c0-22.1-17.9-40-40-40H288v80h56c22.1 0 40-17.9 40-40zM288 224h88c22.1 0 40-17.9 40-40s-17.9-40-40-40H344 288v80zm283.3 67.3l-208 208L352 510.6l-11.3-11.3-112-112 22.6-22.6L352 465.4 548.7 268.7l22.6 22.6z'
      
    ]
  };

  

  
  

  var faCoffinCross = {
    prefix: 'fasl',
    iconName: 'coffin-cross',
    icon: [
      384,
      512,
      [],
      'e051',
      
      'M35.2 150.9L127.7 32H256.3l92.5 118.9L255.8 480H128.2l-93-329.1zM104 512H280L384 144 272 0H112L0 144 104 512zM208 112V96H176v16 64H112 96v32h16 64V336v16h32V336 208h64 16V176H272 208V112z'
      
    ]
  };

  

  
  

  var faGoalNet = {
    prefix: 'fasl',
    iconName: 'goal-net',
    icon: [
      640,
      512,
      [],
      'e3ab',
      
      'M16 32H0V48 464v16H32V464 64H608V464v16h32V464 48 32H624 16zm176 80H160v80H80v32h80v64H80v32h80v64H80v32h80v64h32V416h64v64h32V416h64v64h32V416h64v64h32V416h80V384H480V320h80V288H480V224h80V192H480V112H448v80H384V112H352v80H288V112H256v80H192V112zm0 112h64v64H192V224zm96 0h64v64H288V224zm96 0h64v64H384V224zM192 384V320h64v64H192zm96 0V320h64v64H288zm96 0V320h64v64H384z'
      
    ]
  };

  

  
  

  var faXRay = {
    prefix: 'fasl',
    iconName: 'x-ray',
    icon: [
      512,
      512,
      [],
      'f497',
      
      'M0 32H16 48 464h32 16V64H496 480V448h16 16v32H496 464 48 16 0V448H16 32V64H16 0V32zM64 64V448H448V64H64zM272 96v16 32h64 16v32H336 272v32h96 16v32H368 272v53.5l52.9-20.4 2.8-1.1h3H384h16v16 57.6 5.5l-3.4 4.3-42.7 54.4-4.8 6.1h-7.8H170.7h-7.8l-4.8-6.1-42.7-54.4-3.4-4.3v-5.5V288 272h16 53.3 3l2.8 1.1L240 293.5V240H144 128V208h16 96V176H176 160V144h16 64V112 96h32zM144 340.1L178.5 384H333.5L368 340.1V304H333.6l-71.9 27.7-5.8 2.2-5.8-2.2L178.4 304H144v36.1zM192 352a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faArrowDownFromBracket = {
    prefix: 'fasl',
    iconName: 'arrow-down-from-bracket',
    icon: [
      448,
      512,
      [],
      'e667',
      
      'M235.3 499.3L224 510.6l-11.3-11.3-128-128L73.4 360 96 337.4l11.3 11.3L208 449.4 208 176l0-16 32 0 0 16 0 273.4L340.7 348.7 352 337.4 374.6 360l-11.3 11.3-128 128zM32 176l0 16L0 192l0-16L0 16 0 0 16 0 432 0l16 0 0 16 0 160 0 16-32 0 0-16 0-144L32 32l0 144z'
      
    ]
  };

  

  
  

  var faDiagramVenn = {
    prefix: 'fasl',
    iconName: 'diagram-venn',
    icon: [
      640,
      512,
      [],
      'e15a',
      
      'M224 448C118 448 32 362 32 256S118 64 224 64c21.5 0 42.1 3.5 61.4 10C228.8 114.7 192 181 192 256s36.8 141.3 93.4 182c-19.3 6.5-39.9 10-61.4 10zM415.3 240H224.7c1.4-16.7 4.9-32.8 10.3-48H405.1c5.4 15.2 8.9 31.3 10.3 48zM224.7 272H415.3c-1.4 16.7-4.9 32.8-10.3 48H234.9c-5.4-15.2-8.9-31.3-10.3-48zm25 80H390.3c-16.9 29.1-41.2 53.5-70.3 70.3c-29.1-16.9-53.5-41.2-70.3-70.3zm0-192c16.9-29.1 41.2-53.5 70.3-70.3c29.1 16.9 53.5 41.2 70.3 70.3H249.7zM224 480c34.4 0 66.9-7.7 96-21.6c29.1 13.8 61.6 21.6 96 21.6c123.7 0 224-100.3 224-224S539.7 32 416 32c-34.4 0-66.9 7.7-96 21.6C290.9 39.7 258.4 32 224 32C100.3 32 0 132.3 0 256S100.3 480 224 480zM416 64c106 0 192 86 192 192s-86 192-192 192c-21.5 0-42.1-3.5-61.4-10C411.2 397.3 448 331 448 256s-36.8-141.3-93.4-182c19.3-6.5 39.9-10 61.4-10z'
      
    ]
  };

  

  
  

  var faFileLock = {
    prefix: 'fasl',
    iconName: 'file-lock',
    icon: [
      576,
      512,
      [],
      'e3a6',
      
      'M208 192H320h32 32V152L232 0H32 0V32 480v32H32 320l0-32H32V32H192V176v16h16zM224 37.3L346.7 160H224V37.3zM464 224c26.5 0 48 21.5 48 48v48H416V272c0-26.5 21.5-48 48-48zm-80 48v48H352v32V480v32h32H544h32V480 352 320H544V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H544V480H384V352z'
      
    ]
  };

  

  
  

  var faEar = {
    prefix: 'fasl',
    iconName: 'ear',
    icon: [
      384,
      512,
      [128066],
      'f5f0',
      
      'M271.7 330.8l-17.3 9.9 1.3 19.9c.2 2.5 .2 4.9 .2 7.4c0 61.9-50.1 112-112 112S32 429.9 32 368V192c0-88.4 71.6-160 160-160s160 71.6 160 160c0 59.3-32.2 111.1-80.3 138.8zM288 368c0-3.2-.1-6.4-.3-9.5C345.3 325.3 384 263.2 384 192C384 86 298 0 192 0S0 86 0 192V368c0 79.5 64.5 144 144 144s144-64.5 144-144zM112 192c0-44.2 35.8-80 80-80s80 35.8 80 80v16 16h32V208 192c0-61.9-50.1-112-112-112S80 130.1 80 192v32 8.6l7.1 4.8L128 264.6v23.9L85.8 323.7 73.5 334 94 358.5l12.3-10.2 48-40 5.8-4.8V296 256v-8.6l-7.1-4.8L112 215.4V192z'
      
    ]
  };

  

  
  

  var faPlaneCircleExclamation = {
    prefix: 'fasl',
    iconName: 'plane-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e556',
      
      'M256 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4C184.4 62.7 176 89 176 109.7v44.5L8.1 250.1 0 254.7V264v96 21.9l20.9-6.7L176 325.4l0 50.6-57.6 43.2L112 424v8 64 16h16 16 2.2l2.2-.6L256 480.6l107.6 30.7 2.2 .6H368h16 10.8c-14.2-10-26.9-22-37.5-35.7l-96.8-27.7-4.4-1.3-4.4 1.3L144 479.4V440l57.6-43.2L208 392v-8l0-80.6V281.5l-20.9 6.7L32 338.1V273.3l167.9-96 8.1-4.6v-9.3V109.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3C298.1 75.5 304 96.1 304 109.7v61.7 9.3l8.1 4.6 76.2 43.5c9.6-7.4 19.9-13.9 30.9-19.2L336 162.1V109.7c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 448V416H480v32h32zm0-160H480v16 80 16h32V384 304 288z'
      
    ]
  };

  

  
  

  var faWindow = {
    prefix: 'fasl',
    iconName: 'window',
    icon: [
      512,
      512,
      [],
      'f40e',
      
      'M32 64V448H480V64H32zM0 32H32 480h32V64 448v32H480 32 0V448 64 32zm120 72v48H72V104h48zm48 0h48v48H168V104zm144 0v48H264V104h48z'
      
    ]
  };

  

  
  

  var faFaceAstonished = {
    prefix: 'fasl',
    iconName: 'face-astonished',
    icon: [
      512,
      512,
      [],
      'e36b',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V352zm-96 0c0-35.3 28.7-64 64-64s64 28.7 64 64v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V352zM152.4 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9L89.4 143.2l11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1h16v32H192zm141 .9c-4.3-.6-8.6-.9-13-.9H304V96h16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8z'
      
    ]
  };

  

  
  

  var faPipeSmoking = {
    prefix: 'fasl',
    iconName: 'pipe-smoking',
    icon: [
      640,
      512,
      [],
      'e3c4',
      
      'M514.7 0h8H624h16V32H624 530.7L395.2 212.2l21.7 14.4 13.2 8.8-8.7 13.3L296 439.8C266.5 484.9 216.2 512 162.3 512H160C71.6 512 0 440.4 0 352V240 224H16 240h16v16 32l67.2-89.6 9.1-12.1 12.6 8.4 23.7 15.8L509.9 6.4 514.7 0zM252.8 329.6L224 320V256H32v96c0 70.7 57.3 128 128 128h2.3c43.1 0 83.4-21.7 107-57.8L385.9 244.5l-46.2-30.8L252.8 329.6z'
      
    ]
  };

  

  
  

  var faFileInvoiceDollar = {
    prefix: 'fasl',
    iconName: 'file-invoice-dollar',
    icon: [
      384,
      512,
      [],
      'f571',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM64 64V96H80h64 16V64H144 80 64zm0 64v32H80h64 16V128H144 80 64zM208 234.7H176v16 6.5c-6.3 .9-12.2 2.5-17.7 4.7c-13.6 5.5-26.2 15.9-29.4 32.1c-1.8 9.1-.8 17.9 3.4 25.7c4 7.5 10.2 12.7 16.3 16.4c11 6.6 25.6 10.5 37.4 13.7l2 .5c13.8 3.7 24.1 6.7 30.7 11c3 1.9 4.1 3.5 4.6 4.5c.4 .8 1 2.4 .3 6c-.6 3.1-2.8 6.5-9.8 9.2c-7.3 2.8-18.3 3.9-31.9 2c-6.5-1-17.9-4.4-27.4-7.3l0 0 0 0 0 0 0 0c-2.1-.6-4.2-1.3-6.1-1.8l-15.3-4.5-9.1 30.7 15.3 4.5c1.3 .4 2.9 .9 4.7 1.4l0 0 0 0 0 0 0 0c8.8 2.7 22.6 6.9 31.9 8.4v6.8 16h32v-16-6.2c6.1-.8 11.9-2.2 17.3-4.2c14.2-5.4 26.5-16.1 29.8-33c1.8-9.3 1-18.1-2.9-26.1c-3.8-7.8-9.8-13.3-16-17.3c-11.5-7.4-27-11.6-39.2-14.9l-.5-.1c-13.9-3.7-24.4-6.6-31.2-10.7c-3.1-1.9-4.2-3.3-4.6-4.1c-.2-.4-.8-1.6-.2-4.5c.3-1.8 2.2-5.5 9.9-8.6c7.5-3 18.7-4.5 31.8-2.7c4.4 .6 18.2 3 22.3 4l15.6 3.7 7.4-31.1-15.6-3.7c-5-1.2-17.7-3.4-23.7-4.3v-6.8-16z'
      
    ]
  };

  

  
  

  var faScalpelLineDashed = {
    prefix: 'fasl',
    iconName: 'scalpel-line-dashed',
    icon: [
      576,
      512,
      ["scalpel-path"],
      'f61e',
      
      'M337 256H231.3L420.2 43.5C426.7 36.2 436 32 445.8 32C464.7 32 480 47.3 480 66.2v4.2c0 9-3.2 17.7-8.9 24.6L337 256zm15 32L495.7 115.6C506.2 102.9 512 87 512 70.5V66.2C512 29.7 482.3 0 445.8 0c-18.9 0-36.9 8.1-49.5 22.2L188.4 256 160 288h42.8H352zM178.3 320L33 476.4 0 512s19.5-1 48.8-5.6c83.2-13 245.6-55.1 268.5-186.4H284.6c-13.9 63.8-69.7 103.2-135.9 128c-21.5 8.1-43.1 14.2-63.1 18.7L222 320H178.3zM240 480H224v32h16 64 16V480H304 240zm128 0H352v32h16 64 16V480H432 368zm128 0H480v32h16 64 16V480H560 496z'
      
    ]
  };

  
    var faScalpelPath = faScalpelLineDashed;
  

  
  

  var faHandsBound = {
    prefix: 'fasl',
    iconName: 'hands-bound',
    icon: [
      640,
      512,
      [],
      'e4f9',
      
      'M16 0H32 96h16V16 154.3l59.6 72.9 13.8-8.3-38.7-58-8.9-13.3 13.3-8.9 48-32 12.4-8.3 9.1 11.9 80 104 3.3 4.3V224 352h32V224v-5.4l3.3-4.3 80-104 9.1-11.9 12.4 8.3 48 32 13.3 8.9-8.9 13.3-38.7 58 13.8 8.3L528 154.3V16 0h16 64 16V16 192v5.6l-3.5 4.4-120 150H528h16v32H528 112 96V352h16 27.5L19.5 202 16 197.6V192 16 0zM176 352h96V229.4l-67.6-87.8-22.2 14.8 39.1 58.7 9.3 14-14.4 8.6-40 24-11.9 7.1-8.8-10.7-72-88L80 165.7V160 32H48V186.4L172.5 342l3.5 4.4V352zm288 0v-5.6l3.5-4.4L592 186.4V32H560V160v5.7l-3.6 4.4-72 88-8.8 10.7-11.9-7.1-40-24-14.4-8.6 9.3-14 39.1-58.7-22.2-14.8L368 229.4V352h96zM144 496V448H112 96V416h16H528h16v32H528 496v48 16H464V496 448H368v48 16H336V496 448H304v48 16H272V496 448H176v48 16H144V496z'
      
    ]
  };

  

  
  

  var faClockThree = {
    prefix: 'fasl',
    iconName: 'clock-three',
    icon: [
      512,
      512,
      [],
      'e356',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112V256v16h16H368h16V240H368 272V112 96H240v16z'
      
    ]
  };

  

  
  

  var faSpider = {
    prefix: 'fasl',
    iconName: 'spider',
    icon: [
      512,
      512,
      [128375],
      'f717',
      
      'M0 146.6V132.5l26.1-8.7 5.1 15.2 21.3 63.8 110 28.9L76.3 138.9 68.9 131l4.6-9.8 56-120 29 13.5L107.1 125 176 199.3V152c0-32.2 19-59.9 46.3-72.6L236 73.1l7.2 13.3L256 110.3l12.9-23.9L276 73.1l13.7 6.4C317 92.1 336 119.8 336 152v47.3L404.9 125 353.5 14.8l29-13.5 56 120 4.6 9.8-7.3 7.9-86.2 92.8 110-28.9 21.3-63.8 5.1-15.2 26.1 8.7v14.1l-.8 2.5-24 72-2.7 8.2-8.4 2.2L382.9 256l93.2 24.5 8.4 2.2 2.7 8.2 24 72 .8 2.5v14.1l-26.1 8.7-5.1-15.2-21.3-63.8L367.2 285 437 382.7l4.9 6.8-2.8 7.9-40 112-30.1-10.8 37.2-104.1L367.9 341c-2.6 59.5-51.7 107-111.9 107s-109.3-47.5-111.9-107l-38.2 53.5 37.2 104.1-30.1 10.8-40-112-2.8-7.9 4.9-6.8L144.8 285 52.4 309.3 31.2 373.1l-5.1 15.2L0 379.5V365.4l.8-2.5 24-72 2.7-8.2 8.4-2.2L129.1 256 35.9 231.5l-8.4-2.2-2.7-8.2-24-72L0 146.6zm270.1 5L256 177.7l-14.1-26.2-18.7-34.7c-9.4 8.8-15.2 21.3-15.2 35.1V256v0l0 .4 0 7.2-5.4 4.8C186.3 283 176 304.3 176 328v8c0 44.2 35.8 80 80 80s80-35.8 80-80v-8c0-23.7-10.3-45-26.7-59.6l-5.4-4.8 0-7.2 0-.4v0V152c0-13.8-5.9-26.3-15.2-35.1l-18.7 34.7z'
      
    ]
  };

  

  
  

  var faBracketCurlyRight = {
    prefix: 'fasl',
    iconName: 'bracket-curly-right',
    icon: [
      256,
      512,
      [],
      '7d',
      
      'M176 32h16V48 185.4l59.3 59.3 4.7 4.7v13.3l-4.7 4.7L192 326.6V464v16H176 48 32V448H48 160V320v-6.6l4.7-4.7L217.4 256l-52.7-52.7-4.7-4.7V192 64H48 32V32H48 176z'
      
    ]
  };

  

  
  

  var faFileDashedLine = {
    prefix: 'fasl',
    iconName: 'file-dashed-line',
    icon: [
      640,
      512,
      ["page-break"],
      'f877',
      
      'M480 192v64h32V152L360 0H160 128V32 256h32V32H320V176v16h16H480zM160 480V352H128V480v32h32H480h32V480 352H480V480H160zM474.7 160H352V37.3L474.7 160zM48 288H32v32H48 176h16V288H176 48zm224 0H256v32h16 96 16V288H368 272zm192 0H448v32h16H592h16V288H592 464z'
      
    ]
  };

  
    var faPageBreak = faFileDashedLine;
  

  
  

  var faArrowUpFromSquare = {
    prefix: 'fasl',
    iconName: 'arrow-up-from-square',
    icon: [
      512,
      512,
      [],
      'e09c',
      
      'M267.3 12.7L256 1.4 244.7 12.7l-104 104L129.4 128 152 150.6l11.3-11.3L240 62.6V320v16h32V320 62.6l76.7 76.7L360 150.6 382.6 128l-11.3-11.3-104-104zM16 32H0V48 496v16H16 496h16V496 48 32H496 416 400V64h16 64V480H32V64H96h16V32H96 16z'
      
    ]
  };

  

  
  

  var faBinBottlesRecycle = {
    prefix: 'fasl',
    iconName: 'bin-bottles-recycle',
    icon: [
      640,
      512,
      [],
      'e5f6',
      
      'M384 0h16 96 16V32H496 400 384V0zM352 192H320h-.4v-.1V163.6L248.4 128H135.6L64 163.8V192H32V144l96-48H256l63.6 31.8 32 16 .4 .2v45.5l0 0V192zm223.6 0h-.5-32c0-1.9 .2-3.8 .5-5.6V114.5L504.2 96H391l-32.8 15.3L321.8 93.1 383.9 64H511.3l64.3 30.1V160v31.9 .1zM608 256h-1.9L576 512H64L33.9 256H32 0V224H32h1.9H48 62.3 577.7 592h14.1H608h32v32H608zm-34.1 0H66.1L92.5 480H547.5l26.4-224zM295.4 288H304h32 8.6l4.7 7.2 26.3 40-27.1 17L327.4 320H312.6l-20.3 30.5-27.1-17 25.6-38.4 4.8-7.1zm70.7 90.9l27.1-17 19.3 29.3 2.6 4V400v32 16h-16H337.7V416h45.5V404.8l-17.1-25.9zM305.7 416v32H240 224V432 400v-4.8l2.7-4 20.6-31 27.1 17L256 404.8V416h49.7zM144 0h96 16V16 32h16V64H256 240 224V48 32H160V48 64H144 128 112V32h16V16 0h16z'
      
    ]
  };

  

  
  

  var faGripLinesVertical = {
    prefix: 'fasl',
    iconName: 'grip-lines-vertical',
    icon: [
      192,
      512,
      [],
      'f7a5',
      
      'M48 32L16 32l0 448H48L48 32zm128 0l-32 0 0 448h32l0-448z'
      
    ]
  };

  

  
  

  var faMobileRetro = {
    prefix: 'fasl',
    iconName: 'mobile-retro',
    icon: [
      320,
      512,
      [],
      'e527',
      
      'M288 32V480H32V32H288zM32 0H0V32 480v32H32 288h32V480 32 0H288 32zM224 160v64H96V160H224zM96 128H64v32 64 32H96 224h32V224 160 128H224 96zm8 176H56v48h48V304zM56 384v48h48V384H56zm128-80H136v48h48V304zm-48 80v48h48V384H136zm128-80H216v48h48V304zm-48 80v48h48V384H216zM128 64H112V96h16 64 16V64H192 128z'
      
    ]
  };

  

  
  

  var faPersonRunning = {
    prefix: 'fasl',
    iconName: 'person-running',
    icon: [
      448,
      512,
      [127939,"running"],
      'f70c',
      
      'M280 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 280 0zM121.4 112H128h48 2.2l2.2 .6 112 32 8.5 2.4 2.4 8.5L332.1 256H400h16v32H400 320 307.9l-3.3-11.6-20.3-70.9L247.2 317.1c-.2 .5-.3 .9-.5 1.3l49.2 27.7 11.7 6.6-4.5 12.7L251.3 512H217.4l51.1-144.6-93.3-52.5c-20-11.3-29.3-35.2-22-57l36.4-109.3L173.8 144H134.6L75.3 203.3 64 214.6 41.4 192l11.3-11.3 64-64 4.7-4.7zm99 45.3L183.5 268c-2.4 7.3 .7 15.2 7.3 19l27.5 15.4 44.3-133-42.2-12.1zM130 314.1c5.9 10 14.1 18.7 24.1 25.4l-27.4 66.6-4.1 9.9H112 16 0V384H16h85.3L130 314.1z'
      
    ]
  };

  
    var faRunning = faPersonRunning;
  

  
  

  var faShuffle = {
    prefix: 'fasl',
    iconName: 'shuffle',
    icon: [
      512,
      512,
      [128256,"random"],
      'f074',
      
      'M427.3 44.7L416 33.4 393.4 56l11.3 11.3L449.4 112H400 320h-8l-4.8 6.4L244 202.7l20 26.7L328 144h72 49.4l-44.7 44.7L393.4 200 416 222.6l11.3-11.3L494.6 144H496v-1.4l3.3-3.3L510.6 128l-11.3-11.3-3.3-3.3V112h-1.4L427.3 44.7zM120 368H16 0v32H16 128h8l4.8-6.4L204 309.3l-20-26.7L120 368zM416 478.6l11.3-11.3L494.6 400H496v-1.4l3.3-3.3L510.6 384l-11.3-11.3-3.3-3.3V368h-1.4l-67.3-67.3L416 289.4 393.4 312l11.3 11.3L449.4 368H400 328L140.8 118.4 136 112h-8H16 0v32H16 120L307.2 393.6 312 400h8 80 49.4l-44.7 44.7L393.4 456 416 478.6z'
      
    ]
  };

  
    var faRandom = faShuffle;
  

  
  

  var faPeanuts = {
    prefix: 'fasl',
    iconName: 'peanuts',
    icon: [
      640,
      512,
      [129372],
      'e431',
      
      'M306.9 139.9c-.9-12.6-4-25.3-9.4-37.5L264.9 29.2 251.9 0 222.6 13 149.4 45.6c-13.9 6.2-25.9 14.8-35.7 25.2c-9.8 10.3-17.8 22.7-23.3 36.9l-.2 .4c-5.4 14.1-7.7 28.6-7.3 42.9c.2 7.8 1.2 15.7 3.1 23.5c4.2 18.4 6.4 37.9-.4 55.5s-21.4 30.6-36.8 41.5c-6.6 4.5-12.7 9.7-18 15.3c-9.9 10.4-17.9 22.8-23.4 37C2 338-.3 352.6 0 366.9c.4 14.3 3.5 28.8 9.7 42.7l32.6 73.2 13 29.2 29.2-13L96 493.9v-35L71.5 469.8 39 396.6c-4.4-10-6.7-20.3-6.9-30.5l0 0c-.3-10.2 1.4-20.6 5.3-30.8c3.9-10.2 9.7-19.1 16.7-26.5l0 0c3.8-4 8.1-7.7 12.9-10.9l.2-.1 .2-.1c16.6-11.7 38-29.3 48.3-56.2s6.2-54.2 1.7-74l-.1-.2-.1-.2c-1.4-5.6-2.1-11.2-2.2-16.7l0 0c-.3-10.1 1.4-20.5 5.2-30.6l0 0 .1-.3c3.9-10.1 9.6-19 16.6-26.3l0 0c7-7.4 15.6-13.6 25.5-18l73.2-32.6 32.6 73.2c8.9 20.1 9 41.8 1.7 60.9l0 0-.2 .6 0 0c-.4 1.1-.9 2.2-1.4 3.3c10.5-3.8 18.9-8.6 25.2-14.8c5.5-5.5 9.7-13.5 13.4-25.6zM596.2 253.1c27-26.8 43.8-64 43.8-105.1V32 0H608 492c-20.1 0-39.2 4-56.7 11.2c-17.4 7.2-33.7 17.8-47.8 32c-14.3 14.2-25 30.7-32.3 48.2c-4.6 11.2-7.6 22.9-10.4 34.6c-5.6 22.4-11.1 44.6-28.6 62.1c-17.6 17.6-42.2 25.4-66.7 30.3c-29.5 5.4-56.1 19-78.1 41c-14.2 14.2-24.9 30.5-32.1 48C132 324.8 128 343.9 128 364V480v32h32H276c40.5 0 77.1-16.2 103.8-42.5c22.4-22 36.4-49 41.8-78.9c4.8-24.5 12.6-49.1 30.3-66.7c17.6-17.6 39.7-23.1 62.1-28.6c11.7-2.9 23.4-5.8 34.6-10.4c17.3-7.2 33.5-17.7 47.6-31.7zM160 480V364c0-15.8 3.1-30.8 8.8-44.4l0 0c5.6-13.6 14-26.4 25.2-37.6c17.3-17.3 38-27.9 61.2-32.1l.2 0 .2 0c25.9-5.1 58.5-14.4 83.1-39c19.1-19.1 27.4-41.3 32.6-60c2.2-7.7 3.8-14.1 5.2-19.9l0 0 0 0c2.5-10.1 4.5-18.2 8.2-27.2l0 0c5.7-13.7 14.1-26.6 25.3-37.8c11.1-11.1 23.9-19.4 37.5-25.1l0 0C461.2 35.1 476.2 32 492 32H608V148c0 32.2-13.1 61.3-34.3 82.3l0 0c-11.1 11-23.8 19.3-37.3 24.9l0 0c-9 3.7-17.1 5.7-27.2 8.2c-5.8 1.4-12.2 3-19.9 5.2c-18.7 5.3-40.9 13.6-60 32.6c-24.6 24.6-33.9 57.2-39 83.1l0 .2 0 .2c-4.3 23.4-15.1 44.4-32.7 61.8l20.9 21.3-20.9-21.3c-21 20.7-49.7 33.3-81.4 33.3H160zM544 147.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-64 64a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-224 224a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM339.2 416a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zM544 211.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM339.2 352a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0z'
      
    ]
  };

  

  
  

  var faTransporter1 = {
    prefix: 'fasl',
    iconName: 'transporter-1',
    icon: [
      512,
      512,
      [],
      'e043',
      
      'M256 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80A56 56 0 1 0 256 0a56 56 0 1 0 0 112zM96 448v16 32 16h32V496 480H384v16 16h32V496 464 448H400 384 128 112 96zm96-255v95h32V176h64V288h32V193l67.3 88.7 9.7 12.7 25.5-19.3-9.7-12.7-84.9-112L323 144h-7.9H196.9 189l-4.8 6.3-84.9 112-9.7 12.7 25.5 19.3 9.7-12.7L192 193zm288-49V128H448v16 16H432 416v32h16 16v16 16h32V208 192h16 16V160H496 480V144zM64 336V320H32v16 16H16 0v32H16 32v16 16H64V400 384H80 96V352H80 64V336zm112-16H160v32h16H336h16V320H336 176zm0 64H160v32h16H336h16V384H336 176z'
      
    ]
  };

  

  
  

  var faArrowUpLeft = {
    prefix: 'fasl',
    iconName: 'arrow-up-left',
    icon: [
      384,
      512,
      [],
      'e09d',
      
      'M48 96H32v16V336v16H64V336 150.6L316.7 403.3 328 414.6 350.6 392l-11.3-11.3L86.6 128H272h16V96H272 48z'
      
    ]
  };

  

  
  

  var faSquarePhoneHangup = {
    prefix: 'fasl',
    iconName: 'square-phone-hangup',
    icon: [
      448,
      512,
      ["phone-square-down"],
      'e27a',
      
      'M416 64V448H32V64H416zm32-32H416 32 0V64 448v32H32 416h32V448 64 32zM224 160c-58 0-116.1 21.6-160.5 64.9L52.8 235.3l-9.4 9.2 7.2 11 37.3 57.2 6.4 9.8 11.3-3.1 74.7-20.8 13.9-3.9-2.4-14.2L188.6 262c23.3-4.9 47.4-4.9 70.7 0l-3.1 18.6-2.4 14.2 13.9 3.9 74.7 20.8 11.3 3.1 6.4-9.8 37.3-57.2 7.2-11-9.4-9.2-10.7-10.4 0 0C340.1 181.6 282 160 224 160zM85.8 247.8C123.9 210.6 173.9 192 224 192s100.1 18.6 138.2 55.8l0 0 1.3 1.2-23.7 36.4-49.5-13.8 3.2-18.8 2.4-13.9-13.5-4.1c-37.9-11.4-78.5-11.4-116.4 0l-13.5 4.1 2.4 13.9 3.2 18.8-49.5 13.8L84.6 249l1.3-1.2z'
      
    ]
  };

  
    var faPhoneSquareDown = faSquarePhoneHangup;
  

  
  

  var faShieldSlash = {
    prefix: 'fasl',
    iconName: 'shield-slash',
    icon: [
      640,
      512,
      [],
      'e24b',
      
      'M416.1 413.4c-26.1 25.1-57.8 47.1-96.1 63.7c-89.4-38.7-142.6-106.4-172.8-175.9c-18.9-43.6-28.8-87.8-32.9-126l-34-26.9c1.8 47.1 12.1 106.9 37.6 165.6c32.7 75.3 91 150 189.4 192.6L320 512l12.7-5.5c43.7-18.9 79.6-44.2 108.7-73.1l-25.3-20zM308.4 4.5l-136.6 53 29.2 23L320 34.3l207.5 80.5c2.7 45.6-4.5 116.8-34.7 186.3c-1 2.4-2.1 4.8-3.2 7.2l25.8 20.4c2.4-4.9 4.6-9.9 6.8-14.8c32.4-74.7 40.2-151 37.3-200.9l-1.2-20.5L539.1 85 331.6 4.5 320 0 308.4 4.5zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faCircleU = {
    prefix: 'fasl',
    iconName: 'circle-u',
    icon: [
      512,
      512,
      [],
      'e127',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 160V144H144v16V288c0 61.9 50.1 112 112 112s112-50.1 112-112V160 144H336v16V288c0 44.2-35.8 80-80 80s-80-35.8-80-80V160z'
      
    ]
  };

  

  
  

  var faGaugeSimpleMax = {
    prefix: 'fasl',
    iconName: 'gauge-simple-max',
    icon: [
      512,
      512,
      ["tachometer-fastest"],
      'f62b',
      
      'M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm0 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64s28.7-64 64-64c17.5 0 33.4 7 44.9 18.4l106.9-64.1 13.7-8.2L438 261.5l-13.7 8.2L317.4 333.8c1.7 5.8 2.6 11.9 2.6 18.2c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTachometerFastest = faGaugeSimpleMax;
  

  
  

  var faPlaneTail = {
    prefix: 'fasl',
    iconName: 'plane-tail',
    icon: [
      512,
      512,
      [],
      'e22c',
      
      'M-11.8 0H8 120h6.5l4.7 4.5 248 240 11.5 11.1-.4 .4H496h16v32H496 258.1L32 348.3v48.5L258.8 480H496h16v32H496 256h-2.8l-2.7-1-240-88L0 419.2V408 336 323.7l11.9-3.2L55 309-7.6 19.4-11.8 0zM113.5 32H27.8L85.9 300.8l165.9-44.2 2-.5H256h89L113.5 32zM208 352H368h16v32H368 208 192V352h16z'
      
    ]
  };

  

  
  

  var faShapes = {
    prefix: 'fasl',
    iconName: 'shapes',
    icon: [
      512,
      512,
      ["triangle-circle-square"],
      'f61f',
      
      'M178.3 192L269.6 32.2 288 0l18.4 32.2L397.7 192 416 224H379.1 196.9 160l18.3-32zm182.6 0L288 64.5 215.1 192H360.9zM480 304H320V464H480V304zM320 272H480h32v32V464v32H480 320 288V464 304 272h32zM224 384A96 96 0 1 0 32 384a96 96 0 1 0 192 0zM0 384a128 128 0 1 1 256 0A128 128 0 1 1 0 384z'
      
    ]
  };

  
    var faTriangleCircleSquare = faShapes;
  

  
  

  var faChargingStation = {
    prefix: 'fasl',
    iconName: 'charging-station',
    icon: [
      576,
      512,
      [],
      'f5e7',
      
      'M288 32V480H64V32H288zM32 32V480L0 480v32H32 64 288h32 32V480l-32 0V288h16c26.5 0 48 21.5 48 48v48c0 35.3 28.7 64 64 64s64-28.7 64-64V270.4c36.5-7.4 64-39.7 64-78.4V144 128H560 544V80 64H512V80v48H480V80 64H448V80v48H432 416v16 48c0 38.7 27.5 71 64 78.4V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V336c0-44.2-35.8-80-80-80H320V32 0H288 64 32V32zM512 160h32v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V160h32 32zM204.8 121.6l9.6-12.8L188.8 89.6l-9.6 12.8-72 96L88 224h32 80l-52.8 70.4-9.6 12.8 25.6 19.2 9.6-12.8 72-96L264 192H232 152l52.8-70.4z'
      
    ]
  };

  

  
  

  var faMaximize = {
    prefix: 'fasl',
    iconName: 'maximize',
    icon: [
      512,
      512,
      ["expand-arrows-alt"],
      'f31e',
      
      'M216 56L193.4 78.6l-46.1 46.1L256 233.4 364.7 124.7 318.6 78.6 296 56l22.6-22.6L320 32H448h32V64 192l-1.4 1.4L456 216l-22.6-22.6-46.1-46.1L278.6 256 387.3 364.7l46.1-46.1L456 296l22.6 22.6L480 320V448v32H448 320l-1.4-1.4L296 456l22.6-22.6 46.1-46.1L256 278.6 147.3 387.3l46.1 46.1L216 456l-22.6 22.6L192 480H64 32V448 320l1.4-1.4L56 296l22.6 22.6 46.1 46.1L233.4 256 124.7 147.3 78.6 193.4 56 216 33.4 193.4 32 192V64 32H64 192l1.4 1.4L216 56zm-53.3 8H64v98.7L162.7 64zM64 349.3V448h98.7L64 349.3zm384 0L349.3 448H448V349.3zm0-186.5V64H349.3L448 162.7z'
      
    ]
  };

  
    var faExpandArrowsAlt = faMaximize;
  

  
  

  var faLightbulbGear = {
    prefix: 'fasl',
    iconName: 'lightbulb-gear',
    icon: [
      576,
      512,
      [],
      'e5fd',
      
      'M192 32c76.8 0 139.6 60.2 143.8 136h32C363.6 74.5 286.5 0 192 0C94.8 0 16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1l0 0c-4.9-6.7-9.5-13-13.6-19C57.5 234.8 48 206.6 48 176C48 96.5 112.5 32 192 32zm59 384H240 144 112v32 32 32h32 96 32V480 452.3L251 416zM112 176c0-44.2 35.8-80 80-80V64C130.1 64 80 114.1 80 176h32zm32 304V448h96v32H144zM464.2 238.4v-32h-32-32-32v32 3.2c-7.7 3.4-15 7.5-21.8 12.3l-4.3-2.5-27.5-16.3L298.8 263l-32.1 57 30.1 17.8c-.5 4.6-.8 9.2-.8 13.9s.3 9.4 .8 13.9l-30.1 17.8 32.1 57 15.7 27.9L342.1 452l4.3-2.5c6.8 4.8 14.1 9 21.8 12.3V465v32h32 32 32V465v-3.3c7.6-3.3 14.8-7.4 21.5-12.2l4.3 2.5 27.5 16.3 15.7-27.9 32.1-57-30.1-17.8c.5-4.6 .8-9.2 .8-13.9s-.3-9.4-.8-13.9L565.3 320l-32.1-57-15.7-27.9-27.5 16.3-4.3 2.5c-6.7-4.8-13.9-8.9-21.5-12.2v-3.3zm37.8 43.1l3.7-2.2L522 308.4l-3.1 1.8L501 320.8l2.4 20.6c.4 3.4 .6 6.8 .6 10.3s-.2 6.9-.6 10.3L501 382.6l17.9 10.6L522 395l-16.4 29.1-3.7-2.2L484 411.3l-17 12.1c-4.9 3.5-10.2 6.5-15.7 8.9l-19.1 8.4v20.9V465h-32v-3.2-21l-19.2-8.4c-5.6-2.5-11-5.5-16-9l-17-12.1-17.9 10.6-3.7 2.2L310 395l3.1-1.8L331 382.6 328.6 362c-.4-3.4-.6-6.8-.6-10.3s.2-6.9 .6-10.3l2.4-20.6-17.9-10.6-3.1-1.8 16.4-29.1 3.7 2.2L348 292.1 365 280c5-3.5 10.3-6.6 16-9l19.2-8.4v-21-3.2h32v3.3 20.9l19.1 8.4c5.6 2.4 10.8 5.4 15.7 8.9l17 12.1 17.9-10.6zM416.1 407.7a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm0-80a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faCactus = {
    prefix: 'fasl',
    iconName: 'cactus',
    icon: [
      512,
      512,
      [127797],
      'f8a7',
      
      'M320 96c0-35.3-28.7-64-64-64s-64 28.7-64 64V224v32 32 32V480H320V448 416 384 352 96zm32 288v32H464h16V400 272 256H448v16 80 32H416 352zm0 64v32 32H320 192 160V480 320H48 32 0V288 272 144 128 96H32 64 96v32 16 48 32h32 32V96c0-53 43-96 96-96s96 43 96 96V352h32 32V320 272 256 224h32 32 32v32 16V400v16 32H480 464 352zM64 256V224 144 128H32v16V272v16H48 160V256H96 64zM224 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faSignalBarsGood = {
    prefix: 'fasl',
    iconName: 'signal-bars-good',
    icon: [
      640,
      512,
      ["signal-alt-3"],
      'f693',
      
      'M416 160V480H384V160h32zm-32-32H352v32V480v32h32 32 32V480 160 128H416 384zM256 288V480H224V288h32zm-32-32H192v32V480v32h32 32 32V480 288 256H256 224zM64 416H96v64H64V416zM32 384v32 64 32H64 96h32V480 416 384H96 64 32z'
      
    ]
  };

  
    var faSignalAlt3 = faSignalBarsGood;
  

  
  

  var faClockFourThirty = {
    prefix: 'fasl',
    iconName: 'clock-four-thirty',
    icon: [
      512,
      512,
      [],
      'e34b',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400V285.9l71.1 47.4 13.3 8.9 17.8-26.6-13.3-8.9-96-64L240 226.1V256 400v16h32V400z'
      
    ]
  };

  

  
  

  var faArrowPointer = {
    prefix: 'fasl',
    iconName: 'arrow-pointer',
    icon: [
      320,
      512,
      ["mouse-pointer"],
      'f245',
      
      'M161.5 320H288h32l-.1-32 0-10L32 32 0 46.9V432l7.2 7.9L29 463.8l20.5-25 84.2-102.6 59.7 134.4 29.2-13L161.5 320zm-39.4-20.3L32 409.6V74.1L282.3 288H146.9 131.8l-9.6 11.7z'
      
    ]
  };

  
    var faMousePointer = faArrowPointer;
  

  
  

  var faClockSevenThirty = {
    prefix: 'fasl',
    iconName: 'clock-seven-thirty',
    icon: [
      512,
      512,
      [],
      'e351',
      
      'M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400V308.8l-34.7 52-8.9 13.3-26.6-17.8 8.9-13.3 64-96L272 256V400v16H240V400z'
      
    ]
  };

  

  
  

  var faVenusMars = {
    prefix: 'fasl',
    iconName: 'venus-mars',
    icon: [
      640,
      512,
      [9892],
      'f228',
      
      'M176 320a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM352 176c0 91.8-70.3 167.2-160 175.3V416h64 16v32H256 192v48 16H160V496 448H96 80V416H96h64V351.3C70.3 343.2 0 267.8 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c9.7-5.1 19-10.9 27.8-17.4C325.6 368.5 361 384 400 384c79.5 0 144-64.5 144-144s-64.5-144-144-144c-10.5 0-20.7 1.1-30.6 3.3c-4.1-10.2-8.9-20.1-14.5-29.4C369.3 66 384.4 64 400 64c42.8 0 82.1 15.3 112.6 40.7L585.4 32H496 480V0h16H624h16V16 144v16H608V144 54.6l-72.7 72.7C560.7 157.9 576 197.2 576 240c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z'
      
    ]
  };

  

  
  

  var faBox = {
    prefix: 'fasl',
    iconName: 'box',
    icon: [
      448,
      512,
      [128230],
      'f466',
      
      'M84.8 64H208v96H42.1L84.8 64zM240 192H416V448H32V192H208h32zm165.9-32H240V64H363.2l42.7 96zM384 32H64L0 176V448v32H32 416h32V448 176L384 32z'
      
    ]
  };

  

  
  

  var faPageCaretDown = {
    prefix: 'fasl',
    iconName: 'page-caret-down',
    icon: [
      384,
      512,
      ["file-caret-down"],
      'e429',
      
      'M352 125.3V480H32V32H258.7L352 125.3zM384 112L272 0H32 0V32 480v32H32 352h32V480 112zM192 306.7L141.3 256H242.7L192 306.7zm0 45.3l22.6-22.6L288 256V224H256 128 96v32l73.4 73.4L192 352z'
      
    ]
  };

  
    var faFileCaretDown = faPageCaretDown;
  

  
  

  var faCross = {
    prefix: 'fasl',
    iconName: 'cross',
    icon: [
      384,
      512,
      [10013,128327],
      'f654',
      
      'M128 0h16 96 16V16 128H368h16v16 96 16H368 256V496v16H240 144 128V496 256H16 0V240 144 128H16 128V16 0zm32 32V144v16H144 32v64H144h16v16V480h64V240 224h16H352V160H240 224V144 32H160z'
      
    ]
  };

  

  
  

  var faRepeat = {
    prefix: 'fasl',
    iconName: 'repeat',
    icon: [
      512,
      512,
      [128257],
      'f363',
      
      'M320 32V0h32l73.4 73.4L448 96l-22.6 22.6L352 192H320V160 112H32V256v16H0V256 96 80H16 320V32zm32 114.7L402.7 96 352 45.3V80v32 34.7zM512 256l0 160v16H496l-304 0v48 32H160L86.6 438.6 64 416l22.6-22.6L160 320h32v32 48l288 0 0-144V240l32 0v16zM109.3 416L160 466.7V365.3L109.3 416z'
      
    ]
  };

  

  
  

  var faDialMin = {
    prefix: 'fasl',
    iconName: 'dial-min',
    icon: [
      576,
      512,
      [],
      'e161',
      
      'M312 8H264V56h48V8zM120 72H72v48h48V72zm336 0v48h48V72H456zM568 264H520v48h48V264zM8 264v48H56V264H8zM120 456H72v48h48V456zm336 0v48h48V456H456zM276.7 276.7l-89.8 89.8c-39.1-50.2-35.5-122.9 10.6-169c50-50 131-50 181 0s50 131 0 181c-46.2 46.2-118.8 49.7-169 10.6l89.8-89.8L310.6 288 288 265.4l-11.3 11.3zM174.9 401.1A160 160 0 1 0 401.1 174.9 160 160 0 1 0 174.9 401.1z'
      
    ]
  };

  

  
  

  var faStar = {
    prefix: 'fasl',
    iconName: 'star',
    icon: [
      576,
      512,
      [11088,61446],
      'f005',
      
      'M374.6 164L306.1 34.3 288.1 0 270 34.3 201.5 164 57.1 189l-38.2 6.6 27 27.8L148.1 328.5 127.2 473.6 121.7 512l34.8-17.1 131.6-64.7 131.6 64.7L454.4 512l-5.5-38.4L428 328.5 530.2 223.4l27-27.8L519 189 374.6 164zM492 216.8l-86.9 89.4-11 11.3 2.2 15.6 17.8 123.5-111.9-55-14.1-6.9-14.1 6.9L162 456.5l17.8-123.5 2.2-15.6-11-11.3L84.1 216.8 207 195.5l15.5-2.7 7.3-13.9L288.1 68.6l58.2 110.3 7.3 13.9 15.5 2.7L492 216.8z'
      
    ]
  };

  

  
  

  var faDiamondExclamation = {
    prefix: 'fasl',
    iconName: 'diamond-exclamation',
    icon: [
      512,
      512,
      [],
      'e405',
      
      'M22.6 278.6L0 256l22.6-22.6L233.4 22.6 256 0l22.6 22.6L489.4 233.4 512 256l-22.6 22.6L278.6 489.4 256 512l-22.6-22.6L22.6 278.6zM45.3 256L256 466.7 466.7 256 256 45.3 45.3 256zM272 128v16V272v16H240V272 144 128h32zM232 368V320h48v48H232z'
      
    ]
  };

  

  
  

  var faSignalBars = {
    prefix: 'fasl',
    iconName: 'signal-bars',
    icon: [
      640,
      512,
      ["signal-alt","signal-alt-4","signal-bars-strong"],
      'f690',
      
      'M544 32V480h32V32H544zM512 0h32 32 32V32 480v32H576 544 512V480 32 0zM384 160V480h32V160H384zm-32-32h32 32 32v32V480v32H416 384 352V480 160 128zM256 288H224V480h32V288zm-32-32h32 32v32V480v32H256 224 192V480 288 256h32zM64 416v64H96V416H64zM32 384H64 96h32v32 64 32H96 64 32V480 416 384z'
      
    ]
  };

  
    var faSignalAlt = faSignalBars;
  
    var faSignalAlt4 = faSignalBars;
  
    var faSignalBarsStrong = faSignalBars;
  

  
  

  var faSprayCanSparkles = {
    prefix: 'fasl',
    iconName: 'spray-can-sparkles',
    icon: [
      512,
      512,
      ["air-freshener"],
      'f5d0',
      
      'M112 0h96 16V16 80 96H192V80 32H128V80 96H96V80 16 0h16zM96 160c-35.3 0-64 28.7-64 64V480H288V224c0-35.3-28.7-64-64-64H96zM0 224c0-53 43-96 96-96H224c53 0 96 43 96 96V480v32H288 32 0V480 224zM160 368a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM352 0V16 32h16 16V64H368 352V80 96H320V80 64H304 288V32l16 0h16V16 0h32zM480 16V32h16 16V64H496 480V80 96H448V80 64H432 416V32l16 0h16V16 0h32V16zm0 192v16h16 16v32H496 480v16 16H448V272 256H432 416V224h16 16V208 192h32v16zm-64-96v16h16 16v32H432 416v16 16H384V176 160H368 352V128h16 16V112 96h32v16z'
      
    ]
  };

  
    var faAirFreshener = faSprayCanSparkles;
  

  
  

  var faCommentText = {
    prefix: 'fasl',
    iconName: 'comment-text',
    icon: [
      512,
      512,
      [],
      'e14d',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM192 160H176v32h16 48V304v16h32V304 192h48 16V160H320 256 192z'
      
    ]
  };

  

  
  

  var faSunDust = {
    prefix: 'fasl',
    iconName: 'sun-dust',
    icon: [
      512,
      512,
      [],
      'f764',
      
      'M178.7 15.5L256 57.1l77.3-41.6L362 0l9.4 31.3 25.2 84.1 0 0-25.7 25.7 0 0-5-16.5L342.7 46.8 271.2 85.3 256 93.5l-15.2-8.2L169.3 46.8 146 124.6l-5 16.5-16.5 5L46.8 169.3l38.5 71.5L93.5 256l-8.2 15.2L46.8 342.7 124.6 366l16.5 5 0 0-25.7 25.7 0 0L31.3 371.4 0 362l15.5-28.8L57.1 256 15.5 178.7 0 150l31.3-9.4 84.1-25.2 25.2-84.1L150 0l28.8 15.5zM256 128c35.3 0 67.4 14.3 90.5 37.5l-22.6 22.6C306.5 170.7 282.5 160 256 160c-53 0-96 43-96 96c0 26.5 10.7 50.5 28.1 67.9l-22.6 22.6C142.3 323.3 128 291.3 128 256c0-70.7 57.3-128 128-128zm200 32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-56 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-56 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM160 456a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm160 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM240 376a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56-56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faCameraRotate = {
    prefix: 'fasl',
    iconName: 'camera-rotate',
    icon: [
      640,
      512,
      [],
      'e0d8',
      
      'M224 32H416l21.3 64H544h32v32V448v32H544 96 64V448 128 96H96 202.7L224 32zm213.3 96H414.3L407 106.1 392.9 64H247.1l-14 42.1L225.7 128H202.7 96V448H544V128H437.3zM224 304h64 16v32H288 262.6l14.1 14.1C288.2 361.5 303.8 368 320 368c27.8 0 52.3-14.2 66.7-35.8l26.6 17.7C393.3 380.1 359 400 320 400c-24.7 0-48.5-9.8-65.9-27.3L240 358.6V384v16H208V384 320 304h16zm208-32H416 352 336V240h16 25.4l-14.1-14.1C351.8 214.5 336.2 208 320 208c-27.8 0-52.3 14.2-66.7 35.8l-26.6-17.7C246.7 195.9 281 176 320 176c24.7 0 48.5 9.8 65.9 27.3L400 217.4V192 176h32v16 64 16z'
      
    ]
  };

  

  
  

  var faUniformMartialArts = {
    prefix: 'fasl',
    iconName: 'uniform-martial-arts',
    icon: [
      640,
      512,
      [],
      'e3d1',
      
      'M123.6 0h-9.5l-4.6 8.3L2 204l-2 3.6v4.1V400v16H16h96 16V400 384 288 240.4l32-58.2V288h32V120l-30-7.7L98 228.6l-2 3.6v4.1V384H32V215.8L133.1 32h97l72 144-56 112h35.8l52.4-104.8L409.9 32h97L608 215.8V384H544V236.3v-4.1l-2-3.6L478 112.3 448 120V288h32V182.3l32 58.2V288v96 16 16h16 96 16V400 211.7v-4.1l-2-3.6L530.4 8.3 525.8 0h-9.5H400h-9.9H249.9 240 123.6zM265.9 32H374.1L320 140.2 265.9 32zM480 384H448v96H192V384H160V496v16h16H464h16V496 384zM144 320v32h16H290.1l-47.4 71.1-8.9 13.3 26.6 17.8 8.9-13.3 50.7-76 50.7 76 8.9 13.3 26.6-17.8-8.9-13.3L349.9 352H480h16V320H480 320 160 144z'
      
    ]
  };

  

  
  

  var faFaceWeary = {
    prefix: 'fasl',
    iconName: 'face-weary',
    icon: [
      512,
      512,
      [],
      'e3a1',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 94c26.3 0 52.4 4 77.5 11.9c-10.6-26.1-38.7-43.9-77.5-43.9c-38.1 0-65.4 17.3-76.6 43.6C204.2 353.9 230 350 256 350zm0-64c62.2 0 114 38.8 114 100v22.7L348.6 401l-16.5-5.9C307.7 386.4 282 382 256 382s-51.8 4.5-76.2 13.2L163.3 401 141 409l1-23.7c2.5-60.2 51.2-99.4 114-99.4zM222.6 176l-11.3 11.3-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L200 153.4 222.6 176zm78.1 11.3L289.4 176 312 153.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z'
      
    ]
  };

  

  
  

  var faEggFried = {
    prefix: 'fasl',
    iconName: 'egg-fried',
    icon: [
      512,
      512,
      [],
      'f7fc',
      
      'M461.1 182.8c31.6 42.6 22.6 102.7-19.9 134.3c-13.4 9.9-28.4 15.8-43.8 18c-23.8 3.3-49.1 13.4-70.9 26.8c-21.6 13.3-42.8 31.8-55.7 54.1C235.5 477.2 157.2 498.2 96 462.8S13.8 349.2 49.1 288c28.1-48.6 42.7-116.9 47.2-168.4c2-22.3 11.7-44 29.1-60.8c38.2-36.7 99-35.5 135.7 2.7c17.9 18.6 42.8 36.8 68.2 51.6s53.5 27.6 78.5 33.9c20.6 5.3 39.6 17.4 53.3 35.8zM415.8 116c-42.4-10.9-101.2-45.1-131.5-76.7c-49-51-130-52.6-181-3.6C80.1 58 67.1 87 64.5 116.8C60.2 166.1 46.2 229.1 21.4 272C-22.7 348.5 3.5 446.4 80 490.6s174.4 18 218.6-58.6c18.8-32.5 66.1-60 103.3-65.2c20.5-2.9 40.6-10.8 58.4-24c56.8-42.1 68.7-122.3 26.6-179.1c-18.2-24.6-43.5-40.7-71-47.8zM224 336a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM96 240a128 128 0 1 0 256 0A128 128 0 1 0 96 240zm88 0c0-22.1 17.9-40 40-40V168c-39.8 0-72 32.2-72 72h32z'
      
    ]
  };

  

  
  

  var faCircleBookmark = {
    prefix: 'fasl',
    iconName: 'circle-bookmark',
    icon: [
      512,
      512,
      ["bookmark-circle"],
      'e100',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm17.8-218.6L256 281.5l-17.8 11.8L192 324.2V160H320V324.2l-46.2-30.8zM160 384l32-21.3L256 320l64 42.7L352 384V345.5 160 128H320 192 160v32V345.5 384z'
      
    ]
  };

  
    var faBookmarkCircle = faCircleBookmark;
  

  
  

  var faBellExclamation = {
    prefix: 'fasl',
    iconName: 'bell-exclamation',
    icon: [
      448,
      512,
      [],
      'f848',
      
      'M208 0h32V32.8c80.9 8 144 76.2 144 159.2v97.4l59.3 59.3 4.7 4.7V360v40 16H432 16 0V400 360v-6.6l4.7-4.7L64 289.4V192c0-83 63.1-151.2 144-159.2V0zm16 64C153.3 64 96 121.3 96 192V296v6.6l-4.7 4.7L32 366.6V384H416V366.6l-59.3-59.3-4.7-4.7V296 192c0-70.7-57.3-128-128-128zM160 448h32c0 17.7 14.3 32 32 32s32-14.3 32-32h32c0 35.3-28.7 64-64 64s-64-28.7-64-64zm80-336v16V240v16H208V240 128 112h32zm8 184v48H200V296h48z'
      
    ]
  };

  

  
  

  var faBan = {
    prefix: 'fasl',
    iconName: 'ban',
    icon: [
      512,
      512,
      [128683,"cancel"],
      'f05e',
      
      'M402.7 425.3l-316-316C52.6 148.6 32 199.9 32 256c0 123.7 100.3 224 224 224c56.1 0 107.4-20.6 146.7-54.7zm22.6-22.6C459.4 363.4 480 312.1 480 256C480 132.3 379.7 32 256 32c-56.1 0-107.4 20.6-146.7 54.7l316 316zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faCancel = faBan;
  

  
  

  var faScalpel = {
    prefix: 'fasl',
    iconName: 'scalpel',
    icon: [
      512,
      512,
      [],
      'f61d',
      
      'M471.1 95.1c5.8-6.9 8.9-15.6 8.9-24.6V66.2C480 47.3 464.7 32 445.8 32c-9.8 0-19.1 4.2-25.6 11.5L231.3 256H337L471.1 95.1zm24.6 20.5L352 288H202.8 160l28.4-32L396.2 22.2C408.8 8.1 426.8 0 445.8 0C482.3 0 512 29.7 512 66.2v4.2c0 16.5-5.8 32.5-16.3 45.1zM33 476.4L178.3 320H222L85.7 466.8c20-4.6 41.6-10.7 63.1-18.7c66.2-24.8 121.9-64.2 135.9-128h32.7C294.5 451.3 132 493.4 48.8 506.4C19.5 511 0 512 0 512l33-35.6z'
      
    ]
  };

  

  
  

  var faPersonCircleMinus = {
    prefix: 'fasl',
    iconName: 'person-circle-minus',
    icon: [
      576,
      512,
      [],
      'e540',
      
      'M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM99.3 128h9.6H211.1h9.6l4.5 8.5 66.7 124.9c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496v16H192V496 352H128V496v16H96V496 202.1L46.1 295.5l-7.5 14.1L10.3 294.6l7.5-14.1 76.9-144 4.5-8.5zM128 320h64V160H128V320zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 160H496 368 352V352h16H496h16v32z'
      
    ]
  };

  

  
  

  var faCircleThreeQuartersStroke = {
    prefix: 'fasl',
    iconName: 'circle-three-quarters-stroke',
    icon: [
      512,
      512,
      [],
      'e5d4',
      
      'M477.7 288H240 224V272 34.3C115.4 49.8 32 143.2 32 256c0 123.7 100.3 224 224 224c112.8 0 206.2-83.4 221.7-192zm2.3-32C480 132.3 379.7 32 256 32V256H480zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  

  
  

  var faHouseFlag = {
    prefix: 'fasl',
    iconName: 'house-flag',
    icon: [
      640,
      512,
      [],
      'e50d',
      
      'M480 0H448V16 32 64v96 32V512h32V192H608h32V160 64 32H608 480V16 0zm0 160V64H608v96H480zm-64-24L281.6 35.2 272 28l-9.6 7.2-256 192 19.2 25.6L64 224V496v16H80 416V480H344V336 320H328 216 200v16V480H96V200L272 68 416 176V136zM312 352V480l-80 0V352h80z'
      
    ]
  };

  

  
  

  var faChartArea = {
    prefix: 'fasl',
    iconName: 'chart-area',
    icon: [
      512,
      512,
      ["area-chart"],
      'f1fe',
      
      'M32 48V32H0V48 464v16H16 496h16V448H496 32V48zm214.6 70.6L224 96l-22.6 22.6L96 224V352v32h32H448h32V352 240l-75.1-87.6L384 128l-22.7 22.7-18.7 18.7L320 192l-22.6-22.6-50.7-50.7zm96 96l39.6-39.6L448 251.8V352H128V237.3l96-96 73.4 73.4L320 237.3l22.6-22.6z'
      
    ]
  };

  
    var faAreaChart = faChartArea;
  

  
  

  var faMoneyBillWave = {
    prefix: 'fasl',
    iconName: 'money-bill-wave',
    icon: [
      576,
      512,
      [],
      'f53a',
      
      'M96 446.8V440c0-35.3-28.7-64-64-64v55.2c21.2 8.6 42.4 13.5 64 15.6zm32 1.1c48-1 97.9-13.4 152.1-27.2l4-1c51.3-13.1 106.6-27.2 163.9-28.1c.2-52.8 43.1-95.6 96-95.6V168c-53 0-96-43-96-96V64.1c-48 1-97.9 13.4-152.1 27.2l-4 1c-51.3 13.1-106.6 27.2-163.9 28.1c-.2 52.8-43.1 95.6-96 95.6V344c53 0 96 43 96 96v7.9zM480 392v.5c21.2 1.6 42.5 5.4 64 11.9V328c-35.3 0-64 28.7-64 64zM96 119.5c-21.2-1.6-42.5-5.4-64-11.9V184c35.3 0 64-28.7 64-64v-.5zM480 72c0 35.3 28.7 64 64 64V80.8c-21.2-8.6-42.4-13.5-64-15.6V72zM0 60.3c10.7 5.4 21.3 10 32 13.7c85.3 29.8 170.7 8.1 256-13.7c96-24.5 192-48.9 288 0V416.3v35.4c-10.7-5.4-21.3-10-32-13.7c-85.3-29.8-170.7-8.1-256 13.7c-96 24.5-192 48.9-288 0V95.7 60.3zM224 256c0 47 31.3 80 64 80s64-33 64-80s-31.3-80-64-80s-64 33-64 80zm64-112c55.6 0 96 53 96 112s-40.4 112-96 112s-96-53-96-112s40.4-112 96-112z'
      
    ]
  };

  

  
  

  var faPizzaSlice = {
    prefix: 'fasl',
    iconName: 'pizza-slice',
    icon: [
      512,
      512,
      [],
      'f818',
      
      'M8.8 476.8L0 512l35.2-8.8L512 384C512 171.9 340.1 0 128 0L8.8 476.8zM44 468l88.8-355.3c142.5 10.2 256.3 124 266.5 266.5L44 468zM140.7 81.3l12.1-48.4C327.4 45 467 184.6 479.1 359.2l-48.4 12.1C417.1 217.5 294.5 94.9 140.7 81.3zM176 264a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM144 392a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faTruckBolt = {
    prefix: 'fasl',
    iconName: 'truck-bolt',
    icon: [
      640,
      512,
      [],
      'e3d0',
      
      'M384 32V384H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H32V32H384zM32 416H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32 16 16V384H624 608V224v-5.9l-3.9-4.5-96-112L503.4 96H496 416V32 0H384 32 0V32 384v32H32zM416 128h72.6l82.3 96H416V128zm0 216.4V256H576V384h-5.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM251.3 107.3L262.6 96 240 73.4 228.7 84.7l-80 80L121.4 192H160h68l-52.7 52.7L164 256l22.6 22.6L198 267.3l80-80L305.3 160H266.7h-68l52.7-52.7z'
      
    ]
  };

  

  
  

  var faSignPosts = {
    prefix: 'fasl',
    iconName: 'sign-posts',
    icon: [
      576,
      512,
      [],
      'e625',
      
      'M32 64V384H544V64H512 480 96 64 32zM512 32h32 32V64 384v32H544 512l0 96H480l0-96H96l0 96H64l0-96H32 0V384 64 32H32 64L64 0H96l0 32H480l0-32h32l0 32z'
      
    ]
  };

  

  
  

  var faMailbox = {
    prefix: 'fasl',
    iconName: 'mailbox',
    icon: [
      576,
      512,
      [128234],
      'f813',
      
      'M32 208V416H256V208c0-61.9-50.1-112-112-112S32 146.1 32 208zm256 0V416H544V208c0-61.9-50.1-112-112-112H234.5c32.6 26.4 53.5 66.8 53.5 112zM0 208C0 128.5 64.5 64 144 64H432c79.5 0 144 64.5 144 144V416v32H544 288 256 32 0V416 208zm112-16h64 16v32H176 112 96V192h16zm224 0h96 64 16v16 96 16H496 432 416V304 224H336 320V192h16zm112 96h32V224H448v64z'
      
    ]
  };

  

  
  

  var faChartLineUp = {
    prefix: 'fasl',
    iconName: 'chart-line-up',
    icon: [
      512,
      512,
      [],
      'e0e5',
      
      'M32 48V32H0V48 464v16H16 496h16V448H496 32V48zm304 80H320v32h16 89.4L320 265.4l-84.7-84.7L224 169.4l-11.3 11.3-112 112L89.4 304 112 326.6l11.3-11.3L224 214.6l84.7 84.7L320 310.6l11.3-11.3L448 182.6V272v16h32V272 144 128H464 336z'
      
    ]
  };

  

  
  

  var faBuildingLock = {
    prefix: 'fasl',
    iconName: 'building-lock',
    icon: [
      576,
      512,
      [],
      'e4d6',
      
      'M32 32H352V272c0-30.5 12.2-58.2 32-78.4V32 0H352 32 0V32 480v32H32h96 32 64 32 64l0-32H256V400 368H224 160 128v32 80H32V32zM320 240V224H304 240 224v16 64 16h16 64 16V304 288 240zM160 480V400h64v80H160zM64 96v16 64 16H80h64 16V176 112 96H144 80 64zm32 32h32v32H96V128zM240 96H224v16 64 16h16 64 16V176 112 96H304 240zm16 64V128h32v32H256zM64 224v16 64 16H80h64 16V304 240 224H144 80 64zm32 32h32v32H96V256zm160 32V256h32v32H256zm208-64c26.5 0 48 21.5 48 48v48H416V272c0-26.5 21.5-48 48-48zm-80 48v48H352v32V480v32h32H544h32V480 352 320H544V272c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80H544V480H384V352z'
      
    ]
  };

  

  
  

  var faRectangleHistoryCircleUser = {
    prefix: 'fasl',
    iconName: 'rectangle-history-circle-user',
    icon: [
      640,
      512,
      [],
      'e4a4',
      
      'M480 160v32.7c5.3-.5 10.6-.7 16-.7s10.7 .2 16 .7V160 128H480L32 128H0v32V480v32H32l362.8 0c-12.9-9.1-24.5-19.9-34.6-32L32 480l0-320 448 0zM464 64L48 64V96l416 0V64zM416 0H96V32l320 0V0zM553.5 464.1C536.7 474.2 517 480 496 480s-40.7-5.8-57.5-15.9L454.6 448h82.7l16.1 16.1zm24.9-20.3l-23.1-23.1-4.7-4.7H544 448h-6.6l-4.7 4.7-23.1 23.1C395.2 423.9 384 397.2 384 368c0-61.9 50.1-112 112-112s112 50.1 112 112c0 29.2-11.2 55.9-29.6 75.8zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 320a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z'
      
    ]
  };

  

  
  

  var faPersonDressFairy = {
    prefix: 'fasl',
    iconName: 'person-dress-fairy',
    icon: [
      640,
      512,
      [],
      'e607',
      
      'M320 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 320 0a64 64 0 1 0 0 128zm-39.9 64h79.7l45.7 160H234.4l45.7-160zM384 160H256L201.1 352 192 384h33.3H256V496v16h32V496 384h64V496v16h32V496 384h30.7H448l-9.1-32L384 160zM34.9 32H16 0V48v64c0 86.7 40.6 163.9 103.7 213.7C78.7 360 64 402.3 64 448v16 16H80h32c41.2 0 79.7-12 112-32.7V416H213.2c-28.6 20.2-63.6 32-101.2 32H96c0-38.7 12.5-74.4 33.6-103.5l9.1-12.4 9.1-12.4-12.1-9.5-12.1-9.5C67.7 256.6 32 188.5 32 112V64h2.9c76 0 144.1 33.5 190.6 86.5l10.2-35.8C184.1 63.6 113.2 32 34.9 32zM528 448c-37.7 0-72.6-11.8-101.2-32H416v31.3C448.3 468 486.8 480 528 480h32 16V464 448c0-45.7-14.7-88-39.7-122.3C599.4 275.9 640 198.7 640 112V48 32H624 605.1c-78.3 0-149.3 31.6-200.8 82.7l10.2 35.8C461 97.5 529.2 64 605.1 64H608v48c0 76.5-35.7 144.6-91.5 188.6l-12.1 9.5-12.1 9.5 9.1 12.4 9.1 12.4c21.1 29 33.6 64.7 33.6 103.5H528z'
      
    ]
  };

  

  
  

  var faTabletButton = {
    prefix: 'fasl',
    iconName: 'tablet-button',
    icon: [
      448,
      512,
      [],
      'f10a',
      
      'M32 32V480H416V32H32zM0 0H32 416h32V32 480v32H416 32 0V480 32 0zM224 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faC = {
    prefix: 'fasl',
    iconName: 'c',
    icon: [
      384,
      512,
      [99],
      '43',
      
      'M224 64C118 64 32 150 32 256s86 192 192 192c51.6 0 98.4-20.3 132.9-53.4l22.2 23.1C338.8 456.2 284.2 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c60.2 0 114.8 23.8 155.1 62.4l-22.2 23.1C322.4 84.3 275.6 64 224 64z'
      
    ]
  };

  

  
  

  var faLocationArrow = {
    prefix: 'fasl',
    iconName: 'location-arrow',
    icon: [
      448,
      512,
      [],
      'f124',
      
      'M256 224v32V431.1L377.8 102.2 48.9 224H224h32zM0 208L392.5 62.6 432 48 417.4 87.5 272 480H256 224V448 288 256H192 32 0V224 208z'
      
    ]
  };

  

  
  

  var faMessagePlus = {
    prefix: 'fasl',
    iconName: 'message-plus',
    icon: [
      512,
      512,
      ["comment-alt-plus"],
      'f4a8',
      
      'M160 416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448 416zm0-32h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zM272 112v16 64h64 16v32H336 272v64 16H240V288 224H176 160V192h16 64V128 112h32z'
      
    ]
  };

  
    var faCommentAltPlus = faMessagePlus;
  

  
  

  var faFaceSmileTear = {
    prefix: 'fasl',
    iconName: 'face-smile-tear',
    icon: [
      512,
      512,
      [],
      'e393',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM153.6 313.4l-24.2 21 10.5 12.1c22.2 25.7 61 53.5 116.1 53.5h16V368H256c-43.4 0-74-21.8-91.9-42.5l-10.5-12.1zM326 339.8l26-32.5 26 32.5c3.9 4.8 6 10.8 6 17c0 15-12.2 27.2-27.2 27.2h-9.5c-15 0-27.2-12.2-27.2-27.2c0-6.2 2.1-12.2 6-17zm-25-20c-8.4 10.5-13 23.6-13 37c0 32.7 26.5 59.2 59.2 59.2h9.5c32.7 0 59.2-26.5 59.2-59.2c0-13.4-4.6-26.5-13-37l-30.5-38.2L352 256l-20.5 25.6L301 319.8zM200.4 208a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faRoadBridge = {
    prefix: 'fasl',
    iconName: 'road-bridge',
    icon: [
      640,
      512,
      [],
      'e563',
      
      'M320 32V0h32H608h32V32 480v32H608 352 320V480 32zM496 480H608V32H496V96v16H464V96 32H352V480H464V416 400h32v16 64zm0-288v16 96 16H464V304 208 192h32zM16 96H288v32H240v64h48v32H16 0V192H16 80V128H16 0V96H16zM264 288h24v32H264c-30.9 0-56 25.1-56 56V496v16H192 96 80V496 376c0-30.9-25.1-56-56-56H16 0V288H16h8c48.6 0 88 39.4 88 88V480h64V376c0-48.6 39.4-88 88-88zM208 128H112v64h96V128z'
      
    ]
  };

  

  
  

  var faCalendarPen = {
    prefix: 'fasl',
    iconName: 'calendar-pen',
    icon: [
      448,
      512,
      ["calendar-edit"],
      'f333',
      
      'M128 0V16 64H320V16 0h32V16 64h64 32V96v64 32V480v32H416 32 0V480 192 160 96 64H32 96V16 0h32zM416 192H32V480H416V192zm0-96H32v64H416V96zM280.1 209.4l11.3 11.3 47.9 47.9 11.3 11.3-11.3 11.3L201.4 429.1l-3.3 3.3-4.5 1-62.1 14.2-24.9 5.7 5.7-24.9 14.2-62.1 1-4.5 3.3-3.3L268.8 220.7l11.3-11.3zM156.8 377.9l-7.5 32.7 32.7-7.5 83.2-83.2-25.2-25.2-83.2 83.2zM262.7 272.1l25.2 25.2 17.4-17.4-25.2-25.2-17.4 17.4z'
      
    ]
  };

  
    var faCalendarEdit = faCalendarPen;
  

  
  

  var faFolderImage = {
    prefix: 'fasl',
    iconName: 'folder-image',
    icon: [
      512,
      512,
      [],
      'e18a',
      
      'M32 32H224l48 64H480h32v32V448v32H480 32 0V448 64 32H32zm240 96H256l-9.6-12.8L208 64H32V448H480V128H272zM104 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184.4-9.5l12.2 15.7 112 144 3.4 4.3V352v16 16H400 112 96V368 352v-5.6l3.5-4.4 64-80 11.2-14 12.6 12.6 19.6 19.6 68.8-82.5 12.7-15.3zm-.9 51l-67.3 80.7-11.2 13.5-12.4-12.4L177.3 296l-44.8 56H379.7L287.6 233.5z'
      
    ]
  };

  

  
  

  var faPersonHalfDress = {
    prefix: 'fasl',
    iconName: 'person-half-dress',
    icon: [
      320,
      512,
      [],
      'e548',
      
      'M168.5 78.5a24 24 0 1 1 -17-44.9 24 24 0 1 1 17 44.9zM168.4 .6A56 56 0 1 0 151.6 111.3 56 56 0 1 0 168.4 .6zM211.1 128H192v32h0V320h0v32h0v64h0v80 16h32v0h0V496 202.2l49.9 93.4 7.5 14.1 28.2-15.1-7.5-14.1-76.9-144-4.5-8.5h-9.6zM126.3 263.2l7.2-14.3-28.6-14.3-7.2 14.3-64 128L22.1 400H48 96v96 16h32V496 400h32V368H128 96 73.9l52.4-104.8zM160 160V128H108.9 99.3l-4.5 8.5-76.9 144-7.5 14.1 28.2 15.1 7.5-14.1L118.5 160H160z'
      
    ]
  };

  

  
  

  var faFileChartColumn = {
    prefix: 'fasl',
    iconName: 'file-chart-column',
    icon: [
      384,
      512,
      ["file-chart-line"],
      'f659',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM208 240V224H176v16V432v16h32V432 240zm96 64V288H272v16V432v16h32V432 304zM112 368V352H80v16 64 16h32V432 368z'
      
    ]
  };

  
    var faFileChartLine = faFileChartColumn;
  

  
  

  var faSynagogue = {
    prefix: 'fasl',
    iconName: 'synagogue',
    icon: [
      640,
      512,
      [128333],
      'f69b',
      
      'M192 288V480h64V384c0-35.3 28.7-64 64-64s64 28.7 64 64v96h64V288 143.4L320 41 192 143.4V288zm-32-32V128L320 0 480 128V256l41.4-41.4L544 192l22.6 22.6L640 288V480v32H608 480 448 384 352 288 256 192 160 32 0V480 288l73.4-73.4L96 192l22.6 22.6L160 256zm0 45.3l-64-64-64 64V480H160V301.3zm320 0V480H608V301.3l-64-64-64 64zM288 480h64V384c0-17.7-14.3-32-32-32s-32 14.3-32 32v96zm60.5-335.5l25.8-.2 32.1-.3-16.8 27.4L377 192l12.7 20.6L406.4 240l-32.1-.3-25.8-.2-12.7 21.7L320 288l-15.8-26.9-12.7-21.7-25.8 .2-32.1 .3 16.8-27.4L263 192l-12.7-20.6L233.6 144l32.1 .3 25.8 .2 12.7-21.7L320 96l15.8 26.9 12.7 21.7zm9.1 27.1l-8.8 .1-15.7 .1-8-13.6-5-8.6-5 8.6-8 13.6-15.7-.1-8.8-.1 3.8 6.1 8.7 14.2-8.7 14.2-3.8 6.1 8.8-.1 15.7-.1 8 13.6 5 8.6 5-8.6 8-13.6 15.7 .1 8.8 .1-3.8-6.1L345.1 192l8.7-14.2 3.8-6.1z'
      
    ]
  };

  

  
  

  var faGlobe = {
    prefix: 'fasl',
    iconName: 'globe',
    icon: [
      512,
      512,
      [127760],
      'f0ac',
      
      'M215.1 476.3c-25-26.4-55.5-67.6-72.9-124.3H53.6c30.3 63.8 90 111.1 161.5 124.3zm2.4-46.5c14 18.5 27.9 32.4 38.5 41.6c10.5-9.3 24.5-23.1 38.5-41.6c15.4-20.3 30.7-46.1 41.7-77.7H175.8c11 31.6 26.3 57.4 41.7 77.7zM160 256c0 23.1 2.5 44.5 6.8 64H345.2c4.3-19.5 6.8-40.9 6.8-64s-2.5-44.5-6.8-64H166.8c-4.3 19.5-6.8 40.9-6.8 64zm-25.9-64H41.3c-6 20.3-9.3 41.8-9.3 64s3.2 43.7 9.3 64h92.8c-3.9-19.8-6.1-41.1-6.1-64s2.2-44.2 6.1-64zm41.7-32H336.2c-11-31.6-26.3-57.4-41.7-77.7c-14-18.5-27.9-32.4-38.5-41.6c-10.5 9.3-24.5 23.1-38.5 41.6c-15.4 20.3-30.7 46.1-41.7 77.7zm202.1 32c3.9 19.8 6.1 41.1 6.1 64s-2.2 44.2-6.1 64h92.8c6-20.3 9.3-41.8 9.3-64s-3.2-43.7-9.3-64H377.9zm80.6-32c-30.3-63.8-90-111.1-161.5-124.3c25 26.4 55.5 67.6 72.9 124.3h88.6zm-316.3 0c17.5-56.6 47.9-97.9 72.9-124.3C143.5 48.9 83.9 96.2 53.6 160h88.6zM296.9 476.3c71.6-13.2 131.2-60.4 161.5-124.3H369.8c-17.5 56.6-47.9 97.9-72.9 124.3zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512z'
      
    ]
  };

  

  
  

  var faPersonDolly = {
    prefix: 'fasl',
    iconName: 'person-dolly',
    icon: [
      512,
      512,
      [],
      'f4d0',
      
      'M56 56a24 24 0 1 1 48 0A24 24 0 1 1 56 56zm80 0A56 56 0 1 0 24 56a56 56 0 1 0 112 0zM0 496l0 16 32 0 0-16 0-130.5L1.6 341.6c-.5-.4-1.1-.9-1.6-1.3L0 496zM16 144H0v16V278.9c0 16 8 31 21.4 39.9l100.2 66.8L146.9 512h32.6L151.7 372.9l-1.3-6.5-5.5-3.7L112 340.8V214.5l42.5 66.2 4.7 7.3H168h60.5L254 393.7c-18 11.3-30 31.4-30 54.3c0 35.3 28.7 64 64 64c33.8 0 61.5-26.2 63.8-59.5l148-37-7.8-31L346 421c-10.2-21.9-32.3-37-58-37c-1.1 0-2.3 0-3.4 .1L231.6 164.2l-3.8-15.6-31.1 7.5 3.8 15.6L220.8 256h-44L109.5 151.3l-4.7-7.3H96 16zm64 32V319.4L39.1 292.2c-4.5-3-7.1-8-7.1-13.3V176H80zM256 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM480 345.6l-7.8-31L449.4 223l-7.8-31-31 7.8L319 222.6l-31 7.8 7.8 31L318.6 353l7.8 31 31-7.8L449 353.4l31-7.8zm-130.3-.4l-22.9-91.5 91.5-22.9 22.9 91.5-91.5 22.9z'
      
    ]
  };

  

  
  

  var faLocationCrosshairsSlash = {
    prefix: 'fasl',
    iconName: 'location-crosshairs-slash',
    icon: [
      640,
      512,
      ["location-slash"],
      'f603',
      
      'M395.5 397.1C373 409.2 347.3 416 320 416c-88.4 0-160-71.6-160-160c0-14 1.8-27.7 5.2-40.7l-27-21.3c-5 14.6-8.2 30-9.6 46H80 64v32H80h48.7c7.7 93.3 82.1 167.6 175.3 175.3V496v16h32V496 447.3c31.6-2.6 61-12.9 86.4-28.9l-27-21.3zM304 64.7c-31.6 2.6-61 12.9-86.4 28.9l27 21.3C267 102.8 292.7 96 320 96c88.4 0 160 71.6 160 160c0 14-1.8 27.7-5.2 40.7l27 21.3c5-14.6 8.2-30 9.6-46H560h16V240H560 511.3C503.6 146.7 429.3 72.4 336 64.7V16 0H304V16 64.7zM320 352c5.6 0 11.2-.5 16.5-1.4l-55.7-44c-.3-.2-.6-.5-.9-.7l-55.7-44c3 50.3 44.8 90.1 95.8 90.1zM303.5 161.4l55.7 44c.3 .2 .6 .5 .9 .7l55.7 44C412.8 199.8 371 160 320 160c-5.6 0-11.2 .5-16.5 1.4zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  
    var faLocationSlash = faLocationCrosshairsSlash;
  

  
  

  var faSteak = {
    prefix: 'fasl',
    iconName: 'steak',
    icon: [
      576,
      512,
      [129385],
      'f824',
      
      'M368 32c-31 0-57 9.9-77.4 28.9L268.8 37.4C295.7 12.4 329.7 0 368 0c65 0 117.7 39 150.5 80c33.9 42.4 57.5 99.6 57.5 160c0 83.9-55.1 152.8-113.4 196.2C402.1 481.2 321.7 512 240 512H32 0V480 360c0-38.6 17.8-68.3 42.5-88.1c19.6-15.8 41.4-26.8 63.3-37.8c27.3-13.8 54.6-27.6 77.7-50.7c13.8-13.8 19.7-27.9 30-52.9c3.2-7.7 6.8-16.5 11.2-26.6c7.7-17.6 20.6-44.7 44.1-66.5l21.8 23.4c-18.4 17.1-29.1 39-36.5 55.9c-4.3 9.8-7.8 18.3-11 26l-1.1 2.6c-9.5 23-17.5 42.4-35.9 60.7c-24.6 24.6-52.8 39.8-77.6 52.4c-2.8 1.4-5.5 2.8-8.2 4.2l0 0 0 0c-22.2 11.2-40.9 20.7-57.8 34.3C44.4 311.4 32 332.3 32 360V480H240c74 0 147.9-28.1 203.5-69.5C497.9 370 544 309.5 544 240c0-52.2-20.6-102.6-50.5-140C464.1 63.3 419.7 32 368 32zM352 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM121.9 297.7c28.3-11.9 65.5-27.6 106.8-69c23.4-23.4 35.6-52.6 47.2-81.3l.1-.2 0 0c2.4-5.9 4.8-11.9 7.3-17.6c7.1-16.3 15.7-32.9 29-45.3c14-13 32-20.3 55.6-20.3c38.6 0 74.7 23.8 100.5 56c26 32.5 43.5 75.9 43.5 120c0 55.2-37.2 107.3-87.6 144.8C373.6 422.6 306.3 448 240 448H96 64V416 360c0-7.5 1.1-15.6 4.7-23.6c3.7-8.3 9.1-13.9 13.5-17.7c10.2-8.6 24.2-14.6 37.6-20.2l.8-.3 0 0 1.2-.5 0 0zm12.4 29.5l-1.2 .5c-15.2 6.4-24.3 10.5-30.2 15.5C98.6 346.8 96 351 96 360v24 32h32H240c58.6 0 119.4-22.6 165.3-56.8C451.7 324.6 480 280.8 480 240c0-35.9-14.5-72.5-36.5-100c-22.2-27.8-50.1-44-75.5-44c-16.3 0-26.3 4.7-33.9 11.7c-8.2 7.6-14.6 19-21.5 34.7c-2.3 5.3-4.6 11-7.1 17c-11.4 28.1-25.6 63.2-54.3 91.9c-45.8 45.8-87.7 63.5-117 75.8z'
      
    ]
  };

  

  
  

  var faBullhorn = {
    prefix: 'fasl',
    iconName: 'bullhorn',
    icon: [
      512,
      512,
      [128226,128363],
      'f0a1',
      
      'M418.8 0l6 0L432 0l16 0V16 464v16l-16 0-7.2 0-6 0-4.5-4-62.1-54.5c-44.7-39.2-100.9-62.6-160.2-66.8V496v16H176 80 64V496 352H16 0V336 144 128H16 143.6l44.4-2.5c60.7-3.4 118.5-27 164.2-67.1L414.3 4l4.5-4zM96 352V480h64V352.9l-16.4-.9H96zM416 45L373.3 82.5c-42.4 37.2-94.1 61.7-149.3 71.1V326.4c55.1 9.4 106.9 33.9 149.3 71.1L416 435V45zM192 322.6V157.3c-.8 0-1.5 .1-2.3 .1L144.9 160l-.4 0H144 32V320H144h.4l.4 0 44.8 2.5c.8 0 1.5 .1 2.3 .1zM512 192v16 64 16H480V272 208 192h32z'
      
    ]
  };

  

  
  

  var faBoxCheck = {
    prefix: 'fasl',
    iconName: 'box-check',
    icon: [
      448,
      512,
      [],
      'f467',
      
      'M42.1 160H208V64H84.8L42.1 160zM208 192H32V448H416V192H240 208zM363.2 64H240v96H405.9L363.2 64zM64 32H384l64 144V448v32H416 32 0V448 176L64 32zM331.3 251.3l-128 128L192 390.6l-11.3-11.3-64-64L105.4 304 128 281.4l11.3 11.3L192 345.4 308.7 228.7 320 217.4 342.6 240l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faTamale = {
    prefix: 'fasl',
    iconName: 'tamale',
    icon: [
      320,
      512,
      [129748],
      'e451',
      
      'M295.4 304H263l22.5 145.9c-4.4 2.7-10 5.8-16.9 9C246.7 469 211.3 480 160 480s-86.7-11-108.6-21.1c-6.9-3.2-12.5-6.3-16.9-9L57 304H24.6L0 464s48 48 160 48s160-48 160-48L295.4 304zM320 48s-48-48-160-48S0 48 0 48L24.6 208H57L34.5 62.1c4.4-2.7 10-5.8 16.9-9C73.3 42.9 108.7 32 160 32s86.7 10.9 108.6 21.1c6.9 3.2 12.5 6.3 16.9 9L263 208h32.4L320 48zM8 240v32H24 128L99.2 310.4l-9.6 12.8 25.6 19.2 9.6-12.8L160 282.7l35.2 46.9 9.6 12.8 25.6-19.2-9.6-12.8L192 272H296h16V240H296 160 24 8zM176 56H144V72 208h16 16V72 56zm-6.4 292.8L160 336l-9.6 12.8-6.4 8.5V440v16h32V440 357.3l-6.4-8.5zM95.9 78.6L94.5 62.6 62.6 65.5l1.4 15.9L75.6 208h32.1L95.9 78.6zm5.6 293.6L71.4 349.6l-7.4 81-1.4 15.9 31.9 2.9 1.4-15.9 5.6-61.3zm147.1-22.6l-30.1 22.6 5.6 61.3 1.4 15.9 31.9-2.9-1.4-15.9-7.4-81zM212.3 208h32.1L255.9 81.4l1.4-15.9-31.9-2.9-1.4 15.9L212.3 208z'
      
    ]
  };

  

  
  

  var faHatSanta = {
    prefix: 'fasl',
    iconName: 'hat-santa',
    icon: [
      640,
      512,
      [],
      'f7a7',
      
      'M422.7 202.6L384 192l14.9 37.2L435.2 320H400.7L354.3 203.9l-13.2-33 18.7-18.7 32.6 8.9 70.8 19.3 2 14.7 2.6 19.4-.2 .3-44.9-12.3zm11.7-111l57.2 67.6-30.8 3.4 1.6 11.5L410 112.3C384.1 81.7 346 64 305.9 64c-55.7 0-105.9 33.9-126.5 85.7L111.3 320H76.8l72.9-182.2C175.2 73.9 237.1 32 305.9 32c49.5 0 96.5 21.8 128.5 59.6zM480 384H32v64H480V384zM32 352H480h32v32 64 32H480 32 0V448 384 352H32zM575.2 180.6l1 .8 1.3-.2 31.7-4.3 3.5 31.8 .1 1.3 1 .8 25.5 19.4-20 25-.8 1 .2 1.3 4.3 31.7-31.8 3.5-1.3 .1-.8 1-19.4 25.5-25-20-1-.8-1.3 .2-31.7 4.3-3.5-31.8-.1-1.3-1-.8-25.5-19.4 20-25 .8-1-.2-1.3-4.3-31.7 31.8-3.5 1.3-.1 .8-1 19.4-25.5 25 20zm5.3 32.5L566.9 215l-10.7-8.6-.4-.3-.3 .4-8.3 10.9-13.6 1.5-.5 .1 .1 .5 1.8 13.6-8.6 10.7-.3 .4 .4 .3 10.9 8.3 1.5 13.6 .1 .5 .5-.1 13.6-1.8 10.7 8.6 .4 .3 .3-.4 8.3-10.9 13.6-1.5 .5-.1-.1-.5L585 246.9l8.6-10.7 .3-.4-.4-.3-10.9-8.3-1.5-13.6-.1-.5-.5 .1z'
      
    ]
  };

  

  
  

  var faArrowLeftToBracket = {
    prefix: 'fasl',
    iconName: 'arrow-left-to-bracket',
    icon: [
      512,
      512,
      [],
      'e669',
      
      'M164.7 267.3L153.4 256l11.3-11.3 128-128L304 105.4 326.6 128l-11.3 11.3L214.6 240 496 240l16 0 0 32-16 0-281.4 0L315.3 372.7 326.6 384 304 406.6l-11.3-11.3-128-128zM176 448l16 0 0 32-16 0L16 480 0 480l0-16L0 48 0 32l16 0 160 0 16 0 0 32-16 0L32 64l0 384 144 0z'
      
    ]
  };

  

  
  

  var faKey = {
    prefix: 'fasl',
    iconName: 'key',
    icon: [
      512,
      512,
      [128273],
      'f084',
      
      'M192 176c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144c-11.1 0-22-1.3-32.4-3.6l-8.6-2-6.3 6.3L257.4 352H208 192v16 48H144 128v16 48H32V398.6L194.8 235.8l6.9-6.9-2.9-9.3c-4.4-13.8-6.7-28.4-6.7-43.7zM336 0C238.8 0 160 78.8 160 176c0 15.1 1.9 29.8 5.5 43.9L4.7 380.7 0 385.4V392 496v16H16 144h16V496 448h48 16V432 384h40 6.6l4.7-4.7 30-30c10 1.8 20.2 2.7 30.7 2.7c97.2 0 176-78.8 176-176S433.2 0 336 0zm32 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faWavePulse = {
    prefix: 'fasl',
    iconName: 'wave-pulse',
    icon: [
      640,
      512,
      ["heart-rate"],
      'f5f8',
      
      'M341 0l2.7 12.7L417.9 369l47-134.3 3.8-10.7H480 624h16v32H624 491.4L439.1 405.3 435.4 416H424 408 395l-2.7-12.7L320.9 60.2 247.8 498.6 245.6 512H232 216 203.1l-2.8-12.6L147.1 256H16 0V224H16 160h12.9l2.8 12.6L223 452.9 296.2 13.4 298.4 0 312 0l16 0 13 0z'
      
    ]
  };

  
    var faHeartRate = faWavePulse;
  

  
  

  var faHighlighter = {
    prefix: 'fasl',
    iconName: 'highlighter',
    icon: [
      576,
      512,
      [],
      'f591',
      
      'M263.4 416H336L560 80 480 0 144 224v72.6L94.6 346 72 368.6 88.4 385 4.7 468.7 0 473.4V480v16 16H16 128h6.6l4.7-4.7L175 471.6 191.4 488 214 465.4 263.4 416zm-111 33l-31 31H38.6L111 407.6 152.4 449zm39-6.2l-74.1-74.1 49.4-49.4 9.4-9.4V296.6 241.1l35.1-23.4L342.3 348.9 318.9 384H263.4 250.1l-9.4 9.4-49.4 49.4zm46.9-243.1L475.9 41.2l42.9 42.9L360.4 321.7 238.2 199.6z'
      
    ]
  };

  

  
  

  var faSquareCaretLeft = {
    prefix: 'fasl',
    iconName: 'square-caret-left',
    icon: [
      448,
      512,
      ["caret-square-left"],
      'f191',
      
      'M32 448l384 0 0-384L32 64l0 384zM0 480l0-32L0 64 0 32l32 0 384 0 32 0 0 32 0 384 0 32-32 0L32 480 0 480zm288-96l-32 0-8 0L128 256 248 128l8 0 32 0 0 32 0 192 0 32zM171.9 256L256 345.7l0-179.5L171.9 256z'
      
    ]
  };

  
    var faCaretSquareLeft = faSquareCaretLeft;
  

  
  

  var faLightSwitch = {
    prefix: 'fasl',
    iconName: 'light-switch',
    icon: [
      384,
      512,
      [],
      'e017',
      
      'M176 48V32H32V480H176V464 448h32v16 16H352V32H208V48 64H176V48zM0 0H32 352h32V32 480v32H352 32 0V480 32 0zM96 240V128 96h32H256h32v32V240v32V384v32H256 128 96V384 272 240zm32 32V384H256V272H128zm0-32H256V128H128V240z'
      
    ]
  };

  

  
  

  var faBuildingUser = {
    prefix: 'fasl',
    iconName: 'building-user',
    icon: [
      640,
      512,
      [],
      'e4da',
      
      'M32 32H352V432.2L384 359V32 0H352 32 0V32 480v32H32h96 32 64 32 61.1l14-32H256V400 368H224 160 128v32 80H32V32zM160 480V400h64v80H160zM64 96v16 64 16H80h64 16V176 112 96H144 80 64zm32 32h32v32H96V128zM240 96H224v16 64 16h16 64 16V176 112 96H304 240zm16 64V128h32v32H256zM64 224v16 64 16H80h64 16V304 240 224H144 80 64zm32 32h32v32H96V256zm144-32H224v16 64 16h16 64 16V304 240 224H304 240zm16 64V256h32v32H256zm152 96l-8.4 19.2-28 64L366 480l-14 32h34.9 14H591.1h14H640l-14-32-5.6-12.8-28-64L584 384H563.1 496 428.9 408zm183.1 96H556.1 435.9 400.9l14-32 14-32H563.1l14 32 14 32zM576 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-128 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faVanShuttle = {
    prefix: 'fasl',
    iconName: 'van-shuttle',
    icon: [
      640,
      512,
      [128656,"shuttle-van"],
      'f5b6',
      
      'M16 32H0V48 368v16H16 64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h48 16V368 208v-6.1l-4.1-4.6-144-160L487.1 32H480 368 176 16zM480 288c-41.8 0-77.4 26.7-90.5 64H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H32V224H176 368 608V352H570.5c-13.2-37.3-48.7-64-90.5-64zM32 192V64H160V192H32zm160 0V64H352V192H192zm192 0V64h88.9L588.1 192H384zm32 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM160 320a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  
    var faShuttleVan = faVanShuttle;
  

  
  

  var faDumpster = {
    prefix: 'fasl',
    iconName: 'dumpster',
    icon: [
      576,
      512,
      [],
      'f793',
      
      'M304 64H410.4l18.2 96H304V64zM447.7 192h.6H510h32.2 1.1H576l-6.4-32L544 32H424c-.2 0-.4 0-.6 0H288l0 0 0 0H152.3c-.2 0-.4 0-.6 0H32L6.4 160 0 192H32.6h1.1H66h61.7 .6L288 192l159.7 0zM69.8 224H37.5l3.8 32H16 0v32H16 45.1L64 448.9V464v16H96V464 448H480v16 16h32V464 448.9L530.9 288H560h16V256H560 534.7l3.8-32H506.2L483.7 416H92.3L69.8 224zM272 64v96H147.3l18-96H272zM132.7 64l-18 96H39L58.2 64h74.5zm385 0L537 160H461.2L443 64h74.8z'
      
    ]
  };

  

  
  

  var faArrowDownToArc = {
    prefix: 'fasl',
    iconName: 'arrow-down-to-arc',
    icon: [
      512,
      512,
      [],
      'e4ae',
      
      'M256 480c123.7 0 224-100.3 224-224l0-16 32 0 0 16c0 141.4-114.6 256-256 256S0 397.4 0 256l0-16 32 0 0 16c0 123.7 100.3 224 224 224zM396 202.6l-128 144-12 13.5-12-13.5-128-144-10.6-12 23.9-21.3 10.6 12L240 293.9 240 16l0-16 32 0 0 16 0 277.9L372 181.4l10.6-12 23.9 21.3-10.6 12z'
      
    ]
  };

  

  
  

  var faLightEmergency = {
    prefix: 'fasl',
    iconName: 'light-emergency',
    icon: [
      448,
      512,
      [],
      'e41f',
      
      'M352 320V192c0-70.7-57.3-128-128-128S96 121.3 96 192V320H64V192c0-88.4 71.6-160 160-160s160 71.6 160 160V320H352zM32 384v64H416V384H32zm0-32H416h32v32 64 32H416 32 0V448 384 352H32zM160 192H128c0-53 43-96 96-96v32c-35.3 0-64 28.7-64 64z'
      
    ]
  };

  

  
  

  var faToiletPaperUnder = {
    prefix: 'fasl',
    iconName: 'toilet-paper-under',
    icon: [
      512,
      512,
      ["toilet-paper-reverse"],
      'e2a0',
      
      'M32 192c0-46.5 10.3-87.7 26.2-116.8C74.4 45.5 94.1 32 112 32H337.3c-7.2 8.2-13.6 17.7-19.2 27.9C299.2 94.5 288 141.2 288 192s11.2 97.5 30.1 132.1c5.6 10.2 12 19.6 19.2 27.9H112c-17.9 0-37.6-13.5-53.8-43.2C42.3 279.7 32 238.5 32 192zM346.2 75.2C362.4 45.5 382.1 32 400 32s37.6 13.5 53.8 43.2C469.7 104.3 480 145.5 480 192s-10.3 87.7-26.2 116.8C437.6 338.5 417.9 352 400 352s-37.6-13.5-53.8-43.2C330.3 279.7 320 238.5 320 192s10.3-87.7 26.2-116.8zM480 327.6V480H160V416H128v80 16h16H496h16V496 192c0-50.8-11.2-97.5-30.1-132.1C463.4 25.9 435.1 0 400 0H112C76.9 0 48.6 25.9 30.1 59.9C11.2 94.5 0 141.2 0 192s11.2 97.5 30.1 132.1C48.6 358.1 76.9 384 112 384H400c33.9 0 61.4-24.1 80-56.4zM385.5 212.4c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6s-11.9-11.3-14.5-27.6zM431.4 256c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16s26.6-9.9 31.4-16zM96 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  
    var faToiletPaperReverse = faToiletPaperUnder;
  

  
  

  var faSchoolCircleCheck = {
    prefix: 'fasl',
    iconName: 'school-circle-check',
    icon: [
      640,
      512,
      [],
      'e56b',
      
      'M160 96H32 0v32V480v32H32 256h32 64 32 10.8c-12.9-9.1-24.5-19.9-34.6-32H352 320 288V384c0-17.7 14.3-32 32-32l.7 0c1-10.9 2.9-21.5 5.8-31.7c-2.1-.2-4.3-.3-6.5-.3c-35.3 0-64 28.7-64 64v96H32V128H160c5.8 0 11.5-1.6 16.5-4.6L320 37.3l143.5 86.1c5 3 10.7 4.6 16.5 4.6H608V232.2c12.1 10 22.9 21.7 32 34.6V128 96H608 480L320 0 160 96zM340.3 285.8c16.5-31.3 42.2-57 73.5-73.5c1.4-6.5 2.2-13.3 2.2-20.3c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c7 0 13.8-.7 20.3-2.2zM112 160H96v16 96 16h16 64 16V272 176 160H176 112zm16 96V192h32v64H128zM96 320v16 96 16h16 64 16V432 336 320H176 112 96zm32 32h32v64H128V352zM320 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 32V144H304v16 32 16h16 24 16V176H344h-8V160zm160 96a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm78.6-176L552 313.4l-11.3 11.3L480 385.4l-28.7-28.7L440 345.4 417.4 368l11.3 11.3 40 40L480 430.6l11.3-11.3 72-72L574.6 336z'
      
    ]
  };

  

  
  

  var faComma = {
    prefix: 'fasl',
    iconName: 'comma',
    icon: [
      192,
      512,
      [],
      '2c',
      
      'M136 366.6L62.6 480H52.9L75.8 320H136v46.6zM48 288L20.6 480 16 512H48.3 80l88-136V320 288H136 48z'
      
    ]
  };

  

  
  

  var faSensor = {
    prefix: 'fasl',
    iconName: 'sensor',
    icon: [
      448,
      512,
      [],
      'e028',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM128 144V272v16H96V272 144 128h32v16zm64 0V272v16H160V272 144 128h32v16z'
      
    ]
  };

  

  
  

  var faUser = {
    prefix: 'fasl',
    iconName: 'user',
    icon: [
      448,
      512,
      [62144,128100],
      'f007',
      
      'M320 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM43.3 480H404.7L360.4 336H87.6L43.3 480zM64 304H384l54.2 176 9.8 32H414.5 33.5 0l9.8-32L64 304z'
      
    ]
  };

  

  
  

  var faRotateReverse = {
    prefix: 'fasl',
    iconName: 'rotate-reverse',
    icon: [
      512,
      512,
      [],
      'e631',
      
      'M82.9 288C98 369.9 169.7 432 256 432c52.7 0 99.9-23.1 132.2-59.8l-37.6-37.6L328 312l22.6-22.6L352 288h96 32v32 96l-1.4 1.4L456 440l-22.6-22.6-22.5-22.5C372.8 437.3 317.5 464 256 464C152 464 65.8 387.7 50.4 288H82.9zm18.2-170.9C139.2 74.7 194.5 48 256 48c104 0 190.2 76.3 205.6 176H429.1C414.1 142.1 342.3 80 256 80c-52.7 0-99.9 23.1-132.2 59.8l37.6 37.6L184 200l-22.6 22.6L160 224H64 32V192 96l1.4-1.4L56 72 78.6 94.6l22.5 22.5zM381.3 320L448 386.7V320H381.3zM64 192h66.7L64 125.3V192z'
      
    ]
  };

  

  
  

  var faBadgePercent = {
    prefix: 'fasl',
    iconName: 'badge-percent',
    icon: [
      512,
      512,
      [],
      'f646',
      
      'M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4l6.2 11.7 12.6-3.9c25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1l-3.9 12.6 11.7 6.2C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4l-11.7 6.2 3.9 12.6c7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4l-12.6-3.9-6.2 11.7C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4l-6.2-11.7-12.6 3.9c-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1l3.9-12.6-11.7-6.2C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4l11.7-6.2-3.9-12.6c-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4l12.6 3.9 6.2-11.7zM256 0c-36.1 0-68 18.1-87.1 45.6c-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4C188 493.9 219.9 512 256 512s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9C493.9 324 512 292.1 512 256s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zM358.6 176L336 153.4l-11.3 11.3-160 160L153.4 336 176 358.6l11.3-11.3 160-160L358.6 176zM192 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM320 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faBridgeCircleExclamation = {
    prefix: 'fasl',
    iconName: 'bridge-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e4ca',
      
      'M48 32h64 32 96 32 96 32 96 32 64 16V64H592 528v64h64 16v32H592 528 496 400 368 272 240 144 112 48 32V128H48h64V64H48 32V32H48zM496 64H400v64h96V64zM368 64H272v64h96V64zM240 64H144v64h96V64zM48 240H64c53 0 96 43 96 96V448h64V336c0-53 43-96 96-96c16.1 0 31.2 4 44.6 10.9c-7.2 8.1-13.7 16.9-19.3 26.2c-7.7-3.3-16.3-5.2-25.2-5.2c-35.3 0-64 28.7-64 64V464v16H240 144 128V464 336c0-35.3-28.7-64-64-64H48 32V240H48zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 80H480V416h32v32zm0-160v16 80 16H480V384 304 288h32z'
      
    ]
  };

  

  
  

  var faPenClip = {
    prefix: 'fasl',
    iconName: 'pen-clip',
    icon: [
      512,
      512,
      ["pen-alt"],
      'f305',
      
      'M0 512l6.8-34L32 352 276.7 107.3 240 70.6 131.3 179.3 120 190.6 97.4 168l11.3-11.3 120-120L240 25.4l11.3 11.3 48 48 62.1-62.1L384 0l22.6 22.6 82.7 82.7L512 128l-22.6 22.6-62.1 62.1 0 0-22.6 22.6 0 0L160 480 34 505.2 0 512zM404.7 190.1L466.7 128 384 45.3l-62.1 62.1 82.7 82.7zM299.3 129.9L61.5 367.8 40.8 471.2l103.4-20.7L382.1 212.7l-82.7-82.7z'
      
    ]
  };

  
    var faPenAlt = faPenClip;
  

  
  

  var faH3 = {
    prefix: 'fasl',
    iconName: 'h3',
    icon: [
      640,
      512,
      [],
      'f315',
      
      'M32 80V64H0V80 256 432v16H32V432 272H288V432v16h32V432 256 80 64H288V80 240H32V80zM600 64H400 384V96h16H560L421 228.4l-5 4.7V256h16 96c44.2 0 80 35.8 80 80s-35.8 80-80 80H456.6c-19.9 0-36.8-14.6-39.6-34.3l-1.1-7.9-31.7 4.5 1.1 7.9c5.1 35.5 35.4 61.8 71.3 61.8H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H472L611 91.6l5-4.7V64H600z'
      
    ]
  };

  

  
  

  var faBowlChopsticksNoodles = {
    prefix: 'fasl',
    iconName: 'bowl-chopsticks-noodles',
    icon: [
      512,
      512,
      [],
      'e2ea',
      
      'M192 93.1V60.5 32 16h32V32 54.1 86.7v59.4 32.1V224H479.9 512l-1.9 32-1.7 29.2C503.5 368.1 454 438.2 384 472.9V480v32H352 160 128V480v-7.1C58 438.2 8.5 368.1 3.6 285.2L1.9 256 0 224H32.1 128V184.6L17.1 192 14.9 160 128 152.5V105.9L19.1 127.7 12.9 96.3 128 73.3V48 32h32V48 66.9 99.5v50.8 32.1V224h32V180.3 148.2 93.1zM256 144L494.9 128l2.1 31.9L256 176V144zm0-96.3L492.9 .3l6.3 31.4L256 80.3V47.7zM160 472.9V480H352v-7.1V453l17.8-8.8c60.1-29.7 102.5-89.9 106.6-160.9l1.6-27.3H33.9l1.6 27.3c4.2 71 46.6 131.2 106.6 160.9L160 453v19.9z'
      
    ]
  };

  

  
  

  var faPizza = {
    prefix: 'fasl',
    iconName: 'pizza',
    icon: [
      576,
      512,
      [127829],
      'f817',
      
      'M391.8 120.2l22.6-22.6L437 75c-7.6-7.6-15.6-14.6-24-21.2C369.6 20.1 315.2 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c59.2 0 113.6-20.1 157-53.8c8.5-6.6 16.5-13.7 24-21.2l-22.6-22.6-22.6-22.6-22.6-22.6-90.5-90.5L256 256l22.6-22.6 90.5-90.5 22.6-22.6zM367.2 99.5C335.9 77.1 297.5 64 256 64C150 64 64 150 64 256s86 192 192 192c41.5 0 79.9-13.1 111.2-35.5l22.9 22.9C352.7 463.4 306.3 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c50.3 0 96.7 16.6 134.2 44.6L367.2 99.5zm-23 290C318.9 406.2 288.6 416 256 416c-88.4 0-160-71.6-160-160s71.6-160 160-160c32.6 0 62.9 9.8 88.2 26.5L233.4 233.4 210.7 256l22.6 22.6L344.2 389.5zm155.2 .7l-22.9-22.9C498.9 335.9 512 297.5 512 256s-13.1-79.9-35.5-111.2l22.9-22.9c28 37.4 44.6 83.8 44.6 134.2s-16.6 96.7-44.6 134.2zM480 256c0 32.6-9.8 62.9-26.5 88.2L365.3 256l88.2-88.2C470.2 193.1 480 223.4 480 256zM342.6 233.4L320 256l22.6 22.6 90.5 90.5 0 0 22.6 22.6 0 0 22.6 22.6L501 437c7.6-7.6 14.6-15.6 21.2-24c33.7-43.3 53.8-97.8 53.8-157s-20.1-113.6-53.8-157c-6.6-8.4-13.6-16.5-21.2-24l0 0L478.4 97.6l-22.6 22.6-22.6 22.6-90.5 90.5zM160 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-112a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faE = {
    prefix: 'fasl',
    iconName: 'e',
    icon: [
      320,
      512,
      [101],
      '45',
      
      'M16 32H0V48 256 464v16H16 304h16V448H304 32V272H240h16V240H240 32V64H304h16V32H304 16z'
      
    ]
  };

  

  
  

  var faLambda = {
    prefix: 'fasl',
    iconName: 'lambda',
    icon: [
      448,
      512,
      [],
      'f66e',
      
      'M16 32H0V64H16 149.8l12.1 26.2-.7-.3L1.4 480H36L179.8 129 337.5 470.7l4.3 9.3H352h80 16V448H432 362.2L174.5 41.3 170.2 32H160 16z'
      
    ]
  };

  

  
  

  var faWandMagicSparkles = {
    prefix: 'fasl',
    iconName: 'wand-magic-sparkles',
    icon: [
      576,
      512,
      ["magic-wand-sparkles"],
      'e2ca',
      
      'M150.6 489.4L128 512l-22.6-22.6L54.6 438.6 32 416l22.6-22.6L425.4 22.6 448 0l22.6 22.6 50.7 50.7L544 96l-22.6 22.6L150.6 489.4zM498.7 96L448 45.3 337.9 155.3l50.7 50.7L498.7 96zM128 466.7L366.1 228.7l-50.7-50.7L77.3 416 128 466.7zM252.2 3.8V16 35.8H272h12.2V60.2H272 252.2V80 92.2H227.8V80 60.2H208 195.8V35.8H208h19.8V16 3.8h24.3zM128 80v48h48 16v32H176 128v48 16H96V208 160H48 32V128H48 96V80 64h32V80zM480 336v48h48 16v32H528 480v48 16H448V464 416H400 384V384h16 48V336 320h32v16z'
      
    ]
  };

  
    var faMagicWandSparkles = faWandMagicSparkles;
  

  
  

  var faGauge = {
    prefix: 'fasl',
    iconName: 'gauge',
    icon: [
      512,
      512,
      ["dashboard","gauge-med","tachometer-alt-average"],
      'f624',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62l0-194 0-16-32 0 0 16 0 194c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64zM144 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm296 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM392 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faDashboard = faGauge;
  
    var faGaugeMed = faGauge;
  
    var faTachometerAltAverage = faGauge;
  

  
  

  var faVial = {
    prefix: 'fasl',
    iconName: 'vial',
    icon: [
      512,
      512,
      [129514],
      'f492',
      
      'M312 1.4l11.3 11.3 24 24 128 128 24 24L510.6 200 488 222.6l-11.3-11.3L464 198.6l-84.7 84.7L181.8 480.8c-20 20-47.1 31.2-75.3 31.2C47.7 512 0 464.3 0 405.5c0-28.2 11.2-55.3 31.2-75.3l69.5-69.5L313.4 48 300.7 35.3 289.4 24 312 1.4zm24 69.3L150.6 256H361.4l80-80L336 70.6zM329.4 288H118.6L53.8 352.8c-14 14-21.8 32.9-21.8 52.7c0 41.1 33.4 74.5 74.5 74.5c19.8 0 38.7-7.8 52.7-21.8L329.4 288z'
      
    ]
  };

  

  
  

  var faSquareBolt = {
    prefix: 'fasl',
    iconName: 'square-bolt',
    icon: [
      448,
      512,
      [],
      'e265',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm264 80h8 18.4l-2.6 18.3L274.4 224H320h16v16 8 6.6l-4.7 4.7-136 136-4.7 4.7H184h-8H157.6l2.6-18.3L173.6 288H128 112V272v-8-6.6l4.7-4.7 136-136 4.7-4.7H264zM158.6 256H192h18.4l-2.6 18.3-10.5 73.8L289.4 256H256 237.6l2.6-18.3 10.5-73.8L158.6 256z'
      
    ]
  };

  

  
  

  var faLeafOak = {
    prefix: 'fasl',
    iconName: 'leaf-oak',
    icon: [
      512,
      512,
      [],
      'f6f7',
      
      'M512 248l-47.3 14.2L432 272l20.5 27.3L480 336l-48 48-60.3-5L336 376l13.3 33.2L352 416l-64 64-96-48H112h-9.4L38.5 496.1 27.2 507.4 4.6 484.8l11.3-11.3L80 409.4V400l0-80L32 224l64-64 6.8 2.7L136 176l-3-35.7L128 80l48-48 36.7 27.5L240 80l9.8-32.7L264 0h72l32 48 64-16 48 48-16 64 48 32v72zM134.6 400H192h7.6l6.8 3.4 75.4 37.7 32.8-32.8-8.2-20.4-19.2-48.1 51.6 4.3 81.2 6.8L437.7 333l-31.3-41.8-27.5-36.7 43.9-13.2L480 224.2V193.1l-33.8-22.5-18.8-12.5 5.5-21.9 11.6-46.4L422.2 67.4 375.8 79l-21.9 5.5L341.4 65.8 318.9 32H287.8L270.7 89.2l-13.2 43.9-36.7-27.5L179 74.3 161.1 92.1l6.8 81.2 4.3 51.6-48.1-19.2-20.4-8.2L70.9 230.3l37.7 75.4 3.4 6.8V320l0 57.4L285.6 203.8l11.3-11.3 22.6 22.6-11.3 11.3L134.6 400z'
      
    ]
  };

  

  
  

  var faMarsStroke = {
    prefix: 'fasl',
    iconName: 'mars-stroke',
    icon: [
      512,
      512,
      [9894],
      'f229',
      
      'M368 0H352V32h16 89.4L384 105.4 347.3 68.7 336 57.4 313.4 80l11.3 11.3L361.4 128l-40.7 40.7C290.1 143.3 250.8 128 208 128c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-42.8-15.3-82.1-40.7-112.6L384 150.6l36.7 36.7L432 198.6 454.6 176l-11.3-11.3L406.6 128 480 54.6V144v16h32V144 16 0H496 368zM64 304a144 144 0 1 1 288 0A144 144 0 1 1 64 304z'
      
    ]
  };

  

  
  

  var faCircleParking = {
    prefix: 'fasl',
    iconName: 'circle-parking',
    icon: [
      512,
      512,
      ["parking-circle"],
      'f615',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 128h96c53 0 96 43 96 96s-43 96-96 96H208v48 16H176V368 304 144 128h16zm96 160c35.3 0 64-28.7 64-64s-28.7-64-64-64H208V288h80z'
      
    ]
  };

  
    var faParkingCircle = faCircleParking;
  

  
  

  var faCrutches = {
    prefix: 'fasl',
    iconName: 'crutches',
    icon: [
      640,
      512,
      [],
      'f7f8',
      
      'M188.7 12.7L200 1.4 222.6 24 211.3 35.3 198.6 48l98.7 98.7-22.6 22.6L176 70.6 70.6 176 176 281.4l64.5-64.5-11.3 56.6L198.6 304 219 324.4l-7.2 36-1 1-46.1-46.1L48 198.6 35.3 211.3 24 222.6 1.4 200l11.3-11.3 176-176zM384.6 407.2l37.7-7.5 77 77L510.6 488 488 510.6l-11.3-11.3-92.1-92.1zM451.3 12.7l176 176L638.6 200 616 222.6l-11.3-11.3-176-176L417.4 24 440 1.4l11.3 11.3zm-174.6 200l47.9-47.9 .1-.1 .1-.1 94-94 22.6 22.6L358.6 176 464 281.4l82.7-82.7 22.6 22.6-94.1 94.1-48 48-3.4 3.4-4.7 1-155.3 31L163.3 499.3 152 510.6 129.4 488l11.3-11.3L241.3 376.1l31-155.3 1-4.8 3.4-3.4zm26.1 19.2L276.4 363.6l131.7-26.3L441.4 304 336 198.6l-33.3 33.3z'
      
    ]
  };

  

  
  

  var faChartSimple = {
    prefix: 'fasl',
    iconName: 'chart-simple',
    icon: [
      448,
      512,
      [],
      'e473',
      
      'M256 64V448H192V64h64zM192 32H160V64 448v32h32 64 32V448 64 32H256 192zM96 256V448H32V256H96zM32 224H0v32V448v32H32 96h32V448 256 224H96 32zm320-96h64V448H352V128zM320 96v32V448v32h32 64 32V448 128 96H416 352 320z'
      
    ]
  };

  

  
  

  var faBagSeedling = {
    prefix: 'fasl',
    iconName: 'bag-seedling',
    icon: [
      512,
      512,
      [],
      'e5f2',
      
      'M89 96H423l12.6 50.3c8.2 33 12.4 66.9 12.4 100.9v17.7c0 34-4.2 67.9-12.4 100.9L423 416H89L76.4 365.7C68.2 332.7 64 298.9 64 264.8V247.2c0-34 4.2-67.9 12.4-100.9L89 96zM424.9 64H87.1L76.4 32H435.6L424.9 64zM87.1 448H424.9l10.7 32H76.4l10.7-32zM32 0L42.7 32 59.4 82.3 45.4 138.5C36.5 174 32 210.5 32 247.2v17.7c0 36.6 4.5 73.1 13.4 108.7l14.1 56.2L42.7 480 32 512H65.7 446.3 480l-10.7-32-16.8-50.3 14.1-56.2c8.9-35.5 13.4-72 13.4-108.7V247.2c0-36.6-4.5-73.1-13.4-108.7L452.6 82.3 469.3 32 480 0H446.3 65.7 32zm96 160v16 16c0 65.3 48.9 119.1 112 127v33 16h32V352 319c63.1-7.9 112-61.7 112-127V176 160H368 344.7c-37.2 0-68.9 17.9-88.7 44.5c-19.8-26.6-51.5-44.5-88.7-44.5H144 128zM272 286.7V240.4c11.7-27.9 39.1-48.4 72.7-48.4H352c0 47.6-34.6 87.1-80 94.7zm-32-46.2v46.2c-45.4-7.6-80-47.1-80-94.7h7.3c33.6 0 61 20.5 72.7 48.4z'
      
    ]
  };

  

  
  

  var faPenCircle = {
    prefix: 'fasl',
    iconName: 'pen-circle',
    icon: [
      512,
      512,
      [],
      'e20e',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM321.3 149.3L298.5 172 340 213.5l22.8-22.8-41.5-41.5zM166 304.5l-7.7 49.1 49.1-7.7L317.4 236.1l-41.5-41.5L166 304.5zM385.4 168.1L408 190.7l-22.6 22.6L222.7 376l-69.5 10.8L120 392l5.2-33.2L136 289.3 321.3 104l64.1 64.1z'
      
    ]
  };

  

  
  

  var faRadiation = {
    prefix: 'fasl',
    iconName: 'radiation',
    icon: [
      512,
      512,
      [],
      'f7b9',
      
      'M117.4 80c-44.1 34.8-74.8 85.8-83.2 144l114.4 0c5.1-17 14.1-32.4 26-44.9L117.4 80zM216 186.7c-23.9 13.8-40 39.7-40 69.3H144L32 256H0c0-10.8 .7-21.5 2-32c8.7-70 45.8-131.3 99.3-172c8.5-6.5 17.4-12.4 26.7-17.8L144 62l72 124.7zm0 138.6l.1 .1c11.7 6.8 25.4 10.6 39.9 10.6s28.1-3.9 39.9-10.6l.1-.1L312 353l72 124.7-.4 .2c-9.1 5.2-18.5 9.9-28.3 14c-30.5 12.9-64.1 20-99.3 20s-68.8-7.1-99.3-20c-9.8-4.1-19.2-8.8-28.3-14l-.4-.2L200 353l16-27.7zM256 480c29.4 0 57.5-5.7 83.2-15.9L282 365c-8.3 2-17 3-26 3s-17.6-1-26-3l-57.2 99.1C198.5 474.3 226.6 480 256 480zM410.7 52C464.2 92.7 501.3 154 510 224c1.3 10.5 2 21.2 2 32H480l-112 0H336c0-29.6-16.1-55.5-40-69.3L368 62l16-27.7c9.3 5.4 18.2 11.3 26.7 17.8zM394.6 80l-57.2 99.1c11.9 12.6 20.9 27.9 26 44.9l114.4 0c-8.3-58.2-39-109.2-83.2-144zM272 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faPlaneUpSlash = {
    prefix: 'fasl',
    iconName: 'plane-up-slash',
    icon: [
      640,
      512,
      [],
      'e22e',
      
      'M432 426v53.4L324.4 448.6l-4.4-1.3-4.4 1.3L208 479.4V440l57.6-43.2L272 392v-8V303.4v-3.8l-16.4-12.9-4.5 1.5L96 338.1V273.3L178.7 226l-27.1-21.4L72.1 250.1 64 254.7V264v96 21.9l20.9-6.7L240 325.4l0 50.6-57.6 43.2L176 424v8 64 16h16 16 2.2l2.2-.6L320 480.6l107.6 30.7 2.2 .6H432h16 16V496 451.2L432 426zM240 109.7v1.6l32 25.3V109.7c0-13.5 6.1-34.1 16.6-51.3c5.2-8.5 10.9-15.4 16.7-20C311 33.7 315.9 32 320 32c9.1 0 20.9 8.2 31.8 26.3C362.1 75.5 368 96.1 368 109.7v61.7 9.3l8.1 4.6 167.9 96v70l32 25.3V272v-9.3l-8.1-4.6L400 162.1V109.7c0-20.6-8.1-46.8-20.8-67.9C367.1 21.6 346.9 0 320 0c-13.4 0-25.2 5.7-34.8 13.3c-9.5 7.6-17.6 17.7-24 28.4C248.4 62.7 240 89 240 109.7zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faMug = {
    prefix: 'fasl',
    iconName: 'mug',
    icon: [
      576,
      512,
      [],
      'f874',
      
      'M64 96V416H384V96H368 64zm352 0V256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H416zm0 192V416v32H384 64 32V416 96 64H64 368h16 32 48c61.9 0 112 50.1 112 112s-50.1 112-112 112H416z'
      
    ]
  };

  

  
  

  var faMicrochipAi = {
    prefix: 'fasl',
    iconName: 'microchip-ai',
    icon: [
      512,
      512,
      [],
      'e1ec',
      
      'M176 0V16 64h64V16 0h32V16 64h64V16 0h32V16 64h48 32V96v48h48 16v32H496 448v64h48 16v32H496 448v64h48 16v32H496 448v48 32H416 368v48 16H336V496 448H272v48 16H240V496 448H176v48 16H144V496 448H96 64V416 368H16 0V336H16 64V272H16 0V240H16 64V176H16 0V144H16 64V96 64H96h48V16 0h32zM416 96H96V416H416V96zm-96 80h32v16V320v16H320V320 192 176zM135.9 336l2.2-5.7L160 272.8V272h.3l32.7-85.7L197 176h22l3.9 10.3L255.7 272h.3v.8l21.9 57.5 2.2 5.7H245.9l-12.2-32H182.3l-12.2 32H135.9zM208 236.8L194.6 272h26.9L208 236.8z'
      
    ]
  };

  

  
  

  var faFileWaveform = {
    prefix: 'fasl',
    iconName: 'file-waveform',
    icon: [
      448,
      512,
      ["file-medical-alt"],
      'f478',
      
      'M416 192V480H96V384H64v96 32H96 416h32V480 152L296 0H96 64V32 288H96V32H256V176v16h16H416zm-5.3-32H288V37.3L410.7 160zM270.3 264.8L256 236.2l-14.3 28.6L189.3 369.7l-32.5-43.3L152 320h-8H16 0v32H16 136l43.2 57.6 15.5 20.7 11.6-23.2L256 307.8l17.7 35.4 4.4 8.8H288h64 16V320H352 297.9l-27.6-55.2z'
      
    ]
  };

  
    var faFileMedicalAlt = faFileWaveform;
  

  
  

  var faCreditCardBlank = {
    prefix: 'fasl',
    iconName: 'credit-card-blank',
    icon: [
      576,
      512,
      [],
      'f389',
      
      'M32 64V448H544V64H32zM0 32H32 544h32V64 448v32H544 32 0V448 64 32zM96 352h96v32H96V352zm128 0H384v32H224V352z'
      
    ]
  };

  

  
  

  var faFaceAnxiousSweat = {
    prefix: 'fasl',
    iconName: 'face-anxious-sweat',
    icon: [
      576,
      512,
      [],
      'e36a',
      
      'M288 32C174.4 32 80.6 116.5 66 226.1l-31.7-4.2C50.9 96.6 158.2 0 288 0C429.4 0 544 114.6 544 256s-114.6 256-256 256c-57.6 0-110.8-19.1-153.6-51.2l19.2-25.6C191 463.3 237.5 480 288 480c123.7 0 224-100.3 224-224S411.7 32 288 32zM391.6 272a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm15-88l-11.3 11.3-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L200 137.4 222.6 160zm142.1 11.3L353.4 160 376 137.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM192 392c0-48.6 39.4-88 88-88h16c48.6 0 88 39.4 88 88v8 16H368 208 192V400v-8zm32.6-8H351.4c-3.9-27.1-27.2-48-55.4-48H280c-28.2 0-51.6 20.9-55.4 48zM40 347.1c-5.2 5.8-8 13.3-8 21.1C32 385.6 46.3 400 64 400s32-14.4 32-31.8c0-7.8-2.9-15.3-8-21.1l-24-27-24 27zM16.1 325.9l26.5-29.8L64 272l21.4 24.1 26.5 29.8c10.4 11.7 16.1 26.7 16.1 42.4c0 35.2-28.8 63.8-64 63.8s-64-28.5-64-63.8c0-15.6 5.7-30.7 16.1-42.4z'
      
    ]
  };

  

  
  

  var faFolder = {
    prefix: 'fasl',
    iconName: 'folder',
    icon: [
      512,
      512,
      [61716,128193,128447,"folder-blank"],
      'f07b',
      
      'M272 96L224 32H32 0V64 448v32H32 480h32V448 128 96H480 272zm208 32V448H32V64H208l38.4 51.2L256 128h16H480z'
      
    ]
  };

  
    var faFolderBlank = faFolder;
  

  
  

  var faObjectsAlignTop = {
    prefix: 'fasl',
    iconName: 'objects-align-top',
    icon: [
      512,
      512,
      [],
      'e3c0',
      
      'M512 0L0 0 0 32l512 0V0zM192 160l0 320-96 0 0-320h96zM96 128l-32 0 0 32 0 320 0 32H96h96 32V480l0-320V128H192 96zm320 32l0 192H320l0-192h96zm-96-32H288v32l0 192v32h32 96 32V352l0-192V128l-32 0H320z'
      
    ]
  };

  

  
  

  var faFileCad = {
    prefix: 'fasl',
    iconName: 'file-cad',
    icon: [
      512,
      512,
      [],
      'e672',
      
      'M352 192l0 112 32 0 0-152L232 0 32 0 0 0 0 32 0 480l0 32 32 0 80 0 0-32-80 0L32 32l160 0 0 144 0 16 16 0 144 0zm-5.3-32L224 160l0-122.7L346.7 160zM200 352c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-8 0-16-32 0 0 16 0 8c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 8 0 16 32 0 0-16 0-8c0-22.1-17.9-40-40-40l-16 0zm232 0l-16 0 0 16 0 128 0 16 16 0 32 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-32 0zm16 32l16 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-16 0 0-96zm-160 8l0 56 0 48 0 16 32 0 0-16 0-32 32 0 0 32 0 16 32 0 0-16 0-48 0-56c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm32 40l0-40c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 40-32 0z'
      
    ]
  };

  

  
  

  var faTrashPlus = {
    prefix: 'fasl',
    iconName: 'trash-plus',
    icon: [
      448,
      512,
      [],
      'e2b2',
      
      'M160 0h-8.9l-4.7 7.5L111.1 64H64.1 32 0V96H34.3L64 512H384L413.7 96H448V64H416 383.9 336.9L301.6 7.5 296.9 0H288 160zM299.1 64H148.9l20-32H279.1l20 32zM93.8 480L66.4 96H381.6L354.2 480H93.8zM240 192H208v16 64H144 128v32h16 64v64 16h32V368 304h64 16V272H304 240V208 192z'
      
    ]
  };

  

  
  

  var faHeadSideGear = {
    prefix: 'fasl',
    iconName: 'head-side-gear',
    icon: [
      512,
      512,
      [],
      'e611',
      
      'M32 224C32 118 118 32 224 32h24c88.4 0 160 71.6 160 160v7.2l5.4 4.8L480 263.2V304H432 416v16 96H304 288v16 64 16h32V496 448H432h16V432 336h48 16V320 256v-7.2l-5.4-4.8-66.8-59.3C436 82 351.6 0 248 0H224C100.3 0 0 100.3 0 224c0 61 24.4 116.4 64 156.8V496v16H96V496 374.1v-6.8l-4.9-4.7C54.6 327.6 32 278.4 32 224zM176 104v16 20.8c-.8 .5-1.6 1-2.4 1.4l-15-8.1-13.7-7.4-7.8 13.5-32 55.4L96.9 210l14.5 7.8 11.5 6.2-11.5 6.2L96.9 238l8.2 14.3 32 55.4 7.8 13.5 13.7-7.4 15-8.1c.8 .5 1.6 1 2.4 1.4V328v16h16 64 16V328 307.2c.8-.5 1.6-1 2.4-1.4l15 8.1 13.7 7.4 7.8-13.5 32-55.4 8.2-14.3-14.5-7.8L325.1 224l11.5-6.2 14.5-7.8-8.2-14.3-32-55.4-7.8-13.5-13.7 7.4-15 8.1c-.8-.5-1.6-1-2.4-1.4V120 104H256 192 176zm32 32h32v14.7 10.5l9.6 4.2c5 2.2 9.6 5 13.9 8.3l8.2 6.5 9.2-5 10-5.4 16 27.7-10.8 5.8-9.2 5 .9 10.4c.1 1.8 .2 3.5 .2 5.3s-.1 3.6-.2 5.3l-.9 10.4 9.2 5 10.8 5.8-16 27.7-10-5.4-9.2-5-8.2 6.5c-4.2 3.3-8.9 6.1-13.9 8.3l-9.6 4.2v10.5V312H208V297.3 286.9l-9.6-4.2c-5-2.2-9.6-5-13.9-8.3l-8.2-6.5-9.2 5-10 5.4-16-27.7 10.8-5.8 9.2-5-.9-10.4c-.1-1.8-.2-3.5-.2-5.3s.1-3.6 .2-5.3l.9-10.4-9.2-5-10.8-5.8 16-27.7 10 5.4 9.2 5 8.2-6.5c4.2-3.3 8.9-6.1 13.9-8.3l9.6-4.2V150.7 136zm40 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faArrowUpFromBracket = {
    prefix: 'fasl',
    iconName: 'arrow-up-from-bracket',
    icon: [
      448,
      512,
      [],
      'e09a',
      
      'M235.3 12.7L224 1.4 212.7 12.7l-128 128L73.4 152 96 174.6l11.3-11.3L208 62.6 208 336l0 16 32 0 0-16 0-273.4L340.7 163.3 352 174.6 374.6 152l-11.3-11.3-128-128zM32 336l0-16L0 320l0 16L0 496l0 16 16 0 416 0 16 0 0-16 0-160 0-16-32 0 0 16 0 144L32 480l0-144z'
      
    ]
  };

  

  
  

  var faHandPointDown = {
    prefix: 'fasl',
    iconName: 'hand-point-down',
    icon: [
      384,
      512,
      [],
      'f0a7',
      
      'M48 512H32V496 272H16 0V256 160C0 71.6 71.6 0 160 0h64c88.4 0 160 71.6 160 160v0 16 64 16 48 16H368 304v16H288 224v16 16H208 144V496v16H128 48zm96-176h48V320 272H144v64zm48-96l0 0 0-48H112 96V160h16 80 16 16 48 16 16 48c0-70.7-57.3-128-128-128H160C89.3 32 32 89.3 32 160v80h80v0h32v0h48zm32 0l0 16v16l0 32h48V192H224l0 48zM112 272H64V480h48V368 352 272zm240-32V192H304v96h48V256 240z'
      
    ]
  };

  

  
  

  var faRaccoon = {
    prefix: 'fasl',
    iconName: 'raccoon',
    icon: [
      512,
      512,
      [],
      'e613',
      
      'M296 0h80 7.6l.4 .5V0h64 9.9l4.4 8.8 16 32 3 5.9-2.1 6.3L463.9 98.8l28.5 35.1 3.6 4.4V144v40 11.9l-11.4 3.4-77.7 23.3-46 30.7-4 2.7H352 320h-4.8l-4-2.7-46-30.7-77.7-23.3L176 195.9V184 144v-5.7l3.6-4.4 28.5-35.1L192.8 53.1l-2.1-6.3 3-5.9 16-32L214.1 0H224h64V.5l.4-.5H296zM233.9 32l-8.6 17.2L232 69.4 262.4 32H233.9zM446.7 49.2L438.1 32H409.6L440 69.4l6.7-20.2zM208 149.7v22.4l48.9 14.7 50-40c7.1-5.7 10.4-14.8 8.6-23.7c-3.3-16.4-21.9-24.7-36.2-16l-71 42.6-.1-.2-.1 .1zM336 93.1c15.9-20.2 44.8-27.9 69.4-15.5L368.4 32H303.6l-37 45.6c24.6-12.4 53.5-4.7 69.4 15.5zm0 69.5c-2.6 3.4-5.7 6.5-9.1 9.2L290.4 201 312 215.4c.3-13 10.9-23.4 24-23.4s23.7 10.4 24 23.4L381.6 201l-36.5-29.2c-3.4-2.7-6.5-5.8-9.1-9.2zm79.1 24.2L464 172.1V149.7l-.1-.1-.1 .2-71-42.6c-14.4-8.6-32.9-.4-36.2 16c-1.8 8.9 1.5 18 8.6 23.7l50 40zM128 267.1c12.5-15 27-28.2 43.2-39.2l7 2.1 35.2 10.6C153.5 268.6 112 329.5 112 400v16H80V400c0-16.5 1.9-32.6 5.6-48H32v48c0 44.2 35.8 80 80 80H320c0-17.7-14.3-32-32-32H240 224V416h16 48c35.3 0 64 28.7 64 64h96c0-17.7-14.3-32-32-32H400 384V416h16 16c35.3 0 64 28.7 64 64v16 16H464 112C50.1 512 0 461.9 0 400V48 32H16h96 16V48 267.1zm320 51.2c0-24.7-8.2-48.5-22.8-67.8l32.2-9.7C472 263.7 480 290.6 480 318.3l0 17.7 0 9.9-8.8 4.4-64 32-10.3 5.2-8.2-8.2-32-32L345.4 336l11.3-11.3 32-32L400 281.4 422.6 304l-11.3 11.3L390.6 336l12.5 12.5L448 326.1l0-7.8zM95.9 320l.1-.1V256H32v64H95.9zM96 160H32v64H96V160zm0-32V64H32v64H96zM315.3 347.3l-32 32-8.2 8.2-10.3-5.2-64-32-14.3-7.2 14.3-28.6 14.3 7.2 53.7 26.8 11.9-11.9-38.1-34L230.7 292 252 268.2l11.9 10.6 50.7 45.3 12.6 11.3-12 12zM272 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faOption = {
    prefix: 'fasl',
    iconName: 'option',
    icon: [
      640,
      512,
      [],
      'e318',
      
      'M464 448h-7.6l-4.8-5.9L168.4 96H16 0V64H16 176h7.6l4.8 5.9L471.6 416H624h16v32H624 464zM432 96H416V64h16H624h16V96H624 432z'
      
    ]
  };

  

  
  

  var faBacon = {
    prefix: 'fasl',
    iconName: 'bacon',
    icon: [
      576,
      512,
      [129363],
      'f7e5',
      
      'M0 352c10.5-4.7 20.5-9.4 29.9-13.9c131.3-63 155.3-104.1 181-148.2C239.1 141.4 269.6 89.2 448 0L555.6 134.5 576 160c-10.2 5.1-19.8 10-29.1 14.9C394.1 255.1 365.5 304.2 338.8 350c-27.5 47.2-53 91-210.8 162L20.6 377.8 0 352zm83 52.5c114.2-59.3 159.6-121.3 201.1-177.9l3-4c22-29.9 44-59.4 75.2-85.3c27.4-22.8 61.4-42.4 108.1-58L439.3 40.3C366.7 78.1 323.6 108 295.8 132.8c-29.8 26.7-42.8 48.3-56.2 71.3l-1.4 2.3c-13.8 23.6-29 49.8-61.6 78.5c-27.6 24.3-66.6 49.7-126.3 78.8L83 404.5zM103.4 430l34 42.5c64.5-30.5 101.5-54.8 125-75.5c24.8-21.8 35.7-40.5 49.1-63.6l.9-1.5c14.6-25 31.6-53.4 68.8-86.7c31.4-28.1 76.4-59.1 145.4-95.7l-34.8-43.5c-49.4 15.1-83 34.2-109 55.9c-27.8 23.1-47.8 49.6-69.8 79.7l-2.8 3.9C268.2 302.5 220.1 368.1 103.4 430z'
      
    ]
  };

  

  
  

  var faTrashList = {
    prefix: 'fasl',
    iconName: 'trash-list',
    icon: [
      640,
      512,
      [],
      'e2b1',
      
      'M160 0h-8.9l-4.7 7.5L111.1 64H64.1 32 0V96H34.3L64 512H352L381.7 96H416V64H384 351.9 304.9L269.6 7.5 264.9 0H256 160zM267.1 64H148.9l20-32h78.3l20 32zM93.8 480L66.4 96H349.6L322.2 480H93.8zM640 128H448v32H640V128zM608 256H448v32H608V256zM448 384v32h96V384H448z'
      
    ]
  };

  

  
  

  var faMessageCaptions = {
    prefix: 'fasl',
    iconName: 'message-captions',
    icon: [
      512,
      512,
      ["comment-alt-captions"],
      'e1de',
      
      'M160 416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448 416zm0-32h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zM80 224H304h16v32H304 80 64V224H80zm288 0h64 16v32H432 368 352V224h16zM80 288h96 16v32H176 80 64V288H80zm160 0H432h16v32H432 240 224V288h16z'
      
    ]
  };

  
    var faCommentAltCaptions = faMessageCaptions;
  

  
  

  var faSushi = {
    prefix: 'fasl',
    iconName: 'sushi',
    icon: [
      576,
      512,
      [127843,"nigiri"],
      'e48a',
      
      'M281.9 238.3l259.6 86.2L576 336l-6.3-35.8L556 222.6C539.8 130.9 460.1 64 366.9 64H209.1C115.9 64 36.2 130.9 20 222.6L6.4 299.9 0 336l34.6-12 247.3-85.7zM41 287.9l10.5-59.7c12.4-70.1 69.2-122.7 138.4-131L86.4 272.2 41 287.9zm230.4-79.9L133.2 256 227.7 96H338.6l-66 111.7-1.2 .4zm35.3 4.8L375.6 96.2c33.9 1.8 65.3 14.3 90.6 34.3L399.4 243.6l-92.6-30.8zm123.7 41.1l59.3-100.4c17.4 20.9 29.7 46.3 34.7 74.7l10.7 60.5L430.5 253.9zM32.2 358.7c3.4 49.9 45 89.3 95.8 89.3c19.2 0 37-5.6 52-15.3c15 9.7 32.8 15.3 52 15.3c20.9 0 40.2-6.7 56-18c15.8 11.3 35.1 18 56 18c19.2 0 37-5.6 52-15.3c15 9.7 32.8 15.3 52 15.3c50.7 0 92.2-39.2 95.7-89L512 348.5V352c0 35.3-28.7 64-64 64c-12.8 0-24.7-3.7-34.6-10.2L396 394.6l-17.4 11.2c-10 6.4-21.8 10.2-34.6 10.2c-14 0-26.8-4.4-37.3-12L288 390.6 269.3 404c-10.5 7.6-23.3 12-37.3 12c-12.8 0-24.7-3.7-34.6-10.2L180 394.6l-17.4 11.2c-10 6.4-21.8 10.2-34.6 10.2c-35.3 0-64-28.7-64-64v-4.3l-31.8 11z'
      
    ]
  };

  
    var faNigiri = faSushi;
  

  
  

  var faBullseye = {
    prefix: 'fasl',
    iconName: 'bullseye',
    icon: [
      512,
      512,
      [],
      'f140',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-288a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faArrowLeftToLine = {
    prefix: 'fasl',
    iconName: 'arrow-left-to-line',
    icon: [
      448,
      512,
      [8676,"arrow-to-left"],
      'f33e',
      
      'M0 432l0 16 32 0 0-16L32 80l0-16L0 64 0 80 0 432zM100.7 244.7L89.4 256l11.3 11.3 128 128L240 406.6 262.6 384l-11.3-11.3L150.6 272 256 272l176 0 16 0 0-32-16 0-176 0-105.4 0L251.3 139.3 262.6 128 240 105.4l-11.3 11.3-128 128z'
      
    ]
  };

  
    var faArrowToLeft = faArrowLeftToLine;
  

  
  

  var faLocationSmile = {
    prefix: 'fasl',
    iconName: 'location-smile',
    icon: [
      384,
      512,
      ["map-marker-smile"],
      'f60d',
      
      'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 20.2 9.1 48.6 26.5 82.7c16.9 33.2 39.9 68.2 63.4 100.5c23.4 32.2 46.9 61 64.5 81.9c1.9 2.3 3.8 4.5 5.6 6.6c1.8-2.1 3.6-4.3 5.6-6.6c17.7-20.8 41.1-49.7 64.5-81.9c23.5-32.3 46.4-67.3 63.4-100.5C342.9 240.6 352 212.2 352 192zm32 0c0 88.8-120.7 237.9-170.7 295.9C200.2 503.1 192 512 192 512s-8.2-8.9-21.3-24.1C120.7 429.9 0 280.8 0 192C0 86 86 0 192 0S384 86 384 192zM128 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM98.7 264.9l26.6-17.8C132.1 257.3 156 280 192 280s59.9-22.7 66.7-32.9l26.6 17.8c-11 16.5-43.9 47.1-93.3 47.1s-82.3-30.6-93.3-47.1z'
      
    ]
  };

  
    var faMapMarkerSmile = faLocationSmile;
  

  
  

  var faHelmetUn = {
    prefix: 'fasl',
    iconName: 'helmet-un',
    icon: [
      512,
      512,
      [],
      'e503',
      
      'M240 32c114.9 0 208 93.1 208 208v16H256 244.5l-3.6 10.9L212.5 352H32V240C32 125.1 125.1 32 240 32zm96 419.4l-93.6-88.1L267.5 288H336V451.4zM368 480V288H496h16V256H496 480V240C480 107.5 372.5 0 240 0S0 107.5 0 240V368v16H16 217.7L349 507.7l4.6 4.3H360 464h16V480H464 368zM160 112V96H128v16 64c0 26.5 21.5 48 48 48s48-21.5 48-48V112 96H192v16 64c0 8.8-7.2 16-16 16s-16-7.2-16-16V112zM272 96H256v16 96 16h32V208 164.4l31.1 51.8 4.7 7.8h9.1H336h16V208 112 96H320v16 43.6l-31.1-51.8L284.3 96h-9.1H272z'
      
    ]
  };

  

  
  

  var faUmbrellaBeach = {
    prefix: 'fasl',
    iconName: 'umbrella-beach',
    icon: [
      576,
      512,
      [127958],
      'f5ca',
      
      'M571.1 285.5c-1 10.7-2.8 21.4-5.2 32.2l-30.3-11-92.8-33.8 0 0-30.1-10.9L245 200.9l-30.1-10.9 0 0-96.1-35-30.3-11c5-9.8 10.6-19.1 16.7-28c63.7-92.9 183.7-135.4 294.7-97c.9 .3 1.7 .6 2.6 .9l5.9 2.1c2.5 .9 5 1.9 7.4 3c104.8 44.1 166 151.1 155.3 260.5zM389.6 49.2c-24.1-7.9-50.7-1.3-68.3 17.3c-28.5 30.1-50.7 65.6-65.3 104.3l167.6 61c13.7-39.1 19.5-80.5 17-121.9c-1.4-24.2-16-45.5-37.7-55.6c-3.3-1.4-6.6-2.7-10-3.9c-1.1-.4-2.2-.8-3.2-1.2zM305.9 37c-66.7 3.1-129.4 36.1-169.6 90.2l89.6 32.6C242 117 266.5 77.8 298 44.5c2.5-2.7 5.1-5.1 7.9-7.5zM453.6 242.7l86.3 31.4c3.9-65.7-21.5-129.6-68.3-174.7c.4 2.8 .7 5.7 .9 8.5c2.7 45.7-3.7 91.6-18.9 134.8zM16 480H219.4l81.8-224.7 30.1 10.9L253.4 480H560h16v32H560 16 0V480H16z'
      
    ]
  };

  

  
  

  var faBrainArrowCurvedRight = {
    prefix: 'fasl',
    iconName: 'brain-arrow-curved-right',
    icon: [
      640,
      512,
      ["mind-share"],
      'f677',
      
      'M144.2 75.4l-1.1 11.3-11 2.8C111.4 94.7 96 113.6 96 136c0 3.1 .3 6.2 .9 9.2l2.5 13.2-12.5 4.8C68.8 170 56 187.6 56 208c0 5.2 .8 10.3 2.4 15l3.3 10-7.9 7C40.4 251.7 32 268.9 32 288c0 22.9 12 43 30.2 54.3l11.6 7.2-5.3 12.6C65.6 368.8 64 376.2 64 384c0 30.9 25.1 56 56 56c3.3 0 6.5-.3 9.5-.8l12.9-2.2 4.7 12.2c6.9 18 24.4 30.8 44.8 30.8h48V432 80 32H192c-25 0-45.5 19.1-47.8 43.4zM240 512H192c-29.6 0-55.5-16.1-69.3-40c-.9 0-1.8 0-2.7 0c-48.6 0-88-39.4-88-88c0-7.6 1-15 2.8-22C13.6 344.4 0 317.8 0 288c0-25.1 9.6-48 25.4-65c-.9-4.9-1.4-9.9-1.4-15c0-29.6 16.1-55.5 40-69.3c0-.9 0-1.8 0-2.7c0-33.6 20.7-62.4 50.1-74.2C122.3 26.4 154.1 0 192 0h48 16 16 48c37.9 0 69.7 26.4 77.9 61.8C427.3 73.6 448 102.4 448 136c0 .9 0 1.8 0 2.7c19.4 11.2 33.7 30.4 38.4 53.1H453.2c-4.7-13.1-15-23.6-28.1-28.6l-12.5-4.8 2.5-13.2c.6-3 .9-6 .9-9.2c0-22.4-15.4-41.3-36.2-46.5l-11-2.8-1.1-11.3C365.5 51.1 345 32 320 32H272V80 432v48h48c.6 0 1.1 0 1.7 0c6.6 11.3 14.3 20.8 21.8 28.5c-7.4 2.3-15.3 3.5-23.5 3.5H272 256 240zM464 400c-5.5 0-10.9 .7-16 2c-27.6 7.1-48 32.2-48 62v9.7V512s-16-8-32-24s-32-40-32-72c0-61.9 50.1-112 112-112h32V272 256 224h32L617.4 329.4 640 352l-22.6 22.6L512 480H480V448 432 400H464zm0-32h16 32v32 34.7L594.7 352 512 269.3V304v32H480 448c-44.2 0-80 35.8-80 80c0 7.6 1.4 14.7 3.8 21.2c11.6-40 48.5-69.2 92.2-69.2z'
      
    ]
  };

  
    var faMindShare = faBrainArrowCurvedRight;
  

  
  

  var fa6 = {
    prefix: 'fasl',
    iconName: '6',
    icon: [
      320,
      512,
      [],
      '36',
      
      'M200.8 32L41.2 211.5C16 239.9 1.5 276.2 .1 314.1C0 316.1 0 318 0 320c0 88.4 71.6 160 160 160s160-71.6 160-160s-71.6-160-160-160c-11.4 0-22.5 1.2-33.2 3.5L243.6 32H200.8zM160 448C89.3 448 32 390.7 32 320c0-1 0-2 0-3.1C33.7 247.7 90.3 192 160 192c70.7 0 128 57.3 128 128s-57.3 128-128 128z'
      
    ]
  };

  

  
  

  var faCreditCardFront = {
    prefix: 'fasl',
    iconName: 'credit-card-front',
    icon: [
      576,
      512,
      [],
      'f38a',
      
      'M544 64V448H32V64H544zM32 32H0V64 448v32H32 544h32V448 64 32H544 32zM96 288v32H480V288H96zm0 64v32h96V352H96zm288 0H224v32H384V352zm8-208h80v64H392V144zm-32-32v32 64 32h32 80 32V208 144 112H472 392 360z'
      
    ]
  };

  

  
  

  var faBatteryLow = {
    prefix: 'fasl',
    iconName: 'battery-low',
    icon: [
      576,
      512,
      ["battery-1"],
      'e0b1',
      
      'M480 128V384H32V128H480zM32 96H0v32V384v32H32 480h32V384 128 96H480 32zm544 96H544v32 64 32h32V288 224 192zM96 192h32V320H96V192zM64 160v32V320v32H96h32 32V320 192 160H128 96 64z'
      
    ]
  };

  
    var faBattery1 = faBatteryLow;
  

  
  

  var faAlignJustify = {
    prefix: 'fasl',
    iconName: 'align-justify',
    icon: [
      448,
      512,
      [],
      'f039',
      
      'M16 48H0V80H16 432h16V48H432 16zM0 176v32H16 432h16V176H432 16 0zM16 304H0v32H16 432h16V304H432 16zm0 128H0v32H16 432h16V432H432 16z'
      
    ]
  };

  

  
  

  var faFanTable = {
    prefix: 'fasl',
    iconName: 'fan-table',
    icon: [
      448,
      512,
      [],
      'e004',
      
      'M32 224a192 192 0 1 1 384 0A192 192 0 1 1 32 224zM240 447.4C356.2 439.2 448 342.3 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224C0 342.3 91.8 439.2 208 447.4V480H80 64v32H80 224 368h16V480H368 240V447.4zM195.3 62.6l-14.8 6-22.3 9c-49.2 19.9-72.9 75.8-53 125c9.4 23.2 28.3 44.2 50.6 57.7l-44.1 56.4-9.9 12.6 12.6 9.8L133.4 354c41.8 32.6 102.1 25.2 134.8-16.5c15.4-19.7 24.2-46.6 24.7-72.7l70.9 10 15.8 2.2 2.2-15.8 3.3-23.8c7.4-52.5-29.2-101-81.7-108.4c-24.8-3.5-52.4 2.4-75.3 15L201.3 77.5l-6-14.8zm-17.7 41.7l28.2 69.8 8.2 20.2 16.8-13.8c18.5-15.2 45.8-23.1 68.1-19.9c35 4.9 59.4 37.3 54.5 72.3l-1.1 7.9-74.6-10.5-21.6-3 3.6 21.5c3.9 23.7-2.9 51.2-16.8 69c-21.8 27.9-62 32.8-89.8 11l-6.3-4.9 46.4-59.4 13.4-17.2-20.4-7.7c-22.4-8.4-42.9-28.1-51.3-49c-13.2-32.8 2.6-70.1 35.4-83.3l7.4-3zM224 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faBookmark = {
    prefix: 'fasl',
    iconName: 'bookmark',
    icon: [
      384,
      512,
      [61591,128278],
      'f02e',
      
      'M192 363l16.1 9.4L352 456.3V32H32V456.3l143.9-83.9L192 363zM32 493.3L0 512V475 32 0H32 352h32V32 475v37l-32-18.7L192 400 32 493.3z'
      
    ]
  };

  

  
  

  var faSemicolon = {
    prefix: 'fasl',
    iconName: 'semicolon',
    icon: [
      192,
      512,
      [],
      '3b',
      
      'M64 96v64h64V96H64zM32 64H64h64 32V96v64 32H128 64 32V160 96 64zM46.9 480L128 358.3V320H73.9L39.6 480h7.3zm-40 0L48 288h80 32v32 48L64 512H32.7 0l6.9-32z'
      
    ]
  };

  

  
  

  var faSquareExclamation = {
    prefix: 'fasl',
    iconName: 'square-exclamation',
    icon: [
      448,
      512,
      ["exclamation-square"],
      'f321',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm240 96v16V272v16H208V272 144 128h32zM200 320h48v48H200V320z'
      
    ]
  };

  
    var faExclamationSquare = faSquareExclamation;
  

  
  

  var faTrainSubwayTunnel = {
    prefix: 'fasl',
    iconName: 'train-subway-tunnel',
    icon: [
      512,
      512,
      ["subway-tunnel"],
      'e2a3',
      
      'M256 32C132.3 32 32 132.3 32 256V496v16H0V496 256C0 114.6 114.6 0 256 0S512 114.6 512 256V496v16H480V496 256C480 132.3 379.7 32 256 32zM144 160v96H368V160H144zm0 128V416h49.4H200 312h6.6H368V288H144zM350.6 448l52.7 52.7L414.6 512l-45.3 0-64-64H206.6l-64 64H97.4l0 0 11.3-11.3L161.4 448H144 112V416 160 128h32H368h32v32V416v32H368 350.6zM176 360a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm136-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faSubwayTunnel = faTrainSubwayTunnel;
  

  
  

  var faSquareUp = {
    prefix: 'fasl',
    iconName: 'square-up',
    icon: [
      448,
      512,
      [11014,"arrow-alt-square-up"],
      'f353',
      
      'M32 64l0 384 384 0 0-384L32 64zM0 32l32 0 384 0 32 0 0 32 0 384 0 32-32 0L32 480 0 480l0-32L0 64 0 32zM192 256l0 96 64 0 0-96 0-32 32 0 18.7 0L224 141.3 141.3 224l18.7 0 32 0 0 32zM224 96l22.6 22.6L352 224l0 32-32 0-32 0 0 32 0 64 0 32-32 0-64 0-32 0 0-32 0-64 0-32-32 0-32 0 0-32L201.4 118.6 224 96z'
      
    ]
  };

  
    var faArrowAltSquareUp = faSquareUp;
  

  
  

  var faFaceHoldingBackTears = {
    prefix: 'fasl',
    iconName: 'face-holding-back-tears',
    icon: [
      512,
      512,
      [129401],
      'e482',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM322.1 121.6l-1.5-5.2 30.8-8.8 1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4-3.7 29.7C425.4 203.5 432 221 432 240c0 18-6 34.6-16 48v32 16H384V320v-6.7c-9.8 4.3-20.6 6.7-32 6.7c-44.2 0-80-35.8-80-80c0-41.5 31.5-75.6 72-79.6c-10-10.8-17.6-24.1-21.9-38.8zm-130.7-5.2l-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6v32 16 16 16H208V304c-13.4 10-30 16-48 16c-11.4 0-22.2-2.4-32-6.7V320v16H96V320 288c-10-13.4-16-30-16-48c0-19 6.6-36.5 17.7-50.2L94 160.1l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2 30.8 8.8zM208 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm144 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM160 208c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c17.7 0 32-14.3 32-32zm160 32c17.7 0 32-14.3 32-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm34.3 135.2C344.4 395 311.6 432 256 432s-88.4-37-98.3-56.8l28.6-14.3C192.4 373 215.6 400 256 400s63.6-27 69.7-39.2l28.6 14.3z'
      
    ]
  };

  

  
  

  var faBowlSoftServe = {
    prefix: 'fasl',
    iconName: 'bowl-soft-serve',
    icon: [
      512,
      512,
      [],
      'e46b',
      
      'M256 0H226.1l16.6 24.9 10.8 16.3c1.6 2.4 2.5 5.3 2.5 8.2c0 8.1-6.6 14.7-14.7 14.7H167.2C127.9 64 96 95.9 96 135.2c0 9 1.7 17.6 4.7 25.6C61.9 166.3 32 199.6 32 240v64 16H48 464h16V304 240c0-41.2-31.1-75.1-71.2-79.5c4.6-9.5 7.2-20.2 7.2-31.5C416 57.8 358.2 0 287 0H256zm32 49.3c0-6-1.1-11.8-3.3-17.3H287c53.6 0 97 43.4 97 97c0 12.4-5.6 23.5-14.4 31H280 264v32h16 42.4 52.6H384h16c26.5 0 48 21.5 48 48v48H64V240c0-26.5 21.5-48 48-48h16 2 38 3.2H184V160H168 136.8c-5.5-6.8-8.8-15.4-8.8-24.8c0-21.7 17.6-39.2 39.2-39.2h74.1C267.1 96 288 75.1 288 49.3zM32 352c0 53 43 96 96 96h54.1l-20.4 40.8L150.1 512H176 336h25.9l-11.6-23.2L329.9 448H384c53 0 96-43 96-96H448c0 35.3-28.7 64-64 64H304 278.1l11.6 23.2L310.1 480H201.9l20.4-40.8L233.9 416H208 128c-35.3 0-64-28.7-64-64H32z'
      
    ]
  };

  

  
  

  var faBaguette = {
    prefix: 'fasl',
    iconName: 'baguette',
    icon: [
      640,
      512,
      [129366],
      'e3d8',
      
      'M591.9 74.8c-29.4-44.1-89-56-133.1-26.6l-79.2 52.8 47.8 47.8L438.6 160 416 182.6l-11.3-11.3L352.4 119l-88 58.7 51 51L326.6 240 304 262.6l-11.3-11.3-55.5-55.5-88 58.7 54.2 54.2L214.6 320 192 342.6l-11.3-11.3L122 272.6 74.7 304.1c-44.1 29.4-56 89-26.6 133.1s89 56 133.1 26.6l384-256c44.1-29.4 56-89 26.6-133.1zM618.5 57c39.2 58.8 23.3 138.3-35.5 177.5l-384 256C140.2 529.7 60.7 513.8 21.5 455S-1.8 316.7 57 277.5l384-256C499.8-17.7 579.3-1.8 618.5 57z'
      
    ]
  };

  

  
  

  var faBarcodeRead = {
    prefix: 'fasl',
    iconName: 'barcode-read',
    icon: [
      576,
      512,
      [],
      'f464',
      
      'M0 0H16 144h16V32H144 32V144v16H0V144 16 0zM128 128h32V384H128V128zm64 0h32V384H192V128zM416 384V128h32V384H416zM288 128V384H256V128h32zm48 0h32V384H336V128zM560 0h16V16 144v16H544V144 32H432 416V0h16H560zM0 512V496 368 352H32v16V480H144h16v32H144 16 0zm560 0H432 416V480h16H544V368 352h32v16V496v16H560z'
      
    ]
  };

  

  
  

  var faArrowUpBigSmall = {
    prefix: 'fasl',
    iconName: 'arrow-up-big-small',
    icon: [
      576,
      512,
      ["sort-size-up"],
      'f88e',
      
      'M320 32h32H512h32V64 224v32H512 352 320V224 64 32zm32 192H512V64H352V224zM160 33.4l11.3 11.3 88 88L270.6 144 248 166.6l-11.3-11.3L176 94.6V464v16H144V464 94.6L83.3 155.3 72 166.6 49.4 144l11.3-11.3 88-88L160 33.4zM352 320h96 32v32 96 32H448 352 320V448 352 320h32zm96 32H352v96h96V352z'
      
    ]
  };

  
    var faSortSizeUp = faArrowUpBigSmall;
  

  
  

  var faMoneyBill = {
    prefix: 'fasl',
    iconName: 'money-bill',
    icon: [
      576,
      512,
      [],
      'f0d6',
      
      'M480 96c0 35.3 28.7 64 64 64V96H480zm-32 0H128c0 53-43 96-96 96V320c53 0 96 43 96 96H448c0-53 43-96 96-96V192c-53 0-96-43-96-96zM32 416H96c0-35.3-28.7-64-64-64v64zm512-64c-35.3 0-64 28.7-64 64h64V352zM32 96v64c35.3 0 64-28.7 64-64H32zM0 64H32 544h32V96 416v32H544 32 0V416 96 64zM352 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  

  
  

  var faHandPointUp = {
    prefix: 'fasl',
    iconName: 'hand-point-up',
    icon: [
      384,
      512,
      [9757],
      'f0a6',
      
      'M48 0H32V16 240H16 0v16 96c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160v0V336 272 256 208 192H368 304V176H288 224V160 144H208 144V16 0H128 48zm96 176h48v16 48H144V176zm48 96l0 0 0 48H112 96v32h16 80 16 16 48 16 16 48c0 70.7-57.3 128-128 128H160C89.3 480 32 422.7 32 352V272h80v0h32v0h48zm32 0l0-16V240l0-32h48V320H224l0-48zM112 240H64V32h48V144v16 80zm240 32v48H304V224h48v32 16z'
      
    ]
  };

  

  
  

  var faSquareJ = {
    prefix: 'fasl',
    iconName: 'square-j',
    icon: [
      448,
      512,
      [],
      'e273',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM304 144V288c0 53-43 96-96 96s-96-43-96-96V272 256h32v16 16c0 35.3 28.7 64 64 64s64-28.7 64-64V144 128h32v16z'
      
    ]
  };

  

  
  

  var faBagShoppingPlus = {
    prefix: 'fasl',
    iconName: 'bag-shopping-plus',
    icon: [
      448,
      512,
      [],
      'e651',
      
      'M160 96v32H288V96c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 32V96c0-53 43-96 96-96h16V1.3c45.4 7.6 80 47.1 80 94.7v32h96 32v32V480v32H416 32 0V480 160 128H32h96zm0 32H32V480H416V160H320 288 160 128zm0 144h16 64V240 224h32v16 64h64 16v32H304 240v64 16H208l0-16V336H144 128V304z'
      
    ]
  };

  

  
  

  var faSquareDashed = {
    prefix: 'fasl',
    iconName: 'square-dashed',
    icon: [
      448,
      512,
      [],
      'e269',
      
      'M16 32H128V64H32v96H0V48 32H16zM0 192H32V320H0V192zm416 0h32V320H416V192zm32-32H416V64H320V32H432h16V48 160zm0 192V464v16H432 320V448h96V352h32zM32 352v96h96v32H16 0V464 352H32zM288 480H160V448H288v32zM160 64V32H288V64H160z'
      
    ]
  };

  

  
  

  var faFaceFrownOpen = {
    prefix: 'fasl',
    iconName: 'face-frown-open',
    icon: [
      512,
      512,
      [128550,"frown-open"],
      'f57a',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm36.2 183.8c-27-10-58.7-15.8-92.6-15.8c-33.9 0-65.5 5.8-92.5 15.8l-25.9 9.6 4.6-27.2C150.6 323.7 200 288 256 288s105.4 35.7 113.9 86.2l4.6 27.2-25.9-9.6zM256 320c-30.2 0-55.4 13.1-69.8 31.8c21.9-5 45.4-7.7 69.8-7.7c24.4 0 47.9 2.7 69.9 7.8C311.4 333.1 286.3 320 256 320z'
      
    ]
  };

  
    var faFrownOpen = faFaceFrownOpen;
  

  
  

  var faFileVector = {
    prefix: 'fasl',
    iconName: 'file-vector',
    icon: [
      384,
      512,
      [],
      'e64c',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zm8 256H144V224H80v64h32v96H80v64h64V416h96v32h64V384H272V288h32V224H240v32zm0 128H144V288h96v96z'
      
    ]
  };

  

  
  

  var faTally1 = {
    prefix: 'fasl',
    iconName: 'tally-1',
    icon: [
      640,
      512,
      [],
      'e294',
      
      'M144 32V48 464v16H112V464 48 32h32z'
      
    ]
  };

  

  
  

  var faPooStorm = {
    prefix: 'fasl',
    iconName: 'poo-storm',
    icon: [
      448,
      512,
      ["poo-bolt"],
      'f75a',
      
      'M164.4 0h22.4c70 0 138.5 45.4 148.1 118.2C363.7 130.3 384 158.7 384 192v13.5c37.3 13.2 64 48.7 64 90.5v88 16H432 347.9L368 379.9V368h48V296c0-30.9-22-56.8-51.2-62.7L352 230.7V217.6 192c0-22.4-15.3-41.2-36.1-46.5l-11.5-2.9-.6-11.8c-2.4-50.4-43.2-88-94.1-96.8c.4 1.4 .8 2.7 1.3 4.1c2.3 7.8 5 17.8 5 25.4c0 43.5-27.5 67.3-46.4 78.4l-3.7 2.2h-4.3H144c-26.5 0-48 21.5-48 48v25.6 13.1l-12.8 2.6C54 239.2 32 265.1 32 296v72H80v32H16 0V384 296c0-41.8 26.7-77.4 64-90.5V192c0-44.2 35.8-80 80-80h13c13-8.5 27-23.3 27-48.6c0-2.2-1.2-7.8-3.7-16.2c-2.3-7.6-5.1-15.6-7.1-21.5l-.1-.2 0 0 0 0c-.6-1.6-1.1-3.1-1.5-4.3L164.4 0zM264 224h8 18.4l-2.6 18.3L274.4 336H320h16v16 8 6.6l-4.7 4.7-136 136-4.7 4.7H184h-8H157.6l2.6-18.3L173.6 400H128 112V384v-8-6.6l4.7-4.7 136-136 4.7-4.7H264zM158.6 368H192h18.4l-2.6 18.3-10.5 73.8L289.4 368H256 237.6l2.6-18.3 10.5-73.8L158.6 368z'
      
    ]
  };

  
    var faPooBolt = faPooStorm;
  

  
  

  var faCapsules = {
    prefix: 'fasl',
    iconName: 'capsules',
    icon: [
      576,
      512,
      [],
      'f46b',
      
      'M32 240H192V144c0-44.2-35.8-80-80-80s-80 35.8-80 80v96zM0 256V144C0 82.1 50.1 32 112 32s112 50.1 112 112v24.2c3-32.2 19.3-63 47.3-83c50.7-36.2 120.5-23.6 156 28.1L555.7 300.6c35.5 51.7 23.2 123-27.5 159.2s-120.5 23.6-156-28.1L243.8 244.4c-11.5-16.8-18-35.7-19.8-54.8V256 368c0 61.9-50.1 112-112 112S0 429.9 0 368V256zm192 16H32v96c0 44.2 35.8 80 80 80s80-35.8 80-80V272zM398.6 413.6c25.5 37.1 75.1 45.8 111 20.1c36.3-26 45.5-77.6 19.7-115.1l-52.7-76.8-2.2 1.6L344.4 334.6l54.2 79.1zm57.5-196.4l2.5-1.7-57.7-84.2c-25.5-37.1-75.1-45.8-111-20.1c-36.3 26-45.5 77.6-19.7 115.1l56.1 81.8 129.8-90.9z'
      
    ]
  };

  

  
  

  var faDonut = {
    prefix: 'fasl',
    iconName: 'donut',
    icon: [
      512,
      512,
      [127849,"doughnut"],
      'e406',
      
      'M32 208v8 16 18.6l47.7 24 2.3 1.2 1.8 1.8 38.3 38.6 64.9 6.5 1.5 .2 1.5 .4 66 19.9 66-19.9 1.5-.4 1.5-.2 64.9-6.5 23.8-23.9-9-8.9-32-32L361.4 240 384 217.4l11.3 11.3 32 32 10.9 10.9 41.8-21V232 216v-8c0-29.2-19-60.4-59.9-86c-29.6-18.5-68.5-32.4-112.9-38.5l-7.8 7.8-32 32L256 134.6 233.4 112l11.3-11.3 20.6-20.6c-3.1-.1-6.2-.1-9.3-.1c-65.7 0-123.6 16.7-164.1 42C51 147.6 32 178.8 32 208zM0 216v-8C0 119.6 114.6 48 256 48s256 71.6 256 160v8 16 28.4 9.9V304c0 88.4-114.6 160-256 160S0 392.4 0 304V270.3v-9.9V232 216zm32 70.4V304c0 29.2 19 60.4 59.9 86c40.5 25.3 98.4 42 164.1 42s123.6-16.7 164.1-42C461 364.4 480 333.2 480 304V286.4L449.1 302l-40.5 40.8-4 4.1-5.7 .6-69 7-69.1 20.9-4.6 1.4-4.6-1.4-69.1-20.9-69-7-5.7-.6-4-4.1L62.9 302 32 286.4zm176-94.5c0 0 0 .1 0 .1s0 0 0 0s0 0 0 .1c0 0 0 .1 .1 .3c.1 .3 .4 .9 1.1 1.7c1.5 1.7 4.2 4 8.7 6.2c8.9 4.5 22.4 7.7 38.1 7.7s29.2-3.2 38.1-7.7c4.5-2.2 7.2-4.5 8.7-6.2c.7-.8 1-1.4 1.1-1.7c.1-.2 .1-.3 .1-.3s0-.1 0-.1s0 0 0-.1s0-.1-.1-.3c-.1-.3-.4-.9-1.1-1.7c-1.5-1.7-4.2-4-8.7-6.2c-8.9-4.5-22.4-7.7-38.1-7.7s-29.2 3.2-38.1 7.7c-4.5 2.2-7.2 4.5-8.7 6.2c-.7 .8-1 1.4-1.1 1.7c-.1 .2-.1 .3-.1 .3zm-4.4-36.9c14.2-7.1 32.8-11.1 52.4-11.1s38.2 3.9 52.4 11.1c13.3 6.6 27.6 18.8 27.6 36.9s-14.3 30.3-27.6 36.9C294.2 236.1 275.6 240 256 240s-38.2-3.9-52.4-11.1C190.3 222.3 176 210.2 176 192s14.3-30.3 27.6-36.9zm-32.3-15.7l-32 32L128 182.6 105.4 160l11.3-11.3 32-32L160 105.4 182.6 128l-11.3 11.3zm224-6.6l32 32L438.6 176 416 198.6l-11.3-11.3-32-32L361.4 144 384 121.4l11.3 11.3zM64 192H96h16v32H96 64 48V192H64zm91.3 52.7l32 32L198.6 288 176 310.6l-11.3-11.3-32-32L121.4 256 144 233.4l11.3 11.3zm176 38.6l-32 32L288 326.6 265.4 304l11.3-11.3 32-32L320 249.4 342.6 272l-11.3 11.3z'
      
    ]
  };

  
    var faDoughnut = faDonut;
  

  
  

  var faDongSign = {
    prefix: 'fasl',
    iconName: 'dong-sign',
    icon: [
      384,
      512,
      [],
      'e169',
      
      'M320 32H288V64H192V96h96V203.3c-23.5-26.6-57.8-43.3-96-43.3c-70.7 0-128 57.3-128 128s57.3 128 128 128c38.2 0 72.5-16.8 96-43.3V416h32V288 96h32V64H320V32zM96 288a96 96 0 1 1 192 0A96 96 0 1 1 96 288zM384 480V448H0v32H384z'
      
    ]
  };

  

  
  

  var faTemperatureHalf = {
    prefix: 'fasl',
    iconName: 'temperature-half',
    icon: [
      320,
      512,
      [127777,"temperature-2","thermometer-2","thermometer-half"],
      'f2c9',
      
      'M96 275l-10.7 9.5C62.4 305.1 48 334.9 48 368c0 61.9 50.1 112 112 112s112-50.1 112-112c0-33.2-14.4-62.9-37.3-83.5L224 275V260.7 32H96V260.7 275zM224 0h32V32 260.7c29.5 26.4 48 64.7 48 107.3c0 79.5-64.5 144-144 144S16 447.6 16 368c0-42.6 18.5-81 48-107.3V32 0H96 224zM160 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62V208 192h32v16 98c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64z'
      
    ]
  };

  
    var faTemperature2 = faTemperatureHalf;
  
    var faThermometer2 = faTemperatureHalf;
  
    var faThermometerHalf = faTemperatureHalf;
  

  
  

  var faCommentImage = {
    prefix: 'fasl',
    iconName: 'comment-image',
    icon: [
      512,
      512,
      [],
      'e148',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM288.1 126.9l-12.4 14.8-68.8 82.5-19.6-19.6-12-12L164 205.4l-64 72-4 4.5V288v16 16h16H400h16V304 288v-5.7l-3.6-4.4-112-136-12.3-14.9zm-.1 50.2L379.3 288H133.4l43.3-48.7 20 20 12.4 12.4 11.2-13.5 67.6-81.2zM184 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faEscalator = {
    prefix: 'fasl',
    iconName: 'escalator',
    icon: [
      640,
      512,
      [],
      'e171',
      
      'M264 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 184 56zm233.9 72h6 24H560h64 16v16V272v16H624 560 478.1L244.7 492.2 226.6 508l-4.5 4h-6H192 80 16 0V496 368 352H16 80h81.9L395.3 147.8 413.4 132l4.5-4zm12 32l-13.6 11.9L178.5 380l-4.5 4h-6H80 32v96H80 192h18l13.6-11.9L461.5 260l4.5-4h6 88 48V160H560 448 430zM320 171.2l-32 28V176H192V283.2l-32 28V176 144h32 96 32v27.2z'
      
    ]
  };

  

  
  

  var faCarWash = {
    prefix: 'fasl',
    iconName: 'car-wash',
    icon: [
      448,
      512,
      [],
      'f5e6',
      
      'M76.3 92.5c1.2-1.1 3.7-4 3.7-12.5c0-.7-.5-4.5-4.1-11.7c-3-6-7.2-12.5-11.9-18.9c-4.7 6.4-8.9 13-11.9 18.9C48.5 75.5 48 79.3 48 80c0 8.8 7.2 16 16 16c7 0 10.7-2.1 12.3-3.5zM42.9 24.2C53.9 10.1 64 0 64 0s10.1 10.1 21.1 24.2C98 40.7 112 62.7 112 80c0 32-21.5 48-48 48s-48-21.5-48-48c0-17.3 14-39.3 26.9-55.8zM240 80c0-.7-.5-4.5-4.1-11.7c-3-6-7.2-12.5-11.9-18.9c-4.7 6.4-8.9 13-11.9 18.9C208.5 75.5 208 79.3 208 80c0 8.8 7.2 16 16 16c7 0 10.7-2.1 12.3-3.5c1.2-1.1 3.7-4 3.7-12.5zm-64 0c0-17.3 14-39.3 26.9-55.8C213.9 10.1 224 0 224 0s10.1 10.1 21.1 24.2C258 40.7 272 62.7 272 80c0 32-21.5 48-48 48s-48-21.5-48-48zm-68.1 96H120 328h12.1l3.3 11.6L372.1 288H384h32v32 96 16 32 48H384V464H64v48H32V464 432 416 320 288H64 75.9l28.7-100.4 3.3-11.6zM384 320H360.4c-.2 0-.5 0-.7 0H88.4c-.2 0-.5 0-.7 0H64v96 16H384V416 320zM315.9 208H132.1l-22.9 80H338.8l-22.9-80zM112 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm200 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM400 80c0-.7-.5-4.5-4.1-11.7c-3-6-7.2-12.5-11.9-18.9c-4.7 6.4-8.9 13-11.9 18.9C368.5 75.5 368 79.3 368 80c0 8.8 7.2 16 16 16c7 0 10.7-2.1 12.3-3.5c1.2-1.1 3.7-4 3.7-12.5zm-64 0c0-17.3 14-39.3 26.9-55.8C373.9 10.1 384 0 384 0s10.1 10.1 21.1 24.2C418 40.7 432 62.7 432 80c0 32-21.5 48-48 48s-48-21.5-48-48z'
      
    ]
  };

  

  
  

  var faNotesMedical = {
    prefix: 'fasl',
    iconName: 'notes-medical',
    icon: [
      512,
      512,
      [],
      'f481',
      
      'M128 416H96V384 64 32h32H448h32V64 320l-96 96H128zm242.7-32L448 306.7V64H128V384H370.7zM320 480v32H304 16 0V496 144 128H32v16l0 336H304h16zM256 112h64 16v16 48h48 16v16 64 16H384 336v48 16H320 256 240V320 272H192 176V256 192 176h16 48V128 112h16zm16 80v16H256 208v32h48 16v16 48h32V256 240h16 48V208H320 304V192 144H272v48z'
      
    ]
  };

  

  
  

  var faSlotMachine = {
    prefix: 'fasl',
    iconName: 'slot-machine',
    icon: [
      640,
      512,
      [],
      'e3ce',
      
      'M416 416H96l0 64 288 0h32V416zm-32 96L96 512H64V480 416H32 0V384 128 96H32 64V32 0H96 416h32V32 96h32 32v32V384v32H480 448v64H576V221.3c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3V496v16H592 448 416 384h0zM608 176a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 32L96 32V96H416V32zm64 96H32V384H480V128zm-48 48v18.9l-1 2.7L379.1 336H344.9l48-128H352 336V176h16 64 16zM311 197.6L259.1 336H224.9l48-128H232 216V176h16 64 16v18.9l-1 2.7zm-120 0L139.1 336H104.9l48-128H112 96V176h16 64 16v18.9l-1 2.7z'
      
    ]
  };

  

  
  

  var faWineGlassCrack = {
    prefix: 'fasl',
    iconName: 'wine-glass-crack',
    icon: [
      320,
      512,
      ["fragile"],
      'f4bb',
      
      'M61.2 32L46.4 195.6C40.3 262.4 92.9 320 160 320s119.7-57.6 113.6-124.4L258.8 32H183.6l23.2 58.1 5.5 13.7-13.2 6.6L155 132.4l48.3 48.3L214.6 192 192 214.6l-11.3-11.3-64-64L101 123.6l19.9-9.9 50.8-25.4L149.2 32H61.2zM305.5 192.7c7.3 80.2-51.4 150-129.5 158.5V480h64 16v32H240 160 80 64V480H80h64V351.1C65.9 342.7 7.2 272.8 14.5 192.7L32 0H288l17.5 192.7z'
      
    ]
  };

  
    var faFragile = faWineGlassCrack;
  

  
  

  var faG = {
    prefix: 'fasl',
    iconName: 'g',
    icon: [
      448,
      512,
      [103],
      '47',
      
      'M224 64C118 64 32 150 32 256s86 192 192 192c100.6 0 183.2-77.4 191.3-176h-173-16V240h16H432h16v16c0 123.7-100.3 224-224 224S0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57l11.9 10.7-21.3 23.8L352 112.9C318 82.5 273.2 64 224 64z'
      
    ]
  };

  

  
  

  var faWhistle = {
    prefix: 'fasl',
    iconName: 'whistle',
    icon: [
      640,
      512,
      [],
      'f460',
      
      'M93.4 115.3C79.5 128.1 67.6 143 58 159.4c-14.8-2.8-26-15.8-26-31.4c0-17.7 14.3-32 32-32c13.2 0 24.5 7.9 29.4 19.3zM0 128c0 28.4 18.5 52.5 44.1 60.8C36.3 209.7 32 232.4 32 256c0 106 86 192 192 192c64.7 0 121.9-32 156.7-81L536 448l82.2-88.5L640 336l-25.2-19.9L493.9 220.5 448 248l-32-24 14.6-53.6-78.1-61.8C315.9 79.7 270.6 64 224 64c-38.8 0-74.8 11.5-105 31.2C107.8 76.5 87.4 64 64 64C28.7 64 0 92.7 0 128zM370.8 325.7l-16.2 22.8C325.6 389.4 277.9 416 224 416c-88.4 0-160-71.6-160-160s71.6-160 160-160c39.4 0 77.7 13.3 108.6 37.8l61.5 48.7-9 33.2-5.7 21 17.4 13 32 24L446 286.5l18.5-11.1 26.9-16.2L593 339.6l-63.8 68.7L395.5 338.6l-24.7-12.9zM256 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128z'
      
    ]
  };

  

  
  

  var faLinkSimple = {
    prefix: 'fasl',
    iconName: 'link-simple',
    icon: [
      576,
      512,
      [],
      'e1cd',
      
      'M0 256C0 167.6 71.6 96 160 96h80 16v32H240 160C89.3 128 32 185.3 32 256s57.3 128 128 128h80 16v32H240 160C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160H336 320V384h16 80c70.7 0 128-57.3 128-128s-57.3-128-128-128H336 320V96h16 80c88.4 0 160 71.6 160 160zM152 240H424h16v32H424 152 136V240h16z'
      
    ]
  };

  

  
  

  var faMonitorWaveform = {
    prefix: 'fasl',
    iconName: 'monitor-waveform',
    icon: [
      576,
      512,
      ["monitor-heart-rate"],
      'f611',
      
      'M32 64V256H176h8.6l4.8 7.1 30.8 46.2 53-139 13-34 16.3 32.6L345.9 256H432h16v32H432 336h-9.9l-4.4-8.8L290 215.7l-51 134-11 29-17.2-25.8L167.4 288H32V448H544V64H32zM0 32H32 544h32V64 448v32H544 32 0V448 64 32z'
      
    ]
  };

  
    var faMonitorHeartRate = faMonitorWaveform;
  

  
  

  var faQ = {
    prefix: 'fasl',
    iconName: 'q',
    icon: [
      448,
      512,
      [113],
      '51',
      
      'M32 256c0 106 86 192 192 192c41.9 0 80.6-13.4 112.2-36.2L224.9 256h39.3l96.4 134.9C394.9 356.2 416 308.6 416 256c0-106-86-192-192-192S32 150 32 256zM354.8 437.9C318 464.4 272.8 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 63.3-26.3 120.5-68.6 161.3L447.1 512H407.8l-53-74.1z'
      
    ]
  };

  

  
  

  var faHorse = {
    prefix: 'fasl',
    iconName: 'horse',
    icon: [
      576,
      512,
      [128014],
      'f6f0',
      
      'M336 144v16H320 256 192 146.7c-28 0-50.7 22.7-50.7 50.7c0 6.7 1.3 13.3 3.9 19.5l34.9 83.7 1.2 3V320v7.8 3.3l-1.3 3-20.8 48.5-3.3 7.8 2.3 8.1L135.5 480h49.8l-22.5-80.9-1.5-5.4 2.2-5.2 18.5-43.1 1.9-4.5V336 312v-4.2-20l19.5 4.4L318.4 318c1.4 .3 2.8 .6 4.3 .8l13.3 2.3v13.5V480h48V311.6v-7.2l5.3-4.8C405.6 285.1 416 264 416 240V176 160h16 32 8.6l4.7 7.1 23.4 35.1 42.4-26.5L533.2 71.2 493.9 32H480h-8H448c-61.9 0-112 50.1-112 112zM539.2 32l20.7 20.7 4.1 4.1 .5 5.7 11.4 120 .9 9.8-8.4 5.2-64 40-13.2 8.2-8.6-12.9L455.4 192H448v48c0 30.9-12.4 58.4-32 78.4V496v16H400 320 304V496 347.6l-88-19.8V336v8.2 3.3l-1.3 3-3.2 7.5L195.2 396l26.6 95.7 5.6 20.3H206.4h-83H111.2L108 500.3 82 407l-3.8-13.5L76.8 388l2.2-5.2 5.5-12.9L104 324.5v-1.3L70.4 242.5c-4.2-10.1-6.4-20.8-6.4-31.7c-18.6 6.6-32 24.4-32 45.3v48 16H0V304 256c0-41.3 31.3-75.2 71.4-79.5c13-28.6 41.8-48.5 75.3-48.5H192h64 48.9c8-72 69-128 143.1-128h24 8 20.6 6.6H544h16V32H544h-4.8zM464 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faDialMed = {
    prefix: 'fasl',
    iconName: 'dial-med',
    icon: [
      576,
      512,
      [],
      'e15f',
      
      'M312 8H264V56h48V8zM120 72H72v48h48V72zm336 0v48h48V72H456zM568 264H520v48h48V264zM8 264v48H56V264H8zM120 456H72v48h48V456zm336 0v48h48V456H456zM160 288c0-65.3 48.9-119.1 112-127V288v16h32V288 161c63.1 7.9 112 61.7 112 127c0 70.7-57.3 128-128 128s-128-57.3-128-128zM288 128a160 160 0 1 0 0 320 160 160 0 1 0 0-320z'
      
    ]
  };

  

  
  

  var faAngleRight = {
    prefix: 'fasl',
    iconName: 'angle-right',
    icon: [
      320,
      512,
      [8250],
      'f105',
      
      'M278.6 256l-11.3 11.3-160 160L96 438.6 73.4 416l11.3-11.3L233.4 256 84.7 107.3 73.4 96 96 73.4l11.3 11.3 160 160L278.6 256z'
      
    ]
  };

  

  
  

  var faBellOn = {
    prefix: 'fasl',
    iconName: 'bell-on',
    icon: [
      640,
      512,
      [128365],
      'f8fa',
      
      'M304 0h32V32.8c80.9 8 144 76.2 144 159.2v97.4l59.3 59.3 4.7 4.7V360v40 16H528 112 96V400 360v-6.6l4.7-4.7L160 289.4V192c0-83 63.1-151.2 144-159.2V0zm16 64c-70.7 0-128 57.3-128 128V296v6.6l-4.7 4.7L128 366.6V384H512V366.6l-59.3-59.3-4.7-4.7V296 192c0-70.7-57.3-128-128-128zM256 448h32c0 17.7 14.3 32 32 32s32-14.3 32-32h32c0 35.3-28.7 64-64 64s-64-28.7-64-64zM0 160H16 96h16v32H96 16 0V160zm544 0h80 16v32H624 544 528V160h16zM605.5 31.2l-14.3 7.2-64 32-14.3 7.2L498.5 48.8l14.3-7.2 64-32 14.3-7.2 14.3 28.6zM48.8 38.3L34.5 31.2 48.8 2.5 63.2 9.7l64 32 14.3 7.2L127.2 77.5l-14.3-7.2-64-32z'
      
    ]
  };

  

  
  

  var faFilters = {
    prefix: 'fasl',
    iconName: 'filters',
    icon: [
      640,
      512,
      [],
      'e17e',
      
      'M384 256V368l64 48V256 242.7l9.4-9.4L608 82.7V64H224V82.7L374.6 233.4l9.4 9.4V256zm-32 0L192 96V64 32h32H608h32V64 96L480 256V440v40l-32-24-96-72V256zM32 96H160v13.3l9.4 9.4 9.4 9.4H32v18.7L182.6 297.4l9.4 9.4V320v80l64 48V320 306.7l9.4-9.4L306.7 256 320 269.3V288l-32 32V472v40l-32-24-96-72V320L0 160V128 96H32z'
      
    ]
  };

  

  
  

  var faMugMarshmallows = {
    prefix: 'fasl',
    iconName: 'mug-marshmallows',
    icon: [
      512,
      512,
      [],
      'f7b7',
      
      'M224 32H64 32V64v64H64V64H194.7l32-32H224zm121.4 73.4L294.6 54.6 272 32 249.4 54.6l-50.7 50.7L176 128h45.3L272 77.3 322.7 128H368l-22.6-22.6zM32 448V192H96v80 16h32V272 192H336h16V448H32zm96-288H96 32 0v32V448v32H32 352h32V448 384h16c61.9 0 112-50.1 112-112s-50.1-112-112-112H384 352 336 128zM384 352V192h16c44.2 0 80 35.8 80 80s-35.8 80-80 80H384z'
      
    ]
  };

  

  
  

  var faHorseSaddle = {
    prefix: 'fasl',
    iconName: 'horse-saddle',
    icon: [
      576,
      512,
      [],
      'f8c3',
      
      'M336 144v16 80 16H320 256v48l62.4 14c1.4 .3 2.8 .6 4.3 .8l13.3 2.3v13.5V480h48V311.6v-7.2l5.3-4.8C405.6 285.1 416 264 416 240V176 160h16 32 8.6l4.7 7.1 23.4 35.1 42.4-26.5L533.2 71.2 493.9 32H480h-8H448c-61.9 0-112 50.1-112 112zm-96 80h64V160H256 192 176v64h64zm-16 32H160 144V240 160.1c-26.7 1.4-48 23.5-48 50.6c0 6.7 1.3 13.3 3.9 19.5l34.9 83.7 1.2 3V320v7.8 3.3l-1.3 3-20.8 48.5-3.3 7.8 2.3 8.1L135.5 480h49.8l-22.5-80.9-1.5-5.4 2.2-5.2 18.5-43.1 1.9-4.5V336 312v-4.2-20l19.5 4.4 20.5 4.6V256zm32-128h48 .9c8-72 69-128 143.1-128h24 8 20.6 6.6H544h16V32H544h-4.8l20.7 20.7 4.1 4.1 .5 5.7 11.4 120 .9 9.8-8.4 5.2-64 40-13.2 8.2-8.6-12.9L455.4 192H448v48c0 30.9-12.4 58.4-32 78.4V496v16H400 320 304V496 347.6l-88-19.8V336v8.2 3.3l-1.3 3-3.2 7.5L195.2 396l26.6 95.7 5.6 20.3H206.4h-83H111.2L108 500.3 82 407l-3.8-13.5L76.8 388l2.2-5.2 5.5-12.9L104 324.5v-1.3L70.4 242.5c-4.2-10.1-6.4-20.8-6.4-31.7c-18.6 6.6-32 24.4-32 45.3v48 16H0V304 256c0-41.3 31.3-75.2 71.4-79.5c13-28.6 41.8-48.5 75.3-48.5H192h64zM464 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'
      
    ]
  };

  

  
  

  var faJoint = {
    prefix: 'fasl',
    iconName: 'joint',
    icon: [
      640,
      512,
      [],
      'f595',
      
      'M416 0h32V43c0 42.4 16.9 83.1 46.9 113.1l21 21c18 18 28.1 42.4 28.1 67.9v43H512V245c0-17-6.7-33.3-18.7-45.3l-21-21C436.2 142.7 416 93.9 416 43V0zM640 288H608V245c0-42.4-16.9-83.1-46.9-113.1l-21-21C522.1 92.9 512 68.4 512 43V0h32V43c0 17 6.7 33.3 18.7 45.3l21 21c36 36 56.2 84.8 56.2 135.8v43zM30.9 450.3C10.8 439.7 0 432 0 432s10.8-7.7 30.9-18.3C75.6 390.1 166.6 352 288 352H608h32v32 96 32H608 288c-121.4 0-212.4-38.1-257.1-61.7zM66 432c7.2 3.3 15.2 6.8 23.9 10.3c47 18.8 115 37.7 198.1 37.7h35.2l-71.5-85.8-7.1-8.5c-63.5 5.1-116.2 20.6-154.7 36c-8.7 3.5-16.7 6.9-23.9 10.3zm417.2 48l-71.5-85.8L403.2 384H288l-3.2 0 71.5 85.7 8.5 10.2H483.2zm33.1-10.2l8.5 10.2H608V384H444.8l71.5 85.8z'
      
    ]
  };

  

  
  

  var faBracketRound = {
    prefix: 'fasl',
    iconName: 'bracket-round',
    icon: [
      192,
      512,
      ["parenthesis"],
      '28',
      
      'M0 256C0 136.7 91.2 58.4 136.4 33.9l15.2 28.1C111.5 83.8 32 153.4 32 256s79.5 172.2 119.6 193.9l-15.2 28.1C91.2 453.6 0 375.3 0 256z'
      
    ]
  };

  
    var faParenthesis = faBracketRound;
  

  
  

  var faIgloo = {
    prefix: 'fasl',
    iconName: 'igloo',
    icon: [
      576,
      512,
      [],
      'f7ae',
      
      'M576 320v32 96 32H544 384 192 32 0V448 320C0 160.9 128.9 32 288 32s288 128.9 288 288zm-32 32H480 448 384v96H544V352zm0-32c0-46.6-12.5-90.3-34.2-128H480V320h64zM352 192H320 128V320h69.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H448V192H352zM96 352H32v96H192V352H128 96zm0-32V192H66.2C44.5 229.7 32 273.4 32 320H96zM487.9 160C453.8 117.5 406.4 86.1 352 72.1V160H487.9zM320 66c-10.5-1.3-21.2-2-32-2c-80.8 0-152.9 37.5-199.9 96H320V66zM288 288c-35.3 0-64 28.7-64 64v96H352V352c0-35.3-28.7-64-64-64z'
      
    ]
  };

  

  
  

  var faSchool = {
    prefix: 'fasl',
    iconName: 'school',
    icon: [
      640,
      512,
      [127979],
      'f549',
      
      'M32 96H160L320 0 480 96H608h32v32V480v32H608 384 352 288 256 32 0V480 128 96H32zM352 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v96h64V384zm32 96H608V128H480c-5.8 0-11.5-1.6-16.5-4.6L320 37.3 176.5 123.4c-5 3-10.7 4.6-16.5 4.6H32V480H256V384c0-35.3 28.7-64 64-64s64 28.7 64 64v96zM96 160h16 64 16v16 96 16H176 112 96V272 176 160zm32 32v64h32V192H128zm336-32h64 16v16 96 16H528 464 448V272 176 160h16zm16 96h32V192H480v64zM96 320h16 64 16v16 96 16H176 112 96V432 336 320zm32 32v64h32V352H128zm336-32h64 16v16 96 16H528 464 448V432 336 320h16zm48 96V352H480v64h32zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm16 64v16h8 16v32H344 320 304V192 160 144h32v16z'
      
    ]
  };

  

  
  

  var faBriefcaseBlank = {
    prefix: 'fasl',
    iconName: 'briefcase-blank',
    icon: [
      512,
      512,
      [],
      'e0c8',
      
      'M144 0H128V16 96H32 0v32V448v32H32 480h32V448 128 96H480 384V16 0H368 144zM352 96H160V32H352V96zM144 128H368 480V448H32V128H144z'
      
    ]
  };

  

  
  

  var faChartCandlestick = {
    prefix: 'fasl',
    iconName: 'chart-candlestick',
    icon: [
      512,
      512,
      [],
      'e0e2',
      
      'M32 48V32H0V48 464v16H16 496h16V448H496 32V48zm288 0V32H288V48 96H256v32 96 32h32v48 16h32V304 256h32V224 128 96H320V48zM192 64H160V80v48H128v32V288v32h32v48 16h32V368 320h32V288 160 128H192V80 64zm128 64v96H288V128h32zm128 96v64H416V224h32zm-32-32H384v32 64 32h32v48 16h32V368 320h32V288 224 192H448V144 128H416v16 48zM160 160h32V288H160V160z'
      
    ]
  };

  

  
  

  var faRoadBarrier = {
    prefix: 'fasl',
    iconName: 'road-barrier',
    icon: [
      640,
      512,
      [],
      'e562',
      
      'M32 48V32H0V48 80H0v32V272v32L0 464v16H32V464l0-160H608V464v16h32V464 304 272 112 80 48 32H608V48 80H32V48zm0 224l0-160H150.1l-80 160H32zM608 112V272H489.9l80-160H608zm-294.1 0h92.2l-80 160H233.9l80-160zM454.1 272H361.9l80-160h92.2l-80 160zm-176-160l-80 160H105.9l80-160h92.2z'
      
    ]
  };

  

  
  

  var faMortarPestle = {
    prefix: 'fasl',
    iconName: 'mortar-pestle',
    icon: [
      512,
      512,
      [],
      'f5a7',
      
      'M252.3 160h53.9L464.6 43.4l1.9 2.2L352 160h45.3L510.1 47.2 469.5 0 252.3 160zM480 192H448 64 32 16 0v32H16 32v32c0 71.6 32.7 130.1 93.8 163c9.4 5 19.4 9.5 30.1 13.3c-6.8 8.5-12.5 17.8-16.9 27.9c-2.8 6.4-5.2 13-6.9 19.9c-2.6 10.2-4 21-4 32h32H352h32c0-11-1.4-21.8-4-32c-1.8-6.9-4.1-13.5-6.9-19.9c-4.5-10-10.2-19.4-16.9-27.9c10.7-3.8 20.7-8.2 30.1-13.3c61.1-32.9 93.8-91.4 93.8-163V224h16 16V192H496 480zM346.5 480H165.5c3.6-10.2 8.8-19.5 15.4-27.8l28-35.1-42.3-15C99.3 378.2 64 325.4 64 256V224H448v32c0 69.4-35.3 122.2-102.6 146.1l-42.3 15 28 35.1c6.6 8.3 11.9 17.6 15.4 27.8z'
      
    ]
  };

  

  
  

  var faShieldCheck = {
    prefix: 'fasl',
    iconName: 'shield-check',
    icon: [
      512,
      512,
      [],
      'f2f7',
      
      'M48.5 114.9L256 34.3l207.5 80.5c2.7 45.6-4.5 116.8-34.7 186.3S345.4 438.4 256 477.1C166.6 438.4 113.4 370.7 83.2 301.2S45.8 160.5 48.5 114.9zm447-1.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM363.3 203.3L374.6 192 352 169.4l-11.3 11.3L224 297.4l-52.7-52.7L160 233.4 137.4 256l11.3 11.3 64 64L224 342.6l11.3-11.3 128-128z'
      
    ]
  };

  

  
  

  var faUserAlien = {
    prefix: 'fasl',
    iconName: 'user-alien',
    icon: [
      448,
      512,
      [],
      'e04a',
      
      'M224 32C154.6 32 96 91.1 96 167c0 46.1 31.7 92.3 70.4 130.4c18.6 18.3 37.4 33.3 51.5 43.7c2.1 1.6 4.2 3 6.1 4.4c1.9-1.3 3.9-2.8 6.1-4.4c14.1-10.4 32.9-25.3 51.5-43.7C320.3 259.4 352 213.1 352 167c0-75.9-58.6-135-128-135zM64 167C64 74.8 135.6 0 224 0s160 74.8 160 167c0 119.3-160 217-160 217s-160-97.7-160-217zM168.6 384H71.8L43 480H405l-28.8-96H279.4c11.3-8.8 24.3-19.5 37.7-32H400l38.4 128 9.6 32H414.6 33.4 0l9.6-32L48 352h82.9c13.4 12.5 26.3 23.2 37.7 32zM149.1 176.8l48 16 15.2 5.1-10.1 30.4-15.2-5.1-48-16-15.2-5.1 10.1-30.4 15.2 5.1zm160 30.4l-48 16-15.2 5.1-10.1-30.4 15.2-5.1 48-16 15.2-5.1 10.1 30.4-15.2 5.1z'
      
    ]
  };

  

  
  

  var faSnowman = {
    prefix: 'fasl',
    iconName: 'snowman',
    icon: [
      512,
      512,
      [9731,9924],
      'f7d0',
      
      'M256 0C194.1 0 144 50.1 144 112c0 17.6 4.1 34.2 11.3 49c-5.7 7.3-10.7 15.2-14.7 23.6L96 169.8V112 96H64v16 47.1L21.1 144.8 10.9 175.2 130.4 215c-1.6 8.1-2.4 16.4-2.4 25c0 14 2.2 27.4 6.4 40C110.5 308 96 344.3 96 384c0 50.3 23.2 95.1 59.4 124.4l4.4 3.6h5.7 181 5.7l4.4-3.6C392.8 479.1 416 434.3 416 384c0-39.7-14.5-76-38.4-104c4.1-12.6 6.4-26.1 6.4-40c0-8.5-.8-16.9-2.4-25l119.5-39.8-10.1-30.4L448 159.1V112 96H416v16 57.8l-44.6 14.9c-4.1-8.4-9-16.4-14.7-23.6c7.2-14.8 11.3-31.5 11.3-49C368 50.1 317.9 0 256 0zM176 112c0-44.2 35.8-80 80-80s80 35.8 80 80c0 15.6-4.5 30.2-12.2 42.5L317.2 165l8.5 9C342 191.2 352 214.4 352 240c0 13.3-2.7 25.9-7.5 37.3l-4.1 9.8 7.4 7.6C370.2 317.8 384 349.3 384 384c0 38.2-16.7 72.5-43.3 96H171.3c-26.6-23.5-43.3-57.8-43.3-96c0-34.7 13.8-66.2 36.3-89.3l7.4-7.6-4.1-9.8c-4.8-11.5-7.5-24.1-7.5-37.3c0-25.6 10-48.8 26.3-66l8.5-9-6.6-10.5C180.5 142.2 176 127.6 176 112zm48 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 24.3c0 2.9 .8 5.8 2.3 8.3L256 168l13.7-23.4c1.5-2.5 2.3-5.4 2.3-8.3V136c0-8.8-7.2-16-16-16s-16 7.2-16 16v.3zM272 336V304H240v32h32zm0 48H240v32h32V384zm0-160H240v32h32V224zM304 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faWheatAwnCircleExclamation = {
    prefix: 'fasl',
    iconName: 'wheat-awn-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e598',
      
      'M78.2 411L4.7 484.5l22.6 22.6 73.5-73.5 0 0 33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6 22.6-22.6L298.4 405c8.3-.5 16.6-2 24.5-4.6c-2-10.5-3-21.3-3-32.4l0-.8c-23.7 11-52.6 6.7-72.2-12.8l-33.9-33.9c31.8-31.8 80.4-36.6 117.3-14.4c4.5-12 10.3-23.4 17.2-33.9c-3.6-2.3-6.9-5.1-10.1-8.2L304.4 230c29.9-29.9 74.5-35.9 110.4-18.2c11.6-6.1 24-10.9 37-14.2c-2.5-2-5-3.9-7.6-5.6L491 145.1l11.3-11.3-22.6-22.6-11.3 11.3L414 176.9c-16.1-5.5-33-7.8-49.8-6.7L491 43.3 468.4 20.7 341.6 147.5c1-16.8-1.2-33.7-6.7-49.8l54.3-54.4L400.5 32 377.9 9.4 366.6 20.7 319.8 67.5c-4.5-6.5-9.6-12.8-15.4-18.6L293.1 37.7 270.5 15.1 247.8 37.7 225.2 60.3c-17.4 17.4-26.7 39.8-28 62.6L180 105.6l-22.6 22.6-22.6 22.6c-17.4 17.4-26.7 39.8-28 62.6L89.5 196.1 66.9 218.7 44.3 241.3c-37.5 37.5-37.5 98.3 0 135.8L78.2 411l0 0zM191.6 297.5l-.3 .3-33.9-33.9c-25-25-25-65.5 0-90.5L180 150.8l11.3 11.3c37.4 37.4 37.5 97.9 .4 135.4zM270.5 60.3l11.3 11.3c37.5 37.5 37.5 98.2 0 135.7l-33.9-33.9c-25-25-25-65.5 0-90.5l22.6-22.6zM100.8 252.6c37.5 37.5 37.5 98.2 0 135.7L66.9 354.4c-25-25-25-65.5 0-90.5l22.6-22.6 11.3 11.3zM259.2 411l11.3 11.3-22.6 22.6c-25 25-65.5 25-90.5 0L123.5 411c37.5-37.5 98.2-37.5 135.7 0zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 448V416H480v32h32zm0-160H480v16 80 16h32V384 304 288z'
      
    ]
  };

  

  
  

  var faGunSquirt = {
    prefix: 'fasl',
    iconName: 'gun-squirt',
    icon: [
      576,
      512,
      [],
      'e19d',
      
      'M128 48V32H96V48l0 16C43 64 0 107 0 160c0 50.4 38.8 91.7 88.1 95.7L40 448l-8 32H65 192l32-128h64v16 16h32V368 336 304 288H288v16 16H232l16-64 264 0h16V240 208h32 16V192 128 112H560 528V80 64H512 128V48zM96 96h32H496v32 16h16 32v32H512 496v16 32H96c-35.3 0-64-28.7-64-64s28.7-64 64-64zm0 48H80v32H96 448h16V144H448 96zM215 256L167 448H73l48-192h94z'
      
    ]
  };

  

  
  

  var faPiano = {
    prefix: 'fasl',
    iconName: 'piano',
    icon: [
      512,
      512,
      [],
      'f8d4',
      
      'M432 384v32 16H400V416 384H368v32 16H336V416 384H240v32 16H208V416 384H176v32 16H144V416 384H112v32 16H80V416 384H32v96H480V384H432zm0-32h48V307.8L369.7 252.6 352 243.8V224 192c0-88.4-71.6-160-160-160S32 103.6 32 192V352H80h32 32 32 32 32 96 32 32 32zm80-64v64 16 16 96 32H480 32 0V480 384 368 352 192C0 86 86 0 192 0S384 86 384 192v32l128 64z'
      
    ]
  };

  

  
  

  var faPepper = {
    prefix: 'fasl',
    iconName: 'pepper',
    icon: [
      512,
      512,
      [129745],
      'e432',
      
      'M245.5 36.5c10.6 16.8 21.2 40 25 69c19.5-9.3 42.2-12.2 64.7-6.5c10.5 2.6 20.1 6.9 28.7 12.4c21.5-13.8 48.5-19.1 75.3-12.4c51.4 12.9 82.7 65 69.8 116.4l-56 224c-12.9 51.4-65 82.7-116.4 69.8c-10.5-2.6-20.1-6.9-28.7-12.4c-5.7 3.7-11.8 6.7-18.3 9.2c-10.6 4-22 6.1-33.7 6.1c-11.7 0-23.1-2.1-33.7-6.1c-6.5-2.4-12.6-5.5-18.3-9.2c-8.6 5.5-18.3 9.8-28.7 12.4C123.8 522 71.7 490.7 58.9 439.3l-56-224C-10 163.8 21.3 111.7 72.7 98.9c26.8-6.7 53.8-1.4 75.3 12.4c7.5-4.9 15.9-8.7 24.9-11.4c.7-.2 1.5-.4 2.2-.6c.6-.2 1.1-.3 1.7-.4c.1 0 .1 0 .2 0L192.2 95l.3 1.3c15.9-1.2 31.4 1.5 45.4 7.5c-3.6-20.9-11.5-37.7-19.5-50.3c-5.4-8.5-10.8-15-14.7-19.3c-2-2.1-3.6-3.7-4.6-4.7c-.5-.5-.9-.9-1.2-1.1l-.2-.2 0 0 0 0s0 0 10.3-12.3S218.2 3.7 218.3 3.7l0 0 0 0 .1 .1 .2 .2 .6 .5c.5 .4 1.1 1 1.9 1.7c1.6 1.5 3.7 3.6 6.2 6.3c5 5.5 11.7 13.5 18.3 23.9zm-60.9 93.4c0 0-.1 0-.1 0c-34.3 8.6-55.1 43.3-46.6 77.6L175.5 358l3.9 15.5-31 7.8-3.9-15.5L106.9 215.3c-7.3-29.3-.3-58.8 16.5-81.1c-12.9-6.1-28-8-42.9-4.2c-34.3 8.6-55.1 43.3-46.6 77.6l56 224c8.6 34.3 43.3 55.1 77.6 46.6c10-2.5 18.8-7.2 26.1-13.4l10.4-8.9 10.4 8.9c5.5 4.7 12 8.6 19.1 11.3l0 0c7.1 2.7 14.7 4.1 22.5 4.1h0c7.8 0 15.4-1.4 22.4-4.1l0 0c7.1-2.7 13.6-6.5 19.1-11.3l10.4-8.9 10.4 8.9c7.3 6.2 16.1 10.9 26.1 13.4c34.3 8.6 69-12.3 77.6-46.6l56-224c8.6-34.3-12.3-69-46.6-77.6c-20.9-5.2-41.9 .4-57.1 13.4L364 152.2l-10.4-8.9c-7.3-6.2-16.1-10.9-26.1-13.4c-22.4-5.6-44.9 1.3-60.3 16.4L256 157.2l-11.2-10.9c-15.4-15-37.9-21.9-60.2-16.4zM256 512h0l0-16 0 16h0z'
      
    ]
  };

  

  
  

  var faTruckMedical = {
    prefix: 'fasl',
    iconName: 'truck-medical',
    icon: [
      640,
      512,
      [128657,"ambulance"],
      'f0f9',
      
      'M384 32V384H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H32V32H384zM32 416H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32 16 16V384H624 608V224v-5.9l-3.9-4.5-96-112L503.4 96H496 416V32 0H384 32 0V32 384v32H32zM416 128h72.6l82.3 96H416V128zm0 216.4V256H576V384h-5.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM176 64H160V80v48l-48 0H96v16 64 16h16 48v48 16h16 64 16V272 224h48 16V208 144 128H304 256V80 64H240 176zm16 80V96h32v48 16h16 48v32H240 224v16 48H192V208 192H176 128V160h48 16V144z'
      
    ]
  };

  
    var faAmbulance = faTruckMedical;
  

  
  

  var faApartment = {
    prefix: 'fasl',
    iconName: 'apartment',
    icon: [
      576,
      512,
      [],
      'e468',
      
      'M448 160h32 64 32v32V480v32H544 448 352 336 288 256 240 224 128 32 0V480 128 96H32 96h32V64 32 0h32H416h32V32v96 32zM224 480V368 352h16 96 16v16V480h96 96V192H448 416V160 32H160V96v32H128 32V480h96 96zm96 0V384H256v96h32 32zm192-32H496 432 416V432 368 352h16 64 16v16 64 16zm-32-32V384H448v32h32zM144 384H80 64V368 304 288H80h64 16v16 64 16H144zm-16-64H96v32h32V320zm384 0H496 432 416V304 240 224h16 64 16v16 64 16zm-32-64H448v32h32V256zm-336 0H80 64V240 176 160H80h64 16v16 64 16H144zm-16-64H96v32h32V192zm208 96H320 256 240V272 208 192h16 64 16v16 64 16zm-32-64H272v32h32V224zm16-64H256 240V144 80 64h16 64 16V80v64 16H320zM304 96H272v32h32V96z'
      
    ]
  };

  

  
  

  var faTriangle = {
    prefix: 'fasl',
    iconName: 'triangle',
    icon: [
      512,
      512,
      [9650],
      'f2ec',
      
      'M0 480l18.3-32L237.6 64.2 256 32l18.4 32.2L493.7 448 512 480H475.1 36.9 0zM256 96.5L55.1 448H456.9L256 96.5z'
      
    ]
  };

  

  
  

  var faFileMov = {
    prefix: 'fasl',
    iconName: 'file-mov',
    icon: [
      512,
      512,
      [],
      'e647',
      
      'M352 192v96h32V152L232 0H32 0V32 480v32H32 64V480H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM256 368V352l-16 0-5.6 0-9.6 0-4.5 8.5-28.5 53.8-29.7-54-4.6-8.3-9.5 0-4 0-16 0v16V496v16h32V496 423l18 32.7 14.3 26 13.9-26.2L224 421.8V496v16h32V496 368zm192 0V352H416v16 35c0 21.1 3.8 42 11.2 61.8L441 501.6l3.9 10.4H456h16 11.1l3.9-10.4 13.8-36.8C508.2 445 512 424.1 512 403V368 352H480v16 35c0 17.3-3.1 34.4-9.2 50.6L464 471.8l-6.8-18.2c-6.1-16.2-9.2-33.3-9.2-50.6V368zM288 392v80c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8z'
      
    ]
  };

  

  
  

  var faHeadSideCoughSlash = {
    prefix: 'fasl',
    iconName: 'head-side-cough-slash',
    icon: [
      640,
      512,
      [],
      'e062',
      
      'M224 32h24c88.4 0 160 71.6 160 160v7.2l5.4 4.8L480 263.2v37.6L512 326V320 256v-7.2l-5.4-4.8-66.8-59.3C436 82 351.6 0 248 0H224c-34.8 0-67.7 7.9-97.1 22.1l28.5 22.5C176.8 36.4 199.9 32 224 32zM31.3 109.7C11.4 143.1 0 182.2 0 224c0 61 24.4 116.4 64 156.8V496v16H96V496 374.1v-6.8l-4.9-4.7C54.6 327.6 32 278.4 32 224c0-34.3 9-66.5 24.7-94.3l-25.4-20zM528.5 339.1l33.7 26.6c8.1-3.8 13.8-12.1 13.8-21.7c0-13.3-10.7-24-24-24c-11.6 0-21.2 8.2-23.5 19.1zm63.6 50.2l32 25.3c9.2-3.3 15.8-12.2 15.8-22.6c0-13.3-10.7-24-24-24c-12.3 0-22.5 9.3-23.9 21.3zM432 426l-23.6-18.7-72.4-6V389.9l42.6-6.1-34.7-27.4-26.2 3.7-13.7 2V376v40 14.7l14.7 1.2 81.3 6.8V456H304 288v16 24 16h32V496v-8h96 16V472 426zM640 296a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faPear = {
    prefix: 'fasl',
    iconName: 'pear',
    icon: [
      512,
      512,
      [],
      'e20c',
      
      'M507.3 27.3L453.1 81.5c39.1 50.2 35.5 122.8-10.6 169l-58.8 58.8c.2 3.5 .3 7.1 .3 10.7c0 106-86 192-192 192S0 426 0 320S86 128 192 128c3.6 0 7.2 .1 10.7 .3l58.8-58.8c46.2-46.2 118.8-49.7 169-10.6L484.7 4.7l22.6 22.6zM388.7 100.7l18.9-18.9C370.1 55 317.8 58.5 284.1 92.1l-58.8 58.8L215.2 161l-14.3-.8c-3-.2-5.9-.2-8.9-.2c-88.4 0-160 71.6-160 160s71.6 160 160 160s160-71.6 160-160c0-3-.1-6-.2-8.9l-.8-14.3 10.1-10.1 58.8-58.8c33.6-33.6 37.1-86 10.4-123.5l-18.9 18.9L400 134.6 377.4 112l11.3-11.3zM272 336h32c0 53-43 96-96 96V400c35.3 0 64-28.7 64-64z'
      
    ]
  };

  

  
  

  var faStaffSnake = {
    prefix: 'fasl',
    iconName: 'staff-snake',
    icon: [
      384,
      512,
      ["rod-asclepius","rod-snake","staff-aesculapius"],
      'e579',
      
      'M208 0H176V48H120 88 72 64C28.7 48 0 76.7 0 112v32 32H32 80c35.3 0 64-28.7 64-64V80h32V192v32 64H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V192H128c-35.3 0-64 28.7-64 64s28.7 64 64 64h48v96H112 96v32h16 64v64h32V448 416 320h32c26.5 0 48 21.5 48 48s-21.5 48-48 48v32c44.2 0 80-35.8 80-80s-35.8-80-80-80H208V224 192 80h88c30.9 0 56 25.1 56 56s-25.1 56-56 56H240v32h56c48.6 0 88-39.4 88-88s-39.4-88-88-88H208V0zM112 80v32c0 17.7-14.3 32-32 32H32V112c0-17.7 14.3-32 32-32h8H88h24zM72 120a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  
    var faRodAsclepius = faStaffSnake;
  
    var faRodSnake = faStaffSnake;
  
    var faStaffAesculapius = faStaffSnake;
  

  
  

  var faSpiderBlackWidow = {
    prefix: 'fasl',
    iconName: 'spider-black-widow',
    icon: [
      512,
      512,
      [],
      'f718',
      
      'M0 132.5v14.1l.8 2.5 24 72 2.7 8.2 8.4 2.2L129.1 256 35.9 280.5l-8.4 2.2-2.7 8.2-24 72L0 365.4v14.1l26.1 8.7 5.1-15.2 21.3-63.8L144.8 285 75 382.7l-4.9 6.8 2.8 7.9 40 112 30.1-10.8L105.9 394.5 144.1 341c2.6 59.5 51.7 107 111.9 107s109.3-47.5 111.9-107l38.2 53.5L368.9 498.6l30.1 10.8 40-112 2.8-7.9-4.9-6.8L367.2 285l92.3 24.3 21.3 63.8 5.1 15.2 26.1-8.7V365.4l-.8-2.5-24-72-2.7-8.2-8.4-2.2L382.9 256l93.2-24.5 8.4-2.2 2.7-8.2 24-72 .8-2.5V132.5l-26.1-8.7-5.1 15.2-21.3 63.8-110 28.9 86.2-92.8 7.3-7.9-4.6-9.8-56-120-29 13.5L404.9 125 336 199.3V152c0-32.2-19-59.9-46.3-72.6L276 73.1l-7.2 13.3L256 110.3 243.1 86.4 236 73.1l-13.7 6.4C195 92.1 176 119.8 176 152v47.3L107.1 125 158.5 14.8l-29-13.5-56 120L68.9 131l7.3 7.9 86.2 92.8-110-28.9L31.2 138.9l-5.1-15.2L0 132.5zm288.8-15.6c9.4 8.8 15.2 21.3 15.2 35.1V256v0l0 .4 0 7.2 5.4 4.8C325.7 283 336 304.3 336 328v8c0 44.2-35.8 80-80 80s-80-35.8-80-80v-8c0-23.7 10.3-45 26.7-59.6l5.4-4.8 0-7.2 0-.4v0V152c0-13.8 5.9-26.3 15.2-35.1l18.7 34.7L256 177.8l14.1-26.2 18.7-34.7zM216 288v16l24 32-24 32v16h80V368l-24-32 24-32V288H216z'
      
    ]
  };

  

  
  

  var faCircleD = {
    prefix: 'fasl',
    iconName: 'circle-d',
    icon: [
      512,
      512,
      [],
      'e104',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128H160v16V368v16h16 80c70.7 0 128-57.3 128-128s-57.3-128-128-128H176zm80 224H192V160h64c53 0 96 43 96 96s-43 96-96 96z'
      
    ]
  };

  

  
  

  var faHammerWar = {
    prefix: 'fasl',
    iconName: 'hammer-war',
    icon: [
      384,
      512,
      [],
      'f6e4',
      
      'M208 16V0H176V16 60.4L48 32H32 0V64 256v32H32 48l144-32 144 32h16 32V256 64 32H352 336L208 60.4V16zm0 276.3l-16-3.6-16 3.6V496v16h32V496 292.3zm-22.9-67.6L44.5 256H32V64H44.5L185.1 95.2c4.6 1 9.3 1 13.9 0L339.5 64H352V256H339.5L198.9 224.8c-4.6-1-9.3-1-13.9 0z'
      
    ]
  };

  

  
  

  var faBicycle = {
    prefix: 'fasl',
    iconName: 'bicycle',
    icon: [
      640,
      512,
      [128690],
      'f206',
      
      'M304 32H288V64h16 38.3l50.5 96H223.5l-33.7-56.2L185.1 96H176 112 96v32h16 54.9L197 178.2l-26.5 53.1c-13.3-4.7-27.6-7.2-42.5-7.2C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h65 9.5l4.5-8.3 83.4-152.9 21.2 40.3C405.6 270.2 384 308.6 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-15.8 0-31 2.9-45 8.1L366.2 40.5 361.7 32H352 304zM453.8 275.7l44.1 83.8 7.5 14.2 28.3-14.9-7.4-14.2-44.1-83.8c9.4-3.1 19.5-4.8 29.9-4.8c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-31.1 14.8-58.8 37.8-76.3zM156 260.2l-42.3 84.7L128 368h94.7c-7.6 45.4-47.1 80-94.7 80c-53 0-96-43-96-96s43-96 96-96c9.8 0 19.2 1.5 28 4.2zM224 336H153.9l62.7-125.3L291.7 336H256 224zm18.7-144H389L319.3 319.8 242.7 192z'
      
    ]
  };

  

  
  

  var faBangladeshiTakaSign = {
    prefix: 'fasl',
    iconName: 'bangladeshi-taka-sign',
    icon: [
      384,
      512,
      [],
      'e2e6',
      
      'M32 64H48c26.5 0 48 21.5 48 48v80H32v32H96V400c0 44.2 35.8 80 80 80h32c97.2 0 176-78.8 176-176V272c0-44.2-35.8-80-80-80H256v32h48c26.5 0 48 21.5 48 48v32c0 79.5-64.5 144-144 144H176c-26.5 0-48-21.5-48-48V224h64V192H128V112c0-44.2-35.8-80-80-80H32V64z'
      
    ]
  };

  

  
  

  var faCalendars = {
    prefix: 'fasl',
    iconName: 'calendars',
    icon: [
      512,
      512,
      [],
      'e0d7',
      
      'M224 0V16 64H384V16 0h32V16 64h64 32V96v96V384v32H480 128 96V384 192 96 64h32 64V16 0h32zM128 96v64H480V96H128zm352 96H128V384H480V192zM32 208V480H368h16v32H368 16 0V496 208 192H32v16z'
      
    ]
  };

  

  
  

  var faCircleArrowUpRight = {
    prefix: 'fasl',
    iconName: 'circle-arrow-up-right',
    icon: [
      512,
      512,
      [],
      'e0fc',
      
      'M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm80 160h16v16V320v16H320V320 214.6L187.3 347.3 176 358.6 153.4 336l11.3-11.3L297.4 192H200 184V160h16H336z'
      
    ]
  };

  

  
  

  var faLeafyGreen = {
    prefix: 'fasl',
    iconName: 'leafy-green',
    icon: [
      576,
      512,
      [129388],
      'e41d',
      
      'M226.4 37.9c-7.8 12.9-13.4 27.3-16.2 42.7l-.1 .1c-1.8-11.7-7.1-22.9-16.2-31.9c-22.4-22.4-58.7-22.4-81.1 0c-9.9 9.9-15.4 22.5-16.6 35.5L94 109.1l-24.6 4c-8.9 1.4-17.4 5.6-24.3 12.5c-16.5 16.5-17.4 42.7-2.7 60.2l7.5 8.9v11.7 59.4l44.8 44.8 1.3 1.3v77.8L72.1 413.4V387.2l0-54.2L17.9 278.9V206.3c-25.3-30.1-23.8-75.1 4.5-103.4C34.3 91.1 49 83.9 64.3 81.4c1.8-20.2 10.4-39.8 25.8-55.3c34.9-34.9 91.5-34.9 126.4 0c3.7 3.7 7 7.6 9.9 11.7zm283 144.5l16-19.1C537 149.4 544 131.6 544 112c0-44.2-35.8-80-80-80c-19.6 0-37.4 7-51.3 18.6l-19.1 16L373.4 52.1C362.9 44.5 350 40 336 40c-33.5 0-60.9 25.7-63.8 58.4l-1 11.6-8.3 8.3-55 55V256v13.3l-9.4 9.4L160 317.3v76.1l96-96V208 192h32v16 57.4l36.7-36.7 96-96L432 121.4 454.6 144l-11.3 11.3L374.6 224H432h16v32H432 342.6l-59.3 59.3L182.6 416h76.1l38.6-38.6 9.4-9.4H320h82.7l55-55 8.3-8.3 11.6-1c32.7-2.8 58.4-30.3 58.4-63.8c0-14-4.5-26.9-12.1-37.4l-14.6-20.2zM416 400H320l-48 48-121.4 0-36.8 36.8-11.3 11.3L91.2 507.4 68.6 484.8l11.3-11.3 11.3-11.3L128 425.4V304l48-48V160l64.4-64.4C244.6 46.5 285.8 8 336 8c21 0 40.3 6.7 56.1 18.1C411.6 9.8 436.6 0 464 0c61.9 0 112 50.1 112 112c0 27.4-9.8 52.4-26.1 71.9C561.3 199.7 568 219 568 240c0 50.2-38.5 91.4-87.6 95.6L416 400z'
      
    ]
  };

  

  
  

  var faSquid = {
    prefix: 'fasl',
    iconName: 'squid',
    icon: [
      512,
      512,
      [129425],
      'e450',
      
      'M510.3 19L512 0 493 1.7c-36.7 3.1-69.8 8.2-99.6 14.8l0-.4L258.4 3.3 238.7 1.4 241 21.1l6.3 54.2c-13.6 9.2-25.6 18.9-36.2 29c-44.1 42.3-61.6 90.2-65.9 130.3l-40.1-40.1c-6.1-6.1-6.3-15.9-.4-22.2l60.4-65c18.5-20 16.8-51.4-3.9-69.1L130.4 11.9l-9.7-8.4-10.3 7.7-5 3.7c-38.6 29-42.9 85.2-9.4 119.7L81.3 150.5c-17.6 18.9-17 48.3 1.2 66.6l50.3 50.3-20.7 30.1L73.9 259.3c-18.7-18.7-49.1-18.7-67.9 0l-1.4 1.4 22.6 22.6 1.4-1.4c6.2-6.2 16.4-6.2 22.6 0l42.3 42.3-24.1 35c-3.8 5.5-9.9 8.7-16.6 8.7c-11.1 0-20.1-9-20.1-20.1V336 320H.9v16 11.9C.9 376.7 24.2 400 53 400c17.2 0 33.2-8.4 42.9-22.6l20.7-30.1 48.1 48.1-29.5 20.3c-14.6 10-23.2 26.7-22.9 44.4c.5 28.8 24 52 52.8 52h11.7 16V480h-16H165.2c-11.4 0-20.7-9.1-20.8-20.5c-.1-7 3.3-13.6 9-17.5l34.4-23.6 42.3 42.3c6.2 6.2 6.2 16.4 0 22.6l-1.4 1.4 22.6 22.6 1.4-1.4c18.7-18.7 18.7-49.1 0-67.9l-38.1-38.1 30.1-20.7 50.3 50.3c18.3 18.3 47.7 18.8 66.6 1.2L377.4 416c34.5 33.5 90.7 29.2 119.7-9.4l3.7-5 7.7-10.3-8.4-9.7-26.3-30.7c-17.7-20.7-49.1-22.5-69.1-3.9l-65 60.4c-6.3 5.9-16.1 5.7-22.2-.4l-40.1-40.1c40.1-4.4 88.1-21.9 130.3-65.9c10.1-10.5 19.8-22.5 29-36.1l54 7.1 19.9 2.6-1.9-20-12.8-136-.4 0c6.6-29.8 11.6-62.8 14.8-99.6zm-39 179.5l3.7 39-20.4-2.7c5.9-11.2 11.5-23.3 16.7-36.3zM191.5 376.9l-56.4-56.4 38.1-55.4L176 261v-5c0-36.4 12.3-85.5 57.3-128.7c43-41.2 117.3-78.3 243.3-92c-13.6 126-50.7 200.3-92 243.3C341.5 323.7 292.4 336 256 336h-5l-4.1 2.8-55.4 38.1zM277.5 57.3L275.1 37l38.5 3.6c-12.9 5.2-25 10.7-36.1 16.6zM117.8 111.1c-17.4-19.2-16.2-48.5 1.8-66.3l20.6 17.7c6.9 5.9 7.5 16.4 1.3 23l-23.8 25.6zm283 283l25.6-23.8c6.7-6.2 17.1-5.6 23 1.3l17.7 20.6c-17.8 18.1-47.2 19.2-66.3 1.8zM240.9 320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faSparkles = {
    prefix: 'fasl',
    iconName: 'sparkles',
    icon: [
      512,
      512,
      [10024],
      'f890',
      
      'M448 32V48 96h48 16v32H496 448v48 16H416V176 128H368 352V96h16 48V48 32h32zm0 288v16 48h48 16v32H496 448v48 16H416V464 416H368 352V384h16 48V336 320h32zm-99.8-46.1L256 320l-46.1 92.2L192 448l-17.9-35.8L128 320 35.8 273.9 0 256l35.8-17.9L128 192l46.1-92.2L192 64l17.9 35.8L256 192l92.2 46.1L384 256l-35.8 17.9zM227.4 305.7l4.8-9.5 9.5-4.8L312.4 256l-70.8-35.4-9.5-4.8-4.8-9.5L192 135.6l-35.4 70.8-4.8 9.5-9.5 4.8L71.6 256l70.8 35.4 9.5 4.8 4.8 9.5L192 376.4l35.4-70.8z'
      
    ]
  };

  

  
  

  var faV = {
    prefix: 'fasl',
    iconName: 'v',
    icon: [
      384,
      512,
      [118],
      '56',
      
      'M349 32h34.5L206.8 470l-4 10H181.2l-4-10L.5 32H35L192 421.2 349 32z'
      
    ]
  };

  

  
  

  var faObjectsAlignBottom = {
    prefix: 'fasl',
    iconName: 'objects-align-bottom',
    icon: [
      512,
      512,
      [],
      'e3bb',
      
      'M512 512L0 512l0-32 512 0v32zM192 352l0-320L96 32l0 320h96zM96 384H64l0-32L64 32 64 0H96h96 32V32l0 320v32H192 96zm320-32l0-192H320l0 192h96zm-96 32H288V352l0-192V128h32 96 32v32l0 192v32l-32 0H320z'
      
    ]
  };

  

  
  

  var faBasketballHoop = {
    prefix: 'fasl',
    iconName: 'basketball-hoop',
    icon: [
      640,
      512,
      [],
      'f435',
      
      'M0 201.1c17.8-39.2 44.8-74.5 75.9-104.2C126.4 48.5 206 0 320 0S513.6 48.5 564.1 96.9c31 29.7 58 64.9 75.9 104.2V372.8L505 431.5l4.9-37 98-42.6V208.2c-15.8-32.5-39-62.4-66-88.2C496 76 424 32 320 32S144 76 98 120c-27 25.8-50.2 55.7-66 88.2V351.8l98 42.6 4.9 37L0 372.8V201.1zM146 272H128 112V240h16 16 15.8c.2 0 .3 0 .5 0H192h47.9c.1 0 .1 0 .2 0h31.8c.1 0 .1 0 .2 0h95.8c.1 0 .1 0 .2 0h31.8c.1 0 .1 0 .2 0H448h31.7c.2 0 .3 0 .5 0H496h16 16v32H512 494L463.9 498.1 462 512H440.7l-4.8-5.5-48.3-55.7-56.3 56.5-4.7 4.7H313.4l-4.7-4.7-56.3-56.5-48.3 55.7-4.8 5.5H178l-1.9-13.9L146 272zm32.3 0l7.3 54.7 48.6-53.1-1.4-1.7H178.3zM279 272l-2.1 2.2 43 49.6 43-49.6L361 272H279zm128.3 0l-1.4 1.7 48.6 53.1 7.3-54.7H407.3zM320 473.3l46.6-46.8L320 372.7l-46.6 53.8L320 473.3zm-69.3-69.5l48.1-55.5L255.2 298l-52.6 57.5 48.1 48.3zm-21 24.2l-35.3-35.5 8.8 66.1 26.5-30.6zm159.6-24.2l48.1-48.3L384.8 298l-43.6 50.3 48.1 55.5zm21 24.2l26.5 30.6 8.8-66.1-35.3 35.5zM160 128h16H464h16v16 64H448V160H192v48H160V144 128z'
      
    ]
  };

  

  
  

  var faTooth = {
    prefix: 'fasl',
    iconName: 'tooth',
    icon: [
      448,
      512,
      [129463],
      'f5c9',
      
      'M132 64c14.7 0 29 4.8 40.8 13.6l41.6 31.2 21.3 16 12.8 9.6 19.2-25.6-12.8-9.6-5.4-4 16.3-13.9c13-11.1 29.5-17.2 46.6-17.2c39.5 0 71.6 32.1 71.6 71.6v3c0 11.6-2.7 23-7.9 33.4l-30.4 60.9-1 2.1-.4 2.3L307.4 443.6 271.5 300.1l-3-12.1H256 192 179.5l-3 12.1L140.6 443.6 103.8 237.2l-.4-2.3-1-2.1L71.9 172c-5.2-10.4-7.9-21.8-7.9-33.4V132c0-37.6 30.4-68 68-68zm91.3 11.5L192 52c-17.3-13-38.4-20-60-20C76.8 32 32 76.8 32 132v6.6c0 16.6 3.9 32.9 11.3 47.7l29.4 58.8 39.6 221.7 2.4 13.2H128h24 12.5l3-12.1 37-147.9h39l37 147.9 3 12.1H296h24 13.4l2.4-13.2 39.6-221.7 29.4-58.8c7.4-14.8 11.3-31.1 11.3-47.7v-3C416 78.4 369.6 32 312.4 32c-24.7 0-48.6 8.8-67.4 24.9L223.3 75.5z'
      
    ]
  };

  

  
  

  var faFaceGrinWide = {
    prefix: 'fasl',
    iconName: 'face-grin-wide',
    icon: [
      512,
      512,
      [128515,"grin-alt"],
      'f581',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm89.9-166.2c-22.5 23.6-54.5 38.3-89.9 38.3s-67.4-14.7-89.9-38.3c28.5 5.4 58.7 8.3 89.9 8.3s61.4-2.9 89.9-8.3zm25-38.6c-35.1 9.6-74 14.9-114.9 14.9s-79.9-5.3-114.9-14.9c-13-3.5-25.4-7.7-37.2-12.3c3.1 13.8 8 26.9 14.5 39c26.2 48.9 78 82.2 137.7 82.2s111.5-33.3 137.7-82.2c6.5-12.1 11.4-25.2 14.5-39c-11.8 4.6-24.3 8.8-37.2 12.3zM192 144V128H160v16 96 16h32V240 144zm160 0V128H320v16 96 16h32V240 144z'
      
    ]
  };

  
    var faGrinAlt = faFaceGrinWide;
  

  
  

  var faPills = {
    prefix: 'fasl',
    iconName: 'pills',
    icon: [
      576,
      512,
      [],
      'f484',
      
      'M32 144c0-44.2 35.8-80 80-80s80 35.8 80 80V256H32V144zm0 144H192v80c0 44.2-35.8 80-80 80s-80-35.8-80-80V288zM112 32C50.1 32 0 82.1 0 144V368c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zM517.1 398.5L337.5 218.9C359.2 202 386.4 192 416 192c70.7 0 128 57.3 128 128c0 29.6-10 56.8-26.9 78.5zm-22.6 22.6C472.8 438 445.6 448 416 448c-70.7 0-128-57.3-128-128c0-29.6 10-56.8 26.9-78.5L494.5 421.1zM416 480a160 160 0 1 0 0-320 160 160 0 1 0 0 320z'
      
    ]
  };

  

  
  

  var faArrowDownLeftAndArrowUpRightToCenter = {
    prefix: 'fasl',
    iconName: 'arrow-down-left-and-arrow-up-right-to-center',
    icon: [
      512,
      512,
      [],
      'e092',
      
      'M499.3 35.3L510.6 24 488 1.4 476.7 12.7 320 169.4 320 64V48l-32 0V64l0 144v16h16l144 0h16V192H448l-105.4 0L499.3 35.3zM12.7 476.7L1.4 488 24 510.6l11.3-11.3L192 342.6 192 448v16h32V448l0-144V288H208 64 48l0 32H64 169.4L12.7 476.7z'
      
    ]
  };

  

  
  

  var faHryvniaSign = {
    prefix: 'fasl',
    iconName: 'hryvnia-sign',
    icon: [
      384,
      512,
      [8372,"hryvnia"],
      'f6f2',
      
      'M99.7 86.1C121.3 71.7 146.7 64 172.6 64H231c40.3 0 73 32.7 73 73c0 21.4-9.3 41.3-25 55H0v32H220.2L106 281.1c-4.1 2.1-8.1 4.4-11.8 6.9H0v32H63.6C53.6 336.2 48 355.2 48 375c0 58 47 105 105 105h58.4c32.3 0 63.8-9.5 90.6-27.4l10.9-7.2 13.3-8.9-17.8-26.6-13.3 8.9-10.9 7.2c-21.6 14.4-46.9 22.1-72.9 22.1H153c-40.3 0-73-32.7-73-73c0-21.4 9.3-41.3 25-55H384V288H163.8L278 230.9c4.1-2.1 8.1-4.4 11.8-6.9H384V192H320.4c10-16.2 15.6-35.2 15.6-55c0-58-47-105-105-105H172.6c-32.3 0-63.8 9.5-90.6 27.4L71.1 66.7 57.8 75.6l17.8 26.6 13.3-8.9 10.9-7.2z'
      
    ]
  };

  
    var faHryvnia = faHryvniaSign;
  

  
  

  var faI = {
    prefix: 'fasl',
    iconName: 'i',
    icon: [
      320,
      512,
      [105],
      '49',
      
      'M16 32H0V64H16 144V448H16 0v32H16 304h16V448H304 176V64H304h16V32H304 160 16z'
      
    ]
  };

  

  
  

  var faUserHelmetSafety = {
    prefix: 'fasl',
    iconName: 'user-helmet-safety',
    icon: [
      448,
      512,
      [128119,"user-construction","user-hard-hat"],
      'f82c',
      
      'M192 0H176V16v9.3c-46.9 19-80 65-80 118.7l-16 0H64v32H80 368h16V144H368l-16 0c0-53.7-33.1-99.7-80-118.7V16 0H256 192zM128 144c0-35.5 19.3-66.6 48-83.2V80 96h32V80 32h32V80 96h32V80 60.8c28.7 16.6 48 47.6 48 83.2H128zm96 176c65.3 0 119.1-48.9 127-112H318.7c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H97c7.9 63.1 61.7 112 127 112zM71.8 384H376.2L405 480H43l28.8-96zm366.6 96L400 352H224 48L9.6 480 0 512H33.4 414.6 448l-9.6-32z'
      
    ]
  };

  
    var faUserConstruction = faUserHelmetSafety;
  
    var faUserHardHat = faUserHelmetSafety;
  

  
  

  var faDialHigh = {
    prefix: 'fasl',
    iconName: 'dial-high',
    icon: [
      576,
      512,
      [],
      'e15c',
      
      'M312 8V56H264V8h48zM120 72v48H72V72h48zm336 0h48v48H456V72zM568 264v48H520V264h48zM8 264H56v48H8V264zM120 456v48H72V456h48zm336 0h48v48H456V456zM288 272H415c-7.9-63.1-61.7-112-127-112c-70.7 0-128 57.3-128 128s57.3 128 128 128c65.3 0 119.1-48.9 127-112H288 272V272h16zM128 288a160 160 0 1 1 320 0 160 160 0 1 1 -320 0z'
      
    ]
  };

  

  
  

  var faGlassEmpty = {
    prefix: 'fasl',
    iconName: 'glass-empty',
    icon: [
      384,
      512,
      [],
      'e191',
      
      'M69.6 480H314.4l35-448H34.6l35 448zM344 512H40L2.5 32 0 0H32.1 351.9 384l-2.5 32L344 512z'
      
    ]
  };

  

  
  

  var faDroneFront = {
    prefix: 'fasl',
    iconName: 'drone-front',
    icon: [
      640,
      512,
      ["drone-alt"],
      'f860',
      
      'M160 96v16 16H272h16v32H272 16 0V128H16 128V112 96h32zm352 0v16 16H624h16v32H624 368 352V128h16H480V112 96h32zM128 256V192h32v55.1l12.6 7.9 50.6-33.7C251.9 202.2 285.5 192 320 192s68.1 10.2 96.8 29.3L467.4 255l12.6-7.9V192h32v64 8.9l-7.5 4.7-33.7 21-2.4 3.6-1.6-1.1-20.4 12.8 29.9 35.9 3.7 4.5V352v48 16H448V400 357.8L419 323l-42.5 26.6-3.9 2.4H368 272h-4.6l-3.9-2.4L221 323l-29 34.8V400v16H160V400 352v-5.8l3.7-4.5 29.9-35.9-20.4-12.8-1.6 1.1-2.4-3.6-33.6-21-7.5-4.7V256zm74.4 17.6L276.6 320h86.8l74.2-46.4-38.5-25.7C375.7 232.3 348.1 224 320 224s-55.6 8.3-79.1 23.9l-38.5 25.7z'
      
    ]
  };

  
    var faDroneAlt = faDroneFront;
  

  
  

  var faStairs = {
    prefix: 'fasl',
    iconName: 'stairs',
    icon: [
      576,
      512,
      [],
      'e289',
      
      'M416 32h16H560h16V64H560 448V176v16H432 304V336v16H288 160V464v16H144 16 0V448H16 128V336 320h16H272V176 160h16H416V48 32z'
      
    ]
  };

  

  
  

  var faToiletPaperUnderSlash = {
    prefix: 'fasl',
    iconName: 'toilet-paper-under-slash',
    icon: [
      640,
      512,
      ["toilet-paper-reverse-slash"],
      'e2a1',
      
      'M541 512l-40.5-32H224V416H192v80 16h16H541zM508.7 323.4l25.1 19.8c3.7-4.9 7.1-10.2 10.2-15.7v23.7l32 25.3V192c0-50.8-11.2-97.5-30.1-132.1C527.4 25.9 499.1 0 464 0H176c-19.3 0-36.5 7.8-51.1 20.4l25.8 20.4c8.5-6 17.1-8.8 25.3-8.8H401.3c-7.2 8.2-13.6 17.7-19.2 27.9C363.2 94.5 352 141.2 352 192c0 2.6 0 5.2 .1 7.8l33.9 26.7c-1.3-11.1-1.9-22.6-1.9-34.5c0-46.5 10.3-87.7 26.2-116.8C426.4 45.5 446.1 32 464 32s37.6 13.5 53.8 43.2C533.7 104.3 544 145.5 544 192s-10.3 87.7-26.2 116.8c-2.9 5.4-6 10.3-9.2 14.6zM64 192c0 50.8 11.2 97.5 30.1 132.1c18.6 34 46.8 59.9 81.9 59.9H378.8l-40.5-32H176c-17.9 0-37.6-13.5-53.8-43.2C106.3 279.7 96 238.5 96 192c0-10.3 .5-20.4 1.5-30.1L68.2 138.8c-2.8 17-4.2 34.8-4.2 53.2zm400 48c-6.4 0-11.9-11.3-14.5-27.6c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6zm0 32c16.2 0 26.6-9.9 31.4-16c5.1-6.4 8.2-13.8 10.3-20c4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20c-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20c-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20c4.8 6.1 15.1 16 31.4 16zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  
    var faToiletPaperReverseSlash = faToiletPaperUnderSlash;
  

  
  

  var faDrawSquare = {
    prefix: 'fasl',
    iconName: 'draw-square',
    icon: [
      448,
      512,
      [],
      'f5ef',
      
      'M64 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96c29.8 0 54.9 20.4 62 48H322c7.1-27.6 32.2-48 62-48c35.3 0 64 28.7 64 64c0 29.8-20.4 54.9-48 62V354c27.6 7.1 48 32.2 48 62c0 35.3-28.7 64-64 64c-29.8 0-54.9-20.4-62-48H126c-7.1 27.6-32.2 48-62 48c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62V158C20.4 150.9 0 125.8 0 96C0 60.7 28.7 32 64 32zm62 368H322c5.8-22.5 23.5-40.2 46-46V158c-22.5-5.8-40.2-23.5-46-46H126c-5.8 22.5-23.5 40.2-46 46V354c22.5 5.8 40.2 23.5 46 46zM96 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32-288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faFilePlus = {
    prefix: 'fasl',
    iconName: 'file-plus',
    icon: [
      384,
      512,
      [],
      'f319',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM176 432h32V416 352h64 16V320H272 208V256 240H176v16 64H112 96v32h16 64v64 16z'
      
    ]
  };

  

  
  

  var faStamp = {
    prefix: 'fasl',
    iconName: 'stamp',
    icon: [
      512,
      512,
      [],
      'f5bf',
      
      'M304 138.3l-8 9.1v12.1V256v32h32 88c35.3 0 64 28.7 64 64v32H32V352c0-35.3 28.7-64 64-64h88 32V256 159.5 147.4l-8-9.1C198 127 192 112.3 192 96c0-35.3 28.7-64 64-64s64 28.7 64 64c0 16.3-6 31-16 42.3zM512 416V384 352c0-53-43-96-96-96H360 328V224 159.5c14.9-16.9 24-39.2 24-63.5c0-53-43-96-96-96s-96 43-96 96c0 24.3 9.1 46.6 24 63.5V224v32H152 96c-53 0-96 43-96 96v32 32H32 480h32zM64 456V440H32v16 40 16H48 464h16V496 456 440H448v16 24H64V456z'
      
    ]
  };

  

  
  

  var faSaltShaker = {
    prefix: 'fasl',
    iconName: 'salt-shaker',
    icon: [
      384,
      512,
      [129474],
      'e446',
      
      'M379 480l5 32H351.6 32.4 0l5-32L62.7 110.7C72.7 47 127.5 0 192 0s119.3 47 129.3 110.7L379 480zM301.6 192H82.4l-45 288H346.6l-45-288zm-5-32l-6.9-44.4C282.2 67.5 240.7 32 192 32s-90.2 35.5-97.7 83.6L87.4 160H296.6zM176 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM144 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm38.1 128l28 224H257.9l-28-224h32.2zm-108 0l-28 224H93.9l28-224h32.2z'
      
    ]
  };

  

  
  

  var faChartMixedUpCircleDollar = {
    prefix: 'fasl',
    iconName: 'chart-mixed-up-circle-dollar',
    icon: [
      576,
      512,
      [],
      'e5d9',
      
      'M416 0H400V32h16 71L320.2 171 202.5 68l-9.6-8.4-10.3 7.5-176 128 18.8 25.9L191.1 100.5 309.5 204l10.3 9 10.5-8.7L512 52.8V128v16h32V128 16 0H528 416zm96 32l0 0h0v0zM80 352v96H48V352H80zM48 320H16v32 96 32H48 80h32V448 352 320H80 48zm128-64h32V448H176V256zm-32-32v32V448v32h32 32 32V448 256 224H208 176 144zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM408.1 339c-.1-1.9 .3-2.9 .8-3.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1l15.5 3.9 7.7-31.1L465.9 301c-5.6-1.4-11.6-2.7-17.9-3.7V288 272H416v16 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8l-15.3-4.8L372 425.2l15.3 4.8c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4 16h32v-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1z'
      
    ]
  };

  

  
  

  var faICursor = {
    prefix: 'fasl',
    iconName: 'i-cursor',
    icon: [
      256,
      512,
      [],
      'f246',
      
      'M128 66C106.2 26.6 64.2 0 16 0H0V32H16c53 0 96 43 96 96V240H64 48v32H64h48V384c0 53-43 96-96 96H0v32H16c48.2 0 90.2-26.6 112-66c21.8 39.4 63.8 66 112 66h16V480H240c-53 0-96-43-96-96V272h48 16V240H192 144V128c0-53 43-96 96-96h16V0H240c-48.2 0-90.2 26.6-112 66z'
      
    ]
  };

  

  
  

  var faSquareArrowUpLeft = {
    prefix: 'fasl',
    iconName: 'square-arrow-up-left',
    icon: [
      448,
      512,
      [],
      'e263',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM144 160H280h16v32H280 182.6L315.3 324.7 326.6 336 304 358.6l-11.3-11.3L160 214.6V320v16H128V320 176 160h16z'
      
    ]
  };

  

  
  

  var fa5 = {
    prefix: 'fasl',
    iconName: '5',
    icon: [
      320,
      512,
      [],
      '35',
      
      'M51.2 32H64 272h16V64H272 76.8l-36 160H192c70.7 0 128 57.3 128 128s-57.3 128-128 128H87.5c-35.2 0-67-21-80.9-53.3L1.3 414.3l29.4-12.6L36 414.1C44.8 434.6 65.1 448 87.5 448H192c53 0 96-43 96-96s-43-96-96-96H20.8 .8l4.4-19.5 43.2-192L51.2 32z'
      
    ]
  };

  

  
  

  var faLandMineOn = {
    prefix: 'fasl',
    iconName: 'land-mine-on',
    icon: [
      640,
      512,
      [],
      'e51b',
      
      'M336 0H304V16 176v16h32V176 16 0zM44.8 121.6L25.6 147.2l12.8 9.6 128 96 12.8 9.6 19.2-25.6-12.8-9.6-128-96-12.8-9.6zm569.6 25.6l-19.2-25.6-12.8 9.6-128 96-12.8 9.6 19.2 25.6 12.8-9.6 128-96 12.8-9.6zM192 336v32H160 128L78.2 480 64 512H99 541h35l-14.2-32L512 368H480 448h0V336 320 288H416 224 192v32 16zm224 32H224V320H416v48zM224 400H416h32 0 43.2l35.6 80H113.2l35.6-80H192h0 32z'
      
    ]
  };

  

  
  

  var faTricycle = {
    prefix: 'fasl',
    iconName: 'tricycle',
    icon: [
      512,
      512,
      [],
      'e5c3',
      
      'M272 32H256V64h16H384v40l-53.3 40H303.4c-58.4 0-113.2 24.5-152.1 66.1L117.9 160H128h16V128H128 48 32v32H48 79.4l51 76.5c-2.7 4-5.2 8.1-7.6 12.3l-4.2 7.4c-2.2-.1-4.4-.2-6.6-.2C50.1 256 0 306.1 0 368s50.1 112 112 112s112-50.1 112-112c0-48-30.1-88.9-72.5-104.8C183 209.2 240.8 176 303.4 176h20.1l14.2 56.6C289.9 251.2 256 297.6 256 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-5.2 0-10.3 .3-15.3 .9l-14.6-58.5 55.5-41.6L416 120v-8V48 32H400 272zm73.5 232l23 91.9 3.9 15.5 31-7.8-3.9-15.5-23-91.8c2.5-.2 4.9-.3 7.4-.3c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-39.3 23.7-73.1 57.5-88zM112 288a80 80 0 1 1 0 160 80 80 0 1 1 0-160z'
      
    ]
  };

  

  
  

  var faFaceZany = {
    prefix: 'fasl',
    iconName: 'face-zany',
    icon: [
      512,
      512,
      [],
      'e3a4',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 77.2-39.1 145.3-98.6 185.6c-3.6 17.6-10.8 33.9-20.8 48.1C449.9 449.7 512 360.1 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 360.1 62.1 449.7 151.3 489.7c-10-14.2-17.2-30.5-20.8-48.1C71.1 401.3 32 333.2 32 256zM352 144c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-3.9 .5-7.7 1.4-11.4C261 143.9 271.5 152 284 152c15.5 0 28-12.5 28-28c0-12.5-8.1-23-19.4-26.6c3.6-.9 7.5-1.4 11.4-1.4c26.5 0 48 21.5 48 48zm32 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM104 224a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm112 0A72 72 0 1 0 72 224a72 72 0 1 0 144 0zm-72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM336 352H217.7l170.5-98.4c5.3 35.4-4.5 71.3-26.5 98.4H352 336zM158.5 386.2c.5 .5 1 1 1.5 1.4V416c0 24.3 9.1 46.6 24 63.5v.5h.4c17.6 19.6 43.1 32 71.6 32s54-12.4 71.6-32h.4v-.5c14.9-16.9 24-39.2 24-63.5V403.5c55.2-36.5 80-103.6 65.5-166.8c-2.4-10.5-5.9-20.8-10.5-30.9l-27.9 16.1L164.8 345.6l-27.9 16.1c6.4 9 13.7 17.2 21.5 24.5zM320 416c0 35.3-28.7 64-64 64s-64-28.7-64-64V384h48v24h32V384h48v32z'
      
    ]
  };

  

  
  

  var faSquareRss = {
    prefix: 'fasl',
    iconName: 'square-rss',
    icon: [
      448,
      512,
      ["rss-square"],
      'f143',
      
      'M416 64V448H32V64H416zM32 32H0V64 448v32H32 416h32V448 64 32H416 32zm80 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM64 160c141.4 0 256 114.6 256 256h32c0-159.1-128.9-288-288-288v32zM256 416c0-106-86-192-192-192v32c88.4 0 160 71.6 160 160h32z'
      
    ]
  };

  
    var faRssSquare = faSquareRss;
  

  
  

  var faOctagonMinus = {
    prefix: 'fasl',
    iconName: 'octagon-minus',
    icon: [
      512,
      512,
      ["minus-octagon"],
      'f308',
      
      'M32 338.7V173.3L173.3 32H338.7L480 173.3V338.7L338.7 480H173.3L32 338.7zM160 0L0 160V352L160 512H352L512 352V160L352 0H160zm0 240H144v32h16H352h16V240H352 160z'
      
    ]
  };

  
    var faMinusOctagon = faOctagonMinus;
  

  
  

  var faDiceFive = {
    prefix: 'fasl',
    iconName: 'dice-five',
    icon: [
      448,
      512,
      [9860],
      'f523',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM128 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm216 24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM128 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faRoadCircleCheck = {
    prefix: 'fasl',
    iconName: 'road-circle-check',
    icon: [
      640,
      512,
      [],
      'e564',
      
      'M184.1 64L74.4 448H339.2c5.9 11.4 12.9 22.2 21 32H65.3 32l9.1-32L160 32H304h32H480l46.5 162.6c-9.9-1.7-20.1-2.6-30.5-2.6c-1.2 0-2.4 0-3.6 0L455.9 64H336v48 16H304V112 64H184.1zM326.6 320H304V304 208 192h32v16 86.6c-3.8 8.2-6.9 16.7-9.4 25.4zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm78.6 112l-11.3 11.3-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336z'
      
    ]
  };

  

  
  

  var faFaceRelieved = {
    prefix: 'fasl',
    iconName: 'face-relieved',
    icon: [
      512,
      512,
      [],
      'e389',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm187.3 92.7c13 13 35.8 27.3 68.7 27.3s55.6-14.3 68.7-27.3L336 337.4 358.6 360l-11.3 11.3C329.4 389.2 298.9 408 256 408s-73.4-18.8-91.3-36.7L153.4 360 176 337.4l11.3 11.3zM395.2 234.4l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0l25.6-19.2c21.6 28.8 64.8 28.8 86.4 0zm-278.4 0c21.6 28.8 64.8 28.8 86.4 0l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0l25.6-19.2zm95.4-112.3l-15.2 5.1-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5-8.9 13.3L89.8 180.4l8.9-13.3 7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1 15.2-5.1 10.1 30.4zm102.7 5.1l-15.2-5.1 10.1-30.4 15.2 5.1 6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5 8.9 13.3-26.6 17.8-8.9-13.3L379 173.4c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1z'
      
    ]
  };

  

  
  

  var faEclipse = {
    prefix: 'fasl',
    iconName: 'eclipse',
    icon: [
      640,
      512,
      [],
      'f749',
      
      'M178.7 15.5L256 57.1l77.3-41.6L362 0l9.4 31.3L381.5 65c-10 4.3-19.7 9.5-28.8 15.3l-10-33.5L271.2 85.3 256 93.5l-15.2-8.2L169.3 46.8 146 124.6l-5 16.5-16.5 5L46.8 169.3l38.5 71.5L93.5 256l-8.2 15.2L46.8 342.7 124.6 366l16.5 5 5 16.5 23.3 77.8 71.5-38.5 15.2-8.2 15.2 8.2 71.5 38.5 10-33.5c9.2 5.8 18.8 10.9 28.8 15.3l-10.1 33.7L362 512l-28.8-15.5L256 454.9l-77.3 41.6L150 512l-9.4-31.3-25.2-84.1L31.3 371.4 0 362l15.5-28.8L57.1 256 15.5 178.7 0 150l31.3-9.4 84.1-25.2 25.2-84.1L150 0l28.8 15.5zM256 128c13.7 0 27 2.2 39.4 6.2c-6.5 9-12.3 18.4-17.3 28.4c-7.1-1.7-14.5-2.6-22.1-2.6c-53 0-96 43-96 96s43 96 96 96c7.6 0 15-.9 22.1-2.6c5 9.9 10.8 19.4 17.3 28.4c-12.4 4-25.6 6.2-39.4 6.2c-70.7 0-128-57.3-128-128s57.3-128 128-128zM608 256a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-320 0a176 176 0 1 1 352 0 176 176 0 1 1 -352 0z'
      
    ]
  };

  

  
  

  var faAlarmClock = {
    prefix: 'fasl',
    iconName: 'alarm-clock',
    icon: [
      512,
      512,
      [9200],
      'f34e',
      
      'M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5l27-17.2c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1l21.8-23.5C138.4 9.3 116.4 0 92.2 0zM357.1 24.6l21.8 23.5C389.6 38.1 404 32 419.8 32C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3l27 17.2c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM67.3 499.3l42-42C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l42 42L456 510.6 478.6 488l-11.3-11.3-42-42C459.4 395.4 480 344.1 480 288C480 164.3 379.7 64 256 64S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-42 42L33.4 488 56 510.6l11.3-11.3zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm16 80V160H240v16V304v8l6.4 4.8 64 48 12.8 9.6 19.2-25.6-12.8-9.6L272 296V176z'
      
    ]
  };

  

  
  

  var faEarDeaf = {
    prefix: 'fasl',
    iconName: 'ear-deaf',
    icon: [
      512,
      512,
      ["deaf","deafness","hard-of-hearing"],
      'f2a4',
      
      'M499.3 35.3l-56 56L432 102.6 409.4 80l11.3-11.3 56-56L488 1.4 510.6 24 499.3 35.3zm-312 312l-152 152L24 510.6 1.4 488l11.3-11.3 152-152L176 313.4 198.6 336l-11.3 11.3zM240 96C160.5 96 96 160.5 96 240v16H64V240c0-97.2 78.8-176 176-176s176 78.8 176 176c0 54.7-24.9 103.5-64 135.8V384c0 70.7-57.3 128-128 128H208 192V480h16 16c53 0 96-43 96-96V368v-8l6.4-4.8c35-26.3 57.6-68.1 57.6-115.2c0-79.5-64.5-144-144-144zm0 64c-44.2 0-80 35.8-80 80v16H128V240c0-61.9 50.1-112 112-112s112 50.1 112 112v16H320V240c0-44.2-35.8-80-80-80z'
      
    ]
  };

  
    var faDeaf = faEarDeaf;
  
    var faDeafness = faEarDeaf;
  
    var faHardOfHearing = faEarDeaf;
  

  
  

  var faClockThreeThirty = {
    prefix: 'fasl',
    iconName: 'clock-three-thirty',
    icon: [
      512,
      512,
      [],
      'e357',
      
      'M32 256a224 224 0 1 0 448 0A224 224 0 1 0 32 256zm480 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM240 400V256 240h16H368h16v32H368 272V400v16H240V400z'
      
    ]
  };

  

  
  

  var faFaceGrinWink = {
    prefix: 'fasl',
    iconName: 'face-grin-wink',
    icon: [
      512,
      512,
      ["grin-wink"],
      'f58c',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3c22.5 23.6 54.5 38.3 89.9 38.3s67.4-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm0-32c41 0 79.9-5.3 114.9-14.9c13-3.5 25.4-7.7 37.2-12.3c-3.1 13.8-8 26.9-14.5 39c-26.2 48.9-78 82.2-137.7 82.2s-111.5-33.3-137.7-82.2c-6.5-12.1-11.4-25.2-14.5-39c11.8 4.6 24.3 8.8 37.2 12.3c35.1 9.6 74 14.9 114.9 14.9zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm140.4 29.6l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0z'
      
    ]
  };

  
    var faGrinWink = faFaceGrinWink;
  

  
  

  var faHatWitch = {
    prefix: 'fasl',
    iconName: 'hat-witch',
    icon: [
      576,
      512,
      [],
      'f6e7',
      
      'M492.2 194.2L480 176H432l-16 32 64 176H445.9l-60-165.1L381.2 206l6.2-12.3 16-32 8.8-17.7H432h48 17.1l9.5 14.2 3.3 4.9 25.3-44.3L443.6 38.6 232.9 151 130.9 384H96L208 128 448 0 576 112l-46.2 80.9L512 224l-19.8-29.8zM71.6 448l64 32H440.4l64-32H71.6zM576 448L448 512H128L0 448V416H32 544h32v32zM320 352H256v32H224V352 320h32 64 32v32 32H320V352z'
      
    ]
  };

  

  
  

  var faCoffeeBeans = {
    prefix: 'fasl',
    iconName: 'coffee-beans',
    icon: [
      512,
      512,
      [],
      'e13f',
      
      'M476.8 258c50-50 39.9-141.2-22.6-203.6S300.5-18.2 250.5 31.8s-39.9 141.2 22.6 203.6S426.8 308 476.8 258zm-72.7-82.8l42.4 66.7c-35.4 26.1-99.7 21.9-150.8-29.2C250 167.1 241.9 110.7 259.4 74l42.9 67.3 101.8 33.9zM431.5 77c45.7 45.7 53.9 102.1 36.3 138.8L425 148.5 323.2 114.5 280.7 47.8C316.1 21.7 380.5 26 431.5 77zM135.1 402.1L118 479.2C74.5 472.7 32 424.2 32 352c0-64.7 34.1-110.3 72.5-123.8L88.4 300.5l-1.2 5.5 2.5 5.1 45.5 90.9zM128 224l-.8 0 .8 0 .8 0-.8 0zm96 128c0 64.7-34.1 110.3-72.5 123.8l16.1-72.4 1.2-5.5-2.5-5.1-45.5-90.9L138 224.8c43.5 6.5 86 55.1 86 127.2zM128 512c70.7 0 128-71.6 128-160s-57.3-160-128-160S0 263.6 0 352s57.3 160 128 160z'
      
    ]
  };

  

  
  

  var faMessageSms = {
    prefix: 'fasl',
    iconName: 'message-sms',
    icon: [
      512,
      512,
      [],
      'e1e5',
      
      'M160 448V416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448zm0-64h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zm-8-240h8v0h8v32H152 132.8c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.2 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8H112 96V240h16 27.2c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6C102.2 204.7 96 193.2 96 180.8c0-20.3 16.5-36.8 36.8-36.8H152zm40 16V144h24l4.8 6.4L256 197.3l35.2-46.9L296 144h24v16 96 16H288V256 208l-19.2 25.6L256 250.7l-12.8-17.1L224 208v48 16H192V256 160zm144 20.8c0-20.3 16.4-36.7 36.7-36.8H384v0h8 16v32H392 372.8c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.2 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8H352 336V240h16 27.2c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6c-10.2-6.8-16.4-18.3-16.4-30.7z'
      
    ]
  };

  

  
  

  var faChessBishop = {
    prefix: 'fasl',
    iconName: 'chess-bishop',
    icon: [
      320,
      512,
      [9821],
      'f43a',
      
      'M104 0H88V32h16 11.6C103.6 42.9 89.8 56.7 75.9 72.8C39 115.7 0 177.6 0 248.7c0 53.2 37.2 80 64 92.3V352H96V330.4 319.3l-10.4-3.9C62.5 306.8 32 288.1 32 248.7c0-59.7 33-114.3 68.1-155c17.4-20.2 34.7-36.4 47.8-47.6c4.7-4 8.8-7.3 12.1-10c3.3 2.6 7.4 6 12.1 10c13.1 11.2 30.4 27.5 47.8 47.6c7.2 8.4 14.3 17.3 21.1 26.7l-76.2 76.2L153.4 208 176 230.6l11.3-11.3L258.6 148c17.3 30.4 29.4 64.6 29.4 100.7c0 39.4-30.5 58-53.6 66.7L224 319.3v11.1V352h32V341.1c26.8-12.3 64-39.1 64-92.3c0-71.2-39-133-75.9-175.9C230.2 56.7 216.4 42.9 204.4 32H216h16V0H216 104zM32 480v-9.5L65.8 416H254.2L288 470.5V480H32zm240-96H48L0 461.3V480v32H32 288h32V480 461.3L272 384z'
      
    ]
  };

  

  
  

  var faSealExclamation = {
    prefix: 'fasl',
    iconName: 'seal-exclamation',
    icon: [
      512,
      512,
      [],
      'e242',
      
      'M278.6 22.6L331 75l74 0 32 0 0 32 0 74 52.4 52.4L512 256l-22.6 22.6L437 331l0 74 0 32-32 0-74 0-52.4 52.4L256 512l-22.6-22.6L181 437l-74 0-32 0 0-32 0-74L22.6 278.6 0 256l22.6-22.6L75 181l0-74 0-32 32 0 74 0 52.4-52.4L256 0l22.6 22.6zM331 107l-13.3 0-9.4-9.4L256 45.3 203.6 97.6l-9.4 9.4L181 107l-74 0 0 74 0 13.3-9.4 9.4L45.3 256l52.4 52.4 9.4 9.4 0 13.3 0 74 74 0 13.3 0 9.4 9.4L256 466.7l52.4-52.4 9.4-9.4 13.3 0 74 0 0-74 0-13.3 9.4-9.4L466.7 256l-52.4-52.4-9.4-9.4 0-13.3 0-74-74 0zm-59 21l0 16 0 128 0 16-32 0 0-16 0-128 0-16 32 0zM232 320l48 0 0 48-48 0 0-48z'
      
    ]
  };

  

  
  

  var faGrateDroplet = {
    prefix: 'fasl',
    iconName: 'grate-droplet',
    icon: [
      576,
      512,
      [],
      'e194',
      
      'M32 64H416V207.1l32-49.1V64 32H416 32 0V64 448v32H32 344.2c-6.6-9.9-12-20.6-16.1-32H32V64zM384 256V112 96H368 296 224 152 80 64v16V256 400v16H80h72 72 72 24.9c-.6-5.3-.9-10.6-.9-16v-2.1c0-4.6 .2-9.3 .7-13.9H312V272h40v33.4l32-49.1V256zM96 240V128h40V240H96zm72 0V128h40V240H168zm72 0V128h40V240H240zm72 0V128h40V240H312zm-32 32V384H240V272h40zm-72 0V384H168V272h40zm-72 0V384H96V272h40zm261.3 81.1L464 250.6l66.7 102.4c8.7 13.3 13.3 28.9 13.3 44.8V400c0 44.2-35.8 80-80 80s-80-35.8-80-80v-2.1c0-15.9 4.6-31.5 13.3-44.8zm-26.8-17.5c-12.1 18.5-18.5 40.2-18.5 62.3V400c0 61.9 50.1 112 112 112s112-50.1 112-112v-2.1c0-22.1-6.4-43.7-18.5-62.3L483.1 221.3 464 192l-19.1 29.3L370.5 335.6z'
      
    ]
  };

  

  
  

  var faVideoArrowUpRight = {
    prefix: 'fasl',
    iconName: 'video-arrow-up-right',
    icon: [
      576,
      512,
      [],
      'e2c9',
      
      'M352 96V416H32V96H352zM32 64H0V96 416v32H32 352h32V416 352 160 96 64H352 32zM416 332.2V368l128 64 32 16V412.2 99.8 64L544 80 416 144v35.8l128-64V396.2l-128-64zM160 160H144v32h16 73.4L100.7 324.7 89.4 336 112 358.6l11.3-11.3L256 214.6V288v16h32V288 176 160H272 160z'
      
    ]
  };

  

  
  

  var faAcorn = {
    prefix: 'fasl',
    iconName: 'acorn',
    icon: [
      448,
      512,
      [],
      'f6ae',
      
      'M263.4 31.2l3.9-3.9L244.7 4.7l-3.9 3.9C225.5 23.9 215.1 43.2 210.5 64H96C43 64 0 107 0 160v16 32H32 416h32V176 160c0-53-43-96-96-96H243.6c3.8-12.3 10.6-23.6 19.8-32.8zM352 96c35.3 0 64 28.7 64 64v16H32V160c0-35.3 28.7-64 64-64H352zM48.4 240C52.6 320.1 89.3 435.1 224 480c134.7-44.9 171.4-159.9 175.6-240h-32c-4 70.6-35.4 165.1-143.5 206C115.8 405.1 84.4 310.6 80.5 240h-32z'
      
    ]
  };

  

  
  

  var faFlute = {
    prefix: 'fasl',
    iconName: 'flute',
    icon: [
      640,
      512,
      [],
      'f8b9',
      
      'M160 320V192H608V320H160zm-32 0H32V192h96V320zm16-160H128 32 0v32V320v32H32h96 16 16H608h32V320 192 160H608 160 144zM320 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faRaygun = {
    prefix: 'fasl',
    iconName: 'raygun',
    icon: [
      576,
      512,
      [],
      'e025',
      
      'M32 95.2v2.5C12.2 117.8 0 145.5 0 176c0 61.9 50.1 112 112 112L46.3 419.4 32 448l28.6 14.3 70.8 35.4L160 512l14.3-28.6L272 288h48v16 16h32V304 288 256 192h32v80 16h32V272 192h32v9.9l8.8 4.4 96 48L576 265.9V240 112 86.1L552.8 97.7l-96 48-8.8 4.4V160H416V80 64H384V80v80H352V96 64 48 32H320V48 64H198.4l-11.8-4.5L64 12.3 32 0V34.3 95.2zM64 46.6L109.3 64l0 0C93.1 64.4 77.8 68.2 64 74.8V46.6zM110.5 64c-.4 0-.8 0-1.1 0l1.1 0zM480 182.1V169.9l64-32v76.2l-64-32zM320 176v80l-32 0H252.2 128l-16 0c-44.2 0-80-35.8-80-80s35.8-80 80-80H320v80zM147.8 288h88.4L145.7 469.1 74.9 433.7 147.8 288zM112 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faSkeletonRibs = {
    prefix: 'fasl',
    iconName: 'skeleton-ribs',
    icon: [
      640,
      512,
      [],
      'e5cb',
      
      'M336 16V0H304V16 64H216h-9.5l-4.5 8.4L216 80c-14.1-7.6-14.1-7.6-14.1-7.6l0 0 0 0-.1 .1-.2 .4-.9 1.7c-.8 1.5-1.9 3.7-3.4 6.5c-2.9 5.6-7 13.7-12 23.8c-9.9 20.2-23 48.6-36.2 81C123.1 250.2 96 332.7 96 400v64 16h16 64 3.4l3.1-1.4 121.5-54V496v16h32V496 424.6l121.5 54 3.1 1.4H464h64 16V464 400c0-67.3-27.1-149.8-53.2-214c-13.2-32.4-26.3-60.8-36.2-81c-4.9-10.1-9.1-18.2-12-23.8c-1.4-2.8-2.6-5-3.4-6.5l-.9-1.7-.2-.4-.1-.1 0 0 0 0s0 0-14.1 7.6l14.1-7.6L433.5 64H424 336V16zM304 96v82.9L176.2 204.4c.9-2.2 1.7-4.3 2.6-6.4c12.8-31.6 25.7-59.2 35.3-79c4.8-9.8 8.7-17.6 11.5-23H304zM162.9 239.7l.3-.1L304 211.5V284L135.8 333.1c6.4-30.7 16.1-62.8 27.1-93.3zM130 368.1l2.5-.7 171.5-50v72.3L172.6 448H128V400c0-10.2 .7-20.9 2-31.9zm206 21.5V317.3l171.5 50 2.5 .7c1.3 11 2 21.7 2 31.9v48H467.4L336 389.6zm168.2-56.5L336 284V211.5l140.9 28.2 .3 .1c10.9 30.6 20.7 62.6 27.1 93.3zM463.8 204.4L336 178.9V96h78.3c2.8 5.4 6.8 13.2 11.5 23c9.6 19.8 22.5 47.4 35.3 79c.9 2.1 1.7 4.3 2.6 6.4zM0 64V80 216v24 16V496v16H32V496 256 240 225.9l16.4-8.2C97.2 193.3 128 143.4 128 88.9V80 64H112 16 0zM32 190.1V96H95.8c-2.5 39.6-25.9 75.2-61.7 93.1l-2.1 1zM624 64H528 512V80v8.9c0 54.5 30.8 104.4 79.6 128.8l16.4 8.2V240v16V496v16h32V496 256 240 216 80 64H624zM608 96v94.1l-2.1-1c-35.8-17.9-59.2-53.5-61.7-93.1H608z'
      
    ]
  };

  

  
  

  var faThoughtBubble = {
    prefix: 'fasl',
    iconName: 'thought-bubble',
    icon: [
      512,
      512,
      [],
      'e32e',
      
      'M145.1 96h18.5l9.2-16c16.6-28.8 47.7-48 83.2-48s66.5 19.2 83.2 48l9.2 16h18.5H368c61.9 0 112 50.1 112 112s-50.1 112-112 112H334.4 321.3l-9.3 9.1c-14.5 14.2-34.2 22.9-56 22.9s-41.5-8.7-56-22.9l-9.3-9.1H177.6 144C82.1 320 32 269.9 32 208S82.1 96 144 96h1.1zM256 0c-47.4 0-88.7 25.7-110.9 64H144C64.5 64 0 128.5 0 208s64.5 144 144 144h33.6c20.2 19.8 47.9 32 78.4 32s58.2-12.2 78.4-32H368c79.5 0 144-64.5 144-144s-64.5-144-144-144h-1.1C344.7 25.7 303.4 0 256 0zM160 448H128V416h32v32zm-32-64H96v32 32 32h32 32 32V448 416 384H160 128zM0 512H64V448H0v64z'
      
    ]
  };

  

  
  

  var faUpToDottedLine = {
    prefix: 'fasl',
    iconName: 'up-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e457',
      
      'M56 40V88H8V40H56zm96 0V88H104V40h48zm48 0h48V88H200V40zm144 0V88H296V40h48zm48 0h48V88H392V40zM272 336V304h32 48V286.3L224 171.1 96 286.3V304h48 32v32V448h96V336zm112 0H352 336 304v32 80 32H272 176 144V448 368 336H112 96 64V304 272L224 128 384 272v32 32z'
      
    ]
  };

  

  
  

  var faFaceGrinTongue = {
    prefix: 'fasl',
    iconName: 'face-grin-tongue',
    icon: [
      512,
      512,
      [128539,"grin-tongue"],
      'f589',
      
      'M256 32C132.3 32 32 132.3 32 256c0 77.2 39.1 145.3 98.6 185.6c3.6 17.6 10.8 33.9 20.8 48.1C62.1 449.7 0 360.1 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 104.1-62.1 193.7-151.3 233.7c10-14.2 17.2-30.5 20.8-48.1C440.9 401.3 480 333.2 480 256C480 132.3 379.7 32 256 32zM176.4 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM352 416c0 53-43 96-96 96s-96-43-96-96V383.3c-17.1-13.3-31.4-30.1-41.7-49.4c-6.5-12.1-11.4-25.2-14.5-39c11.8 4.6 24.3 8.8 37.2 12.3c35.1 9.6 74 14.9 114.9 14.9s79.9-5.3 114.9-14.9c13-3.5 25.4-7.7 37.2-12.3c-3.1 13.8-8 26.9-14.5 39c-10.3 19.3-24.6 36.1-41.8 49.4V416zm-32 0V352H272v24H240V352H192v64c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  
    var faGrinTongue = faFaceGrinTongue;
  

  
  

  var faPeriod = {
    prefix: 'fasl',
    iconName: 'period',
    icon: [
      192,
      512,
      [],
      '2e',
      
      'M128 384l0 64-64 0 0-64 64 0zM64 352l-32 0 0 32 0 64 0 32 32 0 64 0 32 0 0-32 0-64 0-32-32 0-64 0z'
      
    ]
  };

  

  
  

  var faBridgeCircleXmark = {
    prefix: 'fasl',
    iconName: 'bridge-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e4cb',
      
      'M48 32h64 32 96 32 96 32 96 32 64 16V64H592 528v64h64 16v32H592 528 496 400 368 272 240 144 112 48 32V128H48h64V64H48 32V32H48zM496 64H400v64h96V64zM368 64H272v64h96V64zM240 64H144v64h96V64zM48 240H64c53 0 96 43 96 96V448h64V336c0-53 43-96 96-96c16.1 0 31.2 4 44.6 10.9c-7.2 8.1-13.7 16.9-19.3 26.2c-7.7-3.3-16.3-5.2-25.2-5.2c-35.3 0-64 28.7-64 64V464v16H240 144 128V464 336c0-35.3-28.7-64-64-64H48 32V240H48zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-36.7L518.6 368l36.7 36.7L566.6 416 544 438.6l-11.3-11.3L496 390.6l-36.7 36.7L448 438.6 425.4 416l11.3-11.3L473.4 368l-36.7-36.7L425.4 320 448 297.4l11.3 11.3L496 345.4l36.7-36.7L544 297.4 566.6 320l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faFaceKiss = {
    prefix: 'fasl',
    iconName: 'face-kiss',
    icon: [
      512,
      512,
      [128535,"kiss"],
      'f596',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm238.1 29.5l3.8-26.9c15.2 2.1 32.7 6.6 46.8 13.6c7 3.4 13.9 7.8 19.2 13.4c5.4 5.6 9.8 13.2 9.8 22.5s-4.4 16.9-9.8 22.5c-5.3 5.5-12.2 9.9-19.2 13.4l-.2 .1 .2 .1c7 3.4 13.9 7.8 19.2 13.4c5.4 5.6 9.8 13.2 9.8 22.5s-4.4 16.9-9.8 22.5c-5.3 5.5-12.2 9.9-19.2 13.4c-14.1 6.9-31.6 11.4-46.8 13.6l-3.8-26.9c13.3-1.9 27.8-5.8 38.6-11c5.4-2.7 9.2-5.3 11.5-7.7c2.2-2.3 2.2-3.5 2.2-3.8s-.1-1.5-2.2-3.8c-2.3-2.4-6.1-5.1-11.5-7.7c-10.8-5.3-25.3-9.2-38.6-11V330.5c13.3-1.9 27.8-5.8 38.6-11c5.4-2.7 9.2-5.3 11.5-7.7c2.2-2.3 2.2-3.5 2.2-3.8s-.1-1.5-2.2-3.8c-2.3-2.4-6.1-5.1-11.5-7.7c-10.8-5.3-25.3-9.2-38.6-11zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faKiss = faFaceKiss;
  

  
  

  var faWindowFrameOpen = {
    prefix: 'fasl',
    iconName: 'window-frame-open',
    icon: [
      512,
      512,
      [],
      'e050',
      
      'M272 32H448V256H272V32zM480 288V256 32 0H448 64 32V32 256v32H64 448h32zM64 256V32H240V256H64zM16 480H0v32H16 48 464h32 16V480H496 480V320H448V480H64V320H32V480H16z'
      
    ]
  };

  

  
  

  var faLightbulbCfl = {
    prefix: 'fasl',
    iconName: 'lightbulb-cfl',
    icon: [
      320,
      512,
      [],
      'e5a6',
      
      'M160 28V7.5l-19.9 5-128 32L0 47.5V60v67.5V140v0 20.5 47V220v20.5V300v20.5l19.9-5 111.9-28 .1 0 64-16 92.1-23v47l-99.9 25-12.1 3V336v48H144V333.5l-32 8V384H96 64v32 32 32H96h48v16 16h32V496 480h48 32V448 416 384H224 208V348.5l99.9-25 12.1-3V308 228 207.5l0 0v-47V148 127.5 68 47.5l-19.9 5L160 87.5V28zM288 215.5l-163.9 41L32 279.5v-47l256-64v47zm-128-95l128-32v47l-256 64v-47l115.9-29 12.1-3zm-32-25l-96 24v-47l96-24v47zM224 448H176 144 96V416H224v32z'
      
    ]
  };

  

  
  

  var faCommentArrowDown = {
    prefix: 'fasl',
    iconName: 'comment-arrow-down',
    icon: [
      512,
      512,
      [],
      'e143',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM272 144V128H240v16V281.4l-52.7-52.7L176 217.4 153.4 240l11.3 11.3 80 80L256 342.6l11.3-11.3 80-80L358.6 240 336 217.4l-11.3 11.3L272 281.4V144z'
      
    ]
  };

  

  
  

  var faCameraWeb = {
    prefix: 'fasl',
    iconName: 'camera-web',
    icon: [
      448,
      512,
      ["webcam"],
      'f832',
      
      'M224 32a192 192 0 1 1 0 384 192 192 0 1 1 0-384zM351.3 408.3C409.7 367.9 448 300.4 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224c0 76.4 38.3 143.9 96.7 184.3L40.9 480 16 512H56.5 391.5 432l-24.9-32-55.8-71.7zm-27.8 16.4l43 55.3H81.4l43-55.3c30 14.9 63.8 23.3 99.6 23.3s69.6-8.4 99.6-23.3zM224 112a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288z'
      
    ]
  };

  
    var faWebcam = faCameraWeb;
  

  
  

  var faSquareM = {
    prefix: 'fasl',
    iconName: 'square-m',
    icon: [
      448,
      512,
      [],
      'e276',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM96 144V128h24.3l4.8 6.8L224 276.1l98.9-141.3 4.8-6.8H352v16V368v16H320V368 194.8L237.1 313.2 224 331.9l-13.1-18.7L128 194.8V368v16H96V368 144z'
      
    ]
  };

  

  
  

  var faFaceScream = {
    prefix: 'fasl',
    iconName: 'face-scream',
    icon: [
      640,
      512,
      [],
      'e38b',
      
      'M543.4 272.3c.4-5.4 .6-10.8 .6-16.3C544 132.3 443.7 32 320 32S96 132.3 96 256c0 5.5 .2 10.9 .6 16.3L71.8 293.9l-4.4 3.9C65.2 284.2 64 270.2 64 256C64 114.6 178.6 0 320 0S576 114.6 576 256c0 14.2-1.2 28.2-3.4 41.8l-4.4-3.8-24.8-21.7zM411.3 460.6c-3.2 12.8-5.7 25.3-7.7 37.4c-26.2 9-54.3 14-83.6 14c-29.2 0-57.3-4.9-83.5-13.9c-2-12.1-4.5-24.7-7.7-37.4C256.7 473.1 287.5 480 320 480c32.5 0 63.4-6.9 91.3-19.4zM224.3 164.4c-13.1 5.8-26.4 17.1-36.1 33c-9.7 15.9-13.3 32.2-12.1 45.3c1.2 13 6.9 21.7 14.7 26c8.1 4.4 19.5 4.7 32.7-1.1c13.1-5.8 26.4-17.1 36.1-33c9.7-15.9 13.3-32.2 12.1-45.3c-1.2-13-6.9-21.7-14.7-26c-8.1-4.4-19.5-4.7-32.7 1.1zm-12.9-29.3c19.4-8.6 41.8-10.4 61 .1c19.4 10.6 29.3 30.3 31.2 51.2c1.9 20.8-3.8 43.9-16.6 64.9c-12.8 21-30.9 37-50.5 45.6c-19.4 8.6-41.8 10.4-61-.1c-19.4-10.6-29.3-30.3-31.2-51.2c-1.9-20.8 3.8-43.9 16.6-64.9c12.8-21 30.9-37 50.5-45.6zm204.2 29.3c-13.2-5.8-24.6-5.5-32.7-1.1c-7.9 4.3-13.5 13-14.7 26c-1.2 13.1 2.4 29.4 12.1 45.3c9.7 15.9 23 27.2 36.1 33c13.2 5.8 24.6 5.5 32.7 1.1c7.9-4.3 13.5-13 14.7-26c1.2-13.1-2.4-29.4-12.1-45.3c-9.7-15.9-23-27.2-36.1-33zm12.9-29.3c19.5 8.6 37.7 24.6 50.5 45.6c12.8 21 18.5 44.1 16.6 64.9c-1.9 20.9-11.8 40.6-31.2 51.2c-19.2 10.5-41.5 8.7-61 .1c-19.5-8.6-37.7-24.6-50.5-45.6c-12.8-21-18.5-44.1-16.6-64.9c1.9-20.9 11.8-40.6 31.2-51.2c19.2-10.5 41.5-8.7 61-.1zM352 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V352zm-96 0c0-35.3 28.7-64 64-64s64 28.7 64 64v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V352zM113.6 317.8c54.6 45.6 83.1 126.6 92.6 194.2H173.9c-8.8-57.9-31.9-121.6-70.7-160.5L59.9 389.3c21.2 36 35.4 79 38 122.7H65.8c-2.8-41.8-18-83.5-40-116.9l-7.7-11.7 10.5-9.2L92.9 318l10.3-9 10.5 8.7zm500.6 77.3c-22.1 33.4-37.2 75.1-40 116.9H542.2c2.6-43.6 16.8-86.7 38-122.7l-43.3-37.8c-38.8 38.9-62 102.6-70.7 160.5H433.8c9.4-67.6 37.9-148.6 92.6-194.2l10.5-8.7 10.3 9 64.3 56.2 10.5 9.2-7.7 11.7z'
      
    ]
  };

  

  
  

  var faArrowUpSquareTriangle = {
    prefix: 'fasl',
    iconName: 'arrow-up-square-triangle',
    icon: [
      576,
      512,
      ["sort-shapes-up-alt"],
      'f88b',
      
      'M352 64V192H480V64H352zM320 32h32H480h32V64 192v32H480 352 320V192 64 32zM160 33.4l11.3 11.3 88 88L270.6 144 248 166.6l-11.3-11.3L176 94.6V464v16H144V464 94.6L83.3 155.3 72 166.6 49.4 144l11.3-11.3 88-88L160 33.4zM296 480l20-32 81.1-129.8L416 288l18.9 30.2L516 448l20 32H498.3 333.7 296zm182.3-32L416 348.4 353.7 448H478.3z'
      
    ]
  };

  
    var faSortShapesUpAlt = faArrowUpSquareTriangle;
  

  
  

  var faFieldHockeyStickBall = {
    prefix: 'fasl',
    iconName: 'field-hockey-stick-ball',
    icon: [
      512,
      512,
      [127953,"field-hockey"],
      'f44c',
      
      'M484 131.9L520 79 414 7.1l-35.9 53-45.7 67.4-2.8 3.8 .2 .1L164.4 375.2c-3.6 5.4-9.7 8.6-16.1 8.6c-10.9 0-19.7-8.8-19.6-19.7l0-2.6c0-4.2 1.3-8.4 3.6-11.9L149.6 323l35-53.6-107.2-70L42.4 253 25.1 279.5C9.3 303.6 .8 331.8 .6 360.5l0 2.6C0 445.2 66.5 512 148.6 511.8c48.8-.1 94.3-24.4 121.7-64.7L484 131.9zM404.6 78l18-26.5 53 35.9-18 26.5-32.9 48.5L373.4 124l31.2-46zM190.9 393.1L355.4 150.6l51 38.2 .3 .2L243.8 429.1c-21.4 31.6-57.1 50.6-95.3 50.7c-64.3 .2-116.4-52.1-115.9-116.4l0-2.6c.2-22.6 6.8-44.8 19.2-63.7l17.3-26.5 17.5-26.8 53.6 35-17.5 26.8L105.4 332c-5.7 8.7-8.7 18.8-8.8 29.2l0 2.6c-.2 28.7 23 52 51.7 51.9c17-.1 33-8.5 42.5-22.6zM384 432a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  
    var faFieldHockey = faFieldHockeyStickBall;
  

  
  

  var faSquare2 = {
    prefix: 'fasl',
    iconName: 'square-2',
    icon: [
      448,
      512,
      [],
      'e257',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM218.7 160c-13.8 0-27 5.5-36.7 15.2l-23.4 23.4L136 176l23.4-23.4c15.7-15.7 37.1-24.6 59.3-24.6h4.9c43.6 0 79 35.4 79 79L301 223c-2.9 14.2-9.8 27.4-19.8 38.2L195.7 352h123v32h-176V361.7L257.8 239.2c8.2-8.7 12.8-20.2 12.8-32.2c0-26-21-47-47-47h-4.9z'
      
    ]
  };

  

  
  

  var faSaxophone = {
    prefix: 'fasl',
    iconName: 'saxophone',
    icon: [
      640,
      512,
      [127927],
      'f8dc',
      
      'M496 32h-6.2l-4.6 4.2L219 279.4 252.2 160H272h16V128H272 261.1 240 48 35 16 0v32H16 28.3L3.6 277.2C1.2 288.6 0 300.2 0 311.8v5.6C0 407.2 72.8 480 162.6 480c48.8 0 94.9-21.9 125.8-59.6L527.6 128H624h16V112 96 89.4l-4.7-4.7-48-48L582.6 32H576 496zM61 160h158L184.6 283.7l-2.5 9 6.7 6.6 16 15.8 10.8 10.7 11.2-10.3L502.2 64h67.2l32 32H520h-7.6l-4.8 5.9-244 298.3c-24.8 30.3-61.9 47.9-101 47.9C90.5 448 32 389.5 32 317.4v-5.6c0-9.4 1-18.8 2.9-28L61 160zm43 176a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40-104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faStopwatch = {
    prefix: 'fasl',
    iconName: 'stopwatch',
    icon: [
      448,
      512,
      [9201],
      'f2f2',
      
      'M128 0H320V32H240V96.6c49.4 3.8 94 24.8 127.7 57l37-37L416 105.4 438.6 128l-11.3 11.3-38.2 38.2C416 212.6 432 256.4 432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-109.5 84.6-199.2 192-207.4V32H128V0zM48 304a176 176 0 1 0 352 0A176 176 0 1 0 48 304zm192-96V320v16H208V320 208 192h32v16z'
      
    ]
  };

  

  
  

  var faBlinds = {
    prefix: 'fasl',
    iconName: 'blinds',
    icon: [
      512,
      512,
      [],
      'f8fb',
      
      'M0 0H16 496h16V16 80 96H496 160V258.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V96H16 0V80 16 0zM32 32V64H480V32H32zM96 192v32H33 0l8-32 16-64H57L41 192H96zm96 32V192H471l-16-64h33l16 64 8 32H479 192zM65.6 288c-1 5.2-1.6 10.5-1.6 16s.6 10.8 1.6 16H33 0l8-32 8-32H49l-8 32H65.6zm156.8 32c1-5.2 1.6-10.5 1.6-16s-.6-10.8-1.6-16H471l-8-32h33l8 32 8 32H479 222.4zM144 384H471l-8-32h33l8 32 8 32H479 33 0l8-32 8-32H49l-8 32H144zM512 512H479 33 0l8-32 8-32H49l-8 32H471l-8-32h33l8 32 8 32zM144 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32z'
      
    ]
  };

  

  
  

  var faCommand = {
    prefix: 'fasl',
    iconName: 'command',
    icon: [
      512,
      512,
      [],
      'e142',
      
      'M0 0H16 160h16V16 144H336V16 0h16H496h16V16 160v16H496 368V336H496h16v16V496v16H496 352 336V496 368H176V496v16H160 16 0V496 352 336H16 144V176H16 0V160 16 0zM144 144V32H32V144H144zm32 192H336V176H176V336zm-32 32H32V480H144V368zm224 0V480H480V368H368zm0-224H480V32H368V144z'
      
    ]
  };

  

  
  

  var faPopsicle = {
    prefix: 'fasl',
    iconName: 'popsicle',
    icon: [
      320,
      512,
      [],
      'e43e',
      
      'M288 160c0-70.7-57.3-128-128-128S32 89.3 32 160V352H144V192 176h32v16V352H288V160zM144 384H32 0V352 160C0 71.6 71.6 0 160 0s160 71.6 160 160V352v32H288 176V496v16H144V496 384z'
      
    ]
  };

  

  
  

  var faBookArrowUp = {
    prefix: 'fasl',
    iconName: 'book-arrow-up',
    icon: [
      448,
      512,
      [],
      'e0ba',
      
      'M64 0C28.7 0 0 28.7 0 64L0 448l0 0c0 35.3 28.7 64 64 64H176V480H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H176V384H64c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32H416V384H304v32h80v64H304v32H432h16V480H432 416V416h16 16V400 16 0H432 64zm68.7 228.7L121.4 240 144 262.6l11.3-11.3L224 182.6 224 496v16h32V496l0-313.4 68.7 68.7L336 262.6 358.6 240l-11.3-11.3-96-96L240 121.4l-11.3 11.3-96 96z'
      
    ]
  };

  

  
  

  var faCircleMicrophone = {
    prefix: 'fasl',
    iconName: 'circle-microphone',
    icon: [
      512,
      512,
      ["microphone-circle"],
      'e116',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 96h16 96 16v16V256c0 35.3-28.7 64-64 64s-64-28.7-64-64V112 96zm32 32V256c0 17.7 14.3 32 32 32s32-14.3 32-32V128H224zm-64 96v16 16c0 53 43 96 96 96s96-43 96-96V240 224h32v16 16c0 65.3-48.9 119.1-112 127v17 16H240V400 383c-63.1-7.9-112-61.7-112-127V240 224h32z'
      
    ]
  };

  
    var faMicrophoneCircle = faCircleMicrophone;
  

  
  

  var faSpiderWeb = {
    prefix: 'fasl',
    iconName: 'spider-web',
    icon: [
      576,
      512,
      [128376],
      'f719',
      
      'M146.3 5.8l13.2 2.5L289.1 32.6 418.8 8.3 432 5.8l4.7 12.6 48.8 130 81.1 97.3 8.5 10.2-8.5 10.2-81.1 97.3-48.8 130L432 506.2l-13.2-2.5L289.1 479.4 159.5 503.7l-13.2 2.5-4.7-12.6-48.8-130L11.7 266.2 3.2 256l8.5-10.2 81.1-97.3 48.8-130 4.7-12.6zm13.1 56.3L121.8 162.2l-1 2.5-1.7 2.1L58.2 240h70.5l41.1-46.9 24.6-69.8-35-61.2zM187 46l34.2 59.9 67.7 19.6 66.9-19.4L390 46.2 292.1 64.6l-2.9 .6-2.9-.6L187 46zM418.5 60.9l-35.2 61.7 24.9 70.5L449.1 240h71l-61-73.2-1.7-2.1-1-2.5-38-101.3zM520.1 272H449l-40.8 46.7-24.3 71.7 34.7 60.7 38-101.3 1-2.5 1.7-2.1 61-73.2zM390 465.8l-32.2-56.4-69.2-22.9-67.2 19.5L187 466l99.2-18.6 2.9-.6 2.9 .6L390 465.8zM159.4 449.9l35-61.2-24.6-69.9L128.8 272H58.2l61 73.2 1.7 2.1 1 2.5 37.5 100.1zm12-177.9l24.5 28 2 2.3 1 2.9 16.5 46.7L261 272H171.3zm72.8 94l40.3-11.7 4.8-1.4 4.7 1.6L334 367.8l-45.4-79.5L244.2 366zm118.4-12.7l16.3-47.9 1-3L382 300l24.5-28H316.1l46.5 81.3zm44-113.3L382 211.8l-2-2.3-1-2.9-16.7-47.3L316.1 240h90.5zM333 146l-39.6 11.5-4.5 1.3-4.5-1.3L244 145.8l44.5 77.9L333 146zM215.3 160l-16.4 46.6-1 2.9-2 2.3L171.2 240H261l-45.7-80z'
      
    ]
  };

  

  
  

  var faHandSpock = {
    prefix: 'fasl',
    iconName: 'hand-spock',
    icon: [
      576,
      512,
      [128406],
      'f259',
      
      'M273.8 1.7L278 17.2 324.4 186 344.9 70.3l7-39.4 2.8-15.8 15.8 2.8 78.8 13.9 15.8 2.8-2.8 15.8-7 39.4-3.8 21.8 76.1 18.3 15.6 3.7-3.7 15.6L478.6 401.6C463.1 466.4 405.2 512 338.6 512l-2.6 0-8.1 0-9.4 0c-58.8 0-115.8-20.9-160.6-59L51.7 362.7 39.5 352.3l10.4-12.2 51.8-61L112.1 267l12.2 10.4 31.5 26.8-49-150.8-12.4-38-4.9-15.2 15.2-4.9 72.2-23.5L170 46.9l-4.2-15.4 15.4-4.2L258.3 6l15.4-4.2zm-98.3 104l-45.6 14.8 7.4 22.8 63.2 194.3-28.9 21.7-55.7-47.3L84.6 348.7l94 79.9c39.1 33.2 88.6 51.4 139.9 51.4l9.4 0 8.1 0 2.6 0c51.8 0 96.8-35.5 108.9-85.9l56.9-237L457.7 146 426.6 275.7 423.6 288h-36l3.3-18.8 32.7-185 4.2-23.6-47.3-8.3-4.2 23.6L343.6 261.5 338.9 288H319.3l-6.9-25-61-221.9L205.1 53.8l58.8 214 5.6 20.2H234.6L231 276.9 182.8 128.6l-7.4-22.8z'
      
    ]
  };

  

  
  

  var faCircleCamera = {
    prefix: 'fasl',
    iconName: 'circle-camera',
    icon: [
      512,
      512,
      ["camera-circle"],
      'e103',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm60-352l-12-32H208l-12 32H160 128v32V320v32h32H352h32V320 192 160H352 316zm36 32V320H160V192h36 22.2l7.8-20.8 4.2-11.2h51.6l4.2 11.2 7.8 20.8H316h36zm-96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  
    var faCameraCircle = faCircleCamera;
  

  
  

  var faFacePersevering = {
    prefix: 'fasl',
    iconName: 'face-persevering',
    icon: [
      512,
      512,
      [],
      'e385',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM316.1 410.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7l-10.7 11.9-23.8-21.4 10.7-11.9C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3l10.7 11.9-23.8 21.4-10.7-11.9zM121.8 246l15.9-27.8 13.9 7.9 56 32L231.9 272l-24.3 13.9-56 32-13.9 7.9L121.8 298l13.9-7.9L167.4 272l-31.7-18.1L121.8 246zm254.5 7.9L344.6 272l31.7 18.1 13.9 7.9-15.9 27.8-13.9-7.9-56-32L280.1 272l24.3-13.9 56-32 13.9-7.9L390.2 246l-13.9 7.9zM222.6 112l-11.3 11.3-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L200 89.4 222.6 112zm78.1 11.3L289.4 112 312 89.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z'
      
    ]
  };

  

  
  

  var faGaugeSimpleLow = {
    prefix: 'fasl',
    iconName: 'gauge-simple-low',
    icon: [
      512,
      512,
      ["tachometer-slow"],
      'f62c',
      
      'M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm0 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64c0-18.6 7.9-35.3 20.5-47L129.9 151.6l-7.6-14.1 28.2-15.2 7.6 14.1 82.6 153.4c4.9-1.2 10-1.8 15.3-1.8c35.3 0 64 28.7 64 64s-28.7 64-64 64z'
      
    ]
  };

  
    var faTachometerSlow = faGaugeSimpleLow;
  

  
  

  var faFaceSaluting = {
    prefix: 'fasl',
    iconName: 'face-saluting',
    icon: [
      640,
      512,
      [129761],
      'e484',
      
      'M240.4 105.8l-15.3 9.1 33.1 52.9-40.7 25.4-93.6 58.5c-43.5 27.2-101 7.7-119-40.3c-13.8-36.9 .8-78.3 34.7-98.4L191.6 23.2 232.9-1.2l48.8 82.6-41.3 24.4zM224.1 78.3l13.8-8.1L221.6 42.6l-13.8 8.1L55.8 140.6c-20.5 12.1-29.4 37.2-21 59.6c10.9 29.1 45.7 40.9 72.1 24.4l93.6-58.5 13.6-8.5-17-27.1L183.5 139 128 173.7V135.1l96.1-56.8zM368.8 32.6c-10.1-.8-20.1-.8-30-.3L337 .4c11.2-.6 22.7-.6 34.2 .3c141 10.6 246.7 133.4 236.1 274.4s-133.4 246.7-274.4 236.1C221.7 503 132.5 424.8 104.9 323l30.9-8.4C159.9 403.8 238 472.1 335.3 479.4c123.4 9.3 230.9-83.3 240.1-206.6s-83.3-230.9-206.6-240.1zM352 400.5c-68.2 0-110.4-28.4-124.5-46l25-20c7.2 9 39.7 34 99.5 34s92.3-25 99.5-34l25 20c-14.1 17.6-56.3 46-124.5 46zm-79.6-216a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faChevronUp = {
    prefix: 'fasl',
    iconName: 'chevron-up',
    icon: [
      512,
      512,
      [],
      'f077',
      
      'M256 105.4l11.3 11.3 192 192L470.6 320 448 342.6l-11.3-11.3L256 150.6 75.3 331.3 64 342.6 41.4 320l11.3-11.3 192-192L256 105.4z'
      
    ]
  };

  

  
  

  var faSquareI = {
    prefix: 'fasl',
    iconName: 'square-i',
    icon: [
      448,
      512,
      [],
      'e272',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm144 96h80 80 16v32H304 240V352h64 16v32H304 240 208 144 128V352h16 64V160H144 128V128h16z'
      
    ]
  };

  

  
  

  var faCalendarCircleExclamation = {
    prefix: 'fasl',
    iconName: 'calendar-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e46e',
      
      'M128 16V0H96V16 64H32 0V96v64 32V480v32H32 330.8c-12.9-9.1-24.5-19.9-34.6-32H32V192H352h64 16 16V160 96 64H416 352V16 0H320V16 64H128V16zM32 96H416v64H32V96zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 448V416H416v32h32zm0-160H416v16 80 16h32V384 304 288z'
      
    ]
  };

  

  
  

  var faPlug = {
    prefix: 'fasl',
    iconName: 'plug',
    icon: [
      384,
      512,
      [128268],
      'f1e6',
      
      'M128 16V0H96V16v96h32V16zm160 0V0H256V16v96h32V16zM16 144H0v32H16 32v64c0 83 63.1 151.2 144 159.2V496v16h32V496 399.2c80.9-8 144-76.2 144-159.2V176h16 16V144H368 352 320 64 32 16zM192 368c-70.7 0-128-57.3-128-128V176H320v64c0 70.7-57.3 128-128 128z'
      
    ]
  };

  

  
  

  var faHouseCircleXmark = {
    prefix: 'fasl',
    iconName: 'house-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e50b',
      
      'M288 2.7L298.6 12 502.7 192.1c-2.2-.1-4.5-.1-6.7-.1c-12.8 0-25.3 1.4-37.3 4L288 45.3 96 214.7V480H208V304 288h16H339.2c-5.2 10.1-9.4 20.8-12.6 32H240V480l16 0H360.2c10 12.1 21.7 22.9 34.6 32H80 64V496 243L26.6 276 5.4 252l272-240L288 2.7zM608 368a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm203.3-36.7L518.6 368l36.7 36.7L566.6 416 544 438.6l-11.3-11.3L496 390.6l-36.7 36.7L448 438.6 425.4 416l11.3-11.3L473.4 368l-36.7-36.7L425.4 320 448 297.4l11.3 11.3L496 345.4l36.7-36.7L544 297.4 566.6 320l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faWorm = {
    prefix: 'fasl',
    iconName: 'worm',
    icon: [
      512,
      512,
      [],
      'e599',
      
      'M432 192V164.2l-27.5-3.9-31.1-4.4c-30.7-4.4-53.4-30.6-53.4-61.6C320 59.9 347.9 32 382.3 32H480v72 56 48V356c0 68.5-55.5 124-124 124s-124-55.5-124-124V320c0-44.2-35.8-80-80-80c-39.8 0-72 32.2-72 72V456v24H32V456 312c0-66.3 53.7-120 120-120c70.7 0 128 57.3 128 128v36c0 42 34 76 76 76s76-34 76-76V192zM382.3 0C330.2 0 288 42.2 288 94.3c0 46.9 34.5 86.7 80.9 93.3L400 192V356c0 24.3-19.7 44-44 44s-44-19.7-44-44V320c0-88.4-71.6-160-160-160C68.1 160 0 228.1 0 312V456v24 32H32 80h32V480 456 312c0-22.1 17.9-40 40-40c26.5 0 48 21.5 48 48v36c0 86.2 69.8 156 156 156s156-69.8 156-156V208 160 104 32 0H480 382.3zM408 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faFaceShush = {
    prefix: 'fasl',
    iconName: 'face-shush',
    icon: [
      512,
      512,
      [],
      'e38c',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 45.8-13.7 88.4-37.3 123.9l26.6 17.7C496.3 357 512 308.3 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 83.8 40.2 158.1 102.4 204.8l19.2-25.6C67.2 394.3 32 329.3 32 256zM200.4 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm160 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM208 244.1c-8.5-4.7-15.4-10.1-20.7-15.4l-22.6 22.6c10.3 10.3 24.7 20.8 43.3 28V304h-8H184 152v32 16 32 80 16 32h32 16 88 24 7.5 15l9.6-11.5 4.8-5.8 40-48 10.2-12.3 20.5-24.6L395 389.4l-24.6-20.5-24.6-20.5-1.9 2.2V336 304H312h-8V279.3c18.6-7.2 33.1-17.7 43.3-28l-22.6-22.6c-5.3 5.3-12.2 10.8-20.7 15.4V240 224 192H272 240 208v32 16 4.1zM272 224v16 64H240V240 224h32zM184 336h16 96 16v16 40 16H280V392 368H216v8.9L294.2 448h10.3l35.2-42.2L350 393.5 374.5 414l-10.2 12.3-40 48-4.8 5.8H312 288 200 184V464 384 352 336z'
      
    ]
  };

  

  
  

  var faFlaskRoundPotion = {
    prefix: 'fasl',
    iconName: 'flask-round-potion',
    icon: [
      448,
      512,
      ["flask-potion"],
      'f6e1',
      
      'M160 186.8V167.4 32H288V167.4v19.4l17.2 9c56.4 29.4 94.8 88.3 94.8 156.1c-55.6-1.3-87.4-15.5-115.7-30.1c-2.9-1.5-5.7-3-8.6-4.5C248.3 302.9 220 288 176 288c-47 0-83.5 12.8-108.4 25.8c-6.6 3.5-12.4 6.9-17.4 10.2c8.9-55.8 44.1-102.9 92.6-128.2l17.2-9zm237.1 197c-6.9 37.6-25.6 71-52.3 96.2H103.2c-31-29.2-51.3-69.5-54.7-114.4c1-.6 1.9-1.4 2.8-2.2l0 0 0 0 .2-.2c.3-.2 .7-.6 1.3-1.2c1.2-1.1 3.2-2.7 5.8-4.7c5.2-4 13.2-9.5 23.8-15C103.5 331.2 135 320 176 320c35.8 0 57.7 11.4 85.1 25.8c2.8 1.4 5.6 2.9 8.5 4.4c30.6 15.8 66.7 31.9 127.5 33.6zM51.3 363.4l0 0 0 0c0 0 0 0 0 0zm0 0l0 0s0 0 0 0zM320 167.4V32h16 16V0H336 320 288 160 128 112 96V32h16 16V167.4C61.4 202.1 16 271.8 16 352c0 64.3 29.2 121.8 75.1 160H356.9c45.9-38.2 75.1-95.7 75.1-160c0-80.2-45.4-149.9-112-184.6z'
      
    ]
  };

  
    var faFlaskPotion = faFlaskRoundPotion;
  

  
  

  var faPi = {
    prefix: 'fasl',
    iconName: 'pi',
    icon: [
      448,
      512,
      [],
      'f67e',
      
      'M16 64H0V96H16 128V346.4L67.5 422l25 20 64-80 3.5-4.4V352 96H320V432v16h16 80 10.8l4-10.1 16-40-29.7-11.9-12 29.9H352V96h80 16V64H432 16z'
      
    ]
  };

  

  
  

  var faOm = {
    prefix: 'fasl',
    iconName: 'om',
    icon: [
      512,
      512,
      [128329],
      'f679',
      
      'M329.4 41.4l16-16L368 2.7l22.6 22.6 16 16L429.3 64 406.6 86.6l-16 16L368 125.3l-22.6-22.6-16-16L306.7 64l22.6-22.6zM368 80l16-16L368 48 352 64l16 16zM144 128c-20.9 0-39.5 10-51.2 25.6l-9.6 12.8L57.6 147.2l9.6-12.8C84.7 111.1 112.6 96 144 96c53 0 96 43 96 96c0 24.6-9.2 47-24.4 64h82.8L374 195.5l4.4-3.5H384h16c61.9 0 112 50.1 112 112v80.9c0 52.5-42.6 95.1-95.1 95.1c-36 0-69-20.4-85.1-52.6l-10.1-20.3-7.2-14.3 28.6-14.3 7.2 14.3 10.1 20.3C371.1 434.5 393 448 416.9 448c34.9 0 63.1-28.3 63.1-63.1V304c0-44.2-35.8-80-80-80H389.6L314 284.5l-4.4 3.5H304 244.7c26.6 23.5 43.3 57.8 43.3 96c0 70.7-57.3 128-128 128H144C64.5 512 0 447.5 0 368V352H32v16c0 61.9 50.1 112 112 112h16c53 0 96-43 96-96s-43-96-96-96H144 128V256h16l0 0c35.3 0 64-28.7 64-64c0-35.3-28.7-64-64-64zm135.5 13.6s0 0 8.5-13.6s8.5-13.6 8.5-13.6l0 0 .2 .1c.2 .1 .6 .3 1.1 .6c1 .6 2.4 1.4 4.4 2.4c3.9 2 9.5 4.8 16.3 7.6c13.8 5.6 31.6 10.8 49.6 10.8s35.8-5.2 49.6-10.8c6.8-2.8 12.4-5.5 16.3-7.6c1.9-1 3.4-1.9 4.4-2.4c.5-.3 .8-.5 1.1-.6l.2-.1 0 0s0 0 8.5 13.6s8.5 13.6 8.5 13.6l0 0 0 0 0 0-.1 .1-.4 .3c-.4 .2-.9 .5-1.5 .9c-1.3 .8-3.1 1.8-5.5 3c-4.6 2.5-11.2 5.7-19.2 8.9c-15.8 6.4-38 13.2-61.6 13.2s-45.8-6.8-61.6-13.2c-8-3.2-14.6-6.5-19.2-8.9c-2.3-1.2-4.2-2.3-5.5-3c-.6-.4-1.2-.7-1.5-.9l-.4-.3-.1-.1 0 0 0 0 0 0z'
      
    ]
  };

  

  
  

  var faArrowTurnLeftDown = {
    prefix: 'fasl',
    iconName: 'arrow-turn-left-down',
    icon: [
      384,
      512,
      [],
      'e633',
      
      'M331.3 379.3L342.6 368 320 345.4l-11.3 11.3L208 457.4 208 32l160 0 16 0 0-32L368 0 192 0 176 0l0 16 0 441.4L75.3 356.7 64 345.4 41.4 368l11.3 11.3 128 128L192 518.6l11.3-11.3 128-128z'
      
    ]
  };

  

  
  

  var faFolderBookmark = {
    prefix: 'fasl',
    iconName: 'folder-bookmark',
    icon: [
      512,
      512,
      [],
      'e186',
      
      'M32 32H224l48 64H480h32v32V448v32H480 32 0V448 64 32H32zm384 96V304v25.9l-23.2-11.6L336 289.9l-56.8 28.4L256 329.9V304 128l-9.6-12.8L208 64H32V448H480V128H416zm-32 0H288V278.1l40.8-20.4 7.2-3.6 7.2 3.6L384 278.1V128z'
      
    ]
  };

  

  
  

  var faTurnRight = {
    prefix: 'fasl',
    iconName: 'turn-right',
    icon: [
      512,
      512,
      [],
      'e639',
      
      'M352 256l-32 0-192 0-32 0 0 32 0 160-64 0 0-256 288 0 32 0 0-32 0-50.7L466.7 224 352 338.7l0-50.7 0-32zm-32 96l0 32 32 0L489.4 246.6 512 224l-22.6-22.6L352 64l-32 0 0 32 0 32 0 32-32 0L32 160 0 160l0 32L0 448l0 32 32 0 64 0 32 0 0-32 0-128 0-32 32 0 128 0 32 0 0 32 0 32z'
      
    ]
  };

  

  
  

  var faPrintMagnifyingGlass = {
    prefix: 'fasl',
    iconName: 'print-magnifying-glass',
    icon: [
      640,
      512,
      ["print-search"],
      'f81a',
      
      'M160 32V160H128V32 0h32H448l64 64v96H480V77.3L434.7 32H160zM320 224H96V384h32V352 320h32H288c0 11 1.1 21.7 3.2 32H160V480H448h32v-3.2c6.2-1.3 12.2-2.9 18.2-4.8L512 485.8V512H480 160 128V480 416H96 64V384 224 192H96 352c-12.1 9.1-22.9 19.9-32 32zM448 416.2a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 32c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 29.6-10 56.8-26.9 78.5l78.1 77.7 11.3 11.3-22.6 22.7L604.7 499l-78.2-77.8c-21.7 16.9-48.9 26.9-78.5 26.9z'
      
    ]
  };

  
    var faPrintSearch = faPrintMagnifyingGlass;
  

  
  

  var faUtensilsSlash = {
    prefix: 'fasl',
    iconName: 'utensils-slash',
    icon: [
      640,
      512,
      [],
      'e464',
      
      'M544 336V320 32 0H512C496 0 384 32 384 176v49l32 25.3V176c0-62.5 23.8-97.7 47-117.8c12-10.4 24.4-17.2 34.5-21.3c7.6-3.1 12.6-4.2 14.3-4.6l.2-.1V320h-7.6L544 351.3V336zM224 261.8L176.2 224H176c-22.7 0-41.8-15.8-46.7-37L96.1 160.8c-.1 1.5-.1 3-.1 4.5V176c0 44.2 35.8 80 80 80h16V496v16h32V496 261.8zM168 15.2L166.1 53 197 77.3l3-60.5L200.8 0h-32L168 15.2zm-48.3 1.1L148.4 39l6.5-39H122.4l-2.7 16.3zM320 165.3c0-4.4-.4-8.8-1.1-13.2L293.6 0H261.1l24.6 147.4L320 174.5v-9.2zM248 15.2L247.2 0h-32l.8 16.8L220 95.5l33.4 26.3L248 15.2zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faPersonBikingMountain = {
    prefix: 'fasl',
    iconName: 'person-biking-mountain',
    icon: [
      640,
      512,
      [128693,"biking-mountain"],
      'f84b',
      
      'M392 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 392 0zM320.3 114.7l10.4 9.4L406.1 192H480h16v32H480 400h-6.1l-4.6-4.1-69.6-62.6L250 217.1c-8 6.8-7.3 19.4 1.3 25.3l93.7 64.4 6.9 4.8V320v96 16H320V416 328.4l-86.8-59.7c-26-17.9-28-55.5-4-76l80.4-68.9 10.7-9.1zM263.1 81.4l23.4 22-23.8 21.5-94.9 85.7L119 159.8 96.8 136.7l24.7-20.5L184.3 64h60.3l18.5 17.4zM231.9 96H195.8l-52.2 43.3L169.3 166l69.9-63.1L231.9 96zM421.1 474.1C398.2 451 384 419.1 384 384c0-70.7 57.3-128 128-128s128 57.3 128 128c0 35.3-14.3 67.3-37.4 90.4l-.2 .2C579.3 497.7 547.3 512 512 512c-35.1 0-67-14.2-90.1-37.1l-.8-.8zm9.3-144.2l3.3 3.3 7.8 7.8-4.4 10c-.5 1.1-1 2.3-1.4 3.4l-4 10.2h-11H416v38.9h4.6 11l4 10.2c.4 1.1 .9 2.3 1.4 3.4l4.4 10-7.8 7.7-3.3 3.3 27.5 27.5 3.3-3.3 7.8-7.8 10 4.4c1.1 .5 2.3 1 3.4 1.4l10.2 4v11V480h38.9v-4.6-11l10.2-4c1.1-.4 2.3-.9 3.4-1.4l10-4.4 7.8 7.8 3.3 3.3 27.5-27.5-3.3-3.3-7.7-7.7 4.4-10c.5-1.1 1-2.3 1.4-3.4l4-10.2h11H608V364.5h-4.6-11l-4-10.2c-.4-1.1-.9-2.3-1.4-3.4l-4.4-10 7.8-7.8 3.3-3.3-27.5-27.5-3.3 3.3-7.7 7.7-10-4.4c-1.1-.5-2.3-1-3.4-1.4l-10.2-4v-11V288H492.5v4.6 11l-10.2 4c-1.1 .4-2.3 .9-3.4 1.4l-10 4.4-7.7-7.7-3.3-3.3-27.5 27.5zM493 384a19 19 0 1 0 38 0 19 19 0 1 0 -38 0zm19 51a51 51 0 1 1 0-102 51 51 0 1 1 0 102zM0 384c0-70.7 57.3-128 128-128s128 57.3 128 128c0 35.3-14.3 67.3-37.4 90.4l-.1 .2C195.3 497.7 163.3 512 128 512c-35.1 0-67-14.2-90.1-37.1l-.8-.8C14.2 451 0 419.1 0 384zm73.9-81.6L46.4 329.9l3.3 3.3 7.8 7.8-4.4 10c-.5 1.1-1 2.3-1.4 3.4l-4 10.2h-11H32v38.9h4.6 11l4 10.2c.4 1.1 .9 2.3 1.4 3.4l4.4 10-7.7 7.7-3.3 3.3 27.5 27.5 3.3-3.3 7.7-7.8 10 4.4c1.1 .5 2.3 1 3.4 1.4l10.2 4v11V480h38.9v-4.6-11l10.2-4c1.1-.4 2.3-.9 3.4-1.4l10-4.4 7.8 7.8 3.3 3.3 27.5-27.5-3.3-3.3-7.7-7.7 4.4-10c.5-1.1 1-2.3 1.4-3.4l4-10.2h11H224V364.5h-4.6-11l-4-10.2c-.4-1.1-.9-2.3-1.4-3.4l-4.4-10 7.7-7.8 3.3-3.3-27.5-27.5-3.3 3.3-7.7 7.7-10-4.4c-1.1-.5-2.3-1-3.4-1.4l-10.2-4v-11V288H108.5v4.6 11l-10.2 4c-1.1 .4-2.3 .9-3.4 1.4l-10 4.4-7.7-7.7-3.3-3.3zM128 365a19 19 0 1 0 0 38 19 19 0 1 0 0-38zm51 19A51 51 0 1 1 77 384a51 51 0 1 1 102 0z'
      
    ]
  };

  
    var faBikingMountain = faPersonBikingMountain;
  

  
  

  var faHand = {
    prefix: 'fasl',
    iconName: 'hand',
    icon: [
      512,
      512,
      [9995,129306,"hand-paper"],
      'f256',
      
      'M224 0H208V16 32H144 128V48 288.8L95.6 256.4 67.3 228.1 56 216.8 44.7 228.1l-40 40L0 272.8v6.6 33.1 6.6l4.7 4.7 11.7 11.7L120.2 439.4C166.7 485.9 229.8 512 295.5 512H304l0 0c97.2 0 176-78.8 176-176V112 96H464 400h0V48 32H384 320l0-16 0-16H304 224zM368 128V240v16h32V240 128h48V336c0 79.5-64.5 144-144 144l0 0h-8.4c-57.3 0-112.2-22.8-152.7-63.3L39 313l-7-7V286.1l24-24 17 17 48 48 11.3 11.3L143.6 327l11.7-11.7 4.7-4.7V304 64h48V240v16h32V240 48 32h48l0 16 0 16h0V80 240v16h32V240 80 64h48v48 16h0z'
      
    ]
  };

  
    var faHandPaper = faHand;
  

  
  

  var faHeadSideBrain = {
    prefix: 'fasl',
    iconName: 'head-side-brain',
    icon: [
      512,
      512,
      [],
      'f808',
      
      'M32 224C32 118 118 32 224 32h24c88.4 0 160 71.6 160 160v7.2l5.4 4.8L480 263.2V304H432 416v16 96H304 288v16 64 16h32V496 448H432h16V432 336h48 16V320 256v-7.2l-5.4-4.8-66.8-59.3C436 82 351.6 0 248 0H224C100.3 0 0 100.3 0 224c0 61 24.4 116.4 64 156.8V496v16H96V496 374.1v-6.8l-4.9-4.7C54.6 327.6 32 278.4 32 224zm171.1-99.8c4.1-7.3 12-12.2 20.9-12.2s16.8 4.9 20.9 12.2l7.7 13.7 13.8-7.5c2.8-1.5 6-2.4 9.5-2.4c7 0 13.2 3.6 16.8 9.1l5.6 8.6 10.1-1.5c1.1-.2 2.3-.3 3.5-.3c13.3 0 24 10.7 24 24v24H272 256v16 16 16H240 224v32h16 32 16V256 224h64 16V208 168c0-30.4-24.2-55.2-54.5-56c-9.5-9.9-22.8-16-37.5-16c-4 0-7.8 .4-11.5 1.3C254.3 86.6 239.9 80 224 80s-30.3 6.6-40.5 17.3C179.8 96.4 176 96 172 96c-22.2 0-41.1 13.9-48.6 33.4C98.6 135.1 80 157.4 80 184c0 19.2 9.7 36.1 24.3 46.2c3.1 28 26.8 49.8 55.7 49.8v24 16h32V304 264 248H176 160c-13.3 0-24-10.7-24-24c0-.7 0-1.3 .1-2l.9-11.4L126.5 206c-8.6-3.7-14.5-12.2-14.5-22c0-13.3 10.7-24 24-24l.2 0 14.4 0 1.6-14.3c1.1-10 9.6-17.8 19.9-17.8c3.5 0 6.7 .9 9.5 2.4l13.8 7.5 7.7-13.7z'
      
    ]
  };

  

  
  

  var faCucumber = {
    prefix: 'fasl',
    iconName: 'cucumber',
    icon: [
      512,
      512,
      [129362],
      'e401',
      
      'M60.1 316.1l256-256c37.5-37.5 98.3-37.5 135.8 0s37.5 98.3 0 135.8l-256 256c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8zM37.5 474.5c49.7 49.7 130 50 180 1L232 489.9 265.9 456l-14.5-14.5L441.5 251.5 456 265.9 489.9 232l-14.5-14.5c49-50.1 48.7-130.4-1-180c-50-50-131-50-181 0l-127 127L152 150.1 118.1 184l14.5 14.5-95 95c-50 50-50 131 0 181zM168 288H128v40h40V288zm144-64v40h40V224H312zM384 96H344v40h40V96z'
      
    ]
  };

  

  
  

  var faPoliceBox = {
    prefix: 'fasl',
    iconName: 'police-box',
    icon: [
      384,
      512,
      [],
      'e021',
      
      'M208 16V0H176V16 32H80 64V48 64H48 32V80 480H16 0v32H16 368h16V480H368 352V80 64H336 320V48 32H304 208V16zM320 480H64V96H80 96V80 64h80 32 80V80 96h16 16V480zM112 280h48v48H112V280zM88 256v24 48 24h24 48 24V328 280 256H160 112 88zm44-104v20H112V152h20zm0 28v20H112V180h20zm28 0v20H140V180h20zm-20-8V152h20v20H140zm-28-44H88v24 48 24h24 48 24V200 152 128H160 112zm140 24h20v20H252V152zm-8 0v20H224V152h20zm0 28v20H224V180h20zm8 20V180h20v20H252zm-52-72v24 48 24h24 48 24V200 152 128H272 224 200z'
      
    ]
  };

  

  
  

  var faFlaskVial = {
    prefix: 'fasl',
    iconName: 'flask-vial',
    icon: [
      640,
      512,
      [],
      'e4f3',
      
      'M224 32h32V0H224 192 64 32 0V32H32V352c0 53 43 96 96 96c11.2 0 22-1.9 32-5.5V432 418.4l7.1-11.6 5.5-9C161.1 409.1 145.4 416 128 416c-35.3 0-64-28.7-64-64V192H192V352c0 6.7-1 13.1-2.9 19.1L224 314.4V32zM64 32H192V160H64V32zM304 0H288V32h16 16V219.5L194.4 423.6l-2.4 3.9V432v64 16h16H624h16V496 432v-4.5l-2.4-3.9L512 219.5V32h16 16V0H528 304zM480 32V224v4.5l2.4 3.9L536.3 320H295.7l53.9-87.6 2.4-3.9V224 32H480zM224 436.5L276 352H556l52 84.5V480H224V436.5z'
      
    ]
  };

  

  
  

  var faEyeSlash = {
    prefix: 'fasl',
    iconName: 'eye-slash',
    icon: [
      640,
      512,
      [],
      'f070',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM608 256C578 181.3 478.4 32 320 32c-50.2 0-94.5 15-132.5 37.8l27.1 21.4C245.9 74.4 281.1 64 320 64c68.4 0 125.4 32.1 170 75c39.8 38.3 67.9 83.7 83.2 117c-10.5 22.8-27 51.4-49.3 79.4L549 355.3c28.4-35.8 48.2-72.4 59-99.3zM91 156.7C62.6 192.5 42.8 229.1 32 256c30 74.7 129.6 224 288 224c50.2 0 94.5-15 132.5-37.8l-27.1-21.4C394.1 437.6 358.9 448 320 448c-68.4 0-125.4-32.1-170-75c-39.8-38.3-67.9-83.7-83.2-117c10.5-22.8 27-51.4 49.3-79.4L91 156.7zM320 384c16.7 0 32.7-3.2 47.4-9.1l-30.9-24.4c-5.4 .9-10.9 1.4-16.5 1.4c-51 0-92.8-39.8-95.8-90.1l-30.9-24.4c-.9 6-1.3 12.2-1.3 18.5c0 70.7 57.3 128 128 128zM448 256c0-70.7-57.3-128-128-128c-16.7 0-32.7 3.2-47.4 9.1l30.9 24.4c5.4-.9 10.9-1.4 16.5-1.4c51 0 92.8 39.8 95.8 90.1l30.9 24.4c.9-6 1.3-12.2 1.3-18.5z'
      
    ]
  };

  

  
  

  var faFacePleading = {
    prefix: 'fasl',
    iconName: 'face-pleading',
    icon: [
      512,
      512,
      [],
      'e386',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280.1 410.7c-4.7-5.3-12.7-10.7-24.1-10.7s-19.4 5.4-24.1 10.7l-10.7 11.9-23.8-21.4 10.7-11.9c9.2-10.2 25.2-21.3 47.9-21.3s38.7 11.1 47.9 21.3l10.7 11.9-23.8 21.4-10.7-11.9zM316.2 101L347 92.2l4.4 15.4 1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4 15.9 2-4 31.8-13.8-1.7c10 13.3 15.9 29.9 15.9 47.9c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-41.5 31.5-75.6 72-79.6c-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2L316.2 101zM191.4 116.4l-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-17.9 5.9-34.5 15.9-47.9l-13.8 1.7-4-31.8 15.9-2 11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2L165 92.2l30.8 8.8-4.4 15.4zM160 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm240-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-272 0c17.7 0 32-14.3 32-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm224-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c17.7 0 32-14.3 32-32z'
      
    ]
  };

  

  
  

  var faUsers = {
    prefix: 'fasl',
    iconName: 'users',
    icon: [
      640,
      512,
      [],
      'f0c0',
      
      'M96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zm128 0A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm96 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM199.8 384H440.2L469 480H171l28.8-96zM464 352H176L137.6 480 128 512h33.4H478.6 512l-9.6-32L464 352zM448 224H569.8l36 96H640L592 192H444c2.6 10.2 4 21 4 32zM196 192H48L0 320H34.2l36-96H192c0-11 1.4-21.8 4-32zM464 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 432 80a80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faCircleF = {
    prefix: 'fasl',
    iconName: 'circle-f',
    icon: [
      512,
      512,
      [],
      'e10e',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 128H160v16V256 368v16h32V368 272H304h16V240H304 192V160H336h16V128H336 176z'
      
    ]
  };

  

  
  

  var faRight = {
    prefix: 'fasl',
    iconName: 'right',
    icon: [
      448,
      512,
      [11157,"arrow-alt-right"],
      'f356',
      
      'M240 208l-32 0L32 208l0 96 176 0 32 0 0 32 0 80 2.7 0 160-160L242.8 96 240 96l0 80 0 32zM256 64L425.4 233.4 448 256l-22.6 22.6L256 448l-16 0-32 0 0-32 0-48 0-32-32 0L32 336 0 336l0-32 0-96 0-32 32 0 144 0 32 0 0-32 0-48 0-32 32 0 16 0z'
      
    ]
  };

  
    var faArrowAltRight = faRight;
  

  
  

  var faPersonRays = {
    prefix: 'fasl',
    iconName: 'person-rays',
    icon: [
      512,
      512,
      [],
      'e54d',
      
      'M232 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 200 56a56 56 0 1 0 112 0zM204.9 128h-9.6l-4.5 8.5-76.9 144-7.5 14.1 28.2 15.1 7.5-14.1L192 202.1V496v16h32V496 352h64V496v16h32V496 202.2l49.9 93.4 7.5 14.1 28.2-15.1-7.5-14.1-76.9-144-4.5-8.5h-9.6H204.9zM288 320H224V160h64V320zM100.7 123.3l22.6-22.6-96-96L4.7 27.3l96 96zm310.6 0l96-96L484.7 4.7l-96 96 22.6 22.6zM4.7 484.7l22.6 22.6 96-96-22.6-22.6-96 96zm406.6-96l-22.6 22.6 96 96 22.6-22.6-96-96z'
      
    ]
  };

  

  
  

  var faReplyClock = {
    prefix: 'fasl',
    iconName: 'reply-clock',
    icon: [
      640,
      512,
      ["reply-time"],
      'e239',
      
      'M496 32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256A144 144 0 1 0 496 0a144 144 0 1 0 0 288zM512 64H480V80v64 16h16 48 16V128H544 512V80 64zm0 272c0-5.6-.3-11.2-.8-16.6c-5 .4-10.1 .6-15.2 .6c-5.7 0-11.4-.3-17-.8c.6 5.5 1 11.1 1 16.8c0 38.2-13.9 67.8-32.1 90.3C444.9 349.4 381.6 288 304 288H224 192v32 52.6L47.4 240 192 107.4V160v32h32H326.6c-2.9-10.3-4.9-21-5.9-32H256 224V128 96 64H192L23.7 218.3 0 240l23.7 21.7L192 416h32V384 352 320h32 48c61.9 0 112 50.1 112 112c0 9.9-1.4 19-3.5 27.4C404.2 491.8 384 512 384 512s27-10.1 56.2-33.4C474.5 451.1 512 405.2 512 336z'
      
    ]
  };

  
    var faReplyTime = faReplyClock;
  

  
  

  var faMitten = {
    prefix: 'fasl',
    iconName: 'mitten',
    icon: [
      448,
      512,
      [],
      'f7b5',
      
      'M0 135.4C0 60.6 60.6 0 135.4 0C195.1 0 247.7 39.1 265 96.2l30.8 101.7 18.7-30.3 8.2-13.3 13.5 7.9 96 56 13.2 7.7-7.1 13.6L370.5 368H334.3l68.4-129.9-69.3-40.4L304.3 245l-18.6 30.3-10.3-34.1L234.3 105.5C221.1 61.8 180.9 32 135.4 32C78.3 32 32 78.3 32 135.4v8.9c0 9.2 1.1 18.3 3.3 27.2L84.5 368h-33L4.3 179.2C1.4 167.7 0 156 0 144.2v-8.9zM64 432v48H352V432H64zM32 400H64 352h32v32 48 32H352 64 32V480 432 400z'
      
    ]
  };

  

  
  

  var faArrowDownZA = {
    prefix: 'fasl',
    iconName: 'arrow-down-z-a',
    icon: [
      576,
      512,
      ["sort-alpha-desc","sort-alpha-down-alt"],
      'f881',
      
      'M160 478.6l11.3-11.3 88-88L270.6 368 248 345.4l-11.3 11.3L176 417.4V48 32H144V48 417.4L83.3 356.7 72 345.4 49.4 368l11.3 11.3 88 88L160 478.6zM336 32V64h16 99.5L340 189.4l-4 4.5V200v8 16h16H480h16V192H480 380.5L492 66.6l4-4.5V56 48 32H480 352 336zm65.4 265.5l-80 180-1.1 2.5h35l14.2-32h93l14.2 32h35l-1.1-2.5-80-180-4.2-9.5H405.6l-4.2 9.5zM416 343.4L448.3 416H383.7L416 343.4z'
      
    ]
  };

  
    var faSortAlphaDesc = faArrowDownZA;
  
    var faSortAlphaDownAlt = faArrowDownZA;
  

  
  

  var faBagShopping = {
    prefix: 'fasl',
    iconName: 'bag-shopping',
    icon: [
      448,
      512,
      ["shopping-bag"],
      'f290',
      
      'M160 96v32H288V96c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 64H32V480H416V160H320v80 16H288V240 160H160v80 16H128V240 160zm0-32V96c0-53 43-96 96-96s96 43 96 96v32h96 32v32V480v32H416 32 0V480 160 128H32h96z'
      
    ]
  };

  
    var faShoppingBag = faBagShopping;
  

  
  

  var faHandHeart = {
    prefix: 'fasl',
    iconName: 'hand-heart',
    icon: [
      512,
      512,
      [],
      'f4bc',
      
      'M208 0h16 80 16l0 16 0 16h64 16V48 96h0 64 16v16V336c0 97.2-78.8 176-176 176l0 0h-8.5c-65.8 0-128.9-26.1-175.4-72.6L16.4 335.6 4.7 323.9 0 319.2v-6.6V279.4v-6.6l4.7-4.7 40-40L56 216.8l11.3 11.3 28.3 28.3L128 288.8V48 32h16 64V16 0zM368 128V112 64H320V80 240v16H288V240 80 64h0l0-16 0-16H240V48 240v16H208V240 64H160V304v6.6l-4.7 4.7L143.6 327l-11.3 11.3L121 327 73 279l-17-17-24 24v19.9l7 7L142.8 416.7c40.5 40.5 95.4 63.3 152.7 63.3H304l0 0c79.5 0 144-64.5 144-144V128H400V240v16H368V240 128h0zM266.1 328.5l-5.2-4.8c-4.3-4-10-6.3-15.9-6.3h-3.5c-10.9 0-19.8 8.9-19.8 19.8c0 5.5 2.3 10.7 6.3 14.4l60 56.1 60-56.1c4-3.7 6.3-9 6.3-14.4c0-10.9-8.9-19.8-19.8-19.8H331c-5.9 0-11.6 2.2-15.9 6.3l-5.2 4.8L288 348.9l-21.9-20.4zm-76.4 8.7c0-28.6 23.2-51.8 51.8-51.8H245c14 0 27.5 5.3 37.8 14.9l5.2 4.8 5.2-4.8c10.3-9.6 23.8-14.9 37.8-14.9h3.5c28.6 0 51.8 23.2 51.8 51.8c0 14.3-5.9 28-16.4 37.8l-70.9 66.4L288 451.5l-10.9-10.2-70.9-66.4c-10.5-9.8-16.4-23.5-16.4-37.8z'
      
    ]
  };

  

  
  

  var faTruckContainerEmpty = {
    prefix: 'fasl',
    iconName: 'truck-container-empty',
    icon: [
      640,
      512,
      [],
      'e2b5',
      
      'M448 128h16 88 7.1l4.8 5.3 72 80 4.1 4.6V224v32 48 16 48 32H608c0 44.2-35.8 80-80 80s-80-35.8-80-80H288c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c32.8 0 61 19.7 73.3 48H448V256 240 224 144 128zm32 128v80c13.4-10 30-16 48-16c32.8 0 61 19.7 73.3 48H608V320 304 256H480zm122.5-32l-57.6-64H480v64H602.5zM528 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faCalendarExclamation = {
    prefix: 'fasl',
    iconName: 'calendar-exclamation',
    icon: [
      448,
      512,
      [],
      'f334',
      
      'M128 0V16 64H320V16 0h32V16 64h64 32V96v64 32V480v32H416 32 0V480 192 160 96 64H32 96V16 0h32zM416 192H32V480H416V192zm0-96H32v64H416V96zM240 240v16 96 16H208V352 256 240h32zm0 160v32H208V400h32z'
      
    ]
  };

  

  
  

  var faSink = {
    prefix: 'fasl',
    iconName: 'sink',
    icon: [
      512,
      512,
      [],
      'e06d',
      
      'M272 80c0-26.5 21.5-48 48-48s48 21.5 48 48v32 16h32V112 80c0-44.2-35.8-80-80-80s-80 35.8-80 80V288H160V240 224H144 48 32v32H48h80v32H16 0v32H16 128h32 80 32 80 32H496h16V288H496 384V256h80 16V224H464 368 352v16 48H272V80zM32 352v48c0 61.9 50.1 112 112 112H368c61.9 0 112-50.1 112-112V352H448v48c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V352H32z'
      
    ]
  };

  

  
  

  var faSunset = {
    prefix: 'fasl',
    iconName: 'sunset',
    icon: [
      576,
      512,
      [127751],
      'f767',
      
      'M288 230.6l11.3-11.3 96-96L406.6 112 384 89.4l-11.3 11.3L304 169.4V16 0H272V16 169.4l-68.7-68.7L192 89.4 169.4 112l11.3 11.3 96 96L288 230.6zm0 50.5l-77.3-41.6L182 224l-9.4 31.3-25.2 84.1L63.3 364.6 32 374l15.5 28.8L71.9 448h36.3L78.8 393.3 156.6 370l16.5-5 5-16.5 23.3-77.8 71.5 38.5 15.2 8.2 15.2-8.2 71.5-38.5L398 348.6l5 16.5 16.5 5 77.8 23.3L467.8 448h36.3l24.4-45.3L544 374l-31.3-9.4-84.1-25.2-25.2-84.1L394 224l-28.8 15.5L288 281.1zM412 448c-14.2-55.2-64.3-96-124-96s-109.8 40.8-124 96h33.4c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H412zM16 480H0v32H16 560h16V480H560 16z'
      
    ]
  };

  

  
  

  var faMicroscope = {
    prefix: 'fasl',
    iconName: 'microscope',
    icon: [
      512,
      512,
      [128300],
      'f610',
      
      'M176 0H160V16 32H144 128V48 304v16h16H272h16V304 160c88.4 0 160 71.6 160 160s-71.6 160-160 160H208 16 0v32H16 208h80H496h16V480H496 394.2c51.7-34.4 85.8-93.2 85.8-160c0-106-86-192-192-192V48 32H272 256V16 0H240 176zM160 288V64h16 16V48 32h32V48 64h16 16V288H160zm0 64v32h16 64 16V352H240 176 160zM96 416v32h16H304h16V416H304 112 96z'
      
    ]
  };

  

  
  

  var faHourglassHalf = {
    prefix: 'fasl',
    iconName: 'hourglass-half',
    icon: [
      384,
      512,
      ["hourglass-2"],
      'f252',
      
      'M16 512H0V480H16 32V368v-7.8l6.2-4.8L165.9 256 38.2 156.6 32 151.8V144 32H16 0V0H16 48 336h32 16V32H368 352V144v7.8l-6.2 4.8L218.1 256l127.8 99.4 6.2 4.8V368 480h16 16v32H368 336 48 16zm304-32V416H64v64H320zM64 375.8V384H320v-8.2L192 276.3 64 375.8zM94.6 160L192 235.7 289.4 160H94.6zM320 128V32H64v96H320z'
      
    ]
  };

  
    var faHourglass2 = faHourglassHalf;
  

  
  

  var faCircleCalendar = {
    prefix: 'fasl',
    iconName: 'circle-calendar',
    icon: [
      512,
      512,
      ["calendar-circle"],
      'e102',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM224 96v16 16h64V112 96h32v16 16h32 32v32 32 32V352v32H352 160 128V352 224 192 160 128h32 32V112 96h32zm-32 64H160v32H352V160H320 288 224 192zm160 64H160V352H352V224z'
      
    ]
  };

  
    var faCalendarCircle = faCircleCalendar;
  

  
  

  var faCircleW = {
    prefix: 'fasl',
    iconName: 'circle-w',
    icon: [
      512,
      512,
      [],
      'e12c',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM104.6 160l72.2 228.8 3.5 11.2h23.4l3.6-11.1L256 236.5l48.8 152.4 3.6 11.1h23.4l3.5-11.2L407.4 160H373.9l-54 171.2-48.7-152L265.1 160H246.9l-6.1 19.1-48.7 152L138.1 160H104.6z'
      
    ]
  };

  

  
  

  var faHeartCircleMinus = {
    prefix: 'fasl',
    iconName: 'heart-circle-minus',
    icon: [
      576,
      512,
      [],
      'e4ff',
      
      'M256 141.3l-22.6-22.6L209.1 94.4C189.7 74.9 163.3 64 135.8 64C78.5 64 32 110.5 32 167.8c0 27.5 10.9 53.9 30.4 73.4l24.2 24.2L256 434.8l9.5-9.5c3.7 10.9 8.5 21.3 14.2 31.1l-1.1 1.1L256 480l-22.6-22.6L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8l1.6 1.6L256 96l22.6-22.6 1.6-1.6c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 13.8-2.1 27.4-6.2 40.4c-9.6-4.5-19.7-8.1-30.2-10.7c2.9-9.5 4.3-19.5 4.3-29.7C480 110.5 433.5 64 376.2 64c-27.5 0-53.9 10.9-73.4 30.4l-24.2 24.2L256 141.3zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 160H496 368 352V352h16H496h16v32z'
      
    ]
  };

  

  
  

  var faWaveSine = {
    prefix: 'fasl',
    iconName: 'wave-sine',
    icon: [
      640,
      512,
      [8767],
      'f899',
      
      'M31.4 244.2s0 0-15.4-4.2S.6 235.8 .6 235.8l0 0 0 0 0-.1 .1-.5c.1-.4 .3-.9 .5-1.6c.4-1.4 1-3.4 1.8-5.9c1.6-5 4-12.2 7.3-20.8c6.5-17.1 16.3-40 29.9-63C66.8 99 110.9 48 176 48c51.5 0 84.9 28.8 108.2 67.8c22.6 37.8 37 87.4 50.7 134.4l.4 1.3c14.2 48.6 27.6 94.4 47.9 128.3c19.7 33 44.2 52.2 80.8 52.2c46.9 0 82.8-37 108.2-80.1c12.4-21 21.5-42.1 27.6-58c3-7.9 5.2-14.5 6.7-19.1c.7-2.3 1.3-4.1 1.6-5.2l.4-1.3 .1-.3 0-.1 0 0s0 0 15.4 4.2s15.4 4.2 15.4 4.2l0 0 0 0 0 .1-.1 .5c-.1 .4-.3 .9-.5 1.6c-.4 1.4-1 3.4-1.8 5.9c-1.6 5-4 12.2-7.3 20.8c-6.5 17.1-16.3 40-29.9 63C573.2 413 529.1 464 464 464c-51.5 0-84.9-28.8-108.2-67.8c-22.6-37.8-37-87.4-50.7-134.4l-.4-1.3c-14.2-48.6-27.6-94.4-47.9-128.3C237.1 99.2 212.5 80 176 80c-46.9 0-82.8 37-108.2 80.1c-12.4 21-21.5 42.1-27.6 58c-3 7.9-5.2 14.5-6.7 19.1c-.7 2.3-1.3 4.1-1.6 5.2l-.4 1.3-.1 .3 0 .1 0 0z'
      
    ]
  };

  

  
  

  var faDisplayChartUpCircleDollar = {
    prefix: 'fasl',
    iconName: 'display-chart-up-circle-dollar',
    icon: [
      640,
      512,
      [],
      'e5e6',
      
      'M32 32H544V198.6c11.2 3.2 21.9 7.4 32 12.6V32 0H544 32 0V32 384v32H32 213.1l-10.7 64H144 128v32h16 72H360h34.8c-12.9-9.1-24.5-19.9-34.6-32H341.1 288 234.9l10.7-64H288h38.6c-2.9-10.3-4.9-21-5.9-32H232.3c-.2 0-.4 0-.6 0H32V32zM480 192.7V112 96H464 368 352v32h16 57.4L304 249.4l-68.7-68.7L224 169.4l-11.3 11.3-112 112L89.4 304 112 326.6l11.3-11.3L224 214.6l68.7 68.7L304 294.6l11.3-11.3L448 150.6v48c10.3-2.9 21-4.9 32-5.9zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM472.8 335.4c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1l15.5 3.9 7.7-31.1L529.9 301c-5.6-1.4-11.6-2.7-17.9-3.7V288 272H480v16 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8l-15.3-4.8L436 425.2l15.3 4.8c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4 16h32v-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z'
      
    ]
  };

  

  
  

  var faShareNodes = {
    prefix: 'fasl',
    iconName: 'share-nodes',
    icon: [
      448,
      512,
      ["share-alt"],
      'f1e0',
      
      'M448 112c0 44.2-35.8 80-80 80c-22.9 0-43.6-9.6-58.1-25l-151 75.5c.8 4.4 1.1 8.9 1.1 13.5s-.4 9.1-1.1 13.5l151 75.5c14.6-15.4 35.2-25 58.1-25c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80c0-9.7 1.7-19 4.9-27.7L147.2 299.5c-14.3 22-39 36.5-67.2 36.5c-44.2 0-80-35.8-80-80s35.8-80 80-80c28.2 0 52.9 14.5 67.2 36.5l145.7-72.9c-3.2-8.6-4.9-17.9-4.9-27.7c0-44.2 35.8-80 80-80s80 35.8 80 80zM80 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM416 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM368 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  
    var faShareAlt = faShareNodes;
  

  
  

  var faKnife = {
    prefix: 'fasl',
    iconName: 'knife',
    icon: [
      512,
      512,
      ["utensil-knife"],
      'f2e4',
      
      'M465.2 13.8L454.4 25.6c10.8-11.8 10.8-11.8 10.8-11.8l0 0 0 0 .1 .1 .2 .1 .5 .5c.4 .4 .9 .9 1.6 1.6c1.3 1.4 3.2 3.3 5.4 5.8c4.4 4.9 10.1 12.1 15.8 21.2C500.2 61.2 512 87.8 512 120c0 29.9-14.2 63.2-40.4 101.5c-26.5 38.6-66.6 84.3-121.4 139.1l-42.8 42.8L296 414.8l-11.3-11.3L201.2 320 24.5 510.1 1.1 488.3 189 286l0 0L442.7 14.7 453.5 3.1l11.7 10.6zm-11 35.6L223 296.5l73 73L327.5 338c54.3-54.3 92.8-98.3 117.6-134.6c25-36.5 34.8-63.3 34.8-83.5c0-24.3-9-45-18.3-59.9c-2.6-4.1-5.2-7.7-7.5-10.8z'
      
    ]
  };

  
    var faUtensilKnife = faKnife;
  

  
  

  var faLightbulbOn = {
    prefix: 'fasl',
    iconName: 'lightbulb-on',
    icon: [
      640,
      512,
      [],
      'f672',
      
      'M464 176c0 30.6-9.5 58.8-25.7 82.1c-4.1 5.9-8.7 12.3-13.6 19c-12.7 17.5-27.1 37.2-38 57.1c-8.9 16.2-13.7 33.3-16.2 49.9H403c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8l0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0 0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9c-10.9-20-25.3-39.7-38-57.1l0 0c-4.9-6.7-9.5-13-13.6-19C185.5 234.8 176 206.6 176 176c0-79.5 64.5-144 144-144s144 64.5 144 144zm-224 0c0-44.2 35.8-80 80-80V64c-61.9 0-112 50.1-112 112h32zm32 304V448h96v32H272zm-32-64v32 32 32h32 96 32V480 448 416H368 272 240zM67.2 7.7L52.8 .5 38.5 29.2l14.3 7.2 52 26 14.3 7.2 14.3-28.6-14.3-7.2-52-26zm520 28.6l14.3-7.2L587.2 .5 572.8 7.7l-52 26-14.3 7.2 14.3 28.6 14.3-7.2 52-26zM16 160H0v32H16 80 96V160H80 16zm544 0H544v32h16 64 16V160H624 560zM119.2 318.3l14.3-7.2-14.3-28.6-14.3 7.2-52 26-14.3 7.2 14.3 28.6 14.3-7.2 52-26zm416-28.6l-14.3-7.2-14.3 28.6 14.3 7.2 52 26 14.3 7.2 14.3-28.6-14.3-7.2-52-26z'
      
    ]
  };

  

  
  

  var faMessageMiddleTop = {
    prefix: 'fasl',
    iconName: 'message-middle-top',
    icon: [
      512,
      512,
      ["comment-middle-top-alt"],
      'e1e2',
      
      'M173.7 96H32 0v32V480v32H32 480h32V480 128 96H480 338.3L277.1 24.6 256 0 234.9 24.6 173.7 96zM256 49.2l58 67.7 9.6 11.2h14.7H480V480H32V128H173.7h14.7l9.6-11.2 58-67.7z'
      
    ]
  };

  
    var faCommentMiddleTopAlt = faMessageMiddleTop;
  

  
  

  var faCarSide = {
    prefix: 'fasl',
    iconName: 'car-side',
    icon: [
      640,
      512,
      [128663],
      'f5e4',
      
      'M117.2 32H128 384h7.7l4.8 6L519.7 192H608h32v32V368v32H608 574.7c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H254.7c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H32 0V368 224 192H32 53.2l60-149.9 4-10.1zM418 368c-1.3 5.1-2 10.5-2 16s.7 10.9 2 16c7.1 27.6 32.2 48 62 48s54.9-20.4 62-48c1.3-5.1 2-10.5 2-16s-.7-10.9-2-16c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48zm156.7 0H608V224H32V368H65.3c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80H385.3c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80zM96 384c0 5.5 .7 10.9 2 16c7.1 27.6 32.2 48 62 48s54.9-20.4 62-48c1.3-5.1 2-10.5 2-16s-.7-10.9-2-16c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48c-1.3 5.1-2 10.5-2 16zM87.6 192H224V176 80 64H138.8L87.6 192zM256 192H478.7L376.3 64H256V80v96 16z'
      
    ]
  };

  

  
  

  var faSquareSliders = {
    prefix: 'fasl',
    iconName: 'square-sliders',
    icon: [
      448,
      512,
      ["sliders-h-square"],
      'f3f0',
      
      'M32 448l384 0 0-384L32 64l0 384zM0 64L0 32l32 0 384 0 32 0 0 32 0 384 0 32-32 0L32 480 0 480l0-32L0 64zM96 192l0-32 16 0 48 0 0-24 0-16 32 0 0 16 0 24 0 32 0 24 0 16-32 0 0-16 0-24-48 0-16 0zm128 0l0-32 16 0 96 0 16 0 0 32-16 0-96 0-16 0zM96 352l0-32 16 0 112 0 0-24 0-16 32 0 0 16 0 24 0 32 0 24 0 16-32 0 0-16 0-24-112 0-16 0zm192 0l0-32 16 0 32 0 16 0 0 32-16 0-32 0-16 0z'
      
    ]
  };

  
    var faSlidersHSquare = faSquareSliders;
  

  
  

  var faPenToSquare = {
    prefix: 'fasl',
    iconName: 'pen-to-square',
    icon: [
      512,
      512,
      ["edit"],
      'f044',
      
      'M128 384l6.3-33.7L152 256 385.4 22.6 408 0l22.6 22.6 58.7 58.7L512 104l-22.6 22.6L256 360l-94.3 17.7L128 384zm112.4-53.6L410.1 160.7l-58.7-58.7L181.6 271.6l-13.6 72.3 72.3-13.6zM432.7 138.1L466.7 104 408 45.3 373.9 79.3l58.7 58.7zM0 64H16 208h16V96H208 32V480H416V304 288h32v16V496v16H432 16 0V496 80 64z'
      
    ]
  };

  
    var faEdit = faPenToSquare;
  

  
  

  var faSackDollar = {
    prefix: 'fasl',
    iconName: 'sack-dollar',
    icon: [
      512,
      512,
      [128176],
      'f81d',
      
      'M351.2 94l42.8-62L416 0H377.1 134.9 96l22.1 32 42.8 62L179 120.4c-7.7 4.9-16.7 11-26.4 18.1C91.2 183.7 0 273.4 0 416v64 32H32 480h32V480 416c0-142.6-91.2-232.3-152.6-277.5c-9.7-7.1-18.6-13.2-26.4-18.1L351.2 94zM480 480H32V416c0-147.7 109.4-233.5 164.3-268.6l5.3-3.4h109l5.3 3.4C370.6 182.5 480 268.3 480 416v64zM306.6 102.2l-6.7 9.8H212.1l-6.7-9.8L156.9 32H355.1l-48.4 70.2zM272 224V208H240v16 9.3c-6.5 1.1-12.7 2.9-18.3 5.4c-14.1 6.4-25.9 18.1-28.8 34.7c-1.6 9.5-.7 18.5 3.1 26.6c3.8 7.9 9.7 13.7 15.9 17.9c11.1 7.5 25.8 11.9 37.7 15.5l2 .6c13.8 4.2 23.9 7.5 30.5 12.3c2.9 2.1 4.3 4 5.1 5.7c.7 1.6 1.3 4.3 .5 9c-.9 5-3.8 9-10.3 11.8c-7 3-17.7 4.3-31 2.2c-6.4-1-17.6-4.8-27.1-8.1l0 0 0 0c-2.2-.7-4.2-1.4-6.1-2.1l-15.2-5.1-10.1 30.4 15.2 5.1c1.3 .4 2.8 1 4.6 1.6l0 0 0 0 0 0c8.9 3 23 7.9 32.4 9.6V416v16h32V416v-8.9c6.3-.9 12.3-2.5 17.9-4.9c14.7-6.3 26.3-18.3 29.3-35.7c1.7-9.7 .9-18.9-2.7-27.2c-3.6-8.2-9.3-14.3-15.6-18.8c-11.6-8.4-27.2-13.1-39.5-16.8l-.6-.2c-13.9-4.2-24.3-7.4-31-12c-3-2-4.3-3.8-5-5.1c-.6-1.2-1.2-3.3-.5-7.4c.6-3.6 3.3-7.8 10.5-11c7.3-3.3 18-4.9 30.9-2.9c4.4 .7 18.1 3.4 22.1 4.4l15.5 4.1 8.2-30.9-15.5-4.1c-5.1-1.4-18.2-3.9-24.1-4.9V224z'
      
    ]
  };

  

  
  

  var faCrosshairsSimple = {
    prefix: 'fasl',
    iconName: 'crosshairs-simple',
    icon: [
      512,
      512,
      [],
      'e59f',
      
      'M479.4 240H384 368v32h16 95.4C471.6 383 383 471.6 272 479.4V384 368H240v16 95.4C129 471.6 40.4 383 32.6 272H128h16V240H128 32.6C40.4 129 129 40.4 240 32.6V128v16h32V128 32.6C383 40.4 471.6 129 479.4 240zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  

  
  

  var faBridgeLock = {
    prefix: 'fasl',
    iconName: 'bridge-lock',
    icon: [
      640,
      512,
      [],
      'e4cc',
      
      'M32 32H48h64 32 96 32 96 32 96 32 64 16V64H592 528v64h64 16v32H592 528 496 400 368 272 240 144 112 48 32V128H48h64V64H48 32V32zM384 264.4V288v48c0-35.3-28.7-64-64-64s-64 28.7-64 64V464v16H240 144 128V464 336c0-35.3-28.7-64-64-64H48 32V240H48 64c53 0 96 43 96 96V448h64V336c0-53 43-96 96-96c24.6 0 47 9.2 64 24.4zM400 64v64h96V64H400zm-32 64V64H272v64h96zM144 64v64h96V64H144zM528 224c-26.5 0-48 21.5-48 48v48h96V272c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48h32v32V480v32H608 448 416V480 352 320h32V272zm0 80V480H608V352H448z'
      
    ]
  };

  

  
  

  var faFolderArrowUp = {
    prefix: 'fasl',
    iconName: 'folder-arrow-up',
    icon: [
      512,
      512,
      ["folder-upload"],
      'e054',
      
      'M32 32H224l48 64H480h32v32V448v32H480 32 0V448 64 32H32zm240 96H256l-9.6-12.8L208 64H32V448H480V128H272zm0 240v16H240V368 246.6l-52.7 52.7L176 310.6 153.4 288l11.3-11.3 80-80L256 185.4l11.3 11.3 80 80L358.6 288 336 310.6l-11.3-11.3L272 246.6V368z'
      
    ]
  };

  
    var faFolderUpload = faFolderArrowUp;
  

  
  

  var faSquareSmall = {
    prefix: 'fasl',
    iconName: 'square-small',
    icon: [
      320,
      512,
      [],
      'e27e',
      
      'M288 128V384H32V128H288zM32 96H0v32V384v32H32 288h32V384 128 96H288 32z'
      
    ]
  };

  

  
  

  var faBackpack = {
    prefix: 'fasl',
    iconName: 'backpack',
    icon: [
      448,
      512,
      [127890],
      'f5d4',
      
      'M144 0h16H288h16V16 64h16c70.7 0 128 57.3 128 128V480v32H416 32 0V480 192C0 121.3 57.3 64 128 64h16V16 0zM272 32H176V64h96V32zM32 192V480H80V368 272 256H96 352h16v16 96V480h48V192c0-53-43-96-96-96H288 160 128c-53 0-96 43-96 96zm80 288H336V384H112v96zm32-320H304h16v32H304 144 128V160h16zM336 352V288H112v64H336z'
      
    ]
  };

  

  
  

  var faArrowsCross = {
    prefix: 'fasl',
    iconName: 'arrows-cross',
    icon: [
      448,
      512,
      [],
      'e0a2',
      
      'M288 32H272V64h16H393.4L12.7 444.7 1.4 456 24 478.6l11.3-11.3L416 86.6V192v16h32V192 48 32H432 288zM35.3 44.7L24 33.4 1.4 56 12.7 67.3 173.1 227.7l22.6-22.6L35.3 44.7zm217 262.2L393.4 448H288 272v32h16H432h16V464 320 304H416v16V425.4L274.9 284.3l-22.6 22.6z'
      
    ]
  };

  

  
  

  var faTree = {
    prefix: 'fasl',
    iconName: 'tree',
    icon: [
      448,
      512,
      [127794],
      'f1bb',
      
      'M235.1 10.8L224 .3 212.9 10.8 68.9 148.4 64 153.2V160v16 16H80h29.2L35.9 277.6 32 282.1V288v16 16H48 77.2L3.9 405.6 0 410.1V416v16 16H16 144h16 48v48 16h32V496 448h48 16H432h16V432 416v-5.9l-3.9-4.5L370.8 320H400h16V304 288v-5.9l-3.9-4.5L338.8 192H368h16V176 160v-6.8l-4.9-4.7L235.1 10.8zM240 416V208 192H208v16V416H160 144 37.1l87.1-101.6L146.8 288H112 69.1l87.1-101.6L178.8 160H144 103.2L224 44.5 344.8 160H304 269.2l22.6 26.4L378.9 288H336 301.2l22.6 26.4L410.9 416H304 288 240z'
      
    ]
  };

  

  
  

  var faCommentsQuestionCheck = {
    prefix: 'fasl',
    iconName: 'comments-question-check',
    icon: [
      640,
      512,
      [],
      'e14f',
      
      'M78.2 274.7L70.9 293 52.4 339.1l99.9-23 6.7-1.6 6.8 1.4c13.5 2.7 27.6 4.2 42.2 4.2c102.4 0 176-69.3 176-144s-73.6-144-176-144S32 101.3 32 176c0 30.8 11.9 59.8 33.2 84l13 14.8zM38 375.2L0 384l14.5-36.2 26.7-66.7C15.3 251.8 0 215.4 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176s-93.1 176-208 176c-16.7 0-32.9-1.7-48.5-4.8L38 375.2zm207.2 6.2c11.5-1.6 22.8-3.9 33.8-6.8C308.4 417.3 363.8 448 432 448c14.6 0 28.7-1.5 42.2-4.2l6.8-1.4 6.7 1.6 99.9 23L569.1 421l-7.3-18.3 13-14.8c21.3-24.1 33.2-53.2 33.2-84c0-70.9-66.3-137-160.6-143.5c-.9-11.1-2.8-21.9-5.6-32.3C552.1 132.5 640 209.6 640 304c0 39.4-15.3 75.8-41.2 105.1l26.7 66.7L640 512l-38-8.8-121.5-28c-15.6 3.1-31.8 4.8-48.5 4.8c-82 0-153-40.2-186.8-98.5zM185.3 80.7H225c27.7 0 50 22.7 50 50.2c0 18.7-10.5 36.1-27.3 44.7L224 187.6v15.7H192v-16-9.5V168l8.7-4.5L233.2 147c6-3 9.8-9.3 9.8-16.1c0-10.1-8.2-18.2-18-18.2H185.3c-6.8 0-12.3 5.5-12.3 12.3v5.7H141V125c0-24.5 19.8-44.3 44.3-44.3zM225 221.3v34H191v-34h34zm325.6 56l-11.3 11.3L454 374l-11.3 11.3L431.4 374l-42.7-42.7L377.4 320 400 297.4l11.3 11.3L442.7 340l74-74L528 254.7l22.6 22.6z'
      
    ]
  };

  

  
  

  var faHouseFloodWater = {
    prefix: 'fasl',
    iconName: 'house-flood-water',
    icon: [
      576,
      512,
      [],
      'e50e',
      
      'M297.1 10.8L288 4.5l-9.1 6.3-208 144L57.7 164l18.2 26.3 13.2-9.1L112 165.3v86.2l2.6 1.9 1.1 .8 0 0c11 7.9 19.3 13.9 28.3 18.8V143.1L288 43.5l144 99.7V273c8.9-4.9 17.3-10.9 28.3-18.8l3.7-2.7V165.3l22.9 15.8 13.2 9.1L518.3 164l-13.2-9.1-208-144zM133.8 346.8c-14.6-10-26-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C41.7 358.1 20.9 368 0 368v32c30.3 0 57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 385.9 161.7 400 192 400s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 385.9 353.7 400 384 400s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C518.5 385.9 545.7 400 576 400V368c-20.9 0-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C425.6 358.1 404.9 368 384 368s-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C233.6 358.1 212.9 368 192 368s-41.7-9.9-58.2-21.2zM192 480c-20.9 0-41.7-9.9-58.2-21.2c-14.6-10-26-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C41.7 470.1 20.9 480 0 480v32c30.3 0 57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 497.9 161.7 512 192 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 497.9 353.7 512 384 512s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C518.5 497.9 545.7 512 576 512V480c-20.9 0-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C425.6 470.1 404.9 480 384 480s-41.7-9.9-58.2-21.2c-14.7-10-25.9-21.5-37.8-34.2c-11.9 12.8-23.1 24.2-37.8 34.2C233.6 470.1 212.9 480 192 480z'
      
    ]
  };

  

  
  

  var faMapLocation = {
    prefix: 'fasl',
    iconName: 'map-location',
    icon: [
      576,
      512,
      ["map-marked"],
      'f59f',
      
      'M376 120c0 9.7-4.6 25.4-15.2 46.2c-10.2 20-24.1 41.3-38.6 61.2c-12 16.5-24.1 31.7-34.1 43.7c-10-12-22.1-27.2-34.1-43.7c-14.5-19.9-28.4-41.2-38.6-61.2C204.6 145.4 200 129.7 200 120c0-48.6 39.4-88 88-88s88 39.4 88 88zm32 0C408 53.7 354.3 0 288 0S168 53.7 168 120c0 51.3 64.4 134.7 98.8 175.7C279.4 310.7 288 320 288 320s8.6-9.3 21.2-24.3C343.6 254.7 408 171.3 408 120zm-7.4 105.5l.5 .2 9.8-3.5L544 173.7V425.6L416 472.1V288H384V474.1L192 419.3V288H160V419.8L32 466.3V214.4l115.7-42.1c-4-10-7.3-20.3-9.4-30.6L0 192V477.9 512l32-11.6L176 448l224 64 176-64V162 128l-32 11.6L423.5 183.4c-1.9 4-3.8 8-5.8 11.9c-5.1 10.1-11 20.2-17.1 30.1z'
      
    ]
  };

  
    var faMapMarked = faMapLocation;
  

  
  

  var faBlanket = {
    prefix: 'fasl',
    iconName: 'blanket',
    icon: [
      448,
      512,
      [],
      'f498',
      
      'M16 32H0V48 288v16 16V464v16H16 432h16V448H432 32V320H416v48H96 80v32H96 432h16V384 320 304 288 48 32H432 16zM416 288H32V64H416V288z'
      
    ]
  };

  

  
  

  var faGlobePointer = {
    prefix: 'fasl',
    iconName: 'globe-pointer',
    icon: [
      512,
      512,
      [],
      'e60e',
      
      'M230.4 445.6l-9.1 26.2-12.5 35.9c15.3 2.8 31 4.3 47.2 4.3c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 15.9 1.5 31.5 4.2 46.6l30.6-10.6C33 280.3 32 268.3 32 256c0-22.2 3.2-43.7 9.3-64h92.8c-3.9 19.8-6.1 41.1-6.1 64c0 1.3 0 2.6 0 3.9l32.1-11.1c.5-20.4 2.9-39.3 6.7-56.8H345.2c4.3 19.5 6.8 40.9 6.8 64s-2.5 44.5-6.8 64H274.1L263 352h73.2c-11 31.6-26.3 57.4-41.7 77.7c-14 18.5-27.9 32.4-38.5 41.6c-7.3-6.4-16.2-15-25.6-25.8zm64-363.3c15.4 20.3 30.7 46.1 41.7 77.7H175.8c11-31.6 26.3-57.4 41.7-77.7c14-18.5 27.9-32.4 38.5-41.6c10.5 9.3 24.5 23.1 38.5 41.6zM384 256c0-22.9-2.2-44.2-6.1-64h92.8c6 20.3 9.3 41.8 9.3 64s-3.2 43.7-9.3 64H377.9c3.9-19.8 6.1-41.1 6.1-64zm-14.2-96c-17.5-56.6-47.9-97.9-72.9-124.3C368.5 48.9 428.1 96.2 458.4 160H369.8zM53.6 160c30.3-63.8 90-111.1 161.5-124.3c-25 26.4-55.5 67.6-72.9 124.3H53.6zM369.8 352h88.6c-30.3 63.8-90 111.1-161.5 124.3c25-26.4 55.5-67.6 72.9-124.3zM255.1 277.3l10.8-31.1-31.2 10.8-183 63.2L15.6 332.6l34.3 17 60.2 29.7L4.7 484.7l22.6 22.6L132.5 402.1l29 60.8L178.3 498l12.8-36.7 64-184zM144.3 360.4L98.5 337.8l115.6-39.9L173.7 414l-22-46.1-2.4-5-5-2.5z'
      
    ]
  };

  

  
  

  var faHotTubPerson = {
    prefix: 'fasl',
    iconName: 'hot-tub-person',
    icon: [
      512,
      512,
      ["hot-tub"],
      'f593',
      
      'M256 0V16c0 24.6 12.3 47.6 32.8 61.3l16.1 10.7C334.3 107.7 352 140.7 352 176v16H320V176c0-24.6-12.3-47.6-32.8-61.3l-16.1-10.7C241.7 84.3 224 51.3 224 16V0h32zM128 160l128 96h16H480h32v32V480v32H480 32 0V480 336 272 256 192 160H32h96zM32 288v48V480H480V288H272 256 245.3 32zm0-32H202.7l-85.3-64H32v64zM384 16c0 24.6 12.3 47.6 32.8 61.3l16.1 10.7C462.3 107.7 480 140.7 480 176v16H448V176c0-24.6-12.3-47.6-32.8-61.3l-16.1-10.7C369.7 84.3 352 51.3 352 16V0h32V16zM128 336v16 80 16H96V432 352 336h32zm96 0v16 80 16H192V432 352 336h32zm96 0v16 80 16H288V432 352 336h32zm96 0v16 80 16H384V432 352 336h32zM96 64A32 32 0 1 0 32 64a32 32 0 1 0 64 0zM0 64a64 64 0 1 1 128 0A64 64 0 1 1 0 64z'
      
    ]
  };

  
    var faHotTub = faHotTubPerson;
  

  
  

  var faHouseNight = {
    prefix: 'fasl',
    iconName: 'house-night',
    icon: [
      640,
      512,
      [],
      'e010',
      
      'M113.6 0c-.5 0-1.1 0-1.6 0C50.1 0 0 50.1 0 112s50.1 112 112 112c30.5 0 58.2-12.2 78.4-32c.5-.5 1.1-1.1 1.6-1.6c9.5-9.7 17.2-21.1 22.7-33.7c-7.2 2.1-14.8 3.3-22.7 3.3c-5.1 0-10.1-.5-15-1.4c-37-7-65-39.5-65-78.6c0-17.4 5.5-33.5 15-46.6c7.4-10.3 17.2-18.8 28.6-24.6C142.6 3.3 128.5 .2 113.6 0zM32 112c0-36.3 24.2-66.9 57.3-76.7C83.3 49 80 64.1 80 80c0 46.4 28.2 86.2 68.5 103.2c-10.9 5.6-23.3 8.8-36.5 8.8c-44.2 0-80-35.8-80-80zm378.1-4.4L400 99.4l-10.1 8.2-216 176-12.4 10.1 20.2 24.8 12.4-10.1L224 284V496v16h16H560h16V496 284l29.9 24.4 12.4 10.1 20.2-24.8-12.4-10.1-216-176zM544 258V480H256V258L400 140.6 544 258zM336 272v16 96 16h16 96 16V384 288 272H448 352 336zm32 32h64v64H368V304zM272 0H240V16 48H208 192V80h16 32v32 16h32V112 80h32 16V48H304 272V16 0zM112 320H80v16 32H48 32v32H48 80v32 16h32V432 400h32 16V368H144 112V336 320z'
      
    ]
  };

  

  
  

  var faRectanglePro = {
    prefix: 'fasl',
    iconName: 'rectangle-pro',
    icon: [
      640,
      512,
      ["pro"],
      'e235',
      
      'M32 64V448H608V64H32zM0 32H32 608h32V64 448v32H608 32 0V448 64 32zM96 160h48c35.3 0 64 28.7 64 64s-28.7 64-64 64H112v48 16H80V336 272 176 160H96zm48 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H112v64h32zm256-16c0-44.2 35.8-80 80-80s80 35.8 80 80v32c0 44.2-35.8 80-80 80s-80-35.8-80-80V240zm80-48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48V240c0-26.5-21.5-48-48-48zM240 160h16 48c35.3 0 64 28.7 64 64c0 24-13.3 45-32.9 55.9l42 72.1h-37l-37.3-64H272v48 16H240V336 272 176 160zm32 96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H272v64z'
      
    ]
  };

  
    var faPro = faRectanglePro;
  

  
  

  var faMonkey = {
    prefix: 'fasl',
    iconName: 'monkey',
    icon: [
      576,
      512,
      [128018],
      'f6fb',
      
      'M160 416c0-76.1 38-143.4 96-183.8V272v.9C216.7 308 192 359.1 192 416v64H416V432c0-44.2-35.8-80-80-80H304 288V320h16 32c31.3 0 59.7 12.9 80 33.6V320 304h53L571.7 413l4.3 4.6V424v72 16H544V496 430.3l-96-102V432v48h32 16v32H480 448 416 192 160 144C64.5 512 0 447.5 0 368V16 0H16 176h16V16 176v16H176 80 64V160H80h80V32H32V368c0 61.9 50.1 112 112 112h16V416zM464 64c-14.6-19.4-37.8-32-64-32s-49.4 12.6-64 32H464zm16 48c0 23.8-17.3 43.5-40 47.3V208H360V159.3c-22.7-3.8-40-23.6-40-47.3v32 32 64H480V176 144 112zm32 128v32H480 320 288V240 176c-35.3 0-64-28.7-64-64s28.7-64 64-64h20.1C328.3 19 361.9 0 400 0s71.7 19 91.9 48H512c35.3 0 64 28.7 64 64s-28.7 64-64 64v64zm0-128v32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-4.6c3 10.1 4.6 20.9 4.6 32zM288 144V112c0-11.1 1.6-21.9 4.6-32H288c-17.7 0-32 14.3-32 32s14.3 32 32 32zm80-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faSignalBarsSlash = {
    prefix: 'fasl',
    iconName: 'signal-bars-slash',
    icon: [
      640,
      512,
      ["signal-alt-slash"],
      'f694',
      
      'M512 326l32 25.3V32h32V376.6l32 25.3V32 0H576 544 512V32 326zm-64-50.5V160 128H416 384 352v32 39.7L384 225V160h32v90.2l32 25.3zm-96 87.3V480v32h32 32 32V480 438.6l-32-25.3V480H384V388.1l-32-25.3zM216.7 256H192v32V480v32h32 32 32V480 312.3L216.7 256zm7.3 32h32V480H224V288zM96 416v64H64V416H96zM64 384H32v32 64 32H64 96h32V480 416 384H96 64zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  
    var faSignalAltSlash = faSignalBarsSlash;
  

  
  

  var faGasPump = {
    prefix: 'fasl',
    iconName: 'gas-pump',
    icon: [
      512,
      512,
      [9981],
      'f52f',
      
      'M288 32V192H64V32H288zm0 192V480H64V224H288zM32 32V480L0 480v32H32 64 288h32 32V480l-32 0V288h16c26.5 0 48 21.5 48 48v48c0 35.3 28.7 64 64 64s64-28.7 64-64V136v-7l-5.2-4.8-96-88L399 25.4 377.4 49l11.8 10.8L416 84.4V160c0 35.3 28.7 64 64 64V384c0 17.7-14.3 32-32 32s-32-14.3-32-32V336c0-44.2-35.8-80-80-80H320V32 0H288 64 32V32zM480 192c-17.7 0-32-14.3-32-32V113.7L480 143v49z'
      
    ]
  };

  

  
  

  var faArrowDownFromLine = {
    prefix: 'fasl',
    iconName: 'arrow-down-from-line',
    icon: [
      384,
      512,
      [8615,"arrow-from-top"],
      'f345',
      
      'M203.3 467.3L192 478.6l-11.3-11.3-128-128L41.4 328 64 305.4l11.3 11.3L176 417.4 176 144l0-16 32 0 0 16 0 273.4L308.7 316.7 320 305.4 342.6 328l-11.3 11.3-128 128zM16 64L0 64 0 32l16 0 352 0 16 0 0 32-16 0L16 64z'
      
    ]
  };

  
    var faArrowFromTop = faArrowDownFromLine;
  

  
  

  var faLock = {
    prefix: 'fasl',
    iconName: 'lock',
    icon: [
      448,
      512,
      [128274],
      'f023',
      
      'M128 128v64H320V128c0-53-43-96-96-96s-96 43-96 96zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h64 32v32V480v32H416 32 0V480 224 192H32 96zM32 480H416V224H32V480z'
      
    ]
  };

  

  
  

  var faPaintbrush = {
    prefix: 'fasl',
    iconName: 'paintbrush',
    icon: [
      576,
      512,
      [128396,"paint-brush"],
      'f1fc',
      
      'M248.4 214.2l259.5-173 26.9 26.9-173 259.5-76 40.9-78.3-78.3 0 0 0 0 40.9-76zM254 382s0 0 0 0l0 0c1.3 5.8 2 11.8 2 18c0 44.2-35.8 80-80 80h0H96V400c0-44.2 35.8-80 80-80c6.2 0 12.2 .7 18 2c0 0 0 0 0 0L254 382zM512 0L224 192l-51.7 96.1C112.1 290 64 339.4 64 400v48 32H32h0H16 0v32H16 32 64 96h80 0c60.6 0 110-48.1 111.9-108.3L384 352 576 64 512 0z'
      
    ]
  };

  
    var faPaintBrush = faPaintbrush;
  

  
  

  var faSnowBlowing = {
    prefix: 'fasl',
    iconName: 'snow-blowing',
    icon: [
      640,
      512,
      [],
      'f761',
      
      'M192 64V80v41.4l20.7-20.7L224 89.4 246.6 112l-11.3 11.3L192 166.6v61.7l53.4-30.8 15.9-59.2 4.1-15.5 30.9 8.3-4.1 15.5-7.6 28.3 35.8-20.7 13.9-8 16 27.7-13.9 8-35.8 20.7 28.3 7.6 15.5 4.1L336 245.2 320.6 241l-59.2-15.9L208 256l53.4 30.8L320.6 271l15.5-4.1 8.3 30.9-15.5 4.1-28.3 7.6 35.8 20.7 13.9 8-16 27.7-13.9-8-35.8-20.7 7.6 28.3 4.1 15.5-30.9 8.3-4.1-15.5-15.9-59.2L192 283.7v61.7l43.3 43.3L246.6 400 224 422.6l-11.3-11.3L192 390.6V432v16H160V432 390.6l-20.7 20.7L128 422.6 105.4 400l11.3-11.3L160 345.4V283.7l-53.4 30.8L90.7 373.7l-4.1 15.5-30.9-8.3 4.1-15.5 7.6-28.3L31.6 357.9l-13.9 8-16-27.7 13.9-8 35.8-20.7-28.3-7.6L7.7 297.7 16 266.8 31.4 271l59.2 15.9L144 256 90.6 225.2 31.4 241 16 245.2 7.7 214.3l15.5-4.1 28.3-7.6L15.6 181.9l-13.9-8 16-27.7 13.9 8 35.8 20.7-7.6-28.3-4.1-15.5 30.9-8.3 4.1 15.5 15.9 59.2L160 228.3V166.6l-43.3-43.3L105.4 112 128 89.4l11.3 11.3L160 121.4V80 64h32zM480 448V416h16 64c26.5 0 48-21.5 48-48s-21.5-48-48-48H400 384V288h16H560c44.2 0 80 35.8 80 80s-35.8 80-80 80H496 480zM496 64h64c44.2 0 80 35.8 80 80s-35.8 80-80 80H400 384V192h16H560c26.5 0 48-21.5 48-48s-21.5-48-48-48H496 480V64h16z'
      
    ]
  };

  

  
  

  var faFutbol = {
    prefix: 'fasl',
    iconName: 'futbol',
    icon: [
      512,
      512,
      [9917,"futbol-ball","soccer-ball"],
      'f1e3',
      
      'M299.7 475.7L327.7 382l-21.2-29.2H303 209h-3.5L184.3 382l28.1 93.8c14.1 2.8 28.7 4.3 43.7 4.3s29.5-1.5 43.7-4.3zm36.6-10.5c37-14.2 69.3-38 93.9-68.3l-72.9-1.7-20.9 70zm115.3-99.8c14.1-25.1 23.5-53.2 27-83.1L398 226.7l-34.4 11.2-1.1 3.3-29.1 89.4-1.1 3.3 21.3 29.2 97.9 2.3zm28.2-121.1c-2.1-40.6-15-78.3-35.8-110.4l-24.2 68.9 60 41.5zM420.5 103.9c-19.8-21.4-43.8-39-70.6-51.4L272 111.9v36.2l2.8 2 76.1 55.3 2.8 2 34.4-11.2 32.4-92.3zM314.1 39.6c-18.5-5-38-7.6-58.1-7.6s-39.5 2.6-58.1 7.6L256 83.9l58.1-44.3zM162.2 52.5c-26.8 12.4-50.8 30-70.6 51.4l32.4 92.3 34.4 11.2 2.8-2 76.1-55.3 2.8-2 0-36.2L162.2 52.5zm-94 81.4C47.3 166 34.4 203.7 32.3 244.3l60-41.5L68.1 133.9zM33.5 282.4c3.5 29.9 12.9 58 27 83.1l97.9-2.3 21.2-29.2-1.1-3.3-29.1-89.4-1.1-3.3L114 226.7 33.5 282.4zM81.9 396.9c24.6 30.3 56.8 54 93.9 68.3l-20.9-70-72.9 1.7zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm209 64.7l94 0 0 0 29.1-89.4L256 176l-76.1 55.3L209 320.7l0 0z'
      
    ]
  };

  
    var faFutbolBall = faFutbol;
  
    var faSoccerBall = faFutbol;
  

  
  

  var faJug = {
    prefix: 'fasl',
    iconName: 'jug',
    icon: [
      448,
      512,
      [],
      'f8c6',
      
      'M169.3 115.6L176 107V96 32h96V96v11l6.7 8.7L384 251v37H64V251L169.3 115.6zM128 32h16V96L32 240v64 96 80 32H64 384h32V480 400 304 240l-14.4-18.5c26.8-7.7 46.4-32.3 46.4-61.5c0-35.3-28.7-64-64-64c-23.6 0-44.2 12.8-55.3 31.8L304 96V32h16V0H304 272 176 144 128V32zM378.3 191.5l-26.2-33.7c1.1-16.7 15-29.8 31.9-29.8c17.7 0 32 14.3 32 32s-14.3 32-32 32c-2 0-3.9-.2-5.7-.5zM64 384V320H384v64H64zm0 32H384v64H64V416z'
      
    ]
  };

  

  
  

  var faFolderPlus = {
    prefix: 'fasl',
    iconName: 'folder-plus',
    icon: [
      512,
      512,
      [],
      'f65e',
      
      'M32 32H224l48 64H480h32v32V448v32H480 32 0V448 64 32H32zm240 96H256l-9.6-12.8L208 64H32V448H480V128H272zm0 64v16 64h64 16v32H336 272v64 16H240V368 304H176 160V272h16 64V208 192h32z'
      
    ]
  };

  

  
  

  var faCampground = {
    prefix: 'fasl',
    iconName: 'campground',
    icon: [
      576,
      512,
      [9978],
      'f6bb',
      
      'M64 422.2V480h65.9l1.5-1.9 144-184L288 278l12.6 16.1 144 184 1.5 1.9H512V422.2L288 155.3 64 422.2zM170.6 480H288 405.4L288 330 170.6 480zM35.7 406.1L267.1 130.4 179.7 26.3 204.3 5.7 288 105.5 371.7 5.7l24.5 20.6L308.9 130.4 540.3 406.1l3.7 4.5v5.8V496v16H528 288 48 32V496 416.4v-5.8l3.7-4.5z'
      
    ]
  };

  

  
  

  var faClockNineThirty = {
    prefix: 'fasl',
    iconName: 'clock-nine-thirty',
    icon: [
      512,
      512,
      [],
      'e34d',
      
      'M32 256a224 224 0 1 1 448 0A224 224 0 1 1 32 256zm480 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 400V256 240H256 144 128v32h16 96V400v16h32V400z'
      
    ]
  };

  

  
  

  var faWatchFitness = {
    prefix: 'fasl',
    iconName: 'watch-fitness',
    icon: [
      384,
      512,
      [],
      'f63e',
      
      'M80 0H64V16 64H32 0V96 416v32H32 64l0 48v16H80l224 0h16V496 448h32 32V416 96 64H352 320V16 0H304 80zM96 480l0-32H288v32L96 480zM288 64H96V32H288V64zM32 96H352V416H32V96zm152.3 81.2c-11.5-11-26.8-17.2-42.7-17.2h-2.4C106.5 160 80 186.5 80 219.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L192 352.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2h-2.4c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4zm79.3 61.6L192 307.7l-71.7-68.9c-5.3-5.1-8.3-12.2-8.3-19.6c0-15 12.2-27.2 27.2-27.2h2.4c7.7 0 15 3 20.5 8.3l7.7 7.4L192 229l22.2-21.3 7.7-7.4c5.5-5.3 12.9-8.3 20.5-8.3h2.4c15 0 27.2 12.2 27.2 27.2c0 7.4-3 14.5-8.3 19.6z'
      
    ]
  };

  

  
  

  var faHouseMedicalCircleXmark = {
    prefix: 'fasl',
    iconName: 'house-medical-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e513',
      
      'M298.6 12L288 2.7 277.4 12 5.4 252l21.2 24L64 243V496v16H80 394.8c-12.9-9.1-24.5-19.9-34.6-32H96V214.7L288 45.3 458.7 196c12-2.6 24.5-4 37.3-4c2.3 0 4.5 0 6.7 .1L298.6 12zM336 240V192 176H320 256 240v16 48H192 176v16 64 16h16 48v48 16h16 64 2.9c-1.9-10.4-2.9-21.1-2.9-32c0-22.6 4.3-44.2 12-64H320 304v16 48H272V320 304H256 208V272h48 16V256 208h32v48 16h16 28.5c7.6-11.7 16.6-22.4 26.7-32H336zm48 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7L566.6 320 544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7z'
      
    ]
  };

  

  
  

  var faUpToLine = {
    prefix: 'fasl',
    iconName: 'up-to-line',
    icon: [
      384,
      512,
      ["arrow-alt-to-top"],
      'f34d',
      
      'M16 64L0 64 0 32l16 0 352 0 16 0 0 32-16 0L16 64zM240 336l0-32 32 0 48 0 0-17.7L192 171.1 64 286.3 64 304l48 0 32 0 0 32 0 112 96 0 0-112zm112 0l-32 0-16 0-32 0 0 32 0 80 0 32-32 0-96 0-32 0 0-32 0-80 0-32-32 0-16 0-32 0 0-32 0-32L192 128 352 272l0 32 0 32z'
      
    ]
  };

  
    var faArrowAltToTop = faUpToLine;
  

  
  

  var faEgg = {
    prefix: 'fasl',
    iconName: 'egg',
    icon: [
      384,
      512,
      [129370],
      'f7fb',
      
      'M192 464c-85.2 0-160-84.3-160-176c0-50.8 14.7-113.1 43.5-161.7C104.2 77.9 143.4 48 192 48s87.8 29.9 116.5 78.3C337.3 174.9 352 237.2 352 288c0 91.7-74.8 176-160 176zM0 288C0 394 86 496 192 496s192-102 192-208c0-112-64-272-192-272S0 176 0 288zm112 0c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2l-21.6-23.6c-23.9 21.8-41.1 52.7-52.3 84.2C85.7 226.1 80 259.7 80 288v16h32V288z'
      
    ]
  };

  

  
  

  var faFaceDizzy = {
    prefix: 'fasl',
    iconName: 'face-dizzy',
    icon: [
      512,
      512,
      ["dizzy"],
      'f567',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208 96a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zM137.4 192l-36.7-36.7 22.6-22.6L160 169.4l36.7-36.7 22.6 22.6L182.6 192l36.7 36.7-22.6 22.6L160 214.6l-36.7 36.7-22.6-22.6L137.4 192zm192 0l-36.7-36.7 22.6-22.6L352 169.4l36.7-36.7 22.6 22.6L374.6 192l36.7 36.7-22.6 22.6L352 214.6l-36.7 36.7-22.6-22.6L329.4 192z'
      
    ]
  };

  
    var faDizzy = faFaceDizzy;
  

  
  

  var faClipboardMedical = {
    prefix: 'fasl',
    iconName: 'clipboard-medical',
    icon: [
      384,
      512,
      [],
      'e133',
      
      'M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36l3.1 12H254h34v48H192 96V80h34 12.4l3.1-12zM192 0c-32.8 0-61 19.8-73.3 48H80 64V64 80H32 0v32V480v32H32 352h32V480 112 80H352 320V64 48H304 265.3C253 19.8 224.8 0 192 0zM320 144V112h32V480H32V112H64v32 16H80 192 304h16V144zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM160 208H144v16 48H96 80v16 64 16H96h48v48 16h16 64 16V416 368h48 16V352 288 272H288 240V224 208H224 160zm16 80V240h32v48 16h16 48v32H224 208v16 48H176V352 336H160 112V304h48 16V288z'
      
    ]
  };

  

  
  

  var faCircleDot = {
    prefix: 'fasl',
    iconName: 'circle-dot',
    icon: [
      512,
      512,
      [128280,"dot-circle"],
      'f192',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  
    var faDotCircle = faCircleDot;
  

  
  

  var faBorderCenterV = {
    prefix: 'fasl',
    iconName: 'border-center-v',
    icon: [
      448,
      512,
      [],
      'f89d',
      
      'M208 48l0 416 0 16 32 0 0-16 0-416 0-16-32 0 0 16zM56 472l0-48L8 424l0 48 48 0zm384 0l0-48-48 0 0 48 48 0zM56 376l0-48L8 328l0 48 48 0zm384 0l0-48-48 0 0 48 48 0zM392 184l48 0 0-48-48 0 0 48zM56 184l0-48L8 136l0 48 48 0zm336 96l48 0 0-48-48 0 0 48zM56 280l0-48L8 232l0 48 48 0zM392 88l48 0 0-48-48 0 0 48zM8 88l48 0 0-48L8 40 8 88zM296 280l48 0 0-48-48 0 0 48zM344 88l0-48-48 0 0 48 48 0zM296 472l48 0 0-48-48 0 0 48zM152 88l0-48-48 0 0 48 48 0zM104 472l48 0 0-48-48 0 0 48zm48-192l0-48-48 0 0 48 48 0z'
      
    ]
  };

  

  
  

  var faGamepad = {
    prefix: 'fasl',
    iconName: 'gamepad',
    icon: [
      640,
      512,
      [],
      'f11b',
      
      'M32 96V416H608V96H32zM0 64H32 608h32V96 416v32H608 32 0V416 96 64zM208 192v48h48 16v32H256 208v48 16H176V320 272H128 112V240h16 48V192 176h32v16zM408 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faCartPlus = {
    prefix: 'fasl',
    iconName: 'cart-plus',
    icon: [
      576,
      512,
      [],
      'f217',
      
      'M16 0H0V32H16 67.2l77.2 339.5 2.8 12.5H160 496h16V352H496 172.8l-14.5-64H488h12l3.4-11.5L575.3 32H541.9L476 256H151L95.6 12.5 92.8 0H80 16zM160 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM240 112v32h16 48v48 16h32V192 144h48 16V112H384 336V64 48H304V64v48H256 240z'
      
    ]
  };

  

  
  

  var faSquarePhoneFlip = {
    prefix: 'fasl',
    iconName: 'square-phone-flip',
    icon: [
      448,
      512,
      ["phone-square-alt"],
      'f87b',
      
      'M416 64V448H32V64H416zm32-32H416 32 0V64 448v32H32 416h32V448 64 32zM249.2 122.1l-32 80-3.9 9.8 7.5 7.5L239.4 238c-9.1 13-20.4 24.3-33.4 33.4l-18.7-18.7-7.5-7.5-9.8 3.9-80 32L77.9 286l2.3 12.9 16 88L98.7 400H112h16c132.5 0 240-107.4 240-240l0-16 0-13.4-13.1-2.4-88-16L254 109.9l-4.9 12.1zM336 160c0 114.9-93.1 208-208 208h-2.6l-11.3-62 58.1-23.2 20.3 20.3 8.7 8.7 10.6-6.1c25.7-14.8 47.1-36.2 61.9-61.9l6.1-10.6-8.7-8.7-20.3-20.3L274 146.1l62 11.3 0 2.6z'
      
    ]
  };

  
    var faPhoneSquareAlt = faSquarePhoneFlip;
  

  
  

  var faTreePalm = {
    prefix: 'fasl',
    iconName: 'tree-palm',
    icon: [
      576,
      512,
      [127796],
      'f82b',
      
      'M115.7 128H33.9C43.1 87.8 85.7 32 176 32c65 0 105.2 28.9 126 59.9l7.9 11.8 12.6-6.5C342.8 86.8 368.4 80 400 80c90.3 0 132.9 55.8 142.1 96H464V144 128H432v16 32H255.3h-6.6l-4.7 4.7L107.9 316.8C88 285.1 78.5 225 124.4 166.5c1-1.3 2-2.5 3.1-3.8c3.9-4.8 8.3-9.5 13-14.3c18-18 36.4-30.1 54.1-37.8L181.9 81.3c-21.7 9.4-43.4 23.8-64.1 44.5c-.7 .7-1.4 1.4-2.2 2.2zM432 208h32 96 16V192c0-56.8-55.2-144-176-144c-30.6 0-57.1 5.6-79.6 15C292.2 28.1 244.6 0 176 0C55.2 0 0 87.2 0 144v16H16 89.6c-51 76.6-29.3 157.2 5.6 192.1l11.3 11.3 11.3-11.3L242.8 227.2c1.5 9.7 2.7 20.6 3.3 32.8c2.6 53.5-5.7 130.2-37.3 231.3L202.2 512H224 360h14.1l1.8-14c8.3-66.2 2-140.1-12.2-207.3c-6.1-28.9-13.8-56.9-22.6-82.7H432zm-124.8 0c9.8 27.1 18.4 57.4 25.2 89.3c12.7 59.9 18.6 124.4 13.3 182.7H245.5c27.3-93.8 35-167.5 32.4-221.6c-.9-19.2-3.1-36-6.3-50.4h35.5z'
      
    ]
  };

  

  
  

  var faList = {
    prefix: 'fasl',
    iconName: 'list',
    icon: [
      512,
      512,
      ["list-squares"],
      'f03a',
      
      'M48 80H80v32H48V80zM16 48V80v32 32H48 80h32V112 80 48H80 48 16zM176 80H160v32h16H496h16V80H496 176zm0 160H160v32h16H496h16V240H496 176zm0 160H160v32h16H496h16V400H496 176zM80 240v32H48V240H80zM48 208H16v32 32 32H48 80h32V272 240 208H80 48zm0 192H80v32H48V400zM16 368v32 32 32H48 80h32V432 400 368H80 48 16z'
      
    ]
  };

  
    var faListSquares = faList;
  

  
  

  var faFilmSimple = {
    prefix: 'fasl',
    iconName: 'film-simple',
    icon: [
      512,
      512,
      ["film-alt"],
      'f3a0',
      
      'M128 352v96H384V352 256 160 64H128v96 96 96zM96 368H32v80H96V368zm0-32V272H32v64H96zm0-96V176H32v64H96zm0-96V64H32v80H96zM416 272v64h64V272H416zm0 96v80h64V368H416zm0-128h64V176H416v64zm0-96h64V64H416v80zM480 32h32V64 448v32H480 32 0V448 64 32H32 480z'
      
    ]
  };

  
    var faFilmAlt = faFilmSimple;
  

  
  

  var faAbacus = {
    prefix: 'fasl',
    iconName: 'abacus',
    icon: [
      576,
      512,
      [129518],
      'f640',
      
      'M544 64V192H448V160h16 16V128H464 448V64h96zM416 128H400 384v32h16 16v32H288V160h16 16V128H304 288V64H416v64zm-160 0H240 224v32h16 16v32H160V160h16 16V128H176 160V64h96v64zm-128 0H112 96v32h16 16v32H32V64h96v64zM32 448V224h96v64H112 96v32h16 16v32H112 96v32h16 16v64H32zm128-64h16 16V352H176 160V320h16 16V288H176 160V224h96v64H240 224v32h16 16v32H240 224v32h16 16v64H160V384zm128-64h16 16V288H304 288V224H416V352H400 384v32h16 16v64H288V384h16 16V352H304 288V320zm160 64h16 16V352H464 448V224h96V448H448V384zM32 32H0V64 448v32H32 544h32V448 64 32H544 32z'
      
    ]
  };

  

  
  

  var faHockeySticks = {
    prefix: 'fasl',
    iconName: 'hockey-sticks',
    icon: [
      640,
      512,
      [],
      'f454',
      
      'M320.9 320L481.8 8.7l28.4 14.7-248 480-4.5 8.7H248 16 0V496 336 320H16 320.9zm-16.5 32H128V480H238.3l66.1-128zM32 352V480H96V352H32zM156.4 8.7L300.8 288h-36L128 23.3 156.4 8.7zM376 503.3l-38.9-75.3 18-34.9L400 480H510.2V352H376.4L393 320H622.2h16v16V496v16h-16-232-9.7l-4.5-8.7zM542.2 352V480h64V352h-64z'
      
    ]
  };

  

  
  

  var faFaceAnguished = {
    prefix: 'fasl',
    iconName: 'face-anguished',
    icon: [
      512,
      512,
      [],
      'e369',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm248 48h16c48.6 0 88 39.4 88 88v8 16H336 176 160V400v-8c0-48.6 39.4-88 88-88zm16 32H248c-28.2 0-51.6 20.9-55.4 48H319.4c-3.9-27.1-27.2-48-55.4-48zM152.4 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9L89.4 143.2l11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1h16v32H192zm141 .9c-4.3-.6-8.6-.9-13-.9H304V96h16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8z'
      
    ]
  };

  

  
  

  var faGhost = {
    prefix: 'fasl',
    iconName: 'ghost',
    icon: [
      384,
      512,
      [128123],
      'f6e2',
      
      'M88.1 426.9L71.8 408.3 49.7 419.4 32 428.2V192c0-88.4 71.6-160 160-160s160 71.6 160 160V428.2l-17.7-8.8-22.1-11.1-16.3 18.6-34.8 39.7-47.9-42.6L192 405.2l-21.3 18.9-47.9 42.6L88.1 426.9zM0 480l32-16 32-16 34.9 39.9L120 512l23.9-21.3L192 448l48.1 42.7L264 512l21.1-24.1L320 448l32 16 32 16V444.2 192C384 86 298 0 192 0S0 86 0 192V444.2 480zM152 192a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm128 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faHeading = {
    prefix: 'fasl',
    iconName: 'heading',
    icon: [
      448,
      512,
      ["header"],
      'f1dc',
      
      'M0 32H16 80h64 16V64H144 96V224H352V64H304 288V32h16 64 64 16V64H432 384V240 448h48 16v32H432 304 288V448h16 48V256H96V448h48 16v32H144 16 0V448H16 64V240 64H16 0V32z'
      
    ]
  };

  
    var faHeader = faHeading;
  

  
  

  var faTrainTunnel = {
    prefix: 'fasl',
    iconName: 'train-tunnel',
    icon: [
      512,
      512,
      [],
      'e454',
      
      'M256 32C132.3 32 32 132.3 32 256V496v16H0V496 256C0 114.6 114.6 0 256 0S512 114.6 512 256V496v16H480V496 256C480 132.3 379.7 32 256 32zM161.4 448H144 112V416 160 128h32H368h32v32V416v32H368 350.6l52.7 52.7L414.6 512l-45.3 0-64-64H206.6l-64 64H97.4l0 0 11.3-11.3L161.4 448zm157.3-32H368V288H144V416h49.4H200 312h6.6zM144 256H368V160H144v96zm112 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faSquareParkingSlash = {
    prefix: 'fasl',
    iconName: 'square-parking-slash',
    icon: [
      640,
      512,
      ["parking-slash"],
      'f617',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zm460 462l-40.5-32H128V186L96 160.7V448v32h32H500.4zM139.6 32l40.5 32H512V326l32 25.3V64 32H512 139.6zM240 274.4V288v32 48 16h32V368 352 320 299.6l-32-25.3zm197.7-7c6.6-13 10.3-27.8 10.3-43.4c0-53-43-96-96-96H264c-.9 0-1.8 0-2.7 .1L301.7 160H352c35.3 0 64 28.7 64 64c0 8.1-1.5 15.8-4.2 22.9l25.9 20.4z'
      
    ]
  };

  
    var faParkingSlash = faSquareParkingSlash;
  

  
  

  var faPesetaSign = {
    prefix: 'fasl',
    iconName: 'peseta-sign',
    icon: [
      384,
      512,
      [],
      'e221',
      
      'M48 32H32V48 160H0v32H32V304 464v16H64V464 320H208c74.1 0 135.2-56 143.1-128H384V160H351.1c-8-72-69-128-143.1-128H48zM318.9 160H64V64H208c56.4 0 103.1 41.7 110.9 96zM64 192H318.9c-7.8 54.3-54.4 96-110.9 96H64V192z'
      
    ]
  };

  

  
  

  var faSandwich = {
    prefix: 'fasl',
    iconName: 'sandwich',
    icon: [
      512,
      512,
      [129386],
      'f81f',
      
      'M480 96v64H32V96H480zM32 64H0V96v64 32H32 480h32V160 96 64H480 32zM320 352l-64-32H32 0v32 64 32H32 480h32V416 352 320H480 384l-64 32zm71.6 0H480v64H32V352H248.4l57.2 28.6 14.3 7.2 14.3-7.2L391.6 352zM131.9 224.5l-3.7-.9-3.7 .9-104 24L4.8 252 12 283.2l15.6-3.6 100.3-23.1 124.3 31.1 3.9 1 3.9-1 124.3-31.1 100.3 23.1 15.6 3.6 7.2-31.2-15.6-3.6-104-24-3.7-.9-3.7 .9L256 255.5l-124.1-31z'
      
    ]
  };

  

  
  

  var faBookOpenCover = {
    prefix: 'fasl',
    iconName: 'book-open-cover',
    icon: [
      640,
      512,
      ["book-open-alt"],
      'e0c0',
      
      'M96 373.8l208 41.6V65.3L96 36.7V373.8zm240 41.6l208-41.6V36.7L336 65.3V415.4zM576 0V32.3 400L320 451.2 64 400V32.3 0L96 4.4 320 35.2 544 4.4 576 0zM0 28.8l32 4.4V65.5 160 418.6l288 57.6 288-57.6V160 65.5 33.2l32-4.4V61.1 444.8l-320 64L0 444.8V61.1 28.8z'
      
    ]
  };

  
    var faBookOpenAlt = faBookOpenCover;
  

  
  

  var faShredder = {
    prefix: 'fasl',
    iconName: 'shredder',
    icon: [
      512,
      512,
      [],
      'f68a',
      
      'M96 32V192H416V77.3L370.7 32H96zM448 192h32 32v32V352v32H480 32 0V352 224 192H32 64V32 0H96 384l64 64V192zM32 224V352H480V224H32zm384 32h32v32H416V256zM96 496V416h32v80 16H96V496zm96 0V416h32v80 16H192V496zm96 0V416h32v80 16H288V496zm96 0V416h32v80 16H384V496z'
      
    ]
  };

  

  
  

  var faSquareCheck = {
    prefix: 'fasl',
    iconName: 'square-check',
    icon: [
      448,
      512,
      [9745,9989,61510,"check-square"],
      'f14a',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM331.3 203.3l-128 128L192 342.6l-11.3-11.3-64-64L105.4 256 128 233.4l11.3 11.3L192 297.4 308.7 180.7 320 169.4 342.6 192l-11.3 11.3z'
      
    ]
  };

  
    var faCheckSquare = faSquareCheck;
  

  
  

  var faLuchadorMask = {
    prefix: 'fasl',
    iconName: 'luchador-mask',
    icon: [
      448,
      512,
      ["luchador","mask-luchador"],
      'f455',
      
      'M224 32C118 32 32 118 32 224V480H416V224c0-106-86-192-192-192zM0 224C0 100.3 100.3 0 224 0S448 100.3 448 224V480v32H416 32 0V480 224zM128 384c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zm224 0c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62V288c-44.2 0-80-35.8-80-80V192 160H96h48c44.2 0 80 35.8 80 80c0-44.2 35.8-80 80-80h48 32v32 16c0 44.2-35.8 80-80 80v34c27.6 7.1 48 32.2 48 62zM176 304v16h96V304l-16-16-32-32-32 32-16 16zm82.7-80c-1.8 5-2.7 10.4-2.7 16v16h32 16c20.9 0 38.7-13.4 45.3-32c1.8-5 2.7-10.4 2.7-16V192H320 304c-20.9 0-38.7 13.4-45.3 32zM144 192H128 96v16c0 5.6 1 11 2.7 16c6.6 18.6 24.4 32 45.3 32h16 32V240c0-5.6-1-11-2.7-16c-6.6-18.6-24.4-32-45.3-32z'
      
    ]
  };

  
    var faLuchador = faLuchadorMask;
  
    var faMaskLuchador = faLuchadorMask;
  

  
  

  var faCommentLines = {
    prefix: 'fasl',
    iconName: 'comment-lines',
    icon: [
      512,
      512,
      [],
      'f4b0',
      
      'M86.9 382l7.2-19.3L79.6 348.2C49.1 317.6 32 279.9 32 240c0-91.3 93.8-176 224-176s224 84.7 224 176s-93.8 176-224 176c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8L68.6 430.8 86.9 382zM16 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L30.1 442.4 16 480zM144 176H128v32h16H368h16V176H368 144zm0 96H128v32h16H272h16V272H272 144z'
      
    ]
  };

  

  
  

  var faKeySkeletonLeftRight = {
    prefix: 'fasl',
    iconName: 'key-skeleton-left-right',
    icon: [
      640,
      512,
      [],
      'e3b4',
      
      'M608 128c0-53-43-96-96-96c-52.7 0-95.5 42.5-96 95.1v.9h0v0c0 53 43 96 96 96s96-43 96-96zM388 96C402.2 40.8 452.4 0 512 0c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128-57.3-128-128v0H288v64 16H256V192 128H192l0 64 0 16-32 0 0-16 0-80 0-16 16 0 212 0zM32 384c0 53 43 96 96 96c52.7 0 95.5-42.5 96-95.1V384h0v0c0-53-43-96-96-96s-96 43-96 96zm220 32c-14.2 55.2-64.3 96-124 96C57.3 512 0 454.7 0 384s57.3-128 128-128s128 57.3 128 128v0h96V320 304h32v16 64h64l0-64 0-16 32 0 0 16 0 80 0 16H464 252z'
      
    ]
  };

  

  
  

  var faAsterisk = {
    prefix: 'fasl',
    iconName: 'asterisk',
    icon: [
      384,
      512,
      [10033,61545],
      '2a',
      
      'M208 32V48 226.9l151.4-96.4 17.2 27L221.8 256l154.8 98.5-17.2 27L208 285.1V464v16H176V464 285.1L24.6 381.5l-17.2-27L162.2 256 7.4 157.5l17.2-27L176 226.9V48 32h32z'
      
    ]
  };

  

  
  

  var faHandsHoldingChild = {
    prefix: 'fasl',
    iconName: 'hands-holding-child',
    icon: [
      640,
      512,
      [],
      'e4fa',
      
      'M336 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm18.5 64h59.1 6.6l4.7 4.7 50.5 50.7 11.3 11.3L400 201.3 388.7 190l-27.1-27.2L368 271.1l.9 16L337 288.9l-.9-16L334.1 240H305.9L304 272.9l-.9 16L271.1 287l.9-16 6.4-108.3L251.3 190 240 201.3l-22.7-22.6 11.3-11.3 50.5-50.7 4.7-4.7h6.6zm41.7 96l-3.8-64H311.6l-3.8 64h24.4zM112 64h16V80 265.4l36.7-36.7L176 217.4l11.3 11.3L320 361.4 452.7 228.7 464 217.4l11.3 11.3L512 265.4V80 64h16 96 16V80 384v6.6l-4.7 4.7-104 104L520 510.6 497.4 488l11.3-11.3L608 377.4V96H544V288v6.6l-1.4 1.4-3.3 3.3-8 8-72 72L448 390.6l-4.7 4.7L432 406.6 409.4 384l11.3-11.3 4.7-4.7 11.3-11.3L497.4 296 464 262.6l-128 128V496v16H304V496 390.6l-128-128L142.6 296l60.7 60.7 0 0 16 16L230.6 384 208 406.6l-11.3-11.3-16-16 0 0-72-72-8-8L97.4 296 96 294.6V288 96H32V377.4l99.3 99.3L142.6 488 120 510.6l-11.3-11.3-104-104L0 390.6V384 80 64H16h96z'
      
    ]
  };

  

  
  

  var faAnkh = {
    prefix: 'fasl',
    iconName: 'ankh',
    icon: [
      320,
      512,
      [9765],
      'f644',
      
      'M64 128c0 48.2 25.8 88.6 55 118.7c14.4 14.8 28.8 26.4 39.7 34.2l1.3 .9 1.3-.9c10.9-7.8 25.3-19.3 39.7-34.2c29.2-30.1 55-70.5 55-118.7c0-53-43-96-96-96s-96 43-96 96zm52.1 160C79.1 255.9 32 200.8 32 128C32 57.3 89.3 0 160 0s128 57.3 128 128c0 72.8-47.1 127.9-84.1 160H304h16v32H304 176V496v16H144V496 320H16 0V288H16 116.1z'
      
    ]
  };

  

  
  

  var faWheatAwn = {
    prefix: 'fasl',
    iconName: 'wheat-awn',
    icon: [
      512,
      512,
      ["wheat-alt"],
      'e2cd',
      
      'M78.2 411L4.7 484.5l22.6 22.6 73.5-73.5 0 0 33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6 22.6-22.6L298.4 405c22.8-1.3 45.2-10.6 62.5-28l22.6-22.6 22.6-22.6-17.3-17.3c22.8-1.3 45.2-10.6 62.5-28l22.6-22.6 22.6-22.6L474 218.7l-11.3-11.3c-5.8-5.8-12-10.9-18.6-15.4L491 145.1l11.3-11.3-22.6-22.6-11.3 11.3L414 176.9c-16.1-5.5-33-7.8-49.8-6.7L491 43.3 468.4 20.7 341.6 147.5c1-16.8-1.2-33.7-6.7-49.8l54.3-54.4L400.5 32 377.9 9.4 366.6 20.7 319.8 67.5c-4.5-6.5-9.6-12.8-15.4-18.6L293.1 37.7 270.5 15.1 247.8 37.7 225.2 60.3c-17.4 17.4-26.7 39.8-28 62.6L180 105.6l-22.6 22.6-22.6 22.6c-17.4 17.4-26.7 39.8-28 62.6L89.5 196.1 66.9 218.7 44.3 241.3c-37.5 37.5-37.5 98.3 0 135.8L78.2 411l0 0zM191.6 297.5l-.3 .3-33.9-33.9c-25-25-25-65.5 0-90.5L180 150.8l11.3 11.3c37.4 37.4 37.5 97.9 .4 135.4zM270.5 60.3l11.3 11.3c37.5 37.5 37.5 98.2 0 135.7l-33.9-33.9c-25-25-25-65.5 0-90.5l22.6-22.6zM100.8 252.6c37.5 37.5 37.5 98.2 0 135.7L66.9 354.4c-25-25-25-65.5 0-90.5l22.6-22.6 11.3 11.3zM259.2 411l11.3 11.3-22.6 22.6c-25 25-65.5 25-90.5 0L123.5 411c37.5-37.5 98.2-37.5 135.7 0zm90.5-90.5l11.3 11.3-22.6 22.6c-25 25-65.5 25-90.5 0l-33.9-33.9c37.5-37.5 98.2-37.5 135.7 0zM440.1 230l11.3 11.3-22.6 22.6c-25 25-65.5 25-90.5 0L304.4 230c37.5-37.5 98.2-37.5 135.7 0z'
      
    ]
  };

  
    var faWheatAlt = faWheatAwn;
  

  
  

  var faCompress = {
    prefix: 'fasl',
    iconName: 'compress',
    icon: [
      448,
      512,
      [],
      'f066',
      
      'M160 48V32H128V48 160H16 0v32H16 144h16V176 48zM16 320H0v32H16 128V464v16h32V464 336 320H144 16zM320 48V32H288V48 176v16h16H432h16V160H432 320V48zM304 320H288v16V464v16h32V464 352H432h16V320H432 304z'
      
    ]
  };

  

  
  

  var faCircleN = {
    prefix: 'fasl',
    iconName: 'circle-n',
    icon: [
      512,
      512,
      [],
      'e118',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 128v16V368v16h32V368 193.9L323 377.3l4.8 6.7H352V368 144 128H320v16V318.1L189 134.7l-4.8-6.7H160z'
      
    ]
  };

  

  
  

  var faAlbum = {
    prefix: 'fasl',
    iconName: 'album',
    icon: [
      448,
      512,
      [128189],
      'f89f',
      
      'M416 64V448H32V64H416zM32 32H0V64 448v32H32 416h32V448 64 32H416 32zm192 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 288a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm0-136a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faCloudSunRain = {
    prefix: 'fasl',
    iconName: 'cloud-sun-rain',
    icon: [
      640,
      512,
      [127782],
      'f743',
      
      'M109.3 135.6l-53.9 9 31.6 45.1L99.7 208 86.9 226.4 55.3 271.4l53.9 9 22.5 3.8 3.8 22.5 9 53.9L160 349.9v39.1l-9.6 6.7L121.3 416l-5.8-35L104 312 35 300.5 0 294.7l20.3-29.1L60.7 208 20.3 150.4 0 121.3l35-5.8L104 104l11.5-69 5.8-35 29.1 20.3L208 60.7l57.6-40.3L294.7 0l5.8 35 7.3 44c-10.6 5.7-20.4 12.8-28.9 21.1l-7.5-44.7L226.4 86.9 208 99.7 189.7 86.9 144.6 55.3l-9 53.9-3.8 22.5-22.5 3.8zM208 128c15.7 0 30.4 4.5 42.8 12.4c-3.9 8.9-6.8 18.3-8.7 28c-1.5 .6-3 1.2-4.5 1.8c-8.2-6.4-18.5-10.3-29.7-10.3c-26.5 0-48 21.5-48 48c0 11.2 3.8 21.5 10.3 29.7c-4.7 11-7.9 22.7-9.4 35C141 258.1 128 234.6 128 208c0-44.2 35.8-80 80-80zm86.5 287.9h.2l0 .1H304l-64 96H200l64-96h30.7l-.1-.1zM368 96c30.3 0 57.3 14 74.9 35.9c2.7 3.3 5.1 6.8 7.3 10.4c2.9-2 5.9-3.9 9.1-5.5c11-5.7 23.5-8.9 36.7-8.9c44.2 0 80 35.8 80 80c0 3.7-.3 7.4-.7 11c-.3 2.1-.7 4.2-1.1 6.2c2.1 .4 4.2 .8 6.2 1.4c34.3 9 59.7 40.2 59.7 77.4v80h-32l-48 0H288 224 192v-32-64c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96zM607.9 303.9c0-23.6-17-43.2-39.5-47.2l-32.8-5.8 7.1-32.5c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48c-10.3 0-19.7 3.2-27.4 8.6l-28 19.6-17.7-29.3C411.5 140.3 391.2 128 368 128c-35.3 0-63.9 28.6-64 63.9l0 1.2 .2 27.3-26.9 4.5C247 229.9 224 256.3 224 287.9v64h64H559.9l48 0v-48zM360 416h40l-64 96H296l64-96zm136 0l-64 96H392l64-96h40zm56 0h40l-64 96H488l64-96z'
      
    ]
  };

  

  
  

  var faSwords = {
    prefix: 'fasl',
    iconName: 'swords',
    icon: [
      512,
      512,
      [9876],
      'f71d',
      
      'M304 354.7L39 89.7l-4.2-55 55 4.2 265 265 22.6-22.6L104 8 32.3 2.5 0 0 2.5 32.3 8 104 281.4 377.4 304 354.7zm139.3-78.1L432 265.4l-11.3 11.3-144 144L265.4 432l11.3 11.3 32 32 7 7 9.4-3.1 62.6-20.9 41 41L440 510.6l11.3-11.3 48-48L510.6 440l-11.3-11.3-41-41 20.9-62.6 3.1-9.4-7-7-32-32zm-119 169L310.6 432 432 310.6l13.7 13.7-20.9 62.6-3.1 9.4 7 7L465.4 440 440 465.4l-36.7-36.7-7-7-9.4 3.1-62.6 20.9zM80 265.4L68.7 276.7l-32 32-7 7 3.1 9.4 20.9 62.6-41 41L1.4 440l11.3 11.3 48 48L72 510.6l11.3-11.3 41-41 62.6 20.9 9.4 3.1 7-7 32-32L246.6 432l-11.3-11.3-24-24 22.1-22.1L210.7 352l-22.1 22.1-50.7-50.7L160 301.3l-22.6-22.6-22.1 22.1-24-24L80 265.4zM201.4 432l-13.7 13.7-62.6-20.9-9.4-3.1-7 7L72 465.4 46.6 440l36.7-36.7 7-7-3.1-9.4L66.3 324.3 80 310.6 201.4 432zm77.3-294.6L301.3 160l121-121 55-4.2-4.2 55-121 121 22.6 22.6L504 104l5.5-71.7L512 0 479.7 2.5 408 8 278.6 137.4z'
      
    ]
  };

  

  
  

  var faCommentSlash = {
    prefix: 'fasl',
    iconName: 'comment-slash',
    icon: [
      640,
      512,
      [],
      'f4b3',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM403.5 403.5C378.1 411.5 350 416 320 416c-28.4 0-55.5-4.2-80.3-11.7l-9.2-2.8-9.3 2.8-88.5 26.6L150.9 382l7.2-19.3-14.5-14.6C113.1 317.6 96 279.9 96 240c0-22.9 5.9-45.3 16.7-66.1L87 153.6C72.2 179.9 64 209.2 64 240c0 49.6 21.3 95.1 56.9 130.8L94.1 442.4 80 480l38.5-11.6 111.9-33.6c27.9 8.5 58.1 13.1 89.6 13.1c40.5 0 78.9-7.7 113-21.3l-29.4-23.2zM320 32c-51.1 0-98.6 12.1-138.6 33.1L209.2 87C241.2 72.5 278.8 64 320 64c130.2 0 224 84.7 224 176c0 31-10.8 61.2-30.1 87.5l25.3 20C562.6 316.1 576 279.3 576 240C576 125.1 461.4 32 320 32z'
      
    ]
  };

  

  
  

  var faBoxTaped = {
    prefix: 'fasl',
    iconName: 'box-taped',
    icon: [
      448,
      512,
      ["box-alt"],
      'f49a',
      
      'M42.1 160L84.8 64H178l-18 96H144L42.1 160zM144 192h16v64 32h32 64 32V256 192h16H416V448H32V192H144zm48 0h64v64H192V192zm96-32L270 64h93.2l42.7 96H304 288zm-32.6 0H192.6l18-96h26.9l18 96zM264 32H184 64L0 176V448v32H32 416h32V448 176L384 32H264z'
      
    ]
  };

  
    var faBoxAlt = faBoxTaped;
  

  
  

  var faXmarkToSlot = {
    prefix: 'fasl',
    iconName: 'xmark-to-slot',
    icon: [
      576,
      512,
      ["times-to-slot","vote-nay"],
      'f771',
      
      'M128 64V384H448V64H128zm352 0V384h16 16v32H496 480 448 128 96 80 64V384H80 96V64 32h32H448h32V64zM32 320H64v32H32v96H544V352H512V320h32 32v32 96 32H544 32 0V448 352 320H32zM223.4 136.8l11.3 11.3L288 201.4l53.3-53.3 11.3-11.3 22.6 22.6-11.3 11.3L310.6 224l53.3 53.3 11.3 11.3-22.6 22.6-11.3-11.3L288 246.6l-53.3 53.3-11.3 11.3-22.6-22.6 11.3-11.3L265.4 224l-53.3-53.3-11.3-11.3 22.6-22.6z'
      
    ]
  };

  
    var faTimesToSlot = faXmarkToSlot;
  
    var faVoteNay = faXmarkToSlot;
  

  
  

  var faVolumeLow = {
    prefix: 'fasl',
    iconName: 'volume-low',
    icon: [
      448,
      512,
      [128264,"volume-down"],
      'f027',
      
      'M149.3 328.1l-9.1-8.1H128 32V192h96 12.2l9.1-8.1L284.2 64H288V448h-3.8L149.3 328.1zM0 352H32h96L272 480h16 32V448 64 32H288 272L128 160H32 0v32V320v32zm409.6-19.2C432.9 315.3 448 287.4 448 256s-15.1-59.3-38.4-76.8l-19.2 25.6C405.9 216.5 416 235.1 416 256s-10.1 39.5-25.6 51.2l19.2 25.6z'
      
    ]
  };

  
    var faVolumeDown = faVolumeLow;
  

  
  

  var faFeather = {
    prefix: 'fasl',
    iconName: 'feather',
    icon: [
      512,
      512,
      [129718],
      'f52d',
      
      'M325.6 163.8L96 393.4V237.3L265.4 67.9c23-23 54.1-35.9 86.6-35.9s63.7 12.9 86.6 35.9l5.5 5.5c23 23 35.9 54.1 35.9 86.6c0 22.8-6.3 44.9-18 64H310.6l37.6-37.6 11.3-11.3-22.6-22.6-11.3 11.3zm-47 92.2H434.7l-64 64H214.6l64-64zm60.1 96l-64 64H118.6l64-64H338.7zM64 224V425.4L14.3 475.1 3 486.4 25.6 509l11.3-11.3L86.6 448H288L466.7 269.3c29-29 45.3-68.3 45.3-109.3s-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L64 224z'
      
    ]
  };

  

  
  

  var faSquareCode = {
    prefix: 'fasl',
    iconName: 'square-code',
    icon: [
      448,
      512,
      [],
      'e267',
      
      'M416 64V448H32V64H416zM32 32H0V64 448v32H32 416h32V448 64 32H416 32zM249.4 182.7l10.6 12L314.6 256 260 317.4l-10.6 12 23.9 21.3 10.6-12 64-72 9.4-10.6L348 245.4l-64-72-10.6-12-23.9 21.3zm-61.5 12l10.6-12-23.9-21.3-10.6 12-64 72L90.6 256l9.4 10.6 64 72 10.6 12 23.9-21.3-10.6-12L133.4 256 188 194.6z'
      
    ]
  };

  

  
  

  var faDisplayChartUp = {
    prefix: 'fasl',
    iconName: 'display-chart-up',
    icon: [
      576,
      512,
      [],
      'e5e3',
      
      'M544 32V384H344.3c-.2 0-.4 0-.6 0H232.3c-.2 0-.4 0-.6 0H32V32H544zM32 416H213.1l-10.7 64H144 128v32h16 72H360h72 16V480H432 373.6l-10.7-64H544h32V384 32 0H544 32 0V32 384v32H32zm202.9 64l10.7-64h84.9l10.7 64H234.9zM368 96H352v32h16 57.4L304 249.4l-68.7-68.7L224 169.4l-11.3 11.3-112 112L89.4 304 112 326.6l11.3-11.3L224 214.6l68.7 68.7L304 294.6l11.3-11.3L448 150.6V208v16h32V208 112 96H464 368z'
      
    ]
  };

  

  
  

  var faChartScatter3d = {
    prefix: 'fasl',
    iconName: 'chart-scatter-3d',
    icon: [
      512,
      512,
      [],
      'e0e8',
      
      'M272 280.6V48 32H240V48 280.6L37.7 451.8 25.5 462.1l20.7 24.4 12.2-10.3L256 309 453.7 476.2l12.2 10.3 20.7-24.4-12.2-10.3L272 280.6zM56 40H8V88H56V40zM8 232v48H56V232H8zm144-96H104v48h48V136zm304 0v48h48V136H456zM408 40H360V88h48V40zM360 232v48h48V232H360zM280 472V424H232v48h48z'
      
    ]
  };

  

  
  

  var faHanukiah = {
    prefix: 'fasl',
    iconName: 'hanukiah',
    icon: [
      640,
      512,
      [128334],
      'f6e6',
      
      'M336 16V48 64H304V48 16 0h32V16zM64 80v32 16H32V112 80 64H64V80zm64 0v32 16H96V112 80 64h32V80zm64 0v32 16H160V112 80 64h32V80zm64 0v32 16H224V112 80 64h32V80zm160 0v32 16H384V112 80 64h32V80zm64 0v32 16H448V112 80 64h32V80zm64 0v32 16H512V112 80 64h32V80zm64 0v32 16H576V112 80 64h32V80zM336 96v16V352h48V176 160h32v16V352h32V176 160h32v16V352h32V176 160h32v16V349.3c18.6-6.6 32-24.4 32-45.3V176 160h32v16V304c0 44.2-35.8 80-80 80H336v96H496h16v32H496 320 144 128V480h16H304V384H112c-44.2 0-80-35.8-80-80V176 160H64v16V304c0 20.9 13.4 38.7 32 45.3V176 160h32v16V352h32V176 160h32v16V352h32V176 160h32v16V352h48V112 96h32z'
      
    ]
  };

  

  
  

  var faFaceCowboyHat = {
    prefix: 'fasl',
    iconName: 'face-cowboy-hat',
    icon: [
      512,
      512,
      [],
      'e36e',
      
      'M199.2 9.7L256 38.1 312.8 9.7l13.9-6.9 7.4 13.7 49.4 91.8c27.1-8.9 51.8-20.7 73.3-34.6c.9-.6 1.8-1.2 2.6-1.7c3.8-2.6 7.6-5.2 11.2-7.9L488 81.3c-.5 1.4-.9 2.7-1.4 4.1c-1.1 3.1-2.3 6.2-3.6 9.2C450.5 169.9 361.2 224 256 224S61.5 169.9 29 94.6c-1.3-3-2.5-6.1-3.6-9.2c-.5-1.3-1-2.7-1.4-4.1L41.3 64c3.6 2.7 7.4 5.3 11.2 7.9c.9 .6 1.8 1.2 2.7 1.7c21.5 13.9 46.2 25.6 73.3 34.6l49.4-91.8 7.4-13.7 13.9 6.9zM352 117.1L313.3 45.3 263.2 70.3 256 73.9l-7.2-3.6L198.7 45.3 160 117.1c30 7.1 62.3 10.9 96 10.9s65.9-3.8 96-10.9zm70.1 10.8C373.3 148.5 316.3 160 256 160s-117.3-11.5-166.1-32.1C127 165.8 186.1 192 256 192s129-26.2 166.1-64.1zm-12 90.9c9.5-5 18.7-10.6 27.5-16.5C454.4 232.4 464 267.1 464 304c0 114.9-93.1 208-208 208S48 418.9 48 304c0-36.9 9.6-71.6 26.5-101.7c8.7 5.9 17.9 11.4 27.5 16.5C88 244.1 80 273.1 80 304c0 97.2 78.8 176 176 176s176-78.8 176-176c0-30.9-8-59.9-21.9-85.2zM192 256a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM256 386.1c-25.9 0-51-2.6-75-7.4c19.5 23.6 46.7 37.4 75 37.4s55.4-13.8 75-37.4c-23.9 4.8-49.1 7.4-75 7.4zm0-32c34.2 0 66.8-4.9 96.4-13.6c12.9-3.8 25.1-8.4 36.7-13.6c-2.7 14-7.1 27.2-12.9 39.5c-23 48.6-68.2 81.7-120.3 81.7s-97.3-33.1-120.3-81.7c-5.8-12.3-10.2-25.5-12.9-39.5c11.6 5.2 23.9 9.8 36.7 13.6c29.6 8.8 62.2 13.6 96.4 13.6z'
      
    ]
  };

  

  
  

  var faFlag = {
    prefix: 'fasl',
    iconName: 'flag',
    icon: [
      448,
      512,
      [61725,127988],
      'f024',
      
      'M32 16V0H0V16 64 367v33 96 16H32V496 392l96.3-24.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4L448 368V51.8 16L416 32 393.6 43.2c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L32 56V16zm0 73L140.7 61.8c30.7-7.7 63.1-4.1 91.4 10c55.3 27.7 120.4 27.7 175.8 0l8.1-4.1v278l-34.7 13c-37.9 14.2-80 12-116.2-6.1c-44.7-22.4-96-28-144.5-15.9L32 359V89z'
      
    ]
  };

  

  
  

  var faArrowUpToLine = {
    prefix: 'fasl',
    iconName: 'arrow-up-to-line',
    icon: [
      384,
      512,
      ["arrow-to-top"],
      'f341',
      
      'M16 32L0 32 0 64l16 0 352 0 16 0 0-32-16 0L16 32zM203.3 132.7L192 121.4l-11.3 11.3-128 128L41.4 272 64 294.6l11.3-11.3L176 182.6 176 288l0 176 0 16 32 0 0-16 0-176 0-105.4L308.7 283.3 320 294.6 342.6 272l-11.3-11.3-128-128z'
      
    ]
  };

  
    var faArrowToTop = faArrowUpToLine;
  

  
  

  var faSquirrel = {
    prefix: 'fasl',
    iconName: 'squirrel',
    icon: [
      512,
      512,
      [],
      'f71a',
      
      'M32 144C32 82.1 82.1 32 144 32s112 50.1 112 112v32 16h32V176 144C288 64.5 223.5 0 144 0S0 64.5 0 144s64.5 144 144 144h6.5l7.5 13.6c-18.7 22.3-30 51-30 82.4V496v16h16H256 368 480h16V480H480 439.6c15.2-17 24.4-39.4 24.4-64c0-28.4-12.4-54-32-71.6V256h24 7.5l4.8-5.8 40-48 3.7-4.4V192 145.4v-9.1l-7.8-4.7-56-33.4L444.4 96H440 416V64H384v48 16h16 35.6L480 154.5v31.7L448.5 224H416 400v16 85.5c-10-3.5-20.8-5.5-32-5.5c-10 0-19.7 1.5-28.8 4.4l9.6 30.5c6-1.9 12.5-2.9 19.2-2.9c35.3 0 64 28.7 64 64s-28.7 64-64 64H256 160V384c0-26.9 11-51.1 28.8-68.6l8.7-8.5-5.9-10.6-17.6-32-4.6-8.3H160 144C82.1 256 32 205.9 32 144zM352 64H320V80v76.2c0 34.6-6.1 56.6-17.1 76.2c-10.1 18.1-24.5 34.6-44.4 57.5c-2.8 3.2-5.7 6.5-8.7 10l-11.2 13c-20.1 23.3-30.6 57.4-30.6 87v16h32V400c0-23.4 8.5-49.6 22.8-66.1l11.2-13c2.9-3.4 5.8-6.7 8.6-9.9l0 0 0 0c19.6-22.5 36.3-41.7 48.2-63c14.1-25.3 21.2-52.8 21.2-91.9V80 64zm80 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faFireBurner = {
    prefix: 'fasl',
    iconName: 'fire-burner',
    icon: [
      640,
      512,
      [],
      'e4f1',
      
      'M329.4 41.4L352 64l22.6-22.6L384 32c76.8 64 96 133.3 96 160c0 85.2-66.6 154.9-150.7 159.7c-3.1 .3-6.2 .4-9.3 .4s-6.3-.1-9.3-.4C226.6 346.9 160 277.2 160 192c0-89.6 85.3-165.3 128-192l41.4 41.4zM320 320c2.4 0 4.8-.1 7.2-.2c33.6-3.3 56.8-29.4 56.8-57.3c0-21.9-15.9-47.5-39-71.3c-8.8-9-17.6-16.9-25-23c-7.4 6.1-16.2 13.9-25 23c-23.1 23.8-39 49.5-39 71.3c0 27.8 23.2 54 56.8 57.3c2.4 .1 4.8 .2 7.2 .2zm96-57.4c0 5.4-.5 10.6-1.5 15.8C435.3 255.6 448 225.3 448 192c0-14.1-11-63.7-63-115.8L374.6 86.6 352 109.3 329.4 86.6l-45-45c-16.2 12.7-34.9 30-51.4 50.7c-24.3 30.5-41 65-41 99.7c0 33.3 12.7 63.6 33.5 86.3c-1-5.1-1.5-10.4-1.5-15.8c0-70.4 96-134.4 96-134.4s96 64 96 134.4zM32 256H48h64 16v32H112 64v96H576V288H528 512V256h16 64 16v16V384h32v32 64 32H608 32 0V480 416 384H32V272 256zm0 224H608V416H576 64 32v64zm160-56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faRoadSpikes = {
    prefix: 'fasl',
    iconName: 'road-spikes',
    icon: [
      640,
      512,
      [],
      'e568',
      
      'M64 156.4L160 310v10H64V156.4zm96 93.2L64 96H32v32V320v32H64h96 32 96 32 96 32H570.3 608l-20-32L448 96H416v32V249.6L320 96H288v32V249.6L192 96H160v32V249.6zM416 310v10H320V300.8 156.4L416 310zm32 10V300.8 156.4L550.3 320H448zM288 310v10H192V300.8 156.4L288 310zM0 416v32H16 624h16V416H624 16 0z'
      
    ]
  };

  

  
  

  var faFaceSleeping = {
    prefix: 'fasl',
    iconName: 'face-sleeping',
    icon: [
      512,
      512,
      [],
      'e38d',
      
      'M32 256C32 132.3 132.3 32 256 32c33.1 0 64.5 7.2 92.7 20l13.3-29.1C329.6 8.2 293.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-37.8-8.2-73.6-22.9-105.9L460 163.3c12.8 28.2 20 59.6 20 92.7c0 123.7-100.3 224-224 224S32 379.7 32 256zM232 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm83.2-149.6c-21.6 28.8-64.8 28.8-86.4 0l-25.6 19.2c34.4 45.9 103.2 45.9 137.6 0l-25.6-19.2zm-278.4 0L91.2 253.6c34.4 45.9 103.2 45.9 137.6 0l-25.6-19.2c-21.6 28.8-64.8 28.8-86.4 0zM288 96v32h16 26.7l-36.3 27.2L288 160v8 8 16h16 64 16V160H368 341.3l36.3-27.2L384 128v-8-8V96H368 304 288zM432 0H416V32h16 26.7L422.4 59.2 416 64v8 8V96h16 64 16V64H496 469.3l36.3-27.2L512 32V24 16 0H496 432z'
      
    ]
  };

  

  
  

  var faMemory = {
    prefix: 'fasl',
    iconName: 'memory',
    icon: [
      576,
      512,
      [],
      'f538',
      
      'M0 96V64H32 544h32V96v50.7c-18.6 6.6-32 24.4-32 45.3s13.4 38.7 32 45.3V304 416v32H544 32 0V416 304 237.3c18.6-6.6 32-24.4 32-45.3s-13.4-38.7-32-45.3V96zM544 256c-19.4-14.6-32-37.8-32-64s12.6-49.4 32-64V96H32v32c19.4 14.6 32 37.8 32 64s-12.6 49.4-32 64v32H544V256zm0 64H32v96H96V400 384h32v16 16h56V400 384h32v16 16h56V400 384h32v16 16h56V400 384h32v16 16h56V400 384h32v16 16h64V320zM176 144v96 16H144V240 144 128h32v16zm128 0v96 16H272V240 144 128h32v16zm128 0v96 16H400V240 144 128h32v16z'
      
    ]
  };

  

  
  

  var faCircleDollarToSlot = {
    prefix: 'fasl',
    iconName: 'circle-dollar-to-slot',
    icon: [
      512,
      512,
      ["donate"],
      'f4b9',
      
      'M256 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384A208 208 0 1 0 256 0a208 208 0 1 0 0 416zM64 352H16 0v16V496v16H16 496h16V496 368 352H496 448c-8.6 11.5-18.3 22.2-28.8 32H480v96H32V384H92.8c-10.5-9.8-20.2-20.5-28.8-32zM272 112V96H240v16 9.3c-6.5 1.1-12.7 2.9-18.3 5.4c-14.1 6.4-25.9 18.1-28.8 34.7c-1.6 9.5-.7 18.5 3.1 26.6c3.8 7.9 9.7 13.7 15.9 17.9c11.1 7.5 25.8 11.9 37.7 15.5l0 0 2 .6c13.8 4.2 23.9 7.5 30.5 12.3c2.9 2.1 4.3 4 5.1 5.7c.7 1.6 1.3 4.3 .5 9c-.9 5-3.8 9-10.3 11.8c-7 3-17.7 4.3-31 2.2c-6.4-1-17.6-4.8-27.1-8.1l0 0 0 0c-2.2-.7-4.2-1.4-6.1-2.1l-15.2-5.1-10.1 30.4 15.2 5.1c1.3 .4 2.8 1 4.6 1.6l0 0 0 0 0 0c8.9 3 23 7.9 32.4 9.6V304v16h32V304v-8.9c6.3-.9 12.3-2.5 17.9-4.9c14.7-6.3 26.3-18.3 29.3-35.7c1.7-9.7 .9-18.9-2.7-27.2c-3.6-8.2-9.3-14.3-15.6-18.8c-11.6-8.4-27.2-13.1-39.5-16.9l-.6-.2c-13.9-4.2-24.3-7.4-31-12c-3-2-4.3-3.8-5-5.1c-.6-1.2-1.2-3.3-.5-7.4c.6-3.6 3.3-7.8 10.5-11c7.3-3.3 18-4.9 30.9-2.9c4.4 .7 18.1 3.4 22.1 4.4l15.5 4.1 8.2-30.9-15.5-4.1c-5.1-1.4-18.2-3.9-24.1-4.9V112z'
      
    ]
  };

  
    var faDonate = faCircleDollarToSlot;
  

  
  

  var faSpaceStationMoonConstruction = {
    prefix: 'fasl',
    iconName: 'space-station-moon-construction',
    icon: [
      512,
      512,
      ["space-station-moon-alt"],
      'e034',
      
      'M32 256C32 132.3 132.3 32 256 32c61 0 116.3 24.4 156.7 64H368 352v32h16 80l12.8-25.6C414.1 40.2 339.8 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c91.2 0 171.3-47.7 216.6-119.5L459.1 368H416 400v32h16 11.6c-41.1 48.9-102.7 80-171.6 80c-95.1 0-176.3-59.2-208.8-142.8c39.2 13.6 104 32.3 208.8 32.3c119.5 0 187-24.3 223.8-37.6c5-1.8 9.4-3.4 13.3-4.7l8.5-2.8 2-8.7c4.1-17.7 8.4-38.9 8.4-59.6c0-5.7-.2-11.4-.6-17.1l-1-14.9h-15H432 416v32h16 48c0 14.1-2.5 29.1-5.7 43.8l-5 1.8C433 314.7 369.9 337.4 256 337.4s-177-22.7-213.3-35.8c-2.3-.8-4.4-1.6-6.5-2.3c-2.7-14-4.2-28.5-4.2-43.3zm104-96a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0zm-64 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm152 0H352v32h16 80 16V160H448 368z'
      
    ]
  };

  
    var faSpaceStationMoonAlt = faSpaceStationMoonConstruction;
  

  
  

  var faPipeSection = {
    prefix: 'fasl',
    iconName: 'pipe-section',
    icon: [
      640,
      512,
      [],
      'e438',
      
      'M32 112V96H0v16 16 16 16V352v16 16 16 16H32V400 384H608v16 16h32V400 384 368 352 160 144 128 112 96H608v16 16H256 32V112zm0 48H256 608V352H32V160z'
      
    ]
  };

  

  
  

  var faSitemap = {
    prefix: 'fasl',
    iconName: 'sitemap',
    icon: [
      576,
      512,
      [],
      'f0e8',
      
      'M336 64v96H304 272 240V64h96zM240 192h32v48H80 64v16 64H32 0v32 96 32H32h96 32V448 352 320H128 96V272H272v48H240 208v32 96 32h32 96 32V448 352 320H336 304V272H480v48H448 416v32 96 32h32 96 32V448 352 320H544 512V256 240H496 304V192h32 32V160 64 32H336 240 208V64v96 32h32zM32 448V352h96v96H32zm208-96h96v96H240V352zm208 96V352h96v96H448z'
      
    ]
  };

  

  
  

  var faHeadphonesSimple = {
    prefix: 'fasl',
    iconName: 'headphones-simple',
    icon: [
      512,
      512,
      ["headphones-alt"],
      'f58f',
      
      'M32 288C32 164.3 132.3 64 256 64s224 100.3 224 224V400v16h32V400 288C512 146.6 397.4 32 256 32S0 146.6 0 288V400v16H32V400 288zm128 0V448H96V288h64zM96 256H64v32V448v32H96h64 32V448 288 256H160 96zm256 32h64V448H352V288zm64-32H352 320v32V448v32h32 64 32V448 288 256H416z'
      
    ]
  };

  
    var faHeadphonesAlt = faHeadphonesSimple;
  

  
  

  var faCloudShowersHeavy = {
    prefix: 'fasl',
    iconName: 'cloud-showers-heavy',
    icon: [
      512,
      512,
      [],
      'f740',
      
      'M384 128v32h32c35.3 0 64 28.7 64 64v64H416 96 32V224c0-27.8 17.8-51.6 42.7-60.4L96 156.1V133.5 112c0-44.2 35.8-80 80-80c27 0 50.9 13.4 65.5 34l17.8 25.2 25.9-16.9c10-6.5 22-10.3 34.9-10.3c35.3 0 64 28.7 64 64zM0 320H32 96 416h64 32V288 224c0-53-43-96-96-96c0-53-43-96-96-96c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0C114.1 0 64 50.1 64 112v21.5C26.7 146.6 0 182.2 0 224v64 32zm72 32L0 512H32l72-160H72zm120 0L120 512h32l72-160H192zm72 160l72-160H304L232 512h32zM424 352L352 512h32l72-160H424z'
      
    ]
  };

  

  
  

  var faTemperatureList = {
    prefix: 'fasl',
    iconName: 'temperature-list',
    icon: [
      512,
      512,
      [],
      'e299',
      
      'M69.3 284.5L80 275V260.7 32H208V260.7 275l10.7 9.5c23 20.6 37.3 50.3 37.3 83.5c0 61.9-50.1 112-112 112S32 429.9 32 368c0-33.2 14.4-62.9 37.3-83.5zM240 0H208 80 48V32 260.7C18.5 287.1 0 325.4 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-42.6-18.5-81-48-107.3V32 0zM112 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-29.8-20.4-54.9-48-62V144 128H128v16V306c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64s64-28.7 64-64zM320 32V64h16H496h16V32H496 336 320zm0 128v32h16H496h16V160H496 336 320zm32 128v32h16H496h16V288H496 368 352z'
      
    ]
  };

  

  
  

  var faUnlockKeyhole = {
    prefix: 'fasl',
    iconName: 'unlock-keyhole',
    icon: [
      448,
      512,
      ["unlock-alt"],
      'f13e',
      
      'M224 32c-53 0-96 43-96 96v64H416h32v32V480v32H416 32 0V480 224 192H32 96V128C96 57.3 153.3 0 224 0c58 0 107 38.6 122.7 91.4L316 100.6C304.2 60.9 267.5 32 224 32zM32 224V480H416V224H32zM264 368H184 168V336h16 80 16v32H264z'
      
    ]
  };

  
    var faUnlockAlt = faUnlockKeyhole;
  

  
  

  var faSidebarFlip = {
    prefix: 'fasl',
    iconName: 'sidebar-flip',
    icon: [
      512,
      512,
      [],
      'e24f',
      
      'M32 64V448H288V64H32zm448 0H320V448H480V64zm0-32h32V64 448v32H480 32 0V448 64 32H32 480zM352 96h96v32H352V96zm96 64v32H352V160h96zm-96 64h96v32H352V224z'
      
    ]
  };

  

  
  

  var faCircleChevronDown = {
    prefix: 'fasl',
    iconName: 'circle-chevron-down',
    icon: [
      512,
      512,
      ["chevron-circle-down"],
      'f13a',
      
      'M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm11.3-164.7L256 358.6l-11.3-11.3-112-112L121.4 224 144 201.4l11.3 11.3L256 313.4 356.7 212.7 368 201.4 390.6 224l-11.3 11.3-112 112z'
      
    ]
  };

  
    var faChevronCircleDown = faCircleChevronDown;
  

  
  

  var faFaceFrownSlight = {
    prefix: 'fasl',
    iconName: 'face-frown-slight',
    icon: [
      512,
      512,
      [],
      'e376',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM382.3 392.8l-28.6 14.3C344.9 389.7 312.4 352 256 352s-88.9 37.7-97.7 55.2l-28.6-14.3C142.3 367.7 184.4 320 256 320s113.7 47.7 126.3 72.8zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faArrowRightFromBracket = {
    prefix: 'fasl',
    iconName: 'arrow-right-from-bracket',
    icon: [
      512,
      512,
      ["sign-out"],
      'f08b',
      
      'M499.3 267.3L510.6 256l-11.3-11.3-128-128L360 105.4 337.4 128l11.3 11.3L449.4 240 176 240l-16 0 0 32 16 0 273.4 0L348.7 372.7 337.4 384 360 406.6l11.3-11.3 128-128zM176 64l16 0 0-32-16 0L16 32 0 32 0 48 0 464l0 16 16 0 160 0 16 0 0-32-16 0L32 448 32 64l144 0z'
      
    ]
  };

  
    var faSignOut = faArrowRightFromBracket;
  

  
  

  var faSchoolCircleXmark = {
    prefix: 'fasl',
    iconName: 'school-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e56d',
      
      'M160 96H32 0v32V480v32H32 256h32 64 32 10.8c-12.9-9.1-24.5-19.9-34.6-32H352 320 288V384c0-17.7 14.3-32 32-32l.7 0c1-10.9 2.9-21.5 5.8-31.7c-2.1-.2-4.3-.3-6.5-.3c-35.3 0-64 28.7-64 64v96H32V128H160c5.8 0 11.5-1.6 16.5-4.6L320 37.3l143.5 86.1c5 3 10.7 4.6 16.5 4.6H608V232.2c12.1 10 22.9 21.7 32 34.6V128 96H608 480L320 0 160 96zM340.3 285.8c16.5-31.3 42.2-57 73.5-73.5c1.4-6.5 2.2-13.3 2.2-20.3c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c7 0 13.8-.7 20.3-2.2zM112 160H96v16 96 16h16 64 16V272 176 160H176 112zm16 96V192h32v64H128zM96 320v16 96 16h16 64 16V432 336 320H176 112 96zm32 32h32v64H128V352zM320 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 32V144H304v16 32 16h16 24 16V176H344h-8V160zm48 208a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-84.7-36.7L566.6 320 544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7z'
      
    ]
  };

  

  
  

  var faCircleExclamation = {
    prefix: 'fasl',
    iconName: 'circle-exclamation',
    icon: [
      512,
      512,
      ["exclamation-circle"],
      'f06a',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm16-384H240v16V272v16h32V272 144 128zM232 368h48V320H232v48z'
      
    ]
  };

  
    var faExclamationCircle = faCircleExclamation;
  

  
  

  var faBlock = {
    prefix: 'fasl',
    iconName: 'block',
    icon: [
      448,
      512,
      [],
      'e46a',
      
      'M416 64V448H32V64H416zM32 32H0V64 448v32H32 416h32V448 64 32H416 32zm80 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM112 392a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faTrashCanList = {
    prefix: 'fasl',
    iconName: 'trash-can-list',
    icon: [
      640,
      512,
      [],
      'e2ab',
      
      'M143.1 0H152 264h8.9l4.7 7.5L312.9 64H352h32 32V96H384V480v32H352 64 32V480 96H0V64H32 64h39.1L138.4 7.5 143.1 0zm-2.3 64H275.1l-20-32H160.9l-20 32zM64 96V480H352V96H64zm112 64v16V400v16H144V400 176 160h32zm96 0v16V400v16H240V400 176 160h32zm368-32v32H448V128H640zM608 256v32H448V256H608zM448 384h96v32H448V384z'
      
    ]
  };

  

  
  

  var faCommentMiddle = {
    prefix: 'fasl',
    iconName: 'comment-middle',
    icon: [
      512,
      512,
      [],
      'e149',
      
      'M300.2 380.9L293 392.5l-37 59.2-37-59.2-7.2-11.6-13.3-2.8C98 357.1 32 285.3 32 208c0-91.3 93.8-176 224-176s224 84.7 224 176c0 77.3-66 149.1-166.5 170.1l-13.3 2.8zM237.1 481.8L256 512l18.9-30.2 45.2-72.4C430.5 386.3 512 304.9 512 208C512 93.1 397.4 0 256 0S0 93.1 0 208c0 96.9 81.5 178.3 191.9 201.4l45.2 72.4z'
      
    ]
  };

  

  
  

  var faCaretLeft = {
    prefix: 'fasl',
    iconName: 'caret-left',
    icon: [
      256,
      512,
      [],
      'f0d9',
      
      'M160 128l0 256-1.7 0L43 256 158.2 128l1.7 0zm32 0l0-32-32 0-16 0L0 256 144 416l16 0 32 0 0-32 0-256z'
      
    ]
  };

  

  
  

  var faLightbulb = {
    prefix: 'fasl',
    iconName: 'lightbulb',
    icon: [
      384,
      512,
      [128161],
      'f0eb',
      
      'M310.3 258.1C326.5 234.8 336 206.6 336 176c0-79.5-64.5-144-144-144S48 96.5 48 176c0 30.6 9.5 58.8 25.7 82.1c4.1 5.9 8.8 12.3 13.6 19l0 0c12.7 17.5 27.1 37.2 38 57.1c8.9 16.2 13.7 33.3 16.2 49.9H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H242.5c2.5-16.6 7.3-33.7 16.2-49.9c10.9-20 25.3-39.7 38-57.1c4.9-6.7 9.5-13 13.6-19zM192 96c-44.2 0-80 35.8-80 80H80c0-61.9 50.1-112 112-112V96zM144 448v32h96V448H144zm-32 0V416h32 96 32v32 32 32H240 144 112V480 448z'
      
    ]
  };

  

  
  

  var faPeopleRobbery = {
    prefix: 'fasl',
    iconName: 'people-robbery',
    icon: [
      576,
      512,
      [],
      'e536',
      
      'M80 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM80 0a56 56 0 1 1 0 112A56 56 0 1 1 80 0zM283.8 176l-3.3-11.7-40-144 30.8-8.6L308.2 144l27.8 0h32 64 32l27.8 0L528.6 11.7l30.8 8.6-40 144L516.2 176H504 464V496v16H432V496 352H368V496v16H336V496 176H296 283.8zM432 176H368V320h64V176zM32 144h80 8l4.8 6.4L192 240h48 16v32H240 184h-8l-4.8-6.4L104 176H48l0 144h64V288 272h32v16V496v16H112V496 352H48l0 144 0 16-32 0 0-16 0-336 0-16H32zM424 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0A56 56 0 1 1 344 56z'
      
    ]
  };

  

  
  

  var faSquareTerminal = {
    prefix: 'fasl',
    iconName: 'square-terminal',
    icon: [
      448,
      512,
      [],
      'e32a',
      
      'M416 64V448H32V64H416zM32 32H0V64 448v32H32 416h32V448 64 32H416 32zM73.4 160l11.3 11.3L169.4 256 84.7 340.7 73.4 352 96 374.6l11.3-11.3 96-96L214.6 256l-11.3-11.3-96-96L96 137.4 73.4 160zM208 352H192v32h16H368h16V352H368 208z'
      
    ]
  };

  

  
  

  var faCassetteTape = {
    prefix: 'fasl',
    iconName: 'cassette-tape',
    icon: [
      576,
      512,
      [128429],
      'f8ab',
      
      'M544 64V448H478.1L447 362.5 443.2 352H432 144 132.8L129 362.5 97.9 448H32V64H544zM444.1 448H131.9l23.3-64H420.8l23.3 64zM32 32H0V64 448v32H32 544h32V448 64 32H544 32zM160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm55.4 64c5.4-9.4 8.6-20.3 8.6-32s-3.1-22.6-8.6-32H360.6c-5.4 9.4-8.6 20.3-8.6 32s3.1 22.6 8.6 32H215.4zM160 288H416c35.3 0 64-28.7 64-64s-28.7-64-64-64H160c-35.3 0-64 28.7-64 64s28.7 64 64 64zm256-96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faShieldCross = {
    prefix: 'fasl',
    iconName: 'shield-cross',
    icon: [
      512,
      512,
      [9960],
      'f712',
      
      'M48.5 114.9L256 34.3l207.5 80.5c2.7 45.6-4.5 116.8-34.7 186.3S345.4 438.4 256 477.1C166.6 438.4 113.4 370.7 83.2 301.2S45.8 160.5 48.5 114.9zm447-1.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9zM272 112V96H240v16 64H112 96v32h16H240V400v16h32V400 208H400h16V176H400 272V112z'
      
    ]
  };

  

  
  

  var fa8 = {
    prefix: 'fasl',
    iconName: '8',
    icon: [
      320,
      512,
      [],
      '38',
      
      'M304 152c0-66.3-53.7-120-120-120H136C69.7 32 16 85.7 16 152c0 41.4 20.9 77.9 52.8 99.4C28.1 270.6 0 312 0 360c0 66.3 53.7 120 120 120h80c66.3 0 120-53.7 120-120c0-48-28.1-89.4-68.8-108.6C283.1 229.9 304 193.4 304 152zM184.1 272H200c48.6 0 88 39.4 88 88s-39.4 88-88 88H120c-48.6 0-88-39.4-88-88s39.4-88 88-88h15.9c0 0 .1 0 .1 0h48c0 0 0 0 .1 0zm0-32c0 0 0 0-.1 0H136c0 0 0 0-.1 0C87.4 240 48 200.6 48 152c0-48.6 39.4-88 88-88l48 0c48.6 0 88 39.4 88 88c0 48.6-39.4 88-87.9 88z'
      
    ]
  };

  

  
  

  var faRulerHorizontal = {
    prefix: 'fasl',
    iconName: 'ruler-horizontal',
    icon: [
      640,
      512,
      [],
      'f547',
      
      'M32 352l576 0V160l-80 0v64 16H496V224 160H432v64 16H400V224 160H336v64 16H304V224 160H240v64 16H208V224 160H144v64 16H112V224 160l-80 0 0 192zM0 384V352 160 128H32 608h32v32V352v32H608L32 384H0z'
      
    ]
  };

  

  
  

  var faCoconut = {
    prefix: 'fasl',
    iconName: 'coconut',
    icon: [
      512,
      512,
      [],
      'e2f6',
      
      'M272.5 40c45.4-14 79.7-8.9 98.6 9.9s23.9 53.2 9.9 98.6C367.2 193 336 244 290 290s-97 77.2-141.6 91c-45.4 14-79.7 8.9-98.6-9.9S26 317.9 40 272.5c13.8-44.6 45-95.6 91-141.6s97-77.2 141.6-91zM393.7 27.2C362.4-4.1 312.8-5.9 263.1 9.4c-50.5 15.6-105.8 50-154.8 98.9S25 212.6 9.4 263.1C-5.9 312.8-4.1 362.4 27.2 393.7l42.4 42.4C118.2 484.7 184.1 512 252.9 512c14 0 27.8-1.1 41.3-3.3l1.9 1.9 2.7-2.7C405.1 489 489 405.1 508 298.7l2.7-2.7-1.9-1.9c2.1-13.4 3.3-27.2 3.3-41.2c0-68.7-27.3-134.6-75.9-183.2L393.7 27.2zM267.3 436.7L256 425.4 233.4 448l11.3 11.3L265 479.7c-4 .2-8.1 .3-12.2 .3c-56.6 0-111-21.1-152.8-59c18.5 .1 38.1-3.3 57.8-9.4c50.5-15.6 105.8-50 154.8-98.9s83.4-104.3 98.9-154.8c6.1-19.7 9.4-39.3 9.4-57.8c37.9 41.7 59 96.1 59 152.8c0 4.1-.1 8.2-.3 12.2l-20.4-20.4L448 233.4 425.4 256l11.3 11.3 37.4 37.4c-8.5 36.5-25.9 69.7-49.7 97.1l-45.1-45.1L368 345.4 345.4 368l11.3 11.3 45.1 45.1c-27.4 23.8-60.5 41.1-97.1 49.7l-37.4-37.4zm50.9-333.4c3.5 3.5 9.6 17-1.7 48.8c-10.4 29.4-32.9 64.9-66.2 98.2s-68.9 55.9-98.2 66.2c-31.8 11.2-45.4 5.1-48.8 1.7s-9.6-17 1.7-48.8c10.4-29.4 32.9-64.9 66.2-98.2s68.9-55.9 98.2-66.2c31.8-11.2 45.4-5.1 48.8-1.7zm22.6-22.6c-34.4-34.4-120.5-4-192.3 67.9s-102.2 158-67.9 192.3s120.5 4 192.3-67.9s102.2-158 67.9-192.3z'
      
    ]
  };

  

  
  

  var faFilm = {
    prefix: 'fasl',
    iconName: 'film',
    icon: [
      512,
      512,
      [127902],
      'f008',
      
      'M128 448V352 272H384v80 96H128zM384 240H128V160 64H384v96 80zM96 448H32V368H96v80zM32 336V272H96v64H32zM96 176v64H32V176H96zM96 64v80H32V64H96zM416 336V272h64v64H416zm0 112V368h64v80H416zm0-272h64v64H416V176zm64-32H416V64h64v80zM512 32H480 32 0V64 448v32H32 480h32V448 64 32z'
      
    ]
  };

  

  
  

  var faSickle = {
    prefix: 'fasl',
    iconName: 'sickle',
    icon: [
      512,
      512,
      [],
      'f822',
      
      'M320 0C214 0 128 86 128 192c0 71 38.5 132.9 95.7 166.1l10.6 6.2 8.7-8.7 36-36 9-9-6.8-10.8C270.3 282.5 264 262 264 240c0-61.9 50.1-112 112-112c48.1 0 89.1 30.3 105 72.9l31-5.3c0-1.2 0-2.4 0-3.6C512 86 426 0 320 0zM160 192c0-88.4 71.6-160 160-160c65.7 0 122.1 39.6 146.8 96.2C442 108.1 410.4 96 376 96c-79.5 0-144 64.5-144 144c0 23.6 5.7 45.9 15.8 65.6l-18.3 18.3C187.5 295.1 160 246.7 160 192zm-56 97.4L81.4 312l11.3 11.3 4.7 4.7L12.7 412.7 1.4 424l11.3 11.3 64 64L88 510.6l11.3-11.3L184 414.6l4.7 4.7L200 430.6 222.6 408l-11.3-11.3-4.7-4.7-11.3-11.3-64-64L120 305.4l-4.7-4.7L104 289.4zm16 61.3L161.4 392 88 465.4 46.6 424 120 350.6z'
      
    ]
  };

  

  
  

  var faRadar = {
    prefix: 'fasl',
    iconName: 'radar',
    icon: [
      512,
      512,
      [],
      'e024',
      
      'M32 256C32 132.3 132.3 32 256 32c56.1 0 107.4 20.6 146.7 54.7l-34.1 34.1C338.1 95.3 298.8 80 256 80c-72.2 0-134.2 43.5-161.3 105.6L124 198.4c22.2-50.9 73-86.4 132-86.4c34 0 65.2 11.8 89.9 31.5l-34.3 34.3C295.9 166.6 276.7 160 256 160c-53 0-96 43-96 96s43 96 96 96s96-43 96-96H320c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c11.9 0 23 3.2 32.5 8.9l-43.8 43.8L233.4 256 256 278.6l11.3-11.3 224-224L502.6 32 480 9.4 468.7 20.7 425.4 64C380.2 24.2 320.9 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256H480c0 123.7-100.3 224-224 224S32 379.7 32 256zM313.6 388l12.8 29.3C388.5 390.2 432 328.2 432 256H400c0 59-35.5 109.8-86.4 132zM124 313.6L94.7 326.4c17.7 40.6 50.3 73.2 90.9 90.9L198.4 388c-33.2-14.5-59.9-41.2-74.4-74.4zM120 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM256 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faPhotoFilmMusic = {
    prefix: 'fasl',
    iconName: 'photo-film-music',
    icon: [
      640,
      512,
      [],
      'e228',
      
      'M192 32H576V142.6l32-10.7V32 0H576 192 160V32 272v0 48 32h32 48 0H384V320H278.6l84.7-84.7L384 214.6l12-12 84-84 42 42 33.9-11.3L491.3 84.7 480 73.4 468.7 84.7 352 201.4l-52.7-52.7L288 137.4l-11.3 11.3L192 233.4V32zM329.4 224l-96 96H192V278.6l96-96L329.4 224zM256 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM128 96H112 96 32 0v32V416v32H32 96h16 16H290.2c3.2-12.4 9.7-23.2 17.9-32H128V384 336 208 128 96zM96 192H32V128H96v64zm0 224H32V352H96v64zm0-192v96H32V224H96zm544-68.9l-21.1 7-192 64L416 229.8v11.5 72V423.7c-9.4-4.1-20.3-6.4-32-6.4c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48V324.8l160-53.3v88.2c-9.4-4.1-20.3-6.4-32-6.4c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48c0-1.6-.1-3.2-.3-4.8c.2-1 .3-2.1 .3-3.2v-144-72V155.1zM410.1 457c5.5 4.1 5.9 7.4 5.9 8.3s-.4 4.2-5.9 8.3c-5.5 4.1-14.6 7.7-26.1 7.7s-20.5-3.5-26.1-7.7c-5.5-4.1-5.9-7.4-5.9-8.3s.4-4.2 5.9-8.3c5.5-4.1 14.6-7.7 26.1-7.7s20.5 3.5 26.1 7.7zM448 291.1V252.8l160-53.3v38.3L448 291.1zM608 401.3c0 .9-.4 4.2-5.9 8.3c-5.5 4.1-14.6 7.7-26.1 7.7s-20.5-3.5-26.1-7.7c-5.5-4.1-5.9-7.4-5.9-8.3s.4-4.2 5.9-8.3c5.5-4.1 14.6-7.7 26.1-7.7s20.5 3.5 26.1 7.7c5.5 4.1 5.9 7.4 5.9 8.3z'
      
    ]
  };

  

  
  

  var faRollerCoaster = {
    prefix: 'fasl',
    iconName: 'roller-coaster',
    icon: [
      640,
      512,
      [],
      'e324',
      
      'M144 64c-5.4 0-10.8 .4-16 1.1V464v16H96V464 74.8C58.2 92.8 32 131.3 32 176V464v16H0V464 176C0 96.5 64.5 32 144 32h6.6c46.2 0 89.7 22.2 116.7 59.7L392.7 265.4c24.8 34.3 64.5 54.6 106.8 54.6H512c53 0 96-43 96-96v-5c0-40.9-26.9-75.4-64-86.9V272c-6.7 5-15 8-24 8h-8V128.1c-22.5 .8-44.4 6.8-64 17.5V263.2c-9.2-6.3-17.3-14.2-23.9-23.4L416 228.5V169l-21.4 19L373.4 164l26.4-23.5C432.1 111.9 473.8 96 517 96c67.9 0 123 55.1 123 123v5V464v16H608V464 308.7c-23.5 26.6-57.8 43.3-96 43.3V464v16H480V464 350.8c-22.8-2.7-44.6-10.2-64-21.7V464v16H384V464 304.3c-6.2-6.2-12-12.9-17.2-20.2L320 219.3V464v16H288V464 175l-46.7-64.6c-5.1-7-10.9-13.4-17.3-19V464v16H192V464 72c-13-5.2-27.1-8-41.4-8H144z'
      
    ]
  };

  

  
  

  var faCorn = {
    prefix: 'fasl',
    iconName: 'corn',
    icon: [
      512,
      512,
      [127805],
      'f6c7',
      
      'M448 0c-14.6 0-28.1 4.9-38.8 13.1C401.4 9.8 392.9 8 384 8c-20.3 0-38.5 9.5-50.2 24.3c-1.9-.2-3.9-.3-5.8-.3c-20.3 0-38.5 9.5-50.2 24.3c-1.9-.2-3.9-.3-5.8-.3c-21.9 0-41.2 11-52.7 27.7c7.7 10.3 14.7 21 21 32l.1-.6C242.7 99.8 256 88 272 88c3.1 0 6.1 .4 8.9 1.3l12.6 3.7 6.1-11.6C304.9 71 315.7 64 328 64c3.1 0 6.1 .4 8.9 1.3l12.6 3.7 6.1-11.6C360.9 47 371.7 40 384 40c6.9 0 13.2 2.1 18.4 5.8l11.9 8.4 9.5-11C429.6 36.3 438.3 32 448 32c17.7 0 32 14.3 32 32c0 9.7-4.3 18.4-11.2 24.3l-11 9.5 8.4 11.9c3.7 5.2 5.8 11.5 5.8 18.4c0 12.3-7 23.1-17.3 28.4l-11.6 6.1 3.7 12.6c.8 2.8 1.3 5.8 1.3 8.9c0 12.3-7 23.1-17.3 28.4l-11.6 6.1 3.7 12.6c.8 2.8 1.3 5.8 1.3 8.9c0 10.9-5.4 20.5-13.7 26.3c8.7 6.3 17.1 13.4 24.9 21C448 275.6 456 258.7 456 240c0-2-.1-3.9-.3-5.8C470.5 222.5 480 204.3 480 184c0-2-.1-3.9-.3-5.8C494.5 166.5 504 148.3 504 128c0-8.9-1.8-17.4-5.1-25.2C507.1 92.1 512 78.6 512 64c0-35.3-28.7-64-64-64zM163.3 68.7L145 50.4l-8.2 24.6-23 68.9L4 269.5 0 274v6V392v6.3l4.2 4.6 96 104L105 512h7H232h6.6l4.7-4.7L352.8 397.8 437.5 367l23.6-8.6-17.8-17.8-29.1-29.1C378.6 276 330.3 256 280 256c-10.8 0-21.6 .9-32.1 2.7c-1.9-69.5-30.3-135.7-79.6-185l-5-5zM216 266v1.1c-26.2 9.4-50.2 24.5-70.2 44.5L51 406.4 32 385.7V286L140 162.5l2.1-2.4 1-3.1 15.5-46.6C195.6 153.7 216 208.8 216 266zM119 480L72.7 429.9l95.7-95.7C198 304.6 238.1 288 280 288s82 16.6 111.6 46.2l11.3 11.3L338.5 369l-3.3 1.2-2.5 2.5L225.4 480H119z'
      
    ]
  };

  

  
  

  var faFaceKissBeam = {
    prefix: 'fasl',
    iconName: 'face-kiss-beam',
    icon: [
      512,
      512,
      [128537,"kiss-beam"],
      'f597',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm237.8 39.8l4.5-31.7c15.4 2.2 33.1 6.7 47.5 13.8c7.2 3.5 14.3 8 19.9 13.9c5.6 5.9 10.4 14.1 10.4 24.2s-4.8 18.3-10.4 24.2c-4.5 4.7-10.1 8.6-15.9 11.8c5.8 3.2 11.4 7.1 15.9 11.8c5.6 5.9 10.4 14.1 10.4 24.2s-4.8 18.3-10.4 24.2c-5.6 5.8-12.7 10.3-19.9 13.9c-14.4 7-32.1 11.6-47.5 13.8l-4.5-31.7c13.1-1.8 27.3-5.7 37.9-10.8c5.3-2.6 8.8-5.1 10.8-7.2c1.1-1.1 1.4-1.8 1.6-2.1c-.1-.3-.5-1-1.6-2.1c-2-2.1-5.5-4.6-10.8-7.2c-10.5-5.1-24.8-9-37.9-10.8V336.2c13.1-1.8 27.3-5.7 37.9-10.8c5.3-2.6 8.8-5.1 10.8-7.2c1.1-1.1 1.4-1.8 1.6-2.1c-.1-.3-.5-1-1.6-2.1c-2-2.1-5.5-4.6-10.8-7.2c-10.5-5.1-24.8-9-37.9-10.8zM288 316.2a0 0 0 1 0 -.1 0 0 0 0 1 0 .1 0zm0-.3a.1 .1 0 1 0 0-.1 .1 .1 0 1 0 0 .1zm0 72.2c0 .1 0 .1 0 .1s0 0 0 0s0 0 0 0l0-.1zm0-.2a.1 .1 0 1 0 0-.1 .1 .1 0 1 0 0 .1zM156.5 194.5c-6.2 7.2-10.8 16.8-12.9 25.4l-31-7.8c3.2-12.7 9.8-27.1 19.9-38.6C142.4 161.9 157.2 152 176 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6l-31 7.8c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4l-31-7.8c3.2-12.7 9.8-27.1 19.9-38.6C302.4 161.9 317.2 152 336 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6l-31 7.8c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z'
      
    ]
  };

  
    var faKissBeam = faFaceKissBeam;
  

  
  

  var faSquareUpRight = {
    prefix: 'fasl',
    iconName: 'square-up-right',
    icon: [
      448,
      512,
      [8599,"external-link-square-alt"],
      'f360',
      
      'M416 64V448H32V64H416zm32-32H416 32 0V64 448v32H32 416h32V448 64 32zM320 144H160h-6.6l-4.7 4.7-16 16L121.4 176l11.3 11.3L173.4 228l-64.7 64.7L97.4 304l11.3 11.3 56 56L176 382.6l11.3-11.3L252 306.6l40.7 40.7L304 358.6l11.3-11.3 16-16 4.7-4.7V320 160 144H320zM304 313.4l-40.7-40.7L252 261.4l-11.3 11.3L176 337.4 142.6 304l64.7-64.7L218.6 228l-11.3-11.3L166.6 176H304V313.4z'
      
    ]
  };

  
    var faExternalLinkSquareAlt = faSquareUpRight;
  

  
  

  var faDropletPercent = {
    prefix: 'fasl',
    iconName: 'droplet-percent',
    icon: [
      384,
      512,
      ["humidity"],
      'f750',
      
      'M352 320c0-18.5-8.9-46-26.5-80.1c-17-33-40-68.3-63.5-101c-23.4-32.6-47-62.1-64.7-83.4c-1.9-2.2-3.6-4.4-5.4-6.4c-1.7 2.1-3.5 4.2-5.4 6.4c-17.7 21.3-41.2 50.8-64.7 83.4c-23.5 32.7-46.5 68-63.5 101C40.9 274 32 301.5 32 320c0 88.4 71.6 160 160 160s160-71.6 160-160zM0 320C0 235.8 121 83.6 170.9 24.4C183.8 9.1 192 0 192 0s8.2 9.1 21.1 24.4C263 83.6 384 235.8 384 320c0 106-86 192-192 192S0 426 0 320zm267.3-52.7l-128 128L128 406.6 105.4 384l11.3-11.3 128-128L256 233.4 278.6 256l-11.3 11.3zM112 264a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm136 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  
    var faHumidity = faDropletPercent;
  

  
  

  var faFaceBeamHandOverMouth = {
    prefix: 'fasl',
    iconName: 'face-beam-hand-over-mouth',
    icon: [
      512,
      512,
      [129325],
      'e47c',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 57.4-21.6 109.7-57 149.3l23.8 21.3C487.3 381.4 512 321.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 57.6 19.1 110.8 51.2 153.6l25.6-19.2C48.7 353 32 306.5 32 256zm111.5-76.1c2.1-8.6 6.7-18.2 12.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4l31-7.8c-3.2-12.7-9.8-27.1-19.9-38.6C209.6 121.9 194.8 112 176 112s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6l31 7.8zm172.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4l31-7.8c-3.2-12.7-9.8-27.1-19.9-38.6C369.6 121.9 354.8 112 336 112s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6l31 7.8c2.1-8.6 6.7-18.2 12.9-25.4zM328 257.4l9.4 9.4 3.9 3.9 9.4 9.4-11.3 11.3-4.7 4.7-6.6 6.6-4.7 4.7-33.4 33.4-22.6 22.6 9.4 9.4 22.6-22.6L321.4 328l11.3-11.3L344 305.4l13.3 13.3 9.4 9.4-9.4 9.4-1.9 1.9L344 350.6l-9.4 9.4-11.3 11.3-1.4 1.4-22.6 22.6 9.4 9.4L321.4 392l9.9-9.9 1.4-1.4L344 369.4l13.3 13.3 9.4 9.4-11.3 11.3L344 414.6l-12.7 12.7-22.6 22.6-2.2 2.2C288.7 470 264.4 480 239.2 480c-52.6 0-95.2-42.6-95.2-95.2V372 352 334.4v-12-20h8 21.7H176h8v20 12 3l6.1-6.1 8.9-8.9 13.7-13.7 3.3-3.3L257.4 264l11.3-11.3L280 241.4l9.4 9.4L302.6 264l-11.3 11.3L280 286.6l-22.1 22.1-22.6 22.6 9.4 9.4 22.6-22.6 33.4-33.4 4.7-4.7 6.6-6.6 4.7-4.7L328 257.4zm0-45.3l-16 16-9.4-9.4L280 196.1l-22.6 22.6-11.3 11.3-40.3 40.3H184 144 112v32 20V352v20 12.8C112 455.1 168.9 512 239.2 512c33.7 0 66.1-13.4 89.9-37.3l48.8-48.8 11.3-11.3L411.9 392l-22.6-22.6-9.4-9.4 9.4-9.4L411.9 328l-22.6-22.6-9.4-9.4 16-16-22.6-22.6-22.6-22.6L328 212.1z'
      
    ]
  };

  

  
  

  var faHeartCrack = {
    prefix: 'fasl',
    iconName: 'heart-crack',
    icon: [
      512,
      512,
      [128148,"heart-broken"],
      'f7a9',
      
      'M240 125.3V144v6.6l4.7 4.7 34.2 34.2-79.8 53.2-14.5 9.7L195.5 266l64 80 25-20-53.1-66.4 81.5-54.3 16.2-10.8-13.8-13.8L272 137.4V125.3l6.6-6.6 24.2-24.2C322.3 74.9 348.7 64 376.2 64C433.5 64 480 110.5 480 167.8c0 27.5-10.9 53.9-30.4 73.4l-24.2 24.2L256 434.8 86.6 265.4 62.4 241.2C42.9 221.7 32 195.3 32 167.8C32 110.5 78.5 64 135.8 64c27.5 0 53.9 10.9 73.4 30.4l24.2 24.2 6.6 6.6zM256 480l22.6-22.6L448 288l24.2-24.2c25.5-25.5 39.8-60 39.8-96C512 92.8 451.2 32 376.2 32c-36 0-70.5 14.3-96 39.8l-1.6 1.6L256 96 233.4 73.4l-1.6-1.6c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8c0 36 14.3 70.5 39.8 96L64 288 233.4 457.4 256 480z'
      
    ]
  };

  
    var faHeartBroken = faHeartCrack;
  

  
  

  var faHourglassEnd = {
    prefix: 'fasl',
    iconName: 'hourglass-end',
    icon: [
      384,
      512,
      [8987,"hourglass-3"],
      'f253',
      
      'M0 0H16 48 336h32 16V32H368 352V144v7.8l-6.2 4.8L218.1 256l127.8 99.4 6.2 4.8V368 480h16 16v32H368 336 48 16 0V480H16 32V368v-7.8l6.2-4.8L165.9 256 38.2 156.6 32 151.8V144 32H16 0V0zM64 32V136.2l128 99.6 128-99.6V32H64zM94.6 352h.2 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .7 .6L192 276.3 94.6 352zM64 384v96H320V384h-.4H319h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H304h-.6-.6-.6-.6-.6-.6-.6H299h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H292h-.6-.6-.6-.6-.6-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H266h-.7-.7H264h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H255h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H246h-.7-.7-.7-.7-.7-.7H241h-.7-.7-.7-.7-.7-.7-.7-.7-.7H234h-.7-.7-.7-.7-.7-.7H229h-.7-.7-.7-.7-.7-.7-.7-.7-.7H222h-.7-.7-.7-.7-.7-.7H217h-.7-.7-.7-.7-.7-.7H212h-.7-.7-.7-.7-.7-.7-.7-.7-.7H205h-.7-.7-.7-.7-.7-.7H200h-.7-.7-.7-.7-.7-.7-.7-.7-.7H193h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H184h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H175h-.7-.7H173h-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7-.7H151h-.6-.6H149h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H142h-.6-.6-.6-.6-.6-.6-.6H137h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H129h-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H114h-.6-.6-.6-.5-.5-.5-.5-.5-.5-.5H108h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H92h-.5-.5-.5-.5-.5-.5-.4-.4-.4-.4H87h-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4H82h-.4-.4-.4-.4H80h-.4-.4-.4-.4-.4-.4-.4H77h-.4-.4-.4-.4-.4-.4-.4-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.2-.2-.2H64z'
      
    ]
  };

  
    var faHourglass3 = faHourglassEnd;
  

  
  

  var faPeopleGroup = {
    prefix: 'fasl',
    iconName: 'people-group',
    icon: [
      640,
      512,
      [],
      'e533',
      
      'M104 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 72 88a56 56 0 1 0 112 0zm8 88h-8H160 72 62.9l-4.7 7.8-48 80-5.3 8.9 6 8.5L64 357v75 16H80h96 16V432 344.8L170.5 318 160 304.8V416H96V208h64v64.9l8.7-12.4L192 227.2V192 176zM448 432v16h16 96 16V432 357l53.1-75.9 6-8.5-5.3-8.9-48-80-4.7-7.8H568 480 456h-8v16 35.2l23.3 33.3 8.7 12.4V208h64V416H480V304.8L469.5 318 448 344.8V432zM43.1 271.3L64 236.4v64.8L43.1 271.3zM536 88a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-80 0a56 56 0 1 0 112 0A56 56 0 1 0 456 88zM596.9 271.3L576 301.2V236.4l20.9 34.9zM288 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 256 96a64 64 0 1 0 128 0zM264 192h-8.3l-4.8 6.8-56 80-6.9 9.8 7.5 9.4L256 373.6V464v16h16 96 16V464 373.6L444.5 298l7.5-9.4-6.9-9.8-56-80-4.8-6.8H376 264zm-8 55.3v75.1l-28-35 28-40zM288 448V224h64V448H288zm96-125.6V247.3l28 40-28 35z'
      
    ]
  };

  

  
  

  var faKeyboardLeft = {
    prefix: 'fasl',
    iconName: 'keyboard-left',
    icon: [
      640,
      512,
      [],
      'e1c3',
      
      'M608 96V416H192V96H608zM192 64H160V96 416v32h32H608h32V416 96 64H608 192zm40 72v48h48V136H232zm48 96H232v48h48V232zm-48 96v48h48V328H232zM376 136H328v48h48V136zm-48 96v48h48V232H328zm144-96H424v48h48V136zm-48 96v48h48V232H424zm144-96H520v48h48V136zm-48 96v48h48V232H520zm48 96H520v48h48V328zm-232 8H320v32h16H464h16V336H464 336zM115.3 187.3L126.6 176 104 153.4 92.7 164.7l-80 80L1.4 256l11.3 11.3 80 80L104 358.6 126.6 336l-11.3-11.3L46.6 256l68.7-68.7z'
      
    ]
  };

  

  
  

  var faBars = {
    prefix: 'fasl',
    iconName: 'bars',
    icon: [
      448,
      512,
      ["navicon"],
      'f0c9',
      
      'M0 64H448V96H0V64zM0 224H448v32H0V224zM448 384v32H0V384H448z'
      
    ]
  };

  
    var faNavicon = faBars;
  

  
  

  var faPrescriptionBottle = {
    prefix: 'fasl',
    iconName: 'prescription-bottle',
    icon: [
      384,
      512,
      [],
      'f485',
      
      'M352 32V96H32V32H352zM32 0H0V32 96v32H32 352h32V96 32 0H352 32zm0 160V480v32H64 320h32V480 160H320V480H64V416h80 16V384H144 64V320h80 16V288H144 64V224h80 16V192H144 64V160H32z'
      
    ]
  };

  

  
  

  var faSwatchbook = {
    prefix: 'fasl',
    iconName: 'swatchbook',
    icon: [
      512,
      512,
      [],
      'f5c3',
      
      'M0 416c0 53 43 96 96 96H496h16V496 336 320H496 331.7L447.3 204.5l11.3-11.3-11.3-11.3L334.2 68.7 322.8 57.4 311.5 68.7 192 188.2V16 0H176 16 0V16 416zm480 64H171.7l128-128H480V480zM413.4 193.1L192 414.5v-181L322.8 102.6l90.5 90.5zM96 480c-35.3 0-64-28.7-64-64l0-128H160V416c0 35.3-28.7 64-64 64zM32 256V160H160v96H32zm0-128V32l128 0v96H32zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faRectangleVerticalHistory = {
    prefix: 'fasl',
    iconName: 'rectangle-vertical-history',
    icon: [
      576,
      512,
      [],
      'e237',
      
      'M224 32V480H544V32H224zM192 0h32H544h32V32 480v32H544 224 192V480 32 0zM96 48h32V464H96V48zM0 96H32V416H0V96z'
      
    ]
  };

  

  
  

  var faGrillFire = {
    prefix: 'fasl',
    iconName: 'grill-fire',
    icon: [
      576,
      512,
      [],
      'e5a4',
      
      'M416 64H32V96c0 106 86 192 192 192c3.9 0 7.8-.1 11.7-.3c-3.8 10.4-6.7 21.2-8.8 32.3c-1 0-1.9 0-2.9 0c-19.9 0-39.2-2.6-57.6-7.5l-26.1 57.3c4.3 4.2 8.1 8.9 11.1 14.1h75.2c1.9 11 4.7 21.7 8.3 32H160c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c5.7 0 11.1 .7 16.4 2.1l23.7-52C56 267.9 0 188.5 0 96V64 32H32 416h32V64 96c0 24.8-4 48.7-11.5 71.1l-25.8-25.8c3.5-14.5 5.4-29.7 5.4-45.2V64zM96 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM425.4 201.4L448 224l22.6-22.6L480 192c76.8 64 96 133.3 96 160c0 85.2-66.6 154.9-150.7 159.7c-3.1 .3-6.2 .4-9.3 .4s-6.3-.1-9.3-.4C322.6 506.9 256 437.2 256 352c0-89.6 85.3-165.3 128-192l41.4 41.4zM416 480c2.4 0 4.8-.1 7.2-.2c33.6-3.3 56.8-29.4 56.8-57.3c0-21.9-15.9-47.5-39-71.3c-8.8-9-17.6-16.9-25-23c-7.4 6.1-16.2 13.9-25 23c-23.1 23.8-39 49.5-39 71.3c0 27.8 23.2 54 56.8 57.3c2.4 .1 4.8 .2 7.2 .2zm96-57.4c0 5.4-.5 10.6-1.5 15.8C531.3 415.6 544 385.3 544 352c0-14.1-11-63.7-63-115.8l-10.4 10.4L448 269.3l-22.6-22.6-45-45c-16.2 12.7-34.9 30-51.4 50.7c-24.3 30.5-41 65-41 99.7c0 33.3 12.7 63.6 33.5 86.3c-1-5.1-1.5-10.4-1.5-15.8c0-70.4 96-134.4 96-134.4s96 64 96 134.4z'
      
    ]
  };

  

  
  

  var faJoystick = {
    prefix: 'fasl',
    iconName: 'joystick',
    icon: [
      448,
      512,
      [128377],
      'f8c5',
      
      'M304 112a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm32 0c0 56.4-41.7 103.1-96 110.9V320H208V222.9c-54.3-7.8-96-54.4-96-110.9C112 50.1 162.1 0 224 0s112 50.1 112 112zM64 288H80h32 16v32H112 80 64V288zM416 480V384H32v96H416zM32 352H416h32v32 96 32H416 32 0V480 384 352H32zM208 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faLaptopCode = {
    prefix: 'fasl',
    iconName: 'laptop-code',
    icon: [
      640,
      512,
      [],
      'f5fc',
      
      'M544 64H96V352H64V64 32H96 544h32V64 352H544V64zM61.3 448H578.7L608 418.7V416H32v2.7L61.3 448zM640 384v32 16l-48 48H48L0 432V416 384H32 608h32zM294.6 160l-11.3 11.3L230.6 224l52.7 52.7L294.6 288 272 310.6l-11.3-11.3-64-64L185.4 224l11.3-11.3 64-64L272 137.4 294.6 160zm62.1 11.3L345.4 160 368 137.4l11.3 11.3 64 64L454.6 224l-11.3 11.3-64 64L368 310.6 345.4 288l11.3-11.3L409.4 224l-52.7-52.7z'
      
    ]
  };

  

  
  

  var faTruckUtensils = {
    prefix: 'fasl',
    iconName: 'truck-utensils',
    icon: [
      640,
      512,
      [],
      'e628',
      
      'M32 32V384H69.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H384V32H32zM64 416H32 0V384 32 0H32 384h32V32 96h80 7.4l4.8 5.6 96 112 3.9 4.5V224 384h16 16v32H624 608 576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96zM570.9 224l-82.3-96H416v96H570.9zM416 256v88.4c17-15.2 39.4-24.4 64-24.4c41.8 0 77.4 26.7 90.5 64H576V256H416zM224 416A64 64 0 1 0 96 416a64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM320 112v16 96 32 48 16H288V304 256H256 224V224 160c0-41.8 26.7-77.4 64-90.5c10-3.5 20.8-5.5 32-5.5V96v16zM288 224V128 112v-7.4c-19.1 11.1-32 31.7-32 55.4v64h32zM160 206.1V208v64 16H128V272 206.1c-31.6-7.6-54.4-37.2-52-71.1l4-56.1 1.1-16 31.9 2.3-1.1 16-4 56.1C106.5 158.2 123 176 144 176s37.5-17.8 36.1-38.7l-4-56.1-1.1-16 31.9-2.3 1.1 16 4 56.1c2.4 33.9-20.4 63.5-52 71.1zM160 80v48 16H128V128 80 64h32V80z'
      
    ]
  };

  

  
  

  var faFileCircleQuestion = {
    prefix: 'fasl',
    iconName: 'file-circle-question',
    icon: [
      576,
      512,
      [],
      'e4ef',
      
      'M352 192v19.2c10.1-5.2 20.8-9.4 32-12.6V152L232 0H32 0V32 480v32H32 330.8c-12.9-9.1-24.5-19.9-34.6-32H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 448V416H416v32h32zM368 329.5v6.4l32 0v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8-8.6 4.5v9.7 6.8 16h32V386.8l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z'
      
    ]
  };

  

  
  

  var faHeartHalfStroke = {
    prefix: 'fasl',
    iconName: 'heart-half-stroke',
    icon: [
      512,
      512,
      ["heart-half-alt"],
      'e1ac',
      
      'M240 125.3V418.8L86.6 265.4 62.4 241.2C42.9 221.7 32 195.3 32 167.8C32 110.5 78.5 64 135.8 64c27.5 0 53.9 10.9 73.4 30.4l24.2 24.2 6.6 6.6zm32 293.5V125.3l6.6-6.6 24.2-24.2C322.3 74.9 348.7 64 376.2 64C433.5 64 480 110.5 480 167.8c0 27.5-10.9 53.9-30.4 73.4l-24.2 24.2L272 418.8zM256 480l22.6-22.6L448 288l24.2-24.2c25.5-25.5 39.8-60 39.8-96C512 92.8 451.2 32 376.2 32c-36 0-70.5 14.3-96 39.8l-1.6 1.6L256 96 233.4 73.4l-1.6-1.6c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8c0 36 14.3 70.5 39.8 96L64 288 233.4 457.4 256 480z'
      
    ]
  };

  
    var faHeartHalfAlt = faHeartHalfStroke;
  

  
  

  var faSquareCaretDown = {
    prefix: 'fasl',
    iconName: 'square-caret-down',
    icon: [
      448,
      512,
      ["caret-square-down"],
      'f150',
      
      'M32 448V64H416V448H32zM0 480H32 416h32V448 64 32H416 32 0V64 448v32zM96 192v32 8L224 352 352 232v-8V192H320 128 96zM224 308.1L134.3 224H313.7L224 308.1z'
      
    ]
  };

  
    var faCaretSquareDown = faSquareCaretDown;
  

  
  

  var faCompass = {
    prefix: 'fasl',
    iconName: 'compass',
    icon: [
      512,
      512,
      [129517],
      'f14e',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm38.7-217.3L178.6 333.4l38.7-116.1 116.1-38.7L294.7 294.7zm51.3-154.1L192 192 140.6 346.1 128 384l37.9-12.6L320 320l51.4-154.1L384 128l-37.9 12.6zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faBird = {
    prefix: 'fasl',
    iconName: 'bird',
    icon: [
      512,
      512,
      [],
      'e469',
      
      'M224 192H32v8c0 101.6 82.4 184 184 184s184-82.4 184-184V104c0-39.8-32.2-72-72-72s-72 32.2-72 72v56 32H224zM0 200v-8V160H32 192h32V128 104C224 46.6 270.6 0 328 0c43.2 0 80.2 26.3 95.9 63.8L494.8 115l17 12.3-16.3 13.1L432 191.7V200c0 88.6-53.4 164.8-129.7 198.1L362.6 512H326.4L271.7 408.7c-17.8 4.7-36.4 7.3-55.7 7.3c-.1 0-.2 0-.2 0l50.8 96H230.4l-52.6-99.4C76.7 394.6 0 306.2 0 200zm432-49.5l27.1-21.8L432 109.1v41.4zM304 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faHelicopter = {
    prefix: 'fasl',
    iconName: 'helicopter',
    icon: [
      640,
      512,
      [128641],
      'f533',
      
      'M160 0H144V32h16H352v96H144L100.8 70.4 96 64H88 24 3.2L8.5 84.1l32 120 2 7.4 7 3.1 141.3 62.8L292.7 379.3l4.7 4.7H304h.6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .5 .6 .5 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 .6 16V368 272c0-79.5-64.5-144-144-144H384V32H576h16V0H576 160zM44.8 96H80l43.2 57.6L128 160h8H352V352h-.3-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H345h-.5H344h-.5H343h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H335h-.5H334h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H327h-.5-.5-.5-.5-.5-.5-.5-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6-.6H312h-.6-.6-.2l-99.3-99.3-2.1-2.1-2.7-1.2-137-60.9L44.8 96zM384.4 352H384V160h48c61.9 0 112 50.1 112 112v80h-.4-.6-.6-.6-.6-.5-.6-.5-.5-.5-.5-.5H537h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H530h-.5H529h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H521h-.5H520h-.5H519h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H484h-.5H483h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H473h-.5H472h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H464h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H457h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H450h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H444h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H438h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H432h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H426h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H420h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H414h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H407h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H400h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5H392h-.5H391h-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5-.5zM640 464V448H608v16 16H240 224v32h16H624h16V496 464z'
      
    ]
  };

  

  
  

  var faSquareMinus = {
    prefix: 'fasl',
    iconName: 'square-minus',
    icon: [
      448,
      512,
      [61767,"minus-square"],
      'f146',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM128 240H320h16v32H320 128 112V240h16z'
      
    ]
  };

  
    var faMinusSquare = faSquareMinus;
  

  
  

  var faHouseFire = {
    prefix: 'fasl',
    iconName: 'house-fire',
    icon: [
      640,
      512,
      [],
      'e50c',
      
      'M298.6 12L288 2.7 277.4 12 5.4 252l21.2 24L64 243V496v16H80 374.1c-14.1-9.3-26.9-20.5-38.1-33.1V480H240V320h50.9c2-11 4.9-21.7 8.6-32H224 208v16V480H96V214.7L288 45.3 406.5 149.9c8.9-6.9 17.2-12.6 24.5-17.2l2.5-1.6L298.6 12zM489.4 201.4L448 160c-42.7 26.7-128 102.4-128 192c0 85.2 66.6 154.9 150.7 159.7c3.1 .3 6.2 .4 9.3 .4s6.3-.1 9.3-.4C573.4 506.9 640 437.2 640 352c0-26.7-19.2-96-96-160l-9.4 9.4L512 224l-22.6-22.6zM480 480c-2.4 0-4.8-.1-7.2-.2c-33.6-3.3-56.8-29.4-56.8-57.3c0-21.9 15.9-47.5 39-71.3c8.8-9 17.6-16.9 25-23c7.4 6.1 16.2 13.9 25 23c23.1 23.8 39 49.5 39 71.3c0 27.8-23.2 54-56.8 57.3c-2.4 .1-4.8 .2-7.2 .2zm96-57.4c0-70.4-96-134.4-96-134.4s-96 64-96 134.4c0 5.4 .5 10.6 1.5 15.8C364.7 415.6 352 385.3 352 352c0-34.7 16.7-69.1 41-99.7c16.4-20.6 35.2-38 51.4-50.7l45 45L512 269.3l22.6-22.6L545 236.2C597 288.3 608 337.9 608 352c0 33.3-12.7 63.6-33.5 86.3c1-5.1 1.5-10.4 1.5-15.8z'
      
    ]
  };

  

  
  

  var faEmptySet = {
    prefix: 'fasl',
    iconName: 'empty-set',
    icon: [
      512,
      512,
      [216,8709],
      'f656',
      
      'M425.3 109.3l66-66L468.7 20.7l-66 66C363.4 52.6 312.1 32 256 32C132.3 32 32 132.3 32 256c0 56.1 20.6 107.4 54.7 146.7l-66 66 22.6 22.6 66-66C148.6 459.4 199.9 480 256 480c123.7 0 224-100.3 224-224c0-56.1-20.6-107.4-54.7-146.7zm-45.3 .1L109.4 380C81.1 346.5 64 303.3 64 256C64 150 150 64 256 64c47.3 0 90.5 17.1 124 45.4zM132 402.6L402.6 132c28.3 33.5 45.4 76.7 45.4 124c0 106-86 192-192 192c-47.3 0-90.5-17.1-124-45.4z'
      
    ]
  };

  

  
  

  var faStarAndCrescent = {
    prefix: 'fasl',
    iconName: 'star-and-crescent',
    icon: [
      512,
      512,
      [9770],
      'f699',
      
      'M328 48c4.1 0 8.2 .1 12.2 .4c39.4 2.3 75.9 15.5 106.4 36.8c-27-30-60.9-53.7-99.3-68.4C319 5.9 288.2 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c32.2 0 63-5.9 91.3-16.8c38.4-14.7 72.3-38.3 99.3-68.3c-30.5 21.2-67 34.5-106.4 36.8c-4 .2-8.1 .4-12.2 .4c-114.9 0-208-93.1-208-208s93.1-208 208-208zM88 256c0 101.6 63.1 188.4 152.3 223.5C123.9 471.4 32 374.4 32 256S123.9 40.6 240.3 32.5C151.1 67.6 88 154.4 88 256zm313.8-99.8L384 120l-17.8 36.2-24.5 49.6-54.7 8L247 219.5l28.9 28.1 39.6 38.6-9.3 54.5-6.8 39.7L335 361.7 384 336l49 25.7 35.7 18.8-6.8-39.7-9.4-54.5 39.6-38.6L521 219.5l-39.9-5.8-54.7-8-24.5-49.6zm19.9 81.3l30.5 4.4-22 21.5-12 11.7 2.8 16.6 5.2 30.3-27.3-14.3L384 299.8l-14.9 7.8L341.9 322l5.2-30.3 2.8-16.6-12-11.7-22-21.5 30.5-4.4 16.6-2.4 7.4-15.1L384 192.3l13.6 27.6 7.4 15.1 16.6 2.4z'
      
    ]
  };

  

  
  

  var faReply = {
    prefix: 'fasl',
    iconName: 'reply',
    icon: [
      512,
      512,
      [61714,"mail-reply"],
      'f3e5',
      
      'M440.2 446.6C411 469.9 384 480 384 480s20.2-20.2 28.5-52.6c2.1-8.4 3.5-17.5 3.5-27.4c0-61.9-50.1-112-112-112H256 224v32 32 32H192L23.7 229.7 0 208l23.7-21.7L192 32h32V64 96v32h32 80c97.2 0 176 78.8 176 176c0 69.2-37.5 115.1-71.8 142.6zm7.7-52.3c18.3-22.5 32.1-52 32.1-90.3c0-79.5-64.5-144-144-144H224 192V128 75.4L47.4 208 192 340.6V288 256h32 80c77.6 0 140.9 61.4 143.9 138.3z'
      
    ]
  };

  
    var faMailReply = faReply;
  

  
  

  var faMeat = {
    prefix: 'fasl',
    iconName: 'meat',
    icon: [
      512,
      512,
      [127830],
      'f814',
      
      'M288.9 223.1c30 30 65.3 51.2 99.4 60.2c12.2 3.2 25.2 5 38 4.7l-17.3 17.3c-30 30-70.7 46.8-113.1 46.8H205.3L160 306.7V216c0-42.4 16.9-83.1 46.9-113.1l17.2-17.2c-.3 12.8 1.5 25.8 4.7 38c9 34.1 30.2 69.4 60.2 99.4zm175.8 17.7c-31.2 31.2-99.7 13.1-153.2-40.3s-71.5-122-40.3-153.2c9.9-9.9 23.5-14.8 39.2-15.2c8.9 .2 18.1 1.6 27.1 3.9c28.9 7.6 59.6 25.9 86.1 52.3s44.7 57.2 52.3 86.1c2.3 8.9 3.7 17.9 3.9 26.8c-.4 15.9-5.3 29.6-15.3 39.6zM347.6 4.8c-12-3.2-24.8-5-37.4-4.7c-25.7-.3-52.7 6.9-74 28.2l-52 52c-36 36-56.2 84.8-56.2 135.8v97.4l-8.5 8.5C106.8 310.8 90.2 304 72 304c-39.8 0-72 32.2-72 72c0 37.2 28.2 67.8 64.4 71.6C68.2 483.8 98.8 512 136 512c39.8 0 72-32.2 72-72c0-18.2-6.8-34.8-17.9-47.5l8.5-8.5H296c50.9 0 99.7-20.2 135.7-56.2l52.1-52.1c21.4-21.4 28.6-48.6 28.1-74.5c.2-12.5-1.6-25-4.7-36.9c-9-34.1-30.2-69.4-60.2-99.4s-65.3-51.2-99.4-60.2zm-175 359.9l-17.2 17.2-13.9 13.9L158 406.6c10.9 7.2 18 19.5 18 33.4c0 22.1-17.9 40-40 40s-40-17.9-40-40v-8V416H80 72c-22.1 0-40-17.9-40-40s17.9-40 40-40c14 0 26.2 7.1 33.4 18l10.8 16.4 13.9-13.9 17.2-17.2 25.4 25.4zM351.9 160.1c15.3 15.3 34.9 20.4 43.8 11.5s3.8-28.5-11.5-43.8s-34.9-20.4-43.8-11.5s-3.8 28.5 11.5 43.8z'
      
    ]
  };

  

  
  

  var faClover = {
    prefix: 'fasl',
    iconName: 'clover',
    icon: [
      448,
      512,
      [],
      'e139',
      
      'M174.6 64c-18.9 0-34.3 15.3-34.3 34.3c0 7.9 2 15.7 5.8 22.6L190 200.3 168.3 222 88.9 178.1c-6.9-3.8-14.7-5.8-22.6-5.8c-18.9 0-34.3 15.3-34.3 34.3v9.6l28.5 28.5L71.9 256 60.5 267.3 32 295.9v9.6c0 18.9 15.3 34.3 34.3 34.3c7.9 0 15.7-2 22.6-5.8L168.3 290 190 311.7l-43.9 79.4c-3.8 6.9-5.8 14.7-5.8 22.6c0 18.9 15.3 34.3 34.3 34.3h9.6l28.5-28.5L224 408.1l11.3 11.3L263.9 448h9.6c18.9 0 34.3-15.3 34.3-34.3c0-7.9-2-15.7-5.8-22.6L258 311.7 279.7 290l79.4 43.9c6.9 3.8 14.7 5.8 22.6 5.8c18.9 0 34.3-15.3 34.3-34.3v-9.6l-28.5-28.5L376.1 256l11.3-11.3L416 216.1v-9.7c0-18.8-15.3-34.1-34.1-34.1c-8 0-15.8 2-22.8 5.9L281 222l-21.9-21.6L302 120.9c3.7-6.9 5.7-14.6 5.7-22.4c0-19.1-15.5-34.5-34.5-34.5h-9.3L235.3 92.5 224 103.9 212.7 92.5 184.1 64h-9.6zM339.7 98.5c0 13.1-3.3 26-9.5 37.6l-16.7 31 30-16.8c11.7-6.6 25-10 38.4-10c36.5 0 66.1 29.6 66.1 66.1v16.3 6.6l-4.7 4.7L421.4 256l21.9 21.9 4.7 4.7v6.6 16.2c0 36.6-29.7 66.3-66.3 66.3c-13.3 0-26.5-3.4-38.1-9.8l-30.8-17 17 30.8c6.5 11.7 9.8 24.8 9.8 38.1c0 36.6-29.7 66.3-66.3 66.3H257.2h-6.6l-4.7-4.7L224 453.4l-21.9 21.9-4.7 4.7h-6.6H174.6c-36.6 0-66.3-29.7-66.3-66.3c0-13.3 3.4-26.5 9.8-38.1l17-30.8-30.8 17c-11.7 6.5-24.8 9.8-38.1 9.8C29.7 371.7 0 342 0 305.4V289.2l4.7-11.3L26.6 256 4.7 234.1 0 229.4v-6.6V206.6c0-36.6 29.7-66.3 66.3-66.3c13.3 0 26.5 3.4 38.1 9.8l30.8 17-17-30.8c-6.5-11.7-9.8-24.8-9.8-38.1C108.3 61.7 138 32 174.6 32h16.2 6.6l4.7 4.7L224 58.6l21.9-21.9 4.7-4.7h6.6 15.9c36.7 0 66.5 29.8 66.5 66.5z'
      
    ]
  };

  

  
  

  var faUsersSlash = {
    prefix: 'fasl',
    iconName: 'users-slash',
    icon: [
      640,
      512,
      [],
      'e073',
      
      'M191.5 73l30.7 24.2c1.2-5.5 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-12.5 0-24.3 2.9-34.9 8l30.7 24.2c1.4-.1 2.8-.2 4.2-.2c24.1 0 44.1 17.8 47.5 41zM135.6 192H48L0 320H34.2l36-96h106l-40.5-32zM413 247.9c2-7.6 3-15.6 3-23.9c0-53-43-96-96-96c-16.2 0-31.4 4-44.8 11.1l29 22.9c5.1-1.3 10.4-2 15.8-2c35.3 0 64 28.7 64 64l0 1 29 22.9zM338.3 352H320 224 176L137.6 480 128 512h33.4H478.6 512l-9-30-43.8-34.6L469 480H171l28.8-96h179l-40.5-32zM569.8 224l36 96H640L592 192H444c2.6 10.2 4 21 4 32H569.8zM512 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faStarSharpHalf = {
    prefix: 'fasl',
    iconName: 'star-sharp-half',
    icon: [
      576,
      512,
      [],
      'e28c',
      
      'M185.2 316.4l-48 147.8L121.7 512l42.4-26.9 148-93.9V78.3 0l-32 71.5L224.5 195.6H73.3 18.9l44 32 122.3 88.9zm-67.9-88.9H224.5h20.7l8.5-18.9 26.3-58.8V373.5L179.6 437.3l36.1-111 7.2-22.1L204 290.5l-86.7-63z'
      
    ]
  };

  

  
  

  var faPickleball = {
    prefix: 'fasl',
    iconName: 'pickleball',
    icon: [
      576,
      512,
      [],
      'e435',
      
      'M140.3 360.9l-13.7 13.7L61.3 440 88 466.7l65.4-65.4 13.7-13.7 18.5 5.8 90.9 28.4c3.3 13.4 8.2 26.2 14.6 38.1L176 424l-65.4 65.4L88 512 65.4 489.4 38.6 462.6 16 440l22.6-22.6L104 352 64 224 265.4 22.6 288 0l22.6 22.6L505.4 217.4 528 240l-9.5 9.5c-14.2-9.1-29.9-16.1-46.7-20.4L288 45.3l-142 142L283.5 324.3c-4.5 11.3-7.8 23.2-9.7 35.5l-150.4-150-23 23 34.2 109.5 5.8 18.5zM431.9 480.1a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-224a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm-64 128a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0-48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-64-64a16 16 0 1 1 0-32 16 16 0 1 1 0 32z'
      
    ]
  };

  

  
  

  var faFaceMask = {
    prefix: 'fasl',
    iconName: 'face-mask',
    icon: [
      576,
      512,
      [],
      'e37f',
      
      'M444.8 416C404.4 455.6 349 480 288 480s-116.4-24.4-156.8-64h34.1L208 448H368l42.7-32h34.1zm27.1-32H432l0-96v-2l80-32 0 2c0 47.6-14.8 91.7-40.2 128zm37.4-163.3L420.9 256H176 155.1L66.8 220.7C83.7 113.7 176.3 32 288 32s204.3 81.7 221.2 188.7zm30.4-12.2C517.3 89.8 413.2 0 288 0S58.7 89.8 36.4 208.5l-13.3-5.3L11.2 232.9l14.9 5.9 6.4 2.5c-.3 4.8-.4 9.7-.4 14.6c0 141.4 114.6 256 256 256s256-114.6 256-256c0-4.9-.1-9.8-.4-14.6l6.4-2.5 14.9-5.9-11.9-29.7-13.3 5.3zM64 254l80 32v2 96H104.1C78.8 347.7 64 303.6 64 256l0-2zm336 34l0 96-42.7 32H218.7L176 384V288H400zM200 312v32h16H360h16V312H360 216 200zm0 48v32h16H360h16V360H360 216 200zm40-184c8.8 0 16-7.2 16-16s-7.2-16-16-16c-55.4 0-93.6 23-107.3 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C162.9 195.7 193 176 240 176zm180.7 27.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C429.6 167 391.4 144 336 144c-8.8 0-16 7.2-16 16s7.2 16 16 16c47 0 77.1 19.7 84.7 27.3z'
      
    ]
  };

  

  
  

  var faTachographDigital = {
    prefix: 'fasl',
    iconName: 'tachograph-digital',
    icon: [
      640,
      512,
      ["digital-tachograph"],
      'f566',
      
      'M32 96V416H608V96H32zM0 64H32 608h32V96 416v32H608 32 0V416 96 64zm96 96v64H320V160H96zM64 128H96 320h32v32 64 32H320 96 64V224 160 128zm0 224H80 336h16v32H336 80 64V352zm320 0h16H560h16v32H560 400 384V352zM96 288v32H64V288H96zm32 0h32v32H128V288zm96 0v32H192V288h32zm32 0h32v32H256V288zm96 0v32H320V288h32z'
      
    ]
  };

  
    var faDigitalTachograph = faTachographDigital;
  

  
  

  var faMagnifyingGlassArrowRight = {
    prefix: 'fasl',
    iconName: 'magnifying-glass-arrow-right',
    icon: [
      512,
      512,
      [],
      'e521',
      
      'M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L487.9 510.5l22.6-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm27.3-299.3L224 105.4 201.4 128l11.3 11.3L265.4 192H112 96v32h16H265.4l-52.7 52.7L201.4 288 224 310.6l11.3-11.3 80-80L326.6 208l-11.3-11.3-80-80z'
      
    ]
  };

  

  
  

  var faSensorTriangleExclamation = {
    prefix: 'fasl',
    iconName: 'sensor-triangle-exclamation',
    icon: [
      640,
      512,
      ["sensor-alert"],
      'e029',
      
      'M32 64H416v87.8l32-58.7V64 32H416 32 0V64 448v32H32 237l17.5-32H32V64zm96 80V128H96v16V272v16h32V272 144zm64 0V128H160v16V272v16h32V272 144zm64 368h36.5H603.5 640l-17.5-32L466.2 193.4 448 160l-18.2 33.4L273.5 480 256 512zm330.1-32H309.9L448 226.8 586.1 480zM464 320V304H432v16 64 16h32V384 320zm-32 96v32h32V416H432z'
      
    ]
  };

  
    var faSensorAlert = faSensorTriangleExclamation;
  

  
  

  var faUsersMedical = {
    prefix: 'fasl',
    iconName: 'users-medical',
    icon: [
      640,
      512,
      [],
      'f830',
      
      'M144 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm112 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm160 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM171 480l28.8-96H384V368 352H176L137.6 480 128 512h33.4H448V496 480H432 384 171zM592 192H444c2.6 10.2 4 21 4 32H569.8l12 32H608h8l-24-64zM192 224c0-11 1.4-21.8 4-32H48L0 320H34.2l36-96H192zM512 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM496 288H480v16 48H432 416v16 64 16h16 48v48 16h16 64 16V496 448h48 16V432 368 352H624 576V304 288H560 496zm16 80V320h32v48 16h16 48v32H560 544v16 48H512V432 416H496 448V384h48 16V368z'
      
    ]
  };

  

  
  

  var faMessageImage = {
    prefix: 'fasl',
    iconName: 'message-image',
    icon: [
      512,
      512,
      ["comment-alt-image"],
      'e1e0',
      
      'M160 416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448 416zm0-32h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zM104 128a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184.4-9.5l12.2 15.7 112 144 3.4 4.3V288v16 16H400 112 96V304 288v-5.6l3.5-4.4 64-80 11.2-14 12.6 12.6 19.6 19.6 68.8-82.5 12.7-15.3zm-.9 51l-67.3 80.7-11.2 13.5-12.4-12.4L177.3 232l-44.8 56H379.7L287.6 169.5z'
      
    ]
  };

  
    var faCommentAltImage = faMessageImage;
  

  
  

  var faUserChef = {
    prefix: 'fasl',
    iconName: 'user-chef',
    icon: [
      448,
      512,
      [],
      'e3d2',
      
      'M128 32c17.7 0 32 14.3 32 32V80h32V64c0-17.7 14.3-32 32-32s32 14.3 32 32V80h32V64c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.9-8.9 25.8-21.3 30.2L320 98v11.3V144H128V109.3 98l-10.7-3.8C104.9 89.8 96 77.9 96 64c0-17.7 14.3-32 32-32zm48-10.3C164.3 8.4 147.1 0 128 0C92.7 0 64 28.7 64 64c0 23.7 12.9 44.4 32 55.4V160v16c0 70.7 57.3 128 128 128s128-57.3 128-128V160 119.4c19.1-11.1 32-31.7 32-55.4c0-35.3-28.7-64-64-64c-19.1 0-36.3 8.4-48 21.7C260.3 8.4 243.1 0 224 0s-36.3 8.4-48 21.7zM128 176H320c0 53-43 96-96 96s-96-43-96-96zM336 353.3V384h32 8.2L405 480H160V426.7l176-73.3zM128 480H43l28.8-96H80h32V352v-1.2l76 29.6-50.2 20.9-9.8 4.1V416v64zm310.4 0L400 352H368V338.3 320 304l-32 12.4L224 360 112 316.4 80 304v16 18.3V352H48L9.6 480 0 512H33.4 414.6 448l-9.6-32zM240 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faTable = {
    prefix: 'fasl',
    iconName: 'table',
    icon: [
      512,
      512,
      [],
      'f0ce',
      
      'M32 64l0 96 448 0V64L32 64zm0 128l0 112 208 0 0-112L32 192zm240 0l0 112H480l0-112-208 0zM240 336L32 336l0 112 208 0V336zm32 112H480V336H272V448zM0 32l32 0 448 0 32 0V64l0 384v32H480L32 480H0l0-32L0 64 0 32z'
      
    ]
  };

  

  
  

  var faHyphen = {
    prefix: 'fasl',
    iconName: 'hyphen',
    icon: [
      320,
      512,
      [],
      '2d',
      
      'M0 240H16 304h16v32H304 16 0V240z'
      
    ]
  };

  

  
  

  var faMustache = {
    prefix: 'fasl',
    iconName: 'mustache',
    icon: [
      640,
      512,
      [],
      'e5bc',
      
      'M187.2 112H192h80 4.8l4 2.7L320 140.8l39.1-26.1 4-2.7H368h80 5.3l4.3 3.2 88.1 66.1 71.2-35.6L640 134.1V160v44c0 108.2-87.8 196-196 196c-42.4 0-83.7-13.8-117.6-39.2L320 356l-6.4 4.8C279.7 386.2 238.4 400 196 400C87.8 400 0 312.2 0 204V160 136.4l21.9 8.8L94.1 174l89-59.3 4-2.7zm9.7 32l-92 61.3-7 4.7-7.8-3.1L32 183.6V204c0 90.6 73.4 164 164 164c35.5 0 70-11.5 98.4-32.8l16-12L320 316l9.6 7.2 16 12C374 356.5 408.5 368 444 368c90.6 0 164-73.4 164-164V185.9l-56.8 28.4-8.8 4.4-7.9-5.9L442.7 144H372.8l-44 29.3-8.9 5.9-8.9-5.9-44-29.3H196.8z'
      
    ]
  };

  

  
  

  var faHockeyPuck = {
    prefix: 'fasl',
    iconName: 'hockey-puck',
    icon: [
      512,
      512,
      [],
      'f453',
      
      'M38.6 190.9c6.1 8.5 16.3 20.3 32.4 32.2c32 23.7 88.6 48.9 185 48.9s153-25.2 185-48.9c16.1-11.9 26.3-23.7 32.4-32.2c1.9-2.7 3.4-5 4.6-6.9c-1.2-1.9-2.7-4.3-4.6-6.9c-6.1-8.5-16.3-20.3-32.4-32.2C409 121.2 352.4 96 256 96s-153 25.2-185 48.9c-16.1 11.9-26.3 23.7-32.4 32.2c-1.9 2.7-3.4 5-4.6 6.9c1.2 1.9 2.7 4.3 4.6 6.9zm472.3-12.9c0 0 0 0-14.9 5.9l14.9-5.9c.8 1.9 1.1 3.9 1.1 5.9V328v3.6l-1.5 3.3L496 328c14.5 6.8 14.5 6.9 14.5 6.9l0 0 0 .1-.1 .1-.2 .4c-.2 .3-.4 .7-.6 1.2c-.5 1-1.3 2.4-2.3 4c-2 3.3-5 7.9-9.3 13.3c-8.4 10.8-21.6 24.9-41.1 38.9c-39.1 28.1-102.4 55-200.9 55s-161.8-26.9-200.9-55c-19.4-14-32.6-28.1-41.1-38.9c-4.2-5.4-7.2-10-9.3-13.3c-1-1.7-1.8-3-2.3-4c-.3-.5-.5-.9-.6-1.2l-.2-.4-.1-.1 0-.1 0 0c0 0 0 0 14.5-6.9L1.5 334.8 0 331.6V328 184c0-2 .4-4 1.1-5.9L16 184c-14.9-5.9-14.9-5.9-14.9-5.9l0 0 0-.1 .1-.2 .2-.4c.1-.3 .3-.8 .6-1.3c.5-1 1.2-2.4 2.1-4.1c1.8-3.4 4.6-8.1 8.5-13.6c7.9-11 20.4-25.2 39.4-39.3C90.2 90.8 153.7 64 256 64s165.8 26.8 204 55.1c19 14.1 31.6 28.3 39.4 39.3c3.9 5.5 6.7 10.1 8.5 13.6c.9 1.7 1.6 3.1 2.1 4.1c.2 .5 .4 .9 .6 1.3l.2 .4 .1 .2 0 .1 0 0zM480 232c-5.7 5.5-12.3 11.2-20 16.9C421.8 277.2 358.3 304 256 304s-165.8-26.8-204-55.1c-7.7-5.7-14.3-11.4-20-16.9v91.9l.2 .3c1.4 2.3 3.7 5.9 7.1 10.2c6.8 8.7 17.8 20.6 34.5 32.6c33.2 23.9 89.9 49 182.2 49s149-25.1 182.2-49c16.7-12 27.8-23.9 34.5-32.6c3.4-4.3 5.7-7.9 7.1-10.2l.2-.3V232z'
      
    ]
  };

  

  
  

  var faToiletsPortable = {
    prefix: 'fasl',
    iconName: 'toilets-portable',
    icon: [
      576,
      512,
      [],
      'e584',
      
      'M0 0H16 240h16V16 208v32 64 32V496v16H224V496 480H32v16 16H0V496 16 0zM224 304V240H192v64h32zm0-96V128H32V448H224V336H192 160V304 240 208h32 32zm0-176H32V96H224V32zM320 0h16H560h16V16 208v32 64 32V496v16H544V496 480H352v16 16H320V496 16 0zM544 304V240H512v64h32zm0-96V128H352V448H544V336H512 480V304 240 208h32 32zm0-176H352V96H544V32z'
      
    ]
  };

  

  
  

  var faSunPlantWilt = {
    prefix: 'fasl',
    iconName: 'sun-plant-wilt',
    icon: [
      640,
      512,
      [],
      'e57a',
      
      'M202.2 58L179.8 27.2 160 0 140.2 27.2 117.8 58 80.1 52.1 46.9 46.9l5.2 33.2L58 117.8 27.2 140.2 0 160l27.2 19.8L58 202.2l-5.9 37.7-5.2 33.2 33.2-5.2 37.7-5.9 22.5 30.8L160 320l19.8-27.2L202.2 262l37.7 5.9 33.2 5.2-5.2-33.2L262 202.2l30.8-22.5L320 160l-27.2-19.8L262 117.8l5.9-37.7 5.2-33.2-33.2 5.2L202.2 58zm32.5 27.3l-4.3 27.5-3 19.3 15.8 11.5L265.6 160l-22.5 16.4-15.8 11.5 3 19.3 4.3 27.5-27.5-4.3-19.3-3-11.5 15.8L160 265.6l-16.4-22.5-11.5-15.8-19.3 3-27.5 4.3 4.3-27.5 3-19.3L76.8 176.4 54.4 160l22.5-16.4 15.8-11.5-3-19.3L85.3 85.3l27.5 4.3 19.3 3 11.5-15.8L160 54.4l16.4 22.5 11.5 15.8 19.3-3 27.5-4.3zm-41.6 75.6a32 32 0 1 0 -63.9 0 32 32 0 1 0 63.9 0zm303.7 .1c0-17.6 14.3-32 32-32s32 14.3 32 32v49.5c-11.4 2.5-21.7 7.9-29.9 16.2c-11.9 12.1-18 28.9-18 48c0 14.4 7.5 30.9 16.5 45.3c9.4 15.1 22.3 30.7 36.5 44.1l11 10.4 11-10.4c14.2-13.4 27.1-29.1 36.5-44.2c9-14.4 16.5-30.9 16.5-45.2c0-19.1-6.1-35.9-18-48c-8.2-8.3-18.5-13.7-29.9-16.2V160.9c0-35.3-28.6-64-64-64s-64 28.6-64 64v43.9c-11.4-7.6-25.2-12.1-39.9-12.1c-39.7 0-71.9 32.2-71.9 71.9v9.6c-11.4 2.5-21.7 7.9-29.9 16.2c-11.9 12.1-18 28.9-18 48c0 14.4 7.5 30.9 16.5 45.3c9.5 15.1 22.3 30.7 36.5 44.1l11 10.4 11-10.4c14.2-13.4 27.1-29.1 36.5-44.2c9-14.4 16.5-30.9 16.5-45.2c0-19.1-6.1-35.9-18-48c-8.2-8.3-18.5-13.7-29.9-16.2v-9.6c0-22.1 17.9-39.9 39.9-39.9s39.9 17.9 39.9 39.9v15.9V480.1H17.3 1.3v32h16H480.8 624.7h16v-32h-16H496.8V280.6 264.7 160.9zM368.9 304.6c10.6 0 18.2 3.4 23.2 8.4c5 5 8.8 13.2 8.8 25.5c0 4.9-3.3 14.9-11.6 28.3c-5.5 8.8-12.5 18-20.3 26.7c-7.9-8.7-14.9-17.8-20.3-26.6c-8.3-13.3-11.6-23.3-11.6-28.3c0-12.3 3.8-20.5 8.8-25.5c5-5 12.6-8.4 23.2-8.4zM597 302.9c-5.5 8.8-12.5 18-20.3 26.7c-7.9-8.7-14.9-17.8-20.3-26.6c-8.3-13.3-11.6-23.3-11.6-28.3c0-12.3 3.8-20.5 8.8-25.5c5-5 12.6-8.4 23.2-8.4s18.2 3.4 23.2 8.4c5 5 8.8 13.2 8.8 25.5c0 4.9-3.3 14.9-11.6 28.3z'
      
    ]
  };

  

  
  

  var faListMusic = {
    prefix: 'fasl',
    iconName: 'list-music',
    icon: [
      512,
      512,
      [],
      'f8c9',
      
      'M384 71.8L480 43v93.2L384 165V128 71.8zM352 48v80 46.6V208 376c-20.3-14.8-48.7-24-80-24c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80V198.4L512 160V33.4 0L480 9.6 352 48zm0 384c0 9.1-5.1 20.3-19.4 30.5C318.3 472.7 297 480 272 480s-46.3-7.3-60.6-17.5C197.1 452.3 192 441.1 192 432s5.1-20.3 19.4-30.5C225.7 391.3 247 384 272 384s46.3 7.3 60.6 17.5C346.9 411.7 352 422.9 352 432zM16 64H0V96H16 272h16V64H272 16zm0 128H0v32H16 272h16V192H272 16zm0 128H0v32H16 144h16V320H144 16z'
      
    ]
  };

  

  
  

  var faScissors = {
    prefix: 'fasl',
    iconName: 'scissors',
    icon: [
      512,
      512,
      [9984,9986,9988,"cut"],
      'f0c4',
      
      'M32 112a80 80 0 1 1 160 0A80 80 0 1 1 32 112zm192 0C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c29.5 0 56.4-11.4 76.4-30.1l48.9 41.2L262.2 256l-73.8 62.1c-20-18.7-46.9-30.1-76.4-30.1C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-20.8-5.7-40.3-15.5-56.9L506.3 92.2 485.7 67.8 287 235.1l-24.8-20.9-53.7-45.2c9.9-16.7 15.5-36.2 15.5-56.9zM112 320a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm221.7-3.8l152 128 20.6-24.5-152-128-17.6-14.8-24.8 20.9 21.9 18.4z'
      
    ]
  };

  
    var faCut = faScissors;
  

  
  

  var faSquareCaretRight = {
    prefix: 'fasl',
    iconName: 'square-caret-right',
    icon: [
      448,
      512,
      ["caret-square-right"],
      'f152',
      
      'M416 64L32 64l0 384 384 0 0-384zm32-32l0 32 0 384 0 32-32 0L32 480 0 480l0-32L0 64 0 32l32 0 384 0 32 0zM160 128l32 0 8 0L320 256 200 384l-8 0-32 0 0-32 0-192 0-32zM276.1 256L192 166.3l0 179.5L276.1 256z'
      
    ]
  };

  
    var faCaretSquareRight = faSquareCaretRight;
  

  
  

  var faTombstone = {
    prefix: 'fasl',
    iconName: 'tombstone',
    icon: [
      448,
      512,
      [],
      'f720',
      
      'M384 448V192c0-88.4-71.6-160-160-160S64 103.6 64 192V448H32V192C32 86 118 0 224 0S416 86 416 192V448H384zM0 480H16 432h16v32H432 16 0V480zM240 144v64h64 16v32H304 240V368v16H208V368 240H144 128V208h16 64V144 128h32v16z'
      
    ]
  };

  

  
  

  var faMarsAndVenusBurst = {
    prefix: 'fasl',
    iconName: 'mars-and-venus-burst',
    icon: [
      640,
      512,
      [],
      'e523',
      
      'M218.9 86.9L193.8 36.1 176 0 158.2 36.1 133.1 86.9l-55.3-12L38.4 66.3l17.1 36.5L79.6 154 35.7 189.7 4.4 215.2l39.2 9.4 55.1 13.1 .6 56.6 .4 40.3 31.8-24.8L176 274.9l44.6 34.9L233.7 320c-10.2-17.6-17.7-37.1-21.8-57.7l-16.1-12.6L176 234.3l-19.7 15.4L131 269.5l-.3-32.1-.2-25-24.3-5.8-31.2-7.5 24.9-20.3L119.2 163l-10.6-22.6L94.9 111.3l31.4 6.8 24.4 5.3 11.1-22.4L176 72.3l14.2 28.8 11.1 22.4 24.4-5.3 16.5-3.6C253 99 266.1 85.1 280.9 73.4l-6.7 1.5-55.3 12zM528 0H512V32h16 57.4l-75.6 75.6C481.1 80.6 442.5 64 400 64c-88.4 0-160 71.6-160 160c0 83 63.1 151.2 144 159.2V416H344 328v32h16 40v48 16h32V496 448h40 16V416H456 416V383.2c80.9-8 144-76.2 144-159.2c0-34.3-10.8-66.1-29.2-92.2L608 54.6V104v16h32V104 16 0H624 528zM272 224a128 128 0 1 1 256 0 128 128 0 1 1 -256 0z'
      
    ]
  };

  

  
  

  var faFaceAngryHorns = {
    prefix: 'fasl',
    iconName: 'face-angry-horns',
    icon: [
      640,
      512,
      [],
      'e368',
      
      'M86 152c-4.7-7.3-9.7-15.6-14.7-24.6c-12-21.5-23.2-46.1-30.6-71.5l.1 0C65 65 96.3 73.9 134.9 79.2C114.7 100.3 98 124.9 86 152zM167.4 50.5C105.3 45.7 60.6 30.6 33 18.2C11 8.3 0 0 0 0C0 13.3 1.4 26.5 3.9 39.6c10.9 57.6 42.2 111 63.1 141.7c2 3 4 5.8 5.8 8.3C67 210.7 64 233 64 256c0 141.4 114.6 256 256 256s256-114.6 256-256c0-23-3-45.3-8.7-66.5c1.8-2.5 3.7-5.3 5.8-8.3c20.9-30.6 52.2-84 63.1-141.7c2.5-13 3.9-26.3 3.9-39.6c0 0-11 8.3-33 18.2c-27.5 12.4-72.3 27.5-134.4 32.3C430 18.8 377.2 0 320 0S210 18.8 167.4 50.5zM505.1 79.2C543.7 73.9 575 65 599.2 56l.1 0c-7.4 25.4-18.7 50-30.6 71.5c-5 9-10 17.2-14.7 24.6c-12.1-27.1-28.7-51.7-48.9-72.9zM96 256a224 224 0 1 1 448 0A224 224 0 1 1 96 256zM380.1 410.7l10.7 11.9 23.8-21.4-10.7-11.9C387.8 371.4 359.7 352 320 352s-67.8 19.4-83.9 37.3l-10.7 11.9 23.8 21.4 10.7-11.9c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7zM264.4 272c0-2.6-.4-5.1-1.2-7.4l19.7 6.6 15.2 5.1 10.1-30.4-15.2-5.1-96-32-15.2-5.1-10.1 30.4 15.2 5.1 39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6c0 13.3 10.7 24 24 24s24-10.7 24-24zm136 24c13.3 0 24-10.7 24-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13 15.2-5.1-10.1-30.4-15.2 5.1-96 32-15.2 5.1 10.1 30.4 15.2-5.1 20.6-6.9c-.8 2.4-1.3 5-1.3 7.7c0 13.3 10.7 24 24 24z'
      
    ]
  };

  

  
  

  var faSignPost = {
    prefix: 'fasl',
    iconName: 'sign-post',
    icon: [
      512,
      512,
      [],
      'e624',
      
      'M240 0h32V64H432l80 96-80 96H272V512H240V256H64 32V224 96 64H64 240V0zM470.3 160L417 96H64V224H417l53.3-64z'
      
    ]
  };

  

  
  

  var faPeopleArrows = {
    prefix: 'fasl',
    iconName: 'people-arrows',
    icon: [
      640,
      512,
      ["people-arrows-left-right"],
      'e068',
      
      'M128 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM62.7 192L57.4 320H64 96h28.1l17.9 17.9L156.1 352H96V496v16H64V496 352H56 24l1.3-32L32 160H224l1.1 27-19.1 19.1-11.7 11.7L193.3 192H62.7zM160 496V355.9l32 32V496v16H160V496zm288 0V387.9l32-32V496v16H448V496zm96-144H483.9l14.1-14.1L515.9 320H544h32 6.6l-5.3-128H446.7l-1.1 25.7-11.7-11.7L414.9 187l1.1-27H608l6.7 160 1.3 32H584h-8V496v16H544V496 352zM512 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128A64 64 0 1 1 512 0zM251.3 251.3L214.6 288H425.4l-36.7-36.7L377.4 240 400 217.4l11.3 11.3 64 64L486.6 304l-11.3 11.3-64 64L400 390.6 377.4 368l11.3-11.3L425.4 320H214.6l36.7 36.7L262.6 368 240 390.6l-11.3-11.3-64-64L153.4 304l11.3-11.3 64-64L240 217.4 262.6 240l-11.3 11.3z'
      
    ]
  };

  
    var faPeopleArrowsLeftRight = faPeopleArrows;
  

  
  

  var faAlbumCollectionCirclePlus = {
    prefix: 'fasl',
    iconName: 'album-collection-circle-plus',
    icon: [
      640,
      512,
      [],
      'e48e',
      
      'M32 0H48 464h16V32H464 48 32V0zM16 64H32 480h16V96H480 32 16V64zm19.5 96L68.8 480H360.2c10 12.1 21.7 22.9 34.6 32H40L3.3 160 0 128H32.2 479.8 512l-3.3 32-3.4 32.2c-3.1-.2-6.2-.2-9.3-.2c-7.8 0-15.5 .5-23 1.5l3.5-33.5H35.5zM256 192c49 0 92.8 17.6 122.1 45.3c-8 7.2-15.2 15.1-21.8 23.6C334 239.3 299.3 224 256 224c-77.7 0-128 49.3-128 96s50.3 96 128 96c25.7 0 48.4-5.4 67.2-14.3c2.1 10.7 5.1 21 9 30.8C309.6 442.4 283.6 448 256 448c-88.4 0-160-57.3-160-128s71.6-128 160-128zm0 152c-13.3 0-24-9-24-20s10.7-20 24-20s24 9 24 20s-10.7 20-24 20zm352 24a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-64v48h48 16v32H560 512v48 16H480V432 384H432 416V352h16 48V304 288h32v16z'
      
    ]
  };

  

  
  

  var faSquareRoot = {
    prefix: 'fasl',
    iconName: 'square-root',
    icon: [
      576,
      512,
      [8730],
      'f697',
      
      'M328 32H316l-3.3 11.6L203.5 421.8 102.1 232.4 97.6 224H88 16 0v32H16 78.4L193.9 471.6l4.5 8.4H220l3.3-11.6L340 64H560h16V32H560 328z'
      
    ]
  };

  

  
  

  var faChessRookPiece = {
    prefix: 'fasl',
    iconName: 'chess-rook-piece',
    icon: [
      320,
      512,
      ["chess-rook-alt"],
      'f448',
      
      'M96 144V128H48v90.2l36.3 43.6 4.1 4.9-.4 6.3L83.3 352H51.3l4.4-74.6L19.7 234.2 16 229.8V224 112 96H32 96h32 64 32 64 16v16V224v5.8l-3.7 4.4-35.9 43.1 4.4 74.6H236.7L232 272.9l-.4-6.3 4.1-4.9L272 218.2V128H224v16 16H192V144 128H128v16 16H96V144zM32 480H288V463.3L255.2 416H64.8L32 463.3V480zM0 480V453.3L48 384H272l48 69.3V480v32H288 32 0V480zM176 224v32 16H144V256 224 208h32v16z'
      
    ]
  };

  
    var faChessRookAlt = faChessRookPiece;
  

  
  

  var faArrowProgress = {
    prefix: 'fasl',
    iconName: 'arrow-progress',
    icon: [
      512,
      512,
      [],
      'e5df',
      
      'M416 32V96h64V32H416zM384 0h32 64 32V32 96v32H480 416 384V96 32 0zM286 1.5l12.3 10.2 48 40L361 64 346.2 76.3l-48 40L286 126.5 265.5 102l12.3-10.2 14-11.7H32V240H496h16v16V448v16H496 416v16 32H384 320 288V480 416 384h32 64 32v32 16h64V272H16 0V256 64 48H16 291.8l-14-11.7L265.5 26 286 1.5zM128 416v16h67.8l-14.1-11.7L169.5 410 190 385.5l12.3 10.2 48 40L265 448l-14.7 12.3-48 40L190 510.5 169.5 486l12.3-10.2L195.8 464H128v16 32H96 32 0V480 416 384H32 96h32v32zm-32 0H32v64H96V416zm224 0v64h64V416H320z'
      
    ]
  };

  

  
  

  var faFileMp3 = {
    prefix: 'fasl',
    iconName: 'file-mp3',
    icon: [
      512,
      512,
      [],
      'e648',
      
      'M352 192v96h32V152L232 0H32 0V32 480v32H32 64V480H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM256 368V352l-16 0-5.6 0-9.6 0-4.5 8.5-28.5 53.8-29.7-54-4.6-8.3-9.5 0-4 0-16 0v16V496v16h32V496 423l18 32.7 14.3 26 13.9-26.2L224 421.8V496v16h32V496 368zm48-16H288v16 80 48 16h32V496 464h16c30.9 0 56-25.1 56-56s-25.1-56-56-56H304zm32 80H320V384h16c13.3 0 24 10.7 24 24s-10.7 24-24 24zm96-80H416v32h16 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H440 424v32h16 24c8.8 0 16 7.2 16 16s-7.2 16-16 16H432 416v32h16 32c26.5 0 48-21.5 48-48c0-12.3-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32c0-26.5-21.5-48-48-48H432z'
      
    ]
  };

  

  
  

  var faPenRuler = {
    prefix: 'fasl',
    iconName: 'pen-ruler',
    icon: [
      512,
      512,
      ["pencil-ruler"],
      'f5ae',
      
      'M150.6 22.6L128 0 105.4 22.6 22.6 105.4 0 128l22.6 22.6 82.7 82.7L128 210.7 45.2 128 128 45.3l30.1 30.1-25.4 25.4L121.4 112 144 134.6l11.3-11.3 25.4-25.4L210.7 128l22.6-22.6L150.6 22.6zM361.4 489.4L384 512l22.6-22.6 82.7-82.7L512 384l-22.6-22.6-82.7-82.7L384 301.3l30.1 30.1-25.4 25.4L377.4 368 400 390.6l11.3-11.3 25.4-25.4L466.7 384 384 466.7 301.2 384l-22.6 22.6 82.7 82.7zM6.8 478L0 512l34-6.8L160 480 489.4 150.6 512 128l-22.6-22.6L406.6 22.6 384 0 361.4 22.6 32 352 6.8 478zm34-6.8L61.5 367.8 315.3 113.9l82.7 82.7L144.2 450.5 40.8 471.2zM466.7 128l-46.1 46.1L337.9 91.3 384 45.3 466.7 128z'
      
    ]
  };

  
    var faPencilRuler = faPenRuler;
  

  
  

  var faBellConcierge = {
    prefix: 'fasl',
    iconName: 'bell-concierge',
    icon: [
      512,
      512,
      [128718,"concierge-bell"],
      'f562',
      
      'M208 64H192V96h16 32v48.6C123.8 152.8 32 249.7 32 368v16H64V368c0-106 86-192 192-192s192 86 192 192v16h32V368c0-118.3-91.8-215.2-208-223.4V96h32 16V64H304 256 208zM16 416H0v32H16 496h16V416H496 16z'
      
    ]
  };

  
    var faConciergeBell = faBellConcierge;
  

  
  

  var faMessagePen = {
    prefix: 'fasl',
    iconName: 'message-pen',
    icon: [
      512,
      512,
      ["comment-alt-edit","message-edit"],
      'f4a4',
      
      'M160 416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448 416zm0-32h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zM294.1 157.3L281 170.4l12.5 12.5 13.1-13.1-12.5-12.5zm-93.4 93.4l-2.3 14.8 14.8-2.3 57.7-57.7L258.4 193l-57.7 57.7zM329.3 147.2l22.6 22.6-22.6 22.6L228.4 293.2l-35.3 5.5L160 303.9l5.2-33.2 5.5-35.2L294.1 112l35.2 35.2z'
      
    ]
  };

  
    var faCommentAltEdit = faMessagePen;
  
    var faMessageEdit = faMessagePen;
  

  
  

  var faBadge = {
    prefix: 'fasl',
    iconName: 'badge',
    icon: [
      512,
      512,
      [],
      'f335',
      
      'M256 32c-28.3 0-53 15.9-65.4 39.4l-6.2 11.7-12.6-3.9c-25.4-7.8-54.1-1.6-74.1 18.4s-26.2 48.7-18.4 74.1l3.9 12.6-11.7 6.2C47.9 203 32 227.7 32 256s15.9 53 39.4 65.4l11.7 6.2-3.9 12.6c-7.8 25.4-1.6 54.1 18.4 74.1s48.7 26.2 74.1 18.4l12.6-3.9 6.2 11.7C203 464.1 227.7 480 256 480s53-15.9 65.4-39.4l6.2-11.7 12.6 3.9c25.4 7.8 54.1 1.6 74.1-18.4s26.2-48.7 18.4-74.1l-3.9-12.6 11.7-6.2C464.1 309 480 284.3 480 256s-15.9-53-39.4-65.4l-11.7-6.2 3.9-12.6c7.8-25.4 1.6-54.1-18.4-74.1s-48.7-26.2-74.1-18.4l-12.6 3.9-6.2-11.7C309 47.9 284.3 32 256 32zM168.9 45.6C188 18.1 219.9 0 256 0s68 18.1 87.1 45.6c33-6 68.3 3.8 93.9 29.4s35.3 60.9 29.4 93.9C493.9 188 512 219.9 512 256s-18.1 68-45.6 87.1c6 33-3.8 68.3-29.4 93.9s-60.9 35.3-93.9 29.4C324 493.9 292.1 512 256 512s-68-18.1-87.1-45.6c-33 6-68.3-3.8-93.9-29.4s-35.3-60.9-29.4-93.9C18.1 324 0 292.1 0 256s18.1-68 45.6-87.1c-6-33 3.8-68.3 29.4-93.9s60.9-35.3 93.9-29.4z'
      
    ]
  };

  

  
  

  var faSunglasses = {
    prefix: 'fasl',
    iconName: 'sunglasses',
    icon: [
      576,
      512,
      [128374],
      'f892',
      
      'M82.2 35.1l-14-2.5L64 46.1 .7 251.3 0 253.6V256v0 32 48 16 96 32H32 224h32V448 320h64V448v32h32H544h32V448 352 336 288 256v0-2.4l-.7-2.3L512 46.1l-4.2-13.6-14 2.5L421.1 48.3l-15.7 2.9 5.7 31.5 15.7-2.9 58.7-10.6L543.3 256H352 320v32H256V256H224 32.7L90.4 69.1l58.7 10.6 15.7 2.9 5.7-31.5-15.7-2.9L82.2 35.1zM544 336v16 96H387.8l99.4-49.7 14.3-7.2-14.3-28.6-14.3 7.2L352 430.1V393.9l87.2-43.6 14.3-7.2-14.3-28.6-14.3 7.2L352 358.1V288H544v48zM32 288H224V448H83.8l99.4-49.7 14.3-7.2-14.3-28.6-14.3 7.2-135 67.5-1.8 .9V401.9l7.2-3.6 96-48 14.3-7.2-14.3-28.6-14.3 7.2L32 366.1V352 336 288z'
      
    ]
  };

  

  
  

  var faTireFlat = {
    prefix: 'fasl',
    iconName: 'tire-flat',
    icon: [
      512,
      512,
      [],
      'f632',
      
      'M453.9 393.1l-9.6 18 12.2 16.3L480 458.7V480H380 132 32V458.7l23.5-31.3 12.2-16.3-9.6-18C41.5 361.8 32 326.1 32 288C32 164.3 132.3 64 256 64s224 100.3 224 224c0 38.1-9.5 73.8-26.1 105.1zM512 480V448l-29.9-39.9C501.2 372.3 512 331.4 512 288C512 146.6 397.4 32 256 32S0 146.6 0 288c0 43.4 10.8 84.3 29.9 120.1L0 448v32 32H32 132 380 480h32V480zM384 288c0 8.3-.8 16.3-2.3 24.2L319.9 292c.1-1.3 .1-2.7 .1-4c0-15.4-5.5-29.6-14.5-40.6l38.2-52.6C368.5 218.1 384 251.2 384 288zm-74.1 34.4l61.9 20.1c-18.3 38.8-55.6 66.9-99.8 72.4l0-65c15.9-4.1 29.4-14.1 38-27.6zm-70 27.5l0 65c-44.2-5.5-81.5-33.6-99.8-72.4l61.9-20.1c8.6 13.4 22.1 23.4 37.9 27.5zM128 288c0-36.8 15.5-69.9 40.3-93.3l28.1 38.7 10.1 13.9c-9.1 11-14.5 25.2-14.5 40.6c0 1.4 0 2.7 .1 4l-61.8 20.1c-1.5-7.8-2.3-15.9-2.3-24.2zm128-64c-8.3 0-16.3 1.6-23.6 4.5l-10-13.8-28.1-38.8C212.5 165.8 233.6 160 256 160s43.5 5.8 61.8 15.9l-38.2 52.6c-7.3-2.9-15.3-4.5-23.6-4.5zm160 64A160 160 0 1 0 96 288a160 160 0 1 0 320 0zm-192 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'
      
    ]
  };

  

  
  

  var faTreeChristmas = {
    prefix: 'fasl',
    iconName: 'tree-christmas',
    icon: [
      448,
      512,
      [127876],
      'f7db',
      
      'M217.3 0h13.3 11.1l3.9 10.4 17.4 46.5 46.5 17.4L320 78.2V89.3v13.3 11.1l-10.4 3.9-46.5 17.4-17.4 46.5L241.8 192H230.7 217.3 206.2l-3.9-10.4-17.4-46.5-46.5-17.4L128 113.8V102.7 89.3 78.2l10.4-3.9 46.5-17.4 17.4-46.5L206.2 0h11.1zm-5 75l-2.6 6.8L203 84.3 171.8 96 203 107.7l6.8 2.6 2.6 6.8L224 148.2 235.7 117l2.6-6.8 6.8-2.6L276.2 96 245 84.3l-6.8-2.6L235.7 75 224 43.8 212.3 75zM24 320L142.9 153.5l17.1 6.4 6.1 16.2L63.3 320H80h57.7l-30.6 49L37.7 480H410.3L340.9 369l-30.6-49H368h16.7L281.9 176.1l6.1-16.2 17.1-6.4L424 320v32H405.7 392 368l20 32 60 96v32H416 32 0V480l60-96 20-32H56 42.3 24V320zm136-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM288 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faMotorcycle = {
    prefix: 'fasl',
    iconName: 'motorcycle',
    icon: [
      640,
      512,
      [127949],
      'f21c',
      
      'M448 32h-5.4l-4.3 3.3L385 76.3 366.2 40.5 361.7 32H352 272 256V64h16 70.3l16.9 32.1-127.4 98C199.9 172.6 161.4 160 120 160H48 32v32H48h72c92.8 0 168 75.2 168 168v8 16h16 32 16V368 352c0-55.7 28.5-104.8 71.7-133.4l15 28.5C405.6 270.2 384 308.6 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-15.8 0-31 2.9-45 8.1L412.2 128H496h16V112 48 32H496 448zM408.7 190.1C355.4 224.2 320 284 320 352h-.2c-2.1-54-25.7-102.5-62.4-137.3l116.9-89.9 34.4 65.3zM416 352c0-31.1 14.8-58.8 37.8-76.3l44.1 83.8 7.5 14.2 28.3-14.9-7.4-14.2-44.1-83.8c9.4-3.1 19.5-4.8 29.9-4.8c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96zM480 96H411.8l41.6-32H480V96zM128 256c47.6 0 87.1 34.6 94.7 80h-67c-5.5-9.6-15.9-16-27.7-16c-17.7 0-32 14.3-32 32s14.3 32 32 32c11.8 0 22.2-6.4 27.7-16h67c-7.6 45.4-47.1 80-94.7 80c-53 0-96-43-96-96s43-96 96-96zm128 96A128 128 0 1 0 0 352a128 128 0 1 0 256 0z'
      
    ]
  };

  

  
  

  var faChartBullet = {
    prefix: 'fasl',
    iconName: 'chart-bullet',
    icon: [
      512,
      512,
      [],
      'e0e1',
      
      'M288 32V48 64H480h32V96v96 32H480 288v16 16H256V240 224H32 0V192 96 64H32 256V48 32h32zM160 96v96h96V96H160zm128 0v96H480V96H288zM128 96H32v96h96V96zM384 256v16 16h96 32v32 96 32H480 384v16 16H352V464 448H32 0V416 320 288H32 352V272 256h32zM224 416H352V320H224v96zm160-96v96h96V320H384zm-192 0H32v96H192V320z'
      
    ]
  };

  

  
  

  var faStarChristmas = {
    prefix: 'fasl',
    iconName: 'star-christmas',
    icon: [
      512,
      512,
      [],
      'f7d4',
      
      'M217.3 294.7l-15.2-5.1L101.2 256l100.9-33.6 15.2-5.1 5.1-15.2L256 101.2l33.6 100.9 5.1 15.2 15.2 5.1L410.8 256 309.9 289.6l-15.2 5.1-5.1 15.2L256 410.8 222.4 309.9l-5.1-15.2zM50.6 272.9L192 320l47.1 141.4L256 512l16.9-50.6L320 320l141.4-47.1L512 256l-50.6-16.9L320 192 272.9 50.6 256 0 239.1 50.6 192 192 50.6 239.1 0 256l50.6 16.9zM454.6 80L432 57.4 420.7 68.7l-64 64L345.4 144 368 166.6l11.3-11.3 64-64L454.6 80zM91.3 68.7L80 57.4 57.4 80 68.7 91.3l64 64L144 166.6 166.6 144l-11.3-11.3-64-64zM166.6 368L144 345.4l-11.3 11.3-64 64L57.4 432 80 454.6l11.3-11.3 64-64L166.6 368zm212.7-11.3L368 345.4 345.4 368l11.3 11.3 64 64L432 454.6 454.6 432l-11.3-11.3-64-64z'
      
    ]
  };

  

  
  

  var faCircleC = {
    prefix: 'fasl',
    iconName: 'circle-c',
    icon: [
      512,
      512,
      [],
      'e101',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 256c0-53 43-96 96-96c31.4 0 59.3 15.1 76.8 38.5l25.6-19.2C335.1 148.2 297.9 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c41.9 0 79.1-20.2 102.4-51.3l-25.6-19.2C315.3 336.9 287.4 352 256 352c-53 0-96-43-96-96z'
      
    ]
  };

  

  
  

  var faBoxTissue = {
    prefix: 'fasl',
    iconName: 'box-tissue',
    icon: [
      512,
      512,
      [],
      'e05b',
      
      'M96.8 0H208c40 0 52 24 64 48s24 48 64 48h78.3H448l-10.7 32-32 96-10.7 32-16 48H416v32H96V304h35.6l-10.7-48-7.1-32L71.1 32 64 0H96.8zM344.9 304l58.7-176H336c-27.4 0-48.5-8.6-64.5-23.8c-13.7-13-21.9-29.4-27.4-40.4l-.7-1.5c-6.5-13-10.2-19.6-14.9-24.1c-3-2.8-7.9-6.2-20.5-6.2H103.9l60.4 272H344.9zM480 256H428.4l10.7-32H480h32v32V480v32H480 32 0V480 256 224H32 81l7.1 32H32V384H480V256zm0 160H32v64H480V416z'
      
    ]
  };

  

  
  

  var faMicrophoneSlash = {
    prefix: 'fasl',
    iconName: 'microphone-slash',
    icon: [
      640,
      512,
      [],
      'f131',
      
      'M474.8 296.7c3.4-13 5.2-26.6 5.2-40.7V208 192H448v16 48c0 6.3-.5 12.4-1.3 18.5l28.1 22.2zM416 250.2V32 0H384 256 224V32 98.7l32 25.3V32H384V225l32 25.3zM192 236.5l-32-25.3V256c0 83 63.1 151.2 144 159.2V480H240 224v32h16 80 80 16V480H400 336V415.2c21.3-2.1 41.4-8.4 59.5-18.1l-28.1-22.2c-14.7 5.8-30.6 9.1-47.4 9.1c-70.7 0-128-57.3-128-128V236.5zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faBinoculars = {
    prefix: 'fasl',
    iconName: 'binoculars',
    icon: [
      512,
      512,
      [],
      'f1e5',
      
      'M112 32H96V64h16 64 16V32H176 112zm224 0H320V64h16 64 16V32H400 336zM75.4 240.5l3.5-5.8 .8-6.7L92.2 128H192v16V272 448H32V312.9l43.4-72.4zM224 256V160h64v96H224zM288 96v32H224V96H192 64L48 224 0 304V448v32H32 192h32V448 288h64V448v32h32H480h32V448 304l-48-80L448 96H320 288zm32 352V272 144 128h99.8l12.5 100 .8 6.7 3.5 5.8L480 312.9V448H320z'
      
    ]
  };

  

  
  

  var faTruckRamp = {
    prefix: 'fasl',
    iconName: 'truck-ramp',
    icon: [
      640,
      512,
      [],
      'f4e0',
      
      'M368 0H352V16 384v2.9L20 472.5l-15.5 4 8 31 15.5-4L416.1 403.4C417.8 463.7 467.3 512 528 512c61.9 0 112-50.1 112-112s-50.1-112-112-112c-51.2 0-94.4 34.4-107.7 81.3l-.3 .1-36 9.3V32H624h16V0H624 368zM528 320a80 80 0 1 1 0 160 80 80 0 1 1 0-160z'
      
    ]
  };

  

  
  

  var faMusicSlash = {
    prefix: 'fasl',
    iconName: 'music-slash',
    icon: [
      640,
      512,
      [],
      'f8d1',
      
      'M575.5 376.2c.3-2.7 .5-5.4 .5-8.2v0V136 24 2.5L555.4 8.7l-320 96-2.8 .8 30.7 24.2L544 45.5v78.9L340.4 190.6l30.2 23.8L544 158V308.4c-17-12.7-39.4-20.4-64-20.4c-5.1 0-10.1 .3-15 1l48 37.9c9.7 4.5 17.2 10.7 22.4 17.7l40.1 31.7zM256 287l-32-25.3V372.4c-17-12.7-39.4-20.4-64-20.4c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80v0V287zm-96 97c41.1 0 64 26.7 64 48v0c0 21.3-22.9 48-64 48s-64-26.7-64-48s22.9-48 64-48zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faTrillium = {
    prefix: 'fasl',
    iconName: 'trillium',
    icon: [
      448,
      512,
      [],
      'e588',
      
      'M160 219l-16 9.2-35.1 20.3c-24.7 14.3-44 46.1-57.5 80.5c-4.7 11.9-8.3 23.3-11 32.9c9.7 2.5 21.4 5 34 6.9c36.5 5.6 73.7 4.8 98.4-9.5L208 339.1l16-9.2 16 9.2 35.1 20.3c24.7 14.3 62 15.1 98.4 9.5c12.6-1.9 24.3-4.5 34-6.9c-2.7-9.6-6.3-21-11-32.9c-13.4-34.4-32.7-66.2-57.5-80.5L304 228.3 288 219V200.6 160c0-28.5-17.9-61.2-41-90c-8-10-16-18.8-23-26c-7 7.2-15 16-23 26c-23.1 28.8-41 61.5-41 90v40.6V219zm-32-18.5V160C128 80 224 0 224 0s96 80 96 160v40.6l35.1 20.3c69.3 40 90.6 163.1 90.6 163.1s-117.3 43.1-186.6 3.1L224 366.9l-35.1 20.3C119.6 427.1 2.3 384 2.3 384s21.3-123.1 90.6-163.1L128 200.6zM-4 120.5s35.7-22.3 105.1 1.9c-2.8 10.5-4.5 21.2-5 32.2C70 144.7 50.3 142.7 37 143.1c-.5 0-1.1 0-1.6 .1c.2 .5 .5 .9 .7 1.4c6.2 11.7 17.7 27.7 39.1 45.2c-9.1 6.1-17.4 13.2-24.9 20.9C-5.5 162.6-4 120.5-4 120.5zM203.9 410.6c4.6 26.2 12.4 43.6 19.3 54.6c.3 .5 .6 .9 .8 1.3c.3-.4 .6-.9 .8-1.3c6.9-11 14.7-28.4 19.3-54.6c9.8 4.9 20 8.6 30.4 11.3C260.5 492.6 224 512 224 512s-36.5-19.4-50.6-90.2c10.4-2.7 20.7-6.4 30.4-11.3zm170-220c21.9-17.8 33.6-34.1 40-45.9c.2-.5 .5-.9 .7-1.4c-.5 0-1 0-1.6-.1c-13.7-.5-34 1.6-61.1 12.2c-.4-11-2.1-21.8-4.8-32.3c70.6-25.2 106.9-2.5 106.9-2.5s1.5 42.7-55.4 91.2c-7.4-7.8-15.6-14.9-24.7-21.1zM200 256a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 56a56 56 0 1 1 0-112 56 56 0 1 1 0 112z'
      
    ]
  };

  

  
  

  var faBrowsers = {
    prefix: 'fasl',
    iconName: 'browsers',
    icon: [
      576,
      512,
      [],
      'e0cb',
      
      'M544 32V96H256V32H544zM128 32h96V96H128V32zm0 352V128H240 544V384H128zM128 0H96V32 384v32h32H544h32V384 32 0H544 128zM32 112V96H0v16V496v16H16 464h16V480H464 32V112z'
      
    ]
  };

  

  
  

  var faSprinklerCeiling = {
    prefix: 'fasl',
    iconName: 'sprinkler-ceiling',
    icon: [
      384,
      512,
      [],
      'e44c',
      
      'M0 0H32V83.8L128 110v33.2L11.8 111.4 0 108.2V96 0zM256 110l96-26.2V0h32V96v12.2l-11.8 3.2L256 143.1V110zM208 32V48 224h96 16v32H304 192 80 64V224H80h96V48 32h32zM144 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-32 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM0 464a16 16 0 1 1 32 0A16 16 0 1 1 0 464z'
      
    ]
  };

  

  
  

  var faGavel = {
    prefix: 'fasl',
    iconName: 'gavel',
    icon: [
      512,
      512,
      ["legal"],
      'f0e3',
      
      'M318.6 24L307.3 35.3 294.6 48 464 217.4l12.7-12.7L488 193.4 510.6 216l-11.3 11.3-24 24-96 96-24 24L344 382.6 321.4 360l11.3-11.3L345.4 336 176 166.6l-12.7 12.7L152 190.6 129.4 168l11.3-11.3 24-24 96-96 24-24L296 1.4 318.6 24zm-120 120L368 313.4 441.4 240 272 70.6 198.6 144zm-80 345.4L96 512 73.4 489.4 22.6 438.6 0 416l22.6-22.6 98.7-98.7L144 272l22.6 22.6 14.1 14.1 40.4-40.4 22.6 22.6-40.4 40.4 14.1 14.1L240 368l-22.6 22.6-98.7 98.7zM194.7 368L144 317.3 45.3 416 96 466.7 194.7 368z'
      
    ]
  };

  
    var faLegal = faGavel;
  

  
  

  var faReflectBoth = {
    prefix: 'fasl',
    iconName: 'reflect-both',
    icon: [
      512,
      512,
      [],
      'e66f',
      
      'M278.6 169.4L256 192l-22.6-22.6L96 32 96 0l32 0L384 0l32 0 0 32L278.6 169.4zM370.7 32L141.3 32 256 146.7 370.7 32zM192 256l-22.6 22.6L32 416 0 416l0-32L0 128 0 96l32 0L169.4 233.4 192 256zm-45.3 0L32 141.3l0 229.5L146.7 256zM320 256l22.6-22.6L480 96l32 0 0 32 0 256 0 32-32 0L342.6 278.6 320 256zm45.3 0L480 370.7l0-229.5L365.3 256zM256 320l22.6 22.6L416 480l0 32-32 0-256 0-32 0 0-32L233.4 342.6 256 320zm0 45.3L141.3 480l229.5 0L256 365.3z'
      
    ]
  };

  

  
  

  var faTrashClock = {
    prefix: 'fasl',
    iconName: 'trash-clock',
    icon: [
      576,
      512,
      [],
      'e2b0',
      
      'M151.1 0H160 288h8.9l4.7 7.5L336.9 64h47.1H416h32V96H413.7l-7 97.8c-11.3 1.6-22.2 4.3-32.6 8L381.6 96H66.4L93.8 480H296.2c10 12.1 21.7 22.9 34.6 32H64L34.3 96H0V64H32 64.1h47.1L146.4 7.5 151.1 0zm-2.3 64H299.1l-20-32H168.9l-20 32zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 64v16 48h32 16v32H480 432 416V368 304 288h32z'
      
    ]
  };

  

  
  

  var faCartCircleArrowUp = {
    prefix: 'fasl',
    iconName: 'cart-circle-arrow-up',
    icon: [
      640,
      512,
      [],
      'e3f0',
      
      'M16 0H0V32H16 67.2l77.2 339.5 2.8 12.5H160 320.7c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32H151L107.3 64H532.5l-40 128c1.2 0 2.4 0 3.5 0c10 0 19.7 .8 29.2 2.4L566 64l10-32H542.5 100L95.6 12.5 92.8 0H80 16zM184 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM384 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-222.6-8L440 382.6l11.3-11.3L480 342.6V432v16h32V432 342.6l28.7 28.7L552 382.6 574.6 360l-11.3-11.3-56-56L496 281.4l-11.3 11.3-56 56L417.4 360z'
      
    ]
  };

  

  
  

  var faTentArrowLeftRight = {
    prefix: 'fasl',
    iconName: 'tent-arrow-left-right',
    icon: [
      576,
      512,
      [],
      'e57f',
      
      'M562.8 84.2l13 11.8-13 11.8-88 80-21.5-23.7L510.6 112 65.4 112l57.4 52.2-21.5 23.7-88-80L.2 96l13-11.8 88-80 21.5 23.7L65.4 80l445.2 0L453.2 27.8 474.8 4.2l88 80zM96.3 512H64l4.6-32L96 288 288 160 480 288l27.4 192 4.6 32H479.7 96.3zm269-32L304 377.8V480h61.3zM272 320.3c0-.2 0-.4 0-.6V209.1L125.7 306.7 100.9 480H272V320.3zm178.3-13.6L304 209.1V315.6l93.7 156.2 4.9 8.2h72.4L450.3 306.7z'
      
    ]
  };

  

  
  

  var faChfSign = {
    prefix: 'fasl',
    iconName: 'chf-sign',
    icon: [
      640,
      512,
      [],
      'e602',
      
      'M80 32C35.8 32 0 67.8 0 112V400c0 44.2 35.8 80 80 80s80-35.8 80-80V384H128v16c0 26.5-21.5 48-48 48s-48-21.5-48-48V112c0-26.5 21.5-48 48-48s48 21.5 48 48v16h32V112c0-44.2-35.8-80-80-80zM224 48V32H192V48 464v16h32V464 256H384V464v16h32V464 48 32H384V48 224H224V48zM464 32H448V48 464v16h32V464 256H592h16V224H592 480V64H624h16V32H624 464z'
      
    ]
  };

  

  
  

  var faMicrowave = {
    prefix: 'fasl',
    iconName: 'microwave',
    icon: [
      576,
      512,
      [],
      'e01b',
      
      'M544 64V416H512 480 96 64 32V64H544zM512 448h32 32V416 64 32H544 32 0V64 416v32H32 64v32H96V448H480v32h32V448zM464 112V368h32V112H464zM128 160H384V320H128V160zM96 128v32V320v32h32H384h32V320 160 128H384 128 96z'
      
    ]
  };

  

  
  

  var faHospitalUser = {
    prefix: 'fasl',
    iconName: 'hospital-user',
    icon: [
      576,
      512,
      [],
      'f80d',
      
      'M0 0H16 304h16V16 359l-32 73.1V32H32V288H144h16v32H144 32v64H144h16v32H144 32v64H267.1l-14 32H16 0V496 416 384 320 288 16 0zM344 384h20.9H432h67.1H520l8.4 19.2 28 64L562 480l14 32H541.1h-14H336.9h-14H288l14-32 5.6-12.8 28-64L344 384zm183.1 96l-14-32-14-32H364.9l-14 32-14 32h34.9H492.1h34.9zM352 272a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm128 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM136 80h48 16V96v24h24 16v16 48 16H224 200v24 16H184 136 120V224 200H96 80V184 136 120H96h24V96 80h16zm16 56v16H136 112v16h24 16v16 24h16V184 168h16 24V152H184 168V136 112H152v24z'
      
    ]
  };

  

  
  

  var faFaceFlushed = {
    prefix: 'fasl',
    iconName: 'face-flushed',
    icon: [
      512,
      512,
      [128563,"flushed"],
      'f579',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160.4-56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM192 368H320h16v32H320 192 176V368h16zm-32-96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm240 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  
    var faFlushed = faFaceFlushed;
  

  
  

  var faSquare3 = {
    prefix: 'fasl',
    iconName: 'square-3',
    icon: [
      448,
      512,
      [],
      'e258',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM304 151.4l-5.6 4.8-78.9 67.6 19.9-.1c44.4-.2 80.6 35.7 80.6 80.2c0 44.3-35.9 80.2-80.2 80.2h-36c-27.6 0-53.5-13-70.1-35l-2.5-3.4-9.6-12.8 25.6-19.2 9.6 12.8 2.5 3.4c10.5 14 27 22.2 44.5 22.2h36c26.6 0 48.2-21.6 48.2-48.2c0-26.7-21.7-48.3-48.4-48.2l-63.5 .3-16.1 .1V232.6l5.6-4.8L244.7 160H144 128V128h16H288h16v23.4z'
      
    ]
  };

  

  
  

  var faTrowelBricks = {
    prefix: 'fasl',
    iconName: 'trowel-bricks',
    icon: [
      512,
      512,
      [],
      'e58a',
      
      'M61.1 128l156 96H224V32h-6.9l-156 96zM30.5 146.8L0 128l30.5-18.8L208 0h16 32V32v80l88 0V80h32H480h32v32 32 32H480 376 344V144l-88 0v80 32H224 208L30.5 146.8zM480 112H376v32H480V112zM288 352V320 256 224h32H480h32v32 96 72 56 32H480 32 0V480 384 352H32 256h32zm32 0H480V256H320v96zm0 32H304 288 256v96H480V424 384H320zm-96 0H32v96H224V384z'
      
    ]
  };

  

  
  

  var faCloud = {
    prefix: 'fasl',
    iconName: 'cloud',
    icon: [
      640,
      512,
      [9729],
      'f0c2',
      
      'M544 259.6l16 9.2c28.8 16.6 48 47.7 48 83.2v96H512 144 32V336c0-48.7 31.1-90.2 74.7-105.6l21.3-7.5V200.2 192c0-70.7 57.3-128 128-128c45.1 0 84.8 23.3 107.6 58.7l14.2 22 24.3-9.5c11.7-4.6 24.4-7.1 37.9-7.1c57.4 0 104 46.6 104 104v9.1 18.5zM96 200.2C40.1 220 0 273.3 0 336V448v32H32 144 512h96 32V448 352c0-47.4-25.7-88.7-64-110.9V232c0-75.1-60.9-136-136-136c-17.5 0-34.2 3.3-49.5 9.3C362 61.2 312.4 32 256 32C167.6 32 96 103.6 96 192v8.2z'
      
    ]
  };

  

  
  

  var faMessageQuestion = {
    prefix: 'fasl',
    iconName: 'message-question',
    icon: [
      512,
      512,
      [],
      'e1e3',
      
      'M160 416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448 416zm0-32h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zm8-248c0-30.9 25.1-56 56-56h56c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L272 220.3V224v16H240V224 210.5v-9.8l8.7-4.5 45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H224c-13.3 0-24 10.7-24 24v8H168v-8zm64 136h48v48H232V272z'
      
    ]
  };

  

  
  

  var faPaw = {
    prefix: 'fasl',
    iconName: 'paw',
    icon: [
      512,
      512,
      [],
      'f1b0',
      
      'M196.1 103c5.2 15.5 4.7 29.9 1.2 40.2c-3.5 10.3-9 14.6-13.4 16.1c-4.5 1.5-11.7 1.2-20.8-5.1s-18.2-17.6-23.3-33.1s-4.7-29.9-1.2-40.2c3.5-10.3 9-14.6 13.4-16.1c4.5-1.5 11.7-1.2 20.8 5.1s18.2 17.6 23.3 33.1zm30.4-10.1C212.2 50 174.4 23.8 142.1 34.3s-46.9 53.9-32.6 96.8s52.1 69.1 84.4 58.5s46.9-53.9 32.6-96.8zM79.8 243.7c-.9 7.6-3.9 10.4-5.5 11.3c-1.6 .9-5.7 2.2-13-.9s-15.7-9.9-22-20.7s-8-21.4-7-29c.9-7.6 3.9-10.4 5.5-11.3c1.6-.9 5.7-2.2 13 .9s15.7 9.9 22 20.7s8 21.4 7 29zm10.4 39c24.5-14 29.1-51.7 10.2-84.1s-54-47.3-78.5-33.3s-29.1 51.7-10.2 84.1s54 47.3 78.5 33.3zm342.1-39c-.9-7.7 .8-18.2 7-29s14.7-17.6 22-20.7s11.4-1.8 13-.9c1.6 .9 4.6 3.7 5.5 11.3c.9 7.7-.8 18.2-7 29s-14.7 17.6-22 20.7s-11.4 1.8-13 .9c-1.6-.9-4.6-3.7-5.5-11.3zm-10.4 39c24.5 14 59.7-.9 78.5-33.3s14.3-70.1-10.2-84.1s-59.7 .9-78.5 33.3s-14.3 70.1 10.2 84.1zM306.6 143.2c-3.5-10.3-4-24.7 1.2-40.2s14.2-26.8 23.3-33.1s16.3-6.6 20.8-5.1c4.4 1.5 9.9 5.8 13.4 16.1c3.5 10.3 4 24.7-1.2 40.2s-14.2 26.8-23.3 33.1s-16.3 6.6-20.8 5.1c-4.4-1.5-9.9-5.8-13.4-16.1zm3.5 46.5c32.3 10.6 70.1-15.6 84.4-58.5s-.3-86.2-32.6-96.8S291.8 50 277.5 92.9s.3 86.2 32.6 96.8zM263.8 401L256 399l-7.8 1.9L98.8 438.3c8-58 32.3-100.8 60.4-130.2C194.8 270.7 234.9 256 256 256s61.2 14.7 96.8 52.1c28.1 29.5 52.4 72.3 60.4 130.2L263.8 401zM64 480l32.1-8L256 432l159.9 40 32.1 8c0-11.5-.6-22.7-1.6-33.4C431.5 293.9 315.8 224 256 224s-175.5 69.9-190.4 222.6c-1 10.7-1.6 21.8-1.6 33.4z'
      
    ]
  };

  

  
  

  var faTabletScreenButton = {
    prefix: 'fasl',
    iconName: 'tablet-screen-button',
    icon: [
      448,
      512,
      ["tablet-alt"],
      'f3fa',
      
      'M416 32V320H32V32H416zm0 320V480H32V352H416zM32 0H0V32 480v32H32 416h32V480 32 0H416 32zM248 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faTabletAlt = faTabletScreenButton;
  

  
  

  var faCircleNotch = {
    prefix: 'fasl',
    iconName: 'circle-notch',
    icon: [
      512,
      512,
      [],
      'f1ce',
      
      'M196.3 40C101.5 66.2 32 153 32 256c0 123.7 100.3 224 224 224s224-100.3 224-224C480 153 410.5 66.2 315.7 40l8.5-30.8C432.5 39.1 512 138.2 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 138.2 79.5 39.1 187.7 9.2L196.3 40z'
      
    ]
  };

  

  
  

  var faRainbow = {
    prefix: 'fasl',
    iconName: 'rainbow',
    icon: [
      640,
      512,
      [127752],
      'f75b',
      
      'M320 64C160.9 64 32 192.9 32 352V464v16H0V464 352C0 175.3 143.3 32 320 32s320 143.3 320 320V464v16H608V464 352C608 192.9 479.1 64 320 64zm0 192c-53 0-96 43-96 96V464v16H192V464 352c0-70.7 57.3-128 128-128s128 57.3 128 128V464v16H416V464 352c0-53-43-96-96-96zM128 352V464v16H96V464 352c0-123.7 100.3-224 224-224s224 100.3 224 224V464v16H512V464 352c0-106-86-192-192-192s-192 86-192 192z'
      
    ]
  };

  

  
  

  var faEarthAfrica = {
    prefix: 'fasl',
    iconName: 'earth-africa',
    icon: [
      512,
      512,
      [127757,"globe-africa"],
      'f57c',
      
      'M480 256c0-10.9-.8-21.5-2.3-32H384v9.4l27.3 27.3 4.7 4.7V272v64 16H400 368v32 6.6l-4.7 4.7-48 48-4.7 4.7H304 256 240V432 352H160 144V336 248v-6.6l4.7-4.7 40-40 4.7-4.7H200h80.3L304 162.4V128H262.6l-27.3 27.3-4.7 4.7H224 192 176V144 46.7C91.8 78.9 32 160.5 32 256c0 123.7 100.3 224 224 224s224-100.3 224-224zm-9.3-64C443.2 99.5 357.5 32 256 32c-16.5 0-32.5 1.8-48 5.2V128h9.4l27.3-27.3 4.7-4.7H256h64 16v16 56 5.6l-3.5 4.4-32 40-4.8 6H288 206.6L176 254.6V320h80 16v16 80h25.4L336 377.4V336 320h16 32V278.6l-27.3-27.3-4.7-4.7V240 208 192h16H470.7zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faGlobeAfrica = faEarthAfrica;
  

  
  

  var faElephant = {
    prefix: 'fasl',
    iconName: 'elephant',
    icon: [
      640,
      512,
      [128024],
      'f6da',
      
      'M208 0H192V16 34.7C101.2 49.9 32 128.9 32 224v40 0l0 58.4L3.5 358l25 20 32-40 3.5-4.4 0-5.6 0-64v0V224c0-77.4 55-142 128-156.8v44.5c0 58.2 44.6 106.8 102.7 111.6l8 .7 2.7-31.9-8-.7c-41.5-3.5-73.4-38.1-73.4-79.7V32h79.7c41.6 0 76.3 31.9 79.7 73.4l.7 8 31.9-2.7-.7-8c-1.1-13.1-4.4-25.5-9.5-36.9C466.1 76.2 512 128.7 512 192V319.8c13-.8 23.6-3.6 32-7.7V192c0-88.4-71.6-160-160-160h-2C361.8 12.1 334 0 303.7 0H208zM504 384c36.6 0 73.4-10.3 99.4-36.8l-22.9-22.4c-18 18.4-45.3 27.2-76.6 27.2c-20.5 0-35.4-3.6-48.6-11.7c-13.5-8.3-26.7-22.1-42.1-45.2L384 304V480H320V379.9 349.3l-25.2 17.5C279.3 377.6 260.4 384 240 384s-39.3-6.4-54.8-17.2L160 349.3v30.7V480H96V368 352H64v16V496v16H80h96 16V496 406.7c14.8 6 31 9.3 48 9.3s33.2-3.3 48-9.3V496v16h16 96 16V496 349.6c7.2 7.2 14.7 13.2 22.8 18.1c3 1.9 6.1 3.5 9.2 5v10.4c0 53.5 43.4 96.9 96.9 96.9c44.4 0 83.2-30.2 94-73.4l.7-2.7-31-7.8-.7 2.7c-7.2 28.9-33.2 49.1-62.9 49.1C509 448 480 419 480 383.1v-.8c7.6 1.1 15.6 1.7 24 1.7zM480 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faSquareB = {
    prefix: 'fasl',
    iconName: 'square-b',
    icon: [
      448,
      512,
      [],
      'e264',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm128 96h16H248c39.8 0 72 32.2 72 72c0 19.3-7.6 36.8-19.9 49.7C321.6 262.2 336 285.4 336 312c0 39.8-32.2 72-72 72H144 128V368 256 144 128zm160 72c0-22.1-17.9-40-40-40H160v80h88c22.1 0 40-17.9 40-40zM160 352H264c22.1 0 40-17.9 40-40s-17.9-40-40-40H248 160v80z'
      
    ]
  };

  

  
  

  var faCodePullRequestDraft = {
    prefix: 'fasl',
    iconName: 'code-pull-request-draft',
    icon: [
      448,
      512,
      [],
      'e3fa',
      
      'M32 32v96h96V32H32zM0 0H32h96 32V32v96 32H128 96V352h32 32v32 96 32H128 32 0V480 384 352H32 64V160H32 0V128 32 0zM336 32h32 32V64 96H368 336V64 32zm80 352H320v96h96V384zM288 352h32 96 32v32 96 32H416 320 288V480 384 352zm80-160h32v32 32H368 336V224 192h32zM128 384H32v96h96V384z'
      
    ]
  };

  

  
  

  var faW = {
    prefix: 'fasl',
    iconName: 'w',
    icon: [
      576,
      512,
      [119],
      '57',
      
      'M541.5 32h33.9L423.1 469.3 419.4 480H396l-3.3-11.6L288 105.7 183.4 468.4 180 480H156.6l-3.7-10.7L.6 32H34.5L166.6 411.2 272.6 43.6 276 32H300l3.3 11.6L409.4 411.2 541.5 32z'
      
    ]
  };

  

  
  

  var faGiftCard = {
    prefix: 'fasl',
    iconName: 'gift-card',
    icon: [
      576,
      512,
      [],
      'f663',
      
      'M397.1 32c-17.6 0-33.9 9-43.2 23.9l-45 72.1H320h80c26.5 0 48-21.5 48-48s-21.5-48-48-48h-2.9zm-130 96l-45-72.1C212.8 41 196.5 32 178.9 32H176c-26.5 0-48 21.5-48 48s21.5 48 48 48h80 11.1zM288 101l38.8-62c15.1-24.2 41.7-39 70.3-39H400c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48h80 32v32V480v32H544 32 0V480 160 128H32h80c-10-13.4-16-30-16-48c0-44.2 35.8-80 80-80h2.9c28.6 0 55.2 14.7 70.3 39L288 101zM176 160H32V288H544V160H400 322.2l58.1 69.8L390.5 242 366 262.5l-10.2-12.3L288 169l-67.7 81.3L210 262.5 185.5 242l10.2-12.3L253.8 160H176zM32 320v64H544V320H32zM544 480V416H32v64H544z'
      
    ]
  };

  

  
  

  var faTruckMonster = {
    prefix: 'fasl',
    iconName: 'truck-monster',
    icon: [
      640,
      512,
      [],
      'f63b',
      
      'M224 0h16H392h7.6l4.8 5.9L503.6 128H592h16v16 96h-1c4.4 3.9 8.6 8 12.6 12.2l11 11.6-23.3 22-11-11.6C567.2 243.3 525.8 224 480 224c-56.2 0-105.6 28.9-134.1 72.7l-4.7 7.3h-8.7H307.5h-8.7l-4.7-7.3C265.6 252.9 216.2 224 160 224c-45.8 0-87.2 19.3-116.4 50.2l-11 11.6-23.3-22 11-11.6c3.7-3.9 7.6-7.7 11.6-11.3V144 128H48 224V16 0zM64 217.7c28.2-16.3 61-25.7 96-25.7c64.3 0 121.1 31.6 156 80H324c34.8-48.4 91.7-80 156-80c35 0 67.8 9.4 96 25.7V160H496.1h-.3H240 64v57.7zM384.4 32H256v96H462.4l-78-96zm4.7 442.1C366.2 451 352 419.1 352 384c0-70.7 57.3-128 128-128s128 57.3 128 128c0 35.3-14.3 67.3-37.4 90.4l-.2 .2C547.3 497.7 515.3 512 480 512c-35.1 0-67-14.2-90.1-37.1l-.8-.8zm9.3-144.2l3.3 3.3 7.8 7.8-4.4 10c-.5 1.1-1 2.3-1.4 3.4l-4 10.2h-11H384v38.9h4.6 11l4 10.2c.4 1.1 .9 2.3 1.4 3.4l4.4 10-7.8 7.7-3.3 3.3 27.5 27.5 3.3-3.3 7.8-7.8 10 4.4c1.1 .5 2.3 1 3.4 1.4l10.2 4v11V480h38.9v-4.6-11l10.2-4c1.1-.4 2.3-.9 3.4-1.4l10-4.4 7.8 7.8 3.3 3.3 27.5-27.5-3.3-3.3-7.7-7.7 4.4-10c.5-1.1 1-2.3 1.4-3.4l4-10.2h11H576V364.5h-4.6-11l-4-10.2c-.4-1.1-.9-2.3-1.4-3.4l-4.4-10 7.8-7.8 3.3-3.3-27.5-27.5-3.3 3.3-7.7 7.7-10-4.4c-1.1-.5-2.3-1-3.4-1.4l-10.2-4v-11V288H460.5v4.6 11l-10.2 4c-1.1 .4-2.3 .9-3.4 1.4l-10 4.4-7.7-7.7-3.3-3.3-27.5 27.5zM461 384a19 19 0 1 0 38 0 19 19 0 1 0 -38 0zm19 51a51 51 0 1 1 0-102 51 51 0 1 1 0 102zM32 384c0-70.7 57.3-128 128-128s128 57.3 128 128c0 35.3-14.3 67.3-37.4 90.4l-.1 .2C227.3 497.7 195.3 512 160 512c-35.1 0-67-14.2-90.1-37.1l-.8-.8C46.2 451 32 419.1 32 384zm73.9-81.6L78.4 329.9l3.3 3.3 7.8 7.8-4.4 10c-.5 1.1-1 2.3-1.4 3.4l-4 10.2h-11H64v38.9h4.6 11l4 10.2c.4 1.1 .9 2.3 1.4 3.4l4.4 10-7.7 7.7-3.3 3.3 27.5 27.5 3.3-3.3 7.7-7.8 10 4.4c1.1 .5 2.3 1 3.4 1.4l10.2 4v11V480h38.9v-4.6-11l10.2-4c1.1-.4 2.3-.9 3.4-1.4l10-4.4 7.8 7.8 3.3 3.3 27.5-27.5-3.3-3.3-7.7-7.7 4.4-10c.5-1.1 1-2.3 1.4-3.4l4-10.2h11H256V364.5h-4.6-11l-4-10.2c-.4-1.1-.9-2.3-1.4-3.4l-4.4-10 7.7-7.8 3.3-3.3-27.5-27.5-3.3 3.3-7.7 7.7-10-4.4c-1.1-.5-2.3-1-3.4-1.4l-10.2-4v-11V288H140.5v4.6 11l-10.2 4c-1.1 .4-2.3 .9-3.4 1.4l-10 4.4-7.7-7.7-3.3-3.3zM160 365a19 19 0 1 0 0 38 19 19 0 1 0 0-38zm51 19a51 51 0 1 1 -102 0 51 51 0 1 1 102 0z'
      
    ]
  };

  

  
  

  var faScarecrow = {
    prefix: 'fasl',
    iconName: 'scarecrow',
    icon: [
      448,
      512,
      [],
      'f70d',
      
      'M224 176a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0 32c-36.8 0-69.2-19.1-87.7-48H69.9l7.4 11.1-11 9.2L52.2 192l14 11.7 11 9.2L69.9 224H144h19.5l-3.8 19.1L134.6 368.7l25.5-14.6 7.9-4.5 7.9 4.5L224 381.6l48.1-27.5 7.9-4.5 7.9 4.5 25.5 14.6L288.3 243.1 284.5 224H304h74.1l-7.4-11.1 11-9.2L395.8 192l-14.1-11.7-11-9.2 7.4-11.1H311.7c-18.5 28.9-50.8 48-87.7 48zM328 104c0 8.3-1 16.3-2.8 24H408h29.9l-16.6 24.9-8 12L431 179.7 445.8 192 431 204.3l-17.8 14.8 8 12L437.9 256H408 323.5l28.2 140.9 6.9 34.5-30.5-17.4L280 386.4l-48.1 27.5-7.9 4.5-7.9-4.5L168 386.4l-48.1 27.5L89.4 431.3l6.9-34.5L124.5 256H40 10.1l16.6-24.9 8-12L17 204.3 2.2 192 17 179.7l17.8-14.8-8-12L10.1 128H40h82.8c-1.8-7.7-2.8-15.7-2.8-24C120 46.6 166.6 0 224 0s104 46.6 104 104zM208 496V446.1l16 9.1 16-9.1V496v16H208V496zM176 88a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faAlarmSnooze = {
    prefix: 'fasl',
    iconName: 'alarm-snooze',
    icon: [
      512,
      512,
      [],
      'f845',
      
      'M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5l27-17.2c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1l21.8-23.5C138.4 9.3 116.4 0 92.2 0zM357.1 24.6l21.8 23.5C389.6 38.1 404 32 419.8 32C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3l27 17.2c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM67.3 499.3l42-42C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l42 42L456 510.6 478.6 488l-11.3-11.3-42-42C459.4 395.4 480 344.1 480 288C480 164.3 379.7 64 256 64S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-42 42L33.4 488 56 510.6l11.3-11.3zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm-64 96H176v32h16 83.7L194.3 359.8 179.7 384H208 320h16V352H320 236.3l81.5-135.8L332.3 192H304 192z'
      
    ]
  };

  

  
  

  var faSprayCan = {
    prefix: 'fasl',
    iconName: 'spray-can',
    icon: [
      512,
      512,
      [],
      'f5bd',
      
      'M192 32V96h32V32 0H192 128 96V32 96h32V32h64zm32 128c35.3 0 64 28.7 64 64V480H32V224c0-35.3 28.7-64 64-64h32 64 32zm64-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM96 128c-53 0-96 43-96 96V480v32H32 288h32V480 224c0-53-43-96-96-96H192 128 96zm64 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM408 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM480 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM408 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faShishKebab = {
    prefix: 'fasl',
    iconName: 'shish-kebab',
    icon: [
      512,
      512,
      [],
      'f821',
      
      'M416 32c-35.3 0-64 28.7-64 64c0 17.7 7.1 33.7 18.7 45.3l11.3 11.3-11.3 11.3-31.4 31.4 62.1 62.1L424 280l-22.6 22.6L320 384l-1.4 1.4-21.3 21.3L296 408l-81.4 81.4L192 512l-22.6-22.6-62.1-62.1-80 80L4.7 484.7l80-80L22.6 342.6 0 320l22.6-22.6L104 216l1.4-1.4 21.3-21.3L128 192l81.4-81.4L232 88l22.6 22.6 62.1 62.1 21.1-21.1C326.6 135.9 320 116.7 320 96c0-53 43-96 96-96s96 43 96 96c0 21.6-7.2 41.6-19.2 57.6l-25.6-19.2c8-10.7 12.8-24 12.8-38.4c0-35.3-28.7-64-64-64zM297.4 361.4L378.7 280 232 133.3l-81.4 81.4L297.4 361.4zM126.6 238.6L45.3 320 192 466.7l81.4-81.4L126.6 238.6z'
      
    ]
  };

  

  
  

  var faFaceGrinTongueSquint = {
    prefix: 'fasl',
    iconName: 'face-grin-tongue-squint',
    icon: [
      512,
      512,
      [128541,"grin-tongue-squint"],
      'f58a',
      
      'M256 32C132.3 32 32 132.3 32 256c0 77.2 39.1 145.3 98.6 185.6c3.6 17.6 10.8 33.9 20.8 48.1C62.1 449.7 0 360.1 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 104.1-62.1 193.7-151.3 233.7c10-14.2 17.2-30.5 20.8-48.1C440.9 401.3 480 333.2 480 256C480 132.3 379.7 32 256 32zM393.8 333.9c-10.3 19.3-24.6 36.1-41.8 49.4V416c0 53-43 96-96 96s-96-43-96-96V383.3c-17.1-13.3-31.4-30.1-41.7-49.4c-6.5-12.1-11.4-25.2-14.5-39c11.8 4.6 24.3 8.8 37.2 12.3c35.1 9.6 74 14.9 114.9 14.9s79.9-5.3 114.9-14.9c13-3.5 25.4-7.7 37.2-12.3c-3.1 13.8-8 26.9-14.5 39zm-258.1-144L121.8 182l15.9-27.8 13.9 7.9 56 32L231.9 208l-24.3 13.9-56 32-13.9 7.9L121.8 234l13.9-7.9L167.4 208l-31.7-18.1zM390.2 182l-13.9 7.9L344.6 208l31.7 18.1 13.9 7.9-15.9 27.8-13.9-7.9-56-32L280.1 208l24.3-13.9 56-32 13.9-7.9L390.2 182zM320 416V352H272v24H240V352H192v64c0 35.3 28.7 64 64 64s64-28.7 64-64z'
      
    ]
  };

  
    var faGrinTongueSquint = faFaceGrinTongueSquint;
  

  
  

  var faArrowDown91 = {
    prefix: 'fasl',
    iconName: 'arrow-down-9-1',
    icon: [
      576,
      512,
      ["sort-numeric-desc","sort-numeric-down-alt"],
      'f886',
      
      'M160 478.6l11.3-11.3 88-88L270.6 368 248 345.4l-11.3 11.3L176 417.4V48 32H144V48 417.4L83.3 356.7 72 345.4 49.4 368l11.3 11.3 88 88L160 478.6zM368 320h16 32V448H384 368v32h16 48 48 16V448H480 448V304 288H432 384 368v32zm60-152a52 52 0 1 1 0-104 52 52 0 1 1 0 104zm-84-52c0 46.4 37.6 84 84 84c2 0 3.9-.1 5.8-.2l-42.4 53.5c-.7 .9-1.2 1.7-1.7 2.7h40.4l61.7-77.9c13.1-16.5 20.2-37 20.2-58.1h-.1c.1-1.3 .1-2.7 .1-4c0-46.4-37.6-84-84-84s-84 37.6-84 84z'
      
    ]
  };

  
    var faSortNumericDesc = faArrowDown91;
  
    var faSortNumericDownAlt = faArrowDown91;
  

  
  

  var faCircleCaretDown = {
    prefix: 'fasl',
    iconName: 'circle-caret-down',
    icon: [
      512,
      512,
      ["caret-circle-down"],
      'f32d',
      
      'M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM128 192h32H352h32v32 8L256 352 128 232v-8V192zM256 308.1L345.7 224H166.3L256 308.1z'
      
    ]
  };

  
    var faCaretCircleDown = faCircleCaretDown;
  

  
  

  var faCalendarImage = {
    prefix: 'fasl',
    iconName: 'calendar-image',
    icon: [
      448,
      512,
      [],
      'e0d4',
      
      'M128 0V16 64H320V16 0h32V16 64h64 32V96v64 32V480v32H416 32 0V480 192 160 96 64H32 96V16 0h32zM416 192H32V480H416V192zm0-96H32v64H416V96zM250.9 252.1l13.3 18.6L373 422.7 391.1 448H360 88 57.2l17.7-25.2 68-96.7 11-15.7L167.4 324l20.3 20.7L238 271l12.9-18.9zm.6 55.9l-48.3 70.9-11 16.1L178.6 381l-20.5-20.9L118.8 416H328.9L251.5 307.9zM96 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faCircleM = {
    prefix: 'fasl',
    iconName: 'circle-m',
    icon: [
      512,
      512,
      [],
      'e115',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 144V368v16h32V368 194.8l82.9 118.4L256 331.9l13.1-18.7L352 194.8V368v16h32V368 144 128H359.7l-4.8 6.8L256 276.1 157.1 134.8l-4.8-6.8H128v16z'
      
    ]
  };

  

  
  

  var faDialMax = {
    prefix: 'fasl',
    iconName: 'dial-max',
    icon: [
      576,
      512,
      [],
      'e15e',
      
      'M312 8V56H264V8h48zM120 72v48H72V72h48zm336 0h48v48H456V72zM568 264v48H520V264h48zM8 264H56v48H8V264zM120 456v48H72V456h48zm336 0h48v48H456V456zM299.3 276.7l89.8 89.8c39.1-50.2 35.5-122.8-10.6-169c-50-50-131-50-181 0s-50 131 0 181c46.2 46.2 118.8 49.7 169 10.6l-89.8-89.8L265.4 288 288 265.4l11.3 11.3zM174.9 174.9A160 160 0 1 1 401.1 401.1 160 160 0 1 1 174.9 174.9z'
      
    ]
  };

  

  
  

  var faPersonDrowning = {
    prefix: 'fasl',
    iconName: 'person-drowning',
    icon: [
      576,
      512,
      [],
      'e545',
      
      'M128 208V48h32V195.3l191.7 44.2 172.1-46.9 8.4 30.9L366.5 268.6 353 376.7c-3.3-1.2-6.6-2.6-9.8-4c-7.2-3.3-13.6-7.1-20.5-11.8l11.6-92.5-96.3-22.2L218.5 378.3c-8.9 2.9-18.1 4.8-26.5 4.8c-2.1 0-4.3-.1-6.5-.3l21.3-143.8-66.4-15.3L128 220.7V208zm192-48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM192 448c20.9 0 41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C342.3 438.1 363.1 448 384 448s41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.8 23.1 24.2 37.8 34.2C534.4 438.1 555.1 448 576 448v32c-30.3 0-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.9 9.9-19.8 15.3C441.5 465.9 414.3 480 384 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3c-5.1 4.5-11.8 9.9-19.8 15.3C249.5 465.9 222.3 480 192 480s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3c-5.1 4.5-11.8 9.8-19.8 15.3C57.6 465.9 30.3 480 0 480V448c20.9 0 41.6-9.9 58.2-21.2c14.7-10 25.9-21.5 37.8-34.2c11.9 12.7 23.2 24.3 37.8 34.2C150.3 438.1 171.1 448 192 448z'
      
    ]
  };

  

  
  

  var faGrapes = {
    prefix: 'fasl',
    iconName: 'grapes',
    icon: [
      512,
      512,
      [],
      'e306',
      
      'M352.2 10.3c10.2 6.1 18.8 16.4 25.4 27.3c6.7 11.2 12.2 24.4 15.6 37.9c3.1 12.2 4.8 26.2 3.5 39.8c13.6-1.3 27.6 .4 39.8 3.5c13.5 3.4 26.7 8.9 37.9 15.6c10.9 6.6 21.2 15.1 27.3 25.4l5.8 9.7-7.3 8.7L488 168c12.3 10.2 12.3 10.2 12.3 10.2l0 0 0 0 0 0-.1 .2-.4 .5c-.4 .4-.9 1-1.5 1.7c-1.3 1.5-3.2 3.5-5.5 5.9c-4.7 4.8-11.5 11.3-19.6 17.8c-7 5.6-15.7 11.8-25.4 16.8c-4.1-10-9.7-19.3-16.4-27.6c7.4-3.7 14.8-8.6 21.8-14.2c5.1-4.1 9.7-8.3 13.3-11.8c-2.3-1.9-5.1-3.9-8.4-5.9c-8.3-5-18.6-9.3-29.2-12c-22.8-5.7-40.9-3-49.4 5.5l-22.6-22.6c8.4-8.4 11.2-26.6 5.5-49.4c-2.7-10.7-7-20.9-12-29.2c-2-3.3-3.9-6.1-5.9-8.4c-3.6 3.6-7.7 8.2-11.8 13.3c-5.6 7-10.6 14.4-14.2 21.8c-8.3-6.7-17.6-12.2-27.6-16.4c5-9.7 11.2-18.4 16.8-25.4c6.5-8.1 13-14.9 17.8-19.6c2.4-2.4 4.5-4.2 5.9-5.5c.7-.7 1.3-1.2 1.7-1.5l.5-.4 .2-.1 .1 0 0 0 0 0s0 0 10.2 12.3L333.8 11.7l8.7-7.3 9.7 5.8zM320 456c-18.4 0-35.2-6.9-47.9-18.2c-12.4 25-38.3 42.2-68.1 42.2c-19 0-36.3-7-49.6-18.4C142.6 491.1 113.7 512 80 512c-44.2 0-80-35.8-80-80c0-33.7 20.9-62.6 50.4-74.4C39 344.3 32 327 32 308c0-29.8 17.2-55.7 42.2-68.1C62.9 227.2 56 210.4 56 192c0-39.8 32.2-72 72-72c17.6 0 33.8 6.3 46.3 16.9C186.4 108.1 214.9 88 248 88c44.2 0 80 35.8 80 80c0 6.2-.7 12.2-2 18c5.8-1.3 11.8-2 18-2c44.2 0 80 35.8 80 80c0 33.1-20.1 61.6-48.9 73.7C385.7 350.2 392 366.4 392 384c0 39.8-32.2 72-72 72zM296 168a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128 232a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm144 56a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM108 352a44 44 0 1 0 0-88 44 44 0 1 0 0 88zM80 480a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm124-32a44 44 0 1 0 0-88 44 44 0 1 0 0 88zm156-64a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-16-72a48 48 0 1 0 0-96 48 48 0 1 0 0 96z'
      
    ]
  };

  

  
  

  var faBoxArchive = {
    prefix: 'fasl',
    iconName: 'box-archive',
    icon: [
      512,
      512,
      ["archive"],
      'f187',
      
      'M480 64H32v64H64 448h32V64zm0 96H448 64 32 0V128 64 32H32 480h32V64v64 32H480zM160 224h16H336h16v32H336 176 160V224zm288-32h32V448v32H448 64 32V448 192H64V448H448V192z'
      
    ]
  };

  
    var faArchive = faBoxArchive;
  

  
  

  var faFaceSmileHorns = {
    prefix: 'fasl',
    iconName: 'face-smile-horns',
    icon: [
      640,
      512,
      [],
      'e391',
      
      'M86 152c-4.7-7.3-9.7-15.6-14.7-24.6c-12-21.5-23.2-46.1-30.6-71.5l.1 0C65 65 96.3 73.9 134.9 79.2C114.7 100.3 98 124.9 86 152zM167.4 50.5C105.3 45.7 60.6 30.6 33 18.2C11 8.3 0 0 0 0C0 13.3 1.4 26.5 3.9 39.6c10.9 57.6 42.2 111 63.1 141.7c2 3 4 5.8 5.8 8.3C67 210.7 64 233 64 256c0 141.4 114.6 256 256 256s256-114.6 256-256c0-23-3-45.3-8.7-66.5c1.8-2.5 3.7-5.3 5.8-8.3c20.9-30.6 52.2-84 63.1-141.7c2.5-13 3.9-26.3 3.9-39.6c0 0-11 8.3-33 18.2c-27.5 12.4-72.3 27.5-134.4 32.3C430 18.8 377.2 0 320 0S210 18.8 167.4 50.5zM505.1 79.2C543.7 73.9 575 65 599.2 56l.1 0c-7.4 25.4-18.7 50-30.6 71.5c-5 9-10 17.2-14.7 24.6c-12.1-27.1-28.7-51.7-48.9-72.9zM96 256a224 224 0 1 1 448 0A224 224 0 1 1 96 256zm97.7 95.2C206.3 376.3 248.4 424 320 424s113.7-47.7 126.3-72.8l-28.6-14.3C408.9 354.3 376.4 392 320 392s-88.9-37.7-97.7-55.2l-28.6 14.3zM264.4 272c0-2.6-.4-5.1-1.2-7.4l19.7 6.6 15.2 5.1 10.1-30.4-15.2-5.1-96-32-15.2-5.1-10.1 30.4 15.2 5.1 39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6c0 13.3 10.7 24 24 24s24-10.7 24-24zm136 24c13.3 0 24-10.7 24-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13 15.2-5.1-10.1-30.4-15.2 5.1-96 32-15.2 5.1 10.1 30.4 15.2-5.1 20.6-6.9c-.8 2.4-1.3 5-1.3 7.7c0 13.3 10.7 24 24 24z'
      
    ]
  };

  

  
  

  var faToggleOff = {
    prefix: 'fasl',
    iconName: 'toggle-off',
    icon: [
      576,
      512,
      [],
      'f204',
      
      'M544 128V384H32V128H544zm32-32H544 32 0v32V384v32H32 544h32V384 128 96zM224 192V320H96V192H224zm32-32H224 96 64v32V320v32H96 224h32V320 192 160z'
      
    ]
  };

  

  
  

  var faDialOff = {
    prefix: 'fasl',
    iconName: 'dial-off',
    icon: [
      576,
      512,
      [],
      'e162',
      
      'M312 8H264V56h48V8zM120 72H72v48h48V72zm336 0v48h48V72H456zM568 264H520v48h48V264zM8 264v48H56V264H8zM120 456H72v48h48V456zm336 0v48h48V456H456zM272 288V415c-63.1-7.9-112-61.7-112-127c0-70.7 57.3-128 128-128s128 57.3 128 128c0 65.3-48.9 119.1-112 127V288 272H272v16zm16 160a160 160 0 1 0 0-320 160 160 0 1 0 0 320z'
      
    ]
  };

  

  
  

  var faFaceAwesome = {
    prefix: 'fasl',
    iconName: 'face-awesome',
    icon: [
      512,
      512,
      ["gave-dandy"],
      'e409',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 208H104V192c0-22.1 17.9-40 40-40c.5 0 .9 0 1.4 0c-.9 2.5-1.4 5.2-1.4 8c0 13.3 10.7 24 24 24c5.2 0 10.1-1.7 14-4.5c1.3 3.9 2 8.1 2 12.5v16zm-40-88c-39.8 0-72 32.2-72 72v16 32h32 80 32V208 192c0-39.8-32.2-72-72-72zm236.1 53.1c2.5 5.8 3.9 12.2 3.9 18.9v16H288V192c0-26.5 21.5-48 48-48c2 0 3.9 .1 5.8 .3c-3.6 4.2-5.8 9.7-5.8 15.7c0 13.3 10.7 24 24 24c8.4 0 15.8-4.3 20.1-10.9zM256 192v16 32h32 96 32V208 192c0-44.2-35.8-80-80-80s-80 35.8-80 80zm-8 224c-2 0-4 0-6-.1c7.1-27.5 32.2-47.9 62-47.9c14.3 0 27.5 4.7 38.2 12.6C316.9 402.7 283.9 416 248 416zm115.9-59c-16.4-13.1-37.2-21-59.9-21c-45.8 0-84.1 32.1-93.7 75c-50.7-13.8-90.5-54.8-102.1-107H387.8c-4.3 19.5-12.6 37.4-23.9 53zm12.3 35.3c22.4-24 38.1-54.3 44.2-88.2c.9-5 1.6-10.2 2.1-15.3L424 272H391.9 104.1 72l1.5 16.7c.5 5.2 1.2 10.3 2.1 15.3c14.9 82.6 87 144 172.4 144h7.7c48 0 91.4-21.5 120.5-55.8z'
      
    ]
  };

  
    var faGaveDandy = faFaceAwesome;
  

  
  

  var faSquareV = {
    prefix: 'fasl',
    iconName: 'square-v',
    icon: [
      448,
      512,
      [],
      'e284',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM209.5 390.8L93.2 144h35.4L224 346.5 319.5 144h35.4L238.5 390.8l-4.3 9.2H213.9l-4.3-9.2z'
      
    ]
  };

  

  
  

  var faDrumstick = {
    prefix: 'fasl',
    iconName: 'drumstick',
    icon: [
      512,
      512,
      [127831],
      'f6d6',
      
      'M237.3 320H336c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144v98.7L237.3 320zM160 281.4V176C160 78.8 238.8 0 336 0s176 78.8 176 176s-78.8 176-176 176H230.6l-40.5 40.5C201.2 405.2 208 421.8 208 440c0 39.8-32.2 72-72 72c-37.2 0-67.8-28.2-71.6-64.4C28.2 443.8 0 413.2 0 376c0-39.8 32.2-72 72-72c18.2 0 34.8 6.8 47.5 17.9L160 281.4zm19.3 25.9l-49.2 49.2-13.9 13.9L105.4 354C98.2 343.1 86 336 72 336c-22.1 0-40 17.9-40 40s17.9 40 40 40h8H96v16 8c0 22.1 17.9 40 40 40s40-17.9 40-40c0-14-7.1-26.2-18-33.4l-16.4-10.8 13.9-13.9 49.2-49.2-25.4-25.4z'
      
    ]
  };

  

  
  

  var faBroomBall = {
    prefix: 'fasl',
    iconName: 'broom-ball',
    icon: [
      576,
      512,
      ["quidditch","quidditch-broom-ball"],
      'f458',
      
      'M552 0L340 212l-52-52H256l-12.7 75.9-9.8-1.4c-46.3-6.6-93 9-126 42C86.7 297.3 72.7 323.6 67 352c-1.2 6-2.1 12.1-2.5 18.3c-.3 3.7-.4 7.4-.4 11.2v0V384H96L64 416 0 480v32H32l162.5 0c39.4 0 77.2-15.6 105-43.5c33.1-33.1 48.6-79.7 42-126l-1.4-9.8L416 320V288l-52-52L576 24 552 0zM253.7 269.7l52.6 52.6 3.5 24.7c5.2 36.3-7 72.9-33 98.9C255 467.7 225.4 480 194.5 480L45.3 480l73.4-73.4L173.3 352H99.8c5.2-19.8 15.6-38.1 30.3-52.9c25.9-25.9 62.6-38.1 98.9-33l24.7 3.5zm79.6 31.6l-58.7-58.7 7.2-43.5 94.9 94.9-43.5 7.2zM416 432a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  
    var faQuidditch = faBroomBall;
  
    var faQuidditchBroomBall = faBroomBall;
  

  
  

  var faUp = {
    prefix: 'fasl',
    iconName: 'up',
    icon: [
      384,
      512,
      ["arrow-alt-up"],
      'f357',
      
      'M144 240v32V448h96V272 240h32 80v-2.7L192 77.2 32 237.2V240h80 32zM0 224L169.4 54.6 192 32l22.6 22.6L384 224v16 32H352 304 272v32V448v32H240 144 112V448 304 272H80 32 0V240 224z'
      
    ]
  };

  
    var faArrowAltUp = faUp;
  

  
  

  var faFence = {
    prefix: 'fasl',
    iconName: 'fence',
    icon: [
      512,
      512,
      [],
      'e303',
      
      'M32 288V448H96V384 352 192 160 109.3l-32-32-32 32V288zm96 96v64 32H96 32 0V448 288 96L41.4 54.6 64 32 86.6 54.6 128 96v64h64V96l41.4-41.4L256 32l22.6 22.6L320 96v64h64V96l41.4-41.4L448 32l22.6 22.6L512 96V448v32H480 416 384V448 384H320v64 32H288 224 192V448 384H128zm288-32v32 64h64V109.3l-32-32-32 32V288v64zm-32 0V288 192H320V352h64zM128 192V352h64V288 192H128zm96-82.7V288 448h64V384 352 192 160 109.3l-32-32-32 32z'
      
    ]
  };

  

  
  

  var faBlindsOpen = {
    prefix: 'fasl',
    iconName: 'blinds-open',
    icon: [
      512,
      512,
      [],
      'f8fc',
      
      'M16 0H0V16 80 96H16 128V258.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V96H496h16V80 16 0H496 16zM32 64V32H480V64H32zm96 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM16 160H0v32H16 96V160H16zm176 32H496h16V160H496 192v32zM0 480v32H16 496h16V480H496 16 0zM16 320H0v32H16 80c-7-9.3-12-20.2-14.4-32H16zm480 32h16V320H496 222.4c-2.4 11.8-7.4 22.7-14.4 32H496z'
      
    ]
  };

  

  
  

  var faWebhook = {
    prefix: 'fasl',
    iconName: 'webhook',
    icon: [
      576,
      512,
      [],
      'e5d5',
      
      'M192 128c0-53 43-96 96-96s96 43 96 96c0 4.7-.3 9.3-1 13.7l31.7 4.5c.9-6 1.3-12.1 1.3-18.3C416 57.3 358.7 0 288 0S160 57.3 160 128c0 40 18.4 75.8 47.1 99.2L147.3 323c-6.1-1.9-12.6-3-19.3-3c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-17.1-6.7-32.6-17.6-44.1l67.8-108.5 8.5-13.6-13.5-8.5C210 192.4 192 162.3 192 128zM160 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-64-32c0 35.3 28.7 64 64 64c6.7 0 13.2-1 19.3-3l67.8 108.5 8.5 13.6 13.6-8.5c14.7-9.2 32.2-14.6 50.9-14.6c53 0 96 43 96 96s-43 96-96 96c-23.7 0-45.3-8.5-62-22.7l-20.7 24.4C387.6 500.6 416.5 512 448 512c70.7 0 128-57.3 128-128s-57.3-128-128-128c-19.2 0-37.4 4.2-53.8 11.8l-59.8-95.7c10.9-11.5 17.6-27 17.6-44.1c0-35.3-28.7-64-64-64s-64 28.7-64 64zM85 298.1L70.7 269.5C28.8 290.5 0 333.9 0 384c0 70.7 57.3 128 128 128c65.3 0 119.1-48.9 127-112l131 0c7.1 27.6 32.2 48 62 48c35.3 0 64-28.7 64-64s-28.7-64-64-64c-29.8 0-54.9 20.4-62 48l-146 0H224v16c0 53-43 96-96 96s-96-43-96-96c0-37.5 21.5-70.1 53-85.9zM448 416a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  

  
  

  var faScrollTorah = {
    prefix: 'fasl',
    iconName: 'scroll-torah',
    icon: [
      640,
      512,
      ["torah"],
      'f6a0',
      
      'M32 32V480H96V448 64 32H32zm96 416H512V64H128V448zM544 64V448v32h64V32H544V64zM512 512V480H128v32H96 32 0V480 32 0H32 96h32V32H512V0h32 64 32V32 480v32H608 544 512zM168.7 339.9l14.6-24.3 36-59.6-36-59.6-14.6-24.3h28.3H270L306.3 112 320 89.2 333.7 112 370 172.1h72.9 28.3l-14.6 24.3-36 59.6 36 59.6 14.6 24.3H442.9 370l-36.3 60.2L320 422.8l-13.7-22.7L270 339.9H197.1 168.7zM320 360.8l12.6-20.9H307.3L320 360.8zM256.7 256L288 307.9h63.9L383.2 256l-31.3-51.9H288L256.7 256zm145.2 31l-12.6 20.9h25.2L401.9 287zm12.6-82.9H389.3L401.9 225l12.6-20.9zM320 151.2l-12.6 20.9h25.2L320 151.2zM238 225l12.6-20.9H225.4L238 225zm12.6 82.9L238 287l-12.6 20.9h25.2z'
      
    ]
  };

  
    var faTorah = faScrollTorah;
  

  
  

  var faDownRight = {
    prefix: 'fasl',
    iconName: 'down-right',
    icon: [
      384,
      512,
      [],
      'e16b',
      
      'M240 237.3l-22.6-22.6L112 109.3 45.3 176 150.6 281.4 173.3 304l-22.6 22.6L101.3 376l8 8H320V173.3l-8-8-49.4 49.4L240 237.3zm49.4-94.6L312 120l22.6 22.6L352 160V384v32H320 96L78.6 398.6 56 376l22.6-22.6 26.7-26.7L128 304l-22.6-22.6L22.6 198.6 0 176l22.6-22.6L89.4 86.6 112 64l22.6 22.6 82.7 82.7L240 192l22.6-22.6 26.7-26.7z'
      
    ]
  };

  

  
  

  var faPersonArrowUpFromLine = {
    prefix: 'fasl',
    iconName: 'person-arrow-up-from-line',
    icon: [
      640,
      512,
      [],
      'e539',
      
      'M168 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0A56 56 0 1 0 136 56a56 56 0 1 0 112 0zM140.9 128h-9.6l-4.5 8.5-76.9 144-7.5 14.1 28.2 15.1 7.5-14.1L128 202.1V480H16 0v32H16l112 0h32 64 32l368 0h16V480H624 256V202.2l49.9 93.4 7.5 14.1 28.2-15.1-7.5-14.1-76.9-144-4.5-8.5h-9.6H140.9zM224 480H160V352h64V480zm0-160H160V160h64V320zM603.3 132.7l-96-96L496 25.4 484.7 36.7l-96 96L377.4 144 400 166.6l11.3-11.3L480 86.6 480 400v16h32V400 86.6l68.7 68.7L592 166.6 614.6 144l-11.3-11.3z'
      
    ]
  };

  

  
  

  var faBowlingPins = {
    prefix: 'fasl',
    iconName: 'bowling-pins',
    icon: [
      512,
      512,
      [],
      'f437',
      
      'M72 176L14.7 367.9 55.9 512H200.1l41.2-144.1L184 176l21.1-75.6c1.9-6.9 2.9-14.1 2.9-21.3C208 35.4 172.6 0 128.9 0h-1.7C83.4 0 48 35.4 48 79.1c0 7.2 1 14.3 2.9 21.3L72 176zM208 368.1L176 480H80L48 368.1 100.6 192h54.8L208 368.1zM174.3 91.8l-19 68.2H100.8l-19-68.2C80.6 87.7 80 83.4 80 79.1c0-26 21.1-47.1 47.1-47.1h1.7c26 0 47.1 21.1 47.1 47.1c0 4.3-.6 8.5-1.7 12.7zM328 176L270.7 367.9 311.9 512H456.1l41.2-144.1L440 176l21.1-75.6c1.9-6.9 2.9-14.1 2.9-21.3C464 35.4 428.6 0 384.9 0h-1.7C339.4 0 304 35.4 304 79.1c0 7.2 1 14.3 2.9 21.3L328 176zM464 368.1L432 480H336L304 368.1 356.6 192h54.8L464 368.1zM430.3 91.8l-19 68.2H356.8l-19-68.2c-1.2-4.1-1.7-8.4-1.7-12.7c0-26 21.1-47.1 47.1-47.1h1.7c26 0 47.1 21.1 47.1 47.1c0 4.3-.6 8.5-1.7 12.7z'
      
    ]
  };

  

  
  

  var faPencilSlash = {
    prefix: 'fasl',
    iconName: 'pencil-slash',
    icon: [
      640,
      512,
      [],
      'e215',
      
      'M553.4 150.6L576 128l-22.6-22.6L470.6 22.6 448 0 425.4 22.6 294 154l25.3 20 60-60 82.7 82.7-50.3 50.3 25.3 20L553.4 150.6zM320.7 338.1L240 418.7V400 384H224 192V352 336H176 157.3l70.9-70.9-25.3-20L96 352 70.8 478 64 512l34-6.8L224 480 346 358l-25.3-20zM208.2 450.5L104.8 471.2l20.7-103.4c.8 .1 1.7 .2 2.5 .2h32v32 16h16 32v32c0 .9 .1 1.7 .2 2.5zM530.7 128l-46.1 46.1L401.9 91.3 448 45.3 530.7 128zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  

  
  

  var faUserNinja = {
    prefix: 'fasl',
    iconName: 'user-ninja',
    icon: [
      448,
      512,
      [129399],
      'f504',
      
      'M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0C352 57.3 294.7 0 224 0C169.6 0 123 34 104.5 81.9L59.3 36.7 48 25.4 25.4 48 36.7 59.3 89.4 112 36.7 164.7 25.4 176 48 198.6l11.3-11.3 38.4-38.4C107.7 209.7 160.4 256 224 256c70.7 0 128-57.3 128-128zM144 304h-8 0H64L9.8 480 0 512H33.5 312h.1H414.5 448l-9.8-32L384 304H304l-57.4 57.4L224 384l-22.6-22.6L144 304zM87.6 336h41.7l144 144H43.3L87.6 336zm317 144h-86l-72.7-72.7 .7-.7L317.3 336h43.1l44.3 144zM176 96H160v32h16 96 16V96H272 176z'
      
    ]
  };

  

  
  

  var fa7 = {
    prefix: 'fasl',
    iconName: '7',
    icon: [
      320,
      512,
      [],
      '37',
      
      'M304 32h16V52.4l-2.3 3.8L64.2 480H26.9L275.8 64H16 0V32H16 304z'
      
    ]
  };

  

  
  

  var faBlog = {
    prefix: 'fasl',
    iconName: 'blog',
    icon: [
      512,
      512,
      [],
      'f781',
      
      'M192 64c141.4 0 256 114.6 256 256h32C480 160.9 351.1 32 192 32V64zM384 320c0-106-86-192-192-192v32c88.4 0 160 71.6 160 160h32zM32 120V104H0v16V368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144h-8H120v32h16 8c61.9 0 112 50.1 112 112s-50.1 112-112 112S32 429.9 32 368V120z'
      
    ]
  };

  

  
  

  var faCircle9 = {
    prefix: 'fasl',
    iconName: 'circle-9',
    icon: [
      512,
      512,
      [],
      'e0f6',
      
      'M256 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm63.3 303.7C340.3 282.5 352 253.8 352 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c.8 0 1.6 0 2.4 0l-61.8 62.8-1.2 1.2h44.9l79-80.3zM192 224a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faSheetPlastic = {
    prefix: 'fasl',
    iconName: 'sheet-plastic',
    icon: [
      384,
      512,
      [],
      'e571',
      
      'M32 32V480H192V336 320h16H352V32H32zM352 354.7V352H224V480h2.7L352 354.7zM240 512H32 0V480 32 0H32 352h32V32 368L240 512zM187.3 91.3l-96 96L80 198.6 57.4 176l11.3-11.3 96-96L176 57.4 198.6 80 187.3 91.3zm96 32l-160 160L112 294.6 89.4 272l11.3-11.3 160-160L272 89.4 294.6 112l-11.3 11.3z'
      
    ]
  };

  

  
  

  var faFaceUnamused = {
    prefix: 'fasl',
    iconName: 'face-unamused',
    icon: [
      512,
      512,
      [],
      'e39f',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM316.1 394.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7l-10.7 11.9-23.8-21.4 10.7-11.9C188.2 355.4 216.3 336 256 336s67.8 19.4 83.9 37.3l10.7 11.9-23.8 21.4-10.7-11.9zM112 192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H112 96V192h16zm176 0h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32H304 288V192z'
      
    ]
  };

  

  
  

  var faMessageArrowDown = {
    prefix: 'fasl',
    iconName: 'message-arrow-down',
    icon: [
      512,
      512,
      ["comment-alt-arrow-down"],
      'e1db',
      
      'M160 416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448 416zm0-32h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zM272 112V265.4l52.7-52.7L336 201.4 358.6 224l-11.3 11.3-80 80L256 326.6l-11.3-11.3-80-80L153.4 224 176 201.4l11.3 11.3L240 265.4V112 96h32v16z'
      
    ]
  };

  
    var faCommentAltArrowDown = faMessageArrowDown;
  

  
  

  var faGolfFlagHole = {
    prefix: 'fasl',
    iconName: 'golf-flag-hole',
    icon: [
      512,
      512,
      [],
      'e3ac',
      
      'M128 32V0l32 14.2 216.6 96.3L416 128l-39.4 17.5L160 241.8v69.8c29.6-4.9 62.1-7.6 96-7.6c141.4 0 256 46.6 256 104s-114.6 104-256 104S0 465.4 0 408c0-32.8 37.5-62.1 96-81.2v33.8c-3.1 1.1-6.1 2.3-9 3.5c-20.9 8.5-35.7 17.8-44.7 26.5C33.3 399.2 32 405.1 32 408s1.3 8.8 10.3 17.4c9.1 8.7 23.8 18 44.7 26.5C128.7 468.8 188.4 480 256 480s127.3-11.2 169-28.1c20.9-8.5 35.7-17.8 44.7-26.5c9-8.6 10.3-14.5 10.3-17.4s-1.3-8.8-10.3-17.4c-9.1-8.7-23.8-18-44.7-26.5C383.3 347.2 323.6 336 256 336c-34.5 0-67 2.9-96 8v28.2c17-7.6 39.4-12.2 64-12.2c53 0 96 21.5 96 48s-43 48-96 48s-96-21.5-96-48V392 350.9 317.9 256 240 221 48 35 32zm32 174.8L337.2 128 160 49.2V206.8zM288.4 405.4a0 0 0 1 0 0 .1 0 0 0 1 0 0-.1zm-10.8-2.7c-12.1-6-31-10.7-53.6-10.7s-41.5 4.7-53.6 10.7c-4.3 2.1-6.9 4-8.5 5.3c1.6 1.4 4.2 3.2 8.5 5.3c12.1 6 31 10.7 53.6 10.7s41.5-4.7 53.6-10.7c4.3-2.1 6.9-4 8.5-5.3c-1.6-1.4-4.2-3.2-8.5-5.3zm-118 7.9a0 0 0 1 0 0-.1 0 0 0 1 0 0 .1zm128.8-.1a.1 .1 0 1 0 .1 .2 .1 .1 0 1 0 -.1-.2z'
      
    ]
  };

  

  
  

  var faBookBlank = {
    prefix: 'fasl',
    iconName: 'book-blank',
    icon: [
      448,
      512,
      [128213,128215,128216,128217,"book-alt"],
      'f5d9',
      
      'M0 64C0 28.7 28.7 0 64 0H432h16V16 400v16H432 416v64h16 16v32H432 64c-35.3 0-64-28.7-64-64l0 0L0 64zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H384V416H64zM32 392.6c9.4-5.4 20.3-8.6 32-8.6H96V32H64C46.3 32 32 46.3 32 64l0 328.6zM128 32V384H416V32H128z'
      
    ]
  };

  
    var faBookAlt = faBookBlank;
  

  
  

  var faVialVirus = {
    prefix: 'fasl',
    iconName: 'vial-virus',
    icon: [
      512,
      512,
      [],
      'e597',
      
      'M16 32H0V64H16 32V384c0 53 43 96 96 96c22.6 0 43.3-7.8 59.7-20.8l-11-11 22.6-22.6 17-17 .1-.2 0-.1-.1-.1c0-.1-.1-.1-.1-.2l-.2 0 0 0 0 0h0H192h-4.7c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64V224H192v16.5l7.3-7.3 17-17 7.8-7.8V64h16 16V32H240 224 192 64 32 16zM192 192H64V64H192V192zM320 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM216.1 328H192v48l24 0c28.8 0 43.2 34.8 22.9 55.2l-17 17 33.9 33.9 17-17c20.4-20.4 55.2-5.9 55.2 22.9l0 .2V512h48V487.8c.1-28.7 34.8-43 55.2-22.7l17 17 33.9-33.9-17-17C444.8 410.8 459.2 376 488 376l24 0V328H487.9c-28.8 0-43.2-34.8-22.8-55.2l17-17-33.9-33.9-17 17c-20.3 20.3-55.1 6-55.2-22.7V192H328v23.9l0 .1c0 28.8-34.8 43.2-55.2 22.9l-17-17-33.9 33.9 17 17c20.4 20.4 6 55.2-22.8 55.2zm31.4 24c25.7-14.3 38.6-45.6 30.6-73.9c28.3 8 59.6-4.9 73.9-30.6c7.2 12.9 18.7 22.6 32 28.1c13.1 5.3 27.8 6.5 41.9 2.5c-8 28.3 4.9 59.6 30.6 73.9c-25.7 14.3-38.6 45.6-30.6 73.9c-28.3-8-59.6 4.9-73.9 30.6c-14.3-25.7-45.6-38.6-73.9-30.6c8-28.3-4.9-59.6-30.6-73.9z'
      
    ]
  };

  

  
  

  var faCloudXmark = {
    prefix: 'fasl',
    iconName: 'cloud-xmark',
    icon: [
      640,
      512,
      [],
      'e35f',
      
      'M544 241.1V232c0-57.4-46.6-104-104-104c-13.4 0-26.2 2.5-37.9 7.1l-24.3 9.5-14.2-22C340.8 87.3 301.1 64 256 64c-70.7 0-128 57.3-128 128v8.2 22.6l-21.3 7.5C63.1 245.8 32 287.3 32 336V448H144 512h96V352c0-35.5-19.2-66.5-48-83.2l-16-9.2V241.1zM0 336c0-62.7 40.1-116 96-135.8V192c0-88.4 71.6-160 160-160c56.4 0 106 29.2 134.5 73.3c15.3-6 32-9.3 49.5-9.3c75.1 0 136 60.9 136 136v9.1c38.3 22.1 64 63.5 64 110.9v96 32H608 512 144 32 0V448 336zM255.4 200.8l11.3 11.3L320 265.4l53.3-53.3 11.3-11.3 22.6 22.6-11.3 11.3L342.6 288l53.3 53.3 11.3 11.3-22.6 22.6-11.3-11.3L320 310.6l-53.3 53.3-11.3 11.3-22.6-22.6 11.3-11.3L297.4 288l-53.3-53.3-11.3-11.3 22.6-22.6z'
      
    ]
  };

  

  
  

  var faUserCheck = {
    prefix: 'fasl',
    iconName: 'user-check',
    icon: [
      640,
      512,
      [],
      'f4fc',
      
      'M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM87.6 336H360.4l44.3 144H43.3L87.6 336zM384 304H64L9.8 480 0 512H33.5h381H448l-9.8-32L384 304zM627.3 187.3L638.6 176 616 153.4l-11.3 11.3L488 281.4l-52.7-52.7L424 217.4 401.4 240l11.3 11.3 64 64L488 326.6l11.3-11.3 128-128z'
      
    ]
  };

  

  
  

  var faArrowDownToSquare = {
    prefix: 'fasl',
    iconName: 'arrow-down-to-square',
    icon: [
      512,
      512,
      [],
      'e096',
      
      'M267.8 330.9l96-104 10.9-11.8-23.5-21.7-10.9 11.8L272 279.1V16 0H240V16 279.1l-68.2-73.9-10.9-11.8-23.5 21.7 10.9 11.8 96 104L256 343.6l11.8-12.7zM16 32H0V48 496v16H16 496h16V496 48 32H496 400 384V64h16 80V480H32V64h80 16V32H112 16z'
      
    ]
  };

  

  
  

  var faNote = {
    prefix: 'fasl',
    iconName: 'note',
    icon: [
      448,
      512,
      [],
      'e1ff',
      
      'M416 64H32V448H272V320 304h16H416V64zm-5.3 272H304V442.7L410.7 336zm37.3 8L312 480H32 0V448 64 32H32 416h32V64 344zM128 128v48H80V128h48zM80 232h48v48H80V232zm48 104v48H80V336h48z'
      
    ]
  };

  

  
  

  var faTruckRampBox = {
    prefix: 'fasl',
    iconName: 'truck-ramp-box',
    icon: [
      640,
      512,
      ["truck-loading"],
      'f4de',
      
      'M368 0H352V16 384v2.9L20 472.5l-15.5 4 8 31 15.5-4L416.1 403.4C417.8 463.7 467.3 512 528 512c61.9 0 112-50.1 112-112s-50.1-112-112-112c-51.2 0-94.4 34.4-107.7 81.3l-.3 .1-36 9.3V32H624h16V0H624 368zM528 320a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM84.9 191.2L101.5 253l4.1 15.5 15.5-4.1 61.8-16.6 15.5-4.1-4.1-15.5-16.6-61.8 30.9-8.3L250 312.6 95.4 354 54 199.4l30.9-8.3zm30.9-8.3l30.9-8.3L159.2 221l-30.9 8.3-12.4-46.4zM45.7 168.5l-30.9 8.3 8.3 30.9L64.5 362.3l8.3 30.9 30.9-8.3 154.5-41.4 30.9-8.3-8.3-30.9L239.5 149.7l-8.3-30.9-30.9 8.3L45.7 168.5z'
      
    ]
  };

  
    var faTruckLoading = faTruckRampBox;
  

  
  

  var faBlueberries = {
    prefix: 'fasl',
    iconName: 'blueberries',
    icon: [
      512,
      512,
      [],
      'e2e8',
      
      'M382.7 312.3C439.3 292.9 480 239.2 480 176c0-79.5-64.5-144-144-144c-63.2 0-116.9 40.7-136.3 97.3c-7.8-.9-15.7-1.3-23.7-1.3c-3.2 0-6.3 .1-9.4 .2C187.4 54.2 255.4 0 336 0c97.2 0 176 78.8 176 176c0 80.6-54.2 148.6-128.2 169.4c.1-3.1 .2-6.3 .2-9.4c0-8-.5-15.9-1.3-23.7zM320 336A144 144 0 1 0 32 336a144 144 0 1 0 288 0zM0 336a176 176 0 1 1 352 0A176 176 0 1 1 0 336zm176-96v32h32 16v32H208 176v32 16H144V336 304H112 96V272h16 32V240 224h32v16zM368 80v32h32 16v32H400 368v32 16H336V176 144H304 288V112h16 32V80 64h32V80z'
      
    ]
  };

  

  
  

  var faPenField = {
    prefix: 'fasl',
    iconName: 'pen-field',
    icon: [
      640,
      512,
      [],
      'e211',
      
      'M294.3 318.3L288 352l33.7-6.3L416 328 617.4 126.6 640 104 617.4 81.4 558.6 22.6 536 0 513.4 22.6 312 224l-17.7 94.3zm33.7-6.3l13.6-72.3L479.3 101.9l58.7 58.7L400.4 298.4l-72.3 13.6zM594.7 104l-34.1 34.1L501.9 79.3 536 45.3 594.7 104zM16 128H0v16V496v16H16 560h16V496 272 256H544v16V480H32V160H304h16V128H304 16zM152 296H104v48h48V296zm48 0v48h48V296H200z'
      
    ]
  };

  

  
  

  var faClipboardList = {
    prefix: 'fasl',
    iconName: 'clipboard-list',
    icon: [
      384,
      512,
      [],
      'f46d',
      
      'M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36l3.1 12H254h34v48H192 96V80h34 12.4l3.1-12zM192 0c-32.8 0-61 19.8-73.3 48H80 64V64 80H32 0v32V480v32H32 352h32V480 112 80H352 320V64 48H304 265.3C253 19.8 224.8 0 192 0zM320 144V112h32V480H32V112H64v32 16H80 192 304h16V144zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM136 272a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-16H160v32h16 96 16V256H272 176zm0 96H160v32h16 96 16V352H272 176zm-64 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faPumpkin = {
    prefix: 'fasl',
    iconName: 'pumpkin',
    icon: [
      576,
      512,
      [],
      'f707',
      
      'M236.1 103.8c12.6-3.9 25.8-6.4 39.5-7.3l26.8-53.5L320 51.8V98.9c11.1 2 21.8 5.1 32 9.1V32L316.6 14.3 288 0 273.7 28.6l-34.5 69-3.1 6.1zM166 145.1c9.5-9.2 20.1-17.3 31.5-24.1c-14.3-5.8-29.5-9-45.5-9c-43.8 0-82.2 24.1-109 60.4S0 258.1 0 312s16.1 103.3 43 139.6S108.2 512 152 512c24.7 0 47.8-7.7 68-20.9c20.2 13.3 43.3 20.9 68 20.9s47.8-7.7 68-20.9c20.2 13.3 43.3 20.9 68 20.9c43.8 0 82.2-24.1 109-60.4s43-85.7 43-139.6s-16.1-103.3-43-139.6S467.8 112 424 112c-15.9 0-31.2 3.2-45.5 9c11.4 6.8 22 14.9 31.5 24.1c4.6-.8 9.3-1.1 14-1.1c31.3 0 60.9 17.1 83.3 47.4S544 264.3 544 312s-14.3 90.3-36.7 120.6s-52 47.4-83.3 47.4c-20.7 0-40.6-7.5-58.1-21.2c-5.8-4.5-13.9-4.5-19.7 0C328.6 472.5 308.7 480 288 480s-40.6-7.5-58.1-21.2c-5.8-4.5-13.9-4.5-19.7 0C192.6 472.5 172.7 480 152 480c-31.3 0-60.9-17.1-83.3-47.4S32 359.7 32 312s14.3-90.3 36.7-120.6s52-47.4 83.3-47.4c4.7 0 9.4 .4 14 1.1zM195.4 209c20.2-29.6 54.1-49 92.6-49s72.4 19.4 92.6 49l26.4-18c-25.9-38-69.6-63-119.1-63s-93.2 25-119.1 63l26.4 18z'
      
    ]
  };

  

  
  

  var faCodePullRequest = {
    prefix: 'fasl',
    iconName: 'code-pull-request',
    icon: [
      512,
      512,
      [],
      'e13c',
      
      'M32 32h96v96H32V32zM0 0V32v96 32H32 64V352H32 0v32 96 32H32h96 32V480 384 352H128 96V160h32 32V128 32 0H128 32 0zM301.2 4.2l-88 80L200.2 96l13 11.8 88 80 21.5-23.7L265.4 112H336c44.2 0 80 35.8 80 80V352H384 352v32 96 32h32 96 32V480 384 352H480 448V192c0-61.9-50.1-112-112-112H265.4l57.4-52.2L301.2 4.2zM32 384h96v96H32V384zm448 0v96H384V384l32 0h32l32 0z'
      
    ]
  };

  

  
  

  var faDesktopArrowDown = {
    prefix: 'fasl',
    iconName: 'desktop-arrow-down',
    icon: [
      576,
      512,
      [],
      'e155',
      
      'M32 0H240V32H32V256H544V32H336V0H544h32V32 256v32 96 32H544 362.9l10.7 64H432h16v32H432 360 216 144 128V480h16 58.4l10.7-64H32 0V384 288 256 32 0H32zm0 288v96H231.7c.2 0 .4 0 .6 0H343.7c.2 0 .4 0 .6 0H544V288H32zM234.9 480H341.1l-10.7-64H245.6l-10.7 64zM304 16V169.4l52.7-52.7L368 105.4 390.6 128l-11.3 11.3-80 80L288 230.6l-11.3-11.3-80-80L185.4 128 208 105.4l11.3 11.3L272 169.4V16 0h32V16z'
      
    ]
  };

  

  
  

  var faPaste = {
    prefix: 'fasl',
    iconName: 'paste',
    icon: [
      512,
      512,
      ["file-clipboard"],
      'f0ea',
      
      'M136.5 51.2C138.7 40.2 148.4 32 160 32s21.3 8.2 23.5 19.2L186.1 64H192h7.2H224h8 24 32V96h32V64 32H288 256 240 210.6c-9-18.9-28.3-32-50.6-32s-41.6 13.1-50.6 32H80 64 32 0V64 416v32H32 192V416H32V64H64v48 16H80 192V96H96V64h24.8 13.1l2.6-12.8zM480 480H256V160H394.7L480 245.3V480zm32-248L408 128H256 224v32V480v32h32H480h32V480 232z'
      
    ]
  };

  
    var faFileClipboard = faPaste;
  

  
  

  var faComments = {
    prefix: 'fasl',
    iconName: 'comments',
    icon: [
      640,
      512,
      [61670,128490],
      'f086',
      
      'M70.9 293l7.3-18.3L65.2 260C43.9 235.8 32 206.8 32 176c0-74.7 73.6-144 176-144s176 69.3 176 144s-73.6 144-176 144c-14.6 0-28.7-1.5-42.2-4.2l-6.8-1.4-6.7 1.6-99.9 23L70.9 293zM0 384l38-8.8 121.5-28c15.6 3.1 31.8 4.8 48.5 4.8c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 39.4 15.3 75.8 41.2 105.1L14.5 347.8 0 384zm432 96c16.7 0 32.9-1.7 48.5-4.8l121.5 28 38 8.8-14.5-36.2-26.7-66.7C624.7 379.8 640 343.4 640 304c0-94.4-87.9-171.5-198.2-175.8c2.8 10.4 4.7 21.2 5.6 32.3C541.7 167 608 233.1 608 304c0 30.8-11.9 59.8-33.2 84l-13 14.8 7.3 18.3 18.4 46.1-99.9-23-6.7-1.6-6.8 1.4c-13.5 2.7-27.6 4.2-42.2 4.2c-68.2 0-123.6-30.7-153.1-73.3c-11 3-22.3 5.2-33.8 6.8C279 439.8 350 480 432 480z'
      
    ]
  };

  

  
  

  var faCaretRight = {
    prefix: 'fasl',
    iconName: 'caret-right',
    icon: [
      256,
      512,
      [],
      'f0da',
      
      'M96 128l0 256 1.7 0L213 256 97.8 128 96 128zm-32 0l0-32 32 0 16 0L256 256 112 416l-16 0-32 0 0-32 0-256z'
      
    ]
  };

  

  
  

  var faBackward = {
    prefix: 'fasl',
    iconName: 'backward',
    icon: [
      512,
      512,
      [9194],
      'f04a',
      
      'M28.8 275.2L0 256l28.8-19.2L256 85.3 288 64v38.5 95.9L480 83.2 512 64v37.3V410.7 448l-32-19.2L288 313.6v95.9V448l-32-21.3L28.8 275.2zM288 276.3L480 391.5v-271L288 235.7v40.6zM256 388.2V123.8L57.7 256 256 388.2z'
      
    ]
  };

  

  
  

  var faPencil = {
    prefix: 'fasl',
    iconName: 'pencil',
    icon: [
      512,
      512,
      [9999,61504,"pencil-alt"],
      'f303',
      
      'M0 512l6.8-34L32 352 361.4 22.6 384 0l22.6 22.6 82.7 82.7L512 128l-22.6 22.6L160 480 34 505.2 0 512zM176 400v18.7L398.1 196.7l-82.7-82.7L93.3 336H112h16v16 32h32 16v16zm-32 48V416H112 96V400 368H64c-.9 0-1.7-.1-2.5-.2L40.8 471.2l103.4-20.7c-.1-.8-.2-1.7-.2-2.5zM420.7 174.1L466.7 128 384 45.3 337.9 91.3l82.7 82.7zm-89.4 28.7l-128 128L192 342.1l-22.6-22.6 11.3-11.3 128-128L320 168.8l22.6 22.6-11.3 11.3z'
      
    ]
  };

  
    var faPencilAlt = faPencil;
  

  
  

  var faLips = {
    prefix: 'fasl',
    iconName: 'lips',
    icon: [
      576,
      512,
      [128068,128482],
      'f600',
      
      'M192 64l96 48 96-48L576 224s-80 224-240 224H240C80 448 0 224 0 224L192 64zm110.3 76.6c-9 4.5-19.6 4.5-28.6 0L196.4 102 38.5 233.6c1.6 3.5 3.4 7.5 5.4 11.7c9.5 19.9 23.5 46.1 42.1 72.2C124.3 371 176 416 240 416h96c64 0 115.7-45 154-98.6c18.6-26 32.7-52.3 42.1-72.2c2-4.2 3.8-8.1 5.4-11.7L379.6 102l-77.3 38.6zM154.4 256.6C185 276.3 230.1 296 288 296s103-19.7 133.6-39.4c10.5-6.8 19.2-13.5 26.2-19.4l-90.5-20.5c-.9 .3-1.9 .6-2.9 .9c-4.5 1.4-10.7 3.2-17.9 5c-13.9 3.6-32.7 7.5-48.5 7.5s-34.5-3.9-48.5-7.5c-7.2-1.8-13.4-3.6-17.9-5c-1.1-.3-2.1-.6-2.9-.9l-90.5 20.5c7 5.9 15.8 12.7 26.2 19.4zm70.2-71.7l.1 0 .3 .1 1.2 .4c1.1 .4 2.7 .9 4.8 1.5c4.1 1.3 9.9 2.9 16.4 4.6c13.5 3.4 29 6.5 40.6 6.5s27.1-3.1 40.6-6.5c6.6-1.7 12.3-3.4 16.4-4.6c2.1-.6 3.7-1.1 4.8-1.5l1.2-.4 .3-.1 .1 0 0 0 0 0 0 0 8.7-.5 123.4 28 8.9 25.7L480 228c12.4 10.1 12.4 10.1 12.4 10.1l0 0 0 0-.1 .1-.2 .3c-.2 .2-.4 .5-.8 .9c-.6 .7-1.5 1.8-2.7 3c-2.3 2.6-5.8 6.1-10.2 10.3c-8.9 8.4-22.1 19.6-39.4 30.7C404.5 305.7 353.5 328 288 328s-116.5-22.3-151-44.6c-17.2-11.1-30.4-22.3-39.4-30.7c-4.5-4.2-7.9-7.8-10.2-10.3c-1.2-1.3-2.1-2.3-2.7-3c-.3-.4-.6-.7-.8-.9l-.2-.3-.1-.1 0 0 0 0s0 0 12.4-10.1L83.6 238.1l8.9-25.7 123.4-28 8.7 .5 0 0 0 0 0 0z'
      
    ]
  };

  

  
  

  var faLandmarkFlag = {
    prefix: 'fasl',
    iconName: 'landmark-flag',
    icon: [
      512,
      512,
      [],
      'e51c',
      
      'M272 32V64h64V32H272zm64 64H272v32H464h16v32H464 48 32V128H48 240V96 64 32 16 0h16 16 64 32V32 64 96H336zM48 352H64V192H96V352h80V192h32V352h96V192h32V352h80V192h32V352h16v32H448 64 48V352zm440 64v32H472 40 24V416H40 472h16zM0 480H16 496h16v32H496 16 0V480z'
      
    ]
  };

  

  
  

  var faRam = {
    prefix: 'fasl',
    iconName: 'ram',
    icon: [
      640,
      512,
      [128015],
      'f70a',
      
      'M392 0c30.9 0 56 25.1 56 56v8h32V56c0-30.9 25.1-56 56-56s56 25.1 56 56v8V80H560V64 56c0-13.3-10.7-24-24-24s-24 10.7-24 24V72l62.3 62.3 42.6 28.4 13.3 8.9-17.8 26.6-13.3-8.9L576 173.9V304v32H544 400 368V304 177.3l-14 11.2-12.5 10-20-25 12.5-10 34-27.2V136l48-48V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8V80H336V64 56c0-30.9 25.1-56 56-56zm88 96H453.3L400 149.3V304H544V149.3L490.7 96H480zM256 48c19.1 0 36.3 8.4 48 21.7V80v30.9l-3.8 3L280.1 91c-5.9-6.8-14.5-11-24.1-11s-18.2 4.2-24.1 11l-20.1 23-23.9-19C182.4 90.6 175.6 88 168 88c-15 0-27.7 10.4-31.1 24.3l-7 28.5-29-4.5c-1.6-.2-3.2-.4-5-.4c-17.7 0-32 14.3-32 32c0 2.7 .3 5.3 .9 7.8L71 200 49 211.7c-10.2 5.4-17 16.1-17 28.3s6.8 22.8 17 28.3L71 280l-6 24.2c-.6 2.5-.9 5.1-.9 7.8c0 17.7 14.3 32 32 32c1.7 0 3.4-.1 5-.4l29-4.5 7 28.5c3.4 14 16.1 24.3 31.1 24.3c7.6 0 14.4-2.6 19.9-6.9l23.9-19 20.1 23c5.9 6.8 14.5 11 24.1 11s18.2-4.2 24.1-11l20.1-23 23.9 19c5.5 4.3 12.3 6.9 19.9 6.9c14.9 0 27.4-10.2 31-24h16.5 16 .5l15.5 3.9-32 128-3 12.1H376 304 288V496 423.4c-9.4 5.4-20.3 8.6-32 8.6s-22.6-3.1-32-8.6V496v16H208 136 123.5l-3-12.1L89.4 375.7C57.2 372.4 32 345.1 32 312c0-5.3 .7-10.5 1.9-15.5C13.7 285.7 0 264.5 0 240s13.7-45.7 33.9-56.5c-1.2-5-1.9-10.2-1.9-15.5c0-35.3 28.7-64 64-64c3.3 0 6.6 .3 9.8 .8C112.7 76.8 137.9 56 168 56c15 0 28.9 5.2 39.8 13.9C219.5 56.5 236.8 48 256 48zm64 371.3V480h43.5l16.8-67.3C370 419.8 357.5 424 344 424c-8.5 0-16.6-1.7-24-4.7zm-188.3-6.7L148.5 480H192V419.3c-7.4 3-15.5 4.7-24 4.7c-13.5 0-26-4.2-36.3-11.3zM432 192a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faExcavator = {
    prefix: 'fasl',
    iconName: 'excavator',
    icon: [
      640,
      512,
      [],
      'e656',
      
      'M112 0H96V16 160H32 0v32 96 32H32 352h32V288 224 192 160v-4.8l-2.7-4-96-144L280.6 0H272 112zM348.8 160H128V32H263.4l85.3 128zM32 288V192H352v32 64H32zm304 96c26.5 0 48 21.5 48 48s-21.5 48-48 48H80c-26.5 0-48-21.5-48-48s21.5-48 48-48H336zM80 352c-44.2 0-80 35.8-80 80s35.8 80 80 80H336c44.2 0 80-35.8 80-80s-35.8-80-80-80H80zM480 477.3l128-128V352v32 48c0 26.5-21.5 48-48 48H480v-2.7zM640 432V384 352 320v-2.7V272 128 57.1 32 0H608 576L416 138.7V181L587.9 32H608V85.3L586.8 104 416 254.7v42.7L576 156.2 608 128v42.7V304L448 464v16 32h32 80c44.2 0 80-35.8 80-80zM112 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faEggplant = {
    prefix: 'fasl',
    iconName: 'eggplant',
    icon: [
      512,
      512,
      [],
      'e16c',
      
      'M488.7 57.2L480 65.9V207v33l-32-8-32-8-16-48-48-16-16-48L288 96l-8-32-8-32h33H446.1l8.7-8.7L477.4 .6l11.3 11.3 11.3 11.3 11.3 11.3L488.7 57.2zM448 65.9V64h-1.9H313l1.8 7.2 31.3 10.4 15.2 5.1 5.1 15.2 10.9 32.8 32.8 10.9 15.2 5.1 5.1 15.2 10.4 31.3L448 199V65.9zM169.9 139.3c29.1-14.1 58.4-28.3 84.6-45.4l2.5 9.9 4.3 17 6.9 2.3c-5.9 3.8-11.9 7.4-18 10.8c-21.2 12.2-45.5 24-68.4 35.1l0 0 0 0c-14.1 6.8-27.6 13.4-39.5 19.7c-34 17.8-61.7 35.7-80.9 58.3c-18.2 21.5-30 48.8-29.4 88.5C33.1 413.9 98 479.9 176.4 480c66.7 .1 127.2-45.1 176.8-113.6c24.7-34.1 45.4-72.3 61.6-109.8l31.4 7.9C395.9 383.7 301.3 512.1 176.4 512C79.9 511.9 1.4 431.3 0 336C-1.6 222.5 83.4 181.3 169.9 139.3l0 0z'
      
    ]
  };

  

  
  

  var faFolderGrid = {
    prefix: 'fasl',
    iconName: 'folder-grid',
    icon: [
      512,
      512,
      [],
      'e188',
      
      'M32 32H224l48 64H480h32v32V448v32H480 32 0V448 64 32H32zm240 96H256l-9.6-12.8L208 64H32V448H480V128H272zM112 272v32h32V272H112zM80 240h32 32 32v32 32 32H144 112 80V304 272 240zm160 64h32V272H240v32zm-32-64h32 32 32v32 32 32H272 240 208V304 272 240zm192 32H368v32h32V272zm-32-32h32 32v32 32 32H400 368 336V304 272 240h32z'
      
    ]
  };

  

  
  

  var faGaugeMin = {
    prefix: 'fasl',
    iconName: 'gauge-min',
    icon: [
      512,
      512,
      ["tachometer-alt-slowest"],
      'f628',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM280 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0c0-35.3-28.7-64-64-64c-17.5 0-33.4 7-44.9 18.4L104.2 242.3 90.5 234 74 261.5l13.7 8.2 106.8 64.1c-1.7 5.8-2.6 11.9-2.6 18.2c0 35.3 28.7 64 64 64s64-28.7 64-64zM168 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM416 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM392 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faTachometerAltSlowest = faGaugeMin;
  

  
  

  var faDiagramPrevious = {
    prefix: 'fasl',
    iconName: 'diagram-previous',
    icon: [
      512,
      512,
      [],
      'e478',
      
      'M480 320l-208 0H240L32 320l0 128 448 0V320zM272 288H480h32v32V448v32H480 32 0V448 320 288H32 240V182.6l-36.7 36.7L192 230.6 169.4 208l11.3-11.3 64-64L256 121.4l11.3 11.3 64 64L342.6 208 320 230.6l-11.3-11.3L272 182.6V288zM512 32V48 208v16H496 400 384V192h16 80V64L32 64l0 128h80 16v32H112 16 0V208 48 32H16l480 0h16z'
      
    ]
  };

  

  
  

  var faK = {
    prefix: 'fasl',
    iconName: 'k',
    icon: [
      320,
      512,
      [107],
      '4b',
      
      'M273.9 32h43.5L144.5 219.9 317.9 480H279.4L122.2 244.2 32 342.2V464v16H0V464 336 48 32H32V48 295L273.9 32z'
      
    ]
  };

  

  
  

  var faPage = {
    prefix: 'fasl',
    iconName: 'page',
    icon: [
      384,
      512,
      [],
      'e428',
      
      'M32 480H352V125.3L258.7 32H32V480zM272 0L384 112V480v32H352 32 0V480 32 0H32 272z'
      
    ]
  };

  

  
  

  var faStrikethrough = {
    prefix: 'fasl',
    iconName: 'strikethrough',
    icon: [
      512,
      512,
      [],
      'f0cc',
      
      'M129.7 132c4.8-25.9 22-44.8 49.7-56.2c28.3-11.7 67-15 111-8.4c13.8 2.1 56.1 10 69.7 13.5l15.5 4 7.9-31-15.5-4c-15.1-3.9-58.6-12-72.9-14.1c-47.7-7.2-92.7-4.1-127.9 10.5c-35.7 14.7-62.1 41.6-69.1 80.6c-.1 .3-.1 .6-.1 .9c-2.8 22.9 .6 42.7 9.5 59.7c8.8 16.8 22.4 29.6 37.9 39.8c18.7 12.2 41.6 21.2 65.2 28.9H16 0v32H16 496h16V256H496 319.4c-18.1-6.6-37-12.1-55.3-17.3l-1.2-.3c-39-11.2-74.8-21.6-100.2-38.1c-12.5-8.1-21.5-17.2-27.1-27.8c-5.4-10.4-8.1-23.3-6.1-40.5zM379 336.8c4.7 10.8 6.6 24.5 3.4 42.7c-4.7 26.1-21.9 45.2-49.8 56.6c-28.3 11.7-66.9 15-110.9 8.4c-22.1-3.5-59.5-15.7-88-25.1l0 0 0 0 0 0c-6.1-2-11.8-3.9-16.8-5.5l-15.2-4.9-9.8 30.5 15.2 4.9c4.4 1.4 9.6 3.1 15.3 5c28.3 9.3 69.3 22.8 94.4 26.7l.1 0c47.7 7.2 92.7 4.1 127.9-10.5c35.7-14.7 62.1-41.6 69.1-80.6c4.2-23.3 2.2-43.7-5.6-61.3c-.6-1.3-1.2-2.7-1.9-4H367.7c4.9 5.2 8.6 10.8 11.3 16.8z'
      
    ]
  };

  

  
  

  var faTrees = {
    prefix: 'fasl',
    iconName: 'trees',
    icon: [
      640,
      512,
      [],
      'f724',
      
      'M203.5 12.9L192 1 180.5 12.9 63.6 134.1l-4.5 4.6v6.5V160v16h16H97.9L33.7 246.5 29.5 251v6.2V272v16h16H71.3L3.4 375.4 0 379.7v5.5V400v16H16 132.9h16H176v80 16h32V496 416h27.1 16H368h16V400 385.2v-5.5l-3.4-4.3L312.7 288h25.8 16V272 257.2 251l-4.2-4.6L286.1 176h22.8 16V160 145.2v-6.5l-4.5-4.6L203.5 12.9zM208 384V208 192H176v16V384H148.9h-16H37.2l79.4-102.2L136.7 256H104 68.3L146 170.8 170.4 144H134.2 98.5L192 47l93.5 97H249.8 213.6L238 170.8 315.7 256H280 247.3l20.1 25.8L346.8 384H251.1h-16H208zM464 192H432v16V496v16h32V496 416l27.1 0h16H624h16V400 385.2v-5.5l-3.4-4.3L568.7 288h25.8 16V272 257.2 251l-4.2-4.6L542.1 176h22.8 16V160 145.2v-6.5l-4.5-4.6L459.5 12.9 448 1 436.5 12.9l-94.3 97.7 1.2 1.3 13.4 13.9v15.6L448 47l93.5 97H505.8 469.6L494 170.8 571.7 256H536 503.3l20.1 25.8L602.8 384H507.1h-16H464V208 192z'
      
    ]
  };

  

  
  

  var faHandLove = {
    prefix: 'fasl',
    iconName: 'hand-love',
    icon: [
      512,
      512,
      [],
      'e1a5',
      
      'M128 0h16 80 16V16 64h0V80v64h64 16v16 8h48V80 64h16 80 16V80 335.9v0l0 .1v0c0 97.2-78.8 176-176 176l0 0h-8.5c-65.8 0-128.9-26.1-175.4-72.6L16.4 335.6 4.7 323.9 0 319.2v-6.6V279.4v-6.6l4.7-4.7 40-40L56 216.8l11.3 11.3 28.3 28.3L128 288.8V16 0zm80 176V160 32H160V304v6.6l-4.7 4.7L143.6 327l-11.3 11.3L121 327 73 279l-17-17-24 24v19.9l7 7L142.8 416.7c40.5 40.5 95.4 63.3 152.7 63.3H304l0 0c79.5 0 144-64.5 144-144v0l0-.1v0V96H400l0 16V336v16H384 320 304 288 224 208V336 176h0zm160 24H320l0 8V320h48V200zM288 320l0-64V176H240V320h48z'
      
    ]
  };

  

  
  

  var faFootballHelmet = {
    prefix: 'fasl',
    iconName: 'football-helmet',
    icon: [
      512,
      512,
      [],
      'f44f',
      
      'M340.3 245.5l153.9-19.2-.1-.6c-1.3-10.5-3.3-20.8-6-30.9C461 91.9 367.4 16 256 16C123.5 16 16 123.5 16 256c0 61.5 23.1 117.5 61.1 160H112l99.5 42.6c8.3 3.5 17.2 5.4 26.1 5.4c36.7 0 66.4-29.7 66.4-66.4v-1.3c0-8.1-1.5-16.2-4.3-23.8L292 352h35.7l11.1 58.9 13.5 72 2.4 13.1H368 496h16V480 408 336 320H496 354.3l-14-74.5zm-31.8 4L321.7 320H280l-12.4-33.2L256 256l32.6-4.1 19.8-2.5zM92 384c-27.6-35.3-44-79.7-44-128C48 141.1 141.1 48 256 48c95 0 175.2 63.7 200 150.7L252 224.2l-40.2 5 14.2 38 43.7 116.5c1.5 4 2.3 8.3 2.3 12.5v1.3c0 19-15.4 34.4-34.4 34.4c-4.7 0-9.3-.9-13.5-2.8l-99.5-42.6-6-2.6H112 92zm108-48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm280 56H367.8l-7.5-40H480v40zM373.8 424H480v40H381.3l-7.5-40z'
      
    ]
  };

  

  
  

  var faGrid = {
    prefix: 'fasl',
    iconName: 'grid',
    icon: [
      448,
      512,
      ["grid-3"],
      'e195',
      
      'M96 64v64H32V64H96zM32 32H0V64v64 32H32 96h32V128 64 32H96 32zM96 224v64H32V224H96zM32 192H0v32 64 32H32 96h32V288 224 192H96 32zm0 192H96v64H32V384zM0 352v32 64 32H32 96h32V448 384 352H96 32 0zM256 64v64H192V64h64zM192 32H160V64v64 32h32 64 32V128 64 32H256 192zm0 192h64v64H192V224zm-32-32v32 64 32h32 64 32V288 224 192H256 192 160zm96 192v64H192V384h64zm-64-32H160v32 64 32h32 64 32V448 384 352H256 192zM352 64h64v64H352V64zM320 32V64v64 32h32 64 32V128 64 32H416 352 320zm96 192v64H352V224h64zm-64-32H320v32 64 32h32 64 32V288 224 192H416 352zm0 192h64v64H352V384zm-32-32v32 64 32h32 64 32V448 384 352H416 352 320z'
      
    ]
  };

  
    var faGrid3 = faGrid;
  

  
  

  var faPanFrying = {
    prefix: 'fasl',
    iconName: 'pan-frying',
    icon: [
      576,
      512,
      [127859],
      'e42c',
      
      'M224 32a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 416c54.4 0 104.3-19.4 143.1-51.7l104.3 94.2L495.2 512l20.6-24.5 39.3-46.6 20.8-24.6-27-17.7L427 318.8c13.5-28.8 21-60.9 21-94.8C448 100.3 347.7 0 224 0S0 100.3 0 224S100.3 448 224 448zm268.1 18.1l-101.8-92c7.7-8.5 14.8-17.7 21.1-27.3l116.8 76.4-36.1 42.8zM484.8 440a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM152.6 102.3c-14.5 13.9-22.6 32.1-24.3 50.7c-2.1 23.5-8.7 52.4-19.4 71C82.4 269.9 98.1 328.6 144 355.1s104.6 10.8 131.1-35.1c2.9-5.1 8.9-10.9 16.9-15.8c7.9-4.9 16.4-8 23.1-9c12.8-1.8 25.4-6.7 36.5-15c35.5-26.3 42.9-76.4 16.6-111.9c-11.4-15.3-27.2-25.5-44.4-29.8c-8.7-2.2-20-7.1-31-13.6s-20.9-13.8-27.1-20.3c-30.6-31.9-81.3-32.9-113.1-2.2zm90 24.4c8.9 9.3 21.4 18.4 34.1 25.8s26.7 13.8 39.2 17c10.3 2.6 19.8 8.7 26.6 17.9c15.8 21.3 11.3 51.4-10 67.1c-6.7 5-14.2 7.9-21.9 9c-11.9 1.7-24.6 6.7-35.4 13.4c-10.8 6.7-21.4 15.9-27.8 27.1c-17.7 30.6-56.8 41.1-87.4 23.4s-41.1-56.8-23.4-87.4c14-24.3 21.3-58.4 23.6-84.2c1-11.2 5.8-22 14.5-30.4c19.1-18.4 49.5-17.8 67.9 1.3zM200 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z'
      
    ]
  };

  

  
  

  var faAddressBook = {
    prefix: 'fasl',
    iconName: 'address-book',
    icon: [
      512,
      512,
      [62138,"contact-book"],
      'f2b9',
      
      'M64 32V480H416V32H64zM32 0H64 416h32V32 480v32H416 64 32V480 32 0zM512 64V80v64 16H480V144 80 64h32zm0 128v16 64 16H480V272 208 192h32zm0 144v64 16H480V400 336 320h32v16zM272 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm7.1 128l-21.3 64H128l32-96H320l32 96H318.3l-21.3-64H183.1z'
      
    ]
  };

  
    var faContactBook = faAddressBook;
  

  
  

  var faCartMinus = {
    prefix: 'fasl',
    iconName: 'cart-minus',
    icon: [
      576,
      512,
      [],
      'e0db',
      
      'M0 0H16 80 92.8l2.8 12.5L151 256H476L541.9 32h33.4L503.4 276.5 500 288H488 158.2l14.5 64H496h16v32H496 160 147.2l-2.8-12.5L67.2 32H16 0V0zM184 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm296 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM256 112H384h16v32H384 256 240V112h16z'
      
    ]
  };

  

  
  

  var faPager = {
    prefix: 'fasl',
    iconName: 'pager',
    icon: [
      512,
      512,
      [128223],
      'f815',
      
      'M480 96V416H32V96H480zM32 64H0V96 416v32H32 480h32V416 96 64H480 32zM64 320v32H80h64 16V320H144 80 64zm128 0v32h16 64 16V320H272 208 192zM96 160H416v96H96V160zM64 128v32 96 32H96 416h32V256 160 128H416 96 64z'
      
    ]
  };

  

  
  

  var faMerge = {
    prefix: 'fasl',
    iconName: 'merge',
    icon: [
      512,
      512,
      [],
      'e526',
      
      'M0 64H16 96h64 8.1l4.8 6.6L296.1 240H449.4l-52.7-52.7L385.4 176 408 153.4l11.3 11.3L494.6 240H496v1.4l3.3 3.3L510.6 256l-11.3 11.3-3.3 3.3V272h-1.4l-75.3 75.3L408 358.6 385.4 336l11.3-11.3L449.4 272H296.1L172.9 441.4l-4.8 6.6H160 96 16 0V416H16 96h55.9L268.2 256 151.9 96H96 16 0V64z'
      
    ]
  };

  

  
  

  var faCircleH = {
    prefix: 'fasl',
    iconName: 'circle-h',
    icon: [
      512,
      512,
      [9405,"hospital-symbol"],
      'f47e',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 144V128H336v16 96l-160 0V144 128H144v16 96 32l0 96v16h32V368l0-96H336v96 16h32V368 256 144z'
      
    ]
  };

  
    var faHospitalSymbol = faCircleH;
  

  
  

  var faHexagonXmark = {
    prefix: 'fasl',
    iconName: 'hexagon-xmark',
    icon: [
      512,
      512,
      ["times-hexagon","xmark-hexagon"],
      'f2ee',
      
      'M36.9 256L146.6 64H365.4L475.1 256 365.4 448H146.6L36.9 256zM128 32L0 256 128 480H384L512 256 384 32H128zm63.4 136.8l-22.6 22.6 11.3 11.3L233.4 256l-53.3 53.3-11.3 11.3 22.6 22.6 11.3-11.3L256 278.6l53.3 53.3 11.3 11.3 22.6-22.6-11.3-11.3L278.6 256l53.3-53.3 11.3-11.3-22.6-22.6-11.3 11.3L256 233.4l-53.3-53.3-11.3-11.3z'
      
    ]
  };

  
    var faTimesHexagon = faHexagonXmark;
  
    var faXmarkHexagon = faHexagonXmark;
  

  
  

  var faCartXmark = {
    prefix: 'fasl',
    iconName: 'cart-xmark',
    icon: [
      576,
      512,
      [],
      'e0dd',
      
      'M0 0H16 80 92.8l2.8 12.5L151 256H476L541.9 32h33.4L503.4 276.5 500 288H488 158.2l14.5 64H496h16v32H496 160 147.2l-2.8-12.5L67.2 32H16 0V0zM184 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm296 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM379.3 91.3L342.6 128l36.7 36.7L390.6 176 368 198.6l-11.3-11.3L320 150.6l-36.7 36.7L272 198.6 249.4 176l11.3-11.3L297.4 128 260.7 91.3 249.4 80 272 57.4l11.3 11.3L320 105.4l36.7-36.7L368 57.4 390.6 80 379.3 91.3z'
      
    ]
  };

  

  
  

  var faBowArrow = {
    prefix: 'fasl',
    iconName: 'bow-arrow',
    icon: [
      512,
      512,
      [127993],
      'f6b9',
      
      'M363.5 59.5L336 32l38.3-7L478.4 6.1 512 0l-6.1 33.6L487 137.7 480 176l-27.5-27.5-33.2-33.2L181.2 353.4 200 416l-70.3 70.3L104 512 93.6 477.2 80 432 34.8 418.4 0 408l25.7-25.7L96 312l62.6 18.8L396.7 92.7 363.5 59.5zm95.9 50.7l12.8-70.4L401.8 52.6l57.6 57.6zm-78.8 89l23.1-23.1c27.9 41 44.2 90.5 44.2 143.9c0 56.8-18.5 109.2-49.7 151.6l5 5L414.6 488 392 510.6l-11.3-11.3L230.6 349.3l22.6-22.6L375.3 448.7C401 412.3 416 367.9 416 320c0-44.5-13-85.9-35.3-120.8zm-368-67.9L1.4 120 24 97.4l11.3 11.3 5 5C82.8 82.5 135.2 64 192 64c53.3 0 102.9 16.3 143.9 44.2l-23.1 23.1C277.9 109 236.5 96 192 96c-47.9 0-92.3 15-128.7 40.7L185.4 258.7l-22.6 22.6L12.7 131.3zm98 291.5l8.6 28.7 44.6-44.6-13.6-45.2-45.2-13.6L60.5 392.7l28.7 8.6 16.5 5 5 16.5z'
      
    ]
  };

  

  
  

  var faFileCircleExclamation = {
    prefix: 'fasl',
    iconName: 'file-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e4eb',
      
      'M352 192v19.2c10.1-5.2 20.8-9.4 32-12.6V152L232 0H32 0V32 480v32H32 330.8c-12.9-9.1-24.5-19.9-34.6-32H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM320 368a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM448 448V416H416v32h32zm0-160H416v16 80 16h32V384 304 288z'
      
    ]
  };

  

  
  

  var faEnvelopesBulk = {
    prefix: 'fasl',
    iconName: 'envelopes-bulk',
    icon: [
      640,
      512,
      ["mail-bulk"],
      'f674',
      
      'M96 32H416V64h32V32 0H416 96 64V32 192H96V32zM224 192V128H608V384H416v32H608h32V384 128 96H608 224 192v32 64h32zM32 256H352v20.8L192 389.9 32 276.8V256zm0 224V315.9L182.8 422.5l9.2 6.5 9.2-6.5L352 315.9V480H32zm0-256H0v32V480v32H32 352h32V480 256 224H352 32zm464-64H480v16 64 16h16 64 16V240 176 160H560 496zm16 64V192h32v32H512z'
      
    ]
  };

  
    var faMailBulk = faEnvelopesBulk;
  

  
  

  var faJarWheat = {
    prefix: 'fasl',
    iconName: 'jar-wheat',
    icon: [
      320,
      512,
      [],
      'e517',
      
      'M48 0V32H272V0H48zM288 96V480H32V96H288zM32 64H0V96 480v32H32 288h32V480 96 64H288 32zM144 448v16h32V448 432h8c38.7 0 71-27.5 78.4-64c1-5.2 1.6-10.5 1.6-16V336H232h-8c-26.2 0-49.4 12.6-64 32c-14.6-19.4-37.8-32-64-32H88 56v16c0 5.5 .6 10.8 1.6 16c7.4 36.5 39.7 64 78.4 64h8v16zm34.7-48c6.6-18.6 24.4-32 45.3-32h5.3c-6.6 18.6-24.4 32-45.3 32h-5.3zM136 400c-20.9 0-38.7-13.4-45.3-32H96c20.9 0 38.7 13.4 45.3 32H136zm42.7-208c6.6-18.6 24.4-32 45.3-32h5.3c-6.6 18.6-24.4 32-45.3 32h-5.3zM160 160c-14.6-19.4-37.8-32-64-32H88 56v16c0 5.5 .6 10.8 1.6 16c7.4 36.5 39.7 64 78.4 64h8 32 8c38.7 0 71-27.5 78.4-64c1-5.2 1.6-10.5 1.6-16V128H232h-8c-26.2 0-49.4 12.6-64 32zm-24 32c-20.9 0-38.7-13.4-45.3-32H96c20.9 0 38.7 13.4 45.3 32H136zm42.7 104c6.6-18.6 24.4-32 45.3-32h5.3c-6.6 18.6-24.4 32-45.3 32h-5.3zM160 264c-14.6-19.4-37.8-32-64-32H88 56v16c0 5.5 .6 10.8 1.6 16c7.4 36.5 39.7 64 78.4 64h8 32 8c38.7 0 71-27.5 78.4-64c1-5.2 1.6-10.5 1.6-16V232H232h-8c-26.2 0-49.4 12.6-64 32zm-24 32c-20.9 0-38.7-13.4-45.3-32H96c20.9 0 38.7 13.4 45.3 32H136z'
      
    ]
  };

  

  
  

  var faSpoon = {
    prefix: 'fasl',
    iconName: 'spoon',
    icon: [
      512,
      512,
      [61873,129348,"utensil-spoon"],
      'f2e5',
      
      'M256 160.2c0-27.5 17-59.3 48.5-85.6C335.6 48.7 376.5 32 416 32c35.3 0 64 28.7 64 64c0 39.5-16.7 80.4-42.6 111.5C411.1 239 379.3 256 351.8 256H325.5l-18.7-18.7-32-32L256 186.5V160.2zm28.1 99.7L312.2 288h39.6C432 288 512 192 512 96c0-53-43-96-96-96C320 0 224 80 224 160.2v39.6l28.1 28.1 4.7 4.7L4.7 484.7l22.6 22.6L279.4 255.2l4.7 4.7z'
      
    ]
  };

  
    var faUtensilSpoon = faSpoon;
  

  
  

  var faCheeseSwiss = {
    prefix: 'fasl',
    iconName: 'cheese-swiss',
    icon: [
      512,
      512,
      [129472],
      'f7f0',
      
      'M32 448H480V288H413.3c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32H32V448zM413.3 256H480c0-102.5-80.3-186.2-181.4-191.7l-43.8 34c19.2 6.2 33.2 24.3 33.2 45.7c0 26.5-21.5 48-48 48c-25.5 0-46.3-19.8-47.9-44.9L52.1 256H322.7c6.6-18.6 24.4-32 45.3-32s38.7 13.4 45.3 32zM0 256L288 32c123.7 0 224 100.3 224 224V448v32H480 32 0V448 256zM192 368a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM240 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM384 272a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z'
      
    ]
  };

  

  
  

  var faHouseBuilding = {
    prefix: 'fasl',
    iconName: 'house-building',
    icon: [
      640,
      512,
      [],
      'e1b1',
      
      'M288 32H608V480H416v32H608h32V480 32 0H608 288 256V32v75.7l32 26.7V32zm50 144h14 64 16V160 96 80H416 352 336V96v64 14.3l2 1.7zm142 32H464v16 64 16h16 64 16V288 224 208H544 480zm48 64H496V240h32v32zm-64 64v16 64 16h16 64 16V416 352 336H544 480 464zm64 32v32H496V368h32zM368 144V112h32v32H368zm96-64V96v64 16h16 64 16V160 96 80H544 480 464zm32 32h32v32H496V112zM32 271L192 137.7 352 271V480H32V271zM0 256V480v32H32 352h32V480 256L192 96 0 256zm160 32h64v64H160V288zm0-32H128v32 64 32h32 64 32V352 288 256H224 160z'
      
    ]
  };

  

  
  

  var faLeafHeart = {
    prefix: 'fasl',
    iconName: 'leaf-heart',
    icon: [
      512,
      512,
      [],
      'f4cb',
      
      'M304 128H272c-79.5 0-144 64.5-144 144c0 79.5 64.4 144 144 144h0l.8 0c109-.5 207.2-110.5 207.2-259.4c0-23-2.4-45.2-6.9-66.3C447.5 113.7 413.4 128 376 128H304v0zM463.2 54.3c8.7-10.8 15.5-23.3 19.8-36.9c6.1 13.5 11.3 27.7 15.5 42.4c8.8 30.3 13.5 62.9 13.5 96.8C512 317.1 405.1 447.3 273 448l-1 0c-88.5 0-161.8-65.4-174.2-150.5C57.6 329.8 32 379.3 32 434.7V464v16H0V464 434.7C0 361 38.4 296.1 96.5 259.1C103 167.9 179.1 96 272 96l32 0h72c35.2 0 66.6-16.2 87.2-41.7zm-197 178.1l-5.2-4.8c-4.3-4-10-6.3-15.9-6.3h-3.5c-10.9 0-19.8 8.9-19.8 19.8c0 5.5 2.3 10.7 6.3 14.4l60 56.1 60-56.1c4-3.7 6.3-9 6.3-14.4c0-10.9-8.9-19.8-19.8-19.8H331c-5.9 0-11.6 2.2-15.9 6.3l-5.2 4.8L288 252.9l-21.9-20.4zm-76.4 8.7c0-28.6 23.2-51.8 51.8-51.8H245c14 0 27.5 5.3 37.8 14.9l5.2 4.8 5.2-4.8c10.3-9.6 23.8-14.9 37.8-14.9h3.5c28.6 0 51.8 23.2 51.8 51.8c0 14.3-5.9 28-16.4 37.8l-70.9 66.4L288 355.5l-10.9-10.2-70.9-66.4c-10.5-9.8-16.4-23.5-16.4-37.8z'
      
    ]
  };

  

  
  

  var faArrowsRotateReverse = {
    prefix: 'fasl',
    iconName: 'arrows-rotate-reverse',
    icon: [
      512,
      512,
      [],
      'e630',
      
      'M445.4 224C430.1 133.2 351.1 64 256 64c-71.1 0-133.1 38.6-166.3 96H144h16v32H144 74.9 48 41.3 32V176 80 64H64V80v60.5C103.2 75.5 174.5 32 256 32c112.8 0 206.2 83.4 221.7 192H445.4zM256 448c71.1 0 133.1-38.6 166.3-96H367.8h-16V320h16 69.3 26.7 6.9 9.1v16 96 16h-32V432 371.8C408.6 436.6 337.4 480 256 480C143.2 480 49.8 396.6 34.3 288H66.7C81.9 378.8 160.9 448 256 448z'
      
    ]
  };

  

  
  

  var faArrowDownUpAcrossLine = {
    prefix: 'fasl',
    iconName: 'arrow-down-up-across-line',
    icon: [
      576,
      512,
      [],
      'e4af',
      
      'M160 510.6l11.3-11.3 96-96L278.6 392 256 369.4l-11.3 11.3L176 449.4V272H560h16V240H560 432V62.6l68.7 68.7L512 142.6 534.6 120l-11.3-11.3-96-96L416 1.4 404.7 12.7l-96 96L297.4 120 320 142.6l11.3-11.3L400 62.6V240H16 0v32H16 144V449.4L75.3 380.7 64 369.4 41.4 392l11.3 11.3 96 96L160 510.6zM144 48V192h32V48 32H144V48zM400 320V464v16h32V464 320H400z'
      
    ]
  };

  

  
  

  var faSpaghettiMonsterFlying = {
    prefix: 'fasl',
    iconName: 'spaghetti-monster-flying',
    icon: [
      640,
      512,
      ["pastafarianism"],
      'f67b',
      
      'M192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm42 80.3c13.5-11.7 22-29 22-48.3c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64c4.6 0 9.1-.5 13.4-1.4L219 153.7c-24.9 14.5-43.8 33.5-59.2 52.1c-7.6 9.1-14.4 18.2-20.6 26.4l-.5 .7c-6.4 8.5-12 15.9-17.4 22.2c-11.3 13-18.7 17-25.2 17c-5 0-8.7-1.8-12.7-5.5c-4.5-4.4-8.5-10.5-13.8-18.9l-.5-.7c-4.7-7.5-10.6-16.9-18.3-24.3C42.3 214.2 31 208 16 208H0v32H16c5 0 8.7 1.8 12.7 5.5c4.5 4.4 8.5 10.5 13.8 18.9l.5 .7c4.7 7.5 10.6 16.9 18.3 24.3C69.7 297.8 81 304 96 304c19.4 0 34.1-11.4 45.7-23.9l1 1.5c4.4 6.5 10.2 14.3 17.2 22.6c-3 8.5-5.6 17-8 24.9l0 0-1.3 4.3c-3.4 11.2-6.5 20.8-10.2 28.8c-3.7 8-7.5 13.3-11.7 16.7c-3.8 3-8.8 5.2-16.7 5.2c-11 0-21-5.3-36.8-13.8l-.6-.3c-15-8-34.2-17.9-58.5-17.9H0v32H16c15.6 0 28.5 6.1 43.5 14.1l3.1 1.7C75.9 407 92.7 416 112 416c14.6 0 26.8-4.2 36.7-12.2c9.6-7.6 16-17.9 20.8-28.2c4.8-10.3 8.4-21.9 11.8-32.9l1.3-4.4c.9-2.8 1.7-5.6 2.6-8.4c19.3 17 44.1 33.4 74.6 43.2l-1 3.4 0 0c-5.4 18.4-13 43.8-24.3 65.6c-13 25-27.2 37.9-42.4 37.9H176v32h16c35.1 0 57.3-29.1 70.8-55.1c12.8-24.7 21.2-53.1 26.6-71.2c.5-1.8 1-3.5 1.5-5.1l.1-.3c9.2 1.4 18.9 2.1 29 2.1s19.7-.7 29-2.1l.1 .3c.5 1.6 1 3.3 1.5 5.1l0 0c5.3 18.1 13.8 46.5 26.6 71.2c13.5 26 35.8 55.1 70.8 55.1h16V480H448c-15.2 0-29.4-12.9-42.4-37.9c-11.3-21.8-18.9-47.2-24.3-65.6l0 0 0 0-1-3.4c30.5-9.8 55.3-26.2 74.6-43.2c.9 2.8 1.7 5.6 2.6 8.4l1.3 4.4c3.4 11 7 22.6 11.8 32.9c4.8 10.3 11.2 20.6 20.8 28.2c9.9 7.9 22.1 12.2 36.7 12.2c19.3 0 36.1-9 49.4-16.2l3.1-1.7c15-8 27.8-14.1 43.5-14.1h16V352H624c-24.4 0-43.5 9.9-58.5 17.9l-.6 .3C549 378.7 539 384 528 384c-7.9 0-12.9-2.1-16.7-5.2c-4.2-3.3-8-8.6-11.7-16.7c-3.7-8.1-6.8-17.7-10.2-28.8l-1.3-4.3c-2.4-7.9-5-16.4-8-24.9c7.1-8.3 12.8-16.1 17.2-22.6l1-1.5C509.9 292.6 524.6 304 544 304c15 0 26.3-6.2 34.8-14.5c7.7-7.4 13.6-16.8 18.3-24.3l0 0 0 0 .5-.7c5.3-8.4 9.2-14.6 13.8-18.9c3.9-3.8 7.6-5.5 12.7-5.5h16V208H624c-15 0-26.3 6.2-34.8 14.5c-7.7 7.4-13.6 16.8-18.3 24.3l0 0 0 0-.5 .7c-5.3 8.4-9.2 14.6-13.8 18.9c-3.9 3.8-7.6 5.5-12.7 5.5c-6.5 0-13.9-4-25.2-17c-5.4-6.2-11-13.6-17.4-22.2l-.5-.7c-6.2-8.2-13-17.3-20.6-26.4c-15.5-18.6-34.4-37.5-59.2-52.1l13.5-27.1c4.3 .9 8.8 1.4 13.4 1.4c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 19.3 8.5 36.5 22 48.3L392.1 140c-20.4-7.5-44.2-12-72.1-12s-51.7 4.5-72.1 12L234 112.3zM448 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm4.6 259.8c-.9 .8-1.7 1.7-2.5 2.6c-2.2 2.4-4.6 4.8-7.1 7.2c-27.3 26.3-67.9 52-123 52s-95.7-25.6-123-52c-2.5-2.4-4.8-4.8-7.1-7.2c-.7-1-1.5-1.8-2.5-2.6c-8.9-9.7-15.9-19-20.9-26.4c-2.3-3.4-4.2-6.4-5.7-8.9l3.4-4.5 .3-.4c6.3-8.4 12.7-16.9 19.8-25.4C212.5 192.3 250.4 160 320 160s107.5 32.3 135.7 66.2c7.1 8.5 13.5 17 19.8 25.4l.3 .4 3.4 4.5c-1.5 2.5-3.4 5.5-5.7 8.9c-5 7.4-12 16.7-20.9 26.4z'
      
    ]
  };

  
    var faPastafarianism = faSpaghettiMonsterFlying;
  

  
  

  var faTruckFlatbed = {
    prefix: 'fasl',
    iconName: 'truck-flatbed',
    icon: [
      640,
      512,
      [],
      'e2b6',
      
      'M400 96H384v16V384H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H16 0v32H16 64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h48 16V384H624 608V224v-5.9l-3.9-4.5-96-112L503.4 96H496 400zM224 416A64 64 0 1 1 96 416a64 64 0 1 1 128 0zm192-71.6V256H576V384h-5.5c-13.2-37.3-48.7-64-90.5-64c-24.6 0-47 9.2-64 24.4zM570.9 224H416V128h72.6l82.3 96zM480 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faClarinet = {
    prefix: 'fasl',
    iconName: 'clarinet',
    icon: [
      640,
      512,
      [],
      'f8ad',
      
      'M224 96h16 32 96 96 32 16v32H496 480v32h57.8L608 121l32-17.8v36.6V372.2v36.6L608 391l-70.2-39H100.5L0 321.9V190.1L100.5 160H256V128H240 224V96zm224 96v0H384v0H352v0H288v0H256v0H105.2L32 214V298l73.2 22H537.8h8.3l7.2 4L608 354.4V157.6L553.3 188l-7.2 4h-8.3H480v0H448zm0-64H384v32h64V128zm-96 0H288v32h64V128zM272 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faBong = {
    prefix: 'fasl',
    iconName: 'bong',
    icon: [
      448,
      512,
      [],
      'f55c',
      
      'M112 245.4l16-9.2V217.7 32H256V217.7v18.5l16 9.2c29.5 17.1 53 43.2 66.7 74.6H45.3C59 288.6 82.5 262.4 112 245.4zM35.2 352H348.8c2.1 10.3 3.2 21 3.2 32c0 36-11.9 69.3-32 96H64c-20.1-26.7-32-60-32-96c0-11 1.1-21.7 3.2-32zM288 217.7V32h16 16V0H304 288 256 128 96 80 64V32H80 96V217.7C38.6 250.9 0 312.9 0 384c0 49.2 18.5 94 48.9 128H335.1c30.4-34 48.9-78.8 48.9-128c0-39-11.7-75.4-31.7-105.7L400 230.6l20.7 20.7L432 262.6 454.6 240l-11.3-11.3-32-32-32-32L368 153.4 345.4 176l11.3 11.3L377.4 208l-45 45c-12.9-13.8-27.9-25.8-44.4-35.3z'
      
    ]
  };

  

  
  

  var faCameraMovie = {
    prefix: 'fasl',
    iconName: 'camera-movie',
    icon: [
      576,
      512,
      [127909,127910],
      'f8a9',
      
      'M144 0c40.8 0 76.4 21.8 96 54.3C259.6 21.8 295.2 0 336 0c61.9 0 112 50.1 112 112s-50.1 112-112 112H144C82.1 224 32 173.9 32 112S82.1 0 144 0zM64 112c0 44.2 35.8 80 80 80H336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-39.6 0-72.5 28.8-78.9 66.6L254.9 112H241.3h-2.7H225.1l-2.2-13.4C216.5 60.8 183.6 32 144 32c-44.2 0-80 35.8-80 80zm80-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM152 288H136 96V480H384V288H152zm0-32H384h32v32V480v32H384 96 64V480 288H16 0V256H16 64 96h40 16zM448 467.7V433.8l96 33.2V300.9l-96 33.2V300.3l96-33.2L576 256v33.9V478.1 512l-32-11.1-96-33.2z'
      
    ]
  };

  

  
  

  var faSigma = {
    prefix: 'fasl',
    iconName: 'sigma',
    icon: [
      384,
      512,
      [8721],
      'f68b',
      
      'M0 480H16 368h16V464 368 352H352v16 80H52.5L219.8 266.9l10-10.9-10-10.9L52.5 64H352v80 16h32V144 48 32H368 16 0V54.3l4.2 4.6L186.2 256 4.2 453.1 0 457.7V480z'
      
    ]
  };

  

  
  

  var faFaceGrinStars = {
    prefix: 'fasl',
    iconName: 'face-grin-stars',
    icon: [
      512,
      512,
      [129321,"grin-stars"],
      'f587',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm89.9-166.2c-22.5 23.6-54.5 38.3-89.9 38.3s-67.4-14.7-89.9-38.3c28.5 5.4 58.7 8.3 89.9 8.3s61.4-2.9 89.9-8.3zm25-38.6c-35.1 9.6-74 14.9-114.9 14.9s-79.9-5.3-114.9-14.9c-13-3.5-25.4-7.7-37.2-12.3c3.1 13.8 8 26.9 14.5 39c26.2 48.9 78 82.2 137.7 82.2s111.5-33.3 137.7-82.2c6.5-12.1 11.4-25.2 14.5-39c-11.8 4.6-24.3 8.8-37.2 12.3zM160 99.7L146.8 119l-17.9 26.2-30.4 9L76 160.7l14.2 18.5 19.4 25.2-.9 31.7-.6 23.3 22-7.8L160 241l29.9 10.6 22 7.8-.6-23.3-.9-31.7 19.4-25.2L244 160.7l-22.4-6.6-30.4-9L173.2 119 160 99.7zm0 56.6l8 11.6 3.2 4.7 5.5 1.6 13.5 4-8.6 11.2-3.5 4.5 .2 5.7 .4 14.1-13.3-4.7L160 207l-5.4 1.9-13.3 4.7 .4-14.1 .2-5.7-3.5-4.5-8.6-11.2 13.5-4 5.5-1.6 3.2-4.7 8-11.6zM352 99.7L338.8 119l-17.9 26.2-30.4 9L268 160.7l14.2 18.5 19.4 25.2-.9 31.7-.6 23.3 22-7.8L352 241l29.9 10.6 22 7.8-.6-23.3-.9-31.7 19.4-25.2L436 160.7l-22.4-6.6-30.4-9L365.2 119 352 99.7zm0 56.6l8 11.6 3.2 4.7 5.5 1.6 13.5 4-8.6 11.2-3.5 4.5 .2 5.7 .4 14.1-13.3-4.7L352 207l-5.4 1.9-13.3 4.7 .4-14.1 .2-5.7-3.5-4.5-8.6-11.2 13.5-4 5.5-1.6 3.2-4.7 8-11.6z'
      
    ]
  };

  
    var faGrinStars = faFaceGrinStars;
  

  
  

  var faSquareP = {
    prefix: 'fasl',
    iconName: 'square-p',
    icon: [
      448,
      512,
      [],
      'e279',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm144 96h88c48.6 0 88 39.4 88 88s-39.4 88-88 88H160v64 16H128V368 288 144 128h16zm88 144c30.9 0 56-25.1 56-56s-25.1-56-56-56H160V272h72z'
      
    ]
  };

  

  
  

  var faBringForward = {
    prefix: 'fasl',
    iconName: 'bring-forward',
    icon: [
      512,
      512,
      [],
      'f856',
      
      'M192 480H480V192H384V160h96 32v32V480v32H480 192 160V480 384h32v96zM32 320H320V32H32V320zm288 32H32 0V320 32 0H32 320h32V32 320v32H320zm-64-96V96H96V256H256zm32 32H256 96 64V256 96 64H96 256h32V96 256v32z'
      
    ]
  };

  

  
  

  var faRecordVinyl = {
    prefix: 'fasl',
    iconName: 'record-vinyl',
    icon: [
      512,
      512,
      [],
      'f8d9',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM384 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM256 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faTruckPlane = {
    prefix: 'fasl',
    iconName: 'truck-plane',
    icon: [
      640,
      512,
      [],
      'e58f',
      
      'M176.3 56.4C165.9 72.3 160 91 160 103v89.8 8.9l-7.6 4.7L32 280.9v56.9l106.9-35.6 21.1-7v22.2l0 82.7v7.5l-5.8 4.8L112 447.5V479l82.5-30 5-1.8 5.1 1.6L256 464.5V498l-55.6-17.1-83 30.2-2.6 1H112 96 80V496 440v-7.5l5.8-4.8L128 392.5l0-53L21.1 375.2 0 382.2V360 272v-8.9l7.6-4.7L128 183.8V103c0-19.7 8.6-44.5 21.5-64.1C161.9 19.8 182.1 0 208 0c26.3 0 46.5 19.7 58.9 38.9C278.2 56.4 286 77.7 287.7 96H255.5c-1.6-11.7-7-26.7-15.4-39.7C229.5 39.9 217.7 32 208 32c-9.1 0-20.9 7.8-31.7 24.4zM608 160H320V304h14.6l2.8-9.2 19.2-64 6.8-22.8h23.8H540.8h23.8l6.8 22.8 19.2 64 2.8 9.2H608V160zm32 144v16V432v16 16H624 608v32 16H576V496 464H352v32 16H320V496 464H304 288V448 432 320 304 160 128h32H608h32v32V304zm-37 32H560 368 325h-5v96h32H576h32V336h-5zm-43-32l-9.6-32-9.6-32H387.2l-9.6 32L368 304h33.4H526.6 560zM376 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faCircleHeart = {
    prefix: 'fasl',
    iconName: 'circle-heart',
    icon: [
      512,
      512,
      ["heart-circle"],
      'f4c7',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM231 203.9l25 31.2 25-31.2 9.3-11.6c8.3-10.4 20.8-16.4 34.1-16.4c24.1 0 43.6 19.5 43.6 43.6v3.6c0 12.5-5 24.5-13.8 33.4l-24.8 24.8L256 354.7l-73.4-73.4-24.8-24.8c-8.9-8.9-13.8-20.9-13.8-33.4v-3.6c0-24.1 19.5-43.6 43.6-43.6c13.3 0 25.8 6 34.1 16.4l9.3 11.6zm121 100l24.8-24.8c14.9-14.9 23.2-35 23.2-56v-3.6c0-41.8-33.9-75.6-75.6-75.6c-17 0-33.4 5.7-46.6 16c-4.6 3.6-8.8 7.7-12.5 12.4L256 183.9l-9.3-11.6c-3.7-4.6-7.9-8.8-12.5-12.4c-13.2-10.3-29.5-16-46.6-16c-41.8 0-75.6 33.9-75.6 75.6v3.6c0 21 8.3 41.1 23.2 56L160 303.9l73.4 73.4L256 399.9l22.6-22.6L352 303.9z'
      
    ]
  };

  
    var faHeartCircle = faCircleHeart;
  

  
  

  var faChevronsLeft = {
    prefix: 'fasl',
    iconName: 'chevrons-left',
    icon: [
      512,
      512,
      ["chevron-double-left"],
      'f323',
      
      'M52.7 244.7L41.4 256l11.3 11.3 192 192L256 470.6 278.6 448l-11.3-11.3L86.6 256 267.3 75.3 278.6 64 256 41.4 244.7 52.7l-192 192zm192 0L233.4 256l11.3 11.3 192 192L448 470.6 470.6 448l-11.3-11.3L278.6 256 459.3 75.3 470.6 64 448 41.4 436.7 52.7l-192 192z'
      
    ]
  };

  
    var faChevronDoubleLeft = faChevronsLeft;
  

  
  

  var faUnion = {
    prefix: 'fasl',
    iconName: 'union',
    icon: [
      384,
      512,
      [8899],
      'f6a2',
      
      'M32 32V48 288c0 88.4 71.6 160 160 160s160-71.6 160-160V48 32h32V48 288c0 106-86 192-192 192S0 394 0 288V48 32H32z'
      
    ]
  };

  

  
  

  var faMenorah = {
    prefix: 'fasl',
    iconName: 'menorah',
    icon: [
      640,
      512,
      [],
      'f676',
      
      'M48 16V80 96H16V80 16 0H48V16zm96 0V80 96H112V80 16 0h32V16zm96 0V80 96H208V80 16 0h32V16zm96 0V80 96H304V80 16 0h32V16zm96 0V80 96H400V80 16 0h32V16zm96 0V80 96H496V80 16 0h32V16zm96 0V80 96H592V80 16 0h32V16zM48 128l0 16 0 160c0 26.5 21.5 48 48 48h16V144 128h32v16V352h64V144 128h32v16V352h64l0-208V128h32v16l0 208h64V144 128h32v16V352h64V144 128h32v16V352h16c26.5 0 48-21.5 48-48l0-160V128h32v16l0 160c0 44.2-35.8 80-80 80H528 496 432 400 336v96H496h16v32H496 320 144 128V480h16H304V384H240 208 144 112 96c-44.2 0-80-35.8-80-80l0-160 0-16H48z'
      
    ]
  };

  

  
  

  var faFileCsv = {
    prefix: 'fasl',
    iconName: 'file-csv',
    icon: [
      512,
      512,
      [],
      'f6dd',
      
      'M352 192v96h32V152L232 0H32 0V32 480v32H32 96V480H32V32H192V176v16h16H352zm-5.3-32H224V37.3L346.7 160zM200 352c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-8V448H224v16 8c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v8 16h32V400v-8c0-22.1-17.9-40-40-40H200zm133.1 0c-24.9 0-45.1 20.2-45.1 45.1c0 17.8 10.5 34 26.8 41.2l37.4 16.6c4.7 2.1 7.8 6.8 7.8 12c0 7.2-5.9 13.1-13.1 13.1H304 288v32h16 42.9c24.9 0 45.1-20.2 45.1-45.1c0-17.8-10.5-34-26.8-41.2l-37.4-16.6c-4.7-2.1-7.8-6.8-7.8-12c0-7.2 5.9-13.1 13.1-13.1H368h16V352H368 333.1zM448 352H416v16 64 2.9l1 2.7 24 64 3.9 10.4H456h16 11.1l3.9-10.4 24-64 1-2.7V432 368 352H480v16 61.1l-16 42.7-16-42.7V368 352z'
      
    ]
  };

  

  
  

  var faLaptop = {
    prefix: 'fasl',
    iconName: 'laptop',
    icon: [
      640,
      512,
      [128187],
      'f109',
      
      'M544 64H96V352H64V64 32H96 544h32V64 352H544V64zM61.3 448H578.7L608 418.7V416H32v2.7L61.3 448zM640 384v32 16l-48 48H48L0 432V416 384H32 608h32z'
      
    ]
  };

  

  
  

  var faPerson = {
    prefix: 'fasl',
    iconName: 'person',
    icon: [
      320,
      512,
      [129485,"male"],
      'f183',
      
      'M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 160 0zM99.3 128h9.6H211.1h9.6l4.5 8.5 76.9 144 7.5 14.1-28.2 15.1-7.5-14.1L224 202.2V496v16H192V496 352H128V496v16H96V496 202.1L46.1 295.5l-7.5 14.1L10.3 294.6l7.5-14.1 76.9-144 4.5-8.5zM128 320h64V160H128V320z'
      
    ]
  };

  
    var faMale = faPerson;
  

  
  

  var faFireFlameSimple = {
    prefix: 'fasl',
    iconName: 'fire-flame-simple',
    icon: [
      384,
      512,
      ["burn"],
      'f46a',
      
      'M180.9 9.7L192 0l11.1 9.7c76.7 67.1 135.2 152.5 170 248.3c7.2 19.9 10.9 41.1 10.9 62.2C384 425.4 297.2 512 192 512S0 425.4 0 320.2C0 299 3.7 277.8 10.9 258c34.8-95.8 93.3-181.2 170-248.3zM41 268.9c-5.9 16.3-9 33.8-9 51.3C32 407.6 104.5 480 192 480s160-72.4 160-159.8c0-17.4-3.1-34.9-9-51.3c-31.5-86.5-83.3-164.1-151-226.2C124.3 104.9 72.4 182.4 41 268.9zM202.5 164l18 15.7c32.1 28 57.6 62.7 74.9 101.7l.9 2.1c5 11.3 7.6 23.7 7.6 36C304 381.2 254 432 192 432s-112-50.8-112-112.5c0-12.4 2.6-24.7 7.6-36l.9-2.1c17.3-38.9 42.9-73.6 74.9-101.7l18-15.7 10.5-9.2 10.5 9.2zm-18 39.8c-28.6 25-51.3 55.9-66.7 90.6l-.9 2.1c-3.2 7.2-4.9 15.1-4.9 23c0 44.3 35.9 80.5 80 80.5s80-36.2 80-80.5c0-7.9-1.7-15.8-4.9-23l-.9-2.1c-15.4-34.7-38.2-65.6-66.7-90.6l-7.5-6.5-7.5 6.5z'
      
    ]
  };

  
    var faBurn = faFireFlameSimple;
  

  
  

  var faPersonCarryBox = {
    prefix: 'fasl',
    iconName: 'person-carry-box',
    icon: [
      384,
      512,
      ["person-carry"],
      'f4cf',
      
      'M56 56a24 24 0 1 1 48 0A24 24 0 1 1 56 56zm80 0A56 56 0 1 0 24 56a56 56 0 1 0 112 0zM0 496l0 16 32 0 0-16 0-130.5L1.6 341.6c-.5-.4-1.1-.9-1.6-1.3L0 496zM16 144H0v16V278.9c0 16 8 31 21.4 39.9l100.2 66.8L146.9 512h32.6L151.7 372.9l-1.3-6.5-5.5-3.7L112 340.8V214.5l42.5 66.2 4.7 7.3H168h24 32 16 16 96 32V256 128 96H352 224 192v32V256H176.7L109.5 151.3l-4.7-7.3H96 16zM224 256V128H352V256H256 240 224zM80 176V319.4L39.1 292.2c-4.5-3-7.1-8-7.1-13.3V176H80z'
      
    ]
  };

  
    var faPersonCarry = faPersonCarryBox;
  

  
  

  var faArrowUpLong = {
    prefix: 'fasl',
    iconName: 'arrow-up-long',
    icon: [
      384,
      512,
      ["long-arrow-up"],
      'f176',
      
      'M203.3 11.3L192 0 180.7 11.3l-144 144L25.4 166.6 48 189.3l11.3-11.3L176 61.3V496v16h32V496 61.3L324.7 177.9 336 189.3l22.6-22.6-11.3-11.3-144-144z'
      
    ]
  };

  
    var faLongArrowUp = faArrowUpLong;
  

  
  

  var faCalendarCircleUser = {
    prefix: 'fasl',
    iconName: 'calendar-circle-user',
    icon: [
      576,
      512,
      [],
      'e471',
      
      'M128 16V0H96V16 64H32 0V96v64 32V480v32H32 330.8c-12.9-9.1-24.5-19.9-34.6-32H32V192H352h64 16 16V160 96 64H416 352V16 0H320V16 64H128V16zM32 96H416v64H32V96zM489.5 464.1C472.7 474.2 453 480 432 480s-40.7-5.8-57.5-15.9L390.6 448h82.7l16.1 16.1zm24.9-20.3l-23.1-23.1-4.7-4.7H480 384h-6.6l-4.7 4.7-23.1 23.1C331.2 423.9 320 397.2 320 368c0-61.9 50.1-112 112-112s112 50.1 112 112c0 29.2-11.2 55.9-29.6 75.8zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 320a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z'
      
    ]
  };

  

  
  

  var faTransporter = {
    prefix: 'fasl',
    iconName: 'transporter',
    icon: [
      512,
      512,
      [],
      'e042',
      
      'M480 16V32h16 16V64H496 480V80 96H448V80 64H432 416V32h16 16V16 0h32V16zM64 80V96H80 96v32H80 64v16 16H32V144 128H16 0V96H16 32V80 64H64V80zm192 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM96 448h16H400h16v16 32 16H384V496 480H128v16 16H96V496 464 448zm93-304h7.9H315.1 323l4.8 6.3 84.9 112 9.7 12.7-25.5 19.3-9.7-12.7L320 193V304v96 16H288V400 320H224v80 16H192V400 304 193l-67.2 88.7-9.7 12.7L89.6 275.1l9.7-12.7 84.9-112L189 144zm35 32V288h64V176H224z'
      
    ]
  };

  

  
  

  var faDiagramPredecessor = {
    prefix: 'fasl',
    iconName: 'diagram-predecessor',
    icon: [
      512,
      512,
      [],
      'e477',
      
      'M480 320L32 320l0 128 448 0 0-128zm32 128l0 32-32 0L32 480 0 480l0-32L0 320l0-32 32 0 448 0 32 0 0 32 0 128zM256 64l-64 0L32 64l0 128 224 0 0-128zm32 0l0 128 0 32-32 0L32 224 0 224l0-32L0 64 0 32l32 0 160 0 64 0 32 0 128 0 16 0 0 16 0 137.4 36.7-36.7L480 137.4 502.6 160l-11.3 11.3-64 64L416 246.6l-11.3-11.3-64-64L329.4 160 352 137.4l11.3 11.3L400 185.4 400 64 288 64zM96 112l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0z'
      
    ]
  };

  

  
  

  var faCrateEmpty = {
    prefix: 'fasl',
    iconName: 'crate-empty',
    icon: [
      512,
      512,
      [],
      'e151',
      
      'M480 384H32v96H480V384zm0-32V256H32v96H480zm32 0v16 16 96 32H480 32 0V480 384 368 352 256 224H32 480h32v32 96zM64 304a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm368-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM64 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm368-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faBeerMugEmpty = {
    prefix: 'fasl',
    iconName: 'beer-mug-empty',
    icon: [
      512,
      512,
      ["beer"],
      'f0fc',
      
      'M352 64H64V448H352V360.4c0-.2 0-.5 0-.7V64zm32 306.5V448v32H352 64 32V448 64 32H64 352h32V64 96H496h16v16V304v10.5l-9.6 4.2L384 370.5zM384 128V335.5l96-42V128H384zm-224 0v16V368v16H128V368 144 128h32zm64 0v16V368v16H192V368 144 128h32zm64 0v16V368v16H256V368 144 128h32z'
      
    ]
  };

  
    var faBeer = faBeerMugEmpty;
  

  
  

  var faPeopleLine = {
    prefix: 'fasl',
    iconName: 'people-line',
    icon: [
      640,
      512,
      [],
      'e534',
      
      'M304 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-96 64h-8.9l-4.7 7.6-55.9 90.9-1.5-2.5H192 96 87.1l-4.7 7.6-64 104L10 365.2 37.2 382l8.4-13.6L88 299.5V384v16h16 80 16V384 299.5l42.4 68.9 8.4 13.6L278 365.2l-8.4-13.6L221.3 273l.4-.6L264 203.5V304v16h16 80 16V304 203.5l42.4 68.9 .4 .6-48.4 78.6L362 365.2 389.2 382l8.4-13.6L440 299.5V384v16h16 80 16V384 299.5l42.4 68.9 8.4 13.6L630 365.2l-8.4-13.6-64-104-4.7-7.6H544 448h-8.9l-1.5 2.5-55.9-90.9-4.7-7.6H368 272zm24 144V176h48V288H296zM16 448H0v32H16 624h16V448H624 16zM144 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-24 48h48v96H120V272zm360-96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM520 368H472V272h48v96z'
      
    ]
  };

  

  
  

  var faLightbulbExclamationOn = {
    prefix: 'fasl',
    iconName: 'lightbulb-exclamation-on',
    icon: [
      640,
      512,
      [],
      'e1ca',
      
      'M438.3 258.1C454.5 234.8 464 206.6 464 176c0-79.5-64.5-144-144-144s-144 64.5-144 144c0 30.6 9.5 58.8 25.7 82.1c4.1 5.9 8.8 12.3 13.6 19l0 0c12.7 17.5 27.1 37.2 38 57.1c8.9 16.2 13.7 33.3 16.2 49.9H237c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0 0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H370.5c2.5-16.6 7.3-33.7 16.2-49.9c10.9-20 25.3-39.7 38-57.1c4.9-6.7 9.5-13 13.6-19zM272 480h96V448H272v32zm-32-64h32 96 32v32 32 32H368 272 240V480 448 416zm96-304V240v16H304V240 112 96h32v16zM296 288h48v48H296V288zM67.2 7.7l52 26 14.3 7.2L119.2 69.5l-14.3-7.2-52-26L38.5 29.2 52.8 .5 67.2 7.7zm520 28.6l-52 26-14.3 7.2L506.5 40.8l14.3-7.2 52-26L587.2 .5l14.3 28.6-14.3 7.2zM16 160H80 96v32H80 16 0V160H16zm544 0h64 16v32H624 560 544V160h16zM119.2 318.3l-52 26-14.3 7.2L38.5 322.8l14.3-7.2 52-26 14.3-7.2 14.3 28.6-14.3 7.2zm416-28.6l52 26 14.3 7.2-14.3 28.6-14.3-7.2-52-26-14.3-7.2 14.3-28.6 14.3 7.2z'
      
    ]
  };

  

  
  

  var faLocationPlus = {
    prefix: 'fasl',
    iconName: 'location-plus',
    icon: [
      384,
      512,
      ["map-marker-plus"],
      'f60a',
      
      'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 20.2 9.1 48.6 26.5 82.7c16.9 33.2 39.9 68.2 63.4 100.5c23.4 32.2 46.9 61 64.5 81.9c1.9 2.3 3.8 4.5 5.6 6.6c1.8-2.1 3.6-4.3 5.6-6.6c17.7-20.8 41.1-49.7 64.5-81.9c23.5-32.3 46.4-67.3 63.4-100.5C342.9 240.6 352 212.2 352 192zm32 0c0 88.8-120.7 237.9-170.7 295.9C200.2 503.1 192 512 192 512s-8.2-8.9-21.3-24.1C120.7 429.9 0 280.8 0 192C0 86 86 0 192 0S384 86 384 192zM208 96v16 64h64 16v32H272 208v64 16H176V272 208H112 96V176h16 64V112 96h32z'
      
    ]
  };

  
    var faMapMarkerPlus = faLocationPlus;
  

  
  

  var faSquareArrowRight = {
    prefix: 'fasl',
    iconName: 'square-arrow-right',
    icon: [
      448,
      512,
      ["arrow-square-right"],
      'f33b',
      
      'M416 64L32 64l0 384 384 0 0-384zm32-32l0 32 0 384 0 32-32 0L32 480 0 480l0-32L0 64 0 32l32 0 384 0 32 0zM347.3 267.3l-96 96L240 374.6 217.4 352l11.3-11.3L297.4 272 112 272l-16 0 0-32 16 0 185.4 0-68.7-68.7L217.4 160 240 137.4l11.3 11.3 96 96L358.6 256l-11.3 11.3z'
      
    ]
  };

  
    var faArrowSquareRight = faSquareArrowRight;
  

  
  

  var faPeopleRoof = {
    prefix: 'fasl',
    iconName: 'people-roof',
    icon: [
      640,
      512,
      [],
      'e537',
      
      'M328.5 10.5L320 5.1l-8.5 5.4-304 192 17.1 27.1L320 42.9 615.5 229.5l17.1-27.1-304-192zM304 192a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-96 64h-8.9l-4.7 7.6-55.9 90.9-1.5-2.5H192 96 87.1l-4.7 7.6-64 104L10 477.2 37.2 494l8.4-13.6L88 411.5V496v16h16 80 16V496 411.5l42.4 68.9 8.4 13.6L278 477.2l-8.4-13.6L221.3 385l.4-.6L264 315.5V416v16h16 80 16V416 315.5l42.4 68.9 .4 .6-48.4 78.6L362 477.2 389.2 494l8.4-13.6L440 411.5V496v16h16 80 16V496 411.5l42.4 68.9 8.4 13.6L630 477.2l-8.4-13.6-64-104-4.7-7.6H544 448h-8.9l-1.5 2.5-55.9-90.9-4.7-7.6H368 272zm24 144V288h48V400H296zM144 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-24 48h48v96H120V384zm360-96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM472 480V384h48v96H472z'
      
    ]
  };

  

  
  

  var faUsersRectangle = {
    prefix: 'fasl',
    iconName: 'users-rectangle',
    icon: [
      640,
      512,
      [],
      'e594',
      
      'M16 0H0V16 496v16H16 624h16V496 16 0H624 16zM32 480V32H608V480H32zM159.8 176a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM288 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm80.2-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM129.4 336l14.4-48h46.5l3.4-10.1 7.3-21.9H120L96 336h33.4zm366.8-48l14.4 48H544l-24-80H439.1l7.3 21.9 3.4 10.1h46.5zM224 288l-21.3 64L192 384h33.7H414.3 448l-10.7-32L416 288H224zm23.1 32H392.9l10.7 32H236.4l10.7-32z'
      
    ]
  };

  

  
  

  var faAnglesDown = {
    prefix: 'fasl',
    iconName: 'angles-down',
    icon: [
      448,
      512,
      ["angle-double-down"],
      'f103',
      
      'M235.3 267.3L224 278.6l-11.3-11.3-160-160L41.4 96 64 73.4 75.3 84.7 224 233.4 372.7 84.7 384 73.4 406.6 96l-11.3 11.3-160 160zm0 192L224 470.6l-11.3-11.3-160-160L41.4 288 64 265.4l11.3 11.3L224 425.4 372.7 276.7 384 265.4 406.6 288l-11.3 11.3-160 160z'
      
    ]
  };

  
    var faAngleDoubleDown = faAnglesDown;
  

  
  

  var faCrop = {
    prefix: 'fasl',
    iconName: 'crop',
    icon: [
      512,
      512,
      [],
      'f125',
      
      'M128 0V16 361.4L361.4 128 160 128V96l233.4 0 83.3-83.3L488 1.4 510.6 24 499.3 35.3 416 118.6 416 384h80 16v32H496 416v80 16H384V496l0-345.4L150.6 384H352v32H112 96V400 128H16 0V96H16 96V16 0h32z'
      
    ]
  };

  

  
  

  var faSchoolCircleExclamation = {
    prefix: 'fasl',
    iconName: 'school-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e56c',
      
      'M160 96H32 0v32V480v32H32 256h32 64 32 10.8c-12.9-9.1-24.5-19.9-34.6-32H352 320 288V384c0-17.7 14.3-32 32-32l.7 0c1-10.9 2.9-21.5 5.8-31.7c-2.1-.2-4.3-.3-6.5-.3c-35.3 0-64 28.7-64 64v96H32V128H160c5.8 0 11.5-1.6 16.5-4.6L320 37.3l143.5 86.1c5 3 10.7 4.6 16.5 4.6H608V232.2c12.1 10 22.9 21.7 32 34.6V128 96H608 480L320 0 160 96zM340.3 285.8c16.5-31.3 42.2-57 73.5-73.5c1.4-6.5 2.2-13.3 2.2-20.3c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c7 0 13.8-.7 20.3-2.2zM112 160H96v16 96 16h16 64 16V272 176 160H176 112zm16 96V192h32v64H128zM96 320v16 96 16h16 64 16V432 336 320H176 112 96zm32 32h32v64H128V352zM320 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 32V144H304v16 32 16h16 24 16V176H344h-8V160zm48 208a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm256 0a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM512 288H480v16 80 16h32V384 304 288zm0 160V416H480v32h32z'
      
    ]
  };

  

  
  

  var faUserVneck = {
    prefix: 'fasl',
    iconName: 'user-vneck',
    icon: [
      448,
      512,
      [],
      'e461',
      
      'M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zM199.7 420.8L224 449.2l24.3-28.3L321 336h39.4l44.3 144H43.3L87.6 336H127l72.7 84.8zM384 304H306.3l-61.2 71.4L224 400l-21.1-24.6L141.7 304H64L9.8 480 0 512H33.5h381H448l-9.8-32L384 304z'
      
    ]
  };

  

  
  

  var faFootball = {
    prefix: 'fasl',
    iconName: 'football',
    icon: [
      512,
      512,
      [127944,"football-ball"],
      'f44e',
      
      'M456.2 55.4c-48.9-8.2-92.4-10.8-130.9-8.7L464.8 186.2c3.4-47.1-.8-92.9-8.6-130.8zM220 67.1C161.1 89 120.4 126.1 93.3 170.3c-21.6 35.2-34.6 74.9-41.3 115L227.3 460.7c.2 .2 .3 .3 .5 .5c23.5-3.6 44.8-9.1 64.2-16.3c58.9-21.9 99.6-58.9 126.7-103.2c21.6-35.2 34.6-74.9 41.3-115L284.7 51.3c-.2-.2-.3-.3-.5-.5C260.7 54.4 239.4 60 220 67.1zM47.2 325.8c-3.4 47.1 .8 92.9 8.6 130.8c48.9 8.2 92.4 10.8 130.9 8.7L47.2 325.8zM483.1 27.4l4.4 21.5c17.5 84.8 18.6 211.3-41.6 309.5c-30.6 50-76.8 92-142.9 116.5c-65.6 24.3-148.7 30.7-252.6 13.3l-21.6-3.6-4.4-21.5C6.9 378.3 5.8 251.8 66 153.6c30.6-50 76.8-92 142.9-116.5C274.4 12.8 357.6 6.5 461.5 23.8l21.6 3.6zM291.3 156.7l64 64L366.6 232 344 254.6l-11.3-11.3-64-64L257.4 168 280 145.4l11.3 11.3zm-56 56l64 64L310.6 288 288 310.6l-11.3-11.3-64-64L201.4 224 224 201.4l11.3 11.3zm-56 56l64 64L254.6 344 232 366.6l-11.3-11.3-64-64L145.4 280 168 257.4l11.3 11.3z'
      
    ]
  };

  
    var faFootballBall = faFootball;
  

  
  

  var faChevronsUp = {
    prefix: 'fasl',
    iconName: 'chevrons-up',
    icon: [
      512,
      512,
      ["chevron-double-up"],
      'f325',
      
      'M267.3 52.7L256 41.4 244.7 52.7l-192 192L41.4 256 64 278.6l11.3-11.3L256 86.6 436.7 267.3 448 278.6 470.6 256l-11.3-11.3-192-192zm0 192L256 233.4l-11.3 11.3-192 192L41.4 448 64 470.6l11.3-11.3L256 278.6 436.7 459.3 448 470.6 470.6 448l-11.3-11.3-192-192z'
      
    ]
  };

  
    var faChevronDoubleUp = faChevronsUp;
  

  
  

  var faFlagCheckered = {
    prefix: 'fasl',
    iconName: 'flag-checkered',
    icon: [
      448,
      512,
      [127937],
      'f11e',
      
      'M32 16V0H0V16 64 367v33 96 16H32V496 392l96.3-24.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4L448 368V51.8 16L416 32 393.6 43.2c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L32 56V16zm0 73l96-24v68.6L32 154.4V89zm0 98.2l96-20.9v71.3L32 258.4V187.2zm128-27.8l3.5-.8c18.3-4 37.4-3.3 55.4 2l64.4 18.9c1.6 .5 3.2 .9 4.8 1.3v70.7l-60.1-17.7c-22.1-6.5-45.3-7.6-67.9-3.3V159.3zm160 26.9c17.5 1.3 35.2-.1 52.5-4l43.5-10v71.2L365.3 255c-14.9 3.4-30.2 4.5-45.3 3.1V186.2zm-32 98.6v77c-7.8-2.4-15.5-5.4-22.9-9.1c-32.7-16.4-69-23.8-105.1-21.8V263.3l3.5-.8c18.3-4 37.4-3.3 55.4 2l64.4 18.9c1.6 .5 3.2 .9 4.8 1.3zm32 82.9V290.2c17.5 1.3 35.2-.1 52.5-4l43.5-10v69.7l-34.7 13c-19.8 7.4-40.7 10.4-61.3 8.9zm0-213.7V92.6c30.1 0 60.2-6.9 87.9-20.7l8.1-4.1v71.5L365.3 151c-14.9 3.4-30.2 4.5-45.3 3.1zM288 90v57.6l-60.1-17.7c-22.1-6.5-45.3-7.6-67.9-3.3V58.5c24.7-2.4 49.7 2.2 72.1 13.4c17.8 8.9 36.7 15 55.9 18.1zM32 291.2l96-20.9v64.9c-2.5 .5-5 1.1-7.5 1.7L32 359V291.2z'
      
    ]
  };

  

  
  

  var faUtilityPoleDouble = {
    prefix: 'fasl',
    iconName: 'utility-pole-double',
    icon: [
      512,
      512,
      [],
      'e2c4',
      
      'M208 0h16 64 16V16 96h80V48 32h32V48 96h64V48 32h32V48v64 16H496 437.5L304 231.8V288h80V240 224h32v16 48h64V240 224h32v16 64 16H496 437.5L304 423.8V496v16H272V496 320H240V496v16H208V496 423.8L74.5 320H16 0V304 240 224H32v16 48H96V240 224h32v16 48h80V231.8L74.5 128H16 0V112 48 32H32V48 96H96V48 32h32V48 96h80V16 0zM126.6 128L208 191.3V128H126.6zm0 192L208 383.3V320H126.6zM304 383.3L385.4 320H304v63.3zm0-192L385.4 128H304v63.3zM272 32H240V96h32V32zM240 288h32V128H240V288z'
      
    ]
  };

  

  
  

  var faBuildingMemo = {
    prefix: 'fasl',
    iconName: 'building-memo',
    icon: [
      640,
      512,
      [],
      'e61e',
      
      'M352 32H32V480h96V400 368h32 64 32v32 80h32v32H256 224 160 128 32 0V480 32 0H32 352h32V32 64H352V32zM288 96v32H256v32h32v32H240 224V176 112 96h16 48zm0 128v32H256v32h32v32H240 224V304 240 224h16 48zM224 480V400H160v80h64zM80 96h64 16v16 64 16H144 80 64V176 112 96H80zm16 64h32V128H96v32zM80 224h64 16v16 64 16H144 80 64V304 240 224H80zm16 64h32V256H96v32zM352 128V480H608V128H352zM320 96h32H608h32v32V480v32H608 352 320V480 128 96zm56 112a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM376 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-208h96 16v32H560 464 448V192h16zm-16 96h16 96 16v32H560 464 448V288zm16 96h96 16v32H560 464 448V384h16z'
      
    ]
  };

  

  
  

  var faSquareX = {
    prefix: 'fasl',
    iconName: 'square-x',
    icon: [
      448,
      512,
      [],
      'e286',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zm109 96h39.9L224 229.2 299.2 128H339L243.9 256 339 384H299.2L224 282.8 148.8 384H109l95.1-128L109 128z'
      
    ]
  };

  

  
  

  var faBowlScoop = {
    prefix: 'fasl',
    iconName: 'bowl-scoop',
    icon: [
      448,
      512,
      [127847,"bowl-shaved-ice"],
      'e3de',
      
      'M416 224H384c0-88.4-71.6-160-160-160S64 135.6 64 224H32C32 118 118 32 224 32s192 86 192 192zM316.2 416h-1.3H272l28.4 32 28.4 32 7.1 8v24H304 144 112V488l7.1-8 28.4-32L176 416H133.2h-1.3C66.1 416 11 366.2 4.5 300.7L3.2 288 0 256H32.2 415.8 448l-3.2 32-1.3 12.7C437 366.2 381.9 416 316.2 416zm-68.1 21.3L224 410.2l-24.1 27.1-38 42.7H286.1l-38-42.7zm-.8-53.3H272h44.2c49.3 0 90.6-37.4 95.5-86.4l1-9.6H35.4l1 9.6c4.9 49.1 46.2 86.4 95.5 86.4H176h24.7 46.5z'
      
    ]
  };

  
    var faBowlShavedIce = faBowlScoop;
  

  
  

  var faMessageExclamation = {
    prefix: 'fasl',
    iconName: 'message-exclamation',
    icon: [
      512,
      512,
      ["comment-alt-exclamation"],
      'f4a5',
      
      'M160 416H128 32 0V384 32 0H32 480h32V32 384v32H480 304L192 490.7 160 512V473.5 448 416zm0-32h32v32 36.2l94.2-62.8 8.1-5.4H304 480V32H32V384H160zM272 80V96 224v16H240V224 96 80h32zM232 272h48v48H232V272z'
      
    ]
  };

  
    var faCommentAltExclamation = faMessageExclamation;
  

  
  

  var faLightCeiling = {
    prefix: 'fasl',
    iconName: 'light-ceiling',
    icon: [
      512,
      512,
      [],
      'e016',
      
      'M272 0V16 160.5C395.3 168.1 494.9 262.9 510 384c1.3 10.5 2 21.2 2 32H480 32 0c0-10.8 .7-21.5 2-32C17.1 262.9 116.7 168.1 240 160.5V16 0h32zM34.3 384H477.7C462.2 275.4 368.8 192 256 192S49.8 275.4 34.3 384zM256 512c-38.7 0-71-27.5-78.4-64h33.1c6.6 18.6 24.4 32 45.3 32s38.7-13.4 45.3-32h33.1c-7.4 36.5-39.7 64-78.4 64z'
      
    ]
  };

  

  
  

  var faFaceSmileBeam = {
    prefix: 'fasl',
    iconName: 'face-smile-beam',
    icon: [
      512,
      512,
      [128522,"smile-beam"],
      'f5b8',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm129.7 71.2l28.6-14.3c8.7 17.5 41.3 55.2 97.7 55.2s88.9-37.7 97.7-55.2l28.6 14.3C369.7 352.3 327.6 400 256 400s-113.7-47.7-126.3-72.8zm26.8-132.6c-6.2 7.2-10.8 16.8-12.9 25.4l-31-7.8c3.2-12.7 9.8-27.1 19.9-38.6C142.4 161.9 157.2 152 176 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6l-31 7.8c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4l-31-7.8c3.2-12.7 9.8-27.1 19.9-38.6C302.4 161.9 317.2 152 336 152s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6l-31 7.8c-2.1-8.6-6.7-18.2-12.9-25.4c-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z'
      
    ]
  };

  
    var faSmileBeam = faFaceSmileBeam;
  

  
  

  var faForwardStep = {
    prefix: 'fasl',
    iconName: 'forward-step',
    icon: [
      320,
      512,
      ["step-forward"],
      'f051',
      
      'M256 80V64h32V80 240v32V432v16H256V432 294L64 426 32 448V409.2 102.8 64L64 86 256 218V80zm-1.2 176L64 124.8V387.2L254.8 256z'
      
    ]
  };

  
    var faStepForward = faForwardStep;
  

  
  

  var faMessageBot = {
    prefix: 'fasl',
    iconName: 'message-bot',
    icon: [
      640,
      512,
      [],
      'e3b8',
      
      'M192 416h32v32 25.5V512l32-21.3L368 416H512h32V384 208h32v16h64V160H576v16H544V32 0H512 128 96V32 176H64V160H0v64H64V208H96V384v32h32 64zM512 32V192 384H368h-9.7l-8.1 5.4L256 452.2V416 384H224 128V192 32H512zM192 128H448V256H192V128zM160 96v32V256v32h32H448h32V256 128 96H448 192 160zm120 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm112 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassLocation = {
    prefix: 'fasl',
    iconName: 'magnifying-glass-location',
    icon: [
      512,
      512,
      ["search-location"],
      'f689',
      
      'M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L487.9 510.5l22.6-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm38.2-202c-6.5 14.9-15.4 30.2-24.8 44.3c-4.5 6.8-9.1 13.2-13.4 18.9c-4.3-5.8-8.8-12.1-13.4-18.9c-9.4-14-18.3-29.3-24.8-44.3c-6.6-15.3-9.8-28.2-9.8-38c0-26.5 21.5-48 48-48s48 21.5 48 48c0 9.8-3.2 22.7-9.8 38zm-17.5 89c23.7-30.8 59.4-84.2 59.4-127c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 42.7 35.7 96.2 59.4 127c11.8 15.3 20.6 25 20.6 25s8.8-9.7 20.6-25zM232 184a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faSearchLocation = faMagnifyingGlassLocation;
  

  
  

  var faHandPointRight = {
    prefix: 'fasl',
    iconName: 'hand-point-right',
    icon: [
      512,
      512,
      [],
      'f0a4',
      
      'M512 112l0-16-16 0L272 96l0-16 0-16-16 0-96 0C71.6 64 0 135.6 0 224l0 64c0 88.4 71.6 160 160 160l0 0 16 0 64 0 16 0 48 0 16 0 0-16 0-64 16 0 0-16 0-64 16 0 16 0 0-16 0-64 128 0 16 0 0-16 0-80zM336 208l0 48-16 0-48 0 0-48 64 0zm-96 48l0 0-48 0 0-80 0-16-32 0 0 16 0 80 0 16 0 16 0 48 0 16 0 16 0 48C89.3 416 32 358.7 32 288l0-64C32 153.3 89.3 96 160 96l80 0 0 80 0 0 0 32 0 0 0 48zm0 32l16 0 16 0 32 0 0 48-112 0 0-48 48 0zm32-112l0-48 208 0 0 48-112 0-16 0-80 0zM240 416l-48 0 0-48 96 0 0 48-32 0-16 0z'
      
    ]
  };

  

  
  

  var faH1 = {
    prefix: 'fasl',
    iconName: 'h1',
    icon: [
      576,
      512,
      [],
      'f313',
      
      'M32 80V64H0V80 256 432v16H32V432 272H288V432v16h32V432 256 80 64H288V80 240H32V80zm352.5 73.6L464 103.9V416H400 384v32h16 80 80 16V416H560 496V80 64H480h-8-4.6l-3.9 2.4L384 116.1v37.7l.5-.3z'
      
    ]
  };

  

  
  

  var faStandardDefinition = {
    prefix: 'fasl',
    iconName: 'standard-definition',
    icon: [
      576,
      512,
      ["rectangle-sd"],
      'e28a',
      
      'M544 64V448H32V64H544zM32 32H0V64 448v32H32 544h32V448 64 32H544 32zM304 160v16V336v16h16 64c53 0 96-43 96-96s-43-96-96-96H320 304zm32 32h48c35.3 0 64 28.7 64 64s-28.7 64-64 64H336V192zm-176.4 2.4c10.1-3.3 24.9-3.6 43.9-1.1c5.8 .8 23.7 3.8 29.2 5l15.6 3.6 7.1-31.2-15.6-3.6c-6.8-1.6-25.8-4.7-32-5.5c-20.5-2.7-41-3.1-58 2.4c-18.2 5.9-32.3 18.7-36.6 40.1c-.1 .3-.1 .6-.1 .9c-1.6 11.1-.2 21.3 4.6 30.2c4.7 8.8 11.9 15 19.4 19.5c13.9 8.3 32.4 12.6 47.8 16.2l1.4 .3c17.3 4 31 7.4 40.1 12.8c4.2 2.5 6.4 4.9 7.6 7.1c1.1 2 2 5.1 1.2 10.6c-.7 4.6-2.3 7.5-4.2 9.5c-2 2.2-5.2 4.2-10.1 5.8c-10.3 3.3-25.6 3.6-44.5 1c-8.8-1.2-24-5.7-36.3-9.2l0 0c-2.7-.8-5.3-1.5-7.6-2.2L117 302.1l-8.8 30.8 15.4 4.4c1.8 .5 3.9 1.1 6.2 1.8l0 0c12.1 3.5 30.6 9 42 10.6l.1 0c20.4 2.7 41.4 3.2 58.5-2.2c8.8-2.8 17.2-7.3 23.8-14.4c6.8-7.2 10.9-16.3 12.5-26.7c1.6-11.1 .2-21.3-4.6-30.2c-4.7-8.8-11.9-15-19.4-19.5c-13.9-8.3-32.4-12.6-47.8-16.2l0 0-1.4-.3c-17.3-4-31-7.4-40.1-12.8c-4.2-2.5-6.4-4.9-7.6-7.1c-1-1.9-1.9-4.9-1.2-10.1c1.8-8.2 6.3-12.8 15.1-15.6z'
      
    ]
  };

  
    var faRectangleSd = faStandardDefinition;
  

  
  

  var faSkiBoot = {
    prefix: 'fasl',
    iconName: 'ski-boot',
    icon: [
      512,
      512,
      [],
      'e3cc',
      
      'M348.6 32l6.2-32h32.6L330 295.4l141.5 74.5 8.5 4.5V384v96h16 16v32H496 464 24 4.9l3.4-18.8 80-448L90.6 32H104 348.6zM185.3 64H117.4L80.3 272h63.4L185.3 64zm32.6 0L172.5 291.1 169.9 304H156.8 74.5L43.1 480H448V393.7L308 320h-4H240 224V288h16 58.8l12.4-64H272 256V192h16 45.5L342.4 64H217.9z'
      
    ]
  };

  

  
  

  var faFingerprint = {
    prefix: 'fasl',
    iconName: 'fingerprint',
    icon: [
      512,
      512,
      [],
      'f577',
      
      'M32 256C32 132.3 132.3 32 256 32c70.3 0 133 32.4 174.1 83l10.1 12.4L465 107.3 455 94.9C408.1 37 336.3 0 256 0C114.6 0 0 114.6 0 256v48 16H32V304 256zm470.8-68.3l-4.3-15.4-30.8 8.5 4.3 15.4c5.2 19 8.1 39 8.1 59.7v48 16h32V304 256c0-23.6-3.2-46.5-9.2-68.3zM256 80c-30.5 0-59.3 7.8-84.3 21.5l18.8 26.3C210.1 117.7 232.4 112 256 112c79.5 0 144 64.5 144 144v24.9c0 34.6-2.7 69-8.1 103.1h32.4c5.2-34 7.8-68.5 7.8-103.1V256c0-97.2-78.8-176-176-176zM152 156.4L133.1 130C100.3 162 80 206.6 80 256v24.9c0 35-5.5 69.8-16.2 103.1H97.3C107 350.6 112 315.9 112 280.9V256c0-38.6 15.2-73.7 40-99.6zM256 160c-53 0-96 43-96 96v24.9c0 46-7.6 91.6-22.5 135.1h33.7C185 372.4 192 326.8 192 280.9V256c0-35.3 28.7-64 64-64s64 28.7 64 64v24.9c0 45.6-5.4 90.9-16.1 135.1h32.9c10.1-44.2 15.2-89.5 15.2-135.1V256c0-53-43-96-96-96zm16 96H240v24.9c0 60.9-11.2 121.2-33.1 178.1l-5.9 15.3-2.2 5.7h34.3l3.7-9.5C260.1 410 272 345.7 272 280.9V256z'
      
    ]
  };

  

  
  

  var faPumpMedical = {
    prefix: 'fasl',
    iconName: 'pump-medical',
    icon: [
      448,
      512,
      [],
      'e06a',
      
      'M144 0h96 16V16 48h96 6.6l4.7 4.7 48 48L422.6 112 400 134.6l-11.3-11.3L345.4 80H256v48H224V32H160v96H128V16 0h16zM64.1 512H32l2.2-32L56 160H328l21.8 320 2.2 32H319.9 64.1zm253.7-32L298.1 192H85.9L66.3 480H317.7zM208 288v32h32 16v32H240 208v32 16H176V384 352H144 128V320h16 32V288 272h32v16z'
      
    ]
  };

  

  
  

  var faLocationMinus = {
    prefix: 'fasl',
    iconName: 'location-minus',
    icon: [
      384,
      512,
      ["map-marker-minus"],
      'f609',
      
      'M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 20.2 9.1 48.6 26.5 82.7c16.9 33.2 39.9 68.2 63.4 100.5c23.4 32.2 46.9 61 64.5 81.9c1.9 2.3 3.8 4.5 5.6 6.6c1.8-2.1 3.6-4.3 5.6-6.6c17.7-20.8 41.1-49.7 64.5-81.9c23.5-32.3 46.4-67.3 63.4-100.5C342.9 240.6 352 212.2 352 192zm32 0c0 88.8-120.7 237.9-170.7 295.9C200.2 503.1 192 512 192 512s-8.2-8.9-21.3-24.1C120.7 429.9 0 280.8 0 192C0 86 86 0 192 0S384 86 384 192zM96 176H288h16v32H288 96 80V176H96z'
      
    ]
  };

  
    var faMapMarkerMinus = faLocationMinus;
  

  
  

  var faSlidersUp = {
    prefix: 'fasl',
    iconName: 'sliders-up',
    icon: [
      512,
      512,
      ["sliders-v"],
      'f3f1',
      
      'M112 0V16 80h32 32v32 96 32H144 112V496v16H80V496 240H48 16V208 112 80H48 80V16 0h32zM80 208h32 32V112H112 80 48v96H80zM272 0V16 272h32 32v32 96 32H304 272v64 16H240V496 432H208 176V400 304 272h32 32V16 0h32zM400 112V16 0h32V16v96h32 32v32 96 32H464 432V496v16H400V496 272H368 336V240 144 112h32 32zm0 32H368v96h32 32 32V144H432 400zM272 400h32V304H272 240 208v96h32 32z'
      
    ]
  };

  
    var faSlidersV = faSlidersUp;
  

  
  

  var faBridgeCircleCheck = {
    prefix: 'fasl',
    iconName: 'bridge-circle-check',
    icon: [
      640,
      512,
      [],
      'e4c9',
      
      'M48 32H32V64H48h64v64H48 32v32H48h64 32 96 32 96 32 96 32 64 16V128H592 528V64h64 16V32H592 528 496 400 368 272 240 144 112 48zM496 64v64H400V64h96zM368 64v64H272V64h96zM240 64v64H144V64h96zM48 240H32v32H48 64c35.3 0 64 28.7 64 64V464v16h16 96 16V464 336c0-35.3 28.7-64 64-64c9 0 17.5 1.8 25.2 5.2c5.6-9.3 12.1-18.1 19.3-26.2C351.2 244 336.1 240 320 240c-53 0-96 43-96 96V448H160V336c0-53-43-96-96-96H48zm448 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm78.6-176L552 313.4l-11.3 11.3L480 385.4l-28.7-28.7L440 345.4 417.4 368l11.3 11.3 40 40L480 430.6l11.3-11.3 72-72L574.6 336z'
      
    ]
  };

  

  
  

  var faCalculatorSimple = {
    prefix: 'fasl',
    iconName: 'calculator-simple',
    icon: [
      512,
      512,
      ["calculator-alt"],
      'f64c',
      
      'M272 0V16 240H496h16v32H496 272V496v16H240V496 272H16 0V240H16 240V16 0h32zM416 40v8 8V96h40 8 8 8v32h-8-8-8H416v40 8 8 8H384v-8-8-8V128H344h-8-8-8V96h8 8 8 40V56 48 40 32h32v8zM64.4 329.8l11.3 11.3L112 377.4l36.3-36.3 11.3-11.3 22.6 22.6-11.3 11.3L134.6 400l36.3 36.3 11.3 11.3-22.6 22.6-11.3-11.3L112 422.6 75.7 458.9 64.4 470.2 41.8 447.6l11.3-11.3L89.4 400 53.1 363.7 41.8 352.4l22.6-22.6zM48 96H176h16v32H176 48 32V96H48zM464 352h16v32H464 336 320V352h16H464zm0 64h16v32H464 336 320V416h16H464z'
      
    ]
  };

  
    var faCalculatorAlt = faCalculatorSimple;
  

  
  

  var faClosedCaptioningSlash = {
    prefix: 'fasl',
    iconName: 'closed-captioning-slash',
    icon: [
      640,
      512,
      [],
      'e135',
      
      'M40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18zM608 401.8V64 32H576 139.6l40.5 32H576V376.6l32 25.3zM373.5 216.7c11.7-15 30-24.7 50.5-24.7c21.9 0 41.2 11 52.8 27.8l26.4-18.1C485.8 176.5 456.9 160 424 160c-30.7 0-58.1 14.4-75.6 36.9l25.1 19.8zM64 135.4L32 110.2V448v32H64 500.4l-40.5-32H64V135.4zM275.8 302.7C264.4 313.4 248.9 320 232 320c-35.3 0-64-28.7-64-64c0-11.6 3.1-22.4 8.4-31.8l-25.3-20C141.6 219.2 136 236.9 136 256c0 53 43 96 96 96c27.2 0 51.7-11.3 69.1-29.4l-25.3-20z'
      
    ]
  };

  

  
  

  var faMicrophoneLinesSlash = {
    prefix: 'fasl',
    iconName: 'microphone-lines-slash',
    icon: [
      640,
      512,
      ["microphone-alt-slash"],
      'f539',
      
      'M395.5 397.1l-28.1-22.2c-14.7 5.8-30.6 9.1-47.4 9.1c-70.7 0-128-57.3-128-128V236.5l-32-25.3V256c0 83 63.1 151.2 144 159.2V480H240 224v32h16 80 80 16V480H400 336V415.2c21.3-2.1 41.4-8.4 59.5-18.1zM256 123.9V32H384V96H336 320v32h16 48v32H336 320v14.5L342.2 192H384v32h-1.2L416 250.2V224 192 160 128 96 32 0H384 256 224V32 98.7l32 25.3zM446.7 274.5l28.1 22.2c3.4-13 5.2-26.6 5.2-40.7V208 192H448v16 48c0 6.3-.5 12.4-1.3 18.5zM40.4 18L27.8 8.1 8.1 33.4l12.6 9.8L599.8 494.3l12.6 9.8 19.7-25.2L619.5 469 40.4 18z'
      
    ]
  };

  
    var faMicrophoneAltSlash = faMicrophoneLinesSlash;
  

  
  

  var faIcons = {
    prefix: 'fasl',
    iconName: 'icons',
    icon: [
      512,
      512,
      ["heart-music-camera-bolt"],
      'f86d',
      
      'M73.3 0c19.5 0 38.5 7.7 52.3 21.5L128 24l2.5-2.5C144.3 7.7 163.2 0 182.7 0C222.8 0 256 32.5 256 72.6c0 20.1-8.3 39.2-22.9 52.9L128 224 22.9 125.5C8.3 111.8 0 92.6 0 72.6C0 32.5 33.2 0 73.3 0zM211.2 102.2c8.2-7.7 12.8-18.4 12.8-29.6c0-22-18.5-40.6-41.3-40.6c-11.1 0-22 4.5-29.7 12.2l-2.5 2.5L128 69.3 105.4 46.6l-2.5-2.5 20.7-20.7L102.9 44.2C95.2 36.5 84.4 32 73.3 32C50.5 32 32 50.6 32 72.6c0 11.2 4.6 21.9 12.8 29.6l83.2 78 83.2-78zM512 4.5V24 168h-.2c.1 1.3 .2 2.7 .2 4c0 28.7-28.7 52-64 52s-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7V43.5L352 69.1V200h-.2c.1 1.3 .2 2.7 .2 4c0 28.7-28.7 52-64 52s-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7V56 42.9l12.9-2.6 160-32L512 4.5zM480 172c0-3.1-1.5-7.5-6.9-11.9c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zM320 204c0-3.1-1.5-7.5-6.9-11.9c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zM200 256l16 32h40 32v32V480v32H256 32 0V480 320 288H32 72l16-32H200zm16 64H196.2l-8.8-17.7L180.2 288H107.8l-7.2 14.3L91.8 320H72 32V480H256V320H216zm-72 40a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 96a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM452.3 261.1l23.4 21.8-79 85.1H472h36.7l-25 26.9-104 112-23.4-21.8 79-85.1H360 323.3l25-26.9 104-112z'
      
    ]
  };

  
    var faHeartMusicCameraBolt = faIcons;
  

  
  

  var faSoap = {
    prefix: 'fasl',
    iconName: 'soap',
    icon: [
      512,
      512,
      [129532],
      'e06e',
      
      'M224 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 128 64zM32 192H225.3c1.9 11.5 5.9 22.3 11.5 32H32V480H480V224H403.2c5.6-9.7 9.6-20.5 11.5-32H480h32v32V480v32H480 32 0V480 224 192H32zm80 80H320h80 32v32 96 32H400 112 80V400 304 272h32zm0 128H400V304H112v96zM400 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM352 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  

  
  

  var faAtom = {
    prefix: 'fasl',
    iconName: 'atom',
    icon: [
      512,
      512,
      [9883],
      'f5d2',
      
      'M322 421.3c-.3 .7-.6 1.3-.9 1.9C301.4 464.7 278 480 256 480s-45.4-15.3-65.1-56.7c-.3-.6-.6-1.3-.9-1.9c21.1-5 43.3-12.6 66-22.6c22.7 9.9 44.9 17.5 66 22.6zM217.1 379.8c-13.4 4.8-26.4 8.6-38.7 11.4c-4-12.6-7.4-26.3-10.1-40.9c8.4 5.7 17.1 11.2 26 16.6c7.6 4.6 15.2 8.9 22.8 13zm116.4 11.4c-12.3-2.8-25.3-6.5-38.7-11.4c7.6-4.1 15.2-8.4 22.8-13c8.9-5.4 17.6-10.9 26-16.6c-2.8 14.6-6.2 28.3-10.1 40.9zm-32.3-51.8c-15.3 9.2-30.4 17.2-45.2 24.2c-14.8-7-29.9-15.1-45.2-24.2c-17.5-10.5-33.7-21.5-48.5-32.8c-1.5-16.2-2.3-33.1-2.3-50.6s.8-34.4 2.3-50.6c14.8-11.3 31.1-22.3 48.5-32.8c15.3-9.2 30.4-17.2 45.2-24.2c14.8 7 29.9 15.1 45.2 24.2c17.5 10.5 33.7 21.5 48.5 32.8c1.5 16.2 2.3 33.1 2.3 50.6s-.8 34.4-2.3 50.6c-14.8 11.3-31.1 22.3-48.5 32.8zm64.3 56.7c6.6-22.1 11.5-46.6 14.6-72.7c16.7-13.5 31.7-27.5 44.7-41.8l.8 1.2c25 37.7 26.8 66.1 16 85.6c-10.4 18.7-33.6 31-76.1 27.7zm18.1-118.2c.3-7.2 .4-14.5 .4-21.9s-.1-14.7-.4-21.9c7.7 7.3 14.8 14.6 21.3 21.9c-6.5 7.3-13.6 14.7-21.3 21.9zm86 106.1c20.7-37.1 9.4-82.8-23.6-128c33-45.2 44.3-90.9 23.6-128c-20.2-36.3-62.5-49.3-115.2-43.2C332.4 32.7 298.8 0 256 0s-76.4 32.7-98.4 84.8c-52.7-6.1-95 6.8-115.2 43.2C21.7 165.1 33 210.8 66 256c-33 45.2-44.3 90.9-23.6 128c20.2 36.3 62.5 49.3 115.2 43.2c22 52.1 55.7 84.8 98.4 84.8s76.4-32.7 98.4-84.8c52.7 6.1 95-6.8 115.2-43.2zm-28-240.4c10.8 19.5 9.1 47.9-16 85.6l-.8 1.2c-13-14.2-28-28.2-44.7-41.8c-3.1-26.1-8-50.6-14.6-72.7c42.6-3.3 65.7 8.9 76.1 27.7zM321.1 88.7c.3 .6 .6 1.3 .9 1.9c-21.1 5-43.3 12.6-66 22.6c-22.7-9.9-44.9-17.5-66-22.6c.3-.7 .6-1.3 .9-1.9C210.6 47.3 234 32 256 32s45.4 15.3 65.1 56.7zm12.5 32.1c4 12.6 7.4 26.3 10.1 40.9c-8.4-5.7-17.1-11.2-26-16.5c-7.6-4.6-15.2-8.9-22.8-13c13.4-4.8 26.4-8.6 38.7-11.3zm-155.1 0c12.3 2.8 25.3 6.5 38.7 11.3c-7.6 4.1-15.2 8.4-22.8 13c-8.9 5.4-17.6 10.9-26 16.5c2.8-14.6 6.2-28.3 10.1-40.9zm-32-4.9c-6.6 22.1-11.5 46.6-14.6 72.7c-16.7 13.5-31.7 27.5-44.7 41.8l-.8-1.2c-25-37.7-26.8-66.1-16-85.6c10.4-18.7 33.6-31 76.1-27.7zM86.3 282.8l.8-1.2c13 14.2 28 28.2 44.7 41.8c3.1 26.1 8 50.6 14.6 72.7c-42.6 3.3-65.7-8.9-76.1-27.7c-10.8-19.5-9.1-47.9 16-85.6zm42.1-48.8c-.3 7.2-.4 14.5-.4 21.9s.1 14.7 .4 21.9c-7.7-7.3-14.8-14.6-21.3-21.9c6.5-7.3 13.6-14.7 21.3-21.9zM224 256l32 32 32-32-32-32-32 32z'
      
    ]
  };

  

  
  

  var faNfc = {
    prefix: 'fasl',
    iconName: 'nfc',
    icon: [
      448,
      512,
      [],
      'e1f7',
      
      'M416 64V448H32V64H416zM32 32H0V64 448v32H32 416h32V448 64 32H416 32zM64 96v16V400v16H80 368h16V400 112 96H368 224 208v16 98.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V128H352V384H96V128h48 16V96H144 80 64zM224 272a16 16 0 1 1 0-32 16 16 0 1 1 0 32z'
      
    ]
  };

  

  
  

  var faFaceGlasses = {
    prefix: 'fasl',
    iconName: 'face-glasses',
    icon: [
      512,
      512,
      [],
      'e377',
      
      'M256 480C132.3 480 32 379.7 32 256c0-22.2 3.2-43.7 9.3-64H48v96 16H64 224h16V288 192h32v96 16h16H448h16V288 192h6.7c6 20.3 9.3 41.8 9.3 64c0 123.7-100.3 224-224 224zM240 160V144H224 64 62C100.7 77 173.1 32 256 32s155.3 45 194 112h-2H288 272v16H240zM80 272V192 176H208v96H80zM256 0C148.6 0 56.6 66.2 18.6 160H16 0v32H8.1C2.8 212.5 0 233.9 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-22.1-2.8-43.5-8.1-64H512V160H496h-2.6C455.4 66.2 363.4 0 256 0zM432 192v80H304V176H432v16zM256 416c71.6 0 113.7-47.7 126.3-72.8l-28.6-14.3C344.9 346.3 312.4 384 256 384s-88.9-37.7-97.7-55.2l-28.6 14.3C142.3 368.3 184.4 416 256 416zM192.4 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm152 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faRightFromBracket = {
    prefix: 'fasl',
    iconName: 'right-from-bracket',
    icon: [
      512,
      512,
      ["sign-out-alt"],
      'f2f5',
      
      'M304 304l32 0 0 32 0 48 17.7 0L468.9 256 353.7 128 336 128l0 48 0 32-32 0-112 0 0 96 112 0zm0 112l0-32 0-16 0-32-32 0-80 0-32 0 0-32 0-96 0-32 32 0 80 0 32 0 0-32 0-16 0-32 32 0 32 0L512 256 368 416l-32 0-32 0zM176 64L32 64l0 384 144 0 16 0 0 32-16 0L16 480 0 480l0-16L0 48 0 32l16 0 160 0 16 0 0 32-16 0z'
      
    ]
  };

  
    var faSignOutAlt = faRightFromBracket;
  

  
  

  var faFilms = {
    prefix: 'fasl',
    iconName: 'films',
    icon: [
      576,
      512,
      [],
      'e17a',
      
      'M224 272V224H448v48 80H224V272zm0-80V144 64H448v80 48H224zM464 32H448 224 208 192 128 96V64v64 16 16 96 16 16 64 32h32 64 16 16H448h16 16 64 32V352 288 272 256 160 144 128 64 32H544 480 464zM128 64h64v64H128V64zm0 96h64v48 48H128V160zm0 128h64v64H128V288zm416 64H480V288h64v64zm0-96H480V208 160h64v96zm0-128H480V64h64v64zM32 112V96H0v16V464v16H16 464h16V448H464 32V112z'
      
    ]
  };

  

  
  

  var faDoorOpen = {
    prefix: 'fasl',
    iconName: 'door-open',
    icon: [
      576,
      512,
      [],
      'f52b',
      
      'M320 0L288 8 64 64V480H16 0v32H16 64 80 96 288h32V480 33 0zM288 41V480H96V89L288 41zM232 288c13.2 0 24-14.4 24-32s-10.8-32-24-32s-24 14.4-24 32s10.7 32 24 32zM496 64H352V96H480V496v16h16 64 16V480H560 512V80 64H496z'
      
    ]
  };

  

  
  

  var faShovel = {
    prefix: 'fasl',
    iconName: 'shovel',
    icon: [
      512,
      512,
      [],
      'f713',
      
      'M361.4 22.6L384 0l22.6 22.6 82.7 82.7L512 128l-22.6 22.6-46.9 46.9c-17 17-40 26.5-64 26.5c-19.2 0-37-6-51.7-16.2l-99.5 99.5 54.1 54.1L304 384l-22.6 22.6L176 512H32 0V480 336L105.4 230.6 128 208l22.6 22.6 54.1 54.1 99.5-99.5C294 170.5 288 152.7 288 133.5c0-24 9.5-47 26.5-64l46.9-46.9zM466.7 128L384 45.3 337.1 92.1c-11 11-17.1 25.9-17.1 41.4c0 32.3 26.2 58.5 58.5 58.5c15.5 0 30.4-6.2 41.4-17.1L466.7 128zM32 349.3V480H162.7l96-96L128 253.3l-96 96z'
      
    ]
  };

  

  
  

  var faFaceIcicles = {
    prefix: 'fasl',
    iconName: 'face-icicles',
    icon: [
      512,
      512,
      [],
      'e37c',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224l16 256 16-256C512 114.6 397.4 0 256 0S0 114.6 0 256L16 448 32 256zm112 98.7V320h32v48H157.3L144 354.7zM208 368V320h32v48H208zm64 0V320h32v48H272zm82.7 0H336V320h32v34.7L354.7 368zM400 320V288H368 144 112v32 48l32 32H292l12 48 12-48h39.7L368 480l14.5-94.5L400 368V320zM176.4 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM331.1 467.1C307.6 475.4 282.4 480 256 480c-87.6 0-163.4-50.3-200.3-123.5l-4.4 53.3C98 471.8 172.3 512 256 512c27.6 0 54.3-4.4 79.2-12.5l-4.1-32.4zm74.1-3.1c19.8-14.2 37.5-31.3 52.5-50.5L454.4 360c-11.3 21.5-26 41-43.4 57.7L405.2 464z'
      
    ]
  };

  

  
  

  var faCircleMinus = {
    prefix: 'fasl',
    iconName: 'circle-minus',
    icon: [
      512,
      512,
      ["minus-circle"],
      'f056',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 240H144v32h16H352h16V240H352 160z'
      
    ]
  };

  
    var faMinusCircle = faCircleMinus;
  

  
  

  var faFolderArrowDown = {
    prefix: 'fasl',
    iconName: 'folder-arrow-down',
    icon: [
      512,
      512,
      ["folder-download"],
      'e053',
      
      'M32 32H224l48 64H480h32v32V448v32H480 32 0V448 64 32H32zm240 96H256l-9.6-12.8L208 64H32V448H480V128H272zm0 80V329.4l52.7-52.7L336 265.4 358.6 288l-11.3 11.3-80 80L256 390.6l-11.3-11.3-80-80L153.4 288 176 265.4l11.3 11.3L240 329.4V208 192h32v16z'
      
    ]
  };

  
    var faFolderDownload = faFolderArrowDown;
  

  
  

  var faSortDown = {
    prefix: 'fasl',
    iconName: 'sort-down',
    icon: [
      320,
      512,
      ["sort-desc"],
      'f0dd',
      
      'M32 320H288v1.8L160 437 32 321.8V320zm0-32H0v32 16L160 480 320 336V320 288H288 32z'
      
    ]
  };

  
    var faSortDesc = faSortDown;
  

  
  

  var faBarcodeScan = {
    prefix: 'fasl',
    iconName: 'barcode-scan',
    icon: [
      640,
      512,
      [],
      'f465',
      
      'M64 32V192H96V32H64zm0 288V480H96V320H64zm96 0H128V480h32V320zM128 192h32V32H128V192zm64 288h32V320H192V480zm0-288h32V32H192V192zm96 288h32V320H288V480zm0-288h32V32H288V192zm64 288h32V320H352V480zm0-288h32V32H352V192zm96 288h32V320H448V480zm0-288h32V32H448V192zm96 288h32V320H544V480zm0-288h32V32H544V192zM0 240v32l640 0V240L0 240z'
      
    ]
  };

  

  
  

  var faMobileSignal = {
    prefix: 'fasl',
    iconName: 'mobile-signal',
    icon: [
      512,
      512,
      [],
      'e1ef',
      
      'M64 32H320V297.3c10.1-9 20.7-17.3 32-24.8V32 0H320 64 32V32 480v32H64 224c0-10.8 .6-21.5 1.8-32H64V32zM240 400H224 160 144v32h16 64 11.3c1.4-5 3-10 4.7-14.9V400zM512 288V256c-141.4 0-256 114.6-256 256h32c0-123.7 100.3-224 224-224zM480 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-96 0c0-70.7 57.3-128 128-128V352c-88.4 0-160 71.6-160 160h32z'
      
    ]
  };

  

  
  

  var faArrowsUpToLine = {
    prefix: 'fasl',
    iconName: 'arrows-up-to-line',
    icon: [
      576,
      512,
      [],
      'e4c2',
      
      'M16 64L0 64 0 32l16 0 544 0 16 0 0 32-16 0L16 64zm112 41.4l11.3 11.3 104 104L254.6 232 232 254.6l-11.3-11.3L144 166.6 144 464l0 16-32 0 0-16 0-297.4L35.3 243.3 24 254.6 1.4 232l11.3-11.3 104-104L128 105.4zm320 0l11.3 11.3 104 104L574.6 232 552 254.6l-11.3-11.3L464 166.6 464 464l0 16-32 0 0-16 0-297.4-76.7 76.7L344 254.6 321.4 232l11.3-11.3 104-104L448 105.4z'
      
    ]
  };

  

  
  

  var faFork = {
    prefix: 'fasl',
    iconName: 'fork',
    icon: [
      512,
      512,
      ["utensil-fork"],
      'f2e3',
      
      'M385.2 1.2L268.2 86.9c-4.4 3.3-8.6 6.9-12.5 10.7l-1.6 1.6C234.8 118.5 224 144.7 224 172c0 25 9.1 49.1 25.5 67.8L4.7 484.7l22.6 22.6L272.2 262.5C290.9 278.9 315 288 340 288c27.3 0 53.5-10.8 72.8-30.1l1.6-1.6c3.9-3.9 7.5-8.1 10.7-12.5l85.8-116.9-22.9-22.9L399.3 224.9c-2.3 3.1-4.8 6.1-7.6 8.8l-1.6 1.6C376.8 248.5 358.8 256 340 256s-36.8-7.5-50.1-20.8l-13.1-13.1C263.5 208.8 256 190.8 256 172s7.5-36.8 20.8-50.1l1.6-1.6c2.7-2.7 5.7-5.3 8.8-7.6L408.1 24.1 385.2 1.2zm35.5 35.5L284.5 155.8l-8.9 7.8 22.7 22.7 7.3-6.4L443.3 59.3 420.7 36.7zM356.2 227.5L475.3 91.3 452.7 68.7 332.1 206.5l-6.4 7.3 22.7 22.7 7.8-8.9z'
      
    ]
  };

  
    var faUtensilFork = faFork;
  

  
  

  var faUfo = {
    prefix: 'fasl',
    iconName: 'ufo',
    icon: [
      640,
      512,
      [128760],
      'e047',
      
      'M176.6 238.3c-11.7 11-11.7 11-11.6 11l0 0 0 0 .1 .1 .2 .2c.2 .2 .4 .4 .6 .6c.5 .5 1.1 1.1 1.9 1.8c1.6 1.5 4 3.4 7 5.7c6.1 4.5 15.2 10.3 27.7 16c25 11.4 63.1 22.3 117.5 22.3s92.5-10.9 117.5-22.3c12.5-5.7 21.6-11.5 27.7-16c3.1-2.3 5.4-4.2 7-5.7c.8-.7 1.5-1.3 1.9-1.8c.2-.2 .4-.4 .6-.6l.2-.2 .1-.1 0 0 0 0c0 0 0 0-11.6-11l11.7 11c2.5-2.6 4-6 4.3-9.6c.8-9.6 .8-19 .1-28.1c38.3 10.3 69.8 24.1 92.1 39.7C597.1 269.1 608 287.5 608 304c0 12.2-5.8 25.2-19.2 38.5c-13.5 13.4-33.7 26.2-60.1 37.3C476.1 401.9 402.3 416 320 416s-156.1-14.1-208.8-36.2c-26.3-11.1-46.6-23.9-60.1-37.3C37.8 329.2 32 316.2 32 304c0-16.5 10.9-34.9 36.5-52.8c22.3-15.6 53.7-29.3 92.1-39.7c-.7 9.1-.7 18.5 .1 28.1c.3 3.6 1.8 7 4.3 9.6l11.7-11zm296.3-61.5C452.3 110.2 390.3 64 320 64s-132.3 46.2-152.8 112.9C120 188.1 79.5 204.5 50.1 225C20.7 245.6 0 272.3 0 304c0 23.2 11.2 43.9 28.6 61.2c17.3 17.2 41.6 32 70.2 44.1C156.2 433.4 234.4 448 320 448s163.8-14.6 221.2-38.7c28.7-12.1 52.9-26.9 70.2-44.1c17.4-17.3 28.6-38 28.6-61.2c0-31.7-20.7-58.4-50.1-79c-29.3-20.5-69.9-36.9-117-48.1zm-21.1 50.5l.1-.1 0 0 0 0 0 0 0 0zm-3.9 3.3c-.5 .4-1.1 .8-1.7 1.3c-4.5 3.3-11.7 7.9-22 12.6C403.5 254 370 264 320 264s-83.5-10-104.2-19.4c-10.4-4.7-17.6-9.4-22-12.6c-.6-.5-1.2-.9-1.7-1.3C189.1 154.3 249.4 96 320 96s130.9 58.3 127.9 134.7zM96 312l32 32 32-32-32-32L96 312zm192 48l32 32 32-32-32-32-32 32zm224-80l-32 32 32 32 32-32-32-32z'
      
    ]
  };

  

  
  

  var faTextSize = {
    prefix: 'fasl',
    iconName: 'text-size',
    icon: [
      640,
      512,
      [],
      'f894',
      
      'M16 32H0V48v80 16H32V128 64H176l0 384H112 96v32h16H272h16V448H272 208l0-384H352v64 16h32V128 48 32H368 16zM336 224H320v16 48 16h32V288 256H464l0 192H416 400v32h16H544h16V448H544 496l0-192H608v32 16h32V288 240 224H624 480 336z'
      
    ]
  };

  

  
  

  var faSunHaze = {
    prefix: 'fasl',
    iconName: 'sun-haze',
    icon: [
      640,
      512,
      [],
      'f765',
      
      'M242.7 15.5L320 57.1l77.3-41.6L426 0l9.4 31.3 25.2 84.1 84.1 25.2L576 150l-15.5 28.8L518.9 256l0 0H482.5l0 0 8.2-15.2 38.5-71.5L451.4 146l-16.5-5-5-16.5L406.7 46.8 335.2 85.3 320 93.5l-15.2-8.2L233.3 46.8 210 124.6l-5 16.5-16.5 5-77.8 23.3 38.5 71.5 8.2 15.2 0 0H121.1l0 0L79.5 178.7 64 150l31.3-9.4 84.1-25.2 25.2-84.1L214 0l28.8 15.5zM448 256v0H416v0c0-53-43-96-96-96s-96 43-96 96v0H192v0c0-70.7 57.3-128 128-128s128 57.3 128 128zM80 288H400h16v32H400 80 64V288H80zm416 0H624h16v32H624 496 480V288h16zM16 384H560h16v32H560 16 0V384H16zm64 96H208h16v32H208 80 64V480H80zm224 0H624h16v32H624 304 288V480h16z'
      
    ]
  };

  

  
  

  var faVolleyball = {
    prefix: 'fasl',
    iconName: 'volleyball',
    icon: [
      512,
      512,
      [127952,"volleyball-ball"],
      'f45f',
      
      'M430.9 395.9l-48.9 18.5-3.7 1.4-4-.5L184.5 390.7l-7.3 75C201.7 475 228.2 480 256 480c70.8 0 133.9-32.8 174.9-84.1zm27.9-44.8C472.4 322.3 480 290 480 256c0-.9 0-1.8 0-2.8l-73.4 33.3-4 1.8-4.4-.5-134.8-15-64.3 87.4L374.5 383l84.3-31.9zM477 219.4C461.4 124.1 385.5 49 289.7 34.5l40.5 33.1 3.1 2.5 1.5 3.7 73.6 176.8L477 219.4zM237 32.8c-34.7 2.9-67.1 13.7-95.4 30.6l65.6 46.9 3.6 2.6 1.8 4 54.4 124.2 107.8 12-68-163.3L237 32.8zM113.8 82.9C63.9 124 32 186.3 32 256c0 28.8 5.4 56.3 15.3 81.6L55.8 286l.6-4 2.4-3.2L175.1 126.7 113.8 82.9zM72.2 384c19.3 27.7 44.7 50.8 74.2 67.4l7.8-80.2 .4-4.4 2.6-3.5L237.6 254l-43.5-99.4L86.7 295.1 72.2 384zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faVolleyballBall = faVolleyball;
  

  
  

  var faBuildingCircleArrowRight = {
    prefix: 'fasl',
    iconName: 'building-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e4d1',
      
      'M32 32H352V266.8c9.1-12.9 19.9-24.5 32-34.6V32 0H352 32 0V32 480v32H32h96 32 64 32 96 32v-8.2c-12.1-10-22.9-21.7-32-34.6V480H256V400 368H224 160 128v32 80H32V32zM160 480V400h64v80H160zM64 96v16 64 16H80h64 16V176 112 96H144 80 64zm32 32h32v32H96V128zM240 96H224v16 64 16h16 64 16V176 112 96H304 240zm16 64V128h32v32H256zM64 224v16 64 16H80h64 16V304 240 224H144 80 64zm32 32h32v32H96V256zm144-32H224v16 64 16h16 64 16V304 240 224H304 240zm16 64V256h32v32H256zm240-32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm8-222.6L481.4 312l11.3 11.3L521.4 352H432 416v32h16 89.4l-28.7 28.7L481.4 424 504 446.6l11.3-11.3 56-56L582.6 368l-11.3-11.3-56-56L504 289.4z'
      
    ]
  };

  

  
  

  var faRectangleHistory = {
    prefix: 'fasl',
    iconName: 'rectangle-history',
    icon: [
      512,
      512,
      [],
      'e4a2',
      
      'M480 160L32 160l0 320 448 0 0-320zm32-32l0 32 0 320 0 32-32 0L32 512 0 512l0-32L0 160l0-32 32 0 448 0 32 0zM464 64l0 32L48 96l0-32 416 0zM416 0l0 32L96 32 96 0 416 0z'
      
    ]
  };

  

  
  

  var faTally4 = {
    prefix: 'fasl',
    iconName: 'tally-4',
    icon: [
      640,
      512,
      [],
      'e297',
      
      'M144 48V32H112V48 464v16h32V464 48zm128 0V32H240V48 464v16h32V464 48zM400 32H368V48 464v16h32V464 48 32zM528 48V32H496V48 464v16h32V464 48z'
      
    ]
  };

  

  
  

  var faAnchorCircleCheck = {
    prefix: 'fasl',
    iconName: 'anchor-circle-check',
    icon: [
      640,
      512,
      [],
      'e4aa',
      
      'M336 80a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80c0 38.7 27.5 71 64 78.4V160v32H208 192v32h16 64V480H96V310.6l28.7 28.7L136 350.6 158.6 328l-11.3-11.3-56-56L80 249.4 68.7 260.7l-56 56L1.4 328 24 350.6l11.3-11.3L64 310.6V496v16H80 288 394.8c-12.9-9.1-24.5-19.9-34.6-32H304V224h64 16V192H368 304V160v-1.6c36.5-7.4 64-39.7 64-78.4c0-44.2-35.8-80-80-80zM496 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm78.6-176L552 313.4l-11.3 11.3L480 385.4l-28.7-28.7L440 345.4 417.4 368l11.3 11.3 40 40L480 430.6l11.3-11.3 72-72L574.6 336z'
      
    ]
  };

  

  
  

  var faMp3Player = {
    prefix: 'fasl',
    iconName: 'mp3-player',
    icon: [
      384,
      512,
      [],
      'f8ce',
      
      'M32 32V480H352V32H32zM0 0H32 352h32V32 480v32H352 32 0V480 32 0zM112 336a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 112a112 112 0 1 1 0-224 112 112 0 1 1 0 224zM168 336a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 96v64H288V96H96zM64 64H96 288h32V96v64 32H288 96 64V160 96 64z'
      
    ]
  };

  

  
  

  var faCalendarDays = {
    prefix: 'fasl',
    iconName: 'calendar-days',
    icon: [
      448,
      512,
      ["calendar-alt"],
      'f073',
      
      'M128 0V16 64H320V16 0h32V16 64h64 32V96v64 32V480v32H416 32 0V480 192 160 96 64H32 96V16 0h32zM416 192H312v72H416V192zm0 104H312v80H416V296zm0 112H312v72H416V408zM280 376V296H168v80H280zM168 408v72H280V408H168zm-32-32V296H32v80H136zM32 408v72H136V408H32zm0-144H136V192H32v72zm136 0H280V192H168v72zM416 96H32v64H416V96z'
      
    ]
  };

  
    var faCalendarAlt = faCalendarDays;
  

  
  

  var faWifiFair = {
    prefix: 'fasl',
    iconName: 'wifi-fair',
    icon: [
      640,
      512,
      ["wifi-2"],
      'f6ab',
      
      'M320 224c-74.1 0-140.8 31.5-187.5 81.7L110.9 282c52.5-55.4 126.8-90 209.1-90s156.6 34.6 209.1 90l-21.6 23.8C460.8 255.5 394.1 224 320 224zm32 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'
      
    ]
  };

  
    var faWifi2 = faWifiFair;
  

  
  

  var faTirePressureWarning = {
    prefix: 'fasl',
    iconName: 'tire-pressure-warning',
    icon: [
      512,
      512,
      [],
      'f633',
      
      'M400 0V16 27.6c0 42.2 9.8 83.9 28.7 121.6l5 9.9c.2 .3 .3 .6 .5 .9c18 30.9 36.4 73.1 35.8 120.5c-.6 45.5-18.7 97.9-76.2 151.4H118.2C60.7 378.5 42.6 326.1 42 280.6c-.6-47.4 17.8-89.7 35.8-120.5c.2-.3 .3-.6 .5-.9l5-9.9C102.2 111.4 112 69.8 112 27.6V16 0H80V16 27.6c0 37.3-8.7 74-25.3 107.3l-4.7 9.5C30.7 177.5 9.3 225.5 10 281c.7 55 23.1 115.3 86 174v57h32V464h64v48h32V464h64v48h32V464h64v48h32V455c62.9-58.7 85.3-119 86-174c.7-55.5-20.7-103.5-39.9-136.6l-4.7-9.5C440.7 101.6 432 64.8 432 27.6V16 0H400zM272 96H240v16V240v16h32V240 112 96zM232 288v48h48V288H232z'
      
    ]
  };

  

  
  

  var faDiceThree = {
    prefix: 'fasl',
    iconName: 'dice-three',
    icon: [
      448,
      512,
      [9858],
      'f527',
      
      'M32 64V448H416V64H32zM0 32H32 416h32V64 448v32H416 32 0V448 64 32zM128 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'
      
    ]
  };

  

  
  

  var faBuildingUn = {
    prefix: 'fasl',
    iconName: 'building-un',
    icon: [
      384,
      512,
      [],
      'e4d9',
      
      'M32 32V480h96V400 368h32 64 32v32 80h96V32H32zM160 480h64V400H160v80zm-32 32H32 0V480 32 0H32 352h32V32 480v32H352 256 224 160 128zm96-272h64 16v16 64 16H288 224 208V320 256 240h16zm16 64h32V272H240v32zM80 240H96h64 16v16 64 16H160 96 80V320 256 240zm32 32v32h32V272H112zm0-176v64c0 8.8 7.2 16 16 16s16-7.2 16-16V96 80h32V96v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V96 80h32V96zM224 80h8 9.9l4.4 8.8L272 140.2V96 80h32V96v96 16H288h-8-9.9l-4.4-8.8L240 147.8V192v16H208V192 96 80h16z'
      
    ]
  };

  

  
  

  var faRing = {
    prefix: 'fasl',
    iconName: 'ring',
    icon: [
      512,
      512,
      [],
      'f70b',
      
      'M32 170.9V195c1.8 2.5 4.7 6.1 8.6 10.6c7.6 8.5 19.3 19.8 35.7 31.4c40.5-24 99.1-45 179.6-45s139.1 21 179.6 45c16.4-11.6 28.1-22.9 35.7-31.4c4-4.4 6.8-8.1 8.6-10.6V170.9C457.6 145.8 387.9 96 256 96S54.4 145.8 32 170.9zM403.8 256c-35-17.6-83.3-32-147.8-32s-112.7 14.4-147.8 32c35 17.6 83.4 32 147.8 32s112.7-14.4 147.8-32zM60.9 265.2c-11.4-7.8-21-15.7-28.9-22.9v98.8C54.4 366.2 124.1 416 256 416s201.6-49.8 224-74.9V242.3c-7.9 7.3-17.5 15.1-28.9 22.9C410.6 292.9 347.4 320 256 320s-154.6-27.1-195.1-54.8zM512 160V352c-21.3 32-102.4 96-256 96S21.3 384 0 352V160c21.3-32 102.4-96 256-96s234.7 64 256 96z'
      
    ]
  };

  

  
  

  var faWaveSquare = {
    prefix: 'fasl',
    iconName: 'wave-square',
    icon: [
      640,
      512,
      [],
      'f83e',
      
      'M144 32h16H320h16V48 448H464V256 240h16H624h16v32H624 496V464v16H480 320 304V464 64H176V256v16H160 16 0V240H16 144V48 32z'
      
    ]
  };

  

  
  

  var faFileLines = {
    prefix: 'fasl',
    iconName: 'file-lines',
    icon: [
      384,
      512,
      [61686,128441,128462,"file-alt","file-text"],
      'f15c',
      
      'M352 480H32V32H192V176v16h16H352V480zM224 37.3L346.7 160H224V37.3zM232 0H32 0V32 480v32H32 352h32V480 152L232 0zM112 256H96v32h16H272h16V256H272 112zm0 64H96v32h16H272h16V320H272 112zm0 64H96v32h16H272h16V384H272 112z'
      
    ]
  };

  
    var faFileAlt = faFileLines;
  
    var faFileText = faFileLines;
  

  
  

  var faExplosion = {
    prefix: 'fasl',
    iconName: 'explosion',
    icon: [
      576,
      512,
      [],
      'e4e9',
      
      'M304 16V80 96H272V80 16 0h32V16zM16 480H193.3c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80H560h16v32H560 368 208 16 0V480H16zm210 0H350c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48zM75.9 347.7l18.9 1.6L128 352l-6.5-32.7L105.6 240 96 192l38.6 30.1 76.9 59.8L240 304l6.5-35.5L272 128h32l23.4 117.2L336 288l25.6-35.4L490.7 73.8 544 0 520.1 87.8 457 319.1 448 352l33.9-2.8 18.2-1.5L544 344l-27.5 34.4L460.8 448h-41l52.7-65.9-21.9 1.8-45.6 3.8 12-44.1 49.6-182L361.9 306.7 319 366.2l-14.4-71.9-15.9-79.4-17.3 94.9-9.4 52-41.7-32.4-76.1-59.2 15.1 75.7 8.3 41.7-42.4-3.5-21.9-1.8L156.2 448h-41L59.5 378.4 32 344l43.9 3.7z'
      
    ]
  };

  

  
  

  var faDownLeftAndUpRightToCenter = {
    prefix: 'fasl',
    iconName: 'down-left-and-up-right-to-center',
    icon: [
      512,
      512,
      ["compress-alt"],
      'f422',
      
      'M489.4 118.6l-26.7 26.7L440 168l22.6 22.6 2.7 2.7L488 216l-22.6 22.6L448 256H288 256V224 64l17.4-17.4L296 24l22.6 22.6 2.7 2.7L344 72l22.6-22.6 26.7-26.7L416 0l22.6 22.6 50.7 50.7L512 96l-22.6 22.6zM256 256v32V448l-17.4 17.4L216 488l-22.6-22.6-2.7-2.7L168 440l-22.6 22.6-26.7 26.7L96 512 73.4 489.4 22.6 438.6 0 416l22.6-22.6 26.7-26.7L72 344 49.4 321.4l-2.7-2.7L24 296l22.6-22.6L64 256H224h32zm161.4-65.4L394.7 168l22.6-22.6L466.7 96 416 45.3 366.6 94.6 344 117.3 321.4 94.6 296 69.3l-8 8V224H434.7l8-8-25.4-25.4zM94.6 321.4L117.3 344 94.6 366.6 45.3 416 96 466.7l49.4-49.4L168 394.7l22.6 22.6L216 442.7l8-8V288H77.3l-8 8 25.4 25.4z'
      
    ]
  };

  
    var faCompressAlt = faDownLeftAndUpRightToCenter;
  

  
  

  var faSquareUser = {
    prefix: 'fasl',
    iconName: 'square-user',
    icon: [
      448,
      512,
      [],
      'e283',
      
      'M416 64V448H378.7L336 320H112L69.3 448H32V64H416zM344.9 448H103.1l32-96H312.9l32 96zM32 32H0V64 448v32H32 416h32V448 64 32H416 32zM224 256a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z'
      
    ]
  };

  

  
  

  var faFaceHandPeeking = {
    prefix: 'fasl',
    iconName: 'face-hand-peeking',
    icon: [
      640,
      512,
      [129763],
      'e481',
      
      'M320 32c66.3 0 125.9 28.8 167 74.7l23.8-21.3C464 33 395.8 0 320 0C262.4 0 209.2 19.1 166.4 51.2l19.2 25.6C223 48.7 269.6 32 320 32zM130.5 375.5l-27.1 17.1C148.7 464.3 228.8 512 320 512c65.6 0 125.4-24.7 170.7-65.2L469.3 423c-39.6 35.5-91.9 57-149.3 57c-79.8 0-149.8-41.7-189.5-104.5zM360 254.7v32 24h16v16 24h24 16v16.9 24h24 80.8c31.6 0 61.9-12.6 84.3-34.9c46.2-46.2 46.5-120.9 1-167.6l-1.3-1.3-1.5-1.1-60.9-45.9L518.8 123l-12.6 26.8-11.7 24.9-47.7-32.8-19.4-13.3-13.7 19.2-18.6 26-13.5 18.9c-1.8-.4-3.7-.7-5.7-.7c-13.3 0-24 10.7-24 24c0 7.1 3.1 13.5 8 17.9v20.8zm35-24c3.2-4.1 5-9.2 5-14.7c0-4.1-1-7.9-2.8-11.3l3.6 2.5 32.8 23.5-38.6 0zM280 392c0-4.5 2.5-10.2 9.7-15.3c7.1-5.1 17.8-8.7 30.3-8.7s23.2 3.6 30.3 8.7c7.2 5.1 9.7 10.7 9.7 15.3s-2.5 10.2-9.7 15.3c-7.1 5.1-17.8 8.7-30.3 8.7s-23.2-3.6-30.3-8.7c-7.2-5.1-9.7-10.7-9.7-15.3zm40-56c-18.4 0-35.8 5.3-48.9 14.7C258 360.1 248 374.4 248 392s10 31.9 23.1 41.3c13.1 9.4 30.5 14.7 48.9 14.7s35.8-5.3 48.9-14.7C382 423.9 392 409.6 392 392s-10-31.9-23.1-41.3C355.8 341.3 338.4 336 320 336zm4-112c0-30.4 20-56.2 47.6-64.9l-7.2-22.9C327.1 147.9 300 182.8 300 224c0 20.7 6.8 39.8 18.4 55.2l19.2-14.4C329.1 253.4 324 239.3 324 224zm223.6-49.2l41.3 31.1c36.4 37.2 36.1 96.9-.8 133.8c-17.9 17.9-42.1 27.9-67.3 27.9H464 440v-8-8.9-7.1-8h16 8 16v-8.9H456 440l-16 0h-8H400v-8-8-16h24 32 24v-8H456 408h-8H384v-8-8-8-8h24l59.2 0h.2 15.3 8.7V242.5l-16.6-11.8-40.6-29-19.5-13.9 13.9-19.5 4.6-6.5 66.6 45.7 21.6 14.8 12.4 8.5 11.6 8V219.1l-30.2-30.2-.6-.6 2.9-6.1L528 160l19.6 14.8zM264 174.7v-24H240 156.8l1.5-1.5 17-17-17-17L129.9 87l-17-17L96 87 34.9 148.1l0 0-.8 .8 0 0-.1 .2c-45.5 46.6-45.2 121.3 1 167.6c22.4 22.4 52.7 34.9 84.3 34.9H192h24v-24V310.7h24.3 24.2l-.2-24.2-.2-15.8H280v-24-32-24H264v-16zM118.2 155.4l-5.7 5.7L98.8 174.7h19.3 8 6.6H216h24v8 8 8 8H216 184 160v8h24 48 8 16v8 8 8 8H240h-8l-48 0H160v8h24 56l.1 8 .1 8 .2 16h-24H216 192h-8H160v8.9h8 16 8v8 7.1l0 8.9 0 8H168 119.2c-25.2 0-49.5-10-67.3-27.9c-36.9-36.9-37.2-96.6-.8-133.8l.8-.8L96 121l17-17 11.3 11.3 5.7 5.7 11.3 11.3-17 17-1.5 1.5-4.7 4.7z'
      
    ]
  };

  

  
  

  var faTheta = {
    prefix: 'fasl',
    iconName: 'theta',
    icon: [
      384,
      512,
      [],
      'f69e',
      
      'M48 256c0-58.9 17.1-111.6 43.9-149.1C118.7 69.4 154.3 48 192 48s73.3 21.4 100.1 58.9C318.9 144.4 336 197.1 336 256s-17.1 111.6-43.9 149.1C265.3 442.6 229.7 464 192 464s-73.3-21.4-100.1-58.9C65.1 367.6 48 314.9 48 256zM192 16C141.3 16 96.9 44.8 65.8 88.3C34.7 131.9 16 191.2 16 256s18.7 124.1 49.8 167.7C96.9 467.2 141.3 496 192 496s95.1-28.8 126.2-72.3C349.3 380.1 368 320.8 368 256s-18.7-124.1-49.8-167.7C287.1 44.8 242.7 16 192 16zM112 240H96v32h16H272h16V240H272 112z'
      
    ]
  };

  

  
  

  var faFonduePot = {
    prefix: 'fasl',
    iconName: 'fondue-pot',
    icon: [
      512,
      512,
      [129749],
      'e40d',
      
      'M315.8 60.7l-19.3 70.6-2 7.2-2.1 7.7-2.1 7.5-6.4 23.3-22.6-6.2L255.1 192H221.7l8.8-29.5-23.7-6.4 8.4-30.9 2.1-7.7 21.2-77.9 2.1-7.7L249.2 1 280 9.5l15.4 4.2 30.9 8.4L317.9 53l-2.1 7.7zM224.4 256c-.2 0-.5 0-.7 0h.7zm99.2-64l24.9-39.2-19.7-12.6 17.2-27 4.3-6.7 44.1-69.3 4.3-6.7 17.2-27 27 17.2 13.5 8.6 27 17.2-17.2 27-4.3 6.7-44.1 69.3-4.3 6.7-17.2 27L375.5 170l-14 22H323.6zm53.7-68.3l-4.3 6.7 13.5 8.6 4.3-6.7L434.9 63l4.3-6.7-13.5-8.6-4.3 6.7-44.1 69.3zm-113.5 6.4L285 52.3l2.1-7.7-15.4-4.2L269.5 48l-21.2 77.9-2.1 7.7 15.4 4.2 2.1-7.7zM32 256v64c0 70.7 57.3 128 128 128H288c70.7 0 128-57.3 128-128V256h-8H160v64H128V256H96v96H64V256H32zm416 0v64c0 52.3-25.1 98.8-64 128v48 16H352V496 466.7c-19.6 8.6-41.2 13.3-64 13.3H160c-22.8 0-44.4-4.7-64-13.3V496v16H64V496 448C25.1 418.8 0 372.3 0 320V256 224H32 408h8 8 24 48 16v32H496 448z'
      
    ]
  };

  

  
  

  var faRingDiamond = {
    prefix: 'fasl',
    iconName: 'ring-diamond',
    icon: [
      384,
      512,
      [],
      'e5ab',
      
      'M161.6 128L125.2 70.9 146.8 32h90.3l21.6 38.9L222.4 128H192 161.6zm92.3 10.2L296 72 256 0H128L88 72l42.1 66.2C54.4 163.9 0 235.6 0 320C0 426 86 512 192 512s192-86 192-192c0-84.4-54.4-156.1-130.1-181.8zM192 480a160 160 0 1 1 0-320 160 160 0 1 1 0 320z'
      
    ]
  };

  

  
  

  var faRobotAstromech = {
    prefix: 'fasl',
    iconName: 'robot-astromech',
    icon: [
      512,
      512,
      [],
      'e2d2',
      
      'M256 0C176.5 0 112 64.5 112 144v16H48 32v16V420.2L1.7 480.8 0 484.2V488v8 16H16 128h16V496 406.6l36.7 36.7 4.7 4.7H192 320h6.6l4.7-4.7L368 406.6V496v16h16H496h16V496v-8-3.8l-1.7-3.4L480 420.2V176 160H464 400V144C400 64.5 335.5 0 256 0zM400 192h48V424v3.8l1.7 3.4L474.1 480H400V374.6 368 192zm-32-32H144V144c0-61.9 50.1-112 112-112s112 50.1 112 112v16zM144 192H368V361.4L313.4 416H198.6L144 361.4V192zm-32 0V368v6.6V480H37.9l24.4-48.8 1.7-3.4V424 192h48zm112-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM192 224v32h16 96 16V224H304 208 192zm0 64v32h16 96 16V288H304 208 192z'
      
    ]
  };

  

  
  

  var faInfo = {
    prefix: 'fasl',
    iconName: 'info',
    icon: [
      192,
      512,
      [],
      'f129',
      
      'M128 32V96H64V32h64zM16 160H32 96h16v16V448h64 16v32H176 16 0V448H16 80V192H32 16V160z'
      
    ]
  };

  

  
  

  var faSalad = {
    prefix: 'fasl',
    iconName: 'salad',
    icon: [
      512,
      512,
      [129367,"bowl-salad"],
      'f81e',
      
      'M241.1 32c-37.2 0-69.1 22.8-82.4 55.2l-4.7 11.5L141.6 97c-4.4-.6-9-1-13.6-1c-53 0-96 43-96 96c0 24.6 9.2 47 24.4 64H17.1C6.2 237.2 0 215.3 0 192C0 121.3 57.3 64 128 64c2.1 0 4.2 0 6.2 .1C154.6 26 194.8 0 241.1 0C287.4 0 327.6 26 348 64.1c1.3 0 2.7-.1 4-.1c36 0 68.5 14.9 91.8 38.8C430 98.4 415.3 96 400 96c-9 0-17.9 .8-26.5 2.4C366.6 96.8 359.4 96 352 96c-4 0-7.9 .2-11.8 .7l-12.1 1.5L323.5 87c-13.4-32.3-45.3-55-82.3-55zM400 160c-44.2 0-80 35.8-80 80c0 5.5 .6 10.8 1.6 16H289.1c-.7-5.2-1.1-10.6-1.1-16c0-61.9 50.1-112 112-112s112 50.1 112 112c0 5.4-.4 10.8-1.1 16H478.4c1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80zM128 463.8V480H384V463.8 443.6l18.3-8.7c43.7-20.8 74.6-64.1 77.5-114.9H32.2c2.9 50.8 33.8 94.2 77.5 114.9l18.3 8.7v20.2zm-32 0C41.5 437.9 3.2 383.6 .2 320c-.1-2.7-.2-5.3-.2-8V288H32 480h32v24c0 2.7-.1 5.3-.2 8c-3 63.6-41.3 117.9-95.8 143.8V480v32H384 128 96V480 463.8zM256 112V240v16H224V240 112 96h32v16zM107.3 148.7l80 80L198.6 240 176 262.6l-11.3-11.3-80-80L73.4 160 96 137.4l11.3 11.3z'
      
    ]
  };

  
    var faBowlSalad = faSalad;
  

  
  

  var faMessage = {
    prefix: 'fasl',
    iconName: 'message',
    icon: [
      512,
      512,
      ["comment-alt"],
      'f27a',
      
      'M128 416h32v32 25.5V512l32-21.3L304 416H480h32V384 32 0H480 32 0V32 384v32H32h96zM32 384V32H480V384H304h-9.7l-8.1 5.4L192 452.2V416 384H160 32z'
      
    ]
  };

  
    var faCommentAlt = faMessage;
  

  
  

  var faCoffin = {
    prefix: 'fasl',
    iconName: 'coffin',
    icon: [
      384,
      512,
      [9904],
      'f6c6',
      
      'M128.2 480H255.8l93-329.1L256.3 32H127.7L35.2 150.9l93 329.1zM280 512H104L0 144 112 0H272L384 144 280 512z'
      
    ]
  };

  

  
  

  var faStethoscope = {
    prefix: 'fasl',
    iconName: 'stethoscope',
    icon: [
      576,
      512,
      [129658],
      'f0f1',
      
      'M132.6 33.4l-15 5.6L64 59.1V192c0 70.7 57.3 128 128 128s128-57.3 128-128V59.1L266.4 39l-15-5.6 11.2-30 15 5.6 64 24L352 36.9V48 192c0 83-63.1 151.2-144 159.2v.8c0 70.7 57.3 128 128 128s128-57.3 128-128V254c-27.6-7.1-48-32.2-48-62c0-35.3 28.7-64 64-64s64 28.7 64 64c0 29.8-20.4 54.9-48 62v98c0 88.4-71.6 160-160 160s-160-71.6-160-160v-.8C95.1 343.2 32 275 32 192V48 36.9L42.4 33l64-24 15-5.6 11.2 30zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'
      
    ]
  };

  

  
  

  var faGaugeSimpleMin = {
    prefix: 'fasl',
    iconName: 'gauge-simple-min',
    icon: [
      512,
      512,
      ["tachometer-slowest"],
      'f62d',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64s-28.7-64-64-64c-17.5 0-33.4 7-44.9 18.4L104.2 242.3 90.5 234 74 261.5l13.7 8.2 106.8 64.1c-1.7 5.8-2.6 11.9-2.6 18.2c0 35.3 28.7 64 64 64z'
      
    ]
  };

  
    var faTachometerSlowest = faGaugeSimpleMin;
  

  
  

  var faFaceHandYawn = {
    prefix: 'fasl',
    iconName: 'face-hand-yawn',
    icon: [
      512,
      512,
      [],
      'e379',
      
      'M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 57.4-21.6 109.7-57 149.3l23.8 21.3C487.3 381.4 512 321.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 57.6 19.1 110.8 51.2 153.6l25.6-19.2C48.7 353 32 306.5 32 256zm296 1.4l9.4 9.4 3.9 3.9 9.4 9.4-11.3 11.3-4.7 4.7-6.6 6.6-4.7 4.7-33.4 33.4-22.6 22.6 9.4 9.4 22.6-22.6L321.4 328l11.3-11.3L344 305.4l13.3 13.3 9.4 9.4-9.4 9.4-1.9 1.9L344 350.6l-9.4 9.4-11.3 11.3-1.4 1.4-22.6 22.6 9.4 9.4L321.4 392l9.9-9.9 1.4-1.4L344 369.4l13.3 13.3 9.4 9.4-11.3 11.3L344 414.6l-12.7 12.7-22.6 22.6-2.2 2.2C288.7 470 264.4 480 239.2 480c-52.6 0-95.2-42.6-95.2-95.2V372 352 334.4v-12-20h8 21.7H176h8v20 12 3l6.1-6.1 8.9-8.9 13.7-13.7 3.3-3.3L257.4 264l11.3-11.3L280 241.4l9.4 9.4L302.6 264l-11.3 11.3L280 286.6l-22.1 22.1-22.6 22.6 9.4 9.4 22.6-22.6 33.4-33.4 4.7-4.7 6.6-6.6 4.7-4.7L328 257.4zm0-45.3l-16 16-9.4-9.4L280 196.1l-22.6 22.6-11.3 11.3-40.3 40.3H184 144 112v32 20V352v20 12.8C112 455.1 168.9 512 239.2 512c33.7 0 66.1-13.4 89.9-37.3l48.8-48.8 11.3-11.3L411.9 392l-22.6-22.6-9.4-9.4 9.4-9.4L411.9 328l-22.6-22.6-9.4-9.4 16-16-22.6-22.6-22.6-22.6L328 212.1zm-97.5-89.6l-20-25-12.5 10-80 64-12.5 10 20 25 12.5-10 80-64 12.5-10zm63.5 10l80 64 12.5 10 20-25-12.5-10-80-64-12.5-10-20 25 12.5 10z'
      
    ]
  };

  

  
  

  var faUserXmark = {
    prefix: 'fasl',
    iconName: 'user-xmark',
    icon: [
      640,
      512,
      ["user-times"],
      'f235',
      
      'M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM87.6 336H360.4l44.3 144H43.3L87.6 336zM384 304H64L9.8 480 0 512H33.5h381H448l-9.8-32L384 304zm95.4-167.2l-22.6 22.6 11.3 11.3L521.4 224l-53.3 53.3-11.3 11.3 22.6 22.6 11.3-11.3L544 246.6l53.3 53.3 11.3 11.3 22.6-22.6-11.3-11.3L566.6 224l53.3-53.3 11.3-11.3-22.6-22.6-11.3 11.3L544 201.4l-53.3-53.3-11.3-11.3z'
      
    ]
  };

  
    var faUserTimes = faUserXmark;
  

  
  

  var faTextHeight = {
    prefix: 'fasl',
    iconName: 'text-height',
    icon: [
      576,
      512,
      [],
      'f034',
      
      'M16 32H0V48v80 16H32V128 64H144l0 384H80 64v32H80 240h16V448H240 176l0-384H288v64 16h32V128 48 32H304 16zM491.3 44.7L480 33.4 468.7 44.7l-80 80 22.6 22.6L464 94.6l0 322.7-52.7-52.7-22.6 22.6 80 80L480 478.6l11.3-11.3 80-80-22.6-22.6L496 417.4l0-322.7 52.7 52.7 22.6-22.6-80-80z'
      
    ]
  };

  

  
  

  var faHeadSideGoggles = {
    prefix: 'fasl',
    iconName: 'head-side-goggles',
    icon: [
      512,
      512,
      ["head-vr"],
      'f6ea',
      
      'M2.3 256C9.2 304.3 31.5 347.6 64 380.8V496v16H96V496 374.1v-6.8l-4.9-4.7c-29.1-28-49.5-65-56.4-106.5H2.3zM80.9 96C116 56.7 167.1 32 224 32h24c36 0 69.3 11.9 96 32H288c-28.4 0-54 12.4-71.6 32H80.9zM40.1 96H16 0v16 96 16H16 216.4c17.6 19.6 43.1 32 71.6 32H400h96 16V240 80 64H496 400h-8.9C356 24.7 304.9 0 248 0H224C147.9 0 80.6 38 40.1 96zm157.3 96H32V128H197.5c-3.5 10-5.5 20.8-5.5 32s1.9 22 5.5 32zM480 288v16H432 416v16 96H304 288v16 64 16h32V496 448H432h16V432 336h48 16V320 288H480zM288 96h96V224H288c-35.3 0-64-28.7-64-64s28.7-64 64-64zM416 224V96h64V224H416z'
      
    ]
  };

  
    var faHeadVr = faHeadSideGoggles;
  

  
  

  var faCircleL = {
    prefix: 'fasl',
    iconName: 'circle-l',
    icon: [
      512,
      512,
      [],
      'e114',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 144V128H160v16V368v16h16H336h16V352H336 192V144z'
      
    ]
  };

  

  
  

  var faTrashCan = {
    prefix: 'fasl',
    iconName: 'trash-can',
    icon: [
      448,
      512,
      [61460,"trash-alt"],
      'f2ed',
      
      'M160 0h-8.9l-4.7 7.5L111.1 64H64 32 0V96H32V480v32H64 384h32V480 96h32V64H416 384 336.9L301.6 7.5 296.9 0H288 160zM299.1 64H148.9l20-32H279.1l20 32zM64 480V96H384V480H64zm80-304V160H112v16V400v16h32V400 176zm96 0V160H208v16V400v16h32V400 176zm96 0V160H304v16V400v16h32V400 176z'
      
    ]
  };

  
    var faTrashAlt = faTrashCan;
  

  
  

  var faPhoneArrowUpRight = {
    prefix: 'fasl',
    iconName: 'phone-arrow-up-right',
    icon: [
      512,
      512,
      ["phone-arrow-up","phone-outgoing"],
      'e224',
      
      'M280.4 355.3l21.3 12.3L319 350.2l40.7-40.7L475.8 356 453.3 480H448C218.2 480 32 293.7 32 64l0-5.3L156 36.2l46.5 116.1-40.7 40.7-17.3 17.3 12.3 21.3c29.6 51.4 72.4 94.1 123.7 123.7zM512 336L352 272l-55.6 55.6c-46.5-26.8-85.2-65.5-112-112L240 160 176 0 0 32 0 64C0 311.4 200.6 512 448 512h32l32-176zM292.7 196.7L281.4 208 304 230.6l11.3-11.3L480 54.6V144v16h32V144 16 0H496 368 352V32h16 89.4L292.7 196.7z'
      
    ]
  };

  
    var faPhoneArrowUp = faPhoneArrowUpRight;
  
    var faPhoneOutgoing = faPhoneArrowUpRight;
  

  
  

  var faRectanglesMixed = {
    prefix: 'fasl',
    iconName: 'rectangles-mixed',
    icon: [
      576,
      512,
      [],
      'e323',
      
      'M288 64V224H32V64H288zM32 32H0V64 224v32H32 288h32V224 64 32H288 32zM544 64V352H416V64H544zM416 32H384V64 352v32h32H544h32V352 64 32H544 416zM96 336H304V448H96V336zM64 304v32V448v32H96 304h32V448 336 304H304 96 64z'
      
    ]
  };

  

  
  

  var faAt = {
    prefix: 'fasl',
    iconName: 'at',
    icon: [
      512,
      512,
      [61946],
      '40',
      
      'M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224h16v32H256C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v96 16H496 424c-33.4 0-62.5-18.7-77.4-46.1c-20.4 28-53.4 46.1-90.6 46.1c-61.9 0-112-50.1-112-112s50.1-112 112-112c31.3 0 59.7 12.9 80 33.6V176 160h32v16 80 24c0 30.9 25.1 56 56 56h56V256C480 132.3 379.7 32 256 32zm80 224a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faTransporter7 = {
    prefix: 'fasl',
    iconName: 'transporter-7',
    icon: [
      512,
      512,
      [],
      'e2a8',
      
      'M480 48V32H448V48 64H432 416V96h16 16v16 16h32V112 96h16 16V64H496 480V48zM64 272V256H32v16 16H16 0v32H16 32v16 16H64V336 320H80 96V288H80 64V272zm48 176H96v16 32 16h32V496 480H384v16 16h32V496 464 448H400 112z'
      
    ]
  };

  

  
  

  var faBagel = {
    prefix: 'fasl',
    iconName: 'bagel',
    icon: [
      640,
      512,
      [129391],
      'e3d7',
      
      'M608 208c0-97.2-78.8-176-176-176c-49.3 0-93.9 20.3-125.8 52.9c-10.5-4.7-21.3-8.7-32.5-11.8C311.8 28.4 368.6 0 432 0C546.9 0 640 93.1 640 208s-93.1 208-208 208c-3.9 0-7.7-.1-11.5-.3c5.4-10.2 10-20.7 13.9-31.7C530.5 382.7 608 304.4 608 208zM342.7 85l49-1.4L432 56l40.4 27.7L521.3 85l16.4 46.1L576.6 161l-13.8 47 13.8 47-38.8 29.9L521.3 331l-48.9 1.4-29.3 20.1c2.8-13.6 4.4-27.7 4.8-42.1l6.4-4.4 7.8-5.3 9.4-.3 27-.7 9.1-25.5 3.2-8.9 7.5-5.8L539.7 243 532 217l-2.7-9 2.7-9 7.6-25.9-21.4-16.5-7.5-5.8-3.2-8.9-9.1-25.5-27-.7-9.4-.3-7.8-5.3L432 94.8l-22.3 15.3-7.8 5.3-9.4 .3-27 .7-1.8 4.9c-8.5-7.2-17.5-13.9-26.9-19.9L342.7 85zM384 304A176 176 0 1 0 32 304a176 176 0 1 0 352 0zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zm208-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM128 192l16-16 16 16-16 16-16-16zm192 64l-16-16 16-16 16 16-16 16zM112 416L96 400l16-16 16 16-16 16zm128 32l-16-16 16-16 16 16-16 16zm48-48l16-16 16 16-16 16-16-16zM80 288L64 272l16-16 16 16L80 288z'
      
    ]
  };

  

  
  

  var faLineHeight = {
    prefix: 'fasl',
    iconName: 'line-height',
    icon: [
      576,
      512,
      [],
      'f871',
      
      'M107.3 44.7L96 33.4 84.7 44.7l-72 72L1.4 128 24 150.6l11.3-11.3L80 94.6V417.4L35.3 372.7 24 361.4 1.4 384l11.3 11.3 72 72L96 478.6l11.3-11.3 72-72L190.6 384 168 361.4l-11.3 11.3L112 417.4V94.6l44.7 44.7L168 150.6 190.6 128l-11.3-11.3-72-72zM272 80H256v32h16H560h16V80H560 272zm0 160H256v32h16H560h16V240H560 272zM256 400v32h16H560h16V400H560 272 256z'
      
    ]
  };

  

  
  

  var faWagonCovered = {
    prefix: 'fasl',
    iconName: 'wagon-covered',
    icon: [
      640,
      512,
      [],
      'f8ee',
      
      'M639.3 1.8L615.1 3.2 391.6 16H248.4L24.9 3.2 .7 1.8 9 24.7 81.2 224H80 64v16 32 16H96V272 256h8H248h16l112 0h16H536l8 0v16 16h32V272 240 224H560h-1.2L631 24.7l8.3-22.8zM524.8 224H408V47.1L592.7 36.6 524.8 224zM232 224H115.2L47.3 36.6 232 47.1V224zM264 48H376V224H264V48zM176 512c56.4 0 103.1-41.7 110.9-96h66.3c7.8 54.3 54.4 96 110.9 96c61.9 0 112-50.1 112-112s-50.1-112-112-112c-56.4 0-103.1 41.7-110.9 96H286.9c-7.8-54.3-54.4-96-110.9-96c-61.9 0-112 50.1-112 112s50.1 112 112 112zm16-33.6V416h62.4c-6.4 31.3-31.1 56-62.4 62.4zm-32 0c-31.3-6.4-56-31.1-62.4-62.4H160v62.4zM96 399.6v.8l0-.4 0-.4zM97.6 384c6.4-31.3 31.1-56 62.4-62.4V384H97.6zM192 321.6c31.3 6.4 56 31.1 62.4 62.4H192V321.6zM542.4 416c-6.4 31.3-31.1 56-62.4 62.4V416h62.4zM448 416v62.4c-31.3-6.4-56-31.1-62.4-62.4H448zm-64-16l0 .4v-.8l0 .4zm64-16H385.6c6.4-31.3 31.1-56 62.4-62.4V384zm32 0V321.6c31.3 6.4 56 31.1 62.4 62.4H480z'
      
    ]
  };

  

  
  

  var faCircleChevronRight = {
    prefix: 'fasl',
    iconName: 'circle-chevron-right',
    icon: [
      512,
      512,
      ["chevron-circle-right"],
      'f138',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm347.3 11.3L358.6 256l-11.3-11.3-112-112L224 121.4 201.4 144l11.3 11.3L313.4 256 212.7 356.7 201.4 368 224 390.6l11.3-11.3 112-112z'
      
    ]
  };

  
    var faChevronCircleRight = faCircleChevronRight;
  

  
  

  var faArrowsToCircle = {
    prefix: 'fasl',
    iconName: 'arrows-to-circle',
    icon: [
      640,
      512,
      [],
      'e4bd',
      
      'M35.3 12.7L24 1.4 1.4 24 12.7 35.3 137.4 160H80 64v32H80h96 16V176 80 64H160V80v57.4L35.3 12.7zM320 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM448 64V80v96 16h16 96 16V160H560 502.6L627.3 35.3 638.6 24 616 1.4 604.7 12.7 480 137.4V80 64H448zM192 448V432 336 320H176 80 64v32H80h57.4L12.7 476.7 1.4 488 24 510.6l11.3-11.3L160 374.6V432v16h32zm256 0h32V432 374.6L604.7 499.3 616 510.6 638.6 488l-11.3-11.3L502.6 352H560h16V320H560 464 448v16 96 16z'
      
    ]
  };

  

  
  

  var faFillDrip = {
    prefix: 'fasl',
    iconName: 'fill-drip',
    icon: [
      576,
      512,
      [],
      'f576',
      
      'M0 272l22.6 22.6L217.4 489.4 240 512l22.6-22.6L489.4 262.6 512 240l-22.6-22.6L294.6 22.6 272 0 249.4 22.6l-86.1 86.1-96-96L56 1.4 33.4 24 44.7 35.3l96 96L22.6 249.4 0 272zm244.7-36.7L256 246.6 278.6 224l-11.3-11.3-81.4-81.4L272 45.3 466.7 240l-48 48H61.3l-16-16L163.3 153.9l81.4 81.4zM93.3 320H386.7L240 466.7 93.3 320zM484.1 433.3L512 384.5l27.9 48.8c2.7 4.7 4.1 10.1 4.1 15.5c0 17.2-14 31.2-31.2 31.2h-1.6C494 480 480 466 480 448.8c0-5.4 1.4-10.8 4.1-15.5zm-27.8-15.9c-5.5 9.6-8.3 20.4-8.3 31.4c0 34.9 28.3 63.2 63.2 63.2h1.6c34.9 0 63.2-28.3 63.2-63.2c0-11-2.9-21.8-8.3-31.4l-37.2-65.2L512 320l-18.4 32.2-37.2 65.2z'
      
    ]
  };

  



export {

  faTurnUp,
  
  faLevelUpAlt,
  

  faMessageText,
  
  faCommentAltText,
  

  faSquareZ,
  

  faPersonCircleCheck,
  

  faHandHoldingMedical,
  

  faGraduationCap,
  
  faMortarBoard,
  

  faMessageMiddle,
  
  faCommentMiddleAlt,
  

  faVideo,
  
  faVideoCamera,
  

  faSquareSlidersVertical,
  
  faSlidersVSquare,
  

  faPlusMinus,
  

  faBulldozer,
  

  faBarcode,
  

  faFileMp4,
  

  faShieldKeyhole,
  

  faReflectVertical,
  

  faSquareShareNodes,
  
  faShareAltSquare,
  

  faComet,
  

  faJetFighter,
  
  faFighterJet,
  

  faPageCaretUp,
  
  faFileCaretUp,
  

  faHandshakeSimple,
  
  faHandshakeAlt,
  

  faEyes,
  

  faCircleJ,
  

  faGalleryThumbnails,
  

  faHandPointLeft,
  

  faPineapple,
  

  faCloudQuestion,
  

  faFaceWoozy,
  

  faKipSign,
  

  faFileGif,
  

  faMasksTheater,
  
  faTheaterMasks,
  

  faStapler,
  

  faD,
  

  faBedFront,
  
  faBedAlt,
  

  faHorizontalRule,
  

  faTrowel,
  

  faUmbrella,
  

  faCameraCctv,
  
  faCctv,
  

  faGrid2,
  

  faSack,
  

  faCircleT,
  

  faBuildingColumns,
  
  faBank,
  
  faInstitution,
  
  faMuseum,
  
  faUniversity,
  

  faPersonMilitaryPointing,
  

  faUsersGear,
  
  faUsersCog,
  

  faMagnifyingGlassDollar,
  
  faSearchDollar,
  

  faX,
  

  faSkullCow,
  

  faComputerSpeaker,
  

  faFerrisWheel,
  

  faDollarSign,
  
  faDollar,
  
  faUsd,
  

  faCircleWaveformLines,
  
  faWaveformCircle,
  

  faFaceNoseSteam,
  

  faTurkishLiraSign,
  
  faTry,
  
  faTurkishLira,
  

  faPrint,
  

  faCommentXmark,
  
  faCommentTimes,
  

  faFaceSmileRelaxed,
  

  faArrowsSpin,
  

  faExclamation,
  

  faTentArrowsDown,
  

  faPlane,
  

  faFaceSadTear,
  
  faSadTear,
  

  faBlockBrickFire,
  
  faFirewall,
  

  faUserInjured,
  

  faBrainCircuit,
  

  faSkiBootSki,
  

  faKeyboardBrightnessLow,
  

  faBenchTree,
  

  faCircle3,
  

  faCardsBlank,
  

  faBone,
  

  faFileCheck,
  

  faArrowUpFromWaterPump,
  

  faBoot,
  

  faTruckContainer,
  

  faPenFancySlash,
  

  faToggleLargeOff,
  

  faLightSwitchOff,
  

  faCupcake,
  

  faBugSlash,
  

  faFaceSadSweat,
  

  faLocationPinSlash,
  
  faMapMarkerSlash,
  

  faWindWarning,
  
  faWindCircleExclamation,
  

  faPaperclipVertical,
  

  faHundredPoints,
  
  fa100,
  

  faDown,
  
  faArrowAltDown,
  

  faNoteSticky,
  
  faStickyNote,
  

  faDiceD12,
  

  faGramophone,
  

  faJar,
  

  faMagnet,
  

  faCircle2,
  

  fa1,
  

  faFalafel,
  

  faPenSwirl,
  

  faCommentExclamation,
  

  faGripDots,
  

  faSquareFull,
  

  faStopwatch20,
  

  faShieldExclamation,
  

  faCloudSun,
  

  faSyringe,
  

  faBoombox,
  

  faUserNurse,
  

  faTrashCheck,
  

  faBridgeSuspension,
  

  faTrainTram,
  

  faStarshipFreighter,
  

  faUserLarge,
  
  faUserAlt,
  

  faCirclesOverlap,
  

  faRulerVertical,
  

  faRightLeftLarge,
  

  faArrowDownFromArc,
  

  faFlower,
  

  faMagnifyingGlassMinus,
  
  faSearchMinus,
  

  faCalendarHeart,
  

  faMask,
  

  faTreeDecorated,
  

  faBrush,
  

  faMugSaucer,
  
  faCoffee,
  

  faGarlic,
  

  faCommentArrowUp,
  

  faRectangleWide,
  

  faWindowMinimize,
  

  faFileInvoice,
  

  faHandDots,
  
  faAllergies,
  

  faArrowDownToDottedLine,
  

  faClockTwelveThirty,
  

  faOnion,
  

  faUserClock,
  

  faCloudShowers,
  

  faThumbsUp,
  

  faMagnifyingGlassPlus,
  
  faSearchPlus,
  

  faIdCardClip,
  
  faIdCardAlt,
  

  faEarthAsia,
  
  faGlobeAsia,
  

  faHotel,
  

  fa9,
  

  faAlbumCollection,
  

  faGifts,
  

  faCircle4,
  

  faCircleXmark,
  
  faTimesCircle,
  
  faXmarkCircle,
  

  faCalendarMinus,
  

  faBandage,
  
  faBandAid,
  

  faClapperboardPlay,
  

  faSensorCloud,
  
  faSensorSmoke,
  

  faBookUser,
  

  faWatchSmart,
  

  faBrain,
  

  faPompebled,
  

  faBowlingBall,
  

  faUnicorn,
  

  faDice,
  

  faSquareEnvelope,
  
  faEnvelopeSquare,
  

  faPersonWalkingArrowRight,
  

  faRectangleBarcode,
  
  faBarcodeAlt,
  

  faSquareS,
  

  faTurnDown,
  
  faLevelDownAlt,
  

  faWheelchairMove,
  
  faWheelchairAlt,
  

  faFaceGrimace,
  
  faGrimace,
  

  faChessPawnPiece,
  
  faChessPawnAlt,
  

  faArrowsUpDown,
  
  faArrowsV,
  

  faWaterLadder,
  
  faLadderWater,
  
  faSwimmingPool,
  

  faCalendarDay,
  

  faBellRing,
  

  faAudioDescriptionSlash,
  

  faFileSpreadsheet,
  

  faWheat,
  

  faTurnLeft,
  

  faCircleCaretRight,
  
  faCaretCircleRight,
  

  faHands,
  
  faSignLanguage,
  
  faSigning,
  

  faLifeRing,
  

  faMoneyBill1Wave,
  
  faMoneyBillWaveAlt,
  

  faEngine,
  

  faTire,
  

  faScannerGun,
  
  faScanner,
  

  faAlignRight,
  

  faWindowFlip,
  
  faWindowAlt,
  

  faInputText,
  

  faHandHoldingBox,
  

  faDungeon,
  

  faRoadCircleExclamation,
  

  faPaperPlane,
  

  faColumns3,
  

  faRightLeft,
  
  faExchangeAlt,
  

  faMessageDollar,
  
  faCommentAltDollar,
  

  faGridHorizontal,
  

  faCircleO,
  

  faScannerKeyboard,
  

  faHillRockslide,
  

  faMaskFace,
  

  faBottleDroplet,
  

  faTurnDownRight,
  

  faFaceThinking,
  

  faShare,
  
  faMailForward,
  

  faDownLeft,
  

  faDatabase,
  

  faNoteMedical,
  

  faTriangleExclamation,
  
  faExclamationTriangle,
  
  faWarning,
  

  faSnake,
  

  faHandcuffs,
  

  faInhaler,
  

  faBookJournalWhills,
  
  faJournalWhills,
  

  faBookOpen,
  

  faChevronsRight,
  
  faChevronDoubleRight,
  

  faCorner,
  

  faBahtSign,
  

  faCowbell,
  

  faLightbulbDollar,
  

  faTireRugged,
  

  faRectangleXmark,
  
  faRectangleTimes,
  
  faTimesRectangle,
  
  faWindowClose,
  

  faHandBackPointRibbon,
  

  faCartFlatbedSuitcase,
  
  faLuggageCart,
  

  faEarthEurope,
  
  faGlobeEurope,
  

  faPrintSlash,
  

  faRug,
  

  faUserTag,
  

  faImagePortrait,
  
  faPortrait,
  

  faPersonFalling,
  

  faBriefcase,
  

  faPotFood,
  

  faCloudMoon,
  

  faLocationPen,
  
  faMapMarkerEdit,
  

  faSlashForward,
  

  faShieldQuartered,
  

  faHandFist,
  
  faFistRaised,
  

  faAirplay,
  

  faLamp,
  

  faArrowsSplitUpAndLeft,
  

  faSquareW,
  

  faTruckArrowRight,
  

  faDiagramSuccessor,
  

  faCartFlatbedBoxes,
  
  faDollyFlatbedAlt,
  

  faAngleLeft,
  

  faBuildings,
  

  faHouseCircleCheck,
  

  faSwordLaser,
  

  faTomato,
  

  faBatteryThreeQuarters,
  
  faBattery4,
  

  faCheck,
  

  faIceSkate,
  

  faUserPlus,
  

  faBook,
  

  faTurkey,
  

  faClipboardListCheck,
  

  faRectangle,
  
  faRectangleLandscape,
  

  faCommentSms,
  
  faSms,
  

  faBasketShoppingMinus,
  

  faTableList,
  
  faThList,
  

  faHandBackPointDown,
  

  faH5,
  

  fa4,
  

  faSoftServe,
  
  faCreemee,
  

  faFaceViewfinder,
  

  faGripDotsVertical,
  

  faSpinnerScale,
  

  faM,
  

  faDesktop,
  
  faDesktopAlt,
  

  faDiceD8,
  

  faShower,
  

  faDoNotEnter,
  

  faGaugeSimpleHigh,
  
  faTachometer,
  
  faTachometerFast,
  

  faArrowDownBigSmall,
  
  faSortSizeDown,
  

  faCalendarLines,
  
  faCalendarNote,
  

  faScaleBalanced,
  
  faBalanceScale,
  

  faDrawPolygon,
  

  faFaceMonocle,
  

  faRss,
  
  faFeed,
  

  faArrowTrendDown,
  

  faCookieBite,
  

  faPeopleSimple,
  

  faFaceAngry,
  
  faAngry,
  

  faFunction,
  

  faBorderAll,
  

  faAnchor,
  

  faCircleQuarter,
  

  faBookQuran,
  
  faQuran,
  

  faDeleteRight,
  

  faFileCirclePlus,
  

  faTornado,
  

  faFireFlameCurved,
  
  faFireAlt,
  

  faArrowUpZA,
  
  faSortAlphaUpAlt,
  

  faPersonWalkingArrowLoopLeft,
  

  faClone,
  

  faLinkSlash,
  
  faChainBroken,
  
  faChainSlash,
  
  faUnlink,
  

  faPlugCircleExclamation,
  

  faHandHolding,
  

  faFaceGrinTongueWink,
  
  faGrinTongueWink,
  

  faCirclePlus,
  
  faPlusCircle,
  

  faShoePrints,
  

  faDragon,
  

  faWifiWeak,
  
  faWifi1,
  

  faBorderBottom,
  

  faVolumeSlash,
  

  faSdCard,
  

  faAmpGuitar,
  

  faLighthouse,
  

  faBahai,
  
  faHaykal,
  

  faUserDoctorMessage,
  
  faUserMdChat,
  

  faTrailer,
  

  faBoxHeart,
  

  faCalendar,
  

  faBoothCurtain,
  

  faCloudMoonRain,
  

  faUpDown,
  
  faArrowsAltV,
  

  faPencilMechanical,
  

  faTurtle,
  

  faCaravanSimple,
  
  faCaravanAlt,
  

  faPersonWalkingLuggage,
  

  faParagraphLeft,
  
  faParagraphRtl,
  

  faBagsShopping,
  

  faFan,
  

  faBlockBrick,
  
  faWallBrick,
  

  faVoicemail,
  

  faPersonArrowDownToLine,
  

  faObjectIntersect,
  

  faChimney,
  

  faVialCircleCheck,
  

  faInfinity,
  

  faCassetteVhs,
  
  faVhs,
  

  faChartColumn,
  

  faHippo,
  

  faTransformerBolt,
  

  faT,
  

  faOilCan,
  

  faUpRightAndDownLeftFromCenter,
  
  faExpandAlt,
  

  faHashtag,
  

  faFaceExplode,
  
  faExplodingHead,
  

  faSquareXmark,
  
  faTimesSquare,
  
  faXmarkSquare,
  

  faFacePouting,
  

  faContainerStorage,
  

  faEarthOceania,
  
  faGlobeOceania,
  

  faGopuram,
  

  faMelon,
  

  faLightbulbCflOn,
  

  faCardHeart,
  

  faShieldHeart,
  

  faVacuum,
  

  faBroom,
  

  faCoinBlank,
  

  faCircleArrowUpLeft,
  

  faCircleG,
  

  faSkeleton,
  

  faDisplayChartUpCircleCurrency,
  

  faPersonBiking,
  
  faBiking,
  

  faTemperatureLow,
  

  faCodeCommit,
  

  faFileMusic,
  

  faClockOne,
  

  faCompassSlash,
  

  faMusic,
  

  faYinYang,
  

  faSendBackward,
  

  faCheese,
  

  faSquareStar,
  

  faWineGlassEmpty,
  
  faWineGlassAlt,
  

  faPenSlash,
  

  faMoon,
  

  faArrowUpFromLine,
  
  faArrowFromBottom,
  

  faCarrot,
  

  faAmpersand,
  

  faAtomSimple,
  
  faAtomAlt,
  

  faPenLine,
  

  faDog,
  

  faWandMagic,
  
  faMagic,
  

  faTents,
  

  faCricketBatBall,
  
  faCricket,
  

  faDiagramCells,
  

  faFaceDiagonalMouth,
  

  faTentArrowTurnLeft,
  

  faBanParking,
  
  faParkingCircleSlash,
  

  faPenNib,
  

  faScythe,
  

  faHouseChimneyWindow,
  

  faCircleChevronLeft,
  
  faChevronCircleLeft,
  

  faGolfBallTee,
  
  faGolfBall,
  

  faHouseMedical,
  

  faPersonSeat,
  

  faDitto,
  

  faPhonePlus,
  

  faGlassesRound,
  
  faGlassesAlt,
  

  faBinary,
  

  faAvocado,
  

  faGunSlash,
  

  faArrowsRepeat1,
  
  faRepeat1Alt,
  

  faArrowUpShortWide,
  
  faSortAmountUpAlt,
  

  faShield,
  
  faShieldBlank,
  

  faFileExport,
  
  faArrowRightFromFile,
  

  faPhoneMissed,
  

  faFireSmoke,
  

  faFaceGrinBeamSweat,
  
  faGrinBeamSweat,
  

  faTrumpet,
  

  faClockRotateLeft,
  
  faHistory,
  

  faNestingDolls,
  

  faMagnifyingGlassMusic,
  

  faChairOffice,
  

  faFishCooked,
  

  faPenPaintbrush,
  
  faPencilPaintbrush,
  

  faBrowser,
  

  faFireplace,
  

  faDiceD10,
  

  faQrcode,
  

  faSubtitlesSlash,
  

  faAlbumCircleUser,
  

  faPancakes,
  

  faCamcorder,
  
  faVideoHandheld,
  

  faAnglesLeft,
  
  faAngleDoubleLeft,
  

  faBuilding,
  

  faTicketSimple,
  
  faTicketAlt,
  

  faAward,
  

  faUserGroupSimple,
  

  faConveyorBeltEmpty,
  

  faFlagPennant,
  
  faPennant,
  

  faPersonFallingBurst,
  

  faArrowRightToLine,
  
  faArrowToRight,
  

  faAnt,
  

  faLineColumns,
  

  faCardSpade,
  

  faSpade,
  

  faArrowTurnDown,
  
  faLevelDown,
  

  faBorderRight,
  

  faKnifeKitchen,
  

  faUpFromBracket,
  

  faMercury,
  

  faTransgender,
  
  faTransgenderAlt,
  

  faSimCard,
  

  faDiceFour,
  

  faMandolin,
  

  faMeter,
  

  faFaceGrinHearts,
  
  faGrinHearts,
  

  faSplotch,
  

  faSquareN,
  

  faArrowUpRightDots,
  

  faSquareFragile,
  
  faBoxFragile,
  
  faSquareWineGlassCrack,
  

  faLockKeyholeOpen,
  
  faLockOpenAlt,
  

  faConveyorBeltArm,
  

  faWarehouse,
  

  faSunBright,
  
  faSunAlt,
  

  faGears,
  
  faCogs,
  

  faPartyHorn,
  

  faPeace,
  

  faRobot,
  

  faWhale,
  

  faArrowUpTriangleSquare,
  
  faSortShapesUp,
  

  faTowerControl,
  

  faSpinner,
  

  faCircleQuarters,
  

  faRotate,
  
  faSyncAlt,
  

  faCircleTrash,
  
  faTrashCircle,
  

  faHandPeace,
  

  faDial,
  
  faDialMedHigh,
  

  faAlt,
  

  faDiagramLeanCanvas,
  

  faMugTeaSaucer,
  

  faTtyAnswer,
  
  faTeletypeAnswer,
  

  faSpeakers,
  

  faFaceVomit,
  

  faHammer,
  

  faPersonPraying,
  
  faPray,
  

  faCloudsSun,
  

  faTrophy,
  

  faWheatSlash,
  

  faThumbtack,
  
  faThumbTack,
  

  faSignatureSlash,
  

  faPhoneHangup,
  

  faFaceSmile,
  
  faSmile,
  

  faPersonSign,
  

  faDisplay,
  

  faCoinVertical,
  

  faLocationCheck,
  
  faMapMarkerCheck,
  

  faConveyorBelt,
  

  faGlassWaterDroplet,
  

  faTruckMoving,
  

  faPercent,
  
  faPercentage,
  

  faHandMiddleFinger,
  

  faBrightnessLow,
  

  faGaugeCircleMinus,
  

  faCarTilt,
  

  faVrCardboard,
  

  faShieldMinus,
  

  faThermometer,
  

  faCloudMinus,
  

  faTrafficLight,
  

  faCloudMusic,
  

  faDownToDottedLine,
  

  faFaceExpressionless,
  

  faBabyCarriage,
  
  faCarriageBaby,
  

  faRadio,
  

  faEllipsisStroke,
  
  faEllipsisHAlt,
  

  faBatteryQuarter,
  
  faBattery2,
  

  faVideoSlash,
  

  faFrame,
  

  faComputerClassic,
  

  faPumpSoap,
  

  faCarRear,
  
  faCarAlt,
  

  faRetweet,
  

  faClockFive,
  

  faSignalWeak,
  
  faSignal1,
  

  faChevronRight,
  

  faGenderless,
  

  faBriefcaseMedical,
  

  faTurntable,
  

  faPersonToDoor,
  

  faDisease,
  

  faNotdef,
  

  faTrashCanUndo,
  
  faTrashCanArrowTurnLeft,
  
  faTrashUndoAlt,
  

  faFilterSlash,
  

  faTablePivot,
  

  faHandLizard,
  

  faMoneyBillSimple,
  

  faClouds,
  

  faBacteria,
  

  faChevronLeft,
  

  faArrowLeftToArc,
  

  faNose,
  

  faHollyBerry,
  

  faLinkHorizontalSlash,
  
  faChainHorizontalSlash,
  

  faDrumstickBite,
  

  faDinosaur,
  

  faAngleUp,
  

  faMessageMinus,
  
  faCommentAltMinus,
  

  faFill,
  

  faGlassHalf,
  
  faGlassHalfEmpty,
  
  faGlassHalfFull,
  

  faMessageCode,
  

  faSchoolFlag,
  

  faTablet,
  
  faTabletAndroid,
  

  faCommentQuote,
  

  faCameraSlash,
  

  faCloudBoltSun,
  
  faThunderstormSun,
  

  faBellSlash,
  

  faStoreLock,
  

  faEyeDropperHalf,
  

  faBezierCurve,
  

  faSignalStreamSlash,
  

  faFolderCheck,
  

  faSquareDivide,
  

  faSignHanging,
  
  faSign,
  

  faVacuumRobot,
  

  faAngle,
  

  faOliveBranch,
  

  faPlugCircleMinus,
  

  faArrowTrendUp,
  

  faStore,
  

  faDisplayArrowDown,
  

  faCircleGf,
  

  faChartScatter,
  

  faFaceEyesXmarks,
  

  faPlanetMoon,
  

  faFolderMinus,
  

  faFloppyDiskCircleArrowRight,
  
  faSaveCircleArrowRight,
  

  faPhotoFilm,
  
  faPhotoVideo,
  

  faVideoArrowDownLeft,
  

  faCandleHolder,
  

  faClockTen,
  

  faSirenOn,
  

  faRocket,
  

  faClockEleven,
  

  faLassoSparkles,
  

  faFaceDisappointed,
  

  faFileCircleInfo,
  

  faArrowLeftFromArc,
  

  faMap,
  

  faUserHairLong,
  

  faAxeBattle,
  

  faCars,
  

  faShekelSign,
  
  faIls,
  
  faShekel,
  
  faSheqel,
  
  faSheqelSign,
  

  faTally2,
  

  faTeeth,
  

  faBlender,
  

  faWrenchSimple,
  

  faPeanut,
  

  faBuildingMagnifyingGlass,
  

  faCakeSlice,
  
  faShortcake,
  

  faEquals,
  

  faH2,
  

  faArrowRightFromLine,
  
  faArrowFromLeft,
  

  faIslandTropical,
  
  faIslandTreePalm,
  

  faBracketSquare,
  
  faBracket,
  
  faBracketLeft,
  

  faHighlighterLine,
  

  faFlaskGear,
  

  faCopyright,
  

  faSymbols,
  
  faIconsAlt,
  

  faRulerCombined,
  

  faSquareQ,
  

  faLinesLeaning,
  

  faArrowDownToBracket,
  

  faArrowDownUpLock,
  

  faTrashArrowUp,
  
  faTrashRestore,
  

  faKeySkeleton,
  

  faDownFromBracket,
  

  faTractor,
  

  faQuoteLeft,
  
  faQuoteLeftAlt,
  

  faUsersLine,
  

  faBaby,
  

  faCirclePhoneFlip,
  
  faPhoneCircleAlt,
  

  faBuildingShield,
  

  faCartCircleXmark,
  

  faFaceSmileTongue,
  

  faPesoSign,
  

  faClawMarks,
  

  faRhombus,
  

  faChalkboardUser,
  
  faChalkboardTeacher,
  

  faArrowsUpDownLeftRight,
  
  faArrows,
  

  faFaceSmirking,
  

  faXmark,
  
  faClose,
  
  faMultiply,
  
  faRemove,
  
  faTimes,
  

  faCloudCheck,
  

  faFort,
  

  faComputer,
  

  faExpand,
  

  faPlus,
  
  faAdd,
  

  faHatBeach,
  

  faSquarePhone,
  
  faPhoneSquare,
  

  fa2,
  

  faGun,
  

  faChildCombatant,
  
  faChildRifle,
  

  faKeynote,
  

  faShareFromSquare,
  
  faShareSquare,
  

  faGrip,
  
  faGripHorizontal,
  

  faJackOLantern,
  

  faUserVneckHair,
  

  faPartyBell,
  

  faPaintbrushPencil,
  

  faBarsFilter,
  

  faHandSparkles,
  

  faVolumeXmark,
  
  faVolumeMute,
  
  faVolumeTimes,
  

  faBurgerGlass,
  

  faCopy,
  

  faSnowmanHead,
  
  faFrostyHead,
  

  faSidebar,
  

  faChartPyramid,
  

  faPedestal,
  

  faDiagramProject,
  
  faProjectDiagram,
  

  faJetFighterUp,
  

  faAwardSimple,
  

  faCircleP,
  

  faBaseball,
  
  faBaseballBall,
  

  faGlobeStand,
  

  faFaceTongueSweat,
  

  faCircleRadiation,
  
  faRadiationAlt,
  

  faMusicNoteSlash,
  
  faMusicAltSlash,
  

  faMango,
  

  faLinkHorizontal,
  
  faChainHorizontal,
  

  faPhoneIntercom,
  

  faSquareChevronLeft,
  
  faChevronSquareLeft,
  

  faClapperboard,
  

  faDiamondHalfStroke,
  

  faSquareArrowDown,
  
  faArrowSquareDown,
  

  faArrowRightLongToLine,
  

  faCircleHalfStroke,
  
  faAdjust,
  

  faStarfighter,
  

  faUserGraduate,
  

  faObjectUnion,
  

  faCartShoppingFast,
  

  faHexagonExclamation,
  

  faMusicNote,
  
  faMusicAlt,
  

  faWaffle,
  

  faCloudFog,
  
  faFog,
  

  faFish,
  

  faCircleStar,
  
  faStarCircle,
  

  faCircle1,
  

  faCommentHeart,
  

  faStarSharp,
  

  faUserMagnifyingGlass,
  

  faTruckFast,
  
  faShippingFast,
  

  faLacrosseStickBall,
  

  faSquareChevronRight,
  
  faChevronSquareRight,
  

  faPersonSnowboarding,
  
  faSnowboarding,
  

  faArrowsRetweet,
  
  faRetweetAlt,
  

  faUserHeadset,
  

  faY,
  

  faCarBurst,
  
  faCarCrash,
  

  faBoxDollar,
  
  faBoxUsd,
  

  faWind,
  

  faCircleExclamationCheck,
  

  faWreathLaurel,
  

  faMegaphone,
  

  faUserShield,
  

  faMushroom,
  

  faPlanetRinged,
  

  faUserDoctorHair,
  

  faSquareY,
  

  faCircleUser,
  
  faUserCircle,
  

  faJugDetergent,
  

  faDiagramSubtask,
  

  faListCheck,
  
  faTasks,
  

  faShrimp,
  

  faCircleDivide,
  

  faBorderLeft,
  

  faTv,
  
  faTelevision,
  
  faTvAlt,
  

  faDownFromDottedLine,
  

  faArrowUp,
  

  faBoneBreak,
  

  faLandmarkDome,
  
  faLandmarkAlt,
  

  faBrazilianRealSign,
  

  faHatWinter,
  

  faMagnifyingGlassPlay,
  

  faPersonHarassing,
  

  faNfcPen,
  

  faChessKing,
  

  faRankingStar,
  

  faPhoneOffice,
  

  faEnvelopes,
  

  faDownLong,
  
  faLongArrowAltDown,
  

  faJugBottle,
  

  faSdCards,
  

  faTowerCell,
  

  faSchoolLock,
  

  faCircleEllipsis,
  

  faWatermelonSlice,
  

  faHandHoldingMagic,
  

  faListUl,
  
  faListDots,
  

  faCodeCompare,
  

  faDropletDegree,
  
  faDewpoint,
  

  faSkullCrossbones,
  

  faClub,
  

  faHospitals,
  

  faBookArrowRight,
  

  faBellPlus,
  

  faBatteryFull,
  
  faBattery,
  
  faBattery5,
  

  faChevronDown,
  

  faMoneyBillSimpleWave,
  

  faHandsHoldingDiamond,
  
  faHandReceiving,
  

  faTransporter2,
  

  faPersonCircleExclamation,
  

  faSuitcaseRolling,
  

  faDisplaySlash,
  
  faDesktopSlash,
  

  faCircleMicrophoneLines,
  
  faMicrophoneCircleAlt,
  

  faSquarePen,
  
  faPenSquare,
  
  faPencilSquare,
  

  faTablePicnic,
  

  faReceipt,
  

  faFilePen,
  
  faFileEdit,
  

  faWalkieTalkie,
  

  faWand,
  

  faCartArrowDown,
  

  faColon,
  

  faCartFlatbedEmpty,
  
  faDollyFlatbedEmpty,
  

  faLobster,
  

  faBracketCurly,
  
  faBracketCurlyLeft,
  

  faTaxiBus,
  

  faPeach,
  

  faNairaSign,
  

  faFloppyDiskCircleXmark,
  
  faFloppyDiskTimes,
  
  faSaveCircleXmark,
  
  faSaveTimes,
  

  faLocationQuestion,
  
  faMapMarkerQuestion,
  

  faSignalGood,
  
  faSignal3,
  

  faTrashCanArrowUp,
  
  faTrashRestoreAlt,
  

  faChevronsDown,
  
  faChevronDoubleDown,
  

  faPersonDotsFromLine,
  
  faDiagnoses,
  

  faTableTennisPaddleBall,
  
  faPingPongPaddleBall,
  
  faTableTennis,
  

  faMagnifyingGlass,
  
  faSearch,
  

  faRupiahSign,
  

  faTableCellsRowLock,
  

  faBurgerLettuce,
  

  faSquareDownLeft,
  

  faCupTogo,
  
  faCoffeeTogo,
  

  faFont,
  

  faPlay,
  

  faTreeCity,
  

  faFileMinus,
  

  faEarListen,
  
  faAssistiveListeningSystems,
  

  faLink,
  
  faChain,
  

  faBallotCheck,
  

  faGrillHot,
  

  faLandmarkMagnifyingGlass,
  

  faBoxesStacked,
  
  faBoxes,
  
  faBoxesAlt,
  

  faTimer,
  

  faSpeaker,
  

  faCarBus,
  

  faStarHalf,
  

  faMoneyFromBracket,
  

  faCheckToSlot,
  
  faVoteYea,
  

  faCloudHail,
  

  faMeterFire,
  

  faSquareE,
  

  faHeadSideHeart,
  

  faParagraph,
  

  faFax,
  

  faDeerRudolph,
  

  faFishBones,
  

  faHeartCircleBolt,
  

  faIceCream,
  

  faScrubber,
  

  faDrum,
  

  faKite,
  

  faRectangleTerminal,
  

  faAngle90,
  

  faPersonWalkingWithCane,
  
  faBlind,
  

  faTransporterEmpty,
  

  faHotdog,
  

  faEarMuffs,
  

  faRouteInterstate,
  

  faBroccoli,
  

  faFaceSmilingHands,
  

  faOilCanDrip,
  

  faObjectsAlignLeft,
  

  faDharmachakra,
  

  faCircleUpLeft,
  

  faCloudHailMixed,
  

  faDiagramSankey,
  

  faBarsStaggered,
  
  faReorder,
  
  faStream,
  

  faUserBountyHunter,
  

  faChessRook,
  

  faWineBottle,
  

  faWhiskeyGlassIce,
  
  faGlassWhiskeyRocks,
  

  faPollPeople,
  

  faHospital,
  
  faHospitalAlt,
  
  faHospitalWide,
  

  faLampDesk,
  

  faEnvelopeOpenText,
  

  faSquareAmpersand,
  

  faGaugeHigh,
  
  faTachometerAlt,
  
  faTachometerAltFast,
  

  faSquareThisWayUp,
  
  faBoxUp,
  

  faSection,
  

  faSquare0,
  

  faInbox,
  

  faFaceSunglasses,
  

  faSocks,
  

  faGrid4,
  

  faBatteryEmpty,
  
  faBattery0,
  

  faSnowflakeDroplets,
  

  faDove,
  

  faHandBackPointRight,
  

  faHatChef,
  

  faGameBoard,
  

  faPersonBurst,
  

  faCrateApple,
  
  faAppleCrate,
  

  faFileSvg,
  

  faEarthAmericas,
  
  faEarth,
  
  faEarthAmerica,
  
  faGlobeAmericas,
  

  faHexagonImage,
  

  faEraser,
  

  faBullseyePointer,
  

  faDroplet,
  
  faTint,
  

  faCircleWifi,
  

  faNotebook,
  

  faFolderMagnifyingGlass,
  
  faFolderSearch,
  

  faCandyCorn,
  

  faMessageQuote,
  
  faCommentAltQuote,
  

  faUserRobotXmarks,
  

  faArrowDown,
  

  faPersonSwimming,
  
  faSwimmer,
  

  faTRex,
  

  faPretzel,
  

  faQuotes,
  

  faGreaterThan,
  

  faFile,
  

  faBoxOpenFull,
  
  faBoxFull,
  

  faCrab,
  

  faLocationDot,
  
  faMapMarkerAlt,
  

  faDialMedLow,
  

  faCircle0,
  

  faHandshakeAngle,
  
  faHandsHelping,
  

  faAccentGrave,
  

  faPaintRoller,
  

  faTrafficLightStop,
  

  faPhoneSlash,
  

  faStarOfLife,
  

  faPlugCircleXmark,
  

  faHexagonCheck,
  

  faBowlSpoon,
  

  faSuperscript,
  

  faArrowsFromLine,
  

  faFilePpt,
  

  faPinata,
  

  faXmarkLarge,
  

  faCandyBar,
  
  faChocolateBar,
  

  faBell,
  

  faTemperatureFull,
  
  faTemperature4,
  
  faThermometer4,
  
  faThermometerFull,
  

  faBee,
  

  faPodcast,
  

  faCalendarUsers,
  

  faSquareEllipsisVertical,
  

  faClockTwo,
  

  faSquareC,
  

  faSquareH,
  
  faHSquare,
  

  faBookCopy,
  

  faBed,
  

  faPersonFairy,
  

  faMedal,
  

  faTemperatureArrowUp,
  
  faTemperatureUp,
  

  faFileCircleXmark,
  

  faTruckDroplet,
  

  faDrone,
  

  faDiceD20,
  

  faBeerMug,
  
  faBeerFoam,
  

  faFileHeart,
  

  faMessageDots,
  
  faCommentAltDots,
  
  faMessaging,
  

  faHandBackPointLeft,
  

  faArrowsLeftRightToLine,
  

  faBluetooth,
  

  faChartSimpleHorizontal,
  

  faMountainSun,
  

  faCabin,
  

  faCircleX,
  

  faFamilyDress,
  

  faBookOpenReader,
  
  faBookReader,
  

  faMicrophoneStand,
  

  faUserHairMullet,
  
  faBusinessFront,
  
  faPartyBack,
  
  faTrianBalbot,
  

  faPodiumStar,
  

  faUserTieHair,
  

  faHandHoldingHand,
  

  faCar,
  
  faAutomobile,
  

  faBoxBallot,
  

  faCircleS,
  

  faCreditCard,
  
  faCreditCardAlt,
  

  faBowlChopsticks,
  

  faBug,
  

  faHandsHoldingCircle,
  

  faMagnifyingGlassWaveform,
  

  faEnvelopeDot,
  
  faEnvelopeBadge,
  

  faToolbox,
  

  faPersonThroughWindow,
  

  faBells,
  

  faGrid2Plus,
  

  faKitMedical,
  
  faFirstAid,
  

  faChessPawn,
  

  faNfcSlash,
  

  faEllipsis,
  
  faEllipsisH,
  

  faAnchorCircleXmark,
  

  faTentDoublePeak,
  

  faTicketsAirline,
  
  faTicketsPerforatedPlane,
  
  faTicketsPlane,
  

  faArrowRightLong,
  
  faLongArrowRight,
  

  faUserLock,
  

  faThumbsDown,
  

  faGripLines,
  

  faHeadSideCough,
  

  faPanFood,
  

  faPersonDollyEmpty,
  

  faCarTunnel,
  

  faOmega,
  

  faMountains,
  

  faAngleDown,
  

  faAirConditioner,
  

  faSquareQuestion,
  
  faQuestionSquare,
  

  faOilTemperature,
  
  faOilTemp,
  

  faFaceDrooling,
  

  faDisplayCode,
  
  faDesktopCode,
  

  faLessThan,
  

  faArrowDownShortWide,
  
  faSortAmountDesc,
  
  faSortAmountDownAlt,
  

  faFlorinSign,
  

  faChartMixed,
  
  faAnalytics,
  

  faArrowsTurnToDots,
  

  faGrill,
  

  faCircleDown,
  
  faArrowAltCircleDown,
  

  faPersonRunningFast,
  

  faTurnLeftDown,
  

  faWaveTriangle,
  

  faImagePolaroid,
  

  faIndustry,
  

  faBoreHole,
  

  faArrowsRepeat,
  
  faRepeatAlt,
  

  faHorseHead,
  

  faCircleDollar,
  
  faDollarCircle,
  
  faUsdCircle,
  

  faFaceLaughWink,
  
  faLaughWink,
  

  faSignalFair,
  
  faSignal2,
  

  faHouseTree,
  

  faHockeyStickPuck,
  

  faLaptopArrowDown,
  

  faBracketsSquare,
  
  faBrackets,
  

  faFaceSmileHearts,
  

  faSquare8,
  

  faSquareArrowLeft,
  
  faArrowSquareLeft,
  

  faGuitar,
  

  faScreenUsers,
  
  faUsersClass,
  

  faTrashCanSlash,
  
  faTrashAltSlash,
  

  faSun,
  

  faObjectsAlignCenterHorizontal,
  

  faChampagneGlass,
  
  faGlassChampagne,
  

  faTrashUndo,
  
  faTrashArrowTurnLeft,
  

  faRubleSign,
  
  faRouble,
  
  faRub,
  
  faRuble,
  

  faNotes,
  

  faGearCode,
  

  faYenSign,
  
  faCny,
  
  faJpy,
  
  faRmb,
  
  faYen,
  

  faPlaneCircleXmark,
  

  faToilet,
  

  faMars,
  

  faVault,
  

  faArrowTurnLeftUp,
  

  faPersonSimple,
  

  faOilWell,
  

  faGlassWater,
  

  faTrashCanCheck,
  

  faBolt,
  
  faZap,
  

  faMessageSlash,
  
  faCommentAltSlash,
  

  faShieldCat,
  

  faCaravan,
  

  faArrowUpArrowDown,
  
  faSortUpDown,
  

  faHandWave,
  

  faFolderGear,
  
  faFolderCog,
  

  faFolderMedical,
  

  faCameraWebSlash,
  
  faWebcamSlash,
  

  faSaxophoneFire,
  
  faSaxHot,
  

  faFileArrowDown,
  
  faFileDownload,
  

  faCompactDisc,
  

  faToiletPortable,
  

  faBrakeWarning,
  

  faCircleHalf,
  

  faWindsock,
  

  faMound,
  

  faPeoplePants,
  

  faGridRound2Plus,
  

  faHurricane,
  

  faUpload,
  

  faUpFromLine,
  
  faArrowAltFromBottom,
  

  faMoneyCheckDollarPen,
  
  faMoneyCheckEditAlt,
  

  faCodeMerge,
  

  faStop,
  

  faUpLong,
  
  faLongArrowAltUp,
  

  faBlockQuote,
  

  faTruckPickup,
  

  faTowerBroadcast,
  
  faBroadcastTower,
  

  faLoveseat,
  
  faCouchSmall,
  

  faPeopleDress,
  

  faHandHoldingSkull,
  

  faBanana,
  

  faHouseTurret,
  

  faChartScatterBubble,
  

  faCircleVideo,
  
  faVideoCircle,
  

  faGameBoardSimple,
  
  faGameBoardAlt,
  

  faSkull,
  

  faTimelineArrow,
  

  faBowlRice,
  

  faMillSign,
  

  faBalloons,
  

  faChartPieSimpleCircleDollar,
  

  faArrowUpWideShort,
  
  faSortAmountUp,
  

  faUtensils,
  
  faCutlery,
  

  faRotateRight,
  
  faRedoAlt,
  
  faRotateForward,
  

  faArrowRightArrowLeft,
  
  faExchange,
  

  faGolfClub,
  

  faCastle,
  

  faKiwiBird,
  

  faBlanketFire,
  

  faButter,
  

  faHelmetBattle,
  

  faCircleA,
  

  faDiceOne,
  

  faPotato,
  

  faFileMedical,
  

  faPipe,
  

  faMoonOverSun,
  
  faEclipseAlt,
  

  faSeatAirline,
  

  faB,
  

  faSquareDownRight,
  

  faLaptopMedical,
  

  faFlyingDisc,
  

  faCalendarWeek,
  

  faCarCircleBolt,
  

  faVectorCircle,
  

  faHouse,
  
  faHome,
  
  faHomeAlt,
  
  faHomeLgAlt,
  

  faHeartCircleExclamation,
  

  faCourtSport,
  

  faOutdent,
  
  faDedent,
  

  faFaceWorried,
  

  faFaceDotted,
  

  faIdCard,
  
  faDriversLicense,
  

  faBookSkull,
  
  faBookDead,
  

  faAlignCenter,
  

  faFaceMeh,
  
  faMeh,
  

  faCodePullRequestClosed,
  

  faMobile,
  
  faMobileAndroid,
  
  faMobilePhone,
  

  faUserPilot,
  

  faForward,
  

  faLoader,
  

  faGlass,
  

  faFileCircleCheck,
  

  faRotateExclamation,
  

  faScribble,
  

  faCommentsQuestion,
  

  faCommentCaptions,
  

  faEyeDropper,
  
  faEyeDropperEmpty,
  
  faEyedropper,
  

  faCloudBinary,
  

  faOven,
  

  faDeleteLeft,
  
  faBackspace,
  

  faFaceGrin,
  
  faGrin,
  

  faCloudSnow,
  

  faShelves,
  
  faInventory,
  

  faAnglesUpDown,
  

  faDownload,
  

  faArrowsDownToLine,
  

  faTugrikSign,
  

  faBatterySlash,
  

  faClockSixThirty,
  

  faShip,
  

  faGameConsoleHandheld,
  

  faPersonSledding,
  
  faSledding,
  

  faBuildingCircleXmark,
  

  faSprinkler,
  

  faFaceLying,
  

  faCloudRain,
  

  faShovelSnow,
  

  faCableCar,
  
  faTram,
  

  faGarage,
  

  faSwap,
  

  faN,
  

  faPeoplePulling,
  

  faEyeEvil,
  

  faUserHair,
  

  faShuttlecock,
  

  faCalculator,
  

  faImages,
  

  faVenusDouble,
  

  faRightFromLine,
  
  faArrowAltFromLeft,
  

  faPersonHiking,
  
  faHiking,
  

  faClosedCaptioning,
  

  faBadminton,
  

  faHouseMedicalCircleExclamation,
  

  faGearComplexCode,
  

  faCirclePhoneHangup,
  
  faPhoneCircleDown,
  

  faCompressWide,
  

  faFaceSpiralEyes,
  

  faArrowUpFromArc,
  

  faPipeValve,
  

  faClockFiveThirty,
  

  faPersonRifle,
  

  faDiagramNext,
  

  faChartTreeMap,
  

  faTty,
  
  faTeletype,
  

  faLaptopFile,
  

  faFlagUsa,
  

  faCitrus,
  

  faLightsHoliday,
  

  faPipeCollar,
  

  faPersonDressSimple,
  

  faCircleB,
  

  faRightLong,
  
  faLongArrowAltRight,
  

  faLaptopSlash,
  

  faCoin,
  

  faPowerOff,
  

  faTicket,
  

  faSwordLaserAlt,
  

  faEllipsisVertical,
  
  faEllipsisV,
  

  faRouter,
  

  faWandSparkles,
  

  faSquareU,
  

  faPersonPregnant,
  

  faFlask,
  

  faSwordsLaser,
  

  faCentSign,
  

  faHamsa,
  

  faMapPin,
  

  faCroissant,
  

  faNetworkWired,
  

  faFolderTree,
  

  faPeople,
  

  faCauldron,
  

  faSliders,
  
  faSlidersH,
  

  faOutlet,
  

  faFilterList,
  

  faKhanda,
  

  faOlive,
  

  faHoneyPot,
  

  faCoins,
  

  faMountainCity,
  

  faFluxCapacitor,
  

  faBatteryHalf,
  
  faBattery3,
  

  faBoltAuto,
  

  faIndustryWindows,
  
  faIndustryAlt,
  

  faCarMirrors,
  

  faRacquet,
  

  faPiggyBank,
  

  faCarBump,
  

  faSushiRoll,
  
  faMakiRoll,
  
  faMakizushi,
  

  faFaceHeadBandage,
  

  faCircleLocationArrow,
  
  faLocationCircle,
  

  faFolderHeart,
  

  faPlaneUp,
  

  faMobileScreen,
  
  faMobileAndroidAlt,
  

  faBellSchool,
  

  faTemperatureThreeQuarters,
  
  faTemperature3,
  
  faThermometer3,
  
  faThermometerThreeQuarters,
  

  faBoxingGlove,
  
  faGloveBoxing,
  

  faHouseChimneyMedical,
  
  faClinicMedical,
  

  faCards,
  

  faLocationDotSlash,
  
  faMapMarkerAltSlash,
  

  faCaretDown,
  

  faBallot,
  

  faUsbDrive,
  

  faArrowsFromDottedLine,
  

  faKeyboard,
  

  faTimeline,
  

  faS,
  

  faOverline,
  

  faSquareUpLeft,
  

  faBaseballBatBall,
  

  faPenNibSlash,
  

  faListRadio,
  

  faLampStreet,
  

  faCloudSleet,
  

  faFaucet,
  

  faArrowsMaximize,
  
  faExpandArrows,
  

  faCarBolt,
  

  faPallet,
  

  faBackwardStep,
  
  faStepBackward,
  

  faTruckTow,
  

  faInputNumeric,
  

  faClock,
  
  faClockFour,
  

  faDash,
  
  faMinusLarge,
  

  faRaindrops,
  

  faArrowDownArrowUp,
  
  faSortAlt,
  

  faLightSwitchOn,
  

  faSquareRootVariable,
  
  faSquareRootAlt,
  

  faArrowUpFromDottedLine,
  

  faU,
  

  faArrowTurnUp,
  
  faLevelUp,
  

  faMobileSignalOut,
  

  faGripVertical,
  

  faSquareD,
  

  faAxe,
  

  faChessClock,
  

  faPeapod,
  

  faShareAll,
  

  faDisplayMedical,
  
  faDesktopMedical,
  

  faFolderMusic,
  

  faHexagonVerticalNftSlanted,
  

  faTabletScreen,
  
  faTabletAndroidAlt,
  

  faToiletPaperBlank,
  
  faToiletPaperAlt,
  

  faFolderXmark,
  
  faFolderTimes,
  

  faFilmCanister,
  
  faFilmCannister,
  

  faSplit,
  

  faWaveformLines,
  
  faWaveformPath,
  

  faWaterArrowUp,
  
  faWaterRise,
  

  faPlaceOfWorship,
  

  faPersonSkiJumping,
  
  faSkiJump,
  

  faPlugCirclePlus,
  

  faCircle7,
  

  faScannerTouchscreen,
  

  faWaterArrowDown,
  
  faWaterLower,
  

  faFaceSwear,
  

  faRadioTuner,
  
  faRadioAlt,
  

  faFaceSmilePlus,
  
  faSmilePlus,
  

  faMoped,
  

  faTemperatureSnow,
  
  faTemperatureFrigid,
  

  faTabletRugged,
  

  faDistributeSpacingHorizontal,
  

  faEyeDropperFull,
  

  faVials,
  

  faShieldPlus,
  

  faBookFont,
  

  faCartShopping,
  
  faShoppingCart,
  

  faCarGarage,
  

  faPersonMilitaryRifle,
  

  faFlagSwallowtail,
  
  faFlagAlt,
  

  faStarOfDavid,
  

  faMosquito,
  

  faDuck,
  

  faMosque,
  

  faBookHeart,
  

  faDropletSlash,
  
  faTintSlash,
  

  faGear,
  
  faCog,
  

  faCameraSecurity,
  
  faCameraHome,
  

  faUserDoctorHairLong,
  

  faFileCertificate,
  
  faFileAward,
  

  faMessageXmark,
  
  faCommentAltTimes,
  
  faMessageTimes,
  

  faHousePersonReturn,
  
  faHousePersonArrive,
  
  faHouseReturn,
  

  faCartCircleArrowDown,
  

  faFaceSmileHalo,
  

  faCircleBolt,
  

  faPresentationScreen,
  
  faPresentation,
  

  faHandsAslInterpreting,
  
  faAmericanSignLanguageInterpreting,
  
  faAslInterpreting,
  
  faHandsAmericanSignLanguageInterpreting,
  

  faChartUser,
  
  faUserChart,
  

  faBookCircleArrowRight,
  

  faVolumeOff,
  

  faFlaskRoundPoison,
  
  faFlaskPoison,
  

  faFrancSign,
  

  faArrowDownLeft,
  

  faStreetView,
  

  faFontCase,
  

  faPlugCircleCheck,
  

  faArrowLeftLong,
  
  faLongArrowLeft,
  

  faTrashSlash,
  

  faChess,
  

  faGif,
  

  faRightToLine,
  
  faArrowAltToRight,
  

  faFireFlame,
  
  faFlame,
  

  faMinus,
  
  faSubtract,
  

  faCircle5,
  

  faCircleSterling,
  

  faBracketRoundRight,
  

  faVirusSlash,
  

  faDna,
  

  faTurnLeftUp,
  

  faCloudBoltMoon,
  
  faThunderstormMoon,
  

  faCircleUpRight,
  

  faKeyboardDown,
  

  faLeftLong,
  
  faLongArrowAltLeft,
  

  faMoneyBill1,
  
  faMoneyBillAlt,
  

  faCropSimple,
  
  faCropAlt,
  

  faIndianRupeeSign,
  
  faIndianRupee,
  
  faInr,
  

  faListTimeline,
  

  faMoneyBillsSimple,
  
  faMoneyBillsAlt,
  

  faBadgeDollar,
  

  faBallPile,
  

  faFaceSmileUpsideDown,
  

  faChartGantt,
  

  faTrainSubway,
  
  faSubway,
  

  faGameConsoleHandheldCrank,
  

  faSportsball,
  

  faSignalBarsFair,
  
  faSignalAlt2,
  

  faDistributeSpacingVertical,
  

  faCircleLeft,
  
  faArrowAltCircleLeft,
  

  faCowbellCirclePlus,
  
  faCowbellMore,
  

  faPlaneArrival,
  

  faPersonFromPortal,
  
  faPortalExit,
  

  faCalendarPlus,
  

  faPersonSkiingNordic,
  
  faSkiingNordic,
  

  faArrowDownRight,
  

  faGrate,
  

  faTrafficCone,
  

  faHouseMedicalCircleCheck,
  

  faAlarmExclamation,
  

  faTarpDroplet,
  

  faRectangleList,
  
  faListAlt,
  

  faDumbbell,
  

  faFaceGrinSquintTears,
  
  faGrinSquintTears,
  

  faReel,
  

  faHardDrive,
  
  faHdd,
  

  faTvMusic,
  

  faArrowRotateLeft,
  
  faArrowLeftRotate,
  
  faArrowRotateBack,
  
  faArrowRotateBackward,
  
  faUndo,
  

  faCookie,
  

  faOctagonDivide,
  

  faCommentArrowUpRight,
  

  faOctagon,
  

  faBorderBottomRight,
  
  faBorderStyleAlt,
  

  faCarBuilding,
  

  faMessageMusic,
  
  faCommentAltMusic,
  

  faCameraViewfinder,
  
  faScreenshot,
  

  faMoneyBillWheat,
  

  faPlusLarge,
  

  faBellSchoolSlash,
  

  faBowlingBallPin,
  

  faArrowDownAZ,
  
  faSortAlphaAsc,
  
  faSortAlphaDown,
  

  faCheckDouble,
  

  faPeopleDressSimple,
  

  faVestPatches,
  

  faLaptopBinary,
  

  faTent,
  

  faAlien,
  

  faPersonCane,
  

  faCloudRainbow,
  

  faCrosshairs,
  

  faMusicMagnifyingGlass,
  

  faTruck,
  

  faLandmark,
  

  faHouseWindow,
  

  faHoseReel,
  

  faFamilyPants,
  

  faPlateUtensils,
  

  faPrescriptionBottleMedical,
  
  faPrescriptionBottleAlt,
  

  faBraille,
  

  faCalendarClock,
  
  faCalendarTime,
  

  faClockDesk,
  

  faCalendarCheck,
  

  faPlaneProp,
  

  faNfcSignal,
  

  faStarSharpHalfStroke,
  
  faStarSharpHalfAlt,
  

  faWater,
  

  faWaveform,
  

  faTricycleAdult,
  

  faFileEps,
  

  faHandHoldingDroplet,
  
  faHandHoldingWater,
  

  faSquare4,
  

  faBuoyMooring,
  

  faArrowDown19,
  
  faSortNumericAsc,
  
  faSortNumericDown,
  

  faSleigh,
  

  faCarOn,
  

  faMeteor,
  

  faCartArrowUp,
  

  faSquareVirus,
  

  faCamera,
  
  faCameraAlt,
  

  faCameraPolaroid,
  

  faCloudMeatball,
  

  faMessageHeart,
  

  faHammerCrash,
  

  faFishingRod,
  

  faCircleInfo,
  
  faInfoCircle,
  

  faSlashBack,
  

  faUserDoctor,
  
  faUserMd,
  

  faMeterBolt,
  

  faHouseChimneyBlank,
  

  faHouseHeart,
  
  faHomeHeart,
  

  faFileXmark,
  
  faFileTimes,
  

  faMountain,
  

  faHourglass,
  
  faHourglassEmpty,
  

  faNfcTrash,
  

  faTruckFieldUn,
  

  faPuzzlePieceSimple,
  
  faPuzzlePieceAlt,
  

  faTreeDeciduous,
  
  faTreeAlt,
  

  faIndent,
  

  faCommentMusic,
  

  faRugbyBall,
  

  faMessageMedical,
  
  faCommentAltMedical,
  

  faReflectHorizontal,
  

  faParachuteBox,
  

  faCircleNodes,
  

  faCircleWifiCircleWifi,
  
  faCircleWifiGroup,
  

  faArrowTurnDownLeft,
  

  faBorderNone,
  

  faCircleSmall,
  

  faBottleBaby,
  

  faLitecoinSign,
  

  faH6,
  

  faCircleY,
  

  faAppleCore,
  

  faArrowUp91,
  
  faSortNumericUpAlt,
  

  faPersonPinball,
  

  faLungs,
  

  faRibbon,
  

  faLockA,
  

  faArrowRightToCity,
  

  faChartLineDown,
  

  faPaperclip,
  

  faBinRecycle,
  

  faAnglesUp,
  
  faAngleDoubleUp,
  

  faFaceTissue,
  

  faDollyEmpty,
  

  faEnvelope,
  

  faTruckLadder,
  

  faHeadSide,
  

  faCakeCandles,
  
  faBirthdayCake,
  
  faCake,
  

  faSquare1,
  

  faComment,
  

  faEllipsisStrokeVertical,
  
  faEllipsisVAlt,
  

  faBracketsCurly,
  

  faCircleYen,
  

  faCoffeeBean,
  

  faInboxes,
  

  faBookSection,
  
  faBookLaw,
  

  faStretcher,
  

  faTag,
  

  faSteeringWheel,
  

  faPlaneLock,
  

  faTruckFire,
  

  faSatellite,
  

  faChessClockFlip,
  
  faChessClockAlt,
  

  faFilePlusMinus,
  

  faUserVisor,
  

  faLiraSign,
  

  faChild,
  

  faWashingMachine,
  
  faWasher,
  

  faBookSparkles,
  
  faBookSpells,
  

  faSquareArrowDownRight,
  

  faFilmSlash,
  

  faBusSchool,
  

  faClipboardUser,
  

  faFaceFearful,
  

  faLocationExclamation,
  
  faMapMarkerExclamation,
  

  faTableRows,
  
  faRows,
  

  faHatCowboySide,
  

  faDiscDrive,
  

  faPhoneVolume,
  
  faVolumeControlPhone,
  

  faSealQuestion,
  

  faSolarSystem,
  

  faBookTanakh,
  
  faTanakh,
  

  faTableCellsLarge,
  
  faThLarge,
  

  faCloudDrizzle,
  

  faPeoplePantsSimple,
  

  faFlowerTulip,
  

  faBusinessTime,
  
  faBriefcaseClock,
  

  faCommentDollar,
  

  faPersonDress,
  
  faFemale,
  

  faDreidel,
  

  faOtter,
  

  faUserSecret,
  

  faRv,
  

  faClockElevenThirty,
  

  faExpandWide,
  

  faBriefcaseArrowRight,
  

  faSuitcaseMedical,
  
  faMedkit,
  

  faO,
  

  faBookBible,
  
  faBible,
  

  faMessagesQuestion,
  

  faGamepadModern,
  
  faGamepadAlt,
  

  faCurlingStone,
  
  faCurling,
  

  faTankWater,
  

  faImageLandscape,
  
  faLandscape,
  

  faArrowUpToDottedLine,
  

  faSiren,
  

  faFilePdf,
  

  faBagShoppingMinus,
  

  faTableCells,
  
  faTh,
  

  faCircleSort,
  
  faSortCircle,
  

  faUpRightFromSquare,
  
  faExternalLinkAlt,
  

  faCherries,
  

  faFileVideo,
  

  faUsersViewfinder,
  

  faGalaxy,
  

  faJ,
  

  faHighDefinition,
  
  faRectangleHd,
  

  faRestroom,
  

  faDiceD6,
  

  faAlignLeft,
  

  faTemperatureSun,
  
  faTemperatureHot,
  

  faCupStrawSwoosh,
  

  faArrowLeftFromBracket,
  

  faRuler,
  

  faPersonCircleXmark,
  

  faArrowLeft,
  

  faLeafMaple,
  

  faRepublican,
  

  faHandsClapping,
  

  faSnowflakes,
  

  faCircleAmpersand,
  

  faCampfire,
  

  faHandsHolding,
  

  faHeadphones,
  

  faTengeSign,
  
  faTenge,
  

  faSquare7,
  

  faLampFloor,
  

  faSunCloud,
  

  faDivide,
  

  faEnvelopeOpenDollar,
  

  faCubes,
  

  faSquareR,
  

  faBillboard,
  

  fa0,
  

  faShirt,
  
  faTShirt,
  
  faTshirt,
  

  faClockSix,
  

  faHose,
  

  faPhoneXmark,
  

  faGuitars,
  

  faScrollOld,
  

  faQuoteRight,
  
  faQuoteRightAlt,
  

  faPenClipSlash,
  
  faPenAltSlash,
  

  faPoo,
  

  faFaceMelting,
  

  faBookMedical,
  

  faArrowDownSmallBig,
  
  faSortSizeDownAlt,
  

  faGaugeSimple,
  
  faGaugeSimpleMed,
  
  faTachometerAverage,
  

  faTrash,
  

  faHandFingersCrossed,
  

  faCloudWord,
  

  faPhoneArrowDownLeft,
  
  faPhoneArrowDown,
  
  faPhoneIncoming,
  

  faOrnament,
  

  faFileXml,
  

  faCarSideBolt,
  

  faBrightness,
  

  faBoxCircleCheck,
  

  faShowerDown,
  
  faShowerAlt,
  

  faPersonDigging,
  
  faDigging,
  

  faMouseField,
  

  faCoffeePot,
  

  faPenFancy,
  

  faChartKanban,
  

  faHatWizard,
  

  faSquareKanban,
  

  faGarageCar,
  

  faTextWidth,
  

  faPersonBooth,
  

  faBanBug,
  
  faDebug,
  

  faBridgeWater,
  

  faVentDamper,
  

  faMosquitoNet,
  

  faRocketLaunch,
  

  faStarfighterTwinIonEngine,
  
  faStarfighterAlt,
  

  faDiceSix,
  

  faStarfighterTwinIonEngineAdvanced,
  
  faStarfighterAltAdvanced,
  

  faShieldVirus,
  

  faConveyorBeltBoxes,
  
  faConveyorBeltAlt,
  

  faLaptopMobile,
  
  faPhoneLaptop,
  

  faDoorClosed,
  

  faDialLow,
  

  faOctagonExclamation,
  

  faArrowUp19,
  
  faSortNumericUp,
  

  faPipeCircleCheck,
  

  faUserGear,
  
  faUserCog,
  

  faPuzzle,
  

  faSquareHeart,
  
  faHeartSquare,
  

  faSquare5,
  

  faHouseBlank,
  
  faHomeBlank,
  

  faLightbulbSlash,
  

  faBooksMedical,
  

  faKeyboardBrightness,
  

  faHeadSideVirus,
  

  faRectangleCode,
  

  faTrafficLightSlow,
  

  faKiwiFruit,
  

  faPawClaws,
  

  faBorderInner,
  

  faToothbrush,
  

  faCalendarCirclePlus,
  

  faRampLoading,
  

  faNarwhal,
  

  faTableLayout,
  

  faChildReaching,
  

  faCalendarXmark,
  
  faCalendarTimes,
  

  faComputerMouseScrollwheel,
  
  faMouseAlt,
  

  faPhone,
  

  faFaceGrinTears,
  
  faGrinTears,
  

  faSpinnerThird,
  

  faLungsVirus,
  

  faUsersBetweenLines,
  

  faChildDress,
  

  faCardClub,
  

  faRulerTriangle,
  

  faHousePersonLeave,
  
  faHouseLeave,
  
  faHousePersonDepart,
  

  faLeftFromBracket,
  

  faMarsDouble,
  

  faLocationCrosshairs,
  
  faLocation,
  

  faChessQueenPiece,
  
  faChessQueenAlt,
  

  faBiohazard,
  

  faWebAwesome,
  

  faBalloon,
  

  faSensorOn,
  

  faMessagesDollar,
  
  faCommentsAltDollar,
  

  faArrowRotateRight,
  
  faArrowRightRotate,
  
  faArrowRotateForward,
  
  faRedo,
  

  faUserMusic,
  

  faFacePensive,
  

  faHandsPraying,
  
  faPrayingHands,
  

  faHandScissors,
  

  faDrumSteelpan,
  

  faHandPointer,
  

  faBacterium,
  

  faGridDividers,
  

  faHandHoldingDollar,
  
  faHandHoldingUsd,
  

  faCircleEllipsisVertical,
  

  faFaceGrinSquint,
  
  faGrinSquint,
  

  faSquareLeft,
  
  faArrowAltSquareLeft,
  

  faDiamond,
  

  faUserNurseHairLong,
  

  faAlbumCirclePlus,
  

  faScarf,
  

  faPlantWilt,
  

  faCommentDots,
  
  faCommenting,
  

  faCalendarArrowUp,
  
  faCalendarUpload,
  

  faSortUp,
  
  faSortAsc,
  

  faSquareL,
  

  faTennisBall,
  

  faFaceTongueMoney,
  

  faUserPoliceTie,
  

  faFileUser,
  

  faScaleUnbalanced,
  
  faBalanceScaleLeft,
  

  faFaceKissClosedEyes,
  

  faVihara,
  

  faFloppyDisk,
  
  faSave,
  

  faShop,
  
  faStoreAlt,
  

  faPrescription,
  

  faWalker,
  

  faScreencast,
  

  faDiploma,
  
  faScrollRibbon,
  

  faShirtTankTop,
  

  faChessBishopPiece,
  
  faChessBishopAlt,
  

  faFaceFrown,
  
  faFrown,
  

  faDryer,
  

  faWindowMaximize,
  

  faHouseChimney,
  
  faHomeLg,
  

  faArrowUpLeftFromCircle,
  

  faHeartCircleXmark,
  

  faBus,
  

  faPump,
  

  faSignal,
  
  faSignal5,
  
  faSignalPerfect,
  

  faFileCode,
  

  faToiletPaperBlankUnder,
  
  faToiletPaperReverseAlt,
  

  faFloppyDisks,
  

  faTowerObservation,
  

  faPen,
  

  faUserSlash,
  

  faManhole,
  

  faHexagon,
  

  faFileShield,
  

  faPersonMilitaryToPerson,
  

  faAudioDescription,
  

  faArrowsMinimize,
  
  faCompressArrows,
  

  faBootHeeled,
  

  faTicketAirline,
  
  faTicketPerforatedPlane,
  
  faTicketPlane,
  

  faHeat,
  

  faFaceSadCry,
  
  faSadCry,
  

  faEye,
  

  faBusSimple,
  
  faBusAlt,
  

  faChestnut,
  

  faTape,
  

  faBasketShopping,
  
  faShoppingBasket,
  

  faHouseMedicalFlag,
  

  faMobileButton,
  

  faTerminal,
  

  faCircleSortUp,
  
  faSortCircleUp,
  

  faBanSmoking,
  
  faSmokingBan,
  

  faCartFlatbed,
  
  faDollyFlatbed,
  

  faCircleR,
  

  faArrowUpRight,
  

  faDolphin,
  

  faArrowsToLine,
  

  faFaucetDrip,
  

  faBarsProgress,
  
  faTasksAlt,
  

  faNfcSymbol,
  

  faSquareChevronUp,
  
  faChevronSquareUp,
  

  faHouseSignal,
  

  faFaceRaisedEyebrow,
  

  faFaceZipper,
  

  faCardDiamond,
  

  faSquareParking,
  
  faParking,
  

  faUserRobot,
  

  faFaceMehBlank,
  
  faMehBlank,
  

  faForwardFast,
  
  faFastForward,
  

  faWineGlass,
  

  faTags,
  

  faArrowTurnRight,
  

  faHeadSideMedical,
  

  faFileCircleMinus,
  

  faUserTieHairLong,
  

  faTeethOpen,
  

  faCommentMedical,
  

  faPanorama,
  

  faClipboardQuestion,
  

  faCartCircleCheck,
  

  faRoute,
  

  faTruckField,
  

  faBasketShoppingPlus,
  

  faUserCrown,
  

  faFaceClouds,
  

  faAnchorCircleExclamation,
  

  faFiles,
  

  faCircleCaretLeft,
  
  faCaretCircleLeft,
  

  faTrashXmark,
  

  faCat,
  

  faTruckFront,
  

  faSquareQuarters,
  

  faFileDoc,
  

  faArrowDownFromDottedLine,
  

  faPhoneFlip,
  
  faPhoneAlt,
  

  faBridge,
  

  faHatCowboy,
  

  faWarehouseFull,
  
  faWarehouseAlt,
  

  faCodeBranch,
  

  faObjectSubtract,
  

  faHouseWater,
  
  faHouseFlood,
  

  faPopcorn,
  

  faFaceHandOverMouth,
  

  faCircleK,
  

  faArrowRightFromArc,
  

  faTypewriter,
  

  faCanFood,
  

  faBorderCenterH,
  

  faBookBookmark,
  

  faHandshakeSlash,
  

  faPlaneDeparture,
  

  faBuoy,
  

  faImageUser,
  

  faTicketsPerforated,
  

  faCircleQuestion,
  
  faQuestionCircle,
  

  faFileImage,
  

  faRupeeSign,
  
  faRupee,
  

  faDiagramNested,
  

  faVectorPolygon,
  

  faBugs,
  

  faWrench,
  

  faArrowTurnLeft,
  

  faTransporter6,
  

  faUtilityPole,
  

  faBurger,
  
  faHamburger,
  

  faStaff,
  

  faChartRadar,
  

  faLockHashtag,
  

  faTurnDownLeft,
  

  faFileAudio,
  

  faPool8Ball,
  

  faTruckClock,
  
  faShippingTimed,
  

  faCartCirclePlus,
  

  faClipboardCheck,
  

  faFlatbreadStuffed,
  

  faOctagonCheck,
  

  faWallet,
  

  faUsersRays,
  

  faVolumeHigh,
  
  faVolumeUp,
  

  faCloudSlash,
  

  faInboxOut,
  
  faInboxArrowUp,
  

  faClockOneThirty,
  

  faMobileScreenButton,
  
  faMobileAlt,
  

  faSlider,
  

  faCircleUp,
  
  faArrowAltCircleUp,
  

  faBadgeCheck,
  

  faSatelliteDish,
  

  faForkKnife,
  
  faUtensilsAlt,
  

  faBasketball,
  
  faBasketballBall,
  

  faTrademark,
  

  faCircleDashed,
  

  faPlaneSlash,
  

  faInterrobang,
  

  faUserAstronaut,
  

  faRecycle,
  

  faBackwardFast,
  
  faFastBackward,
  

  faSword,
  

  faCartCircleExclamation,
  

  faLeftToBracket,
  

  faCircle,
  

  faSquarePollHorizontal,
  
  faPollH,
  

  faHouseFloodWaterCircleArrowRight,
  

  faMoneyBillTrendUp,
  

  faMoneyBillTransfer,
  

  faElevator,
  

  faTally3,
  

  faHouseChimneyHeart,
  

  faTableTree,
  

  faLockOpen,
  

  faSolarPanel,
  

  faShieldDog,
  

  faShutters,
  

  faBitcoinSign,
  

  faArrowDownTriangleSquare,
  
  faSortShapesDown,
  

  faCube,
  

  faHandsHoldingDollar,
  
  faHandsUsd,
  

  faToiletPaperXmark,
  

  faWifiSlash,
  

  faSquareInfo,
  
  faInfoSquare,
  

  faTemperatureQuarter,
  
  faTemperature1,
  
  faThermometer1,
  
  faThermometerQuarter,
  

  faR,
  

  faLockKeyhole,
  
  faLockAlt,
  

  faDiamondHalf,
  

  faKitchenSet,
  

  faAppleWhole,
  
  faAppleAlt,
  

  faCircleEuro,
  

  faToiletPaperSlash,
  

  faRabbit,
  

  faValueAbsolute,
  

  faAngel,
  

  faFolders,
  

  faGaugeCirclePlus,
  

  faCirclePause,
  
  faPauseCircle,
  

  faBottleWater,
  

  faFaceSurprise,
  
  faSurprise,
  

  faArrowRightToArc,
  

  faUserShakespeare,
  

  faMartiniGlassCitrus,
  
  faCocktail,
  

  faBracketsRound,
  
  faParentheses,
  

  faArrowLeftLongToLine,
  

  faPawSimple,
  
  faPawAlt,
  

  faHouseCrack,
  

  faLeftToLine,
  
  faArrowAltToLeft,
  

  faHexagonMinus,
  
  faMinusHexagon,
  

  faDumpsterFire,
  

  faCircleArrowDownLeft,
  

  faHouseUser,
  
  faHomeUser,
  

  faMarsAndVenus,
  

  faFileChartPie,
  

  faHeart,
  

  faFaceNauseated,
  

  faBookCircleArrowUp,
  

  faShirtRunning,
  

  faSignPostsWrench,
  

  faGridRound4,
  

  faFaceThermometer,
  

  faPlugCircleBolt,
  

  faTrophyStar,
  
  faTrophyAlt,
  

  faCircleThreeQuarters,
  

  faArrowsToEye,
  

  faScrewdriverWrench,
  
  faTools,
  

  faHandHorns,
  

  faFaceSleepy,
  

  faTarp,
  

  faHammerBrush,
  

  faClockNine,
  

  faHandsHoldingHeart,
  
  faHandsHeart,
  

  faBasketShoppingSimple,
  
  faShoppingBasketAlt,
  

  faH,
  

  faLeftFromLine,
  
  faArrowAltFromRight,
  

  faCupStraw,
  

  faMessageSmile,
  
  faCommentAltSmile,
  

  faSpaceStationMoon,
  

  faMelonSlice,
  

  faPersonCircleQuestion,
  

  faCashRegister,
  

  faOctagonPlus,
  
  faPlusOctagon,
  

  faSignsPost,
  
  faMapSigns,
  

  faArrowRight,
  

  faSignatureLock,
  

  faTickets,
  

  faMaskVentilator,
  

  faSendBack,
  

  faCalendarArrowDown,
  
  faCalendarDownload,
  

  faChartLine,
  
  faLineChart,
  

  faFrenchFries,
  

  faObjectGroup,
  

  faRingsWedding,
  

  faBreadLoaf,
  

  faFaceRollingEyes,
  
  faMehRollingEyes,
  

  faHexagonVerticalNft,
  

  faUserCowboy,
  

  faSeal,
  

  faPlaneCircleCheck,
  

  faCircleRight,
  
  faArrowAltCircleRight,
  

  faEject,
  

  faStarship,
  

  faSimCards,
  

  faCommentCode,
  

  faHelmetSafety,
  
  faHardHat,
  
  faHatHard,
  

  faToiletPaper,
  

  faKaaba,
  

  faSquareList,
  

  faLocationPin,
  
  faMapMarker,
  

  faTelescope,
  

  faObjectExclude,
  

  faPoop,
  

  faHandPointRibbon,
  

  faAlien8bit,
  
  faAlienMonster,
  

  faCircleArrowDownRight,
  

  faFaceDisguise,
  

  faObjectUngroup,
  

  faFaceGrinBeam,
  
  faGrinBeam,
  

  faBuildingFlag,
  

  faCircleQ,
  

  faFishFins,
  

  faFileContract,
  

  faFileExcel,
  

  faFileXls,
  

  faSackXmark,
  

  faClockEight,
  

  faBoltLightning,
  

  faChartPie,
  
  faPieChart,
  

  faPersonCirclePlus,
  

  faTaxi,
  
  faCab,
  

  faRoad,
  

  faBedBunk,
  

  faLeaf,
  

  faF,
  

  faCloudPlus,
  

  faAustralSign,
  

  faChessKnightPiece,
  
  faChessKnightAlt,
  

  faPie,
  

  faSquareEllipsis,
  

  faVirusCovid,
  

  faImagePolaroidUser,
  

  faWonSign,
  
  faKrw,
  
  faWon,
  

  faImagesUser,
  

  faCubesStacked,
  

  faArrowUpRightFromSquare,
  
  faExternalLink,
  

  faMagnifyingGlassChart,
  

  faMobileNotch,
  
  faMobileIphone,
  

  faClothesHanger,
  

  faBuildingCircleExclamation,
  

  faMoonStars,
  

  faWhiskeyGlass,
  
  faGlassWhiskey,
  

  faCode,
  

  faFileExclamation,
  

  faStarHalfStroke,
  
  faStarHalfAlt,
  

  faMoneyCheck,
  

  faPuzzlePiece,
  

  faTrainTrack,
  

  faArrowUpSmallBig,
  
  faSortSizeUpAlt,
  

  faHandHoldingHeart,
  

  faHouseChimneyUser,
  

  faDryerHeat,
  
  faDryerAlt,
  

  faUpDownLeftRight,
  
  faArrowsAlt,
  

  faToggleLargeOn,
  

  faFileSignature,
  

  faQuestion,
  

  faUserNurseHair,
  

  faClipboardPrescription,
  

  faCirclePhone,
  
  faPhoneCircle,
  

  faSquareG,
  

  faFilter,
  

  faDownToLine,
  
  faArrowAltToBottom,
  

  faRouteHighway,
  

  faMemoCircleCheck,
  

  faPodium,
  

  faDagger,
  

  faFaceKissWinkHeart,
  
  faKissWinkHeart,
  

  faWheatAwnSlash,
  

  faLanguage,
  

  faBreadSlice,
  

  faVectorSquare,
  

  faMoneyCheckDollar,
  
  faMoneyCheckAlt,
  

  faDiceD4,
  

  faPersonDressBurst,
  

  faChartNetwork,
  

  faWifiExclamation,
  

  faKidneys,
  

  faFaceParty,
  

  faSparkle,
  

  faChartWaterfall,
  

  faListOl,
  
  faList12,
  
  faListNumeric,
  

  faSort,
  
  faUnsorted,
  

  faLocust,
  

  faFilterCircleXmark,
  

  faToiletPaperCheck,
  

  faCircleI,
  

  faUserGroupCrown,
  
  faUsersCrown,
  

  faCircleArrowRight,
  
  faArrowCircleRight,
  

  faBreadSliceButter,
  

  faMoonCloud,
  

  faArrowTurnDownRight,
  

  faGuitarElectric,
  

  faRectangleAd,
  
  faAd,
  

  faNewspaper,
  

  faStomach,
  

  faSnowflake,
  

  faBroomWide,
  

  faP,
  

  faTrashCanClock,
  

  faSausage,
  

  faFeatherPointed,
  
  faFeatherAlt,
  

  faMace,
  

  faTemperatureArrowDown,
  
  faTemperatureDown,
  

  faBookmarkSlash,
  

  faA,
  

  faRoadLock,
  

  faInputPipe,
  

  faDeer,
  

  faPersonSkiing,
  
  faSkiing,
  

  faZ,
  

  faPinball,
  

  faFaceConfused,
  

  faDemocrat,
  

  faLinkSimpleSlash,
  

  faPickaxe,
  

  faTicketsSimple,
  

  faCommentsDollar,
  

  faFaceHushed,
  

  faPersonSnowmobiling,
  
  faSnowmobile,
  

  faChurch,
  

  faTableCellsColumnLock,
  

  faCalendarLinesPen,
  

  faGlassCitrus,
  

  faItalic,
  

  faCediSign,
  

  faCouch,
  

  faMartiniGlassEmpty,
  
  faGlassMartini,
  

  faMemo,
  

  faSquare,
  

  faCommentCheck,
  

  faHeartHalf,
  

  faTicketPerforated,
  

  faFileZipper,
  
  faFileArchive,
  

  faHouseChimneyCrack,
  
  faHouseDamage,
  

  faHeartCircleCheck,
  

  faArchway,
  

  faClockTwoThirty,
  

  faHashtagLock,
  

  faBorderOuter,
  

  faArrowsToDot,
  

  faRestroomSimple,
  

  faLayerGroup,
  

  faEnvelopeCircleCheck,
  

  faWave,
  

  faCommentMiddleTop,
  

  faGridRound2,
  

  faVirus,
  

  faBookAtlas,
  
  faAtlas,
  

  faTruckPlow,
  

  faShieldHalved,
  
  faShieldAlt,
  

  faFaceConfounded,
  

  faPalletBox,
  

  faGreaterThanEqual,
  

  faSquareArrowUp,
  
  faArrowSquareUp,
  

  faBurgerSoda,
  

  faCabinetFiling,
  

  faListDropdown,
  

  faWatchCalculator,
  

  faWatchApple,
  

  faCruzeiroSign,
  

  faShelvesEmpty,
  

  faGarageOpen,
  

  faMagnifyingGlassArrowsRotate,
  

  faFireExtinguisher,
  

  faArrowsToDottedLine,
  

  faCircleBookOpen,
  
  faBookCircle,
  

  faArrowsRotate,
  
  faRefresh,
  
  faSync,
  

  faBorderTop,
  

  faMugTea,
  

  faBurgerFries,
  

  faGuaraniSign,
  

  faGingerbreadMan,
  

  faCommentQuestion,
  

  faAlicorn,
  

  faAlarmPlus,
  

  faMattressPillow,
  

  faMemoPad,
  

  faRabbitRunning,
  
  faRabbitFast,
  

  faHandshakeSimpleSlash,
  
  faHandshakeAltSlash,
  

  faCatSpace,
  

  faDrawCircle,
  

  faEnvelopeOpen,
  

  faListTree,
  

  faLollipop,
  
  faLollypop,
  

  faSignalStrong,
  
  faSignal4,
  

  faUserLargeSlash,
  
  faUserAltSlash,
  

  faChalkboard,
  
  faBlackboard,
  

  faMeterDroplet,
  

  faChildren,
  

  faWreath,
  

  faCloudArrowDown,
  
  faCloudDownload,
  
  faCloudDownloadAlt,
  

  faHouseLock,
  

  faArrowsLeftRight,
  
  faArrowsH,
  

  faObjectsAlignCenterVertical,
  

  faSquareDown,
  
  faArrowAltSquareDown,
  

  faFilePowerpoint,
  

  faFileWord,
  

  faLeft,
  
  faArrowAltLeft,
  

  faWavesSine,
  

  faCircle6,
  

  faChessKingPiece,
  
  faChessKingAlt,
  

  faTombstoneBlank,
  
  faTombstoneAlt,
  

  faFaceSmileWink,
  
  faSmileWink,
  

  faProjector,
  

  faText,
  

  faCircleDownLeft,
  

  faWatch,
  

  faTextSlash,
  
  faRemoveFormat,
  

  faChartLineUpDown,
  

  faCloudBolt,
  
  faThunderstorm,
  

  faMessageCheck,
  
  faCommentAltCheck,
  

  faHandHoldingSeedling,
  

  faPhoneArrowRight,
  

  faSquareDollar,
  
  faDollarSquare,
  
  faUsdSquare,
  

  faArrowDownWideShort,
  
  faSortAmountAsc,
  
  faSortAmountDown,
  

  faCandyCane,
  

  faSquare9,
  

  faBowlFood,
  

  faGroupArrowsRotate,
  

  faFileJpg,
  

  faFlashlight,
  

  faCircleArrowLeft,
  
  faArrowCircleLeft,
  

  faBoxesPacking,
  

  faLeftRight,
  
  faArrowsAltH,
  

  faClockSeven,
  

  faSeedling,
  
  faSprout,
  

  faArrowsDownToPeople,
  

  faBullseyeArrow,
  

  faFerry,
  

  faTrianglePersonDigging,
  
  faConstruction,
  

  faCircleEnvelope,
  
  faEnvelopeCircle,
  

  faInboxFull,
  

  faPig,
  

  faVest,
  

  faArrowsTurnRight,
  

  faObjectsAlignRight,
  

  faChartMixedUpCircleCurrency,
  

  faTransporter4,
  

  faPalette,
  

  faCloudArrowUp,
  
  faCloudUpload,
  
  faCloudUploadAlt,
  

  faFontAwesome,
  
  faFontAwesomeFlag,
  
  faFontAwesomeLogoFull,
  

  faGasPumpSlash,
  

  faCrutch,
  

  faSquareALock,
  

  faUserVneckHairLong,
  

  faCircleCaretUp,
  
  faCaretCircleUp,
  

  faUfoBeam,
  

  faSmog,
  

  faBlindsRaised,
  

  faMoneyBills,
  

  faFaceTired,
  
  faTired,
  

  faHouseLaptop,
  
  faLaptopHouse,
  

  faBurst,
  

  faIntegral,
  

  faDiamondTurnRight,
  
  faDirections,
  

  faSubscript,
  

  faGlobeSnow,
  

  faScaleUnbalancedFlip,
  
  faBalanceScaleRight,
  

  faAddressCard,
  
  faContactCard,
  
  faVcard,
  

  faTrashCanPlus,
  

  faRegistered,
  

  faGaugeLow,
  
  faTachometerAltSlow,
  

  faBomb,
  

  faTemperatureEmpty,
  
  faTemperature0,
  
  faThermometer0,
  
  faThermometerEmpty,
  

  faHillAvalanche,
  

  faPlaneEngines,
  
  faPlaneAlt,
  

  faClockEightThirty,
  

  faPause,
  

  faLocationPinLock,
  

  faStrawberry,
  

  faArrowLeftFromLine,
  
  faArrowFromRight,
  

  faSpa,
  

  faScroll,
  

  faSquareF,
  

  faBoxOpen,
  

  faKerning,
  

  faLightEmergencyOn,
  

  faSquareArrowUpRight,
  
  faExternalLinkSquare,
  

  faBanjo,
  

  faFileImport,
  
  faArrowRightToFile,
  

  faCommentPen,
  
  faCommentEdit,
  

  faCircleArrowDown,
  
  faArrowCircleDown,
  

  faCameraRetro,
  

  faFilterCircleDollar,
  
  faFunnelDollar,
  

  faBinaryLock,
  

  faStarShooting,
  

  faPersonSkating,
  
  faSkating,
  

  faSuitcase,
  

  faReplyAll,
  
  faMailReplyAll,
  

  faCrystalBall,
  

  faCertificate,
  

  faTentArrowDownToLine,
  

  faArrowDownLong,
  
  faLongArrowDown,
  

  faUpToBracket,
  

  faUserTie,
  

  faSquarePersonConfined,
  

  faViruses,
  

  faBatteryExclamation,
  

  faSterlingSign,
  
  faGbp,
  
  faPoundSign,
  

  faSmoke,
  

  faMaskSnorkel,
  

  faImageSlash,
  

  faPersonWalkingDashedLineArrowRight,
  

  faStocking,
  

  faTeddyBear,
  

  faVolcano,
  

  faLariSign,
  

  faUserPolice,
  

  faCircleChevronUp,
  
  faChevronCircleUp,
  

  faUpRight,
  

  faFileMagnifyingGlass,
  
  faFileSearch,
  

  faGearComplex,
  

  faUniversalAccess,
  

  faAperture,
  

  faHelicopterSymbol,
  

  faTreeLarge,
  

  faBatteryBolt,
  

  faSquareArrowDownLeft,
  

  faFaceLaughBeam,
  
  faLaughBeam,
  

  faBinBottles,
  

  faMarker,
  

  faKazoo,
  

  faIdBadge,
  

  faNeuter,
  

  faPersonShelter,
  

  faIcicles,
  

  faCarWrench,
  
  faCarMechanic,
  

  faChopsticks,
  

  faCalendarCircleMinus,
  

  faPlateWheat,
  

  faCompassDrafting,
  
  faDraftingCompass,
  

  faArrowUpToBracket,
  

  faPhoneRotary,
  

  faHeadSideHeadphones,
  

  faCircleStop,
  
  faStopCircle,
  

  faBat,
  

  faMoneySimpleFromBracket,
  

  faHandHoldingCircleDollar,
  

  faSquareDashedCirclePlus,
  

  faCircleCheck,
  
  faCheckCircle,
  

  faChair,
  

  faEuroSign,
  
  faEur,
  
  faEuro,
  

  faEthernet,
  

  fa360Degrees,
  

  faTablets,
  

  faLocationArrowUp,
  

  faArrowUpRightAndArrowDownLeftFromCenter,
  

  faCirclePlay,
  
  faPlayCircle,
  

  faCannabis,
  

  faTruckRampCouch,
  
  faTruckCouch,
  

  faAnglesRight,
  
  faAngleDoubleRight,
  

  faSnowplow,
  

  faAlignSlash,
  

  faOctagonXmark,
  
  faTimesOctagon,
  
  faXmarkOctagon,
  

  faMonument,
  

  faRefrigerator,
  

  faMinimize,
  
  faCompressArrowsAlt,
  

  faSmoking,
  

  faDolly,
  
  faDollyBox,
  

  faGem,
  

  faHandshake,
  

  faHeadSideMask,
  

  faLemon,
  

  faTick,
  

  faSquareA,
  

  faTableColumns,
  
  faColumns,
  

  faRotateLeft,
  
  faRotateBack,
  
  faRotateBackward,
  
  faUndoAlt,
  

  faMartiniGlass,
  
  faGlassMartiniAlt,
  

  faBracketSquareRight,
  

  faArrowUpFromGroundWater,
  

  faForklift,
  

  faSquareNfi,
  

  faHouseTsunami,
  

  faFolderClosed,
  

  faCircleSortDown,
  
  faSortCircleDown,
  

  faScrewdriver,
  

  faShieldXmark,
  
  faShieldTimes,
  

  faCaretUp,
  

  faDownFromLine,
  
  faArrowAltFromTop,
  

  faSquareRing,
  

  fa3,
  

  faFileZip,
  

  faCow,
  

  faMicrophone,
  

  faWindowFrame,
  

  faImage,
  

  faFloppyDiskPen,
  

  faBucket,
  

  faFrog,
  

  faMessageLines,
  
  faCommentAltLines,
  

  faCloudExclamation,
  

  faToriiGate,
  

  faPanelEws,
  

  faSubtitles,
  

  faSunrise,
  

  faHockeyMask,
  

  faLacrosseStick,
  

  faCustard,
  

  faMistletoe,
  

  faBowlScoops,
  

  faSquarePlus,
  
  faPlusSquare,
  

  faCircleV,
  

  faFileBinary,
  

  faNfcMagnifyingGlass,
  

  faWindowRestore,
  

  faSailboat,
  

  faCassetteBetamax,
  
  faBetamax,
  

  faCrow,
  

  fa00,
  

  faHexagonDivide,
  

  faUserUnlock,
  

  faSensorFire,
  

  faFaceExhaling,
  

  faTrafficLightGo,
  

  faEyeLowVision,
  
  faLowVision,
  

  faUpFromDottedLine,
  

  faTrain,
  

  faLessThanEqual,
  

  faHandsBubbles,
  
  faHandsWash,
  

  faChartBar,
  
  faBarChart,
  

  faCloudShowersWater,
  

  faSquareCaretUp,
  
  faCaretSquareUp,
  

  faTally,
  
  faTally5,
  

  faGridRound5,
  

  faHandBackFist,
  
  faHandRock,
  

  faMarsStrokeRight,
  
  faMarsStrokeH,
  

  faPersonChalkboard,
  

  faRightLongToLine,
  

  faSwapArrows,
  

  faGrid5,
  

  faArrowDownToLine,
  
  faArrowToBottom,
  

  faRepeat1,
  

  faBuildingCircleCheck,
  

  faBurgerCheese,
  
  faCheeseburger,
  

  faChessBoard,
  

  faBringFront,
  

  faUpLeft,
  

  faSquareQuote,
  

  faHoodCloak,
  

  faGlasses,
  

  faPaintbrushFine,
  
  faPaintBrushAlt,
  
  faPaintBrushFine,
  
  faPaintbrushAlt,
  

  faChessQueen,
  

  faTreasureChest,
  

  faMessageArrowUpRight,
  

  faFileSlash,
  

  faCoinFront,
  

  faGaugeCircleBolt,
  

  faTransporter5,
  

  faVolume,
  
  faVolumeMedium,
  

  faDiceTwo,
  

  faGift,
  

  faMemoCircleInfo,
  

  faMailboxFlagUp,
  

  faFaceDowncastSweat,
  

  faCarBattery,
  
  faBatteryCar,
  

  faDogLeashed,
  

  faMugHot,
  

  faArrowDownSquareTriangle,
  
  faSortShapesDownAlt,
  

  faSquarePollVertical,
  
  faPoll,
  

  faJedi,
  

  faTilde,
  

  faMapLocationDot,
  
  faMapMarkedAlt,
  

  faBorderTopLeft,
  
  faBorderStyle,
  

  faNotEqual,
  

  faMoneyCheckPen,
  
  faMoneyCheckEdit,
  

  faManatSign,
  

  faSquareK,
  

  faCircleDownRight,
  

  faEngineWarning,
  
  faEngineExclamation,
  

  faTransporter3,
  

  faBuildingNgo,
  

  faAnchorLock,
  

  faBold,
  

  faStroopwafel,
  

  faSignature,
  

  faCaduceus,
  

  faSquareO,
  

  faBinarySlash,
  

  faUserPen,
  
  faUserEdit,
  

  faPrescriptionBottlePill,
  

  faUnderline,
  

  faRectangleHistoryCirclePlus,
  

  faUmbrellaSimple,
  
  faUmbrellaAlt,
  

  faBath,
  
  faBathtub,
  

  faMessages,
  
  faCommentsAlt,
  

  faWifi,
  
  faWifi3,
  
  faWifiStrong,
  

  faFileArrowUp,
  
  faFileUpload,
  

  faHouseCircleExclamation,
  

  faClipboard,
  

  faHexagonPlus,
  
  faPlusHexagon,
  

  faTaco,
  

  faChampagneGlasses,
  
  faGlassCheers,
  

  faMarsStrokeUp,
  
  faMarsStrokeV,
  

  faUserMinus,
  

  faSignalSlash,
  

  faRoadCircleXmark,
  

  faStoreSlash,
  

  faH4,
  

  faBadgerHoney,
  

  faHeadset,
  

  faColonSign,
  

  faUnlock,
  

  faSheep,
  

  faCitrusSlice,
  

  faPepperHot,
  

  faClockTwelve,
  

  faMicrophoneLines,
  
  faMicrophoneAlt,
  

  faSignalBarsWeak,
  
  faSignalAlt1,
  

  faCity,
  

  faCodeFork,
  

  faHeartCirclePlus,
  

  faFlatbread,
  

  faBowlHot,
  
  faSoup,
  

  faCandy,
  

  faAlbumCollectionCircleUser,
  

  faFolderOpen,
  

  faFaceLaugh,
  
  faLaugh,
  

  faChartPieSimple,
  
  faChartPieAlt,
  

  faShirtLongSleeve,
  

  faShuttleSpace,
  
  faSpaceShuttle,
  

  faHouseDay,
  

  faBedPulse,
  
  faProcedures,
  

  faFire,
  

  faStars,
  

  faCircleZ,
  

  faDownToBracket,
  

  faSignalStream,
  

  faL,
  

  faPersonWalking,
  
  faWalking,
  

  faRectangleVertical,
  
  faRectanglePortrait,
  

  faToggleOn,
  

  faCircleArrowUp,
  
  faArrowCircleUp,
  

  faBedEmpty,
  

  faPianoKeyboard,
  

  faUserPilotTie,
  

  faWheelchair,
  

  faTriangleInstrument,
  
  faTriangleMusic,
  

  faCommentPlus,
  

  faSquareChevronDown,
  
  faChevronSquareDown,
  

  faObjectsColumn,
  

  faViolin,
  

  faBurrito,
  

  faCommentMinus,
  

  faBinaryCircleCheck,
  

  faPanelFire,
  

  faBoltSlash,
  

  faCodeSimple,
  

  faFaceLaughSquint,
  
  faLaughSquint,
  

  faPalletBoxes,
  
  faPaletteBoxes,
  
  faPalletAlt,
  

  faBarsSort,
  

  faChessKnight,
  

  faFarm,
  
  faBarnSilo,
  

  faSquareT,
  

  faTvRetro,
  

  faScannerImage,
  

  faSnooze,
  
  faZzz,
  

  faBlockQuestion,
  

  faPlayPause,
  

  faLayerPlus,
  
  faLayerGroupPlus,
  

  faArrowUpAZ,
  
  faSortAlphaUp,
  

  faUserGroup,
  
  faUserFriends,
  

  faBooks,
  

  faStarExclamation,
  

  faArrowUpToArc,
  

  faWeightScale,
  
  faWeight,
  

  faHandBackPointUp,
  

  faFlowerDaffodil,
  

  faCalendarRange,
  

  faTableCellsLock,
  

  faFilePrescription,
  

  faXmarksLines,
  

  faWeightHanging,
  

  faCrown,
  

  faLeftLongToLine,
  

  faMicrochip,
  

  faTemperatureHigh,
  

  faTrashCanXmark,
  

  faFolderUser,
  

  faPeopleCarryBox,
  
  faPeopleCarry,
  

  faClockTenThirty,
  

  faCloudsMoon,
  

  faCircle8,
  

  faHeartPulse,
  
  faHeartbeat,
  

  faInboxIn,
  
  faInboxArrowDown,
  

  faPassport,
  

  faVenus,
  

  faCommentSmile,
  

  faSquareRight,
  
  faArrowAltSquareRight,
  

  faVideoPlus,
  

  faRightToBracket,
  
  faSignInAlt,
  

  faFireHydrant,
  

  faFilePng,
  

  faApostrophe,
  

  faPersonBreastfeeding,
  

  faGaugeMax,
  
  faTachometerAltFastest,
  

  faBuildingWheat,
  

  faCircleE,
  

  faChartPieSimpleCircleCurrency,
  

  faLayerMinus,
  
  faLayerGroupMinus,
  

  faLightbulbExclamation,
  

  faMessageArrowUp,
  
  faCommentAltArrowUp,
  

  faPaperPlaneTop,
  
  faPaperPlaneAlt,
  
  faSend,
  

  faPersonSeatReclined,
  

  faHourglassClock,
  

  faBlenderPhone,
  

  faUserHairBuns,
  

  faHourglassStart,
  
  faHourglass1,
  

  faFamily,
  

  faShopLock,
  

  faIntersection,
  

  faVirusCovidSlash,
  

  faServer,
  

  faBadgeSheriff,
  

  faGridRound,
  

  faSlidersSimple,
  

  faWindTurbine,
  

  faShopSlash,
  
  faStoreAltSlash,
  

  faSquare6,
  

  faPersonSkiLift,
  
  faSkiLift,
  

  faNfcLock,
  

  faCannon,
  

  faFilesMedical,
  

  faPegasus,
  

  faArrowRightToBracket,
  
  faSignIn,
  

  faComputerMouse,
  
  faMouse,
  

  faCalendarStar,
  

  faPersonToPortal,
  
  faPortalEnter,
  

  faSlash,
  

  faLasso,
  

  faCircleQuarterStroke,
  

  faLocationXmark,
  
  faMapMarkerTimes,
  
  faMapMarkerXmark,
  

  faSpellCheck,
  

  faCoffinCross,
  

  faGoalNet,
  

  faXRay,
  

  faArrowDownFromBracket,
  

  faDiagramVenn,
  

  faFileLock,
  

  faEar,
  

  faPlaneCircleExclamation,
  

  faWindow,
  

  faFaceAstonished,
  

  faPipeSmoking,
  

  faFileInvoiceDollar,
  

  faScalpelLineDashed,
  
  faScalpelPath,
  

  faHandsBound,
  

  faClockThree,
  

  faSpider,
  

  faBracketCurlyRight,
  

  faFileDashedLine,
  
  faPageBreak,
  

  faArrowUpFromSquare,
  

  faBinBottlesRecycle,
  

  faGripLinesVertical,
  

  faMobileRetro,
  

  faPersonRunning,
  
  faRunning,
  

  faShuffle,
  
  faRandom,
  

  faPeanuts,
  

  faTransporter1,
  

  faArrowUpLeft,
  

  faSquarePhoneHangup,
  
  faPhoneSquareDown,
  

  faShieldSlash,
  

  faCircleU,
  

  faGaugeSimpleMax,
  
  faTachometerFastest,
  

  faPlaneTail,
  

  faShapes,
  
  faTriangleCircleSquare,
  

  faChargingStation,
  

  faMaximize,
  
  faExpandArrowsAlt,
  

  faLightbulbGear,
  

  faCactus,
  

  faSignalBarsGood,
  
  faSignalAlt3,
  

  faClockFourThirty,
  

  faArrowPointer,
  
  faMousePointer,
  

  faClockSevenThirty,
  

  faVenusMars,
  

  faBox,
  

  faPageCaretDown,
  
  faFileCaretDown,
  

  faCross,
  

  faRepeat,
  

  faDialMin,
  

  faStar,
  

  faDiamondExclamation,
  

  faSignalBars,
  
  faSignalAlt,
  
  faSignalAlt4,
  
  faSignalBarsStrong,
  

  faSprayCanSparkles,
  
  faAirFreshener,
  

  faCommentText,
  

  faSunDust,
  

  faCameraRotate,
  

  faUniformMartialArts,
  

  faFaceWeary,
  

  faEggFried,
  

  faCircleBookmark,
  
  faBookmarkCircle,
  

  faBellExclamation,
  

  faBan,
  
  faCancel,
  

  faScalpel,
  

  faPersonCircleMinus,
  

  faCircleThreeQuartersStroke,
  

  faHouseFlag,
  

  faChartArea,
  
  faAreaChart,
  

  faMoneyBillWave,
  

  faPizzaSlice,
  

  faTruckBolt,
  

  faSignPosts,
  

  faMailbox,
  

  faChartLineUp,
  

  faBuildingLock,
  

  faRectangleHistoryCircleUser,
  

  faPersonDressFairy,
  

  faTabletButton,
  

  faC,
  

  faLocationArrow,
  

  faMessagePlus,
  
  faCommentAltPlus,
  

  faFaceSmileTear,
  

  faRoadBridge,
  

  faCalendarPen,
  
  faCalendarEdit,
  

  faFolderImage,
  

  faPersonHalfDress,
  

  faFileChartColumn,
  
  faFileChartLine,
  

  faSynagogue,
  

  faGlobe,
  

  faPersonDolly,
  

  faLocationCrosshairsSlash,
  
  faLocationSlash,
  

  faSteak,
  

  faBullhorn,
  

  faBoxCheck,
  

  faTamale,
  

  faHatSanta,
  

  faArrowLeftToBracket,
  

  faKey,
  

  faWavePulse,
  
  faHeartRate,
  

  faHighlighter,
  

  faSquareCaretLeft,
  
  faCaretSquareLeft,
  

  faLightSwitch,
  

  faBuildingUser,
  

  faVanShuttle,
  
  faShuttleVan,
  

  faDumpster,
  

  faArrowDownToArc,
  

  faLightEmergency,
  

  faToiletPaperUnder,
  
  faToiletPaperReverse,
  

  faSchoolCircleCheck,
  

  faComma,
  

  faSensor,
  

  faUser,
  

  faRotateReverse,
  

  faBadgePercent,
  

  faBridgeCircleExclamation,
  

  faPenClip,
  
  faPenAlt,
  

  faH3,
  

  faBowlChopsticksNoodles,
  

  faPizza,
  

  faE,
  

  faLambda,
  

  faWandMagicSparkles,
  
  faMagicWandSparkles,
  

  faGauge,
  
  faDashboard,
  
  faGaugeMed,
  
  faTachometerAltAverage,
  

  faVial,
  

  faSquareBolt,
  

  faLeafOak,
  

  faMarsStroke,
  

  faCircleParking,
  
  faParkingCircle,
  

  faCrutches,
  

  faChartSimple,
  

  faBagSeedling,
  

  faPenCircle,
  

  faRadiation,
  

  faPlaneUpSlash,
  

  faMug,
  

  faMicrochipAi,
  

  faFileWaveform,
  
  faFileMedicalAlt,
  

  faCreditCardBlank,
  

  faFaceAnxiousSweat,
  

  faFolder,
  
  faFolderBlank,
  

  faObjectsAlignTop,
  

  faFileCad,
  

  faTrashPlus,
  

  faHeadSideGear,
  

  faArrowUpFromBracket,
  

  faHandPointDown,
  

  faRaccoon,
  

  faOption,
  

  faBacon,
  

  faTrashList,
  

  faMessageCaptions,
  
  faCommentAltCaptions,
  

  faSushi,
  
  faNigiri,
  

  faBullseye,
  

  faArrowLeftToLine,
  
  faArrowToLeft,
  

  faLocationSmile,
  
  faMapMarkerSmile,
  

  faHelmetUn,
  

  faUmbrellaBeach,
  

  faBrainArrowCurvedRight,
  
  faMindShare,
  

  fa6,
  

  faCreditCardFront,
  

  faBatteryLow,
  
  faBattery1,
  

  faAlignJustify,
  

  faFanTable,
  

  faBookmark,
  

  faSemicolon,
  

  faSquareExclamation,
  
  faExclamationSquare,
  

  faTrainSubwayTunnel,
  
  faSubwayTunnel,
  

  faSquareUp,
  
  faArrowAltSquareUp,
  

  faFaceHoldingBackTears,
  

  faBowlSoftServe,
  

  faBaguette,
  

  faBarcodeRead,
  

  faArrowUpBigSmall,
  
  faSortSizeUp,
  

  faMoneyBill,
  

  faHandPointUp,
  

  faSquareJ,
  

  faBagShoppingPlus,
  

  faSquareDashed,
  

  faFaceFrownOpen,
  
  faFrownOpen,
  

  faFileVector,
  

  faTally1,
  

  faPooStorm,
  
  faPooBolt,
  

  faCapsules,
  

  faDonut,
  
  faDoughnut,
  

  faDongSign,
  

  faTemperatureHalf,
  
  faTemperature2,
  
  faThermometer2,
  
  faThermometerHalf,
  

  faCommentImage,
  

  faEscalator,
  

  faCarWash,
  

  faNotesMedical,
  

  faSlotMachine,
  

  faWineGlassCrack,
  
  faFragile,
  

  faG,
  

  faWhistle,
  

  faLinkSimple,
  

  faMonitorWaveform,
  
  faMonitorHeartRate,
  

  faQ,
  

  faHorse,
  

  faDialMed,
  

  faAngleRight,
  

  faBellOn,
  

  faFilters,
  

  faMugMarshmallows,
  

  faHorseSaddle,
  

  faJoint,
  

  faBracketRound,
  
  faParenthesis,
  

  faIgloo,
  

  faSchool,
  

  faBriefcaseBlank,
  

  faChartCandlestick,
  

  faRoadBarrier,
  

  faMortarPestle,
  

  faShieldCheck,
  

  faUserAlien,
  

  faSnowman,
  

  faWheatAwnCircleExclamation,
  

  faGunSquirt,
  

  faPiano,
  

  faPepper,
  

  faTruckMedical,
  
  faAmbulance,
  

  faApartment,
  

  faTriangle,
  

  faFileMov,
  

  faHeadSideCoughSlash,
  

  faPear,
  

  faStaffSnake,
  
  faRodAsclepius,
  
  faRodSnake,
  
  faStaffAesculapius,
  

  faSpiderBlackWidow,
  

  faCircleD,
  

  faHammerWar,
  

  faBicycle,
  

  faBangladeshiTakaSign,
  

  faCalendars,
  

  faCircleArrowUpRight,
  

  faLeafyGreen,
  

  faSquid,
  

  faSparkles,
  

  faV,
  

  faObjectsAlignBottom,
  

  faBasketballHoop,
  

  faTooth,
  

  faFaceGrinWide,
  
  faGrinAlt,
  

  faPills,
  

  faArrowDownLeftAndArrowUpRightToCenter,
  

  faHryvniaSign,
  
  faHryvnia,
  

  faI,
  

  faUserHelmetSafety,
  
  faUserConstruction,
  
  faUserHardHat,
  

  faDialHigh,
  

  faGlassEmpty,
  

  faDroneFront,
  
  faDroneAlt,
  

  faStairs,
  

  faToiletPaperUnderSlash,
  
  faToiletPaperReverseSlash,
  

  faDrawSquare,
  

  faFilePlus,
  

  faStamp,
  

  faSaltShaker,
  

  faChartMixedUpCircleDollar,
  

  faICursor,
  

  faSquareArrowUpLeft,
  

  fa5,
  

  faLandMineOn,
  

  faTricycle,
  

  faFaceZany,
  

  faSquareRss,
  
  faRssSquare,
  

  faOctagonMinus,
  
  faMinusOctagon,
  

  faDiceFive,
  

  faRoadCircleCheck,
  

  faFaceRelieved,
  

  faEclipse,
  

  faAlarmClock,
  

  faEarDeaf,
  
  faDeaf,
  
  faDeafness,
  
  faHardOfHearing,
  

  faClockThreeThirty,
  

  faFaceGrinWink,
  
  faGrinWink,
  

  faHatWitch,
  

  faCoffeeBeans,
  

  faMessageSms,
  

  faChessBishop,
  

  faSealExclamation,
  

  faGrateDroplet,
  

  faVideoArrowUpRight,
  

  faAcorn,
  

  faFlute,
  

  faRaygun,
  

  faSkeletonRibs,
  

  faThoughtBubble,
  

  faUpToDottedLine,
  

  faFaceGrinTongue,
  
  faGrinTongue,
  

  faPeriod,
  

  faBridgeCircleXmark,
  

  faFaceKiss,
  
  faKiss,
  

  faWindowFrameOpen,
  

  faLightbulbCfl,
  

  faCommentArrowDown,
  

  faCameraWeb,
  
  faWebcam,
  

  faSquareM,
  

  faFaceScream,
  

  faArrowUpSquareTriangle,
  
  faSortShapesUpAlt,
  

  faFieldHockeyStickBall,
  
  faFieldHockey,
  

  faSquare2,
  

  faSaxophone,
  

  faStopwatch,
  

  faBlinds,
  

  faCommand,
  

  faPopsicle,
  

  faBookArrowUp,
  

  faCircleMicrophone,
  
  faMicrophoneCircle,
  

  faSpiderWeb,
  

  faHandSpock,
  

  faCircleCamera,
  
  faCameraCircle,
  

  faFacePersevering,
  

  faGaugeSimpleLow,
  
  faTachometerSlow,
  

  faFaceSaluting,
  

  faChevronUp,
  

  faSquareI,
  

  faCalendarCircleExclamation,
  

  faPlug,
  

  faHouseCircleXmark,
  

  faWorm,
  

  faFaceShush,
  

  faFlaskRoundPotion,
  
  faFlaskPotion,
  

  faPi,
  

  faOm,
  

  faArrowTurnLeftDown,
  

  faFolderBookmark,
  

  faTurnRight,
  

  faPrintMagnifyingGlass,
  
  faPrintSearch,
  

  faUtensilsSlash,
  

  faPersonBikingMountain,
  
  faBikingMountain,
  

  faHand,
  
  faHandPaper,
  

  faHeadSideBrain,
  

  faCucumber,
  

  faPoliceBox,
  

  faFlaskVial,
  

  faEyeSlash,
  

  faFacePleading,
  

  faUsers,
  

  faCircleF,
  

  faRight,
  
  faArrowAltRight,
  

  faPersonRays,
  

  faReplyClock,
  
  faReplyTime,
  

  faMitten,
  

  faArrowDownZA,
  
  faSortAlphaDesc,
  
  faSortAlphaDownAlt,
  

  faBagShopping,
  
  faShoppingBag,
  

  faHandHeart,
  

  faTruckContainerEmpty,
  

  faCalendarExclamation,
  

  faSink,
  

  faSunset,
  

  faMicroscope,
  

  faHourglassHalf,
  
  faHourglass2,
  

  faCircleCalendar,
  
  faCalendarCircle,
  

  faCircleW,
  

  faHeartCircleMinus,
  

  faWaveSine,
  

  faDisplayChartUpCircleDollar,
  

  faShareNodes,
  
  faShareAlt,
  

  faKnife,
  
  faUtensilKnife,
  

  faLightbulbOn,
  

  faMessageMiddleTop,
  
  faCommentMiddleTopAlt,
  

  faCarSide,
  

  faSquareSliders,
  
  faSlidersHSquare,
  

  faPenToSquare,
  
  faEdit,
  

  faSackDollar,
  

  faCrosshairsSimple,
  

  faBridgeLock,
  

  faFolderArrowUp,
  
  faFolderUpload,
  

  faSquareSmall,
  

  faBackpack,
  

  faArrowsCross,
  

  faTree,
  

  faCommentsQuestionCheck,
  

  faHouseFloodWater,
  

  faMapLocation,
  
  faMapMarked,
  

  faBlanket,
  

  faGlobePointer,
  

  faHotTubPerson,
  
  faHotTub,
  

  faHouseNight,
  

  faRectanglePro,
  
  faPro,
  

  faMonkey,
  

  faSignalBarsSlash,
  
  faSignalAltSlash,
  

  faGasPump,
  

  faArrowDownFromLine,
  
  faArrowFromTop,
  

  faLock,
  

  faPaintbrush,
  
  faPaintBrush,
  

  faSnowBlowing,
  

  faFutbol,
  
  faFutbolBall,
  
  faSoccerBall,
  

  faJug,
  

  faFolderPlus,
  

  faCampground,
  

  faClockNineThirty,
  

  faWatchFitness,
  

  faHouseMedicalCircleXmark,
  

  faUpToLine,
  
  faArrowAltToTop,
  

  faEgg,
  

  faFaceDizzy,
  
  faDizzy,
  

  faClipboardMedical,
  

  faCircleDot,
  
  faDotCircle,
  

  faBorderCenterV,
  

  faGamepad,
  

  faCartPlus,
  

  faSquarePhoneFlip,
  
  faPhoneSquareAlt,
  

  faTreePalm,
  

  faList,
  
  faListSquares,
  

  faFilmSimple,
  
  faFilmAlt,
  

  faAbacus,
  

  faHockeySticks,
  

  faFaceAnguished,
  

  faGhost,
  

  faHeading,
  
  faHeader,
  

  faTrainTunnel,
  

  faSquareParkingSlash,
  
  faParkingSlash,
  

  faPesetaSign,
  

  faSandwich,
  

  faBookOpenCover,
  
  faBookOpenAlt,
  

  faShredder,
  

  faSquareCheck,
  
  faCheckSquare,
  

  faLuchadorMask,
  
  faLuchador,
  
  faMaskLuchador,
  

  faCommentLines,
  

  faKeySkeletonLeftRight,
  

  faAsterisk,
  

  faHandsHoldingChild,
  

  faAnkh,
  

  faWheatAwn,
  
  faWheatAlt,
  

  faCompress,
  

  faCircleN,
  

  faAlbum,
  

  faCloudSunRain,
  

  faSwords,
  

  faCommentSlash,
  

  faBoxTaped,
  
  faBoxAlt,
  

  faXmarkToSlot,
  
  faTimesToSlot,
  
  faVoteNay,
  

  faVolumeLow,
  
  faVolumeDown,
  

  faFeather,
  

  faSquareCode,
  

  faDisplayChartUp,
  

  faChartScatter3d,
  

  faHanukiah,
  

  faFaceCowboyHat,
  

  faFlag,
  

  faArrowUpToLine,
  
  faArrowToTop,
  

  faSquirrel,
  

  faFireBurner,
  

  faRoadSpikes,
  

  faFaceSleeping,
  

  faMemory,
  

  faCircleDollarToSlot,
  
  faDonate,
  

  faSpaceStationMoonConstruction,
  
  faSpaceStationMoonAlt,
  

  faPipeSection,
  

  faSitemap,
  

  faHeadphonesSimple,
  
  faHeadphonesAlt,
  

  faCloudShowersHeavy,
  

  faTemperatureList,
  

  faUnlockKeyhole,
  
  faUnlockAlt,
  

  faSidebarFlip,
  

  faCircleChevronDown,
  
  faChevronCircleDown,
  

  faFaceFrownSlight,
  

  faArrowRightFromBracket,
  
  faSignOut,
  

  faSchoolCircleXmark,
  

  faCircleExclamation,
  
  faExclamationCircle,
  

  faBlock,
  

  faTrashCanList,
  

  faCommentMiddle,
  

  faCaretLeft,
  

  faLightbulb,
  

  faPeopleRobbery,
  

  faSquareTerminal,
  

  faCassetteTape,
  

  faShieldCross,
  

  fa8,
  

  faRulerHorizontal,
  

  faCoconut,
  

  faFilm,
  

  faSickle,
  

  faRadar,
  

  faPhotoFilmMusic,
  

  faRollerCoaster,
  

  faCorn,
  

  faFaceKissBeam,
  
  faKissBeam,
  

  faSquareUpRight,
  
  faExternalLinkSquareAlt,
  

  faDropletPercent,
  
  faHumidity,
  

  faFaceBeamHandOverMouth,
  

  faHeartCrack,
  
  faHeartBroken,
  

  faHourglassEnd,
  
  faHourglass3,
  

  faPeopleGroup,
  

  faKeyboardLeft,
  

  faBars,
  
  faNavicon,
  

  faPrescriptionBottle,
  

  faSwatchbook,
  

  faRectangleVerticalHistory,
  

  faGrillFire,
  

  faJoystick,
  

  faLaptopCode,
  

  faTruckUtensils,
  

  faFileCircleQuestion,
  

  faHeartHalfStroke,
  
  faHeartHalfAlt,
  

  faSquareCaretDown,
  
  faCaretSquareDown,
  

  faCompass,
  

  faBird,
  

  faHelicopter,
  

  faSquareMinus,
  
  faMinusSquare,
  

  faHouseFire,
  

  faEmptySet,
  

  faStarAndCrescent,
  

  faReply,
  
  faMailReply,
  

  faMeat,
  

  faClover,
  

  faUsersSlash,
  

  faStarSharpHalf,
  

  faPickleball,
  

  faFaceMask,
  

  faTachographDigital,
  
  faDigitalTachograph,
  

  faMagnifyingGlassArrowRight,
  

  faSensorTriangleExclamation,
  
  faSensorAlert,
  

  faUsersMedical,
  

  faMessageImage,
  
  faCommentAltImage,
  

  faUserChef,
  

  faTable,
  

  faHyphen,
  

  faMustache,
  

  faHockeyPuck,
  

  faToiletsPortable,
  

  faSunPlantWilt,
  

  faListMusic,
  

  faScissors,
  
  faCut,
  

  faSquareCaretRight,
  
  faCaretSquareRight,
  

  faTombstone,
  

  faMarsAndVenusBurst,
  

  faFaceAngryHorns,
  

  faSignPost,
  

  faPeopleArrows,
  
  faPeopleArrowsLeftRight,
  

  faAlbumCollectionCirclePlus,
  

  faSquareRoot,
  

  faChessRookPiece,
  
  faChessRookAlt,
  

  faArrowProgress,
  

  faFileMp3,
  

  faPenRuler,
  
  faPencilRuler,
  

  faBellConcierge,
  
  faConciergeBell,
  

  faMessagePen,
  
  faCommentAltEdit,
  
  faMessageEdit,
  

  faBadge,
  

  faSunglasses,
  

  faTireFlat,
  

  faTreeChristmas,
  

  faMotorcycle,
  

  faChartBullet,
  

  faStarChristmas,
  

  faCircleC,
  

  faBoxTissue,
  

  faMicrophoneSlash,
  

  faBinoculars,
  

  faTruckRamp,
  

  faMusicSlash,
  

  faTrillium,
  

  faBrowsers,
  

  faSprinklerCeiling,
  

  faGavel,
  
  faLegal,
  

  faReflectBoth,
  

  faTrashClock,
  

  faCartCircleArrowUp,
  

  faTentArrowLeftRight,
  

  faChfSign,
  

  faMicrowave,
  

  faHospitalUser,
  

  faFaceFlushed,
  
  faFlushed,
  

  faSquare3,
  

  faTrowelBricks,
  

  faCloud,
  

  faMessageQuestion,
  

  faPaw,
  

  faTabletScreenButton,
  
  faTabletAlt,
  

  faCircleNotch,
  

  faRainbow,
  

  faEarthAfrica,
  
  faGlobeAfrica,
  

  faElephant,
  

  faSquareB,
  

  faCodePullRequestDraft,
  

  faW,
  

  faGiftCard,
  

  faTruckMonster,
  

  faScarecrow,
  

  faAlarmSnooze,
  

  faSprayCan,
  

  faShishKebab,
  

  faFaceGrinTongueSquint,
  
  faGrinTongueSquint,
  

  faArrowDown91,
  
  faSortNumericDesc,
  
  faSortNumericDownAlt,
  

  faCircleCaretDown,
  
  faCaretCircleDown,
  

  faCalendarImage,
  

  faCircleM,
  

  faDialMax,
  

  faPersonDrowning,
  

  faGrapes,
  

  faBoxArchive,
  
  faArchive,
  

  faFaceSmileHorns,
  

  faToggleOff,
  

  faDialOff,
  

  faFaceAwesome,
  
  faGaveDandy,
  

  faSquareV,
  

  faDrumstick,
  

  faBroomBall,
  
  faQuidditch,
  
  faQuidditchBroomBall,
  

  faUp,
  
  faArrowAltUp,
  

  faFence,
  

  faBlindsOpen,
  

  faWebhook,
  

  faScrollTorah,
  
  faTorah,
  

  faDownRight,
  

  faPersonArrowUpFromLine,
  

  faBowlingPins,
  

  faPencilSlash,
  

  faUserNinja,
  

  fa7,
  

  faBlog,
  

  faCircle9,
  

  faSheetPlastic,
  

  faFaceUnamused,
  

  faMessageArrowDown,
  
  faCommentAltArrowDown,
  

  faGolfFlagHole,
  

  faBookBlank,
  
  faBookAlt,
  

  faVialVirus,
  

  faCloudXmark,
  

  faUserCheck,
  

  faArrowDownToSquare,
  

  faNote,
  

  faTruckRampBox,
  
  faTruckLoading,
  

  faBlueberries,
  

  faPenField,
  

  faClipboardList,
  

  faPumpkin,
  

  faCodePullRequest,
  

  faDesktopArrowDown,
  

  faPaste,
  
  faFileClipboard,
  

  faComments,
  

  faCaretRight,
  

  faBackward,
  

  faPencil,
  
  faPencilAlt,
  

  faLips,
  

  faLandmarkFlag,
  

  faRam,
  

  faExcavator,
  

  faEggplant,
  

  faFolderGrid,
  

  faGaugeMin,
  
  faTachometerAltSlowest,
  

  faDiagramPrevious,
  

  faK,
  

  faPage,
  

  faStrikethrough,
  

  faTrees,
  

  faHandLove,
  

  faFootballHelmet,
  

  faGrid,
  
  faGrid3,
  

  faPanFrying,
  

  faAddressBook,
  
  faContactBook,
  

  faCartMinus,
  

  faPager,
  

  faMerge,
  

  faCircleH,
  
  faHospitalSymbol,
  

  faHexagonXmark,
  
  faTimesHexagon,
  
  faXmarkHexagon,
  

  faCartXmark,
  

  faBowArrow,
  

  faFileCircleExclamation,
  

  faEnvelopesBulk,
  
  faMailBulk,
  

  faJarWheat,
  

  faSpoon,
  
  faUtensilSpoon,
  

  faCheeseSwiss,
  

  faHouseBuilding,
  

  faLeafHeart,
  

  faArrowsRotateReverse,
  

  faArrowDownUpAcrossLine,
  

  faSpaghettiMonsterFlying,
  
  faPastafarianism,
  

  faTruckFlatbed,
  

  faClarinet,
  

  faBong,
  

  faCameraMovie,
  

  faSigma,
  

  faFaceGrinStars,
  
  faGrinStars,
  

  faSquareP,
  

  faBringForward,
  

  faRecordVinyl,
  

  faTruckPlane,
  

  faCircleHeart,
  
  faHeartCircle,
  

  faChevronsLeft,
  
  faChevronDoubleLeft,
  

  faUnion,
  

  faMenorah,
  

  faFileCsv,
  

  faLaptop,
  

  faPerson,
  
  faMale,
  

  faFireFlameSimple,
  
  faBurn,
  

  faPersonCarryBox,
  
  faPersonCarry,
  

  faArrowUpLong,
  
  faLongArrowUp,
  

  faCalendarCircleUser,
  

  faTransporter,
  

  faDiagramPredecessor,
  

  faCrateEmpty,
  

  faBeerMugEmpty,
  
  faBeer,
  

  faPeopleLine,
  

  faLightbulbExclamationOn,
  

  faLocationPlus,
  
  faMapMarkerPlus,
  

  faSquareArrowRight,
  
  faArrowSquareRight,
  

  faPeopleRoof,
  

  faUsersRectangle,
  

  faAnglesDown,
  
  faAngleDoubleDown,
  

  faCrop,
  

  faSchoolCircleExclamation,
  

  faUserVneck,
  

  faFootball,
  
  faFootballBall,
  

  faChevronsUp,
  
  faChevronDoubleUp,
  

  faFlagCheckered,
  

  faUtilityPoleDouble,
  

  faBuildingMemo,
  

  faSquareX,
  

  faBowlScoop,
  
  faBowlShavedIce,
  

  faMessageExclamation,
  
  faCommentAltExclamation,
  

  faLightCeiling,
  

  faFaceSmileBeam,
  
  faSmileBeam,
  

  faForwardStep,
  
  faStepForward,
  

  faMessageBot,
  

  faMagnifyingGlassLocation,
  
  faSearchLocation,
  

  faHandPointRight,
  

  faH1,
  

  faStandardDefinition,
  
  faRectangleSd,
  

  faSkiBoot,
  

  faFingerprint,
  

  faPumpMedical,
  

  faLocationMinus,
  
  faMapMarkerMinus,
  

  faSlidersUp,
  
  faSlidersV,
  

  faBridgeCircleCheck,
  

  faCalculatorSimple,
  
  faCalculatorAlt,
  

  faClosedCaptioningSlash,
  

  faMicrophoneLinesSlash,
  
  faMicrophoneAltSlash,
  

  faIcons,
  
  faHeartMusicCameraBolt,
  

  faSoap,
  

  faAtom,
  

  faNfc,
  

  faFaceGlasses,
  

  faRightFromBracket,
  
  faSignOutAlt,
  

  faFilms,
  

  faDoorOpen,
  

  faShovel,
  

  faFaceIcicles,
  

  faCircleMinus,
  
  faMinusCircle,
  

  faFolderArrowDown,
  
  faFolderDownload,
  

  faSortDown,
  
  faSortDesc,
  

  faBarcodeScan,
  

  faMobileSignal,
  

  faArrowsUpToLine,
  

  faFork,
  
  faUtensilFork,
  

  faUfo,
  

  faTextSize,
  

  faSunHaze,
  

  faVolleyball,
  
  faVolleyballBall,
  

  faBuildingCircleArrowRight,
  

  faRectangleHistory,
  

  faTally4,
  

  faAnchorCircleCheck,
  

  faMp3Player,
  

  faCalendarDays,
  
  faCalendarAlt,
  

  faWifiFair,
  
  faWifi2,
  

  faTirePressureWarning,
  

  faDiceThree,
  

  faBuildingUn,
  

  faRing,
  

  faWaveSquare,
  

  faFileLines,
  
  faFileAlt,
  
  faFileText,
  

  faExplosion,
  

  faDownLeftAndUpRightToCenter,
  
  faCompressAlt,
  

  faSquareUser,
  

  faFaceHandPeeking,
  

  faTheta,
  

  faFonduePot,
  

  faRingDiamond,
  

  faRobotAstromech,
  

  faInfo,
  

  faSalad,
  
  faBowlSalad,
  

  faMessage,
  
  faCommentAlt,
  

  faCoffin,
  

  faStethoscope,
  

  faGaugeSimpleMin,
  
  faTachometerSlowest,
  

  faFaceHandYawn,
  

  faUserXmark,
  
  faUserTimes,
  

  faTextHeight,
  

  faHeadSideGoggles,
  
  faHeadVr,
  

  faCircleL,
  

  faTrashCan,
  
  faTrashAlt,
  

  faPhoneArrowUpRight,
  
  faPhoneArrowUp,
  
  faPhoneOutgoing,
  

  faRectanglesMixed,
  

  faAt,
  

  faTransporter7,
  

  faBagel,
  

  faLineHeight,
  

  faWagonCovered,
  

  faCircleChevronRight,
  
  faChevronCircleRight,
  

  faArrowsToCircle,
  

  faFillDrip,
  

};
